
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("ycm07", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $64dd9c724ccb3c66$export$2e2bcd8739ae039);

var $8qokp = parcelRequire("8qokp");

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("3avtZ");

var $8Uumt = parcelRequire("8Uumt");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $jD5no = parcelRequire("jD5no");

var $g99jC = parcelRequire("g99jC");

var $4nnGr = parcelRequire("4nnGr");

var $evDrO = parcelRequire("evDrO");

var $f00ho = parcelRequire("f00ho");

var $x8FYU = parcelRequire("x8FYU");

var $1kpI8 = parcelRequire("1kpI8");

var $fNi03 = parcelRequire("fNi03");

var $8CVvd = parcelRequire("8CVvd");

var $3HwlS = parcelRequire("3HwlS");

var $43qGj = parcelRequire("43qGj");

var $9dbF6 = parcelRequire("9dbF6");

var $9NiTW = parcelRequire("9NiTW");

var $l8ruj = parcelRequire("l8ruj");

var $dCm1o = parcelRequire("dCm1o");

var $vtv5G = parcelRequire("vtv5G");
const $64dd9c724ccb3c66$var$LIST_NAV_ITEM_SEEN_IT_FLAG = 'jsw.list.nav-item-flag';
const $64dd9c724ccb3c66$var$JiraSoftwareListApp = ({ queries: { listQuery: listQuery, formattingRulesQuery: formattingRulesQuery } })=>{
    const { data: features } = (0, $43qGj.useFeatures)();
    const { data: board } = (0, $fNi03.useBoard)();
    const isScrumProject = board?.type === 'scrum' || features?.hasSprint;
    const data = (0, $8Uumt.usePreloadedQuery)((0, $8qokp.default), listQuery);
    const isSimplifiedProject = data.jira?.jiraProjectByKey?.projectStyle === 'TEAM_MANAGED_PROJECT';
    const isSubtasksEnabled = data.jira?.isSubtasksEnabled ?? false;
    const canCreateIssues = data.jira?.jiraProjectByKey?.createIssues?.canPerform ?? false;
    const canCreateSubtask = canCreateIssues && (isSimplifiedProject || isSubtasksEnabled);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "software-list-app"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9NiTW.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), {
        id: "software-list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g99jC.ProjectContextProvider), {
        projectFragment: data.jira?.jiraProjectByKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4nnGr.ListFeaturesProvider), {
        featureView: "software-list",
        hasCreateSubtask: canCreateSubtask,
        canCreateIssues: canCreateIssues,
        isSoftwareFieldsEnabled: true,
        isBusinessFieldsEnabled: false,
        isScrumProject: isScrumProject,
        isShareButtonEnabled: (0, $8CVvd.getWillShowNav3)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1kpI8.ViewPreferencesProvider), {
        view: "list",
        preferences: (0, $x8FYU.LIST_VIEW_PREFERENCES)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            !(0, $dCm1o.isVisualRefreshEnabled)() && $64dd9c724ccb3c66$var$pageContainerStyles,
            $64dd9c724ccb3c66$var$fullHeightPageContainerStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $64dd9c724ccb3c66$var$listContainerStyles
    }, (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $evDrO.default), {
        queryFragment: data,
        formattingRulesQuery: formattingRulesQuery
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $evDrO.default), {
        queryFragment: data,
        header: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $vtv5G.PageHeader), null),
        formattingRulesQuery: formattingRulesQuery
    })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9dbF6.SubProductUpdater), {
        subProduct: "software"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f00ho.SeenIt), {
        flag: $64dd9c724ccb3c66$var$LIST_NAV_ITEM_SEEN_IT_FLAG
    }))));
};
const $64dd9c724ccb3c66$var$pageContainerStyles = (0, $8CUq3.xcss)({
    paddingLeft: 'space.200'
});
const $64dd9c724ccb3c66$var$fullHeightPageContainerStyles = (0, $8CUq3.xcss)({
    height: '100%'
});
const $64dd9c724ccb3c66$var$listContainerStyles = (0, $8CUq3.xcss)({
    height: '100%'
});
var $64dd9c724ccb3c66$export$2e2bcd8739ae039 = $64dd9c724ccb3c66$var$JiraSoftwareListApp;

});
parcelRegister("8qokp", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b006f045d583cf0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6c62d90d709ff146b85094fd8950c8a3>>
 * @relayHash 7ca7a7e73175fabcafbcca8378817432
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e63ab64e310db9403bb03770e66a53a6920f135e0096a5f8f31a3ac88d170c0b

var $eiowN = parcelRequire("eiowN");
const $9b006f045d583cf0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = [
        v1 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "projectStyle"
    }, v4 = [
        {
            "kind": "Literal",
            "name": "type",
            "value": "CREATE_ISSUES"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "canPerform"
    }, v6 = [
        v1 /*: any*/ 
    ], v7 = {
        "args": v6 /*: any*/ ,
        "kind": "ScalarField",
        "name": "isSubtasksEnabled"
    }, v8 = [
        v5 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "src_jiraSoftwareListQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": v3 /*: any*/ ,
                                    "action": "THROW",
                                    "path": "jira.jiraProjectByKey.projectStyle"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "alias": "createIssues",
                                        "args": v4 /*: any*/ ,
                                        "concreteType": "JiraProjectAction",
                                        "kind": "LinkedField",
                                        "name": "action",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": v5 /*: any*/ ,
                                                "action": "THROW",
                                                "path": "jira.jiraProjectByKey.createIssues.canPerform"
                                            }
                                        ],
                                        "storageKey": "action(type:\"CREATE_ISSUES\")"
                                    },
                                    "action": "THROW",
                                    "path": "jira.jiraProjectByKey.createIssues"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "ProjectContextProvider"
                                }
                            ]
                        },
                        v7 /*: any*/ 
                    ]
                },
                {
                    "kind": "FragmentSpread",
                    "name": "src_businessList_List_queryFragment"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "src_jiraSoftwareListQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "alias": "createIssues",
                                    "args": v4 /*: any*/ ,
                                    "concreteType": "JiraProjectAction",
                                    "kind": "LinkedField",
                                    "name": "action",
                                    "plural": false,
                                    "selections": v8 /*: any*/ ,
                                    "storageKey": "action(type:\"CREATE_ISSUES\")"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectId"
                                },
                                {
                                    "concreteType": "JiraAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "large"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectType"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "status"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isFavourite"
                                },
                                {
                                    "alias": "assignIssues",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "ASSIGN_ISSUES"
                                        }
                                    ],
                                    "concreteType": "JiraProjectAction",
                                    "kind": "LinkedField",
                                    "name": "action",
                                    "plural": false,
                                    "selections": v8 /*: any*/ ,
                                    "storageKey": "action(type:\"ASSIGN_ISSUES\")"
                                },
                                {
                                    "alias": "administerProject",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "EDIT_PROJECT_CONFIG"
                                        }
                                    ],
                                    "concreteType": "JiraProjectAction",
                                    "kind": "LinkedField",
                                    "name": "action",
                                    "plural": false,
                                    "selections": v8 /*: any*/ ,
                                    "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                                },
                                {
                                    "alias": "deleteIssues",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "DELETE_ISSUES"
                                        }
                                    ],
                                    "concreteType": "JiraProjectAction",
                                    "kind": "LinkedField",
                                    "name": "action",
                                    "plural": false,
                                    "selections": v8 /*: any*/ ,
                                    "storageKey": "action(type:\"DELETE_ISSUES\")"
                                },
                                {
                                    "alias": "editIssues",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "EDIT_ISSUES"
                                        }
                                    ],
                                    "concreteType": "JiraProjectAction",
                                    "kind": "LinkedField",
                                    "name": "action",
                                    "plural": false,
                                    "selections": v8 /*: any*/ ,
                                    "storageKey": "action(type:\"EDIT_ISSUES\")"
                                },
                                {
                                    "alias": "linkIssues",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "LINK_ISSUES"
                                        }
                                    ],
                                    "concreteType": "JiraProjectAction",
                                    "kind": "LinkedField",
                                    "name": "action",
                                    "plural": false,
                                    "selections": v8 /*: any*/ ,
                                    "storageKey": "action(type:\"LINK_ISSUES\")"
                                },
                                {
                                    "alias": "scheduleIssues",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "SCHEDULE_ISSUES"
                                        }
                                    ],
                                    "concreteType": "JiraProjectAction",
                                    "kind": "LinkedField",
                                    "name": "action",
                                    "plural": false,
                                    "selections": v8 /*: any*/ ,
                                    "storageKey": "action(type:\"SCHEDULE_ISSUES\")"
                                },
                                {
                                    "alias": "transitionIssues",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "TRANSITION_ISSUES"
                                        }
                                    ],
                                    "concreteType": "JiraProjectAction",
                                    "kind": "LinkedField",
                                    "name": "action",
                                    "plural": false,
                                    "selections": v8 /*: any*/ ,
                                    "storageKey": "action(type:\"TRANSITION_ISSUES\")"
                                },
                                {
                                    "alias": "viewIssues",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "VIEW_ISSUES"
                                        }
                                    ],
                                    "concreteType": "JiraProjectAction",
                                    "kind": "LinkedField",
                                    "name": "action",
                                    "plural": false,
                                    "selections": v8 /*: any*/ ,
                                    "storageKey": "action(type:\"VIEW_ISSUES\")"
                                }
                            ]
                        },
                        v7 /*: any*/ ,
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "JiraJqlFieldWithAliases",
                            "kind": "LinkedField",
                            "name": "rankField",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "fieldId"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e63ab64e310db9403bb03770e66a53a6920f135e0096a5f8f31a3ac88d170c0b",
            "metadata": {},
            "name": "src_jiraSoftwareListQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$9b006f045d583cf0$var$node.hash = "61bb861782021b761a02b9ba76dbad90";
(0, $eiowN.PreloadableQueryRegistry).set($9b006f045d583cf0$var$node.params.id, $9b006f045d583cf0$var$node);
var $9b006f045d583cf0$export$2e2bcd8739ae039 = $9b006f045d583cf0$var$node;

});

parcelRegister("g99jC", function(module, exports) {

$parcel$export(module.exports, "ProjectContextProvider", () => $c897bf0612de228a$export$a85f6b5857d2176);

var $g6hRl = parcelRequire("g6hRl");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $12jwF = parcelRequire("12jwF");

var $54qG5 = parcelRequire("54qG5");

var $5YBrl = parcelRequire("5YBrl");

var $1Zr0i = parcelRequire("1Zr0i");

var $daQYX = parcelRequire("daQYX");

var $cm8b5 = parcelRequire("cm8b5");

var $gxGcZ = parcelRequire("gxGcZ");

var $iXVV6 = parcelRequire("iXVV6");

var $lVJAU = parcelRequire("lVJAU");

var $k7McJ = parcelRequire("k7McJ");

var $8OqLl = parcelRequire("8OqLl");
const $c897bf0612de228a$export$a85f6b5857d2176 = ({ children: children, projectFragment: projectFragment = null })=>{
    const { replace: replace } = (0, $lVJAU.useRouterActions)();
    const projectData = (0, $8Uumt.useFragment)((0, $g6hRl.default), projectFragment);
    const project = (0, $5uXOq.useMemo)(()=>projectData ? {
            id: Number(projectData.projectId),
            key: projectData.key,
            avatarUrl: projectData.avatar.large,
            name: projectData.name,
            type: projectData.projectType.toLowerCase(),
            isSimplified: projectData.projectStyle === 'TEAM_MANAGED_PROJECT',
            isFavorite: projectData.isFavourite ?? false,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            status: projectData.status,
            permissions: {
                assignIssues: projectData.assignIssues.canPerform,
                administerProject: projectData.administerProject.canPerform,
                createIssues: projectData.createIssues.canPerform,
                deleteIssues: projectData.deleteIssues.canPerform,
                editIssues: projectData.editIssues.canPerform,
                linkIssues: projectData.linkIssues.canPerform,
                scheduleIssues: projectData.scheduleIssues.canPerform,
                transitionIssues: projectData.transitionIssues.canPerform,
                viewIssues: projectData.viewIssues.canPerform
            }
        } : null, [
        projectData
    ]);
    const jqlContext = projectData ? `project = '${projectData.key}'` : '';
    const analyticsAttributes = (0, $5uXOq.useMemo)(()=>({
            projectId: Number(projectData?.projectId),
            isTeamManaged: projectData?.projectStyle === 'TEAM_MANAGED_PROJECT',
            projectType: projectData?.projectType.toLowerCase()
        }), [
        projectData
    ]);
    const entityData = (0, $5uXOq.useMemo)(()=>projectData?.viewIssues.canPerform ? {
            name: projectData.name,
            id: String(projectData.projectId)
        } : null, [
        projectData
    ]);
    const projects = (0, $5uXOq.useMemo)(()=>project ? [
            project
        ] : undefined, [
        project
    ]);
    const projectIdList = (0, $5uXOq.useMemo)(()=>projectData ? [
            Number(projectData.projectId)
        ] : undefined, [
        projectData
    ]);
    if (projectData?.status === 'ARCHIVED') {
        replace('/jira/errors/project-archived');
        return null;
    }
    let content;
    if (projectData == null || project == null || entityData == null) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8OqLl.default), null);
    else content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $daQYX.ProjectHookProvider), {
        project: project
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $54qG5.BusinessEntityProvider), {
        data: entityData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Zr0i.RealtimeProvider), {
        ids: projectIdList
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $12jwF.AriProvider), {
        ari: projectData.id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5YBrl.JqlProvider), {
        jqlContext: jqlContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gxGcZ.FiltersProvider), {
        projects: projects
    }, children)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cm8b5.ExperienceSuccess), {
        experience: (0, $k7McJ.FETCH_PROJECT_EXPERIENCE)
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        containerId: projectData?.projectId,
        containerType: "project",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: "businessProjectContext",
        attributes: analyticsAttributes,
        // we set a key on the first element to force React to re-render when the context changes
        // to avoid query race-conditions that would lead to promises from a previous context
        // resolving in the current context view, and thus seeing unrelated data
        key: projectData?.projectId
    }, content);
};

});
parcelRegister("g6hRl", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca223f7fcde9b08b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e73e87eb1063410c3f46a80af3137edb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ca223f7fcde9b08b$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "canPerform"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "ProjectContextProvider",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "id"
                },
                "action": "THROW",
                "path": "id"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "key"
                },
                "action": "THROW",
                "path": "key"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "projectId"
                },
                "action": "THROW",
                "path": "projectId"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraAvatar",
                    "kind": "LinkedField",
                    "name": "avatar",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "large"
                            },
                            "action": "THROW",
                            "path": "avatar.large"
                        }
                    ]
                },
                "action": "THROW",
                "path": "avatar"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "name"
                },
                "action": "THROW",
                "path": "name"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "projectType"
                },
                "action": "THROW",
                "path": "projectType"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "status"
                },
                "action": "THROW",
                "path": "status"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "projectStyle"
                },
                "action": "THROW",
                "path": "projectStyle"
            },
            {
                "kind": "ScalarField",
                "name": "isFavourite"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "assignIssues",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "ASSIGN_ISSUES"
                        }
                    ],
                    "concreteType": "JiraProjectAction",
                    "kind": "LinkedField",
                    "name": "action",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "assignIssues.canPerform"
                        }
                    ],
                    "storageKey": "action(type:\"ASSIGN_ISSUES\")"
                },
                "action": "THROW",
                "path": "assignIssues"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "administerProject",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "EDIT_PROJECT_CONFIG"
                        }
                    ],
                    "concreteType": "JiraProjectAction",
                    "kind": "LinkedField",
                    "name": "action",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "administerProject.canPerform"
                        }
                    ],
                    "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                },
                "action": "THROW",
                "path": "administerProject"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "createIssues",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "CREATE_ISSUES"
                        }
                    ],
                    "concreteType": "JiraProjectAction",
                    "kind": "LinkedField",
                    "name": "action",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "createIssues.canPerform"
                        }
                    ],
                    "storageKey": "action(type:\"CREATE_ISSUES\")"
                },
                "action": "THROW",
                "path": "createIssues"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "deleteIssues",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "DELETE_ISSUES"
                        }
                    ],
                    "concreteType": "JiraProjectAction",
                    "kind": "LinkedField",
                    "name": "action",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "deleteIssues.canPerform"
                        }
                    ],
                    "storageKey": "action(type:\"DELETE_ISSUES\")"
                },
                "action": "THROW",
                "path": "deleteIssues"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "editIssues",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "EDIT_ISSUES"
                        }
                    ],
                    "concreteType": "JiraProjectAction",
                    "kind": "LinkedField",
                    "name": "action",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "editIssues.canPerform"
                        }
                    ],
                    "storageKey": "action(type:\"EDIT_ISSUES\")"
                },
                "action": "THROW",
                "path": "editIssues"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "linkIssues",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "LINK_ISSUES"
                        }
                    ],
                    "concreteType": "JiraProjectAction",
                    "kind": "LinkedField",
                    "name": "action",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "linkIssues.canPerform"
                        }
                    ],
                    "storageKey": "action(type:\"LINK_ISSUES\")"
                },
                "action": "THROW",
                "path": "linkIssues"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "scheduleIssues",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "SCHEDULE_ISSUES"
                        }
                    ],
                    "concreteType": "JiraProjectAction",
                    "kind": "LinkedField",
                    "name": "action",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "scheduleIssues.canPerform"
                        }
                    ],
                    "storageKey": "action(type:\"SCHEDULE_ISSUES\")"
                },
                "action": "THROW",
                "path": "scheduleIssues"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "transitionIssues",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "TRANSITION_ISSUES"
                        }
                    ],
                    "concreteType": "JiraProjectAction",
                    "kind": "LinkedField",
                    "name": "action",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "transitionIssues.canPerform"
                        }
                    ],
                    "storageKey": "action(type:\"TRANSITION_ISSUES\")"
                },
                "action": "THROW",
                "path": "transitionIssues"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "viewIssues",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "VIEW_ISSUES"
                        }
                    ],
                    "concreteType": "JiraProjectAction",
                    "kind": "LinkedField",
                    "name": "action",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "viewIssues.canPerform"
                        }
                    ],
                    "storageKey": "action(type:\"VIEW_ISSUES\")"
                },
                "action": "THROW",
                "path": "viewIssues"
            }
        ],
        "type": "JiraProject"
    };
}();
$ca223f7fcde9b08b$var$node.hash = "f7f67dcd623ea65a39456849cac7a581";
var $ca223f7fcde9b08b$export$2e2bcd8739ae039 = $ca223f7fcde9b08b$var$node;

});

parcelRegister("12jwF", function(module, exports) {

$parcel$export(module.exports, "AriProvider", () => $d9a27a44a6301e03$export$c806f8ac05dc61fa);
$parcel$export(module.exports, "useEntityAri", () => $d9a27a44a6301e03$export$badcacdc306567b8);

var $5uXOq = parcelRequire("5uXOq");
const $d9a27a44a6301e03$var$AriContext = /*#__PURE__*/ (0, $5uXOq.createContext)('');
const $d9a27a44a6301e03$export$c806f8ac05dc61fa = ({ ari: ari, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d9a27a44a6301e03$var$AriContext.Provider, {
        value: ari
    }, children);
const $d9a27a44a6301e03$export$badcacdc306567b8 = ()=>(0, $5uXOq.useContext)($d9a27a44a6301e03$var$AriContext);

});

parcelRegister("54qG5", function(module, exports) {

$parcel$export(module.exports, "BusinessEntityProvider", () => $a71d927d8f07dfcc$export$c800e064c3c327ef);
$parcel$export(module.exports, "useBusinessEntity", () => $a71d927d8f07dfcc$export$ff2574b00bc1c100);

var $5uXOq = parcelRequire("5uXOq");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
const $a71d927d8f07dfcc$var$BusinessEntityContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $a71d927d8f07dfcc$export$c800e064c3c327ef = ({ data: data, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a71d927d8f07dfcc$var$BusinessEntityContext.Provider, {
        value: data
    }, children);
const $a71d927d8f07dfcc$export$ff2574b00bc1c100 = ()=>{
    const entity = (0, $5uXOq.useContext)($a71d927d8f07dfcc$var$BusinessEntityContext);
    return {
        data: entity
    };
};

});

parcelRegister("5YBrl", function(module, exports) {

$parcel$export(module.exports, "JqlProvider", () => $81e54c5b62a4ab4d$export$fdc879e2ba0da048);
$parcel$export(module.exports, "useJqlContext", () => $81e54c5b62a4ab4d$export$f32e2f688fc08561);

var $5uXOq = parcelRequire("5uXOq");
const $81e54c5b62a4ab4d$var$JqlContext = /*#__PURE__*/ (0, $5uXOq.createContext)('');
const $81e54c5b62a4ab4d$export$fdc879e2ba0da048 = ({ jqlContext: jqlContext, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($81e54c5b62a4ab4d$var$JqlContext.Provider, {
        value: jqlContext
    }, children);
const $81e54c5b62a4ab4d$export$f32e2f688fc08561 = ()=>(0, $5uXOq.useContext)($81e54c5b62a4ab4d$var$JqlContext);

});

parcelRegister("1Zr0i", function(module, exports) {

$parcel$export(module.exports, "RealtimeProvider", () => $6a65786548fb921c$export$64d242981d970821);
$parcel$export(module.exports, "useRealtimeContext", () => $6a65786548fb921c$export$f39c07717ad8c35b);

var $5uXOq = parcelRequire("5uXOq");
const $6a65786548fb921c$var$RealtimeContext = /*#__PURE__*/ (0, $5uXOq.createContext)([]);
const $6a65786548fb921c$export$64d242981d970821 = ({ ids: ids, children: children })=>{
    const projectsIds = (0, $5uXOq.useMemo)(()=>ids ? ids.map((pid)=>String(pid)) : [], [
        ids
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6a65786548fb921c$var$RealtimeContext.Provider, {
        value: projectsIds
    }, children);
};
const $6a65786548fb921c$export$f39c07717ad8c35b = ()=>(0, $5uXOq.useContext)($6a65786548fb921c$var$RealtimeContext);

});

parcelRegister("daQYX", function(module, exports) {

$parcel$export(module.exports, "ProjectHookProvider", () => $cf7f84dff81db95f$export$f1938a4916a14d9f);
$parcel$export(module.exports, "useProject", () => $cf7f84dff81db95f$export$51b1383ef8844a7);

var $5uXOq = parcelRequire("5uXOq");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
const $cf7f84dff81db95f$var$Context = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $cf7f84dff81db95f$export$f1938a4916a14d9f = ({ project: project, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cf7f84dff81db95f$var$Context.Provider, {
        value: project
    }, children);
const $cf7f84dff81db95f$export$51b1383ef8844a7 = ()=>{
    const project = (0, $5uXOq.useContext)($cf7f84dff81db95f$var$Context);
    if (!project) throw new Error('useProject must be used within a ProjectHookProvider');
    return project;
};

});

parcelRegister("gxGcZ", function(module, exports) {

$parcel$export(module.exports, "FiltersProvider", () => $5ac2d1f4676106ae$export$905df3588d1d8c75);
$parcel$export(module.exports, "useAssigneesFilterQuery", () => $5ac2d1f4676106ae$export$f39bce8705b01ff5);
$parcel$export(module.exports, "useProjectFilter", () => $5ac2d1f4676106ae$export$b71768ffb8163578);
$parcel$export(module.exports, "useAllowedFieldTypes", () => $5ac2d1f4676106ae$export$9dc8a291956c2fa9);

var $5uXOq = parcelRequire("5uXOq");

var $5fc53 = parcelRequire("5fc53");

var $gzkAf = parcelRequire("gzkAf");
const $5ac2d1f4676106ae$var$DEFAULT_VALUE = {
    assigneeQuery: '',
    projectFilter: {
        totalCount: 0,
        options: []
    }
};
const $5ac2d1f4676106ae$var$FiltersContext = /*#__PURE__*/ (0, $5uXOq.createContext)($5ac2d1f4676106ae$var$DEFAULT_VALUE);
const $5ac2d1f4676106ae$export$905df3588d1d8c75 = ({ projects: projects, children: children })=>{
    const value = (0, $5uXOq.useMemo)(()=>{
        if (!projects) return $5ac2d1f4676106ae$var$DEFAULT_VALUE;
        const assigneeQuery = `is assignee of (${projects.map((project)=>project.key).join(', ')})`;
        const projectFilter = {
            totalCount: projects.length,
            options: projects.map((project)=>({
                    label: project.name,
                    value: String(project.id),
                    avatar: project.avatarUrl,
                    square: true
                }))
        };
        return {
            assigneeQuery: assigneeQuery,
            projectFilter: projectFilter
        };
    }, [
        projects
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5ac2d1f4676106ae$var$FiltersContext.Provider, {
        value: value
    }, children);
};
const $5ac2d1f4676106ae$export$f39bce8705b01ff5 = ()=>(0, $5uXOq.useContext)($5ac2d1f4676106ae$var$FiltersContext).assigneeQuery;
const $5ac2d1f4676106ae$export$b71768ffb8163578 = ()=>(0, $5uXOq.useContext)($5ac2d1f4676106ae$var$FiltersContext).projectFilter;
const $5ac2d1f4676106ae$export$9dc8a291956c2fa9 = (inputAllowedFieldTypes)=>{
    const filtersContext = (0, $5uXOq.useContext)($5ac2d1f4676106ae$var$FiltersContext);
    return (0, $5uXOq.useMemo)(()=>{
        const result = new Set(inputAllowedFieldTypes ?? (0, $gzkAf.BUSINESS_FIELD_TYPES));
        if (filtersContext.projectFilter.totalCount <= 1) result.delete((0, $5fc53.PROJECT_TYPE));
        return result;
    }, [
        filtersContext,
        inputAllowedFieldTypes
    ]);
};

});
parcelRegister("gzkAf", function(module, exports) {

$parcel$export(module.exports, "POPUP_WIDTH", () => $92b04c6ea9a59b67$export$b6d617db656efcca);
$parcel$export(module.exports, "SHOW_MORE_OPTIONS_BTN_SIZE", () => $92b04c6ea9a59b67$export$dd535f74d98d8b3);
$parcel$export(module.exports, "OPTIONS_AVAILABLE_WIDTH", () => $92b04c6ea9a59b67$export$dba112976ea61483);
$parcel$export(module.exports, "GAP_BETWEEN_OPTION", () => $92b04c6ea9a59b67$export$fe1082abeeda69ed);
$parcel$export(module.exports, "OPTION_SPAN_PADDING", () => $92b04c6ea9a59b67$export$17ed91292eb6c163);
$parcel$export(module.exports, "POPUP_OFFSET_TOP", () => $92b04c6ea9a59b67$export$15839778e99d81e7);
$parcel$export(module.exports, "OPTION_MAX_WIDTH", () => $92b04c6ea9a59b67$export$39aa3a14ebf850c7);
$parcel$export(module.exports, "DATE_RANGE_TYPE", () => $92b04c6ea9a59b67$export$1178808c606e043b);
$parcel$export(module.exports, "BUSINESS_FIELD_TYPES", () => $92b04c6ea9a59b67$export$c269ba5d631cb115);
$parcel$export(module.exports, "SOFTWARE_FIELD_TYPES", () => $92b04c6ea9a59b67$export$232814e45256d5dc);
$parcel$export(module.exports, "IMPLEMENTED_TYPES", () => $92b04c6ea9a59b67$export$9615a3d79408a88a);
$parcel$export(module.exports, "EXTRA_CUSTOM_FIELD_TYPES", () => $92b04c6ea9a59b67$export$a21166a4b76932b5);
$parcel$export(module.exports, "SAVED_FILTERS_PER_PAGE", () => $92b04c6ea9a59b67$export$1989c7236a398e8a);

var $gwIPs = parcelRequire("gwIPs");

var $5fc53 = parcelRequire("5fc53");
const $92b04c6ea9a59b67$export$b6d617db656efcca = 360;
const $92b04c6ea9a59b67$export$90bfd0dcc25478e1 = (0, $gwIPs.gridSize) * 2.5;
const $92b04c6ea9a59b67$export$dd535f74d98d8b3 = 32;
const $92b04c6ea9a59b67$export$dba112976ea61483 = $92b04c6ea9a59b67$export$b6d617db656efcca - $92b04c6ea9a59b67$export$90bfd0dcc25478e1 * 2;
const $92b04c6ea9a59b67$export$fe1082abeeda69ed = (0, $gwIPs.gridSize) / 2;
const $92b04c6ea9a59b67$export$17ed91292eb6c163 = (0, $gwIPs.gridSize) * 2;
const $92b04c6ea9a59b67$export$15839778e99d81e7 = 215;
const $92b04c6ea9a59b67$export$de3cbeaaf9d2669 = 28;
const $92b04c6ea9a59b67$export$39aa3a14ebf850c7 = 150;
const $92b04c6ea9a59b67$export$1178808c606e043b = 'dateRange';
const $92b04c6ea9a59b67$export$c269ba5d631cb115 = [
    (0, $5fc53.ASSIGNEE_TYPE),
    (0, $5fc53.CATEGORY_TYPE),
    (0, $5fc53.COMPONENTS_TYPE),
    (0, $5fc53.CREATED),
    $92b04c6ea9a59b67$export$1178808c606e043b,
    (0, $5fc53.ISSUE_TYPE),
    (0, $5fc53.LABELS_TYPE),
    (0, $5fc53.PRIORITY_TYPE),
    (0, $5fc53.PROJECT_TYPE),
    (0, $5fc53.REPORTER_TYPE),
    (0, $5fc53.STATUS_TYPE),
    (0, $5fc53.UPDATED),
    (0, $5fc53.USER_CF_TYPE),
    (0, $5fc53.SELECT_CF_TYPE),
    (0, $5fc53.MULTI_SELECT_CF_TYPE),
    (0, $5fc53.MULTI_CHECKBOXES_CF_TYPE),
    (0, $5fc53.PEOPLE_CF_TYPE),
    (0, $5fc53.DATE_CF_TYPE),
    (0, $5fc53.GOALS_CF_TYPE),
    (0, $5fc53.TEAMS_PLATFORM_CF_TYPE),
    (0, $5fc53.PARENT_FIELD_TYPE)
];
const $92b04c6ea9a59b67$export$232814e45256d5dc = [
    (0, $5fc53.SPRINT_TYPE),
    (0, $5fc53.FIX_VERSIONS_TYPE)
];
const $92b04c6ea9a59b67$export$9615a3d79408a88a = new Set([
    ...$92b04c6ea9a59b67$export$c269ba5d631cb115,
    ...$92b04c6ea9a59b67$export$232814e45256d5dc
]);
const $92b04c6ea9a59b67$export$a21166a4b76932b5 = new Set([
    (0, $5fc53.USER_CF_TYPE),
    (0, $5fc53.SELECT_CF_TYPE),
    (0, $5fc53.MULTI_SELECT_CF_TYPE),
    (0, $5fc53.MULTI_CHECKBOXES_CF_TYPE),
    (0, $5fc53.PEOPLE_CF_TYPE),
    (0, $5fc53.DATE_CF_TYPE)
]);
const $92b04c6ea9a59b67$export$6a2e733db5135f27 = (0, $gwIPs.gridSize) * 3.5;
const $92b04c6ea9a59b67$export$1989c7236a398e8a = 50;
const $92b04c6ea9a59b67$export$91fc9d65fca142a3 = 'users';
const $92b04c6ea9a59b67$export$d74c70f8fb216c6b = 'recentlyUsedUsers';

});


// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("k7McJ", function(module, exports) {

$parcel$export(module.exports, "FETCH_PROJECT_EXPERIENCE", () => $47951bf9c4bef1f5$export$cb40bbf7ea51db63);
const $47951bf9c4bef1f5$export$cb40bbf7ea51db63 = {
    experience: 'fetch-project',
    packageName: 'jiraBusinessEntityProjectProvider',
    teamName: 'wanjel'
};

});

parcelRegister("8OqLl", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5cc2e237e9a9763$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $a5cc2e237e9a9763$var$NotFoundComponent = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("dDX2b")), {
    moduleId: "./src/packages/business/entity/project-provider/src/ui/project-context/not-found/main.tsx"
});
const $a5cc2e237e9a9763$var$NotFoundAsync = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "not-found-component",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a5cc2e237e9a9763$var$NotFoundComponent, null));
var $a5cc2e237e9a9763$export$2e2bcd8739ae039 = $a5cc2e237e9a9763$var$NotFoundAsync;

});
parcelRegister("dDX2b", function(module, exports) {

let $9eecb5dea26f1017$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9eecb5dea26f1017$var$load("gUneV").then(()=>parcelRequire('4zX1V'));

});



parcelRegister("4nnGr", function(module, exports) {

$parcel$export(module.exports, "useJWMListFeatures", () => $a4964e0e2b381387$export$1253737febad5ca9);
$parcel$export(module.exports, "ListFeaturesProvider", () => $a4964e0e2b381387$export$9b33d4a1cd64aa2c);

var $5uXOq = parcelRequire("5uXOq");
const $a4964e0e2b381387$var$defaultFeaturesContext = {
    isShareButtonEnabled: true,
    isPresenceEnabled: true,
    issueViewInteraction: 'default',
    isOnboardingEnabled: true,
    featureView: 'list',
    inviteButtonInteraction: 'default',
    typeSelectInteraction: 'default',
    hasFilterCustomFields: true,
    hasCreateSubtask: true,
    canCreateIssues: true,
    isSoftwareFieldsEnabled: false,
    isBusinessFieldsEnabled: true,
    isScrumProject: false
};
const $a4964e0e2b381387$var$ListFeaturesContext = /*#__PURE__*/ (0, $5uXOq.createContext)($a4964e0e2b381387$var$defaultFeaturesContext);
const $a4964e0e2b381387$export$1253737febad5ca9 = ()=>(0, $5uXOq.useContext)($a4964e0e2b381387$var$ListFeaturesContext);
const $a4964e0e2b381387$export$9b33d4a1cd64aa2c = ({ children: children, ...props })=>{
    const value = (0, $5uXOq.useMemo)(()=>({
            ...$a4964e0e2b381387$var$defaultFeaturesContext,
            ...props
        }), [
        props
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a4964e0e2b381387$var$ListFeaturesContext.Provider, {
        value: value
    }, children);
};

});

parcelRegister("evDrO", function(module, exports) {

$parcel$export(module.exports, "default", () => $37be016d73635480$export$2e2bcd8739ae039);

var $fWCh0 = parcelRequire("fWCh0");

var $aa94M = parcelRequire("aa94M");

var $ea26r = parcelRequire("ea26r");

var $2cLRx = parcelRequire("2cLRx");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $bL5sD = parcelRequire("bL5sD");

var $aXhsp = parcelRequire("aXhsp");

var $AeWM3 = parcelRequire("AeWM3");

var $eiOkd = parcelRequire("eiOkd");

var $54aDJ = parcelRequire("54aDJ");

var $imVeH = parcelRequire("imVeH");

var $daQYX = parcelRequire("daQYX");

var $adJfs = parcelRequire("adJfs");

var $388MD = parcelRequire("388MD");

var $cm8b5 = parcelRequire("cm8b5");

var $33Toe = parcelRequire("33Toe");

var $l9KLJ = parcelRequire("l9KLJ");

var $lL5b5 = parcelRequire("lL5b5");

var $kLaXN = parcelRequire("kLaXN");

var $7CMCs = parcelRequire("7CMCs");

var $6s1PB = parcelRequire("6s1PB");

var $5fc53 = parcelRequire("5fc53");

var $4rBJg = parcelRequire("4rBJg");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $eCGEE = parcelRequire("eCGEE");

var $4R6GH = parcelRequire("4R6GH");

var $6ByXP = parcelRequire("6ByXP");

var $hug5L = parcelRequire("hug5L");

var $eTDjN = parcelRequire("eTDjN");

var $cpqMw = parcelRequire("cpqMw");

var $4nnGr = parcelRequire("4nnGr");

var $5cP2Q = parcelRequire("5cP2Q");

var $8e3Yw = parcelRequire("8e3Yw");

var $g4BWd = parcelRequire("g4BWd");

var $aoiYi = parcelRequire("aoiYi");

var $eADY6 = parcelRequire("eADY6");
const $37be016d73635480$var$analyticsSourceName = 'listView';
const $37be016d73635480$var$ListViewWithWorkflow = /*#__PURE__*/ (0, $5uXOq.memo)(({ formattingRulesQuery: formattingRulesQuery, queryFragment: queryFragment })=>{
    const projectData = (0, $daQYX.useProject)();
    const projectId = String(projectData.id);
    const projectKey = projectData.key;
    const projectName = projectData.name;
    const projectType = projectData.type;
    const isTeamManaged = projectData.isSimplified;
    const [groupByFieldId] = (0, $8e3Yw.useGroupBy)();
    const isGroupingByStatus = groupByFieldId === (0, $5fc53.STATUS_TYPE);
    const services = (0, $g4BWd.useCreateIssue)();
    const data = (0, $8Uumt.useFragment)((0, $2cLRx.default), queryFragment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l9KLJ.WorkflowsProvider), {
        enabled: isGroupingByStatus
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $33Toe.IssueCreateProvider), {
        onCreateIssue: services.createIssue,
        onRefetchIssue: services.refetchIssue,
        queryFragment: data
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        objectType: "list",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: $37be016d73635480$var$analyticsSourceName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aoiYi.default), {
        projectKey: projectKey,
        projectName: projectName,
        projectId: projectId,
        projectType: projectType,
        isTeamManaged: isTeamManaged,
        formattingRulesQuery: formattingRulesQuery
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: {
            projectKey: projectKey
        }
    }))));
});
const $37be016d73635480$export$4b527a365d42af03 = /*#__PURE__*/ (0, $5uXOq.memo)(({ queryFragment: queryFragment, header: header, formattingRulesQuery: formattingRulesQuery })=>{
    const { isSoftwareFieldsEnabled: isSoftwareFieldsEnabled } = (0, $4nnGr.useJWMListFeatures)();
    // NOTE: Don't want to fire exposures here - happens in form directory view
    const [formsIssueViewExpConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jwm_business_forms_issue_view');
    const data = (0, $8Uumt.useFragment)((0, $ea26r.default), queryFragment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eiOkd.default), {
        header: header,
        sidebarTheme: isSoftwareFieldsEnabled ? 'software' : 'business',
        withSidebar: true,
        withOverflow: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $adJfs.IssueTypesAndFieldsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($37be016d73635480$var$ListViewWithWorkflow, {
        queryFragment: data,
        formattingRulesQuery: formattingRulesQuery
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $388MD.RefetchFieldsController), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "forms-label-flag",
        packageName: "jiraBusinessList",
        teamName: "jira-werewolves"
    }, formsIssueViewExpConfig.get('isFormsIssueViewEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5cP2Q.FormsLabelFlag), null)));
});
const $37be016d73635480$var$ListViewRootWithConfluenceProvider = ({ children: children })=>{
    const hasConfluence = (0, $imVeH.useTenantHasConfluence)();
    return hasConfluence ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $54aDJ.ConfluenceModalProvider), null, children) : children;
};
const $37be016d73635480$export$d63bf888f7c02a67 = ({ queryFragment: queryFragment, formattingRulesQuery: formattingRulesQuery, header: header })=>{
    const hasConfluence = (0, $imVeH.useTenantHasConfluence)();
    const data = (0, $8Uumt.useFragment)((0, $aa94M.default), queryFragment);
    // `hasConfluence` check only needed until we roll out `jsw_perf_format-links-in-custom-fields` experiment.
    // remove this condition after clean up but keep `ListViewRootWithConfluenceProvider`
    if (hasConfluence || (0, $6s1PB.expValEquals)('jsw_perf_format-links-in-custom-fields', 'list-view', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($37be016d73635480$var$ListViewRootWithConfluenceProvider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $AeWM3.ApolloClientProvider), {
        client: (0, $aXhsp.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($37be016d73635480$export$4b527a365d42af03, {
        queryFragment: data,
        header: header,
        formattingRulesQuery: formattingRulesQuery
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $AeWM3.ApolloClientProvider), {
        client: (0, $aXhsp.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($37be016d73635480$export$4b527a365d42af03, {
        queryFragment: data,
        header: header,
        formattingRulesQuery: formattingRulesQuery
    }));
};
const $37be016d73635480$var$MaybeFormatRulesContainer = (0, $bL5sD.componentWithFG)('conditional-formatting-new-list-targeting-gate', (0, $hug5L.FormatRulesContainer), ({ children: children })=>children);
const $37be016d73635480$var$List = ({ queryFragment: queryFragment, formattingRulesQuery: formattingRulesQuery, header: header })=>{
    const data = (0, $8Uumt.useFragment)((0, $fWCh0.default), queryFragment);
    const InvalidJQLErrorBoundary = (0, $4R6GH.fg)('timeline-add-jql-error-boundary') ? (0, $eCGEE.InvalidJQLErrorBoundary) : (0, $cpqMw.InvalidJQLErrorBoundary);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cm8b5.ExperienceErrorBoundary), {
        experience: (0, $eTDjN.VIEW_EXPERIENCE),
        shouldStartExperience: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4rBJg.FiltersJqlProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($37be016d73635480$var$MaybeFormatRulesContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(InvalidJQLErrorBoundary, {
        render: (clearError)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6ByXP.ConditionalWrapper), {
                condition: (0, $4R6GH.fg)('update-filter-empty-state'),
                renderWrapper: (errorState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
                        xcss: $37be016d73635480$var$wrapperStyles
                    }, errorState)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eADY6.ErrorState), {
                reason: "INVALID_JQL",
                clearError: clearError
            }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kLaXN.AuthenticationErrorBoundary), {
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lL5b5.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($37be016d73635480$export$d63bf888f7c02a67, {
        queryFragment: data,
        header: header,
        formattingRulesQuery: formattingRulesQuery
    }))))));
};
var $37be016d73635480$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($37be016d73635480$var$List);
const $37be016d73635480$var$wrapperStyles = (0, $8CUq3.xcss)({
    height: '100%'
});

});
parcelRegister("fWCh0", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8aa7346502b9073$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<da52a55af52d8c8660402462cc2f9793>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d8aa7346502b9073$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "src_businessList_List_queryFragment",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "src_businessList_ListViewRootWithSmartCard_queryFragment"
        }
    ],
    "type": "Query"
};
$d8aa7346502b9073$var$node.hash = "141e0658b8a403c4800a74e2c87fdb8d";
var $d8aa7346502b9073$export$2e2bcd8739ae039 = $d8aa7346502b9073$var$node;

});

parcelRegister("aa94M", function(module, exports) {

$parcel$export(module.exports, "default", () => $61ef561dc4e625d7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f9299b360d1c09f2ccaf3097b6b4781b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $61ef561dc4e625d7$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "src_businessList_ListViewRootWithSmartCard_queryFragment",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "src_businessList_ListViewRoot_queryFragment"
        }
    ],
    "type": "Query"
};
$61ef561dc4e625d7$var$node.hash = "d9c417a88c77b82987a401093871e680";
var $61ef561dc4e625d7$export$2e2bcd8739ae039 = $61ef561dc4e625d7$var$node;

});

parcelRegister("ea26r", function(module, exports) {

$parcel$export(module.exports, "default", () => $6243191b7906d05e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8a91dc418fed1e6c23a0a3a725731eaa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6243191b7906d05e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "src_businessList_ListViewRoot_queryFragment",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "src_businessList_ListViewWithWorkflow_queryFragment"
        }
    ],
    "type": "Query"
};
$6243191b7906d05e$var$node.hash = "0808de8252e260b8784d5c7b742c4f16";
var $6243191b7906d05e$export$2e2bcd8739ae039 = $6243191b7906d05e$var$node;

});

parcelRegister("2cLRx", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba5fb173ddbf3a82$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1de7d5361a6ea6f892b570e4febbc125>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ba5fb173ddbf3a82$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "src_businessList_ListViewWithWorkflow_queryFragment",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "IssueCreateProvider"
        }
    ],
    "type": "Query"
};
$ba5fb173ddbf3a82$var$node.hash = "f2ef167d11fdd3f2601fe9d2916e6c35";
var $ba5fb173ddbf3a82$export$2e2bcd8739ae039 = $ba5fb173ddbf3a82$var$node;

});

parcelRegister("bL5sD", function(module, exports) {

$parcel$export(module.exports, "componentWithFG", () => $fdd65d30971656f3$export$cf56d0f54cfcce4);

var $VSDnB = parcelRequire("VSDnB");

var $gmmd2 = parcelRequire("gmmd2");
const $fdd65d30971656f3$export$cf56d0f54cfcce4 = (featureFlagName, ComponentTrue, ComponentFalse)=>(0, $gmmd2.componentWithCondition)(()=>(0, $VSDnB.fg)(featureFlagName), ComponentTrue, ComponentFalse);

});
parcelRegister("gmmd2", function(module, exports) {

$parcel$export(module.exports, "componentWithCondition", () => $5b194bd8d7426f4b$export$6e8ea24b15199873);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $5b194bd8d7426f4b$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>condition() ? /*#__PURE__*/ (0, $2OMIu.jsx)(ComponentTrue, {
            ...props,
            ref: ref
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}

});


parcelRegister("aXhsp", function(module, exports) {

$parcel$export(module.exports, "default", () => $d88f4e626c9babc0$export$2e2bcd8739ae039);

var $9XE6b = parcelRequire("9XE6b");

var $ivfDv = parcelRequire("ivfDv");

var $e3a3O = parcelRequire("e3a3O");

var $clSzL = parcelRequire("clSzL");

var $h4ppL = parcelRequire("h4ppL");

var $JPsIz = parcelRequire("JPsIz");

var $lC4FX = parcelRequire("lC4FX");

var $cuKXc = parcelRequire("cuKXc");

var $2YZCu = parcelRequire("2YZCu");

var $dxpxC = parcelRequire("dxpxC");

var $l0T7c = parcelRequire("l0T7c");

var $9g713 = parcelRequire("9g713");


const $d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID = 'gira';
const $d88f4e626c9babc0$var$CACHE_NAME = `apollo-cache/${$d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID}`;
const $d88f4e626c9babc0$var$LOG_NAMESPACE = `apollo.${$d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID}.error.graphql`;
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $d88f4e626c9babc0$var$isSsrSuccessful = ()=>false ? true : !window || !window.SPA_STATE;
const $d88f4e626c9babc0$var$NETWORK_ERRORS_COUNTER_KEY = 'networkErrorsCounter';
const $d88f4e626c9babc0$export$851a7159daf49c89 = new (0, $ivfDv.IntrospectionFragmentMatcher)({
    introspectionQueryResultData: (/*@__PURE__*/$parcel$interopDefault($l0T7c))
});
const $d88f4e626c9babc0$var$errorLink = (0, $h4ppL.onError)(({ graphQLErrors: graphQLErrors, networkError: networkError, operation: operation })=>{
    // Ignore network errors as they will be logged in the retry link
    (0, $9g713.reportErrors)({
        graphQLErrors: graphQLErrors,
        operation: operation
    });
    // Skip default error logging if analytics context data is defined for the query.
    const errorAnalytics = (0, $9g713.getErrorAnalyticsContext)(operation.getContext());
    if (errorAnalytics !== undefined) return;
    if (graphQLErrors) {
        if (Array.isArray(graphQLErrors)) graphQLErrors.map(({ message: message, locations: locations, path: path })=>(0, $2YZCu.default).safeErrorWithoutCustomerData($d88f4e626c9babc0$var$LOG_NAMESPACE, `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`, {
                message: JSON.stringify(message),
                path: JSON.stringify(path),
                locations: JSON.stringify(locations)
            }));
        else (0, $2YZCu.default).safeErrorWithoutCustomerData($d88f4e626c9babc0$var$LOG_NAMESPACE, '[GraphQL error]: Unexpected error message format', {
            message: JSON.stringify(graphQLErrors)
        });
    }
    if (networkError) {
        const occuredNetworkErrorsBefore = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(operation.getContext(), [
            $d88f4e626c9babc0$var$NETWORK_ERRORS_COUNTER_KEY
        ], 0);
        (0, $2YZCu.default).safeErrorWithoutCustomerData($d88f4e626c9babc0$var$LOG_NAMESPACE, `[Network error]: ${networkError}, attempt ${occuredNetworkErrorsBefore + 1}`);
        operation.setContext({
            [$d88f4e626c9babc0$var$NETWORK_ERRORS_COUNTER_KEY]: occuredNetworkErrorsBefore + 1
        });
    }
});
const $d88f4e626c9babc0$var$retryLinkWithFama = new (0, $lC4FX.RetryLink)({
    delay: {
        initial: 300,
        max: 120000,
        jitter: true
    },
    attempts: (count, operation, networkError)=>{
        const retry = count < 5 && networkError && !networkError.statusCode;
        // Don't report any error if we're going to attempt a retry
        if (!retry) (0, $9g713.reportErrors)({
            networkError: networkError,
            operation: operation
        });
        return retry;
    }
});
class $d88f4e626c9babc0$var$CancelableRequestLink extends (0, $clSzL.ApolloLink) {
    constructor(){
        super();
        this.inFlightRequestControllers = {};
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    request(operation, forward) {
        const context = operation.getContext();
        if (!context.cancelable) return forward(operation);
        const key = JSON.stringify([
            operation.operationName,
            operation.query
        ]); // Equivalent to `operation.toKey` less the _actual_ variables
        this.inFlightRequestControllers[key]?.abort(); // Always abort the previous request
        const abortController = new AbortController();
        operation.setContext({
            ...context,
            fetchOptions: {
                signal: abortController.signal
            } // HttpLink passes this directly to fetch implementation
        });
        this.inFlightRequestControllers[key] = abortController;
        const cleanup = ()=>{
            // This callback may be called long after the request is replaced
            if (this.inFlightRequestControllers[key] === abortController) delete this.inFlightRequestControllers[key];
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return new (0, $clSzL.Observable)((observer)=>{
            const subscription = forward(operation).subscribe({
                next: observer.next.bind(observer),
                // @ts-expect-error - TS7006 - Parameter 'error' implicitly has an 'any' type.
                error: (error)=>{
                    observer.error(error);
                    cleanup();
                },
                complete: observer.complete.bind(observer)
            });
            return ()=>{
                subscription?.unsubscribe();
                cleanup();
            };
        });
    }
}
const $d88f4e626c9babc0$var$cache = new (0, $ivfDv.InMemoryCache)({
    cacheRedirects: {
        Query: {
            ...(0, $cuKXc.fragmentCacheRedirect)()
        }
    },
    fragmentMatcher: $d88f4e626c9babc0$export$851a7159daf49c89,
    dataIdFromObject: (object)=>object.id && `${object.id}${object.__typename}`
})// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
.restore(!$d88f4e626c9babc0$var$isSsrSuccessful() && window.SPA_STATE[$d88f4e626c9babc0$var$CACHE_NAME] || {});
const $d88f4e626c9babc0$export$de66868aab9e79ea = (baseUrl)=>new (0, $e3a3O.ApolloClient)({
        name: $d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID,
        ssrMode: $d88f4e626c9babc0$var$isSsrSuccessful(),
        // @ts-expect-error - TS2345 - Argument of type '{ name: string; ssrMode: boolean; addTypename: boolean; link: ApolloLink; cache: InMemoryCache; connectToDevTools: boolean; }' is not assignable to parameter of type 'ApolloClientOptions<NormalizedCacheObject>'.
        addTypename: true,
        link: (0, $clSzL.ApolloLink).from([
            $d88f4e626c9babc0$var$retryLinkWithFama,
            $d88f4e626c9babc0$var$errorLink,
            (0, $dxpxC.UFOLoggerLink),
            (0, $cuKXc.fragmentLinkState)($d88f4e626c9babc0$var$cache),
            ...!$d88f4e626c9babc0$var$isSsrSuccessful() ? [
                new $d88f4e626c9babc0$var$CancelableRequestLink()
            ] : [],
            new (0, $JPsIz.HttpLink)({
                uri: ({ operationName: operationName })=>`${baseUrl}/rest/${$d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID}/1/?operation=${encodeURIComponent(operationName)}`,
                credentials: 'same-origin',
                // @ts-expect-error - TS2345 - Argument of type '{ uri: ({ operationName }: Operation) => string; credentials: string; abortErrorDoesNotCauseError: boolean; }' is not assignable to parameter of type 'Options'.
                abortErrorDoesNotCauseError: !$d88f4e626c9babc0$var$isSsrSuccessful()
            })
        ].filter(Boolean)),
        cache: $d88f4e626c9babc0$var$cache,
        connectToDevTools: false
    });
var $d88f4e626c9babc0$export$2e2bcd8739ae039 = {
    clientId: $d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID,
    clientCreator: $d88f4e626c9babc0$export$de66868aab9e79ea
};

});
parcelRegister("ivfDv", function(module, exports) {

$parcel$export(module.exports, "IntrospectionFragmentMatcher", () => $d7874048ca668ecb$export$3b71c6b829c99d21);
$parcel$export(module.exports, "defaultDataIdFromObject", () => $d7874048ca668ecb$export$bd03c5a9c99d6bce);
$parcel$export(module.exports, "InMemoryCache", () => $d7874048ca668ecb$export$467265324939f47f);

var $3VFsf = parcelRequire("3VFsf");

var $hzuXv = parcelRequire("hzuXv");

var $jojW6 = parcelRequire("jojW6");
var $bqMzA = parcelRequire("bqMzA");

var $gLy2H = parcelRequire("gLy2H");

var $1DiV8 = parcelRequire("1DiV8");
var $d7874048ca668ecb$var$haveWarned = false;
function $d7874048ca668ecb$var$shouldWarn() {
    var answer = !$d7874048ca668ecb$var$haveWarned;
    if (!(0, $jojW6.isTest)()) $d7874048ca668ecb$var$haveWarned = true;
    return answer;
}
var $d7874048ca668ecb$export$5d3fcf53267091de = function() {
    function HeuristicFragmentMatcher() {}
    HeuristicFragmentMatcher.prototype.ensureReady = function() {
        return Promise.resolve();
    };
    HeuristicFragmentMatcher.prototype.canBypassInit = function() {
        return true;
    };
    HeuristicFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        if (!__typename) {
            $d7874048ca668ecb$var$shouldWarn();
            return 'heuristic';
        }
        if (__typename === typeCondition) return true;
        $d7874048ca668ecb$var$shouldWarn();
        return 'heuristic';
    };
    return HeuristicFragmentMatcher;
}();
var $d7874048ca668ecb$export$3b71c6b829c99d21 = function() {
    function IntrospectionFragmentMatcher(options) {
        if (options && options.introspectionQueryResultData) {
            this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
            this.isReady = true;
        } else this.isReady = false;
        this.match = this.match.bind(this);
    }
    IntrospectionFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        (0, $1DiV8.invariant)(this.isReady, 1);
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        (0, $1DiV8.invariant)(__typename, 2);
        if (__typename === typeCondition) return true;
        var implementingTypes = this.possibleTypesMap[typeCondition];
        if (__typename && implementingTypes && implementingTypes.indexOf(__typename) > -1) return true;
        return false;
    };
    IntrospectionFragmentMatcher.prototype.parseIntrospectionResult = function(introspectionResultData) {
        var typeMap = {};
        introspectionResultData.__schema.types.forEach(function(type) {
            if (type.kind === 'UNION' || type.kind === 'INTERFACE') typeMap[type.name] = type.possibleTypes.map(function(implementingType) {
                return implementingType.name;
            });
        });
        return typeMap;
    };
    return IntrospectionFragmentMatcher;
}();
var $d7874048ca668ecb$var$hasOwn = Object.prototype.hasOwnProperty;
var $d7874048ca668ecb$var$DepTrackingCache = function() {
    function DepTrackingCache(data) {
        var _this = this;
        if (data === void 0) data = Object.create(null);
        this.data = data;
        this.depend = (0, $gLy2H.wrap)(function(dataId) {
            return _this.data[dataId];
        }, {
            disposable: true,
            makeCacheKey: function(dataId) {
                return dataId;
            }
        });
    }
    DepTrackingCache.prototype.toObject = function() {
        return this.data;
    };
    DepTrackingCache.prototype.get = function(dataId) {
        this.depend(dataId);
        return this.data[dataId];
    };
    DepTrackingCache.prototype.set = function(dataId, value) {
        var oldValue = this.data[dataId];
        if (value !== oldValue) {
            this.data[dataId] = value;
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.delete = function(dataId) {
        if ($d7874048ca668ecb$var$hasOwn.call(this.data, dataId)) {
            delete this.data[dataId];
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.clear = function() {
        this.replace(null);
    };
    DepTrackingCache.prototype.replace = function(newData) {
        var _this = this;
        if (newData) {
            Object.keys(newData).forEach(function(dataId) {
                _this.set(dataId, newData[dataId]);
            });
            Object.keys(this.data).forEach(function(dataId) {
                if (!$d7874048ca668ecb$var$hasOwn.call(newData, dataId)) _this.delete(dataId);
            });
        } else Object.keys(this.data).forEach(function(dataId) {
            _this.delete(dataId);
        });
    };
    return DepTrackingCache;
}();
function $d7874048ca668ecb$var$defaultNormalizedCacheFactory(seed) {
    return new $d7874048ca668ecb$var$DepTrackingCache(seed);
}
var $d7874048ca668ecb$export$628ef07ba8965f12 = function() {
    function StoreReader(_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.cacheKeyRoot, cacheKeyRoot = _c === void 0 ? new (0, $gLy2H.KeyTrie)((0, $jojW6.canUseWeakMap)) : _c, _d = _b.freezeResults, freezeResults = _d === void 0 ? false : _d;
        var _e = this, executeStoreQuery = _e.executeStoreQuery, executeSelectionSet = _e.executeSelectionSet, executeSubSelectedArray = _e.executeSubSelectedArray;
        this.freezeResults = freezeResults;
        this.executeStoreQuery = (0, $gLy2H.wrap)(function(options) {
            return executeStoreQuery.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, fragmentMatcher = _a.fragmentMatcher;
                if (contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(contextValue.store, query, fragmentMatcher, JSON.stringify(variableValues), rootValue.id);
            }
        });
        this.executeSelectionSet = (0, $gLy2H.wrap)(function(options) {
            return executeSelectionSet.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, selectionSet, execContext.fragmentMatcher, JSON.stringify(execContext.variableValues), rootValue.id);
            }
        });
        this.executeSubSelectedArray = (0, $gLy2H.wrap)(function(options) {
            return executeSubSelectedArray.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var field = _a.field, array = _a.array, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, field, array, JSON.stringify(execContext.variableValues));
            }
        });
    }
    StoreReader.prototype.readQueryFromStore = function(options) {
        return this.diffQueryAgainstStore((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
            returnPartialData: false
        })).result;
    };
    StoreReader.prototype.diffQueryAgainstStore = function(_a) {
        var store = _a.store, query = _a.query, variables = _a.variables, previousResult = _a.previousResult, _b = _a.returnPartialData, returnPartialData = _b === void 0 ? true : _b, _c = _a.rootId, rootId = _c === void 0 ? 'ROOT_QUERY' : _c, fragmentMatcherFunction = _a.fragmentMatcherFunction, config = _a.config;
        var queryDefinition = (0, $jojW6.getQueryDefinition)(query);
        variables = (0, $jojW6.assign)({}, (0, $jojW6.getDefaultValues)(queryDefinition), variables);
        var context = {
            store: store,
            dataIdFromObject: config && config.dataIdFromObject,
            cacheRedirects: config && config.cacheRedirects || {}
        };
        var execResult = this.executeStoreQuery({
            query: query,
            rootValue: {
                type: 'id',
                id: rootId,
                generated: true,
                typename: 'Query'
            },
            contextValue: context,
            variableValues: variables,
            fragmentMatcher: fragmentMatcherFunction
        });
        var hasMissingFields = execResult.missing && execResult.missing.length > 0;
        if (hasMissingFields && !returnPartialData) execResult.missing.forEach(function(info) {
            if (info.tolerable) return;
            throw new (0, $1DiV8.InvariantError)(8);
        });
        if (previousResult) {
            if ((0, $bqMzA.equal)(previousResult, execResult.result)) execResult.result = previousResult;
        }
        return {
            result: execResult.result,
            complete: !hasMissingFields
        };
    };
    StoreReader.prototype.executeStoreQuery = function(_a) {
        var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, _b = _a.fragmentMatcher, fragmentMatcher = _b === void 0 ? $d7874048ca668ecb$var$defaultFragmentMatcher : _b;
        var mainDefinition = (0, $jojW6.getMainDefinition)(query);
        var fragments = (0, $jojW6.getFragmentDefinitions)(query);
        var fragmentMap = (0, $jojW6.createFragmentMap)(fragments);
        var execContext = {
            query: query,
            fragmentMap: fragmentMap,
            contextValue: contextValue,
            variableValues: variableValues,
            fragmentMatcher: fragmentMatcher
        };
        return this.executeSelectionSet({
            selectionSet: mainDefinition.selectionSet,
            rootValue: rootValue,
            execContext: execContext
        });
    };
    StoreReader.prototype.executeSelectionSet = function(_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
        var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
        var finalResult = {
            result: null
        };
        var objectsToMerge = [];
        var object = contextValue.store.get(rootValue.id);
        var typename = object && object.__typename || rootValue.id === 'ROOT_QUERY' && 'Query' || void 0;
        function handleMissing(result) {
            var _a;
            if (result.missing) {
                finalResult.missing = finalResult.missing || [];
                (_a = finalResult.missing).push.apply(_a, result.missing);
            }
            return result.result;
        }
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $jojW6.shouldInclude)(selection, variables)) return;
            if ((0, $jojW6.isField)(selection)) {
                var fieldResult = handleMissing(_this.executeField(object, typename, selection, execContext));
                if (typeof fieldResult !== 'undefined') objectsToMerge.push((_a = {}, _a[(0, $jojW6.resultKeyNameFromField)(selection)] = fieldResult, _a));
            } else {
                var fragment = void 0;
                if ((0, $jojW6.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = fragmentMap[selection.name.value];
                    if (!fragment) throw new (0, $1DiV8.InvariantError)(9);
                }
                var typeCondition = fragment.typeCondition && fragment.typeCondition.name.value;
                var match = !typeCondition || execContext.fragmentMatcher(rootValue, typeCondition, contextValue);
                if (match) {
                    var fragmentExecResult = _this.executeSelectionSet({
                        selectionSet: fragment.selectionSet,
                        rootValue: rootValue,
                        execContext: execContext
                    });
                    if (match === 'heuristic' && fragmentExecResult.missing) fragmentExecResult = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, fragmentExecResult), {
                        missing: fragmentExecResult.missing.map(function(info) {
                            return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, info), {
                                tolerable: true
                            });
                        })
                    });
                    objectsToMerge.push(handleMissing(fragmentExecResult));
                }
            }
        });
        finalResult.result = (0, $jojW6.mergeDeepArray)(objectsToMerge);
        this.freezeResults;
        return finalResult;
    };
    StoreReader.prototype.executeField = function(object, typename, field, execContext) {
        var variables = execContext.variableValues, contextValue = execContext.contextValue;
        var fieldName = field.name.value;
        var args = (0, $jojW6.argumentsObjectFromField)(field, variables);
        var info = {
            resultKey: (0, $jojW6.resultKeyNameFromField)(field),
            directives: (0, $jojW6.getDirectiveInfoFromField)(field, variables)
        };
        var readStoreResult = $d7874048ca668ecb$var$readStoreResolver(object, typename, fieldName, args, contextValue, info);
        if (Array.isArray(readStoreResult.result)) return this.combineExecResults(readStoreResult, this.executeSubSelectedArray({
            field: field,
            array: readStoreResult.result,
            execContext: execContext
        }));
        if (!field.selectionSet) {
            $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, readStoreResult.result);
            this.freezeResults;
            return readStoreResult;
        }
        if (readStoreResult.result == null) return readStoreResult;
        return this.combineExecResults(readStoreResult, this.executeSelectionSet({
            selectionSet: field.selectionSet,
            rootValue: readStoreResult.result,
            execContext: execContext
        }));
    };
    StoreReader.prototype.combineExecResults = function() {
        var execResults = [];
        for(var _i = 0; _i < arguments.length; _i++)execResults[_i] = arguments[_i];
        var missing;
        execResults.forEach(function(execResult) {
            if (execResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, execResult.missing);
            }
        });
        return {
            result: execResults.pop().result,
            missing: missing
        };
    };
    StoreReader.prototype.executeSubSelectedArray = function(_a) {
        var _this = this;
        var field = _a.field, array = _a.array, execContext = _a.execContext;
        var missing;
        function handleMissing(childResult) {
            if (childResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, childResult.missing);
            }
            return childResult.result;
        }
        array = array.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return handleMissing(_this.executeSubSelectedArray({
                field: field,
                array: item,
                execContext: execContext
            }));
            if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                selectionSet: field.selectionSet,
                rootValue: item,
                execContext: execContext
            }));
            $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, item);
            return item;
        });
        this.freezeResults;
        return {
            result: array,
            missing: missing
        };
    };
    return StoreReader;
}();
function $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, value) {
    if (!field.selectionSet && (0, $jojW6.isIdValue)(value)) throw new (0, $1DiV8.InvariantError)(10);
}
function $d7874048ca668ecb$var$defaultFragmentMatcher() {
    return true;
}
function $d7874048ca668ecb$export$7a4899fe13f33235(idValue) {
    (0, $1DiV8.invariant)((0, $jojW6.isIdValue)(idValue), 11);
}
function $d7874048ca668ecb$var$readStoreResolver(object, typename, fieldName, args, context, _a) {
    var resultKey = _a.resultKey, directives = _a.directives;
    var storeKeyName = fieldName;
    if (args || directives) storeKeyName = (0, $jojW6.getStoreKeyName)(storeKeyName, args, directives);
    var fieldValue = void 0;
    if (object) {
        fieldValue = object[storeKeyName];
        if (typeof fieldValue === 'undefined' && context.cacheRedirects && typeof typename === 'string') {
            var type = context.cacheRedirects[typename];
            if (type) {
                var resolver = type[fieldName];
                if (resolver) fieldValue = resolver(object, args, {
                    getCacheKey: function(storeObj) {
                        var id = context.dataIdFromObject(storeObj);
                        return id && (0, $jojW6.toIdValue)({
                            id: id,
                            typename: storeObj.__typename
                        });
                    }
                });
            }
        }
    }
    if (typeof fieldValue === 'undefined') return {
        result: fieldValue,
        missing: [
            {
                object: object,
                fieldName: storeKeyName,
                tolerable: false
            }
        ]
    };
    if ((0, $jojW6.isJsonValue)(fieldValue)) fieldValue = fieldValue.json;
    return {
        result: fieldValue
    };
}
var $d7874048ca668ecb$export$ee7258b8691956a3 = function() {
    function ObjectCache(data) {
        if (data === void 0) data = Object.create(null);
        this.data = data;
    }
    ObjectCache.prototype.toObject = function() {
        return this.data;
    };
    ObjectCache.prototype.get = function(dataId) {
        return this.data[dataId];
    };
    ObjectCache.prototype.set = function(dataId, value) {
        this.data[dataId] = value;
    };
    ObjectCache.prototype.delete = function(dataId) {
        this.data[dataId] = void 0;
    };
    ObjectCache.prototype.clear = function() {
        this.data = Object.create(null);
    };
    ObjectCache.prototype.replace = function(newData) {
        this.data = newData || Object.create(null);
    };
    return ObjectCache;
}();
function $d7874048ca668ecb$export$7e2b40d1002de152(seed) {
    return new $d7874048ca668ecb$export$ee7258b8691956a3(seed);
}
var $d7874048ca668ecb$export$de4e6870dc6ac801 = function(_super) {
    (0, $3VFsf.__extends)(WriteError, _super);
    function WriteError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'WriteError';
        return _this;
    }
    return WriteError;
}(Error);
function $d7874048ca668ecb$export$fb86e3236e77e3(error, document) {
    var enhancedError = new $d7874048ca668ecb$export$de4e6870dc6ac801("Error writing result to store for query:\n " + JSON.stringify(document));
    enhancedError.message += '\n' + error.message;
    enhancedError.stack = error.stack;
    return enhancedError;
}
var $d7874048ca668ecb$export$eb8361c5d132fb8f = function() {
    function StoreWriter() {}
    StoreWriter.prototype.writeQueryToStore = function(_a) {
        var query = _a.query, result = _a.result, _b = _a.store, store = _b === void 0 ? $d7874048ca668ecb$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        return this.writeResultToStore({
            dataId: 'ROOT_QUERY',
            result: result,
            document: query,
            store: store,
            variables: variables,
            dataIdFromObject: dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
    };
    StoreWriter.prototype.writeResultToStore = function(_a) {
        var dataId = _a.dataId, result = _a.result, document = _a.document, _b = _a.store, store = _b === void 0 ? $d7874048ca668ecb$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        var operationDefinition = (0, $jojW6.getOperationDefinition)(document);
        try {
            return this.writeSelectionSetToStore({
                result: result,
                dataId: dataId,
                selectionSet: operationDefinition.selectionSet,
                context: {
                    store: store,
                    processedData: {},
                    variables: (0, $jojW6.assign)({}, (0, $jojW6.getDefaultValues)(operationDefinition), variables),
                    dataIdFromObject: dataIdFromObject,
                    fragmentMap: (0, $jojW6.createFragmentMap)((0, $jojW6.getFragmentDefinitions)(document)),
                    fragmentMatcherFunction: fragmentMatcherFunction
                }
            });
        } catch (e) {
            throw $d7874048ca668ecb$export$fb86e3236e77e3(e, document);
        }
    };
    StoreWriter.prototype.writeSelectionSetToStore = function(_a) {
        var _this = this;
        var result = _a.result, dataId = _a.dataId, selectionSet = _a.selectionSet, context = _a.context;
        var variables = context.variables, store = context.store, fragmentMap = context.fragmentMap;
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $jojW6.shouldInclude)(selection, variables)) return;
            if ((0, $jojW6.isField)(selection)) {
                var resultFieldKey = (0, $jojW6.resultKeyNameFromField)(selection);
                var value = result[resultFieldKey];
                if (typeof value !== 'undefined') _this.writeFieldToStore({
                    dataId: dataId,
                    value: value,
                    field: selection,
                    context: context
                });
                else {
                    var isDefered = false;
                    var isClient = false;
                    if (selection.directives && selection.directives.length) {
                        isDefered = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'defer';
                        });
                        isClient = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'client';
                        });
                    }
                    !isDefered && !isClient && context.fragmentMatcherFunction;
                }
            } else {
                var fragment = void 0;
                if ((0, $jojW6.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = (fragmentMap || {})[selection.name.value];
                    (0, $1DiV8.invariant)(fragment, 3);
                }
                var matches = true;
                if (context.fragmentMatcherFunction && fragment.typeCondition) {
                    var id = dataId || 'self';
                    var idValue = (0, $jojW6.toIdValue)({
                        id: id,
                        typename: undefined
                    });
                    var fakeContext = {
                        store: new $d7874048ca668ecb$export$ee7258b8691956a3((_a = {}, _a[id] = result, _a)),
                        cacheRedirects: {}
                    };
                    var match = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
                    !(0, $jojW6.isProduction)() && match;
                    matches = !!match;
                }
                if (matches) _this.writeSelectionSetToStore({
                    result: result,
                    selectionSet: fragment.selectionSet,
                    dataId: dataId,
                    context: context
                });
            }
        });
        return store;
    };
    StoreWriter.prototype.writeFieldToStore = function(_a) {
        var _b;
        var field = _a.field, value = _a.value, dataId = _a.dataId, context = _a.context;
        var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store;
        var storeValue;
        var storeObject;
        var storeFieldName = (0, $jojW6.storeKeyNameFromField)(field, variables);
        if (!field.selectionSet || value === null) storeValue = value != null && typeof value === 'object' ? {
            type: 'json',
            json: value
        } : value;
        else if (Array.isArray(value)) {
            var generatedId = dataId + "." + storeFieldName;
            storeValue = this.processArrayValue(value, generatedId, field.selectionSet, context);
        } else {
            var valueDataId = dataId + "." + storeFieldName;
            var generated = true;
            if (!$d7874048ca668ecb$var$isGeneratedId(valueDataId)) valueDataId = '$' + valueDataId;
            if (dataIdFromObject) {
                var semanticId = dataIdFromObject(value);
                (0, $1DiV8.invariant)(!semanticId || !$d7874048ca668ecb$var$isGeneratedId(semanticId), 4);
                if (semanticId || typeof semanticId === 'number' && semanticId === 0) {
                    valueDataId = semanticId;
                    generated = false;
                }
            }
            if (!$d7874048ca668ecb$var$isDataProcessed(valueDataId, field, context.processedData)) this.writeSelectionSetToStore({
                dataId: valueDataId,
                result: value,
                selectionSet: field.selectionSet,
                context: context
            });
            var typename = value.__typename;
            storeValue = (0, $jojW6.toIdValue)({
                id: valueDataId,
                typename: typename
            }, generated);
            storeObject = store.get(dataId);
            var escapedId = storeObject && storeObject[storeFieldName];
            if (escapedId !== storeValue && (0, $jojW6.isIdValue)(escapedId)) {
                var hadTypename = escapedId.typename !== undefined;
                var hasTypename = typename !== undefined;
                var typenameChanged = hadTypename && hasTypename && escapedId.typename !== typename;
                (0, $1DiV8.invariant)(!generated || escapedId.generated || typenameChanged, 5);
                (0, $1DiV8.invariant)(!hadTypename || hasTypename, 6);
                if (escapedId.generated) {
                    if (typenameChanged) {
                        if (!generated) store.delete(escapedId.id);
                    } else $d7874048ca668ecb$var$mergeWithGenerated(escapedId.id, storeValue.id, store);
                }
            }
        }
        storeObject = store.get(dataId);
        if (!storeObject || !(0, $bqMzA.equal)(storeValue, storeObject[storeFieldName])) store.set(dataId, (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, storeObject), (_b = {}, _b[storeFieldName] = storeValue, _b)));
    };
    StoreWriter.prototype.processArrayValue = function(value, generatedId, selectionSet, context) {
        var _this = this;
        return value.map(function(item, index) {
            if (item === null) return null;
            var itemDataId = generatedId + "." + index;
            if (Array.isArray(item)) return _this.processArrayValue(item, itemDataId, selectionSet, context);
            var generated = true;
            if (context.dataIdFromObject) {
                var semanticId = context.dataIdFromObject(item);
                if (semanticId) {
                    itemDataId = semanticId;
                    generated = false;
                }
            }
            if (!$d7874048ca668ecb$var$isDataProcessed(itemDataId, selectionSet, context.processedData)) _this.writeSelectionSetToStore({
                dataId: itemDataId,
                result: item,
                selectionSet: selectionSet,
                context: context
            });
            return (0, $jojW6.toIdValue)({
                id: itemDataId,
                typename: item.__typename
            }, generated);
        });
    };
    return StoreWriter;
}();
function $d7874048ca668ecb$var$isGeneratedId(id) {
    return id[0] === '$';
}
function $d7874048ca668ecb$var$mergeWithGenerated(generatedKey, realKey, cache) {
    if (generatedKey === realKey) return false;
    var generated = cache.get(generatedKey);
    var real = cache.get(realKey);
    var madeChanges = false;
    Object.keys(generated).forEach(function(key) {
        var value = generated[key];
        var realValue = real[key];
        if ((0, $jojW6.isIdValue)(value) && $d7874048ca668ecb$var$isGeneratedId(value.id) && (0, $jojW6.isIdValue)(realValue) && !(0, $bqMzA.equal)(value, realValue) && $d7874048ca668ecb$var$mergeWithGenerated(value.id, realValue.id, cache)) madeChanges = true;
    });
    cache.delete(generatedKey);
    var newRealValue = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, generated), real);
    if ((0, $bqMzA.equal)(newRealValue, real)) return madeChanges;
    cache.set(realKey, newRealValue);
    return true;
}
function $d7874048ca668ecb$var$isDataProcessed(dataId, field, processedData) {
    if (!processedData) return false;
    if (processedData[dataId]) {
        if (processedData[dataId].indexOf(field) >= 0) return true;
        else processedData[dataId].push(field);
    } else processedData[dataId] = [
        field
    ];
    return false;
}
var $d7874048ca668ecb$var$defaultConfig = {
    fragmentMatcher: new $d7874048ca668ecb$export$5d3fcf53267091de(),
    dataIdFromObject: $d7874048ca668ecb$export$bd03c5a9c99d6bce,
    addTypename: true,
    resultCaching: true,
    freezeResults: false
};
function $d7874048ca668ecb$export$bd03c5a9c99d6bce(result) {
    if (result.__typename) {
        if (result.id !== undefined) return result.__typename + ":" + result.id;
        if (result._id !== undefined) return result.__typename + ":" + result._id;
    }
    return null;
}
var $d7874048ca668ecb$var$hasOwn$1 = Object.prototype.hasOwnProperty;
var $d7874048ca668ecb$var$OptimisticCacheLayer = function(_super) {
    (0, $3VFsf.__extends)(OptimisticCacheLayer, _super);
    function OptimisticCacheLayer(optimisticId, parent, transaction) {
        var _this = _super.call(this, Object.create(null)) || this;
        _this.optimisticId = optimisticId;
        _this.parent = parent;
        _this.transaction = transaction;
        return _this;
    }
    OptimisticCacheLayer.prototype.toObject = function() {
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.parent.toObject()), this.data);
    };
    OptimisticCacheLayer.prototype.get = function(dataId) {
        return $d7874048ca668ecb$var$hasOwn$1.call(this.data, dataId) ? this.data[dataId] : this.parent.get(dataId);
    };
    return OptimisticCacheLayer;
}($d7874048ca668ecb$export$ee7258b8691956a3);
var $d7874048ca668ecb$export$467265324939f47f = function(_super) {
    (0, $3VFsf.__extends)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.typenameDocumentCache = new Map();
        _this.cacheKeyRoot = new (0, $gLy2H.KeyTrie)((0, $jojW6.canUseWeakMap));
        _this.silenceBroadcast = false;
        _this.config = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, $d7874048ca668ecb$var$defaultConfig), config);
        if (_this.config.customResolvers) _this.config.cacheRedirects = _this.config.customResolvers;
        if (_this.config.cacheResolvers) _this.config.cacheRedirects = _this.config.cacheResolvers;
        _this.addTypename = !!_this.config.addTypename;
        _this.data = _this.config.resultCaching ? new $d7874048ca668ecb$var$DepTrackingCache() : new $d7874048ca668ecb$export$ee7258b8691956a3();
        _this.optimisticData = _this.data;
        _this.storeWriter = new $d7874048ca668ecb$export$eb8361c5d132fb8f();
        _this.storeReader = new $d7874048ca668ecb$export$628ef07ba8965f12({
            cacheKeyRoot: _this.cacheKeyRoot,
            freezeResults: config.freezeResults
        });
        var cache = _this;
        var maybeBroadcastWatch = cache.maybeBroadcastWatch;
        _this.maybeBroadcastWatch = (0, $gLy2H.wrap)(function(c) {
            return maybeBroadcastWatch.call(_this, c);
        }, {
            makeCacheKey: function(c) {
                if (c.optimistic) return;
                if (c.previousResult) return;
                if (cache.data instanceof $d7874048ca668ecb$var$DepTrackingCache) return cache.cacheKeyRoot.lookup(c.query, JSON.stringify(c.variables));
            }
        });
        return _this;
    }
    InMemoryCache.prototype.restore = function(data) {
        if (data) this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function(optimistic) {
        if (optimistic === void 0) optimistic = false;
        return (optimistic ? this.optimisticData : this.data).toObject();
    };
    InMemoryCache.prototype.read = function(options) {
        if (typeof options.rootId === 'string' && typeof this.data.get(options.rootId) === 'undefined') return null;
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.readQueryFromStore({
            store: options.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(options.query),
            variables: options.variables,
            rootId: options.rootId,
            fragmentMatcherFunction: fragmentMatcherFunction,
            previousResult: options.previousResult,
            config: this.config
        }) || null;
    };
    InMemoryCache.prototype.write = function(write) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        this.storeWriter.writeResultToStore({
            dataId: write.dataId,
            result: write.result,
            variables: write.variables,
            document: this.transformDocument(write.query),
            store: this.data,
            dataIdFromObject: this.config.dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
        this.broadcastWatches();
    };
    InMemoryCache.prototype.diff = function(query) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.diffQueryAgainstStore({
            store: query.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(query.query),
            variables: query.variables,
            returnPartialData: query.returnPartialData,
            previousResult: query.previousResult,
            fragmentMatcherFunction: fragmentMatcherFunction,
            config: this.config
        });
    };
    InMemoryCache.prototype.watch = function(watch) {
        var _this = this;
        this.watches.add(watch);
        return function() {
            _this.watches.delete(watch);
        };
    };
    InMemoryCache.prototype.evict = function(query) {
        throw new (0, $1DiV8.InvariantError)(7);
    };
    InMemoryCache.prototype.reset = function() {
        this.data.clear();
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
        var toReapply = [];
        var removedCount = 0;
        var layer = this.optimisticData;
        while(layer instanceof $d7874048ca668ecb$var$OptimisticCacheLayer){
            if (layer.optimisticId === idToRemove) ++removedCount;
            else toReapply.push(layer);
            layer = layer.parent;
        }
        if (removedCount > 0) {
            this.optimisticData = layer;
            while(toReapply.length > 0){
                var layer_1 = toReapply.pop();
                this.performTransaction(layer_1.transaction, layer_1.optimisticId);
            }
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.performTransaction = function(transaction, optimisticId) {
        var _a = this, data = _a.data, silenceBroadcast = _a.silenceBroadcast;
        this.silenceBroadcast = true;
        if (typeof optimisticId === 'string') this.data = this.optimisticData = new $d7874048ca668ecb$var$OptimisticCacheLayer(optimisticId, this.optimisticData, transaction);
        try {
            transaction(this);
        } finally{
            this.silenceBroadcast = silenceBroadcast;
            this.data = data;
        }
        this.broadcastWatches();
    };
    InMemoryCache.prototype.recordOptimisticTransaction = function(transaction, id) {
        return this.performTransaction(transaction, id);
    };
    InMemoryCache.prototype.transformDocument = function(document) {
        if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document);
            if (!result) {
                result = (0, $jojW6.addTypenameToDocument)(document);
                this.typenameDocumentCache.set(document, result);
                this.typenameDocumentCache.set(result, result);
            }
            return result;
        }
        return document;
    };
    InMemoryCache.prototype.broadcastWatches = function() {
        var _this = this;
        if (!this.silenceBroadcast) this.watches.forEach(function(c) {
            return _this.maybeBroadcastWatch(c);
        });
    };
    InMemoryCache.prototype.maybeBroadcastWatch = function(c) {
        c.callback(this.diff({
            query: c.query,
            variables: c.variables,
            previousResult: c.previousResult && c.previousResult(),
            optimistic: c.optimistic
        }));
    };
    return InMemoryCache;
}((0, $hzuXv.ApolloCache));

});
parcelRegister("hzuXv", function(module, exports) {

$parcel$export(module.exports, "ApolloCache", () => $ccadb856bf057658$export$5fc74f25506aa9c);

var $jojW6 = parcelRequire("jojW6");
function $ccadb856bf057658$var$queryFromPojo(obj) {
    var op = {
        kind: 'OperationDefinition',
        operation: 'query',
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $ccadb856bf057658$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            op
        ]
    };
    return out;
}
function $ccadb856bf057658$var$fragmentFromPojo(obj, typename) {
    var frag = {
        kind: 'FragmentDefinition',
        typeCondition: {
            kind: 'NamedType',
            name: {
                kind: 'Name',
                value: typename || '__FakeType'
            }
        },
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $ccadb856bf057658$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            frag
        ]
    };
    return out;
}
function $ccadb856bf057658$var$selectionSetFromObj(obj) {
    if (typeof obj === 'number' || typeof obj === 'boolean' || typeof obj === 'string' || typeof obj === 'undefined' || obj === null) return null;
    if (Array.isArray(obj)) return $ccadb856bf057658$var$selectionSetFromObj(obj[0]);
    var selections = [];
    Object.keys(obj).forEach(function(key) {
        var nestedSelSet = $ccadb856bf057658$var$selectionSetFromObj(obj[key]);
        var field = {
            kind: 'Field',
            name: {
                kind: 'Name',
                value: key
            },
            selectionSet: nestedSelSet || undefined
        };
        selections.push(field);
    });
    var selectionSet = {
        kind: 'SelectionSet',
        selections: selections
    };
    return selectionSet;
}
var $ccadb856bf057658$var$justTypenameQuery = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: null,
            variableDefinitions: null,
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: null,
                        name: {
                            kind: 'Name',
                            value: '__typename'
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: null
                    }
                ]
            }
        }
    ]
};
var $ccadb856bf057658$export$5fc74f25506aa9c = function() {
    function ApolloCache() {}
    ApolloCache.prototype.transformDocument = function(document) {
        return document;
    };
    ApolloCache.prototype.transformForLink = function(document) {
        return document;
    };
    ApolloCache.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: options.query,
            variables: options.variables,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: (0, $jojW6.getFragmentQueryDocument)(options.fragment, options.fragmentName),
            variables: options.variables,
            rootId: options.id,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.writeQuery = function(options) {
        this.write({
            dataId: 'ROOT_QUERY',
            result: options.data,
            query: options.query,
            variables: options.variables
        });
    };
    ApolloCache.prototype.writeFragment = function(options) {
        this.write({
            dataId: options.id,
            result: options.data,
            variables: options.variables,
            query: (0, $jojW6.getFragmentQueryDocument)(options.fragment, options.fragmentName)
        });
    };
    ApolloCache.prototype.writeData = function(_a) {
        var id = _a.id, data = _a.data;
        if (typeof id !== 'undefined') {
            var typenameResult = null;
            try {
                typenameResult = this.read({
                    rootId: id,
                    optimistic: false,
                    query: $ccadb856bf057658$var$justTypenameQuery
                });
            } catch (e) {}
            var __typename = typenameResult && typenameResult.__typename || '__ClientData';
            var dataToWrite = Object.assign({
                __typename: __typename
            }, data);
            this.writeFragment({
                id: id,
                fragment: $ccadb856bf057658$var$fragmentFromPojo(dataToWrite, __typename),
                data: dataToWrite
            });
        } else this.writeQuery({
            query: $ccadb856bf057658$var$queryFromPojo(data),
            data: data
        });
    };
    return ApolloCache;
}();
var $ccadb856bf057658$export$94affb487e701bf2;
$ccadb856bf057658$export$94affb487e701bf2 || ($ccadb856bf057658$export$94affb487e701bf2 = {});

});

parcelRegister("gLy2H", function(module, exports) {

$parcel$export(module.exports, "KeyTrie", () => $c34b71496108423e$export$6bd8d8299be3ac82);
$parcel$export(module.exports, "wrap", () => $c34b71496108423e$export$4997ffc0176396a6);

var $jFbNy = parcelRequire("jFbNy");
function $c34b71496108423e$var$defaultDispose() {}
var $c34b71496108423e$var$Cache = /** @class */ function() {
    function Cache(max, dispose) {
        if (max === void 0) max = Infinity;
        if (dispose === void 0) dispose = $c34b71496108423e$var$defaultDispose;
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    Cache.prototype.has = function(key) {
        return this.map.has(key);
    };
    Cache.prototype.get = function(key) {
        var entry = this.getEntry(key);
        return entry && entry.value;
    };
    Cache.prototype.getEntry = function(key) {
        var entry = this.map.get(key);
        if (entry && entry !== this.newest) {
            var older = entry.older, newer = entry.newer;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            entry.older = this.newest;
            entry.older.newer = entry;
            entry.newer = null;
            this.newest = entry;
            if (entry === this.oldest) this.oldest = newer;
        }
        return entry;
    };
    Cache.prototype.set = function(key, value) {
        var entry = this.getEntry(key);
        if (entry) return entry.value = value;
        entry = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = entry;
        this.newest = entry;
        this.oldest = this.oldest || entry;
        this.map.set(key, entry);
        return entry.value;
    };
    Cache.prototype.clean = function() {
        while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
    };
    Cache.prototype.delete = function(key) {
        var entry = this.map.get(key);
        if (entry) {
            if (entry === this.newest) this.newest = entry.older;
            if (entry === this.oldest) this.oldest = entry.newer;
            if (entry.newer) entry.newer.older = entry.older;
            if (entry.older) entry.older.newer = entry.newer;
            this.map.delete(key);
            this.dispose(entry.value, key);
            return true;
        }
        return false;
    };
    return Cache;
}();
var $c34b71496108423e$var$parentEntrySlot = new (0, $jFbNy.Slot)();
var $c34b71496108423e$var$reusableEmptyArray = [];
var $c34b71496108423e$var$emptySetPool = [];
var $c34b71496108423e$var$POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function $c34b71496108423e$var$assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function $c34b71496108423e$var$valueIs(a, b) {
    var len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function $c34b71496108423e$var$valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function $c34b71496108423e$var$valueCopy(value) {
    return value.slice(0);
}
var $c34b71496108423e$var$Entry = /** @class */ function() {
    function Entry(fn, args) {
        this.fn = fn;
        this.args = args;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        ++Entry.count;
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    Entry.prototype.recompute = function() {
        $c34b71496108423e$var$assert(!this.recomputing, "already recomputing");
        if (!$c34b71496108423e$var$rememberParent(this) && $c34b71496108423e$var$maybeReportOrphan(this)) // The recipient of the entry.reportOrphan callback decided to dispose
        // of this orphan entry by calling entry.dispose(), so we don't need to
        // (and should not) proceed with the recomputation.
        return void 0;
        return $c34b71496108423e$var$mightBeDirty(this) ? $c34b71496108423e$var$reallyRecompute(this) : $c34b71496108423e$var$valueGet(this.value);
    };
    Entry.prototype.setDirty = function() {
        if (this.dirty) return;
        this.dirty = true;
        this.value.length = 0;
        $c34b71496108423e$var$reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        $c34b71496108423e$var$maybeUnsubscribe(this);
    };
    Entry.prototype.dispose = function() {
        var _this = this;
        $c34b71496108423e$var$forgetChildren(this).forEach($c34b71496108423e$var$maybeReportOrphan);
        $c34b71496108423e$var$maybeUnsubscribe(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        this.parents.forEach(function(parent) {
            parent.setDirty();
            $c34b71496108423e$var$forgetChild(parent, _this);
        });
    };
    Entry.count = 0;
    return Entry;
}();
function $c34b71496108423e$var$rememberParent(child) {
    var parent = $c34b71496108423e$var$parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if ($c34b71496108423e$var$mightBeDirty(child)) $c34b71496108423e$var$reportDirtyChild(parent, child);
        else $c34b71496108423e$var$reportCleanChild(parent, child);
        return parent;
    }
}
function $c34b71496108423e$var$reallyRecompute(entry) {
    // Since this recomputation is likely to re-remember some of this
    // entry's children, we forget our children here but do not call
    // maybeReportOrphan until after the recomputation finishes.
    var originalChildren = $c34b71496108423e$var$forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    $c34b71496108423e$var$parentEntrySlot.withValue(entry, $c34b71496108423e$var$recomputeNewValue, [
        entry
    ]);
    if ($c34b71496108423e$var$maybeSubscribe(entry)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    $c34b71496108423e$var$setClean(entry);
    // Now that we've had a chance to re-remember any children that were
    // involved in the recomputation, we can safely report any orphan
    // children that remain.
    originalChildren.forEach($c34b71496108423e$var$maybeReportOrphan);
    return $c34b71496108423e$var$valueGet(entry.value);
}
function $c34b71496108423e$var$recomputeNewValue(entry) {
    entry.recomputing = true;
    // Set entry.value as unknown.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, entry.args);
    } catch (e) {
        // If entry.fn throws, entry.value will become exceptional.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function $c34b71496108423e$var$mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function $c34b71496108423e$var$setClean(entry) {
    entry.dirty = false;
    if ($c34b71496108423e$var$mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    $c34b71496108423e$var$reportClean(entry);
}
function $c34b71496108423e$var$reportDirty(child) {
    child.parents.forEach(function(parent) {
        return $c34b71496108423e$var$reportDirtyChild(parent, child);
    });
}
function $c34b71496108423e$var$reportClean(child) {
    child.parents.forEach(function(parent) {
        return $c34b71496108423e$var$reportCleanChild(parent, child);
    });
}
// Let a parent Entry know that one of its children may be dirty.
function $c34b71496108423e$var$reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    $c34b71496108423e$var$assert(parent.childValues.has(child));
    $c34b71496108423e$var$assert($c34b71496108423e$var$mightBeDirty(child));
    if (!parent.dirtyChildren) parent.dirtyChildren = $c34b71496108423e$var$emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    $c34b71496108423e$var$reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function $c34b71496108423e$var$reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    $c34b71496108423e$var$assert(parent.childValues.has(child));
    $c34b71496108423e$var$assert(!$c34b71496108423e$var$mightBeDirty(child));
    var childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, $c34b71496108423e$var$valueCopy(child.value));
    else if (!$c34b71496108423e$var$valueIs(childValue, child.value)) parent.setDirty();
    $c34b71496108423e$var$removeDirtyChild(parent, child);
    if ($c34b71496108423e$var$mightBeDirty(parent)) return;
    $c34b71496108423e$var$reportClean(parent);
}
function $c34b71496108423e$var$removeDirtyChild(parent, child) {
    var dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if ($c34b71496108423e$var$emptySetPool.length < $c34b71496108423e$var$POOL_TARGET_SIZE) $c34b71496108423e$var$emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// If the given entry has a reportOrphan method, and no remaining parents,
// call entry.reportOrphan and return true iff it returns true. The
// reportOrphan function should return true to indicate entry.dispose()
// has been called, and the entry has been removed from any other caches
// (see index.js for the only current example).
function $c34b71496108423e$var$maybeReportOrphan(entry) {
    return entry.parents.size === 0 && typeof entry.reportOrphan === "function" && entry.reportOrphan() === true;
}
// Removes all children from this entry and returns an array of the
// removed children.
function $c34b71496108423e$var$forgetChildren(parent) {
    var children = $c34b71496108423e$var$reusableEmptyArray;
    if (parent.childValues.size > 0) {
        children = [];
        parent.childValues.forEach(function(_value, child) {
            $c34b71496108423e$var$forgetChild(parent, child);
            children.push(child);
        });
    }
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    $c34b71496108423e$var$assert(parent.dirtyChildren === null);
    return children;
}
function $c34b71496108423e$var$forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    $c34b71496108423e$var$removeDirtyChild(parent, child);
}
function $c34b71496108423e$var$maybeSubscribe(entry) {
    if (typeof entry.subscribe === "function") try {
        $c34b71496108423e$var$maybeUnsubscribe(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, entry.args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}
function $c34b71496108423e$var$maybeUnsubscribe(entry) {
    var unsubscribe = entry.unsubscribe;
    if (typeof unsubscribe === "function") {
        entry.unsubscribe = void 0;
        unsubscribe();
    }
}
// A trie data structure that holds object keys weakly, yet can also hold
// non-object keys, unlike the native `WeakMap`.
var $c34b71496108423e$export$6bd8d8299be3ac82 = /** @class */ function() {
    function KeyTrie(weakness) {
        this.weakness = weakness;
    }
    KeyTrie.prototype.lookup = function() {
        var array = [];
        for(var _i = 0; _i < arguments.length; _i++)array[_i] = arguments[_i];
        return this.lookupArray(array);
    };
    KeyTrie.prototype.lookupArray = function(array) {
        var node = this;
        array.forEach(function(key) {
            return node = node.getChildTrie(key);
        });
        return node.data || (node.data = Object.create(null));
    };
    KeyTrie.prototype.getChildTrie = function(key) {
        var map = this.weakness && $c34b71496108423e$var$isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
        var child = map.get(key);
        if (!child) map.set(key, child = new KeyTrie(this.weakness));
        return child;
    };
    return KeyTrie;
}();
function $c34b71496108423e$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}
// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
var $c34b71496108423e$var$keyTrie = new $c34b71496108423e$export$6bd8d8299be3ac82(typeof WeakMap === "function");
function $c34b71496108423e$export$cd3144f8dd136006() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return $c34b71496108423e$var$keyTrie.lookupArray(args);
}
var $c34b71496108423e$var$caches = new Set();
function $c34b71496108423e$export$4997ffc0176396a6(originalFunction, options) {
    if (options === void 0) options = Object.create(null);
    var cache = new $c34b71496108423e$var$Cache(options.max || Math.pow(2, 16), function(entry) {
        return entry.dispose();
    });
    var disposable = !!options.disposable;
    var makeCacheKey = options.makeCacheKey || $c34b71496108423e$export$cd3144f8dd136006;
    function optimistic() {
        if (disposable && !$c34b71496108423e$var$parentEntrySlot.hasValue()) // If there's no current parent computation, and this wrapped
        // function is disposable (meaning we don't care about entry.value,
        // just dependency tracking), then we can short-cut everything else
        // in this function, because entry.recompute() is going to recycle
        // the entry object without recomputing anything, anyway.
        return void 0;
        var key = makeCacheKey.apply(null, arguments);
        if (key === void 0) return originalFunction.apply(null, arguments);
        var args = Array.prototype.slice.call(arguments);
        var entry = cache.get(key);
        if (entry) entry.args = args;
        else {
            entry = new $c34b71496108423e$var$Entry(originalFunction, args);
            cache.set(key, entry);
            entry.subscribe = options.subscribe;
            if (disposable) entry.reportOrphan = function() {
                return cache.delete(key);
            };
        }
        var value = entry.recompute();
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        $c34b71496108423e$var$caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!$c34b71496108423e$var$parentEntrySlot.hasValue()) {
            $c34b71496108423e$var$caches.forEach(function(cache) {
                return cache.clean();
            });
            $c34b71496108423e$var$caches.clear();
        }
        // If options.disposable is truthy, the caller of wrap is telling us
        // they don't care about the result of entry.recompute(), so we should
        // avoid returning the value, so it won't be accidentally used.
        return disposable ? void 0 : value;
    }
    optimistic.dirty = function() {
        var key = makeCacheKey.apply(null, arguments);
        var child = key !== void 0 && cache.get(key);
        if (child) child.setDirty();
    };
    return optimistic;
}

});
parcelRegister("jFbNy", function(module, exports) {

$parcel$export(module.exports, "Slot", () => $e50aff8f879ebe36$export$8c6ed5c666ac1360);
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
var $e50aff8f879ebe36$var$currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
var $e50aff8f879ebe36$var$MISSING_VALUE = {};
var $e50aff8f879ebe36$var$idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
var $e50aff8f879ebe36$var$makeSlotClass = function() {
    return /** @class */ function() {
        function Slot() {
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                $e50aff8f879ebe36$var$idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
        Slot.prototype.hasValue = function() {
            for(var context_1 = $e50aff8f879ebe36$var$currentContext; context_1; context_1 = context_1.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context_1.slots) {
                var value = context_1.slots[this.id];
                if (value === $e50aff8f879ebe36$var$MISSING_VALUE) break;
                if (context_1 !== $e50aff8f879ebe36$var$currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                $e50aff8f879ebe36$var$currentContext.slots[this.id] = value;
                return true;
            }
            if ($e50aff8f879ebe36$var$currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            $e50aff8f879ebe36$var$currentContext.slots[this.id] = $e50aff8f879ebe36$var$MISSING_VALUE;
            return false;
        };
        Slot.prototype.getValue = function() {
            if (this.hasValue()) return $e50aff8f879ebe36$var$currentContext.slots[this.id];
        };
        Slot.prototype.withValue = function(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            var _a;
            var slots = (_a = {
                __proto__: null
            }, _a[this.id] = value, _a);
            var parent = $e50aff8f879ebe36$var$currentContext;
            $e50aff8f879ebe36$var$currentContext = {
                parent: parent,
                slots: slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                $e50aff8f879ebe36$var$currentContext = parent;
            }
        };
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        Slot.bind = function(callback) {
            var context = $e50aff8f879ebe36$var$currentContext;
            return function() {
                var saved = $e50aff8f879ebe36$var$currentContext;
                try {
                    $e50aff8f879ebe36$var$currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    $e50aff8f879ebe36$var$currentContext = saved;
                }
            };
        };
        // Immediately run a callback function without any captured context.
        Slot.noContext = function(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if ($e50aff8f879ebe36$var$currentContext) {
                var saved = $e50aff8f879ebe36$var$currentContext;
                try {
                    $e50aff8f879ebe36$var$currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    $e50aff8f879ebe36$var$currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        };
        return Slot;
    }();
};
// We store a single global implementation of the Slot class as a permanent
// non-enumerable symbol property of the Array constructor. This obfuscation
// does nothing to prevent access to the Slot class, but at least it ensures
// the implementation (i.e. currentContext) cannot be tampered with, and all
// copies of the @wry/context package (hopefully just one) will share the
// same Slot implementation. Since the first copy of the @wry/context package
// to be imported wins, this technique imposes a very high cost for any
// future breaking changes to the Slot class.
var $e50aff8f879ebe36$var$globalKey = "@wry/context:Slot";
var $e50aff8f879ebe36$var$host = Array;
var $e50aff8f879ebe36$export$8c6ed5c666ac1360 = $e50aff8f879ebe36$var$host[$e50aff8f879ebe36$var$globalKey] || function() {
    var Slot = $e50aff8f879ebe36$var$makeSlotClass();
    try {
        Object.defineProperty($e50aff8f879ebe36$var$host, $e50aff8f879ebe36$var$globalKey, {
            value: $e50aff8f879ebe36$var$host[$e50aff8f879ebe36$var$globalKey] = Slot,
            enumerable: false,
            writable: false,
            configurable: false
        });
    } finally{
        return Slot;
    }
}();
var $e50aff8f879ebe36$export$2385a24977818dd0 = $e50aff8f879ebe36$export$8c6ed5c666ac1360.bind, $e50aff8f879ebe36$export$9fa6f2e300a97f8 = $e50aff8f879ebe36$export$8c6ed5c666ac1360.noContext;
function $e50aff8f879ebe36$export$831dc9f2ab0a617b(callback, delay) {
    return setTimeout($e50aff8f879ebe36$export$2385a24977818dd0(callback), delay);
}
// Turn any generator function into an async function (using yield instead
// of await), with context automatically preserved across yields.
function $e50aff8f879ebe36$export$d5d7536e965c82da(genFn) {
    return function() {
        var gen = genFn.apply(this, arguments);
        var boundNext = $e50aff8f879ebe36$export$2385a24977818dd0(gen.next);
        var boundThrow = $e50aff8f879ebe36$export$2385a24977818dd0(gen.throw);
        return new Promise(function(resolve, reject) {
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                var next = result.done ? resolve : invokeNext;
                if ($e50aff8f879ebe36$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            var invokeNext = function(value) {
                return invoke(boundNext, value);
            };
            var invokeThrow = function(error) {
                return invoke(boundThrow, error);
            };
            invokeNext();
        });
    };
}
function $e50aff8f879ebe36$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
var $e50aff8f879ebe36$var$wrappedFibers = [];
function $e50aff8f879ebe36$export$14794f6e0a4dc6a0(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if ($e50aff8f879ebe36$var$wrappedFibers.indexOf(Fiber) < 0) {
        var wrap = function(obj, method) {
            var fn = obj[method];
            obj[method] = function() {
                return $e50aff8f879ebe36$export$9fa6f2e300a97f8(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        $e50aff8f879ebe36$var$wrappedFibers.push(Fiber);
    }
    return Fiber;
}

});



parcelRegister("h4ppL", function(module, exports) {

$parcel$export(module.exports, "onError", () => $c6d6862dd229df53$export$2288787135a8f66e);

var $3VFsf = parcelRequire("3VFsf");

var $clSzL = parcelRequire("clSzL");
function $c6d6862dd229df53$export$2288787135a8f66e(errorHandler) {
    return new (0, $clSzL.ApolloLink)(function(operation, forward) {
        return new (0, $clSzL.Observable)(function(observer) {
            var sub;
            var retriedSub;
            var retriedResult;
            try {
                sub = forward(operation).subscribe({
                    next: function(result) {
                        if (result.errors) {
                            retriedResult = errorHandler({
                                graphQLErrors: result.errors,
                                response: result,
                                operation: operation,
                                forward: forward
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer)
                                });
                                return;
                            }
                        }
                        observer.next(result);
                    },
                    error: function(networkError) {
                        retriedResult = errorHandler({
                            operation: operation,
                            networkError: networkError,
                            graphQLErrors: networkError && networkError.result && networkError.result.errors,
                            forward: forward
                        });
                        if (retriedResult) {
                            retriedSub = retriedResult.subscribe({
                                next: observer.next.bind(observer),
                                error: observer.error.bind(observer),
                                complete: observer.complete.bind(observer)
                            });
                            return;
                        }
                        observer.error(networkError);
                    },
                    complete: function() {
                        if (!retriedResult) observer.complete.bind(observer)();
                    }
                });
            } catch (e) {
                errorHandler({
                    networkError: e,
                    operation: operation,
                    forward: forward
                });
                observer.error(e);
            }
            return function() {
                if (sub) sub.unsubscribe();
                if (retriedSub) sub.unsubscribe();
            };
        });
    });
}
var $c6d6862dd229df53$export$d2c8415987899609 = function(_super) {
    (0, $3VFsf.__extends)(ErrorLink, _super);
    function ErrorLink(errorHandler) {
        var _this = _super.call(this) || this;
        _this.link = $c6d6862dd229df53$export$2288787135a8f66e(errorHandler);
        return _this;
    }
    ErrorLink.prototype.request = function(operation, forward) {
        return this.link.request(operation, forward);
    };
    return ErrorLink;
}((0, $clSzL.ApolloLink));

});

parcelRegister("JPsIz", function(module, exports) {

$parcel$export(module.exports, "HttpLink", () => $089c1f6736cf7295$export$f4bbf1aec241cc1);

var $3VFsf = parcelRequire("3VFsf");

var $clSzL = parcelRequire("clSzL");

var $f0Elb = parcelRequire("f0Elb");
var $089c1f6736cf7295$export$95180a16573d6675 = function(linkOptions) {
    if (linkOptions === void 0) linkOptions = {};
    var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, abortErrorDoesNotCauseError = linkOptions.abortErrorDoesNotCauseError, requestOptions = (0, $3VFsf.__rest)(linkOptions, [
        "uri",
        "fetch",
        "includeExtensions",
        "useGETForQueries",
        "abortErrorDoesNotCauseError"
    ]);
    (0, $f0Elb.checkFetcher)(fetcher);
    if (!fetcher) fetcher = fetch;
    var linkConfig = {
        http: {
            includeExtensions: includeExtensions
        },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers
    };
    return new (0, $clSzL.ApolloLink)(function(operation) {
        var chosenURI = (0, $f0Elb.selectURI)(operation, uri);
        var context = operation.getContext();
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) clientAwarenessHeaders['apollographql-client-name'] = name_1;
            if (version) clientAwarenessHeaders['apollographql-client-version'] = version;
        }
        var contextHeaders = (0, $3VFsf.__assign)({}, clientAwarenessHeaders, context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders
        };
        var _b = (0, $f0Elb.selectHttpOptionsAndBody)(operation, (0, $f0Elb.fallbackHttpConfig), linkConfig, contextConfig), options = _b.options, body = _b.body;
        var controller;
        if (!options.signal) {
            var _c = (0, $f0Elb.createSignalIfSupported)(), _controller = _c.controller, signal = _c.signal;
            controller = _controller;
            if (controller) options.signal = signal;
        }
        var definitionIsMutation = function(d) {
            return d.kind === 'OperationDefinition' && d.operation === 'mutation';
        };
        if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = 'GET';
        if (options.method === 'GET') {
            var _d = $089c1f6736cf7295$var$rewriteURIForGET(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
            if (parseError) return (0, $clSzL.fromError)(parseError);
            chosenURI = newURI;
        } else try {
            options.body = (0, $f0Elb.serializeFetchParameter)(body, 'Payload');
        } catch (parseError) {
            return (0, $clSzL.fromError)(parseError);
        }
        return new (0, $clSzL.Observable)(function(observer) {
            fetcher(chosenURI, options).then(function(response) {
                operation.setContext({
                    response: response
                });
                return response;
            }).then((0, $f0Elb.parseAndCheckHttpResponse)(operation)).then(function(result) {
                observer.next(result);
                observer.complete();
                return result;
            }).catch(function(err) {
                if (err.name === 'AbortError' && !abortErrorDoesNotCauseError) return;
                if (err.result && err.result.errors && err.result.data) observer.next(err.result);
                observer.error(err);
            });
            return function() {
                if (controller) controller.abort();
            };
        });
    });
};
function $089c1f6736cf7295$var$rewriteURIForGET(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function(key, value) {
        queryParams.push(key + "=" + encodeURIComponent(value));
    };
    if ('query' in body) addQueryParam('query', body.query);
    if (body.operationName) addQueryParam('operationName', body.operationName);
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0, $f0Elb.serializeFetchParameter)(body.variables, 'Variables map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('variables', serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0, $f0Elb.serializeFetchParameter)(body.extensions, 'Extensions map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('extensions', serializedExtensions);
    }
    var fragment = '', preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf('#');
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
    var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
    return {
        newURI: newURI
    };
}
var $089c1f6736cf7295$export$f4bbf1aec241cc1 = function(_super) {
    (0, $3VFsf.__extends)(HttpLink, _super);
    function HttpLink(opts) {
        return _super.call(this, $089c1f6736cf7295$export$95180a16573d6675(opts).request) || this;
    }
    return HttpLink;
}((0, $clSzL.ApolloLink));

});
parcelRegister("f0Elb", function(module, exports) {

$parcel$export(module.exports, "fallbackHttpConfig", () => $aed625edf13c57eb$export$dd86f00dc866e75d);
$parcel$export(module.exports, "parseAndCheckHttpResponse", () => $aed625edf13c57eb$export$d4051215bea0639f);
$parcel$export(module.exports, "checkFetcher", () => $aed625edf13c57eb$export$8423f0cd3773115e);
$parcel$export(module.exports, "createSignalIfSupported", () => $aed625edf13c57eb$export$f5853cd1fc39aea6);
$parcel$export(module.exports, "selectHttpOptionsAndBody", () => $aed625edf13c57eb$export$a00ebfd5f1eebfb1);
$parcel$export(module.exports, "serializeFetchParameter", () => $aed625edf13c57eb$export$5f8e80ac52052e28);
$parcel$export(module.exports, "selectURI", () => $aed625edf13c57eb$export$63ccc2571850f81a);

var $3VFsf = parcelRequire("3VFsf");

var $1c8Um = parcelRequire("1c8Um");

var $1DiV8 = parcelRequire("1DiV8");
var $aed625edf13c57eb$var$defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false
};
var $aed625edf13c57eb$var$defaultHeaders = {
    accept: '*/*',
    'content-type': 'application/json'
};
var $aed625edf13c57eb$var$defaultOptions = {
    method: 'POST'
};
var $aed625edf13c57eb$export$dd86f00dc866e75d = {
    http: $aed625edf13c57eb$var$defaultHttpOptions,
    headers: $aed625edf13c57eb$var$defaultHeaders,
    options: $aed625edf13c57eb$var$defaultOptions
};
var $aed625edf13c57eb$export$c33ef9219f27efd7 = function(response, result, message) {
    var error = new Error(message);
    error.name = 'ServerError';
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
var $aed625edf13c57eb$export$d4051215bea0639f = function(operations) {
    return function(response) {
        return response.text().then(function(bodyText) {
            try {
                return JSON.parse(bodyText);
            } catch (err) {
                var parseError = err;
                parseError.name = 'ServerParseError';
                parseError.response = response;
                parseError.statusCode = response.status;
                parseError.bodyText = bodyText;
                return Promise.reject(parseError);
            }
        }).then(function(result) {
            if (response.status >= 300) $aed625edf13c57eb$export$c33ef9219f27efd7(response, result, "Response not successful: Received status code " + response.status);
            if (!Array.isArray(result) && !result.hasOwnProperty('data') && !result.hasOwnProperty('errors')) $aed625edf13c57eb$export$c33ef9219f27efd7(response, result, "Server response was missing for query '" + (Array.isArray(operations) ? operations.map(function(op) {
                return op.operationName;
            }) : operations.operationName) + "'.");
            return result;
        });
    };
};
var $aed625edf13c57eb$export$8423f0cd3773115e = function(fetcher) {
    if (!fetcher && typeof fetch === 'undefined') {
        var library = 'unfetch';
        if (typeof window === 'undefined') library = 'node-fetch';
        throw new (0, $1DiV8.InvariantError)(1);
    }
};
var $aed625edf13c57eb$export$f5853cd1fc39aea6 = function() {
    if (typeof AbortController === 'undefined') return {
        controller: false,
        signal: false
    };
    var controller = new AbortController();
    var signal = controller.signal;
    return {
        controller: controller,
        signal: signal
    };
};
var $aed625edf13c57eb$export$a00ebfd5f1eebfb1 = function(operation, fallbackConfig) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    var options = (0, $3VFsf.__assign)({}, fallbackConfig.options, {
        headers: fallbackConfig.headers,
        credentials: fallbackConfig.credentials
    });
    var http = fallbackConfig.http;
    configs.forEach(function(config) {
        options = (0, $3VFsf.__assign)({}, options, config.options, {
            headers: (0, $3VFsf.__assign)({}, options.headers, config.headers)
        });
        if (config.credentials) options.credentials = config.credentials;
        http = (0, $3VFsf.__assign)({}, http, config.http);
    });
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = {
        operationName: operationName,
        variables: variables
    };
    if (http.includeExtensions) body.extensions = extensions;
    if (http.includeQuery) body.query = (0, $1c8Um.print)(query);
    return {
        options: options,
        body: body
    };
};
var $aed625edf13c57eb$export$5f8e80ac52052e28 = function(p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    } catch (e) {
        var parseError = new (0, $1DiV8.InvariantError)(2);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};
var $aed625edf13c57eb$export$63ccc2571850f81a = function(operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) return contextURI;
    else if (typeof fallbackURI === 'function') return fallbackURI(operation);
    else return fallbackURI || '/graphql';
};

});


parcelRegister("lC4FX", function(module, exports) {

$parcel$export(module.exports, "RetryLink", () => $fbc0c610016bf5c5$export$943d544ad120494a);

var $3VFsf = parcelRequire("3VFsf");

var $clSzL = parcelRequire("clSzL");
function $fbc0c610016bf5c5$var$buildDelayFunction(delayOptions) {
    var _a = delayOptions || {}, _b = _a.initial, initial = _b === void 0 ? 300 : _b, _c = _a.jitter, jitter = _c === void 0 ? true : _c, _d = _a.max, max = _d === void 0 ? Infinity : _d;
    var baseDelay = jitter ? initial : initial / 2;
    return function delayFunction(count) {
        var delay = Math.min(max, baseDelay * Math.pow(2, count));
        if (jitter) delay = Math.random() * delay;
        return delay;
    };
}
function $fbc0c610016bf5c5$var$buildRetryFunction(retryOptions) {
    var _a = retryOptions || {}, retryIf = _a.retryIf, _b = _a.max, max = _b === void 0 ? 5 : _b;
    return function retryFunction(count, operation, error) {
        if (count >= max) return false;
        return retryIf ? retryIf(error, operation) : !!error;
    };
}
var $fbc0c610016bf5c5$var$RetryableOperation = function() {
    function RetryableOperation(operation, nextLink, delayFor, retryIf) {
        var _this = this;
        this.operation = operation;
        this.nextLink = nextLink;
        this.delayFor = delayFor;
        this.retryIf = retryIf;
        this.retryCount = 0;
        this.values = [];
        this.complete = false;
        this.canceled = false;
        this.observers = [];
        this.currentSubscription = null;
        this.onNext = function(value) {
            _this.values.push(value);
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.next(value);
            }
        };
        this.onComplete = function() {
            _this.complete = true;
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.complete();
            }
        };
        this.onError = function(error) {
            return (0, $3VFsf.__awaiter)(_this, void 0, void 0, function() {
                var shouldRetry, _i, _a, observer;
                return (0, $3VFsf.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            this.retryCount += 1;
                            return [
                                4,
                                this.retryIf(this.retryCount, this.operation, error)
                            ];
                        case 1:
                            shouldRetry = _b.sent();
                            if (shouldRetry) {
                                this.scheduleRetry(this.delayFor(this.retryCount, this.operation, error));
                                return [
                                    2
                                ];
                            }
                            this.error = error;
                            for(_i = 0, _a = this.observers; _i < _a.length; _i++){
                                observer = _a[_i];
                                if (!observer) continue;
                                observer.error(error);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
        };
    }
    RetryableOperation.prototype.subscribe = function(observer) {
        if (this.canceled) throw new Error("Subscribing to a retryable link that was canceled is not supported");
        this.observers.push(observer);
        for(var _i = 0, _a = this.values; _i < _a.length; _i++){
            var value = _a[_i];
            observer.next(value);
        }
        if (this.complete) observer.complete();
        else if (this.error) observer.error(this.error);
    };
    RetryableOperation.prototype.unsubscribe = function(observer) {
        var index = this.observers.indexOf(observer);
        if (index < 0) throw new Error("RetryLink BUG! Attempting to unsubscribe unknown observer!");
        this.observers[index] = null;
        if (this.observers.every(function(o) {
            return o === null;
        })) this.cancel();
    };
    RetryableOperation.prototype.start = function() {
        if (this.currentSubscription) return;
        this.try();
    };
    RetryableOperation.prototype.cancel = function() {
        if (this.currentSubscription) this.currentSubscription.unsubscribe();
        clearTimeout(this.timerId);
        this.timerId = null;
        this.currentSubscription = null;
        this.canceled = true;
    };
    RetryableOperation.prototype.try = function() {
        this.currentSubscription = this.nextLink(this.operation).subscribe({
            next: this.onNext,
            error: this.onError,
            complete: this.onComplete
        });
    };
    RetryableOperation.prototype.scheduleRetry = function(delay) {
        var _this = this;
        if (this.timerId) throw new Error("RetryLink BUG! Encountered overlapping retries");
        this.timerId = setTimeout(function() {
            _this.timerId = null;
            _this.try();
        }, delay);
    };
    return RetryableOperation;
}();
var $fbc0c610016bf5c5$export$943d544ad120494a = function(_super) {
    (0, $3VFsf.__extends)(RetryLink, _super);
    function RetryLink(options) {
        var _this = _super.call(this) || this;
        var _a = options || {}, attempts = _a.attempts, delay = _a.delay;
        _this.delayFor = typeof delay === 'function' ? delay : $fbc0c610016bf5c5$var$buildDelayFunction(delay);
        _this.retryIf = typeof attempts === 'function' ? attempts : $fbc0c610016bf5c5$var$buildRetryFunction(attempts);
        return _this;
    }
    RetryLink.prototype.request = function(operation, nextLink) {
        var retryable = new $fbc0c610016bf5c5$var$RetryableOperation(operation, nextLink, this.delayFor, this.retryIf);
        retryable.start();
        return new (0, $clSzL.Observable)(function(observer) {
            retryable.subscribe(observer);
            return function() {
                retryable.unsubscribe(observer);
            };
        });
    };
    return RetryLink;
}((0, $clSzL.ApolloLink));

});

parcelRegister("cuKXc", function(module, exports) {

$parcel$export(module.exports, "fragmentCacheRedirect", () => $918cb5692ff82562$export$5133c88128301697);
$parcel$export(module.exports, "fragmentLinkState", () => $918cb5692ff82562$export$3f9ecfb4d42ab23d);

var $jojW6 = parcelRequire("jojW6");

var $9HlP2 = parcelRequire("9HlP2");

var $ivfDv = parcelRequire("ivfDv");
function $918cb5692ff82562$export$5133c88128301697(dataIdFromObject) {
    if (dataIdFromObject === void 0) dataIdFromObject = (0, $ivfDv.defaultDataIdFromObject);
    return {
        getFragment: function(_, _a) {
            var id = _a.id, __typename = _a.__typename;
            return (0, $jojW6.toIdValue)(dataIdFromObject({
                __typename: __typename,
                id: id
            }));
        }
    };
}
function $918cb5692ff82562$export$3f9ecfb4d42ab23d(apolloCache) {
    return (0, $9HlP2.withClientState)({
        cache: apolloCache,
        resolvers: {
            Query: {
                getFragment: function(_, _a, _b) {
                    var __typename = _a.__typename, id = _a.id;
                    var cache = _b.cache;
                    var fragmentId = cache.config.dataIdFromObject({
                        __typename: __typename,
                        id: id
                    });
                    return cache.data.data[fragmentId];
                }
            }
        }
    });
}

});
parcelRegister("9HlP2", function(module, exports) {

$parcel$export(module.exports, "withClientState", () => $70f90ea50d538958$export$a13f755900e15d9e);

var $clSzL = parcelRequire("clSzL");

var $jojW6 = parcelRequire("jojW6");

var $jWd7i = parcelRequire("jWd7i");

var $b2p88 = parcelRequire("b2p88");
var $70f90ea50d538958$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $70f90ea50d538958$var$graphql = $jWd7i.graphql;
var $70f90ea50d538958$var$capitalizeFirstLetter = function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
var $70f90ea50d538958$export$a13f755900e15d9e = function(clientStateConfig) {
    if (clientStateConfig === void 0) clientStateConfig = {
        resolvers: {},
        defaults: {}
    };
    var defaults = clientStateConfig.defaults, cache = clientStateConfig.cache, typeDefs = clientStateConfig.typeDefs, fragmentMatcher = clientStateConfig.fragmentMatcher;
    if (cache && defaults) cache.writeData({
        data: defaults
    });
    return new (function(_super) {
        $70f90ea50d538958$var$__extends(StateLink, _super);
        function StateLink() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        StateLink.prototype.writeDefaults = function() {
            if (cache && defaults) cache.writeData({
                data: defaults
            });
        };
        StateLink.prototype.request = function(operation, forward) {
            if (forward === void 0) forward = function() {
                return (0, $clSzL.Observable).of({
                    data: {}
                });
            };
            if (typeDefs) {
                var directives_1 = 'directive @client on FIELD';
                var definition_1 = (0, $b2p88.normalizeTypeDefs)(typeDefs);
                operation.setContext(function(_a) {
                    var _b = _a.schemas, schemas = _b === void 0 ? [] : _b;
                    return {
                        schemas: schemas.concat([
                            {
                                definition: definition_1,
                                directives: directives_1
                            }
                        ])
                    };
                });
            }
            var isClient = (0, $jojW6.hasDirectives)([
                'client'
            ], operation.query);
            if (!isClient) return forward(operation);
            var resolvers = typeof clientStateConfig.resolvers === 'function' ? clientStateConfig.resolvers() : clientStateConfig.resolvers;
            var server = (0, $b2p88.removeClientSetsFromDocument)(operation.query);
            var query = operation.query;
            var type = $70f90ea50d538958$var$capitalizeFirstLetter(((0, $jojW6.getMainDefinition)(query) || {}).operation) || 'Query';
            var resolver = function(fieldName, rootValue, args, context, info) {
                if (rootValue === void 0) rootValue = {};
                var resultKey = info.resultKey;
                var aliasedNode = rootValue[resultKey];
                var preAliasingNode = rootValue[fieldName];
                var aliasNeeded = resultKey !== fieldName;
                if (aliasedNode !== undefined || preAliasingNode !== undefined) return aliasedNode || preAliasingNode;
                var resolverMap = resolvers[rootValue.__typename || type];
                if (resolverMap) {
                    var resolve = resolverMap[fieldName];
                    if (resolve) return resolve(rootValue, args, context, info);
                }
                return (aliasNeeded ? aliasedNode : preAliasingNode) || (defaults || {})[fieldName];
            };
            if (server) operation.query = server;
            var obs = server && forward ? forward(operation) : (0, $clSzL.Observable).of({
                data: {}
            });
            return new (0, $clSzL.Observable)(function(observer) {
                var complete = false;
                var handlingNext = false;
                obs.subscribe({
                    next: function(_a) {
                        var data = _a.data, errors = _a.errors;
                        var observerErrorHandler = observer.error.bind(observer);
                        var context = operation.getContext();
                        handlingNext = true;
                        $70f90ea50d538958$var$graphql(resolver, query, data, context, operation.variables, {
                            fragmentMatcher: fragmentMatcher
                        }).then(function(nextData) {
                            observer.next({
                                data: nextData,
                                errors: errors
                            });
                            if (complete) observer.complete();
                            handlingNext = false;
                        }).catch(observerErrorHandler);
                    },
                    error: observer.error.bind(observer),
                    complete: function() {
                        if (!handlingNext) observer.complete();
                        complete = true;
                    }
                });
            });
        };
        return StateLink;
    }((0, $clSzL.ApolloLink)))();
};

});
parcelRegister("jWd7i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3VFsf = parcelRequire("3VFsf");

var $jojW6 = parcelRequire("jojW6");

var $jDjTr = parcelRequire("jDjTr");
function $e83d9bca6fb9481d$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (execOptions === void 0) execOptions = {};
    var mainDefinition = $jojW6.getMainDefinition(document);
    var fragments = $jojW6.getFragmentDefinitions(document);
    var fragmentMap = $jojW6.createFragmentMap(fragments);
    var resultMapper = execOptions.resultMapper;
    var fragmentMatcher = execOptions.fragmentMatcher || function() {
        return true;
    };
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher
    };
    return $e83d9bca6fb9481d$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
module.exports.graphql = $e83d9bca6fb9481d$var$graphql;
function $e83d9bca6fb9481d$var$executeSelectionSet(selectionSet, rootValue, execContext) {
    return $3VFsf.__awaiter(this, void 0, void 0, function() {
        var fragmentMap, contextValue, variables, result, execute;
        var _this = this;
        return $3VFsf.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
                    result = {};
                    execute = function(selection) {
                        return $3VFsf.__awaiter(_this, void 0, void 0, function() {
                            var fieldResult, resultFieldKey, fragment, typeCondition, fragmentResult;
                            return $3VFsf.__generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if (!$jojW6.shouldInclude(selection, variables)) return [
                                            2
                                        ];
                                        if (!$jojW6.isField(selection)) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            $e83d9bca6fb9481d$var$executeField(selection, rootValue, execContext)
                                        ];
                                    case 1:
                                        fieldResult = _a.sent();
                                        resultFieldKey = $jojW6.resultKeyNameFromField(selection);
                                        if (fieldResult !== undefined) {
                                            if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                                            else $jDjTr.merge(result[resultFieldKey], fieldResult);
                                        }
                                        return [
                                            2
                                        ];
                                    case 2:
                                        if ($jojW6.isInlineFragment(selection)) fragment = selection;
                                        else {
                                            fragment = fragmentMap[selection.name.value];
                                            if (!fragment) throw new Error("No fragment named " + selection.name.value);
                                        }
                                        typeCondition = fragment.typeCondition.name.value;
                                        if (!execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) return [
                                            3,
                                            4
                                        ];
                                        return [
                                            4,
                                            $e83d9bca6fb9481d$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext)
                                        ];
                                    case 3:
                                        fragmentResult = _a.sent();
                                        $jDjTr.merge(result, fragmentResult);
                                        _a.label = 4;
                                    case 4:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    };
                    return [
                        4,
                        Promise.all(selectionSet.selections.map(execute))
                    ];
                case 1:
                    _a.sent();
                    if (execContext.resultMapper) return [
                        2,
                        execContext.resultMapper(result, rootValue)
                    ];
                    return [
                        2,
                        result
                    ];
            }
        });
    });
}
function $e83d9bca6fb9481d$var$executeField(field, rootValue, execContext) {
    return $3VFsf.__awaiter(this, void 0, void 0, function() {
        var variables, contextValue, resolver, fieldName, args, info, result;
        return $3VFsf.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
                    fieldName = field.name.value;
                    args = $jojW6.argumentsObjectFromField(field, variables);
                    info = {
                        isLeaf: !field.selectionSet,
                        resultKey: $jojW6.resultKeyNameFromField(field),
                        directives: $jojW6.getDirectiveInfoFromField(field, variables),
                        field: field
                    };
                    return [
                        4,
                        resolver(fieldName, rootValue, args, contextValue, info)
                    ];
                case 1:
                    result = _a.sent();
                    if (!field.selectionSet) return [
                        2,
                        result
                    ];
                    if (result == null) return [
                        2,
                        result
                    ];
                    if (Array.isArray(result)) return [
                        2,
                        $e83d9bca6fb9481d$var$executeSubSelectedArray(field, result, execContext)
                    ];
                    return [
                        2,
                        $e83d9bca6fb9481d$var$executeSelectionSet(field.selectionSet, result, execContext)
                    ];
            }
        });
    });
}
function $e83d9bca6fb9481d$var$executeSubSelectedArray(field, result, execContext) {
    return Promise.all(result.map(function(item) {
        if (item === null) return null;
        if (Array.isArray(item)) return $e83d9bca6fb9481d$var$executeSubSelectedArray(field, item, execContext);
        return $e83d9bca6fb9481d$var$executeSelectionSet(field.selectionSet, item, execContext);
    }));
}

});
parcelRegister("jDjTr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jojW6 = parcelRequire("jojW6");
function $e4b11739b667b187$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (variableValues === void 0) variableValues = {};
    if (execOptions === void 0) execOptions = {};
    var mainDefinition = $jojW6.getMainDefinition(document);
    var fragments = $jojW6.getFragmentDefinitions(document);
    var fragmentMap = $jojW6.createFragmentMap(fragments);
    var resultMapper = execOptions.resultMapper;
    var fragmentMatcher = execOptions.fragmentMatcher || function() {
        return true;
    };
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher
    };
    return $e4b11739b667b187$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
module.exports.graphql = $e4b11739b667b187$var$graphql;
function $e4b11739b667b187$var$executeSelectionSet(selectionSet, rootValue, execContext) {
    var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
    var result = {};
    selectionSet.selections.forEach(function(selection) {
        if (variables && !$jojW6.shouldInclude(selection, variables)) return;
        if ($jojW6.isField(selection)) {
            var fieldResult = $e4b11739b667b187$var$executeField(selection, rootValue, execContext);
            var resultFieldKey = $jojW6.resultKeyNameFromField(selection);
            if (fieldResult !== undefined) {
                if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                else $e4b11739b667b187$var$merge(result[resultFieldKey], fieldResult);
            }
        } else {
            var fragment = void 0;
            if ($jojW6.isInlineFragment(selection)) fragment = selection;
            else {
                fragment = fragmentMap[selection.name.value];
                if (!fragment) throw new Error("No fragment named " + selection.name.value);
            }
            var typeCondition = fragment.typeCondition.name.value;
            if (execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) {
                var fragmentResult = $e4b11739b667b187$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext);
                $e4b11739b667b187$var$merge(result, fragmentResult);
            }
        }
    });
    if (execContext.resultMapper) return execContext.resultMapper(result, rootValue);
    return result;
}
function $e4b11739b667b187$var$executeField(field, rootValue, execContext) {
    var variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
    var fieldName = field.name.value;
    var args = $jojW6.argumentsObjectFromField(field, variables);
    var info = {
        isLeaf: !field.selectionSet,
        resultKey: $jojW6.resultKeyNameFromField(field),
        directives: $jojW6.getDirectiveInfoFromField(field, variables),
        field: field
    };
    var result = resolver(fieldName, rootValue, args, contextValue, info);
    if (!field.selectionSet) return result;
    if (result == null) return result;
    if (Array.isArray(result)) return $e4b11739b667b187$var$executeSubSelectedArray(field, result, execContext);
    return $e4b11739b667b187$var$executeSelectionSet(field.selectionSet, result, execContext);
}
function $e4b11739b667b187$var$executeSubSelectedArray(field, result, execContext) {
    return result.map(function(item) {
        if (item === null) return null;
        if (Array.isArray(item)) return $e4b11739b667b187$var$executeSubSelectedArray(field, item, execContext);
        return $e4b11739b667b187$var$executeSelectionSet(field.selectionSet, item, execContext);
    });
}
var $e4b11739b667b187$var$hasOwn = Object.prototype.hasOwnProperty;
function $e4b11739b667b187$var$merge(dest, src) {
    if (src !== null && typeof src === 'object') Object.keys(src).forEach(function(key) {
        var srcVal = src[key];
        if (!$e4b11739b667b187$var$hasOwn.call(dest, key)) dest[key] = srcVal;
        else $e4b11739b667b187$var$merge(dest[key], srcVal);
    });
}
module.exports.merge = $e4b11739b667b187$var$merge;

});


parcelRegister("b2p88", function(module, exports) {

$parcel$export(module.exports, "removeClientSetsFromDocument", () => $80935fed9657b3c7$export$8eae69e876ee321e);
$parcel$export(module.exports, "normalizeTypeDefs", () => $80935fed9657b3c7$export$467f9c465e4ace4e);

var $1c8Um = parcelRequire("1c8Um");

var $jojW6 = parcelRequire("jojW6");
var $80935fed9657b3c7$var$connectionRemoveConfig = {
    test: function(directive) {
        return directive.name.value === 'client';
    },
    remove: true
};
var $80935fed9657b3c7$var$removed = new Map();
function $80935fed9657b3c7$export$8eae69e876ee321e(query) {
    var cached = $80935fed9657b3c7$var$removed.get(query);
    if (cached) return cached;
    (0, $jojW6.checkDocument)(query);
    var docClone = (0, $jojW6.removeDirectivesFromDocument)([
        $80935fed9657b3c7$var$connectionRemoveConfig
    ], query);
    $80935fed9657b3c7$var$removed.set(query, docClone);
    return docClone;
}
function $80935fed9657b3c7$export$467f9c465e4ace4e(typeDefs) {
    var defs = Array.isArray(typeDefs) ? typeDefs : [
        typeDefs
    ];
    return defs.map(function(typeDef) {
        return typeof typeDef === 'string' ? typeDef : (0, $1c8Um.print)(typeDef);
    }).map(function(str) {
        return str.trim();
    }).join('\n');
}

});



parcelRegister("dxpxC", function(module, exports) {

$parcel$export(module.exports, "UFOLoggerLink", () => $4350c2bcf1320fcf$export$fb326ed954631f3f);

var $clSzL = parcelRequire("clSzL");

var $bFU4G = parcelRequire("bFU4G");
const $4350c2bcf1320fcf$export$fb326ed954631f3f = new (0, $clSzL.ApolloLink)((operation, forward)=>{
    const networkStart = performance.now();
    return forward(operation).map((response)=>{
        const networkComplete = performance.now();
        const operationName = operation.operationName ?? 'unnamed';
        (0, $bFU4G.addSpanToAll)('graphql', operationName, [
            {
                name: 'network'
            }
        ], networkStart, networkComplete);
        return response;
    });
});

});

parcelRegister("l0T7c", function(module, exports) {
module.exports = JSON.parse("{\"__schema\":{\"types\":[{\"kind\":\"UNION\",\"name\":\"AllActivityFeedItemUnion\",\"possibleTypes\":[{\"name\":\"HistoryItem\"},{\"name\":\"CommentItem\"},{\"name\":\"WorklogItem\"},{\"name\":\"IncidentItem\"},{\"name\":\"ApprovalItem\"},{\"name\":\"HiddenCommentItem\"}]},{\"kind\":\"UNION\",\"name\":\"ApprovalActivityValueUnion\",\"possibleTypes\":[{\"name\":\"ApprovalCreated\"},{\"name\":\"ApproverDecision\"},{\"name\":\"ApprovalCompleted\"}]},{\"kind\":\"UNION\",\"name\":\"ConfluencePageUnion\",\"possibleTypes\":[{\"name\":\"ConfluencePage\"},{\"name\":\"FailedRemoteLink\"}]},{\"kind\":\"UNION\",\"name\":\"GQLCategorizedField\",\"possibleTypes\":[{\"name\":\"GQLSortableField\"},{\"name\":\"GQLSearchableField\"}]},{\"kind\":\"UNION\",\"name\":\"GadgetParameters\",\"possibleTypes\":[{\"name\":\"VotedGadgetParameters\"},{\"name\":\"AssignedToMeGadgetParameters\"},{\"name\":\"WatchedGadgetParameters\"},{\"name\":\"InProgressGadgetParameters\"},{\"name\":\"FilterResultsGadgetParameters\"},{\"name\":\"TwoDimensionalStatisticsParameters\"},{\"name\":\"PieChartParameters\"},{\"name\":\"IssueStatisticsParameters\"},{\"name\":\"WorkloadPieChartParameters\"},{\"name\":\"ActivityStreamGadgetParameters\"},{\"name\":\"CreatedVsResolvedGadgetParameters\"},{\"name\":\"SprintGadgetParameters\"},{\"name\":\"ProjectsGadgetParameters\"},{\"name\":\"ConnectGadgetParameters\"},{\"name\":\"NotConfiguredGadgetParameters\"},{\"name\":\"UnsupportedGadgetParameters\"}]},{\"kind\":\"UNION\",\"name\":\"GroupByFieldUnion\",\"possibleTypes\":[{\"name\":\"PriorityField\"},{\"name\":\"StatusField\"},{\"name\":\"UserField\"},{\"name\":\"LabelsField\"},{\"name\":\"SelectCustomField\"},{\"name\":\"JWMCategoryCustomField\"},{\"name\":\"IssueTypeField\"},{\"name\":\"StoryPointsField\"},{\"name\":\"SprintCustomField\"},{\"name\":\"FloatCustomField\"}]},{\"kind\":\"UNION\",\"name\":\"GroupSectionItem\",\"possibleTypes\":[{\"name\":\"FieldSectionItem\"},{\"name\":\"EcosystemSectionItem\"},{\"name\":\"ForgeSectionItem\"},{\"name\":\"PanelSectionItem\"}]},{\"kind\":\"UNION\",\"name\":\"HistoryValue\",\"possibleTypes\":[{\"name\":\"AssigneeFieldValue\"},{\"name\":\"PriorityFieldValue\"},{\"name\":\"StatusFieldValue\"},{\"name\":\"WorkLogFieldValue\"},{\"name\":\"RespondersFieldValue\"},{\"name\":\"GenericFieldValue\"}]},{\"kind\":\"UNION\",\"name\":\"IncidentActivityValueUnion\",\"possibleTypes\":[{\"name\":\"ResponderAlertAssignedValue\"},{\"name\":\"AlertValue\"},{\"name\":\"ResponderAlertPriorityChangedValue\"},{\"name\":\"IccSessionValue\"},{\"name\":\"IccSessionInvitationValue\"},{\"name\":\"StakeholderUpdatedValue\"},{\"name\":\"IncidentStakeholderActionValue\"}]},{\"kind\":\"UNION\",\"name\":\"IssueFieldUnion\",\"possibleTypes\":[{\"name\":\"PriorityField\"},{\"name\":\"StatusField\"},{\"name\":\"IssueTypeField\"},{\"name\":\"ProjectComponentsField\"},{\"name\":\"LabelsField\"},{\"name\":\"WatchersField\"},{\"name\":\"UserField\"},{\"name\":\"TextField\"},{\"name\":\"VersionsField\"},{\"name\":\"DateField\"},{\"name\":\"DateTimeField\"},{\"name\":\"IssueKeyField\"},{\"name\":\"ProjectField\"},{\"name\":\"ResolutionField\"},{\"name\":\"TimeTrackingField\"},{\"name\":\"TimeOriginalEstimateField\"},{\"name\":\"TimeEstimateField\"},{\"name\":\"TimeSpentField\"},{\"name\":\"StoryPointsField\"},{\"name\":\"EpicLinkField\"},{\"name\":\"EpicNameField\"},{\"name\":\"ColorField\"},{\"name\":\"EpicColorField\"},{\"name\":\"SprintCustomField\"},{\"name\":\"SelectCustomField\"},{\"name\":\"FlaggedCustomField\"},{\"name\":\"UserPickerCustomField\"},{\"name\":\"TextAreaCustomField\"},{\"name\":\"FloatCustomField\"},{\"name\":\"DatePickerCustomField\"},{\"name\":\"TextFieldCustomField\"},{\"name\":\"MultiSelectCustomField\"},{\"name\":\"LabelsCustomField\"},{\"name\":\"MultiUserPickerCustomField\"},{\"name\":\"PeopleCustomField\"},{\"name\":\"UrlCustomField\"},{\"name\":\"VersionCustomField\"},{\"name\":\"GroupPickerCustomField\"},{\"name\":\"MultiVersionCustomField\"},{\"name\":\"MultiGroupPickerCustomField\"},{\"name\":\"CheckBoxesCustomField\"},{\"name\":\"RadioButtonsCustomField\"},{\"name\":\"DateTimeCustomField\"},{\"name\":\"SeverityField\"},{\"name\":\"AffectedServicesField\"},{\"name\":\"TechLeadField\"},{\"name\":\"AttachmentsField\"},{\"name\":\"GlancesField\"},{\"name\":\"SecurityLevelField\"},{\"name\":\"IssueLinksField\"},{\"name\":\"IssuesInEpicField\"},{\"name\":\"SubtasksField\"},{\"name\":\"ChildIssuesField\"},{\"name\":\"CascadingSelectCustomField\"},{\"name\":\"CmdbField\"},{\"name\":\"SLACustomField\"},{\"name\":\"ProjectCustomField\"},{\"name\":\"EpicStatusField\"},{\"name\":\"ParentField\"},{\"name\":\"JWMCategoryCustomField\"},{\"name\":\"CommentSummaryField\"}]},{\"kind\":\"UNION\",\"name\":\"IssueSections\",\"possibleTypes\":[{\"name\":\"PrimarySecondaryContextSections\"},{\"name\":\"JsdSections\"}]},{\"kind\":\"UNION\",\"name\":\"JiraActiveBackgroundDetailsResult\",\"possibleTypes\":[{\"name\":\"JiraColorBackground\"},{\"name\":\"JiraGradientBackground\"},{\"name\":\"JiraMediaBackground\"},{\"name\":\"JiraAttachmentBackground\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraAtlassianIntelligenceAction\",\"possibleTypes\":[{\"name\":\"JiraAccessAtlassianIntelligenceFeature\"},{\"name\":\"JiraEnableAtlassianIntelligenceDeepLink\"},{\"name\":\"JiraContactOrgAdminToEnableAtlassianIntelligence\"}]},{\"kind\":\"UNION\",\"name\":\"JiraBackgroundUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraBackgroundUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraBoardResult\",\"possibleTypes\":[{\"name\":\"JiraBoard\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraChildIssues\",\"possibleTypes\":[{\"name\":\"JiraChildIssuesWithinLimit\"},{\"name\":\"JiraChildIssuesExceedingLimit\"}]},{\"kind\":\"UNION\",\"name\":\"JiraCommentVisibility\",\"possibleTypes\":[{\"name\":\"JiraRoleVisibility\"},{\"name\":\"JiraGroupVisibility\"}]},{\"kind\":\"UNION\",\"name\":\"JiraConfluencePageContent\",\"possibleTypes\":[{\"name\":\"JiraConfluencePageContentDetails\"},{\"name\":\"JiraConfluencePageContentError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraContainerNavigationResult\",\"possibleTypes\":[{\"name\":\"JiraContainerNavigation\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraDefaultUnsplashImagesPageResult\",\"possibleTypes\":[{\"name\":\"JiraDefaultUnsplashImagesPage\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFavourite\",\"possibleTypes\":[{\"name\":\"JiraProject\"},{\"name\":\"JiraSystemFilter\"},{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraDashboard\"},{\"name\":\"JiraPlan\"},{\"name\":\"JiraBoard\"},{\"name\":\"JiraServiceManagementQueue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFieldFormatConfig\",\"possibleTypes\":[{\"name\":\"JiraNumberFieldFormatConfig\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFieldSetViewResult\",\"possibleTypes\":[{\"name\":\"JiraFieldSetView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFormattingExpression\",\"possibleTypes\":[{\"name\":\"JiraFormattingSingleValueOperand\"},{\"name\":\"JiraFormattingTwoValueOperand\"},{\"name\":\"JiraFormattingMultipleValueOperand\"},{\"name\":\"JiraFormattingNoValueOperand\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGlobalPermissionGrantsResult\",\"possibleTypes\":[{\"name\":\"JiraGlobalPermissionGrantsList\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGrantTypeValue\",\"possibleTypes\":[{\"name\":\"JiraDefaultGrantTypeValue\"},{\"name\":\"JiraUserGrantTypeValue\"},{\"name\":\"JiraProjectRoleGrantTypeValue\"},{\"name\":\"JiraGroupGrantTypeValue\"},{\"name\":\"JiraIssueFieldGrantTypeValue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGroupLayoutItem\",\"possibleTypes\":[{\"name\":\"JiraFieldLayoutItem\"},{\"name\":\"JiraEcosystemLayoutItem\"},{\"name\":\"JiraForgeLayoutItem\"},{\"name\":\"JiraPanelLayoutItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateAdditionalServicesResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateAdditionalServices\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateFieldsResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateFields\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateLayoutResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateLayout\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueExportEvent\",\"possibleTypes\":[{\"name\":\"JiraIssueExportTaskSubmitted\"},{\"name\":\"JiraIssueExportTaskProgress\"},{\"name\":\"JiraIssueExportTaskCompleted\"},{\"name\":\"JiraIssueExportTaskTerminated\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"},{\"name\":\"JiraIssueItemPanelItem\"},{\"name\":\"JiraIssueItemGroupContainer\"},{\"name\":\"JiraIssueItemTabContainer\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemContainersResult\",\"possibleTypes\":[{\"name\":\"JiraIssueItemContainers\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemGroupContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"},{\"name\":\"JiraIssueItemPanelItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemTabContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayout\",\"possibleTypes\":[{\"name\":\"JiraDefaultIssueLayout\"},{\"name\":\"JiraIssueCreateLayout\"},{\"name\":\"JiraLegacyIssueLayout\"},{\"name\":\"JsdDefaultIssueLayout\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutConfigurationResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutFieldConfigurationHiddenIn\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutFieldConfigurationHiddenInGlobal\"},{\"name\":\"JiraIssueLayoutFieldConfigurationHiddenInLayoutOwner\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutFieldPanelItemConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutFieldItemConfiguration\"},{\"name\":\"JiraIssueLayoutPanelItemConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutItemConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutContainerConfiguration\"},{\"name\":\"JiraIssueLayoutFieldItemConfiguration\"},{\"name\":\"JiraIssueLayoutGroupContainerConfiguration\"},{\"name\":\"JiraIssueLayoutTabContainerConfiguration\"},{\"name\":\"JiraIssueLayoutPanelItemConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutOwner\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutIssueTypeOwner\"},{\"name\":\"JiraIssueLayoutRequestTypeOwner\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutOwners\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutOwnersResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueResult\",\"possibleTypes\":[{\"name\":\"JiraIssue\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchByFilterResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchByFilter\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchByJqlResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchByJql\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchError\",\"possibleTypes\":[{\"name\":\"JiraInvalidJqlError\"},{\"name\":\"JiraInvalidSyntaxError\"},{\"name\":\"JiraServerError\"},{\"name\":\"JiraCustomIssueSearchError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchViewResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJQLGenerationError\",\"possibleTypes\":[{\"name\":\"JiraInvalidJqlError\"},{\"name\":\"JiraInvalidSyntaxError\"},{\"name\":\"JiraServerError\"},{\"name\":\"JiraUIExposedError\"},{\"name\":\"JiraUsageLimitExceededError\"},{\"name\":\"JiraUnsupportedLanguageError\"},{\"name\":\"JiraGeneratedJqlInvalidError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJourneyItem\",\"possibleTypes\":[{\"name\":\"JiraJourneyWorkItem\"},{\"name\":\"JiraJourneyStatusDependency\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJourneyParentIssueValueType\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementRequestType\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJourneyTriggerConfiguration\",\"possibleTypes\":[{\"name\":\"JiraJourneyWorkdayIntegrationTriggerConfiguration\"},{\"name\":\"JiraJourneyParentIssueTriggerConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlFieldConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraJqlFieldConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlHydratedQueryResult\",\"possibleTypes\":[{\"name\":\"JiraJqlHydratedQuery\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlQueryHydratedFieldResult\",\"possibleTypes\":[{\"name\":\"JiraJqlQueryHydratedField\"},{\"name\":\"JiraJqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlQueryHydratedValueResult\",\"possibleTypes\":[{\"name\":\"JiraJqlQueryHydratedValue\"},{\"name\":\"JiraJqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraMediaUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraMediaUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraNavigationItemResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementSavedView\"},{\"name\":\"JiraSoftwareBuiltInNavigationItem\"},{\"name\":\"JiraAppNavigationItem\"},{\"name\":\"JiraShortcutNavigationItem\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraOnSuggestedChildIssueResult\",\"possibleTypes\":[{\"name\":\"JiraSuggestedIssue\"},{\"name\":\"JiraSuggestedChildIssueStatus\"},{\"name\":\"JiraSuggestedChildIssueError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraOverviewPlanMigrationStateResult\",\"possibleTypes\":[{\"name\":\"JiraOverviewPlanMigrationState\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraPermissionSchemeViewResult\",\"possibleTypes\":[{\"name\":\"JiraPermissionSchemeView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectConfiguration\",\"possibleTypes\":[{\"name\":\"JiraProjectConfigurationResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectNavigationMetadata\",\"possibleTypes\":[{\"name\":\"JiraSoftwareProjectNavigationMetadata\"},{\"name\":\"JiraServiceManagementProjectNavigationMetadata\"},{\"name\":\"JiraWorkManagementProjectNavigationMetadata\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectsUsingField\",\"possibleTypes\":[{\"name\":\"JiraProjectsUsingFieldResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraRemoteIssueLink\",\"possibleTypes\":[{\"name\":\"JiraIssueRemoteIssueLink\"},{\"name\":\"JiraConfluenceRemoteIssueLink\"},{\"name\":\"JiraWebRemoteIssueLink\"},{\"name\":\"JiraCustomRemoteIssueLink\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSearchableEntity\",\"possibleTypes\":[{\"name\":\"JiraProject\"},{\"name\":\"JiraSystemFilter\"},{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraBoard\"},{\"name\":\"JiraDashboard\"},{\"name\":\"JiraIssue\"},{\"name\":\"JiraServiceManagementQueue\"},{\"name\":\"JiraPlan\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSectionLayoutItem\",\"possibleTypes\":[{\"name\":\"JiraGroupLayout\"},{\"name\":\"JiraTabLayout\"},{\"name\":\"JiraFieldLayoutItem\"},{\"name\":\"JiraEcosystemLayoutItem\"},{\"name\":\"JiraForgeLayoutItem\"},{\"name\":\"JiraPanelLayoutItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementApproverPrincipal\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementUserApproverPrincipal\"},{\"name\":\"JiraServiceManagementGroupApproverPrincipal\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementEntitledEntity\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementEntitlementCustomer\"},{\"name\":\"JiraServiceManagementEntitlementOrganization\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementRequestTypePreviewField\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementTextPreviewField\"},{\"name\":\"JiraServiceManagementTextAreaPreviewField\"},{\"name\":\"JiraServiceManagementDueDatePreviewField\"},{\"name\":\"JiraServiceManagementDatePreviewField\"},{\"name\":\"JiraServiceManagementDateTimePreviewField\"},{\"name\":\"JiraServiceManagementAttachmentPreviewField\"},{\"name\":\"JiraServiceManagementSelectPreviewField\"},{\"name\":\"JiraServiceManagementMultiSelectPreviewField\"},{\"name\":\"JiraServiceManagementMultiUserPickerPreviewField\"},{\"name\":\"JiraServiceManagementMultiServicePickerPreviewField\"},{\"name\":\"JiraServiceManagementMultiCheckboxesPreviewField\"},{\"name\":\"JiraServiceManagementPeoplePreviewField\"},{\"name\":\"JiraServiceManagementUnknownPreviewField\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementResponder\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementUserResponder\"},{\"name\":\"JiraServiceManagementTeamResponder\"}]},{\"kind\":\"UNION\",\"name\":\"JiraShareableEntityEditGrant\",\"possibleTypes\":[{\"name\":\"JiraShareableEntityGroupGrant\"},{\"name\":\"JiraShareableEntityProjectRoleGrant\"},{\"name\":\"JiraShareableEntityUserGrant\"},{\"name\":\"JiraShareableEntityProjectGrant\"},{\"name\":\"JiraShareableEntityUnknownProjectGrant\"}]},{\"kind\":\"UNION\",\"name\":\"JiraShareableEntityShareGrant\",\"possibleTypes\":[{\"name\":\"JiraShareableEntityGroupGrant\"},{\"name\":\"JiraShareableEntityProjectRoleGrant\"},{\"name\":\"JiraShareableEntityProjectGrant\"},{\"name\":\"JiraShareableEntityAnonymousAccessGrant\"},{\"name\":\"JiraShareableEntityAnyLoggedInUserGrant\"},{\"name\":\"JiraShareableEntityUnknownProjectGrant\"},{\"name\":\"JiraShareableEntityUserGrant\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSpreadsheetGroupFieldValue\",\"possibleTypes\":[{\"name\":\"AtlassianAccountUser\"},{\"name\":\"JiraOption\"},{\"name\":\"JiraStatus\"},{\"name\":\"JiraPriority\"},{\"name\":\"JiraStoryPoint\"},{\"name\":\"JiraGoal\"}]},{\"kind\":\"UNION\",\"name\":\"JiraUnsplashImageSearchPageResult\",\"possibleTypes\":[{\"name\":\"JiraUnsplashImageSearchPage\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraVersionConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraVersionConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraVersionResult\",\"possibleTypes\":[{\"name\":\"JiraVersion\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementActiveBackgroundDetailsResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementColorBackground\"},{\"name\":\"JiraWorkManagementGradientBackground\"},{\"name\":\"JiraWorkManagementMediaBackground\"},{\"name\":\"JiraWorkManagementAttachmentBackground\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementBackgroundUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementBackgroundUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementCategoryOptionConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementCategoryOptionConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementFieldConfigurationConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementFieldConfigurationConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementFilterConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementFilterConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementGiraOverviewResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementGiraOverview\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementSavedViewResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementSavedView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementViewItemConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementViewItemConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlFieldConnectionResult\",\"possibleTypes\":[{\"name\":\"JqlFieldConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlHydratedQueryResult\",\"possibleTypes\":[{\"name\":\"JqlHydratedQuery\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlQueryHydratedFieldResult\",\"possibleTypes\":[{\"name\":\"JqlQueryHydratedField\"},{\"name\":\"JqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlQueryHydratedValueResult\",\"possibleTypes\":[{\"name\":\"JqlQueryHydratedValue\"},{\"name\":\"JqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"LayoutDefiner\",\"possibleTypes\":[{\"name\":\"FieldLayoutScreen\"},{\"name\":\"JiraRequestType\"}]},{\"kind\":\"UNION\",\"name\":\"MediaUploadTokenUnion\",\"possibleTypes\":[{\"name\":\"MediaUploadToken\"},{\"name\":\"FailedMediaUploadToken\"}]},{\"kind\":\"UNION\",\"name\":\"MergedFieldUnion\",\"possibleTypes\":[{\"name\":\"IssueTypeField\"},{\"name\":\"StatusField\"}]},{\"kind\":\"UNION\",\"name\":\"ProjectCategoryGadgetUnion\",\"possibleTypes\":[{\"name\":\"ProjectsGadgetItem\"},{\"name\":\"CategoriesGadgetItem\"}]},{\"kind\":\"UNION\",\"name\":\"RemoteIssueDetailsUnion\",\"possibleTypes\":[{\"name\":\"AssociatedIssueWrapper\"},{\"name\":\"FailedRemoteIssue\"}]},{\"kind\":\"UNION\",\"name\":\"SectionItem\",\"possibleTypes\":[{\"name\":\"GroupLayout\"},{\"name\":\"TabLayout\"},{\"name\":\"FieldSectionItem\"},{\"name\":\"EcosystemSectionItem\"},{\"name\":\"ForgeSectionItem\"},{\"name\":\"PanelSectionItem\"}]},{\"kind\":\"UNION\",\"name\":\"TimeSeriesChartAdditionalPropertiesUnion\",\"possibleTypes\":[{\"name\":\"CreatedVsResolvedProperties\"}]}]}}");

});

parcelRegister("9g713", function(module, exports) {

$parcel$export(module.exports, "getErrorAnalyticsContext", () => $a87e716199660ede$export$bd030713895ed5e2);
$parcel$export(module.exports, "reportErrors", () => $a87e716199660ede$export$a78ebe1911f50d41);

var $9XE6b = parcelRequire("9XE6b");

var $e3a3O = parcelRequire("e3a3O");

var $jcw0u = parcelRequire("jcw0u");
const $a87e716199660ede$export$15d632fe38832073 = 'giraErrorAnalytics';
const $a87e716199660ede$export$fc6a71db0f9a33f9 = (errorAnalytics, context = {})=>({
        ...context,
        [$a87e716199660ede$export$15d632fe38832073]: errorAnalytics
    });
const $a87e716199660ede$export$bd030713895ed5e2 = (context)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const errorAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(context, [
        $a87e716199660ede$export$15d632fe38832073
    ], undefined);
    if (typeof errorAnalytics === 'object' && typeof errorAnalytics.id === 'string' && (errorAnalytics.packageName === undefined || typeof errorAnalytics.packageName === 'string') && (errorAnalytics.teamName === undefined || typeof errorAnalytics.teamName === 'string') && (errorAnalytics.attributes === undefined || typeof errorAnalytics.attributes === 'object') && (errorAnalytics.sendToPrivacyUnsafeSplunk === undefined || typeof errorAnalytics.sendToPrivacyUnsafeSplunk === 'boolean')) return {
        id: errorAnalytics.id,
        packageName: errorAnalytics.packageName,
        teamName: errorAnalytics.teamName,
        attributes: errorAnalytics.attributes,
        sendToPrivacyUnsafeSplunk: errorAnalytics.sendToPrivacyUnsafeSplunk
    };
    return undefined;
};
const $a87e716199660ede$export$a78ebe1911f50d41 = ({ graphQLErrors: graphQLErrors, networkError: networkError, operation: operation })=>{
    const errorAnalytics = $a87e716199660ede$export$bd030713895ed5e2(operation.getContext());
    // Refine mixed type to Array | void
    if (graphQLErrors !== undefined && !Array.isArray(graphQLErrors)) return;
    const hasGraphQLError = graphQLErrors !== undefined && graphQLErrors.length > 0;
    const hasNetworkError = networkError !== undefined;
    // Only report errors using the JFE analytics pipeline if analytics context data is defined for the query.
    if (errorAnalytics === undefined || !hasGraphQLError && !hasNetworkError) return;
    const { id: id, packageName: packageName, teamName: teamName, attributes: attributes, sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk } = errorAnalytics;
    const error = new (0, $e3a3O.ApolloError)({
        // Above Array.isArray check will refine the type to a read-only array. We need this spread to keep flow happy.
        graphQLErrors: graphQLErrors ? [
            ...graphQLErrors
        ] : undefined,
        networkError: networkError
    });
    const attributesWithOperationName = {
        ...attributes,
        operationName: operation.operationName,
        hasGraphQLError: hasGraphQLError,
        hasNetworkError: hasNetworkError
    };
    (0, $jcw0u.default)({
        error: error,
        meta: {
            id: id,
            packageName: packageName,
            teamName: teamName
        },
        attributes: attributesWithOperationName,
        sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk
    });
};

});


parcelRegister("AeWM3", function(module, exports) {

$parcel$export(module.exports, "resetCache", () => $63ae5caf575c2d55$export$6e5dca841bdf93e3);
$parcel$export(module.exports, "resetCacheAsync", () => $63ae5caf575c2d55$export$cd62f60830f74ae2);
$parcel$export(module.exports, "getClient", () => $63ae5caf575c2d55$export$6bb76d6eba7e258c);
$parcel$export(module.exports, "ApolloClientProvider", () => $63ae5caf575c2d55$export$8e363dbef886ff17);

var $5uXOq = parcelRequire("5uXOq");

var $9XE6b = parcelRequire("9XE6b");

var $bvsgq = parcelRequire("bvsgq");

var $9OXo1 = parcelRequire("9OXo1");
const $63ae5caf575c2d55$var$CLIENTS_CACHE = {};
const $63ae5caf575c2d55$export$6e5dca841bdf93e3 = (clientId)=>{
    // we need to `clearStore` directly to the InMemoryCache instance
    $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId]?.clearStore();
    delete $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId];
};
const $63ae5caf575c2d55$export$cd62f60830f74ae2 = async (clientId)=>{
    // we need to `clearStore` directly to the InMemoryCache instance
    const client = $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId];
    delete $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId];
    await client?.clearStore();
};
const $63ae5caf575c2d55$export$44dd3e9494f887fc = ()=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys($63ae5caf575c2d55$var$CLIENTS_CACHE).reduce((acc, key)=>Object.assign(acc, {
            [`apollo-cache/${key}`]: $63ae5caf575c2d55$var$CLIENTS_CACHE[key].extract()
        }), {});
const $63ae5caf575c2d55$export$6bb76d6eba7e258c = (baseUrl, { clientId: clientId, clientCreator: clientCreator }, xsrfToken)=>{
    let client = $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId];
    if (!client) {
        client = clientCreator(baseUrl, xsrfToken);
        $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId] = client;
    }
    return client;
};
class $63ae5caf575c2d55$export$8e363dbef886ff17 extends (0, $5uXOq.Component) {
    getClient(baseUrl, xsrfToken) {
        return $63ae5caf575c2d55$export$6bb76d6eba7e258c(baseUrl, this.props.client, xsrfToken != null ? xsrfToken : undefined);
    }
    render() {
        const { children: children } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(this.props, 'client.clientId')) throw new Error('Please provide a client configuration');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
            const client = this.getClient(tenantContext.baseUrl, tenantContext.xsrfToken);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bvsgq.ApolloProvider), {
                client: client
            }, children);
        });
    }
}

});
parcelRegister("bvsgq", function(module, exports) {

$parcel$export(module.exports, "getApolloContext", () => $02296d7a3662bd2d$export$a47505d961ee3a1);
$parcel$export(module.exports, "ApolloProvider", () => $02296d7a3662bd2d$export$c16b04c8a9956446);
$parcel$export(module.exports, "DocumentType", () => $02296d7a3662bd2d$export$d1d99cf900472499);
$parcel$export(module.exports, "operationName", () => $02296d7a3662bd2d$export$5db520940cf00715);
$parcel$export(module.exports, "parser", () => $02296d7a3662bd2d$export$8f49e4af10703ce3);

var $5uXOq = parcelRequire("5uXOq");

var $1DiV8 = parcelRequire("1DiV8");
var $02296d7a3662bd2d$var$apolloContext;
function $02296d7a3662bd2d$export$a47505d961ee3a1() {
    if (!$02296d7a3662bd2d$var$apolloContext) $02296d7a3662bd2d$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({});
    return $02296d7a3662bd2d$var$apolloContext;
}
function $02296d7a3662bd2d$export$c2ee824bcc89ca6a() {
    $02296d7a3662bd2d$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({});
}
var $02296d7a3662bd2d$export$c16b04c8a9956446 = function(_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = $02296d7a3662bd2d$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ApolloContext.Consumer, null, function(context) {
        if (context === void 0) context = {};
        if (client && context.client !== client) context = Object.assign({}, context, {
            client: client
        });
        (0, $1DiV8.invariant)(context.client, 5);
        return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ApolloContext.Provider, {
            value: context
        }, children);
    });
};
var $02296d7a3662bd2d$export$ed5ceab8c2bb5ce4 = function(props) {
    var ApolloContext = $02296d7a3662bd2d$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ApolloContext.Consumer, null, function(context) {
        (0, $1DiV8.invariant)(context && context.client, 6);
        return props.children(context.client);
    });
};
var $02296d7a3662bd2d$export$d1d99cf900472499;
(function(DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})($02296d7a3662bd2d$export$d1d99cf900472499 || ($02296d7a3662bd2d$export$d1d99cf900472499 = {}));
var $02296d7a3662bd2d$var$cache = new Map();
function $02296d7a3662bd2d$export$5db520940cf00715(type) {
    var name;
    switch(type){
        case $02296d7a3662bd2d$export$d1d99cf900472499.Query:
            name = 'Query';
            break;
        case $02296d7a3662bd2d$export$d1d99cf900472499.Mutation:
            name = 'Mutation';
            break;
        case $02296d7a3662bd2d$export$d1d99cf900472499.Subscription:
            name = 'Subscription';
            break;
    }
    return name;
}
function $02296d7a3662bd2d$export$8f49e4af10703ce3(document) {
    var cached = $02296d7a3662bd2d$var$cache.get(document);
    if (cached) return cached;
    var variables, type, name;
    (0, $1DiV8.invariant)(!!document && !!document.kind, 1);
    var fragments = document.definitions.filter(function(x) {
        return x.kind === 'FragmentDefinition';
    });
    var queries = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'query';
    });
    var mutations = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'mutation';
    });
    var subscriptions = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'subscription';
    });
    (0, $1DiV8.invariant)(!fragments.length || queries.length || mutations.length || subscriptions.length, 2);
    (0, $1DiV8.invariant)(queries.length + mutations.length + subscriptions.length <= 1, 3);
    type = queries.length ? $02296d7a3662bd2d$export$d1d99cf900472499.Query : $02296d7a3662bd2d$export$d1d99cf900472499.Mutation;
    if (!queries.length && !mutations.length) type = $02296d7a3662bd2d$export$d1d99cf900472499.Subscription;
    var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
    (0, $1DiV8.invariant)(definitions.length === 1, 4);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === 'Name') name = definition.name.value;
    else name = 'data';
    var payload = {
        name: name,
        type: type,
        variables: variables
    };
    $02296d7a3662bd2d$var$cache.set(document, payload);
    return payload;
}

});


parcelRegister("eiOkd", function(module, exports) {

$parcel$export(module.exports, "default", () => $b98d0f47ed36cd9a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $6cG4N = parcelRequire("6cG4N");


var $bUSNl = parcelRequire("bUSNl");

var $lLfAu = parcelRequire("lLfAu");
// This wrapper should be agnostic, please don't add any project or overview logic here.
const $b98d0f47ed36cd9a$var$BusinessAppWrapper = ({ children: children, className: className, header: header, sidebarTheme: sidebarTheme, shouldAddPadding: shouldAddPadding = true, withSidebar: withSidebar = false, withDynamicHeight: withDynamicHeight = false, withOverflow: withOverflow = false })=>{
    const [{ content: sidebarContent }] = (0, $bUSNl.useSidebar)();
    const isSidebarOpen = withSidebar && sidebarContent != null;
    let content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, header, children);
    if (withSidebar) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lLfAu.SidebarLayout), {
        theme: sidebarTheme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $b98d0f47ed36cd9a$var$contentWrapperStyles,
            isSidebarOpen && $b98d0f47ed36cd9a$var$sidebarOpenContentWrapperStyles
        ]
    }, content));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b98d0f47ed36cd9a$var$ThemedContainer, {
        shouldAddPadding: shouldAddPadding,
        isSidebarOpen: isSidebarOpen,
        withSidebar: withSidebar,
        withDynamicHeight: withDynamicHeight,
        withOverflow: withOverflow,
        id: (0, $c15b7ab4e654e0c4$export$e5e75ff4daca6597),
        // Used for styling
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: className
    }, content);
};
const $b98d0f47ed36cd9a$var$contentWrapperStyles = (0, $8CUq3.xcss)({
    // @ts-expect-error - we need to use Tokens to correctly set the color value using CSS variables
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    color: (0, $6cG4N.Tokens).COLOR_TEXT,
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    flexShrink: 1,
    maxWidth: '100%',
    minWidth: '0',
    width: 'auto'
});
const $b98d0f47ed36cd9a$var$sidebarOpenContentWrapperStyles = (0, $8CUq3.xcss)({
    paddingRight: 'space.300',
    paddingBottom: 'space.300'
});
var $b98d0f47ed36cd9a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($b98d0f47ed36cd9a$var$BusinessAppWrapper);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $b98d0f47ed36cd9a$var$ThemedContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { withSidebar: withSidebar, withDynamicHeight: withDynamicHeight, shouldAddPadding: shouldAddPadding, isSidebarOpen: isSidebarOpen, withOverflow: withOverflow, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2lx21bp4 _1n261q9c _vchhusvi _1e0c1txw _1bah1y6m _ca0qidpf",
            !__cmplp.withSidebar && "_syazfrbu",
            __cmplp.withDynamicHeight ? "_4t3i1wug" : "_4t3i1osq",
            __cmplp.withDynamicHeight ? "_1tke1osq" : "_1tke1wug",
            !__cmplp.shouldAddPadding || __cmplp.isSidebarOpen ? "_u5f3idpf" : "_u5f31ejb",
            !__cmplp.shouldAddPadding || __cmplp.isSidebarOpen ? "_n3tdidpf" : "_n3td1ejb",
            __cmplp.shouldAddPadding ? "_19bv1ejb" : "_19bvidpf",
            __cmplp.withOverflow ? "_1reo1wug _18m91wug" : "_1reoewfl _18m9ewfl",
            __cmplp.className
        ])
    });
});

});
const $c15b7ab4e654e0c4$export$e5e75ff4daca6597 = 'jwm-container';

parcelRegister("bUSNl", function(module, exports) {

$parcel$export(module.exports, "getSidebarQueryParams", () => $39fc2da09b28cabf$export$ddc11e4d41e7cf62);
$parcel$export(module.exports, "useSidebar", () => $39fc2da09b28cabf$export$54c70f22f548bff8);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $hE5wF = parcelRequire("hE5wF");

var $3hGWp = parcelRequire("3hGWp");

var $dCm1o = parcelRequire("dCm1o");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $4R6GH = parcelRequire("4R6GH");

var $jnA4H = parcelRequire("jnA4H");

const $39fc2da09b28cabf$export$ddc11e4d41e7cf62 = ()=>[
        (0, $hE5wF.SELECTED_ISSUE_PARAM),
        (0, $hE5wF.SELECTED_COMMENT_PARAM)
    ];
const $39fc2da09b28cabf$export$b3747bec68e731a9 = ()=>(0, $dCm1o.isVisualRefreshEnabled)() ? (0, $55f230b510f63572$export$b16f75f2e0c3c029) : (0, $55f230b510f63572$export$2146fa818259227f);
const $39fc2da09b28cabf$var$setSidebarContent = (content)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            content: content
        });
    };
const $39fc2da09b28cabf$var$setSidebarWidth = (width)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        let minWidth;
        const sidebarWidthFromStore = (0, $jnA4H.getSidebarWidthFromStore)(state);
        if ((0, $4R6GH.fg)('fix_reply_editor_width')) minWidth = Math.min(sidebarWidthFromStore, (0, $55f230b510f63572$export$77e787f7c2e430e5));
        else minWidth = Math.min(sidebarWidthFromStore, $39fc2da09b28cabf$export$b3747bec68e731a9());
        const newWidth = Math.max(width, minWidth);
        if (newWidth === state.sidebarWidth) return;
        setState({
            ...state,
            sidebarWidth: newWidth
        });
        (0, $jnA4H.localStorage).set((0, $55f230b510f63572$export$86880b4b2e1a2384), newWidth);
    };
const $39fc2da09b28cabf$var$setSidebarOnClose = (onSidebarClose)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            onSidebarClose: onSidebarClose
        });
    };
const $39fc2da09b28cabf$var$closeSidebar = ()=>({ setState: setState, getState: getState })=>{
        const state = getState();
        state.onSidebarClose();
        setState({
            ...state,
            content: null,
            onSidebarClose: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        });
    };
const $39fc2da09b28cabf$var$actions = {
    setSidebarContent: $39fc2da09b28cabf$var$setSidebarContent,
    setSidebarWidth: $39fc2da09b28cabf$var$setSidebarWidth,
    setSidebarOnClose: $39fc2da09b28cabf$var$setSidebarOnClose,
    closeSidebar: $39fc2da09b28cabf$var$closeSidebar
};
const $39fc2da09b28cabf$var$Store = (0, $iXqE5.createStore)({
    initialState: {
        content: null,
        sidebarWidth: null,
        onSidebarClose: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    },
    actions: $39fc2da09b28cabf$var$actions,
    name: 'JWMSidebarStore'
});
const $39fc2da09b28cabf$var$useHook = (0, $3sQ5x.createHook)($39fc2da09b28cabf$var$Store);
const $39fc2da09b28cabf$export$54c70f22f548bff8 = ()=>{
    const [state, hookActions] = $39fc2da09b28cabf$var$useHook();
    const sidebarQueryParams = $39fc2da09b28cabf$export$ddc11e4d41e7cf62();
    const [, setQueryParams] = (0, $3hGWp.useQueryParams)(...sidebarQueryParams);
    const resetSidebarQueryParams = (0, $5uXOq.useCallback)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newQueryParams = sidebarQueryParams.reduce((acc, param)=>Object.assign(acc, {
                [param]: undefined
            }), {});
        setQueryParams(newQueryParams);
    }, [
        setQueryParams,
        sidebarQueryParams
    ]);
    return [
        state,
        {
            ...hookActions,
            resetSidebarQueryParams: resetSidebarQueryParams
        }
    ];
};

});
parcelRegister("hE5wF", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_RANK_SORTING_DIRECTION", () => $bfd6cbe4770149b5$export$8386e51ba415e85d);
$parcel$export(module.exports, "DEFAULT_AVATAR_RES", () => $bfd6cbe4770149b5$export$159fe44438c210e9);
$parcel$export(module.exports, "FILTER_PARAM", () => $bfd6cbe4770149b5$export$d8301e0b33832d94);
$parcel$export(module.exports, "INLINE_CREATE_PARAM", () => $bfd6cbe4770149b5$export$599c163c1570a353);
$parcel$export(module.exports, "INVITE_OPEN_PARAM", () => $bfd6cbe4770149b5$export$3a74d1a195d2f007);
$parcel$export(module.exports, "SELECTED_ISSUE_PARAM", () => $bfd6cbe4770149b5$export$c070acdc9b0f1be5);
$parcel$export(module.exports, "SELECTED_COMMENT_PARAM", () => $bfd6cbe4770149b5$export$3bcbd99d0f9ad6d8);
$parcel$export(module.exports, "GROUP_BY_ASSIGNEE", () => $bfd6cbe4770149b5$export$dba794af6c0f2afc);
$parcel$export(module.exports, "GROUP_BY_PRIORITY", () => $bfd6cbe4770149b5$export$56ecb5d2dfb80edc);
$parcel$export(module.exports, "GROUP_BY_CATEGORY", () => $bfd6cbe4770149b5$export$22ef551f315f2786);
$parcel$export(module.exports, "GROUP_BY_STATUS", () => $bfd6cbe4770149b5$export$6d69efb296b78a);
$parcel$export(module.exports, "START_DATE_ALIAS_FIELD_ID", () => $bfd6cbe4770149b5$export$e23e1d1ea45171c2);
$parcel$export(module.exports, "RANK_ALIAS_FIELD_ID", () => $bfd6cbe4770149b5$export$e35c6e217c75dc4b);
$parcel$export(module.exports, "REMOTE_ISSUE_LINKS_TYPE", () => $bfd6cbe4770149b5$export$e5eab344feb92af9);
$parcel$export(module.exports, "COMMENT_SUMMARY_TYPE", () => $bfd6cbe4770149b5$export$a311e1b78816c048);
$parcel$export(module.exports, "CARD_COVERS_TYPE", () => $bfd6cbe4770149b5$export$f5583ff4ab4d63e5);
$parcel$export(module.exports, "DEFAULT_PAGE_SIZE", () => $bfd6cbe4770149b5$export$5716e8bcb003888d);
$parcel$export(module.exports, "STORY_POINTS_ALIAS_FIELD_ID", () => $bfd6cbe4770149b5$export$1f9fb9f15184100f);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_ALIAS_FIELD_ID", () => $bfd6cbe4770149b5$export$c72ea455b368cdd9);
$parcel$export(module.exports, "UNASSIGNED_USER_ID", () => $bfd6cbe4770149b5$export$12e572fd459c10dc);

const $bfd6cbe4770149b5$export$8386e51ba415e85d = (0, $2a9e000a443b1a95$export$1dee026a19752d6b);
const $bfd6cbe4770149b5$export$159fe44438c210e9 = '48x48';
const $bfd6cbe4770149b5$export$d8301e0b33832d94 = 'filter';
const $bfd6cbe4770149b5$export$599c163c1570a353 = 'inlineCreate';
const $bfd6cbe4770149b5$export$3a74d1a195d2f007 = 'inviteOpen';
const $bfd6cbe4770149b5$export$e1e3f9fa6f04d6d = 'quickFilters';
const $bfd6cbe4770149b5$export$c070acdc9b0f1be5 = 'selectedIssue';
const $bfd6cbe4770149b5$export$3bcbd99d0f9ad6d8 = 'selectedComment';
const $bfd6cbe4770149b5$export$dba794af6c0f2afc = 'assignee';
const $bfd6cbe4770149b5$export$56ecb5d2dfb80edc = 'priority';
const $bfd6cbe4770149b5$export$22ef551f315f2786 = 'category';
const $bfd6cbe4770149b5$export$6d69efb296b78a = 'status';
const $bfd6cbe4770149b5$export$e23e1d1ea45171c2 = 'startdate';
const $bfd6cbe4770149b5$export$e35c6e217c75dc4b = 'rank';
const $bfd6cbe4770149b5$export$e5eab344feb92af9 = 'remoteIssueLinks';
const $bfd6cbe4770149b5$export$a311e1b78816c048 = 'commentsummary';
const $bfd6cbe4770149b5$export$f5583ff4ab4d63e5 = 'cardCovers';
const $bfd6cbe4770149b5$export$5716e8bcb003888d = 25;
const $bfd6cbe4770149b5$export$1f9fb9f15184100f = 'storypoints';
const $bfd6cbe4770149b5$export$c72ea455b368cdd9 = 'storypointestimate';
const $bfd6cbe4770149b5$export$786b42b4618e6ee4 = 'sprint';
const $bfd6cbe4770149b5$export$12e572fd459c10dc = 'unassigned';

});
const $2a9e000a443b1a95$export$1dee026a19752d6b = 'ASC';
const $2a9e000a443b1a95$export$b6abcf7fa1d94f65 = 'DESC';


parcelRegister("jnA4H", function(module, exports) {

$parcel$export(module.exports, "localStorage", () => $301038d04a64b539$export$c2ed3351cac403d1);
$parcel$export(module.exports, "getSidebarWidthFromStore", () => $301038d04a64b539$export$ff9cb331cac6c6b5);

var $bSSG7 = parcelRequire("bSSG7");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

const $301038d04a64b539$export$c2ed3351cac403d1 = (0, $bSSG7.createLocalStorageProvider)('jira_business_common');
const $301038d04a64b539$export$ff9cb331cac6c6b5 = (store)=>{
    if (store.sidebarWidth) return store.sidebarWidth;
    if ((0, $4R6GH.fg)('fix_reply_editor_width')) return 0, $55f230b510f63572$export$77e787f7c2e430e5;
    return (0, $dCm1o.isVisualRefreshEnabled)() ? (0, $55f230b510f63572$export$b16f75f2e0c3c029) : (0, $55f230b510f63572$export$2146fa818259227f);
};

});
const $55f230b510f63572$export$86880b4b2e1a2384 = 'jwm.sidebar';
const $55f230b510f63572$export$2146fa818259227f = 360;
const $55f230b510f63572$export$b16f75f2e0c3c029 = 435;
const $55f230b510f63572$export$77e787f7c2e430e5 = 463;



parcelRegister("lLfAu", function(module, exports) {

$parcel$export(module.exports, "SidebarLayout", () => $1dbab6fa0f2d1b51$export$8295a33ab8a36876);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $lmBAt = parcelRequire("lmBAt");

var $getxR = parcelRequire("getxR");

var $He4jn = parcelRequire("He4jn");

var $bUSNl = parcelRequire("bUSNl");

var $jnA4H = parcelRequire("jnA4H");

var $eHSp3 = parcelRequire("eHSp3");
const $1dbab6fa0f2d1b51$var$Sidebar = ({ children: children, sidebarWidth: sidebarWidth, theme: theme })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $1dbab6fa0f2d1b51$var$sidebarStyles,
            /* styles now for all project theming. remove || 'business' condition on nav4 has been fully rolled out and jira_theming_milestone_1 has been cleaned up */ (theme === 'business' || theme && (0, $lmBAt.getIsSoftwareThemingEnabled)()) && $1dbab6fa0f2d1b51$var$businessSidebarStyles
        ],
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            width: sidebarWidth
        }
    }, children);
};
const $1dbab6fa0f2d1b51$export$8295a33ab8a36876 = ({ children: children, theme: theme = 'business' })=>{
    (0, $getxR.useSidebarQueryParams)();
    const [store, { setSidebarContent: setSidebarContent }] = (0, $bUSNl.useSidebar)();
    const { content: content } = store;
    const sidebarWidth = (0, $jnA4H.getSidebarWidthFromStore)(store);
    const { onMouseDown: onMouseDown, isResizing: isResizing } = (0, $He4jn.useResizer)();
    // reset sidebar content on view unmount
    (0, $5uXOq.useEffect)(()=>()=>{
            setSidebarContent(null);
        }, [
        setSidebarContent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eHSp3.Wrapper), {
        isResizing: isResizing,
        "data-testid": "business-app-wrapper.ui.app-wrapper.sidebar-layout.sidebar-layout-wrapper"
    }, children, content && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1dbab6fa0f2d1b51$var$Sidebar, {
        sidebarWidth: sidebarWidth,
        theme: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eHSp3.ResizeHandle), {
        onMouseDown: onMouseDown
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eHSp3.SidebarContent), null, content)));
};
const $1dbab6fa0f2d1b51$var$sidebarStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'elevation.surface',
    flexGrow: 0,
    flexShrink: 0,
    position: 'relative',
    zIndex: 'card',
    maxWidth: '75%'
});
const $1dbab6fa0f2d1b51$var$businessSidebarStyles = (0, $8CUq3.xcss)({
    borderTopLeftRadius: 'border.radius.200',
    borderTopRightRadius: 'border.radius.200',
    boxShadow: 'elevation.shadow.overlay',
    marginRight: 'space.300',
    marginTop: 'space.300'
});

});
parcelRegister("getxR", function(module, exports) {

$parcel$export(module.exports, "useSidebarQueryParams", () => $7ddee5a34b903b90$export$34adbeffbeceba68);

var $5uXOq = parcelRequire("5uXOq");

var $hE5wF = parcelRequire("hE5wF");

var $1XJ20 = parcelRequire("1XJ20");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $3hGWp = parcelRequire("3hGWp");

var $bUSNl = parcelRequire("bUSNl");
const $7ddee5a34b903b90$var$isEscapeEvent = (e)=>e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
const $7ddee5a34b903b90$export$34adbeffbeceba68 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [{ content: content }, { setSidebarContent: setSidebarContent, resetSidebarQueryParams: resetSidebarQueryParams }] = (0, $bUSNl.useSidebar)();
    const sidebarQueryParams = (0, $bUSNl.getSidebarQueryParams)();
    const [queryParams, setQueryParams] = (0, $3hGWp.useQueryParams)(...sidebarQueryParams);
    const prevQueryParams = (0, $1XJ20.usePreviousWithInitial)(queryParams);
    const closeSidebar = (0, $5uXOq.useCallback)(()=>{
        // reset sidebar query params (IssueApp, Comments)
        resetSidebarQueryParams();
        // reset sidebar content
        setSidebarContent(null);
    }, [
        resetSidebarQueryParams,
        setSidebarContent
    ]);
    // keep only one sidebar-related query param at the time
    (0, $5uXOq.useEffect)(()=>{
        sidebarQueryParams.forEach((queryParam)=>{
            if (!prevQueryParams[queryParam] && queryParams[queryParam]) {
                const newQueryParams = sidebarQueryParams.filter((param)=>param !== queryParam).reduce((acc, param)=>Object.assign(acc, {
                        [param]: undefined
                    }), {});
                setQueryParams(newQueryParams);
            }
        });
    }, [
        prevQueryParams,
        queryParams,
        setQueryParams,
        sidebarQueryParams
    ]);
    // handle closing sidebar on Escape
    (0, $5uXOq.useEffect)(()=>{
        const handleKeydown = (event)=>{
            if (!queryParams[0, $hE5wF.SELECTED_ISSUE_PARAM]) // sidebar is not open, exit
            return;
            if (queryParams[0, $hE5wF.SELECTED_ISSUE_PARAM] && content?.key === 'unscheduledSidebar') // should not close the sidebar if the sidebar and modal is open
            return;
            if ($7ddee5a34b903b90$var$isEscapeEvent(event)) {
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'sidebar closed', 'esc');
                closeSidebar();
            }
        };
        typeof document !== 'undefined' && document.addEventListener('keydown', handleKeydown);
        return ()=>{
            typeof document !== 'undefined' && document.removeEventListener('keydown', handleKeydown);
        };
    }, [
        closeSidebar,
        content?.key,
        createAnalyticsEvent,
        queryParams
    ]);
};

});

parcelRegister("He4jn", function(module, exports) {

$parcel$export(module.exports, "useResizer", () => $80d7a99fb39f1e91$export$faede3f1542958fc);

var $5uXOq = parcelRequire("5uXOq");

var $34ck9 = parcelRequire("34ck9");

var $bUSNl = parcelRequire("bUSNl");

var $jnA4H = parcelRequire("jnA4H");
const $80d7a99fb39f1e91$var$THROTTLE_TIME = 16;
const $80d7a99fb39f1e91$export$faede3f1542958fc = ()=>{
    const [store, { setSidebarWidth: setSidebarWidth }] = (0, $bUSNl.useSidebar)();
    const sidebarWidth = (0, $jnA4H.getSidebarWidthFromStore)(store);
    const startRef = (0, $5uXOq.useRef)(0);
    // storing width in a ref to avoid re-creating onMouseMove handler during resize
    const width = (0, $5uXOq.useRef)(0);
    const [isResizing, setIsResizing] = (0, $5uXOq.useState)(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const resize = (0, $5uXOq.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($34ck9)))((clientX)=>{
        const proposedWidth = width.current + startRef.current - clientX;
        setSidebarWidth(proposedWidth);
    }, $80d7a99fb39f1e91$var$THROTTLE_TIME), [
        setSidebarWidth
    ]);
    const onMouseMove = (0, $5uXOq.useCallback)((event)=>{
        event.preventDefault();
        resize(event.clientX);
    }, [
        resize
    ]);
    const onMouseUp = (0, $5uXOq.useCallback)(()=>{
        startRef.current = 0;
        width.current = 0;
        setIsResizing(false);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.removeEventListener('mousemove', onMouseMove);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.removeEventListener('mouseup', onMouseUp);
    }, [
        onMouseMove
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.removeEventListener('mousemove', onMouseMove);
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.removeEventListener('mouseup', onMouseUp);
        }, [
        onMouseMove,
        onMouseUp
    ]);
    const onMouseDown = (0, $5uXOq.useCallback)((event)=>{
        startRef.current = event.clientX;
        width.current = sidebarWidth;
        setIsResizing(true);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('mousemove', onMouseMove);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('mouseup', onMouseUp);
    }, [
        onMouseMove,
        onMouseUp,
        sidebarWidth
    ]);
    return {
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseMove: onMouseMove,
        isResizing: isResizing
    };
};

});

parcelRegister("eHSp3", function(module, exports) {

$parcel$export(module.exports, "Wrapper", () => $71d20039839e60ab$export$e6dfd72ab29f8598);
$parcel$export(module.exports, "SidebarContent", () => $71d20039839e60ab$export$49e8f7b58a4df4ea);
$parcel$export(module.exports, "ResizeHandle", () => $71d20039839e60ab$export$33f2411a0ad35be7);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $71d20039839e60ab$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isResizing: isResizing, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _4cvr1fhb _4t3i1osq",
            __cmplp.isResizing ? "_80omuf7j" : "_80om73ad",
            __cmplp.className
        ])
    });
});
const $71d20039839e60ab$export$49e8f7b58a4df4ea = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18m91wug _13wustnw _1igsidpf _184nidpf _bhl91osq _ogwtu2gc _6tinidpf _1cezu2gc _m3zkidpf _134m1txw _sojr1h6o",
            __cmplp.className
        ])
    });
});
const $71d20039839e60ab$export$33f2411a0ad35be7 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bsb1tcg _80omuf7j _kqswh2mm _1wpz1fhb _1pbybfng _1ltvxmi2 _4t3i1osq _16r2glyw _qc5othzt _aetrb3bt _18postnw _z0aiyh40 _15l2idpf _19doutpp _1qdg1osq _gcm11p6i _4tpu1p6i",
            __cmplp.className
        ])
    });
});

});



parcelRegister("54aDJ", function(module, exports) {

$parcel$export(module.exports, "ConfluenceModalProvider", () => $80aa91d8ae783d16$export$465701d340b2a0fb);

var $5uXOq = parcelRequire("5uXOq");

var $i8Qvm = parcelRequire("i8Qvm");

var $bKinl = parcelRequire("bKinl");

var $3kWBc = parcelRequire("3kWBc");

var $hInrt = parcelRequire("hInrt");

var $7X77D = parcelRequire("7X77D");
const $80aa91d8ae783d16$export$465701d340b2a0fb = ({ children: children })=>{
    const viewModalControlNew = (0, $hInrt.useConfluenceViewModalNew)();
    const { createModalProps: createModalProps, showCreatePage: showCreatePage, hideCreatePage: hideCreatePage } = (0, $hInrt.useConfluenceCreatePageModal)();
    const confluenceContext = (0, $5uXOq.useMemo)(()=>({
            showConfluencePage: viewModalControlNew.showConfluencePage,
            showCreatePage: showCreatePage
        }), [
        viewModalControlNew.showConfluencePage,
        showCreatePage
    ]);
    const { confluencePageUrl: confluencePageUrl, viewMode: viewMode, onCloseCompleteCallback: onCloseCompleteCallback } = viewModalControlNew.viewModalProps;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bKinl.confluencePagesContext).Provider, {
        value: confluenceContext
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, confluencePageUrl != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7X77D.default), {
        onClose: viewModalControlNew.hideConfluencePage,
        confluenceUrl: confluencePageUrl || '',
        mode: viewMode,
        onCloseComplete: onCloseCompleteCallback,
        isOpen: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3kWBc.default), {
        onClose: hideCreatePage,
        ...createModalProps
    }));
};

});
parcelRegister("bKinl", function(module, exports) {

$parcel$export(module.exports, "confluencePagesContext", () => $2f6ddafdd32c5a4c$export$4cb8e522e2ecb030);
$parcel$export(module.exports, "useConfluencePagesModals", () => $2f6ddafdd32c5a4c$export$750ed67ce7764287);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");
const $2f6ddafdd32c5a4c$export$4cb8e522e2ecb030 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    showConfluencePage: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    showCreatePage: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
});
const $2f6ddafdd32c5a4c$export$750ed67ce7764287 = ()=>{
    const context = (0, $5uXOq.useContext)($2f6ddafdd32c5a4c$export$4cb8e522e2ecb030);
    const { showConfluencePage: showConfluencePage, showCreatePage: showCreatePage } = context;
    return {
        showConfluencePage: showConfluencePage,
        showCreatePage: showCreatePage
    };
};

});

parcelRegister("3kWBc", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0652eb4cfa0c28f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d0652eb4cfa0c28f$var$LazyCreatePage = (0, $kxZPA.lazy)(()=>(parcelRequire("2sZT1")), {
    ssr: false,
    moduleId: "./src/packages/business/shared/components/confluence-pages/src/ui/confluence-view-modal/create-page-modal/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d0652eb4cfa0c28f$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "create-page-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d0652eb4cfa0c28f$var$LazyCreatePage, props));

});
parcelRegister("2sZT1", function(module, exports) {

let $1cbe33a4a1964bec$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1cbe33a4a1964bec$var$load("3qpkO").then(()=>parcelRequire('5mDXx'));

});


parcelRegister("hInrt", function(module, exports) {

$parcel$export(module.exports, "useConfluenceCreatePageModal", () => $ee59ca0344a0436e$export$81799af04beb008f);
$parcel$export(module.exports, "useConfluenceViewModalNew", () => $ee59ca0344a0436e$export$3cac20211c8788d8);

var $5uXOq = parcelRequire("5uXOq");

var $gVnoy = parcelRequire("gVnoy");

var $2NMNM = parcelRequire("2NMNM");

var $8zOmE = parcelRequire("8zOmE");
const $ee59ca0344a0436e$export$81799af04beb008f = ()=>{
    const [createModalProps, setCreateModalProps] = (0, $5uXOq.useState)({
        showCreateModal: false,
        onCreate: undefined
    });
    const showCreatePage = (0, $5uXOq.useCallback)(({ onCreate: onCreate, onCloseComplete: onCloseComplete, onCancel: onCancel } = {})=>setCreateModalProps({
            showCreateModal: true,
            onCreate: onCreate,
            onCloseComplete: onCloseComplete,
            onCancel: onCancel
        }), []);
    const hideCreatePage = (0, $5uXOq.useCallback)(()=>setCreateModalProps({
            showCreateModal: false,
            onCreate: undefined
        }), []);
    return {
        createModalProps: createModalProps,
        showCreatePage: showCreatePage,
        hideCreatePage: hideCreatePage
    };
};
const $ee59ca0344a0436e$export$3cac20211c8788d8 = ()=>{
    const [viewModalProps, setViewModalProps] = (0, $5uXOq.useState)({
        confluencePageUrl: null,
        viewMode: (0, $gVnoy.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
        onCloseCompleteCallback: undefined
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const showConfluencePage = (0, $5uXOq.useCallback)(({ confluenceUrl: confluenceUrl, mode: mode, onCloseComplete: onCloseComplete })=>{
        setViewModalProps({
            confluencePageUrl: confluenceUrl,
            viewMode: mode || (0, $gVnoy.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
            onCloseCompleteCallback: onCloseComplete
        });
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'jwmConfluenceModal viewed');
    }, [
        createAnalyticsEvent
    ]);
    /**
	 * Sets the modal props state back to a default state, which will cause the modal to close
	 *
	 * NOTE: There's a [StrictMode](https://react.dev/reference/react/StrictMode) bug using the
	 * `onCloseCompleteCallback` prop on `@atlaskit/modal-dialog`. This issue has been raised with the
	 * Design System team in the following [thread](https://atlassian.slack.com/archives/CFJ9DU39U/p1715670965075749).
	 * StrictMode is enabled by default in local development so this will not work in local dev
	 * until fixed but works in production.
	 */ const hideConfluencePage = (0, $5uXOq.useCallback)(()=>{
        setViewModalProps({
            confluencePageUrl: null,
            viewMode: (0, $gVnoy.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
            onCloseCompleteCallback: undefined
        });
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'jwmConfluenceModal closed');
    }, [
        createAnalyticsEvent
    ]);
    return {
        viewModalProps: viewModalProps,
        showConfluencePage: showConfluencePage,
        hideConfluencePage: hideConfluencePage
    };
};

});

parcelRegister("7X77D", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3e7a84b08712e0f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $a3e7a84b08712e0f$var$LazyConfluenceViewModal = (0, $kxZPA.lazy)(()=>(parcelRequire("5C3Dz")), {
    ssr: false,
    moduleId: "./src/packages/business/shared/components/confluence-pages/src/ui/confluence-view-modal/view-page-modal/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a3e7a84b08712e0f$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "view-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3e7a84b08712e0f$var$LazyConfluenceViewModal, props));

});
parcelRegister("5C3Dz", function(module, exports) {

let $416352a0bba24906$var$load = (parcelRequire("28QjX"))(4);
module.exports = $416352a0bba24906$var$load("5knyw").then(()=>parcelRequire('17Ef1'));

});



parcelRegister("imVeH", function(module, exports) {

$parcel$export(module.exports, "useTenantHasConfluence", () => $734552c5f3b177b5$export$964fe2dd9242a588);

var $4Pf62 = parcelRequire("4Pf62");

var $hqBSi = parcelRequire("hqBSi");
const $734552c5f3b177b5$export$964fe2dd9242a588 = ()=>{
    const licensedProducts = (0, $hqBSi.useLicensedProducts)();
    return Boolean(licensedProducts[(0, $4Pf62.LICENSED_PRODUCTS).CONFLUENCE]);
};

});

parcelRegister("adJfs", function(module, exports) {

$parcel$export(module.exports, "IssueTypesAndFieldsContext", () => $1c25c33c14b14fda$export$31eaf35dc72d0fa0);

var $5uXOq = parcelRequire("5uXOq");

var $5tTFS = parcelRequire("5tTFS");

var $gKZoD = parcelRequire("gKZoD");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $1T2vX = parcelRequire("1T2vX");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $1c25c33c14b14fda$var$noop = ()=>{};
// track Apollo cache watchers 1 sec after availableFields query finishes to make sure UI is fully rendered
const $1c25c33c14b14fda$var$TRACKING_TIMEOUT = 1000;
const $1c25c33c14b14fda$export$31eaf35dc72d0fa0 = ({ children: children })=>{
    (0, $gKZoD.di)(setTimeout);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const client = (0, $5tTFS.useApolloClient)();
    const IssueTypesAndFieldsViewContextProps = (0, $1T2vX.useIssueTypesAndFieldsService)({
        issueOperation: 'VIEW'
    });
    const IssueTypesAndFieldsCreateContextProps = (0, $1T2vX.useIssueTypesAndFieldsService)({
        issueOperation: 'CREATE'
    });
    const loading = IssueTypesAndFieldsViewContextProps.loading || IssueTypesAndFieldsCreateContextProps.loading;
    (0, $5uXOq.useEffect)(()=>{
        if (loading) return $1c25c33c14b14fda$var$noop;
        const timeoutId = setTimeout(()=>{
            // tracking the number of Apollo cache watches
            // the lower the number, the faster UI
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'apolloCacheWatches created', {
                // @ts-expect-error - TS2551 - Property 'watches' does not exist on type 'ApolloCache<object>'. Did you mean 'watch'?
                watches: client?.cache?.watches?.size
            });
        }, $1c25c33c14b14fda$var$TRACKING_TIMEOUT);
        return ()=>{
            if (timeoutId) clearTimeout(timeoutId);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        createAnalyticsEvent,
        loading
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1T2vX.IssueTypesAndFieldsContextView).Provider, {
        value: IssueTypesAndFieldsViewContextProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1T2vX.IssueTypesAndFieldsContextCreate).Provider, {
        value: IssueTypesAndFieldsCreateContextProps
    }, children));
};

});
parcelRegister("5tTFS", function(module, exports) {

$parcel$export(module.exports, "useQuery", () => $3fdad8fd02cd9507$export$dd0a697e1782aedd);
$parcel$export(module.exports, "useLazyQuery", () => $3fdad8fd02cd9507$export$fd83eea6ecd2d8fa);
$parcel$export(module.exports, "useMutation", () => $3fdad8fd02cd9507$export$609860bf8b0084c);
$parcel$export(module.exports, "useApolloClient", () => $3fdad8fd02cd9507$export$eb9a56e7a29e494);

var $bvsgq = parcelRequire("bvsgq");

var $3VFsf = parcelRequire("3VFsf");

var $5uXOq = parcelRequire("5uXOq");

var $e3a3O = parcelRequire("e3a3O");

var $bqMzA = parcelRequire("bqMzA");

var $1DiV8 = parcelRequire("1DiV8");
var $3fdad8fd02cd9507$var$OperationData = function() {
    function OperationData(options, context) {
        this.isMounted = false;
        this.previousOptions = {};
        this.context = {};
        this.options = {};
        this.options = options || {};
        this.context = context || {};
    }
    OperationData.prototype.getOptions = function() {
        return this.options;
    };
    OperationData.prototype.setOptions = function(newOptions, storePrevious) {
        if (storePrevious === void 0) storePrevious = false;
        if (storePrevious && !(0, $bqMzA.equal)(this.options, newOptions)) this.previousOptions = this.options;
        this.options = newOptions;
    };
    OperationData.prototype.unmount = function() {
        this.isMounted = false;
    };
    OperationData.prototype.refreshClient = function() {
        var client = this.options && this.options.client || this.context && this.context.client;
        (0, $1DiV8.invariant)(!!client, 2);
        var isNew = false;
        if (client !== this.client) {
            isNew = true;
            this.client = client;
            this.cleanup();
        }
        return {
            client: this.client,
            isNew: isNew
        };
    };
    OperationData.prototype.verifyDocumentType = function(document, type) {
        var operation = (0, $bvsgq.parser)(document);
        var requiredOperationName = (0, $bvsgq.operationName)(type);
        var usedOperationName = (0, $bvsgq.operationName)(operation.type);
        (0, $1DiV8.invariant)(operation.type === type, 3);
    };
    return OperationData;
}();
var $3fdad8fd02cd9507$var$QueryData = function(_super) {
    (0, $3VFsf.__extends)(QueryData, _super);
    function QueryData(_a) {
        var options = _a.options, context = _a.context, forceUpdate = _a.forceUpdate;
        var _this = _super.call(this, options, context) || this;
        _this.previousData = {};
        _this.currentObservable = {};
        _this.runLazy = false;
        _this.runLazyQuery = function(options) {
            _this.cleanup();
            _this.runLazy = true;
            _this.lazyOptions = options;
            _this.forceUpdate();
        };
        _this.getExecuteResult = function() {
            var result = _this.getQueryResult();
            _this.startQuerySubscription();
            return result;
        };
        _this.obsRefetch = function(variables) {
            return _this.currentObservable.query.refetch(variables);
        };
        _this.obsFetchMore = function(fetchMoreOptions) {
            return _this.currentObservable.query.fetchMore(fetchMoreOptions);
        };
        _this.obsUpdateQuery = function(mapFn) {
            return _this.currentObservable.query.updateQuery(mapFn);
        };
        _this.obsStartPolling = function(pollInterval) {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.startPolling(pollInterval);
        };
        _this.obsStopPolling = function() {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.stopPolling();
        };
        _this.obsSubscribeToMore = function(options) {
            return _this.currentObservable.query.subscribeToMore(options);
        };
        _this.forceUpdate = forceUpdate;
        return _this;
    }
    QueryData.prototype.execute = function() {
        this.refreshClient();
        var _a = this.getOptions(), skip = _a.skip, query = _a.query;
        if (skip || query !== this.previousData.query) {
            this.removeQuerySubscription();
            this.previousData.query = query;
        }
        this.updateObservableQuery();
        if (this.isMounted) this.startQuerySubscription();
        return this.getExecuteSsrResult() || this.getExecuteResult();
    };
    QueryData.prototype.executeLazy = function() {
        return !this.runLazy ? [
            this.runLazyQuery,
            {
                loading: false,
                networkStatus: (0, $e3a3O.NetworkStatus).ready,
                called: false,
                data: undefined
            }
        ] : [
            this.runLazyQuery,
            this.execute()
        ];
    };
    QueryData.prototype.fetchData = function() {
        var options = this.getOptions();
        if (options.skip || options.ssr === false) return false;
        var obs = this.currentObservable.query;
        var currentResult = obs.getCurrentResult();
        return currentResult.loading ? obs.result() : false;
    };
    QueryData.prototype.afterExecute = function(_a) {
        var _this = this;
        var _b = (_a === void 0 ? {} : _a).lazy, lazy = _b === void 0 ? false : _b;
        this.isMounted = true;
        if (!lazy || this.runLazy) {
            this.handleErrorOrCompleted();
            setTimeout(function() {
                _this.currentObservable.query && _this.currentObservable.query.resetQueryStoreErrors();
            });
        }
        this.previousOptions = this.getOptions();
        return this.unmount.bind(this);
    };
    QueryData.prototype.cleanup = function() {
        this.removeQuerySubscription();
        delete this.currentObservable.query;
        delete this.previousData.result;
    };
    QueryData.prototype.getOptions = function() {
        var options = _super.prototype.getOptions.call(this);
        if (this.lazyOptions) {
            options.variables = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options.variables), this.lazyOptions.variables);
            options.context = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options.context), this.lazyOptions.context);
        }
        if (this.runLazy) delete options.skip;
        return options;
    };
    QueryData.prototype.getExecuteSsrResult = function() {
        var treeRenderingInitiated = this.context && this.context.renderPromises;
        var ssrDisabled = this.getOptions().ssr === false;
        var fetchDisabled = this.refreshClient().client.disableNetworkFetches;
        var ssrLoading = {
            loading: true,
            networkStatus: (0, $e3a3O.NetworkStatus).loading,
            called: true,
            data: undefined
        };
        if (ssrDisabled && (treeRenderingInitiated || fetchDisabled)) return ssrLoading;
        var result;
        if (treeRenderingInitiated) result = this.context.renderPromises.addQueryPromise(this, this.getExecuteResult) || ssrLoading;
        return result;
    };
    QueryData.prototype.prepareObservableQueryOptions = function() {
        var options = this.getOptions();
        this.verifyDocumentType(options.query, (0, $bvsgq.DocumentType).Query);
        var displayName = options.displayName || 'Query';
        if (this.context && this.context.renderPromises && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options.fetchPolicy = 'cache-first';
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
            displayName: displayName,
            context: options.context,
            metadata: {
                reactComponent: {
                    displayName: displayName
                }
            }
        });
    };
    QueryData.prototype.initializeObservableQuery = function() {
        if (this.context && this.context.renderPromises) this.currentObservable.query = this.context.renderPromises.getSSRObservable(this.getOptions());
        if (!this.currentObservable.query) {
            var observableQueryOptions = this.prepareObservableQueryOptions();
            this.previousData.observableQueryOptions = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, observableQueryOptions), {
                children: null
            });
            this.currentObservable.query = this.refreshClient().client.watchQuery((0, $3VFsf.__assign)({}, observableQueryOptions));
            if (this.context && this.context.renderPromises) this.context.renderPromises.registerSSRObservable(this.currentObservable.query, observableQueryOptions);
        }
    };
    QueryData.prototype.updateObservableQuery = function() {
        if (!this.currentObservable.query) {
            this.initializeObservableQuery();
            return;
        }
        var newObservableQueryOptions = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.prepareObservableQueryOptions()), {
            children: null
        });
        if (!(0, $bqMzA.equal)(newObservableQueryOptions, this.previousData.observableQueryOptions)) {
            this.previousData.observableQueryOptions = newObservableQueryOptions;
            this.currentObservable.query.setOptions(newObservableQueryOptions).catch(function() {});
        }
    };
    QueryData.prototype.startQuerySubscription = function() {
        var _this = this;
        if (this.currentObservable.subscription || this.getOptions().skip) return;
        var obsQuery = this.currentObservable.query;
        this.currentObservable.subscription = obsQuery.subscribe({
            next: function(_a) {
                var loading = _a.loading, networkStatus = _a.networkStatus, data = _a.data;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading === loading && previousResult.networkStatus === networkStatus && (0, $bqMzA.equal)(previousResult.data, data)) return;
                _this.forceUpdate();
            },
            error: function(error) {
                _this.resubscribeToQuery();
                if (!error.hasOwnProperty('graphQLErrors')) throw error;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading || !(0, $bqMzA.equal)(error, _this.previousData.error)) {
                    _this.previousData.error = error;
                    _this.forceUpdate();
                }
            }
        });
    };
    QueryData.prototype.resubscribeToQuery = function() {
        this.removeQuerySubscription();
        var lastError = this.currentObservable.query.getLastError();
        var lastResult = this.currentObservable.query.getLastResult();
        this.currentObservable.query.resetLastResults();
        this.startQuerySubscription();
        Object.assign(this.currentObservable.query, {
            lastError: lastError,
            lastResult: lastResult
        });
    };
    QueryData.prototype.getQueryResult = function() {
        var result = this.observableQueryFields();
        var options = this.getOptions();
        if (options.skip) result = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, result), {
            data: undefined,
            error: undefined,
            loading: false,
            called: true
        });
        else {
            var currentResult = this.currentObservable.query.getCurrentResult();
            var loading = currentResult.loading, partial = currentResult.partial, networkStatus = currentResult.networkStatus, errors = currentResult.errors;
            var error = currentResult.error, data = currentResult.data;
            if (errors && errors.length > 0) error = new (0, $e3a3O.ApolloError)({
                graphQLErrors: errors
            });
            result = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, result), {
                loading: loading,
                networkStatus: networkStatus,
                error: error,
                called: true
            });
            if (loading) {
                var previousData = this.previousData.result && this.previousData.result.data;
                result.data = previousData && data ? (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, previousData), data) : previousData || data;
            } else if (error) Object.assign(result, {
                data: (this.currentObservable.query.getLastResult() || {}).data
            });
            else {
                var fetchPolicy = this.currentObservable.query.options.fetchPolicy;
                var partialRefetch = options.partialRefetch;
                if (partialRefetch && !data && partial && fetchPolicy !== 'cache-only') {
                    Object.assign(result, {
                        loading: true,
                        networkStatus: (0, $e3a3O.NetworkStatus).loading
                    });
                    result.refetch();
                    return result;
                }
                result.data = data;
            }
        }
        result.client = this.client;
        this.previousData.loading = this.previousData.result && this.previousData.result.loading || false;
        this.previousData.result = result;
        return result;
    };
    QueryData.prototype.handleErrorOrCompleted = function() {
        var obsQuery = this.currentObservable.query;
        if (!obsQuery) return;
        var _a = obsQuery.getCurrentResult(), data = _a.data, loading = _a.loading, error = _a.error;
        if (!loading) {
            var _b = this.getOptions(), query = _b.query, variables = _b.variables, onCompleted = _b.onCompleted, onError = _b.onError;
            if (this.previousOptions && !this.previousData.loading && (0, $bqMzA.equal)(this.previousOptions.query, query) && (0, $bqMzA.equal)(this.previousOptions.variables, variables)) return;
            if (onCompleted && !error) onCompleted(data);
            else if (onError && error) onError(error);
        }
    };
    QueryData.prototype.removeQuerySubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    QueryData.prototype.observableQueryFields = function() {
        var observable = this.currentObservable.query;
        return {
            variables: observable.variables,
            refetch: this.obsRefetch,
            fetchMore: this.obsFetchMore,
            updateQuery: this.obsUpdateQuery,
            startPolling: this.obsStartPolling,
            stopPolling: this.obsStopPolling,
            subscribeToMore: this.obsSubscribeToMore
        };
    };
    return QueryData;
}($3fdad8fd02cd9507$var$OperationData);
function $3fdad8fd02cd9507$var$useDeepMemo(memoFn, key) {
    var ref = (0, $5uXOq.useRef)();
    if (!ref.current || !(0, $bqMzA.equal)(key, ref.current.key)) ref.current = {
        key: key,
        value: memoFn()
    };
    return ref.current.value;
}
function $3fdad8fd02cd9507$var$useBaseQuery(query, options, lazy) {
    if (lazy === void 0) lazy = false;
    var context = (0, $5uXOq.useContext)((0, $bvsgq.getApolloContext)());
    var _a = (0, $5uXOq.useReducer)(function(x) {
        return x + 1;
    }, 0), tick = _a[0], forceUpdate = _a[1];
    var updatedOptions = options ? (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
        query: query
    }) : {
        query: query
    };
    var queryDataRef = (0, $5uXOq.useRef)();
    if (!queryDataRef.current) queryDataRef.current = new $3fdad8fd02cd9507$var$QueryData({
        options: updatedOptions,
        context: context,
        forceUpdate: forceUpdate
    });
    var queryData = queryDataRef.current;
    queryData.setOptions(updatedOptions);
    queryData.context = context;
    var memo = {
        options: (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, updatedOptions), {
            onError: undefined,
            onCompleted: undefined
        }),
        context: context,
        tick: tick
    };
    var result = $3fdad8fd02cd9507$var$useDeepMemo(function() {
        return lazy ? queryData.executeLazy() : queryData.execute();
    }, memo);
    var queryResult = lazy ? result[1] : result;
    (0, $5uXOq.useEffect)(function() {
        return queryData.afterExecute({
            lazy: lazy
        });
    }, [
        queryResult.loading,
        queryResult.networkStatus,
        queryResult.error,
        queryResult.data
    ]);
    (0, $5uXOq.useEffect)(function() {
        return function() {
            return queryData.cleanup();
        };
    }, []);
    return result;
}
function $3fdad8fd02cd9507$export$dd0a697e1782aedd(query, options) {
    return $3fdad8fd02cd9507$var$useBaseQuery(query, options, false);
}
function $3fdad8fd02cd9507$export$fd83eea6ecd2d8fa(query, options) {
    return $3fdad8fd02cd9507$var$useBaseQuery(query, options, true);
}
var $3fdad8fd02cd9507$var$MutationData = function(_super) {
    (0, $3VFsf.__extends)(MutationData, _super);
    function MutationData(_a) {
        var options = _a.options, context = _a.context, result = _a.result, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.runMutation = function(mutationFunctionOptions) {
            if (mutationFunctionOptions === void 0) mutationFunctionOptions = {};
            _this.onMutationStart();
            var mutationId = _this.generateNewMutationId();
            return _this.mutate(mutationFunctionOptions).then(function(response) {
                _this.onMutationCompleted(response, mutationId);
                return response;
            }).catch(function(error) {
                _this.onMutationError(error, mutationId);
                if (!_this.getOptions().onError) throw error;
            });
        };
        _this.verifyDocumentType(options.mutation, (0, $bvsgq.DocumentType).Mutation);
        _this.result = result;
        _this.setResult = setResult;
        _this.mostRecentMutationId = 0;
        return _this;
    }
    MutationData.prototype.execute = function(result) {
        this.isMounted = true;
        this.verifyDocumentType(this.getOptions().mutation, (0, $bvsgq.DocumentType).Mutation);
        result.client = this.refreshClient().client;
        return [
            this.runMutation,
            result
        ];
    };
    MutationData.prototype.afterExecute = function() {
        this.isMounted = true;
        return this.unmount.bind(this);
    };
    MutationData.prototype.cleanup = function() {};
    MutationData.prototype.mutate = function(mutationFunctionOptions) {
        var _a = this.getOptions(), mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, update = _a.update, _b = _a.context, mutationContext = _b === void 0 ? {} : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, fetchPolicy = _a.fetchPolicy;
        var mutateOptions = (0, $3VFsf.__assign)({}, mutationFunctionOptions);
        var mutateVariables = Object.assign({}, variables, mutateOptions.variables);
        delete mutateOptions.variables;
        return this.refreshClient().client.mutate((0, $3VFsf.__assign)({
            mutation: mutation,
            optimisticResponse: optimisticResponse,
            refetchQueries: mutateOptions.refetchQueries || this.getOptions().refetchQueries,
            awaitRefetchQueries: awaitRefetchQueries,
            update: update,
            context: mutationContext,
            fetchPolicy: fetchPolicy,
            variables: mutateVariables
        }, mutateOptions));
    };
    MutationData.prototype.onMutationStart = function() {
        if (!this.result.loading && !this.getOptions().ignoreResults) this.updateResult({
            loading: true,
            error: undefined,
            data: undefined,
            called: true
        });
    };
    MutationData.prototype.onMutationCompleted = function(response, mutationId) {
        var _a = this.getOptions(), onCompleted = _a.onCompleted, ignoreResults = _a.ignoreResults;
        var data = response.data, errors = response.errors;
        var error = errors && errors.length > 0 ? new (0, $e3a3O.ApolloError)({
            graphQLErrors: errors
        }) : undefined;
        var callOncomplete = function() {
            return onCompleted ? onCompleted(data) : null;
        };
        if (this.isMostRecentMutation(mutationId) && !ignoreResults) this.updateResult({
            called: true,
            loading: false,
            data: data,
            error: error
        });
        callOncomplete();
    };
    MutationData.prototype.onMutationError = function(error, mutationId) {
        var onError = this.getOptions().onError;
        if (this.isMostRecentMutation(mutationId)) this.updateResult({
            loading: false,
            error: error,
            data: undefined,
            called: true
        });
        if (onError) onError(error);
    };
    MutationData.prototype.generateNewMutationId = function() {
        return ++this.mostRecentMutationId;
    };
    MutationData.prototype.isMostRecentMutation = function(mutationId) {
        return this.mostRecentMutationId === mutationId;
    };
    MutationData.prototype.updateResult = function(result) {
        if (this.isMounted && (!this.previousResult || !(0, $bqMzA.equal)(this.previousResult, result))) {
            this.setResult(result);
            this.previousResult = result;
        }
    };
    return MutationData;
}($3fdad8fd02cd9507$var$OperationData);
function $3fdad8fd02cd9507$export$609860bf8b0084c(mutation, options) {
    var context = (0, $5uXOq.useContext)((0, $bvsgq.getApolloContext)());
    var _a = (0, $5uXOq.useState)({
        called: false,
        loading: false
    }), result = _a[0], setResult = _a[1];
    var updatedOptions = options ? (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
        mutation: mutation
    }) : {
        mutation: mutation
    };
    var mutationDataRef = (0, $5uXOq.useRef)();
    function getMutationDataRef() {
        if (!mutationDataRef.current) mutationDataRef.current = new $3fdad8fd02cd9507$var$MutationData({
            options: updatedOptions,
            context: context,
            result: result,
            setResult: setResult
        });
        return mutationDataRef.current;
    }
    var mutationData = getMutationDataRef();
    mutationData.setOptions(updatedOptions);
    mutationData.context = context;
    (0, $5uXOq.useEffect)(function() {
        return mutationData.afterExecute();
    });
    return mutationData.execute(result);
}
var $3fdad8fd02cd9507$var$SubscriptionData = function(_super) {
    (0, $3VFsf.__extends)(SubscriptionData, _super);
    function SubscriptionData(_a) {
        var options = _a.options, context = _a.context, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.currentObservable = {};
        _this.setResult = setResult;
        _this.initialize(options);
        return _this;
    }
    SubscriptionData.prototype.execute = function(result) {
        if (this.getOptions().skip === true) {
            this.cleanup();
            return {
                loading: false,
                error: undefined,
                data: undefined,
                variables: this.getOptions().variables
            };
        }
        var currentResult = result;
        if (this.refreshClient().isNew) currentResult = this.getLoadingResult();
        var shouldResubscribe = this.getOptions().shouldResubscribe;
        if (typeof shouldResubscribe === 'function') shouldResubscribe = !!shouldResubscribe(this.getOptions());
        if (shouldResubscribe !== false && this.previousOptions && Object.keys(this.previousOptions).length > 0 && (this.previousOptions.subscription !== this.getOptions().subscription || !(0, $bqMzA.equal)(this.previousOptions.variables, this.getOptions().variables) || this.previousOptions.skip !== this.getOptions().skip)) {
            this.cleanup();
            currentResult = this.getLoadingResult();
        }
        this.initialize(this.getOptions());
        this.startSubscription();
        this.previousOptions = this.getOptions();
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, currentResult), {
            variables: this.getOptions().variables
        });
    };
    SubscriptionData.prototype.afterExecute = function() {
        this.isMounted = true;
    };
    SubscriptionData.prototype.cleanup = function() {
        this.endSubscription();
        delete this.currentObservable.query;
    };
    SubscriptionData.prototype.initialize = function(options) {
        if (this.currentObservable.query || this.getOptions().skip === true) return;
        this.currentObservable.query = this.refreshClient().client.subscribe({
            query: options.subscription,
            variables: options.variables,
            fetchPolicy: options.fetchPolicy
        });
    };
    SubscriptionData.prototype.startSubscription = function() {
        if (this.currentObservable.subscription) return;
        this.currentObservable.subscription = this.currentObservable.query.subscribe({
            next: this.updateCurrentData.bind(this),
            error: this.updateError.bind(this),
            complete: this.completeSubscription.bind(this)
        });
    };
    SubscriptionData.prototype.getLoadingResult = function() {
        return {
            loading: true,
            error: undefined,
            data: undefined
        };
    };
    SubscriptionData.prototype.updateResult = function(result) {
        if (this.isMounted) this.setResult(result);
    };
    SubscriptionData.prototype.updateCurrentData = function(result) {
        var onSubscriptionData = this.getOptions().onSubscriptionData;
        this.updateResult({
            data: result.data,
            loading: false,
            error: undefined
        });
        if (onSubscriptionData) onSubscriptionData({
            client: this.refreshClient().client,
            subscriptionData: result
        });
    };
    SubscriptionData.prototype.updateError = function(error) {
        this.updateResult({
            error: error,
            loading: false
        });
    };
    SubscriptionData.prototype.completeSubscription = function() {
        var onSubscriptionComplete = this.getOptions().onSubscriptionComplete;
        if (onSubscriptionComplete) onSubscriptionComplete();
        this.endSubscription();
    };
    SubscriptionData.prototype.endSubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    return SubscriptionData;
}($3fdad8fd02cd9507$var$OperationData);
function $3fdad8fd02cd9507$export$368b4214baeb914c(subscription, options) {
    var context = (0, $5uXOq.useContext)((0, $bvsgq.getApolloContext)());
    var updatedOptions = options ? (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
        subscription: subscription
    }) : {
        subscription: subscription
    };
    var _a = (0, $5uXOq.useState)({
        loading: !updatedOptions.skip,
        error: undefined,
        data: undefined
    }), result = _a[0], setResult = _a[1];
    var subscriptionDataRef = (0, $5uXOq.useRef)();
    function getSubscriptionDataRef() {
        if (!subscriptionDataRef.current) subscriptionDataRef.current = new $3fdad8fd02cd9507$var$SubscriptionData({
            options: updatedOptions,
            context: context,
            setResult: setResult
        });
        return subscriptionDataRef.current;
    }
    var subscriptionData = getSubscriptionDataRef();
    subscriptionData.setOptions(updatedOptions, true);
    subscriptionData.context = context;
    (0, $5uXOq.useEffect)(function() {
        return subscriptionData.afterExecute();
    });
    (0, $5uXOq.useEffect)(function() {
        return subscriptionData.cleanup.bind(subscriptionData);
    }, []);
    return subscriptionData.execute(result);
}
function $3fdad8fd02cd9507$export$eb9a56e7a29e494() {
    var client = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext((0, $bvsgq.getApolloContext)()).client;
    (0, $1DiV8.invariant)(client, 1);
    return client;
}
function $3fdad8fd02cd9507$var$makeDefaultQueryInfo() {
    return {
        seen: false,
        observable: null
    };
}
var $3fdad8fd02cd9507$export$260e90e395a79974 = function() {
    function RenderPromises() {
        this.queryPromises = new Map();
        this.queryInfoTrie = new Map();
    }
    RenderPromises.prototype.registerSSRObservable = function(observable, props) {
        this.lookupQueryInfo(props).observable = observable;
    };
    RenderPromises.prototype.getSSRObservable = function(props) {
        return this.lookupQueryInfo(props).observable;
    };
    RenderPromises.prototype.addQueryPromise = function(queryInstance, finish) {
        var info = this.lookupQueryInfo(queryInstance.getOptions());
        if (!info.seen) {
            this.queryPromises.set(queryInstance.getOptions(), new Promise(function(resolve) {
                resolve(queryInstance.fetchData());
            }));
            return null;
        }
        return finish();
    };
    RenderPromises.prototype.hasPromises = function() {
        return this.queryPromises.size > 0;
    };
    RenderPromises.prototype.consumeAndAwaitPromises = function() {
        var _this = this;
        var promises = [];
        this.queryPromises.forEach(function(promise, queryInstance) {
            _this.lookupQueryInfo(queryInstance).seen = true;
            promises.push(promise);
        });
        this.queryPromises.clear();
        return Promise.all(promises);
    };
    RenderPromises.prototype.lookupQueryInfo = function(props) {
        var queryInfoTrie = this.queryInfoTrie;
        var query = props.query, variables = props.variables;
        var varMap = queryInfoTrie.get(query) || new Map();
        if (!queryInfoTrie.has(query)) queryInfoTrie.set(query, varMap);
        var variablesString = JSON.stringify(variables);
        var info = varMap.get(variablesString) || $3fdad8fd02cd9507$var$makeDefaultQueryInfo();
        if (!varMap.has(variablesString)) varMap.set(variablesString, info);
        return info;
    };
    return RenderPromises;
}();

});

parcelRegister("1T2vX", function(module, exports) {

$parcel$export(module.exports, "useIssueTypesAndFieldsService", () => $90cf08abf5e3ede7$export$3ef3324b7f7d6a38);
$parcel$export(module.exports, "IssueTypesAndFieldsContextView", () => $90cf08abf5e3ede7$export$77937175321fab39);
$parcel$export(module.exports, "IssueTypesAndFieldsContextCreate", () => $90cf08abf5e3ede7$export$fbd286e14113bfc);
$parcel$export(module.exports, "useIssueTypesAndFields", () => $90cf08abf5e3ede7$export$d2121b02f0b65782);

var $5uXOq = parcelRequire("5uXOq");

var $5tTFS = parcelRequire("5tTFS");


var $gN11a = parcelRequire("gN11a");

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $1nb22 = parcelRequire("1nb22");

var $doZTA = parcelRequire("doZTA");

var $4R6GH = parcelRequire("4R6GH");

var $8Zw8m = parcelRequire("8Zw8m");

var $8tTgF = parcelRequire("8tTgF");
const $90cf08abf5e3ede7$export$d7241b17c19f0a9c = 'PROJECT_NOT_FOUND';
const $90cf08abf5e3ede7$export$4c72baf45fce4585 = 'VIEW_PROJECT_PERMISSION_ERROR';
const $90cf08abf5e3ede7$var$isProjectPermissionError = (error)=>error.message.indexOf($90cf08abf5e3ede7$export$d7241b17c19f0a9c) > -1 || error.message.indexOf($90cf08abf5e3ede7$export$4c72baf45fce4585) > -1 || // @ts-expect-error TS2339 - Property 'extensions' does not exist on type 'ApolloError'
    error.extensions?.statusCode === 403 || // @ts-expect-error TS2339 - Property 'extensions' does not exist on type 'ApolloError'
    error.extensions?.statusCode === 404;
const $90cf08abf5e3ede7$export$6b9bc8a33ade0736 = (input)=>{
    const [routerState] = (0, $doZTA.useRouter)();
    const { projectKey: projectKey } = (0, $1nb22.getProjectKeyId)(routerState?.match, routerState?.query);
    const variables = (0, $5uXOq.useMemo)(()=>({
            projectKey: projectKey,
            issueOperation: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            input.issueOperation,
            first: 100,
            isSearchableInJqlEnabled: (0, $4R6GH.fg)('jira_issue_field_searchable_in_jql_data_fetcher')
        }), [
        input.issueOperation,
        projectKey
    ]);
    const { query: query, view: view } = // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly "classic-business-form": { readonly view: "Form"; readonly query: DocumentNode; }; readonly "classic-business-form-submit": { readonly view: "FormSubmit"; readonly query: DocumentNode; }; ... 8 more ...; readonly default: { ...; }; }'.
    (0, $8tTgF.JWMQueryByRouteMap)?.[routerState?.route?.name] ?? (0, $8tTgF.JWMQueryByRouteMap)[0, $8Zw8m.DEFAULT];
    return (0, $5uXOq.useMemo)(()=>({
            loading: false,
            query: query,
            view: view,
            variables: variables
        }), [
        query,
        view,
        variables
    ]);
};
const $90cf08abf5e3ede7$export$1768f0a0f85b4de9 = (input)=>{
    const client = (0, $5tTFS.useApolloClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { variables: queryVariables, query: query } = $90cf08abf5e3ede7$export$6b9bc8a33ade0736(input);
    const analyticsTaskName = 'useIssueTypesAndFieldsCacheApolloCacheActions';
    return (0, $5uXOq.useCallback)(({ findField: findField, updateItem: updateItem })=>{
        const getCacheData = ()=>{
            try {
                const read = client.readQuery({
                    query: query,
                    variables: queryVariables
                });
                (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheRead taskSuccess', {
                    task: analyticsTaskName
                });
                return read;
            } catch (e) {
                (0, $jcw0u.default)({
                    error: e instanceof Error ? e : new Error('Unknown cache read error'),
                    meta: {
                        id: 'useIssueTypesAndFieldsCache',
                        packageName: 'jiraBusinessEntityProject',
                        teamName: 'wanjel'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true,
                    attributes: {
                        task: analyticsTaskName,
                        query: JSON.stringify(query),
                        variables: JSON.stringify(queryVariables),
                        eventName: 'apolloCacheRead taskFail',
                        error: JSON.stringify(e)
                    }
                });
                return null;
            }
        };
        const cacheData = getCacheData();
        const existingEdges = cacheData?.jiraBusinessAvailableFields?.edges;
        if (existingEdges == null) return;
        let shouldUpdate = false;
        const newEdges = existingEdges.map((edge)=>{
            const existingFields = edge?.node?.fields?.edges;
            if (existingFields == null) return edge;
            const itemToUpdateIndex = existingFields.findIndex((fieldEdge)=>findField ? findField(fieldEdge?.node) : false) ?? undefined;
            const existingField = existingFields[itemToUpdateIndex]?.node;
            if (itemToUpdateIndex === undefined || itemToUpdateIndex === -1 || existingField == null) return edge;
            const itemOverride = updateItem(existingField);
            if (itemOverride === undefined) return edge;
            const newFields = [
                ...existingFields
            ];
            newFields[itemToUpdateIndex] = {
                node: itemOverride,
                __typename: 'JiraIssueFieldEdge'
            };
            shouldUpdate = true;
            return {
                ...edge,
                node: {
                    ...edge?.node || {},
                    fields: {
                        edges: newFields,
                        __typename: 'JiraIssueFieldConnection'
                    }
                }
            };
        });
        if (!shouldUpdate) return;
        const newData = {
            ...cacheData,
            jiraBusinessAvailableFields: {
                ...cacheData?.jiraBusinessAvailableFields || {},
                edges: newEdges
            }
        };
        try {
            client.writeQuery({
                query: query,
                variables: queryVariables,
                // @ts-expect-error - TS2345 - Argument of type '{ query: any; variables: { projectId: number | undefined; issueOperation: IssueOperation; first: number; } | undefined; notifyOnNetworkStatusChange: boolean; data: { jiraBusinessAvailableFields: { ...; }; }; }' is not assignable to parameter of type 'WriteQueryOptions<{ jiraBusinessAvailableFields: { edges: (JiraBusinessAvailableFieldsListView_jiraBusinessAvailableFields_edges | { ...; } | null)[]; __typename?: "JiraBusinessAvailableFieldsConnection" | undefined; }; }, { ...; }>'.
                notifyOnNetworkStatusChange: true,
                data: newData
            });
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheWrite taskSuccess', {
                task: analyticsTaskName
            });
        } catch (e) {
            (0, $jcw0u.default)({
                error: e instanceof Error ? e : new Error('Unknown cache write error'),
                meta: {
                    id: 'useIssueTypesAndFieldsCache',
                    packageName: 'jiraBusinessEntityProject',
                    teamName: 'wanjel'
                },
                sendToPrivacyUnsafeSplunk: true,
                skipSentry: true,
                attributes: {
                    task: analyticsTaskName,
                    query: JSON.stringify(query),
                    variables: JSON.stringify(queryVariables),
                    eventName: 'apolloCacheWrite taskFail',
                    error: JSON.stringify(e)
                }
            });
        }
    }, [
        client,
        createAnalyticsEvent,
        query,
        queryVariables
    ]);
};
const $90cf08abf5e3ede7$export$3ef3324b7f7d6a38 = (input)=>{
    const [hasStartedFetchingFields, setHasStartedFetchingFields] = (0, $5uXOq.useState)(false);
    const fetchAttempts = (0, $5uXOq.useRef)(0);
    const { variables: queryVariables, loading: isQueryLoading, query: query, view: view } = $90cf08abf5e3ede7$export$6b9bc8a33ade0736(input);
    const [getAvailableFields, { data: data, called: called, loading: loading, error: error, refetch: refetchQuery }] = (0, $5tTFS.useLazyQuery)(query, {
        variables: queryVariables,
        errorPolicy: 'all',
        fetchPolicy: 'cache-first',
        onError: (apolloError)=>{
            (0, $gN11a.markViewMetric)(view.toLowerCase(), (0, $a286480ec63fa4c8$export$ac953882305d6102));
            // do not fire error if user doesn't have project permissions
            if ($90cf08abf5e3ede7$var$isProjectPermissionError(apolloError)) return;
            (0, $jcw0u.default)({
                meta: {
                    id: `availableFields${view}ViewQuery`,
                    packageName: 'jiraBusinessEntityProject',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: `Failed to fetch available fields in ${view} view`
                },
                error: apolloError,
                sendToPrivacyUnsafeSplunk: true
            });
        },
        onCompleted: (onCompletedData)=>{
            (0, $gN11a.markViewMetric)(view.toLowerCase(), (0, $a286480ec63fa4c8$export$ac953882305d6102));
            if (onCompletedData?.jiraBusinessAvailableFields == null) throw error || new Error('No available fields data');
            onCompletedData?.jiraBusinessAvailableFields?.edges?.forEach((e)=>{
                const fieldEdges = e?.node?.fields?.edges;
                if (fieldEdges == null || fieldEdges?.length === 0) {
                    const emptyMessage = fieldEdges == null ? 'null fields' : '0 length fields';
                    const emptyFieldsError = new Error(`availableFieldsAPI is returning ${emptyMessage} for issueType ${e?.node?.issueType.name ?? 'UNKNOWN'}`);
                    // retrying due to intermittent error related to new projects: FUN-570
                    if (fetchAttempts.current < 1) {
                        fetchAttempts.current += 1;
                        refetch();
                    } else throw emptyFieldsError;
                }
            });
        }
    });
    (0, $5uXOq.useEffect)(()=>{
        if (queryVariables && !hasStartedFetchingFields && !error) {
            setHasStartedFetchingFields(true);
            (0, $gN11a.markViewMetric)(view.toLowerCase(), (0, $a286480ec63fa4c8$export$7b887ee35f2b465e));
            getAvailableFields();
        }
    }, [
        error,
        getAvailableFields,
        hasStartedFetchingFields,
        queryVariables,
        view
    ]);
    const refetch = (0, $5uXOq.useCallback)(()=>{
        if (called && typeof refetchQuery === 'function') return refetchQuery(queryVariables);
        const err = new Error('availableFields refetch is undefined because the service has not been called yet');
        (0, $jcw0u.default)({
            meta: {
                id: 'availableFieldsRefetchIsUndefined',
                packageName: 'jiraBusinessEntityProject',
                teamName: 'wanjel'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    }, [
        called,
        refetchQuery,
        queryVariables
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (hasStartedFetchingFields && error) setHasStartedFetchingFields(false);
    }, [
        hasStartedFetchingFields,
        error
    ]);
    const result = (0, $5uXOq.useMemo)(()=>(0, $8tTgF.transformResult)(data), [
        data
    ]);
    const typesWithFields = (0, $5uXOq.useMemo)(()=>(0, $8tTgF.transformResultToTypesWithFields)(data), [
        data
    ]);
    const hierarchyLevels = (0, $5uXOq.useMemo)(()=>result.issueTypes.map((issueType)=>({
                level: issueType.hierarchyLevel,
                name: issueType.name,
                id: issueType.id
            })).sort((a, b)=>a.level !== b.level ? b.level - a.level : a.name.localeCompare(b.name)), [
        result.issueTypes
    ]);
    // make sure "loading" flag starts from "true"
    const isFieldsLoading = hasStartedFetchingFields ? loading : true;
    return {
        error: error,
        loading: error ? false : isQueryLoading || isFieldsLoading,
        data: result,
        typesWithFields: typesWithFields,
        hierarchyLevels: hierarchyLevels,
        refetch: refetch
    };
};
const $90cf08abf5e3ede7$var$issueTypesAndFieldsContextDefaultValue = {
    data: {
        fields: [],
        issueTypes: []
    },
    loading: false,
    error: undefined,
    typesWithFields: [],
    hierarchyLevels: []
};
const $90cf08abf5e3ede7$export$77937175321fab39 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    ...$90cf08abf5e3ede7$var$issueTypesAndFieldsContextDefaultValue
});
const $90cf08abf5e3ede7$export$fbd286e14113bfc = /*#__PURE__*/ (0, $5uXOq.createContext)({
    ...$90cf08abf5e3ede7$var$issueTypesAndFieldsContextDefaultValue
});
const $90cf08abf5e3ede7$export$d2121b02f0b65782 = (input)=>{
    const issueTypesAndFieldsViewData = (0, $5uXOq.useContext)($90cf08abf5e3ede7$export$77937175321fab39);
    const issueTypesAndFieldsCreateData = (0, $5uXOq.useContext)($90cf08abf5e3ede7$export$fbd286e14113bfc);
    if (!input || input.issueOperation === 'VIEW') return issueTypesAndFieldsViewData;
    return issueTypesAndFieldsCreateData;
};

});
const $a286480ec63fa4c8$export$747aad128920134d = 3000;
const $a286480ec63fa4c8$export$e4f8d353742c04ac = 4000;
const $a286480ec63fa4c8$export$540ffd289e5e0562 = 'timeWaitingForBackendData';
const $a286480ec63fa4c8$export$23e322eb7c526958 = 'REQUEST_START';
const $a286480ec63fa4c8$export$83ca21a50372ea3b = 'REQUEST_END';
const $a286480ec63fa4c8$export$821ca6ff41f300ec = 'jwm-availableFieldsQuery';
const $a286480ec63fa4c8$export$7b887ee35f2b465e = 'AVAILABLE_FIELDS_QUERY_START';
const $a286480ec63fa4c8$export$ac953882305d6102 = 'AVAILABLE_FIELDS_QUERY_END';
const $a286480ec63fa4c8$export$7f7f60b5526c5ee3 = 'jwm-ui-render-time';
const $a286480ec63fa4c8$export$b78f0bbf209e5f4 = 'UI_RENDER_START';
const $a286480ec63fa4c8$export$88ea1e280513690f = 'UI_RENDER_END';

parcelRegister("8Zw8m", function(module, exports) {

$parcel$export(module.exports, "DEFAULT", () => $c9bd1f086657e924$export$e6952b12ade67489);
$parcel$export(module.exports, "HierarchyLevel", () => $c9bd1f086657e924$export$7faaf3222dfd10db);
const $c9bd1f086657e924$export$e6952b12ade67489 = 'default';
const $c9bd1f086657e924$export$7faaf3222dfd10db = Object.freeze({
    EPIC: 1,
    BASE: 0,
    SUBTASK: -1
});

});

parcelRegister("8tTgF", function(module, exports) {

$parcel$export(module.exports, "transformResult", () => $66b8ed432f1db6bc$export$f13b29f9ed0c5a03);
$parcel$export(module.exports, "transformResultToTypesWithFields", () => $66b8ed432f1db6bc$export$55ab7865f91ba09b);
$parcel$export(module.exports, "JWMQueryByRouteMap", () => $66b8ed432f1db6bc$export$7188da46161cbb8f);

var $5fc53 = parcelRequire("5fc53");

var $4R6GH = parcelRequire("4R6GH");

var $8Zw8m = parcelRequire("8Zw8m");

var $e3MSU = parcelRequire("e3MSU");
const $66b8ed432f1db6bc$export$b07b0d8dc0894ecf = {
    fields: [],
    issueTypes: []
};
const $66b8ed432f1db6bc$var$emptyArray = [];
const $66b8ed432f1db6bc$export$bffa388e20165996 = (node, issueType)=>{
    const fieldConfig = {
        isRequired: !!node.fieldConfig?.isRequired,
        isEditable: !!node.fieldConfig?.isEditable
    };
    if (node.type === 'priority') {
        fieldConfig.options = node.priorities.nodes;
        // Set middle priority as default if backend doesn't return any
        if (node.priority) fieldConfig.defaultPriorityId = node.priority.priorityId;
        else if (fieldConfig.options.length > 0) fieldConfig.defaultPriorityId = // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        node.priorities.nodes[Math.floor(fieldConfig.options.length / 2)].priorityId;
    }
    if (node.type === 'issuetype') {
        fieldConfig.options = node.issueTypes.nodes;
        fieldConfig.avatarId = issueType.avatarId;
        fieldConfig.avatarUrl = issueType.avatar?.medium;
    }
    if (node.type === 'issuelinks' && node.issueLinkTypeRelations) // 'is blocked by' / 'blocks' is used as the default issue link type
    fieldConfig.defaultIssueLinkTypeId = node.issueLinkTypeRelations.nodes.find(// @ts-expect-error - TS7006 - Parameter 'linkNode' implicitly has an 'any' type.
    (linkNode)=>linkNode.relationName === 'is blocked by')?.linkTypeId || // take the first awailable otherwise
    node.issueLinkTypeRelations.nodes[0]?.linkTypeId;
    if (node.type === (0, $5fc53.MULTI_SELECT_CF_TYPE) || node.type === (0, $5fc53.SELECT_CF_TYPE)) {
        const fieldOptions = [];
        // convert so that it can be used by the select field
        // @ts-expect-error - TS7031 - Binding element 'value' implicitly has an 'any' type. | TS7031 - Binding element 'optionId' implicitly has an 'any' type.
        node.fieldOptions.nodes.forEach(({ value: value, optionId: optionId })=>{
            fieldOptions.push({
                value: value,
                label: value,
                optionId: optionId
            });
        });
        fieldConfig.selectOptions = fieldOptions;
    }
    if (node.type === (0, $5fc53.MULTI_CHECKBOXES_CF_TYPE)) {
        const fieldOptions = [];
        // convert so that it can be used by the select field
        // @ts-expect-error - TS7031 - Binding element 'value' implicitly has an 'any' type. | TS7031 - Binding element 'optionId' implicitly has an 'any' type.
        node.fieldOptions.nodes.forEach(({ value: value, optionId: optionId })=>{
            fieldOptions.push({
                value: value,
                label: value,
                optionId: optionId
            });
        });
        fieldConfig.selectOptions = fieldOptions;
    }
    if (node.type === (0, $5fc53.CATEGORY_TYPE)) {
        // @ts-expect-error - TS2304 - Cannot find name 'SelectOption'.
        const fieldOptions = [];
        // convert so that it can be used by the select field
        // @ts-expect-error - TS7031 - Binding element 'value' implicitly has an 'any' type. | TS7031 - Binding element 'optionId' implicitly has an 'any' type.
        node.fieldOptions.nodes.forEach(({ value: value, optionId: optionId, color: color })=>{
            fieldOptions.push({
                value: value,
                label: value,
                optionId: optionId,
                color: color?.colorKey ?? null
            });
        });
        fieldConfig.selectOptions = fieldOptions;
    }
    const shouldAddIsSearchableInJql = (0, $4R6GH.fg)('jira_issue_field_searchable_in_jql_data_fetcher') && typeof node.isSearchableInJql === 'boolean';
    return {
        id: node.fieldId,
        aliasFieldId: node.aliasFieldId,
        name: node.name,
        type: node.type,
        fieldConfig: fieldConfig,
        ...shouldAddIsSearchableInJql && {
            isSearchableInJql: node.isSearchableInJql
        },
        issueTypes: [],
        __typename: node.__typename
    };
};
const $66b8ed432f1db6bc$export$f13b29f9ed0c5a03 = (data)=>{
    if (data && data.jiraBusinessAvailableFields && data.jiraBusinessAvailableFields.edges) {
        const issueFieldsById = {};
        const issueTypesById = {};
        data.jiraBusinessAvailableFields.edges.map((edge)=>edge && edge.node || {}).forEach(// @ts-expect-error - TS2345 - Argument of type '({ issueType, fields, isDefaultIssueType, }: { issueType: {    name: string;    issueTypeId: string;    type: string;    avatarId: string;    hierarchy?: {        level: number;    };}; fields: {    edges: {        nodes: [];    }[];}; isDefaultIssueType: boolean; }) => void' is not assignable to parameter of type '(value: {}, index: number, array: {}[]) => void'.
        ({ issueType: issueType, fields: fields, isDefaultIssueType: isDefaultIssueType })=>{
            issueTypesById[issueType.issueTypeId] = {
                id: issueType.issueTypeId,
                isDefault: isDefaultIssueType,
                name: issueType.name,
                subtask: issueType.type === 'SUB_TASK',
                avatarId: issueType.avatarId,
                avatarUrl: issueType.avatar?.medium ?? null,
                hierarchyLevel: issueType.hierarchy?.level ?? 0
            };
            fields.edges// @ts-expect-error - TS2551 - Property 'node' does not exist on type '{ nodes: []; }'. Did you mean 'nodes'?
            .map((edge)=>edge && edge.node || {}).forEach((node)=>{
                if (node.fieldId) {
                    if (!issueFieldsById[node.fieldId]) issueFieldsById[node.fieldId] = $66b8ed432f1db6bc$export$bffa388e20165996(node, issueType);
                    issueFieldsById[node.fieldId].issueTypes = issueFieldsById[node.fieldId].issueTypes || [];
                    // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
                    issueFieldsById[node.fieldId].issueTypes.push(issueType.issueTypeId);
                }
            });
        });
        return {
            fields: Object.keys(issueFieldsById).map((id)=>issueFieldsById[id]),
            issueTypes: Object.keys(issueTypesById).map((id)=>issueTypesById[id])
        };
    }
    // @ts-expect-error - TS2322 - Type '{ readonly fields: readonly []; readonly issueTypes: readonly []; }' is not assignable to type '{ fields: BusinessIssueField[]; issueTypes: BusinessIssueType[]; }'.
    return $66b8ed432f1db6bc$export$b07b0d8dc0894ecf;
};
const $66b8ed432f1db6bc$export$55ab7865f91ba09b = (data)=>{
    if (data && data.jiraBusinessAvailableFields && data.jiraBusinessAvailableFields.edges) return data.jiraBusinessAvailableFields.edges.map((edge)=>edge && edge.node || {}).map(// @ts-expect-error - TS2345 - Argument of type '({ issueType, fields, isDefaultIssueType, }: { issueType: {    name: string;    issueTypeId: string;    type: string;    avatarId: string;    hierarchy?: {        level: number;    };}; fields: {    edges: {        nodes: [];    }[];}; isDefaultIssueType: boolean; }) => { issueType: { id: string; isDefault: boolean;...' is not assignable to parameter of type '(value: {}, index: number, array: {}[]) => { issueType: { id: string; isDefault: boolean; name: string; subtask: boolean; avatarId: string; hierarchyLevel: number; }; fields: BusinessIssueField[]; }'.
    ({ issueType: issueType, fields: fields, isDefaultIssueType: isDefaultIssueType })=>({
            issueType: {
                id: issueType.issueTypeId,
                isDefault: isDefaultIssueType,
                name: issueType.name,
                subtask: issueType.type === 'SUB_TASK',
                avatarId: issueType.avatarId,
                avatarUrl: issueType.avatar?.medium ?? '',
                hierarchyLevel: issueType.hierarchy?.level ?? 0
            },
            fields: fields.edges// @ts-expect-error - TS2551 - Property 'node' does not exist on type '{ nodes: []; }'. Did you mean 'nodes'?
            .map((edge)=>edge && edge.node || {}).map((node)=>$66b8ed432f1db6bc$export$bffa388e20165996(node, issueType))
        }));
    return $66b8ed432f1db6bc$var$emptyArray;
};
const $66b8ed432f1db6bc$export$7188da46161cbb8f = {
    'classic-business-form': {
        view: 'Form',
        query: (0, $e3MSU.ISSUE_TYPES_AND_FIELDS_FORM_QUERY)
    },
    'classic-business-form-submit': {
        view: 'FormSubmit',
        query: (0, $e3MSU.ISSUE_TYPES_AND_FIELDS_FORM_SUBMIT_QUERY)
    },
    'classic-business-calendar': {
        view: 'Calendar',
        query: (0, $e3MSU.ISSUE_TYPES_AND_FIELDS_CALENDAR_QUERY)
    },
    'classic-business-calendar-embed': {
        view: 'CalendarEmbed',
        query: (0, $e3MSU.ISSUE_TYPES_AND_FIELDS_CALENDAR_QUERY)
    },
    'classic-business-list': {
        view: 'List',
        query: (0, $e3MSU.ISSUE_TYPES_AND_FIELDS_LIST_QUERY)
    },
    'classic-business-list-embed': {
        view: 'ListEmbed',
        query: (0, $e3MSU.ISSUE_TYPES_AND_FIELDS_LIST_QUERY)
    },
    'classic-business-timeline': {
        view: 'Timeline',
        query: (0, $e3MSU.ISSUE_TYPES_AND_FIELDS_TIMELINE_QUERY)
    },
    'classic-business-timeline-embed': {
        view: 'TimelineEmbed',
        query: (0, $e3MSU.ISSUE_TYPES_AND_FIELDS_TIMELINE_QUERY)
    },
    'classic-business-board': {
        view: 'Board',
        query: (0, $e3MSU.ISSUE_TYPES_AND_FIELDS_BOARD_QUERY)
    },
    'classic-business-board-embed': {
        view: 'BoardEmbed',
        query: (0, $e3MSU.ISSUE_TYPES_AND_FIELDS_BOARD_QUERY)
    },
    'classic-business-board-custom-embed': {
        view: 'BoardEmbed',
        query: (0, $e3MSU.ISSUE_TYPES_AND_FIELDS_BOARD_QUERY)
    },
    [(0, $8Zw8m.DEFAULT)]: {
        view: 'Common',
        query: (0, $e3MSU.ISSUE_TYPES_AND_FIELDS_LIST_QUERY)
    }
};

});
parcelRegister("e3MSU", function(module, exports) {

$parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_LIST_QUERY", () => $32ca725097f9e68f$export$ba5f98a8d6136727);
$parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_CALENDAR_QUERY", () => $32ca725097f9e68f$export$cba408dff1091b60);
$parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_TIMELINE_QUERY", () => $32ca725097f9e68f$export$363435cea078aa93);
$parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_BOARD_QUERY", () => $32ca725097f9e68f$export$1641a42cf2cdb09a);
$parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_FORM_QUERY", () => $32ca725097f9e68f$export$7903c43b0ec55315);
$parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_FORM_SUBMIT_QUERY", () => $32ca725097f9e68f$export$79304c172f5555ae);

var $5cllN = parcelRequire("5cllN");
const $32ca725097f9e68f$export$ec2562ca5badac3b = (0, $5cllN.default)`
  fragment GetIssueTypesAndFields on JiraBusinessAvailableFields {
    issueType {
      issueTypeId
      name
      type
      avatarId
      avatar {
        medium
      }
      hierarchy {
        level
      }
    }
    isDefaultIssueType
    fields {
      edges {
        node {
          fieldId
          type
          name
          aliasFieldId
          isSearchableInJql @include(if: $isSearchableInJqlEnabled)
          ... on GenericIssueField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraIssueTypeField {
            fieldConfig {
              isRequired
              isEditable
            }
            issueTypes {
              nodes {
                name
                id
              }
            }
          }
          ... on JiraPriorityField {
            fieldConfig {
              isRequired
              isEditable
            }
            priority {
              priorityId
            }
            priorities {
              nodes {
                priorityId
                name
                iconUrl
              }
            }
          }
          ... on JiraLabelsField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSingleSelectUserPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSingleLineTextField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraDatePickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraAffectedServicesField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraAttachmentsField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraCMDBField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraCascadingSelectField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraCheckboxesField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraColorField {
            fieldConfig {
              isRequired
              isEditable
            }
            color {
              colorKey
            }
          }
          ... on JiraComponentsField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraDateTimePickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraEpicLinkField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraIssueLinkField {
            fieldConfig {
              isRequired
              isEditable
            }
            issueLinkTypeRelations(first: 10) {
              nodes {
                linkTypeId
                relationName
              }
            }
          }
          ... on JiraIssueRestrictionField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraMultipleGroupPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraMultipleSelectField {
            fieldConfig {
              isRequired
              isEditable
            }
            fieldOptions {
              nodes {
                id
                optionId
                value
              }
            }
          }
          ... on JiraMultipleSelectUserPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraMultipleVersionPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraNumberField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
					... on JiraParentIssueField {
						fieldConfig {
							isRequired
							isEditable
						}
					}
          ... on JiraPeopleField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraProjectField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraRadioSelectField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraResolutionField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraRichTextField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSecurityLevelField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSingleGroupPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSingleSelectField {
            fieldConfig {
              isRequired
              isEditable
            }
            fieldOptions {
              nodes {
                id
                optionId
                value
              }
            }
          }
          ... on JiraSingleVersionPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSprintField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraTeamField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraUrlField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JsmRequestTypeField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JWMCategoryField {
            fieldConfig {
              isRequired
              isEditable
            }
            fieldOptions {
              nodes {
                id
                optionId
                value
                color {
                    colorKey
                }
              }
            }
          }
          ... on JiraCheckboxesField {
            fieldConfig {
              isRequired
              isEditable
            }
            fieldOptions {
              nodes {
                id
                optionId
                value
              }
            }
          }
          ... on JiraAtlassianTeamField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraGoalsField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
        }
      }
    }
  }
`;
const $32ca725097f9e68f$export$ba5f98a8d6136727 = (0, $5cllN.default)`
  query JiraBusinessAvailableFieldsListView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String, $isSearchableInJqlEnabled: Boolean = false) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$32ca725097f9e68f$export$ec2562ca5badac3b}
`;
const $32ca725097f9e68f$export$cba408dff1091b60 = (0, $5cllN.default)`
  query JiraBusinessAvailableFieldsCalendarView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String, $isSearchableInJqlEnabled: Boolean = false) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$32ca725097f9e68f$export$ec2562ca5badac3b}
`;
const $32ca725097f9e68f$export$363435cea078aa93 = (0, $5cllN.default)`
  query JiraBusinessAvailableFieldsTimelineView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String, $isSearchableInJqlEnabled: Boolean = false) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$32ca725097f9e68f$export$ec2562ca5badac3b}
`;
const $32ca725097f9e68f$export$1641a42cf2cdb09a = (0, $5cllN.default)`
  query JiraBusinessAvailableFieldsBoardView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String, $isSearchableInJqlEnabled: Boolean = false) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$32ca725097f9e68f$export$ec2562ca5badac3b}
`;
const $32ca725097f9e68f$export$7903c43b0ec55315 = (0, $5cllN.default)`
  query JiraBusinessAvailableFieldsFormView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String, $isSearchableInJqlEnabled: Boolean = false) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$32ca725097f9e68f$export$ec2562ca5badac3b}
`;
const $32ca725097f9e68f$export$79304c172f5555ae = (0, $5cllN.default)`
  query JiraBusinessAvailableFieldsFormSubmitView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String, $isSearchableInJqlEnabled: Boolean = false) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$32ca725097f9e68f$export$ec2562ca5badac3b}
`;

});




parcelRegister("388MD", function(module, exports) {

$parcel$export(module.exports, "useRefetchFields", () => $d6a4bf67baf22373$export$715664166ba98964);
$parcel$export(module.exports, "RefetchFieldsController", () => $d6a4bf67baf22373$export$f1f4bd03b141f216);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $1T2vX = parcelRequire("1T2vX");
const $d6a4bf67baf22373$var$REFETCH_TIMEOUT = 500;
const $d6a4bf67baf22373$var$MAX_NUMBER_OF_RETRIES = 5;
const $d6a4bf67baf22373$var$actions = {
    setRefetchFields: (refetchFields)=>({ setState: setState })=>setState({
                refetchFields: refetchFields
            })
};
const $d6a4bf67baf22373$export$c87e497850d70653 = ()=>Promise.resolve(null);
const $d6a4bf67baf22373$var$Store = (0, $iXqE5.createStore)({
    initialState: {
        refetchFields: $d6a4bf67baf22373$export$c87e497850d70653
    },
    actions: $d6a4bf67baf22373$var$actions,
    name: 'JWMRefetchFieldsStore'
});
const $d6a4bf67baf22373$var$useHook = (0, $3sQ5x.createHook)($d6a4bf67baf22373$var$Store);
const $d6a4bf67baf22373$export$715664166ba98964 = ()=>{
    const [{ refetchFields: refetchFields }, { setRefetchFields: setRefetchFields }] = $d6a4bf67baf22373$var$useHook();
    return {
        refetchFields: refetchFields,
        setRefetchFields: setRefetchFields
    };
};
const $d6a4bf67baf22373$export$f1f4bd03b141f216 = ()=>{
    const pendingRefetch = (0, $5uXOq.useRef)();
    const retryCount = (0, $5uXOq.useRef)(0);
    const { setRefetchFields: setRefetchFields } = $d6a4bf67baf22373$export$715664166ba98964();
    const { refetch: refetchViewFields } = (0, $1T2vX.useIssueTypesAndFieldsService)({
        issueOperation: 'VIEW'
    });
    const { refetch: refetchCreateFields } = (0, $1T2vX.useIssueTypesAndFieldsService)({
        issueOperation: 'CREATE'
    });
    const setPendingRefetch = (refetch, resolve)=>{
        const toId = setTimeout(()=>{
            pendingRefetch.current = null;
            refetch();
        }, $d6a4bf67baf22373$var$REFETCH_TIMEOUT);
        pendingRefetch.current = {
            timeoutId: toId,
            resolve: resolve
        };
    };
    const clearPendingRefetch = ()=>{
        if (pendingRefetch.current) {
            const { timeoutId: toId, resolve: resolve } = pendingRefetch.current;
            clearTimeout(toId);
            resolve(null);
            pendingRefetch.current = null;
        }
    };
    (0, $5uXOq.useEffect)(()=>()=>{
            setRefetchFields($d6a4bf67baf22373$export$c87e497850d70653);
        }, [
        setRefetchFields
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            clearPendingRefetch();
        }, []);
    const refetchFields = (0, $5uXOq.useCallback)(({ shouldRetry: shouldRetry } = {})=>{
        clearPendingRefetch();
        return new Promise((resolve, reject)=>{
            const refetch = async ()=>{
                try {
                    const response = await Promise.all([
                        refetchViewFields(),
                        refetchCreateFields()
                    ]);
                    if (!shouldRetry || !shouldRetry(response)) {
                        resolve(response);
                        retryCount.current = 0;
                    } else if (retryCount.current < $d6a4bf67baf22373$var$MAX_NUMBER_OF_RETRIES) {
                        retryCount.current += 1;
                        // schedule another refetch
                        setPendingRefetch(refetch, resolve);
                    } else {
                        const error = new Error('refetching fields exceeded retries count');
                        (0, $jcw0u.default)({
                            meta: {
                                id: 'JwmRefetchFields',
                                packageName: 'jiraBusinessEntityProject',
                                teamName: 'wanjel'
                            },
                            error: error,
                            attributes: {
                                message: `Failed to refetch fields after ${$d6a4bf67baf22373$var$MAX_NUMBER_OF_RETRIES} retries`
                            },
                            sendToPrivacyUnsafeSplunk: true,
                            skipSentry: true
                        });
                        reject(error);
                    }
                } catch (error) {
                    reject(error);
                }
            };
            // A newly associated field doesn’t show up instantly because of the eventual consistency:
            // recomputation of the fields configuration executes as a background task.
            // That's why we need to wait for a bit here before refetching
            setPendingRefetch(refetch, resolve);
        });
    }, [
        refetchCreateFields,
        refetchViewFields
    ]);
    (0, $5uXOq.useEffect)(()=>{
        setRefetchFields(refetchFields);
    }, [
        refetchFields,
        setRefetchFields
    ]);
    return null;
};

});

parcelRegister("33Toe", function(module, exports) {

$parcel$export(module.exports, "IssueCreateProvider", () => $16929302557484c9$export$a975cd9627cdf4b6);
$parcel$export(module.exports, "useCreateIssue", () => $16929302557484c9$export$8af2d18142c8506c);
$parcel$export(module.exports, "isOptimisticIssue", () => $16929302557484c9$export$8512029c7fc94e58);
$parcel$export(module.exports, "useIsHighlighted", () => $16929302557484c9$export$2ecca9d8a7f031af);

var $5MxQY = parcelRequire("5MxQY");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $dqDis = parcelRequire("dqDis");

var $cYlk7 = parcelRequire("cYlk7");

var $ja8d8 = parcelRequire("ja8d8");

var $ecPXN = parcelRequire("ecPXN");
class $16929302557484c9$var$IssueCreateJob {
    constructor(createParams){
        this.createParams = createParams;
        this.promise = new Promise((resolve, reject)=>{
            this.reject = reject;
            this.resolve = resolve;
        });
    }
}
const $16929302557484c9$var$IssueCreateContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $16929302557484c9$var$reducer = (state, action)=>{
    switch(action.type){
        case 'enqueue':
            return {
                ...state,
                jobQueue: [
                    ...state.jobQueue,
                    action.job
                ]
            };
        case 'start-job':
            return {
                ...state,
                runningJob: state.jobQueue[0],
                jobQueue: state.jobQueue.slice(1)
            };
        case 'end-job':
            return {
                ...state,
                runningJob: null
            };
        case 'highlight':
            return {
                ...state,
                highlightedIssues: new Set([
                    ...state.highlightedIssues,
                    action.issueId
                ])
            };
        case 'unhighlight':
            return {
                ...state,
                highlightedIssues: new Set([
                    ...state.highlightedIssues
                ].filter((id)=>id !== action.issueId))
            };
        case 'save-summary':
            return {
                ...state,
                summary: action.summary
            };
        default:
            return state;
    }
};
const $16929302557484c9$var$initialState = {
    jobQueue: [],
    runningJob: null,
    highlightedIssues: new Set(),
    summary: ''
};
const $16929302557484c9$export$a975cd9627cdf4b6 = ({ onCreateIssue: onCreateIssue, onRefetchIssue: onRefetchIssue, ignoreFiltersContext: ignoreFiltersContext = false, queryFragment: queryFragment, children: children })=>{
    const { data: { user: user } } = (0, $cYlk7.useCurrentUser)();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const currentUser = user;
    // optimistic issue ids are negative numbers to distinguish them from real issue ids
    const nextIssueId = (0, $5uXOq.useRef)(-1);
    const [{ jobQueue: jobQueue, runningJob: runningJob, highlightedIssues: highlightedIssues, summary: summary }, dispatch] = (0, $5uXOq.useReducer)($16929302557484c9$var$reducer, $16929302557484c9$var$initialState);
    const data = (0, $8Uumt.useFragment)((0, $5MxQY.default), queryFragment);
    const rankFieldId = data.jira.rankField?.fieldId ?? null;
    const createIssueController = (0, $ja8d8.useCreateIssue)(onCreateIssue, onRefetchIssue);
    const highlightIssue = (0, $5uXOq.useCallback)((issueId)=>dispatch({
            type: 'highlight',
            issueId: issueId
        }), []);
    const unhighlightIssue = (0, $5uXOq.useCallback)((issueId)=>setTimeout(()=>{
            dispatch({
                type: 'unhighlight',
                issueId: issueId
            });
        }, 2000), []);
    const createIssue = (0, $5uXOq.useCallback)((createParams)=>{
        const job = new $16929302557484c9$var$IssueCreateJob(createParams);
        dispatch({
            type: 'enqueue',
            job: job
        });
        let rank;
        if (createParams.input.rankAfter) rank = (0, $dqDis.getNextRank)(createParams.input.rankAfter.rank);
        else if (createParams.input.rankBefore) rank = (0, $dqDis.getPreviousRank)(createParams.input.rankBefore.rank);
        const reporter = {
            accountId: currentUser.accountId,
            avatarUrl: currentUser.avatarUrls['48x48'],
            displayName: currentUser.displayName
        };
        const optimisticIssuePayload = {
            issueId: nextIssueId.current--,
            rank: rank,
            reporter: reporter,
            ...createParams.input
        };
        return {
            optimisticIssuePayload: optimisticIssuePayload,
            promise: job.promise
        };
    }, [
        currentUser
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // dequeue and run the next job if there is one and there is no running job
        if (jobQueue.length > 0 && !runningJob) {
            const job = jobQueue[0];
            dispatch({
                type: 'start-job'
            });
            createIssueController({
                createParams: job.createParams,
                highlightIssue: highlightIssue,
                unhighlightIssue: unhighlightIssue,
                ignoreFiltersContext: ignoreFiltersContext,
                rankFieldId: rankFieldId
            }).then(job.resolve).catch(job.reject).finally(()=>dispatch({
                    type: 'end-job'
                }));
        }
    }, [
        createIssueController,
        highlightedIssues,
        jobQueue,
        runningJob,
        highlightIssue,
        unhighlightIssue,
        ignoreFiltersContext,
        rankFieldId
    ]);
    (0, $ecPXN.useCreateParamHandler)(rankFieldId);
    const saveSummary = (0, $5uXOq.useCallback)((newSummary)=>{
        dispatch({
            type: 'save-summary',
            summary: newSummary
        });
    }, []);
    const value = (0, $5uXOq.useMemo)(()=>({
            createIssue: createIssue,
            highlightedIssues: highlightedIssues,
            summary: summary,
            saveSummary: saveSummary,
            rankFieldId: rankFieldId
        }), [
        createIssue,
        highlightedIssues,
        summary,
        saveSummary,
        rankFieldId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($16929302557484c9$var$IssueCreateContext.Provider, {
        value: value
    }, children);
};
const $16929302557484c9$export$8af2d18142c8506c = (onSubmit, onBlur)=>{
    const context = (0, $5uXOq.useContext)($16929302557484c9$var$IssueCreateContext);
    if (!context) throw new Error('useCreateIssue must be used within an IssueCreateProvider');
    const { createIssue: createIssue, summary: summary, saveSummary: saveSummary } = context;
    const summaryRef = (0, $5uXOq.useRef)(summary);
    const hasExitedWithoutUserAction = (0, $5uXOq.useRef)(true);
    const submit = (0, $5uXOq.useCallback)((createParams)=>{
        const result = createIssue(createParams);
        onSubmit(result);
        hasExitedWithoutUserAction.current = false;
        setTimeout(()=>{
            // reset the value as the form can stay open after submitting
            hasExitedWithoutUserAction.current = true;
        }, 100);
        return result;
    }, [
        createIssue,
        onSubmit
    ]);
    const blur = (0, $5uXOq.useCallback)((event)=>{
        onBlur?.(event);
        hasExitedWithoutUserAction.current = false;
    }, [
        onBlur
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            // if the component has exited without the user blurring the form or submitting,
            // then save the summary value so it can be reapplied
            saveSummary(hasExitedWithoutUserAction.current ? summaryRef.current : '');
        }, [
        saveSummary
    ]);
    return {
        summaryRef: summaryRef,
        submit: submit,
        blur: blur
    };
};
const $16929302557484c9$export$8512029c7fc94e58 = (issueId)=>issueId < 0;
const $16929302557484c9$export$2ecca9d8a7f031af = ()=>{
    const context = (0, $5uXOq.useContext)($16929302557484c9$var$IssueCreateContext);
    if (!context) throw new Error('useIsHighlighted must be used within an IssueCreateProvider');
    const { highlightedIssues: highlightedIssues } = context;
    return (0, $5uXOq.useCallback)((issueId)=>$16929302557484c9$export$8512029c7fc94e58(issueId) || highlightedIssues.has(issueId), [
        highlightedIssues
    ]);
};

});
parcelRegister("5MxQY", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e535bc522f3f9e2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<585091df852ca82a8e22a918b7bea1b2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2e535bc522f3f9e2$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        }
    ],
    "kind": "Fragment",
    "name": "IssueCreateProvider",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "cloudId",
                                "variableName": "cloudId"
                            }
                        ],
                        "concreteType": "JiraJqlFieldWithAliases",
                        "kind": "LinkedField",
                        "name": "rankField",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "fieldId"
                            }
                        ]
                    }
                ]
            },
            "action": "THROW",
            "path": "jira"
        }
    ],
    "type": "Query"
};
$2e535bc522f3f9e2$var$node.hash = "fea400f7b9138349b48b46b455b7d1db";
var $2e535bc522f3f9e2$export$2e2bcd8739ae039 = $2e535bc522f3f9e2$var$node;

});

parcelRegister("dqDis", function(module, exports) {

$parcel$export(module.exports, "getNextRank", () => $d36f563d8781dd11$export$5c16a8b7eebff4b8);
$parcel$export(module.exports, "getPreviousRank", () => $d36f563d8781dd11$export$e2047b3433d9f565);

var $daQYX = parcelRequire("daQYX");
const $d36f563d8781dd11$export$5c16a8b7eebff4b8 = (s)=>`${s}0`;
const $d36f563d8781dd11$export$e2047b3433d9f565 = (s)=>{
    const lastCharCode = s.charCodeAt(s.length - 1);
    const previousLastChar = String.fromCharCode(lastCharCode - 1);
    if (lastCharCode === 0) return $d36f563d8781dd11$export$e2047b3433d9f565(s.substring(0, s.length - 1));
    return `${s.substring(0, s.length - 1)}${previousLastChar}99`;
};
const $d36f563d8781dd11$export$2fbfa09555819a54 = ()=>{
    const { permissions: permissions } = (0, $daQYX.useProject)();
    return permissions.scheduleIssues && permissions.editIssues;
};

});

parcelRegister("ja8d8", function(module, exports) {

$parcel$export(module.exports, "useCreateIssue", () => $50507bfa414423fc$export$8af2d18142c8506c);

var $5uXOq = parcelRequire("5uXOq");

var $1T2vX = parcelRequire("1T2vX");

var $l9KLJ = parcelRequire("l9KLJ");

var $jcw0u = parcelRequire("jcw0u");

var $6s1PB = parcelRequire("6s1PB");

var $jJZqs = parcelRequire("jJZqs");

var $pa9q9 = parcelRequire("pa9q9");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $kpiI3 = parcelRequire("kpiI3");

var $8roPX = parcelRequire("8roPX");

var $lVeTj = parcelRequire("lVeTj");

var $fb3JB = parcelRequire("fb3JB");
const $50507bfa414423fc$export$8edbb6d449614942 = ()=>{
    const workflows = (0, $l9KLJ.useWorkflows)();
    return (0, $5uXOq.useCallback)((createInput)=>{
        if (createInput.status && workflows != null) {
            // find the workflow for the input issue type
            const workflow = workflows.find((w)=>w.issueTypes.some((it)=>it.issueTypeId === createInput.issueType.id));
            // find the first transition to the input status that is initial, or global but not conditional
            const { statusId: statusId } = createInput.status;
            const transition = workflow?.transitions.find((t)=>t.to.statusId === statusId && (t.isInitial || t.isGlobal && !t.isConditional));
            return transition?.transitionId;
        }
    }, [
        workflows
    ]);
};
const $50507bfa414423fc$export$8af2d18142c8506c = (onCreateIssue, onRefetchIssue)=>{
    const showCreateSuccessFlag = (0, $lVeTj.useShowCreateSuccessFlag)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { typesWithFields: typesWithFields } = (0, $1T2vX.useIssueTypesAndFields)({
        issueOperation: 'CREATE'
    });
    const getTransitionId = $50507bfa414423fc$export$8edbb6d449614942();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const showCreateIssueDialog = (0, $8roPX.useCreateIssueDialog)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return (0, $5uXOq.useCallback)(async ({ createParams: createParams, highlightIssue: highlightIssue, unhighlightIssue: unhighlightIssue, ignoreFiltersContext: ignoreFiltersContext, rankFieldId: rankFieldId })=>{
        const transitionId = getTransitionId(createParams.input);
        const issueTypeName = createParams.input.issueType.name;
        try {
            if (!(0, $kpiI3.hasAllRequiredFields)({
                issueType: typesWithFields.find(({ issueType: issueType })=>issueType.id === createParams.input.issueType.id),
                createInput: createParams.input
            })) throw new (0, $jJZqs.ValidationError)('Missing required fields');
            const response = await onCreateIssue(createParams, {
                transitionId: transitionId
            });
            highlightIssue(response.itemIdentifiers.issueId);
            if (createParams.showSuccessFlag) showCreateSuccessFlag(response.itemIdentifiers.issueKey, issueTypeName);
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'issue created', String(response.itemIdentifiers.issueId), {
                location: createParams.location,
                ...(0, $4R6GH.fg)('add-fields-attributes-to-issue-create') && {
                    fields: {
                        hasAssignee: createParams?.input?.assignee != null,
                        hasDueDate: createParams?.input?.dueDate != null
                    }
                },
                ...createParams.timeMsSinceFocus && (0, $4R6GH.fg)('jira_list_view_inline_create_form_focus_time') ? {
                    timeMsSinceFocus: createParams.timeMsSinceFocus
                } : {}
            });
            unhighlightIssue(response.itemIdentifiers.issueId);
            return response.item;
        } catch (error) {
            let finalError = error;
            try {
                if (error instanceof (0, $jJZqs.ValidationError)) {
                    const { issueId: issueId, issueKey: issueKey } = await showCreateIssueDialog(createParams.input, rankFieldId, {
                        transitionId: transitionId
                    });
                    highlightIssue(issueId);
                    const issue = await onRefetchIssue(issueId, createParams.fieldIdsToReturn, !ignoreFiltersContext);
                    if (createParams.showSuccessFlag) showCreateSuccessFlag(issueKey, issueTypeName);
                    unhighlightIssue(issueId);
                    return issue;
                }
                if (error instanceof Error) (0, $jcw0u.default)({
                    meta: {
                        id: 'JWMCreateIssueInline',
                        packageName: 'jiraBusinessIssueCreate',
                        teamName: 'deliveroo'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            } catch (refetchError) {
                finalError = refetchError;
            }
            if (finalError instanceof (0, $8roPX.CancelledError)) return null;
            const getTitle = ()=>{
                if ((0, $6s1PB.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false)) return (0, $fb3JB.default).errorFlagTitleIssueTerminologyRefreshM4;
                if ((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) return (0, $fb3JB.default).errorFlagTitleIssueTermRefresh;
                return (0, $fb3JB.default).errorFlagTitle;
            };
            showFlag({
                type: 'error',
                title: formatMessage(getTitle(), {
                    workType: issueTypeName
                }),
                description: formatMessage((0, $fb3JB.default).errorFlagDescription),
                messageId: 'business-issue-create.controllers.create-issue.show-flag.error',
                messageType: 'transactional'
            });
            throw finalError;
        }
    }, [
        getTransitionId,
        typesWithFields,
        onCreateIssue,
        createAnalyticsEvent,
        showCreateSuccessFlag,
        showFlag,
        formatMessage,
        showCreateIssueDialog,
        onRefetchIssue
    ]);
};

});
parcelRegister("l9KLJ", function(module, exports) {

$parcel$export(module.exports, "WorkflowsProvider", () => $a3eac8b2a2bf7ce6$export$80a1d3130ff3ec75);
$parcel$export(module.exports, "useWorkflows", () => $a3eac8b2a2bf7ce6$export$437f9bd807b88beb);

var $5uXOq = parcelRequire("5uXOq");

var $7HGHK = parcelRequire("7HGHK");
var $pa9q9 = parcelRequire("pa9q9");

var $6ZYlM = parcelRequire("6ZYlM");

var $lDVEA = parcelRequire("lDVEA");
const $a3eac8b2a2bf7ce6$var$FETCH_WORKFLOW_FLAG_ID = (0, $7HGHK.toFlagId)('fetch-board-error-flag');
const $a3eac8b2a2bf7ce6$var$WorkflowsContext = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
const $a3eac8b2a2bf7ce6$export$80a1d3130ff3ec75 = ({ children: children, enabled: enabled = true, workflows: workflows })=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { fetch: fetch, data: data, error: error } = (0, $6ZYlM.useFetchWorkflows)();
    (0, $5uXOq.useEffect)(()=>{
        if (enabled && workflows == null) fetch();
    }, [
        enabled,
        fetch,
        workflows
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (error) showFlag({
            id: $a3eac8b2a2bf7ce6$var$FETCH_WORKFLOW_FLAG_ID,
            type: 'error',
            title: (0, $lDVEA.default).workflowsErrorTitle,
            description: (0, $lDVEA.default).workflowsErrorDescription,
            messageId: 'business-workflows.controllers.workflows-context.show-flag.error',
            messageType: 'transactional'
        });
    }, [
        error,
        showFlag
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3eac8b2a2bf7ce6$var$WorkflowsContext.Provider, {
        value: workflows ?? data
    }, children);
};
const $a3eac8b2a2bf7ce6$export$437f9bd807b88beb = ()=>(0, $5uXOq.useContext)($a3eac8b2a2bf7ce6$var$WorkflowsContext);

});
parcelRegister("6ZYlM", function(module, exports) {

$parcel$export(module.exports, "useFetchWorkflows", () => $8896012bd25091f7$export$41ba56ef14d1b9b1);
/* eslint-disable @typescript-eslint/no-non-null-assertion */ 
var $5uXOq = parcelRequire("5uXOq");

var $5tTFS = parcelRequire("5tTFS");

var $daQYX = parcelRequire("daQYX");

var $jcw0u = parcelRequire("jcw0u");

var $6V9lc = parcelRequire("6V9lc");
const $8896012bd25091f7$export$41ba56ef14d1b9b1 = ()=>{
    const project = (0, $daQYX.useProject)();
    const [fetch, { data: data, loading: loading, error: error, refetch: refetch, called: called }] = (0, $5tTFS.useLazyQuery)((0, $6V9lc.WORKFLOWS_QUERY), {
        variables: {
            projectId: project.id,
            first: 100
        },
        onError: (apolloError)=>{
            (0, $jcw0u.default)({
                meta: {
                    id: 'jwmFetchWorkflows',
                    packageName: 'jiraBusinessWorkflows',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to fetch workflows'
                },
                error: apolloError,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    });
    const workflowsDetails = (0, $5uXOq.useMemo)(()=>data?.jwmWorkflowWithIssueTypes?.edges?.map((edge)=>{
            const { workflow: workflow, issueTypes: issueTypes } = edge?.node || {};
            return {
                workflowId: workflow.workflowId,
                name: workflow?.name ?? undefined,
                transitions: workflow.transitions.edges.map((transitionEdge)=>({
                        transitionId: transitionEdge.node.transitionId,
                        name: transitionEdge.node.name ?? undefined,
                        isInitial: transitionEdge.node.isInitial,
                        isGlobal: transitionEdge.node.isGlobal,
                        isConditional: transitionEdge.node.isConditional,
                        to: {
                            statusId: transitionEdge.node.to.statusId
                        }
                    })),
                issueTypes: issueTypes.edges.map((issueTypeEdge)=>({
                        issueTypeId: issueTypeEdge.node.issueTypeId,
                        name: issueTypeEdge.node.name,
                        avatarUrl: issueTypeEdge.node.avatar.medium,
                        hierarchyLevel: issueTypeEdge.node.hierarchy.level
                    }))
            };
        }), [
        data
    ]);
    return {
        fetch: fetch,
        data: workflowsDetails,
        loading: loading,
        error: error,
        refetch: refetch,
        called: called
    };
};

});
parcelRegister("6V9lc", function(module, exports) {

$parcel$export(module.exports, "WORKFLOWS_QUERY", () => $ece8b64659728495$export$d54deb6c2b9695b7);

var $5cllN = parcelRequire("5cllN");
const $ece8b64659728495$export$d54deb6c2b9695b7 = (0, $5cllN.default)`
    query JWMWorkflowWithIssueTypes($projectId: Long!, $filter: JWMWorkflowWithIssueTypesFilter, $first: Int, $after: String, $last: Int, $before: String) {
        jwmWorkflowWithIssueTypes(projectId: $projectId, filter: $filter, first: $first, after: $after, last: $last, before: $before) {
            edges {
                node {
                    workflow {
                        workflowId
                        name
                        transitions(first: $first) {
                            edges {
                                node {
                                    transitionId
                                    name
                                    isInitial
                                    isGlobal
                                    isConditional
                                    to {
                                        statusId
                                    }
                                }
                            }
                        }
                    }
                    issueTypes(first: $first) {
                        edges {
                            node {
                                issueTypeId
                                name
                                avatar {
                                  medium
                                }
                              	hierarchy {
                              	  level
                              	}
                            }
                        }
                    }
                }
            }
        }
    }
`;

});


parcelRegister("lDVEA", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3db26a0042253e3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a3db26a0042253e3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    workflowsErrorTitle: {
        "id": "business-workflows.controllers.workflows-context.workflows-error-title",
        "defaultMessage": "Failed to load workflows details"
    },
    workflowsErrorDescription: {
        "id": "business-workflows.controllers.workflows-context.workflows-error-description",
        "defaultMessage": "We couldn't load your workflow details, try refreshing the page or try again later."
    }
});

});


parcelRegister("kpiI3", function(module, exports) {

$parcel$export(module.exports, "hasAllRequiredFields", () => $5d73fa9073989726$export$146976a1cbd99cd0);

var $hE5wF = parcelRequire("hE5wF");

var $5fc53 = parcelRequire("5fc53");
const $5d73fa9073989726$export$146976a1cbd99cd0 = ({ issueType: issueType, createInput: createInput })=>{
    if (!issueType) return false;
    return issueType.fields.every((field)=>{
        if (!field.fieldConfig?.isRequired) return true;
        if (!field.type && !field.aliasFieldId) return false;
        if (field.aliasFieldId && field.aliasFieldId === (0, $hE5wF.START_DATE_ALIAS_FIELD_ID)) return Boolean(createInput.startDate);
        if (field.aliasFieldId === (0, $hE5wF.STORY_POINTS_ALIAS_FIELD_ID)) return createInput.storyPoints != null;
        if (field.type) switch(field.type){
            case 0, $5fc53.ISSUE_TYPE:
            case 0, $5fc53.REPORTER_TYPE:
                return true;
            case 0, $5fc53.SUMMARY_TYPE:
                return Boolean(createInput.summary);
            case 0, $5fc53.PRIORITY_TYPE:
                return Boolean(createInput.priority);
            case 0, $5fc53.ASSIGNEE_TYPE:
                return Boolean(createInput.assignee);
            case 0, $5fc53.DUE_DATE_TYPE:
                return Boolean(createInput.dueDate);
            case 0, $5fc53.CATEGORY_TYPE:
                return Boolean(createInput.category);
            case 0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE:
                return createInput.storyPointEstimate != null;
            case 0, $5fc53.SPRINT_TYPE:
                return Boolean(createInput.sprint);
            default:
                break;
        }
        return false;
    });
};

});

parcelRegister("8roPX", function(module, exports) {

$parcel$export(module.exports, "CancelledError", () => $549ab3c244a8a20a$export$a8430ed4188f35a9);
$parcel$export(module.exports, "useCreateIssueDialog", () => $549ab3c244a8a20a$export$8254d39962ec7361);

var $5uXOq = parcelRequire("5uXOq");

var $1T2vX = parcelRequire("1T2vX");

var $5eGnF = parcelRequire("5eGnF");

var $9svjh = parcelRequire("9svjh");

var $hULKg = parcelRequire("hULKg");

var $5rzqz = parcelRequire("5rzqz");

var $3ZKGh = parcelRequire("3ZKGh");
class $549ab3c244a8a20a$export$a8430ed4188f35a9 extends Error {
}
const $549ab3c244a8a20a$export$8d1d8a0d2a7917ac = ()=>{
    const { typesWithFields: typesWithFields } = (0, $1T2vX.useIssueTypesAndFields)({
        issueOperation: 'CREATE'
    });
    return (0, $5uXOq.useCallback)((issueType, predicate)=>{
        if (!issueType) return undefined;
        const issueTypeWithFields = typesWithFields.find((typeWithFields)=>typeWithFields.issueType.id === issueType.id);
        return issueTypeWithFields?.fields.find(predicate);
    }, [
        typesWithFields
    ]);
};
const $549ab3c244a8a20a$export$8254d39962ec7361 = ()=>{
    const [, { openIssueCreateModal: openIssueCreateModal }] = (0, $5rzqz.useTriggerIssueCreateModal)();
    const { subscribe: subscribe } = (0, $9svjh.useGICLifeCycleEvents)();
    const getField = $549ab3c244a8a20a$export$8d1d8a0d2a7917ac();
    return (0, $5uXOq.useCallback)((createInput, rankFieldId, extraPayload)=>new Promise((resolve, reject)=>{
            const unsubscribe = subscribe((0, $5eGnF.GIC_LIFECYCLE_EVENTS).MODAL_KEEP_EDITING_EXISTING_ISSUE, ()=>{
                // the user cancelled editing
                onClose(null);
            });
            // resolve the promise once the GIC has been closed or reject it if cancelled
            const onClose = (data)=>{
                const result = data?.[0];
                if (result) resolve(result);
                else // adding a delay upon user cancelling because of a bug in the GIC's state management logic ICO-303
                setTimeout(()=>{
                    reject(new $549ab3c244a8a20a$export$a8430ed4188f35a9('User cancelled'));
                }, 100);
                unsubscribe();
            };
            const { payload: payload, submitApiData: submitApiData } = (0, $3ZKGh.buildGICPayload)({
                createInput: createInput,
                extraPayload: extraPayload,
                rankFieldId: rankFieldId,
                getField: getField
            });
            const isSubTaskCreationOpen = createInput.issueType?.hierarchyLevel === -1;
            openIssueCreateModal({
                id: 'jwm-create-issue-dialog',
                onClose: onClose,
                payload: payload,
                context: {
                    projectId: createInput.projectId,
                    submitApiData: submitApiData
                },
                isSubTaskCreationOpen: isSubTaskCreationOpen,
                triggerPointKey: (0, $hULKg.JWM_INLINE_CREATE),
                disableProjectDropdown: true,
                disableIssueTypeDropdown: Boolean(payload.issueType?.issueTypeId),
                disableCreationSuccessFlag: true,
                displayCreateAnotherIssueToggle: false,
                minimizableModalView: 'mini'
            });
        }), [
        getField,
        openIssueCreateModal,
        subscribe
    ]);
};

});
parcelRegister("5eGnF", function(module, exports) {

$parcel$export(module.exports, "GIC_LIFECYCLE_EVENTS", () => $700db8c378cd19d9$export$876003a5b887f37e);
const $700db8c378cd19d9$export$876003a5b887f37e = {
    MODAL_OPENED: 'MODAL_OPENED',
    MODAL_CLOSED: 'MODAL_CLOSED',
    MODAL_KEEP_EDITING_EXISTING_ISSUE: 'MODAL_KEEP_EDITING',
    MODAL_DISCARD_EXISTING_IN_PROGRESS_ISSUE: 'MODAL_DISCARD',
    MODAL_DISCARD_SUGGESTED_ISSUE: 'MODAL_DISCARD_SUGGESTED_ISSUE',
    MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES: 'MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES',
    MODAL_DISCARD_ALL_SUGGESTED_ISSUES: 'MODAL_DISCARD_ALL_SUGGESTED_ISSUES',
    CREATE_FORM_FIELD_CONFIG_UPDATE: 'CREATE_FORM_FIELD_CONFIG_UPDATE',
    CREATE_FORM_FIELD_VALUE_CHANGE: 'CREATE_FORM_FIELD_VALUE_CHANGE',
    ISSUE_CREATE_SUCCESS: 'ISSUE_CREATE_SUCCESS',
    PROJECT_FIELD_VALUE_CHANGE: 'PROJECT_FIELD_VALUE_CHANGE',
    ISSUE_TYPE_FIELD_VALUE_CHANGE: 'ISSUE_TYPE_FIELD_VALUE_CHANGE',
    RESET_FORM_FIELDS_FOR_CREATE_ANOTHER: 'RESET_FORM_FIELDS_FOR_CREATE_ANOTHER',
    USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE: 'USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE',
    STATUS_FIELD_STATE_CHANGE: 'STATUS_FIELD_STATE_CHANGE',
    CREATE_FORM_FIELD_BLUR: 'CREATE_FORM_FIELD_BLUR',
    CLASSIFICATION_LEVEL_FIELD_CHANGE: 'CLASSIFICATION_LEVEL_FIELD_CHANGE',
    FORM_CONTEXT_STATE_CHANGE: 'FORM_CONTEXT_STATE_CHANGE'
};

});

parcelRegister("9svjh", function(module, exports) {

$parcel$export(module.exports, "useGICLifeCycleEvents", () => $d9b2e43e4699b192$export$e3ff72f196296fcc);

var $1mrD8 = parcelRequire("1mrD8");
const $d9b2e43e4699b192$var$GICLifeCycleEventsService = new (0, $1mrD8.PubSubHub)();
const $d9b2e43e4699b192$export$e3ff72f196296fcc = ()=>({
        ...$d9b2e43e4699b192$var$GICLifeCycleEventsService
    });

});
parcelRegister("1mrD8", function(module, exports) {

$parcel$export(module.exports, "PubSubHub", () => $6e9a69c6f6f4fcfe$export$e3607828f8f2c01e);
class $6e9a69c6f6f4fcfe$export$e3607828f8f2c01e {
    constructor(){
        this.subscribers = {};
        this.subscribe = (event, subscriber)=>{
            let subs = this.subscribers[event];
            if (!subs) {
                subs = [];
                this.subscribers[event] = subs;
            }
            subs?.push(subscriber);
            return ()=>this.unsubscribe(event, subscriber);
        };
        this.unsubscribe = (event, subscriber)=>{
            const subs = this.subscribers[event];
            if (subs) this.subscribers[event] = subs.filter((subscription)=>subscription !== subscriber);
        };
        this.publish = (event, data)=>{
            const subs = this.subscribers[event];
            if (subs?.length) subs?.forEach((subscriber)=>subscriber(data));
        };
        this.clearAll = ()=>{
            this.subscribers = {};
        };
    }
}

});


parcelRegister("3ZKGh", function(module, exports) {

$parcel$export(module.exports, "buildGICPayload", () => $1e0041a78523c89b$export$eb18ffe6388f217a);
/* eslint-disable @typescript-eslint/no-non-null-assertion */ 
var $f9ece = parcelRequire("f9ece");

var $k7m40 = parcelRequire("k7m40");
var $el0er = parcelRequire("el0er");

var $4R6GH = parcelRequire("4R6GH");

var $hE5wF = parcelRequire("hE5wF");

var $5fc53 = parcelRequire("5fc53");
const $1e0041a78523c89b$var$assigneeFieldPredicate = (field)=>field.type === (0, $5fc53.ASSIGNEE_TYPE);
const $1e0041a78523c89b$var$categoryFieldPredicate = (field)=>field.type === (0, $5fc53.CATEGORY_TYPE);
const $1e0041a78523c89b$var$dueDateFieldPredicate = (field)=>field.type === (0, $5fc53.DUE_DATE_TYPE);
const $1e0041a78523c89b$var$priorityFieldPredicate = (field)=>field.type === (0, $5fc53.PRIORITY_TYPE);
const $1e0041a78523c89b$var$startDateFieldPredicate = (field)=>field.aliasFieldId === (0, $hE5wF.START_DATE_ALIAS_FIELD_ID);
const $1e0041a78523c89b$var$storyPointEstimateFieldPredicate = (field)=>field.type === (0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE);
const $1e0041a78523c89b$var$storyPointsFieldPredicate = (field)=>field.type === (0, $5fc53.NUMBER_CF_TYPE) && field.aliasFieldId === (0, $hE5wF.STORY_POINTS_ALIAS_FIELD_ID);
const $1e0041a78523c89b$var$sprintFieldPredicate = (field)=>field.type === (0, $5fc53.SPRINT_TYPE);
const $1e0041a78523c89b$export$eb18ffe6388f217a = ({ createInput: createInput, extraPayload: extraPayload, rankFieldId: rankFieldId, getField: getField })=>{
    const payload = {
        defaultValues: {
            singleLineTextFields: [],
            singleSelectUserPickerFields: [],
            numberFields: [],
            datePickerFields: []
        },
        project: {
            projectId: createInput.projectId
        }
    };
    const additionalFields = {};
    let transition;
    if (createInput.summary) payload.defaultValues.singleLineTextFields.push({
        fieldId: (0, $5fc53.SUMMARY_TYPE),
        text: createInput.summary
    });
    if (createInput.issueType) payload.issueType = {
        issueTypeId: createInput.issueType.id
    };
    if (createInput.dueDate && getField(createInput.issueType, $1e0041a78523c89b$var$dueDateFieldPredicate)) {
        const formattedDueDate = (0, $4R6GH.fg)('change-timezone-formatting-in-duedate-for-icc') ? (0, $k7m40.default)((0, $el0er.default)(createInput.dueDate), 'yyyy-MM-dd') : (0, $f9ece.default)(createInput.dueDate, 'UTC', 'yyyy-MM-dd');
        payload.defaultValues.datePickerFields.push({
            fieldId: (0, $5fc53.DUE_DATE_TYPE),
            date: {
                formattedDate: formattedDueDate
            }
        });
        additionalFields.duedate = formattedDueDate;
    }
    const startDateField = getField(createInput.issueType, $1e0041a78523c89b$var$startDateFieldPredicate);
    if (createInput.startDate && startDateField) {
        const formattedStartDate = (0, $f9ece.default)(createInput.startDate, 'UTC', 'yyyy-MM-dd');
        payload.defaultValues.datePickerFields.push({
            fieldId: startDateField.id,
            date: {
                formattedDate: formattedStartDate
            }
        });
        additionalFields[startDateField.id] = formattedStartDate;
    }
    if (createInput.assignee && getField(createInput.issueType, $1e0041a78523c89b$var$assigneeFieldPredicate)) {
        payload.defaultValues.singleSelectUserPickerFields.push({
            fieldId: (0, $5fc53.ASSIGNEE_TYPE),
            user: {
                accountId: createInput.assignee.accountId
            }
        });
        additionalFields[0, $5fc53.ASSIGNEE_TYPE] = {
            id: createInput.assignee.accountId
        };
    }
    if (createInput.priority && getField(createInput.issueType, $1e0041a78523c89b$var$priorityFieldPredicate)) {
        payload.defaultValues.priority = {
            priorityId: createInput.priority.priorityId
        };
        additionalFields[0, $5fc53.PRIORITY_TYPE] = {
            id: createInput.priority.priorityId
        };
    }
    const categoryField = getField(createInput.issueType, $1e0041a78523c89b$var$categoryFieldPredicate);
    if (createInput.category && categoryField) {
        payload.defaultValues.singleSelectFields = [
            {
                fieldId: categoryField.id,
                option: {
                    id: createInput.category.optionId,
                    optionId: createInput.category.optionId
                }
            }
        ];
        additionalFields[categoryField.id] = {
            id: createInput.category.optionId,
            value: createInput.category.value
        };
    }
    const storyPointEstimateField = getField(createInput.issueType, $1e0041a78523c89b$var$storyPointEstimateFieldPredicate);
    if (createInput.storyPointEstimate && storyPointEstimateField) {
        payload.defaultValues.numberFields.push({
            fieldId: storyPointEstimateField.id,
            value: createInput.storyPointEstimate
        });
        additionalFields[storyPointEstimateField.id] = {
            id: storyPointEstimateField.id,
            value: createInput.storyPointEstimate
        };
    }
    const storyPointsField = getField(createInput.issueType, $1e0041a78523c89b$var$storyPointsFieldPredicate);
    if (createInput.storyPoints && storyPointsField) {
        payload.defaultValues.numberFields.push({
            fieldId: storyPointsField.id,
            value: createInput.storyPoints
        });
        additionalFields[storyPointsField.id] = {
            id: storyPointsField.id,
            value: createInput.storyPoints
        };
    }
    const sprintField = getField(createInput.issueType, $1e0041a78523c89b$var$sprintFieldPredicate);
    if (createInput.sprint && sprintField) {
        payload.defaultValues.sprintsField = {
            fieldId: sprintField.id,
            sprints: [
                {
                    sprintId: createInput.sprint.id
                }
            ]
        };
        additionalFields[sprintField.id] = {
            id: sprintField.id,
            value: createInput.sprint.id
        };
    }
    if (createInput.parentIssueId) {
        payload.parentId = {
            parentId: createInput.parentIssueId
        };
        payload.defaultValues.parentField = {
            issueId: createInput.parentIssueId
        };
    }
    if (createInput.status && extraPayload?.transitionId) {
        payload.status = {
            statusId: createInput.status.statusId
        };
        transition = {
            id: extraPayload.transitionId
        };
    }
    if (rankFieldId && (createInput.rankAfter || createInput.rankBefore)) // rank is always passed as additional field
    additionalFields[rankFieldId] = {
        ...createInput.rankAfter ? {
            rankAfterIssue: createInput.rankAfter.issueId
        } : {},
        ...createInput.rankBefore ? {
            rankBeforeIssue: createInput.rankBefore.issueId
        } : {}
    };
    return {
        payload: payload,
        submitApiData: {
            additionalFields: additionalFields,
            transition: transition
        }
    };
};

});


parcelRegister("lVeTj", function(module, exports) {

$parcel$export(module.exports, "useShowCreateSuccessFlag", () => $374f26855338ec61$export$dfe953d11a91d407);

var $5uXOq = parcelRequire("5uXOq");

var $hE5wF = parcelRequire("hE5wF");

var $l0oHX = parcelRequire("l0oHX");

var $6s1PB = parcelRequire("6s1PB");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $ieDtd = parcelRequire("ieDtd");

var $64qgp = parcelRequire("64qgp");

var $7dMty = parcelRequire("7dMty");
const $374f26855338ec61$export$dfe953d11a91d407 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    const [, setSelectedIssueKey] = (0, $ieDtd.useQueryParam)((0, $hE5wF.SELECTED_ISSUE_PARAM));
    return (0, $5uXOq.useCallback)((issueKey, workType)=>{
        const flagId = `jwm-create-success-flag-${issueKey}`;
        const getTitle = ()=>{
            if ((0, $6s1PB.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false)) return (0, $7dMty.default).createSuccessFlagTitleIssueTerminologyRefreshM4;
            if ((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) return (0, $7dMty.default).createSuccessFlagTitleIssueTermRefresh;
            return (0, $7dMty.default).createSuccessFlagTitle;
        };
        const getAction = ()=>{
            if (workType && (0, $64qgp.isWorkTypeAvgLength)(workType) && (0, $6s1PB.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false)) return (0, $7dMty.default).viewIssueLinkTextIssueTerminologyRefreshM4;
            if ((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) return (0, $7dMty.default).viewIssueLinkTextIssueTermRefresh;
            return (0, $7dMty.default).viewIssueLinkText;
        };
        showFlag({
            id: flagId,
            isAutoDismiss: true,
            type: 'success',
            title: formatMessage(getTitle(), {
                issueKey: issueKey,
                workType: workType
            }),
            messageId: 'business-issue-create.controllers.show-create-success-flag.show-flag.success',
            messageType: 'transactional',
            actions: [
                {
                    content: [
                        getAction(),
                        {
                            workType: workType
                        }
                    ],
                    href: `/browse/${issueKey}`,
                    onClick: (event)=>{
                        if (event && !(0, $l0oHX.isModifiedEvent)(event)) {
                            setSelectedIssueKey(issueKey);
                            event.preventDefault();
                            event.stopPropagation();
                        }
                        dismissFlag(flagId);
                    }
                }
            ]
        });
    }, [
        dismissFlag,
        formatMessage,
        setSelectedIssueKey,
        showFlag
    ]);
};

});
parcelRegister("l0oHX", function(module, exports) {

$parcel$export(module.exports, "isModifiedEvent", () => $6c9cca471f547e7f$export$642c6f14f6d4bbd5);
const $6c9cca471f547e7f$export$642c6f14f6d4bbd5 = (event)=>Boolean(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);

});

parcelRegister("64qgp", function(module, exports) {

$parcel$export(module.exports, "isWorkTypeAvgLength", () => $75f802d4e52cf385$export$cc4247ae0afa23ac);
const $75f802d4e52cf385$var$WORK_TYPE_AVG_LENGTH = 30;
const $75f802d4e52cf385$export$cc4247ae0afa23ac = (workType)=>workType.length < $75f802d4e52cf385$var$WORK_TYPE_AVG_LENGTH;

});

parcelRegister("7dMty", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ecb7a23bce33f96$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9ecb7a23bce33f96$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createSuccessFlagTitle: {
        "id": "business-issue-create.controllers.show-create-success-flag.create-success-flag-title",
        "defaultMessage": "You've created issue \"{issueKey}\""
    },
    viewIssueLinkText: {
        "id": "business-issue-create.controllers.show-create-success-flag.view-issue-link-text",
        "defaultMessage": "View issue"
    },
    createSuccessFlagTitleIssueTermRefresh: {
        "id": "business-issue-create.controllers.show-create-success-flag.create-success-flag-title-issue-term-refresh",
        "defaultMessage": "You've created work item \"{issueKey}\""
    },
    createSuccessFlagTitleIssueTerminologyRefreshM4: {
        "id": "business-issue-create.controllers.show-create-success-flag.create-success-flag-title-issue-terminology-refresh-m4",
        "defaultMessage": "Created {workType} \"{issueKey}\""
    },
    viewIssueLinkTextIssueTermRefresh: {
        "id": "business-issue-create.controllers.show-create-success-flag.view-issue-link-text-issue-term-refresh",
        "defaultMessage": "View"
    },
    viewIssueLinkTextIssueTerminologyRefreshM4: {
        "id": "business-issue-create.controllers.show-create-success-flag.view-issue-link-text-issue-terminology-refresh-m4",
        "defaultMessage": "View {workType}"
    }
});

});


parcelRegister("fb3JB", function(module, exports) {

$parcel$export(module.exports, "default", () => $87c4612732d8fc8d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $87c4612732d8fc8d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorFlagTitle: {
        "id": "business-issue-create.controllers.create-issue.error-flag-title",
        "defaultMessage": "We weren't able to create an issue"
    },
    errorFlagDescription: {
        "id": "business-issue-create.controllers.create-issue.error-flag-description",
        "defaultMessage": "Refresh the page and try again."
    },
    errorFlagTitleIssueTermRefresh: {
        "id": "business-issue-create.controllers.create-issue.error-flag-title-issue-term-refresh",
        "defaultMessage": "We weren't able to create a work item"
    },
    errorFlagTitleIssueTerminologyRefreshM4: {
        "id": "business-issue-create.controllers.create-issue.error-flag-title-issue-terminology-refresh-m4",
        "defaultMessage": "We can't create the {workType}"
    }
});

});


parcelRegister("ecPXN", function(module, exports) {

$parcel$export(module.exports, "useCreateParamHandler", () => $eb6f03408afb5aea$export$294bf5b0ba86140);

var $5uXOq = parcelRequire("5uXOq");

var $hE5wF = parcelRequire("hE5wF");

var $daQYX = parcelRequire("daQYX");

var $ieDtd = parcelRequire("ieDtd");

var $8roPX = parcelRequire("8roPX");
const $eb6f03408afb5aea$export$294bf5b0ba86140 = (rankFieldId)=>{
    const [inlineCreateParam, setInlineCreateParam] = (0, $ieDtd.useQueryParam)((0, $hE5wF.INLINE_CREATE_PARAM));
    const showCreateIssueDialog = (0, $8roPX.useCreateIssueDialog)();
    const project = (0, $daQYX.useProject)();
    (0, $5uXOq.useEffect)(()=>{
        if (inlineCreateParam != null) {
            showCreateIssueDialog({
                projectId: String(project.id)
            }, rankFieldId).catch(()=>{
            // we don't care about the error in this scenario
            });
            setInlineCreateParam(undefined);
        }
    }, [
        inlineCreateParam,
        project,
        rankFieldId,
        setInlineCreateParam,
        showCreateIssueDialog
    ]);
};

});


parcelRegister("lL5b5", function(module, exports) {

$parcel$export(module.exports, "default", () => $07c2532655d93687$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $j0xEB = parcelRequire("j0xEB");

var $j2Jlg = parcelRequire("j2Jlg");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$07c2532655d93687$export$2e2bcd8739ae039 = ()=>{
    const { href: href = null } = (0, $j0xEB.default)() || {};
    if (href && !href.includes('login.jsp')) {
        const encodedRedirectUrl = encodeURIComponent(href);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j2Jlg.default), {
            url: `/login.jsp?os_destination=${encodedRedirectUrl}`
        });
    }
    return null;
};

});
parcelRegister("j2Jlg", function(module, exports) {

$parcel$export(module.exports, "default", () => $773e6f988af77e5c$export$2e2bcd8739ae039);

var $gKZoD = parcelRequire("gKZoD");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$773e6f988af77e5c$export$2e2bcd8739ae039 = ({ url: url })=>{
    (0, $gKZoD.di)(window);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.assign(url);
    return null;
};

});


parcelRegister("kLaXN", function(module, exports) {

$parcel$export(module.exports, "AuthenticationErrorBoundary", () => $2792454dc55144b9$export$124b2dc1d1aab5e6);

var $5uXOq = parcelRequire("5uXOq");

var $fPruT = parcelRequire("fPruT");
class $2792454dc55144b9$export$124b2dc1d1aab5e6 extends (0, $5uXOq.Component) {
    componentDidCatch(error, info) {
        if (error instanceof (0, $fPruT.AuthenticationError)) {
            this.setState({
                caughtError: {
                    error: error,
                    info: info
                }
            });
            return;
        }
        throw error;
    }
    render() {
        const { caughtError: caughtError } = this.state;
        const { children: children, render: renderFallback } = this.props;
        if (!caughtError) return children;
        return renderFallback();
    }
    constructor(...args){
        super(...args), this.state = {
            caughtError: null
        };
    }
}

});

parcelRegister("4rBJg", function(module, exports) {

$parcel$export(module.exports, "FiltersJqlProvider", () => $5cd36cb66237f349$export$ab33e8ef78c4167e);

var $5uXOq = parcelRequire("5uXOq");

var $x8FYU = parcelRequire("x8FYU");

var $1kpI8 = parcelRequire("1kpI8");

var $l4Ejo = parcelRequire("l4Ejo");
const $5cd36cb66237f349$export$ab33e8ef78c4167e = ({ children: children })=>{
    const [jql, saveFilters] = (0, $1kpI8.useViewPreference)((0, $x8FYU.FILTER_PREFERENCE));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l4Ejo.InternalFiltersJqlProvider), {
        jql: jql,
        saveJql: saveFilters
    }, children);
};

});
parcelRegister("x8FYU", function(module, exports) {

$parcel$export(module.exports, "CREATE_TYPE_ID_PREFERENCE", () => $3a8fd327ed3934d4$export$2df4c3d44dcb1e5b);
$parcel$export(module.exports, "EXPANDED_ISSUES_PREFERENCE", () => $3a8fd327ed3934d4$export$638c3932e4cbdede);
$parcel$export(module.exports, "FIELDS_PREFERENCE", () => $3a8fd327ed3934d4$export$e3ddfc509464e305);
$parcel$export(module.exports, "FIELDS_DETAIL_PREFERENCE", () => $3a8fd327ed3934d4$export$ffcb5603c64e12d0);
$parcel$export(module.exports, "FILTER_PREFERENCE", () => $3a8fd327ed3934d4$export$f50d5db589fb1475);
$parcel$export(module.exports, "GROUPING_PREFERENCE", () => $3a8fd327ed3934d4$export$ac8a4771da7f03af);
$parcel$export(module.exports, "HIDE_DONE_ITEMS_PREFERENCE", () => $3a8fd327ed3934d4$export$4aace169721c2927);
$parcel$export(module.exports, "HIDE_SOFTWARE_RELEASE_PREFERENCE", () => $3a8fd327ed3934d4$export$983f0d3325e2938);
$parcel$export(module.exports, "RANGE_MODE_PREFERENCE", () => $3a8fd327ed3934d4$export$f43988a3762bf711);
$parcel$export(module.exports, "SORTING_PREFERENCE", () => $3a8fd327ed3934d4$export$373eea1341dcff74);
$parcel$export(module.exports, "BOARD_VIEW_PREFERENCES", () => $3a8fd327ed3934d4$export$4ec60be96e9eadc0);
$parcel$export(module.exports, "LIST_VIEW_PREFERENCES", () => $3a8fd327ed3934d4$export$43fc1ec27b2f1801);
$parcel$export(module.exports, "CALENDAR_VIEW_PREFERENCES", () => $3a8fd327ed3934d4$export$14e2a519a8c2881a);
$parcel$export(module.exports, "TIMELINE_VIEW_PREFERENCES", () => $3a8fd327ed3934d4$export$8443f3f4fd94276);
$parcel$export(module.exports, "ATTACHMENTS_VIEW_PREFERENCES", () => $3a8fd327ed3934d4$export$2e2923d9c9daba20);

var $hE5wF = parcelRequire("hE5wF");

var $54zCO = parcelRequire("54zCO");
const $3a8fd327ed3934d4$export$5d3f940b56d7af28 = (0, $54zCO.createSimplePreference)('activeWorkflow');
const $3a8fd327ed3934d4$export$8019dfa5a44f6d46 = (0, $54zCO.createSimplePreference)('collapsedColumns');
const $3a8fd327ed3934d4$export$3ef984a9f784490f = (0, $54zCO.createSimplePreference)('columnOrder');
const $3a8fd327ed3934d4$export$2df4c3d44dcb1e5b = (0, $54zCO.createSimplePreference)('createType');
const $3a8fd327ed3934d4$export$638c3932e4cbdede = (0, $54zCO.createSimplePreference)('expandedIssues');
const $3a8fd327ed3934d4$export$e3ddfc509464e305 = (0, $54zCO.createSimplePreference)('fields');
const $3a8fd327ed3934d4$export$ffcb5603c64e12d0 = (0, $54zCO.createSimplePreference)('fieldsDetail');
const $3a8fd327ed3934d4$export$f50d5db589fb1475 = (0, $54zCO.createSimpleUrlPreference)((0, $hE5wF.FILTER_PARAM));
const $3a8fd327ed3934d4$export$ac8a4771da7f03af = (0, $54zCO.createSimpleUrlPreference)('groupBy');
const $3a8fd327ed3934d4$export$4aace169721c2927 = (0, $54zCO.createSimpleUrlPreference)('hideDone');
const $3a8fd327ed3934d4$export$983f0d3325e2938 = (0, $54zCO.createSimpleUrlPreference)('hideSoftwareRelease');
const $3a8fd327ed3934d4$export$f43988a3762bf711 = (0, $54zCO.createSimpleUrlPreference)('rangeMode');
const $3a8fd327ed3934d4$export$373eea1341dcff74 = {
    ...(0, $54zCO.createSimplePreference)('sorting'),
    queryParameter: {
        serialize: (value)=>({
                sortBy: value?.sortBy,
                direction: value?.direction
            }),
        deserialize: (value)=>value.sortBy ? {
                sortBy: value.sortBy,
                direction: value.direction
            } : undefined
    }
};
const $3a8fd327ed3934d4$export$4ec60be96e9eadc0 = [
    $3a8fd327ed3934d4$export$2df4c3d44dcb1e5b,
    $3a8fd327ed3934d4$export$638c3932e4cbdede
];
const $3a8fd327ed3934d4$export$43fc1ec27b2f1801 = [
    $3a8fd327ed3934d4$export$2df4c3d44dcb1e5b,
    $3a8fd327ed3934d4$export$e3ddfc509464e305,
    $3a8fd327ed3934d4$export$ffcb5603c64e12d0,
    $3a8fd327ed3934d4$export$f50d5db589fb1475,
    $3a8fd327ed3934d4$export$ac8a4771da7f03af,
    $3a8fd327ed3934d4$export$4aace169721c2927,
    $3a8fd327ed3934d4$export$373eea1341dcff74
];
const $3a8fd327ed3934d4$export$14e2a519a8c2881a = [
    $3a8fd327ed3934d4$export$2df4c3d44dcb1e5b,
    $3a8fd327ed3934d4$export$f50d5db589fb1475,
    $3a8fd327ed3934d4$export$4aace169721c2927,
    $3a8fd327ed3934d4$export$983f0d3325e2938
];
const $3a8fd327ed3934d4$export$8443f3f4fd94276 = [
    $3a8fd327ed3934d4$export$2df4c3d44dcb1e5b,
    $3a8fd327ed3934d4$export$f50d5db589fb1475,
    $3a8fd327ed3934d4$export$4aace169721c2927,
    $3a8fd327ed3934d4$export$f43988a3762bf711
];
const $3a8fd327ed3934d4$export$2e2923d9c9daba20 = [
    $3a8fd327ed3934d4$export$f50d5db589fb1475
];

});
parcelRegister("54zCO", function(module, exports) {

$parcel$export(module.exports, "createSimplePreference", () => $7a26b5020c269cbd$export$464a71be397e5f3d);
$parcel$export(module.exports, "createSimpleUrlPreference", () => $7a26b5020c269cbd$export$78f3983105936d30);

var $etyzk = parcelRequire("etyzk");
const $7a26b5020c269cbd$export$464a71be397e5f3d = (id)=>({
        id: id,
        serialize: (0, (/*@__PURE__*/$parcel$interopDefault($etyzk))),
        deserialize: (0, (/*@__PURE__*/$parcel$interopDefault($etyzk)))
    });
const $7a26b5020c269cbd$export$78f3983105936d30 = (queryParameter)=>({
        id: queryParameter,
        serialize: (0, (/*@__PURE__*/$parcel$interopDefault($etyzk))),
        deserialize: (0, (/*@__PURE__*/$parcel$interopDefault($etyzk))),
        queryParameter: {
            serialize: (value)=>({
                    [queryParameter]: value
                }),
            deserialize: (value)=>value[queryParameter]
        }
    });

});


parcelRegister("1kpI8", function(module, exports) {

$parcel$export(module.exports, "ViewPreferencesProvider", () => $5141bcd6fd206946$export$1db44e21d818b27);
$parcel$export(module.exports, "useViewPreference", () => $5141bcd6fd206946$export$ee494de6c0ff45d7);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $54qG5 = parcelRequire("54qG5");

var $1XJ20 = parcelRequire("1XJ20");

var $doZTA = parcelRequire("doZTA");

var $kGDhO = parcelRequire("kGDhO");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
const $5141bcd6fd206946$var$ViewPreferencesContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $5141bcd6fd206946$export$1db44e21d818b27 = ({ view: view, preferences: preferences, children: children, persistChanges: persistChanges = true })=>{
    const { data: entity } = (0, $54qG5.useBusinessEntity)();
    const [{ query: query }, routerActions] = (0, $doZTA.useRouter)();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const { updateQueryParam: updateQueryParam } = routerActions;
    const prevQuery = (0, $1XJ20.usePreviousWithInitial)(query);
    const [store, setStore] = (0, $5uXOq.useState)(()=>preferences.reduce((acc, preference)=>{
            let value;
            const { id: id, queryParameter: queryParameter } = preference;
            // a preference value of an empty string, indicates that any value in local storage should be ignored and cleared
            const rawQueryValue = queryParameter && queryParameter.deserialize(query);
            const hasQueryValue = rawQueryValue !== undefined;
            // if the URL has a preference value set
            // we prioritize those values over the persisted ones
            if (hasQueryValue) // if the value matches the clearable value, we treat the value as `undefined`
            value = rawQueryValue === '' ? undefined : rawQueryValue;
            else if (persistChanges) value = preference.deserialize((0, $kGDhO.getPreference)(entity.id, view, preference.id));
            acc[id] = value;
            return acc;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        }, {}));
    const setPreferenceValue = (0, $5uXOq.useCallback)((preference, value, action)=>{
        // set the new preference value in the store
        setStore((prevStore)=>{
            const newStore = {
                ...prevStore,
                [preference.id]: value
            };
            return newStore;
        });
        // if the preference serialises to the URL, update the URL
        if (preference.queryParameter && action !== 'none') updateQueryParam(preference.queryParameter.serialize(value), action);
        // if the view is persisting changes, update the preference in local storage
        if (persistChanges) {
            const serializedValue = preference.serialize(value);
            (0, $kGDhO.setPreference)(entity.id, view, preference.id, serializedValue);
        }
    }, [
        persistChanges,
        updateQueryParam,
        entity.id,
        view
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // if the view is persisting changes, on initial mount
        // check all preferences that serialise to the URL, and set their values to the URL
        if (!persistChanges) return;
        let restoredQuery = {};
        for (const preference of preferences){
            const value = store[preference.id];
            if (value && preference.queryParameter) restoredQuery = {
                ...restoredQuery,
                ...preference.queryParameter.serialize(value)
            };
        }
        updateQueryParam({
            ...restoredQuery,
            ...query
        }, 'replace');
    // only run this effect on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        // this effect updates the store value only when the query has changed
        // we shouldn't run it when the component is mounting the first time
        // or when the query hasn't changed
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(prevQuery, query)) {
            // update the store if the query is updated
            const newState = preferences.reduce((acc, preference)=>{
                const { id: id, queryParameter: queryParameter } = preference;
                if (queryParameter) {
                    const queryValue = queryParameter.deserialize(query);
                    acc[id] = queryValue;
                }
                return acc;
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            }, {});
            setStore({
                ...store,
                ...newState
            });
        }
    }, [
        preferences,
        query,
        store,
        entity.id,
        view,
        prevQuery
    ]);
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            store: store,
            setPreferenceValue: setPreferenceValue
        }), [
        store,
        setPreferenceValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5141bcd6fd206946$var$ViewPreferencesContext.Provider, {
        value: contextValue
    }, children);
};
const $5141bcd6fd206946$export$ee494de6c0ff45d7 = (preference)=>{
    const { store: store, setPreferenceValue: setPreferenceValue } = (0, $5uXOq.useContext)($5141bcd6fd206946$var$ViewPreferencesContext);
    const setValue = (0, $5uXOq.useCallback)((value, action = 'push')=>{
        setPreferenceValue(preference, value, action);
    }, [
        preference,
        setPreferenceValue
    ]);
    const value = store[preference.id];
    return [
        value,
        setValue
    ];
};

});
parcelRegister("kGDhO", function(module, exports) {

$parcel$export(module.exports, "setPreference", () => $39001b1dd806b76a$export$c6483f3cdc3e51e1);
$parcel$export(module.exports, "getPreference", () => $39001b1dd806b76a$export$5fa261395d19a143);

var $bSSG7 = parcelRequire("bSSG7");
const $39001b1dd806b76a$var$store = (0, $bSSG7.createLocalStorageProvider)('jwm-view-preferences');
const $39001b1dd806b76a$var$buildPreferenceKey = (entityId, viewId, preferenceId)=>`${entityId}_${viewId}_${preferenceId}`;
const $39001b1dd806b76a$export$c6483f3cdc3e51e1 = (entityId, viewId, preferenceId, value)=>{
    const key = $39001b1dd806b76a$var$buildPreferenceKey(entityId, viewId, preferenceId);
    $39001b1dd806b76a$var$store.set(key, value);
};
const $39001b1dd806b76a$export$5fa261395d19a143 = (entityId, viewId, preferenceId)=>{
    const key = $39001b1dd806b76a$var$buildPreferenceKey(entityId, viewId, preferenceId);
    return $39001b1dd806b76a$var$store.get(key);
};

});


parcelRegister("l4Ejo", function(module, exports) {

$parcel$export(module.exports, "InternalFiltersJqlProvider", () => $8a462d10017c11b6$export$db1e4f4070782197);
$parcel$export(module.exports, "useFiltersPreference", () => $8a462d10017c11b6$export$4eb37722e136bcfd);
$parcel$export(module.exports, "useFilters", () => $8a462d10017c11b6$export$973ca22476b0e05f);

var $5uXOq = parcelRequire("5uXOq");

var $1tESh = parcelRequire("1tESh");
const $8a462d10017c11b6$var$Context = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $8a462d10017c11b6$export$db1e4f4070782197 = ({ children: children, jql: jql, saveJql: saveJql })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8a462d10017c11b6$var$Context.Provider, {
        value: (0, $5uXOq.useMemo)(()=>({
                jql: jql,
                saveJql: saveJql
            }), [
            jql,
            saveJql
        ])
    }, children);
};
const $8a462d10017c11b6$export$4eb37722e136bcfd = ()=>{
    const context = (0, $5uXOq.useContext)($8a462d10017c11b6$var$Context);
    if (!context) throw new Error('useFiltersPreference must be used within a InternalFiltersJqlProvider');
    return context;
};
const $8a462d10017c11b6$export$973ca22476b0e05f = ()=>{
    const { jql: jql, saveJql: saveJql } = $8a462d10017c11b6$export$4eb37722e136bcfd();
    const setFilter = (0, $5uXOq.useCallback)((filters)=>{
        const serialisedJql = (0, $1tESh.serialiseJql)(filters);
        saveJql(serialisedJql !== '' ? serialisedJql : undefined);
    }, [
        saveJql
    ]);
    return {
        jql: jql,
        setFilter: setFilter
    };
};

});
parcelRegister("1tESh", function(module, exports) {

$parcel$export(module.exports, "serialiseJql", () => $1e9d101255159a24$export$e1718e1e441cb0f6);
$parcel$export(module.exports, "extractAnalyticsFilterDataFromJQL", () => $1e9d101255159a24$export$9ee6085825c9cbfa);

var $gccSB = parcelRequire("gccSB");

var $2nvJN = parcelRequire("2nvJN");

var $gwejS = parcelRequire("gwejS");

var $f9ece = parcelRequire("f9ece");

var $iEIQF = parcelRequire("iEIQF");
var $bzbto = parcelRequire("bzbto");
var $l0V05 = parcelRequire("l0V05");

var $7htvz = parcelRequire("7htvz");
const $1e9d101255159a24$var$START_DATE_JQL = 'Start date[Date]';
const $1e9d101255159a24$var$EMPTY = 'EMPTY';
const $1e9d101255159a24$var$getQuotedFieldName = (fieldName)=>`"${fieldName}"`;
const $1e9d101255159a24$var$getFieldNameForJqlRaw = (fieldName)=>{
    // custom fields are indexed by their ids and only work with JQL when referenced as such `cf[id]`.
    if (fieldName.indexOf('customfield_') === 0) {
        const customFieldId = fieldName.split('customfield_')[1];
        return `cf[${customFieldId}]`;
    }
    // date range jql will be formatted to e.g. "Start date[Date]" >= "2021-12-01" AND due < "2021-12-31"
    // the "to" fieldName for the date range will be transformed to "due" in the "serialiseJql" function
    // where "const toFieldName = fieldId === 'dateRange' ? 'due' : fieldName;"
    if (fieldName === 'dateRange') return $1e9d101255159a24$var$START_DATE_JQL;
    return fieldName;
};
const $1e9d101255159a24$var$getFieldNameForJql = (fieldName)=>$1e9d101255159a24$var$getQuotedFieldName($1e9d101255159a24$var$getFieldNameForJqlRaw(fieldName));
const $1e9d101255159a24$var$getFieldIdFromJql = (rawFieldName, getShouldConvertCustomField)=>{
    const fieldName = (0, (/*@__PURE__*/$parcel$interopDefault($2nvJN)))(rawFieldName, '"');
    const shouldConvertCustomField = getShouldConvertCustomField ? getShouldConvertCustomField(fieldName) : true;
    // `cf[id]` -> `customfield_${id}`.
    if (fieldName.indexOf('cf[') === 0 && shouldConvertCustomField) {
        const extraction = new RegExp(/cf\[(.+)\]/).exec(fieldName);
        if (!extraction) return fieldName;
        const fieldId = extraction[1];
        return `customfield_${fieldId}`;
    }
    const startDateJql = $1e9d101255159a24$var$START_DATE_JQL;
    // update this if we add a start date or due date filter
    if (fieldName === startDateJql || fieldName === 'due') return 'dateRange';
    return fieldName;
};
const $1e9d101255159a24$var$sanitizeWord = (word)=>word.replace(/(["\\])/g, '\\$1');
const $1e9d101255159a24$var$sanitizeWordOld = (word)=>word.replace(/'/g, "\\'");
const $1e9d101255159a24$export$e1718e1e441cb0f6 = (filters)=>{
    const jqlQuery = (0, $iEIQF.default).query();
    Object.entries(filters).filter(([, options])=>options != null && (Array.isArray(options) && options.length > 0 || !Array.isArray(options) && typeof options === 'object' && (options.value == null || !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(options.value)))).forEach(([fieldId, options])=>{
        const fieldName = $1e9d101255159a24$var$getFieldNameForJqlRaw(fieldId);
        if (!Array.isArray(options) && typeof options === 'object' && !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(options?.value)) {
            // one additional day will be added to jql 'to' date based on selected date, e.g. when due date is "2021-12-30"
            // date range jql will be formatted to e.g. "Start date[Date]" >= "2021-12-01" AND due < "2021-12-31"
            const toFieldName = fieldId === 'dateRange' ? 'due' : fieldName;
            if (options.value.to != null) {
                const toDate = (0, $f9ece.default)((0, $gwejS.default)(new Date(options.value.to), 1), 'UTC', 'yyyy-MM-dd');
                jqlQuery.appendClause((0, $iEIQF.default).terminalClause((0, $iEIQF.default).field(toFieldName), (0, $iEIQF.default).operator((0, $bzbto.OPERATOR_LT)), (0, $iEIQF.default).valueOperand(toDate)), (0, $3cef51f82b2cbe1d$export$6d6d48d210d3ca97));
            }
            if (options.value.from != null) jqlQuery.appendClause((0, $iEIQF.default).terminalClause((0, $iEIQF.default).field(fieldName), (0, $iEIQF.default).operator((0, $bzbto.OPERATOR_GT_EQUALS)), (0, $iEIQF.default).valueOperand(options.value.from)), (0, $3cef51f82b2cbe1d$export$6d6d48d210d3ca97));
            return;
        }
        if (Array.isArray(options)) {
            const operands = options.map((option)=>{
                if (option.isEmptyOption) return (0, $iEIQF.default).valueOperand((0, $49b29ef7baa2a152$export$1c46dca02aac24dd));
                if (option.value) // Currently, the AST does not sanatize all values correctly (no \ or JQL keywords), so we need to manually wrap in quotes
                // We can remove this once https://jplat.jira.atlassian.cloud/browse/EM-6563 is implemented
                return (0, $iEIQF.default).byText.valueOperand(`"${$1e9d101255159a24$var$sanitizeWord(option.value)}"`);
                return null;
            }).filter((operand)=>operand != null);
            if (operands.length === 1) jqlQuery.appendClause((0, $iEIQF.default).terminalClause((0, $iEIQF.default).field(fieldName), (0, $iEIQF.default).operator((0, $bzbto.OPERATOR_EQUALS)), operands[0]), (0, $3cef51f82b2cbe1d$export$6d6d48d210d3ca97));
            else if (operands.length > 1) jqlQuery.appendClause((0, $iEIQF.default).terminalClause((0, $iEIQF.default).field(fieldName), (0, $iEIQF.default).operator((0, $bzbto.OPERATOR_IN)), (0, $iEIQF.default).listOperand(operands)), (0, $3cef51f82b2cbe1d$export$6d6d48d210d3ca97));
        }
    });
    const jast = (0, $iEIQF.default).jast(jqlQuery);
    return (0, $l0V05.print)(jast, {
        operatorCase: 'upper',
        printWidth: null
    });
};
const $1e9d101255159a24$export$5bd6a523f48a18cd = (filters)=>{
    const pairs = Object.entries(filters).filter(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ([, options])=>options != null && (Array.isArray(options) && options.length > 0 || !Array.isArray(options) && typeof options === 'object' && (options.value == null || !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(options.value)))) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .map(([fieldId, options])=>{
        const fieldName = $1e9d101255159a24$var$getFieldNameForJql(fieldId);
        if (!Array.isArray(options) && typeof options === 'object' && !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(options?.value)) {
            // one additional day will be added to jql 'to' date based on selected date, e.g. when due date is "2021-12-30"
            // date range jql will be formatted to e.g. "Start date[Date]" >= "2021-12-01" AND due < "2021-12-31"
            const toFieldName = fieldId === 'dateRange' ? $1e9d101255159a24$var$getQuotedFieldName('due') : fieldName;
            let toDate;
            if (options.value.to) toDate = (0, $f9ece.default)((0, $gwejS.default)(new Date(options.value.to), 1), 'UTC', 'yyyy-MM-dd');
            else toDate = options.value.to;
            if (options.value.from != null && options.value.to != null) return `${fieldName} >= ${options.value.from} AND ${toFieldName} < ${toDate}`;
            if (options.value.from != null) return `${fieldName} >= ${options.value.from}`;
            return `${toFieldName} < ${toDate}`;
        }
        if (Array.isArray(options)) {
            const values = options.map((option)=>// make sure we don't wrap EMPTY with quotation marks
                option.value === (0, $7htvz.EMPTY_FILTER_VALUE) ? $1e9d101255159a24$var$EMPTY : `'${$1e9d101255159a24$var$sanitizeWordOld(option.value)}'`).join(',');
            if (options.length > 1) return `${fieldName} in (${values})`;
            if (options.length === 1) return `${fieldName} = ${values}`;
        }
        return null;
    });
    return pairs.join(' AND ');
};
const $1e9d101255159a24$var$extractField = (statement)=>{
    let fieldId;
    const dateOperatorRegex = />=|</;
    if (dateOperatorRegex.test(statement)) {
        const operator = statement.includes('>=') ? ' >= ' : ' < ';
        [fieldId] = statement.split(operator);
    }
    if (statement.includes(' = ')) [fieldId] = statement.split(/ = /);
    if (statement.includes(' in ')) [fieldId] = statement.split(' in ');
    if (fieldId) return $1e9d101255159a24$var$getFieldIdFromJql(fieldId);
};
const $1e9d101255159a24$export$9ee6085825c9cbfa = (jql)=>{
    if (!jql) return {};
    return jql.split(/ AND | OR /).map($1e9d101255159a24$var$extractField).reduce((acc, curr)=>{
        if (curr) acc[curr] = true;
        return acc;
    }, {});
};

});
parcelRegister("2nvJN", function(module, exports) {

var $kHBB0 = parcelRequire("kHBB0");

var $6wH7T = parcelRequire("6wH7T");

var $gvFfr = parcelRequire("gvFfr");

var $4TR1Q = parcelRequire("4TR1Q");

var $c2mKc = parcelRequire("c2mKc");

var $jx6Tp = parcelRequire("jx6Tp");

var $jJVtR = parcelRequire("jJVtR");
/**
 * Removes leading and trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trim('  abc  ');
 * // => 'abc'
 *
 * _.trim('-_-abc-_-', '_-');
 * // => 'abc'
 *
 * _.map(['  foo  ', '  bar  '], _.trim);
 * // => ['foo', 'bar']
 */ function $1bb6592c97235e03$var$trim(string, chars, guard) {
    string = $jJVtR(string);
    if (string && (guard || chars === undefined)) return $6wH7T(string);
    if (!string || !(chars = $kHBB0(chars))) return string;
    var strSymbols = $jx6Tp(string), chrSymbols = $jx6Tp(chars), start = $c2mKc(strSymbols, chrSymbols), end = $4TR1Q(strSymbols, chrSymbols) + 1;
    return $gvFfr(strSymbols, start, end).join('');
}
module.exports = $1bb6592c97235e03$var$trim;

});
parcelRegister("4TR1Q", function(module, exports) {

var $2wwA6 = parcelRequire("2wwA6");
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the last unmatched string symbol.
 */ function $39156edc40ecb497$var$charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;
    while(index-- && $2wwA6(chrSymbols, strSymbols[index], 0) > -1);
    return index;
}
module.exports = $39156edc40ecb497$var$charsEndIndex;

});

parcelRegister("c2mKc", function(module, exports) {

var $2wwA6 = parcelRequire("2wwA6");
/**
 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the first unmatched string symbol.
 */ function $8c37507367fba30b$var$charsStartIndex(strSymbols, chrSymbols) {
    var index = -1, length = strSymbols.length;
    while(++index < length && $2wwA6(chrSymbols, strSymbols[index], 0) > -1);
    return index;
}
module.exports = $8c37507367fba30b$var$charsStartIndex;

});


const $3cef51f82b2cbe1d$export$6d6d48d210d3ca97 = 'and';
const $3cef51f82b2cbe1d$export$7b8f0a728d79a753 = 'or';

const $49b29ef7baa2a152$export$38accfc5a5d1c113 = 'value';
const $49b29ef7baa2a152$export$f6049126fd97001f = 'keyword';
const $49b29ef7baa2a152$export$19c7c729db381f9d = 'function';
const $49b29ef7baa2a152$export$fabec4aebba3f4df = 'list';
const $49b29ef7baa2a152$export$1c46dca02aac24dd = 'empty';

parcelRegister("7htvz", function(module, exports) {

$parcel$export(module.exports, "OPTIMISTIC_ID", () => $d5b40c70d7e37442$export$6e40821019289c70);
$parcel$export(module.exports, "CREATE_FILTER_EXPERIENCE", () => $d5b40c70d7e37442$export$d6ceedee35ae2c19);
$parcel$export(module.exports, "UPDATE_FILTER_EXPERIENCE", () => $d5b40c70d7e37442$export$ca3691ea47eec823);
$parcel$export(module.exports, "DELETE_FILTER_EXPERIENCE", () => $d5b40c70d7e37442$export$2a5fce320f18ac6c);
$parcel$export(module.exports, "STAR_FILTER_EXPERIENCE", () => $d5b40c70d7e37442$export$b0ec8deb6068dc3b);
$parcel$export(module.exports, "SAVED_FILTER_EXPERIENCE", () => $d5b40c70d7e37442$export$6c99c87a0ac0052a);
$parcel$export(module.exports, "EMPTY_FILTER_VALUE", () => $d5b40c70d7e37442$export$9ebaf9fe814731d3);
$parcel$export(module.exports, "SIMPLE_SEARCH_PARAM", () => $d5b40c70d7e37442$export$9b72011e2eb8d7d0);
const $d5b40c70d7e37442$export$b8b9d90f9e5bd72b = 'jiraBusinessFilters';
const $d5b40c70d7e37442$export$6e40821019289c70 = 'optimistic-filter-id';
const $d5b40c70d7e37442$export$d6ceedee35ae2c19 = {
    experience: 'filtersCreateSavedFilters',
    packageName: $d5b40c70d7e37442$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $d5b40c70d7e37442$export$ca3691ea47eec823 = {
    experience: 'filtersUpdateSavedFilters',
    packageName: $d5b40c70d7e37442$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $d5b40c70d7e37442$export$2a5fce320f18ac6c = {
    experience: 'filtersDeleteSavedFilters',
    packageName: $d5b40c70d7e37442$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $d5b40c70d7e37442$export$b0ec8deb6068dc3b = {
    experience: 'filtersStarSavedFilters',
    packageName: $d5b40c70d7e37442$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $d5b40c70d7e37442$export$6c99c87a0ac0052a = {
    experience: 'filtersLoadSavedFilters',
    packageName: $d5b40c70d7e37442$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $d5b40c70d7e37442$export$9ebaf9fe814731d3 = null;
const $d5b40c70d7e37442$export$9b72011e2eb8d7d0 = 'text';

});




parcelRegister("eCGEE", function(module, exports) {

$parcel$export(module.exports, "InvalidJQLErrorBoundary", () => $4794a08a435b4ffe$export$c80d0587c83953fe);

var $5uXOq = parcelRequire("5uXOq");

var $c9Ur7 = parcelRequire("c9Ur7");
const $4794a08a435b4ffe$var$JQL_ERROR_TYPE = new Set([
    'FIELD_VALIDATION_FAILED',
    'FIELD_MISSING_HANDLER'
]);
const $4794a08a435b4ffe$var$isInvalidJQLError = (error)=>{
    if (error instanceof (0, $c9Ur7.QueryError)) {
        if ((error.extensions || []).find((err)=>err.statusCode === 400 && $4794a08a435b4ffe$var$JQL_ERROR_TYPE.has(err.errorType ?? ''))) return true;
    }
    return false;
};
class $4794a08a435b4ffe$export$c80d0587c83953fe extends (0, $5uXOq.Component) {
    componentDidCatch(error, info) {
        if ($4794a08a435b4ffe$var$isInvalidJQLError(error)) {
            this.setState({
                caughtError: {
                    error: error,
                    info: info
                }
            });
            return;
        }
        throw error;
    }
    render() {
        const { caughtError: caughtError } = this.state;
        const { children: children, render: renderFallback } = this.props;
        if (!caughtError) return children;
        return renderFallback(this.clearError);
    }
    constructor(...args){
        super(...args), this.state = {
            caughtError: null
        }, this.clearError = ()=>{
            this.setState({
                caughtError: null
            });
        };
    }
}

});
parcelRegister("c9Ur7", function(module, exports) {

$parcel$export(module.exports, "QueryError", () => $835bdf2aa5daa049$export$83dcbdfe8cbc1e17);
const $835bdf2aa5daa049$export$f215947b3d76a6b7 = 'QueryError';
class $835bdf2aa5daa049$export$83dcbdfe8cbc1e17 extends Error {
    constructor(payload){
        super(payload.message ?? undefined);
        this.extensions = payload.extensions;
        this.message = payload.message ?? '';
        this.statusCode = payload.extensions?.[0]?.statusCode ?? -1;
    }
}

});


parcelRegister("6ByXP", function(module, exports) {

$parcel$export(module.exports, "ConditionalWrapper", () => $29a10aa5daca2294$export$39aecc95f0365819);

var $5uXOq = parcelRequire("5uXOq");
const $29a10aa5daca2294$export$39aecc95f0365819 = ({ condition: condition, renderWrapper: renderWrapper, children: children })=>condition ? renderWrapper(children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);

});

parcelRegister("hug5L", function(module, exports) {

$parcel$export(module.exports, "FormatRulesContainer", () => $7cf99983147e2a90$export$2022a9665c731c36);
$parcel$export(module.exports, "useFormatRulesStore", () => $7cf99983147e2a90$export$2fe3fe2e87aa2741);
$parcel$export(module.exports, "useFormatRulesSerialisedJql", () => $7cf99983147e2a90$export$3b2286d9a476f9a1);

var $1tESh = parcelRequire("1tESh");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $4R6GH = parcelRequire("4R6GH");
const $7cf99983147e2a90$var$initialState = {
    rowRules: [],
    cellRulesByFieldId: {},
    issueIdRowRuleMatched: {},
    rulesJqlInput: {}
};
const $7cf99983147e2a90$var$actions = {
    setFormatRules: (rules)=>({ setState: setState })=>{
            const newState = {
                ...rules
            };
            setState(newState);
        },
    setRulesForJqlInput: (input)=>({ setState: setState })=>{
            const newState = {
                rulesJqlInput: input
            };
            setState(newState);
        },
    setMatchedRowRule: ({ rule: rule, issueId: issueId })=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const newState = {
                issueIdRowRuleMatched: {
                    ...currentState.issueIdRowRuleMatched,
                    [issueId]: rule
                }
            };
            setState(newState);
        },
    removeMatchedRowRule: ({ ruleId: ruleId })=>({ setState: setState, getState: getState })=>{
            const { issueIdRowRuleMatched: issueIdRowRuleMatched } = getState();
            const rowRuleMatched = Object.entries(issueIdRowRuleMatched).filter(([, value])=>value.id !== ruleId);
            const newIssueIdRowRuleMatched = Object.fromEntries(rowRuleMatched);
            setState({
                issueIdRowRuleMatched: newIssueIdRowRuleMatched
            });
        }
};
const $7cf99983147e2a90$var$oldStore = (0, $iXqE5.createStore)({
    initialState: $7cf99983147e2a90$var$initialState,
    actions: $7cf99983147e2a90$var$actions,
    name: 'JWMFormatRulesOld'
});
const $7cf99983147e2a90$export$2022a9665c731c36 = (0, $gg7kZ.createContainer)();
const $7cf99983147e2a90$var$Store = (0, $iXqE5.createStore)({
    initialState: $7cf99983147e2a90$var$initialState,
    actions: $7cf99983147e2a90$var$actions,
    name: 'JWMFormatRules',
    containedBy: $7cf99983147e2a90$export$2022a9665c731c36
});
const $7cf99983147e2a90$var$useFormatRulesStoreOld = (0, $3sQ5x.createHook)($7cf99983147e2a90$var$oldStore);
const $7cf99983147e2a90$var$useFormatRulesStoreNew = (0, $3sQ5x.createHook)($7cf99983147e2a90$var$Store);
const $7cf99983147e2a90$export$2fe3fe2e87aa2741 = ()=>(0, $4R6GH.fg)('conditional-formatting-new-list-targeting-gate') ? $7cf99983147e2a90$var$useFormatRulesStoreNew() : $7cf99983147e2a90$var$useFormatRulesStoreOld();
const $7cf99983147e2a90$var$getSerialisedJql = (state)=>(0, $1tESh.serialiseJql)(state.rulesJqlInput);
const $7cf99983147e2a90$var$useFormatRulesSerialisedJqlOld = (0, $3sQ5x.createHook)($7cf99983147e2a90$var$oldStore, {
    selector: $7cf99983147e2a90$var$getSerialisedJql
});
const $7cf99983147e2a90$var$useFormatRulesSerialisedJqlNew = (0, $3sQ5x.createHook)($7cf99983147e2a90$var$Store, {
    selector: $7cf99983147e2a90$var$getSerialisedJql
});
const $7cf99983147e2a90$export$3b2286d9a476f9a1 = ()=>(0, $4R6GH.fg)('conditional-formatting-new-list-targeting-gate') ? $7cf99983147e2a90$var$useFormatRulesSerialisedJqlNew() : $7cf99983147e2a90$var$useFormatRulesSerialisedJqlOld();

});

parcelRegister("eTDjN", function(module, exports) {

$parcel$export(module.exports, "LIST_PADDING_LEFT", () => $21d3dbd35ecbeebb$export$a473358fe9122073);
$parcel$export(module.exports, "LIST_ROW", () => $21d3dbd35ecbeebb$export$beca668e8640bfff);
$parcel$export(module.exports, "DEFAULT_ROW_HEIGHT", () => $21d3dbd35ecbeebb$export$258441c8a79bb589);
$parcel$export(module.exports, "ROW_KEY", () => $21d3dbd35ecbeebb$export$1c6db1a0937ef0bd);
$parcel$export(module.exports, "SELECT_ROW_COLUMN_WIDTH", () => $21d3dbd35ecbeebb$export$c9c106422318b1d6);
$parcel$export(module.exports, "EXPAND_ICON_INDENT_WIDTH", () => $21d3dbd35ecbeebb$export$68438aed9d51940e);
$parcel$export(module.exports, "COMPONENTS_MAX_DISPLAYABLE_OPTIONS", () => $21d3dbd35ecbeebb$export$fd8201de23366906);
$parcel$export(module.exports, "DATE_LOZENGE_ID", () => $21d3dbd35ecbeebb$export$9fcfab1f93d2a27a);
$parcel$export(module.exports, "CHILD_CREATE_BTN_WRAPPER", () => $21d3dbd35ecbeebb$export$16bb76a118fce7b4);
$parcel$export(module.exports, "UP", () => $21d3dbd35ecbeebb$export$b29f845fa4b57508);
$parcel$export(module.exports, "DOWN", () => $21d3dbd35ecbeebb$export$c7c029a231f98d34);
$parcel$export(module.exports, "LEFT", () => $21d3dbd35ecbeebb$export$f981f70d61d1405a);
$parcel$export(module.exports, "RIGHT", () => $21d3dbd35ecbeebb$export$1cac5500365a4eb4);
$parcel$export(module.exports, "BULK_SELECT_CHECKBOX_ID", () => $21d3dbd35ecbeebb$export$61ba93f63403a728);
$parcel$export(module.exports, "DRAG_AND_DROP_BUTTON_FOCUS_EVENT", () => $21d3dbd35ecbeebb$export$2e64c33508f031cb);
$parcel$export(module.exports, "ACTION_DRAG_STARTED", () => $21d3dbd35ecbeebb$export$5886ae675e1cc401);
$parcel$export(module.exports, "ACTION_DRAG_ENDED", () => $21d3dbd35ecbeebb$export$736f74130173aad9);
$parcel$export(module.exports, "NO_ISSUE_TYPE", () => $21d3dbd35ecbeebb$export$6a707112f448ba18);
$parcel$export(module.exports, "NO_PARENT_ISSUE_TYPE", () => $21d3dbd35ecbeebb$export$aa7400fdf583255b);
$parcel$export(module.exports, "TOP_LEVEL_COLLECTION", () => $21d3dbd35ecbeebb$export$e9f49e7d94ba81a7);
$parcel$export(module.exports, "BULK_DELETE_IN_PROGRESS_FLAG_ID", () => $21d3dbd35ecbeebb$export$2537d1b6d47b8b99);
$parcel$export(module.exports, "BULK_DELETE_SUCCESS_FLAG_ID", () => $21d3dbd35ecbeebb$export$50d12af09489a2d7);
$parcel$export(module.exports, "BULK_DELETE_FAILED_FLAG_ID", () => $21d3dbd35ecbeebb$export$b4268ee17ddbdd7f);
$parcel$export(module.exports, "BULK_DELETE_FAILED_CLIENT_FLAG_ID", () => $21d3dbd35ecbeebb$export$ebf578347a3066f4);
$parcel$export(module.exports, "VIEW_EXPERIENCE", () => $21d3dbd35ecbeebb$export$4a2289be55388ee6);
$parcel$export(module.exports, "LOAD_CHILDREN_EXPERIENCE", () => $21d3dbd35ecbeebb$export$16b872ae5b961241);
$parcel$export(module.exports, "LOAD_GROUP_ITEMS_EXPERIENCE", () => $21d3dbd35ecbeebb$export$47da82a3abffaada);
$parcel$export(module.exports, "LOAD_GROUP_ITEMS_CHILDREN_EXPERIENCE", () => $21d3dbd35ecbeebb$export$6c7be7d66ea2537f);
$parcel$export(module.exports, "BULK_DELETE_EXPERIENCE", () => $21d3dbd35ecbeebb$export$435db386ec1c226);
$parcel$export(module.exports, "BULK_COPY_EXPERIENCE", () => $21d3dbd35ecbeebb$export$dbecc95ea17b546e);
$parcel$export(module.exports, "CREATE_CATEGORY_EXPERIENCE", () => $21d3dbd35ecbeebb$export$af494ffa4befd621);
$parcel$export(module.exports, "UPDATE_CATEGORY_EXPERIENCE", () => $21d3dbd35ecbeebb$export$15d259507553cf76);
$parcel$export(module.exports, "DELETE_CATEGORY_EXPERIENCE", () => $21d3dbd35ecbeebb$export$a433ff40336ab4a7);
$parcel$export(module.exports, "SUPPORTED_GROUPS_TYPES", () => $21d3dbd35ecbeebb$export$220fd19c26dc2508);
$parcel$export(module.exports, "BULK_EDIT_CHANGEBOARDING_MESSAGE_ID", () => $21d3dbd35ecbeebb$export$5b958d8fec7c426a);
$parcel$export(module.exports, "DEV_SUMMARY_FIELD", () => $21d3dbd35ecbeebb$export$20b3b4741b8cfb64);
$parcel$export(module.exports, "PARENT_FIELD", () => $21d3dbd35ecbeebb$export$bf9df74e065af482);

var $5fc53 = parcelRequire("5fc53");
const $21d3dbd35ecbeebb$export$a473358fe9122073 = 20;
const $21d3dbd35ecbeebb$export$beca668e8640bfff = 'listRow';
const $21d3dbd35ecbeebb$export$258441c8a79bb589 = 40;
const $21d3dbd35ecbeebb$export$1c6db1a0937ef0bd = 'rowKey';
const $21d3dbd35ecbeebb$export$c9c106422318b1d6 = 65;
const $21d3dbd35ecbeebb$export$1911356e2f572e = 35;
const $21d3dbd35ecbeebb$export$68438aed9d51940e = 20;
const $21d3dbd35ecbeebb$export$56446adcecbeec34 = {
    tableFooter: 1,
    tableShadow: 2,
    inlineFieldCreateControls: 3
};
const $21d3dbd35ecbeebb$export$3e36baaa5cb0cfb5 = [
    0,
    -$21d3dbd35ecbeebb$export$258441c8a79bb589
];
const $21d3dbd35ecbeebb$export$fd8201de23366906 = 9;
const $21d3dbd35ecbeebb$export$9fcfab1f93d2a27a = 'list-date-lozenge';
const $21d3dbd35ecbeebb$export$16bb76a118fce7b4 = 'child-create-btn-wrapper';
const $21d3dbd35ecbeebb$export$b29f845fa4b57508 = 'up';
const $21d3dbd35ecbeebb$export$c7c029a231f98d34 = 'down';
const $21d3dbd35ecbeebb$export$f981f70d61d1405a = 'left';
const $21d3dbd35ecbeebb$export$1cac5500365a4eb4 = 'right';
const $21d3dbd35ecbeebb$export$61ba93f63403a728 = 'bulk-select-checkbox';
const $21d3dbd35ecbeebb$export$2e64c33508f031cb = 'drag-and-drop-button-focus';
const $21d3dbd35ecbeebb$export$ce523a2c42983704 = 45;
const $21d3dbd35ecbeebb$export$5886ae675e1cc401 = 'dragStarted';
const $21d3dbd35ecbeebb$export$736f74130173aad9 = 'dragEnded';
const $21d3dbd35ecbeebb$export$6a707112f448ba18 = 'noIssueType';
const $21d3dbd35ecbeebb$export$aa7400fdf583255b = 'noParentIssueType';
const $21d3dbd35ecbeebb$export$e9f49e7d94ba81a7 = 'topLevelCollection';
const $21d3dbd35ecbeebb$export$2537d1b6d47b8b99 = 'bulk-delete-in-progress-flag';
const $21d3dbd35ecbeebb$export$50d12af09489a2d7 = 'bulk-delete-success-flag';
const $21d3dbd35ecbeebb$export$b4268ee17ddbdd7f = 'bulk-delete-failed-flag';
const $21d3dbd35ecbeebb$export$ebf578347a3066f4 = 'bulk-delete-failed-client-flag';
const $21d3dbd35ecbeebb$export$4a2289be55388ee6 = {
    experience: 'listView',
    experienceId: 'main',
    packageName: 'jiraBusinessList',
    teamName: 'keystone'
};
const $21d3dbd35ecbeebb$export$16b872ae5b961241 = {
    experience: 'loadChildren',
    experienceId: 'children',
    packageName: 'jiraBusinessList',
    teamName: 'keystone'
};
const $21d3dbd35ecbeebb$export$47da82a3abffaada = {
    experience: 'loadGroup',
    experienceId: 'groupItems',
    packageName: 'jiraBusinessList',
    teamName: 'keystone'
};
const $21d3dbd35ecbeebb$export$6c7be7d66ea2537f = {
    experience: 'loadGroupChildren',
    experienceId: 'groupItemsChildren',
    packageName: 'jiraBusinessList',
    teamName: 'keystone'
};
const $21d3dbd35ecbeebb$export$435db386ec1c226 = {
    experience: 'bulkDelete',
    experienceId: 'bulkDelete',
    packageName: 'jiraBusinessList',
    teamName: 'keystone'
};
const $21d3dbd35ecbeebb$export$dbecc95ea17b546e = {
    experience: 'bulkCopy',
    experienceId: 'bulkCopy',
    packageName: 'jiraBusinessList',
    teamName: 'keystone'
};
const $21d3dbd35ecbeebb$export$af494ffa4befd621 = {
    experience: 'createCategory',
    experienceId: 'createCategory',
    packageName: 'jiraBusinessList',
    teamName: 'jira-warepil'
};
const $21d3dbd35ecbeebb$export$15d259507553cf76 = {
    experience: 'updateCategory',
    experienceId: 'updateCategory',
    packageName: 'jiraBusinessList',
    teamName: 'jira-warepil'
};
const $21d3dbd35ecbeebb$export$a433ff40336ab4a7 = {
    experience: 'deleteCategory',
    experienceId: 'deleteCategory',
    packageName: 'jiraBusinessList',
    teamName: 'jira-warepil'
};
const $21d3dbd35ecbeebb$export$220fd19c26dc2508 = [
    (0, $5fc53.ASSIGNEE_TYPE),
    (0, $5fc53.PRIORITY_TYPE),
    (0, $5fc53.STATUS_TYPE),
    (0, $5fc53.CATEGORY_TYPE),
    (0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE),
    (0, $5fc53.NUMBER_CF_TYPE),
    (0, $5fc53.SPRINT_TYPE)
];
const $21d3dbd35ecbeebb$export$5b958d8fec7c426a = 'bulk_edit_changeboarding';
const $21d3dbd35ecbeebb$export$20b3b4741b8cfb64 = 'devSummaryField';
const $21d3dbd35ecbeebb$export$bf9df74e065af482 = 'parentField';

});

parcelRegister("cpqMw", function(module, exports) {

$parcel$export(module.exports, "InvalidJQLErrorBoundary", () => $7183ea5130be839a$export$c80d0587c83953fe);

var $5uXOq = parcelRequire("5uXOq");

var $c9Ur7 = parcelRequire("c9Ur7");
const $7183ea5130be839a$var$isInvalidJQLError = (error)=>{
    if (error instanceof (0, $c9Ur7.QueryError)) {
        if ((error.extensions || []).find((err)=>err.statusCode === 400 && err.errorType === 'FIELD_MISSING_HANDLER')) return true;
    }
    return false;
};
class $7183ea5130be839a$export$c80d0587c83953fe extends (0, $5uXOq.Component) {
    componentDidCatch(error, info) {
        if ($7183ea5130be839a$var$isInvalidJQLError(error)) {
            this.setState({
                caughtError: {
                    error: error,
                    info: info
                }
            });
            return;
        }
        throw error;
    }
    render() {
        const { caughtError: caughtError } = this.state;
        const { children: children, render: renderFallback } = this.props;
        if (!caughtError) return children;
        return renderFallback(this.clearError);
    }
    constructor(...args){
        super(...args), this.state = {
            caughtError: null
        }, this.clearError = ()=>{
            this.setState({
                caughtError: null
            });
        };
    }
}

});

parcelRegister("5cP2Q", function(module, exports) {

$parcel$export(module.exports, "FormsLabelFlag", () => $adf17fbc6aec6252$export$acb1b1990395076);

var $5uXOq = parcelRequire("5uXOq");

var $1jWct = parcelRequire("1jWct");

var $kRkJF = parcelRequire("kRkJF");

var $d4xRU = parcelRequire("d4xRU");
var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $eq1P7 = parcelRequire("eq1P7");
const $adf17fbc6aec6252$export$acb1b1990395076 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { quickFiltersJql: quickFiltersJql } = (0, $kRkJF.useFilteredViewContextInput)({
        view: 'list'
    });
    const containsFilter = (0, $5uXOq.useMemo)(()=>quickFiltersJql && $adf17fbc6aec6252$var$filtersByBusinessFormIdLabel(quickFiltersJql), [
        quickFiltersJql
    ]);
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    const flagId = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>{
        if (containsFilter && flagId.current == null) flagId.current = showFlag({
            render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4xRU.default), {
                    messageType: "engagement",
                    messageId: "business-list.controllers.forms-label-flag.ak-flag.flag",
                    id: "",
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1jWct))), {
                        spacing: "spacious",
                        label: formatMessage((0, $eq1P7.default).iconLabel)
                    }),
                    title: formatMessage((0, $eq1P7.default).title),
                    description: formatMessage((0, $eq1P7.default).description),
                    onDismissed: ()=>{
                        if (flagId.current) dismissFlag(flagId.current);
                    },
                    actions: [
                        {
                            content: formatMessage((0, $eq1P7.default).viewAllLink),
                            href: `?filter=${encodeURIComponent('labels = "business-form"')}`,
                            onClick (_, analyticsEvent) {
                                (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'link clicked', 'viewAllBusinessFormsIssues');
                            }
                        }
                    ],
                    ...props
                })
        });
        return ()=>{
            if (flagId.current) dismissFlag(flagId.current);
        };
    }, [
        containsFilter,
        dismissFlag,
        formatMessage,
        showFlag
    ]);
    return null;
};
const $adf17fbc6aec6252$var$filtersByBusinessFormIdLabel = (jql)=>{
    return jql.split(/ AND | OR /).map((statement)=>{
        const tokens = [
            ' = ',
            ' in ',
            ' IN '
        ];
        for (const token of tokens){
            if (statement.includes(token)) return statement.split(token);
        }
        return [];
    }).reduce((acc, curr)=>{
        const [field, values] = curr;
        if (field === 'labels' && values.match(/business-form-\d/)) return true;
        return acc;
    }, false);
};

});
parcelRegister("kRkJF", function(module, exports) {

$parcel$export(module.exports, "useFilteredViewJQL", () => $6b3238559c925b96$export$a50cc7c1087f7d9b);
$parcel$export(module.exports, "useFilteredViewContextInput", () => $6b3238559c925b96$export$d566b5d8a729afa0);

var $5uXOq = parcelRequire("5uXOq");


var $5YBrl = parcelRequire("5YBrl");

var $5fc53 = parcelRequire("5fc53");

var $2UUq6 = parcelRequire("2UUq6");

var $17ot5 = parcelRequire("17ot5");

var $l4Ejo = parcelRequire("l4Ejo");

var $1T1ir = parcelRequire("1T1ir");

var $7VpiX = parcelRequire("7VpiX");
const $6b3238559c925b96$export$a50cc7c1087f7d9b = ()=>{
    const { addSimpleSearchToJQL: addSimpleSearchToJQL } = (0, $1T1ir.useSimpleSearchJQL)();
    const { jql: jql } = (0, $l4Ejo.useFilters)();
    const [isHidingDoneItems] = (0, $17ot5.useHideDoneItems)();
    // ensure views recieve filters jql that will not cause a page crash
    const jqlSanitised = (0, $5uXOq.useMemo)(()=>(0, $7VpiX.sanitiseJql)(jql), [
        jql
    ]);
    const filtersJQL = (0, $5uXOq.useMemo)(()=>{
        if (isHidingDoneItems) {
            const filtersJql = [
                jqlSanitised,
                "StatusCategory != 'Complete'"
            ].filter(Boolean).join(' AND ');
            return addSimpleSearchToJQL(filtersJql);
        }
        return addSimpleSearchToJQL(jqlSanitised || null);
    }, [
        jqlSanitised,
        addSimpleSearchToJQL,
        isHidingDoneItems
    ]);
    return filtersJQL;
};
const $6b3238559c925b96$var$FIX_VERSION_SORTING_JQL = 'fixVersion';
const $6b3238559c925b96$export$d566b5d8a729afa0 = ({ view: view })=>{
    const filtersJQL = $6b3238559c925b96$export$a50cc7c1087f7d9b();
    const { isSearching: isSearching } = (0, $1T1ir.useSimpleSearchJQL)();
    const [sortingBy] = (0, $2UUq6.useSorting)();
    const { jql: jql } = (0, $l4Ejo.useFilters)();
    const isFiltering = jql != null || isSearching;
    const [isHidingDoneItems] = (0, $17ot5.useHideDoneItems)();
    const jqlContext = (0, $5YBrl.useJqlContext)();
    const hierarchyParent = (view === 'list' || view === 'timeline') && !isFiltering ? (0, $8debe7dace56daea$export$9355e489ad16f98e) : undefined;
    const jqlErrors = (0, $5uXOq.useMemo)(()=>(0, $7VpiX.getJqlErrors)(jql), [
        jql
    ]);
    const sorting = (0, $5uXOq.useMemo)(()=>{
        /*
			When sorting by a specific field, we use the fieldId in the JQL query.
			For the fix version field, the fieldId doesn’t work in JQL must be “fixVersion”.
			Apparently, "fixVersion" is the clause name. It's a legacy choice that was made from the very beginning, and now we're unable to change it.
		*/ if (sortingBy.sortBy === (0, $5fc53.FIX_VERSIONS_TYPE)) return {
            ...sortingBy,
            sortBy: $6b3238559c925b96$var$FIX_VERSION_SORTING_JQL
        };
        return sortingBy;
    }, [
        sortingBy
    ]);
    return {
        jqlContext: jqlContext,
        quickFiltersJql: filtersJQL,
        sorting: sorting,
        isFiltering: isFiltering,
        hierarchyParent: hierarchyParent,
        isHidingDoneItems: isHidingDoneItems,
        jqlErrors: jqlErrors
    };
};

});
const $8debe7dace56daea$export$9355e489ad16f98e = 'TASK';
const $8debe7dace56daea$export$3cb4a99a332e4186 = 'EPIC';

parcelRegister("2UUq6", function(module, exports) {

$parcel$export(module.exports, "useSorting", () => $46c72127586d4f92$export$21ebc1ba2b2bee67);
$parcel$export(module.exports, "useSorter", () => $46c72127586d4f92$export$f161a6f9d84a6fea);

var $5uXOq = parcelRequire("5uXOq");

var $ftuRD = parcelRequire("ftuRD");

var $1T2vX = parcelRequire("1T2vX");

var $x8FYU = parcelRequire("x8FYU");

var $1kpI8 = parcelRequire("1kpI8");

var $8841m = parcelRequire("8841m");

var $h1cpf = parcelRequire("h1cpf");

var $8Yjb2 = parcelRequire("8Yjb2");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $46c72127586d4f92$var$EMPTY_SORTING_ATTRIBUTE = {};
const $46c72127586d4f92$export$21ebc1ba2b2bee67 = ()=>{
    const [sorting, setSorting] = (0, $1kpI8.useViewPreference)((0, $x8FYU.SORTING_PREFERENCE));
    return [
        sorting || $46c72127586d4f92$var$EMPTY_SORTING_ATTRIBUTE,
        setSorting
    ];
};
const $46c72127586d4f92$var$emptyArray = [];
const $46c72127586d4f92$export$f161a6f9d84a6fea = ()=>{
    const [sorting] = $46c72127586d4f92$export$21ebc1ba2b2bee67();
    const [sortingFieldConfig] = (0, $ftuRD.useIssueTypeFieldConfig)({
        screen: 'VIEW',
        issueTypeId: 'default',
        fieldId: sorting.sortBy
    });
    const [priorityFieldConfig] = (0, $ftuRD.useIssueTypeFieldConfig)({
        screen: 'VIEW',
        issueTypeId: 'default',
        fieldId: 'priority'
    });
    const { data: data } = (0, $1T2vX.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const sortingFieldConfigFieldType = sortingFieldConfig?.fieldType ?? data?.fields?.find((field)=>field?.id === sorting.sortBy)?.type;
    const { statuses: statuses } = (0, $8841m.useProjectStatuses)();
    const priorities = priorityFieldConfig?.options || $46c72127586d4f92$var$emptyArray;
    const sortFunction = (0, $5uXOq.useCallback)((issues)=>{
        const getPrioritiesSortedList = ()=>[
                ...priorities
            ].reverse().reduce((acc, next, index)=>{
                acc[next.priorityId] = index;
                return acc;
            }, {});
        const getIssueTypesSortedList = ()=>[
                ...data.issueTypes
            ].sort((a, b)=>a.name.localeCompare(b.name)).reduce((acc, next, index)=>{
                acc[next.name] = index;
                return acc;
            }, {});
        const getStatusSortOrder = (key)=>{
            if (key in (0, $h1cpf.STATUS_SORT_ORDER)) return (0, $h1cpf.STATUS_SORT_ORDER)[key];
            return -1;
        };
        const getStatusesSortedList = ()=>[
                ...statuses
            ].sort((a, b)=>{
                const orderComparison = getStatusSortOrder(a.statusCategory.key) - getStatusSortOrder(b.statusCategory.key);
                if (orderComparison !== 0) return orderComparison;
                // If the status category order is the same, then sort alphabetically by name.
                return a.name.localeCompare(b.name);
            }).reduce((acc, next, index)=>{
                acc[next.name] = index;
                return acc;
            }, {});
        const sortedLists = {
            priorities: getPrioritiesSortedList(),
            issueTypes: getIssueTypesSortedList(),
            statuses: getStatusesSortedList()
        };
        const { getters: getters, orders: orders } = (0, $8Yjb2.createSortingGettersAndOrders)(sorting, sortingFieldConfigFieldType, sortedLists);
        return (0, $8Yjb2.sortListBy)(issues, getters, orders);
    }, [
        sorting,
        sortingFieldConfigFieldType,
        priorities,
        data.issueTypes,
        statuses
    ]);
    return {
        sort: sortFunction
    };
};

});
parcelRegister("ftuRD", function(module, exports) {

$parcel$export(module.exports, "useIssueTypeFieldConfig", () => $66b06940d67822ac$export$42e875bfb69ded2);

var $5uXOq = parcelRequire("5uXOq");

var $9XE6b = parcelRequire("9XE6b");

var $3sQ5x = parcelRequire("3sQ5x");
var $6dDSs = parcelRequire("6dDSs");
var $iXqE5 = parcelRequire("iXqE5");

var $1T2vX = parcelRequire("1T2vX");
const $66b06940d67822ac$var$merge = (screen, issueTypeId, configs)=>({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            [screen]: {
                ...(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(getState(), [
                    screen
                ], {}),
                [issueTypeId]: configs
            }
        });
    };
const $66b06940d67822ac$var$actions = {
    merge: $66b06940d67822ac$var$merge
};
const $66b06940d67822ac$export$cbf0f7fe9ca42a65 = (0, $iXqE5.createStore)({
    initialState: {},
    actions: $66b06940d67822ac$var$actions,
    name: 'issueTypeFieldConfig'
});
const $66b06940d67822ac$var$getIssueTypeFieldConfigSelector = (0, $6dDSs.createSelector)((state)=>state, (_, props)=>props?.screen ?? undefined, (_, props)=>props?.issueTypeId ?? undefined, (_, props)=>props?.fieldId ?? undefined, (state, screen, issueTypeId, fieldId)=>{
    if (screen === undefined || issueTypeId === undefined || fieldId === undefined) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(state, [
        screen,
        issueTypeId,
        fieldId
    ], null);
});
const $66b06940d67822ac$export$47647eb426e85a25 = (0, $3sQ5x.createHook)($66b06940d67822ac$export$cbf0f7fe9ca42a65, {
    selector: $66b06940d67822ac$var$getIssueTypeFieldConfigSelector
});
const $66b06940d67822ac$export$42e875bfb69ded2 = (props)=>{
    const [state, fieldsConfigActions] = $66b06940d67822ac$export$47647eb426e85a25(props);
    const screen = props?.screen || 'VIEW';
    const { data: data, loading: loading, error: error } = (0, $1T2vX.useIssueTypesAndFields)({
        issueOperation: screen
    });
    // store field config to be consumed at the cell level
    return (0, $5uXOq.useMemo)(()=>{
        if (state != null) return [
            state,
            fieldsConfigActions,
            {
                loading: false,
                error: undefined
            }
        ];
        if (loading === false && (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(data, [
            'issueTypes'
        ], []).length > 0) data.issueTypes.forEach((issueType)=>{
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const config = {};
            data.fields.forEach((field)=>{
                if ((field.issueTypes || []).includes(issueType.id) && field.id != null) config[field.id] = {
                    ...field.fieldConfig,
                    fieldType: field.type
                };
            });
            fieldsConfigActions.merge(screen, issueType.id, config);
            if (issueType.isDefault) fieldsConfigActions.merge(screen, 'default', config);
        });
        return [
            state,
            fieldsConfigActions,
            {
                loading: loading,
                error: error
            }
        ];
    }, [
        data,
        error,
        fieldsConfigActions,
        loading,
        screen,
        state
    ]);
};

});

parcelRegister("8841m", function(module, exports) {

$parcel$export(module.exports, "useProjectStatuses", () => $f2e77b2d189a9e48$export$11ff6a520db76faf);

var $5uXOq = parcelRequire("5uXOq");

var $7qDUb = parcelRequire("7qDUb");

var $3JOCw = parcelRequire("3JOCw");

var $daQYX = parcelRequire("daQYX");

var $2YZCu = parcelRequire("2YZCu");

var $3sQ5x = parcelRequire("3sQ5x");
var $6dDSs = parcelRequire("6dDSs");
var $iXqE5 = parcelRequire("iXqE5");
const $f2e77b2d189a9e48$var$PACKAGE_LOCATION = 'jira-business.common.services.project-statuses';
const $f2e77b2d189a9e48$var$MAX_RETRIES = 3;
const $f2e77b2d189a9e48$var$set = (projectKey, statuses)=>({ setState: setState })=>setState({
            [projectKey]: statuses
        });
const $f2e77b2d189a9e48$var$actions = {
    set: $f2e77b2d189a9e48$var$set
};
const $f2e77b2d189a9e48$var$ProjectStatusesStore = (0, $iXqE5.createStore)({
    initialState: {},
    actions: $f2e77b2d189a9e48$var$actions,
    name: 'projectStatuses'
});
const $f2e77b2d189a9e48$var$getProjectStatusesSelector = (0, $6dDSs.createSelector)((state)=>state, (_, props)=>props?.projectKey ?? undefined, (state, projectKey)=>{
    if (projectKey === undefined || state[projectKey] == null) return [];
    return state[projectKey];
});
const $f2e77b2d189a9e48$export$482f388228eef22c = (0, $3sQ5x.createHook)($f2e77b2d189a9e48$var$ProjectStatusesStore, {
    selector: $f2e77b2d189a9e48$var$getProjectStatusesSelector
});
const $f2e77b2d189a9e48$var$emptyArray = [];
const $f2e77b2d189a9e48$export$11ff6a520db76faf = ()=>{
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const requestInFlight = (0, $5uXOq.useRef)(false);
    const [retriesCount, setRetriesCount] = (0, $5uXOq.useState)(0);
    const projectData = (0, $daQYX.useProject)();
    const projectKey = projectData.key;
    const [statuses, statusActions] = $f2e77b2d189a9e48$export$482f388228eef22c({
        projectKey: projectKey
    });
    const retry = (0, $5uXOq.useCallback)(()=>{
        requestInFlight.current = false;
        setRetriesCount(retriesCount + 1);
    }, [
        retriesCount
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (requestInFlight.current === false) {
            requestInFlight.current = true;
            fetch(`/rest/api/3/project/${projectKey}/statuses`).then((response)=>response.json()).then((issueTypes)=>{
                const allStatuses = issueTypes.reduce(// @ts-expect-error - TS7006 - Parameter 'acc' implicitly has an 'any' type. | TS7006 - Parameter 'next' implicitly has an 'any' type.
                (acc, next)=>acc.concat(next.statuses), []);
                const dedupedResults = (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))(allStatuses, 'id');
                return (0, (/*@__PURE__*/$parcel$interopDefault($7qDUb)))(dedupedResults, [
                    'name'
                ]);
            }).then((uniqueStatuses)=>{
                statusActions.set(projectKey, uniqueStatuses);
                setIsLoading(false);
            }).catch(()=>{
                (0, $2YZCu.default).safeErrorWithoutCustomerData($f2e77b2d189a9e48$var$PACKAGE_LOCATION, `Failed to retrieve project statuses - Retry #${retriesCount}`);
                setIsLoading(false);
                if (retriesCount < $f2e77b2d189a9e48$var$MAX_RETRIES) retry();
            }).finally(()=>{
                requestInFlight.current = false;
            });
            setIsLoading(true);
        }
    }, [
        projectKey,
        statusActions,
        retriesCount,
        retry
    ]);
    if (projectKey != null && Array.isArray(statuses) && statuses.length > 0) return {
        statuses: statuses,
        loading: isLoading
    };
    return {
        statuses: $f2e77b2d189a9e48$var$emptyArray,
        loading: isLoading
    };
};

});

parcelRegister("h1cpf", function(module, exports) {

$parcel$export(module.exports, "STATUS_SORT_ORDER", () => $20cadc5cf5f0437c$export$de9c103e53e690d1);
const $20cadc5cf5f0437c$export$de9c103e53e690d1 = {
    new: 1,
    indeterminate: 2,
    done: 3
};

});

parcelRegister("8Yjb2", function(module, exports) {

$parcel$export(module.exports, "sortListBy", () => $9b7a6804aae1eb73$export$3793ed28be8699ad);
$parcel$export(module.exports, "createSortingGettersAndOrders", () => $9b7a6804aae1eb73$export$b3fdfcb601c683c3);

var $1AkQu = parcelRequire("1AkQu");

var $hE5wF = parcelRequire("hE5wF");

var $ijSZT = parcelRequire("ijSZT");

var $fCkUD = parcelRequire("fCkUD");

var $57lFd = parcelRequire("57lFd");

var $gULOk = parcelRequire("gULOk");

var $5fc53 = parcelRequire("5fc53");

var $ixx6N = parcelRequire("ixx6N");
const $9b7a6804aae1eb73$var$DEFAULT_HIGHER_RANKING_VALUE = 'Z';
const $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE = '~~';
const $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_NUMBER_VALUE = 0;
const $9b7a6804aae1eb73$var$toAcceptedOrder = (order)=>order != null && order.toLowerCase() === 'asc' ? 'asc' : 'desc';
const $9b7a6804aae1eb73$export$3793ed28be8699ad = (nodes, getters, orders)=>(0, (/*@__PURE__*/$parcel$interopDefault($1AkQu)))(nodes, getters, orders.map($9b7a6804aae1eb73$var$toAcceptedOrder));
const $9b7a6804aae1eb73$var$getValueMapAndJoin = (fields, fieldKey, attributeName, defaultValue, // eslint-disable-next-line @typescript-eslint/no-explicit-any
getMapValueCb)=>{
    // join array with space so alphabetical order can be applied.
    // @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string | undefined'.
    const fieldValue = (0, $57lFd.safeGetValue)(fields, fieldKey, attributeName, defaultValue) ?? defaultValue;
    return fieldValue.map(getMapValueCb).join(' ') || $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE;
};
const $9b7a6804aae1eb73$var$resolvePriorityOrder = (fields, priorities)=>{
    const priorityId = (0, $57lFd.safeGetValue)(fields, 'priority', 'value.priorityId', '');
    const priorityOrder = priorities[priorityId];
    if (priorityOrder == null) return -1;
    return priorityOrder;
};
const $9b7a6804aae1eb73$var$resolveStatusOrder = (fields, statuses)=>{
    const statusName = (0, $57lFd.safeGetValue)(fields, 'status', 'name', '');
    const statusOrder = statuses[statusName];
    if (statusOrder == null) return -1;
    return statusOrder;
};
const $9b7a6804aae1eb73$var$resolveTypeOrder = (fields, types)=>{
    const typeName = (0, $57lFd.safeGetValue)(fields, 'issuetype', 'value', '');
    const typeOrder = types[typeName];
    if (typeOrder == null) return -1;
    return typeOrder;
};
const $9b7a6804aae1eb73$var$resolveIssueKeyOrder = (fields)=>{
    const [, issueKeyNumber = 0] = (0, $57lFd.safeGetValue)(fields, 'issuekey', 'value', '').split('-');
    return Number(issueKeyNumber);
};
const $9b7a6804aae1eb73$var$resolveCustomTextFieldOrder = (fields, sortingField)=>{
    // wiki value will be null when empty
    const value = (0, $57lFd.safeGetValue)(fields, sortingField, 'value', null);
    return value != null ? value.toLowerCase() : $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE; // empty values should rank lower
};
const $9b7a6804aae1eb73$var$createSortableGetter = (fieldType, sortingField, sortedList)=>(node)=>{
        const { rank: rank, fields: fields = [] } = node;
        if (fieldType != null && (0, $ijSZT.isSortingSupportedFieldTypePredicated)(fieldType) && (0, $ijSZT.isSortingSupported)(fieldType)) {
            const field = (0, $57lFd.getFieldValue)(fields, sortingField);
            if ((0, $fCkUD.isNewTransformedFieldPredicated)(field)) return (0, $ijSZT.getSorting)(fieldType, field) || $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE;
            return $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE;
        }
        switch(fieldType){
            case 0, $5fc53.LABELS_TYPE:
            case 0, $5fc53.LABELS_CF_TYPE:
                // The backend will return [''] when it's empty so our default value might not be applied so we force return ~~ when it happens so empty items are ordered properly
                return $9b7a6804aae1eb73$var$getValueMapAndJoin(fields, sortingField, 'value', [
                    ''
                ], (label)=>label.toLowerCase());
            case 0, $5fc53.PRIORITY_TYPE:
                return $9b7a6804aae1eb73$var$resolvePriorityOrder(fields, sortedList != null && sortedList.priorities || {});
            case 0, $5fc53.STATUS_TYPE:
                return $9b7a6804aae1eb73$var$resolveStatusOrder(fields, sortedList != null && sortedList.statuses || {});
            case 0, $5fc53.ISSUE_TYPE:
                return $9b7a6804aae1eb73$var$resolveTypeOrder(fields, sortedList != null && sortedList.issueTypes || {});
            case 0, $5fc53.ASSIGNEE_TYPE:
            case 0, $5fc53.REPORTER_TYPE:
                return (0, $57lFd.safeGetValue)(fields, sortingField, 'value.name', // unassigned items are ranked higher than the ones with an user :shrug:
                $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE).toLowerCase();
            case 0, $5fc53.USER_CF_TYPE:
                return (0, $57lFd.safeGetValue)(fields, sortingField, 'value.name', // unassigned items are ranked higher than the ones with an user :shrug:
                $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE).toLowerCase();
            case 'issuekey':
                return $9b7a6804aae1eb73$var$resolveIssueKeyOrder(fields);
            case 0, $5fc53.CREATED:
            case 0, $5fc53.UPDATED:
                return (0, $57lFd.safeGetValue)(fields, sortingField, 'value', '');
            case 0, $5fc53.DATE_CF_TYPE:
                return (0, $57lFd.safeGetValue)(fields, sortingField, 'value', $9b7a6804aae1eb73$var$DEFAULT_HIGHER_RANKING_VALUE);
            case 0, $5fc53.DUE_DATE_TYPE:
                return (0, $57lFd.safeGetValue)(fields, sortingField, 'value', // empty dates are ranked higher than the ones with set date :shrug:
                $9b7a6804aae1eb73$var$DEFAULT_HIGHER_RANKING_VALUE);
            case 0, $5fc53.DATETIME_CF_TYPE:
                return (0, $57lFd.safeGetValue)(fields, sortingField, 'value', $9b7a6804aae1eb73$var$DEFAULT_HIGHER_RANKING_VALUE);
            case 0, $hE5wF.RANK_ALIAS_FIELD_ID:
                // We want to check for l-1 if the new jql parent is on
                if ((0, $57lFd.safeGetValue)(fields, 'issuetype', 'level', undefined) === -1) return (0, $ixx6N.resolveRank)((0, $57lFd.safeGetValue)(fields, 'parent', 'value', undefined), rank ?? '');
                return rank ?? '';
            case 0, $5fc53.SUMMARY_TYPE:
                return (0, $57lFd.safeGetValue)(fields, sortingField, 'value', '').toLowerCase();
            case 0, $5fc53.TEXT_CF_TYPE:
                return $9b7a6804aae1eb73$var$resolveCustomTextFieldOrder(fields, sortingField);
            case 0, $5fc53.SELECT_CF_TYPE:
            case 0, $5fc53.CATEGORY_TYPE:
                return (0, $57lFd.safeGetValue)(fields, sortingField, 'value.value', $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE);
            case 0, $5fc53.MULTI_SELECT_CF_TYPE:
            case 0, $5fc53.MULTI_CHECKBOXES_CF_TYPE:
                return $9b7a6804aae1eb73$var$getValueMapAndJoin(fields, sortingField, 'value', [], (selectedValue)=>selectedValue?.value.toLowerCase());
            case 0, $5fc53.TIME_ESTIMATE_TYPE:
                return (0, $57lFd.safeGetValue)(fields, sortingField, 'value.timeInSeconds', $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_NUMBER_VALUE);
            case 0, $5fc53.URL_CF_TYPE:
                return (0, $57lFd.safeGetValue)(fields, sortingField, 'value', $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE);
            case 0, $5fc53.NUMBER_CF_TYPE:
            case 0, $5fc53.STORY_POINTS_TYPE:
            case 0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE:
                return (0, $57lFd.safeGetValue)(fields, sortingField, 'value', $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_NUMBER_VALUE);
            case 0, $5fc53.COMPONENTS_TYPE:
                return $9b7a6804aae1eb73$var$getValueMapAndJoin(fields, sortingField, 'value', [], (component)=>component?.name.toLowerCase());
            case 0, $5fc53.SPRINT_TYPE:
                {
                    const sprintValue = (0, $57lFd.safeGetValue)(fields, sortingField, 'value', $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE);
                    if (Array.isArray(sprintValue) && sprintValue.length) {
                        const { name: name, state: state } = sprintValue[0];
                        if (state === 'CLOSED') {
                            const statusId = (0, $57lFd.safeGetValue)(fields, 'status', 'value', '');
                            // closed sprints should not be shown if the status is not done
                            // means that this ticket is on the backlog
                            if (statusId?.toString() !== (0, $gULOk.StatusCategoryIds)[(0, $gULOk.StatusCategoryTypes).DONE].toString()) return $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE;
                        }
                        return name.toLowerCase();
                    }
                    return $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE;
                }
            default:
                return (0, $57lFd.safeGetValue)(fields, (0, $hE5wF.RANK_ALIAS_FIELD_ID), 'value', '');
        }
    };
const $9b7a6804aae1eb73$export$b3fdfcb601c683c3 = (sorting, fieldType, sortedLists)=>{
    const getters = [];
    const orders = [];
    let sortFieldType = fieldType;
    // fieldType for key is not returned from useIssueTypeFieldConfig
    if (sorting?.sortBy === 'key') sortFieldType = 'issuekey';
    if (sorting != null && sorting.sortBy != null) {
        orders.push(sorting.direction, sorting.direction);
        getters.push($9b7a6804aae1eb73$var$createSortableGetter(sortFieldType, sorting.sortBy, sortedLists));
        getters.push($9b7a6804aae1eb73$var$createSortableGetter((0, $hE5wF.RANK_ALIAS_FIELD_ID), (0, $hE5wF.RANK_ALIAS_FIELD_ID)));
    } else {
        orders.push((0, $hE5wF.DEFAULT_RANK_SORTING_DIRECTION));
        getters.push($9b7a6804aae1eb73$var$createSortableGetter((0, $hE5wF.RANK_ALIAS_FIELD_ID), (0, $hE5wF.RANK_ALIAS_FIELD_ID)));
    }
    return {
        getters: getters,
        orders: orders
    };
};

});
parcelRegister("1AkQu", function(module, exports) {

var $kE90z = parcelRequire("kE90z");

var $8LQ84 = parcelRequire("8LQ84");
/**
 * This method is like `_.sortBy` except that it allows specifying the sort
 * orders of the iteratees to sort by. If `orders` is unspecified, all values
 * are sorted in ascending order. Otherwise, specify an order of "desc" for
 * descending or "asc" for ascending sort order of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @param {string[]} [orders] The sort orders of `iteratees`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 34 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 36 }
 * ];
 *
 * // Sort by `user` in ascending order and by `age` in descending order.
 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 */ function $127952ba7d4c15a6$var$orderBy(collection, iteratees, orders, guard) {
    if (collection == null) return [];
    if (!$8LQ84(iteratees)) iteratees = iteratees == null ? [] : [
        iteratees
    ];
    orders = guard ? undefined : orders;
    if (!$8LQ84(orders)) orders = orders == null ? [] : [
        orders
    ];
    return $kE90z(collection, iteratees, orders);
}
module.exports = $127952ba7d4c15a6$var$orderBy;

});

parcelRegister("ijSZT", function(module, exports) {

$parcel$export(module.exports, "getSorting", () => $426da0baa4d91e21$export$654dceec98f3061f);
$parcel$export(module.exports, "isSortingSupported", () => $426da0baa4d91e21$export$c6c6084d02f37d7e);
$parcel$export(module.exports, "isSortingSupportedFieldTypePredicated", () => $426da0baa4d91e21$export$190ed2ad153b150b);
$parcel$export(module.exports, "getSortingDisabledFields", () => $426da0baa4d91e21$export$56c924491e5617ad);

var $8QpSo = parcelRequire("8QpSo");

var $1OjAh = parcelRequire("1OjAh");

var $5nNdw = parcelRequire("5nNdw");

var $cBFqc = parcelRequire("cBFqc");

var $coSD0 = parcelRequire("coSD0");

var $55FhM = parcelRequire("55FhM");

var $gjQcQ = parcelRequire("gjQcQ");

var $4CML6 = parcelRequire("4CML6");

var $WhnfX = parcelRequire("WhnfX");

var $aK7yP = parcelRequire("aK7yP");

var $7LNXH = parcelRequire("7LNXH");

var $dtcdd = parcelRequire("dtcdd");
const $426da0baa4d91e21$var$createSortingHandlers = (0, $8QpSo.default)(()=>({
        ...(0, $55FhM.parentSortingHandler),
        ...(0, $dtcdd.versionSortingHandler),
        ...(0, $WhnfX.resolutionSortingHandler),
        ...(0, $coSD0.groupSortingHandler),
        ...(0, $4CML6.radioSelectSortingHandler),
        ...(0, $1OjAh.cascadingSelectSortingHandler),
        ...(0, $gjQcQ.projectSortingHandler)
    }));
const $426da0baa4d91e21$export$654dceec98f3061f = (fieldType, ...args)=>{
    const handlers = $426da0baa4d91e21$var$createSortingHandlers();
    if (handlers[fieldType] == null) return;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return handlers[fieldType]?.(...args);
};
const $426da0baa4d91e21$export$c6c6084d02f37d7e = (fieldType)=>{
    const handlers = $426da0baa4d91e21$var$createSortingHandlers();
    return handlers[fieldType] != null;
};
const $426da0baa4d91e21$export$190ed2ad153b150b = (fieldType)=>true;
const $426da0baa4d91e21$export$56c924491e5617ad = (0, $8QpSo.default)(()=>({
        ...(0, $5nNdw.devSummaryDisabledSorting),
        ...(0, $7LNXH.teamDisabledSorting),
        ...(0, $aK7yP.statusCategoryDisabledSorting),
        ...(0, $cBFqc.goalsDisabledSorting)
    }));

});
parcelRegister("1OjAh", function(module, exports) {

$parcel$export(module.exports, "cascadingSelectSortingHandler", () => $1924a50c91a471c7$export$7b0bfc6838ff3257);

var $5fc53 = parcelRequire("5fc53");

var $jKNTt = parcelRequire("jKNTt");
const $1924a50c91a471c7$var$getCascadingSelectSorting = (field)=>(0, $jKNTt.getCascadingSelectStringValue)(field.value);
const $1924a50c91a471c7$export$7b0bfc6838ff3257 = {
    [(0, $5fc53.CASCADING_SELECT_CF_TYPE)]: $1924a50c91a471c7$var$getCascadingSelectSorting
};

});
parcelRegister("jKNTt", function(module, exports) {

$parcel$export(module.exports, "getCascadingSelectStringValue", () => $c7661401b6222cfb$export$f110a74eb752aa7e);
$parcel$export(module.exports, "cascadingSelectStringValueHandler", () => $c7661401b6222cfb$export$f39c163ada81742a);
$parcel$export(module.exports, "cascadingSelectRichValueHandler", () => $c7661401b6222cfb$export$af92c160980c340f);

var $5fc53 = parcelRequire("5fc53");
const $c7661401b6222cfb$export$f110a74eb752aa7e = (fieldValue)=>{
    if (fieldValue && fieldValue.parentOptionValue) {
        if (fieldValue.childOptionValue) return `${fieldValue.parentOptionValue.value} - ${fieldValue.childOptionValue.value}`;
        return `${fieldValue.parentOptionValue.value}`;
    }
    return '';
};
const $c7661401b6222cfb$var$getCascadingSelectValue = (field)=>$c7661401b6222cfb$export$f110a74eb752aa7e(field.value);
const $c7661401b6222cfb$var$getCascadingSelectRichValue = (field)=>field.value ?? null;
const $c7661401b6222cfb$export$f39c163ada81742a = {
    [(0, $5fc53.CASCADING_SELECT_CF_TYPE)]: $c7661401b6222cfb$var$getCascadingSelectValue
};
const $c7661401b6222cfb$export$af92c160980c340f = {
    [(0, $5fc53.CASCADING_SELECT_CF_TYPE)]: $c7661401b6222cfb$var$getCascadingSelectRichValue
};

});


parcelRegister("5nNdw", function(module, exports) {

$parcel$export(module.exports, "devSummaryDisabledSorting", () => $8d45926c3e16e57e$export$8cf683615a3ccf77);

var $5fc53 = parcelRequire("5fc53");
const $8d45926c3e16e57e$export$8cf683615a3ccf77 = {
    [(0, $5fc53.DEV_SUMMARY_CF_TYPE)]: false
};

});

parcelRegister("cBFqc", function(module, exports) {

$parcel$export(module.exports, "goalsDisabledSorting", () => $c7872d24a62cd4a6$export$60ff70c996f5c362);

var $5fc53 = parcelRequire("5fc53");
const $c7872d24a62cd4a6$export$60ff70c996f5c362 = {
    [(0, $5fc53.GOALS_CF_TYPE)]: false
};

});

parcelRegister("coSD0", function(module, exports) {

$parcel$export(module.exports, "groupSortingHandler", () => $a9d8ecbf0dcf5f2d$export$a577fd60fa30451d);

var $5fc53 = parcelRequire("5fc53");
const $a9d8ecbf0dcf5f2d$var$getSingleGroupSorting = (field)=>field.value?.name ?? '';
const $a9d8ecbf0dcf5f2d$var$getMultipleGroupSorting = (field)=>field.value == null ? '' : field.value.map((v)=>v.name).join(',');
const $a9d8ecbf0dcf5f2d$export$a577fd60fa30451d = {
    [(0, $5fc53.GROUP_CF_TYPE)]: $a9d8ecbf0dcf5f2d$var$getSingleGroupSorting,
    [(0, $5fc53.MULTI_GROUP_CF_TYPE)]: $a9d8ecbf0dcf5f2d$var$getMultipleGroupSorting
};

});

parcelRegister("55FhM", function(module, exports) {

$parcel$export(module.exports, "parentSortingHandler", () => $a7f27eceaa949fb5$export$20dbdacc158507c9);

var $5fc53 = parcelRequire("5fc53");
const $a7f27eceaa949fb5$var$getParentSorting = (field)=>field.value ? field.value.issueKey : '';
const $a7f27eceaa949fb5$export$20dbdacc158507c9 = {
    [(0, $5fc53.PARENT_TYPE)]: $a7f27eceaa949fb5$var$getParentSorting
};

});

parcelRegister("gjQcQ", function(module, exports) {

$parcel$export(module.exports, "projectSortingHandler", () => $a97b41f281e121d8$export$18c888fa7805bbf9);

var $5fc53 = parcelRequire("5fc53");
const $a97b41f281e121d8$var$getProjectSorting = (field)=>field.value?.name ?? '';
const $a97b41f281e121d8$export$18c888fa7805bbf9 = {
    [(0, $5fc53.PROJECT_PICKER_CF_TYPE)]: $a97b41f281e121d8$var$getProjectSorting
};

});

parcelRegister("4CML6", function(module, exports) {

$parcel$export(module.exports, "radioSelectSortingHandler", () => $0a650a9e38d8f12d$export$d622730346571a2b);

var $5fc53 = parcelRequire("5fc53");
const $0a650a9e38d8f12d$var$getRadioSelectSorting = (field)=>field.value ? field.value.value : '';
const $0a650a9e38d8f12d$export$d622730346571a2b = {
    [(0, $5fc53.RADIO_BUTTONS_CF_TYPE)]: $0a650a9e38d8f12d$var$getRadioSelectSorting
};

});

parcelRegister("WhnfX", function(module, exports) {

$parcel$export(module.exports, "resolutionSortingHandler", () => $5149dcabcac386a7$export$596a643f093db9a7);

var $5fc53 = parcelRequire("5fc53");
const $5149dcabcac386a7$var$getResolutionSorting = (field)=>field.value?.name ?? '';
const $5149dcabcac386a7$export$596a643f093db9a7 = {
    [(0, $5fc53.RESOLUTION_TYPE)]: $5149dcabcac386a7$var$getResolutionSorting
};

});

parcelRegister("aK7yP", function(module, exports) {

$parcel$export(module.exports, "statusCategoryDisabledSorting", () => $a8138d3f5e843f75$export$117cb43589655b27);

var $5fc53 = parcelRequire("5fc53");
const $a8138d3f5e843f75$export$117cb43589655b27 = {
    [(0, $5fc53.STATUS_CATEGORY_TYPE)]: false
};

});

parcelRegister("7LNXH", function(module, exports) {

$parcel$export(module.exports, "teamDisabledSorting", () => $f566370ab4491013$export$1626c947db580b0f);

var $5fc53 = parcelRequire("5fc53");
const $f566370ab4491013$export$1626c947db580b0f = {
    [(0, $5fc53.TEAMS_PLATFORM_CF_TYPE)]: false
};

});

parcelRegister("dtcdd", function(module, exports) {

$parcel$export(module.exports, "versionSortingHandler", () => $b3c9429c32861e4c$export$f2894a637a250eaa);

var $5fc53 = parcelRequire("5fc53");
const $b3c9429c32861e4c$var$getSingleVersionSorting = (field)=>field.value?.name ?? '';
const $b3c9429c32861e4c$var$getMultipleVersionSorting = (field)=>field.value == null ? '' : field.value.map((v)=>v.name).join(',');
const $b3c9429c32861e4c$export$f2894a637a250eaa = {
    [(0, $5fc53.VERSION_CF_TYPE)]: $b3c9429c32861e4c$var$getSingleVersionSorting,
    [(0, $5fc53.MULTI_VERSION_CF_TYPE)]: $b3c9429c32861e4c$var$getMultipleVersionSorting,
    [(0, $5fc53.FIX_VERSIONS_TYPE)]: $b3c9429c32861e4c$var$getMultipleVersionSorting,
    [(0, $5fc53.AFFECTS_VERSIONS_TYPE)]: $b3c9429c32861e4c$var$getMultipleVersionSorting
};

});


parcelRegister("fCkUD", function(module, exports) {

$parcel$export(module.exports, "isNewTransformedFieldPredicated", () => $fb9b3f13d18b237f$export$b018c2b58ea7e0de);
const $fb9b3f13d18b237f$export$b018c2b58ea7e0de = (field)=>field != null;

});

parcelRegister("57lFd", function(module, exports) {

$parcel$export(module.exports, "getFieldValue", () => $9c93e114366691a0$export$2e85048acc9aea83);
$parcel$export(module.exports, "safeGetValue", () => $9c93e114366691a0$export$f17a5eaf5fe57cff);
$parcel$export(module.exports, "safeGetTransformedFieldValue", () => $9c93e114366691a0$export$16456470899ab77f);
$parcel$export(module.exports, "safeGetTransformedValue", () => $9c93e114366691a0$export$c1cc7bc9b4953394);

var $9XE6b = parcelRequire("9XE6b");
const $9c93e114366691a0$export$2e85048acc9aea83 = (fields, fieldKey)=>{
    if (fields && fieldKey != null) return fields.find((field)=>field?.fieldKey && field.fieldKey === fieldKey || field?.fieldId && field.fieldId === fieldKey || field?.aliasFieldId && field.aliasFieldId === fieldKey);
    return undefined;
};
const $9c93e114366691a0$export$f17a5eaf5fe57cff = (fields, fieldKey, attributeName, defaultValue)=>{
    const field = $9c93e114366691a0$export$2e85048acc9aea83(fields, fieldKey);
    return (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(field, attributeName, defaultValue);
};
const $9c93e114366691a0$export$16456470899ab77f = (fields, fieldKey, attributeName, defaultValue)=>{
    const field = $9c93e114366691a0$export$2e85048acc9aea83(fields, fieldKey);
    return $9c93e114366691a0$export$c1cc7bc9b4953394(field, defaultValue);
};
const $9c93e114366691a0$export$c1cc7bc9b4953394 = (field, defaultValue)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(field, 'value', defaultValue);

});

parcelRegister("ixx6N", function(module, exports) {

$parcel$export(module.exports, "resolveRank", () => $0a08bd66273f9a8c$export$992090b26f7c7f11);
const $0a08bd66273f9a8c$export$992090b26f7c7f11 = (parentIssue, rank)=>{
    // for the Sub-task issue types, sorting based on rank considers the parent rank first, then sorts based on item rank
    // concatenating (parentRank + rank) would do that for us!
    const parentRank = parentIssue?.rank ?? '';
    return parentRank.concat(rank);
};

});



parcelRegister("17ot5", function(module, exports) {

$parcel$export(module.exports, "useHideDoneItems", () => $f683983c23bf92d0$export$c2cb7b17819b92d4);
$parcel$export(module.exports, "useInferHideDoneItemsWithFilters", () => $f683983c23bf92d0$export$a14bc8305f71e469);

var $5uXOq = parcelRequire("5uXOq");

var $x8FYU = parcelRequire("x8FYU");

var $1kpI8 = parcelRequire("1kpI8");

var $gULOk = parcelRequire("gULOk");

var $dpQnO = parcelRequire("dpQnO");
const $f683983c23bf92d0$export$c2cb7b17819b92d4 = ()=>{
    const [hideDoneItems, persistHideDoneItems] = (0, $1kpI8.useViewPreference)((0, $x8FYU.HIDE_DONE_ITEMS_PREFERENCE));
    const setHideDoneItems = (0, $5uXOq.useCallback)((hide, action = 'push')=>persistHideDoneItems(hide ? 'true' : undefined, action), [
        persistHideDoneItems
    ]);
    return [
        hideDoneItems === 'true',
        setHideDoneItems
    ];
};
const $f683983c23bf92d0$export$a14bc8305f71e469 = ({ filters: filters })=>{
    const [hideDoneItems, setHideDoneItems] = $f683983c23bf92d0$export$c2cb7b17819b92d4();
    const { quickFilters: quickFilters } = (0, $dpQnO.useQuickFilters)();
    (0, $5uXOq.useEffect)(()=>{
        if (hideDoneItems) {
            const isFilteringByDoneStatus = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (filters && filters.status)?.find((status)=>Number(status.categoryId) === (0, $gULOk.StatusCategoryIds)[(0, $gULOk.StatusCategoryTypes).DONE]);
            if (isFilteringByDoneStatus || quickFilters?.DONE) setHideDoneItems(false, 'replace');
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        filters,
        quickFilters?.DONE
    ]);
};

});
parcelRegister("dpQnO", function(module, exports) {

$parcel$export(module.exports, "useQuickFilters", () => $59496077a2cce3b6$export$3dae1bb95b659fd4);

var $5uXOq = parcelRequire("5uXOq");

var $5fc53 = parcelRequire("5fc53");

var $g4ZHz = parcelRequire("g4ZHz");

var $l4Ejo = parcelRequire("l4Ejo");
const $59496077a2cce3b6$var$quickFilterToJQLMapOld = {
    ASSIGNED_TO_ME: 'assignee = currentUser()',
    DONE: "StatusCategory = 'Complete'",
    DUE_THIS_WEEK: 'duedate <= endOfWeek() and duedate > startOfWeek()'
};
const $59496077a2cce3b6$export$808f76242d61e1a5 = (sprintJQLTerm)=>{
    if (sprintJQLTerm == null) return $59496077a2cce3b6$var$quickFilterToJQLMapOld;
    return {
        ...$59496077a2cce3b6$var$quickFilterToJQLMapOld,
        ACTIVE_SPRINTS: `${sprintJQLTerm} in openSprints()`
    };
};
const $59496077a2cce3b6$var$buildJQLFromQuickFilters = (quickFilters, { quickFilterToJQLMap: quickFilterToJQLMap = $59496077a2cce3b6$var$quickFilterToJQLMapOld } = {})=>{
    const jqlClauses = Object.entries(quickFilters).map(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly ASSIGNED_TO_ME: "assignee = currentUser()"; readonly DONE: "StatusCategory = 'Complete'"; readonly DUE_THIS_WEEK: "duedate <= endOfWeek() and duedate > startOfWeek()"; }'.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ([key, isEnabled])=>isEnabled === true && quickFilterToJQLMap[key]);
    const enabledFilters = jqlClauses.filter((jql)=>jql);
    return enabledFilters.join(' AND ') || null;
};
const $59496077a2cce3b6$export$9294471da4d3c33f = {
    ASSIGNED_TO_ME: false,
    DONE: false,
    DUE_THIS_WEEK: false,
    ACTIVE_SPRINTS: false
};
const $59496077a2cce3b6$export$9692fc1a2fd983f5 = (jql, { quickFilterToJQLMap: quickFilterToJQLMap = $59496077a2cce3b6$var$quickFilterToJQLMapOld } = {})=>{
    const quickFilters = {
        ...$59496077a2cce3b6$export$9294471da4d3c33f
    };
    if (!jql) return quickFilters;
    if (jql.includes(quickFilterToJQLMap.ASSIGNED_TO_ME)) quickFilters.ASSIGNED_TO_ME = true;
    if (jql.includes(quickFilterToJQLMap.DONE)) quickFilters.DONE = true;
    if (jql.includes(quickFilterToJQLMap.DUE_THIS_WEEK)) quickFilters.DUE_THIS_WEEK = true;
    if (quickFilterToJQLMap.ACTIVE_SPRINTS && jql.includes(quickFilterToJQLMap.ACTIVE_SPRINTS)) quickFilters.ACTIVE_SPRINTS = true;
    return quickFilters;
};
const $59496077a2cce3b6$var$useSprintFieldJQLTerm = ()=>{
    const { data: fields } = (0, $g4ZHz.useFieldsResource)();
    return (0, $5uXOq.useMemo)(()=>{
        if (fields == null) return undefined;
        const sprintField = fields.find((field)=>field.type === (0, $5fc53.SPRINT_TYPE));
        return sprintField != null ? sprintField.jqlTerm : undefined;
    }, [
        fields
    ]);
};
const $59496077a2cce3b6$export$3dae1bb95b659fd4 = ()=>{
    const sprintFieldJQLTerm = $59496077a2cce3b6$var$useSprintFieldJQLTerm();
    const quickFilterToJQLMap = (0, $5uXOq.useMemo)(()=>$59496077a2cce3b6$export$808f76242d61e1a5(sprintFieldJQLTerm), [
        sprintFieldJQLTerm
    ]);
    const { jql: jql, saveJql: saveJql } = (0, $l4Ejo.useFiltersPreference)();
    const setQuickFilters = (0, $5uXOq.useCallback)((newQuickFilters)=>{
        if (newQuickFilters) {
            const newJql = $59496077a2cce3b6$var$buildJQLFromQuickFilters(newQuickFilters, {
                quickFilterToJQLMap: quickFilterToJQLMap
            });
            if (newJql == null) saveJql(undefined);
            else saveJql(newJql);
        } else saveJql(undefined);
    }, [
        quickFilterToJQLMap,
        saveJql
    ]);
    const quickFilters = (0, $5uXOq.useMemo)(()=>$59496077a2cce3b6$export$9692fc1a2fd983f5(jql, {
            quickFilterToJQLMap: quickFilterToJQLMap
        }), [
        jql,
        quickFilterToJQLMap
    ]);
    return {
        quickFilters: quickFilters,
        persistQuickFilters: setQuickFilters,
        quickFiltersJql: $59496077a2cce3b6$var$buildJQLFromQuickFilters(quickFilters, {
            quickFilterToJQLMap: quickFilterToJQLMap
        })
    };
};

});


parcelRegister("1T1ir", function(module, exports) {

$parcel$export(module.exports, "useSimpleSearch", () => $9ff55c3a873f98f5$export$b549f44e7ca96280);
$parcel$export(module.exports, "useSimpleSearchHighlight", () => $9ff55c3a873f98f5$export$fd04dfca01137d2);
$parcel$export(module.exports, "useSearchText", () => $9ff55c3a873f98f5$export$119186efd4186c93);
$parcel$export(module.exports, "useSimpleSearchJQL", () => $9ff55c3a873f98f5$export$42b8d8a5ec5bc873);

var $5uXOq = parcelRequire("5uXOq");

var $9XS00 = parcelRequire("9XS00");

var $ieDtd = parcelRequire("ieDtd");

var $7htvz = parcelRequire("7htvz");
const $9ff55c3a873f98f5$var$sanitize = (value)=>value.replace(/\\/g, '\\\\').replace(/'/g, "\\'").replace(/\t/g, ' ');
const $9ff55c3a873f98f5$var$issueKeyRegex = new RegExp(`^${(0, $9XS00.ISSUEKEY_REGEX)}$`);
const $9ff55c3a873f98f5$var$japaneseAndChineseRegex = /[\p{Script_Extensions=Hiragana}\p{Script_Extensions=Katakana}\p{Script_Extensions=Han}]/u;
const $9ff55c3a873f98f5$export$b549f44e7ca96280 = ()=>{
    const [simpleSearch, persistSimpleSearch] = (0, $ieDtd.useQueryParam)((0, $7htvz.SIMPLE_SEARCH_PARAM));
    const setSimpleSearch = (0, $5uXOq.useCallback)((searchText)=>{
        searchText != null && searchText.trim() !== '' ? persistSimpleSearch(searchText) : persistSimpleSearch(undefined);
    }, [
        persistSimpleSearch
    ]);
    return [
        simpleSearch ?? '',
        setSimpleSearch
    ];
};
const $9ff55c3a873f98f5$export$72839f749ccf76b2 = (text)=>{
    if (text == null) return [];
    return text.split(' ').filter((word)=>word !== '');
};
const $9ff55c3a873f98f5$export$fd04dfca01137d2 = ()=>{
    const [simpleSearch] = $9ff55c3a873f98f5$export$b549f44e7ca96280();
    return (0, $5uXOq.useMemo)(()=>$9ff55c3a873f98f5$export$72839f749ccf76b2(simpleSearch), [
        simpleSearch
    ]);
};
const $9ff55c3a873f98f5$export$abb78553baf1cfac = (text)=>{
    if (text == null || text.trim() === '') return '';
    let search = $9ff55c3a873f98f5$var$sanitize(text);
    if ($9ff55c3a873f98f5$var$issueKeyRegex.test(text)) return `(summary ~ '${search}*' OR description ~ '${search}*' OR key = '${search}')`;
    // if the text does not contain Chinese or Japanese characters (which are not tokenized),
    // and does not end with a space character
    // make it a wildcard search
    if (!$9ff55c3a873f98f5$var$japaneseAndChineseRegex.test(text) && !text.endsWith(' ')) search = `${search}*`;
    return `(summary ~ '${search}' OR description ~ '${search}')`;
};
const $9ff55c3a873f98f5$export$119186efd4186c93 = (text)=>{
    const jql = (0, $5uXOq.useMemo)(()=>$9ff55c3a873f98f5$export$abb78553baf1cfac(text), [
        text
    ]);
    const highlight = (0, $5uXOq.useMemo)(()=>$9ff55c3a873f98f5$export$72839f749ccf76b2(text), [
        text
    ]);
    return {
        jql: jql,
        highlight: highlight
    };
};
const $9ff55c3a873f98f5$export$42b8d8a5ec5bc873 = ()=>{
    const [simpleSearch] = $9ff55c3a873f98f5$export$b549f44e7ca96280();
    const jql = (0, $5uXOq.useMemo)(()=>$9ff55c3a873f98f5$export$abb78553baf1cfac(simpleSearch), [
        simpleSearch
    ]);
    const addSimpleSearchToJQL = (0, $5uXOq.useCallback)((currentJQL)=>{
        if (jql === '') return currentJQL;
        if (currentJQL == null) return jql;
        return `${currentJQL} AND ${jql}`;
    }, [
        jql
    ]);
    return {
        jql: jql,
        isSearching: jql !== '',
        addSimpleSearchToJQL: addSimpleSearchToJQL
    };
};
var $9ff55c3a873f98f5$export$2e2bcd8739ae039 = $9ff55c3a873f98f5$export$b549f44e7ca96280;

});
parcelRegister("9XS00", function(module, exports) {

$parcel$export(module.exports, "ISSUEKEY_REGEX", () => $76f8b51a225e9798$export$b52c9cee589449a8);
$parcel$export(module.exports, "default", () => $76f8b51a225e9798$export$2e2bcd8739ae039);

var $aZsz6 = parcelRequire("aZsz6");
const $76f8b51a225e9798$export$b52c9cee589449a8 = '([A-Z][A-Z0-9_]+-\\d+)';
var /**
 * Returns the issue key if the URL is a valid full page Jira issue URL. It may also include a trailing
 * hash fragment. A matching URL must look like:
 * <host><baseurl>/browse/<issuekey><#hash?>
 * e.g. https://my-jira-instance.atlassian.net/browse/FOO-123#xyz
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$76f8b51a225e9798$export$2e2bcd8739ae039 = (url, host)=>{
    const parsedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($aZsz6)))(url, {});
    const isMatchingProtocol = parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:';
    const isMatchingHost = parsedUrl.host === host;
    const matches = parsedUrl.pathname.match(new RegExp(`^\\/browse\\/${$76f8b51a225e9798$export$b52c9cee589449a8}\\/?$`));
    const issueKey = matches && matches.length > 1 ? matches[1] : null;
    return isMatchingProtocol && isMatchingHost && issueKey || null;
};

});


parcelRegister("7VpiX", function(module, exports) {

$parcel$export(module.exports, "sanitiseJql", () => $e5742a6c935cce4a$export$78c9a06ab18996fc);
$parcel$export(module.exports, "getJqlErrors", () => $e5742a6c935cce4a$export$cc387523b0acb16d);

var $eK6AG = parcelRequire("eK6AG");
var $l0V05 = parcelRequire("l0V05");
const $e5742a6c935cce4a$export$78c9a06ab18996fc = (jql)=>{
    if (!jql) return jql;
    const builder = new (0, $eK6AG.JastBuilder)();
    const jast = builder.build(jql);
    if (jast.query && jast.query.orderBy) jast.query.orderBy = undefined;
    return (0, $l0V05.print)(jast, {
        operatorCase: 'upper',
        printWidth: null
    });
};
const $e5742a6c935cce4a$export$cc387523b0acb16d = (jql)=>{
    if (!jql) return [];
    const builder = new (0, $eK6AG.JastBuilder)();
    const jast = builder.build(jql);
    return jast.errors;
};

});


parcelRegister("eq1P7", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7fbca7864143b4e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c7fbca7864143b4e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "business-list.controllers.forms-label-flag.title",
        "defaultMessage": "We\u2019ve introduced new form labels"
    },
    description: {
        "id": "business-list.controllers.forms-label-flag.description",
        "defaultMessage": "To include older submissions in your search, update your filters."
    },
    viewAllLink: {
        "id": "business-list.controllers.forms-label-flag.view-all-link",
        "defaultMessage": "Update filters"
    },
    iconLabel: {
        "id": "business-list.controllers.forms-label-flag.icon-label",
        "defaultMessage": "Alert"
    }
});

});


parcelRegister("8e3Yw", function(module, exports) {

$parcel$export(module.exports, "useGroupBy", () => $6c4a56f4e59830d6$export$c4ec754551fa3ff4);

var $x8FYU = parcelRequire("x8FYU");

var $1kpI8 = parcelRequire("1kpI8");
const $6c4a56f4e59830d6$export$c4ec754551fa3ff4 = ()=>{
    const [groupByFieldId, setGroupBy] = (0, $1kpI8.useViewPreference)((0, $x8FYU.GROUPING_PREFERENCE));
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return [
        groupByFieldId,
        setGroupBy
    ];
};

});

parcelRegister("g4BWd", function(module, exports) {

$parcel$export(module.exports, "useCreateIssue", () => $cf55a53088d59416$export$8af2d18142c8506c);

var $5uXOq = parcelRequire("5uXOq");

var $5tTFS = parcelRequire("5tTFS");

var $egmQO = parcelRequire("egmQO");

var $hE5wF = parcelRequire("hE5wF");

var $5YBrl = parcelRequire("5YBrl");

var $gZEAz = parcelRequire("gZEAz");

var $ePLOx = parcelRequire("ePLOx");

var $kRkJF = parcelRequire("kRkJF");

var $jlq4V = parcelRequire("jlq4V");

var $4R6GH = parcelRequire("4R6GH");

var $jJZqs = parcelRequire("jJZqs");

var $eCBf9 = parcelRequire("eCBf9");

var $560mU = parcelRequire("560mU");

var $5fc53 = parcelRequire("5fc53");

var $koeKL = parcelRequire("koeKL");

var $6s1PB = parcelRequire("6s1PB");

var $lDRI0 = parcelRequire("lDRI0");

var $eTDjN = parcelRequire("eTDjN");

var $c82az = parcelRequire("c82az");

var $2F7tZ = parcelRequire("2F7tZ");
const $cf55a53088d59416$var$storyPointEstimateFieldPredicate = (field)=>field.type === (0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE);
const $cf55a53088d59416$var$storyPointsFieldPredicate = (field)=>field.type === (0, $5fc53.NUMBER_CF_TYPE) && field.aliasFieldId === (0, $hE5wF.STORY_POINTS_ALIAS_FIELD_ID);
const $cf55a53088d59416$var$sprintFieldPredicate = (field)=>field.type === (0, $5fc53.SPRINT_TYPE);
function $cf55a53088d59416$export$fd83eea6ecd2d8fa(query) {
    const client = (0, $5tTFS.useApolloClient)();
    return (0, $5uXOq.useCallback)((variables)=>client.query({
            query: query,
            variables: variables,
            errorPolicy: 'all'
        }), [
        client,
        query
    ]);
}
const $cf55a53088d59416$export$8af2d18142c8506c = ()=>{
    const { data: categoryField } = (0, $gZEAz.useCategoryField)();
    const { data: storyPointEstimateField } = (0, $ePLOx.useFindField)($cf55a53088d59416$var$storyPointEstimateFieldPredicate);
    const { data: storyPointsField } = (0, $ePLOx.useFindField)($cf55a53088d59416$var$storyPointsFieldPredicate);
    const { data: sprintField } = (0, $ePLOx.useFindField)($cf55a53088d59416$var$sprintFieldPredicate);
    const cloudId = (0, $koeKL.useCloudId)();
    const jqlContext = (0, $5YBrl.useJqlContext)();
    const filtersJQL = (0, $kRkJF.useFilteredViewJQL)();
    const { onIssueCreated: onIssueCreated } = (0, $560mU.useOnboardingGetStartedTourActions)();
    const refetchIssue = $cf55a53088d59416$export$fd83eea6ecd2d8fa((0, $c82az.ISSUE_REFETCH_QUERY));
    const [createIssue] = (0, $5tTFS.useMutation)((0, $c82az.CREATE_ISSUE_MUTATION));
    const createIssueService = (0, $5uXOq.useCallback)(async (createParams, extraPayload = {})=>{
        const input = (0, $2F7tZ.buildInput)(createParams.input, extraPayload, categoryField, sprintField, storyPointEstimateField, storyPointsField);
        const fieldIdsSet = new Set(createParams.fieldIdsToReturn);
        const isDevSummaryFieldVisible = fieldIdsSet.has((0, $eTDjN.DEV_SUMMARY_FIELD));
        const isParentFieldVisible = fieldIdsSet.has((0, $eTDjN.PARENT_FIELD));
        fieldIdsSet.delete((0, $eTDjN.DEV_SUMMARY_FIELD));
        fieldIdsSet.delete((0, $eTDjN.PARENT_FIELD));
        fieldIdsSet.delete((0, $5fc53.ISSUE_LINKS_TYPE));
        fieldIdsSet.delete((0, $hE5wF.CARD_COVERS_TYPE));
        const fieldIds = Array.from(fieldIdsSet);
        const { data: data, errors: errors } = await createIssue({
            variables: {
                input: input,
                fieldIds: fieldIds,
                isParentFieldVisible: isParentFieldVisible,
                isDevSummaryFieldVisible: isDevSummaryFieldVisible,
                isUnreadCommentsEnabled: (0, $6s1PB.expVal)('jira_unread_comments_in_list_view', 'isEnabled', false),
                includeIsVerifiedInTeamFragment: (0, $4R6GH.fg)('is-verified-in-business-team-field-fragment')
            },
            // @ts-expect-error - errorPolicy is not in the types but does work
            errorPolicy: 'all'
        });
        const result = data?.createJiraBusinessIssue;
        if (result?.success !== true || !result?.item) {
            const firstMutationError = result?.errors?.[0];
            if (firstMutationError) {
                const statusCode = firstMutationError.extensions?.statusCode;
                if (statusCode && statusCode >= 400 && statusCode < 500) throw new (0, $jJZqs.ValidationError)(firstMutationError.message ?? 'Failed to create issue');
                throw new (0, $eCBf9.MutationError)(firstMutationError);
            }
            throw new (0, $jlq4V.GraphQLErrors)(errors);
        }
        if ((0, $lDRI0.shouldWrapTypeCellOnboardingSpotlight)() || (0, $lDRI0.shouldWrapFieldsDropdownOnboardingSpotlight)()) onIssueCreated(createParams.input.projectId);
        return {
            item: result.item,
            itemIdentifiers: {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                issueId: result.itemIdentifiers.issueId,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-non-null-assertion
                issueKey: result.itemIdentifiers.issueKey[0].text
            }
        };
    }, [
        categoryField,
        createIssue,
        onIssueCreated,
        sprintField,
        storyPointEstimateField,
        storyPointsField
    ]);
    const refetchIssueService = (0, $5uXOq.useCallback)(async (issueId, fieldIds, withFiltersContext)=>{
        const jql = (0, $egmQO.generateJql)({
            jqlContext: jqlContext,
            quickFiltersJql: withFiltersContext ? filtersJQL : undefined,
            issueIds: [
                issueId
            ]
        });
        const fieldIdsSet = new Set(fieldIds);
        fieldIdsSet.delete((0, $5fc53.ISSUE_LINKS_TYPE));
        fieldIdsSet.delete((0, $hE5wF.CARD_COVERS_TYPE));
        const fieldIdsToRequest = Array.from(fieldIdsSet);
        const { data: data } = await refetchIssue({
            jql: jql,
            fieldIds: fieldIdsToRequest,
            cloudId: cloudId,
            first: 1,
            isParentFieldVisible: false,
            isDevSummaryFieldVisible: false,
            isUnreadCommentsEnabled: (0, $6s1PB.expVal)('jira_unread_comments_in_list_view', 'isEnabled', false),
            includeIsVerifiedInTeamFragment: (0, $4R6GH.fg)('is-verified-in-business-team-field-fragment')
        });
        const viewItems = data?.jira?.jwmViewItems;
        if (!viewItems || viewItems.__typename === 'QueryError') throw new Error('Issue not found');
        const issue = viewItems.edges?.[0]?.node;
        return issue ?? null;
    }, [
        cloudId,
        filtersJQL,
        jqlContext,
        refetchIssue
    ]);
    return {
        createIssue: createIssueService,
        refetchIssue: refetchIssueService
    };
};

});
parcelRegister("egmQO", function(module, exports) {

$parcel$export(module.exports, "generateJql", () => $da4d6eca1d928e18$export$d43e55153d6948c0);
$parcel$export(module.exports, "getVariables", () => $da4d6eca1d928e18$export$a39eddd73bba62c1);

var $hE5wF = parcelRequire("hE5wF");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");


var $42GbZ = parcelRequire("42GbZ");
const $da4d6eca1d928e18$var$DEFAULT_CHILDREN_PER_PAGE = (0, $hE5wF.DEFAULT_PAGE_SIZE);
const $da4d6eca1d928e18$var$IS_EMPTY = 'IS EMPTY';
const $da4d6eca1d928e18$var$IS_NOT_EMPTY = 'IS NOT EMPTY';
const $da4d6eca1d928e18$export$d43e55153d6948c0 = (input, parentIssueForJql)=>{
    const { groupQuery: groupQuery, hierarchyLevel: hierarchyLevel, hierarchyParent: hierarchyParent, issueIds: issueIds, jqlContext: jqlContext, projectIdOrKey: projectIdOrKey, quickFiltersJql: quickFiltersJql, sorting: sorting } = input;
    const defaultSorting = `ORDER BY Rank ${(0, $hE5wF.DEFAULT_RANK_SORTING_DIRECTION)}`;
    const jql = [];
    // Check if sorting direction is valid, the direction possible passed from the URL params which can be invalid
    const isValidDirection = sorting?.direction?.toUpperCase() === 'ASC' || sorting?.direction?.toUpperCase() === 'DESC';
    const sortByClause = sorting != null && sorting.sortBy != null && sorting.direction != null && isValidDirection ? `ORDER By ${(0, $42GbZ.getJqlTerm)(sorting.sortBy)} ${sorting.direction}, Rank ${sorting.direction}` : defaultSorting;
    if (Array.isArray(issueIds) && issueIds.length > 0) jql.push(`(${issueIds.map((id)=>`id = ${id}`).join(' or ')})`);
    if (jqlContext) jql.push(jqlContext);
    else if (typeof projectIdOrKey !== 'undefined') jql.push(`project = '${projectIdOrKey}'`);
    if (typeof hierarchyLevel === 'number' && hierarchyParent === (0, $8debe7dace56daea$export$9355e489ad16f98e)) {
        // fetch items by hierarchyLevel + any item that doesn't have a parent (e.g. tasks that don't belong to any Epic)
        if (typeof projectIdOrKey !== 'undefined') jql.push(`(hierarchyLevel = ${hierarchyLevel} OR parent ${$da4d6eca1d928e18$var$IS_EMPTY} OR (parent ${$da4d6eca1d928e18$var$IS_NOT_EMPTY} AND parentProject != '${projectIdOrKey}'))`);
        else jql.push(`(hierarchyLevel = ${hierarchyLevel} OR parent ${$da4d6eca1d928e18$var$IS_EMPTY})`);
    }
    if (hierarchyParent === (0, $8debe7dace56daea$export$9355e489ad16f98e)) jql.push('type in standardIssueTypes()');
    // Controls the query to get all children for a single parent
    if (parentIssueForJql && parentIssueForJql.hierarchyType === (0, $8debe7dace56daea$export$9355e489ad16f98e)) jql.push(`parent = '${parentIssueForJql.issueId}'`);
    // Controls the query to get group items
    if (groupQuery) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const { jqlTerm: jqlTerm, value: value } = groupQuery;
        if (!value) jql.push(`${jqlTerm} ${$da4d6eca1d928e18$var$IS_EMPTY}`);
        else jql.push(`${jqlTerm} = ${value}`);
        if (hierarchyParent === (0, $8debe7dace56daea$export$9355e489ad16f98e)) {
            if (typeof projectIdOrKey !== 'undefined') jql.push(`(parent ${$da4d6eca1d928e18$var$IS_EMPTY} OR (parent ${$da4d6eca1d928e18$var$IS_NOT_EMPTY} AND parentProject != '${projectIdOrKey}'))`);
            else jql.push(`parent ${$da4d6eca1d928e18$var$IS_EMPTY}`);
        }
    }
    if (quickFiltersJql != null) jql.push(`(${quickFiltersJql})`);
    return `${jql.join(' AND ')} ${sortByClause}`;
};
const $da4d6eca1d928e18$export$a39eddd73bba62c1 = (input)=>{
    const { fieldIds: fieldIds, parentIssue: parentIssue } = input;
    const singleQueryJql = {
        jql: $da4d6eca1d928e18$export$d43e55153d6948c0(input, parentIssue)
    };
    // REMOTE_ISSUE_LINKS_TYPE should not be part of the fieldIds as it is only used to determine
    // whether legacyConfluenceLinks(JIS2) is fetched
    const newFieldIds = Array.isArray(fieldIds) ? [
        ...fieldIds
    ] : [];
    const remoteIssueLinksIndex = newFieldIds.indexOf((0, $hE5wF.REMOTE_ISSUE_LINKS_TYPE));
    const hasConfluenceLinks = remoteIssueLinksIndex > -1;
    if (hasConfluenceLinks) newFieldIds.splice(remoteIssueLinksIndex, 1);
    const shouldAddWithQueryError = input.withQueryError && (0, $4R6GH.fg)('timeline-add-jql-error-boundary');
    return {
        ...singleQueryJql,
        first: parentIssue ? $da4d6eca1d928e18$var$DEFAULT_CHILDREN_PER_PAGE : (0, $hE5wF.DEFAULT_PAGE_SIZE),
        fieldIds: newFieldIds,
        withConfluenceLinks: hasConfluenceLinks,
        includeDoneItems: input.isHidingDoneItems === false,
        isParentFieldVisible: input.isParentFieldVisible ?? false,
        isDevSummaryFieldVisible: input.isDevSummaryFieldVisible ?? false,
        isUnreadCommentsEnabled: (0, $6s1PB.expVal)('jira_unread_comments_in_list_view', 'isEnabled', false),
        includeIsVerifiedInTeamFragment: (0, $4R6GH.fg)('is-verified-in-business-team-field-fragment'),
        ...shouldAddWithQueryError && {
            withQueryError: input.withQueryError
        }
    };
};

});
parcelRegister("42GbZ", function(module, exports) {

$parcel$export(module.exports, "getJqlTerm", () => $f8ba3884a7b69792$export$43330b5a5235b231);

var $5fc53 = parcelRequire("5fc53");
const $f8ba3884a7b69792$export$43330b5a5235b231 = (fieldId, fieldType)=>{
    // custom fields are indexed by their ids and only work with JQL when referenced as such `cf[id]`.
    if (fieldId.indexOf('customfield_') === 0) {
        const customFieldId = fieldId.split('customfield_')[1];
        return `cf[${customFieldId}]`;
    }
    // We are hardcoding the components field jqlTerm because is not the same as field ID
    // We should get the jqlTerm from the BE
    // https://atlassian.slack.com/archives/CFGMKF5QC/p1724650674231049?thread_ts=1720579171.825049&cid=CFGMKF5QC
    if (fieldType === (0, $5fc53.COMPONENTS_TYPE)) return 'component';
    return fieldId;
};

});


parcelRegister("gZEAz", function(module, exports) {

$parcel$export(module.exports, "useCategoryField", () => $23a2f3aed16dc942$export$f7ac7f1f12b4c794);

var $5fc53 = parcelRequire("5fc53");

var $1T2vX = parcelRequire("1T2vX");
const $23a2f3aed16dc942$export$f7ac7f1f12b4c794 = ()=>{
    const { data: { fields: fields }, loading: loading, error: error } = (0, $1T2vX.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const categoryField = fields.find((field)=>field.type === (0, $5fc53.CATEGORY_TYPE)) ?? null;
    return {
        data: categoryField,
        loading: loading,
        error: error
    };
};

});

parcelRegister("ePLOx", function(module, exports) {

$parcel$export(module.exports, "useFindField", () => $7269f16a47ce2a8a$export$4b0b80fa50e6b4be);

var $1T2vX = parcelRequire("1T2vX");
const $7269f16a47ce2a8a$export$4b0b80fa50e6b4be = (predicate)=>{
    const { data: { fields: fields }, loading: loading, error: error } = (0, $1T2vX.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const field = fields.find(predicate) ?? null;
    return {
        data: field,
        loading: loading,
        error: error
    };
};

});

parcelRegister("560mU", function(module, exports) {

$parcel$export(module.exports, "CREATE_CHILD_SPOTLIGHT_ID", () => $90c48096f6d773df$export$ee6c1fae9e22c684);
$parcel$export(module.exports, "CREATE_FIELD_SPOTLIGHT_ID", () => $90c48096f6d773df$export$29036d8d6f932a01);
$parcel$export(module.exports, "useOnboardingGetStartedTourActions", () => $90c48096f6d773df$export$65ae8844df2a9c08);
$parcel$export(module.exports, "useListViewOnboarding", () => $90c48096f6d773df$export$967b7a7235234c22);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $90c48096f6d773df$export$ee6c1fae9e22c684 = 'onboardingGetStartedListViewCreateChildButton';
const $90c48096f6d773df$export$29036d8d6f932a01 = 'onboardingGetStartedListViewCreateIssueFieldsButton';
const $90c48096f6d773df$var$defaultNonTourState = {
    projectId: null,
    isTourActive: false,
    isICCOpenByDefault: false,
    previousActiveSpotlight: null,
    currentActiveSpotlight: null
};
const $90c48096f6d773df$var$actions = {
    startTour: (projectId)=>({ setState: setState })=>setState({
                projectId: projectId,
                isTourActive: true,
                isICCOpenByDefault: true
            }),
    setActiveSpotlight: ({ projectId: projectId, spotlightId: spotlightId })=>({ setState: setState })=>{
            // Make sure to reset other state in case there was a tour that previosly started
            setState({
                ...$90c48096f6d773df$var$defaultNonTourState,
                projectId: projectId,
                currentActiveSpotlight: spotlightId
            });
        },
    dismissSpotlight: (spotlightId)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            // If not doing the tour then reset onboarding entirely
            if (!state.isTourActive) return setState($90c48096f6d773df$var$defaultNonTourState);
            // If last onboarding step for a tour, reset everything
            if (spotlightId === $90c48096f6d773df$export$29036d8d6f932a01) return setState($90c48096f6d773df$var$defaultNonTourState);
            return setState({
                previousActiveSpotlight: spotlightId,
                currentActiveSpotlight: null
            });
        },
    onIssueCreated: (projectId)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            if (projectId !== state.projectId || !state.isTourActive) return;
            if (state.previousActiveSpotlight === null) return setState({
                currentActiveSpotlight: $90c48096f6d773df$export$ee6c1fae9e22c684,
                isICCOpenByDefault: false
            });
            if (state.previousActiveSpotlight === $90c48096f6d773df$export$ee6c1fae9e22c684) return setState({
                currentActiveSpotlight: $90c48096f6d773df$export$29036d8d6f932a01
            });
        }
};
const $90c48096f6d773df$var$Store = (0, $iXqE5.createStore)({
    initialState: $90c48096f6d773df$var$defaultNonTourState,
    actions: $90c48096f6d773df$var$actions,
    name: 'GetStartedListViewTour'
});
const $90c48096f6d773df$export$65ae8844df2a9c08 = (0, $3sQ5x.createActionsHook)($90c48096f6d773df$var$Store);
const $90c48096f6d773df$export$291dba6650679451 = (0, $3sQ5x.createHook)($90c48096f6d773df$var$Store, {
    selector: (state, projectId)=>state.isICCOpenByDefault && state.projectId === projectId
});
const $90c48096f6d773df$export$967b7a7235234c22 = (0, $3sQ5x.createHook)($90c48096f6d773df$var$Store, {
    selector: (state, { projectId: projectId, id: id })=>state.currentActiveSpotlight === id && state.projectId === projectId
});

});

parcelRegister("lDRI0", function(module, exports) {

$parcel$export(module.exports, "shouldWrapTypeCellOnboardingSpotlight", () => $6b34fa4a91432925$export$ae9648e7a6869852);
$parcel$export(module.exports, "HierarchySpotlightWrapper", () => $6b34fa4a91432925$export$b5c7f9e8a7f1a6cc);
$parcel$export(module.exports, "FieldsSpotlightWrapper", () => $6b34fa4a91432925$export$97c588254ded10a);
$parcel$export(module.exports, "shouldWrapFieldsDropdownOnboardingSpotlight", () => $6b34fa4a91432925$export$3bc79d2296ff5e03);

var $5uXOq = parcelRequire("5uXOq");

var $5Fk4Z = parcelRequire("5Fk4Z");
var $1QiBP = parcelRequire("1QiBP");

var $hxoiH = parcelRequire("hxoiH");

var $daQYX = parcelRequire("daQYX");

var $lIj85 = parcelRequire("lIj85");

var $ktYbj = parcelRequire("ktYbj");

var $ibSNt = parcelRequire("ibSNt");

var $9UmVt = parcelRequire("9UmVt");

var $koVbs = parcelRequire("koVbs");

var $560mU = parcelRequire("560mU");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $ehdJY = parcelRequire("ehdJY");

var $jOXuX = parcelRequire("jOXuX");


var $9yQlD = parcelRequire("9yQlD");

var $4R6GH = parcelRequire("4R6GH");

var $aum1T = parcelRequire("aum1T");
const $6b34fa4a91432925$var$spotlightMessages = {
    [(0, $560mU.CREATE_CHILD_SPOTLIGHT_ID)]: {
        heading: (0, $aum1T.messages).createChildHeading,
        body: (0, $aum1T.messages).createChildBody,
        dismiss: (0, $aum1T.messages).dismiss
    },
    [(0, $560mU.CREATE_FIELD_SPOTLIGHT_ID)]: {
        heading: (0, $aum1T.messages).createFieldHeading,
        body: (0, $aum1T.messages).createFieldBody,
        dismiss: (0, $aum1T.messages).dismiss
    }
};
const $6b34fa4a91432925$var$spotlightImageUrls = {
    [(0, $560mU.CREATE_CHILD_SPOTLIGHT_ID)]: {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($9UmVt))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($ibSNt)))
    },
    [(0, $560mU.CREATE_FIELD_SPOTLIGHT_ID)]: {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($ktYbj))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($lIj85)))
    }
};
const $6b34fa4a91432925$var$useShouldShowListViewTour = ({ isSpotlightVisible: isSpotlightVisible })=>{
    const projectData = (0, $daQYX.useProject)();
    const projectId = projectData.id;
    const { startTour: startTour } = (0, $560mU.useOnboardingGetStartedTourActions)();
    (0, $5uXOq.useEffect)(()=>{
        if (!isSpotlightVisible && projectId && $6b34fa4a91432925$export$ae9648e7a6869852()) startTour(String(projectId));
    }, [
        isSpotlightVisible,
        projectId,
        startTour
    ]);
};
const $6b34fa4a91432925$export$e77e3591fa77f5ec = ({ renderTrigger: renderTrigger, spotlightId: spotlightId, onClickHandler: onClickHandler })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const projectData = (0, $daQYX.useProject)();
    const [isSpotlightVisible, actions] = (0, $560mU.useListViewOnboarding)({
        projectId: String(projectData.id),
        id: spotlightId
    });
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    (0, $5uXOq.useEffect)(()=>{
        if (isSpotlightVisible) (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'spotlight'
        }), spotlightId);
    }, [
        createAnalyticsEvent,
        isSpotlightVisible,
        spotlightId
    ]);
    $6b34fa4a91432925$var$useShouldShowListViewTour({
        isSpotlightVisible: isSpotlightVisible
    });
    const onClick = (_, analyticsEvent)=>{
        actions.dismissSpotlight(spotlightId);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, `${spotlightId}Dismiss`);
        onClickHandler && onClickHandler();
    };
    const { heading: heading, body: body, dismiss: dismiss } = $6b34fa4a91432925$var$spotlightMessages[spotlightId];
    const { dark: dark, light: light } = $6b34fa4a91432925$var$spotlightImageUrls[spotlightId];
    const imageUrl = colorMode === 'dark' ? dark : light;
    if (isSpotlightVisible) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: spotlightId
    }, renderTrigger(isSpotlightVisible)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1QiBP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
        image: imageUrl,
        actions: [
            {
                onClick: onClick,
                text: formatMessage(dismiss)
            }
        ],
        heading: formatMessage(heading),
        target: spotlightId,
        key: spotlightId,
        targetRadius: 3,
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        messageId: spotlightId,
        messageType: "transactional",
        dialogWidth: 275
    }, formatMessage(body))));
    return renderTrigger(isSpotlightVisible);
};
const $6b34fa4a91432925$export$b5c7f9e8a7f1a6cc = ({ renderTrigger: renderTrigger })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6b34fa4a91432925$export$e77e3591fa77f5ec, {
        spotlightId: (0, $560mU.CREATE_CHILD_SPOTLIGHT_ID),
        renderTrigger: renderTrigger,
        onClickHandler: ()=>{
            (0, $9yQlD.sessionStorageProvider).remove((0, $6784cbc7d62e5d7c$export$6973064a898f5989));
        }
    });
};
const $6b34fa4a91432925$export$97c588254ded10a = ({ renderTrigger: renderTrigger })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6b34fa4a91432925$export$e77e3591fa77f5ec, {
        spotlightId: (0, $560mU.CREATE_FIELD_SPOTLIGHT_ID),
        renderTrigger: renderTrigger,
        onClickHandler: ()=>{
            (0, $9yQlD.sessionStorageProvider).remove((0, $6784cbc7d62e5d7c$export$115fac1f1144bda1));
        }
    });
};
const $6b34fa4a91432925$export$ae9648e7a6869852 = ()=>{
    return ((0, $jOXuX.isTailoredOnboardingEnabled)() || (0, $4R6GH.fg)('tailored_onboarding_m2p5_gate')) && (0, $9yQlD.sessionStorageProvider).get((0, $6784cbc7d62e5d7c$export$6973064a898f5989)) === true;
};
const $6b34fa4a91432925$export$3bc79d2296ff5e03 = ()=>{
    return ((0, $jOXuX.isTailoredOnboardingEnabled)() || (0, $4R6GH.fg)('tailored_onboarding_m2p5_gate')) && (0, $9yQlD.sessionStorageProvider).get((0, $6784cbc7d62e5d7c$export$115fac1f1144bda1)) === true;
};

});
parcelRegister("lIj85", function(module, exports) {
module.exports = new URL("edit-ticket-with-background-dark.9447b0b7.svg", import.meta.url).toString();

});

parcelRegister("ktYbj", function(module, exports) {
module.exports = new URL("edit-ticket-with-background-light.78ada054.svg", import.meta.url).toString();

});

parcelRegister("ibSNt", function(module, exports) {
module.exports = new URL("hierarchy-tasks-with-background-dark.54880609.svg", import.meta.url).toString();

});

parcelRegister("9UmVt", function(module, exports) {
module.exports = new URL("hierarchy-tasks-with-background-light.7076b893.svg", import.meta.url).toString();

});

// Session storage constants used between going through initial onboarding screens
// and landing in JIRA
// Note this key used to be 'should-show-scrum-modal' but was changed to prevent a bug where experienced users
// Could see the modal if they were previously enrolled into ISO
const $6784cbc7d62e5d7c$export$67abe0a3b8dfe03f = 'should-show-scrum-modal-v2';
const $6784cbc7d62e5d7c$export$4e1360a3e7785935 = 'should-show-kanban-modal';
const $6784cbc7d62e5d7c$export$e3884212029f7bef = 'should-show-welcome-modal';
const $6784cbc7d62e5d7c$export$c45d2ea50af63a85 = 'showed-welcome-modal-during-signup';
const $6784cbc7d62e5d7c$export$c9dc4cb209930823 = 'can-enroll-in-config-wizard-view';
const $6784cbc7d62e5d7c$export$891ca65264b256bb = 'should-show-personlized-sample-data-for-kanban';
const $6784cbc7d62e5d7c$export$f47dca9dda77d157 = 'should-hide-quickstart-for-personalized-sample-data';
const $6784cbc7d62e5d7c$export$16588d2012f3f89b = 'should-show-business-sample-data-nudge';
const $6784cbc7d62e5d7c$export$928ffae10e4c0006 = 'template-key-to-show-onboarding-modal';
const $6784cbc7d62e5d7c$export$6e69f8dc03075ef8 = 'team-type';
const $6784cbc7d62e5d7c$export$c06666264cd35603 = 'team-type-shorthand';
const $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe = 'onboarding-selected-project-template-type';
const $6784cbc7d62e5d7c$export$6973064a898f5989 = 'should-show-list-view-type-cell-spotlight';
const $6784cbc7d62e5d7c$export$115fac1f1144bda1 = 'should-show-list-view-fields-dropdown-spotlight';
const $6784cbc7d62e5d7c$export$69fe8832c4f79a32 = 'onboarding_started_timestamp';
const $6784cbc7d62e5d7c$export$a8d62e500b59f31e = 'boardCreateColumnButtonNudge';
const $6784cbc7d62e5d7c$export$92c7f0eacc8d8d98 = 'assigneeFilterAddPeopleButtonNudge';
const $6784cbc7d62e5d7c$export$dd63d0099d95ba4f = 'navigationAppsNavItemNudge';
const $6784cbc7d62e5d7c$export$aba87e019f5ccb8d = 'navigationCreateIssueButtonNudge';
const $6784cbc7d62e5d7c$export$46d9a3d441dfd22b = 'navigationPlansNavItemNudge';
const $6784cbc7d62e5d7c$export$e20072f7d0c5357f = 'roadmapCreateEpicButtonNudge';
const $6784cbc7d62e5d7c$export$1e39959907a7f359 = 'roadmapCreateEpicChildIssueButtonNudge';
const $6784cbc7d62e5d7c$export$b74a8fdb2c75b869 = 'navigationPeopleNavItemNudge';
const $6784cbc7d62e5d7c$export$b1a6ab17737f33e = 'backlogAccordionNudge';
const $6784cbc7d62e5d7c$export$eb64d5f1a091478b = 'backlogCreateSprintIssueNudge';
const $6784cbc7d62e5d7c$export$64d75060ee6ba425 = 'backlogCreateIssueNudge';
const $6784cbc7d62e5d7c$export$3366ddefe77d5112 = 'boardCreateColumnNudge';
const $6784cbc7d62e5d7c$export$9d9e95a66a2c6abe = 'addItemsCalendarNudge';
const $6784cbc7d62e5d7c$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $6784cbc7d62e5d7c$export$7aa8bceae32c7862 = 'navigationAppsProfileItemNudge';
const $6784cbc7d62e5d7c$export$c6df9a2c7447e12d = 'getStartedListNudge';
const $6784cbc7d62e5d7c$export$468488291ccd988 = 'timelineAddItemNudge';
const $6784cbc7d62e5d7c$export$7a33548109ac931d = 'createFormNudge';
const $6784cbc7d62e5d7c$export$b65ba9ea0c0ced43 = 'jsw-onboarding-checklist.open';
const $6784cbc7d62e5d7c$export$3b5d230b66f60471 = 'jsw-onboarding-checklist.visibility';
const $6784cbc7d62e5d7c$export$594d3436316492be = 'summaryViewNudge';
const $6784cbc7d62e5d7c$export$f93b83d735f01fa3 = 'pagesCreatePageNudge';
const $6784cbc7d62e5d7c$export$77bc79debbf5c069 = 'inviteTeamNudge';
const $6784cbc7d62e5d7c$export$6ffa29e74c0304c4 = 'tailorBoardColumnsNudge';
const $6784cbc7d62e5d7c$export$699265ec8ad9a740 = 'Software Development';
const $6784cbc7d62e5d7c$export$e07d1fa2da8ed874 = 'Customer Service';
const $6784cbc7d62e5d7c$export$76dcec3f438d9e56 = 'IT Support';
const $6784cbc7d62e5d7c$export$9a574c301f67ba30 = 'Human Resources';
const $6784cbc7d62e5d7c$export$363ec144a94029c8 = 'Finance';
const $6784cbc7d62e5d7c$export$df0fb32d68ae1e78 = 'Legal';
const $6784cbc7d62e5d7c$export$d9c0e3e59442fb4 = 'Marketing';
const $6784cbc7d62e5d7c$export$27dbc7d7ce66e6e3 = 'Operations';
const $6784cbc7d62e5d7c$export$a5dce388adf922bd = 'Sales';
const $6784cbc7d62e5d7c$export$e1473b31a257caff = 'Data Science';
const $6784cbc7d62e5d7c$export$85657457db93c2c2 = 'Product Management';
const $6784cbc7d62e5d7c$export$c0c2d1dfaeba89dd = 'Project Management';
const $6784cbc7d62e5d7c$export$2e6a7ad3ab9c82a3 = 'Design';
const $6784cbc7d62e5d7c$export$7b60378c3b4372e9 = 'Other or Personal';
const $6784cbc7d62e5d7c$export$572242e58bd07594 = 'CS';
const $6784cbc7d62e5d7c$export$d7de553940261eba = 'ITS';
const $6784cbc7d62e5d7c$export$4c29d0d04c15e55d = 'HR';
const $6784cbc7d62e5d7c$export$3950f7f841bf94b6 = 'FNC';
const $6784cbc7d62e5d7c$export$881249b988b6030f = 'LGL';
const $6784cbc7d62e5d7c$export$e4824f74b9879164 = 'MKT';
const $6784cbc7d62e5d7c$export$4f3cb0844009af52 = 'OPS';
const $6784cbc7d62e5d7c$export$1a65d50c4a641bb4 = 'SAL';
const $6784cbc7d62e5d7c$export$9ee64e8fbd8b03a2 = 'DS';
const $6784cbc7d62e5d7c$export$b8b1ac856ba1434b = 'DEV';
const $6784cbc7d62e5d7c$export$4f54a09a24fd1d74 = 'PDM';
const $6784cbc7d62e5d7c$export$79685802e8ff1098 = 'PJM';
const $6784cbc7d62e5d7c$export$e5c438b7501b5a24 = 'DES';
const $6784cbc7d62e5d7c$export$cbc0e551d91a692d = 'OTR';

parcelRegister("aum1T", function(module, exports) {

$parcel$export(module.exports, "messages", () => $805758291b6be1d3$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $805758291b6be1d3$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    createChildHeading: {
        "id": "business-list.common.onboarding-spotlight-wrapper.create-child-heading",
        "defaultMessage": "Now break it down"
    },
    createChildBody: {
        "id": "business-list.common.onboarding-spotlight-wrapper.create-child-body",
        "defaultMessage": "Splitting the work into smaller tasks makes it easier to prioritize each one."
    },
    createFieldHeading: {
        "id": "business-list.common.onboarding-spotlight-wrapper.create-field-heading",
        "defaultMessage": "Add a new field"
    },
    createFieldBody: {
        "id": "business-list.common.onboarding-spotlight-wrapper.create-field-body",
        "defaultMessage": "Add as many fields as you require in order to capture the right information for each piece of work."
    },
    dismiss: {
        "id": "business-list.common.spotlight-wrapper.dismiss-non-final",
        "defaultMessage": "OK"
    }
});

});


parcelRegister("c82az", function(module, exports) {

$parcel$export(module.exports, "CREATE_ISSUE_MUTATION", () => $eb757ea22cfcb9ef$export$f5c1cac020b22be4);
$parcel$export(module.exports, "ISSUE_REFETCH_QUERY", () => $eb757ea22cfcb9ef$export$834c81726d4c51eb);

var $5cllN = parcelRequire("5cllN");

var $1jIw5 = parcelRequire("1jIw5");

var $hgp1u = parcelRequire("hgp1u");

var $kkA5E = parcelRequire("kkA5E");

var $61h55 = parcelRequire("61h55");
const $eb757ea22cfcb9ef$var$CREATED_ITEM_FRAGMENT = (0, $5cllN.default)`
fragment CreatedListItemFragment on JiraWorkManagementViewItem {
    id
    issueId
    childSummary {
        hasChildren
        totalCount
    }
    commentSummary {
        totalCount
        # Temporary field for Unread Comments in List View experiment
        # Clean up in https://hello.jira.atlassian.cloud/browse/WAR-1557
        hasUnreadComment @include(if: $isUnreadCommentsEnabled)
    }
    legacyConfluenceLinks(getFirstOnly: true) {
        ...ConfluenceLinksFragment
    }
    devSummaryCache @include(if: $isDevSummaryFieldVisible)  {
        ...DevSummaryFieldFragment
    }
    ...ListViewIssueFieldsFragment
}
${(0, $61h55.LIST_VIEW_FIELDS_FRAGMENT)}
${(0, $1jIw5.CONFLUENCE_LINKS_FRAGMENT)}
${(0, $hgp1u.JIRA_BUSINESS_TOP_LEVEL_FIELD_FRAGMENT)}
`;
const $eb757ea22cfcb9ef$export$f5c1cac020b22be4 = (0, $5cllN.default)`

mutation JWMListInlineCreateIssue ($input: JiraCreateIssueInput!, $fieldIds: [String]!, $isParentFieldVisible: Boolean!, $isDevSummaryFieldVisible: Boolean!, $includeIsVerifiedInTeamFragment: Boolean!, $isUnreadCommentsEnabled: Boolean = false) {
    createJiraBusinessIssue(input: $input, fieldIdsToReturn: $fieldIds) {
        item {
            ...CreatedListItemFragment
        }
        ...CreateIssueFragment
    }
}
${(0, $kkA5E.CREATE_ISSUE_FRAGMENT)}
${$eb757ea22cfcb9ef$var$CREATED_ITEM_FRAGMENT}
`;
const $eb757ea22cfcb9ef$export$834c81726d4c51eb = (0, $5cllN.default)`
query JWMListInlineCreateRefetchQuery($cloudId: ID!, $jql: String!, $fieldIds: [String]!, $first: Int, $isParentFieldVisible: Boolean!, $isDevSummaryFieldVisible: Boolean!, $includeIsVerifiedInTeamFragment: Boolean!, $isUnreadCommentsEnabled: Boolean = false) {
    jira {
        jwmViewItems(cloudId: $cloudId, jql: $jql, first: $first) {
            ... on JiraWorkManagementViewItemConnection {
                edges {
                    node {
                        ...CreatedListItemFragment
                    }
                }
            }
        }
    }
}
${$eb757ea22cfcb9ef$var$CREATED_ITEM_FRAGMENT}
`;

});
parcelRegister("1jIw5", function(module, exports) {

$parcel$export(module.exports, "CONFLUENCE_LINKS_FRAGMENT", () => $163c64757226ab14$export$757a6323be066698);

var $5cllN = parcelRequire("5cllN");
const $163c64757226ab14$export$757a6323be066698 = (0, $5cllN.default)`
    fragment ConfluenceLinksFragment on ConfluenceLinks {    
            linkedConfluencePages {
                pageCount
                pages {
                    ... on ConfluencePage {
                        id
                        globalId
                        href
                        title
                        type
                        lastUpdatedContext {
                            user {
                                key
                                accountId
                                emailAddress
                                avatarUrl
                                displayName
                                active
                            }
                        }
                    }
                    ... on FailedRemoteLink {
                        id
                        error
                        link {
                            id
                            globalId
                            href
                        }
                        repairLink {
                            href
                        }
                    }
                }
            }
    }
`;

});

parcelRegister("hgp1u", function(module, exports) {

$parcel$export(module.exports, "JIRA_BUSINESS_FIELDS_FRAGMENT", () => $7e186b77adb3d312$export$16a4e56fe7b29670);
$parcel$export(module.exports, "JIRA_BUSINESS_TOP_LEVEL_FIELD_FRAGMENT", () => $7e186b77adb3d312$export$8a6df2ce60bca6f1);
// eslint-disable-next-line jira/restricted/graphql-tag

var $5cllN = parcelRequire("5cllN");

var $PEXLp = parcelRequire("PEXLp");

var $NP5lF = parcelRequire("NP5lF");

var $iGMM4 = parcelRequire("iGMM4");

var $lwUNo = parcelRequire("lwUNo");

var $8zsae = parcelRequire("8zsae");

var $j7Iys = parcelRequire("j7Iys");

var $1pAp2 = parcelRequire("1pAp2");

var $3GIY9 = parcelRequire("3GIY9");

var $28LQn = parcelRequire("28LQn");

var $ggiU6 = parcelRequire("ggiU6");

var $ieCa3 = parcelRequire("ieCa3");

var $8FrR1 = parcelRequire("8FrR1");

var $6VSLz = parcelRequire("6VSLz");

var $cO6xZ = parcelRequire("cO6xZ");

var $jXXlm = parcelRequire("jXXlm");

var $baFng = parcelRequire("baFng");

var $iNcfS = parcelRequire("iNcfS");

var $9YcjN = parcelRequire("9YcjN");

var $2ix3d = parcelRequire("2ix3d");

var $exG5v = parcelRequire("exG5v");

var $3f4qN = parcelRequire("3f4qN");
const $7e186b77adb3d312$export$16a4e56fe7b29670 = (0, $5cllN.default)`
	${(0, $ggiU6.PARENT_FRAGMENT)}
	${(0, $3f4qN.VERSION_FRAGMENT)}
	${(0, $iNcfS.TEAM_FRAGMENT)}
	${(0, $8zsae.GOALS_FRAGMENT)}
	${(0, $cO6xZ.RESOLUTION_FRAGMENT)}
	${(0, $j7Iys.GROUP_FRAGMENT)}
	${(0, $1pAp2.LABELS_FRAGMENT)}
	${(0, $NP5lF.DATE_FRAGMENT)}
	${(0, $iGMM4.DATE_TIME_FRAGMENT)}
	${(0, $exG5v.ATLASSIAN_ACCOUNT_FRAGMENT)}
	${(0, $exG5v.USER_FRAGMENT)}
	${(0, $exG5v.PEOPLE_FRAGMENT)}
	${(0, $exG5v.MULTIPLE_USER_FRAGMENT)}
	${(0, $ieCa3.PRIORITY_FRAGMENT)}
	${(0, $3GIY9.MULTIPLE_SELECT_FRAGMENT)}
	${(0, $28LQn.NUMBER_FRAGMENT)}
	${(0, $6VSLz.RADIO_SELECT_FRAGMENT)}
	${(0, $jXXlm.SINGLE_SELECT_FRAGMENT)}
	${(0, $2ix3d.URL_FRAGMENT)}
	${(0, $9YcjN.SINGLE_LINE_TEXT_FRAGMENT)}
	${(0, $baFng.STATUS_CATEGORY_FRAGMENT)}
	${(0, $PEXLp.CASCADING_SELECT_FRAGMENT)}
	${(0, $8FrR1.PROJECT_FRAGMENT)}
`;
const $7e186b77adb3d312$export$8a6df2ce60bca6f1 = (0, $5cllN.default)`
	${(0, $lwUNo.DEV_SUMMARY_FRAGMENT)}
`;

});
parcelRegister("PEXLp", function(module, exports) {

$parcel$export(module.exports, "CASCADING_SELECT_FRAGMENT", () => $ebed62ab0f3bd519$export$88d11aac85f3a5f2);

var $5cllN = parcelRequire("5cllN");
const $ebed62ab0f3bd519$export$88d11aac85f3a5f2 = (0, $5cllN.default)`
    fragment jiraCascadingSelectFieldFragment on JiraCascadingSelectField {
        id
        fieldId
        fieldConfig {
            isEditable
        }
        cascadingOption {
            parentValue {
                id
                isDisabled
                value
            }
            childOptionValue {
                id
                optionId
                isDisabled
                value
            }
        }
    } 
`;

});

parcelRegister("NP5lF", function(module, exports) {

$parcel$export(module.exports, "DATE_FRAGMENT", () => $68f33dc7015a2fed$export$f8e1b8104aa9273f);

var $5cllN = parcelRequire("5cllN");
const $68f33dc7015a2fed$export$f8e1b8104aa9273f = (0, $5cllN.default)`
    fragment jiraDateFieldFragment on JiraDatePickerField {
        date
    } 
`;

});

parcelRegister("iGMM4", function(module, exports) {

$parcel$export(module.exports, "DATE_TIME_FRAGMENT", () => $163b86e1c4c674a9$export$f5c7c2e5cce27d00);

var $5cllN = parcelRequire("5cllN");
const $163b86e1c4c674a9$export$f5c7c2e5cce27d00 = (0, $5cllN.default)`
    fragment jiraDateTimeFieldFragment on JiraDateTimePickerField {
        dateTime
    } 
`;

});

parcelRegister("lwUNo", function(module, exports) {

$parcel$export(module.exports, "DEV_SUMMARY_FRAGMENT", () => $b217a628105095f2$export$a5751f0d2763fac3);

var $5cllN = parcelRequire("5cllN");
const $b217a628105095f2$export$a5751f0d2763fac3 = (0, $5cllN.default)`
    fragment DevSummaryFieldFragment on JiraIssueDevSummaryResult {
        devSummary {
            commit {
                overall {
                    count
                }
            }
            pullrequest {
                overall {
                    state
                    count
                }
            }
        }
    } 
`;

});

parcelRegister("8zsae", function(module, exports) {

$parcel$export(module.exports, "GOALS_FRAGMENT", () => $d95223f07223b855$export$14859f852d0eecb4);

var $5cllN = parcelRequire("5cllN");
const $d95223f07223b855$export$14859f852d0eecb4 = (0, $5cllN.default)`
    fragment JiraGoalsFieldFragment on JiraGoalsField {
        __typename
        fieldId
        name
        fieldConfig {
            isEditable
        }
        selectedGoals(first: 1) {
            totalCount,
            edges {
                node {
                    id
                    name
                    status
                }
            }
        }
    }
`;

});

parcelRegister("j7Iys", function(module, exports) {

$parcel$export(module.exports, "GROUP_FRAGMENT", () => $de6f0431613b8dd7$export$91c2ad2e63414b50);
// eslint-disable-next-line jira/restricted/graphql-tag

var $5cllN = parcelRequire("5cllN");
// needed for namespacing
const $de6f0431613b8dd7$var$gqlTagGira = (0, $5cllN.default);
const $de6f0431613b8dd7$export$99b0877e6d0a4712 = $de6f0431613b8dd7$var$gqlTagGira`
	fragment jiraBusinessSingleGroupFieldFragment on JiraSingleGroupPickerField {
		__typename
		id
		fieldId
		name
		selectedGroup {
			id
			groupId
			name
		}
	}
`;
const $de6f0431613b8dd7$export$27846949a41c873f = $de6f0431613b8dd7$var$gqlTagGira`
	fragment jiraBusinessMultipleGroupFieldFragment on JiraMultipleGroupPickerField {
		__typename
		id
		fieldId
		name
		selectedGroupsConnection {
			edges {
				node {
					id
					groupId
					name
				}
			}
		}
	}
`;
const $de6f0431613b8dd7$export$91c2ad2e63414b50 = (0, $5cllN.default)`
	${$de6f0431613b8dd7$export$27846949a41c873f}
	${$de6f0431613b8dd7$export$99b0877e6d0a4712}
`;

});

parcelRegister("1pAp2", function(module, exports) {

$parcel$export(module.exports, "LABELS_FRAGMENT", () => $4df5b87c30bf16eb$export$30f9416168d64de4);

var $5cllN = parcelRequire("5cllN");
const $4df5b87c30bf16eb$export$30f9416168d64de4 = (0, $5cllN.default)`
    fragment jiraLabelsFieldFragment on JiraLabelsField {
        selectedLabelsConnection {
            edges {
                node {
                    name
                }
            }
        }
    } 
`;

});

parcelRegister("3GIY9", function(module, exports) {

$parcel$export(module.exports, "MULTIPLE_SELECT_FRAGMENT", () => $2f0a11646cf2cfca$export$ed658c6a0e11bdf9);

var $5cllN = parcelRequire("5cllN");
const $2f0a11646cf2cfca$export$ed658c6a0e11bdf9 = (0, $5cllN.default)`
    fragment jiraMultipleSelectFieldFragment on JiraMultipleSelectField {
        fieldConfig {
            isEditable
          }
        selectedOptions {
            edges {
                node {
                    optionId
                    value
                }
            }
        }
    }
`;

});

parcelRegister("28LQn", function(module, exports) {

$parcel$export(module.exports, "NUMBER_FRAGMENT", () => $c04add054a4eac3a$export$c1b90ff48aa1e878);

var $5cllN = parcelRequire("5cllN");
const $c04add054a4eac3a$export$c1b90ff48aa1e878 = (0, $5cllN.default)`
    fragment jiraNumberFieldFragment on JiraNumberField {
        number
        fieldConfig {
          isEditable
        }
    }
`;

});

parcelRegister("ggiU6", function(module, exports) {

$parcel$export(module.exports, "PARENT_FRAGMENT", () => $3b4f564338c94723$export$1efcd2a93f28f76e);

var $5cllN = parcelRequire("5cllN");
const $3b4f564338c94723$export$1efcd2a93f28f76e = (0, $5cllN.default)`
    fragment jiraBusinessParentFieldFragment on JiraParentIssueField {
        fieldId
        parentIssue {
            id
            issueId
            key
            rankField: fieldsByIdOrAlias(idsOrAliases: ["rank"], ignoreMissingFields: true) @connection (key: "parentRankField") {
                aliasFieldId
                ... on JiraSingleLineTextField {
                    text
                }
            }
            fields: fieldsByIdOrAlias(idsOrAliases: ["summary", "issuetype", "issuecolor", "status"], ignoreMissingFields: true) @connection (key: "parentFields") @include(if: $isParentFieldVisible) {
                fieldId
                name
                aliasFieldId
                type
                ... on JiraColorField {
                    color {
                        colorKey
                    }
                }
                ... on JiraSingleLineTextField {
                    text
                }
                ... on JiraStatusField {
                    status {
                        name
                        statusCategory {
                            statusCategoryId
                        }
                    }
                }
                ... on JiraIssueTypeField {
                    issueType {
                        name
                        avatar {
                            medium
                        }
                    }
                }
            }
        }
    }
`;

});

parcelRegister("ieCa3", function(module, exports) {

$parcel$export(module.exports, "PRIORITY_FRAGMENT", () => $6c55e56b9f67ebd2$export$6d5f71aa3bbf9a14);

var $5cllN = parcelRequire("5cllN");
const $6c55e56b9f67ebd2$export$6d5f71aa3bbf9a14 = (0, $5cllN.default)`
    fragment jiraPriorityFieldFragment on JiraPriorityField {
        priority {
            id
            name
            priorityId
            iconUrl
        }
    }
`;

});

parcelRegister("8FrR1", function(module, exports) {

$parcel$export(module.exports, "PROJECT_FRAGMENT", () => $9a8182c208e3906d$export$e365122194197244);

var $5cllN = parcelRequire("5cllN");
const $9a8182c208e3906d$export$e365122194197244 = (0, $5cllN.default)`
    fragment jiraProjectFieldFragment on JiraProjectField {
        fieldId
        name
        project {
            id
            projectId
            name
            key
            avatar {
                large
            }
        }
    }
`;

});

parcelRegister("6VSLz", function(module, exports) {

$parcel$export(module.exports, "RADIO_SELECT_FRAGMENT", () => $1385b530ca3edd64$export$55296ac87efdd2c2);

var $5cllN = parcelRequire("5cllN");
const $1385b530ca3edd64$export$55296ac87efdd2c2 = (0, $5cllN.default)`
    fragment jiraRadioSelectFieldFragment on JiraRadioSelectField {
        id
        fieldId
        name
        fieldConfig {
            isEditable
        }
        selectedOption {
            optionId
            value
        }
    }
`;

});

parcelRegister("cO6xZ", function(module, exports) {

$parcel$export(module.exports, "RESOLUTION_FRAGMENT", () => $27a75f6f548a47f6$export$e8f52599fbfc8f74);

var $5cllN = parcelRequire("5cllN");
const $27a75f6f548a47f6$export$e8f52599fbfc8f74 = (0, $5cllN.default)`
    fragment jiraBusinessResolutionFieldFragment on JiraResolutionField {
        fieldId
        name
        resolution {
            id
            name
        }
    } 
`;

});

parcelRegister("jXXlm", function(module, exports) {

$parcel$export(module.exports, "SINGLE_SELECT_FRAGMENT", () => $74a33283ae84d68d$export$f1c5cfc4b5de6700);

var $5cllN = parcelRequire("5cllN");
const $74a33283ae84d68d$export$f1c5cfc4b5de6700 = (0, $5cllN.default)`
    fragment jiraSingleSelectFragment on JiraSingleSelectField {
        fieldConfig {
            isEditable
        }
        fieldOption {
            optionId
            value
            color {
                colorKey
            }
        }
    }
`;

});

parcelRegister("baFng", function(module, exports) {

$parcel$export(module.exports, "STATUS_CATEGORY_FRAGMENT", () => $a0882d2c1a43f19a$export$a125a2d730e3d413);

var $5cllN = parcelRequire("5cllN");
const $a0882d2c1a43f19a$export$a125a2d730e3d413 = (0, $5cllN.default)`
    fragment jiraStatusCategoryFragment on JiraStatusCategoryField {
        fieldId
        fieldConfig {
          isEditable
        }
        statusCategory {
          id
          statusCategoryId
          name
        }
    }
`;

});

parcelRegister("iNcfS", function(module, exports) {

$parcel$export(module.exports, "TEAM_FRAGMENT", () => $7c31d1d554d693ca$export$b8a1e15b67d0c801);

var $5cllN = parcelRequire("5cllN");
const $7c31d1d554d693ca$export$b8a1e15b67d0c801 = (0, $5cllN.default)`
    fragment jiraBusinessTeamFieldFragment on JiraTeamViewField {
        fieldId
        selectedTeam {
            jiraSuppliedName
            jiraSuppliedTeamId
            jiraSuppliedIsVerified @include(if: $includeIsVerifiedInTeamFragment)
        }
    } 
`;

});

parcelRegister("9YcjN", function(module, exports) {

$parcel$export(module.exports, "SINGLE_LINE_TEXT_FRAGMENT", () => $f1f674f06c8943a4$export$23113309bffe00ca);

var $5cllN = parcelRequire("5cllN");
const $f1f674f06c8943a4$export$23113309bffe00ca = (0, $5cllN.default)`
    fragment jiraSingleLineTextFragment on JiraSingleLineTextField {
        text
    }
`;

});

parcelRegister("2ix3d", function(module, exports) {

$parcel$export(module.exports, "URL_FRAGMENT", () => $9063163b69045994$export$7044ea8d89b6f59d);

var $5cllN = parcelRequire("5cllN");
const $9063163b69045994$export$7044ea8d89b6f59d = (0, $5cllN.default)`
    fragment jiraUrlFieldFragment on JiraUrlField {
        uri
        fieldConfig {
          isEditable
        }
    }
`;

});

parcelRegister("exG5v", function(module, exports) {

$parcel$export(module.exports, "ATLASSIAN_ACCOUNT_FRAGMENT", () => $5c6c513b05f48580$export$7620e2c63d440c49);
$parcel$export(module.exports, "USER_FRAGMENT", () => $5c6c513b05f48580$export$6496fa362c67d06e);
$parcel$export(module.exports, "PEOPLE_FRAGMENT", () => $5c6c513b05f48580$export$49438f3cf8087021);
$parcel$export(module.exports, "MULTIPLE_USER_FRAGMENT", () => $5c6c513b05f48580$export$5267cb871f0541c9);

var $5cllN = parcelRequire("5cllN");
const $5c6c513b05f48580$export$7620e2c63d440c49 = (0, $5cllN.default)`
  fragment AtlassianAccountFragment on AtlassianAccountUser {
    accountId
    accountStatus
    picture
    name
  }
`;
const $5c6c513b05f48580$export$6496fa362c67d06e = (0, $5cllN.default)`
    fragment jiraSingleUserFieldFragment on JiraSingleSelectUserPickerField {
        user {
            ...AtlassianAccountFragment
        }
        fieldConfig {
            isEditable
        }
    }
`;
const $5c6c513b05f48580$export$49438f3cf8087021 = (0, $5cllN.default)`
    fragment jiraPeopleFieldFragment on JiraPeopleField {
        fieldConfig {
          isEditable
        }
        selectedUsersConnection {
          edges {
            node {
              ...AtlassianAccountFragment
            }
          }
        }
    }
`;
const $5c6c513b05f48580$export$5267cb871f0541c9 = (0, $5cllN.default)`
    fragment jiraMultipleUserFieldFragment on JiraMultipleSelectUserPickerField {
        selectedUsersConnection {
          edges {
            node {
              ...AtlassianAccountFragment
            }
          }
        }
        fieldConfig {
          isEditable
        }
    }
`;

});

parcelRegister("3f4qN", function(module, exports) {

$parcel$export(module.exports, "VERSION_FRAGMENT", () => $e03bc7b37dba3728$export$6f6bf5d27acb96a6);
// eslint-disable-next-line jira/restricted/graphql-tag

var $5cllN = parcelRequire("5cllN");
// needed for namespacing
const $e03bc7b37dba3728$var$gqlTagGira = (0, $5cllN.default);
const $e03bc7b37dba3728$export$4320515340a845c0 = $e03bc7b37dba3728$var$gqlTagGira`
    fragment jiraBusinessSingleVersionFieldFragment on JiraSingleVersionPickerField {
      __typename
      id
      fieldId
      name
      version {
        versionId
        name
      }
    }
`;
const $e03bc7b37dba3728$export$b336fe1ccb7b1f67 = $e03bc7b37dba3728$var$gqlTagGira`
    fragment jiraBusinessMultipleVersionFieldFragment on JiraMultipleVersionPickerField {
      __typename
      id
      fieldId
      name
      selectedVersionsConnection {
        edges {
          node {
            versionId
            name
          }
        }
      }
    }
`;
const $e03bc7b37dba3728$export$6f6bf5d27acb96a6 = (0, $5cllN.default)`
	${$e03bc7b37dba3728$export$b336fe1ccb7b1f67}
	${$e03bc7b37dba3728$export$4320515340a845c0}
`;

});


parcelRegister("kkA5E", function(module, exports) {

$parcel$export(module.exports, "CREATE_ISSUE_FRAGMENT", () => $22484cc131c517f0$export$47232071d0e9dfb);

var $5cllN = parcelRequire("5cllN");
const $22484cc131c517f0$export$47232071d0e9dfb = (0, $5cllN.default)`
fragment CreateIssueFragment on JiraBusinessCreateIssuePayload {
  itemIdentifiers: item @connection (key: "issue-create-ids") {
    issueId
    issueKey: fieldsByIdOrAlias(idsOrAliases: ["issuekey"]) {
      ... on JiraSingleLineTextField {
          text
      }
    }
  }
  success
  errors {
    message
    extensions {
      ...on MutationErrorExtension {
        statusCode
        errorType
      }
    }
  }
}`;

});

parcelRegister("61h55", function(module, exports) {

$parcel$export(module.exports, "LIST_VIEW_FIELDS_FRAGMENT", () => $165c1ba5d9304c2b$export$878eea3ba159096b);
$parcel$export(module.exports, "LIST_VIEW_QUERY", () => $165c1ba5d9304c2b$export$bf9c5668f03a036d);
$parcel$export(module.exports, "BACKGROUND_LIST_VIEW_QUERY", () => $165c1ba5d9304c2b$export$b0ac16e8fe90de24);
$parcel$export(module.exports, "LIST_VIEW_ITEM_DETAILS_QUERY", () => $165c1ba5d9304c2b$export$3f338783432a1617);

var $5cllN = parcelRequire("5cllN");

var $1jIw5 = parcelRequire("1jIw5");

var $hgp1u = parcelRequire("hgp1u");
const $165c1ba5d9304c2b$export$878eea3ba159096b = (0, $5cllN.default)`
  fragment ListViewIssueFieldsFragment on JiraWorkManagementViewItem {
    fields: fieldsByIdOrAlias(idsOrAliases: $fieldIds, ignoreMissingFields: true) @connection (key: "fields") {
      fieldId
      name
      aliasFieldId
      type
      ... on JiraIssueTypeField {
        issueType {
          issueTypeId
          name
          avatar {
            medium
          }
          hierarchy {
            level
          }
        }
      }
      ... on JiraStatusField {
        status {
          name
          statusId
          statusCategory {
            statusCategoryId
          }
        }
      }
      ... on JiraRichTextField {
        richText {
          adfValue {
            json
            convertedPlainText {
              plainText
              isTruncated
            }
          }
        }
        renderer
      }
      ... on JiraOriginalTimeEstimateField {
        originalEstimate {
          timeInSeconds
        }
        fieldConfig {
          isEditable
        }
      }
      ... on JiraTimeTrackingField {
        originalEstimate {
          timeInSeconds
        }
        timeTrackingSettings {
          defaultUnit
          defaultFormat
          workingHoursPerDay
          workingDaysPerWeek
        }
      }
      ... on JiraComponentsField {
        fieldConfig {
          isEditable
        }
        selectedComponentsConnection {
          edges {
            node {
              name
              componentId
            }
          }
        }
      }
      ... on JiraParentIssueField {
        parentIssue {
          issueId
          key
        }
      }
     ... on JiraCheckboxesField {
        selectedOptions {
          edges {
            node {
              optionId
              value
            }
          }
        }
      }
      ... on JiraSprintField {
        fieldId
        aliasFieldId
        fieldConfig {
          isEditable
        }
        selectedSprintsConnection(first: 1) {
          edges {
            node {
              sprintId
              name
              state
            }
          }
        }
      }
      ...jiraBusinessSingleVersionFieldFragment
      ...jiraBusinessMultipleVersionFieldFragment
      ...jiraBusinessParentFieldFragment
      ...jiraBusinessTeamFieldFragment
      ...JiraGoalsFieldFragment
      ...jiraBusinessResolutionFieldFragment
      ...jiraBusinessSingleGroupFieldFragment
      ...jiraBusinessMultipleGroupFieldFragment
      ...jiraLabelsFieldFragment
      ...jiraDateFieldFragment
      ...jiraDateTimeFieldFragment
      ...jiraSingleUserFieldFragment
      ...jiraMultipleUserFieldFragment
      ...jiraPeopleFieldFragment
      ...jiraPriorityFieldFragment
      ...jiraMultipleSelectFieldFragment
      ...jiraNumberFieldFragment
      ...jiraRadioSelectFieldFragment
      ...jiraSingleSelectFragment
      ...jiraUrlFieldFragment
      ...jiraSingleLineTextFragment
      ...jiraStatusCategoryFragment
      ...jiraCascadingSelectFieldFragment
      ...jiraProjectFieldFragment
    }
  }

  ${(0, $hgp1u.JIRA_BUSINESS_FIELDS_FRAGMENT)}
`;
const $165c1ba5d9304c2b$export$5f151982dc1bb93c = (0, $5cllN.default)`
  fragment ListViewItemEdges on JiraWorkManagementViewItemConnection {
    edges {
      node {
        id
        issueId
        childSummary(includeDone: $includeDoneItems) {
            hasChildren
            totalCount
        }
        commentSummary {
            totalCount
            # Temporary field for Unread Comments in List view experiment
            # Clean up in https://hello.jira.atlassian.cloud/browse/WAR-1557
            hasUnreadComment @include(if: $isUnreadCommentsEnabled)
        }
        legacyConfluenceLinks(getFirstOnly: true) @include(if: $withConfluenceLinks) @connection(key: "legacyConfluenceLinks") {
            ...ConfluenceLinksFragment
        }
        devSummaryCache @include(if: $isDevSummaryFieldVisible)  {
          ...DevSummaryFieldFragment
        }
        ...ListViewIssueFieldsFragment
      }
    }
  }
  ${$165c1ba5d9304c2b$export$878eea3ba159096b}
  ${(0, $1jIw5.CONFLUENCE_LINKS_FRAGMENT)}
  ${(0, $hgp1u.JIRA_BUSINESS_TOP_LEVEL_FIELD_FRAGMENT)}
`;
const $165c1ba5d9304c2b$export$bf9c5668f03a036d = (0, $5cllN.default)`
  query JWMListViewItems($cloudId: ID!, $jql: String!, $includeDoneItems: Boolean!, $fieldIds: [String]!, $first: Int, $after: String, $withConfluenceLinks: Boolean!, $isParentFieldVisible: Boolean!, $isDevSummaryFieldVisible: Boolean!, $includeIsVerifiedInTeamFragment: Boolean!, $isUnreadCommentsEnabled: Boolean = false) {
    jira {
      list: jwmViewItems(
        cloudId: $cloudId,
        jql: $jql,
        first: $first,
        after: $after,
      ) @connection (key: "list", filter:["jql"]) {
        ...on QueryError {
          message
          extensions {
            statusCode
            errorType
          }
        }
        ... on JiraWorkManagementViewItemConnection {
          ...ListViewItemEdges
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }
    }
  }

  ${$165c1ba5d9304c2b$export$5f151982dc1bb93c}
`;
const $165c1ba5d9304c2b$export$b0ac16e8fe90de24 = (0, $5cllN.default)`
  query JWMListViewItemsBackground($cloudId: ID!, $jql: String!, $includeDoneItems: Boolean!, $fieldIds: [String]!, $first: Int, $after: String, $withConfluenceLinks: Boolean!, $isParentFieldVisible: Boolean!, $isDevSummaryFieldVisible: Boolean!, $includeIsVerifiedInTeamFragment: Boolean!, $isUnreadCommentsEnabled: Boolean = false) {
    jira {
      list: jwmViewItems(
        cloudId: $cloudId,
        jql: $jql,
        first: $first,
        after: $after,
      ) @connection (key: "backgroundList", filter:["jql"]) {
        ... on JiraWorkManagementViewItemConnection {
          ...ListViewItemEdges
          totalCount
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }
    }
  }

  ${$165c1ba5d9304c2b$export$5f151982dc1bb93c}
`;
const $165c1ba5d9304c2b$export$3f338783432a1617 = (0, $5cllN.default)`
  query JWMListViewItemDetails($cloudId: ID!, $jql: String!, $includeDoneItems: Boolean!, $fieldIds: [String]!, $first: Int, $after: String, $withConfluenceLinks: Boolean!, $isParentFieldVisible: Boolean!, $isDevSummaryFieldVisible: Boolean!, $includeIsVerifiedInTeamFragment: Boolean!, $isUnreadCommentsEnabled: Boolean = false) {
    jira {
      list: jwmViewItems(
        cloudId: $cloudId,
        jql: $jql,
        first: $first,
        after: $after,
      ) {
        ... on JiraWorkManagementViewItemConnection {
          ...ListViewItemEdges
        }
      }
    }
  }

  ${$165c1ba5d9304c2b$export$5f151982dc1bb93c}
`;

});


parcelRegister("2F7tZ", function(module, exports) {

$parcel$export(module.exports, "buildInput", () => $fffa8e113b0d87a3$export$f4db126e014728a3);

var $5fc53 = parcelRequire("5fc53");

var $4kK95 = parcelRequire("4kK95");

var $6s1PB = parcelRequire("6s1PB");

var $jkrrf = parcelRequire("jkrrf");
const $fffa8e113b0d87a3$var$RANK_BEFORE_ID = 'rankBefore';
const $fffa8e113b0d87a3$var$RANK_AFTER_ID = 'rankAfter';
const $fffa8e113b0d87a3$export$f4db126e014728a3 = (input, extraPayload, categoryField, sprintField, storyPointEstimateField, storyPointsField)=>{
    const singleLineTextFields = [
        {
            fieldId: (0, $5fc53.SUMMARY_TYPE),
            text: input.summary
        }
    ];
    const singleSelectUserPickerFields = [];
    const numberFields = [];
    const datePickerFields = [];
    if (input.category && categoryField?.id) singleLineTextFields.push({
        // @ts-expect-error - Type 'string' is not assignable to type '"summary"'.
        fieldId: categoryField.id,
        text: input.category.optionId
    });
    if (input.assignee) singleSelectUserPickerFields.push({
        fieldId: (0, $5fc53.ASSIGNEE_TYPE),
        user: {
            accountId: input.assignee.accountId
        }
    });
    if (input.dueDate) datePickerFields.push({
        fieldId: (0, $5fc53.DUE_DATE_TYPE),
        date: {
            formattedDate: (0, $4kK95.DateOnly).fromDateAccordingToLocalTime(input.dueDate).toISOString()
        }
    });
    if (input.storyPointEstimate != null && storyPointEstimateField?.id) numberFields.push({
        fieldId: storyPointEstimateField.id,
        value: input.storyPointEstimate
    });
    if (input.storyPoints != null && storyPointsField?.id) numberFields.push({
        fieldId: storyPointsField.id,
        value: input.storyPoints
    });
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jira_powerful_inline_create_in_list_view');
    const isPICInListViewExperimentEnabled = expConfig.get('isEnabled', false);
    (0, $jkrrf.fireExposureForPowerfulInlineCreateAATest)();
    const fields = {
        singleLineTextFields: singleLineTextFields,
        singleSelectUserPickerFields: singleSelectUserPickerFields,
        ...isPICInListViewExperimentEnabled ? {
            datePickerFields: datePickerFields
        } : {},
        numberFields: numberFields,
        ...input.sprint && sprintField?.id && {
            sprintsField: {
                fieldId: sprintField.id,
                sprints: [
                    {
                        sprintId: input.sprint.id
                    }
                ]
            }
        },
        ...input.priority && {
            priority: {
                priorityId: input.priority.priorityId
            }
        },
        ...input.parentIssueId && {
            parentField: {
                issueId: input.parentIssueId
            }
        }
    };
    const rank = {
        ...input.rankBefore && {
            before: {
                id: $fffa8e113b0d87a3$var$RANK_BEFORE_ID,
                issueId: input.rankBefore.issueId
            }
        },
        ...input.rankAfter && {
            after: {
                id: $fffa8e113b0d87a3$var$RANK_AFTER_ID,
                issueId: input.rankAfter.issueId
            }
        }
    };
    const result = {
        projectId: input.projectId,
        issueType: input.issueType.id,
        fields: fields,
        rank: rank,
        ...extraPayload?.transitionId && {
            transitionId: extraPayload.transitionId
        }
    };
    return result;
};

});
parcelRegister("4kK95", function(module, exports) {

$parcel$export(module.exports, "DateOnly", () => $a1048e23edd181e2$export$988b361b394263b6);
$parcel$export(module.exports, "toDateOnly", () => $a1048e23edd181e2$export$b0961ad8aee63b8b);
const $a1048e23edd181e2$export$9cda9b56d134780f = 'Invalid date or date format';
const $a1048e23edd181e2$var$toISOString = (year, month, day)=>`${String(year).padStart(4, '0')}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
const $a1048e23edd181e2$var$isLeapYear = (year)=>year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
const $a1048e23edd181e2$var$daysInMonth = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
/**
 Returns a boolean to indicate that the date specified is valid.

 Note: Dates before Year zero are treated to be invalid.
 */ const $a1048e23edd181e2$var$isDateValid = (year, month, day)=>{
    if ([
        year,
        month,
        day
    ].findIndex((n)=>typeof n !== 'number' || Number.isNaN(n)) !== -1) return false;
    if (year < 0) return false;
    if (month < 1 || month > 12) return false;
    if (day < 1) return false;
    if (day > (month === 2 && $a1048e23edd181e2$var$isLeapYear(year) ? 29 : $a1048e23edd181e2$var$daysInMonth[month - 1])) return false;
    return true;
};
const $a1048e23edd181e2$var$dateFormatRegExp = /^([0-9][0-9][0-9][0-9])-([0-1][0-9])-([0-3][0-9])$/;
class $a1048e23edd181e2$export$988b361b394263b6 {
    /**
	 * Return true if the string is a valid ISO date string in the format 'YYYY-MM-DD'.
	 * @param dateString
	 * @returns {boolean}
	 */ static isISODateString(dateString) {
        try {
            $a1048e23edd181e2$export$988b361b394263b6.fromISODateString(dateString);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e?.message === $a1048e23edd181e2$export$9cda9b56d134780f) return false;
            throw e;
        }
        return true;
    }
    /**
	 * Create a DateOnly object from a string in the format 'YYYY-MM-DD'.
	 */ // go/jfe-eslint
    static fromISODateString(dateString) {
        const matches = $a1048e23edd181e2$var$dateFormatRegExp.exec(dateString);
        if (matches === null) throw new Error($a1048e23edd181e2$export$9cda9b56d134780f);
        const [, year, month, day] = matches;
        // @ts-expect-error - TS2556 - A spread argument must either have a tuple type or be passed to a rest parameter.
        return new $a1048e23edd181e2$export$988b361b394263b6(...[
            year,
            month,
            day
        ].map((s)=>Number.parseInt(s, 10)));
    }
    /**
	 * DISCLAIMER:
	 * Date() does NOT store timezone information.
	 *
	 * Date.prototype.toString() leverages the system's timezone to serialize it into a string according to local time.
	 * Methods getDate(), getMonth(), getFullYear() behave the same and also return values according to local time.
	 *
	 * Methods toUTCString(), getUTCDate(), getUTCMonth(), getUTCFullYear() return values according to universal time.
	 *
	 * Reference: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date
	 */ /**
	 * Create a DateOnly object that reflects the local year, month & day for the specified Date.
	 *
	 * See the disclaimer above for further details.
	 */ // go/jfe-eslint
    static fromDateAccordingToLocalTime(date) {
        return new $a1048e23edd181e2$export$988b361b394263b6(date.getFullYear(), date.getMonth() + 1, date.getDate());
    }
    /**
	 * Create a DateOnly object that reflects the UTC year, month & day of the specified Date.
	 *
	 * See the disclaimer above for further details.
	 */ // go/jfe-eslint
    static fromDateAccordingToUTC(date) {
        return new $a1048e23edd181e2$export$988b361b394263b6(date.getUTCFullYear(), date.getUTCMonth() + 1, date.getUTCDate());
    }
    /**
	 * Compare 2 DateOnly objects.
	 *
	 * (Similar to the TC39 proposal Temporal.PlainDate.compare).
	 *
	 * If a comes before b, return -1.
	 * If a is equal to b, return 0.
	 * If a is greater than b, return 1.
	 */ static compare(a, b) {
        if (a.year === b.year) {
            if (a.month === b.month) {
                if (a.day === b.day) return 0;
                return a.day < b.day ? -1 : 1;
            }
            return a.month < b.month ? -1 : 1;
        }
        return a.year < b.year ? -1 : 1;
    }
    /**
	 * Create a DateOnly object which represents a day. It does not have a time component.
	 * @param year - A year, ranging between 0 and 9999 inclusive.
	 * @param month - A month, ranging between 1 and 12 inclusive.
	 * @param day - A day of the month, ranging between 1 and 31 inclusive.
	 */ constructor(year, month, day){
        if (!$a1048e23edd181e2$var$isDateValid(year, month, day)) throw new Error($a1048e23edd181e2$export$9cda9b56d134780f);
        this.year = year;
        this.month = month;
        this.day = day;
    }
    getYear() {
        return this.year;
    }
    getMonth() {
        return this.month;
    }
    getDay() {
        return this.day;
    }
    toISOString() {
        return $a1048e23edd181e2$var$toISOString(this.year, this.month, this.day);
    }
    /**
	 * Returns a Date object with the same date, with the time component set to 00:00:00 which corresponds to the UTC timezone.
	 */ toUTCDate() {
        return new Date(Date.UTC(this.year, this.month - 1, this.day));
    }
    /**
	 * Returns a Date object with the same date, with the time component set to 00:00:00 for the local timezone.
	 */ toLocalDate() {
        // take the current date (e.g. 1.06.2020)
        const localDate = new Date();
        // store current month in a const to compare below
        const currentMonth = localDate.getMonth();
        // set the year
        localDate.setFullYear(this.year);
        localDate.setHours(0);
        localDate.setMinutes(0);
        localDate.setSeconds(0);
        localDate.setMilliseconds(0);
        localDate.setDate(this.day);
        // if this.day doesn't exist in the current month (e.g. 31 doesn't exist in June ),
        // it will set the month to July instead. We need to make sure setDate doesn't change the month
        if (localDate.getMonth() !== currentMonth) {
            localDate.setMonth(this.month - 1);
            // reset the date after updating the month
            localDate.setDate(this.day);
        } else localDate.setMonth(this.month - 1);
        return localDate;
    }
    equals(dateOnly) {
        return $a1048e23edd181e2$export$988b361b394263b6.compare(this, dateOnly) === 0;
    }
}
const $a1048e23edd181e2$export$b0961ad8aee63b8b = (date)=>typeof date === 'string' ? $a1048e23edd181e2$export$988b361b394263b6.fromISODateString(date.replace(/T.*/, '')) : null;

});

parcelRegister("jkrrf", function(module, exports) {

$parcel$export(module.exports, "fireExposureForPowerfulInlineCreateAATest", () => $c294d57db1e82549$export$30b66c5484d93831);

var $6s1PB = parcelRequire("6s1PB");
const $c294d57db1e82549$export$30b66c5484d93831 = ()=>{
    (0, $6s1PB.expVal)('jira_powerful_inline_create_experiments_aa', 'isEnabled', false);
};

});



parcelRegister("aoiYi", function(module, exports) {

$parcel$export(module.exports, "default", () => $79523967be3ef702$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $imZsD = parcelRequire("imZsD");

var $fNobW = parcelRequire("fNobW");

var $kMSay = parcelRequire("kMSay");

var $kJ1Ne = parcelRequire("kJ1Ne");

var $57r8q = parcelRequire("57r8q");

var $hE5wF = parcelRequire("hE5wF");

var $e21nk = parcelRequire("e21nk");

var $cm8b5 = parcelRequire("cm8b5");

var $kRkJF = parcelRequire("kRkJF");

var $1T1ir = parcelRequire("1T1ir");

var $2UUq6 = parcelRequire("2UUq6");

var $33Toe = parcelRequire("33Toe");

var $exeAk = parcelRequire("exeAk");

var $ltZxv = parcelRequire("ltZxv");

var $3kVj2 = parcelRequire("3kVj2");

var $ksKCJ = parcelRequire("ksKCJ");

var $7Wnap = parcelRequire("7Wnap");


var $7Q2kM = parcelRequire("7Q2kM");

var $eGLgs = parcelRequire("eGLgs");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $2gCtH = parcelRequire("2gCtH");

var $2OMDV = parcelRequire("2OMDV");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $iuzc0 = parcelRequire("iuzc0");

var $14XJw = parcelRequire("14XJw");

var $g5X3G = parcelRequire("g5X3G");

var $koeKL = parcelRequire("koeKL");

var $l8ruj = parcelRequire("l8ruj");

var $ieDtd = parcelRequire("ieDtd");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");

var $2vSU6 = parcelRequire("2vSU6");

var $e1OxR = parcelRequire("e1OxR");

var $itmJb = parcelRequire("itmJb");

var $eTDjN = parcelRequire("eTDjN");

var $dJ1ye = parcelRequire("dJ1ye");

var $mk7k0 = parcelRequire("mk7k0");

var $iHWvz = parcelRequire("iHWvz");

var $3fU11 = parcelRequire("3fU11");

var $4nnGr = parcelRequire("4nnGr");

var $8TUlY = parcelRequire("8TUlY");

var $8e3Yw = parcelRequire("8e3Yw");

var $5HTKY = parcelRequire("5HTKY");

var $9u99d = parcelRequire("9u99d");

var $gijCE = parcelRequire("gijCE");

var $g7iDt = parcelRequire("g7iDt");

var $dvvS3 = parcelRequire("dvvS3");

var $5t2X8 = parcelRequire("5t2X8");

var $hb2SN = parcelRequire("hb2SN");

var $j2Xxu = parcelRequire("j2Xxu");

var $7G4Lw = parcelRequire("7G4Lw");

var $7pW4c = parcelRequire("7pW4c");

var $gP1aD = parcelRequire("gP1aD");

var $5bYhZ = parcelRequire("5bYhZ");

var $2CfGf = parcelRequire("2CfGf");

var $fX4kd = parcelRequire("fX4kd");

var $5h7oA = parcelRequire("5h7oA");

var $lz9hZ = parcelRequire("lz9hZ");

var $1QC74 = parcelRequire("1QC74");

var $dUCV4 = parcelRequire("dUCV4");

var $aQK8w = parcelRequire("aQK8w");

var $dfOFF = parcelRequire("dfOFF");

var $8nhP8 = parcelRequire("8nhP8");

var $86297 = parcelRequire("86297");

var $35R0r = parcelRequire("35R0r");

var $1pfh5 = parcelRequire("1pfh5");
const $79523967be3ef702$var$FOOTER_HEIGHT = 45;
const $79523967be3ef702$var$ROW_HEIGHT = 40;
const $79523967be3ef702$var$ON_END_REACHED_THRESHOLD = 300;
const $79523967be3ef702$var$STARGATE_URL = '/gateway/api';
// passing in empty componentName so that we can define action name from analytics events
const $79523967be3ef702$var$BaseTableWithAnalytics = (0, $2OMDV.AnalyticsEventToProps)('', {
    onResize: 'resized'
})((props)=>(0, $4R6GH.fg)('jsw_list_assignee_focused_analytics') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5bYhZ.MemoizedBaseTable), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5bYhZ.BaseTable), props));
const $79523967be3ef702$var$useEdition = (type)=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    return (0, $5uXOq.useMemo)(()=>{
        if (!type) return;
        const projectType = (0, $2vSU6.toProjectType)(type);
        if (!projectType) return;
        return (0, $ldyPw.getEditionForProject)(projectType, appEditions);
    }, [
        appEditions,
        type
    ]);
};
const $79523967be3ef702$var$ListContent = ({ projectId: projectId, projectKey: projectKey, projectName: projectName, projectType: projectType })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const interactionMetrics = (0, $dJ1ye.useInteractionMetrics)();
    const [columnWidths, { setColumnWidth: setColumnWidth }] = (0, $3fU11.useColumnWidths)();
    const [{ hierarchyData: { data: issues, loading: loading, error: error } }] = (0, $9u99d.useHierarchyStore)();
    const viewMode = (0, $2gCtH.useViewMode)();
    const isViewModeSideBar = viewMode === 'SIDEBAR';
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { isFiltering: isFiltering } = (0, $kRkJF.useFilteredViewContextInput)({
        view: 'list'
    });
    const { isSearching: isSearching } = (0, $1T1ir.useSimpleSearchJQL)();
    const [selectedIssueKey, setSelectedIssueKey] = (0, $ieDtd.useQueryParam)((0, $hE5wF.SELECTED_ISSUE_PARAM));
    const showReparentModal = (0, $hb2SN.useShouldShowReparentModal)();
    (0, $cm8b5.useQueryBasedViewAutomaticTracking)((0, $eTDjN.VIEW_EXPERIENCE), {
        loading: loading,
        error: error
    });
    const [{ sortBy: sortBy }] = (0, $2UUq6.useSorting)();
    const isSorting = sortBy != null;
    const { featureView: featureView, isSoftwareFieldsEnabled: isSoftwareFieldsEnabled } = (0, $4nnGr.useJWMListFeatures)();
    const numIssues = (0, $5uXOq.useMemo)(()=>issues.filter((i)=>!i.id.match('^SKELETON-ITEM-[0-9]+-id$')).length, [
        issues
    ]);
    const [showBulkEditOnboarding, setShowBulkEditOnboarding] = (0, $5uXOq.useState)(false);
    const [coordinationClient, setCoordinationClient] = (0, $5uXOq.useState)(null);
    if ((0, $4R6GH.fg)('jira_list_view_bulk_edit_changeboarding')) {
        if (numIssues >= 2 && cloudId && orgId && !coordinationClient) {
            const coordClient = new (0, $eGLgs.CoordinationClient)(cloudId, $79523967be3ef702$var$STARGATE_URL, false, orgId, 'engagement');
            setCoordinationClient(coordClient);
            coordClient.start((0, $eTDjN.BULK_EDIT_CHANGEBOARDING_MESSAGE_ID)).then(setShowBulkEditOnboarding);
        }
    }
    (0, $j2Xxu.useTableAnalytics)();
    const ufoPressTracing = (0, $kMSay.default)('jwm.list.issue-view-opened');
    const onBeforeOpened = (0, $5uXOq.useCallback)((event)=>{
        ufoPressTracing(event.timeStamp);
    }, [
        ufoPressTracing
    ]);
    const filterIssue = (0, $5uXOq.useCallback)((issue)=>Boolean(issue.id && !(0, $33Toe.isOptimisticIssue)(Number(issue.id)) && issue.key), []);
    const { createOpenIssueModalHandler: openIssueModal } = (0, $ltZxv.useIssueModalActions)({
        onBeforeOpened: onBeforeOpened,
        filterIssue: filterIssue
    });
    const { toggleHighlightRow: toggleHighlightRow, getRowClassName: getRowClassName } = (0, $2CfGf.useHighlightDoneItems)();
    const highlightRow = (0, $5uXOq.useCallback)((issueKey)=>toggleHighlightRow(issueKey, true), [
        toggleHighlightRow
    ]);
    const { onIssueUpdated: onIssueUpdated } = (0, $7pW4c.useIssueUpdated)();
    const { updateCommentsCache: updateCommentsCache } = (0, $6s1PB.expVal)('jira_unread_comments_in_list_view', 'isEnabled', false) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $gP1aD.useUpdateCommentsCellCache)() : {
        updateCommentsCache: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    };
    const openIssueModalWithUnreadCommentsReset = (0, $5uXOq.useCallback)((issue)=>{
        updateCommentsCache(issue.key);
        return openIssueModal(issue);
    }, [
        openIssueModal,
        updateCommentsCache
    ]);
    const columns = (0, $35R0r.useGetColumns)({
        columnWidths: columnWidths,
        rowHeight: $79523967be3ef702$var$ROW_HEIGHT,
        openIssueModal: (0, $6s1PB.expVal)('jira_unread_comments_in_list_view', 'isEnabled', false) ? openIssueModalWithUnreadCommentsReset : openIssueModal,
        highlightRow: highlightRow,
        loading: loading,
        projectId: projectId,
        onIssueUpdated: onIssueUpdated,
        showBulkEditOnboarding: showBulkEditOnboarding
    });
    const onResize = (columnKey, width, analyticsEvent)=>{
        interactionMetrics[0, $dJ1ye.COLUMN_RESIZED].start();
        setColumnWidth(columnKey, width);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'column resized', {
            columnKey: columnKey
        });
    };
    const onModalIssueClose = (0, $5uXOq.useCallback)(()=>{
        setSelectedIssueKey(undefined);
    }, [
        setSelectedIssueKey
    ]);
    const { onIssueChange: onIssueChange } = (0, $g7iDt.useIssueChangeUpdater)();
    // this needs to be memoised otherwise it rerenders when the table changes causing some elements to blink
    // a common reason for the table to change while this is open is the realtime implementation
    const bentoView = (0, $5uXOq.useMemo)(()=>selectedIssueKey != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3kVj2.default), {
            issueKey: (0, $g5X3G.toIssueKey)(selectedIssueKey),
            onClose: onModalIssueClose,
            analyticsSource: (0, $fcf97b7a09088940$export$7ca28938a07e0c33),
            onChange: onIssueChange,
            isSoftwareProject: isSoftwareFieldsEnabled
        }), [
        selectedIssueKey,
        onModalIssueClose,
        onIssueChange,
        isSoftwareFieldsEnabled
    ]);
    const [groupByFieldId] = (0, $8e3Yw.useGroupBy)();
    const isGrouping = groupByFieldId != null;
    const isAdmin = (0, $itmJb.useIsAdmin)();
    let edition;
    if ((0, $4R6GH.fg)('add-attribute-required-for-colorful-labels-expe')) // eslint-disable-next-line react-hooks/rules-of-hooks
    edition = $79523967be3ef702$var$useEdition(projectType);
    (0, $5uXOq.useEffect)(()=>{
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'list viewed', {
            isGrouping: isGrouping,
            isSorting: isSorting,
            isFiltering: isFiltering,
            isSearching: isSearching,
            groupBy: groupByFieldId,
            ...edition ? {
                edition: edition
            } : {}
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
        name: "list-view",
        hold: loading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Wnap.RenderStartMark), {
        view: featureView,
        loading: loading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gijCE.default), null), isAdmin && (0, $4R6GH.fg)('jsw_list_assignee_focused_analytics') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e1OxR.default), {
        shouldUseInvitePeopleModal: true,
        source: "list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($79523967be3ef702$var$BaseTableWithAnalytics, {
        columns: columns,
        onResize: onResize,
        onEndReachedThreshold: $79523967be3ef702$var$ON_END_REACHED_THRESHOLD,
        footerHeight: $79523967be3ef702$var$FOOTER_HEIGHT,
        rowHeight: $79523967be3ef702$var$ROW_HEIGHT,
        getRowClassName: getRowClassName,
        loadingMessage: formatMessage((0, $aQK8w.default).loadingMoreItems),
        isSorting: isSorting,
        EmptyState: (0, $lz9hZ.EmptyState),
        GroupItem: (0, $1QC74.GroupItem),
        projectId: projectId,
        projectKey: projectKey,
        projectName: projectName
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($79523967be3ef702$var$BaseTableWithAnalytics, {
        columns: columns,
        onResize: onResize,
        onEndReachedThreshold: $79523967be3ef702$var$ON_END_REACHED_THRESHOLD,
        footerHeight: $79523967be3ef702$var$FOOTER_HEIGHT,
        rowHeight: $79523967be3ef702$var$ROW_HEIGHT,
        getRowClassName: getRowClassName,
        loadingMessage: formatMessage((0, $aQK8w.default).loadingMoreItems),
        isSorting: isSorting,
        EmptyState: (0, $lz9hZ.EmptyState),
        GroupItem: (0, $1QC74.GroupItem),
        projectId: projectId,
        projectKey: projectKey,
        projectName: projectName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5t2X8.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5HTKY.default), {
        isBackgroundQueryDisabled: !isGrouping
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8TUlY.UpdateFieldsDetail), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "jira-list-issue-app"
    }, isViewModeSideBar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ksKCJ.SidebarIssueView), {
        issueKey: selectedIssueKey,
        onClose: onModalIssueClose,
        analyticsSource: (0, $fcf97b7a09088940$export$7ca28938a07e0c33),
        onChange: onIssueChange,
        isSoftwareProject: isSoftwareFieldsEnabled
    }) : bentoView), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Q2kM.DevDetailsDialogLoaderAsync), {
        scopeId: "software-list.list"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dvvS3.default), {
        showBulkEditOnboarding: showBulkEditOnboarding,
        coordinationClient: coordinationClient
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fX4kd.default), null), showReparentModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8nhP8.AsyncReparentModal), null), !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5h7oA.default), null), (0, $4R6GH.fg)('jira_onboarding_wizard_m1_feature_gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $86297.WelcomeModal), null), (0, $4R6GH.fg)('jira_forms_public_access_changeboarding_gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJ1Ne.default), {
        projectId: projectId.toString()
    }), (0, $4R6GH.fg)('jira-list-nin-migration-survey') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1pfh5.MigrationFeedback), null));
};
const $79523967be3ef702$export$84d0dd190d551cd1 = ({ projectId: projectId, projectKey: projectKey, projectName: projectName, projectType: projectType, isTeamManaged: isTeamManaged, formattingRulesQuery: formattingRulesQuery })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ childrenItems: _childrenQueryData }] = (0, $9u99d.useHierarchyStore)();
    const pageHeading = formatMessage((0, $aQK8w.default).listHeading);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onClear = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'groupBy cleared', {
            reason: 'stale'
        });
    }, [
        createAnalyticsEvent
    ]);
    (0, $7G4Lw.useClearStaleGroupBy)({
        onClear: onClear
    });
    (0, $iHWvz.useWatchBulkSelection)();
    const listViewContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e21nk.BusinessDocumentTitle), {
        pageHeading: pageHeading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "jira-list-header-actions"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dUCV4.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), {
        blanketIsTinted: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($79523967be3ef702$var$ListContent, {
        projectKey: projectKey,
        projectName: projectName,
        projectId: projectId,
        projectType: projectType,
        isTeamManaged: isTeamManaged
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dfOFF.InteractionMetrics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $exeAk.PrefetchIssueDataController), null), formattingRulesQuery && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $57r8q.FormatRules), {
        query: formattingRulesQuery
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $mk7k0.BulkSelectionContainer), {
        scope: "JWMListBulkSelection"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iuzc0.QuickstartPillVisibilityContainer), {
        scope: "ListPageQuickstartPill"
    }, listViewContent));
};
var $79523967be3ef702$export$2e2bcd8739ae039 = $79523967be3ef702$export$84d0dd190d551cd1;

});
parcelRegister("kJ1Ne", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce599d26c9577203$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $i8Qvm = parcelRequire("i8Qvm");

var $8uFbT = parcelRequire("8uFbT");

var $4mO32 = parcelRequire("4mO32");

var $7XluA = parcelRequire("7XluA");

var $7CMCs = parcelRequire("7CMCs");

var $AeWM3 = parcelRequire("AeWM3");

var $aXhsp = parcelRequire("aXhsp");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $e43Es = parcelRequire("e43Es");

var $hN7SF = parcelRequire("hN7SF");

var $getng = parcelRequire("getng");

var $6P8fi = parcelRequire("6P8fi");

const $ce599d26c9577203$var$entryPointParams = {};
const $ce599d26c9577203$var$PublicFormChangeboardingModalRoot = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "public-forms-changeboarding-modal",
        packageName: "@atlassian/jira-public-forms-changeboarding-modal",
        teamName: "a4t-tanuki",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $AeWM3.ApolloClientProvider), {
        client: (0, $aXhsp.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce599d26c9577203$var$PublicFormChangeboardingModalContainer, props))));
};
const $ce599d26c9577203$var$PublicFormChangeboardingModalContainer = ({ projectId: projectId })=>{
    const { isActive: isModalTriggerActive } = (0, $8uFbT.useTrigger)((0, $1a3ee76b747d2e0b$export$245c2608a15570d3));
    const { isActive: isFlagTriggerActive } = (0, $8uFbT.useTrigger)((0, $1a3ee76b747d2e0b$export$6c605e0a476d3e4b));
    const data = (0, $e43Es.useGetData)({
        projectId: projectId,
        isEnabled: (isModalTriggerActive || isFlagTriggerActive) && (0, $4R6GH.fg)('jira_forms_public_access_changeboarding_gate')
    });
    const hasLoadedEntrypoint = (0, $5uXOq.useRef)(false);
    const { entryPointActions: modalEntryPointActions, entryPointReferenceSubject: modalEntryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $getng.asyncChangeboardingModalEntryPoint), $ce599d26c9577203$var$entryPointParams);
    const { entryPointActions: flagEntryPointActions, entryPointReferenceSubject: flagEntryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $hN7SF.asyncChangeboardingFlagEntryPoint), $ce599d26c9577203$var$entryPointParams);
    const isEligibleToViewChangeboarding = data && !data.projectHasPublicForm && data.isPublicFormEnabledForSite && data.canAdministerProject && data.projectHasFormNavItem;
    const shouldLoadModal = isModalTriggerActive && isEligibleToViewChangeboarding;
    const shouldRenderFlag = isFlagTriggerActive && isEligibleToViewChangeboarding;
    (0, $5uXOq.useEffect)(()=>{
        // if project already has public forms or has been disabled for the site, then
        // they already are aware of the feature and do not need to be notified
        if (data?.projectHasPublicForm || data?.isPublicFormEnabledForSite === false) {
            (0, $6P8fi.emitModalMessageEvent)({
                action: 'filter'
            });
            (0, $6P8fi.emitFlagMessageEvent)({
                action: 'filter'
            });
        }
    }, [
        data?.projectHasPublicForm,
        data?.isPublicFormEnabledForSite
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!hasLoadedEntrypoint.current) {
            if (shouldRenderFlag) {
                if (!(0, $6s1PB.expVal)('jira_forms_public_access_changeboarding', 'isEnabled', false)) {
                    // if in control cohort, snooze the post office message and check again later
                    // as experiment gradually rolls out
                    (0, $6P8fi.emitFlagMessageEvent)({
                        action: 'snooze'
                    });
                    return;
                }
                flagEntryPointActions.load();
                hasLoadedEntrypoint.current = true;
            }
            if (shouldLoadModal) {
                if (!(0, $6s1PB.expVal)('jira_forms_public_access_changeboarding', 'isEnabled', false)) {
                    (0, $6P8fi.emitModalMessageEvent)({
                        action: 'snooze'
                    });
                    return;
                }
                modalEntryPointActions.load();
                hasLoadedEntrypoint.current = true;
            }
        }
    }, [
        flagEntryPointActions,
        modalEntryPointActions,
        shouldLoadModal,
        shouldRenderFlag
    ]);
    if (!data || !data.project || !shouldLoadModal && !shouldRenderFlag) return null;
    const firstFormIdInProject = data.forms?.[0]?.formId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: modalEntryPointReferenceSubject,
        id: "public-forms-changeboarding-modal",
        packageName: "@atlassian/jira-public-forms-changeboarding-modal",
        teamName: "a4t-tanuki",
        fallback: null,
        errorFallback: "unmount",
        runtimeProps: {
            firstFormIdInProject: firstFormIdInProject,
            project: data.project
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: flagEntryPointReferenceSubject,
        id: "public-forms-changeboarding-flag",
        packageName: "@atlassian/jira-public-forms-changeboarding-modal",
        teamName: "a4t-tanuki",
        fallback: null,
        errorFallback: "unmount",
        runtimeProps: {
            firstFormIdInProject: firstFormIdInProject,
            project: data.project
        }
    }));
};
var $ce599d26c9577203$export$2e2bcd8739ae039 = $ce599d26c9577203$var$PublicFormChangeboardingModalRoot;

});
parcelRegister("e43Es", function(module, exports) {

$parcel$export(module.exports, "useGetData", () => $41a4c09c49cfff36$export$1f47bbb09bba389a);

var $5tTFS = parcelRequire("5tTFS");

var $kV9ss = parcelRequire("kV9ss");

var $koeKL = parcelRequire("koeKL");

var $lHhTR = parcelRequire("lHhTR");
const $41a4c09c49cfff36$var$getProjectHasFormNavItem = (data)=>{
    if (!data.jira?.containerNavigation) return false;
    if (!('navigationItems' in data.jira.containerNavigation)) return false;
    return data.jira.containerNavigation.navigationItems?.edges?.some((node)=>node?.node?.typeKey === 'FORMS') ?? false;
};
const $41a4c09c49cfff36$var$getProjectHasPublicForm = (data)=>{
    return data.jiraBusinessFormsByProjectId?.nodes?.some((node)=>node?.accessLevel === 'public') ?? false;
};
const $41a4c09c49cfff36$export$1f47bbb09bba389a = ({ projectId: projectId, isEnabled: isEnabled })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const projectAri = (0, $kV9ss.JiraProjectAri).create({
        siteId: cloudId,
        projectId: projectId
    });
    const { data: data } = (0, $5tTFS.useQuery)((0, $lHhTR.GET_DATA_QUERY), {
        variables: {
            projectId: projectId,
            projectAri: projectAri.toString()
        },
        fetchPolicy: 'network-only',
        skip: !isEnabled
    });
    if (!data) return undefined;
    const projectHasFormNavItem = $41a4c09c49cfff36$var$getProjectHasFormNavItem(data);
    const isPublicFormEnabledForSite = data.jiraBusinessFormsByProjectId?.publicFormsEnabled ?? null;
    const canAdministerProject = data.jira?.jiraProject?.administerProject?.canPerform ?? false;
    const projectHasPublicForm = $41a4c09c49cfff36$var$getProjectHasPublicForm(data);
    const firstStoryLevelIssueTypeId = data.jira?.jiraProject?.issueTypes?.edges?.[0]?.node?.issueTypeId ?? null;
    return {
        forms: data.jiraBusinessFormsByProjectId?.nodes,
        project: data.jira?.jiraProject,
        projectHasFormNavItem: projectHasFormNavItem,
        isPublicFormEnabledForSite: isPublicFormEnabledForSite,
        canAdministerProject: canAdministerProject,
        projectHasPublicForm: projectHasPublicForm,
        firstStoryLevelIssueTypeId: firstStoryLevelIssueTypeId
    };
};

});
parcelRegister("lHhTR", function(module, exports) {

$parcel$export(module.exports, "GET_DATA_QUERY", () => $91b4b63945405a40$export$d51f8ada234b77b5);

var $5cllN = parcelRequire("5cllN");
const $91b4b63945405a40$export$d51f8ada234b77b5 = (0, $5cllN.default)`
query getPublicFormChangeboardingData ($projectId: Long!, $projectAri: ID!) {
    jira {
        containerNavigation(
            input: {scopeId: $projectAri}
        ) {
            ... on JiraContainerNavigation {
                id
                navigationItems(first: 100) {
                    edges {
                        node {
                            typeKey
                            id
                        }
                    }
                }
            }
        }

        jiraProject(id: $projectAri) {
            id
            projectId
            key
            name
            projectType
			tmpBoardId
            administerProject: action(type: EDIT_PROJECT_CONFIG) {
              canPerform
            }
            issueTypes(
                first: 1,
                filter: { minHierarchyLevel: 0, maxHierarchyLevel: 0 }
            ) {
                edges {
                    node {
                        id
                        name
                        issueTypeId
                    }
                }
            }
        }
    }

    jiraBusinessFormsByProjectId(projectId: $projectId, first: 50) {
        publicFormsEnabled
        nodes {
            formId
            accessLevel
        }
    }
}
`;

});


parcelRegister("hN7SF", function(module, exports) {

$parcel$export(module.exports, "asyncChangeboardingFlagEntryPoint", () => $b78bb725d4342816$export$b6311e50754a3c1b);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $b78bb725d4342816$export$b6311e50754a3c1b = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("eoxUT")), {
        moduleId: "8f6b3883",
        moduleName: "PublicFormChangeboardingFlag"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("eoxUT", function(module, exports) {

let $a7ad9db866bbc73d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a7ad9db866bbc73d$var$load("3G2OT").then(()=>parcelRequire('f17IT'));

});


parcelRegister("getng", function(module, exports) {

$parcel$export(module.exports, "asyncChangeboardingModalEntryPoint", () => $fe964ab657d9125c$export$6f32a80685928724);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $fe964ab657d9125c$export$6f32a80685928724 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("djZZ9")), {
        moduleId: "2cab4041",
        moduleName: "PublicFormChangeboardingModal"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("djZZ9", function(module, exports) {

let $9b2d21b108df2c1e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9b2d21b108df2c1e$var$load("aeZUn").then(()=>parcelRequire('aHFvH'));

});


parcelRegister("6P8fi", function(module, exports) {

$parcel$export(module.exports, "getFormBuilderUrl", () => $d9991abb643263eb$export$1a0bdbdcca54ab65);
$parcel$export(module.exports, "emitModalMessageEvent", () => $d9991abb643263eb$export$bd83076b2e7fa91a);
$parcel$export(module.exports, "emitFlagMessageEvent", () => $d9991abb643263eb$export$e40f3f03094e29dc);

const $d9991abb643263eb$var$SOFTWARE_TMP_PREFIX = '/jira/software';
const $d9991abb643263eb$var$SOFTWARE_CMP_PREFIX = '/jira/software/c';
const $d9991abb643263eb$var$BUSINESS_PREFIX = '/jira/core';
const $d9991abb643263eb$export$36e24695f02d4503 = (project)=>{
    if (project.projectType === 'SOFTWARE') {
        if (project.tmpBoardId !== null) return $d9991abb643263eb$var$SOFTWARE_TMP_PREFIX;
        return $d9991abb643263eb$var$SOFTWARE_CMP_PREFIX;
    }
    return $d9991abb643263eb$var$BUSINESS_PREFIX;
};
const $d9991abb643263eb$export$1a0bdbdcca54ab65 = ({ project: project, formId: formId })=>{
    return `${$d9991abb643263eb$export$36e24695f02d4503(project)}/projects/${project.key}/form/${formId}/builder`;
};
const $d9991abb643263eb$export$bd83076b2e7fa91a = (eventDetails)=>{
    const event = new CustomEvent((0, $1a3ee76b747d2e0b$export$ca851eafcdc960ee), {
        detail: eventDetails
    });
    if (typeof document !== 'undefined') document.dispatchEvent(event);
};
const $d9991abb643263eb$export$e40f3f03094e29dc = (eventDetails)=>{
    const event = new CustomEvent((0, $1a3ee76b747d2e0b$export$a963aea3558fe23a), {
        detail: eventDetails
    });
    if (typeof document !== 'undefined') document.dispatchEvent(event);
};

});
const $1a3ee76b747d2e0b$export$ca3d56c0d6d21363 = 'jira_business_public-forms-changeboarding';
const $1a3ee76b747d2e0b$export$3b45ec1a607f2838 = 'SHOULD_SHOW_FORM_BUILDER_SPOTLIGHTING';
const $1a3ee76b747d2e0b$export$64e47a95ce32c8b2 = 'PUBLIC_FORM_CHANGEBOARDING_SPOTLIGHTS_FORM_ACCESS_STEP';
const $1a3ee76b747d2e0b$export$51318ec2f5085d87 = 'PUBLIC_FORM_CHANGEBOARDING_SPOTLIGHTS_FORM_FIELD_STEP';
const $1a3ee76b747d2e0b$export$ca851eafcdc960ee = 'jira-forms-public-forms-changeboarding-event';
const $1a3ee76b747d2e0b$export$245c2608a15570d3 = 'jira-forms-public-forms-changeboarding-trigger-id';
const $1a3ee76b747d2e0b$export$a963aea3558fe23a = 'jira-forms-public-forms-changeboarding-flag-event';
const $1a3ee76b747d2e0b$export$6c605e0a476d3e4b = 'jira-forms-public-forms-changeboarding-flag-trigger-id';



parcelRegister("57r8q", function(module, exports) {

$parcel$export(module.exports, "FormatRules", () => $846afdd27dc3631b$export$85cc1c447494ea9e);

var $ejcnh = parcelRequire("ejcnh");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $llMZa = parcelRequire("llMZa");

var $hug5L = parcelRequire("hug5L");
const $846afdd27dc3631b$export$85cc1c447494ea9e = ({ query: query })=>{
    const [, { setFormatRules: setFormatRules, setRulesForJqlInput: setRulesForJqlInput }] = (0, $hug5L.useFormatRulesStore)();
    const { jira: jira } = (0, $8Uumt.usePreloadedQuery)((0, $ejcnh.default), query);
    (0, $5uXOq.useEffect)(()=>{
        const formattingRulesByProject = jira?.jiraProjectByKey?.conditionalFormattingRules;
        if (!formattingRulesByProject) return;
        /* rowRules and cellRulesByFieldId - data to be able to format per rows and per field cell */ let rowRules = [];
        const cellRulesByFieldId = {};
        const rulesJqlInput = {};
        formattingRulesByProject.edges?.forEach((edge, index)=>{
            const rule = edge?.node;
            if (rule) {
                const { formattingArea: formattingArea, formattingColor: formattingColor } = rule;
                let fieldId = null;
                let operator = 'IS';
                let value;
                switch(rule.expression.__typename){
                    case 'JiraFormattingSingleValueOperand':
                        operator = rule.expression.singleValueOperator;
                        ({ value: value, fieldId: fieldId } = rule.expression);
                        break;
                    case 'JiraFormattingMultipleValueOperand':
                        operator = rule.expression.multipleValueOperator;
                        value = rule.expression.values;
                        fieldId = rule.expression.fieldId;
                        break;
                    case 'JiraFormattingNoValueOperand':
                        operator = rule.expression.noValueOperator;
                        fieldId = rule.expression.fieldId;
                        break;
                    default:
                        break;
                }
                const color = (0, $llMZa.formattingColors)[formattingColor.colorKey || ''];
                const mappedRule = {
                    id: rule.id,
                    fieldId: fieldId,
                    operator: operator,
                    value: value,
                    color: color?.value,
                    formattingArea: formattingArea,
                    index: index,
                    hoverColor: color?.hoverValue
                };
                if (mappedRule.fieldId) {
                    if (mappedRule.formattingArea === 'ROW') rowRules = [
                        ...rowRules,
                        mappedRule
                    ];
                    else cellRulesByFieldId[mappedRule.fieldId] = [
                        ...cellRulesByFieldId[mappedRule.fieldId] || [],
                        mappedRule
                    ];
                    // input to serialise jql input
                    const DUMMY_VALUE = '-';
                    const values = Array.isArray(mappedRule.value) ? mappedRule.value : [
                        mappedRule.value
                    ];
                    if (!rulesJqlInput[mappedRule.fieldId]) rulesJqlInput[mappedRule.fieldId] = [];
                    values.forEach((ruleValue)=>{
                        if (mappedRule.fieldId) rulesJqlInput[mappedRule.fieldId]?.push({
                            value: ruleValue ?? DUMMY_VALUE,
                            label: ruleValue ?? DUMMY_VALUE
                        });
                    });
                }
            }
        });
        setFormatRules({
            rowRules: rowRules,
            cellRulesByFieldId: cellRulesByFieldId
        });
        setRulesForJqlInput(rulesJqlInput);
    }, [
        jira?.jiraProjectByKey?.conditionalFormattingRules,
        setFormatRules,
        setRulesForJqlInput
    ]);
    return null;
};

});
parcelRegister("ejcnh", function(module, exports) {

$parcel$export(module.exports, "default", () => $653ec3882dd047d6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<be46c1bf7842bd4e81b2735dfa9eb61d>>
 * @relayHash fe655b1c8f3fbc00448359fc7bbdb4a2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 19617cae23dba3619feb6b7d7006b077c3444a7b0f92752732863a7b7f39d16b

var $eiowN = parcelRequire("eiowN");
const $653ec3882dd047d6$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v4 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "colorKey"
    }, v7 = {
        "kind": "ScalarField",
        "name": "formattingArea"
    }, v8 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v9 = {
        "kind": "LinkedField",
        "name": "expression",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v8 /*: any*/ ,
                    {
                        "alias": "singleValueOperator",
                        "kind": "ScalarField",
                        "name": "operator"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ],
                "type": "JiraFormattingSingleValueOperand"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v8 /*: any*/ ,
                    {
                        "alias": "multipleValueOperator",
                        "kind": "ScalarField",
                        "name": "operator"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "values"
                    }
                ],
                "type": "JiraFormattingMultipleValueOperand"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v8 /*: any*/ ,
                    {
                        "alias": "noValueOperator",
                        "kind": "ScalarField",
                        "name": "operator"
                    }
                ],
                "type": "JiraFormattingNoValueOperand"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "formatRulesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v4 /*: any*/ ,
                                    "concreteType": "JiraFormattingRuleConnection",
                                    "kind": "LinkedField",
                                    "name": "conditionalFormattingRules",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFormattingRuleEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraFormattingRule",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraColor",
                                                            "kind": "LinkedField",
                                                            "name": "formattingColor",
                                                            "plural": false,
                                                            "selections": [
                                                                v6 /*: any*/ 
                                                            ]
                                                        },
                                                        v7 /*: any*/ ,
                                                        v9 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "formatRulesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v4 /*: any*/ ,
                                    "concreteType": "JiraFormattingRuleConnection",
                                    "kind": "LinkedField",
                                    "name": "conditionalFormattingRules",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFormattingRuleEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraFormattingRule",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraColor",
                                                            "kind": "LinkedField",
                                                            "name": "formattingColor",
                                                            "plural": false,
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                v5 /*: any*/ 
                                                            ]
                                                        },
                                                        v7 /*: any*/ ,
                                                        v9 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "19617cae23dba3619feb6b7d7006b077c3444a7b0f92752732863a7b7f39d16b",
            "metadata": {},
            "name": "formatRulesQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$653ec3882dd047d6$var$node.hash = "43fc879528441b68c4aa3cce2725ca49";
(0, $eiowN.PreloadableQueryRegistry).set($653ec3882dd047d6$var$node.params.id, $653ec3882dd047d6$var$node);
var $653ec3882dd047d6$export$2e2bcd8739ae039 = $653ec3882dd047d6$var$node;

});

parcelRegister("llMZa", function(module, exports) {

$parcel$export(module.exports, "formattingColors", () => $b066db4218a81ff1$export$2fedf4ac4eb04087);
$parcel$export(module.exports, "getColorKeyFromValue", () => $b066db4218a81ff1$export$ae7e938b8bdf2df5);

var $8QpSo = parcelRequire("8QpSo");

var $deuYz = parcelRequire("deuYz");
const $b066db4218a81ff1$export$2fedf4ac4eb04087 = {
    lightPurple: {
        label: (0, $deuYz.default).lightPurple,
        value: "var(--ds-background-accent-purple-subtlest, #F3F0FF)",
        hoverValue: "var(--ds-background-accent-purple-subtlest-hovered, #DFD8FD)"
    },
    lightBlue: {
        label: (0, $deuYz.default).lightBlue,
        value: "var(--ds-background-accent-blue-subtlest, #E9F2FF)",
        hoverValue: "var(--ds-background-accent-blue-subtlest-hovered, #CCE0FF)"
    },
    lightGreen: {
        label: (0, $deuYz.default).lightGreen,
        value: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
        hoverValue: "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)"
    },
    lightTeal: {
        label: (0, $deuYz.default).lightTeal,
        value: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
        hoverValue: "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)"
    },
    lightYellow: {
        label: (0, $deuYz.default).lightYellow,
        value: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
        hoverValue: "var(--ds-background-accent-yellow-subtlest-hovered, #F8E6A0)"
    },
    lightRed: {
        label: (0, $deuYz.default).lightRed,
        value: "var(--ds-background-accent-red-subtlest, #FFECEB)",
        hoverValue: "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)"
    },
    lightGray: {
        label: (0, $deuYz.default).lightGray,
        value: "var(--ds-background-accent-gray-subtlest, #F1F2F4)",
        hoverValue: "var(--ds-background-accent-gray-subtlest-hovered, #DCDFE4)"
    },
    purple: {
        label: (0, $deuYz.default).purple,
        value: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
        hoverValue: "var(--ds-background-accent-purple-subtler-hovered, #B8ACF6)"
    },
    blue: {
        label: (0, $deuYz.default).blue,
        value: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
        hoverValue: "var(--ds-background-accent-blue-subtler-hovered, #85B8FF)"
    },
    green: {
        label: (0, $deuYz.default).green,
        value: "var(--ds-background-accent-green-subtler, #BAF3DB)",
        hoverValue: "var(--ds-background-accent-green-subtler-hovered, #7EE2B8)"
    },
    teal: {
        label: (0, $deuYz.default).teal,
        value: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        hoverValue: "var(--ds-background-accent-teal-subtler-hovered, #9DD9EE)"
    },
    yellow: {
        label: (0, $deuYz.default).yellow,
        value: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
        hoverValue: "var(--ds-background-accent-yellow-subtler-hovered, #F5CD47)"
    },
    red: {
        label: (0, $deuYz.default).red,
        value: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        hoverValue: "var(--ds-background-accent-red-subtler-hovered, #FD9891)"
    },
    gray: {
        label: (0, $deuYz.default).gray,
        value: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        hoverValue: "var(--ds-background-accent-gray-subtler-hovered, #B3B9C4)"
    }
};
const $b066db4218a81ff1$export$ae7e938b8bdf2df5 = (0, $8QpSo.default)((value)=>{
    const selectedColor = Object.entries($b066db4218a81ff1$export$2fedf4ac4eb04087).find(([_, color])=>color.value === value);
    return selectedColor?.[0];
});

});
parcelRegister("deuYz", function(module, exports) {

$parcel$export(module.exports, "default", () => $431e5d2eb706d069$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $431e5d2eb706d069$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    lightPurple: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.light-purple",
        "defaultMessage": "Subtle purple"
    },
    lightBlue: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.light-blue",
        "defaultMessage": "Subtle blue"
    },
    lightGreen: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.light-green",
        "defaultMessage": "Subtle green"
    },
    lightTeal: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.light-teal",
        "defaultMessage": "Subtle teal"
    },
    lightYellow: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.light-yellow",
        "defaultMessage": "Subtle yellow"
    },
    lightRed: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.light-red",
        "defaultMessage": "Subtle red"
    },
    lightGray: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.light-gray",
        "defaultMessage": "Subtle gray"
    },
    purple: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.purple",
        "defaultMessage": "Bold purple"
    },
    blue: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.blue",
        "defaultMessage": "Bold blue"
    },
    green: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.green",
        "defaultMessage": "Bold green"
    },
    teal: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.teal",
        "defaultMessage": "Bold teal"
    },
    yellow: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.yellow",
        "defaultMessage": "Bold yellow"
    },
    red: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.red",
        "defaultMessage": "Bold red"
    },
    gray: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.gray",
        "defaultMessage": "Bold gray"
    }
});

});



parcelRegister("e21nk", function(module, exports) {

$parcel$export(module.exports, "BusinessDocumentTitle", () => $aa5670652f17dfc4$export$416064ba09d98e69);

var $5uXOq = parcelRequire("5uXOq");

var $id7K0 = parcelRequire("id7K0");

var $54qG5 = parcelRequire("54qG5");
const $aa5670652f17dfc4$export$416064ba09d98e69 = /*#__PURE__*/ (0, $5uXOq.memo)(({ pageHeading: pageHeading })=>{
    const { data: entity } = (0, $54qG5.useBusinessEntity)();
    const documentTitle = entity?.name ? `${pageHeading} - ${entity.name}` : pageHeading;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $id7K0.DocumentTitle), {
        title: documentTitle
    });
});

});
parcelRegister("id7K0", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $938046587fdeeb52$export$dd5ad0b65cf665da);

var $5uXOq = parcelRequire("5uXOq");

var $cSD7y = parcelRequire("cSD7y");

var $4CAXd = parcelRequire("4CAXd");
// eslint-disable-next-line jira/react/no-class-components
class $938046587fdeeb52$var$DocumentTitleOld extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $4CAXd.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber = (0, $4CAXd.DocumentTitleSubscriber) } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CAXd.DocumentTitleHelperOld), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}
const $938046587fdeeb52$export$dd5ad0b65cf665da = (0, $cSD7y.componentWithFG)('jira-concurrent-document-title', (0, $4CAXd.DocumentTitleHelper), $938046587fdeeb52$var$DocumentTitleOld);

});


parcelRegister("exeAk", function(module, exports) {

$parcel$export(module.exports, "PrefetchIssueDataController", () => $77c62695b59f030f$export$1e95fb877713bf5e);

var $5uXOq = parcelRequire("5uXOq");

var $hE5wF = parcelRequire("hE5wF");

var $1XJ20 = parcelRequire("1XJ20");

var $ieDtd = parcelRequire("ieDtd");

var $1JH9w = parcelRequire("1JH9w");

var $l1hWj = parcelRequire("l1hWj");
const $77c62695b59f030f$var$IssueDataLoader = /*#__PURE__*/ (0, $5uXOq.memo)(({ issues: issues })=>issues.map((issueKey)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1hWj.AsyncIssueViewCriticalDataLoader), {
            key: issueKey,
            issueKey: issueKey
        })));
const $77c62695b59f030f$export$1e95fb877713bf5e = ()=>{
    const { prefetchedIssues: prefetchedIssues } = (0, $1JH9w.usePrefetchIssueViewData)();
    const { clearCache: clearCache } = (0, $1JH9w.usePrefetchIssueViewDataActions)();
    const [selectedIssueKey] = (0, $ieDtd.useQueryParam)((0, $hE5wF.SELECTED_ISSUE_PARAM));
    const prevSelectedIssueKey = (0, $1XJ20.usePreviousWithInitial)(selectedIssueKey);
    (0, $5uXOq.useEffect)(()=>{
        const isIssueAppClosed = prevSelectedIssueKey && !selectedIssueKey;
        const isIssueKeyUpdated = selectedIssueKey && prevSelectedIssueKey && selectedIssueKey !== prevSelectedIssueKey;
        // clear cache when user closes Issue modal or opens another issue without closing it (ie via breadcrumbs)
        if (isIssueAppClosed || isIssueKeyUpdated) clearCache();
    }, [
        clearCache,
        prevSelectedIssueKey,
        selectedIssueKey
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            // clear cache on unmount
            clearCache();
        }, [
        clearCache
    ]);
    const issues = (0, $5uXOq.useMemo)(()=>Object.keys(prefetchedIssues), [
        prefetchedIssues
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($77c62695b59f030f$var$IssueDataLoader, {
        issues: issues
    });
};

});
parcelRegister("1JH9w", function(module, exports) {

$parcel$export(module.exports, "usePrefetchIssueViewData", () => $a3ad7c51df3f2dbe$export$519e056a921d9691);
$parcel$export(module.exports, "usePrefetchIssueViewDataActions", () => $a3ad7c51df3f2dbe$export$fee97ccc4dadacbb);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
/**
 * The minimum allowed time between two consecutive issue data prefetches.
 */ const $a3ad7c51df3f2dbe$var$ALLOWED_TIME_BETWEEN_PREFETCHES = 500;
const $a3ad7c51df3f2dbe$var$MAX_DELAY = 300;
const $a3ad7c51df3f2dbe$var$MIN_DELAY = 0;
const $a3ad7c51df3f2dbe$export$a87749ac92873cf7 = ()=>100;
const $a3ad7c51df3f2dbe$var$actions = {
    // prefetches issue view data on hover
    prefetchIssue: (issueKey)=>({ getState: getState, setState: setState })=>{
            const { timestampOfTheLastPrefetch: timestampOfTheLastPrefetch, prefetchedIssues: prefetchedIssues } = getState();
            const currentTimestamp = Date.now();
            const delay = timestampOfTheLastPrefetch !== null && currentTimestamp - timestampOfTheLastPrefetch < $a3ad7c51df3f2dbe$var$ALLOWED_TIME_BETWEEN_PREFETCHES ? $a3ad7c51df3f2dbe$var$MAX_DELAY : $a3ad7c51df3f2dbe$var$MIN_DELAY;
            // clear cache if it exceeds the limit so that it doesn't grow indefinitely
            const nextPrefetchedIssues = Object.keys(prefetchedIssues).length === $a3ad7c51df3f2dbe$export$a87749ac92873cf7() ? {} : prefetchedIssues;
            setState({
                // prefetch the issue only if the time from the last prefetch is greater than ALLOWED_TIME_BETWEEN_PREFETCHES
                prefetchedIssues: delay === $a3ad7c51df3f2dbe$var$MIN_DELAY && !prefetchedIssues[issueKey] ? {
                    ...nextPrefetchedIssues,
                    [issueKey]: true
                } : prefetchedIssues,
                timestampOfTheLastPrefetch: currentTimestamp
            });
        },
    // clears cached issues (ie on view unmount)
    clearCache: ()=>({ setState: setState })=>{
            setState({
                timestampOfTheLastPrefetch: null,
                prefetchedIssues: {}
            });
        }
};
const $a3ad7c51df3f2dbe$var$PrefetchIssueViewStore = (0, $iXqE5.createStore)({
    initialState: {
        timestampOfTheLastPrefetch: null,
        prefetchedIssues: {}
    },
    actions: $a3ad7c51df3f2dbe$var$actions,
    name: 'JWMPrefetchIssueViewStore'
});
const $a3ad7c51df3f2dbe$export$519e056a921d9691 = (0, $3sQ5x.createStateHook)($a3ad7c51df3f2dbe$var$PrefetchIssueViewStore);
const $a3ad7c51df3f2dbe$export$fee97ccc4dadacbb = (0, $3sQ5x.createActionsHook)($a3ad7c51df3f2dbe$var$PrefetchIssueViewStore);

});

parcelRegister("l1hWj", function(module, exports) {

$parcel$export(module.exports, "AsyncIssueViewCriticalDataLoader", () => $4e841b6ce3a4317a$export$15a49d6c068f7356);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $bNCEz = parcelRequire("bNCEz");
const $4e841b6ce3a4317a$var$entryPointParams = {};
const $4e841b6ce3a4317a$export$15a49d6c068f7356 = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $bNCEz.asyncIssueViewCriticalDataLoaderEntrypoint), $4e841b6ce3a4317a$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jwm-issue-view-critical-data-loader",
        packageName: "jiraBusinessIssueViewCriticalDataLoader",
        runtimeProps: props
    });
});

});
parcelRegister("bNCEz", function(module, exports) {

$parcel$export(module.exports, "asyncIssueViewCriticalDataLoaderEntrypoint", () => $4dc1e3141aa0750a$export$6254258f84be452a);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $4dc1e3141aa0750a$export$6254258f84be452a = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("aWUUG")), {
        moduleId: "1f53773a"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("aWUUG", function(module, exports) {

let $7f8b77f12e8bf0cf$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7f8b77f12e8bf0cf$var$load("fLUhh").then(()=>parcelRequire('5h1fq'));

});




parcelRegister("ltZxv", function(module, exports) {

$parcel$export(module.exports, "useIssueModalActions", () => $938b6b6c79d6d36e$export$6f3a65eba75c0ec1);

var $5uXOq = parcelRequire("5uXOq");

var $hE5wF = parcelRequire("hE5wF");

var $l0oHX = parcelRequire("l0oHX");

var $ieDtd = parcelRequire("ieDtd");
const $938b6b6c79d6d36e$var$alwaysTrue = ()=>true;
const $938b6b6c79d6d36e$export$6f3a65eba75c0ec1 = ({ onBeforeOpened: onBeforeOpened, filterIssue: filterIssue = $938b6b6c79d6d36e$var$alwaysTrue } = {})=>{
    const [_, setSelectedIssueKey] = (0, $ieDtd.useQueryParam)((0, $hE5wF.SELECTED_ISSUE_PARAM));
    const createOpenIssueModalHandler = (0, $5uXOq.useCallback)((issue)=>(event)=>{
            if (filterIssue(issue)) {
                if (!(0, $l0oHX.isModifiedEvent)(event)) {
                    onBeforeOpened && onBeforeOpened(event);
                    setSelectedIssueKey(issue.key);
                    event.preventDefault();
                    event.stopPropagation();
                }
            }
        }, [
        filterIssue,
        onBeforeOpened,
        setSelectedIssueKey
    ]);
    return {
        createOpenIssueModalHandler: createOpenIssueModalHandler
    };
};

});

parcelRegister("3kVj2", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9988a92625a64f1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $bUSNl = parcelRequire("bUSNl");

var $hE5wF = parcelRequire("hE5wF");


var $2gCtH = parcelRequire("2gCtH");

var $gjEtj = parcelRequire("gjEtj");

var $lfTZh = parcelRequire("lfTZh");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $l8ruj = parcelRequire("l8ruj");

var $kxZPA = parcelRequire("kxZPA");

var $ieDtd = parcelRequire("ieDtd");

const $e9988a92625a64f1$export$843a6e93936e3b60 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("lV0c3")), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/modal-issue-app.tsx"
});
const $e9988a92625a64f1$var$ModalIssueAppWrapper = ({ issueKey: issueKey, onClose: onClose, onChange: onChange, onDeleteSuccess: onDeleteSuccess, analyticsSource: analyticsSource = (0, $fcf97b7a09088940$export$82540942fb014b0a), viewModeSwitchDisabled: viewModeSwitchDisabled, isSoftwareProject: isSoftwareProject })=>{
    const [, setSelectedIssue] = (0, $ieDtd.useQueryParam)((0, $hE5wF.SELECTED_ISSUE_PARAM));
    const onIssueKeyChange = (0, $5uXOq.useCallback)(({ toIssueKey: toIssueKey })=>setSelectedIssue(toIssueKey), [
        setSelectedIssue
    ]);
    const [, { setSidebarContent: setSidebarContent }] = (0, $bUSNl.useSidebar)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [, { setDetailViewAsSidebar: setDetailViewAsSidebar, setDetailViewAsModal: setDetailViewAsModal }] = (0, $2gCtH.useIssueContextActions)();
    const onSwitchToModal = (0, $5uXOq.useCallback)(()=>{
        setDetailViewAsModal();
        setSidebarContent(null);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'issueAppMenuItem clicked', 'switchToModal');
    }, [
        createAnalyticsEvent,
        setDetailViewAsModal,
        setSidebarContent
    ]);
    const onSwitchToSidebar = (0, $5uXOq.useCallback)(()=>{
        setSidebarContent(null);
        setDetailViewAsSidebar();
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'issueAppMenuItem clicked', 'switchToSidebar');
    }, [
        createAnalyticsEvent,
        setDetailViewAsSidebar,
        setSidebarContent
    ]);
    const viewModeOptions = (0, $5uXOq.useMemo)(()=>!viewModeSwitchDisabled ? {
            viewModeSwitchEnabled: true,
            onSwitchToModal: onSwitchToModal,
            onSwitchToSidebar: onSwitchToSidebar
        } : undefined, [
        onSwitchToModal,
        onSwitchToSidebar,
        viewModeSwitchDisabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "business-modal-issue-app"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: isSoftwareProject ? 'jswModalIssueApp' : 'jwmModalIssueApp'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjEtj.ModalBoundary), {
        packageName: isSoftwareProject ? 'software' : 'business',
        id: "issue-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "modal-issue-app",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e9988a92625a64f1$export$843a6e93936e3b60, {
        analyticsSource: analyticsSource,
        issueKey: issueKey,
        onClose: onClose,
        onChange: onChange,
        onIssueDeleteSuccess: onDeleteSuccess,
        onIssueKeyChange: onIssueKeyChange,
        viewModeOptions: viewModeOptions
    })))));
};
var $e9988a92625a64f1$export$2e2bcd8739ae039 = $e9988a92625a64f1$var$ModalIssueAppWrapper;

});
const $fcf97b7a09088940$export$53d41ff2666118e1 = 'agility-backlog';
const $fcf97b7a09088940$export$7552fe2669628499 = 'bitbucket-issue';
const $fcf97b7a09088940$export$41a718da0a8636f4 = 'connect-issue';
const $fcf97b7a09088940$export$cebf0bc8b2ccaf57 = 'core-issue';
const $fcf97b7a09088940$export$5e91e17726e54450 = 'jiraCalendar';
const $fcf97b7a09088940$export$2dac1950892123f5 = 'jiraTimeline';
const $fcf97b7a09088940$export$82540942fb014b0a = 'business-calendar';
const $fcf97b7a09088940$export$7ca28938a07e0c33 = 'business-list';
const $fcf97b7a09088940$export$f6cf06aaaeb58a54 = 'business-timeline';
const $fcf97b7a09088940$export$b2c0462ff17aa26e = 'business-board';
const $fcf97b7a09088940$export$a607850ebccd28ac = 'business-approvals';
const $fcf97b7a09088940$export$1da6cede3561048f = 'business-files';
const $fcf97b7a09088940$export$b19f949fb9713614 = 'full-issue';
const $fcf97b7a09088940$export$a5132300c5214280 = 'embed-issue';
const $fcf97b7a09088940$export$710114090a811b37 = 'global-issue-navigator-issue';
const $fcf97b7a09088940$export$ce88447986394f2d = 'mobile-issue';
const $fcf97b7a09088940$export$6a90d9196d330040 = 'project-issue-navigator';
const $fcf97b7a09088940$export$2247c9059c171db1 = 'roadmap-issue';
const $fcf97b7a09088940$export$cd16d39c55c569d0 = 'simple-software-board';
const $fcf97b7a09088940$export$f72626bf0d75dfad = 'software-backlog-issue';
const $fcf97b7a09088940$export$778b4609e784cb27 = 'software-deployments-issue';
const $fcf97b7a09088940$export$5b73d694a6048002 = 'version-detail-issue';
const $fcf97b7a09088940$export$accce97178e4e049 = 'software-cycle-time-report-issue';
const $fcf97b7a09088940$export$21b5b7189add7861 = 'software-incidents-issue';
const $fcf97b7a09088940$export$9c5d81b901471b27 = 'software-issue';
const $fcf97b7a09088940$export$1735f6ad917dc411 = 'change-calendar';
const $fcf97b7a09088940$export$7063ee6d0035a982 = 'queues-issue-view';
const $fcf97b7a09088940$export$5bd5011b6596a0e7 = 'reports-issue-view';
const $fcf97b7a09088940$export$9dfa9e993d3e0520 = 'forge-full-page-extension';
const $fcf97b7a09088940$export$14a8072f422804fd = 'issue-navigator-next';
const $fcf97b7a09088940$export$5f3c20fe2ff6c0a2 = 'staffing-issue';

parcelRegister("lV0c3", function(module, exports) {

let $ff4f124285f4d7ca$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $ff4f124285f4d7ca$var$load("ffQaD"),
    $ff4f124285f4d7ca$var$load("kvRbA"),
    $ff4f124285f4d7ca$var$load("3yAl4"),
    $ff4f124285f4d7ca$var$load("kNFvF"),
    $ff4f124285f4d7ca$var$load("bWP0X")
]).then(()=>parcelRequire('2555l'));

});


parcelRegister("ksKCJ", function(module, exports) {

$parcel$export(module.exports, "SidebarIssueView", () => $15a07712b759f270$export$ccdf533f42a8d6f8);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bUSNl = parcelRequire("bUSNl");

var $2xJgT = parcelRequire("2xJgT");

var $1XJ20 = parcelRequire("1XJ20");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $g5X3G = parcelRequire("g5X3G");

var $cZ5o7 = parcelRequire("cZ5o7");

var $2ax5r = parcelRequire("2ax5r");
const $15a07712b759f270$var$ISSUE_VIEW_SIDEBAR_CONTENT_KEY = 'issueViewSidebar';
const $15a07712b759f270$export$ccdf533f42a8d6f8 = /*#__PURE__*/ (0, $5uXOq.memo)(({ issueKey: issueKey, onClose: onClose, analyticsSource: analyticsSource, onChange: onChange, onIssueDeleteSuccess: onIssueDeleteSuccess, isSoftwareProject: isSoftwareProject })=>{
    const [{ content: content }, { setSidebarContent: setSidebarContent }] = (0, $bUSNl.useSidebar)();
    const prevIssueKey = (0, $1XJ20.usePreviousWithInitial)(issueKey);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $2ax5r.useSetSidebarStyleVar)();
    const onCloseSidebar = (0, $5uXOq.useCallback)(()=>{
        onClose();
    }, [
        onClose
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // avoid re-rendering in case props aren't memoised
        if (issueKey === prevIssueKey && !!content) return;
        if (issueKey) {
            const newContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($15a07712b759f270$var$CSSAntiCorruptionLayer, {
                key: $15a07712b759f270$var$ISSUE_VIEW_SIDEBAR_CONTENT_KEY
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cZ5o7.SidebarIssueApp), {
                issueKey: (0, $g5X3G.toIssueKey)(issueKey),
                onClose: onCloseSidebar,
                analyticsSource: analyticsSource,
                onChange: onChange,
                onIssueDeleteSuccess: onIssueDeleteSuccess,
                isSoftwareProject: isSoftwareProject
            }));
            setSidebarContent(newContent);
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'sidebarIssueApp opened');
        } else {
            if (content?.key === $15a07712b759f270$var$ISSUE_VIEW_SIDEBAR_CONTENT_KEY) setSidebarContent(null);
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'sidebarIssueApp closed');
        }
    }, [
        analyticsSource,
        content,
        createAnalyticsEvent,
        isSoftwareProject,
        issueKey,
        onChange,
        onCloseSidebar,
        onIssueDeleteSuccess,
        prevIssueKey,
        setSidebarContent
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // Preload IssueApp here, otherwise it'd be loaded when Sidebar opens up for the first time, which is a bit slow
        (0, $2xJgT.callWhenIdle)(()=>{
            (0, $cZ5o7.IssueApp).preload();
        }, 3000);
    }, []);
    return null;
});
// put an extra div around issue view to "adopt" styles from `SidebarContent` (`> div`)
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $15a07712b759f270$var$CSSAntiCorruptionLayer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq _vchhusvi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2xJgT", function(module, exports) {

$parcel$export(module.exports, "callWhenIdle", () => $8c65c2dcde2b90c3$export$d2542992df1e054);
const $8c65c2dcde2b90c3$export$d2542992df1e054 = (callback, timeout = 200)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (typeof window.requestIdleCallback === 'function') {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const callbackId = window.requestIdleCallback(callback);
        return ()=>cancelIdleCallback(callbackId);
    }
    const timer = setTimeout(callback, timeout);
    return ()=>{
        clearTimeout(timer);
    };
};

});

parcelRegister("cZ5o7", function(module, exports) {

$parcel$export(module.exports, "IssueApp", () => $f0984329e6d3d9e6$export$35dd9ab573b87c3f);
$parcel$export(module.exports, "SidebarIssueApp", () => $f0984329e6d3d9e6$export$e402f7c18d4d7f37);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $bUSNl = parcelRequire("bUSNl");

var $2gCtH = parcelRequire("2gCtH");

var $7eqRV = parcelRequire("7eqRV");

var $lfTZh = parcelRequire("lfTZh");

var $1XJ20 = parcelRequire("1XJ20");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $lb0Dk = parcelRequire("lb0Dk");

var $l8ruj = parcelRequire("l8ruj");

var $kxZPA = parcelRequire("kxZPA");

const $f0984329e6d3d9e6$export$35dd9ab573b87c3f = (0, $kxZPA.lazy)(()=>(parcelRequire("6r0bl")), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
});
const $f0984329e6d3d9e6$export$e402f7c18d4d7f37 = ({ analyticsSource: analyticsSource, issueKey: issueKey, onClose: onClose, onIssueDeleteSuccess: onIssueDeleteSuccess, onChange: onChange, isSoftwareProject: isSoftwareProject })=>{
    const [currentIssueKey, setCurrentIssueKey] = (0, $5uXOq.useState)(issueKey);
    const prevIssueKey = (0, $1XJ20.usePreviousWithInitial)(issueKey);
    // @ts-expect-error - TS7031 - Binding element 'nextIssueKey' implicitly has an 'any' type.
    const onIssueKeyChange = (0, $5uXOq.useCallback)(({ toIssueKey: nextIssueKey })=>{
        setCurrentIssueKey(nextIssueKey);
    }, []);
    const [, { setDetailViewAsSidebar: setDetailViewAsSidebar, setDetailViewAsModal: setDetailViewAsModal }] = (0, $2gCtH.useIssueContextActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [, { setSidebarContent: setSidebarContent }] = (0, $bUSNl.useSidebar)();
    (0, $5uXOq.useEffect)(()=>{
        if (prevIssueKey !== issueKey) setCurrentIssueKey(issueKey);
    }, [
        currentIssueKey,
        issueKey,
        prevIssueKey
    ]);
    const onSwitchToModal = (0, $5uXOq.useCallback)(()=>{
        setDetailViewAsModal();
        setSidebarContent(null);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'issueAppMenuItem clicked', 'switchToModal');
    }, [
        createAnalyticsEvent,
        setDetailViewAsModal,
        setSidebarContent
    ]);
    const onSwitchToSidebar = (0, $5uXOq.useCallback)(()=>{
        setDetailViewAsSidebar();
        setSidebarContent(null);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'issueAppMenuItem clicked', 'switchToSidebar');
    }, [
        createAnalyticsEvent,
        setDetailViewAsSidebar,
        setSidebarContent
    ]);
    const PACKAGE_NAME = (0, $5uXOq.useMemo)(()=>isSoftwareProject ? 'jswSidebarIssueApp' : 'jwmSidebarIssueApp', [
        isSoftwareProject
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "business-sidebar-issue-app"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: PACKAGE_NAME
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-app",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lb0Dk.IssueViewSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7eqRV.IssueBoundary), {
        packageName: PACKAGE_NAME
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f0984329e6d3d9e6$export$35dd9ab573b87c3f, {
        viewModeOptions: {
            viewMode: 'SIDEBAR',
            viewModeSwitchEnabled: true,
            onSwitchToModal: onSwitchToModal,
            onSwitchToSidebar: onSwitchToSidebar
        },
        issueKey: currentIssueKey,
        analyticsSource: analyticsSource,
        shouldShowCloseButton: true,
        onClose: onClose,
        onIssueKeyChange: onIssueKeyChange,
        shouldSetInitialFocus: true,
        shouldShowRootProjectsBreadcrumb: true,
        onIssueDeleteSuccess: onIssueDeleteSuccess,
        onIssueDeleteFailure: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        isSpaEnabled: false,
        isLoadedWithPage: false,
        onChange: onChange
    })))));
};

});
parcelRegister("7eqRV", function(module, exports) {

$parcel$export(module.exports, "IssueBoundary", () => $e3c8771effba3477$export$fbf48ede0cf52b5a);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $gjEtj = parcelRequire("gjEtj");

var $lfTZh = parcelRequire("lfTZh");

var $lb0Dk = parcelRequire("lb0Dk");
const $e3c8771effba3477$export$fbf48ede0cf52b5a = ({ children: children, isEmbedView: isEmbedView = true, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "issue",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lb0Dk.IssueViewSkeleton), {
            isEmbedView: isEmbedView
        })
    }, children));
const $e3c8771effba3477$export$74d408982642a541 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjEtj.ModalBoundary), {
        id: "issue-modal",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-modal-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lb0Dk.IssueViewSkeleton), {
            isModalView: true
        })
    }, children));

});

parcelRegister("6r0bl", function(module, exports) {

let $4af567dadff2b991$var$load = (parcelRequire("28QjX"))(4);











module.exports = Promise.all([
    (parcelRequire("avM1e"))('redaction_onboarding_iv_llc', function() {
        return Promise.all([
            $4af567dadff2b991$var$load("czPin")
        ]);
    }, function() {
        return Promise.all([
            $4af567dadff2b991$var$load("iGvP4")
        ]);
    }),
    (parcelRequire("avM1e"))('magma-3467-iv-renderer-sync-small-nodes', function() {
        return Promise.all([
            $4af567dadff2b991$var$load("d5z58"),
            $4af567dadff2b991$var$load("kvRbA"),
            $4af567dadff2b991$var$load("ffQaD"),
            $4af567dadff2b991$var$load("l253H"),
            $4af567dadff2b991$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $4af567dadff2b991$var$load("f771T")
        ]);
    }),
    (parcelRequire("avM1e"))('magma-3467-iv-renderer-sync-card-nodes', function() {
        return Promise.all([
            $4af567dadff2b991$var$load("lh7CA"),
            $4af567dadff2b991$var$load("kNFvF"),
            $4af567dadff2b991$var$load("kvRbA"),
            $4af567dadff2b991$var$load("ffQaD"),
            $4af567dadff2b991$var$load("l253H"),
            $4af567dadff2b991$var$load("76n7a"),
            $4af567dadff2b991$var$load("fliVL")
        ]);
    }, function() {
        return Promise.all([
            $4af567dadff2b991$var$load("jrRVX")
        ]);
    }),
    (parcelRequire("avM1e"))('magma-3467-iv-renderer-sync-media-nodes', function() {
        return Promise.all([
            $4af567dadff2b991$var$load("gXEyJ"),
            $4af567dadff2b991$var$load("l253H"),
            $4af567dadff2b991$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $4af567dadff2b991$var$load("hy7ba")
        ]);
    }),
    (parcelRequire("avM1e"))('jira_amplitude_sr', function() {
        return Promise.all([
            $4af567dadff2b991$var$load("8EtZR"),
            $4af567dadff2b991$var$load("kVX56")
        ]);
    }, function() {
        return Promise.all([
            $4af567dadff2b991$var$load("6jOz3")
        ]);
    }),
    (parcelRequire("avM1e"))('details_loader_to_entrypoint_iv_llc_dev_panel', function() {
        return Promise.all([
            $4af567dadff2b991$var$load("84z1X")
        ]);
    }, function() {
        return Promise.all([]);
    }),
    (parcelRequire("avM1e"))('empanada_profilecard_trial_sync_trigger_import', function() {
        return Promise.all([
            $4af567dadff2b991$var$load("czifk"),
            $4af567dadff2b991$var$load("kvRbA"),
            $4af567dadff2b991$var$load("ffQaD")
        ]);
    }, function() {
        return Promise.all([
            $4af567dadff2b991$var$load("kcs34")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_team_profilecard_trial_sync_trigger', function() {
        return Promise.all([
            $4af567dadff2b991$var$load("cTJTG"),
            $4af567dadff2b991$var$load("l253H"),
            $4af567dadff2b991$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $4af567dadff2b991$var$load("4Qxp7")
        ]);
    }),
    (parcelRequire("avM1e"))('improve_issue_view_comment_ai', function() {
        return Promise.all([
            $4af567dadff2b991$var$load("egvYO")
        ]);
    }, function() {
        return Promise.all([
            $4af567dadff2b991$var$load("hkt2G")
        ]);
    }),
    (parcelRequire("avM1e"))('improve_rendering_child_issues_summary_bar', function() {
        return Promise.all([
            $4af567dadff2b991$var$load("juSGb"),
            $4af567dadff2b991$var$load("kvRbA"),
            $4af567dadff2b991$var$load("ffQaD")
        ]);
    }, function() {
        return Promise.all([
            $4af567dadff2b991$var$load("5FVQh"),
            $4af567dadff2b991$var$load("kvRbA"),
            $4af567dadff2b991$var$load("ffQaD")
        ]);
    }),
    (parcelRequire("avM1e"))('link_paste_recommendations', function() {
        return Promise.all([]);
    }, function() {
        return Promise.all([
            $4af567dadff2b991$var$load("7ClEP")
        ]);
    }),
    $4af567dadff2b991$var$load("3yAl4"),
    $4af567dadff2b991$var$load("fliVL"),
    $4af567dadff2b991$var$load("7mIf9"),
    $4af567dadff2b991$var$load("jXweD"),
    $4af567dadff2b991$var$load("jbxE1"),
    $4af567dadff2b991$var$load("7imUH"),
    $4af567dadff2b991$var$load("kVX56"),
    $4af567dadff2b991$var$load("kNFvF"),
    $4af567dadff2b991$var$load("ffQaD"),
    $4af567dadff2b991$var$load("kvRbA"),
    $4af567dadff2b991$var$load("76n7a"),
    $4af567dadff2b991$var$load("l253H"),
    $4af567dadff2b991$var$load("gaip1")
]).then(()=>parcelRequire('6qbjz'));

});
parcelRegister("avM1e", function(module, exports) {
"use strict";
module.exports = function(cond, ifTrue, ifFalse) {
    return globalThis.__MCOND && globalThis.__MCOND(cond) ? ifTrue() : ifFalse();
};

});



parcelRegister("2ax5r", function(module, exports) {

$parcel$export(module.exports, "useSetSidebarStyleVar", () => $f33586d1e0f68dde$export$70b20cd72362e39d);

var $5uXOq = parcelRequire("5uXOq");

var $bUSNl = parcelRequire("bUSNl");


var $5e5zm = parcelRequire("5e5zm");

var $jnA4H = parcelRequire("jnA4H");
const $f33586d1e0f68dde$var$MARGIN = 24;
const $f33586d1e0f68dde$export$70b20cd72362e39d = ()=>{
    const [store] = (0, $bUSNl.useSidebar)();
    const { content: content } = store;
    const sidebarWidth = (0, $jnA4H.getSidebarWidthFromStore)(store);
    const { setWidth: setWidth } = (0, $5e5zm.useDetailPanelActions)();
    (0, $5uXOq.useEffect)(()=>{
        if (content !== null) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.documentElement?.style.setProperty((0, $563deb1efef5771e$export$c83c5cba188418d8), `${sidebarWidth}px`);
            setWidth(sidebarWidth + $f33586d1e0f68dde$var$MARGIN);
        } else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.documentElement?.style.removeProperty((0, $563deb1efef5771e$export$c83c5cba188418d8));
        return ()=>{
            setWidth(0);
        };
    }, [
        content,
        setWidth,
        sidebarWidth
    ]);
};

});
const $563deb1efef5771e$export$c83c5cba188418d8 = '--detailPanelWidth';



parcelRegister("7Wnap", function(module, exports) {

$parcel$export(module.exports, "RenderStartMark", () => $4c177752bab6a832$export$2128f295d6adb861);
$parcel$export(module.exports, "PageLoadMetrics", () => $4c177752bab6a832$export$66b33c055cbb625e);

var $5uXOq = parcelRequire("5uXOq");

var $5rqex = parcelRequire("5rqex");


var $gN11a = parcelRequire("gN11a");
const $4c177752bab6a832$export$2128f295d6adb861 = ({ view: view, loading: loading })=>{
    if (loading === true) return null;
    (0, $gN11a.markViewMetric)(view, (0, $a286480ec63fa4c8$export$b78f0bbf209e5f4));
    return null;
};
const $4c177752bab6a832$export$66b33c055cbb625e = /*#__PURE__*/ (0, $5uXOq.memo)(({ view: view, attributes: attributes, product: product = 'jwm' })=>{
    // set UI_RENDER_END mark to indicate the end of UI render
    (0, $gN11a.markViewMetric)(view, (0, $a286480ec63fa4c8$export$88ea1e280513690f));
    const metric = (0, $gN11a.pageLoadMetrics)[view];
    return metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5rqex.default), {
        appName: `${product}.${view}`,
        metric: metric,
        extra: attributes
    });
});

});
parcelRegister("5rqex", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $ab527e70454bab7e$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $ab527e70454bab7e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $ab527e70454bab7e$export$9b3029ee6188a41f);

var $5uXOq = parcelRequire("5uXOq");

var $99gkn = parcelRequire("99gkn");

var $aOr3t = parcelRequire("aOr3t");

var $1u4q7 = parcelRequire("1u4q7");

var $1AZST = parcelRequire("1AZST");

var $6G6w0 = parcelRequire("6G6w0");

var $3wLoG = parcelRequire("3wLoG");

var $gtdbK = parcelRequire("gtdbK");

var $zbAs4 = parcelRequire("zbAs4");

var $3B7oW = parcelRequire("3B7oW");
const $ab527e70454bab7e$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $ab527e70454bab7e$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        $ab527e70454bab7e$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $1AZST.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $zbAs4.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $gtdbK.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $3B7oW.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $99gkn.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aOr3t.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3wLoG.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $1u4q7.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6G6w0.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame
        }));
    }
}
const $ab527e70454bab7e$export$9b3029ee6188a41f = $ab527e70454bab7e$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("aOr3t", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $a3e67858f0c2f8da$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $a3e67858f0c2f8da$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $a3e67858f0c2f8da$export$d93d677ef2f33c5c);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");
function $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $a3e67858f0c2f8da$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $5uXOq.useContext)((0, $1tcYS.default));
    const interactionId = (0, $1u4q7.getInteractionId)().current;
    (0, $5uXOq.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $bFU4G.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $a3e67858f0c2f8da$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $1u4q7.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $bFU4G.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingsConfig);
        (0, $bFU4G.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("6G6w0", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $84d0d168ebb35c8a$export$575e93c0f9905999);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $21pfT = parcelRequire("21pfT");

var $x9xyg = parcelRequire("x9xyg");

var $7N30e = parcelRequire("7N30e");

var $4dRjY = parcelRequire("4dRjY");

var $2SVPM = parcelRequire("2SVPM");

var $6b6Tk = parcelRequire("6b6Tk");

const $84d0d168ebb35c8a$var$emitMetrics = (metric, customData, stopTime)=>{
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) metric.stop({
        customData: customData,
        stopTime: stopTime
    });
    else metric.stop({
        customData: customData
    });
    if ((0, $6b6Tk.isAutomaticExposureCollectionEnabled)()) (0, $7N30e.stopLowPriorityEventDelay)();
};
class $84d0d168ebb35c8a$export$575e93c0f9905999 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $21pfT.browserMetrics).getPageLoadMetric()?.getData()?.start || 0;
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_END');
        (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, $x9xyg.setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
                setTimeout(()=>{
                    $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                }, 500);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            $84d0d168ebb35c8a$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $1tcYS.default);
    }
    render() {
        return null;
    }
}

});
parcelRegister("4dRjY", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $9953c23a4f71adac$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $9953c23a4f71adac$export$2a999c5f84501025);

var $x9xyg = parcelRequire("x9xyg");
const $9953c23a4f71adac$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $9953c23a4f71adac$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($9953c23a4f71adac$export$8e54fca0a680fdfd);
        (0, $x9xyg.setMark)($9953c23a4f71adac$export$8e54fca0a680fdfd);
    }
    return null;
};

});

const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("3wLoG", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $bc9c50f4292c4530$export$d91154f099475c5);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $1AZST = parcelRequire("1AZST");
class $bc9c50f4292c4530$export$d91154f099475c5 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $1AZST.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $1AZST.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $1tcYS.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("gtdbK", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $9088c71f7c9189f4$export$bf239ac2bfb04967);

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");
function $9088c71f7c9189f4$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $bFU4G.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("zbAs4", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $30d390cd1767d57f$export$e63862cd888fe05a);

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");

var $1AZST = parcelRequire("1AZST");
var $49z18 = parcelRequire("49z18");
async function $30d390cd1767d57f$export$e63862cd888fe05a() {
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $1AZST.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $49z18.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $bFU4G.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("3B7oW", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $afa764d83f81f55e$export$f00f1e874ce869e9);

var $1u4q7 = parcelRequire("1u4q7");

var $y7eb2 = parcelRequire("y7eb2");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $afa764d83f81f55e$export$7b4abba432e57989 = (value)=>$afa764d83f81f55e$var$isString(value) && $afa764d83f81f55e$var$startsAsObject(value) || $afa764d83f81f55e$var$isObject(value);
const $afa764d83f81f55e$export$fcc03ee4c944962f = (featureFlagValue)=>$afa764d83f81f55e$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $afa764d83f81f55e$export$d2818866b4acbea4 = new Map();
const $afa764d83f81f55e$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $y7eb2.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $afa764d83f81f55e$export$fcc03ee4c944962f(value);
            $afa764d83f81f55e$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});



parcelRegister("7Q2kM", function(module, exports) {

$parcel$export(module.exports, "DevDetailsDialogLoaderAsync", () => $1e951f8230b07137$export$f5ffc0f323543e16);
$parcel$export(module.exports, "default", () => $1e951f8230b07137$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1e951f8230b07137$var$DevDetailDialogLoaderWithContainer = (0, $kxZPA.lazy)(()=>(parcelRequire("yNiJl")), {
    ssr: false,
    moduleId: "./src/packages/development/details-loader/src/ui/index-old.tsx"
});
const $1e951f8230b07137$export$f5ffc0f323543e16 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "dev-detail-dialog-loader-with-container",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1e951f8230b07137$var$DevDetailDialogLoaderWithContainer, props));
$1e951f8230b07137$export$f5ffc0f323543e16.defaultProps = {
    onCloseDevDetailDialog: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
var $1e951f8230b07137$export$2e2bcd8739ae039 = $1e951f8230b07137$export$f5ffc0f323543e16;

});
parcelRegister("yNiJl", function(module, exports) {

let $06896b433283881c$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $06896b433283881c$var$load("76n7a"),
    $06896b433283881c$var$load("l253H"),
    $06896b433283881c$var$load("drDbh")
]).then(()=>parcelRequire('26nI6'));

});


parcelRegister("e1OxR", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f3117b4e456671f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $b71gk = parcelRequire("b71gk");

var $7wK4b = parcelRequire("7wK4b");

var $bZLPe = parcelRequire("bZLPe");
const $0f3117b4e456671f$var$AddPeopleModal = ({ shouldUseInvitePeopleModal: shouldUseInvitePeopleModal, source: source })=>{
    const { isModalOpen: isModalOpen, closeAddPeopleModal: closeAddPeopleModal } = (0, $7wK4b.useAddPeople)();
    if (isModalOpen) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bZLPe.ProjectInvitePeopleModal), {
        onModalClose: closeAddPeopleModal,
        shouldUseInvitePeopleModal: shouldUseInvitePeopleModal,
        source: source
    });
    return null;
};
const $0f3117b4e456671f$var$AddPeople = ({ children: children, shouldUseInvitePeopleModal: shouldUseInvitePeopleModal, source: source })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7wK4b.AddPeopleProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "jira-business.invite-people.ui.add-people",
        packageName: "jira-business.invite-people.ui.add-people",
        teamName: "jira-warepil"
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0f3117b4e456671f$var$InviteWrapper, {
        "data-testid": "business-invite-people.ui.add-people-with-avatars.add-people.invite-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0f3117b4e456671f$var$AddPeopleModal, {
        shouldUseInvitePeopleModal: shouldUseInvitePeopleModal,
        source: source
    }))));
var $0f3117b4e456671f$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($0f3117b4e456671f$var$AddPeople);
// this wrapper prevents the modal component to inherit any css logic from its parent, which could cause interferences in the consumer's UI
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0f3117b4e456671f$var$InviteWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7wK4b", function(module, exports) {

$parcel$export(module.exports, "AddPeopleProvider", () => $3ebbf4ad1e53c7be$export$6d41c2327e862d9d);
$parcel$export(module.exports, "useAddPeople", () => $3ebbf4ad1e53c7be$export$93ea361ec674cff6);

var $5uXOq = parcelRequire("5uXOq");

var $daQYX = parcelRequire("daQYX");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $3ebbf4ad1e53c7be$var$AddPeopleContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    triggerBtnRef: {
        current: null
    },
    isModalOpen: false,
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    openAddPeopleModal: ()=>{},
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    closeAddPeopleModal: ()=>{}
});
const $3ebbf4ad1e53c7be$export$6d41c2327e862d9d = ({ children: children })=>{
    const projectData = (0, $daQYX.useProject)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isModalOpen, setIsModalOpen] = (0, $5uXOq.useState)(false);
    const triggerBtnRef = (0, $5uXOq.useRef)(null);
    const onCloseCallbackRef = (0, $5uXOq.useRef)();
    const openAddPeopleModal = (0, $5uXOq.useCallback)((onClose, source)=>{
        setIsModalOpen(true);
        const eventName = projectData.isSimplified ? 'jwmProjectInviteComponent' : 'jwmInstanceInviteComponent';
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', eventName, {
            source: source
        });
        if (onClose) onCloseCallbackRef.current = onClose;
    }, [
        createAnalyticsEvent,
        projectData.isSimplified
    ]);
    const closeAddPeopleModal = (0, $5uXOq.useCallback)(()=>{
        setIsModalOpen(false);
        if (typeof onCloseCallbackRef.current === 'function') {
            onCloseCallbackRef.current();
            onCloseCallbackRef.current = null;
        }
    }, []);
    const context = (0, $5uXOq.useMemo)(()=>({
            triggerBtnRef: triggerBtnRef,
            isModalOpen: isModalOpen,
            openAddPeopleModal: openAddPeopleModal,
            closeAddPeopleModal: closeAddPeopleModal
        }), [
        triggerBtnRef,
        isModalOpen,
        openAddPeopleModal,
        closeAddPeopleModal
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ebbf4ad1e53c7be$var$AddPeopleContext.Provider, {
        value: context
    }, children);
};
const $3ebbf4ad1e53c7be$export$93ea361ec674cff6 = ()=>(0, $5uXOq.useContext)($3ebbf4ad1e53c7be$var$AddPeopleContext);

});

parcelRegister("bZLPe", function(module, exports) {

$parcel$export(module.exports, "ProjectInvitePeopleModal", () => $74aeebd820c67267$export$6dfea89767cb5ac1);

var $5uXOq = parcelRequire("5uXOq");

var $daQYX = parcelRequire("daQYX");

var $2erM2 = parcelRequire("2erM2");

var $cb8cx = parcelRequire("cb8cx");

var $9AFuM = parcelRequire("9AFuM");
const $74aeebd820c67267$export$6dfea89767cb5ac1 = ({ onModalClose: onModalClose, shouldUseInvitePeopleModal: shouldUseInvitePeopleModal = false, source: source })=>{
    const projectData = (0, $daQYX.useProject)();
    const { handleAddSuccess: handleAddSuccess, handleError: handleError } = (0, $2erM2.useInviteModalHandlers)();
    if (!shouldUseInvitePeopleModal && projectData.isSimplified) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cb8cx.AddPeopleModal), {
        onModalClose: onModalClose,
        onInviteSuccess: handleAddSuccess,
        onInviteError: handleError
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9AFuM.InvitePeopleModal), {
        onModalClose: onModalClose,
        onInviteSuccess: handleAddSuccess,
        onInviteError: handleError,
        source: source
    });
};

});
parcelRegister("2erM2", function(module, exports) {

$parcel$export(module.exports, "useInviteModalHandlers", () => $d23a63b1c343bca5$export$f696e14fc423d0b);

var $5uXOq = parcelRequire("5uXOq");

var $daQYX = parcelRequire("daQYX");

var $jcw0u = parcelRequire("jcw0u");

var $pa9q9 = parcelRequire("pa9q9");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $9OXo1 = parcelRequire("9OXo1");


var $99ejj = parcelRequire("99ejj");

var $kPioc = parcelRequire("kPioc");
const $d23a63b1c343bca5$export$f696e14fc423d0b = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const { isSiteAdmin: isSiteAdmin } = (0, $9OXo1.useTenantContext)();
    const projectData = (0, $daQYX.useProject)();
    const handleAddSuccess = (0, $5uXOq.useCallback)(({ modalType: modalType, totalPeopleAdded: totalPeopleAdded, email: email, inviteStatus: inviteStatus })=>{
        const hasSentInvitation = inviteStatus === (0, $99ejj.InvitationStatusEnum).INVITED;
        const hasSuccessfullyAddedPeople = !inviteStatus && projectData.permissions.administerProject;
        showFlag(hasSuccessfullyAddedPeople ? (0, $kPioc.createAddSuccessFlagConfig)({
            totalPeopleAdded: totalPeopleAdded,
            email: email,
            projectKey: projectData.key
        }) : (0, $kPioc.createInviteSuccessFlagConfig)({
            totalPeopleAdded: totalPeopleAdded,
            email: email,
            hasSentInvitation: hasSentInvitation
        }));
        // The event tracked by the Invite People SLOs
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), `jwm${modalType}Invite success`, {
            inviteStatus: inviteStatus
        });
    }, [
        createAnalyticsEvent,
        showFlag,
        projectData
    ]);
    const handleError = (0, $5uXOq.useCallback)(({ modalType: modalType, errorMessage: errorMessage, statusCode: statusCode })=>{
        if (errorMessage.includes((0, $20132b2015719a62$export$4e427f77b64bbbed)) || errorMessage.includes((0, $20132b2015719a62$export$20ef020abfaa9ec))) {
            showFlag((0, $kPioc.createInviteFailedUserLimitFlagConfig)(isSiteAdmin, createAnalyticsEvent));
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'userLimit reached', `jwm${modalType}Invite`);
            return;
        }
        if (errorMessage.includes((0, $20132b2015719a62$export$a1d765adf759361e))) showFlag((0, $kPioc.inviteFailBadRequestFlagConfig));
        else if (errorMessage.includes((0, $20132b2015719a62$export$c7f012c6e67c4217))) showFlag((0, $kPioc.inviteFailNetworkErrorFlagConfig));
        else if (errorMessage.includes((0, $20132b2015719a62$export$c8a538cf4ae41623)) || errorMessage.includes((0, $20132b2015719a62$export$9bbcbc11675c1278)) || errorMessage.includes((0, $20132b2015719a62$export$a51af3c30283d234))) showFlag((0, $kPioc.inviteFailGenericFlagConfig));
        else showFlag((0, $kPioc.inviteFailFlagConfig));
        const isClientError = statusCode && statusCode >= 400 && statusCode < 500;
        if (errorMessage.includes((0, $20132b2015719a62$export$14fb68f74ccc8b23)) || isClientError) return;
        (0, $jcw0u.default)({
            meta: {
                id: `jwm${modalType}Invite`,
                packageName: (0, $20132b2015719a62$export$b8b9d90f9e5bd72b),
                teamName: 'jira-warepil'
            },
            attributes: {
                message: errorMessage
            },
            error: new Error(errorMessage),
            sendToPrivacyUnsafeSplunk: true
        });
        // The event tracked by the Invite People SLOs
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), `jwm${modalType}Invite failed`);
    }, [
        createAnalyticsEvent,
        isSiteAdmin,
        showFlag
    ]);
    return {
        handleAddSuccess: handleAddSuccess,
        handleError: handleError
    };
};

});
const $20132b2015719a62$export$b8b9d90f9e5bd72b = 'jira-business.invite-people';
const $20132b2015719a62$export$a1d765adf759361e = 'Check your request, then give it another try.';
const $20132b2015719a62$export$c7f012c6e67c4217 = 'Check your network connection, then give it another try.';
const $20132b2015719a62$export$c8a538cf4ae41623 = 'AUTH_FAILED';
const $20132b2015719a62$export$9bbcbc11675c1278 = 'SERVER_ERROR';
const $20132b2015719a62$export$a51af3c30283d234 = 'USER_NOT_FOUND';
const $20132b2015719a62$export$4e427f77b64bbbed = 'LICENSE_LIMIT_REACHED';
const $20132b2015719a62$export$20ef020abfaa9ec = 'Licence Exceeded';
const $20132b2015719a62$export$14fb68f74ccc8b23 = 'Recaptcha validation failed';

parcelRegister("99ejj", function(module, exports) {

$parcel$export(module.exports, "InvitationStatusEnum", () => $e49e7d7763027049$export$2e0a7d2dc28c9a18);
const $e49e7d7763027049$export$2e0a7d2dc28c9a18 = {
    ACCESS_REQUESTED: 'ACCESS_REQUESTED',
    INVITED: 'INVITED'
};

});

parcelRegister("kPioc", function(module, exports) {

$parcel$export(module.exports, "inviteFailFlagConfig", () => $366128c003d2496b$export$95c6157ced8b3439);
$parcel$export(module.exports, "inviteFailGenericFlagConfig", () => $366128c003d2496b$export$1108ab4b8a5d8a7d);
$parcel$export(module.exports, "inviteFailBadRequestFlagConfig", () => $366128c003d2496b$export$7f2d6442eed4d708);
$parcel$export(module.exports, "inviteFailNetworkErrorFlagConfig", () => $366128c003d2496b$export$c3bdacfc2255a9ed);
$parcel$export(module.exports, "createInviteSuccessFlagConfig", () => $366128c003d2496b$export$d456881895c2a0b2);
$parcel$export(module.exports, "createAddSuccessFlagConfig", () => $366128c003d2496b$export$cca35dec2a083169);
$parcel$export(module.exports, "createInviteFailedUserLimitFlagConfig", () => $366128c003d2496b$export$251dc06b3962c565);

var $8zOmE = parcelRequire("8zOmE");

var $6OFcj = parcelRequire("6OFcj");
const $366128c003d2496b$export$8c9a09c293b933fb = ({ specificDescription: specificDescription, agnosticDescription: agnosticDescription, totalPeopleAdded: totalPeopleAdded, email: email })=>{
    if (totalPeopleAdded <= 0) return [
        agnosticDescription,
        {}
    ];
    return [
        specificDescription,
        {
            totalPeopleAddedMinusOne: totalPeopleAdded - 1,
            totalPeopleAdded: totalPeopleAdded,
            email: email
        }
    ];
};
const $366128c003d2496b$export$95c6157ced8b3439 = {
    type: 'error',
    title: (0, $6OFcj.default).inviteFailedMessageTitle,
    description: (0, $6OFcj.default).inviteFailedMessageDescription,
    actions: [
        {
            content: (0, $6OFcj.default).inviteFailedMessageCta,
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            onClick: ()=>window.open('/secure/ContactAdministrators!default.jspa', '_blank')
        }
    ],
    messageId: 'business-invite-people.controllers.modal-handlers.invite-fail-flag-config.error.error.invite-fail-flag-config',
    messageType: 'transactional'
};
const $366128c003d2496b$export$1108ab4b8a5d8a7d = {
    type: 'error',
    title: (0, $6OFcj.default).inviteFailedMessageTitle,
    description: (0, $6OFcj.default).inviteFailedGenericMessageDescription,
    messageId: 'business-invite-people.controllers.modal-handlers.invite-fail-generic-flag-config.error.error.invite-fail-generic-flag-config',
    messageType: 'transactional'
};
const $366128c003d2496b$export$7f2d6442eed4d708 = {
    type: 'error',
    title: (0, $6OFcj.default).inviteFailedMessageTitle,
    description: (0, $6OFcj.default).inviteFailedBadRequestMessageDescription,
    messageId: 'business-invite-people.controllers.modal-handlers.invite-fail-bad-request-flag-config.error.error.invite-fail-bad-request-flag-config',
    messageType: 'transactional'
};
const $366128c003d2496b$export$c3bdacfc2255a9ed = {
    type: 'error',
    title: (0, $6OFcj.default).inviteFailedMessageTitle,
    description: (0, $6OFcj.default).inviteFailedNetworkErrorMessageDescription,
    messageId: 'business-invite-people.controllers.modal-handlers.invite-fail-network-error-flag-config.error.error.invite-fail-network-error-flag-config',
    messageType: 'transactional'
};
const $366128c003d2496b$export$d456881895c2a0b2 = ({ totalPeopleAdded: totalPeopleAdded, email: email, hasSentInvitation: hasSentInvitation })=>{
    if (!hasSentInvitation) return {
        type: 'success',
        title: (0, $6OFcj.default).requestInviteSuccessMessageTitle,
        description: $366128c003d2496b$export$8c9a09c293b933fb({
            agnosticDescription: (0, $6OFcj.default).requestInviteSuccessMessageDescriptionAgnostic,
            specificDescription: (0, $6OFcj.default).requestInviteSuccessMessageDescription,
            totalPeopleAdded: totalPeopleAdded,
            email: email
        }),
        messageId: 'business-invite-people.controllers.modal-handlers.flag.success.success.request-invite-success',
        messageType: 'transactional'
    };
    return {
        type: 'success',
        title: (0, $6OFcj.default).inviteSuccessMessageTitle,
        description: $366128c003d2496b$export$8c9a09c293b933fb({
            agnosticDescription: (0, $6OFcj.default).inviteSuccessMessageDescriptionAgnostic,
            specificDescription: (0, $6OFcj.default).inviteSuccessMessageDescription,
            totalPeopleAdded: totalPeopleAdded,
            email: email
        }),
        messageId: 'business-invite-people.controllers.modal-handlers.flag.success.success.invite-success',
        messageType: 'transactional'
    };
};
const $366128c003d2496b$export$cca35dec2a083169 = ({ totalPeopleAdded: totalPeopleAdded, email: email, projectKey: projectKey })=>({
        type: 'success',
        title: (0, $6OFcj.default).peopleAddedSuccessMessageTitle,
        description: $366128c003d2496b$export$8c9a09c293b933fb({
            agnosticDescription: (0, $6OFcj.default).peopleAddedSuccessMessageDescriptionAgnostic,
            specificDescription: (0, $6OFcj.default).peopleAddedSuccessMessageDescription,
            totalPeopleAdded: totalPeopleAdded,
            email: email
        }),
        actions: [
            {
                content: (0, $6OFcj.default).peopleAddedManageAccess,
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                onClick: ()=>window.location.assign(`/jira/core/projects/${projectKey}/settings/access`)
            }
        ],
        messageId: 'business-invite-people.controllers.modal-handlers.flag.success.success.people-added-success',
        messageType: 'transactional'
    });
const $366128c003d2496b$export$251dc06b3962c565 = (isSiteAdmin, createAnalyticsEvent)=>({
        type: 'warning',
        title: (0, $6OFcj.default).userLimitInviteErrorTitle,
        description: isSiteAdmin ? (0, $6OFcj.default).userLimitInviteErrorDescriptionAdmin : (0, $6OFcj.default).userLimitInviteErrorDescription,
        actions: isSiteAdmin ? [
            {
                content: (0, $6OFcj.default).upgradePlan,
                onClick: ()=>{
                    (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'upgradePlan');
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    window.open('/admin/billing/applications', '_blank');
                }
            },
            {
                content: (0, $6OFcj.default).viewUsers,
                onClick: ()=>{
                    (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'viewUsers');
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    window.open('/admin/users', '_blank');
                }
            }
        ] : [
            {
                content: (0, $6OFcj.default).inviteFailedMessageCta,
                onClick: ()=>{
                    (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'contactAdmin');
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    window.open('/secure/ContactAdministrators!default.jspa', '_blank');
                }
            }
        ],
        messageId: 'business-invite-people.controllers.modal-handlers.flag.warning.warning.user-limit-invite',
        messageType: 'transactional'
    });

});
parcelRegister("6OFcj", function(module, exports) {

$parcel$export(module.exports, "default", () => $d87007b6d35f6d31$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d87007b6d35f6d31$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    inviteSuccessMessageTitle: {
        "id": "business-invite-people.controllers.modal-handlers.invite-success-message-title",
        "defaultMessage": "Invitation sent"
    },
    inviteSuccessMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.invite-success-message-description",
        "defaultMessage": "You've invited {totalPeopleAdded, plural, one {{email}} =2 {{email} and {totalPeopleAddedMinusOne} other} other {{email} and {totalPeopleAddedMinusOne} others}} to this business project."
    },
    inviteSuccessMessageDescriptionAgnostic: {
        "id": "business-invite-people.controllers.modal-handlers.invite-success-message-description-agnostic",
        "defaultMessage": "You've successfully invited people to your business project."
    },
    inviteFailedMessageTitle: {
        "id": "business-invite-people.controllers.modal-handlers.invite-failed-message-title",
        "defaultMessage": "Something went wrong"
    },
    inviteFailedMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.invite-failed-message-description",
        "defaultMessage": "We weren\u2019t able to invite any users. Contact your admin for help."
    },
    inviteFailedMessageCta: {
        "id": "business-invite-people.controllers.modal-handlers.invite-failed-message-cta",
        "defaultMessage": "Contact your admin"
    },
    inviteFailedGenericMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.invite-failed-generic-message-description",
        "defaultMessage": "We weren\u2019t able to invite any users, please try again."
    },
    inviteFailedBadRequestMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.invite-failed-bad-request-message-description",
        "defaultMessage": "We weren\u2019t able to invite any users. Check your request, then give it another try."
    },
    inviteFailedNetworkErrorMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.invite-failed-network-error-message-description",
        "defaultMessage": "We weren\u2019t able to invite any users. Check your network connection, then give it another try."
    },
    requestInviteSuccessMessageTitle: {
        "id": "business-invite-people.controllers.modal-handlers.request-invite-success-message-title",
        "defaultMessage": "Access request sent to your admin"
    },
    requestInviteSuccessMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.request-invite-success-message-description",
        "defaultMessage": "Your admin needs to approve access for {totalPeopleAdded, plural, one {{email}} =2 {{email} and {totalPeopleAddedMinusOne} other} other {{email} and {totalPeopleAddedMinusOne} others}}."
    },
    requestInviteSuccessMessageDescriptionAgnostic: {
        "id": "business-invite-people.controllers.modal-handlers.request-invite-success-message-description-agnostic",
        "defaultMessage": "Your admin needs to approve access for people to your business project."
    },
    peopleAddedSuccessMessageTitle: {
        "id": "business-invite-people.controllers.modal-handlers.people-added-success-message-title",
        "defaultMessage": "New people added"
    },
    peopleAddedSuccessMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.people-added-success-message-description",
        "defaultMessage": "{totalPeopleAdded, plural, one {{email}} =2 {{email} and {totalPeopleAddedMinusOne} other} other {{email} and {totalPeopleAddedMinusOne} others}} added to the project. You can also add teammates and manage their access to the project from Project settings"
    },
    peopleAddedSuccessMessageDescriptionAgnostic: {
        "id": "business-invite-people.controllers.modal-handlers.people-added-success-message-description-agnostic",
        "defaultMessage": "People added to the project. You can also add teammates and manage their access to the project from Project settings"
    },
    peopleAddedManageAccess: {
        "id": "business-invite-people.controllers.modal-handlers.people-added-manage-access",
        "defaultMessage": "Manage access"
    },
    userLimitInviteErrorTitle: {
        "id": "business-invite-people.controllers.modal-handlers.user-limit-invite-error-title",
        "defaultMessage": "Can't add more people"
    },
    userLimitInviteErrorDescriptionAdmin: {
        "id": "business-invite-people.controllers.modal-handlers.user-limit-invite-error-description-admin",
        "defaultMessage": "You've reached your user limit. Upgrade your plan or remove other users."
    },
    userLimitInviteErrorDescription: {
        "id": "business-invite-people.controllers.modal-handlers.user-limit-invite-error-description",
        "defaultMessage": "You've reached your user limit. Contact your admin for help."
    },
    viewUsers: {
        "id": "business-invite-people.controllers.modal-handlers.view-users",
        "defaultMessage": "View users"
    },
    upgradePlan: {
        "id": "business-invite-people.controllers.modal-handlers.upgrade-plan",
        "defaultMessage": "Upgrade plan"
    }
});

});



parcelRegister("cb8cx", function(module, exports) {

$parcel$export(module.exports, "AddPeopleModal", () => $4afbb4a2961eae5f$export$b28f48897cdf7241);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $daQYX = parcelRequire("daQYX");

var $b71gk = parcelRequire("b71gk");

var $lfTZh = parcelRequire("lfTZh");

var $5oFIy = parcelRequire("5oFIy");

var $itmJb = parcelRequire("itmJb");

var $kxZPA = parcelRequire("kxZPA");

var $7wK4b = parcelRequire("7wK4b");


const $4afbb4a2961eae5f$export$a4917c848b5c6ce8 = (0, $kxZPA.lazy)(()=>(parcelRequire("jzGx5")), {
    ssr: false,
    moduleId: "./src/packages/permissions-administration/components/project-add-people/src/index.tsx"
});
const $4afbb4a2961eae5f$var$userInviteErrorCodes = {
    BAD_REQUEST_ERROR_CODE: $20132b2015719a62$export$a1d765adf759361e,
    NETWORK_ERROR_CODE: $20132b2015719a62$export$c7f012c6e67c4217,
    AUTH_FAILED_ERROR_CODE: $20132b2015719a62$export$c8a538cf4ae41623,
    SERVER_ERROR_ERROR_CODE: $20132b2015719a62$export$9bbcbc11675c1278,
    USER_NOT_FOUND_ERROR_CODE: $20132b2015719a62$export$a51af3c30283d234
};
const $4afbb4a2961eae5f$export$b28f48897cdf7241 = /*#__PURE__*/ (0, $5uXOq.memo)(({ onInviteSuccess: onInviteSuccess, onInviteError: onInviteError, onModalClose: onModalClose })=>{
    const { triggerBtnRef: triggerBtnRef } = (0, $7wK4b.useAddPeople)();
    const projectData = (0, $daQYX.useProject)();
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const handleInviteSuccess = (0, $5uXOq.useCallback)((addedParties, _role)=>{
        onInviteSuccess({
            totalPeopleAdded: addedParties.length,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            email: addedParties[0]?.email || addedParties[0]?.displayName,
            modalType: 'Project'
        });
    }, [
        onInviteSuccess
    ]);
    // From the given error message, we want to search for a known error code defined under the user invite endpoint
    // Otherwise, we return the whole message and use that as error code for mapping later on
    const extractErrorCode = (message)=>{
        // Typescript assumes Object.keys is of type string[] so need to type cast
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        for (const errorCode of Object.keys($4afbb4a2961eae5f$var$userInviteErrorCodes)){
            const errorMessage = $4afbb4a2961eae5f$var$userInviteErrorCodes[errorCode];
            if (message.includes(errorMessage)) return errorCode;
        }
        return message; // Return original message if no error code found
    };
    const handleInviteFailure = (0, $5uXOq.useCallback)((errors)=>{
        const userInviteErrorsWithCode = {};
        errors.forEach((error)=>{
            // Group all errors by known user invite error codes
            const errorCode = extractErrorCode(error.message);
            if (errorCode) {
                if (!userInviteErrorsWithCode[errorCode]) userInviteErrorsWithCode[errorCode] = [];
                userInviteErrorsWithCode[errorCode].push(error);
            }
        });
        // Join messages with the same error code
        const groupedUserInviteErrors = Object.values(userInviteErrorsWithCode).map((group)=>{
            const statusCode = group[0]?.statusCode; // Assuming all errors with same error code have the same status code
            const messages = group.map((obj)=>obj.message).join('\n');
            return {
                message: messages,
                statusCode: statusCode
            };
        });
        groupedUserInviteErrors.forEach((groupedUserInviteError)=>{
            onInviteError({
                modalType: 'Project',
                errorMessage: groupedUserInviteError.message,
                statusCode: groupedUserInviteError.statusCode
            });
        });
    }, [
        onInviteError
    ]);
    const { id: id, key: key } = projectData;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "async.jira-business.project-invite-people-modal.add-people",
        packageName: "jira-business.project-invite-people-modal.add-people",
        teamName: "jira-warepil"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireTrackAnalytics), {
        eventName: "jwmProjectInviteComponent viewed"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "add-people-modal-lazy",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4afbb4a2961eae5f$export$a4917c848b5c6ce8, {
        isOpen: true,
        triggerBtnRef: triggerBtnRef,
        onClose: onModalClose,
        onAddSuccess: handleInviteSuccess,
        onError: handleInviteFailure,
        projectId: id,
        projectKey: key,
        projectType: "business",
        isAdmin: isAdmin,
        analyticsPrefix: "",
        allowFlags: false,
        onStopPerfMetric: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    })));
});

});
parcelRegister("jzGx5", function(module, exports) {

let $e402474a8a96bcf2$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $e402474a8a96bcf2$var$load("ffQaD"),
    $e402474a8a96bcf2$var$load("kvRbA"),
    $e402474a8a96bcf2$var$load("76n7a"),
    $e402474a8a96bcf2$var$load("l253H"),
    $e402474a8a96bcf2$var$load("jJdCl")
]).then(()=>parcelRequire('jd2mv'));

});


parcelRegister("9AFuM", function(module, exports) {

$parcel$export(module.exports, "InvitePeopleModal", () => $5ae346fd9b1f20af$export$e3ec81c4d0451f63);

var $5uXOq = parcelRequire("5uXOq");

var $daQYX = parcelRequire("daQYX");

var $9fuVs = parcelRequire("9fuVs");

var $b71gk = parcelRequire("b71gk");

var $7NYq5 = parcelRequire("7NYq5");

var $lfTZh = parcelRequire("lfTZh");

var $6jY6G = parcelRequire("6jY6G");

var $5oFIy = parcelRequire("5oFIy");

var $12hlA = parcelRequire("12hlA");

var $14XJw = parcelRequire("14XJw");

var $efvDm = parcelRequire("efvDm");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");

var $koeKL = parcelRequire("koeKL");

var $itmJb = parcelRequire("itmJb");

var $kxZPA = parcelRequire("kxZPA");

var $99ejj = parcelRequire("99ejj");

const $5ae346fd9b1f20af$export$cbfde4f653ce234 = (0, $kxZPA.lazy)(()=>(parcelRequire("bJInk")), {
    ssr: false,
    moduleId: "../platform/packages/people-and-teams/invite-people/src/index.ts"
});
const $5ae346fd9b1f20af$export$4d2a63c83bbce998 = (res)=>{
    if (res.accessRequested?.length) return (0, $99ejj.InvitationStatusEnum).ACCESS_REQUESTED;
    return (0, $99ejj.InvitationStatusEnum).INVITED;
};
const $5ae346fd9b1f20af$var$LIST_ROUTES = [
    'software-list-classic',
    'software-list'
];
const $5ae346fd9b1f20af$var$isFailureResponse = (res)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    res.failure !== undefined;
const $5ae346fd9b1f20af$export$e3ec81c4d0451f63 = /*#__PURE__*/ (0, $5uXOq.memo)(({ onInviteSuccess: onInviteSuccess, onInviteError: onInviteError, onModalClose: onModalClose, source: source = 'projectBoard' })=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    const cloudId = (0, $koeKL.useCloudId)();
    const appEditions = (0, $k9JTq.useAppEditions)();
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const projectData = (0, $daQYX.useProject)();
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const onInviteCompleteHandler = (0, $5uXOq.useCallback)((response)=>{
        if ($5ae346fd9b1f20af$var$isFailureResponse(response)) {
            const { message: message, status: status } = response.failure;
            onInviteError({
                modalType: 'Instance',
                errorMessage: message,
                statusCode: status
            });
            return;
        }
        const inviteStatus = $5ae346fd9b1f20af$export$4d2a63c83bbce998(response);
        const { invited: invited, accessRequested: accessRequested } = response;
        onInviteSuccess({
            totalPeopleAdded: invited.length || accessRequested.length,
            email: invited[0]?.email || accessRequested[0]?.email || '',
            modalType: 'Instance',
            inviteStatus: inviteStatus
        });
    }, [
        onInviteError,
        onInviteSuccess
    ]);
    const isSoftwareRoute = (0, $5uXOq.useMemo)(()=>$5ae346fd9b1f20af$var$LIST_ROUTES.includes(route.name), [
        route
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "async.jira-business.project-invite-people-modal.invite-people",
        packageName: "jira-business.project-invite-people-modal.invite-people",
        teamName: "jira-warepil"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "project-invite-people-modal.invite-people",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
        messageId: "business-invite-people.ui.add-people-with-avatars.add-people.project-invite-people-modal.invite-people-modal.jira-modal",
        messageType: "transactional",
        onClose: onModalClose,
        width: "small",
        shouldScrollInViewport: true,
        testId: "business-invite-people.ui.add-people-with-avatars.add-people.project-invite-people-modal.invite-people-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireTrackAnalytics), {
        eventName: "jwmInstanceInviteComponent viewed"
    }), isSoftwareRoute ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $12hlA.default), {
        isOpen: true,
        cloudId: cloudId,
        projectId: projectData.id,
        jiraProjectKey: projectData.key,
        isSiteAdmin: isAdmin,
        onClose: onModalClose,
        appEdition: (0, $ldyPw.getEdition)((0, $efvDm.JIRA_SOFTWARE), appEditions),
        jiraProjectName: projectData.name
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5ae346fd9b1f20af$export$cbfde4f653ce234, {
        onSendHandler: onModalClose,
        onInviteCompletedHandler: onInviteCompleteHandler,
        onCancelHandler: onModalClose,
        resourceAri: `ari:cloud:jira::site/${cloudId}`,
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        continueUrl: window.location.href,
        enableThirdParty: true,
        source: source,
        orgId: orgId
    })))));
});

});
parcelRegister("12hlA", function(module, exports) {

$parcel$export(module.exports, "default", () => $0bc8c7c74346f034$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $0bc8c7c74346f034$var$LazyComponent = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("dc1Hs")), {
    ssr: false,
    moduleId: "./src/packages/project-settings/invite-people-modal-project/src/index.tsx"
});
const $0bc8c7c74346f034$export$6a02a79fa2b0ddab = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "async-project-invite-people-modal",
        packageName: "jira-project-invite-people-modal",
        teamName: "groot-growth"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "project-invite-people-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0bc8c7c74346f034$var$LazyComponent, props)));
var $0bc8c7c74346f034$export$2e2bcd8739ae039 = $0bc8c7c74346f034$export$6a02a79fa2b0ddab;

});
parcelRegister("dc1Hs", function(module, exports) {

let $99adb6ea021a0d60$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $99adb6ea021a0d60$var$load("76n7a"),
    $99adb6ea021a0d60$var$load("l253H"),
    $99adb6ea021a0d60$var$load("ffQaD"),
    $99adb6ea021a0d60$var$load("kvRbA"),
    $99adb6ea021a0d60$var$load("kNFvF"),
    $99adb6ea021a0d60$var$load("jLXj7")
]).then(()=>parcelRequire('3dNZP'));

});


parcelRegister("bJInk", function(module, exports) {

let $88b651aa95001e56$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $88b651aa95001e56$var$load("76n7a"),
    $88b651aa95001e56$var$load("l253H"),
    $88b651aa95001e56$var$load("MmE0u")
]).then(()=>parcelRequire('ddHJI'));

});




parcelRegister("dJ1ye", function(module, exports) {

$parcel$export(module.exports, "COLUMN_RESIZED", () => $78b8694f0d6e1ba7$export$8b3afcfe2043df19);
$parcel$export(module.exports, "COLUMN_VISIBILITY_CHANGED", () => $78b8694f0d6e1ba7$export$8d5ff5bc3618f0bf);
$parcel$export(module.exports, "DND_ROW_DROPPED", () => $78b8694f0d6e1ba7$export$fcf01bd231fb8f52);
$parcel$export(module.exports, "DND_ROW_LIFTED", () => $78b8694f0d6e1ba7$export$96db5145b3b810a2);
$parcel$export(module.exports, "useInteractionMetrics", () => $78b8694f0d6e1ba7$export$6f239bf5d81555c8);

var $dGrdR = parcelRequire("dGrdR");
const $78b8694f0d6e1ba7$export$8b3afcfe2043df19 = 'column-resized';
const $78b8694f0d6e1ba7$export$8d5ff5bc3618f0bf = 'column-visibility-changed';
const $78b8694f0d6e1ba7$export$fcf01bd231fb8f52 = 'dnd-row-droppped';
const $78b8694f0d6e1ba7$export$96db5145b3b810a2 = 'dnd-row-lifted';
const $78b8694f0d6e1ba7$export$eee8b97030e3c397 = 'more-fields-button-clicked';
const $78b8694f0d6e1ba7$var$interactionMetrics = {
    [$78b8694f0d6e1ba7$export$8b3afcfe2043df19]: (0, $dGrdR.metrics).interaction({
        key: `jwm.list.${$78b8694f0d6e1ba7$export$8b3afcfe2043df19}`
    }),
    [$78b8694f0d6e1ba7$export$8d5ff5bc3618f0bf]: (0, $dGrdR.metrics).interaction({
        key: `jwm.list.${$78b8694f0d6e1ba7$export$8d5ff5bc3618f0bf}`
    }),
    [$78b8694f0d6e1ba7$export$eee8b97030e3c397]: (0, $dGrdR.metrics).interaction({
        key: `jwm.list.${$78b8694f0d6e1ba7$export$eee8b97030e3c397}`
    }),
    [$78b8694f0d6e1ba7$export$96db5145b3b810a2]: (0, $dGrdR.metrics).interaction({
        key: `jwm.list.${$78b8694f0d6e1ba7$export$96db5145b3b810a2}`
    }),
    [$78b8694f0d6e1ba7$export$fcf01bd231fb8f52]: (0, $dGrdR.metrics).interaction({
        key: `jwm.list.${$78b8694f0d6e1ba7$export$fcf01bd231fb8f52}`
    })
};
const $78b8694f0d6e1ba7$export$6f239bf5d81555c8 = ()=>$78b8694f0d6e1ba7$var$interactionMetrics;

});

parcelRegister("mk7k0", function(module, exports) {

$parcel$export(module.exports, "BulkSelectionContainer", () => $cccb1c5255a2f5be$export$ba7d4447e46b479e);
$parcel$export(module.exports, "useBulkSelectionStore", () => $cccb1c5255a2f5be$export$2addfe65a8c51586);
$parcel$export(module.exports, "useIsIssueSelected", () => $cccb1c5255a2f5be$export$cfefd69fc8a5ac52);
$parcel$export(module.exports, "useIsGroupSelected", () => $cccb1c5255a2f5be$export$5810b0d7bc5c531d);
$parcel$export(module.exports, "useDiffIssuesSelected", () => $cccb1c5255a2f5be$export$84ca3a6195e96ba);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $d3Bn9 = parcelRequire("d3Bn9");
const $cccb1c5255a2f5be$var$actions = {
    selectIssues: ({ issues: issues, issuesData: issuesData, selectGroup: selectGroup, rowIndex: rowIndex })=>({ setState: setState, getState: getState })=>{
            const state = getState();
            const selectedIssuesDataMap = new Map(state.selectedIssuesData);
            issuesData?.forEach((issue)=>{
                selectedIssuesDataMap.set(issue.issueId, issue);
            });
            const newState = {
                ...state,
                selectedIssues: new Set([
                    ...state.selectedIssues,
                    ...issues
                ]),
                ...issuesData && {
                    selectedIssuesData: selectedIssuesDataMap
                },
                ...selectGroup ? {
                    selectedGroups: new Set([
                        ...state.selectedGroups,
                        selectGroup
                    ])
                } : {},
                ...rowIndex !== undefined ? {
                    lastSelectedRowIndex: rowIndex
                } : {}
            };
            setState(newState);
        },
    selectAllIssues: ({ issues: issues, issuesData: // TODO: make issuesData required when removing use of issues https://jbusiness.atlassian.net/browse/HRZ-589
    issuesData = [] })=>({ setState: setState, getState: getState })=>{
            const state = getState();
            const selectedIssuesDataMap = new Map();
            issuesData?.forEach((issue)=>{
                selectedIssuesDataMap.set(issue.issueId, issue);
            });
            const newState = {
                ...state,
                areAllIssuesSelected: true,
                selectedIssues: new Set(issues),
                selectedIssuesData: selectedIssuesDataMap,
                lastSelectedRowIndex: undefined
            };
            setState(newState);
        },
    selectGroup: (groupId)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                selectedGroups: new Set([
                    ...state.selectedGroups,
                    groupId
                ])
            });
        },
    selectAll: ()=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                areAllIssuesSelected: true
            });
        },
    unselectAll: ()=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                areAllIssuesSelected: false,
                lastSelectedRowIndex: undefined
            });
        },
    unselectGroup: (groupId)=>({ setState: setState, getState: getState })=>{
            const { selectedGroups: selectedGroups, ...state } = getState();
            selectedGroups.delete(groupId);
            setState({
                ...state,
                areAllIssuesSelected: false,
                selectedGroups: new Set(selectedGroups)
            });
        },
    unselectIssues: ({ issues: issues, unselectGroup: unselectGroup, rowIndex: rowIndex })=>({ setState: setState, getState: getState })=>{
            const { selectedIssues: selectedIssues, selectedIssuesData: selectedIssuesData, ...state } = getState();
            if (unselectGroup) state.selectedGroups.delete(unselectGroup);
            issues.forEach((issueId)=>{
                selectedIssues.delete(issueId);
                selectedIssuesData.delete(issueId);
            });
            const newState = {
                ...state,
                areAllIssuesSelected: false,
                selectedIssues: new Set(selectedIssues),
                selectedIssuesData: selectedIssuesData,
                ...unselectGroup ? {
                    selectedGroups: new Set(state.selectedGroups)
                } : {},
                ...rowIndex !== undefined ? {
                    lastSelectedRowIndex: rowIndex
                } : {}
            };
            setState(newState);
        },
    clearSelection: ()=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                areAllIssuesSelected: false,
                selectedGroups: new Set(),
                selectedIssues: new Set(),
                selectedIssuesData: new Map()
            });
        },
    toggleShowDeleteModal: ({ showDeleteModal: showDeleteModal })=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                showDeleteModal: showDeleteModal
            });
        },
    toggleBulkEditSidebar: ({ showBulkEditSidebar: showBulkEditSidebar })=>({ setState: setState, getState: getState })=>{
            const state = getState();
            const { selectedIssues: selectedIssues } = state;
            if (showBulkEditSidebar) setState({
                ...state,
                showBulkEditSidebar: showBulkEditSidebar,
                bulkEditableIssues: new Set(selectedIssues)
            });
            else setState({
                ...state,
                showBulkEditSidebar: showBulkEditSidebar,
                bulkEditableIssues: new Set()
            });
        },
    setBulkChangePermission: ({ bulkChangePermission: bulkChangePermission })=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                bulkChangePermission: bulkChangePermission
            });
        },
    setFetchingGroups: (groups)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                fetchingGroups: groups
            });
        },
    setLastSelectedRowIndex: (lastSelectedRowIndex)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                lastSelectedRowIndex: lastSelectedRowIndex
            });
        }
};
const $cccb1c5255a2f5be$var$initialState = {
    areAllIssuesSelected: false,
    selectedIssues: new Set(),
    selectedIssuesData: new Map(),
    selectedGroups: new Set(),
    showDeleteModal: false,
    showBulkEditSidebar: false,
    // groups that were collapsed and we are fetching the children to select them
    fetchingGroups: [],
    bulkEditableIssues: new Set()
};
const $cccb1c5255a2f5be$var$Store = (0, $iXqE5.createStore)({
    initialState: $cccb1c5255a2f5be$var$initialState,
    actions: $cccb1c5255a2f5be$var$actions,
    name: 'JWMListBulkSelection'
});
const $cccb1c5255a2f5be$export$ba7d4447e46b479e = (0, $gg7kZ.createContainer)($cccb1c5255a2f5be$var$Store, {
    onInit: ()=>({ setState: setState })=>{
            setState({
                ...$cccb1c5255a2f5be$var$initialState
            });
        }
});
const $cccb1c5255a2f5be$export$2addfe65a8c51586 = (0, $3sQ5x.createHook)($cccb1c5255a2f5be$var$Store);
const $cccb1c5255a2f5be$export$cfefd69fc8a5ac52 = (0, $3sQ5x.createHook)($cccb1c5255a2f5be$var$Store, {
    selector: (0, $d3Bn9.isIssueSelected)
});
const $cccb1c5255a2f5be$export$5810b0d7bc5c531d = (0, $3sQ5x.createHook)($cccb1c5255a2f5be$var$Store, {
    selector: (0, $d3Bn9.isGroupSelected)
});
const $cccb1c5255a2f5be$export$84ca3a6195e96ba = (0, $3sQ5x.createHook)($cccb1c5255a2f5be$var$Store, {
    selector: (0, $d3Bn9.diffIssuesSelected)
});

});
parcelRegister("d3Bn9", function(module, exports) {

$parcel$export(module.exports, "isIssueSelected", () => $9e3433dc4bb608a0$export$32568110248dd20a);
$parcel$export(module.exports, "isGroupSelected", () => $9e3433dc4bb608a0$export$9a23656adbf96f8a);
$parcel$export(module.exports, "diffIssuesSelected", () => $9e3433dc4bb608a0$export$bb31aa8fa8f2c5e0);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6dDSs = parcelRequire("6dDSs");
const $9e3433dc4bb608a0$export$32568110248dd20a = (0, $6dDSs.createSelector)((state)=>({
        selectedIssues: state.selectedIssues,
        fetchingGroups: state.fetchingGroups
    }), (__, { issueId: issueId, parentIssueId: parentIssueId })=>({
        issueId: issueId,
        parentIssueId: parentIssueId
    }), ({ selectedIssues: selectedIssues, fetchingGroups: fetchingGroups }, issue)=>{
    if (selectedIssues.has(String(issue.issueId))) return true;
    if (issue.parentIssueId) // Optimistic selection
    return fetchingGroups.includes(String(issue.parentIssueId));
    return false;
});
const $9e3433dc4bb608a0$export$9a23656adbf96f8a = (0, $6dDSs.createSelector)((state)=>state.selectedGroups, (__, groupId)=>groupId, (selectedGroups, groupId)=>{
    if (!groupId) return false;
    return selectedGroups.has(groupId);
});
const $9e3433dc4bb608a0$export$bb31aa8fa8f2c5e0 = (0, $6dDSs.createSelector)((state)=>state.selectedIssues, (__, issues)=>issues, (selectedIssues, issues)=>{
    if (!issues) return undefined;
    const diff = [];
    issues.forEach((issueId)=>{
        if (!selectedIssues.has(issueId)) diff.push(issueId);
    });
    return diff;
});

});


parcelRegister("iHWvz", function(module, exports) {

$parcel$export(module.exports, "useWatchBulkSelection", () => $73f7008f7d336b8f$export$5cafb03426b5addb);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $daQYX = parcelRequire("daQYX");

var $l4Ejo = parcelRequire("l4Ejo");

var $dpQnO = parcelRequire("dpQnO");

var $1XJ20 = parcelRequire("1XJ20");

var $8e3Yw = parcelRequire("8e3Yw");

var $9u99d = parcelRequire("9u99d");

var $mk7k0 = parcelRequire("mk7k0");

var $4DEgE = parcelRequire("4DEgE");
const $73f7008f7d336b8f$export$5cafb03426b5addb = ()=>{
    const [{ selectedIssues: selectedIssues }, { clearSelection: clearSelection, unselectIssues: unselectIssues }] = (0, $mk7k0.useBulkSelectionStore)();
    const projectData = (0, $daQYX.useProject)();
    const projectId = projectData.id;
    const { jql: jql } = (0, $l4Ejo.useFilters)();
    const { quickFiltersJql: quickFiltersJql } = (0, $dpQnO.useQuickFilters)();
    const [{ hierarchyData: { data: issues }, childrenItems: childrenItems }] = (0, $9u99d.useHierarchyStore)();
    const [groupByFieldId] = (0, $8e3Yw.useGroupBy)();
    const isGrouping = groupByFieldId != null;
    /*
        Use state to check once the filters has been updated
        After this we should wait for the new issues to be fetched
        and unselect the issues that are no longer visible for this new query
    */ const [hasFiltersBeenUpdated, setHasFiltersBeenUpdated] = (0, $5uXOq.useState)(false);
    const prevIssues = (0, $1XJ20.usePreviousWithInitial)(issues);
    // clear all items when grouping & filters change as the groups reset and collapse
    (0, $5uXOq.useEffect)(()=>{
        if (selectedIssues.size && (jql || quickFiltersJql)) {
            if (isGrouping) clearSelection();
            else setHasFiltersBeenUpdated(true);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        jql,
        quickFiltersJql
    ]);
    // clear items which are no longer visible after filtering etc.
    (0, $5uXOq.useEffect)(()=>{
        if (hasFiltersBeenUpdated && !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(prevIssues, issues) && !isGrouping) {
            const allIssueIds = (0, $4DEgE.getAllIssuesIds)({
                data: issues,
                childrenItems: childrenItems
            });
            const issuesToUnselect = [
                ...selectedIssues
            ].filter((issueId)=>allIssueIds.indexOf(issueId) === -1);
            if (issuesToUnselect.length > 0) unselectIssues({
                issues: issuesToUnselect
            });
            setHasFiltersBeenUpdated(false);
        }
    }, [
        childrenItems,
        hasFiltersBeenUpdated,
        isGrouping,
        issues,
        prevIssues,
        selectedIssues,
        unselectIssues
    ]);
    // clear all items when changing project
    (0, $5uXOq.useEffect)(()=>{
        clearSelection();
    }, [
        projectId,
        clearSelection
    ]);
};

});
parcelRegister("9u99d", function(module, exports) {

$parcel$export(module.exports, "useHierarchyStore", () => $587b2d62b109ceda$export$2fc259d06066fab6);

var $8Rkzz = parcelRequire("8Rkzz");

var $hE5wF = parcelRequire("hE5wF");

var $57lFd = parcelRequire("57lFd");

var $jDUax = parcelRequire("jDUax");

var $5fc53 = parcelRequire("5fc53");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $3fT9O = parcelRequire("3fT9O");
const $587b2d62b109ceda$export$21726efd4013edfd = 1;
const $587b2d62b109ceda$var$createLoadingItems = ()=>Array.from(Array((0, $hE5wF.DEFAULT_PAGE_SIZE)).keys()).map((i)=>(0, $3fT9O.createItemSkeleton)({
            issueId: String(i)
        }));
const $587b2d62b109ceda$var$getInitialState = ()=>({
        hierarchyData: {
            data: $587b2d62b109ceda$var$createLoadingItems(),
            loading: true,
            totalCount: 0,
            isLoadingNextPage: false,
            loadNextPage: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        },
        expandedItems: {},
        childrenItems: {},
        issuesMap: new Map(),
        issueParentMap: new Map()
    });
const $587b2d62b109ceda$export$d4c72bab9d6cc13a = $587b2d62b109ceda$var$getInitialState();
const $587b2d62b109ceda$var$findAnchorIndex = (issues, anchorId)=>{
    if (anchorId == null) return undefined;
    const index = issues.findIndex((issue)=>String(issue.issueId) === anchorId);
    if (index === -1) return undefined;
    return index;
};
// Recursively creates hierarchy tree by iterating over the items and their children
const $587b2d62b109ceda$var$createHierarchy = ({ item: item, childrenItems: childrenItems, issuesMap: issuesMap, extendItemsWithChildCreate: extendItemsWithChildCreate, hierarchyLevels: hierarchyLevels, showFlatList: showFlatList, issueParentMap: issueParentMap })=>{
    const childQueryData = childrenItems[item.issueId] || {};
    const childrenData = Array.isArray(childQueryData.data) ? childQueryData.data : [];
    const childrenCount = item.childSummary?.totalCount ?? 0;
    const epicLevelIssueTypeIds = hierarchyLevels.filter((hierarchyLevel)=>hierarchyLevel.level === $587b2d62b109ceda$export$21726efd4013edfd).map((hierarchyLevel)=>hierarchyLevel.id);
    const hasChildren = item.issuetype?.id && epicLevelIssueTypeIds.includes(item.issuetype.id) ? true : childrenCount > 0;
    let children = [];
    if (((0, $jDUax.isGroupItem)(item.issueId) || showFlatList !== true) && hasChildren) {
        const depth = (item.depth || 0) + 1;
        const skeletonItem = childQueryData.loading ? [
            (0, $3fT9O.createItemSkeleton)({
                issueId: item.issueId
            })
        ] : [];
        children = childrenData.length ? childrenData.map((childItem, index)=>{
            issueParentMap.set(`${childItem.issueId}`, `${item.issueId}`);
            return $587b2d62b109ceda$var$createHierarchy({
                item: {
                    ...childItem,
                    rankIndex: index,
                    depth: depth,
                    rowKey: `${childItem.id}-${depth}`
                },
                childrenItems: childrenItems,
                issuesMap: issuesMap,
                hierarchyLevels: hierarchyLevels,
                extendItemsWithChildCreate: extendItemsWithChildCreate,
                issueParentMap: issueParentMap
            });
        }) : skeletonItem;
        if (childQueryData.hasNextPage === true) children.push((0, $3fT9O.createRowForShowMore)(item.issueId));
    }
    const newItem = extendItemsWithChildCreate(item, children);
    issuesMap.set(`${item.issueId}`, newItem);
    return newItem;
};
const $587b2d62b109ceda$var$extendItemsWithChildCreate = (rowCreateState, setRowCreatePosition, getState, setState, hierarchyLevels)=>(item, children)=>{
        const expandItem = (issueId)=>{
            const state = getState();
            if (!state.expandedItems[issueId]) setState({
                ...state,
                expandedItems: {
                    ...state.expandedItems,
                    [issueId]: true
                }
            });
        };
        const insertInlineCreate = (anchorIndex, type, issueId)=>{
            if (anchorIndex != null) children.splice(anchorIndex, 0, (0, $3fT9O.createRowForInlineCreate)(type, String(issueId)));
            else children.unshift((0, $3fT9O.createRowForInlineCreate)(type, String(issueId)));
        };
        const hierarchyLevel = hierarchyLevels.find((x)=>x.id === item.issuetype?.id)?.level;
        const anchorIndex = $587b2d62b109ceda$var$findAnchorIndex(children, rowCreateState.anchorId);
        const { parentId: parentId } = rowCreateState;
        if (String(parentId) === String(item.issueId)) {
            if ((0, $jDUax.isGroupItem)(item.issueId)) insertInlineCreate(anchorIndex, 'group', item.issueId);
            else if (hierarchyLevel === 0) insertInlineCreate(anchorIndex, 'subtask', item.issueId);
            else if (hierarchyLevel && hierarchyLevel >= 1) insertInlineCreate(anchorIndex, 'task', item.issueId);
        }
        return {
            ...item,
            children: children,
            onChildCreateButtonClicked: hierarchyLevel !== -1 ? ()=>{
                setRowCreatePosition({
                    parentId: item.issueId
                });
                expandItem(item.issueId);
            } : undefined
        };
    };
const $587b2d62b109ceda$var$transformTopLevelIssues = (data, rowCreateState)=>{
    const { parentId: parentId, anchorId: anchorId } = rowCreateState;
    /**
	 * Due to race conditions, we cannot trust query data to be the source of truth for top level issues,
	 * so we need to make sure any inline create row has been removed before proceeding
	 */ const topLevelIssues = data.filter((item)=>!(0, $3fT9O.isItemAnInlineCreate)(String(item.issueId)));
    if (anchorId && !parentId) {
        const anchorIndex = $587b2d62b109ceda$var$findAnchorIndex(topLevelIssues, rowCreateState.anchorId);
        if (anchorIndex != null) // Insert the sibling issue create row
        topLevelIssues.splice(anchorIndex, 0, (0, $3fT9O.createRowForInlineCreate)('sibling'));
    }
    return topLevelIssues;
};
// Takes top level items (or Groups) GraphQL response and stores it in here
const $587b2d62b109ceda$var$setHierarchyData = (queryData, rowCreateState, setRowCreatePosition, hierarchyLevels, showFlatList)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const { childrenItems: childrenItems, issuesMap: issuesMap, issueParentMap: issueParentMap } = state;
        const childCreateCallback = $587b2d62b109ceda$var$extendItemsWithChildCreate(rowCreateState, setRowCreatePosition, getState, setState, hierarchyLevels);
        if (queryData.loading) return;
        /**
		 * transformTopLevelIssues is used to transform both ListViewIssue[] and HierarchyItem[] array types, depending on what is passed as the 'data' argument,
		 *  hence the need to type cast it as ListViewIssue[] to avoid type errors
		 */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const topLevelIssues = $587b2d62b109ceda$var$transformTopLevelIssues(queryData.data, rowCreateState);
        const data = queryData.loading ? $587b2d62b109ceda$var$createLoadingItems() : topLevelIssues.map((item, index)=>$587b2d62b109ceda$var$createHierarchy({
                item: {
                    ...item,
                    rankIndex: index,
                    depth: 0,
                    rowKey: `${item.id}-0`
                },
                childrenItems: childrenItems,
                issuesMap: issuesMap,
                extendItemsWithChildCreate: childCreateCallback,
                showFlatList: showFlatList,
                hierarchyLevels: hierarchyLevels,
                issueParentMap: issueParentMap
            }));
        setState({
            ...state,
            hierarchyData: {
                ...queryData,
                data: data
            }
        });
    };
// Updates expanded items
const $587b2d62b109ceda$var$setExpandedItems = (issueId, isExpanded)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            expandedItems: {
                ...state.expandedItems,
                [issueId]: isExpanded
            }
        });
    };
// Stores GraphQL response of expanded child items
const $587b2d62b109ceda$var$setChildrenItems = (parentIssueId, queryData, rowCreateState, setRowCreatePosition, hierarchyLevels)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const childrenItems = {
            ...state.childrenItems,
            [parentIssueId]: {
                ...queryData,
                ...queryData.data ? {
                    data: queryData.data.map((issue)=>({
                            ...issue,
                            parentIssueId: parentIssueId
                        }))
                } : {}
            }
        };
        const { issuesMap: issuesMap, issueParentMap: issueParentMap } = state;
        let targetFound = false;
        const updateHierarchy = ({ rootIssueId: rootIssueId })=>{
            const item = issuesMap.get(`${rootIssueId}`);
            // We can stop traversal once the parent node has been updated
            if (targetFound || !item) return null;
            const childCreateCallback = $587b2d62b109ceda$var$extendItemsWithChildCreate(rowCreateState, setRowCreatePosition, getState, setState, hierarchyLevels);
            if (String(item.issueId) === String(parentIssueId)) {
                // If we find the node we're appending children to, we need to create the new hierarchy below it and return to notify parents to update
                targetFound = true;
                return $587b2d62b109ceda$var$createHierarchy({
                    item: item,
                    childrenItems: childrenItems,
                    issuesMap: issuesMap,
                    extendItemsWithChildCreate: childCreateCallback,
                    hierarchyLevels: hierarchyLevels,
                    issueParentMap: issueParentMap
                });
            }
            const { children: children } = item;
            const updatedChild = children?.reduce((acc, curr, index)=>{
                const newChild = updateHierarchy({
                    rootIssueId: curr.issueId
                });
                if (newChild) children[index] = newChild;
                return newChild ?? acc;
            }, undefined);
            if (updatedChild) {
                // if one of the children updated, then we need to update this node as well
                const newItem = {
                    ...item,
                    children: children
                };
                issuesMap.set(`${item.issueId}`, newItem);
                return newItem;
            }
            return null;
        };
        const topLevelItems = state.hierarchyData.data;
        for(let index = 0, count = topLevelItems.length; index < count; index += 1){
            const item = topLevelItems[index];
            const newItem = updateHierarchy({
                rootIssueId: item.issueId
            });
            if (newItem) topLevelItems[index] = newItem;
            if (targetFound) break;
        }
        setState({
            ...state,
            childrenItems: childrenItems,
            hierarchyData: {
                ...state.hierarchyData,
                data: [
                    ...topLevelItems
                ]
            }
        });
    };
// rebuilds the hierarchy, factoring in changes to row create position
const $587b2d62b109ceda$var$refreshHierarchy = (rowCreateState, setRowCreatePosition, hierarchyLevels)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const { issuesMap: issuesMap, childrenItems: childrenItems, issueParentMap: issueParentMap } = state;
        /**
		 * getTopLevelIssues is used to transform both ListViewIssue[] and HierarchyItem[], depending on what is passed as the 'data' argument,
		 *  hence the need to type cast it as HierarchyItem[] to avoid type errors
		 */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const topLevelIssues = $587b2d62b109ceda$var$transformTopLevelIssues(state.hierarchyData.data, rowCreateState);
        for(let index = 0, count = topLevelIssues.length; index < count; index += 1){
            const item = topLevelIssues[index];
            const childCreateCallback = $587b2d62b109ceda$var$extendItemsWithChildCreate(rowCreateState, setRowCreatePosition, getState, setState, hierarchyLevels);
            const newItem = $587b2d62b109ceda$var$createHierarchy({
                item: item,
                childrenItems: childrenItems,
                issuesMap: issuesMap,
                extendItemsWithChildCreate: childCreateCallback,
                hierarchyLevels: hierarchyLevels,
                issueParentMap: issueParentMap
            });
            if (newItem) topLevelIssues[index] = newItem;
        }
        setState({
            ...state,
            childrenItems: childrenItems,
            hierarchyData: {
                ...state.hierarchyData,
                data: [
                    ...topLevelIssues
                ]
            }
        });
    };
const $587b2d62b109ceda$var$resetCache = ()=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            childrenItems: {},
            expandedItems: {}
        });
    };
const $587b2d62b109ceda$var$expandFirstItems = ()=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const firstIssueId = state.hierarchyData.data[0]?.issueId;
        setState({
            ...state,
            expandedItems: firstIssueId != null ? {
                [firstIssueId]: true
            } : {}
        });
    };
const $587b2d62b109ceda$var$clearExpandedItems = ()=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            expandedItems: Object.fromEntries(Object.keys(state.expandedItems).map((key)=>[
                    key,
                    false
                ]))
        });
    };
const $587b2d62b109ceda$var$getParentIssueKeysByChildId = (issueId)=>({ getState: getState })=>{
        const { issuesMap: issuesMap } = getState();
        let parents = [];
        let node = issuesMap.get(`${issueId}`);
        do {
            const parentIssue = (0, $57lFd.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            node?.fields, (0, $5fc53.PARENT_TYPE), 'issue', null);
            const cachedParentIssueId = !(0, $jDUax.isGroupItem)(`${node?.parentIssueId}`) ? node?.parentIssueId : null;
            const parentIssueId = parentIssue?.issueId ? parentIssue?.issueId : cachedParentIssueId;
            if (parentIssueId) {
                node = issuesMap.get(`${parentIssueId}`);
                // When parent issue is cached in hierarchy store
                if (node) parents = [
                    {
                        id: `${parentIssueId}`,
                        key: `${node.key}`
                    },
                    ...parents
                ];
                else if (parentIssue?.issueKey) {
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    const key = `${parentIssue?.issueKey || ''}`;
                    parents = [
                        {
                            id: `${parentIssueId}`,
                            key: key
                        },
                        ...parents
                    ];
                }
            } else node = undefined;
        }while (node);
        if (parents.length) return parents;
        return null;
    };
const $587b2d62b109ceda$var$clearHierarchyData = ()=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            hierarchyData: $587b2d62b109ceda$var$getInitialState().hierarchyData
        });
    };
const $587b2d62b109ceda$var$initState = ({ projectKey: projectKey })=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            projectKey: projectKey
        });
    };
const $587b2d62b109ceda$var$actions = {
    setHierarchyData: $587b2d62b109ceda$var$setHierarchyData,
    setExpandedItems: $587b2d62b109ceda$var$setExpandedItems,
    setChildrenItems: $587b2d62b109ceda$var$setChildrenItems,
    refreshHierarchy: $587b2d62b109ceda$var$refreshHierarchy,
    expandFirstItems: $587b2d62b109ceda$var$expandFirstItems,
    clearExpandedItems: $587b2d62b109ceda$var$clearExpandedItems,
    clearHierarchyData: $587b2d62b109ceda$var$clearHierarchyData,
    resetCache: $587b2d62b109ceda$var$resetCache,
    getParentIssueKeysByChildId: $587b2d62b109ceda$var$getParentIssueKeysByChildId,
    initState: $587b2d62b109ceda$var$initState
};
const $587b2d62b109ceda$var$Store = (0, $iXqE5.createStore)({
    initialState: $587b2d62b109ceda$export$d4c72bab9d6cc13a,
    actions: $587b2d62b109ceda$var$actions,
    name: 'JWMHierarchyStore'
});
const $587b2d62b109ceda$export$2fc259d06066fab6 = (0, $3sQ5x.createHook)($587b2d62b109ceda$var$Store);

});
parcelRegister("jDUax", function(module, exports) {

$parcel$export(module.exports, "getParentIssueId", () => $6e16617835cc2337$export$846a0afb93794223);
$parcel$export(module.exports, "isGroupItem", () => $6e16617835cc2337$export$dcc23ed179776a3b);
$parcel$export(module.exports, "getGroupItemId", () => $6e16617835cc2337$export$4f6368343f5d1a95);
$parcel$export(module.exports, "isRootLevel", () => $6e16617835cc2337$export$7044e84e19490c29);

var $57lFd = parcelRequire("57lFd");

var $deqCE = parcelRequire("deqCE");
const $6e16617835cc2337$export$3ba5d152e044664d = (parentIssue, subtaskFieldIssue)=>{
    const parentIssueFields = parentIssue.fields || [];
    const subtasksFieldIndex = parentIssueFields.findIndex((field)=>field?.fieldKey === 'subtasks');
    const subtasksField = typeof subtasksFieldIndex === 'number' && subtasksFieldIndex !== -1 ? parentIssueFields[subtasksFieldIndex] : undefined;
    if (subtasksFieldIndex === -1 || subtasksField == null) // there should be a subtask field always in the code
    // since it's declared in the gql
    return parentIssue;
    const updatedFields = [
        ...parentIssueFields
    ];
    updatedFields[subtasksFieldIndex] = {
        ...updatedFields[subtasksFieldIndex],
        issues: [
            subtaskFieldIssue,
            ...subtasksField?.issues || []
        ].filter((issue, index, issueArray)=>issueArray.findIndex((current)=>current.issueId === issue.issueId) === index)
    };
    return {
        ...parentIssue,
        // we're updating just the subtasks field, but flow doesn't understand that because the union type of fields
        fields: updatedFields
    };
};
const $6e16617835cc2337$export$30019f8058090ccb = (isFiltering, id)=>{
    if (id === (0, $deqCE.OPTIMISTIC_ISSUE_ID)) return false;
    return !isFiltering;
};
const $6e16617835cc2337$export$d9893aac42f29b60 = (node)=>{
    const issueKey = (0, $57lFd.safeGetValue)(node.fields, 'issuekey', 'text', undefined);
    const parentIssue = (0, $57lFd.safeGetValue)(node.fields, 'parent', 'parentIssue', undefined);
    const projectKey1 = (issueKey ?? '').split('-')[0];
    const projectKey2 = (parentIssue?.key ?? '').split('-')[0];
    const sameProject = projectKey1 && projectKey2 ? projectKey1 === projectKey2 : false;
    return sameProject ? parentIssue?.issueId : undefined;
};
const $6e16617835cc2337$export$846a0afb93794223 = (node)=>{
    const parentIssue = (0, $57lFd.safeGetValue)(node.fields, 'parent', 'parentIssue', undefined);
    // We need to return parent issue if is a group parent
    if ($6e16617835cc2337$export$dcc23ed179776a3b(parentIssue?.issueId)) return parentIssue?.issueId;
    return $6e16617835cc2337$export$d9893aac42f29b60(node);
};
const $6e16617835cc2337$export$dcc23ed179776a3b = (issueId = '')=>typeof issueId === 'string' && issueId.startsWith((0, $deqCE.GROUP_ITEM_PREFIX));
const $6e16617835cc2337$export$4f6368343f5d1a95 = (issueId)=>{
    const [_, groupItemId] = issueId.split(`${(0, $deqCE.GROUP_ITEM_PREFIX)}_`);
    return groupItemId ?? issueId;
};
const $6e16617835cc2337$export$7044e84e19490c29 = (issueId)=>issueId === (0, $deqCE.ROOT_LEVEL);

});
parcelRegister("deqCE", function(module, exports) {

$parcel$export(module.exports, "OPTIMISTIC_ID_PREFIX", () => $13edc00a14335139$export$a76c6afcd77fffd8);
$parcel$export(module.exports, "OPTIMISTIC_ISSUE_ID", () => $13edc00a14335139$export$2bc461aaabcabfc9);
$parcel$export(module.exports, "ROOT_LEVEL", () => $13edc00a14335139$export$d24bbd23c8a5d65e);
$parcel$export(module.exports, "GROUP_ITEM_PREFIX", () => $13edc00a14335139$export$b29b9e70f9850100);
const $13edc00a14335139$export$a76c6afcd77fffd8 = '-optimistic';
const $13edc00a14335139$export$2bc461aaabcabfc9 = -1;
const $13edc00a14335139$export$d24bbd23c8a5d65e = 'rootLevel';
const $13edc00a14335139$export$b29b9e70f9850100 = 'GROUP_BY';

});


parcelRegister("3fT9O", function(module, exports) {

$parcel$export(module.exports, "isItemAnIssue", () => $c4aa3153d0b8fbae$export$975d97cb9b482d9f);
$parcel$export(module.exports, "createItemSkeleton", () => $c4aa3153d0b8fbae$export$ac4443ed642486ab);
$parcel$export(module.exports, "isItemSkeleton", () => $c4aa3153d0b8fbae$export$121c11fd7ecbe3e1);
$parcel$export(module.exports, "INLINE_CREATE_ITEM_PREFIX", () => $c4aa3153d0b8fbae$export$cdc74f7556cd3fa2);
$parcel$export(module.exports, "createRowForInlineCreate", () => $c4aa3153d0b8fbae$export$eb550cfe09336f0d);
$parcel$export(module.exports, "isItemAnInlineCreate", () => $c4aa3153d0b8fbae$export$f785dc554f71ae43);
$parcel$export(module.exports, "isItemAnInlineCreateTask", () => $c4aa3153d0b8fbae$export$76703e048af589f9);
$parcel$export(module.exports, "isItemAnInlineCreateSubTask", () => $c4aa3153d0b8fbae$export$7bcd44296e4ddac3);
$parcel$export(module.exports, "isItemAnInlineCreateGroup", () => $c4aa3153d0b8fbae$export$a18c1da7342b1b86);
$parcel$export(module.exports, "isItemASiblingTopLevelHierarchyInlineCreate", () => $c4aa3153d0b8fbae$export$6341a221cf48c3e1);
$parcel$export(module.exports, "isItemShowMore", () => $c4aa3153d0b8fbae$export$20c8aeca27cd0961);
$parcel$export(module.exports, "createRowForShowMore", () => $c4aa3153d0b8fbae$export$4a6167a75be5ff06);

var $gULOk = parcelRequire("gULOk");

var $3rO9r = parcelRequire("3rO9r");
const $c4aa3153d0b8fbae$export$975d97cb9b482d9f = (issueId)=>Number(issueId) > 0;
const $c4aa3153d0b8fbae$export$8764542593218704 = 'SKELETON-ITEM-';
const $c4aa3153d0b8fbae$export$ac4443ed642486ab = ({ issueId: issueId })=>({
        id: `${$c4aa3153d0b8fbae$export$8764542593218704}${issueId}-id`,
        issueId: `${$c4aa3153d0b8fbae$export$8764542593218704}${issueId}`,
        typeId: 'loading',
        issuetype: {},
        key: 'loading',
        rank: '',
        status: {
            name: 'To do',
            categoryId: (0, $gULOk.categoryIdForStatusCategory)((0, $gULOk.TODO)).toString()
        },
        totalSubtasks: 0,
        rankIndex: 0,
        rowKey: `${$c4aa3153d0b8fbae$export$8764542593218704}-${issueId}`,
        cacheVariables: (0, $3rO9r.DEFAULT_CACHE_VARIABLES)
    });
const $c4aa3153d0b8fbae$export$121c11fd7ecbe3e1 = (issueId = '')=>String(issueId).startsWith($c4aa3153d0b8fbae$export$8764542593218704);
const $c4aa3153d0b8fbae$export$cdc74f7556cd3fa2 = 'INLINE-CREATE-';
const $c4aa3153d0b8fbae$export$eb550cfe09336f0d = (type = 'subtask', issueId = 'InlineCreate')=>({
        id: `${$c4aa3153d0b8fbae$export$cdc74f7556cd3fa2}${type}-id`,
        issueId: `${$c4aa3153d0b8fbae$export$cdc74f7556cd3fa2}${type}-issueId`,
        parentIssueId: issueId,
        typeId: `${$c4aa3153d0b8fbae$export$cdc74f7556cd3fa2}-typeId--${issueId}`,
        issuetype: {},
        key: `${$c4aa3153d0b8fbae$export$cdc74f7556cd3fa2}-key-${issueId}`,
        rank: '',
        rankIndex: -1,
        status: {
            name: 'To do',
            categoryId: (0, $gULOk.categoryIdForStatusCategory)((0, $gULOk.TODO)).toString()
        },
        totalSubtasks: 0,
        rowKey: `${$c4aa3153d0b8fbae$export$cdc74f7556cd3fa2}-${issueId}`,
        cacheVariables: (0, $3rO9r.DEFAULT_CACHE_VARIABLES)
    });
const $c4aa3153d0b8fbae$export$f785dc554f71ae43 = (issueId = '')=>issueId.startsWith($c4aa3153d0b8fbae$export$cdc74f7556cd3fa2);
const $c4aa3153d0b8fbae$export$76703e048af589f9 = (issueId = '')=>issueId.startsWith(`${$c4aa3153d0b8fbae$export$cdc74f7556cd3fa2}task`);
const $c4aa3153d0b8fbae$export$7bcd44296e4ddac3 = (issueId = '')=>issueId.startsWith(`${$c4aa3153d0b8fbae$export$cdc74f7556cd3fa2}subtask`);
const $c4aa3153d0b8fbae$export$a18c1da7342b1b86 = (issueId = '')=>issueId.startsWith(`${$c4aa3153d0b8fbae$export$cdc74f7556cd3fa2}group`);
const $c4aa3153d0b8fbae$export$6341a221cf48c3e1 = (issueId = '')=>issueId.startsWith(`${$c4aa3153d0b8fbae$export$cdc74f7556cd3fa2}sibling`);
const $c4aa3153d0b8fbae$export$8fca45ac4bf48d8a = 'SHOW_MORE-';
const $c4aa3153d0b8fbae$export$20c8aeca27cd0961 = (issueId = '')=>issueId.startsWith($c4aa3153d0b8fbae$export$8fca45ac4bf48d8a);
const $c4aa3153d0b8fbae$export$4a6167a75be5ff06 = (issueId)=>({
        id: `${$c4aa3153d0b8fbae$export$8fca45ac4bf48d8a}-id`,
        issueId: `${$c4aa3153d0b8fbae$export$8fca45ac4bf48d8a}-issueId`,
        parentIssueId: issueId,
        typeId: `${$c4aa3153d0b8fbae$export$8fca45ac4bf48d8a}-typeId--${issueId}`,
        issuetype: {},
        key: `${$c4aa3153d0b8fbae$export$8fca45ac4bf48d8a}-key-${issueId}`,
        rank: '',
        rankIndex: -1,
        status: {
            name: 'To do',
            categoryId: (0, $gULOk.categoryIdForStatusCategory)((0, $gULOk.TODO)).toString()
        },
        totalSubtasks: 0,
        rowKey: `${$c4aa3153d0b8fbae$export$8fca45ac4bf48d8a}-${issueId}`,
        cacheVariables: (0, $3rO9r.DEFAULT_CACHE_VARIABLES)
    });

});
parcelRegister("3rO9r", function(module, exports) {

$parcel$export(module.exports, "SELECT_ROW_COLUMN_ID", () => $ee5861e63098ead5$export$2862da21a9b5c4c7);
$parcel$export(module.exports, "COLUMNS_WITH_DISABLED_REORDERING", () => $ee5861e63098ead5$export$d4e2ef02d58b3b19);
$parcel$export(module.exports, "DEFAULT_CACHE_VARIABLES", () => $ee5861e63098ead5$export$fc14c7f3b5089b5d);
$parcel$export(module.exports, "PLACEHOLDER_COLUMN", () => $ee5861e63098ead5$export$b74e0ecca7ce25fe);

var $5fc53 = parcelRequire("5fc53");
const $ee5861e63098ead5$export$2862da21a9b5c4c7 = 'selectRow';
const $ee5861e63098ead5$export$e7d0f09e45be184e = 'column-draggable-helper-class';
const $ee5861e63098ead5$export$d4e2ef02d58b3b19 = [
    $ee5861e63098ead5$export$2862da21a9b5c4c7,
    (0, $5fc53.ISSUE_TYPE),
    'key'
];
const $ee5861e63098ead5$export$fc14c7f3b5089b5d = {
    jql: ''
};
const $ee5861e63098ead5$export$b74e0ecca7ce25fe = 'PLACEHOLDER';

});



parcelRegister("4DEgE", function(module, exports) {

$parcel$export(module.exports, "getFlattenIssuesList", () => $affbcffbecf7083a$export$f47d7c5b44a813c0);
$parcel$export(module.exports, "getAllIssueChildren", () => $affbcffbecf7083a$export$1945e9d463a28215);
$parcel$export(module.exports, "getAllIssuesIds", () => $affbcffbecf7083a$export$1b9aa9aa607a46fc);

var $ajpes = parcelRequire("ajpes");

var $8QpSo = parcelRequire("8QpSo");

var $deqCE = parcelRequire("deqCE");

var $jDUax = parcelRequire("jDUax");

var $g5X3G = parcelRequire("g5X3G");

var $3fT9O = parcelRequire("3fT9O");
const $affbcffbecf7083a$export$f47d7c5b44a813c0 = ({ issues: issues, expandedItems: expandedItems })=>{
    if (!issues || issues.length === 0) return [];
    const flattenedIssues = issues.flatMap((issue)=>{
        const isExpanded = expandedItems[(0, $g5X3G.toIssueId)(issue.issueId)];
        const children = isExpanded ? $affbcffbecf7083a$export$f47d7c5b44a813c0({
            issues: issue.children,
            expandedItems: expandedItems
        }) : [];
        return [
            issue,
            ...children
        ];
    });
    return flattenedIssues;
};
const $affbcffbecf7083a$export$1945e9d463a28215 = (0, $8QpSo.default)(({ issue: issue, childrenItems: childrenItems })=>{
    if (!issue) return [];
    const issueChildren = childrenItems[issue.issueId];
    if (!issueChildren) return [];
    let issuesIds = [];
    issueChildren.data?.forEach((child)=>{
        issuesIds = [
            ...issuesIds,
            String(child.issueId),
            ...$affbcffbecf7083a$export$1945e9d463a28215({
                issue: child,
                childrenItems: childrenItems
            })
        ];
    });
    return issuesIds;
}, (0, (/*@__PURE__*/$parcel$interopDefault($ajpes))));
const $affbcffbecf7083a$export$1b9aa9aa607a46fc = ({ data: data, childrenItems: childrenItems })=>{
    let issuesIds = [];
    data.forEach((issue)=>{
        const { issueId: issueId, id: id } = issue;
        if (!(0, $jDUax.isGroupItem)(issueId) && !(0, $3fT9O.isItemSkeleton)(issueId) && !id.startsWith((0, $deqCE.OPTIMISTIC_ID_PREFIX))) issuesIds.push(String(issueId));
        if (childrenItems[issueId]) issuesIds = [
            ...issuesIds,
            ...$affbcffbecf7083a$export$1945e9d463a28215({
                issue: issue,
                childrenItems: childrenItems
            })
        ];
    });
    return issuesIds;
};

});


parcelRegister("3fU11", function(module, exports) {

$parcel$export(module.exports, "useColumnWidths", () => $956c71744ece40c4$export$d598237875812773);

var $5uXOq = parcelRequire("5uXOq");

var $daQYX = parcelRequire("daQYX");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $5bGaW = parcelRequire("5bGaW");
const $956c71744ece40c4$export$86880b4b2e1a2384 = 'column.widths';
const $956c71744ece40c4$var$actions = {
    setColumnWidth: (columnKey, width)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            const { columnsWidths: columnsWidths, storageKey: storageKey } = state;
            if (storageKey == null) return;
            const newState = {
                ...state,
                columnsWidths: {
                    ...columnsWidths,
                    [columnKey]: width
                }
            };
            (0, $5bGaW.localStorage).set(storageKey, newState.columnsWidths);
            setState(newState);
        },
    initState: (projectKey)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            if (state.storageKey != null) return;
            const storageKey = `${projectKey}-${$956c71744ece40c4$export$86880b4b2e1a2384}`;
            setState({
                ...state,
                storageKey: storageKey,
                columnsWidths: (0, $5bGaW.localStorage).get(storageKey) || {}
            });
        }
};
const $956c71744ece40c4$var$Store = (0, $iXqE5.createStore)({
    initialState: {
        storageKey: null,
        columnsWidths: {}
    },
    actions: $956c71744ece40c4$var$actions,
    name: 'JBusListViewColumnWidthStore'
});
const $956c71744ece40c4$var$useHook = (0, $3sQ5x.createHook)($956c71744ece40c4$var$Store);
const $956c71744ece40c4$export$d598237875812773 = ()=>{
    const [{ columnsWidths: columnsWidths }, { setColumnWidth: setColumnWidth, initState: initState }] = $956c71744ece40c4$var$useHook();
    const projectData = (0, $daQYX.useProject)();
    const projectKey = projectData.key;
    (0, $5uXOq.useEffect)(()=>{
        if (projectKey != null) initState(projectKey);
    }, [
        initState,
        projectKey
    ]);
    return [
        columnsWidths,
        {
            setColumnWidth: setColumnWidth
        }
    ];
};

});
parcelRegister("5bGaW", function(module, exports) {

$parcel$export(module.exports, "localStore", () => $443d62cf2aefea7c$export$74cea4b24a6bc9fa);
$parcel$export(module.exports, "localStorage", () => $443d62cf2aefea7c$export$c2ed3351cac403d1);

var $bSSG7 = parcelRequire("bSSG7");
const $443d62cf2aefea7c$export$74cea4b24a6bc9fa = (0, $bSSG7.createLocalStorageProvider)('jira_business_list-view');
const $443d62cf2aefea7c$export$c2ed3351cac403d1 = $443d62cf2aefea7c$export$74cea4b24a6bc9fa;

});


parcelRegister("8TUlY", function(module, exports) {

$parcel$export(module.exports, "useIssueFields", () => $caa9955f3c0147ae$export$3dd4dc75e8b8fc8a);
$parcel$export(module.exports, "UpdateFieldsDetail", () => $caa9955f3c0147ae$export$fc1188611b218081);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $kGsr8 = parcelRequire("kGsr8");

var $8QpSo = parcelRequire("8QpSo");

var $1T2vX = parcelRequire("1T2vX");

var $6eSqc = parcelRequire("6eSqc");

var $jcw0u = parcelRequire("jcw0u");

var $5fc53 = parcelRequire("5fc53");

var $lt1LT = parcelRequire("lt1LT");

var $avVp3 = parcelRequire("avVp3");

var $4yxtN = parcelRequire("4yxtN");
const $caa9955f3c0147ae$var$fieldIdsToQuery = [
    'rank',
    'parent'
];
const $caa9955f3c0147ae$var$buildListOfAvailableFields = (0, $8QpSo.default)((fields, constants)=>fields// add fields missing in the service response
    .concat(constants.MISSING_FIELDS)// filter out fields that we can't render yet
    .filter((field)=>constants.SUPPORTED_FIELD_TYPES.includes(field.type ?? ''))// sort in order of SUPPORTED_FIELDS
    .sort((a, b)=>constants.SUPPORTED_FIELD_TYPES.indexOf(a.type ?? '') - constants.SUPPORTED_FIELD_TYPES.indexOf(b.type ?? '')), (0, (/*@__PURE__*/$parcel$interopDefault($ajpes))));
const $caa9955f3c0147ae$var$getSortedAvailableFields = (0, $8QpSo.default)((availableFields, fieldsOrder, constants)=>availableFields.sort((a, b)=>{
        // fieldsOrder are initially set to SUPPORTED_FIELD_TYPES which are typed base
        // Category field is a custom field and it's id (e.g, customfield_X) is not equal to the type
        // so finding by id will return -1
        const aFieldsOrderIdx = a?.type && (0, $lt1LT.DEFAULT_CUSTOM_FIELDS_BY_TYPE).includes(a?.type) ? fieldsOrder.indexOf(a.type) : fieldsOrder.indexOf(a.id);
        const bFieldsOrderIdx = b?.type && (0, $lt1LT.DEFAULT_CUSTOM_FIELDS_BY_TYPE).includes(b?.type) ? fieldsOrder.indexOf(b.type) : fieldsOrder.indexOf(b.id);
        // if field is missing from fieldsOrder add to the end sorted based on field type
        if (aFieldsOrderIdx === -1 || bFieldsOrderIdx === -1) {
            if (aFieldsOrderIdx !== -1) return -1;
            if (bFieldsOrderIdx !== -1) return 1;
            return constants.SUPPORTED_FIELD_TYPES.indexOf(a.type ?? '') - constants.SUPPORTED_FIELD_TYPES.indexOf(b.type ?? '');
        }
        return aFieldsOrderIdx - bFieldsOrderIdx;
    }));
const $caa9955f3c0147ae$export$3dd4dc75e8b8fc8a = ()=>{
    const constants = (0, $lt1LT.useConstants)();
    const { data: data, loading: loading, error: error } = (0, $1T2vX.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const availableFields = $caa9955f3c0147ae$var$buildListOfAvailableFields(data.fields, constants);
    const { fields: { order: order, details: details }, toggleField: toggleField, reorderFields: reorderFields, resetCache: resetCache } = (0, $avVp3.useFieldsActions)(!loading && error == null ? availableFields : null);
    const getAvailableFields = (0, $5uXOq.useCallback)(()=>{
        try {
            return $caa9955f3c0147ae$var$getSortedAvailableFields(availableFields, order, constants);
        } catch (err) {
            resetCache && resetCache();
            (0, $jcw0u.default)({
                meta: {
                    id: 'getAvailableFields',
                    packageName: 'jiraBusinessList',
                    teamName: 'keystone'
                },
                attributes: {
                    message: 'Error trying to get available fields from cache'
                },
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
            return $caa9955f3c0147ae$var$getSortedAvailableFields(availableFields, [], constants);
        }
    }, [
        availableFields,
        constants,
        order,
        resetCache
    ]);
    const shouldGetVisibleFieldsFromCache = (0, $5uXOq.useMemo)(()=>(loading || error != null) && details != null, [
        details,
        error,
        loading
    ]);
    const getVisibleFields = (0, $5uXOq.useCallback)(()=>{
        if (shouldGetVisibleFieldsFromCache) try {
            return order.map((id)=>details?.[id]).filter((field)=>constants.SUPPORTED_FIELD_TYPES.includes(field?.type ?? ''));
        } catch (err) {
            resetCache && resetCache();
            (0, $jcw0u.default)({
                meta: {
                    id: 'getVisibleFields',
                    packageName: 'jiraBusinessList',
                    teamName: 'keystone'
                },
                attributes: {
                    message: 'Error trying to get visible fields from cache'
                },
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
            return [];
        }
        return getAvailableFields().filter((field)=>constants.ALWAYS_VISIBLE_FIELDS.includes(field.id) || field.id != null && order.includes(field.id) || field.type !== undefined && order.includes(field.type));
    }, [
        shouldGetVisibleFieldsFromCache,
        getAvailableFields,
        order,
        details,
        constants.SUPPORTED_FIELD_TYPES,
        constants.ALWAYS_VISIBLE_FIELDS,
        resetCache
    ]);
    const getQueryFieldIds = (0, $5uXOq.useCallback)(()=>{
        if (loading) return [];
        const visibleFieldIds = getVisibleFields()// the top level dev summary is the only thing that we should be using
        // we need to remove it from fieldIds because could fetch the field twice and is a complex field
        .filter((field)=>field.type !== (0, $5fc53.DEV_SUMMARY_CF_TYPE)).map((field)=>field.id === 'key' ? 'issuekey' : field.id)// avoid querying items on columns re-ordering
        .sort((a, b)=>constants.SUPPORTED_FIELD_TYPES.indexOf(a) - constants.SUPPORTED_FIELD_TYPES.indexOf(b)).concat($caa9955f3c0147ae$var$fieldIdsToQuery);
        if (visibleFieldIds.includes('timeoriginalestimate') && !visibleFieldIds.includes('timetracking')) // In JIS2, replace timeoriginalestimate with timetracking, which will have the information we
        // need to determine timeAsString in the JIS2 transformer in
        // src/packages/business/list/src/services/get-list-view-issues/field-transformer-jis2/index.tsx
        visibleFieldIds.splice(visibleFieldIds.indexOf('timeoriginalestimate'), 1, 'timetracking');
        const queryFieldIds = visibleFieldIds.filter((field)=>field !== 'commentsummary');
        return (0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))(queryFieldIds);
    }, [
        constants.SUPPORTED_FIELD_TYPES,
        getVisibleFields,
        loading
    ]);
    const { getQueryFieldIdsWithCache: getQueryFieldIdsWithCache } = (0, $4yxtN.useFieldsCache)({
        loading: loading,
        error: error,
        getQueryFieldIds: getQueryFieldIds
    });
    const { hierarchyLevelsWithCache: hierarchyLevelsWithCache } = (0, $6eSqc.useHierarchyCache)({
        view: 'list'
    });
    const isParentFieldVisible = (0, $5uXOq.useCallback)(()=>getVisibleFields().some((field)=>field.id === 'parent'), [
        getVisibleFields
    ]);
    const isDevSummaryFieldVisible = (0, $5uXOq.useCallback)(()=>getVisibleFields().some((field)=>field.type === (0, $5fc53.DEV_SUMMARY_CF_TYPE)), [
        getVisibleFields
    ]);
    return {
        constants: constants,
        toggleField: toggleField,
        getVisibleFields: getVisibleFields,
        getAvailableFields: getAvailableFields,
        getQueryFieldIds: getQueryFieldIdsWithCache,
        isParentFieldVisible: isParentFieldVisible,
        isDevSummaryFieldVisible: isDevSummaryFieldVisible,
        hierarchyLevelsWithCache: hierarchyLevelsWithCache,
        reorderFields: reorderFields,
        fieldsOrder: order,
        isVisibleFieldsCached: shouldGetVisibleFieldsFromCache,
        loading: loading,
        error: error
    };
};
const $caa9955f3c0147ae$export$fc1188611b218081 = ()=>{
    const constants = (0, $lt1LT.useConstants)();
    const { data: data, loading: loading, error: error } = (0, $1T2vX.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const availableFields = $caa9955f3c0147ae$var$buildListOfAvailableFields(data.fields, constants);
    (0, $avVp3.useUpdateFieldsDetail)(!loading && error == null ? availableFields : null);
    return null;
};

});
parcelRegister("6eSqc", function(module, exports) {

$parcel$export(module.exports, "useHierarchyCache", () => $bd31eaa7cf3733ec$export$c2cd1510e81d00ce);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $54qG5 = parcelRequire("54qG5");

var $1T2vX = parcelRequire("1T2vX");


var $ae0ja = parcelRequire("ae0ja");
const $bd31eaa7cf3733ec$export$c2cd1510e81d00ce = ({ view: view })=>{
    const { loading: loading, error: error, hierarchyLevels: newHierarchyLevels } = (0, $1T2vX.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const { data: entity } = (0, $54qG5.useBusinessEntity)();
    const localStorage = (0, $ae0ja.getLocalStorage)(view);
    const hierarchyStorageKey = `${entity.id}_${(0, $17d9937555b623d9$export$2cab30374aa79c41)}`;
    const [hierarchyLevels, setHierarchyLevels] = (0, $5uXOq.useState)(localStorage.get(hierarchyStorageKey));
    // save hierarchyLevels in localStorage
    (0, $5uXOq.useEffect)(()=>{
        if (!loading && !error) {
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(hierarchyLevels, newHierarchyLevels)) {
                setHierarchyLevels(newHierarchyLevels);
                localStorage.set(hierarchyStorageKey, newHierarchyLevels);
            }
        }
    }, [
        loading,
        error,
        hierarchyLevels,
        hierarchyStorageKey,
        setHierarchyLevels,
        localStorage,
        newHierarchyLevels
    ]);
    const hierarchyLevelsWithCache = (0, $5uXOq.useMemo)(()=>{
        // return from cache (localStorage)
        if (hierarchyLevels && Array.isArray(hierarchyLevels)) return hierarchyLevels;
        // returns nothing if available fields query is in progress. But if cache is empty, it returns newHierarchyLevels
        if (loading) return [];
        return newHierarchyLevels;
    }, [
        hierarchyLevels,
        loading,
        newHierarchyLevels
    ]);
    return {
        hierarchyLevelsWithCache: hierarchyLevelsWithCache
    };
};

});
const $17d9937555b623d9$export$2cab30374aa79c41 = 'hierarchy_levels';

parcelRegister("ae0ja", function(module, exports) {

$parcel$export(module.exports, "getLocalStorage", () => $d865db96ae8c3b63$export$d3720feff416e85b);

var $bSSG7 = parcelRequire("bSSG7");
const $d865db96ae8c3b63$export$d3720feff416e85b = (view)=>(0, $bSSG7.createLocalStorageProvider)(`jira_business_${view}-view`);

});


parcelRegister("lt1LT", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_CUSTOM_FIELDS_BY_TYPE", () => $41419a4f7af35dcb$export$5150e2d13825462d);
$parcel$export(module.exports, "getInitVisibleFields", () => $41419a4f7af35dcb$export$86172108eb1873dd);
$parcel$export(module.exports, "getAlwaysVisibleFields", () => $41419a4f7af35dcb$export$de476ed52b559d9);
$parcel$export(module.exports, "useConstants", () => $41419a4f7af35dcb$export$eedf91b09a0fe0d1);

var $5uXOq = parcelRequire("5uXOq");

var $imVeH = parcelRequire("imVeH");

var $hE5wF = parcelRequire("hE5wF");

var $daQYX = parcelRequire("daQYX");

var $7q7Al = parcelRequire("7q7Al");

var $koVbs = parcelRequire("koVbs");

var $e5wyW = parcelRequire("e5wyW");

var $5fc53 = parcelRequire("5fc53");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $4nnGr = parcelRequire("4nnGr");

var $03VXS = parcelRequire("03VXS");

var $5bGaW = parcelRequire("5bGaW");


var $dwwxm = parcelRequire("dwwxm");
const $41419a4f7af35dcb$export$5150e2d13825462d = [
    (0, $5fc53.CATEGORY_TYPE),
    (0, $5fc53.SPRINT_TYPE)
];
const $41419a4f7af35dcb$var$insertFieldAfter = (field, newField, list)=>{
    const position = list.indexOf(field) + 1;
    if (position > 0) list.splice(position, 0, newField);
};
const $41419a4f7af35dcb$var$getInitVisibleFieldsWithNoReorder = ({ isCategoryEnabled: isCategoryEnabled = true, isScrumProject: isScrumProject = false, entityId: entityId })=>{
    const visibleFields = [
        (0, $5fc53.ISSUE_TYPE),
        'key',
        (0, $5fc53.SUMMARY_TYPE),
        (0, $5fc53.STATUS_TYPE),
        isCategoryEnabled ? (0, $5fc53.CATEGORY_TYPE) : undefined,
        isScrumProject ? (0, $5fc53.SPRINT_TYPE) : undefined,
        (0, $5fc53.ASSIGNEE_TYPE),
        (0, $5fc53.DUE_DATE_TYPE),
        (0, $5fc53.PRIORITY_TYPE),
        (0, $5fc53.LABELS_TYPE),
        (0, $5fc53.CREATED),
        (0, $5fc53.UPDATED),
        (0, $5fc53.REPORTER_TYPE)
    ].filter(Boolean);
    if ((0, $6s1PB.expVal)('jira_unread_comments_in_list_view', 'isEnabled', false)) {
        visibleFields.splice(4, 0, (0, $hE5wF.COMMENT_SUMMARY_TYPE));
        const enabledCommentsFieldStorageKey = `${entityId}_${(0, $03VXS.ENABLED_COMMENTS_FIELD_LOCAL_STORAGE_KEY)}`;
        (0, $5bGaW.localStore).set(enabledCommentsFieldStorageKey, true);
    }
    return visibleFields;
};
const $41419a4f7af35dcb$var$getInitVisibleFieldsWithReorder = ({ isCategoryEnabled: isCategoryEnabled = true, isScrumProject: isScrumProject = false, entityId: entityId })=>{
    const visibleFields = [
        (0, $5fc53.ISSUE_TYPE),
        'key',
        (0, $5fc53.SUMMARY_TYPE),
        (0, $5fc53.STATUS_TYPE),
        isCategoryEnabled ? (0, $5fc53.CATEGORY_TYPE) : undefined,
        (0, $5fc53.ASSIGNEE_TYPE),
        (0, $5fc53.DUE_DATE_TYPE),
        (0, $5fc53.PRIORITY_TYPE),
        (0, $5fc53.LABELS_TYPE),
        (0, $5fc53.CREATED),
        (0, $5fc53.UPDATED),
        (0, $5fc53.REPORTER_TYPE)
    ].filter(Boolean);
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [routeBizConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('route_biz_to_kanban_revision');
    if ((0, $6s1PB.expVal)('jira_unread_comments_in_list_view', 'isEnabled', false)) {
        const isWizardCreatedProject = (0, $5bGaW.localStore).get(`${entityId}_${(0, $ac9ccc3e76f230b6$export$e6304a5e5749bfc7)}`) === true && ((0, $6s1PB.expVal)('jira_onboarding_enable_extra_fields_jsw_projects', 'isEnabled', false) || routeBizConfig.get('isEnabled', false));
        isWizardCreatedProject ? $41419a4f7af35dcb$var$insertFieldAfter((0, $5fc53.PRIORITY_TYPE), (0, $hE5wF.COMMENT_SUMMARY_TYPE), visibleFields) : $41419a4f7af35dcb$var$insertFieldAfter((0, $5fc53.STATUS_TYPE), (0, $hE5wF.COMMENT_SUMMARY_TYPE), visibleFields);
        const enabledCommentsFieldStorageKey = `${entityId}_${(0, $03VXS.ENABLED_COMMENTS_FIELD_LOCAL_STORAGE_KEY)}`;
        (0, $5bGaW.localStore).set(enabledCommentsFieldStorageKey, true);
        if (isScrumProject) isWizardCreatedProject ? $41419a4f7af35dcb$var$insertFieldAfter((0, $hE5wF.COMMENT_SUMMARY_TYPE), (0, $5fc53.SPRINT_TYPE), visibleFields) : $41419a4f7af35dcb$var$insertFieldAfter(isCategoryEnabled ? (0, $5fc53.CATEGORY_TYPE) : (0, $hE5wF.COMMENT_SUMMARY_TYPE), (0, $5fc53.SPRINT_TYPE), visibleFields);
    } else if (isScrumProject) (0, $5bGaW.localStore).get(`${entityId}_${(0, $ac9ccc3e76f230b6$export$e6304a5e5749bfc7)}`) === true && (0, $6s1PB.expVal)('jira_onboarding_enable_extra_fields_jsw_projects', 'isEnabled', false) ? $41419a4f7af35dcb$var$insertFieldAfter((0, $5fc53.PRIORITY_TYPE), (0, $5fc53.SPRINT_TYPE), visibleFields) : $41419a4f7af35dcb$var$insertFieldAfter(isCategoryEnabled ? (0, $5fc53.CATEGORY_TYPE) : (0, $5fc53.STATUS_TYPE), (0, $5fc53.SPRINT_TYPE), visibleFields);
    return visibleFields;
};
const $41419a4f7af35dcb$export$86172108eb1873dd = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('jira_list_view_reorder_fields_kill_switch'), $41419a4f7af35dcb$var$getInitVisibleFieldsWithReorder, $41419a4f7af35dcb$var$getInitVisibleFieldsWithNoReorder);
const $41419a4f7af35dcb$export$db265ae985088fd7 = ({ isCategoryEnabled: isCategoryEnabled = true, isScrumProject: isScrumProject = false })=>({
        [(0, $5fc53.ISSUE_TYPE)]: true,
        key: true,
        [(0, $5fc53.SUMMARY_TYPE)]: true,
        [(0, $5fc53.STATUS_TYPE)]: true,
        ...(0, $03VXS.isUnreadCommentsInListViewExperimentEnabled)() ? {
            [(0, $hE5wF.COMMENT_SUMMARY_TYPE)]: true
        } : {},
        ...isCategoryEnabled ? {
            [(0, $5fc53.CATEGORY_TYPE)]: true
        } : {},
        ...isScrumProject ? {
            [(0, $5fc53.SPRINT_TYPE)]: true
        } : {},
        [(0, $5fc53.ASSIGNEE_TYPE)]: true,
        [(0, $5fc53.DUE_DATE_TYPE)]: true,
        [(0, $5fc53.PRIORITY_TYPE)]: true,
        [(0, $5fc53.LABELS_TYPE)]: true,
        [(0, $5fc53.CREATED)]: true,
        [(0, $5fc53.UPDATED)]: true,
        [(0, $5fc53.REPORTER_TYPE)]: true
    });
const $41419a4f7af35dcb$export$de476ed52b559d9 = ()=>[
        (0, $5fc53.ISSUE_TYPE),
        'key',
        (0, $5fc53.SUMMARY_TYPE)
    ];
const $41419a4f7af35dcb$export$e4330d77fd93d1de = ({ defaultVisibleFields: defaultVisibleFields, hasConfluence: hasConfluence = false, isSoftwareFieldsEnabled: isSoftwareFieldsEnabled = false, isBusinessFieldsEnabled: isBusinessFieldsEnabled = true, isTeamManaged: isTeamManaged = true, isScrumProject: isScrumProject = false } = {})=>Object.keys(defaultVisibleFields ?? $41419a4f7af35dcb$export$db265ae985088fd7({
        isCategoryEnabled: isBusinessFieldsEnabled,
        isScrumProject: isScrumProject
    })).concat([
        (0, $5fc53.TEXT_CF_TYPE),
        (0, $5fc53.USER_CF_TYPE),
        (0, $5fc53.NUMBER_CF_TYPE),
        (0, $5fc53.TIME_ESTIMATE_TYPE),
        (0, $5fc53.TEXT_AREA_CF_TYPE),
        (0, $5fc53.DATE_CF_TYPE),
        (0, $5fc53.DATETIME_CF_TYPE),
        (0, $5fc53.SELECT_CF_TYPE),
        (0, $5fc53.MULTI_SELECT_CF_TYPE),
        (0, $5fc53.MULTI_CHECKBOXES_CF_TYPE),
        (0, $5fc53.URL_CF_TYPE),
        (0, $5fc53.MULTI_USER_CF_TYPE),
        (0, $5fc53.COMPONENTS_TYPE),
        (0, $5fc53.LABELS_CF_TYPE),
        (0, $5fc53.PEOPLE_CF_TYPE),
        ...(0, $03VXS.isUnreadCommentsInListViewExperimentEnabled)() ? [] : [
            (0, $hE5wF.COMMENT_SUMMARY_TYPE)
        ]
    ]).concat(isSoftwareFieldsEnabled && isTeamManaged ? [
        (0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE)
    ] : []).concat(isSoftwareFieldsEnabled && !isTeamManaged ? [
        (0, $5fc53.STORY_POINTS_TYPE)
    ] : []).concat(isSoftwareFieldsEnabled && !isScrumProject ? [
        (0, $5fc53.SPRINT_TYPE)
    ] : []).concat(hasConfluence ? [
        (0, $hE5wF.REMOTE_ISSUE_LINKS_TYPE)
    ] : []).concat((0, $7q7Al.getSupportedFieldTypes)(isSoftwareFieldsEnabled));
const $41419a4f7af35dcb$export$c7b8f0505fa10763 = (hasConfluence)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return (0, $5uXOq.useMemo)(()=>[
            {
                id: 'key',
                type: 'key',
                name: formatMessage((0, $dwwxm.default).key),
                issueTypes: [],
                fieldConfig: {
                    isRequired: true,
                    isEditable: false
                }
            },
            {
                id: (0, $hE5wF.COMMENT_SUMMARY_TYPE),
                type: (0, $hE5wF.COMMENT_SUMMARY_TYPE),
                name: formatMessage((0, $dwwxm.default).comments),
                issueTypes: [],
                fieldConfig: {
                    isRequired: true,
                    isEditable: false
                }
            },
            ...hasConfluence ? [
                {
                    id: (0, $hE5wF.REMOTE_ISSUE_LINKS_TYPE),
                    type: (0, $hE5wF.REMOTE_ISSUE_LINKS_TYPE),
                    name: formatMessage((0, $dwwxm.default).confluencePages),
                    issueTypes: [],
                    fieldConfig: {
                        isRequired: false,
                        isEditable: true
                    }
                }
            ] : []
        ], [
        formatMessage,
        hasConfluence
    ]);
};
const $41419a4f7af35dcb$export$eedf91b09a0fe0d1 = ()=>{
    const hasConfluence = (0, $imVeH.useTenantHasConfluence)();
    const projectData = (0, $daQYX.useProject)();
    const isTeamManaged = projectData.isSimplified;
    const { isSoftwareFieldsEnabled: isSoftwareFieldsEnabled, isBusinessFieldsEnabled: isBusinessFieldsEnabled, isScrumProject: isScrumProject } = (0, $4nnGr.useJWMListFeatures)();
    const missingFields = $41419a4f7af35dcb$export$c7b8f0505fa10763(hasConfluence);
    return (0, $5uXOq.useMemo)(()=>{
        const defaultVisibleFields = $41419a4f7af35dcb$export$db265ae985088fd7({
            isCategoryEnabled: isBusinessFieldsEnabled,
            isScrumProject: isScrumProject
        });
        const alwaysVisibleFields = $41419a4f7af35dcb$export$de476ed52b559d9();
        const supportedFieldTypes = $41419a4f7af35dcb$export$e4330d77fd93d1de({
            defaultVisibleFields: defaultVisibleFields,
            hasConfluence: hasConfluence,
            isSoftwareFieldsEnabled: isSoftwareFieldsEnabled,
            isBusinessFieldsEnabled: isBusinessFieldsEnabled,
            isTeamManaged: isTeamManaged,
            isScrumProject: isScrumProject
        });
        return {
            DEFAULT_VISIBLE_FIELDS: defaultVisibleFields,
            ALWAYS_VISIBLE_FIELDS: alwaysVisibleFields,
            SUPPORTED_FIELD_TYPES: supportedFieldTypes,
            MISSING_FIELDS: missingFields
        };
    }, [
        isBusinessFieldsEnabled,
        hasConfluence,
        isSoftwareFieldsEnabled,
        isTeamManaged,
        isScrumProject,
        missingFields
    ]);
};

});
parcelRegister("7q7Al", function(module, exports) {

$parcel$export(module.exports, "getSupportedFieldTypes", () => $06a9162b5061f29f$export$e4330d77fd93d1de);
$parcel$export(module.exports, "getTopLevelFieldKey", () => $06a9162b5061f29f$export$5a7b6a57d325d92);
$parcel$export(module.exports, "isTopLevelField", () => $06a9162b5061f29f$export$9ce71a7c226d8918);

var $8QpSo = parcelRequire("8QpSo");

var $fDZ77 = parcelRequire("fDZ77");


var $733SL = parcelRequire("733SL");

var $8FNbi = parcelRequire("8FNbi");

var $ekKiJ = parcelRequire("ekKiJ");

var $7cLw1 = parcelRequire("7cLw1");

var $k7N5y = parcelRequire("k7N5y");

var $cyODY = parcelRequire("cyODY");

var $8WpsQ = parcelRequire("8WpsQ");

var $3dSsD = parcelRequire("3dSsD");

var $fQVSU = parcelRequire("fQVSU");

var $8g1d0 = parcelRequire("8g1d0");
const $06a9162b5061f29f$export$e4330d77fd93d1de = (0, $8QpSo.default)((isSoftwareFieldsEnabled)=>[
        ...(0, $7cLw1.parentSupportedTypes),
        ...(0, $fQVSU.teamSupportedTypes),
        ...(0, $8WpsQ.resolutionSupportedTypes),
        ...(0, $ekKiJ.groupSupportedTypes),
        ...(0, $3dSsD.statusCategorySupportedTypes),
        ...(0, $k7N5y.projectSupportedTypes),
        ...(0, $fDZ77.cascadingSelectSupportedTypes),
        ...(0, $cyODY.radioSelectSupportedTypes),
        ...(0, $8FNbi.goalsSupportedTypes),
        ...isSoftwareFieldsEnabled ? [
            ...(0, $733SL.devSummarySupportedTypes),
            ...(0, $8g1d0.versionSupportedTypes)
        ] : []
    ]);
const $06a9162b5061f29f$export$6868d04e3954dca5 = (fieldType, isSoftwareFieldsEnabled = true)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $06a9162b5061f29f$export$e4330d77fd93d1de(isSoftwareFieldsEnabled).includes(fieldType);
// top level field
const $06a9162b5061f29f$var$TOP_LEVEL_FIELD = [
    ...(0, $733SL.devSummarySupportedTypes)
];
const $06a9162b5061f29f$var$isValidTopFieldType = (typename)=>true;
const $06a9162b5061f29f$export$5a7b6a57d325d92 = (fieldType)=>{
    if (!fieldType || !$06a9162b5061f29f$var$isValidTopFieldType(fieldType)) return null;
    if ((0, $733SL.devSummarySupportedTypes).includes(fieldType)) return 0, $677cd2eb13864f6c$export$72b5bd2391f1e7c0;
    return null;
};
const $06a9162b5061f29f$export$9ce71a7c226d8918 = (fieldType)=>{
    if (!fieldType || !$06a9162b5061f29f$var$isValidTopFieldType(fieldType)) return false;
    return $06a9162b5061f29f$var$TOP_LEVEL_FIELD.includes(fieldType);
};

});
parcelRegister("fDZ77", function(module, exports) {

$parcel$export(module.exports, "cascadingSelectSupportedTypes", () => $5bd2fe36390d1f16$export$caf76d0a4f04f1d);

var $5fc53 = parcelRequire("5fc53");
const $5bd2fe36390d1f16$export$caf76d0a4f04f1d = [
    (0, $5fc53.CASCADING_SELECT_CF_TYPE)
];

});

const $677cd2eb13864f6c$export$72b5bd2391f1e7c0 = 'devSummary';

parcelRegister("733SL", function(module, exports) {

$parcel$export(module.exports, "devSummarySupportedTypes", () => $02845184c1eb8060$export$22d58d85f8d7faea);

var $5fc53 = parcelRequire("5fc53");
const $02845184c1eb8060$export$22d58d85f8d7faea = [
    (0, $5fc53.DEV_SUMMARY_CF_TYPE)
];

});

parcelRegister("8FNbi", function(module, exports) {

$parcel$export(module.exports, "goalsSupportedTypes", () => $470c8570b6d1341d$export$bc170bcdefb8333f);

var $5fc53 = parcelRequire("5fc53");
const $470c8570b6d1341d$export$bc170bcdefb8333f = [
    (0, $5fc53.GOALS_CF_TYPE)
];

});

parcelRegister("ekKiJ", function(module, exports) {

$parcel$export(module.exports, "groupSupportedTypes", () => $114ec89a4fb2dc61$export$f3ef0b84bd022156);
$parcel$export(module.exports, "groupSupportedConditionalFormattingTypes", () => $114ec89a4fb2dc61$export$5da94d35e69a91e);

var $5fc53 = parcelRequire("5fc53");
const $114ec89a4fb2dc61$export$f3ef0b84bd022156 = [
    (0, $5fc53.GROUP_CF_TYPE),
    (0, $5fc53.MULTI_GROUP_CF_TYPE)
];
const $114ec89a4fb2dc61$export$5da94d35e69a91e = [
    (0, $5fc53.GROUP_CF_TYPE)
];

});

parcelRegister("7cLw1", function(module, exports) {

$parcel$export(module.exports, "parentSupportedTypes", () => $c5fb36828627f566$export$cc8590a96c2280c);

var $5fc53 = parcelRequire("5fc53");
const $c5fb36828627f566$export$cc8590a96c2280c = [
    (0, $5fc53.PARENT_TYPE)
];

});

parcelRegister("k7N5y", function(module, exports) {

$parcel$export(module.exports, "projectSupportedTypes", () => $017f46c4670101d3$export$ecab9c2d3c8390e9);

var $5fc53 = parcelRequire("5fc53");
const $017f46c4670101d3$export$ecab9c2d3c8390e9 = [
    (0, $5fc53.PROJECT_PICKER_CF_TYPE)
];

});

parcelRegister("cyODY", function(module, exports) {

$parcel$export(module.exports, "radioSelectSupportedTypes", () => $d22f5b68d5f35a42$export$a92ad538b45df386);

var $5fc53 = parcelRequire("5fc53");
const $d22f5b68d5f35a42$export$a92ad538b45df386 = [
    (0, $5fc53.RADIO_BUTTONS_CF_TYPE)
];

});

parcelRegister("8WpsQ", function(module, exports) {

$parcel$export(module.exports, "resolutionSupportedTypes", () => $ee0e811848af2dc6$export$89876769ad40213e);

var $5fc53 = parcelRequire("5fc53");
const $ee0e811848af2dc6$export$89876769ad40213e = [
    (0, $5fc53.RESOLUTION_TYPE)
];

});

parcelRegister("3dSsD", function(module, exports) {

$parcel$export(module.exports, "statusCategorySupportedTypes", () => $d093394df406eef3$export$ce1a6f07ee0c2fd4);

var $5fc53 = parcelRequire("5fc53");
const $d093394df406eef3$export$ce1a6f07ee0c2fd4 = [
    (0, $5fc53.STATUS_CATEGORY_TYPE)
];

});

parcelRegister("fQVSU", function(module, exports) {

$parcel$export(module.exports, "teamSupportedTypes", () => $9c5d2ff9e9ba22cf$export$7fe9ceb0183f4a3e);

var $5fc53 = parcelRequire("5fc53");
const $9c5d2ff9e9ba22cf$export$7fe9ceb0183f4a3e = [
    (0, $5fc53.TEAMS_PLATFORM_CF_TYPE)
];

});

parcelRegister("8g1d0", function(module, exports) {

$parcel$export(module.exports, "versionSupportedTypes", () => $c4377a5f6bed15e4$export$c35776c44a9e8a18);

var $5fc53 = parcelRequire("5fc53");
const $c4377a5f6bed15e4$export$c35776c44a9e8a18 = [
    (0, $5fc53.VERSION_CF_TYPE),
    (0, $5fc53.MULTI_VERSION_CF_TYPE),
    (0, $5fc53.FIX_VERSIONS_TYPE),
    (0, $5fc53.AFFECTS_VERSIONS_TYPE)
];

});


parcelRegister("03VXS", function(module, exports) {

$parcel$export(module.exports, "ENABLED_COMMENTS_FIELD_LOCAL_STORAGE_KEY", () => $aab311f73ff527c0$export$4e0f3dada38fa63b);
$parcel$export(module.exports, "isUnreadCommentsInListViewExperimentEnabled", () => $aab311f73ff527c0$export$3390aceb73d51c1a);

var $6s1PB = parcelRequire("6s1PB");
const $aab311f73ff527c0$export$4e0f3dada38fa63b = 'list_enabled_comments_field';
const $aab311f73ff527c0$export$3390aceb73d51c1a = ()=>{
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jira_unread_comments_in_list_view');
    return expConfig.get('isEnabled', false);
};

});

const $ac9ccc3e76f230b6$export$e6304a5e5749bfc7 = 'jira_project_with_wizard';

parcelRegister("dwwxm", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b0f17238a94f2d5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3b0f17238a94f2d5$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    key: {
        "id": "business-list.controllers.get-issue-fields.constants.key",
        "defaultMessage": "Key"
    },
    comments: {
        "id": "business-list.controllers.get-issue-fields.constants.comments",
        "defaultMessage": "Comments"
    },
    confluencePages: {
        "id": "business-list.controllers.get-issue-fields.constants.confluence-pages",
        "defaultMessage": "Confluence items"
    }
});

});


parcelRegister("avVp3", function(module, exports) {

$parcel$export(module.exports, "useUpdateFieldsDetail", () => $351f74ddc29ec171$export$33428c970fa4bad3);
$parcel$export(module.exports, "useFieldsActions", () => $351f74ddc29ec171$export$4027818e87c46ba5);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $54qG5 = parcelRequire("54qG5");

var $hE5wF = parcelRequire("hE5wF");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $gEb1A = parcelRequire("gEb1A");

var $lt1LT = parcelRequire("lt1LT");

var $drIRL = parcelRequire("drIRL");

var $5bGaW = parcelRequire("5bGaW");

var $03VXS = parcelRequire("03VXS");
const $351f74ddc29ec171$var$getFieldsCache = ({ availableFields: availableFields, fields: fields, order: order })=>{
    if (availableFields == null) return fields.details;
    const newDetails = {};
    availableFields.forEach(({ id: id, name: name, type: type })=>{
        if (order.includes(id)) newDetails[id] = {
            id: id,
            name: name,
            type: type
        };
        else if (type != null && order.includes(type)) newDetails[type] = {
            id: id,
            name: name,
            type: type
        };
    });
    return newDetails;
};
const $351f74ddc29ec171$export$33428c970fa4bad3 = (availableFields)=>{
    const [fields, setFields] = (0, $drIRL.useFieldsPreference)((0, $6s1PB.expVal)('jira_unread_comments_in_list_view', 'isEnabled', false) ? true : undefined);
    const { data: entity } = (0, $54qG5.useBusinessEntity)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const enabledCommentsFieldStorageKey = `${entity.id}_${(0, $03VXS.ENABLED_COMMENTS_FIELD_LOCAL_STORAGE_KEY)}`;
    (0, $5uXOq.useEffect)(()=>{
        if (availableFields != null) setFields({
            order: fields.order,
            details: $351f74ddc29ec171$var$getFieldsCache({
                order: fields.order,
                fields: fields,
                availableFields: availableFields
            })
        });
        else if ((0, $4R6GH.fg)('_jira_unread_comments_in_list_view_gate')) {
            const hasCommentsFieldBeenPreviouslyEnabled = (0, $5bGaW.localStore).get(enabledCommentsFieldStorageKey);
            if (!fields.order.includes((0, $hE5wF.COMMENT_SUMMARY_TYPE)) && !hasCommentsFieldBeenPreviouslyEnabled && (0, $6s1PB.expVal)('jira_unread_comments_in_list_view', 'isEnabled', false)) {
                const newFieldsOrder = [
                    ...fields.order
                ];
                const commentsFieldIndex = fields.order.length > 3 ? 4 : 3;
                newFieldsOrder.splice(commentsFieldIndex, 0, (0, $hE5wF.COMMENT_SUMMARY_TYPE));
                setFields({
                    order: newFieldsOrder,
                    details: fields.details
                });
                (0, $5bGaW.localStore).set(enabledCommentsFieldStorageKey, true);
                (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'commentsColumn enabled', {
                    location: 'Updating fields'
                });
            }
        }
    // We only want to update cache when available fields change the first time
    // OR when we are adding the comments field for the first time
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        availableFields
    ]);
};
const $351f74ddc29ec171$export$4027818e87c46ba5 = (availableFields)=>{
    const [fields, setFields, setFieldsOld] = (0, $drIRL.useFieldsPreference)();
    const [{ createIndex: createIndex, createFields: createFields }] = (0, $gEb1A.useInlineFieldCreateControls)();
    const resetCache = (0, $5uXOq.useCallback)(()=>{
        setFields(undefined);
        setFieldsOld(undefined);
    }, [
        setFields,
        setFieldsOld
    ]);
    const reorderFields = (0, $5uXOq.useCallback)(({ visibleFields: visibleFields, oldIndex: oldIndex, newIndex: newIndex })=>{
        try {
            if (oldIndex === newIndex) return;
            let oldFieldIndex = oldIndex;
            let newFieldIndex = newIndex;
            if (newFieldIndex < 3) /*
                    moving column to:
                    - the first position it's not possible due to the bulk selection
                    - the second position it's not possible because the type issue should not be repositioned
                    - the third position it's not possible because the key issue should not be repositioned
                */ return;
            // We have an extra column at the beginning for bulk selection
            // that should be considered to reorder fields
            oldFieldIndex -= 1;
            newFieldIndex -= 1;
            const reorderedFields = [
                ...visibleFields
            ];
            const [reorderedField] = reorderedFields.splice(oldFieldIndex, 1);
            reorderedFields.splice(newFieldIndex, 0, reorderedField);
            // visibleFields is initially set by DEFAULT_VISIBLE_FIELDS which are type based
            // we need to keep it consistent for those fields as getAvailableFields finds this field by type
            const fieldsOrder = reorderedFields.map((field)=>field?.type && (0, $lt1LT.DEFAULT_CUSTOM_FIELDS_BY_TYPE).includes(field.type) ? field.type : field.id);
            setFields({
                ...fields,
                order: fieldsOrder
            });
        } catch (error) {
            resetCache();
            (0, $jcw0u.default)({
                meta: {
                    id: 'reorderFields',
                    packageName: 'jiraBusinessList',
                    teamName: 'keystone'
                },
                attributes: {
                    message: 'Error trying to reorder the fields'
                },
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        fields,
        resetCache,
        setFields
    ]);
    const toggleField = (0, $5uXOq.useCallback)((fieldId)=>{
        try {
            const isVisible = fields.order.includes(fieldId);
            const newFieldsOrder = [
                ...fields.order
            ];
            let createColumnIndex = createIndex;
            if (createFields) {
                const createField = createFields.find((f)=>f.fieldId === fieldId);
                createColumnIndex = createField?.createIndex ?? createColumnIndex;
            }
            if (!isVisible) {
                if (typeof createColumnIndex !== 'undefined') newFieldsOrder.splice(createColumnIndex, 0, fieldId);
                else newFieldsOrder.push(fieldId);
            } else {
                const fieldIndex = newFieldsOrder.findIndex((fId)=>fId === fieldId);
                if (fieldIndex >= 0) newFieldsOrder.splice(fieldIndex, 1);
            }
            setFields({
                order: newFieldsOrder,
                details: $351f74ddc29ec171$var$getFieldsCache({
                    availableFields: availableFields,
                    fields: fields,
                    order: newFieldsOrder
                })
            });
        } catch (error) {
            resetCache();
            (0, $jcw0u.default)({
                meta: {
                    id: 'toggleFields',
                    packageName: 'jiraBusinessList',
                    teamName: 'keystone'
                },
                attributes: {
                    message: 'Error trying to toogle a field'
                },
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        fields,
        createIndex,
        createFields,
        setFields,
        availableFields,
        resetCache
    ]);
    return {
        fields: fields,
        toggleField: toggleField,
        reorderFields: reorderFields,
        resetCache: resetCache
    };
};

});
parcelRegister("gEb1A", function(module, exports) {

$parcel$export(module.exports, "useInlineFieldCreateControls", () => $a0cf18d02e0a77bd$export$d98d27d7d9c6b61f);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $a0cf18d02e0a77bd$var$actions = {
    setIsSelected: (isSelected)=>({ setState: setState })=>{
            setState({
                isSelected: isSelected
            });
        },
    setCreateIndex: (columnIndex)=>({ setState: setState })=>{
            setState({
                createIndex: columnIndex !== undefined ? columnIndex + 1 : undefined
            });
        },
    clearCreateIndex: ()=>({ setState: setState })=>{
            setState({
                createIndex: undefined
            });
        },
    addCreateField: ({ fieldId: fieldId, name: name, type: type })=>({ setState: setState, getState: getState })=>{
            setState({
                createFields: [
                    ...getState().createFields,
                    {
                        fieldId: fieldId,
                        name: name,
                        type: type,
                        createIndex: getState().createIndex
                    }
                ]
            });
        },
    removeCreateField: (fieldId)=>({ setState: setState, getState: getState })=>{
            setState({
                createFields: [
                    ...getState().createFields.filter((field)=>field.fieldId !== fieldId)
                ]
            });
        }
};
const $a0cf18d02e0a77bd$var$Store = (0, $iXqE5.createStore)({
    initialState: {
        isSelected: false,
        createIndex: undefined,
        createFields: []
    },
    actions: $a0cf18d02e0a77bd$var$actions,
    name: 'JwmListInlineFieldCreate'
});
const $a0cf18d02e0a77bd$export$d98d27d7d9c6b61f = (0, $3sQ5x.createHook)($a0cf18d02e0a77bd$var$Store);

});

parcelRegister("drIRL", function(module, exports) {

$parcel$export(module.exports, "useFieldsPreference", () => $6d00c670b20c3715$export$46ce869a6df40a8b);

var $5uXOq = parcelRequire("5uXOq");

var $x8FYU = parcelRequire("x8FYU");

var $1kpI8 = parcelRequire("1kpI8");

var $6s1PB = parcelRequire("6s1PB");

var $54qG5 = parcelRequire("54qG5");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $4nnGr = parcelRequire("4nnGr");

var $lt1LT = parcelRequire("lt1LT");
const $6d00c670b20c3715$export$46ce869a6df40a8b = (fromUpdateFieldDetails)=>{
    const [fields, setFieldsOld] = (0, $1kpI8.useViewPreference)((0, $x8FYU.FIELDS_PREFERENCE));
    const [fieldsDetail, setFields] = (0, $1kpI8.useViewPreference)((0, $x8FYU.FIELDS_DETAIL_PREFERENCE));
    const { isBusinessFieldsEnabled: isBusinessFieldsEnabled, isScrumProject: isScrumProject } = (0, $4nnGr.useJWMListFeatures)();
    const { data: entity } = (0, $54qG5.useBusinessEntity)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    // We want to only fire track analytics once when fields are being initialised
    (0, $5uXOq.useEffect)(()=>{
        if (fromUpdateFieldDetails && (fieldsDetail == null || !Array.isArray(fieldsDetail.order)) && (0, $6s1PB.expVal)('jira_unread_comments_in_list_view', 'isEnabled', false)) (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'commentsColumn enabled', {
            location: 'Initialising fields'
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const fieldsPreferences = (0, $5uXOq.useMemo)(()=>{
        if (fieldsDetail == null && fields != null) return {
            order: fields,
            details: null
        };
        if (fieldsDetail == null || !Array.isArray(fieldsDetail.order)) return {
            order: (0, $lt1LT.getInitVisibleFields)({
                isCategoryEnabled: isBusinessFieldsEnabled,
                isScrumProject: isScrumProject,
                ...(0, $6s1PB.expVal)('jira_unread_comments_in_list_view', 'isEnabled', false) ? {
                    entityId: entity.id
                } : {}
            }),
            details: null
        };
        return fieldsDetail;
    }, [
        fieldsDetail,
        fields,
        isBusinessFieldsEnabled,
        isScrumProject,
        entity.id
    ]);
    return [
        fieldsPreferences,
        setFields,
        setFieldsOld
    ];
};

});


parcelRegister("4yxtN", function(module, exports) {

$parcel$export(module.exports, "useFieldsCache", () => $8364c6e8a86b2f99$export$2fa1686d7312ac20);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $54qG5 = parcelRequire("54qG5");

var $5bGaW = parcelRequire("5bGaW");
const $8364c6e8a86b2f99$var$QUERY_FIELDS_ID_LOCAL_STORAGE_KEY = 'query_fields_id';
const $8364c6e8a86b2f99$export$2fa1686d7312ac20 = ({ loading: loading, error: error, getQueryFieldIds: getQueryFieldIds })=>{
    const { data: entity } = (0, $54qG5.useBusinessEntity)();
    const queryFieldsStorageKey = `${entity.id}_${$8364c6e8a86b2f99$var$QUERY_FIELDS_ID_LOCAL_STORAGE_KEY}`;
    const [queryFieldIds, setQueryFieldsIds] = (0, $5uXOq.useState)((0, $5bGaW.localStorage).get(queryFieldsStorageKey));
    // save queryFieldIds in localStorage on initial page load when queryFieldIds are empty in localStorage
    (0, $5uXOq.useEffect)(()=>{
        if (!loading && !error) {
            const newQueryFieldIds = getQueryFieldIds();
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(queryFieldIds, newQueryFieldIds)) {
                setQueryFieldsIds(newQueryFieldIds);
                (0, $5bGaW.localStorage).set(queryFieldsStorageKey, newQueryFieldIds);
            }
        }
    }, [
        loading,
        error,
        getQueryFieldIds,
        queryFieldsStorageKey,
        queryFieldIds,
        setQueryFieldsIds
    ]);
    const getQueryFieldIdsWithCache = (0, $5uXOq.useCallback)(()=>{
        // return from cache (localStorage)
        if (queryFieldIds && Array.isArray(queryFieldIds)) return queryFieldIds;
        // returns nothing if available fields query is in progress. But if cache is empty, it calls getQueryFieldIds
        if (loading) return [];
        return getQueryFieldIds();
    }, [
        getQueryFieldIds,
        loading,
        queryFieldIds
    ]);
    return {
        getQueryFieldIdsWithCache: getQueryFieldIdsWithCache
    };
};

});


parcelRegister("5HTKY", function(module, exports) {

$parcel$export(module.exports, "default", () => $da0cd9ca4631d484$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $da0cd9ca4631d484$var$GroupUpdater = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("5Kkic")), {
    ssr: false,
    moduleId: "./src/packages/business/list/src/controllers/group-updater/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$da0cd9ca4631d484$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jwm-group-updater",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($da0cd9ca4631d484$var$GroupUpdater, props));

});
parcelRegister("5Kkic", function(module, exports) {

let $42f0fd48967d6601$var$load = (parcelRequire("28QjX"))(4);
module.exports = $42f0fd48967d6601$var$load("ccCqM").then(()=>parcelRequire('a1ET1'));

});


parcelRegister("gijCE", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2667eebc48b622e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8e3Yw = parcelRequire("8e3Yw");

var $ayaYc = parcelRequire("ayaYc");

var $jahNX = parcelRequire("jahNX");

var $aKtkc = parcelRequire("aKtkc");
const $e2667eebc48b622e$var$Hierarchy = ()=>{
    const { childrenLoader: childrenLoader } = (0, $ayaYc.useChildrenLoader)();
    const [groupByFieldId] = (0, $8e3Yw.useGroupBy)();
    // avoid re-fetching children when Hierarchy component re-renders
    const childItemsLoader = (0, $5uXOq.useMemo)(()=>childrenLoader, [
        childrenLoader
    ]);
    const shouldGroupItems = groupByFieldId != null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, shouldGroupItems ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jahNX.default), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aKtkc.default), null), childItemsLoader);
};
var // eslint-disable-next-line @typescript-eslint/no-explicit-any
$e2667eebc48b622e$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($e2667eebc48b622e$var$Hierarchy);

});
parcelRegister("ayaYc", function(module, exports) {

$parcel$export(module.exports, "useChildrenLoader", () => $6ac6c3206164d3b9$export$10e8857fe2182cb4);

var $5uXOq = parcelRequire("5uXOq");

var $1T2vX = parcelRequire("1T2vX");

var $deqCE = parcelRequire("deqCE");

var $jDUax = parcelRequire("jDUax");

var $fel5A = parcelRequire("fel5A");

var $eSwsD = parcelRequire("eSwsD");

var $9u99d = parcelRequire("9u99d");

var $8Ugqh = parcelRequire("8Ugqh");
const $6ac6c3206164d3b9$export$10e8857fe2182cb4 = ()=>{
    const [{ expandedItems: expandedItems, childrenItems: childrenItems, issuesMap: issuesMap }] = (0, $9u99d.useHierarchyStore)();
    const { data: data } = (0, $1T2vX.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const { setChildrenItems: setChildrenItems } = (0, $8Ugqh.useSetChildrenItems)();
    const getHierarchyLevel = (0, $5uXOq.useCallback)((issueId)=>{
        const maybeIssue = issuesMap.get(issueId);
        if (!maybeIssue) return undefined;
        const maybeIssueTypeData = data.issueTypes.find((issueType)=>issueType.id === maybeIssue.issuetype.id);
        if (!maybeIssueTypeData) return undefined;
        return maybeIssueTypeData.hierarchyLevel;
    }, [
        data.issueTypes,
        issuesMap
    ]);
    const childrenLoader = (0, $5uXOq.useMemo)(()=>{
        const expandedItemIssueIds = Object.keys(expandedItems).filter((issueId)=>!(0, $jDUax.isGroupItem)(issueId) && // exclude optimistically created items that'd immediately be expanded when "Expand All" is on
            String(issueId) !== String((0, $deqCE.OPTIMISTIC_ISSUE_ID)));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fel5A.ChildrenController), {
            expandedItemIssueIds: expandedItemIssueIds,
            loadingIssueIds: expandedItemIssueIds.filter((expandedItemId)=>!childrenItems[expandedItemId] || childrenItems[expandedItemId].loading),
            setChildrenQueryData: setChildrenItems,
            ChildQueryController: (0, $eSwsD.ListViewChildQueryController),
            getHierarchyLevel: getHierarchyLevel
        });
    }, [
        expandedItems,
        setChildrenItems,
        getHierarchyLevel,
        childrenItems
    ]);
    return {
        childrenLoader: childrenLoader
    };
};

});
parcelRegister("fel5A", function(module, exports) {

$parcel$export(module.exports, "ChildrenController", () => $0a07eaf715c6ad45$export$8c3512dd18e9e8f);

var $5uXOq = parcelRequire("5uXOq");

const $0a07eaf715c6ad45$export$8c3512dd18e9e8f = /*#__PURE__*/ (0, $5uXOq.memo)(({ expandedItemIssueIds: expandedItemIssueIds, setChildrenQueryData: setChildrenQueryData, ChildQueryController: ChildQueryController, getHierarchyLevel: getHierarchyLevel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, expandedItemIssueIds.map((expandedItemIssueId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ChildQueryController, {
            parentIssueId: expandedItemIssueId,
            parentHierarchyType: (0, $8debe7dace56daea$export$9355e489ad16f98e),
            parentHierarchyLevel: getHierarchyLevel ? getHierarchyLevel(expandedItemIssueId) : undefined,
            onDataChange: setChildrenQueryData,
            key: expandedItemIssueId
        }))), (prevProps, nextProps)=>{
    const prevIssueIds = prevProps.expandedItemIssueIds.sort();
    const nextIssueIds = nextProps.expandedItemIssueIds.sort();
    const prevLoadingIssueIds = prevProps.loadingIssueIds?.sort();
    const nextLoadingIssueIds = nextProps.loadingIssueIds?.sort();
    let loadingIssuesMatch = true;
    if (prevLoadingIssueIds === undefined || nextLoadingIssueIds === undefined) loadingIssuesMatch = prevLoadingIssueIds === nextLoadingIssueIds;
    else loadingIssuesMatch = prevLoadingIssueIds?.length === nextLoadingIssueIds?.length && prevLoadingIssueIds.every((_, id)=>prevLoadingIssueIds[id] === nextLoadingIssueIds[id]);
    return prevProps.setChildrenQueryData === nextProps.setChildrenQueryData && prevIssueIds.length === nextIssueIds.length && prevIssueIds.every((_, id)=>prevIssueIds[id] === nextIssueIds[id]) && loadingIssuesMatch;
});

});

parcelRegister("eSwsD", function(module, exports) {

$parcel$export(module.exports, "ListViewChildQueryController", () => $206788a0341995dd$export$fffae14cb4664bb4);

var $5uXOq = parcelRequire("5uXOq");

var $cm8b5 = parcelRequire("cm8b5");

var $kRkJF = parcelRequire("kRkJF");

var $9SwwX = parcelRequire("9SwwX");

var $8tf7c = parcelRequire("8tf7c");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $eTDjN = parcelRequire("eTDjN");

var $h7hV2 = parcelRequire("h7hV2");

var $8TUlY = parcelRequire("8TUlY");

var $dC9wp = parcelRequire("dC9wp");
const $206788a0341995dd$export$fffae14cb4664bb4 = /*#__PURE__*/ (0, $5uXOq.memo)(({ parentHierarchyType: parentHierarchyType, parentIssueId: parentIssueId, onDataChange: onDataChange, parentHierarchyLevel: parentHierarchyLevel })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { jqlContext: jqlContext, quickFiltersJql: quickFiltersJql, sorting: sorting, isHidingDoneItems: isHidingDoneItems } = (0, $kRkJF.useFilteredViewContextInput)({
        view: 'list'
    });
    const { getQueryFieldIds: getQueryFieldIds, loading: isLoadingFields, isParentFieldVisible: isParentFieldVisible, isDevSummaryFieldVisible: isDevSummaryFieldVisible } = (0, $8TUlY.useIssueFields)();
    const onComplete = (0, $5uXOq.useCallback)((responseData)=>{
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'listChildrenData fetched', {
            totalChildren: (0, $9SwwX.getAGGCompliantData)(responseData, 'list')?.edges?.length,
            parentIssueId: parentIssueId,
            hierarchyLevel: parentHierarchyLevel
        });
    }, [
        createAnalyticsEvent,
        parentHierarchyLevel,
        parentIssueId
    ]);
    const { data: data, error: error, hasNextPage: hasNextPage, isLoadingNextPage: isLoadingNextPage, loading: loading, loadNextPage: loadNextPage } = (0, $h7hV2.useListViewIssues)({
        input: {
            jqlContext: jqlContext,
            fieldIds: getQueryFieldIds(),
            quickFiltersJql: quickFiltersJql,
            parentIssue: {
                hierarchyType: parentHierarchyType,
                hierarchyLevel: parentHierarchyLevel,
                issueId: parentIssueId
            },
            sorting: sorting,
            isHidingDoneItems: isHidingDoneItems,
            isParentFieldVisible: isParentFieldVisible(),
            isDevSummaryFieldVisible: isDevSummaryFieldVisible()
        },
        condition: !isLoadingFields,
        onComplete: onComplete
    });
    (0, $cm8b5.useQueryBasedViewAutomaticTracking)((0, $eTDjN.LOAD_CHILDREN_EXPERIENCE), {
        loading: loading,
        error: error,
        shouldStartExperience: true
    });
    (0, $5uXOq.useEffect)(()=>{
        onDataChange(parentIssueId, {
            data: data,
            error: error,
            hasNextPage: hasNextPage,
            isLoadingNextPage: isLoadingNextPage,
            loading: loading,
            loadNextPage: loadNextPage
        });
    }, [
        data,
        error,
        hasNextPage,
        isLoadingNextPage,
        loading,
        loadNextPage,
        onDataChange,
        parentIssueId
    ]);
    return error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8tf7c.ErrorFlag), {
        error: error,
        title: (0, $dC9wp.default).errorTitle,
        description: (0, $dC9wp.default).errorMessage
    }) : null;
});

});
parcelRegister("9SwwX", function(module, exports) {

$parcel$export(module.exports, "useFetchMore", () => $0f8617a70c5d6b6c$export$d84f34af2f3f5d9f);
$parcel$export(module.exports, "getAGGCompliantData", () => $0f8617a70c5d6b6c$export$5a178cf599565b50);

var $5tTFS = parcelRequire("5tTFS");

var $e3a3O = parcelRequire("e3a3O");

var $8Qi2I = parcelRequire("8Qi2I");

var $c9Ur7 = parcelRequire("c9Ur7");

var $4R6GH = parcelRequire("4R6GH");

var $fPruT = parcelRequire("fPruT");
function $0f8617a70c5d6b6c$export$2b602b4ab6fde7b6({ after: after, onError: onError, errorPolicy: errorPolicy = 'none', updateQuery: updateQuery, query: query, variables: variables, client: client }) {
    const variablesWithAfter = {
        ...variables,
        after: after
    };
    return client.query({
        query: query,
        variables: variablesWithAfter,
        fetchPolicy: 'no-cache',
        errorPolicy: errorPolicy
    }).then((response)=>{
        if (!response) return;
        if (response.errors) {
            onError && onError(new (0, $e3a3O.ApolloError)({
                graphQLErrors: response.errors
            }));
            if (errorPolicy === 'none') return;
        }
        if (response.data == null) return;
        // Update cache based on updateQuery method
        const prevData = client.readQuery({
            query: query,
            variables: variables
        });
        if (prevData == null) // It should not happened, adding the check just to make flow happpy
        return;
        const newData = updateQuery(prevData, {
            fetchMoreResult: response.data,
            variables: variablesWithAfter
        });
        client.writeQuery({
            query: query,
            variables: variables,
            // @ts-expect-error - TS2345 - Argument of type '{ query: DocumentNode; variables: TVariables; notifyOnNetworkStatusChange: boolean; data: TData; }' is not assignable to parameter of type 'WriteQueryOptions<TData, TVariables>'.
            notifyOnNetworkStatusChange: true,
            data: newData
        });
    }).catch((err)=>{
        onError && onError(err);
    });
}
function $0f8617a70c5d6b6c$export$d84f34af2f3f5d9f({ variables: variables, query: query }) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const client = (0, $5tTFS.useApolloClient)();
    // We're using `useDeepMemo` instead of `useCallback`/`useMemo` as it's very
    // likely that the `variables` dependency will change with each render even
    // though its contents will remain the same. Doing this stops us from
    // unnecessarily returning a new callback, as this could trigger unnecessary
    // rerenders or side-effects.
    return (0, $8Qi2I.useDeepMemo)(()=>(options)=>$0f8617a70c5d6b6c$export$2b602b4ab6fde7b6({
                ...options,
                variables: variables,
                query: query,
                client: client
            }), [
        client,
        variables,
        query
    ]);
}
function $0f8617a70c5d6b6c$export$5a178cf599565b50(data, listName, onError) {
    if (listName && data?.jira?.[listName]) {
        const _data = data.jira[listName];
        if (_data?.__typename === 'QueryError') {
            const queryError = new (0, $c9Ur7.QueryError)(_data);
            if (queryError.extensions?.find((ex)=>ex.statusCode === 401) && !(0, $4R6GH.fg)('flingo-1623-ignore-throw-to-sentry')) throw new (0, $fPruT.AuthenticationError)(_data.message);
            if (onError) {
                onError(_data);
                return undefined;
            }
            throw new (0, $c9Ur7.QueryError)(_data);
        }
        return _data;
    }
    return undefined;
}

});
parcelRegister("8Qi2I", function(module, exports) {

$parcel$export(module.exports, "useDeepMemo", () => $5b0bf94477e3396a$export$722debc0e56fea39);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");
const $5b0bf94477e3396a$export$722debc0e56fea39 = (memoFn, deps)=>{
    const ref = (0, $5uXOq.useRef)();
    if (!ref.current || !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(ref.current.deps, deps)) ref.current = {
        value: memoFn(),
        deps: deps
    };
    return ref.current.value;
};

});


parcelRegister("8tf7c", function(module, exports) {

$parcel$export(module.exports, "ErrorFlag", () => $b20ca95c735c7779$export$518ba8e0e60f145f);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $jJZqs = parcelRequire("jJZqs");

var $LJaTB = parcelRequire("LJaTB");
const $b20ca95c735c7779$export$518ba8e0e60f145f = ({ error: error, title: title, description: description })=>{
    if (!error) return null;
    if (error instanceof (0, $jJZqs.ValidationError)) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const errorMessage = error.message || error.errors && error.errors[0] && error.errors[0].error || description;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $LJaTB.FlagRenderer), {
            flag: {
                messageId: 'issue-error-flag.flag.warning.issue.fields.components.error-flag.flag.warning',
                messageType: 'transactional',
                type: 'warning',
                title: title,
                description: errorMessage,
                testId: (0, $4R6GH.fg)('relay-migration-issue-fields-number') ? 'issue-error-flag.error-flag.warning' : undefined
            }
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $LJaTB.FlagRenderer), {
        flag: {
            messageId: 'issue-error-flag.flag.error.issue.fields.components.error-flag.flag.error',
            messageType: 'transactional',
            type: 'error',
            title: title,
            description: description,
            testId: (0, $4R6GH.fg)('relay-migration-issue-fields-number') ? 'issue-error-flag.error-flag.error' : undefined
        }
    });
};

});
parcelRegister("LJaTB", function(module, exports) {

$parcel$export(module.exports, "FlagRenderer", () => $2de6889b93863972$export$7c38ebd1f7ca6a5a);

var $hkhmi = parcelRequire("hkhmi");

var $34Vv8 = parcelRequire("34Vv8");
const $2de6889b93863972$export$7c38ebd1f7ca6a5a = (0, $34Vv8.default)((0, $hkhmi.default));

});
parcelRegister("hkhmi", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2971dd786c0add8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fHfPB = parcelRequire("fHfPB");
class $e2971dd786c0add8$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { flagService: flagService, flag: flag } = this.props;
        if (flagService) this.flagId = flagService.showFlag(flag);
    }
    componentWillUnmount() {
        const { flagService: flagService } = this.props;
        if (flagService && this.flagId) flagService.dismissFlag((0, $fHfPB.dismissFlag)(this.flagId));
    }
    render() {
        return null;
    }
}

});



parcelRegister("h7hV2", function(module, exports) {

$parcel$export(module.exports, "useListViewIssues", () => $03b2587a35d6e361$export$3c9c5774f09af6c0);

var $5uXOq = parcelRequire("5uXOq");

var $egmQO = parcelRequire("egmQO");

var $8Wswo = parcelRequire("8Wswo");

var $2UUq6 = parcelRequire("2UUq6");

var $cvbVg = parcelRequire("cvbVg");

var $9SwwX = parcelRequire("9SwwX");


var $gN11a = parcelRequire("gN11a");

var $jcw0u = parcelRequire("jcw0u");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $koeKL = parcelRequire("koeKL");

var $6s1PB = parcelRequire("6s1PB");

var $4NLOw = parcelRequire("4NLOw");

var $61h55 = parcelRequire("61h55");

var $bsMMx = parcelRequire("bsMMx");
const $03b2587a35d6e361$var$emptyArray = [];
const $03b2587a35d6e361$export$3c9c5774f09af6c0 = ({ input: input, condition: condition = true, onComplete: onComplete })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [hasLoadingStarted, setHasLoadingStarted] = (0, $5uXOq.useState)(false);
    const cloudId = (0, $koeKL.useCloudId)();
    const onNextPageLoaded = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'table endReached');
    }, [
        createAnalyticsEvent
    ]);
    const queryVariables = (0, $egmQO.getVariables)(input);
    const { data: data, loadFirstPage: loadFirstPage, hasNextPage: hasNextPage, loading: loading, error: error, loadNextPage: loadNextPage, isLoadingNextPage: isLoadingNextPage } = (0, $cvbVg.useJqlPagination)({
        variables: {
            cloudId: cloudId,
            ...queryVariables
        },
        errorPolicy: 'all',
        query: (0, $61h55.LIST_VIEW_QUERY),
        onCompleted: (responseData)=>{
            const listData = (0, $9SwwX.getAGGCompliantData)(responseData, 'list');
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'listViewItemsQuery succeeded', {
                issuesCount: listData?.edges?.length,
                ...(0, $6s1PB.expVal)('jira_unread_comments_in_list_view', 'isEnabled', false) ? {
                    numberOfIssuesWithUnreadComments: listData?.edges?.filter((item)=>item?.node?.commentSummary?.hasUnreadComment).length
                } : {}
            });
            (0, $gN11a.markViewMetric)('list', (0, $a286480ec63fa4c8$export$83ca21a50372ea3b));
            if (onComplete) onComplete(responseData);
        },
        onError: (apolloError)=>{
            if (!(0, $4NLOw.shouldHandleTheError)(apolloError)) return;
            (0, $jcw0u.default)({
                meta: {
                    id: 'listViewItemsQuery',
                    packageName: 'jiraBusinessList',
                    teamName: 'keystone'
                },
                attributes: {
                    message: 'Failed to fetch issues in list view',
                    ...(0, $8Wswo.getGraphqlErrorAttributes)(apolloError)
                },
                error: apolloError,
                sendToPrivacyUnsafeSplunk: true
            });
            (0, $gN11a.markViewMetric)('list', (0, $a286480ec63fa4c8$export$83ca21a50372ea3b));
        },
        onPaginationError: (apolloError)=>{
            if (!(0, $4NLOw.shouldHandleTheError)(apolloError)) return;
            (0, $jcw0u.default)({
                meta: {
                    id: 'listViewPaginationQuery',
                    packageName: 'jiraBusinessList',
                    teamName: 'keystone'
                },
                attributes: {
                    message: 'Failed to fetch more issues in list view',
                    ...(0, $8Wswo.getGraphqlErrorAttributes)(apolloError)
                },
                error: apolloError,
                sendToPrivacyUnsafeSplunk: true
            });
        },
        onNextPageLoaded: onNextPageLoaded
    });
    (0, $5uXOq.useEffect)(()=>{
        // only call once when condition === true
        if (!data && condition) {
            (0, $gN11a.markViewMetric)('list', (0, $a286480ec63fa4c8$export$23e322eb7c526958));
            loadFirstPage();
            setHasLoadingStarted(true);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        condition,
        data
    ]);
    const { sort: sort } = (0, $2UUq6.useSorter)();
    const _data = (0, $9SwwX.getAGGCompliantData)(data, 'list');
    const edges = _data?.edges || $03b2587a35d6e361$var$emptyArray;
    const intl = (0, $koVbs.default)();
    const result = (0, $5uXOq.useMemo)(()=>{
        if (Array.isArray(edges) && edges.length === 0) return edges;
        const cacheVariables = {
            jql: queryVariables.jql,
            withConfluenceLinks: queryVariables.withConfluenceLinks,
            includeDoneItems: queryVariables.includeDoneItems,
            isParentFieldVisible: queryVariables.isParentFieldVisible,
            isDevSummaryFieldVisible: queryVariables.isDevSummaryFieldVisible,
            includeIsVerifiedInTeamFragment: queryVariables.includeIsVerifiedInTeamFragment
        };
        return sort(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $bsMMx.transformResult)(edges, {
            cacheVariables: cacheVariables,
            intl: intl
        }));
    }, [
        edges,
        sort,
        queryVariables.jql,
        queryVariables.withConfluenceLinks,
        queryVariables.includeDoneItems,
        queryVariables.isParentFieldVisible,
        queryVariables.isDevSummaryFieldVisible,
        queryVariables.includeIsVerifiedInTeamFragment,
        intl
    ]);
    return {
        data: result,
        // Make sure to return loading=true until items are loaded.
        loading: hasLoadingStarted ? loading : true,
        // return undefined to avoid showing the error flag in UI
        error: !(0, $4NLOw.shouldHandleTheError)(error) ? undefined : error,
        loadNextPage: loadNextPage,
        hasNextPage: hasNextPage,
        isLoadingNextPage: isLoadingNextPage
    };
};

});
parcelRegister("cvbVg", function(module, exports) {

$parcel$export(module.exports, "useIssuePagination", () => $0bf39943290cab91$export$b49565a42289e6b);
$parcel$export(module.exports, "useJqlPagination", () => $0bf39943290cab91$export$9408824d9baedabc);
$parcel$export(module.exports, "useRefreshInterval", () => $0bf39943290cab91$export$7cfdc4e3bbeb1790);

var $5uXOq = parcelRequire("5uXOq");

var $3JOCw = parcelRequire("3JOCw");

var $5tTFS = parcelRequire("5tTFS");

var $9SwwX = parcelRequire("9SwwX");
const $0bf39943290cab91$var$paginationOptionsForIssuesByJql = {
    uniqueId: 'issueId',
    filter: 'jql'
};
function $0bf39943290cab91$export$f80c710216eae131({ data: data, variables: variables, listName: listName, query: query, onError: onError, errorPolicy: errorPolicy = 'none', uniqueId: uniqueId, filter: filter }) {
    const [isLoadingNextPage, setIsLoadingNextPage] = (0, $5uXOq.useState)(false);
    const _data = data && (0, $9SwwX.getAGGCompliantData)(data, listName, onError);
    const hasNextPage = _data?.pageInfo?.hasNextPage || false;
    const endCursor = _data?.pageInfo?.endCursor || '';
    const fetchMore = (0, $9SwwX.useFetchMore)({
        query: query,
        variables: variables
    });
    /**
	 * creating a useRef for onError so that we don't regenerate the `next` function every time `onError` changes.
	 * - This will make the `next` reference to be more resistant to reference changes in case consumer inline the `onError` function
	 * - Moreover, `onError` is not affecting the data that we fetch, since it will be only called in in-need basis
	 * - Additionally in apollo repository, `onError` is also excluded from memoization list  (check the useQuery)
	 */ const onErrorRef = (0, $5uXOq.useRef)();
    onErrorRef.current = onError;
    const resetWhenChanged = filter ? variables[filter] : variables;
    (0, $5uXOq.useEffect)(()=>{
        // reset next page state
        setIsLoadingNextPage(false);
    }, [
        resetWhenChanged
    ]);
    const updateQueryAGGCompliant = (0, $5uXOq.useCallback)(// @ts-expect-error TS2345 - Argument of type '(prev: TData, { fetchMoreResult }: { fetchMoreResult?: TData | undefined; variables: TVariables; }) => TData | { jira: { [x: string]: any; }; }' is not assignable to parameter of type '(prev: TData, options: { fetchMoreResult?: TData | undefined; variables: TVariables; }) => TData'.
    (prev, { fetchMoreResult: fetchMoreResult })=>{
        setIsLoadingNextPage(false);
        if (!fetchMoreResult) return prev;
        const edges = [
            ...(0, $9SwwX.getAGGCompliantData)(prev, listName)?.edges || [],
            ...(0, $9SwwX.getAGGCompliantData)(fetchMoreResult, listName)?.edges || []
        ];
        return {
            jira: {
                ...fetchMoreResult.jira,
                [listName]: {
                    ...(0, $9SwwX.getAGGCompliantData)(fetchMoreResult, listName),
                    edges: (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))(edges, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    (edge)=>edge?.node && edge.node[uniqueId])
                }
            }
        };
    }, [
        setIsLoadingNextPage,
        listName,
        uniqueId
    ]);
    const next = (0, $5uXOq.useCallback)((after)=>{
        setIsLoadingNextPage(true);
        fetchMore({
            after: after,
            onError: onErrorRef.current,
            errorPolicy: errorPolicy,
            updateQuery: updateQueryAGGCompliant
        });
    }, [
        fetchMore,
        updateQueryAGGCompliant,
        errorPolicy
    ]);
    return {
        hasNextPage: hasNextPage,
        endCursor: endCursor,
        isLoadingNextPage: isLoadingNextPage,
        next: next
    };
}
const $0bf39943290cab91$export$b49565a42289e6b = (options)=>$0bf39943290cab91$export$f80c710216eae131({
        ...options,
        ...$0bf39943290cab91$var$paginationOptionsForIssuesByJql
    });
const $0bf39943290cab91$export$ea10f704343077db = ({ variables: variables, query: query, onCompleted: onCompleted, onError: onError, onPaginationError: onPaginationError, onNextPageLoaded: onNextPageLoaded, uniqueId: uniqueId, filter: filter, fetchPolicy: fetchPolicy, errorPolicy: errorPolicy = 'none' })=>{
    const [inFlightPage, setInFlightPage] = (0, $5uXOq.useState)();
    const resetWhenChanged = filter ? variables[filter] : variables;
    (0, $5uXOq.useEffect)(()=>{
        // reset inflight track
        setInFlightPage(null);
    }, [
        resetWhenChanged
    ]);
    const [loadFirstPage, { data: data, loading: loading, error: error, refetch: refetch }] = (0, $5tTFS.useLazyQuery)(query, {
        variables: variables,
        errorPolicy: errorPolicy,
        fetchPolicy: fetchPolicy || 'network-only',
        onCompleted: onCompleted,
        onError: onError
    });
    if (data?.jira?.list?.__typename === 'QueryError') onError && onError(data?.jira?.list);
    const { next: next, hasNextPage: hasNextPage, endCursor: endCursor, isLoadingNextPage: isLoadingNextPage } = $0bf39943290cab91$export$f80c710216eae131({
        data: data,
        variables: variables,
        listName: 'list',
        onError: onPaginationError,
        errorPolicy: errorPolicy,
        query: query,
        uniqueId: uniqueId,
        filter: filter
    });
    const loadNextPage = (0, $5uXOq.useCallback)(()=>{
        /*
		 * Do not load the same page twice and do not load the next page if
		 * a request is already in progress.
		 */ if (!hasNextPage || endCursor === inFlightPage || loading) return;
        setInFlightPage(endCursor);
        next(endCursor);
        onNextPageLoaded && onNextPageLoaded();
    }, [
        endCursor,
        hasNextPage,
        inFlightPage,
        next,
        onNextPageLoaded,
        loading
    ]);
    return {
        loading: loading,
        error: error,
        data: data,
        loadFirstPage: loadFirstPage,
        hasNextPage: hasNextPage,
        isLoadingNextPage: isLoadingNextPage,
        loadNextPage: loadNextPage,
        refetch: refetch
    };
};
const $0bf39943290cab91$export$9408824d9baedabc = (options)=>$0bf39943290cab91$export$ea10f704343077db({
        ...options,
        ...$0bf39943290cab91$var$paginationOptionsForIssuesByJql
    });
const $0bf39943290cab91$export$7cfdc4e3bbeb1790 = (callback, condition, interval)=>{
    (0, $5uXOq.useEffect)(()=>{
        if (interval == null) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        const timer = setTimeout(()=>{
            if (condition) callback();
        }, interval * 1000);
        return ()=>{
            clearTimeout(timer);
        };
    }, [
        interval,
        callback,
        condition
    ]);
};

});

parcelRegister("4NLOw", function(module, exports) {

$parcel$export(module.exports, "shouldHandleTheError", () => $772da81157c64678$export$47770c8b6d645cdb);
const $772da81157c64678$var$IGNORED_ERRORS = [
    {
        errorType: 'ISSUE_UNAVAILABLE',
        statusCode: 404
    },
    {
        errorType: 'FIELD_VALUE_UNAVAILABLE',
        statusCode: 500
    },
    {
        errorType: 'DATA_FETCHER_THREW',
        statusCode: 500
    }
];
const $772da81157c64678$export$47770c8b6d645cdb = (error)=>{
    if (error?.networkError) return true;
    const filterIssueUnavailableErrors = (graphQLError)=>!$772da81157c64678$var$IGNORED_ERRORS.find((ignoredError)=>ignoredError.errorType === graphQLError?.extensions?.errorType && ignoredError.statusCode === graphQLError?.extensions?.statusCode);
    const errorsToShow = (error?.graphQLErrors || []).filter(filterIssueUnavailableErrors);
    return errorsToShow.length > 0;
};

});

parcelRegister("bsMMx", function(module, exports) {

$parcel$export(module.exports, "addChildToParentListView", () => $11e9e7ac961f2fe3$export$a79dcdc594f4a8c4);
$parcel$export(module.exports, "removeChildFromParentListView", () => $11e9e7ac961f2fe3$export$1ea2ddc4aab7921f);
$parcel$export(module.exports, "transformResult", () => $11e9e7ac961f2fe3$export$f13b29f9ed0c5a03);

var $hE5wF = parcelRequire("hE5wF");

var $fqrog = parcelRequire("fqrog");

var $5fc53 = parcelRequire("5fc53");

var $4kK95 = parcelRequire("4kK95");

var $6s1PB = parcelRequire("6s1PB");

var $jUV6i = parcelRequire("jUV6i");
const $11e9e7ac961f2fe3$export$a79dcdc594f4a8c4 = (parentIssue)=>({
        ...parentIssue,
        childSummary: {
            __typename: 'JiraWorkManagementChildSummary',
            hasChildren: true,
            totalCount: parentIssue.childSummary?.totalCount ? parentIssue.childSummary?.totalCount + 1 : 1
        }
    });
const $11e9e7ac961f2fe3$export$1ea2ddc4aab7921f = (parentIssue, childrenToRemove = 1)=>{
    const newCount = parentIssue.childSummary?.totalCount ? parentIssue.childSummary?.totalCount - childrenToRemove : 0;
    return {
        ...parentIssue,
        childSummary: {
            __typename: 'JiraWorkManagementChildSummary',
            hasChildren: newCount > 0,
            totalCount: newCount
        }
    };
};
const $11e9e7ac961f2fe3$var$createDateTimeFieldTransformer = ()=>(field)=>({
            [field.aliasFieldId || field.fieldId]: (field.dateTime && (0, $4kK95.DateOnly).fromDateAccordingToLocalTime(new Date(field.dateTime))) ?? null
        });
const $11e9e7ac961f2fe3$var$createDateFieldTransformer = ()=>(field)=>({
            [field.aliasFieldId || field.fieldId]: (field.date && (0, $4kK95.toDateOnly)(field.date)) ?? null
        });
const $11e9e7ac961f2fe3$var$atlassianAccountUserTransformer = (user)=>({
        accountId: user.accountId,
        avatarUrl: user.picture,
        displayName: user.name
    });
const $11e9e7ac961f2fe3$var$createJiraSingleSelectUserPickeTransformer = ()=>(field)=>field.user && {
            [field.aliasFieldId || field.fieldId]: $11e9e7ac961f2fe3$var$atlassianAccountUserTransformer(field.user)
        } || null;
const $11e9e7ac961f2fe3$var$createJiraSingleLineTextTransformer = (fieldId)=>(field)=>({
            [fieldId || field.aliasFieldId || field.fieldId]: field.text
        });
const $11e9e7ac961f2fe3$var$createJiraLabelsTransformer = ()=>(field)=>({
            [field.aliasFieldId || field.fieldId]: field.selectedLabelsConnection?.edges?.map((edge)=>edge?.node?.name) || []
        });
const $11e9e7ac961f2fe3$var$topLevelFieldTransformers = {
    [(0, $5fc53.ISSUE_KEY_TYPE)]: $11e9e7ac961f2fe3$var$createJiraSingleLineTextTransformer('key'),
    [(0, $5fc53.ISSUE_TYPE)]: (field)=>({
            issuetype: {
                iconUrl: field.issueType?.avatar?.medium,
                id: field.issueType?.issueTypeId,
                name: field.issueType?.name,
                level: field.issueType?.hierarchy?.level
            }
        }),
    [(0, $5fc53.SUMMARY_TYPE)]: $11e9e7ac961f2fe3$var$createJiraSingleLineTextTransformer(),
    [(0, $5fc53.STATUS_TYPE)]: (field)=>({
            status: {
                id: field.status.statusId,
                name: field.status.name,
                categoryId: field.status.statusCategory?.statusCategoryId
            }
        }),
    [(0, $hE5wF.START_DATE_ALIAS_FIELD_ID)]: $11e9e7ac961f2fe3$var$createDateFieldTransformer(),
    [(0, $5fc53.DUE_DATE_TYPE)]: $11e9e7ac961f2fe3$var$createDateFieldTransformer(),
    [(0, $5fc53.UPDATED)]: $11e9e7ac961f2fe3$var$createDateTimeFieldTransformer(),
    [(0, $5fc53.CREATED)]: $11e9e7ac961f2fe3$var$createDateTimeFieldTransformer(),
    [(0, $5fc53.ASSIGNEE_TYPE)]: $11e9e7ac961f2fe3$var$createJiraSingleSelectUserPickeTransformer(),
    [(0, $5fc53.PRIORITY_TYPE)]: (field)=>({
            priority: (field.priority && {
                id: field.priority.id,
                name: field.priority.name,
                iconUrl: field.priority.iconUrl
            }) ?? null
        }),
    [(0, $5fc53.LABELS_TYPE)]: $11e9e7ac961f2fe3$var$createJiraLabelsTransformer(),
    [(0, $5fc53.RANK_CF_TYPE)]: $11e9e7ac961f2fe3$var$createJiraSingleLineTextTransformer(),
    [(0, $5fc53.TIME_ESTIMATE_TYPE)]: (field)=>({
            timeoriginalestimate: field.originalEstimate?.timeInSeconds ?? null
        })
};
const $11e9e7ac961f2fe3$var$getTopLevelField = (field)=>{
    const transformer = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $11e9e7ac961f2fe3$var$topLevelFieldTransformers[field.type];
    if (transformer) // @ts-expect-error - TS2345 - Type &#39;JWMListViewItems_jira_list_JiraWorkManagementViewItemConnection_edges_node_fields_JiraColorField&#39; is not assignable to type &#39;never&#39;
    return transformer(field);
    return null;
};
const $11e9e7ac961f2fe3$export$f13b29f9ed0c5a03 = (edges, options)=>{
    if (edges) return edges.filter((edge)=>{
        return Array.isArray(edge?.node?.fields);
    }).map((edge)=>{
        const { id: id, fields: fields, issueId: issueId, childSummary: childSummary, legacyConfluenceLinks: legacyConfluenceLinks, commentSummary: commentSummary } = edge.node;
        const listViewIssue = {
            id: id,
            issueId: issueId,
            childSummary: {
                totalCount: childSummary?.totalCount,
                hasChildren: childSummary?.hasChildren ?? false
            },
            cacheVariables: options.cacheVariables,
            fields: (0, $jUV6i.listViewTransformFields)(fields, options.intl),
            confluenceLinks: legacyConfluenceLinks ?? undefined,
            commentSummary: {
                totalCount: commentSummary?.totalCount,
                // Temporary field for Unread Comments in List View experiment
                // Clean up in https://hello.jira.atlassian.cloud/browse/WAR-1557
                ...commentSummary?.hasUnreadComment != null && (0, $6s1PB.expVal)('jira_unread_comments_in_list_view', 'isEnabled', false) ? {
                    hasUnreadComment: commentSummary.hasUnreadComment
                } : {}
            },
            ...(0, $fqrog.transformTopLevelFields)(edge?.node)
        };
        fields?.forEach((field)=>{
            if (field != null) {
                const fieldValues = $11e9e7ac961f2fe3$var$getTopLevelField(field);
                Object.assign(listViewIssue, fieldValues);
            }
        });
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return listViewIssue;
    });
    return [];
};

});
parcelRegister("fqrog", function(module, exports) {

$parcel$export(module.exports, "transformField", () => $e630afa64fd6ceac$export$fbce423ada1f57a0);
$parcel$export(module.exports, "isTransformFieldSupported", () => $e630afa64fd6ceac$export$d3f2873cf2713a58);
$parcel$export(module.exports, "transformTopLevelFields", () => $e630afa64fd6ceac$export$82a9f94774eb7857);

var $8QpSo = parcelRequire("8QpSo");

var $gTfZ2 = parcelRequire("gTfZ2");


var $fLdM4 = parcelRequire("fLdM4");

var $fTh7Q = parcelRequire("fTh7Q");

var $la89U = parcelRequire("la89U");

var $8n29C = parcelRequire("8n29C");

var $8wFTy = parcelRequire("8wFTy");

var $dUPoX = parcelRequire("dUPoX");

var $aC1CM = parcelRequire("aC1CM");

var $h0F6x = parcelRequire("h0F6x");

var $gQbVm = parcelRequire("gQbVm");

var $gygm0 = parcelRequire("gygm0");

var $erqgq = parcelRequire("erqgq");
// Used for list view controller when transforming Gira response
const $e630afa64fd6ceac$var$createSupportedTransformations = (0, $8QpSo.default)(()=>({
        ...(0, $gygm0.transformVersionField)(),
        ...(0, $8n29C.transformParentField)(),
        ...(0, $gQbVm.transformTeamField)(),
        ...(0, $fTh7Q.transformGoalsField)(),
        ...(0, $aC1CM.transformResolutionField)(),
        ...(0, $la89U.transformGroupField)(),
        ...(0, $dUPoX.transformRadioSelectField)(),
        ...(0, $h0F6x.transformStatusCategoryField)(),
        ...(0, $8wFTy.transformProjectField)(),
        ...(0, $gTfZ2.transformCascadingSelectField)()
    }));
const $e630afa64fd6ceac$var$isValidTypename = (typename)=>true;
const $e630afa64fd6ceac$export$66480ae6e701514d = (field)=>true;
const $e630afa64fd6ceac$export$fbce423ada1f57a0 = (field, intl)=>{
    const supportedTransformations = $e630afa64fd6ceac$var$createSupportedTransformations();
    if (field == null) return null;
    const typename = field.__typename;
    if (!$e630afa64fd6ceac$var$isValidTypename(typename)) return null;
    const transform = supportedTransformations[typename];
    if (transform == null) return null;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return transform(field, intl);
};
const $e630afa64fd6ceac$export$d3f2873cf2713a58 = (field)=>{
    const supportedTransformations = $e630afa64fd6ceac$var$createSupportedTransformations();
    if (!(0, $erqgq.isJiraBusinessFields)(field)) return false;
    if (!$e630afa64fd6ceac$var$isValidTypename(field.__typename)) return false;
    return supportedTransformations[field.__typename] != null;
};
const $e630afa64fd6ceac$export$82a9f94774eb7857 = (issueNode)=>issueNode ? {
        [(0, $677cd2eb13864f6c$export$72b5bd2391f1e7c0)]: (0, $fLdM4.transformDevSummaryField)(issueNode.devSummaryCache)
    } : {};

});
parcelRegister("gTfZ2", function(module, exports) {

$parcel$export(module.exports, "transformCascadingSelectField", () => $9854766c7dcd472c$export$b5257861e8de13fa);

var $erdwt = parcelRequire("erdwt");

var $5fc53 = parcelRequire("5fc53");

const $9854766c7dcd472c$export$b5257861e8de13fa = ()=>({
        [(0, $206b407a57faed7a$export$c5c9bcd04d3610df)]: (field)=>{
            if (field.__typename !== (0, $206b407a57faed7a$export$c5c9bcd04d3610df)) return null;
            return {
                type: (0, $5fc53.CASCADING_SELECT_CF_TYPE),
                id: field.id,
                fieldId: field.fieldId,
                value: field.cascadingOption && field.cascadingOption.parentValue ? {
                    parentOptionValue: {
                        id: field.cascadingOption.parentValue.id,
                        optionId: (0, $erdwt.JiraIssueFieldOptionAri).parse(field.cascadingOption.parentValue.id).optionId,
                        value: field.cascadingOption.parentValue.value,
                        isDisabled: field.cascadingOption.parentValue.isDisabled
                    },
                    ...field.cascadingOption.childOptionValue ? {
                        childOptionValue: {
                            id: field.cascadingOption.childOptionValue.id,
                            optionId: field.cascadingOption.childOptionValue.optionId,
                            value: field.cascadingOption.childOptionValue.value,
                            isDisabled: field.cascadingOption.childOptionValue.isDisabled
                        }
                    } : {}
                } : null
            };
        }
    });

});
parcelRegister("erdwt", function(module, exports) {

$parcel$export(module.exports, "JiraIssueFieldOptionAri", () => $a82e13aa7ad841f1$export$e3bc1ec22f941fbe);

var $aeXsV = parcelRequire("aeXsV");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/jira/issue-field-option/manifest.ts
var $a82e13aa7ad841f1$var$jiraIssueFieldOptionAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $aeXsV.JiraIssueFieldOptionAriResourceOwner),
    resourceType: (0, $aeXsV.JiraIssueFieldOptionAriResourceType),
    resourceIdSlug: "activation/{activationId}/{fieldId}/{optionId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        fieldId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/,
        // eslint-disable-line no-useless-escape
        optionId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/issue-field-option/index.ts
var $a82e13aa7ad841f1$export$e3bc1ec22f941fbe = class _JiraIssueFieldOptionAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._fieldId = opts.resourceIdSegmentValues.fieldId, this._optionId = opts.resourceIdSegmentValues.optionId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get fieldId() {
        return this._fieldId;
    }
    get optionId() {
        return this._optionId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $a82e13aa7ad841f1$var$jiraIssueFieldOptionAriStaticOpts.qualifier,
            platformQualifier: $a82e13aa7ad841f1$var$jiraIssueFieldOptionAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $a82e13aa7ad841f1$var$jiraIssueFieldOptionAriStaticOpts.resourceOwner,
            resourceType: $a82e13aa7ad841f1$var$jiraIssueFieldOptionAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.fieldId}/${opts.optionId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                fieldId: opts.fieldId,
                optionId: opts.optionId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $a82e13aa7ad841f1$var$jiraIssueFieldOptionAriStaticOpts);
        return new _JiraIssueFieldOptionAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $a82e13aa7ad841f1$var$jiraIssueFieldOptionAriStaticOpts);
        return new _JiraIssueFieldOptionAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            fieldId: this.fieldId,
            optionId: this.optionId
        };
    }
};

});
parcelRegister("aeXsV", function(module, exports) {

$parcel$export(module.exports, "JiraIssueFieldOptionAriResourceOwner", () => $774956c9da7baac8$export$eb4f4cf0880fe5a8);
$parcel$export(module.exports, "JiraIssueFieldOptionAriResourceType", () => $774956c9da7baac8$export$4bec333360908e78);
// src/jira/issue-field-option/types.ts
var $774956c9da7baac8$export$eb4f4cf0880fe5a8 = "jira", $774956c9da7baac8$export$4bec333360908e78 = "issue-field-option";

});


const $206b407a57faed7a$export$c5c9bcd04d3610df = 'JiraCascadingSelectField';


parcelRegister("fLdM4", function(module, exports) {

$parcel$export(module.exports, "transformDevSummaryField", () => $d62ec76730f01701$export$2093d68e8a6114b5);
const $d62ec76730f01701$var$hasPullRequest = (field)=>Number(field?.devSummary?.pullrequest?.overall?.count) > 0;
const $d62ec76730f01701$var$isUnderReview = (field)=>$d62ec76730f01701$var$hasPullRequest(field) && field?.devSummary?.pullrequest?.overall?.state === 'OPEN';
const $d62ec76730f01701$var$isMerged = (field)=>$d62ec76730f01701$var$hasPullRequest(field) && field?.devSummary?.pullrequest?.overall?.state === 'MERGED';
const $d62ec76730f01701$export$2093d68e8a6114b5 = (field)=>field ? {
        pullRequestsCount: Number(field?.devSummary?.pullrequest?.overall?.count),
        isUnderReview: $d62ec76730f01701$var$isUnderReview(field),
        isMerged: $d62ec76730f01701$var$isMerged(field),
        commitCount: Number(field?.devSummary?.commit?.overall?.count)
    } : null;

});

parcelRegister("fTh7Q", function(module, exports) {

$parcel$export(module.exports, "transformGoalsField", () => $80b6ef74eef34661$export$c34241865478278);

var $5fc53 = parcelRequire("5fc53");

const $80b6ef74eef34661$export$c34241865478278 = ()=>({
        [(0, $79c833f42551f759$export$aac6761ddd37ded5)]: (field)=>{
            if (field.__typename !== (0, $79c833f42551f759$export$aac6761ddd37ded5)) return null;
            return {
                type: (0, $5fc53.GOALS_CF_TYPE),
                fieldId: field.fieldId,
                name: field.name,
                isEditable: !!field.fieldConfig?.isEditable,
                value: {
                    goals: field.selectedGoals?.edges?.filter((edge)=>edge?.node !== null).map((edge)=>({
                            id: edge?.node?.id || '',
                            name: edge?.node?.name || '',
                            status: edge?.node?.status || null
                        })) || [],
                    totalCount: field.selectedGoals?.totalCount || 0
                }
            };
        }
    });

});
const $79c833f42551f759$export$aac6761ddd37ded5 = 'JiraGoalsField';


parcelRegister("la89U", function(module, exports) {

$parcel$export(module.exports, "transformGroupField", () => $9ca99cda73f0ee52$export$5090c8e3ce3e3e36);

var $5fc53 = parcelRequire("5fc53");

const $9ca99cda73f0ee52$export$5090c8e3ce3e3e36 = ()=>({
        [(0, $340a31f3aa62c282$export$e67f77aeba6db6c8)]: (field)=>{
            if (field.__typename !== (0, $340a31f3aa62c282$export$e67f77aeba6db6c8)) return null;
            return {
                type: (0, $5fc53.GROUP_CF_TYPE),
                fieldId: field.fieldId,
                name: field.name,
                value: field.selectedGroup ? {
                    id: field.selectedGroup.id,
                    groupId: field.selectedGroup.groupId,
                    name: field.selectedGroup.name ?? ''
                } : null
            };
        },
        [(0, $340a31f3aa62c282$export$bf73c80438672453)]: (field)=>{
            if (field.__typename !== (0, $340a31f3aa62c282$export$bf73c80438672453)) return null;
            return {
                type: (0, $5fc53.MULTI_GROUP_CF_TYPE),
                fieldId: field.fieldId,
                name: field.name,
                value: field.selectedGroupsConnection?.edges?.map?.((edge)=>edge?.node != null ? {
                        id: edge.node.id,
                        groupId: edge.node.groupId,
                        name: edge.node.name ?? ''
                    } : null).filter(Boolean) ?? null
            };
        }
    });

});
const $340a31f3aa62c282$export$e67f77aeba6db6c8 = 'JiraSingleGroupPickerField';
const $340a31f3aa62c282$export$bf73c80438672453 = 'JiraMultipleGroupPickerField';


parcelRegister("8n29C", function(module, exports) {

$parcel$export(module.exports, "transformParentField", () => $9cbd1149b243724f$export$9154eb05be84db49);

var $5fc53 = parcelRequire("5fc53");

var $57lFd = parcelRequire("57lFd");

const $9cbd1149b243724f$export$9154eb05be84db49 = ()=>({
        [(0, $96199b0c0c91be44$export$89cbdbc2fa7a3b27)]: (field)=>{
            if (field.__typename !== (0, $96199b0c0c91be44$export$89cbdbc2fa7a3b27)) return null;
            let fields = {};
            if (Array.isArray(field.parentIssue?.fields)) {
                const issueType = (0, $57lFd.safeGetValue)(field.parentIssue.fields, 'issuetype', 'issueType', null);
                const color = (0, $57lFd.safeGetValue)(field.parentIssue.fields, 'issuecolor', 'color.colorKey', null);
                fields = {
                    summary: (0, $57lFd.safeGetValue)(field.parentIssue.fields, 'summary', 'text', null),
                    statusCategoryId: (0, $57lFd.safeGetValue)(field.parentIssue?.fields, 'status', 'status.statusCategory.statusCategoryId', null),
                    issueType: issueType ? {
                        name: issueType.name,
                        iconUrl: issueType.avatar?.medium
                    } : null,
                    color: color != null ? color.toUpperCase() : null
                };
            }
            if (Array.isArray(field.parentIssue?.rankField)) {
                const rank = (0, $57lFd.safeGetValue)(field.parentIssue?.rankField, 'rank', 'text', null);
                fields = {
                    ...fields,
                    rank: rank ?? null
                };
            }
            return {
                type: (0, $5fc53.PARENT_TYPE),
                fieldId: field.fieldId,
                value: field.parentIssue ? {
                    id: field.parentIssue?.id,
                    issueId: field.parentIssue?.issueId,
                    issueKey: field.parentIssue?.key,
                    ...fields
                } : null
            };
        }
    });

});
const $96199b0c0c91be44$export$89cbdbc2fa7a3b27 = 'JiraParentIssueField';


parcelRegister("8wFTy", function(module, exports) {

$parcel$export(module.exports, "transformProjectField", () => $171682a66941f140$export$1fd74e5690ffdae3);

var $5fc53 = parcelRequire("5fc53");

const $171682a66941f140$export$1fd74e5690ffdae3 = ()=>({
        [(0, $76dad3b4843304d3$export$32cecd77017de859)]: (field)=>{
            if (field.__typename !== (0, $76dad3b4843304d3$export$32cecd77017de859)) return null;
            return {
                type: (0, $5fc53.PROJECT_PICKER_CF_TYPE),
                fieldId: field.fieldId,
                name: field.name,
                value: field.project ? {
                    id: field.project.id,
                    name: field.project.name ?? '',
                    key: field.project.key ?? '',
                    avatarUrls: {
                        '48x48': field.project.avatar?.large ?? ''
                    },
                    projectId: field.project.projectId
                } : null
            };
        }
    });

});
const $76dad3b4843304d3$export$32cecd77017de859 = 'JiraProjectField';


parcelRegister("dUPoX", function(module, exports) {

$parcel$export(module.exports, "transformRadioSelectField", () => $5b81f5d47241d28b$export$ee3d5244f5f85b47);

var $4R6GH = parcelRequire("4R6GH");

var $5fc53 = parcelRequire("5fc53");

const $5b81f5d47241d28b$export$ee3d5244f5f85b47 = ()=>({
        [(0, $d6c7b5757fc9ff6e$export$561e8c47e4fa1c1b)]: (field)=>{
            if (field.__typename !== (0, $d6c7b5757fc9ff6e$export$561e8c47e4fa1c1b)) return null;
            return {
                id: (0, $4R6GH.fg)('jira-list-view-radio-cell-relay-edit-view') ? field.id : '',
                type: (0, $5fc53.RADIO_BUTTONS_CF_TYPE),
                fieldId: field.fieldId,
                name: field.name,
                isEditable: !!field.fieldConfig?.isEditable,
                value: field.selectedOption ? {
                    id: field.selectedOption.optionId,
                    value: field.selectedOption.value ?? ''
                } : null
            };
        }
    });

});
const $d6c7b5757fc9ff6e$export$561e8c47e4fa1c1b = 'JiraRadioSelectField';


parcelRegister("aC1CM", function(module, exports) {

$parcel$export(module.exports, "transformResolutionField", () => $64ed186dee127bcd$export$3441c85b045ddb32);

var $5fc53 = parcelRequire("5fc53");

const $64ed186dee127bcd$export$3441c85b045ddb32 = ()=>({
        [(0, $a3d8c7863d334786$export$a7bcc074cfedc376)]: (field)=>{
            if (field.__typename !== (0, $a3d8c7863d334786$export$a7bcc074cfedc376)) return null;
            return {
                type: (0, $5fc53.RESOLUTION_TYPE),
                fieldId: field.fieldId,
                value: field.resolution ? {
                    id: field.resolution.id,
                    name: field.resolution.name ?? ''
                } : null
            };
        }
    });

});
const $a3d8c7863d334786$export$a7bcc074cfedc376 = 'JiraResolutionField';


parcelRegister("h0F6x", function(module, exports) {

$parcel$export(module.exports, "transformStatusCategoryField", () => $84a62c9cfa413a6f$export$daffdd43f256def6);

var $5fc53 = parcelRequire("5fc53");

const $84a62c9cfa413a6f$export$daffdd43f256def6 = ()=>({
        [(0, $0109c63a793596b4$export$aa464b56f1076111)]: (field)=>{
            if (field.__typename !== (0, $0109c63a793596b4$export$aa464b56f1076111)) return null;
            return {
                type: (0, $5fc53.STATUS_CATEGORY_TYPE),
                fieldId: field.fieldId,
                value: field.statusCategory ? {
                    statusCategoryId: field.statusCategory.statusCategoryId,
                    name: field.statusCategory.name ?? ''
                } : null
            };
        }
    });

});
const $0109c63a793596b4$export$aa464b56f1076111 = 'JiraStatusCategoryField';


parcelRegister("gQbVm", function(module, exports) {

$parcel$export(module.exports, "transformTeamField", () => $9e03399a683d167a$export$c924eaa42d1ef062);

var $5fc53 = parcelRequire("5fc53");

const $9e03399a683d167a$export$c924eaa42d1ef062 = ()=>({
        [(0, $d01e345798316c77$export$4b2dddaf094af935)]: (field)=>{
            if (field.__typename !== (0, $d01e345798316c77$export$4b2dddaf094af935)) return null;
            return {
                type: (0, $5fc53.TEAMS_PLATFORM_CF_TYPE),
                fieldId: field.fieldId,
                value: field.selectedTeam ? {
                    id: field.selectedTeam.jiraSuppliedTeamId,
                    name: field.selectedTeam.jiraSuppliedName ?? '',
                    isVerified: field.selectedTeam.jiraSuppliedIsVerified ?? false
                } : null
            };
        }
    });

});
const $d01e345798316c77$export$4b2dddaf094af935 = 'JiraTeamViewField';


parcelRegister("gygm0", function(module, exports) {

$parcel$export(module.exports, "transformVersionField", () => $2cc8ced84840d9fe$export$7beb4bd99d0c30b);

var $5fc53 = parcelRequire("5fc53");

const $2cc8ced84840d9fe$export$7beb4bd99d0c30b = ()=>({
        [(0, $2768c56582d92138$export$7d00c90aa4f1f657)]: (field)=>{
            if (field.__typename !== (0, $2768c56582d92138$export$7d00c90aa4f1f657)) return null;
            return {
                type: (0, $5fc53.VERSION_CF_TYPE),
                fieldId: field.fieldId,
                name: field.name,
                value: field.version ? {
                    id: field.version.versionId,
                    name: field.version.name ?? ''
                } : null
            };
        },
        [(0, $2768c56582d92138$export$f240ecd334700f48)]: (field)=>{
            if (field.__typename !== (0, $2768c56582d92138$export$f240ecd334700f48)) return null;
            return {
                type: (0, $5fc53.MULTI_VERSION_CF_TYPE),
                fieldId: field.fieldId,
                name: field.name,
                value: field.selectedVersionsConnection?.edges?.map?.((edge)=>edge?.node != null ? {
                        id: edge?.node.versionId,
                        name: edge?.node.name ?? ''
                    } : null).filter((version)=>version != null) ?? null
            };
        }
    });

});
const $2768c56582d92138$export$7d00c90aa4f1f657 = 'JiraSingleVersionPickerField';
const $2768c56582d92138$export$f240ecd334700f48 = 'JiraMultipleVersionPickerField';


parcelRegister("erqgq", function(module, exports) {

$parcel$export(module.exports, "isJiraBusinessFields", () => $b41b61505251b1ca$export$257745f9c8865601);
const $b41b61505251b1ca$export$257745f9c8865601 = (_)=>true;

});


parcelRegister("jUV6i", function(module, exports) {

$parcel$export(module.exports, "listViewTransformFields", () => $7dbf501f1c077c87$export$34af57b660300007);

var $fqrog = parcelRequire("fqrog");

var $2Igls = parcelRequire("2Igls");

var $5fc53 = parcelRequire("5fc53");

var $etKNj = parcelRequire("etKNj");

var $k698r = parcelRequire("k698r");
const $7dbf501f1c077c87$var$transformTimeTracking = (originalEstimate, timeTrackingOptions, intl)=>{
    if (originalEstimate) return {
        timeInSeconds: Number(originalEstimate.timeInSeconds) || undefined,
        timeAsString: (0, $etKNj.timeTrackingFormatter)(Number(originalEstimate.timeInSeconds), {
            ...timeTrackingOptions,
            timeFormat: (0, $k698r.timeFormatMap).get(timeTrackingOptions.timeFormat) || (0, $2Igls.PRETTY)
        }, intl)
    };
    return null;
};
const $7dbf501f1c077c87$var$transformUser = (user)=>{
    if (user) return {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        accountId: user.accountId,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        name: user.name,
        picture: user.picture ?? ''
    };
    return null;
};
const $7dbf501f1c077c87$var$transformUsers = (users)=>{
    if (users) return users.map((user)=>$7dbf501f1c077c87$var$transformUser(user?.node));
    return null;
};
const $7dbf501f1c077c87$var$transformSelectField = (selectedOption)=>{
    if (selectedOption) return {
        optionId: String(selectedOption.optionId),
        value: selectedOption.value,
        ...selectedOption.color ? {
            color: selectedOption.color?.colorKey
        } : {}
    };
    return null;
};
const $7dbf501f1c077c87$export$d4a0295c1cbaac03 = (selectedOptions)=>{
    if (selectedOptions) return selectedOptions.map((option)=>option?.node?.optionId && option?.node?.value ? $7dbf501f1c077c87$var$transformSelectField(option.node) : null).filter((option)=>option !== null);
    return null;
};
const $7dbf501f1c077c87$export$c072126708d93f04 = (labels)=>{
    if (labels) return labels.map((label)=>label?.node?.name ?? null).filter((label)=>label !== null);
    return null;
};
const $7dbf501f1c077c87$var$transformSprint = (sprints)=>{
    if (sprints) return sprints.map((sprint)=>sprint?.node ?? null).filter((sprint)=>sprint !== null);
    return null;
};
const $7dbf501f1c077c87$export$b5df62b8f5dea4f9 = (componentValues)=>{
    if (componentValues?.length) return componentValues.map((componentValue)=>componentValue?.node?.componentId ? {
            componentId: componentValue.node?.componentId ?? '',
            name: componentValue.node?.name ?? null
        } : null).filter((componentValue)=>componentValue !== null);
    return null;
};
const $7dbf501f1c077c87$var$transformParent = (parentIssue)=>{
    if (parentIssue) return {
        issueId: parentIssue.issueId,
        issueKey: parentIssue.key
    };
    return null;
};
const $7dbf501f1c077c87$var$listFieldTransformers = {
    JiraIssueTypeField: (field)=>{
        if (field.__typename !== 'JiraIssueTypeField') return null;
        return {
            type: (0, $5fc53.ISSUE_TYPE),
            fieldId: field.fieldId,
            value: field.issueType?.name ?? null,
            level: field.issueType?.hierarchy?.level,
            issueTypeId: field.issueType?.issueTypeId
        };
    },
    JiraSingleLineTextField: (field)=>{
        if (field.__typename !== 'JiraSingleLineTextField') return null;
        return {
            type: field.type === 'issuekey' ? 'key' : field.type,
            fieldId: field.fieldId,
            value: field.text
        };
    },
    JiraUrlField: (field)=>{
        if (field.__typename !== 'JiraUrlField') return null;
        return {
            type: (0, $5fc53.URL_CF_TYPE),
            fieldId: field.fieldId,
            value: field.uri
        };
    },
    JiraRichTextField: (field)=>{
        if (field.__typename !== 'JiraRichTextField') return null;
        const value = field.richText?.adfValue?.json;
        return {
            type: (0, $5fc53.TEXT_AREA_CF_TYPE),
            fieldId: field.fieldId,
            value: value ? JSON.stringify(value) : ''
        };
    },
    JiraStatusField: (field)=>{
        if (field.__typename !== 'JiraStatusField') return null;
        return {
            type: (0, $5fc53.STATUS_TYPE),
            fieldId: field.fieldId,
            name: field.status?.name,
            statusId: field.status?.statusId,
            value: Number(field.status?.statusCategory?.statusCategoryId) ? Number(field.status?.statusCategory?.statusCategoryId) : null
        };
    },
    JiraSingleSelectUserPickerField: (field)=>{
        if (field.__typename !== 'JiraSingleSelectUserPickerField') return null;
        return {
            type: field.type,
            fieldId: field.fieldId,
            value: $7dbf501f1c077c87$var$transformUser(field.user)
        };
    },
    JiraLabelsField: (field)=>{
        if (field.__typename !== 'JiraLabelsField') return null;
        return {
            type: field.fieldId === 'labels' ? (0, $5fc53.LABELS_TYPE) : (0, $5fc53.LABELS_CF_TYPE),
            fieldId: field.fieldId,
            value: $7dbf501f1c077c87$export$c072126708d93f04(field.selectedLabelsConnection?.edges ?? null)
        };
    },
    JiraPriorityField: (field)=>{
        if (field.__typename !== 'JiraPriorityField') return null;
        return {
            type: (0, $5fc53.PRIORITY_TYPE),
            fieldId: field.fieldId,
            value: field.priority ? {
                name: field.priority.name,
                priorityId: field.priority.priorityId,
                iconUrl: field.priority.iconUrl
            } : null
        };
    },
    JiraDateTimePickerField: (field)=>{
        if (field.__typename !== 'JiraDateTimePickerField') return null;
        return {
            type: field.type,
            fieldId: field.fieldId,
            value: field.dateTime
        };
    },
    JiraMultipleSelectField: (field)=>{
        if (field.__typename !== 'JiraMultipleSelectField') return null;
        return {
            type: (0, $5fc53.MULTI_SELECT_CF_TYPE),
            fieldId: field.fieldId,
            value: $7dbf501f1c077c87$export$d4a0295c1cbaac03(field.selectedOptions?.edges ?? null)
        };
    },
    JiraSingleSelectField: (field)=>{
        if (field.__typename !== 'JiraSingleSelectField') return null;
        return {
            type: field.type,
            fieldId: field.fieldId,
            value: $7dbf501f1c077c87$var$transformSelectField(field.fieldOption) ?? null
        };
    },
    // Use the timetracking field to map to the timeoriginalestimate field rather than directly using
    // timeoriginalestimate because timetracking returns data needed to determine the timeAsString.
    // Logic to request for the timetracking field data if timeoriginalestimate is in list view is in
    // `getQueryFieldIds` in src/packages/business/list/src/controllers/get-issue-fields/index.tsx
    JiraTimeTrackingField: (field, intl)=>{
        if (field.__typename !== 'JiraTimeTrackingField' || field.originalEstimate?.timeInSeconds == null || field.timeTrackingSettings?.workingHoursPerDay == null || field.timeTrackingSettings?.workingDaysPerWeek == null || field.timeTrackingSettings?.defaultUnit == null || intl == null) return {
            type: (0, $5fc53.TIME_ESTIMATE_TYPE),
            fieldId: 'timeoriginalestimate',
            value: null
        };
        const { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, defaultFormat: timeFormat, defaultUnit: defaultUnit } = field.timeTrackingSettings;
        return {
            type: (0, $5fc53.TIME_ESTIMATE_TYPE),
            fieldId: 'timeoriginalestimate',
            value: $7dbf501f1c077c87$var$transformTimeTracking(field.originalEstimate, {
                workingHoursPerDay: workingHoursPerDay,
                workingDaysPerWeek: workingDaysPerWeek,
                timeFormat: timeFormat || (0, $2Igls.PRETTY),
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                defaultUnit: defaultUnit
            }, intl)
        };
    },
    JiraDatePickerField: (field)=>{
        if (field.__typename !== 'JiraDatePickerField') return null;
        return {
            type: field.type,
            fieldId: field.fieldId,
            value: field.date
        };
    },
    JiraNumberField: (field)=>{
        if (field.__typename !== 'JiraNumberField') return null;
        return {
            type: field.type === (0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE) || field.type === (0, $5fc53.STORY_POINTS_TYPE) ? field.type : (0, $5fc53.NUMBER_CF_TYPE),
            fieldId: field.fieldId,
            value: field.number
        };
    },
    JiraMultipleSelectUserPickerField: (field)=>{
        if (field.__typename !== 'JiraMultipleSelectUserPickerField') return null;
        return {
            type: (0, $5fc53.MULTI_USER_CF_TYPE),
            fieldId: field.fieldId,
            value: $7dbf501f1c077c87$var$transformUsers(field.selectedUsersConnection?.edges ?? null)
        };
    },
    JiraPeopleField: (field)=>{
        if (field.__typename !== 'JiraPeopleField') return null;
        return {
            type: (0, $5fc53.PEOPLE_CF_TYPE),
            fieldId: field.fieldId,
            value: $7dbf501f1c077c87$var$transformUsers(field.selectedUsersConnection?.edges ?? null)
        };
    },
    JiraComponentsField: (field)=>{
        if (field.__typename !== 'JiraComponentsField') return null;
        return {
            type: (0, $5fc53.COMPONENTS_TYPE),
            fieldId: field.fieldId,
            value: $7dbf501f1c077c87$export$b5df62b8f5dea4f9(field.selectedComponentsConnection?.edges ?? null)
        };
    },
    JiraParentIssueField: (field)=>{
        if (field.__typename !== 'JiraParentIssueField') return null;
        return {
            type: (0, $5fc53.PARENT_TYPE),
            fieldId: field.fieldId,
            value: $7dbf501f1c077c87$var$transformParent(field.parentIssue)
        };
    },
    JiraCheckboxesField: (field)=>{
        if (field.__typename !== 'JiraCheckboxesField') return null;
        return {
            type: (0, $5fc53.MULTI_CHECKBOXES_CF_TYPE),
            fieldId: field.fieldId,
            value: $7dbf501f1c077c87$export$d4a0295c1cbaac03(field.selectedOptions?.edges ?? null)
        };
    },
    JiraSprintField: (field)=>{
        if (field.__typename !== 'JiraSprintField') return null;
        return {
            type: (0, $5fc53.SPRINT_TYPE),
            fieldId: field.fieldId,
            value: $7dbf501f1c077c87$var$transformSprint(field.selectedSprintsConnection?.edges ?? null)
        };
    }
};
const $7dbf501f1c077c87$var$listViewTransformField = (field, intl)=>{
    if (field == null) return null;
    if ((0, $fqrog.isTransformFieldSupported)(field)) return (0, $fqrog.transformField)(field, intl);
    if (field.__typename in $7dbf501f1c077c87$var$listFieldTransformers) return $7dbf501f1c077c87$var$listFieldTransformers[field.__typename](field, intl);
    return null;
};
const $7dbf501f1c077c87$export$34af57b660300007 = (fields, intl)=>{
    const toReturn = [];
    fields?.forEach((field)=>{
        const transformedField = $7dbf501f1c077c87$var$listViewTransformField(field, intl);
        if (transformedField != null) toReturn.push(transformedField);
    });
    return toReturn;
};

});
parcelRegister("2Igls", function(module, exports) {

$parcel$export(module.exports, "MINUTE", () => $88f80910cde3e0d3$export$f4aba04677f37907);
$parcel$export(module.exports, "HOUR", () => $88f80910cde3e0d3$export$1bf939ebcf31ef0e);
$parcel$export(module.exports, "DAY", () => $88f80910cde3e0d3$export$1a58b8d7f494dd72);
$parcel$export(module.exports, "WEEK", () => $88f80910cde3e0d3$export$3241045aa1844a20);
$parcel$export(module.exports, "DAYS", () => $88f80910cde3e0d3$export$b387b66963374517);
$parcel$export(module.exports, "HOURS", () => $88f80910cde3e0d3$export$f25ebc73c10ad2c);
$parcel$export(module.exports, "PRETTY", () => $88f80910cde3e0d3$export$d39e6ebabedff673);
$parcel$export(module.exports, "defaultTimeTrackingConfiguration", () => $88f80910cde3e0d3$export$e17ebf14f4144ede);
$parcel$export(module.exports, "DEFAULT_TO_NEW_ISSUE_VIEW", () => $88f80910cde3e0d3$export$83f9ac2d887bd06a);
const $88f80910cde3e0d3$export$f4aba04677f37907 = 'minute';
const $88f80910cde3e0d3$export$1bf939ebcf31ef0e = 'hour';
const $88f80910cde3e0d3$export$1a58b8d7f494dd72 = 'day';
const $88f80910cde3e0d3$export$3241045aa1844a20 = 'week';
const $88f80910cde3e0d3$export$b387b66963374517 = 'days';
const $88f80910cde3e0d3$export$f25ebc73c10ad2c = 'hours';
const $88f80910cde3e0d3$export$d39e6ebabedff673 = 'pretty';
const $88f80910cde3e0d3$export$e17ebf14f4144ede = {
    isTimeTrackingEnabled: false,
    daysPerWeek: 5,
    hoursPerDay: 8,
    defaultUnit: $88f80910cde3e0d3$export$f4aba04677f37907,
    format: $88f80910cde3e0d3$export$d39e6ebabedff673
};
const $88f80910cde3e0d3$export$7a0204710d322de6 = 'LOCK_IN_NEW_ISSUE_VIEW';
const $88f80910cde3e0d3$export$83f9ac2d887bd06a = 'DEFAULT_TO_NEW_ISSUE_VIEW';
const $88f80910cde3e0d3$export$f269c0bf10ad77e2 = 'DEFAULT_TO_OLD_ISSUE_VIEW';

});

parcelRegister("etKNj", function(module, exports) {

$parcel$export(module.exports, "timeTrackingFormatter", () => $5d7d4350edc91a82$export$5169d8c8f9327e33);
$parcel$export(module.exports, "timeTrackingFormatterWithDefaults", () => $5d7d4350edc91a82$export$71be3aa954f6065b);
$parcel$export(module.exports, "timeTrackingFormatterLongForm", () => $5d7d4350edc91a82$export$bb4e82d8c2aeeff1);
$parcel$export(module.exports, "transformAGGToJiraTimeFormat", () => $5d7d4350edc91a82$export$9dccd3a07969375d);
$parcel$export(module.exports, "transformAGGToJiraTimeUnit", () => $5d7d4350edc91a82$export$8516173ab945b52f);

var $gBj4V = parcelRequire("gBj4V");

var $lgkxY = parcelRequire("lgkxY");

var $4TB2x = parcelRequire("4TB2x");
const $5d7d4350edc91a82$var$validate = (condition)=>(distance)=>condition ? distance : 0;
// Format time to be 2 decimal places without trailing zeros
const $5d7d4350edc91a82$var$timeFormatter = (time, unit)=>time > 0 ? `${time.toFixed(2).replace(/\.?0+$/, '')}${unit}` : `0${unit}`;
const $5d7d4350edc91a82$var$timePrettyFormatter = (timeInSeconds, units, formatMessage)=>{
    const timeForZero = `0${formatMessage(units[3].suffix)}`;
    if (timeInSeconds <= 0) return timeForZero;
    const initialTimeObj = {
        secondsRemaining: timeInSeconds,
        time: ''
    };
    const result = units.reduce((timeObj, unit)=>{
        if (unit.seconds <= 0) return timeObj;
        const currentTimeValue = Math.floor(timeObj.secondsRemaining / unit.seconds);
        const secondsRemaining = currentTimeValue > 0 ? timeObj.secondsRemaining % unit.seconds : timeObj.secondsRemaining;
        const time = currentTimeValue > 0 ? `${timeObj.time} ${currentTimeValue}${formatMessage(unit.suffix)}` : timeObj.time;
        return {
            secondsRemaining: secondsRemaining,
            time: time
        };
    }, initialTimeObj);
    return result.time.trim() || timeForZero;
};
const $5d7d4350edc91a82$var$timePrettyFormatterLongForm = (timeInSeconds, units, formatMessage)=>{
    const timeForZero = `0 ${formatMessage(units[3].suffix, {
        [units[3].type]: 0
    })}`;
    if (timeInSeconds <= 0) return timeForZero;
    const initialTimeObj = {
        secondsRemaining: timeInSeconds,
        time: ''
    };
    const result = units.reduce((timeObj, unit)=>{
        if (unit.seconds <= 0) return timeObj;
        const { suffix: suffix, type: type } = unit;
        const currentTimeValue = Math.floor(timeObj.secondsRemaining / unit.seconds);
        if (currentTimeValue === 1) return {
            secondsRemaining: timeObj.secondsRemaining % unit.seconds,
            time: `${timeObj.time} ${currentTimeValue} ${formatMessage(suffix, {
                [type]: currentTimeValue
            })}`
        };
        const secondsRemaining = currentTimeValue > 1 ? timeObj.secondsRemaining % unit.seconds : timeObj.secondsRemaining;
        const time = currentTimeValue > 1 ? `${timeObj.time} ${currentTimeValue} ${formatMessage(suffix, {
            [type]: currentTimeValue
        })}` : timeObj.time;
        return {
            secondsRemaining: secondsRemaining,
            time: time
        };
    }, initialTimeObj);
    return result.time.trim() || timeForZero;
};
const $5d7d4350edc91a82$export$5169d8c8f9327e33 = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat } = (0, $gBj4V.defaultTimeTrackingOptions), { formatMessage: formatMessage })=>{
    const isTimeValid = timeInSeconds > 0;
    const isTimeInDaysValid = isTimeValid && workingHoursPerDay > 0;
    const unit = (0, $4TB2x.createUnit)(timeInSeconds);
    const units = [
        unit({
            type: 'week',
            suffix: (0, $lgkxY.default).timeUnitWeek,
            seconds: Math.max(workingDaysPerWeek, 0) * Math.max(workingHoursPerDay, 0) * (0, $gBj4V.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'day',
            suffix: (0, $lgkxY.default).timeUnitDay,
            transform: $5d7d4350edc91a82$var$validate(isTimeInDaysValid),
            seconds: Math.max(workingHoursPerDay, 0) * (0, $gBj4V.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'hour',
            suffix: (0, $lgkxY.default).timeUnitHour,
            transform: $5d7d4350edc91a82$var$validate(isTimeValid),
            seconds: (0, $gBj4V.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'minute',
            suffix: (0, $lgkxY.default).timeUnitMinute,
            seconds: (0, $gBj4V.SECONDS_PER_MINUTE)
        })
    ];
    switch(timeFormat){
        case (0, $gBj4V.TimeFormats).DAYS:
            return $5d7d4350edc91a82$var$timeFormatter(units[1].time, formatMessage(units[1].suffix));
        case (0, $gBj4V.TimeFormats).HOURS:
            return $5d7d4350edc91a82$var$timeFormatter(units[2].time, formatMessage(units[2].suffix));
        case (0, $gBj4V.TimeFormats).PRETTY:
        default:
            return $5d7d4350edc91a82$var$timePrettyFormatter(timeInSeconds, units, formatMessage);
    }
};
const $5d7d4350edc91a82$export$71be3aa954f6065b = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat }, intl)=>{
    const timeTrackingSettings = {
        workingHoursPerDay: workingHoursPerDay || (0, $gBj4V.defaultTimeTrackingOptions).workingHoursPerDay,
        workingDaysPerWeek: workingDaysPerWeek || (0, $gBj4V.defaultTimeTrackingOptions).workingDaysPerWeek,
        timeFormat: timeFormat || (0, $gBj4V.defaultTimeTrackingOptions).timeFormat,
        defaultUnit: (0, $gBj4V.defaultTimeTrackingOptions).defaultUnit
    };
    return $5d7d4350edc91a82$export$5169d8c8f9327e33(timeInSeconds || 0, timeTrackingSettings, intl);
};
const $5d7d4350edc91a82$export$bb4e82d8c2aeeff1 = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat } = (0, $gBj4V.defaultTimeTrackingOptions), { formatMessage: formatMessage })=>{
    const isTimeValid = timeInSeconds > 0;
    const isTimeInDaysValid = isTimeValid && workingHoursPerDay > 0;
    const unit = (0, $4TB2x.createUnit)(timeInSeconds);
    const units = [
        unit({
            type: 'week',
            suffix: (0, $lgkxY.default).timeUnitLongWeek,
            seconds: Math.max(workingDaysPerWeek, 0) * Math.max(workingHoursPerDay, 0) * (0, $gBj4V.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'day',
            suffix: (0, $lgkxY.default).timeUnitLongDay,
            transform: $5d7d4350edc91a82$var$validate(isTimeInDaysValid),
            seconds: Math.max(workingHoursPerDay, 0) * (0, $gBj4V.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'hour',
            suffix: (0, $lgkxY.default).timeUnitLongHour,
            transform: $5d7d4350edc91a82$var$validate(isTimeValid),
            seconds: (0, $gBj4V.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'minute',
            suffix: (0, $lgkxY.default).timeUnitLongMinute,
            seconds: (0, $gBj4V.SECONDS_PER_MINUTE)
        })
    ];
    switch(timeFormat){
        case (0, $gBj4V.TimeFormats).DAYS:
            return $5d7d4350edc91a82$var$timeFormatter(units[1].time, ` ${formatMessage(units[1].suffix, {
                day: units[1].time
            })}`);
        case (0, $gBj4V.TimeFormats).HOURS:
            return $5d7d4350edc91a82$var$timeFormatter(units[2].time, ` ${formatMessage(units[2].suffix, {
                hour: units[2].time
            })}`);
        case (0, $gBj4V.TimeFormats).PRETTY:
        default:
            return $5d7d4350edc91a82$var$timePrettyFormatterLongForm(timeInSeconds, units, formatMessage);
    }
};
const $5d7d4350edc91a82$export$9dccd3a07969375d = (format)=>{
    switch(String(format).toLowerCase()){
        case (0, $gBj4V.TimeFormats).DAYS:
            return (0, $gBj4V.TimeFormats).DAYS;
        case (0, $gBj4V.TimeFormats).HOURS:
            return (0, $gBj4V.TimeFormats).HOURS;
        case (0, $gBj4V.TimeFormats).PRETTY:
            return (0, $gBj4V.TimeFormats).PRETTY;
        default:
            return (0, $gBj4V.TimeFormats).DAYS;
    }
};
const $5d7d4350edc91a82$export$8516173ab945b52f = (defaultUnit)=>{
    switch(String(defaultUnit).toLowerCase()){
        case (0, $gBj4V.TimeUnits).DAY:
            return (0, $gBj4V.TimeUnits).DAY;
        case (0, $gBj4V.TimeUnits).HOUR:
            return (0, $gBj4V.TimeUnits).HOUR;
        case (0, $gBj4V.TimeUnits).MINUTE:
            return (0, $gBj4V.TimeUnits).MINUTE;
        case (0, $gBj4V.TimeUnits).WEEK:
            return (0, $gBj4V.TimeUnits).WEEK;
        default:
            return (0, $gBj4V.TimeUnits).DAY;
    }
};

});
parcelRegister("gBj4V", function(module, exports) {

$parcel$export(module.exports, "SECONDS_PER_MINUTE", () => $f8bb2765f8828f08$export$544c576050746347);
$parcel$export(module.exports, "SECONDS_PER_HOUR", () => $f8bb2765f8828f08$export$3cc7ae4b390f50a);
$parcel$export(module.exports, "TimeFormats", () => $f8bb2765f8828f08$export$5d7ed58d46354b1);
$parcel$export(module.exports, "TimeUnits", () => $f8bb2765f8828f08$export$5d7753c8ad881494);
$parcel$export(module.exports, "defaultTimeTrackingOptions", () => $f8bb2765f8828f08$export$f8d48c1fed813e90);
const $f8bb2765f8828f08$export$544c576050746347 = 60;
const $f8bb2765f8828f08$var$MINUTES_PER_HOUR = 60;
const $f8bb2765f8828f08$export$3cc7ae4b390f50a = $f8bb2765f8828f08$var$MINUTES_PER_HOUR * $f8bb2765f8828f08$export$544c576050746347;
const $f8bb2765f8828f08$var$TIME_FORMAT_PRETTY = 'pretty';
const $f8bb2765f8828f08$var$TIME_FORMAT_DAYS = 'days';
const $f8bb2765f8828f08$var$TIME_FORMAT_HOURS = 'hours';
const $f8bb2765f8828f08$export$5d7ed58d46354b1 = Object.freeze({
    PRETTY: $f8bb2765f8828f08$var$TIME_FORMAT_PRETTY,
    DAYS: $f8bb2765f8828f08$var$TIME_FORMAT_DAYS,
    HOURS: $f8bb2765f8828f08$var$TIME_FORMAT_HOURS
});
const $f8bb2765f8828f08$var$TIME_UNIT_WEEK = 'week';
const $f8bb2765f8828f08$var$TIME_UNIT_DAY = 'day';
const $f8bb2765f8828f08$var$TIME_UNIT_HOUR = 'hour';
const $f8bb2765f8828f08$var$TIME_UNIT_MINUTE = 'minute';
const $f8bb2765f8828f08$export$5d7753c8ad881494 = Object.freeze({
    WEEK: $f8bb2765f8828f08$var$TIME_UNIT_WEEK,
    DAY: $f8bb2765f8828f08$var$TIME_UNIT_DAY,
    HOUR: $f8bb2765f8828f08$var$TIME_UNIT_HOUR,
    MINUTE: $f8bb2765f8828f08$var$TIME_UNIT_MINUTE
});
const $f8bb2765f8828f08$export$f8d48c1fed813e90 = {
    workingHoursPerDay: 8,
    workingDaysPerWeek: 5,
    timeFormat: $f8bb2765f8828f08$export$5d7ed58d46354b1.PRETTY,
    defaultUnit: $f8bb2765f8828f08$export$5d7753c8ad881494.MINUTE
};

});

parcelRegister("lgkxY", function(module, exports) {

$parcel$export(module.exports, "default", () => $00e424f4a1d744f3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $00e424f4a1d744f3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    timeUnitWeek: {
        "id": "time-tracking-formatter.time-unit-week",
        "defaultMessage": "w"
    },
    timeUnitDay: {
        "id": "time-tracking-formatter.time-unit-day",
        "defaultMessage": "d"
    },
    timeUnitHour: {
        "id": "time-tracking-formatter.time-unit-hour",
        "defaultMessage": "h"
    },
    timeUnitMinute: {
        "id": "time-tracking-formatter.time-unit-minute",
        "defaultMessage": "m"
    },
    timeUnitLongWeek: {
        "id": "time-tracking-formatter.time-unit-long-week",
        "defaultMessage": "{week, plural, zero {weeks} one {week} other {weeks} }"
    },
    timeUnitLongDay: {
        "id": "time-tracking-formatter.time-unit-long-day",
        "defaultMessage": "{day, plural, zero {days} one {day} other {days} }"
    },
    timeUnitLongHour: {
        "id": "time-tracking-formatter.time-unit-long-hour",
        "defaultMessage": "{hour, plural, zero {hours} one {hour} other {hours} }"
    },
    timeUnitLongMinute: {
        "id": "time-tracking-formatter.time-unit-long-minute",
        "defaultMessage": "{minute, plural, zero {minutes} one {minute} other {minutes} }"
    }
});

});

parcelRegister("4TB2x", function(module, exports) {

$parcel$export(module.exports, "createUnit", () => $d8f5ee4c356dec74$export$aab44654646f3ccc);
const $d8f5ee4c356dec74$export$aab44654646f3ccc = (timeInSeconds)=>({ suffix: suffix, seconds: seconds, type: type, transform: transform })=>{
        const distance = timeInSeconds / seconds;
        const time = transform ? transform(distance) : distance;
        return {
            seconds: seconds,
            suffix: suffix,
            time: time,
            type: type
        };
    };

});


parcelRegister("k698r", function(module, exports) {

$parcel$export(module.exports, "timeFormatMap", () => $f501f8b965f0cf20$export$17f3cee8c0df1);

var $2Igls = parcelRequire("2Igls");
const $f501f8b965f0cf20$export$17f3cee8c0df1 = new Map([
    [
        'HOURS',
        (0, $2Igls.HOURS)
    ],
    [
        'hours',
        (0, $2Igls.HOURS)
    ],
    [
        'DAYS',
        (0, $2Igls.DAYS)
    ],
    [
        'days',
        (0, $2Igls.DAYS)
    ],
    [
        'PRETTY',
        (0, $2Igls.PRETTY)
    ],
    [
        'pretty',
        (0, $2Igls.PRETTY)
    ]
]);

});




parcelRegister("dC9wp", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5aae8c49d2090cb$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f5aae8c49d2090cb$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorTitle: {
        "id": "business-list.controllers.children-query.error-title",
        "defaultMessage": "We couldn't load items."
    },
    errorMessage: {
        "id": "business-list.controllers.children-query.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    }
});

});


parcelRegister("8Ugqh", function(module, exports) {

$parcel$export(module.exports, "useSetChildrenItems", () => $ddd86149d753423f$export$1d27e69d8e0f02db);

var $5uXOq = parcelRequire("5uXOq");

var $8TUlY = parcelRequire("8TUlY");

var $acMuh = parcelRequire("acMuh");

var $9u99d = parcelRequire("9u99d");
const $ddd86149d753423f$export$1d27e69d8e0f02db = ()=>{
    const [, { setChildrenItems: setChildrenItems }] = (0, $9u99d.useHierarchyStore)();
    const [rowCreateState, { setRowCreatePosition: setRowCreatePosition }] = (0, $acMuh.useRowCreateStore)();
    const { hierarchyLevelsWithCache: hierarchyLevelsWithCache } = (0, $8TUlY.useIssueFields)();
    const setChildrenItemsWithDependencies = (0, $5uXOq.useCallback)((parentIssueId, queryData)=>setChildrenItems(parentIssueId, queryData, rowCreateState, setRowCreatePosition, hierarchyLevelsWithCache), [
        setChildrenItems,
        rowCreateState,
        setRowCreatePosition,
        hierarchyLevelsWithCache
    ]);
    return {
        setChildrenItems: setChildrenItemsWithDependencies
    };
};

});
parcelRegister("acMuh", function(module, exports) {

$parcel$export(module.exports, "useRowCreateStore", () => $4b5fb03663355d26$export$b9c0fc956229dde8);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $4b5fb03663355d26$var$initialState = {
    parentId: undefined,
    anchorId: undefined
};
const $4b5fb03663355d26$var$actions = {
    setRowCreatePosition: (rowCreatePosition)=>({ setState: setState })=>{
            if (rowCreatePosition) setState(rowCreatePosition);
        },
    resetRowCreatePosition: ()=>({ setState: setState })=>setState($4b5fb03663355d26$var$initialState)
};
const $4b5fb03663355d26$var$ListViewRowCreateStore = (0, $iXqE5.createStore)({
    initialState: $4b5fb03663355d26$var$initialState,
    actions: $4b5fb03663355d26$var$actions,
    name: 'JWMListViewRowInlineCreate'
});
const $4b5fb03663355d26$export$b9c0fc956229dde8 = (0, $3sQ5x.createHook)($4b5fb03663355d26$var$ListViewRowCreateStore);

});



parcelRegister("jahNX", function(module, exports) {

$parcel$export(module.exports, "default", () => $299757a118bd0bad$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cm8b5 = parcelRequire("cm8b5");

var $8tf7c = parcelRequire("8tf7c");

var $1XJ20 = parcelRequire("1XJ20");

var $4R6GH = parcelRequire("4R6GH");

var $eTDjN = parcelRequire("eTDjN");

var $8e3Yw = parcelRequire("8e3Yw");

var $gwq1c = parcelRequire("gwq1c");

var $igEI3 = parcelRequire("igEI3");

var $4k0re = parcelRequire("4k0re");

var $9u99d = parcelRequire("9u99d");

var $5mOA5 = parcelRequire("5mOA5");

var $1Qz1F = parcelRequire("1Qz1F");

var $2lh30 = parcelRequire("2lh30");
const $299757a118bd0bad$var$GroupsLoader = ()=>{
    const items = (0, $gwq1c.useListItemGroups)();
    const { childrenLoader: childrenLoader } = (0, $4k0re.useGroupChildrenLoader)({
        groups: items.data
    });
    const prevItems = (0, $1XJ20.usePreviousWithInitial)(items);
    const [, { expandFirstItems: expandFirstItems }] = (0, $9u99d.useHierarchyStore)();
    const { setHierarchyData: setHierarchyData } = (0, $1Qz1F.useSetHierarchyData)();
    const [groupByFieldId] = (0, $8e3Yw.useGroupBy)();
    const { resetListViewGroupByRefreshCacheTrigger: resetListViewGroupByRefreshCacheTrigger } = (0, $4R6GH.fg)('refetch_status_on_list_group_by_status') ? (0, $2lh30.useListViewRefreshCacheActions)() : {
        resetListViewGroupByRefreshCacheTrigger: undefined
    };
    const shouldTriggerGroupByCacheRefresh = (0, $4R6GH.fg)('refetch_status_on_list_group_by_status') ? (0, $2lh30.useListViewRefreshCacheStore)((state)=>state.shouldTriggerGroupByCacheRefresh) : false;
    (0, $cm8b5.useQueryBasedViewAutomaticTracking)((0, $eTDjN.LOAD_GROUP_ITEMS_EXPERIENCE), {
        loading: items.loading,
        error: items.error,
        shouldStartExperience: true
    });
    // resets expanded items and queryData cache when filtering/sorting/groupBy is updated
    (0, $5mOA5.useResetItems)();
    (0, $5uXOq.useEffect)(()=>{
        if (shouldTriggerGroupByCacheRefresh) {
            items.refetch();
            resetListViewGroupByRefreshCacheTrigger?.();
        }
    }, [
        items,
        resetListViewGroupByRefreshCacheTrigger,
        shouldTriggerGroupByCacheRefresh
    ]);
    // initialize items when switching between grouping -> hierarchy
    (0, $5uXOq.useEffect)(()=>{
        if (items.loading) return;
        setHierarchyData(items);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        items.loading
    ]);
    // updates groups only when "data", "loading", "isLoadingNextPage" or "totalCount" changes
    (0, $5uXOq.useEffect)(()=>{
        if (prevItems.totalCount !== items.totalCount || prevItems.loading !== items.loading || prevItems.data !== items.data || prevItems.isLoadingNextPage !== items.isLoadingNextPage) setHierarchyData(items);
    }, [
        items,
        prevItems,
        setHierarchyData
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!items.loading && groupByFieldId != null) expandFirstItems();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        items.loading,
        groupByFieldId
    ]);
    // avoid re-fetching children when GroupsLoader re-renders
    const groupChildrenLoader = (0, $5uXOq.useMemo)(()=>childrenLoader, [
        childrenLoader
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, groupChildrenLoader, items.error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8tf7c.ErrorFlag), {
        error: items.error,
        title: (0, $igEI3.default).errorTitle,
        description: (0, $igEI3.default).errorMessage
    }));
};
var // eslint-disable-next-line @typescript-eslint/no-explicit-any
$299757a118bd0bad$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($299757a118bd0bad$var$GroupsLoader);

});
parcelRegister("gwq1c", function(module, exports) {

$parcel$export(module.exports, "useListItemGroups", () => $e2a9a1a3d0a8153f$export$cc19d2aa74250242);

var $5YBrl = parcelRequire("5YBrl");

var $gribp = parcelRequire("gribp");

var $8e3Yw = parcelRequire("8e3Yw");
const $e2a9a1a3d0a8153f$export$cc19d2aa74250242 = ()=>{
    const [groupByFieldId] = (0, $8e3Yw.useGroupBy)();
    const jqlContext = (0, $5YBrl.useJqlContext)();
    return (0, $gribp.useListItemGroups)({
        input: {
            jqlContext: jqlContext,
            groupByFieldId: groupByFieldId
        }
    });
};

});
parcelRegister("gribp", function(module, exports) {

$parcel$export(module.exports, "getGroupVariables", () => $b5de0af99da479ba$export$5c591b26f9c07c51);
$parcel$export(module.exports, "useListViewGroupRecovery", () => $b5de0af99da479ba$export$30e59d989a124a32);
$parcel$export(module.exports, "useListItemGroups", () => $b5de0af99da479ba$export$cc19d2aa74250242);
/* eslint-disable camelcase */ 
var $5uXOq = parcelRequire("5uXOq");

var $3JOCw = parcelRequire("3JOCw");

var $5tTFS = parcelRequire("5tTFS");

var $hE5wF = parcelRequire("hE5wF");

var $fyPbs = parcelRequire("fyPbs");

var $jcw0u = parcelRequire("jcw0u");

var $5fc53 = parcelRequire("5fc53");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $4NLOw = parcelRequire("4NLOw");

var $3WUKM = parcelRequire("3WUKM");

var $ktYkO = parcelRequire("ktYkO");
const $b5de0af99da479ba$var$DEFAULT_ITEMS_PER_PAGE = 50;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b5de0af99da479ba$var$emptyArray = [];
const $b5de0af99da479ba$var$fieldIds = [
    (0, $5fc53.ASSIGNEE_TYPE),
    (0, $5fc53.PRIORITY_TYPE),
    (0, $5fc53.STATUS_TYPE),
    (0, $hE5wF.STORY_POINTS_ALIAS_FIELD_ID),
    (0, $hE5wF.STORY_POINT_ESTIMATE_ALIAS_FIELD_ID)
];
const $b5de0af99da479ba$export$5c591b26f9c07c51 = ({ groupByFieldId: groupByFieldId, jqlContext: jqlContext })=>{
    const jql = jqlContext || '';
    return {
        jql: jql,
        first: $b5de0af99da479ba$var$DEFAULT_ITEMS_PER_PAGE,
        groupByFieldId: groupByFieldId != null ? groupByFieldId : '',
        fieldIds: $b5de0af99da479ba$var$fieldIds
    };
};
const $b5de0af99da479ba$export$30e59d989a124a32 = (input, settings)=>{
    const variables = $b5de0af99da479ba$export$5c591b26f9c07c51(input);
    return (0, $fyPbs.useGroupRecovery)({
        settings: settings,
        queryList: (0, $3WUKM.LIST_VIEW_ITEM_GROUPS_QUERY),
        queryBackgroundList: (0, $3WUKM.BACKGROUND_LIST_VIEW_ITEMS_GROUPS_QUERY),
        variables: variables,
        onError: (apolloError)=>{
            if (!(0, $4NLOw.shouldHandleTheError)(apolloError)) return;
            (0, $jcw0u.default)({
                meta: {
                    id: 'listRecoveryGroupQuery',
                    packageName: 'jiraBusinessList',
                    teamName: 'keystone'
                },
                attributes: {
                    message: 'Failed to fetch issues in background in list view while grouping'
                },
                error: apolloError,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    });
};
const $b5de0af99da479ba$export$cc19d2aa74250242 = ({ input: input })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isLoadingNextPage, setIsLoadingNextPage] = (0, $5uXOq.useState)(false);
    const { data: data, loading: loading, error: error, fetchMore: fetchMore, refetch: refetch } = (0, $5tTFS.useQuery)((0, $3WUKM.LIST_VIEW_ITEM_GROUPS_QUERY), {
        variables: $b5de0af99da479ba$export$5c591b26f9c07c51(input),
        onCompleted: (responseData)=>{
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'listViewItemGroupsQuery succeeded', {
                groupsCount: responseData.groups?.nodes?.length
            });
        },
        onError: (apolloError)=>{
            if (!(0, $4NLOw.shouldHandleTheError)(apolloError)) return;
            (0, $jcw0u.default)({
                meta: {
                    id: 'listViewItemGroupsQuery',
                    packageName: 'jiraBusinessList',
                    teamName: 'keystone'
                },
                attributes: {
                    message: 'Failed to fetch item groups in list view'
                },
                error: apolloError,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    });
    const totalCount = data?.groups?.totalCount || 0;
    const nodes = data?.groups?.nodes || $b5de0af99da479ba$var$emptyArray;
    const hasNextPage = data?.groups?.pageInfo?.hasNextPage || false;
    const endCursor = data?.groups?.pageInfo?.endCursor || '';
    const result = (0, $5uXOq.useMemo)(()=>{
        if (!Array.isArray(nodes) || nodes.length === 0) return [];
        return (0, $ktYkO.transformResult)(nodes);
    }, [
        nodes
    ]);
    const loadNextPage = (0, $5uXOq.useCallback)(()=>{
        /*
		 * Do not load the same page twice and do not load the next page if
		 * a request is already in progress.
		 */ if (!hasNextPage || loading) return;
        setIsLoadingNextPage(true);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'table endReached');
        fetchMore({
            variables: {
                ...$b5de0af99da479ba$export$5c591b26f9c07c51(input),
                after: endCursor
            },
            // @ts-expect-error - The expected type comes from property 'updateQuery' which is declared here on type 'FetchMoreQueryOptions<JWMListViewItemGroupsWithPaginationVariables, keyof
            updateQuery: (prev, { fetchMoreResult: fetchMoreResult })=>{
                setIsLoadingNextPage(false);
                if (!fetchMoreResult) return prev;
                const updatedNodes = [
                    ...prev?.groups?.nodes || [],
                    ...fetchMoreResult?.groups?.nodes || []
                ];
                return {
                    groups: {
                        ...fetchMoreResult.groups,
                        nodes: (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))(updatedNodes, 'id')
                    }
                };
            },
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            onError: (apolloError)=>{
                (0, $jcw0u.default)({
                    meta: {
                        id: 'listViewItemGroupsQuery',
                        packageName: 'jiraBusinessList',
                        teamName: 'keystone'
                    },
                    attributes: {
                        message: 'Failed to fetch more item groups in list view'
                    },
                    error: apolloError,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        });
    }, [
        createAnalyticsEvent,
        endCursor,
        fetchMore,
        hasNextPage,
        input,
        loading
    ]);
    return {
        data: result,
        loading: loading,
        error: error,
        totalCount: totalCount,
        hasNextPage: hasNextPage,
        isLoadingNextPage: isLoadingNextPage,
        loadNextPage: loadNextPage,
        refetch: refetch
    };
};

});
parcelRegister("fyPbs", function(module, exports) {

$parcel$export(module.exports, "useGroupRecovery", () => $21c2f85161b33d23$export$b5990c6f00139390);

var $5uXOq = parcelRequire("5uXOq");

var $5tTFS = parcelRequire("5tTFS");

var $8my64 = parcelRequire("8my64");

var $jcw0u = parcelRequire("jcw0u");

var $1XJ20 = parcelRequire("1XJ20");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $cvbVg = parcelRequire("cvbVg");
const $21c2f85161b33d23$var$MAX_ITEMS_PER_PAGE = 50;
const $21c2f85161b33d23$var$getOperationName = (query)=>{
    const operation = (0, $8my64.getOperationAST)(query, undefined);
    return operation && operation.name && operation.name.value || '';
};
const $21c2f85161b33d23$export$b5990c6f00139390 = ({ settings: settings, queryList: queryList, queryBackgroundList: queryBackgroundList, variables: variables, onError: onError })=>{
    const analyticsTaskId = $21c2f85161b33d23$var$getOperationName(queryBackgroundList);
    const analyticsTaskName = 'groupsBackgroundRefetch';
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const backgroundQueryVariables = (0, $5uXOq.useMemo)(()=>({
            ...variables,
            first: $21c2f85161b33d23$var$MAX_ITEMS_PER_PAGE
        }), [
        variables
    ]);
    const client = (0, $5tTFS.useApolloClient)();
    const [fetchListInBackground, { loading: loading, data: data, fetchMore: fetchMore }] = (0, $5tTFS.useLazyQuery)(queryBackgroundList, {
        fetchPolicy: 'network-only',
        onError: onError
    });
    const [hasStarted, setHasStarted] = (0, $5uXOq.useState)(false);
    const [hasFinished, setHasFinished] = (0, $5uXOq.useState)(false);
    const [refreshCount, setRefreshCount] = (0, $5uXOq.useState)(0);
    const [currentQuery, setCurrentQuery] = (0, $5uXOq.useState)();
    const [currentGroup, setCurrentGroup] = (0, $5uXOq.useState)();
    const listEndCursor = (0, $5uXOq.useRef)(undefined);
    const { hasNextPage: hasNextPage, endCursor: endCursor } = data?.backgroundGroups?.pageInfo || {};
    const prevEndCursor = (0, $1XJ20.usePreviousWithInitial)(endCursor);
    // refetch all pages until the current endCursor: if we have 5 pages in total, list endCursor is on page 2,
    // then background refresh will pull first 2 pages only
    (0, $5uXOq.useEffect)(()=>{
        if (hasStarted && hasNextPage && // query pages one-by-one until we reach the current page
        endCursor !== listEndCursor.current && // query pages only when endCursor changes,
        // otherwise it might query the same page multiple times due to re-renders of useListRecovery
        endCursor !== prevEndCursor) fetchMore({
            variables: {
                ...backgroundQueryVariables,
                after: endCursor
            },
            updateQuery: (prev, { fetchMoreResult: fetchMoreResult })=>{
                if (!fetchMoreResult) return prev;
                const updatedNodes = [
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    ...prev?.backgroundGroups?.nodes || [],
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    ...fetchMoreResult?.backgroundGroups?.nodes || []
                ];
                return {
                    backgroundGroups: {
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        ...fetchMoreResult.backgroundGroups,
                        nodes: updatedNodes
                    }
                };
            }
        });
    }, [
        hasStarted,
        hasNextPage,
        endCursor,
        prevEndCursor,
        fetchListInBackground,
        backgroundQueryVariables,
        fetchMore
    ]);
    // abort background operations if a new query is provided
    (0, $5uXOq.useEffect)(()=>{
        if (!hasStarted || variables.jql === currentQuery && variables.groupByFieldId === currentGroup) return;
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'ui taskAbort', {
            task: analyticsTaskName,
            taskId: analyticsTaskId,
            reason: 'query has changed'
        });
        setHasFinished(true);
        setHasStarted(false);
        setCurrentQuery(undefined);
        setCurrentGroup(undefined);
    }, [
        analyticsTaskId,
        createAnalyticsEvent,
        currentGroup,
        currentQuery,
        hasStarted,
        variables,
        variables.groupByFieldId,
        variables.jql
    ]);
    // replace list items with backgroundList items so the main view will update
    (0, $5uXOq.useEffect)(()=>{
        if (hasStarted && !hasFinished && !loading && listEndCursor.current === endCursor) try {
            const backgroundListData = client.readQuery({
                query: queryBackgroundList,
                variables: backgroundQueryVariables
            });
            const getCachedListData = ()=>{
                try {
                    const read = client.readQuery({
                        query: queryList,
                        variables: variables
                    });
                    (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheRead taskSuccess', {
                        task: analyticsTaskName,
                        taskId: analyticsTaskId
                    });
                    return read;
                } catch (e) {
                    (0, $jcw0u.default)({
                        error: e instanceof Error ? e : new Error('Unknown cache read error'),
                        meta: {
                            id: 'useGroupRecovery',
                            packageName: 'jiraBusinessListHandlers',
                            teamName: 'keystone'
                        },
                        sendToPrivacyUnsafeSplunk: true,
                        skipSentry: true,
                        attributes: {
                            task: analyticsTaskName,
                            taskId: analyticsTaskId,
                            query: JSON.stringify(queryList),
                            variables: JSON.stringify(variables),
                            eventName: 'apolloCacheRead taskFail',
                            error: JSON.stringify(e)
                        }
                    });
                    return null;
                }
            };
            const listData = getCachedListData();
            setRefreshCount(refreshCount + 1);
            setHasFinished(true);
            setHasStarted(false);
            setCurrentQuery(undefined);
            setCurrentGroup(undefined);
            if (!backgroundListData || backgroundListData.backgroundGroups == null || !listData || listData.groups == null || !Array.isArray(backgroundListData.backgroundGroups.nodes) || !Array.isArray(listData.groups.nodes)) throw new Error('Conditions not met');
            const { backgroundGroups: backgroundGroups } = backgroundListData;
            if (backgroundGroups.nodes == null) return;
            client.writeQuery({
                query: queryList,
                variables: variables,
                data: {
                    groups: {
                        ...backgroundGroups,
                        nodes: backgroundGroups.nodes
                    }
                }
            });
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'ui taskSuccess', {
                task: analyticsTaskName,
                taskId: analyticsTaskId,
                details: `${backgroundGroups.nodes.length} items updated`
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'ui taskFail', {
                task: analyticsTaskName,
                taskId: analyticsTaskId,
                error: `Failed to refresh data in the background (${e.name || 'error'})`
            });
        }
    }, [
        hasStarted,
        client,
        loading,
        hasFinished,
        refreshCount,
        backgroundQueryVariables,
        queryList,
        queryBackgroundList,
        variables,
        createAnalyticsEvent,
        analyticsTaskId,
        endCursor
    ]);
    const refreshList = (0, $5uXOq.useCallback)(()=>{
        if (hasStarted && !hasFinished || settings.isDisabled) return;
        const listData = client.readQuery({
            query: queryList,
            variables: variables
        });
        // store current list endCursor so that we know at what page to stop backgroundList fetching
        listEndCursor.current = listData?.groups?.pageInfo?.endCursor;
        fetchListInBackground({
            variables: backgroundQueryVariables
        });
        setCurrentQuery(variables.jql);
        setCurrentGroup(variables.groupByFieldId);
        setHasStarted(true);
        setHasFinished(false);
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'ui taskStart', {
            task: analyticsTaskName,
            taskId: analyticsTaskId
        });
    }, [
        analyticsTaskId,
        backgroundQueryVariables,
        client,
        createAnalyticsEvent,
        fetchListInBackground,
        hasFinished,
        hasStarted,
        queryList,
        settings.isDisabled,
        variables
    ]);
    const isRefreshing = hasStarted && !hasFinished;
    (0, $cvbVg.useRefreshInterval)(refreshList, // it won't trigger a refresh if another has been triggered
    // it won't trigger refresh if the tab is invisible
    settings.isVisible && !isRefreshing, settings.updateInterval);
    return {
        isRefreshing: isRefreshing,
        refreshCount: refreshCount,
        refreshList: refreshList
    };
};

});
parcelRegister("8my64", function(module, exports) {

$parcel$export(module.exports, "getOperationAST", () => $616ad3b99120bff0$export$1f718485f6b6643f);

var $bzIlO = parcelRequire("bzIlO");
function $616ad3b99120bff0$export$1f718485f6b6643f(documentAST, operationName) {
    var operation = null;
    for(var _i2 = 0, _documentAST$definiti2 = documentAST.definitions; _i2 < _documentAST$definiti2.length; _i2++){
        var definition = _documentAST$definiti2[_i2];
        if (definition.kind === (0, $bzIlO.Kind).OPERATION_DEFINITION) {
            var _definition$name;
            if (operationName == null) {
                // If no operation name was provided, only return an Operation if there
                // is one defined in the document. Upon encountering the second, return
                // null.
                if (operation) return null;
                operation = definition;
            } else if (((_definition$name = definition.name) === null || _definition$name === void 0 ? void 0 : _definition$name.value) === operationName) return definition;
        }
    }
    return operation;
}

});


parcelRegister("3WUKM", function(module, exports) {

$parcel$export(module.exports, "LIST_VIEW_ITEM_GROUPS_QUERY", () => $ece5837ebbdf5681$export$ee6c63a9d588e5da);
$parcel$export(module.exports, "BACKGROUND_LIST_VIEW_ITEMS_GROUPS_QUERY", () => $ece5837ebbdf5681$export$1531880e8d0ec6bc);

var $5cllN = parcelRequire("5cllN");

var $cNu0r = parcelRequire("cNu0r");
const $ece5837ebbdf5681$export$ee6c63a9d588e5da = (0, $5cllN.default)`
    query JWMListViewItemGroupsWithPagination ($jql: String!, $groupByFieldId: ID!, $fieldIds: [String]!, $first: Int, $last: Int, $before: String, $after: String) {
        groups: jwmItemGroups(jql: $jql, groupByFieldId: $groupByFieldId, fieldIds: $fieldIds, first: $first, last: $last, before: $before, after: $after) @connection (key: "groups", filter:["jql", "groupByFieldId"]) {
            totalCount
            nodes {
                id
                field {
                    __typename
                    ...on StatusField {
                        fieldKey
                        name
                        statusId
                        statusCategoryId
                    }
                    ... on PriorityField {
                        fieldKey
                        name
                        id
                        iconUrl
                    }
                    ... on UserField {
                        fieldKey
                        userValue {
                            displayName
                            avatarUrl
                            accountId
                        }
                    }
                    ... on JWMCategoryCustomField {
                        fieldKey
                        selectedValue {
                            optionId
                            value
                        }
                        category {
                            ...JwmCategoryOptionsFragment
                        }
                    }
                    ... on SelectCustomField {
                        fieldKey
                        selectedValue {
                          optionId
                          value
                        }
                    }
                    ... on FloatCustomField {
                        fieldKey
                        floatValue
                    }
                    ... on SprintCustomField {
                        fieldKey
                        title
                        values {
                            id
                            name
                            state
                        }
                    }
                }
                totalCount
            }
            pageInfo {
                hasNextPage
                endCursor
            }
        }
    }
    ${(0, $cNu0r.JWM_CATEGORY_OPTIONS_FRAGMENT)}
`;
const $ece5837ebbdf5681$export$1531880e8d0ec6bc = (0, $5cllN.default)`
    query JiraBusinessBackgroundListViewItemGroupsWithPagination ($jql: String!, $groupByFieldId: ID!, $fieldIds: [String]!, $first: Int, $last: Int, $before: String, $after: String) {
        backgroundGroups: jwmItemGroups(jql: $jql, groupByFieldId: $groupByFieldId, fieldIds: $fieldIds, first: $first, last: $last, before: $before, after: $after) @connection (key: "backgroundGroups", filter:["jql", "groupByFieldId"]) {
            totalCount
            nodes {
                id
                field {
                    __typename
                    ...on StatusField {
                        fieldKey
                        name
                        statusId
                        statusCategoryId
                    }
                    ... on PriorityField {
                        fieldKey
                        name
                        id
                        iconUrl
                    }
                    ... on UserField {
                        fieldKey
                        userValue {
                            displayName
                            avatarUrl
                            accountId
                        }
                    }
                    ... on JWMCategoryCustomField {
                        fieldKey
                        selectedValue {
                            optionId
                            value
                        }
                        category {
                            ...JwmCategoryOptionsFragment
                        }
                    }
                    ... on SelectCustomField {
                        fieldKey
                        selectedValue {
                          optionId
                          value
                        }
                    }
                    ... on FloatCustomField {
                        fieldKey
                        floatValue
                    }
                    ... on SprintCustomField {
                        fieldKey
                        title
                        values {
                            id
                            name
                            state
                        }
                    }
                }
                totalCount
            }
            pageInfo {
                hasNextPage
                endCursor
            }
        }
    }
    ${(0, $cNu0r.JWM_CATEGORY_OPTIONS_FRAGMENT)}
`;

});
parcelRegister("cNu0r", function(module, exports) {

$parcel$export(module.exports, "JWM_CATEGORY_OPTIONS_FRAGMENT", () => $1a2ec678845bd42b$export$61519670a3514192);

var $5cllN = parcelRequire("5cllN");
const $1a2ec678845bd42b$export$61519670a3514192 = (0, $5cllN.default)`
    fragment JwmCategoryOptionsFragment on JiraWorkManagementCategoryOption {
        id
        color
        option {
            id
            optionId
            value
            isDisabled
        }
    }
`;

});


parcelRegister("ktYkO", function(module, exports) {

$parcel$export(module.exports, "createGroupIssueId", () => $f28447dc530bd153$export$4ac2cce4af64b535);
$parcel$export(module.exports, "transformResult", () => $f28447dc530bd153$export$f13b29f9ed0c5a03);
$parcel$export(module.exports, "getGroupQuery", () => $f28447dc530bd153$export$399b257fbf191156);
$parcel$export(module.exports, "findItemGroup", () => $f28447dc530bd153$export$326ed4587250ed11);
$parcel$export(module.exports, "createItemGroup", () => $f28447dc530bd153$export$c8d5f559d504cbde);
/* eslint-disable camelcase */ 
var $7Jxgt = parcelRequire("7Jxgt");

var $42GbZ = parcelRequire("42GbZ");

var $hE5wF = parcelRequire("hE5wF");

var $57lFd = parcelRequire("57lFd");

var $deqCE = parcelRequire("deqCE");

var $jDUax = parcelRequire("jDUax");

var $4R6GH = parcelRequire("4R6GH");

var $dXq4S = parcelRequire("dXq4S");

var $4rfxU = parcelRequire("4rfxU");

var $2O65s = parcelRequire("2O65s");

var $5fc53 = parcelRequire("5fc53");
const $f28447dc530bd153$export$4ac2cce4af64b535 = (nodeId)=>`${0, $deqCE.GROUP_ITEM_PREFIX}_${nodeId}`;
const $f28447dc530bd153$export$eb0e89edd4882353 = (statusIdPath = '')=>{
    if (statusIdPath == null) return '';
    const splitStatusIdPath = statusIdPath.split('/');
    return splitStatusIdPath[splitStatusIdPath.length - 1];
};
const $f28447dc530bd153$var$getCategory = (field)=>{
    if (field && 'category' in field && field.category != null && field.category.option != null) return {
        fieldKey: field.fieldKey,
        name: field.category.option.value,
        optionId: field.category.option.optionId,
        color: field.category.color ?? null
    };
    return {};
};
const $f28447dc530bd153$var$getStoryPoints = (field)=>field?.__typename === 'FloatCustomField' && 'floatValue' in field ? field.floatValue : null;
const $f28447dc530bd153$var$getSprint = (field)=>{
    if (field && field.__typename === 'SprintCustomField' && field.values && field.values[0]) return {
        fieldKey: field.fieldKey,
        title: field.title,
        id: field.values[0].id,
        name: field.values[0].name,
        state: field.values[0].state
    };
    return null;
};
const $f28447dc530bd153$export$f13b29f9ed0c5a03 = (nodes)=>{
    if (!nodes) return [];
    return nodes.map((node)=>{
        const { id: id, field: field } = node || {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const values = {};
        if (field && 'fieldKey' in field && field.fieldKey != null) values[field.fieldKey] = field;
        const totalCount = node?.totalCount;
        const groupItem = {
            id: id,
            issueId: $f28447dc530bd153$export$4ac2cce4af64b535(id || ''),
            key: '',
            typeId: '',
            issuetype: {},
            rank: '',
            status: values.status ? {
                id: values.status.statusId,
                name: values.status.name,
                categoryId: values.status.statusCategoryId
            } : {},
            ...values.assignee ? values.assignee.userValue && {
                assignee: {
                    accountId: values.assignee.userValue.accountId,
                    displayName: values.assignee.userValue.displayName,
                    avatarUrl: values.assignee.userValue.avatarUrl
                }
            } : {},
            labels: values.labels && values.labels.labels || [],
            priority: values.priority ? {
                id: values.priority.id,
                name: values.priority.name,
                iconUrl: values.priority.iconUrl
            } : {},
            category: $f28447dc530bd153$var$getCategory(field),
            childSummary: {
                totalCount: totalCount,
                hasChildren: (totalCount ?? 0) > 0
            },
            storypoints: $f28447dc530bd153$var$getStoryPoints(field),
            storypointestimate: $f28447dc530bd153$var$getStoryPoints(field),
            sprint: $f28447dc530bd153$var$getSprint(field)
        };
        return groupItem;
    });
};
const $f28447dc530bd153$export$399b257fbf191156 = ({ groupIssueId: groupIssueId, groupByFieldId: groupByFieldId, groups: groups })=>{
    if (!groups || !groupByFieldId) return undefined;
    const groupItem = groups.find((group)=>group.issueId === groupIssueId);
    if (!groupItem) return undefined;
    if (groupByFieldId === (0, $5fc53.ASSIGNEE_TYPE)) return {
        jqlTerm: (0, $5fc53.ASSIGNEE_TYPE),
        value: groupItem.assignee?.accountId
    };
    if (groupByFieldId === (0, $5fc53.PRIORITY_TYPE)) {
        const priorityAri = groupItem?.priority?.id;
        let priorityId = priorityAri ? (0, $dXq4S.getAriConfig)(priorityAri).resourceId : undefined;
        if ((0, $4R6GH.fg)('migrate-deprecated-jira-platform-ari-fns')) priorityId = priorityAri && (0, $2O65s.JiraPriorityAri).check(priorityAri) ? (0, $2O65s.JiraPriorityAri).parse(priorityAri).priorityId : undefined;
        return {
            jqlTerm: (0, $5fc53.PRIORITY_TYPE),
            value: priorityId
        };
    }
    if (groupByFieldId === (0, $5fc53.STATUS_TYPE)) {
        const statusAri = groupItem?.status?.id;
        let statusId = statusAri ? (0, $dXq4S.getAriConfig)(statusAri).resourceId : undefined;
        if ((0, $4R6GH.fg)('migrate-deprecated-jira-platform-ari-fns')) statusId = statusAri && (0, $4rfxU.JiraIssueStatusAri).check(statusAri) ? (0, $4rfxU.JiraIssueStatusAri).parse(statusAri).issuestatusId : undefined;
        return {
            jqlTerm: (0, $5fc53.STATUS_TYPE),
            value: statusId
        };
    }
    if (groupByFieldId.startsWith('customfield_')) {
        const getValue = ()=>{
            if (groupItem.category) {
                const categoryName = groupItem.category?.name ?? undefined;
                if (categoryName) // wrap with quotes and escape quotes
                return `"${categoryName.replace(/"/g, '\\"')}"`;
            }
            if (typeof groupItem.storypoints === 'number') return groupItem.storypoints;
            if (typeof groupItem.storypointestimate === 'number') return groupItem.storypointestimate;
            if (groupItem.sprint) return groupItem.sprint && String(groupItem.sprint?.id) || undefined;
            return undefined;
        };
        return {
            jqlTerm: (0, $42GbZ.getJqlTerm)(groupByFieldId),
            value: getValue()
        };
    }
    return undefined;
};
const $f28447dc530bd153$export$326ed4587250ed11 = ({ item: item, groups: groups, groupByFieldId: groupByFieldId, isGroupingByCategory: isGroupingByCategory = false })=>{
    if (!groups || !groupByFieldId) return undefined;
    const field = (0, $57lFd.getFieldValue)(item.fields, groupByFieldId);
    // if item doesn't support category field but list is grouped by category, return the uncategorized group
    if (!field && isGroupingByCategory) return groups.find((group)=>!group.category?.name);
    return groups.find((group)=>{
        switch(field?.type){
            case 0, $5fc53.CATEGORY_TYPE:
                return String(group?.category?.optionId) === String((0, $57lFd.safeGetValue)(item.fields, groupByFieldId, 'fieldOption', undefined)?.optionId);
            case 0, $5fc53.ASSIGNEE_TYPE:
                return groupByFieldId && group.assignee?.accountId === (0, $57lFd.safeGetValue)(item.fields, groupByFieldId, 'user', undefined)?.accountId;
            case 0, $5fc53.STATUS_TYPE:
                return groupByFieldId && $f28447dc530bd153$export$eb0e89edd4882353(group.status?.id) === (0, $57lFd.safeGetValue)(item.fields, groupByFieldId, 'status.statusId', undefined);
            case 0, $5fc53.PRIORITY_TYPE:
                return groupByFieldId && group.priority?.name === (0, $57lFd.safeGetValue)(item.fields, groupByFieldId, 'priority.name', undefined);
            case 0, $5fc53.SPRINT_TYPE:
                return $f28447dc530bd153$var$getSprintGroup(item, group);
            case 0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE:
                return groupByFieldId && group.storypointestimate === (0, $57lFd.safeGetValue)(item.fields, groupByFieldId, 'number', undefined);
            case 0, $5fc53.NUMBER_CF_TYPE:
                if (field.aliasFieldId === (0, $hE5wF.STORY_POINTS_ALIAS_FIELD_ID)) return groupByFieldId && group.storypoints === (0, $57lFd.safeGetValue)(item.fields, groupByFieldId, 'number', undefined);
                return false;
            default:
                return false;
        }
    });
};
const $f28447dc530bd153$var$getSprintGroup = (item, group)=>{
    const sprintId = (0, $57lFd.safeGetValue)(item.fields, 'sprint', 'selectedSprintsConnection.edges[0].node.sprintId', undefined);
    if (!sprintId) return group.sprint === null;
    return group.sprint?.id === Number(sprintId);
};
const $f28447dc530bd153$export$c86575e2d4de1020 = ({ item: item, groupItemsQueryData: groupItemsQueryData })=>{
    if (!groupItemsQueryData) return undefined;
    const keys = Object.keys(groupItemsQueryData);
    // an issue can be in multiple groups due to hierarchy items appearing at all levels
    const matchingGroups = keys.filter((groupIssueId)=>// data could be undefined if is loading
        groupItemsQueryData[groupIssueId].data?.find((node)=>node.issueId === item.issueId));
    return matchingGroups.find((groupName)=>(0, $jDUax.isGroupItem)(groupName)) ?? matchingGroups[0];
};
// TODO: JFP-2824 | Suppressed to enable upgrade to ESLint v9 - please fix this if you can!
const $f28447dc530bd153$var$convertFieldToGroupItemField = (groupByFieldId, field)=>{
    if (groupByFieldId === (0, $5fc53.ASSIGNEE_TYPE) && field) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const userField = field;
        const convertedField = {
            fieldKey: groupByFieldId,
            userValue: {
                accountId: userField.user?.accountId ?? null,
                displayName: userField.user?.name ?? null,
                avatarUrl: userField.user?.picture,
                __typename: 'UserValue'
            },
            __typename: 'UserField'
        };
        return convertedField;
    }
    if (groupByFieldId === (0, $5fc53.PRIORITY_TYPE) && field) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const priorityField = field;
        const convertedField = {
            fieldKey: groupByFieldId,
            name: priorityField.priority?.name ?? null,
            id: priorityField.priority?.id ?? null,
            iconUrl: priorityField.priority?.iconUrl,
            __typename: 'PriorityField'
        };
        return convertedField;
    }
    if (groupByFieldId?.startsWith('customfield_') && field) {
        if (field.__typename === 'JiraSingleSelectField' && field.type === (0, $5fc53.CATEGORY_TYPE)) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const categoryField = field;
            if (categoryField.fieldOption) {
                const convertedField = {
                    category: {
                        color: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        categoryField.fieldOption?.color?.colorKey ?? null,
                        id: (0, $7Jxgt.v4)(),
                        option: {
                            id: (0, $7Jxgt.v4)(),
                            isDisabled: false,
                            optionId: categoryField.fieldOption.optionId,
                            value: categoryField.fieldOption.value,
                            __typename: 'JiraOption'
                        },
                        __typename: 'JiraWorkManagementCategoryOption'
                    },
                    selectedValue: {
                        optionId: categoryField.fieldOption.optionId,
                        value: categoryField.fieldOption.value ?? '',
                        __typename: 'Option'
                    },
                    fieldKey: field.fieldId,
                    __typename: 'JWMCategoryCustomField'
                };
                return convertedField;
            }
        }
        if (field.__typename === 'JiraNumberField') {
            const convertedField = {
                fieldKey: field.fieldId,
                floatValue: field.number,
                __typename: 'FloatCustomField'
            };
            return convertedField;
        }
    }
    return field;
};
const $f28447dc530bd153$export$c8d5f559d504cbde = ({ item: item, groupByFieldId: groupByFieldId })=>{
    if (!item || !groupByFieldId) return undefined;
    let field = (0, $57lFd.getFieldValue)(item.fields, groupByFieldId);
    if (!field) return;
    if (field && groupByFieldId) // TODO: Remove this part once JER-321 is done.
    field = $f28447dc530bd153$var$convertFieldToGroupItemField(groupByFieldId, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    field);
    return {
        id: (0, $7Jxgt.v4)(),
        field: field,
        totalCount: 1,
        __typename: 'JWMItemGroup'
    };
};

});
parcelRegister("4rfxU", function(module, exports) {

$parcel$export(module.exports, "JiraIssueStatusAri", () => $33b5be1df4583b87$export$12447ab6c7bdd0b0);

var $bnH8K = parcelRequire("bnH8K");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/jira/issue-status/manifest.ts
var $33b5be1df4583b87$var$jiraIssueStatusAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $bnH8K.JiraIssueStatusAriResourceOwner),
    resourceType: (0, $bnH8K.JiraIssueStatusAriResourceType),
    resourceIdSlug: "activation/{activationId}/{issuestatusId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        issuestatusId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/issue-status/index.ts
var $33b5be1df4583b87$export$12447ab6c7bdd0b0 = class _JiraIssueStatusAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._issuestatusId = opts.resourceIdSegmentValues.issuestatusId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get issuestatusId() {
        return this._issuestatusId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $33b5be1df4583b87$var$jiraIssueStatusAriStaticOpts.qualifier,
            platformQualifier: $33b5be1df4583b87$var$jiraIssueStatusAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $33b5be1df4583b87$var$jiraIssueStatusAriStaticOpts.resourceOwner,
            resourceType: $33b5be1df4583b87$var$jiraIssueStatusAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.issuestatusId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                issuestatusId: opts.issuestatusId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $33b5be1df4583b87$var$jiraIssueStatusAriStaticOpts);
        return new _JiraIssueStatusAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $33b5be1df4583b87$var$jiraIssueStatusAriStaticOpts);
        return new _JiraIssueStatusAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            issuestatusId: this.issuestatusId
        };
    }
};

});
parcelRegister("bnH8K", function(module, exports) {

$parcel$export(module.exports, "JiraIssueStatusAriResourceOwner", () => $84934e6f85101959$export$7ac9f54b32d39fd3);
$parcel$export(module.exports, "JiraIssueStatusAriResourceType", () => $84934e6f85101959$export$7f58026b0f198a18);
// src/jira/issue-status/types.ts
var $84934e6f85101959$export$7ac9f54b32d39fd3 = "jira", $84934e6f85101959$export$7f58026b0f198a18 = "issue-status";

});


parcelRegister("2O65s", function(module, exports) {

$parcel$export(module.exports, "JiraPriorityAri", () => $20b4f9052b3cf7d9$export$5f41709ebd395cb1);

var $7ZK4B = parcelRequire("7ZK4B");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/jira/priority/manifest.ts
var $20b4f9052b3cf7d9$var$jiraPriorityAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $7ZK4B.JiraPriorityAriResourceOwner),
    resourceType: (0, $7ZK4B.JiraPriorityAriResourceType),
    resourceIdSlug: "activation/{activationId}/{priorityId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        priorityId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/priority/index.ts
var $20b4f9052b3cf7d9$export$5f41709ebd395cb1 = class _JiraPriorityAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._priorityId = opts.resourceIdSegmentValues.priorityId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get priorityId() {
        return this._priorityId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $20b4f9052b3cf7d9$var$jiraPriorityAriStaticOpts.qualifier,
            platformQualifier: $20b4f9052b3cf7d9$var$jiraPriorityAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $20b4f9052b3cf7d9$var$jiraPriorityAriStaticOpts.resourceOwner,
            resourceType: $20b4f9052b3cf7d9$var$jiraPriorityAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.priorityId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                priorityId: opts.priorityId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $20b4f9052b3cf7d9$var$jiraPriorityAriStaticOpts);
        return new _JiraPriorityAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $20b4f9052b3cf7d9$var$jiraPriorityAriStaticOpts);
        return new _JiraPriorityAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            priorityId: this.priorityId
        };
    }
};

});
parcelRegister("7ZK4B", function(module, exports) {

$parcel$export(module.exports, "JiraPriorityAriResourceOwner", () => $5d21f81242417687$export$a154bdc743e3d7f4);
$parcel$export(module.exports, "JiraPriorityAriResourceType", () => $5d21f81242417687$export$f5f5f4d1fc71ee3e);
// src/jira/priority/types.ts
var $5d21f81242417687$export$a154bdc743e3d7f4 = "jira", $5d21f81242417687$export$f5f5f4d1fc71ee3e = "priority";

});





parcelRegister("igEI3", function(module, exports) {

$parcel$export(module.exports, "default", () => $c124b0de0e2a63f6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c124b0de0e2a63f6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorTitle: {
        "id": "business-list.controllers.with-grouping.error-title",
        "defaultMessage": "We couldn't load item groups."
    },
    errorMessage: {
        "id": "business-list.controllers.with-grouping.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    }
});

});

parcelRegister("4k0re", function(module, exports) {

$parcel$export(module.exports, "useGroupChildrenLoader", () => $65f2238f74c2c43e$export$2f8ce4dc0f882a8a);

var $5uXOq = parcelRequire("5uXOq");

var $jDUax = parcelRequire("jDUax");

var $8e3Yw = parcelRequire("8e3Yw");

var $gUe9l = parcelRequire("gUe9l");

var $9u99d = parcelRequire("9u99d");

var $8Ugqh = parcelRequire("8Ugqh");
const $65f2238f74c2c43e$export$2f8ce4dc0f882a8a = ({ groups: groups })=>{
    const [{ expandedItems: expandedItems }] = (0, $9u99d.useHierarchyStore)();
    const [groupByFieldId] = (0, $8e3Yw.useGroupBy)();
    const { setChildrenItems: setChildrenItems } = (0, $8Ugqh.useSetChildrenItems)();
    const childrenLoader = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gUe9l.GroupItemsController), {
            expandedGroupItemIssueIds: Object.keys(expandedItems).filter((0, $jDUax.isGroupItem)),
            groupByFieldId: groupByFieldId,
            onDataChange: setChildrenItems,
            groups: groups
        }), [
        expandedItems,
        groupByFieldId,
        groups,
        setChildrenItems
    ]);
    return {
        childrenLoader: childrenLoader
    };
};

});
parcelRegister("gUe9l", function(module, exports) {

$parcel$export(module.exports, "GroupItemsController", () => $566720f75a8bbd98$export$bf0c6c1ff455a90f);

var $5uXOq = parcelRequire("5uXOq");

var $ktYkO = parcelRequire("ktYkO");

var $8BlVu = parcelRequire("8BlVu");
const $566720f75a8bbd98$export$bf0c6c1ff455a90f = /*#__PURE__*/ (0, $5uXOq.memo)(({ expandedGroupItemIssueIds: expandedGroupItemIssueIds, groupByFieldId: groupByFieldId, groups: groups, onDataChange: onDataChange })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, expandedGroupItemIssueIds.map((expandedGroupItemIssueId)=>{
        const groupQuery = (0, $ktYkO.getGroupQuery)({
            groups: groups,
            groupIssueId: expandedGroupItemIssueId,
            groupByFieldId: groupByFieldId
        });
        if (!groupQuery) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8BlVu.GroupItemsQueryController), {
            groupIssueId: expandedGroupItemIssueId,
            onDataChange: onDataChange,
            key: expandedGroupItemIssueId,
            groupQuery: groupQuery
        });
    })), // Only re-render when expandedGroupItemIssueIds or onDataChange changes
(prevProps, nextProps)=>{
    const prevIssueIds = prevProps.expandedGroupItemIssueIds.sort();
    const nextIssueIds = nextProps.expandedGroupItemIssueIds.sort();
    return prevProps.onDataChange === nextProps.onDataChange && prevIssueIds.length === nextIssueIds.length && prevIssueIds.every((_, id)=>prevIssueIds[id] === nextIssueIds[id]);
});

});
parcelRegister("8BlVu", function(module, exports) {

$parcel$export(module.exports, "GroupItemsQueryController", () => $a5348e1835fae9e7$export$e689a28b990fb20b);

var $5uXOq = parcelRequire("5uXOq");

var $daQYX = parcelRequire("daQYX");

var $cm8b5 = parcelRequire("cm8b5");

var $kRkJF = parcelRequire("kRkJF");

var $jcw0u = parcelRequire("jcw0u");

var $8tf7c = parcelRequire("8tf7c");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $eTDjN = parcelRequire("eTDjN");

var $h7hV2 = parcelRequire("h7hV2");

var $8TUlY = parcelRequire("8TUlY");

var $mH57d = parcelRequire("mH57d");

var $39n00 = parcelRequire("39n00");
const $a5348e1835fae9e7$export$e689a28b990fb20b = /*#__PURE__*/ (0, $5uXOq.memo)(({ groupIssueId: groupIssueId, groupQuery: groupQuery, onDataChange: onDataChange })=>{
    const { hierarchyParent: hierarchyParent } = (0, $mH57d.useHierarchyConfig)();
    const { jqlContext: jqlContext, quickFiltersJql: quickFiltersJql, sorting: sorting, isHidingDoneItems: isHidingDoneItems, jqlErrors: jqlErrors } = (0, $kRkJF.useFilteredViewContextInput)({
        view: 'list'
    });
    const isValidFiltersJql = !jqlErrors.length;
    const projectData = (0, $daQYX.useProject)();
    const projectKey = projectData.key;
    const { getQueryFieldIds: getQueryFieldIds, loading: isLoadingFields, isParentFieldVisible: isParentFieldVisible, isDevSummaryFieldVisible: isDevSummaryFieldVisible } = (0, $8TUlY.useIssueFields)();
    const { data: data, loading: isLoadingItems, error: error, loadNextPage: loadNextPage, hasNextPage: hasNextPage, isLoadingNextPage: isLoadingNextPage } = (0, $h7hV2.useListViewIssues)({
        input: {
            jqlContext: jqlContext,
            fieldIds: getQueryFieldIds(),
            quickFiltersJql: quickFiltersJql,
            sorting: sorting,
            groupQuery: groupQuery,
            hierarchyParent: hierarchyParent,
            isHidingDoneItems: isHidingDoneItems,
            projectIdOrKey: projectKey,
            isParentFieldVisible: isParentFieldVisible(),
            isDevSummaryFieldVisible: isDevSummaryFieldVisible()
        },
        condition: isLoadingFields === false && isValidFiltersJql
    });
    const loading = !isValidFiltersJql ? false : isLoadingFields || isLoadingItems;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const totalIssues = data?.length;
    (0, $cm8b5.useQueryBasedViewAutomaticTracking)((0, $eTDjN.LOAD_GROUP_ITEMS_CHILDREN_EXPERIENCE), {
        loading: loading,
        error: error,
        shouldStartExperience: true
    });
    (0, $5uXOq.useEffect)(()=>{
        if (loading || typeof totalIssues !== 'number') return;
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'listGroupItemsQuery succeeded', {
            totalIssues: totalIssues
        });
    }, [
        loading,
        createAnalyticsEvent,
        totalIssues
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (error) (0, $jcw0u.default)({
            meta: {
                id: 'listGroupItemsQuery',
                packageName: 'jiraBusinessList',
                teamName: 'keystone'
            },
            attributes: {
                message: 'Failed to query group items in list view'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        error
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (jqlErrors.length) (0, $jcw0u.default)({
            meta: {
                id: 'listGroupItemsQuery',
                packageName: 'jiraBusinessList',
                teamName: 'keystone'
            },
            attributes: {
                message: 'Error in the JQL query'
            },
            error: jqlErrors[0],
            skipSentry: true
        });
    }, [
        jqlErrors
    ]);
    (0, $5uXOq.useEffect)(()=>{
        onDataChange(groupIssueId, {
            data: data,
            loading: loading,
            error: error,
            loadNextPage: loadNextPage,
            isLoadingNextPage: isLoadingNextPage,
            hasNextPage: hasNextPage
        });
    }, [
        data,
        error,
        loading,
        loadNextPage,
        isLoadingNextPage,
        onDataChange,
        groupIssueId,
        hasNextPage
    ]);
    return error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8tf7c.ErrorFlag), {
        error: error,
        title: (0, $39n00.default).errorTitle,
        description: (0, $39n00.default).errorMessage
    }) : null;
});

});
parcelRegister("mH57d", function(module, exports) {

$parcel$export(module.exports, "useHierarchyConfig", () => $a6cf1187f2a7220c$export$4691cc2dea373ff0);


var $kRkJF = parcelRequire("kRkJF");
const $a6cf1187f2a7220c$export$4691cc2dea373ff0 = ()=>{
    const { isFiltering: isFiltering } = (0, $kRkJF.useFilteredViewContextInput)({
        view: 'list'
    });
    const hierarchyParent = !isFiltering ? (0, $8debe7dace56daea$export$9355e489ad16f98e) : undefined;
    return {
        showFlatList: isFiltering,
        hierarchyParent: hierarchyParent
    };
};

});

parcelRegister("39n00", function(module, exports) {

$parcel$export(module.exports, "default", () => $3568df50bca07fe3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3568df50bca07fe3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorTitle: {
        "id": "business-list.controllers.group-items-query.error-title",
        "defaultMessage": "We couldn't load group items."
    },
    errorMessage: {
        "id": "business-list.controllers.group-items-query.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    }
});

});




parcelRegister("5mOA5", function(module, exports) {

$parcel$export(module.exports, "useResetItems", () => $b066ea047574cf0c$export$266465ecb6779ef7);

var $5uXOq = parcelRequire("5uXOq");

var $daQYX = parcelRequire("daQYX");

var $kRkJF = parcelRequire("kRkJF");

var $l4Ejo = parcelRequire("l4Ejo");

var $dpQnO = parcelRequire("dpQnO");

var $8e3Yw = parcelRequire("8e3Yw");

var $9u99d = parcelRequire("9u99d");
const $b066ea047574cf0c$export$266465ecb6779ef7 = ()=>{
    const { sorting: sorting } = (0, $kRkJF.useFilteredViewContextInput)({
        view: 'list'
    });
    const { jql: jql } = (0, $l4Ejo.useFilters)();
    const { quickFiltersJql: quickFiltersJql } = (0, $dpQnO.useQuickFilters)();
    const [groupByFieldId] = (0, $8e3Yw.useGroupBy)();
    const [{ hierarchyData: { loading: loading } }, { resetCache: resetCache, clearHierarchyData: clearHierarchyData }] = (0, $9u99d.useHierarchyStore)();
    const projectData = (0, $daQYX.useProject)();
    const projectKey = projectData.key;
    const lastSorting = (0, $5uXOq.useRef)({
        ...sorting
    });
    const lastJqlFiltering = (0, $5uXOq.useRef)(jql);
    const lastQuickFilterJql = (0, $5uXOq.useRef)(quickFiltersJql);
    const lastGroupByFieldId = (0, $5uXOq.useRef)(groupByFieldId);
    (0, $5uXOq.useEffect)(()=>{
        if (loading) return;
        const hasSortingChanged = lastSorting.current.sortBy !== sorting.sortBy || lastSorting.current.direction !== sorting.direction;
        const hasFilteringChanged = lastJqlFiltering.current !== jql || lastQuickFilterJql.current !== quickFiltersJql;
        const hasGroupByFieldIdChanged = lastGroupByFieldId.current !== groupByFieldId;
        if (hasGroupByFieldIdChanged || hasSortingChanged || hasFilteringChanged) {
            resetCache();
            // update last reference
            lastSorting.current = sorting;
            lastJqlFiltering.current = jql;
            lastQuickFilterJql.current = quickFiltersJql;
            lastGroupByFieldId.current = groupByFieldId;
        }
    }, [
        groupByFieldId,
        loading,
        sorting,
        resetCache,
        jql,
        quickFiltersJql
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // Reset hierarchy data when navigate across projects
        clearHierarchyData();
    }, [
        projectKey,
        clearHierarchyData
    ]);
};

});

parcelRegister("1Qz1F", function(module, exports) {

$parcel$export(module.exports, "useSetHierarchyData", () => $261cbc59f08097d5$export$b96814cd86fd4960);

var $5uXOq = parcelRequire("5uXOq");

var $8TUlY = parcelRequire("8TUlY");

var $acMuh = parcelRequire("acMuh");

var $mH57d = parcelRequire("mH57d");

var $9u99d = parcelRequire("9u99d");
const $261cbc59f08097d5$export$b96814cd86fd4960 = ()=>{
    const [, { setHierarchyData: setHierarchyData, refreshHierarchy: refreshHierarchy }] = (0, $9u99d.useHierarchyStore)();
    const [rowCreateState, { setRowCreatePosition: setRowCreatePosition }] = (0, $acMuh.useRowCreateStore)();
    const { hierarchyLevelsWithCache: hierarchyLevelsWithCache } = (0, $8TUlY.useIssueFields)();
    const { showFlatList: showFlatList } = (0, $mH57d.useHierarchyConfig)();
    (0, $5uXOq.useEffect)(()=>{
        refreshHierarchy(rowCreateState, setRowCreatePosition, hierarchyLevelsWithCache);
    }, [
        rowCreateState,
        setRowCreatePosition,
        hierarchyLevelsWithCache,
        refreshHierarchy
    ]);
    const setHierarchyDataWithDependencies = (0, $5uXOq.useCallback)((queryData)=>setHierarchyData(queryData, rowCreateState, setRowCreatePosition, hierarchyLevelsWithCache, showFlatList), [
        setHierarchyData,
        rowCreateState,
        setRowCreatePosition,
        hierarchyLevelsWithCache,
        showFlatList
    ]);
    return {
        setHierarchyData: setHierarchyDataWithDependencies
    };
};

});

parcelRegister("2lh30", function(module, exports) {

$parcel$export(module.exports, "useListViewRefreshCacheActions", () => $d1cc003d7a3b6a65$export$30c401359fbae99f);
$parcel$export(module.exports, "useListViewRefreshCacheStore", () => $d1cc003d7a3b6a65$export$411620cf912de4ea);
/* eslint-disable jira/filename-case */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $3sQ5x = parcelRequire("3sQ5x");
const $d1cc003d7a3b6a65$var$actions = {
    triggerListViewCacheRefresh: ()=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                shouldTriggerCacheRefresh: true
            });
        },
    triggerListViewGroupByCacheRefresh: ()=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                shouldTriggerGroupByCacheRefresh: true
            });
        },
    triggerWorkflowCacheRefresh: ()=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                shouldTriggerWorkflowCacheRefresh: true
            });
        },
    resetRefreshCacheTrigger: ()=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                shouldTriggerCacheRefresh: false
            });
        },
    resetListViewGroupByRefreshCacheTrigger: ()=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                shouldTriggerGroupByCacheRefresh: false
            });
        },
    resetWorkflowCacheRefreshTrigger: ()=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                shouldTriggerWorkflowCacheRefresh: false
            });
        }
};
const $d1cc003d7a3b6a65$var$ListViewTriggerCacheRefreshStore = (0, $iXqE5.createStore)({
    initialState: {
        shouldTriggerCacheRefresh: false,
        shouldTriggerGroupByCacheRefresh: false,
        shouldTriggerWorkflowCacheRefresh: false
    },
    actions: $d1cc003d7a3b6a65$var$actions,
    name: 'list-view-trigger-cache-refresh-store'
});
const $d1cc003d7a3b6a65$export$30c401359fbae99f = (0, $3sQ5x.createActionsHook)($d1cc003d7a3b6a65$var$ListViewTriggerCacheRefreshStore);
const $d1cc003d7a3b6a65$export$411620cf912de4ea = (0, $3sQ5x.createSelectorHook)($d1cc003d7a3b6a65$var$ListViewTriggerCacheRefreshStore);

});


parcelRegister("aKtkc", function(module, exports) {

$parcel$export(module.exports, "default", () => $937e553ba1f63081$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $daQYX = parcelRequire("daQYX");

var $cm8b5 = parcelRequire("cm8b5");

var $kRkJF = parcelRequire("kRkJF");

var $jcw0u = parcelRequire("jcw0u");

var $8tf7c = parcelRequire("8tf7c");

var $1XJ20 = parcelRequire("1XJ20");

var $eTDjN = parcelRequire("eTDjN");

var $h7hV2 = parcelRequire("h7hV2");

var $tx8ST = parcelRequire("tx8ST");

var $8TUlY = parcelRequire("8TUlY");

var $mH57d = parcelRequire("mH57d");

var $9u99d = parcelRequire("9u99d");

var $5mOA5 = parcelRequire("5mOA5");

var $1Qz1F = parcelRequire("1Qz1F");

var $4AG94 = parcelRequire("4AG94");
const $937e553ba1f63081$export$9e1fb4c88b271603 = ()=>{
    const [{ hierarchyLevel: hierarchyLevel }, { resetHierarchyLevel: resetHierarchyLevel, setHierarchyLevel: setHierarchyLevel }] = (0, $tx8ST.useHierarchyLevel)();
    const { jqlContext: jqlContext, quickFiltersJql: quickFiltersJql, sorting: sorting, isHidingDoneItems: isHidingDoneItems, jqlErrors: jqlErrors } = (0, $kRkJF.useFilteredViewContextInput)({
        view: 'list'
    });
    const { showFlatList: showFlatList, hierarchyParent: hierarchyParent } = (0, $mH57d.useHierarchyConfig)();
    const prevShowFlatList = (0, $1XJ20.usePreviousWithInitial)(showFlatList);
    const { hierarchyLevelsWithCache: hierarchyLevelsWithCache, getQueryFieldIds: getQueryFieldIds, isParentFieldVisible: isParentFieldVisible, isDevSummaryFieldVisible: isDevSummaryFieldVisible } = (0, $8TUlY.useIssueFields)();
    const queryFieldIds = getQueryFieldIds();
    const isValidFiltersJql = !jqlErrors.length;
    const projectData = (0, $daQYX.useProject)();
    const projectKey = projectData.key;
    // fetch issues based on `hierarchyLevel` - regardless of issue types
    const items = (0, $h7hV2.useListViewIssues)({
        input: {
            jqlContext: jqlContext,
            quickFiltersJql: quickFiltersJql,
            fieldIds: queryFieldIds,
            sorting: sorting,
            hierarchyLevel: hierarchyLevel,
            hierarchyParent: hierarchyParent,
            isHidingDoneItems: isHidingDoneItems,
            projectIdOrKey: projectKey,
            isParentFieldVisible: isParentFieldVisible(),
            isDevSummaryFieldVisible: isDevSummaryFieldVisible()
        },
        condition: typeof hierarchyLevel === 'number' && queryFieldIds.length > 0 && isValidFiltersJql
    });
    (0, $5uXOq.useEffect)(()=>{
        if (hierarchyLevel == null && hierarchyLevelsWithCache.length) setHierarchyLevel(hierarchyLevelsWithCache[0].level);
    }, [
        hierarchyLevel,
        hierarchyLevelsWithCache,
        setHierarchyLevel
    ]);
    // reset hierarchyLevel to the top level when filtering change
    (0, $5uXOq.useEffect)(()=>{
        if (hierarchyLevelsWithCache.length && prevShowFlatList && !showFlatList) setHierarchyLevel(hierarchyLevelsWithCache[0].level);
    }, [
        showFlatList,
        prevShowFlatList,
        setHierarchyLevel,
        hierarchyLevelsWithCache
    ]);
    // reset hierarchyLevel on unmount
    (0, $5uXOq.useEffect)(()=>()=>resetHierarchyLevel(), []); // eslint-disable-line react-hooks/exhaustive-deps
    const levels = (0, $5uXOq.useMemo)(()=>[
            ...new Set(hierarchyLevelsWithCache.map((x)=>x.level))
        ], [
        hierarchyLevelsWithCache
    ]);
    // When BE service returns empty response from top level items query
    // We take next hierarchy level and re-fetch items... until BE returs some data, or we reach the bottom hierarchy level
    (0, $5uXOq.useEffect)(()=>{
        if (!items.loading && !items.data.length && hierarchyLevel != null) {
            const nextIndex = levels.indexOf(hierarchyLevel) + 1;
            if (typeof levels[nextIndex] === 'number') setHierarchyLevel(levels[nextIndex]);
        }
    }, [
        hierarchyLevel,
        levels,
        items.data.length,
        items.loading,
        setHierarchyLevel
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (jqlErrors.length) (0, $jcw0u.default)({
            meta: {
                id: 'listHierarchyLoader',
                packageName: 'jiraBusinessList',
                teamName: 'keystone'
            },
            attributes: {
                message: 'Error in the JQL query'
            },
            error: jqlErrors[0],
            skipSentry: true
        });
    }, [
        jqlErrors
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            ...items,
            loading: isValidFiltersJql ? items.loading : false
        }), [
        items,
        isValidFiltersJql
    ]);
};
const $937e553ba1f63081$var$HierarchyLoader = ()=>{
    const items = $937e553ba1f63081$export$9e1fb4c88b271603();
    const prevItems = (0, $1XJ20.usePreviousWithInitial)(items);
    const [, { resetCache: resetCache }] = (0, $9u99d.useHierarchyStore)();
    const { setHierarchyData: setHierarchyData } = (0, $1Qz1F.useSetHierarchyData)();
    (0, $cm8b5.useQueryBasedViewAutomaticTracking)((0, $eTDjN.VIEW_EXPERIENCE), {
        loading: items.loading,
        error: items.error
    });
    // resets expanded items and queryData cache when filtering/sorting/groupBy is updated
    (0, $5mOA5.useResetItems)();
    // initialize items when switching between grouping -> hierarchy
    (0, $5uXOq.useEffect)(()=>{
        setHierarchyData(items);
        resetCache();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // updates hierarchy items in store only when "data", "isLoadingNextPage" or "totalCount" changes
    (0, $5uXOq.useEffect)(()=>{
        if (prevItems.data !== items.data || prevItems.isLoadingNextPage !== items.isLoadingNextPage) setHierarchyData(items);
    }, [
        items,
        prevItems,
        setHierarchyData
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, items.error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8tf7c.ErrorFlag), {
        error: items.error,
        title: (0, $4AG94.default).errorTitle,
        description: (0, $4AG94.default).errorMessage
    }));
};
var // eslint-disable-next-line @typescript-eslint/no-explicit-any
$937e553ba1f63081$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($937e553ba1f63081$var$HierarchyLoader);

});
parcelRegister("tx8ST", function(module, exports) {

$parcel$export(module.exports, "useHierarchyLevel", () => $2beebbfe8785f523$export$62fdc6b7b35d2861);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $2beebbfe8785f523$var$initialState = {
    hierarchyLevel: undefined
};
const $2beebbfe8785f523$var$resetHierarchyLevel = ()=>({ setState: setState })=>setState({
            ...$2beebbfe8785f523$var$initialState
        });
const $2beebbfe8785f523$var$setHierarchyLevel = (hierarchyLevel)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            hierarchyLevel: hierarchyLevel
        });
    };
const $2beebbfe8785f523$var$actions = {
    resetHierarchyLevel: $2beebbfe8785f523$var$resetHierarchyLevel,
    setHierarchyLevel: $2beebbfe8785f523$var$setHierarchyLevel
};
const $2beebbfe8785f523$var$Store = (0, $iXqE5.createStore)({
    initialState: $2beebbfe8785f523$var$initialState,
    actions: $2beebbfe8785f523$var$actions,
    name: 'JWMHierarchyLevelStore'
});
const $2beebbfe8785f523$export$62fdc6b7b35d2861 = (0, $3sQ5x.createHook)($2beebbfe8785f523$var$Store);

});

parcelRegister("4AG94", function(module, exports) {

$parcel$export(module.exports, "default", () => $a83dfa9276871092$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a83dfa9276871092$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorTitle: {
        "id": "business-list.controllers.hierarchy.hierarchy-loader.error-title",
        "defaultMessage": "We couldn't load items."
    },
    errorMessage: {
        "id": "business-list.controllers.hierarchy.hierarchy-loader.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    }
});

});



parcelRegister("g7iDt", function(module, exports) {

$parcel$export(module.exports, "useIssueChangeUpdater", () => $6303542b071cd29b$export$55b903604085ad27);

var $5uXOq = parcelRequire("5uXOq");

var $FTaAj = parcelRequire("FTaAj");

var $aMwM1 = parcelRequire("aMwM1");
const $6303542b071cd29b$export$55b903604085ad27 = ()=>{
    const { onIssueRemoved: onIssueRemoved } = (0, $aMwM1.useListViewUpdaterService)();
    const onIssueChange = (0, $5uXOq.useCallback)((event)=>{
        if (event.type === (0, $FTaAj.ChangeEventTypes).ISSUE_RELATIONSHIP_UPDATED) {
            const { issueId: issueId, meta: { oldParentIssueId: oldParentIssueId } } = event;
            onIssueRemoved({
                issueId: Number(issueId),
                parentId: oldParentIssueId || undefined
            });
        }
    }, [
        onIssueRemoved
    ]);
    return {
        onIssueChange: onIssueChange
    };
};

});
parcelRegister("FTaAj", function(module, exports) {

$parcel$export(module.exports, "ChangeEventTypes", () => $0a7f3a2a8450d0c8$export$8db21fc94823e1cc);
const $0a7f3a2a8450d0c8$var$FIELD_CHANGE_REQUESTED = 'FIELD_CHANGE_REQUESTED';
const $0a7f3a2a8450d0c8$var$FIELD_CHANGED = 'FIELD_CHANGED';
const $0a7f3a2a8450d0c8$var$FIELD_CHANGE_FAILED = 'FIELD_CHANGE_FAILED';
const $0a7f3a2a8450d0c8$var$ISSUE_TYPE_CHANGED = 'ISSUE_TYPE_CHANGED';
const $0a7f3a2a8450d0c8$var$ISSUE_RELATIONSHIP_UPDATED = 'ISSUE_RELATIONSHIP_UPDATED';
const $0a7f3a2a8450d0c8$var$ISSUE_LINKS_CREATED = 'ISSUE_LINKS_CREATED';
const $0a7f3a2a8450d0c8$var$ISSUE_LINK_DELETED = 'ISSUE_LINK_DELETED';
const $0a7f3a2a8450d0c8$var$CHILD_ISSUE_ADDED = 'CHILD_ISSUE_ADDED';
const $0a7f3a2a8450d0c8$var$SUBTASK_ADDED = 'SUBTASK_ADDED';
const $0a7f3a2a8450d0c8$var$ISSUE_CHILDREN_ORDER_CHANGED = 'ISSUE_CHILDREN_ORDER_CHANGED';
const $0a7f3a2a8450d0c8$var$CHILD_ISSUE_FIELD_UPDATED = 'CHILD_ISSUE_FIELD_UPDATED';
const $0a7f3a2a8450d0c8$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS = 'CREATE_CONFLUENCE_PAGE_LINK_SUCCESS';
const $0a7f3a2a8450d0c8$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS = 'DELETE_CONFLUENCE_PAGE_LINK_SUCCESS';
const $0a7f3a2a8450d0c8$export$8db21fc94823e1cc = {
    [$0a7f3a2a8450d0c8$var$FIELD_CHANGE_REQUESTED]: $0a7f3a2a8450d0c8$var$FIELD_CHANGE_REQUESTED,
    [$0a7f3a2a8450d0c8$var$FIELD_CHANGE_FAILED]: $0a7f3a2a8450d0c8$var$FIELD_CHANGE_FAILED,
    [$0a7f3a2a8450d0c8$var$FIELD_CHANGED]: $0a7f3a2a8450d0c8$var$FIELD_CHANGED,
    [$0a7f3a2a8450d0c8$var$ISSUE_TYPE_CHANGED]: $0a7f3a2a8450d0c8$var$ISSUE_TYPE_CHANGED,
    [$0a7f3a2a8450d0c8$var$ISSUE_RELATIONSHIP_UPDATED]: $0a7f3a2a8450d0c8$var$ISSUE_RELATIONSHIP_UPDATED,
    [$0a7f3a2a8450d0c8$var$ISSUE_LINKS_CREATED]: $0a7f3a2a8450d0c8$var$ISSUE_LINKS_CREATED,
    [$0a7f3a2a8450d0c8$var$ISSUE_LINK_DELETED]: $0a7f3a2a8450d0c8$var$ISSUE_LINK_DELETED,
    [$0a7f3a2a8450d0c8$var$CHILD_ISSUE_ADDED]: $0a7f3a2a8450d0c8$var$CHILD_ISSUE_ADDED,
    [$0a7f3a2a8450d0c8$var$SUBTASK_ADDED]: $0a7f3a2a8450d0c8$var$SUBTASK_ADDED,
    [$0a7f3a2a8450d0c8$var$ISSUE_CHILDREN_ORDER_CHANGED]: $0a7f3a2a8450d0c8$var$ISSUE_CHILDREN_ORDER_CHANGED,
    [$0a7f3a2a8450d0c8$var$CHILD_ISSUE_FIELD_UPDATED]: $0a7f3a2a8450d0c8$var$CHILD_ISSUE_FIELD_UPDATED,
    [$0a7f3a2a8450d0c8$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS]: $0a7f3a2a8450d0c8$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS,
    [$0a7f3a2a8450d0c8$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS]: $0a7f3a2a8450d0c8$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS
};

});

parcelRegister("aMwM1", function(module, exports) {

$parcel$export(module.exports, "useListViewUpdaterService", () => $1d9f6e41892ada2f$export$8fe666044644d3c0);

var $5tTFS = parcelRequire("5tTFS");

var $egmQO = parcelRequire("egmQO");

var $daQYX = parcelRequire("daQYX");

var $kRkJF = parcelRequire("kRkJF");

var $jDUax = parcelRequire("jDUax");

var $hlKA4 = parcelRequire("hlKA4");

var $9SwwX = parcelRequire("9SwwX");

var $dCjtG = parcelRequire("dCjtG");

var $gwNxS = parcelRequire("gwNxS");

var $jcw0u = parcelRequire("jcw0u");

var $5fc53 = parcelRequire("5fc53");

var $g5X3G = parcelRequire("g5X3G");

var $koeKL = parcelRequire("koeKL");

var $ktYkO = parcelRequire("ktYkO");

var $61h55 = parcelRequire("61h55");

var $bsMMx = parcelRequire("bsMMx");

var $tx8ST = parcelRequire("tx8ST");

var $mk7k0 = parcelRequire("mk7k0");

var $8e3Yw = parcelRequire("8e3Yw");

var $3xYz2 = parcelRequire("3xYz2");

var $mH57d = parcelRequire("mH57d");

var $9u99d = parcelRequire("9u99d");

var $dvriG = parcelRequire("dvriG");
const $1d9f6e41892ada2f$export$8fe666044644d3c0 = ()=>{
    const [{ selectedIssues: selectedIssues, showDeleteModal: showDeleteModal }, { toggleShowDeleteModal: toggleShowDeleteModal, unselectIssues: unselectIssues }] = (0, $mk7k0.useBulkSelectionStore)();
    const [{ hierarchyLevel: hierarchyLevel }] = (0, $tx8ST.useHierarchyLevel)();
    const { jqlContext: jqlContext, quickFiltersJql: quickFiltersJql, sorting: sorting, isHidingDoneItems: isHidingDoneItems } = (0, $kRkJF.useFilteredViewContextInput)({
        view: 'list'
    });
    const fieldIds = (0, $dvriG.useSupportedFieldIds)();
    const { hierarchyParent: hierarchyParent } = (0, $mH57d.useHierarchyConfig)();
    const { addToCache: addToCache, removeFromCache: removeFromCache, updateItemsInCache: updateItemsInCache } = (0, $hlKA4.useCacheActions)();
    const [{ issueParentMap: issueParentMap, issuesMap: issuesMap, childrenItems: childrenQueryData, hierarchyData: hierarchyData }] = (0, $9u99d.useHierarchyStore)();
    const projectData = (0, $daQYX.useProject)();
    const projectKey = projectData.key;
    const groups = hierarchyData.data;
    const [groupByFieldId] = (0, $8e3Yw.useGroupBy)();
    const isGroupingByStatus = groupByFieldId === (0, $5fc53.STATUS_TYPE);
    const cloudId = (0, $koeKL.useCloudId)();
    const topLevelVariables = {
        ...(0, $egmQO.getVariables)({
            jqlContext: jqlContext,
            fieldIds: fieldIds,
            quickFiltersJql: quickFiltersJql,
            sorting: sorting,
            hierarchyLevel: hierarchyLevel,
            hierarchyParent: hierarchyParent,
            isHidingDoneItems: isHidingDoneItems,
            projectIdOrKey: projectKey
        }),
        cloudId: cloudId
    };
    const { addToCacheCallback: addToCacheCallback, removeFromCacheCallback: removeFromCacheCallback } = (0, $gwNxS.createViewUpdaterCallbacksWithCacheActions)({
        query: (0, $61h55.LIST_VIEW_QUERY),
        addToCache: addToCache,
        updateItemsInCache: updateItemsInCache,
        removeFromCache: removeFromCache,
        isHierarchyEnabled: ()=>typeof hierarchyParent !== 'undefined',
        isInfiniteHierarchyEnabled: ()=>typeof hierarchyParent !== 'undefined',
        createVariablesForItemWithoutParent: ()=>topLevelVariables,
        createVariablesForGroupItem: (groupIssueId)=>({
                cloudId: cloudId,
                ...(0, $egmQO.getVariables)({
                    jqlContext: jqlContext,
                    fieldIds: fieldIds,
                    quickFiltersJql: quickFiltersJql,
                    sorting: sorting,
                    groupQuery: (0, $ktYkO.getGroupQuery)({
                        groups: groups,
                        groupIssueId: groupIssueId,
                        groupByFieldId: groupByFieldId
                    }),
                    hierarchyParent: hierarchyParent,
                    isHidingDoneItems: isHidingDoneItems
                })
            }),
        createVariablesForItemWithParent: (parentIssueId)=>{
            if (!hierarchyParent) // this scenario should be impossible because there is isHierarchyEnabled parameter above
            return topLevelVariables;
            return {
                ...(0, $egmQO.getVariables)({
                    jqlContext: jqlContext,
                    fieldIds: fieldIds,
                    quickFiltersJql: quickFiltersJql,
                    sorting: sorting,
                    isHidingDoneItems: isHidingDoneItems,
                    hierarchyParent: undefined,
                    projectIdOrKey: projectKey,
                    parentIssue: {
                        hierarchyType: hierarchyParent,
                        issueId: parentIssueId
                    }
                }),
                cloudId: cloudId
            };
        },
        // We only want to add or remove item if the existing query for children-of-this-parent exists
        // this is to prevent apollo error where the cache key is missing
        shouldChildItemBeAddedToOrRemovedFromCache: (parentIssueId)=>Boolean(childrenQueryData && childrenQueryData[(0, $g5X3G.toIssueId)(parentIssueId)] !== undefined),
        getParentOfIssueIfExist: (issueId)=>{
            const maybeIssue = issuesMap.get(issueId);
            if (!maybeIssue) return undefined;
            return maybeIssue.parentIssueId ?? (0, $jDUax.getParentIssueId)(maybeIssue);
        },
        getPrevParentOfIssueIfExists: (issueId)=>issueParentMap.get(String(issueId)),
        onUpdateParentWithNewChild: (0, $bsMMx.addChildToParentListView),
        // note that prevParent will be undefined if the prevParent is not expanded or does not exist
        updateIssueParentMap: (issueId, newParentId)=>{
            if (newParentId) issueParentMap.set(String(issueId), String(newParentId));
            else issueParentMap.delete(String(issueId));
        },
        removeChildFromParent: (0, $bsMMx.removeChildFromParentListView),
        isGroupingByStatus: isGroupingByStatus,
        isGrouping: !!groupByFieldId
    });
    const isGrouping = groupByFieldId != null;
    const { addToGroupCache: addToGroupCache, removeFromGroupCache: removeFromGroupCache } = (0, $3xYz2.useGroupCacheActions)({
        fieldIds: fieldIds
    });
    // When we detect an item has been updated that is currently filtered out of view, we still want to update group totals
    // so we do another request with no filters and update group cache's total count only
    const [getUpdatedIssue] = (0, $5tTFS.useLazyQuery)((0, $61h55.LIST_VIEW_ITEM_DETAILS_QUERY), {
        fetchPolicy: 'network-only',
        onError: (apolloError)=>{
            (0, $jcw0u.default)({
                meta: {
                    id: 'listViewUpdaterQuery',
                    packageName: 'jiraBusinessList',
                    teamName: 'keystone'
                },
                attributes: {
                    message: 'Failed to fetch updated issue by id in list view updater'
                },
                error: apolloError,
                sendToPrivacyUnsafeSplunk: true
            });
        },
        onCompleted: (result)=>{
            const items = (0, $9SwwX.getAGGCompliantData)(result, 'list');
            const validNodes = items?.edges?.map((edge)=>edge?.node).filter(Boolean);
            if (validNodes && validNodes.length > 0) addToGroupCache(validNodes, {
                updateCountOnly: true
            });
        }
    });
    const handleFilteredUpdate = (issueIds)=>{
        getUpdatedIssue({
            variables: {
                ...(0, $egmQO.getVariables)({
                    issueIds: issueIds,
                    fieldIds: fieldIds
                }),
                cloudId: cloudId
            }
        });
    };
    const getGroupChildItems = (items)=>{
        const groupChildItems = [];
        const nestedItems = [];
        items.forEach((item)=>{
            const parentIssueId = (0, $jDUax.getParentIssueId)(item);
            // we only want to move items between groups via realtime update if the item is a direct child of a group item
            // that is when it doesn't have a parent field, or its parent is a group item,
            if (parentIssueId != null && !(0, $jDUax.isGroupItem)(parentIssueId) && childrenQueryData && childrenQueryData[parentIssueId]) nestedItems.push(item);
            else groupChildItems.push(item);
        });
        return {
            groupChildItems: groupChildItems,
            nestedItems: nestedItems
        };
    };
    return (0, $dCjtG.useViewUpdater)({
        input: {
            projectKey: projectKey,
            fieldIds: fieldIds,
            quickFiltersJql: quickFiltersJql,
            isHidingDoneItems: isHidingDoneItems
        },
        query: (0, $61h55.LIST_VIEW_ITEM_DETAILS_QUERY),
        actions: [
            {
                addToCache: (items)=>{
                    if (isGrouping) {
                        const { groupChildItems: groupChildItems, nestedItems: nestedItems } = getGroupChildItems(items);
                        if (groupChildItems.length) return addToGroupCache(groupChildItems);
                        if (nestedItems.length) return addToCacheCallback(items);
                    }
                    return addToCacheCallback(items);
                },
                removeFromCache: (items)=>{
                    if (selectedIssues?.size) {
                        let issuesToUnselect = [];
                        items.forEach(({ issueId: issueId })=>{
                            if (selectedIssues.has(String(issueId))) issuesToUnselect = [
                                ...issuesToUnselect,
                                String(issueId)
                            ];
                        });
                        if (issuesToUnselect.length) {
                            unselectIssues({
                                issues: issuesToUnselect
                            });
                            if (issuesToUnselect.length === selectedIssues.size && showDeleteModal) toggleShowDeleteModal({
                                showDeleteModal: false
                            });
                        }
                    }
                    if (isGrouping) {
                        const { groupChildItems: groupChildItems, nestedItems: nestedItems } = getGroupChildItems(items);
                        if (groupChildItems.length) return removeFromGroupCache(groupChildItems);
                        if (nestedItems.length) return removeFromCacheCallback(items);
                    }
                    return removeFromCacheCallback(items);
                },
                handleFilteredUpdate: (issueIds)=>isGrouping ? handleFilteredUpdate(issueIds) : undefined
            }
        ],
        onError: (apolloError)=>{
            (0, $jcw0u.default)({
                meta: {
                    id: 'listViewUpdaterQuery',
                    packageName: 'jiraBusinessList',
                    teamName: 'keystone'
                },
                attributes: {
                    message: 'Failed to fetch issues in list view updater'
                },
                error: apolloError,
                sendToPrivacyUnsafeSplunk: true
            });
        },
        onAppendItemsError: (apolloError)=>{
            (0, $jcw0u.default)({
                meta: {
                    id: 'listViewAppendItemsQuery',
                    packageName: 'jiraBusinessList',
                    teamName: 'keystone'
                },
                attributes: {
                    message: 'Failed to append issues by id in list view updater'
                },
                error: apolloError,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    });
};

});
parcelRegister("hlKA4", function(module, exports) {

$parcel$export(module.exports, "useCacheActions", () => $f61770b894122deb$export$f79bd85e41a6298f);

var $5uXOq = parcelRequire("5uXOq");

var $9XE6b = parcelRequire("9XE6b");

var $5tTFS = parcelRequire("5tTFS");

var $hE5wF = parcelRequire("hE5wF");

var $57lFd = parcelRequire("57lFd");

var $jcw0u = parcelRequire("jcw0u");

var $3fAi8 = parcelRequire("3fAi8");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $g5X3G = parcelRequire("g5X3G");

var $ieDtd = parcelRequire("ieDtd");

var $deqCE = parcelRequire("deqCE");

var $jDUax = parcelRequire("jDUax");

var $9SwwX = parcelRequire("9SwwX");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $f61770b894122deb$var$getIssueKey = (fields)=>(0, $57lFd.safeGetValue)(fields, 'issuekey', 'text', '');
const $f61770b894122deb$var$getIndexById = (listData, issueId)=>{
    if (listData == null || listData.edges == null) return -1;
    const { edges: edges } = listData;
    return edges.findIndex((edge)=>edge != null && edge.node != null && edge.node.issueId != null && edge.node.issueId === issueId);
};
const $f61770b894122deb$export$f79bd85e41a6298f = ()=>{
    const analyticsTaskName = 'useCacheActionsApolloCacheActions';
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const client = (0, $5tTFS.useApolloClient)();
    const [, extractedFieldValueActions] = (0, $3fAi8.useFieldsValuesActions)();
    const [currentIssueKey] = (0, $ieDtd.useQueryParam)((0, $hE5wF.SELECTED_ISSUE_PARAM));
    const removeIssueFromExtractedFieldsCache = (0, $5uXOq.useCallback)(({ currentIssueId: currentIssueId, issueKey: issueKey, parentIssueId: parentIssueId })=>{
        issueKey != null && // do not clean the cache if the issue is currently visible in bento (that would show blank fields)
        issueKey !== currentIssueKey && `${parentIssueId}` !== `${currentIssueId}` && extractedFieldValueActions.setIssue((0, $g5X3G.toIssueKey)(issueKey), {});
    }, [
        currentIssueKey,
        extractedFieldValueActions
    ]);
    const addToCache = (0, $5uXOq.useCallback)(({ query: query, variables: variables, newNodes: newNodes })=>{
        const getCachedListData = ()=>{
            try {
                const read = client.readQuery({
                    query: query,
                    variables: variables
                });
                (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheRead taskSuccess', {
                    task: analyticsTaskName
                });
                return read;
            } catch (e) {
                (0, $jcw0u.default)({
                    error: e instanceof Error ? e : new Error('Unknown cache read error'),
                    meta: {
                        id: 'addToCache',
                        packageName: 'jiraBusinessListHandlers',
                        teamName: 'keystone'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true,
                    attributes: {
                        task: analyticsTaskName,
                        query: JSON.stringify(query),
                        variables: JSON.stringify(variables),
                        eventName: 'apolloCacheRead taskFail',
                        error: JSON.stringify(e)
                    }
                });
                return null;
            }
        };
        const data = getCachedListData();
        const listData = (0, $9SwwX.getAGGCompliantData)(data ?? undefined, 'list');
        if (listData == null || listData.edges == null || !Array.isArray(newNodes) || newNodes.length === 0) return;
        try {
            const newIssueIds = new Set(newNodes.map((item)=>{
                if (item != null && item.issueId != null) return item.issueId;
                return undefined;
            }).filter(Boolean));
            newNodes.forEach((item)=>{
                if (item == null || item.fields == null) return;
                const issueKey = $f61770b894122deb$var$getIssueKey(item.fields);
                if (issueKey != null && issueKey !== '') {
                    const parentIssueId = (0, $jDUax.getParentIssueId)(item);
                    const currentIssueId = item.issueId;
                    removeIssueFromExtractedFieldsCache({
                        currentIssueId: currentIssueId,
                        issueKey: issueKey,
                        parentIssueId: parentIssueId
                    });
                }
            });
            const isOptimisticIssueWithRealIssueInNewNodes = (issue)=>{
                // check whether an issue is an optimisticIssue that has the real data coming in
                // summary should give us a second check to replace the right optimistic issue with the new one
                // we are using summary instead of issueKey or issueId
                // since it's the only field that will contain the same value to identify
                // the correlation between real issue and optimistic issue
                const issueSummary = issue.fields?.find((field)=>field.fieldId === 'summary');
                const newNodeWithSameSummary = newNodes.find((newNode)=>newNode.fields?.find((field)=>field.fieldId === 'summary' && issueSummary != null && field.text === issueSummary.text));
                return issue.id.toString().startsWith((0, $deqCE.OPTIMISTIC_ID_PREFIX)) && newNodeWithSameSummary != null;
            };
            const newIssues = listData.edges.filter((edge)=>edge != null && edge.node != null && edge.node.issueId != null && !newIssueIds.has(edge.node.issueId) && !isOptimisticIssueWithRealIssueInNewNodes(edge.node)).concat(newNodes.map((node)=>({
                    node: node,
                    __typename: 'JiraWorkManagementViewItemEdge'
                }))) ?? [];
            client.writeQuery({
                query: query,
                variables: variables,
                data: {
                    ...data,
                    jira: {
                        ...data?.jira ?? {},
                        list: {
                            ...listData,
                            edges: newIssues,
                            totalCount: newIssues.length
                        }
                    }
                }
            });
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheWrite taskSuccess', {
                task: analyticsTaskName
            });
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloAddToCache taskSuccess', {
                task: analyticsTaskName
            });
        } catch (e) {
            (0, $jcw0u.default)({
                error: e instanceof Error ? e : new Error('Unknown cache write error'),
                meta: {
                    id: 'addToCache',
                    packageName: 'jiraBusinessListHandlers',
                    teamName: 'keystone'
                },
                sendToPrivacyUnsafeSplunk: true,
                skipSentry: true,
                attributes: {
                    task: analyticsTaskName,
                    query: JSON.stringify(query),
                    variables: JSON.stringify(variables),
                    eventName: 'apolloCacheWrite taskFail',
                    error: JSON.stringify(e)
                }
            });
        }
    }, [
        client,
        createAnalyticsEvent,
        removeIssueFromExtractedFieldsCache
    ]);
    const removeFromCache = (0, $5uXOq.useCallback)(({ query: query, variables: variables, issueId: issueId })=>{
        const issueIds = Array.isArray(issueId) ? issueId : [
            issueId
        ];
        const getCachedListData = ()=>{
            try {
                const read = client.readQuery({
                    query: query,
                    variables: variables
                });
                (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheRead taskSuccess', {
                    task: analyticsTaskName
                });
                return read;
            } catch (e) {
                (0, $jcw0u.default)({
                    error: e instanceof Error ? e : new Error('Unknown cache read error'),
                    meta: {
                        id: 'removeFromCache',
                        packageName: 'jiraBusinessListHandlers',
                        teamName: 'keystone'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true,
                    attributes: {
                        task: analyticsTaskName,
                        query: JSON.stringify(query),
                        variables: JSON.stringify(variables),
                        eventName: 'apolloCacheRead taskFail',
                        error: JSON.stringify(e)
                    }
                });
                return null;
            }
        };
        const data = getCachedListData();
        const listData = (0, $9SwwX.getAGGCompliantData)(data ?? undefined, 'list');
        if (!listData?.edges || !Array.isArray(listData.edges)) return;
        try {
            const updatedEdges = listData.edges?.filter((edge)=>edge?.node && !issueIds.includes(edge.node.issueId));
            client.writeQuery({
                query: query,
                variables: variables,
                data: {
                    ...data,
                    jira: {
                        ...data?.jira ?? {},
                        list: {
                            ...listData,
                            edges: updatedEdges,
                            totalCount: updatedEdges.length
                        }
                    }
                }
            });
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheWrite taskSuccess', {
                task: analyticsTaskName
            });
            issueIds.forEach((issue)=>{
                const index = $f61770b894122deb$var$getIndexById(listData ?? undefined, issue);
                const item = updatedEdges[index];
                const issueKey = $f61770b894122deb$var$getIssueKey(item?.node?.fields ?? []);
                const currentIssueId = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(item, 'issueId', 0);
                if (issueKey !== '') removeIssueFromExtractedFieldsCache({
                    currentIssueId: currentIssueId,
                    issueKey: issueKey
                });
            });
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloRemoveFromCache taskSuccess', {
                task: analyticsTaskName
            });
        } catch (e) {
            (0, $jcw0u.default)({
                error: e instanceof Error ? e : new Error('Unknown cache Write error'),
                meta: {
                    id: 'removeFromCache',
                    packageName: 'jiraBusinessListHandlers',
                    teamName: 'keystone'
                },
                sendToPrivacyUnsafeSplunk: true,
                skipSentry: true,
                attributes: {
                    task: analyticsTaskName,
                    query: JSON.stringify(query),
                    variables: JSON.stringify(variables),
                    eventName: 'apolloCacheWrite taskFail',
                    error: JSON.stringify(e)
                }
            });
        }
    }, [
        client,
        createAnalyticsEvent,
        removeIssueFromExtractedFieldsCache
    ]);
    const getCachedIssueById = (0, $5uXOq.useCallback)(({ query: query, variables: variables, issueId: issueId })=>{
        const getCachedListData = ()=>{
            try {
                const read = client.readQuery({
                    query: query,
                    variables: variables
                });
                (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheRead taskSuccess', {
                    task: analyticsTaskName
                });
                return read;
            } catch (e) {
                (0, $jcw0u.default)({
                    error: e instanceof Error ? e : new Error('Unknown cache read error'),
                    meta: {
                        id: 'getCachedIssueById',
                        packageName: 'jiraBusinessListHandlers',
                        teamName: 'keystone'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true,
                    attributes: {
                        task: analyticsTaskName,
                        query: JSON.stringify(query),
                        variables: JSON.stringify(variables),
                        eventName: 'apolloCacheRead taskFail',
                        error: JSON.stringify(e)
                    }
                });
                return null;
            }
        };
        const data = getCachedListData();
        const listData = (0, $9SwwX.getAGGCompliantData)(data ?? undefined, 'list');
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloGetCachedIssueById taskSuccess', {
            task: analyticsTaskName
        });
        return listData?.edges?.find((issue)=>issue?.node?.issueId === Number(issueId))?.node ?? null;
    }, [
        client,
        createAnalyticsEvent
    ]);
    const updateItemsInCache = (0, $5uXOq.useCallback)(({ query: query, variables: variables, issueIds: issueIds, updateItem: updateItem })=>{
        const getCachedListData = ()=>{
            try {
                const read = client.readQuery({
                    query: query,
                    variables: variables
                });
                (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheRead taskSuccess', {
                    task: analyticsTaskName
                });
                return read;
            } catch (e) {
                (0, $jcw0u.default)({
                    error: e instanceof Error ? e : new Error('Unknown cache read error'),
                    meta: {
                        id: 'updateItemsInCache',
                        packageName: 'jiraBusinessListHandlers',
                        teamName: 'keystone'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true,
                    attributes: {
                        task: analyticsTaskName,
                        query: JSON.stringify(query),
                        variables: JSON.stringify(variables),
                        eventName: 'apolloCacheRead taskFail',
                        error: JSON.stringify(e)
                    }
                });
                return null;
            }
        };
        const data = getCachedListData();
        const listData = (0, $9SwwX.getAGGCompliantData)(data ?? undefined, 'list');
        const existingEdges = listData?.edges;
        if (existingEdges == null) return;
        try {
            const newEdges = [
                ...existingEdges
            ];
            let hasItemOverride = false;
            issueIds.forEach((issueId)=>{
                const issueToUpdateIndex = existingEdges.findIndex((issue)=>issue?.node?.issueId === Number(issueId)) ?? undefined;
                const existingIssue = existingEdges[issueToUpdateIndex];
                if (existingIssue?.node == null || issueToUpdateIndex === undefined || issueToUpdateIndex === -1 || existingIssue == null) return;
                const itemOverride = updateItem(existingIssue.node);
                if (itemOverride === undefined) return;
                hasItemOverride = true;
                newEdges[issueToUpdateIndex] = {
                    node: itemOverride,
                    __typename: 'JiraWorkManagementViewItemEdge'
                };
            });
            if (!hasItemOverride) return;
            client.writeQuery({
                query: query,
                variables: variables,
                data: {
                    ...data,
                    jira: {
                        ...data?.jira ?? {},
                        list: {
                            ...listData,
                            edges: newEdges,
                            totalCount: newEdges.length
                        }
                    }
                }
            });
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheWrite taskSuccess', {
                task: analyticsTaskName
            });
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloUpdateItemsInCache taskSuccess', {
                task: analyticsTaskName
            });
        } catch (e) {
            (0, $jcw0u.default)({
                error: e instanceof Error ? e : new Error('Unknown cache write error'),
                meta: {
                    id: 'updateItemsInCache',
                    packageName: 'jiraBusinessListHandlers',
                    teamName: 'keystone'
                },
                sendToPrivacyUnsafeSplunk: true,
                skipSentry: true,
                attributes: {
                    task: analyticsTaskName,
                    query: JSON.stringify(query),
                    variables: JSON.stringify(variables),
                    eventName: 'apolloCacheWrite taskFail',
                    error: JSON.stringify(e)
                }
            });
        }
    }, [
        client,
        createAnalyticsEvent
    ]);
    return {
        addToCache: addToCache,
        removeFromCache: removeFromCache,
        getCachedIssueById: getCachedIssueById,
        updateItemsInCache: updateItemsInCache
    };
};

});
parcelRegister("3fAi8", function(module, exports) {

$parcel$export(module.exports, "useFieldValue", () => $ddbc380ab4ee430c$export$b79fae7fbe3ac392);
$parcel$export(module.exports, "useFieldsValues", () => $ddbc380ab4ee430c$export$25b73e671fe7a8fa);
$parcel$export(module.exports, "useMultiFieldValuesForIssues", () => $ddbc380ab4ee430c$export$915cdeec521b54f7);
$parcel$export(module.exports, "FieldValueSubscriber", () => $ddbc380ab4ee430c$export$4e5f1f4ed08d155e);
$parcel$export(module.exports, "useFieldsValuesActions", () => $ddbc380ab4ee430c$export$612d9bcb0c9d8976);

var $5uXOq = parcelRequire("5uXOq");

var $1UikQ = parcelRequire("1UikQ");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");
const $ddbc380ab4ee430c$var$setIssue = (issueKey, fields)=>({ setState: setState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: fields
        });
    };
const $ddbc380ab4ee430c$var$setIssues = (issues)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = {};
        issues.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState(newIssues);
    };
const $ddbc380ab4ee430c$var$setFieldValue = (issueKey, fieldKey, value)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...getState()[issueKey],
                [fieldKey]: value
            }
        });
    };
const $ddbc380ab4ee430c$var$getFieldValue = (issueKey, fieldKey)=>({ getState: getState })=>{
        const issueFieldValues = getState()[issueKey];
        return issueFieldValues && issueFieldValues[fieldKey];
    };
const $ddbc380ab4ee430c$var$mergeIssue = (issueKey, fields)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, getState()[issueKey], fields)
        });
    };
const $ddbc380ab4ee430c$export$11aa02e14fdf7753 = (issues)=>({ setState: setState, getState: getState })=>{
        if (issues.length === 0) return;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = {};
        issues.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState((0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, getState(), newIssues));
    };
const $ddbc380ab4ee430c$var$actions = {
    setFieldValue: $ddbc380ab4ee430c$var$setFieldValue,
    getFieldValue: $ddbc380ab4ee430c$var$getFieldValue,
    setIssue: $ddbc380ab4ee430c$var$setIssue,
    mergeIssue: $ddbc380ab4ee430c$var$mergeIssue,
    setIssues: $ddbc380ab4ee430c$var$setIssues,
    mergeIssues: $ddbc380ab4ee430c$export$11aa02e14fdf7753
};
// this is a global store
const $ddbc380ab4ee430c$var$store = (0, $iXqE5.createStore)({
    name: 'issue-fields',
    initialState: {},
    actions: $ddbc380ab4ee430c$var$actions
});
const $ddbc380ab4ee430c$var$getFieldValueSelector = (state, { issueKey: issueKey, fieldKey: fieldKey })=>{
    const issueFieldValues = state[issueKey];
    return issueFieldValues && issueFieldValues[fieldKey];
};
const $ddbc380ab4ee430c$var$getFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKey: fieldKey })=>(issueKeys || []).map((issueKey)=>$ddbc380ab4ee430c$var$getFieldValueSelector(state, {
            fieldKey: fieldKey,
            issueKey: issueKey
        }));
const $ddbc380ab4ee430c$var$getMultiFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKeys: fieldKeys })=>(issueKeys || []).reduce((accumulator, issueKey)=>{
        if (!state[issueKey]) return accumulator;
        const fieldValue = fieldKeys.reduce((acc, fieldKey)=>{
            acc[fieldKey] = $ddbc380ab4ee430c$var$getFieldValueSelector(state, {
                fieldKey: fieldKey,
                issueKey: issueKey
            });
            return acc;
        }, {});
        accumulator[issueKey] = fieldValue;
        return accumulator;
    }, {});
const $ddbc380ab4ee430c$var$getAllFields = (state, issueKey)=>state[issueKey];
const $ddbc380ab4ee430c$export$b79fae7fbe3ac392 = (0, $3sQ5x.createHook)($ddbc380ab4ee430c$var$store, {
    selector: $ddbc380ab4ee430c$var$getFieldValueSelector
});
const $ddbc380ab4ee430c$export$25b73e671fe7a8fa = (0, $3sQ5x.createHook)($ddbc380ab4ee430c$var$store, {
    selector: $ddbc380ab4ee430c$var$getAllFields
});
const $ddbc380ab4ee430c$export$ac289b84121829df = (0, $3sQ5x.createHook)($ddbc380ab4ee430c$var$store, {
    selector: $ddbc380ab4ee430c$var$getFieldValuesForIssuesSelector
});
const $ddbc380ab4ee430c$export$915cdeec521b54f7 = (0, $3sQ5x.createHook)($ddbc380ab4ee430c$var$store, {
    selector: $ddbc380ab4ee430c$var$getMultiFieldValuesForIssuesSelector
});
const $ddbc380ab4ee430c$export$4e5f1f4ed08d155e = (0, $51nlc.createSubscriber)($ddbc380ab4ee430c$var$store, {
    selector: $ddbc380ab4ee430c$var$getFieldValueSelector
});
const $ddbc380ab4ee430c$var$useFieldValueStoreActions = (0, $3sQ5x.createHook)($ddbc380ab4ee430c$var$store, {
    selector: null
});
const $ddbc380ab4ee430c$export$612d9bcb0c9d8976 = ()=>{
    const [, fieldValueStoreActions] = $ddbc380ab4ee430c$var$useFieldValueStoreActions();
    const fieldsValuesActions = (0, $5uXOq.useMemo)(()=>{
        const setIssueAction = (issueKey, fields)=>fieldValueStoreActions.setIssue(issueKey, fields);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const setFieldValueAction = (issueKey, fieldKey, value)=>fieldValueStoreActions.setFieldValue(issueKey, fieldKey, value);
        const getFieldValueAction = (issueKey, fieldKey)=>fieldValueStoreActions.getFieldValue(issueKey, fieldKey);
        const mergeIssueAction = (issueKey, fields)=>fieldValueStoreActions.mergeIssue(issueKey, fields);
        const setIssuesAction = (issues)=>fieldValueStoreActions.setIssues(issues);
        const mergeIssuesAction = (issues)=>fieldValueStoreActions.mergeIssues(issues);
        return {
            setIssue: setIssueAction,
            setFieldValue: setFieldValueAction,
            getFieldValue: getFieldValueAction,
            mergeIssue: mergeIssueAction,
            setIssues: setIssuesAction,
            mergeIssues: mergeIssuesAction
        };
    }, [
        fieldValueStoreActions
    ]);
    return [
        null,
        fieldsValuesActions
    ];
};

});


parcelRegister("dCjtG", function(module, exports) {

$parcel$export(module.exports, "useViewUpdater", () => $92d86c8da94b73a1$export$a7d7c9fa51f6f9e6);

var $5uXOq = parcelRequire("5uXOq");

var $5tTFS = parcelRequire("5tTFS");

var $egmQO = parcelRequire("egmQO");

var $5YBrl = parcelRequire("5YBrl");

var $3ItGl = parcelRequire("3ItGl");

var $4R6GH = parcelRequire("4R6GH");

var $5fc53 = parcelRequire("5fc53");

var $koeKL = parcelRequire("koeKL");

var $9SwwX = parcelRequire("9SwwX");

var $1TVaR = parcelRequire("1TVaR");

var $1RfvD = parcelRequire("1RfvD");
const $92d86c8da94b73a1$export$a7d7c9fa51f6f9e6 = ({ input: input, query: query, actions: actions, onError: onError, onAppendItemsError: onAppendItemsError })=>{
    const jqlContext = (0, $5YBrl.useJqlContext)();
    const cloudId = (0, $koeKL.useCloudId)();
    // Keep track of updates in flight so we can validate them against the current list of issues.
    // Useful when filters are enabled and items are changed in a way that do not match the filter anymore.
    const [updateInFlightList, setUpdateInFlightList] = (0, $5uXOq.useState)([]);
    const [cacheActionIssues, dispatch] = (0, $1RfvD.useCacheActionsReducer)();
    // getIssuesByIdVariablesRef is for using the variables in the useCallback for onComplete,
    // otherwise it errors because it is referenced before it's declared and is undefined
    const getIssuesByIdVariablesRef = (0, $5uXOq.useRef)();
    const getIssuesByIdOnCompletedRef = (0, $5uXOq.useRef)(null);
    // should be removed when timeline-add-jql-error-boundary fg is cleaned up HRZ-2089
    const shouldAddWithQueryError = input.withQueryError && (0, $4R6GH.fg)('timeline-add-jql-error-boundary');
    // Separate query to handle issue removal
    const [fetchIssueToRemove, { loading: fetchIssueToRemoveLoading }] = (0, $5tTFS.useLazyQuery)(query, {
        fetchPolicy: 'network-only',
        errorPolicy: 'all',
        onCompleted: (0, $5uXOq.useCallback)((result)=>{
            const items = (0, $9SwwX.getAGGCompliantData)(result, 'list', (0, $4R6GH.fg)('flingo-1623-ignore-throw-to-sentry') ? onError : undefined);
            const validNodes = items?.edges?.map((edge)=>edge?.node).filter(Boolean);
            if (validNodes && validNodes.length > 0) dispatch({
                type: 'REMOVE_FROM_CACHE',
                issues: validNodes
            });
        }, [
            dispatch,
            onError
        ]),
        onError: onAppendItemsError
    });
    // Separated query to update individual items so the other query can deal with pagination in the right sequence
    const [getIssuesById, { variables: getIssuesByIdVariables, loading: getIssuesByIdLoading }] = (0, $5tTFS.useLazyQuery)(query, {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all',
        onError: (0, $5uXOq.useCallback)((error)=>{
            if ((0, $3ItGl.isAbortError)(error.networkError)) return;
            onError(error);
        }, [
            onError
        ]),
        onCompleted: (0, $5uXOq.useCallback)((result)=>getIssuesByIdOnCompletedRef.current?.(result), [])
    });
    if (getIssuesByIdVariablesRef.current !== getIssuesByIdVariables) getIssuesByIdVariablesRef.current = getIssuesByIdVariables;
    // Separated query to append newly created items so we know it needs to be added to the top of the list.
    // Adding to the top to mimic backend behaviour but this might need to change when we introduce sorting.
    const [appendIssuesById, { loading: appendIssuesByIdLoading }] = (0, $5tTFS.useLazyQuery)(query, {
        fetchPolicy: 'network-only',
        errorPolicy: 'all',
        onCompleted: (0, $5uXOq.useCallback)((result)=>{
            const items = (0, $9SwwX.getAGGCompliantData)(result, 'list', onError);
            const validNodes = items?.edges?.map((edge)=>edge?.node).filter(Boolean);
            if (validNodes && validNodes.length > 0) dispatch({
                type: 'ADD_TO_CACHE',
                issues: validNodes
            });
        }, [
            dispatch,
            onError
        ]),
        onError: onAppendItemsError
    });
    const { addRequestToQueue: addRequestToQueue, addRequestToAbortableQueue: addRequestToAbortableQueue } = (0, $1TVaR.useRequestQueue)({
        isRequestLoading: fetchIssueToRemoveLoading || getIssuesByIdLoading || appendIssuesByIdLoading
    });
    const removeIssueById = (0, $5uXOq.useCallback)((issueIdsToRemove)=>{
        addRequestToQueue(()=>fetchIssueToRemove({
                variables: {
                    ...(0, $egmQO.getVariables)({
                        jqlContext: jqlContext,
                        issueIds: issueIdsToRemove,
                        fieldIds: input.fieldIds,
                        isHidingDoneItems: input.isHidingDoneItems,
                        isParentFieldVisible: input.isParentFieldVisible,
                        isDevSummaryFieldVisible: input.isDevSummaryFieldVisible,
                        projectIdOrKey: input.projectKey,
                        // we don't want to include any quickFiltersJql on purpose
                        // because we actually want to get the data of the issue that is not suppose to match the current quickFiltersJql
                        // e.g. consider this scenario
                        // - if the current quickFiltersJql is filtering DONE item
                        // - and the issueId that we need to remove is because user moving it to DONE
                        // - if we include the quickFiltersJql in here, the BE will NOT return the issue data because it's already DONE -> so we can't filter it in FE
                        // - so in this case we just want the data of the issue
                        quickFiltersJql: null,
                        ...shouldAddWithQueryError && {
                            withQueryError: input.withQueryError
                        }
                    }),
                    cloudId: cloudId
                }
            }));
    }, [
        addRequestToQueue,
        fetchIssueToRemove,
        jqlContext,
        input.fieldIds,
        input.isHidingDoneItems,
        input.isParentFieldVisible,
        input.isDevSummaryFieldVisible,
        input.projectKey,
        cloudId,
        shouldAddWithQueryError,
        input.withQueryError
    ]);
    const removeIssue = (0, $5uXOq.useCallback)(({ issueId: issueId, parentId: parentId })=>{
        // @ts-expect-error ts(2322) - we can't instantiate an issue of the generic type, as we can't know the whole issue
        // However, the removeFromCache function called with this issue only needs this part of the interface
        const issueNode = {
            issueId: issueId,
            fields: parentId != null ? [
                {
                    fieldId: 'parent',
                    type: (0, $5fc53.PARENT_TYPE),
                    parentIssue: {
                        issueId: parentId
                    }
                }
            ] : []
        };
        dispatch({
            type: 'REMOVE_FROM_CACHE',
            issues: [
                issueNode
            ]
        });
    }, [
        dispatch
    ]);
    // Filters are handled by JQL (not client side). The update function respects the filters so a BLANK update
    // means the item findIssueById didn't match the JQL filter and SHOULD be removed.
    const handleFilterMismatch = (0, $5uXOq.useCallback)((variables, result)=>{
        if (!variables.jql) return;
        if (!result || !result.jira) // this is a case where the request failed, we don't want to remove the issue from the list in this case
        return;
        const updateIndex = updateInFlightList.findIndex((updateInput)=>(0, $egmQO.getVariables)(updateInput).jql === variables.jql);
        if (updateIndex === -1) return;
        const currentUpdate = updateInFlightList[updateIndex];
        // In slow connections, users might change filters after an update was requested but before it can be applied.
        // We should not process those!
        const isUsingSameFilter = currentUpdate.quickFiltersJql === input.quickFiltersJql;
        const issueIds = [
            ...currentUpdate.issueIds || []
        ];
        const items = (0, $9SwwX.getAGGCompliantData)(result, 'list', (0, $4R6GH.fg)('flingo-1623-ignore-throw-to-sentry') ? onError : undefined);
        const validNodes = items?.edges?.map((edge)=>edge?.node).filter(Boolean);
        if (isUsingSameFilter) {
            const issueIdsToRemove = [];
            issueIds.forEach((issueId, idIndex)=>{
                // item exists in the list but not in the filtered results - remove it!
                const item = validNodes?.find((node)=>node?.issueId === issueId);
                if (item == null) issueIdsToRemove.push(issueId);
                issueIds.splice(idIndex, 0);
                updateInFlightList[updateIndex] = {
                    ...currentUpdate,
                    issueIds: issueIds
                };
            });
            if (issueIdsToRemove.length > 0) removeIssueById(issueIdsToRemove);
        }
        setUpdateInFlightList((prevUpdateInFlightList)=>{
            prevUpdateInFlightList.splice(updateIndex, 1);
            return prevUpdateInFlightList;
        });
        // if item returns in filtered results it should be added to the cache. The method will dedup and sort by rank.
        if (validNodes && validNodes.length > 0) dispatch({
            type: 'ADD_TO_CACHE',
            issues: validNodes
        });
        // if item has been filtered out we may still want to do something with it
        const filteredIssueIds = issueIds.filter((issueId)=>!(validNodes ?? []).find((node)=>node?.issueId === issueId));
        if (filteredIssueIds.length > 0) dispatch({
            type: 'HANDLE_FILTERED_UPDATE',
            issues: filteredIssueIds
        });
    }, [
        updateInFlightList,
        input,
        removeIssueById,
        dispatch,
        onError
    ]);
    getIssuesByIdOnCompletedRef.current = (result)=>handleFilterMismatch(getIssuesByIdVariables, result);
    // Interact with the cache in a useEffect to avoid doing it faster than the group items query data is updated
    (0, $5uXOq.useEffect)(()=>{
        if (cacheActionIssues.addToCache.length === 0 && cacheActionIssues.removeFromCache.length === 0 && cacheActionIssues.handleFilteredUpdate.length === 0) return;
        /* eslint-disable @typescript-eslint/consistent-type-assertions */ Object.entries(cacheActionIssues)/* eslint-enable @typescript-eslint/consistent-type-assertions */ .forEach(([actionName, issues])=>{
            if (Array.isArray(issues) && issues.length > 0) actions.forEach((actionEntry)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                actionEntry?.[actionName]?.(issues);
            });
        });
        dispatch({
            type: 'CLEAR'
        });
    }, [
        cacheActionIssues,
        actions,
        dispatch
    ]);
    return {
        onIssueUpdated: (issueIds)=>{
            // we want to fetch this issueIds
            // but at the same time we pass the `quickFiltersJql`
            // so if in the end result, we don't get back the `issueIds`, we know that the updated issue is not valid anymore in the current `quickFiltersJql`
            // e.g.
            // - current quickFiltersJql is NOT showing DONE item
            // - then there is an update to an ISSUE-X that changes the status
            // - we then fetch updated data of ISSUE_X based on current quickFiltersJql
            // - if the ISSUE-X is returned in the result -> it means ISSUE-X still matches current quickFiltersJql
            // - otherwise it is not, so it will be handled in handleFilterMismatch to be removed from view
            const updateInput = {
                jqlContext: jqlContext,
                issueIds: issueIds,
                fieldIds: input.fieldIds,
                quickFiltersJql: input.quickFiltersJql,
                isHidingDoneItems: input.isHidingDoneItems,
                isParentFieldVisible: input.isParentFieldVisible,
                isDevSummaryFieldVisible: input.isDevSummaryFieldVisible,
                projectIdOrKey: input.projectKey,
                ...shouldAddWithQueryError && {
                    withQueryError: input.withQueryError
                }
            };
            setUpdateInFlightList((prevUpdateInFlightList)=>[
                    ...prevUpdateInFlightList,
                    updateInput
                ]);
            addRequestToAbortableQueue(issueIds, getIssuesById, {
                variables: {
                    ...(0, $egmQO.getVariables)(updateInput),
                    cloudId: cloudId
                }
            });
        },
        onIssueCreated: (issueIds)=>{
            addRequestToQueue(()=>appendIssuesById({
                    variables: {
                        ...(0, $egmQO.getVariables)({
                            jqlContext: jqlContext,
                            issueIds: issueIds,
                            fieldIds: input.fieldIds,
                            quickFiltersJql: input.quickFiltersJql,
                            isHidingDoneItems: input.isHidingDoneItems,
                            isParentFieldVisible: input.isParentFieldVisible,
                            isDevSummaryFieldVisible: input.isDevSummaryFieldVisible,
                            projectIdOrKey: input.projectKey,
                            ...shouldAddWithQueryError && {
                                withQueryError: input.withQueryError
                            }
                        }),
                        cloudId: cloudId
                    }
                }));
        },
        onIssueRemoved: (params)=>removeIssue(params)
    };
};

});
parcelRegister("3ItGl", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ABORT_ERROR_MESSAGE", () => $d72d9e0bee84c3ed$export$6131a8d209a21250);
$parcel$export(module.exports, "AbortError", () => $d72d9e0bee84c3ed$export$18b052ffd8c84d7);
$parcel$export(module.exports, "isAbortError", () => $d72d9e0bee84c3ed$export$d2c30ea522b3259e);
const $d72d9e0bee84c3ed$export$6131a8d209a21250 = 'The operation was aborted.';
class $d72d9e0bee84c3ed$export$18b052ffd8c84d7 extends Error {
    constructor(message, statusCode = 499){
        super(message);
        this.name = 'AbortError';
        this.statusCode = statusCode;
    }
}
const $d72d9e0bee84c3ed$export$d2c30ea522b3259e = (error)=>error instanceof $d72d9e0bee84c3ed$export$18b052ffd8c84d7;

});

parcelRegister("1TVaR", function(module, exports) {

$parcel$export(module.exports, "useRequestQueue", () => $c49911f50c422071$export$a90df70eeafb262f);

var $5uXOq = parcelRequire("5uXOq");

var $3ItGl = parcelRequire("3ItGl");
const $c49911f50c422071$export$a90df70eeafb262f = ({ isRequestLoading: isRequestLoading })=>{
    const [abortableQueueMap, setAbortableQueueMap] = (0, $5uXOq.useState)(new Map());
    const abortControllerMap = (0, $5uXOq.useRef)(new Map());
    const inProgressRequestId = (0, $5uXOq.useRef)(null);
    const addRequestToAbortableQueue = (0, $5uXOq.useCallback)((issueIds, queryFunction, queryOptions)=>{
        const id = issueIds.join('-');
        const existingAbortController = abortControllerMap.current.get(id);
        existingAbortController?.abort(new (0, $3ItGl.AbortError)((0, $3ItGl.DEFAULT_ABORT_ERROR_MESSAGE)));
        const abortController = new AbortController();
        abortControllerMap.current.set(id, abortController);
        const request = ()=>{
            queryFunction({
                ...queryOptions,
                context: {
                    ...queryOptions.context,
                    fetchOptions: {
                        ...queryOptions.context?.fetchOptions,
                        signal: abortController.signal
                    }
                }
            });
        };
        setAbortableQueueMap((prevQueueMap)=>new Map([
                ...prevQueueMap,
                [
                    id,
                    request
                ]
            ]));
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        if (!isRequestLoading && abortableQueueMap.size) {
            const iterator = abortableQueueMap.entries();
            const nextResult = iterator.next();
            if (!nextResult.done) {
                const [id, request] = nextResult.value;
                inProgressRequestId.current = id;
                request();
            }
            setAbortableQueueMap(new Map(iterator));
        }
    }, [
        abortableQueueMap,
        isRequestLoading
    ]);
    const [queue, setQueue] = (0, $5uXOq.useState)([]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isRequestLoading && queue.length > 0) setQueue((prevQueue)=>{
            const [nextItem, ...restOfQueue] = prevQueue;
            nextItem();
            return restOfQueue;
        });
    }, [
        queue,
        isRequestLoading
    ]);
    const addRequestToQueue = (request)=>setQueue((prevQueue)=>[
                ...prevQueue,
                request
            ]);
    return {
        addRequestToQueue: addRequestToQueue,
        addRequestToAbortableQueue: addRequestToAbortableQueue
    };
};

});

parcelRegister("1RfvD", function(module, exports) {

$parcel$export(module.exports, "useCacheActionsReducer", () => $9eb3afdf1d8deb15$export$83303d410e8412eb);

var $5uXOq = parcelRequire("5uXOq");
const $9eb3afdf1d8deb15$var$cacheActionsReducer = (state, action)=>{
    switch(action.type){
        case 'ADD_TO_CACHE':
            return {
                ...state,
                addToCache: [
                    ...state.addToCache,
                    ...action.issues
                ]
            };
        case 'REMOVE_FROM_CACHE':
            return {
                ...state,
                removeFromCache: [
                    ...state.removeFromCache,
                    ...action.issues
                ]
            };
        case 'HANDLE_FILTERED_UPDATE':
            return {
                ...state,
                handleFilteredUpdate: [
                    ...state.handleFilteredUpdate,
                    ...action.issues
                ]
            };
        case 'CLEAR':
            return {
                addToCache: [],
                removeFromCache: [],
                handleFilteredUpdate: []
            };
        default:
            return state;
    }
};
const $9eb3afdf1d8deb15$export$83303d410e8412eb = ()=>// @ts-expect-error - TS2554 - Expected 3 arguments, but got 2.
    (0, $5uXOq.useReducer)($9eb3afdf1d8deb15$var$cacheActionsReducer, {
        addToCache: [],
        removeFromCache: [],
        handleFilteredUpdate: []
    });

});


parcelRegister("gwNxS", function(module, exports) {

$parcel$export(module.exports, "createViewUpdaterCallbacksWithCacheActions", () => $65b2bcc93c8e1166$export$cc1c02509eec9edb);
$parcel$export(module.exports, "createGroupingViewUpdaterCacheActions", () => $65b2bcc93c8e1166$export$c410d2a23de7830a);

var $jDUax = parcelRequire("jDUax");
const $65b2bcc93c8e1166$export$cc1c02509eec9edb = ({ isHierarchyEnabled: isHierarchyEnabled, isInfiniteHierarchyEnabled: isInfiniteHierarchyEnabled, query: query, addToCache: addToCache, removeFromCache: removeFromCache, updateItemsInCache: updateItemsInCache, createVariablesForItemWithParent: createVariablesForItemWithParent, createVariablesForItemWithoutParent: createVariablesForItemWithoutParent, shouldChildItemBeAddedToOrRemovedFromCache: shouldChildItemBeAddedToOrRemovedFromCache, onUpdateParentWithNewChild: onUpdateParentWithNewChild, getParentOfIssueIfExist: getParentOfIssueIfExist, isItemHierarchySupported: isItemHierarchySupported, removeChildFromParent: removeChildFromParent, updateIssueParentMap: updateIssueParentMap, getPrevParentOfIssueIfExists: getPrevParentOfIssueIfExists, createVariablesForGroupItem: createVariablesForGroupItem, isGroupingByStatus: isGroupingByStatus = false, isGrouping: isGrouping = false })=>{
    const getParentVariables = (parentId)=>{
        const variables = createVariablesForItemWithoutParent();
        if (!parentId) return variables;
        if (createVariablesForGroupItem && (0, $jDUax.isGroupItem)(parentId)) return createVariablesForGroupItem(parentId);
        return createVariablesForItemWithParent(parentId);
    };
    const updateIssueParent = ({ prevParentIssueId: prevParentIssueId, parentIssueId: parentIssueId, item: item })=>{
        updateIssueParentMap && updateIssueParentMap(item.issueId, parentIssueId);
        if (!prevParentIssueId && !isGrouping || isGrouping && prevParentIssueId || prevParentIssueId && shouldChildItemBeAddedToOrRemovedFromCache(prevParentIssueId)) removeFromCache({
            query: query,
            variables: getParentVariables(prevParentIssueId),
            issueId: Number(item.issueId)
        });
        if (isGroupingByStatus) return;
        const hasParentToRemove = getParentOfIssueIfExist && !!getParentOfIssueIfExist(item.issueId);
        if (removeChildFromParent && prevParentIssueId && hasParentToRemove) {
            const grandParentId = getParentOfIssueIfExist ? getParentOfIssueIfExist(String(prevParentIssueId)) : undefined;
            if ((0, $jDUax.isGroupItem)(grandParentId) || (0, $jDUax.isGroupItem)(prevParentIssueId)) return;
            updateItemsInCache({
                query: query,
                variables: getParentVariables(grandParentId),
                issueIds: [
                    String(prevParentIssueId)
                ],
                updateItem: (existingParentIssue)=>removeChildFromParent(existingParentIssue, 1)
            });
        }
        if (!parentIssueId) return;
        // updateChildCount of new parent
        // so user will have an indicator that shows the parent has subtask now
        const newGrandParentId = getParentOfIssueIfExist ? getParentOfIssueIfExist(parentIssueId.toString()) : undefined;
        if ((0, $jDUax.isGroupItem)(newGrandParentId) || (0, $jDUax.isGroupItem)(parentIssueId)) return;
        updateItemsInCache({
            query: query,
            variables: getParentVariables(newGrandParentId),
            issueIds: [
                parentIssueId
            ],
            updateItem: (existingIssue)=>{
                const updatedIssueWithNewChild = onUpdateParentWithNewChild(existingIssue, item);
                return updatedIssueWithNewChild;
            }
        });
    };
    const addToCacheCallback = (items)=>{
        if (isHierarchyEnabled()) {
            const itemsWithoutParent = items.filter((i)=>(0, $jDUax.getParentIssueId)(i) === undefined);
            const itemsWithParent = items.filter((i)=>(0, $jDUax.getParentIssueId)(i) !== undefined);
            // add items WITHOUT parent first
            if (itemsWithoutParent.length > 0) {
                addToCache({
                    newNodes: itemsWithoutParent,
                    query: query,
                    variables: createVariablesForItemWithoutParent()
                });
                items.forEach((item)=>{
                    // when parent is unlinked from issue
                    const parentIssueId = undefined;
                    const prevParentIssueId = getPrevParentOfIssueIfExists ? getPrevParentOfIssueIfExists(item.issueId) : undefined;
                    if (isInfiniteHierarchyEnabled() && prevParentIssueId !== parentIssueId) updateIssueParent({
                        prevParentIssueId: prevParentIssueId,
                        parentIssueId: parentIssueId,
                        item: item
                    });
                });
            }
            // then add items WITH parent
            itemsWithParent.forEach((item)=>{
                const parentIssueId = (0, $jDUax.getParentIssueId)(item);
                if (parentIssueId === undefined) // this scenario should be impossible because we already filtered the item
                // but doing this just to remove the Flow error
                return;
                // CLEAN UP THE FOLLOWING CONDITION WITH as it's only used by timeline view - followed by https://jbusiness.atlassian.net/browse/HRZ-1391
                if (isItemHierarchySupported && !isItemHierarchySupported(item)) {
                    // this is a specific scenario for the TIMELINE
                    // in that view we don't support epic hierarchy (we don't show the epic children, those are displayed on the same level)
                    // in that case we should not use the parent variables because that query doesn't exist
                    addToCache({
                        newNodes: [
                            item
                        ],
                        query: query,
                        variables: createVariablesForItemWithoutParent()
                    });
                    return;
                }
                const prevParentIssueId = getPrevParentOfIssueIfExists ? getPrevParentOfIssueIfExists(item.issueId) : undefined;
                const shouldUpdateIssueParent = isInfiniteHierarchyEnabled() && prevParentIssueId !== parentIssueId;
                const shouldChildItemBeAddedOrRemovedFromCache = shouldChildItemBeAddedToOrRemovedFromCache(parentIssueId);
                if (shouldUpdateIssueParent) updateIssueParent({
                    prevParentIssueId: prevParentIssueId,
                    parentIssueId: parentIssueId,
                    item: item
                });
                // We only want to add item if the existing query for children-of-this-parent exists
                // this is to prevent apollo error where the cache key is missing
                if (shouldChildItemBeAddedOrRemovedFromCache) addToCache({
                    newNodes: [
                        item
                    ],
                    query: query,
                    variables: createVariablesForItemWithParent(parentIssueId)
                });
                else if (!shouldChildItemBeAddedOrRemovedFromCache && !shouldUpdateIssueParent) {
                    let variables = createVariablesForItemWithoutParent();
                    if (isInfiniteHierarchyEnabled() && // Grandparent only exists in infinite hierarchy
                    getParentOfIssueIfExist) {
                        const grandParentId = getParentOfIssueIfExist(parentIssueId.toString());
                        if (grandParentId != null) variables = createVariablesForItemWithParent(grandParentId);
                    }
                    // if the parent is not listed to have child yet
                    // we will update the parent to show children
                    // so user will have an indicator that shows the parent has subtask now
                    updateItemsInCache({
                        query: query,
                        variables: variables,
                        issueIds: [
                            parentIssueId
                        ],
                        updateItem: (existingIssue)=>{
                            const updatedIssueWithNewChild = onUpdateParentWithNewChild(existingIssue, item);
                            return updatedIssueWithNewChild;
                        }
                    });
                }
            });
            return;
        }
        addToCache({
            newNodes: items,
            query: query,
            variables: createVariablesForItemWithoutParent()
        });
    };
    const removeFromCacheCallback = (items)=>{
        items.forEach((item)=>{
            if (isHierarchyEnabled()) {
                const parentIssueId = (0, $jDUax.getParentIssueId)(item);
                if (parentIssueId !== undefined) {
                    if (shouldChildItemBeAddedToOrRemovedFromCache(parentIssueId)) removeFromCache({
                        issueId: item.issueId,
                        query: query,
                        variables: createVariablesForItemWithParent(parentIssueId)
                    });
                    // TODO remove the subtask from parent 'Subtask' field https://jbusiness.atlassian.net/browse/JET-1883
                    return;
                }
            }
            removeFromCache({
                issueId: item.issueId,
                query: query,
                variables: createVariablesForItemWithoutParent()
            });
        });
    };
    return {
        addToCacheCallback: addToCacheCallback,
        removeFromCacheCallback: removeFromCacheCallback
    };
};
const $65b2bcc93c8e1166$export$c410d2a23de7830a = ({ query: query, groupsQuery: groupsQuery, addToCache: addToCache, removeFromCache: removeFromCache, addGroupItemToCache: addGroupItemToCache, updateGroupItemInCache: updateGroupItemInCache, updateItemsInCache: updateItemsInCache, createVariablesForGroups: createVariablesForGroups, createVariablesForGroupItem: createVariablesForGroupItem, createItemGroup: createItemGroup, findItemGroup: findItemGroup, findGroupById: findGroupById, canUpdateGroupCache: canUpdateGroupCache, getParentOfIssueIfExist: getParentOfIssueIfExist, getPrevParentOfIssueIfExists: getPrevParentOfIssueIfExists, onUpdateParentWithNewChild: onUpdateParentWithNewChild, removeChildFromParent: removeChildFromParent, createVariablesForItemWithParent: createVariablesForItemWithParent, updateIssueParentMap: updateIssueParentMap })=>{
    const getReparentingInfo = (item)=>{
        const currentParent = (0, $jDUax.getParentIssueId)(item);
        const prevParent = getPrevParentOfIssueIfExists(String(item.issueId));
        // note that currentParent can be undefined or a groupitem if parent is unlinked
        const isUnlinkParent = (!currentParent || (0, $jDUax.isGroupItem)(currentParent)) && prevParent && currentParent !== prevParent;
        const isReparenting = currentParent && currentParent !== prevParent;
        return {
            isReparenting: isReparenting,
            isUnlinkParent: isUnlinkParent,
            currentParent: currentParent,
            prevParent: prevParent
        };
    };
    const removeItemFromCache = (item, currentGroupIssueId)=>{
        const { isReparenting: isReparenting, prevParent: prevParent, isUnlinkParent: isUnlinkParent } = getReparentingInfo(item);
        // check if items data exists in apollo cache, so that updating it won't blow up apollo
        if (canUpdateGroupCache(currentGroupIssueId) && (!isReparenting && !isUnlinkParent || prevParent && (0, $jDUax.isGroupItem)(prevParent))) removeFromCache({
            issueId: item.issueId,
            query: query,
            variables: createVariablesForGroupItem(currentGroupIssueId)
        });
        else if (prevParent && (isReparenting || isUnlinkParent) && !(0, $jDUax.isGroupItem)(prevParent)) removeFromCache({
            issueId: item.issueId,
            query: query,
            variables: createVariablesForItemWithParent(prevParent)
        });
        const groupItem = findGroupById(currentGroupIssueId);
        const prevGrandParent = prevParent ? getParentOfIssueIfExist(prevParent) : undefined;
        if (groupItem) {
            if (prevParent && (isReparenting || isUnlinkParent) && prevGrandParent && removeChildFromParent) // update count of prevParent
            updateItemsInCache({
                query: query,
                variables: (0, $jDUax.isGroupItem)(prevGrandParent) ? createVariablesForGroupItem(prevGrandParent) : createVariablesForItemWithParent(prevGrandParent),
                issueIds: [
                    prevParent
                ],
                updateItem: (existingParentIssue)=>removeChildFromParent(existingParentIssue, 1)
            });
            else if (isChildIssueInGroup(groupItem, item.issueId)) // update totalGroupItems in itemGroups cache.
            updateGroupItemInCache({
                query: groupsQuery,
                variables: createVariablesForGroups(),
                id: groupItem.id,
                updateItem: (group)=>({
                        ...group,
                        totalCount: group.totalCount !== undefined ? Math.max(0, group.totalCount - 1) : undefined
                    })
            });
        }
    };
    const getGroupIssueId = (issueId)=>{
        if ((0, $jDUax.isGroupItem)(issueId)) return issueId;
        const parentId = getParentOfIssueIfExist ? getParentOfIssueIfExist(issueId) : undefined;
        if (!parentId) return null;
        if ((0, $jDUax.isGroupItem)(parentId)) return parentId;
        return getGroupIssueId(parentId);
    };
    const isChildIssueInGroup = (group, childIssueId)=>group.children?.some((issue)=>issue.issueId === childIssueId);
    const addToGroupCache = (items, { updateCountOnly: updateCountOnly = false } = {
        updateCountOnly: false
    })=>{
        items.forEach((item)=>{
            const { isReparenting: isReparenting, currentParent: currentParent, prevParent: prevParent } = getReparentingInfo(item);
            const currentGroupIssueId = prevParent ? getGroupIssueId(prevParent) : undefined;
            const nextGroup = findItemGroup(item);
            if (currentGroupIssueId != null && !updateCountOnly) removeItemFromCache(item, currentGroupIssueId);
            if (nextGroup != null) {
                // check if items data exists in apollo cache, so that updating it won't blow up apollo
                const shouldAddToCache = canUpdateGroupCache(nextGroup.issueId) && !updateCountOnly;
                if (shouldAddToCache) {
                    // add the item to the next group
                    addToCache({
                        newNodes: [
                            item
                        ],
                        query: query,
                        variables: createVariablesForGroupItem(nextGroup.issueId)
                    });
                    // this should not be necessary once background refetch when grouping is working correctly
                    updateIssueParentMap(item.issueId);
                }
                const newGrandParentId = currentParent ? getParentOfIssueIfExist(currentParent) : undefined;
                if (currentParent && isReparenting && newGrandParentId) updateItemsInCache({
                    query: query,
                    variables: (0, $jDUax.isGroupItem)(newGrandParentId) ? createVariablesForGroupItem(newGrandParentId) : createVariablesForItemWithParent(newGrandParentId),
                    issueIds: [
                        currentParent
                    ],
                    updateItem: (existingIssue)=>{
                        const updatedIssueWithNewChild = onUpdateParentWithNewChild(existingIssue, item);
                        return updatedIssueWithNewChild;
                    }
                });
                else // update totalGroupItems in itemGroups cache.
                updateGroupItemInCache({
                    query: groupsQuery,
                    variables: createVariablesForGroups(),
                    id: nextGroup.id,
                    updateItem: (group)=>({
                            ...group,
                            totalCount: group.totalCount !== undefined ? Math.max(0, group.totalCount + 1) : undefined
                        })
                });
            } else {
                const newGroup = createItemGroup(item);
                if (newGroup != null) addGroupItemToCache({
                    query: groupsQuery,
                    variables: createVariablesForGroups(),
                    newNodes: [
                        newGroup
                    ]
                });
            }
        });
    };
    const removeFromGroupCache = (items)=>{
        items.forEach((item)=>{
            const prevParent = getPrevParentOfIssueIfExists(String(item.issueId));
            const currentGroupIssueId = prevParent ? getGroupIssueId(prevParent) : undefined;
            // happens when updating parent but new parent is not expanded
            if (currentGroupIssueId != null) removeItemFromCache(item, currentGroupIssueId);
        });
    };
    return {
        addToCache: addToGroupCache,
        removeFromCache: removeFromGroupCache
    };
};

});

parcelRegister("3xYz2", function(module, exports) {

$parcel$export(module.exports, "useGroupCacheActions", () => $3125aeceaae206dd$export$3083f2cce6510ba2);

var $egmQO = parcelRequire("egmQO");

var $daQYX = parcelRequire("daQYX");

var $kRkJF = parcelRequire("kRkJF");

var $jDUax = parcelRequire("jDUax");

var $dNchx = parcelRequire("dNchx");

var $hlKA4 = parcelRequire("hlKA4");

var $gwNxS = parcelRequire("gwNxS");

var $5fc53 = parcelRequire("5fc53");

var $g5X3G = parcelRequire("g5X3G");

var $koeKL = parcelRequire("koeKL");

var $3WUKM = parcelRequire("3WUKM");

var $gribp = parcelRequire("gribp");

var $ktYkO = parcelRequire("ktYkO");

var $61h55 = parcelRequire("61h55");

var $bsMMx = parcelRequire("bsMMx");

var $tx8ST = parcelRequire("tx8ST");

var $8TUlY = parcelRequire("8TUlY");

var $8e3Yw = parcelRequire("8e3Yw");

var $mH57d = parcelRequire("mH57d");

var $9u99d = parcelRequire("9u99d");

var $aQbWi = parcelRequire("aQbWi");

var $eg2To = parcelRequire("eg2To");
const $3125aeceaae206dd$export$3083f2cce6510ba2 = ({ fieldIds: fieldIds } = {})=>{
    const { addToCache: addToCache, removeFromCache: removeFromCache, updateItemsInCache: updateItemsInCache } = (0, $hlKA4.useCacheActions)();
    const { addGroupItemToCache: addGroupItemToCache, updateGroupItemInCache: updateGroupItemInCache } = (0, $dNchx.useItemGroupsCacheActions)();
    const { hierarchyParent: hierarchyParent } = (0, $mH57d.useHierarchyConfig)();
    const [{ rankParentIssueId: rankParentIssueId }] = (0, $aQbWi.useRankParent)();
    const input = (0, $eg2To.useIssuesInput)({
        groupIssueId: (0, $jDUax.isGroupItem)(rankParentIssueId) ? rankParentIssueId : undefined,
        parentIssueId: !(0, $jDUax.isGroupItem)(rankParentIssueId) ? rankParentIssueId : undefined
    });
    const projectData = (0, $daQYX.useProject)();
    const projectKey = projectData.key;
    const [{ issueParentMap: issueParentMap, issuesMap: issuesMap, childrenItems: childrenItems, hierarchyData: hierarchyData }] = (0, $9u99d.useHierarchyStore)();
    const [groupByFieldId] = (0, $8e3Yw.useGroupBy)();
    const { jqlContext: jqlContext, quickFiltersJql: quickFiltersJql, sorting: sorting, isHidingDoneItems: isHidingDoneItems } = (0, $kRkJF.useFilteredViewContextInput)({
        view: 'list'
    });
    const groupItemsQueryData = childrenItems;
    const groups = hierarchyData.data;
    const cloudId = (0, $koeKL.useCloudId)();
    const { getAvailableFields: getAvailableFields } = (0, $8TUlY.useIssueFields)();
    const availableFields = getAvailableFields();
    const categoryField = availableFields.find((field)=>field?.type === (0, $5fc53.CATEGORY_TYPE));
    const isGroupingByCategory = groupByFieldId === categoryField?.id;
    const [{ hierarchyLevel: hierarchyLevel }] = (0, $tx8ST.useHierarchyLevel)();
    const { addToCache: addToGroupCache, removeFromCache: removeFromGroupCache } = (0, $gwNxS.createGroupingViewUpdaterCacheActions)({
        query: (0, $61h55.LIST_VIEW_QUERY),
        groupsQuery: (0, $3WUKM.LIST_VIEW_ITEM_GROUPS_QUERY),
        addToCache: addToCache,
        removeFromCache: removeFromCache,
        updateItemsInCache: updateItemsInCache,
        addGroupItemToCache: addGroupItemToCache,
        updateGroupItemInCache: updateGroupItemInCache,
        // make sure group items data exists in apollo cache
        canUpdateGroupCache: (groupIssueId)=>groupItemsQueryData ? !!groupItemsQueryData[(0, $g5X3G.toIssueId)(groupIssueId)] : false,
        findItemGroup: (item)=>(0, $ktYkO.findItemGroup)({
                groups: groups,
                groupByFieldId: groupByFieldId,
                item: item,
                isGroupingByCategory: isGroupingByCategory
            }),
        createItemGroup: (item)=>(0, $ktYkO.createItemGroup)({
                groupByFieldId: groupByFieldId,
                item: item
            }),
        findGroupById: (groupIssueId)=>groups?.find((group)=>groupIssueId === (0, $ktYkO.createGroupIssueId)(group.id)),
        createVariablesForGroupItem: (groupIssueId)=>({
                cloudId: cloudId,
                ...(0, $egmQO.getVariables)({
                    jqlContext: jqlContext,
                    fieldIds: fieldIds || input.fieldIds,
                    quickFiltersJql: quickFiltersJql,
                    sorting: sorting,
                    groupQuery: (0, $ktYkO.getGroupQuery)({
                        groups: groups,
                        groupIssueId: groupIssueId,
                        groupByFieldId: groupByFieldId
                    }),
                    hierarchyParent: input.hierarchyParent,
                    isHidingDoneItems: isHidingDoneItems,
                    projectIdOrKey: projectKey
                })
            }),
        createVariablesForGroups: ()=>(0, $gribp.getGroupVariables)({
                groupByFieldId: groupByFieldId,
                jqlContext: jqlContext
            }),
        getParentOfIssueIfExist: (issueId)=>{
            const maybeIssue = issuesMap.get(String(issueId));
            if (!maybeIssue) return undefined;
            return maybeIssue.parentIssueId ?? (0, $jDUax.getParentIssueId)(maybeIssue);
        },
        getPrevParentOfIssueIfExists: (issueId)=>issueParentMap.get(String(issueId)),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onUpdateParentWithNewChild: (0, $bsMMx.addChildToParentListView),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        removeChildFromParent: (0, $bsMMx.removeChildFromParentListView),
        createVariablesForItemWithParent: (parentIssueId)=>{
            if (!hierarchyParent) return {
                ...(0, $egmQO.getVariables)({
                    jqlContext: jqlContext,
                    fieldIds: fieldIds || input.fieldIds,
                    quickFiltersJql: quickFiltersJql,
                    sorting: sorting,
                    hierarchyLevel: hierarchyLevel,
                    hierarchyParent: hierarchyParent,
                    isHidingDoneItems: isHidingDoneItems
                }),
                cloudId: cloudId
            };
            return {
                ...(0, $egmQO.getVariables)({
                    jqlContext: jqlContext,
                    fieldIds: fieldIds || input.fieldIds,
                    quickFiltersJql: quickFiltersJql,
                    sorting: sorting,
                    isHidingDoneItems: isHidingDoneItems,
                    hierarchyParent: undefined,
                    parentIssue: {
                        hierarchyType: hierarchyParent,
                        issueId: parentIssueId
                    }
                }),
                cloudId: cloudId
            };
        },
        // note that prevParent will be undefined if the prevParent is not expanded or does not exist
        updateIssueParentMap: (issueId, newParentId)=>{
            if (newParentId) issueParentMap.set(String(issueId), String(newParentId));
            else issueParentMap.delete(String(issueId));
        }
    });
    return {
        addToGroupCache: addToGroupCache,
        removeFromGroupCache: removeFromGroupCache
    };
};

});
parcelRegister("dNchx", function(module, exports) {

$parcel$export(module.exports, "useItemGroupsCacheActions", () => $62cdbc15a2470d27$export$a49f2fc3773a6a0f);

var $5uXOq = parcelRequire("5uXOq");

var $5tTFS = parcelRequire("5tTFS");

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $62cdbc15a2470d27$export$a49f2fc3773a6a0f = ()=>{
    const analyticsTaskName = 'useItemGroupsCacheActionsApolloCacheActions';
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const client = (0, $5tTFS.useApolloClient)();
    const updateGroupItemInCache = (0, $5uXOq.useCallback)(({ query: query, variables: variables, id: id, updateItem: updateItem })=>{
        const getCachedListData = ()=>{
            try {
                const read = client.readQuery({
                    query: query,
                    variables: variables
                });
                (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheRead taskSuccess', {
                    task: analyticsTaskName
                });
                return read;
            } catch (e) {
                (0, $jcw0u.default)({
                    error: e instanceof Error ? e : new Error('Unknown cache read error'),
                    meta: {
                        id: 'updateGroupItemInCache',
                        packageName: 'jiraBusinessListHandlers',
                        teamName: 'keystone'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true,
                    attributes: {
                        task: analyticsTaskName,
                        query: JSON.stringify(query),
                        variables: JSON.stringify(variables),
                        eventName: 'apolloCacheRead taskFail',
                        error: JSON.stringify(e)
                    }
                });
                return null;
            }
        };
        const data = getCachedListData();
        const existingNodes = data?.groups.nodes;
        if (existingNodes == null) return;
        const itemToUpdateIndex = existingNodes.findIndex((issue)=>issue?.id === id) ?? undefined;
        const existingItem = existingNodes[itemToUpdateIndex];
        if (itemToUpdateIndex === undefined || itemToUpdateIndex === -1 || existingItem == null) return;
        const itemOverride = updateItem(existingItem);
        if (itemOverride === undefined) return;
        const newNodes = [
            ...existingNodes
        ];
        newNodes[itemToUpdateIndex] = itemOverride;
        try {
            client.writeQuery({
                query: query,
                variables: variables,
                // @ts-expect-error - TS2345 - Argument of type '{ query: DocumentNode; variables: GenericGroupVariables; notifyOnNetworkStatusChange: boolean; data: { groups: { nodes: (TIssueNode | null | undefined)[]; }; }; }' is not assignable to parameter of type 'WriteQueryOptions<{ groups: { nodes: (TIssueNode | null | undefined)[]; }; }, GenericGroupVariables>'.
                notifyOnNetworkStatusChange: true,
                data: {
                    ...data,
                    groups: {
                        ...data?.groups || {},
                        nodes: newNodes
                    }
                }
            });
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheWrite taskSuccess', {
                task: analyticsTaskName
            });
        } catch (e) {
            (0, $jcw0u.default)({
                error: e instanceof Error ? e : new Error('Unknown cache write error'),
                meta: {
                    id: 'updateGroupItemInCache',
                    packageName: 'jiraBusinessListHandlers',
                    teamName: 'keystone'
                },
                sendToPrivacyUnsafeSplunk: true,
                skipSentry: true,
                attributes: {
                    task: analyticsTaskName,
                    query: JSON.stringify(query),
                    variables: JSON.stringify(variables),
                    eventName: 'apolloCacheWrite taskFail',
                    error: JSON.stringify(e)
                }
            });
        }
    }, [
        client,
        createAnalyticsEvent
    ]);
    const addGroupItemToCache = (0, $5uXOq.useCallback)(({ query: query, variables: variables, newNodes: newNodes })=>{
        const getCachedListData = ()=>{
            try {
                const read = client.readQuery({
                    query: query,
                    variables: variables
                });
                (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheRead taskSuccess', {
                    task: analyticsTaskName
                });
                return read;
            } catch (e) {
                (0, $jcw0u.default)({
                    error: e instanceof Error ? e : new Error('Unknown cache read error'),
                    meta: {
                        id: 'addGroupItemToCache',
                        packageName: 'jiraBusinessListHandlers',
                        teamName: 'keystone'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true,
                    attributes: {
                        task: analyticsTaskName,
                        query: JSON.stringify(query),
                        variables: JSON.stringify(variables),
                        eventName: 'apolloCacheRead taskFail',
                        error: JSON.stringify(e)
                    }
                });
                return null;
            }
        };
        const data = getCachedListData();
        if (data == null || data.groups == null || !Array.isArray(newNodes) || newNodes.length === 0 || !Array.isArray(newNodes)) return;
        const newGroupsIds = new Set(newNodes.map((item)=>item != null && item.id != null ? item.id : undefined).filter(Boolean));
        if (data == null || data.groups == null || !Array.isArray(data.groups.nodes)) return;
        try {
            const newGroups = data.groups.nodes.filter((node)=>node != null && node.id != null && !newGroupsIds.has(node.id)).concat(newNodes) ?? [];
            client.writeQuery({
                query: query,
                variables: variables,
                data: {
                    ...data,
                    groups: {
                        ...data.groups,
                        nodes: newGroups
                    }
                }
            });
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheWrite taskSuccess', {
                task: analyticsTaskName
            });
        } catch (e) {
            (0, $jcw0u.default)({
                error: e instanceof Error ? e : new Error('Unknown cache write error'),
                meta: {
                    id: 'addGroupItemToCache',
                    packageName: 'jiraBusinessListHandlers',
                    teamName: 'keystone'
                },
                sendToPrivacyUnsafeSplunk: true,
                skipSentry: true,
                attributes: {
                    task: analyticsTaskName,
                    query: JSON.stringify(query),
                    variables: JSON.stringify(variables),
                    eventName: 'apolloCacheWrite taskFail',
                    error: JSON.stringify(e)
                }
            });
        }
    }, [
        client,
        createAnalyticsEvent
    ]);
    return {
        updateGroupItemInCache: updateGroupItemInCache,
        addGroupItemToCache: addGroupItemToCache
    };
};

});

parcelRegister("aQbWi", function(module, exports) {

$parcel$export(module.exports, "useRankParent", () => $57f47ab7dd554ef0$export$70ab091cfa570abd);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $57f47ab7dd554ef0$var$actions = {
    setRankParentIssueId: (rankParentIssueId)=>({ setState: setState })=>setState({
                rankParentIssueId: rankParentIssueId
            })
};
const $57f47ab7dd554ef0$var$Store = (0, $iXqE5.createStore)({
    initialState: {
        rankParentIssueId: null
    },
    actions: $57f47ab7dd554ef0$var$actions,
    name: 'JBusListViewRankParentIssueIdStore'
});
const $57f47ab7dd554ef0$export$70ab091cfa570abd = (0, $3sQ5x.createHook)($57f47ab7dd554ef0$var$Store);

});

parcelRegister("eg2To", function(module, exports) {

$parcel$export(module.exports, "useIssuesInput", () => $0f1e3192f550f0e8$export$242d22b97c239de6);

var $daQYX = parcelRequire("daQYX");

var $kRkJF = parcelRequire("kRkJF");

var $ktYkO = parcelRequire("ktYkO");

var $tx8ST = parcelRequire("tx8ST");

var $8TUlY = parcelRequire("8TUlY");

var $8e3Yw = parcelRequire("8e3Yw");

var $mH57d = parcelRequire("mH57d");

var $9u99d = parcelRequire("9u99d");
const $0f1e3192f550f0e8$export$242d22b97c239de6 = (options)=>{
    const { groupIssueId: groupIssueId, parentIssueId: parentIssueId } = options || {};
    const [{ hierarchyLevel: hierarchyLevel }] = (0, $tx8ST.useHierarchyLevel)();
    const [{ hierarchyData: hierarchyData }] = (0, $9u99d.useHierarchyStore)();
    const { jqlContext: jqlContext, quickFiltersJql: quickFiltersJql, isHidingDoneItems: isHidingDoneItems } = (0, $kRkJF.useFilteredViewContextInput)({
        view: 'list'
    });
    const { hierarchyParent: hierarchyParent } = (0, $mH57d.useHierarchyConfig)();
    const { getQueryFieldIds: getQueryFieldIds, isParentFieldVisible: isParentFieldVisible, isDevSummaryFieldVisible: isDevSummaryFieldVisible } = (0, $8TUlY.useIssueFields)();
    const groups = hierarchyData.data;
    const [groupByFieldId] = (0, $8e3Yw.useGroupBy)();
    const projectData = (0, $daQYX.useProject)();
    const projectKey = projectData.key;
    let input = {
        jqlContext: jqlContext,
        quickFiltersJql: quickFiltersJql,
        projectIdOrKey: projectKey,
        fieldIds: getQueryFieldIds(),
        isHidingDoneItems: isHidingDoneItems,
        isParentFieldVisible: isParentFieldVisible(),
        isDevSummaryFieldVisible: isDevSummaryFieldVisible()
    };
    if (groupIssueId != null) input = {
        ...input,
        hierarchyParent: hierarchyParent,
        groupQuery: (0, $ktYkO.getGroupQuery)({
            groupIssueId: groupIssueId,
            groupByFieldId: groupByFieldId,
            groups: groups
        })
    };
    else if (parentIssueId != null && hierarchyParent != null) input = {
        ...input,
        hierarchyParent: undefined,
        parentIssue: {
            hierarchyType: hierarchyParent,
            issueId: parentIssueId
        }
    };
    else {
        input.hierarchyLevel = hierarchyLevel;
        input.hierarchyParent = hierarchyParent;
    }
    return input;
};

});


parcelRegister("dvriG", function(module, exports) {

$parcel$export(module.exports, "useSupportedFieldIds", () => $62b3f66933d336ef$export$ec520f6de95e7778);

var $5uXOq = parcelRequire("5uXOq");

var $eTDjN = parcelRequire("eTDjN");

var $8TUlY = parcelRequire("8TUlY");
const $62b3f66933d336ef$export$ec520f6de95e7778 = ()=>{
    const { getQueryFieldIds: getQueryFieldIds, getAvailableFields: getAvailableFields } = (0, $8TUlY.useIssueFields)();
    const queryFieldIds = getQueryFieldIds();
    return (0, $5uXOq.useMemo)(()=>[
            ...queryFieldIds,
            ...getAvailableFields().filter((field)=>field.type ? !queryFieldIds.includes(field.id) && (0, $eTDjN.SUPPORTED_GROUPS_TYPES).includes(field.type) : false).map((field)=>field.id)
        ], [
        getAvailableFields,
        queryFieldIds
    ]);
};

});



parcelRegister("dvvS3", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c7eb75530dece9b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5c7eb75530dece9b$var$ListActionsBanner = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("e3gwm")), {
    ssr: false,
    moduleId: "./src/packages/business/list/src/controllers/list-actions-banner/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5c7eb75530dece9b$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "list-actions-banner",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5c7eb75530dece9b$var$ListActionsBanner, props));

});
parcelRegister("e3gwm", function(module, exports) {

let $a3ae29351268e11f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a3ae29351268e11f$var$load("8yeQ4").then(()=>parcelRequire('5wbFn'));

});


parcelRegister("5t2X8", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ab4865a45b6485e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $6ab4865a45b6485e$var$ListViewUpdater = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("bclCz")), {
    ssr: false,
    moduleId: "./src/packages/business/list/src/controllers/list-updater/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6ab4865a45b6485e$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "list-view-updater",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6ab4865a45b6485e$var$ListViewUpdater, props));

});
parcelRegister("bclCz", function(module, exports) {

let $82719638f38e31c0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $82719638f38e31c0$var$load("5DRAU").then(()=>parcelRequire('krSOQ'));

});


parcelRegister("hb2SN", function(module, exports) {

$parcel$export(module.exports, "useReparentModalStore", () => $4948937417ccdc13$export$2e755c9651c94d7f);
$parcel$export(module.exports, "useShouldShowReparentModal", () => $4948937417ccdc13$export$bb435bd62aedac9f);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $4948937417ccdc13$var$actions = {
    openReparentModal: (issueIdToReparent)=>({ setState: setState })=>{
            setState({
                issueIdToReparent: issueIdToReparent
            });
        },
    closeReparentModal: ()=>({ setState: setState })=>{
            setState({
                issueIdToReparent: null
            });
        }
};
const $4948937417ccdc13$var$ReparentModalStore = (0, $iXqE5.createStore)({
    initialState: {
        issueIdToReparent: null
    },
    actions: $4948937417ccdc13$var$actions,
    name: 'JWMReparentModal'
});
const $4948937417ccdc13$export$2e755c9651c94d7f = (0, $3sQ5x.createHook)($4948937417ccdc13$var$ReparentModalStore);
const $4948937417ccdc13$export$e88c9698e4ec8c24 = (state)=>state.issueIdToReparent != null;
const $4948937417ccdc13$export$bb435bd62aedac9f = (0, $3sQ5x.createHook)($4948937417ccdc13$var$ReparentModalStore, {
    selector: $4948937417ccdc13$export$e88c9698e4ec8c24
});

});

parcelRegister("j2Xxu", function(module, exports) {

$parcel$export(module.exports, "useTableAnalytics", () => $2b851d25530fa3ca$export$d0703a75f31864f4);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $2LpEi = parcelRequire("2LpEi");
const $2b851d25530fa3ca$export$d0703a75f31864f4 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [{ tableRef: tableRef }] = (0, $2LpEi.useTableRefStore)();
    const tableInitialised = (0, $5uXOq.useRef)(false);
    const _columns = tableRef.current?.getColumnManager()?._columns;
    const columns = (0, $5uXOq.useMemo)(()=>_columns ?? [], [
        _columns
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!tableInitialised.current && columns.length > 0) {
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'table init', {
                numberOfColumns: columns.length
            });
            tableInitialised.current = true;
        }
    }, [
        columns.length,
        createAnalyticsEvent
    ]);
};

});
parcelRegister("2LpEi", function(module, exports) {

$parcel$export(module.exports, "useTableRefStore", () => $cc7f9390c2d8a809$export$18c478ca7c21c86a);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $cc7f9390c2d8a809$var$actions = {
    setTableRef: (tableRef)=>({ setState: setState })=>{
            setState({
                tableRef: tableRef
            });
        }
};
const $cc7f9390c2d8a809$var$TableRefStore = (0, $iXqE5.createStore)({
    initialState: {
        tableRef: {
            current: null
        }
    },
    actions: $cc7f9390c2d8a809$var$actions,
    name: 'JWMTableRef'
});
const $cc7f9390c2d8a809$export$18c478ca7c21c86a = (0, $3sQ5x.createHook)($cc7f9390c2d8a809$var$TableRefStore);

});


parcelRegister("7G4Lw", function(module, exports) {

$parcel$export(module.exports, "useClearStaleGroupBy", () => $ecb5c32198935408$export$33497e7241a3f128);

var $5uXOq = parcelRequire("5uXOq");

var $8TUlY = parcelRequire("8TUlY");

var $8e3Yw = parcelRequire("8e3Yw");
const $ecb5c32198935408$export$33497e7241a3f128 = ({ onClear: onClear })=>{
    const [groupByFieldId, setGroupBy] = (0, $8e3Yw.useGroupBy)();
    const { getAvailableFields: getAvailableFields, loading: loading } = (0, $8TUlY.useIssueFields)();
    const availableFields = getAvailableFields();
    (0, $5uXOq.useEffect)(()=>{
        if (!groupByFieldId || loading) return;
        const isGroupedFieldAvailable = availableFields.some((field)=>field.id === groupByFieldId);
        if (!isGroupedFieldAvailable) {
            setGroupBy(undefined);
            onClear();
        }
    }, [
        groupByFieldId,
        setGroupBy,
        availableFields,
        loading,
        onClear
    ]);
    return null;
};

});

parcelRegister("7pW4c", function(module, exports) {

$parcel$export(module.exports, "useIssueUpdated", () => $e768416e23dc9126$export$5ed6d188c4dd5d1d);

var $5uXOq = parcelRequire("5uXOq");

var $5fc53 = parcelRequire("5fc53");

var $aMwM1 = parcelRequire("aMwM1");
const $e768416e23dc9126$var$canRemoveIssue = ({ fieldType: fieldType, issueKey: issueKey, newValue: newValue, oldValue: oldValue })=>{
    switch(fieldType){
        case 0, $5fc53.PARENT_TYPE:
            {
                const currentProject = (issueKey ?? '').split('-')[0];
                const oldValueProjectKey = (oldValue?.key ?? '').split('-')[0];
                const newValueProjectKey = (newValue?.key ?? '').split('-')[0];
                if (// parent from foreign project is assigned
                !oldValue?.value && newValueProjectKey !== currentProject || // parent from foreign project is unlinked
                !newValue?.value && oldValueProjectKey !== currentProject) return false;
                return newValue?.value !== oldValue?.value;
            }
        default:
            return false;
    }
};
const $e768416e23dc9126$export$5ed6d188c4dd5d1d = ()=>{
    const { onIssueRemoved: onIssueRemoved } = (0, $aMwM1.useListViewUpdaterService)();
    const onIssueUpdated = (0, $5uXOq.useCallback)(({ issueKey: issueKey, issueId: issueId, fieldType: fieldType, newValue: newValue, oldValue: oldValue })=>{
        if ($e768416e23dc9126$var$canRemoveIssue({
            issueKey: issueKey,
            fieldType: fieldType,
            newValue: newValue,
            oldValue: oldValue
        })) onIssueRemoved({
            issueId: Number(issueId),
            parentId: oldValue?.value ?? undefined
        });
    }, [
        onIssueRemoved
    ]);
    return {
        onIssueUpdated: onIssueUpdated
    };
};

});

parcelRegister("gP1aD", function(module, exports) {

$parcel$export(module.exports, "useUpdateCommentsCellCache", () => $eecceb33b349fc18$export$abd1cc6872440893);

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $hlKA4 = parcelRequire("hlKA4");

var $9u99d = parcelRequire("9u99d");

var $61h55 = parcelRequire("61h55");
const $eecceb33b349fc18$export$abd1cc6872440893 = ()=>{
    const { updateItemsInCache: updateItemsInCache } = (0, $hlKA4.useCacheActions)();
    const [{ issuesMap: issuesMap }] = (0, $9u99d.useHierarchyStore)();
    const updateCommentsCache = (0, $5uXOq.useCallback)((issueKey, updatedValue = false)=>{
        // early return if it fails the experiment check
        if (!(0, $6s1PB.expVal)('jira_unread_comments_in_list_view', 'isEnabled', false)) return;
        const issueInCache = [
            ...issuesMap.values()
        ].find((issue)=>issue.key === issueKey);
        // early return if no cached issue
        if (!issueInCache) return;
        updateItemsInCache({
            query: (0, $61h55.LIST_VIEW_QUERY),
            issueIds: [
                issueInCache.issueId
            ],
            variables: {
                ...issueInCache.cacheVariables,
                isUnreadCommentsEnabled: true,
                includeIsVerifiedInTeamFragment: (0, $4R6GH.fg)('is-verified-in-business-team-field-fragment')
            },
            updateItem: (item)=>{
                return {
                    ...item,
                    ...item.commentSummary ? {
                        commentSummary: {
                            ...item.commentSummary,
                            hasUnreadComment: updatedValue
                        }
                    } : {}
                };
            }
        });
    }, [
        issuesMap,
        updateItemsInCache
    ]);
    return {
        updateCommentsCache: updateCommentsCache
    };
};

});

parcelRegister("5bYhZ", function(module, exports) {

$parcel$export(module.exports, "BaseTable", () => $2419d18feedd8ecf$export$e869e821efc59136);
$parcel$export(module.exports, "MemoizedBaseTable", () => $2419d18feedd8ecf$export$ab6f8c35c2816088);

var $5uXOq = parcelRequire("5uXOq");

var $7EOTc = parcelRequire("7EOTc");
const $2419d18feedd8ecf$export$e869e821efc59136 = (props)=>{
    (0, $5uXOq.useEffect)(()=>{
        // preload components required for initial render
        (0, $7EOTc.Table).preload();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7EOTc.default), props);
};
const $2419d18feedd8ecf$export$ab6f8c35c2816088 = /*#__PURE__*/ (0, $5uXOq.memo)($2419d18feedd8ecf$export$e869e821efc59136);

});
parcelRegister("7EOTc", function(module, exports) {

$parcel$export(module.exports, "Table", () => $9c8b8cb8c940984c$export$54ec01a60f47d33d);
$parcel$export(module.exports, "default", () => $9c8b8cb8c940984c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $ihWa4 = parcelRequire("ihWa4");

const $9c8b8cb8c940984c$export$54ec01a60f47d33d = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("bvKGR")), {
    moduleId: "./src/packages/business/list/src/ui/list-view/base-table/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9c8b8cb8c940984c$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "base-table",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ihWa4.LoadingTable), props)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9c8b8cb8c940984c$export$54ec01a60f47d33d, props));

});
parcelRegister("ihWa4", function(module, exports) {

$parcel$export(module.exports, "LoadingTable", () => $6b3086f0727377e7$export$b353ee8dbb8fb09e);

var $5uXOq = parcelRequire("5uXOq");

var $lob44 = parcelRequire("lob44");

var $i63x4 = parcelRequire("i63x4");
const $6b3086f0727377e7$var$getRowSkeleton = (columns, rowHeight, // eslint-disable-next-line @typescript-eslint/no-explicit-any
SkeletonRow, // eslint-disable-next-line @typescript-eslint/no-explicit-any
SkeletonField, key = 0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SkeletonRow, {
        key: key
    }, columns.map((column)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SkeletonField, {
            key: column.key,
            height: rowHeight,
            width: column.width
        })));
const $6b3086f0727377e7$var$getLoadingSkeleton = (columns, rowHeight, // eslint-disable-next-line @typescript-eslint/no-explicit-any
SkeletonRow, // eslint-disable-next-line @typescript-eslint/no-explicit-any
SkeletonField)=>Array.from({
        length: 20
    }, (_, i)=>$6b3086f0727377e7$var$getRowSkeleton(columns, rowHeight, SkeletonRow, SkeletonField, i));
const $6b3086f0727377e7$export$b353ee8dbb8fb09e = /*#__PURE__*/ (0, $5uXOq.memo)(({ columns: columns, rowHeight: rowHeight })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i63x4.Wrapper), null, columns.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i63x4.TableWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i63x4.LoadingRow), {
        key: "loading-header-row"
    }, columns.map((column)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i63x4.LoadingWrapper), {
            key: column.key
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i63x4.LoadingIcon), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i63x4.LoadingField), {
            // @ts-expect-error - Type 'number | undefined' is not assignable to type 'number'.
            height: rowHeight,
            width: column.width - (0, $i63x4.ICON_OFFSET)
        })))), $6b3086f0727377e7$var$getLoadingSkeleton(columns, rowHeight, (0, $i63x4.LoadingRow), (0, $i63x4.LoadingField))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i63x4.SpinnerWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lob44.ThemedSpinner), null))), (prevProps, nextProps)=>prevProps.columns.length === nextProps.columns.length);

});
parcelRegister("i63x4", function(module, exports) {

$parcel$export(module.exports, "LoadingRow", () => $291a4f365813f7cf$export$d1e723d3001badba);
$parcel$export(module.exports, "LoadingField", () => $291a4f365813f7cf$export$2304bbb03949f4f1);
$parcel$export(module.exports, "ICON_OFFSET", () => $291a4f365813f7cf$export$382610e783aa2ae8);
$parcel$export(module.exports, "LoadingWrapper", () => $291a4f365813f7cf$export$43a792a870d28db2);
$parcel$export(module.exports, "LoadingIcon", () => $291a4f365813f7cf$export$b936c55164dcf1db);
$parcel$export(module.exports, "Wrapper", () => $291a4f365813f7cf$export$e6dfd72ab29f8598);
$parcel$export(module.exports, "SpinnerWrapper", () => $291a4f365813f7cf$export$52b4dfd89a6b3a1b);
$parcel$export(module.exports, "TableWrapper", () => $291a4f365813f7cf$export$4267411171632d35);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $gwIPs = parcelRequire("gwIPs");
const $291a4f365813f7cf$var$LOADING_VIEW_HEIGHT = '76vh';
const $291a4f365813f7cf$export$d1e723d3001badba = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y",
            __cmplp.className
        ])
    });
});
const $291a4f365813f7cf$export$2304bbb03949f4f1 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1rjw0ur": (0, $lD23V.default)(`${__cmplp.width - (0, $gwIPs.gridSize) * 2}px`),
            "--_mkz9at": (0, $lD23V.default)(`${__cmplp.height - (0, $gwIPs.gridSize) * 2}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1sit _1bsbra4q _4t3i2wna _bfhkvuon _19pku2gc _2hwxu2gc _otyru2gc _18u0u2gc _19bvv77o",
            __cmplp.className
        ])
    });
});
const $291a4f365813f7cf$var$ICON_SIZE = 24;
const $291a4f365813f7cf$export$382610e783aa2ae8 = $291a4f365813f7cf$var$ICON_SIZE + (0, $gwIPs.gridSize) * 2;
const $291a4f365813f7cf$export$43a792a870d28db2 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $291a4f365813f7cf$export$b936c55164dcf1db = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1sit _1e0c1txw _1bsb1tcg _4t3i1tcg _bfhkn82g _19pku2gc _2hwxu2gc _otyru2gc _18u0u2gc",
            __cmplp.className
        ])
    });
});
const $291a4f365813f7cf$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoftgi _1reo15vq _18m915vq _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $291a4f365813f7cf$export$52b4dfd89a6b3a1b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _1bah1h6o _4cvr1h6o _1tkeo1og",
            __cmplp.className
        ])
    });
});
const $291a4f365813f7cf$export$4267411171632d35 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _bfhkvuon _1e0c1ule _4t3io1og",
            __cmplp.className
        ])
    });
});

});


parcelRegister("bvKGR", function(module, exports) {

let $8616cea94a9750df$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8616cea94a9750df$var$load("2U0D6").then(()=>parcelRequire('fIVjM'));

});



parcelRegister("2CfGf", function(module, exports) {

$parcel$export(module.exports, "getColumnVisibilityIndexes", () => $ee7d1ec793425b8d$export$2b4b1825d849585e);
$parcel$export(module.exports, "useHighlightDoneItems", () => $ee7d1ec793425b8d$export$10dde765bae17fce);
$parcel$export(module.exports, "calculateIssuesHeight", () => $ee7d1ec793425b8d$export$e12173811eb87ac);
$parcel$export(module.exports, "getIssueCreateRankBefore", () => $ee7d1ec793425b8d$export$963872cb9359ad45);
$parcel$export(module.exports, "getTotalfooterHeight", () => $ee7d1ec793425b8d$export$de7e7bee3c77500a);
$parcel$export(module.exports, "getIsAiwbInListViewEnabled", () => $ee7d1ec793425b8d$export$7642df937ccaca57);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $33Toe = parcelRequire("33Toe");

var $g5X3G = parcelRequire("g5X3G");

var $6s1PB = parcelRequire("6s1PB");

var $3fT9O = parcelRequire("3fT9O");

var $9eTTF = parcelRequire("9eTTF");
const $ee7d1ec793425b8d$export$2b4b1825d849585e = (0, $8QpSo.default)((scrollLeft, tableWidth, columns)=>{
    const leftEdge = scrollLeft;
    const rightEdge = scrollLeft + tableWidth;
    const visibleColumnsIdx = [];
    const invisibleColumnsIdx = [];
    let totalOffset = 0;
    const columnsOffset = columns.reduce((acc, column)=>{
        acc.push(totalOffset);
        totalOffset += column.width;
        return acc;
    }, []);
    columnsOffset.forEach((columnOffset, colIdx)=>{
        const isNotVisible = columnOffset + columns[colIdx].width < leftEdge || columnOffset > rightEdge;
        isNotVisible ? invisibleColumnsIdx.push(colIdx) : visibleColumnsIdx.push(colIdx);
    });
    return {
        visibleColumns: visibleColumnsIdx,
        invisibleColumns: invisibleColumnsIdx
    };
});
const $ee7d1ec793425b8d$export$10dde765bae17fce = ()=>{
    const [highlightedIssues, setHightlightedIssues] = (0, $5uXOq.useState)({});
    const toggleHighlightRow = (0, $5uXOq.useCallback)((issueKey, value, timeout = 5000)=>{
        setHightlightedIssues((prev)=>({
                ...prev,
                [issueKey]: value
            }));
        if (value) // using a timer here to clean up the object instead of tiying it to the unmount of the row because base-table unmounts rows due to virtualisation.
        setTimeout(()=>{
            setHightlightedIssues((prevState)=>{
                const newState = {
                    ...prevState
                };
                delete newState[issueKey];
                return newState;
            });
        }, timeout);
    }, []);
    const getRowClassName = (0, $5uXOq.useCallback)(({ rowData: rowData })=>highlightedIssues[rowData.key] && 'highlight', [
        highlightedIssues
    ]);
    return {
        toggleHighlightRow: toggleHighlightRow,
        getRowClassName: getRowClassName
    };
};
const $ee7d1ec793425b8d$export$e12173811eb87ac = (issues, rowHeight, expandedItems, expandedGroups)=>issues.reduce((totalHeight, issue)=>{
        let accumulatedHeight = totalHeight;
        accumulatedHeight += rowHeight;
        // add the total heights of all expanded children
        if (issue.children && issue.children.length > 0 && (expandedItems && expandedItems[(0, $g5X3G.toIssueId)(issue.issueId)] === true || expandedGroups && expandedGroups[(0, $g5X3G.toIssueId)(issue.issueId)] === true)) accumulatedHeight += $ee7d1ec793425b8d$export$e12173811eb87ac(issue.children, rowHeight, expandedItems, expandedGroups);
        return accumulatedHeight;
    }, 0);
const $ee7d1ec793425b8d$export$963872cb9359ad45 = ({ items: items, startIndex: startIndex })=>{
    let rankBefore;
    const itemsCount = items?.length ?? 0;
    if (itemsCount > 0) for(let i = startIndex; i < itemsCount; i++){
        const { issueId: issueId, rank: rank } = items[i];
        const isItemAnIssue = !(0, $33Toe.isOptimisticIssue)(issueId) && !(0, $9eTTF.isEmptyRow)(String(issueId)) && !(0, $3fT9O.isItemAnInlineCreate)(String(issueId)) && !(0, $3fT9O.isItemShowMore)(String(issueId));
        if (isItemAnIssue) {
            rankBefore = {
                issueId: String(issueId),
                rank: rank
            };
            break;
        }
    }
    return rankBefore;
};
const $ee7d1ec793425b8d$export$de7e7bee3c77500a = ({ isGrouping: isGrouping, canCreateIssues: canCreateIssues })=>{
    return isGrouping || !canCreateIssues ? 0 : 40;
};
const $ee7d1ec793425b8d$export$7642df937ccaca57 = ()=>{
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('aiwb_in_list_view_experiment');
    return expConfig.get('isEnabled', false);
};

});
parcelRegister("9eTTF", function(module, exports) {

$parcel$export(module.exports, "isEmptyRow", () => $372e6f5f965af8b8$export$ee1d59c3151f153d);

var $jDUax = parcelRequire("jDUax");

var $g5X3G = parcelRequire("g5X3G");

var $3fT9O = parcelRequire("3fT9O");

var $3rO9r = parcelRequire("3rO9r");
const $372e6f5f965af8b8$export$36f6900d705f61ab = ({ data: data, childrenQueryData: childrenQueryData, rowCreateState: rowCreateState, setRowCreatePosition: setRowCreatePosition, setIssueExpanded: setIssueExpanded, groups: groups, groupItemsQueryData: groupItemsQueryData })=>{
    const issuesMap = new Map();
    const addAndReturnIssue = (issue)=>{
        issuesMap.set(String(issue.issueId), issue);
        return issue;
    };
    const convertListViewIssueToListViewControllerData = ({ issue: issue, children: children, issueHasChildCreateOpen: issueHasChildCreateOpen, canCreateChild: canCreateChild, rankIndex: rankIndex, parentIssueId: parentIssueId })=>{
        if ((0, $jDUax.isGroupItem)(issue.issueId) && groupItemsQueryData) return addAndReturnIssue({
            ...issue,
            rankIndex: rankIndex,
            children: issueHasChildCreateOpen ? [
                (0, $3fT9O.createRowForInlineCreate)('group'),
                ...children || []
            ] : children
        });
        if (childrenQueryData) return addAndReturnIssue({
            ...issue,
            rankIndex: rankIndex,
            parentIssueId: parentIssueId,
            children: issueHasChildCreateOpen ? [
                ...children || [],
                (0, $3fT9O.createRowForInlineCreate)('subtask')
            ] : children,
            onChildCreateButtonClicked: canCreateChild ? ()=>{
                setRowCreatePosition({
                    parentId: issue.issueId
                });
                if (setIssueExpanded) setIssueExpanded((0, $g5X3G.toIssueId)(issue.issueId), true);
            } : undefined
        });
        return addAndReturnIssue({
            ...issue,
            rankIndex: rankIndex
        });
    };
    const isGrouping = typeof groups !== 'undefined' ? groups.length > 0 : false;
    if (isGrouping && !groupItemsQueryData || !childrenQueryData) return {
        convertedData: data.map((issue, index)=>convertListViewIssueToListViewControllerData({
                issue: issue,
                children: undefined,
                issueHasChildCreateOpen: false,
                canCreateChild: false,
                rankIndex: index,
                parentIssueId: undefined
            })),
        issuesMap: issuesMap
    };
    const items = isGrouping ? groups : data;
    const convertedData = (items || []).map((issue, index)=>{
        // TODO https://jbusiness.atlassian.net/browse/JET-1723 need to convert to string
        const { issueId: issueIdNumber, childSummary: childSummary } = issue;
        const issueId = String(issueIdNumber);
        const { parentId: parentId } = rowCreateState;
        const issueHasChildCreateOpen = parentId === issue.issueId;
        const hasNoChildren = !childSummary?.hasChildren;
        if (hasNoChildren) return convertListViewIssueToListViewControllerData({
            issue: issue,
            children: undefined,
            issueHasChildCreateOpen: issueHasChildCreateOpen,
            canCreateChild: true,
            parentIssueId: undefined,
            rankIndex: index
        });
        // Getting children from either GroupQueryData or ChildrenQueryData and merging them with items
        let children;
        const childIssuesData = childrenQueryData ? childrenQueryData[issue.issueId] : undefined;
        const groupItemsData = groupItemsQueryData ? groupItemsQueryData[issue.issueId] : undefined;
        const childItemsData = isGrouping ? groupItemsData : childIssuesData;
        const loading = isGrouping ? !groupItemsData || groupItemsData?.loading : !childIssuesData || childIssuesData?.loading;
        if (loading === true) children = [
            (0, $3fT9O.createItemSkeleton)({
                issueId: issueId
            })
        ];
        else children = childItemsData ? childItemsData.data.map((childIssue, childIndex)=>{
            const convertedChildIssue = convertListViewIssueToListViewControllerData({
                issue: childIssue,
                // TODO remove undefined children for recursive call once we introduce multiple hierarchy levels
                children: undefined,
                issueHasChildCreateOpen: false,
                // children items cannot create child anymore, TODO when multiple hierarchy introduced, this logic will need to change
                canCreateChild: false,
                parentIssueId: issueId,
                rankIndex: childIndex
            });
            return convertedChildIssue;
        }) : [];
        const convertedIssue = convertListViewIssueToListViewControllerData({
            issue: issue,
            children: children,
            issueHasChildCreateOpen: issueHasChildCreateOpen,
            canCreateChild: true,
            parentIssueId: undefined,
            rankIndex: index
        });
        return convertedIssue;
    });
    return {
        convertedData: convertedData,
        issuesMap: issuesMap
    };
};
const $372e6f5f965af8b8$var$EMTPY_ROW_PREFIX = 'EMPTY_ROW';
const $372e6f5f965af8b8$export$ee1d59c3151f153d = (issueId = '')=>issueId.toString().startsWith($372e6f5f965af8b8$var$EMTPY_ROW_PREFIX);
const $372e6f5f965af8b8$export$4293a35894588c6e = [
    {
        id: '',
        rowKey: $372e6f5f965af8b8$var$EMTPY_ROW_PREFIX,
        issueId: $372e6f5f965af8b8$var$EMTPY_ROW_PREFIX,
        typeId: '',
        issuetype: {},
        key: '',
        rank: '',
        rankIndex: -1,
        status: {
            categoryId: '',
            name: ''
        },
        totalSubtasks: 0,
        cacheVariables: (0, $3rO9r.DEFAULT_CACHE_VARIABLES)
    }
];

});


parcelRegister("fX4kd", function(module, exports) {

$parcel$export(module.exports, "default", () => $81b26d5d56c1748a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $81b26d5d56c1748a$var$LazyBulkDeleteModal = (0, $kxZPA.lazy)(()=>(parcelRequire("5ckZ8")), {
    ssr: false,
    moduleId: "./src/packages/business/list/src/ui/list-view/bulk-delete-modal/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$81b26d5d56c1748a$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "bulk-delete-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($81b26d5d56c1748a$var$LazyBulkDeleteModal, null));

});
parcelRegister("5ckZ8", function(module, exports) {

let $3c8e59f38354f86b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3c8e59f38354f86b$var$load("2BPmY").then(()=>parcelRequire('bIZ4A'));

});


parcelRegister("5h7oA", function(module, exports) {

$parcel$export(module.exports, "default", () => $6329f0d83059ca6f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iAbh9 = parcelRequire("iAbh9");

var $5vJHu = parcelRequire("5vJHu");

var $iuzc0 = parcelRequire("iuzc0");

var $mk7k0 = parcelRequire("mk7k0");

var $aJDYj = parcelRequire("aJDYj");

var $hPruQ = parcelRequire("hPruQ");

var $2Len7 = parcelRequire("2Len7");
const $6329f0d83059ca6f$var$BulkEdit = ()=>{
    const bulkChangePermission = (0, $aJDYj.useBulkChangePermission)();
    const bulkOperationsForm = (0, $5vJHu.useReferenceLoader)();
    const [, { toggleBulkEditSidebar: toggleBulkEditSidebar }] = (0, $mk7k0.useBulkSelectionStore)();
    const [, { toggleShowQuickstart: toggleShowQuickstart }] = (0, $iuzc0.useQuickstartPillVisibilityStore)();
    const onOpenSidebar = (0, $5uXOq.useCallback)(()=>{
        toggleBulkEditSidebar({
            showBulkEditSidebar: true
        });
    }, [
        toggleBulkEditSidebar
    ]);
    const onCloseSidebar = (0, $5uXOq.useCallback)(()=>{
        toggleBulkEditSidebar({
            showBulkEditSidebar: false
        });
        toggleShowQuickstart({
            showQuickstartPill: true
        });
    }, [
        toggleBulkEditSidebar,
        toggleShowQuickstart
    ]);
    if (!bulkChangePermission) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iAbh9.BulkOpsAnalyticsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Len7.BulkEditSidebar), {
        bulkOperationsForm: bulkOperationsForm
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hPruQ.BulkOperationsLoader), {
        bulkOperationsForm: bulkOperationsForm,
        onCloseSidebar: onCloseSidebar,
        onOpenSidebar: onOpenSidebar
    }));
};
var $6329f0d83059ca6f$export$2e2bcd8739ae039 = $6329f0d83059ca6f$var$BulkEdit;

});
parcelRegister("iAbh9", function(module, exports) {

$parcel$export(module.exports, "BulkOpsAnalyticsProvider", () => $477c8df705ed825f$export$8ab440f197429d1e);
$parcel$export(module.exports, "useBulkOpsSessionContext", () => $477c8df705ed825f$export$95271787b6ae4d3c);

var $5uXOq = parcelRequire("5uXOq");

var $iXVV6 = parcelRequire("iXVV6");

var $8p26c = parcelRequire("8p26c");
const $477c8df705ed825f$var$BulkOpsAnalyticsContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $477c8df705ed825f$export$8ab440f197429d1e = (props)=>{
    const [bulkOpsFlow] = (0, $5uXOq.useState)(new (0, $8p26c.DefaultBulkOpsFlow)());
    const [bulkOpsSessionID, setBulkOpsSessionID] = (0, $5uXOq.useState)(bulkOpsFlow?.getFlowAttributes().bulkOpsSessionID || undefined);
    (0, $5uXOq.useEffect)(()=>{
        const unsubscribe = bulkOpsFlow?.registerAnalyticsEventPublisher((sessionId)=>{
            setBulkOpsSessionID(sessionId);
        });
        return ()=>{
            unsubscribe?.();
        };
    }, [
        bulkOpsFlow
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($477c8df705ed825f$var$BulkOpsAnalyticsContext.Provider, {
        value: bulkOpsFlow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            bulkOpsSessionID: bulkOpsSessionID
        }
    }, props.children));
};
const $477c8df705ed825f$export$95271787b6ae4d3c = ()=>(0, $5uXOq.useContext)($477c8df705ed825f$var$BulkOpsAnalyticsContext);

});
parcelRegister("8p26c", function(module, exports) {

$parcel$export(module.exports, "DefaultBulkOpsFlow", () => $66219c4f12f760b8$export$74bf75c57acfbb74);

var $7Jxgt = parcelRequire("7Jxgt");
class $66219c4f12f760b8$export$74bf75c57acfbb74 {
    isInFlow() {
        return this.bulkOpsSessionID !== undefined;
    }
    get sessionID() {
        return this.bulkOpsSessionID;
    }
    get bulkActionsCompleted() {
        return this.numBulkActionsCompleted;
    }
    get bulkOperationType() {
        return this.bulkOperationTypeValue;
    }
    notifyAnalyticsEventPublishers(sessionID) {
        let index = 0;
        this.analyticsEventPublishers.forEach((listener)=>{
            listener(sessionID, index);
            index += 1;
        });
        this.analyticsEventPublishers.clear();
    }
    start(_attributes) {
        if (this.isInFlow()) return;
        this.bulkOpsSessionID = (0, $7Jxgt.v4)();
        this.notifyAnalyticsEventPublishers(this.bulkOpsSessionID);
    }
    end(_attributes) {
        this.bulkOpsSessionID = undefined;
        this.numBulkActionsCompleted = 0;
    }
    executeAction() {
        if (!this.isInFlow()) this.start();
        this.numBulkActionsCompleted += 1;
    }
    setBulkOperationType(bulkOperationType) {
        this.bulkOperationTypeValue = bulkOperationType;
    }
    getFlowAttributes() {
        if (this.bulkOpsSessionID && this.numBulkActionsCompleted !== 0) return {
            bulkOpsSessionID: this.bulkOpsSessionID,
            numBulkActionsCompleted: this.numBulkActionsCompleted
        };
        return this.bulkOpsSessionID ? {
            bulkOpsSessionID: this.bulkOpsSessionID
        } : {};
    }
    registerAnalyticsEventPublisher(analyticsEventPublisher) {
        this.analyticsEventPublishers.add(analyticsEventPublisher);
        return ()=>{
            this.analyticsEventPublishers.delete(analyticsEventPublisher);
        };
    }
    constructor(){
        this.numBulkActionsCompleted = 0;
        this.analyticsEventPublishers = new Set();
    }
}

});


parcelRegister("5vJHu", function(module, exports) {

$parcel$export(module.exports, "useReferenceLoader", () => $6eeb97186bbafb10$export$727d936bc4a88f4e);

var $5uXOq = parcelRequire("5uXOq");
const $6eeb97186bbafb10$export$727d936bc4a88f4e = ()=>{
    const [ref, setRef] = (0, $5uXOq.useState)(null);
    return (0, $5uXOq.useMemo)(()=>({
            setRef: setRef,
            ref: ref
        }), [
        setRef,
        ref
    ]);
};

});

parcelRegister("aJDYj", function(module, exports) {

$parcel$export(module.exports, "useBulkChangePermission", () => $947d33e7b3e45493$export$9a67849ec94d7b59);

var $5uXOq = parcelRequire("5uXOq");

var $lqQXn = parcelRequire("lqQXn");

var $mk7k0 = parcelRequire("mk7k0");
const $947d33e7b3e45493$export$9a67849ec94d7b59 = ()=>{
    const [, { setBulkChangePermission: setBulkChangePermission }] = (0, $mk7k0.useBulkSelectionStore)();
    const bulkChangePermission = (0, $lqQXn.useBulkChangePermissionService)();
    (0, $5uXOq.useEffect)(()=>{
        bulkChangePermission !== null && bulkChangePermission !== undefined && setBulkChangePermission({
            bulkChangePermission: bulkChangePermission
        });
    }, [
        bulkChangePermission,
        setBulkChangePermission
    ]);
    return bulkChangePermission;
};

});
parcelRegister("lqQXn", function(module, exports) {

$parcel$export(module.exports, "useBulkChangePermissionService", () => $07b9a9bb1eab5d1d$export$cd2838b9aad6b912);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $9OXo1 = parcelRequire("9OXo1");

const $07b9a9bb1eab5d1d$export$cd2838b9aad6b912 = ()=>{
    const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
    const [bulkChangePermission, setPermission] = (0, $5uXOq.useState)();
    const getBulkChangePermission = (0, $5uXOq.useCallback)(async ()=>{
        try {
            const gqlResponse = await (0, $eusud.performPostRequest)('/gateway/api/graphql', {
                body: JSON.stringify({
                    query: (0, $ce37d40571922cc2$export$f9d7f5d9663f3e0c),
                    variables: {
                        cloudId: cloudId
                    }
                })
            });
            setPermission(gqlResponse?.data?.jira?.permission?.hasPermission ?? false);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'fetchBulkChangePermission',
                    packageName: 'jiraBusinessList',
                    teamName: 'keystone'
                },
                attributes: {
                    message: 'Failed to get bulk change permission.'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            setPermission(false);
        }
    }, [
        cloudId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!cloudId) return;
        getBulkChangePermission();
    }, [
        getBulkChangePermission,
        cloudId
    ]);
    return bulkChangePermission;
};

});
const $ce37d40571922cc2$export$f9d7f5d9663f3e0c = `
query GetBulkEditPermission ($cloudId: ID!) {
  jira {
    permission(cloudId: $cloudId, type: BULK_CHANGE) {
      hasPermission
    }
  }
}`;



parcelRegister("hPruQ", function(module, exports) {

$parcel$export(module.exports, "BulkOperationsLoader", () => $c3a3afd760fb1a0d$export$3af81192d3c2a190);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $6aXrw = parcelRequire("6aXrw");

var $a4GFE = parcelRequire("a4GFE");

var $mk7k0 = parcelRequire("mk7k0");

var $8e3Yw = parcelRequire("8e3Yw");

var $jBW5k = parcelRequire("jBW5k");
const $c3a3afd760fb1a0d$export$3af81192d3c2a190 = ({ bulkOperationsForm: bulkOperationsForm, onOpenSidebar: onOpenSidebar, onCloseSidebar: onCloseSidebar })=>{
    const [groupByFieldId] = (0, $8e3Yw.useGroupBy)();
    const { bulkOptimisticUpdate: bulkOptimisticUpdate } = (0, $jBW5k.useUpdateGroupIssue)();
    const { updateSelectedItemsInCache: updateSelectedItemsInCache } = (0, $a4GFE.useBulkEditCacheActions)();
    const [{ bulkEditableIssues: selectedIssues }] = (0, $mk7k0.useBulkSelectionStore)();
    const onUpdateStart = (0, $5uXOq.useCallback)((res)=>{
        const { data: data, issueIds: issueIds } = res[0];
        if (data) {
            if (groupByFieldId) // TODO: Transform data to ListItemField type for bulkOptimisticUpdate
            bulkOptimisticUpdate(issueIds, []);
            else updateSelectedItemsInCache({
                data: data,
                issueIds: issueIds
            });
        }
    }, [
        groupByFieldId,
        bulkOptimisticUpdate,
        updateSelectedItemsInCache
    ]);
    const onUpdateError = (0, $5uXOq.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), []);
    const onUpdateSuccess = (0, $5uXOq.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), []);
    const onOpenForm = (0, $5uXOq.useCallback)(()=>{
        onOpenSidebar();
    }, [
        onOpenSidebar
    ]);
    const onCloseForm = (0, $5uXOq.useCallback)(()=>{
        onCloseSidebar();
    }, [
        onCloseSidebar
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6aXrw.AsyncBulkOpsCore), {
        bulkOperationsForm: bulkOperationsForm,
        onOpenForm: onOpenForm,
        onCloseForm: onCloseForm,
        onUpdateStart: onUpdateStart,
        onUpdateError: onUpdateError,
        onUpdateSuccess: onUpdateSuccess,
        onLegacyBulkEditRequest: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onSelectAll: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        selectableIssueIds: [],
        selectedIssueIds: Array.from(selectedIssues).map(Number) ?? [],
        extraAnalyticsAttributes: {},
        onClearAll: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onClearAllVisible: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        // configure when resolving the ticket https://jplat.jira.atlassian.cloud/browse/THOR-3771. leaving this switched on by default for now.
        hasBulkEditPermission: true,
        // TODO: Only applied for List View as its eventually going away - enable legacy features it relies on
        isLegacyBulkOperations: true,
        shouldHideToolbar: true
    });
};

});
parcelRegister("6aXrw", function(module, exports) {

$parcel$export(module.exports, "AsyncBulkOpsCore", () => $dd195193bf05f4ed$export$ac7b39f8b8a9f5cd);
$parcel$export(module.exports, "BulkOpsCoreWithToolbar", () => $dd195193bf05f4ed$export$e277fa5a9b41268f);

var $5uXOq = parcelRequire("5uXOq");

var $Pdfe3 = parcelRequire("Pdfe3");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $8G5F5 = parcelRequire("8G5F5");

var $91LZJ = parcelRequire("91LZJ");

var $2NMNM = parcelRequire("2NMNM");

var $lWYYR = parcelRequire("lWYYR");

var $9by3l = parcelRequire("9by3l");

var $6s1PB = parcelRequire("6s1PB");

var $fvbIR = parcelRequire("fvbIR");
const $dd195193bf05f4ed$var$entryPointParams = {};
const $dd195193bf05f4ed$export$ac7b39f8b8a9f5cd = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $fvbIR.asyncBulkOpsCoreEntryPoint), $dd195193bf05f4ed$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "jira.backlog.bulk.operations.core",
        packageName: "jiraBulkOperationsCore",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
        runtimeProps: props
    });
};
const $dd195193bf05f4ed$export$e277fa5a9b41268f = ({ bulkOpsCoreEntryPointReference: bulkOpsCoreEntryPointReference, ...props })=>{
    const hasSelectAllButton = Boolean(props.onSelectAll);
    const extraToolbarButtonsSkeleton = props.extraToolbarButtons?.map((button)=>({
            hasIcon: Boolean(button.icon),
            text: button.name
        })) || [];
    const { dismissBulkOperation: dismissBulkOperation } = (0, $91LZJ.useBulkOperationsActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onDeselectAll = (0, $5uXOq.useCallback)(()=>{
        dismissBulkOperation({
            createAnalyticsEvent: createAnalyticsEvent,
            dismissType: 'DESELECT_ALL_ISSUES'
        });
    }, [
        createAnalyticsEvent,
        dismissBulkOperation
    ]);
    // TODO: move this back to the bottom when cleaning up bulk_delete_experiment AND isLegacyBulkOperations
    const toolbarWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8G5F5.ToolbarWrapper), {
        show: props.selectedIssueIds.length > 0,
        width: "calc(100% - var(--leftSidebarWidth, 0px))",
        onDeselectAll: onDeselectAll
    }, bulkOpsCoreEntryPointReference && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "jiraAsyncBulkOperationsCoreWithToolBar",
        packageName: "jiraBulkOperationsCoreWithToolBar",
        teamName: "deliveroo",
        entryPointReferenceSubject: bulkOpsCoreEntryPointReference,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Pdfe3.BulkOperationsToolbarSkeleton), {
            buttons: extraToolbarButtonsSkeleton,
            hasSelectAllButton: hasSelectAllButton
        }),
        runtimeProps: props
    }));
    if (!(0, $6s1PB.expVal)('bulk_delete_experiment', 'isEnabled', false) || props.isLegacyBulkOperations) return toolbarWrapper;
    const formProps = {
        selectedIssueIds: props.selectedIssueIds,
        onOpenForm: props.onOpenForm,
        onCloseForm: props.onCloseForm,
        onUpdateError: props.onUpdateError,
        onUpdateSuccess: props.onUpdateSuccess,
        onLegacyBulkEditRequest: props.onLegacyBulkEditRequest,
        onUpdateStart: props.onUpdateStart
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lWYYR.FormSubmissionStatusContainer), {
        isGlobal: true,
        ...formProps
    }, toolbarWrapper, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9by3l.EditFormSubmitStatus), null));
};

});
parcelRegister("Pdfe3", function(module, exports) {

$parcel$export(module.exports, "BulkOperationsToolbarSkeleton", () => $b74ffcc19e228775$export$59bb23e2f88d002d);

var $5uXOq = parcelRequire("5uXOq");

var $eNciG = parcelRequire("eNciG");

var $koVbs = parcelRequire("koVbs");

var $6s1PB = parcelRequire("6s1PB");

var $a1sGj = parcelRequire("a1sGj");

var $dgVef = parcelRequire("dgVef");

var $jx5JX = parcelRequire("jx5JX");

var $RR58o = parcelRequire("RR58o");
const $b74ffcc19e228775$export$59bb23e2f88d002d = ({ hasSelectAllButton: hasSelectAllButton, buttons: buttons })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const allButtons = [
        {
            text: formatMessage((0, $dgVef.messages).editButton),
            hasIcon: true
        },
        {
            text: formatMessage((0, $a1sGj.messages).changeStatus),
            hasIcon: true
        },
        ...(0, $6s1PB.expVal)('bulk_delete_experiment', 'isEnabled', false) ? [
            {
                text: formatMessage((0, $jx5JX.messages).deleteButton),
                hasIcon: true
            }
        ] : [],
        ...(0, $6s1PB.expVal)('bulk_watch_unwatch', 'isEnabled', false) ? [
            {
                text: formatMessage((0, $RR58o.messages).watchOptions),
                hasIcon: true
            }
        ] : [],
        ...buttons
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eNciG.ToolbarSkeleton), {
        hasSelectAllButton: hasSelectAllButton,
        buttons: allButtons
    });
};

});
parcelRegister("eNciG", function(module, exports) {

$parcel$export(module.exports, "ToolbarSkeleton", () => $ff19fad29388fb19$export$5e29225d56ca7c7d);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $1DVhQ = parcelRequire("1DVhQ");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $eyjpj = parcelRequire("eyjpj");

var $hGxOR = parcelRequire("hGxOR");
const $ff19fad29388fb19$var$SkeletonBase = (props)=>/*#__PURE__*/ $5uXOq.createElement((0, $1DVhQ.default), {
        ...props,
        height: "7px",
        isShimmering: true,
        color: "var(--ds-background-accent-gray-subtle, #8590A2)",
        ShimmeringEndColor: "var(--ds-background-accent-gray-bolder, #626F86)",
        width: props.width || '100%',
        "aria-hidden": "true"
    });
const $ff19fad29388fb19$var$SkeletonActionButton = ({ width: width, text: text, hasIcon: hasIcon })=>{
    return /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
        xcss: $ff19fad29388fb19$var$skeletonButtonStyles,
        "aria-hidden": "true",
        testId: "floating-toolbar.ui.skeleton.box"
    }, /*#__PURE__*/ $5uXOq.createElement($ff19fad29388fb19$var$SkeletonBase, {
        width: width
    }), /*#__PURE__*/ $5uXOq.createElement((0, $f5TWP.default), null, /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
        xcss: $ff19fad29388fb19$var$invisibleTextStyles
    }, text), /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
        xcss: hasIcon ? $ff19fad29388fb19$var$iconSpacerStyles : $ff19fad29388fb19$var$noIconSpacerStyles
    })));
};
const $ff19fad29388fb19$var$SkeletonCloseIcon = ()=>/*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
        xcss: $ff19fad29388fb19$var$closeIconContainerStyles
    }, /*#__PURE__*/ $5uXOq.createElement($ff19fad29388fb19$var$SkeletonBase, {
        width: "16px"
    })); // These props are used to calculate a more appropriate skeleton
const $ff19fad29388fb19$export$5e29225d56ca7c7d = ({ hasSelectAllButton: hasSelectAllButton, buttons: buttons })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ $5uXOq.createElement((0, $eyjpj.FloatingToolbarContainer), null, /*#__PURE__*/ $5uXOq.createElement((0, $eyjpj.FloatingToolbarContent), null, /*#__PURE__*/ $5uXOq.createElement((0, $eyjpj.FloatingToolbarSideContent), null, /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), null, /*#__PURE__*/ $5uXOq.createElement($ff19fad29388fb19$var$SkeletonBase, null), /*#__PURE__*/ $5uXOq.createElement((0, $f5TWP.default), {
        space: "space.050",
        "aria-hidden": "true"
    }, /*#__PURE__*/ $5uXOq.createElement("h2", {
        className: (0, $bwpsq.default)([
            "_11c82smr _1e0c1txw _1n261g80 _4cvr1h6o _ae4v1h6o _3um015vq _4t3iidpf"
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $ousew.default), {
        ...(0, $hGxOR.default).selectedItemsLabel,
        values: {
            numberOfSelectedItems: 1,
            numberSelected: /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
                xcss: $ff19fad29388fb19$var$numberSelectedStyles
            }, 1)
        }
    }))))), hasSelectAllButton && /*#__PURE__*/ $5uXOq.createElement($ff19fad29388fb19$var$SkeletonActionButton, {
        text: formatMessage((0, $hGxOR.default).selectAllButtonLabel),
        hasIcon: true
    }), /*#__PURE__*/ $5uXOq.createElement((0, $eyjpj.FloatingToolbarSeparator), null), /*#__PURE__*/ $5uXOq.createElement((0, $f5TWP.default), {
        alignBlock: "center"
    }, buttons.map((button)=>{
        return /*#__PURE__*/ $5uXOq.createElement($ff19fad29388fb19$var$SkeletonActionButton, {
            key: button.text,
            ...button
        });
    }), /*#__PURE__*/ $5uXOq.createElement($ff19fad29388fb19$var$SkeletonCloseIcon, null))));
};
const $ff19fad29388fb19$var$skeletonButtonStyles = (0, $8CUq3.xcss)({
    paddingInlineStart: 'space.100',
    paddingInlineEnd: 'space.150'
});
const $ff19fad29388fb19$var$closeIconContainerStyles = (0, $8CUq3.xcss)({
    paddingInlineStart: 'space.100',
    paddingInlineEnd: 'space.100'
});
const $ff19fad29388fb19$var$selectedContainer = null;
const $ff19fad29388fb19$var$iconSpacerStyles = (0, $8CUq3.xcss)({
    width: '26px'
});
const $ff19fad29388fb19$var$noIconSpacerStyles = (0, $8CUq3.xcss)({
    width: '4px'
});
const $ff19fad29388fb19$var$invisibleTextStyles = (0, $8CUq3.xcss)({
    height: '0',
    visibility: 'hidden'
});
const $ff19fad29388fb19$var$numberSelectedStyles = (0, $8CUq3.xcss)({
    width: '24px',
    marginRight: 'space.050'
});

});
parcelRegister("eyjpj", function(module, exports) {

$parcel$export(module.exports, "FloatingToolbarContainer", () => $65d4363d5da90d3d$export$da9876c16f406ff3);
$parcel$export(module.exports, "FloatingToolbarContent", () => $65d4363d5da90d3d$export$634954b758f92d4);
$parcel$export(module.exports, "FloatingToolbarSeparator", () => $65d4363d5da90d3d$export$e9d27765ebab091b);
$parcel$export(module.exports, "FloatingToolbarSideContent", () => $65d4363d5da90d3d$export$fcfdbfa230cd1442);
$parcel$export(module.exports, "ContentSlider", () => $65d4363d5da90d3d$export$ff7934be9f806b5f);

var $5uXOq = parcelRequire("5uXOq");

var $35XSW = parcelRequire("35XSW");
var $8Sbj3 = parcelRequire("8Sbj3");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $faL1o = parcelRequire("faL1o");
const $65d4363d5da90d3d$export$da9876c16f406ff3 = ({ children: children, onKeyDown: onKeyDown })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        role: "toolbar",
        xcss: $65d4363d5da90d3d$var$floatingContainerStyles,
        "aria-label": formatMessage((0, $faL1o.messages).toolbarName),
        onKeyDown: onKeyDown
    }, children);
};
const $65d4363d5da90d3d$export$634954b758f92d4 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $65d4363d5da90d3d$var$contentContainerStyles,
        alignBlock: "center"
    }, children);
const $65d4363d5da90d3d$export$e9d27765ebab091b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $65d4363d5da90d3d$var$separatorStyles
    });
const $65d4363d5da90d3d$export$fcfdbfa230cd1442 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $65d4363d5da90d3d$var$sideContentContainer
    }, children);
const $65d4363d5da90d3d$export$ff7934be9f806b5f = ({ children: children, show: show })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $35XSW.default), null, show && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Sbj3.default), {
        enterFrom: "bottom",
        fade: "inout"
    }, (slideInProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", slideInProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $65d4363d5da90d3d$var$mainContainerStyles
        }, children))));
const $65d4363d5da90d3d$var$floatingContainerStyles = (0, $8CUq3.xcss)({
    padding: 'space.100',
    backgroundColor: 'color.background.neutral.bold.pressed',
    borderRadius: '6px',
    boxShadow: 'elevation.shadow.overlay'
});
const $65d4363d5da90d3d$var$contentContainerStyles = (0, $8CUq3.xcss)({
    height: '32px',
    color: 'color.text.inverse',
    fontVariantNumeric: 'tabular-nums'
});
const $65d4363d5da90d3d$var$separatorStyles = (0, $8CUq3.xcss)({
    height: '16px',
    width: '1px',
    backgroundColor: 'elevation.surface.raised',
    borderRadius: '2px',
    marginLeft: 'space.100',
    marginRight: 'space.100'
});
const $65d4363d5da90d3d$var$sideContentContainer = (0, $8CUq3.xcss)({
    paddingLeft: 'space.100',
    paddingRight: 'space.100'
});
const $65d4363d5da90d3d$var$mainContainerStyles = (0, $8CUq3.xcss)({
    pointerEvents: 'auto'
});

});
parcelRegister("faL1o", function(module, exports) {

$parcel$export(module.exports, "messages", () => $39ec34d441f2b8b5$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $39ec34d441f2b8b5$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    toolbarName: {
        "id": "floating-toolbar.common.toolbar-name",
        "defaultMessage": "Bulk actions"
    }
});

});


parcelRegister("hGxOR", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5f61683952119ea$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d5f61683952119ea$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    selectedItemsLabel: {
        "id": "floating-toolbar.selected-items-label",
        "defaultMessage": "{numberSelected} {numberOfSelectedItems, plural, one {selected} other {selected}}"
    },
    clearAllButton: {
        "id": "floating-toolbar.clear-all-button",
        "defaultMessage": "Clear all"
    },
    selectAllButtonLabel: {
        "id": "floating-toolbar.select-all-button-label",
        "defaultMessage": "Select all"
    }
});

});


parcelRegister("a1sGj", function(module, exports) {

$parcel$export(module.exports, "messages", () => $7df5795053ce776c$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $7df5795053ce776c$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    changeStatus: {
        "id": "bulk-operations-core.toolbar.use-status-action.change-status",
        "defaultMessage": "Change status"
    }
});

});

parcelRegister("dgVef", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2f1b529e937c824e$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $2f1b529e937c824e$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    editButton: {
        "id": "bulk-operations-core.toolbar.use-edit-action.edit-button",
        "defaultMessage": "Edit fields"
    }
});

});

parcelRegister("jx5JX", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f8d6851d0038f949$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $f8d6851d0038f949$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    deleteButton: {
        "id": "bulk-operations-core.toolbar.use-bulk-delete-action.detele-button",
        "defaultMessage": "Delete"
    }
});

});

parcelRegister("RR58o", function(module, exports) {

$parcel$export(module.exports, "messages", () => $3ac9a4f547ce95d9$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $3ac9a4f547ce95d9$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    watchOptions: {
        "id": "bulk-operations-core.toolbar.use-watch-action.watch-options",
        "defaultMessage": "Watch options"
    },
    startWatching: {
        "id": "bulk-operations-core.toolbar.use-watch-action.start-watching",
        "defaultMessage": "Start watching"
    },
    stopWatching: {
        "id": "bulk-operations-core.toolbar.use-watch-action.stop-watching",
        "defaultMessage": "Stop watching"
    },
    successFlagDescriptionStartWatching: {
        "id": "bulk-operations-core.toolbar.use-watch-action.success-flag-description-start-watching",
        "defaultMessage": "You're watching {itemCount, plural, one {this work item} other {# work items}}."
    },
    successFlagDescriptionStopWatching: {
        "id": "bulk-operations-core.toolbar.use-watch-action.success-flag-description-stop-watching",
        "defaultMessage": "You aren't watching {itemCount, plural, one {this work item} other {# work items}}."
    }
});

});


parcelRegister("8G5F5", function(module, exports) {

$parcel$export(module.exports, "ToolbarWrapper", () => $bb1a9147c120653f$export$b705b0380e6fe1b0);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $1XJ20 = parcelRequire("1XJ20");

var $eyjpj = parcelRequire("eyjpj");
const $bb1a9147c120653f$export$b705b0380e6fe1b0 = ({ children: children, show: show, width: width, onDeselectAll: onDeselectAll })=>{
    const previousShow = (0, $1XJ20.usePrevious)(show);
    (0, $5uXOq.useEffect)(()=>{
        if (previousShow && !show) onDeselectAll?.();
    }, [
        onDeselectAll,
        previousShow,
        show
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $bb1a9147c120653f$var$floatingPositionerStyles
        ],
        // eslint-disable-next-line jira/react/no-style-attribute -- width of component can change depending on the consumer
        style: {
            width: width || '100%'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eyjpj.ContentSlider), {
        show: show
    }, children));
};
const $bb1a9147c120653f$var$floatingPositionerStyles = (0, $8CUq3.xcss)({
    position: 'fixed',
    bottom: 'space.100',
    zIndex: 'layer',
    pointerEvents: 'none',
    display: 'flex',
    justifyContent: 'center',
    transition: 'width 300ms cubic-bezier(0.2, 0, 0, 1)'
});

});

parcelRegister("91LZJ", function(module, exports) {

$parcel$export(module.exports, "useBulkOperations", () => $655e95f3b81da53e$export$940587be18a93fc4);
$parcel$export(module.exports, "useBulkOperationsActions", () => $655e95f3b81da53e$export$355499dfde532d1a);
$parcel$export(module.exports, "useIsBulkOperationsInProgress", () => $655e95f3b81da53e$export$760458c2204457a1);
$parcel$export(module.exports, "useShouldRenderSpotlight", () => $655e95f3b81da53e$export$4a165cf2377f023a);
$parcel$export(module.exports, "useBulkTransitionsStage", () => $655e95f3b81da53e$export$b3afff39a0c663ad);
$parcel$export(module.exports, "useBulkOperationInForm", () => $655e95f3b81da53e$export$6794339387d6d562);
$parcel$export(module.exports, "useBulkOperationType", () => $655e95f3b81da53e$export$4289f82da677ffac);
$parcel$export(module.exports, "useCancelDialogTrigger", () => $655e95f3b81da53e$export$babceeeb2408337b);
$parcel$export(module.exports, "useCurrentView", () => $655e95f3b81da53e$export$8ce7af7b2f8c770);

var $8zOmE = parcelRequire("8zOmE");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $5ltfA = parcelRequire("5ltfA");

var $liV8G = parcelRequire("liV8G");
const $655e95f3b81da53e$export$d4c72bab9d6cc13a = {
    operationType: null,
    isSidebarOpen: false,
    cancelDialogTrigger: undefined,
    currentView: 'edit',
    firstFieldId: undefined,
    operationStartTime: null
};
const $655e95f3b81da53e$var$actions = {
    setSummaryView: ()=>({ setState: setState })=>{
            setState({
                currentView: 'summary'
            });
        },
    setFirstFieldId: (firstFieldId)=>({ setState: setState })=>{
            setState({
                firstFieldId: firstFieldId
            });
        },
    setEditView: ()=>({ setState: setState })=>{
            setState({
                currentView: 'edit'
            });
        },
    setCancelDialogTrigger: (newTrigger = 'user-triggered')=>({ setState: setState, getState: getState })=>{
            const { cancelDialogTrigger: currentTrigger } = getState();
            /* Sometimes both events can be fired (route change & onclick) in one loop
					We need to prioritise route-change event  */ if (currentTrigger === 'route-change' && newTrigger === 'user-triggered') return;
            setState({
                cancelDialogTrigger: newTrigger
            });
        },
    clearDialogTrigger: ()=>({ setState: setState })=>{
            setState({
                cancelDialogTrigger: undefined
            });
        },
    startEdit: (args)=>({ setState: setState })=>{
            const { shouldRenderSpotlight: shouldRenderSpotlight } = args || {
                shouldRenderSpotlight: false
            };
            setState({
                operationType: {
                    type: (0, $liV8G.BulkOperationsTypes).BULK_EDIT
                },
                shouldRenderSpotlight: shouldRenderSpotlight,
                isSidebarOpen: true,
                operationStartTime: performance.now()
            });
        },
    loadTransitions: ()=>({ setState: setState })=>{
            setState({
                operationType: {
                    type: (0, $liV8G.BulkOperationsTypes).BULK_TRANSITION,
                    stage: (0, $liV8G.BulkTransitionsStage).LOAD_BULK_TRANSITIONS
                },
                isSidebarOpen: false
            });
        },
    startQuickTransitions: ()=>({ setState: setState })=>{
            setState({
                operationType: {
                    type: (0, $liV8G.BulkOperationsTypes).BULK_TRANSITION,
                    stage: (0, $liV8G.BulkTransitionsStage).START_QUICK_TRANSITIONS
                },
                isSidebarOpen: false,
                operationStartTime: performance.now()
            });
        },
    startSidebarTransition: ()=>({ setState: setState })=>{
            setState({
                operationType: {
                    type: (0, $liV8G.BulkOperationsTypes).BULK_TRANSITION,
                    stage: (0, $liV8G.BulkTransitionsStage).START_SIDEBAR_TRANSITION
                },
                isSidebarOpen: true,
                operationStartTime: performance.now()
            });
        },
    startTransitionScreen: ()=>({ setState: setState })=>{
            setState({
                operationType: {
                    type: (0, $liV8G.BulkOperationsTypes).BULK_TRANSITION,
                    stage: (0, $liV8G.BulkTransitionsStage).START_TRANSITION_SCREEN
                },
                isSidebarOpen: true
            });
        },
    dismissBulkOperation: ({ createAnalyticsEvent: createAnalyticsEvent, dismissType: dismissType })=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const analyticsEvent = createAnalyticsEvent({});
            const operationEndTime = performance.now();
            const operationTimeTaken = currentState.operationStartTime ? operationEndTime - currentState.operationStartTime : null;
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'dismissed bulkOperations', {
                dismissType: dismissType,
                operationTimeTaken: operationTimeTaken
            });
            (0, $5ltfA.extraFormDataService).clear();
            setState($655e95f3b81da53e$export$d4c72bab9d6cc13a);
        }
};
const $655e95f3b81da53e$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    initialState: $655e95f3b81da53e$export$d4c72bab9d6cc13a,
    actions: $655e95f3b81da53e$var$actions,
    name: 'bulk-operations-store'
});
const $655e95f3b81da53e$export$940587be18a93fc4 = (0, $3sQ5x.createHook)($655e95f3b81da53e$export$6f57813fe9f31bf9);
const $655e95f3b81da53e$export$355499dfde532d1a = (0, $3sQ5x.createActionsHook)($655e95f3b81da53e$export$6f57813fe9f31bf9);
const $655e95f3b81da53e$export$760458c2204457a1 = (0, $3sQ5x.createStateHook)($655e95f3b81da53e$export$6f57813fe9f31bf9, {
    selector: (state)=>state.operationType !== null
});
const $655e95f3b81da53e$export$4a165cf2377f023a = (0, $3sQ5x.createStateHook)($655e95f3b81da53e$export$6f57813fe9f31bf9, {
    selector: (state)=>!!state.shouldRenderSpotlight
});
const $655e95f3b81da53e$export$b3afff39a0c663ad = (0, $3sQ5x.createStateHook)($655e95f3b81da53e$export$6f57813fe9f31bf9, {
    selector: (state)=>{
        const { operationType: operationType } = state;
        if (operationType?.type === (0, $liV8G.BulkOperationsTypes).BULK_TRANSITION) return operationType.stage;
        return null;
    }
});
const $655e95f3b81da53e$export$6794339387d6d562 = (0, $3sQ5x.createStateHook)($655e95f3b81da53e$export$6f57813fe9f31bf9, {
    selector: (state)=>{
        if (state.isSidebarOpen && state.operationType) return state.operationType.type;
        return null;
    }
});
const $655e95f3b81da53e$export$4289f82da677ffac = (0, $3sQ5x.createStateHook)($655e95f3b81da53e$export$6f57813fe9f31bf9, {
    selector: (state)=>state.operationType
});
const $655e95f3b81da53e$export$babceeeb2408337b = (0, $3sQ5x.createStateHook)($655e95f3b81da53e$export$6f57813fe9f31bf9, {
    selector: (state)=>state.cancelDialogTrigger
});
const $655e95f3b81da53e$export$8ce7af7b2f8c770 = (0, $3sQ5x.createStateHook)($655e95f3b81da53e$export$6f57813fe9f31bf9, {
    selector: (state)=>state.currentView
});

});
parcelRegister("5ltfA", function(module, exports) {

$parcel$export(module.exports, "extraFormDataService", () => $3546d70b36caa00c$export$3cd9d97d155e8e66);
class $3546d70b36caa00c$var$ExtraFormData {
    clear() {
        this.data = {};
    }
    addByKey(key, value) {
        this.data[key] = value;
    }
    getByKey(key) {
        return this.data[key];
    }
    getAll() {
        return this.data;
    }
    constructor(){
        this.data = {};
    }
}
const $3546d70b36caa00c$var$extraFormData = new $3546d70b36caa00c$var$ExtraFormData();
const $3546d70b36caa00c$var$addDataByKey = (key, value)=>{
    $3546d70b36caa00c$var$extraFormData.addByKey(key, value);
};
const $3546d70b36caa00c$var$clear = ()=>{
    $3546d70b36caa00c$var$extraFormData.clear();
};
const $3546d70b36caa00c$var$getDataByKey = (key)=>$3546d70b36caa00c$var$extraFormData.getByKey(key);
const $3546d70b36caa00c$var$getData = ()=>$3546d70b36caa00c$var$extraFormData.getAll();
const $3546d70b36caa00c$export$3cd9d97d155e8e66 = {
    addDataByKey: $3546d70b36caa00c$var$addDataByKey,
    getDataByKey: $3546d70b36caa00c$var$getDataByKey,
    clear: $3546d70b36caa00c$var$clear,
    getData: $3546d70b36caa00c$var$getData
};

});

parcelRegister("liV8G", function(module, exports) {

$parcel$export(module.exports, "BulkOperationsTypes", () => $41c61f309c49c414$export$7ec2782f56bb6e02);
$parcel$export(module.exports, "BulkTransitionsStage", () => $41c61f309c49c414$export$a6f51fa6c8971716);
const $41c61f309c49c414$export$7ec2782f56bb6e02 = {
    BULK_EDIT: 'BULK_EDIT',
    BULK_TRANSITION: 'BULK_TRANSITION',
    BULK_DELETE: 'BULK_DELETE',
    BULK_WATCH: 'BULK_WATCH',
    BULK_UNWATCH: 'BULK_UNWATCH'
};
const $41c61f309c49c414$export$a6f51fa6c8971716 = {
    LOAD_BULK_TRANSITIONS: 'LOAD_BULK_TRANSITIONS',
    START_QUICK_TRANSITIONS: 'START_QUICK_TRANSITIONS',
    START_SIDEBAR_TRANSITION: 'START_SIDEBAR_TRANSITION',
    START_TRANSITION_SCREEN: 'START_TRANSITION_SCREEN'
};
const $41c61f309c49c414$export$1550a2cc6d56ae33 = {
    // ERRORS //
    ERROR_BULK_EDIT: 'ERROR_BULK_EDIT',
    ERROR_BULK_TRANSITION: 'ERROR_BULK_TRANSITION',
    ERROR_BULK_TRANSITION_SCREEN_MOUNT: 'ERROR_BULK_TRANSITION_SCREEN_MOUNT',
    // BULK EDIT //
    EDIT_FORM_PRISTINE_CANCEL: 'EDIT_FORM_PRISTINE_CANCEL',
    EDIT_FORM_DIRTY_CANCEL: 'EDIT_FORM_DIRTY_CANCEL',
    EDIT_FORM_SUMMARY_CANCEL: 'EDIT_FORM_SUMMARY_CANCEL',
    EDIT_ATTEMPT_SUBMIT: 'EDIT_ATTEMPT_SUBMIT',
    // TRANSITION DIALOG //
    TRANSITION_DIALOG_PRISTINE_CANCEL: 'TRANSITION_DIALOG_PRISTINE_CANCEL',
    TRANSITION_DIALOG_DIRTY_CANCEL: 'TRANSITION_DIALOG_DIRTY_CANCEL',
    TRANSITION_DIALOG_CANT_CONTINUE_WARNING: 'TRANSITION_DIALOG_CANT_CONTINUE_WARNING',
    TRANSITION_DIALOG_ATTEMPT_SUBMIT: 'TRANSITION_DIALOG_ATTEMPT_SUBMIT',
    // TRANSITION FORM //
    TRANSITION_FORM_PRISTINE_CANCEL: 'TRANSITION_FORM_PRISTINE_CANCEL',
    TRANSITION_FORM_DIRTY_CANCEL: 'TRANSITION_FORM_DIRTY_CANCEL',
    TRANSITION_FORM_ATTEMPT_SUBMIT: 'TRANSITION_FORM_ATTEMPT_SUBMIT',
    // TRANSITION WITH SCREEN //
    TRANSITION_WITH_SCREEN_LEGACY_LINK: 'TRANSITION_WITH_SCREEN_LEGACY_LINK',
    TRANSITION_WITH_SCREEN_SUMMARY_CANCEL: 'TRANSITION_WITH_SCREEN_SUMMARY_CANCEL',
    TRANSITION_WITH_SCREEN_CANCEL: 'TRANSITION_WITH_SCREEN_CANCEL',
    // BULK DELETE //
    DELETE_ATTEMPT_SUBMIT: 'DELETE_ATTEMPT_SUBMIT',
    DELETE_ATTEMPT_CANCEL: 'DELETE_CANCEL',
    // BULK WATCH //
    WATCH_ATTEMPT_SUBMIT: 'WATCH_ATTEMPT_SUBMIT',
    // BULK UNWATCH //
    UNWATCH_ATTEMPT_SUBMIT: 'UNWATCH_ATTEMPT_SUBMIT',
    // OTHER //
    NAVIGATION: 'NAVIGATION',
    DESELECT_ALL_ISSUES: 'DESELECT_ALL_ISSUES'
};

});


parcelRegister("lWYYR", function(module, exports) {

$parcel$export(module.exports, "FormSubmissionStatusContainer", () => $55cb7d47e9fb8082$export$89eaa1757634ea57);
$parcel$export(module.exports, "useBulkOperationsFormSubmissionActions", () => $55cb7d47e9fb8082$export$497042634f495a36);
$parcel$export(module.exports, "useFormSubmitStatus", () => $55cb7d47e9fb8082$export$18b9f82ace8120bc);
$parcel$export(module.exports, "useFormSubmitProgressData", () => $55cb7d47e9fb8082$export$f978a44c91fecf30);
$parcel$export(module.exports, "useFormSubmitSuccessData", () => $55cb7d47e9fb8082$export$6def2d73afa09050);
$parcel$export(module.exports, "useFormSubmitIssueIds", () => $55cb7d47e9fb8082$export$ec939e52c2362761);
$parcel$export(module.exports, "useFormSubmitErrorData", () => $55cb7d47e9fb8082$export$1b826b4651e625bf);
$parcel$export(module.exports, "useFormSubmitFlagData", () => $55cb7d47e9fb8082$export$f99368b86d418226);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");

var $gDmIh = parcelRequire("gDmIh");

var $2SnjZ = parcelRequire("2SnjZ");
const $55cb7d47e9fb8082$var$initialState = {
    flagStatus: (0, $2SnjZ.SubmitFlagStatus).NoFlag,
    flagData: undefined,
    data: undefined,
    callbacks: {},
    issueIds: []
};
const $55cb7d47e9fb8082$var$Store = (0, $iXqE5.createStore)({
    initialState: $55cb7d47e9fb8082$var$initialState,
    actions: $gDmIh.actions,
    name: 'bulk-operations-form-submit-state'
});
const $55cb7d47e9fb8082$export$31c34f2147c0d0ae = (0, $3sQ5x.createHook)($55cb7d47e9fb8082$var$Store);
const $55cb7d47e9fb8082$export$c88ec44e7ac83ded = ()=>({ setState: setState }, { selectedIssueIds: selectedIssueIds, ...callbacks })=>{
        setState({
            callbacks: callbacks,
            issueIds: selectedIssueIds
        });
    };
const $55cb7d47e9fb8082$export$89eaa1757634ea57 = (0, $gg7kZ.createContainer)($55cb7d47e9fb8082$var$Store, {
    onInit: $55cb7d47e9fb8082$export$c88ec44e7ac83ded,
    onUpdate: $55cb7d47e9fb8082$export$c88ec44e7ac83ded
});
const $55cb7d47e9fb8082$export$497042634f495a36 = (0, $3sQ5x.createActionsHook)($55cb7d47e9fb8082$var$Store);
const $55cb7d47e9fb8082$var$getFormSubmitStatus = (state)=>state.flagStatus;
const $55cb7d47e9fb8082$export$18b9f82ace8120bc = (0, $3sQ5x.createStateHook)($55cb7d47e9fb8082$var$Store, {
    selector: $55cb7d47e9fb8082$var$getFormSubmitStatus
});
const $55cb7d47e9fb8082$var$getFormSubmitProgressData = (state)=>{
    if (state.flagStatus === (0, $2SnjZ.SubmitFlagStatus).ProgressFlag || state.flagStatus === (0, $2SnjZ.SubmitFlagStatus).NoFlag) return state.data;
    return undefined;
};
const $55cb7d47e9fb8082$export$f978a44c91fecf30 = (0, $3sQ5x.createStateHook)($55cb7d47e9fb8082$var$Store, {
    selector: $55cb7d47e9fb8082$var$getFormSubmitProgressData
});
const $55cb7d47e9fb8082$var$getFormSubmitSuccessData = (state)=>{
    if (state.flagStatus === (0, $2SnjZ.SubmitFlagStatus).SuccessFlag) return state.data.numberOfIssuesUpdated;
    return undefined;
};
const $55cb7d47e9fb8082$export$6def2d73afa09050 = (0, $3sQ5x.createStateHook)($55cb7d47e9fb8082$var$Store, {
    selector: $55cb7d47e9fb8082$var$getFormSubmitSuccessData
});
const $55cb7d47e9fb8082$var$getFormSubmitIssueIds = (state)=>state.issueIds;
const $55cb7d47e9fb8082$export$ec939e52c2362761 = (0, $3sQ5x.createStateHook)($55cb7d47e9fb8082$var$Store, {
    selector: $55cb7d47e9fb8082$var$getFormSubmitIssueIds
});
const $55cb7d47e9fb8082$var$getFormSubmitErrorData = (state)=>{
    if (state.flagStatus === (0, $2SnjZ.SubmitFlagStatus).PartialErrorFlag) return state.data;
    return undefined;
};
const $55cb7d47e9fb8082$export$1b826b4651e625bf = (0, $3sQ5x.createStateHook)($55cb7d47e9fb8082$var$Store, {
    selector: $55cb7d47e9fb8082$var$getFormSubmitErrorData
});
const $55cb7d47e9fb8082$var$getFormSubmitFlagData = (state)=>state.flagData;
const $55cb7d47e9fb8082$export$f99368b86d418226 = (0, $3sQ5x.createStateHook)($55cb7d47e9fb8082$var$Store, {
    selector: $55cb7d47e9fb8082$var$getFormSubmitFlagData
});

});
parcelRegister("gDmIh", function(module, exports) {

$parcel$export(module.exports, "actions", () => $2a881fd5be32e130$export$e324594224ef24da);

var $e7WVN = parcelRequire("e7WVN");

var $6s1PB = parcelRequire("6s1PB");

var $dNaZ2 = parcelRequire("dNaZ2");

var $2SnjZ = parcelRequire("2SnjZ");
const $2a881fd5be32e130$export$e324594224ef24da = {
    startSubmit: (interactionSource)=>({ setState: setState })=>{
            setState({
                flagStatus: (0, $2SnjZ.SubmitFlagStatus).NoFlag,
                data: undefined,
                interactionSource: interactionSource
            });
        },
    setIdle: ()=>({ setState: setState })=>{
            setState({
                flagStatus: (0, $2SnjZ.SubmitFlagStatus).NoFlag,
                data: undefined
            });
        },
    dismissPollingFlag: ()=>({ setState: setState, getState: getState })=>{
            const { flagStatus: flagStatus, data: data } = getState();
            if (flagStatus === (0, $2SnjZ.SubmitFlagStatus).ProgressFlag) setState({
                flagStatus: (0, $2SnjZ.SubmitFlagStatus).NoFlag,
                flagData: undefined,
                data: data
            });
        },
    setPollingStart: (taskId, inputData, flagData)=>({ setState: setState, getState: getState })=>{
            const { callbacks: callbacks } = getState();
            callbacks.onUpdateStart?.(inputData.map(({ issueIds: issueIds, data: data, bulkOperationType: bulkOperationType })=>({
                    data: data,
                    issueIds: (0, $dNaZ2.transformIssueArisToIds)(issueIds),
                    bulkOperationType: (0, $6s1PB.expVal)('bulk_operations_in_nin_experiment', 'isEnabled', false) ? bulkOperationType : undefined
                })));
            setState({
                flagStatus: (0, $2SnjZ.SubmitFlagStatus).ProgressFlag,
                flagData: flagData,
                data: {
                    taskId: taskId
                }
            });
        },
    /*
		This action is a temporary workaround to open the legacy bulk edit page.
		The Bulk Transition doesn't have support to return the issueKeys so this implementation was done here
		and will be removed when we implement Bulk Transition with multiple workflows.
		Project Plan: https://hello.atlassian.net/wiki/spaces/JSDee/pages/3388755384/Bulk+Transition+Project+Plan
		*/ redirectToLegacyBulkTransition: ()=>({ getState: getState })=>{
            const { callbacks: callbacks, issueIds: issueIds } = getState();
            callbacks.onLegacyBulkEditRequest?.(issueIds);
        },
    updateProgress: (progress)=>({ setState: setState, getState: getState })=>{
            const { flagStatus: flagStatus, data: data } = getState();
            if (flagStatus !== (0, $2SnjZ.SubmitFlagStatus).ProgressFlag) return;
            setState({
                flagStatus: (0, $2SnjZ.SubmitFlagStatus).ProgressFlag,
                data: {
                    progress: progress,
                    taskId: data.taskId
                }
            });
        },
    setError: ()=>({ setState: setState, getState: getState })=>{
            const { callbacks: callbacks, issueIds: issueIds, interactionSource: interactionSource } = getState();
            if (interactionSource) (0, $e7WVN.setInteractionError)(interactionSource, {
                name: 'errorSubmitBulkEdit',
                errorMessage: `Error submitting changes for issues:${issueIds}`
            });
            callbacks.onUpdateError?.(issueIds);
            setState({
                flagStatus: (0, $2SnjZ.SubmitFlagStatus).ErrorFlag,
                data: {}
            });
        },
    setPartialError: (totalCount, failedCount, failedIssueKeys, failedIssueIds)=>({ setState: setState, getState: getState })=>{
            const { callbacks: callbacks } = getState();
            callbacks.onUpdateError?.(failedIssueIds.map(Number));
            setState({
                flagStatus: (0, $2SnjZ.SubmitFlagStatus).PartialErrorFlag,
                data: {
                    totalCount: totalCount,
                    failedCount: failedCount,
                    issueKeys: failedIssueKeys
                }
            });
        },
    setSuccess: (numberOfIssuesUpdated)=>({ setState: setState, getState: getState })=>{
            const { callbacks: callbacks, issueIds: issueIds } = getState();
            callbacks.onUpdateSuccess?.(issueIds);
            setState({
                flagStatus: (0, $2SnjZ.SubmitFlagStatus).SuccessFlag,
                data: {
                    numberOfIssuesUpdated: numberOfIssuesUpdated
                }
            });
        }
};

});
parcelRegister("dNaZ2", function(module, exports) {

$parcel$export(module.exports, "transformIssueArisToIds", () => $5b70fe4cf077e0c7$export$98b993b1def7c51b);

var $jUlV7 = parcelRequire("jUlV7");
const $5b70fe4cf077e0c7$export$98b993b1def7c51b = (issueAris)=>issueAris.map((issueAri)=>parseInt((0, $jUlV7.JiraIssueAri).parse(issueAri).issueId, 10));

});
parcelRegister("jUlV7", function(module, exports) {

$parcel$export(module.exports, "JiraIssueAri", () => $e7e440357f375b75$export$1da6808e89ee03e);

var $bQ5aj = parcelRequire("bQ5aj");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/jira/issue/manifest.ts
var $e7e440357f375b75$var$jiraIssueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $bQ5aj.JiraIssueAriResourceOwner),
    resourceType: (0, $bQ5aj.JiraIssueAriResourceType),
    resourceIdSlug: "{issueId}",
    resourceIdSegmentFormats: {
        issueId: /[0-9]+/
    }
};
// src/jira/issue/index.ts
var $e7e440357f375b75$export$1da6808e89ee03e = class _JiraIssueAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._issueId = opts.resourceIdSegmentValues.issueId;
    }
    get siteId() {
        return this._siteId;
    }
    get issueId() {
        return this._issueId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $e7e440357f375b75$var$jiraIssueAriStaticOpts.qualifier,
            platformQualifier: $e7e440357f375b75$var$jiraIssueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $e7e440357f375b75$var$jiraIssueAriStaticOpts.resourceOwner,
            resourceType: $e7e440357f375b75$var$jiraIssueAriStaticOpts.resourceType,
            resourceId: `${opts.issueId}`,
            resourceIdSegmentValues: {
                issueId: opts.issueId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $e7e440357f375b75$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $e7e440357f375b75$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            issueId: this.issueId
        };
    }
};

});
parcelRegister("bQ5aj", function(module, exports) {

$parcel$export(module.exports, "JiraIssueAriResourceOwner", () => $89e88ec215209f61$export$665a39f1b4e29e0a);
$parcel$export(module.exports, "JiraIssueAriResourceType", () => $89e88ec215209f61$export$76beb4d0da177ad4);
// src/jira/issue/types.ts
var $89e88ec215209f61$export$665a39f1b4e29e0a = "jira", $89e88ec215209f61$export$76beb4d0da177ad4 = "issue";

});



parcelRegister("2SnjZ", function(module, exports) {

$parcel$export(module.exports, "SubmitFlagStatus", () => $525bc18cc622d8e9$export$1f723227c515b0bc);
const $525bc18cc622d8e9$export$1f723227c515b0bc = {
    ProgressFlag: 'ProgressFlag',
    SuccessFlag: 'SuccessFlag',
    ErrorFlag: 'ErrorFlag',
    PartialErrorFlag: 'PartialErrorFlag',
    NoFlag: 'NoFlag'
};

});



parcelRegister("9by3l", function(module, exports) {

$parcel$export(module.exports, "EditFormSubmitStatus", () => $e83c157517cc4c24$export$ef11ca2bf4b4dcc1);

var $5uXOq = parcelRequire("5uXOq");

var $fJBgF = parcelRequire("fJBgF");

var $i39RY = parcelRequire("i39RY");

var $6B3QB = parcelRequire("6B3QB");
const $e83c157517cc4c24$export$ef11ca2bf4b4dcc1 = ()=>{
    (0, $6B3QB.useEditFormStatusFlags)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fJBgF.BulkOperationsErrorBoundary), {
        id: "bulk-operations.core.edit-form.submit-status.progress-polling"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i39RY.EditFormSubmitStatusProgressPolling), null));
};

});
parcelRegister("fJBgF", function(module, exports) {

$parcel$export(module.exports, "BulkOperationsErrorBoundary", () => $b64a81991de189c5$export$d8d35fe42889b9a4);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");
const $b64a81991de189c5$export$d8d35fe42889b9a4 = ({ id: id, children: children, fallback: fallback, onError: onError })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: id,
        packageName: "jiraBulkOperationsCommon",
        fallback: fallback || 'unmount',
        teamName: "deliveroo",
        onError: onError
    }, children);

});

parcelRegister("i39RY", function(module, exports) {

$parcel$export(module.exports, "EditFormSubmitStatusProgressPolling", () => $efb450c3ebbd83c0$export$6777d6eee8444c89);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $lfTZh = parcelRequire("lfTZh");

var $fMYkx = parcelRequire("fMYkx");

var $koeKL = parcelRequire("koeKL");

var $lWYYR = parcelRequire("lWYYR");

var $5ZcSp = parcelRequire("5ZcSp");

var $g1FBI = parcelRequire("g1FBI");
const $efb450c3ebbd83c0$export$6777d6eee8444c89 = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const { taskId: taskId } = (0, $lWYYR.useFormSubmitProgressData)() || {};
    const reset = (0, $5ZcSp.useResetFormSubmissionState)();
    const [queryReference, fetchFormStatus, disposeQuery] = (0, $8Uumt.useQueryLoader)((0, $fMYkx.default));
    const refetch = (0, $5uXOq.useCallback)((id)=>{
        fetchFormStatus({
            taskId: id,
            cloudId: cloudId
        }, {
            fetchPolicy: 'network-only'
        });
    }, [
        cloudId,
        fetchFormStatus
    ]);
    (0, $5uXOq.useEffect)(()=>reset, [
        reset
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (taskId) refetch(taskId);
    }, [
        refetch,
        taskId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!taskId) disposeQuery();
    }, [
        disposeQuery,
        taskId
    ]);
    return queryReference && taskId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "bulk-operations.core.form.submit-status.progress-polling",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g1FBI.ProgressPolling), {
        taskId: taskId,
        queryReference: queryReference,
        refetch: refetch
    })) : null;
};

});
parcelRegister("fMYkx", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2ea417a9f0cf75c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<40d6ef912a0c10b81e4bb6bf5d4de0cd>>
 * @relayHash 7fbd44b7b195b0263a244f68b9781379
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0ff9d3b1123e3ca95975e3b78d63122ba5c367587628b46eb1310db36a26717c
const $c2ea417a9f0cf75c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "taskId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "taskId",
            "variableName": "taskId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "progress"
    }, v3 = {
        "kind": "ScalarField",
        "name": "taskId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "status"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "mainEditFormSubmitStatus_progressPollingQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssueBulkOperationProgress",
                            "kind": "LinkedField",
                            "name": "bulkOperationProgress",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "kind": "FragmentSpread",
                                    "name": "processResponse_bulkOperationsCommon"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "mainEditFormSubmitStatus_progressPollingQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssueBulkOperationProgress",
                            "kind": "LinkedField",
                            "name": "bulkOperationProgress",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "totalIssueCount"
                                },
                                {
                                    "concreteType": "JiraIssueBulkOperationFailureConnection",
                                    "kind": "LinkedField",
                                    "name": "failedAccessibleIssues",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueBulkOperationFailureEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueBulkOperationFailure",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssue",
                                                            "kind": "LinkedField",
                                                            "name": "issue",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "issueId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "key"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "id"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0ff9d3b1123e3ca95975e3b78d63122ba5c367587628b46eb1310db36a26717c",
            "metadata": {},
            "name": "mainEditFormSubmitStatus_progressPollingQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c2ea417a9f0cf75c$var$node.hash = "5fda96b9fc7b0bf909c4b82c92314696";
var $c2ea417a9f0cf75c$export$2e2bcd8739ae039 = $c2ea417a9f0cf75c$var$node;

});

parcelRegister("5ZcSp", function(module, exports) {

$parcel$export(module.exports, "useFormStatusFlags", () => $3edf48c04f4e1eb8$export$6c43148bc841854a);
$parcel$export(module.exports, "useResetFormSubmissionState", () => $3edf48c04f4e1eb8$export$fc35d2af96f6134d);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");

var $lWYYR = parcelRequire("lWYYR");

var $2SnjZ = parcelRequire("2SnjZ");
const $3edf48c04f4e1eb8$export$6c43148bc841854a = ({ renderSuccessFlag: renderSuccessFlag, renderInProgressFlag: renderInProgressFlag, renderErrorFlag: renderErrorFlag, renderPartialErrorFlag: renderPartialErrorFlag })=>{
    const submitStatus = (0, $lWYYR.useFormSubmitStatus)();
    const existingFlagId = (0, $5uXOq.useRef)();
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    const { setIdle: setIdle, dismissPollingFlag: dismissPollingFlag } = (0, $lWYYR.useBulkOperationsFormSubmissionActions)();
    const dismissExistingFlag = (0, $5uXOq.useCallback)(()=>{
        if (existingFlagId.current) {
            dismissFlag(existingFlagId.current);
            existingFlagId.current = undefined;
        }
    }, [
        dismissFlag
    ]);
    const flags = (0, $5uXOq.useMemo)(()=>({
            [(0, $2SnjZ.SubmitFlagStatus).ProgressFlag]: {
                id: 'in-progress-flag',
                render: (props)=>renderInProgressFlag({
                        ...props,
                        onDismissed: dismissPollingFlag
                    })
            },
            [(0, $2SnjZ.SubmitFlagStatus).ErrorFlag]: {
                id: 'error-flag',
                render: (props)=>renderErrorFlag({
                        ...props,
                        onDismissed: setIdle
                    })
            },
            [(0, $2SnjZ.SubmitFlagStatus).PartialErrorFlag]: {
                id: 'partial-error-flag',
                render: (props)=>renderPartialErrorFlag({
                        ...props,
                        onDismissed: setIdle
                    })
            },
            [(0, $2SnjZ.SubmitFlagStatus).SuccessFlag]: {
                id: 'success-flag',
                render: (props)=>renderSuccessFlag({
                        ...props,
                        onDismissed: setIdle
                    })
            }
        }), [
        dismissPollingFlag,
        renderErrorFlag,
        renderInProgressFlag,
        renderPartialErrorFlag,
        renderSuccessFlag,
        setIdle
    ]);
    (0, $5uXOq.useEffect)(()=>dismissExistingFlag, [
        dismissExistingFlag
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const flag = flags[submitStatus];
        if (!flag) {
            dismissExistingFlag();
            return;
        }
        if (existingFlagId.current) setTimeout(()=>{
            existingFlagId.current = showFlag(flag);
            dismissFlag('in-progress-flag');
        }, 200);
        else existingFlagId.current = showFlag(flag);
    }, [
        dismissFlag,
        dismissExistingFlag,
        setIdle,
        flags,
        submitStatus,
        showFlag
    ]);
};
const $3edf48c04f4e1eb8$export$fc35d2af96f6134d = ()=>{
    const { setIdle: setIdle } = (0, $lWYYR.useBulkOperationsFormSubmissionActions)();
    return setIdle;
};

});

parcelRegister("g1FBI", function(module, exports) {

$parcel$export(module.exports, "ProgressPolling", () => $46ecdfb4535e4c5d$export$906b2a9d5f88a9d9);

var $fMYkx = parcelRequire("fMYkx");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $jcw0u = parcelRequire("jcw0u");

var $8cuDP = parcelRequire("8cuDP");

var $lWYYR = parcelRequire("lWYYR");

var $dCXqh = parcelRequire("dCXqh");

var $4ZuCq = parcelRequire("4ZuCq");
const $46ecdfb4535e4c5d$export$7f111648ca05f056 = 'bulkEditProgressPolling';
const $46ecdfb4535e4c5d$export$5578b12147815e51 = ()=>(0, $5uXOq.useRef)();
const $46ecdfb4535e4c5d$export$906b2a9d5f88a9d9 = ({ queryReference: queryReference, refetch: refetch, taskId: taskId })=>{
    const { logRetryAttempt: logRetryAttempt, retryStatus: retryStatus, resetRetryCount: resetRetryCount } = (0, $4ZuCq.useAllowedRetries)();
    const previousProgress = $46ecdfb4535e4c5d$export$5578b12147815e51();
    const { setError: setError } = (0, $lWYYR.useBulkOperationsFormSubmissionActions)();
    const data = (0, $8Uumt.usePreloadedQuery)((0, $fMYkx.default), queryReference);
    const { status: status, taskId: dataTaskId, progress: progress } = data.jira?.bulkOperationProgress || {};
    const retry = (0, $5uXOq.useCallback)(()=>{
        if (previousProgress.current !== progress) resetRetryCount();
        else /*  Log retry attempt as task error when no status/taskId returned.
               Task errors happen because there is a delay before task reaches progress queue.
               Delay P99 is ~1s. */ logRetryAttempt(!status || !dataTaskId);
        previousProgress.current = progress;
        refetch(dataTaskId || taskId);
    }, [
        progress,
        previousProgress,
        refetch,
        dataTaskId,
        taskId,
        resetRetryCount,
        logRetryAttempt,
        status
    ]);
    const clearRetryInterval = (0, $4ZuCq.useRetryInterval)(taskId, retry);
    (0, $5uXOq.useEffect)(()=>{
        if (retryStatus !== 'underLimit') {
            setError();
            if (retryStatus === 'maxTaskErrorAttemptsReached') (0, $jcw0u.default)({
                meta: (0, $8cuDP.getAnalyticsMeta)($46ecdfb4535e4c5d$export$7f111648ca05f056),
                error: new Error('jira.bulkOperationProgress is null or undefined')
            });
            clearRetryInterval();
        }
    }, [
        clearRetryInterval,
        retryStatus,
        setError
    ]);
    return data.jira?.bulkOperationProgress ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dCXqh.ProcessResponse), {
        fragmentRef: data.jira.bulkOperationProgress,
        onStopRetry: clearRetryInterval,
        retryStatus: retryStatus
    }) : null;
};

});
parcelRegister("8cuDP", function(module, exports) {

$parcel$export(module.exports, "generateButtonAction", () => $6c52ae02037233ac$export$523c4156c8b6dfec);
$parcel$export(module.exports, "getAnalyticsMeta", () => $6c52ae02037233ac$export$f43befd82d0c5b42);
const $6c52ae02037233ac$export$523c4156c8b6dfec = ({ onClick: onClick, text: text, width: width, onFocus: onFocus, appearance: appearance })=>({
        onClick: onClick,
        onFocus: onFocus,
        text: text,
        appearance: appearance,
        theme: (current, themeProps)=>appearance === 'link' ? {
                buttonStyles: {
                    ...current(themeProps).buttonStyles,
                    color: "var(--ds-text-discovery, #5E4DB2)"
                },
                spinnerStyles: current(themeProps).spinnerStyles
            } : {
                buttonStyles: {
                    ...current(themeProps).buttonStyles,
                    backgroundColor: "var(--ds-icon-discovery, #8270DB)",
                    color: "var(--ds-text-inverse, #FFFFFF)",
                    width: width && width
                },
                spinnerStyles: current(themeProps).spinnerStyles
            }
    });
const $6c52ae02037233ac$export$f43befd82d0c5b42 = (id)=>({
        id: id,
        packageName: 'jiraBulkOperationsCommon',
        teamName: 'deliveroo'
    });

});

parcelRegister("dCXqh", function(module, exports) {

$parcel$export(module.exports, "ProcessResponse", () => $14b2ad7a3e4a1b5b$export$e9b0d96d75994f3f);

var $6Y7c3 = parcelRequire("6Y7c3");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $jcw0u = parcelRequire("jcw0u");

var $8cuDP = parcelRequire("8cuDP");

var $lWYYR = parcelRequire("lWYYR");
const $14b2ad7a3e4a1b5b$export$7f111648ca05f056 = 'bulkEditProgressPolling';
const $14b2ad7a3e4a1b5b$var$CANCELLED = 'CANCELLED';
const $14b2ad7a3e4a1b5b$var$DEAD = 'DEAD';
const $14b2ad7a3e4a1b5b$var$FAILED = 'FAILED';
const $14b2ad7a3e4a1b5b$var$COMPLETE = 'COMPLETE';
const $14b2ad7a3e4a1b5b$export$e8667bfb18d4707c = [
    $14b2ad7a3e4a1b5b$var$CANCELLED,
    $14b2ad7a3e4a1b5b$var$DEAD,
    $14b2ad7a3e4a1b5b$var$FAILED
];
const $14b2ad7a3e4a1b5b$export$e9b0d96d75994f3f = /*#__PURE__*/ (0, $5uXOq.memo)(({ fragmentRef: fragmentRef, onStopRetry: onStopRetry, retryStatus: retryStatus })=>{
    const { setError: setError, setSuccess: setSuccess, updateProgress: updateProgress, setPartialError: setPartialError } = (0, $lWYYR.useBulkOperationsFormSubmissionActions)();
    const data = (0, $8Uumt.useFragment)((0, $6Y7c3.default), fragmentRef);
    const { status: status, totalIssueCount: totalIssueCount, progress: progress, failedAccessibleIssues: failedAccessibleIssues } = data;
    const { failedIds: failedIds, failedKeys: failedKeys } = (0, $5uXOq.useMemo)(()=>{
        const initial = {
            failedIds: [],
            failedKeys: []
        };
        return (failedAccessibleIssues?.edges || []).reduce((acc, curr)=>{
            const issue = curr?.node?.issue;
            if (issue?.issueId) acc.failedIds.push(Number(issue.issueId));
            if (issue?.key) acc.failedKeys.push(issue.key);
            return acc;
        }, initial);
    }, [
        failedAccessibleIssues
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (retryStatus !== 'underLimit') return;
        const isProgressFinished = status === $14b2ad7a3e4a1b5b$var$COMPLETE || $14b2ad7a3e4a1b5b$export$e8667bfb18d4707c.includes(status);
        const isPartialError = (status === $14b2ad7a3e4a1b5b$var$FAILED || status === $14b2ad7a3e4a1b5b$var$COMPLETE) && totalIssueCount && failedAccessibleIssues?.edges?.length;
        if (status === $14b2ad7a3e4a1b5b$var$COMPLETE && !totalIssueCount) (0, $jcw0u.default)({
            meta: (0, $8cuDP.getAnalyticsMeta)($14b2ad7a3e4a1b5b$export$7f111648ca05f056),
            error: new Error('jira.bulkOperationProgress.totalIssueCount is 0, null or undefined on task complete'),
            attributes: {
                totalIssueCount: totalIssueCount,
                failures: JSON.stringify(failedAccessibleIssues)
            }
        });
        if (isProgressFinished) {
            if (isPartialError) {
                const failedCount = failedIds.length;
                setPartialError(totalIssueCount, failedCount, failedKeys, failedIds.map(Number));
            } else if (status !== $14b2ad7a3e4a1b5b$var$COMPLETE) setError();
            onStopRetry();
            if (!isPartialError && status === $14b2ad7a3e4a1b5b$var$COMPLETE) setSuccess(totalIssueCount || 0);
            return;
        }
        if (progress) updateProgress(progress / 100);
    }, [
        failedAccessibleIssues,
        failedAccessibleIssues?.edges?.length,
        failedIds,
        failedKeys,
        onStopRetry,
        progress,
        retryStatus,
        setError,
        setPartialError,
        setSuccess,
        status,
        totalIssueCount,
        updateProgress
    ]);
    return null;
});

});
parcelRegister("6Y7c3", function(module, exports) {

$parcel$export(module.exports, "default", () => $253e67fdaf7e1c3a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ac9d636d8d9008c1a9afc7eb05dd5e9e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $253e67fdaf7e1c3a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "processResponse_bulkOperationsCommon",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "progress"
        },
        {
            "kind": "ScalarField",
            "name": "status"
        },
        {
            "kind": "ScalarField",
            "name": "totalIssueCount"
        },
        {
            "concreteType": "JiraIssueBulkOperationFailureConnection",
            "kind": "LinkedField",
            "name": "failedAccessibleIssues",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraIssueBulkOperationFailureEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraIssueBulkOperationFailure",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "issue",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "issueId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueBulkOperationProgress"
};
$253e67fdaf7e1c3a$var$node.hash = "6fd178055d35ff262e914a98799a4f45";
var $253e67fdaf7e1c3a$export$2e2bcd8739ae039 = $253e67fdaf7e1c3a$var$node;

});


parcelRegister("4ZuCq", function(module, exports) {

$parcel$export(module.exports, "useAllowedRetries", () => $49861852d9be3429$export$4ae93933b6be0be6);
$parcel$export(module.exports, "useRetryInterval", () => $49861852d9be3429$export$f61ff7daea15ab2c);

var $5uXOq = parcelRequire("5uXOq");
const $49861852d9be3429$export$dc3de1463a3f7c7c = 5;
const $49861852d9be3429$export$9359b1dc19be60fe = 2;
const $49861852d9be3429$export$996964a131ee58eb = 1500;
const $49861852d9be3429$export$4ae93933b6be0be6 = ()=>{
    const [retryStatus, setRetryStatus] = (0, $5uXOq.useState)('underLimit');
    const numberOfAttempts = (0, $5uXOq.useRef)(0);
    const isPreviousTaskError = (0, $5uXOq.useRef)();
    const logRetryAttempt = (0, $5uXOq.useCallback)((isTaskError)=>{
        if (isPreviousTaskError.current !== undefined && isPreviousTaskError.current !== isTaskError) numberOfAttempts.current = 0;
        numberOfAttempts.current += 1;
        if (numberOfAttempts.current >= (isTaskError ? $49861852d9be3429$export$9359b1dc19be60fe : $49861852d9be3429$export$dc3de1463a3f7c7c)) setRetryStatus(isTaskError ? 'maxTaskErrorAttemptsReached' : 'maxAttemptsReached');
        isPreviousTaskError.current = isTaskError;
    }, []);
    const resetRetryCount = (0, $5uXOq.useCallback)(()=>{
        setRetryStatus('underLimit');
        numberOfAttempts.current = 0;
    }, []);
    return {
        logRetryAttempt: logRetryAttempt,
        retryStatus: retryStatus,
        resetRetryCount: resetRetryCount
    };
};
const $49861852d9be3429$export$f61ff7daea15ab2c = (taskId, callback)=>{
    const callbackRef = (0, $5uXOq.useRef)(callback);
    (0, $5uXOq.useEffect)(()=>{
        // make a reference to the retry callback for setInterval to invoke.
        callbackRef.current = callback;
    }, [
        callback
    ]);
    const intervalId = (0, $5uXOq.useRef)();
    const clearRetryInterval = (0, $5uXOq.useCallback)(()=>{
        if (intervalId.current) {
            clearInterval(intervalId.current);
            intervalId.current = undefined;
        }
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        if (taskId) {
            const retry = ()=>{
                callbackRef.current();
            };
            intervalId.current = typeof window !== 'undefined' ? window.setInterval(retry, $49861852d9be3429$export$996964a131ee58eb) : undefined;
        }
        return clearRetryInterval;
    }, [
        clearRetryInterval,
        taskId
    ]);
    return clearRetryInterval;
};

});



parcelRegister("6B3QB", function(module, exports) {

$parcel$export(module.exports, "useEditFormStatusFlags", () => $28ccccb1017e9f12$export$7aafd3aa5686e9e5);

var $5uXOq = parcelRequire("5uXOq");

var $iAbh9 = parcelRequire("iAbh9");

var $5ZcSp = parcelRequire("5ZcSp");

var $1a1SF = parcelRequire("1a1SF");

var $4qiYI = parcelRequire("4qiYI");

var $eAH0D = parcelRequire("eAH0D");

var $KgqBB = parcelRequire("KgqBB");
const $28ccccb1017e9f12$export$7aafd3aa5686e9e5 = ()=>{
    const bulkOpsFlow = (0, $iAbh9.useBulkOpsSessionContext)();
    const renderInProgressFlag = (0, $5uXOq.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4qiYI.InProgressFlag), props), []);
    const renderSuccessFlag = (0, $5uXOq.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $KgqBB.OperationSuccessFlag), {
            ...props,
            bulkOpsFlow: bulkOpsFlow
        }), [
        bulkOpsFlow
    ]);
    const renderErrorFlag = (0, $5uXOq.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1a1SF.OperationErrorFlag), {
            ...props,
            bulkOpsFlow: bulkOpsFlow
        }), [
        bulkOpsFlow
    ]);
    const renderPartialErrorFlag = (0, $5uXOq.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eAH0D.OperationPartialErrorFlag), {
            ...props,
            bulkOpsFlow: bulkOpsFlow
        }), [
        bulkOpsFlow
    ]);
    (0, $5ZcSp.useFormStatusFlags)({
        renderInProgressFlag: renderInProgressFlag,
        renderSuccessFlag: renderSuccessFlag,
        renderErrorFlag: renderErrorFlag,
        renderPartialErrorFlag: renderPartialErrorFlag
    });
};

});
parcelRegister("1a1SF", function(module, exports) {

$parcel$export(module.exports, "OperationErrorFlag", () => $eaaa41da1a7ecf26$export$e8ce457da529d993);

var $5uXOq = parcelRequire("5uXOq");

var $3KRpp = parcelRequire("3KRpp");

var $koVbs = parcelRequire("koVbs");

var $lFyfa = parcelRequire("lFyfa");

var $lWYYR = parcelRequire("lWYYR");


var $5spBe = parcelRequire("5spBe");
const $eaaa41da1a7ecf26$export$e8ce457da529d993 = ({ onDismissed: onDismissed, bulkOpsFlow: bulkOpsFlow, ...props })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const issueIds = (0, $lWYYR.useFormSubmitIssueIds)();
    const analyticsAttributes = (0, $5uXOq.useMemo)(()=>({
            numSelectedCards: issueIds.length ?? 0,
            flagType: 'error'
        }), [
        issueIds.length
    ]);
    (0, $lFyfa.useFlagAnalytics)(analyticsAttributes, bulkOpsFlow);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.ErrorFlag), {
        ...props,
        testId: (0, $2ab1dd31d2bd7e94$export$a7bb072605d6094c),
        id: (0, $2ab1dd31d2bd7e94$export$5881677fb314e6d9),
        title: formatMessage((0, $5spBe.default).title),
        description: formatMessage((0, $5spBe.default).description),
        onDismissed: onDismissed,
        messageId: "bulk-operations-common.ui.submit-status.flags.error-flag",
        messageType: "transactional"
    });
};

});
parcelRegister("lFyfa", function(module, exports) {

$parcel$export(module.exports, "useFlagAnalytics", () => $962929ab66118301$export$f367641684fed076);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $962929ab66118301$export$f367641684fed076 = (attributes, bulkOpsFlow)=>{
    const analyticsEventFired = (0, $5uXOq.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        if (!analyticsEventFired.current) {
            const analyticsEvent = createAnalyticsEvent({
                actionSubject: 'bulkProcess',
                action: 'complete'
            });
            const actionSubjectId = bulkOpsFlow?.bulkOperationType;
            const analyticsAttributes = {
                ...attributes,
                bulkOpsSessionID: bulkOpsFlow?.sessionID
            };
            if (actionSubjectId) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, actionSubjectId, analyticsAttributes);
            else (0, $8zOmE.fireUIAnalytics)(analyticsEvent, analyticsAttributes);
            bulkOpsFlow?.setBulkOperationType(undefined);
            analyticsEventFired.current = true;
        }
    }, [
        createAnalyticsEvent,
        bulkOpsFlow,
        attributes
    ]);
};

});

const $2ab1dd31d2bd7e94$export$5881677fb314e6d9 = 'bulk-operations-core.edit-form.edit-form-status-flags.error-flag';
const $2ab1dd31d2bd7e94$export$a7bb072605d6094c = 'bulk-operations-core.ui.edit-form.edit-form-status-flags.error-flag';

parcelRegister("5spBe", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f294a6f2114edb8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8f294a6f2114edb8$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "bulk-operations-common.submit-status.flags.error-flag.title",
        "defaultMessage": "Failed to update"
    },
    description: {
        "id": "bulk-operations-common.submit-status.flags.error-flag.description",
        "defaultMessage": "We were unable to make those changes. Try again, or view the items that failed to update."
    }
});

});


parcelRegister("4qiYI", function(module, exports) {

$parcel$export(module.exports, "InProgressFlag", () => $d48b48811f386cd7$export$e75d6d3573e1e6fe);

var $5uXOq = parcelRequire("5uXOq");

var $1jWct = parcelRequire("1jWct");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $32MQk = parcelRequire("32MQk");

var $3KRpp = parcelRequire("3KRpp");

var $koVbs = parcelRequire("koVbs");

var $lWYYR = parcelRequire("lWYYR");


var $467wt = parcelRequire("467wt");
const $d48b48811f386cd7$export$e75d6d3573e1e6fe = ({ onDismissed: onDismissed, ...props })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const progressData = (0, $lWYYR.useFormSubmitProgressData)();
    const progress = progressData?.progress;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.InfoFlag), {
        ...props,
        testId: (0, $8d8e2c7303082419$export$a7bb072605d6094c),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1jWct))), {
            spacing: "spacious",
            color: "var(--ds-icon-information, #1D7AFC)",
            label: ""
        }),
        id: (0, $8d8e2c7303082419$export$5881677fb314e6d9),
        title: formatMessage((0, $467wt.default).title),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, $467wt.default).description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $d48b48811f386cd7$var$progressBarContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $32MQk.default), {
            ariaLabel: formatMessage((0, $467wt.default).title),
            isIndeterminate: !progress,
            value: progress
        }))),
        onDismissed: onDismissed,
        messageId: "bulk-operations-common.ui.submit-status.flags.in-progress-flag.info-flag.in-progress-flag",
        messageType: "transactional"
    });
};
const $d48b48811f386cd7$var$progressBarContainerStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.200'
});

});
parcelRegister("32MQk", function(module, exports) {

$parcel$export(module.exports, "default", () => $baa3bacea9c957c9$export$2e2bcd8739ae039);
/* progress-bar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");
const $baa3bacea9c957c9$var$MIN_VALUE = 0;
const $baa3bacea9c957c9$var$MAX_VALUE = 1;
const $baa3bacea9c957c9$var$increasingBarAnimation = null;
const $baa3bacea9c957c9$var$decreasingBarAnimation = null;
const $baa3bacea9c957c9$var$containerStyles = null;
const $baa3bacea9c957c9$var$containerAppearance = {
    default: "_bfhk1t45",
    success: "_bfhk1t45",
    inverse: "_bfhklgn7"
};
const $baa3bacea9c957c9$var$barAppearance = {
    default: "_bfhk1wby",
    success: "_bfhk1bh5",
    inverse: "_bfhkvuon"
};
const $baa3bacea9c957c9$var$barStyles = null;
const $baa3bacea9c957c9$var$determinateBarStyles = null;
const $baa3bacea9c957c9$var$increasingBarStyles = null;
const $baa3bacea9c957c9$var$decreasingBarStyles = null;
/**
 * __Progress bar__
 *
 * A progress bar displays the status of a given process.
 *
 * - [Examples](https://atlassian.design/components/progress-bar/examples)
 * - [Code](https://atlassian.design/components/progress-bar/code)
 * - [Usage](https://atlassian.design/components/progress-bar/usage)
 */ const $baa3bacea9c957c9$var$ProgressBar = ({ appearance: appearance = 'default', ariaLabel: ariaLabel, isIndeterminate: isIndeterminate = false, testId: testId = 'progress-bar', value: value = 0 })=>{
    const valueParsed = isIndeterminate ? $baa3bacea9c957c9$var$MIN_VALUE : Math.max($baa3bacea9c957c9$var$MIN_VALUE, Math.min(value, $baa3bacea9c957c9$var$MAX_VALUE));
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "progressbar",
        "aria-label": ariaLabel,
        "aria-valuemin": $baa3bacea9c957c9$var$MIN_VALUE,
        "aria-valuenow": valueParsed,
        "aria-valuemax": $baa3bacea9c957c9$var$MAX_VALUE,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_2rko1sit _1reo15vq _18m915vq _1bsb1osq _4t3ii2wt _kqswh2mm _bfhk1t45",
            $baa3bacea9c957c9$var$containerAppearance[appearance]
        ]),
        children: isIndeterminate ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                    className: (0, $bwpsq.default)([
                        "_2rko1sit _1e0c1ule _4t3ii2wt _kqswstnw",
                        $baa3bacea9c957c9$var$barAppearance[appearance],
                        "_5sagymdr _tip812c5 _j7hq7g40"
                    ])
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                    className: (0, $bwpsq.default)([
                        "_2rko1sit _1e0c1ule _4t3ii2wt _kqswstnw",
                        $baa3bacea9c957c9$var$barAppearance[appearance],
                        "_ju251bs3 _5sagymdr _tip812c5 _j7hqio0v"
                    ])
                })
            ]
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            style: {
                width: `${Number(value) * 100}%`
            },
            className: (0, $bwpsq.default)([
                "_2rko1sit _1e0c1ule _4t3ii2wt _kqswstnw",
                $baa3bacea9c957c9$var$barAppearance[appearance],
                "_v564calv"
            ])
        })
    });
};
var $baa3bacea9c957c9$export$2e2bcd8739ae039 = $baa3bacea9c957c9$var$ProgressBar;

});

const $8d8e2c7303082419$export$5881677fb314e6d9 = 'bulk-operations-core.edit-form.edit-form-status-flags.in-progress-flag';
const $8d8e2c7303082419$export$a7bb072605d6094c = 'bulk-operations-core.ui.edit-form.edit-form-status-flags.in-progress-flag';

parcelRegister("467wt", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad0f48248e41a6f7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ad0f48248e41a6f7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "bulk-operations-common.submit-status.flags.in-progress-flag.title",
        "defaultMessage": "Bulk action in progress"
    },
    description: {
        "id": "bulk-operations-common.submit-status.flags.in-progress-flag.description",
        "defaultMessage": "Stay on this page until the bulk action is finished."
    }
});

});


parcelRegister("eAH0D", function(module, exports) {

$parcel$export(module.exports, "OperationPartialErrorFlag", () => $3e92f97fd9b21aaf$export$3229b80e24d6bab4);

var $5uXOq = parcelRequire("5uXOq");

var $3KRpp = parcelRequire("3KRpp");

var $5Zxxp = parcelRequire("5Zxxp");

var $koVbs = parcelRequire("koVbs");

var $lFyfa = parcelRequire("lFyfa");

var $lWYYR = parcelRequire("lWYYR");


var $3sBIG = parcelRequire("3sBIG");
const $3e92f97fd9b21aaf$export$3229b80e24d6bab4 = ({ onDismissed: onDismissed, bulkOpsFlow: bulkOpsFlow, ...props })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const issueIds = (0, $lWYYR.useFormSubmitIssueIds)();
    const errorData = (0, $lWYYR.useFormSubmitErrorData)();
    const openInProductHelp = (0, $5Zxxp.useHelpPanelLink)();
    const analyticsAttributes = (0, $5uXOq.useMemo)(()=>({
            numSelectedCards: issueIds.length ?? 0,
            numFailedCards: errorData?.failedCount ?? 0,
            failedIssueKeys: errorData?.issueKeys ?? [],
            flagType: 'error'
        }), [
        errorData?.failedCount,
        errorData?.issueKeys,
        issueIds.length
    ]);
    (0, $lFyfa.useFlagAnalytics)(analyticsAttributes, bulkOpsFlow);
    const getViewSummaryURL = (0, $5uXOq.useMemo)(()=>{
        const errorDataIssueIds = errorData?.issueKeys?.join(',');
        const jqlSearch = encodeURIComponent(`issueKey in (${errorDataIssueIds})`);
        return `/issues/?jql=${jqlSearch}`;
    }, [
        errorData?.issueKeys
    ]);
    const handleLearnMoreClick = (0, $5uXOq.useCallback)(()=>{
        openInProductHelp((0, $cd9a3566c0552310$export$353a2cc7a64c70f2));
    }, [
        openInProductHelp
    ]);
    const flagActions = (0, $5uXOq.useMemo)(()=>[
            {
                content: formatMessage((0, $3sBIG.default).viewSummary),
                href: getViewSummaryURL,
                target: '_blank'
            },
            {
                content: formatMessage((0, $3sBIG.default).learnMore),
                onClick: handleLearnMoreClick
            }
        ], [
        formatMessage,
        getViewSummaryURL,
        handleLearnMoreClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.ErrorFlag), {
        ...props,
        testId: (0, $cd9a3566c0552310$export$a7bb072605d6094c),
        id: (0, $cd9a3566c0552310$export$5881677fb314e6d9),
        title: formatMessage((0, $3sBIG.default).title, {
            failedCount: errorData?.failedCount,
            totalCount: errorData?.totalCount
        }),
        description: formatMessage((0, $3sBIG.default).description),
        onDismissed: onDismissed,
        messageId: "bulk-operations-common.ui.submit-status.flags.partial-error-flag.error-flag",
        messageType: "transactional",
        actions: flagActions
    });
};

});
const $cd9a3566c0552310$export$5881677fb314e6d9 = 'bulk-operations-core.edit-form.edit-form-status-flags.partial-error-flag';
const $cd9a3566c0552310$export$a7bb072605d6094c = 'bulk-operations-core.ui.edit-form.edit-form-status-flags.partial-error-flag';
const $cd9a3566c0552310$export$353a2cc7a64c70f2 = '62h4g5fA9BUhungZSSNyEl';

parcelRegister("3sBIG", function(module, exports) {

$parcel$export(module.exports, "default", () => $d677c629c32f2537$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d677c629c32f2537$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "bulk-operations-common.submit-status.flags.partial-error-flag.title",
        "defaultMessage": "{failedCount}/{totalCount} items not updated"
    },
    description: {
        "id": "bulk-operations-common.submit-status.flags.partial-error-flag.description",
        "defaultMessage": "We were unable to update some of the items. View summary to view the items that failed to update."
    },
    viewSummary: {
        "id": "bulk-operations-common.submit-status.flags.partial-error-flag.view-summary",
        "defaultMessage": "View summary"
    },
    learnMore: {
        "id": "bulk-operations-common.submit-status.flags.partial-error-flag.learn-more",
        "defaultMessage": "Learn more"
    }
});

});


parcelRegister("KgqBB", function(module, exports) {

$parcel$export(module.exports, "OperationSuccessFlag", () => $bce6226a9eee46d7$export$3a6420f74b01547e);

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $3KRpp = parcelRequire("3KRpp");

var $koVbs = parcelRequire("koVbs");

var $lFyfa = parcelRequire("lFyfa");

var $lWYYR = parcelRequire("lWYYR");


var $6Kmv8 = parcelRequire("6Kmv8");
const $bce6226a9eee46d7$export$3a6420f74b01547e = ({ onDismissed: onDismissed, bulkOpsFlow: bulkOpsFlow, ...props })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const flagData = (0, $lWYYR.useFormSubmitFlagData)();
    const issueIds = (0, $lWYYR.useFormSubmitIssueIds)();
    const count = (0, $5uXOq.useRef)((0, $lWYYR.useFormSubmitSuccessData)());
    const analyticsAttributes = (0, $5uXOq.useMemo)(()=>({
            numSelectedCards: issueIds.length,
            flagType: 'success',
            numCardsUpdated: count.current
        }), [
        issueIds.length
    ]);
    (0, $lFyfa.useFlagAnalytics)(analyticsAttributes, bulkOpsFlow);
    const flagDescription = (0, $5uXOq.useMemo)(()=>{
        if (flagData && flagData.customDescription && (0, $6s1PB.expVal)('bulk_watch_unwatch', 'isEnabled', false)) return flagData.customDescription;
        if ((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) return formatMessage((0, $6Kmv8.default).descriptionIssueTermRefresh, {
            count: count.current
        });
        return formatMessage((0, $6Kmv8.default).description, {
            count: count.current
        });
    }, [
        flagData,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.SuccessFlag), {
        ...props,
        testId: (0, $e16d5662adf0a415$export$a7bb072605d6094c),
        id: (0, $e16d5662adf0a415$export$5881677fb314e6d9),
        title: formatMessage((0, $6Kmv8.default).title),
        description: flagDescription,
        onDismissed: onDismissed,
        messageId: "bulk-operations-common.ui.submit-status.flags.success-flag",
        messageType: "transactional"
    });
};

});
const $e16d5662adf0a415$export$5881677fb314e6d9 = 'bulk-operations-core.edit-form.edit-form-status-flags.submit-success-flag';
const $e16d5662adf0a415$export$a7bb072605d6094c = 'bulk-operations-core.ui.edit-form.edit-form-status-flags.operation-success-flag';

parcelRegister("6Kmv8", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecab86bc54831efa$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ecab86bc54831efa$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "bulk-operations-common.submit-status.flags.success-flag.title",
        "defaultMessage": "Bulk action complete"
    },
    description: {
        "id": "bulk-operations-common.submit-status.flags.success-flag.description",
        "defaultMessage": "You\u2019ve edited {count, plural, one {# issue} other {# issues}}."
    },
    descriptionIssueTermRefresh: {
        "id": "bulk-operations-common.submit-status.flags.success-flag.description-issue-term-refresh",
        "defaultMessage": "You\u2019ve edited {count, plural, one {# work item} other {# work items}}."
    }
});

});




parcelRegister("fvbIR", function(module, exports) {

$parcel$export(module.exports, "asyncBulkOpsCoreEntryPoint", () => $187b82d9aad4ec6a$export$d90d57132636bb1);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $187b82d9aad4ec6a$export$d90d57132636bb1 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("cliXS")), {
        moduleId: "f81933b6"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("cliXS", function(module, exports) {

let $8fc628381702f5c0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8fc628381702f5c0$var$load("3bwa5").then(()=>parcelRequire('k9wdm'));

});



parcelRegister("a4GFE", function(module, exports) {

$parcel$export(module.exports, "useBulkEditCacheActions", () => $e13377b68f17ae57$export$cbb9dab75d903148);

var $5uXOq = parcelRequire("5uXOq");

var $fn8B5 = parcelRequire("fn8B5");

var $daQYX = parcelRequire("daQYX");

var $4R6GH = parcelRequire("4R6GH");

var $deqCE = parcelRequire("deqCE");

var $hlKA4 = parcelRequire("hlKA4");

var $5VgIi = parcelRequire("5VgIi");

var $5fc53 = parcelRequire("5fc53");

var $6s1PB = parcelRequire("6s1PB");

var $61h55 = parcelRequire("61h55");

var $bsMMx = parcelRequire("bsMMx");

var $8TUlY = parcelRequire("8TUlY");

var $9u99d = parcelRequire("9u99d");

var $4u33f = parcelRequire("4u33f");
const $e13377b68f17ae57$export$cbb9dab75d903148 = ()=>{
    const { updateItemsInCache: updateItemsInCache } = (0, $hlKA4.useCacheActions)();
    const [{ issuesMap: issuesMap, issueParentMap: issueParentMap, childrenItems: childrenItems }] = (0, $9u99d.useHierarchyStore)();
    const { getQueryFieldIds: getQueryFieldIds } = (0, $8TUlY.useIssueFields)();
    const queryFieldIds = getQueryFieldIds();
    const { key: projectKey } = (0, $daQYX.useProject)();
    const { updateIssueParent: updateIssueParent, unlinkParentIssue: unlinkParentIssue } = (0, $5VgIi.useUpdateIssueParent)({
        childrenQueryData: childrenItems,
        fieldIds: queryFieldIds,
        issuesMap: issuesMap,
        issueParentMap: issueParentMap,
        cacheQuery: (0, $61h55.LIST_VIEW_QUERY),
        removeChildFromParent: (0, $bsMMx.removeChildFromParentListView),
        addChildToParent: (0, $bsMMx.addChildToParentListView),
        view: 'list',
        packageName: 'jiraBusinessList',
        shouldOnlyUpdateCache: true,
        projectKey: projectKey
    });
    const updateSelectedItemsInCache = (0, $5uXOq.useCallback)(({ data: data, issueIds: issueIds })=>{
        const selectedIssuesByParent = (0, (/*@__PURE__*/$parcel$interopDefault($fn8B5)))([
            ...issueIds.map((issueId)=>issueId.toString())
        ], (issueId)=>issuesMap.get(issueId)?.parentIssueId || (0, $deqCE.ROOT_LEVEL));
        const parents = Object.entries(selectedIssuesByParent);
        const optimisticUpdateIssue = (existingIssue)=>{
            const updatedIssue = {
                ...existingIssue,
                fields: [
                    ...existingIssue.fields?.filter((field)=>!Object.keys(data).includes(field?.fieldId)) ?? [],
                    ...(0, $4u33f.transformData)(existingIssue, data)
                ]
            };
            return updatedIssue;
        };
        parents.forEach(([, issues])=>{
            const variables = issuesMap.get(issues[0])?.cacheVariables;
            if (variables !== undefined) {
                updateItemsInCache({
                    query: (0, $61h55.LIST_VIEW_QUERY),
                    variables: {
                        ...variables,
                        isUnreadCommentsEnabled: (0, $6s1PB.expVal)('jira_unread_comments_in_list_view', 'isEnabled', false),
                        includeIsVerifiedInTeamFragment: (0, $4R6GH.fg)('is-verified-in-business-team-field-fragment')
                    },
                    issueIds: issues,
                    updateItem: optimisticUpdateIssue
                });
                if (data?.[0, $5fc53.PARENT_TYPE] !== undefined) issues.forEach((issueId)=>{
                    if (data?.[0, $5fc53.PARENT_TYPE]?.id) {
                        const parentIssue = issuesMap.get(data?.[0, $5fc53.PARENT_TYPE].id.toString());
                        if (parentIssue) updateIssueParent({
                            issueKey: issueId,
                            parentIssue: parentIssue
                        });
                    } else unlinkParentIssue({
                        issueKey: issueId
                    });
                });
            }
        });
    }, [
        issuesMap,
        updateItemsInCache,
        updateIssueParent,
        unlinkParentIssue
    ]);
    return {
        updateSelectedItemsInCache: updateSelectedItemsInCache
    };
};

});
parcelRegister("5VgIi", function(module, exports) {

$parcel$export(module.exports, "useUpdateIssueParent", () => $31f00dbe71d3540f$export$346cb12ae0ad6251);

var $5uXOq = parcelRequire("5uXOq");

var $egmQO = parcelRequire("egmQO");

var $koVbs = parcelRequire("koVbs");

var $1T2vX = parcelRequire("1T2vX");

var $cm8b5 = parcelRequire("cm8b5");

var $kRkJF = parcelRequire("kRkJF");

var $dqDis = parcelRequire("dqDis");

var $jcw0u = parcelRequire("jcw0u");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $pa9q9 = parcelRequire("pa9q9");

var $5fc53 = parcelRequire("5fc53");

var $hlKA4 = parcelRequire("hlKA4");

var $eVIe2 = parcelRequire("eVIe2");

var $cM59n = parcelRequire("cM59n");

var $4KWeK = parcelRequire("4KWeK");

var $keaDy = parcelRequire("keaDy");
const $31f00dbe71d3540f$export$346cb12ae0ad6251 = ({ childrenQueryData: childrenQueryData = {}, fieldIds: fieldIds, issueParentMap: issueParentMap, issuesMap: issuesMap, cacheQuery: cacheQuery, addChildToParent: addChildToParent, removeChildFromParent: removeChildFromParent, view: view, packageName: packageName, shouldOnlyUpdateCache: shouldOnlyUpdateCache = false, projectKey: projectKey })=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const intl = (0, $koVbs.default)();
    const { hierarchyLevels: hierarchyLevels } = (0, $1T2vX.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const { quickFiltersJql: quickFiltersJql, hierarchyParent: hierarchyParent, jqlContext: jqlContext, isHidingDoneItems: isHidingDoneItems } = (0, $kRkJF.useFilteredViewContextInput)({
        view: view
    });
    const { addToCache: addToCache, getCachedIssueById: getCachedIssueById, removeFromCache: removeFromCache, updateItemsInCache: updateItemsInCache } = (0, $hlKA4.useCacheActions)();
    const [newParentIssue, setNewParentIssue] = (0, $5uXOq.useState)();
    const [reparentIssue, setReparentIssue] = (0, $5uXOq.useState)();
    const [optimisticRank, setOptimisticRank] = (0, $5uXOq.useState)('');
    const shouldAddToCache = (0, $5uXOq.useRef)(false);
    const [revertData, setRevertData] = (0, $5uXOq.useState)(null);
    const updateParentIssueExperience = (0, $4KWeK.getUpdateParentIssueExperience)(packageName);
    const startExperience = (0, $cm8b5.useExperienceStart)(updateParentIssueExperience);
    const markExperienceSuccess = (0, $cm8b5.useExperienceSuccess)(updateParentIssueExperience);
    const markExperienceFailed = (0, $cm8b5.useExperienceFail)(updateParentIssueExperience);
    const updateIssueField = (0, $cM59n.useUpdateIssueField)({
        onSuccess: ()=>{
            markExperienceSuccess();
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onError: (error, updateIssueFieldErrorPayload)=>{
            const showWorkTypeDetails = updateIssueFieldErrorPayload.issueKey && updateIssueFieldErrorPayload.workType && (0, $6s1PB.expVal)('jira-itr-m4-exp-3', 'isEnabled', false);
            if (error.statusCode === 400) {
                if (showWorkTypeDetails) showFlag((0, $keaDy.getRankItemFail400FlagWithWorkType)(intl, updateIssueFieldErrorPayload));
                else showFlag((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $4KWeK.UPDATE_ITEM_PARENT_FAIL_400_FLAG_WITH_ISSUE_TERM) : (0, $4KWeK.UPDATE_ITEM_PARENT_FAIL_400_FLAG));
            } else if (error.statusCode === 404) {
                if (showWorkTypeDetails) showFlag((0, $keaDy.getRankItemFail404FlagWithWorkType)(intl, updateIssueFieldErrorPayload));
                else showFlag((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $4KWeK.UPDATE_ITEM_PARENT_FAIL_404_FLAG_WITH_ISSUE_TERM) : (0, $4KWeK.UPDATE_ITEM_PARENT_FAIL_404_FLAG));
            } else {
                showFlag((0, $4KWeK.UPDATE_ITEM_PARENT_FAIL_GENERIC_FLAG));
                markExperienceFailed('update issue parent failed', error);
            }
            throw error;
        }
    });
    const getRankPosition = (0, $5uXOq.useCallback)((rankRequest)=>{
        if (!rankRequest) return;
        const relativeIssueId = rankRequest.rankAfterId || rankRequest.rankBeforeId;
        if (relativeIssueId) {
            const relativeIssue = issuesMap.get(relativeIssueId);
            const relativeIssueRank = rankRequest.rankPosition || relativeIssue?.rank;
            if (relativeIssueRank) {
                const { rankBeforeId: rankBeforeId } = rankRequest;
                return rankBeforeId ? (0, $dqDis.getPreviousRank)(relativeIssueRank) : (0, $dqDis.getNextRank)(relativeIssueRank);
            }
        }
    }, [
        issuesMap
    ]);
    const getVariablesInput = (0, $5uXOq.useCallback)((parentId)=>{
        const defaultVariableInput = {
            jqlContext: jqlContext,
            fieldIds: fieldIds,
            quickFiltersJql: quickFiltersJql,
            isHidingDoneItems: isHidingDoneItems,
            ...hierarchyLevels !== undefined && {
                hierarchyLevel: hierarchyLevels[0]?.level
            },
            // project clause is only used in List view to render issues with parents from foreign projects
            projectIdOrKey: projectKey
        };
        if (hierarchyParent && parentId) return {
            ...defaultVariableInput,
            hierarchyParent: undefined,
            parentIssue: {
                hierarchyType: hierarchyParent,
                issueId: parentId
            }
        };
        return {
            ...defaultVariableInput,
            hierarchyParent: hierarchyParent
        };
    }, [
        jqlContext,
        fieldIds,
        quickFiltersJql,
        isHidingDoneItems,
        hierarchyLevels,
        projectKey,
        hierarchyParent
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (hierarchyParent && newParentIssue && reparentIssue) {
            const { issueId: newParentId, hasChildren: hasChildren, childSummary: childSummary } = newParentIssue;
            if (childrenQueryData[newParentId] && childrenQueryData[newParentId].loading === false) {
                const grandParentId = issueParentMap?.get(newParentId) ?? newParentIssue?.parentIssueId;
                if (!hasChildren || typeof childSummary?.totalCount === 'number') // Update parent issue hasChildren to true
                updateItemsInCache({
                    query: cacheQuery,
                    // We need to get the details of the current parent from the grandparent
                    variables: (0, $egmQO.getVariables)(getVariablesInput(grandParentId)),
                    issueIds: [
                        newParentIssue.issueId
                    ],
                    updateItem: (existingIssue)=>addChildToParent(existingIssue)
                });
                if ((0, $4R6GH.fg)('jwm_timeline_meatball_reparent_menu')) {
                    if (shouldAddToCache.current) {
                        const variables = (0, $egmQO.getVariables)(getVariablesInput(newParentId));
                        const newNode = (0, $keaDy.generateIssueWithUpdatedParent)(reparentIssue, newParentIssue, view);
                        addToCache({
                            query: cacheQuery,
                            variables: variables,
                            newNodes: [
                                optimisticRank ? (0, $eVIe2.getOptimisticRanked)(newNode, optimisticRank) : newNode
                            ]
                        });
                        shouldAddToCache.current = false;
                        setReparentIssue(undefined);
                        setNewParentIssue(undefined);
                        setOptimisticRank('');
                    }
                } else {
                    const variables = (0, $egmQO.getVariables)(getVariablesInput(newParentId));
                    const newNode = (0, $keaDy.generateIssueWithUpdatedParent)(reparentIssue, newParentIssue, view);
                    addToCache({
                        query: cacheQuery,
                        variables: variables,
                        newNodes: [
                            optimisticRank ? (0, $eVIe2.getOptimisticRanked)(newNode, optimisticRank) : newNode
                        ]
                    });
                    setReparentIssue(undefined);
                    setNewParentIssue(undefined);
                    setOptimisticRank('');
                }
            }
        }
    }, [
        addToCache,
        childrenQueryData,
        getVariablesInput,
        hierarchyParent,
        isHidingDoneItems,
        jqlContext,
        quickFiltersJql,
        newParentIssue,
        reparentIssue,
        updateItemsInCache,
        getCachedIssueById,
        issueParentMap,
        optimisticRank,
        cacheQuery,
        addChildToParent,
        issuesMap,
        view
    ]);
    const updateIssueParentCache = (0, $5uXOq.useCallback)(({ oldParentId: oldParentId, issueKey: issueKey, parentIssue: parentIssue, isMeatballsAction: isMeatballsAction })=>{
        const variables = (0, $egmQO.getVariables)(getVariablesInput(oldParentId));
        const issue = getCachedIssueById({
            issueId: issueKey,
            query: cacheQuery,
            variables: variables
        });
        setNewParentIssue(parentIssue);
        if (issue) {
            setReparentIssue(issue);
            // If update parent action is from meatballs menu and new parent is not expanded, don't use optimistic update
            // Otherwise, it will cause the updated issue unmounted and remounted in timeline-table
            // which will cause the focus can't return to meatballs button after the reparent (for keyboard user)
            if (isMeatballsAction && !(childrenQueryData[parentIssue.issueId] && childrenQueryData[parentIssue.issueId].loading === false) && (0, $4R6GH.fg)('jwm_timeline_meatball_reparent_menu')) return;
            // Remove the issue from the old parent
            removeFromCache({
                query: cacheQuery,
                variables: variables,
                issueId: Number(issueKey)
            });
            if ((0, $4R6GH.fg)('jwm_timeline_meatball_reparent_menu')) {
                if (childrenQueryData[parentIssue.issueId] && childrenQueryData[parentIssue.issueId].loading === false) {
                    const originalRank = issuesMap.get(String(issueKey))?.rank;
                    // Add the issue to the new parent if parent issue already expanded
                    const newVariable = (0, $egmQO.getVariables)(getVariablesInput(parentIssue.issueId));
                    const newNode = (0, $keaDy.generateIssueWithUpdatedParent)(issue, parentIssue, view);
                    addToCache({
                        query: cacheQuery,
                        variables: newVariable,
                        newNodes: [
                            originalRank ? (0, $eVIe2.getOptimisticRanked)(newNode, originalRank) : newNode
                        ]
                    });
                } else shouldAddToCache.current = true;
            }
            // update child count of prev parent
            if (oldParentId && removeChildFromParent) {
                const grandParentId = issuesMap.get(oldParentId)?.parentIssueId;
                const queryVariables = (0, $egmQO.getVariables)(getVariablesInput(grandParentId));
                updateItemsInCache({
                    query: cacheQuery,
                    variables: queryVariables,
                    issueIds: [
                        String(oldParentId)
                    ],
                    updateItem: (existingParentIssue)=>removeChildFromParent(existingParentIssue, 1)
                });
            }
        }
    }, [
        getVariablesInput,
        getCachedIssueById,
        cacheQuery,
        removeFromCache,
        childrenQueryData,
        removeChildFromParent,
        view,
        addToCache,
        issuesMap,
        updateItemsInCache
    ]);
    const unlinkParentIssueCache = (0, $5uXOq.useCallback)(({ issueKey: issueKey, oldParentId: oldParentId, updateRank: updateRank })=>{
        const variables = (0, $egmQO.getVariables)(getVariablesInput(oldParentId));
        const issue = getCachedIssueById({
            issueId: issueKey,
            query: cacheQuery,
            variables: variables
        });
        // Remove the issue from the old parent
        removeFromCache({
            query: cacheQuery,
            variables: variables,
            issueId: Number(issueKey)
        });
        // update child count of prev parent
        if (oldParentId && removeChildFromParent) {
            const grandParentId = issuesMap.get(oldParentId)?.parentIssueId;
            const queryVariables = (0, $egmQO.getVariables)(getVariablesInput(grandParentId));
            updateItemsInCache({
                query: cacheQuery,
                variables: queryVariables,
                issueIds: [
                    String(oldParentId)
                ],
                updateItem: (parentIssue)=>removeChildFromParent(parentIssue, 1)
            });
        }
        const reparentIssueVariable = (0, $egmQO.getVariables)(getVariablesInput());
        if (issue) {
            const newNode = (0, $keaDy.generateIssueWithUpdatedParent)(issue, undefined, view);
            // Add issue to the top level
            addToCache({
                query: cacheQuery,
                variables: reparentIssueVariable,
                newNodes: [
                    updateRank ? (0, $eVIe2.getOptimisticRanked)(newNode, updateRank) : newNode
                ]
            });
        }
    }, [
        getVariablesInput,
        getCachedIssueById,
        cacheQuery,
        removeFromCache,
        removeChildFromParent,
        issuesMap,
        updateItemsInCache,
        view,
        addToCache
    ]);
    const revertOptimisticCacheUpdate = (0, $5uXOq.useCallback)(({ originalParentId: originalParentId, parentIssue: parentIssue, issueKey: issueKey, originalRank: originalRank })=>{
        const originalParent = originalParentId && issuesMap.get(originalParentId);
        if (originalParent) updateIssueParentCache({
            oldParentId: parentIssue?.issueId,
            issueKey: issueKey,
            parentIssue: originalParent
        });
        else if (originalRank && parentIssue) unlinkParentIssueCache({
            oldParentId: parentIssue.issueId,
            issueKey: issueKey,
            updateRank: originalRank
        });
    }, [
        issuesMap,
        unlinkParentIssueCache,
        updateIssueParentCache
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (revertData && revertData.parentIssue?.issueId && childrenQueryData[revertData.parentIssue.issueId] && childrenQueryData[revertData.parentIssue.issueId].loading === false) {
            const { originalParentId: originalParentId, parentIssue: parentIssue, issueKey: issueKey, originalRank: originalRank } = revertData;
            originalRank && setOptimisticRank(originalRank);
            revertOptimisticCacheUpdate({
                originalParentId: originalParentId,
                parentIssue: parentIssue,
                issueKey: issueKey,
                originalRank: originalRank
            });
            setRevertData(null);
        }
    }, [
        childrenQueryData,
        revertData,
        revertOptimisticCacheUpdate
    ]);
    const updateIssueParent = (0, $5uXOq.useCallback)(async ({ issueKey: issueKey, parentIssue: parentIssue, rankRequest: rankRequest, oldParentIssueId: oldParentIssueId, isMeatballsAction: isMeatballsAction })=>{
        !shouldOnlyUpdateCache && startExperience();
        const updateRank = getRankPosition(rankRequest);
        if (updateRank) setOptimisticRank(updateRank);
        const issue = issuesMap.get(String(issueKey));
        const originalRank = issue?.rank;
        const oldParentId = oldParentIssueId ?? issueParentMap?.get(issueKey);
        updateIssueParentCache({
            oldParentId: oldParentId,
            issueKey: issueKey,
            parentIssue: parentIssue,
            isMeatballsAction: isMeatballsAction
        });
        if (shouldOnlyUpdateCache) {
            await Promise.resolve();
            return {
                updateStatus: (0, $4KWeK.SUCCEEDED)
            };
        }
        try {
            await updateIssueField({
                issueKey: issueKey,
                fieldKey: (0, $5fc53.PARENT_TYPE),
                newValue: {
                    id: String(parentIssue.issueId)
                },
                workType: issue?.issuetype?.name,
                key: issue?.key
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: (0, $4KWeK.ERROR_ID),
                    packageName: (0, $4KWeK.PACKAGE_NAME),
                    teamName: (0, $4KWeK.TEAM_NAME)
                },
                attributes: {
                    message: 'update issue parent failed',
                    parentLevel: parentIssue?.issueType?.hierarchyLevel,
                    issueLevel: issue?.issueType?.hierarchyLevel,
                    view: view
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            setRevertData({
                originalParentId: oldParentId,
                parentIssue: parentIssue,
                issueKey: issueKey,
                originalRank: originalRank
            });
            return {
                updateStatus: (0, $4KWeK.FAILED)
            };
        }
        return {
            updateStatus: (0, $4KWeK.SUCCEEDED)
        };
    }, [
        shouldOnlyUpdateCache,
        startExperience,
        getRankPosition,
        issuesMap,
        issueParentMap,
        updateIssueParentCache,
        updateIssueField,
        view
    ]);
    const unlinkParentIssue = (0, $5uXOq.useCallback)(async ({ issueKey: issueKey, rankRequest: rankRequest, oldParentIssueId: oldParentIssueId })=>{
        const issue = issuesMap.get(String(issueKey));
        !shouldOnlyUpdateCache && startExperience();
        const oldParentId = oldParentIssueId || issueParentMap?.get(issueKey);
        const updateRank = getRankPosition(rankRequest);
        const originalRank = issuesMap.get(String(issueKey))?.rank;
        unlinkParentIssueCache({
            issueKey: issueKey,
            oldParentId: oldParentId,
            updateRank: updateRank
        });
        if (shouldOnlyUpdateCache) {
            await Promise.resolve();
            return {
                updateStatus: (0, $4KWeK.SUCCEEDED)
            };
        }
        try {
            await updateIssueField({
                issueKey: issueKey,
                fieldKey: (0, $5fc53.PARENT_TYPE),
                newValue: {
                    id: null
                },
                workType: issue?.issuetype?.name,
                key: issue?.key
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: (0, $4KWeK.ERROR_ID),
                    packageName: (0, $4KWeK.PACKAGE_NAME),
                    teamName: (0, $4KWeK.TEAM_NAME)
                },
                attributes: {
                    message: 'unlink issue parent failed',
                    issueLevel: issue?.issueType?.hierarchyLevel,
                    view: view
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            if (originalRank) {
                setOptimisticRank(originalRank);
                revertOptimisticCacheUpdate({
                    originalParentId: oldParentId,
                    issueKey: issueKey
                });
            }
            return {
                updateStatus: (0, $4KWeK.FAILED)
            };
        }
        return {
            updateStatus: (0, $4KWeK.SUCCEEDED)
        };
    }, [
        shouldOnlyUpdateCache,
        startExperience,
        issueParentMap,
        getRankPosition,
        issuesMap,
        unlinkParentIssueCache,
        updateIssueField,
        view,
        revertOptimisticCacheUpdate
    ]);
    return {
        updateIssueParent: updateIssueParent,
        unlinkParentIssue: unlinkParentIssue
    };
};

});
parcelRegister("eVIe2", function(module, exports) {

$parcel$export(module.exports, "getOptimisticRanked", () => $c396479aef7761d0$export$44963c8ed1f74aef);
$parcel$export(module.exports, "getListViewRelativeIssueInfo", () => $c396479aef7761d0$export$caf645882630a6c1);

var $5fc53 = parcelRequire("5fc53");
const $c396479aef7761d0$export$44963c8ed1f74aef = (issue, rank)=>{
    const newRank = {
        ...issue?.fields?.find(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (field)=>field.type === (0, $5fc53.RANK_CF_TYPE) || field.aliasFieldId === 'rank')
    };
    newRank.text = rank;
    return {
        ...issue,
        fields: [
            ...issue?.fields?.filter(// eslint-disable-next-line @typescript-eslint/no-explicit-any
            (field)=>field.type !== (0, $5fc53.RANK_CF_TYPE) && field.aliasFieldId !== 'rank') || [],
            newRank
        ]
    };
};
const $c396479aef7761d0$export$caf645882630a6c1 = ({ newIndex: newIndex, oldIndex: oldIndex, issues: issues, instruction: instruction, relativeIssueOverride: relativeIssueOverride })=>{
    let rankCall = newIndex === 0 ? 'rankBefore' : 'rankAfter';
    // instruction will only be available ranking via dnd
    if (instruction) rankCall = instruction === 'reorder-below' ? 'rankAfter' : 'rankBefore';
    // if newIndex is 0 we want to optimistically rank it above the task that is
    // currently at index 0 of the collection
    let afterIndex = newIndex > oldIndex ? newIndex : Math.max(0, newIndex - 1);
    // newIndex will equal oldIndex in cases where we dnd to reparent and rank
    if (newIndex === oldIndex) afterIndex = rankCall === 'rankAfter' ? Math.max(0, newIndex - 1) : newIndex;
    let relativeIssue = relativeIssueOverride ?? issues[afterIndex];
    // if issue to rank after doesn't have a rank eg. group item then let's try and
    // rank before instead
    if (!relativeIssue?.rank) {
        const beforeIndex = newIndex > oldIndex ? Math.min(issues.length - 1, newIndex + 1) : newIndex;
        relativeIssue = issues[beforeIndex];
        rankCall = 'rankBefore';
    }
    return {
        rankCall: rankCall,
        relativeIssue: relativeIssue
    };
};

});

parcelRegister("cM59n", function(module, exports) {

$parcel$export(module.exports, "useUpdateIssueField", () => $9bfd5ad22b59743a$export$cc74d3329dbba44d);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $99cgx = parcelRequire("99cgx");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $9bfd5ad22b59743a$var$JWM_ISSUE_FIELD_UPDATE = 'jwmIssueFieldUpdate';
const $9bfd5ad22b59743a$export$cc74d3329dbba44d = ({ onError: onError, onSuccess: onSuccess })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const updateIssueField = (0, $5uXOq.useCallback)(async ({ issueKey: issueKey, fieldKey: fieldKey, newValue: newValue, workType: workType, key: key })=>(0, $99cgx.defaultSaveField)(issueKey, fieldKey, newValue, '').then((response)=>{
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), `${$9bfd5ad22b59743a$var$JWM_ISSUE_FIELD_UPDATE} succeeded`, {
                field: newValue
            });
            onSuccess && onSuccess();
            return response;
        }).catch((error)=>{
            (0, $jcw0u.default)({
                meta: {
                    id: $9bfd5ad22b59743a$var$JWM_ISSUE_FIELD_UPDATE,
                    packageName: 'jiraBusinessListHandlers',
                    teamName: 'keystone'
                },
                attributes: {
                    message: `${$9bfd5ad22b59743a$var$JWM_ISSUE_FIELD_UPDATE} failed`,
                    field: fieldKey.startsWith('customfield_') ? 'category' : fieldKey
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            onError && onError(error, {
                issueKey: key,
                workType: workType
            });
        }), [
        createAnalyticsEvent,
        onError,
        onSuccess
    ]);
    return updateIssueField;
};

});
parcelRegister("99cgx", function(module, exports) {

$parcel$export(module.exports, "defaultSaveField", () => $2a246664763defba$export$b74e6b7f831f1cb2);
$parcel$export(module.exports, "defaultSaveFieldById", () => $2a246664763defba$export$b2c49aae5d84cced);
$parcel$export(module.exports, "defaultAddValuesToField", () => $2a246664763defba$export$c46c7284cd9c5d3);
$parcel$export(module.exports, "defaultRemoveValuesFromField", () => $2a246664763defba$export$33b78476f5d734b3);

var $eusud = parcelRequire("eusud");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2a246664763defba$var$getFieldUpdate = (fieldKey, value)=>({
        fields: {
            [fieldKey]: value
        }
    });
const $2a246664763defba$export$b74e6b7f831f1cb2 = async (issueKey, fieldKey, newValue, _baseUrl)=>(0, $eusud.performPutRequest)(`/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify($2a246664763defba$var$getFieldUpdate(fieldKey, newValue))
    });
const $2a246664763defba$export$b2c49aae5d84cced = async (issueKey, fieldKey, newValue, _baseUrl)=>(0, $eusud.performPutRequest)(`/rest/api/3/issue/${issueKey}/?returnIssue=true`, {
        body: JSON.stringify($2a246664763defba$var$getFieldUpdate(fieldKey, newValue))
    });
const $2a246664763defba$export$c46c7284cd9c5d3 = async (issueKey, fieldKey, valuesToAdd, _baseUrl)=>{
    const updateParam = {
        update: {
            [fieldKey]: [
                {
                    operation: 'add',
                    value: valuesToAdd
                }
            ]
        }
    };
    return (0, $eusud.performPutRequest)(`/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify(updateParam)
    });
};
const $2a246664763defba$export$33b78476f5d734b3 = async (issueKey, fieldKey, valuesToRemove, _baseUrl)=>{
    const updateParam = {
        update: {
            [fieldKey]: [
                {
                    operation: 'remove',
                    value: valuesToRemove
                }
            ]
        }
    };
    return (0, $eusud.performPutRequest)(`/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify(updateParam)
    });
};

});


parcelRegister("4KWeK", function(module, exports) {

$parcel$export(module.exports, "UPDATE_ITEM_PARENT_FAIL_GENERIC_FLAG", () => $524da9ace56d1024$export$e80b28191e1d3602);
$parcel$export(module.exports, "UPDATE_ITEM_PARENT_FAIL_400_FLAG", () => $524da9ace56d1024$export$29d372313e7a3d7b);
$parcel$export(module.exports, "UPDATE_ITEM_PARENT_FAIL_400_FLAG_WITH_ISSUE_TERM", () => $524da9ace56d1024$export$a75bfbb3fb2f437c);
$parcel$export(module.exports, "UPDATE_ITEM_PARENT_FAIL_404_FLAG", () => $524da9ace56d1024$export$6a4ca5120f2baf63);
$parcel$export(module.exports, "UPDATE_ITEM_PARENT_FAIL_404_FLAG_WITH_ISSUE_TERM", () => $524da9ace56d1024$export$4cba4bafd925e182);
$parcel$export(module.exports, "getUpdateParentIssueExperience", () => $524da9ace56d1024$export$8f39ff4e40cb6a05);
$parcel$export(module.exports, "SUCCEEDED", () => $524da9ace56d1024$export$11823571c61d4d02);
$parcel$export(module.exports, "FAILED", () => $524da9ace56d1024$export$d71930f7f5807a72);
$parcel$export(module.exports, "PACKAGE_NAME", () => $524da9ace56d1024$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "ERROR_ID", () => $524da9ace56d1024$export$f3390a0e172fee41);
$parcel$export(module.exports, "TEAM_NAME", () => $524da9ace56d1024$export$d57b6b390e78d90f);

var $gqQjF = parcelRequire("gqQjF");
const $524da9ace56d1024$export$e80b28191e1d3602 = {
    type: 'error',
    title: (0, $gqQjF.default).updateIssueParentErrorTitle,
    description: (0, $gqQjF.default).updateIssueParentGenericErrorDescription,
    messageId: 'business-list-handlers.controllers.update-issue-parent.update-item-parent-fail-generic-flag.error.error.update-item-parent-fail-generic-flag',
    messageType: 'transactional'
};
const $524da9ace56d1024$export$29d372313e7a3d7b = {
    type: 'error',
    title: (0, $gqQjF.default).updateIssueParentErrorTitle,
    description: (0, $gqQjF.default).updateIssueParent400ErrorDescription,
    messageId: 'business-list-handlers.controllers.update-issue-parent.update-item-parent-fail-400-flag.error.error.update-item-parent-fail-400-flag',
    messageType: 'transactional'
};
const $524da9ace56d1024$export$a75bfbb3fb2f437c = {
    type: 'error',
    title: (0, $gqQjF.default).updateIssueParentErrorTitle,
    description: (0, $gqQjF.default).updateIssueParent400ErrorDescriptionIssueTermRefresh,
    messageId: 'business-list-handlers.controllers.update-issue-parent.update-item-parent-fail-400-flag-with-issue-term.error.error.update-item-parent-fail-400-flag-with-issue-term',
    messageType: 'transactional'
};
const $524da9ace56d1024$export$6a4ca5120f2baf63 = {
    type: 'error',
    title: (0, $gqQjF.default).updateIssueParentErrorTitle,
    description: (0, $gqQjF.default).updateIssueParent404ErrorDescription,
    messageId: 'business-list-handlers.controllers.update-issue-parent.update-item-parent-fail-404-flag.error.error.update-item-parent-fail-404-flag',
    messageType: 'transactional'
};
const $524da9ace56d1024$export$4cba4bafd925e182 = {
    type: 'error',
    title: (0, $gqQjF.default).updateIssueParentErrorTitle,
    description: (0, $gqQjF.default).updateIssueParent404ErrorDescriptionIssueTermRefresh,
    messageId: 'business-list-handlers.controllers.update-issue-parent.update-item-parent-fail-404-flag-with-issue-term.error.error.update-item-parent-fail-404-flag-with-issue-term',
    messageType: 'transactional'
};
const $524da9ace56d1024$export$8f39ff4e40cb6a05 = (packageName)=>({
        experience: 'updateParentIssue',
        packageName: packageName,
        teamName: 'keystone'
    });
const $524da9ace56d1024$export$11823571c61d4d02 = 'SUCCEEDED';
const $524da9ace56d1024$export$d71930f7f5807a72 = 'FAILED';
const $524da9ace56d1024$export$b8b9d90f9e5bd72b = 'jiraBusinessListHandlers';
const $524da9ace56d1024$export$f3390a0e172fee41 = 'useUpdateIssueParent';
const $524da9ace56d1024$export$d57b6b390e78d90f = 'keystone';

});
parcelRegister("gqQjF", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0fc83ceaf8c6923$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c0fc83ceaf8c6923$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    updateIssueParentErrorTitle: {
        "id": "business-list-handlers.controllers.update-issue-parent.update-issue-parent-error-title",
        "defaultMessage": "Something's gone wrong"
    },
    updateIssueParentGenericErrorDescription: {
        "id": "business-list-handlers.controllers.update-issue-parent.update-issue-parent-generic-error-description",
        "defaultMessage": "Refresh the page and try again."
    },
    updateIssueParent400ErrorDescription: {
        "id": "business-list-handlers.controllers.update-issue-parent.update-issue-parent-400-error-description",
        "defaultMessage": "You don\u2019t have permission to update this issue. Contact a project admin."
    },
    updateIssueParent400ErrorTitleIssueTerminologyRefreshM4: {
        "id": "business-list-handlers.controllers.update-issue-parent.update-issue-parent-400-error-title-issue-terminology-refresh-m4",
        "defaultMessage": "You don\u2019t have permission to update this {workType} {issueKey}"
    },
    updateIssueParent400ErrorDescriptionIssueTerminologyRefreshM4: {
        "id": "business-list-handlers.controllers.update-issue-parent.update-issue-parent-400-error-description-issue-terminology-refresh-m4",
        "defaultMessage": "Contact your project admin."
    },
    updateIssueParent404ErrorDescription: {
        "id": "business-list-handlers.controllers.update-issue-parent.update-issue-parent-404-error-description",
        "defaultMessage": "We\u2019re having trouble updating this issue. To continue, refresh the page."
    },
    updateIssueParent404ErrorTitleIssueTerminologyRefreshM4: {
        "id": "business-list-handlers.controllers.update-issue-parent.update-issue-parent-404-error-title-issue-terminology-refresh-m4",
        "defaultMessage": "We\u2019re having trouble updating {workType} {issueKey}"
    },
    updateIssueParent404ErrorDescriptionIssueTerminologyRefreshM4: {
        "id": "business-list-handlers.controllers.update-issue-parent.update-issue-parent-404-error-description-issue-terminology-refresh-m4",
        "defaultMessage": "Refresh and try again."
    },
    updateIssueParent400ErrorDescriptionIssueTermRefresh: {
        "id": "business-list-handlers.controllers.update-issue-parent.update-issue-parent-400-error-description-issue-term-refresh",
        "defaultMessage": "You don\u2019t have permission to update this work item. Contact a project admin."
    },
    updateIssueParent404ErrorDescriptionIssueTermRefresh: {
        "id": "business-list-handlers.controllers.update-issue-parent.update-issue-parent-404-error-description-issue-term-refresh",
        "defaultMessage": "We\u2019re having trouble updating this work item. To continue, refresh the page."
    }
});

});


parcelRegister("keaDy", function(module, exports) {

$parcel$export(module.exports, "generateIssueWithUpdatedParent", () => $2bb42896f508435e$export$2b799a607e235a03);
$parcel$export(module.exports, "getRankItemFail400FlagWithWorkType", () => $2bb42896f508435e$export$4bde91eba02a7762);
$parcel$export(module.exports, "getRankItemFail404FlagWithWorkType", () => $2bb42896f508435e$export$2d4a7410e074364d);

var $5fc53 = parcelRequire("5fc53");

var $gqQjF = parcelRequire("gqQjF");
const $2bb42896f508435e$export$32c176d5dc779b09 = (rank)=>rank ? [
        {
            aliasFieldId: 'rank',
            text: rank,
            __typename: 'JiraSingleLineTextField'
        }
    ] : null;
const $2bb42896f508435e$var$generateParentField = (issueId, key, id, rank, view)=>{
    const shouldHaveIdAttribute = view === 'list';
    return {
        aliasFieldId: null,
        fieldId: (0, $5fc53.PARENT_TYPE),
        type: (0, $5fc53.PARENT_TYPE),
        name: 'Parent',
        parentIssue: issueId && key ? {
            __typename: 'JiraIssue',
            issueId: issueId,
            key: key,
            ...shouldHaveIdAttribute ? {
                id: id
            } : {},
            rankField: $2bb42896f508435e$export$32c176d5dc779b09(rank)
        } : null,
        __typename: 'JiraParentIssueField'
    };
};
const $2bb42896f508435e$export$2b799a607e235a03 = (issue, newParentIssue, view)=>{
    const { issueId: newParentIssueId, key: newParentKey, id: newParentId, rank: newParentRank } = newParentIssue || {};
    const parentFieldIndex = issue?.fields?.findIndex((field)=>field.type === (0, $5fc53.PARENT_TYPE) || field.fieldId === (0, $5fc53.PARENT_TYPE));
    const shouldHaveIdAttribute = view === 'list';
    const parentField = parentFieldIndex !== -1 && parentFieldIndex !== undefined ? {
        ...issue?.fields?.[parentFieldIndex],
        parentIssue: !newParentIssueId || !newParentKey ? null : {
            ...shouldHaveIdAttribute ? {
                id: newParentId
            } : {},
            issueId: newParentIssueId,
            rankField: $2bb42896f508435e$export$32c176d5dc779b09(newParentRank),
            key: newParentKey,
            __typename: 'JiraIssue'
        }
    } : $2bb42896f508435e$var$generateParentField(newParentIssueId, newParentKey, newParentId, newParentRank, view);
    return {
        ...issue,
        fields: [
            ...issue?.fields?.filter((field)=>field.type !== (0, $5fc53.PARENT_TYPE) && field.fieldId !== (0, $5fc53.PARENT_TYPE)) || [],
            parentField
        ]
    };
};
const $2bb42896f508435e$export$4bde91eba02a7762 = (intl, { issueKey: issueKey, workType: workType })=>{
    return {
        type: 'error',
        title: intl.formatMessage((0, $gqQjF.default).updateIssueParent400ErrorTitleIssueTerminologyRefreshM4, {
            issueKey: issueKey,
            workType: workType
        }),
        description: intl.formatMessage((0, $gqQjF.default).updateIssueParent400ErrorDescriptionIssueTerminologyRefreshM4, {
            issueKey: issueKey,
            workType: workType
        }),
        messageId: 'business-list-handlers.controllers.update-issue-parent.flag.error.use-rank-issue.flag.error.rank-item-fail-generic-flag.error.error.rank-item-fail-generic-flag.1',
        messageType: 'transactional'
    };
};
const $2bb42896f508435e$export$2d4a7410e074364d = (intl, { issueKey: issueKey, workType: workType })=>{
    return {
        type: 'error',
        title: intl.formatMessage((0, $gqQjF.default).updateIssueParent404ErrorTitleIssueTerminologyRefreshM4, {
            issueKey: issueKey,
            workType: workType
        }),
        description: intl.formatMessage((0, $gqQjF.default).updateIssueParent404ErrorDescriptionIssueTerminologyRefreshM4, {
            issueKey: issueKey,
            workType: workType
        }),
        messageId: 'business-list-handlers.controllers.update-issue-parent.flag.error.use-rank-issue.flag.error.rank-item-fail-generic-flag.error.error.rank-item-fail-generic-flag.1.1',
        messageType: 'transactional'
    };
};

});


parcelRegister("4u33f", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $fd962ec12b5e85da$export$3ceb62baab058c6b);

var $1tNy6 = parcelRequire("1tNy6");
const $fd962ec12b5e85da$export$3ceb62baab058c6b = (existingIssue, data)=>{
    const optimisticUpdateFields = [];
    return Object.keys(data).reduce((acc, fieldId)=>{
        const accumulator = acc;
        const existingField = existingIssue.fields?.find((field)=>field.fieldId === fieldId);
        if (existingField) {
            if ((0, $1tNy6.isOptimisticUpdateSupported)(existingField.type)) {
                const fieldFormValue = data[existingField.fieldId];
                if (fieldFormValue === undefined) return accumulator;
                const transformedField = (0, $1tNy6.transformFieldForOptimisticUpdates)(existingField.type, existingField, fieldFormValue);
                if (transformedField !== undefined) accumulator.push(transformedField);
            } else accumulator.push(existingField);
        }
        return accumulator;
    }, optimisticUpdateFields);
};

});
parcelRegister("1tNy6", function(module, exports) {

$parcel$export(module.exports, "transformFieldForOptimisticUpdates", () => $f81bbc933ba84564$export$efcd89b84c6a3e91);
$parcel$export(module.exports, "isOptimisticUpdateSupported", () => $f81bbc933ba84564$export$d96ec240de147154);

var $8QpSo = parcelRequire("8QpSo");

var $cjwQR = parcelRequire("cjwQR");

var $7TMJD = parcelRequire("7TMJD");

var $8gg2R = parcelRequire("8gg2R");

var $ipj45 = parcelRequire("ipj45");

var $dfRts = parcelRequire("dfRts");

var $huhmz = parcelRequire("huhmz");

var $1W9Eo = parcelRequire("1W9Eo");

var $5Tu55 = parcelRequire("5Tu55");

var $5oQ5q = parcelRequire("5oQ5q");

var $bHeL8 = parcelRequire("bHeL8");

var $cTipH = parcelRequire("cTipH");

var $8fxvG = parcelRequire("8fxvG");
const $f81bbc933ba84564$var$createSupportedBulkEditTransformations = (0, $8QpSo.default)(()=>({
        ...(0, $1W9Eo.priorityOptimisticUpdatesHandler),
        ...(0, $cTipH.userOptimisticUpdatesHandler),
        ...(0, $8gg2R.labelsOptimisticUpdatesHandler),
        ...(0, $cjwQR.dateOptimisticUpdatesHandler),
        ...(0, $7TMJD.dateTimeOptimisticUpdatesHandler),
        ...(0, $ipj45.multiSelectOptimisticUpdatesHandler),
        ...(0, $dfRts.numberOptimisticUpdatesHandler),
        ...(0, $huhmz.parentOptimisticUpdatesHandler),
        ...(0, $8fxvG.versionOptimisticUpdatesHandler),
        ...(0, $5Tu55.singleSelectOptimisticUpdatesHandler),
        ...(0, $bHeL8.urlOptimisticUpdatesHandler),
        ...(0, $5oQ5q.textOptimisticUpdatesHandler)
    }));
const $f81bbc933ba84564$export$efcd89b84c6a3e91 = (fieldType, ...args)=>{
    const handlers = $f81bbc933ba84564$var$createSupportedBulkEditTransformations();
    if (!handlers[fieldType]) return;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return handlers[fieldType](...args);
};
const $f81bbc933ba84564$export$d96ec240de147154 = (fieldType)=>{
    const handlers = $f81bbc933ba84564$var$createSupportedBulkEditTransformations();
    return handlers[fieldType] !== null;
};

});
parcelRegister("cjwQR", function(module, exports) {

$parcel$export(module.exports, "dateOptimisticUpdatesHandler", () => $675901b25b250cde$export$f6ab9c7ce755192);

var $5fc53 = parcelRequire("5fc53");
const $675901b25b250cde$export$fb826df18639e2fa = (existingField, fieldData)=>({
        ...existingField,
        date: fieldData ?? null
    });
const $675901b25b250cde$export$f6ab9c7ce755192 = {
    [(0, $5fc53.DATE_CF_TYPE)]: $675901b25b250cde$export$fb826df18639e2fa,
    [(0, $5fc53.DUE_DATE_TYPE)]: $675901b25b250cde$export$fb826df18639e2fa,
    [(0, $5fc53.START_DATE_TYPE)]: $675901b25b250cde$export$fb826df18639e2fa
};

});

parcelRegister("7TMJD", function(module, exports) {

$parcel$export(module.exports, "dateTimeOptimisticUpdatesHandler", () => $5d84f1e94dc3713c$export$a24474a096daecea);

var $5fc53 = parcelRequire("5fc53");
const $5d84f1e94dc3713c$export$3863479bf706ee55 = (existingField, fieldData)=>({
        ...existingField,
        dateTime: fieldData ?? null
    });
const $5d84f1e94dc3713c$export$a24474a096daecea = {
    [(0, $5fc53.DATETIME_CF_TYPE)]: $5d84f1e94dc3713c$export$3863479bf706ee55
};

});

parcelRegister("8gg2R", function(module, exports) {

$parcel$export(module.exports, "labelsOptimisticUpdatesHandler", () => $69575aae1fc11e8b$export$ae3a6c05d0376219);

var $5fc53 = parcelRequire("5fc53");

var $1s49T = parcelRequire("1s49T");
const $69575aae1fc11e8b$export$24889be11660a2f9 = (existingField, fieldData)=>{
    const action = fieldData.action;
    const existingLabels = existingField.selectedLabelsConnection?.edges?.map((edge)=>edge?.node).filter(Boolean) ?? [];
    const labelNodes = (0, $1s49T.transformOptionsUsingMultiAction)({
        existingOptions: existingLabels,
        options: fieldData.value.map((value)=>({
                __typename: 'JiraLabel',
                labelId: null,
                name: value.value
            })),
        action: action,
        isEqual: (option, existingOption)=>option.name === existingOption.name
    });
    return {
        ...existingField,
        selectedLabelsConnection: {
            __typename: 'JiraLabelConnection',
            edges: labelNodes?.map((node)=>({
                    __typename: 'JiraLabelEdge',
                    node: node
                })) ?? null
        }
    };
};
const $69575aae1fc11e8b$export$ae3a6c05d0376219 = {
    [(0, $5fc53.LABELS_TYPE)]: $69575aae1fc11e8b$export$24889be11660a2f9
};

});
parcelRegister("1s49T", function(module, exports) {

$parcel$export(module.exports, "transformOptionsUsingMultiAction", () => $553b6571b5146a7e$export$de5a9a8aa203227b);
const $553b6571b5146a7e$export$de5a9a8aa203227b = ({ existingOptions: existingOptions, options: options, action: action, isEqual: isEqual })=>{
    if (action === 'set') return options;
    if (action === 'add') return [
        ...existingOptions.filter((existingOption)=>options.some((option)=>!isEqual(option, existingOption))),
        ...options
    ];
    if (action === 'remove') return existingOptions.filter((existingOption)=>options.some((option)=>!isEqual(option, existingOption)));
    return null;
};

});


parcelRegister("ipj45", function(module, exports) {

$parcel$export(module.exports, "multiSelectOptimisticUpdatesHandler", () => $4c6a47d622007833$export$451576b5e993a4c6);

var $5fc53 = parcelRequire("5fc53");
const $4c6a47d622007833$export$6308785fb410c4b7 = (existingField, fieldData)=>({
        ...existingField,
        selectedOptions: {
            __typename: 'JiraOptionConnection',
            edges: fieldData.map((field)=>({
                    __typename: 'JiraOptionEdge',
                    node: {
                        __typename: 'JiraOption',
                        optionId: '',
                        value: field.value
                    }
                }))
        }
    });
const $4c6a47d622007833$export$451576b5e993a4c6 = {
    [(0, $5fc53.MULTI_SELECT_CF_TYPE)]: $4c6a47d622007833$export$6308785fb410c4b7
};

});

parcelRegister("dfRts", function(module, exports) {

$parcel$export(module.exports, "numberOptimisticUpdatesHandler", () => $65867e0dbf8cbf13$export$b507b41c3a04d8b2);

var $5fc53 = parcelRequire("5fc53");
const $65867e0dbf8cbf13$export$db1d3572e95020a7 = (existingField, fieldData)=>({
        ...existingField,
        number: fieldData
    });
const $65867e0dbf8cbf13$export$b507b41c3a04d8b2 = {
    [(0, $5fc53.NUMBER_CF_TYPE)]: $65867e0dbf8cbf13$export$db1d3572e95020a7,
    [(0, $5fc53.STORY_POINTS_TYPE)]: $65867e0dbf8cbf13$export$db1d3572e95020a7,
    [(0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE)]: $65867e0dbf8cbf13$export$db1d3572e95020a7
};

});

parcelRegister("huhmz", function(module, exports) {

$parcel$export(module.exports, "parentOptimisticUpdatesHandler", () => $948415c29bf235c9$export$beaef88a0d44b30c);

var $5fc53 = parcelRequire("5fc53");
const $948415c29bf235c9$export$b807f08dd17c9fef = (existingField, fieldData)=>({
        ...existingField,
        parentIssue: {
            __typename: 'JiraIssue',
            id: fieldData.id?.toString() || '',
            issueId: fieldData.value.toString(),
            key: fieldData.key,
            rankField: [],
            fields: [
                {
                    fieldId: 'summary',
                    aliasFieldId: null,
                    name: 'Summary',
                    type: 'summary',
                    text: fieldData.fields.summary,
                    __typename: 'JiraSingleLineTextField'
                },
                {
                    fieldId: 'issuetype',
                    aliasFieldId: null,
                    name: 'Issue Type',
                    type: 'issuetype',
                    __typename: 'JiraIssueTypeField',
                    issueType: {
                        __typename: 'JiraIssueType',
                        name: fieldData?.fields?.issuetype?.name || '',
                        avatar: {
                            medium: fieldData?.fields?.issuetype?.iconUrl?.replace('xsmall', 'medium'),
                            __typename: 'JiraAvatar'
                        }
                    }
                }
            ]
        }
    });
const $948415c29bf235c9$export$beaef88a0d44b30c = {
    [(0, $5fc53.PARENT_TYPE)]: $948415c29bf235c9$export$b807f08dd17c9fef
};

});

parcelRegister("1W9Eo", function(module, exports) {

$parcel$export(module.exports, "priorityOptimisticUpdatesHandler", () => $4e87693315b8215f$export$1722f398d0e70c01);

var $2O65s = parcelRequire("2O65s");

var $5fc53 = parcelRequire("5fc53");
const $4e87693315b8215f$export$5096de161ee14da = (existingField, fieldData)=>{
    const priorityId = fieldData.value && (0, $2O65s.JiraPriorityAri).check(fieldData.value) ? (0, $2O65s.JiraPriorityAri).parse(fieldData.value).resourceId : fieldData?.value ?? '';
    return {
        ...existingField,
        priority: {
            id: fieldData.value ?? '',
            name: fieldData.label,
            priorityId: priorityId,
            iconUrl: fieldData.iconUrl,
            __typename: 'JiraPriority'
        }
    };
};
const $4e87693315b8215f$export$1722f398d0e70c01 = {
    [(0, $5fc53.PRIORITY_TYPE)]: $4e87693315b8215f$export$5096de161ee14da
};

});

parcelRegister("5Tu55", function(module, exports) {

$parcel$export(module.exports, "singleSelectOptimisticUpdatesHandler", () => $376f9aee475cbb0c$export$3bfe96bec4aaa3d1);

var $5fc53 = parcelRequire("5fc53");
const $376f9aee475cbb0c$export$1c2a2f3ef1a9bb3 = (existingField, fieldData)=>{
    if (fieldData === null) return {
        ...existingField,
        fieldOption: null
    };
    return {
        ...existingField,
        fieldOption: {
            __typename: 'JiraOption',
            optionId: fieldData.value,
            value: fieldData.label,
            color: null
        }
    };
};
const $376f9aee475cbb0c$export$3bfe96bec4aaa3d1 = {
    [(0, $5fc53.SELECT_CF_TYPE)]: $376f9aee475cbb0c$export$1c2a2f3ef1a9bb3
};

});

parcelRegister("5oQ5q", function(module, exports) {

$parcel$export(module.exports, "textOptimisticUpdatesHandler", () => $26cb1f779e5562aa$export$6d32d6f2341892ca);

var $5fc53 = parcelRequire("5fc53");
const $26cb1f779e5562aa$export$dff85ea10550e176 = (existingField, fieldData)=>({
        ...existingField,
        text: !fieldData ? ' ' : fieldData
    });
const $26cb1f779e5562aa$export$6d32d6f2341892ca = {
    [(0, $5fc53.TEXT_CF_TYPE)]: $26cb1f779e5562aa$export$dff85ea10550e176
};

});

parcelRegister("bHeL8", function(module, exports) {

$parcel$export(module.exports, "urlOptimisticUpdatesHandler", () => $1a3fe8279dbe22b4$export$5275c3199d66bb55);

var $5fc53 = parcelRequire("5fc53");
const $1a3fe8279dbe22b4$export$2fdc0fb9ea4e0c38 = (existingField, fieldData)=>({
        ...existingField,
        uri: !fieldData ? null : fieldData
    });
const $1a3fe8279dbe22b4$export$5275c3199d66bb55 = {
    [(0, $5fc53.URL_CF_TYPE)]: $1a3fe8279dbe22b4$export$2fdc0fb9ea4e0c38
};

});

parcelRegister("cTipH", function(module, exports) {

$parcel$export(module.exports, "userOptimisticUpdatesHandler", () => $8ac8bda4358749d4$export$2205d16240a6327f);

var $hE5wF = parcelRequire("hE5wF");

var $5fc53 = parcelRequire("5fc53");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $8ac8bda4358749d4$var$activeAccountStatus = 'active';
const $8ac8bda4358749d4$export$ae35491859a54223 = (existingField, fieldData)=>({
        ...existingField,
        user: fieldData != null ? {
            accountId: fieldData.accountId ?? '',
            accountStatus: $8ac8bda4358749d4$var$activeAccountStatus,
            picture: fieldData.avatarUrls[0, $hE5wF.DEFAULT_AVATAR_RES],
            name: fieldData.displayName,
            __typename: 'AtlassianAccountUser'
        } : null
    });
const $8ac8bda4358749d4$export$741c2fd1d5e759e7 = (existingField, fieldData)=>({
        ...existingField,
        user: fieldData != null ? {
            accountId: fieldData.id ?? '',
            accountStatus: $8ac8bda4358749d4$var$activeAccountStatus,
            picture: fieldData.avatarUrl,
            name: fieldData.name,
            __typename: 'AtlassianAccountUser'
        } : null
    });
const $8ac8bda4358749d4$export$2205d16240a6327f = {
    [(0, $5fc53.REPORTER_TYPE)]: $8ac8bda4358749d4$export$741c2fd1d5e759e7,
    [(0, $5fc53.ASSIGNEE_TYPE)]: $8ac8bda4358749d4$export$ae35491859a54223
};

});

parcelRegister("8fxvG", function(module, exports) {

$parcel$export(module.exports, "versionOptimisticUpdatesHandler", () => $1174451c6262e677$export$ded24c5df4d4a072);

var $5fc53 = parcelRequire("5fc53");

var $1s49T = parcelRequire("1s49T");
const $1174451c6262e677$export$23dfa4890df81d45 = (existingField, fieldData)=>({
        ...existingField,
        version: fieldData ? {
            __typename: 'JiraVersion',
            versionId: fieldData.value,
            name: fieldData.label
        } : null
    });
const $1174451c6262e677$export$ab0e3c9aa41c8369 = (existingField, fieldData)=>{
    const action = fieldData.action;
    const existingVersions = existingField.selectedVersionsConnection?.edges?.map((edge)=>edge?.node).filter(Boolean) ?? [];
    const versionNodes = (0, $1s49T.transformOptionsUsingMultiAction)({
        existingOptions: existingVersions,
        options: fieldData.value.map((value)=>({
                __typename: 'JiraVersion',
                versionId: value.value,
                name: value.label
            })),
        action: action,
        isEqual: (option, existingOption)=>option.versionId === existingOption.versionId
    });
    return {
        ...existingField,
        selectedVersionsConnection: {
            __typename: 'JiraVersionConnection',
            edges: versionNodes?.map((node)=>({
                    __typename: 'JiraVersionEdge',
                    node: node
                })) ?? null
        }
    };
};
const $1174451c6262e677$export$ded24c5df4d4a072 = {
    [(0, $5fc53.VERSION_CF_TYPE)]: $1174451c6262e677$export$23dfa4890df81d45,
    [(0, $5fc53.MULTI_VERSION_CF_TYPE)]: $1174451c6262e677$export$ab0e3c9aa41c8369,
    [(0, $5fc53.FIX_VERSIONS_TYPE)]: $1174451c6262e677$export$ab0e3c9aa41c8369,
    [(0, $5fc53.AFFECTS_VERSIONS_TYPE)]: $1174451c6262e677$export$ab0e3c9aa41c8369
};

});




parcelRegister("jBW5k", function(module, exports) {

$parcel$export(module.exports, "useUpdateGroupIssue", () => $030e59a1f2f630ab$export$43b9ca95cc220db0);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $egmQO = parcelRequire("egmQO");

var $jDUax = parcelRequire("jDUax");

var $hlKA4 = parcelRequire("hlKA4");

var $jcw0u = parcelRequire("jcw0u");

var $6s1PB = parcelRequire("6s1PB");

var $eusud = parcelRequire("eusud");

var $pa9q9 = parcelRequire("pa9q9");

var $99cgx = parcelRequire("99cgx");

var $dXq4S = parcelRequire("dXq4S");

var $2O65s = parcelRequire("2O65s");

var $5fc53 = parcelRequire("5fc53");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $g5X3G = parcelRequire("g5X3G");

var $koeKL = parcelRequire("koeKL");

var $bs8Kk = parcelRequire("bs8Kk");

var $61h55 = parcelRequire("61h55");

var $4FAe4 = parcelRequire("4FAe4");

var $3xYz2 = parcelRequire("3xYz2");

var $9u99d = parcelRequire("9u99d");

var $aQbWi = parcelRequire("aQbWi");

var $eg2To = parcelRequire("eg2To");


var $Jhh8D = parcelRequire("Jhh8D");
const $030e59a1f2f630ab$export$43b9ca95cc220db0 = ()=>{
    const { getCachedIssueById: getCachedIssueById } = (0, $hlKA4.useCacheActions)();
    const { addToGroupCache: addToGroupCache } = (0, $3xYz2.useGroupCacheActions)();
    const [{ rankParentIssueId: rankParentIssueId }] = (0, $aQbWi.useRankParent)();
    const input = (0, $eg2To.useIssuesInput)({
        groupIssueId: (0, $jDUax.isGroupItem)(rankParentIssueId) ? rankParentIssueId : undefined,
        parentIssueId: !(0, $jDUax.isGroupItem)(rankParentIssueId) ? rankParentIssueId : undefined
    });
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [originalIssue, setOriginalIssue] = (0, $5uXOq.useState)();
    const [{ issuesMap: issuesMap }] = (0, $9u99d.useHierarchyStore)();
    const [updateError, setUpdateError] = (0, $5uXOq.useState)(null);
    const cloudId = (0, $koeKL.useCloudId)();
    (0, $5uXOq.useEffect)(()=>{
        if (updateError) {
            setUpdateError(null);
            // revert optimistic update
            if (originalIssue) {
                addToGroupCache([
                    originalIssue
                ]);
                setOriginalIssue(null);
            }
            showFlag({
                type: 'error',
                title: [
                    (0, $Jhh8D.default).errorTitle,
                    {
                        field: updateError.field
                    }
                ],
                description: [
                    (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $Jhh8D.default).errorMessageIssueTermRefresh : (0, $Jhh8D.default).errorMessage,
                    {
                        field: updateError.field
                    }
                ],
                messageId: 'business-list.controllers.update-group-issue.show-flag.error',
                messageType: 'transactional'
            });
            (0, $jcw0u.default)({
                meta: {
                    id: updateError.query,
                    packageName: 'jiraBusinessList',
                    teamName: 'keystone'
                },
                error: updateError.error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        originalIssue,
        updateError,
        addToGroupCache,
        showFlag
    ]);
    const optimisticUpdate = (0, $5uXOq.useCallback)((issue, fieldType, field)=>{
        const cachedIssue = getCachedIssueById({
            issueId: issue.issueId,
            query: (0, $61h55.LIST_VIEW_QUERY),
            variables: {
                ...(0, $egmQO.getVariables)(input),
                cloudId: cloudId
            }
        });
        setOriginalIssue(cachedIssue);
        if (cachedIssue) {
            const updatedIssue = {
                ...cachedIssue,
                fields: [
                    ...cachedIssue.fields?.filter(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                    (cachedField)=>cachedField.fieldId !== fieldType) ?? [],
                    field
                ]
            };
            addToGroupCache([
                updatedIssue
            ]);
        }
    }, [
        getCachedIssueById,
        input,
        cloudId,
        addToGroupCache
    ]);
    const bulkOptimisticUpdate = (0, $5uXOq.useCallback)((issueIds, fields)=>{
        const cachedIssues = issueIds.map((issueId)=>getCachedIssueById({
                issueId: issueId.toString(),
                query: (0, $61h55.LIST_VIEW_QUERY),
                variables: {
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    ...issuesMap.get(issueId.toString())?.cacheVariables,
                    cloudId: cloudId
                }
            })).filter(Boolean);
        const fieldIds = fields.map((field)=>field.fieldId);
        if (cachedIssues.length) {
            const updatedIssues = cachedIssues.map((cachedIssue)=>({
                    ...cachedIssue,
                    fields: [
                        ...cachedIssue.fields?.filter(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                        (cachedField)=>!fieldIds.includes(cachedField.fieldId)) ?? [],
                        ...fields
                    ]
                }));
            addToGroupCache(updatedIssues);
        }
    }, [
        getCachedIssueById,
        issuesMap,
        cloudId,
        addToGroupCache
    ]);
    const updateField = (0, $5uXOq.useCallback)((issue, fieldType, fieldValue, analyticsAlias)=>{
        (0, $99cgx.defaultSaveField)((0, $g5X3G.toIssueKey)(issue.key), fieldType, fieldValue, '').then(()=>{
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), `${(0, $7d2725467dc93480$export$406cbd2164fd0d71)} succeeded`, {
                field: (0, $bs8Kk.getFieldForAnalytics)(fieldType, analyticsAlias)
            });
        }).catch((error)=>{
            setUpdateError({
                error: error,
                field: (0, $bs8Kk.getFieldForAnalytics)(fieldType, analyticsAlias),
                query: (0, $7d2725467dc93480$export$406cbd2164fd0d71)
            });
        });
    }, [
        setUpdateError,
        createAnalyticsEvent
    ]);
    const updateAssignee = (0, $5uXOq.useCallback)((issue, fieldValue)=>{
        const newField = {
            aliasFieldId: null,
            fieldId: (0, $5fc53.ASSIGNEE_TYPE),
            name: 'assignee',
            type: 'assignee',
            fieldConfig: {
                isEditable: true,
                __typename: 'JiraFieldConfig'
            },
            __typename: 'JiraSingleSelectUserPickerField',
            user: fieldValue != null ? {
                accountId: fieldValue.accountId,
                accountStatus: (0, $4FAe4.AccountStatus).active,
                picture: fieldValue.avatarUrl,
                name: fieldValue.displayName,
                __typename: 'AtlassianAccountUser'
            } : null
        };
        optimisticUpdate(issue, (0, $5fc53.ASSIGNEE_TYPE), newField);
        if (fieldValue === null || fieldValue === undefined) // unassigned user
        updateField(issue, (0, $5fc53.ASSIGNEE_TYPE), null);
        else (0, $eusud.performGetRequest)(`/rest/api/2/user/assignable/search?issueKey=${issue.key}&accountId=${fieldValue.accountId}`).then((response)=>{
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), `${(0, $7d2725467dc93480$export$3e3161555559eda3)} succeeded`);
            if (Array.isArray(response) && response[0]) updateField(issue, (0, $5fc53.ASSIGNEE_TYPE), response[0]);
            else setUpdateError({
                error: new Error('User does not exist or is not allowed to be assigned to the issue'),
                field: (0, $5fc53.ASSIGNEE_TYPE),
                query: (0, $7d2725467dc93480$export$3e3161555559eda3)
            });
        }).catch((error)=>{
            setUpdateError({
                error: error,
                field: (0, $5fc53.ASSIGNEE_TYPE),
                query: (0, $7d2725467dc93480$export$3e3161555559eda3)
            });
        });
    }, [
        optimisticUpdate,
        updateField,
        setUpdateError,
        createAnalyticsEvent
    ]);
    const updatePriority = (0, $5uXOq.useCallback)((issue, fieldValue)=>{
        if (fieldValue) {
            let priorityId = fieldValue.id && (0, $dXq4S.isAri)(fieldValue.id) ? (0, $dXq4S.getAriConfig)(fieldValue.id).resourceId : fieldValue?.id ?? null;
            if ((0, $4R6GH.fg)('migrate-deprecated-jira-platform-ari-fns')) priorityId = fieldValue.id && (0, $2O65s.JiraPriorityAri).check(fieldValue.id) ? (0, $2O65s.JiraPriorityAri).parse(fieldValue.id).priorityId : fieldValue?.id ?? null;
            const newField = {
                aliasFieldId: null,
                fieldId: (0, $5fc53.PRIORITY_TYPE),
                type: (0, $5fc53.PRIORITY_TYPE),
                name: 'Priority',
                priority: {
                    id: fieldValue.id ?? '',
                    name: fieldValue.name,
                    priorityId: priorityId ?? '',
                    iconUrl: fieldValue.iconUrl,
                    __typename: 'JiraPriority'
                },
                __typename: 'JiraPriorityField'
            };
            optimisticUpdate(issue, (0, $5fc53.PRIORITY_TYPE), newField);
            updateField(issue, (0, $5fc53.PRIORITY_TYPE), {
                ...fieldValue,
                id: priorityId
            });
        }
    }, [
        optimisticUpdate,
        updateField
    ]);
    const updateCategory = (0, $5uXOq.useCallback)((issue, fieldKey, fieldValue)=>{
        const category = fieldValue ? {
            value: fieldValue.name,
            label: fieldValue.name
        } : null;
        const newField = {
            aliasFieldId: null,
            fieldId: fieldKey,
            fieldConfig: {
                isEditable: true,
                __typename: 'JiraFieldConfig'
            },
            __typename: 'JiraSingleSelectField',
            name: 'Category',
            type: (0, $5fc53.CATEGORY_TYPE),
            fieldOption: fieldValue ? {
                optionId: fieldValue.optionId,
                value: fieldValue.name,
                color: fieldValue.color ? {
                    colorKey: fieldValue.color,
                    __typename: 'JiraColor'
                } : null,
                __typename: 'JiraOption'
            } : null
        };
        optimisticUpdate(issue, fieldKey, newField);
        updateField(issue, fieldKey, category, 'category');
    }, [
        optimisticUpdate,
        updateField
    ]);
    const updateJiraNumber = (0, $5uXOq.useCallback)((issue, field, number)=>{
        if (typeof number !== 'undefined') {
            const newField = {
                fieldId: field.id,
                aliasFieldId: field.aliasFieldId || null,
                name: field.name,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                type: field.type,
                number: number,
                fieldConfig: {
                    isEditable: true,
                    __typename: 'JiraFieldConfig'
                },
                __typename: 'JiraNumberField'
            };
            optimisticUpdate(issue, field.id, newField);
            updateField(issue, field.id, number, newField.aliasFieldId || newField.type);
        }
    }, [
        optimisticUpdate,
        updateField
    ]);
    const updateSprint = (0, $5uXOq.useCallback)((issue, field, sprint)=>{
        if (typeof sprint !== 'undefined') {
            const newField = {
                fieldId: field.id,
                name: field.name,
                aliasFieldId: 'sprint',
                type: (0, $5fc53.SPRINT_TYPE),
                fieldConfig: {
                    isEditable: true,
                    __typename: 'JiraFieldConfig'
                },
                selectedSprintsConnection: {
                    edges: sprint === null ? [] : [
                        {
                            node: {
                                sprintId: String(sprint.id),
                                name: sprint.name,
                                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                                state: sprint.state,
                                __typename: 'JiraSprint'
                            },
                            __typename: 'JiraSprintEdge'
                        }
                    ],
                    __typename: 'JiraSprintConnection'
                },
                __typename: 'JiraSprintField'
            };
            optimisticUpdate(issue, field.id, newField);
            updateField(issue, field.id, sprint === null ? null : Number(sprint.id), 'sprint');
        }
    }, [
        optimisticUpdate,
        updateField
    ]);
    return {
        updateAssignee: updateAssignee,
        updatePriority: updatePriority,
        updateCategory: updateCategory,
        updateJiraNumber: updateJiraNumber,
        updateSprint: updateSprint,
        bulkOptimisticUpdate: bulkOptimisticUpdate
    };
};

});
parcelRegister("bs8Kk", function(module, exports) {

$parcel$export(module.exports, "getFieldForAnalytics", () => $4e9f4ccdb8980f86$export$af1963dc1f827ac2);

var $5fc53 = parcelRequire("5fc53");
const $4e9f4ccdb8980f86$export$af1963dc1f827ac2 = (fieldType, analyticsAlias)=>{
    if (analyticsAlias) {
        // keep backwards compatibility
        if (analyticsAlias === (0, $5fc53.CATEGORY_TYPE)) return 'category';
        return analyticsAlias;
    }
    return fieldType;
};

});

parcelRegister("4FAe4", function(module, exports) {

$parcel$export(module.exports, "AccountStatus", () => $83fafda9779bb4f3$export$3693f74db10d5f88);
// TODO: go/restrict-enums
var $83fafda9779bb4f3$export$3693f74db10d5f88 = /*#__PURE__*/ function(AccountStatus) {
    AccountStatus["active"] = "active";
    AccountStatus["closed"] = "closed";
    AccountStatus["inactive"] = "inactive";
    return AccountStatus;
}({});

});

const $7d2725467dc93480$export$3e3161555559eda3 = 'updateGroupIssueAssigneeSearch';
const $7d2725467dc93480$export$406cbd2164fd0d71 = 'updateGroupIssueUpdateField';

parcelRegister("Jhh8D", function(module, exports) {

$parcel$export(module.exports, "default", () => $f701cde766a4ed4b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f701cde766a4ed4b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorTitle: {
        "id": "business-list.controllers.update-group-issue.error-title",
        "defaultMessage": "Failed to update {field}"
    },
    errorMessage: {
        "id": "business-list.controllers.update-group-issue.error-message",
        "defaultMessage": "Something went wrong updating the issue's {field} field. Please try again or contact your administrator if the problem persists."
    },
    errorMessageIssueTermRefresh: {
        "id": "business-list.controllers.update-group-issue.error-message-issue-term-refresh",
        "defaultMessage": "Something went wrong updating the {field} field in the work item. Try again or contact your admin."
    }
});

});



parcelRegister("2Len7", function(module, exports) {

$parcel$export(module.exports, "BulkEditSidebar", () => $601fad54799fc304$export$43008afc76943d65);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $bUSNl = parcelRequire("bUSNl");

var $mk7k0 = parcelRequire("mk7k0");
const $601fad54799fc304$var$useOnUnmount = (fn)=>{
    const currentFn = (0, $5uXOq.useRef)(fn);
    currentFn.current = fn;
    (0, $5uXOq.useEffect)(()=>()=>currentFn.current(), []);
};
const $601fad54799fc304$export$43008afc76943d65 = ({ bulkOperationsForm: bulkOperationsForm })=>{
    const [{ content: content }, { resetSidebarQueryParams: resetSidebarQueryParams, setSidebarContent: _setSidebarContent }] = (0, $bUSNl.useSidebar)();
    const [{ showBulkEditSidebar: showBulkEditSidebar }] = (0, $mk7k0.useBulkSelectionStore)();
    const lastSetSidebarContent = (0, $5uXOq.useRef)(null);
    const setSidebarContent = (0, $5uXOq.useCallback)((newContent)=>{
        _setSidebarContent(newContent);
        lastSetSidebarContent.current = newContent;
    }, [
        _setSidebarContent
    ]);
    const resetSidebarContent = (0, $5uXOq.useCallback)(()=>{
        if (lastSetSidebarContent.current) setSidebarContent(null);
    }, [
        setSidebarContent
    ]);
    $601fad54799fc304$var$useOnUnmount(resetSidebarContent);
    const sidebarContent = (0, $5uXOq.useMemo)(()=>showBulkEditSidebar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            "data-testId": "business-list.ui.list-view.bulk-edit-sidebar.wrapper",
            xcss: $601fad54799fc304$var$wrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            "data-testId": "business-list.ui.list-view.bulk-edit-sidebar.bulkops-sidebar",
            ref: bulkOperationsForm.setRef,
            xcss: $601fad54799fc304$var$containerStyles
        })) : null, [
        bulkOperationsForm.setRef,
        showBulkEditSidebar
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!sidebarContent) return;
        if (!lastSetSidebarContent.current) resetSidebarQueryParams();
        if (content !== sidebarContent) setSidebarContent(sidebarContent);
    }, [
        content,
        resetSidebarQueryParams,
        setSidebarContent,
        sidebarContent
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (sidebarContent) return;
        if (content && content === lastSetSidebarContent.current) resetSidebarContent();
    }, [
        content,
        resetSidebarContent,
        sidebarContent
    ]);
    return null;
};
const $601fad54799fc304$var$wrapperStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    flexDirection: 'column',
    inset: 'space.0',
    justifyContent: 'stretch'
});
const $601fad54799fc304$var$containerStyles = (0, $8CUq3.xcss)({
    height: '100%',
    flexGrow: 1,
    // Adjust for the unwanted vertical padding from 'SidebarLayout'
    marginBottom: 'space.negative.100',
    marginTop: 'space.negative.100'
});

});


parcelRegister("lz9hZ", function(module, exports) {

$parcel$export(module.exports, "EmptyState", () => $7c3c8f03e5b2f97a$export$fddf379e22a74b00);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $hE5wF = parcelRequire("hE5wF");

var $kRkJF = parcelRequire("kRkJF");

var $1T1ir = parcelRequire("1T1ir");

var $6cG4N = parcelRequire("6cG4N");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $22OQR = parcelRequire("22OQR");

var $ieDtd = parcelRequire("ieDtd");

var $4nnGr = parcelRequire("4nnGr");

var $eADY6 = parcelRequire("eADY6");

var $cngB1 = parcelRequire("cngB1");

var $2IAT8 = parcelRequire("2IAT8");
const $7c3c8f03e5b2f97a$export$ea3803e2a45d21c4 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [, setInlineCreateParam] = (0, $ieDtd.useQueryParam)((0, $hE5wF.INLINE_CREATE_PARAM));
    const handleClick = (0, $5uXOq.useCallback)(()=>setInlineCreateParam('true'), [
        setInlineCreateParam
    ]);
    const { isSoftwareFieldsEnabled: isSoftwareFieldsEnabled } = (0, $4nnGr.useJWMListFeatures)();
    let createButtonText = (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $2IAT8.default).createItemButtonIssueTermRefresh : (0, $2IAT8.default).createItemButton;
    if (isSoftwareFieldsEnabled) createButtonText = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $2IAT8.default).createIssueButtonIssueTermRefresh : (0, $2IAT8.default).createIssueButton;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7c3c8f03e5b2f97a$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cngB1.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7c3c8f03e5b2f97a$var$HeadingWrapper, null, formatMessage((0, $2IAT8.default).emptyStateHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $7c3c8f03e5b2f97a$var$contentWrapperStyles
    }, formatMessage((0, $2IAT8.default).emptyStateDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $22OQR.ThemedButton), {
        appearance: "primary",
        onClick: handleClick
    }, formatMessage(createButtonText)));
};
const $7c3c8f03e5b2f97a$export$fddf379e22a74b00 = ({ reason: reason, clearError: clearError })=>{
    const { isFiltering: isFiltering, jqlErrors: jqlErrors } = (0, $kRkJF.useFilteredViewContextInput)({
        view: 'list'
    });
    const { isSearching: isSearching } = (0, $1T1ir.useSimpleSearchJQL)();
    if (reason === 'INVALID_JQL') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: $7c3c8f03e5b2f97a$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eADY6.ErrorState), {
        reason: "INVALID_JQL",
        clearError: clearError
    }));
    if (isFiltering || isSearching) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: $7c3c8f03e5b2f97a$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eADY6.ErrorState), {
        reason: jqlErrors.length ? 'INVALID_JQL' : 'NO_RESULTS'
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: $7c3c8f03e5b2f97a$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7c3c8f03e5b2f97a$export$ea3803e2a45d21c4, null));
};
const $7c3c8f03e5b2f97a$var$Wrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $7c3c8f03e5b2f97a$var$emptyWrapperStyles
    }, children);
const $7c3c8f03e5b2f97a$var$emptyWrapperStyles = (0, $8CUq3.xcss)({
    textAlign: 'center',
    margin: 'auto',
    width: '400px',
    padding: 'space.300',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    background: (0, $6cG4N.Tokens).ELEVATION_SURFACE_CONTRAST_BOLDER,
    borderRadius: 'border.radius.200'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7c3c8f03e5b2f97a$var$HeadingWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "h2", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syazfrbu _19pku2gc",
            __cmplp.className
        ])
    });
});
const $7c3c8f03e5b2f97a$var$contentWrapperStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.150',
    marginBottom: 'space.300'
});
const $7c3c8f03e5b2f97a$var$wrapperStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.1000',
    paddingTop: 'space.800',
    width: '100%'
});

});
parcelRegister("eADY6", function(module, exports) {

$parcel$export(module.exports, "ErrorState", () => $dfca44a017616b59$export$c1ed4f415b9e7023);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $l1N8i = parcelRequire("l1N8i");

var $5qRwM = parcelRequire("5qRwM");

var $eCeGD = parcelRequire("eCeGD");

var $47SnX = parcelRequire("47SnX");

var $koVbs = parcelRequire("koVbs");

var $lVJAU = parcelRequire("lVJAU");

var $l4Ejo = parcelRequire("l4Ejo");

var $2UUq6 = parcelRequire("2UUq6");

var $4R6GH = parcelRequire("4R6GH");

var $he7sk = parcelRequire("he7sk");


var $dIw4m = parcelRequire("dIw4m");
const $dfca44a017616b59$export$c1ed4f415b9e7023 = ({ reason: reason, clearError: clearError })=>{
    // @ts-expect-error - TS2339 - Property 'updateQueryParam' does not exist on type 'BoundActions<EntireRouterState, PublicRouterActions>'.
    const { updateQueryParam: updateQueryParam } = (0, $lVJAU.useRouterActions)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { saveJql: saveJql } = (0, $l4Ejo.useFiltersPreference)();
    const [, setSorting] = (0, $2UUq6.useSorting)();
    const handleOnClear = (0, $5uXOq.useCallback)(()=>{
        updateQueryParam({
            [(0, $62868bc451fae4c2$export$9b72011e2eb8d7d0)]: undefined,
            [(0, $62868bc451fae4c2$export$386e264f84ef9d00)]: undefined,
            [(0, $62868bc451fae4c2$export$a7aec88cc56e6f46)]: undefined
        }, 'replace');
        saveJql(undefined);
        setSorting(undefined);
        clearError?.();
    }, [
        saveJql,
        updateQueryParam,
        setSorting,
        clearError
    ]);
    const message = reason === 'INVALID_JQL' ? formatMessage((0, $dIw4m.default).invalidStateHeading) : formatMessage((0, $dIw4m.default).emptyStateHeading);
    if ((0, $4R6GH.fg)('update-filter-empty-state')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $he7sk.ThemedFilterEmptyState), {
        reason: reason,
        handleOnClearOverride: handleOnClear
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $dfca44a017616b59$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $dfca44a017616b59$var$illustrationStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5qRwM.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($47SnX))),
        alt: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $dfca44a017616b59$var$headerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "medium"
    }, message)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        appearance: "primary",
        onClick: handleOnClear
    }, formatMessage((0, $dIw4m.default).clearFiltersButton)));
};
const $dfca44a017616b59$var$wrapperStyles = (0, $8CUq3.xcss)({
    textAlign: 'center',
    margin: 'auto',
    width: '450px',
    padding: 'space.300',
    borderRadius: 'border.radius.200',
    background: "var(--ds-background-neutral-subtle, #00000000)",
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
});
const $dfca44a017616b59$var$headerWrapperStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.400',
    marginBottom: 'space.300'
});
const $dfca44a017616b59$var$illustrationStyles = (0, $8CUq3.xcss)({
    width: '208px',
    height: '190px',
    display: 'flex',
    justifyContent: 'center'
});

});
parcelRegister("47SnX", function(module, exports) {
module.exports = new URL("search-no-results-old.10b14394.svg", import.meta.url).toString();

});

parcelRegister("he7sk", function(module, exports) {

$parcel$export(module.exports, "ThemedFilterEmptyState", () => $cd3da1c859fecc93$export$e911425bb76dd69e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $6cG4N = parcelRequire("6cG4N");

var $47SnX = parcelRequire("47SnX");

var $koVbs = parcelRequire("koVbs");

var $22OQR = parcelRequire("22OQR");

var $lODMY = parcelRequire("lODMY");

var $4R6GH = parcelRequire("4R6GH");

var $l4Ejo = parcelRequire("l4Ejo");

var $7htvz = parcelRequire("7htvz");

var $23WHC = parcelRequire("23WHC");
const $cd3da1c859fecc93$export$e911425bb76dd69e = ({ reason: reason, clearError: clearError, handleOnClearOverride: handleOnClearOverride })=>{
    const { updateQueryParam: updateQueryParam } = (0, $lODMY.useRouterStoreActions)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { saveJql: saveJql } = (0, $l4Ejo.useFiltersPreference)();
    const handleOnClear = (0, $5uXOq.useCallback)(()=>{
        if (handleOnClearOverride && (0, $4R6GH.fg)('update-filter-empty-state')) {
            handleOnClearOverride();
            return;
        }
        saveJql(undefined);
        updateQueryParam({
            [(0, $7htvz.SIMPLE_SEARCH_PARAM)]: undefined
        }, 'replace');
        (0, $4R6GH.fg)('timeline-add-jql-error-boundary') && clearError?.();
    }, [
        saveJql,
        updateQueryParam,
        clearError,
        handleOnClearOverride
    ]);
    const message = reason === 'INVALID_JQL' ? formatMessage((0, $23WHC.default).invalidStateHeading) : formatMessage((0, $23WHC.default).emptyStateHeading);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $cd3da1c859fecc93$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cd3da1c859fecc93$var$Illustration, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($47SnX))),
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cd3da1c859fecc93$var$HeadingWrapper, null, message), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $22OQR.ThemedButton), {
        appearance: "primary",
        onClick: handleOnClear
    }, formatMessage((0, $23WHC.default).clearFiltersButton)));
};
const $cd3da1c859fecc93$var$wrapperStyles = (0, $8CUq3.xcss)({
    textAlign: 'center',
    margin: 'auto',
    width: '450px',
    padding: 'space.300',
    borderRadius: 'border.radius.200',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    background: (0, $6cG4N.Tokens).ELEVATION_SURFACE_CONTRAST_BOLDER
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cd3da1c859fecc93$var$HeadingWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "h3", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syazfrbu _otyr1ejb",
            __cmplp.className
        ])
    });
});
const $cd3da1c859fecc93$var$Illustration = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1yk2 _4t3i13i4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("23WHC", function(module, exports) {

$parcel$export(module.exports, "default", () => $4708df9bdc612950$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4708df9bdc612950$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    emptyStateHeading: {
        "id": "business-filters.themed-filter-empty-state.empty-state-heading",
        "defaultMessage": "It looks like we can't find any results that match."
    },
    invalidStateHeading: {
        "id": "business-filters.themed-filter-empty-state.invalid-state-heading",
        "defaultMessage": "We can't handle the current filters, please clear to continue."
    },
    clearFiltersButton: {
        "id": "business-filters.themed-filter-empty-state.clear-filters-button",
        "defaultMessage": "Clear"
    }
});

});


const $62868bc451fae4c2$export$9b72011e2eb8d7d0 = 'text';
const $62868bc451fae4c2$export$386e264f84ef9d00 = 'sortBy';
const $62868bc451fae4c2$export$a7aec88cc56e6f46 = 'direction';

parcelRegister("dIw4m", function(module, exports) {

$parcel$export(module.exports, "default", () => $54be6ed6c0ad3797$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $54be6ed6c0ad3797$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    emptyStateHeading: {
        "id": "business-filters.themed-filter-empty-state.empty-state-heading",
        "defaultMessage": "It looks like we can't find any results that match."
    },
    invalidStateHeading: {
        "id": "business-filters.themed-filter-empty-state.invalid-state-heading",
        "defaultMessage": "We can't handle the current filters, please clear to continue."
    },
    clearFiltersButton: {
        "id": "business-filters.themed-filter-empty-state.clear-filters-button",
        "defaultMessage": "Clear"
    }
});

});


parcelRegister("cngB1", function(module, exports) {

$parcel$export(module.exports, "default", () => $0518b6eb1b77d0a1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $0518b6eb1b77d0a1$var$Illustration = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("275aX")), {
    moduleId: "./src/packages/business/list/src/ui/list-view/empty-state/illustration/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0518b6eb1b77d0a1$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jwm-list-empty-state",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0518b6eb1b77d0a1$var$Illustration, null));

});
parcelRegister("275aX", function(module, exports) {

let $18a0400506739e02$var$load = (parcelRequire("28QjX"))(4);
module.exports = $18a0400506739e02$var$load("2W0mY").then(()=>parcelRequire('g69tt'));

});


parcelRegister("2IAT8", function(module, exports) {

$parcel$export(module.exports, "default", () => $166191219629cb77$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $166191219629cb77$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    emptyStateHeading: {
        "id": "business-list.list-view.empty-state.empty-state-heading",
        "defaultMessage": "View your work in a list"
    },
    emptyStateDescription: {
        "id": "business-list.list-view.empty-state.empty-state-description",
        "defaultMessage": "Manage and sort all your project\u2019s work into a single list that can be easily scanned and sorted by category."
    },
    createItemButton: {
        "id": "business-list.list-view.empty-state.create-item-button",
        "defaultMessage": "Create an item"
    },
    createItemButtonIssueTermRefresh: {
        "id": "business-list.list-view.empty-state.create-item-button-issue-term-refresh",
        "defaultMessage": "Create a work item"
    },
    createIssueButton: {
        "id": "business-list.list-view.empty-state.create-issue-button",
        "defaultMessage": "Create issue"
    },
    createIssueButtonIssueTermRefresh: {
        "id": "business-list.list-view.empty-state.create-issue-button-issue-term-refresh",
        "defaultMessage": "Create work item"
    }
});

});


parcelRegister("1QC74", function(module, exports) {

$parcel$export(module.exports, "GroupItem", () => $632d45ab0c250375$export$3142cb2f1b79aeb9);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $9pdbW = parcelRequire("9pdbW");

var $17ot5 = parcelRequire("17ot5");

var $5njbg = parcelRequire("5njbg");

var $gULOk = parcelRequire("gULOk");

var $koVbs = parcelRequire("koVbs");

var $4R6GH = parcelRequire("4R6GH");

var $dXq4S = parcelRequire("dXq4S");

var $4rfxU = parcelRequire("4rfxU");

var $5fc53 = parcelRequire("5fc53");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $g5X3G = parcelRequire("g5X3G");

var $1CXMr = parcelRequire("1CXMr");

var $fc0Dc = parcelRequire("fc0Dc");

var $8TUlY = parcelRequire("8TUlY");

var $8e3Yw = parcelRequire("8e3Yw");

var $9u99d = parcelRequire("9u99d");

var $acMuh = parcelRequire("acMuh");

var $6GT2e = parcelRequire("6GT2e");

var $5ZOAc = parcelRequire("5ZOAc");

var $f7bpX = parcelRequire("f7bpX");

var $hWLf6 = parcelRequire("hWLf6");

var $240fW = parcelRequire("240fW");

var $9wkeV = parcelRequire("9wkeV");

var $iaKbb = parcelRequire("iaKbb");

var $dMoqa = parcelRequire("dMoqa");

var $gC8QP = parcelRequire("gC8QP");

var $earxJ = parcelRequire("earxJ");
const $632d45ab0c250375$var$ICON_SIZE = 24; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $632d45ab0c250375$var$LoadingIcon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1sit _1e0c1txw _1bsbu2gc _4t3i1tcg _bfhkn82g _19pku2gc _2hwx1b66 _otyru2gc _18u0pxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $632d45ab0c250375$var$CreateIssuePlusButtonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0u2gc",
            __cmplp.className
        ])
    });
});
const $632d45ab0c250375$var$GroupItemRenderer = ({ field: field, data: data })=>{
    switch(field.__typename){
        case 'JiraSingleSelectUserPickerField':
            if (field.type === (0, $5fc53.ASSIGNEE_TYPE)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6GT2e.AssigneeItem), {
                data: data
            });
            return null;
        case 'GenericIssueField':
            if (field.type === (0, $5fc53.STATUS_TYPE)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dMoqa.StatusItem), {
                data: data
            });
            return null;
        case 'JiraPriorityField':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $240fW.PriorityItem), {
                data: data
            });
        case 'JWMCategoryField':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ZOAc.CategoryItem), {
                data: data
            });
        case 'JiraNumberField':
            if (field.aliasFieldId === 'storypoints') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gC8QP.StoryPointsItem), {
                value: data.storypoints
            });
            if (field.aliasFieldId === 'storypointestimate') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gC8QP.StoryPointsItem), {
                value: data.storypointestimate
            });
            return null;
        case 'JiraSprintField':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iaKbb.SprintItem), {
                data: data
            });
        default:
            return null;
    }
};
const $632d45ab0c250375$export$3142cb2f1b79aeb9 = /*#__PURE__*/ (0, $5uXOq.memo)(({ data: data, rowIndex: rowIndex, canCreateIssues: canCreateIssues })=>{
    const [groupByFieldId] = (0, $8e3Yw.useGroupBy)();
    const [, setHideDoneItems] = (0, $17ot5.useHideDoneItems)();
    const issueId = (0, $g5X3G.toIssueId)(data.issueId);
    const totalGroupItems = data.childSummary?.totalCount ?? 0;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ expandedItems: expandedGroups, hierarchyData: { loading: loading } }, { setExpandedItems: setGroupExpanded }] = (0, $9u99d.useHierarchyStore)();
    const [{ shouldExpandAllItems: shouldExpandAllItems }, { disableExpandCollapseAllItems: disableExpandCollapseAllItems }] = (0, $9pdbW.useExpandCollapseAllItems)({
        view: 'list'
    });
    const [, { setRowCreatePosition: setRowCreatePosition }] = (0, $acMuh.useRowCreateStore)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { getAvailableFields: getAvailableFields } = (0, $8TUlY.useIssueFields)();
    const availableFields = getAvailableFields();
    const categoryFieldId = availableFields.find((fieldItem)=>fieldItem.type === (0, $5fc53.CATEGORY_TYPE))?.id;
    const field = (0, $fc0Dc.useGetGroupByField)();
    const onExpand = (0, $5uXOq.useCallback)(()=>{
        const isExpanded = Boolean(expandedGroups[issueId]);
        const isStatusGroup = groupByFieldId === (0, $5fc53.STATUS_TYPE);
        const isDoneStatus = // @ts-expect-error - TS2367 - This condition will always return 'false' since the types 'string' and 'number' have no overlap.
        data.status?.categoryId === (0, $gULOk.StatusCategoryIds)[(0, $gULOk.StatusCategoryTypes).DONE];
        // show done items when expanding the done status group
        if (isStatusGroup && isDoneStatus && !isExpanded) setHideDoneItems(false);
        if (isExpanded && shouldExpandAllItems) disableExpandCollapseAllItems();
        setGroupExpanded(issueId, !isExpanded);
    }, [
        data,
        disableExpandCollapseAllItems,
        expandedGroups,
        groupByFieldId,
        issueId,
        setGroupExpanded,
        setHideDoneItems,
        shouldExpandAllItems
    ]);
    const handleAddInlineCreateRow = (0, $5uXOq.useCallback)((e)=>{
        e.preventDefault();
        setRowCreatePosition({
            parentId: String(issueId)
        });
        if (setGroupExpanded) setGroupExpanded(issueId, true);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'listRowCreateGroupItemIcon', {
            groupByFieldId: groupByFieldId
        });
    }, [
        setRowCreatePosition,
        issueId,
        setGroupExpanded,
        createAnalyticsEvent,
        groupByFieldId
    ]);
    const checkIfHasIssueCreation = (0, $5njbg.useCanCreateIssueInStatus)();
    const canInlineCreate = (0, $5uXOq.useMemo)(()=>{
        if (!canCreateIssues) return false;
        if (groupByFieldId !== (0, $5fc53.STATUS_TYPE)) return true;
        let statusId = data.status?.id && (0, $dXq4S.getAriConfig)(data.status.id).resourceId;
        if ((0, $4R6GH.fg)('migrate-deprecated-jira-platform-ari-fns')) statusId = data.status?.id && (0, $4rfxU.JiraIssueStatusAri).check(data.status.id) ? (0, $4rfxU.JiraIssueStatusAri).parse(data.status.id).issuestatusId : undefined;
        if (!statusId) return false;
        return checkIfHasIssueCreation(statusId);
    }, [
        canCreateIssues,
        checkIfHasIssueCreation,
        data.status,
        groupByFieldId
    ]);
    const CreateIssueComponent = (0, $5uXOq.useMemo)(()=>canInlineCreate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($632d45ab0c250375$var$CreateIssuePlusButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1CXMr.default), {
            tooltip: formatMessage((0, $hWLf6.default).createIssue),
            label: formatMessage((0, $hWLf6.default).addGroupItem),
            onClick: handleAddInlineCreateRow,
            shouldDisplayBtn: true
        })), [
        canInlineCreate,
        formatMessage,
        handleAddInlineCreateRow
    ]);
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($632d45ab0c250375$var$LoadingRow, {
        key: "loading-grouping-header-row",
        "data-testid": "business-list.ui.list-view.group-item.loading-row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($632d45ab0c250375$var$LoadingWrapper, {
        key: data.key
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($632d45ab0c250375$var$LoadingIcon, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($632d45ab0c250375$var$LoadingField, null)));
    const renderView = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $earxJ.Wrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9wkeV.SelectGroupCheckbox), {
        group: data,
        rowIndex: rowIndex
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $earxJ.GroupContainer), null, totalGroupItems > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f7bpX.ExpandIcon), {
        onClick: onExpand,
        totalGroupItems: totalGroupItems,
        rowIndex: rowIndex,
        expanded: expandedGroups[issueId] === true
    }), field ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($632d45ab0c250375$var$GroupItemRenderer, {
        field: field,
        data: data
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, groupByFieldId === (0, $5fc53.ASSIGNEE_TYPE) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6GT2e.AssigneeItem), {
        data: data
    }), groupByFieldId === (0, $5fc53.STATUS_TYPE) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dMoqa.StatusItem), {
        data: data
    }), groupByFieldId === (0, $5fc53.PRIORITY_TYPE) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $240fW.PriorityItem), {
        data: data
    }), groupByFieldId === categoryFieldId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ZOAc.CategoryItem), {
        data: data
    })), CreateIssueComponent));
    return renderView;
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $632d45ab0c250375$var$LoadingWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $632d45ab0c250375$var$LoadingField = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _1bsb68cl _bfhkn82g _19pku2gc _2hwxu2gc _otyru2gc _18u0u2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $632d45ab0c250375$var$LoadingRow = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9pdbW", function(module, exports) {

$parcel$export(module.exports, "useExpandCollapseAllItems", () => $3b02fa0a8e1492e4$export$38cfcb71ce0d3b89);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $3b02fa0a8e1492e4$var$actions = {
    toggleExpanding: (view)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                [view]: {
                    ...state[view],
                    shouldExpandAllItems: !state[view].shouldExpandAllItems,
                    shouldCollapseAllItems: false
                }
            });
        },
    setCollapsing: (view)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                [view]: {
                    ...state[view],
                    shouldExpandAllItems: false,
                    shouldCollapseAllItems: true
                }
            });
        },
    disableExpandCollapse: (view)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                [view]: {
                    ...state[view],
                    shouldExpandAllItems: false,
                    shouldCollapseAllItems: false
                }
            });
        },
    setHasExpandedAllItems: (view, hasExpanded)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                [view]: {
                    ...state[view],
                    hasExpandedAllItems: hasExpanded
                }
            });
        },
    setHasCollapsedAllItems: (view, hasCollapsed)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                [view]: {
                    ...state[view],
                    hasCollapsedAllItems: hasCollapsed
                }
            });
        }
};
const $3b02fa0a8e1492e4$var$Store = (0, $iXqE5.createStore)({
    initialState: {
        list: {
            shouldExpandAllItems: false,
            shouldCollapseAllItems: false,
            hasExpandedAllItems: false,
            hasCollapsedAllItems: false
        },
        timeline: {
            shouldExpandAllItems: false,
            shouldCollapseAllItems: false,
            hasExpandedAllItems: false,
            hasCollapsedAllItems: false
        }
    },
    actions: $3b02fa0a8e1492e4$var$actions,
    name: 'JWMExpandCollapseStore'
});
const $3b02fa0a8e1492e4$var$useHook = (0, $3sQ5x.createHook)($3b02fa0a8e1492e4$var$Store);
const $3b02fa0a8e1492e4$export$38cfcb71ce0d3b89 = ({ view: view, onCollapse: onCollapse })=>{
    const [state, { toggleExpanding: toggleExpanding, setCollapsing: setCollapsing, disableExpandCollapse: disableExpandCollapse, setHasExpandedAllItems: setHasExpandedAllItems, setHasCollapsedAllItems: setHasCollapsedAllItems }] = $3b02fa0a8e1492e4$var$useHook();
    const { shouldExpandAllItems: shouldExpandAllItems, shouldCollapseAllItems: shouldCollapseAllItems, hasExpandedAllItems: hasExpandedAllItems, hasCollapsedAllItems: hasCollapsedAllItems } = state[view];
    const toggleExpandingForView = (0, $5uXOq.useCallback)(()=>toggleExpanding(view), [
        toggleExpanding,
        view
    ]);
    const setCollapsingForView = (0, $5uXOq.useCallback)(()=>setCollapsing(view), [
        setCollapsing,
        view
    ]);
    const setHasCollapsedAllItemsForView = (0, $5uXOq.useCallback)((hasCollapsed)=>setHasCollapsedAllItems(view, hasCollapsed), [
        setHasCollapsedAllItems,
        view
    ]);
    const setHasExpandedAllItemsForView = (0, $5uXOq.useCallback)((hasExpanded)=>setHasExpandedAllItems(view, hasExpanded), [
        setHasExpandedAllItems,
        view
    ]);
    const disableExpandCollapseForView = (0, $5uXOq.useCallback)(()=>disableExpandCollapse(view), [
        disableExpandCollapse,
        view
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (onCollapse && shouldCollapseAllItems) {
            onCollapse();
            disableExpandCollapseForView();
        }
    }, [
        disableExpandCollapseForView,
        onCollapse,
        shouldCollapseAllItems
    ]);
    return [
        {
            shouldExpandAllItems: shouldExpandAllItems,
            shouldCollapseAllItems: shouldCollapseAllItems,
            hasExpandedAllItems: hasExpandedAllItems,
            hasCollapsedAllItems: hasCollapsedAllItems
        },
        {
            toggleExpandAllItems: toggleExpandingForView,
            collapseAllItems: setCollapsingForView,
            disableExpandCollapseAllItems: disableExpandCollapseForView,
            setHasExpandedAllItems: setHasExpandedAllItemsForView,
            setHasCollapsedAllItems: setHasCollapsedAllItemsForView
        }
    ];
};

});

parcelRegister("5njbg", function(module, exports) {

$parcel$export(module.exports, "useCanCreateIssueInStatus", () => $fee15ae5c2026453$export$efe8838d1712139f);

var $5uXOq = parcelRequire("5uXOq");

var $daQYX = parcelRequire("daQYX");

var $l9KLJ = parcelRequire("l9KLJ");
const $fee15ae5c2026453$export$efe8838d1712139f = ()=>{
    const workflows = (0, $l9KLJ.useWorkflows)();
    const project = (0, $daQYX.useProject)();
    return (0, $5uXOq.useCallback)((statusId, workflow = null)=>{
        if (!workflows) return false;
        const eligibleWorkflows = workflow != null ? [
            workflow
        ] : workflows.filter((w)=>w.issueTypes.some((it)=>it.hierarchyLevel >= 0));
        // we want to show the create button on the group if it can:
        // - be created from the initial transition,
        // - OR if it has a global transition leading to it
        //      AND the transition isn't conditional
        //      AND the user is allowed to transition issues
        return eligibleWorkflows.some((w)=>w.transitions.some((transition)=>transition.to.statusId === statusId && (transition.isInitial || transition.isGlobal && !transition.isConditional && project.permissions.transitionIssues)));
    }, [
        project,
        workflows
    ]);
};

});

parcelRegister("1CXMr", function(module, exports) {

$parcel$export(module.exports, "default", () => $97edc763cb6a35fa$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $42CjB = parcelRequire("42CjB");

var $99M5v = parcelRequire("99M5v");

var $3bDjY = parcelRequire("3bDjY");

var $gwIPs = parcelRequire("gwIPs");

var $dCm1o = parcelRequire("dCm1o");

var $eTDjN = parcelRequire("eTDjN");
var $97edc763cb6a35fa$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: props.tooltip
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($97edc763cb6a35fa$var$ChildCreateButtonWrapper, {
        id: (0, $eTDjN.CHILD_CREATE_BTN_WRAPPER),
        shouldDisplayBtn: props.shouldDisplayBtn,
        "data-testid": "business-list.common.ui.create-issue-plus-button.child-create-button-wrapper"
    }, (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        onClick: props.onClick,
        spacing: "compact",
        appearance: "subtle",
        label: props.label,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($99M5v)))
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($97edc763cb6a35fa$var$ChildCreateButton, {
        onClick: props.onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($99M5v))), {
        label: props.label,
        LEGACY_size: "small"
    })))));
const $97edc763cb6a35fa$var$BUTTON_SIZE = 2 * (0, $gwIPs.gridSize);
const $97edc763cb6a35fa$var$ICON_SIZE = 12;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $97edc763cb6a35fa$var$ChildCreateButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _19itglyw _2rko1sit _12ji1r31 _1qu2glyw _12y31o36 _v5641mqx _80omtlke _1bsb7vkz _4t3i7vkz _s7n4jp4b _bfhkm7j4 _syaz1fxt _11r7k42h _e2oo1crf _1xjx1crf _z2391qo1 _19y51fxt _16uvt94y _jomr15ej _irr315ej _1di61t1b _9h8h1j89",
            __cmplp.className
        ])
    });
});
const $97edc763cb6a35fa$var$ChildCreateButtonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldDisplayBtn: shouldDisplayBtn, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.shouldDisplayBtn ? "_1e0c1txw" : "_1e0cglyw",
            __cmplp.className
        ])
    });
});

});

parcelRegister("fc0Dc", function(module, exports) {

$parcel$export(module.exports, "useGetGroupByField", () => $64e17e972578427d$export$7a0354af7d69ba55);

var $hE5wF = parcelRequire("hE5wF");

var $ePLOx = parcelRequire("ePLOx");

var $5fc53 = parcelRequire("5fc53");

var $8TUlY = parcelRequire("8TUlY");

var $8e3Yw = parcelRequire("8e3Yw");
const $64e17e972578427d$export$1aef70471c979441 = (field)=>field.type === (0, $5fc53.CATEGORY_TYPE);
const $64e17e972578427d$export$48f560f91a048a7f = (field)=>field.type === (0, $5fc53.NUMBER_CF_TYPE) && field.aliasFieldId === (0, $hE5wF.STORY_POINTS_ALIAS_FIELD_ID);
const $64e17e972578427d$export$8b6cfed4387d2f77 = (field)=>field.type === (0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE);
const $64e17e972578427d$export$ea68dd9055d500e2 = (field)=>field.type === (0, $5fc53.SPRINT_TYPE);
const $64e17e972578427d$export$7a0354af7d69ba55 = ()=>{
    const [groupByFieldId] = (0, $8e3Yw.useGroupBy)();
    const { getAvailableFields: getAvailableFields } = (0, $8TUlY.useIssueFields)();
    const availableFields = getAvailableFields();
    const { data: categoryField } = (0, $ePLOx.useFindField)($64e17e972578427d$export$1aef70471c979441);
    const { data: storyPointsField } = (0, $ePLOx.useFindField)($64e17e972578427d$export$48f560f91a048a7f);
    const { data: storyPointEstimateField } = (0, $ePLOx.useFindField)($64e17e972578427d$export$8b6cfed4387d2f77);
    const { data: sprintField } = (0, $ePLOx.useFindField)($64e17e972578427d$export$ea68dd9055d500e2);
    switch(groupByFieldId){
        case categoryField?.id:
            return categoryField;
        case storyPointsField?.id:
            return storyPointsField;
        case storyPointEstimateField?.id:
            return storyPointEstimateField;
        case sprintField?.id:
            return sprintField;
        default:
            return availableFields.find((availableField)=>availableField.type === groupByFieldId);
    }
};

});

parcelRegister("6GT2e", function(module, exports) {

$parcel$export(module.exports, "AssigneeItem", () => $ba9678029c920422$export$be57e3a2d4264803);

var $5uXOq = parcelRequire("5uXOq");

var $ujWmd = parcelRequire("ujWmd");

var $bmZvc = parcelRequire("bmZvc");

var $koVbs = parcelRequire("koVbs");

var $lI995 = parcelRequire("lI995");

var $hYB1g = parcelRequire("hYB1g");
const $ba9678029c920422$export$be57e3a2d4264803 = ({ data: data })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isUnassigned = !data.assignee;
    const unassignedDisplayName = formatMessage((0, $hYB1g.default).unassignedDisplayName);
    const displayName = isUnassigned ? unassignedDisplayName : data.assignee?.displayName;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isUnassigned ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        appearance: "circle",
        src: "",
        size: "small"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bmZvc.AvatarLite), {
        avatarUrl: data.assignee?.avatarUrl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lI995.DisplayName), null, displayName));
};

});
parcelRegister("bmZvc", function(module, exports) {

$parcel$export(module.exports, "AvatarLite", () => $0b2cc805665652bb$export$8b9560cc4e12c651);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");
const $0b2cc805665652bb$var$AVATAR_SIZE = 24;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0b2cc805665652bb$var$Avatar = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { avatarUrl: avatarUrl, isHighlighted: isHighlighted, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1fzlxay": (0, $lD23V.default)(`url(${__cmplp.avatarUrl})`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1ssb _12ji1r31 _1qu2glyw _12y3idpf _1itk1v7f _ouxl1ssb _12vemgnk _1lrw1dfr _bfhk18uv _vchh18uv _4t3i1tcg _1bsb1tcg _1ul91tcg _1tke1tcg _1e0c1o8l _kqswh2mm _80om1kw7 _19pkv77o _2hwxv77o _otyrv77o _18u0v77o",
            __cmplp.isHighlighted ? "_16qsa9gh" : "_16qsglyw",
            __cmplp.className
        ])
    });
});
const $0b2cc805665652bb$var$hasKeywords = (name)=>(keyword)=>name && keyword && name.toLowerCase().includes(keyword.toLowerCase());
const $0b2cc805665652bb$export$8b9560cc4e12c651 = /*#__PURE__*/ (0, $5uXOq.memo)(({ avatarUrl: avatarUrl, name: name = '', highlight: highlight, testId: testId })=>{
    const isHighlighted = highlight && highlight.some($0b2cc805665652bb$var$hasKeywords(name));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0b2cc805665652bb$var$Avatar, {
        // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
        avatarUrl: avatarUrl,
        title: name,
        // @ts-expect-error - TS2322 - Type 'boolean | undefined' is not assignable to type 'boolean'.
        isHighlighted: isHighlighted,
        "data-testid": testId
    });
});

});

parcelRegister("lI995", function(module, exports) {

$parcel$export(module.exports, "CellContentContainer", () => $3f8a6a40f1bb00b7$export$bd476b087602e432);
$parcel$export(module.exports, "CellContainer", () => $3f8a6a40f1bb00b7$export$287da707e3318210);
$parcel$export(module.exports, "CellContentWrapper", () => $3f8a6a40f1bb00b7$export$f76c50a859269a04);
$parcel$export(module.exports, "AvatarItem", () => $3f8a6a40f1bb00b7$export$15f08c141eda7939);
$parcel$export(module.exports, "DisplayName", () => $3f8a6a40f1bb00b7$export$101fbca3a406e1fd);
$parcel$export(module.exports, "EmptyCellContent", () => $3f8a6a40f1bb00b7$export$78bba2733575aa77);
$parcel$export(module.exports, "Container", () => $3f8a6a40f1bb00b7$export$42a852a2b6b56249);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $5uXOq = parcelRequire("5uXOq");

var $gwIPs = parcelRequire("gwIPs");
const $3f8a6a40f1bb00b7$export$95bfdfec8f6b837d = 2;
const $3f8a6a40f1bb00b7$export$e643c5fb607dbcc5 = `0 0 0 ${$3f8a6a40f1bb00b7$export$95bfdfec8f6b837d}px ${"var(--ds-border-focused, #388BFF)"} inset`;
const $3f8a6a40f1bb00b7$export$85e848b114283663 = 160;
const $3f8a6a40f1bb00b7$export$df441c04a8cf98f7 = 40;
const $3f8a6a40f1bb00b7$export$bd476b087602e432 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_g3ey1q": (0, $lD23V.default)(__cmplp.width - ((0, $gwIPs.gridSize) * 3 + $3f8a6a40f1bb00b7$export$95bfdfec8f6b837d * 2), "px"),
            "--_1nq8131": (0, $lD23V.default)(__cmplp.height - $3f8a6a40f1bb00b7$export$95bfdfec8f6b837d * 2, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_12ji1r31 _1qu2glyw _12y31o36 _1e0c1txw _4cvr1h6o _1bsb6uc2 _4t3i4226",
            __cmplp.className
        ])
    });
});
const $3f8a6a40f1bb00b7$var$focusedStyle = null;
const $3f8a6a40f1bb00b7$var$formattedStyle = null;
const $3f8a6a40f1bb00b7$var$formattedHoverStyle = null;
const $3f8a6a40f1bb00b7$var$cellContainerStyles = null;
const $3f8a6a40f1bb00b7$export$287da707e3318210 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ isFocused: isFocused, formatRuleBackgroundColor: formatRuleBackgroundColor, formatRuleHoverColor: formatRuleHoverColor, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: ref,
        ...props,
        /* eslint-disable-next-line jira/react/no-style-attribute -- Ignored via go/DSP-18766 */ style: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {
            '--local-format-color': formatRuleBackgroundColor,
            '--local-format-hover-color': formatRuleHoverColor
        },
        className: (0, $bwpsq.default)([
            "_12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _bd9w1r31 _ezapglyw _1qzf1o36 _zbayglpi _p7r11txw _dzc21h6o _bhl91osq _k8em1osq _1gze18uv",
            isFocused && "_bp7o4ls2 _1gzevuon",
            formatRuleBackgroundColor && !isFocused && "_bfhk1olo",
            formatRuleHoverColor && !isFocused && "_erv6872d _1tj5872d _irr3872d"
        ])
    }, props.children));
const $3f8a6a40f1bb00b7$export$f76c50a859269a04 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { preferredWidth: preferredWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1kfanob": (0, $lD23V.default)(__cmplp.preferredWidth, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1rw8 _1ul91178 _1p3lidpf _13ce4ls2",
            __cmplp.className
        ])
    });
});
const $3f8a6a40f1bb00b7$export$15f08c141eda7939 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isUnassigned: isUnassigned, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c1txw _4cvr1h6o _o5721q9c _1bsb1osq _4t3imslj _16l4kb7n",
            __cmplp.isUnassigned ? "_tzy4idpf" : "_tzy4kb7n",
            __cmplp.isUnassigned ? "_syaz131l" : "_syaz1kw7",
            __cmplp.className
        ])
    });
});
const $3f8a6a40f1bb00b7$export$101fbca3a406e1fd = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _18u01b66 _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $3f8a6a40f1bb00b7$export$78bba2733575aa77 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _syaz131l _lcxvglyw _12qeu2gc",
            __cmplp.className
        ])
    });
});
const $3f8a6a40f1bb00b7$var$containerBaseStyles = null;
const $3f8a6a40f1bb00b7$var$containerMenuOpenStyles = null;
const $3f8a6a40f1bb00b7$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ width: width, isMenuOpen: isMenuOpen, children: children, ...rest }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: ref,
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            width: width ? `${width}px` : '100%'
        },
        ...rest,
        className: (0, $bwpsq.default)([
            "_2rko1hkb _1e0c1txw _4cvr1h6o _4t3i1osq _80omtlke _bfhk18uv _19bvu2gc _16qsglyw",
            isMenuOpen && "_bfhkvuon _19bvze3t _16qscdgj"
        ])
    }, children));

});

parcelRegister("hYB1g", function(module, exports) {

$parcel$export(module.exports, "default", () => $35d87a01fb128cf8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $35d87a01fb128cf8$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    unassignedDisplayName: {
        "id": "business-list.list-view.group-item.assignee-item.unassigned-display-name",
        "defaultMessage": "Unassigned"
    }
});

});


parcelRegister("5ZOAc", function(module, exports) {

$parcel$export(module.exports, "CategoryItem", () => $80825934ae99d844$export$41d1d7fbacf843);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $DhnKp = parcelRequire("DhnKp");

var $koVbs = parcelRequire("koVbs");

var $1J45B = parcelRequire("1J45B");
const $80825934ae99d844$export$41d1d7fbacf843 = /*#__PURE__*/ (0, $5uXOq.memo)(({ data: data })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return data.category?.name != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $DhnKp.default), {
        categoryColor: data.category.color,
        categoryName: data.category.name,
        isInteractive: false
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($80825934ae99d844$var$UncategorizedLabel, null, formatMessage((0, $1J45B.default).noCategory));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $80825934ae99d844$var$UncategorizedLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1fxt",
            __cmplp.className
        ])
    });
});

});
parcelRegister("DhnKp", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3fabf56d1291b24$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $7XYc4 = parcelRequire("7XYc4");

var $dCm1o = parcelRequire("dCm1o");

var $gSwFG = parcelRequire("gSwFG");
const $f3fabf56d1291b24$var$CategoryTag = ({ categoryName: categoryName, categoryColor: categoryColor, isInteractive: isInteractive = true })=>{
    const { textColor: textColor, backgroundColor: tagColor } = (0, $gSwFG.getColorMetadata)(categoryColor);
    return /*#__PURE__*/ $5uXOq.createElement($f3fabf56d1291b24$var$CategoryTagWrapper, {
        isInteractive: isInteractive,
        textColor: (0, $dCm1o.isVisualRefreshEnabled)() ? "var(--ds-text, #172B4D)" : textColor,
        "aria-label": categoryName,
        "data-testid": "business-categories.ui.category-form.category-tag.category-tag-wrapper"
    }, /*#__PURE__*/ $5uXOq.createElement($f3fabf56d1291b24$var$StyledTag, {
        color: tagColor
    }, categoryName));
};
var $f3fabf56d1291b24$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($f3fabf56d1291b24$var$CategoryTag);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f3fabf56d1291b24$var$CategoryTagWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { textColor: textColor, isInteractive: isInteractive, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1qrlcdp": (0, $lD23V.default)(__cmplp.textColor)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_v564188d _1e0c116y _1bah1e5h _4cvr1h6o _p12f1osq _1ul9idpf _1tkeidpf _syazijt0",
            __cmplp.isInteractive ? "_d0altlke" : "_d0al73ad",
            __cmplp.className
        ])
    });
});
const $f3fabf56d1291b24$var$StyledTagOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_xexnhp": (0, $lD23V.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoiti9 _11c82smr _1reo15vq _18m915vq _bfhk1cj8 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _vwz4kb7n _1bto1l2s _o5721q9c _p12f1osq",
            __cmplp.className
        ])
    });
});
const $f3fabf56d1291b24$var$StyledTagNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_14v0t1n": (0, $lD23V.default)(`1px solid ${__cmplp.color}`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko5n0m _19it11we _11c82smr _1reo15vq _18m915vq _bfhk18uv _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66 _vwz4kb7n _1bto1l2s _o5721q9c _p12f1osq",
            __cmplp.className
        ])
    });
});
const $f3fabf56d1291b24$var$StyledTag = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $f3fabf56d1291b24$var$StyledTagNew, $f3fabf56d1291b24$var$StyledTagOld);

});
parcelRegister("gSwFG", function(module, exports) {

$parcel$export(module.exports, "getRandomColor", () => $371e0387ab2e6a89$export$e4369cabd7e84cd9);
$parcel$export(module.exports, "getColorNameFromValue", () => $371e0387ab2e6a89$export$b5ccbadd112d8ce9);
$parcel$export(module.exports, "getValueFromColorName", () => $371e0387ab2e6a89$export$9eff62e8ee2aaa2c);
$parcel$export(module.exports, "getColorMetadata", () => $371e0387ab2e6a89$export$49fce7fdcf55f26d);

var $3m7Ch = parcelRequire("3m7Ch");
const $371e0387ab2e6a89$export$e4369cabd7e84cd9 = ()=>{
    const randomIndex = Math.floor(Math.random() * (0, $3m7Ch.CATEGORY_THEMES).length);
    return (0, $3m7Ch.CATEGORY_THEMES)[randomIndex].name;
};
const $371e0387ab2e6a89$export$b5ccbadd112d8ce9 = (colorValue)=>(0, $3m7Ch.CATEGORY_THEMES).find((item)=>item.backgroundColor === colorValue)?.name ?? '';
const $371e0387ab2e6a89$export$9eff62e8ee2aaa2c = (colorName)=>(0, $3m7Ch.CATEGORY_THEMES).find((item)=>item.name === colorName)?.backgroundColor ?? '';
const $371e0387ab2e6a89$export$49fce7fdcf55f26d = (colorName)=>{
    if (!colorName) return 0, $3m7Ch.GREY_LIGHTEST_META;
    return (0, $3m7Ch.CATEGORY_THEMES).find((item)=>item.name === colorName) ?? (0, $3m7Ch.GREY_LIGHTEST_META);
};
const $371e0387ab2e6a89$export$4ef6b7574883e63d = ()=>(0, $3m7Ch.CATEGORY_THEMES).map((item)=>item.name);

});
parcelRegister("3m7Ch", function(module, exports) {

$parcel$export(module.exports, "GREY_LIGHTEST_META", () => $b019b47b4798283a$export$cb19a604bb399a88);
$parcel$export(module.exports, "CHECK_MARK_COLOR_DARK", () => $b019b47b4798283a$export$270aee965367aeb3);
$parcel$export(module.exports, "CHECK_MARK_COLOR_LIGHT", () => $b019b47b4798283a$export$941ef40ef5fdd2b1);
$parcel$export(module.exports, "CATEGORY_THEMES", () => $b019b47b4798283a$export$845e69f3af4133a6);

var $gAmq4 = parcelRequire("gAmq4");
const $b019b47b4798283a$export$cb19a604bb399a88 = {
    name: 'GREY_LIGHTEST',
    backgroundColor: "var(--ds-background-neutral, #091E420F)",
    textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
    messageLabel: (0, $gAmq4.default).greyLightest
};
const $b019b47b4798283a$var$GREY_LIGHTER_META = {
    name: 'GREY_LIGHTER',
    backgroundColor: "var(--ds-background-neutral-hovered, #091E4224)",
    textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
    messageLabel: (0, $gAmq4.default).greyLighter
};
const $b019b47b4798283a$var$GREY_META = {
    name: 'GREY',
    backgroundColor: "var(--ds-background-neutral-pressed, #091E424F)",
    textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
    messageLabel: (0, $gAmq4.default).grey
};
const $b019b47b4798283a$var$GREY_DARKER_META = {
    name: 'GREY_DARKER',
    backgroundColor: "var(--ds-background-neutral-bold, #44546F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).greyDarker
};
const $b019b47b4798283a$var$GREY_DARKEST_META = {
    name: 'GREY_DARKEST',
    backgroundColor: "var(--ds-background-neutral-bold-pressed, #172B4D)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).greyDarkest
};
const $b019b47b4798283a$var$PURPLE_LIGHTEST_META = {
    name: 'PURPLE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-purple-subtlest, #F3F0FF)",
    textColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    messageLabel: (0, $gAmq4.default).purpleLightest
};
const $b019b47b4798283a$var$PURPLE_LIGHTER_META = {
    name: 'PURPLE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
    textColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    messageLabel: (0, $gAmq4.default).purpleLighter
};
const $b019b47b4798283a$var$PURPLE_META = {
    name: 'PURPLE',
    backgroundColor: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
    textColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    messageLabel: (0, $gAmq4.default).purple
};
const $b019b47b4798283a$var$PURPLE_DARKER_META = {
    name: 'PURPLE_DARKER',
    backgroundColor: "var(--ds-text-accent-purple, #5E4DB2)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).purpleDarker
};
const $b019b47b4798283a$var$PURPLE_DARKEST_META = {
    name: 'PURPLE_DARKEST',
    backgroundColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).purpleDarkest
};
const $b019b47b4798283a$var$BLUE_LIGHTEST_META = {
    name: 'BLUE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-blue-subtlest, #E9F2FF)",
    textColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    messageLabel: (0, $gAmq4.default).blueLightest
};
const $b019b47b4798283a$var$BLUE_LIGHTER_META = {
    name: 'BLUE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
    textColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    messageLabel: (0, $gAmq4.default).blueLighter
};
const $b019b47b4798283a$var$BLUE_META = {
    name: 'BLUE',
    backgroundColor: "var(--ds-background-accent-blue-subtle, #579DFF)",
    textColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    messageLabel: (0, $gAmq4.default).blue
};
const $b019b47b4798283a$var$BLUE_DARKER_META = {
    name: 'BLUE_DARKER',
    backgroundColor: "var(--ds-text-accent-blue, #0055CC)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).blueDarker
};
const $b019b47b4798283a$var$BLUE_DARKEST_META = {
    name: 'BLUE_DARKEST',
    backgroundColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).blueDarkest
};
const $b019b47b4798283a$var$TEAL_LIGHTEST_META = {
    name: 'TEAL_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: (0, $gAmq4.default).tealLightest
};
const $b019b47b4798283a$var$TEAL_LIGHTER_META = {
    name: 'TEAL_LIGHTER',
    backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: (0, $gAmq4.default).tealLighter
};
const $b019b47b4798283a$var$TEAL_META = {
    name: 'TEAL',
    backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: (0, $gAmq4.default).teal
};
const $b019b47b4798283a$var$TEAL_DARKER_META = {
    name: 'TEAL_DARKER',
    backgroundColor: "var(--ds-text-accent-teal, #206A83)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).tealDarker
};
const $b019b47b4798283a$var$TEAL_DARKEST_META = {
    name: 'TEAL_DARKEST',
    backgroundColor: "var(--ds-text-accent-teal-bolder, #164555)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).tealDarkest
};
const $b019b47b4798283a$var$GREEN_LIGHTEST_META = {
    name: 'GREEN_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $gAmq4.default).greenLightest
};
const $b019b47b4798283a$var$GREEN_LIGHTER_META = {
    name: 'GREEN_LIGHTER',
    backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $gAmq4.default).greenLighter
};
const $b019b47b4798283a$var$GREEN_META = {
    name: 'GREEN',
    backgroundColor: "var(--ds-background-accent-green-subtle, #4BCE97)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $gAmq4.default).green
};
const $b019b47b4798283a$var$GREEN_DARKER_META = {
    name: 'GREEN_DARKER',
    backgroundColor: "var(--ds-background-accent-green-bolder, #1F845A)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).greenDarker
};
const $b019b47b4798283a$var$GREEN_DARKEST_META = {
    name: 'GREEN_DARKEST',
    backgroundColor: "var(--ds-text-accent-green-bolder, #164B35)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).greenDarkest
};
const $b019b47b4798283a$var$LIME_LIGHTEST_META = {
    name: 'LIME_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $gAmq4.default).limeLightest
};
const $b019b47b4798283a$var$LIME_LIGHTER_META = {
    name: 'LIME_LIGHTER',
    backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $gAmq4.default).limeLighter
};
const $b019b47b4798283a$var$LIME_META = {
    name: 'LIME',
    backgroundColor: "var(--ds-background-accent-lime-subtle, #94C748)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $gAmq4.default).lime
};
const $b019b47b4798283a$var$LIME_DARKER_META = {
    name: 'LIME_DARKER',
    backgroundColor: "var(--ds-text-accent-lime, #4C6B1F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).limeDarker
};
const $b019b47b4798283a$var$LIME_DARKEST_META = {
    name: 'LIME_DARKEST',
    backgroundColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).limeDarkest
};
const $b019b47b4798283a$var$YELLOW_LIGHTEST_META = {
    name: 'YELLOW_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $gAmq4.default).yellowLightest
};
const $b019b47b4798283a$var$YELLOW_LIGHTER_META = {
    name: 'YELLOW_LIGHTER',
    backgroundColor: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $gAmq4.default).yellowLighter
};
const $b019b47b4798283a$var$YELLOW_META = {
    name: 'YELLOW',
    backgroundColor: "var(--ds-background-accent-yellow-subtle, #F5CD47)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $gAmq4.default).yellow
};
const $b019b47b4798283a$var$YELLOW_DARKER_META = {
    name: 'YELLOW_DARKER',
    backgroundColor: "var(--ds-text-accent-yellow, #7F5F01)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).yellowDarker
};
const $b019b47b4798283a$var$YELLOW_DARKEST_META = {
    name: 'YELLOW_DARKEST',
    backgroundColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).yellowDarkest
};
const $b019b47b4798283a$var$ORANGE_LIGHTEST_META = {
    name: 'ORANGE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-orange-subtlest, #FFF3EB)",
    textColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    messageLabel: (0, $gAmq4.default).orangeLightest
};
const $b019b47b4798283a$var$ORANGE_LIGHTER_META = {
    name: 'ORANGE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
    textColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    messageLabel: (0, $gAmq4.default).orangeLighter
};
const $b019b47b4798283a$var$ORANGE_META = {
    name: 'ORANGE',
    backgroundColor: "var(--ds-background-accent-orange-subtle, #FEA362)",
    textColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    messageLabel: (0, $gAmq4.default).orange
};
const $b019b47b4798283a$var$ORANGE_DARKER_META = {
    name: 'ORANGE_DARKER',
    backgroundColor: "var(--ds-background-accent-orange-bolder, #C25100)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).orangeDarker
};
const $b019b47b4798283a$var$ORANGE_DARKEST_META = {
    name: 'ORANGE_DARKEST',
    backgroundColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).orangeDarkest
};
const $b019b47b4798283a$var$RED_LIGHTEST_META = {
    name: 'RED_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-red-subtlest, #FFECEB)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: (0, $gAmq4.default).redLightest
};
const $b019b47b4798283a$var$RED_LIGHTER_META = {
    name: 'RED_LIGHTER',
    backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: (0, $gAmq4.default).redLighter
};
const $b019b47b4798283a$var$RED_META = {
    name: 'RED',
    backgroundColor: "var(--ds-background-accent-red-subtle, #F87168)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: (0, $gAmq4.default).red
};
const $b019b47b4798283a$var$RED_DARKER_META = {
    name: 'RED_DARKER',
    backgroundColor: "var(--ds-background-accent-red-bolder, #C9372C)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).redDarker
};
const $b019b47b4798283a$var$RED_DARKEST_META = {
    name: 'RED_DARKEST',
    backgroundColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).redDarkest
};
const $b019b47b4798283a$var$MAGENTA_LIGHTEST_META = {
    name: 'MAGENTA_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    messageLabel: (0, $gAmq4.default).magentaLightest
};
const $b019b47b4798283a$var$MAGENTA_LIGHTER_META = {
    name: 'MAGENTA_LIGHTER',
    backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    messageLabel: (0, $gAmq4.default).magentaLighter
};
const $b019b47b4798283a$var$MAGENTA_META = {
    name: 'MAGENTA',
    backgroundColor: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    messageLabel: (0, $gAmq4.default).magenta
};
const $b019b47b4798283a$var$MAGENTA_DARKER_META = {
    name: 'MAGENTA_DARKER',
    backgroundColor: "var(--ds-text-accent-magenta, #943D73)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).magentaDarker
};
const $b019b47b4798283a$var$MAGENTA_DARKEST_META = {
    name: 'MAGENTA_DARKEST',
    backgroundColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).magentaDarkest
};
const $b019b47b4798283a$export$270aee965367aeb3 = "var(--ds-text-inverse, #FFFFFF)";
const $b019b47b4798283a$export$941ef40ef5fdd2b1 = "var(--ds-text, #172B4D)";
const $b019b47b4798283a$export$845e69f3af4133a6 = [
    $b019b47b4798283a$export$cb19a604bb399a88,
    $b019b47b4798283a$var$PURPLE_LIGHTEST_META,
    $b019b47b4798283a$var$BLUE_LIGHTEST_META,
    $b019b47b4798283a$var$TEAL_LIGHTEST_META,
    $b019b47b4798283a$var$GREEN_LIGHTEST_META,
    $b019b47b4798283a$var$LIME_LIGHTEST_META,
    $b019b47b4798283a$var$YELLOW_LIGHTEST_META,
    $b019b47b4798283a$var$ORANGE_LIGHTEST_META,
    $b019b47b4798283a$var$RED_LIGHTEST_META,
    $b019b47b4798283a$var$MAGENTA_LIGHTEST_META,
    $b019b47b4798283a$var$GREY_LIGHTER_META,
    $b019b47b4798283a$var$PURPLE_LIGHTER_META,
    $b019b47b4798283a$var$BLUE_LIGHTER_META,
    $b019b47b4798283a$var$TEAL_LIGHTER_META,
    $b019b47b4798283a$var$GREEN_LIGHTER_META,
    $b019b47b4798283a$var$LIME_LIGHTER_META,
    $b019b47b4798283a$var$YELLOW_LIGHTER_META,
    $b019b47b4798283a$var$ORANGE_LIGHTER_META,
    $b019b47b4798283a$var$RED_LIGHTER_META,
    $b019b47b4798283a$var$MAGENTA_LIGHTER_META,
    $b019b47b4798283a$var$GREY_META,
    $b019b47b4798283a$var$PURPLE_META,
    $b019b47b4798283a$var$BLUE_META,
    $b019b47b4798283a$var$TEAL_META,
    $b019b47b4798283a$var$GREEN_META,
    $b019b47b4798283a$var$LIME_META,
    $b019b47b4798283a$var$YELLOW_META,
    $b019b47b4798283a$var$ORANGE_META,
    $b019b47b4798283a$var$RED_META,
    $b019b47b4798283a$var$MAGENTA_META,
    $b019b47b4798283a$var$GREY_DARKER_META,
    $b019b47b4798283a$var$PURPLE_DARKER_META,
    $b019b47b4798283a$var$BLUE_DARKER_META,
    $b019b47b4798283a$var$TEAL_DARKER_META,
    $b019b47b4798283a$var$GREEN_DARKER_META,
    $b019b47b4798283a$var$LIME_DARKER_META,
    $b019b47b4798283a$var$YELLOW_DARKER_META,
    $b019b47b4798283a$var$ORANGE_DARKER_META,
    $b019b47b4798283a$var$RED_DARKER_META,
    $b019b47b4798283a$var$MAGENTA_DARKER_META,
    $b019b47b4798283a$var$GREY_DARKEST_META,
    $b019b47b4798283a$var$PURPLE_DARKEST_META,
    $b019b47b4798283a$var$BLUE_DARKEST_META,
    $b019b47b4798283a$var$TEAL_DARKEST_META,
    $b019b47b4798283a$var$GREEN_DARKEST_META,
    $b019b47b4798283a$var$LIME_DARKEST_META,
    $b019b47b4798283a$var$YELLOW_DARKEST_META,
    $b019b47b4798283a$var$ORANGE_DARKEST_META,
    $b019b47b4798283a$var$RED_DARKEST_META,
    $b019b47b4798283a$var$MAGENTA_DARKEST_META
];

});
parcelRegister("gAmq4", function(module, exports) {

$parcel$export(module.exports, "default", () => $d59c1f29a6afb9ec$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d59c1f29a6afb9ec$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    greyLightest: {
        "id": "business-categories.category-form.category-color-picker.grey-lightest",
        "defaultMessage": "Grey lightest"
    },
    greyLighter: {
        "id": "business-categories.category-form.category-color-picker.grey-lighter",
        "defaultMessage": "Grey lighter"
    },
    grey: {
        "id": "business-categories.category-form.category-color-picker.grey",
        "defaultMessage": "Grey"
    },
    greyDarker: {
        "id": "business-categories.category-form.category-color-picker.grey-darker",
        "defaultMessage": "Grey darker"
    },
    greyDarkest: {
        "id": "business-categories.category-form.category-color-picker.grey-darkest",
        "defaultMessage": "Grey darkest"
    },
    purpleLightest: {
        "id": "business-categories.category-form.category-color-picker.purple-lightest",
        "defaultMessage": "Purple lightest"
    },
    purpleLighter: {
        "id": "business-categories.category-form.category-color-picker.purple-lighter",
        "defaultMessage": "Purple lighter"
    },
    purple: {
        "id": "business-categories.category-form.category-color-picker.purple",
        "defaultMessage": "Purple"
    },
    purpleDarker: {
        "id": "business-categories.category-form.category-color-picker.purple-darker",
        "defaultMessage": "Purple darker"
    },
    purpleDarkest: {
        "id": "business-categories.category-form.category-color-picker.purple-darkest",
        "defaultMessage": "Purple darkest"
    },
    blueLightest: {
        "id": "business-categories.category-form.category-color-picker.blue-lightest",
        "defaultMessage": "Blue lightest"
    },
    blueLighter: {
        "id": "business-categories.category-form.category-color-picker.blue-lighter",
        "defaultMessage": "Blue lighter"
    },
    blue: {
        "id": "business-categories.category-form.category-color-picker.blue",
        "defaultMessage": "Blue"
    },
    blueDarker: {
        "id": "business-categories.category-form.category-color-picker.blue-darker",
        "defaultMessage": "Blue darker"
    },
    blueDarkest: {
        "id": "business-categories.category-form.category-color-picker.blue-darkest",
        "defaultMessage": "Blue darkest"
    },
    tealLightest: {
        "id": "business-categories.category-form.category-color-picker.teal-lightest",
        "defaultMessage": "Teal lightest"
    },
    tealLighter: {
        "id": "business-categories.category-form.category-color-picker.teal-lighter",
        "defaultMessage": "Teal lighter"
    },
    teal: {
        "id": "business-categories.category-form.category-color-picker.teal",
        "defaultMessage": "Teal"
    },
    tealDarker: {
        "id": "business-categories.category-form.category-color-picker.teal-darker",
        "defaultMessage": "Teal darker"
    },
    tealDarkest: {
        "id": "business-categories.category-form.category-color-picker.teal-darkest",
        "defaultMessage": "Teal darkest"
    },
    greenLightest: {
        "id": "business-categories.category-form.category-color-picker.green-lightest",
        "defaultMessage": "Green lightest"
    },
    greenLighter: {
        "id": "business-categories.category-form.category-color-picker.green-lighter",
        "defaultMessage": "Green lighter"
    },
    green: {
        "id": "business-categories.category-form.category-color-picker.green",
        "defaultMessage": "Green"
    },
    greenDarker: {
        "id": "business-categories.category-form.category-color-picker.green-darker",
        "defaultMessage": "Green darker"
    },
    greenDarkest: {
        "id": "business-categories.category-form.category-color-picker.green-darkest",
        "defaultMessage": "Green darkest"
    },
    limeLightest: {
        "id": "business-categories.category-form.category-color-picker.lime-lightest",
        "defaultMessage": "Lime lightest"
    },
    limeLighter: {
        "id": "business-categories.category-form.category-color-picker.lime-lighter",
        "defaultMessage": "Lime lighter"
    },
    lime: {
        "id": "business-categories.category-form.category-color-picker.lime",
        "defaultMessage": "Lime"
    },
    limeDarker: {
        "id": "business-categories.category-form.category-color-picker.lime-darker",
        "defaultMessage": "Lime darker"
    },
    limeDarkest: {
        "id": "business-categories.category-form.category-color-picker.lime-darkest",
        "defaultMessage": "Lime darkest"
    },
    yellowLightest: {
        "id": "business-categories.category-form.category-color-picker.yellow-lightest",
        "defaultMessage": "Yellow lightest"
    },
    yellowLighter: {
        "id": "business-categories.category-form.category-color-picker.yellow-lighter",
        "defaultMessage": "Yellow lighter"
    },
    yellow: {
        "id": "business-categories.category-form.category-color-picker.yellow",
        "defaultMessage": "Yellow"
    },
    yellowDarker: {
        "id": "business-categories.category-form.category-color-picker.yellow-darker",
        "defaultMessage": "Yellow darker"
    },
    yellowDarkest: {
        "id": "business-categories.category-form.category-color-picker.yellow-darkest",
        "defaultMessage": "Yellow darkest"
    },
    orangeLightest: {
        "id": "business-categories.category-form.category-color-picker.orange-lightest",
        "defaultMessage": "Orange lightest"
    },
    orangeLighter: {
        "id": "business-categories.category-form.category-color-picker.orange-lighter",
        "defaultMessage": "Orange lighter"
    },
    orange: {
        "id": "business-categories.category-form.category-color-picker.orange",
        "defaultMessage": "Orange"
    },
    orangeDarker: {
        "id": "business-categories.category-form.category-color-picker.orange-darker",
        "defaultMessage": "Orange darker"
    },
    orangeDarkest: {
        "id": "business-categories.category-form.category-color-picker.orange-darkest",
        "defaultMessage": "Orange darkest"
    },
    redLightest: {
        "id": "business-categories.category-form.category-color-picker.red-lightest",
        "defaultMessage": "Red lightest"
    },
    redLighter: {
        "id": "business-categories.category-form.category-color-picker.red-lighter",
        "defaultMessage": "Red lighter"
    },
    red: {
        "id": "business-categories.category-form.category-color-picker.red",
        "defaultMessage": "Red"
    },
    redDarker: {
        "id": "business-categories.category-form.category-color-picker.red-darker",
        "defaultMessage": "Red darker"
    },
    redDarkest: {
        "id": "business-categories.category-form.category-color-picker.red-darkest",
        "defaultMessage": "Red darkest"
    },
    magentaLightest: {
        "id": "business-categories.category-form.category-color-picker.magenta-lightest",
        "defaultMessage": "Magenta lightest"
    },
    magentaLighter: {
        "id": "business-categories.category-form.category-color-picker.magenta-lighter",
        "defaultMessage": "Magenta lighter"
    },
    magenta: {
        "id": "business-categories.category-form.category-color-picker.magenta",
        "defaultMessage": "Magenta"
    },
    magentaDarker: {
        "id": "business-categories.category-form.category-color-picker.magenta-darker",
        "defaultMessage": "Magenta darker"
    },
    magentaDarkest: {
        "id": "business-categories.category-form.category-color-picker.magenta-darkest",
        "defaultMessage": "Magenta darkest"
    }
});

});




parcelRegister("1J45B", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d1bb813bc020276$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3d1bb813bc020276$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noCategory: {
        "id": "business-list.list-view.group-item.category-item.no-category",
        "defaultMessage": "Uncategorized"
    }
});

});


parcelRegister("f7bpX", function(module, exports) {

$parcel$export(module.exports, "ExpandIcon", () => $d04d9993a92cad32$export$fcdb0af0473ee9e4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $6Ingq = parcelRequire("6Ingq");

var $ebd3R = parcelRequire("ebd3R");

var $hORKG = parcelRequire("hORKG");

var $3dGN0 = parcelRequire("3dGN0");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $k409E = parcelRequire("k409E");
const $d04d9993a92cad32$var$CONTENT_OFFSET = "var(--ds-space-100, 8px)";
const $d04d9993a92cad32$var$WRAPPER_TRANSFORM = `translate(calc(-100% - ${$d04d9993a92cad32$var$CONTENT_OFFSET}), -50%)`;
const $d04d9993a92cad32$export$fcdb0af0473ee9e4 = ({ expanded: expanded, onClick: onClick, rowIndex: rowIndex, totalGroupItems: totalGroupItems })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const Icon = expanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hORKG))), {
        label: formatMessage((0, $k409E.default).collapseLabel),
        color: "var(--ds-text-subtle, #44546F)",
        LEGACY_primaryColor: "var(--ds-text-subtle, #44546F)",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($6Ingq)))
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3dGN0))), {
        label: formatMessage((0, $k409E.default).open),
        color: "var(--ds-text-subtle, #44546F)",
        LEGACY_primaryColor: "var(--ds-text-subtle, #44546F)",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($ebd3R)))
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleClick = (0, $5uXOq.useCallback)(()=>{
        onClick();
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'listRowGroupExpandIcon', {
            direction: expanded ? 'collapse' : 'expand',
            totalGroupItems: totalGroupItems
        });
    }, [
        createAnalyticsEvent,
        expanded,
        onClick,
        totalGroupItems
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        position: "top",
        content: formatMessage(expanded ? (0, $k409E.default).collapse : (0, $k409E.default).expand)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d04d9993a92cad32$var$ExpandIconWrapper, {
        onClick: handleClick,
        iconBefore: Icon,
        appearance: "subtle",
        testId: `business-list.ui.list-view.group-item.expand-icon.expand-icon-wrapper-${rowIndex}`
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $d04d9993a92cad32$var$ExpandIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_t9ec1mu3 _14n4stnw _w1ap1tcg _btpd1tcg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("k409E", function(module, exports) {

$parcel$export(module.exports, "default", () => $9854930fac9ad6a3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9854930fac9ad6a3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    expand: {
        "id": "business-list.list-view.group-item.expand-icon.expand",
        "defaultMessage": "Expand"
    },
    collapse: {
        "id": "business-list.list-view.group-item.expand-icon.collapse",
        "defaultMessage": "Collapse"
    },
    collapseLabel: {
        "id": "business-list.list-view.group-item.expand-icon.collapse-label",
        "defaultMessage": "collapse"
    },
    open: {
        "id": "business-list.list-view.group-item.expand-icon.open",
        "defaultMessage": "open"
    }
});

});


parcelRegister("hWLf6", function(module, exports) {

$parcel$export(module.exports, "default", () => $26876a53e8b553de$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $26876a53e8b553de$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    visibleItemsCount: {
        "id": "business-list.list-view.group-item.visible-items-count",
        "defaultMessage": "{ visibleItems } of { totalGroupItems }"
    },
    addGroupItem: {
        "id": "business-list.list-view.group-item.add-group-item",
        "defaultMessage": "Add group item"
    },
    createIssue: {
        "id": "business-list.list-view.group-item.create-issue",
        "defaultMessage": "Create"
    }
});

});

parcelRegister("240fW", function(module, exports) {

$parcel$export(module.exports, "PriorityItem", () => $62f1151e65aa2226$export$2ea27b6e6a4479a7);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $aVM5G = parcelRequire("aVM5G");

var $jDI2j = parcelRequire("jDI2j");
const $62f1151e65aa2226$export$2ea27b6e6a4479a7 = ({ data: data })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const priorityName = data.priority?.name != null ? data.priority.name : formatMessage((0, $jDI2j.default).noPriority);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aVM5G.default), {
        iconUrl: data.priority?.iconUrl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($62f1151e65aa2226$var$PriorityLabel, null, priorityName));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $62f1151e65aa2226$var$PriorityLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0u2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aVM5G", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad71f64ee21bbdf9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $ad71f64ee21bbdf9$var$PRIORITY_ICON_SIZE = 20;
const $ad71f64ee21bbdf9$var$PriorityIcon = ({ iconUrl: iconUrl })=>iconUrl == null ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ad71f64ee21bbdf9$var$ImageIcon, {
        src: iconUrl,
        alt: ""
    });
var $ad71f64ee21bbdf9$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($ad71f64ee21bbdf9$var$PriorityIcon);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ad71f64ee21bbdf9$var$ImageIcon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbgktf _4t3igktf",
            __cmplp.className
        ])
    });
});

});

parcelRegister("jDI2j", function(module, exports) {

$parcel$export(module.exports, "default", () => $99fc1044a3441d0c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $99fc1044a3441d0c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noPriority: {
        "id": "business-list.list-view.group-item.priority-item.no-priority",
        "defaultMessage": "No priority"
    }
});

});


parcelRegister("9wkeV", function(module, exports) {

$parcel$export(module.exports, "SelectGroupCheckbox", () => $c271e39c3161153e$export$5740ccbed0a2bd61);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $2GQqf = parcelRequire("2GQqf");

var $mk7k0 = parcelRequire("mk7k0");

var $79pxk = parcelRequire("79pxk");

var $bW4OH = parcelRequire("bW4OH");

var $4DEgE = parcelRequire("4DEgE");

var $9u99d = parcelRequire("9u99d");

var $2SSu7 = parcelRequire("2SSu7");
const $c271e39c3161153e$var$getFirstParent = ({ issuesMap: issuesMap, issueId: issueId })=>{
    const parentIssueId = issuesMap.get(issueId)?.parentIssueId;
    if (parentIssueId) return $c271e39c3161153e$var$getFirstParent({
        issuesMap: issuesMap,
        issueId: parentIssueId
    });
    return issueId;
};
const $c271e39c3161153e$export$5740ccbed0a2bd61 = /*#__PURE__*/ (0, $5uXOq.memo)(({ group: group, rowIndex: rowIndex, onKeyDown: onKeyDown })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [{ issuesMap: issuesMap, expandedItems: expandedItems, childrenItems: childrenItems }] = (0, $9u99d.useHierarchyStore)();
    const [{ areAllIssuesSelected: areAllIssuesSelected, selectedIssues: selectedIssues }, { selectIssues: selectIssues, unselectIssues: unselectIssues, selectGroup: selectGroup, unselectGroup: unselectGroup }] = (0, $mk7k0.useBulkSelectionStore)();
    const [isGroupSelected] = (0, $mk7k0.useIsGroupSelected)(group.issueId);
    const { onShiftKeyBulkSelection: onShiftKeyBulkSelection } = (0, $bW4OH.useShiftKeySelection)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { fetchingGroups: fetchingGroups, selectCollapsedGroups: selectCollapsedGroups } = (0, $79pxk.useSelectCollapsedGroups)();
    const isLoadingGroupIssues = childrenItems[group.issueId]?.loading;
    const groupIssues = (0, $5uXOq.useMemo)(()=>!isLoadingGroupIssues ? (0, $4DEgE.getAllIssueChildren)({
            issue: group,
            childrenItems: childrenItems
        }) : undefined, [
        childrenItems,
        group,
        isLoadingGroupIssues
    ]);
    const [diffGroupIssuesSelected] = (0, $mk7k0.useDiffIssuesSelected)(groupIssues);
    // fetchingGroups - prevent unselecting the group while fetching issues
    (0, $5uXOq.useEffect)(()=>{
        if (!areAllIssuesSelected && !fetchingGroups && !isLoadingGroupIssues && diffGroupIssuesSelected && groupIssues?.length) {
            if (diffGroupIssuesSelected.length === 0 && !isGroupSelected) // if all the issues of the group are selected we should select the group
            selectGroup(group.issueId);
            else if (diffGroupIssuesSelected.length && isGroupSelected) // if some issue is not selected we should unselect the group
            unselectGroup(group.issueId);
        }
    }, [
        areAllIssuesSelected,
        diffGroupIssuesSelected,
        fetchingGroups,
        group.issueId,
        groupIssues?.length,
        isGroupSelected,
        isLoadingGroupIssues,
        selectGroup,
        unselectGroup
    ]);
    const hasChildren = group.childSummary?.hasChildren;
    const hasFirstIssuesToFetch = (0, $5uXOq.useMemo)(()=>expandedItems[group.issueId] === undefined && hasChildren && groupIssues?.length === 0, [
        expandedItems,
        group.issueId,
        groupIssues?.length,
        hasChildren
    ]);
    const onClickCheckbox = (0, $5uXOq.useCallback)(({ isChecked: isChecked, shiftKeyPressed: shiftKeyPressed })=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'checkbox clicked', 'selectGroup', {
            isChecked: isChecked,
            rowIndex: rowIndex,
            shiftKeyPressed: shiftKeyPressed
        });
        if (isChecked) {
            // if the group is selected and we have not fetched children of the group
            // we should expand the group and fetch them
            selectCollapsedGroups([
                group
            ]);
            selectIssues({
                issues: groupIssues || [],
                selectGroup: group.issueId,
                rowIndex: rowIndex
            });
        } else {
            let issuesToUnselect = groupIssues || [];
            if (!groupIssues?.length) /* Edge case - Sorting - line 170 */ issuesToUnselect = [
                ...selectedIssues
            ].filter((issueId)=>$c271e39c3161153e$var$getFirstParent({
                    issuesMap: issuesMap,
                    issueId: issueId
                }) === group.issueId);
            unselectIssues({
                issues: issuesToUnselect,
                unselectGroup: group.issueId,
                rowIndex: rowIndex
            });
        }
        if (shiftKeyPressed) onShiftKeyBulkSelection({
            isChecked: isChecked,
            rowIndex: rowIndex
        });
    }, [
        createAnalyticsEvent,
        group,
        groupIssues,
        issuesMap,
        onShiftKeyBulkSelection,
        rowIndex,
        selectCollapsedGroups,
        selectIssues,
        selectedIssues,
        unselectIssues
    ]);
    //  if there is some issue of the group selected
    let hasSomeGroupIssueSelected = !!(Number(diffGroupIssuesSelected?.length) > 0 && Number(diffGroupIssuesSelected?.length) < Number(groupIssues?.length));
    // shouldBeSelected is to check the group immediately when all the issues are selected (diffGroupIssuesSelected is 0)
    //  instead of waiting for the useEffect (line 73) to update the store to calling selectGroup once all the issues are selected
    const shouldBeSelected = Number(diffGroupIssuesSelected?.length) === 0 && hasChildren && Number(groupIssues?.length) > 0 && !hasFirstIssuesToFetch;
    let isChecked = isGroupSelected || hasSomeGroupIssueSelected || !!shouldBeSelected;
    if (!isChecked && selectedIssues.size) {
        /*
                 Edge case - Sorting
                  When the sorting of the columns or the filters changes all the groups change to collapsed and all the children's data it's null.
                 If there is data selected we are not able to match it with the group data.
                 If the change it's due to a filter change we clear the selection because we don't know if it's going to match with the new group data.
                 If the change it's due to sorting we know that will still be part of that group
             */ hasSomeGroupIssueSelected = [
            ...selectedIssues
        ].some((issueId)=>$c271e39c3161153e$var$getFirstParent({
                issuesMap: issuesMap,
                issueId: issueId
            }) === group.issueId);
        isChecked = hasSomeGroupIssueSelected;
    }
    const handleKeyDown = (0, $5uXOq.useCallback)((e)=>{
        if (e.key === 'Enter') {
            onClickCheckbox({
                isChecked: !isChecked,
                shiftKeyPressed: e.shiftKey
            });
            return;
        }
        onKeyDown?.(e);
    }, [
        isChecked,
        onClickCheckbox,
        onKeyDown
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2GQqf.BulkSelectCheckbox), {
        onClick: onClickCheckbox,
        onKeyDown: handleKeyDown,
        isChecked: isChecked,
        isIndeterminate: hasSomeGroupIssueSelected,
        label: formatMessage((0, $2SSu7.default).selectGroup)
    });
});

});
parcelRegister("2GQqf", function(module, exports) {

$parcel$export(module.exports, "BulkSelectCheckbox", () => $05c4778a6afe1316$export$9d26591b0d1643b6);

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $kkJfY = parcelRequire("kkJfY");

var $k6T4f = parcelRequire("k6T4f");
var $5Fk4Z = parcelRequire("5Fk4Z");

var $jldZL = parcelRequire("jldZL");

var $4R6GH = parcelRequire("4R6GH");

var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $eTDjN = parcelRequire("eTDjN");
const $05c4778a6afe1316$export$9d26591b0d1643b6 = /*#__PURE__*/ (0, $5uXOq.memo)(({ id: id, onClick: onClick, isChecked: isChecked, isIndeterminate: isIndeterminate, isSelected: isSelected, wrapperRef: wrapperRef, onKeyDown: onKeyDown, isDisabled: isDisabled, hasPulse: hasPulse, label: label, ...props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const bulkSelectId = id ?? `${0, $eTDjN.BULK_SELECT_CHECKBOX_ID}_${(0, $7Jxgt.v4)()}`;
    const handleOnClick = (0, $5uXOq.useCallback)((event)=>{
        if (hasPulse) (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'checkbox'
        }), 'checkbox clicked', 'bulkEditChangeboardingCheckboxPulse');
        onClick({
            isChecked: event?.currentTarget?.checked,
            shiftKeyPressed: !!event?.shiftKey
        });
    }, [
        hasPulse,
        onClick,
        createAnalyticsEvent
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isSelected && wrapperRef?.current) wrapperRef.current.focus();
    }, [
        isSelected,
        wrapperRef
    ]);
    const onWrapperRef = (0, $5uXOq.useCallback)((ref)=>{
        if (wrapperRef) // eslint-disable-next-line no-param-reassign
        wrapperRef.current = ref;
    }, [
        wrapperRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jldZL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("label", {
        htmlFor: bulkSelectId
    }, label)), hasPulse && (0, $4R6GH.fg)('jira_list_view_bulk_edit_changeboarding') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: "bulk-select-checkbox"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k6T4f.Pulse), {
        radius: 3,
        testId: "business-list.common.ui.bulk-select-checkbox.spotlight-pulse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkJfY.default), {
        id: bulkSelectId,
        onClick: handleOnClick,
        isChecked: isChecked,
        isDisabled: isDisabled,
        isIndeterminate: isIndeterminate,
        testId: "business-list.common.ui.bulk-select-checkbox",
        onKeyDown: onKeyDown,
        ...wrapperRef ? {
            ref: onWrapperRef
        } : {},
        ...props
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: {
            messageId: (0, $eTDjN.BULK_EDIT_CHANGEBOARDING_MESSAGE_ID),
            componentType: 'spotlight-pulse'
        }
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkJfY.default), {
        id: bulkSelectId,
        onClick: handleOnClick,
        isChecked: isChecked,
        isDisabled: isDisabled,
        isIndeterminate: isIndeterminate,
        testId: "business-list.common.ui.bulk-select-checkbox",
        onKeyDown: onKeyDown,
        ...wrapperRef ? {
            ref: onWrapperRef
        } : {},
        ...props
    }));
});

});
parcelRegister("kkJfY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3106eb14f9b0a593$export$2e2bcd8739ae039);
/* checkbox.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6QvkM = parcelRequire("6QvkM");

var $5JjdN = parcelRequire("5JjdN");

var $kag1C = parcelRequire("kag1C");
var $7xteU = parcelRequire("7xteU");
var $hsLv2 = parcelRequire("hsLv2");
var $e62YQ = parcelRequire("e62YQ");
const $3106eb14f9b0a593$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf _r050fibj _9bg71mn3 _19op11so _a30fhteq _1610e4h9 _13wo93zu _q5a61gyf _8gq114p8 _wje2mov0 _1fo21cni _eyedglyw _1ef7js4s _1h6rjs4s _smzgj3jf _1dk7j3jf _l71j1i6y _t34a1i6y _y32gkivo _1ah9199y _1frj180l _h78e1g3k _dwvb1ps2 _1bok170n _1mhr17cl _fx2i3rva _10oaq2ws _w12s155b _15y61vek _e6ww155b _sg1j1vek _rphw18jz _y9y9mz2b _141bmz2b _255gmz2b _jj67mz2b _swhgmz2b _axq81diq _1jiz1diq _s9051diq _1efy1diq _1oav1diq _10y313gf _1wt913gf _qq8613gf _1adw13gf _12sr13gf _16jiglyw _693jglyw _1niqglyw _cl9tglyw _1jbnglyw _j1ta1hou _18qu1ps2 _1g52170n _1log17cl _32hzmz2b _1vv91diq _yjhd1hou _w1cowc43 _jdqn1onz _4y4t1onz _lvfrwc43 _g68dwc43 _13dk1onz _w1el1onz _a9yw1onz _1l3g1onz _dcdpgir2 _wobcgir2 _rp9wgir2 _9ebfwc43 _e43iwc43 _1tkuwc43 _1lehwc43 _b9q3wc43 _tu2918qt _1uxv18qt _1ufw18qt _opo918qt _1e8318qt _1k3d18qt _25yv18qt _1igz18qt _c7cc18qt _1swg18qt"
}; /**
    * __Checkbox__
    *
    * A checkbox an input control that allows a user to select one or more options from a number of choices.
    *
    * - [Examples](https://atlassian.design/components/checkbox/examples)
    * - [Code](https://atlassian.design/components/checkbox/code)
    * - [Usage](https://atlassian.design/components/checkbox/usage)
    */ 
const $3106eb14f9b0a593$var$Checkbox = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $5uXOq.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $5uXOq.useRef)(null);
    const mergedRefs = (0, $5JjdN.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $5uXOq.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $7xteU.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("input" // It is necessary only for Safari. It allows to render focus styles.
            , {
                tabIndex: 0,
                ...rest,
                type: "checkbox",
                ref: mergedRefs,
                disabled: isDisabled,
                checked: isChecked,
                value: value,
                name: name,
                required: isRequired,
                className: (0, $bwpsq.default)([
                    $3106eb14f9b0a593$var$checkboxStyles.root,
                    className
                ]),
                onChange: onChangeAnalytics,
                "aria-invalid": isInvalid ? 'true' : undefined,
                "data-testid": testId && `${testId}--hidden-checkbox`,
                "data-invalid": isInvalid ? 'true' : undefined
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kag1C.default), {
                isIndeterminate: isIndeterminate,
                isChecked: isChecked
            }),
            label && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $hsLv2.default), {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e62YQ.default), {})
                ]
            })
        ]
    });
}));
$3106eb14f9b0a593$var$Checkbox.displayName = 'Checkbox';
var $3106eb14f9b0a593$export$2e2bcd8739ae039 = $3106eb14f9b0a593$var$Checkbox;

});
parcelRegister("kag1C", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0746a27410bc168$export$2e2bcd8739ae039);
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $dV6Te = parcelRequire("dV6Te");

var $VSDnB = parcelRequire("VSDnB");
function $a0746a27410bc168$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $VSDnB.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
            fill: "inherit",
            x: "8",
            y: "11",
            width: "8",
            height: "2",
            rx: "1"
        });
    }
    if (isChecked) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $VSDnB.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
            fill: "inherit"
        });
    }
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $a0746a27410bc168$var$CheckboxIcon = /*#__PURE__*/ (0, $5uXOq.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $5uXOq.useMemo)(()=>$a0746a27410bc168$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dV6Te.default), {
        label: "",
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                (0, $VSDnB.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5"
                }) : /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    fill: "currentColor",
                    x: "6",
                    y: "6",
                    width: "12",
                    height: "12",
                    rx: "2"
                }),
                icon
            ]
        })
    });
});
var $a0746a27410bc168$export$2e2bcd8739ae039 = $a0746a27410bc168$var$CheckboxIcon;

});

parcelRegister("7xteU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b368d644c230660$export$2e2bcd8739ae039);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $7b368d644c230660$var$baseStyles = null;
const $7b368d644c230660$var$textLabelLayoutStyles = null;
const $7b368d644c230660$var$disabledStyles = null;
const $7b368d644c230660$var$labelStyles = null;
function $7b368d644c230660$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("label", {
        className: (0, $bwpsq.default)([
            "_11c82smr _1e0c11p5 _1ejihkll _umai184x _syazj3m3 _80om73ad",
            label && "_zulp1nu5 _yv0ey09t",
            isDisabled && "_syaz1tvo _80om13gf",
            "_h5e3mag2 _1nzs11d3 _1eszzyvw _yp0jhh5a _ay2w1y1w _d51u10ko _phft1fmg _1g1funzk _l6wkzyvw _1dikhh5a _1sfg1q3k _fpdj1y1w _1yjc194a _oaj11fmg _1j3h1q3k _eawb1dzn _1rda1qbb _18q015t7 _13hr3acm",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
}

});

parcelRegister("hsLv2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce636d67b4ff1120$export$2e2bcd8739ae039);
/* label-text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $ce636d67b4ff1120$var$labelTextStyles = null;
function $ce636d67b4ff1120$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            "_nd5l11ig _1wpz1h6o"
        ]),
        children: children
    });
}

});

parcelRegister("e62YQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2156c28a3894cac$export$2e2bcd8739ae039);
/* required-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $d2156c28a3894cac$var$requiredIndicatorStyles = null;
function $d2156c28a3894cac$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "aria-hidden": true,
        className: (0, $bwpsq.default)([
            "_syaz1gtz _bozgv77o"
        ]),
        children: "*"
    });
}

});



parcelRegister("79pxk", function(module, exports) {

$parcel$export(module.exports, "useSelectCollapsedGroups", () => $15bcf90ef5bfa851$export$fb1b9a2145b5780d);

var $5uXOq = parcelRequire("5uXOq");

var $9u99d = parcelRequire("9u99d");

var $mk7k0 = parcelRequire("mk7k0");
const $15bcf90ef5bfa851$export$fb1b9a2145b5780d = ()=>{
    const [{ expandedItems: expandedItems, childrenItems: childrenItems }, { setExpandedItems: setExpandedItems }] = (0, $9u99d.useHierarchyStore)();
    const [{ fetchingGroups: fetchingGroups, selectedGroups: selectedGroups }, { selectIssues: selectIssues, selectGroup: selectGroup, setFetchingGroups: setFetchingGroups }] = (0, $mk7k0.useBulkSelectionStore)();
    (0, $5uXOq.useEffect)(()=>{
        // if the fetch of the group issues is done and the group is selected
        // we should select the group issues
        if (fetchingGroups.length) {
            let groupFetchDone = [];
            fetchingGroups.forEach((groupId)=>{
                const group = childrenItems[groupId];
                if (group?.loading === false && selectedGroups.has(groupId)) {
                    selectIssues({
                        issues: group.data.map((i)=>String(i.issueId))
                    });
                    groupFetchDone = [
                        ...groupFetchDone,
                        groupId
                    ];
                }
            });
            if (groupFetchDone.length) setFetchingGroups(fetchingGroups.filter((g)=>!groupFetchDone.includes(g)));
        }
    }, [
        childrenItems,
        fetchingGroups,
        selectIssues,
        selectedGroups,
        setFetchingGroups
    ]);
    const selectCollapsedGroups = (0, $5uXOq.useCallback)((groups)=>{
        let groupToFetch = [];
        groups.forEach((group)=>{
            const { issueId: issueId, childSummary: childSummary } = group;
            const hasChildren = childSummary?.hasChildren;
            selectGroup(issueId);
            const hasIssuesToFetch = expandedItems[issueId] === undefined && childrenItems[issueId] === undefined && hasChildren;
            setExpandedItems(issueId, true);
            // if the group is selected and we have not fetched children of the group
            // we should expand the group and fetch them
            if (hasIssuesToFetch) groupToFetch = [
                ...groupToFetch,
                issueId
            ];
        });
        setFetchingGroups(groupToFetch);
    }, [
        childrenItems,
        expandedItems,
        selectGroup,
        setExpandedItems,
        setFetchingGroups
    ]);
    return {
        selectCollapsedGroups: selectCollapsedGroups,
        fetchingGroups: fetchingGroups.length > 0
    };
};

});

parcelRegister("bW4OH", function(module, exports) {

$parcel$export(module.exports, "useShiftKeySelection", () => $c97ee04499e140fa$export$e105f3cb55da1b14);

var $5uXOq = parcelRequire("5uXOq");

var $fn8B5 = parcelRequire("fn8B5");

var $jDUax = parcelRequire("jDUax");

var $8e3Yw = parcelRequire("8e3Yw");

var $9u99d = parcelRequire("9u99d");

var $mk7k0 = parcelRequire("mk7k0");

var $79pxk = parcelRequire("79pxk");

var $4DEgE = parcelRequire("4DEgE");
const $c97ee04499e140fa$export$e105f3cb55da1b14 = ()=>{
    const [groupByFieldId] = (0, $8e3Yw.useGroupBy)();
    const [{ issuesMap: issuesMap, expandedItems: expandedItems, hierarchyData: hierarchyData, childrenItems: childrenItems }] = (0, $9u99d.useHierarchyStore)();
    const [{ selectedIssues: selectedIssuesStore, fetchingGroups: fetchingGroups, lastSelectedRowIndex: lastSelectedRowIndex }, { selectIssues: selectIssues, unselectIssues: unselectIssues, setLastSelectedRowIndex: setLastSelectedRowIndex }] = (0, $mk7k0.useBulkSelectionStore)();
    const { selectCollapsedGroups: selectCollapsedGroups } = (0, $79pxk.useSelectCollapsedGroups)();
    /*
        If grouping, the last lastSelectedRowIndex could change  due to expanding and fetching a group
        Once we finish with the fetching of the groups we should update lastSelectedRowIndex with the new index
    */ const [lastIssueIdSelected, setLastIssueIdSelected] = (0, $5uXOq.useState)();
    (0, $5uXOq.useEffect)(()=>{
        const isGrouping = groupByFieldId != null;
        if (isGrouping && !fetchingGroups.length && lastSelectedRowIndex !== undefined && lastIssueIdSelected) {
            const issues = (0, $4DEgE.getFlattenIssuesList)({
                issues: hierarchyData.data,
                expandedItems: expandedItems
            });
            const newIndex = issues.findIndex((i)=>String(i.issueId) === lastIssueIdSelected);
            if (newIndex >= 0) {
                setLastSelectedRowIndex(newIndex);
                setLastIssueIdSelected(undefined);
            }
        }
    // Should only update the last selected row index once
    // the expanded items are updated and the groups are finally fetched
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        expandedItems,
        fetchingGroups
    ]);
    const onShiftKeyBulkSelection = (0, $5uXOq.useCallback)(({ isChecked: isChecked, rowIndex: selectedRowIndex })=>{
        let rowIndex = selectedRowIndex;
        if (lastSelectedRowIndex !== undefined && rowIndex !== undefined) {
            const lastIssueSelected = issuesMap.get([
                ...selectedIssuesStore
            ].pop() || '');
            const parentLastIssueSelected = lastIssueSelected?.parentIssueId;
            let expandedItemsToGetFlattenList = expandedItems;
            if (parentLastIssueSelected && !(0, $jDUax.isGroupItem)(parentLastIssueSelected) && !expandedItems[parentLastIssueSelected]) {
                /*
                    Edge case
                        If the last issue selected it's a child of a collapsed task/epic
                        We should simulate the parent as expanded because we need to select the hidden children
                        */ expandedItemsToGetFlattenList = {
                    ...expandedItemsToGetFlattenList,
                    [parentLastIssueSelected]: true
                };
                rowIndex += issuesMap.get(parentLastIssueSelected)?.children?.length || 0;
            }
            const issues = expandedItems ? (0, $4DEgE.getFlattenIssuesList)({
                issues: hierarchyData.data,
                expandedItems: expandedItemsToGetFlattenList
            }) : hierarchyData.data;
            let selectedIssues = [];
            if (lastSelectedRowIndex < rowIndex) selectedIssues = issues.slice(lastSelectedRowIndex, rowIndex + 1);
            else selectedIssues = issues.slice(rowIndex, !isChecked ? lastSelectedRowIndex + 1 : lastSelectedRowIndex);
            let issueIds = [];
            const isGrouping = groupByFieldId != null;
            if (isGrouping) {
                const groups = (0, (/*@__PURE__*/$parcel$interopDefault($fn8B5)))(selectedIssues, (issue)=>(0, $jDUax.isGroupItem)(issue.issueId));
                // select/unselect issues that are in the middle and are not groups
                issueIds = groups.false.map((issue)=>String(issue.issueId));
                // Should select and expand the groups in the middle but not the parent of the selected issue
                const pressedIssue = issues[rowIndex];
                const groupsToSelect = groups.true?.filter((group)=>group.issueId !== pressedIssue.parentIssueId) || [];
                if (groupsToSelect.length) {
                    /*
                            if there are groups in the middle of the selection we should keep
                            the last issue selected to update the row index because could change
                            depending on the groups that are going to be expanded
                        */ setLastIssueIdSelected(pressedIssue.issueId);
                    if (isChecked) selectCollapsedGroups(groupsToSelect);
                    else groupsToSelect.forEach((group)=>{
                        const groupIssues = (0, $4DEgE.getAllIssueChildren)({
                            issue: group,
                            childrenItems: childrenItems
                        });
                        unselectIssues({
                            issues: groupIssues || [],
                            unselectGroup: group.issueId,
                            rowIndex: rowIndex
                        });
                    });
                }
            } else issueIds = selectedIssues.map((issue)=>String(issue.issueId));
            if (!isChecked) unselectIssues({
                issues: issueIds
            });
            else selectIssues({
                issues: issueIds
            });
        }
    }, [
        childrenItems,
        expandedItems,
        groupByFieldId,
        hierarchyData.data,
        issuesMap,
        lastSelectedRowIndex,
        selectCollapsedGroups,
        selectIssues,
        selectedIssuesStore,
        unselectIssues
    ]);
    return {
        onShiftKeyBulkSelection: onShiftKeyBulkSelection
    };
};

});

parcelRegister("2SSu7", function(module, exports) {

$parcel$export(module.exports, "default", () => $033eedec001f2bfe$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $033eedec001f2bfe$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    selectGroup: {
        "id": "business-list.list-view.group-item.select-group-checkbox.select-group",
        "defaultMessage": "Select group"
    }
});

});


parcelRegister("iaKbb", function(module, exports) {

$parcel$export(module.exports, "SprintItem", () => $559bdcd95b3fa7c0$export$c40eb2da058b4e36);

var $5uXOq = parcelRequire("5uXOq");

var $d9xxV = parcelRequire("d9xxV");

var $koVbs = parcelRequire("koVbs");

var $fZK5l = parcelRequire("fZK5l");
const $559bdcd95b3fa7c0$export$c40eb2da058b4e36 = ({ data: data })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { sprint: sprint } = data;
    let text;
    if (!sprint) text = formatMessage((0, $fZK5l.default).backlog);
    else if (sprint.state === 'CLOSED') text = formatMessage((0, $fZK5l.default).completedSprint);
    else text = sprint.name;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d9xxV.default), {
        text: text,
        testId: "business-list.ui.list-view.group-item.sprint-item.simple-tag"
    });
};

});
parcelRegister("d9xxV", function(module, exports) {

$parcel$export(module.exports, "default", () => $87927dab24395a15$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $5oSQr = parcelRequire("5oSQr");

var $aXLIT = parcelRequire("aXLIT");

var $eYXIO = parcelRequire("eYXIO");
const $87927dab24395a15$var$SimpleTagComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ appearance: appearance, elemBefore: elemBefore = null, color: color = 'standard', href: href, testId: testId, text: text = '', linkComponent: linkComponent }, ref)=>{
    const content = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eYXIO.default), {
        elemBefore: elemBefore,
        isRemovable: false,
        text: text,
        color: color,
        href: href,
        linkComponent: linkComponent
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5oSQr.default), {
        ref: ref,
        testId: testId,
        href: href,
        appearance: appearance,
        color: color,
        before: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aXLIT.default), {
            elemBefore: elemBefore
        }),
        contentElement: content
    });
});
/**
 * __Simple tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * `SimpleTag` is the default form of a tag, where text is required. Tags with static text can be used as a flag or as a reference to an object or attribute.
 *
 * - [Examples](https://atlassian.design/components/tag/examples)
 * - [Code](https://atlassian.design/components/tag/code)
 * - [Usage](https://atlassian.design/components/tag/usage)
 */ const $87927dab24395a15$var$SimpleTag = /*#__PURE__*/ (0, $5uXOq.memo)($87927dab24395a15$var$SimpleTagComponent);
var $87927dab24395a15$export$2e2bcd8739ae039 = $87927dab24395a15$var$SimpleTag;

});
parcelRegister("5oSQr", function(module, exports) {

$parcel$export(module.exports, "default", () => $db35d9df42c66ff0$export$2e2bcd8739ae039);
/* base.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $2hnSR = parcelRequire("2hnSR");
const $db35d9df42c66ff0$var$borderColorCssVar = '--ds-bc';
const $db35d9df42c66ff0$var$focusRingCssVar = '--ds-cfr';
const $db35d9df42c66ff0$var$textLinkCssVar = '--ds-ctl';
const $db35d9df42c66ff0$var$textDefaultCssVar = '--ds-ct';
const $db35d9df42c66ff0$var$textHoverCssVar = '--ds-cth';
const $db35d9df42c66ff0$var$textActiveCssVar = '--ds-ctp';
const $db35d9df42c66ff0$var$backgroundDefaultCssVar = '--ds-cb';
const $db35d9df42c66ff0$var$backgroundHoverCssVar = '--ds-cbh';
const $db35d9df42c66ff0$var$backgroundActiveCssVar = '--ds-cba';
const $db35d9df42c66ff0$var$removeButtonDefaultCssVar = '--ds-rb';
const $db35d9df42c66ff0$var$removeButtonHoverCssVar = '--ds-rbh';
const $db35d9df42c66ff0$var$borderRadiusCssVar = '--ds-br';
// To be removed with platform-component-visual-refresh (BLU-2992)
const $db35d9df42c66ff0$var$baseStylesOld = null;
const $db35d9df42c66ff0$var$baseStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $db35d9df42c66ff0$var$interactiveStylesOld = null;
const $db35d9df42c66ff0$var$interactiveStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $db35d9df42c66ff0$var$focusRingStylesOld = null;
const $db35d9df42c66ff0$var$focusRingStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $db35d9df42c66ff0$var$nonStandardLinkStyles = null;
const $db35d9df42c66ff0$var$BaseTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(function BaseTag({ before: before, contentElement: contentElement, after: after, testId: testId, appearance: appearance = 'default', style: style, color: color = 'standard', href: href, className: className, ...other }, ref) {
    const isLink = Boolean(href);
    const isRemovable = Boolean(after);
    const isInteractive = isLink || isRemovable;
    const isStandardLink = isLink && color === 'standard';
    // Change link text color if  the tag is standard color
    const textLinkColors = isStandardLink ? (0, $2hnSR.textColors)['standardLink'] : (0, $2hnSR.textColors)[color];
    const backgroundHoverColors = isRemovable && !isLink ? (0, $2hnSR.backgroundColors)[color] : (0, $2hnSR.linkHoverBackgroundColors)[color];
    const backgroundActiveColors = isRemovable && !isLink ? (0, $2hnSR.backgroundColors)[color] : (0, $2hnSR.linkActiveBackgroundColors)[color];
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("span", {
        ...other,
        ref: ref,
        style: {
            // NOTE: The vast majority of these styles have zero purpose to be runtime computed
            // This can all be migrated to statically distributed atomic CSS with Compiled in the future
            // The main reason for not touching this is there is to avoid excessive changes in the same PR on non-visual-refresh code
            /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ [$db35d9df42c66ff0$var$borderColorCssVar]: (0, $2hnSR.borderColors)[color],
            [$db35d9df42c66ff0$var$textDefaultCssVar]: (0, $2hnSR.textColors)[color],
            [$db35d9df42c66ff0$var$textHoverCssVar]: (0, $2hnSR.textHoverColors)[color],
            [$db35d9df42c66ff0$var$textActiveCssVar]: (0, $2hnSR.textActiveColors)[color],
            [$db35d9df42c66ff0$var$textLinkCssVar]: textLinkColors,
            [$db35d9df42c66ff0$var$backgroundDefaultCssVar]: (0, $2hnSR.backgroundColors)[color],
            [$db35d9df42c66ff0$var$backgroundHoverCssVar]: backgroundHoverColors,
            [$db35d9df42c66ff0$var$backgroundActiveCssVar]: backgroundActiveColors,
            [$db35d9df42c66ff0$var$focusRingCssVar]: (0, $2hnSR.focusRingColors),
            [$db35d9df42c66ff0$var$removeButtonDefaultCssVar]: (0, $2hnSR.removeButtonColors)[color],
            [$db35d9df42c66ff0$var$removeButtonHoverCssVar]: (0, $2hnSR.removeButtonHoverColors)[color],
            [$db35d9df42c66ff0$var$borderRadiusCssVar]: appearance === 'rounded' ? '10px' : '3px',
            /* eslint-enable @atlaskit/ui-styling-standard/enforce-style-prop */ /* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values */ // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...style
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_zulp1b66 _2rko1sit _1h6d2fso _1dqonqa1 _189ee4h9 _1mou1b66 _195g1b66 _18zr1b66 _1e0c116y _vchhusvi _1ul9idpf _4t3iv47k _kqswh2mm _4cvr1h6o _bfhk1w7a _syaz1fxt _80om73ad" : "_2rko1l5z _1mou1b66 _195g1b66 _1rjcze3t _18zrze3t _1e0c116y _1ul9idpf _4t3iv47k _kqswh2mm _bfhklsll _syaz148y _80om73ad",
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_1e38ugt7 _7glxv77o" : "_1guj1r31 _pbhaglyw _11ow1o36 _1u6lnr64",
            isLink && (0, $VSDnB.fg)('platform-component-visual-refresh') && "_irr3166n _1di61dty",
            !(0, $VSDnB.fg)('platform-component-visual-refresh') && isLink && !isStandardLink && "_9h8h1348",
            !(0, $VSDnB.fg)('platform-component-visual-refresh') && isInteractive && "_irr31lyj _1di6oo20",
            className
        ]),
        "data-testid": testId,
        children: [
            before,
            contentElement,
            after
        ]
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$db35d9df42c66ff0$export$2e2bcd8739ae039 = $db35d9df42c66ff0$var$BaseTag;

});
parcelRegister("2hnSR", function(module, exports) {

$parcel$export(module.exports, "textColors", () => $5b444d8505b9cc3c$export$daa0ace263cb20d2);
$parcel$export(module.exports, "borderColors", () => $5b444d8505b9cc3c$export$1c1b571cf296eca7);
$parcel$export(module.exports, "textHoverColors", () => $5b444d8505b9cc3c$export$7c7104a5f052cab7);
$parcel$export(module.exports, "textActiveColors", () => $5b444d8505b9cc3c$export$382469baad253eb7);
$parcel$export(module.exports, "backgroundColors", () => $5b444d8505b9cc3c$export$b9d7c59a579c23c6);
$parcel$export(module.exports, "linkHoverBackgroundColors", () => $5b444d8505b9cc3c$export$4410079763249c74);
$parcel$export(module.exports, "linkActiveBackgroundColors", () => $5b444d8505b9cc3c$export$76be99c5e13e3566);
$parcel$export(module.exports, "focusRingColors", () => $5b444d8505b9cc3c$export$2a31dbe82788f940);
$parcel$export(module.exports, "removalHoverBackgroundColors", () => $5b444d8505b9cc3c$export$1202b7eb21da7b58);
$parcel$export(module.exports, "removalActiveBackgroundColors", () => $5b444d8505b9cc3c$export$62ace793ebb16bda);
$parcel$export(module.exports, "removalTextColors", () => $5b444d8505b9cc3c$export$17d206ccea111bbb);
$parcel$export(module.exports, "removeButtonColors", () => $5b444d8505b9cc3c$export$f64c7641cbc22da7);
$parcel$export(module.exports, "removeButtonHoverColors", () => $5b444d8505b9cc3c$export$b03fbc2a369c563e);
// Text colors
const $5b444d8505b9cc3c$export$daa0ace263cb20d2 = {
    standard: "var(--ds-text, #253858)",
    standardLink: "var(--ds-link, #0052CC)",
    blue: "var(--ds-text-accent-blue-bolder, #172B4D)",
    red: "var(--ds-text-accent-red-bolder, #172B4D)",
    yellow: "var(--ds-text-accent-yellow-bolder, #172B4D)",
    green: "var(--ds-text-accent-green-bolder, #172B4D)",
    teal: "var(--ds-text-accent-teal-bolder, #172B4D)",
    purple: "var(--ds-text-accent-purple-bolder, #172B4D)",
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: "var(--ds-text-accent-gray-bolder, #FFFFFF)",
    blueLight: "var(--ds-text-accent-blue, #0747A6)",
    redLight: "var(--ds-text-accent-red, #42526E)",
    yellowLight: "var(--ds-text-accent-yellow, #42526E)",
    greenLight: "var(--ds-text-accent-green, #006644)",
    tealLight: "var(--ds-text-accent-teal, #42526E)",
    purpleLight: "var(--ds-text-accent-purple, #403294)",
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: "var(--ds-text-accent-gray, #42526E)"
};
const $5b444d8505b9cc3c$export$1c1b571cf296eca7 = {
    standard: '#B7B9BE',
    blue: '#669DF1',
    red: '#F87168',
    yellow: '#DDB30E',
    green: '#4BCE97',
    teal: '#6CC3E0',
    purple: '#C97CF4',
    lime: '#94C748',
    magenta: '#E774BB',
    orange: '#FCA700',
    grey: '#B7B9BE',
    standardLink: '#B7B9BE',
    blueLight: '#669DF1',
    redLight: '#F87168',
    yellowLight: '#DDB30E',
    greenLight: '#4BCE97',
    tealLight: '#6CC3E0',
    purpleLight: '#C97CF4',
    limeLight: '#94C748',
    magentaLight: '#E774BB',
    orangeLight: '#FCA700',
    greyLight: '#B7B9BE'
};
const $5b444d8505b9cc3c$export$7c7104a5f052cab7 = {
    standard: "var(--ds-link, #0065FF)",
    blue: "var(--ds-text-accent-blue-bolder, #172B4D)",
    red: "var(--ds-text-accent-red-bolder, #172B4D)",
    yellow: "var(--ds-text-accent-yellow-bolder, #172B4D)",
    green: "var(--ds-text-accent-green-bolder, #172B4D)",
    teal: "var(--ds-text-accent-teal-bolder, #172B4D)",
    purple: "var(--ds-text-accent-purple-bolder, #172B4D)",
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: "var(--ds-text-accent-gray-bolder, #FFFFFF)",
    blueLight: "var(--ds-text-accent-blue, #0747A6)",
    redLight: "var(--ds-text-accent-red, #42526E)",
    yellowLight: "var(--ds-text-accent-yellow, #42526E)",
    greenLight: "var(--ds-text-accent-green, #006644)",
    tealLight: "var(--ds-text-accent-teal, #42526E)",
    purpleLight: "var(--ds-text-accent-purple, #403294)",
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: "var(--ds-text-accent-gray, #42526E)"
};
const $5b444d8505b9cc3c$export$382469baad253eb7 = {
    standard: "var(--ds-link-pressed, #0065FF)",
    blue: "var(--ds-text-accent-blue, #172B4D)",
    red: "var(--ds-text-accent-red, #172B4D)",
    yellow: "var(--ds-text-accent-yellow, #172B4D)",
    green: "var(--ds-text-accent-green, #172B4D)",
    teal: "var(--ds-text-accent-teal, #172B4D)",
    purple: "var(--ds-text-accent-purple, #172B4D)",
    lime: "var(--ds-text-accent-lime, #4C6B1F)",
    magenta: "var(--ds-text-accent-magenta, #943D73)",
    orange: "var(--ds-text-accent-orange, #974F0C)",
    grey: "var(--ds-text-accent-gray, #FFFFFF)",
    blueLight: "var(--ds-text-accent-blue-bolder, #0747A6)",
    redLight: "var(--ds-text-accent-red-bolder, #42526E)",
    yellowLight: "var(--ds-text-accent-yellow-bolder, #42526E)",
    greenLight: "var(--ds-text-accent-green-bolder, #006644)",
    tealLight: "var(--ds-text-accent-teal-bolder, #42526E)",
    purpleLight: "var(--ds-text-accent-purple-bolder, #403294)",
    limeLight: "var(--ds-text-accent-lime-bolder, #37471F)",
    magentaLight: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orangeLight: "var(--ds-text-accent-orange-bolder, #5F3811)",
    greyLight: "var(--ds-text-accent-gray-bolder, #42526E)"
};
const $5b444d8505b9cc3c$export$b9d7c59a579c23c6 = {
    standard: "var(--ds-background-neutral, #F4F5F7)",
    blue: "var(--ds-background-accent-blue-subtle, #4C9AFF)",
    red: "var(--ds-background-accent-red-subtle, #FF8F73)",
    yellow: "var(--ds-background-accent-yellow-subtle, #FFC400)",
    green: "var(--ds-background-accent-green-subtle, #57D9A3)",
    teal: "var(--ds-background-accent-teal-subtle, #00C7E6)",
    purple: "var(--ds-background-accent-purple-subtle, #998DD9)",
    lime: "var(--ds-background-accent-lime-subtle, #94C748)",
    magenta: "var(--ds-background-accent-magenta-subtle, #E774BB)",
    orange: "var(--ds-background-accent-orange-subtle, #FAA53D)",
    grey: "var(--ds-background-accent-gray-subtle, #42526E)",
    blueLight: "var(--ds-background-accent-blue-subtler, #B3D4FF)",
    redLight: "var(--ds-background-accent-red-subtler, #FFBDAD)",
    yellowLight: "var(--ds-background-accent-yellow-subtler, #FFE380)",
    greenLight: "var(--ds-background-accent-green-subtler, #79F2C0)",
    tealLight: "var(--ds-background-accent-teal-subtler, #79E2F2)",
    purpleLight: "var(--ds-background-accent-purple-subtler, #C0B6F2)",
    limeLight: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    magentaLight: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    orangeLight: "var(--ds-background-accent-orange-subtler, #FFE2BD)",
    greyLight: "var(--ds-background-accent-gray-subtler, #EBECF0)"
};
const $5b444d8505b9cc3c$export$4410079763249c74 = {
    standard: "var(--ds-background-neutral-hovered, #EBECF0)",
    blue: "var(--ds-background-accent-blue-subtle-hovered, #B3D4FF)",
    red: "var(--ds-background-accent-red-subtle-hovered, #FFBDAD)",
    yellow: "var(--ds-background-accent-yellow-subtle-hovered, #FFE380)",
    green: "var(--ds-background-accent-green-subtle-hovered, #79F2C0)",
    teal: "var(--ds-background-accent-teal-subtle-hovered, #79E2F2)",
    purple: "var(--ds-background-accent-purple-subtle-hovered, #C0B6F2)",
    lime: "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    magenta: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    orange: "var(--ds-background-accent-orange-subtle-hovered, #FEC57B)",
    grey: "var(--ds-background-accent-gray-subtle-hovered, #505F79)",
    blueLight: "var(--ds-background-accent-blue-subtler-hovered, #DEEBFF)",
    redLight: "var(--ds-background-accent-red-subtler-hovered, #FFEBE6)",
    yellowLight: "var(--ds-background-accent-yellow-subtler-hovered, #FFF0B3)",
    greenLight: "var(--ds-background-accent-green-subtler-hovered, #ABF5D1)",
    tealLight: "var(--ds-background-accent-teal-subtler-hovered, #B3F5FF)",
    purpleLight: "var(--ds-background-accent-purple-subtler-hovered, #EAE6FF)",
    limeLight: "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    orangeLight: "var(--ds-background-accent-orange-subtler-hovered, #FEC57B)",
    greyLight: "var(--ds-background-accent-gray-subtler-hovered, #DFE1E6)"
};
const $5b444d8505b9cc3c$export$76be99c5e13e3566 = {
    standard: "var(--ds-background-neutral-pressed, #EBECF0)",
    blue: "var(--ds-background-accent-blue-subtle-pressed, #DEEBFF)",
    red: "var(--ds-background-accent-red-subtle-pressed, #FFEBE6)",
    yellow: "var(--ds-background-accent-yellow-subtle-pressed, #FFF0B3)",
    green: "var(--ds-background-accent-green-subtle-pressed, #ABF5D1)",
    teal: "var(--ds-background-accent-teal-subtle-pressed, #B3F5FF)",
    purple: "var(--ds-background-accent-purple-subtle-pressed, #EAE6FF)",
    grey: "var(--ds-background-accent-gray-subtle-pressed, #5E6C84)",
    lime: "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    magenta: "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    orange: "var(--ds-background-accent-orange-subtle-pressed, #FFE2BD)",
    blueLight: "var(--ds-background-accent-blue-subtler-pressed, #4C9AFF)",
    redLight: "var(--ds-background-accent-red-subtler-pressed, #FF8F73)",
    yellowLight: "var(--ds-background-accent-yellow-subtler-pressed, #FFC400)",
    greenLight: "var(--ds-background-accent-green-subtler-pressed, #57D9A3)",
    tealLight: "var(--ds-background-accent-teal-subtler-pressed, #00C7E6)",
    purpleLight: "var(--ds-background-accent-purple-subtler-pressed, #998DD9)",
    limeLight: "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    orangeLight: "var(--ds-background-accent-orange-subtler-pressed, #FAA53D)",
    greyLight: "var(--ds-background-accent-gray-subtler-pressed, #C1C7D0)"
};
const $5b444d8505b9cc3c$export$2a31dbe82788f940 = "var(--ds-border-focused, #4C9AFF)";
const $5b444d8505b9cc3c$export$1202b7eb21da7b58 = "var(--ds-background-danger, #FFEBE6)";
const $5b444d8505b9cc3c$export$62ace793ebb16bda = "var(--ds-background-danger-hovered, #FFEBE6)";
const $5b444d8505b9cc3c$export$17d206ccea111bbb = "var(--ds-text-danger, #BF2600)";
const $5b444d8505b9cc3c$export$f64c7641cbc22da7 = {
    standard: "var(--ds-text, #42526E)",
    blue: "var(--ds-text-accent-blue-bolder, #42526E)",
    red: "var(--ds-text-accent-red-bolder, #42526E)",
    yellow: "var(--ds-text-accent-yellow-bolder, #42526E)",
    green: "var(--ds-text-accent-green-bolder, #42526E)",
    teal: "var(--ds-text-accent-teal-bolder, #42526E)",
    purple: "var(--ds-text-accent-purple-bolder, #42526E)",
    lime: "var(--ds-text-accent-lime-bolder, #42526E)",
    magenta: "var(--ds-text-accent-magenta-bolder, #42526E)",
    orange: "var(--ds-text-accent-orange-bolder, #42526E)",
    grey: "var(--ds-text-accent-gray-bolder, #42526E)",
    blueLight: "var(--ds-text-accent-blue, #42526E)",
    redLight: "var(--ds-text-accent-red, #42526E)",
    yellowLight: "var(--ds-text-accent-yellow, #42526E)",
    greenLight: "var(--ds-text-accent-green, #42526E)",
    tealLight: "var(--ds-text-accent-teal, #42526E)",
    purpleLight: "var(--ds-text-accent-purple, #42526E)",
    limeLight: "var(--ds-text-accent-lime, #42526E)",
    magentaLight: "var(--ds-text-accent-magenta, #42526E)",
    orangeLight: "var(--ds-text-accent-orange, #42526E)",
    greyLight: "var(--ds-text-accent-gray, #42526E)"
};
const $5b444d8505b9cc3c$export$b03fbc2a369c563e = {
    standard: "var(--ds-text-danger, #253858)",
    standardLink: "var(--ds-text-danger, #0052CC)",
    blue: "var(--ds-text-danger, #172B4D)",
    red: "var(--ds-text-danger, #172B4D)",
    yellow: "var(--ds-text-danger, #172B4D)",
    green: "var(--ds-text-danger, #172B4D)",
    teal: "var(--ds-text-danger, #172B4D)",
    purple: "var(--ds-text-danger, #172B4D)",
    lime: "var(--ds-text-danger, #172B4D)",
    magenta: "var(--ds-text-danger, #172B4D)",
    orange: "var(--ds-text-danger, #172B4D)",
    grey: "var(--ds-text-danger, #FFFFFF)",
    blueLight: "var(--ds-text-danger, #0747A6)",
    redLight: "var(--ds-text-danger, #42526E)",
    yellowLight: "var(--ds-text-danger, #42526E)",
    greenLight: "var(--ds-text-danger, #006644)",
    tealLight: "var(--ds-text-danger, #42526E)",
    purpleLight: "var(--ds-text-danger, #403294)",
    limeLight: "var(--ds-text-danger, #403294)",
    magentaLight: "var(--ds-text-danger, #403294)",
    orangeLight: "var(--ds-text-danger, #403294)",
    greyLight: "var(--ds-text-danger, #42526E)"
};

});


parcelRegister("aXLIT", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b11e671062d0fc5$export$2e2bcd8739ae039);
/* before.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");
const $4b11e671062d0fc5$var$beforeElementStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $4b11e671062d0fc5$var$beforeElementStylesOld = null;
const $4b11e671062d0fc5$var$Before = ({ elemBefore: elemBefore })=>elemBefore ? /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_1e0c1txw _4t3i7vkz _4cvr1h6o _1bah1h6o _152tze3t" : "_2rko1l5z _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _152tze3t"
        ]),
        children: elemBefore
    }) : null;
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4b11e671062d0fc5$export$2e2bcd8739ae039 = $4b11e671062d0fc5$var$Before;

});

parcelRegister("eYXIO", function(module, exports) {

$parcel$export(module.exports, "default", () => $c46b06918fbe54e8$export$2e2bcd8739ae039);
/* content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");
// To be removed with platform-component-visual-refresh (BLU-2992)
const $c46b06918fbe54e8$var$baseStylesOld = null;
const $c46b06918fbe54e8$var$baseStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $c46b06918fbe54e8$var$linkStylesOld = null;
const $c46b06918fbe54e8$var$linkStyles = null;
const $c46b06918fbe54e8$var$hasAfterStylesOld = null;
const $c46b06918fbe54e8$var$hasAfterStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $c46b06918fbe54e8$var$hasBeforeStyles = null;
const $c46b06918fbe54e8$var$Content = ({ elemBefore: elemBefore = null, isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, linkComponent: linkComponent })=>{
    const Link = linkComponent ?? 'a';
    if (href) return /*#__PURE__*/ (0, $2OMIu.jsx)(Link, {
        href: href,
        "data-color": color,
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_11c82smr _1reo15vq _18m915vq _p12fmgvx _1bto1l2s _o5721q9c" : "_11c82smr _1reo15vq _18m915vq _p12fmgvx _y4ti1b66 _bozg1b66 _1bto1l2s _o5721q9c",
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_4bfu18uv _1hmsglyw _ajmmnqa1 _syaz1fxt _lcxv1wug _nt751r31 _49pcglyw _1hvw1o36 _9oik18uv _1bnx8stv _jf4cnqa1 _30l31fxt _1nrm18uv _c2wa8stv _1iohnqa1 _9h8h1fxt" : "_4bfu18uv _1hmsglyw _ajmmnqa1 _syazs5nr _lcxv1wug _nt751r31 _49pcglyw _1hvw1o36 _9oik18uv _1bnx8stv _jf4cnqa1 _30l3117u _1nrm18uv _c2wa8stv _1iohnqa1 _9h8h1348",
            !(0, $VSDnB.fg)('platform-component-visual-refresh') && elemBefore && "_ahbqv47k",
            isRemovable && (0, $VSDnB.fg)('platform-component-visual-refresh') && "_p12f1lit",
            isRemovable && !(0, $VSDnB.fg)('platform-component-visual-refresh') && "_p12f1lit _y4tipxbi"
        ]),
        children: text
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_11c82smr _1reo15vq _18m915vq _p12fmgvx _1bto1l2s _o5721q9c" : "_11c82smr _1reo15vq _18m915vq _p12fmgvx _y4ti1b66 _bozg1b66 _1bto1l2s _o5721q9c",
            !(0, $VSDnB.fg)('platform-component-visual-refresh') && elemBefore && "_ahbqv47k",
            isRemovable && (0, $VSDnB.fg)('platform-component-visual-refresh') && "_p12f1lit",
            isRemovable && !(0, $VSDnB.fg)('platform-component-visual-refresh') && "_p12f1lit _y4tipxbi"
        ]),
        children: text
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c46b06918fbe54e8$export$2e2bcd8739ae039 = $c46b06918fbe54e8$var$Content;

});


parcelRegister("fZK5l", function(module, exports) {

$parcel$export(module.exports, "default", () => $90d99ce7164fc949$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $90d99ce7164fc949$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    completedSprint: {
        "id": "business-list.list-view.group-item.sprint-item.completed-sprint",
        "defaultMessage": "Completed sprint"
    },
    backlog: {
        "id": "business-list.list-view.group-item.sprint-item.backlog",
        "defaultMessage": "Backlog"
    }
});

});


parcelRegister("dMoqa", function(module, exports) {

$parcel$export(module.exports, "StatusItem", () => $fa1e0dcc1a1c7374$export$a687524c95d42e5);

var $5uXOq = parcelRequire("5uXOq");

var $3u0c5 = parcelRequire("3u0c5");

var $gULOk = parcelRequire("gULOk");

var $dCm1o = parcelRequire("dCm1o");
const $fa1e0dcc1a1c7374$var$appearanceMap = {
    [(0, $gULOk.UNDEFINED)]: 'default',
    [(0, $gULOk.TODO)]: 'default',
    [(0, $gULOk.DONE)]: 'success',
    [(0, $gULOk.IN_PROGRESS)]: 'inprogress'
};
const $fa1e0dcc1a1c7374$export$cbc76b787f60c037 = (categoryId)=>categoryId != null ? $fa1e0dcc1a1c7374$var$appearanceMap[(0, $gULOk.statusCategoryForId)(categoryId)] : $fa1e0dcc1a1c7374$var$appearanceMap[0, $gULOk.UNDEFINED];
const $fa1e0dcc1a1c7374$export$a687524c95d42e5 = ({ data: data })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
        appearance: $fa1e0dcc1a1c7374$export$cbc76b787f60c037(data.status?.categoryId),
        isBold: (0, $dCm1o.isVisualRefreshEnabled)()
    }, data.status?.name);

});

parcelRegister("gC8QP", function(module, exports) {

$parcel$export(module.exports, "StoryPointsItem", () => $c90d8c76411d1744$export$93b96298887b28d0);

var $5uXOq = parcelRequire("5uXOq");

var $16T6Y = parcelRequire("16T6Y");

var $d9xxV = parcelRequire("d9xxV");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $2WW6a = parcelRequire("2WW6a");
const $c90d8c76411d1744$export$93b96298887b28d0 = ({ value: value })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $16T6Y.default), {
        testId: "business-list.ui.list-view.group-item.storypoints-item.storypoints",
        appearance: "default"
    }, typeof value === 'number' ? formatMessage((0, $2WW6a.default).storyPoints, {
        points: value
    }) : formatMessage((0, $2WW6a.default).noStoryPoints)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d9xxV.default), {
        testId: "business-list.ui.list-view.group-item.storypoints-item.storypoints",
        text: typeof value === 'number' ? formatMessage((0, $2WW6a.default).storyPoints, {
            points: value
        }) : formatMessage((0, $2WW6a.default).noStoryPoints)
    });
};

});
parcelRegister("2WW6a", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd099e29f4e03970$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $bd099e29f4e03970$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    storyPoints: {
        "id": "business-list.list-view.group-item.storypoints-item.story-points",
        "defaultMessage": "{points, plural, one {# point} other {# points}}"
    },
    noStoryPoints: {
        "id": "business-list.list-view.group-item.storypoints-item.no-story-points",
        "defaultMessage": "No points"
    }
});

});


parcelRegister("earxJ", function(module, exports) {

$parcel$export(module.exports, "Wrapper", () => $aa807fa9ae1daad0$export$e6dfd72ab29f8598);
$parcel$export(module.exports, "GroupContainer", () => $aa807fa9ae1daad0$export$dd05ea0be7e7193a);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");
const $aa807fa9ae1daad0$var$ICON_SIZE = 24;
const $aa807fa9ae1daad0$var$wrapperStyles = (0, $8CUq3.xcss)({
    paddingLeft: 'space.250'
});
const $aa807fa9ae1daad0$export$e6dfd72ab29f8598 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        xcss: $aa807fa9ae1daad0$var$wrapperStyles
    }, children);
const $aa807fa9ae1daad0$var$groupContainerStyles = (0, $8CUq3.xcss)({
    paddingLeft: 'space.500'
});
const $aa807fa9ae1daad0$export$dd05ea0be7e7193a = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        xcss: $aa807fa9ae1daad0$var$groupContainerStyles
    }, children);
const $aa807fa9ae1daad0$export$caa7a2fe02de419c = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0u2gc",
            __cmplp.className
        ])
    });
});
const $aa807fa9ae1daad0$export$b936c55164dcf1db = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1sit _1e0c1txw _1bsbu2gc _4t3i1tcg _bfhkn82g _19pku2gc _2hwx1b66 _otyru2gc _18u0pxbi",
            __cmplp.className
        ])
    });
});
const $aa807fa9ae1daad0$export$d1e723d3001badba = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y",
            __cmplp.className
        ])
    });
});
const $aa807fa9ae1daad0$export$2304bbb03949f4f1 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _1bsb68cl _bfhkn82g _19pku2gc _2hwxu2gc _otyru2gc _18u0u2gc",
            __cmplp.className
        ])
    });
});
const $aa807fa9ae1daad0$export$43a792a870d28db2 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});

});


parcelRegister("dUCV4", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d4f608e0dc3b08b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jldZL = parcelRequire("jldZL");

var $lQFjJ = parcelRequire("lQFjJ");

var $Q7Myb = parcelRequire("Q7Myb");

var $9pdbW = parcelRequire("9pdbW");

var $gzkAf = parcelRequire("gzkAf");

var $17ot5 = parcelRequire("17ot5");

var $5hI3W = parcelRequire("5hI3W");

var $4Mmyc = parcelRequire("4Mmyc");

var $17X6Y = parcelRequire("17X6Y");

var $ccsmj = parcelRequire("ccsmj");

var $70g8n = parcelRequire("70g8n");

var $dXCxS = parcelRequire("dXCxS");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $3HwlS = parcelRequire("3HwlS");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $5GqLe = parcelRequire("5GqLe");

var $73w1P = parcelRequire("73w1P");

var $aSUiK = parcelRequire("aSUiK");

var $dCm1o = parcelRequire("dCm1o");

var $4nnGr = parcelRequire("4nnGr");

var $8e3Yw = parcelRequire("8e3Yw");

var $mH57d = parcelRequire("mH57d");

var $kALEJ = parcelRequire("kALEJ");

var $9WaRX = parcelRequire("9WaRX");

var $i0CN8 = parcelRequire("i0CN8");

var $h4BPz = parcelRequire("h4BPz");

var $2ITuF = parcelRequire("2ITuF");
const $9d4f608e0dc3b08b$export$223875819fd7cf93 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { inviteButtonInteraction: inviteButtonInteraction, isShareButtonEnabled: isShareButtonEnabled, isPresenceEnabled: isPresenceEnabled, hasFilterCustomFields: hasFilterCustomFields, isSoftwareFieldsEnabled: isSoftwareFieldsEnabled } = (0, $4nnGr.useJWMListFeatures)();
    const [hideDoneItems, setHideDoneItems] = (0, $17ot5.useHideDoneItems)();
    const [{ hasExpandedAllItems: hasExpandedAllItems, hasCollapsedAllItems: hasCollapsedAllItems }, { toggleExpandAllItems: toggleExpandAllItems, collapseAllItems: collapseAllItems }] = (0, $9pdbW.useExpandCollapseAllItems)({
        view: 'list'
    });
    const [groupByFieldId] = (0, $8e3Yw.useGroupBy)();
    const isGrouping = groupByFieldId != null;
    const { showFlatList: showFlatList } = (0, $mH57d.useHierarchyConfig)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { hiddenQuickFilters: hiddenQuickFilters, allowedAliasFieldId: allowedAliasFieldId } = (0, $h4BPz.useFilterProps)();
    const projectType = (0, $3HwlS.getWillShowNav4)() && isSoftwareFieldsEnabled ? 'software' : 'business';
    const hasFeedbackButton = (0, $dCm1o.isVisualRefreshEnabled)() ? false : projectType === 'software';
    const shareButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ccsmj.JWMShareButton), {
        shareTitle: (0, $i0CN8.default).shareTitle,
        integrationType: (0, $5GqLe.integrationTypes).LIST,
        shareContentType: "list"
    });
    const handleExpandCollapseAllItems = (0, $5uXOq.useCallback)((operation)=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'expandCollapseAll', {
            operation: operation
        });
        if (operation === 'collapse') collapseAllItems();
        else if (operation === 'expand') toggleExpandAllItems();
    }, [
        collapseAllItems,
        createAnalyticsEvent,
        toggleExpandAllItems
    ]);
    const searchBarLabelId = 'header-actions-search-field-label';
    const searchBar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jldZL.default), {
        id: searchBarLabelId
    }, formatMessage((0, $i0CN8.default).searchLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Mmyc.SimpleSearchField), {
        placeholder: (0, $i0CN8.default).simpleSearch,
        view: "list",
        describedbyId: searchBarLabelId
    }));
    const addPeopleWithPresence = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $17X6Y.default), {
        view: "list",
        isPresenceEnabledInContext: isPresenceEnabled,
        isOpenNewTabOnClick: inviteButtonInteraction === 'openNewTab',
        allowCustomFields: hasFilterCustomFields,
        allowedAliasFieldId: allowedAliasFieldId,
        hasInviteButton: !(0, $dCm1o.isVisualRefreshEnabled)()
    });
    const shareActionButton = isShareButtonEnabled && shareButton;
    const allowedFieldTypes = (0, $5uXOq.useMemo)(()=>isSoftwareFieldsEnabled ? new Set([
            ...(0, $gzkAf.BUSINESS_FIELD_TYPES),
            ...(0, $gzkAf.SOFTWARE_FIELD_TYPES)
        ]) : undefined, [
        isSoftwareFieldsEnabled
    ]);
    const filters = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $73w1P.FilterDropdownListNudgeAsync), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5hI3W.Filters), {
        view: "list",
        allowedFieldTypes: allowedFieldTypes,
        allowCustomFields: hasFilterCustomFields,
        allowedAliasFieldId: allowedAliasFieldId,
        hiddenQuickFilters: hiddenQuickFilters
    }));
    const groupByDropdown = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kALEJ.default), null);
    const fieldStatistics = (0, $6s1PB.expValEquals)('helios_list_view_experiment_m2', 'cohort', 'variation') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9WaRX.default), null) : null;
    const visualRefreshEnabled = (0, $dCm1o.isVisualRefreshEnabled)();
    const settingsMenu = visualRefreshEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dXCxS.default), {
        hideDoneItems: Boolean(hideDoneItems),
        onChangeHideDoneItems: setHideDoneItems,
        onExpandCollapseAllItems: handleExpandCollapseAllItems,
        isExpandCollapseButtonEnabled: !showFlatList || isGrouping,
        hasExpandedAllItems: hasExpandedAllItems,
        hasCollapsedAllItems: hasCollapsedAllItems
    });
    const moreMenuOld = visualRefreshEnabled && hasFeedbackButton || !visualRefreshEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aSUiK.MoreDropdownListNudgeAsync), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70g8n.default), {
        hideDoneItems: Boolean(hideDoneItems),
        onChangeHideDoneItems: setHideDoneItems,
        onExpandCollapseAllItems: handleExpandCollapseAllItems,
        isExpandCollapseButtonEnabled: !showFlatList || isGrouping,
        hasExpandedAllItems: hasExpandedAllItems,
        hasCollapsedAllItems: hasCollapsedAllItems,
        hasFeedbackButton: hasFeedbackButton,
        projectType: projectType,
        hideItemsMenuOptions: visualRefreshEnabled
    })) : null;
    const showMenu = (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh-list-more-menu');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lQFjJ.ActionsWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lQFjJ.LeftActionsWrapper), null, searchBar, addPeopleWithPresence, (0, $dCm1o.isVisualRefreshEnabled)() && filters), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lQFjJ.RightActionsWrapper), null, !(0, $dCm1o.isVisualRefreshEnabled)() && !(0, $3HwlS.getWillShowNav4)() && shareActionButton, !(0, $dCm1o.isVisualRefreshEnabled)() && filters, groupByDropdown, (!(0, $dCm1o.isVisualRefreshEnabled)() || (0, $dCm1o.isVisualRefreshEnabled)() && !(0, $4R6GH.fg)('visual-refresh-list-more-menu')) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Q7Myb.FormatButton), null), (!(0, $dCm1o.isVisualRefreshEnabled)() || (0, $dCm1o.isVisualRefreshEnabled)() && !(0, $4R6GH.fg)('visual-refresh-list-more-menu')) && fieldStatistics, settingsMenu, (!(0, $dCm1o.isVisualRefreshEnabled)() || (0, $dCm1o.isVisualRefreshEnabled)() && !(0, $4R6GH.fg)('visual-refresh-list-more-menu')) && moreMenuOld, showMenu && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2ITuF.ListMoreMenu), null)));
};
var $9d4f608e0dc3b08b$export$2e2bcd8739ae039 = $9d4f608e0dc3b08b$export$223875819fd7cf93;

});
parcelRegister("lQFjJ", function(module, exports) {

$parcel$export(module.exports, "ActionsWrapper", () => $31ed5059f3fb9550$export$c8223871eecc8f3a);
$parcel$export(module.exports, "ActionsWrapperStyled", () => $31ed5059f3fb9550$export$ac9cdc71f29d2899);
$parcel$export(module.exports, "LeftActionsWrapper", () => $31ed5059f3fb9550$export$42cb1c7ab389bf4d);
$parcel$export(module.exports, "RightActionsWrapper", () => $31ed5059f3fb9550$export$4aa2cd250ec24dcc);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $dCm1o = parcelRequire("dCm1o");

var $7XYc4 = parcelRequire("7XYc4");

var $g3TqM = parcelRequire("g3TqM");

var $lmBAt = parcelRequire("lmBAt");

var $4R6GH = parcelRequire("4R6GH");

var $bUSNl = parcelRequire("bUSNl");
const $31ed5059f3fb9550$export$c8223871eecc8f3a = ({ children: children, testId: testId })=>{
    const [{ content: content }] = (0, $bUSNl.useSidebar)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($31ed5059f3fb9550$export$ac9cdc71f29d2899, {
        sidebarOpen: !!content,
        "data-testid": testId,
        visualRefresh: (0, $dCm1o.isVisualRefreshEnabled)()
    }, children);
};
const $31ed5059f3fb9550$var$actionsWrapperStyles = {
    root: "_1e0c1txw _ca0qutpp _u5f31ejb _n3tdutpp _19bv1ejb _19pkidpf _2hwx10v4 _otyrpxbi _18u010v4 _bfhk1iew _kqswh2mm _1kt9f705 _1cs8stnw _kfgt1osq _1mp41osq _m9csad7r _1aukidpf _qnecidpf",
    increaseVerticalPadding: "_ca0qv47k _n3tdv47k",
    noRightMargin: "_2hwxidpf",
    noBottomMargin: "_otyridpf"
};
const $31ed5059f3fb9550$var$actionsWrapperInnerStyles = {
    root: "_zulpu2gc _16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _1tke1ylp _4cvr1h6o _1n261g80 _kqswh2mm"
};
const $31ed5059f3fb9550$export$3ca8f6d44a62ab0 = ({ sidebarOpen: sidebarOpen, hasBottomSpacing: hasBottomSpacing = true, visualRefresh: visualRefresh, children: children })=>{
    const Wrapper = (0, $lmBAt.getIsSoftwareThemingM2Enabled)() ? (0, $g3TqM.ContrastThemeWrapper) : (0, $5uXOq.Fragment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $31ed5059f3fb9550$var$actionsWrapperStyles.root,
            visualRefresh && $31ed5059f3fb9550$var$actionsWrapperStyles.increaseVerticalPadding,
            !visualRefresh && sidebarOpen && $31ed5059f3fb9550$var$actionsWrapperStyles.noRightMargin,
            !hasBottomSpacing && $31ed5059f3fb9550$var$actionsWrapperStyles.noBottomMargin
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $31ed5059f3fb9550$var$actionsWrapperInnerStyles.root
        ])
    }, children)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $31ed5059f3fb9550$var$CenterAlignedWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $31ed5059f3fb9550$var$ActionsWrapperStyledOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $31ed5059f3fb9550$var$CenterAlignedWrapper, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1w54sxz": (0, $lD23V.default)((()=>{
                if (__cmplp.visualRefresh) return `0 ${"var(--ds-space-negative-300, -24px)"} ${__cmplp.hasBottomSpacing ?? true ? "var(--ds-space-200, 16px)" : 0} ${"var(--ds-space-negative-300, -24px)"}`;
                return `0 ${__cmplp.sidebarOpen ? 0 : "var(--ds-space-negative-300, -24px)"} ${__cmplp.hasBottomSpacing ?? true ? "var(--ds-space-200, 16px)" : 0} ${"var(--ds-space-negative-300, -24px)"}`;
            })())
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18s8c1cy _1tke1ylp _1n261g80 _bfhk1iew _18k9ad7r",
            __cmplp.visualRefresh ? "_1yt41big" : "_1yt46hdp",
            __cmplp.className
        ])
    });
});
const $31ed5059f3fb9550$export$42cb1c7ab389bf4d = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $31ed5059f3fb9550$var$CenterAlignedWrapper, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
});
const $31ed5059f3fb9550$export$4aa2cd250ec24dcc = $31ed5059f3fb9550$var$CenterAlignedWrapper;
const $31ed5059f3fb9550$export$ac9cdc71f29d2899 = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('bugfix_stacking_context_of_navigation'), $31ed5059f3fb9550$export$3ca8f6d44a62ab0, $31ed5059f3fb9550$var$ActionsWrapperStyledOld);

});
parcelRegister("g3TqM", function(module, exports) {

$parcel$export(module.exports, "ContrastThemeWrapper", () => $7d5fccb6e2bd27bd$export$83167134ef4aca8c);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");


var $a2e2Q = parcelRequire("a2e2Q");
const $7d5fccb6e2bd27bd$export$83167134ef4aca8c = ({ children: children })=>{
    const { isSoftwareProject: isSoftwareProject } = (0, $a2e2Q.useSoftwareProjectTheming)();
    if (isSoftwareProject) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $7d5fccb6e2bd27bd$var$overrideStyles
    }, children);
    return children;
};
const $7d5fccb6e2bd27bd$var$overrideStyles = (0, $8CUq3.xcss)({
    // @ts-expect-error Object literal may only specify known properties, and ''--ds-background-brand-bold'' does not exist in type 'SafeCSSObject'.ts(2353)
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--project-color-text': `var(${(0, $5b25b2eb4e8be764$export$7748fdcd335afdc0)}, ${"var(--ds-text, #172B4D)"})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--project-color-text-subtle': `var(${(0, $5b25b2eb4e8be764$export$fac615ceaa871e35)}, ${"var(--ds-text-subtle, #44546F)"})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    '--project-color-border': `var(${(0, $5b25b2eb4e8be764$export$4cd72d361867c565)}, ${"var(--ds-border, #091E4224)"})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    '--project-background-selected': `var(${(0, $5b25b2eb4e8be764$export$6377a47d5e33fe0c)}, ${"var(--ds-background-selected, #E9F2FF)"})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    '--project-color-border-selected': `var(${(0, $5b25b2eb4e8be764$export$e2e8fadb946a45d2)}, ${"var(--ds-border-selected, #0C66E4)"})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    '--project-color-text-selected': `var(${(0, $5b25b2eb4e8be764$export$7d1315b9160d905c)}, ${"var(--ds-text-selected, #0C66E4)"})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    '--project-text-accent-selected': `var(${(0, $5b25b2eb4e8be764$export$b7b95e9772d9313)}, ${"var(--ds-text-selected, #0C66E4)"})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    '--project-color-background-input': `var(${(0, $5b25b2eb4e8be764$export$6c9f7212e806df4b)}, ${"var(--ds-background-input, #FFFFFF)"})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    '--project-color-background-brand-bold': `var(${(0, $5b25b2eb4e8be764$export$7156de003aaa81f0)}, ${"var(--ds-background-brand-bold, #0C66E4)"})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    '--project-color-text-inverse': `var(${(0, $5b25b2eb4e8be764$export$8993323021b69878)}, ${"var(--ds-text-inverse, #FFFFFF)"})`
});

});
const $5b25b2eb4e8be764$export$d1b9ea3245b6a5de = 3;
const $5b25b2eb4e8be764$export$d07bba395c9390f1 = 32;
const $5b25b2eb4e8be764$export$29911ec08ab2ca2d = 5;
const $5b25b2eb4e8be764$export$b61e6f89a9db76de = 4;
const $5b25b2eb4e8be764$export$7fd2e391116c6ef5 = 9;
const $5b25b2eb4e8be764$export$e1633e494d305bfb = 'MORE';
const $5b25b2eb4e8be764$export$1cfe9795423425c = '--horizontal-navigation-color-background-neutral-hovered';
const $5b25b2eb4e8be764$export$539c074adec2188a = '--horizontal-navigation-color-link';
const $5b25b2eb4e8be764$export$6f76912df5477959 = '--horizontal-navigation-color-link-pressed';
const $5b25b2eb4e8be764$export$fac615ceaa871e35 = '--horizontal-navigation-color-text-subtle';
const $5b25b2eb4e8be764$export$7748fdcd335afdc0 = '--horizontal-navigation-color-text';
const $5b25b2eb4e8be764$export$88e550ed188132a7 = '--horizontal-navigation-color-elevation-surface';
const $5b25b2eb4e8be764$export$e2e8fadb946a45d2 = '--horizontal-navigation-color-border-selected';
const $5b25b2eb4e8be764$export$4cd72d361867c565 = '--horizontal-navigation-color-border';
const $5b25b2eb4e8be764$export$be4d7e23cb48401e = '--horizontal-navigation-color-background-neutral';
const $5b25b2eb4e8be764$export$8dd437f6d09d567 = '--horizontal-navigation-color-background-neutral-selected';
const $5b25b2eb4e8be764$export$cf26c31143daa350 = '--hn-yjlbv';
const $5b25b2eb4e8be764$export$6377a47d5e33fe0c = '--horizontal-navigation-background-selected';
const $5b25b2eb4e8be764$export$7d1315b9160d905c = '--horizontal-navigation-color-text-selected';
const $5b25b2eb4e8be764$export$b7b95e9772d9313 = '--horizontal-navigation-text-accent-selected';
const $5b25b2eb4e8be764$export$6c9f7212e806df4b = '--horizontal-navigation-color-background-input';
const $5b25b2eb4e8be764$export$7156de003aaa81f0 = '--horizontal-navigation-color-background-brand-bold';
const $5b25b2eb4e8be764$export$8993323021b69878 = '--horizontal-navigation-color-text-inverse';



parcelRegister("Q7Myb", function(module, exports) {

$parcel$export(module.exports, "FormatButton", () => $0c73312955acd57c$export$4ce756b69a643bb2);

var $5uXOq = parcelRequire("5uXOq");

var $ciYaM = parcelRequire("ciYaM");

var $dmnFy = parcelRequire("dmnFy");

var $imZsD = parcelRequire("imZsD");
var $5Fk4Z = parcelRequire("5Fk4Z");

var $3bDjY = parcelRequire("3bDjY");

var $daQYX = parcelRequire("daQYX");

var $cm8b5 = parcelRequire("cm8b5");

var $47gW9 = parcelRequire("47gW9");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $koVbs = parcelRequire("koVbs");

var $7mPT9 = parcelRequire("7mPT9");

var $22OQR = parcelRequire("22OQR");

var $koeKL = parcelRequire("koeKL");

var $dCm1o = parcelRequire("dCm1o");

var $8iVnX = parcelRequire("8iVnX");

var $hug5L = parcelRequire("hug5L");

var $eTGH6 = parcelRequire("eTGH6");

var $7HvuF = parcelRequire("7HvuF");

var $dkq9p = parcelRequire("dkq9p");

var $9Unx5 = parcelRequire("9Unx5");

var $hgUKb = parcelRequire("hgUKb");
const $0c73312955acd57c$export$4ce756b69a643bb2 = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const projectData = (0, $daQYX.useProject)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [hydrateJql] = (0, $hug5L.useFormatRulesSerialisedJql)();
    const formatButtonRef = (0, $5uXOq.useRef)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $dkq9p.formatRulesEntryPoint), {
        projectKey: projectData.key,
        cloudId: cloudId,
        hydrateJql: hydrateJql
    });
    const buttonTriggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions);
    const errorFallback = (0, $5uXOq.useCallback)(({ error: error })=>// TODO: show error flag
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cm8b5.ExperienceFailed), {
            experience: (0, $8iVnX.LIST_FORMAT_RULE_EXPERIENCE),
            error: error
        }), []);
    const { onClickFormatButton: onClickFormatButton, isFormatRulesSidebarOpen: isFormatRulesSidebarOpen } = (0, $eTGH6.useFormatRulesSidebar)({
        SidebarComponent: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
                entryPointReferenceSubject: entryPointReferenceSubject,
                id: "jwm.business.format.rules",
                packageName: "jiraBusinessFormatRules",
                runtimeProps: props,
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9Unx5.SidebarFallback), null),
                errorFallback: errorFallback
            }),
        projectId: String(projectData.id),
        formatButtonRef: formatButtonRef
    });
    const themedButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $22OQR.ThemedButton), {
        onClick: ()=>onClickFormatButton({
                showOnboarding: false
            }),
        iconBefore: (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ciYaM))), {
            label: "",
            spacing: "spacious",
            color: "currentColor"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dmnFy))), {
            label: "",
            LEGACY_size: "medium",
            spacing: "spacious"
        }),
        isSelected: isFormatRulesSidebarOpen,
        "aria-label": (0, $dCm1o.isVisualRefreshEnabled)() ? formatMessage((0, $7HvuF.default).formatRulesTooltip) : undefined,
        appearance: (0, $dCm1o.isVisualRefreshEnabled)() ? 'default' : 'subtle',
        ref: (0, $7mPT9.mergeRefs)(buttonTriggerRef, formatButtonRef),
        testId: "business-conditional-formatting-sidebar.ui.format-rules-sidebar.themed-button",
        title: (0, $dCm1o.isVisualRefreshEnabled)() ? undefined : formatMessage((0, $7HvuF.default).formatRulesTooltip)
    }, !(0, $dCm1o.isVisualRefreshEnabled)() && formatMessage((0, $7HvuF.default).format));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: "format-rule-button"
    }, (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $7HvuF.default).formatRulesTooltip)
    }, themedButton) : themedButton), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hgUKb.Onboarding), {
        ref: (0, $7mPT9.mergeRefs)(buttonTriggerRef, formatButtonRef),
        onClickFormatButton: onClickFormatButton
    }));
};

});
parcelRegister("8iVnX", function(module, exports) {

$parcel$export(module.exports, "MAX_RULES_FETCHED", () => $1cd48cac4950abc6$export$6e645d821ccb2e78);
$parcel$export(module.exports, "DATE_VALUES", () => $1cd48cac4950abc6$export$42247ee7424a5edb);
$parcel$export(module.exports, "DATE_PICKER_OPERATORS", () => $1cd48cac4950abc6$export$5a5ebc5948b83a8a);
$parcel$export(module.exports, "PACKAGE_NAME", () => $1cd48cac4950abc6$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $1cd48cac4950abc6$export$d57b6b390e78d90f);
$parcel$export(module.exports, "CREATE_FORMAT_RULE_EXPERIENCE", () => $1cd48cac4950abc6$export$fa13d8a70748751a);
$parcel$export(module.exports, "LIST_FORMAT_RULE_EXPERIENCE", () => $1cd48cac4950abc6$export$a81756a20f687e60);
$parcel$export(module.exports, "DELETE_FORMAT_RULE_EXPERIENCE", () => $1cd48cac4950abc6$export$aec4d62b875e16db);
$parcel$export(module.exports, "UPDATE_FORMAT_RULE_EXPERIENCE", () => $1cd48cac4950abc6$export$3f6ab32e23b3d013);
$parcel$export(module.exports, "SORT_FORMAT_RULE_EXPERIENCE", () => $1cd48cac4950abc6$export$2f9cc81b0092d33b);
$parcel$export(module.exports, "HELP_ARTICLE", () => $1cd48cac4950abc6$export$5b1d06b602bd68c5);

var $42ioY = parcelRequire("42ioY");
const $1cd48cac4950abc6$export$6e645d821ccb2e78 = 20;
const $1cd48cac4950abc6$export$42247ee7424a5edb = (0, $42ioY.DATE_VALUE_OPERATORS);
const $1cd48cac4950abc6$export$5a5ebc5948b83a8a = [
    (0, $42ioY.DATE_VALUE_OPERATORS).EXACT_DATE
];
const $1cd48cac4950abc6$export$b8b9d90f9e5bd72b = 'jiraBusinessFormatRule';
const $1cd48cac4950abc6$export$d57b6b390e78d90f = 'keystone';
const $1cd48cac4950abc6$export$fa13d8a70748751a = {
    experience: 'createFormatRule',
    packageName: $1cd48cac4950abc6$export$b8b9d90f9e5bd72b,
    teamName: $1cd48cac4950abc6$export$d57b6b390e78d90f
};
const $1cd48cac4950abc6$export$a81756a20f687e60 = {
    experience: 'listFormatRule',
    packageName: $1cd48cac4950abc6$export$b8b9d90f9e5bd72b,
    teamName: $1cd48cac4950abc6$export$d57b6b390e78d90f
};
const $1cd48cac4950abc6$export$aec4d62b875e16db = {
    experience: 'deleteFormatRule',
    packageName: $1cd48cac4950abc6$export$b8b9d90f9e5bd72b,
    teamName: $1cd48cac4950abc6$export$d57b6b390e78d90f
};
const $1cd48cac4950abc6$export$3f6ab32e23b3d013 = {
    experience: 'updateFormatRule',
    packageName: $1cd48cac4950abc6$export$b8b9d90f9e5bd72b,
    teamName: $1cd48cac4950abc6$export$d57b6b390e78d90f
};
const $1cd48cac4950abc6$export$2f9cc81b0092d33b = {
    experience: 'sortFormatRule',
    packageName: $1cd48cac4950abc6$export$b8b9d90f9e5bd72b,
    teamName: $1cd48cac4950abc6$export$d57b6b390e78d90f
};
const $1cd48cac4950abc6$export$5b1d06b602bd68c5 = {
    helpArticleId: '7afzXgtL4UauMCJZ3IxTTH',
    href: 'https://support.atlassian.com/jira-software-cloud/docs/what-are-format-rules/'
};

});
parcelRegister("42ioY", function(module, exports) {

$parcel$export(module.exports, "DATE_VALUE_OPERATORS", () => $d9db4359c930d400$export$6a2fdc772d1c71fb);
const $d9db4359c930d400$export$6a2fdc772d1c71fb = {
    EXACT_DATE: 'EXACT_DATE',
    TODAY: 'TODAY',
    TOMORROW: 'TOMORROW',
    YESTERDAY: 'YESTERDAY',
    THIS_WEEK: 'THIS_WEEK',
    LAST_WEEK: 'LAST_WEEK',
    NEXT_WEEK: 'NEXT_WEEK',
    THIS_QUARTER: 'THIS_QUARTER',
    LAST_QUARTER: 'LAST_QUARTER',
    NEXT_QUARTER: 'NEXT_QUARTER',
    THIS_YEAR: 'THIS_YEAR',
    LAST_YEAR: 'LAST_YEAR',
    NEXT_YEAR: 'NEXT_YEAR'
};

});


parcelRegister("eTGH6", function(module, exports) {

$parcel$export(module.exports, "useFormatRulesSidebar", () => $36f7a848a98dec9a$export$5bcab55a2e93dc2d);

var $5uXOq = parcelRequire("5uXOq");

var $bUSNl = parcelRequire("bUSNl");

var $hE5wF = parcelRequire("hE5wF");

var $cm8b5 = parcelRequire("cm8b5");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $ieDtd = parcelRequire("ieDtd");

var $8iVnX = parcelRequire("8iVnX");
const $36f7a848a98dec9a$var$FORMAT_SIDEBAR_SIDEBAR_CONTENT_KEY = 'formatRulesSidebar';
const $36f7a848a98dec9a$export$5bcab55a2e93dc2d = ({ projectId: projectId, SidebarComponent: SidebarComponent, formatButtonRef: formatButtonRef })=>{
    const [, setSelectedIssueKey] = (0, $ieDtd.useQueryParam)((0, $hE5wF.SELECTED_ISSUE_PARAM));
    const [{ content: content }, { setSidebarContent: setSidebarContent }] = (0, $bUSNl.useSidebar)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const isFormatRulesSidebarOpen = (0, $5uXOq.useMemo)(()=>content?.key === $36f7a848a98dec9a$var$FORMAT_SIDEBAR_SIDEBAR_CONTENT_KEY, [
        content
    ]);
    const startExperience = (0, $cm8b5.useExperienceStart)((0, $8iVnX.LIST_FORMAT_RULE_EXPERIENCE));
    const onCloseSidebar = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'formatRulesCloseButton');
        setSidebarContent(null);
        formatButtonRef?.current?.focus();
    }, [
        createAnalyticsEvent,
        formatButtonRef,
        setSidebarContent
    ]);
    const onClickFormatButton = (0, $5uXOq.useCallback)(({ showOnboarding: showOnboarding })=>{
        if (isFormatRulesSidebarOpen) onCloseSidebar();
        else {
            setSelectedIssueKey(undefined);
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'formatRulesSidebarButton');
            startExperience();
            setSidebarContent(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SidebarComponent, {
                key: $36f7a848a98dec9a$var$FORMAT_SIDEBAR_SIDEBAR_CONTENT_KEY,
                onCloseSidebar: onCloseSidebar,
                projectId: projectId,
                showOnboarding: showOnboarding
            }));
        }
    }, [
        isFormatRulesSidebarOpen,
        onCloseSidebar,
        setSelectedIssueKey,
        createAnalyticsEvent,
        startExperience,
        setSidebarContent,
        SidebarComponent,
        projectId
    ]);
    return {
        onClickFormatButton: onClickFormatButton,
        isFormatRulesSidebarOpen: isFormatRulesSidebarOpen
    };
};

});

parcelRegister("7HvuF", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ca7955f4716097e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0ca7955f4716097e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    format: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.format",
        "defaultMessage": "Format"
    },
    formatRulesTooltip: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.format-rules-tooltip",
        "defaultMessage": "Format rules"
    }
});

});

parcelRegister("dkq9p", function(module, exports) {

$parcel$export(module.exports, "formatRulesEntryPoint", () => $921d0df9c4a9863b$export$a812fb5060f92ae9);

var $576dU = parcelRequire("576dU");

var $lO1QX = parcelRequire("lO1QX");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $921d0df9c4a9863b$export$a812fb5060f92ae9 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("fDJZp")), {
        moduleId: "b6770cbd"
    }),
    getPreloadProps: ({ projectKey: projectKey, cloudId: cloudId, hydrateJql: hydrateJql })=>({
            queries: {
                listViewFormattingRulesQuery: {
                    parameters: (0, $lO1QX.default),
                    variables: {
                        projectKey: projectKey,
                        cloudId: cloudId,
                        first: 20
                    },
                    options: {
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        fetchPolicy: 'store-or-network'
                    }
                },
                listViewFormattingRulesHydrateJqlQuery: {
                    parameters: (0, $576dU.default),
                    variables: {
                        cloudId: cloudId,
                        jql: hydrateJql
                    },
                    options: {
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});

});
parcelRegister("576dU", function(module, exports) {

$parcel$export(module.exports, "default", () => $29b8f0a12b567a40$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<42f4819615778ccd3ce9e0b392115e74>>
 * @relayHash 2c022a9f710f4bdf011c2cdafd02ce28
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0da32c6286953e253b4c87ac4dae3561c26afba277b98f8c19bb3efa09e88e83
const $29b8f0a12b567a40$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jql"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v3 = [
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "jql"
        }
    ], v4 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v7 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = [
        v8 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "list_hydrateJql_Query",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2 /*: any*/ ,
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "args": v3 /*: any*/ ,
                                            "kind": "LinkedField",
                                            "name": "hydrateJqlQuery",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "fieldValueData_businessConditionalFormattingSidebar"
                                                        }
                                                    ],
                                                    "type": "JiraJqlHydratedQuery"
                                                },
                                                v4 /*: any*/ 
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "jira.jqlBuilder.hydrateJqlQuery"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "list_hydrateJql_Query",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v3 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "hydrateJqlQuery",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "fields",
                                                    "plural": true,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraJqlField",
                                                                    "kind": "LinkedField",
                                                                    "name": "field",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v6 /*: any*/ ,
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "type"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "values",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v5 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "values",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        v5 /*: any*/ ,
                                                                                        v6 /*: any*/ ,
                                                                                        v7 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "user",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v5 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "accountId"
                                                                                                        },
                                                                                                        v8 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlUserFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraPriority",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "priority",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "priorityId"
                                                                                                        },
                                                                                                        v8 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlPriorityFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraSprint",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "sprint",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "sprintId"
                                                                                                        },
                                                                                                        v8 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlSprintFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraGroup",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "group",
                                                                                                    "plural": false,
                                                                                                    "selections": v9 /*: any*/ 
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlGroupFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatus",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "status",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "statusId"
                                                                                                        },
                                                                                                        v8 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlStatusFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraProject",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "project",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "projectId"
                                                                                                        },
                                                                                                        v8 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlProjectFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueTypes",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "issueTypeId"
                                                                                                        },
                                                                                                        v8 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlIssueTypeFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraVersion",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "version",
                                                                                                    "plural": false,
                                                                                                    "selections": v9 /*: any*/ 
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlVersionFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraComponent",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "component",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "componentId"
                                                                                                        },
                                                                                                        v8 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlComponentFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "option",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "optionId"
                                                                                                        },
                                                                                                        v8 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlOptionFieldValue"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraJqlQueryHydratedValue"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlQueryHydratedField"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraJqlHydratedQuery"
                                        },
                                        v4 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0da32c6286953e253b4c87ac4dae3561c26afba277b98f8c19bb3efa09e88e83",
            "metadata": {},
            "name": "list_hydrateJql_Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$29b8f0a12b567a40$var$node.hash = "29ea070df4a573820b0818573b62d704";
var $29b8f0a12b567a40$export$2e2bcd8739ae039 = $29b8f0a12b567a40$var$node;

});

parcelRegister("lO1QX", function(module, exports) {

$parcel$export(module.exports, "default", () => $c158b5869b83a61f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1f83698e03e27f727ef1e2fe7252fc51>>
 * @relayHash 0c433cda5f667bcf4a540416173db6d2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a2dff011be60f61ee521340c2f88a86124a936945911e4b5bfb138137a0954e0
const $c158b5869b83a61f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v4 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v7 = [
        v6 /*: any*/ 
    ], v8 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "list_RuleList_Query",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v4 /*: any*/ ,
                                            "concreteType": "JiraFormattingRuleConnection",
                                            "kind": "LinkedField",
                                            "name": "conditionalFormattingRules",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraFormattingRuleEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraFormattingRule",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "expression",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v7 /*: any*/ ,
                                                                            "type": "JiraFormattingMultipleValueOperand"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v7 /*: any*/ ,
                                                                            "type": "JiraFormattingSingleValueOperand"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v7 /*: any*/ ,
                                                                            "type": "JiraFormattingNoValueOperand"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "FragmentSpread",
                                                                    "name": "ruleItem_businessConditionalFormattingSidebar"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraProjectByKey"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "list_RuleList_Query",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v4 /*: any*/ ,
                                    "concreteType": "JiraFormattingRuleConnection",
                                    "kind": "LinkedField",
                                    "name": "conditionalFormattingRules",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFormattingRuleEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraFormattingRule",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "expression",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__typename"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v6 /*: any*/ ,
                                                                        {
                                                                            "alias": "multipleValueOperator",
                                                                            "kind": "ScalarField",
                                                                            "name": "operator"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "values"
                                                                        }
                                                                    ],
                                                                    "type": "JiraFormattingMultipleValueOperand"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v6 /*: any*/ ,
                                                                        {
                                                                            "alias": "singleValueOperator",
                                                                            "kind": "ScalarField",
                                                                            "name": "operator"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "value"
                                                                        }
                                                                    ],
                                                                    "type": "JiraFormattingSingleValueOperand"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v6 /*: any*/ ,
                                                                        {
                                                                            "alias": "noValueOperator",
                                                                            "kind": "ScalarField",
                                                                            "name": "operator"
                                                                        }
                                                                    ],
                                                                    "type": "JiraFormattingNoValueOperand"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraColor",
                                                            "kind": "LinkedField",
                                                            "name": "formattingColor",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "colorKey"
                                                                },
                                                                v5 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "formattingArea"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v8 /*: any*/ 
                                    ]
                                },
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "a2dff011be60f61ee521340c2f88a86124a936945911e4b5bfb138137a0954e0",
            "metadata": {},
            "name": "list_RuleList_Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c158b5869b83a61f$var$node.hash = "bec8fc4cc19c330e28e463dc69485d6f";
var $c158b5869b83a61f$export$2e2bcd8739ae039 = $c158b5869b83a61f$var$node;

});

parcelRegister("fDJZp", function(module, exports) {

let $b62e2c16aa586012$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b62e2c16aa586012$var$load("64qrd").then(()=>parcelRequire('dMDrl'));

});


parcelRegister("9Unx5", function(module, exports) {

$parcel$export(module.exports, "ListFallback", () => $5e6ab21bf2ceafb8$export$a207fef8aae38be9);
$parcel$export(module.exports, "SidebarFallback", () => $5e6ab21bf2ceafb8$export$289c886cdbc6d1e3);

var $5uXOq = parcelRequire("5uXOq");

var $iwwXK = parcelRequire("iwwXK");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $5e6ab21bf2ceafb8$export$a207fef8aae38be9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), {
        hasIcon: true,
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), {
        hasIcon: true,
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), {
        hasIcon: true,
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), {
        hasIcon: true,
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), {
        hasIcon: true,
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), {
        isShimmering: true,
        width: "120px"
    }));
const $5e6ab21bf2ceafb8$export$289c886cdbc6d1e3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $5e6ab21bf2ceafb8$var$containerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), {
        isShimmering: true,
        width: "120px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), {
        isShimmering: true,
        width: "100%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5e6ab21bf2ceafb8$export$a207fef8aae38be9, null)));
const $5e6ab21bf2ceafb8$var$containerStyle = (0, $8CUq3.xcss)({
    padding: 'space.250'
});

});

parcelRegister("hgUKb", function(module, exports) {

$parcel$export(module.exports, "Onboarding", () => $653c3dd67cf5534e$export$70238cd3868b67c9);
$parcel$export(module.exports, "SidebarOnboarding", () => $653c3dd67cf5534e$export$d4bff02b549bd7de);

var $5uXOq = parcelRequire("5uXOq");

var $kbqIt = parcelRequire("kbqIt");

var $1QiBP = parcelRequire("1QiBP");

var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $ioD1B = parcelRequire("ioD1B");

var $eGLgs = parcelRequire("eGLgs");

var $koVbs = parcelRequire("koVbs");

var $ehdJY = parcelRequire("ehdJY");

var $koeKL = parcelRequire("koeKL");

var $2tT7R = parcelRequire("2tT7R");

var $03v3Q = parcelRequire("03v3Q");

var $2ccxh = parcelRequire("2ccxh");
const $653c3dd67cf5534e$export$53e766134521dfd3 = 'STG-EXT-1441';
const $653c3dd67cf5534e$export$5cbe8adda16e7b01 = 'jira-list-view-format-rules-onboarding';
const $653c3dd67cf5534e$var$ENV_STAGING = 'staging';
const $653c3dd67cf5534e$var$STARGATE_URL = '/gateway/api';
const $653c3dd67cf5534e$export$70238cd3868b67c9 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ onClickFormatButton: onClickFormatButton }, ref)=>{
    const ONBOARDING_ENGAGEMENT_ID = (0, $2tT7R.useEnvironment)() === $653c3dd67cf5534e$var$ENV_STAGING ? $653c3dd67cf5534e$export$53e766134521dfd3 : $653c3dd67cf5534e$export$5cbe8adda16e7b01;
    const cloudId = (0, $koeKL.useCloudId)();
    /**
   * Onboarding Experience is loaded manually on page load via EP's CoordinationClient class
   * Once loaded, if the message is active for this particular context, only then the FORMATTING_RULES_ONBOARDING will be loaded and displayed
   */ const coordinationClient = (0, $5uXOq.useMemo)(()=>new (0, $eGLgs.CoordinationClient)(cloudId, $653c3dd67cf5534e$var$STARGATE_URL, false, '', 'engagement'), [
        cloudId
    ]);
    const [isEnrolled, stopEnrolment] = (0, $kbqIt.useCoordination)(coordinationClient, ONBOARDING_ENGAGEMENT_ID);
    const [isSpotlightActive, setIsSpotlightActive] = (0, $5uXOq.useState)(true);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    (0, $5uXOq.useEffect)(()=>{
        if (isEnrolled) stopEnrolment(false);
    }, [
        isEnrolled,
        stopEnrolment
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ioD1B.ChoreographerContextProvider), {
        isChoreographed: coordinationClient.enableChoreographer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1QiBP.default), null, isEnrolled && isSpotlightActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
        messageId: "business-conditional-formatting-sidebar.ui.format-rules-sidebar.sidebar.onboarding.jira-spotlight.format-rule-button",
        messageType: "engagement",
        image: (0, (/*@__PURE__*/$parcel$interopDefault($03v3Q))),
        actionsBeforeElement: "1/3",
        actions: [
            {
                onClick: ()=>{
                    setIsSpotlightActive(false);
                    onClickFormatButton({
                        showOnboarding: true
                    });
                },
                text: formatMessage((0, $2ccxh.default).next)
            },
            {
                appearance: 'subtle',
                onClick: ()=>setIsSpotlightActive(false),
                text: formatMessage((0, $2ccxh.default).dismiss)
            }
        ],
        dialogWidth: 320,
        heading: formatMessage((0, $2ccxh.default).onboardingHeading),
        target: "format-rule-button",
        key: "format-rule-button",
        targetRadius: 3,
        footer: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
                ref: ref,
                alignItems: "center",
                justifyContent: "space-between",
                xcss: $653c3dd67cf5534e$var$footerContainerStyle
            }, children)
    }, formatMessage((0, $2ccxh.default).onboardingDescription))));
});
const $653c3dd67cf5534e$export$d4bff02b549bd7de = ({ showOnboarding: showOnboarding })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [activeSpotlight, setActiveSpotlight] = (0, $5uXOq.useState)(null);
    const next = ()=>setActiveSpotlight((activeSpotlight || 0) + 1);
    const end = ()=>setActiveSpotlight(null);
    (0, $5uXOq.useEffect)(()=>{
        if (showOnboarding) setTimeout(()=>{
            setActiveSpotlight(0);
        }, 100);
    }, [
        showOnboarding
    ]);
    const renderActiveSpotlight = ()=>{
        const spotlights = [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
                messageId: "business-conditional-formatting-sidebar.ui.format-rules-sidebar.sidebar.onboarding.jira-spotlight.create-rule-form",
                messageType: "engagement",
                actionsBeforeElement: "2/3",
                actions: [
                    {
                        onClick: next,
                        text: 'Next'
                    },
                    {
                        appearance: 'subtle',
                        onClick: end,
                        text: formatMessage((0, $2ccxh.default).dismiss)
                    }
                ],
                dialogWidth: 280,
                target: "create-rule-form",
                key: "create-rule-form",
                targetRadius: 3
            }, formatMessage((0, $2ccxh.default).createRuleOnboarding)),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
                messageId: "business-conditional-formatting-sidebar.ui.format-rules-sidebar.sidebar.onboarding.jira-spotlight.drag-rule-form",
                messageType: "engagement",
                actionsBeforeElement: "3/3",
                actions: [
                    {
                        onClick: end,
                        text: formatMessage((0, $2ccxh.default).done)
                    }
                ],
                dialogWidth: 280,
                target: "drag-rule-form",
                key: "drag-rule-form",
                targetRadius: 3
            }, formatMessage((0, $2ccxh.default).rulesOrderOnboarding))
        ];
        if (activeSpotlight === null) return null;
        return spotlights[activeSpotlight];
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1QiBP.default), null, renderActiveSpotlight());
};
const $653c3dd67cf5534e$var$footerContainerStyle = (0, $8CUq3.xcss)({
    paddingTop: 'space.050'
});

});
parcelRegister("03v3Q", function(module, exports) {
module.exports = new URL("onboarding.d274e357.svg", import.meta.url).toString();

});

parcelRegister("2ccxh", function(module, exports) {

$parcel$export(module.exports, "default", () => $6516f853326487b4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6516f853326487b4$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    onboardingHeading: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.onboarding-heading",
        "defaultMessage": "Highlight important work with color"
    },
    onboardingDescription: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.onboarding-description",
        "defaultMessage": "Create a format rule to quickly view work that needs attention. Only you\u2019ll be able to view the rules you create or edit."
    },
    next: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.next",
        "defaultMessage": "Next"
    },
    createRuleOnboarding: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.create-rule-onboarding",
        "defaultMessage": "For example, you could create a rule that formats rows red when the due date is before today."
    },
    rulesOrderOnboarding: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.rules-order-onboarding",
        "defaultMessage": "If you have multiple rules that apply to the same cell, the rule at the top takes precedence. Drag rules up or down to reorder them."
    },
    done: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.done",
        "defaultMessage": "Done"
    },
    dismiss: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.dismiss",
        "defaultMessage": "Dismiss"
    }
});

});



parcelRegister("5hI3W", function(module, exports) {

$parcel$export(module.exports, "Filters", () => $afeed5d78bb3bf98$export$92a576f896a9bf72);

var $5uXOq = parcelRequire("5uXOq");

var $7mPT9 = parcelRequire("7mPT9");

var $jgJNO = parcelRequire("jgJNO");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $l8ruj = parcelRequire("l8ruj");

var $4R6GH = parcelRequire("4R6GH");

var $lM9c1 = parcelRequire("lM9c1");

var $1TU9r = parcelRequire("1TU9r");

var $gxGcZ = parcelRequire("gxGcZ");

var $dpQnO = parcelRequire("dpQnO");

var $ab4a1 = parcelRequire("ab4a1");

var $6xNkv = parcelRequire("6xNkv");
const $afeed5d78bb3bf98$var$hiddenQuickFiltersDefault = [
    'ACTIVE_SPRINTS'
];
const $afeed5d78bb3bf98$export$92a576f896a9bf72 = /*#__PURE__*/ (0, $5uXOq.memo)(({ view: view, allowedFieldTypes: inputAllowedFieldTypes, allowedAliasFieldId: allowedAliasFieldId, hiddenQuickFilters: hiddenQuickFilters = $afeed5d78bb3bf98$var$hiddenQuickFiltersDefault, allowCustomFields: allowCustomFields, allowSavedFilters: allowSavedFilters = true, handleHasFiltersApplied: handleHasFiltersApplied, appearance: appearance })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const allowedFieldTypes = (0, $gxGcZ.useAllowedFieldTypes)(inputAllowedFieldTypes);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const triggerRef = (0, $5uXOq.useRef)(null);
    const close = (0, $5uXOq.useCallback)(()=>{
        setIsOpen(false);
        if ((0, $4R6GH.fg)('wanjel-a11y-enterprise-grade')) triggerRef.current?.focus();
    }, []);
    const toggle = (0, $5uXOq.useCallback)(()=>{
        setIsOpen((prevIsOpen)=>!prevIsOpen);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'jwmFilterButton clicked');
    }, [
        createAnalyticsEvent
    ]);
    const { quickFilters: quickFilters, persistQuickFilters: setQuickFilters } = (0, $dpQnO.useQuickFilters)();
    const { filters: filters, fieldConfig: fieldConfig, customFieldsLoader: customFieldsLoader, hasFilterError: hasFilterError, setFilters: setFilters } = (0, $1TU9r.useDeserialiseJqlFiltersWithContext)({
        view: view,
        allowedFieldTypes: allowedFieldTypes,
        allowedAliasFieldId: allowedAliasFieldId,
        allowCustomFields: allowCustomFields
    });
    const count = Object.values(filters).flat().length + Object.values(quickFilters).filter((value)=>value).length;
    (0, $5uXOq.useEffect)(()=>{
        if (handleHasFiltersApplied) handleHasFiltersApplied(count);
    }, [
        count,
        handleHasFiltersApplied
    ]);
    (0, $lM9c1.useGoalsFilterAnalyticsEvent)({
        filters: filters,
        view: view
    });
    const hasFiltersApplied = count > 0 || hasFilterError;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "business-filters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isOpen,
        onClose: close,
        placement: "bottom-end",
        messageId: "business-filters.ui.filters.popup",
        messageType: "transactional",
        autoFocus: !(0, $4R6GH.fg)('wanjel-a11y-enterprise-grade'),
        ...(0, $4R6GH.fg)('wanjel-fix-rendertoparent-header-popup-in-board') ? {
            shouldRenderToParent: true,
            strategy: 'absolute'
        } : {},
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ab4a1.MenuContent), {
                "data-testid": "business-filters.ui.filters.menu-content",
                count: count,
                fieldConfig: fieldConfig,
                filters: filters,
                quickFilters: quickFilters,
                setQuickFilters: setQuickFilters,
                setFilters: setFilters,
                hiddenQuickFilters: hiddenQuickFilters,
                view: view,
                allowCustomFields: allowCustomFields,
                allowSavedFilters: allowSavedFilters,
                hasFilterError: hasFilterError
            })),
        trigger: ({ ref: ref, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6xNkv.Trigger), {
                ...triggerProps,
                appearance: appearance,
                count: count,
                hasFiltersApplied: hasFiltersApplied,
                isSelected: isOpen,
                onClick: toggle,
                ref: (0, $4R6GH.fg)('wanjel-a11y-enterprise-grade') ? (0, $7mPT9.mergeRefs)(triggerRef, ref) : ref
            })
    }), customFieldsLoader));
});

});
parcelRegister("lM9c1", function(module, exports) {

$parcel$export(module.exports, "useGoalsFilterAnalyticsEvent", () => $a083b46fb378eaf3$export$c9b2aef46b42c898);

var $5uXOq = parcelRequire("5uXOq");

var $5fc53 = parcelRequire("5fc53");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $8DJTW = parcelRequire("8DJTW");
const $a083b46fb378eaf3$export$c9b2aef46b42c898 = ({ filters: filters, view: view })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { data: filterFields } = (0, $8DJTW.useFilterFields)();
    const goalField = (0, $5uXOq.useMemo)(()=>filterFields.find((field)=>field.type === (0, $5fc53.GOALS_CF_TYPE)), [
        filterFields
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (goalField && filters[goalField.id]) {
            const goalsFilter = filters[goalField.id];
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'goalsFilter applied', {
                source: view,
                goalsCount: Array.isArray(goalsFilter) ? goalsFilter.length : 0
            });
        }
    }, [
        createAnalyticsEvent,
        filters,
        goalField,
        view
    ]);
};

});
parcelRegister("8DJTW", function(module, exports) {

$parcel$export(module.exports, "useFilterFields", () => $058acf7f8802e33f$export$b2d30fa5478b571a);

var $5uXOq = parcelRequire("5uXOq");

var $g4ZHz = parcelRequire("g4ZHz");
const $058acf7f8802e33f$export$b2d30fa5478b571a = ()=>{
    const { data: fields, loading: loading } = (0, $g4ZHz.useFieldsResource)();
    const data = (0, $5uXOq.useMemo)(()=>fields?.map((field)=>({
                id: field.jqlTerm,
                name: field.displayName,
                type: field.type
            })) ?? [], [
        fields
    ]);
    return {
        data: data,
        loading: loading,
        error: undefined
    };
};

});


parcelRegister("1TU9r", function(module, exports) {

$parcel$export(module.exports, "DeserialisedFiltersProvider", () => $fbaf3c30d9711dbc$export$c5640c1fbeb250b6);
$parcel$export(module.exports, "useDeserialisedFilters", () => $fbaf3c30d9711dbc$export$ac7ff3aa0620d1a7);
$parcel$export(module.exports, "useDeserialiseJqlFilters", () => $fbaf3c30d9711dbc$export$eaa578dc219a620a);
$parcel$export(module.exports, "useDeserialiseJqlFiltersWithContext", () => $fbaf3c30d9711dbc$export$87f52da20e747485);

var $5uXOq = parcelRequire("5uXOq");

var $g9ql5 = parcelRequire("g9ql5");

var $8DJTW = parcelRequire("8DJTW");

var $17ot5 = parcelRequire("17ot5");

var $l4Ejo = parcelRequire("l4Ejo");

var $dpQnO = parcelRequire("dpQnO");

var $2RV6Z = parcelRequire("2RV6Z");
const $fbaf3c30d9711dbc$var$DEFAULT_VALUE = {
    filters: {}
};
/* Context used by the board view until the filters get implemented in the backend */ const $fbaf3c30d9711dbc$var$DeserialisedFiltersContext = /*#__PURE__*/ (0, $5uXOq.createContext)($fbaf3c30d9711dbc$var$DEFAULT_VALUE);
const $fbaf3c30d9711dbc$export$c5640c1fbeb250b6 = ({ children: children })=>{
    const [filters, setFilters] = (0, $5uXOq.useState)({});
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(true);
    const value = (0, $5uXOq.useMemo)(()=>({
            filters: filters,
            setFilters: setFilters,
            isLoading: isLoading,
            setIsLoading: setIsLoading
        }), [
        filters,
        isLoading
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fbaf3c30d9711dbc$var$DeserialisedFiltersContext.Provider, {
        value: value
    }, children);
};
const $fbaf3c30d9711dbc$export$ac7ff3aa0620d1a7 = ()=>(0, $5uXOq.useContext)($fbaf3c30d9711dbc$var$DeserialisedFiltersContext);
const $fbaf3c30d9711dbc$var$EMPTY_FILTER = {};
const $fbaf3c30d9711dbc$export$eaa578dc219a620a = ({ view: view, allowedFieldTypes: allowedFieldTypes, allowedAliasFieldId: allowedAliasFieldId, allowCustomFields: allowCustomFields })=>{
    const { jql: jql, setFilter: setFilter } = (0, $l4Ejo.useFilters)();
    const { fieldConfig: fieldConfig, resolvers: resolvers, customFieldsLoader: customFieldsLoader, loading: isLoadingFieldConfig } = (0, $g9ql5.useFieldConfigWithCustomFields)({
        view: view,
        allowedFieldTypes: allowedFieldTypes,
        allowedAliasFieldId: allowedAliasFieldId,
        allowCustomFields: allowCustomFields
    });
    const { setFilters: setContextFilters, setIsLoading: setIsLoadingFilters } = $fbaf3c30d9711dbc$export$ac7ff3aa0620d1a7();
    const [filters, setFilters] = (0, $5uXOq.useState)({});
    const [error, setError] = (0, $5uXOq.useState)(null);
    const hasFilterError = error != null;
    const [isDeserialisingFilters, setIsDeserialisingFilters] = (0, $5uXOq.useState)(false);
    const [filtersCache, setFiltersCache] = (0, $5uXOq.useState)({});
    const { data: filterFields, loading: isLoadingFilterFields } = (0, $8DJTW.useFilterFields)();
    const { quickFiltersJql: quickFiltersJql } = (0, $dpQnO.useQuickFilters)();
    (0, $5uXOq.useEffect)(()=>{
        // Skip if loading
        if (isDeserialisingFilters || isLoadingFieldConfig || isLoadingFilterFields) return;
        // Skip if no fields supported
        if (!Object.keys(fieldConfig).length) return;
        // Skip if deserialised this jql before
        if (jql != null && filters === filtersCache[jql]) return;
        // Skip if has error and jql not empty
        if (hasFilterError && jql != null) return;
        if (jql == null) {
            if (hasFilterError) setError(null);
            if (filters !== $fbaf3c30d9711dbc$var$EMPTY_FILTER) setFilters($fbaf3c30d9711dbc$var$EMPTY_FILTER);
            return;
        }
        if (quickFiltersJql !== null) {
            setFilters($fbaf3c30d9711dbc$var$EMPTY_FILTER);
            return;
        }
        if (filtersCache[jql]) {
            setFilters(filtersCache[jql]);
            return;
        }
        setIsDeserialisingFilters(true);
        setIsLoadingFilters?.(true);
        (0, $2RV6Z.deserialiseJql)(jql, fieldConfig, filterFields, resolvers).then((result)=>{
            setFilters(result);
            setFiltersCache({
                ...filtersCache,
                [jql]: result
            });
            setContextFilters?.(result);
        }).catch((e)=>{
            setError(e);
        }).finally(()=>{
            setIsDeserialisingFilters(false);
            setIsLoadingFilters?.(false);
        });
    }, [
        hasFilterError,
        quickFiltersJql,
        error,
        filters,
        isLoadingFieldConfig,
        isLoadingFilterFields,
        fieldConfig,
        jql,
        filtersCache,
        filterFields,
        resolvers,
        isDeserialisingFilters,
        setIsLoadingFilters,
        setContextFilters
    ]);
    (0, $17ot5.useInferHideDoneItemsWithFilters)({
        filters: filters
    });
    return {
        fieldConfig: fieldConfig,
        filters: filters,
        hasFilterError: hasFilterError,
        customFieldsLoader: customFieldsLoader,
        setFilters: setFilter,
        loading: isLoadingFieldConfig || isDeserialisingFilters
    };
};
const $fbaf3c30d9711dbc$export$87f52da20e747485 = (props)=>{
    const { fieldConfig: fieldConfig, filters: filters, hasFilterError: hasFilterError, customFieldsLoader: customFieldsLoader, setFilters: setFilters, loading: loading } = $fbaf3c30d9711dbc$export$eaa578dc219a620a(props);
    const { setFilters: setContextFilters, setIsLoading: setIsLoadingFilters } = $fbaf3c30d9711dbc$export$ac7ff3aa0620d1a7();
    (0, $5uXOq.useEffect)(()=>{
        if (setContextFilters) setContextFilters(filters);
    }, [
        filters,
        setContextFilters
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (setIsLoadingFilters) setIsLoadingFilters(loading);
    }, [
        loading,
        setIsLoadingFilters
    ]);
    return {
        fieldConfig: fieldConfig,
        filters: filters,
        hasFilterError: hasFilterError,
        customFieldsLoader: customFieldsLoader,
        setFilters: setFilters
    };
};

});
parcelRegister("g9ql5", function(module, exports) {

$parcel$export(module.exports, "useFieldConfigWithCustomFields", () => $937abfae1d89db7d$export$9f6dc7e3584916fa);

var $5uXOq = parcelRequire("5uXOq");

var $5fc53 = parcelRequire("5fc53");

var $gzkAf = parcelRequire("gzkAf");

var $5FlVd = parcelRequire("5FlVd");

var $RjSi3 = parcelRequire("RjSi3");

var $cLe9v = parcelRequire("cLe9v");
const $937abfae1d89db7d$var$emptySet = new Set();
const $937abfae1d89db7d$var$CustomFieldsLoader = ({ allowedFieldTypes: allowedFieldTypes, allowedAliasFieldId: allowedAliasFieldId, setFieldConfig: setFieldConfig })=>{
    const { fieldConfig: fieldConfig, resolvers: resolvers, loading: loading } = (0, $cLe9v.useFieldConfig)({
        allowedFieldTypes: allowedFieldTypes,
        allowedAliasFieldId: allowedAliasFieldId
    });
    (0, $5uXOq.useEffect)(()=>{
        setFieldConfig({
            fieldConfig: fieldConfig,
            resolvers: resolvers,
            loading: loading
        });
    }, [
        fieldConfig,
        resolvers,
        loading,
        setFieldConfig
    ]);
    return null;
};
const $937abfae1d89db7d$export$9f6dc7e3584916fa = ({ view: view, allowCustomFields: allowCustomFields, allowedAliasFieldId: allowedAliasFieldId, allowedFieldTypes: allowedFieldTypes })=>{
    const [newAllowedFieldTypes, oldAllowedFieldTypes] = (0, $5uXOq.useMemo)(()=>{
        // split allowedFieldTypes into new and old input for useFieldConfigV2 and useFieldConfigOld
        const newTypes = new Set(allowedFieldTypes);
        const oldTypes = new Set();
        (0, $gzkAf.EXTRA_CUSTOM_FIELD_TYPES).forEach((type)=>{
            if (allowedFieldTypes.has(type)) {
                newTypes.delete(type);
                oldTypes.add(type);
            }
        });
        return [
            newTypes,
            oldTypes
        ];
    }, [
        allowedFieldTypes
    ]);
    const hasCustomFields = Boolean(allowCustomFields) && oldAllowedFieldTypes.size > 0;
    const hasAliasFields = allowedAliasFieldId != null && allowedAliasFieldId.size > 0;
    const shouldLoadOldFieldConfig = hasAliasFields || hasCustomFields;
    const { fieldConfig: fieldConfigNew, resolvers: resolversNew, loading: isLoadingFieldConfigNew } = (0, $RjSi3.useFieldConfigV2)({
        view: view,
        allowedFieldTypes: newAllowedFieldTypes
    });
    const [{ fieldConfig: fieldConfigOld, loading: isLoadingFieldConfigOld, resolvers: resolversOld }, setFieldConfig] = (0, $5uXOq.useState)({
        fieldConfig: {},
        resolvers: {},
        loading: shouldLoadOldFieldConfig
    });
    const customFieldsLoader = (0, $5uXOq.useMemo)(()=>{
        if (!shouldLoadOldFieldConfig) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($937abfae1d89db7d$var$CustomFieldsLoader, {
            allowedFieldTypes: allowCustomFields ? oldAllowedFieldTypes : $937abfae1d89db7d$var$emptySet,
            allowedAliasFieldId: allowedAliasFieldId,
            setFieldConfig: setFieldConfig
        });
    }, [
        allowCustomFields,
        allowedAliasFieldId,
        oldAllowedFieldTypes,
        shouldLoadOldFieldConfig
    ]);
    const { fetchUsers: fetchUsers } = (0, $5FlVd.useFetchFieldValues)({
        view: view,
        allowedFieldTypes: allowedFieldTypes
    });
    const fieldConfig = (0, $5uXOq.useMemo)(()=>{
        const aliasFields = {};
        const otherFields = {};
        Object.keys(fieldConfigOld).forEach((id)=>{
            if (fieldConfigOld[id].systemType === (0, $5fc53.PEOPLE_CF_TYPE) || fieldConfigOld[id].systemType === (0, $5fc53.USER_CF_TYPE)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            fieldConfigOld[id] = {
                ...fieldConfigOld[id],
                loadOptions: fetchUsers
            };
            // We want to assure that alias fields are always at the end of the filter
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            if (fieldConfigOld[id].aliasFieldId != null) aliasFields[id] = fieldConfigOld[id];
            else otherFields[id] = fieldConfigOld[id];
        });
        return {
            ...otherFields,
            ...fieldConfigNew,
            ...aliasFields
        };
    }, [
        fieldConfigOld,
        fieldConfigNew,
        fetchUsers
    ]);
    return {
        fieldConfig: fieldConfig,
        resolvers: {
            ...resolversOld,
            ...resolversNew
        },
        customFieldsLoader: customFieldsLoader,
        loading: isLoadingFieldConfigNew || isLoadingFieldConfigOld
    };
};

});
parcelRegister("5FlVd", function(module, exports) {

$parcel$export(module.exports, "useFetchFieldValues", () => $b6820483a00ce3be$export$6cb851ed13e3949e);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $hE5wF = parcelRequire("hE5wF");

var $5YBrl = parcelRequire("5YBrl");

var $jlq4V = parcelRequire("jlq4V");

var $eusud = parcelRequire("eusud");

var $5fc53 = parcelRequire("5fc53");

var $koeKL = parcelRequire("koeKL");

var $ieDtd = parcelRequire("ieDtd");

var $b4fG8 = parcelRequire("b4fG8");

var $34JdM = parcelRequire("34JdM");

var $czmU8 = parcelRequire("czmU8");

var $84pWT = parcelRequire("84pWT");


var $ldL1T = parcelRequire("ldL1T");
const $b6820483a00ce3be$var$MAX_NUMBER_OF_OPTIONS = 20; // min number to render two rows of the priority filter
const $b6820483a00ce3be$var$MAX_INITIAL_NUMBER_OF_OPTIONS = 50; // Increased initial number of options fetched
const $b6820483a00ce3be$var$EMPTY_FIELD_DATA = {
    totalCount: 0,
    options: []
};
const $b6820483a00ce3be$var$ACTIVE_SPRINTS_JQL = '(sprint in openSprints() OR sprint in futureSprints())';
const $b6820483a00ce3be$var$fetchInitialDataInternal = async (cloudId, jqlContext, jqlURLParam, allowedFieldTypes, goalsJqlTerm)=>{
    try {
        const response = await (0, $eusud.performPostRequest)('/rest/gira/1/?operation=JWMInitialFilterFieldValues', {
            body: JSON.stringify({
                query: (0, $c4148dc6c1f759d4$export$a48313dd44fc9855),
                variables: {
                    cloudId: cloudId,
                    first: $b6820483a00ce3be$var$MAX_INITIAL_NUMBER_OF_OPTIONS,
                    jql: jqlContext,
                    shouldFetchSoftwareFields: Boolean(allowedFieldTypes?.has((0, $5fc53.FIX_VERSIONS_TYPE))) || Boolean(allowedFieldTypes?.has((0, $5fc53.SPRINT_TYPE))),
                    shouldFetchGoalsField: Boolean(allowedFieldTypes?.has((0, $5fc53.GOALS_CF_TYPE)) && !!goalsJqlTerm),
                    goalsJqlTerm: goalsJqlTerm || '',
                    sprintsJqlContext: allowedFieldTypes?.has((0, $5fc53.SPRINT_TYPE)) ? `${jqlContext} AND ${$b6820483a00ce3be$var$ACTIVE_SPRINTS_JQL}` : undefined
                }
            })
        });
        if (response.data?.jira?.jqlBuilder == null && response.data?.jwmCategoryOptions == null) throw new (0, $jlq4V.GraphQLErrors)(response.errors);
        const hydratedValues = jqlURLParam ? await (0, $czmU8.hydrateFilterValues)(cloudId, jqlURLParam) : null;
        const transformedInitialData = (0, $ldL1T.transformInitialData)(response.data);
        if (hydratedValues !== null) {
            const transformedHydratedValues = (0, $84pWT.transformHydratedValues)(hydratedValues);
            return (0, $84pWT.mergeHydratedValues)(transformedInitialData, transformedHydratedValues);
        }
        return transformedInitialData;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $ldL1T.fireFieldValuesErrorAnalytics)('initialiseFilterData', 'Failed to initialise filter data', err);
    }
    return null;
};
const $b6820483a00ce3be$var$memoizedFetchInitialData = (0, $8QpSo.default)($b6820483a00ce3be$var$fetchInitialDataInternal);
const $b6820483a00ce3be$export$6cb851ed13e3949e = ({ view: view, allowedFieldTypes: allowedFieldTypes, filterFields: filterFields })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const jqlContext = (0, $5YBrl.useJqlContext)();
    const [jqlURLParam] = (0, $ieDtd.useQueryParam)((0, $hE5wF.FILTER_PARAM));
    const jqlURLParamRef = (0, $5uXOq.useRef)(jqlURLParam);
    const goalsJqlTerm = (0, $ldL1T.useGoalsJqlTerm)(filterFields);
    const fetchTeamsService = (0, $34JdM.useFetchTeams)();
    const fetchTeamsServiceNew = (0, $5uXOq.useCallback)(()=>{
        if (allowedFieldTypes?.has((0, $5fc53.TEAMS_PLATFORM_CF_TYPE))) return fetchTeamsService({
            first: $b6820483a00ce3be$var$MAX_NUMBER_OF_OPTIONS
        });
        return Promise.resolve();
    }, [
        allowedFieldTypes,
        fetchTeamsService
    ]);
    const fetchInitialData = (0, $5uXOq.useCallback)(async ()=>{
        return Promise.all([
            $b6820483a00ce3be$var$memoizedFetchInitialData(cloudId, jqlContext, jqlURLParamRef.current, allowedFieldTypes, goalsJqlTerm),
            fetchTeamsServiceNew()
        ]).then((values)=>{
            let result = (0, $b4fG8.EMPTY_TRANSFORMED_DATA);
            values.forEach((value)=>{
                result = {
                    ...result,
                    ...value
                };
            });
            return result;
        });
    }, [
        allowedFieldTypes,
        cloudId,
        fetchTeamsServiceNew,
        goalsJqlTerm,
        jqlContext
    ]);
    const fetchData = (0, $5uXOq.useCallback)(async ({ fieldName: fieldName, query: query = '', first: first = $b6820483a00ce3be$var$MAX_NUMBER_OF_OPTIONS, afterCursor: afterCursor, jqlContext: jqlContextProp })=>{
        const response = await (0, $eusud.performPostRequest)('/rest/gira/1/?operation=JWMFilterFieldValues', {
            body: JSON.stringify({
                query: (0, $c4148dc6c1f759d4$export$f8e8a5f34f6ea725),
                variables: {
                    cloudId: cloudId,
                    first: first,
                    jqlTerm: fieldName,
                    jql: jqlContextProp ?? jqlContext,
                    searchString: query,
                    after: afterCursor
                }
            })
        });
        if (response.data?.jira?.jqlBuilder?.fieldValues == null) throw new (0, $jlq4V.GraphQLErrors)(response.errors);
        return response.data.jira.jqlBuilder.fieldValues;
    }, [
        cloudId,
        jqlContext
    ]);
    const fetchLabels = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'labels',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $b4fG8.transformDefaultField)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $ldL1T.fireFieldValuesErrorAnalytics)('searchFilterLabels', 'Failed to search labels', err);
        }
        return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
    }, [
        fetchData
    ]);
    const fetchComponents = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'component',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $b4fG8.transformDefaultField)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $ldL1T.fireFieldValuesErrorAnalytics)('searchFilterComponents', 'Failed to search components', err);
        }
        return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
    }, [
        fetchData
    ]);
    const fetchPriorities = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'priority',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $b4fG8.transformPriorities)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $ldL1T.fireFieldValuesErrorAnalytics)('searchFilterPriorities', 'Failed to search priorities', err);
        }
        return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
    }, [
        fetchData
    ]);
    const fetchUsers = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'assignee',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $b4fG8.transformUsers)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $ldL1T.fireFieldValuesErrorAnalytics)('searchFilterUsers', 'Failed to search users', err);
        }
        return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
    }, [
        fetchData
    ]);
    const fetchIssueTypes = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'issuetype',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            let options = (0, $b4fG8.transformIssueTypes)(fieldValuesData);
            if (view === 'board') options = options.filter((option)=>option.hierarchyLevel !== -1);
            return {
                totalCount: fieldValuesData.totalCount,
                options: options
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $ldL1T.fireFieldValuesErrorAnalytics)('searchFilterIssueTypes', 'Failed to search issue types', err);
        }
        return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
    }, [
        fetchData,
        view
    ]);
    const fetchStatuses = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'status',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $b4fG8.transformStatuses)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $ldL1T.fireFieldValuesErrorAnalytics)('searchFilterStatuses', 'Failed to search statuses', err);
        }
        return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
    }, [
        fetchData
    ]);
    const fetchCategories = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first = $b6820483a00ce3be$var$MAX_NUMBER_OF_OPTIONS })=>{
        try {
            const response = await (0, $eusud.performPostRequest)('/rest/gira/1/?operation=JWMCategoryFieldValuesSearch', {
                body: JSON.stringify({
                    query: (0, $c4148dc6c1f759d4$export$562e34ec948f373d),
                    variables: {
                        first: first,
                        jql: jqlContext,
                        searchQuery: query,
                        after: afterCursor
                    }
                })
            });
            if (response.errors != null) throw new (0, $jlq4V.GraphQLErrors)(response.errors);
            if (response.data?.jira?.jwmCategoryOptions?.edges == null) throw new Error('GraphQL response has no data');
            return {
                totalCount: response.data.jira.jwmCategoryOptions.totalCount,
                options: (0, $b4fG8.transformCategories)(response.data.jira.jwmCategoryOptions)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $ldL1T.fireFieldValuesErrorAnalytics)('searchFilterCategories', 'Failed to search categories', err);
        }
        return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
    }, [
        jqlContext
    ]);
    const fetchSprints = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'sprint',
                query: query,
                first: first,
                afterCursor: afterCursor,
                jqlContext: `${jqlContext} AND ${$b6820483a00ce3be$var$ACTIVE_SPRINTS_JQL}`
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $b4fG8.transformSprints)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $ldL1T.fireFieldValuesErrorAnalytics)('searchFilterSprints', 'Failed to search sprints', err);
        }
        return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
    }, [
        fetchData,
        jqlContext
    ]);
    const fetchFixVersions = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'fixVersion',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $b4fG8.transformDefaultField)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $ldL1T.fireFieldValuesErrorAnalytics)('searchFilterFixVersion', 'Failed to search fix version', err);
        }
        return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
    }, [
        fetchData
    ]);
    const fetchParents = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'parent',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $b4fG8.transformParent)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $ldL1T.fireFieldValuesErrorAnalytics)('searchFilterParent', 'Failed to search parents', err);
        }
        return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
    }, [
        fetchData
    ]);
    const fetchGoals = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        if (!goalsJqlTerm) return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: goalsJqlTerm,
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $b4fG8.transformGoals)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $ldL1T.fireFieldValuesErrorAnalytics)('searchFilterGoals', 'Failed to search goals', err);
        }
        return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
    }, [
        fetchData,
        goalsJqlTerm
    ]);
    const fetchTeams = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            const fieldValuesData = await fetchTeamsService({
                query: query,
                first: first,
                after: afterCursor
            });
            return fieldValuesData[0, $5fc53.TEAMS_PLATFORM_CF_TYPE];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $ldL1T.fireFieldValuesErrorAnalytics)('searchFilterTeams', 'Failed to search teams', err);
        }
        return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
    }, [
        fetchTeamsService
    ]);
    return {
        fetchInitialData: fetchInitialData,
        fetchLabels: fetchLabels,
        fetchComponents: fetchComponents,
        fetchPriorities: fetchPriorities,
        fetchUsers: fetchUsers,
        fetchIssueTypes: fetchIssueTypes,
        fetchStatuses: fetchStatuses,
        fetchCategories: fetchCategories,
        fetchSprints: fetchSprints,
        fetchFixVersions: fetchFixVersions,
        fetchParents: fetchParents,
        fetchTeams: fetchTeams,
        fetchGoals: fetchGoals
    };
};

});
parcelRegister("b4fG8", function(module, exports) {

$parcel$export(module.exports, "transformPriorities", () => $7c1a01ddd808f237$export$86ca92dec35c4797);
$parcel$export(module.exports, "transformUsers", () => $7c1a01ddd808f237$export$fb8c90bfc4beaa59);
$parcel$export(module.exports, "transformIssueTypes", () => $7c1a01ddd808f237$export$4c05e2584b34e4d8);
$parcel$export(module.exports, "transformStatuses", () => $7c1a01ddd808f237$export$20a57a5ec025f2d);
$parcel$export(module.exports, "transformCategories", () => $7c1a01ddd808f237$export$1b389c47cf1df04e);
$parcel$export(module.exports, "transformDefaultField", () => $7c1a01ddd808f237$export$6133e08eeff30d5f);
$parcel$export(module.exports, "transformSprints", () => $7c1a01ddd808f237$export$6a33be7fc7f04943);
$parcel$export(module.exports, "transformGoals", () => $7c1a01ddd808f237$export$673d4fceed3e8383);
$parcel$export(module.exports, "transformParent", () => $7c1a01ddd808f237$export$87e9766fb5100314);
$parcel$export(module.exports, "transformTeams", () => $7c1a01ddd808f237$export$fd398a52d6f57b46);
$parcel$export(module.exports, "EMPTY_TRANSFORMED_DATA", () => $7c1a01ddd808f237$export$ca9df9cab9cc134f);
$parcel$export(module.exports, "transformValuesData", () => $7c1a01ddd808f237$export$8e327b5f9ebc175d);

var $3JOCw = parcelRequire("3JOCw");

var $5fc53 = parcelRequire("5fc53");

var $dCm1o = parcelRequire("dCm1o");
const $7c1a01ddd808f237$var$getFirstIssueTypeAvatar = (node)=>node.issueTypes?.find((issueType)=>issueType?.avatar?.medium != null)?.avatar?.medium;
const $7c1a01ddd808f237$var$getFirstIssueTypeId = (node)=>node.issueTypes[0]?.issueTypeId;
const $7c1a01ddd808f237$var$getFirstIssueTypeHierarchyLevel = (node)=>node.issueTypes[0]?.hierarchy?.level;
const $7c1a01ddd808f237$export$86ca92dec35c4797 = (data)=>data.edges.map(({ node: node, cursor: cursor })=>({
            cursor: cursor,
            value: node.jqlTerm,
            label: node.displayName,
            avatar: node.priority.iconUrl || ''
        }));
const $7c1a01ddd808f237$export$fb8c90bfc4beaa59 = (data)=>data.edges.filter(({ node: node })=>node?.user != null).map(({ node: node, cursor: cursor })=>({
            cursor: cursor,
            value: node.jqlTerm,
            label: node.displayName,
            avatar: node?.user?.picture || ''
        }));
const $7c1a01ddd808f237$export$4c05e2584b34e4d8 = (data)=>data.edges.map(({ node: node, cursor: cursor })=>({
            cursor: cursor,
            value: node.jqlTerm,
            label: node.displayName,
            id: $7c1a01ddd808f237$var$getFirstIssueTypeId(node),
            avatar: $7c1a01ddd808f237$var$getFirstIssueTypeAvatar(node) || '',
            square: true,
            hierarchyLevel: $7c1a01ddd808f237$var$getFirstIssueTypeHierarchyLevel(node) || 0
        }));
const $7c1a01ddd808f237$export$20a57a5ec025f2d = (data)=>data.edges.map(({ node: node, cursor: cursor })=>({
            cursor: cursor,
            value: node.jqlTerm,
            label: node.displayName,
            categoryId: node.statusCategory.statusCategoryId
        }));
const $7c1a01ddd808f237$export$1b389c47cf1df04e = (data)=>{
    const transformedCategories = data.edges.map((edge)=>({
            cursor: edge?.cursor,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            value: edge.node.option.value,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            label: edge.node.option.value,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            color: edge.node.color
        }));
    // Remove any categories that have the same name across multiple projects
    return (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))(transformedCategories, ({ value: value })=>value);
};
const $7c1a01ddd808f237$export$6133e08eeff30d5f = (data)=>data.edges.map(({ node: node, cursor: cursor })=>({
            cursor: cursor,
            value: node.jqlTerm,
            label: node.displayName
        }));
const $7c1a01ddd808f237$export$6a33be7fc7f04943 = (data)=>data.edges.filter(({ node: node })=>node?.sprint != null).map(({ node: node, cursor: cursor })=>({
            cursor: cursor,
            value: node.displayName,
            label: node.sprint?.name || ''
        }));
const $7c1a01ddd808f237$export$673d4fceed3e8383 = (data)=>data.edges.map(({ node: node, cursor: cursor })=>({
            cursor: cursor,
            value: node.jqlTerm,
            label: node.goal.name || '',
            status: node.goal.status || ''
        }));
const $7c1a01ddd808f237$export$87e9766fb5100314 = (data)=>data?.edges.map(({ node: node, cursor: cursor })=>{
        let avatar = '';
        if (node.issue?.fieldsByIdOrAlias && node.issue.fieldsByIdOrAlias.length > 0) avatar = node.issue.fieldsByIdOrAlias[0].issueType?.avatar?.medium || '';
        return {
            cursor: cursor,
            value: node.jqlTerm,
            label: node.displayName,
            avatar: avatar,
            ...(0, $dCm1o.isVisualRefreshEnabled)() && {
                square: true
            }
        };
    });
const $7c1a01ddd808f237$export$fd398a52d6f57b46 = (data)=>data?.edges.filter(({ node: node })=>node?.team != null).map(({ node: node })=>({
            cursor: data.pageInfo?.endCursor,
            value: node.team.id.replace('ari:cloud:identity::team/', ''),
            label: node.team.displayName || '',
            avatar: node.team.smallAvatarImageUrl || ''
        }));
// Type predicted
const $7c1a01ddd808f237$var$isIssueType = (fieldValue)=>{
    const { node: node } = fieldValue.edges[0];
    return Boolean(node && 'issueTypes' in node);
};
const $7c1a01ddd808f237$var$isPriority = (fieldValue)=>{
    const { node: node } = fieldValue.edges[0];
    return Boolean(node && 'priority' in node);
};
const $7c1a01ddd808f237$var$isStatus = (fieldValue)=>{
    const { node: node } = fieldValue.edges[0];
    return Boolean(node && 'statusCategory' in node);
};
const $7c1a01ddd808f237$var$isSprint = (fieldValue)=>{
    const { node: node } = fieldValue.edges[0];
    return Boolean(node && 'sprint' in node);
};
const $7c1a01ddd808f237$var$isGoal = (fieldValue)=>{
    const { node: node } = fieldValue.edges[0];
    return Boolean(node && 'goal' in node);
};
const $7c1a01ddd808f237$var$isParent = (fieldValue)=>{
    const { node: node } = fieldValue.edges[0];
    return Boolean(node && 'issue' in node);
};
// any fieldValue could be a UserFieldValues because the edges could have some node with "user" undefined
// for example : { node: { displayName: "administrators", jqlTerm: "membersOf(administrators)" }}
const $7c1a01ddd808f237$var$isUser = (fieldValue)=>true;
const $7c1a01ddd808f237$var$isDefaultField = (fieldValue)=>Boolean(fieldValue.edges[0]);
const $7c1a01ddd808f237$export$ca9df9cab9cc134f = {
    labels: {
        totalCount: 0,
        options: []
    },
    components: {
        totalCount: 0,
        options: []
    },
    priority: {
        totalCount: 0,
        options: []
    },
    users: {
        totalCount: 0,
        options: []
    },
    issuetype: {
        totalCount: 0,
        options: []
    },
    status: {
        totalCount: 0,
        options: []
    },
    [(0, $5fc53.CATEGORY_TYPE)]: {
        totalCount: 0,
        options: []
    },
    [(0, $5fc53.SPRINT_TYPE)]: {
        totalCount: 0,
        options: []
    },
    [(0, $5fc53.FIX_VERSIONS_TYPE)]: {
        totalCount: 0,
        options: []
    },
    [(0, $5fc53.PARENT_FIELD_TYPE)]: {
        totalCount: 0,
        options: []
    },
    [(0, $5fc53.GOALS_CF_TYPE)]: {
        totalCount: 0,
        options: []
    },
    [(0, $5fc53.TEAMS_PLATFORM_CF_TYPE)]: {
        totalCount: 0,
        options: []
    }
};
const $7c1a01ddd808f237$export$8e327b5f9ebc175d = (data)=>{
    const transformedData = {
        ...$7c1a01ddd808f237$export$ca9df9cab9cc134f
    };
    Object.entries(data).forEach(([key, fieldValue])=>{
        if (fieldValue && fieldValue.edges && Array.isArray(fieldValue.edges) && fieldValue.edges.length) switch(key){
            case 'issuetype':
                if ($7c1a01ddd808f237$var$isIssueType(fieldValue)) transformedData.issuetype = {
                    totalCount: fieldValue.totalCount,
                    options: $7c1a01ddd808f237$export$4c05e2584b34e4d8(fieldValue)
                };
                break;
            case 'priority':
                if ($7c1a01ddd808f237$var$isPriority(fieldValue)) transformedData.priority = {
                    totalCount: fieldValue.totalCount,
                    options: $7c1a01ddd808f237$export$86ca92dec35c4797(fieldValue)
                };
                break;
            case 'status':
                if ($7c1a01ddd808f237$var$isStatus(fieldValue)) transformedData.status = {
                    totalCount: fieldValue.totalCount,
                    options: $7c1a01ddd808f237$export$20a57a5ec025f2d(fieldValue)
                };
                break;
            case 'component':
            case 'components':
            case 'fixVersions':
            case 'labels':
                if ($7c1a01ddd808f237$var$isDefaultField(fieldValue)) {
                    const transformedKey = key === 'component' ? (0, $5fc53.COMPONENTS_TYPE) : key;
                    transformedData[transformedKey] = {
                        totalCount: fieldValue.totalCount,
                        options: $7c1a01ddd808f237$export$6133e08eeff30d5f(fieldValue)
                    };
                }
                break;
            case 'parent':
                if ($7c1a01ddd808f237$var$isParent(fieldValue)) transformedData[key] = {
                    totalCount: fieldValue.totalCount,
                    options: $7c1a01ddd808f237$export$87e9766fb5100314(fieldValue)
                };
                break;
            default:
                if ($7c1a01ddd808f237$var$isSprint(fieldValue)) transformedData[0, $5fc53.SPRINT_TYPE] = {
                    totalCount: fieldValue.totalCount,
                    options: $7c1a01ddd808f237$export$6a33be7fc7f04943(fieldValue)
                };
                else if (fieldValue.edges.some((item)=>item.node && 'user' in item.node) && $7c1a01ddd808f237$var$isUser(fieldValue)) {
                    const usersData = $7c1a01ddd808f237$export$fb8c90bfc4beaa59(fieldValue);
                    const userOptions = (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))([
                        ...usersData,
                        ...transformedData.users?.options ?? []
                    ], ({ value: value })=>value);
                    transformedData.users = {
                        totalCount: userOptions.length,
                        options: userOptions
                    };
                } else if ($7c1a01ddd808f237$var$isGoal(fieldValue)) transformedData[0, $5fc53.GOALS_CF_TYPE] = {
                    totalCount: fieldValue.totalCount,
                    options: $7c1a01ddd808f237$export$673d4fceed3e8383(fieldValue)
                };
        }
    });
    return transformedData;
};

});

parcelRegister("34JdM", function(module, exports) {

$parcel$export(module.exports, "useFetchTeams", () => $96faa576a82047b8$export$da1ab223b3f1410c);
$parcel$export(module.exports, "useFetchTeamsById", () => $96faa576a82047b8$export$c8925d7eebfccb3d);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $5fc53 = parcelRequire("5fc53");

var $jlq4V = parcelRequire("jlq4V");

var $14XJw = parcelRequire("14XJw");

var $koeKL = parcelRequire("koeKL");

var $b4fG8 = parcelRequire("b4fG8");

// use ari functions from @atlassian/ari whenever it is ready for import
const $96faa576a82047b8$var$prependOrgIdAri = (orgId)=>`ari:cloud:platform::org/${orgId}`;
const $96faa576a82047b8$export$37430da53242c305 = {
    [(0, $5fc53.TEAMS_PLATFORM_CF_TYPE)]: {
        totalCount: 0,
        options: []
    }
};
const $96faa576a82047b8$var$MAX_NUMBER_OF_OPTIONS = 20;
const $96faa576a82047b8$var$EMPTY_ARRAY = [];
const $96faa576a82047b8$export$da1ab223b3f1410c = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const fetchTeams = (0, $5uXOq.useCallback)(async ({ query: query, first: first = $96faa576a82047b8$var$MAX_NUMBER_OF_OPTIONS, after: after })=>{
        if (orgId) try {
            const response = await (0, $eusud.performPostRequest)('/gateway/api/graphql', {
                body: JSON.stringify({
                    query: (0, $31f39d27d8739895$export$cbe5a6af25588495),
                    variables: {
                        orgId: $96faa576a82047b8$var$prependOrgIdAri(orgId),
                        cloudId: cloudId,
                        queryString: query,
                        first: first,
                        after: after
                    }
                })
            });
            if (response.errors != null) {
                if (response.errors[0]?.extensions?.statusCode === 403) return $96faa576a82047b8$export$37430da53242c305;
                throw new (0, $jlq4V.GraphQLErrors)(response.errors);
            }
            const teamData = response.data.team;
            if (!teamData) throw new Error('Empty team data');
            const options = (0, $b4fG8.transformTeams)(teamData.teamSearchV2) || [];
            // Teams query doesn't return the total count
            const totalCount = options.length >= first ? first : options.length;
            return {
                [(0, $5fc53.TEAMS_PLATFORM_CF_TYPE)]: {
                    totalCount: totalCount,
                    options: options
                }
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'fetchTeams',
                    packageName: 'jiraBusinessFilters',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to fetch team filter data'
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return $96faa576a82047b8$export$37430da53242c305;
    }, [
        cloudId,
        orgId
    ]);
    return fetchTeams;
};
const $96faa576a82047b8$export$c8925d7eebfccb3d = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const fetchTeamsById = (0, $5uXOq.useCallback)(async ({ teamIds: teamIds })=>Promise.all(teamIds.map((teamId)=>(0, $eusud.performPostRequest)('/gateway/api/graphql', {
                body: JSON.stringify({
                    query: (0, $31f39d27d8739895$export$32a6317a30e26003),
                    variables: {
                        cloudId: cloudId,
                        teamId: `ari:cloud:identity::team/${teamId}`
                    }
                })
            }))).then((result)=>{
            const options = result.map((response)=>{
                const teamOption = response.data.team.teamV2;
                return {
                    value: teamOption.id.replace('ari:cloud:identity::team/', ''),
                    label: teamOption.displayName || '',
                    avatar: teamOption.smallAvatarImageUrl || ''
                };
            }) || [];
            return options;
        })// eslint-disable-next-line @typescript-eslint/no-explicit-any
        .catch((err)=>{
            (0, $jcw0u.default)({
                meta: {
                    id: 'fetchTeamsById',
                    packageName: 'jiraBusinessFilters',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to fetch team by ID filter data'
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
            return $96faa576a82047b8$var$EMPTY_ARRAY;
        }), [
        cloudId
    ]);
    return fetchTeamsById;
};

});
const $31f39d27d8739895$export$cbe5a6af25588495 = `
    query JWMTeamFilterValues($cloudId: String!, $orgId: ID!, $queryString: String, $first: Int, $after: String) {
        team @optIn(to: "Team-search-v2") {
            teamSearchV2(
                organizationId: $orgId
                siteId: $cloudId
                first: $first
                after: $after
                filter: {query: $queryString}
            ) {
                pageInfo {
                    hasNextPage
                    endCursor
                }
                edges {
                    node {
                        team {
                            id
                            displayName
                            smallAvatarImageUrl
                        }
                    }
                }
            }
        }
    }
`;
const $31f39d27d8739895$export$32a6317a30e26003 = `
    query JWMTeamFilterById($teamId: ID!, $cloudId: String!) {
        team @optIn(to: "Team-search-v2") {
            teamV2(id: $teamId, siteId: $cloudId) {
                id
                displayName
                smallAvatarImageUrl
            }
        }
    }
`;


parcelRegister("czmU8", function(module, exports) {

$parcel$export(module.exports, "hydrateFilterValues", () => $3268558672fc0eb1$export$b18eef22aaa99c21);

var $8QpSo = parcelRequire("8QpSo");

var $c9Ur7 = parcelRequire("c9Ur7");

var $jlq4V = parcelRequire("jlq4V");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

const $3268558672fc0eb1$export$3361e9be8093ddcc = (fields)=>{
    const hydratedValues = {};
    fields.forEach((hydratedField)=>{
        if (!hydratedField) return;
        const { field: field, values: values } = hydratedField;
        if (!field || !values) return;
        hydratedValues[field.jqlTerm] = {
            edges: values.map((item)=>(item && item.values && item.values[0]) ?? null).filter(Boolean).map((item)=>({
                    node: item
                })),
            totalCount: 0
        };
    });
    return hydratedValues;
};
const $3268558672fc0eb1$export$7a89edfb546e2344 = async (cloudId, jqlContext)=>{
    try {
        const response = await (0, $eusud.performPostRequest)('/rest/gira/1/?operation=JWMHydrateFilterValues', {
            body: JSON.stringify({
                query: (0, $d73ce8e52a931002$export$2bd792833522f1f1),
                variables: {
                    cloudId: cloudId,
                    jql: jqlContext
                }
            })
        });
        if (response.errors != null) throw new (0, $jlq4V.GraphQLErrors)(response.errors);
        if (response.data?.jira?.jqlBuilder?.hydrateJqlQuery?.fields == null) {
            if (response.data?.jira?.jqlBuilder?.hydrateJqlQuery?.__typename === 'QueryError') throw new (0, $c9Ur7.QueryError)(response.data.jira.jqlBuilder.hydrateJqlQuery);
            throw new Error('Failed to fetch on hydrateFilterValuesService');
        }
        return $3268558672fc0eb1$export$3361e9be8093ddcc(response.data.jira.jqlBuilder.hydrateJqlQuery.fields);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: 'JWMHydrateFilterValues',
                packageName: 'jiraBusinessFilters',
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $3268558672fc0eb1$export$b18eef22aaa99c21 = (0, $8QpSo.default)($3268558672fc0eb1$export$7a89edfb546e2344);

});
const $d73ce8e52a931002$var$FIELD_VALUE_NODE_FRAGMENT = `
fragment FieldValueNodeFragment on JiraJqlFieldValue {
    jqlTerm
    displayName
    ... on JiraJqlUserFieldValue {
        user {
            picture
        }
    }
    ... on JiraJqlPriorityFieldValue {
        priority {
            iconUrl
        }
    }
    ... on JiraJqlIssueTypeFieldValue {
        issueTypes {
            issueTypeId
            avatar {
                medium
            }
            hierarchy {
                level
            }
        }
    }
    ... on JiraJqlStatusFieldValue {
        statusCategory {
            statusCategoryId
        }
    }
    ... on JiraJqlSprintFieldValue {
        sprint {
            sprintId
            name
        }
    }
    ... on JiraJqlGoalsFieldValue {
        goal {
            name
            status
        }
    }
    ... on JiraJqlIssueFieldValue {
        issue {
            fieldsByIdOrAlias(idsOrAliases: ["issuetype"]) {
                ... on JiraIssueTypeField {
                    issueType {
                        avatar {
                            medium
                        }
                    }
                }
            }
        }
    }
}
`;
const $d73ce8e52a931002$export$2bd792833522f1f1 = `
query JwmHydrateFilterValues($cloudId: ID!, $jql: String!) {
	jira {
        jqlBuilder(cloudId: $cloudId) {
            hydrateJqlQuery(query: $jql, viewContext: JWM) {
                ... on JiraJqlHydratedQuery {
                    fields {
                        ... on JiraJqlQueryHydratedField {
                            field {
                                jqlTerm
                            }
                            values {
                                ... on JiraJqlQueryHydratedValue {
                                    values {
                                        jqlTerm
                                        displayName
                                        ...FieldValueNodeFragment
                                    }
                                }
                            }
                        }
                    }
                }
                ... on QueryError {
                    message
                    extensions {
                      statusCode
                    }
                }
                __typename
            }
        }
	}
}
${$d73ce8e52a931002$var$FIELD_VALUE_NODE_FRAGMENT}
`;


parcelRegister("84pWT", function(module, exports) {

$parcel$export(module.exports, "transformHydratedValues", () => $b845ee1bf81ff96f$export$56282b201a60959e);
$parcel$export(module.exports, "mergeHydratedValues", () => $b845ee1bf81ff96f$export$8f60413c08081990);

var $3JOCw = parcelRequire("3JOCw");

var $5fc53 = parcelRequire("5fc53");

var $b4fG8 = parcelRequire("b4fG8");
const $b845ee1bf81ff96f$export$56282b201a60959e = (data)=>{
    return (0, $b4fG8.transformValuesData)(data);
};
const $b845ee1bf81ff96f$export$8f60413c08081990 = (initialData, hydratedValues)=>({
        labels: {
            totalCount: initialData.labels.totalCount,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))([
                ...hydratedValues.labels.options,
                ...initialData.labels.options
            ], ({ value: value })=>value)
        },
        components: {
            totalCount: initialData.components.totalCount,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))([
                ...hydratedValues.components.options,
                ...initialData.components.options
            ], ({ value: value })=>value)
        },
        priority: {
            totalCount: initialData.priority.totalCount,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))([
                ...hydratedValues.priority.options,
                ...initialData.priority.options
            ], ({ value: value })=>value)
        },
        users: {
            totalCount: initialData.users.totalCount,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))([
                ...hydratedValues.users.options,
                ...initialData.users.options
            ], ({ value: value })=>value)
        },
        issuetype: {
            totalCount: initialData.issuetype.totalCount,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))([
                ...hydratedValues.issuetype.options,
                ...initialData.issuetype.options
            ], ({ value: value })=>value)
        },
        status: {
            totalCount: initialData.status.totalCount,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))([
                ...hydratedValues.status.options,
                ...initialData.status.options
            ], ({ value: value })=>value)
        },
        // hydrate values endpoint doesn't support categories
        [(0, $5fc53.CATEGORY_TYPE)]: initialData[0, $5fc53.CATEGORY_TYPE],
        [(0, $5fc53.SPRINT_TYPE)]: {
            totalCount: initialData[0, $5fc53.SPRINT_TYPE].totalCount,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))([
                ...hydratedValues[0, $5fc53.SPRINT_TYPE].options,
                ...initialData[0, $5fc53.SPRINT_TYPE].options
            ], ({ value: value })=>value)
        },
        [(0, $5fc53.FIX_VERSIONS_TYPE)]: {
            totalCount: initialData[0, $5fc53.FIX_VERSIONS_TYPE]?.totalCount || 0,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))([
                ...hydratedValues[0, $5fc53.FIX_VERSIONS_TYPE].options || [],
                ...initialData[0, $5fc53.FIX_VERSIONS_TYPE].options || []
            ], ({ value: value })=>value)
        },
        [(0, $5fc53.PARENT_FIELD_TYPE)]: {
            totalCount: initialData[0, $5fc53.PARENT_FIELD_TYPE]?.totalCount || 0,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))([
                ...hydratedValues[0, $5fc53.PARENT_FIELD_TYPE].options || [],
                ...initialData[0, $5fc53.PARENT_FIELD_TYPE].options || []
            ], ({ value: value })=>value)
        },
        [(0, $5fc53.GOALS_CF_TYPE)]: {
            totalCount: initialData[0, $5fc53.GOALS_CF_TYPE]?.totalCount || 0,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))([
                ...hydratedValues[0, $5fc53.GOALS_CF_TYPE].options,
                ...initialData[0, $5fc53.GOALS_CF_TYPE].options
            ], ({ value: value })=>value)
        },
        [(0, $5fc53.TEAMS_PLATFORM_CF_TYPE)]: {
            totalCount: initialData[0, $5fc53.TEAMS_PLATFORM_CF_TYPE]?.totalCount || 0,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))([
                ...hydratedValues[0, $5fc53.TEAMS_PLATFORM_CF_TYPE].options || [],
                ...initialData[0, $5fc53.TEAMS_PLATFORM_CF_TYPE].options || []
            ], ({ value: value })=>value)
        }
    });

});

const $c4148dc6c1f759d4$var$FIELD_VALUE_NODE_FRAGMENT = `
fragment FieldValueNodeFragment on JiraJqlFieldValue {
    jqlTerm
    displayName
    ... on JiraJqlUserFieldValue {
        user {
            picture
        }
    }
    ... on JiraJqlPriorityFieldValue {
        priority {
            iconUrl
        }
    }
    ... on JiraJqlIssueTypeFieldValue {
        issueTypes {
            issueTypeId
            avatar {
                medium
            }
            hierarchy {
                level
            }
        }
    }
    ... on JiraJqlStatusFieldValue {
        statusCategory {
            statusCategoryId
        }
    }
    ... on JiraJqlSprintFieldValue {
        sprint {
            sprintId
            name
        }
    }
    ... on JiraJqlGoalsFieldValue {
        goal {
            name
            status
        }
    }
    ... on JiraJqlIssueFieldValue {
        issue {
            fieldsByIdOrAlias(idsOrAliases: ["issuetype"]) {
                ... on JiraIssueTypeField {
                    issueType {
                        avatar {
                            medium
                        }
                    }
                }
            }
        }
    }
}
`;
const $c4148dc6c1f759d4$var$CATEGORY_CONNECTION_FRAGMENT = `
fragment CategoryConnection on JiraWorkManagementCategoryOptionConnection {
    edges {
        cursor
        node {
            option {
              value
            }
            color
        }
    }
    totalCount
}
`;
const $c4148dc6c1f759d4$export$a48313dd44fc9855 = `
query JwmInitialFilterValues($cloudId: ID!, $first: Int, $jql: String!, $shouldFetchSoftwareFields: Boolean = false, $sprintsJqlContext: String, $goalsJqlTerm: String!, $shouldFetchGoalsField: Boolean = false) {
    jira {
        jqlBuilder(cloudId: $cloudId) {
            labels: fieldValues(
                first: $first
                jqlTerm: "labels"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            components: fieldValues(
                first: $first
                jqlTerm: "component"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            priority: fieldValues(
                first: $first
                jqlTerm: "priority"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            users: fieldValues(
                first: $first
                jqlTerm: "assignee"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            recentlyUsedUsers(
                first: $first
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            issuetype: fieldValues(
                first: $first
                jqlTerm: "issuetype"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                     cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            status: fieldValues(
                first: $first
                jqlTerm: "status"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            sprints: fieldValues(
                first: $first
                jqlTerm: "sprint"
                jqlContext: $sprintsJqlContext
                viewContext: JSW
            ) @include(if: $shouldFetchSoftwareFields) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            fixVersions: fieldValues(
                first: $first
                jqlTerm: "fixVersion"
                jqlContext: $jql
                viewContext: JWM
            ) @include(if: $shouldFetchSoftwareFields) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            parent: fieldValues(
                first: $first
                jqlTerm: "parent"
                jqlContext: $jql
                viewContext: JSW
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }

            goals: fieldValues(
                first: $first
                jqlTerm: $goalsJqlTerm
                jqlContext: $jql
                viewContext: JWM
            ) @include(if: $shouldFetchGoalsField) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
        }
        jwmCategoryOptions(jqlContext: $jql, first: $first) {
            ...CategoryConnection
        }
    }
}
${$c4148dc6c1f759d4$var$FIELD_VALUE_NODE_FRAGMENT}
${$c4148dc6c1f759d4$var$CATEGORY_CONNECTION_FRAGMENT}
`;
const $c4148dc6c1f759d4$export$f8e8a5f34f6ea725 = `
query JwmSearchFilterValues($cloudId: ID!, $first: Int, $jqlTerm: String!, $jql: String!, $searchString: String, $after: String) {
    jira {
        jqlBuilder(cloudId: $cloudId) {
            fieldValues(
                first: $first
                jqlTerm: $jqlTerm
                jqlContext: $jql
                searchString: $searchString
                after: $after
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
        }
    }
}
${$c4148dc6c1f759d4$var$FIELD_VALUE_NODE_FRAGMENT}
`;
const $c4148dc6c1f759d4$export$562e34ec948f373d = `
query JwmCategorySearchFilterValues($first: Int, $jql: String!, $searchQuery: String, $after: String) {
    jira {       
        jwmCategoryOptions(jqlContext: $jql, first: $first, searchQuery: $searchQuery, after: $after) {
            ...CategoryConnection
        }
    }
}
${$c4148dc6c1f759d4$var$CATEGORY_CONNECTION_FRAGMENT}
`;

parcelRegister("ldL1T", function(module, exports) {

$parcel$export(module.exports, "transformInitialData", () => $6a7ee4f9267edb3b$export$93219b8691fe49a0);
$parcel$export(module.exports, "fireFieldValuesErrorAnalytics", () => $6a7ee4f9267edb3b$export$c3c62a63250fc6f8);
$parcel$export(module.exports, "useGoalsJqlTerm", () => $6a7ee4f9267edb3b$export$674eff5ec8403101);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $5fc53 = parcelRequire("5fc53");

var $b4fG8 = parcelRequire("b4fG8");
const $6a7ee4f9267edb3b$var$transformInitialCategories = (data)=>{
    if (data.jira.jwmCategoryOptions?.edges != null && Array.isArray(data.jira.jwmCategoryOptions.edges)) return {
        totalCount: data.jira.jwmCategoryOptions.totalCount,
        options: (0, $b4fG8.transformCategories)(data.jira.jwmCategoryOptions)
    };
    return undefined;
};
const $6a7ee4f9267edb3b$export$93219b8691fe49a0 = (data)=>{
    const transformedData = (0, $b4fG8.transformValuesData)(data.jira.jqlBuilder);
    const categories = $6a7ee4f9267edb3b$var$transformInitialCategories(data);
    if (categories) transformedData[0, $5fc53.CATEGORY_TYPE] = categories;
    return transformedData;
};
const $6a7ee4f9267edb3b$export$c3c62a63250fc6f8 = (errorId, errorMessage, // eslint-disable-next-line @typescript-eslint/no-explicit-any
error)=>{
    (0, $jcw0u.default)({
        meta: {
            id: errorId,
            packageName: 'jiraBusinessFilters',
            teamName: 'wanjel'
        },
        attributes: {
            message: errorMessage
        },
        error: error,
        sendToPrivacyUnsafeSplunk: true
    });
};
const $6a7ee4f9267edb3b$export$674eff5ec8403101 = (filterFields)=>{
    const goalsJqlTerm = (0, $5uXOq.useMemo)(()=>filterFields?.find((field)=>field?.type === (0, $5fc53.GOALS_CF_TYPE))?.id, [
        filterFields
    ]);
    return goalsJqlTerm;
};

});


parcelRegister("RjSi3", function(module, exports) {

$parcel$export(module.exports, "useFieldConfigV2", () => $95c9fbd80a67ba2b$export$c041141a7ef797c1);

var $5uXOq = parcelRequire("5uXOq");

var $54qG5 = parcelRequire("54qG5");

var $aJfd5 = parcelRequire("aJfd5");

var $koVbs = parcelRequire("koVbs");

var $5fc53 = parcelRequire("5fc53");

var $5FlVd = parcelRequire("5FlVd");

var $8DJTW = parcelRequire("8DJTW");

var $gxGcZ = parcelRequire("gxGcZ");

var $34JdM = parcelRequire("34JdM");

var $1qi71 = parcelRequire("1qi71");
const $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA = {
    totalCount: 0,
    options: []
};
const $95c9fbd80a67ba2b$var$EMPTY_FILTER_DATA = {
    initialUsers: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA,
    initialLabels: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA,
    initialComponents: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA,
    initialPriorities: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA,
    initialIssueTypes: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA,
    initialStatuses: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA,
    initialCategories: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA,
    initialSprints: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA,
    initialFixVersions: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA,
    initialParents: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA,
    initialGoals: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA,
    initialTeams: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA
};
const $95c9fbd80a67ba2b$var$initialState = {
    data: undefined,
    loadingData: true
};
const $95c9fbd80a67ba2b$var$reducer = (state, action)=>{
    switch(action.type){
        case 'init':
            return $95c9fbd80a67ba2b$var$initialState;
        case 'fetch-data-success':
            return {
                ...state,
                data: action.value,
                loadingData: false
            };
        case 'fetch-data-error':
            return {
                ...state,
                data: $95c9fbd80a67ba2b$var$EMPTY_FILTER_DATA,
                loadingData: false
            };
        default:
            return state;
    }
};
/**
 * useFieldConfig hook that is used to populate the field and field values for JWM Filters.
 * It can be used for JWM Overviews which includes multiple Jira Projects.
 */ const $95c9fbd80a67ba2b$var$emptyFieldValue = {
    totalCount: 0,
    options: []
};
const $95c9fbd80a67ba2b$export$c041141a7ef797c1 = ({ view: view, allowedFieldTypes: allowedFieldTypes })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const projectFieldData = (0, $gxGcZ.useProjectFilter)();
    const { data: filterFields, loading: loadingFilterFields } = (0, $8DJTW.useFilterFields)();
    const [{ data: data, loadingData: loadingData }, dispatch] = (0, $5uXOq.useReducer)($95c9fbd80a67ba2b$var$reducer, $95c9fbd80a67ba2b$var$initialState);
    const userResolver = (0, $5uXOq.useRef)(new (0, $aJfd5.UserResolver)());
    const fetchTeamsById = (0, $34JdM.useFetchTeamsById)();
    const { fetchLabels: fetchLabels, fetchComponents: fetchComponents, fetchUsers: fetchUsers, fetchCategories: fetchCategories, fetchInitialData: fetchInitialData, ...fetchOptions } = (0, $5FlVd.useFetchFieldValues)({
        view: view,
        allowedFieldTypes: allowedFieldTypes,
        filterFields: filterFields
    });
    const { data: entity } = (0, $54qG5.useBusinessEntity)();
    const businessEntityId = entity.id;
    const initialiseDefaultData = (0, $5uXOq.useCallback)(()=>{
        fetchInitialData().then((initialData)=>{
            dispatch({
                type: 'fetch-data-success',
                value: {
                    initialUsers: initialData?.users ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                    initialLabels: initialData?.labels ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                    initialComponents: initialData?.components ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                    initialPriorities: initialData?.priority ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                    initialIssueTypes: initialData?.issuetype ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                    initialStatuses: initialData?.status ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                    initialCategories: initialData?.[0, $5fc53.CATEGORY_TYPE] ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                    initialSprints: initialData?.[0, $5fc53.SPRINT_TYPE] ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                    initialFixVersions: initialData?.[0, $5fc53.FIX_VERSIONS_TYPE] ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                    initialParents: initialData?.[0, $5fc53.PARENT_FIELD_TYPE] ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                    initialTeams: initialData?.[0, $5fc53.TEAMS_PLATFORM_CF_TYPE] ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                    initialGoals: initialData?.[0, $5fc53.GOALS_CF_TYPE] ?? $95c9fbd80a67ba2b$var$emptyFieldValue
                }
            });
        }).catch(()=>{
            dispatch({
                type: 'fetch-data-error'
            });
        });
    }, [
        fetchInitialData
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!loadingFilterFields) {
            dispatch({
                type: 'init'
            });
            initialiseDefaultData();
        }
    }, [
        initialiseDefaultData,
        loadingFilterFields,
        businessEntityId
    ]);
    // TODO: JFP-2824 | Suppressed to enable upgrade to ESLint v9 - please fix this if you can!
    const { fieldConfig: fieldConfig, resolvers: resolvers } = (0, $5uXOq.useMemo)(()=>{
        const fieldOptionsData = {
            priority: data?.initialPriorities ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
            issuetype: data?.initialIssueTypes ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
            status: data?.initialStatuses ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
            users: data?.initialUsers ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
            labels: data?.initialLabels ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
            components: data?.initialComponents ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
            [(0, $5fc53.CATEGORY_TYPE)]: data?.initialCategories ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
            [(0, $5fc53.SPRINT_TYPE)]: data?.initialSprints ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
            project: projectFieldData,
            [(0, $5fc53.FIX_VERSIONS_TYPE)]: data?.initialFixVersions ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
            [(0, $5fc53.PARENT_FIELD_TYPE)]: data?.initialParents ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
            [(0, $5fc53.TEAMS_PLATFORM_CF_TYPE)]: data?.initialTeams ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
            [(0, $5fc53.GOALS_CF_TYPE)]: data?.initialGoals ?? $95c9fbd80a67ba2b$var$emptyFieldValue
        };
        return (0, $1qi71.getFilterFieldConfigAndResolvers)({
            view: view,
            formatMessage: formatMessage,
            allFields: filterFields,
            allowedFieldTypes: allowedFieldTypes,
            fieldOptionsData: fieldOptionsData,
            fetchUsers: fetchUsers,
            fetchLabels: fetchLabels,
            fetchComponents: fetchComponents,
            fetchCategories: fetchCategories,
            fetchTeamsById: fetchTeamsById,
            ...fetchOptions,
            userResolver: userResolver.current
        });
    }, [
        data?.initialPriorities,
        data?.initialIssueTypes,
        data?.initialStatuses,
        data?.initialUsers,
        data?.initialLabels,
        data?.initialComponents,
        data?.initialCategories,
        data?.initialSprints,
        data?.initialFixVersions,
        data?.initialParents,
        data?.initialGoals,
        data?.initialTeams,
        projectFieldData,
        view,
        formatMessage,
        filterFields,
        allowedFieldTypes,
        fetchUsers,
        fetchLabels,
        fetchComponents,
        fetchCategories,
        fetchOptions,
        fetchTeamsById
    ]);
    return {
        fieldConfig: fieldConfig,
        resolvers: resolvers,
        loading: loadingData || loadingFilterFields || data == null
    };
};

});
parcelRegister("aJfd5", function(module, exports) {

$parcel$export(module.exports, "UserResolver", () => $c1905445333aa67f$export$723df28d03868f02);

var $2YZCu = parcelRequire("2YZCu");

var $7f4tk = parcelRequire("7f4tk");
class $c1905445333aa67f$export$723df28d03868f02 {
    constructor(){
        // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
        this.getUsersFromAccountId = (accountIds)=>{
            const recoveredFromCache = [];
            const missingFromCache = [];
            accountIds.forEach((accountId)=>{
                const user = this.cache.get(accountId);
                if (user) recoveredFromCache.push(user);
                else missingFromCache.push(accountId);
            });
            if (missingFromCache.length === 0) // @ts-expect-error - User is not assignable to type 'string'
            return Promise.resolve(recoveredFromCache);
            return (0, $7f4tk.default)(`/rest/api/2/user/bulk?maxResults=10&${missingFromCache.map((accountId)=>`accountId=${accountId}`).join('&')}`).then((response)=>response && response.values.length > 0 && // @ts-expect-error - TS2339 - Property 'forEach' does not exist on type '() => IterableIterator<Readonly<Partial<Diff<ResponseSuccess, Record<any, any>>> & { accountId: string | null; displayName: string; avatarUrls: { readonly "48x48"?: string | undefined; readonly "32x32"?: string | undefined; readonly "24x24"?: string | undefined; readonly "16x16"?: string | undefined; }; }>>'. | TS7006 - Parameter 'user' implicitly has an 'any' type.
                response.values.forEach((user)=>{
                    if (user) this.cache.set(user.accountId, user);
                })).then(()=>this.getUsersFromAccountId(accountIds)).catch((err)=>{
                (0, $2YZCu.default).safeErrorWithoutCustomerData('jwm.services.get-users', 'Failed to fetch users', err);
            });
        };
        this.cache = new Map();
    }
}

});

parcelRegister("1qi71", function(module, exports) {

$parcel$export(module.exports, "getFilterFieldConfigAndResolvers", () => $beea8d83023eb0fe$export$ba4f3d2149c2bf3b);

var $9XE6b = parcelRequire("9XE6b");

var $8QpSo = parcelRequire("8QpSo");

var $4R6GH = parcelRequire("4R6GH");

var $5fc53 = parcelRequire("5fc53");

var $dCm1o = parcelRequire("dCm1o");

var $gzkAf = parcelRequire("gzkAf");

var $gBF4Z = parcelRequire("gBF4Z");

var $7htvz = parcelRequire("7htvz");

var $j0h5m = parcelRequire("j0h5m");
const $beea8d83023eb0fe$export$fb8c90bfc4beaa59 = (0, $8QpSo.default)((users)=>{
    if ((users == null || !Array.isArray(users)) && (0, $4R6GH.fg)('prevent_user_transformation_on_non-array_input')) return [];
    // Remove this lint and ts ignore when 'prevent_user_transformation_on_non-array_input' gets clean up
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return users.reduce((acc, next)=>{
        acc.push({
            value: next.accountId || '',
            label: next.displayName,
            avatar: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(next, [
                'avatarUrls',
                '24x24'
            ], '')
        });
        return acc;
    }, []);
});
const $beea8d83023eb0fe$var$getType = (type)=>{
    switch(type){
        case 0, $5fc53.CATEGORY_TYPE:
            return (0, $gBF4Z.FieldType).CategorySelectFilter;
        case 0, $5fc53.PRIORITY_TYPE:
            return (0, $gBF4Z.FieldType).PrioritySelectFilter;
        case 0, $5fc53.ASSIGNEE_TYPE:
        case 0, $5fc53.REPORTER_TYPE:
        case 0, $5fc53.USER_CF_TYPE:
            return (0, $gBF4Z.FieldType).AvatarAsyncSelectFilter;
        case 0, $5fc53.ISSUE_TYPE:
        case 0, $5fc53.PARENT_FIELD_TYPE:
        case 0, $5fc53.TEAMS_PLATFORM_CF_TYPE:
            return (0, $gBF4Z.FieldType).AvatarSelectFilter;
        case 0, $5fc53.STATUS_TYPE:
            return (0, $gBF4Z.FieldType).LozengeSelectFilter;
        case 0, $5fc53.LABELS_TYPE:
        case 0, $5fc53.COMPONENTS_TYPE:
        case 0, $5fc53.FIX_VERSIONS_TYPE:
        case 0, $5fc53.SPRINT_TYPE:
            return (0, $gBF4Z.FieldType).AsyncSelectFilter;
        case 0, $5fc53.CREATED:
        case 0, $5fc53.UPDATED:
            return (0, $gBF4Z.FieldType).DateFilter;
        case 0, $5fc53.PROJECT_TYPE:
            return (0, $gBF4Z.FieldType).ProjectFilter;
        case 0, $5fc53.GOALS_CF_TYPE:
            return (0, $gBF4Z.FieldType).GoalsSelectFilter;
        default:
            return (0, $gBF4Z.FieldType).SelectFilter;
    }
};
const $beea8d83023eb0fe$var$getValues = (type, fieldOptionsData)=>{
    switch(type){
        case 0, $5fc53.ASSIGNEE_TYPE:
        case 0, $5fc53.REPORTER_TYPE:
        case 0, $5fc53.USER_CF_TYPE:
            return fieldOptionsData.users;
        default:
            return fieldOptionsData[type];
    }
};
const $beea8d83023eb0fe$var$isUserField = (type)=>{
    switch(type){
        case 0, $5fc53.ASSIGNEE_TYPE:
        case 0, $5fc53.REPORTER_TYPE:
        case 0, $5fc53.USER_CF_TYPE:
            return true;
        default:
            return false;
    }
};
const $beea8d83023eb0fe$var$isCustomField = (type)=>{
    switch(type){
        case 0, $5fc53.USER_CF_TYPE:
        case 0, $5fc53.PEOPLE_CF_TYPE:
        case 0, $5fc53.SELECT_CF_TYPE:
        case 0, $5fc53.MULTI_SELECT_CF_TYPE:
        case 0, $5fc53.MULTI_CHECKBOXES_CF_TYPE:
            return true;
        default:
            return false;
    }
};
const $beea8d83023eb0fe$var$createUserValueGetter = (userResolver)=>(0, $8QpSo.default)((accountIds)=>userResolver.getUsersFromAccountId(accountIds) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .then((response)=>$beea8d83023eb0fe$export$fb8c90bfc4beaa59(response)));
const $beea8d83023eb0fe$var$createTeamValueGetter = ({ fetchTeamsById: fetchTeamsById, options: options })=>(0, $8QpSo.default)((teamIds)=>{
        // if the team is already loaded not fetch the team data
        const teamsLoadedOptions = options.filter((option)=>option.value ? teamIds.includes(option.value) : false);
        if (teamsLoadedOptions.length === teamIds.length) return teamsLoadedOptions;
        const loadedTeamIds = teamsLoadedOptions.map((option)=>option.value);
        const teamIdsToFetch = teamsLoadedOptions.length ? teamIds.filter((teamId)=>!loadedTeamIds.includes(teamId)) : teamIds;
        return fetchTeamsById({
            teamIds: teamIdsToFetch
        });
    });
const $beea8d83023eb0fe$export$ba4f3d2149c2bf3b = ({ view: view, formatMessage: formatMessage, allowedFieldTypes: allowedFieldTypes, allFields: allFields, fieldOptionsData: fieldOptionsData, userResolver: userResolver, fetchUsers: fetchUsers, fetchLabels: fetchLabels, fetchComponents: fetchComponents, fetchCategories: fetchCategories, fetchStatuses: fetchStatuses, fetchPriorities: fetchPriorities, fetchIssueTypes: fetchIssueTypes, fetchSprints: fetchSprints, fetchFixVersions: fetchFixVersions, fetchParents: fetchParents, fetchGoals: fetchGoals, fetchTeams: fetchTeams, fetchTeamsById: fetchTeamsById })=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const fieldConfig = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const resolvers = {};
    if (allowedFieldTypes.has((0, $gzkAf.DATE_RANGE_TYPE))) // manually add dateRange to fieldConfig
    fieldConfig.dateRange = {
        label: formatMessage((0, $j0h5m.default).dateRangeLabel),
        type: (0, $gBF4Z.FieldType).DateFilter,
        fromLabel: formatMessage((0, $j0h5m.default).startDateLabel),
        toLabel: formatMessage((0, $j0h5m.default).dueDateLabel)
    };
    const fields = allFields.filter((field)=>allowedFieldTypes.has(field.type ?? ''));
    fields.forEach((field)=>{
        const { name: name, type: type, id: id } = field;
        const fieldType = type ?? '';
        const fieldValues = $beea8d83023eb0fe$var$getValues(fieldType, fieldOptionsData);
        fieldConfig[id] = {
            label: name,
            type: $beea8d83023eb0fe$var$getType(fieldType),
            placeholder: formatMessage((0, $j0h5m.default).filterPlaceholder),
            options: fieldValues?.options || [],
            totalCount: fieldValues?.totalCount || 0,
            isCustomField: $beea8d83023eb0fe$var$isCustomField(fieldType),
            fieldConfigVersion: 2
        };
        // issue type
        if (type === (0, $5fc53.ISSUE_TYPE)) {
            let options = fieldValues?.options || [];
            if (view === 'board') {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                options = (fieldValues?.options).filter((option)=>option.hierarchyLevel !== -1);
                fieldConfig[id].options = options;
            }
            if (fetchIssueTypes) {
                fieldConfig[id].loadOptions = fetchIssueTypes;
                fieldConfig[id].defaultOptions = options;
            }
        } else if ($beea8d83023eb0fe$var$isUserField(fieldType)) {
            fieldConfig[id].loadOptions = fetchUsers;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            resolvers[id] = $beea8d83023eb0fe$var$createUserValueGetter(userResolver);
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $7htvz.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $j0h5m.default).unassignedLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fieldType === (0, $5fc53.LABELS_TYPE)) {
            fieldConfig[id].loadOptions = fetchLabels;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $7htvz.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $j0h5m.default).noLabelsLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fieldType === (0, $5fc53.COMPONENTS_TYPE)) {
            fieldConfig[id].loadOptions = fetchComponents;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $7htvz.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $j0h5m.default).noComponentsLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fieldType === (0, $5fc53.CATEGORY_TYPE)) {
            fieldConfig[id].loadOptions = fetchCategories;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $7htvz.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $j0h5m.default).noCategoriesLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fieldType === (0, $5fc53.STATUS_TYPE) && fetchStatuses) {
            fieldConfig[id].loadOptions = fetchStatuses;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
        } else if (fieldType === (0, $5fc53.PRIORITY_TYPE) && fetchPriorities) {
            fieldConfig[id].loadOptions = fetchPriorities;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
        } else if (fieldType === (0, $5fc53.SPRINT_TYPE) && fetchSprints) {
            fieldConfig[id].loadOptions = fetchSprints;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $7htvz.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $j0h5m.default).noSprintLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fieldType === (0, $5fc53.FIX_VERSIONS_TYPE) && fetchFixVersions) {
            fieldConfig[id].loadOptions = fetchFixVersions;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $7htvz.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $j0h5m.default).noVersionLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fieldType === (0, $5fc53.PARENT_FIELD_TYPE) && fetchParents) {
            fieldConfig[id].loadOptions = fetchParents;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $7htvz.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $j0h5m.default).noParentLabel),
                    isEmptyOption: true,
                    ...(0, $dCm1o.isVisualRefreshEnabled)() && {
                        square: true
                    }
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fieldType === (0, $5fc53.GOALS_CF_TYPE) && fetchGoals) {
            fieldConfig[id].loadOptions = fetchGoals;
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $7htvz.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $j0h5m.default).noGoalLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fetchTeams && fieldType === (0, $5fc53.TEAMS_PLATFORM_CF_TYPE)) {
            fieldConfig[id].loadOptions = fetchTeams;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $7htvz.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $j0h5m.default).noTeamLabel),
                    isEmptyOption: true
                }
            ];
            if (fetchTeamsById) resolvers[id] = $beea8d83023eb0fe$var$createTeamValueGetter({
                fetchTeamsById: fetchTeamsById,
                options: fieldConfig[id].options
            });
            fieldConfig[id].totalCount += 1;
        }
    });
    return {
        fieldConfig: fieldConfig,
        resolvers: resolvers
    };
};

});
parcelRegister("gBF4Z", function(module, exports) {

$parcel$export(module.exports, "FieldType", () => $8ecd5c1ebfc76de6$export$ed12481c953b8653);
$parcel$export(module.exports, "isDateField", () => $8ecd5c1ebfc76de6$export$7d34c8548269835d);
const $8ecd5c1ebfc76de6$export$ed12481c953b8653 = {
    AsyncSelectFilter: 'AsyncSelectFilter',
    AvatarSelectFilter: 'AvatarSelectFilter',
    AvatarAsyncSelectFilter: 'AvatarAsyncSelectFilter',
    PaginatedAsyncSelectFilter: 'PaginatedAsyncSelectFilter',
    LozengeAsyncSelectFilter: 'LozengeAsyncSelectFilter',
    PaginatedLozengeAsyncSelectFilter: 'PaginatedLozengeAsyncSelectFilter',
    LozengeSelectFilter: 'LozengeSelectFilter',
    PrioritySelectFilter: 'PrioritySelectFilter',
    CategorySelectFilter: 'CategorySelectFilter',
    GoalsSelectFilter: 'GoalsSelectFilter',
    PaginatedAvatarAsyncSelectFilter: 'PaginatedAvatarAsyncSelectFilter',
    NumberFilter: 'NumberFilter',
    SelectFilter: 'SelectFilter',
    SearchFilter: 'SearchFilter',
    TextFilter: 'TextFilter',
    DateFilter: 'DateFilter',
    ProjectFilter: 'ProjectFilter'
};
const $8ecd5c1ebfc76de6$export$7d34c8548269835d = (field)=>field.type === $8ecd5c1ebfc76de6$export$ed12481c953b8653.DateFilter;

});

parcelRegister("j0h5m", function(module, exports) {

$parcel$export(module.exports, "default", () => $73773c42d63775af$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $73773c42d63775af$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    filterPlaceholder: {
        "id": "business-filters.controllers.field-config-v2.filter-placeholder",
        "defaultMessage": "Search"
    },
    dateRangeLabel: {
        "id": "business-filters.controllers.field-config-v2.date-range-label",
        "defaultMessage": "Date range"
    },
    startDateLabel: {
        "id": "business-filters.controllers.field-config-v2.start-date-label",
        "defaultMessage": "Start date"
    },
    dueDateLabel: {
        "id": "business-filters.controllers.field-config-v2.due-date-label",
        "defaultMessage": "Due date"
    },
    unassignedLabel: {
        "id": "business-filters.controllers.field-config-v2.unassigned-label",
        "defaultMessage": "Unassigned"
    },
    noLabelsLabel: {
        "id": "business-filters.controllers.field-config-v2.no-labels-label",
        "defaultMessage": "No label"
    },
    noCategoriesLabel: {
        "id": "business-filters.controllers.field-config-v2.no-categories-label",
        "defaultMessage": "No category"
    },
    noComponentsLabel: {
        "id": "business-filters.controllers.field-config-v2.no-components-label",
        "defaultMessage": "No component"
    },
    noSprintLabel: {
        "id": "business-filters.controllers.field-config-v2.no-sprint-label",
        "defaultMessage": "Backlog"
    },
    noVersionLabel: {
        "id": "business-filters.controllers.field-config-v2.no-version-label",
        "defaultMessage": "No version"
    },
    noParentLabel: {
        "id": "business-filters.controllers.field-config-v2.no-parent-label",
        "defaultMessage": "No parent"
    },
    noGoalLabel: {
        "id": "business-filters.controllers.field-config-v2.no-goal-label",
        "defaultMessage": "No goal"
    },
    noTeamLabel: {
        "id": "business-filters.controllers.field-config-v2.no-team-label",
        "defaultMessage": "No team"
    }
});

});



parcelRegister("cLe9v", function(module, exports) {

$parcel$export(module.exports, "useFieldConfig", () => $bad07c14bc3eb691$export$70da50df1be2dbe1);

var $5uXOq = parcelRequire("5uXOq");

var $3JOCw = parcelRequire("3JOCw");

var $hE5wF = parcelRequire("hE5wF");

var $ftuRD = parcelRequire("ftuRD");

var $1T2vX = parcelRequire("1T2vX");

var $2H8QW = parcelRequire("2H8QW");

var $2Lcoi = parcelRequire("2Lcoi");

var $aJfd5 = parcelRequire("aJfd5");

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");

var $koVbs = parcelRequire("koVbs");

var $5fc53 = parcelRequire("5fc53");

var $koeKL = parcelRequire("koeKL");

var $ieDtd = parcelRequire("ieDtd");
var $doZTA = parcelRequire("doZTA");

var $czmU8 = parcelRequire("czmU8");

var $84pWT = parcelRequire("84pWT");

var $8841m = parcelRequire("8841m");

var $1vUxa = parcelRequire("1vUxa");

var $e3P1V = parcelRequire("e3P1V");
const $bad07c14bc3eb691$var$MAX_NUMBER_OF_OPTIONS = 10;
const $bad07c14bc3eb691$var$useFilterMapper = true;
const $bad07c14bc3eb691$var$EMPTY_ARRAY = [];
const $bad07c14bc3eb691$var$EMPTY_USER_ARRAY = [];
const $bad07c14bc3eb691$var$EMPTY_COMPONENT_ARRAY = [];
const $bad07c14bc3eb691$var$EMPTY_CATEGORY_ARRAY = [];
const $bad07c14bc3eb691$export$1fe8227c57fa0d68 = ()=>({
        initialUsers: {
            data: $bad07c14bc3eb691$var$EMPTY_USER_ARRAY,
            isLoading: false
        },
        initialLabels: {
            data: $bad07c14bc3eb691$var$EMPTY_ARRAY,
            isLoading: false
        },
        initialComponents: {
            data: $bad07c14bc3eb691$var$EMPTY_COMPONENT_ARRAY,
            isLoading: false
        },
        initialCategories: {
            data: $bad07c14bc3eb691$var$EMPTY_CATEGORY_ARRAY,
            isLoading: false
        },
        projectKey: null
    });
const $bad07c14bc3eb691$export$74cea4b24a6bc9fa = $bad07c14bc3eb691$export$1fe8227c57fa0d68();
const $bad07c14bc3eb691$var$useForceUpdate = ()=>{
    const [, setValue] = (0, $5uXOq.useState)(0);
    return (0, $5uXOq.useCallback)(()=>setValue((value)=>value + 1), []);
};
const $bad07c14bc3eb691$export$70da50df1be2dbe1 = ({ allowedFieldTypes: allowedFieldTypes, allowedAliasFieldId: allowedAliasFieldId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [userResolver] = (0, $5uXOq.useState)(new (0, $aJfd5.UserResolver)());
    const forceUpdate = $bad07c14bc3eb691$var$useForceUpdate();
    const [priorityFieldConfig] = (0, $ftuRD.useIssueTypeFieldConfig)({
        screen: 'VIEW',
        issueTypeId: 'default',
        fieldId: 'priority'
    });
    const { data: issueTypeData, loading: loadingIssueTypesAndFields } = (0, $1T2vX.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const formattedCategoryOptions = (0, $5uXOq.useMemo)(()=>{
        const categoryOptions = issueTypeData.fields.find((field)=>field.type === (0, $5fc53.CATEGORY_TYPE))?.fieldConfig?.selectOptions ?? [];
        return categoryOptions.map(({ value: value })=>({
                label: value,
                value: value
            }));
    }, [
        issueTypeData
    ]);
    const { statuses: statuses, loading: loadingStatuses } = (0, $8841m.useProjectStatuses)();
    const [{ match: { params: { projectKey: projectKey } } }] = (0, $doZTA.useRouter)();
    const cloudId = (0, $koeKL.useCloudId)();
    const [jqlURLParam] = (0, $ieDtd.useQueryParam)((0, $hE5wF.FILTER_PARAM));
    const jqlURLParamRef = (0, $5uXOq.useRef)(jqlURLParam);
    const hydratedUsers = (0, $5uXOq.useRef)(null);
    const fetchInitialUsers = (0, $5uXOq.useCallback)(async ()=>{
        $bad07c14bc3eb691$export$74cea4b24a6bc9fa.initialUsers.isLoading = true;
        let users = [];
        const hydratedValues = jqlURLParamRef.current ? await (0, $czmU8.hydrateFilterValues)(cloudId, jqlURLParamRef.current) : null;
        if (hydratedValues !== null) {
            const transformedHydratedValues = (0, $84pWT.transformHydratedValues)(hydratedValues);
            hydratedUsers.current = transformedHydratedValues.users.options;
        }
        const url = `/rest/api/3/user/search?maxResults=${$bad07c14bc3eb691$var$MAX_NUMBER_OF_OPTIONS}&query=`;
        users = await (0, $7f4tk.default)(url);
        $bad07c14bc3eb691$export$74cea4b24a6bc9fa.initialUsers = {
            data: users,
            isLoading: false
        };
        forceUpdate();
        return users;
    }, [
        cloudId,
        forceUpdate
    ]);
    const fetchInitialLabels = (0, $5uXOq.useCallback)(async ()=>{
        const url = `/rest/api/3/label?maxResults=${$bad07c14bc3eb691$var$MAX_NUMBER_OF_OPTIONS}`;
        try {
            $bad07c14bc3eb691$export$74cea4b24a6bc9fa.initialLabels.isLoading = true;
            const response = await (0, $7f4tk.default)(url);
            const labels = response.values;
            $bad07c14bc3eb691$export$74cea4b24a6bc9fa.initialLabels = {
                data: labels,
                isLoading: false
            };
            forceUpdate();
            return labels;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'fetchFilterInitialLabels',
                    packageName: 'jiraBusinessFilters',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to fetch initial labels',
                    errorType: (0, $2H8QW.getErrorType)(err)
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        $bad07c14bc3eb691$export$74cea4b24a6bc9fa.initialLabels = {
            data: $bad07c14bc3eb691$var$EMPTY_ARRAY,
            isLoading: false
        };
        forceUpdate();
        return $bad07c14bc3eb691$var$EMPTY_ARRAY;
    }, [
        forceUpdate
    ]);
    const fetchUsers = (0, $5uXOq.useCallback)(async (query = '')=>{
        if (projectKey != null) {
            const url = `/rest/api/2/user/assignable/search?project=${projectKey}&maxResults=${$bad07c14bc3eb691$var$MAX_NUMBER_OF_OPTIONS}&query=${query}`;
            try {
                const response = await (0, $7f4tk.default)(url);
                return response;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (err) {
                (0, $jcw0u.default)({
                    meta: {
                        id: 'searchFilterUsers',
                        packageName: 'jiraBusinessFilters',
                        teamName: 'wanjel'
                    },
                    attributes: {
                        message: 'Failed to search users',
                        errorType: (0, $2H8QW.getErrorType)(err)
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        }
        return $bad07c14bc3eb691$var$EMPTY_USER_ARRAY;
    }, [
        projectKey
    ]);
    const fetchProjectComponents = (0, $5uXOq.useCallback)(async (query = '')=>{
        if (projectKey != null) try {
            const response = await (0, $2Lcoi.fetchComponents)({
                inputValue: query,
                autoCompleteUrl: `/rest/api/3/project/${projectKey}/component`,
                useFilterMapper: $bad07c14bc3eb691$var$useFilterMapper
            });
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'fetchFilterComponents',
                    packageName: 'jiraBusinessFilters',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to fetch components',
                    errorType: (0, $2H8QW.getErrorType)(err)
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return [];
    }, [
        projectKey
    ]);
    const fetchLabels = (0, $5uXOq.useCallback)((query = '')=>(0, $7f4tk.default)(`/rest/api/1.0/labels/suggest?query=${query}`).catch((err)=>{
            (0, $jcw0u.default)({
                meta: {
                    id: 'searchFilterLabels',
                    packageName: 'jiraBusinessFilters',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to search labels',
                    errorType: (0, $2H8QW.getErrorType)(err)
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
        }), []);
    const fetchProjectCategories = (0, $5uXOq.useCallback)((query = '')=>{
        // TODO Replace with back end fetch API
        const filteredCategoriesQuery = formattedCategoryOptions?.filter((categoryOption)=>categoryOption.label.toLowerCase().startsWith(query.toLowerCase()));
        return Promise.resolve(filteredCategoriesQuery ?? []);
    }, [
        formattedCategoryOptions
    ]);
    const { fetch: fetchInitialStoryPointsData, data: initialStoryPoints, loading: loadingStoryPoints } = (0, $1vUxa.useGroupItemValues)({
        groupFieldId: (0, $hE5wF.STORY_POINTS_ALIAS_FIELD_ID)
    });
    const { fetch: fetchInitialStoryPointsEstimateData, data: initialStoryPointsEstimate, loading: loadingStoryPointsEstimate } = (0, $1vUxa.useGroupItemValues)({
        groupFieldId: (0, $hE5wF.STORY_POINT_ESTIMATE_ALIAS_FIELD_ID)
    });
    (0, $5uXOq.useEffect)(()=>{
        if (allowedAliasFieldId != null && allowedAliasFieldId.has((0, $hE5wF.STORY_POINTS_ALIAS_FIELD_ID))) fetchInitialStoryPointsData();
    }, [
        allowedAliasFieldId,
        fetchInitialStoryPointsData
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (allowedAliasFieldId != null && allowedAliasFieldId.has((0, $hE5wF.STORY_POINT_ESTIMATE_ALIAS_FIELD_ID))) fetchInitialStoryPointsEstimateData();
    }, [
        allowedAliasFieldId,
        fetchInitialStoryPointsEstimateData
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (projectKey != null && // Initially fetch for everything if projectKey is updated or users is empty
        ($bad07c14bc3eb691$export$74cea4b24a6bc9fa.projectKey !== projectKey || $bad07c14bc3eb691$export$74cea4b24a6bc9fa.initialUsers.data === $bad07c14bc3eb691$var$EMPTY_USER_ARRAY)) {
            if ($bad07c14bc3eb691$export$74cea4b24a6bc9fa.initialUsers.isLoading === false) {
                $bad07c14bc3eb691$export$74cea4b24a6bc9fa.projectKey = projectKey;
                fetchInitialUsers();
            }
        }
    }, [
        fetchInitialUsers,
        fetchProjectComponents,
        projectKey,
        fetchInitialLabels,
        fetchProjectCategories,
        forceUpdate
    ]);
    const { data: initialUsers, isLoading: isLoadingUsers } = $bad07c14bc3eb691$export$74cea4b24a6bc9fa.initialUsers;
    const { data: initialLabels, isLoading: isLoadingLabels } = $bad07c14bc3eb691$export$74cea4b24a6bc9fa.initialLabels;
    const { data: initialComponents, isLoading: isLoadingComponents } = $bad07c14bc3eb691$export$74cea4b24a6bc9fa.initialComponents;
    const { data: initialCategories, isLoading: isLoadingCategories } = $bad07c14bc3eb691$export$74cea4b24a6bc9fa.initialCategories;
    const fieldOptionsData = (0, $5uXOq.useMemo)(()=>({
            priority: (0, $e3P1V.transformPriority)(priorityFieldConfig),
            issuetype: (0, $e3P1V.transformIssueType)(issueTypeData),
            status: (0, $e3P1V.transformStatuses)(statuses),
            users: (0, $e3P1V.transformUsers)(initialUsers),
            labels: (0, $e3P1V.transformLabels)(initialLabels),
            components: initialComponents,
            [(0, $5fc53.CATEGORY_TYPE)]: initialCategories,
            [(0, $hE5wF.STORY_POINTS_ALIAS_FIELD_ID)]: initialStoryPoints?.options || [],
            [(0, $hE5wF.STORY_POINT_ESTIMATE_ALIAS_FIELD_ID)]: initialStoryPointsEstimate?.options || []
        }), [
        priorityFieldConfig,
        issueTypeData,
        statuses,
        initialUsers,
        initialLabels,
        initialComponents,
        initialCategories,
        initialStoryPoints?.options,
        initialStoryPointsEstimate?.options
    ]);
    fieldOptionsData.users = (0, $5uXOq.useMemo)(()=>{
        if (hydratedUsers.current === null) return fieldOptionsData.users;
        return (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))([
            ...hydratedUsers.current ?? [],
            ...fieldOptionsData.users ?? []
        ], ({ value: value })=>value);
    }, [
        fieldOptionsData
    ]);
    const { fieldConfig: fieldConfig, resolvers: resolvers } = (0, $e3P1V.getFilterFieldConfigAndResolvers)({
        formatMessage: formatMessage,
        allowedFieldTypes: allowedFieldTypes,
        allowedAliasFieldId: allowedAliasFieldId,
        allFields: issueTypeData.fields,
        fieldOptionsData: fieldOptionsData,
        fetchUsers: (query)=>fetchUsers(query).then((users)=>(0, $e3P1V.transformUsers)(users || [])),
        fetchLabels: (query)=>fetchLabels(query).then((labels)=>labels ? (0, $e3P1V.transformLabelSuggestions)(labels) : []),
        fetchComponents: (query)=>fetchProjectComponents(query).then((components)=>components),
        fetchCategories: (query)=>fetchProjectCategories(query).then((categoriesResponse)=>categoriesResponse),
        userResolver: userResolver
    });
    const fetching = isLoadingUsers || isLoadingLabels || isLoadingComponents || isLoadingCategories || loadingStoryPoints || loadingStoryPointsEstimate;
    return {
        fieldConfig: fieldConfig,
        resolvers: resolvers,
        loading: loadingIssueTypesAndFields || loadingStatuses || fetching
    };
};

});
parcelRegister("2H8QW", function(module, exports) {

$parcel$export(module.exports, "getErrorType", () => $3122aab38ac46d24$export$e19f9f08a6d79fd2);

var $jJZqs = parcelRequire("jJZqs");
const $3122aab38ac46d24$export$7453182ebe5973d4 = 'APOLLO_NETWORK_ERROR';
const $3122aab38ac46d24$export$9705762bba4e9e25 = 'NULL_OR_UNDEFINED';
const $3122aab38ac46d24$export$d46a05f8561f868a = 'OTHER';
const $3122aab38ac46d24$export$c748438cec453c9f = {
    FAILED_TO_FETCH: 'Failed to fetch',
    NETWORK_ERROR: 'NetworkError when attempting to fetch resource.',
    NETWORK_REQUEST_FAILED: 'Network request failed',
    NETWORK_CONNECTION_LOST: 'The network connection was lost.',
    NETWORK_CONNECTION_ERROR: 'upstream connect error or disconnect/reset before headers. reset reason: connection',
    UNEXPECTED_ERROR_OCCURRED: 'Response ended with an error message: An unexpected error occurred',
    ABORTED: 'operation was aborted.',
    CANCELLED: 'cancelled',
    TIMEOUT: 'The request timed out.'
};
const $3122aab38ac46d24$var$isApolloClientNetworkError = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
error)=>error.networkError !== undefined && error.networkError !== null;
const $3122aab38ac46d24$export$e19f9f08a6d79fd2 = (error)=>{
    if (error == null) return $3122aab38ac46d24$export$9705762bba4e9e25;
    const message = String(error instanceof Error ? error.message : error).trim();
    if (error instanceof (0, $jJZqs.default)) {
        const { statusCode: statusCode } = error;
        if (statusCode) return `FETCH_ERROR_${statusCode}`;
    }
    if ($3122aab38ac46d24$var$isApolloClientNetworkError(error)) return $3122aab38ac46d24$export$7453182ebe5973d4;
    const entry = Object.entries($3122aab38ac46d24$export$c748438cec453c9f).find((arrayItem)=>String(arrayItem[1]).toLowerCase() === message.toLowerCase());
    return entry ? entry[0] : $3122aab38ac46d24$export$d46a05f8561f868a;
};

});

parcelRegister("2Lcoi", function(module, exports) {

$parcel$export(module.exports, "fetchComponents", () => $14f8d378ed2868dc$export$4f703ddb7c8cc5b3);

var $ebyGx = parcelRequire("ebyGx");

var $2H8QW = parcelRequire("2H8QW");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $lb7V6 = parcelRequire("lb7V6");
const $14f8d378ed2868dc$export$4f703ddb7c8cc5b3 = ({ inputValue: inputValue, autoCompleteUrl: autoCompleteUrl, useFilterMapper: useFilterMapper, queryParameters: queryParameters })=>{
    const mapperFunction = useFilterMapper === true ? (0, $lb7V6.mapComponentsToFilterOptions) : (0, $lb7V6.mapComponentsToOptions);
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify({
        query: inputValue,
        ...queryParameters
    });
    return (0, $eusud.performGetRequest)(`${autoCompleteUrl}?${query}`).then((response)=>mapperFunction(response.values)).catch((error)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'fetchProjectComponents',
                packageName: 'jiraBusinessFetchComponents',
                teamName: 'wanjel'
            },
            attributes: {
                message: 'Failed to fetch jwm project components',
                errorType: (0, $2H8QW.getErrorType)(error)
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    });
};

});
parcelRegister("lb7V6", function(module, exports) {

$parcel$export(module.exports, "mapComponentsToOptions", () => $4c5d47ac0f899709$export$85e44418187c2c1e);
$parcel$export(module.exports, "mapComponentsToFilterOptions", () => $4c5d47ac0f899709$export$b4ef58d3e943e4d5);
const $4c5d47ac0f899709$export$85e44418187c2c1e = (components)=>components.map(({ id: id, componentId: componentId, name: name })=>({
            label: name,
            value: componentId !== undefined ? String(componentId) : String(id)
        }));
const $4c5d47ac0f899709$export$b4ef58d3e943e4d5 = (components)=>components.map(({ name: name })=>({
            label: name,
            value: name
        }));

});


parcelRegister("1vUxa", function(module, exports) {

$parcel$export(module.exports, "useGroupItemValues", () => $f2df8273d684a2c0$export$f05af123f98299b0);

var $5uXOq = parcelRequire("5uXOq");

var $ccvFs = parcelRequire("ccvFs");

var $5YBrl = parcelRequire("5YBrl");

var $jlq4V = parcelRequire("jlq4V");

var $koVbs = parcelRequire("koVbs");

var $g31qf = parcelRequire("g31qf");

var $baeZQ = parcelRequire("baeZQ");
const $f2df8273d684a2c0$var$reducer = (state, action)=>{
    switch(action.type){
        case 'loading':
            return {
                loading: true
            };
        case 'success':
            return {
                loading: false,
                data: action.payload
            };
        case 'error':
            return {
                loading: false,
                data: null
            };
        default:
            return state;
    }
};
const $f2df8273d684a2c0$export$f05af123f98299b0 = ({ groupFieldId: groupFieldId })=>{
    const [state, dispatch] = (0, $5uXOq.useReducer)($f2df8273d684a2c0$var$reducer, {
        loading: false
    });
    const jqlContext = (0, $5YBrl.useJqlContext)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const fetchDataAbortable = (0, $ccvFs.useAbortable)((0, $g31qf.fetchGroupItemValues));
    const fetch = (0, $5uXOq.useCallback)(async ()=>{
        try {
            dispatch({
                type: 'loading'
            });
            const response = await fetchDataAbortable(groupFieldId, jqlContext);
            if (response.data?.items == null) throw new (0, $jlq4V.GraphQLErrors)(response.errors);
            dispatch({
                type: 'success',
                payload: (0, $baeZQ.transformInitialData)({
                    data: response.data,
                    formatMessage: formatMessage
                })
            });
        } catch (error) {
            if (error === (0, $ccvFs.ABORTED)) return;
            dispatch({
                type: 'error'
            });
        }
    }, [
        fetchDataAbortable,
        formatMessage,
        groupFieldId,
        jqlContext
    ]);
    return {
        fetch: fetch,
        data: state.data,
        loading: state.loading
    };
};

});
parcelRegister("ccvFs", function(module, exports) {

$parcel$export(module.exports, "ABORTED", () => $e04e223192d877be$export$23e29024ea698a35);
$parcel$export(module.exports, "useAbortable", () => $e04e223192d877be$export$a487c7eb4387f959);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $5uXOq = parcelRequire("5uXOq");
const $e04e223192d877be$export$23e29024ea698a35 = Symbol('ABORTED');
const $e04e223192d877be$export$a487c7eb4387f959 = (fetch)=>{
    const prevControllerRef = (0, $5uXOq.useRef)(null);
    return (0, $5uXOq.useCallback)((...args)=>{
        if (prevControllerRef.current) prevControllerRef.current.abort();
        const controller = new AbortController();
        prevControllerRef.current = controller;
        return fetch(controller.signal, ...args).catch((error)=>{
            if (controller.signal.aborted) throw $e04e223192d877be$export$23e29024ea698a35;
            else throw error;
        });
    }, [
        fetch
    ]);
};

});

parcelRegister("g31qf", function(module, exports) {

$parcel$export(module.exports, "fetchGroupItemValues", () => $71087c8bd1916bd2$export$7e6e0c3f4468ce45);

var $jcw0u = parcelRequire("jcw0u");

var $fZneA = parcelRequire("fZneA");

var $eusud = parcelRequire("eusud");

const $71087c8bd1916bd2$var$MAX_NUMBER_OF_OPTIONS = 20; // min number to render two rows
const $71087c8bd1916bd2$export$7e6e0c3f4468ce45 = async (signal, groupFieldId, jqlContext)=>{
    try {
        const variables = {
            fieldId: groupFieldId,
            first: $71087c8bd1916bd2$var$MAX_NUMBER_OF_OPTIONS,
            jql: jqlContext
        };
        const response = await (0, $eusud.performPostRequest)('/rest/gira/1/?operation=JWMFilterValuesByGroupItems', {
            body: JSON.stringify({
                query: (0, $626c877b75948b48$export$a48313dd44fc9855),
                variables: variables
            })
        });
        return response;
    } catch (error) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        if (!(0, $fZneA.isHttpClientErrorResponse)(error) && !signal.aborted) (0, $jcw0u.default)({
            meta: {
                id: 'initializeFilterGroupItemsData',
                packageName: 'jiraBusinessFilters',
                teamName: 'wanjel'
            },
            attributes: {
                message: 'Failed to initialize filter data using the group query'
            },
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});
const $626c877b75948b48$export$a48313dd44fc9855 = `
query JWMFilterValuesByGroupItems($fieldId: ID!, $jql: String!, $first: Int!) {
  items: jwmItemGroups(jql: $jql, groupByFieldId: $fieldId, fieldIds: [], first: $first) {
    totalCount
    edges {
      node {
        id
        field {
          __typename
          ... on FloatCustomField {
            floatValue
          }
        }
      }
    }
  }
}
`;


parcelRegister("baeZQ", function(module, exports) {

$parcel$export(module.exports, "transformInitialData", () => $a3e52c0a295405a4$export$93219b8691fe49a0);

var $9D5f1 = parcelRequire("9D5f1");
const $a3e52c0a295405a4$export$93219b8691fe49a0 = ({ data: data, formatMessage: formatMessage })=>({
        totalCount: data.items.totalCount,
        options: data.items.edges.map((edge)=>{
            if (edge.node.field.floatValue == null) return {
                value: null,
                label: formatMessage((0, $9D5f1.default).noneOption)
            };
            const stringFloatValue = String(edge.node.field.floatValue);
            return {
                value: stringFloatValue,
                label: stringFloatValue
            };
        })
    });

});
parcelRegister("9D5f1", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff2b830268d99634$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ff2b830268d99634$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noneOption: {
        "id": "business-filters.controllers.group-item-values.none-option",
        "defaultMessage": "None"
    }
});

});



parcelRegister("e3P1V", function(module, exports) {

$parcel$export(module.exports, "transformPriority", () => $b808701b322de4e8$export$1b9f55a39456e911);
$parcel$export(module.exports, "transformIssueType", () => $b808701b322de4e8$export$96520244689f81c1);
$parcel$export(module.exports, "transformStatuses", () => $b808701b322de4e8$export$20a57a5ec025f2d);
$parcel$export(module.exports, "transformUsers", () => $b808701b322de4e8$export$fb8c90bfc4beaa59);
$parcel$export(module.exports, "transformLabels", () => $b808701b322de4e8$export$c072126708d93f04);
$parcel$export(module.exports, "transformLabelSuggestions", () => $b808701b322de4e8$export$cdfcc40760c1a4f8);
$parcel$export(module.exports, "getFilterFieldConfigAndResolvers", () => $b808701b322de4e8$export$ba4f3d2149c2bf3b);

var $9XE6b = parcelRequire("9XE6b");

var $8QpSo = parcelRequire("8QpSo");

var $hE5wF = parcelRequire("hE5wF");

var $5fc53 = parcelRequire("5fc53");

var $4R6GH = parcelRequire("4R6GH");

var $gzkAf = parcelRequire("gzkAf");

var $gBF4Z = parcelRequire("gBF4Z");

var $7htvz = parcelRequire("7htvz");

var $6S22M = parcelRequire("6S22M");
const $b808701b322de4e8$export$1b9f55a39456e911 = (0, $8QpSo.default)((priorityFieldConfig)=>[
        ...priorityFieldConfig?.options || []
    ].reduce((acc, next)=>{
        acc.push({
            value: next.name,
            label: next.name,
            avatar: next.iconUrl || ''
        });
        return acc;
    }, []));
const $b808701b322de4e8$export$96520244689f81c1 = (0, $8QpSo.default)((issueTypeData)=>issueTypeData.issueTypes.reduce((acc, next)=>{
        acc.push({
            value: next.id,
            label: next.name,
            id: next.id,
            avatar: next.avatarUrl,
            square: true
        });
        return acc;
    }, []));
const $b808701b322de4e8$export$20a57a5ec025f2d = (0, $8QpSo.default)((statuses)=>statuses.reduce((acc, next)=>{
        acc.push({
            value: next.untranslatedName,
            label: next.name,
            categoryId: next.statusCategory.id,
            // Board needs the status id as number for client side filtering
            id: Number(next.id)
        });
        return acc;
    }, []));
const $b808701b322de4e8$export$fb8c90bfc4beaa59 = (0, $8QpSo.default)((users)=>users.reduce((acc, next)=>{
        acc.push({
            value: next.accountId || '',
            label: next.displayName,
            avatar: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(next, [
                'avatarUrls',
                '24x24'
            ], '')
        });
        return acc;
    }, []));
const $b808701b322de4e8$export$c072126708d93f04 = (0, $8QpSo.default)((labels)=>labels.reduce((acc, next)=>{
        acc.push({
            value: next || '',
            label: next
        });
        return acc;
    }, []));
const $b808701b322de4e8$export$cdfcc40760c1a4f8 = (0, $8QpSo.default)((labels)=>labels?.suggestions.reduce((acc, next)=>{
        acc.push({
            value: next.label || '',
            label: next.label
        });
        return acc;
    }, []));
const $b808701b322de4e8$var$getType = ({ type: type })=>{
    switch(type){
        case 0, $5fc53.PRIORITY_TYPE:
            return (0, $gBF4Z.FieldType).PrioritySelectFilter;
        case 0, $5fc53.ASSIGNEE_TYPE:
        case 0, $5fc53.REPORTER_TYPE:
        case 0, $5fc53.USER_CF_TYPE:
        case 0, $5fc53.PEOPLE_CF_TYPE:
            return (0, $gBF4Z.FieldType).AvatarAsyncSelectFilter;
        case 0, $5fc53.ISSUE_TYPE:
            return (0, $gBF4Z.FieldType).AvatarSelectFilter;
        case 0, $5fc53.STATUS_TYPE:
            return (0, $gBF4Z.FieldType).LozengeSelectFilter;
        case 0, $5fc53.LABELS_TYPE:
        case 0, $5fc53.COMPONENTS_TYPE:
        case 0, $5fc53.SELECT_CF_TYPE:
        case 0, $5fc53.MULTI_SELECT_CF_TYPE:
            return (0, $gBF4Z.FieldType).AsyncSelectFilter;
        case 0, $5fc53.CREATED:
        case 0, $5fc53.UPDATED:
        case 0, $5fc53.DATE_CF_TYPE:
            return (0, $gBF4Z.FieldType).DateFilter;
        case 0, $5fc53.CATEGORY_TYPE:
            return (0, $gBF4Z.FieldType).CategorySelectFilter;
        case 0, $5fc53.NUMBER_CF_TYPE:
        case 0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE:
        default:
            return (0, $gBF4Z.FieldType).SelectFilter;
    }
};
const $b808701b322de4e8$var$getSelectCustomFieldValues = (field)=>(field?.fieldConfig?.selectOptions ?? []).map(({ value: value })=>({
            label: value,
            value: value
        }));
const $b808701b322de4e8$var$getValues = ({ type: type, fieldOptionsData: fieldOptionsData, field: field, aliasFieldId: aliasFieldId })=>{
    switch(type){
        case 0, $5fc53.ASSIGNEE_TYPE:
        case 0, $5fc53.REPORTER_TYPE:
        case 0, $5fc53.USER_CF_TYPE:
        case 0, $5fc53.PEOPLE_CF_TYPE:
            return fieldOptionsData.users;
        case 0, $5fc53.SELECT_CF_TYPE:
        case 0, $5fc53.MULTI_SELECT_CF_TYPE:
        case 0, $5fc53.MULTI_CHECKBOXES_CF_TYPE:
            return $b808701b322de4e8$var$getSelectCustomFieldValues(field);
        case 0, $5fc53.NUMBER_CF_TYPE:
            if (aliasFieldId === (0, $hE5wF.STORY_POINTS_ALIAS_FIELD_ID)) return fieldOptionsData[0, $hE5wF.STORY_POINTS_ALIAS_FIELD_ID];
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return fieldOptionsData[type];
        case 0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE:
            return fieldOptionsData[0, $hE5wF.STORY_POINT_ESTIMATE_ALIAS_FIELD_ID];
        default:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return fieldOptionsData[type];
    }
};
const $b808701b322de4e8$var$isUserField = (type)=>{
    switch(type){
        case 0, $5fc53.ASSIGNEE_TYPE:
        case 0, $5fc53.REPORTER_TYPE:
        case 0, $5fc53.USER_CF_TYPE:
        case 0, $5fc53.PEOPLE_CF_TYPE:
            return true;
        default:
            return false;
    }
};
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
const $b808701b322de4e8$var$isCustomField = (type)=>(0, $gzkAf.EXTRA_CUSTOM_FIELD_TYPES).has(type);
const $b808701b322de4e8$var$createUserValueGetter = (userResolver)=>(0, $8QpSo.default)((accountIds)=>// @ts-expect-error - TS7006 - Parameter 'response' implicitly has an 'any' type.
        userResolver.getUsersFromAccountId(accountIds).then((response)=>$b808701b322de4e8$export$fb8c90bfc4beaa59(response)));
const $b808701b322de4e8$export$ba4f3d2149c2bf3b = ({ formatMessage: formatMessage, allowedFieldTypes: allowedFieldTypes, allowedAliasFieldId: allowedAliasFieldId = new Set(), allFields: allFields, fieldOptionsData: fieldOptionsData, fetchUsers: fetchUsers, fetchLabels: fetchLabels, fetchComponents: fetchComponents, fetchCategories: fetchCategories, userResolver: userResolver })=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const fieldConfig = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const resolvers = {};
    if (allowedFieldTypes.has((0, $gzkAf.DATE_RANGE_TYPE))) // manually add dateRange to fieldConfig
    fieldConfig.dateRange = {
        label: formatMessage((0, $6S22M.default).dateRangeLabel),
        type: (0, $gBF4Z.FieldType).DateFilter
    };
    const fields = allFields.filter((field)=>allowedFieldTypes.has(field.type ?? '') || allowedAliasFieldId.has(field.aliasFieldId || ''));
    fields.forEach((field)=>{
        const { name: name, type: type, id: id, aliasFieldId: aliasFieldId } = field;
        // if the type is unsupported
        // or it's the start date field (which is handled separately as 'date range')
        // then skip
        if (type == null || aliasFieldId === (0, $hE5wF.START_DATE_ALIAS_FIELD_ID)) return;
        const selectType = $b808701b322de4e8$var$getType({
            type: type
        });
        const shouldAddIsSearchableInJql = (0, $4R6GH.fg)('jira_issue_field_searchable_in_jql_data_fetcher') && typeof field.isSearchableInJql === 'boolean';
        fieldConfig[id] = {
            systemType: type,
            label: name,
            type: selectType,
            placeholder: formatMessage((0, $6S22M.default).filterPlaceholder),
            options: $b808701b322de4e8$var$getValues({
                type: type,
                fieldOptionsData: fieldOptionsData,
                field: field,
                aliasFieldId: aliasFieldId
            }),
            isCustomField: $b808701b322de4e8$var$isCustomField(type),
            ...shouldAddIsSearchableInJql && {
                isSearchableInJql: field.isSearchableInJql
            },
            fieldConfigVersion: 1
        };
        if (aliasFieldId != null && allowedAliasFieldId.has(aliasFieldId)) fieldConfig[id].aliasFieldId = aliasFieldId;
        if (type === (0, $5fc53.ISSUE_TYPE)) fieldConfig[id].label = formatMessage((0, $6S22M.default).typeLabel);
        if ($b808701b322de4e8$var$isUserField(type)) {
            fieldConfig[id].loadOptions = fetchUsers;
            fieldConfig[id].defaultOptions = $b808701b322de4e8$var$getValues({
                type: type,
                fieldOptionsData: fieldOptionsData
            });
            resolvers[id] = $b808701b322de4e8$var$createUserValueGetter(userResolver);
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: 'EMPTY',
                    label: formatMessage((0, $6S22M.default).unassignedLabel),
                    isEmptyOption: true
                }
            ];
        }
        if (type === (0, $5fc53.LABELS_TYPE)) {
            fieldConfig[id].loadOptions = fetchLabels;
            fieldConfig[id].defaultOptions = $b808701b322de4e8$var$getValues({
                type: type,
                fieldOptionsData: fieldOptionsData
            });
        }
        if (type === (0, $5fc53.COMPONENTS_TYPE)) {
            fieldConfig[id].loadOptions = fetchComponents;
            fieldConfig[id].defaultOptions = $b808701b322de4e8$var$getValues({
                type: type,
                fieldOptionsData: fieldOptionsData
            });
        }
        if (type === (0, $5fc53.CATEGORY_TYPE)) {
            fieldConfig[id].loadOptions = fetchCategories;
            fieldConfig[id].defaultOptions = $b808701b322de4e8$var$getValues({
                type: type,
                fieldOptionsData: fieldOptionsData
            });
        }
        if (type === (0, $5fc53.SELECT_CF_TYPE) || type === (0, $5fc53.MULTI_SELECT_CF_TYPE) || type === (0, $5fc53.MULTI_CHECKBOXES_CF_TYPE)) fieldConfig[id].options = [
            ...fieldConfig[id].options,
            {
                value: (0, $7htvz.EMPTY_FILTER_VALUE),
                label: formatMessage((0, $6S22M.default).noneOption),
                isEmptyOption: true
            }
        ];
    });
    return {
        fieldConfig: fieldConfig,
        resolvers: resolvers
    };
};

});
parcelRegister("6S22M", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0167d244ddce5b9$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c0167d244ddce5b9$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    filterPlaceholder: {
        "id": "business-filters.controllers.field-config.filter-placeholder",
        "defaultMessage": "Search"
    },
    dateRangeLabel: {
        "id": "business-filters.controllers.field-config.date-range-label",
        "defaultMessage": "Date range"
    },
    typeLabel: {
        "id": "business-filters.controllers.field-config.type-label",
        "defaultMessage": "Type"
    },
    unassignedLabel: {
        "id": "business-filters.controllers.field-config.unassigned-label",
        "defaultMessage": "Unassigned"
    },
    noneOption: {
        "id": "business-filters.controllers.field-config.none-option",
        "defaultMessage": "None"
    }
});

});




parcelRegister("2RV6Z", function(module, exports) {

$parcel$export(module.exports, "deserialiseJql", () => $42cbf7cea9b7c40a$export$214464255b766962);

var $3dHKF = parcelRequire("3dHKF");

var $2nvJN = parcelRequire("2nvJN");

var $pyK8a = parcelRequire("pyK8a");

var $f9ece = parcelRequire("f9ece");

var $bv7J5 = parcelRequire("bv7J5");
var $eK6AG = parcelRequire("eK6AG");
var $bzbto = parcelRequire("bzbto");

var $5fc53 = parcelRequire("5fc53");

var $gBF4Z = parcelRequire("gBF4Z");

var $7htvz = parcelRequire("7htvz");
const $42cbf7cea9b7c40a$var$START_DATE_JQL = 'Start date[Date]';
const $42cbf7cea9b7c40a$var$EMPTY = 'EMPTY';
// some filters should display options retrieved from the URL parameters even when they are not returned amongst the useFieldConfig field values
const $42cbf7cea9b7c40a$var$shouldIncludeUnknownOption = (filterField)=>{
    const allowedFieldTypes = new Set([
        (0, $5fc53.COMPONENTS_TYPE),
        (0, $5fc53.LABELS_TYPE),
        (0, $5fc53.PRIORITY_TYPE),
        (0, $5fc53.CATEGORY_TYPE),
        (0, $5fc53.PARENT_FIELD_TYPE)
    ]);
    return allowedFieldTypes.has(filterField?.type ?? '');
};
const $42cbf7cea9b7c40a$var$getFieldIdFromJql = (rawFieldName, getShouldConvertCustomField)=>{
    const fieldName = (0, (/*@__PURE__*/$parcel$interopDefault($2nvJN)))(rawFieldName, '"');
    const shouldConvertCustomField = getShouldConvertCustomField ? getShouldConvertCustomField(fieldName) : true;
    // `cf[id]` -> `customfield_${id}`.
    if (fieldName.indexOf('cf[') === 0 && shouldConvertCustomField) {
        const extraction = new RegExp(/cf\[(.+)\]/).exec(fieldName);
        if (!extraction) return fieldName;
        const fieldId = extraction[1];
        return `customfield_${fieldId}`;
    }
    const startDateJql = $42cbf7cea9b7c40a$var$START_DATE_JQL;
    // update this if we add a start date or due date filter
    if (fieldName === startDateJql || fieldName === 'due') return 'dateRange';
    return fieldName;
};
const $42cbf7cea9b7c40a$var$transformIntoOptions = async (list, field, resolver, filterField)=>{
    if (resolver && typeof resolver === 'function') return resolver(list);
    const allowUnknownOption = $42cbf7cea9b7c40a$var$shouldIncludeUnknownOption(filterField);
    return list.map((value)=>{
        if (field && !(0, $gBF4Z.isDateField)(field) && Array.isArray(field.options)) {
            const optionInField = field.options.find((option)=>{
                if ((option == null || option.value == null) && !option.isEmptyOption) return null;
                if (option.isEmptyOption) return value === $42cbf7cea9b7c40a$var$EMPTY;
                return option.value === value;
            });
            if (!optionInField && allowUnknownOption) return {
                value: value,
                label: value
            };
            return optionInField;
        }
        return undefined;
    }).filter((item)=>item != null && 'value' in item);
};
class $42cbf7cea9b7c40a$export$5299115fe71e8b39 extends (0, $bv7J5.AbstractJastVisitor) {
    constructor(fieldConfig, filterFields, resolvers){
        super(), this.getOption = (fieldName, items)=>$42cbf7cea9b7c40a$var$transformIntoOptions(items, this.fieldConfig[fieldName], this.resolvers[fieldName], this.filterFields.find((field)=>field.id === fieldName)), this.visitCompoundClause = async (compoundClause)=>{
            const clauseMap = {};
            const operator = compoundClause.operator.value;
            if (operator === (0, $3cef51f82b2cbe1d$export$6d6d48d210d3ca97)) {
                const clausePromises = await Promise.all(compoundClause.clauses.map((clause)=>clause.accept(this)));
                return clausePromises.reduce((result, clause)=>this.aggregateResultSync(clause, result), clauseMap);
            }
            throw new Error(`JQL contains invalid operator between clauses: ${operator}`);
        }, this.parseDateOperand = (operator, operand)=>{
            if (operand?.operandType === (0, $49b29ef7baa2a152$export$38accfc5a5d1c113)) {
                let date = (0, $f9ece.default)(new Date(operand.value), 'UTC', 'yyyy-MM-dd');
                if (operator.value === (0, $bzbto.OPERATOR_LT)) date = (0, $f9ece.default)((0, $pyK8a.default)(new Date(operand.value), 1), 'UTC', 'yyyy-MM-dd');
                const dateType = operator.value === (0, $bzbto.OPERATOR_LT) ? 'to' : 'from';
                return {
                    value: {
                        [dateType]: date
                    }
                };
            }
            throw new Error(`JQL cannot parse date operand type: ${operand.operandType}`);
        }, this.parseSelectOperand = async (fieldName, operand)=>{
            if (operand?.operandType === (0, $49b29ef7baa2a152$export$fabec4aebba3f4df)) {
                const optionPromises = operand.values.flatMap((value)=>this.parseSelectOperand(fieldName, value));
                return (await Promise.all(optionPromises)).flatMap((option)=>option);
            }
            if (operand?.operandType === (0, $49b29ef7baa2a152$export$38accfc5a5d1c113)) return this.getOption(fieldName, [
                operand.value
            ]);
            if (operand?.operandType === (0, $49b29ef7baa2a152$export$f6049126fd97001f)) return [
                {
                    isEmptyOption: true,
                    value: (0, $7htvz.EMPTY_FILTER_VALUE),
                    label: ''
                }
            ];
            throw new Error(`JQL cannot parse select operand type: ${operand.operandType}`);
        }, this.visitTerminalClause = async (terminalClause)=>{
            const { field: field, operand: operand, operator: operator } = terminalClause;
            if (!operand || !operator) return Promise.resolve({});
            const getShouldConvertCustomField = (fieldName)=>// should convert cf[] -> customfield_ if it's not a field from version 2
                !(this.fieldConfig[fieldName] && this.fieldConfig[fieldName].fieldConfigVersion === 2);
            const fieldName = $42cbf7cea9b7c40a$var$getFieldIdFromJql(field.value, getShouldConvertCustomField);
            if (!Object.keys(this.fieldConfig).includes(fieldName)) throw new Error(`JQL contains unsupported fields: ${fieldName}`);
            let value = [];
            if (operator.value === (0, $bzbto.OPERATOR_GT_EQUALS) || operator.value === (0, $bzbto.OPERATOR_LT)) value = this.parseDateOperand(operator, operand);
            else if (operator.value === (0, $bzbto.OPERATOR_EQUALS) || operator.value === (0, $bzbto.OPERATOR_IN)) value = await this.parseSelectOperand(fieldName, operand);
            else throw new Error(`JQL contains unsupported operator in terminal clause: ${operator.value}`);
            return {
                [fieldName]: value
            };
        };
        this.fieldConfig = fieldConfig;
        this.filterFields = filterFields;
        this.resolvers = resolvers;
    }
    visitNotClause() {
        throw new Error('JQL contains invalid clause: NOT');
    }
    defaultResult() {
        return Promise.resolve({});
    }
    /**
	 * @param aggregate new ClauseMap to add into nextResult
	 * @param nextResult ClauseMap with previous results
	 * @returns ClauseMap with the merged results adding the aggregate at the end
	 */ async aggregateResult(aggregate, nextResult) {
        // First parameter is the object where we want to add the values and the second the new values to merge into the first object.
        return (0, (/*@__PURE__*/$parcel$interopDefault($3dHKF)))(await nextResult, await aggregate, (destValue, srcValue)=>{
            if (Array.isArray(srcValue)) return srcValue.concat(destValue ?? []);
            return undefined;
        });
    }
    aggregateResultSync(aggregate, nextResult) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($3dHKF)))(nextResult, aggregate, (destValue, srcValue)=>{
            if (Array.isArray(srcValue)) return srcValue.concat(destValue ?? []);
            return undefined;
        });
    }
}
const $42cbf7cea9b7c40a$export$214464255b766962 = async (jql, fieldConfig, filterFields, resolvers)=>{
    // Create the syntax tree for the filters JQL
    const builder = new (0, $eK6AG.JastBuilder)();
    const jast = builder.build(jql);
    if (jast.query?.orderBy != null) throw new Error('JQL contains unsupported ORDER BY');
    // Parse the JQL AST into a FilterType object
    const parser = new $42cbf7cea9b7c40a$export$5299115fe71e8b39(fieldConfig, filterFields, resolvers);
    const parsedJql = await jast.query?.accept(parser);
    return parsedJql ?? {};
};

});


parcelRegister("ab4a1", function(module, exports) {

$parcel$export(module.exports, "MenuContent", () => $1b74022ad6f4d372$export$479f0f2f71193efe);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $hMVQe = parcelRequire("hMVQe");

var $kn3Xd = parcelRequire("kn3Xd");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1b74022ad6f4d372$var$LazyMenuContent = (0, $kxZPA.lazy)(()=>(parcelRequire("aOglh")), {
    moduleId: "./src/packages/business/shared/components/filters/src/ui/filters/menu-content/main.tsx"
});
const $1b74022ad6f4d372$export$479f0f2f71193efe = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kn3Xd.DropdownWrapper), {
        "data-testid": "business-filters.ui.filters.menu-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "menu-content",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hMVQe.MenuFallback), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1b74022ad6f4d372$var$LazyMenuContent, props)));

});
parcelRegister("hMVQe", function(module, exports) {

$parcel$export(module.exports, "MenuFallback", () => $a630aa0f7c48ef76$export$1198e585d599d03);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eZJjh = parcelRequire("eZJjh");
const $a630aa0f7c48ef76$export$1198e585d599d03 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a630aa0f7c48ef76$var$SpinnerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "medium",
        testId: "business-filters.common.ui.menu-fallback.spinner"
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a630aa0f7c48ef76$var$SpinnerWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
            __cmplp.className
        ])
    });
});

});

parcelRegister("kn3Xd", function(module, exports) {

$parcel$export(module.exports, "DropdownWrapper", () => $5ca6b1e17ddf2f10$export$5f7211d21bfdae05);
$parcel$export(module.exports, "ScrollableContent", () => $5ca6b1e17ddf2f10$export$6c560fdadeb11d78);
$parcel$export(module.exports, "DropdownHeaderWrapper", () => $5ca6b1e17ddf2f10$export$e23294aded7a8a49);
$parcel$export(module.exports, "DropdownHeaderButtons", () => $5ca6b1e17ddf2f10$export$53ca7a3701b98335);
$parcel$export(module.exports, "FiltersListSeparator", () => $5ca6b1e17ddf2f10$export$1a67069896d998b9);
$parcel$export(module.exports, "FiltersListWrapper", () => $5ca6b1e17ddf2f10$export$a5a9080bd2c85987);
$parcel$export(module.exports, "Section", () => $5ca6b1e17ddf2f10$export$6e2c8f0811a474ce);
$parcel$export(module.exports, "LastSection", () => $5ca6b1e17ddf2f10$export$1faf3c7558df435);
$parcel$export(module.exports, "SectionMessageWrapper", () => $5ca6b1e17ddf2f10$export$c5e20d5e200edfe2);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $gzkAf = parcelRequire("gzkAf");
const $5ca6b1e17ddf2f10$var$DROPDOWN_HEADER_HEIGHT = 52;
const $5ca6b1e17ddf2f10$var$DROPDOWN_HEADER_VERTICAL_PADDING = "var(--ds-space-150, 12px)";
const $5ca6b1e17ddf2f10$export$5f7211d21bfdae05 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ul91gwv",
            __cmplp.className
        ])
    });
});
const $5ca6b1e17ddf2f10$export$6c560fdadeb11d78 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { offsetTop: offsetTop, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1uik9ob": (0, $lD23V.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `calc(${__cmplp.offsetTop && __cmplp.offsetTop > (0, $gzkAf.POPUP_OFFSET_TOP) ? '95vh' : '85vh'} - ${// dynamically calculating offsetTop on popup mount
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (__cmplp.offsetTop ?? (0, $gzkAf.POPUP_OFFSET_TOP)) + $5ca6b1e17ddf2f10$var$DROPDOWN_HEADER_HEIGHT}px)`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo1wug _18m91wug _ln19p27b _c71l1pam",
            __cmplp.className
        ])
    });
});
const $5ca6b1e17ddf2f10$export$e23294aded7a8a49 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { stickyHeader: stickyHeader, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11q71bhr _2rko1sit _1yt4jd10 _11c8dcr7 _1pbykb7n _kqswh2mm _1e0c1txw _1bah1yb4 _4cvr1h6o _1tke1ejb",
            __cmplp.stickyHeader ? "_16qs9g9j" : "_16qsglyw",
            __cmplp.className
        ])
    });
});
const $5ca6b1e17ddf2f10$export$53ca7a3701b98335 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bahesu3",
            __cmplp.className
        ])
    });
});
const $5ca6b1e17ddf2f10$export$1a67069896d998b9 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18s81alc _x3dozgxb",
            __cmplp.className
        ])
    });
});
const $5ca6b1e17ddf2f10$export$a5a9080bd2c85987 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_p12f1gwv",
            __cmplp.className
        ])
    });
});
const $5ca6b1e17ddf2f10$export$6e2c8f0811a474ce = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulp1f4h _1e0c1txw _2lx21bp4 _n3td1f4h",
            __cmplp.className
        ])
    });
});
const $5ca6b1e17ddf2f10$export$1faf3c7558df435 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $5ca6b1e17ddf2f10$export$6e2c8f0811a474ce, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpidpf _n3tdidpf",
            __cmplp.className
        ])
    });
});
const $5ca6b1e17ddf2f10$export$c5e20d5e200edfe2 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
            __cmplp.className
        ])
    });
});

});

parcelRegister("aOglh", function(module, exports) {

let $0207ec639d971ae3$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $0207ec639d971ae3$var$load("ffQaD"),
    $0207ec639d971ae3$var$load("kvRbA"),
    $0207ec639d971ae3$var$load("kNFvF"),
    $0207ec639d971ae3$var$load("kPkde")
]).then(()=>parcelRequire('lk6eZ'));

});


parcelRegister("6xNkv", function(module, exports) {

$parcel$export(module.exports, "Trigger", () => $9499219f0b3ef189$export$41fb9f06171c75f4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $2o8gl = parcelRequire("2o8gl");

var $hORKG = parcelRequire("hORKG");

var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $22OQR = parcelRequire("22OQR");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

var $fj0YT = parcelRequire("fj0YT");
const $9499219f0b3ef189$var$FILTER_ICON = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2o8gl))), {
    label: "",
    LEGACY_size: "small"
});
const $9499219f0b3ef189$export$41fb9f06171c75f4 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ onClick: onClick, isSelected: isSelected, count: count, hasFiltersApplied: hasFiltersApplied, withThemedButton: withThemedButton = true, isDisabled: isDisabled, appearance: appearance = 'subtle', ...otherProps }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const filterMessageOld = (0, $5uXOq.useMemo)(()=>{
        if (count > 0) return formatMessage((0, $fj0YT.default).filtersCount, {
            filters: count
        });
        if (hasFiltersApplied) return formatMessage((0, $fj0YT.default).buttonWithFilters);
        return formatMessage((0, $fj0YT.default).filterButton);
    }, [
        count,
        formatMessage,
        hasFiltersApplied
    ]);
    const filterMessage = (0, $5uXOq.useMemo)(()=>{
        if (hasFiltersApplied && count === 0) return formatMessage((0, $fj0YT.default).buttonWithFilters);
        if ((0, $4R6GH.fg)('visual-refresh-headers-buttons')) return isSelected || count > 0 ? formatMessage((0, $fj0YT.default).filterButton) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $9499219f0b3ef189$var$triggerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            color: "color.text.subtle",
            weight: "medium",
            maxLines: 1
        }, formatMessage((0, $fj0YT.default).filterButton)));
        return formatMessage((0, $fj0YT.default).filterButton);
    }, [
        count,
        formatMessage,
        hasFiltersApplied,
        isSelected
    ]);
    const TriggerButton = withThemedButton ? (0, $22OQR.ThemedButton) : (0, $fVnbM.default);
    return (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TriggerButton, {
        ...otherProps,
        "aria-label": formatMessage((0, $fj0YT.default).filtersCount, {
            filters: count
        }),
        ref: ref,
        isDisabled: isDisabled,
        isSelected: isSelected || count > 0,
        onClick: onClick,
        testId: "business-filters.ui.filters.trigger.button-wrapper",
        iconAfter: count === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hORKG))), {
            label: "" // eslint-disable-next-line no-nested-ternary
            ,
            ...(0, $4R6GH.fg)('visual-refresh-headers-buttons') ? !(isSelected || count > 0) ? {
                color: "var(--ds-icon-subtle, #626F86)"
            } : {} : {
                color: 'currentColor'
            }
        }) : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9499219f0b3ef189$var$ButtonContents, null, filterMessage, count > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9499219f0b3ef189$var$BadgeContents, null, count))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TriggerButton, {
        ...otherProps,
        ref: ref,
        testId: "business-filters.ui.filters.trigger.button-wrapper",
        iconBefore: $9499219f0b3ef189$var$FILTER_ICON,
        isSelected: isSelected,
        onClick: onClick,
        appearance: appearance,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9499219f0b3ef189$var$ButtonContents, null, filterMessageOld));
});
const $9499219f0b3ef189$var$triggerStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.075',
    paddingBottom: 'space.075'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9499219f0b3ef189$var$ButtonContents = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulp12x7 _1e0c1txw _2lx2vrvc _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $9499219f0b3ef189$var$BadgeContents = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f36mu8 _n3tdidpf _19bv6mu8 _2rkogqwt _11c82smr _1e0c1txw _1bah1h6o _4cvr1h6o _bfhkllho _4t3i1j6v _1ul91j6v",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fj0YT", function(module, exports) {

$parcel$export(module.exports, "default", () => $483bd49c4d6c7782$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $483bd49c4d6c7782$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    filtersCount: {
        "id": "business-filters.filters.trigger.filters-count",
        "defaultMessage": "{filters, number} {filters, plural, one {filter applied} other {filters applied}}"
    },
    filterButton: {
        "id": "business-filters.filters.trigger.filter-button",
        "defaultMessage": "Filter"
    },
    buttonWithFilters: {
        "id": "business-filters.filters.trigger.button-with-filters",
        "defaultMessage": "Filters applied"
    },
    newLozenge: {
        "id": "business-filters.filters.trigger.new-lozenge",
        "defaultMessage": "New"
    },
    newLozengeTooltip: {
        "id": "business-filters.filters.trigger.new-lozenge-tooltip",
        "defaultMessage": "Now you can save your frequently used filters. Apply some filters to get started."
    }
});

});



parcelRegister("4Mmyc", function(module, exports) {

$parcel$export(module.exports, "SimpleSearchTextField", () => $c9154e4bfb02bfbe$export$63f96dda4bd4f7dc);
$parcel$export(module.exports, "SimpleSearchField", () => $c9154e4bfb02bfbe$export$44e8ccf3428dc1d5);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $42CjB = parcelRequire("42CjB");

var $84THj = parcelRequire("84THj");

var $26g7Y = parcelRequire("26g7Y");

var $hyOJh = parcelRequire("hyOJh");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $kY99m = parcelRequire("kY99m");

var $6cG4N = parcelRequire("6cG4N");

var $koVbs = parcelRequire("koVbs");

var $jDrwg = parcelRequire("jDrwg");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dCm1o = parcelRequire("dCm1o");

var $l4v6E = parcelRequire("l4v6E");

var $1T1ir = parcelRequire("1T1ir");

var $emybt = parcelRequire("emybt");
const $c9154e4bfb02bfbe$var$SEARCH_FIELD_WIDTH = 184;
const $c9154e4bfb02bfbe$export$63f96dda4bd4f7dc = /*#__PURE__*/ (0, $5uXOq.memo)(({ inputRef: inputRef, placeholder: placeholder, value: externalValue = '', onChange: onChange, onFocus: onFocus, view: view, testId: testId = 'searchfield', isDisabled: isDisabled, label: label, describedbyId: describedbyId, themedField: themedField = true, isFullWidth: isFullWidth = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [searchValue, setSearchValue] = (0, $5uXOq.useState)(externalValue);
    const handleSearchChange = (0, $5uXOq.useCallback)((newValue)=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'simpleSearchField updated', {
            view: view,
            ...(0, $l4v6E.getTextFieldAttributes)(newValue)
        });
        onChange(newValue);
    }, [
        createAnalyticsEvent,
        onChange,
        view
    ]);
    const [handleSearchChangeDebounced] = (0, $jDrwg.default)(handleSearchChange, 500);
    const handleChange = (0, $5uXOq.useCallback)((e)=>{
        setSearchValue(e.target.value);
        handleSearchChangeDebounced(e.target.value);
    }, [
        handleSearchChangeDebounced
    ]);
    const handleClear = (0, $5uXOq.useCallback)(()=>{
        setSearchValue('');
        handleSearchChangeDebounced('');
    }, [
        setSearchValue,
        handleSearchChangeDebounced
    ]);
    const themedIconPrimaryColor = isDisabled ? (0, $6cG4N.Tokens).COLOR_TEXT_DISABLED : (0, $6cG4N.Tokens).COLOR_TEXT_SUBTLEST; // eslint-disable-next-line no-nested-ternary
    const Container = themedField ? (0, $dCm1o.isVisualRefreshEnabled)() ? $c9154e4bfb02bfbe$var$ThemedContainer : $c9154e4bfb02bfbe$var$ThemedContainerOld : (0, $5uXOq.Fragment);
    (0, $5uXOq.useEffect)(()=>{
        setSearchValue(externalValue);
    }, [
        externalValue
    ]);
    const elemAfterSearchIcon = !(0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($26g7Y))), {
        label: "",
        color: "currentColor",
        LEGACY_size: "small",
        LEGACY_primaryColor: themedField ? themedIconPrimaryColor : undefined
    }) : null;
    let textFieldWidth;
    if ((0, $dCm1o.isVisualRefreshEnabled)()) textFieldWidth = isFullWidth ? '100%' : $c9154e4bfb02bfbe$var$SEARCH_FIELD_WIDTH;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
        ref: inputRef,
        "aria-describedby": describedbyId,
        testId: testId,
        value: searchValue,
        isCompact: true,
        placeholder: formatMessage(placeholder),
        "aria-label": label || formatMessage(placeholder),
        onChange: handleChange,
        onFocus: onFocus,
        isDisabled: isDisabled,
        elemAfterInput: searchValue !== '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            paddingInlineEnd: (0, $dCm1o.isVisualRefreshEnabled)() ? 'space.025' : undefined
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
            icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($84THj))), {
                    ...iconProps,
                    label: formatMessage((0, $emybt.default).clear),
                    spacing: "none",
                    color: "var(--ds-text, #172B4D)",
                    LEGACY_size: "small",
                    LEGACY_primaryColor: themedField ? themedIconPrimaryColor : undefined
                }),
            appearance: "subtle",
            spacing: "compact",
            label: formatMessage((0, $emybt.default).clear),
            testId: "business-filters.ui.simple-search-field.clear-button",
            onClick: handleClear
        })) : elemAfterSearchIcon,
        elemBeforeInput: (0, $dCm1o.isVisualRefreshEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $c9154e4bfb02bfbe$var$iconStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hyOJh))), {
            color: "currentColor",
            label: "",
            spacing: "none"
        })),
        width: textFieldWidth,
        className: (0, $bwpsq.default)([
            !(0, $dCm1o.isVisualRefreshEnabled)() && "_dzcou2gc"
        ])
    }));
});
const $c9154e4bfb02bfbe$export$44e8ccf3428dc1d5 = /*#__PURE__*/ (0, $5uXOq.memo)(({ placeholder: placeholder, view: view, describedbyId: describedbyId, onChange: onChange })=>{
    const [simpleSearch, setSimpleSearch] = (0, $1T1ir.useSimpleSearch)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleFocus = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'simpleSearchField focused', {
            view: view
        });
    }, [
        createAnalyticsEvent,
        view
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (onChange) onChange(simpleSearch);
    }, [
        onChange,
        simpleSearch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c9154e4bfb02bfbe$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c9154e4bfb02bfbe$export$63f96dda4bd4f7dc, {
        view: view,
        onFocus: handleFocus,
        describedbyId: describedbyId,
        onChange: (text)=>{
            if (onChange) onChange(text);
            return setSimpleSearch(text);
        },
        value: simpleSearch,
        placeholder: placeholder
    }));
});
const $c9154e4bfb02bfbe$var$textFieldStyles = null;
const $c9154e4bfb02bfbe$var$iconStyles = (0, $8CUq3.xcss)({
    display: 'inline-flex',
    marginLeft: 'space.075'
}); /* eslint-disable @atlaskit/design-system/no-unsafe-design-token-usage */ 
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c9154e4bfb02bfbe$var$ThemedContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_6l8rjjc1 _x2xkjjc1 _sg3vjjc1 _w15ajjc1 _n8yf4zrn _jeievy9e _7n83frbu _1o8h13fh _n2ul1jo4",
            __cmplp.className
        ])
    });
}); /* eslint-enable @atlaskit/design-system/no-unsafe-design-token-usage */ 
const $c9154e4bfb02bfbe$var$ThemedContainerOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $c9154e4bfb02bfbe$var$ThemedContainer, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_n8yfim6e",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c9154e4bfb02bfbe$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jDrwg", function(module, exports) {

$parcel$export(module.exports, "default", () => $049f084810e3e7c4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");
function $049f084810e3e7c4$export$2e2bcd8739ae039(callback, delay, options) {
    const optionsRef = (0, $5uXOq.useRef)(options);
    // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
    const callbackRef = (0, $5uXOq.useRef)((...args)=>{
        callback(...args);
    });
    callbackRef.current = callback;
    const debouncedCallBack = (0, $5uXOq.useMemo)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((...args)=>callbackRef.current(...args), delay, optionsRef.current), [
        delay
    ]);
    (0, $5uXOq.useEffect)(()=>debouncedCallBack.cancel, [
        debouncedCallBack
    ]);
    return [
        debouncedCallBack,
        debouncedCallBack.cancel
    ];
}

});

parcelRegister("l4v6E", function(module, exports) {

$parcel$export(module.exports, "getTextFieldAttributes", () => $211f318fc379b0d9$export$dfd7972bcd113afb);
const $211f318fc379b0d9$export$dfd7972bcd113afb = (value = '')=>{
    const wordCount = value.split(/s+/).filter((word)=>word !== '').length;
    return {
        queryLength: value.length,
        wordCount: wordCount
    };
};

});

parcelRegister("emybt", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5a1b27b61b41126$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a5a1b27b61b41126$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    clear: {
        "id": "business-filters.simple-search-field.clear",
        "defaultMessage": "Clear"
    }
});

});


parcelRegister("17X6Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a40c8fa5f1e21a1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $b71gk = parcelRequire("b71gk");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $e1OxR = parcelRequire("e1OxR");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $0a40c8fa5f1e21a1$var$LazyAddPeopleWithAvatars = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("67GjI")), {
    ssr: false,
    moduleId: "./src/packages/business/shared/components/invite-people/src/ui/add-people-with-avatars/main.tsx"
});
const $0a40c8fa5f1e21a1$var$AddPeopleWithAvatar = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "async.jira-business.invite-people.add-people-with-avatars",
        packageName: "jiraBusinessInvitePeople",
        teamName: "jira-warepil"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "invite-button-with-avatars",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0a40c8fa5f1e21a1$var$AvatarFallback, null)
    }, props?.hasInviteButton === false ? // not including the Add People provider if the invite button is not needed
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0a40c8fa5f1e21a1$var$LazyAddPeopleWithAvatars, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e1OxR.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0a40c8fa5f1e21a1$var$LazyAddPeopleWithAvatars, props))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0a40c8fa5f1e21a1$var$AvatarFallback = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1ylp",
            __cmplp.className
        ])
    });
});
var $0a40c8fa5f1e21a1$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($0a40c8fa5f1e21a1$var$AddPeopleWithAvatar);

});
parcelRegister("67GjI", function(module, exports) {

let $475438c977c8b3a1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $475438c977c8b3a1$var$load("fTMHe").then(()=>parcelRequire('62h3r'));

});


parcelRegister("ccsmj", function(module, exports) {

$parcel$export(module.exports, "JWMShareButton", () => $e895e30d5d3d8dcc$export$b326da26415fdf10);

var $5uXOq = parcelRequire("5uXOq");

var $kOEld = parcelRequire("kOEld");

var $12jwF = parcelRequire("12jwF");

var $koVbs = parcelRequire("koVbs");

var $22OQR = parcelRequire("22OQR");

var $iL8EU = parcelRequire("iL8EU");

var $9j8is = parcelRequire("9j8is");

var $fjgF8 = parcelRequire("fjgF8");

var $4XKuc = parcelRequire("4XKuc");
const $e895e30d5d3d8dcc$var$SHARE_ICON = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kOEld))), {
    label: "",
    LEGACY_size: "small"
});
const $e895e30d5d3d8dcc$export$b326da26415fdf10 = ({ shareTitle: shareTitle, integrationType: integrationType, shareContentType: shareContentType, isAutoOpenDialog: isAutoOpenDialog = false, onDialogClose: onDialogClose })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { shareIntegrations: shareIntegrations } = (0, $9j8is.useShareIntegrations)(shareContentType);
    const entityAri = (0, $12jwF.useEntityAri)();
    const shareButtonRef = (0, $5uXOq.useRef)(null);
    const renderCustomTriggerButton = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7031 - Binding element 'onClick' implicitly has an 'any' type. | TS7031 - Binding element 'isSelected' implicitly has an 'any' type. | TS7031 - Binding element 'ref' implicitly has an 'any' type.
    ({ onClick: onClick, isSelected: isSelected }, { ref: ref, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            ref: ref
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $22OQR.ThemedButton), {
            ...triggerProps,
            ref: shareButtonRef,
            onClick: onClick,
            isSelected: isSelected,
            iconBefore: $e895e30d5d3d8dcc$var$SHARE_ICON,
            appearance: "subtle"
        }, formatMessage((0, $4XKuc.default).share))), [
        formatMessage
    ]);
    const handleDialogClose = ()=>{
        onDialogClose?.();
        shareButtonRef?.current?.focus();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fjgF8.AsyncShareProjectNudge), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iL8EU.ShareButton), {
        isAutoOpenDialog: isAutoOpenDialog,
        integrationType: integrationType,
        triggerButtonStyle: "icon-with-text",
        productId: "jira",
        subProductId: "jira-core",
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        shareLink: false ? '' : window.location.href,
        shareTitle: formatMessage(shareTitle),
        shareContentType: shareContentType,
        // @ts-expect-error - TS2322 - Type '({ onClick, isSelected }: { onClick: any; isSelected: any; }, { ref, ...triggerProps }: { [x: string]: any; ref: any; }) => Element' is not assignable to type 'RenderCustomTriggerButton'.
        renderCustomTriggerButton: renderCustomTriggerButton,
        objectAri: entityAri,
        onDialogClose: handleDialogClose,
        copyTooltipText: formatMessage((0, $4XKuc.default).shareTooltipText),
        shareIntegrations: shareIntegrations,
        integrationMode: "tabs",
        shareFormHelperMessage: formatMessage((0, $4XKuc.default).shareJwmHelperMessage)
    }));
};

});
parcelRegister("kOEld", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::eddb3c8fd23121248d7a9663e3c0819a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f277c50ed79b6741$var$_react = $f277c50ed79b6741$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $f277c50ed79b6741$var$_share = $f277c50ed79b6741$var$_interopRequireDefault((parcelRequire("empdx")));

var $f277c50ed79b6741$var$_share2 = $f277c50ed79b6741$var$_interopRequireDefault((parcelRequire("jZX0t")));
function $f277c50ed79b6741$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ShareIcon.
 * This component is ShareIcon, with `UNSAFE_fallbackIcon` set to "ShareIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sharing an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f277c50ed79b6741$var$ShareIcon = (props)=>/*#__PURE__*/ $f277c50ed79b6741$var$_react.default.createElement($f277c50ed79b6741$var$_share.default, Object.assign({
        LEGACY_fallbackIcon: $f277c50ed79b6741$var$_share2.default
    }, props));
$f277c50ed79b6741$var$ShareIcon.Name = 'ShareIconMigration';
var $f277c50ed79b6741$var$_default = module.exports.default = $f277c50ed79b6741$var$ShareIcon;

});
parcelRegister("jZX0t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e8f17c524b03e26b$var$_react = $e8f17c524b03e26b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $e8f17c524b03e26b$var$_share = $e8f17c524b03e26b$var$_interopRequireDefault((parcelRequire("empdx")));
function $e8f17c524b03e26b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e8f17c524b03e26b$var$ShareIcon = (props)=>/*#__PURE__*/ $e8f17c524b03e26b$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m12-4a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m0 14a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/><path d="m7 13.562 8.66 5 1-1.732-8.66-5z"/><path d="m7 10.83 1 1.732 8.66-5-1-1.732z"/></g></svg>`
    }, props, {
        newIcon: $e8f17c524b03e26b$var$_share.default
    }));
$e8f17c524b03e26b$var$ShareIcon.displayName = 'ShareIcon';
var $e8f17c524b03e26b$var$_default = module.exports.default = $e8f17c524b03e26b$var$ShareIcon;

});


parcelRegister("iL8EU", function(module, exports) {

$parcel$export(module.exports, "ShareLoadingPlaceholder", () => $4e5335f44d688bbf$export$5619d05bf511476b);
$parcel$export(module.exports, "ShareButtonAnalyticsWrapperWithGating", () => $4e5335f44d688bbf$export$593c5080db936480);
$parcel$export(module.exports, "ShareButtonSync", () => $4e5335f44d688bbf$export$9b6a83af27cc7de5);
$parcel$export(module.exports, "ShareButton", () => $4e5335f44d688bbf$export$e980dfbc2840e8bc);
$parcel$export(module.exports, "ShareButtonAsync", () => $4e5335f44d688bbf$export$3585ee2128ae4c25);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $fVnbM = parcelRequire("fVnbM");

var $kOEld = parcelRequire("kOEld");

var $42CjB = parcelRequire("42CjB");

var $1PVpv = parcelRequire("1PVpv");

var $empdx = parcelRequire("empdx");

var $b71gk = parcelRequire("b71gk");

var $koVbs = parcelRequire("koVbs");

var $cfDZ3 = parcelRequire("cfDZ3");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $itmJb = parcelRequire("itmJb");

var $4R6GH = parcelRequire("4R6GH");

var $dAfqg = parcelRequire("dAfqg");

var $7XYc4 = parcelRequire("7XYc4");

var $67hPg = parcelRequire("67hPg");
var $kNJSJ = parcelRequire("kNJSJ");

var $7CMCs = parcelRequire("7CMCs");

var $iXVV6 = parcelRequire("iXVV6");

var $2vSU6 = parcelRequire("2vSU6");

var $Kpokz = parcelRequire("Kpokz");

var $7aU9g = parcelRequire("7aU9g");

var $8BVfN = parcelRequire("8BVfN");
const $4e5335f44d688bbf$export$5619d05bf511476b = ({ triggerButtonStyle: triggerButtonStyle = 'icon-only' })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kOEld))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: formatMessage((0, $Kpokz.messages).shareTriggerButtonText),
            color: "var(--ds-icon, #44546F)"
        }),
        isDisabled: true
    }, triggerButtonStyle === 'icon-with-text' ? formatMessage((0, $Kpokz.messages).shareTriggerButtonText) : null));
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $4e5335f44d688bbf$var$ShareButtonBase = (0, $kxZPA.lazyAfterPaint)(()=>Promise.resolve((parcelRequire("7aU9g"))), {
    ssr: false,
    moduleId: "./src/packages/growth/share-button/src/ui/index.tsx"
});
const $4e5335f44d688bbf$var$ShareButtonAnalyticsWrapper = ({ children: children })=>{
    const { data: data } = (0, $dAfqg.useProjectContext)();
    const projectKey = data?.projectKey || '';
    const projectType = data?.projectType;
    const projectStyle = data?.simplified ? (0, $2vSU6.TEAM_MANAGED_PROJECT) : (0, $2vSU6.COMPANY_MANAGED_PROJECT);
    const userLocation = (0, $cfDZ3.getUserLocation)();
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const isProjectAdmin = data?.isProjectAdmin || false;
    const analyticsData = (0, $5uXOq.useMemo)(()=>{
        const projectContextData = projectKey ? {
            projectType: projectType,
            projectStyle: projectStyle,
            isProjectAdmin: isProjectAdmin
        } : undefined;
        return {
            isAdmin: isAdmin,
            userLocation: userLocation,
            ...projectContextData
        };
    }, [
        projectKey,
        projectType,
        projectStyle,
        isProjectAdmin,
        userLocation,
        isAdmin
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: analyticsData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1PVpv.FabricElementsAnalyticsContext), {
        data: analyticsData
    }, children));
};
const $4e5335f44d688bbf$export$593c5080db936480 = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('jsw-smart-access-extended-analytics-enabled'), $4e5335f44d688bbf$var$ShareButtonAnalyticsWrapper, (0, $5uXOq.Fragment));
const $4e5335f44d688bbf$export$9b6a83af27cc7de5 = (props)=>(0, $4R6GH.fg)('migrate_share_dialog_error_boundary') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$export$593c5080db936480, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "async.share.button",
        packageName: "share-button",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7aU9g.default), props))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "async.share.button",
        packageName: "share-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$export$593c5080db936480, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7aU9g.default), props)));
const $4e5335f44d688bbf$export$e980dfbc2840e8bc = (props)=>(0, $4R6GH.fg)('migrate_share_dialog_error_boundary') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$export$593c5080db936480, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "async.share.button",
        packageName: "share-button",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "share-button",
        fallback: props.renderCustomTriggerButton === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$export$5619d05bf511476b, {
            triggerButtonStyle: props.triggerButtonStyle
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(props.renderCustomTriggerButton, {
            isDisabled: true,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$var$ShareButtonBase, props)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "async.share.button",
        packageName: "share-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "share-button",
        fallback: props.renderCustomTriggerButton === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$export$5619d05bf511476b, {
            triggerButtonStyle: props.triggerButtonStyle
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(props.renderCustomTriggerButton, {
            isDisabled: true,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$export$593c5080db936480, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$var$ShareButtonBase, props))));
const $4e5335f44d688bbf$export$3585ee2128ae4c25 = (props)=>{
    const { Panel: Panel, trigger: trigger } = (0, $kNJSJ.usePanel)();
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({}), []);
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            ...props
        }), [
        props
    ]);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: props.errorBoundaryId,
        packageName: "jiraShareButton",
        teamName: props.teamName,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $67hPg.Trigger), {
        trigger: trigger,
        entryPoint: (0, $8BVfN.shareButtonEntryPoint),
        entryPointParams: entryPointParams,
        entryPointProps: entryPointProps
    }, ({ ref: ref })=>!isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ref: ref,
            testId: "share-button.button",
            label: formatMessage((0, $Kpokz.messages).shareTriggerButtonText),
            appearance: "default",
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($empdx))), {
                    spacing: "spacious",
                    label: "",
                    color: "var(--ds-icon, #44546F)"
                }),
            onClick: ()=>setIsOpen(true)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Panel, null));
};

});
parcelRegister("Kpokz", function(module, exports) {

$parcel$export(module.exports, "messages", () => $026d1258a1c95d57$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $026d1258a1c95d57$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    shareTriggerButtonText: {
        "id": "share-button.share-trigger-button-text",
        "defaultMessage": "Share"
    }
});

});

parcelRegister("7aU9g", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "JiraShareButton", () => $4e0ba5939e9454a3$export$1b9334aba47cc461);
$parcel$export(module.exports, "default", () => $4e0ba5939e9454a3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $81zXP = parcelRequire("81zXP");

var $jcw0u = parcelRequire("jcw0u");

var $koVbs = parcelRequire("koVbs");

var $dXq4S = parcelRequire("dXq4S");

var $14XJw = parcelRequire("14XJw");

var $9OXo1 = parcelRequire("9OXo1");

var $4R6GH = parcelRequire("4R6GH");

var $7CMCs = parcelRequire("7CMCs");

var $dAfqg = parcelRequire("dAfqg");

var $lIxty = parcelRequire("lIxty");

var $3Qkpk = parcelRequire("3Qkpk");

var $ly021 = parcelRequire("ly021");

var $3Misg = parcelRequire("3Misg");

var $cvSAQ = parcelRequire("cvSAQ");

var $60DYE = parcelRequire("60DYE");

var $cRUzY = parcelRequire("cRUzY");

var $fG2b8 = parcelRequire("fG2b8");

var $hn0BX = parcelRequire("hn0BX");

var $1uAgh = parcelRequire("1uAgh");

var $ckpyh = parcelRequire("ckpyh");
const $4e0ba5939e9454a3$export$1b9334aba47cc461 = (props)=>{
    const { triggerButtonStyle: triggerButtonStyle, isAutoOpenDialog: isAutoOpenDialog = false, onDialogClose: onDialogClose, renderCustomTriggerButton: renderCustomTriggerButton, shareShortcutTriggerCount: shareShortcutTriggerCount = 0, prevShareShortcutTriggerCount: prevShareShortcutTriggerCount = 0, shareFormTitle: shareFormTitle, shareContentType: shareContentType, poSpotlightShareButtonId: poSpotlightShareButtonId, additionalTabs: additionalTabs, shareIntegrations: shareIntegrations, shareFieldsFooter: shareFieldsFooterProp, ...otherProps } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const { cloudId: cloudId, activationId: activationId } = (0, $9OXo1.useTenantContext)();
    const [{ loading: loadingOutgoingMailStatus, data: outgoingMailStatus, error: outgoingMailStatusError }, fetchEmailSettings] = (0, $3Qkpk.default)();
    const [{ data: hasUserPermission, error: userPermissionError }, fetchUserPermission] = (0, $ly021.default)();
    const [{ loading: loadingComplainceStatusHipaa, data: complainceStatusHIPAA, error: complainceStatusHipaaError }, fetchHipaaComplianceStatus] = (0, $lIxty.useIsHipaaComplianceService)();
    const [isAutoOpen, setIsAutoOpen] = (0, $5uXOq.useState)(true);
    const shortcutPressed = !!(shareShortcutTriggerCount && shareShortcutTriggerCount > 0 && shareShortcutTriggerCount > prevShareShortcutTriggerCount);
    (0, $5uXOq.useEffect)(()=>{
        if (outgoingMailStatus === undefined && isAutoOpenDialog === true) fetchEmailSettings();
    // fetchEmailSettings is unstable and casues a setState loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isAutoOpenDialog,
        outgoingMailStatus
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (complainceStatusHIPAA === undefined && isAutoOpenDialog === true) fetchHipaaComplianceStatus();
    // complianceStatusHIPAA is unstable and casues a setState loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isAutoOpenDialog,
        complainceStatusHIPAA
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (hasUserPermission === undefined && isAutoOpenDialog === true) fetchUserPermission();
    // hasUserPermission is unstable and casues a setState loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isAutoOpenDialog,
        hasUserPermission
    ]);
    // This is used purely to trigger a re-render.
    // If `isAutoOpenDialog` prop is already true, when the prop is recalculated
    // in the parent if it's `true` again there will be no re-render.
    (0, $5uXOq.useEffect)(()=>{
        if (outgoingMailStatus === undefined && shortcutPressed) fetchEmailSettings();
        if (shortcutPressed) setIsAutoOpen(shortcutPressed);
    // fetchEmailSettings is unstable and casues a setState loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        outgoingMailStatus,
        shortcutPressed,
        shareShortcutTriggerCount
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (complainceStatusHIPAA === undefined && shortcutPressed) fetchHipaaComplianceStatus();
        if (shortcutPressed) setIsAutoOpen(shortcutPressed);
    // fetchEmailSettings is unstable and casues a setState loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        complainceStatusHIPAA,
        shortcutPressed,
        shareShortcutTriggerCount
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (hasUserPermission === undefined && shortcutPressed) fetchUserPermission();
        if (shortcutPressed) setIsAutoOpen(shortcutPressed);
    // fetchUserPermission is unstable and casues a setState loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        hasUserPermission,
        shortcutPressed,
        shareShortcutTriggerCount
    ]);
    const getCustomFormTitle = (0, $5uXOq.useCallback)(()=>{
        switch(shareContentType){
            case 'summary':
                return formatMessage((0, $fG2b8.default).shareMainTabTextJwmSummary);
            case 'board':
                return formatMessage((0, $fG2b8.default).shareMainTabTextJwmBoard);
            case 'list':
                return formatMessage((0, $fG2b8.default).shareMainTabTextJwmList);
            case 'calendar':
                return formatMessage((0, $fG2b8.default).shareMainTabTextJwmCalendar);
            case 'timeline':
                return formatMessage((0, $fG2b8.default).shareMainTabTextJwmTimeline);
            case 'form':
                return formatMessage((0, $fG2b8.default).shareMainTabTextJwmForm);
            case 'attachments':
                return formatMessage((0, $fG2b8.default).shareMainTabTextJwmAttachments);
            default:
                return shareFormTitle;
        }
    }, [
        formatMessage,
        shareContentType,
        shareFormTitle
    ]);
    // Error handling fires analytics.
    (0, $5uXOq.useEffect)(()=>{
        if (outgoingMailStatusError) (0, $jcw0u.default)({
            meta: {
                id: 'getEmailSettings',
                packageName: 'jiraShareButton',
                teamName: 'people-and-teams-collective'
            }
        });
    }, [
        outgoingMailStatusError
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (complainceStatusHipaaError) (0, $jcw0u.default)({
            meta: {
                id: 'getComplainceStatusHIPAA',
                packageName: 'jiraShareButton',
                teamName: 'people-and-teams-collective'
            }
        });
    }, [
        complainceStatusHipaaError
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (userPermissionError) (0, $jcw0u.default)({
            meta: {
                id: 'userPermissionError',
                packageName: 'jiraShareButton',
                teamName: 'people-and-teams-collective'
            }
        });
    }, [
        userPermissionError
    ]);
    // Loading but no errors or data available.
    const shouldAutoOpenPreShareDialog = isAutoOpenDialog === true && (loadingOutgoingMailStatus || loadingComplainceStatusHipaa || complainceStatusHIPAA !== undefined || !!outgoingMailStatusError || !!complainceStatusHipaaError || outgoingMailStatus !== undefined);
    const isExtendedShareDialogEnabled = (0, $cvSAQ.useIsExtendedShareDialogEnabled)();
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const { data: projectAccessData, fetch: fetchProjectAccessLevels, loading: isProjectAccessLoading } = (0, $3Misg.useProjectAccessLevel)();
    const { data: userRoles, fetch: fetchUserRoles, loading: userRolesLoading } = (0, $60DYE.useUserRole)(projectContext?.projectKey);
    const shareFieldsFooter = isExtendedShareDialogEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "jiraShareButtonProjectAccessLevel",
        packageName: "jiraShareButton",
        teamName: "a4t-pandora",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ckpyh.ProjectAccessLevelSelect), {
        currentAccessLevel: projectAccessData?.accessLevel && projectAccessData?.accessLevel,
        accessLevels: projectAccessData?.availableAccessLevels,
        getProjectAccessLevels: fetchProjectAccessLevels,
        isLoading: isProjectAccessLoading
    })), shareFieldsFooterProp) : shareFieldsFooterProp;
    const isOutgoingMailDisabled = outgoingMailStatus?.isEmailEnabled === false;
    const isDisabledDueToEmail = isOutgoingMailDisabled && (additionalTabs?.length ?? 0) === 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (outgoingMailStatus === undefined || isDisabledDueToEmail || complainceStatusHIPAA?.isCompliant === true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hn0BX.default), {
        triggerButtonStyle: triggerButtonStyle,
        loading: loadingOutgoingMailStatus || loadingComplainceStatusHipaa,
        error: outgoingMailStatusError || complainceStatusHipaaError,
        emailSettings: outgoingMailStatus,
        hipaaStatus: complainceStatusHIPAA,
        renderCustomTriggerButton: renderCustomTriggerButton,
        getEmailSettings: fetchEmailSettings,
        getHipaaStatus: fetchHipaaComplianceStatus,
        getUserPermission: fetchUserPermission,
        ...isExtendedShareDialogEnabled && {
            getUserRoles: fetchUserRoles
        },
        isAutoOpenDialog: shortcutPressed || shouldAutoOpenPreShareDialog,
        onTriggerButtonClick: props.onTriggerButtonClick,
        shareShortcutTriggerCount: shareShortcutTriggerCount,
        poSpotlightShareButtonId: poSpotlightShareButtonId
    }), outgoingMailStatus !== undefined && !isDisabledDueToEmail && complainceStatusHIPAA?.isCompliant === false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1uAgh.default), {
        triggerButtonAppearance: "default",
        isAutoOpenDialog: isAutoOpen,
        renderCustomTriggerButton: renderCustomTriggerButton,
        shareContentType: shareContentType,
        shareFormTitle: shareFormTitle || getCustomFormTitle(),
        triggerButtonStyle: triggerButtonStyle,
        isBrowseUsersEnabled: hasUserPermission,
        onDialogClose: ()=>{
            setIsAutoOpen(false);
            if (onDialogClose) onDialogClose();
        },
        orgId: orgId,
        workspaceAri: (0, $4R6GH.fg)('jira_share_button-enable_jira_workspace_ari') ? (0, $81zXP.JiraWorkspaceAri).create({
            activationId: activationId,
            siteId: cloudId
        }).toString() : (0, $dXq4S.createAri)({
            resourceId: activationId,
            cloudId: cloudId,
            resourceType: 'workspace',
            resourceOwner: 'jira'
        }),
        additionalTabs: additionalTabs,
        shareIntegrations: isOutgoingMailDisabled ? [] : shareIntegrations,
        isOutgoingMailDisabled: isOutgoingMailDisabled,
        shareFieldsFooter: isOutgoingMailDisabled ? (0, $cRUzY.default)({
            canUserEnableEmail: outgoingMailStatus?.canUserEnableEmail
        }) : shareFieldsFooter,
        isExtendedShareDialogEnabled: isExtendedShareDialogEnabled,
        ...isExtendedShareDialogEnabled && {
            userRoles: userRoles,
            userRolesLoading: userRolesLoading
        },
        ...otherProps
    }));
};
var $4e0ba5939e9454a3$export$2e2bcd8739ae039 = $4e0ba5939e9454a3$export$1b9334aba47cc461;

});
parcelRegister("lIxty", function(module, exports) {

$parcel$export(module.exports, "useIsHipaaComplianceService", () => $8b53c07d7b6353b9$export$dad138577ca71048);

var $5uXOq = parcelRequire("5uXOq");

var $ld2hZ = parcelRequire("ld2hZ");

var $eusud = parcelRequire("eusud");
const $8b53c07d7b6353b9$var$getHipaaComplianceStatus = async ()=>(0, $eusud.performGetRequest)('/rest/internal/latest/compliance/status/HIPAA');
const $8b53c07d7b6353b9$export$dad138577ca71048 = ()=>{
    const { loading: loading, error: error, data: data, fetch: fetchHipaaComplianceStatus } = (0, $ld2hZ.useService)($8b53c07d7b6353b9$var$getHipaaComplianceStatus);
    const transformedData = (0, $5uXOq.useMemo)(()=>data ? {
            isCompliant: data.isCompliant
        } : undefined, [
        data
    ]);
    return [
        {
            loading: loading,
            error: error,
            data: transformedData
        },
        fetchHipaaComplianceStatus
    ];
};

});

parcelRegister("3Qkpk", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b79009b50ad613d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ld2hZ = parcelRequire("ld2hZ");

var $eusud = parcelRequire("eusud");
const $8b79009b50ad613d$var$getEmailSettings = async ()=>(0, $eusud.performGetRequest)('/rest/jira-mail-plugin/1.0/outgoingMail/config');
const $8b79009b50ad613d$export$5f20fafd52370aae = ()=>{
    const { loading: loading, error: error, data: data, fetch: fetchEmailSettings } = (0, $ld2hZ.useService)($8b79009b50ad613d$var$getEmailSettings);
    const transformedData = (0, $5uXOq.useMemo)(()=>data ? {
            isEmailEnabled: data.enabled,
            canUserEnableEmail: data.canEditConfig
        } : undefined, [
        data
    ]);
    return [
        {
            loading: loading,
            error: error,
            data: transformedData
        },
        fetchEmailSettings
    ];
};
var $8b79009b50ad613d$export$2e2bcd8739ae039 = $8b79009b50ad613d$export$5f20fafd52370aae;

});

parcelRegister("ly021", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3c761b58cac213d$export$2e2bcd8739ae039);

var $ld2hZ = parcelRequire("ld2hZ");

var $eusud = parcelRequire("eusud");
const $b3c761b58cac213d$var$getUserPermission = async ()=>(0, $eusud.performGetRequest)('/rest/api/3/mypermissions?permissions=USER_PICKER');
const $b3c761b58cac213d$export$ce7974a7294500be = ()=>{
    const { loading: loading, error: error, data: data, fetch: fetchUserPermission } = (0, $ld2hZ.useService)($b3c761b58cac213d$var$getUserPermission);
    return [
        {
            loading: loading,
            error: error,
            data: data?.permissions?.USER_PICKER?.havePermission
        },
        fetchUserPermission
    ];
};
var $b3c761b58cac213d$export$2e2bcd8739ae039 = $b3c761b58cac213d$export$ce7974a7294500be;

});

parcelRegister("3Misg", function(module, exports) {

$parcel$export(module.exports, "useProjectAccessLevel", () => $da4bace31cc40a76$export$e262f937bd216199);

var $5uXOq = parcelRequire("5uXOq");

var $ld2hZ = parcelRequire("ld2hZ");

var $eusud = parcelRequire("eusud");

var $dAfqg = parcelRequire("dAfqg");
const $da4bace31cc40a76$var$getProjectAccessLevel = async (projectId)=>{
    if (!projectId) throw new Error('Project ID is missing while fetching project access level.');
    return (0, $eusud.performGetRequest)(`/rest/internal/simplified/1.0/accesslevel/project/${projectId}`);
};
const $da4bace31cc40a76$var$getProjectAccessLevels = async ()=>{
    return (0, $eusud.performGetRequest)('/rest/internal/simplified/1.0/accesslevel?projectType=software');
};
const $da4bace31cc40a76$var$updateProjectAccessLevel = async ({ projectId: projectId, projectKey: projectKey, accessLevel: accessLevel })=>{
    if (!projectId || !projectKey) throw new Error('Project ID and/or Key is missing while updating project access level.');
    return (0, $eusud.performPutRequest)(`/rest/internal/simplified/1.0/projects/${projectId}/summary`, {
        body: JSON.stringify({
            accessLevel: accessLevel,
            key: projectKey
        })
    });
};
const $da4bace31cc40a76$export$e262f937bd216199 = ()=>{
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const { projectId: projectId, projectKey: projectKey } = (0, $5uXOq.useMemo)(()=>({
            projectId: projectContext?.projectId,
            projectKey: projectContext?.projectKey
        }), [
        projectContext
    ]);
    const { loading: isLoading, error: error, data: data, fetch: fetch } = (0, $ld2hZ.useService)(()=>Promise.all([
            $da4bace31cc40a76$var$getProjectAccessLevel(projectId),
            $da4bace31cc40a76$var$getProjectAccessLevels()
        ]).then(([accessLevel, availableAccessLevels])=>({
                accessLevel: accessLevel,
                availableAccessLevels: availableAccessLevels
            })));
    const { loading: isUpdating, error: updateError, fetch: update } = (0, $ld2hZ.useService)(({ accessLevel: accessLevel })=>$da4bace31cc40a76$var$updateProjectAccessLevel({
            projectId: projectId,
            projectKey: projectKey,
            accessLevel: accessLevel
        }));
    return {
        loading: isLoading || isUpdating,
        error: error || updateError,
        data: data,
        fetch: fetch,
        update: update
    };
};

});

parcelRegister("cvSAQ", function(module, exports) {

$parcel$export(module.exports, "useIsExtendedShareDialogEnabled", () => $8c2efaed9c82d207$export$1000ebfdeca10b3c);

var $6s1PB = parcelRequire("6s1PB");

var $3HwlS = parcelRequire("3HwlS");

var $lODMY = parcelRequire("lODMY");

var $itmJb = parcelRequire("itmJb");

var $dAfqg = parcelRequire("dAfqg");
const $8c2efaed9c82d207$export$1000ebfdeca10b3c = ()=>{
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const { data: projectContextData } = (0, $dAfqg.useProjectContext)();
    const isProjectAdmin = !!projectContextData?.isProjectAdmin;
    const isTMP = (0, $dAfqg.useIsSimplifiedProject)();
    const shouldShowInNav3View = (0, $lODMY.useIsActiveRoute)(new Set([
        'software-timeline',
        'software-boards',
        'software-backlog',
        'issue'
    ]));
    return ((0, $3HwlS.getWillShowNav4)() || shouldShowInNav3View) && isTMP && (isAdmin || isProjectAdmin) && (0, $6s1PB.expVal)('tmp_secure_project_access_share_dialog', 'isEnabled', false);
};

});

parcelRegister("60DYE", function(module, exports) {

$parcel$export(module.exports, "useUserRole", () => $13fb2e5bc2538e40$export$77101ee802ae0455);

var $5uXOq = parcelRequire("5uXOq");

var $ld2hZ = parcelRequire("ld2hZ");

var $eusud = parcelRequire("eusud");
const $13fb2e5bc2538e40$var$getUserRolesService = (projectKey)=>{
    if (!projectKey) throw new Error('Project Key is required to fetch user roles');
    return (0, $eusud.performGetRequest)(`/rest/api/3/project/${projectKey}/roledetails?excludeConnectAddons=true`);
};
const $13fb2e5bc2538e40$var$addUserRoleService = ({ projectKey: projectKey, roleId: roleId, groups: groups, users: users })=>{
    if (!projectKey) throw new Error('Project key is required to add user role');
    return (0, $eusud.performPostRequest)(`/rest/projectconfig/latest/roles/${projectKey}/${roleId}`, {
        body: JSON.stringify({
            groups: groups,
            users: users
        })
    });
};
const $13fb2e5bc2538e40$export$77101ee802ae0455 = (projectKey)=>{
    const { data: data, fetch: fetch, loading: isFetching, error: fetchError } = (0, $ld2hZ.useService)(()=>$13fb2e5bc2538e40$var$getUserRolesService(projectKey));
    const { loading: isAdding, error: addError, fetch: addUserRoleInternal } = (0, $ld2hZ.useService)($13fb2e5bc2538e40$var$addUserRoleService);
    const add = (0, $5uXOq.useCallback)((roleId, { users: users, groups: groups })=>addUserRoleInternal({
            projectKey: projectKey,
            roleId: roleId,
            users: users,
            groups: groups
        }), [
        addUserRoleInternal,
        projectKey
    ]);
    return {
        fetch: fetch,
        add: add,
        data: data,
        loading: isFetching || isAdding,
        error: fetchError || addError
    };
};

});

parcelRegister("cRUzY", function(module, exports) {

$parcel$export(module.exports, "default", () => $2333dcf1c6e1c11b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $92Z2l = parcelRequire("92Z2l");
var $ctz0s = parcelRequire("ctz0s");

var $cgL5K = parcelRequire("cgL5K");

var $koVbs = parcelRequire("koVbs");

var $cGLqe = parcelRequire("cGLqe");
const $2333dcf1c6e1c11b$var$OutgoingMailWarningMessage = ({ canUserEnableEmail: canUserEnableEmail })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return canUserEnableEmail ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctz0s.default), {
            href: "/secure/admin/OutgoingMailServers.jspa"
        }, formatMessage((0, $cGLqe.default).outgoingMailSettingsLink)),
        appearance: "warning"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, formatMessage((0, $cGLqe.default).disabledWarningMessage))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        appearance: "warning"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, formatMessage((0, $cGLqe.default).disabledWarningMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, formatMessage((0, $cGLqe.default).nonAdminWarningMessage)));
};
var $2333dcf1c6e1c11b$export$2e2bcd8739ae039 = $2333dcf1c6e1c11b$var$OutgoingMailWarningMessage;

});
parcelRegister("cGLqe", function(module, exports) {

$parcel$export(module.exports, "default", () => $5118dd1ca51be8cb$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5118dd1ca51be8cb$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    disabledWarningMessage: {
        "id": "share-button.pre-share-view.warning-content.disabled-warning-message",
        "defaultMessage": "Outgoing mail is not configured."
    },
    adminEnableOutgoingMail: {
        "id": "share-button.pre-share-view.warning-content.admin-enable-outgoing-mail",
        "defaultMessage": "You can configure it here"
    },
    outgoingMail: {
        "id": "share-button.pre-share-view.warning-content.outgoing-mail",
        "defaultMessage": "Outgoing Mail"
    },
    nonAdminWarningMessage: {
        "id": "share-button.pre-share-view.warning-content.non-admin-warning-message",
        "defaultMessage": "Please contact your Jira administrator to enable sharing."
    },
    disabledWarningMessageIfHipaa: {
        "id": "share-button.pre-share-view.warning-content.disabled-warning-message-if-hipaa",
        "defaultMessage": "You cannot share issue as your organization has signed up for HIPAA compliance"
    },
    disabledWarningMessageIfHipaaIssueTermRefresh: {
        "id": "share-button.pre-share-view.warning-content.disabled-warning-message-if-hipaa-issue-term-refresh",
        "defaultMessage": "You can't share work item as your organization has signed up for HIPAA compliance"
    },
    outgoingMailSettingsLink: {
        "id": "share-button.pre-share-view.warning-content.enable-outgoing-mail-link",
        "defaultMessage": "Set up email sharing"
    }
});

});


parcelRegister("fG2b8", function(module, exports) {

$parcel$export(module.exports, "default", () => $a915a4d87397f963$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a915a4d87397f963$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    shareMainTabTextJwmSummary: {
        "id": "share-button.share-main-tab-text-jwm-summary",
        "defaultMessage": "Share summary"
    },
    shareMainTabTextJwmBoard: {
        "id": "share-button.share-main-tab-text-jwm-board",
        "defaultMessage": "Share board"
    },
    shareMainTabTextJwmList: {
        "id": "share-button.share-main-tab-text-jwm-list",
        "defaultMessage": "Share list"
    },
    shareMainTabTextJwmCalendar: {
        "id": "share-button.share-main-tab-text-jwm-calendar",
        "defaultMessage": "Share calendar"
    },
    shareMainTabTextJwmTimeline: {
        "id": "share-button.share-main-tab-text-jwm-timeline",
        "defaultMessage": "Share timeline"
    },
    shareMainTabTextJwmForm: {
        "id": "share-button.share-main-tab-text-jwm-form",
        "defaultMessage": "Share form"
    },
    shareMainTabTextJwmAttachments: {
        "id": "share-button.share-main-tab-text-jwm-attachments",
        "defaultMessage": "Share attachments"
    }
});

});

parcelRegister("hn0BX", function(module, exports) {

$parcel$export(module.exports, "default", () => $6286a7fcdb67d585$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $42CjB = parcelRequire("42CjB");

var $fVnbM = parcelRequire("fVnbM");

var $empdx = parcelRequire("empdx");

var $kOEld = parcelRequire("kOEld");

var $eZJjh = parcelRequire("eZJjh");

var $3bDjY = parcelRequire("3bDjY");

var $jgJNO = parcelRequire("jgJNO");

var $9fuVs = parcelRequire("9fuVs");

var $gwIPs = parcelRequire("gwIPs");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $l8ruj = parcelRequire("l8ruj");

var $dCm1o = parcelRequire("dCm1o");

var $ggimd = parcelRequire("ggimd");

var $6P8F6 = parcelRequire("6P8F6");
const $6286a7fcdb67d585$var$ConditionalTooltip = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $ggimd.default).shareTriggerButtonText),
        position: "top"
    }, children);
};
const $6286a7fcdb67d585$var$PreShareView = ({ triggerButtonStyle: triggerButtonStyle, loading: loading, error: error, emailSettings: emailSettings, hipaaStatus: hipaaStatus, renderCustomTriggerButton: renderCustomTriggerButton, getEmailSettings: getEmailSettings, getHipaaStatus: getHipaaStatus, getUserPermission: getUserPermission, getUserRoles: getUserRoles, isAutoOpenDialog: isAutoOpenDialog = false, onDialogClose: onDialogClose, onTriggerButtonClick: onTriggerButtonClick, shareShortcutTriggerCount: shareShortcutTriggerCount, poSpotlightShareButtonId: poSpotlightShareButtonId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(isAutoOpenDialog);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    // Used to invoke a re-render when isAutoOpenDialog has not changed but the shortcut has been pressed again.
    (0, $5uXOq.useEffect)(()=>{
        setIsOpen(isAutoOpenDialog);
    }, [
        isAutoOpenDialog,
        shareShortcutTriggerCount
    ]);
    const onTriggerClick = (0, $5uXOq.useCallback)((trigger)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'PreShareView Button Clicked',
            actionSubject: 'Share'
        });
        setIsOpen(!isOpen);
        if (!isOpen) {
            getUserPermission();
            getEmailSettings();
            getHipaaStatus();
            getUserRoles && getUserRoles();
        }
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, trigger);
        if (onTriggerButtonClick) onTriggerButtonClick();
    }, [
        createAnalyticsEvent,
        isOpen,
        onTriggerButtonClick,
        getUserPermission,
        getEmailSettings,
        getHipaaStatus,
        getUserRoles
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        onClose: ()=>{
            setIsOpen(false);
            onDialogClose && onDialogClose();
        },
        zIndex: (0, $gwIPs.layers).modal,
        messageId: "share-button.ui.pre-share-view.popup",
        messageType: "transactional",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6286a7fcdb67d585$var$DialogLayout, {
                "data-testid": "share-button.ui.pre-share-view.warningModal"
            }, loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
                testId: "share-button.ui.pre-share-view.loading",
                size: "medium"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6P8F6.WarningContent), {
                isEmailEnabled: emailSettings?.isEmailEnabled,
                canUserEnableEmail: !!emailSettings?.canUserEnableEmail,
                isUserHIPAA: !!hipaaStatus?.isCompliant
            }), error && // eslint-disable-next-line @atlaskit/design-system/use-heading
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("h1", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $ggimd.default).errorMessage)))),
        isOpen: isOpen,
        placement: "left-start",
        trigger: (triggerProps)=>renderCustomTriggerButton ? renderCustomTriggerButton({
                isSelected: isOpen,
                onClick: ()=>onTriggerClick('RenderCustomTriggerPreShareView')
            }, triggerProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6286a7fcdb67d585$var$ConditionalTooltip, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
                name: "issue-pre-share-button"
            }, (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
                testId: "share-button.ui.pre-share-view.button",
                id: poSpotlightShareButtonId,
                isDisabled: loading,
                label: formatMessage((0, $ggimd.default).shareTriggerButtonText),
                ...triggerProps,
                appearance: "default",
                icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($empdx))), {
                        spacing: "spacious",
                        label: triggerButtonStyle === 'icon-with-text' ? '' : formatMessage((0, $ggimd.default).shareTriggerButtonText),
                        color: "var(--ds-icon, #44546F)"
                    }),
                onClick: ()=>onTriggerClick('PreShareView')
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                testId: "share-button.ui.pre-share-view.button",
                id: poSpotlightShareButtonId,
                disabled: loading,
                ...triggerProps,
                appearance: "subtle",
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kOEld))), {
                    LEGACY_size: "medium",
                    spacing: "spacious",
                    label: triggerButtonStyle === 'icon-with-text' ? '' : formatMessage((0, $ggimd.default).shareTriggerButtonText),
                    color: "var(--ds-icon, #44546F)"
                }),
                onClick: ()=>onTriggerClick('PreShareView')
            }, triggerButtonStyle === 'icon-with-text' ? formatMessage((0, $ggimd.default).shareTriggerButtonText) : null)))
    });
};
var $6286a7fcdb67d585$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $6286a7fcdb67d585$var$PreShareView;
const $6286a7fcdb67d585$var$DialogLayout = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y3gn1h6o _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ggimd", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3676909909c5a34$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a3676909909c5a34$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    shareTriggerButtonText: {
        "id": "share-button.pre-share-view.share-trigger-button-text",
        "defaultMessage": "Share"
    },
    errorMessage: {
        "id": "share-button.pre-share-view.error-message",
        "defaultMessage": "Unable to fetch sharing details"
    }
});

});

parcelRegister("6P8F6", function(module, exports) {

$parcel$export(module.exports, "WarningContent", () => $ecad3da73effb00b$export$b7eb687edfdfe752);

var $5uXOq = parcelRequire("5uXOq");

var $bU3PY = parcelRequire("bU3PY");

var $41j30 = parcelRequire("41j30");

var $4R6GH = parcelRequire("4R6GH");

var $ousew = parcelRequire("ousew");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $cGLqe = parcelRequire("cGLqe");
function $ecad3da73effb00b$export$b7eb687edfdfe752({ isEmailEnabled: isEmailEnabled, canUserEnableEmail: canUserEnableEmail, isUserHIPAA: isUserHIPAA }) {
    if (isEmailEnabled === false || isUserHIPAA) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa),
        sourceName: "PreShareWarningView"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))), {
        LEGACY_size: "medium",
        spacing: "spacious",
        label: "Warning",
        testId: "share-button.ui.pre-share-view.warning-content.warning-icon"
    }), isEmailEnabled === false && // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $cGLqe.default).disabledWarningMessage), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null), canUserEnableEmail ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $cGLqe.default).adminEnableOutgoingMail), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $41j30.default), {
        href: "/secure/admin/OutgoingMailServers.jspa"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $cGLqe.default).outgoingMail))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $cGLqe.default).nonAdminWarningMessage)), isEmailEnabled !== false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $cGLqe.default).disabledWarningMessageIfHipaaIssueTermRefresh : (0, $cGLqe.default).disabledWarningMessageIfHipaa), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: {
            canUserEnableEmail: canUserEnableEmail,
            isUserHIPAA: isUserHIPAA
        }
    }));
    return null;
}

});


parcelRegister("1uAgh", function(module, exports) {

$parcel$export(module.exports, "default", () => $379ea30a2af32bdf$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2gQ83 = parcelRequire("2gQ83");

var $dsCiy = parcelRequire("dsCiy");

var $4Pf62 = parcelRequire("4Pf62");

var $7f4tk = parcelRequire("7f4tk");

var $pa9q9 = parcelRequire("pa9q9");
var $34Vv8 = parcelRequire("34Vv8");

var $az4zD = parcelRequire("az4zD");

var $koeKL = parcelRequire("koeKL");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $dAfqg = parcelRequire("dAfqg");

var $kAdLR = parcelRequire("kAdLR");

var $aYuZy = parcelRequire("aYuZy");

var $kwHgU = parcelRequire("kwHgU");

var $8HBuB = parcelRequire("8HBuB");

var $cvSAQ = parcelRequire("cvSAQ");

var $3Misg = parcelRequire("3Misg");

var $b4Qrh = parcelRequire("b4Qrh");

var $60DYE = parcelRequire("60DYE");
const $379ea30a2af32bdf$var$USER_PICKER_LIMIT = 20;
class $379ea30a2af32bdf$export$e980dfbc2840e8bc extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            shouldAutoDismissFlag: true,
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onTriggerButtonClick: ()=>{}
        };
    }
    constructor(props){
        super(props), this.getOriginTracingInstance = ()=>new (0, $2gQ83.default)({
                product: this.props.productId
            }), this.loadUsers = async (searchText = '')=>{
            const searchTextEncoded = encodeURIComponent(searchText);
            const url = `/rest/api/3/groupuserpicker?maxResults=${$379ea30a2af32bdf$var$USER_PICKER_LIMIT}&query=${searchTextEncoded}&showAvatar=true&avatarSize=medium&excludeConnectAddons=true`;
            const groupsAndUsers = await (0, $7f4tk.default)(url);
            return groupsAndUsers.users.users.filter((user)=>user.accountType === 'atlassian').map((user)=>{
                const userData = {
                    type: 'user',
                    id: user.accountId,
                    name: user.displayName,
                    avatarUrl: user.avatarUrl
                };
                return userData;
            });
        }, this.showFlags = (flags)=>{
            const { flagService: flagService, shouldAutoDismissFlag: shouldAutoDismissFlag } = this.props;
            if (flagService?.showFlag) flags.forEach((flag)=>{
                flagService.showFlag({
                    type: flag.appearance,
                    title: flag.title.defaultMessage,
                    isAutoDismiss: shouldAutoDismissFlag,
                    messageId: `share-button.ui.share-view.showFlag.${flag.title.id}`,
                    messageType: 'transactional'
                });
            });
        }, this.cloudId = '';
        this.cloudId = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)().cloudId;
        if (props.legacyShareClientConfig !== undefined) this.legacyShareClient = new (0, $aYuZy.default)(props.legacyShareClientConfig);
    }
    render() {
        const { objectAri: objectAri, renderCustomTriggerButton: renderCustomTriggerButton, shareLink: shareLink, shareTitle: shareTitle, shareContentType: shareContentType, shareFormTitle: shareFormTitle, subProductId: subProductId, triggerButtonAppearance: triggerButtonAppearance = 'subtle', triggerButtonStyle: triggerButtonStyle, onTriggerButtonClick: onTriggerButtonClick, shareIntegrations: shareIntegrations, integrationMode: integrationMode = 'off', isAutoOpenDialog: isAutoOpenDialog, onDialogClose: onDialogClose, copyTooltipText: copyTooltipText, orgId: orgId, isBrowseUsersEnabled: isBrowseUsersEnabled, shareFormHelperMessage: shareFormHelperMessage, shareFieldsFooter: shareFieldsFooter, additionalTabs: additionalTabs, builtInTabContentWidth: builtInTabContentWidth, isOutgoingMailDisabled: isOutgoingMailDisabled, customHeader: customHeader, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled, onSubmit: onSubmit, userRoles: userRoles = [], userRolesLoading: userRolesLoading } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dsCiy.ShareDialogContainer), {
            shareClient: this.legacyShareClient,
            triggerButtonAppearance: triggerButtonAppearance,
            triggerButtonStyle: triggerButtonStyle,
            cloudId: this.cloudId,
            orgId: orgId,
            loadUserOptions: this.legacyShareClient && this.loadUsers,
            // @ts-expect-error - TS2322 - Type '() => OriginTracing' is not assignable to type 'OriginTracingFactory'.
            originTracingFactory: this.getOriginTracingInstance,
            productId: subProductId,
            renderCustomTriggerButton: renderCustomTriggerButton,
            shareAri: objectAri || (0, $kAdLR.createAri)(subProductId, this.cloudId),
            shareFormHelperMessage: shareFormHelperMessage,
            shareLink: shareLink,
            shareTitle: shareTitle,
            shareContentType: shareContentType,
            shareFormTitle: shareFormTitle,
            showFlags: this.showFlags,
            enableSmartUserPicker: !this.legacyShareClient,
            product: "jira",
            onTriggerButtonClick: onTriggerButtonClick,
            shareIntegrations: shareIntegrations,
            integrationMode: integrationMode,
            isAutoOpenDialog: isAutoOpenDialog,
            onDialogClose: onDialogClose,
            copyTooltipText: copyTooltipText,
            isBrowseUsersDisabled: isBrowseUsersEnabled === false,
            shareFieldsFooter: shareFieldsFooter,
            workspaceAri: this.props.workspaceAri,
            additionalTabs: additionalTabs,
            builtInTabContentWidth: builtInTabContentWidth,
            isSubmitShareDisabled: isOutgoingMailDisabled,
            customHeader: customHeader,
            isExtendedShareDialogEnabled: isExtendedShareDialogEnabled,
            additionalUserFields: isExtendedShareDialogEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8HBuB.UserRole), {
                roles: userRoles,
                isLoading: !!userRolesLoading
            }),
            CustomSubmitButton: isExtendedShareDialogEnabled ? (0, $b4Qrh.CustomShareSubmitButton) : undefined,
            onSubmit: onSubmit
        });
    }
}
const $379ea30a2af32bdf$var$noop = ()=>null;
const $379ea30a2af32bdf$var$ShareButtonFC = ({ objectAri: objectAri, triggerButtonAppearance: triggerButtonAppearance = 'subtle', onTriggerButtonClick: onTriggerButtonClick = $379ea30a2af32bdf$var$noop, integrationMode: integrationMode = 'off', isBrowseUsersEnabled: isBrowseUsersEnabled, isOutgoingMailDisabled: isOutgoingMailDisabled, legacyShareClientConfig: legacyShareClientConfig, shouldAutoDismissFlag: shouldAutoDismissFlag = false, onSubmit: onSubmit, userRoles: userRoles = [], userRolesLoading: userRolesLoading, ...props })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const isExtendedShareDialogEnabled = (0, $cvSAQ.useIsExtendedShareDialogEnabled)();
    const legacyShareClient = (0, $5uXOq.useMemo)(()=>legacyShareClientConfig && new (0, $aYuZy.default)(legacyShareClientConfig), [
        legacyShareClientConfig
    ]);
    const getOriginTracingInstance = (0, $5uXOq.useCallback)(()=>{
        return new (0, $2gQ83.default)({
            product: 'jira'
        });
    }, []);
    const showFlags = (0, $5uXOq.useCallback)((flags)=>{
        if (showFlag) flags.forEach((flag)=>{
            showFlag({
                type: flag.appearance,
                title: flag.title.defaultMessage,
                isAutoDismiss: shouldAutoDismissFlag,
                messageId: `share-button.ui.share-view.showFlag.${flag.title.id}`,
                messageType: 'transactional'
            });
        });
    }, [
        showFlag,
        shouldAutoDismissFlag
    ]);
    const { update: updateProjectAccessLevel } = (0, $3Misg.useProjectAccessLevel)();
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const { add: addToUserRole } = (0, $60DYE.useUserRole)(projectContext?.projectKey);
    const handleOnSubmit = (0, $5uXOq.useCallback)((data)=>{
        if (isExtendedShareDialogEnabled) {
            if (data?.projectAccessLevel?.value) updateProjectAccessLevel({
                accessLevel: data?.projectAccessLevel.value
            });
            if (data.users && data?.userRole?.value) {
                const roleId = data?.userRole.value;
                const userIds = data.users.filter((user)=>user.type === 'user').map((user)=>user.id);
                const groupIds = data.users.filter((user)=>user.type === 'group').map((group)=>group.id);
                addToUserRole(roleId, {
                    users: userIds,
                    groups: groupIds
                });
            }
        }
        onSubmit && onSubmit(data);
    }, [
        isExtendedShareDialogEnabled,
        onSubmit,
        updateProjectAccessLevel,
        addToUserRole
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dsCiy.ShareDialogContainer), {
        shareClient: legacyShareClient,
        cloudId: cloudId,
        loadUserOptions: legacyShareClient && (0, $kwHgU.loadUsers),
        // @ts-expect-error - TS2322 - Type '() => OriginTracing' is not assignable to type 'OriginTracingFactory'.
        originTracingFactory: getOriginTracingInstance,
        shareAri: objectAri || (0, $kAdLR.createAri)(props.subProductId, cloudId),
        showFlags: showFlags,
        enableSmartUserPicker: !legacyShareClient,
        product: "jira",
        isBrowseUsersDisabled: isBrowseUsersEnabled === false,
        isSubmitShareDisabled: isOutgoingMailDisabled,
        triggerButtonAppearance: triggerButtonAppearance,
        onTriggerButtonClick: onTriggerButtonClick,
        integrationMode: integrationMode,
        isExtendedShareDialogEnabled: isExtendedShareDialogEnabled,
        onSubmit: handleOnSubmit,
        CustomSubmitButton: isExtendedShareDialogEnabled ? (0, $b4Qrh.CustomShareSubmitButton) : undefined,
        additionalUserFields: isExtendedShareDialogEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8HBuB.UserRole), {
            roles: userRoles,
            isLoading: !!userRolesLoading
        }),
        ...props
    });
};
var $379ea30a2af32bdf$export$2e2bcd8739ae039 = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('jira-growth-share-button-refactor-fc'), $379ea30a2af32bdf$var$ShareButtonFC, (0, $az4zD.injectIntlV2)((0, $34Vv8.default)($379ea30a2af32bdf$export$e980dfbc2840e8bc)));

});
parcelRegister("dsCiy", function(module, exports) {

$parcel$export(module.exports, "ShareDialogContainer", () => $dd0122880035a80e$export$78b28896b43ae5d6);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $1SBaA = parcelRequire("1SBaA");

var $8QpSo = parcelRequire("8QpSo");

var $ousew = parcelRequire("ousew");

var $3joPi = parcelRequire("3joPi");

var $cb25w = parcelRequire("cb25w");

var $VSDnB = parcelRequire("VSDnB");

var $9b5JR = parcelRequire("9b5JR");

var $inlXa = parcelRequire("inlXa");

var $idKBS = parcelRequire("idKBS");

var $b2oBK = parcelRequire("b2oBK");

var $hQWyD = parcelRequire("hQWyD");

var $65uFp = parcelRequire("65uFp");

var $2sAb4 = parcelRequire("2sAb4");

var $7ZU6o = parcelRequire("7ZU6o");

var $7v5Ga = parcelRequire("7v5Ga");

var $4gTjW = parcelRequire("4gTjW");
const $dd0122880035a80e$var$COPY_LINK_EVENT = (0, $b2oBK.copyLinkButtonClicked)({
    start: 0
});
const $dd0122880035a80e$export$f84bd70098573c5c = {
    disableSharingToEmails: false
};
const $dd0122880035a80e$var$memoizedFormatCopyLink = (0, $8QpSo.default)((origin, link)=>origin.addToUrl(link));
function $dd0122880035a80e$var$getCurrentPageUrl() {
    return window.location.href;
}
class $dd0122880035a80e$export$bc8c417f2da43f4 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            enableSmartUserPicker: false,
            shareeAction: 'view',
            product: 'confluence'
        };
    }
    constructor(props){
        super(props), this._isMounted = false, this._urlShorteningRequestCounter = 0, this._lastUrlShorteningWasTooSlow = false, this.createAndFireEvent = (payload)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) createAnalyticsEvent(payload).fire((0, $b2oBK.CHANNEL_ID));
        }, this.fetchConfig = ()=>{
            this.setState({
                isFetchingConfig: true
            }, async ()=>{
                try {
                    (0, $65uFp.renderShareDialogExp).start();
                    const config = await this.shareClient.getConfig(this.props.cloudId);
                    if (this._isMounted) this.setState({
                        config: config,
                        isFetchingConfig: false
                    });
                    (0, $65uFp.renderShareDialogExp).success();
                } catch (error) {
                    if (this._isMounted) this.setState({
                        config: $dd0122880035a80e$export$f84bd70098573c5c,
                        isFetchingConfig: false
                    });
                    let { ...errObj } = error;
                    if (error instanceof Error) errObj = {
                        ...errObj,
                        className: error.constructor.name
                    };
                    (0, $hQWyD.isValidFailedExperience)((0, $65uFp.renderShareDialogExp), errObj);
                }
            });
        }, this.handleSubmitShare = ({ users: users, comment: comment, ...rest })=>{
            const shareLink = this.getFormShareLink();
            const { productId: productId, shareAri: shareAri, shareContentType: shareContentType, shareTitle: shareTitle, shareeAction: shareeAction, workspaceAri: workspaceAri } = this.props;
            const content = {
                ari: shareAri,
                link: shareLink,
                title: shareTitle,
                type: shareContentType,
                workspaceAri: workspaceAri
            };
            const metaData = {
                productId: productId,
                atlOriginId: this.getFormShareOriginTracing().id,
                shareeAction: shareeAction
            };
            this.props.onSubmit?.({
                users: users,
                comment: comment,
                ...rest
            });
            return this.shareClient.share(content, (0, $4gTjW.optionDataToUsers)(users), metaData, comment).then(()=>{
                if (!this._isMounted) return;
                // renew Origin Tracing Id per share action succeeded
                this.setState((state)=>({
                        shareActionCount: state.shareActionCount + 1
                    }));
            });
        }, this.handleDialogOpen = async ()=>{
            if (this.props.onDialogOpen) this.props.onDialogOpen();
            this.setState({
                currentPageUrl: $dd0122880035a80e$var$getCurrentPageUrl()
            }, ()=>{
                this.updateShortCopyLink();
            });
            // always refetch the config when modal is re-opened
            this.fetchConfig();
        }, this.decorateAnalytics = (payload)=>{
            if (payload.type === $dd0122880035a80e$var$COPY_LINK_EVENT.type && payload.action === $dd0122880035a80e$var$COPY_LINK_EVENT.action && payload.actionSubjectId === $dd0122880035a80e$var$COPY_LINK_EVENT.actionSubjectId) {
                const isCopyLinkShortened = !!this.getShortenedCopyLink();
                payload = {
                    ...payload,
                    attributes: {
                        ...payload.attributes,
                        shortUrl: isCopyLinkShortened
                    }
                };
                if (this.shouldShortenCopyLink() && !isCopyLinkShortened) this._lastUrlShorteningWasTooSlow = true;
            }
            return payload;
        }, // ensure origin is re-generated if the link or the factory changes
        // separate memoization is needed since copy != form
        this.getUniqueCopyLinkOriginTracing = (0, $8QpSo.default)((link, originTracingFactory)=>{
            return originTracingFactory();
        }), // form origin must furthermore be regenerated after each form share
        this.getUniqueFormShareOriginTracing = (0, $8QpSo.default)((link, originTracingFactory, shareCount)=>{
            return originTracingFactory();
        }), this.getUpToDateShortenedCopyLink = (0, $8QpSo.default)((data, originId)=>{
            this._lastUrlShorteningWasTooSlow = false;
            this._urlShorteningRequestCounter++;
            this.createAndFireEvent((0, $b2oBK.shortUrlRequested)());
            const start = Date.now();
            return this.urlShortenerClient.shorten({
                ...data,
                originId: originId
            }).then((response)=>{
                this.createAndFireEvent((0, $b2oBK.shortUrlGenerated)(start, this._lastUrlShorteningWasTooSlow));
                return response.shortUrl;
            }).catch(()=>{
                this.createAndFireEvent((0, $b2oBK.errorEncountered)('urlShortening'));
                return null;
            });
        }, (0, (/*@__PURE__*/$parcel$interopDefault($1SBaA)))), this.getFormShareLink = ()=>{
            // original share link is used here
            return this.getRawLink();
        };
        // v0.4 -> v0.5 .client -> .shareClient
        (0, $3joPi.default)(!props.client, 'elements/share: Breaking change, please update your props!');
        this.shareClient = props.shareClient || new (0, $inlXa.ShareServiceClient)();
        this.urlShortenerClient = props.urlShortenerClient || new (0, $9b5JR.AtlassianUrlShortenerClient)();
        this.state = {
            shareActionCount: 0,
            config: $dd0122880035a80e$export$f84bd70098573c5c,
            isFetchingConfig: false,
            currentPageUrl: $dd0122880035a80e$var$getCurrentPageUrl(),
            shortenedCopyLink: null
        };
    }
    componentDidMount() {
        this._isMounted = true;
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    componentDidUpdate(prevProps) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($1SBaA)))(prevProps.shortLinkData, this.props.shortLinkData)) this.updateShortCopyLink();
    }
    getRawLink() {
        const { shareLink: shareLink } = this.props;
        const { currentPageUrl: currentPageUrl } = this.state;
        return shareLink || currentPageUrl;
    }
    getCopyLinkOriginTracing() {
        const { originTracingFactory: originTracingFactory } = this.props;
        const shareLink = this.getRawLink();
        return this.getUniqueCopyLinkOriginTracing(shareLink, originTracingFactory);
    }
    getFormShareOriginTracing() {
        const { originTracingFactory: originTracingFactory } = this.props;
        const { shareActionCount: shareActionCount } = this.state;
        const shareLink = this.getRawLink();
        return this.getUniqueFormShareOriginTracing(shareLink, originTracingFactory, shareActionCount);
    }
    getFullCopyLink() {
        const { formatCopyLink: formatCopyLink } = this.props;
        const shareLink = this.getRawLink();
        const copyLinkOrigin = this.getCopyLinkOriginTracing();
        return (formatCopyLink || $dd0122880035a80e$var$memoizedFormatCopyLink)(copyLinkOrigin, shareLink);
    }
    shouldShortenCopyLink() {
        return !!this.props.shortLinkData || !!this.props.useUrlShortener;
    }
    getShortenedCopyLink() {
        return this.shouldShortenCopyLink() && this.state.shortenedCopyLink || undefined;
    }
    getCopyLink() {
        return this.getShortenedCopyLink() || this.getFullCopyLink();
    }
    updateShortCopyLink() {
        this.setState({
            shortenedCopyLink: null
        });
        const { shortLinkData: shortLinkData } = this.props;
        if (!shortLinkData) return;
        const originId = this.getCopyLinkOriginTracing().id;
        const shortLink = this.getUpToDateShortenedCopyLink(shortLinkData, originId);
        const requestCounter = this._urlShorteningRequestCounter;
        shortLink.then((shortenedCopyLink)=>{
            if (!this._isMounted) return;
            const isRequestOutdated = requestCounter !== this._urlShorteningRequestCounter;
            if (isRequestOutdated) return;
            this.setState({
                shortenedCopyLink: shortenedCopyLink
            });
        });
    }
    render() {
        const { cloudId: cloudId, orgId: orgId, isAutoOpenDialog: isAutoOpenDialog, dialogPlacement: dialogPlacement, loadUserOptions: loadUserOptions, renderCustomTriggerButton: renderCustomTriggerButton, shareContentType: shareContentType, shareContentSubType: shareContentSubType, shareContentId: shareContentId, shareFormTitle: shareFormTitle, shareFormHelperMessage: shareFormHelperMessage, shouldCloseOnEscapePress: shouldCloseOnEscapePress, showFlags: showFlags, enableSmartUserPicker: enableSmartUserPicker, loggedInAccountId: loggedInAccountId, triggerButtonAppearance: triggerButtonAppearance, triggerButtonIcon: triggerButtonIcon, triggerButtonStyle: triggerButtonStyle, triggerButtonTooltipText: triggerButtonTooltipText, triggerButtonTooltipPosition: triggerButtonTooltipPosition, bottomMessage: bottomMessage, shareeAction: shareeAction, product: product, productAttributes: productAttributes, customHeader: customHeader, customFooter: customFooter, onTriggerButtonClick: onTriggerButtonClick, onUserSelectionChange: onUserSelectionChange, shareFieldsFooter: shareFieldsFooter, isCopyDisabled: isCopyDisabled, isPublicLink: isPublicLink, integrationMode: integrationMode, shareIntegrations: shareIntegrations, additionalTabs: additionalTabs, builtInTabContentWidth: builtInTabContentWidth, shareAri: shareAri, tabIndex: tabIndex, copyTooltipText: copyTooltipText, onDialogClose: onDialogClose, isBrowseUsersDisabled: isBrowseUsersDisabled, userPickerOptions: userPickerOptions, isSubmitShareDisabled: isSubmitShareDisabled, additionalUserFields: additionalUserFields, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled, CustomSubmitButton: CustomSubmitButton } = this.props;
        const { config: config, isFetchingConfig: isFetchingConfig } = this.state;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2sAb4.default), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7ZU6o.default), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7v5Ga.ShareDialogWithTrigger), {
                    onTriggerButtonClick: onTriggerButtonClick,
                    isAutoOpenDialog: isAutoOpenDialog,
                    config: config,
                    isFetchingConfig: isFetchingConfig,
                    copyLink: this.getCopyLink(),
                    analyticsDecorator: this.decorateAnalytics,
                    dialogPlacement: dialogPlacement,
                    loadUserOptions: loadUserOptions,
                    onDialogOpen: this.handleDialogOpen,
                    onShareSubmit: this.handleSubmitShare,
                    renderCustomTriggerButton: renderCustomTriggerButton,
                    shareContentType: shareContentType,
                    shareContentSubType: shareContentSubType,
                    shareContentId: shareContentId,
                    shareFormTitle: shareFormTitle,
                    shareFormHelperMessage: shareFormHelperMessage,
                    copyLinkOrigin: this.getCopyLinkOriginTracing(),
                    formShareOrigin: this.getFormShareOriginTracing(),
                    shouldCloseOnEscapePress: shouldCloseOnEscapePress,
                    showFlags: showFlags,
                    enableSmartUserPicker: enableSmartUserPicker,
                    loggedInAccountId: loggedInAccountId,
                    cloudId: cloudId,
                    orgId: orgId,
                    triggerButtonAppearance: triggerButtonAppearance,
                    triggerButtonIcon: triggerButtonIcon,
                    triggerButtonStyle: triggerButtonStyle,
                    triggerButtonTooltipPosition: triggerButtonTooltipPosition,
                    triggerButtonTooltipText: triggerButtonTooltipText,
                    bottomMessage: bottomMessage,
                    submitButtonLabel: shareeAction === 'edit' && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        ...(0, $idKBS.messages).inviteTriggerButtonText
                    }),
                    product: product,
                    productAttributes: productAttributes,
                    customHeader: (0, $VSDnB.fg)('platform_share_custom_header_prop') && customHeader,
                    customFooter: customFooter,
                    onUserSelectionChange: onUserSelectionChange,
                    shareFieldsFooter: shareFieldsFooter,
                    isCopyDisabled: isCopyDisabled,
                    isPublicLink: isPublicLink,
                    integrationMode: integrationMode,
                    shareIntegrations: shareIntegrations,
                    shareAri: shareAri,
                    tabIndex: tabIndex,
                    copyTooltipText: copyTooltipText,
                    onDialogClose: onDialogClose,
                    isBrowseUsersDisabled: isBrowseUsersDisabled,
                    userPickerOptions: userPickerOptions,
                    additionalTabs: additionalTabs,
                    builtInTabContentWidth: builtInTabContentWidth,
                    isSubmitShareDisabled: isSubmitShareDisabled,
                    additionalUserFields: additionalUserFields,
                    isExtendedShareDialogEnabled: isExtendedShareDialogEnabled,
                    CustomSubmitButton: CustomSubmitButton
                })
            })
        });
    }
}
const $dd0122880035a80e$export$78b28896b43ae5d6 = (0, $cb25w.default)()($dd0122880035a80e$export$bc8c417f2da43f4);

});
parcelRegister("1SBaA", function(module, exports) {
'use strict';
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});

parcelRegister("9b5JR", function(module, exports) {

$parcel$export(module.exports, "AtlassianUrlShortenerClient", () => $db8e8ad360042aaf$export$8fed7002650b52ef);
class $db8e8ad360042aaf$export$8fed7002650b52ef {
    async shorten(data) {
        try {
            const response = await fetch('/gateway/api/atl-link/create', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            });
            if (!response.ok) throw new Error(`status="${response.status}"`);
            const result = await response.json();
            if (!result.shortUrl) throw new Error('Breach of contract!');
            return result;
        } catch (err) {
            if (err instanceof Error) err.message = `While shortening URL: ${err.message}!`;
            throw err;
        }
    }
}

});

parcelRegister("inlXa", function(module, exports) {

$parcel$export(module.exports, "ShareServiceClient", () => $17bc358e1d85e6d0$export$ee05f3e1f0248b62);

var $dS9cn = parcelRequire("dS9cn");
const $17bc358e1d85e6d0$export$a7d7a4246bdd7a12 = 'share';
const $17bc358e1d85e6d0$export$1a440d9a41e6ce3e = 'share/configuration';
const $17bc358e1d85e6d0$export$7745139d0aa6183c = '/gateway/api';
class $17bc358e1d85e6d0$export$ee05f3e1f0248b62 {
    constructor(serviceConfig){
        this.serviceConfig = {
            url: $17bc358e1d85e6d0$export$7745139d0aa6183c,
            ...serviceConfig || {}
        };
    }
    getConfig(cloudId) {
        const options = {
            path: $17bc358e1d85e6d0$export$1a440d9a41e6ce3e,
            queryParams: {
                cloudId: cloudId
            },
            requestInit: {
                method: 'get'
            }
        };
        return (0, $dS9cn.utils).requestService(this.serviceConfig, options);
    }
    /**
	 * To send a POST request to the share endpoint in Share service
	 */ share(content, recipients, metadata, comment) {
        return fetch(`${this.serviceConfig.url}/${$17bc358e1d85e6d0$export$a7d7a4246bdd7a12}`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            credentials: 'include',
            body: JSON.stringify({
                content: content,
                recipients: recipients,
                metadata: metadata,
                comment: comment
            })
        }).then((response)=>{
            if (response.status === 204) return Promise.resolve();
            else if (response.ok) return response.json();
            else return Promise.reject({
                code: response.status,
                reason: response.statusText,
                body: response.json()
            });
        });
    }
}

});

parcelRegister("idKBS", function(module, exports) {

$parcel$export(module.exports, "messages", () => $990cec53807f67a0$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $990cec53807f67a0$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    formTitle: {
        id: 'fabric.elements.share.form.title',
        defaultMessage: 'Share',
        description: 'Title for Share form.'
    },
    formSend: {
        id: 'fabric.elements.share.form.send',
        defaultMessage: 'Send',
        description: 'Label for Share form submit button.'
    },
    formShare: {
        id: 'fabric.elements.share.form.share',
        defaultMessage: 'Share',
        description: 'Label for Share form submit button.'
    },
    formSendPublic: {
        id: 'fabric.elements.share.form.public.send',
        defaultMessage: 'Send public link',
        description: 'Label for Share form submit button when link is public.'
    },
    formSharePublic: {
        id: 'fabric.elements.share.form.public.share',
        defaultMessage: 'Share public link',
        description: 'Label for Share form submit button when link is public.'
    },
    formRetry: {
        id: 'fabric.elements.share.form.retry',
        defaultMessage: 'Retry',
        description: 'Label for Share from retry button.'
    },
    formNoPermissions: {
        id: 'fabric.elements.share.form.no-permissions',
        defaultMessage: 'You do not have the ability to share.',
        description: 'Copy to show when a user can not share.'
    },
    commentLabel: {
        id: 'fabric.elements.share.form.comment.label',
        defaultMessage: 'Message (optional)',
        description: 'Label for the comment field in the Share form.'
    },
    extendedDialogCommentLabel: {
        id: 'fabric.elements.share.form.extended.dialog.comment.label',
        defaultMessage: 'Message',
        description: 'Label for the comment field in the extended share dialog.'
    },
    commentPlaceholder: {
        id: 'fabric.elements.share.form.comment.placeholder',
        defaultMessage: 'Anything they should know?',
        description: 'Placeholder for the comment field in Share form.'
    },
    // Email disabled (Jira)
    userPickerLabelEmailDisabledJira: {
        id: 'fabric.elements.share.form.user-picker.label.email-disabled-jira',
        defaultMessage: 'Names or teams',
        description: 'Label for the user picker field in the Share form in Jira with no email option.'
    },
    userPickerPlaceholderEmailDisabledJira: {
        id: 'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira',
        defaultMessage: 'e.g. Maria, Team Orange',
        description: 'Placeholder for the user picker field in the Share form in Jira with no email option. These examples should be localized.'
    },
    userPickerRequiredMessageEmailDisabledJira: {
        id: 'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira',
        defaultMessage: 'Select at least one person or team',
        description: 'Error message for the user picker field in the Share form in Jira with no email option, when no entries are selected.'
    },
    // Email disabled (Confluence)
    userPickerLabelEmailDisabledConfluence: {
        id: 'fabric.elements.share.form.user-picker.label.email-disabled-confluence',
        defaultMessage: 'Names, teams, or groups',
        description: 'Label for the user picker field in the Share form in Confluence with no email option.'
    },
    userPickerRequiredMessageEmailDisabledConfluence: {
        id: 'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence',
        defaultMessage: 'Select at least one person, team, or group',
        description: 'Error message for the user picker field in the Share form in Confluence with no email option, when no entries are selected.'
    },
    // Browse users disabled
    userPickerLabelBrowseUsersDisabled: {
        id: 'fabric.elements.share.form.user-picker.label.email-only',
        defaultMessage: 'Emails',
        description: 'Label for the user picker field in the Share form when browse user permissions are disabled.'
    },
    userPickerPlaceholderBrowseUsersDisabled: {
        id: 'fabric.elements.share.form.user-picker.placeholder.email-only',
        defaultMessage: 'e.g. maria@company.com',
        description: 'Placeholder for the user picker field in the Share form when browse user permissions are disabled. These examples should be localized.'
    },
    userPickerRequiredMessageBrowseUsersDisabled: {
        id: 'fabric.elements.share.form.user-picker.validation.required-message.email-only',
        defaultMessage: 'Select at least one email',
        description: 'Error message for the user picker field in the Share form in when browse user permissions are disabled, when no entries are selected.'
    },
    // Generic (Jira)
    userPickerLabelJira: {
        id: 'fabric.elements.share.form.user-picker.label.jira',
        defaultMessage: 'Names, teams, or emails',
        description: 'Label for the user picker field in the Share form in Jira.'
    },
    userPickerPlaceholderJira: {
        id: 'fabric.elements.share.form.user-picker.placeholder.jira',
        defaultMessage: 'e.g. Maria, Team Orange, maria@company.com',
        description: 'Placeholder for the user picker field in the Share form in Jira. These examples should be localized.'
    },
    userPickerRequiredMessageJira: {
        id: 'fabric.elements.share.form.user-picker.validation.required-message.jira',
        defaultMessage: 'Select at least one person, team, or email',
        description: 'Error message for the user picker field in the Share form in Jira, when no entries are selected.'
    },
    // Generic (Confluence)
    userPickerLabelConfluence: {
        id: 'fabric.elements.share.form.user-picker.label.confluence',
        defaultMessage: 'Names, teams, groups, or emails',
        description: 'Label for the user picker field in the Share form in Confluence.'
    },
    userPickerPlaceholderConfluence: {
        id: 'fabric.elements.share.form.user-picker.placeholder.confluence',
        defaultMessage: 'e.g. Maria, Team Orange, group-one',
        description: 'Placeholder for the user picker field in the Share form in Confluence. These examples should be localized.'
    },
    userPickerRequiredMessageConfluence: {
        id: 'fabric.elements.share.form.user-picker.validation.required-message.confluence',
        defaultMessage: 'Select at least one person, team, group, or email',
        description: 'Error message for the user picker field in the Share form in Confluence, when no entries are selected.'
    },
    // Common messages
    userPickerAddMoreMessage: {
        id: 'fabric.elements.share.form.user-picker.add-more',
        defaultMessage: 'Enter more',
        description: 'Message to encourage the user to add more items to user picker in Share form.'
    },
    userPickerRequiredMessage: {
        id: 'fabric.elements.share.form.user-picker.validation.required',
        defaultMessage: 'Select at least one user, group, team or email.',
        description: 'Required error message for the user picker field in Share form.'
    },
    userPickerExistingUserOnlyNoOptionsMessage: {
        id: 'fabric.elements.share.form.user-picker.no-options.existingUserOnly',
        defaultMessage: `We couldn\u{2019}t find any results for "{inputValue}".`,
        description: 'Existing user only no options message displayed when the search for users returns empty.'
    },
    userPickerGenericNoOptionsMessage: {
        id: 'fabric.elements.share.form.user-picker.no-options.generic',
        defaultMessage: `We couldn\u{2019}t find any results for "{inputValue}". Invite people by using an email address.`,
        description: 'Generic no options message displayed when the search for users returns empty.'
    },
    shareTriggerButtonIconLabel: {
        id: 'fabric.elements.share.trigger.button.icon.label',
        defaultMessage: 'Share icon',
        description: 'Default text for aria-label of the share dialog trigger button icon'
    },
    shareTriggerButtonText: {
        id: 'fabric.elements.share.trigger.button.text',
        defaultMessage: 'Share',
        description: 'Default text for the share dialog trigger button'
    },
    shareTriggerButtonTooltipText: {
        id: 'fabric.elements.share.trigger.button.tooltip.text',
        defaultMessage: 'Share',
        description: 'Default text for tooltip on the icon-only share dialog trigger button'
    },
    inviteTriggerButtonText: {
        id: 'fabric.elements.share.trigger.button.invite.text',
        defaultMessage: 'Invite',
        description: 'Button label for when the sharee action is set to "edit".'
    },
    copyLinkButtonText: {
        id: 'fabric.elements.share.copylink.button.text',
        defaultMessage: 'Copy link',
        description: 'Default text for the Copy Link button'
    },
    copyPublicLinkButtonText: {
        id: 'fabric.elements.share.copypubliclink.button.text',
        defaultMessage: 'Copy public link',
        description: 'Default text for the Copy Link button when the link is public'
    },
    copiedToClipboardMessage: {
        id: 'fabric.elements.share.copied.to.clipboard.message',
        defaultMessage: 'Link copied to clipboard',
        description: 'Default text for the copied link message'
    },
    infoMessageDefaultConfluence: {
        id: 'fabric.elements.share.form.info.message.no.invite.confluence',
        defaultMessage: 'Recipients will see the name of the page and your message',
        description: 'Message indicating the recipients of the email share will be able to see the Confluence page title and the included message'
    },
    infoMessageDefaultJira: {
        id: 'fabric.elements.share.form.info.message.no.invite.jira',
        defaultMessage: 'Recipients will see the name of the issue and your message',
        description: 'Message indicating the recipients of the email share will be able to see the Jira issue title and the included message'
    },
    infoMessageDefaultJiraIssueTermRefresh: {
        id: 'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh',
        defaultMessage: 'Recipients will see the name of the work item and your message',
        description: 'Message indicating the recipients of the email share will be able to see the Jira issue title and the included message'
    },
    requiredFieldSummary: {
        id: 'fabric.elements.share.form.required-field.summary',
        defaultMessage: 'Required fields are marked with an asterisk',
        description: 'Summary info of required fields asterisk.'
    },
    shareFailureIconLabel: {
        id: 'fabric.elements.share.failure.icon.label',
        defaultMessage: 'Error icon',
        description: 'Default text for the aria-label of the share failure error icon in the tooltip'
    },
    shareFailureMessage: {
        id: 'fabric.elements.share.failure.message',
        defaultMessage: 'Unable to share',
        description: 'Default text for share failure message displayed in the tooltip'
    },
    shareSuccessMessage: {
        id: 'fabric.elements.share.success.message',
        defaultMessage: "{object, select,blogpost {Blog post shared}board {Board shared}calendar {Calendar shared}draft {Draft shared}filter {Filter shared}issue {Issue shared}summary {Summary shared}list {List shared}timeline {Timeline shared}form {Form shared}media {Media shared}page {Page shared}project {Project shared}pullrequest {Pull Request shared}question {Question shared}report {Report shared}repository {Repository shared}request {Request shared}roadmap {Timeline shared}site {Site shared}space {Space shared}other {Link Shared}}",
        description: 'Default text for share success message displayed in a flag'
    },
    shareToIntegrationButtonText: {
        id: 'fabric.elements.share.to.integration.button',
        defaultMessage: 'Share to {integrationName}',
        description: 'Text for the button that allows the user to share the currently viewed item through a 3rd party app like Slack'
    },
    shareInIntegrationButtonText: {
        id: 'fabric.elements.share.in.integration.button',
        defaultMessage: 'Share in {integrationName}',
        description: 'Text for the button that allows the user to share the currently viewed item through a 3rd party app like Slack'
    },
    shareMainTabTextJira: {
        id: 'fabric.elements.share.main.tab.text.jira',
        defaultMessage: 'Share issue',
        description: 'Text for the main share tab for jira'
    },
    shareMainTabTextConfluence: {
        id: 'fabric.elements.share.main.tab.text.confluence',
        defaultMessage: 'Share page',
        description: 'Text for the main share tab for confluence'
    },
    inviteToConfluence: {
        id: 'fabric.elements.share.invite.to.confluence',
        defaultMessage: 'Invite to Confluence',
        description: 'Text for the byline of the non-licensed users'
    },
    inviteToJira: {
        id: 'fabric.elements.share.invite.to.jira',
        defaultMessage: 'Invite to Jira',
        description: 'Text for the byline of the non-licensed users'
    },
    sharePopupLabel: {
        id: 'fabric.elements.share.popup.label',
        defaultMessage: 'Share',
        description: 'Label of the popup that contains share menu used by assistive technologies'
    },
    slackMenuItemText: {
        id: 'fabric.elements.share.menu.slack.label',
        defaultMessage: 'Slack',
        description: 'Text for the slack menu in share'
    },
    emailMenuItemText: {
        id: 'fabric.elements.share.menu.email.label',
        defaultMessage: 'Email',
        description: 'Text for the email menu in share'
    }
});

});

parcelRegister("b2oBK", function(module, exports) {

$parcel$export(module.exports, "CHANNEL_ID", () => $5f90f772f4877396$export$e5fd2b76433ec8a8);
$parcel$export(module.exports, "ANALYTICS_SOURCE", () => $5f90f772f4877396$export$f7109619a5e9e0d6);
$parcel$export(module.exports, "INTEGRATION_MODAL_SOURCE", () => $5f90f772f4877396$export$8944b0a832f27e18);
$parcel$export(module.exports, "screenEvent", () => $5f90f772f4877396$export$a129deea0412e0d8);
$parcel$export(module.exports, "shareSplitButtonEvent", () => $5f90f772f4877396$export$eab30ffadcd0ab75);
$parcel$export(module.exports, "shareIntegrationButtonEvent", () => $5f90f772f4877396$export$f04d85d45801fef1);
$parcel$export(module.exports, "errorEncountered", () => $5f90f772f4877396$export$afe83ea4a1997503);
$parcel$export(module.exports, "shareTriggerButtonClicked", () => $5f90f772f4877396$export$584e8ee8b04ff145);
$parcel$export(module.exports, "shareTabClicked", () => $5f90f772f4877396$export$544b588ba577a9a6);
$parcel$export(module.exports, "shareMenuItemClicked", () => $5f90f772f4877396$export$69ab8fd7ab99f6db);
$parcel$export(module.exports, "cancelShare", () => $5f90f772f4877396$export$b4731c87331a8174);
$parcel$export(module.exports, "shortUrlRequested", () => $5f90f772f4877396$export$35781a2d50f9fba9);
$parcel$export(module.exports, "shortUrlGenerated", () => $5f90f772f4877396$export$e78d65558f8d859a);
$parcel$export(module.exports, "copyLinkButtonClicked", () => $5f90f772f4877396$export$9af471d00b79f9b0);
$parcel$export(module.exports, "formShareSubmitted", () => $5f90f772f4877396$export$e2e6cacbe383cb80);

var $3smIt = parcelRequire("3smIt");
const $5f90f772f4877396$var$buildAttributes = (attributes = {})=>({
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        ...attributes
    });
const $5f90f772f4877396$var$createEvent = (eventType, source, action, actionSubject, actionSubjectId, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        source: source,
        attributes: $5f90f772f4877396$var$buildAttributes(attributes)
    });
const $5f90f772f4877396$var$createScreenEvent = (name, attributes = {})=>({
        eventType: 'screen',
        name: name,
        attributes: $5f90f772f4877396$var$buildAttributes(attributes)
    });
const $5f90f772f4877396$export$e5fd2b76433ec8a8 = 'fabric-elements';
const $5f90f772f4877396$export$f7109619a5e9e0d6 = 'shareModal';
const $5f90f772f4877396$export$8944b0a832f27e18 = 'integrationShareDialog';
const $5f90f772f4877396$export$a129deea0412e0d8 = ({ isPublicLink: isPublicLink = false })=>$5f90f772f4877396$var$createScreenEvent($5f90f772f4877396$export$f7109619a5e9e0d6, {
        isPublicLink: isPublicLink
    });
const $5f90f772f4877396$export$eab30ffadcd0ab75 = ()=>$5f90f772f4877396$var$createEvent('ui', $5f90f772f4877396$export$8944b0a832f27e18, 'clicked', 'button', 'shareSplitButton');
const $5f90f772f4877396$export$f04d85d45801fef1 = (type = '')=>$5f90f772f4877396$var$createEvent('ui', $5f90f772f4877396$export$8944b0a832f27e18, 'clicked', 'button', 'shareToIntegration', {
        integrationType: type.toLowerCase()
    });
const $5f90f772f4877396$export$afe83ea4a1997503 = (actionSubjectId, attributes = {})=>$5f90f772f4877396$var$createEvent('operational', $5f90f772f4877396$export$f7109619a5e9e0d6, 'encountered', 'error', actionSubjectId, {
        ...attributes,
        source: $5f90f772f4877396$export$f7109619a5e9e0d6
    });
const $5f90f772f4877396$export$584e8ee8b04ff145 = ()=>$5f90f772f4877396$var$createEvent('ui', $5f90f772f4877396$export$f7109619a5e9e0d6, 'clicked', 'button', 'share');
const $5f90f772f4877396$export$544b588ba577a9a6 = (subjectId, shareContentType)=>$5f90f772f4877396$var$createEvent('ui', $5f90f772f4877396$export$f7109619a5e9e0d6, 'clicked', 'tab', subjectId || 'shareTab', {
        shareContentType: shareContentType
    });
const $5f90f772f4877396$export$69ab8fd7ab99f6db = (subjectId, shareContentType)=>$5f90f772f4877396$var$createEvent('ui', $5f90f772f4877396$export$f7109619a5e9e0d6, 'clicked', 'menuItem', subjectId || 'shareMenuItem', {
        shareContentType: shareContentType
    });
const $5f90f772f4877396$export$b4731c87331a8174 = (start)=>$5f90f772f4877396$var$createEvent('ui', $5f90f772f4877396$export$f7109619a5e9e0d6, 'pressed', 'keyboardShortcut', 'cancelShare', {
        source: $5f90f772f4877396$export$f7109619a5e9e0d6,
        duration: $5f90f772f4877396$var$duration(start)
    });
const $5f90f772f4877396$export$35781a2d50f9fba9 = ()=>$5f90f772f4877396$var$createEvent('operational', $5f90f772f4877396$export$f7109619a5e9e0d6, 'requested', 'shortUrl', undefined, {
        source: $5f90f772f4877396$export$f7109619a5e9e0d6
    });
const $5f90f772f4877396$export$e78d65558f8d859a = (start, tooSlow)=>$5f90f772f4877396$var$createEvent('operational', $5f90f772f4877396$export$f7109619a5e9e0d6, 'generated', 'shortUrl', undefined, {
        source: $5f90f772f4877396$export$f7109619a5e9e0d6,
        duration: $5f90f772f4877396$var$duration(start),
        tooSlow: tooSlow
    });
const $5f90f772f4877396$export$9af471d00b79f9b0 = ({ start: start, shareContentType: shareContentType, shareContentSubType: shareContentSubType, shareContentId: shareContentId, shareOrigin: shareOrigin, isPublicLink: isPublicLink = false, ari: ari })=>$5f90f772f4877396$var$createEvent('ui', $5f90f772f4877396$export$f7109619a5e9e0d6, 'clicked', 'button', 'copyShareLink', {
        source: $5f90f772f4877396$export$f7109619a5e9e0d6,
        duration: $5f90f772f4877396$var$duration(start),
        shortUrl: undefined,
        // unknown at creation, will be filled later
        contentType: shareContentType,
        contentSubType: shareContentSubType,
        contentId: shareContentId,
        isPublicLink: isPublicLink,
        ari: ari,
        // this specific string is needed for marking a successful navigation session
        navdexPointType: 'navigationSessionEnd',
        ...$5f90f772f4877396$var$getOriginTracingAttributes(shareOrigin)
    });
const $5f90f772f4877396$export$e2e6cacbe383cb80 = ({ start: start, data: data, shareContentType: shareContentType, shareContentSubType: shareContentSubType, shareContentId: shareContentId, shareOrigin: shareOrigin, isPublicLink: isPublicLink = false })=>{
    const users = $5f90f772f4877396$var$extractIdsByType(data, (0, $3smIt.isUser));
    const externalUsers = $5f90f772f4877396$var$extractIdsByType(data, (0, $3smIt.isExternalUser));
    const groups = $5f90f772f4877396$var$extractIdsByType(data, (0, $3smIt.isGroup));
    const teams = $5f90f772f4877396$var$extractIdsByType(data, (0, $3smIt.isTeam));
    const teamUserCounts = $5f90f772f4877396$var$extractMemberCountsFromTeams(data, (0, $3smIt.isTeam));
    const emails = $5f90f772f4877396$var$extractIdsByType(data, (0, $3smIt.isEmail));
    return $5f90f772f4877396$var$createEvent('ui', $5f90f772f4877396$export$f7109619a5e9e0d6, 'clicked', 'button', 'submitShare', {
        ...$5f90f772f4877396$var$getOriginTracingAttributes(shareOrigin),
        contentType: shareContentType,
        contentSubType: shareContentSubType,
        contentId: shareContentId,
        duration: $5f90f772f4877396$var$duration(start),
        emailCount: emails.length,
        teamCount: teams.length,
        userCount: users.length,
        groupCount: groups.length,
        externalUserCount: externalUsers.length,
        users: users,
        teams: teams,
        teamUserCounts: teamUserCounts,
        groups: groups,
        messageLength: data.comment && data.comment.format === 'plain_text' ? data.comment.value.length : 0,
        isMessageEnabled: true,
        isPublicLink: isPublicLink
    });
};
const $5f90f772f4877396$var$duration = (start)=>Date.now() - start;
const $5f90f772f4877396$var$getOriginTracingAttributes = (origin)=>origin ? origin.toAnalyticsAttributes({
        hasGeneratedId: true
    }) : {};
const $5f90f772f4877396$var$extractIdsByType = (data, checker)=>data.users.filter(checker).map((option)=>option.id);
const $5f90f772f4877396$var$extractMemberCountsFromTeams = (data, checker)=>// teams with zero memberships cannot exist in share, so we use that
    // as the default value for undefined team member counts
    data.users.filter(checker).map((option)=>option.memberCount || 0);

});

parcelRegister("hQWyD", function(module, exports) {

$parcel$export(module.exports, "isValidFailedExperience", () => $4557ff6e37d018ec$export$883079293b9cad76);
const $4557ff6e37d018ec$var$ignoredErrorStatusCode = [
    401,
    403,
    429
];
const $4557ff6e37d018ec$export$883079293b9cad76 = (experience, // the type for error is 'any' because consumers of the share config can pass in custom error objects
error)=>{
    const errorStatusCode = error.code || error.status || error.statusCode;
    if ($4557ff6e37d018ec$var$ignoredErrorStatusCode.includes(parseInt(errorStatusCode))) {
        experience.abort({
            metadata: {
                error: error
            }
        });
        return;
    }
    experience.failure({
        metadata: {
            error: error
        }
    });
};

});

parcelRegister("65uFp", function(module, exports) {

$parcel$export(module.exports, "renderShareDialogExp", () => $8388968bcc7a2bcd$export$99c0383421ae57eb);
$parcel$export(module.exports, "shareSubmitExp", () => $8388968bcc7a2bcd$export$31627ee726f40567);

var $7Zbvr = parcelRequire("7Zbvr");
var $boHLC = parcelRequire("boHLC");
const $8388968bcc7a2bcd$export$99c0383421ae57eb = new (0, $boHLC.UFOExperience)('render-share-dialog', {
    type: (0, $7Zbvr.ExperienceTypes).Experience,
    performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: 'people'
    }
});
const $8388968bcc7a2bcd$export$31627ee726f40567 = new (0, $boHLC.UFOExperience)('share-submit-action', {
    type: (0, $7Zbvr.ExperienceTypes).Experience,
    performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: 'people'
    }
});

});

parcelRegister("2sAb4", function(module, exports) {

$parcel$export(module.exports, "default", () => $d485dd997db54c76$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cb25w = parcelRequire("cb25w");

var $b2oBK = parcelRequire("b2oBK");
// ErrorBoundary does not support in functional component
// eslint-disable-next-line @repo/internal/react/no-class-components
class $d485dd997db54c76$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidCatch(error) {
        const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
        if (createAnalyticsEvent) createAnalyticsEvent((0, $b2oBK.errorEncountered)(undefined, {
            message: error.message,
            errorClass: error.name
        })).fire((0, $b2oBK.CHANNEL_ID));
        this.setState({
            hasError: true
        });
    }
    render() {
        const { hasError: hasError } = this.state;
        if (hasError) // Silently fail.
        return null;
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            hasError: false
        };
    }
}
var $d485dd997db54c76$export$2e2bcd8739ae039 = (0, $cb25w.default)()($d485dd997db54c76$var$ErrorBoundary);

});

parcelRegister("7ZU6o", function(module, exports) {

$parcel$export(module.exports, "default", () => $3769956cd18ef333$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");
var $i5FdW = parcelRequire("i5FdW");

var $55GMe = parcelRequire("55GMe");
const $3769956cd18ef333$var$MessagesIntlProvider = ({ intl: intl, children: children })=>{
    const mergedMessages = (0, $5uXOq.useMemo)(()=>{
        return {
            ...intl.messages,
            ...(0, $55GMe.getMessagesForLocale)(intl.locale)
        };
    }, [
        intl.messages,
        intl.locale
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
        locale: intl.locale,
        messages: mergedMessages,
        defaultLocale: "en-US",
        children: children
    });
};
var $3769956cd18ef333$export$2e2bcd8739ae039 = (0, $8RXs9.default)($3769956cd18ef333$var$MessagesIntlProvider);

});
parcelRegister("55GMe", function(module, exports) {

$parcel$export(module.exports, "getMessagesForLocale", () => $8fc7d6e642efa1c9$export$d0a3169680473b6c);
// Cannot import from `../i18n` because there is `../i18n.tsx` file there.
/* eslint-disable @atlassian/tangerine/import/no-dangling-index */ 
var $aiyiV = parcelRequire("aiyiV");
var $c7HRD = parcelRequire("c7HRD");
var $gdvwP = parcelRequire("gdvwP");
var $1mT6n = parcelRequire("1mT6n");
var $axcS0 = parcelRequire("axcS0");
var $gM6wy = parcelRequire("gM6wy");
var $jCrgt = parcelRequire("jCrgt");
var $ddwcq = parcelRequire("ddwcq");
var $2Slqk = parcelRequire("2Slqk");
var $byDyk = parcelRequire("byDyk");
var $9y8hX = parcelRequire("9y8hX");
var $bMFAQ = parcelRequire("bMFAQ");
var $4JZF5 = parcelRequire("4JZF5");
var $dzumV = parcelRequire("dzumV");
var $fH3rr = parcelRequire("fH3rr");
var $16RW6 = parcelRequire("16RW6");
var $hrNSu = parcelRequire("hrNSu");
var $ioYTp = parcelRequire("ioYTp");
var $iQCSg = parcelRequire("iQCSg");
var $hkr2R = parcelRequire("hkr2R");
var $7dbDF = parcelRequire("7dbDF");
var $8zZLq = parcelRequire("8zZLq");
var $dGOFQ = parcelRequire("dGOFQ");
var $64yeQ = parcelRequire("64yeQ");
var $iTJhG = parcelRequire("iTJhG");
const $8fc7d6e642efa1c9$var$localesMessagesMap = {
    cs: $aiyiV.default,
    da: $c7HRD.default,
    de: $gdvwP.default,
    en: $1mT6n.default,
    en_GB: $axcS0.default,
    en_ZZ: $gM6wy.default,
    es: $jCrgt.default,
    et: $ddwcq.default,
    fi: $2Slqk.default,
    fr: $byDyk.default,
    hu: $9y8hX.default,
    is: $bMFAQ.default,
    it: $4JZF5.default,
    ja: $dzumV.default,
    ko: $fH3rr.default,
    nb: $16RW6.default,
    nl: $hrNSu.default,
    pl: $ioYTp.default,
    pt_BR: $iQCSg.default,
    'pt-BR': (0, $iQCSg.default),
    pt_PT: $hkr2R.default,
    'pt-PT': (0, $hkr2R.default),
    ro: $7dbDF.default,
    ru: $8zZLq.default,
    sk: $dGOFQ.default,
    sv: $64yeQ.default,
    zh: $iTJhG.default
};
const $8fc7d6e642efa1c9$export$d0a3169680473b6c = (locale)=>{
    let messages = $8fc7d6e642efa1c9$var$localesMessagesMap[locale];
    if (!messages) {
        const parentLocale = locale.split(/[-_]/)[0];
        messages = $8fc7d6e642efa1c9$var$localesMessagesMap[parentLocale];
    }
    if (!messages) messages = (0, $1mT6n.default);
    return messages;
};

});
parcelRegister("aiyiV", function(module, exports) {

$parcel$export(module.exports, "default", () => $b03a8517fda6267e$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Czech
var $b03a8517fda6267e$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Odkaz zkop\xedrov\xe1n do schr\xe1nky",
    'fabric.elements.share.copylink.button.text': "Zkop\xedrovat odkaz",
    'fabric.elements.share.copypubliclink.button.text': "Kop\xedrovat ve\u0159ejn\xfd odkaz",
    'fabric.elements.share.failure.icon.label': 'Ikona chyby',
    'fabric.elements.share.failure.message': "Nelze sd\xedlet",
    'fabric.elements.share.form.comment.label': "Zpr\xe1va (voliteln\xe1)",
    'fabric.elements.share.form.comment.placeholder': "N\u011Bco, co by m\u011Bli v\u011Bd\u011Bt?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "P\u0159\xedjemci uvid\xed n\xe1zev str\xe1nky a\xa0va\u0161i zpr\xe1vu.",
    'fabric.elements.share.form.info.message.no.invite.jira': "P\u0159\xedjemci uvid\xed n\xe1zev po\u017Eadavku a\xa0va\u0161i zpr\xe1vu.",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "P\u0159\xedjemci uvid\xed n\xe1zev po\u017Eadavku a\xa0va\u0161i zpr\xe1vu.",
    'fabric.elements.share.form.no-permissions': "Nem\xe1te mo\u017Enost sd\xedlet.",
    'fabric.elements.share.form.public.send': "Odeslat ve\u0159ejn\xfd odkaz",
    'fabric.elements.share.form.public.share': "Sd\xedlet ve\u0159ejn\xfd odkaz",
    'fabric.elements.share.form.required-field.summary': "Povinn\xe1 pole jsou ozna\u010Dena hv\u011Bzdi\u010Dkou.",
    'fabric.elements.share.form.retry': 'Zkusit znovu',
    'fabric.elements.share.form.send': 'Odeslat',
    'fabric.elements.share.form.share': "Sd\xedlet",
    'fabric.elements.share.form.title': "Sd\xedlet",
    'fabric.elements.share.form.user-picker.add-more': "Zadejte v\xedce",
    'fabric.elements.share.form.user-picker.label.confluence': "Jm\xe9na, t\xfdmy, skupiny nebo e-maily",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "Jm\xe9na, t\xfdmy nebo skupiny",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "Jm\xe9na nebo t\xfdmy",
    'fabric.elements.share.form.user-picker.label.email-only': 'E-maily',
    'fabric.elements.share.form.user-picker.label.jira': "Jm\xe9na, t\xfdmy nebo e-maily",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Pro \u201E{inputValue}\u201C se nepoda\u0159ilo naj\xedt \u017E\xe1dn\xe9 v\xfdsledky.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Pro \u201E{inputValue}\u201C se nepoda\u0159ilo naj\xedt \u017E\xe1dn\xe9 v\xfdsledky. Pozv\u011Bte lidi pomoc\xed jejich e-mailov\xe9 adresy.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': "nap\u0159. Marie, T\xfdm pomeran\u010D, skupina-jedna",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "nap\u0159. Marie, T\xfdm pomeran\u010D",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "nap\u0159. marie@spolecnost.cz",
    'fabric.elements.share.form.user-picker.placeholder.jira': "nap\u0159. Marie, T\xfdm pomeran\u010D, marie@spolecnost.cz",
    'fabric.elements.share.form.user-picker.validation.required': "Vyberte alespo\u0148 jednoho u\u017Eivatele, skupinu, t\xfdm nebo e-mail.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "Vyberte alespo\u0148 jednu osobu, t\xfdm, skupinu nebo e-mail",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "Vyberte alespo\u0148 jednu osobu, t\xfdm nebo skupinu",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "Vyberte alespo\u0148 jednu osobu nebo t\xfdm",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "Vyberte alespo\u0148 jeden e-mail",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "Vyberte alespo\u0148 jednu osobu, t\xfdm nebo e-mail",
    'fabric.elements.share.in.integration.button': "Sd\xedlet v: {integrationName}",
    'fabric.elements.share.invite.to.confluence': 'Pozvat do Confluence',
    'fabric.elements.share.invite.to.jira': 'Pozvat do Jira',
    'fabric.elements.share.main.tab.text.confluence': "Sd\xedlet str\xe1nku",
    'fabric.elements.share.main.tab.text.jira': "Sd\xedlet po\u017Eadavek",
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "Sd\xedlet",
    'fabric.elements.share.success.message': "{object, select,blogpost {P\u0159\xedsp\u011Bvek na blogu byl sd\xedlen}board {Board byl sd\xedlen}calendar {Kalend\xe1\u0159 byl sd\xedlen}draft {Koncept byl sd\xedlen}filter {Filtr byl sd\xedlen}issue {Po\u017Eadavek byl sd\xedlen}summary {Souhrn byl sd\xedlen}list {Seznam byl sd\xedlen}timeline {\u010Casov\xe1 osa byla sd\xedlena}form {Formul\xe1\u0159 byl sd\xedlen}media {Multim\xe9dia byla sd\xedlena}page {Str\xe1nka byla sd\xedlena}project {Projekt byl sd\xedlen}pullrequest {Pull request byl sd\xedlen}question {Ot\xe1zka byla sd\xedlena}report {Sestava byla sd\xedlena}repository {Repozit\xe1\u0159 byl sd\xedlen}request {\u017D\xe1dost byla sd\xedlena}roadmap {\u010Casov\xe1 osa byla sd\xedlena}site {Web byl sd\xedlen}space {Prostor byl sd\xedlen}other {Odkaz byl sd\xedlen}}",
    'fabric.elements.share.to.integration.button': "Sd\xedlet ve slu\u017Eb\u011B {integrationName}",
    'fabric.elements.share.trigger.button.icon.label': "Ikona sd\xedlen\xed",
    'fabric.elements.share.trigger.button.invite.text': 'Pozvat',
    'fabric.elements.share.trigger.button.text': "Sd\xedlet",
    'fabric.elements.share.trigger.button.tooltip.text': "Sd\xedlet"
};

});

parcelRegister("c7HRD", function(module, exports) {

$parcel$export(module.exports, "default", () => $40449a444ce6f8c1$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Danish (Denmark)
var $40449a444ce6f8c1$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Link er kopieret til udklipsholder',
    'fabric.elements.share.copylink.button.text': 'Kopier link',
    'fabric.elements.share.copypubliclink.button.text': "Kopi\xe9r offentligt link",
    'fabric.elements.share.failure.icon.label': 'Fejlikon',
    'fabric.elements.share.failure.message': 'Kan ikke deles',
    'fabric.elements.share.form.comment.label': 'Besked (valgfrit)',
    'fabric.elements.share.form.comment.placeholder': "Er der noget, de b\xf8r vide?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "Modtagere vil se navnet p\xe5 siden og din besked",
    'fabric.elements.share.form.info.message.no.invite.jira': "Modtagere vil se navnet p\xe5 sagen og din meddelelse",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "Modtagere f\xe5r vist navnet p\xe5 sagen og din besked",
    'fabric.elements.share.form.no-permissions': 'Du kan ikke dele.',
    'fabric.elements.share.form.public.send': 'Send offentligt link',
    'fabric.elements.share.form.public.share': 'Del offentligt link',
    'fabric.elements.share.form.required-field.summary': "P\xe5kr\xe6vede felter er markeret med en stjerne",
    'fabric.elements.share.form.retry': "Pr\xf8v igen",
    'fabric.elements.share.form.send': 'Send',
    'fabric.elements.share.form.share': 'Del',
    'fabric.elements.share.form.title': 'Del',
    'fabric.elements.share.form.user-picker.add-more': 'Indtast mere',
    'fabric.elements.share.form.user-picker.label.confluence': 'Navne, teams, grupper eller e-mails',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Navne, teams eller grupper',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Navne eller teams',
    'fabric.elements.share.form.user-picker.label.email-only': 'E-mails',
    'fabric.elements.share.form.user-picker.label.jira': 'Navne, teams eller e-mails',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'Vi kunne ikke finde nogen resultater for "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'Vi kunne ikke finde nogen resultater for "{inputValue}". Invit\xe9r personer via e-mailadresser.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': 'f.eks. Maria, Team Orange, gruppe et',
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'f.eks. Maria, Team Orange',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'f.eks. maria@company.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'f.eks. Maria, Team Orange, maria@company.com',
    'fabric.elements.share.form.user-picker.validation.required': "V\xe6lg mindst \xe9n bruger, \xe9n gruppe, \xe9t team eller \xe9n e-mail.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "V\xe6lg mindst en person, et team, en gruppe eller en e-mail",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "V\xe6lg mindst en person, et team eller en gruppe",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "V\xe6lg mindst en person eller et team",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "V\xe6lg mindst en e-mail",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "V\xe6lg mindst en person, et team eller en e-mail",
    'fabric.elements.share.in.integration.button': 'Del i {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Inviter til Confluence',
    'fabric.elements.share.invite.to.jira': 'Inviter til Jira',
    'fabric.elements.share.main.tab.text.confluence': 'Del side',
    'fabric.elements.share.main.tab.text.jira': 'Del sag',
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Del',
    'fabric.elements.share.success.message': "{object, select,blogpost {Blogindl\xe6g delt}board {Tavle delt}calendar {Kalender delt}draft {Udkast delt}filter {Filter delt}issue {Sag delt}summary {Oversigt delt}list {Liste delt}timeline {Tidslinje delt}form {Formular delt}media {Medier delt}page {Side delt}project {Projekt delt}pullrequest {Pullanmodning delt}question {Sp\xf8rgsm\xe5l delt}report {Rapport delt}repository {Lager delt}request {Anmodning delt}roadmap {Tidslinje delt}site {Websted delt}space {Omr\xe5de delt}other {Link delt}}",
    'fabric.elements.share.to.integration.button': 'Del med {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Del ikon',
    'fabric.elements.share.trigger.button.invite.text': "Invit\xe9r",
    'fabric.elements.share.trigger.button.text': 'Del',
    'fabric.elements.share.trigger.button.tooltip.text': 'Del'
};

});

parcelRegister("gdvwP", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9ad081aeac1c38f$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //German (Germany)
var $c9ad081aeac1c38f$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Link in Zwischenablage kopiert',
    'fabric.elements.share.copylink.button.text': 'Link kopieren',
    'fabric.elements.share.copypubliclink.button.text': "\xd6ffentlichen Link kopieren",
    'fabric.elements.share.failure.icon.label': 'Fehler-Symbol',
    'fabric.elements.share.failure.message': "Teilen nicht m\xf6glich",
    'fabric.elements.share.form.comment.label': 'Nachricht (optional)',
    'fabric.elements.share.form.comment.placeholder': 'Irgendetwas Wissenswertes?',
    'fabric.elements.share.form.info.message.no.invite.confluence': "Empf\xe4nger sehen den Namen der Seite und Ihre Nachricht",
    'fabric.elements.share.form.info.message.no.invite.jira': "Empf\xe4nger sehen den Namen des Vorgangs und Ihre Nachricht",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "Empf\xe4nger sehen den Namen des Vorgangs und Ihre Nachricht",
    'fabric.elements.share.form.no-permissions': "Sie k\xf6nnen keine Elemente teilen.",
    'fabric.elements.share.form.public.send': "\xd6ffentlichen Link senden",
    'fabric.elements.share.form.public.share': "\xd6ffentlichen Link teilen",
    'fabric.elements.share.form.required-field.summary': 'Pflichtfelder sind mit einem Sternchen markiert.',
    'fabric.elements.share.form.retry': 'Erneut versuchen',
    'fabric.elements.share.form.send': 'Senden',
    'fabric.elements.share.form.share': 'Teilen',
    'fabric.elements.share.form.title': 'Teilen',
    'fabric.elements.share.form.user-picker.add-more': 'Weitere eingeben',
    'fabric.elements.share.form.user-picker.label.confluence': 'Namen, Teams, Gruppen oder E-Mail-Adressen',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Namen, Teams oder Gruppen',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Namen oder Teams',
    'fabric.elements.share.form.user-picker.label.email-only': 'E-Mail-Adressen',
    'fabric.elements.share.form.user-picker.label.jira': 'Namen, Teams oder E-Mail-Adressen',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Es wurden keine Ergebnisse f\xfcr \u201E{inputValue}\u201C gefunden.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Es wurden keine Ergebnisse f\xfcr \u201E{inputValue}\u201C gefunden. Laden Sie Personen mittels E-Mail-Adresse ein.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': "z.\xa0B. Maria, Team Orange, Gruppe eins",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "z.\xa0B. Maria, Team Orange",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "z.\xa0B. maria@company.com",
    'fabric.elements.share.form.user-picker.placeholder.jira': "z.\xa0B. Maria, Team Orange, maria@company.com",
    'fabric.elements.share.form.user-picker.validation.required': "W\xe4hlen Sie mindestens einen Benutzer, eine Gruppe, ein Team oder eine E-Mail-Adresse aus.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "W\xe4hlen Sie mindestens eine Person, ein Team, eine Gruppe oder eine E-Mail-Adresse aus.",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "W\xe4hlen Sie mindestens eine Person, ein Team oder eine Gruppe aus.",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "W\xe4hlen Sie mindestens eine Person oder ein Team aus.",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "W\xe4hlen Sie mindestens eine E-Mail-Adresse aus.",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "W\xe4hlen Sie mindestens eine Person, ein Team oder eine E-Mail-Adresse aus.",
    'fabric.elements.share.in.integration.button': 'In {integrationName} teilen',
    'fabric.elements.share.invite.to.confluence': 'Zu Confluence einladen',
    'fabric.elements.share.invite.to.jira': 'Zu Jira einladen',
    'fabric.elements.share.main.tab.text.confluence': 'Seite teilen',
    'fabric.elements.share.main.tab.text.jira': 'Vorgang teilen',
    'fabric.elements.share.menu.email.label': 'E-Mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Teilen',
    'fabric.elements.share.success.message': '{object, select,blogpost {Blogpost geteilt}board {Board geteilt}calendar {Kalender geteilt}draft {Entwurf geteilt}filter {Filter geteilt}issue {Vorgang geteilt}summary {Zusammenfassung geteilt}list {Liste geteilt}timeline {Zeitleiste geteilt}form {Formular geteilt}media {Medien geteilt}page {Seite geteilt}project {Projekt geteilt}pullrequest {Pull-Anfrage geteilt}question {Frage geteilt}report {Bericht geteilt}repository {Repository geteilt}request {Anfrage geteilt}roadmap {Zeitleiste geteilt}site {Site geteilt}space {Bereich geteilt}other {Link geteilt}}',
    'fabric.elements.share.to.integration.button': 'Mit {integrationName} teilen',
    'fabric.elements.share.trigger.button.icon.label': 'Teilen-Symbol',
    'fabric.elements.share.trigger.button.invite.text': 'Einladen',
    'fabric.elements.share.trigger.button.text': 'Teilen',
    'fabric.elements.share.trigger.button.tooltip.text': 'Teilen'
};

});

parcelRegister("1mT6n", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ae943d78330d54c$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $5ae943d78330d54c$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Link copied to clipboard',
    'fabric.elements.share.copylink.button.text': 'Copy link',
    'fabric.elements.share.copypubliclink.button.text': 'Copy public link',
    'fabric.elements.share.failure.icon.label': 'Error icon',
    'fabric.elements.share.failure.message': 'Unable to share',
    'fabric.elements.share.form.comment.label': 'Message (optional)',
    'fabric.elements.share.form.comment.placeholder': 'Anything they should know?',
    'fabric.elements.share.form.info.message.no.invite.confluence': 'Recipients will see the name of the page and your message',
    'fabric.elements.share.form.info.message.no.invite.jira': 'Recipients will see the name of the issue and your message',
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': 'Recipients will see the name of the work item and your message',
    'fabric.elements.share.form.no-permissions': 'You do not have the ability to share.',
    'fabric.elements.share.form.public.send': 'Send public link',
    'fabric.elements.share.form.public.share': 'Share public link',
    'fabric.elements.share.form.required-field.summary': 'Required fields are marked with an asterisk',
    'fabric.elements.share.form.retry': 'Retry',
    'fabric.elements.share.form.send': 'Send',
    'fabric.elements.share.form.share': 'Share',
    'fabric.elements.share.form.title': 'Share',
    'fabric.elements.share.form.user-picker.add-more': 'Enter more',
    'fabric.elements.share.form.user-picker.label.confluence': 'Names, teams, groups, or emails',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Names, teams, or groups',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Names or teams',
    'fabric.elements.share.form.user-picker.label.email-only': 'Emails',
    'fabric.elements.share.form.user-picker.label.jira': 'Names, teams, or emails',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'We couldn\u2019t find any results for "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'We couldn\u2019t find any results for "{inputValue}". Invite people by using an email address.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': 'e.g. Maria, Team Orange, group-one',
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'e.g. Maria, Team Orange',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'e.g. maria@company.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'e.g. Maria, Team Orange, maria@company.com',
    'fabric.elements.share.form.user-picker.validation.required': 'Select at least one user, group, team or email.',
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': 'Select at least one person, team, group, or email',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': 'Select at least one person, team, or group',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': 'Select at least one person or team',
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': 'Select at least one email',
    'fabric.elements.share.form.user-picker.validation.required-message.jira': 'Select at least one person, team, or email',
    'fabric.elements.share.in.integration.button': 'Share in {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Invite to Confluence',
    'fabric.elements.share.invite.to.jira': 'Invite to Jira',
    'fabric.elements.share.main.tab.text.confluence': 'Share page',
    'fabric.elements.share.main.tab.text.jira': 'Share issue',
    'fabric.elements.share.menu.email.label': 'Email',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Share',
    'fabric.elements.share.success.message': '{object, select,blogpost {Blog post shared}board {Board shared}calendar {Calendar shared}draft {Draft shared}filter {Filter shared}issue {Issue shared}summary {Summary shared}list {List shared}timeline {Timeline shared}form {Form shared}media {Media shared}page {Page shared}project {Project shared}pullrequest {Pull Request shared}question {Question shared}report {Report shared}repository {Repository shared}request {Request shared}roadmap {Timeline shared}site {Site shared}space {Space shared}other {Link Shared}}',
    'fabric.elements.share.to.integration.button': 'Share to {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Share icon',
    'fabric.elements.share.trigger.button.invite.text': 'Invite',
    'fabric.elements.share.trigger.button.text': 'Share',
    'fabric.elements.share.trigger.button.tooltip.text': 'Share'
};

});

parcelRegister("axcS0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4de2c962853eb1a7$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //English (United Kingdom)
var $4de2c962853eb1a7$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Link copied to clipboard',
    'fabric.elements.share.copylink.button.text': 'Copy link',
    'fabric.elements.share.copypubliclink.button.text': 'Copy public link',
    'fabric.elements.share.failure.icon.label': 'Error icon',
    'fabric.elements.share.failure.message': 'Unable to share',
    'fabric.elements.share.form.comment.label': 'Message (optional)',
    'fabric.elements.share.form.comment.placeholder': 'Anything they should know?',
    'fabric.elements.share.form.info.message.no.invite.confluence': 'Recipients will see the name of the page and your message',
    'fabric.elements.share.form.info.message.no.invite.jira': 'Recipients will see the name of the issue and your message',
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': 'Recipients will see the name of the work item and your message',
    'fabric.elements.share.form.no-permissions': 'You do not have the ability to share.',
    'fabric.elements.share.form.public.send': 'Send public link',
    'fabric.elements.share.form.public.share': 'Share public link',
    'fabric.elements.share.form.required-field.summary': 'Required fields are marked with an asterisk',
    'fabric.elements.share.form.retry': 'Retry',
    'fabric.elements.share.form.send': 'Send',
    'fabric.elements.share.form.share': 'Share',
    'fabric.elements.share.form.title': 'Share',
    'fabric.elements.share.form.user-picker.add-more': 'Enter more',
    'fabric.elements.share.form.user-picker.label.confluence': 'Names, teams, groups, or emails',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Names, teams, or groups',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Names or teams',
    'fabric.elements.share.form.user-picker.label.email-only': 'Emails',
    'fabric.elements.share.form.user-picker.label.jira': 'Names, teams, or emails',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'We couldn\u2019t find any results for "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'We couldn\u2019t find any results for "{inputValue}". Invite people by using an email address.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': 'e.g. Maria, Team Orange, group-one',
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'e.g. Maria, Team Orange',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'e.g. maria@company.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'e.g. Maria, Team Orange, maria@company.com',
    'fabric.elements.share.form.user-picker.validation.required': 'Select at least one user, group, team or email.',
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': 'Select at least one person, team, group, or email',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': 'Select at least one person, team, or group',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': 'Select at least one person or team',
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': 'Select at least one email',
    'fabric.elements.share.form.user-picker.validation.required-message.jira': 'Select at least one person, team, or email',
    'fabric.elements.share.in.integration.button': 'Share in {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Invite to Confluence',
    'fabric.elements.share.invite.to.jira': 'Invite to Jira',
    'fabric.elements.share.main.tab.text.confluence': 'Share page',
    'fabric.elements.share.main.tab.text.jira': 'Share issue',
    'fabric.elements.share.menu.email.label': 'Email',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Share',
    'fabric.elements.share.success.message': '{object, select,blogpost {Blog post shared}board {Board shared}calendar {Calendar shared}draft {Draft shared}filter {Filter shared}issue {Issue shared}summary {Summary shared}list {List shared}timeline {Timeline shared}form {Form shared}media {Media shared}page {Page shared}project {Project shared}pullrequest {Pull Request shared}question {Question shared}report {Report shared}repository {Repository shared}request {Request shared}roadmap {Timeline shared}site {Site shared}space {Space shared}other {Link Shared}}',
    'fabric.elements.share.to.integration.button': 'Share to {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Share icon',
    'fabric.elements.share.trigger.button.invite.text': 'Invite',
    'fabric.elements.share.trigger.button.text': 'Share',
    'fabric.elements.share.trigger.button.tooltip.text': 'Share'
};

});

parcelRegister("gM6wy", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ca0de856e819520$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $8ca0de856e819520$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "\u2063\u2062Link copied to clipboard\x8f\u200D\x8f\u2061\u206B\u206A\u200D\u206E\x8f\x8d\x8f\u206C\u206A\u206C\x90\u200C\x9d\u206F\x81\x90\u206C\u206B\u2061\u206A\x8d\x8d\u206A\x90\u206C\x8d\u2060\u2061\u2063\u2064",
    'fabric.elements.share.copylink.button.text': "\u2063\u2062Copy link\x8d\u206C\x8f\u206E\u206A\u200D\u206E\x9d\x90\u061C\u2061\x8d\u206E\x90\u206D\x8d\u2061\u200C\u206F\x8d\u2061\x8d\u206A\x81\x81\u206B\u206E\u200C\x9d\u2060\u206F\x81\u2063\u2064",
    'fabric.elements.share.copypubliclink.button.text': "\u2063\u2062Copy public link\u2061\x81\u200C\u206F\u200D\u206D\x9d\u2061\x8f\u206C\u206D\x8f\u2061\x81\x81\u206A\u206A\x90\u206E\u2060\u061C\u2060\u206F\u206E\u206B\u206D\u200C\u061C\u200C\x9d\x9d\x9d\u2063\u2064",
    'fabric.elements.share.failure.icon.label': "\u2063\u2062Error icon\u200D\u061C\u206C\u206E\u206F\u2061\u206E\u206F\x8f\x90\u2060\u061C\x90\u061C\u200D\u200C\u206A\u206A\u200C\u200C\u206E\u206F\x90\u200D\u2061\u206B\u206A\u2060\x8f\u200C\x90\u206E\u2063\u2064",
    'fabric.elements.share.failure.message': "\u2063\u2062Unable to share\x8f\u206A\u206E\x90\u200D\x90\u2061\x90\u206A\x8d\u206D\x8d\x9d\u2060\x90\x9d\u206C\u2061\u206C\x9d\x8d\u206C\u206C\u206B\x9d\x8d\u206B\x9d\u200C\x81\u200D\u2060\u2063\u2064",
    'fabric.elements.share.form.comment.label': "\u2063\u2062Message (optional)\x8d\u200D\u206F\x8d\u206B\x90\u2060\u2061\u206D\u206E\u206F\u2061\u2060\x8f\u206C\u206E\u206B\x81\u200C\x90\u206D\u206C\x8d\u2060\u061C\u2060\u2060\x81\x8f\u200D\u200D\u206F\u2063\u2064",
    'fabric.elements.share.form.comment.placeholder': "\u2063\u2062Anything they should know?\u2060\u206F\x81\u061C\x8d\u2061\u2061\u200D\u206B\u206B\u206F\u206A\x81\u2061\u200C\u2060\x8d\x90\u206E\x90\u206E\x81\u206D\u200D\x8f\u206C\u206E\u206A\u206C\u2060\u206A\u206D\u2063\u2064",
    'fabric.elements.share.form.info.message.no.invite.confluence': "\u2063\u2062Recipients will see the name of the page and your message\u206F\u2060\x81\x90\u200C\u200C\x81\x90\u061C\u2060\x8d\u200C\x81\u206A\u2061\u061C\u206E\x8f\u2060\u206D\u206D\x8f\u200C\u200C\x9d\u206D\u200C\u2060\x8f\x8f\u206A\u200C\u2063\u2064",
    'fabric.elements.share.form.info.message.no.invite.jira': "\u2063\u2062Recipients will see the name of the issue and your message\x81\u206C\u206C\x8d\u206F\u200D\u206B\u200D\u2060\u061C\u2061\x81\u206D\x8d\u206A\x8d\x90\u206B\x8d\u206A\x8f\x8d\u206D\u206E\u206D\x9d\u200D\u206C\u206E\x9d\u206F\u2060\u2063\u2064",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "\u2063\u2062Recipients will see the name of the work item and your message\u061C\u206B\u200D\u206B\u206D\u2060\u200D\u200C\u200C\x90\x8f\u206D\u2060\u200C\x8f\u206E\u206B\x9d\x9d\u206E\x8f\u2060\x90\u206F\u2060\x9d\u206D\u2060\u206F\x81\u206B\u206B\u2063\u2064",
    'fabric.elements.share.form.no-permissions': "\u2063\u2062You do not have the ability to share.\x8f\u206B\u206F\x8f\u061C\u206B\u206D\x81\u206C\u206F\u206F\u206C\u2060\u206E\u200D\u200D\x81\x81\u200D\u206B\x8d\u206E\x9d\u206C\x8f\u206A\u2061\u2060\u2061\x90\u206D\u206E\u2063\u2064",
    'fabric.elements.share.form.public.send': "\u2063\u2062Send public link\u206E\u206B\x8d\u206D\u206E\u206C\u2060\u206F\u206B\u206F\u061C\u2060\x8d\x9d\u200D\u206F\u2060\u2061\u206E\x81\u061C\u206F\u206D\x8d\x8f\u200C\x8d\x81\u206D\u2061\u206B\u2060\u2063\u2064",
    'fabric.elements.share.form.public.share': "\u2063\u2062Share public link\u2060\u2061\x90\u200D\u206A\u206A\u200D\u206F\u200D\x8f\u206B\u200C\u2060\u206C\u061C\u200D\u206C\u200C\u206F\x9d\u206F\x8d\u200D\x81\x9d\u206D\u2061\u2061\u206D\u2061\u061C\u206E\u2063\u2064",
    'fabric.elements.share.form.required-field.summary': "\u2063\u2062Required fields are marked with an asterisk\x8d\x8d\u200D\u206C\u2060\u206F\u206A\x9d\u206F\u200D\x90\x9d\u206A\u206D\x9d\u206B\u206C\u200C\x90\x81\x81\u206C\u2061\u200C\u200C\u2060\u200D\u061C\u206B\x9d\u206B\x9d\u2063\u2064",
    'fabric.elements.share.form.retry': "\u2063\u2062Retry\u200C\u206B\u206F\u206D\u200C\x9d\u206C\u2061\u061C\u200C\u206C\u206C\u206A\u206C\u206C\x8d\x90\u206A\x9d\x8d\u206C\u206A\u200C\x81\x8f\x8f\u2061\u2061\u206F\x90\u200C\x8d\u2063\u2064",
    'fabric.elements.share.form.send': "\u2063\u2062Send\x90\u200D\u206D\u200C\x8f\u2060\u2060\u200D\u061C\u200D\x8d\u200C\u206D\u206F\u200D\u206E\u206B\u206D\u2061\u206F\x9d\u206F\u206F\u206F\u061C\u206A\u206D\u206A\x8d\x8d\u2060\u061C\u2063\u2064",
    'fabric.elements.share.form.share': "\u2063\u2062Share\u2060\x8f\u200C\u200D\x9d\x9d\u206A\u206D\u206B\u206C\x81\x90\x8d\u2060\x8f\x8f\u206C\u200C\u206A\u200C\u061C\u2060\u061C\x8f\u061C\x8f\u206D\u206E\x8f\x8f\u200C\x81\u2063\u2064",
    'fabric.elements.share.form.title': "\u2063\u2062Share\u206E\u206B\u2060\u206E\x9d\u206C\x8d\u061C\x90\x9d\u206A\u206B\u206D\u206F\u200C\u206F\u200D\x9d\u061C\u200D\u206E\u2060\u206E\x81\u206F\u061C\x8d\x81\x8f\u2061\u206B\u200C\u2063\u2064",
    'fabric.elements.share.form.user-picker.add-more': "\u2063\u2062Enter more\u2060\x9d\u2060\x81\u2061\u200D\u206B\u206F\u206E\x8d\x8d\u206B\u200C\u061C\u061C\u200C\x9d\u200D\u2060\x8d\x9d\u206C\x8f\u206A\x8f\u206B\x8d\x9d\u061C\u206C\u200D\u2060\u2063\u2064",
    'fabric.elements.share.form.user-picker.label.confluence': "\u2063\u2062Names, teams, groups, or emails\u206F\x9d\u206F\u206D\x81\u2061\x90\u200D\u206E\u2060\x90\x8f\x81\x8d\u2061\u206D\u200D\u206D\u200D\u206A\x9d\x81\u206F\u206C\u061C\x90\u200C\u200D\x81\x8d\u206E\u200D\u2063\u2064",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "\u2063\u2062Names, teams, or groups\u206A\x8d\x8f\u206F\x90\u206E\u200D\u206E\u2060\u061C\u206F\u206C\x8d\x8d\x9d\u200C\x90\u206F\x9d\u061C\u206C\x90\x90\u206B\u2060\u061C\u2060\u206E\x8d\u2061\x8f\u206A\u2063\u2064",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "\u2063\u2062Names or teams\x8d\u206B\u206C\u206D\u206E\x90\x9d\u200C\u206A\x90\x90\u206D\u200D\u206F\u200D\x8f\u061C\u061C\u206F\u206F\u061C\u206E\u206F\u206B\u2060\u061C\u2060\u200D\u2061\x9d\x8d\x90\u2063\u2064",
    'fabric.elements.share.form.user-picker.label.email-only': "\u2063\u2062Emails\x81\u061C\x9d\u206C\x8f\u206A\u200C\u206A\u206F\u2060\u206B\x9d\u206F\x90\x9d\x9d\u206A\u061C\x8f\u206B\u206F\u206E\x8f\u061C\x9d\u206C\u206E\u206F\u2060\u206C\x8f\u206C\u2063\u2064",
    'fabric.elements.share.form.user-picker.label.jira': "\u2063\u2062Names, teams, or emails\u200C\u2061\u206D\u206B\u200C\u061C\u206F\u061C\u2060\u200C\x8f\x8f\u2061\u206D\x81\u206B\x8f\u061C\u200D\x8d\x8f\u2061\u206E\u061C\u206D\x81\u2060\u061C\u2060\u206B\u206F\u200C\u2063\u2064",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': '\u2063\u2062We couldn\u2019t find any results for "{inputValue}".\u206D\x8f\x8f\u2061\u206D\u200C\x81\x9d\u206D\x90\x8f\u200C\u206E\u206F\u206B\x8f\u061C\u2061\u2061\u206F\u2061\x81\x9d\u2060\x90\u2060\u206B\x9d\u200D\u206D\u200D\u206A\u2063\u2064',
    'fabric.elements.share.form.user-picker.no-options.generic': '\u2063\u2062We couldn\u2019t find any results for "{inputValue}". Invite people by using an email address.\x8d\u2061\u061C\x8f\x9d\u206E\u061C\u200D\u2060\u206A\u206A\x9d\u061C\x9d\x8f\x90\u2060\u2060\u2061\u206E\u061C\u206F\u206C\x90\u2061\u2060\u206D\u200D\u206B\x8f\x90\u200D\u2063\u2064',
    'fabric.elements.share.form.user-picker.placeholder.confluence': "\u2063\u2062e.g. Maria, Team Orange, group-one\u200D\u206D\x81\u2061\u200D\u2060\u206B\u061C\x90\x8f\u206C\u206E\u206A\x8f\x8f\u061C\u206E\u200D\x90\x8d\x8d\x90\u206C\x90\u2061\u206C\x9d\u206F\x90\u206F\u206C\x9d\u2063\u2064",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "\u2063\u2062e.g. Maria, Team Orange\x81\u206E\u206C\x81\u061C\x9d\u2061\u206A\u206F\x9d\x90\u206C\u200C\x90\u2061\u200D\u206D\x90\u206F\x81\x81\u061C\u206C\u206C\u206C\x8d\u061C\x8d\u206F\u061C\u206A\u061C\u2063\u2064",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "\u2063\u2062e.g. maria@company.com\x8d\u206B\u206A\u061C\x9d\u206B\x81\u2060\u206B\x9d\u206B\u206C\u206B\u200C\u206C\u200D\u206C\u206F\u061C\u206B\x90\u206A\x8f\u2060\u200D\u061C\u206F\u206E\u200C\x8f\u061C\x8d\u2063\u2064",
    'fabric.elements.share.form.user-picker.placeholder.jira': "\u2063\u2062e.g. Maria, Team Orange, maria@company.com\x8f\x8d\u206A\u200C\u2061\u061C\u206D\x81\u2061\x8d\u206A\x8d\u200D\x8d\u206A\u206D\u2061\u2061\u061C\u200C\x9d\u200C\u206C\u200D\u206A\x8f\u206C\u2060\u206D\u206B\x9d\u2061\u2063\u2064",
    'fabric.elements.share.form.user-picker.validation.required': "\u2063\u2062Select at least one user, group, team or email.\x81\u206E\u206A\x81\u206F\u2061\x8f\x9d\x9d\u206D\u2061\u061C\u206B\u206F\x9d\u200C\u200D\u206D\u206B\x81\x81\u206A\u206F\u200C\x8d\x90\x81\u206B\u2060\u061C\x9d\u206B\u2063\u2064",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "\u2063\u2062Select at least one person, team, group, or email\u206B\x81\u206E\x9d\u206D\x90\u200D\x9d\u200C\u206D\x9d\u2060\u206B\x8d\x8f\u206C\u206C\u2061\u206D\u206F\x8d\x90\u200C\x90\u200D\u206F\u200C\u206A\u206D\u2061\u2060\u200D\u2063\u2064",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "\u2063\u2062Select at least one person, team, or group\x8d\u206C\u206F\u061C\x90\u206D\x9d\u206D\u206A\u200C\u206E\x8f\u2060\u206D\x81\u206A\x8d\u206A\x9d\x9d\u2060\u200C\u206A\x8f\u200C\x9d\x9d\u206E\u2061\x8d\x81\x8f\u2063\u2064",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "\u2063\u2062Select at least one person or team\u206A\u206F\u200D\x8f\u206D\u206F\u206B\x90\u206C\x81\u206E\u2060\u200D\u2061\x81\u206A\x8d\u206E\u206F\x8f\x9d\x8f\x8f\u2060\x9d\x81\x81\u206A\u206C\x81\u200C\u2061\u2063\u2064",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "\u2063\u2062Select at least one email\x8f\u206F\u206D\x81\u200D\u206B\u206B\x8d\u206D\x8d\u200C\x8d\x9d\u200C\u206F\u200D\u200D\u2060\u2061\u206F\u061C\x8d\u206F\x90\u200D\u2061\u206A\x8d\x90\u200C\x8f\u200C\u2063\u2064",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "\u2063\u2062Select at least one person, team, or email\u2060\x9d\u2060\u206A\x90\u200C\u200C\u061C\u206C\u200D\x8d\u200D\u200D\u2060\u200C\u206C\u206A\u206D\u206D\u206E\u200D\u200D\x90\u061C\u200C\u2060\u206A\u206B\u2061\u206A\u2060\x8f\u2063\u2064",
    'fabric.elements.share.in.integration.button': "\u2063\u2062Share in {integrationName}\u2060\u061C\x90\u206A\u2061\u206C\u206D\u2061\u206D\x90\x8f\x8f\u200C\u206B\u206A\x9d\u206C\u2061\u061C\u200C\x90\u206E\u206A\u206F\u206C\x81\u200C\x8f\u206C\u200C\x81\u206D\u2063\u2064",
    'fabric.elements.share.invite.to.confluence': "\u2063\u2062Invite to Confluence\u206A\u206E\x8f\u2061\x8f\u206D\u206B\x9d\u206A\x9d\x8f\u206F\u061C\u200D\u206B\u206A\u200D\x9d\u2060\u206D\u200D\x8f\u2061\x8d\u2060\u2061\u206E\x81\u206C\u061C\u200D\u200D\u2063\u2064",
    'fabric.elements.share.invite.to.jira': "\u2063\u2062Invite to Jira\u061C\x8f\u2060\u2061\x8f\u206F\x8d\x81\x9d\x81\u206C\u2060\u200C\u206E\u206E\u061C\x90\u2060\u206E\u2060\u200D\x8d\x81\u206B\u206F\x8d\u200D\u206B\u2061\x9d\u206C\x8f\u2063\u2064",
    'fabric.elements.share.main.tab.text.confluence': "\u2063\u2062Share page\x81\u206A\u206F\u206D\u206C\u206C\x8f\x8f\x8f\x8d\x8f\x8f\u206A\u206C\u206F\x9d\u200C\x8f\u200D\u200C\u200D\u2060\x8d\u206B\x8f\u2061\u061C\u206E\x81\u200C\x8d\u206E\u2063\u2064",
    'fabric.elements.share.main.tab.text.jira': "\u2063\u2062Share issue\x9d\x9d\x8f\x9d\u061C\u206D\u200D\u206E\x90\x81\u200D\x9d\x81\x90\x8f\u206C\u061C\u200D\x9d\x9d\u206C\x9d\u206F\u2061\u2060\u2060\u206A\u206E\u061C\x81\u200D\x8f\u2063\u2064",
    'fabric.elements.share.menu.email.label': "\u2063\u2062Email\u206E\x90\u200D\u206B\u2061\u206C\u061C\u206A\u206A\u200C\u200C\x8f\u061C\x8f\u200C\u200C\u206C\u206D\u200C\u206A\x8f\x81\u206F\u2061\x8d\u2061\u206E\u2061\u206E\u206C\u206A\u206A\u2063\u2064",
    'fabric.elements.share.menu.slack.label': "\u2063\u2062Slack\u206B\u200C\u206B\x8f\u061C\u206D\x9d\u061C\x8f\u200D\u2060\u200D\x81\x90\u206C\u206F\u200C\x81\u2061\x9d\x8f\u206F\u200D\x8f\u206E\u200C\x8f\x81\u206C\u2060\x8d\u2060\u2063\u2064",
    'fabric.elements.share.popup.label': "\u2063\u2062Share\u206D\x9d\u206D\u206B\u206C\u200D\u200C\u206C\x8f\u206C\x90\x81\x81\x8d\x90\x8f\u206B\u206A\u2061\u200C\u206F\u206A\u200C\u206E\x9d\x8d\u206E\u200C\u200D\u200D\x81\u206C\u2063\u2064",
    'fabric.elements.share.success.message': "\u2063\u2062{object, select,blogpost {Blog post shared}board {Board shared}calendar {Calendar shared}draft {Draft shared}filter {Filter shared}issue {Issue shared}summary {Summary shared}list {List shared}timeline {Timeline shared}form {Form shared}media {Media shared}page {Page shared}project {Project shared}pullrequest {Pull Request shared}question {Question shared}report {Report shared}repository {Repository shared}request {Request shared}roadmap {Timeline shared}site {Site shared}space {Space shared}other {Link Shared}}\x8f\x8f\u206A\x81\x9d\u206F\u061C\u206F\u206A\u200C\u206C\u206F\u206F\x8d\x8d\u206C\u206C\x8d\u206C\u206D\u206C\u206A\u206E\u2060\u200D\x90\u061C\x90\x81\u206E\u206D\x9d\u2063\u2064",
    'fabric.elements.share.to.integration.button': "\u2063\u2062Share to {integrationName}\x9d\u206D\u200C\x9d\x8d\u206C\u206E\u206E\u206D\u206A\u2061\u200C\u2060\u206F\x90\u2061\x8d\u2061\u2061\u2060\x9d\u200D\x90\u200D\u206A\x9d\u061C\u200C\x9d\u206B\u2061\x8f\u2063\u2064",
    'fabric.elements.share.trigger.button.icon.label': "\u2063\u2062Share icon\x81\x90\u200C\x9d\u206C\u200D\x8f\x8f\u206E\x9d\u206F\u206B\x8f\u206F\x9d\x8d\x8d\u061C\u200D\x9d\x8f\u206C\u206F\u200D\u206D\u061C\x90\u206A\u200C\u206A\u206B\u2061\u2063\u2064",
    'fabric.elements.share.trigger.button.invite.text': "\u2063\u2062Invite\u2061\u200D\u206A\u206B\x9d\u206D\x8f\u200D\u206F\x81\u2060\u206B\u206B\x8f\x8f\u206E\u061C\u2061\x8f\u200C\u206E\x81\u2060\u061C\u061C\x9d\u206E\u061C\x9d\u206D\u206A\u061C\u2063\u2064",
    'fabric.elements.share.trigger.button.text': "\u2063\u2062Share\u206B\u206A\x81\x8d\x8d\x9d\x8f\u200C\u206D\u206D\x9d\u2061\x81\x81\u200D\u206F\u200C\u206C\u200D\x90\u206A\u206B\u206F\u061C\u061C\u206E\x9d\u2061\u200D\x90\x81\u206B\u2063\u2064",
    'fabric.elements.share.trigger.button.tooltip.text': "\u2063\u2062Share\u200C\u206F\u2061\u206A\x90\u200C\u061C\u200C\x8f\u200C\u206A\u206F\u206D\u2060\u061C\u2061\u206D\u206F\u206E\u206D\x8d\u200C\x90\u200C\u200D\u206A\u206E\x8d\u206A\u200C\u206C\u206A\u2063\u2064"
};

});

parcelRegister("jCrgt", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa4d05b5c2cb0939$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Spanish (International)
var $fa4d05b5c2cb0939$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Enlace copiado en el portapapeles',
    'fabric.elements.share.copylink.button.text': 'Copiar enlace',
    'fabric.elements.share.copypubliclink.button.text': "Copiar enlace p\xfablico",
    'fabric.elements.share.failure.icon.label': 'Icono de error',
    'fabric.elements.share.failure.message': 'No se puede compartir',
    'fabric.elements.share.form.comment.label': 'Mensaje (opcional)',
    'fabric.elements.share.form.comment.placeholder': "\xbfHay algo que haya que saber?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "Los destinatarios ver\xe1n el nombre de la p\xe1gina y tu mensaje",
    'fabric.elements.share.form.info.message.no.invite.jira': "Los destinatarios ver\xe1n el nombre de la incidencia y tu mensaje",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "Los destinatarios ver\xe1n el nombre de la actividad y tu mensaje",
    'fabric.elements.share.form.no-permissions': 'No puedes compartir.',
    'fabric.elements.share.form.public.send': "Enviar enlace p\xfablico",
    'fabric.elements.share.form.public.share': "Compartir enlace p\xfablico",
    'fabric.elements.share.form.required-field.summary': "Los campos obligatorios est\xe1n marcados con un asterisco",
    'fabric.elements.share.form.retry': 'Reintentar',
    'fabric.elements.share.form.send': 'Enviar',
    'fabric.elements.share.form.share': 'Compartir',
    'fabric.elements.share.form.title': 'Compartir',
    'fabric.elements.share.form.user-picker.add-more': "Introduce m\xe1s cosas",
    'fabric.elements.share.form.user-picker.label.confluence': "Nombres, equipos, grupos o correos electr\xf3nicos",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Nombres, equipos o grupos',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Nombres o equipos',
    'fabric.elements.share.form.user-picker.label.email-only': "Correos electr\xf3nicos",
    'fabric.elements.share.form.user-picker.label.jira': "Nombres, equipos o correos electr\xf3nicos",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'No hemos encontrado ning\xfan resultado para "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'No hemos encontrado ning\xfan resultado para "{inputValue}". Invita a la gente mediante una direcci\xf3n de correo electr\xf3nico.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': "p.\xa0ej. Mar\xeda, equipo naranja, grupo uno",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "p.\xa0ej. Mar\xeda, equipo naranja",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "p.\xa0ej. maria@empresa.com",
    'fabric.elements.share.form.user-picker.placeholder.jira': "p.\xa0ej. Mar\xeda, equipo naranja, maria@empresa.com",
    'fabric.elements.share.form.user-picker.validation.required': "Selecciona al menos un usuario, grupo, equipo o correo electr\xf3nico.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "Selecciona al menos una persona, equipo, grupo o correo electr\xf3nico",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': 'Selecciona al menos una persona, equipo o grupo',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': 'Selecciona al menos una persona o equipo',
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "Selecciona al menos un correo electr\xf3nico",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "Selecciona al menos una persona, equipo o correo electr\xf3nico",
    'fabric.elements.share.in.integration.button': 'Compartir en {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Invitar a Confluence',
    'fabric.elements.share.invite.to.jira': 'Invitar a Jira',
    'fabric.elements.share.main.tab.text.confluence': "Compartir p\xe1gina",
    'fabric.elements.share.main.tab.text.jira': 'Compartir incidencia',
    'fabric.elements.share.menu.email.label': "Correo electr\xf3nico",
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Compartir',
    'fabric.elements.share.success.message': "{object, select,blogpost {Entrada de blog compartida}board {Tablero compartido}calendar {Calendario compartido}draft {Borrador compartido}filter {Filtro compartido}issue {Incidencia compartida}summary {Resumen compartido}list {Lista compartida}timeline {Cronograma compartido}form {Formulario compartido}media {Recursos multimedia compartidos}page {P\xe1gina compartida}project {Proyecto compartido}pullrequest {Solicitud de incorporaci\xf3n de cambios compartida}question {Pregunta compartida}report {Informe compartido}repository {Repositorio compartido}request {Solicitud compartida}roadmap {Cronograma compartido}site {Sitio compartido}space {Espacio compartido}other {Enlace compartido}}",
    'fabric.elements.share.to.integration.button': 'Compartir en {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Icono de compartir',
    'fabric.elements.share.trigger.button.invite.text': 'Invitar',
    'fabric.elements.share.trigger.button.text': 'Compartir',
    'fabric.elements.share.trigger.button.tooltip.text': 'Compartir'
};

});

parcelRegister("ddwcq", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8a813df19fa2152$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Estonian
var $f8a813df19fa2152$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Link kopeeritud l\xf5ikelauale",
    'fabric.elements.share.copylink.button.text': 'Kopeeri link',
    'fabric.elements.share.failure.icon.label': 'Vea ikoon',
    'fabric.elements.share.failure.message': 'Jagamine nurjus',
    'fabric.elements.share.form.comment.placeholder': "S\xf5numi lisamine",
    'fabric.elements.share.form.retry': 'Proovi uuesti',
    'fabric.elements.share.form.send': 'Saada',
    'fabric.elements.share.form.title': 'Jaga',
    'fabric.elements.share.form.user-picker.add-more': 'Sisesta veel',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'Me ei suutnud leida \xfchtegi tulemust seoses otsitavaga \u201E{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'Me ei suutnud leida \xfchtegi tulemust seoses otsitavaga \u201E{inputValue}". Kutsu inimesi e-posti aadressi alusel.',
    'fabric.elements.share.form.user-picker.placeholder.existingUserOnly': "Sisesta nimi v\xf5i meeskond",
    'fabric.elements.share.form.user-picker.placeholder.generic': "Sisestage nimi, r\xfchm, meeskond v\xf5i meil",
    'fabric.elements.share.form.user-picker.placeholder.jira': "Sisestage nimi, tiim v\xf5i meil",
    'fabric.elements.share.form.user-picker.validation.required': "Valige v\xe4hemalt \xfcks kasutaja, r\xfchm, meeskond v\xf5i meil.",
    'fabric.elements.share.form.user-picker.validation.required.jira': "Valige v\xe4hemalt \xfcks kasutaja, tiim v\xf5i meil.",
    'fabric.elements.share.success.message': "{object, select, blogpost {Blogipostitus jagatud} board {T\xf6\xf6laud jagatud} calendar {Kalender jagatud} draft {Mustand jagatud} filter {Filter jagatud} issue {Probleem jagatud} media {Meediafail jagatud} page {Leht jagatud} project {Projekt jagatud} pullrequest {T\xf5mbekutse jagatud} question {K\xfcsimus jagatud} report {Raport jagatud} repository {Koodihoidla jagatud} request {Taotlus jagatud} roadmap {T\xf6\xf6plaan jagatud} site {Sait jagatud} space {Ruum jagatud} other {Link jagatud}}",
    'fabric.elements.share.trigger.button.icon.label': 'Jagamisikoon',
    'fabric.elements.share.trigger.button.invite.text': 'Kutsu',
    'fabric.elements.share.trigger.button.text': 'Jaga',
    'fabric.elements.share.trigger.button.tooltip.text': 'Jaga'
};

});

parcelRegister("2Slqk", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8abdec291b18f8c$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Finnish
var $c8abdec291b18f8c$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Linkki kopioitu leikep\xf6yd\xe4lle",
    'fabric.elements.share.copylink.button.text': 'Kopioi linkki',
    'fabric.elements.share.copypubliclink.button.text': 'Kopioi julkinen linkki',
    'fabric.elements.share.failure.icon.label': 'Virhekuvake',
    'fabric.elements.share.failure.message': 'Ei voitu jakaa',
    'fabric.elements.share.form.comment.label': 'Viesti (valinnainen)',
    'fabric.elements.share.form.comment.placeholder': "Mit\xe4 muiden tulisi tiet\xe4\xe4?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "Vastaanottajat n\xe4kev\xe4t sivun nimen ja viestisi",
    'fabric.elements.share.form.info.message.no.invite.jira': "Vastaanottajat n\xe4kev\xe4t asian nimen ja viestisi",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "Vastaanottajat n\xe4kev\xe4t ty\xf6teht\xe4v\xe4n nimen ja viestisi",
    'fabric.elements.share.form.no-permissions': 'Sinulla ei ole jakamisoikeutta.',
    'fabric.elements.share.form.public.send': "L\xe4het\xe4 julkinen linkki",
    'fabric.elements.share.form.public.share': 'Jaa julkinen linkki',
    'fabric.elements.share.form.required-field.summary': "Pakolliset kent\xe4t on merkitty t\xe4hdell\xe4",
    'fabric.elements.share.form.retry': "Yrit\xe4 uudelleen",
    'fabric.elements.share.form.send': "L\xe4het\xe4",
    'fabric.elements.share.form.share': 'Jaa',
    'fabric.elements.share.form.title': 'Jaa',
    'fabric.elements.share.form.user-picker.add-more': "Sy\xf6t\xe4 lis\xe4\xe4",
    'fabric.elements.share.form.user-picker.label.confluence': "Nimet, tiimit, ryhm\xe4t tai s\xe4hk\xf6postiosoitteet",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "Nimet, tiimit tai ryhm\xe4t",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Nimet tai tiimit',
    'fabric.elements.share.form.user-picker.label.email-only': "S\xe4hk\xf6postiosoitteet",
    'fabric.elements.share.form.user-picker.label.jira': "Nimet, tiimit tai s\xe4hk\xf6postiosoitteet",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'Tuloksia ei l\xf6ytynyt haulle "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'Tuloksia ei l\xf6ytynyt haulle "{inputValue}". Kutsu henkil\xf6it\xe4 s\xe4hk\xf6postiosoitteen avulla.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': "esim. Maria, Oranssi tiimi, ykk\xf6sryhm\xe4",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'esim. Maria, Oranssi tiimi',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'esim. maria@yritys.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'esim. Maria, Oranssi tiimi, maria@yritys.com',
    'fabric.elements.share.form.user-picker.validation.required': "Valitse v\xe4hint\xe4\xe4n yksi k\xe4ytt\xe4j\xe4, ryhm\xe4, tiimi tai s\xe4hk\xf6postiosoite.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "Valitse v\xe4hint\xe4\xe4n yksi henkil\xf6, tiimi, ryhm\xe4 tai s\xe4hk\xf6postiosoite",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "Valitse v\xe4hint\xe4\xe4n yksi henkil\xf6, tiimi tai ryhm\xe4",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "Valitse v\xe4hint\xe4\xe4n yksi henkil\xf6 tai tiimi",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "Valitse v\xe4hint\xe4\xe4n yksi s\xe4hk\xf6postiosoite",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "Valitse v\xe4hint\xe4\xe4n yksi henkil\xf6, tiimi tai s\xe4hk\xf6postiosoite",
    'fabric.elements.share.in.integration.button': 'Jaa sovelluksessa {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Kutsu Confluenceen',
    'fabric.elements.share.invite.to.jira': 'Kutsu Jiraan',
    'fabric.elements.share.main.tab.text.confluence': 'Jaa sivu',
    'fabric.elements.share.main.tab.text.jira': 'Jaa asia',
    'fabric.elements.share.menu.email.label': "S\xe4hk\xf6posti",
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Jaa',
    'fabric.elements.share.success.message': "{object, select,blogpost {Blogijulkaisu jaettu}board {Taulu jaettu}calendar {Kalenteri jaettu}draft {Luonnos jaettu}filter {Suodatin jaettu}issue {Asia jaettu}summary {Yhteenveto jaettu}list {Luettelo jaettu}timeline {Aikajana jaettu}form {Lomake jaettu}media {Media jaettu}page {Sivu jaettu}project {Projekti jaettu}pullrequest {Pull-pyynt\xf6 jaettu}question {Kysymys jaettu}report {Raportti jaettu}repository {S\xe4il\xf6 jaettu}request {Pyynt\xf6 jaettu}roadmap {Aikajana jaettu}site {Sivusto jaettu}space {Ty\xf6tila jaettu}other {Linkki jaettu}}",
    'fabric.elements.share.to.integration.button': 'Jaa kohteeseen {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Jaa kuvake',
    'fabric.elements.share.trigger.button.invite.text': 'Kutsu',
    'fabric.elements.share.trigger.button.text': 'Jaa',
    'fabric.elements.share.trigger.button.tooltip.text': 'Jaa'
};

});

parcelRegister("byDyk", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1bb494a2b2c3eb5$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //French (France)
var $f1bb494a2b2c3eb5$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Lien copi\xe9 dans le presse-papier",
    'fabric.elements.share.copylink.button.text': 'Copier le lien',
    'fabric.elements.share.copypubliclink.button.text': 'Copier le lien public',
    'fabric.elements.share.failure.icon.label': "Ic\xf4ne d'erreur",
    'fabric.elements.share.failure.message': 'Partage impossible',
    'fabric.elements.share.form.comment.label': 'Message (facultatif)',
    'fabric.elements.share.form.comment.placeholder': "D'autres choses \xe0 savoir\xa0?",
    'fabric.elements.share.form.info.message.no.invite.confluence': 'Les destinataires verront le nom de la page et votre message',
    'fabric.elements.share.form.info.message.no.invite.jira': 'Les destinataires verront le nom du ticket et votre message',
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': 'Les destinataires verront le nom du ticket et votre message',
    'fabric.elements.share.form.no-permissions': 'Vous ne pouvez pas partager ce contenu.',
    'fabric.elements.share.form.public.send': 'Envoyer le lien public',
    'fabric.elements.share.form.public.share': 'Partager un lien public',
    'fabric.elements.share.form.required-field.summary': "Les champs obligatoires sont marqu\xe9s d'un ast\xe9risque",
    'fabric.elements.share.form.retry': "R\xe9essayer",
    'fabric.elements.share.form.send': 'Envoyer',
    'fabric.elements.share.form.share': 'Partager',
    'fabric.elements.share.form.title': 'Partager',
    'fabric.elements.share.form.user-picker.add-more': "Saisir plus d\u2019\xe9l\xe9ments",
    'fabric.elements.share.form.user-picker.label.confluence': "Noms, \xe9quipes, groupes ou e-mails",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "Noms, \xe9quipes ou groupes",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "Noms ou \xe9quipes",
    'fabric.elements.share.form.user-picker.label.email-only': 'E-mails',
    'fabric.elements.share.form.user-picker.label.jira': "Noms, \xe9quipes ou e-mails",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Pas de r\xe9sultats pour \xab\xa0{inputValue}\xa0\xbb.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Pas de r\xe9sultats pour \xab\xa0{inputValue}\xa0\xbb. Invitez des personnes \xe0 l'aide d'une adresse e-mail.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': "Par exemple, Maria, \xe9quipe Orange, groupe-1",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "Par exemple, Maria, \xe9quipe Orange",
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'Par exemple, maria@entreprise.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': "Par exemple, Maria, \xe9quipe Orange, maria@entreprise.com",
    'fabric.elements.share.form.user-picker.validation.required': "S\xe9lectionnez au moins un utilisateur, un groupe, une \xe9quipe ou une adresse e-mail.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "S\xe9lectionnez au moins une personne, une \xe9quipe, un groupe ou un e-mail",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "S\xe9lectionnez au moins une personne, une \xe9quipe ou un groupe",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "S\xe9lectionnez au moins une personne ou \xe9quipe",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "S\xe9lectionnez au moins un e-mail",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "S\xe9lectionnez au moins une personne, une \xe9quipe ou un e-mail",
    'fabric.elements.share.in.integration.button': 'Partager dans {integrationName}',
    'fabric.elements.share.invite.to.confluence': "Inviter \xe0 rejoindre Confluence",
    'fabric.elements.share.invite.to.jira': "Inviter \xe0 rejoindre Jira",
    'fabric.elements.share.main.tab.text.confluence': 'Partager la page',
    'fabric.elements.share.main.tab.text.jira': 'Partager le ticket',
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Partager',
    'fabric.elements.share.success.message': "{object, select,blogpost {Billet de blog partag\xe9}board {Tableau partag\xe9}calendar {Calendrier partag\xe9}draft {Brouillon partag\xe9}filter {Filtre partag\xe9}issue {Ticket partag\xe9}summary {R\xe9sum\xe9 partag\xe9}list {Liste partag\xe9e}timeline {Chronologie partag\xe9e}form {Formulaire partag\xe9}media {M\xe9dia partag\xe9}page {Page partag\xe9e}project {Projet partag\xe9}pullrequest {Pull request partag\xe9e}question {Question partag\xe9e}report {Rapport partag\xe9}repository {D\xe9p\xf4t partag\xe9}request {Demande partag\xe9e}roadmap {Chronologie partag\xe9e}site {Site partag\xe9}space {Espace partag\xe9}other {Lien partag\xe9}}",
    'fabric.elements.share.to.integration.button': 'Partager avec {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': "Ic\xf4ne de partage",
    'fabric.elements.share.trigger.button.invite.text': 'Inviter',
    'fabric.elements.share.trigger.button.text': 'Partager',
    'fabric.elements.share.trigger.button.tooltip.text': 'Partager'
};

});

parcelRegister("9y8hX", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b7ac209639193ae$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Hungarian
var $7b7ac209639193ae$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Hivatkoz\xe1s \xe1tm\xe1solva a v\xe1g\xf3lapra",
    'fabric.elements.share.copylink.button.text': "Hivatkoz\xe1s m\xe1sol\xe1sa",
    'fabric.elements.share.copypubliclink.button.text': "Publikus link m\xe1sol\xe1sa",
    'fabric.elements.share.failure.icon.label': 'Hiba ikon',
    'fabric.elements.share.failure.message': 'Nem lehet megosztani',
    'fabric.elements.share.form.comment.label': "\xdczenet (nem k\xf6telez\u0151)",
    'fabric.elements.share.form.comment.placeholder': "Van b\xe1rmi, amit \xe9rdemes tudni?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "A c\xedmzettek l\xe1tj\xe1k az oldal nev\xe9t \xe9s az \xfczenetedet",
    'fabric.elements.share.form.info.message.no.invite.jira': "A c\xedmzettek l\xe1tj\xe1k az \xfcgy nev\xe9t \xe9s az \xfczenetedet",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "A c\xedmzettek l\xe1tj\xe1k az \xfcgy nev\xe9t \xe9s az \xfczenetedet",
    'fabric.elements.share.form.no-permissions': "Nincs lehet\u0151s\xe9ged a megoszt\xe1sra.",
    'fabric.elements.share.form.public.send': "Publikus link k\xfcld\xe9se",
    'fabric.elements.share.form.public.share': "Nyilv\xe1nos link megoszt\xe1sa",
    'fabric.elements.share.form.required-field.summary': "A k\xf6telez\u0151 mez\u0151k csillaggal vannak megjel\xf6lve",
    'fabric.elements.share.form.retry': "\xdajra",
    'fabric.elements.share.form.send': "K\xfcld\xe9s",
    'fabric.elements.share.form.share': "Megoszt\xe1s",
    'fabric.elements.share.form.title': "Megoszt\xe1s",
    'fabric.elements.share.form.user-picker.add-more': "Tov\xe1bbiak megad\xe1sa",
    'fabric.elements.share.form.user-picker.label.confluence': "Nevek, csapatok, csoportok vagy e-mail-c\xedmek",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Nevek, csapatok vagy csoportok',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Nevek vagy csapatok',
    'fabric.elements.share.form.user-picker.label.email-only': "E-mail-c\xedmek",
    'fabric.elements.share.form.user-picker.label.jira': "Nevek, csapatok vagy e-mail-c\xedmek",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Nincs tal\xe1lat a k\xf6vetkez\u0151 keres\xe9sre: \u201E{inputValue}\u201D.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Nincs tal\xe1lat a k\xf6vetkez\u0151 keres\xe9sre: \u201E{inputValue}\u201D. H\xedvj meg embereket az e-mail-c\xedm\xfck alapj\xe1n.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': "pl. M\xe1ria, Narancs csapat, egyes-csoport",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "pl. M\xe1ria, Narancs csapat",
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'pl. maria@vallalat.hu',
    'fabric.elements.share.form.user-picker.placeholder.jira': "pl. M\xe1ria, Narancs csapat, maria@vallalat.hu",
    'fabric.elements.share.form.user-picker.validation.required': "V\xe1lassz ki legal\xe1bb egy felhaszn\xe1l\xf3t, csoportot, csapatot vagy e-mail-c\xedmet.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "V\xe1lassz ki legal\xe1bb egy szem\xe9lyt, csapatot, csoportot vagy e-mail-c\xedmet",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "V\xe1lassz ki legal\xe1bb egy szem\xe9lyt, csapatot vagy csoportot",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "V\xe1lassz ki legal\xe1bb egy szem\xe9lyt vagy csapatot",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "V\xe1lassz ki legal\xe1bb egy e-mail-c\xedmet",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "V\xe1lassz ki legal\xe1bb egy szem\xe9lyt, csapatot vagy e-mail-c\xedmet",
    'fabric.elements.share.in.integration.button': "Megoszt\xe1s itt: {integrationName}",
    'fabric.elements.share.invite.to.confluence': "Megh\xedv\xe1s a Confluence-be",
    'fabric.elements.share.invite.to.jira': "Megh\xedv\xe1s a Jir\xe1ba",
    'fabric.elements.share.main.tab.text.confluence': "Oldal megoszt\xe1sa",
    'fabric.elements.share.main.tab.text.jira': "\xdcgy megoszt\xe1sa",
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "Megoszt\xe1s",
    'fabric.elements.share.success.message': "{object, select,blogpost {Blogposzt megosztva}board {T\xe1bla megosztva}calendar {Napt\xe1r megosztva}draft {Piszkozat megosztva}filter {Sz\u0171r\u0151 megosztva}issue {\xdcgy megosztva}summary {\xd6sszefoglal\xf3 megosztva}list {Lista megosztva}timeline {Id\u0151vonal megosztva}form {\u0170rlap megosztva}media {M\xe9dia megosztva}page {Oldal megosztva}project {Projekt megosztva}pullrequest {Pull-k\xe9relem megosztva}question {K\xe9rd\xe9s megosztva}report {Jelent\xe9s megosztva}repository {Adatt\xe1r megosztva}request {K\xe9relem megosztva}roadmap {Id\u0151vonal megosztva}site {Webhely megosztva}space {Munkat\xe9r megosztva}other {Link megosztva}}",
    'fabric.elements.share.to.integration.button': "Megoszt\xe1s itt: {integrationName}",
    'fabric.elements.share.trigger.button.icon.label': "Ikon megoszt\xe1sa",
    'fabric.elements.share.trigger.button.invite.text': "Megh\xedv\xe1s",
    'fabric.elements.share.trigger.button.text': "Megoszt\xe1s",
    'fabric.elements.share.trigger.button.tooltip.text': "Megoszt\xe1s"
};

});

parcelRegister("bMFAQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $567821fb7188ce82$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by i18n-tools.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ // Icelandic
var $567821fb7188ce82$export$2e2bcd8739ae039 = {
    'fabric.elements.share.form.title': 'Deila',
    'fabric.elements.share.form.send': 'Senda ',
    'fabric.elements.share.form.retry': 'Reyna aftur',
    'fabric.elements.share.form.comment.placeholder': "B\xe6ta vi\xf0 skilabo\xf0um",
    'fabric.elements.share.form.user-picker.placeholder.generic': "Sl\xe1\xf0u inn nafn, teymi e\xf0a t\xf6lvup\xf3stur",
    'fabric.elements.share.form.user-picker.placeholder.existingUserOnly': "Sl\xe1\xf0u inn nafn e\xf0a teymi",
    'fabric.elements.share.form.user-picker.add-more': "F\xe6ra inn fleiri ",
    'fabric.elements.share.form.user-picker.validation.required': "Veldu a\xf0 minnsta kosti einn notanda, teymi e\xf0a netfang.",
    'fabric.elements.share.form.user-picker.no-options.domainBasedUserOnly': "\xde\xfa getur a\xf0eins bo\xf0i\xf0 f\xf3lki sem eru me\xf0 {domains} netf\xf6ng. Haf\xf0u samband vi\xf0 stj\xf3rnanda s\xed\xf0unnar \xfeinnar til a\xf0 bj\xf3\xf0a \xf6\xf0ru f\xf3lki.",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Ekki fundust neinar ni\xf0urst\xf6\xf0ur fyrir \u201E{inputValue}\u201C. Bj\xf3ddu f\xf3lki me\xf0 \xfev\xed a\xf0 nota netf\xf6ng.",
    'fabric.elements.share.form.user-picker.no-options.generic': 'Engar ni\xf0urst\xf6\xf0ur fundust fyrir "{inputValue}". Bj\xf3ddu f\xf3lki me\xf0 \xfev\xed a\xf0 nota t\xf6lvup\xf3stfang.',
    'fabric.elements.share.trigger.button.icon.label': "Deilingart\xe1kn",
    'fabric.elements.share.trigger.button.text': 'Deila',
    'fabric.elements.share.trigger.button.tooltip.text': 'Deila',
    'fabric.elements.share.trigger.button.invite.text': "Bo\xf0i\xf0",
    'fabric.elements.share.copylink.button.icon.label': "\u201EAfrita tengil\u201C-t\xe1kn",
    'fabric.elements.share.copylink.button.text': 'Afrita tengil',
    'fabric.elements.share.copied.to.clipboard.icon.label': "T\xe1kn sem s\xfdnir a\xf0 tengilinn hafi veri\xf0 afrita\xf0ur me\xf0 g\xf3\xf0um \xe1rangri",
    'fabric.elements.share.copied.to.clipboard.message': "Tengill afrita\xf0ur \xe1 klippibor\xf0",
    'fabric.elements.share.form.capabilities.info.message': "Bo\xf0skorti\xf0 \xfeitt ver\xf0ur sent til stj\xf3rnanda til sam\xfeykkis",
    'fabric.elements.share.failure.icon.label': "Villut\xe1kn",
    'fabric.elements.share.failure.message': "Ekki er h\xe6gt a\xf0 deila",
    'fabric.elements.share.success.message': "{object, select, blogpost {Blog post shared} tafla {Board shared} dagatal {Calendar shared} uppkast {Draft shared} s\xeda {Filter shared} m\xe1lefni {Issue shared} mi\xf0ill {Media shared} s\xed\xf0a {Page shared} verkefni {Project shared} togbei\xf0ni {Pull Request shared} spurning {Question shared} sk\xfdrsla {Report shared} Gagnageymsla {Repository shared} bei\xf0ni {Request shared} vegv\xedsir {Roadmap shared} s\xed\xf0a {Site shared} sv\xe6\xf0i {Space shared} anna\xf0 {Link Shared}}",
    'fabric.elements.share.admin.notified.message': "Stj\xf3rnanda hefur veri\xf0 tilkynnt"
};

});

parcelRegister("4JZF5", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee9f8422b31a9859$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Italian (Italy)
var $ee9f8422b31a9859$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Link copiato negli appunti',
    'fabric.elements.share.copylink.button.text': 'Copia link',
    'fabric.elements.share.copypubliclink.button.text': 'Copia link pubblico',
    'fabric.elements.share.failure.icon.label': 'Icona Errore',
    'fabric.elements.share.failure.message': 'Impossibile effettuare la condivisione',
    'fabric.elements.share.form.comment.label': 'Messaggio (opzionale)',
    'fabric.elements.share.form.comment.placeholder': 'Vuoi comunicare loro qualcosa?',
    'fabric.elements.share.form.info.message.no.invite.confluence': 'I destinatari vedranno il nome della pagina e il tuo messaggio',
    'fabric.elements.share.form.info.message.no.invite.jira': 'I destinatari vedranno il nome del ticket e il tuo messaggio',
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': 'I destinatari vedranno il nome del ticket e il tuo messaggio',
    'fabric.elements.share.form.no-permissions': 'Non puoi eseguire condivisioni.',
    'fabric.elements.share.form.public.send': 'Invia link pubblico',
    'fabric.elements.share.form.public.share': 'Condividi link pubblico',
    'fabric.elements.share.form.required-field.summary': 'I campi obbligatori sono contrassegnati da un asterisco',
    'fabric.elements.share.form.retry': 'Riprova',
    'fabric.elements.share.form.send': 'Invia',
    'fabric.elements.share.form.share': 'Condividi',
    'fabric.elements.share.form.title': 'Condividi',
    'fabric.elements.share.form.user-picker.add-more': 'Inerisci altri elementi',
    'fabric.elements.share.form.user-picker.label.confluence': 'Nomi, team, gruppi o indirizzi e-mail',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Nomi, team o gruppi',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Nomi o team',
    'fabric.elements.share.form.user-picker.label.email-only': 'Indirizzi e-mail',
    'fabric.elements.share.form.user-picker.label.jira': 'Nomi, team o indirizzi e-mail',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Nessun risultato trovato per \u201C{inputValue}\u201D.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Nessun risultato trovato per \u201C{inputValue}\u201D. Invita le persone inserendo il loro indirizzo e-mail.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': 'ad esempio Maria, Team Arancione, gruppo uno',
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'ad esempio Maria, Team Arancione',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'ad esempio maria@azienda.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'ad esempio Maria, Team Arancione, maria@azienda.com',
    'fabric.elements.share.form.user-picker.validation.required': "Seleziona almeno un utente, un gruppo, un team o un'e-mail.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': 'Seleziona almeno una persona, un team, un gruppo o un indirizzo e-mail.',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': 'Seleziona almeno una persona, un team o un gruppo',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': 'Seleziona almeno una persona o un team.',
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': 'Seleziona almeno un indirizzo e-mail',
    'fabric.elements.share.form.user-picker.validation.required-message.jira': 'Seleziona almeno una persona, un team o un indirizzo e-mail',
    'fabric.elements.share.in.integration.button': 'Condividi in {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Invita in Confluence',
    'fabric.elements.share.invite.to.jira': 'Invita in Jira',
    'fabric.elements.share.main.tab.text.confluence': 'Condividi pagina',
    'fabric.elements.share.main.tab.text.jira': 'Condividi ticket',
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Condividi',
    'fabric.elements.share.success.message': '{object, select,blogpost {Post del blog condiviso}board {Board condivisa}calendar {Calendario condiviso}draft {Bozza condivisa}filter {Filtro condiviso}issue {Ticket condiviso}summary {Riepilogo condiviso}list {Elenco condiviso}timeline {Timeline condivisa}form {Modulo condiviso}media {Elemento multimediale condiviso}page {Pagina condiviso}project {Progetto condiviso}pullrequest {Pull request condivisa}question {Domanda condivisa}report {Report condiviso}repository {Repository condiviso}request {Richiesta condivisa}roadmap {Timeline condivisa}site {Sito condiviso}space {Spazio condiviso}other {Link condiviso}}',
    'fabric.elements.share.to.integration.button': 'Condividi in {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Icona Condividi',
    'fabric.elements.share.trigger.button.invite.text': 'Invita',
    'fabric.elements.share.trigger.button.text': 'Condividi',
    'fabric.elements.share.trigger.button.tooltip.text': 'Condividi'
};

});

parcelRegister("dzumV", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb77872613c037b3$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Japanese
var $eb77872613c037b3$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "\u30EA\u30F3\u30AF\u3092\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u306B\u30B3\u30D4\u30FC\u3057\u307E\u3057\u305F",
    'fabric.elements.share.copylink.button.text': "\u30EA\u30F3\u30AF\u3092\u30B3\u30D4\u30FC",
    'fabric.elements.share.copypubliclink.button.text': "\u516C\u958B\u30EA\u30F3\u30AF\u3092\u30B3\u30D4\u30FC",
    'fabric.elements.share.failure.icon.label': "\u30A8\u30E9\u30FC \u30A2\u30A4\u30B3\u30F3",
    'fabric.elements.share.failure.message': "\u5171\u6709\u3067\u304D\u307E\u305B\u3093",
    'fabric.elements.share.form.comment.label': "\u30E1\u30C3\u30BB\u30FC\u30B8 (\u30AA\u30D7\u30B7\u30E7\u30F3)",
    'fabric.elements.share.form.comment.placeholder': "\u5171\u6709\u5148\u306E\u30E6\u30FC\u30B6\u30FC\u3078\u306E\u30B3\u30E1\u30F3\u30C8\u304C\u3042\u308B\u5834\u5408\u306F\u3053\u3053\u306B\u66F8\u304D\u8FBC\u307F\u307E\u3059\u3002",
    'fabric.elements.share.form.info.message.no.invite.confluence': "\u53D7\u4FE1\u8005\u306B\u30DA\u30FC\u30B8\u306E\u540D\u524D\u3068\u30E1\u30C3\u30BB\u30FC\u30B8\u304C\u8868\u793A\u3055\u308C\u307E\u3059",
    'fabric.elements.share.form.info.message.no.invite.jira': "\u53D7\u4FE1\u8005\u306B\u8AB2\u984C\u306E\u540D\u524D\u3068\u30E1\u30C3\u30BB\u30FC\u30B8\u304C\u8868\u793A\u3055\u308C\u307E\u3059",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "\u53D7\u4FE1\u8005\u306B\u4F5C\u696D\u9805\u76EE\u306E\u540D\u524D\u3068\u30E1\u30C3\u30BB\u30FC\u30B8\u304C\u8868\u793A\u3055\u308C\u307E\u3059",
    'fabric.elements.share.form.no-permissions': "\u5171\u6709\u3067\u304D\u307E\u305B\u3093\u3002",
    'fabric.elements.share.form.public.send': "\u516C\u958B\u30EA\u30F3\u30AF\u3092\u9001\u4FE1",
    'fabric.elements.share.form.public.share': "\u516C\u958B\u30EA\u30F3\u30AF\u3092\u5171\u6709",
    'fabric.elements.share.form.required-field.summary': "\u5FC5\u9808\u30D5\u30A3\u30FC\u30EB\u30C9\u306B\u306F\u30A2\u30B9\u30BF\u30EA\u30B9\u30AF\u304C\u4ED8\u3044\u3066\u3044\u307E\u3059",
    'fabric.elements.share.form.retry': "\u518D\u8A66\u884C",
    'fabric.elements.share.form.send': "\u9001\u4FE1",
    'fabric.elements.share.form.share': "\u5171\u6709",
    'fabric.elements.share.form.title': "\u5171\u6709",
    'fabric.elements.share.form.user-picker.add-more': "\u3055\u3089\u306B\u8FFD\u52A0",
    'fabric.elements.share.form.user-picker.label.confluence': "\u540D\u524D\u3001\u30C1\u30FC\u30E0\u3001\u30B0\u30EB\u30FC\u30D7\u3001\u307E\u305F\u306F\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "\u540D\u524D\u3001\u30C1\u30FC\u30E0\u3001\u307E\u305F\u306F\u30B0\u30EB\u30FC\u30D7",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "\u540D\u524D\u307E\u305F\u306F\u30C1\u30FC\u30E0",
    'fabric.elements.share.form.user-picker.label.email-only': "\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9",
    'fabric.elements.share.form.user-picker.label.jira': "\u540D\u524D\u3001\u30C1\u30FC\u30E0\u3001\u307E\u305F\u306F\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': '"{inputValue}" \u306B\u4E00\u81F4\u3059\u308B\u7D50\u679C\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F\u3002',
    'fabric.elements.share.form.user-picker.no-options.generic': '"{inputValue}" \u306B\u4E00\u81F4\u3059\u308B\u7D50\u679C\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9\u3092\u4F7F\u7528\u3057\u3066\u30E6\u30FC\u30B6\u30FC\u3092\u62DB\u5F85\u3057\u3066\u304F\u3060\u3055\u3044\u3002',
    'fabric.elements.share.form.user-picker.placeholder.confluence': "\u4F8B: \u4F50\u85E4\u3001\u30C1\u30FC\u30E0 \u30AA\u30EC\u30F3\u30B8\u3001\u30B0\u30EB\u30FC\u30D7\u30EF\u30F3",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "\u4F8B: \u4F50\u85E4\u3001\u30C1\u30FC\u30E0 \u30AA\u30EC\u30F3\u30B8",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "\u4F8B: sato@company.com",
    'fabric.elements.share.form.user-picker.placeholder.jira': "\u4F8B: \u4F50\u85E4\u3001\u30C1\u30FC\u30E0 \u30AA\u30EC\u30F3\u30B8\u3001sato@company.com",
    'fabric.elements.share.form.user-picker.validation.required': "\u30E6\u30FC\u30B6\u30FC\u3001\u30B0\u30EB\u30FC\u30D7\u3001\u30C1\u30FC\u30E0\u3001\u30E1\u30FC\u30EB\u3092\u5C11\u306A\u304F\u3068\u3082 1 \u3064\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "\u30E6\u30FC\u30B6\u30FC\u3001\u30C1\u30FC\u30E0\u3001\u30B0\u30EB\u30FC\u30D7\u3001\u307E\u305F\u306F\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9\u3092\u5C11\u306A\u304F\u3068\u3082 1 \u3064\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "\u30E6\u30FC\u30B6\u30FC\u3001\u30C1\u30FC\u30E0\u3001\u307E\u305F\u306F\u30B0\u30EB\u30FC\u30D7\u3092\u5C11\u306A\u304F\u3068\u3082 1 \u3064\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "\u30E6\u30FC\u30B6\u30FC\u307E\u305F\u306F\u30C1\u30FC\u30E0\u3092\u5C11\u306A\u304F\u3068\u3082 1 \u3064\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9\u3092\u5C11\u306A\u304F\u3068\u3082 1 \u3064\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "\u30E6\u30FC\u30B6\u30FC\u3001\u30C1\u30FC\u30E0\u3001\u307E\u305F\u306F\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9\u3092\u5C11\u306A\u304F\u3068\u3082 1 \u3064\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
    'fabric.elements.share.in.integration.button': "{integrationName} \u3067\u5171\u6709",
    'fabric.elements.share.invite.to.confluence': "Confluence \u306B\u62DB\u5F85",
    'fabric.elements.share.invite.to.jira': "Jira \u306B\u62DB\u5F85",
    'fabric.elements.share.main.tab.text.confluence': "\u30DA\u30FC\u30B8\u3092\u5171\u6709",
    'fabric.elements.share.main.tab.text.jira': "\u8AB2\u984C\u3092\u5171\u6709",
    'fabric.elements.share.menu.email.label': "\u30E1\u30FC\u30EB",
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "\u5171\u6709",
    'fabric.elements.share.success.message': "{object, select,blogpost {\u30D6\u30ED\u30B0\u6295\u7A3F\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}board {\u30DC\u30FC\u30C9\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}calendar {\u30AB\u30EC\u30F3\u30C0\u30FC\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}draft {\u4E0B\u66F8\u304D\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}filter {\u30D5\u30A3\u30EB\u30BF\u30FC\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}issue {\u8AB2\u984C\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}summary {\u8981\u7D04\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}list {\u30EA\u30B9\u30C8\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}timeline {\u30BF\u30A4\u30E0\u30E9\u30A4\u30F3\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}form {\u30D5\u30A9\u30FC\u30E0\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}media {\u30E1\u30C7\u30A3\u30A2\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}page {\u30DA\u30FC\u30B8\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}project {\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}pullrequest {\u30D7\u30EB \u30EA\u30AF\u30A8\u30B9\u30C8\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}question {\u8CEA\u554F\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}report {\u30EC\u30DD\u30FC\u30C8\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}repository {\u30EA\u30DD\u30B8\u30C8\u30EA\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}request {\u30EA\u30AF\u30A8\u30B9\u30C8\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}roadmap {\u30BF\u30A4\u30E0\u30E9\u30A4\u30F3\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}site {\u30B5\u30A4\u30C8\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}space {\u30B9\u30DA\u30FC\u30B9\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}other {\u30EA\u30F3\u30AF\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}}",
    'fabric.elements.share.to.integration.button': "{integrationName} \u3068\u5171\u6709",
    'fabric.elements.share.trigger.button.icon.label': "\u5171\u6709\u30A2\u30A4\u30B3\u30F3",
    'fabric.elements.share.trigger.button.invite.text': "\u62DB\u5F85",
    'fabric.elements.share.trigger.button.text': "\u5171\u6709",
    'fabric.elements.share.trigger.button.tooltip.text': "\u5171\u6709"
};

});

parcelRegister("fH3rr", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c880483be1fc144$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Korean
var $6c880483be1fc144$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "\uB9C1\uD06C\uB97C \uD074\uB9BD\uBCF4\uB4DC\uC5D0 \uBCF5\uC0AC\uD568",
    'fabric.elements.share.copylink.button.text': "\uB9C1\uD06C \uBCF5\uC0AC",
    'fabric.elements.share.copypubliclink.button.text': "\uACF5\uAC1C \uB9C1\uD06C \uBCF5\uC0AC",
    'fabric.elements.share.failure.icon.label': "\uC624\uB958 \uC544\uC774\uCF58",
    'fabric.elements.share.failure.message': "\uACF5\uC720\uD560 \uC218 \uC5C6\uC74C",
    'fabric.elements.share.form.comment.label': "\uBA54\uC2DC\uC9C0(\uC120\uD0DD \uC0AC\uD56D)",
    'fabric.elements.share.form.comment.placeholder': "\uC0AC\uC6A9\uC790\uAC00 \uC54C\uC544\uC57C \uD560 \uB0B4\uC6A9\uC774 \uC788\uC2B5\uB2C8\uAE4C?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "\uC218\uC2E0\uC790\uAC00 \uD398\uC774\uC9C0 \uC774\uB984\uACFC \uBA54\uC2DC\uC9C0\uB97C \uBCFC \uC218 \uC788\uC2B5\uB2C8\uB2E4",
    'fabric.elements.share.form.info.message.no.invite.jira': "\uC218\uC2E0\uC790\uAC00 \uC774\uC288 \uC774\uB984\uACFC \uBA54\uC2DC\uC9C0\uB97C \uBCFC \uC218 \uC788\uC2B5\uB2C8\uB2E4",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "\uC218\uC2E0\uC790\uAC00 \uC5C5\uBB34 \uD56D\uBAA9 \uC774\uB984 \uBC0F \uBA54\uC2DC\uC9C0\uB97C \uBCFC \uC218 \uC788\uC2B5\uB2C8\uB2E4",
    'fabric.elements.share.form.no-permissions': "\uACF5\uC720\uD560 \uAD8C\uD55C\uC774 \uC5C6\uC2B5\uB2C8\uB2E4.",
    'fabric.elements.share.form.public.send': "\uACF5\uAC1C \uB9C1\uD06C \uBCF4\uB0B4\uAE30",
    'fabric.elements.share.form.public.share': "\uACF5\uAC1C \uB9C1\uD06C \uACF5\uC720",
    'fabric.elements.share.form.required-field.summary': "\uD544\uC218 \uD544\uB4DC\uB294 \uBCC4\uD45C\uB85C \uD45C\uC2DC\uB418\uC5B4 \uC788\uC2B5\uB2C8\uB2E4",
    'fabric.elements.share.form.retry': "\uB2E4\uC2DC \uC2DC\uB3C4",
    'fabric.elements.share.form.send': "\uBCF4\uB0B4\uAE30",
    'fabric.elements.share.form.share': "\uACF5\uC720",
    'fabric.elements.share.form.title': "\uACF5\uC720",
    'fabric.elements.share.form.user-picker.add-more': "\uB354 \uC785\uB825\uD558\uC138\uC694",
    'fabric.elements.share.form.user-picker.label.confluence': "\uC774\uB984, \uD300, \uADF8\uB8F9 \uB610\uB294 \uC774\uBA54\uC77C",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "\uC774\uB984, \uD300 \uB610\uB294 \uADF8\uB8F9",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "\uC774\uB984 \uB610\uB294 \uD300",
    'fabric.elements.share.form.user-picker.label.email-only': "\uC774\uBA54\uC77C",
    'fabric.elements.share.form.user-picker.label.jira': "\uC774\uB984, \uD300 \uB610\uB294 \uC774\uBA54\uC77C",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': '"{inputValue}"\uC5D0 \uB300\uD55C \uACB0\uACFC\uB97C \uCC3E\uC9C0 \uBABB\uD588\uC2B5\uB2C8\uB2E4.',
    'fabric.elements.share.form.user-picker.no-options.generic': '"{inputValue}"\uC5D0 \uB300\uD55C \uACB0\uACFC\uB97C \uCC3E\uC9C0 \uBABB\uD588\uC2B5\uB2C8\uB2E4. \uC774\uBA54\uC77C \uC8FC\uC18C\uB97C \uC0AC\uC6A9\uD558\uC5EC \uC0AC\uC6A9\uC790\uB97C \uCD08\uB300\uD558\uC138\uC694.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': "\uC608: Maria, Team Orange, group-one",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "\uC608: Maria, Team Orange",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "\uC608: maria@company.com",
    'fabric.elements.share.form.user-picker.placeholder.jira': "\uC608: Maria, Team Orange, maria@company.com",
    'fabric.elements.share.form.user-picker.validation.required': "\uC0AC\uC6A9\uC790, \uADF8\uB8F9, \uD300 \uB610\uB294 \uC774\uBA54\uC77C\uC744 \uD558\uB098 \uC774\uC0C1 \uC120\uD0DD\uD558\uC138\uC694.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "\uC0AC\uC6A9\uC790, \uD300, \uADF8\uB8F9 \uB610\uB294 \uC774\uBA54\uC77C\uC744 \uD558\uB098 \uC774\uC0C1 \uC120\uD0DD\uD558\uC138\uC694",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "\uC0AC\uC6A9\uC790, \uD300 \uB610\uB294 \uADF8\uB8F9\uC744 \uD558\uB098 \uC774\uC0C1 \uC120\uD0DD\uD558\uC138\uC694",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "\uC0AC\uC6A9\uC790 \uB610\uB294 \uD300\uC744 \uD558\uB098 \uC774\uC0C1 \uC120\uD0DD\uD558\uC138\uC694",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "\uC774\uBA54\uC77C\uC744 \uD558\uB098 \uC774\uC0C1 \uC120\uD0DD\uD558\uC138\uC694",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "\uC0AC\uC6A9\uC790, \uD300 \uB610\uB294 \uC774\uBA54\uC77C\uC744 \uD558\uB098 \uC774\uC0C1 \uC120\uD0DD\uD558\uC138\uC694",
    'fabric.elements.share.in.integration.button': "{integrationName}\uC5D0\uC11C \uACF5\uC720",
    'fabric.elements.share.invite.to.confluence': "Confluence\uC5D0 \uCD08\uB300",
    'fabric.elements.share.invite.to.jira': "Jira\uC5D0 \uCD08\uB300",
    'fabric.elements.share.main.tab.text.confluence': "\uD398\uC774\uC9C0 \uACF5\uC720",
    'fabric.elements.share.main.tab.text.jira': "\uC774\uC288 \uACF5\uC720",
    'fabric.elements.share.menu.email.label': "\uC774\uBA54\uC77C",
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "\uACF5\uC720",
    'fabric.elements.share.success.message': "{object, select,blogpost {\uACF5\uC720\uD55C \uBE14\uB85C\uADF8 \uAC8C\uC2DC\uBB3C}board {\uACF5\uC720\uD55C \uBCF4\uB4DC}calendar {\uACF5\uC720\uD55C \uCE98\uB9B0\uB354}draft {\uACF5\uC720\uD55C \uCD08\uC548}filter {\uACF5\uC720\uD55C \uD544\uD130}issue {\uACF5\uC720\uD55C \uC774\uC288}summary {\uACF5\uC720\uD55C \uC694\uC57D}list {\uACF5\uC720\uD55C \uBAA9\uB85D}timeline {\uACF5\uC720\uD55C \uD0C0\uC784\uB77C\uC778}form {\uACF5\uC720\uD55C \uC591\uC2DD}media {\uACF5\uC720\uD55C \uBBF8\uB514\uC5B4}page {\uACF5\uC720\uD55C \uD398\uC774\uC9C0}project {\uACF5\uC720\uD55C \uD504\uB85C\uC81D\uD2B8}pullrequest {\uACF5\uC720\uD55C \uD480\uB9AC\uD018\uC2A4\uD2B8}question {\uACF5\uC720\uD55C \uC9C8\uBB38}report {\uACF5\uC720\uD55C \uBCF4\uACE0\uC11C}repository {\uACF5\uC720\uD55C \uB9AC\uD3EC\uC9C0\uD1A0\uB9AC}request {\uACF5\uC720\uD55C \uC694\uCCAD}timeline {\uACF5\uC720\uD55C \uD0C0\uC784\uB77C\uC778}site {\uACF5\uC720\uD55C \uC0AC\uC774\uD2B8}space {\uACF5\uC720\uD55C \uC2A4\uD398\uC774\uC2A4}other {\uACF5\uC720\uD55C \uB9C1\uD06C}}",
    'fabric.elements.share.to.integration.button': "{integrationName}\uC5D0 \uACF5\uC720",
    'fabric.elements.share.trigger.button.icon.label': "\uACF5\uC720 \uC544\uC774\uCF58",
    'fabric.elements.share.trigger.button.invite.text': "\uCD08\uB300",
    'fabric.elements.share.trigger.button.text': "\uACF5\uC720",
    'fabric.elements.share.trigger.button.tooltip.text': "\uACF5\uC720"
};

});

parcelRegister("16RW6", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa1be7e35603d5ed$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Norwegian (Bokmål)
var $fa1be7e35603d5ed$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Kobling er kopiert til utklippstavlen',
    'fabric.elements.share.copylink.button.text': 'Kopier kobling',
    'fabric.elements.share.copypubliclink.button.text': 'Kopier offentlig tilgjengelig kobling',
    'fabric.elements.share.failure.icon.label': 'Feil-ikon',
    'fabric.elements.share.failure.message': 'Kan ikke deles',
    'fabric.elements.share.form.comment.label': 'Melding (valgfritt)',
    'fabric.elements.share.form.comment.placeholder': "Er det noe mottakerne b\xf8r vite om dette?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "Mottakerne vil se navnet p\xe5 siden og meldingen",
    'fabric.elements.share.form.info.message.no.invite.jira': "Mottakerne vil se navnet p\xe5 saken og meldingen",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "Mottakerne vil se navnet p\xe5 arbeidsoppgaven og meldingen",
    'fabric.elements.share.form.no-permissions': "Du har ikke muligheten til \xe5 dele.",
    'fabric.elements.share.form.public.send': 'Send offentlig tilgjengelig kobling',
    'fabric.elements.share.form.public.share': 'Del offentlig kobling',
    'fabric.elements.share.form.required-field.summary': 'Obligatoriske felt er merket med stjerne',
    'fabric.elements.share.form.retry': "Pr\xf8v igjen",
    'fabric.elements.share.form.send': 'Send',
    'fabric.elements.share.form.share': 'Del',
    'fabric.elements.share.form.title': 'Del',
    'fabric.elements.share.form.user-picker.add-more': 'Legg til mer',
    'fabric.elements.share.form.user-picker.label.confluence': 'Navn, team, grupper eller e-poster',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Navn, team eller grupper',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Navn eller team',
    'fabric.elements.share.form.user-picker.label.email-only': 'E-poster',
    'fabric.elements.share.form.user-picker.label.jira': 'Navn, team eller e-poster',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'Vi kunne ikke finne noen resultater for "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'Vi kunne ikke finne noen resultater for "{inputValue}". Inviter personer ved \xe5 bruke en e-postadresse.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': "f.eks. Maria, oransje team, gruppe \xe9n",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'f.eks. Maria, oransje team',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'f.eks. maria@company.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'f.eks. Maria, oransje team, maria@company.com',
    'fabric.elements.share.form.user-picker.validation.required': "Velg minst \xe9n bruker, gruppe eller e-post eller minst ett team.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "Velg minst \xe9n person, gruppe, e-postadresse eller ett team",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "Velg minst \xe9n person, gruppe eller ett team",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "Velg minst \xe9n person eller ett team",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "Velg minst \xe9n e-postadresse",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "Velg minst \xe9n person, gruppe, e-postadresse eller ett team",
    'fabric.elements.share.in.integration.button': 'Del i {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Inviter til Confluence',
    'fabric.elements.share.invite.to.jira': 'Inviter til Jira',
    'fabric.elements.share.main.tab.text.confluence': 'Del side',
    'fabric.elements.share.main.tab.text.jira': 'Del sak',
    'fabric.elements.share.menu.email.label': 'E-post',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Del',
    'fabric.elements.share.success.message': "{object, select,blogpost {Blogginnlegg er delt}board {Tavle er delt}calendar {Kalender er delt}draft {Utkast er delt}filter {Filter er delt}issue {Sak er delt}summary {Sammendrag er delt}list {Liste er delt}timeline {Tidslinje er delt}form {Skjema er delt}media {Medier er delt}page {Side er delt}project {Prosjekt er delt}pullrequest {Pull-foresp\xf8rsel er delt}question {Sp\xf8rsm\xe5l er delt}report {Rapport er delt}repository {Repositorium er delt}request {Foresp\xf8rsel er delt}roadmap {Veikart er delt}site {Nettsted er delt}space {Omr\xe5de er delt}other {Kobling er delt}}",
    'fabric.elements.share.to.integration.button': 'Del til {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Dele-ikon',
    'fabric.elements.share.trigger.button.invite.text': 'Inviter',
    'fabric.elements.share.trigger.button.text': 'Del',
    'fabric.elements.share.trigger.button.tooltip.text': 'Del'
};

});

parcelRegister("hrNSu", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cf381178f2c2c61$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Dutch (Netherlands)
var $9cf381178f2c2c61$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Link naar klembord gekopieerd',
    'fabric.elements.share.copylink.button.text': "Link kopi\xebren",
    'fabric.elements.share.copypubliclink.button.text': "Openbare link kopi\xebren",
    'fabric.elements.share.failure.icon.label': "Pictogram 'Fout'",
    'fabric.elements.share.failure.message': 'Kan niet delen',
    'fabric.elements.share.form.comment.label': 'Bericht (optioneel)',
    'fabric.elements.share.form.comment.placeholder': 'Is er iets ze moet weten?',
    'fabric.elements.share.form.info.message.no.invite.confluence': 'Ontvangers zien de naam van de pagina en je bericht',
    'fabric.elements.share.form.info.message.no.invite.jira': 'Ontvangers zien de naam van de issue en je bericht',
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': 'Ontvangers zien de naam van het werkitem en je bericht',
    'fabric.elements.share.form.no-permissions': 'Je kunt niet delen.',
    'fabric.elements.share.form.public.send': 'Openbare link verzenden',
    'fabric.elements.share.form.public.share': 'Openbare link delen',
    'fabric.elements.share.form.required-field.summary': 'Verplichte velden zijn aangeduid met een asterisk',
    'fabric.elements.share.form.retry': 'Opnieuw proberen',
    'fabric.elements.share.form.send': 'Verzenden',
    'fabric.elements.share.form.share': 'Delen',
    'fabric.elements.share.form.title': 'Delen',
    'fabric.elements.share.form.user-picker.add-more': 'Meer invoeren',
    'fabric.elements.share.form.user-picker.label.confluence': 'Namen, teams, groepen of e-mails',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Namen, teams of groepen',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Namen of teams',
    'fabric.elements.share.form.user-picker.label.email-only': 'E-mails',
    'fabric.elements.share.form.user-picker.label.jira': 'Namen, teams of e-mails',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Geen resultaten gevonden voor ''{inputValue}'.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Geen resultaten gevonden voor ''{inputValue}'. Nodig personen uit door hun e-mailadres in te voeren.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': 'bijv. Maria, team Oranje, groep-een',
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'bijv. Maria, team Oranje',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'bijv. Maria, maria@bedrijf.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'bijv. Maria, team Oranje, maria@bedrijf.com',
    'fabric.elements.share.form.user-picker.validation.required': "Selecteer minimaal \xe9\xe9n gebruiker, groep, team of e-mailadres.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "Selecteer minimaal \xe9\xe9n persoon, team, groep of e-mailadres",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "Selecteer minimaal \xe9\xe9n persoon, team of groep",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "Selecteer minimaal \xe9\xe9n persoon of team",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "Selecteer minimaal \xe9\xe9n e-mailadres",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "Selecteer minimaal \xe9\xe9n persoon, team of e-mailadres",
    'fabric.elements.share.in.integration.button': 'Delen in {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Uitnodigen voor Confluence',
    'fabric.elements.share.invite.to.jira': 'Uitnodigen voor Jira',
    'fabric.elements.share.main.tab.text.confluence': 'Pagina delen',
    'fabric.elements.share.main.tab.text.jira': 'Issue delen',
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Delen',
    'fabric.elements.share.success.message': '{object, select,blogpost {Blogpost gedeeld}board {Bord gedeeld}calendar {Agenda gedeeld}draft {Concept gedeeld}filter {Filter gedeeld}issue {Issue gedeeld}summary {Samenvatting gedeeld}list {Lijst gedeeld}timeline {Tijdlijn gedeeld}form {Formulier gedeeld}media {Media gedeeld}page {Pagina gedeeld}project {Project gedeeld}pullrequest {Pull-request gedeeld}question {Vraag gedeeld}report {Rapport gedeeld}repository {Repository gedeeld}request {Aanvraag gedeeld}roadmap {Tijdlijn gedeeld}site {Site gedeeld}space {Space gedeeld}other {Link gedeeld}}',
    'fabric.elements.share.to.integration.button': 'Delen met {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': "Pictogram 'Delen'",
    'fabric.elements.share.trigger.button.invite.text': 'Uitnodigen',
    'fabric.elements.share.trigger.button.text': 'Delen',
    'fabric.elements.share.trigger.button.tooltip.text': 'Delen'
};

});

parcelRegister("ioYTp", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7d711b9dc04d41d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Polish (Poland)
var $f7d711b9dc04d41d$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "\u0141\u0105cze skopiowano do schowka",
    'fabric.elements.share.copylink.button.text': "Kopiuj \u0142\u0105cze",
    'fabric.elements.share.copypubliclink.button.text': "Kopiuj \u0142\u0105cze publiczne",
    'fabric.elements.share.failure.icon.label': "Ikona b\u0142\u0119du",
    'fabric.elements.share.failure.message': "Nie mo\u017Cna udost\u0119pni\u0107",
    'fabric.elements.share.form.comment.label': "Wiadomo\u015B\u0107 (opcjonalnie)",
    'fabric.elements.share.form.comment.placeholder': "Czy jest co\u015B, o czym powinni wiedzie\u0107?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "Odbiorcy zobacz\u0105 nazw\u0119 strony i Tw\xf3j komunikat",
    'fabric.elements.share.form.info.message.no.invite.jira': "Odbiorcy zobacz\u0105 nazw\u0119 zg\u0142oszenia i Tw\xf3j komunikat",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "Odbiorcy zobacz\u0105 nazw\u0119 zg\u0142oszenia i\xa0Tw\xf3j komunikat.",
    'fabric.elements.share.form.no-permissions': "Nie mo\u017Cesz udost\u0119pnia\u0107.",
    'fabric.elements.share.form.public.send': "Wy\u015Blij \u0142\u0105cze publiczne",
    'fabric.elements.share.form.public.share': "Udost\u0119pnij \u0142\u0105cze publiczne",
    'fabric.elements.share.form.required-field.summary': "Pola wymagane s\u0105 oznaczone gwiazdk\u0105",
    'fabric.elements.share.form.retry': "Spr\xf3buj ponownie",
    'fabric.elements.share.form.send': "Wy\u015Blij",
    'fabric.elements.share.form.share': "Udost\u0119pnij",
    'fabric.elements.share.form.title': "Udost\u0119pnij",
    'fabric.elements.share.form.user-picker.add-more': "Wprowad\u017A wi\u0119cej",
    'fabric.elements.share.form.user-picker.label.confluence': "Nazwy, zespo\u0142y, grupy lub adresy e-mail",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "Nazwy, zespo\u0142y lub grupy",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "Nazwy lub zespo\u0142y",
    'fabric.elements.share.form.user-picker.label.email-only': 'Adresy e-mail',
    'fabric.elements.share.form.user-picker.label.jira': "Nazwy, zespo\u0142y lub adresy e-mail",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Nie znaleziono wynik\xf3w dla \u201E{inputValue}\u201D.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Nie znaleziono wynik\xf3w dla \u201E{inputValue}\u201D. Zapro\u015B u\u017Cytkownik\xf3w, podaj\u0105c adres e-mail.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': "np. Maria, zesp\xf3\u0142 pomara\u0144czowy, grupa 1",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "np. Maria, zesp\xf3\u0142 pomara\u0144czowy",
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'np. maria@firma.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': "np. Maria, zesp\xf3\u0142 pomara\u0144czowy, maria@firma.com",
    'fabric.elements.share.form.user-picker.validation.required': "Wybierz co najmniej jednego u\u017Cytkownika, jedn\u0105 grup\u0119 albo jeden zesp\xf3\u0142 lub adres e-mail.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "Wybierz co najmniej jedn\u0105 osob\u0119, jeden zesp\xf3\u0142, jedn\u0105 grup\u0119 lub jeden adres e-mail",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "Wybierz co najmniej jedn\u0105 osob\u0119, jeden zesp\xf3\u0142 lub jedn\u0105 grup\u0119",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "Wybierz co najmniej jedn\u0105 osob\u0119 lub jeden zesp\xf3\u0142",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': 'Wybierz co najmniej jeden adres e-mail',
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "Wybierz co najmniej jedn\u0105 osob\u0119, jeden zesp\xf3\u0142 lub jeden adres e-mail",
    'fabric.elements.share.in.integration.button': "Udost\u0119pnij w {integrationName}",
    'fabric.elements.share.invite.to.confluence': "Zapro\u015B do\xa0Confluence",
    'fabric.elements.share.invite.to.jira': "Zapro\u015B do\xa0systemu Jira",
    'fabric.elements.share.main.tab.text.confluence': "Udost\u0119pnij stron\u0119",
    'fabric.elements.share.main.tab.text.jira': "Udost\u0119pnij zg\u0142oszenie",
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "Udost\u0119pnij",
    'fabric.elements.share.success.message': "{object, select,blogpost {Udost\u0119pniono wpis na blogu}board {Udost\u0119pniono tablic\u0119}calendar {Udost\u0119pniono kalendarz}draft {Udost\u0119pniono wersj\u0119 robocz\u0105}filter {Udost\u0119pniono filtr}issue {Udost\u0119pniono zg\u0142oszenie}summary {Udost\u0119pniono podsumowanie}list {Udost\u0119pniono list\u0119}timeline {Udost\u0119pniono o\u015B czasu}form {Udost\u0119pniono formularz}media {Udost\u0119pniono multimedia}page {Udost\u0119pniono stron\u0119}project {Udost\u0119pniono projekt}pullrequest {Udost\u0119pniono pull request}question {Udost\u0119pniono pytanie}report {Udost\u0119pniono raport}repository {Udost\u0119pniono repozytorium}request {Udost\u0119pniono wniosek}roadmap {Udost\u0119pniono o\u015B czasu}site {Udost\u0119pniono witryn\u0119}space {Udost\u0119pniono przestrze\u0144}other {Udost\u0119pniono \u0142\u0105cze}}",
    'fabric.elements.share.to.integration.button': "Udost\u0119pnij w {integrationName}",
    'fabric.elements.share.trigger.button.icon.label': "Ikona udost\u0119pniania",
    'fabric.elements.share.trigger.button.invite.text': "Zapro\u015B",
    'fabric.elements.share.trigger.button.text': "Udost\u0119pnij",
    'fabric.elements.share.trigger.button.tooltip.text': "Udost\u0119pnij"
};

});

parcelRegister("iQCSg", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2341ebeae6083b8$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Portuguese (Brazil)
var $b2341ebeae6083b8$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Link copiado para a \xe1rea de transfer\xeancia",
    'fabric.elements.share.copylink.button.text': 'Copiar link',
    'fabric.elements.share.copypubliclink.button.text': "Copiar link p\xfablico",
    'fabric.elements.share.failure.icon.label': "\xcdcone de erro",
    'fabric.elements.share.failure.message': "N\xe3o foi poss\xedvel compartilhar",
    'fabric.elements.share.form.comment.label': 'Mensagem (opcional)',
    'fabric.elements.share.form.comment.placeholder': "H\xe1 algo que eles deveriam saber?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "Os destinat\xe1rios v\xe3o ver o nome da p\xe1gina e sua mensagem",
    'fabric.elements.share.form.info.message.no.invite.jira': "Os destinat\xe1rios v\xe3o ver o nome do item e sua mensagem",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "Os destinat\xe1rios v\xe3o ver o nome do ticket e a mensagem",
    'fabric.elements.share.form.no-permissions': "Voc\xea n\xe3o est\xe1 apto a compartilhar.",
    'fabric.elements.share.form.public.send': "Enviar link p\xfablico",
    'fabric.elements.share.form.public.share': "Compartilhar link p\xfablico",
    'fabric.elements.share.form.required-field.summary': "Os campos obrigat\xf3rios est\xe3o marcados com um asterisco",
    'fabric.elements.share.form.retry': 'Tentar novamente',
    'fabric.elements.share.form.send': 'Enviar',
    'fabric.elements.share.form.share': 'Compartilhar',
    'fabric.elements.share.form.title': 'Compartilhar',
    'fabric.elements.share.form.user-picker.add-more': 'Insira mais itens',
    'fabric.elements.share.form.user-picker.label.confluence': 'Nomes, equipes, grupos ou e-mails',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Nomes, equipes ou grupos',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Nomes ou equipes',
    'fabric.elements.share.form.user-picker.label.email-only': 'E-mails',
    'fabric.elements.share.form.user-picker.label.jira': 'Nomes, equipes ou e-mails',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'N\xe3o encontramos nenhum resultado para "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'N\xe3o encontramos nenhum resultado para "{inputValue}". Convide pessoas usando um endere\xe7o de e-mail.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': 'por exemplo, Maria, equipe laranja, grupo um',
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'por exemplo, Maria, equipe laranja',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'por exemplo, maria@empresa.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'por exemplo, Maria, equipe laranja, maria@empresa.com',
    'fabric.elements.share.form.user-picker.validation.required': "Selecione ao menos um usu\xe1rio, grupo, equipe ou e-mail.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': 'Selecione pelo menos uma pessoa, equipe, grupo ou e-mail',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': 'Selecione pelo menos uma pessoa, equipe ou grupo',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': 'Selecione pelo menos uma pessoa ou equipe',
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': 'Selecione pelo menos um e-mail',
    'fabric.elements.share.form.user-picker.validation.required-message.jira': 'Selecione pelo menos uma pessoa, equipe ou e-mail',
    'fabric.elements.share.in.integration.button': 'Compartilhar em {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Convidar para o Confluence',
    'fabric.elements.share.invite.to.jira': 'Convidar para o Jira',
    'fabric.elements.share.main.tab.text.confluence': "Compartilhar p\xe1gina",
    'fabric.elements.share.main.tab.text.jira': 'Compartilhar item',
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Compartilhar',
    'fabric.elements.share.success.message': "{object, select,blogpost {Blog compartilhado}board {Quadro compartilhado}calendar {Calend\xe1rio compartilhado}draft {Rascunho compartilhado}filter {Filtro compartilhado}issue {Item compartilhado}summary {Resumo compartilhado}list {Lista compartilhada}timeline {Cronograma compartilhado}form {Formul\xe1rio compartilhado}media {M\xeddia compartilhada}page {P\xe1gina compartilhada}project {Projeto compartilhado}pullrequest {Pull request compartilhada}question {Pergunta compartilhada}report {Relat\xf3rio compartilhado}repository {Reposit\xf3rio compartilhado}request {Solicita\xe7\xe3o compartilhada}roadmap {Cronograma compartilhado}site {Site compartilhado}space {Espa\xe7o compartilhado}other {Link compartilhado}}",
    'fabric.elements.share.to.integration.button': 'Compartilhar em {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': "\xcdcone de compartilhamento",
    'fabric.elements.share.trigger.button.invite.text': 'Convidar',
    'fabric.elements.share.trigger.button.text': 'Compartilhar',
    'fabric.elements.share.trigger.button.tooltip.text': 'Compartilhar'
};

});

parcelRegister("hkr2R", function(module, exports) {

$parcel$export(module.exports, "default", () => $362c0a09cda3dcd7$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Portuguese (Portugal)
var $362c0a09cda3dcd7$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Liga\xe7\xe3o copiada para a \xe1rea de transfer\xeancia",
    'fabric.elements.share.copylink.button.text': "Copiar liga\xe7\xe3o",
    'fabric.elements.share.failure.icon.label': "\xcdcone de erro",
    'fabric.elements.share.failure.message': "N\xe3o \xe9 poss\xedvel partilhar",
    'fabric.elements.share.form.comment.placeholder': 'Adicionar uma mensagem',
    'fabric.elements.share.form.retry': 'Tentar novamente',
    'fabric.elements.share.form.send': 'Enviar',
    'fabric.elements.share.form.title': 'Partilhar',
    'fabric.elements.share.form.user-picker.add-more': 'Introduza mais',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'N\xe3o foi poss\xedvel encontrar resultados para "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'N\xe3o foi poss\xedvel encontrar resultados para "{inputValue}". Convite pessoas adicionando um endere\xe7o de e-mail.',
    'fabric.elements.share.form.user-picker.placeholder.existingUserOnly': 'Introduza o nome ou equipa',
    'fabric.elements.share.form.user-picker.placeholder.generic': 'Introduza o nome, grupo, equipa ou e-mail',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'Introduza o nome, a equipa ou o e-mail',
    'fabric.elements.share.form.user-picker.validation.required': 'Selecione, pelo menos, um utilizador, grupo, equipa ou e-mail.',
    'fabric.elements.share.form.user-picker.validation.required.jira': 'Selecione, pelo menos, um utilizador, equipa ou e-mail.',
    'fabric.elements.share.success.message': "{object, select, blogpost {Publica\xe7\xe3o do blogue partilhada} board {Quadro partilhado} calendar {Calend\xe1rio partilhado} draft {Rascunho partilhado} filter {Filtro partilhado} issue {Problema partilhado} media {Multim\xe9dia partilhado} page {P\xe1gina partilhada} project {Projeto partilhado} pullrequest {Pedidos Pull partilhados} question {Pergunta partilhada} report {Relat\xf3rio partilhado} repository {Reposit\xf3rio partilhado} request {Pedido partilhado} roadmap {Roteiro partilhado} site {Site partilhado} space {Espa\xe7o partilhado} other {Liga\xe7\xe3o partilhada}}",
    'fabric.elements.share.trigger.button.icon.label': "Partilhar \xedcone",
    'fabric.elements.share.trigger.button.invite.text': 'Convidar',
    'fabric.elements.share.trigger.button.text': 'Partilhar',
    'fabric.elements.share.trigger.button.tooltip.text': 'Partilhar'
};

});

parcelRegister("7dbDF", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bc047a07085c3fb$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by i18n-tools.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ // Romanian
var $6bc047a07085c3fb$export$2e2bcd8739ae039 = {
    'fabric.elements.share.form.title': "Partaja\u021Bi",
    'fabric.elements.share.form.send': "Trimite\u021Bi",
    'fabric.elements.share.form.retry': "Re\xeencerca\u021Bi",
    'fabric.elements.share.form.comment.placeholder': "Ad\u0103uga\u021Bi un mesaj",
    'fabric.elements.share.form.user-picker.placeholder.generic': "Introduce\u021Bi nume, echip\u0103 sau e-mail",
    'fabric.elements.share.form.user-picker.placeholder.existingUserOnly': "Introduce\u021Bi nume sau echip\u0103",
    'fabric.elements.share.form.user-picker.add-more': "Introduce\u021Bi mai multe",
    'fabric.elements.share.form.user-picker.validation.required': "Selecta\u021Bi cel pu\u021Bin un utilizator, echip\u0103 sau e-mail.",
    'fabric.elements.share.form.user-picker.no-options.domainBasedUserOnly': "Pute\u021Bi invita persoane nu mai cu adrese de e-mail {domains}. Contacta\u021Bi administratorul site-ului pentru a invita alte persoane.",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Nu am g\u0103sit niciun rezultat pentru \u201E{inputValue}\u201D.",
    'fabric.elements.share.form.user-picker.no-options.generic': 'Nu am g\u0103sit niciun rezultat pentru "{inputValue}". Invit\u0103 persoane utiliz\xe2nd o adres\u0103 de e-mail.',
    'fabric.elements.share.trigger.button.icon.label': "Pictogram\u0103 partajare",
    'fabric.elements.share.trigger.button.text': "Partaja\u021Bi",
    'fabric.elements.share.trigger.button.tooltip.text': "Partaja\u021Bi",
    'fabric.elements.share.trigger.button.invite.text': "Invita\u021Bi",
    'fabric.elements.share.copylink.button.icon.label': "Pictogram\u0103 copiere link",
    'fabric.elements.share.copylink.button.text': "Copia\u021Bi link",
    'fabric.elements.share.copied.to.clipboard.icon.label': "Pictogram\u0103 copiere linkuri cu succes",
    'fabric.elements.share.copied.to.clipboard.message': "Link copiat \xeen clipboard",
    'fabric.elements.share.form.capabilities.info.message': "Invita\u021Bia dvs. va fi transmis\u0103 unui administrator pentru aprobare",
    'fabric.elements.share.failure.icon.label': "Pictogram\u0103 eroare",
    'fabric.elements.share.failure.message': 'Nu se poate partaja',
    'fabric.elements.share.success.message': "{object, select, blogpost {Blog post shared} panou {Board shared} calendar {Calendar shared} schi\u021B\u0103{Draft shared} filtru {Filter shared} problem\u0103 {Issue shared} media {Media shared} pagin\u0103 {Page shared} proiect {Project shared} pullrequest {Pull Request shared} \xeentrebare {Question shared} raport {Report shared} depozit {Repository shared} solicitare {Request shared} planificare {Roadmap shared} site {Site shared} spa\u021Biu {Space shared} altele {Link Shared}}",
    'fabric.elements.share.admin.notified.message': 'Administratorul dvs. a fost notificat'
};

});

parcelRegister("8zZLq", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d906580aa8a5e1c$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Russian
var $7d906580aa8a5e1c$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "\u0421\u0441\u044B\u043B\u043A\u0430 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0432 \u0431\u0443\u0444\u0435\u0440 \u043E\u0431\u043C\u0435\u043D\u0430",
    'fabric.elements.share.copylink.button.text': "\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0441\u0441\u044B\u043B\u043A\u0443",
    'fabric.elements.share.copypubliclink.button.text': "\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043F\u0443\u0431\u043B\u0438\u0447\u043D\u0443\u044E \u0441\u0441\u044B\u043B\u043A\u0443",
    'fabric.elements.share.failure.icon.label': "\u0417\u043D\u0430\u0447\u043E\u043A \u043E\u0448\u0438\u0431\u043A\u0438",
    'fabric.elements.share.failure.message': "\u041D\u0435 \u0443\u0434\u0430\u0435\u0442\u0441\u044F \u043F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F",
    'fabric.elements.share.form.comment.label': "\u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 (\u043D\u0435\u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E)",
    'fabric.elements.share.form.comment.placeholder': "\u0427\u0442\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C \u0441\u043B\u0435\u0434\u0443\u0435\u0442 \u0437\u043D\u0430\u0442\u044C?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "\u041F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u0438 \u0443\u0432\u0438\u0434\u044F\u0442 \u0438\u043C\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u0438 \u0432\u0430\u0448\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435",
    'fabric.elements.share.form.info.message.no.invite.jira': "\u041F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u0438 \u0443\u0432\u0438\u0434\u044F\u0442 \u0438\u043C\u044F \u0437\u0430\u0434\u0430\u0447\u0438 \u0438 \u0432\u0430\u0448\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "\u041F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u0438 \u0443\u0432\u0438\u0434\u044F\u0442 \u0438\u043C\u044F \u0437\u0430\u0434\u0430\u0447\u0438 \u0438 \u0432\u0430\u0448\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435",
    'fabric.elements.share.form.no-permissions': "\u0423 \u0432\u0430\u0441 \u043D\u0435\u0442 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u0438 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043E\u0431\u0449\u0438\u0439 \u0434\u043E\u0441\u0442\u0443\u043F.",
    'fabric.elements.share.form.public.send': "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043F\u0443\u0431\u043B\u0438\u0447\u043D\u0443\u044E \u0441\u0441\u044B\u043B\u043A\u0443",
    'fabric.elements.share.form.public.share': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0441\u0441\u044B\u043B\u043A\u043E\u0439 \u043E\u0431\u0449\u0435\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430",
    'fabric.elements.share.form.required-field.summary': "\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u043F\u043E\u043B\u044F \u043E\u0442\u043C\u0435\u0447\u0435\u043D\u044B \u0437\u0432\u0435\u0437\u0434\u043E\u0447\u043A\u043E\u0439",
    'fabric.elements.share.form.retry': "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C",
    'fabric.elements.share.form.send': "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C",
    'fabric.elements.share.form.share': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F",
    'fabric.elements.share.form.title': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F",
    'fabric.elements.share.form.user-picker.add-more': "\u0414\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u0431\u043E\u043B\u044C\u0448\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439",
    'fabric.elements.share.form.user-picker.label.confluence': "\u0418\u043C\u0435\u043D\u0430, \u043A\u043E\u043C\u0430\u043D\u0434\u044B, \u0433\u0440\u0443\u043F\u043F\u044B \u0438\u043B\u0438 \u0430\u0434\u0440\u0435\u0441\u0430 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "\u0418\u043C\u0435\u043D\u0430, \u043A\u043E\u043C\u0430\u043D\u0434\u044B \u0438\u043B\u0438 \u0433\u0440\u0443\u043F\u043F\u044B",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "\u0418\u043C\u0435\u043D\u0430 \u0438\u043B\u0438 \u043A\u043E\u043C\u0430\u043D\u0434\u044B",
    'fabric.elements.share.form.user-picker.label.email-only': "\u0410\u0434\u0440\u0435\u0441\u0430 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B",
    'fabric.elements.share.form.user-picker.label.jira': "\u0418\u043C\u0435\u043D\u0430, \u043A\u043E\u043C\u0430\u043D\u0434\u044B \u0438\u043B\u0438 \u0430\u0434\u0440\u0435\u0441\u0430 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "\u041D\u0435\u0442 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043E\u0432 \u043F\u043E \u0437\u0430\u043F\u0440\u043E\u0441\u0443 \xab{inputValue}\xbb.",
    'fabric.elements.share.form.user-picker.no-options.generic': "\u041D\u0435\u0442 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043E\u0432 \u043F\u043E \u0437\u0430\u043F\u0440\u043E\u0441\u0443 \xab{inputValue}\xbb. \u041F\u0440\u0438\u0433\u043B\u0430\u0441\u0438\u0442\u0435 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439 \u043F\u043E \u0430\u0434\u0440\u0435\u0441\u0443 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': "\u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, \u041C\u0430\u0440\u0438\u044F, \u043A\u043E\u043C\u0430\u043D\u0434\u0430 \xab\u0410\u043F\u0435\u043B\u044C\u0441\u0438\u043D\xbb, \u0433\u0440\u0443\u043F\u043F\u0430-\u043E\u0434\u0438\u043D",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "\u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, \u041C\u0430\u0440\u0438\u044F, \u043A\u043E\u043C\u0430\u043D\u0434\u0430 \xab\u0410\u043F\u0435\u043B\u044C\u0441\u0438\u043D\xbb",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "\u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, maria@company.com",
    'fabric.elements.share.form.user-picker.placeholder.jira': "\u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, \u041C\u0430\u0440\u0438\u044F, \u043A\u043E\u043C\u0430\u043D\u0434\u0430 \xab\u0410\u043F\u0435\u043B\u044C\u0441\u0438\u043D\xbb, maria@company.com",
    'fabric.elements.share.form.user-picker.validation.required': "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0445\u043E\u0442\u044F \u0431\u044B 1\xa0\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u0433\u0440\u0443\u043F\u043F\u0443, \u043A\u043E\u043C\u0430\u043D\u0434\u0443 \u0438\u043B\u0438 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B. \u043F\u043E\u0447\u0442\u044B.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u043D\u043E\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u043A\u043E\u043C\u0430\u043D\u0434\u0443, \u0433\u0440\u0443\u043F\u043F\u0443 \u0438\u043B\u0438 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u043D\u043E\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u043A\u043E\u043C\u0430\u043D\u0434\u0443 \u0438\u043B\u0438 \u0433\u0440\u0443\u043F\u043F\u0443",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u043D\u043E\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0438\u043B\u0438 \u043A\u043E\u043C\u0430\u043D\u0434\u0443",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u0438\u043D \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u043D\u043E\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u043A\u043E\u043C\u0430\u043D\u0434\u0443 \u0438\u043B\u0438 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B",
    'fabric.elements.share.in.integration.button': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0432 {integrationName}",
    'fabric.elements.share.invite.to.confluence': "\u041F\u0440\u0438\u0433\u043B\u0430\u0441\u0438\u0442\u044C \u0432 Confluence",
    'fabric.elements.share.invite.to.jira': "\u041F\u0440\u0438\u0433\u043B\u0430\u0441\u0438\u0442\u044C \u0432 Jira",
    'fabric.elements.share.main.tab.text.confluence': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435\u0439",
    'fabric.elements.share.main.tab.text.jira': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0437\u0430\u0434\u0430\u0447\u0435\u0439",
    'fabric.elements.share.menu.email.label': "\u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430",
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F",
    'fabric.elements.share.success.message': "{object, select,blogpost {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0437\u0430\u043F\u0438\u0441\u0438 \u0432 \u0431\u043B\u043E\u0433\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}board {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0434\u043E\u0441\u043A\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}calendar {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u044E \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}draft {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0447\u0435\u0440\u043D\u043E\u0432\u0438\u043A\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}filter {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0444\u0438\u043B\u044C\u0442\u0440\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}issue {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0437\u0430\u0434\u0430\u0447\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}summary {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0442\u0435\u043C\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}list {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0441\u043F\u0438\u0441\u043A\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}timeline {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0445\u0440\u043E\u043D\u043E\u043B\u043E\u0433\u0438\u0438 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}form {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0444\u043E\u0440\u043C\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}media {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u043C\u0435\u0434\u0438\u0430\u0444\u0430\u0439\u043B\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}page {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}project {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u043F\u0440\u043E\u0435\u043A\u0442\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}pullrequest {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0437\u0430\u043F\u0440\u043E\u0441\u0443 pull \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}question {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0432\u043E\u043F\u0440\u043E\u0441\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}report {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u043E\u0442\u0447\u0435\u0442\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}repository {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0440\u0435\u043F\u043E\u0437\u0438\u0442\u043E\u0440\u0438\u044E \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}request {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0437\u0430\u043F\u0440\u043E\u0441\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}roadmap {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0445\u0440\u043E\u043D\u043E\u043B\u043E\u0433\u0438\u0438 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}site {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0441\u0430\u0439\u0442\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}space {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0440\u0430\u0437\u0434\u0435\u043B\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}other {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0441\u0441\u044B\u043B\u043A\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}}",
    'fabric.elements.share.to.integration.button': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0432 {integrationName}",
    'fabric.elements.share.trigger.button.icon.label': "\u0417\u043D\u0430\u0447\u043E\u043A \xab\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F\xbb",
    'fabric.elements.share.trigger.button.invite.text': "\u041F\u0440\u0438\u0433\u043B\u0430\u0441\u0438\u0442\u044C",
    'fabric.elements.share.trigger.button.text': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F",
    'fabric.elements.share.trigger.button.tooltip.text': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F"
};

});

parcelRegister("dGOFQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cd5c80c863bfbe9$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Slovak
var $9cd5c80c863bfbe9$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Prepojenie sa skop\xedrovalo do schr\xe1nky",
    'fabric.elements.share.copylink.button.text': "Kop\xedrova\u0165 prepojenie",
    'fabric.elements.share.failure.icon.label': 'Ikona chyby',
    'fabric.elements.share.failure.message': "Zdie\u013Eanie nie je mo\u017En\xe9",
    'fabric.elements.share.form.comment.placeholder': "Prida\u0165 spr\xe1vu",
    'fabric.elements.share.form.retry': "Opakova\u0165",
    'fabric.elements.share.form.send': "Odosla\u0165",
    'fabric.elements.share.form.title': "Zdie\u013Eanie",
    'fabric.elements.share.form.user-picker.add-more': "Zadajte \u010Fal\u0161ie polo\u017Eky",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Nepodarilo sa n\xe1js\u0165 \u017Eiadne v\xfdsledky pre \u201E{inputValue}\u201C.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Nepodarilo sa n\xe1js\u0165 \u017Eiadne v\xfdsledky pre \u201E{inputValue}\u201C. Pozvite \u013Eud\xed pomocou e-mailovej adresy.",
    'fabric.elements.share.form.user-picker.placeholder.existingUserOnly': "Zadajte meno alebo t\xedm",
    'fabric.elements.share.form.user-picker.placeholder.generic': "Zadajte meno, skupinu, t\xedm alebo e-mail",
    'fabric.elements.share.form.user-picker.placeholder.jira': "Zadajte meno, t\xedm alebo e-mail",
    'fabric.elements.share.form.user-picker.validation.required': "Vyberte aspo\u0148 jedn\xe9ho pou\u017E\xedvate\u013Ea, skupinu, t\xedm alebo e-mail.",
    'fabric.elements.share.form.user-picker.validation.required.jira': "Vyberte aspo\u0148 jedn\xe9ho pou\u017E\xedvate\u013Ea, t\xedm alebo e-mail.",
    'fabric.elements.share.success.message': "{object, select, blogpost {Blogov\xfd pr\xedspevok sa zdie\u013Eal} board {N\xe1stenka sa zdie\u013Eala} calendar {Kalend\xe1r sa zdie\u013Eal} draft {Koncept sa zdie\u013Eal} filter {Filter sa zdie\u013Eal} issue {Probl\xe9m sa zdie\u013Eal} media {Medi\xe1lny s\xfabor sa zdie\u013Eal} page {Str\xe1nka sa zdie\u013Eala} project {Projekt sa zdie\u013Eal} pullrequest {Po\u017Eiadavka na stiahnutie a pos\xfadenie sa zdie\u013Eala} question {Ot\xe1zka sa zdie\u013Eala} report {Zostava sa zdie\u013Eala} repository {Repozit\xe1r sa zdie\u013Eal} request {\u017Diados\u0165 sa zdie\u013Eala} roadmap {Pl\xe1n sa zdie\u013Eal} site {Web sa zdie\u013Eal} space {Priestor sa zdie\u013Eal} other {Prepojenie sa zdie\u013Ealo}}",
    'fabric.elements.share.trigger.button.icon.label': "Ikona zdie\u013Eania",
    'fabric.elements.share.trigger.button.invite.text': "Pozva\u0165",
    'fabric.elements.share.trigger.button.text': "Zdie\u013Ea\u0165",
    'fabric.elements.share.trigger.button.tooltip.text': "Zdie\u013Eanie"
};

});

parcelRegister("64yeQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $643613031271747a$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Swedish
var $643613031271747a$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "L\xe4nk kopierad till urklipp",
    'fabric.elements.share.copylink.button.text': "Kopiera l\xe4nk",
    'fabric.elements.share.copypubliclink.button.text': "Kopiera offentlig l\xe4nk",
    'fabric.elements.share.failure.icon.label': 'Fel-ikon',
    'fabric.elements.share.failure.message': 'Det gick inte att dela',
    'fabric.elements.share.form.comment.label': 'Meddelande (valfritt)',
    'fabric.elements.share.form.comment.placeholder': "Finns det n\xe5got de beh\xf6ver veta?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "Mottagare ser namnet p\xe5 sidan och ditt meddelande",
    'fabric.elements.share.form.info.message.no.invite.jira': "Mottagare ser namnet p\xe5 \xe4rendet och ditt meddelande",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "Mottagare ser namnet p\xe5 arbetsuppgiften och ditt meddelande",
    'fabric.elements.share.form.no-permissions': "Du har inte m\xf6jlighet att dela.",
    'fabric.elements.share.form.public.send': "Skicka offentlig l\xe4nk",
    'fabric.elements.share.form.public.share': "Dela offentlig l\xe4nk",
    'fabric.elements.share.form.required-field.summary': "Obligatoriska f\xe4lt \xe4r markerade med en asterisk",
    'fabric.elements.share.form.retry': "F\xf6rs\xf6k igen",
    'fabric.elements.share.form.send': 'Skicka',
    'fabric.elements.share.form.share': 'Dela',
    'fabric.elements.share.form.title': 'Dela',
    'fabric.elements.share.form.user-picker.add-more': 'Ange fler',
    'fabric.elements.share.form.user-picker.label.confluence': 'Namn, team, grupper eller e-postadresser',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Namn, team eller grupper',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Namn eller team',
    'fabric.elements.share.form.user-picker.label.email-only': 'E-postadresser',
    'fabric.elements.share.form.user-picker.label.jira': 'Namn, team eller e-postadresser',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'Vi hittade inte n\xe5gra resultat f\xf6r "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'Vi hittade inte n\xe5gra resultat f\xf6r "{inputValue}". Bjud in personer genom att anv\xe4nda e-postadresser.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': 't.ex. Maria, Team Orange, grupp-ett',
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 't.ex. Maria, Team Orange',
    'fabric.elements.share.form.user-picker.placeholder.email-only': "t.ex. maria@f\xf6retag.se",
    'fabric.elements.share.form.user-picker.placeholder.jira': "t.ex. Maria, Team Orange, maria@f\xf6retag.se",
    'fabric.elements.share.form.user-picker.validation.required': "V\xe4lj minst en anv\xe4ndare, en grupp, ett team eller en e-postadress.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "V\xe4lj minst en person, ett team, en grupp eller en e-postadress",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "V\xe4lj minst en person, ett team eller en grupp",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "V\xe4lj minst en person eller ett team",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "V\xe4lj minst en e-postadress",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "V\xe4lj minst en person, ett team eller en e-postadress",
    'fabric.elements.share.in.integration.button': 'Dela i {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Bjud in till Confluence',
    'fabric.elements.share.invite.to.jira': 'Bjud in till Jira',
    'fabric.elements.share.main.tab.text.confluence': 'Dela sida',
    'fabric.elements.share.main.tab.text.jira': "Dela \xe4rende",
    'fabric.elements.share.menu.email.label': 'E-post',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Dela',
    'fabric.elements.share.success.message': "{object, select,blogpost {Blogginl\xe4gg har delats}board {Tavla har delats}calendar {Kalender har delats}draft {Utkast har delats}filter {Filter har delats}issue {\xc4rende har delats}summary {Sammanfattning har delats}list {Lista har delats}timeline {Tidslinje har delats}form {Formul\xe4r har delats}media {Media har delats}page {Sida har delats}project {Projekt har delats}pullrequest {Pull request har delats}question {Fr\xe5ga har delats}report {Rapport har delats}repository {Lagringsplats har delats}request {F\xf6rfr\xe5gan har delats}roadmap {Tidslinje har delats}site {Webbplats har delats}space {Utrymme har delats}other {L\xe4nk har delats}}",
    'fabric.elements.share.to.integration.button': 'Dela till {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Dela-ikon',
    'fabric.elements.share.trigger.button.invite.text': 'Bjud In',
    'fabric.elements.share.trigger.button.text': 'Dela',
    'fabric.elements.share.trigger.button.tooltip.text': 'Dela'
};

});

parcelRegister("iTJhG", function(module, exports) {

$parcel$export(module.exports, "default", () => $65937a71b1200549$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Simplified)
var $65937a71b1200549$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "\u94FE\u63A5\u5DF2\u590D\u5236\u5230\u526A\u8D34\u677F",
    'fabric.elements.share.copylink.button.text': "\u590D\u5236\u94FE\u63A5",
    'fabric.elements.share.copypubliclink.button.text': "\u590D\u5236\u516C\u5171\u94FE\u63A5",
    'fabric.elements.share.failure.icon.label': "\u9519\u8BEF\u56FE\u6807",
    'fabric.elements.share.failure.message': "\u65E0\u6CD5\u5171\u4EAB",
    'fabric.elements.share.form.comment.label': "\u6D88\u606F\uFF08\u53EF\u9009\uFF09",
    'fabric.elements.share.form.comment.placeholder': "\u5BF9\u65B9\u662F\u5426\u5E94\u77E5\u9053\u67D0\u4E9B\u4FE1\u606F\uFF1F",
    'fabric.elements.share.form.info.message.no.invite.confluence': "\u6536\u4EF6\u4EBA\u5C06\u770B\u5230\u9875\u9762\u540D\u79F0\u548C\u60A8\u7684\u6D88\u606F",
    'fabric.elements.share.form.info.message.no.invite.jira': "\u6536\u4EF6\u4EBA\u5C06\u770B\u5230\u4E8B\u52A1\u540D\u79F0\u548C\u60A8\u7684\u6D88\u606F",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "\u6536\u4EF6\u4EBA\u5C06\u770B\u5230\u5DE5\u4F5C\u9879\u540D\u79F0\u548C\u60A8\u7684\u6D88\u606F",
    'fabric.elements.share.form.no-permissions': "\u60A8\u65E0\u6CD5\u5171\u4EAB\u3002",
    'fabric.elements.share.form.public.send': "\u53D1\u9001\u516C\u5171\u94FE\u63A5",
    'fabric.elements.share.form.public.share': "\u5206\u4EAB\u516C\u5F00\u94FE\u63A5",
    'fabric.elements.share.form.required-field.summary': "\u5FC5\u586B\u5B57\u6BB5\u6807\u6709\u661F\u53F7",
    'fabric.elements.share.form.retry': "\u91CD\u8BD5",
    'fabric.elements.share.form.send': "\u53D1\u9001",
    'fabric.elements.share.form.share': "\u5171\u4EAB",
    'fabric.elements.share.form.title': "\u5171\u4EAB",
    'fabric.elements.share.form.user-picker.add-more': "\u8F93\u5165\u66F4\u591A",
    'fabric.elements.share.form.user-picker.label.confluence': "\u59D3\u540D\u3001\u56E2\u961F\u3001\u7FA4\u7EC4\u6216\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "\u59D3\u540D\u3001\u56E2\u961F\u6216\u7FA4\u7EC4",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "\u59D3\u540D\u6216\u56E2\u961F",
    'fabric.elements.share.form.user-picker.label.email-only': "\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
    'fabric.elements.share.form.user-picker.label.jira': "\u59D3\u540D\u3001\u56E2\u961F\u6216\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "\u6211\u4EEC\u627E\u4E0D\u5230\u4EFB\u4F55\u5173\u4E8E\u201C{inputValue}\u201D\u7684\u7ED3\u679C\u3002",
    'fabric.elements.share.form.user-picker.no-options.generic': "\u6211\u4EEC\u627E\u4E0D\u5230\u4EFB\u4F55\u5173\u4E8E\u201C{inputValue}\u201D\u7684\u7ED3\u679C\u3002\u8BF7\u7528\u7535\u5B50\u90AE\u4EF6\u5730\u5740\u9080\u8BF7\u4ED6\u4EBA\u3002",
    'fabric.elements.share.form.user-picker.placeholder.confluence': "\u4F8B\u5982\uFF0C\u739B\u5229\u4E9A\u3001\u6A59\u961F\u3001\u7B2C\u4E00\u7EC4",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "\u4F8B\u5982\uFF0C\u739B\u5229\u4E9A\u3001\u6A59\u961F",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "\u4F8B\u5982\uFF0Cmaria@company.com",
    'fabric.elements.share.form.user-picker.placeholder.jira': "\u4F8B\u5982\uFF0C\u739B\u5229\u4E9A\u3001\u6A59\u961F\u3001maria@company.com",
    'fabric.elements.share.form.user-picker.validation.required': "\u8BF7\u81F3\u5C11\u9009\u62E9\u4E00\u4E2A\u7528\u6237\u3001\u7EC4\u3001\u56E2\u961F\u6216\u7535\u5B50\u90AE\u4EF6\u3002",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "\u8BF7\u81F3\u5C11\u9009\u62E9\u4E00\u4E2A\u4EBA\u5458\u3001\u56E2\u961F\u3001\u7FA4\u7EC4\u6216\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "\u8BF7\u81F3\u5C11\u9009\u62E9\u4E00\u4E2A\u4EBA\u5458\u3001\u56E2\u961F\u6216\u7FA4\u7EC4",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "\u8BF7\u81F3\u5C11\u9009\u62E9\u4E00\u4E2A\u4EBA\u5458\u6216\u56E2\u961F",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "\u8BF7\u81F3\u5C11\u9009\u62E9\u4E00\u4E2A\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "\u8BF7\u81F3\u5C11\u9009\u62E9\u4E00\u4E2A\u4EBA\u5458\u3001\u56E2\u961F\u6216\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
    'fabric.elements.share.in.integration.button': "\u5728 {integrationName} \u4E2D\u5206\u4EAB",
    'fabric.elements.share.invite.to.confluence': "\u9080\u8BF7\u52A0\u5165 Confluence",
    'fabric.elements.share.invite.to.jira': "\u9080\u8BF7\u52A0\u5165 Jira",
    'fabric.elements.share.main.tab.text.confluence': "\u5206\u4EAB\u9875\u9762",
    'fabric.elements.share.main.tab.text.jira': "\u5171\u4EAB\u4E8B\u52A1",
    'fabric.elements.share.menu.email.label': "\u7535\u5B50\u90AE\u4EF6",
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "\u5171\u4EAB",
    'fabric.elements.share.success.message': "{object, select,blogpost {\u535A\u5BA2\u6587\u7AE0\u5DF2\u5171\u4EAB}board {\u9762\u677F\u5DF2\u5171\u4EAB}calendar {\u65E5\u5386\u5DF2\u5171\u4EAB}draft {\u8349\u7A3F\u5DF2\u5171\u4EAB}filter {\u7B5B\u9009\u5668\u5DF2\u5171\u4EAB}issue {\u4E8B\u52A1\u5DF2\u5171\u4EAB}summary {\u6458\u8981\u5DF2\u5171\u4EAB}list {\u5217\u8868\u5DF2\u5171\u4EAB}timeline {\u65F6\u95F4\u7EBF\u5DF2\u5171\u4EAB}form {\u8868\u5355\u5DF2\u5171\u4EAB}media {\u5A92\u4F53\u5DF2\u5171\u4EAB}page {\u9875\u9762\u5DF2\u5171\u4EAB}project {\u9879\u76EE\u5DF2\u5171\u4EAB}pullrequest {\u62C9\u53D6\u8BF7\u6C42\u5DF2\u5171\u4EAB}question {\u95EE\u9898\u5DF2\u5171\u4EAB}report {\u62A5\u544A\u5DF2\u5171\u4EAB}repository {\u5B58\u50A8\u5E93\u5DF2\u5171\u4EAB}request {\u8BF7\u6C42\u5DF2\u5171\u4EAB}roadmap {\u65F6\u95F4\u7EBF\u5DF2\u5171\u4EAB}site {\u7AD9\u70B9\u5DF2\u5171\u4EAB}space {\u7A7A\u95F4\u5DF2\u5171\u4EAB}other {\u94FE\u63A5\u5DF2\u5171\u4EAB}}",
    'fabric.elements.share.to.integration.button': "\u5206\u4EAB\u5230 {integrationName}",
    'fabric.elements.share.trigger.button.icon.label': "\u5171\u4EAB\u56FE\u6807",
    'fabric.elements.share.trigger.button.invite.text': "\u9080\u8BF7",
    'fabric.elements.share.trigger.button.text': "\u5171\u4EAB",
    'fabric.elements.share.trigger.button.tooltip.text': "\u5171\u4EAB"
};

});



parcelRegister("7v5Ga", function(module, exports) {

$parcel$export(module.exports, "ShareDialogWithTrigger", () => $2879aae105082725$export$c7f8df1e37e7f581);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $ousew = parcelRequire("ousew");
var $8RXs9 = parcelRequire("8RXs9");

var $cb25w = parcelRequire("cb25w");

var $kOEld = parcelRequire("kOEld");

var $VSDnB = parcelRequire("VSDnB");

var $1I7E8 = parcelRequire("1I7E8");

var $k8nZq = parcelRequire("k8nZq");

var $k5uoT = parcelRequire("k5uoT");

var $3bDjY = parcelRequire("3bDjY");

var $idKBS = parcelRequire("idKBS");


var $b2oBK = parcelRequire("b2oBK");

var $hQWyD = parcelRequire("hQWyD");

var $65uFp = parcelRequire("65uFp");

var $KNlKW = parcelRequire("KNlKW");

var $bked4 = parcelRequire("bked4");

var $1t1FK = parcelRequire("1t1FK");

var $cnQaw = parcelRequire("cnQaw");

var $4gTjW = parcelRequire("4gTjW");
function $2879aae105082725$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2879aae105082725$var$shareButtonWrapperStyles = {
    name: "8s6ifx",
    styles: "display:inline-flex;outline:none"
};
const $2879aae105082725$export$4d9147e1bc6c176 = {
    users: [],
    comment: {
        format: 'plain_text',
        value: ''
    }
};
const $2879aae105082725$export$55abe7932f6ca981 = ()=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kOEld))), {
        spacing: "spacious",
        label: "",
        color: "currentColor"
    });
class $2879aae105082725$export$e927f7ec13b9edc0 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    static{
        this.defaultProps = {
            isDisabled: false,
            dialogPlacement: 'bottom-end',
            shouldCloseOnEscapePress: true,
            triggerButtonAppearance: 'subtle',
            triggerButtonStyle: 'icon-only',
            triggerButtonTooltipPosition: 'top',
            dialogZIndex: (0, $k5uoT.layers).modal()
        };
    }
    componentDidMount() {
        if (this.props.isAutoOpenDialog) this.handleDialogOpen();
    }
    componentDidUpdate(prevProps) {
        if (this.props.isAutoOpenDialog !== prevProps.isAutoOpenDialog && this.props.isAutoOpenDialog) this.handleDialogOpen();
    }
    componentWillUnmount() {
        if (this.props.isAutoOpenDialog && this.props.onDialogClose) this.props.onDialogClose();
    }
    async generateShareError(err) {
        const errorBody = err.body ? await err.body : {};
        // We'll only try and deal with the first error, sorry
        const firstErrorFromBody = errorBody.messagesDetails?.[0];
        return {
            message: firstErrorFromBody?.message || err.message,
            errorCode: firstErrorFromBody?.errorCode,
            helpUrl: firstErrorFromBody?.helpUrl,
            retryable: firstErrorFromBody?.errorCode === undefined
        };
    }
    render() {
        const { isDialogOpen: isDialogOpen, isSharing: isSharing, shareError: shareError, defaultValue: defaultValue, showIntegrationForm: showIntegrationForm, selectedIntegration: selectedIntegration, isMenuItemSelected: isMenuItemSelected } = this.state;
        const { copyLink: copyLink, dialogPlacement: dialogPlacement, config: config, isFetchingConfig: isFetchingConfig, loadUserOptions: loadUserOptions, shareFormTitle: shareFormTitle, shareFormHelperMessage: shareFormHelperMessage, bottomMessage: bottomMessage, submitButtonLabel: submitButtonLabel, product: product, productAttributes: productAttributes, customHeader: customHeader, customFooter: customFooter, enableSmartUserPicker: enableSmartUserPicker, loggedInAccountId: loggedInAccountId, cloudId: cloudId, orgId: orgId, shareFieldsFooter: shareFieldsFooter, dialogZIndex: dialogZIndex, isPublicLink: isPublicLink, tabIndex: tabIndex, copyTooltipText: copyTooltipText, integrationMode: integrationMode, shareIntegrations: shareIntegrations, additionalTabs: additionalTabs, builtInTabContentWidth: builtInTabContentWidth, isBrowseUsersDisabled: isBrowseUsersDisabled, userPickerOptions: userPickerOptions, isSubmitShareDisabled: isSubmitShareDisabled, additionalUserFields: additionalUserFields, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled, CustomSubmitButton: CustomSubmitButton } = this.props;
        const style = typeof tabIndex !== 'undefined' && tabIndex >= 0 ? {
            outline: 'none'
        } : undefined;
        const footer = (0, $4gTjW.resolveShareFooter)(integrationMode, this.state.tabIndex, customFooter);
        // for performance purposes, we may want to have a loadable content i.e. ShareForm
        return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
        /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $2879aae105082725$var$shareButtonWrapperStyles,
            tabIndex: tabIndex,
            onKeyDown: this.handleKeyDown,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: style
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1I7E8.default), {
            content: ()=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
                    ref: this.containerRef
                }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $KNlKW.default), {
                    Content: selectedIntegration && selectedIntegration.Content,
                    selectedIntegration: selectedIntegration,
                    copyLink: copyLink,
                    showIntegrationForm: showIntegrationForm,
                    bottomMessage: bottomMessage,
                    customHeader: (0, $VSDnB.fg)('platform_share_custom_header_prop') && customHeader,
                    customFooter: footer,
                    loadOptions: loadUserOptions,
                    isSharing: isSharing,
                    shareFormTitle: shareFormTitle,
                    showTitle: integrationMode !== 'tabs' || !shareIntegrations || !shareIntegrations.length,
                    shareFormHelperMessage: shareFormHelperMessage,
                    shareError: shareError,
                    defaultValue: defaultValue,
                    config: config,
                    isFetchingConfig: isFetchingConfig,
                    setIsLoading: this.setIsLoading,
                    submitButtonLabel: submitButtonLabel,
                    product: product,
                    productAttributes: productAttributes,
                    enableSmartUserPicker: enableSmartUserPicker,
                    loggedInAccountId: loggedInAccountId,
                    cloudId: cloudId,
                    orgId: orgId,
                    onUserSelectionChange: this.handleOnUserSelectionChange,
                    shareFieldsFooter: shareFieldsFooter,
                    isPublicLink: isPublicLink,
                    copyTooltipText: copyTooltipText,
                    integrationMode: integrationMode,
                    shareIntegrations: shareIntegrations,
                    additionalTabs: additionalTabs,
                    builtInTabContentWidth: builtInTabContentWidth,
                    isMenuItemSelected: isMenuItemSelected,
                    isSubmitShareDisabled: isSubmitShareDisabled,
                    // actions
                    onLinkCopy: this.handleCopyLink,
                    onSubmit: this.handleShareSubmit,
                    onDismiss: this.handleFormDismiss,
                    onDialogClose: this.handleCloseDialog,
                    onTabChange: this.onTabChange,
                    onMenuItemChange: this.onMenuItemChange,
                    //ref
                    selectPortalRef: this.selectPortalRef,
                    isBrowseUsersDisabled: isBrowseUsersDisabled,
                    userPickerOptions: userPickerOptions,
                    additionalUserFields: additionalUserFields,
                    isExtendedShareDialogEnabled: isExtendedShareDialogEnabled,
                    CustomSubmitButton: CustomSubmitButton
                })),
            isOpen: isDialogOpen,
            onClose: this.handleCloseDialog,
            placement: dialogPlacement,
            trigger: this.renderShareTriggerButton,
            zIndex: dialogZIndex,
            label: this.props.intl.formatMessage((0, $idKBS.messages).sharePopupLabel),
            role: "dialog",
            // TODO: remove after https://hello.atlassian.net/wiki/x/SoEGzQ experiment is finished
            offset: this.calculatePopupOffset({
                isMenuItemSelected: isMenuItemSelected,
                dialogPlacement: dialogPlacement
            }),
            shouldRenderToParent: (0, $VSDnB.fg)('enable-appropriate-reading-order-in-share-dialog')
        }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $k8nZq.default), {
            zIndex: (0, $4gTjW.generateSelectZIndex)(dialogZIndex)
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            ref: this.selectPortalRef
        }))));
    }
    constructor(...args){
        super(...args), this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), /**
   * Because the PopUp component has a higher zIndex it causes
   * the select to be rendered within it, and add scrollbars.
   * We will render the select options the PopUp outside,
   */ this.selectPortalRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.start = 0, this.state = {
            isDialogOpen: false,
            isSharing: false,
            ignoreIntermediateState: false,
            defaultValue: $2879aae105082725$export$4d9147e1bc6c176,
            isUsingSplitButton: false,
            showIntegrationForm: false,
            selectedIntegration: null,
            tabIndex: 0,
            isMenuItemSelected: false,
            isLoading: false
        }, this.closeAndResetDialog = ()=>{
            this.setState({
                defaultValue: $2879aae105082725$export$4d9147e1bc6c176,
                ignoreIntermediateState: true,
                shareError: undefined,
                isDialogOpen: false,
                showIntegrationForm: false,
                selectedIntegration: null,
                isMenuItemSelected: false
            });
            const { onUserSelectionChange: onUserSelectionChange, onDialogClose: onDialogClose } = this.props;
            if (onUserSelectionChange) onUserSelectionChange($2879aae105082725$export$4d9147e1bc6c176.users);
            if (onDialogClose) onDialogClose();
        }, this.createAndFireEvent = (payload)=>{
            const { createAnalyticsEvent: createAnalyticsEvent, analyticsDecorator: analyticsDecorator } = this.props;
            if (analyticsDecorator) payload = analyticsDecorator(payload);
            if (createAnalyticsEvent) createAnalyticsEvent(payload).fire((0, $b2oBK.CHANNEL_ID));
        }, this.onTabChange = (index)=>{
            let subjectId = 'shareTab';
            const { shareContentType: shareContentType } = this.props;
            if (index === 1) subjectId = 'shareToSlackTab';
            this.createAndFireEvent((0, $b2oBK.shareTabClicked)(subjectId, shareContentType));
            this.setState({
                tabIndex: index
            });
        }, this.onMenuItemChange = (menuType)=>{
            let subjectId = menuType === 'Slack' ? 'shareToSlackMenuItem' : 'shareMenuItem';
            const { shareContentType: shareContentType } = this.props;
            this.createAndFireEvent((0, $b2oBK.shareMenuItemClicked)(subjectId, shareContentType));
            this.setState({
                isMenuItemSelected: true
            });
        }, this.getFlags = ()=>{
            const { intl: { formatMessage: formatMessage } } = this.props;
            // The reason for providing message property is that in jira,
            // the Flag system takes only Message Descriptor as payload
            // and formatMessage is called for every flag
            // if the translation data is not provided, a translated default message
            // will be displayed
            return [
                {
                    appearance: 'success',
                    title: {
                        ...(0, $idKBS.messages).shareSuccessMessage,
                        defaultMessage: formatMessage((0, $idKBS.messages).shareSuccessMessage, {
                            object: this.props.shareContentType.toLowerCase()
                        })
                    },
                    type: (0, $dcbcc8fabc474606$export$9540ac9c843b8743)
                }
            ];
        }, this.setIsLoading = (isLoading)=>{
            this.setState({
                isLoading: isLoading
            });
        }, this.focus = ()=>{
            if (this.containerRef.current) this.containerRef.current.focus();
        }, this.handleKeyDown = (event)=>{
            const { isLoading: isLoading, isDialogOpen: isDialogOpen } = this.state;
            const { shouldCloseOnEscapePress: shouldCloseOnEscapePress } = this.props;
            if (isLoading) {
                event.stopPropagation();
                this.focus();
            }
            if (isDialogOpen) switch(event.key){
                case 'Esc':
                case 'Escape':
                    // The @atlaskit/popup will capture the event and auto-close, we
                    // need to prevent that if the dialog is set to not close on `ESC`
                    if (!shouldCloseOnEscapePress) {
                        event.preventDefault();
                        event.stopPropagation();
                        // put the focus back onto the share dialog so that
                        // the user can press the escape key again to close the dialog
                        this.focus();
                        return;
                    }
                    // The dialog will auto-close in @atlaskit/popup, we just need to fire
                    // the right events.
                    if (shouldCloseOnEscapePress) {
                        // This experience should be aborted in a scenario when a user closes the dialog before the shareClient.getConfig() call is finished
                        // It is a race condition between the `SUCCEEDED` case and the `ABORTED` case of this experience
                        // UFO experiences can only have one FINAL state so it doesn't matter if we call .abort() after the experience has succeeded and vice versa
                        (0, $65uFp.renderShareDialogExp).abort();
                        this.createAndFireEvent((0, $b2oBK.cancelShare)(this.start));
                        this.closeAndResetDialog();
                    }
            }
        }, this.handleDialogOpen = ()=>{
            this.setState((state)=>({
                    isDialogOpen: !state.isDialogOpen,
                    ignoreIntermediateState: false,
                    showIntegrationForm: false,
                    selectedIntegration: null
                }), ()=>{
                const { onDialogOpen: onDialogOpen, isPublicLink: isPublicLink } = this.props;
                const { isDialogOpen: isDialogOpen } = this.state;
                if (isDialogOpen) {
                    this.start = Date.now();
                    this.createAndFireEvent((0, $b2oBK.screenEvent)({
                        isPublicLink: isPublicLink
                    }));
                    if (onDialogOpen) onDialogOpen();
                    this.focus();
                } else this.handleCloseDialog();
            });
        }, this.onTriggerClick = ()=>{
            const { onTriggerButtonClick: onTriggerButtonClick } = this.props;
            this.createAndFireEvent((0, $b2oBK.shareTriggerButtonClicked)());
            this.handleDialogOpen();
            if (onTriggerButtonClick) onTriggerButtonClick();
        }, this.handleCloseDialog = ()=>{
            if (this.props.onDialogClose) this.props.onDialogClose();
            // This experience should be aborted in a scenario when a user closes the dialog before the shareClient.getConfig() call is finished
            // It is a race condition between the `SUCCEEDED` case and the `ABORTED` case of this experience
            // UFO experiences can only have one FINAL state so it doesn't matter if we call .abort() after the experience has succeeded and vice versa
            (0, $65uFp.renderShareDialogExp).abort();
            this.setState({
                isDialogOpen: false,
                showIntegrationForm: false,
                selectedIntegration: null,
                tabIndex: 0,
                isMenuItemSelected: false
            });
        }, this.handleShareSubmit = (data)=>{
            const { onShareSubmit: onShareSubmit, shareContentType: shareContentType, shareContentSubType: shareContentSubType, shareContentId: shareContentId, formShareOrigin: formShareOrigin, showFlags: showFlags, isPublicLink: isPublicLink, createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (!onShareSubmit) return;
            (0, $65uFp.shareSubmitExp).start();
            this.setState({
                isSharing: true
            });
            this.createAndFireEvent((0, $b2oBK.formShareSubmitted)({
                start: this.start,
                data: data,
                shareContentType: shareContentType,
                shareOrigin: formShareOrigin,
                isPublicLink: isPublicLink,
                shareContentSubType: shareContentSubType,
                shareContentId: shareContentId
            }));
            if (createAnalyticsEvent) createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'shared',
                    actionSubject: 'page',
                    source: (0, $b2oBK.ANALYTICS_SOURCE),
                    attributes: {
                        contentType: shareContentType,
                        subContentType: shareContentSubType,
                        shareData: data
                    }
                }
            }).fire();
            onShareSubmit(data).then(()=>{
                this.closeAndResetDialog();
                this.setState({
                    isSharing: false
                });
                showFlags(this.getFlags());
                (0, $65uFp.shareSubmitExp).success();
            }).catch(async (err)=>{
                const shareError = await this.generateShareError(err).catch((errorGenFailed)=>({
                        message: err.message || errorGenFailed.message || 'Unknown error',
                        retryable: true
                    }));
                this.setState({
                    isSharing: false,
                    shareError: shareError
                });
                (0, $hQWyD.isValidFailedExperience)((0, $65uFp.shareSubmitExp), err);
            });
        }, this.handleFormDismiss = (data)=>{
            this.setState(({ ignoreIntermediateState: ignoreIntermediateState })=>ignoreIntermediateState ? null : {
                    defaultValue: data
                });
        }, this.calculatePopupOffset = ({ isMenuItemSelected: isMenuItemSelected, dialogPlacement: dialogPlacement })=>{
            if (isMenuItemSelected && dialogPlacement === 'bottom-end') return [
                -0.1,
                8
            ];
            return [
                0,
                8
            ];
        }, this.handleCopyLink = ()=>{
            const { copyLinkOrigin: copyLinkOrigin, shareContentType: shareContentType, shareContentSubType: shareContentSubType, shareContentId: shareContentId, isPublicLink: isPublicLink, shareAri: shareAri } = this.props;
            this.createAndFireEvent((0, $b2oBK.copyLinkButtonClicked)({
                start: this.start,
                shareContentType: shareContentType,
                shareOrigin: copyLinkOrigin,
                isPublicLink: isPublicLink,
                ari: shareAri,
                shareContentSubType: shareContentSubType,
                shareContentId: shareContentId
            }));
        }, this.handleIntegrationClick = (integration)=>{
            this.setState({
                isUsingSplitButton: false,
                isDialogOpen: true,
                showIntegrationForm: true,
                selectedIntegration: integration
            });
        }, this.renderShareTriggerButton = (triggerProps)=>{
            const { isDialogOpen: isDialogOpen, isUsingSplitButton: isUsingSplitButton } = this.state;
            const { intl: { formatMessage: formatMessage }, isDisabled: isDisabled, renderCustomTriggerButton: renderCustomTriggerButton, triggerButtonIcon: triggerButtonIcon, triggerButtonTooltipText: triggerButtonTooltipText, triggerButtonTooltipPosition: triggerButtonTooltipPosition, triggerButtonAppearance: triggerButtonAppearance, triggerButtonStyle: triggerButtonStyle, integrationMode: integrationMode, shareIntegrations: shareIntegrations, dialogZIndex: dialogZIndex, dialogPlacement: dialogPlacement } = this.props;
            let button;
            const ShareButtonIcon = triggerButtonIcon || $2879aae105082725$export$55abe7932f6ca981;
            // Render a custom or standard button.
            if (renderCustomTriggerButton) {
                const { shareError: shareError } = this.state;
                button = renderCustomTriggerButton({
                    error: shareError,
                    isDisabled: isDisabled,
                    isSelected: isDialogOpen,
                    onClick: this.onTriggerClick
                }, triggerProps);
            } else button = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bked4.default), {
                appearance: triggerButtonAppearance,
                text: triggerButtonStyle !== 'icon-only' ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), (0, $idKBS.messages).shareTriggerButtonText) : null,
                "aria-label": formatMessage((0, $idKBS.messages).shareTriggerButtonText),
                onClick: this.onTriggerClick,
                iconBefore: triggerButtonStyle !== 'text-only' ? /*#__PURE__*/ (0, $f8Sb3.jsx)(ShareButtonIcon, {
                    label: ""
                }) : undefined,
                isSelected: isDialogOpen,
                isDisabled: isDisabled,
                ref: triggerProps.ref,
                // When we autoFocus the dialog, we want to autofocus the trigger as well, that way when the dialog is closed, the trigger is focused
                autoFocus: this.props.isAutoOpenDialog
            });
            // If the button only shows the icon, wrap it in a tooltip containing the button text.
            if (triggerButtonStyle === 'icon-only') button = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3bDjY.default), {
                content: !isUsingSplitButton ? triggerButtonTooltipText || formatMessage((0, $idKBS.messages).shareTriggerButtonTooltipText) : null,
                position: triggerButtonTooltipPosition,
                hideTooltipOnClick: true
            }, button);
            // If there are any integrations, wrap the share button in a split button with integrations.
            if (integrationMode === 'split' && shareIntegrations?.length) button = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cnQaw.default), {
                shareButton: button,
                handleOpenSplitButton: this.handleOpenSplitButton,
                handleCloseSplitButton: this.handleCloseSplitButton,
                isUsingSplitButton: isUsingSplitButton,
                triggerButtonAppearance: triggerButtonAppearance,
                dialogZIndex: dialogZIndex,
                dialogPlacement: dialogPlacement,
                shareIntegrations: shareIntegrations,
                onIntegrationClick: this.handleIntegrationClick,
                createAndFireEvent: this.createAndFireEvent
            });
            return button;
        }, this.handleOpenSplitButton = ()=>{
            this.setState({
                isUsingSplitButton: true
            }, ()=>this.handleCloseDialog());
            this.createAndFireEvent((0, $b2oBK.shareSplitButtonEvent)());
        }, this.handleCloseSplitButton = ()=>{
            this.setState({
                isUsingSplitButton: false
            });
        }, this.handleOnUserSelectionChange = (value)=>{
            const { onUserSelectionChange: onUserSelectionChange } = this.props;
            this.setState({
                shareError: undefined
            });
            onUserSelectionChange?.(value);
        };
    }
}
const $2879aae105082725$export$bc20a02e9bc30e54 = (props)=>(0, $VSDnB.fg)('share-compiled-migration') ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1t1FK.ShareDialogWithTriggerInternal), props) : /*#__PURE__*/ (0, $f8Sb3.jsx)($2879aae105082725$export$e927f7ec13b9edc0, props);
const $2879aae105082725$export$c7f8df1e37e7f581 = (0, $cb25w.default)()((0, $8RXs9.default)($2879aae105082725$export$bc20a02e9bc30e54));

});
const $dcbcc8fabc474606$export$9540ac9c843b8743 = 'object-shared';
const $dcbcc8fabc474606$export$57af6ad1a12df839 = 'admin-notified';

parcelRegister("KNlKW", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b9c92562d0fe90f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");

var $eZJjh = parcelRequire("eZJjh");

var $dZbU3 = parcelRequire("dZbU3");

var $iXiUJ = parcelRequire("iXiUJ");
function $7b9c92562d0fe90f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7b9c92562d0fe90f$var$spinnerWrapperStyles = {
    name: "1frfa00",
    styles: "width:100%;height:100%;display:flex;justify-content:center;align-content:center"
};

const $7b9c92562d0fe90f$var$LazyShareFormLazy = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("lhRB1")));
const $7b9c92562d0fe90f$var$LoadingDialog = ({ shareFormTitle: shareFormTitle, showTitle: showTitle, setIsLoading: setIsLoading, integrationMode: integrationMode, isMenuItemSelected: isMenuItemSelected, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled })=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        setIsLoading(true);
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dZbU3.default), {
        shareFormTitle: shareFormTitle,
        integrationMode: integrationMode,
        isMenuItemSelected: isMenuItemSelected,
        // if `showTitle` is passed, we use it. Otherwise, we will show title for loading dialog.
        shouldShowTitle: typeof showTitle === 'boolean' ? showTitle : true,
        isExtendedShareDialogEnabled: isExtendedShareDialogEnabled
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $7b9c92562d0fe90f$var$spinnerWrapperStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $eZJjh.default), null)));
};
var $7b9c92562d0fe90f$export$2e2bcd8739ae039 = (props)=>(0, $VSDnB.fg)('share-compiled-migration') ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $iXiUJ.default), props) : /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Suspense), {
        fallback: /*#__PURE__*/ (0, $f8Sb3.jsx)($7b9c92562d0fe90f$var$LoadingDialog, {
            shareFormTitle: props.shareFormTitle,
            showTitle: props.showTitle,
            setIsLoading: props.setIsLoading,
            integrationMode: props.integrationMode,
            isMenuItemSelected: props.isMenuItemSelected,
            isExtendedShareDialogEnabled: props.isExtendedShareDialogEnabled
        })
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)($7b9c92562d0fe90f$var$LazyShareFormLazy, props));

});
parcelRegister("dZbU3", function(module, exports) {

$parcel$export(module.exports, "default", () => $018ce6039808fd6c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $VSDnB = parcelRequire("VSDnB");

var $idKBS = parcelRequire("idKBS");

var $6OqtU = parcelRequire("6OqtU");

var $10MNJ = parcelRequire("10MNJ");

var $i3XHT = parcelRequire("i3XHT");
const $018ce6039808fd6c$var$ShareFormWrapper = ({ shareFormTitle: shareFormTitle, shouldShowTitle: shouldShowTitle, children: children = null, header: header = null, footer: footer = null, integrationMode: integrationMode = 'off', isMenuItemSelected: isMenuItemSelected = false, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const ContentWrapper = (0, $VSDnB.fg)('share-compiled-migration') ? (0, $10MNJ.InlineDialogContentWrapper) : (0, $i3XHT.InlineDialogContentWrapper);
    const FormWrapper = (0, $VSDnB.fg)('share-compiled-migration') ? (0, $10MNJ.InlineDialogFormWrapper) : (0, $i3XHT.InlineDialogFormWrapper);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)(ContentWrapper, {
        label: formatMessage((0, $idKBS.messages).formTitle),
        children: [
            (0, $VSDnB.fg)('platform_share_custom_header_prop') && header,
            /*#__PURE__*/ (0, $2OMIu.jsxs)(FormWrapper, {
                integrationMode: integrationMode,
                isMenuItemSelected: isMenuItemSelected,
                isExtendedShareDialogEnabled: isExtendedShareDialogEnabled,
                children: [
                    shouldShowTitle && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6OqtU.ShareHeader), {
                        title: shareFormTitle
                    }),
                    children
                ]
            }),
            footer
        ]
    });
};
var $018ce6039808fd6c$export$2e2bcd8739ae039 = $018ce6039808fd6c$var$ShareFormWrapper;

});
parcelRegister("6OqtU", function(module, exports) {

$parcel$export(module.exports, "ShareHeader", () => $b6372b3118718628$export$77192fbb468e5af8);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $l1N8i = parcelRequire("l1N8i");

var $VSDnB = parcelRequire("VSDnB");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $idKBS = parcelRequire("idKBS");
const $b6372b3118718628$var$headerWrapperStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    justifyContent: 'space-between',
    marginRight: 'space.400',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 'space.400'
});
const $b6372b3118718628$export$77192fbb468e5af8 = ({ title: title })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        xcss: $b6372b3118718628$var$headerWrapperStyles,
        children: (0, $VSDnB.fg)('share-header-accessibility') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
            size: "small",
            as: "h2",
            children: title || /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $idKBS.messages).formTitle
            })
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
            size: "small",
            children: title || /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $idKBS.messages).formTitle
            })
        })
    });
};

});

parcelRegister("10MNJ", function(module, exports) {

$parcel$export(module.exports, "InlineDialogFormWrapper", () => $923a8f62c8def5db$export$54db87debcabf37b);
$parcel$export(module.exports, "InlineDialogContentWrapper", () => $923a8f62c8def5db$export$a05835e82fd98f96);
/* compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
const $923a8f62c8def5db$var$styles = {
    menuNotSelectedAndMenuIntegration: "_1bsbpk3t",
    tabsIntegration: "_1bsb1wug",
    default: "_1bsb1j89",
    extendedDefault: "_1bsb1op3",
    inlineDialogContentWrapper: "_ca0qpxbi _u5f31ejb _n3tdpxbi _19bv1ejb"
};
const $923a8f62c8def5db$export$54db87debcabf37b = ({ children: children, integrationMode: integrationMode, isMenuItemSelected: isMenuItemSelected, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled })=>{
    if (!isMenuItemSelected && integrationMode === 'menu') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($923a8f62c8def5db$var$styles.menuNotSelectedAndMenuIntegration),
        children: children
    });
    if ((0, $VSDnB.fg)('smart_links_for_plans_platform')) {
        if (integrationMode === 'tabs') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
            xcss: (0, $3JT92.cx)($923a8f62c8def5db$var$styles.tabsIntegration),
            children: children
        });
    }
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)(isExtendedShareDialogEnabled ? $923a8f62c8def5db$var$styles.extendedDefault : $923a8f62c8def5db$var$styles.default),
        children: children
    });
};
const $923a8f62c8def5db$export$a05835e82fd98f96 = ({ children: children, label: label })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        "aria-label": label,
        xcss: $923a8f62c8def5db$var$styles.inlineDialogContentWrapper,
        children: children
    });

});

parcelRegister("i3XHT", function(module, exports) {

$parcel$export(module.exports, "InlineDialogFormWrapper", () => $cd74a614dabf2b1c$export$54db87debcabf37b);
$parcel$export(module.exports, "InlineDialogContentWrapper", () => $cd74a614dabf2b1c$export$a05835e82fd98f96);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");

var $MaS1v = parcelRequire("MaS1v");
/**
 * Set fixed width considering full form width and full menu width in order
 * to prevent dialog form from bouncing when isLoading prop is set to true.
 * Since loading container has 100% width, it adjusts accordingly.
 */ const $cd74a614dabf2b1c$var$calculateFormWrapperWidth = ({ integrationMode: integrationMode, isMenuItemSelected: isMenuItemSelected, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled })=>{
    const formWidth = `${isExtendedShareDialogEnabled ? 452 : 352}px`;
    if (!isMenuItemSelected && integrationMode === 'menu') return 0, $MaS1v.menuWrapperWidth;
    if ((0, $VSDnB.fg)('smart_links_for_plans_platform')) {
        if (integrationMode === 'tabs') return 'auto';
    }
    return formWidth;
};
const $cd74a614dabf2b1c$export$54db87debcabf37b = ({ children: children, integrationMode: integrationMode, isMenuItemSelected: isMenuItemSelected, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled })=>{
    const styles = {
        width: $cd74a614dabf2b1c$var$calculateFormWrapperWidth({
            integrationMode: integrationMode,
            isMenuItemSelected: isMenuItemSelected,
            isExtendedShareDialogEnabled: isExtendedShareDialogEnabled
        })
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: styles
    }, children);
};
const $cd74a614dabf2b1c$var$inlineDialogContentWrapperStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-300, 24px)"}`
});
const $cd74a614dabf2b1c$export$a05835e82fd98f96 = ({ children: children, label: label })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $cd74a614dabf2b1c$var$inlineDialogContentWrapperStyles,
        "aria-label": label
    }, children);
};

});
parcelRegister("MaS1v", function(module, exports) {

$parcel$export(module.exports, "ShareMenuItem", () => $604fc1c02fbeee92$export$144cc6e5e0841ff9);
$parcel$export(module.exports, "menuWrapperWidth", () => $604fc1c02fbeee92$export$1cd8104f92c0e299);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $kJpBP = parcelRequire("kJpBP");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $604fc1c02fbeee92$var$iconContainerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 'size.200',
    width: 'size.200',
    borderRadius: 'border.radius'
});
const $604fc1c02fbeee92$export$144cc6e5e0841ff9 = ({ iconName: iconName, labelId: labelId, onClickHandler: onClickHandler })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $kJpBP.default), {
        iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)($604fc1c02fbeee92$export$8f314e512d92575f, {
            icon: iconName
        }),
        onClick: onClickHandler,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...labelId
        })
    });
const $604fc1c02fbeee92$export$8f314e512d92575f = ({ icon: icon })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        xcss: $604fc1c02fbeee92$var$iconContainerStyles,
        children: icon
    });
const $604fc1c02fbeee92$export$1cd8104f92c0e299 = '102px';

});



parcelRegister("iXiUJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $61d94c1e278a7cbd$export$2e2bcd8739ae039);
/* lazyNext.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $MHKc7 = parcelRequire("MHKc7");

var $eZJjh = parcelRequire("eZJjh");

var $dZbU3 = parcelRequire("dZbU3");
const $61d94c1e278a7cbd$var$styles = {
    spinnerWrapperStyles: "_1bsb1osq _4t3i1osq _1e0c1txw _1bah1h6o _ae4v1h6o"
};

const $61d94c1e278a7cbd$var$LazyShareFormLazy = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("2pN3k")));
const $61d94c1e278a7cbd$var$LoadingDialog = ({ shareFormTitle: shareFormTitle, showTitle: showTitle, setIsLoading: setIsLoading, integrationMode: integrationMode, isMenuItemSelected: isMenuItemSelected, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled })=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        setIsLoading(true);
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dZbU3.default), {
        shareFormTitle: shareFormTitle,
        integrationMode: integrationMode,
        isMenuItemSelected: isMenuItemSelected,
        // if `showTitle` is passed, we use it. Otherwise, we will show title for loading dialog.
        shouldShowTitle: typeof showTitle === 'boolean' ? showTitle : true,
        isExtendedShareDialogEnabled: isExtendedShareDialogEnabled,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
            xcss: (0, $3JT92.cx)($61d94c1e278a7cbd$var$styles.spinnerWrapperStyles),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {})
        })
    });
};
var $61d94c1e278a7cbd$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
        fallback: /*#__PURE__*/ (0, $2OMIu.jsx)($61d94c1e278a7cbd$var$LoadingDialog, {
            shareFormTitle: props.shareFormTitle,
            showTitle: props.showTitle,
            setIsLoading: props.setIsLoading,
            integrationMode: props.integrationMode,
            isMenuItemSelected: props.isMenuItemSelected,
            isExtendedShareDialogEnabled: props.isExtendedShareDialogEnabled
        }),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($61d94c1e278a7cbd$var$LazyShareFormLazy, {
            ...props
        })
    });

});
parcelRegister("2pN3k", function(module, exports) {

let $1c23f763c8bd0f91$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $1c23f763c8bd0f91$var$load("ffQaD"),
    $1c23f763c8bd0f91$var$load("kvRbA"),
    $1c23f763c8bd0f91$var$load("c2PGS")
]).then(()=>parcelRequire('6GxX7'));

});


parcelRegister("lhRB1", function(module, exports) {

let $f7f4c298928f54d1$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $f7f4c298928f54d1$var$load("ffQaD"),
    $f7f4c298928f54d1$var$load("kvRbA"),
    $f7f4c298928f54d1$var$load("3AP4i")
]).then(()=>parcelRequire('1haaP'));

});


parcelRegister("bked4", function(module, exports) {

$parcel$export(module.exports, "default", () => $c623df2911700361$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");
const $c623df2911700361$export$e980dfbc2840e8bc = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(// Discard aria-haspopup
function ShareButton({ text: text, 'aria-haspopup': _ariaHasPopup, ...props }, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
        id: "share-trigger-btn",
        ref: ref,
        "aria-haspopup": "dialog",
        ...props,
        children: text
    });
});
$c623df2911700361$export$e980dfbc2840e8bc.displayName = 'ShareButton';
var $c623df2911700361$export$2e2bcd8739ae039 = $c623df2911700361$export$e980dfbc2840e8bc;

});

parcelRegister("1t1FK", function(module, exports) {

$parcel$export(module.exports, "ShareDialogWithTriggerInternal", () => $38a31715b9b420dd$export$bc20a02e9bc30e54);
/* ShareDialogWithTriggerNext.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $8RXs9 = parcelRequire("8RXs9");

var $cb25w = parcelRequire("cb25w");

var $3JT92 = parcelRequire("3JT92");

var $kOEld = parcelRequire("kOEld");

var $VSDnB = parcelRequire("VSDnB");

var $1I7E8 = parcelRequire("1I7E8");

var $k8nZq = parcelRequire("k8nZq");

var $MHKc7 = parcelRequire("MHKc7");

var $k5uoT = parcelRequire("k5uoT");

var $3bDjY = parcelRequire("3bDjY");

var $idKBS = parcelRequire("idKBS");


var $b2oBK = parcelRequire("b2oBK");

var $hQWyD = parcelRequire("hQWyD");

var $65uFp = parcelRequire("65uFp");

var $KNlKW = parcelRequire("KNlKW");

var $bked4 = parcelRequire("bked4");

var $cnQaw = parcelRequire("cnQaw");

var $4gTjW = parcelRequire("4gTjW");
const $38a31715b9b420dd$var$styles = {
    shareButtonWrapperStyles: "_12ji1r31 _1qu2glyw _12y31o36 _1e0c116y",
    outlineNone: "_12ji1r31 _1qu2glyw _12y31o36"
};
const $38a31715b9b420dd$export$4d9147e1bc6c176 = {
    users: [],
    comment: {
        format: 'plain_text',
        value: ''
    }
};
const $38a31715b9b420dd$export$55abe7932f6ca981 = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kOEld))), {
        spacing: "spacious",
        label: "",
        color: "currentColor"
    });
class $38a31715b9b420dd$export$bc20a02e9bc30e54 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    static{
        this.defaultProps = {
            isDisabled: false,
            dialogPlacement: 'bottom-end',
            shouldCloseOnEscapePress: true,
            triggerButtonAppearance: 'subtle',
            triggerButtonStyle: 'icon-only',
            triggerButtonTooltipPosition: 'top',
            dialogZIndex: (0, $k5uoT.layers).modal()
        };
    }
    componentDidMount() {
        if (this.props.isAutoOpenDialog) this.handleDialogOpen();
    }
    componentDidUpdate(prevProps) {
        if (this.props.isAutoOpenDialog !== prevProps.isAutoOpenDialog && this.props.isAutoOpenDialog) this.handleDialogOpen();
    }
    componentWillUnmount() {
        if (this.props.isAutoOpenDialog && this.props.onDialogClose) this.props.onDialogClose();
    }
    async generateShareError(err) {
        const errorBody = err.body ? await err.body : {};
        // We'll only try and deal with the first error, sorry
        const firstErrorFromBody = errorBody.messagesDetails?.[0];
        return {
            message: firstErrorFromBody?.message || err.message,
            errorCode: firstErrorFromBody?.errorCode,
            helpUrl: firstErrorFromBody?.helpUrl,
            retryable: firstErrorFromBody?.errorCode === undefined
        };
    }
    render() {
        const { isDialogOpen: isDialogOpen, isSharing: isSharing, shareError: shareError, defaultValue: defaultValue, showIntegrationForm: showIntegrationForm, selectedIntegration: selectedIntegration, isMenuItemSelected: isMenuItemSelected } = this.state;
        const { copyLink: copyLink, dialogPlacement: dialogPlacement, config: config, isFetchingConfig: isFetchingConfig, loadUserOptions: loadUserOptions, shareFormTitle: shareFormTitle, shareFormHelperMessage: shareFormHelperMessage, bottomMessage: bottomMessage, submitButtonLabel: submitButtonLabel, product: product, productAttributes: productAttributes, customHeader: customHeader, customFooter: customFooter, enableSmartUserPicker: enableSmartUserPicker, loggedInAccountId: loggedInAccountId, cloudId: cloudId, orgId: orgId, shareFieldsFooter: shareFieldsFooter, dialogZIndex: dialogZIndex, isPublicLink: isPublicLink, tabIndex: tabIndex, copyTooltipText: copyTooltipText, integrationMode: integrationMode, shareIntegrations: shareIntegrations, additionalTabs: additionalTabs, builtInTabContentWidth: builtInTabContentWidth, isBrowseUsersDisabled: isBrowseUsersDisabled, userPickerOptions: userPickerOptions, isSubmitShareDisabled: isSubmitShareDisabled, additionalUserFields: additionalUserFields, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled, CustomSubmitButton: CustomSubmitButton } = this.props;
        const footer = (0, $4gTjW.resolveShareFooter)(integrationMode, this.state.tabIndex, customFooter);
        // for performance purposes, we may want to have a loadable content i.e. ShareForm
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $MHKc7.default), {
            xcss: (0, $3JT92.cx)($38a31715b9b420dd$var$styles.shareButtonWrapperStyles, typeof tabIndex !== 'undefined' && tabIndex >= 0 && $38a31715b9b420dd$var$styles.outlineNone),
            tabIndex: tabIndex,
            onKeyDown: this.handleKeyDown,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1I7E8.default), {
                    content: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                            ref: this.containerRef,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $KNlKW.default), {
                                Content: selectedIntegration && selectedIntegration.Content,
                                selectedIntegration: selectedIntegration,
                                copyLink: copyLink,
                                showIntegrationForm: showIntegrationForm,
                                bottomMessage: bottomMessage,
                                customHeader: (0, $VSDnB.fg)('platform_share_custom_header_prop') && customHeader,
                                customFooter: footer,
                                loadOptions: loadUserOptions,
                                isSharing: isSharing,
                                shareFormTitle: shareFormTitle,
                                showTitle: integrationMode !== 'tabs' || !shareIntegrations || !shareIntegrations.length,
                                shareFormHelperMessage: shareFormHelperMessage,
                                shareError: shareError,
                                defaultValue: defaultValue,
                                config: config,
                                isFetchingConfig: isFetchingConfig,
                                setIsLoading: this.setIsLoading,
                                submitButtonLabel: submitButtonLabel,
                                product: product,
                                productAttributes: productAttributes,
                                enableSmartUserPicker: enableSmartUserPicker,
                                loggedInAccountId: loggedInAccountId,
                                cloudId: cloudId,
                                orgId: orgId,
                                onUserSelectionChange: this.handleOnUserSelectionChange,
                                shareFieldsFooter: shareFieldsFooter,
                                isPublicLink: isPublicLink,
                                copyTooltipText: copyTooltipText,
                                integrationMode: integrationMode,
                                shareIntegrations: shareIntegrations,
                                additionalTabs: additionalTabs,
                                builtInTabContentWidth: builtInTabContentWidth,
                                isMenuItemSelected: isMenuItemSelected,
                                isSubmitShareDisabled: isSubmitShareDisabled,
                                // actions
                                onLinkCopy: this.handleCopyLink,
                                onSubmit: this.handleShareSubmit,
                                onDismiss: this.handleFormDismiss,
                                onDialogClose: this.handleCloseDialog,
                                onTabChange: this.onTabChange,
                                onMenuItemChange: this.onMenuItemChange,
                                //ref
                                selectPortalRef: this.selectPortalRef,
                                isBrowseUsersDisabled: isBrowseUsersDisabled,
                                userPickerOptions: userPickerOptions,
                                additionalUserFields: additionalUserFields,
                                isExtendedShareDialogEnabled: isExtendedShareDialogEnabled,
                                CustomSubmitButton: CustomSubmitButton
                            })
                        }),
                    isOpen: isDialogOpen,
                    onClose: this.handleCloseDialog,
                    placement: dialogPlacement,
                    trigger: this.renderShareTriggerButton,
                    zIndex: dialogZIndex,
                    label: this.props.intl.formatMessage((0, $idKBS.messages).sharePopupLabel),
                    role: "dialog",
                    // TODO: remove after https://hello.atlassian.net/wiki/x/SoEGzQ experiment is finished
                    offset: this.calculatePopupOffset({
                        isMenuItemSelected: isMenuItemSelected,
                        dialogPlacement: dialogPlacement
                    }),
                    shouldRenderToParent: (0, $VSDnB.fg)('enable-appropriate-reading-order-in-share-dialog')
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k8nZq.default), {
                    zIndex: (0, $4gTjW.generateSelectZIndex)(dialogZIndex),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        ref: this.selectPortalRef
                    })
                })
            ]
        });
    }
    constructor(...args){
        super(...args), this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), /**
   * Because the PopUp component has a higher zIndex it causes
   * the select to be rendered within it, and add scrollbars.
   * We will render the select options the PopUp outside,
   */ this.selectPortalRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.start = 0, this.state = {
            isDialogOpen: false,
            isSharing: false,
            ignoreIntermediateState: false,
            defaultValue: $38a31715b9b420dd$export$4d9147e1bc6c176,
            isUsingSplitButton: false,
            showIntegrationForm: false,
            selectedIntegration: null,
            tabIndex: 0,
            isMenuItemSelected: false,
            isLoading: false
        }, this.closeAndResetDialog = ()=>{
            this.setState({
                defaultValue: $38a31715b9b420dd$export$4d9147e1bc6c176,
                ignoreIntermediateState: true,
                shareError: undefined,
                isDialogOpen: false,
                showIntegrationForm: false,
                selectedIntegration: null,
                isMenuItemSelected: false
            });
            const { onUserSelectionChange: onUserSelectionChange, onDialogClose: onDialogClose } = this.props;
            if (onUserSelectionChange) onUserSelectionChange($38a31715b9b420dd$export$4d9147e1bc6c176.users);
            if (onDialogClose) onDialogClose();
        }, this.createAndFireEvent = (payload)=>{
            const { createAnalyticsEvent: createAnalyticsEvent, analyticsDecorator: analyticsDecorator } = this.props;
            if (analyticsDecorator) payload = analyticsDecorator(payload);
            if (createAnalyticsEvent) createAnalyticsEvent(payload).fire((0, $b2oBK.CHANNEL_ID));
        }, this.onTabChange = (index)=>{
            let subjectId = 'shareTab';
            const { shareContentType: shareContentType } = this.props;
            if (index === 1) subjectId = 'shareToSlackTab';
            this.createAndFireEvent((0, $b2oBK.shareTabClicked)(subjectId, shareContentType));
            this.setState({
                tabIndex: index
            });
        }, this.onMenuItemChange = (menuType)=>{
            let subjectId = menuType === 'Slack' ? 'shareToSlackMenuItem' : 'shareMenuItem';
            const { shareContentType: shareContentType } = this.props;
            this.createAndFireEvent((0, $b2oBK.shareMenuItemClicked)(subjectId, shareContentType));
            this.setState({
                isMenuItemSelected: true
            });
        }, this.getFlags = ()=>{
            const { intl: { formatMessage: formatMessage } } = this.props;
            // The reason for providing message property is that in jira,
            // the Flag system takes only Message Descriptor as payload
            // and formatMessage is called for every flag
            // if the translation data is not provided, a translated default message
            // will be displayed
            return [
                {
                    appearance: 'success',
                    title: {
                        ...(0, $idKBS.messages).shareSuccessMessage,
                        defaultMessage: formatMessage((0, $idKBS.messages).shareSuccessMessage, {
                            object: this.props.shareContentType.toLowerCase()
                        })
                    },
                    type: (0, $dcbcc8fabc474606$export$9540ac9c843b8743)
                }
            ];
        }, this.setIsLoading = (isLoading)=>{
            this.setState({
                isLoading: isLoading
            });
        }, this.focus = ()=>{
            if (this.containerRef.current) this.containerRef.current.focus();
        }, this.handleKeyDown = (event)=>{
            const { isLoading: isLoading, isDialogOpen: isDialogOpen } = this.state;
            const { shouldCloseOnEscapePress: shouldCloseOnEscapePress } = this.props;
            if (isLoading) {
                event.stopPropagation();
                this.focus();
            }
            if (isDialogOpen) switch(event.key){
                case 'Esc':
                case 'Escape':
                    // The @atlaskit/popup will capture the event and auto-close, we
                    // need to prevent that if the dialog is set to not close on `ESC`
                    if (!shouldCloseOnEscapePress) {
                        event.preventDefault();
                        event.stopPropagation();
                        // put the focus back onto the share dialog so that
                        // the user can press the escape key again to close the dialog
                        this.focus();
                        return;
                    }
                    // The dialog will auto-close in @atlaskit/popup, we just need to fire
                    // the right events.
                    if (shouldCloseOnEscapePress) {
                        // This experience should be aborted in a scenario when a user closes the dialog before the shareClient.getConfig() call is finished
                        // It is a race condition between the `SUCCEEDED` case and the `ABORTED` case of this experience
                        // UFO experiences can only have one FINAL state so it doesn't matter if we call .abort() after the experience has succeeded and vice versa
                        (0, $65uFp.renderShareDialogExp).abort();
                        this.createAndFireEvent((0, $b2oBK.cancelShare)(this.start));
                        this.closeAndResetDialog();
                    }
            }
        }, this.handleDialogOpen = ()=>{
            this.setState((state)=>({
                    isDialogOpen: !state.isDialogOpen,
                    ignoreIntermediateState: false,
                    showIntegrationForm: false,
                    selectedIntegration: null
                }), ()=>{
                const { onDialogOpen: onDialogOpen, isPublicLink: isPublicLink } = this.props;
                const { isDialogOpen: isDialogOpen } = this.state;
                if (isDialogOpen) {
                    this.start = Date.now();
                    this.createAndFireEvent((0, $b2oBK.screenEvent)({
                        isPublicLink: isPublicLink
                    }));
                    if (onDialogOpen) onDialogOpen();
                    this.focus();
                } else this.handleCloseDialog();
            });
        }, this.onTriggerClick = ()=>{
            const { onTriggerButtonClick: onTriggerButtonClick } = this.props;
            this.createAndFireEvent((0, $b2oBK.shareTriggerButtonClicked)());
            this.handleDialogOpen();
            if (onTriggerButtonClick) onTriggerButtonClick();
        }, this.handleCloseDialog = ()=>{
            if (this.props.onDialogClose) this.props.onDialogClose();
            // This experience should be aborted in a scenario when a user closes the dialog before the shareClient.getConfig() call is finished
            // It is a race condition between the `SUCCEEDED` case and the `ABORTED` case of this experience
            // UFO experiences can only have one FINAL state so it doesn't matter if we call .abort() after the experience has succeeded and vice versa
            (0, $65uFp.renderShareDialogExp).abort();
            this.setState({
                isDialogOpen: false,
                showIntegrationForm: false,
                selectedIntegration: null,
                tabIndex: 0,
                isMenuItemSelected: false
            });
        }, this.handleShareSubmit = (data)=>{
            const { onShareSubmit: onShareSubmit, shareContentType: shareContentType, shareContentSubType: shareContentSubType, shareContentId: shareContentId, formShareOrigin: formShareOrigin, showFlags: showFlags, isPublicLink: isPublicLink } = this.props;
            if (!onShareSubmit) return;
            (0, $65uFp.shareSubmitExp).start();
            this.setState({
                isSharing: true
            });
            this.createAndFireEvent((0, $b2oBK.formShareSubmitted)({
                start: this.start,
                data: data,
                shareContentType: shareContentType,
                shareOrigin: formShareOrigin,
                isPublicLink: isPublicLink,
                shareContentSubType: shareContentSubType,
                shareContentId: shareContentId
            }));
            onShareSubmit(data).then(()=>{
                this.closeAndResetDialog();
                this.setState({
                    isSharing: false
                });
                showFlags(this.getFlags());
                (0, $65uFp.shareSubmitExp).success();
            }).catch(async (err)=>{
                const shareError = await this.generateShareError(err).catch((errorGenFailed)=>({
                        message: err.message || errorGenFailed.message || 'Unknown error',
                        retryable: true
                    }));
                this.setState({
                    isSharing: false,
                    shareError: shareError
                });
                (0, $hQWyD.isValidFailedExperience)((0, $65uFp.shareSubmitExp), err);
            });
        }, this.handleFormDismiss = (data)=>{
            this.setState(({ ignoreIntermediateState: ignoreIntermediateState })=>ignoreIntermediateState ? null : {
                    defaultValue: data
                });
        }, this.calculatePopupOffset = ({ isMenuItemSelected: isMenuItemSelected, dialogPlacement: dialogPlacement })=>{
            if (isMenuItemSelected && dialogPlacement === 'bottom-end') return [
                -0.1,
                8
            ];
            return [
                0,
                8
            ];
        }, this.handleCopyLink = ()=>{
            const { copyLinkOrigin: copyLinkOrigin, shareContentType: shareContentType, shareContentSubType: shareContentSubType, shareContentId: shareContentId, isPublicLink: isPublicLink, shareAri: shareAri } = this.props;
            this.createAndFireEvent((0, $b2oBK.copyLinkButtonClicked)({
                start: this.start,
                shareContentType: shareContentType,
                shareOrigin: copyLinkOrigin,
                isPublicLink: isPublicLink,
                ari: shareAri,
                shareContentSubType: shareContentSubType,
                shareContentId: shareContentId
            }));
        }, this.handleIntegrationClick = (integration)=>{
            this.setState({
                isUsingSplitButton: false,
                isDialogOpen: true,
                showIntegrationForm: true,
                selectedIntegration: integration
            });
        }, this.renderShareTriggerButton = (triggerProps)=>{
            const { isDialogOpen: isDialogOpen, isUsingSplitButton: isUsingSplitButton } = this.state;
            const { intl: { formatMessage: formatMessage }, isDisabled: isDisabled, renderCustomTriggerButton: renderCustomTriggerButton, triggerButtonIcon: triggerButtonIcon, triggerButtonTooltipText: triggerButtonTooltipText, triggerButtonTooltipPosition: triggerButtonTooltipPosition, triggerButtonAppearance: triggerButtonAppearance, triggerButtonStyle: triggerButtonStyle, integrationMode: integrationMode, shareIntegrations: shareIntegrations, dialogZIndex: dialogZIndex, dialogPlacement: dialogPlacement } = this.props;
            let button;
            const ShareButtonIcon = triggerButtonIcon || $38a31715b9b420dd$export$55abe7932f6ca981;
            // Render a custom or standard button.
            if (renderCustomTriggerButton) {
                const { shareError: shareError } = this.state;
                button = renderCustomTriggerButton({
                    error: shareError,
                    isDisabled: isDisabled,
                    isSelected: isDialogOpen,
                    onClick: this.onTriggerClick
                }, triggerProps);
            } else button = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bked4.default), {
                appearance: triggerButtonAppearance,
                text: triggerButtonStyle !== 'icon-only' ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $idKBS.messages).shareTriggerButtonText
                }) : null,
                "aria-label": formatMessage((0, $idKBS.messages).shareTriggerButtonText),
                onClick: this.onTriggerClick,
                iconBefore: triggerButtonStyle !== 'text-only' ? /*#__PURE__*/ (0, $2OMIu.jsx)(ShareButtonIcon, {
                    label: ""
                }) : undefined,
                isSelected: isDialogOpen,
                isDisabled: isDisabled,
                ref: triggerProps.ref,
                // When we autoFocus the dialog, we want to autofocus the trigger as well, that way when the dialog is closed, the trigger is focused
                autoFocus: this.props.isAutoOpenDialog
            });
            // If the button only shows the icon, wrap it in a tooltip containing the button text.
            if (triggerButtonStyle === 'icon-only') button = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
                content: !isUsingSplitButton ? triggerButtonTooltipText || formatMessage((0, $idKBS.messages).shareTriggerButtonTooltipText) : null,
                position: triggerButtonTooltipPosition,
                hideTooltipOnClick: true,
                children: button
            });
            // If there are any integrations, wrap the share button in a split button with integrations.
            if (integrationMode === 'split' && shareIntegrations?.length) button = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cnQaw.default), {
                shareButton: button,
                handleOpenSplitButton: this.handleOpenSplitButton,
                handleCloseSplitButton: this.handleCloseSplitButton,
                isUsingSplitButton: isUsingSplitButton,
                triggerButtonAppearance: triggerButtonAppearance,
                dialogZIndex: dialogZIndex,
                dialogPlacement: dialogPlacement,
                shareIntegrations: shareIntegrations,
                onIntegrationClick: this.handleIntegrationClick,
                createAndFireEvent: this.createAndFireEvent
            });
            return button;
        }, this.handleOpenSplitButton = ()=>{
            this.setState({
                isUsingSplitButton: true
            }, ()=>this.handleCloseDialog());
            this.createAndFireEvent((0, $b2oBK.shareSplitButtonEvent)());
        }, this.handleCloseSplitButton = ()=>{
            this.setState({
                isUsingSplitButton: false
            });
        }, this.handleOnUserSelectionChange = (value)=>{
            const { onUserSelectionChange: onUserSelectionChange } = this.props;
            this.setState({
                shareError: undefined
            });
            onUserSelectionChange?.(value);
        };
    }
}
const $38a31715b9b420dd$export$c7f8df1e37e7f581 = (0, $cb25w.default)()((0, $8RXs9.default)($38a31715b9b420dd$export$bc20a02e9bc30e54));

});
parcelRegister("cnQaw", function(module, exports) {

$parcel$export(module.exports, "default", () => $595b694e7cdc0462$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $ousew = parcelRequire("ousew");

var $42CjB = parcelRequire("42CjB");
var $7E6BG = parcelRequire("7E6BG");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $c8Oei = parcelRequire("c8Oei");

var $VSDnB = parcelRequire("VSDnB");


var $idKBS = parcelRequire("idKBS");

var $b2oBK = parcelRequire("b2oBK");

var $4kfPc = parcelRequire("4kfPc");
// span
const $595b694e7cdc0462$var$dropDownIntegrationButtonWrapperStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    ['button:hover']: {
        background: 'transparent'
    }
});
const $595b694e7cdc0462$var$integrationButtonText = (integrationName)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), {
        ...(0, $idKBS.messages).shareToIntegrationButtonText,
        values: {
            integrationName: integrationName
        }
    });
const $595b694e7cdc0462$var$IntegrationButtonWrapper = ({ children: children })=>// The css has no discernible effect on the button, so it is not included in the migration
    (0, $VSDnB.fg)('share-compiled-migration') ? /*#__PURE__*/ (0, $f8Sb3.jsx)("span", null, children) : /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $595b694e7cdc0462$var$dropDownIntegrationButtonWrapperStyles
    }, children);
const $595b694e7cdc0462$var$SplitButtonDropdown = (props)=>{
    const { triggerButtonAppearance: triggerButtonAppearance, isUsingSplitButton: isUsingSplitButton, handleOpenSplitButton: handleOpenSplitButton, handleCloseSplitButton: handleCloseSplitButton, shareIntegrations: shareIntegrations, onIntegrationClick: onIntegrationClick, createAndFireEvent: createAndFireEvent } = props;
    const onOpenChange = (0, $5uXOq.useCallback)(({ isOpen: isOpen })=>{
        if (isOpen) handleOpenSplitButton();
        else handleCloseSplitButton();
    }, [
        handleOpenSplitButton,
        handleCloseSplitButton
    ]);
    const onIntegrationButtonClick = (0, $5uXOq.useCallback)((integration)=>{
        onIntegrationClick(integration);
        createAndFireEvent((0, $b2oBK.shareIntegrationButtonEvent)(integration.type));
    }, [
        createAndFireEvent,
        onIntegrationClick
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $BLPHT.default), {
        testId: "split-button-dropdown",
        trigger: ({ triggerRef: triggerRef, ...providedProps })=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $42CjB.default), {
                label: "",
                ...providedProps,
                ref: triggerRef,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))),
                appearance: triggerButtonAppearance
            }),
        placement: "bottom-end",
        isOpen: isUsingSplitButton,
        onOpenChange: onOpenChange
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $aRoVz.default), null, shareIntegrations.map((integration)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $6B7KL.default), {
            key: integration.type,
            testId: `split-button-dropdownitem-${integration.type}`
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)($595b694e7cdc0462$var$IntegrationButtonWrapper, null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4kfPc.default), {
            textColor: `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`,
            appearance: "subtle",
            onClick: ()=>onIntegrationButtonClick(integration),
            shouldFitContainer: true,
            text: $595b694e7cdc0462$var$integrationButtonText(integration.type),
            IntegrationIcon: integration.Icon
        }))))));
};
$595b694e7cdc0462$var$SplitButtonDropdown.displayName = 'SplitButtonDropdown';
function $595b694e7cdc0462$export$2e2bcd8739ae039({ shareButton: shareButton, handleOpenSplitButton: handleOpenSplitButton, handleCloseSplitButton: handleCloseSplitButton, isUsingSplitButton: isUsingSplitButton, shareIntegrations: shareIntegrations, onIntegrationClick: onIntegrationClick, triggerButtonAppearance: triggerButtonAppearance, createAndFireEvent: createAndFireEvent }) {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $7E6BG.SplitButton), {
        "data-testid": "split-button",
        appearance: triggerButtonAppearance
    }, shareButton, /*#__PURE__*/ (0, $f8Sb3.jsx)($595b694e7cdc0462$var$SplitButtonDropdown, {
        shareIntegrations: shareIntegrations,
        triggerButtonAppearance: triggerButtonAppearance,
        isUsingSplitButton: isUsingSplitButton,
        handleOpenSplitButton: handleOpenSplitButton,
        handleCloseSplitButton: handleCloseSplitButton,
        onIntegrationClick: onIntegrationClick,
        createAndFireEvent: createAndFireEvent
    }));
}

});
parcelRegister("7E6BG", function(module, exports) {

$parcel$export(module.exports, "SplitButton", () => $2f706a5180e21ed2$export$651ad66661acd392);
/* split-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $icwyz = parcelRequire("icwyz");

var $jvAlz = parcelRequire("jvAlz");
const $2f706a5180e21ed2$var$dividerStyles = {
    baseDivider: "_1bsbe4h9 _kqswh2mm _1pbykb7n",
    dividerDisabled: "_bfhkojnm _80om13gf _tzy41uwv",
    dividerDisabledRefreshed: "_bfhk9xzm _80om13gf",
    dividerOffsetRefreshed: "_195g1n1a"
};
const $2f706a5180e21ed2$var$dividerAppearanceStyles = {
    default: "_bfhk1fxt _tzy41uwv",
    primary: "_bfhk15cr _tzy41wzo",
    navigation: "_1mouu2gc _195g1h5n _4t3i7vkz _bfhkdud1 _tzy419lr"
};
const $2f706a5180e21ed2$var$dividerRefreshedAppearanceStyles = {
    default: "_bfhkmuej",
    primary: "_bfhkveue _tzy41wzo",
    navigation: "_1mouu2gc _195g1h5n _4t3i7vkz _bfhkdud1 _tzy419lr"
};
const $2f706a5180e21ed2$var$dividerHeightStyles = {
    default: "_4t3iviql",
    compact: "_4t3i1k8s"
};
// The divider height is calculated by subtracting twice the border width from the button height.
// This ensures the divider does not intersect with the button's border, avoiding visual issues
// caused by overlapping alpha colors (color.border) at the intersection.
const $2f706a5180e21ed2$var$defaultDividerHeightStyles = {
    default: "_4t3im1ee",
    compact: "_4t3i1hvu"
};
const $2f706a5180e21ed2$export$2e0a83ec2e27ecbb = ({ appearance: appearance, spacing: spacing, isDisabled: isDisabled = false })=>{
    const isDefaultDivider = appearance === 'default' && !isDisabled && (0, $VSDnB.fg)('platform-component-visual-refresh');
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            $2f706a5180e21ed2$var$dividerStyles.baseDivider,
            isDefaultDivider && $2f706a5180e21ed2$var$defaultDividerHeightStyles[spacing],
            !isDefaultDivider && $2f706a5180e21ed2$var$dividerHeightStyles[spacing],
            isDisabled && (0, $VSDnB.fg)('platform-component-visual-refresh') && $2f706a5180e21ed2$var$dividerStyles.dividerDisabledRefreshed,
            isDisabled && !(0, $VSDnB.fg)('platform-component-visual-refresh') && $2f706a5180e21ed2$var$dividerStyles.dividerDisabled,
            !isDisabled && (0, $VSDnB.fg)('platform-component-visual-refresh') && $2f706a5180e21ed2$var$dividerRefreshedAppearanceStyles[appearance],
            !isDisabled && !(0, $VSDnB.fg)('platform-component-visual-refresh') && $2f706a5180e21ed2$var$dividerAppearanceStyles[appearance],
            (0, $VSDnB.fg)('platform-component-visual-refresh') && $2f706a5180e21ed2$var$dividerStyles.dividerOffsetRefreshed
        ])
    });
};
const $2f706a5180e21ed2$var$buttonStyles = {
    splitButton: "_1e0c116y _kqswh2mm _4cvr1h6o _o5721q9c",
    primaryButton: "_traeidpf _anlpidpf _p9ykidpf _bepvidpf",
    secondaryButton: "_1j4hidpf _1553idpf _1qgbidpf _y1n3idpf",
    defaultAppearanceContainer: "_2rko1sit _12jimuej _1cwg1n1a _1qu2nqa1 _12y3t94y"
};
const $2f706a5180e21ed2$export$994ba1b4c598f7 = ({ appearance: appearance, children: children, isDisabled: isDisabled = false })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            appearance === 'default' && !isDisabled && (0, $VSDnB.fg)('platform-component-visual-refresh') && $2f706a5180e21ed2$var$buttonStyles.defaultAppearanceContainer,
            $2f706a5180e21ed2$var$buttonStyles.splitButton
        ]),
        children: children
    });
};
const $2f706a5180e21ed2$export$651ad66661acd392 = ({ children: children, appearance: appearance = 'default', spacing: spacing = 'default', isDisabled: isDisabled = false })=>{
    const { PrimaryAction: PrimaryAction, SecondaryAction: SecondaryAction } = (0, $jvAlz.getActions)(children);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($2f706a5180e21ed2$export$994ba1b4c598f7, {
        appearance: appearance,
        isDisabled: isDisabled,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $icwyz.SplitButtonContext).Provider, {
            value: {
                appearance: appearance,
                spacing: spacing,
                isDisabled: isDisabled
            },
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $2f706a5180e21ed2$var$buttonStyles.primaryButton
                    ]),
                    children: PrimaryAction
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)($2f706a5180e21ed2$export$2e0a83ec2e27ecbb, {
                    appearance: appearance,
                    spacing: spacing,
                    isDisabled: isDisabled
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $2f706a5180e21ed2$var$buttonStyles.secondaryButton
                    ]),
                    children: SecondaryAction
                })
            ]
        })
    });
};
const $2f706a5180e21ed2$export$e3ca81100b492e15 = ({ primaryAction: primaryAction, secondaryAction: secondaryAction, appearance: appearance = 'default', spacing: spacing = 'default', isDisabled: isDisabled = false })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)($2f706a5180e21ed2$export$994ba1b4c598f7, {
        appearance: appearance,
        isDisabled: isDisabled,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $icwyz.SplitButtonContext).Provider, {
            value: {
                appearance: appearance,
                spacing: spacing,
                isDisabled: isDisabled
            },
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $2f706a5180e21ed2$var$buttonStyles.primaryButton
                    ]),
                    children: primaryAction
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)($2f706a5180e21ed2$export$2e0a83ec2e27ecbb, {
                    appearance: appearance,
                    spacing: spacing,
                    isDisabled: isDisabled
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $2f706a5180e21ed2$var$buttonStyles.secondaryButton
                    ]),
                    children: secondaryAction
                })
            ]
        })
    });
};

});
parcelRegister("jvAlz", function(module, exports) {

$parcel$export(module.exports, "getActions", () => $425b7dc91147601e$export$fe3955935f564b31);

var $5uXOq = parcelRequire("5uXOq");

var $6cAn5 = parcelRequire("6cAn5");
const $425b7dc91147601e$export$fe3955935f564b31 = (children)=>{
    const [PrimaryAction, SecondaryAction] = (0, $5uXOq.Children).toArray(children);
    typeof $6cAn5;
    return {
        PrimaryAction: PrimaryAction,
        SecondaryAction: SecondaryAction
    };
};

});


var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
// Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';

parcelRegister("4kfPc", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fe469c80a3193c7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $9yOBd = parcelRequire("9yOBd");

var $VSDnB = parcelRequire("VSDnB");


var $dsMCa = parcelRequire("dsMCa");
function $0fe469c80a3193c7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/design-system/no-css-tagged-template-expression -- Ignored via go/DSP-18766
const $0fe469c80a3193c7$var$integrationButtonCopyWrapperStyle = {
    name: "16rgrc1",
    styles: "display:flex;justify-content:left"
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/design-system/no-css-tagged-template-expression -- Ignored via go/DSP-18766
const $0fe469c80a3193c7$var$integrationIconWrapperStyle = {
    name: "mz1ewe",
    styles: "margin:var(--ds-space-025, 2px) var(--ds-space-100, 8px) var(--ds-space-0, 0px) var(--ds-space-0, 0px)"
};
const $0fe469c80a3193c7$var$IntegrationButtonInner = (props)=>{
    const { text: text, textColor: textColor, IntegrationIcon: IntegrationIcon, ...restProps } = props;
    return(// TODO: (from codemod) CustomThemeButton will be deprecated. Please consider migrating to Pressable or Anchor Primitives with custom styles.
    /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9yOBd.default), restProps, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $0fe469c80a3193c7$var$integrationButtonCopyWrapperStyle,
        style: {
            color: textColor || `var(--ds-text, ${0, $829f609a65d26a98$export$c39c0fe0f26207ae})`
        }
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $0fe469c80a3193c7$var$integrationIconWrapperStyle
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)(IntegrationIcon, null)), /*#__PURE__*/ (0, $f8Sb3.jsx)("span", null, text))));
};
const $0fe469c80a3193c7$var$IntegrationButton = (props)=>(0, $VSDnB.fg)('share-compiled-migration') ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dsMCa.default), {
        text: props.text,
        onClick: props.onClick,
        IntegrationIcon: props.IntegrationIcon
    }) : /*#__PURE__*/ (0, $f8Sb3.jsx)($0fe469c80a3193c7$var$IntegrationButtonInner, props);
$0fe469c80a3193c7$var$IntegrationButton.displayName = 'IntegrationButton';
var $0fe469c80a3193c7$export$2e2bcd8739ae039 = $0fe469c80a3193c7$var$IntegrationButton;

});
parcelRegister("dsMCa", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb233873498bd3e7$export$2e2bcd8739ae039);
/* IntegrationButtonNext.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $eCeGD = parcelRequire("eCeGD");

var $3JT92 = parcelRequire("3JT92");

var $MHKc7 = parcelRequire("MHKc7");
var $dS3PR = parcelRequire("dS3PR");
const $eb233873498bd3e7$var$styles = {
    integrationButtonCopyWrapperStyle: "_1e0c1txw _1bah1e5h _syaz10s3",
    integrationIconWrapperStyle: "_19pkv77o _2hwxu2gc _otyrze3t _18u0ze3t"
};
const $eb233873498bd3e7$var$IntegrationButton = (props)=>{
    const { text: text, IntegrationIcon: IntegrationIcon } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
        appearance: "subtle",
        shouldFitContainer: true,
        onClick: props.onClick,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $MHKc7.default), {
            as: "span",
            xcss: (0, $3JT92.cx)($eb233873498bd3e7$var$styles.integrationButtonCopyWrapperStyle),
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    as: "span",
                    xcss: (0, $3JT92.cx)($eb233873498bd3e7$var$styles.integrationIconWrapperStyle),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)(IntegrationIcon, {})
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                    color: "color.text",
                    children: text
                })
            ]
        })
    });
};
$eb233873498bd3e7$var$IntegrationButton.displayName = 'IntegrationButton';
var $eb233873498bd3e7$export$2e2bcd8739ae039 = $eb233873498bd3e7$var$IntegrationButton;

});



parcelRegister("4gTjW", function(module, exports) {

$parcel$export(module.exports, "generateSelectZIndex", () => $e2b0620d8e0c6274$export$eedd642610b90f47);
$parcel$export(module.exports, "getMenuPortalTargetCurrentHTML", () => $e2b0620d8e0c6274$export$e3e96376b61c8ea);
$parcel$export(module.exports, "optionDataToUsers", () => $e2b0620d8e0c6274$export$1c6fd61621efa6e2);
$parcel$export(module.exports, "allowEmails", () => $e2b0620d8e0c6274$export$e3c57815dfd9a32c);
$parcel$export(module.exports, "resolveShareFooter", () => $e2b0620d8e0c6274$export$6900a66855146901);

var $k5uoT = parcelRequire("k5uoT");
const $e2b0620d8e0c6274$export$ff1a1e5addedc4cc = 10;
const $e2b0620d8e0c6274$export$eedd642610b90f47 = (dialogZIndex)=>{
    // If user provided non-number value for zIndex, ignore and return undefined,
    // which will default to `layers.layer()` inside PopUp
    if (typeof dialogZIndex !== 'number' || !dialogZIndex) return (0, $k5uoT.layers).modal() + $e2b0620d8e0c6274$export$ff1a1e5addedc4cc;
    return dialogZIndex + $e2b0620d8e0c6274$export$ff1a1e5addedc4cc;
};
const $e2b0620d8e0c6274$export$e3e96376b61c8ea = (ref)=>{
    if (!ref) return null;
    if (!Object.prototype.hasOwnProperty.call(ref, 'current')) return null;
    // @ts-ignore ts(2339) - ref not having property current
    return ref.current;
};
const $e2b0620d8e0c6274$export$1c6fd61621efa6e2 = (optionDataArray)=>optionDataArray.map((optionData)=>{
        switch(optionData.type){
            case 'email':
                const user = {
                    type: 'user',
                    email: optionData.id
                };
                return user;
            case 'external_user':
                // When optionData.type is 'external_user', we need to convert it to 'user'
                // because 'external_user' isn't a valid type for the '/gateway/api/share' API.
                return {
                    type: 'user',
                    id: optionData.id
                };
            default:
                return {
                    type: optionData.type || 'user',
                    id: optionData.id
                };
        }
    });
const $e2b0620d8e0c6274$export$e3c57815dfd9a32c = (config)=>!(config && config.disableSharingToEmails);
const $e2b0620d8e0c6274$export$6900a66855146901 = (integrationMode, tabIndex, customFooter)=>{
    if (customFooter) {
        if (integrationMode !== 'tabs' || tabIndex === 0) return customFooter;
    }
};

});




parcelRegister("kAdLR", function(module, exports) {

$parcel$export(module.exports, "createAri", () => $63eb1b2c0e2cfff4$export$594d18a0ad2e0e57);
const $63eb1b2c0e2cfff4$var$getAriResourceOwner = (subProductId)=>{
    switch(subProductId){
        // these options aren't currently valid resource owners
        case 'jira-addon':
        case 'jira-platform':
        case 'jira-polaris':
        case 'jira-portfolio':
        case 'jira-unknown':
            return 'jira';
        // being explicit that these 3 are valid and were not forgotten
        case 'jira-core':
        case 'jira-servicedesk':
        case 'jira-software':
        default:
            return subProductId;
    }
};
const $63eb1b2c0e2cfff4$export$594d18a0ad2e0e57 = (subProductId, cloudId)=>`ari:cloud:${$63eb1b2c0e2cfff4$var$getAriResourceOwner(subProductId)}::site/${cloudId}`;

});

parcelRegister("aYuZy", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea05149486244917$export$2e2bcd8739ae039);

var $2gQ83 = parcelRequire("2gQ83");

var $inlXa = parcelRequire("inlXa");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
class $ea05149486244917$export$2e2bcd8739ae039 extends (0, $inlXa.ShareServiceClient) {
    constructor({ getShareEndpoint: getShareEndpoint, getSharePayload: getSharePayload }){
        super(), this.categorizeRecipients = (recipients)=>{
            const accumulator = {
                userIds: [],
                emails: []
            };
            return recipients.reduce((acc, recipient)=>{
                if (recipient.type === 'user') {
                    // @ts-expect-error - TS2339 - Property 'email' does not exist on type 'User'.
                    if (recipient.email !== undefined) // @ts-expect-error - TS2339 - Property 'email' does not exist on type 'User'.
                    acc.emails.push(recipient.email);
                    else if (recipient.id !== undefined) // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'User'.
                    acc.userIds.push(recipient.id);
                }
                return acc;
            }, accumulator);
        };
        this.getShareEndpoint = getShareEndpoint;
        this.getSharePayload = getSharePayload;
    }
    share(content, recipients, metadata, comment) {
        const categorizedRecipients = this.categorizeRecipients(recipients);
        const shareRequest = {
            usernames: categorizedRecipients.userIds,
            emails: categorizedRecipients.emails,
            message: comment?.value || '',
            atlOrigin: new (0, $2gQ83.default)({
                id: metadata.atlOriginId,
                product: 'jira'
            }).encode(),
            ...this.getSharePayload ? this.getSharePayload(content) : null
        };
        return (0, $eusud.performPostRequest)(this.getShareEndpoint(content), {
            body: JSON.stringify(shareRequest)
        }).catch((error)=>{
            (0, $jcw0u.default)({
                error: error,
                sendToPrivacyUnsafeSplunk: true,
                meta: {
                    packageName: 'jiraShareButton',
                    id: 'LegacyShareClient.share'
                },
                attributes: {
                    contentType: content.type
                }
            });
            throw error;
        });
    }
}

});

parcelRegister("kwHgU", function(module, exports) {

$parcel$export(module.exports, "loadUsers", () => $2adfecc7864678ee$export$2c3a8e05396a78be);
// @ts-expect-error - TS2305 - Module '"@atlaskit/share"' has no exported member 'OptionData'.

var $7f4tk = parcelRequire("7f4tk");
const $2adfecc7864678ee$var$USER_PICKER_LIMIT = 20;
const $2adfecc7864678ee$export$2c3a8e05396a78be = async (searchText = '')=>{
    const searchTextEncoded = encodeURIComponent(searchText);
    const url = `/rest/api/3/groupuserpicker?maxResults=${$2adfecc7864678ee$var$USER_PICKER_LIMIT}&query=${searchTextEncoded}&showAvatar=true&avatarSize=medium&excludeConnectAddons=true`;
    const groupsAndUsers = await (0, $7f4tk.default)(url);
    return groupsAndUsers.users.users.filter((user)=>user.accountType === 'atlassian').map((user)=>({
            type: 'user',
            id: user.accountId,
            name: user.displayName,
            avatarUrl: user.avatarUrl
        }));
};

});

parcelRegister("8HBuB", function(module, exports) {

$parcel$export(module.exports, "UserRole", () => $bbdf16990b710a51$export$eb3485a690c2f0b8);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bChGW = parcelRequire("bChGW");
var $7K5PP = parcelRequire("7K5PP");

var $7O4UO = parcelRequire("7O4UO");
var $bUa6y = parcelRequire("bUa6y");

var $MHKc7 = parcelRequire("MHKc7");
var $414Wj = parcelRequire("414Wj");
var $dS3PR = parcelRequire("dS3PR");

var $7VHMR = parcelRequire("7VHMR");
var $koVbs = parcelRequire("koVbs");
const $bbdf16990b710a51$var$styles = {
    userRoleSelect: "_16jlkb7n _i0dlidpf _1ul91obz _ca0q1ejb"
};
const $bbdf16990b710a51$var$messages = (0, $7VHMR.defineMessages)({
    userRoleLabel: {
        "id": "share-button.user-role.user-role-label.non-final",
        "defaultMessage": "User role"
    }
});
const $bbdf16990b710a51$var$SelectOption = ({ children: children, ...props })=>{
    const { data: data } = props;
    if (!data) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $414Wj.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        size: "medium"
    }, data.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        size: "small",
        color: "color.text.subtle"
    }, data.description)));
};
const $bbdf16990b710a51$export$eb3485a690c2f0b8 = ({ roles: roles, isLoading: isLoading })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const formData = (0, $bUa6y.useFormState)();
    const shouldShowUserRole = (0, $5uXOq.useMemo)(()=>{
        const projectAccessLevel = formData?.values.projectAccessLevel;
        return roles.length > 0 && !!projectAccessLevel && projectAccessLevel.value !== 'OPEN';
    }, [
        formData?.values.projectAccessLevel,
        roles.length
    ]);
    const userRoleOptions = (0, $5uXOq.useMemo)(()=>roles.map((role)=>({
                label: role.name,
                value: role.id,
                description: role.description,
                default: role.default || false
            })), [
        roles
    ]);
    const [currentUserRole, setCurrentUserRole] = (0, $5uXOq.useState)(userRoleOptions.find((role)=>role.default) || userRoleOptions[0]);
    if (!shouldShowUserRole) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
        name: "userRole",
        defaultValue: currentUserRole
    }, ({ fieldProps: { onChange: onChange, value: value, ...fieldProps } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
            xcss: $bbdf16990b710a51$var$styles.userRoleSelect
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
            ...fieldProps,
            isLoading: isLoading,
            options: userRoleOptions,
            value: currentUserRole,
            onChange: (userRoleOption)=>{
                if (!userRoleOption) return;
                onChange(userRoleOption);
                setCurrentUserRole(userRoleOption);
            },
            label: formatMessage($bbdf16990b710a51$var$messages.userRoleLabel),
            components: {
                Option: $bbdf16990b710a51$var$SelectOption
            },
            styles: {
                menuPortal: (base)=>({
                        ...base,
                        zIndex: 9999
                    }),
                control: (base)=>({
                        ...base,
                        minHeight: '44px',
                        height: '100%',
                        width: '100%'
                    }),
                menu: (base)=>({
                        ...base,
                        width: 'fit-content',
                        position: 'absolute',
                        right: 0
                    }),
                option: (base)=>({
                        ...base,
                        width: '320px'
                    })
            },
            menuPortalTarget: globalThis.document.body
        })));
};

});

parcelRegister("b4Qrh", function(module, exports) {

$parcel$export(module.exports, "CustomShareSubmitButton", () => $0164a6f1ecd00b94$export$acf0d09f1a6f345b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $LpImS = parcelRequire("LpImS");

var $bUa6y = parcelRequire("bUa6y");

var $MHKc7 = parcelRequire("MHKc7");
var $bUmQV = parcelRequire("bUmQV");

var $3bDjY = parcelRequire("3bDjY");

var $dD7Zc = parcelRequire("dD7Zc");

var $eCeGD = parcelRequire("eCeGD");

var $7VHMR = parcelRequire("7VHMR");
var $koVbs = parcelRequire("koVbs");
const $0164a6f1ecd00b94$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    formSharePublic: {
        "id": "share-button.custom-share-submit.form-share-public",
        "defaultMessage": "Share public link"
    },
    formSendPublic: {
        "id": "share-button.custom-share-submit.form-send-public",
        "defaultMessage": "Send public link"
    },
    formSave: {
        "id": "share-button.custom-share-submit.form-save",
        "defaultMessage": "Save"
    },
    formShare: {
        "id": "share-button.custom-share-submit.form-share",
        "defaultMessage": "Share"
    },
    formRetry: {
        "id": "share-button.custom-share-submit.form-retry",
        "defaultMessage": "Retry"
    },
    shareFailureMessage: {
        "id": "share-button.custom-share-submit.share-failure-message",
        "defaultMessage": "Unable to share"
    },
    shareFailureIconLabel: {
        "id": "share-button.custom-share-submit.share-failure-icon-label",
        "defaultMessage": "Error icon"
    }
});
const $0164a6f1ecd00b94$var$styles = {
    submitButtonWrapper: "_1e0c1txw _18u01wug",
    centerAlignedIconWrapper: "_1rjcze3t _18zrutpp _1e0c1txw _1wpz1h6o"
};
const $0164a6f1ecd00b94$export$acf0d09f1a6f345b = ({ isPublicLink: isPublicLink = false, shareError: shareError, isSharing: isSharing = false, isDisabled: isDisabled = false, isSubmitShareDisabled: isSubmitShareDisabled = false, integrationMode: integrationMode, submitButtonLabel: submitButtonLabel })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const formData = (0, $bUa6y.useFormState)({
        values: true,
        initialValues: true
    });
    const initialValuesRef = (0, $5uXOq.useRef)(null);
    const [shouldShowButton, setShouldShowButton] = (0, $5uXOq.useState)(false); // We use `useLayoutEffect` to ensure we show/hide the button before the button text is updated to avoid content flickering
    (0, $5uXOq.useLayoutEffect)(()=>{
        // If the form has not provided any state, we don't do anything
        if (!formData) return;
         // Store initial form values for manual dirty field checking
        if (!initialValuesRef.current) initialValuesRef.current = (0, (/*@__PURE__*/$parcel$interopDefault($LpImS)))(formData.initialValues);
         /**
       * We hide the submit button based on 2 fields:
       * - User picker field
       * - Project access level field (provided by consumers)
       *
       * If both are unchanged, we hide the submit button.
       */ 
        const userPickerValues = formData?.values.users;
        const projectAccessLevelValues = formData?.values.projectAccessLevel;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(initialValuesRef.current?.users, userPickerValues) || !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(initialValuesRef.current?.projectAccessLevel, projectAccessLevelValues)) setShouldShowButton(true);
        else setShouldShowButton(false);
    }, [
        formData
    ]);
    const isRetryableError = !!shareError?.retryable;
    const isNonRetryableError = shareError && !shareError.retryable;
    const shouldShowWarning = isRetryableError && !isSharing;
    const buttonAppearance = !shouldShowWarning ? 'primary' : 'warning';
    const tabMode = integrationMode === 'tabs';
    const formPublicLabel = tabMode ? $0164a6f1ecd00b94$export$defe85febe8b728c.formSharePublic : $0164a6f1ecd00b94$export$defe85febe8b728c.formSendPublic;
    const formSendLabel = (0, $5uXOq.useMemo)(()=>{
        /**
     * We change the submit button label based on 2 fields:
     * - User picker field
     * - Project access level field (provided by consumers)
     *
     * If the project access level field is changed but the user picker field is pristine, we show a `Save` button.
     * If the user picker field is changed, we show a `Share` button.
     */ const userPickerValues = formData?.values.users;
        if (userPickerValues && userPickerValues.length > 0) return $0164a6f1ecd00b94$export$defe85febe8b728c.formShare;
        return $0164a6f1ecd00b94$export$defe85febe8b728c.formSave;
    }, [
        formData?.values.users
    ]);
    const sendLabel = isPublicLink ? formPublicLabel : formSendLabel;
    const buttonLabel = isRetryableError ? $0164a6f1ecd00b94$export$defe85febe8b728c.formRetry : sendLabel;
    const buttonDisabled = isDisabled || isNonRetryableError || isSubmitShareDisabled;
    const ButtonLabelWrapper = buttonAppearance === 'warning' ? 'strong' : (0, $5uXOq.Fragment);
    if (!shouldShowButton) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        xcss: $0164a6f1ecd00b94$var$styles.submitButtonWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        xcss: $0164a6f1ecd00b94$var$styles.centerAlignedIconWrapper
    }, shouldShowWarning && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage($0164a6f1ecd00b94$export$defe85febe8b728c.shareFailureMessage),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUmQV.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
        spacing: "spacious",
        label: formatMessage($0164a6f1ecd00b94$export$defe85febe8b728c.shareFailureIconLabel),
        color: "var(--ds-icon-danger, #C9372C)"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        appearance: buttonAppearance,
        type: "submit",
        isLoading: isSharing,
        isDisabled: buttonDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ButtonLabelWrapper, null, submitButtonLabel || formatMessage(buttonLabel))));
};

});


parcelRegister("ckpyh", function(module, exports) {

$parcel$export(module.exports, "ProjectAccessLevelSelect", () => $324557b9f7ca6aa3$export$96197224e274ddb0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $7O4UO = parcelRequire("7O4UO");

var $MHKc7 = parcelRequire("MHKc7");
var $dS3PR = parcelRequire("dS3PR");

var $bgrar = parcelRequire("bgrar");

var $fptva = parcelRequire("fptva");

var $bwyQI = parcelRequire("bwyQI");

var $jHgVl = parcelRequire("jHgVl");

var $bChGW = parcelRequire("bChGW");
var $7K5PP = parcelRequire("7K5PP");

var $1wbtX = parcelRequire("1wbtX");

var $7VHMR = parcelRequire("7VHMR");
var $koVbs = parcelRequire("koVbs");
const $324557b9f7ca6aa3$var$FIELD_NAME = 'projectAccessLevel';
const $324557b9f7ca6aa3$var$styles = {
    iconContainer: "_nd5l2ec4 _18zru2gc _1wpz1h6o",
    dropdownContainer: "_nd5l1ba5",
    descriptionContainer: "_nd5ltgt2 _1bsb1ns9",
    field: "_otyrutpp",
    skeleton: "_otyrutpp"
}; // `css` is used to customise the styles of the Select components, `cssMap` / `xcss` don't work here
const $324557b9f7ca6aa3$var$controlStyles = null;
const $324557b9f7ca6aa3$var$valueContainerStyles = null;
const $324557b9f7ca6aa3$var$messages = (0, $7VHMR.defineMessages)({
    projectAccessLevelLabel: {
        "id": "share-dialog.fields.ProjectAccessLevelField.project-access-level-label.non-final",
        "defaultMessage": "Project access"
    }
});
const $324557b9f7ca6aa3$var$SelectControl = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Control, {
        ...props,
        appearance: "subtle",
        isCompact: true,
        className: (0, $bwpsq.default)([
            "_1bsb1ns9"
        ])
    });
};
const $324557b9f7ca6aa3$var$SelectValueContainer = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).ValueContainer, {
        ...props,
        className: (0, $bwpsq.default)([
            "_11c81ixg _k48pmoej"
        ])
    });
};
const $324557b9f7ca6aa3$var$SelectOption = ({ children: children, ...props })=>{
    const { data: data } = props;
    if (!data) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bgrar.default), {
        templateColumns: "auto 1fr",
        templateAreas: [
            'icon dropdown',
            'blank description'
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        xcss: $324557b9f7ca6aa3$var$styles.iconContainer
    }, $324557b9f7ca6aa3$export$16b26cd5e98d9100(data.iconName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        xcss: $324557b9f7ca6aa3$var$styles.dropdownContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        size: "large",
        weight: "bold"
    }, data.label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        xcss: $324557b9f7ca6aa3$var$styles.descriptionContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        color: "color.text.subtle"
    }, data.description))));
};
const $324557b9f7ca6aa3$export$16b26cd5e98d9100 = (icon)=>{
    const localProps = {
        label: '',
        color: "var(--ds-icon-accent-gray, #758195)",
        LEGACY_size: 'medium',
        spacing: 'spacious'
    };
    switch(icon){
        case 'open':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jHgVl))), localProps);
        case 'private':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bwyQI))), localProps);
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fptva))), {
                label: localProps.label,
                color: localProps.color,
                size: localProps.LEGACY_size
            });
    }
};
const $324557b9f7ca6aa3$var$transformToSelectOption = (level)=>({
        label: level.displayName,
        value: level.value,
        iconName: level.iconName,
        description: level.description
    });
const $324557b9f7ca6aa3$export$96197224e274ddb0 = ({ currentAccessLevel: currentAccessLevel, accessLevels: accessLevels, getProjectAccessLevels: getProjectAccessLevels, isLoading: isLoading })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const selectContainerRef = (0, $5uXOq.useRef)(null);
    const [currentValue, setCurrentValue] = (0, $5uXOq.useState)(currentAccessLevel && $324557b9f7ca6aa3$var$transformToSelectOption(currentAccessLevel));
    const selectOptions = (0, $5uXOq.useMemo)(()=>accessLevels?.map((level)=>$324557b9f7ca6aa3$var$transformToSelectOption(level)), [
        accessLevels
    ]);
    (0, $5uXOq.useEffect)(()=>{
        !currentValue && !isLoading && currentAccessLevel && setCurrentValue($324557b9f7ca6aa3$var$transformToSelectOption(currentAccessLevel));
    }, [
        currentAccessLevel,
        currentValue,
        isLoading
    ]);
    (0, $5uXOq.useEffect)(()=>{
        !accessLevels && !isLoading && getProjectAccessLevels();
    }, [
        accessLevels,
        getProjectAccessLevels,
        isLoading
    ]);
    if (!accessLevels && isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        xcss: $324557b9f7ca6aa3$var$styles.skeleton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wbtX.Skeleton), {
        height: "20px"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        xcss: $324557b9f7ca6aa3$var$styles.field
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
        name: $324557b9f7ca6aa3$var$FIELD_NAME,
        label: formatMessage($324557b9f7ca6aa3$var$messages.projectAccessLevelLabel),
        defaultValue: currentValue
    }, ({ fieldProps: { onChange: onChange, ...fieldProps } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bgrar.default), {
            templateColumns: "auto 1fr",
            templateAreas: [
                'icon dropdown',
                'blank description'
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
            xcss: $324557b9f7ca6aa3$var$styles.iconContainer,
            testId: "share-button.ui.project-access-level.box"
        }, $324557b9f7ca6aa3$export$16b26cd5e98d9100(currentValue?.iconName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
            xcss: $324557b9f7ca6aa3$var$styles.dropdownContainer,
            ref: selectContainerRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
            ...fieldProps,
            options: selectOptions,
            onChange: (value)=>{
                if (!value) return;
                setCurrentValue(value);
                onChange(value);
            },
            isSearchable: false,
            menuPortalTarget: globalThis.document.body,
            components: {
                Control: $324557b9f7ca6aa3$var$SelectControl,
                ValueContainer: $324557b9f7ca6aa3$var$SelectValueContainer,
                Option: $324557b9f7ca6aa3$var$SelectOption
            },
            styles: {
                menuPortal: (base)=>({
                        ...base,
                        zIndex: 9999,
                        width: selectContainerRef.current?.offsetWidth
                    })
            },
            menuPosition: "fixed"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
            xcss: $324557b9f7ca6aa3$var$styles.descriptionContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
            color: "color.text.subtle"
        }, currentValue?.description)))));
};

});
parcelRegister("bwyQI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::86c9de42fef4ccbc35a6164a0094138a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $863db7350f859785$var$_react = $863db7350f859785$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $863db7350f859785$var$_baseNew = $863db7350f859785$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $863db7350f859785$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockLocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $863db7350f859785$var$LockLockedIcon = (props)=>/*#__PURE__*/ $863db7350f859785$var$_react.default.createElement($863db7350f859785$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3h5V4A2.5 2.5 0 0 0 8 1.5M12 7V4a4 4 0 0 0-8 0v3a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M4 8.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5zM7.25 13v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$863db7350f859785$var$LockLockedIcon.displayName = 'LockLockedIcon';
var $863db7350f859785$var$_default = module.exports.default = $863db7350f859785$var$LockLockedIcon;

});

parcelRegister("jHgVl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::25e57ba6be3183cfa1e359a1a5374e32>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e56f2934baaafa03$var$_react = $e56f2934baaafa03$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e56f2934baaafa03$var$_baseNew = $e56f2934baaafa03$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $e56f2934baaafa03$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockUnlocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: unlocked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e56f2934baaafa03$var$LockUnlockedIcon = (props)=>/*#__PURE__*/ $e56f2934baaafa03$var$_react.default.createElement($e56f2934baaafa03$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3H12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2V4a4 4 0 1 1 8 0h-1.5A2.5 2.5 0 0 0 8 1.5m-4 7a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$e56f2934baaafa03$var$LockUnlockedIcon.displayName = 'LockUnlockedIcon';
var $e56f2934baaafa03$var$_default = module.exports.default = $e56f2934baaafa03$var$LockUnlockedIcon;

});



parcelRegister("8BVfN", function(module, exports) {

$parcel$export(module.exports, "shareButtonEntryPoint", () => $735d063ad5974451$export$ad8b1559c594245d);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $735d063ad5974451$export$ad8b1559c594245d = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>{
        if (!false) return (parcelRequire("1qTOc"));
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Promise.resolve({
            default: ()=>null
        });
    }, {
        moduleId: "50ae946e"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("1qTOc", function(module, exports) {

let $10b38293cb9c1f72$var$load = (parcelRequire("28QjX"))(4);
module.exports = $10b38293cb9c1f72$var$load("lMH7t").then(()=>parcelRequire('8kufr'));

});



parcelRegister("9j8is", function(module, exports) {

$parcel$export(module.exports, "useShareIntegrations", () => $d021f3111fd4c646$export$58a9f7a7ab3466f4);

var $5uXOq = parcelRequire("5uXOq");

var $c04PQ = parcelRequire("c04PQ");

var $bCdIp = parcelRequire("bCdIp");

var $pa9q9 = parcelRequire("pa9q9");

var $koeKL = parcelRequire("koeKL");

var $2UEtd = parcelRequire("2UEtd");

var $aMZmw = parcelRequire("aMZmw");
const $d021f3111fd4c646$export$58a9f7a7ab3466f4 = (shareContentType)=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const cloudId = (0, $koeKL.useCloudId)();
    const ineligibilityReasons = (0, $5uXOq.useMemo)(()=>{
        const reasons = [];
        if ((0, $bCdIp.default)()) reasons.push('notDesktop');
        // All Share to Slack must be disabled in FedRAMP environment as
        // Slack Jira Integration app is not available in FedRAMP
        if ((0, $c04PQ.isFedRamp)()) reasons.push('isFedRAMP');
        return reasons;
    }, []);
    const shareIntegrations = (0, $5uXOq.useMemo)(()=>ineligibilityReasons.length === 0 ? [
            {
                type: 'Slack',
                Icon: (0, $aMZmw.default),
                Content: ({ onClose: onClose, changeTab: changeTab })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2UEtd.ShareToSlack), {
                        showFlag: showFlag,
                        product: "jira",
                        channel: "productAnalytics",
                        onClose: onClose,
                        cloudId: cloudId,
                        changeTab: changeTab,
                        shareContentType: shareContentType
                    })
            }
        ] : [], [
        ineligibilityReasons.length,
        showFlag,
        cloudId,
        shareContentType
    ]);
    return {
        shareIntegrations: shareIntegrations
    };
};

});
parcelRegister("2UEtd", function(module, exports) {

$parcel$export(module.exports, "ShareToSlack", () => $168b88234834bfea$export$2cc56764fd9edb21);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eZJjh = parcelRequire("eZJjh");

var $b71gk = parcelRequire("b71gk");

var $lfTZh = parcelRequire("lfTZh");

var $3xc3R = parcelRequire("3xc3R");

const $168b88234834bfea$export$2cc56764fd9edb21 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "async-share-to-slack",
        packageName: "integrations"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "share-to-slack",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($168b88234834bfea$var$StyledShareToSlackLoader, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($168b88234834bfea$var$StyledShareToSlack, props)));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $168b88234834bfea$var$StyledShareToSlackLoader = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $eZJjh.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $168b88234834bfea$var$StyledShareToSlack = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $3xc3R.LazyShareToSlack), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkmgjw _2hwx10v4 _otyrmgjw _18u010v4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3xc3R", function(module, exports) {

$parcel$export(module.exports, "LazyShareToSlack", () => $0733f18014b5074d$export$24281652e6b89b3b);

var $kxZPA = parcelRequire("kxZPA");

const $0733f18014b5074d$export$24281652e6b89b3b = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("lkjYU")), {
    ssr: false,
    moduleId: "../platform/packages/growth/integrations/src/share-to-slack/ui/index.tsx"
});

});
parcelRegister("lkjYU", function(module, exports) {

let $f86af723f983b7c6$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $f86af723f983b7c6$var$load("kNFvF"),
    $f86af723f983b7c6$var$load("ff9v5")
]).then(()=>parcelRequire('2B8HF'));

});



parcelRegister("aMZmw", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1ef732ae0096135$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a1ef732ae0096135$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "4 4 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M7.50403 13.8563C7.50403 14.727 6.79278 15.4382 5.92212 15.4382C5.05146 15.4382 4.34021 14.727 4.34021 13.8563C4.34021 12.9857 5.05146 12.2744 5.92212 12.2744H7.50403V13.8563Z",
        fill: "#E01E5A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M8.30115 13.8563C8.30115 12.9857 9.0124 12.2744 9.88307 12.2744C10.7537 12.2744 11.465 12.9857 11.465 13.8563V17.8172C11.465 18.6879 10.7537 19.3991 9.88307 19.3991C9.0124 19.3991 8.30115 18.6879 8.30115 17.8172V13.8563Z",
        fill: "#E01E5A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M9.88307 7.50415C9.0124 7.50415 8.30115 6.79291 8.30115 5.92224C8.30115 5.05158 9.0124 4.34033 9.88307 4.34033C10.7537 4.34033 11.465 5.05158 11.465 5.92224V7.50415H9.88307Z",
        fill: "#36C5F0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M9.88304 8.30127C10.7537 8.30127 11.465 9.01251 11.465 9.88317C11.465 10.7538 10.7537 11.4651 9.88304 11.4651H5.92212C5.05146 11.4651 4.34021 10.7538 4.34021 9.88317C4.34021 9.01251 5.05146 8.30127 5.92212 8.30127H9.88304Z",
        fill: "#36C5F0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M16.2354 9.88317C16.2354 9.01251 16.9466 8.30127 17.8172 8.30127C18.6879 8.30127 19.3991 9.01251 19.3991 9.88317C19.3991 10.7538 18.6879 11.4651 17.8172 11.4651H16.2354V9.88317Z",
        fill: "#2EB67D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M15.4381 9.88316C15.4381 10.7538 14.7269 11.4651 13.8562 11.4651C12.9855 11.4651 12.2743 10.7538 12.2743 9.88316V5.92225C12.2743 5.05158 12.9855 4.34033 13.8562 4.34033C14.7269 4.34033 15.4381 5.05158 15.4381 5.92225V9.88316Z",
        fill: "#2EB67D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M13.8562 16.2354C14.7269 16.2354 15.4381 16.9466 15.4381 17.8172C15.4381 18.6879 14.7269 19.3991 13.8562 19.3991C12.9855 19.3991 12.2743 18.6879 12.2743 17.8172V16.2354H13.8562Z",
        fill: "#ECB22E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M13.8562 15.4382C12.9855 15.4382 12.2743 14.727 12.2743 13.8563C12.2743 12.9857 12.9855 12.2744 13.8562 12.2744H17.8171C18.6878 12.2744 19.399 12.9857 19.399 13.8563C19.399 14.727 18.6878 15.4382 17.8171 15.4382H13.8562Z",
        fill: "#ECB22E"
    }));

});


parcelRegister("fjgF8", function(module, exports) {

$parcel$export(module.exports, "AsyncShareProjectNudge", () => $7ce891b6fd7965bb$export$d95995d6ca76620b);

var $5uXOq = parcelRequire("5uXOq");

var $bBbEG = parcelRequire("bBbEG");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $7ce891b6fd7965bb$var$LazyShareProjectNudge = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("5ke97")), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/jwm-share-project/index.tsx"
});
const $7ce891b6fd7965bb$export$d95995d6ca76620b = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: (0, $dbbf68c32d8c4308$export$a1be34032ee24f78),
        fallback: children,
        attributes: {
            nudgeId: (0, $dbbf68c32d8c4308$export$a1be34032ee24f78)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jwm-share-project-nudge",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7ce891b6fd7965bb$var$LazyShareProjectNudge, null, children)));

});
const $dbbf68c32d8c4308$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $dbbf68c32d8c4308$export$6770a2081a63fc15 = 'backlogStartSprintNudge';
const $dbbf68c32d8c4308$export$63b61f654ce3da3d = 'backlogCompleteSprintNudge';
const $dbbf68c32d8c4308$export$1c7a80b00ad9619 = 'backlogInsightsNudge';
const $dbbf68c32d8c4308$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingNudges';
const $dbbf68c32d8c4308$export$65fb0c4e534f03fc = 'asyncScrumTourNudge';
const $dbbf68c32d8c4308$export$f2fe211acb4aa81a = 'asyncKanbanTourNudge';
const $dbbf68c32d8c4308$export$fb9c6e63a7490968 = 'asyncJWMCalendarTourNudge';
const $dbbf68c32d8c4308$export$df53a339af97f102 = 'asyncJWMCalendarAndTimelineTourNudge';
const $dbbf68c32d8c4308$export$573d4bf1da6d2bc6 = 'asyncJWMBoardTourNudge';
const $dbbf68c32d8c4308$export$501e36925fa10eef = 'asyncJWMListTourNudge';
const $dbbf68c32d8c4308$export$2f06a16c987cc1a2 = 'asyncJWMTimelineTourNudge';
const $dbbf68c32d8c4308$export$226bdcb034c75951 = 'asyncJWMFormTourNudge';
const $dbbf68c32d8c4308$export$b72fce9f4cf11b5c = 'asyncJWMTrelloKeyDifferencesTourNudge';
const $dbbf68c32d8c4308$export$306510c7b1760652 = 'asyncJWMSummaryAndReportsTabNudge';
const $dbbf68c32d8c4308$export$cf1943561be3a3c2 = 'asyncJWMSummaryViewNudge';
const $dbbf68c32d8c4308$export$f8bf435a6066832c = 'button clicked';
const $dbbf68c32d8c4308$export$3bc551fe07069f89 = 'asyncJWMInviteTeamNudge';
const $dbbf68c32d8c4308$export$d99767a37baddfc = 'sampleProjectDataNudge';
const $dbbf68c32d8c4308$export$2ef41782ca91324c = 'businessSampleDataNudge';
const $dbbf68c32d8c4308$export$4db327e1949c2108 = 'boardInProgressColumnNudge';
const $dbbf68c32d8c4308$export$a402f2c11da96cd7 = 'boardCreateIssueNudge';
const $dbbf68c32d8c4308$export$1e174cd1e0212f3a = 'navigateCalendarNudge';
const $dbbf68c32d8c4308$export$a1398a6ef9526001 = 'inlineEditListNudge';
const $dbbf68c32d8c4308$export$5908fa8acd2c0739 = 'filterListNudge';
const $dbbf68c32d8c4308$export$50192b0fdc9bdacf = 'moreDropdownListNudge';
const $dbbf68c32d8c4308$export$e34e81ed4f255f6e = 'timelineAddDateNudge';
const $dbbf68c32d8c4308$export$aac6e5779d47ef37 = 'timelineAddChildItemNudge';
const $dbbf68c32d8c4308$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $dbbf68c32d8c4308$export$1e0e647cc08bb4d8 = 'trelloKeyDifferencesIssueNudge';
const $dbbf68c32d8c4308$export$762576896c225bd6 = 'trelloKeyDifferencesSummaryNudge';
const $dbbf68c32d8c4308$export$5a96f813312dc7fa = 'trelloKeyDifferencesBoardNudge';
const $dbbf68c32d8c4308$export$ae8eeb04e0b1e9af = 'availableFieldsFormNudge';
const $dbbf68c32d8c4308$export$a54d77300f1dddea = 'changeIssueTypeFormNudge';
const $dbbf68c32d8c4308$export$6afdc7e5f6d2e915 = 'previewSaveFormNudge';
const $dbbf68c32d8c4308$export$eb0b199de90a7ec2 = 'backgroundColorNudge';
const $dbbf68c32d8c4308$export$e9e47a7ad42e71f5 = 'feedbackNudge';
const $dbbf68c32d8c4308$export$791f56b3d78403cc = 'calendarReleasesNudge';
const $dbbf68c32d8c4308$export$a1be34032ee24f78 = 'shareProjectNudge';
const $dbbf68c32d8c4308$export$29fe6611cc093756 = 'summaryTabNudge';
const $dbbf68c32d8c4308$export$f107c06c0830f09d = 'reportsTabNudge';
const $dbbf68c32d8c4308$export$9749a972a54ad7ba = 'boardContainerNudge';
const $dbbf68c32d8c4308$export$fb4f98ca3ff0420 = 'businessSampleDataNudge';
const $dbbf68c32d8c4308$export$b7fd448c62b5fb97 = 'listview';
const $dbbf68c32d8c4308$export$10c63dc5c09466d2 = 'boardview';
const $dbbf68c32d8c4308$export$75b8d65228d517e9 = 'sampleProjectScrumTourNudge';
const $dbbf68c32d8c4308$export$59a47f76d45b99 = 'sampleProjectScrumSprintNudge';
const $dbbf68c32d8c4308$export$513a9459cd6c3f96 = 'sampleProjectScrumBacklogNudge';
const $dbbf68c32d8c4308$export$657cdc4d7e8d9e5f = 'sampleProjectScrumBoardNudge';
const $dbbf68c32d8c4308$export$e16b25a220be9f3b = 'sampleProjectBoardNudge';
const $dbbf68c32d8c4308$export$c2f124710ac3a3ab = 'sampleProjectListNudge';
const $dbbf68c32d8c4308$export$b1c1e2ff4cbedbe = 'sampleProjectScrumSprintNudgeErrorBoundary';
const $dbbf68c32d8c4308$export$b230ed22c9a186d5 = 'sampleProjectScrumBacklogNudgeErrorBoundary';
const $dbbf68c32d8c4308$export$a321b777cf077071 = 'sampleProjectScrumBoardNudgeErrorBoundary';
const $dbbf68c32d8c4308$export$b51b409cb5508624 = 'sampleProjectBoardNudgeErrorBoundary';
const $dbbf68c32d8c4308$export$9757a1f68dc7a9b = 'sampleProjectListNudgeErrorBoundary';
const $dbbf68c32d8c4308$export$63a886637b84800 = 'sampleProjectNavTourNudge';
const $dbbf68c32d8c4308$export$bb40993d16db4a4b = 'SampleProjectNavNudge';
const $dbbf68c32d8c4308$export$8c300ac9d8c53332 = 'SampleProjectNavNudgeErrorBoundary';

parcelRegister("5ke97", function(module, exports) {

let $3e09cb24ccda0426$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3e09cb24ccda0426$var$load("aFhM0").then(()=>parcelRequire('dRf63'));

});


parcelRegister("4XKuc", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ed6b88152ef6ea6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5ed6b88152ef6ea6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    share: {
        "id": "business-invite-people.jwm-share-button.share",
        "defaultMessage": "Share"
    },
    shareTooltipText: {
        "id": "business-invite-people.jwm-share-button.share-tooltip-text",
        "defaultMessage": "Embed this Smart Link in other Atlassian products such as Confluence"
    },
    shareJwmHelperMessage: {
        "id": "business-invite-people.jwm-share-button.share-jwm-helper-message",
        "defaultMessage": "This view, along with any applied groups and filters are shared"
    }
});

});


parcelRegister("70g8n", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bc06decfa7dde08$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $2h2vc = parcelRequire("2h2vc");

var $2SbUq = parcelRequire("2SbUq");

const $1bc06decfa7dde08$export$7174b56226171cc3 = (0, $kxZPA.lazy)(()=>(parcelRequire("abXKW")), {
    ssr: false,
    moduleId: "./src/packages/business/shared/components/more-menu/src/ui/more-menu/menu-content/index.tsx"
});
const $1bc06decfa7dde08$var$MoreMenu = ({ hideDoneItems: hideDoneItems, hasExpandedAllItems: hasExpandedAllItems, hasCollapsedAllItems: hasCollapsedAllItems, hasFeedbackButton: hasFeedbackButton, projectType: projectType, isExpandCollapseButtonEnabled: isExpandCollapseButtonEnabled, onChangeHideDoneItems: onChangeHideDoneItems, onExpandCollapseAllItems: onExpandCollapseAllItems, hideItemsMenuOptions: hideItemsMenuOptions, jpdRoadmapButton: jpdRoadmapButton // GALILEO-1454
 })=>{
    const renderContent = (0, $5uXOq.useCallback)((onCloseMenu)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
            name: "menu-content",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2h2vc.default), null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1bc06decfa7dde08$export$7174b56226171cc3, {
            hideDoneItems: hideDoneItems,
            onChangeHideDoneItems: onChangeHideDoneItems,
            onExpandCollapseAllItems: onExpandCollapseAllItems,
            isExpandCollapseButtonEnabled: isExpandCollapseButtonEnabled,
            hasExpandedAllItems: hasExpandedAllItems,
            hasCollapsedAllItems: hasCollapsedAllItems,
            hasFeedbackButton: hasFeedbackButton,
            projectType: projectType,
            onCloseMenu: onCloseMenu,
            hideItemsMenuOptions: hideItemsMenuOptions,
            jpdRoadmapButton: jpdRoadmapButton
        })), [
        hideDoneItems,
        onChangeHideDoneItems,
        onExpandCollapseAllItems,
        isExpandCollapseButtonEnabled,
        hasExpandedAllItems,
        hasCollapsedAllItems,
        hasFeedbackButton,
        projectType,
        hideItemsMenuOptions,
        jpdRoadmapButton // GALILEO-1454
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2SbUq.default), {
        renderContent: renderContent
    });
};
var $1bc06decfa7dde08$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($1bc06decfa7dde08$var$MoreMenu);

});
parcelRegister("2h2vc", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4b39db453d8ec83$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eZJjh = parcelRequire("eZJjh");
const $c4b39db453d8ec83$var$MenuFallback = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c4b39db453d8ec83$var$SpinnerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "medium"
    }));
var $c4b39db453d8ec83$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($c4b39db453d8ec83$var$MenuFallback);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $c4b39db453d8ec83$var$SpinnerWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
            __cmplp.className
        ])
    });
});

});

parcelRegister("2SbUq", function(module, exports) {

$parcel$export(module.exports, "default", () => $86d5dde4b111cc89$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $jgJNO = parcelRequire("jgJNO");

var $l8ruj = parcelRequire("l8ruj");


var $loRkl = parcelRequire("loRkl");
const $86d5dde4b111cc89$var$MoreMenuCore = /*#__PURE__*/ (0, $5uXOq.memo)(({ renderContent: renderContent, minWidth: minWidth = (0, $f1bdb30d4d079129$export$8c68b096b2d5e9f6), forceVisibility: forceVisibility = false })=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(forceVisibility);
    (0, $5uXOq.useEffect)(()=>{
        setIsOpen(forceVisibility);
    }, [
        forceVisibility
    ]);
    const closeMenu = (0, $5uXOq.useCallback)(()=>setIsOpen(false), []);
    const toggleMenu = (0, $5uXOq.useCallback)(()=>setIsOpen((oldIsOpen)=>!oldIsOpen), []);
    const content = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($86d5dde4b111cc89$export$5f7211d21bfdae05, {
            width: minWidth
        }, renderContent(closeMenu)), [
        closeMenu,
        renderContent,
        minWidth
    ]);
    const trigger = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter 'triggerProps' implicitly has an 'any' type.
    (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $loRkl.default), {
            ...triggerProps,
            isSelected: isOpen,
            onClick: toggleMenu
        }), [
        isOpen,
        toggleMenu
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "business-more-menu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isOpen,
        onClose: closeMenu,
        placement: "bottom-end",
        messageId: "business-more-menu.ui.more-menu.more-menu-core.popup",
        messageType: "transactional",
        content: content,
        trigger: trigger
    }));
});
var $86d5dde4b111cc89$export$2e2bcd8739ae039 = $86d5dde4b111cc89$var$MoreMenuCore;
const $86d5dde4b111cc89$export$5f7211d21bfdae05 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_6f8077": (0, $lD23V.default)(`${__cmplp.width}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1hdq",
            __cmplp.className
        ])
    });
});

});
const $f1bdb30d4d079129$export$8c68b096b2d5e9f6 = 320;

parcelRegister("loRkl", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbbabf378481667d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8U6zd = parcelRequire("8U6zd");

var $bJeNF = parcelRequire("bJeNF");

var $3bDjY = parcelRequire("3bDjY");

var $7XYc4 = parcelRequire("7XYc4");

var $koVbs = parcelRequire("koVbs");

var $22OQR = parcelRequire("22OQR");

var $hCCtP = parcelRequire("hCCtP");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

var $dSexS = parcelRequire("dSexS");
const $fbbabf378481667d$var$MORE_ICON = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bJeNF))), {
    label: "",
    LEGACY_size: "small"
});
const $fbbabf378481667d$var$TriggerOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ onClick: onClick, isSelected: isSelected, ...otherProps }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $22OQR.ThemedButton), {
        ...otherProps,
        ref: ref,
        testId: "business-more-menu.ui.more-menu.more-menu-core.trigger",
        iconBefore: $fbbabf378481667d$var$MORE_ICON,
        isSelected: isSelected,
        onClick: onClick,
        appearance: "subtle",
        "aria-label": formatMessage((0, $dSexS.default).moreButtonLabel)
    }, formatMessage((0, $dSexS.default).moreButtonOld));
});
const $fbbabf378481667d$var$Trigger = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ onClick: onClick, isSelected: isSelected, ...otherProps }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const oldButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $22OQR.ThemedButton), {
        ...otherProps,
        ref: ref,
        testId: "business-more-menu.ui.more-menu.more-menu-core.trigger",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8U6zd))), {
            label: "",
            spacing: "spacious",
            color: "currentColor"
        }),
        isSelected: isSelected,
        onClick: onClick,
        "aria-label": formatMessage((0, $dSexS.default).moreButtonLabel),
        title: (0, $dCm1o.isVisualRefreshEnabled)() ? undefined : formatMessage((0, $dSexS.default).moreButtonOld)
    });
    const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCCtP.ThemedIconButton), {
        ...otherProps,
        ref: ref,
        label: formatMessage((0, $dSexS.default).moreButtonLabel),
        testId: "business-more-menu.ui.more-menu.more-menu-core.trigger",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8U6zd))),
        isSelected: isSelected,
        onClick: onClick,
        title: (0, $dCm1o.isVisualRefreshEnabled)() ? undefined : formatMessage((0, $dSexS.default).moreButtonOld)
    });
    return (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $dSexS.default).moreButton)
    }, (0, $4R6GH.fg)('setting_button_refresh') ? button : oldButton) : button;
});
var $fbbabf378481667d$export$2e2bcd8739ae039 = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $fbbabf378481667d$var$Trigger, $fbbabf378481667d$var$TriggerOld);

});
parcelRegister("hCCtP", function(module, exports) {

$parcel$export(module.exports, "ThemedButtonWrapper", () => $34060b1367424582$export$269674ad0c604d30);
$parcel$export(module.exports, "ThemedButtonNew", () => $34060b1367424582$export$15536ee0f9ee7c0b);
$parcel$export(module.exports, "ThemedIconButton", () => $34060b1367424582$export$d9c2d067feb61447);
$parcel$export(module.exports, "ThemedLinkButton", () => $34060b1367424582$export$b0b5aeed52623827);
$parcel$export(module.exports, "ThemedLinkIconButton", () => $34060b1367424582$export$a1ab08e79d264ec8);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $eCeGD = parcelRequire("eCeGD");
var $42CjB = parcelRequire("42CjB");
var $1GGwS = parcelRequire("1GGwS");
var $krXdA = parcelRequire("krXdA");

var $6cG4N = parcelRequire("6cG4N");

var $4R6GH = parcelRequire("4R6GH");

var $dCm1o = parcelRequire("dCm1o");

var $lmBAt = parcelRequire("lmBAt");

const $34060b1367424582$export$269674ad0c604d30 = ({ children: children })=>(0, $lmBAt.getIsSoftwareThemingEnabled)() || (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh-headers-buttons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "span",
        xcss: [
            $34060b1367424582$var$overrideStyles,
            (0, $lmBAt.getIsSoftwareThemingM2Enabled)() && $34060b1367424582$var$themingM2Styles,
            (0, $4R6GH.fg)('jira_themed_button_styling_fix') && $34060b1367424582$var$wrapperStyles
        ]
    }, children) : children;
const $34060b1367424582$export$15536ee0f9ee7c0b = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($34060b1367424582$export$269674ad0c604d30, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        ...props,
        ref: ref
    }))));
const $34060b1367424582$export$d9c2d067feb61447 = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($34060b1367424582$export$269674ad0c604d30, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        ...props,
        ref: ref
    }))));
const $34060b1367424582$export$b0b5aeed52623827 = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($34060b1367424582$export$269674ad0c604d30, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1GGwS.default), {
        ...props,
        ref: ref
    }))));
const $34060b1367424582$export$a1ab08e79d264ec8 = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($34060b1367424582$export$269674ad0c604d30, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $krXdA.default), {
        ...props,
        ref: ref
    }))));
const $34060b1367424582$var$overrideStyles = (0, $8CUq3.xcss)({
    // @ts-expect-error Object literal may only specify known properties, and ''--ds-background-brand-bold'' does not exist in type 'SafeCSSObject'.ts(2353)
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-brand-bold': (0, $6cG4N.Tokens).COLOR_BACKGROUND_BRAND_BOLD,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-brand-bold-hovered': (0, $6cG4N.Tokens).COLOR_BACKGROUND_BRAND_BOLD_HOVERED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-brand-bold-pressed': (0, $6cG4N.Tokens).COLOR_BACKGROUND_BRAND_BOLD_PRESSED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-disabled': (0, $6cG4N.Tokens).COLOR_BACKGROUND_DISABLED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-selected': (0, $6cG4N.Tokens).COLOR_BACKGROUND_SELECTED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-selected-hovered': (0, $6cG4N.Tokens).COLOR_BACKGROUND_SELECTED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-selected-pressed': (0, $6cG4N.Tokens).COLOR_BACKGROUND_SELECTED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-neutral': (0, $6cG4N.Tokens).COLOR_BACKGROUND_NEUTRAL,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-neutral-hovered': (0, $6cG4N.Tokens).COLOR_BACKGROUND_NEUTRAL_HOVERED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-neutral-pressed': (0, $6cG4N.Tokens).COLOR_BACKGROUND_NEUTRAL_PRESSED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-neutral-subtle-hovered': (0, $6cG4N.Tokens).COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-neutral-subtle-pressed': (0, $6cG4N.Tokens).COLOR_BACKGROUND_NEUTRAL_SUBTLE_PRESSED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-icon-subtle': (0, $6cG4N.Tokens).COLOR_TEXT_SUBTLE,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-icon': (0, $6cG4N.Tokens).COLOR_TEXT,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-link': (0, $6cG4N.Tokens).COLOR_LINK,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-link-pressed': (0, $6cG4N.Tokens).COLOR_LINK_PRESSED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-text': (0, $6cG4N.Tokens).COLOR_TEXT_SUBTLE,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-text-disabled': (0, $6cG4N.Tokens).COLOR_TEXT_DISABLED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-text-inverse': (0, $6cG4N.Tokens).COLOR_TEXT_INVERSE,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-text-selected': (0, $6cG4N.Tokens).COLOR_TEXT_SELECTED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-text-subtle': (0, $6cG4N.Tokens).COLOR_TEXT_SUBTLE,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-border': (0, $6cG4N.Tokens).COLOR_BORDER,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-border-selected': (0, $6cG4N.Tokens).COLOR_BORDER_SELECTED
});
const $34060b1367424582$var$themingM2Styles = (0, $8CUq3.xcss)({
    // @ts-expect-error Object literal may only specify known properties, and ''--ds-background-brand-bold'' does not exist in type 'SafeCSSObject'.ts(2353)
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--project-color-link': `var(${(0, $5b25b2eb4e8be764$export$fac615ceaa871e35)}, ${"var(--ds-text, #172B4D)"})`
});
const $34060b1367424582$var$wrapperStyles = (0, $8CUq3.xcss)({
    display: 'inline-flex'
});

});

parcelRegister("dSexS", function(module, exports) {

$parcel$export(module.exports, "default", () => $52d3441e2e3906d4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $52d3441e2e3906d4$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    moreButtonOld: {
        "id": "business-more-menu.more-menu.more-menu-core.trigger.more-button-old",
        "defaultMessage": "More"
    },
    moreButton: {
        "id": "business-more-menu.more-menu.more-menu-core.trigger.more-button",
        "defaultMessage": "More actions"
    },
    moreButtonLabel: {
        "id": "business-more-menu.more-menu.more-menu-core.trigger.more-button-label",
        "defaultMessage": "More actions on the view options"
    }
});

});



parcelRegister("abXKW", function(module, exports) {

let $76b948cd660c28ce$var$load = (parcelRequire("28QjX"))(4);
module.exports = $76b948cd660c28ce$var$load("9MLSP").then(()=>parcelRequire('fhUV3'));

});


parcelRegister("dXCxS", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0ad71e5c6a4bee7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hYRTO = parcelRequire("hYRTO");

var $kxZPA = parcelRequire("kxZPA");

var $ej8Wl = parcelRequire("ej8Wl");

var $5UVwA = parcelRequire("5UVwA");

const $b0ad71e5c6a4bee7$export$7174b56226171cc3 = (0, $kxZPA.lazy)(()=>(parcelRequire("2zLnM")), {
    ssr: false,
    moduleId: "./src/packages/business/shared/components/settings-menu/src/ui/settings-menu/menu-content/index.tsx"
});
const $b0ad71e5c6a4bee7$var$SettingsMenu = ({ hideDoneItems: hideDoneItems, hasExpandedAllItems: hasExpandedAllItems, hasCollapsedAllItems: hasCollapsedAllItems, isExpandCollapseButtonEnabled: isExpandCollapseButtonEnabled, onChangeHideDoneItems: onChangeHideDoneItems, onExpandCollapseAllItems: onExpandCollapseAllItems })=>{
    const renderContent = (0, $5uXOq.useCallback)((onCloseMenu)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hYRTO.default), {
            name: "menu-content",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ej8Wl.default), null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b0ad71e5c6a4bee7$export$7174b56226171cc3, {
            hideDoneItems: hideDoneItems,
            onChangeHideDoneItems: onChangeHideDoneItems,
            onExpandCollapseAllItems: onExpandCollapseAllItems,
            isExpandCollapseButtonEnabled: isExpandCollapseButtonEnabled,
            hasExpandedAllItems: hasExpandedAllItems,
            hasCollapsedAllItems: hasCollapsedAllItems,
            onCloseMenu: onCloseMenu
        })), [
        hideDoneItems,
        onChangeHideDoneItems,
        onExpandCollapseAllItems,
        isExpandCollapseButtonEnabled,
        hasExpandedAllItems,
        hasCollapsedAllItems
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5UVwA.default), {
        renderContent: renderContent
    });
};
var $b0ad71e5c6a4bee7$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($b0ad71e5c6a4bee7$var$SettingsMenu);

});
parcelRegister("ej8Wl", function(module, exports) {

$parcel$export(module.exports, "default", () => $277612fdcac905c3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $eZJjh = parcelRequire("eZJjh");
const $277612fdcac905c3$var$MenuFallback = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $277612fdcac905c3$var$spinnedWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "medium"
    }));
var $277612fdcac905c3$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($277612fdcac905c3$var$MenuFallback);
const $277612fdcac905c3$var$spinnedWrapperStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 'space.200'
});

});

parcelRegister("5UVwA", function(module, exports) {

$parcel$export(module.exports, "default", () => $442f66c0b9177f44$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $jgJNO = parcelRequire("jgJNO");

var $l8ruj = parcelRequire("l8ruj");


var $egJIl = parcelRequire("egJIl");
const $442f66c0b9177f44$var$SettingMenuCore = /*#__PURE__*/ (0, $5uXOq.memo)(({ renderContent: renderContent, minWidth: minWidth = (0, $7d19812bf97f27a1$export$8c68b096b2d5e9f6), forceVisibility: forceVisibility = false })=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(forceVisibility);
    (0, $5uXOq.useEffect)(()=>{
        setIsOpen(forceVisibility);
    }, [
        forceVisibility
    ]);
    const closeMenu = (0, $5uXOq.useCallback)(()=>setIsOpen(false), []);
    const toggleMenu = (0, $5uXOq.useCallback)(()=>setIsOpen((oldIsOpen)=>!oldIsOpen), []);
    const content = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($442f66c0b9177f44$var$DropdownWrapper, {
            width: minWidth
        }, renderContent(closeMenu)), [
        closeMenu,
        renderContent,
        minWidth
    ]);
    const trigger = (0, $5uXOq.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $egJIl.default), {
            ...triggerProps,
            isSelected: isOpen,
            onClick: toggleMenu
        }), [
        isOpen,
        toggleMenu
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "business-settings-menu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isOpen,
        onClose: closeMenu,
        placement: "bottom-end",
        messageId: "business-settings-menu.ui.settings-menu.settings-menu-core.popup",
        messageType: "transactional",
        content: content,
        trigger: trigger
    }));
});
var $442f66c0b9177f44$export$2e2bcd8739ae039 = $442f66c0b9177f44$var$SettingMenuCore;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $442f66c0b9177f44$var$DropdownWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_6f8077": (0, $lD23V.default)(`${__cmplp.width}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1hdq",
            __cmplp.className
        ])
    });
});

});
const $7d19812bf97f27a1$export$8c68b096b2d5e9f6 = 320;

parcelRegister("egJIl", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c59696bb775620b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4QAwn = parcelRequire("4QAwn");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $22OQR = parcelRequire("22OQR");

var $hCCtP = parcelRequire("hCCtP");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

var $gGI3m = parcelRequire("gGI3m");
const $2c59696bb775620b$var$Trigger = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ onClick: onClick, isSelected: isSelected, ...otherProps }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const oldThemedButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $22OQR.ThemedButton), {
        ...otherProps,
        ref: ref,
        testId: "business-settings-menu.ui.settings-menu.settings-menu-core.trigger.trigger",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4QAwn))), {
            label: "",
            spacing: "spacious",
            color: "currentColor"
        }),
        isSelected: isSelected,
        onClick: onClick,
        "aria-label": formatMessage((0, $gGI3m.default).settingsButtonLabel),
        title: (0, $dCm1o.isVisualRefreshEnabled)() ? undefined : formatMessage((0, $gGI3m.default).settingsButton)
    });
    const themedButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCCtP.ThemedIconButton), {
        ...otherProps,
        ref: ref,
        "data-test": "WOWZER",
        testId: "business-settings-menu.ui.settings-menu.settings-menu-core.trigger.trigger",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4QAwn))),
        isSelected: isSelected,
        onClick: onClick,
        label: formatMessage((0, $gGI3m.default).settingsButtonLabel),
        appearance: "default"
    });
    return (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $gGI3m.default).settingsButton)
    }, (0, $4R6GH.fg)('setting_button_refresh') ? themedButton : oldThemedButton) : oldThemedButton;
});
var $2c59696bb775620b$export$2e2bcd8739ae039 = $2c59696bb775620b$var$Trigger;

});
parcelRegister("gGI3m", function(module, exports) {

$parcel$export(module.exports, "default", () => $85a34ec1433aa56b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $85a34ec1433aa56b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    settingsButton: {
        "id": "business-setting-menu.setting-menu.setting-menu-core.trigger.setting-button",
        "defaultMessage": "View settings"
    },
    settingsButtonLabel: {
        "id": "business-setting-menu.setting-menu.setting-menu-core.trigger.setting-button-label",
        "defaultMessage": "Settings actions on the view options"
    }
});

});



parcelRegister("2zLnM", function(module, exports) {

let $1e039adac5943717$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1e039adac5943717$var$load("7fFrc").then(()=>parcelRequire('3bfOh'));

});


parcelRegister("5GqLe", function(module, exports) {

$parcel$export(module.exports, "integrationTypes", () => $0970fea694a8095f$export$a7359bcfb0ca8e98);
const $0970fea694a8095f$export$a7359bcfb0ca8e98 = {
    BENTO_ISSUE: 'bentoIssue',
    CLASSIC_BOARD: 'classicBoard',
    NEXTGEN_BOARD: 'nextGenBoard',
    ROADMAP: 'roadmap',
    TIMELINE: 'timeline',
    LIST: 'list',
    CALENDAR: 'calendar',
    BOARD: 'board',
    FORM: 'form',
    SUMMARY: 'summary',
    ATTACHMENTS: 'attachments',
    DEPENDENCIES: 'dependencies',
    INCREMENT: 'increment',
    QUEUE: 'queue'
};

});

parcelRegister("73w1P", function(module, exports) {

$parcel$export(module.exports, "FilterDropdownListNudgeAsync", () => $daf5d2329291861d$export$7d038d6ad1823996);

var $5uXOq = parcelRequire("5uXOq");

var $9dZ1c = parcelRequire("9dZ1c");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");


var $2zvUh = parcelRequire("2zvUh");
const $daf5d2329291861d$var$runtimeProps = {};
const $daf5d2329291861d$var$entryPointParams = {};
const $daf5d2329291861d$export$7d038d6ad1823996 = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $2zvUh.filterDropdownNudgeEntrypoint), $daf5d2329291861d$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    const { ref: filterDropdownNudgeRef } = (0, $9dZ1c.useRegisterNudgeTarget)((0, $dbbf68c32d8c4308$export$5908fa8acd2c0739), true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: filterDropdownNudgeRef
    }, props.children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: (0, $dbbf68c32d8c4308$export$501e36925fa10eef),
        packageName: "jiraListOnboarding",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
        runtimeProps: $daf5d2329291861d$var$runtimeProps
    }));
};

});
parcelRegister("2zvUh", function(module, exports) {

$parcel$export(module.exports, "filterDropdownNudgeEntrypoint", () => $521e74bd60ef2f2c$export$5cbb00667240a7df);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $521e74bd60ef2f2c$export$5cbb00667240a7df = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("kIkrU")), {
        moduleId: "202abeae"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("kIkrU", function(module, exports) {

let $f147c7777fa1adf4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f147c7777fa1adf4$var$load("iEcMH").then(()=>parcelRequire('2r6KU'));

});



parcelRegister("aSUiK", function(module, exports) {

$parcel$export(module.exports, "MoreDropdownListNudgeAsync", () => $c87a83e41839d810$export$49ce8a5fd7f1f225);

var $5uXOq = parcelRequire("5uXOq");

var $9dZ1c = parcelRequire("9dZ1c");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");


var $196vF = parcelRequire("196vF");
const $c87a83e41839d810$var$runtimeProps = {};
const $c87a83e41839d810$var$entryPointParams = {};
const $c87a83e41839d810$export$49ce8a5fd7f1f225 = ({ children: children })=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $196vF.moreDropdownNudgeEntrypoint), $c87a83e41839d810$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    const { ref: filterDropdownNudgeRef } = (0, $9dZ1c.useRegisterNudgeTarget)((0, $dbbf68c32d8c4308$export$50192b0fdc9bdacf), true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: filterDropdownNudgeRef
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: (0, $dbbf68c32d8c4308$export$501e36925fa10eef),
        packageName: "jiraListOnboarding",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
        runtimeProps: $c87a83e41839d810$var$runtimeProps
    }));
};

});
parcelRegister("196vF", function(module, exports) {

$parcel$export(module.exports, "moreDropdownNudgeEntrypoint", () => $bc9dc0fefc252a4a$export$32cd09a154d643d4);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $bc9dc0fefc252a4a$export$32cd09a154d643d4 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("3a3hJ")), {
        moduleId: "2bbbd889"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("3a3hJ", function(module, exports) {

let $24d4da9f2b149b15$var$load = (parcelRequire("28QjX"))(4);
module.exports = $24d4da9f2b149b15$var$load("kSEQn").then(()=>parcelRequire('f9SRM'));

});



parcelRegister("kALEJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d85a15e1832e2433$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jgJNO = parcelRequire("jgJNO");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");


var $g42u8 = parcelRequire("g42u8");

var $gIddQ = parcelRequire("gIddQ");
const $d85a15e1832e2433$var$GroupByDropdown = ()=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const close = (0, $5uXOq.useCallback)(()=>setIsOpen(false), []);
    const toggle = (0, $5uXOq.useCallback)(()=>setIsOpen((wasOpen)=>!wasOpen), []);
    const content = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d85a15e1832e2433$export$5f7211d21bfdae05, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g42u8.default), {
            popupWidth: (0, $59c3baa05de8fae5$export$8c68b096b2d5e9f6),
            onToggle: toggle
        })), [
        toggle
    ]);
    const trigger = (0, $5uXOq.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gIddQ.default), {
            ...triggerProps,
            isSelected: isOpen,
            onClick: ()=>{
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'groupByDropdown');
                toggle();
            }
        }), [
        createAnalyticsEvent,
        isOpen,
        toggle
    ]);
    const triggerOld = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter 'triggerProps' implicitly has an 'any' type.
    (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gIddQ.default), {
            ...triggerProps,
            isSelected: isOpen,
            onClick: ()=>{
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'groupByDropdown');
                toggle();
            }
        }), [
        createAnalyticsEvent,
        isOpen,
        toggle
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isOpen,
        onClose: close,
        placement: "bottom-end",
        messageId: "business-list.ui.list-view.header-actions.group-by-dropdown.popup",
        messageType: "transactional",
        content: content,
        trigger: (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh-headers-buttons') ? trigger : triggerOld
    });
};
var // eslint-disable-next-line @typescript-eslint/no-explicit-any
$d85a15e1832e2433$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($d85a15e1832e2433$var$GroupByDropdown);
const $d85a15e1832e2433$export$5f7211d21bfdae05 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ul9uuw1",
            __cmplp.className
        ])
    });
});

});
const $59c3baa05de8fae5$export$8c68b096b2d5e9f6 = 200;

parcelRegister("g42u8", function(module, exports) {

$parcel$export(module.exports, "default", () => $d84f5f6445ec8919$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2h2vc = parcelRequire("2h2vc");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d84f5f6445ec8919$var$GroupByDropdownOptions = (0, $kxZPA.lazy)(()=>(parcelRequire("9gE7f")), {
    ssr: false,
    moduleId: "./src/packages/business/list/src/ui/list-view/header-actions/group-by-dropdown/dropdown-options/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d84f5f6445ec8919$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "group-by-dropdown-options",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2h2vc.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d84f5f6445ec8919$var$GroupByDropdownOptions, props));

});
parcelRegister("9gE7f", function(module, exports) {

let $6bf4b9d873f8e461$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6bf4b9d873f8e461$var$load("8QcUq").then(()=>parcelRequire('b8GXi'));

});


parcelRegister("gIddQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b13f2bfafbce69f7$export$2e2bcd8739ae039);
/* eslint-disable no-nested-ternary */ 
var $5uXOq = parcelRequire("5uXOq");

var $hRkFS = parcelRequire("hRkFS");

var $hORKG = parcelRequire("hORKG");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $22OQR = parcelRequire("22OQR");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

var $fc0Dc = parcelRequire("fc0Dc");

var $8e3Yw = parcelRequire("8e3Yw");

var $7j7Ki = parcelRequire("7j7Ki");
const $b13f2bfafbce69f7$var$GROUP_ICON = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hRkFS))), {
    label: "",
    LEGACY_size: "small"
});
const $b13f2bfafbce69f7$var$Trigger = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ onClick: onClick, isSelected: isSelected, ...otherProps }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [groupByFieldId] = (0, $8e3Yw.useGroupBy)();
    const groupByField = (0, $fc0Dc.useGetGroupByField)();
    const groupByButtonText = formatMessage((0, $7j7Ki.default).groupByButton);
    const selectedGroupButtonText = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $7j7Ki.default).groupByActiveButton,
        values: {
            groupByFieldId: groupByField?.name
        }
    });
    if ((0, $dCm1o.isVisualRefreshEnabled)()) {
        const visuallyRefreshedContent = (0, $4R6GH.fg)('visual-refresh-headers-buttons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, groupByFieldId == null ? isSelected ? groupByButtonText : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $b13f2bfafbce69f7$var$triggerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            color: "color.text.subtle",
            weight: "medium",
            maxLines: 1
        }, groupByButtonText)) : selectedGroupButtonText) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, groupByFieldId == null ? groupByButtonText : selectedGroupButtonText);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $22OQR.ThemedButton), {
            ref: ref,
            "aria-label": formatMessage((0, $7j7Ki.default).groupByActiveButtonAriaLabel, {
                label: groupByField?.name
            }),
            testId: "business-list.ui.list-view.header-actions.group-by-dropdown.trigger.button-wrapper",
            isSelected: isSelected || groupByFieldId != null,
            onClick: onClick,
            iconAfter: groupByFieldId == null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hORKG))), {
                label: "",
                ...!isSelected && (0, $4R6GH.fg)('visual-refresh-headers-buttons') && {
                    color: "var(--ds-icon-subtle, #626F86)"
                },
                ...!(0, $4R6GH.fg)('visual-refresh-headers-buttons') && {
                    color: 'currentColor'
                }
            }) : undefined,
            ...otherProps
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            as: "span",
            columnGap: "space.075",
            alignItems: "center"
        }, visuallyRefreshedContent));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $22OQR.ThemedButton), {
        ref: ref,
        testId: "business-list.ui.list-view.header-actions.group-by-dropdown.trigger.button-wrapper",
        iconBefore: $b13f2bfafbce69f7$var$GROUP_ICON,
        isSelected: isSelected,
        onClick: onClick,
        appearance: "subtle",
        ...otherProps
    }, groupByFieldId == null ? groupByButtonText : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $7j7Ki.default).groupByActiveButtonOld,
        values: {
            groupByFieldId: groupByField?.name
        }
    }));
});
var $b13f2bfafbce69f7$export$2e2bcd8739ae039 = $b13f2bfafbce69f7$var$Trigger;
const $b13f2bfafbce69f7$var$triggerStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.075',
    paddingBottom: 'space.075',
    pointerEvents: 'none'
});

});
parcelRegister("hRkFS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3c013b1e05bf2dafdcad36de91a04a78>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d0076c6993b9840f$var$_react = $d0076c6993b9840f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d0076c6993b9840f$var$_menu = $d0076c6993b9840f$var$_interopRequireDefault((parcelRequire("fYy29")));

var $d0076c6993b9840f$var$_menuExpand = $d0076c6993b9840f$var$_interopRequireDefault((parcelRequire("aLbwz")));
function $d0076c6993b9840f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for MenuIcon.
 * This component is MenuIcon, with `UNSAFE_fallbackIcon` set to "MenuExpandIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for accessing the menu in global product navigation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d0076c6993b9840f$var$MenuIcon = (props)=>/*#__PURE__*/ $d0076c6993b9840f$var$_react.default.createElement($d0076c6993b9840f$var$_menu.default, Object.assign({
        LEGACY_fallbackIcon: $d0076c6993b9840f$var$_menuExpand.default
    }, props));
$d0076c6993b9840f$var$MenuIcon.Name = 'MenuIconMigration';
var $d0076c6993b9840f$var$_default = module.exports.default = $d0076c6993b9840f$var$MenuIcon;

});
parcelRegister("fYy29", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ecb53df8812f428ed0814030a719aff1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ba16dbfa24557687$var$_react = $ba16dbfa24557687$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ba16dbfa24557687$var$_baseNew = $ba16dbfa24557687$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $ba16dbfa24557687$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Menu".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for accessing the menu in global product navigation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ba16dbfa24557687$var$MenuIcon = (props)=>/*#__PURE__*/ $ba16dbfa24557687$var$_react.default.createElement($ba16dbfa24557687$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm0 5.25H1v-1.5h14zM15 14H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$ba16dbfa24557687$var$MenuIcon.displayName = 'MenuIcon';
var $ba16dbfa24557687$var$_default = module.exports.default = $ba16dbfa24557687$var$MenuIcon;

});

parcelRegister("aLbwz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7d573baeaf377068$var$_react = $7d573baeaf377068$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $7d573baeaf377068$var$_menu = $7d573baeaf377068$var$_interopRequireDefault((parcelRequire("fYy29")));
function $7d573baeaf377068$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7d573baeaf377068$var$MenuExpandIcon = (props)=>/*#__PURE__*/ $7d573baeaf377068$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6 12c0-.552.456-1 1.002-1h9.996a.999.999 0 1 1 0 2H7.002A1 1 0 0 1 6 12m0 4c0-.552.456-1 1.002-1h9.996a.999.999 0 1 1 0 2H7.002A1 1 0 0 1 6 16m0-8c0-.552.456-1 1.002-1h9.996a.999.999 0 1 1 0 2H7.002A1 1 0 0 1 6 8"/></svg>`
    }, props, {
        newIcon: $7d573baeaf377068$var$_menu.default
    }));
$7d573baeaf377068$var$MenuExpandIcon.displayName = 'MenuExpandIcon';
var $7d573baeaf377068$var$_default = module.exports.default = $7d573baeaf377068$var$MenuExpandIcon;

});


parcelRegister("7j7Ki", function(module, exports) {

$parcel$export(module.exports, "default", () => $86a89e86f49ce18c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $86a89e86f49ce18c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    groupByButton: {
        "id": "business-list.list-view.header-actions.group-by-dropdown.trigger.group-by-button",
        "defaultMessage": "Group"
    },
    groupByActiveButtonAriaLabel: {
        "id": "business-list.list-view.header-actions.group-by-dropdown.trigger.group-by-active-button-aria-label",
        "defaultMessage": "Group by {label}"
    },
    groupByActiveButtonOld: {
        "id": "business-list.list-view.header-actions.group-by-dropdown.trigger.group-by-active-button-old",
        "defaultMessage": "Group by: {groupByFieldId}"
    },
    groupByActiveButton: {
        "id": "business-list.list-view.header-actions.group-by-dropdown.trigger.group-by-active-button",
        "defaultMessage": "Group: {groupByFieldId}"
    },
    groupByAssignee: {
        "id": "business-list.list-view.header-actions.group-by-dropdown.trigger.group-by-assignee",
        "defaultMessage": "Assignee"
    },
    groupByStatus: {
        "id": "business-list.list-view.header-actions.group-by-dropdown.trigger.group-by-status",
        "defaultMessage": "Status"
    },
    groupByPriority: {
        "id": "business-list.list-view.header-actions.group-by-dropdown.trigger.group-by-priority",
        "defaultMessage": "Priority"
    },
    groupByCategory: {
        "id": "business-list.list-view.header-actions.group-by-dropdown.trigger.group-by-category",
        "defaultMessage": "Category"
    },
    groupByStoryPoints: {
        "id": "business-list.list-view.header-actions.group-by-dropdown.trigger.group-by-story-points",
        "defaultMessage": "Story points"
    },
    groupByStoryPointEstimate: {
        "id": "business-list.list-view.header-actions.group-by-dropdown.trigger.group-by-story-point-estimate",
        "defaultMessage": "Story point estimate"
    }
});

});



parcelRegister("9WaRX", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9bdd1cdbd6448dd$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $imZsD = parcelRequire("imZsD");
var $k6T4f = parcelRequire("k6T4f");
var $5Fk4Z = parcelRequire("5Fk4Z");

var $egmQO = parcelRequire("egmQO");

var $cts5j = parcelRequire("cts5j");

var $jDUax = parcelRequire("jDUax");

var $ioD1B = parcelRequire("ioD1B");

var $eGLgs = parcelRequire("eGLgs");

var $koeKL = parcelRequire("koeKL");

var $8TUlY = parcelRequire("8TUlY");

var $aQbWi = parcelRequire("aQbWi");

var $eg2To = parcelRequire("eg2To");
const $c9bdd1cdbd6448dd$var$ONBOARDING_ENGAGEMENT_ID = 'issue-field-statistics-button-m2';
const $c9bdd1cdbd6448dd$var$STARGATE_URL = '/gateway/api';
const $c9bdd1cdbd6448dd$var$IssueFieldStatisticsButtonWithPulse = ({ displayMenuButton: displayMenuButton })=>{
    const { getVisibleFields: getVisibleFields } = (0, $8TUlY.useIssueFields)();
    const cloudId = (0, $koeKL.useCloudId)();
    const [{ rankParentIssueId: rankParentIssueId }] = (0, $aQbWi.useRankParent)();
    const [showPulse, setShowPulse] = (0, $5uXOq.useState)(true);
    const [isMessageActive, setIsMessageActive] = (0, $5uXOq.useState)(undefined);
    const coordinationClient = (0, $5uXOq.useMemo)(()=>new (0, $eGLgs.CoordinationClient)(cloudId, $c9bdd1cdbd6448dd$var$STARGATE_URL, false, '', 'engagement'), [
        cloudId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        coordinationClient.start($c9bdd1cdbd6448dd$var$ONBOARDING_ENGAGEMENT_ID).then(setIsMessageActive);
    }, [
        coordinationClient
    ]);
    const { hierarchyLevel: hierarchyLevel, ...input } = (0, $eg2To.useIssuesInput)({
        groupIssueId: (0, $jDUax.isGroupItem)(rankParentIssueId) ? rankParentIssueId : undefined,
        parentIssueId: !(0, $jDUax.isGroupItem)(rankParentIssueId) ? rankParentIssueId : undefined
    });
    const generateJqlInput = {
        ...input,
        // When hierarchyParent is undefined, we force flat list behaviour and calculate the jql to include all child issues
        hierarchyParent: undefined
    };
    const handlePulseStop = ()=>{
        if (showPulse) {
            coordinationClient.stop?.($c9bdd1cdbd6448dd$var$ONBOARDING_ENGAGEMENT_ID);
            setShowPulse(false);
        }
    };
    const jql = (0, $egmQO.generateJql)(generateJqlInput, input.parentIssue);
    if (displayMenuButton) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cts5j.IssueFieldStatisticsButton), {
        visibleFields: getVisibleFields(),
        jql: jql,
        displayMenuButton: true
    });
    return isMessageActive && showPulse ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ioD1B.ChoreographerContextProvider), {
        isChoreographed: coordinationClient.enableChoreographer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: "issue-field-statistics-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k6T4f.Pulse), {
        radius: 3,
        pulse: showPulse
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cts5j.IssueFieldStatisticsButton), {
        visibleFields: getVisibleFields(),
        jql: jql,
        stopPulse: handlePulseStop
    }))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cts5j.IssueFieldStatisticsButton), {
        visibleFields: getVisibleFields(),
        jql: jql
    });
};
var $c9bdd1cdbd6448dd$export$2e2bcd8739ae039 = $c9bdd1cdbd6448dd$var$IssueFieldStatisticsButtonWithPulse;

});
parcelRegister("cts5j", function(module, exports) {

$parcel$export(module.exports, "IssueFieldStatisticsButton", () => $94460d2495d86cc9$export$38cc32afd1948a0a);

var $5uXOq = parcelRequire("5uXOq");

var $1LvsK = parcelRequire("1LvsK");

var $3bDjY = parcelRequire("3bDjY");

var $kJpBP = parcelRequire("kJpBP");

var $bUSNl = parcelRequire("bUSNl");

var $7CMCs = parcelRequire("7CMCs");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $22OQR = parcelRequire("22OQR");

var $dCm1o = parcelRequire("dCm1o");

var $ieDtd = parcelRequire("ieDtd");

var $4R6GH = parcelRequire("4R6GH");

var $i90eS = parcelRequire("i90eS");

var $vH6UY = parcelRequire("vH6UY");

var $5ea6B = parcelRequire("5ea6B");
const $94460d2495d86cc9$export$154de29b24345e19 = 'issueFieldStatisticsSidebar';
const $94460d2495d86cc9$export$38cc32afd1948a0a = ({ displayMenuButton: displayMenuButton, jql: jql, visibleFields: visibleFields, stopPulse: stopPulse })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    const [{ content: content }, { setSidebarContent: setSidebarContent, closeSidebar: closeSidebar }] = (0, $bUSNl.useSidebar)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const selectableFields = (0, $5uXOq.useMemo)(()=>(0, $5ea6B.filterStatisticFields)(visibleFields), [
        visibleFields
    ]);
    const [sidebar] = (0, $ieDtd.useQueryParam)('sidebar');
    // detects whether the statistics sidebar is rendered, based on the content rendered within the sidebar
    const isStatisticsSidebarOpen = (0, $5uXOq.useMemo)(()=>content?.key === $94460d2495d86cc9$export$154de29b24345e19, [
        content
    ]);
    const onCloseSidebar = (0, $5uXOq.useCallback)(()=>{
        closeSidebar();
    }, [
        closeSidebar
    ]);
    const onError = (0, $5uXOq.useCallback)(()=>{
        const flagId = showFlag({
            type: 'error',
            title: formatMessage((0, $i90eS.default).errorFlagTitle),
            description: formatMessage((0, $i90eS.default).errorFlagDescription),
            messageId: 'business-issue-field-statistics.ui.show-flag.error',
            messageType: 'transactional',
            actions: [
                {
                    content: formatMessage((0, $i90eS.default).errorFlagContactSupportActionText),
                    href: 'https://support.atlassian.com/contact',
                    target: '_blank',
                    onClick: ()=>flagId && dismissFlag(flagId)
                }
            ]
        });
        onCloseSidebar();
    }, [
        onCloseSidebar,
        showFlag,
        dismissFlag,
        formatMessage
    ]);
    const renderStatisticsSidebar = (0, $5uXOq.useCallback)(()=>{
        setSidebarContent(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
            key: $94460d2495d86cc9$export$154de29b24345e19,
            id: "sidebarContent",
            packageName: "jiraBusinessIssueFieldStatistics",
            teamName: "helios-reports",
            onError: onError
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $vH6UY.StatisticsSidebar), {
            selectableFields: selectableFields,
            jql: jql,
            onClose: onCloseSidebar
        })));
    }, [
        onError,
        selectableFields,
        jql,
        onCloseSidebar,
        setSidebarContent
    ]);
    const hasAutoOpened = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (!hasAutoOpened.current && sidebar === 'statistics' && !isStatisticsSidebarOpen) {
            hasAutoOpened.current = true;
            renderStatisticsSidebar();
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'jira.issueFieldStatistics.openedSharedLink');
        }
    }, [
        createAnalyticsEvent,
        sidebar,
        isStatisticsSidebarOpen,
        renderStatisticsSidebar
    ]);
    const onClick = (_, analyticsEvent)=>{
        if (stopPulse) stopPulse();
        if (!isStatisticsSidebarOpen) {
            renderStatisticsSidebar();
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'openIssueFieldStatistics');
        } else closeSidebar();
    };
    const onMenuClick = (0, $5uXOq.useCallback)(()=>{
        if (stopPulse) stopPulse();
        if (!isStatisticsSidebarOpen) {
            renderStatisticsSidebar();
            if ((0, $4R6GH.fg)('fix_list_view_chart_analytic_event')) (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            }), 'openIssueFieldStatistics');
            else (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'openIssueFieldStatistics');
        } else closeSidebar();
    }, [
        stopPulse,
        isStatisticsSidebarOpen,
        renderStatisticsSidebar,
        createAnalyticsEvent,
        closeSidebar
    ]);
    if (displayMenuButton) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        key: "issueFieldStatisticsMe",
        interactionName: "openIssueFieldStatistics",
        onClick: onMenuClick,
        isSelected: isStatisticsSidebarOpen,
        "aria-label": formatMessage((0, $i90eS.default).tooltip),
        testId: "business-issue-field-statistics.ui.themed-button"
    }, formatMessage((0, $i90eS.default).tooltip));
    const themedButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $22OQR.ThemedButton), {
        onClick: onClick,
        iconBefore: (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1LvsK))), {
            label: "",
            spacing: "spacious",
            color: "currentColor"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1LvsK))), {
            label: "",
            color: "currentColor"
        }),
        isSelected: isStatisticsSidebarOpen,
        "aria-label": (0, $dCm1o.isVisualRefreshEnabled)() ? formatMessage((0, $i90eS.default).tooltip) : undefined,
        appearance: (0, $dCm1o.isVisualRefreshEnabled)() ? 'default' : 'subtle',
        label: formatMessage((0, $i90eS.default).tooltip),
        title: (0, $dCm1o.isVisualRefreshEnabled)() ? undefined : formatMessage((0, $i90eS.default).tooltip)
    }, !(0, $dCm1o.isVisualRefreshEnabled)() && formatMessage((0, $i90eS.default).chartButtonLabel));
    return (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $i90eS.default).tooltip)
    }, themedButton) : themedButton;
};

});
parcelRegister("1LvsK", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8096ab3afa55147abbaed70d63c1ae23>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1492960aa1cfc9ed$var$_react = $1492960aa1cfc9ed$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $1492960aa1cfc9ed$var$_baseNew = $1492960aa1cfc9ed$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $1492960aa1cfc9ed$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartPie".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: pie charts.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1492960aa1cfc9ed$var$ChartPieIcon = (props)=>/*#__PURE__*/ $1492960aa1cfc9ed$var$_react.default.createElement($1492960aa1cfc9ed$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 1.543a6.501 6.501 0 1 0 7.207 7.207H8A.75.75 0 0 1 7.25 8zM0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8" clip-rule="evenodd"/>`
    }, props));
$1492960aa1cfc9ed$var$ChartPieIcon.displayName = 'ChartPieIcon';
var $1492960aa1cfc9ed$var$_default = module.exports.default = $1492960aa1cfc9ed$var$ChartPieIcon;

});

parcelRegister("i90eS", function(module, exports) {

$parcel$export(module.exports, "default", () => $7220fa4608b58393$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7220fa4608b58393$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    tooltip: {
        "id": "business-issue-field-statistics.tooltip",
        "defaultMessage": "View as chart"
    },
    errorFlagTitle: {
        "id": "business-issue-field-statistics.error-flag-title-non-final",
        "defaultMessage": "Something went wrong"
    },
    errorFlagDescription: {
        "id": "business-issue-field-statistics.error-flag-description-non-final",
        "defaultMessage": "We couldn't open the chart. Please try again or contact support."
    },
    errorFlagContactSupportActionText: {
        "id": "business-issue-field-statistics.error-flag-contact-support-action-text-non-final",
        "defaultMessage": "Contact support"
    },
    chartButtonLabel: {
        "id": "business-issue-field-statistics.chart-button-label",
        "defaultMessage": "Chart"
    }
});

});

parcelRegister("vH6UY", function(module, exports) {

$parcel$export(module.exports, "StatisticsSidebar", () => $902c52eaf170b1c9$export$20b212fbbfc9cea2);

var $5uXOq = parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $2x3Cb = parcelRequire("2x3Cb");

var $l1N8i = parcelRequire("l1N8i");

var $84THj = parcelRequire("84THj");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $7K5PP = parcelRequire("7K5PP");

var $koVbs = parcelRequire("koVbs");

var $bFZ3A = parcelRequire("bFZ3A");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $cCFkQ = parcelRequire("cCFkQ");

var $kfbSl = parcelRequire("kfbSl");

var $j6shD = parcelRequire("j6shD");

var $lo35h = parcelRequire("lo35h");

var $2yN2c = parcelRequire("2yN2c");

var $CVuCA = parcelRequire("CVuCA");

var $9QPGZ = parcelRequire("9QPGZ");

var $9WcDz = parcelRequire("9WcDz");
const $902c52eaf170b1c9$export$20b212fbbfc9cea2 = ({ selectableFields: selectableFields, jql: jql, onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [selectedFieldId, setSelectedFieldId] = (0, $lo35h.useStatisticsStorage)((0, $cCFkQ.SELECTED_FIELD_ID_KEY));
    const [initialChartType = (0, $bFZ3A.DEFAULT_CHART_TYPE), setSelectedChartType] = (0, $lo35h.useStatisticsStorage)((0, $cCFkQ.SELECTED_CHART_TYPE_KEY));
    const [, setParams] = (0, $j6shD.useQueryParams)();
    const selectedField = selectableFields.find((field)=>field.id === selectedFieldId);
    // only include chart type if it is actually visible (important for share button)
    const selectedChartType = (0, $kfbSl.isShowingChartTypeSelect)(selectedField) ? initialChartType : undefined;
    const selectFieldValue = selectedField ? {
        label: selectedField.name,
        value: selectedField.id
    } : null;
    const selectFieldOptions = selectableFields.map((field)=>({
            label: field.name,
            value: field.id
        }));
    (0, $5uXOq.useEffect)(()=>{
        const startTime = Date.now();
        return ()=>{
            const endTime = Date.now();
            const duration = endTime - startTime;
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'issueFieldStatisticsSidebar open', {
                duration: duration
            });
        };
    }, [
        createAnalyticsEvent
    ]);
    // Remove sidebar and selected field id from query params when the component unmounts
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            setParams((0, $cCFkQ.CLEAR_ALL_QUERY_PARAMS), 'replace');
        };
    }, [
        setParams
    ]);
    const onSelectField = (option)=>{
        if (!option) setSelectedFieldId(undefined);
        else setSelectedFieldId(option.value);
        // clear any query string params when the field is changed
        setParams((0, $cCFkQ.CLEAR_ALL_QUERY_PARAMS), 'replace');
    };
    const onChartTypeChange = (chartType)=>{
        setSelectedChartType(chartType);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'radio changed', 'jira.issueFieldStatistics.sidebarChart', {
            chartType: chartType
        });
        // clear any query string params when the field is changed
        setParams((0, $cCFkQ.CLEAR_ALL_QUERY_PARAMS), 'replace');
    };
    /*
   * Extra div wrapper required
   * refer https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/jira/src/packages/business/shared/components/app-wrapper/src/ui/app-wrapper/sidebar-layout/styled.tsx#23
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $902c52eaf170b1c9$var$sidebarWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        justifyContent: "space-between",
        alignItems: "center",
        xcss: $902c52eaf170b1c9$var$headingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "medium"
    }, formatMessage((0, $CVuCA.default).heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9QPGZ.ShareButton), {
        selectedField: selectedField,
        selectedChartType: selectedChartType
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($84THj))),
        label: formatMessage((0, $CVuCA.default).close),
        isTooltipDisabled: false,
        onClick: (_, analyticsEvent)=>{
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'closeIssueFieldStatistics');
            onClose();
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.250",
        xcss: $902c52eaf170b1c9$var$mainContentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $CVuCA.default).info)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2x3Cb.Label), {
        htmlFor: "issue-field-statistics-single-select"
    }, formatMessage((0, $CVuCA.default).selectLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        value: selectFieldValue,
        onChange: onSelectField,
        inputId: "issue-field-statistics-single-select",
        options: selectFieldOptions
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9WcDz.StatisticsRenderer), {
        selectedFieldId: selectedFieldId,
        selectedField: selectedField,
        selectedChartType: selectedChartType,
        onChartTypeChange: onChartTypeChange,
        jql: jql
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $902c52eaf170b1c9$var$feedbackButtonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2yN2c.FeedbackButton), null))));
};
const $902c52eaf170b1c9$var$sidebarWrapperStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    paddingInline: 'space.250',
    paddingBlock: 'space.200'
});
const $902c52eaf170b1c9$var$mainContentStyles = (0, $8CUq3.xcss)({
    flexGrow: 1,
    justifyContent: 'flex-start'
});
const $902c52eaf170b1c9$var$headingStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.150'
});
const $902c52eaf170b1c9$var$feedbackButtonWrapperStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    justifyContent: 'flex-start',
    paddingBlock: 'space.100'
});

});
parcelRegister("bFZ3A", function(module, exports) {

$parcel$export(module.exports, "FIELD_LIMIT", () => $7fc5870762fb0097$export$9acb02e1367cd538);
$parcel$export(module.exports, "SingleSelectChart", () => $7fc5870762fb0097$export$3fc279be866fb37e);
$parcel$export(module.exports, "DEFAULT_CHART_TYPE", () => $7fc5870762fb0097$export$dd93950eefb60f52);
$parcel$export(module.exports, "SingleSelectChartList", () => $7fc5870762fb0097$export$af312ecb25572fdf);
// this limit does not include the "other" slice
const $7fc5870762fb0097$export$9acb02e1367cd538 = 7;
const $7fc5870762fb0097$export$3fc279be866fb37e = {
    HORIZONTAL_BAR: 'horizontalBar',
    DONUT: 'donut'
};
const $7fc5870762fb0097$export$dd93950eefb60f52 = $7fc5870762fb0097$export$3fc279be866fb37e.DONUT;
const $7fc5870762fb0097$export$af312ecb25572fdf = Object.values($7fc5870762fb0097$export$3fc279be866fb37e);

});

parcelRegister("cCFkQ", function(module, exports) {

$parcel$export(module.exports, "SIDEBAR_NAME", () => $b3b7fd06c839fba8$export$6d9ce65a72493aac);
$parcel$export(module.exports, "SELECTED_FIELD_ID_KEY", () => $b3b7fd06c839fba8$export$b229a6bf782d77e7);
$parcel$export(module.exports, "SELECTED_CHART_TYPE_KEY", () => $b3b7fd06c839fba8$export$c4ec2849fcb32515);
$parcel$export(module.exports, "SELECTED_FIELD_ID_QUERY_KEY", () => $b3b7fd06c839fba8$export$70a91e824238865d);
$parcel$export(module.exports, "SELECTED_CHART_TYPE_QUERY_KEY", () => $b3b7fd06c839fba8$export$60179bff81db3578);
$parcel$export(module.exports, "CLEAR_ALL_QUERY_PARAMS", () => $b3b7fd06c839fba8$export$1816113812ed602d);

var $e4eHl = parcelRequire("e4eHl");
const $b3b7fd06c839fba8$export$6d9ce65a72493aac = 'statistics';
const $b3b7fd06c839fba8$var$AUTO_OPEN_SIDEBAR_KEY = 'sidebar';
const $b3b7fd06c839fba8$export$b229a6bf782d77e7 = 'statistics-field';
const $b3b7fd06c839fba8$export$c4ec2849fcb32515 = 'statistics-chart';
const $b3b7fd06c839fba8$export$70a91e824238865d = (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))($b3b7fd06c839fba8$export$b229a6bf782d77e7);
const $b3b7fd06c839fba8$export$60179bff81db3578 = (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))($b3b7fd06c839fba8$export$c4ec2849fcb32515);
const $b3b7fd06c839fba8$export$1816113812ed602d = Object.freeze({
    [$b3b7fd06c839fba8$var$AUTO_OPEN_SIDEBAR_KEY]: undefined,
    [$b3b7fd06c839fba8$export$70a91e824238865d]: undefined,
    [$b3b7fd06c839fba8$export$60179bff81db3578]: undefined
});

});

parcelRegister("kfbSl", function(module, exports) {

$parcel$export(module.exports, "getVisualRepresentation", () => $3559af72d0c65d1a$export$58b4997ec8750db5);
$parcel$export(module.exports, "isShowingChartTypeSelect", () => $3559af72d0c65d1a$export$9e355f4370f818f8);
const $3559af72d0c65d1a$export$58b4997ec8750db5 = (selectedField)=>{
    if (selectedField === undefined) return 'NONE';
    switch(selectedField?.__typename){
        case 'JiraNumberField':
            return 'STATISTICS_TABLE';
        default:
            return 'SINGLE_SELECT_CHART';
    }
};
const $3559af72d0c65d1a$export$9e355f4370f818f8 = (selectedField)=>{
    return $3559af72d0c65d1a$export$58b4997ec8750db5(selectedField) === 'SINGLE_SELECT_CHART';
};

});

parcelRegister("j6shD", function(module, exports) {

$parcel$export(module.exports, "useQueryParams", () => $29baf9ca76d383e1$export$b37ee0d76c6d2fbc);

var $lODMY = parcelRequire("lODMY");
const $29baf9ca76d383e1$var$useQuery = (0, $lODMY.createRouterSelector)((o)=>o.query);
const $29baf9ca76d383e1$export$b37ee0d76c6d2fbc = ()=>{
    const routerStoreActions = (0, $lODMY.useRouterStoreActions)();
    const query = $29baf9ca76d383e1$var$useQuery();
    return [
        query,
        routerStoreActions.updateQueryParam
    ];
};

});

parcelRegister("lo35h", function(module, exports) {

$parcel$export(module.exports, "useStatisticsStorage", () => $f9065a10e234aa7b$export$a13d038d4f793f75);

var $5uXOq = parcelRequire("5uXOq");

var $e4eHl = parcelRequire("e4eHl");

var $54qG5 = parcelRequire("54qG5");

var $47u1P = parcelRequire("47u1P");

var $90yGq = parcelRequire("90yGq");

var $ieDtd = parcelRequire("ieDtd");

var $cDCY0 = parcelRequire("cDCY0");

var $1vKDd = parcelRequire("1vKDd");
const $f9065a10e234aa7b$export$a13d038d4f793f75 = (namespace)=>{
    const accountId = (0, $90yGq.useAccountId)();
    const { data: entity } = (0, $54qG5.useBusinessEntity)();
    if ((0, $cDCY0.isKebabCase)(namespace) === false) throw new Error('localStorageNamespace must be in kebab-case');
    const queryParamNamespace = (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(namespace);
    // read from query string
    const [queryValue] = (0, $ieDtd.useQueryParam)(queryParamNamespace);
    const [initialQueryValue, setInitialQueryValue] = (0, $5uXOq.useState)(queryValue);
    // read from local storage
    const [localValue, setLocalValue] = (0, $47u1P.useLocalStorageWithExpiry)(`${(0, $1vKDd.NAMESPACE_PREFIX)}-${namespace}`, `${accountId}-${entity.id}`, (0, $1vKDd.DAY_IN_MS) * 30);
    /*
	 * If query string value is present AND is different from local storage value, update local storage

	 * Note: Because the query string update lags behind, we need to use a ref to ensure
	 * when selectedFieldId is changed in the UI it doesn't immediately revert back to
	 * the previous value, because the query string update lags behind
	 */ (0, $5uXOq.useEffect)(()=>{
        if (initialQueryValue) {
            setLocalValue(initialQueryValue);
            setInitialQueryValue(undefined);
        }
    }, [
        initialQueryValue,
        setLocalValue
    ]);
    return [
        initialQueryValue ?? localValue,
        setLocalValue
    ];
};

});
parcelRegister("47u1P", function(module, exports) {

$parcel$export(module.exports, "useLocalStorage", () => $4772a73a96e71e67$export$86e2cef2561044ac);
$parcel$export(module.exports, "useLocalStorageWithExpiry", () => $4772a73a96e71e67$export$9c89ac8256e92fbb);

var $5uXOq = parcelRequire("5uXOq");

var $bSSG7 = parcelRequire("bSSG7");
const $4772a73a96e71e67$var$isSetStateFunction = (setStateAction)=>typeof setStateAction === 'function';
const $4772a73a96e71e67$export$86e2cef2561044ac = (namespace, key, options)=>{
    const localStorage = (0, $bSSG7.createLocalStorageProvider)(namespace);
    const initialValue = localStorage.get(key) ?? options?.defaultValue;
    // used to trigger re-render of components
    const [value, setValueInState] = (0, $5uXOq.useState)(initialValue);
    const setValue = (0, $5uXOq.useCallback)((setStateAction)=>{
        if ($4772a73a96e71e67$var$isSetStateFunction(setStateAction)) setValueInState((prevVal)=>{
            const newVal = setStateAction(prevVal);
            localStorage.set(key, newVal);
            return newVal;
        });
        else {
            localStorage.set(key, setStateAction);
            setValueInState(setStateAction);
        }
    }, [
        key,
        localStorage
    ]);
    return [
        value,
        setValue
    ];
};
const $4772a73a96e71e67$export$9c89ac8256e92fbb = (namespace, key, ttlInMs, options)=>{
    const localStorage = (0, $bSSG7.createLocalExpirableStorageProvider)(namespace);
    const initialValue = localStorage.get(key) ?? options?.defaultValue;
    // used to trigger re-render of components
    const [value, setValueInState] = (0, $5uXOq.useState)(initialValue);
    const setValue = (0, $5uXOq.useCallback)((setStateAction)=>{
        if ($4772a73a96e71e67$var$isSetStateFunction(setStateAction)) setValueInState((prevVal)=>{
            const newVal = setStateAction(prevVal);
            localStorage.set(key, newVal, Date.now() + ttlInMs);
            return newVal;
        });
        else {
            localStorage.set(key, setStateAction, Date.now() + ttlInMs);
            setValueInState(setStateAction);
        }
    }, [
        key,
        localStorage,
        ttlInMs
    ]);
    return [
        value,
        setValue
    ];
};
const $4772a73a96e71e67$export$436c2fd92113c067 = (namespace, key, options)=>{
    const [state, setState] = $4772a73a96e71e67$export$86e2cef2561044ac(namespace, key, options);
    return [
        state,
        // This is for batch update
        (objectKey, value)=>setState((prevState)=>({
                    ...prevState,
                    [objectKey]: value
                }))
    ];
};
const $4772a73a96e71e67$export$db70e245473ac2a = (namespace, key, ttlInMs, options)=>{
    const [state, setState] = $4772a73a96e71e67$export$9c89ac8256e92fbb(namespace, key, ttlInMs, options);
    return [
        state,
        // This is for batch update
        (objectKey, value)=>setState((prevState)=>({
                    ...prevState,
                    [objectKey]: value
                }))
    ];
};

});

parcelRegister("cDCY0", function(module, exports) {

$parcel$export(module.exports, "isKebabCase", () => $2de7658afb9aad88$export$8f62caee7325c0cd);
// Step 1: Define a branded type for kebab case strings
const $2de7658afb9aad88$export$8f62caee7325c0cd = (value)=>{
    const kebabCaseRegex = /^[a-z]+(-[a-z]+)*$/;
    return kebabCaseRegex.test(value);
};

});

parcelRegister("1vKDd", function(module, exports) {

$parcel$export(module.exports, "NAMESPACE_PREFIX", () => $c31e62345861442d$export$44f66d558865bced);
$parcel$export(module.exports, "DAY_IN_MS", () => $c31e62345861442d$export$8217db641c4c0a89);
const $c31e62345861442d$export$44f66d558865bced = 'jira-list-view-statistics';
const $c31e62345861442d$export$8217db641c4c0a89 = 86400000;

});


parcelRegister("2yN2c", function(module, exports) {

$parcel$export(module.exports, "FeedbackButton", () => $be6e18fccf4b60db$export$116fedbe5e2e2bd8);

var $5uXOq = parcelRequire("5uXOq");

var $eCeGD = parcelRequire("eCeGD");

var $aEHvW = parcelRequire("aEHvW");

var $jPxJ7 = parcelRequire("jPxJ7");

var $koVbs = parcelRequire("koVbs");

var $aoWZv = parcelRequire("aoWZv");
const $be6e18fccf4b60db$var$FEEDBACK_GROUP_ID = 'list-view-issue-field-statistics-feedback';
const $be6e18fccf4b60db$export$116fedbe5e2e2bd8 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const openFeedbackModal = (0, $jPxJ7.useFeedbackCollector)();
    const onClick = (0, $5uXOq.useCallback)(()=>{
        openFeedbackModal($be6e18fccf4b60db$var$FEEDBACK_GROUP_ID);
    }, [
        openFeedbackModal
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        spacing: "default",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($aEHvW))),
        onClick: onClick,
        appearance: "subtle"
    }, formatMessage((0, $aoWZv.default).feedback));
};

});
parcelRegister("aEHvW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c129a0bf5d2aeea221ba2044e3fd85fd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7c1f64cf4f9c421f$var$_react = $7c1f64cf4f9c421f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7c1f64cf4f9c421f$var$_feedback = $7c1f64cf4f9c421f$var$_interopRequireDefault((parcelRequire("5dqGX")));

var $7c1f64cf4f9c421f$var$_feedback2 = $7c1f64cf4f9c421f$var$_interopRequireDefault((parcelRequire("3g1Fk")));
function $7c1f64cf4f9c421f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for FeedbackIcon.
 * This component is FeedbackIcon, with `UNSAFE_fallbackIcon` set to "FeedbackIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7c1f64cf4f9c421f$var$FeedbackIcon = (props)=>/*#__PURE__*/ $7c1f64cf4f9c421f$var$_react.default.createElement($7c1f64cf4f9c421f$var$_feedback.default, Object.assign({
        LEGACY_fallbackIcon: $7c1f64cf4f9c421f$var$_feedback2.default
    }, props));
$7c1f64cf4f9c421f$var$FeedbackIcon.Name = 'FeedbackIconMigration';
var $7c1f64cf4f9c421f$var$_default = module.exports.default = $7c1f64cf4f9c421f$var$FeedbackIcon;

});
parcelRegister("5dqGX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f238518c984ab5d0530bd2cff7eccbeb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3cc2df171aca9493$var$_react = $3cc2df171aca9493$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3cc2df171aca9493$var$_baseNew = $3cc2df171aca9493$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3cc2df171aca9493$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Feedback".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3cc2df171aca9493$var$FeedbackIcon = (props)=>/*#__PURE__*/ $3cc2df171aca9493$var$_react.default.createElement($3cc2df171aca9493$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6.221l-4.064 2.63A.75.75 0 0 1 1 15V9.5h1.5v4.121l3.093-2A.75.75 0 0 1 6 11.5h7a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2.75a.5.5 0 0 0 .5.5h5.44L7.22 5.03l1.06-1.06 2.5 2.5a.75.75 0 0 1 0 1.06l-2.5 2.5-1.06-1.06 1.22-1.22H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$3cc2df171aca9493$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $3cc2df171aca9493$var$_default = module.exports.default = $3cc2df171aca9493$var$FeedbackIcon;

});

parcelRegister("3g1Fk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25f4287f17f73dc4$var$_react = $25f4287f17f73dc4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $25f4287f17f73dc4$var$_feedback = $25f4287f17f73dc4$var$_interopRequireDefault((parcelRequire("5dqGX")));
function $25f4287f17f73dc4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $25f4287f17f73dc4$var$FeedbackIcon = (props)=>/*#__PURE__*/ $25f4287f17f73dc4$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m10.88 5.48-8.43 6.83c-.4.32-.58.96-.41 1.42l.1.27c.17.46.73.83 1.23.82l1.13-.02 6.06-.1 3.65-.06c.51-.01.79-.38.62-.86l-2.92-8.03c-.1-.29-.32-.44-.57-.44a.73.73 0 0 0-.46.18m-5.9 10.46 1.75 4.82a1 1 0 1 0 1.88-.68l-1.54-4.23zm13.71-9.11-2.82 1.03a1 1 0 1 0 .68 1.88l2.82-1.03a1 1 0 1 0-.68-1.88m-1.79 3.85a1 1 0 0 0-.64.77 1 1 0 0 0 .81 1.16l2.96.52a1 1 0 0 0 1.12-1.3l-.02-.05a1 1 0 0 0-.76-.62l-2.95-.52a.97.97 0 0 0-.51.05m-.56-7.65-1.93 2.3a1 1 0 0 0 1.53 1.29l1.93-2.3a1 1 0 0 0-.76-1.64 1 1 0 0 0-.77.36"/></svg>`
    }, props, {
        newIcon: $25f4287f17f73dc4$var$_feedback.default
    }));
$25f4287f17f73dc4$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $25f4287f17f73dc4$var$_default = module.exports.default = $25f4287f17f73dc4$var$FeedbackIcon;

});


parcelRegister("jPxJ7", function(module, exports) {

$parcel$export(module.exports, "useFeedbackCollector", () => $11c0bec8448c2614$export$4be696be8a3bff13);

var $5uXOq = parcelRequire("5uXOq");

var $e4yMr = parcelRequire("e4yMr");

var $4R6GH = parcelRequire("4R6GH");

var $7iULw = parcelRequire("7iULw");

var $dseDh = parcelRequire("dseDh");

var $koVbs = parcelRequire("koVbs");

var $6jY6G = parcelRequire("6jY6G");

var $dAfqg = parcelRequire("dAfqg");

var $itmJb = parcelRequire("itmJb");

var $9OXo1 = parcelRequire("9OXo1");

var $5XRYo = parcelRequire("5XRYo");

var $5Dn32 = parcelRequire("5Dn32");
const $11c0bec8448c2614$export$698ff856156a88fe = /*#__PURE__*/ (0, $5uXOq.memo)(()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return(// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $5XRYo.default).canContactPrompt), ' ', (0, $4R6GH.fg)('replace-anchor-with-link__wanjel') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
        href: "https://www.atlassian.com/legal/privacy-policy",
        target: "_blank",
        rel: "noopener noreferrer"
    }, formatMessage((0, $5XRYo.default).canContactPromptLink)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
        href: "https://www.atlassian.com/legal/privacy-policy",
        target: "_blank",
        rel: "noopener noreferrer"
    }, formatMessage((0, $5XRYo.default).canContactPromptLink))));
});
const $11c0bec8448c2614$export$4f77effad9540593 = /*#__PURE__*/ (0, $5uXOq.memo)(()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return(// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $5XRYo.default).enrollInResearchPrompt, {
        link: (0, $4R6GH.fg)('replace-anchor-with-link__wanjel') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
            href: "https://www.atlassian.com/research-group",
            target: "_blank",
            rel: "noopener noreferrer"
        }, formatMessage((0, $5XRYo.default).enrollInResearchLink)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
            href: "https://www.atlassian.com/research-group",
            target: "_blank",
            rel: "noopener noreferrer"
        }, formatMessage((0, $5XRYo.default).enrollInResearchLink))
    })));
});
const $11c0bec8448c2614$export$4be696be8a3bff13 = ({ projectType: projectType = 'business' } = {})=>{
    const { openFeedbackCollector: openFeedbackCollector } = (0, $dseDh.useFeedbackCollectorActions)();
    const { licensedProducts: licensedProducts } = (0, $9OXo1.useTenantContext)();
    const route = (0, $6jY6G.useCurrentRoute)();
    const { data: project } = (0, $dAfqg.useProjectContext)();
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const getFeedbackContext = (0, $5uXOq.useCallback)((feedbackGroupId)=>{
        const baseFeedbackContext = [
            {
                id: (0, $7iULw.EntryKeys).INLINE_FEEDBACK_ID,
                value: feedbackGroupId
            },
            {
                id: (0, $7iULw.EntryKeys).ROUTE_NAME,
                value: route.name ?? 'unknown'
            },
            {
                id: (0, $7iULw.EntryKeys).ROUTE_GROUP,
                value: route.group ?? 'unknown'
            },
            {
                id: (0, $7iULw.EntryKeys).IS_ADMIN,
                value: isAdmin
            },
            {
                id: (0, $7iULw.EntryKeys).PROJECT_TYPE,
                value: project?.projectType || projectType
            },
            {
                id: (0, $7iULw.EntryKeys).SUPPORTED_PROJECT_TYPES,
                value: (0, $5Dn32.licensedProductsToString)(licensedProducts)
            }
        ];
        // Only send project specific information if project is available
        if (project) baseFeedbackContext.push({
            id: (0, $7iULw.EntryKeys).IS_SIMPLIFIED_PROJECT,
            value: project.simplified
        });
        return baseFeedbackContext;
    }, [
        isAdmin,
        licensedProducts,
        project,
        projectType,
        route.group,
        route.name
    ]);
    return (0, $5uXOq.useCallback)((feedbackGroupId, onClose, triggerRef)=>{
        const feedbackContext = getFeedbackContext(feedbackGroupId);
        openFeedbackCollector({
            entrypointId: (0, $7iULw.ENTRYPOINT_ID_JIRA_PLATFORM),
            feedbackGroupId: feedbackGroupId,
            canBeContactedLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($11c0bec8448c2614$export$698ff856156a88fe, null),
            enrolInResearchLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($11c0bec8448c2614$export$4f77effad9540593, null),
            feedbackContext: feedbackContext,
            onClose: onClose,
            ...triggerRef != null ? {
                triggerRef: triggerRef
            } : {}
        });
    }, [
        getFeedbackContext,
        openFeedbackCollector
    ]);
};

});
parcelRegister("5XRYo", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c924dc8de5075ae$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6c924dc8de5075ae$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    canContactPrompt: {
        "id": "business-feedback-collector.can-contact-prompt",
        "defaultMessage": "Atlassian may contact me about this feedback."
    },
    canContactPromptLink: {
        "id": "business-feedback-collector.can-contact-prompt-link",
        "defaultMessage": "Privacy policy"
    },
    enrollInResearchPrompt: {
        "id": "business-feedback-collector.enroll-in-research-prompt",
        "defaultMessage": "I'd like to help improve Atlassian products by joining the {link}"
    },
    enrollInResearchLink: {
        "id": "business-feedback-collector.enroll-in-research-link",
        "defaultMessage": "Atlassian Research Group"
    }
});

});

parcelRegister("5Dn32", function(module, exports) {

$parcel$export(module.exports, "licensedProductsToString", () => $0dd3b476597799f0$export$f57a7f1d32485807);
const $0dd3b476597799f0$export$f57a7f1d32485807 = (licensedProducts)=>Object.keys(licensedProducts).map((productKey)=>licensedProducts[productKey] ? productKey : '').join(', ');

});


parcelRegister("aoWZv", function(module, exports) {

$parcel$export(module.exports, "default", () => $69734258dffcaf4b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $69734258dffcaf4b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    feedback: {
        "id": "business-issue-field-statistics.statistics-sidebar.feedback-button.feedback",
        "defaultMessage": "Give feedback"
    }
});

});


parcelRegister("CVuCA", function(module, exports) {

$parcel$export(module.exports, "default", () => $65d3f105302a27fd$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $65d3f105302a27fd$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    heading: {
        "id": "business-issue-field-statistics.statistics-sidebar.heading",
        "defaultMessage": "View this list as a chart"
    },
    info: {
        "id": "business-issue-field-statistics.statistics-sidebar.info",
        "defaultMessage": "Select the data you'd like to see in a chart."
    },
    close: {
        "id": "business-issue-field-statistics.statistics-sidebar.close",
        "defaultMessage": "Close"
    },
    selectLabel: {
        "id": "business-issue-field-statistics.statistics-sidebar.select-label",
        "defaultMessage": "Field"
    }
});

});

parcelRegister("9QPGZ", function(module, exports) {

$parcel$export(module.exports, "ShareButton", () => $ce79709f25dbb335$export$e980dfbc2840e8bc);

var $5uXOq = parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $c2i4s = parcelRequire("c2i4s");

var $3Fq5M = parcelRequire("3Fq5M");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $jgJNO = parcelRequire("jgJNO");

var $8zOmE = parcelRequire("8zOmE");

var $cCFkQ = parcelRequire("cCFkQ");

var $byNIx = parcelRequire("byNIx");

var $fkf2G = parcelRequire("fkf2G");
const $ce79709f25dbb335$export$38b2d434cce3ea22 = ()=>window;
const $ce79709f25dbb335$var$PopupContent = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $ce79709f25dbb335$var$popupContentContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c2i4s))), {
        label: "",
        LEGACY_size: "small",
        color: "var(--ds-icon-success, #22A06B)"
    }), "\xa0", formatMessage((0, $byNIx.default).linkCopiedPopup));
};
const $ce79709f25dbb335$export$e980dfbc2840e8bc = ({ selectedField: selectedField, selectedChartType: selectedChartType })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onClipboardError = (0, $fkf2G.useClipboardError)();
    const [isCopied, setIsCopied] = (0, $5uXOq.useState)(false);
    const onClick = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
        if (selectedField === undefined) return null;
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'jira.issueFieldStatistics.shareButton', {
            selectedFieldId: selectedField.id,
            selectedChartType: selectedChartType
        });
        const currentWindow = $ce79709f25dbb335$export$38b2d434cce3ea22();
        const currentNavigator = currentWindow?.navigator;
        if (typeof currentNavigator !== 'undefined') {
            const currentUrl = new URL(currentWindow.location.href);
            currentUrl.searchParams.set('sidebar', (0, $cCFkQ.SIDEBAR_NAME));
            currentUrl.searchParams.set((0, $cCFkQ.SELECTED_FIELD_ID_QUERY_KEY), selectedField.id);
            if (selectedChartType !== undefined) currentUrl.searchParams.set((0, $cCFkQ.SELECTED_CHART_TYPE_QUERY_KEY), selectedChartType);
            if (!currentUrl.searchParams.has('filter')) currentUrl.searchParams.set('filter', '');
            // it is valid to have a trailing slash before the query string, but this does not follow our conventions
            const urlString = currentUrl.toString().replace(/\/(?=\?)/, '');
            currentNavigator.clipboard.writeText(urlString).then(()=>{
                setIsCopied(true);
            }).catch((err)=>{
                onClipboardError(err);
            });
        } else onClipboardError(new Error('Clipboard is not supported'));
    }, [
        selectedField,
        selectedChartType,
        onClipboardError
    ]);
    // clear popup after 3 seconds
    (0, $5uXOq.useEffect)(()=>{
        let timeout;
        if (isCopied) timeout = setTimeout(()=>{
            setIsCopied(false);
        }, 3000);
        return ()=>clearTimeout(timeout);
    }, [
        isCopied
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isCopied,
        onClose: ()=>setIsCopied(false),
        placement: "top-start",
        messageId: "business-issue-field-statistics.ui.statistics-sidebar.share-button.popup",
        messageType: "transactional",
        content: $ce79709f25dbb335$var$PopupContent,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
                ...triggerProps,
                appearance: "subtle",
                isDisabled: selectedField === undefined,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($3Fq5M))),
                label: formatMessage((0, $byNIx.default).share),
                isTooltipDisabled: false,
                onClick: onClick
            })
    });
};
const $ce79709f25dbb335$var$popupContentContainerStyles = (0, $8CUq3.xcss)({
    padding: 'space.200'
});

});
parcelRegister("3Fq5M", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::746afd86dff7a846534476462b8fe4e7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2ab970d264bef26f$var$_react = $2ab970d264bef26f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2ab970d264bef26f$var$_copy = $2ab970d264bef26f$var$_interopRequireDefault((parcelRequire("8w53e")));

var $2ab970d264bef26f$var$_copy2 = $2ab970d264bef26f$var$_interopRequireDefault((parcelRequire("eE13R")));
function $2ab970d264bef26f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CopyIcon.
 * This component is CopyIcon, with `UNSAFE_fallbackIcon` set to "CopyIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2ab970d264bef26f$var$CopyIcon = (props)=>/*#__PURE__*/ $2ab970d264bef26f$var$_react.default.createElement($2ab970d264bef26f$var$_copy.default, Object.assign({
        LEGACY_fallbackIcon: $2ab970d264bef26f$var$_copy2.default
    }, props));
$2ab970d264bef26f$var$CopyIcon.Name = 'CopyIconMigration';
var $2ab970d264bef26f$var$_default = module.exports.default = $2ab970d264bef26f$var$CopyIcon;

});
parcelRegister("8w53e", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cbd1068d7fb082440154244857d12f2c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $63353af41c1756be$var$_react = $63353af41c1756be$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $63353af41c1756be$var$_baseNew = $63353af41c1756be$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $63353af41c1756be$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Copy".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $63353af41c1756be$var$CopyIcon = (props)=>/*#__PURE__*/ $63353af41c1756be$var$_react.default.createElement($63353af41c1756be$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM16 6v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75V6z" clip-rule="evenodd"/>`
    }, props));
$63353af41c1756be$var$CopyIcon.displayName = 'CopyIcon';
var $63353af41c1756be$var$_default = module.exports.default = $63353af41c1756be$var$CopyIcon;

});

parcelRegister("eE13R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aa959fe1f5a86e24$var$_react = $aa959fe1f5a86e24$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $aa959fe1f5a86e24$var$_copy = $aa959fe1f5a86e24$var$_interopRequireDefault((parcelRequire("8w53e")));
function $aa959fe1f5a86e24$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $aa959fe1f5a86e24$var$CopyIcon = (props)=>/*#__PURE__*/ $aa959fe1f5a86e24$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M10 19h8V8h-8zM8 7.992C8 6.892 8.902 6 10.009 6h7.982C19.101 6 20 6.893 20 7.992v11.016c0 1.1-.902 1.992-2.009 1.992H10.01A2 2 0 0 1 8 19.008z"/><path d="M5 16V4.992C5 3.892 5.902 3 7.009 3H15v13zm2 0h8V5H7z"/></g></svg>`
    }, props, {
        newIcon: $aa959fe1f5a86e24$var$_copy.default
    }));
$aa959fe1f5a86e24$var$CopyIcon.displayName = 'CopyIcon';
var $aa959fe1f5a86e24$var$_default = module.exports.default = $aa959fe1f5a86e24$var$CopyIcon;

});


parcelRegister("byNIx", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad9cd037fbf50263$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ad9cd037fbf50263$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    share: {
        "id": "business-issue-field-statistics.statistics-sidebar.share-button.share-non-final",
        "defaultMessage": "Share this chart"
    },
    errorFlagTitle: {
        "id": "business-issue-field-statistics.error-flag-title-non-final",
        "defaultMessage": "Something went wrong"
    },
    errorFlagDescription: {
        "id": "business-issue-field-statistics.error-flag-description-non-final",
        "defaultMessage": "We were unable to copy the link to clipboard. Please try again or contact support."
    },
    errorFlagContactSupportActionText: {
        "id": "business-issue-field-statistics.error-flag-contact-support-action-text-non-final",
        "defaultMessage": "Contact support"
    },
    linkCopiedPopup: {
        "id": "business-issue-field-statistics.statistics-sidebar.share-button.link-copied-popup",
        "defaultMessage": "Link copied to clipboard"
    }
});

});

parcelRegister("fkf2G", function(module, exports) {

$parcel$export(module.exports, "useClipboardError", () => $9c0131d4da6fa20d$export$90a150a33a5e5322);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");


var $byNIx = parcelRequire("byNIx");
const $9c0131d4da6fa20d$export$90a150a33a5e5322 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    return (0, $5uXOq.useCallback)((error)=>{
        (0, $jcw0u.default)({
            meta: {
                id: (0, $d290b8794b3d33dc$export$f3390a0e172fee41),
                packageName: (0, $d290b8794b3d33dc$export$b8b9d90f9e5bd72b),
                teamName: (0, $d290b8794b3d33dc$export$d57b6b390e78d90f)
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        const flagId = showFlag({
            type: 'error',
            title: formatMessage((0, $byNIx.default).errorFlagTitle),
            description: formatMessage((0, $byNIx.default).errorFlagDescription),
            messageId: 'business-issue-field-statistics.ui.statistics-sidebar.share-button.show-flag.error',
            messageType: 'transactional',
            actions: [
                {
                    content: formatMessage((0, $byNIx.default).errorFlagContactSupportActionText),
                    href: 'https://support.atlassian.com/contact',
                    target: '_blank',
                    onClick: ()=>flagId && dismissFlag(flagId)
                }
            ]
        });
    }, [
        showFlag,
        dismissFlag,
        formatMessage
    ]);
};

});
const $d290b8794b3d33dc$export$b8b9d90f9e5bd72b = 'jiraIssueFieldStatistics';
const $d290b8794b3d33dc$export$f3390a0e172fee41 = 'copyToClipboard';
const $d290b8794b3d33dc$export$d57b6b390e78d90f = 'helios-reports';



parcelRegister("9WcDz", function(module, exports) {

$parcel$export(module.exports, "StatisticsRenderer", () => $a8b3cccaa9cf6f30$export$94ae349d8c6a2871);

var $5uXOq = parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");

var $bUSNl = parcelRequire("bUSNl");

var $koVbs = parcelRequire("koVbs");

var $hjYzz = parcelRequire("hjYzz");

var $l4Z9V = parcelRequire("l4Z9V");

var $ecJLL = parcelRequire("ecJLL");

var $nfUJy = parcelRequire("nfUJy");

var $iXVV6 = parcelRequire("iXVV6");

var $jnA4H = parcelRequire("jnA4H");

var $kfbSl = parcelRequire("kfbSl");


var $1ovIw = parcelRequire("1ovIw");
const $a8b3cccaa9cf6f30$var$shouldShowSingleSelectChart = (visualRepresentation)=>visualRepresentation === 'SINGLE_SELECT_CHART';
const $a8b3cccaa9cf6f30$var$shouldShowStatisticsTable = (visualRepresentation)=>visualRepresentation === 'STATISTICS_TABLE';
const $a8b3cccaa9cf6f30$var$calculateSingleSelectChartWidth = (sidebarWidth)=>sidebarWidth - (0, $03857339d4f662fa$export$eb686c593382b322) - (0, $03857339d4f662fa$export$6b0a922783b1a3e9);
const $a8b3cccaa9cf6f30$export$94ae349d8c6a2871 = ({ selectedFieldId: selectedFieldId, selectedField: selectedField, selectedChartType: selectedChartType, onChartTypeChange: onChartTypeChange, jql: jql })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [store] = (0, $bUSNl.useSidebar)();
    const sidebarWidth = (0, $jnA4H.getSidebarWidthFromStore)(store);
    const visualRepresentation = (0, $kfbSl.getVisualRepresentation)(selectedField);
    if (selectedField) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            fieldId: selectedField.id
        }
    }, $a8b3cccaa9cf6f30$var$shouldShowSingleSelectChart(visualRepresentation) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $nfUJy.SingleSelectChartContainer), {
        customFieldId: selectedField.id,
        query: jql,
        width: $a8b3cccaa9cf6f30$var$calculateSingleSelectChartWidth(sidebarWidth),
        chartType: selectedChartType || 'DONUT_CHART',
        onChartTypeChange: onChartTypeChange
    }), $a8b3cccaa9cf6f30$var$shouldShowStatisticsTable(visualRepresentation) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        paddingBlock: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l4Z9V.NumericStatsContainer), {
        customFieldId: selectedField.id,
        query: jql,
        chartType: (0, $ecJLL.NumericChart).TABLE
    })));
    // there is a field id present, but it could not be found in the selectable fields
    if (selectedFieldId !== undefined && selectedField === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        paddingBlock: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjYzz.SidebarError), {
        errorMessage: formatMessage((0, $1ovIw.default).noFieldSelectedError)
    }));
    return null;
};

});
parcelRegister("hjYzz", function(module, exports) {

$parcel$export(module.exports, "SidebarError", () => $736638b4717f96ff$export$6a393cdd679621ef);

var $5uXOq = parcelRequire("5uXOq");

var $bU3PY = parcelRequire("bU3PY");

var $kgoHi = parcelRequire("kgoHi");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");
const $736638b4717f96ff$export$6a393cdd679621ef = ({ errorMessage: errorMessage })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        direction: "column",
        alignItems: "center",
        justifyContent: "center",
        xcss: $736638b4717f96ff$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        align: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))), {
        color: "var(--ds-icon-warning, #E56910)",
        LEGACY_size: "small",
        label: ""
    }), errorMessage));
};
const $736638b4717f96ff$var$containerStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.800',
    paddingBottom: 'space.800'
});

});

parcelRegister("l4Z9V", function(module, exports) {

$parcel$export(module.exports, "NumericStatsContainer", () => $b37afa4f296413ec$export$82a560ce398a7de0);

var $5uXOq = parcelRequire("5uXOq");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $koVbs = parcelRequire("koVbs");

var $koH6I = parcelRequire("koH6I");

var $a5Nyt = parcelRequire("a5Nyt");

var $hjYzz = parcelRequire("hjYzz");

var $atGhH = parcelRequire("atGhH");

var $ecJLL = parcelRequire("ecJLL");

var $kVQ9A = parcelRequire("kVQ9A");
const $b37afa4f296413ec$export$82a560ce398a7de0 = ({ customFieldId: customFieldId, query: query, chartType: chartType })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ loading: loading, data: data, error: error }] = (0, $a5Nyt.useNumberFieldStatistics)({
        customFieldId: customFieldId,
        query: query
    });
    if (chartType !== (0, $ecJLL.NumericChart).TABLE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjYzz.SidebarError), {
        errorMessage: formatMessage((0, $kVQ9A.default).chartTypeError)
    });
    const isDataEmpty = data?.count === 0 || data?.min === undefined && data?.max === undefined && data?.sum === undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $koH6I.SidebarDataHandler), {
        error: error,
        loading: loading,
        data: data,
        isEmpty: isDataEmpty
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$9d2de6eebf7462b5),
        sourceName: "jira.issueFieldStatistics.numericStats"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null), data && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $atGhH.NumericStatsTable), {
        data: data
    })));
};

});
parcelRegister("koH6I", function(module, exports) {

$parcel$export(module.exports, "SidebarDataHandler", () => $96f7b5e008f1c0d5$export$1bc4d26c70cb89fb);

var $5uXOq = parcelRequire("5uXOq");

var $e4yMr = parcelRequire("e4yMr");

var $kgoHi = parcelRequire("kgoHi");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $eZJjh = parcelRequire("eZJjh");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $hjYzz = parcelRequire("hjYzz");

var $3m0tF = parcelRequire("3m0tF");
const $96f7b5e008f1c0d5$export$1bc4d26c70cb89fb = ({ data: data, loading: loading, error: error, isEmpty: isEmpty, children: children })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjYzz.SidebarError), {
        errorMessage: formatMessage((0, $3m0tF.default).error, {
            link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
                    href: "https://support.atlassian.com/contact",
                    appearance: "default"
                }, chunks)
        })
    });
    if (loading || !data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        direction: "column",
        alignItems: "center",
        xcss: $96f7b5e008f1c0d5$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "xlarge",
        label: formatMessage((0, $3m0tF.default).spinnerLabel)
    }));
    if (isEmpty) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$9d2de6eebf7462b5),
        sourceName: "jira.issueFieldStatistics.emptyState"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        direction: "column",
        alignItems: "center",
        xcss: $96f7b5e008f1c0d5$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        weight: "bold",
        align: "center"
    }, formatMessage((0, $3m0tF.default).noData))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null));
    return children;
};
const $96f7b5e008f1c0d5$var$containerStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.800',
    paddingBottom: 'space.800'
});

});
parcelRegister("3m0tF", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c43f3777cdc7ba5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7c43f3777cdc7ba5$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    error: {
        "id": "issue-field-statistics.numeric-stats-container.error",
        "defaultMessage": " We couldn't load your data. Try again or <link>contact support</link>."
    },
    spinnerLabel: {
        "id": "issue-field-statistics.common.async-handler.spinner-label",
        "defaultMessage": "Loading"
    },
    noData: {
        "id": "issue-field-statistics.common.async-handler.no-data",
        "defaultMessage": "No data available"
    }
});

});


parcelRegister("a5Nyt", function(module, exports) {

$parcel$export(module.exports, "useNumberFieldStatistics", () => $2403cb90302dff68$export$5adbcf6eb1301c8d);

var $iuEfD = parcelRequire("iuEfD");

var $48DMb = parcelRequire("48DMb");

const $2403cb90302dff68$var$getNumberFieldStatistics = async ({ customFieldId: customFieldId, query: jql, fetchOptions: fetchOptions = {} })=>{
    const query = new URLSearchParams({
        query: jql
    });
    const url = `/rest/internal/list-view-chart/number/${customFieldId}?${query.toString()}`;
    return (0, $48DMb.fetchJson)(url, fetchOptions);
};
const $2403cb90302dff68$export$5adbcf6eb1301c8d = ({ customFieldId: customFieldId, query: query })=>(0, $iuEfD.useFetch)({
        onFetch: async (fetchOptions)=>$2403cb90302dff68$var$getNumberFieldStatistics({
                customFieldId: customFieldId,
                query: query,
                fetchOptions: fetchOptions
            }),
        analyticsTracking: {
            actionSubject: `useFetch.${(0, $053a7e7c0b960d07$export$8d4ac56f443fb551)}`,
            packageName: (0, $053a7e7c0b960d07$export$b8b9d90f9e5bd72b),
            action: 'dataFetch'
        },
        loggingKey: `${(0, $053a7e7c0b960d07$export$b8b9d90f9e5bd72b)}.${(0, $053a7e7c0b960d07$export$8d4ac56f443fb551)}`,
        isAutoFetchable: true
    }, [
        customFieldId,
        query
    ]);

});
parcelRegister("iuEfD", function(module, exports) {

$parcel$export(module.exports, "useFetch", () => $082fa94a7a9fe60c$export$d852f5f778460fa4);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $4R6GH = parcelRequire("4R6GH");

var $aAhmV = parcelRequire("aAhmV");

var $d6Xq4 = parcelRequire("d6Xq4");

var $bYINM = parcelRequire("bYINM");

var $lUlda = parcelRequire("lUlda");

var $dg0bO = parcelRequire("dg0bO");

var $eW4Xh = parcelRequire("eW4Xh");
const $082fa94a7a9fe60c$export$d852f5f778460fa4 = ({ onFetch: onFetch, isAutoFetchable: isAutoFetchable = true, analyticsTracking: analyticsTracking, browserMetricsKey: browserMetricsKey, loggingKey: loggingKey, initialData: initialData, isAbortable: isAbortable = true }, fetchDependencies)=>{
    const [state, dispatch] = (0, $5uXOq.useReducer)((0, $bYINM.reducer), {
        ...(0, $dg0bO.initialState),
        data: initialData
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { initialized: initialized, fetched: fetched, loading: loading } = state;
    const abortControllerRef = (0, $5uXOq.useRef)();
    const fetchDependenciesRef = (0, $5uXOq.useRef)(fetchDependencies);
    const isMounted = (0, $5uXOq.useRef)(true);
    const getAbortController = (0, $5uXOq.useCallback)(()=>{
        const controller = abortControllerRef.current;
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        if (!abortControllerRef.current || controller?.signal.aborted) abortControllerRef.current = new AbortController();
        return abortControllerRef.current;
    }, []);
    const callFetch = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (...args)=>{
        // @ts-expect-error - TS2339 - Property 'signal' does not exist on type 'unknown'.
        const { signal: signal } = getAbortController();
        (0, $eW4Xh.thunks).fetch({
            onFetch: async ()=>{
                try {
                    return await onFetch({
                        signal: signal
                    }, ...args);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (e) {
                    throw new (0, $d6Xq4.UseFetchHandledError)(isMounted.current, e);
                }
            },
            analyticsTracking: analyticsTracking,
            createAnalyticsEvent: createAnalyticsEvent,
            browserMetricsKey: browserMetricsKey,
            loggingKey: loggingKey,
            signal: signal
        })({
            actions: (0, $aAhmV.buildActionDispatchers)(dispatch)
        });
    }, [
        onFetch,
        analyticsTracking,
        browserMetricsKey,
        createAnalyticsEvent,
        loggingKey,
        getAbortController
    ]);
    const doAbort = (0, $5uXOq.useCallback)(()=>{
        if (isAbortable) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        getAbortController().abort();
    }, [
        getAbortController,
        isAbortable
    ]);
    const doFetch = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (...args)=>{
        if (loading) doAbort();
        callFetch(...args);
    }, [
        loading,
        callFetch,
        doAbort
    ]);
    /**
	 * We need this shouldAutoFetch in concurrent mode or we callFetch twice on mount
	 * We can't do a loading check in the hasEffectsChanged useEffect because loading doesn't get updated in time
	 * So we delay it till the next cycle via useEffect
	 */ const [shouldAutoFetch, setShouldAutoFetch] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $4R6GH.fg)('jira-concurrent-board-perf')) {
            if (shouldAutoFetch) {
                setShouldAutoFetch(false);
                if (!loading) callFetch();
            }
        }
    }, [
        shouldAutoFetch,
        callFetch,
        loading
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const hasEffectsChanged = (0, $lUlda.isShallowDifferent)(fetchDependenciesRef.current, fetchDependencies);
        if (!initialized && !fetched || hasEffectsChanged) {
            if (hasEffectsChanged) fetchDependenciesRef.current = fetchDependencies;
            if (hasEffectsChanged) doAbort();
            if (isAutoFetchable) {
                if ((0, $4R6GH.fg)('jira-concurrent-board-perf')) setShouldAutoFetch(true);
                else callFetch();
            } else if (initialized && hasEffectsChanged) dispatch({
                type: 'resetInitialState',
                payload: null
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        initialized,
        doAbort,
        fetched,
        callFetch,
        isAutoFetchable,
        ...fetchDependencies
    ]);
    (0, $5uXOq.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
            doAbort();
        };
    }, [
        doAbort
    ]);
    return [
        state,
        {
            doFetch: doFetch,
            doAbort: doAbort
        }
    ];
};

});
parcelRegister("aAhmV", function(module, exports) {

$parcel$export(module.exports, "buildActionDispatchers", () => $b5443ab87e9d487f$export$5297818927df1cbf);
$parcel$export(module.exports, "buildSweetStateActionDispatchers", () => $b5443ab87e9d487f$export$25b8423a7d935d64);
$parcel$export(module.exports, "hydrateSweetStateActionsDispatchers", () => $b5443ab87e9d487f$export$7f88d514aa0ad345);

var $aTJxm = parcelRequire("aTJxm");
const $b5443ab87e9d487f$export$5297818927df1cbf = (dispatch)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys((0, $aTJxm.strategies)).reduce((accumulator, strategy)=>{
        accumulator[strategy] = (payload)=>dispatch({
                type: strategy,
                payload: payload
            });
        return accumulator;
    }, {});
const $b5443ab87e9d487f$export$25b8423a7d935d64 = ()=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys((0, $aTJxm.strategies)).reduce((accumulator, strategy)=>{
        accumulator[strategy] = (key, initialData, payload)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                const sliceState = state.fetchables[key] || initialData;
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly resetInitialState: () => { readonly initialized: false; readonly loading: false; readonly fetched: false; readonly hasError: false; readonly aborted: false; readonly error: undefined; readonly data: undefined; }; ... 4 more ...; readonly default: (state: FetchState) => FetchState; }'.
                const nextSliceState = (0, $aTJxm.strategies)[strategy](sliceState, {
                    type: strategy,
                    payload: payload
                });
                const nextState = {
                    ...state,
                    fetchables: {
                        ...state.fetchables,
                        [key]: nextSliceState
                    }
                };
                setState(nextState);
            };
        return accumulator;
    }, {});
const $b5443ab87e9d487f$export$7f88d514aa0ad345 = ({ actions: actions, key: key, initialData: initialData })=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(actions).reduce((accumulator, strategy)=>{
        const actionExecutor = actions[strategy];
        accumulator[strategy] = (payload)=>{
            actionExecutor(key, initialData, payload);
        };
        return accumulator;
    }, {});

});
parcelRegister("aTJxm", function(module, exports) {

$parcel$export(module.exports, "strategies", () => $e708554df9e0cc9d$export$c5491a8691a23b9e);

var $dg0bO = parcelRequire("dg0bO");
const $e708554df9e0cc9d$var$resetInitialState = ()=>(0, $dg0bO.initialState);
const $e708554df9e0cc9d$var$setFetchStart = (state)=>({
        ...state,
        initialized: true,
        loading: true,
        fetched: false,
        hasError: false,
        aborted: false
    });
const $e708554df9e0cc9d$var$setFetchEnd = (_, action)=>({
        initialized: true,
        loading: false,
        fetched: true,
        hasError: false,
        aborted: false,
        data: action.payload
    });
const $e708554df9e0cc9d$var$setError = (_, action)=>({
        error: action.payload,
        initialized: true,
        loading: false,
        fetched: false,
        hasError: true,
        aborted: false
    });
const $e708554df9e0cc9d$var$setAborted = ()=>({
        initialized: true,
        loading: false,
        fetched: false,
        hasError: false,
        aborted: true
    });
const $e708554df9e0cc9d$var$setDefault = (state)=>state;
const $e708554df9e0cc9d$export$c5491a8691a23b9e = {
    resetInitialState: $e708554df9e0cc9d$var$resetInitialState,
    setFetchStart: $e708554df9e0cc9d$var$setFetchStart,
    setFetchEnd: $e708554df9e0cc9d$var$setFetchEnd,
    setError: $e708554df9e0cc9d$var$setError,
    setAborted: $e708554df9e0cc9d$var$setAborted,
    default: $e708554df9e0cc9d$var$setDefault
};

});
parcelRegister("dg0bO", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $147c98f07a60815a$export$d4c72bab9d6cc13a);
const $147c98f07a60815a$export$d4c72bab9d6cc13a = {
    initialized: false,
    loading: false,
    fetched: false,
    hasError: false,
    aborted: false,
    error: undefined,
    data: undefined
};

});



parcelRegister("d6Xq4", function(module, exports) {

$parcel$export(module.exports, "UseFetchHandledError", () => $7de9d917d4a5c394$export$2801d9c787d65a99);
class $7de9d917d4a5c394$export$2801d9c787d65a99 extends Error {
    constructor(componentMounted, e){
        super(e?.message || 'Unknown');
        this.originalError = e;
        this.componentMounted = !!componentMounted;
    }
}

});

parcelRegister("bYINM", function(module, exports) {

$parcel$export(module.exports, "reducer", () => $82dfd012f8e9e396$export$1650419e431d3ba3);

var $aTJxm = parcelRequire("aTJxm");

var $dg0bO = parcelRequire("dg0bO");
const $82dfd012f8e9e396$export$1650419e431d3ba3 = (state = (0, $dg0bO.initialState), action)=>{
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly resetInitialState: () => { readonly initialized: false; readonly loading: false; readonly fetched: false; readonly hasError: false; readonly aborted: false; readonly error: undefined; readonly data: undefined; }; ... 4 more ...; readonly default: (state: FetchState) => FetchState; }'.
    const transformer = (0, $aTJxm.strategies)[action.type] || (0, $aTJxm.strategies).default;
    return transformer(state, action);
};

});

parcelRegister("lUlda", function(module, exports) {

$parcel$export(module.exports, "isShallowDifferent", () => $76bb872f5000fbec$export$a42e2ec7d66a0c03);
const $76bb872f5000fbec$export$a42e2ec7d66a0c03 = (arrayA, arrayB)=>arrayA.length !== arrayB.length || arrayA.some((currentElement, index)=>currentElement !== arrayB[index]);

});

parcelRegister("eW4Xh", function(module, exports) {

$parcel$export(module.exports, "thunks", () => $4eddb453cf1aa4e2$export$eb2332b8a94a914a);

var $eUcR1 = parcelRequire("eUcR1");

var $dTD3b = parcelRequire("dTD3b");

var $7lFwJ = parcelRequire("7lFwJ");
const $4eddb453cf1aa4e2$export$eb2332b8a94a914a = {
    fetch: ({ onFetch: onFetch, analyticsTracking: analyticsTracking, browserMetricsKey: browserMetricsKey, loggingKey: loggingKey, signal: signal, createAnalyticsEvent: createAnalyticsEvent })=>{
        const metricsTracker = (0, $eUcR1.trackBrowserMetricsForJira)({
            browserMetricsKey: browserMetricsKey
        });
        const logger = (0, $7lFwJ.loggingHandler)({
            loggingKey: loggingKey
        });
        return async ({ actions: actions })=>{
            const analyticsTracker = (0, $dTD3b.trackDataFetchAnalytics)({
                ...analyticsTracking,
                createAnalyticsEvent: createAnalyticsEvent
            });
            metricsTracker.start();
            analyticsTracker.start();
            // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
            actions.setFetchStart();
            try {
                const data = await onFetch({
                    signal: signal
                });
                actions.setFetchEnd(data);
                metricsTracker.end();
                analyticsTracker.succeeded();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                metricsTracker.cancel();
                if (e.componentMounted) {
                    if (signal.aborted) {
                        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
                        actions.setAborted();
                        analyticsTracker.aborted();
                    } else {
                        const thrownError = e.originalError;
                        actions.setError(thrownError);
                        analyticsTracker.failed(thrownError);
                        logger.error(thrownError);
                    }
                }
            }
        };
    }
};

});
parcelRegister("eUcR1", function(module, exports) {

$parcel$export(module.exports, "trackBrowserMetricsForJira", () => $ce81c3c268f844ac$export$d8b2320f7d41dc1d);

var $dGrdR = parcelRequire("dGrdR");

var $30KM0 = parcelRequire("30KM0");
const $ce81c3c268f844ac$export$d8b2320f7d41dc1d = ({ browserMetricsKey: browserMetricsKey, attributes: attributes, histogram: // Define bucket sizes for histogram. e.g.: '100_500_1000_2500_5000_10000'. Default to '500_1000_1500_4000_7000'.
histogram })=>{
    if (browserMetricsKey === null || browserMetricsKey === undefined) return {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        start: ()=>{},
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        end: ()=>{},
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        cancel: ()=>{}
    };
    const bm3MetricsTracker = (0, $dGrdR.metrics).interaction({
        key: browserMetricsKey,
        // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string | undefined; }' but required in type 'InteractionHistogramConfig'.
        histogram: {
            result: histogram || (0, $30KM0.DEFAULT_HISTOGRAM_BUCKETS)
        }
    });
    const startHandler = ()=>{
        bm3MetricsTracker.start();
    };
    const endHandler = ()=>{
        bm3MetricsTracker.stop({
            customData: attributes
        });
    };
    const cancelHandler = ()=>{
        bm3MetricsTracker.cancel();
    };
    return {
        start: startHandler,
        end: endHandler,
        cancel: cancelHandler
    };
};

});
parcelRegister("30KM0", function(module, exports) {

$parcel$export(module.exports, "STORE_NAME", () => $b92906e2cd9ec8a5$export$cd79d01fb3d2f506);
$parcel$export(module.exports, "experiences", () => $b92906e2cd9ec8a5$export$9848ee2a7d21002f);
$parcel$export(module.exports, "TIMEOUT_IN_MS", () => $b92906e2cd9ec8a5$export$9ebf97d10ce21f3b);
$parcel$export(module.exports, "DEFAULT_HISTOGRAM_BUCKETS", () => $b92906e2cd9ec8a5$export$e3b77a602bc4d0e6);

const $b92906e2cd9ec8a5$export$cd79d01fb3d2f506 = `${(0, $b0e6fec6a4686296$export$d3996f57ffa8448f)}.experience-tracker-store`;
const $b92906e2cd9ec8a5$export$9848ee2a7d21002f = {
    RENDER: 'render'
};
const $b92906e2cd9ec8a5$export$9ebf97d10ce21f3b = 7000;
const $b92906e2cd9ec8a5$export$e3b77a602bc4d0e6 = '500_1000_1500_4000_7000';

});
const $b0e6fec6a4686296$export$d3996f57ffa8448f = 'jira.insights';
const $b0e6fec6a4686296$export$c9290acd1ba498ff = `${$b0e6fec6a4686296$export$d3996f57ffa8448f}.board`;
const $b0e6fec6a4686296$export$2fd6d7f902b01d67 = `${$b0e6fec6a4686296$export$d3996f57ffa8448f}.backlog`;
const $b0e6fec6a4686296$export$8e66b21ec141a0bd = `${$b0e6fec6a4686296$export$d3996f57ffa8448f}.board-simplified`;
const $b0e6fec6a4686296$export$75eb9639a5b0ba25 = `${$b0e6fec6a4686296$export$d3996f57ffa8448f}.backlog-simplified`;
const $b0e6fec6a4686296$export$1269ea4f2b198811 = `${$b0e6fec6a4686296$export$d3996f57ffa8448f}.error-boundary`;



parcelRegister("dTD3b", function(module, exports) {

$parcel$export(module.exports, "trackDataFetchAnalytics", () => $e920ac60c98f1376$export$bc65acfb4b442c00);

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");

var $fZneA = parcelRequire("fZneA");

var $8zOmE = parcelRequire("8zOmE");

var $93kZ7 = parcelRequire("93kZ7");
const $e920ac60c98f1376$export$d14e9b22afc87cb3 = (statusCode)=>{
    if (statusCode === null) return (0, $93kZ7.statusCodeGroups).UNKNOWN;
    if (statusCode >= 100 && statusCode <= 199) return (0, $93kZ7.statusCodeGroups).INFORMATIONAL_RESPONSES;
    if (statusCode >= 200 && statusCode <= 299) return (0, $93kZ7.statusCodeGroups).SUCCESS_RESPONSES;
    if (statusCode >= 300 && statusCode <= 399) return (0, $93kZ7.statusCodeGroups).REDIRECTS;
    if (statusCode >= 400 && statusCode <= 499) return (0, $93kZ7.statusCodeGroups).CLIENT_ERRORS;
    if (statusCode >= 500 && statusCode <= 599) return (0, $93kZ7.statusCodeGroups).SERVER_ERRORS;
    return (0, $93kZ7.statusCodeGroups).UNKNOWN;
};
const $e920ac60c98f1376$var$includeSample = (sampleRate)=>Math.random() <= 1 / sampleRate;
const $e920ac60c98f1376$var$noopAnalytics = Object.freeze({
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    start: ()=>{},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    succeeded: ()=>{},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    failed: ()=>{},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    aborted: ()=>{}
});
const $e920ac60c98f1376$export$bc65acfb4b442c00 = ({ action: action = 'dataFetch', actionSubject: actionSubject, packageName: packageName, createAnalyticsEvent: createAnalyticsEvent, sampleRate: sampleRate })=>{
    if (actionSubject == null) return $e920ac60c98f1376$var$noopAnalytics;
    if (sampleRate != null && !$e920ac60c98f1376$var$includeSample(sampleRate)) return $e920ac60c98f1376$var$noopAnalytics;
    // Note: Operational analytics do NOT use actionSubjectId!
    const actionSubjectAndAction = `${actionSubject} ${action}`;
    return Object.freeze({
        start: ()=>{
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), actionSubjectAndAction, {
                status: (0, $93kZ7.analyticsStatuses).STARTED,
                packageName: packageName
            });
        },
        succeeded: ()=>{
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), actionSubjectAndAction, {
                statusCodeGroup: '2xx',
                status: (0, $93kZ7.analyticsStatuses).SUCCEEDED,
                packageName: packageName
            });
        },
        failed: (e)=>{
            const error = e !== null && e !== undefined ? e : new Error('Unknown error, e should be present');
            if (!(0, $fZneA.isClientFetchError)(e)) {
                (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), actionSubjectAndAction, {
                    statusCodeGroup: $e920ac60c98f1376$export$d14e9b22afc87cb3(error instanceof (0, $jJZqs.default) ? error.statusCode : -1),
                    status: (0, $93kZ7.analyticsStatuses).FAILED,
                    packageName: packageName
                });
                return;
            }
            // No network connection error
            (0, $jcw0u.default)({
                meta: {
                    id: actionSubject,
                    packageName: packageName
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        },
        aborted: ()=>{
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), actionSubjectAndAction, {
                status: (0, $93kZ7.analyticsStatuses).ABORTED,
                packageName: packageName
            });
        }
    });
};

});
parcelRegister("93kZ7", function(module, exports) {

$parcel$export(module.exports, "statusCodeGroups", () => $88683eadd8082ef6$export$fddea1bcaead87d5);
$parcel$export(module.exports, "analyticsStatuses", () => $88683eadd8082ef6$export$f0fa81eb65b496a1);
const $88683eadd8082ef6$export$fddea1bcaead87d5 = {
    INFORMATIONAL_RESPONSES: '1xx',
    SUCCESS_RESPONSES: '2xx',
    REDIRECTS: '3xx',
    CLIENT_ERRORS: '4xx',
    SERVER_ERRORS: '5xx',
    UNKNOWN: 'unknown'
};
const $88683eadd8082ef6$export$f0fa81eb65b496a1 = {
    SUCCEEDED: 'succeeded',
    FAILED: 'failed',
    ABORTED: 'aborted',
    STARTED: 'started'
};

});


parcelRegister("7lFwJ", function(module, exports) {

$parcel$export(module.exports, "loggingHandler", () => $81689b1ad2d5cba4$export$f35316da257b76e4);

var $2YZCu = parcelRequire("2YZCu");

var $fZneA = parcelRequire("fZneA");
const $81689b1ad2d5cba4$export$f35316da257b76e4 = ({ loggingKey: loggingKey })=>{
    if (loggingKey === null || loggingKey === undefined) return {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        error: ()=>{}
    };
    const errorHandler = (thrownError)=>{
        if (!(0, $fZneA.isClientFetchError)(thrownError)) (0, $2YZCu.default).safeErrorWithoutCustomerData(loggingKey, 'Error fetching data', thrownError);
    };
    return {
        error: errorHandler
    };
};

});



parcelRegister("48DMb", function(module, exports) {

$parcel$export(module.exports, "fetchJson", () => $cfd862e6e9d86034$export$6d71b655afe1638d);

var $7f4tk = parcelRequire("7f4tk");

var $3wzQ9 = parcelRequire("3wzQ9");
const $cfd862e6e9d86034$export$6d71b655afe1638d = async (url, options = {})=>(0, $7f4tk.default)(url, options).catch((error)=>{
        throw new (0, $3wzQ9.FetchUrlError)(url, error);
    });

});
parcelRegister("3wzQ9", function(module, exports) {

$parcel$export(module.exports, "FetchUrlError", () => $f57667a2adaf29d3$export$5cdfc90b27d7ab6c);

var $jJZqs = parcelRequire("jJZqs");

var $fZneA = parcelRequire("fZneA");

var $bw7Gm = parcelRequire("bw7Gm");

var $kFy8J = parcelRequire("kFy8J");
const $f57667a2adaf29d3$var$getStatusCodeGroup = (statusCode)=>{
    if (statusCode === null) return (0, $kFy8J.statusCodeGroups).UNKNOWN;
    if (statusCode >= 100 && statusCode <= 199) return (0, $kFy8J.statusCodeGroups).INFORMATIONAL_RESPONSES;
    if (statusCode >= 200 && statusCode <= 299) return (0, $kFy8J.statusCodeGroups).SUCCESS_RESPONSES;
    if (statusCode >= 300 && statusCode <= 399) return (0, $kFy8J.statusCodeGroups).REDIRECTS;
    if (statusCode >= 400 && statusCode <= 499) return (0, $kFy8J.statusCodeGroups).CLIENT_ERRORS;
    if (statusCode >= 500 && statusCode <= 599) return (0, $kFy8J.statusCodeGroups).SERVER_ERRORS;
    return (0, $kFy8J.statusCodeGroups).UNKNOWN;
};
const $f57667a2adaf29d3$var$stringifySafe = (obj)=>{
    try {
        return JSON.stringify(obj);
    } catch  {
        return null;
    }
};
class $f57667a2adaf29d3$export$5cdfc90b27d7ab6c extends (0, $jJZqs.default) {
    constructor(url, fetchError){
        if (fetchError instanceof (0, $jJZqs.default)) super(fetchError.statusCode, fetchError.message, fetchError.traceId);
        else super(-1, fetchError.message);
        this.name = 'FetchUrlError';
        this.url = (0, $bw7Gm.default)(url);
        this.aborted = fetchError.name === (0, $jJZqs.ABORT_ERROR_NAME);
        this.isClientError = (0, $fZneA.isClientFetchError)(fetchError) || this.statusCode === -1;
        this.statusCodeGroup = $f57667a2adaf29d3$var$getStatusCodeGroup(fetchError instanceof (0, $jJZqs.default) ? fetchError.statusCode : null);
        // NOTE: logging does not support nested objects!
        this.cause = $f57667a2adaf29d3$var$stringifySafe(fetchError);
    }
}

});
parcelRegister("kFy8J", function(module, exports) {

$parcel$export(module.exports, "statusCodeGroups", () => $cb89e2c05d3c28e8$export$fddea1bcaead87d5);
const $cb89e2c05d3c28e8$export$fddea1bcaead87d5 = {
    INFORMATIONAL_RESPONSES: '1xx',
    SUCCESS_RESPONSES: '2xx',
    REDIRECTS: '3xx',
    CLIENT_ERRORS: '4xx',
    SERVER_ERRORS: '5xx',
    UNKNOWN: 'unknown'
};

});



const $053a7e7c0b960d07$export$b8b9d90f9e5bd72b = 'jiraIssueFieldStatistics';
const $053a7e7c0b960d07$export$8d4ac56f443fb551 = 'getNumericFieldStatistics';


parcelRegister("atGhH", function(module, exports) {

$parcel$export(module.exports, "NumericStatsTable", () => $ce9efb6d1e8a8386$export$fa8956702bebcaa8);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $iLuEU = parcelRequire("iLuEU");
const $ce9efb6d1e8a8386$var$tableStyles = null;
const $ce9efb6d1e8a8386$var$cellStyles = null; // This is required to override the css reset which sets padding-left to 0.
const $ce9efb6d1e8a8386$var$statisticStyles = null;
const $ce9efb6d1e8a8386$var$valueStyles = null;
const $ce9efb6d1e8a8386$var$grayBackgroundStyles = null;
const $ce9efb6d1e8a8386$export$1945042cb2b5a024 = ({ left: left, right: right, rowNumber: rowNumber })=>{
    const Tag = rowNumber === 0 ? 'th' : 'td';
    const isGrayBackground = rowNumber % 2 === 1;
    return /*#__PURE__*/ $5uXOq.createElement("tr", null, /*#__PURE__*/ $5uXOq.createElement(Tag, {
        className: (0, $bwpsq.default)([
            "_ca0qutpp _n3tdutpp",
            "_1vykpxbi",
            isGrayBackground && "_bfhk11bn"
        ])
    }, left), /*#__PURE__*/ $5uXOq.createElement(Tag, {
        className: (0, $bwpsq.default)([
            "_ca0qutpp _n3tdutpp",
            "_1kl7zgxb _19bvpxbi",
            isGrayBackground && "_bfhk11bn"
        ])
    }, right));
};
const $ce9efb6d1e8a8386$export$fa8956702bebcaa8 = ({ data: data })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ $5uXOq.createElement("table", {
        className: (0, $bwpsq.default)([
            "_2rko1l7b _189et94y _1dqonqa1 _1h6dmuej _yq5h18uv _btyzidpf"
        ])
    }, /*#__PURE__*/ $5uXOq.createElement("thead", null, /*#__PURE__*/ $5uXOq.createElement($ce9efb6d1e8a8386$export$1945042cb2b5a024, {
        left: formatMessage((0, $iLuEU.default).statistic),
        right: formatMessage((0, $iLuEU.default).value),
        rowNumber: 0
    })), /*#__PURE__*/ $5uXOq.createElement("tbody", null, /*#__PURE__*/ $5uXOq.createElement($ce9efb6d1e8a8386$export$1945042cb2b5a024, {
        left: formatMessage((0, $iLuEU.default).maximum),
        right: data.max,
        rowNumber: 1
    }), /*#__PURE__*/ $5uXOq.createElement($ce9efb6d1e8a8386$export$1945042cb2b5a024, {
        left: formatMessage((0, $iLuEU.default).minimum),
        right: data.min,
        rowNumber: 2
    }), /*#__PURE__*/ $5uXOq.createElement($ce9efb6d1e8a8386$export$1945042cb2b5a024, {
        left: formatMessage((0, $iLuEU.default).sum),
        right: data.sum,
        rowNumber: 3
    }), /*#__PURE__*/ $5uXOq.createElement($ce9efb6d1e8a8386$export$1945042cb2b5a024, {
        left: formatMessage((0, $iLuEU.default).count),
        right: data.count,
        rowNumber: 4
    })));
};

});
parcelRegister("iLuEU", function(module, exports) {

$parcel$export(module.exports, "default", () => $94d3bd9980ef7214$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $94d3bd9980ef7214$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    statistic: {
        "id": "issue-field-statistics.numeric-stats-container.numeric-stats-table.statistic",
        "defaultMessage": "Statistic"
    },
    value: {
        "id": "issue-field-statistics.numeric-stats-container.numeric-stats-table.value",
        "defaultMessage": "Value"
    },
    minimum: {
        "id": "issue-field-statistics.numeric-stats-container.numeric-stats-table.minimum",
        "defaultMessage": "Min"
    },
    maximum: {
        "id": "issue-field-statistics.numeric-stats-container.numeric-stats-table.maximum",
        "defaultMessage": "Max"
    },
    sum: {
        "id": "issue-field-statistics.numeric-stats-container.numeric-stats-table.sum",
        "defaultMessage": "Sum"
    },
    count: {
        "id": "issue-field-statistics.numeric-stats-container.numeric-stats-table.count",
        "defaultMessage": "Total issue count"
    }
});

});


parcelRegister("ecJLL", function(module, exports) {

$parcel$export(module.exports, "NumericChart", () => $01e94e008b2f175a$export$74fcc8c20f11ed4a);
const $01e94e008b2f175a$export$74fcc8c20f11ed4a = {
    TABLE: 'table'
};
const $01e94e008b2f175a$export$f770472ecefe2a6e = $01e94e008b2f175a$export$74fcc8c20f11ed4a.TABLE;
const $01e94e008b2f175a$export$7e4ad1192237e29f = Object.values($01e94e008b2f175a$export$74fcc8c20f11ed4a);

});

parcelRegister("kVQ9A", function(module, exports) {

$parcel$export(module.exports, "default", () => $73e1cfe9f2d5ea73$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $73e1cfe9f2d5ea73$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    chartTypeError: {
        "id": "issue-field-statistics.numeric-stats-container-legacy.chart-type-error",
        "defaultMessage": "Invalid chart type. Please select a valid chart type from the options above."
    }
});

});


parcelRegister("nfUJy", function(module, exports) {

$parcel$export(module.exports, "SingleSelectChartContainer", () => $807d2fc59c0ae890$export$f37d245665d6d6fc);

var $5uXOq = parcelRequire("5uXOq");

var $2x3Cb = parcelRequire("2x3Cb");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $7K5PP = parcelRequire("7K5PP");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $koH6I = parcelRequire("koH6I");

var $hjYzz = parcelRequire("hjYzz");

var $dem5p = parcelRequire("dem5p");

var $fIs6U = parcelRequire("fIs6U");

var $kKAkB = parcelRequire("kKAkB");

var $bFZ3A = parcelRequire("bFZ3A");

var $dUJCJ = parcelRequire("dUJCJ");
const $807d2fc59c0ae890$var$CHART_LABELS = {
    [(0, $bFZ3A.SingleSelectChart).DONUT]: (0, $dUJCJ.default).donutChartLabel,
    [(0, $bFZ3A.SingleSelectChart).HORIZONTAL_BAR]: (0, $dUJCJ.default).horizontalBarChartLabel
};
const $807d2fc59c0ae890$var$isValidChartType = (type)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $bFZ3A.SingleSelectChartList).includes(type);
};
const $807d2fc59c0ae890$var$ChartRenderer = ({ data: data, chartType: chartType, width: width })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (!data) return null;
    switch(chartType){
        case (0, $bFZ3A.SingleSelectChart).DONUT:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fIs6U.DonutChart), {
                data: data,
                width: width
            });
        case (0, $bFZ3A.SingleSelectChart).HORIZONTAL_BAR:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kKAkB.HorizontalBarChart), {
                data: data,
                width: width
            });
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjYzz.SidebarError), {
                errorMessage: formatMessage((0, $dUJCJ.default).chartTypeError)
            });
    }
};
const $807d2fc59c0ae890$export$f37d245665d6d6fc = ({ customFieldId: customFieldId, query: query, width: width, chartType: initialChartType, onChartTypeChange: onChartTypeChange })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ loading: loading, data: data, error: error }] = (0, $dem5p.useSelectFieldStatistics)({
        customFieldId: customFieldId,
        query: query,
        limit: (0, $bFZ3A.FIELD_LIMIT)
    });
    const chartType = $807d2fc59c0ae890$var$isValidChartType(initialChartType) ? initialChartType : (0, $bFZ3A.SingleSelectChart).DONUT;
    const options = (0, $5uXOq.useMemo)(()=>(0, $bFZ3A.SingleSelectChartList).map((type)=>({
                label: formatMessage($807d2fc59c0ae890$var$CHART_LABELS[type]),
                value: type
            })), [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $koH6I.SidebarDataHandler), {
        error: error,
        loading: loading,
        data: data,
        isEmpty: data?.length === 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$9d2de6eebf7462b5),
        sourceName: "jira.issueFieldStatistics.singleSelectChart",
        attributes: {
            chartType: chartType
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlock: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2x3Cb.Label), {
        htmlFor: "issue-field-statistics-chart-type-select",
        id: "issue-field-statistics-chart-type-select-label"
    }, formatMessage((0, $dUJCJ.default).chartTypeSelectLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        value: {
            label: formatMessage($807d2fc59c0ae890$var$CHART_LABELS[chartType]),
            value: chartType
        },
        onChange: (newChartType)=>{
            newChartType && onChartTypeChange(newChartType.value);
        },
        options: options,
        id: "issue-field-statistics-chart-type-select",
        labelId: "issue-field-statistics-chart-type-select-label"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignInline: "center",
        xcss: $807d2fc59c0ae890$var$chartStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($807d2fc59c0ae890$var$ChartRenderer, {
        data: data,
        width: width,
        chartType: chartType
    })))));
};
const $807d2fc59c0ae890$var$chartStyles = (0, $8CUq3.xcss)({
    paddingInline: 'space.150',
    paddingBlock: 'space.200'
});

});
parcelRegister("dem5p", function(module, exports) {

$parcel$export(module.exports, "useSelectFieldStatistics", () => $478bbbbc278976a5$export$5540229e7ae0ba04);

var $iuEfD = parcelRequire("iuEfD");

var $48DMb = parcelRequire("48DMb");


var $eL5UX = parcelRequire("eL5UX");
const $478bbbbc278976a5$var$getSelectFieldStatistics = async ({ customFieldId: customFieldId, query: jql, limit: limit, fetchOptions: fetchOptions = {} })=>{
    const query = new URLSearchParams({
        query: jql,
        limit: limit.toString()
    });
    const url = `/rest/internal/list-view-chart/select/${customFieldId}?${query.toString()}`;
    return (0, $48DMb.fetchJson)(url, fetchOptions);
};
const $478bbbbc278976a5$export$5540229e7ae0ba04 = ({ customFieldId: customFieldId, query: query, limit: limit })=>{
    const { transform: transform } = (0, $eL5UX.useTransformer)();
    return (0, $iuEfD.useFetch)({
        onFetch: async (fetchOptions)=>{
            const response = await $478bbbbc278976a5$var$getSelectFieldStatistics({
                customFieldId: customFieldId,
                query: query,
                limit: limit,
                fetchOptions: fetchOptions
            });
            return transform(response);
        },
        analyticsTracking: {
            actionSubject: `useFetch.${(0, $70bcc60b885bccc7$export$33d4e32fdc33abbf)}`,
            packageName: (0, $70bcc60b885bccc7$export$b8b9d90f9e5bd72b),
            action: 'dataFetch'
        },
        loggingKey: `${(0, $70bcc60b885bccc7$export$b8b9d90f9e5bd72b)}.${(0, $70bcc60b885bccc7$export$33d4e32fdc33abbf)}`,
        isAutoFetchable: true
    }, [
        customFieldId,
        query
    ]);
};

});
const $70bcc60b885bccc7$export$b8b9d90f9e5bd72b = 'jiraIssueFieldStatistics';
const $70bcc60b885bccc7$export$33d4e32fdc33abbf = 'getSelectFieldStatistics';

parcelRegister("eL5UX", function(module, exports) {

$parcel$export(module.exports, "useTransformer", () => $381ff7675cc30cc5$export$c187a9117419b263);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $2Ot3K = parcelRequire("2Ot3K");
const $381ff7675cc30cc5$export$c187a9117419b263 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const transform = (0, $5uXOq.useCallback)((data)=>{
        const slices = Object.entries(data.slices).map(([label, value])=>({
                label: label,
                value: value
            }));
        const sortedSlices = slices.sort((a, b)=>b.value - a.value);
        const otherCategory = data.other > 0 ? [
            {
                label: formatMessage((0, $2Ot3K.default).otherLabel),
                value: data.other
            }
        ] : [];
        return [
            ...sortedSlices,
            ...otherCategory
        ];
    }, [
        formatMessage
    ]);
    return {
        transform: transform
    };
};

});
parcelRegister("2Ot3K", function(module, exports) {

$parcel$export(module.exports, "default", () => $5aacb0e794bec047$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5aacb0e794bec047$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    otherLabel: {
        "id": "issue-field-statistics.services.select-field.transformer.other-label",
        "defaultMessage": "Other"
    }
});

});



parcelRegister("fIs6U", function(module, exports) {

$parcel$export(module.exports, "DonutChart", () => $ccef7da10c2dea79$export$533707e2f61b59ec);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $gXw8D = parcelRequire("gXw8D");

var $6CDHh = parcelRequire("6CDHh");

var $85STF = parcelRequire("85STF");

var $53Pxl = parcelRequire("53Pxl");
const $ccef7da10c2dea79$var$MAX_WIDTH = 600;
const $ccef7da10c2dea79$export$533707e2f61b59ec = ({ data: data, width: initialWidth })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const width = Math.min(initialWidth, $ccef7da10c2dea79$var$MAX_WIDTH);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gXw8D.default), {
        data: data,
        width: width,
        valueAccessor: (d)=>d.value,
        labelAccessor: (d)=>d.label,
        colorAccessor: (d)=>d.label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gXw8D.default).elements.MarkLabels, {
        hide: false
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gXw8D.default).elements.MetricLabel, {
        label: formatMessage((0, $53Pxl.default).centerTextLabel)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6CDHh.CustomLayout), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $85STF.CustomLegend), null));
};

});
parcelRegister("gXw8D", function(module, exports) {

$parcel$export(module.exports, "default", () => $c58b1607dac96615$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9ZuYc = parcelRequire("9ZuYc");

var $4Yvz8 = parcelRequire("4Yvz8");
parcelRequire("4wRz3");
var $2OPEf = parcelRequire("2OPEf");
var $4wRz3 = parcelRequire("4wRz3");

var $jsFNI = parcelRequire("jsFNI");

var $jogiL = parcelRequire("jogiL");

var $jogiL = parcelRequire("jogiL");

var $9BEAR = parcelRequire("9BEAR");
var $dBbYh = parcelRequire("dBbYh");

var $dZ3lg = parcelRequire("dZ3lg");

var $gUvRg = parcelRequire("gUvRg");

var $1iqMi = parcelRequire("1iqMi");
var $7rySF = parcelRequire("7rySF");

var $lFJ6b = parcelRequire("lFJ6b");

var $2dgU7 = parcelRequire("2dgU7");

var $d9Y89 = parcelRequire("d9Y89");

var $8upbu = parcelRequire("8upbu");

var $n8hTk = parcelRequire("n8hTk");

var $dcCcf = parcelRequire("dcCcf");

var $dFdp9 = parcelRequire("dFdp9");

var $dwEoN = parcelRequire("dwEoN");

var $8Yq1M = parcelRequire("8Yq1M");

var $8aZwB = parcelRequire("8aZwB");

var $6MKTx = parcelRequire("6MKTx");

var $2OMIu = parcelRequire("2OMIu");
function $c58b1607dac96615$var$_defineProperty(obj, key, value) {
    key = $c58b1607dac96615$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c58b1607dac96615$var$_toPropertyKey(t) {
    var i = $c58b1607dac96615$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $c58b1607dac96615$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
class $c58b1607dac96615$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    render() {
        const { width: width, height: height, data: data, children: children, ...restProps } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9ZuYc.ElementsProvider), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $d9Y89.default), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dBbYh.MenuProvider), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2dgU7.default), {
                        children: [
                            children,
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4wRz3.LayoutContainer), {
                                width: width,
                                height: height,
                                data: data,
                                gridTemplate: [
                                    'title',
                                    'subtitle',
                                    'plot',
                                    'legend'
                                ],
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jsFNI.DimensionsWrapper), {
                                    children: (_ref)=>{
                                        let { plotHeight: plotHeight, plotWidth: plotWidth, plotSvgRef: plotSvgRef } = _ref;
                                        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6MKTx.PureDonutChart), {
                                            svgRef: plotSvgRef,
                                            height: plotHeight,
                                            width: plotWidth,
                                            data: data,
                                            margin: (0, $lFJ6b.PIE_DEFAULT_MARGIN),
                                            ...restProps
                                        });
                                    }
                                })
                            })
                        ]
                    })
                })
            })
        });
    }
}
$c58b1607dac96615$var$_defineProperty($c58b1607dac96615$export$2e2bcd8739ae039, "events", (0, $n8hTk.donutChartEvents));
$c58b1607dac96615$var$_defineProperty($c58b1607dac96615$export$2e2bcd8739ae039, "elements", {
    Legend: (0, $jogiL.OrdinalLegend).Component,
    LegendLabel: (0, $jogiL.LegendLabel).Component,
    LegendSymbol: (0, $jogiL.LegendSymbol).Component,
    Layout: (0, $2OPEf.Layout).Component,
    Title: (0, $7rySF.Title).Component,
    SubTitle: (0, $1iqMi.Subtitle).Component,
    Mark: (0, $dZ3lg.Arc).Component,
    Marks: (0, $dwEoN.DonutMarks).Component,
    MarkLabels: (0, $dFdp9.DonutMarkLabels).Component,
    Metric: (0, $dcCcf.DonutMetric).Component,
    MetricLabel: (0, $dcCcf.DonutMetricLabel).Component,
    MetricValue: (0, $dcCcf.DonutMetricValue).Component,
    TooltipOverlay: (0, $8aZwB.DonutTooltipOverlay).Component,
    Tooltip: (0, $8upbu.SingleSeriesTooltip).Component,
    Scales: (0, $8Yq1M.DonutScalesElement).Component,
    Theme: (0, $gUvRg.Theme).Component,
    Menu: (0, $9BEAR.Menu).Component,
    DataTable: (0, $4Yvz8.DataTable).Component
});

});
parcelRegister("9ZuYc", function(module, exports) {

$parcel$export(module.exports, "ElementsProvider", () => $7461d58af668f317$export$71c0ba76abe92a7e);
$parcel$export(module.exports, "useElements", () => $7461d58af668f317$export$83d5c6859f2ae3df);
$parcel$export(module.exports, "useElementProps", () => $7461d58af668f317$export$8edbe6dd5606980);

var $5uXOq = parcelRequire("5uXOq");

var $2OMIu = parcelRequire("2OMIu");

var $6cAn5 = parcelRequire("6cAn5");
const $7461d58af668f317$export$a92ee76f0b1f4e66 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
function $7461d58af668f317$export$71c0ba76abe92a7e(_ref) {
    let { children: children, defaultProps: defaultProps, kind: kind } = _ref;
    const ctx = $7461d58af668f317$export$83d5c6859f2ae3df();
    const value = (0, $5uXOq.useMemo)(()=>{
        // If kind is specified, we assume we are in nested element so we get the parent registry
        // Ideally we'd use WeakMap but node < 20 does not support symbols as keys
        const registry = kind && (ctx === null || ctx === void 0 ? void 0 : ctx.registry) || new Map();
        const registeredOverrideComponents = kind && (ctx === null || ctx === void 0 ? void 0 : ctx.registeredOverrideComponents) || new Map();
        return {
            registry: registry,
            registeredOverrideComponents: registeredOverrideComponents,
            register: (kind, value)=>{
                if (!registeredOverrideComponents.get(kind)) registeredOverrideComponents.set(kind, []);
                const overrideComps = registeredOverrideComponents.get(kind) || [];
                if (!overrideComps.includes(value.Component)) overrideComps.push(value.Component);
                if (overrideComps[overrideComps.length - 1] === value.Component) registry.set(kind, value);
            },
            retrieve: (kind)=>registry.get(kind),
            isNested: (k)=>k === kind || Boolean(ctx === null || ctx === void 0 ? void 0 : ctx.isNested(k)),
            getProps: (k)=>k === kind ? defaultProps : ctx === null || ctx === void 0 ? void 0 : ctx.getProps(k),
            getOuterProps: (k)=>{
                var _registry$get;
                return Boolean(ctx === null || ctx === void 0 ? void 0 : ctx.isNested(k)) ? (_registry$get = registry.get(k)) === null || _registry$get === void 0 ? void 0 : _registry$get.outerProps : null;
            }
        };
    }, [
        kind,
        defaultProps
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($7461d58af668f317$export$a92ee76f0b1f4e66.Provider, {
        value: value,
        children: children
    });
}
const $7461d58af668f317$export$83d5c6859f2ae3df = ()=>(0, $5uXOq.useContext)($7461d58af668f317$export$a92ee76f0b1f4e66);
function $7461d58af668f317$export$8edbe6dd5606980(element, _temp) {
    var _process, _process$env, _useElements, _useElements2, _useElements3;
    let { mergeWith: mergeWith } = _temp === void 0 ? {} : _temp;
    if (typeof element.kind !== 'symbol') throw new Error('Invalid element argument. It must be an element or an element Component.');
    if (((_process = $6cAn5) === null || _process === void 0 ? void 0 : (_process$env = _process.env) === null || _process$env === void 0 ? void 0 : _process$env.NODE_ENV) === 'development' && !((_useElements = $7461d58af668f317$export$83d5c6859f2ae3df()) !== null && _useElements !== void 0 && _useElements.isNested(element.kind))) throw new Error('Invalid element argument. Only props of parent elements can be retrieved.');
    return {
        ...(_useElements2 = $7461d58af668f317$export$83d5c6859f2ae3df()) === null || _useElements2 === void 0 ? void 0 : _useElements2.getProps(element.kind),
        ...(_useElements3 = $7461d58af668f317$export$83d5c6859f2ae3df()) === null || _useElements3 === void 0 ? void 0 : _useElements3.getOuterProps(element.kind),
        ...mergeWith
    };
}

});

parcelRegister("4Yvz8", function(module, exports) {

$parcel$export(module.exports, "DataTable", () => $39f5404de5c26a41$export$df30df7ec97b32b5);
$parcel$export(module.exports, "DataTableModal", () => $39f5404de5c26a41$export$4717a7afeef78908);
/* DataTable.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $bwpsq = parcelRequire("bwpsq");

var $42CjB = parcelRequire("42CjB");

var $k3qRI = parcelRequire("k3qRI");

var $2jwCH = parcelRequire("2jwCH");

var $1R1Ge = parcelRequire("1R1Ge");
var $7QSqG = parcelRequire("7QSqG");
var $jgVsb = parcelRequire("jgVsb");

var $1xLej = parcelRequire("1xLej");

var $7rySF = parcelRequire("7rySF");

var $lCjFE = parcelRequire("lCjFE");

var $wM6Wl = parcelRequire("wM6Wl");

var $2OMIu = parcelRequire("2OMIu");
const $39f5404de5c26a41$var$gridStyles = null;
const $39f5404de5c26a41$export$a8a28302b48950e6 = null;
function $39f5404de5c26a41$var$getHeaders(headers) {
    const cellHeaders = headers.map((header)=>({
            key: header,
            content: (0, $lCjFE.toSentenceCase)(header),
            isSortable: true
        }));
    return {
        cells: cellHeaders
    };
}
function $39f5404de5c26a41$var$getRows(data) {
    if (!data.length) {
        const keys = Object.keys(data);
        const rowData = keys.map((k)=>{
            var _data;
            const cellData = (_data = data[k]) === null || _data === void 0 ? void 0 : _data.toString();
            return {
                key: cellData,
                content: cellData
            };
        });
        return [
            {
                key: 'row-0',
                cells: rowData
            }
        ];
    }
    const rows = data.map((d, i)=>{
        const keys = Object.keys(d);
        const rowData = keys.map((k)=>{
            var _d$k;
            const cellData = (_d$k = d[k]) === null || _d$k === void 0 ? void 0 : _d$k.toString();
            return {
                key: cellData,
                content: cellData !== null && cellData !== void 0 ? cellData : '\u2014'
            };
        });
        return {
            key: `row-${i}`,
            cells: rowData
        };
    });
    return rows;
}
function $39f5404de5c26a41$export$84cbf2d941927b3b(_ref) {
    let { data: data, headers: userDefinedHeaders } = _ref;
    if (!data || Array.isArray(data) && data.length === 0) return null;
    const headers = userDefinedHeaders ? $39f5404de5c26a41$var$getHeaders(userDefinedHeaders) : data && $39f5404de5c26a41$var$getHeaders(Object.keys(data[0]));
    const rows = $39f5404de5c26a41$var$getRows(data);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_n3tdu2gc _1reo1wug _18m91wug _ect41sbm _opvxu2gc _91ih131l _1ouib76v _cnoh1il0 _a2nzu2gc _9f9g1oud _slyj1fxt _1xc811bn"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k3qRI.default), {
            head: headers,
            rows: rows,
            rowsPerPage: 10,
            defaultPage: 1,
            loadingSpinnerSize: "large"
        })
    });
}
const $39f5404de5c26a41$export$df30df7ec97b32b5 = (0, $1xLej.element)($39f5404de5c26a41$export$84cbf2d941927b3b);
function $39f5404de5c26a41$export$4717a7afeef78908(_ref2) {
    let { data: data, closeModal: closeModal } = _ref2;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $1R1Ge.default), {
        onClose: closeModal,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jgVsb.default), {
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                    className: (0, $bwpsq.default)([
                        "_1bsb1osq _1e0c11p5 _zulppxbi _1lmcg5aa _yv0e1ghl _4cvr1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                            className: (0, $bwpsq.default)([
                                "_1bahh9n0 _nd5l1bvj"
                            ]),
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                                appearance: "subtle",
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($2jwCH))),
                                label: (0, $wM6Wl.a11yStrings).exitDataTable,
                                onClick: closeModal
                            })
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                            className: (0, $bwpsq.default)([
                                "_1bahv2br _nd5l1cy2"
                            ]),
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7rySF.Title), {})
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7QSqG.default), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)($39f5404de5c26a41$export$df30df7ec97b32b5, {
                    data: data
                })
            })
        ]
    });
}

});
parcelRegister("k3qRI", function(module, exports) {

$parcel$export(module.exports, "default", () => $60e4f0159aa1c87c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eGmKJ = parcelRequire("eGmKJ");

var $gS5Cm = parcelRequire("gS5Cm");

var $dHbUn = parcelRequire("dHbUn");
class $60e4f0159aa1c87c$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            defaultPage: 1,
            isLoading: false,
            isFixedSize: false,
            isRankable: false,
            onSetPage: (0, $eGmKJ.default),
            onSort: (0, $eGmKJ.default),
            rowsPerPage: Infinity
        };
    }
    UNSAFE_componentWillReceiveProps(newProps) {
        const sortKey = newProps.sortKey || this.state.sortKey;
        const sortOrder = newProps.sortOrder || this.state.sortOrder;
        const page = newProps.page || this.state.page;
        this.setState({
            page: page,
            sortKey: sortKey,
            sortOrder: sortOrder,
            rows: newProps.rows
        });
    }
    render() {
        const { page: page, sortKey: sortKey, sortOrder: sortOrder, rows: rows } = this.state;
        const { caption: caption, emptyView: emptyView, head: head, highlightedRowIndex: highlightedRowIndex, loadingSpinnerSize: loadingSpinnerSize, isLoading: isLoading, loadingLabel: loadingLabel, isFixedSize: isFixedSize, isRankable: isRankable, isRankingDisabled: isRankingDisabled, rowsPerPage: rowsPerPage, paginationi18n: paginationi18n, onRankStart: onRankStart, onPageRowsUpdate: onPageRowsUpdate, testId: testId, label: label } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dHbUn.default), {
            paginationi18n: paginationi18n,
            caption: caption,
            emptyView: emptyView,
            head: head,
            highlightedRowIndex: highlightedRowIndex,
            loadingSpinnerSize: loadingSpinnerSize,
            isLoading: isLoading,
            loadingLabel: loadingLabel,
            isFixedSize: isFixedSize,
            onSetPage: this.onSetPageHandler,
            onSort: this.onSortHandler,
            page: page,
            rows: rows,
            rowsPerPage: rowsPerPage,
            sortKey: sortKey,
            sortOrder: sortOrder,
            isRankable: isRankable,
            isRankingDisabled: isRankingDisabled,
            onRankEnd: this.onRankEndHandler,
            onRankStart: onRankStart,
            onPageRowsUpdate: onPageRowsUpdate,
            testId: testId,
            label: label
        });
    }
    constructor(...args){
        super(...args), this.state = {
            page: this.props.defaultPage,
            sortKey: this.props.defaultSortKey,
            sortOrder: this.props.defaultSortOrder,
            rows: this.props.rows
        }, this.onSetPageHandler = (page, analyticsEvent)=>{
            const { onSetPage: onSetPage } = this.props;
            if (onSetPage) {
                onSetPage(page, analyticsEvent);
                this.setState({
                    page: page
                });
            }
        }, this.onSortHandler = ({ key: key, item: item, sortOrder: sortOrder }, analyticsEvent)=>{
            const { onSort: onSort } = this.props;
            if (onSort) {
                onSort({
                    key: key,
                    item: item,
                    sortOrder: sortOrder
                }, analyticsEvent);
                this.setState({
                    sortKey: key,
                    sortOrder: sortOrder
                });
            }
        }, this.onRankEndIfExistsHandler = (params)=>{
            if (this.props.onRankEnd) this.props.onRankEnd(params);
        }, this.onRankEndHandler = (params)=>{
            const { destination: destination } = params;
            const { rows: rows, page: page } = this.state;
            const { rowsPerPage: rowsPerPage } = this.props;
            if (!destination || !rows) {
                this.onRankEndIfExistsHandler(params);
                return;
            }
            const reordered = (0, $gS5Cm.reorderRows)(params, rows, page, rowsPerPage);
            this.setState({
                rows: reordered
            });
            this.onRankEndIfExistsHandler(params);
        };
    }
}

});
parcelRegister("gS5Cm", function(module, exports) {

$parcel$export(module.exports, "getPageRows", () => $7f55105045703159$export$3987dc24b734dcab);
$parcel$export(module.exports, "assertIsSortable", () => $7f55105045703159$export$5eb35a4771ec4090);
$parcel$export(module.exports, "validateSortKey", () => $7f55105045703159$export$9133f5a8bfe8a200);
$parcel$export(module.exports, "inlineStylesIfRanking", () => $7f55105045703159$export$a601f1775e10043f);
$parcel$export(module.exports, "reorderRows", () => $7f55105045703159$export$c476bbe5da59992d);
const $7f55105045703159$export$3987dc24b734dcab = (allRows, pageNumber, rowsPerPage)=>{
    if (!pageNumber || !rowsPerPage || !allRows.length) return [];
    return allRows.slice((pageNumber - 1) * rowsPerPage, pageNumber * rowsPerPage);
};
const $7f55105045703159$export$5eb35a4771ec4090 = (head)=>{
    if (!head || !head.cells) return;
    head.cells.forEach((cell)=>{
        if (cell.isSortable && !cell.key) try {
            throw Error("isSortable can't be set to true, if the 'key' prop is missing.");
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    });
};
const $7f55105045703159$export$9133f5a8bfe8a200 = (sortKey, head)=>{
    if (!sortKey) return;
    const headHasKey = head && head.cells.map((cell)=>cell.key).includes(sortKey);
    if (!headHasKey) try {
        throw Error(`Cell with ${sortKey} key not found in head.`);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};
const $7f55105045703159$export$a601f1775e10043f = (isRanking, width, height)=>{
    if (!isRanking) return {};
    if (height) return {
        width: width,
        height: height
    };
    return {
        width: width
    };
};
const $7f55105045703159$export$92bcb1ed38b134a1 = (index, page, rowsPerPage)=>{
    const itemOnPreviousPages = rowsPerPage && isFinite(rowsPerPage) ? (page - 1) * rowsPerPage : 0;
    return index + itemOnPreviousPages;
};
const $7f55105045703159$export$c476bbe5da59992d = (rankEnd, rows, page = 1, rowsPerPage)=>{
    const { destination: destination, sourceIndex: sourceIndex } = rankEnd;
    if (!destination) return rows;
    const fromIndex = $7f55105045703159$export$92bcb1ed38b134a1(sourceIndex, page, rowsPerPage);
    const toIndex = $7f55105045703159$export$92bcb1ed38b134a1(destination.index, page, rowsPerPage);
    const reordered = rows.slice();
    const [removed] = reordered.splice(fromIndex, 1);
    reordered.splice(toIndex, 0, removed);
    return reordered;
};

});

parcelRegister("dHbUn", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb6422faa785b221$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");


var $gS5Cm = parcelRequire("gS5Cm");

var $hiWL0 = parcelRequire("hiWL0");

var $kF3yx = parcelRequire("kF3yx");

var $fkvnY = parcelRequire("fkvnY");

var $hK8cd = parcelRequire("hK8cd");

var $dDBI6 = parcelRequire("dDBI6");

var $dk72m = parcelRequire("dk72m");

var $50Tma = parcelRequire("50Tma");

var $jlnvO = parcelRequire("jlnvO");
function $cb6422faa785b221$var$toggleSortOrder(currentSortOrder) {
    switch(currentSortOrder){
        case 0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65:
            return 0, $d43e0bb5a9200c87$export$1dee026a19752d6b;
        case 0, $d43e0bb5a9200c87$export$1dee026a19752d6b:
            return 0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65;
        default:
            return currentSortOrder;
    }
}
const $cb6422faa785b221$var$DynamicTable = ({ caption: caption, head: head, highlightedRowIndex: highlightedRowIndex, rows: rows, sortKey: sortKey, sortOrder: sortOrder, loadingLabel: loadingLabel, onPageRowsUpdate: onPageRowsUpdate, testId: testId, totalRows: passedDownTotalRows, label: label, isLoading: isLoading = false, isFixedSize: isFixedSize = false, rowsPerPage: rowsPerPage = Infinity, onSetPage: onSetPage = (0, $eGmKJ.default), onSort: providedOnSort = (0, $eGmKJ.default), page: page = 1, emptyView: emptyView, isRankable: isRankable = false, isRankingDisabled: isRankingDisabled = false, onRankStart: onRankStart = (0, $eGmKJ.default), onRankEnd: providedOnRankEnd = (0, $eGmKJ.default), loadingSpinnerSize: loadingSpinnerSize, paginationi18n: paginationi18n = {
    prev: 'Previous Page',
    next: 'Next Page',
    label: 'Pagination',
    pageLabel: 'Page'
} })=>{
    const [isRanking, setIsRanking] = (0, $5uXOq.useState)(false);
    const tableBodyRef = (0, $5uXOq.useRef)(null);
    const onSort = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: providedOnSort,
        action: 'sorted',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const onRankEnd = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: providedOnRankEnd,
        action: 'ranked',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    (0, $5uXOq.useEffect)(()=>{
        (0, $gS5Cm.validateSortKey)(sortKey, head);
        (0, $gS5Cm.assertIsSortable)(head);
    }, [
        sortKey,
        head
    ]);
    const onSortHandler = (item)=>()=>{
            const { key: key } = item;
            if (!key) return;
            if (onSort && isRankable && key === sortKey && sortOrder === (0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65)) {
                onSort({
                    key: null,
                    sortOrder: null,
                    item: item
                });
                return;
            }
            const sortOrderFormatted = key !== sortKey ? (0, $d43e0bb5a9200c87$export$1dee026a19752d6b) : $cb6422faa785b221$var$toggleSortOrder(sortOrder);
            if (onSort) onSort({
                key: key,
                item: item,
                sortOrder: sortOrderFormatted
            });
        };
    const onSetPageHandler = (page, event)=>{
        onSetPage(page, event);
    };
    const onRankStartHandler = (params)=>{
        setIsRanking(true);
        onRankStart(params);
    };
    const onRankEndHandler = (params)=>{
        setIsRanking(false);
        onRankEnd(params);
    };
    const getSpinnerSize = ()=>{
        if (loadingSpinnerSize) return loadingSpinnerSize;
        return (0, $gS5Cm.getPageRows)(rows || [], page, rowsPerPage).length > 2 ? (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3) : (0, $d43e0bb5a9200c87$export$71dd4c8ecd45e95f);
    };
    const renderEmptyBody = ()=>{
        if (isLoading) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kF3yx.EmptyViewWithFixedHeight), {
            testId: testId
        });
        return emptyView && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kF3yx.EmptyViewContainer), {
            testId: testId,
            children: emptyView
        });
    };
    const rowsLength = rows && rows.length;
    let totalPages;
    // set a flag to denote the dynamic table might get only one page of data
    // for paginated data
    let isTotalPagesControlledExternally = false;
    if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
        /**
     * If total number of rows / records have been passed down as prop
     * Then table is being fed paginated data from server or other sources
     * In this case, we want to respect information passed down by server or external source
     * Rather than relying on our computation based on number of rows
     */ totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
        isTotalPagesControlledExternally = true;
    } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
    totalPages = totalPages < 1 ? 1 : totalPages;
    const getPageNumber = page > totalPages ? totalPages : page; // page! required, because typescript can't yet see defaultProps to know that this won't be undefined
    const rowsExist = !!rowsLength;
    const spinnerSize = getSpinnerSize();
    const emptyBody = renderEmptyBody();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dk72m.default), {
                isLoading: isLoading && rowsExist,
                spinnerSize: spinnerSize,
                targetRef: ()=>tableBodyRef.current,
                testId: testId,
                loadingLabel: loadingLabel,
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $hiWL0.Table), {
                    isFixedSize: isFixedSize,
                    "aria-label": label,
                    hasDataRow: rowsExist,
                    testId: testId,
                    isLoading: isLoading,
                    children: [
                        !!caption && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hiWL0.Caption), {
                            children: caption
                        }),
                        head && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jlnvO.default), {
                            head: head,
                            onSort: onSortHandler,
                            sortKey: sortKey,
                            sortOrder: sortOrder,
                            isRanking: isRanking,
                            isRankable: isRankable,
                            testId: testId
                        }),
                        rowsExist && /*#__PURE__*/ (0, $2OMIu.jsx)($cb6422faa785b221$var$TableBody, {
                            ref: tableBodyRef,
                            highlightedRowIndex: highlightedRowIndex,
                            rows: rows,
                            head: head,
                            sortKey: sortKey,
                            sortOrder: sortOrder,
                            rowsPerPage: rowsPerPage,
                            page: getPageNumber,
                            isFixedSize: isFixedSize || false,
                            onPageRowsUpdate: onPageRowsUpdate,
                            isTotalPagesControlledExternally: isTotalPagesControlledExternally,
                            testId: testId,
                            isRankable: isRankable,
                            isRanking: isRanking,
                            onRankStart: onRankStartHandler,
                            onRankEnd: onRankEndHandler,
                            isRankingDisabled: isRankingDisabled || isLoading || false
                        })
                    ]
                })
            }),
            totalPages <= 1 ? null : // only show pagination if there's MORE than 1 page
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hiWL0.PaginationWrapper), {
                testId: testId,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $50Tma.default), {
                    value: getPageNumber,
                    onChange: onSetPageHandler,
                    total: totalPages,
                    i18n: paginationi18n,
                    isDisabled: isLoading,
                    testId: testId
                })
            }),
            !rowsExist && emptyBody && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dDBI6.default), {
                isLoading: isLoading,
                spinnerSize: (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3),
                testId: testId,
                loadingLabel: loadingLabel,
                children: emptyBody
            })
        ]
    });
};

const $cb6422faa785b221$var$RankableTableBody = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("hcItm")));
const $cb6422faa785b221$var$TableBody = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function TableBody({ isRankable: isRankable = false, isRanking: isRanking, onRankStart: onRankStart, onRankEnd: onRankEnd, isRankingDisabled: isRankingDisabled, ...bodyProps }, ref) {
    const canRank = isRankable && !bodyProps.sortKey;
    /**
   * React 16 does not support SSR for lazy components,
   * so we avoid rendering the `Suspense` on the server.
   */ const [canRenderRankable, setCanRenderRankable] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (canRank) setCanRenderRankable(true);
    }, [
        canRank
    ]);
    const nonRankableBody = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fkvnY.default), {
        ref: ref,
        ...bodyProps
    });
    return canRank && canRenderRankable ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hK8cd.ErrorBoundary), {
        fallback: nonRankableBody,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
            fallback: nonRankableBody,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($cb6422faa785b221$var$RankableTableBody, {
                ref: ref,
                ...bodyProps,
                isRanking: isRanking,
                onRankStart: onRankStart,
                onRankEnd: onRankEnd,
                isRankingDisabled: isRankingDisabled
            })
        })
    }) : nonRankableBody;
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$cb6422faa785b221$export$2e2bcd8739ae039 = $cb6422faa785b221$var$DynamicTable;

});
const $d43e0bb5a9200c87$export$1dee026a19752d6b = 'ASC';
const $d43e0bb5a9200c87$export$b6abcf7fa1d94f65 = 'DESC';
const $d43e0bb5a9200c87$export$71dd4c8ecd45e95f = 'small';
const $d43e0bb5a9200c87$export$7b93a10c0fefe3e3 = 'large';
const $d43e0bb5a9200c87$export$3843c586a90b9cbf = 0.22;

parcelRegister("hiWL0", function(module, exports) {

$parcel$export(module.exports, "Table", () => $3b29b0d00cd7b5c6$export$54ec01a60f47d33d);
$parcel$export(module.exports, "Caption", () => $3b29b0d00cd7b5c6$export$32fbfacc5d962e0c);
$parcel$export(module.exports, "PaginationWrapper", () => $3b29b0d00cd7b5c6$export$3e5e12dc01f20a43);
/* dynamic-table.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

const $3b29b0d00cd7b5c6$var$fixedSizeTableStyles = null;
const $3b29b0d00cd7b5c6$var$tableStyles = null;
const $3b29b0d00cd7b5c6$var$bodyBorder = null;
const $3b29b0d00cd7b5c6$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ isFixedSize: isFixedSize, hasDataRow: hasDataRow, children: children, testId: testId, isLoading: isLoading, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("table", {
        inert: isLoading ? '' : undefined,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-hover-bg': `var(--ds-background-neutral-subtle-hovered, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-highlighted-bg': `var(--ds-background-selected, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-hover-highlighted-bg': `var(--ds-background-selected-hovered, ${(0, $829f609a65d26a98$export$8c13c2ee36917869)})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-row-focus-outline': `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`
        },
        ref: ref,
        ...rest,
        "data-testid": testId && `${testId}--table`,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _yq5h18uv _btyzidpf _ect41gqc",
            isFixedSize && "_1kqm1n9t",
            hasDataRow && "_179r1on0"
        ]),
        children: children
    });
});
const $3b29b0d00cd7b5c6$var$captionStyles = null;
const $3b29b0d00cd7b5c6$export$32fbfacc5d962e0c = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)("caption", {
        className: (0, $bwpsq.default)([
            "_11c8lodh _6rthu2gc _1pfh1ejb _m6k41e03"
        ]),
        children: children
    });
const $3b29b0d00cd7b5c6$var$paginationWrapperStyles = null;
const $3b29b0d00cd7b5c6$export$3e5e12dc01f20a43 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId && `${testId}--pagination--container`,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o"
        ]),
        children: children
    });

});

parcelRegister("kF3yx", function(module, exports) {

$parcel$export(module.exports, "EmptyViewWithFixedHeight", () => $0852c529eaab7231$export$8f45b9407d4090d7);
$parcel$export(module.exports, "EmptyViewContainer", () => $0852c529eaab7231$export$381ea436de119582);
/* empty-body.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $0852c529eaab7231$var$fixedHeightStyles = null;
const $0852c529eaab7231$export$8f45b9407d4090d7 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId && `${testId}--empty-view-with-fixed-height`,
        className: (0, $bwpsq.default)([
            "_4t3i1jdh"
        ]),
        children: children
    });
const $0852c529eaab7231$var$emptyViewContainerStyles = null;
const $0852c529eaab7231$export$381ea436de119582 = (props)=>{
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId && `${testId}--empty-view-container`,
        className: (0, $bwpsq.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _ca0q19bv _u5f319bv _n3td19bv _19bv19bv _1bsb1ssb _y3gn1h6o"
        ]),
        children: children
    });
};

});

parcelRegister("fkvnY", function(module, exports) {

$parcel$export(module.exports, "default", () => $32bba7afdbc8736a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7bJDt = parcelRequire("7bJDt");

var $ggqAE = parcelRequire("ggqAE");
class $32bba7afdbc8736a$var$BodyComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { pageRows: pageRows, head: head, isFixedSize: isFixedSize, highlightedRowIndex: highlightedRowIndex, testId: testId, forwardedRef: forwardedRef } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)("tbody", {
            "data-testid": testId && `${testId}--body`,
            ref: forwardedRef,
            children: pageRows.map((row, rowIndex)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ggqAE.default), {
                    head: head,
                    isFixedSize: isFixedSize,
                    row: row,
                    isHighlighted: row.isHighlighted || !!highlightedRowIndex && (typeof highlightedRowIndex === 'number' ? highlightedRowIndex === rowIndex : highlightedRowIndex.indexOf(rowIndex) > -1),
                    testId: testId
                }, row.key || rowIndex))
        });
    }
}
const $32bba7afdbc8736a$var$Body = (0, $7bJDt.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)($32bba7afdbc8736a$var$BodyComponent, {
        ...props,
        forwardedRef: ref
    });
}));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$32bba7afdbc8736a$export$2e2bcd8739ae039 = $32bba7afdbc8736a$var$Body;

});
parcelRegister("7bJDt", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc6eeecb3dc05edd$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");


var $gS5Cm = parcelRequire("gS5Cm");
const $dc6eeecb3dc05edd$var$getSortingCellValue = (cells, head, sortKey)=>{
    for(let i = 0; i < cells.length; i++){
        if (head.cells[i] && head.cells[i]?.key === sortKey) return cells[i]?.key;
    }
    return undefined;
};
// sort all rows based on sort key and order
const $dc6eeecb3dc05edd$var$getSortedRows = (head, rows, sortKey, sortOrder)=>{
    if (!sortKey || !head) return rows;
    if (!rows) return [];
    const modifier = sortOrder === (0, $d43e0bb5a9200c87$export$1dee026a19752d6b) ? 1 : -1;
    // Re-initialising an I18n Collator on every sort is performance intensive, thus constructed outside
    const collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: 'accent'
    });
    // Get copy of rows to avoid sorting prop in place
    const sortableRows = Array.from(rows);
    // Reorder rows in table based on sorting cell value
    // Algorithm will sort numerics or strings, but not both
    return sortableRows.sort((a, b)=>{
        const valA = $dc6eeecb3dc05edd$var$getSortingCellValue(a.cells, head, sortKey);
        const valB = $dc6eeecb3dc05edd$var$getSortingCellValue(b.cells, head, sortKey);
        if (valA === undefined || valB === undefined) return modifier;
        if (typeof valA !== typeof valB) {
            // numbers are always grouped higher in the sort
            if (typeof valA === 'number') return -1;
            if (typeof valB === 'number') return 1;
            // strings are grouped next
            if (typeof valA === 'string') return -1;
            if (typeof valB === 'string') return 1;
        }
        if (typeof valA === 'string' && typeof valB === 'string') return modifier * collator.compare(valA, valB);
        if (!valA && valA !== 0 || valA < valB) return -modifier;
        if (!valB && valB !== 0 || valA > valB) return modifier;
        if (valA === valB) return 0;
        return 1;
    });
};
function $dc6eeecb3dc05edd$export$2e2bcd8739ae039(WrappedComponent) {
    class WithSortedPageRows extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
        static getDerivedStateFromProps(props, state) {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, page: page, rowsPerPage: rowsPerPage, isTotalPagesControlledExternally: isTotalPagesControlledExternally } = props;
            (0, $gS5Cm.validateSortKey)(sortKey, head);
            let sortedRows;
            let pageRows;
            if (isTotalPagesControlledExternally) {
                sortedRows = rows;
                pageRows = rows;
            } else {
                sortedRows = $dc6eeecb3dc05edd$var$getSortedRows(head, rows, sortKey, sortOrder) || [];
                pageRows = (0, $gS5Cm.getPageRows)(sortedRows, page, rowsPerPage);
            }
            return {
                ...state,
                pageRows: pageRows
            };
        }
        componentDidMount() {
            this.props.onPageRowsUpdate && this.props.onPageRowsUpdate(this.state.pageRows);
        }
        componentDidUpdate(_prevProps, prevState) {
            if (this.props.onPageRowsUpdate && this.state.pageRows !== prevState.pageRows) this.props.onPageRowsUpdate(this.state.pageRows);
        }
        render() {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, rowsPerPage: rowsPerPage, page: page, forwardedRef: forwardedRef, ...restProps } = this.props;
            return /*#__PURE__*/ (0, $2OMIu.jsx)(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                pageRows: this.state.pageRows,
                head: head,
                ...restProps,
                ref: forwardedRef
            });
        }
        constructor(...args){
            super(...args), this.state = {
                pageRows: []
            };
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)(WithSortedPageRows, {
            ...props,
            forwardedRef: ref
        });
    });
}

});

parcelRegister("ggqAE", function(module, exports) {

$parcel$export(module.exports, "default", () => $136b57fea50cecd2$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $1g0dL = parcelRequire("1g0dL");

var $d9WgS = parcelRequire("d9WgS");
const $136b57fea50cecd2$var$Row = ({ row: row, head: head, testId: testId, isFixedSize: isFixedSize, isHighlighted: isHighlighted })=>{
    const { cells: cells, ...restRowProps } = row;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $d9WgS.TableBodyRow), {
        ...restRowProps,
        isHighlighted: isHighlighted,
        ...isHighlighted ? {
            'data-ts--dynamic-table--table-row--highlighted': true
        } : null,
        testId: row.testId || testId && `${testId}--row-${restRowProps.key}`,
        children: cells.map((cell, cellIndex)=>{
            const { content: content, testId: cellTestId, ...restCellProps } = cell;
            const { shouldTruncate: shouldTruncate, width: width } = (head || {
                cells: []
            }).cells[cellIndex] || {};
            return /*#__PURE__*/ (0, $5uXOq.createElement)((0, $1g0dL.TableBodyCell), {
                "data-testid": cellTestId || testId && `${testId}--cell-${cellIndex}`,
                ...restCellProps,
                isFixedSize: isFixedSize,
                key: cellIndex,
                shouldTruncate: shouldTruncate,
                width: width
            }, content);
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$136b57fea50cecd2$export$2e2bcd8739ae039 = $136b57fea50cecd2$var$Row;

});
parcelRegister("1g0dL", function(module, exports) {

$parcel$export(module.exports, "TableBodyCell", () => $11c3ea74eda01ab8$export$948e91fcef170792);
/* table-cell.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $9GQPi = parcelRequire("9GQPi");
const $11c3ea74eda01ab8$var$fixedSizeTruncateStyles = null;
const $11c3ea74eda01ab8$var$overflowTruncateStyles = null;
const $11c3ea74eda01ab8$var$truncationWidthStyles = null;
const $11c3ea74eda01ab8$var$cellStyles = null;
const $11c3ea74eda01ab8$export$948e91fcef170792 = ({ width: width, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, innerRef: innerRef, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("td", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: (0, $9GQPi.getTruncationStyleVars)({
            width: width
        }),
        // HOC withDimensions complains about the types but it is working fine
        // @ts-ignore
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_1bsb8a2a",
            isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c",
            isFixedSize && "_1reo15vq _18m915vq",
            "_19itglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t",
            props.className
        ]),
        ...props
    });

});
parcelRegister("9GQPi", function(module, exports) {

$parcel$export(module.exports, "getTruncationStyleVars", () => $99c9652c1fab2b08$export$5e6497a652ae30b5);
const $99c9652c1fab2b08$var$CSS_VAR_WIDTH = '--local-dynamic-table-width';
const $99c9652c1fab2b08$export$5e6497a652ae30b5 = ({ width: width })=>typeof width !== 'undefined' ? {
        [$99c9652c1fab2b08$var$CSS_VAR_WIDTH]: `${width}%`
    } : undefined;

});


parcelRegister("d9WgS", function(module, exports) {

$parcel$export(module.exports, "TableBodyRow", () => $ba9cb59faf06ce7f$export$45f39d9c38b886d5);
/* table-row.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $ba9cb59faf06ce7f$var$rowStyles = null;
const $ba9cb59faf06ce7f$var$rowBackgroundStyles = null;
const $ba9cb59faf06ce7f$var$rowHighlightedBackgroundStyles = null;
const $ba9cb59faf06ce7f$export$45f39d9c38b886d5 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ isHighlighted: isHighlighted, children: children, style: style, testId: testId, className: className, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("tr", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        /**
   * We rely on this `className` for the `RankableTableBodyRow` to apply extra styles.
   * With Compiled it needs to be statically analyzable. It does not get applied via spread props.
   */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_bfhk1w7a _1ygbi9un _1ah312gs",
            isHighlighted ? "_bfhktkjs _irr31ae3" : "_irr3s8ts",
            className
        ]),
        ...rest,
        ref: ref,
        "data-testid": testId,
        children: children
    });
});

});



parcelRegister("hK8cd", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $883137116243a6a0$export$e926676385687eaf);

var $5uXOq = parcelRequire("5uXOq");
class $883137116243a6a0$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    render() {
        if (this.state.hasError) // You can render any custom fallback UI
        return this.props.fallback;
        return this.props.children;
    }
}

});

parcelRegister("dDBI6", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e4b90b361173610$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eZJjh = parcelRequire("eZJjh");


var $lLAKY = parcelRequire("lLAKY");
class $2e4b90b361173610$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3),
            contentsOpacity: (0, $d43e0bb5a9200c87$export$3843c586a90b9cbf),
            loadingLabel: 'Loading table'
        };
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, contentsOpacity: contentsOpacity, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $lLAKY.Container), {
            testId: testId,
            children: [
                !isLoading ? children : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lLAKY.ContentsContainer), {
                    contentsOpacity: contentsOpacity,
                    testId: testId,
                    children: children
                }),
                isLoading && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lLAKY.SpinnerContainer), {
                    testId: testId,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {
                        size: spinnerSize,
                        testId: testId && `${testId}--loadingSpinner`,
                        label: loadingLabel
                    })
                })
            ]
        });
    }
}

});
parcelRegister("lLAKY", function(module, exports) {

$parcel$export(module.exports, "Container", () => $d0e2766ad96d94ad$export$42a852a2b6b56249);
$parcel$export(module.exports, "ContentsContainer", () => $d0e2766ad96d94ad$export$67c29eae8ae2137a);
$parcel$export(module.exports, "SpinnerContainer", () => $d0e2766ad96d94ad$export$a5e06607a5ac6158);
/* loading-container.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $d0e2766ad96d94ad$export$c335a80381ec61f5 = '--contents-opacity';
const $d0e2766ad96d94ad$var$containerStyles = null;
const $d0e2766ad96d94ad$export$42a852a2b6b56249 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId && `${testId}--container`,
        className: (0, $bwpsq.default)([
            "_kqswh2mm"
        ]),
        children: children
    });
const $d0e2766ad96d94ad$var$contentsContainerStyles = null;
const $d0e2766ad96d94ad$export$67c29eae8ae2137a = ({ children: children, contentsOpacity: contentsOpacity, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        style: {
            [$d0e2766ad96d94ad$export$c335a80381ec61f5]: contentsOpacity
        },
        "data-testid": testId && `${testId}--contents--container`,
        className: (0, $bwpsq.default)([
            "_tzy4saf5 _lcxvglyw"
        ]),
        children: children
    });
const $d0e2766ad96d94ad$var$spinnerContainerStyles = null;
const $d0e2766ad96d94ad$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId && `${testId}--spinner--container`,
        className: (0, $bwpsq.default)([
            "_1r04idpf _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o"
        ]),
        children: children
    });

});


parcelRegister("dk72m", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba39c903b39a83b1$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eZJjh = parcelRequire("eZJjh");


var $4xXH4 = parcelRequire("4xXH4");
class $ba39c903b39a83b1$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3),
            contentsOpacity: `var(--ds-opacity-loading, ${`${0, $d43e0bb5a9200c87$export$3843c586a90b9cbf}`})`,
            loadingLabel: 'Loading table'
        };
    }
    attachListeners() {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResize);
    }
    detachListeners() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
    }
    updateSpinnerPosition() {
        const viewportHeight = window.innerHeight;
        const targetNode = this.getTargetNode();
        const spinnerNode = this.spinnerRef?.current;
        if (!targetNode || typeof targetNode.getBoundingClientRect !== 'function' || !spinnerNode) return;
        const targetRect = targetNode.getBoundingClientRect();
        const spinnerRect = spinnerNode.getBoundingClientRect();
        const spinnerHeight = spinnerRect.height;
        const isInViewport = this.isVerticallyVisible(targetRect, viewportHeight);
        const { top: top, bottom: bottom, height: height } = targetRect;
        if (isInViewport) {
            // The spinner may follow the element only if there is enough space:
            // Let's say the element can fit at least three spinners (vertically)
            const canFollow = height >= spinnerHeight * 3;
            if (canFollow && !this.isFullyVerticallyVisible(targetRect, viewportHeight)) {
                if (top >= 0) {
                    // Only the head of the element is visible
                    const viewportSpaceTakenByElement = viewportHeight - top;
                    const diff = viewportSpaceTakenByElement / 2 + top - spinnerHeight / 2;
                    const y = viewportSpaceTakenByElement < spinnerHeight * 3 ? top + spinnerHeight : diff;
                    this.translateSpinner(spinnerNode, y, true);
                } else if (top < 0 && bottom > viewportHeight) {
                    // The element takes all viewport, nor its head nor tail are visible
                    const y = viewportHeight / 2 - spinnerHeight / 2;
                    this.translateSpinner(spinnerNode, y, true);
                } else {
                    // Only the tail of the element is visible
                    const diff = bottom / 2 - spinnerHeight / 2;
                    const y = diff < spinnerHeight ? diff - (spinnerHeight - diff) : diff;
                    this.translateSpinner(spinnerNode, y, true);
                }
                return;
            }
        } else {
            // If both the element and the spinner are off screen - quit
            if (!this.isVerticallyVisible(spinnerRect, viewportHeight)) return;
        }
        // Three options here:
        // 1) the element is fully visible
        // 2) the element is too small for the spinner to follow
        // 3) the spinner might still be visible while the element isn't
        const containerNode = this.containerRef?.current;
        if (containerNode && typeof containerNode.getBoundingClientRect === 'function') {
            const thisTop = containerNode.getBoundingClientRect().top;
            const y = (top - thisTop) / 2;
            this.translateSpinner(spinnerNode, y, false);
        }
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $4xXH4.Container), {
            testId: testId && `${testId}--loading--container--advanced`,
            ref: this.containerRef,
            children: [
                children,
                isLoading && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4xXH4.SpinnerBackdrop), {
                    testId: testId,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4xXH4.SpinnerContainer), {
                        ref: this.spinnerRef,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {
                            size: spinnerSize,
                            testId: testId && `${testId}--loadingSpinner`,
                            label: loadingLabel
                        })
                    })
                })
            ]
        });
    }
    constructor(...args){
        super(...args), this.spinnerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.componentDidMount = ()=>{
            if (this.props.isLoading && this.hasTargetNode()) {
                this.attachListeners();
                this.updateTargetAppearance();
                this.updateSpinnerPosition();
            }
        }, this.UNSAFE_componentWillReceiveProps = (nextProps)=>{
            if (!nextProps.isLoading || !this.hasTargetNode(nextProps)) this.detachListeners();
            else if (!this.props.isLoading) this.attachListeners();
        }, this.componentDidUpdate = ()=>{
            if (this.hasTargetNode()) {
                this.updateTargetAppearance();
                if (this.props.isLoading) this.updateSpinnerPosition();
            }
        }, this.componentWillUnmount = ()=>{
            this.detachListeners();
        }, this.getTargetNode = (nextProps = this.props)=>{
            const { targetRef: targetRef } = nextProps;
            const target = targetRef?.();
            return target || this.containerRef.current;
        }, this.hasTargetNode = (nextProps)=>!!this.getTargetNode(nextProps), this.isVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            if (bottom <= 0) return false;
            return top < viewportHeight;
        }, this.isFullyVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            return top >= 0 && bottom <= viewportHeight;
        }, this.handleResize = ()=>{
            this.updateSpinnerPosition();
        }, this.handleScroll = ()=>{
            this.updateSpinnerPosition();
        }, this.translateSpinner = (spinnerNode, transformY, isFixed)=>{
            spinnerNode.style.position = isFixed ? 'fixed' : '';
            spinnerNode.style.transform = transformY !== 0 ? `translate3d(0, ${transformY}px, 0)` : '';
        }, this.updateTargetAppearance = ()=>{
            const targetNode = this.getTargetNode();
            const { isLoading: isLoading, contentsOpacity: contentsOpacity } = this.props;
            if (targetNode && targetNode.style && typeof targetNode.style === 'object') {
                targetNode.style.pointerEvents = isLoading ? 'none' : '';
                targetNode.style.opacity = isLoading ? contentsOpacity.toString() : '';
            }
        };
    }
}

});
parcelRegister("4xXH4", function(module, exports) {

$parcel$export(module.exports, "Container", () => $48301faf1109874f$export$42a852a2b6b56249);
$parcel$export(module.exports, "SpinnerBackdrop", () => $48301faf1109874f$export$aa207050321b0c53);
$parcel$export(module.exports, "SpinnerContainer", () => $48301faf1109874f$export$a5e06607a5ac6158);
/* loading-container-advanced.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $48301faf1109874f$var$containerStyles = null;
const $48301faf1109874f$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { children: children, testId: testId, ...rest } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ...rest,
        "data-testid": testId,
        ref: ref,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _6rth1ejb"
        ]),
        children: children
    });
});
const $48301faf1109874f$var$spinnerBackdropStyles = null;
const $48301faf1109874f$export$aa207050321b0c53 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId && `${testId}--spinner-backdrop`,
        className: (0, $bwpsq.default)([
            "_1r04idpf _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _lcxvglyw"
        ]),
        children: children
    });
const $48301faf1109874f$var$spinnerContainerStyles = null;
const $48301faf1109874f$export$a5e06607a5ac6158 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children }, ref)=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: ref,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _152tidpf"
        ]),
        children: children
    }));

});


parcelRegister("50Tma", function(module, exports) {

$parcel$export(module.exports, "default", () => $21d5ee5c6331aeb9$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $xBgAj = parcelRequire("xBgAj");
class $21d5ee5c6331aeb9$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { total: total, value: value = 1, i18n: i18n, testId: testId, isDisabled: isDisabled } = this.props;
        const pages = [
            ...Array(total)
        ].map((_, index)=>index + 1);
        // Pagination accepts array now thus selectedIndex starts with 0
        // So, we are substracting value by one thus not breaking dynamic table
        const selectedIndex = value - 1;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $xBgAj.default), {
            selectedIndex: selectedIndex,
            isDisabled: isDisabled,
            label: i18n?.label,
            nextLabel: i18n?.next,
            previousLabel: i18n?.prev,
            pageLabel: i18n?.pageLabel,
            onChange: this.onChange,
            pages: pages,
            testId: testId && `${testId}--pagination`
        });
    }
    constructor(...args){
        super(...args), this.onChange = (_event, newValue, analyticsEvent)=>{
            this.props.onChange(newValue, analyticsEvent);
        };
    }
}

});
parcelRegister("xBgAj", function(module, exports) {

$parcel$export(module.exports, "default", () => $8aaadfaafd170b3c$export$2e2bcd8739ae039);
/* pagination.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $33etG = parcelRequire("33etG");

var $fmJTX = parcelRequire("fmJTX");

var $6s76W = parcelRequire("6s76W");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");

var $5HBW9 = parcelRequire("5HBW9");

var $15F6T = parcelRequire("15F6T");

var $lmPue = parcelRequire("lmPue");

var $fc5SA = parcelRequire("fc5SA");

var $gRWrA = parcelRequire("gRWrA");
const $8aaadfaafd170b3c$var$styles = {
    paginationMenu: "_ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t",
    paginationMenuItem: "_1pfhze3t _ect41gqc",
    navigatorIconWrapper: "_18zr12x7"
};
const $8aaadfaafd170b3c$var$analyticsAttributes = {
    componentName: 'pagination',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
function $8aaadfaafd170b3c$var$NavigatorIcon({ chevronDirection: chevronDirection }) {
    const Chevron = chevronDirection === 'left' ? (0, (/*@__PURE__*/$parcel$interopDefault($fmJTX))) : (0, (/*@__PURE__*/$parcel$interopDefault($6s76W)));
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "span",
        xcss: $8aaadfaafd170b3c$var$styles.navigatorIconWrapper,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)(Chevron, {
            label: "",
            LEGACY_margin: `0 ${"var(--ds-space-negative-075, -6px)"}`,
            color: "currentColor"
        })
    });
}
function $8aaadfaafd170b3c$var$InnerPagination({ components: components = (0, $fc5SA.emptyObject), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, $fc5SA.emptyObject), max: max = 7, onChange: onChange = (0, $eGmKJ.default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, $lmPue.default), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
    const [selectedIndexValue, setSelectedIndexValue] = (0, $33etG.default)(selectedIndex, ()=>defaultSelectedIndex || 0);
    const onChangeWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            const { event: event, selectedPageIndex: selectedPageIndex } = value;
            if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
            if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
        },
        action: 'changed',
        actionSubject: 'pageNumber',
        analyticsData: analyticsContext,
        ...$8aaadfaafd170b3c$var$analyticsAttributes
    });
    const transform = (page, currPageIndex, testId)=>{
        const selectedPage = pages[selectedIndexValue];
        const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
        const isCurrentPage = page === selectedPage;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c0aEF.default), {
            as: "li",
            xcss: $8aaadfaafd170b3c$var$styles.paginationMenuItem,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $15F6T.default), {
                component: components.Page,
                onClick: (event)=>onChangeWithAnalytics({
                        event: event,
                        selectedPageIndex: currPageIndex
                    }),
                "aria-current": isCurrentPage ? 'page' : undefined,
                "aria-label": pageIndexLabel,
                isSelected: isCurrentPage,
                isDisabled: isDisabled,
                page: page,
                testId: testId && `${testId}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`,
                children: getPageLabel ? getPageLabel(page, currPageIndex) : page
            })
        }, `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`);
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        testId: testId,
        style: style,
        ref: ref,
        "aria-label": label,
        as: "nav",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
            space: "space.0",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5HBW9.default), {
                    component: components.Previous,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue - 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === 0,
                    iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)($8aaadfaafd170b3c$var$NavigatorIcon, {
                        chevronDirection: "left"
                    }),
                    "aria-label": previousLabel,
                    testId: testId && `${testId}--left-navigator`
                }, "left-navigator"),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c0aEF.default), {
                    space: "space.0",
                    alignBlock: "baseline",
                    as: "ul",
                    xcss: $8aaadfaafd170b3c$var$styles.paginationMenu,
                    children: (0, $gRWrA.default)(pages, selectedIndexValue, {
                        max: max,
                        ellipsis: renderEllipsis,
                        transform: transform
                    }, testId)
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5HBW9.default), {
                    component: components.Next,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue + 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
                    iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)($8aaadfaafd170b3c$var$NavigatorIcon, {
                        chevronDirection: "right"
                    }),
                    "aria-label": nextLabel,
                    testId: testId && `${testId}--right-navigator`
                }, "right-navigator")
            ]
        })
    }));
}
/**
 * __Pagination__
 *
 * Pagination allows you to divide large amounts of content into smaller chunks across multiple pages.
 *
 * - [Examples](https://atlassian.design/components/pagination/examples)
 * - [Code](https://atlassian.design/components/pagination/code)
 * - [Usage](https://atlassian.design/components/pagination/usage)
 */ const $8aaadfaafd170b3c$var$Pagination = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)($8aaadfaafd170b3c$var$InnerPagination));
var $8aaadfaafd170b3c$export$2e2bcd8739ae039 = $8aaadfaafd170b3c$var$Pagination;

});
parcelRegister("fmJTX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f8f114aeec843a8c754b38083d324c3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b2fc843461eabf96$var$_react = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b2fc843461eabf96$var$_chevronLeft = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("lRheX")));

var $b2fc843461eabf96$var$_chevronLeftLarge = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("a88oa")));
function $b2fc843461eabf96$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronLeftIcon.
 * This component is ChevronLeftIcon, with `UNSAFE_fallbackIcon` set to "ChevronLeftLargeIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b2fc843461eabf96$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $b2fc843461eabf96$var$_react.default.createElement($b2fc843461eabf96$var$_chevronLeft.default, Object.assign({
        LEGACY_fallbackIcon: $b2fc843461eabf96$var$_chevronLeftLarge.default
    }, props));
$b2fc843461eabf96$var$ChevronLeftIcon.Name = 'ChevronLeftIconMigration';
var $b2fc843461eabf96$var$_default = module.exports.default = $b2fc843461eabf96$var$ChevronLeftIcon;

});
parcelRegister("lRheX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::29f3eb59553566fe46c3ae42f5cce545>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fe9bebc953515e63$var$_react = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $fe9bebc953515e63$var$_baseNew = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $fe9bebc953515e63$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fe9bebc953515e63$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $fe9bebc953515e63$var$_react.default.createElement($fe9bebc953515e63$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.06 6 3.97-3.97L6.97.97l-4.5 4.5a.75.75 0 0 0 0 1.06l4.5 4.5 1.06-1.06z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$fe9bebc953515e63$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $fe9bebc953515e63$var$_default = module.exports.default = $fe9bebc953515e63$var$ChevronLeftIcon;

});

parcelRegister("a88oa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7601289634e055f6$var$_react = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $7601289634e055f6$var$_chevronLeft = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("ks8FD")));
function $7601289634e055f6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7601289634e055f6$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $7601289634e055f6$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props, {
        newIcon: $7601289634e055f6$var$_chevronLeft.default
    }));
$7601289634e055f6$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $7601289634e055f6$var$_default = module.exports.default = $7601289634e055f6$var$ChevronLeftLargeIcon;

});
parcelRegister("ks8FD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4b851fec559156e1edca3c5f214f4a7f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ee3d25fb52825f26$var$_react = $ee3d25fb52825f26$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ee3d25fb52825f26$var$_baseNew = $ee3d25fb52825f26$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $ee3d25fb52825f26$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ee3d25fb52825f26$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $ee3d25fb52825f26$var$_react.default.createElement($ee3d25fb52825f26$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m9.97 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L5.56 8l5.47-5.47z"/>`
    }, props));
$ee3d25fb52825f26$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $ee3d25fb52825f26$var$_default = module.exports.default = $ee3d25fb52825f26$var$ChevronLeftIcon;

});



parcelRegister("6s76W", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dc9d13c7d9aac3b58cfed9b747dada0b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4b2adfad98efb792$var$_react = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $4b2adfad98efb792$var$_chevronRight = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("3dGN0")));

var $4b2adfad98efb792$var$_chevronRightLarge = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("h1toL")));
function $4b2adfad98efb792$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronRightIcon.
 * This component is ChevronRightIcon, with `UNSAFE_fallbackIcon` set to "ChevronRightLargeIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for menu fly outs and to indicate next in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4b2adfad98efb792$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $4b2adfad98efb792$var$_react.default.createElement($4b2adfad98efb792$var$_chevronRight.default, Object.assign({
        LEGACY_fallbackIcon: $4b2adfad98efb792$var$_chevronRightLarge.default
    }, props));
$4b2adfad98efb792$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
var $4b2adfad98efb792$var$_default = module.exports.default = $4b2adfad98efb792$var$ChevronRightIcon;

});
parcelRegister("h1toL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6495598d3d7027d$var$_react = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $c6495598d3d7027d$var$_chevronRight = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("bpC55")));
function $c6495598d3d7027d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c6495598d3d7027d$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $c6495598d3d7027d$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props, {
        newIcon: $c6495598d3d7027d$var$_chevronRight.default
    }));
$c6495598d3d7027d$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $c6495598d3d7027d$var$_default = module.exports.default = $c6495598d3d7027d$var$ChevronRightLargeIcon;

});


parcelRegister("5HBW9", function(module, exports) {

$parcel$export(module.exports, "default", () => $63acbbc2953d9b5a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");
function $63acbbc2953d9b5a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
        "aria-label": props['aria-label'],
        isDisabled: props.isDisabled,
        iconBefore: props.iconBefore,
        testId: props.testId,
        onClick: props.onClick,
        component: props.component,
        appearance: "subtle"
    });
}

});

parcelRegister("15F6T", function(module, exports) {

$parcel$export(module.exports, "default", () => $097dd42f19f41562$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");
function $097dd42f19f41562$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
        ...props,
        appearance: "subtle"
    });
}

});

parcelRegister("lmPue", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d144cd0d91a90ab$export$2e2bcd8739ae039);
/* render-ellipsis.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
var $dS3PR = parcelRequire("dS3PR");

var $jldZL = parcelRequire("jldZL");
const $3d144cd0d91a90ab$var$styles = {
    container: "_1e0c1txw _kqswh2mm"
};
function $3d144cd0d91a90ab$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "li",
        testId: testId,
        xcss: $3d144cd0d91a90ab$var$styles.container,
        paddingInline: "space.100",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dS3PR.default), {
            testId: testId && `${testId}-text`,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $jldZL.default), {
                    children: [
                        "Skipped pages from ",
                        from,
                        " to ",
                        to
                    ]
                }),
                "\u2026"
            ]
        })
    }, key);
}

});

parcelRegister("fc5SA", function(module, exports) {

$parcel$export(module.exports, "emptyObject", () => $cbef1c2cfb373aca$export$3f860eba1218f8d3);
const $cbef1c2cfb373aca$export$3f860eba1218f8d3 = {};

});

parcelRegister("gRWrA", function(module, exports) {

$parcel$export(module.exports, "default", () => $48fbac64848b775a$export$2e2bcd8739ae039);

var $8QpSo = parcelRequire("8QpSo");
// TODO: comma needed after generic declaration below, or the .tsx file thinks
// it is a JSX element. Tidy up in a future refactor.
const $48fbac64848b775a$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
    const total = pages.length;
    // only need ellipsis if we have more pages than we can display
    const needEllipsis = total > max;
    // show start ellipsis if the current page is further away than max - 4 from the first page
    const hasStartEllipsis = needEllipsis && max - 4 < current;
    // show end ellipsis if the current page is further than total - max + 3 from the last page
    const hasEndEllipsis = needEllipsis && current < total - max + 3;
    const getPageComponents = (0, $8QpSo.default)((startIndex = 0, lastIndex = total)=>{
        return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
    });
    if (!needEllipsis) return getPageComponents(0, total);
    if (hasStartEllipsis && !hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: total - pageCount
            }),
            ...getPageComponents(total - pageCount)
        ];
    }
    if (!hasStartEllipsis && hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, pageCount),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: pageCount + 1,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    }
    // we have both start and end ellipsis
    const pageCount = max - 4;
    return [
        ...getPageComponents(0, 1),
        ellipsis({
            key: 'ellipsis-1',
            testId: testId && `${testId}-ellipsis`,
            from: 2,
            to: current - Math.floor(pageCount / 2)
        }),
        ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
        ellipsis({
            key: 'ellipsis-2',
            testId: testId && `${testId}-ellipsis`,
            from: current + 3,
            to: total - 1
        }),
        ...getPageComponents(total - 1)
    ];
};
var $48fbac64848b775a$export$2e2bcd8739ae039 = $48fbac64848b775a$var$collapseRange;

});



parcelRegister("jlnvO", function(module, exports) {

$parcel$export(module.exports, "default", () => $097ee65829e33b82$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $gS5Cm = parcelRequire("gS5Cm");

var $9Ooyy = parcelRequire("9Ooyy");

var $a41RA = parcelRequire("a41RA");

var $7gEwE = parcelRequire("7gEwE");

var $dpXLF = parcelRequire("dpXLF");

var $BQUUh = parcelRequire("BQUUh");
class $097ee65829e33b82$var$TableHead extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    constructor(props){
        super(props);
        this.state = {
            activeSortButtonId: null
        };
    }
    UNSAFE_componentWillMount() {
        (0, $gS5Cm.validateSortKey)(this.props.sortKey, this.props.head);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, $gS5Cm.validateSortKey)(nextProps.sortKey, nextProps.head);
    }
    render() {
        const { head: head, sortKey: sortKey, sortOrder: sortOrder, isFixedSize: isFixedSize, onSort: onSort, isRanking: isRanking, isRankable: isRankable, testId: testId } = this.props;
        const { activeSortButtonId: activeSortButtonId } = this.state;
        if (!head) return null;
        const HeadCellComponentOld = isRankable ? (0, $7gEwE.default) : (0, $BQUUh.default);
        const HeadCellComponent = isRankable ? (0, $a41RA.default) : (0, $dpXLF.default);
        // TODO: Remove `rest` props and use only what is explicitly in the API.
        // Some tests use this to pass in onClick and other stuff within the `head`
        // variable here, but considering it's not in the API, it should probably
        // be removed.
        const { cells: cells, ...rest } = head;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Ooyy.Head), {
            ...rest,
            isRanking: isRanking,
            testId: testId && `${testId}--head`,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("tr", {
                children: cells.map((cell, index)=>{
                    const { ascendingSortTooltip: ascendingSortTooltip, buttonAriaRoleDescription: buttonAriaRoleDescription, colSpan: colSpan, content: content, descendingSortTooltip: descendingSortTooltip, isIconOnlyHeader: isIconOnlyHeader, isSortable: isSortable, key: key, shouldTruncate: shouldTruncate, testId: cellTestId, width: width, // TODO: Remove `rest` props and use only what is explicitly in
                    // the API.
                    ...restCellProps } = cell;
                    const headCellId = `head-cell-${index}`;
                    const handleClick = ()=>{
                        this.setState({
                            activeSortButtonId: headCellId
                        });
                        if (isSortable) onSort(cell)();
                    };
                    return (0, $VSDnB.fg)('platform-component-visual-refresh') ? /*#__PURE__*/ (0, $2OMIu.jsx)(HeadCellComponent, {
                        colSpan: colSpan,
                        content: content,
                        isFixedSize: isFixedSize,
                        isIconOnlyHeader: isIconOnlyHeader,
                        isSortable: !!isSortable,
                        isRanking: isRanking,
                        headCellId: headCellId,
                        activeSortButtonId: activeSortButtonId,
                        onClick: handleClick,
                        testId: cellTestId || testId,
                        shouldTruncate: shouldTruncate,
                        sortOrder: key === sortKey ? sortOrder : undefined,
                        width: width,
                        ascendingSortTooltip: ascendingSortTooltip,
                        descendingSortTooltip: descendingSortTooltip,
                        buttonAriaRoleDescription: buttonAriaRoleDescription,
                        ...restCellProps
                    }, key || index) : /*#__PURE__*/ (0, $2OMIu.jsx)(HeadCellComponentOld, {
                        colSpan: colSpan,
                        content: content,
                        isFixedSize: isFixedSize,
                        isSortable: !!isSortable,
                        isRanking: isRanking,
                        onClick: isSortable ? onSort(cell) : undefined,
                        testId: cellTestId || testId,
                        shouldTruncate: shouldTruncate,
                        sortOrder: key === sortKey ? sortOrder : undefined,
                        width: width,
                        ...restCellProps
                    }, key || index);
                })
            })
        });
    }
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$097ee65829e33b82$export$2e2bcd8739ae039 = $097ee65829e33b82$var$TableHead;

});
parcelRegister("9Ooyy", function(module, exports) {

$parcel$export(module.exports, "Head", () => $e002e0403dc403bb$export$e93312b7773dfcac);
$parcel$export(module.exports, "HeadCell", () => $e002e0403dc403bb$export$4e8024263ace498b);
/* table-head.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");



var $9GQPi = parcelRequire("9GQPi");
const $e002e0403dc403bb$var$CSS_VAR_TEXT_COLOR = '--local-dynamic-table-text-color';
const $e002e0403dc403bb$var$rankingStyles = null;
const $e002e0403dc403bb$var$headStyles = null;
const $e002e0403dc403bb$var$overflowTruncateStyles = null;
const $e002e0403dc403bb$var$truncationWidthStyles = null;
const $e002e0403dc403bb$var$fixedSizeTruncateStyles = null;
const $e002e0403dc403bb$var$cellStyles = null;
const $e002e0403dc403bb$export$e93312b7773dfcac = ({ isRanking: isRanking, testId: testId, ...props })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("thead", {
        "data-testid": testId,
        ...props,
        className: (0, $bwpsq.default)([
            "_179rglyw",
            isRanking && "_1e0c1ule"
        ])
    });
};
const $e002e0403dc403bb$var$headCellBaseStyles = null;
const $e002e0403dc403bb$var$headCellBaseStylesOld = null;
const $e002e0403dc403bb$var$onClickStyles = null;
const $e002e0403dc403bb$var$baseStyles = null;
const $e002e0403dc403bb$var$ascendingStyles = null;
const $e002e0403dc403bb$var$descendingStyles = null;
const $e002e0403dc403bb$export$4e8024263ace498b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ width: width, children: children, isSortable: isSortable, sortOrder: sortOrder, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, onClick: onClick, style: style, testId: testId, ...rest }, ref)=>{
    const mergedStyles = {
        ...style,
        ...width && (0, $9GQPi.getTruncationStyleVars)({
            width: width
        }),
        [$e002e0403dc403bb$var$CSS_VAR_TEXT_COLOR]: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$e2ef2124cf4024b1)})`
    };
    const isASC = sortOrder === (0, $d43e0bb5a9200c87$export$1dee026a19752d6b);
    const isDESC = sortOrder === (0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65);
    const getFormattedSortOrder = ()=>{
        if (isASC) return 'ascending';
        else if (isDESC) return 'descending';
    };
    // If there is no content in the cell, it should be rendered as an empty `td`, not a `th`.
    // https://dequeuniversity.com/rules/axe/4.7/empty-table-header
    const Component = children ? 'th' : 'td';
    const isVisuallyRefreshed = (0, $VSDnB.fg)('platform-component-visual-refresh');
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        "aria-sort": getFormattedSortOrder(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: mergedStyles,
        onClick: !isVisuallyRefreshed ? onClick : undefined,
        ref: ref,
        "data-testid": testId,
        ...rest,
        className: (0, $bwpsq.default)([
            "_izbqglyw _h7alglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t",
            isVisuallyRefreshed ? "_11c8dcr7 _179r1on0 _mqm2glyw _vchhusvi _kqswh2mm _syaz34id _k48pmoej _y3gn1e5h _s7n4nkob _1ygbvd8c" : "_11c8dcr7 _179r1on0 _mqm2glyw _t51zglyw _191wglyw _vchhusvi _kqswh2mm _syaz34id _k48pmoej _y3gn1e5h _s7n4jp4b _1ygbvd8c",
            !isVisuallyRefreshed && onClick && "_irr3yw9d _d0altlke",
            "_1bsb8a2a",
            isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c",
            isFixedSize && "_1reo15vq _18m915vq",
            !isVisuallyRefreshed && isSortable && "_173zglyw _pw6dglyw _1xgk3acm _1wfn3acm _y9yonqa1 _997wnqa1 _sklb1l7b _1j091l7b _19w61ule _1w611ule _1hvvidpf _n56nidpf _wyc4idpf _1d4oidpf _no7mstnw _qh32stnw _4b5mb3bt _hn3bb3bt _14gsx0bf _cigmx0bf _c77kvia6 _qzvtu2gc _f473via6 _1fpyidpf _a04fh2mm _xv14glyw _58ej1kw7 _1ay31kw7 _mdbq1kw7 _10pp1kw7 _1yw3ze3t _n2fdze3t _8607ze3t _szhwze3t _1g2wwc43 _ze9fwc43 _1lcgnqa1 _at5qnqa1 _o4d71l7b _npl51l7b _1rp11onz _1iornqa1 _oi051l7b _1ehx1onz _19t8nqa1 _1bog1l7b",
            !isVisuallyRefreshed && isASC && "_c77k1thn _142s94yt",
            !isVisuallyRefreshed && isDESC && "_f4731thn _17x894yt"
        ]),
        children: children
    });
});

});

parcelRegister("a41RA", function(module, exports) {

$parcel$export(module.exports, "default", () => $669a06e89a9827f7$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cVljL = parcelRequire("cVljL");

var $gS5Cm = parcelRequire("gS5Cm");

var $dpXLF = parcelRequire("dpXLF");
class $669a06e89a9827f7$var$RankableTableHeadCellComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
        const inlineStyles = (0, $gS5Cm.inlineStylesIfRanking)(isRanking, refWidth);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dpXLF.default), {
            inlineStyles: inlineStyles,
            ...restProps
        });
    }
}
const $669a06e89a9827f7$var$RankableTableHeadCell = (0, $cVljL.default)($669a06e89a9827f7$var$RankableTableHeadCellComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$669a06e89a9827f7$export$2e2bcd8739ae039 = $669a06e89a9827f7$var$RankableTableHeadCell;

});
parcelRegister("cVljL", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3e49a9b167764eb$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $a3e49a9b167764eb$export$2e2bcd8739ae039(WrappedComponent) {
    return class WithDimensions extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
        UNSAFE_componentWillReceiveProps(nextProps) {
            const wasRanking = this.props.isRanking;
            const willRanking = nextProps.isRanking;
            if (willRanking && !wasRanking) this.updateDimensions();
        }
        render() {
            const { refWidth: refWidth, refHeight: refHeight } = this.state;
            return /*#__PURE__*/ (0, $2OMIu.jsx)(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refWidth: refWidth,
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refHeight: refHeight,
                innerRef: this.innerRef,
                ...this.props
            });
        }
        constructor(...args){
            super(...args), this.state = {
                refWidth: 0,
                refHeight: 0
            }, this.innerRef = (ref)=>{
                if (ref && !this.props.isRanking) this.ref = ref;
            }, this.updateDimensions = ()=>{
                if (!this.ref) return;
                const clientRect = this.ref.getBoundingClientRect();
                const { width: width } = clientRect;
                const { height: height } = clientRect;
                if (width !== this.state.refWidth || height !== this.state.refHeight) this.setState({
                    refWidth: width,
                    refHeight: height
                });
            };
        }
    };
}

});

parcelRegister("dpXLF", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9c80f4a483cfd6a$export$2e2bcd8739ae039);
/* table-head-cell.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cC5ib = parcelRequire("cC5ib");

var $kcHZS = parcelRequire("kcHZS");

var $MHKc7 = parcelRequire("MHKc7");
var $bUmQV = parcelRequire("bUmQV");
var $3Lty3 = parcelRequire("3Lty3");
var $dS3PR = parcelRequire("dS3PR");

var $3bDjY = parcelRequire("3bDjY");


var $9Ooyy = parcelRequire("9Ooyy");
const $d9c80f4a483cfd6a$var$styles = {
    buttonWrapper: "_1e0c1txw _bfhk18uv _4cvr1h6o _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _d0altlke",
    sortIconHiddenWrapper: "_1e0c1txw _tzy4idpf _bfhk18uv _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1h7hkb7n",
    sortIconVisibleWrapper: "_1e0c1txw _tzy4kb7n _bfhk18uv _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
    hideIconHeaderWrapper: "_tzy4idpf _18u010v4",
    visibleHeaderWrapper: "_tzy4kb7n _u5f31b66"
};
const $d9c80f4a483cfd6a$var$headCellStyles = {
    headCellContainer: "_1e0c1txw _4cvr1h6o"
};
const $d9c80f4a483cfd6a$var$TableHeadCell = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, sortOrder: sortOrder, onClick: onClick, headCellId: headCellId, activeSortButtonId: activeSortButtonId, ascendingSortTooltip: ascendingSortTooltip = 'Sort ascending', descendingSortTooltip: descendingSortTooltip = 'Sort descending', buttonAriaRoleDescription: buttonAriaRoleDescription = 'Sort button', isIconOnlyHeader: isIconOnlyHeader, ...rest })=>{
    const [isHovered, setIsHovered] = (0, $5uXOq.useState)(false);
    const [isFocused, setIsFocused] = (0, $5uXOq.useState)(false);
    const isActive = headCellId === activeSortButtonId || sortOrder !== undefined;
    const isSortIconVisible = isHovered || isActive || isFocused;
    const isVisibleIconOnlyHeader = isSortIconVisible && isIconOnlyHeader;
    const shouldRenderSortIcon = !isIconOnlyHeader || isSortIconVisible || isIconOnlyHeader && !isFocused;
    const handleFocus = (0, $5uXOq.useCallback)(()=>{
        setIsFocused?.(true);
    }, [
        setIsFocused
    ]);
    const handleBlur = (0, $5uXOq.useCallback)(()=>{
        setIsFocused?.(false);
    }, [
        setIsFocused
    ]);
    const handleMouseEnter = (0, $5uXOq.useCallback)(()=>{
        setIsHovered(true);
    }, [
        setIsHovered
    ]);
    const handleMouseLeave = (0, $5uXOq.useCallback)(()=>{
        setIsHovered(false);
    }, [
        setIsHovered
    ]);
    const visuallyRefreshedButton = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: $d9c80f4a483cfd6a$var$headCellStyles.headCellContainer,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
            content: sortOrder === (0, $d43e0bb5a9200c87$export$1dee026a19752d6b) ? ascendingSortTooltip : descendingSortTooltip,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $3Lty3.default), {
                onClick: onClick,
                xcss: $d9c80f4a483cfd6a$var$styles.buttonWrapper,
                "aria-roledescription": buttonAriaRoleDescription,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bUmQV.default), {
                        xcss: isVisibleIconOnlyHeader ? $d9c80f4a483cfd6a$var$styles.hideIconHeaderWrapper : $d9c80f4a483cfd6a$var$styles.visibleHeaderWrapper,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                            size: "small",
                            color: "color.text.subtle",
                            weight: "bold",
                            maxLines: 1,
                            children: content
                        })
                    }),
                    shouldRenderSortIcon && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bUmQV.default), {
                        xcss: isSortIconVisible ? $d9c80f4a483cfd6a$var$styles.sortIconVisibleWrapper : $d9c80f4a483cfd6a$var$styles.sortIconHiddenWrapper,
                        children: sortOrder === (0, $d43e0bb5a9200c87$export$1dee026a19752d6b) ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kcHZS))), {
                            label: "",
                            color: "var(--ds-text-subtle, #44546F)",
                            testId: testId && `${testId}--up--icon`
                        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cC5ib))), {
                            label: "",
                            color: "var(--ds-text-subtle, #44546F)",
                            testId: testId && `${testId}--down--icon`
                        })
                    })
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Ooyy.HeadCell), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: inlineStyles,
        testId: testId && `${testId}--head--cell`,
        ref: typeof innerRef !== 'string' ? innerRef : null,
        ...rest,
        isSortable: isSortable,
        sortOrder: sortOrder,
        children: isSortable ? visuallyRefreshedButton : content
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d9c80f4a483cfd6a$export$2e2bcd8739ae039 = $d9c80f4a483cfd6a$var$TableHeadCell;

});
parcelRegister("cC5ib", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d7f5a6659a6d5dd6eaa41936b6c8533f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $92ed238f23140736$var$_react = $92ed238f23140736$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $92ed238f23140736$var$_baseNew = $92ed238f23140736$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $92ed238f23140736$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $92ed238f23140736$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $92ed238f23140736$var$_react.default.createElement($92ed238f23140736$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v11.44l3.72-3.72 1.06 1.06-5 5a.75.75 0 0 1-1.06 0l-5-5 1.06-1.06 3.72 3.72V1z" clip-rule="evenodd"/>`
    }, props));
$92ed238f23140736$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $92ed238f23140736$var$_default = module.exports.default = $92ed238f23140736$var$ArrowDownIcon;

});

parcelRegister("kcHZS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd7e8572b743336ba9352499cfa665f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eb570e807ab2e210$var$_react = $eb570e807ab2e210$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $eb570e807ab2e210$var$_baseNew = $eb570e807ab2e210$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $eb570e807ab2e210$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eb570e807ab2e210$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $eb570e807ab2e210$var$_react.default.createElement($eb570e807ab2e210$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 15V3.56l3.72 3.72 1.06-1.06-5-5a.75.75 0 0 0-1.06 0l-5 5 1.06 1.06 3.72-3.72V15z" clip-rule="evenodd"/>`
    }, props));
$eb570e807ab2e210$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $eb570e807ab2e210$var$_default = module.exports.default = $eb570e807ab2e210$var$ArrowUpIcon;

});



parcelRegister("7gEwE", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fc2a0c6e4ccfbc5$export$2e2bcd8739ae039);
// Delete this file when cleaning up platform-component-visual-refresh FG

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cVljL = parcelRequire("cVljL");

var $gS5Cm = parcelRequire("gS5Cm");

var $BQUUh = parcelRequire("BQUUh");
class $5fc2a0c6e4ccfbc5$var$RankableTableHeadCellComponentOld extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
        const inlineStyles = (0, $gS5Cm.inlineStylesIfRanking)(isRanking, refWidth);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $BQUUh.default), {
            inlineStyles: inlineStyles,
            ...restProps
        });
    }
}
const $5fc2a0c6e4ccfbc5$var$RankableTableHeadCellOld = (0, $cVljL.default)($5fc2a0c6e4ccfbc5$var$RankableTableHeadCellComponentOld);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5fc2a0c6e4ccfbc5$export$2e2bcd8739ae039 = $5fc2a0c6e4ccfbc5$var$RankableTableHeadCellOld;

});
parcelRegister("BQUUh", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bd2f57a58531c0d$export$2e2bcd8739ae039);
// Delete this file when cleaning up platform-component-visual-refresh FG

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $9Ooyy = parcelRequire("9Ooyy");
const $4bd2f57a58531c0d$var$TableHeadCellOld = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, onClick: onClick, ...rest })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Ooyy.HeadCell), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: inlineStyles,
        testId: testId && `${testId}--head--cell`,
        ref: typeof innerRef !== 'string' ? innerRef : null,
        ...rest,
        onClick: onClick,
        isSortable: isSortable,
        children: isSortable ? /*#__PURE__*/ (0, $2OMIu.jsx)("button", {
            type: "button",
            "aria-roledescription": "Sort button",
            children: content
        }) : content
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4bd2f57a58531c0d$export$2e2bcd8739ae039 = $4bd2f57a58531c0d$var$TableHeadCellOld;

});



parcelRegister("hcItm", function(module, exports) {

let $c8660dfa442bff40$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $c8660dfa442bff40$var$load("76n7a"),
    $c8660dfa442bff40$var$load("l253H"),
    $c8660dfa442bff40$var$load("etJKP")
]).then(()=>parcelRequire('4THp8'));

});



parcelRegister("2jwCH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e514a79fafb6c57d068e94d2350d1008>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1af6a969f6ce5e7d$var$_react = $1af6a969f6ce5e7d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $1af6a969f6ce5e7d$var$_close = $1af6a969f6ce5e7d$var$_interopRequireDefault((parcelRequire("i28qQ")));

var $1af6a969f6ce5e7d$var$_close2 = $1af6a969f6ce5e7d$var$_interopRequireDefault((parcelRequire("2C7j9")));
function $1af6a969f6ce5e7d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CloseIcon.
 * This component is CloseIcon, with `UNSAFE_fallbackIcon` set to "EditorCloseIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for closing an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1af6a969f6ce5e7d$var$CloseIcon = (props)=>/*#__PURE__*/ $1af6a969f6ce5e7d$var$_react.default.createElement($1af6a969f6ce5e7d$var$_close.default, Object.assign({
        LEGACY_fallbackIcon: $1af6a969f6ce5e7d$var$_close2.default
    }, props));
$1af6a969f6ce5e7d$var$CloseIcon.Name = 'CloseIconMigration';
var $1af6a969f6ce5e7d$var$_default = module.exports.default = $1af6a969f6ce5e7d$var$CloseIcon;

});

parcelRegister("1xLej", function(module, exports) {

$parcel$export(module.exports, "element", () => $11fd8259a8258aa3$export$8454457683f90105);
// Chart element takes a chart type generic which says what kind of overrides we can do

var $9ZuYc = parcelRequire("9ZuYc");

var $2OMIu = parcelRequire("2OMIu");
function $11fd8259a8258aa3$export$8454457683f90105(DefaultComponent, options) {
    var _options$as;
    if (options === void 0) options = {};
    const displayName = DefaultComponent.displayName || DefaultComponent.name || options.displayName;
    const kind = ((_options$as = options.as) === null || _options$as === void 0 ? void 0 : _options$as.kind) || Symbol(displayName);
    if (options.as && !options.as.kind) throw new Error('Invalid "as" component. It must be an `element` or `element.Component` value.');
    /**
   * When used outside its own slot, it will register the override
   * while when its used inside the slot, it will render the component
   */ const ElementComponent = (outerProps)=>{
        const ctx = (0, $9ZuYc.useElements)();
        if (!ctx) throw new Error('Element must be used inside an ElementsProvider');
        // Check if we are rendering under the own ElementComponent, if so, just render
        if (ctx !== null && ctx !== void 0 && ctx.isNested(kind)) return /*#__PURE__*/ (0, $2OMIu.jsx)(DefaultComponent, {
            ...!options.as && ctx.getProps(kind),
            ...outerProps
        });
        else {
            ctx.register(kind, {
                Component: DefaultComponent,
                outerProps: outerProps
            });
            return null;
        }
    };
    ElementComponent.kind = kind;
    // When as is defined we return the component without any slot implementation
    if (options.as) return ElementComponent;
    /**
   * Defines the slot where the element will be rendered, grabbing the implementation from the context
   */ const ElementSlot = (defaultProps)=>{
        const ctx = (0, $9ZuYc.useElements)();
        const { Component: Component = DefaultComponent, outerProps: outerProps } = (ctx === null || ctx === void 0 ? void 0 : ctx.retrieve(kind)) || {};
        const isSelf = Component === DefaultComponent;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9ZuYc.ElementsProvider), {
            kind: kind,
            defaultProps: defaultProps,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                ...isSelf && defaultProps,
                ...outerProps
            })
        });
    };
    ElementSlot.kind = kind;
    ElementSlot.Component = ElementComponent;
    ElementSlot.displayName = `element(${displayName})`;
    return ElementSlot;
}

});

parcelRegister("7rySF", function(module, exports) {

$parcel$export(module.exports, "Title", () => $56b61c97525445d3$export$f99233281efd08a0);
/* title.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $bwpsq = parcelRequire("bwpsq");

var $1xLej = parcelRequire("1xLej");

var $2OMIu = parcelRequire("2OMIu");
const $56b61c97525445d3$var$titleTextStyle = null;
function $56b61c97525445d3$var$Title(_ref) {
    let { children: children } = _ref;
    if (!children) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("h2", {
        className: (0, $bwpsq.default)([
            "_syaz1gjq _11c81bk4 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
        ]),
        children: children
    });
}
const $56b61c97525445d3$export$f99233281efd08a0 = (0, $1xLej.element)($56b61c97525445d3$var$Title);

});

parcelRegister("lCjFE", function(module, exports) {

$parcel$export(module.exports, "multiTimeFormat", () => $fbcc67cc8b4b56fb$export$16cec29b78b14126);
$parcel$export(module.exports, "toSentenceCase", () => $fbcc67cc8b4b56fb$export$dcbb097fa84257c1);
$parcel$export(module.exports, "default", () => $fbcc67cc8b4b56fb$export$2e2bcd8739ae039);

var $cRW5v = parcelRequire("cRW5v");
var $kSdfl = parcelRequire("kSdfl");
var $7yDT1 = parcelRequire("7yDT1");
var $2jkSd = parcelRequire("2jkSd");
var $dayZI = parcelRequire("dayZI");
var $8vb39 = parcelRequire("8vb39");
var $idw3k = parcelRequire("idw3k");

var $duk0X = parcelRequire("duk0X");
const $fbcc67cc8b4b56fb$var$formatNumberAbbreviated = (value)=>{
    if (value === null) return 'null';
    let numberValue;
    if (typeof value === 'string') {
        const parsedValue = Number(value);
        if (isNaN(parsedValue)) return value;
        numberValue = parsedValue;
    } else numberValue = value;
    return new Intl.NumberFormat('en-US', {
        notation: 'compact',
        compactDisplay: 'short'
    }).format(numberValue);
};
const $fbcc67cc8b4b56fb$var$percentChange = (currentValue, previousValue)=>{
    if (previousValue === 0) return (currentValue * 100).toFixed();
    return (Math.abs(previousValue - currentValue) / previousValue * 100).toFixed();
};
const $fbcc67cc8b4b56fb$var$formatMillisecond = (0, $duk0X.timeFormat)('.%L'), $fbcc67cc8b4b56fb$var$formatSecond = (0, $duk0X.timeFormat)(':%S'), $fbcc67cc8b4b56fb$var$formatMinute = (0, $duk0X.timeFormat)('%I:%M'), $fbcc67cc8b4b56fb$var$formatHour = (0, $duk0X.timeFormat)('%I %p'), $fbcc67cc8b4b56fb$var$formatDay = (0, $duk0X.timeFormat)('%b %d'), $fbcc67cc8b4b56fb$var$formatWeek = (0, $duk0X.timeFormat)('%b %d'), $fbcc67cc8b4b56fb$var$formatMonth = (0, $duk0X.timeFormat)('%b'), $fbcc67cc8b4b56fb$var$formatYear = (0, $duk0X.timeFormat)('%Y');
function $fbcc67cc8b4b56fb$export$16cec29b78b14126(date) {
    return ((0, $dayZI.second)(date) < date ? $fbcc67cc8b4b56fb$var$formatMillisecond : (0, $7yDT1.timeMinute)(date) < date ? $fbcc67cc8b4b56fb$var$formatSecond : (0, $kSdfl.timeHour)(date) < date ? $fbcc67cc8b4b56fb$var$formatMinute : (0, $cRW5v.timeDay)(date) < date ? $fbcc67cc8b4b56fb$var$formatHour : (0, $2jkSd.timeMonth)(date) < date ? (0, $8vb39.timeSunday)(date) < date ? $fbcc67cc8b4b56fb$var$formatDay : $fbcc67cc8b4b56fb$var$formatWeek : (0, $idw3k.timeYear)(date) < date ? $fbcc67cc8b4b56fb$var$formatMonth : $fbcc67cc8b4b56fb$var$formatYear)(date);
}
function $fbcc67cc8b4b56fb$export$dcbb097fa84257c1(str) {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}
var $fbcc67cc8b4b56fb$export$2e2bcd8739ae039 = {
    formatNumberAbbreviated: $fbcc67cc8b4b56fb$var$formatNumberAbbreviated,
    percentChange: $fbcc67cc8b4b56fb$var$percentChange,
    multiTimeFormat: $fbcc67cc8b4b56fb$export$16cec29b78b14126,
    toSentenceCase: $fbcc67cc8b4b56fb$export$dcbb097fa84257c1
};

});
parcelRegister("cRW5v", function(module, exports) {

$parcel$export(module.exports, "timeDay", () => $95e77e521447ed47$export$8888529b966033e5);
$parcel$export(module.exports, "utcDay", () => $95e77e521447ed47$export$c8cbc42cefd47140);
$parcel$export(module.exports, "unixDay", () => $95e77e521447ed47$export$fb065be2d7ea4a71);

var $ecWlt = parcelRequire("ecWlt");

var $fUrRw = parcelRequire("fUrRw");
const $95e77e521447ed47$export$8888529b966033e5 = (0, $ecWlt.timeInterval)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $fUrRw.durationMinute)) / (0, $fUrRw.durationDay), (date)=>date.getDate() - 1);
const $95e77e521447ed47$export$6657a54f3034cf45 = $95e77e521447ed47$export$8888529b966033e5.range;
const $95e77e521447ed47$export$c8cbc42cefd47140 = (0, $ecWlt.timeInterval)((date)=>{
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCDate(date.getUTCDate() + step);
}, (start, end)=>{
    return (end - start) / (0, $fUrRw.durationDay);
}, (date)=>{
    return date.getUTCDate() - 1;
});
const $95e77e521447ed47$export$d277e198508549a1 = $95e77e521447ed47$export$c8cbc42cefd47140.range;
const $95e77e521447ed47$export$fb065be2d7ea4a71 = (0, $ecWlt.timeInterval)((date)=>{
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCDate(date.getUTCDate() + step);
}, (start, end)=>{
    return (end - start) / (0, $fUrRw.durationDay);
}, (date)=>{
    return Math.floor(date / (0, $fUrRw.durationDay));
});
const $95e77e521447ed47$export$a491caaf5e9481aa = $95e77e521447ed47$export$fb065be2d7ea4a71.range;

});
parcelRegister("ecWlt", function(module, exports) {

$parcel$export(module.exports, "timeInterval", () => $a57f71df9770069e$export$1a539c8b2950ab40);
const $a57f71df9770069e$var$t0 = new Date, $a57f71df9770069e$var$t1 = new Date;
function $a57f71df9770069e$export$1a539c8b2950ab40(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
    }
    interval.floor = (date)=>{
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = (date)=>{
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = (date)=>{
        const d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = (date, step)=>{
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = (start, stop, step)=>{
        const range = [];
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        let previous;
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = (test)=>{
        return $a57f71df9770069e$export$1a539c8b2950ab40((date)=>{
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, (date, step)=>{
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = (start, end)=>{
            $a57f71df9770069e$var$t0.setTime(+start), $a57f71df9770069e$var$t1.setTime(+end);
            floori($a57f71df9770069e$var$t0), floori($a57f71df9770069e$var$t1);
            return Math.floor(count($a57f71df9770069e$var$t0, $a57f71df9770069e$var$t1));
        };
        interval.every = (step)=>{
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? (d)=>field(d) % step === 0 : (d)=>interval.count(0, d) % step === 0);
        };
    }
    return interval;
}

});

parcelRegister("fUrRw", function(module, exports) {

$parcel$export(module.exports, "durationSecond", () => $b951b2d60ecd41a7$export$79ef0e34099623dc);
$parcel$export(module.exports, "durationMinute", () => $b951b2d60ecd41a7$export$683905d551c33fa9);
$parcel$export(module.exports, "durationHour", () => $b951b2d60ecd41a7$export$4157bf0c8e241659);
$parcel$export(module.exports, "durationDay", () => $b951b2d60ecd41a7$export$353686095f4fbf45);
$parcel$export(module.exports, "durationWeek", () => $b951b2d60ecd41a7$export$c241eb88520d5016);
$parcel$export(module.exports, "durationMonth", () => $b951b2d60ecd41a7$export$ab95684df7020b26);
$parcel$export(module.exports, "durationYear", () => $b951b2d60ecd41a7$export$61f8ee2d834c6959);
const $b951b2d60ecd41a7$export$79ef0e34099623dc = 1000;
const $b951b2d60ecd41a7$export$683905d551c33fa9 = $b951b2d60ecd41a7$export$79ef0e34099623dc * 60;
const $b951b2d60ecd41a7$export$4157bf0c8e241659 = $b951b2d60ecd41a7$export$683905d551c33fa9 * 60;
const $b951b2d60ecd41a7$export$353686095f4fbf45 = $b951b2d60ecd41a7$export$4157bf0c8e241659 * 24;
const $b951b2d60ecd41a7$export$c241eb88520d5016 = $b951b2d60ecd41a7$export$353686095f4fbf45 * 7;
const $b951b2d60ecd41a7$export$ab95684df7020b26 = $b951b2d60ecd41a7$export$353686095f4fbf45 * 30;
const $b951b2d60ecd41a7$export$61f8ee2d834c6959 = $b951b2d60ecd41a7$export$353686095f4fbf45 * 365;

});


parcelRegister("kSdfl", function(module, exports) {

$parcel$export(module.exports, "timeHour", () => $f32320462d9111c0$export$46c68a5833bc315b);
$parcel$export(module.exports, "utcHour", () => $f32320462d9111c0$export$31f6f2b3c63ac75e);

var $ecWlt = parcelRequire("ecWlt");

var $fUrRw = parcelRequire("fUrRw");
const $f32320462d9111c0$export$46c68a5833bc315b = (0, $ecWlt.timeInterval)((date)=>{
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $fUrRw.durationSecond) - date.getMinutes() * (0, $fUrRw.durationMinute));
}, (date, step)=>{
    date.setTime(+date + step * (0, $fUrRw.durationHour));
}, (start, end)=>{
    return (end - start) / (0, $fUrRw.durationHour);
}, (date)=>{
    return date.getHours();
});
const $f32320462d9111c0$export$fb843f9087cd5235 = $f32320462d9111c0$export$46c68a5833bc315b.range;
const $f32320462d9111c0$export$31f6f2b3c63ac75e = (0, $ecWlt.timeInterval)((date)=>{
    date.setUTCMinutes(0, 0, 0);
}, (date, step)=>{
    date.setTime(+date + step * (0, $fUrRw.durationHour));
}, (start, end)=>{
    return (end - start) / (0, $fUrRw.durationHour);
}, (date)=>{
    return date.getUTCHours();
});
const $f32320462d9111c0$export$6e7a76cd5f50b719 = $f32320462d9111c0$export$31f6f2b3c63ac75e.range;

});

parcelRegister("7yDT1", function(module, exports) {

$parcel$export(module.exports, "timeMinute", () => $580aa6047b58c4b1$export$a7e4c34a52f0576);
$parcel$export(module.exports, "utcMinute", () => $580aa6047b58c4b1$export$efe6712d6003761b);

var $ecWlt = parcelRequire("ecWlt");

var $fUrRw = parcelRequire("fUrRw");
const $580aa6047b58c4b1$export$a7e4c34a52f0576 = (0, $ecWlt.timeInterval)((date)=>{
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $fUrRw.durationSecond));
}, (date, step)=>{
    date.setTime(+date + step * (0, $fUrRw.durationMinute));
}, (start, end)=>{
    return (end - start) / (0, $fUrRw.durationMinute);
}, (date)=>{
    return date.getMinutes();
});
const $580aa6047b58c4b1$export$186d65358374c0a2 = $580aa6047b58c4b1$export$a7e4c34a52f0576.range;
const $580aa6047b58c4b1$export$efe6712d6003761b = (0, $ecWlt.timeInterval)((date)=>{
    date.setUTCSeconds(0, 0);
}, (date, step)=>{
    date.setTime(+date + step * (0, $fUrRw.durationMinute));
}, (start, end)=>{
    return (end - start) / (0, $fUrRw.durationMinute);
}, (date)=>{
    return date.getUTCMinutes();
});
const $580aa6047b58c4b1$export$cedd563624e8ee50 = $580aa6047b58c4b1$export$efe6712d6003761b.range;

});

parcelRegister("2jkSd", function(module, exports) {

$parcel$export(module.exports, "timeMonth", () => $1aed8c22031a7431$export$7e1084fb688591c1);
$parcel$export(module.exports, "utcMonth", () => $1aed8c22031a7431$export$cd49b3d2bcfe50d5);

var $ecWlt = parcelRequire("ecWlt");
const $1aed8c22031a7431$export$7e1084fb688591c1 = (0, $ecWlt.timeInterval)((date)=>{
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setMonth(date.getMonth() + step);
}, (start, end)=>{
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, (date)=>{
    return date.getMonth();
});
const $1aed8c22031a7431$export$3e24aa839cd0f1c4 = $1aed8c22031a7431$export$7e1084fb688591c1.range;
const $1aed8c22031a7431$export$cd49b3d2bcfe50d5 = (0, $ecWlt.timeInterval)((date)=>{
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCMonth(date.getUTCMonth() + step);
}, (start, end)=>{
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, (date)=>{
    return date.getUTCMonth();
});
const $1aed8c22031a7431$export$49159f585997498 = $1aed8c22031a7431$export$cd49b3d2bcfe50d5.range;

});

parcelRegister("dayZI", function(module, exports) {

$parcel$export(module.exports, "second", () => $99675ab62f0ed735$export$3d3c77ce7df7d30d);

var $ecWlt = parcelRequire("ecWlt");

var $fUrRw = parcelRequire("fUrRw");
const $99675ab62f0ed735$export$3d3c77ce7df7d30d = (0, $ecWlt.timeInterval)((date)=>{
    date.setTime(date - date.getMilliseconds());
}, (date, step)=>{
    date.setTime(+date + step * (0, $fUrRw.durationSecond));
}, (start, end)=>{
    return (end - start) / (0, $fUrRw.durationSecond);
}, (date)=>{
    return date.getUTCSeconds();
});
const $99675ab62f0ed735$export$4792e48abc550fa1 = $99675ab62f0ed735$export$3d3c77ce7df7d30d.range;

});

parcelRegister("8vb39", function(module, exports) {

$parcel$export(module.exports, "timeSunday", () => $6309ca3cb2286854$export$22ee6205b762968c);
$parcel$export(module.exports, "timeMonday", () => $6309ca3cb2286854$export$e79bbe0177cf1b01);
$parcel$export(module.exports, "timeTuesday", () => $6309ca3cb2286854$export$57c0658c29f77708);
$parcel$export(module.exports, "timeWednesday", () => $6309ca3cb2286854$export$3fbeef226c256e43);
$parcel$export(module.exports, "timeThursday", () => $6309ca3cb2286854$export$608689422d5cf9f4);
$parcel$export(module.exports, "timeFriday", () => $6309ca3cb2286854$export$548e5227aa183dca);
$parcel$export(module.exports, "timeSaturday", () => $6309ca3cb2286854$export$c56a3ad248908e19);
$parcel$export(module.exports, "utcSunday", () => $6309ca3cb2286854$export$4898b06303a92011);
$parcel$export(module.exports, "utcMonday", () => $6309ca3cb2286854$export$9cfc53b9cfafd080);
$parcel$export(module.exports, "utcTuesday", () => $6309ca3cb2286854$export$2a6d545f77eceb15);
$parcel$export(module.exports, "utcWednesday", () => $6309ca3cb2286854$export$a5c25d8ed64433c4);
$parcel$export(module.exports, "utcThursday", () => $6309ca3cb2286854$export$1db08111baec2f53);
$parcel$export(module.exports, "utcFriday", () => $6309ca3cb2286854$export$29265e34dd5921f7);
$parcel$export(module.exports, "utcSaturday", () => $6309ca3cb2286854$export$85b74dad05049604);

var $ecWlt = parcelRequire("ecWlt");

var $fUrRw = parcelRequire("fUrRw");
function $6309ca3cb2286854$var$timeWeekday(i) {
    return (0, $ecWlt.timeInterval)((date)=>{
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setDate(date.getDate() + step * 7);
    }, (start, end)=>{
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $fUrRw.durationMinute)) / (0, $fUrRw.durationWeek);
    });
}
const $6309ca3cb2286854$export$22ee6205b762968c = $6309ca3cb2286854$var$timeWeekday(0);
const $6309ca3cb2286854$export$e79bbe0177cf1b01 = $6309ca3cb2286854$var$timeWeekday(1);
const $6309ca3cb2286854$export$57c0658c29f77708 = $6309ca3cb2286854$var$timeWeekday(2);
const $6309ca3cb2286854$export$3fbeef226c256e43 = $6309ca3cb2286854$var$timeWeekday(3);
const $6309ca3cb2286854$export$608689422d5cf9f4 = $6309ca3cb2286854$var$timeWeekday(4);
const $6309ca3cb2286854$export$548e5227aa183dca = $6309ca3cb2286854$var$timeWeekday(5);
const $6309ca3cb2286854$export$c56a3ad248908e19 = $6309ca3cb2286854$var$timeWeekday(6);
const $6309ca3cb2286854$export$eac514c8a8674eba = $6309ca3cb2286854$export$22ee6205b762968c.range;
const $6309ca3cb2286854$export$f7219b1481948356 = $6309ca3cb2286854$export$e79bbe0177cf1b01.range;
const $6309ca3cb2286854$export$77e22b12c5bed05b = $6309ca3cb2286854$export$57c0658c29f77708.range;
const $6309ca3cb2286854$export$b85d407a471809e8 = $6309ca3cb2286854$export$3fbeef226c256e43.range;
const $6309ca3cb2286854$export$c1bc1c49254c8855 = $6309ca3cb2286854$export$608689422d5cf9f4.range;
const $6309ca3cb2286854$export$3691a1557fff46f1 = $6309ca3cb2286854$export$548e5227aa183dca.range;
const $6309ca3cb2286854$export$b755452d02cba8d2 = $6309ca3cb2286854$export$c56a3ad248908e19.range;
function $6309ca3cb2286854$var$utcWeekday(i) {
    return (0, $ecWlt.timeInterval)((date)=>{
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, (start, end)=>{
        return (end - start) / (0, $fUrRw.durationWeek);
    });
}
const $6309ca3cb2286854$export$4898b06303a92011 = $6309ca3cb2286854$var$utcWeekday(0);
const $6309ca3cb2286854$export$9cfc53b9cfafd080 = $6309ca3cb2286854$var$utcWeekday(1);
const $6309ca3cb2286854$export$2a6d545f77eceb15 = $6309ca3cb2286854$var$utcWeekday(2);
const $6309ca3cb2286854$export$a5c25d8ed64433c4 = $6309ca3cb2286854$var$utcWeekday(3);
const $6309ca3cb2286854$export$1db08111baec2f53 = $6309ca3cb2286854$var$utcWeekday(4);
const $6309ca3cb2286854$export$29265e34dd5921f7 = $6309ca3cb2286854$var$utcWeekday(5);
const $6309ca3cb2286854$export$85b74dad05049604 = $6309ca3cb2286854$var$utcWeekday(6);
const $6309ca3cb2286854$export$6f3e1c2b0f7d7880 = $6309ca3cb2286854$export$4898b06303a92011.range;
const $6309ca3cb2286854$export$1d2d8b858bb366f9 = $6309ca3cb2286854$export$9cfc53b9cfafd080.range;
const $6309ca3cb2286854$export$1d5f6785fc7f30f8 = $6309ca3cb2286854$export$2a6d545f77eceb15.range;
const $6309ca3cb2286854$export$7a75faf0e37ef4af = $6309ca3cb2286854$export$a5c25d8ed64433c4.range;
const $6309ca3cb2286854$export$417eb959611b2f2f = $6309ca3cb2286854$export$1db08111baec2f53.range;
const $6309ca3cb2286854$export$59d308db7af08c64 = $6309ca3cb2286854$export$29265e34dd5921f7.range;
const $6309ca3cb2286854$export$a124108a0a7f34c8 = $6309ca3cb2286854$export$85b74dad05049604.range;

});

parcelRegister("idw3k", function(module, exports) {

$parcel$export(module.exports, "timeYear", () => $d4324de4c61acb39$export$cd17cfe45df0c046);
$parcel$export(module.exports, "utcYear", () => $d4324de4c61acb39$export$d5c3802e389714c4);

var $ecWlt = parcelRequire("ecWlt");
const $d4324de4c61acb39$export$cd17cfe45df0c046 = (0, $ecWlt.timeInterval)((date)=>{
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setFullYear(date.getFullYear() + step);
}, (start, end)=>{
    return end.getFullYear() - start.getFullYear();
}, (date)=>{
    return date.getFullYear();
});
// An optimized implementation for this simple case.
$d4324de4c61acb39$export$cd17cfe45df0c046.every = (k)=>{
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $ecWlt.timeInterval)((date)=>{
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setFullYear(date.getFullYear() + step * k);
    });
};
const $d4324de4c61acb39$export$69a4e90dd2cc3bd1 = $d4324de4c61acb39$export$cd17cfe45df0c046.range;
const $d4324de4c61acb39$export$d5c3802e389714c4 = (0, $ecWlt.timeInterval)((date)=>{
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, (start, end)=>{
    return end.getUTCFullYear() - start.getUTCFullYear();
}, (date)=>{
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
$d4324de4c61acb39$export$d5c3802e389714c4.every = (k)=>{
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $ecWlt.timeInterval)((date)=>{
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
const $d4324de4c61acb39$export$3e24d311e17f5802 = $d4324de4c61acb39$export$d5c3802e389714c4.range;

});

parcelRegister("duk0X", function(module, exports) {

$parcel$export(module.exports, "timeFormat", () => $9d1d9a25801dc2bc$export$94f4d87fad5dcf9a);
$parcel$export(module.exports, "timeParse", () => $9d1d9a25801dc2bc$export$32b9cd16e1b8c8d2);
$parcel$export(module.exports, "utcFormat", () => $9d1d9a25801dc2bc$export$1a08fe38f63ebbbb);
$parcel$export(module.exports, "utcParse", () => $9d1d9a25801dc2bc$export$3edae9cf8e233729);

var $7X48q = parcelRequire("7X48q");
var $9d1d9a25801dc2bc$var$locale;
var $9d1d9a25801dc2bc$export$94f4d87fad5dcf9a;
var $9d1d9a25801dc2bc$export$32b9cd16e1b8c8d2;
var $9d1d9a25801dc2bc$export$1a08fe38f63ebbbb;
var $9d1d9a25801dc2bc$export$3edae9cf8e233729;
$9d1d9a25801dc2bc$export$2e2bcd8739ae039({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $9d1d9a25801dc2bc$export$2e2bcd8739ae039(definition) {
    $9d1d9a25801dc2bc$var$locale = (0, $7X48q.default)(definition);
    $9d1d9a25801dc2bc$export$94f4d87fad5dcf9a = $9d1d9a25801dc2bc$var$locale.format;
    $9d1d9a25801dc2bc$export$32b9cd16e1b8c8d2 = $9d1d9a25801dc2bc$var$locale.parse;
    $9d1d9a25801dc2bc$export$1a08fe38f63ebbbb = $9d1d9a25801dc2bc$var$locale.utcFormat;
    $9d1d9a25801dc2bc$export$3edae9cf8e233729 = $9d1d9a25801dc2bc$var$locale.utcParse;
    return $9d1d9a25801dc2bc$var$locale;
}

});
parcelRegister("7X48q", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ca140376c7a3a5b$export$2e2bcd8739ae039);

var $cRW5v = parcelRequire("cRW5v");
var $8vb39 = parcelRequire("8vb39");
var $idw3k = parcelRequire("idw3k");
function $5ca140376c7a3a5b$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $5ca140376c7a3a5b$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $5ca140376c7a3a5b$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $5ca140376c7a3a5b$export$2e2bcd8739ae039(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $5ca140376c7a3a5b$var$formatRe(locale_periods), periodLookup = $5ca140376c7a3a5b$var$formatLookup(locale_periods), weekdayRe = $5ca140376c7a3a5b$var$formatRe(locale_weekdays), weekdayLookup = $5ca140376c7a3a5b$var$formatLookup(locale_weekdays), shortWeekdayRe = $5ca140376c7a3a5b$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $5ca140376c7a3a5b$var$formatLookup(locale_shortWeekdays), monthRe = $5ca140376c7a3a5b$var$formatRe(locale_months), monthLookup = $5ca140376c7a3a5b$var$formatLookup(locale_months), shortMonthRe = $5ca140376c7a3a5b$var$formatRe(locale_shortMonths), shortMonthLookup = $5ca140376c7a3a5b$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $5ca140376c7a3a5b$var$formatDayOfMonth,
        "e": $5ca140376c7a3a5b$var$formatDayOfMonth,
        "f": $5ca140376c7a3a5b$var$formatMicroseconds,
        "g": $5ca140376c7a3a5b$var$formatYearISO,
        "G": $5ca140376c7a3a5b$var$formatFullYearISO,
        "H": $5ca140376c7a3a5b$var$formatHour24,
        "I": $5ca140376c7a3a5b$var$formatHour12,
        "j": $5ca140376c7a3a5b$var$formatDayOfYear,
        "L": $5ca140376c7a3a5b$var$formatMilliseconds,
        "m": $5ca140376c7a3a5b$var$formatMonthNumber,
        "M": $5ca140376c7a3a5b$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $5ca140376c7a3a5b$var$formatUnixTimestamp,
        "s": $5ca140376c7a3a5b$var$formatUnixTimestampSeconds,
        "S": $5ca140376c7a3a5b$var$formatSeconds,
        "u": $5ca140376c7a3a5b$var$formatWeekdayNumberMonday,
        "U": $5ca140376c7a3a5b$var$formatWeekNumberSunday,
        "V": $5ca140376c7a3a5b$var$formatWeekNumberISO,
        "w": $5ca140376c7a3a5b$var$formatWeekdayNumberSunday,
        "W": $5ca140376c7a3a5b$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $5ca140376c7a3a5b$var$formatYear,
        "Y": $5ca140376c7a3a5b$var$formatFullYear,
        "Z": $5ca140376c7a3a5b$var$formatZone,
        "%": $5ca140376c7a3a5b$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $5ca140376c7a3a5b$var$formatUTCDayOfMonth,
        "e": $5ca140376c7a3a5b$var$formatUTCDayOfMonth,
        "f": $5ca140376c7a3a5b$var$formatUTCMicroseconds,
        "g": $5ca140376c7a3a5b$var$formatUTCYearISO,
        "G": $5ca140376c7a3a5b$var$formatUTCFullYearISO,
        "H": $5ca140376c7a3a5b$var$formatUTCHour24,
        "I": $5ca140376c7a3a5b$var$formatUTCHour12,
        "j": $5ca140376c7a3a5b$var$formatUTCDayOfYear,
        "L": $5ca140376c7a3a5b$var$formatUTCMilliseconds,
        "m": $5ca140376c7a3a5b$var$formatUTCMonthNumber,
        "M": $5ca140376c7a3a5b$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $5ca140376c7a3a5b$var$formatUnixTimestamp,
        "s": $5ca140376c7a3a5b$var$formatUnixTimestampSeconds,
        "S": $5ca140376c7a3a5b$var$formatUTCSeconds,
        "u": $5ca140376c7a3a5b$var$formatUTCWeekdayNumberMonday,
        "U": $5ca140376c7a3a5b$var$formatUTCWeekNumberSunday,
        "V": $5ca140376c7a3a5b$var$formatUTCWeekNumberISO,
        "w": $5ca140376c7a3a5b$var$formatUTCWeekdayNumberSunday,
        "W": $5ca140376c7a3a5b$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $5ca140376c7a3a5b$var$formatUTCYear,
        "Y": $5ca140376c7a3a5b$var$formatUTCFullYear,
        "Z": $5ca140376c7a3a5b$var$formatUTCZone,
        "%": $5ca140376c7a3a5b$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $5ca140376c7a3a5b$var$parseDayOfMonth,
        "e": $5ca140376c7a3a5b$var$parseDayOfMonth,
        "f": $5ca140376c7a3a5b$var$parseMicroseconds,
        "g": $5ca140376c7a3a5b$var$parseYear,
        "G": $5ca140376c7a3a5b$var$parseFullYear,
        "H": $5ca140376c7a3a5b$var$parseHour24,
        "I": $5ca140376c7a3a5b$var$parseHour24,
        "j": $5ca140376c7a3a5b$var$parseDayOfYear,
        "L": $5ca140376c7a3a5b$var$parseMilliseconds,
        "m": $5ca140376c7a3a5b$var$parseMonthNumber,
        "M": $5ca140376c7a3a5b$var$parseMinutes,
        "p": parsePeriod,
        "q": $5ca140376c7a3a5b$var$parseQuarter,
        "Q": $5ca140376c7a3a5b$var$parseUnixTimestamp,
        "s": $5ca140376c7a3a5b$var$parseUnixTimestampSeconds,
        "S": $5ca140376c7a3a5b$var$parseSeconds,
        "u": $5ca140376c7a3a5b$var$parseWeekdayNumberMonday,
        "U": $5ca140376c7a3a5b$var$parseWeekNumberSunday,
        "V": $5ca140376c7a3a5b$var$parseWeekNumberISO,
        "w": $5ca140376c7a3a5b$var$parseWeekdayNumberSunday,
        "W": $5ca140376c7a3a5b$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $5ca140376c7a3a5b$var$parseYear,
        "Y": $5ca140376c7a3a5b$var$parseFullYear,
        "Z": $5ca140376c7a3a5b$var$parseZone,
        "%": $5ca140376c7a3a5b$var$parseLiteralPercent
    };
    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $5ca140376c7a3a5b$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $5ca140376c7a3a5b$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null;
            // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
            // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0;
            // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0;
            // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $5ca140376c7a3a5b$var$utcDate($5ca140376c7a3a5b$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? (0, $8vb39.utcMonday).ceil(week) : (0, $8vb39.utcMonday)(week);
                    week = (0, $cRW5v.utcDay).offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $5ca140376c7a3a5b$var$localDate($5ca140376c7a3a5b$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? (0, $8vb39.timeMonday).ceil(week) : (0, $8vb39.timeMonday)(week);
                    week = (0, $cRW5v.timeDay).offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $5ca140376c7a3a5b$var$utcDate($5ca140376c7a3a5b$var$newDate(d.y, 0, 1)).getUTCDay() : $5ca140376c7a3a5b$var$localDate($5ca140376c7a3a5b$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            }
            // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $5ca140376c7a3a5b$var$utcDate(d);
            }
            // Otherwise, all fields are in local time.
            return $5ca140376c7a3a5b$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $5ca140376c7a3a5b$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $5ca140376c7a3a5b$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $5ca140376c7a3a5b$var$numberRe = /^\s*\d+/, $5ca140376c7a3a5b$var$percentRe = /^%/, $5ca140376c7a3a5b$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $5ca140376c7a3a5b$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $5ca140376c7a3a5b$var$requote(s) {
    return s.replace($5ca140376c7a3a5b$var$requoteRe, "\\$&");
}
function $5ca140376c7a3a5b$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($5ca140376c7a3a5b$var$requote).join("|") + ")", "i");
}
function $5ca140376c7a3a5b$var$formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function $5ca140376c7a3a5b$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $5ca140376c7a3a5b$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $5ca140376c7a3a5b$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $5ca140376c7a3a5b$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $5ca140376c7a3a5b$var$parseWeekNumberSunday(d, string, i) {
    var n = $5ca140376c7a3a5b$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $5ca140376c7a3a5b$var$parseWeekNumberISO(d, string, i) {
    var n = $5ca140376c7a3a5b$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $5ca140376c7a3a5b$var$parseWeekNumberMonday(d, string, i) {
    var n = $5ca140376c7a3a5b$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $5ca140376c7a3a5b$var$parseFullYear(d, string, i) {
    var n = $5ca140376c7a3a5b$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $5ca140376c7a3a5b$var$parseYear(d, string, i) {
    var n = $5ca140376c7a3a5b$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $5ca140376c7a3a5b$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $5ca140376c7a3a5b$var$parseQuarter(d, string, i) {
    var n = $5ca140376c7a3a5b$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $5ca140376c7a3a5b$var$parseMonthNumber(d, string, i) {
    var n = $5ca140376c7a3a5b$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $5ca140376c7a3a5b$var$parseDayOfMonth(d, string, i) {
    var n = $5ca140376c7a3a5b$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $5ca140376c7a3a5b$var$parseDayOfYear(d, string, i) {
    var n = $5ca140376c7a3a5b$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $5ca140376c7a3a5b$var$parseHour24(d, string, i) {
    var n = $5ca140376c7a3a5b$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $5ca140376c7a3a5b$var$parseMinutes(d, string, i) {
    var n = $5ca140376c7a3a5b$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $5ca140376c7a3a5b$var$parseSeconds(d, string, i) {
    var n = $5ca140376c7a3a5b$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $5ca140376c7a3a5b$var$parseMilliseconds(d, string, i) {
    var n = $5ca140376c7a3a5b$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $5ca140376c7a3a5b$var$parseMicroseconds(d, string, i) {
    var n = $5ca140376c7a3a5b$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $5ca140376c7a3a5b$var$parseLiteralPercent(d, string, i) {
    var n = $5ca140376c7a3a5b$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $5ca140376c7a3a5b$var$parseUnixTimestamp(d, string, i) {
    var n = $5ca140376c7a3a5b$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $5ca140376c7a3a5b$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $5ca140376c7a3a5b$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $5ca140376c7a3a5b$var$formatDayOfMonth(d, p) {
    return $5ca140376c7a3a5b$var$pad(d.getDate(), p, 2);
}
function $5ca140376c7a3a5b$var$formatHour24(d, p) {
    return $5ca140376c7a3a5b$var$pad(d.getHours(), p, 2);
}
function $5ca140376c7a3a5b$var$formatHour12(d, p) {
    return $5ca140376c7a3a5b$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $5ca140376c7a3a5b$var$formatDayOfYear(d, p) {
    return $5ca140376c7a3a5b$var$pad(1 + (0, $cRW5v.timeDay).count((0, $idw3k.timeYear)(d), d), p, 3);
}
function $5ca140376c7a3a5b$var$formatMilliseconds(d, p) {
    return $5ca140376c7a3a5b$var$pad(d.getMilliseconds(), p, 3);
}
function $5ca140376c7a3a5b$var$formatMicroseconds(d, p) {
    return $5ca140376c7a3a5b$var$formatMilliseconds(d, p) + "000";
}
function $5ca140376c7a3a5b$var$formatMonthNumber(d, p) {
    return $5ca140376c7a3a5b$var$pad(d.getMonth() + 1, p, 2);
}
function $5ca140376c7a3a5b$var$formatMinutes(d, p) {
    return $5ca140376c7a3a5b$var$pad(d.getMinutes(), p, 2);
}
function $5ca140376c7a3a5b$var$formatSeconds(d, p) {
    return $5ca140376c7a3a5b$var$pad(d.getSeconds(), p, 2);
}
function $5ca140376c7a3a5b$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $5ca140376c7a3a5b$var$formatWeekNumberSunday(d, p) {
    return $5ca140376c7a3a5b$var$pad((0, $8vb39.timeSunday).count((0, $idw3k.timeYear)(d) - 1, d), p, 2);
}
function $5ca140376c7a3a5b$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $8vb39.timeThursday)(d) : (0, $8vb39.timeThursday).ceil(d);
}
function $5ca140376c7a3a5b$var$formatWeekNumberISO(d, p) {
    d = $5ca140376c7a3a5b$var$dISO(d);
    return $5ca140376c7a3a5b$var$pad((0, $8vb39.timeThursday).count((0, $idw3k.timeYear)(d), d) + ((0, $idw3k.timeYear)(d).getDay() === 4), p, 2);
}
function $5ca140376c7a3a5b$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $5ca140376c7a3a5b$var$formatWeekNumberMonday(d, p) {
    return $5ca140376c7a3a5b$var$pad((0, $8vb39.timeMonday).count((0, $idw3k.timeYear)(d) - 1, d), p, 2);
}
function $5ca140376c7a3a5b$var$formatYear(d, p) {
    return $5ca140376c7a3a5b$var$pad(d.getFullYear() % 100, p, 2);
}
function $5ca140376c7a3a5b$var$formatYearISO(d, p) {
    d = $5ca140376c7a3a5b$var$dISO(d);
    return $5ca140376c7a3a5b$var$pad(d.getFullYear() % 100, p, 2);
}
function $5ca140376c7a3a5b$var$formatFullYear(d, p) {
    return $5ca140376c7a3a5b$var$pad(d.getFullYear() % 10000, p, 4);
}
function $5ca140376c7a3a5b$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $8vb39.timeThursday)(d) : (0, $8vb39.timeThursday).ceil(d);
    return $5ca140376c7a3a5b$var$pad(d.getFullYear() % 10000, p, 4);
}
function $5ca140376c7a3a5b$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $5ca140376c7a3a5b$var$pad(z / 60 | 0, "0", 2) + $5ca140376c7a3a5b$var$pad(z % 60, "0", 2);
}
function $5ca140376c7a3a5b$var$formatUTCDayOfMonth(d, p) {
    return $5ca140376c7a3a5b$var$pad(d.getUTCDate(), p, 2);
}
function $5ca140376c7a3a5b$var$formatUTCHour24(d, p) {
    return $5ca140376c7a3a5b$var$pad(d.getUTCHours(), p, 2);
}
function $5ca140376c7a3a5b$var$formatUTCHour12(d, p) {
    return $5ca140376c7a3a5b$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $5ca140376c7a3a5b$var$formatUTCDayOfYear(d, p) {
    return $5ca140376c7a3a5b$var$pad(1 + (0, $cRW5v.utcDay).count((0, $idw3k.utcYear)(d), d), p, 3);
}
function $5ca140376c7a3a5b$var$formatUTCMilliseconds(d, p) {
    return $5ca140376c7a3a5b$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $5ca140376c7a3a5b$var$formatUTCMicroseconds(d, p) {
    return $5ca140376c7a3a5b$var$formatUTCMilliseconds(d, p) + "000";
}
function $5ca140376c7a3a5b$var$formatUTCMonthNumber(d, p) {
    return $5ca140376c7a3a5b$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $5ca140376c7a3a5b$var$formatUTCMinutes(d, p) {
    return $5ca140376c7a3a5b$var$pad(d.getUTCMinutes(), p, 2);
}
function $5ca140376c7a3a5b$var$formatUTCSeconds(d, p) {
    return $5ca140376c7a3a5b$var$pad(d.getUTCSeconds(), p, 2);
}
function $5ca140376c7a3a5b$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $5ca140376c7a3a5b$var$formatUTCWeekNumberSunday(d, p) {
    return $5ca140376c7a3a5b$var$pad((0, $8vb39.utcSunday).count((0, $idw3k.utcYear)(d) - 1, d), p, 2);
}
function $5ca140376c7a3a5b$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $8vb39.utcThursday)(d) : (0, $8vb39.utcThursday).ceil(d);
}
function $5ca140376c7a3a5b$var$formatUTCWeekNumberISO(d, p) {
    d = $5ca140376c7a3a5b$var$UTCdISO(d);
    return $5ca140376c7a3a5b$var$pad((0, $8vb39.utcThursday).count((0, $idw3k.utcYear)(d), d) + ((0, $idw3k.utcYear)(d).getUTCDay() === 4), p, 2);
}
function $5ca140376c7a3a5b$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $5ca140376c7a3a5b$var$formatUTCWeekNumberMonday(d, p) {
    return $5ca140376c7a3a5b$var$pad((0, $8vb39.utcMonday).count((0, $idw3k.utcYear)(d) - 1, d), p, 2);
}
function $5ca140376c7a3a5b$var$formatUTCYear(d, p) {
    return $5ca140376c7a3a5b$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $5ca140376c7a3a5b$var$formatUTCYearISO(d, p) {
    d = $5ca140376c7a3a5b$var$UTCdISO(d);
    return $5ca140376c7a3a5b$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $5ca140376c7a3a5b$var$formatUTCFullYear(d, p) {
    return $5ca140376c7a3a5b$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $5ca140376c7a3a5b$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $8vb39.utcThursday)(d) : (0, $8vb39.utcThursday).ceil(d);
    return $5ca140376c7a3a5b$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $5ca140376c7a3a5b$var$formatUTCZone() {
    return "+0000";
}
function $5ca140376c7a3a5b$var$formatLiteralPercent() {
    return "%";
}
function $5ca140376c7a3a5b$var$formatUnixTimestamp(d) {
    return +d;
}
function $5ca140376c7a3a5b$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}

});



parcelRegister("wM6Wl", function(module, exports) {

$parcel$export(module.exports, "a11yStrings", () => $06284f1a6f56f375$export$1bab900455080d68);
const $06284f1a6f56f375$export$1bab900455080d68 = {
    enablePatterns: 'Apply pattern fill',
    disablePatterns: 'Remove pattern fill',
    showDataTable: 'View data table',
    exitDataTable: 'Exit data table',
    moreActions: 'More actions'
};

});


parcelRegister("4wRz3", function(module, exports) {

$parcel$export(module.exports, "LayoutContainer", () => $34c3b357a3a754f8$export$faad8b178f68f912);
$parcel$export(module.exports, "Layout", () => (parcelRequire("2OPEf")).Layout);

var $2OPEf = parcelRequire("2OPEf");

var $2OMIu = parcelRequire("2OMIu");
function $34c3b357a3a754f8$export$faad8b178f68f912(_ref) {
    let { height: height, width: width, children: children, ...props } = _ref;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OPEf.Layout), {
        showBorder: true,
        width: width,
        height: height,
        hasSubtitle: true,
        gridTemplate: (0, $2OPEf.defaultGrid),
        ...props,
        children: children
    });
}

});
parcelRegister("2OPEf", function(module, exports) {

$parcel$export(module.exports, "defaultGrid", () => $20d85081ecba80a6$export$aed5b7d86c3777ab);
$parcel$export(module.exports, "PADDING_MAP", () => $20d85081ecba80a6$export$91bd21658648071c);
$parcel$export(module.exports, "Layout", () => $20d85081ecba80a6$export$c84671f46d6a1ca);
/* layout.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $1xLej = parcelRequire("1xLej");

var $5IT70 = parcelRequire("5IT70");

var $9BEAR = parcelRequire("9BEAR");

var $1iqMi = parcelRequire("1iqMi");
var $7rySF = parcelRequire("7rySF");

var $2OMIu = parcelRequire("2OMIu");
const $20d85081ecba80a6$export$aed5b7d86c3777ab = [
    'title',
    'subtitle',
    'legend',
    'plot'
];
/**
 * Don't display the title/subtitle container if both title and subtitle are empty
 */ const $20d85081ecba80a6$var$titleSubtitleStyles = null;
/**
 * Token map
 */ const $20d85081ecba80a6$var$BACKGROUND_COLOR_MAP = {
    'elevation.surface': "var(--ds-surface, white)",
    'elevation.surface.raised': "var(--ds-surface-raised, white)",
    transparent: 'transparent'
};
const $20d85081ecba80a6$export$91bd21658648071c = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)"
};
function $20d85081ecba80a6$var$Layout(_ref) {
    var _ref2, _ordering$plot;
    let { children: children, width: width, height: height, gridTemplate: gridTemplate, hasSubtitle: hasSubtitle, backgroundColor: backgroundColor = 'elevation.surface', overflow: overflow = 'hidden', showBorder: showBorder = true, padding: padding } = _ref;
    const ordering = gridTemplate.reduce((acc, key, i)=>{
        acc[key] = i + 1;
        return acc;
    }, {});
    const chartOrder = (_ref2 = (_ordering$plot = ordering['plot']) !== null && _ordering$plot !== void 0 ? _ordering$plot : ordering['plot-legend']) !== null && _ref2 !== void 0 ? _ref2 : ordering['legend-plot'];
    const chartFlexDirection = ordering['plot'] || ordering['legend'] ? 'column' : 'row';
    const chartFlexReverse = ordering['legend'] > ordering['plot'] || ordering['plot-legend'] ? '-reverse' : '';
    const [fadeInOpacity, setFadeInOpacity] = (0, $5uXOq.useState)(0);
    (0, $5uXOq.useEffect)(()=>{
        let isMounted = true;
        const ref = window.requestAnimationFrame(()=>{
            // TODO: would be nice to fade in without triggering another render
            if (isMounted) setFadeInOpacity(1);
        });
        return ()=>{
            isMounted = false;
            window.cancelAnimationFrame(ref);
        };
    }, [
        setFadeInOpacity
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
            "data-element": "layout",
            style: {
                width: width,
                height: height,
                backgroundColor: $20d85081ecba80a6$var$BACKGROUND_COLOR_MAP[backgroundColor],
                border: showBorder ? `1px solid ${"var(--ds-border, lightgrey)"}` : '0px',
                // TODO: Clean up to remove showBorder with major version update as a breaking change
                padding: padding ? $20d85081ecba80a6$export$91bd21658648071c[padding] : showBorder ? "var(--ds-space-200, 16px)" : 0,
                overflow: overflow
            },
            className: (0, $bwpsq.default)([
                "_1e0c1txw _2rko1l7b _kqswh2mm _4t3i1osq _2lx21bp4 _vchhusvi"
            ]),
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                    className: (0, $bwpsq.default)([
                        "_n3tdze3t _17kvpxbi _1j6zpxbi"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                            "data-element": "title",
                            style: {
                                order: ordering.title,
                                position: 'relative'
                            },
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5IT70.Icon), {}),
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7rySF.Title), {})
                            ]
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                            "data-element": "subtitle",
                            style: {
                                order: ordering.subtitle,
                                paddingBottom: !hasSubtitle ? 0 : undefined
                            },
                            children: hasSubtitle && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1iqMi.Subtitle), {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    "data-element": "chart",
                    style: {
                        opacity: fadeInOpacity,
                        transition: 'opacity .3s ease-in-out',
                        order: chartOrder,
                        flexDirection: `${chartFlexDirection}${chartFlexReverse}`
                    },
                    className: (0, $bwpsq.default)([
                        "_1e0c1txw _1ul9idpf _1tkeidpf _16jlkb7n"
                    ]),
                    children: children
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9BEAR.ChartMenu), {})
            ]
        })
    });
}
const $20d85081ecba80a6$export$c84671f46d6a1ca = (0, $1xLej.element)($20d85081ecba80a6$var$Layout);

});
parcelRegister("5IT70", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $42abcfeb7064501b$export$f04a61298a47a40f);
/* icon.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $bwpsq = parcelRequire("bwpsq");

var $1xLej = parcelRequire("1xLej");

var $2OMIu = parcelRequire("2OMIu");
const $42abcfeb7064501b$var$iconStyle = null;
function $42abcfeb7064501b$var$Icon(_ref) {
    let { children: children } = _ref;
    if (!children) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_1bsb7vkz _4t3i1tcg _syaz1oju"
        ]),
        children: children
    });
}
const $42abcfeb7064501b$export$f04a61298a47a40f = (0, $1xLej.element)($42abcfeb7064501b$var$Icon);

});

parcelRegister("9BEAR", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $6fe70ec35a14ba96$export$d9b273488cd8ce6f);
$parcel$export(module.exports, "ChartMenu", () => $6fe70ec35a14ba96$export$597da2837c1a3c88);

var $42CjB = parcelRequire("42CjB");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $3oUqw = parcelRequire("3oUqw");

var $1xLej = parcelRequire("1xLej");
var $9ZuYc = parcelRequire("9ZuYc");
parcelRequire("4wRz3");
var $2OPEf = parcelRequire("2OPEf");

var $wM6Wl = parcelRequire("wM6Wl");

var $dBbYh = parcelRequire("dBbYh");

var $2OMIu = parcelRequire("2OMIu");
const $6fe70ec35a14ba96$export$d9b273488cd8ce6f = (0, $1xLej.element)((_ref)=>{
    let { children: children, hide: hide = false, toggleDataTable: toggleDataTable, toggleShowPatterns: toggleShowPatterns, showPatterns: showPatterns, disablePatternOption: disablePatternOption = false } = _ref;
    if (hide) return null;
    const { showBorder: showBorder } = (0, $9ZuYc.useElementProps)((0, $2OPEf.Layout));
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "aria-haspopup": true,
        style: {
            position: 'absolute',
            top: 0,
            right: 0,
            padding: showBorder ? "var(--ds-space-200, 16px)" : 0
        },
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $BLPHT.default), {
            trigger: (_ref2)=>{
                let { triggerRef: triggerRef, ...props } = _ref2;
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                    ...props,
                    appearance: "subtle",
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($3oUqw))),
                    label: (0, $wM6Wl.a11yStrings).moreActions,
                    ref: triggerRef,
                    spacing: "compact"
                });
            },
            label: (0, $wM6Wl.a11yStrings).moreActions,
            shouldRenderToParent: true,
            placement: "bottom-end",
            spacing: "compact",
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $aRoVz.default), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6B7KL.default), {
                        onClick: toggleDataTable,
                        testId: (0, $wM6Wl.a11yStrings).showDataTable,
                        children: (0, $wM6Wl.a11yStrings).showDataTable
                    }, (0, $wM6Wl.a11yStrings).showDataTable),
                    !disablePatternOption ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6B7KL.default), {
                        onClick: toggleShowPatterns,
                        testId: (0, $wM6Wl.a11yStrings).enablePatterns,
                        children: showPatterns ? (0, $wM6Wl.a11yStrings).disablePatterns : (0, $wM6Wl.a11yStrings).enablePatterns
                    }, (0, $wM6Wl.a11yStrings).enablePatterns) : null,
                    children
                ]
            })
        })
    });
});
function $6fe70ec35a14ba96$export$597da2837c1a3c88(props) {
    const { toggleDataTable: toggleDataTable, toggleShowPatterns: toggleShowPatterns, showPatterns: showPatterns } = (0, $dBbYh.useMenuData)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)($6fe70ec35a14ba96$export$d9b273488cd8ce6f, {
        ...props,
        toggleDataTable: toggleDataTable,
        toggleShowPatterns: toggleShowPatterns,
        showPatterns: showPatterns
    });
}

});
parcelRegister("dBbYh", function(module, exports) {

$parcel$export(module.exports, "useMenuData", () => $9e68044b36ea3667$export$bf0039e2171862f5);
$parcel$export(module.exports, "MenuProvider", () => $9e68044b36ea3667$export$62b22d151866115d);

var $5uXOq = parcelRequire("5uXOq");

var $2OMIu = parcelRequire("2OMIu");
function $9e68044b36ea3667$export$2ce5e940c4008526() {
    const [showDataTable, setShowDataTable] = (0, $5uXOq.useState)(false);
    const [showPatterns, setShowPatterns] = (0, $5uXOq.useState)(false);
    const toggleDataTable = (0, $5uXOq.useCallback)(()=>{
        setShowDataTable((prevShowDataTable)=>!prevShowDataTable);
    }, [
        setShowDataTable
    ]);
    const closeDataTable = (0, $5uXOq.useCallback)(()=>{
        setShowDataTable(false);
    }, [
        setShowDataTable
    ]);
    const toggleShowPatterns = (0, $5uXOq.useCallback)(()=>{
        setShowPatterns((prevShowPatterns)=>!prevShowPatterns);
    }, [
        setShowPatterns
    ]);
    return {
        showDataTable: showDataTable,
        closeDataTable: closeDataTable,
        toggleDataTable: toggleDataTable,
        showPatterns: showPatterns,
        toggleShowPatterns: toggleShowPatterns
    };
}
const $9e68044b36ea3667$export$c7e742effb1c51e2 = /*#__PURE__*/ (0, $5uXOq.createContext)({});
function $9e68044b36ea3667$export$bf0039e2171862f5() {
    return (0, $5uXOq.useContext)($9e68044b36ea3667$export$c7e742effb1c51e2);
}
const $9e68044b36ea3667$export$62b22d151866115d = (_ref)=>{
    let { children: children } = _ref;
    const { showDataTable: showDataTable, toggleDataTable: toggleDataTable, closeDataTable: closeDataTable, showPatterns: showPatterns, toggleShowPatterns: toggleShowPatterns } = $9e68044b36ea3667$export$2ce5e940c4008526();
    return /*#__PURE__*/ (0, $2OMIu.jsx)($9e68044b36ea3667$export$c7e742effb1c51e2.Provider, {
        value: {
            showDataTable: showDataTable,
            showPatterns: showPatterns,
            closeDataTable: closeDataTable,
            toggleDataTable: toggleDataTable,
            toggleShowPatterns: toggleShowPatterns
        },
        children: children
    });
};

});


parcelRegister("1iqMi", function(module, exports) {

$parcel$export(module.exports, "Subtitle", () => $0f1c3e683a2010d1$export$cf345ef34cd72655);
/* subtitle.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $bwpsq = parcelRequire("bwpsq");

var $1xLej = parcelRequire("1xLej");

var $2OMIu = parcelRequire("2OMIu");
const $0f1c3e683a2010d1$var$subTitleTextStyle = null;
function $0f1c3e683a2010d1$var$Subtitle(_ref) {
    let { children: children } = _ref;
    if (!children) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("h3", {
        className: (0, $bwpsq.default)([
            "_syaz1gjq _11c81oud _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0q1b66"
        ]),
        children: children
    });
}
const $0f1c3e683a2010d1$export$cf345ef34cd72655 = (0, $1xLej.element)($0f1c3e683a2010d1$var$Subtitle);

});



parcelRegister("jsFNI", function(module, exports) {

$parcel$export(module.exports, "DimensionsWrapper", () => $e2b10ea7064a4053$export$a263c0cd0abdd921);

var $5uXOq = parcelRequire("5uXOq");
const $e2b10ea7064a4053$var$INITIAL_DIMENSIONS = {
    plotHeight: 100,
    plotWidth: 100,
    margin: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    }
};
function $e2b10ea7064a4053$export$a263c0cd0abdd921(_ref) {
    let { children: children } = _ref;
    const [, forceUpdate] = (0, $5uXOq.useState)({});
    const dimensions = (0, $5uXOq.useRef)($e2b10ea7064a4053$var$INITIAL_DIMENSIONS);
    const plotSvgRef = (0, $5uXOq.useRef)(null);
    // Update the dimensions and margin when the SVG element is resized.
    (0, $5uXOq.useEffect)(()=>{
        const resizeObserverSvg = new ResizeObserver((entries)=>{
            if (entries && entries[0]) {
                const { width: ws, height: hs } = entries[0].target.getBoundingClientRect();
                const newMargin = Object.assign({}, dimensions.current.margin);
                dimensions.current = {
                    margin: newMargin,
                    plotHeight: hs,
                    plotWidth: ws
                };
                forceUpdate({});
            }
        });
        // If parentDiv is available, observe it and its axis-left child (if exists).
        // If not, disconnect the observers.
        if (plotSvgRef.current) resizeObserverSvg.observe(plotSvgRef.current);
        return ()=>{
            resizeObserverSvg.disconnect();
        };
    }, []);
    return children({
        ...dimensions.current,
        plotSvgRef: plotSvgRef
    });
}

});

parcelRegister("jogiL", function(module, exports) {

$parcel$export(module.exports, "LegendSymbol", () => $e1dce75aa10566c3$export$b037e73014290792);
$parcel$export(module.exports, "LegendLabel", () => $e1dce75aa10566c3$export$f77025011665b85c);
$parcel$export(module.exports, "OrdinalLegend", () => $e1dce75aa10566c3$export$7f71253a43a34ee6);
/* OrdinalLegend.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $3bDjY = parcelRequire("3bDjY");

var $5uXOq = parcelRequire("5uXOq");

var $lFJ6b = parcelRequire("lFJ6b");

var $xpxC7 = parcelRequire("xpxC7");

var $3pncq = parcelRequire("3pncq");

var $1xLej = parcelRequire("1xLej");
var $9ZuYc = parcelRequire("9ZuYc");

var $2OPEf = parcelRequire("2OPEf");


var $6Qr48 = parcelRequire("6Qr48");

var $Ge7ik = parcelRequire("Ge7ik");

var $2OMIu = parcelRequire("2OMIu");
const $e1dce75aa10566c3$export$83dfac8e05432e26 = {
    font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    color: "var(--ds-text-subtlest, #626F86)",
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    transition: 'color .3s ease-in-out',
    cursor: 'default'
};
const $e1dce75aa10566c3$export$b037e73014290792 = (0, $1xLej.element)((_ref)=>{
    let { color: color, shape: shape, labelAccessor: labelAccessor, datum: datum } = _ref;
    const { getActiveMark: getActiveMark } = (0, $6Qr48.useEventLegendMark)({
        legend: (0, $xpxC7.legendEvent),
        tooltip: (0, $xpxC7.tooltipEvent),
        labelAccessor: labelAccessor
    });
    const activeMark = getActiveMark();
    const isActive = activeMark === labelAccessor(datum);
    let symbol;
    switch(shape){
        case 'square':
            symbol = /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                fill: color,
                width: (0, $924b13d0d377477c$export$b45e5ea5e43b1d74),
                height: (0, $924b13d0d377477c$export$b45e5ea5e43b1d74),
                rx: 2,
                ry: 2
            });
            break;
        case 'line':
            symbol = /*#__PURE__*/ (0, $2OMIu.jsx)("line", {
                x1: 0,
                y1: (0, $924b13d0d377477c$export$b45e5ea5e43b1d74) / 2,
                x2: (0, $924b13d0d377477c$export$b45e5ea5e43b1d74),
                y2: (0, $924b13d0d377477c$export$b45e5ea5e43b1d74) / 2,
                stroke: color,
                strokeWidth: 2
            });
            break;
        case 'circle':
        default:
            symbol = /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                fill: color,
                width: (0, $924b13d0d377477c$export$b45e5ea5e43b1d74),
                height: (0, $924b13d0d377477c$export$b45e5ea5e43b1d74),
                rx: (0, $924b13d0d377477c$export$b45e5ea5e43b1d74) / 2,
                ry: (0, $924b13d0d377477c$export$b45e5ea5e43b1d74) / 2
            });
    }
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        style: {
            opacity: !activeMark || isActive ? 1 : (0, $lFJ6b.NON_HOVER_OPACITY)
        },
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _v56414fr"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
            width: (0, $924b13d0d377477c$export$b45e5ea5e43b1d74),
            height: (0, $924b13d0d377477c$export$b45e5ea5e43b1d74),
            children: symbol
        })
    });
});
const $e1dce75aa10566c3$export$f77025011665b85c = (0, $1xLej.element)((_ref2)=>{
    let { labelAccessor: labelAccessor, datum: datum, limit: limit } = _ref2;
    const { getActiveMark: getActiveMark } = (0, $6Qr48.useEventLegendMark)({
        legend: (0, $xpxC7.legendEvent),
        tooltip: (0, $xpxC7.tooltipEvent),
        labelAccessor: labelAccessor
    });
    const ref = (0, $5uXOq.useRef)(null);
    const activeMark = getActiveMark();
    const isActive = activeMark === labelAccessor(datum);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: labelAccessor(datum),
        canAppear: ()=>{
            const element = ref.current;
            if (!element) return false;
            return element.offsetWidth < element.scrollWidth;
        },
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            ref: ref,
            style: {
                maxWidth: limit,
                color: !activeMark || !isActive ? "var(--ds-text-subtlest, #626F86)" : "var(--ds-text-accent-gray-bolder, #091E42)"
            },
            className: (0, $bwpsq.default)([
                "_11c816g6 _syaz131l _1bto1l2s _1reo15vq _18m915vq _o5721q9c _v564cpn1 _80om73ad"
            ]),
            children: labelAccessor(datum)
        })
    });
});
const $e1dce75aa10566c3$var$VerticalLegendMark = (_ref3)=>{
    let { color: color, labelAccessor: labelAccessor, shape: shape, opacity: opacity, datum: datum } = _ref3;
    const label = labelAccessor(datum);
    const { emit: emit } = (0, $3pncq.useChartEvents)((0, $xpxC7.legendEvent), [
        'pointerenter',
        'pointerleave'
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        style: {
            opacity: opacity
        },
        onPointerEnter: (e)=>emit(e, label),
        onPointerLeave: emit,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _zulpu2gc _p12f1osq _4t3i7vkz _1ul9idpf _19pk1b66 _otyr1b66"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)($e1dce75aa10566c3$export$b037e73014290792, {
                color: color,
                shape: shape,
                datum: datum,
                labelAccessor: labelAccessor
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)($e1dce75aa10566c3$export$f77025011665b85c, {
                datum: datum,
                labelAccessor: labelAccessor,
                limit: (0, $924b13d0d377477c$export$a86fe553d7123e82)
            })
        ]
    });
};
const $e1dce75aa10566c3$var$HorizontalLegendMark = (_ref4)=>{
    let { color: color, labelAccessor: labelAccessor, shape: shape, opacity: opacity, datum: datum } = _ref4;
    const label = labelAccessor(datum);
    const { emit: emit } = (0, $3pncq.useChartEvents)((0, $xpxC7.legendEvent), [
        'pointerenter',
        'pointerleave'
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        style: {
            opacity: opacity
        },
        onPointerEnter: (e)=>emit(e, label),
        role: "option",
        "aria-label": `Option ${label}`,
        onPointerLeave: emit,
        className: (0, $bwpsq.default)([
            "_1e0c116y _zulpu2gc _4t3i7vkz _1ul9idpf"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)($e1dce75aa10566c3$export$b037e73014290792, {
                color: color,
                shape: shape,
                datum: datum,
                labelAccessor: labelAccessor
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)($e1dce75aa10566c3$export$f77025011665b85c, {
                labelAccessor: labelAccessor,
                datum: datum,
                limit: (0, $924b13d0d377477c$export$a86fe553d7123e82)
            })
        ]
    });
};
function $e1dce75aa10566c3$var$VerticalLegend(_ref5) {
    let { data: data, colorAccessor: colorAccessor, colorScale: colorScale, labelAccessor: labelAccessor, shape: shape, justifyContent: justifyContent = 'center', maxRows: maxRows = 10 } = _ref5;
    const legendRef = (0, $5uXOq.useRef)(null);
    const [truncationIndex, setTruncationIndex] = (0, $5uXOq.useState)((0, $924b13d0d377477c$export$7bf402e928540137));
    const flatData = (0, $Ge7ik.useFlatData)({
        labelAccessor: labelAccessor,
        data: data
    });
    (0, $Ge7ik.useTruncationIndexObserver)({
        legendRefCurrent: legendRef.current,
        setTruncationIndex: setTruncationIndex
    });
    const itemsToTruncate = flatData.length - (truncationIndex || 0);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: legendRef,
        style: {
            maxHeight: `${maxRows * (0, $924b13d0d377477c$export$6c7aaaebfae62217) + 2}px`,
            justifyContent: justifyContent
        },
        className: (0, $bwpsq.default)([
            "_1e0c116y _1bah1h6o _1n261g80 _16jlidpf _1o9zidpf _i0dl1r5k _2lx21bp4 _ae4v1y6m _19pk1wug _2hwx1wug _otyr1wug _18u01wug _19bv1crf _4t3i1osq _1reo15vq _18m915vq _gy1ppxbi"
        ]),
        children: flatData.map((d, i)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
                children: itemsToTruncate > 0 && truncationIndex - 1 <= i ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                        style: {
                            position: 'relative'
                        },
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)($e1dce75aa10566c3$var$VerticalLegendMark, {
                                color: colorScale(colorAccessor(d)),
                                labelAccessor: labelAccessor,
                                shape: shape,
                                opacity: 0,
                                datum: d
                            }, labelAccessor(d)),
                            truncationIndex - 1 === i && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                                style: {
                                    position: 'absolute',
                                    top: 0,
                                    left: 0
                                },
                                className: (0, $bwpsq.default)([
                                    "_11c816g6 _syaz131l _1bto1l2s _1reo15vq _18m915vq _o5721q9c _v564cpn1 _80om73ad"
                                ]),
                                children: ` ... ${itemsToTruncate + 1} more`
                            })
                        ]
                    })
                }) : /*#__PURE__*/ (0, $2OMIu.jsx)($e1dce75aa10566c3$var$VerticalLegendMark, {
                    color: colorScale(colorAccessor(d)),
                    labelAccessor: labelAccessor,
                    shape: shape,
                    datum: d
                }, labelAccessor(d))
            }, `vertical-leged-entry${labelAccessor(d)}-${colorScale(colorAccessor(d))}-${i}`))
    });
}
function $e1dce75aa10566c3$var$HorizontalLegend(_ref6) {
    let { data: data, colorAccessor: colorAccessor, colorScale: colorScale, labelAccessor: labelAccessor, shape: shape, justifyContent: justifyContent = 'flex-start', flexDirection: flexDirection = 'row', maxRows: maxRows = 5 } = _ref6;
    const legendRef = (0, $5uXOq.useRef)(null);
    const [truncationIndex, setTruncationIndex] = (0, $5uXOq.useState)((0, $924b13d0d377477c$export$7bf402e928540137));
    const flatData = (0, $Ge7ik.useFlatData)({
        labelAccessor: labelAccessor,
        data: data
    });
    (0, $Ge7ik.useTruncationIndexObserver)({
        legendRefCurrent: legendRef.current,
        setTruncationIndex: setTruncationIndex
    });
    const itemsToTruncate = flatData.length - (truncationIndex || 0);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: legendRef,
        className: (0, $bwpsq.default)([
            "_1e0c116y _1n261g80 _16jlidpf _1o9zidpf _i0dl1wug _2lx21o5q _ae4v1y6m _1bsb1osq _1reo15vq _18m915vq _gy1ppxbi _1p57u2gc _otyrpxbi"
        ]),
        style: {
            // Max rows * legened height +
            maxHeight: `${maxRows * (0, $924b13d0d377477c$export$6c7aaaebfae62217) + 2 + (maxRows - 1) * 8}px`,
            justifyContent: justifyContent,
            "--_j9pi5t": (0, $lD23V.default)(flexDirection)
        },
        children: flatData.map((d, i)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
                children: itemsToTruncate > 0 && truncationIndex - 1 === i ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                        style: {
                            position: 'relative'
                        },
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)($e1dce75aa10566c3$var$HorizontalLegendMark, {
                                color: colorScale(colorAccessor(d)),
                                labelAccessor: labelAccessor,
                                shape: shape,
                                opacity: 0,
                                datum: d
                            }, labelAccessor(d)),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                                style: {
                                    position: 'absolute',
                                    top: 0,
                                    left: 0
                                },
                                className: (0, $bwpsq.default)([
                                    "_11c816g6 _syaz131l _1bto1l2s _1reo15vq _18m915vq _o5721q9c _v564cpn1 _80om73ad"
                                ]),
                                children: ` ... ${itemsToTruncate + 1} more`
                            })
                        ]
                    })
                }) : /*#__PURE__*/ (0, $2OMIu.jsx)($e1dce75aa10566c3$var$HorizontalLegendMark, {
                    color: colorScale(colorAccessor(d)),
                    labelAccessor: labelAccessor,
                    shape: shape,
                    datum: d
                }, labelAccessor(d))
            }, `horizontal-leged-entry${labelAccessor(d)}-${colorScale(colorAccessor(d))}-${i}`))
    });
}
function $e1dce75aa10566c3$export$734b3ee2d20431e7(_ref7) {
    var _layoutProps$gridTemp;
    let { data: data, colorAccessor: colorAccessor, colorScale: colorScale, labelAccessor: labelAccessor, shape: shape, maxRows: maxRows, justifyContent: justifyContent, flexDirection: flexDirection = 'row', hide: hide = false } = _ref7;
    const layoutProps = (0, $9ZuYc.useElementProps)((0, $2OPEf.Layout));
    const sideBySide = !((_layoutProps$gridTemp = layoutProps.gridTemplate) !== null && _layoutProps$gridTemp !== void 0 && _layoutProps$gridTemp.includes('legend'));
    if (hide) return null;
    if (sideBySide) return /*#__PURE__*/ (0, $2OMIu.jsx)($e1dce75aa10566c3$var$VerticalLegend, {
        data: data,
        colorAccessor: colorAccessor,
        colorScale: colorScale,
        labelAccessor: labelAccessor,
        shape: shape,
        maxRows: maxRows,
        justifyContent: justifyContent
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)($e1dce75aa10566c3$var$HorizontalLegend, {
        data: data,
        colorAccessor: colorAccessor,
        colorScale: colorScale,
        labelAccessor: labelAccessor,
        shape: shape,
        maxRows: maxRows,
        justifyContent: justifyContent,
        flexDirection: flexDirection
    });
}
const $e1dce75aa10566c3$export$7f71253a43a34ee6 = (0, $1xLej.element)($e1dce75aa10566c3$export$734b3ee2d20431e7);

});
parcelRegister("lFJ6b", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_MARGIN", () => $fc7068f7f891b7c6$export$6475e56bfff61883);
$parcel$export(module.exports, "PIE_DEFAULT_MARGIN", () => $fc7068f7f891b7c6$export$a0dd0718f5dd9670);
$parcel$export(module.exports, "POINT_MARK_FOCUS_RADIUS", () => $fc7068f7f891b7c6$export$76884527eb6caf6f);
$parcel$export(module.exports, "POINT_MARK_RADIUS", () => $fc7068f7f891b7c6$export$59e9037d71c8e00d);
$parcel$export(module.exports, "POINT_MARK_STROKE", () => $fc7068f7f891b7c6$export$f738b20dae1b22d2);
$parcel$export(module.exports, "POINT_MARK_HOVER_AREA", () => $fc7068f7f891b7c6$export$57d58795ea76db51);
$parcel$export(module.exports, "STACK_GAP", () => $fc7068f7f891b7c6$export$56b61e27223adae9);
$parcel$export(module.exports, "STACK_GAP_PROGRESS_BAR", () => $fc7068f7f891b7c6$export$4d00931646175b35);
$parcel$export(module.exports, "NON_HOVER_OPACITY", () => $fc7068f7f891b7c6$export$2db81f9dcc54cc87);
$parcel$export(module.exports, "NON_HOVER_AREA_OPACITY", () => $fc7068f7f891b7c6$export$eb1fbf26532c9ee2);
$parcel$export(module.exports, "CORNER_RADIUS_VALUE", () => $fc7068f7f891b7c6$export$a15d94c34ecbca08);
const $fc7068f7f891b7c6$export$6475e56bfff61883 = {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
};
const $fc7068f7f891b7c6$export$a0dd0718f5dd9670 = {
    top: 5,
    bottom: 5,
    left: 5,
    right: 5
};
const $fc7068f7f891b7c6$export$76884527eb6caf6f = 10;
const $fc7068f7f891b7c6$export$59e9037d71c8e00d = 4;
const $fc7068f7f891b7c6$export$f738b20dae1b22d2 = 2;
const $fc7068f7f891b7c6$export$57d58795ea76db51 = 5;
const $fc7068f7f891b7c6$export$601d4a48e295711b = 150;
const $fc7068f7f891b7c6$export$56b61e27223adae9 = 1;
const $fc7068f7f891b7c6$export$4d00931646175b35 = 2;
const $fc7068f7f891b7c6$export$2db81f9dcc54cc87 = 0.3;
const $fc7068f7f891b7c6$export$eb1fbf26532c9ee2 = 0.4;
const $fc7068f7f891b7c6$export$a15d94c34ecbca08 = {
    SMALL: 2,
    MEDIUM: 4,
    LARGE: 8,
    NONE: 0
};

});

parcelRegister("xpxC7", function(module, exports) {

$parcel$export(module.exports, "legendEvent", () => $0646e51fd9b45fad$export$11cf9da46183c138);
$parcel$export(module.exports, "tooltipEvent", () => $0646e51fd9b45fad$export$7c54fa9e080df84a);

var $3pncq = parcelRequire("3pncq");
const $0646e51fd9b45fad$export$11cf9da46183c138 = (0, $3pncq.createChartEvent)('legend');
const $0646e51fd9b45fad$export$7c54fa9e080df84a = (0, $3pncq.createChartEvent)('tooltip');

});
parcelRegister("3pncq", function(module, exports) {

$parcel$export(module.exports, "createChartEvent", () => $27b5b3d755d1323d$export$a17f01df75a49c5f);
$parcel$export(module.exports, "useChartEvents", () => $27b5b3d755d1323d$export$17a4e5f119c7d26e);

var $lfbyn = parcelRequire("lfbyn");
function $27b5b3d755d1323d$export$a17f01df75a49c5f(uniqueKey) {
    return Symbol(uniqueKey);
}
function $27b5b3d755d1323d$export$17a4e5f119c7d26e(chartEventType, arg1, callback) {
    if (typeof arg1 === 'function') return {
        emit: (0, $lfbyn.default)(chartEventType, undefined, (d)=>arg1 && arg1(d))
    };
    return {
        emit: (0, $lfbyn.default)(chartEventType, arg1, callback)
    };
}

});
parcelRegister("lfbyn", function(module, exports) {

$parcel$export(module.exports, "default", () => $f773f5f511eb23cf$export$2e2bcd8739ae039);
// eslint-disable-next-line no-restricted-syntax

var $eIrko = parcelRequire("eIrko");

var $5uXOq = parcelRequire("5uXOq");

var $ce7aF = parcelRequire("ce7aF");
function $f773f5f511eb23cf$export$2e2bcd8739ae039(/** Type of event to subscribe to. */ eventType, // Event filter can be an array which is problematic if we make a depedency.
eventFilter, /** Handler invoked on emission of EventType event.  */ handler) {
    const emitter = (0, $5uXOq.useContext)((0, $ce7aF.default));
    const eventFilterStr = [].concat(eventFilter || []).join('|');
    if (!emitter) throw new Error('useEventEmitter/useChartEvents must be used within a EventEmitterContext!');
    // wrap emitter.emit so we can enforce stricter type signature
    const emit = (0, $5uXOq.useCallback)((event, eventData)=>{
        // Doing an includes check will be a problem for a few events. (drag, dragstart).
        // Those should be the only ones though so this is fine.
        if (!eventFilterStr || eventFilterStr.includes(event.type)) {
            if (emitter) emitter.emit(eventType, {
                event: event,
                svgPoint: event ? (0, $eIrko.default)(event) : null,
                eventData: eventData
            });
        }
    }, [
        emitter,
        eventType,
        eventFilterStr
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (emitter && eventType && handler) {
            const filteredHandler = (params)=>{
                if (!eventFilterStr || eventFilterStr.includes(params.event.type)) handler(params);
            };
            emitter.on(eventType, filteredHandler);
            return ()=>emitter === null || emitter === void 0 ? void 0 : emitter.off(eventType, filteredHandler);
        }
        return undefined;
    }, [
        emitter,
        eventType,
        handler,
        eventFilterStr
    ]);
    return emit;
}

});
parcelRegister("eIrko", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab6a5f852b569ad0$export$2e2bcd8739ae039);

var $9hsAU = parcelRequire("9hsAU");

var $koq5f = parcelRequire("koq5f");
function $ab6a5f852b569ad0$export$2e2bcd8739ae039(nodeOrEvent, maybeEvent) {
    // localPoint(node, event)
    if ((0, $koq5f.isElement)(nodeOrEvent) && maybeEvent) return (0, $9hsAU.default)(nodeOrEvent, maybeEvent);
    // localPoint(event)
    if ((0, $koq5f.isEvent)(nodeOrEvent)) {
        var event = nodeOrEvent;
        var node = event.target;
        if (node) return (0, $9hsAU.default)(node, event);
    }
    return null;
}

});
parcelRegister("9hsAU", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c1be1cd7b69982c$export$2e2bcd8739ae039);

var $9c8sC = parcelRequire("9c8sC");

var $koq5f = parcelRequire("koq5f");

var $g6Ir5 = parcelRequire("g6Ir5");
function $6c1be1cd7b69982c$export$2e2bcd8739ae039(node, event) {
    if (!node || !event) return null;
    var coords = (0, $g6Ir5.default)(event);
    // find top-most SVG
    var svg = (0, $koq5f.isSVGElement)(node) ? node.ownerSVGElement : node;
    var screenCTM = (0, $koq5f.isSVGGraphicsElement)(svg) ? svg.getScreenCTM() : null;
    if ((0, $koq5f.isSVGSVGElement)(svg) && screenCTM) {
        var point = svg.createSVGPoint();
        point.x = coords.x;
        point.y = coords.y;
        point = point.matrixTransform(screenCTM.inverse());
        return new (0, $9c8sC.default)({
            x: point.x,
            y: point.y
        });
    }
    // fall back to bounding box
    var rect = node.getBoundingClientRect();
    return new (0, $9c8sC.default)({
        x: coords.x - rect.left - node.clientLeft,
        y: coords.y - rect.top - node.clientTop
    });
}

});
parcelRegister("9c8sC", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b1bcc229a165e03$export$2e2bcd8739ae039);
var $6b1bcc229a165e03$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Point(_ref) {
        var _ref$x = _ref.x, x = _ref$x === void 0 ? 0 : _ref$x, _ref$y = _ref.y, y = _ref$y === void 0 ? 0 : _ref$y;
        this.x = 0;
        this.y = 0;
        this.x = x;
        this.y = y;
    }
    var _proto = Point.prototype;
    _proto.value = function value() {
        return {
            x: this.x,
            y: this.y
        };
    };
    _proto.toArray = function toArray() {
        return [
            this.x,
            this.y
        ];
    };
    return Point;
}();

});

parcelRegister("koq5f", function(module, exports) {

$parcel$export(module.exports, "isElement", () => $ed8a4839102faef6$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isSVGElement", () => $ed8a4839102faef6$export$17eda790a720ec57);
$parcel$export(module.exports, "isSVGSVGElement", () => $ed8a4839102faef6$export$66957ea77182581d);
$parcel$export(module.exports, "isSVGGraphicsElement", () => $ed8a4839102faef6$export$d320b9df0ffd0744);
$parcel$export(module.exports, "isTouchEvent", () => $ed8a4839102faef6$export$c4dfce035d43d1e0);
$parcel$export(module.exports, "isMouseEvent", () => $ed8a4839102faef6$export$764db16956f554f8);
$parcel$export(module.exports, "isEvent", () => $ed8a4839102faef6$export$9671ea99bd126ace);
function $ed8a4839102faef6$export$45a5e7f76e0caa8d(elem) {
    return !!elem && elem instanceof Element;
}
function $ed8a4839102faef6$export$17eda790a720ec57(elem) {
    return !!elem && (elem instanceof SVGElement || 'ownerSVGElement' in elem);
}
function $ed8a4839102faef6$export$66957ea77182581d(elem) {
    return !!elem && 'createSVGPoint' in elem;
}
function $ed8a4839102faef6$export$d320b9df0ffd0744(elem) {
    return !!elem && 'getScreenCTM' in elem;
}
function $ed8a4839102faef6$export$c4dfce035d43d1e0(event) {
    return !!event && 'changedTouches' in event;
}
function $ed8a4839102faef6$export$764db16956f554f8(event) {
    return !!event && 'clientX' in event;
}
function $ed8a4839102faef6$export$9671ea99bd126ace(event) {
    return !!event && (event instanceof Event || 'nativeEvent' in event && event.nativeEvent instanceof Event);
}

});

parcelRegister("g6Ir5", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb9facec00996761$export$2e2bcd8739ae039);

var $koq5f = parcelRequire("koq5f");
function $bb9facec00996761$var$_extends() {
    $bb9facec00996761$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bb9facec00996761$var$_extends.apply(this, arguments);
}
var $bb9facec00996761$var$DEFAULT_POINT = {
    x: 0,
    y: 0
};
function $bb9facec00996761$export$2e2bcd8739ae039(event) {
    if (!event) return $bb9facec00996761$var$_extends({}, $bb9facec00996761$var$DEFAULT_POINT);
    if ((0, $koq5f.isTouchEvent)(event)) return event.changedTouches.length > 0 ? {
        x: event.changedTouches[0].clientX,
        y: event.changedTouches[0].clientY
    } : $bb9facec00996761$var$_extends({}, $bb9facec00996761$var$DEFAULT_POINT);
    if ((0, $koq5f.isMouseEvent)(event)) return {
        x: event.clientX,
        y: event.clientY
    };
    // for focus events try to extract the center position of the target element
    var target = event == null ? void 0 : event.target;
    var boundingClientRect = target && 'getBoundingClientRect' in target ? target.getBoundingClientRect() : null;
    if (!boundingClientRect) return $bb9facec00996761$var$_extends({}, $bb9facec00996761$var$DEFAULT_POINT);
    return {
        x: boundingClientRect.x + boundingClientRect.width / 2,
        y: boundingClientRect.y + boundingClientRect.height / 2
    };
}

});



parcelRegister("ce7aF", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e6c5adf8430c872$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $8e6c5adf8430c872$var$EventEmitterContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
var $8e6c5adf8430c872$export$2e2bcd8739ae039 = $8e6c5adf8430c872$var$EventEmitterContext;

});




const $924b13d0d377477c$export$40c60b78afd59472 = 160;
const $924b13d0d377477c$export$6c7aaaebfae62217 = 16;
const $924b13d0d377477c$export$b45e5ea5e43b1d74 = 12;
const $924b13d0d377477c$export$fc3f40004b88a5a0 = 2;
const $924b13d0d377477c$export$7bf402e928540137 = 10000;
const $924b13d0d377477c$export$a86fe553d7123e82 = '16ch';

parcelRegister("6Qr48", function(module, exports) {

$parcel$export(module.exports, "useEventLegendMark", () => $4fbc9813fd9b9924$export$2cfaecb6a70db2b8);

var $5uXOq = parcelRequire("5uXOq");

var $3pncq = parcelRequire("3pncq");
function $4fbc9813fd9b9924$export$2cfaecb6a70db2b8(_ref) {
    let { tooltip: tooltip, legend: legend, labelAccessor: labelAccessor } = _ref;
    // Hook to manage active tooltip state and compute opacity based on hover events.
    const [active, setActive] = (0, $5uXOq.useState)();
    if (tooltip) // Listen to tooltip events to update active state for legend mark.
    (0, $3pncq.useChartEvents)(tooltip, [
        'pointerout',
        'pointermove'
    ], (d)=>{
        var _d$eventData, _d$eventData2;
        setActive({
            label: ((_d$eventData = d.eventData) === null || _d$eventData === void 0 ? void 0 : _d$eventData.distance) === 0 ? labelAccessor((_d$eventData2 = d.eventData) === null || _d$eventData2 === void 0 ? void 0 : _d$eventData2.datum) : undefined
        });
    });
    // Listen to legend events to update active state for hovered legend item.
    (0, $3pncq.useChartEvents)(legend, (d)=>{
        setActive({
            label: d.eventData
        });
    });
    // Determine opacity for a given arc based on the active tooltip state.
    const getActiveMark = ()=>{
        return active === null || active === void 0 ? void 0 : active.label;
    };
    return {
        getActiveMark: getActiveMark
    };
}

});

parcelRegister("Ge7ik", function(module, exports) {

$parcel$export(module.exports, "useTruncationIndexObserver", () => $07eedfa1c3d431d5$export$ec599d67f76e7af7);
$parcel$export(module.exports, "useFlatData", () => $07eedfa1c3d431d5$export$f27cffe517b2d3a3);

var $5uXOq = parcelRequire("5uXOq");
const $07eedfa1c3d431d5$export$178827bcd84b6d71 = (data, labelAccessor)=>{
    return data.reduce((flat, d)=>{
        const label = labelAccessor(d);
        if (flat[label]) return flat;
        const newFlatData = {
            ...flat
        };
        newFlatData[label] = d;
        return newFlatData;
    }, {});
};
const $07eedfa1c3d431d5$export$5303528d1070ff6f = (value)=>{
    if (value === 'normal') return 8;
    else return parseFloat(value);
};
function $07eedfa1c3d431d5$export$ec599d67f76e7af7(_ref) {
    let { legendRefCurrent: legendRefCurrent, setTruncationIndex: setTruncationIndex } = _ref;
    (0, $5uXOq.useEffect)(()=>{
        const observer = new ResizeObserver((entries)=>{
            let fit = 0;
            const content = [
                ...entries[0].target.children
            ];
            content.forEach((d)=>{
                // Look into isVisible function
                if (!$07eedfa1c3d431d5$export$660f61eb7bd5242a(entries[0].target, d)) fit += 1;
            });
            setTruncationIndex(fit);
        });
        if (legendRefCurrent) observer.observe(legendRefCurrent);
        return ()=>{
            if (legendRefCurrent) observer.unobserve(legendRefCurrent);
        };
    }, [
        legendRefCurrent,
        setTruncationIndex
    ]);
}
const $07eedfa1c3d431d5$export$660f61eb7bd5242a = (parent, child)=>{
    const box1coords = parent.getBoundingClientRect();
    const box2coords = child.getBoundingClientRect();
    if (box2coords.top + 2 < box1coords.top || box2coords.right - 2 > box1coords.right || box2coords.bottom - 2 > box1coords.bottom || box2coords.left + 2 < box1coords.left) return true;
    return false;
};
function $07eedfa1c3d431d5$export$f27cffe517b2d3a3(_ref2) {
    let { labelAccessor: labelAccessor, data: data } = _ref2;
    return (0, $5uXOq.useMemo)(()=>Object.values(data.reduce((flat, d)=>{
            const label = labelAccessor(d);
            if (flat[label]) return flat;
            const newFlatData = {
                ...flat
            };
            newFlatData[label] = {
                ...d
            };
            return newFlatData;
        }, {})), [
        labelAccessor,
        data
    ]);
}

});


parcelRegister("dZ3lg", function(module, exports) {

$parcel$export(module.exports, "Arc", () => $a2e3908135d5fd8e$export$6ef80ffb606dd232);
/* Arc.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $8OBna = parcelRequire("8OBna");

var $1xLej = parcelRequire("1xLej");

var $2OMIu = parcelRequire("2OMIu");
function $a2e3908135d5fd8e$export$596321273a76f453(func, value) {
    if (typeof value === 'number') func(value);
    else func(value);
}
const $a2e3908135d5fd8e$var$arcStyles = `opacity .3s`;
function $a2e3908135d5fd8e$export$ff1ef9a5c671f043(_temp) {
    let { innerRadius: innerRadius, outerRadius: outerRadius, cornerRadius: cornerRadius, startAngle: startAngle, endAngle: endAngle, padAngle: padAngle, padRadius: padRadius } = _temp === void 0 ? {} : _temp;
    const path = (0, $8OBna.default)();
    if (innerRadius != null) $a2e3908135d5fd8e$export$596321273a76f453(path.innerRadius, innerRadius);
    if (outerRadius != null) $a2e3908135d5fd8e$export$596321273a76f453(path.outerRadius, outerRadius);
    if (cornerRadius != null) $a2e3908135d5fd8e$export$596321273a76f453(path.cornerRadius, cornerRadius);
    if (startAngle != null) $a2e3908135d5fd8e$export$596321273a76f453(path.startAngle, startAngle);
    if (endAngle != null) $a2e3908135d5fd8e$export$596321273a76f453(path.endAngle, endAngle);
    if (padAngle != null) $a2e3908135d5fd8e$export$596321273a76f453(path.padAngle, padAngle);
    if (padRadius != null) $a2e3908135d5fd8e$export$596321273a76f453(path.padRadius, padRadius);
    return path;
}
function $a2e3908135d5fd8e$var$Arc(_ref) {
    let { innerRadius: innerRadius, outerRadius: outerRadius, cornerRadius: cornerRadius, startAngle: startAngle, endAngle: endAngle, padAngle: padAngle, padRadius: padRadius, datum: datum, opacity: opacity, children: children, innerRef: innerRef, ariaLabel: ariaLabel, fill: fill, stroke: stroke, transition: transition = $a2e3908135d5fd8e$var$arcStyles, ...rest } = _ref;
    const path = $a2e3908135d5fd8e$export$ff1ef9a5c671f043({
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        cornerRadius: cornerRadius,
        startAngle: startAngle,
        endAngle: endAngle,
        padAngle: padAngle,
        padRadius: padRadius
    });
    if (children) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children({
            path: path
        })
    });
    if (!datum && (startAngle == null || endAngle == null || innerRadius == null || outerRadius == null)) {
        console.warn('[@visx/shape/Arc]: expected data because one of startAngle, endAngle, innerRadius, outerRadius is undefined. Bailing.');
        return null;
    }
    return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
        ref: innerRef,
        d: path(datum) || '',
        role: "img",
        "aria-label": ariaLabel,
        opacity: opacity,
        fill: fill,
        stroke: stroke,
        ...rest,
        className: (0, $bwpsq.default)([
            "_v5641dtu"
        ]),
        style: {
            "--_178jgwx": (0, $lD23V.default)(transition)
        }
    });
}
const $a2e3908135d5fd8e$export$6ef80ffb606dd232 = (0, $1xLej.element)($a2e3908135d5fd8e$var$Arc);

});
parcelRegister("8OBna", function(module, exports) {

$parcel$export(module.exports, "default", () => $66affbabea16b643$export$2e2bcd8739ae039);

var $cuOMt = parcelRequire("cuOMt");

var $fassv = parcelRequire("fassv");

var $h2VGU = parcelRequire("h2VGU");
function $66affbabea16b643$var$arcInnerRadius(d) {
    return d.innerRadius;
}
function $66affbabea16b643$var$arcOuterRadius(d) {
    return d.outerRadius;
}
function $66affbabea16b643$var$arcStartAngle(d) {
    return d.startAngle;
}
function $66affbabea16b643$var$arcEndAngle(d) {
    return d.endAngle;
}
function $66affbabea16b643$var$arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function $66affbabea16b643$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < (0, $fassv.epsilon)) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
}
// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function $66affbabea16b643$var$cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, $fassv.sqrt)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, $fassv.sqrt)((0, $fassv.max)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00;
    // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}
function $66affbabea16b643$export$2e2bcd8739ae039() {
    var innerRadius = $66affbabea16b643$var$arcInnerRadius, outerRadius = $66affbabea16b643$var$arcOuterRadius, cornerRadius = (0, $cuOMt.default)(0), padRadius = null, startAngle = $66affbabea16b643$var$arcStartAngle, endAngle = $66affbabea16b643$var$arcEndAngle, padAngle = $66affbabea16b643$var$arcPadAngle, context = null, path = (0, $h2VGU.withPath)(arc);
    function arc() {
        var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - (0, $fassv.halfPi), a1 = endAngle.apply(this, arguments) - (0, $fassv.halfPi), da = (0, $fassv.abs)(a1 - a0), cw = a1 > a0;
        if (!context) context = buffer = path();
        // Ensure that the outer radius is always larger than the inner radius.
        if (r1 < r0) r = r1, r1 = r0, r0 = r;
        // Is it a point?
        if (!(r1 > (0, $fassv.epsilon))) context.moveTo(0, 0);
        else if (da > (0, $fassv.tau) - (0, $fassv.epsilon)) {
            context.moveTo(r1 * (0, $fassv.cos)(a0), r1 * (0, $fassv.sin)(a0));
            context.arc(0, 0, r1, a0, a1, !cw);
            if (r0 > (0, $fassv.epsilon)) {
                context.moveTo(r0 * (0, $fassv.cos)(a1), r0 * (0, $fassv.sin)(a1));
                context.arc(0, 0, r0, a1, a0, cw);
            }
        } else {
            var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > (0, $fassv.epsilon) && (padRadius ? +padRadius.apply(this, arguments) : (0, $fassv.sqrt)(r0 * r0 + r1 * r1)), rc = (0, $fassv.min)((0, $fassv.abs)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1;
            // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
            if (rp > (0, $fassv.epsilon)) {
                var p0 = (0, $fassv.asin)(rp / r0 * (0, $fassv.sin)(ap)), p1 = (0, $fassv.asin)(rp / r1 * (0, $fassv.sin)(ap));
                if ((da0 -= p0 * 2) > (0, $fassv.epsilon)) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                if ((da1 -= p1 * 2) > (0, $fassv.epsilon)) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                else da1 = 0, a01 = a11 = (a0 + a1) / 2;
            }
            var x01 = r1 * (0, $fassv.cos)(a01), y01 = r1 * (0, $fassv.sin)(a01), x10 = r0 * (0, $fassv.cos)(a10), y10 = r0 * (0, $fassv.sin)(a10);
            // Apply rounded corners?
            if (rc > (0, $fassv.epsilon)) {
                var x11 = r1 * (0, $fassv.cos)(a11), y11 = r1 * (0, $fassv.sin)(a11), x00 = r0 * (0, $fassv.cos)(a00), y00 = r0 * (0, $fassv.sin)(a00), oc;
                // Restrict the corner radius according to the sector angle. If this
                // intersection fails, it’s probably because the arc is too small, so
                // disable the corner radius entirely.
                if (da < (0, $fassv.pi)) {
                    if (oc = $66affbabea16b643$var$intersect(x01, y01, x00, y00, x11, y11, x10, y10)) {
                        var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, $fassv.sin)((0, $fassv.acos)((ax * bx + ay * by) / ((0, $fassv.sqrt)(ax * ax + ay * ay) * (0, $fassv.sqrt)(bx * bx + by * by))) / 2), lc = (0, $fassv.sqrt)(oc[0] * oc[0] + oc[1] * oc[1]);
                        rc0 = (0, $fassv.min)(rc, (r0 - lc) / (kc - 1));
                        rc1 = (0, $fassv.min)(rc, (r1 - lc) / (kc + 1));
                    } else rc0 = rc1 = 0;
                }
            }
            // Is the sector collapsed to a line?
            if (!(da1 > (0, $fassv.epsilon))) context.moveTo(x01, y01);
            else if (rc1 > (0, $fassv.epsilon)) {
                t0 = $66affbabea16b643$var$cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                t1 = $66affbabea16b643$var$cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
                // Have the corners merged?
                if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, $fassv.atan2)(t0.y01, t0.x01), (0, $fassv.atan2)(t1.y01, t1.x01), !cw);
                else {
                    context.arc(t0.cx, t0.cy, rc1, (0, $fassv.atan2)(t0.y01, t0.x01), (0, $fassv.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r1, (0, $fassv.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $fassv.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                    context.arc(t1.cx, t1.cy, rc1, (0, $fassv.atan2)(t1.y11, t1.x11), (0, $fassv.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
            // Is there no inner ring, and it’s a circular sector?
            // Or perhaps it’s an annular sector collapsed due to padding?
            if (!(r0 > (0, $fassv.epsilon)) || !(da0 > (0, $fassv.epsilon))) context.lineTo(x10, y10);
            else if (rc0 > (0, $fassv.epsilon)) {
                t0 = $66affbabea16b643$var$cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                t1 = $66affbabea16b643$var$cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
                // Have the corners merged?
                if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, $fassv.atan2)(t0.y01, t0.x01), (0, $fassv.atan2)(t1.y01, t1.x01), !cw);
                else {
                    context.arc(t0.cx, t0.cy, rc0, (0, $fassv.atan2)(t0.y01, t0.x01), (0, $fassv.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r0, (0, $fassv.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $fassv.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                    context.arc(t1.cx, t1.cy, rc0, (0, $fassv.atan2)(t1.y11, t1.x11), (0, $fassv.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.arc(0, 0, r0, a10, a00, cw);
        }
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    arc.centroid = function() {
        var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - (0, $fassv.pi) / 2;
        return [
            (0, $fassv.cos)(a) * r,
            (0, $fassv.sin)(a) * r
        ];
    };
    arc.innerRadius = function(_) {
        return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, $cuOMt.default)(+_), arc) : innerRadius;
    };
    arc.outerRadius = function(_) {
        return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, $cuOMt.default)(+_), arc) : outerRadius;
    };
    arc.cornerRadius = function(_) {
        return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, $cuOMt.default)(+_), arc) : cornerRadius;
    };
    arc.padRadius = function(_) {
        return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, $cuOMt.default)(+_), arc) : padRadius;
    };
    arc.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $cuOMt.default)(+_), arc) : startAngle;
    };
    arc.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $cuOMt.default)(+_), arc) : endAngle;
    };
    arc.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $cuOMt.default)(+_), arc) : padAngle;
    };
    arc.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, arc) : context;
    };
    return arc;
}

});
parcelRegister("cuOMt", function(module, exports) {

$parcel$export(module.exports, "default", () => $918fad68d61d168d$export$2e2bcd8739ae039);
function $918fad68d61d168d$export$2e2bcd8739ae039(x) {
    return function constant() {
        return x;
    };
}

});

parcelRegister("fassv", function(module, exports) {

$parcel$export(module.exports, "abs", () => $b0addd7ea9ce041c$export$2335f513bbd82c6d);
$parcel$export(module.exports, "atan2", () => $b0addd7ea9ce041c$export$b8b770ee6a0d9760);
$parcel$export(module.exports, "cos", () => $b0addd7ea9ce041c$export$50d414a77b60d802);
$parcel$export(module.exports, "max", () => $b0addd7ea9ce041c$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $b0addd7ea9ce041c$export$96ec731ed4dcb222);
$parcel$export(module.exports, "sin", () => $b0addd7ea9ce041c$export$5de3937cb4b592ed);
$parcel$export(module.exports, "sqrt", () => $b0addd7ea9ce041c$export$eba8049fb5020b81);
$parcel$export(module.exports, "epsilon", () => $b0addd7ea9ce041c$export$6c421550c66a327d);
$parcel$export(module.exports, "pi", () => $b0addd7ea9ce041c$export$18c7bea995a110f);
$parcel$export(module.exports, "halfPi", () => $b0addd7ea9ce041c$export$e51408a300e8929a);
$parcel$export(module.exports, "tau", () => $b0addd7ea9ce041c$export$a4b4b4d4d776fe92);
$parcel$export(module.exports, "acos", () => $b0addd7ea9ce041c$export$fd6306be3fde5b04);
$parcel$export(module.exports, "asin", () => $b0addd7ea9ce041c$export$41726bdb1fc63f);
const $b0addd7ea9ce041c$export$2335f513bbd82c6d = Math.abs;
const $b0addd7ea9ce041c$export$b8b770ee6a0d9760 = Math.atan2;
const $b0addd7ea9ce041c$export$50d414a77b60d802 = Math.cos;
const $b0addd7ea9ce041c$export$8960430cfd85939f = Math.max;
const $b0addd7ea9ce041c$export$96ec731ed4dcb222 = Math.min;
const $b0addd7ea9ce041c$export$5de3937cb4b592ed = Math.sin;
const $b0addd7ea9ce041c$export$eba8049fb5020b81 = Math.sqrt;
const $b0addd7ea9ce041c$export$6c421550c66a327d = 1e-12;
const $b0addd7ea9ce041c$export$18c7bea995a110f = Math.PI;
const $b0addd7ea9ce041c$export$e51408a300e8929a = $b0addd7ea9ce041c$export$18c7bea995a110f / 2;
const $b0addd7ea9ce041c$export$a4b4b4d4d776fe92 = 2 * $b0addd7ea9ce041c$export$18c7bea995a110f;
function $b0addd7ea9ce041c$export$fd6306be3fde5b04(x) {
    return x > 1 ? 0 : x < -1 ? $b0addd7ea9ce041c$export$18c7bea995a110f : Math.acos(x);
}
function $b0addd7ea9ce041c$export$41726bdb1fc63f(x) {
    return x >= 1 ? $b0addd7ea9ce041c$export$e51408a300e8929a : x <= -1 ? -$b0addd7ea9ce041c$export$e51408a300e8929a : Math.asin(x);
}

});

parcelRegister("h2VGU", function(module, exports) {

$parcel$export(module.exports, "withPath", () => $c68f5fd20585fbc0$export$fb6e83118a5dcd45);

var $8CIIl = parcelRequire("8CIIl");
function $c68f5fd20585fbc0$export$fb6e83118a5dcd45(shape) {
    let digits = 3;
    shape.digits = function(_) {
        if (!arguments.length) return digits;
        if (_ == null) digits = null;
        else {
            const d = Math.floor(_);
            if (!(d >= 0)) throw new RangeError(`invalid digits: ${_}`);
            digits = d;
        }
        return shape;
    };
    return ()=>new (0, $8CIIl.Path)(digits);
}

});
parcelRegister("8CIIl", function(module, exports) {

$parcel$export(module.exports, "Path", () => $64748ea63159ab2b$export$4b2950bdac9b6ee9);
$parcel$export(module.exports, "path", () => $64748ea63159ab2b$export$bb654e07daaf8c3a);
const $64748ea63159ab2b$var$pi = Math.PI, $64748ea63159ab2b$var$tau = 2 * $64748ea63159ab2b$var$pi, $64748ea63159ab2b$var$epsilon = 1e-6, $64748ea63159ab2b$var$tauEpsilon = $64748ea63159ab2b$var$tau - $64748ea63159ab2b$var$epsilon;
function $64748ea63159ab2b$var$append(strings) {
    this._ += strings[0];
    for(let i = 1, n = strings.length; i < n; ++i)this._ += arguments[i] + strings[i];
}
function $64748ea63159ab2b$var$appendRound(digits) {
    let d = Math.floor(digits);
    if (!(d >= 0)) throw new Error(`invalid digits: ${digits}`);
    if (d > 15) return $64748ea63159ab2b$var$append;
    const k = 10 ** d;
    return function(strings) {
        this._ += strings[0];
        for(let i = 1, n = strings.length; i < n; ++i)this._ += Math.round(arguments[i] * k) / k + strings[i];
    };
}
class $64748ea63159ab2b$export$4b2950bdac9b6ee9 {
    constructor(digits){
        this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
        this._ = "";
        this._append = digits == null ? $64748ea63159ab2b$var$append : $64748ea63159ab2b$var$appendRound(digits);
    }
    moveTo(x, y) {
        this._append`M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}`;
    }
    closePath() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._append`Z`;
        }
    }
    lineTo(x, y) {
        this._append`L${this._x1 = +x},${this._y1 = +y}`;
    }
    quadraticCurveTo(x1, y1, x, y) {
        this._append`Q${+x1},${+y1},${this._x1 = +x},${this._y1 = +y}`;
    }
    bezierCurveTo(x1, y1, x2, y2, x, y) {
        this._append`C${+x1},${+y1},${+x2},${+y2},${this._x1 = +x},${this._y1 = +y}`;
    }
    arcTo(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        // Is the radius negative? Error.
        if (r < 0) throw new Error(`negative radius: ${r}`);
        let x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
        // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._append`M${this._x1 = x1},${this._y1 = y1}`;
        else if (!(l01_2 > $64748ea63159ab2b$var$epsilon)) ;
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $64748ea63159ab2b$var$epsilon) || !r) this._append`L${this._x1 = x1},${this._y1 = y1}`;
        else {
            let x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($64748ea63159ab2b$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
            // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $64748ea63159ab2b$var$epsilon) this._append`L${x1 + t01 * x01},${y1 + t01 * y01}`;
            this._append`A${r},${r},0,0,${+(y01 * x20 > x01 * y20)},${this._x1 = x1 + t21 * x21},${this._y1 = y1 + t21 * y21}`;
        }
    }
    arc(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        // Is the radius negative? Error.
        if (r < 0) throw new Error(`negative radius: ${r}`);
        let dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
        // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._append`M${x0},${y0}`;
        else if (Math.abs(this._x1 - x0) > $64748ea63159ab2b$var$epsilon || Math.abs(this._y1 - y0) > $64748ea63159ab2b$var$epsilon) this._append`L${x0},${y0}`;
        // Is this arc empty? We’re done.
        if (!r) return;
        // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $64748ea63159ab2b$var$tau + $64748ea63159ab2b$var$tau;
        // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $64748ea63159ab2b$var$tauEpsilon) this._append`A${r},${r},0,1,${cw},${x - dx},${y - dy}A${r},${r},0,1,${cw},${this._x1 = x0},${this._y1 = y0}`;
        else if (da > $64748ea63159ab2b$var$epsilon) this._append`A${r},${r},0,${+(da >= $64748ea63159ab2b$var$pi)},${cw},${this._x1 = x + r * Math.cos(a1)},${this._y1 = y + r * Math.sin(a1)}`;
    }
    rect(x, y, w, h) {
        this._append`M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}h${w = +w}v${+h}h${-w}Z`;
    }
    toString() {
        return this._;
    }
}
function $64748ea63159ab2b$export$bb654e07daaf8c3a() {
    return new $64748ea63159ab2b$export$4b2950bdac9b6ee9;
}
// Allow instanceof d3.path
$64748ea63159ab2b$export$bb654e07daaf8c3a.prototype = $64748ea63159ab2b$export$4b2950bdac9b6ee9.prototype;
function $64748ea63159ab2b$export$e181c6ece8d9cc5f(digits = 3) {
    return new $64748ea63159ab2b$export$4b2950bdac9b6ee9(+digits);
}

});




parcelRegister("gUvRg", function(module, exports) {

$parcel$export(module.exports, "DARK_ORDINAL_COLORS", () => $c4fa96a3b63de071$export$5bb7f899a725c5db);
$parcel$export(module.exports, "LIGHT_ORDINAL_COLORS", () => $c4fa96a3b63de071$export$3f0e124a5347f792);
$parcel$export(module.exports, "DEFAULT_STATUS_ORDINAL_COLORS", () => $c4fa96a3b63de071$export$5d11cb9bccf8f5db);
$parcel$export(module.exports, "DEFAULT_ORDINAL_PATTERNS_DEFS", () => $c4fa96a3b63de071$export$3b4caf16b18628d7);
$parcel$export(module.exports, "DEFAULT_ORDINAL_PATTERNS", () => $c4fa96a3b63de071$export$7b0a836186aa9014);
$parcel$export(module.exports, "useThemeFillStyles", () => $c4fa96a3b63de071$export$c533e33795ec3ca2);
$parcel$export(module.exports, "Theme", () => $c4fa96a3b63de071$export$14faa19a0f3bbeb2);

var $1xLej = parcelRequire("1xLej");

var $36FXm = parcelRequire("36FXm");
var $1vFS2 = parcelRequire("1vFS2");
var $eI0U6 = parcelRequire("eI0U6");
var $at5Kr = parcelRequire("at5Kr");
var $tzkRL = parcelRequire("tzkRL");
var $fmpgQ = parcelRequire("fmpgQ");

var $2OMIu = parcelRequire("2OMIu");
const $c4fa96a3b63de071$export$5bb7f899a725c5db = [
    '#4688EC',
    '#94C748',
    '#C97CF4',
    '#FCA700',
    '#1558BC',
    '#964AC0',
    '#42B2D7',
    '#E06C00'
];
const $c4fa96a3b63de071$export$3f0e124a5347f792 = [
    '#357DE8',
    '#82B536',
    '#BF63F3',
    '#F68909',
    '#1558BC',
    '#964AC0',
    '#42B2D7',
    '#BD5B00'
];
const $c4fa96a3b63de071$export$f32b764d072ed1b7 = [
    "var(--ds-chart-categorical-1, #2898BD)",
    "var(--ds-chart-categorical-2, #5E4DB2)",
    "var(--ds-chart-categorical-3, #E56910)",
    "var(--ds-chart-categorical-4, #943D73)",
    "var(--ds-chart-categorical-5, #09326C)",
    "var(--ds-chart-categorical-6, #8F7EE7)",
    "var(--ds-chart-categorical-7, #50253F)",
    "var(--ds-chart-categorical-8, #A54800)"
];
const $c4fa96a3b63de071$export$5d11cb9bccf8f5db = [
    {
        key: 'danger',
        value: "var(--ds-chart-danger, #F15B50)"
    },
    {
        key: 'warning',
        value: "var(--ds-chart-warning, #B38600)"
    },
    {
        key: 'success',
        value: "var(--ds-chart-success, #22A06B)"
    },
    {
        key: 'discovery',
        value: "var(--ds-chart-discovery, #8F7EE7)"
    },
    {
        key: 'information',
        value: "var(--ds-chart-information, #388BFF)"
    },
    {
        key: 'neutral',
        value: "var(--ds-chart-neutral, #8590A2)"
    }
];
const $c4fa96a3b63de071$export$f29a3c9071a2ca9 = [
    "var(--ds-chart-red-bold, #2898BD)",
    "var(--ds-chart-orange-bold, #943D73)",
    "var(--ds-chart-yellow-bold, #E56910)",
    "var(--ds-chart-lime-bold, #5E4DB2)",
    "var(--ds-chart-green-bold, #09326C)",
    "var(--ds-chart-teal-bold, #09326C)",
    "var(--ds-chart-blue-bold, #8F7EE7)",
    "var(--ds-chart-purple-bold, #50253F)",
    "var(--ds-chart-magenta-bold, #A54800)",
    "var(--ds-chart-gray-bold, #A54800)",
    "var(--ds-chart-red-boldest, #2898BD)",
    "var(--ds-chart-orange-boldest, #943D73)",
    "var(--ds-chart-yellow-boldest, #E56910)",
    "var(--ds-chart-lime-boldest, #5E4DB2)",
    "var(--ds-chart-green-boldest, #09326C)",
    "var(--ds-chart-teal-boldest, #09326C)",
    "var(--ds-chart-blue-boldest, #8F7EE7)",
    "var(--ds-chart-purple-boldest, #50253F)",
    "var(--ds-chart-magenta-boldest, #A54800)",
    "var(--ds-chart-gray-boldest, #A54800)"
];
const $c4fa96a3b63de071$export$1a2fb10b6c1fe2eb = [
    "var(--ds-chart-blue-bolder, #357DE8)",
    "var(--ds-chart-lime-bold, #82B536)",
    "var(--ds-chart-purple-bold, #BF63F3)",
    "var(--ds-chart-orange-bold, #F68909)",
    "var(--ds-chart-blue-boldest, #1558BC)",
    "var(--ds-chart-purple-bolder, #964AC0)",
    "var(--ds-chart-teal-bold, #42B2D7)",
    "var(--ds-chart-orange-bolder, #BD5B00)"
];
const $c4fa96a3b63de071$export$3b4caf16b18628d7 = [
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $tzkRL.default), {
        id: 'lines1',
        height: 5,
        width: 5,
        stroke: '#000000',
        background: $c4fa96a3b63de071$export$1a2fb10b6c1fe2eb[0],
        strokeWidth: 1,
        orientation: [
            'diagonal'
        ]
    }),
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eI0U6.default), {
        id: 'crosshair1',
        width: 5,
        height: 5,
        stroke: '#000000',
        background: $c4fa96a3b63de071$export$1a2fb10b6c1fe2eb[1],
        strokeWidth: 0.7,
        rotation: 45,
        gap: 7
    }),
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $tzkRL.default), {
        id: 'lines2',
        height: 5,
        width: 5,
        stroke: '#000000',
        background: $c4fa96a3b63de071$export$1a2fb10b6c1fe2eb[2],
        strokeWidth: 1,
        orientation: [
            'diagonalRightToLeft'
        ]
    }),
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eI0U6.default), {
        id: 'crosshair2',
        width: 10,
        height: 10,
        stroke: '#000000',
        background: $c4fa96a3b63de071$export$1a2fb10b6c1fe2eb[3],
        strokeWidth: 0.5,
        rotation: 45,
        gap: 7
    }),
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1vFS2.default), {
        id: "circles1",
        height: 8,
        width: 8,
        radius: 1,
        background: $c4fa96a3b63de071$export$1a2fb10b6c1fe2eb[4],
        stroke: '#000000',
        strokeWidth: 0.4,
        complement: true,
        fill: 'none'
    }),
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fmpgQ.default), {
        id: "waves1",
        height: 6,
        width: 6,
        stroke: '#000000',
        background: $c4fa96a3b63de071$export$1a2fb10b6c1fe2eb[5],
        strokeWidth: 0.5
    }),
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $at5Kr.default), {
        id: "hexagons1",
        height: 3,
        background: $c4fa96a3b63de071$export$1a2fb10b6c1fe2eb[6],
        size: 3,
        gap: 2,
        strokeWidth: 0.5,
        stroke: "#000000"
    }),
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $tzkRL.default), {
        id: "lines3",
        height: 6,
        width: 5,
        stroke: '#000000',
        strokeDasharray: 3,
        background: $c4fa96a3b63de071$export$1a2fb10b6c1fe2eb[7],
        orientation: [
            'horizontal'
        ]
    })
];
const $c4fa96a3b63de071$export$7b0a836186aa9014 = (0, $36FXm.getPatternUrls)($c4fa96a3b63de071$export$3b4caf16b18628d7);
const $c4fa96a3b63de071$export$c533e33795ec3ca2 = (_ref)=>{
    let { fillStyles: fillStyles } = _ref;
    if (!fillStyles) return {
        range: [],
        domain: []
    };
    if (fillStyles.filter((d)=>typeof d !== 'string').length > 0) return {
        domain: fillStyles.map((d)=>typeof d === 'string' ? d : d.key),
        range: fillStyles.map((d)=>typeof d === 'string' ? d : d.value)
    };
    else return {
        range: fillStyles === null || fillStyles === void 0 ? void 0 : fillStyles.map((d)=>typeof d === 'string' ? d : d.value)
    };
};
const $c4fa96a3b63de071$export$14faa19a0f3bbeb2 = (0, $1xLej.element)((_ref2)=>{
    let { children: children } = _ref2;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
});
const $c4fa96a3b63de071$export$569885e57444f84a = {
    accessibleCategorical: $c4fa96a3b63de071$export$f32b764d072ed1b7,
    categorical: $c4fa96a3b63de071$export$1a2fb10b6c1fe2eb,
    status: $c4fa96a3b63de071$export$5d11cb9bccf8f5db,
    categorical20: $c4fa96a3b63de071$export$f29a3c9071a2ca9,
    accessiblePatternDefs: $c4fa96a3b63de071$export$3b4caf16b18628d7
};

});
parcelRegister("36FXm", function(module, exports) {

$parcel$export(module.exports, "getPatternUrls", () => $24327a5561e77841$export$c66920886885446e);
const $24327a5561e77841$export$c66920886885446e = (patterns)=>{
    if (!patterns) return [];
    return patterns.map((pattern)=>`url(#${pattern.props.id})`);
};

});

parcelRegister("1vFS2", function(module, exports) {

$parcel$export(module.exports, "default", () => $11992a54050b85ce$export$2e2bcd8739ae039);
// import cx from 'classnames';

var $9NZZf = parcelRequire("9NZZf");

var $2OMIu = parcelRequire("2OMIu");
function $11992a54050b85ce$export$2e2bcd8739ae039(_ref) {
    var _corners;
    let { id: id, width: width, height: height, radius: radius = 2, fill: fill, stroke: stroke, strokeWidth: strokeWidth, strokeDasharray: strokeDasharray, background: background, complement: complement = false, className: className } = _ref;
    let corners;
    if (complement) corners = [
        [
            0,
            0
        ],
        [
            0,
            height
        ],
        [
            width,
            0
        ],
        [
            width,
            height
        ]
    ];
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $9NZZf.default), {
        id: id,
        width: width,
        height: height,
        children: [
            !!background && /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                width: width,
                height: height,
                fill: background
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("circle", {
                // className={cx('visx-pattern-circle', className)}
                cx: width / 2,
                cy: height / 2,
                r: radius,
                fill: fill,
                stroke: stroke,
                strokeWidth: strokeWidth,
                strokeDasharray: strokeDasharray
            }),
            (_corners = corners) === null || _corners === void 0 ? void 0 : _corners.map((_ref2)=>{
                let [cornerX, cornerY] = _ref2;
                return /*#__PURE__*/ (0, $2OMIu.jsx)("circle", {
                    // className={cx('visx-pattern-circle visx-pattern-circle-complement', className)}
                    cx: cornerX,
                    cy: cornerY,
                    r: radius,
                    fill: fill,
                    stroke: stroke,
                    strokeWidth: strokeWidth,
                    strokeDasharray: strokeDasharray
                }, `${id}-complement-${cornerX}-${cornerY}`);
            })
        ]
    });
}

});
parcelRegister("9NZZf", function(module, exports) {

$parcel$export(module.exports, "default", () => $7238c5fbf3c5b07a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
function $7238c5fbf3c5b07a$export$2e2bcd8739ae039(_ref) {
    let { id: id, width: width, height: height, children: children } = _ref;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("defs", {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("pattern", {
            id: id,
            width: width,
            height: height,
            patternUnits: "userSpaceOnUse",
            children: children
        })
    });
}

});


parcelRegister("eI0U6", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab55e03aef75907f$export$2e2bcd8739ae039);

var $9NZZf = parcelRequire("9NZZf");

var $2OMIu = parcelRequire("2OMIu");
function $ab55e03aef75907f$export$2e2bcd8739ae039(_ref) {
    let { id: id, width: width, height: height, stroke: stroke = 'black', strokeWidth: strokeWidth = 1, strokeDasharray: strokeDasharray, background: background, className: className, rotation: rotation = 0, gap: gap = 10 } = _ref;
    const halfGap = gap / 2;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $9NZZf.default), {
        id: id,
        width: gap,
        height: gap,
        children: [
            !!background && /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                width: gap,
                height: gap,
                fill: background
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                transform: `rotate(${rotation}, ${gap / 2}, ${gap / 2})`,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("line", {
                        // Horizontal line
                        x1: halfGap - width / 2,
                        y1: halfGap,
                        x2: halfGap + width / 2,
                        y2: halfGap,
                        stroke: stroke,
                        strokeWidth: strokeWidth,
                        strokeDasharray: strokeDasharray
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("line", {
                        // Vertical line
                        x1: halfGap,
                        y1: halfGap - height / 2,
                        x2: halfGap,
                        y2: halfGap + height / 2,
                        stroke: stroke,
                        strokeWidth: strokeWidth,
                        strokeDasharray: strokeDasharray
                    })
                ]
            })
        ]
    });
}

});

parcelRegister("at5Kr", function(module, exports) {

$parcel$export(module.exports, "default", () => $79f11247fb4541b1$export$2e2bcd8739ae039);

var $edkbM = parcelRequire("edkbM");

var $2OMIu = parcelRequire("2OMIu");
function $79f11247fb4541b1$export$2e2bcd8739ae039(_ref) {
    let { id: id, height: height, fill: fill, stroke: stroke, strokeWidth: strokeWidth, strokeDasharray: strokeDasharray, shapeRendering: shapeRendering, background: background, className: className, size: size = 3, gap: gap = 0 } = _ref;
    const hexWidth = size * Math.sqrt(3) + gap;
    const hexHeight = size * 2 + gap;
    const path = `
        M ${size * Math.sqrt(3) / 2 + gap / 2},${gap / 2}
        L ${size * Math.sqrt(3) + gap / 2},${size / 2 + gap / 2}
        L ${size * Math.sqrt(3) + gap / 2},${size * 1.5 + gap / 2}
        L ${size * Math.sqrt(3) / 2 + gap / 2},${size * 2 + gap / 2}
        L ${gap / 2},${size * 1.5 + gap / 2}
        L ${gap / 2},${size / 2 + gap / 2}
        Z
    `;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $edkbM.default), {
        path: path,
        id: id,
        width: hexWidth,
        height: hexHeight,
        fill: fill,
        stroke: stroke,
        strokeWidth: strokeWidth,
        strokeDasharray: strokeDasharray,
        shapeRendering: shapeRendering,
        background: background
    });
}

});
parcelRegister("edkbM", function(module, exports) {

$parcel$export(module.exports, "default", () => $a591f0adba09b863$export$2e2bcd8739ae039);
// import cx from 'classnames';

var $9NZZf = parcelRequire("9NZZf");

var $2OMIu = parcelRequire("2OMIu");
function $a591f0adba09b863$export$2e2bcd8739ae039(_ref) {
    let { id: id, width: width, height: height, path: path, fill: fill = 'transparent', stroke: stroke, strokeWidth: strokeWidth, strokeDasharray: strokeDasharray, strokeLinecap: strokeLinecap = 'square', shapeRendering: shapeRendering = 'auto', background: background, className: className } = _ref;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $9NZZf.default), {
        id: id,
        width: width,
        height: height,
        children: [
            !!background && /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                width: width,
                height: height,
                fill: background
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                // className={cx('visx-pattern-path', className)}
                d: path,
                fill: fill,
                stroke: stroke,
                strokeWidth: strokeWidth,
                strokeDasharray: strokeDasharray,
                strokeLinecap: strokeLinecap,
                shapeRendering: shapeRendering
            })
        ]
    });
}

});


parcelRegister("tzkRL", function(module, exports) {

$parcel$export(module.exports, "default", () => $058e1e73ded3a1ef$export$2e2bcd8739ae039);
// import cx from 'classnames';

var $8Y6fp = parcelRequire("8Y6fp");

var $9NZZf = parcelRequire("9NZZf");

var $2OMIu = parcelRequire("2OMIu");
function $058e1e73ded3a1ef$export$777054cdc3eb6ab2(_ref) {
    let { height: height, orientation: orientation } = _ref;
    switch(orientation){
        case (0, $8Y6fp.PatternOrientation).horizontal:
            return `M 0,${height / 2} l ${height},0`;
        case (0, $8Y6fp.PatternOrientation).diagonal:
            return `M 0,${height} l ${height},${-height} M ${-height / 4},${height / 4} l ${height / 2},${-height / 2}
             M ${3 / 4 * height},${5 / 4 * height} l ${height / 2},${-height / 2}`;
        case (0, $8Y6fp.PatternOrientation).diagonalRightToLeft:
            return `M 0,0 l ${height},${height}
        M ${-height / 4},${3 / 4 * height} l ${height / 2},${height / 2}
        M ${3 / 4 * height},${-height / 4} l ${height / 2},${height / 2}`;
        case (0, $8Y6fp.PatternOrientation).vertical:
        default:
            return `M ${height / 2}, 0 l 0, ${height}`;
    }
}
function $058e1e73ded3a1ef$export$2e2bcd8739ae039(_ref2) {
    let { id: id, width: width, height: height, stroke: stroke, strokeWidth: strokeWidth, strokeDasharray: strokeDasharray, strokeLinecap: strokeLinecap = 'square', shapeRendering: shapeRendering = 'auto', orientation: orientation = [
        'vertical'
    ], background: background, className: className } = _ref2;
    const orientations = Array.isArray(orientation) ? orientation : [
        orientation
    ];
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $9NZZf.default), {
        id: id,
        width: width,
        height: height,
        children: [
            !!background && /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                // className={cx('visx-pattern-line-background')}
                width: width,
                height: height,
                fill: background
            }),
            orientations.map((o, i)=>/*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    // className={cx('visx-pattern-line', className)}
                    d: $058e1e73ded3a1ef$export$777054cdc3eb6ab2({
                        orientation: o,
                        height: height
                    }),
                    stroke: stroke,
                    strokeWidth: strokeWidth,
                    strokeDasharray: strokeDasharray,
                    strokeLinecap: strokeLinecap,
                    shapeRendering: shapeRendering
                }, `visx-${id}-line-${o}-${i}`))
        ]
    });
}

});
parcelRegister("8Y6fp", function(module, exports) {

$parcel$export(module.exports, "PatternOrientation", () => $6878c5f4aa13ee1a$export$c37d4d4692ef0c91);
const $6878c5f4aa13ee1a$export$c37d4d4692ef0c91 = {
    horizontal: 'horizontal',
    vertical: 'vertical',
    diagonal: 'diagonal',
    diagonalRightToLeft: 'diagonalRightToLeft'
};

});


parcelRegister("fmpgQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2ec83536669626b$export$2e2bcd8739ae039);
// import cx from 'classnames';

var $edkbM = parcelRequire("edkbM");

var $2OMIu = parcelRequire("2OMIu");
function $b2ec83536669626b$export$2e2bcd8739ae039(_ref) {
    let { id: id, width: width, height: height, fill: fill, stroke: stroke, strokeWidth: strokeWidth, strokeDasharray: strokeDasharray, strokeLinecap: strokeLinecap, shapeRendering: shapeRendering, background: background, className: className } = _ref;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $edkbM.default), {
        path: `M 0 ${height / 2} c ${height / 8} ${-height / 4} , ${height * 3 / 8} ${-height / 4} , ${height / 2} 0
             c ${height / 8} ${height / 4} , ${height * 3 / 8} ${height / 4} , ${height / 2} 0 M ${-height / 2} ${height / 2}
             c ${height / 8} ${height / 4} , ${height * 3 / 8} ${height / 4} , ${height / 2} 0 M ${height} ${height / 2}
             c ${height / 8} ${-height / 4} , ${height * 3 / 8} ${-height / 4} , ${height / 2} 0`,
        id: id,
        width: width,
        height: height,
        fill: fill,
        stroke: stroke,
        strokeWidth: strokeWidth,
        strokeDasharray: strokeDasharray,
        strokeLinecap: strokeLinecap,
        shapeRendering: shapeRendering,
        background: background
    });
}

});


parcelRegister("2dgU7", function(module, exports) {

$parcel$export(module.exports, "default", () => $19c9e87b14940b14$export$2e2bcd8739ae039);

var $iktP3 = parcelRequire("iktP3");

var $5uXOq = parcelRequire("5uXOq");

var $ce7aF = parcelRequire("ce7aF");

var $2OMIu = parcelRequire("2OMIu");
function $19c9e87b14940b14$export$2e2bcd8739ae039(_ref) {
    let { children: children } = _ref;
    const emitter = (0, $5uXOq.useMemo)(()=>(0, $iktP3.default)(), []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ce7aF.default).Provider, {
        value: emitter,
        children: children
    });
}

});
parcelRegister("iktP3", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5813a61ecdc228a$export$2e2bcd8739ae039);
function $d5813a61ecdc228a$export$2e2bcd8739ae039(n) {
    return {
        all: n = n || new Map,
        on: function(t, e) {
            var i = n.get(t);
            i ? i.push(e) : n.set(t, [
                e
            ]);
        },
        off: function(t, e) {
            var i = n.get(t);
            i && (e ? i.splice(i.indexOf(e) >>> 0, 1) : n.set(t, []));
        },
        emit: function(t, e) {
            var i = n.get(t);
            i && i.slice().map(function(n) {
                n(e);
            }), (i = n.get("*")) && i.slice().map(function(n) {
                n(t, e);
            });
        }
    };
}

});


parcelRegister("d9Y89", function(module, exports) {

$parcel$export(module.exports, "default", () => $994ac24effc0a743$export$2e2bcd8739ae039);

var $2qM0c = parcelRequire("2qM0c");

var $5uXOq = parcelRequire("5uXOq");

var $kaPp4 = parcelRequire("kaPp4");

var $dYSV3 = parcelRequire("dYSV3");

var $2OMIu = parcelRequire("2OMIu");
function $994ac24effc0a743$var$isValidNumber(_) {
    return _ != null && typeof _ === 'number' && !Number.isNaN(_) && Number.isFinite(_);
}
function $994ac24effc0a743$export$2e2bcd8739ae039(_ref) {
    let { hideTooltipDebounceMs: hideTooltipDebounceMs = 200, children: children } = _ref;
    const { tooltipOpen: tooltipOpen, tooltipLeft: tooltipLeft, tooltipTop: tooltipTop, tooltipData: tooltipData, updateTooltip: updateTooltip, hideTooltip: privateHideTooltip } = (0, $kaPp4.default)(undefined);
    const debouncedHideTooltip = (0, $5uXOq.useRef)(null);
    function cancelDeboundedHideTooltip() {
        if (debouncedHideTooltip.current) {
            debouncedHideTooltip.current.cancel();
            debouncedHideTooltip.current = null;
        }
    }
    (0, $5uXOq.useEffect)(()=>cancelDeboundedHideTooltip, []);
    const showTooltip = (0, $5uXOq.useRef)((props)=>{
        // cancel any hideTooltip calls so it won't hide after invoking the logic below
        if (!props) return;
        const { svgPoint: svgPoint, event: event } = props;
        // Datum by key will only be there sometimes
        if (!props.eventData) return;
        const { datumByKey: datumByKey, ...rest } = props === null || props === void 0 ? void 0 : props.eventData;
        cancelDeboundedHideTooltip();
        const tooltipLeft = event && 'clientX' in event ? event === null || event === void 0 ? void 0 : event.clientX : svgPoint === null || svgPoint === void 0 ? void 0 : svgPoint.x;
        const tooltipTop = event && 'clientY' in event ? event === null || event === void 0 ? void 0 : event.clientY : svgPoint === null || svgPoint === void 0 ? void 0 : svgPoint.y;
        // We may want to avoid updates in some cases.
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        updateTooltip((_ref2)=>{
            let { tooltipData: oldData } = _ref2;
            return {
                tooltipOpen: true,
                tooltipLeft: tooltipLeft,
                tooltipTop: tooltipTop,
                tooltipData: {
                    event: event,
                    nearestDatum: rest,
                    datumByKey: datumByKey || new Map()
                }
            };
        });
    });
    const hideTooltip = (0, $5uXOq.useCallback)(()=>{
        debouncedHideTooltip.current = (0, (/*@__PURE__*/$parcel$interopDefault($2qM0c)))(privateHideTooltip, hideTooltipDebounceMs);
        debouncedHideTooltip.current();
    }, [
        privateHideTooltip,
        hideTooltipDebounceMs
    ]);
    const value = (0, $5uXOq.useMemo)(()=>({
            tooltipOpen: tooltipOpen,
            tooltipLeft: tooltipLeft,
            tooltipTop: tooltipTop,
            tooltipData: tooltipData,
            updateTooltip: updateTooltip,
            showTooltip: showTooltip.current,
            hideTooltip: hideTooltip
        }), [
        hideTooltip,
        tooltipData,
        tooltipLeft,
        tooltipOpen,
        tooltipTop,
        updateTooltip
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dYSV3.default).Provider, {
        value: value,
        children: children
    });
}

});
parcelRegister("2qM0c", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $1c533eb56f421364$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var $1c533eb56f421364$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $1c533eb56f421364$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $1c533eb56f421364$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $1c533eb56f421364$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $1c533eb56f421364$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $1c533eb56f421364$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $1c533eb56f421364$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $1c533eb56f421364$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $1c533eb56f421364$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $1c533eb56f421364$var$root = $1c533eb56f421364$var$freeGlobal || $1c533eb56f421364$var$freeSelf || Function('return this')();
/** Used for built-in method references. */ var $1c533eb56f421364$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $1c533eb56f421364$var$objectToString = $1c533eb56f421364$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $1c533eb56f421364$var$nativeMax = Math.max, $1c533eb56f421364$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $1c533eb56f421364$var$now = function() {
    return $1c533eb56f421364$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $1c533eb56f421364$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($1c533eb56f421364$var$FUNC_ERROR_TEXT);
    wait = $1c533eb56f421364$var$toNumber(wait) || 0;
    if ($1c533eb56f421364$var$isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $1c533eb56f421364$var$nativeMax($1c533eb56f421364$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $1c533eb56f421364$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $1c533eb56f421364$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($1c533eb56f421364$var$now());
    }
    function debounced() {
        var time = $1c533eb56f421364$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $1c533eb56f421364$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $1c533eb56f421364$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $1c533eb56f421364$var$isSymbol(value) {
    return typeof value == 'symbol' || $1c533eb56f421364$var$isObjectLike(value) && $1c533eb56f421364$var$objectToString.call(value) == $1c533eb56f421364$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $1c533eb56f421364$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($1c533eb56f421364$var$isSymbol(value)) return $1c533eb56f421364$var$NAN;
    if ($1c533eb56f421364$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $1c533eb56f421364$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($1c533eb56f421364$var$reTrim, '');
    var isBinary = $1c533eb56f421364$var$reIsBinary.test(value);
    return isBinary || $1c533eb56f421364$var$reIsOctal.test(value) ? $1c533eb56f421364$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $1c533eb56f421364$var$reIsBadHex.test(value) ? $1c533eb56f421364$var$NAN : +value;
}
module.exports = $1c533eb56f421364$var$debounce;

});

parcelRegister("kaPp4", function(module, exports) {

$parcel$export(module.exports, "default", () => $eafc9d7ae9cf5da9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $eafc9d7ae9cf5da9$export$2e2bcd8739ae039(/** Optional initial TooltipState. */ initialTooltipState) {
    const [tooltipState, setTooltipState] = (0, $5uXOq.useState)({
        tooltipOpen: false,
        ...initialTooltipState
    });
    const showTooltip = (0, $5uXOq.useCallback)((showArgs)=>setTooltipState(typeof showArgs === 'function' ? (_ref)=>{
            let { tooltipOpen: tooltipOpen, ...show } = _ref;
            return {
                ...showArgs(show),
                tooltipOpen: true
            };
        } : {
            tooltipOpen: true,
            tooltipLeft: showArgs.tooltipLeft,
            tooltipTop: showArgs.tooltipTop,
            tooltipData: showArgs.tooltipData
        }), [
        setTooltipState
    ]);
    const hideTooltip = (0, $5uXOq.useCallback)(()=>setTooltipState({
            tooltipOpen: false,
            tooltipLeft: undefined,
            tooltipTop: undefined,
            tooltipData: undefined
        }), [
        setTooltipState
    ]);
    return {
        tooltipOpen: tooltipState.tooltipOpen,
        tooltipLeft: tooltipState.tooltipLeft,
        tooltipTop: tooltipState.tooltipTop,
        tooltipData: tooltipState.tooltipData,
        updateTooltip: setTooltipState,
        showTooltip: showTooltip,
        hideTooltip: hideTooltip
    };
}

});

parcelRegister("dYSV3", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2db7acbe58821cc$export$2e2bcd8739ae039);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $5uXOq = parcelRequire("5uXOq");
const $a2db7acbe58821cc$var$TooltipContext = /*#__PURE__*/ (0, $5uXOq.createContext)({});
var $a2db7acbe58821cc$export$2e2bcd8739ae039 = $a2db7acbe58821cc$var$TooltipContext;

});


parcelRegister("8upbu", function(module, exports) {

$parcel$export(module.exports, "SingleSeriesTooltip", () => $62e4a921b2a96d37$export$417a3bee9df17219);

var $1xLej = parcelRequire("1xLej");

var $7Mdb4 = parcelRequire("7Mdb4");

var $a6QE1 = parcelRequire("a6QE1");

var $lCjFE = parcelRequire("lCjFE");

var $2OMIu = parcelRequire("2OMIu");
function $62e4a921b2a96d37$var$SingleSeriesTooltip(_ref) {
    var _window, _window2;
    let { tooltipData: tooltipData, tooltipLeft: tooltipLeft, tooltipTop: tooltipTop, colorAccessor: colorAccessor, labelAccessor: labelAccessor, valueAccessor: valueAccessor, colorScale: colorScale, valueFormatter: valueFormatter = (0, $lCjFE.default).formatNumberAbbreviated } = _ref;
    const datum = tooltipData === null || tooltipData === void 0 ? void 0 : tooltipData.nearestDatum.datum;
    // TODO: SSR check
    const scrollX = ((_window = window) === null || _window === void 0 ? void 0 : _window.scrollX) || 0;
    const scrollY = ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.scrollY) || 0;
    const portalLeft = (tooltipLeft || 0) + scrollX;
    const portalTop = (tooltipTop || 0) + scrollY;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: datum && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $a6QE1.TooltipWithBounds), {
            left: portalLeft,
            top: portalTop,
            tooltipPortalElement: document.body,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7Mdb4.TooltipRow), {
                datum: datum,
                color: colorScale(colorAccessor(datum)),
                label: labelAccessor(datum),
                value: String(valueFormatter(valueAccessor(datum)))
            }, String(labelAccessor(datum)))
        })
    });
}
const $62e4a921b2a96d37$export$417a3bee9df17219 = (0, $1xLej.element)($62e4a921b2a96d37$var$SingleSeriesTooltip);

});
parcelRegister("7Mdb4", function(module, exports) {

$parcel$export(module.exports, "TooltipRow", () => $5a973cdf469c1297$export$4cf463b4a9fc631a);
/* TooltipRow.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $bwpsq = parcelRequire("bwpsq");

var $lFJ6b = parcelRequire("lFJ6b");

var $1xLej = parcelRequire("1xLej");

var $2OMIu = parcelRequire("2OMIu");
const $5a973cdf469c1297$var$outerDivCss = null;
const $5a973cdf469c1297$var$innerDivCss = null;
const $5a973cdf469c1297$var$colorItemCss = null;
const $5a973cdf469c1297$var$labelItemCss = null;
const $5a973cdf469c1297$var$valueItemCss = null;
function $5a973cdf469c1297$var$TooltipRow(_ref) {
    let { color: color, label: label, value: value, isFocussed: isFocussed } = _ref;
    const labelColor = isFocussed === undefined ? "var(--ds-text-subtlest, #626F86)" : isFocussed ? "var(--ds-text-accent-gray-bolder, #091E42)" : "var(--ds-text-subtlest, #626F86)";
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "list",
        className: (0, $bwpsq.default)([
            "_1wpz1fhb _1bah1yb4 _4cvr1h6o _1e0c116y"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
            role: "listitem",
            className: (0, $bwpsq.default)([
                "_u5f3ftgi _1bah1y6m _4cvr1h6o _zulpftgi _1e0c1txw _v5641w7c"
            ]),
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        "_1bah1y6m _4cvr1h6o _zulpftgi _1e0c1txw _v5641w7c"
                    ]),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
                        style: {
                            width: 12,
                            height: 12,
                            borderRadius: 2,
                            opacity: isFocussed === undefined ? 1 : isFocussed ? 1 : (0, $lFJ6b.NON_HOVER_OPACITY)
                        },
                        className: (0, $bwpsq.default)([
                            "_v56414fr"
                        ]),
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                            width: "100%",
                            height: "100%",
                            fill: color
                        })
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    style: {
                        color: labelColor
                    },
                    className: (0, $bwpsq.default)([
                        "_ect41wi2 _1wybdlk8 _k48p1nn1 _slp31hna _v564zqrc"
                    ]),
                    children: label
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    style: {
                        color: labelColor
                    },
                    className: (0, $bwpsq.default)([
                        "_ect41wi2 _1wybdlk8 _k48p1nn1 _vwz41q5e _slp31hna _v564zqrc"
                    ]),
                    children: value
                })
            ]
        })
    });
}
const $5a973cdf469c1297$export$4cf463b4a9fc631a = (0, $1xLej.element)($5a973cdf469c1297$var$TooltipRow);

});

parcelRegister("a6QE1", function(module, exports) {

$parcel$export(module.exports, "TooltipWithBounds", () => $75c34d03f8863ce8$export$5663192fda24cade);

var $5uXOq = parcelRequire("5uXOq");

var $1xLej = parcelRequire("1xLej");

var $gB7jb = parcelRequire("gB7jb");

var $2OMIu = parcelRequire("2OMIu");
const $75c34d03f8863ce8$var$DEFAULT_TRANSLATE = 'translate(0%, -100%)';
function $75c34d03f8863ce8$var$_TooltipWithBounds(_ref) {
    let { children: children, style: style, left: initialLeft = 0, offsetLeft: offsetLeft = 2, offsetTop: offsetTop = -2, top: initialTop = 0, ...otherProps } = _ref;
    const elementRef = (0, $5uXOq.useRef)(null);
    const [transformStyle, setTransformStyle] = (0, $5uXOq.useState)($75c34d03f8863ce8$var$DEFAULT_TRANSLATE);
    (0, $5uXOq.useEffect)(()=>{
        var _elementRef$current;
        const rect = (_elementRef$current = elementRef.current) === null || _elementRef$current === void 0 ? void 0 : _elementRef$current.getBoundingClientRect();
        if (rect) {
            const outOfViewTop = Math.min(0, initialTop - rect.height);
            const outOfViewRight = Math.max(0, initialLeft + rect.width - window.innerWidth);
            const translateX = outOfViewRight > 0 ? -rect.width : 0;
            const translateY = outOfViewTop < 0 ? 0 : -rect.height;
            setTransformStyle(`translate(${translateX}px, ${translateY}px )`);
        }
    }, [
        initialTop,
        initialLeft,
        elementRef
    ]); // Dependency on adjusted state
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gB7jb.default), {
        ref: elementRef,
        style: {
            top: initialTop + offsetTop,
            left: initialLeft + offsetLeft,
            transform: transformStyle,
            ...(0, $gB7jb.defaultStyles),
            ...style
        },
        ...otherProps,
        children: children
    });
}
const $75c34d03f8863ce8$export$5663192fda24cade = (0, $1xLej.element)($75c34d03f8863ce8$var$_TooltipWithBounds);

});
parcelRegister("gB7jb", function(module, exports) {

$parcel$export(module.exports, "defaultStyles", () => $c155c554b9b5d42f$export$214b055320e0bf32);
$parcel$export(module.exports, "default", () => $c155c554b9b5d42f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $2OMIu = parcelRequire("2OMIu");
const $c155c554b9b5d42f$export$214b055320e0bf32 = {
    position: 'absolute',
    backgroundColor: "var(--ds-surface-overlay, white)",
    padding: '.3rem .5rem',
    borderRadius: '3px',
    fontSize: '14px',
    boxShadow: `0px 8px 12px ${"var(--ds-shadow-overflow-perimeter, grey)"}`,
    lineHeight: '1em',
    pointerEvents: 'none',
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 12,
    paddingBottom: 12,
    overflow: 'hidden',
    border: `1px ${"var(--ds-border, grey)"} solid`,
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    gap: 4,
    zIndex: 999,
    display: 'flex',
    transition: 'transform 0.3s'
};
const $c155c554b9b5d42f$var$Tooltip = /*#__PURE__*/ (0, $5uXOq.forwardRef)((_ref, ref)=>{
    let { className: className, top: top, left: left, tooltipPortalElement: tooltipPortalElement, offsetLeft: offsetLeft = 0, offsetTop: offsetTop = 0, style: style = $c155c554b9b5d42f$export$214b055320e0bf32, children: children, unstyled: unstyled = false, applyPositionStyle: applyPositionStyle = false } = _ref;
    const elem = /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: ref,
        role: "tooltip",
        className: className,
        style: {
            top: top == null || offsetTop == null ? top : top + offsetTop,
            left: left == null || offsetLeft == null ? left : left + offsetLeft,
            ...applyPositionStyle && {
                position: 'absolute'
            },
            ...!unstyled && style
        },
        children: children
    });
    // Render via portal
    if (tooltipPortalElement) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: /*#__PURE__*/ (0, $7nsd3.createPortal)(elem, tooltipPortalElement)
    });
    return elem;
});
$c155c554b9b5d42f$var$Tooltip.displayName = 'Tooltip';
var $c155c554b9b5d42f$export$2e2bcd8739ae039 = $c155c554b9b5d42f$var$Tooltip;

});



parcelRegister("n8hTk", function(module, exports) {

$parcel$export(module.exports, "donutChartEvents", () => $045893d60f857527$export$f930f3fb751cfffd);

var $xpxC7 = parcelRequire("xpxC7");
const $045893d60f857527$export$f930f3fb751cfffd = {
    tooltip: (0, $xpxC7.tooltipEvent),
    legend: (0, $xpxC7.legendEvent)
};

});

parcelRegister("dcCcf", function(module, exports) {

$parcel$export(module.exports, "DonutMetricValue", () => $99ca065e440c4016$export$a919e8af430790ff);
$parcel$export(module.exports, "DonutMetricLabel", () => $99ca065e440c4016$export$1378bacd15e58eae);
$parcel$export(module.exports, "DonutMetric", () => $99ca065e440c4016$export$263bc5dd8230a1d9);
/* donut-label.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $bwpsq = parcelRequire("bwpsq");

var $1xLej = parcelRequire("1xLej");

var $9ZCPf = parcelRequire("9ZCPf");

var $5rJQH = parcelRequire("5rJQH");

var $lCjFE = parcelRequire("lCjFE");

var $2OMIu = parcelRequire("2OMIu");
const $99ca065e440c4016$export$9c69e622944f45dc = null;
const $99ca065e440c4016$export$25396b46317eb664 = null;
const $99ca065e440c4016$export$a919e8af430790ff = (0, $1xLej.element)((_ref)=>{
    let { totalValue: totalValue, width: width, formatter: formatter, truncate: truncate } = _ref;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5rJQH.default), {
        width: width,
        truncate: truncate,
        className: (0, $bwpsq.default)([
            "_lswu1fxt _1fjgnkob _11c8iyik"
        ]),
        children: formatter(totalValue)
    }, `donut-value-${totalValue}`);
});
const $99ca065e440c4016$export$1378bacd15e58eae = (0, $1xLej.element)((_ref2)=>{
    let { width: width, label: label, totalValue: totalValue, truncate: truncate } = _ref2;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5rJQH.default), {
        y: 24,
        width: width,
        truncate: truncate,
        className: (0, $bwpsq.default)([
            "_lswu1gjq _1fjgnkob _11c81bk4"
        ]),
        children: label
    }, `donut-value-text-${label}`);
});
const $99ca065e440c4016$export$263bc5dd8230a1d9 = (0, $1xLej.element)(function DonutLabel(_ref3) {
    let { data: data, hide: hide, valueAccessor: valueAccessor, innerRadius: innerRadius } = _ref3;
    if (hide) return null;
    if (innerRadius < 30) return null;
    const centerTextValue = data.reduce((total, d)=>total + valueAccessor(d), 0);
    /* Approximating truncation width, for text to fit in the biggest square inside the inner circle. */ const width = innerRadius * Math.SQRT2;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $9ZCPf.default), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)($99ca065e440c4016$export$a919e8af430790ff, {
                width: width / 1.5,
                totalValue: centerTextValue,
                formatter: (0, $lCjFE.default).formatNumberAbbreviated,
                truncate: data.length > 0
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)($99ca065e440c4016$export$1378bacd15e58eae, {
                width: width,
                label: 'Total value',
                totalValue: centerTextValue,
                truncate: data.length > 0
            })
        ]
    });
});

});
parcelRegister("9ZCPf", function(module, exports) {

$parcel$export(module.exports, "default", () => $7467ed7d3ae0ffa3$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
function $7467ed7d3ae0ffa3$export$2e2bcd8739ae039(_ref) {
    let { top: top = 0, left: left = 0, transform: transform, children: children, innerRef: innerRef, ...restProps } = _ref;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("g", {
        ref: innerRef,
        transform: transform || `translate(${left}, ${top})`,
        ...restProps,
        children: children
    });
}

});

parcelRegister("5rJQH", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f730a0b03a2463c$export$2e2bcd8739ae039);

var $3bDjY = parcelRequire("3bDjY");

var $7V0T2 = parcelRequire("7V0T2");

var $2OMIu = parcelRequire("2OMIu");
const $3f730a0b03a2463c$var$SVG_STYLE = {
    overflow: 'visible'
};
function $3f730a0b03a2463c$export$2e2bcd8739ae039(props) {
    const { dx: dx = 0, dy: dy = 0, textAnchor: textAnchor = 'start', innerRef: innerRef, innerTextRef: innerTextRef, verticalAnchor: verticalAnchor, alignmentBaseline: alignmentBaseline, angle: angle, lineHeight: lineHeight = '1em', scaleToFit: // eslint-disable-next-line @typescript-eslint/no-unused-vars
    scaleToFit = false, capHeight: capHeight, truncate: truncate, singleline: singleline, children: children, ...textProps } = props;
    const { x: x = 0, fontSize: fontSize } = textProps;
    const { wordsByLines: wordsByLines, startDy: startDy, transform: transform, truncated: truncated } = (0, $7V0T2.default)(props);
    /*
   * NOTE: We may need to change this <g> tag back to a <svg> tag at some point
   *
   * https://github.com/airbnb/visx/issues/971
   *
   * The core developer says the following "This is intentional as it simplifies positioning, rotation, and scaling."
   *
   * We measure the axis labels using the element ref. This works fine in some browsers but firefox
   * adds default sizes to svgs. Whereas chrome will respect empty width/height as null value.
   *
   * We currently don't do very fancy things with this text component so ok to switch to <g> for now.
   *
   * I did have to move the dx/dy translates from x/y attributes to a css transform since they
   * use em to center the text.
   */ const textComponent = /*#__PURE__*/ (0, $2OMIu.jsx)("g", {
        ref: innerRef,
        fontSize: fontSize,
        style: {
            ...$3f730a0b03a2463c$var$SVG_STYLE,
            transform: `translate(calc(${dx}), calc(${dy}))`
        },
        children: wordsByLines.length > 0 ? /*#__PURE__*/ (0, $2OMIu.jsx)("text", {
            ref: innerTextRef,
            transform: transform,
            ...textProps,
            textAnchor: textAnchor,
            children: wordsByLines.map((line, index)=>/*#__PURE__*/ (0, $2OMIu.jsx)("tspan", {
                    alignmentBaseline: alignmentBaseline,
                    x: x,
                    dy: index === 0 ? startDy : lineHeight,
                    children: line.words.join(' ')
                }, index))
        }) : null
    });
    if (truncated) {
        var _props$children;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
            tag: "g",
            content: (_props$children = props.children) === null || _props$children === void 0 ? void 0 : _props$children.toString(),
            position: "bottom",
            children: textComponent
        });
    }
    return textComponent;
}

});
parcelRegister("7V0T2", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c3e8b5dd84fb6ea$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6xQMF = parcelRequire("6xQMF");

var $hRG4n = parcelRequire("hRG4n");
function $5c3e8b5dd84fb6ea$var$isNumber(val) {
    return typeof val === 'number';
}
function $5c3e8b5dd84fb6ea$var$isXOrYInValid(xOrY) {
    return(// number that is not NaN or Infinity
    typeof xOrY === 'number' && Number.isFinite(xOrY) || // for percentage
    typeof xOrY === 'string');
}
function $5c3e8b5dd84fb6ea$export$2e2bcd8739ae039(props) {
    const { verticalAnchor: verticalAnchor = 'start', scaleToFit: scaleToFit = false, angle: angle, width: width, lineHeight: lineHeight = '1em', capHeight: capHeight = '0em', children: // Magic number from d3
    // capHeight = '0.71em',
    children, truncate: truncate, style: style, singleline: singleline, ...textProps } = props;
    const { x: x = 0, y: y = 0 } = textProps;
    const isXOrYNotValid = !$5c3e8b5dd84fb6ea$var$isXOrYInValid(x) || !$5c3e8b5dd84fb6ea$var$isXOrYInValid(y);
    const { wordsWithWidth: wordsWithWidth, spaceWidth: spaceWidth } = (0, $5uXOq.useMemo)(()=>{
        const words = children == null ? [] : children.toString().split(/(?:(?!\u00A0+)\s+)/);
        return {
            wordsWithWidth: words.map((word)=>({
                    word: word,
                    wordWidth: (0, $hRG4n.default)(word, style) || 0
                })),
            spaceWidth: (0, $hRG4n.default)('\u00A0', style) || 0
        };
    }, [
        children,
        style
    ]);
    const { wordsByLines: wordsByLines, truncated: truncated } = (0, $5uXOq.useMemo)(()=>{
        let isTruncated = false;
        if (isXOrYNotValid) return {
            wordsByLines: [],
            truncated: isTruncated
        };
        // Only perform calculations if using features that require them (multiline, scaleToFit)
        if (width || scaleToFit) {
            const words = wordsWithWidth.reduce((result, _ref)=>{
                let { word: word, wordWidth: wordWidth } = _ref;
                const currentLine = result[result.length - 1];
                if (currentLine && (width == null || scaleToFit || truncate || singleline || (currentLine.width || 0) + wordWidth + spaceWidth < width)) {
                    currentLine.words.push(word);
                    currentLine.width = currentLine.width || 0;
                    currentLine.width += wordWidth + spaceWidth;
                } else {
                    // Add first word to line or word is too long to scaleToFit on existing line
                    const newLine = {
                        words: [
                            word
                        ],
                        width: wordWidth
                    };
                    result.push(newLine);
                }
                return result;
            }, []);
            // Word can be added to an existing line
            if (truncate && width) {
                const ellipsesWidth = (0, $hRG4n.default)('...', style) || 0;
                const joinedWords = words[0].words.join('\u00A0');
                const joinedSubstring = joinedWords.substring(0, (width - ellipsesWidth) / (words[0].width || 0) * joinedWords.length);
                if (joinedSubstring !== joinedWords) {
                    isTruncated = true;
                    words[0].words = [
                        joinedSubstring + '...'
                    ];
                }
            }
            return {
                wordsByLines: words,
                truncated: isTruncated
            };
        }
        return {
            wordsByLines: [
                {
                    words: children == null ? [] : children.toString().split(/(?:(?!\u00A0+)\s+)/)
                }
            ],
            truncated: isTruncated
        };
    }, [
        isXOrYNotValid,
        width,
        scaleToFit,
        children,
        wordsWithWidth,
        spaceWidth
    ]);
    const startDy = (0, $5uXOq.useMemo)(()=>{
        const startDyStr = isXOrYNotValid ? '' : verticalAnchor === 'start' ? (0, (/*@__PURE__*/$parcel$interopDefault($6xQMF)))(`calc(${capHeight})`) : verticalAnchor === 'middle' ? (0, (/*@__PURE__*/$parcel$interopDefault($6xQMF)))(`calc(${(wordsByLines.length - 1) / 2} * -${lineHeight} + (${capHeight} / 2))`) : (0, (/*@__PURE__*/$parcel$interopDefault($6xQMF)))(`calc(${wordsByLines.length - 1} * -${lineHeight})`);
        return startDyStr;
    }, [
        isXOrYNotValid,
        verticalAnchor,
        capHeight,
        wordsByLines.length,
        lineHeight
    ]);
    const transform = (0, $5uXOq.useMemo)(()=>{
        const transforms = [];
        if (isXOrYNotValid) return '';
        if ($5c3e8b5dd84fb6ea$var$isNumber(x) && $5c3e8b5dd84fb6ea$var$isNumber(y) && $5c3e8b5dd84fb6ea$var$isNumber(width) && scaleToFit && wordsByLines.length > 0) {
            const lineWidth = wordsByLines[0].width || 1;
            const sx = scaleToFit === 'shrink-only' ? Math.min(width / lineWidth, 1) : width / lineWidth;
            const sy = sx;
            const originX = x - sx * x;
            const originY = y - sy * y;
            transforms.push(`matrix(${sx}, 0, 0, ${sy}, ${originX}, ${originY})`);
        }
        if (angle) transforms.push(`rotate(${angle}, ${x}, ${y})`);
        return transforms.length > 0 ? transforms.join(' ') : '';
    }, [
        isXOrYNotValid,
        x,
        y,
        width,
        scaleToFit,
        wordsByLines,
        angle
    ]);
    return {
        wordsByLines: wordsByLines,
        startDy: startDy,
        transform: transform,
        truncated: truncated
    };
}

});
parcelRegister("6xQMF", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hiIN5 = parcelRequire("hiIN5");
var $4c3ec4f1f2153be8$var$_postcssValueParser2 = $4c3ec4f1f2153be8$var$_interopRequireDefault($hiIN5);

var $dR6OW = parcelRequire("dR6OW");

var $8nBRK = parcelRequire("8nBRK");
var $4c3ec4f1f2153be8$var$_reducer2 = $4c3ec4f1f2153be8$var$_interopRequireDefault($8nBRK);

var $hYnJW = parcelRequire("hYnJW");
var $4c3ec4f1f2153be8$var$_stringifier2 = $4c3ec4f1f2153be8$var$_interopRequireDefault($hYnJW);
function $4c3ec4f1f2153be8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// eslint-disable-line
var $4c3ec4f1f2153be8$var$MATCH_CALC = /((?:\-[a-z]+\-)?calc)/;
module.exports.default = function(value) {
    var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
    return (0, $4c3ec4f1f2153be8$var$_postcssValueParser2.default)(value).walk(function(node) {
        // skip anything which isn't a calc() function
        if (node.type !== 'function' || !$4c3ec4f1f2153be8$var$MATCH_CALC.test(node.value)) return;
        // stringify calc expression and produce an AST
        var contents = $4c3ec4f1f2153be8$var$_postcssValueParser2.default.stringify(node.nodes);
        // skip constant() and env()
        if (contents.indexOf('constant') >= 0 || contents.indexOf('env') >= 0) return;
        var ast = $dR6OW.parser.parse(contents);
        // reduce AST to its simplest form, that is, either to a single value
        // or a simplified calc expression
        var reducedAst = (0, $4c3ec4f1f2153be8$var$_reducer2.default)(ast, precision);
        // stringify AST and write it back
        node.type = 'word';
        node.value = (0, $4c3ec4f1f2153be8$var$_stringifier2.default)(node.value, reducedAst, precision);
    }, true).toString();
};
module.exports = module.exports['default'];

});
parcelRegister("hiIN5", function(module, exports) {

var $aoOKs = parcelRequire("aoOKs");

var $ff7Sw = parcelRequire("ff7Sw");

var $5C2vA = parcelRequire("5C2vA");
function $c986dc9f7c9c594c$var$ValueParser(value) {
    if (this instanceof $c986dc9f7c9c594c$var$ValueParser) {
        this.nodes = $aoOKs(value);
        return this;
    }
    return new $c986dc9f7c9c594c$var$ValueParser(value);
}
$c986dc9f7c9c594c$var$ValueParser.prototype.toString = function() {
    return Array.isArray(this.nodes) ? $5C2vA(this.nodes) : "";
};
$c986dc9f7c9c594c$var$ValueParser.prototype.walk = function(cb, bubble) {
    $ff7Sw(this.nodes, cb, bubble);
    return this;
};

$c986dc9f7c9c594c$var$ValueParser.unit = (parcelRequire("dYXzq"));
$c986dc9f7c9c594c$var$ValueParser.walk = $ff7Sw;
$c986dc9f7c9c594c$var$ValueParser.stringify = $5C2vA;
module.exports = $c986dc9f7c9c594c$var$ValueParser;

});
parcelRegister("aoOKs", function(module, exports) {
var $792382d2f72bd93a$var$openParentheses = "(".charCodeAt(0);
var $792382d2f72bd93a$var$closeParentheses = ")".charCodeAt(0);
var $792382d2f72bd93a$var$singleQuote = "'".charCodeAt(0);
var $792382d2f72bd93a$var$doubleQuote = '"'.charCodeAt(0);
var $792382d2f72bd93a$var$backslash = "\\".charCodeAt(0);
var $792382d2f72bd93a$var$slash = "/".charCodeAt(0);
var $792382d2f72bd93a$var$comma = ",".charCodeAt(0);
var $792382d2f72bd93a$var$colon = ":".charCodeAt(0);
var $792382d2f72bd93a$var$star = "*".charCodeAt(0);
module.exports = function(input) {
    var tokens = [];
    var value = input;
    var next, quote, prev, token, escape, escapePos, whitespacePos;
    var pos = 0;
    var code = value.charCodeAt(pos);
    var max = value.length;
    var stack = [
        {
            nodes: tokens
        }
    ];
    var balanced = 0;
    var parent;
    var name = "";
    var before = "";
    var after = "";
    while(pos < max){
        // Whitespaces
        if (code <= 32) {
            next = pos;
            do {
                next += 1;
                code = value.charCodeAt(next);
            }while (code <= 32);
            token = value.slice(pos, next);
            prev = tokens[tokens.length - 1];
            if (code === $792382d2f72bd93a$var$closeParentheses && balanced) after = token;
            else if (prev && prev.type === "div") prev.after = token;
            else if (code === $792382d2f72bd93a$var$comma || code === $792382d2f72bd93a$var$colon || code === $792382d2f72bd93a$var$slash && value.charCodeAt(next + 1) !== $792382d2f72bd93a$var$star) before = token;
            else tokens.push({
                type: "space",
                sourceIndex: pos,
                value: token
            });
            pos = next;
        // Quotes
        } else if (code === $792382d2f72bd93a$var$singleQuote || code === $792382d2f72bd93a$var$doubleQuote) {
            next = pos;
            quote = code === $792382d2f72bd93a$var$singleQuote ? "'" : '"';
            token = {
                type: "string",
                sourceIndex: pos,
                quote: quote
            };
            do {
                escape = false;
                next = value.indexOf(quote, next + 1);
                if (~next) {
                    escapePos = next;
                    while(value.charCodeAt(escapePos - 1) === $792382d2f72bd93a$var$backslash){
                        escapePos -= 1;
                        escape = !escape;
                    }
                } else {
                    value += quote;
                    next = value.length - 1;
                    token.unclosed = true;
                }
            }while (escape);
            token.value = value.slice(pos + 1, next);
            tokens.push(token);
            pos = next + 1;
            code = value.charCodeAt(pos);
        // Comments
        } else if (code === $792382d2f72bd93a$var$slash && value.charCodeAt(pos + 1) === $792382d2f72bd93a$var$star) {
            token = {
                type: "comment",
                sourceIndex: pos
            };
            next = value.indexOf("*/", pos);
            if (next === -1) {
                token.unclosed = true;
                next = value.length;
            }
            token.value = value.slice(pos + 2, next);
            tokens.push(token);
            pos = next + 2;
            code = value.charCodeAt(pos);
        // Dividers
        } else if (code === $792382d2f72bd93a$var$slash || code === $792382d2f72bd93a$var$comma || code === $792382d2f72bd93a$var$colon) {
            token = value[pos];
            tokens.push({
                type: "div",
                sourceIndex: pos - before.length,
                value: token,
                before: before,
                after: ""
            });
            before = "";
            pos += 1;
            code = value.charCodeAt(pos);
        // Open parentheses
        } else if ($792382d2f72bd93a$var$openParentheses === code) {
            // Whitespaces after open parentheses
            next = pos;
            do {
                next += 1;
                code = value.charCodeAt(next);
            }while (code <= 32);
            token = {
                type: "function",
                sourceIndex: pos - name.length,
                value: name,
                before: value.slice(pos + 1, next)
            };
            pos = next;
            if (name === "url" && code !== $792382d2f72bd93a$var$singleQuote && code !== $792382d2f72bd93a$var$doubleQuote) {
                next -= 1;
                do {
                    escape = false;
                    next = value.indexOf(")", next + 1);
                    if (~next) {
                        escapePos = next;
                        while(value.charCodeAt(escapePos - 1) === $792382d2f72bd93a$var$backslash){
                            escapePos -= 1;
                            escape = !escape;
                        }
                    } else {
                        value += ")";
                        next = value.length - 1;
                        token.unclosed = true;
                    }
                }while (escape);
                // Whitespaces before closed
                whitespacePos = next;
                do {
                    whitespacePos -= 1;
                    code = value.charCodeAt(whitespacePos);
                }while (code <= 32);
                if (pos !== whitespacePos + 1) token.nodes = [
                    {
                        type: "word",
                        sourceIndex: pos,
                        value: value.slice(pos, whitespacePos + 1)
                    }
                ];
                else token.nodes = [];
                if (token.unclosed && whitespacePos + 1 !== next) {
                    token.after = "";
                    token.nodes.push({
                        type: "space",
                        sourceIndex: whitespacePos + 1,
                        value: value.slice(whitespacePos + 1, next)
                    });
                } else token.after = value.slice(whitespacePos + 1, next);
                pos = next + 1;
                code = value.charCodeAt(pos);
                tokens.push(token);
            } else {
                balanced += 1;
                token.after = "";
                tokens.push(token);
                stack.push(token);
                tokens = token.nodes = [];
                parent = token;
            }
            name = "";
        // Close parentheses
        } else if ($792382d2f72bd93a$var$closeParentheses === code && balanced) {
            pos += 1;
            code = value.charCodeAt(pos);
            parent.after = after;
            after = "";
            balanced -= 1;
            stack.pop();
            parent = stack[balanced];
            tokens = parent.nodes;
        // Words
        } else {
            next = pos;
            do {
                if (code === $792382d2f72bd93a$var$backslash) next += 1;
                next += 1;
                code = value.charCodeAt(next);
            }while (next < max && !(code <= 32 || code === $792382d2f72bd93a$var$singleQuote || code === $792382d2f72bd93a$var$doubleQuote || code === $792382d2f72bd93a$var$comma || code === $792382d2f72bd93a$var$colon || code === $792382d2f72bd93a$var$slash || code === $792382d2f72bd93a$var$openParentheses || code === $792382d2f72bd93a$var$closeParentheses && balanced));
            token = value.slice(pos, next);
            if ($792382d2f72bd93a$var$openParentheses === code) name = token;
            else tokens.push({
                type: "word",
                sourceIndex: pos,
                value: token
            });
            pos = next;
        }
    }
    for(pos = stack.length - 1; pos; pos -= 1)stack[pos].unclosed = true;
    return stack[0].nodes;
};

});

parcelRegister("ff7Sw", function(module, exports) {
module.exports = function walk(nodes, cb, bubble) {
    var i, max, node, result;
    for(i = 0, max = nodes.length; i < max; i += 1){
        node = nodes[i];
        if (!bubble) result = cb(node, i, nodes);
        if (result !== false && node.type === "function" && Array.isArray(node.nodes)) walk(node.nodes, cb, bubble);
        if (bubble) cb(node, i, nodes);
    }
};

});

parcelRegister("5C2vA", function(module, exports) {
function $4162728150b6e0e4$var$stringifyNode(node, custom) {
    var type = node.type;
    var value = node.value;
    var buf;
    var customResult;
    if (custom && (customResult = custom(node)) !== undefined) return customResult;
    else if (type === "word" || type === "space") return value;
    else if (type === "string") {
        buf = node.quote || "";
        return buf + value + (node.unclosed ? "" : buf);
    } else if (type === "comment") return "/*" + value + (node.unclosed ? "" : "*/");
    else if (type === "div") return (node.before || "") + value + (node.after || "");
    else if (Array.isArray(node.nodes)) {
        buf = $4162728150b6e0e4$var$stringify(node.nodes);
        if (type !== "function") return buf;
        return value + "(" + (node.before || "") + buf + (node.after || "") + (node.unclosed ? "" : ")");
    }
    return value;
}
function $4162728150b6e0e4$var$stringify(nodes, custom) {
    var result, i;
    if (Array.isArray(nodes)) {
        result = "";
        for(i = nodes.length - 1; ~i; i -= 1)result = $4162728150b6e0e4$var$stringifyNode(nodes[i], custom) + result;
        return result;
    }
    return $4162728150b6e0e4$var$stringifyNode(nodes, custom);
}
module.exports = $4162728150b6e0e4$var$stringify;

});

parcelRegister("dYXzq", function(module, exports) {
var $a2df1669eddd979e$var$minus = "-".charCodeAt(0);
var $a2df1669eddd979e$var$plus = "+".charCodeAt(0);
var $a2df1669eddd979e$var$dot = ".".charCodeAt(0);
var $a2df1669eddd979e$var$exp = "e".charCodeAt(0);
var $a2df1669eddd979e$var$EXP = "E".charCodeAt(0);
module.exports = function(value) {
    var pos = 0;
    var length = value.length;
    var dotted = false;
    var sciPos = -1;
    var containsNumber = false;
    var code;
    while(pos < length){
        code = value.charCodeAt(pos);
        if (code >= 48 && code <= 57) containsNumber = true;
        else if (code === $a2df1669eddd979e$var$exp || code === $a2df1669eddd979e$var$EXP) {
            if (sciPos > -1) break;
            sciPos = pos;
        } else if (code === $a2df1669eddd979e$var$dot) {
            if (dotted) break;
            dotted = true;
        } else if (code === $a2df1669eddd979e$var$plus || code === $a2df1669eddd979e$var$minus) {
            if (pos !== 0) break;
        } else break;
        pos += 1;
    }
    if (sciPos + 1 === pos) pos--;
    return containsNumber ? {
        number: value.slice(0, pos),
        unit: value.slice(pos)
    } : false;
};

});


parcelRegister("dR6OW", function(module, exports) {

$parcel$export(module.exports, "parser", () => $a165840c76c6afe6$export$8f49e4af10703ce3, (v) => $a165840c76c6afe6$export$8f49e4af10703ce3 = v);
/* parser generated by jison 0.6.1-215 */ /*
 * Returns a Parser object of the following structure:
 *
 *  Parser: {
 *    yy: {}     The so-called "shared state" or rather the *source* of it;
 *               the real "shared state" `yy` passed around to
 *               the rule actions, etc. is a derivative/copy of this one,
 *               not a direct reference!
 *  }
 *
 *  Parser.prototype: {
 *    yy: {},
 *    EOF: 1,
 *    TERROR: 2,
 *
 *    trace: function(errorMessage, ...),
 *
 *    JisonParserError: function(msg, hash),
 *
 *    quoteName: function(name),
 *               Helper function which can be overridden by user code later on: put suitable
 *               quotes around literal IDs in a description string.
 *
 *    originalQuoteName: function(name),
 *               The basic quoteName handler provided by JISON.
 *               `cleanupAfterParse()` will clean up and reset `quoteName()` to reference this function
 *               at the end of the `parse()`.
 *
 *    describeSymbol: function(symbol),
 *               Return a more-or-less human-readable description of the given symbol, when
 *               available, or the symbol itself, serving as its own 'description' for lack
 *               of something better to serve up.
 *
 *               Return NULL when the symbol is unknown to the parser.
 *
 *    symbols_: {associative list: name ==> number},
 *    terminals_: {associative list: number ==> name},
 *    nonterminals: {associative list: rule-name ==> {associative list: number ==> rule-alt}},
 *    terminal_descriptions_: (if there are any) {associative list: number ==> description},
 *    productions_: [...],
 *
 *    performAction: function parser__performAction(yytext, yyleng, yylineno, yyloc, yystate, yysp, yyvstack, yylstack, yystack, yysstack),
 *
 *               The function parameters and `this` have the following value/meaning:
 *               - `this`    : reference to the `yyval` internal object, which has members (`$` and `_$`)
 *                             to store/reference the rule value `$$` and location info `@$`.
 *
 *                 One important thing to note about `this` a.k.a. `yyval`: every *reduce* action gets
 *                 to see the same object via the `this` reference, i.e. if you wish to carry custom
 *                 data from one reduce action through to the next within a single parse run, then you
 *                 may get nasty and use `yyval` a.k.a. `this` for storing you own semi-permanent data.
 *
 *                 `this.yy` is a direct reference to the `yy` shared state object.
 *
 *                 `%parse-param`-specified additional `parse()` arguments have been added to this `yy`
 *                 object at `parse()` start and are therefore available to the action code via the
 *                 same named `yy.xxxx` attributes (where `xxxx` represents a identifier name from
 *                 the %parse-param` list.
 *
 *               - `yytext`  : reference to the lexer value which belongs to the last lexer token used
 *                             to match this rule. This is *not* the look-ahead token, but the last token
 *                             that's actually part of this rule.
 *
 *                 Formulated another way, `yytext` is the value of the token immediately preceeding
 *                 the current look-ahead token.
 *                 Caveats apply for rules which don't require look-ahead, such as epsilon rules.
 *
 *               - `yyleng`  : ditto as `yytext`, only now for the lexer.yyleng value.
 *
 *               - `yylineno`: ditto as `yytext`, only now for the lexer.yylineno value.
 *
 *               - `yyloc`   : ditto as `yytext`, only now for the lexer.yylloc lexer token location info.
 *
 *                               WARNING: since jison 0.4.18-186 this entry may be NULL/UNDEFINED instead
 *                               of an empty object when no suitable location info can be provided.
 *
 *               - `yystate` : the current parser state number, used internally for dispatching and
 *                               executing the action code chunk matching the rule currently being reduced.
 *
 *               - `yysp`    : the current state stack position (a.k.a. 'stack pointer')
 *
 *                 This one comes in handy when you are going to do advanced things to the parser
 *                 stacks, all of which are accessible from your action code (see the next entries below).
 *
 *                 Also note that you can access this and other stack index values using the new double-hash
 *                 syntax, i.e. `##$ === ##0 === yysp`, while `##1` is the stack index for all things
 *                 related to the first rule term, just like you have `$1`, `@1` and `#1`.
 *                 This is made available to write very advanced grammar action rules, e.g. when you want
 *                 to investigate the parse state stack in your action code, which would, for example,
 *                 be relevant when you wish to implement error diagnostics and reporting schemes similar
 *                 to the work described here:
 *
 *                 + Pottier, F., 2016. Reachability and error diagnosis in LR(1) automata.
 *                   In Journées Francophones des Languages Applicatifs.
 *
 *                 + Jeffery, C.L., 2003. Generating LR syntax error messages from examples.
 *                   ACM Transactions on Programming Languages and Systems (TOPLAS), 25(5), pp.631–640.
 *
 *               - `yyrulelength`: the current rule's term count, i.e. the number of entries occupied on the stack.
 *
 *                 This one comes in handy when you are going to do advanced things to the parser
 *                 stacks, all of which are accessible from your action code (see the next entries below).
 *
 *               - `yyvstack`: reference to the parser value stack. Also accessed via the `$1` etc.
 *                             constructs.
 *
 *               - `yylstack`: reference to the parser token location stack. Also accessed via
 *                             the `@1` etc. constructs.
 *
 *                             WARNING: since jison 0.4.18-186 this array MAY contain slots which are
 *                             UNDEFINED rather than an empty (location) object, when the lexer/parser
 *                             action code did not provide a suitable location info object when such a
 *                             slot was filled!
 *
 *               - `yystack` : reference to the parser token id stack. Also accessed via the
 *                             `#1` etc. constructs.
 *
 *                 Note: this is a bit of a **white lie** as we can statically decode any `#n` reference to
 *                 its numeric token id value, hence that code wouldn't need the `yystack` but *you* might
 *                 want access this array for your own purposes, such as error analysis as mentioned above!
 *
 *                 Note that this stack stores the current stack of *tokens*, that is the sequence of
 *                 already parsed=reduced *nonterminals* (tokens representing rules) and *terminals*
 *                 (lexer tokens *shifted* onto the stack until the rule they belong to is found and
 *                 *reduced*.
 *
 *               - `yysstack`: reference to the parser state stack. This one carries the internal parser
 *                             *states* such as the one in `yystate`, which are used to represent
 *                             the parser state machine in the *parse table*. *Very* *internal* stuff,
 *                             what can I say? If you access this one, you're clearly doing wicked things
 *
 *               - `...`     : the extra arguments you specified in the `%parse-param` statement in your
 *                             grammar definition file.
 *
 *    table: [...],
 *               State transition table
 *               ----------------------
 *
 *               index levels are:
 *               - `state`  --> hash table
 *               - `symbol` --> action (number or array)
 *
 *                 If the `action` is an array, these are the elements' meaning:
 *                 - index [0]: 1 = shift, 2 = reduce, 3 = accept
 *                 - index [1]: GOTO `state`
 *
 *                 If the `action` is a number, it is the GOTO `state`
 *
 *    defaultActions: {...},
 *
 *    parseError: function(str, hash, ExceptionClass),
 *    yyError: function(str, ...),
 *    yyRecovering: function(),
 *    yyErrOk: function(),
 *    yyClearIn: function(),
 *
 *    constructParseErrorInfo: function(error_message, exception_object, expected_token_set, is_recoverable),
 *               Helper function **which will be set up during the first invocation of the `parse()` method**.
 *               Produces a new errorInfo 'hash object' which can be passed into `parseError()`.
 *               See it's use in this parser kernel in many places; example usage:
 *
 *                   var infoObj = parser.constructParseErrorInfo('fail!', null,
 *                                     parser.collect_expected_token_set(state), true);
 *                   var retVal = parser.parseError(infoObj.errStr, infoObj, parser.JisonParserError);
 *
 *    originalParseError: function(str, hash, ExceptionClass),
 *               The basic `parseError` handler provided by JISON.
 *               `cleanupAfterParse()` will clean up and reset `parseError()` to reference this function
 *               at the end of the `parse()`.
 *
 *    options: { ... parser %options ... },
 *
 *    parse: function(input[, args...]),
 *               Parse the given `input` and return the parsed value (or `true` when none was provided by
 *               the root action, in which case the parser is acting as a *matcher*).
 *               You MAY use the additional `args...` parameters as per `%parse-param` spec of this grammar:
 *               these extra `args...` are added verbatim to the `yy` object reference as member variables.
 *
 *               WARNING:
 *               Parser's additional `args...` parameters (via `%parse-param`) MAY conflict with
 *               any attributes already added to `yy` by the jison run-time;
 *               when such a collision is detected an exception is thrown to prevent the generated run-time
 *               from silently accepting this confusing and potentially hazardous situation!
 *
 *               The lexer MAY add its own set of additional parameters (via the `%parse-param` line in
 *               the lexer section of the grammar spec): these will be inserted in the `yy` shared state
 *               object and any collision with those will be reported by the lexer via a thrown exception.
 *
 *    cleanupAfterParse: function(resultValue, invoke_post_methods, do_not_nuke_errorinfos),
 *               Helper function **which will be set up during the first invocation of the `parse()` method**.
 *               This helper API is invoked at the end of the `parse()` call, unless an exception was thrown
 *               and `%options no-try-catch` has been defined for this grammar: in that case this helper MAY
 *               be invoked by calling user code to ensure the `post_parse` callbacks are invoked and
 *               the internal parser gets properly garbage collected under these particular circumstances.
 *
 *    yyMergeLocationInfo: function(first_index, last_index, first_yylloc, last_yylloc, dont_look_back),
 *               Helper function **which will be set up during the first invocation of the `parse()` method**.
 *               This helper API can be invoked to calculate a spanning `yylloc` location info object.
 *
 *               Note: %epsilon rules MAY specify no `first_index` and `first_yylloc`, in which case
 *               this function will attempt to obtain a suitable location marker by inspecting the location stack
 *               backwards.
 *
 *               For more info see the documentation comment further below, immediately above this function's
 *               implementation.
 *
 *    lexer: {
 *        yy: {...},           A reference to the so-called "shared state" `yy` once
 *                             received via a call to the `.setInput(input, yy)` lexer API.
 *        EOF: 1,
 *        ERROR: 2,
 *        JisonLexerError: function(msg, hash),
 *        parseError: function(str, hash, ExceptionClass),
 *        setInput: function(input, [yy]),
 *        input: function(),
 *        unput: function(str),
 *        more: function(),
 *        reject: function(),
 *        less: function(n),
 *        pastInput: function(n),
 *        upcomingInput: function(n),
 *        showPosition: function(),
 *        test_match: function(regex_match_array, rule_index, ...),
 *        next: function(...),
 *        lex: function(...),
 *        begin: function(condition),
 *        pushState: function(condition),
 *        popState: function(),
 *        topState: function(),
 *        _currentRules: function(),
 *        stateStackSize: function(),
 *        cleanupAfterLex: function()
 *
 *        options: { ... lexer %options ... },
 *
 *        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START, ...),
 *        rules: [...],
 *        conditions: {associative list: name ==> set},
 *    }
 *  }
 *
 *
 *  token location info (@$, _$, etc.): {
 *    first_line: n,
 *    last_line: n,
 *    first_column: n,
 *    last_column: n,
 *    range: [start_number, end_number]
 *               (where the numbers are indexes into the input string, zero-based)
 *  }
 *
 * ---
 *
 * The `parseError` function receives a 'hash' object with these members for lexer and
 * parser errors:
 *
 *  {
 *    text:        (matched text)
 *    token:       (the produced terminal token, if any)
 *    token_id:    (the produced terminal token numeric ID, if any)
 *    line:        (yylineno)
 *    loc:         (yylloc)
 *  }
 *
 * parser (grammar) errors will also provide these additional members:
 *
 *  {
 *    expected:    (array describing the set of expected tokens;
 *                  may be UNDEFINED when we cannot easily produce such a set)
 *    state:       (integer (or array when the table includes grammar collisions);
 *                  represents the current internal state of the parser kernel.
 *                  can, for example, be used to pass to the `collect_expected_token_set()`
 *                  API to obtain the expected token set)
 *    action:      (integer; represents the current internal action which will be executed)
 *    new_state:   (integer; represents the next/planned internal state, once the current
 *                  action has executed)
 *    recoverable: (boolean: TRUE when the parser MAY have an error recovery rule
 *                  available for this particular error)
 *    state_stack: (array: the current parser LALR/LR internal state stack; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    value_stack: (array: the current parser LALR/LR internal `$$` value stack; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    location_stack: (array: the current parser LALR/LR internal location stack; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    yy:          (object: the current parser internal "shared state" `yy`
 *                  as is also available in the rule actions; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    lexer:       (reference to the current lexer instance used by the parser)
 *    parser:      (reference to the current parser instance)
 *  }
 *
 * while `this` will reference the current parser instance.
 *
 * When `parseError` is invoked by the lexer, `this` will still reference the related *parser*
 * instance, while these additional `hash` fields will also be provided:
 *
 *  {
 *    lexer:       (reference to the current lexer instance which reported the error)
 *  }
 *
 * When `parseError` is invoked by the parser due to a **JavaScript exception** being fired
 * from either the parser or lexer, `this` will still reference the related *parser*
 * instance, while these additional `hash` fields will also be provided:
 *
 *  {
 *    exception:   (reference to the exception thrown)
 *  }
 *
 * Please do note that in the latter situation, the `expected` field will be omitted as
 * this type of failure is assumed not to be due to *parse errors* but rather due to user
 * action code in either parser or lexer failing unexpectedly.
 *
 * ---
 *
 * You can specify parser options by setting / modifying the `.yy` object of your Parser instance.
 * These options are available:
 *
 * ### options which are global for all parser instances
 *
 *  Parser.pre_parse: function(yy)
 *                 optional: you can specify a pre_parse() function in the chunk following
 *                 the grammar, i.e. after the last `%%`.
 *  Parser.post_parse: function(yy, retval, parseInfo) { return retval; }
 *                 optional: you can specify a post_parse() function in the chunk following
 *                 the grammar, i.e. after the last `%%`. When it does not return any value,
 *                 the parser will return the original `retval`.
 *
 * ### options which can be set up per parser instance
 *
 *  yy: {
 *      pre_parse:  function(yy)
 *                 optional: is invoked before the parse cycle starts (and before the first
 *                 invocation of `lex()`) but immediately after the invocation of
 *                 `parser.pre_parse()`).
 *      post_parse: function(yy, retval, parseInfo) { return retval; }
 *                 optional: is invoked when the parse terminates due to success ('accept')
 *                 or failure (even when exceptions are thrown).
 *                 `retval` contains the return value to be produced by `Parser.parse()`;
 *                 this function can override the return value by returning another.
 *                 When it does not return any value, the parser will return the original
 *                 `retval`.
 *                 This function is invoked immediately before `parser.post_parse()`.
 *
 *      parseError: function(str, hash, ExceptionClass)
 *                 optional: overrides the default `parseError` function.
 *      quoteName: function(name),
 *                 optional: overrides the default `quoteName` function.
 *  }
 *
 *  parser.lexer.options: {
 *      pre_lex:  function()
 *                 optional: is invoked before the lexer is invoked to produce another token.
 *                 `this` refers to the Lexer object.
 *      post_lex: function(token) { return token; }
 *                 optional: is invoked when the lexer has produced a token `token`;
 *                 this function can override the returned token value by returning another.
 *                 When it does not return any (truthy) value, the lexer will return
 *                 the original `token`.
 *                 `this` refers to the Lexer object.
 *
 *      ranges: boolean
 *                 optional: `true` ==> token location info will include a .range[] member.
 *      flex: boolean
 *                 optional: `true` ==> flex-like lexing behaviour where the rules are tested
 *                 exhaustively to find the longest match.
 *      backtrack_lexer: boolean
 *                 optional: `true` ==> lexer regexes are tested in order and for invoked;
 *                 the lexer terminates the scan when a token is returned by the action code.
 *      xregexp: boolean
 *                 optional: `true` ==> lexer rule regexes are "extended regex format" requiring the
 *                 `XRegExp` library. When this `%option` has not been specified at compile time, all lexer
 *                 rule regexes have been written as standard JavaScript RegExp expressions.
 *  }
 */ var $a165840c76c6afe6$export$8f49e4af10703ce3;
var $a165840c76c6afe6$export$7acfa6ed01010e37;
var $a165840c76c6afe6$export$98e6a39c04603d36;
var $a165840c76c6afe6$var$parser = function() {
    // See also:
    // http://stackoverflow.com/questions/1382107/whats-a-good-way-to-extend-error-in-javascript/#35881508
    // but we keep the prototype.constructor and prototype.name assignment lines too for compatibility
    // with userland code which might access the derived class in a 'classic' way.
    function JisonParserError(msg, hash) {
        Object.defineProperty(this, 'name', {
            enumerable: false,
            writable: false,
            value: 'JisonParserError'
        });
        if (msg == null) msg = '???';
        Object.defineProperty(this, 'message', {
            enumerable: false,
            writable: true,
            value: msg
        });
        this.hash = hash;
        var stacktrace;
        if (hash && hash.exception instanceof Error) {
            var ex2 = hash.exception;
            this.message = ex2.message || msg;
            stacktrace = ex2.stack;
        }
        if (!stacktrace) {
            if (Error.hasOwnProperty('captureStackTrace')) Error.captureStackTrace(this, this.constructor);
            else stacktrace = new Error(msg).stack;
        }
        if (stacktrace) Object.defineProperty(this, 'stack', {
            enumerable: false,
            writable: false,
            value: stacktrace
        });
    }
    if (typeof Object.setPrototypeOf === 'function') Object.setPrototypeOf(JisonParserError.prototype, Error.prototype);
    else JisonParserError.prototype = Object.create(Error.prototype);
    JisonParserError.prototype.constructor = JisonParserError;
    JisonParserError.prototype.name = 'JisonParserError';
    // helper: reconstruct the productions[] table
    function bp(s) {
        var rv = [];
        var p = s.pop;
        var r = s.rule;
        for(var i = 0, l = p.length; i < l; i++)rv.push([
            p[i],
            r[i]
        ]);
        return rv;
    }
    // helper: reconstruct the defaultActions[] table
    function bda(s) {
        var rv = {};
        var d = s.idx;
        var g = s.goto;
        for(var i = 0, l = d.length; i < l; i++){
            var j = d[i];
            rv[j] = g[i];
        }
        return rv;
    }
    // helper: reconstruct the 'goto' table
    function bt(s) {
        var rv = [];
        var d = s.len;
        var y = s.symbol;
        var t = s.type;
        var a = s.state;
        var m = s.mode;
        var g = s.goto;
        for(var i = 0, l = d.length; i < l; i++){
            var n = d[i];
            var q = {};
            for(var j = 0; j < n; j++){
                var z = y.shift();
                switch(t.shift()){
                    case 2:
                        q[z] = [
                            m.shift(),
                            g.shift()
                        ];
                        break;
                    case 0:
                        q[z] = a.shift();
                        break;
                    default:
                        // type === 1: accept
                        q[z] = [
                            3
                        ];
                }
            }
            rv.push(q);
        }
        return rv;
    }
    // helper: runlength encoding with increment step: code, length: step (default step = 0)
    // `this` references an array
    function s(c, l, a) {
        a = a || 0;
        for(var i = 0; i < l; i++){
            this.push(c);
            c += a;
        }
    }
    // helper: duplicate sequence from *relative* offset and length.
    // `this` references an array
    function c(i, l) {
        i = this.length - i;
        for(l += i; i < l; i++)this.push(this[i]);
    }
    // helper: unpack an array using helpers and data, all passed in an array argument 'a'.
    function u(a) {
        var rv = [];
        for(var i = 0, l = a.length; i < l; i++){
            var e = a[i];
            // Is this entry a helper function?
            if (typeof e === 'function') {
                i++;
                e.apply(rv, a[i]);
            } else rv.push(e);
        }
        return rv;
    }
    var parser = {
        // Code Generator Information Report
        // ---------------------------------
        //
        // Options:
        //
        //   default action mode: ............. ["classic","merge"]
        //   test-compile action mode: ........ "parser:*,lexer:*"
        //   try..catch: ...................... true
        //   default resolve on conflict: ..... true
        //   on-demand look-ahead: ............ false
        //   error recovery token skip maximum: 3
        //   yyerror in parse actions is: ..... NOT recoverable,
        //   yyerror in lexer actions and other non-fatal lexer are:
        //   .................................. NOT recoverable,
        //   debug grammar/output: ............ false
        //   has partial LR conflict upgrade:   true
        //   rudimentary token-stack support:   false
        //   parser table compression mode: ... 2
        //   export debug tables: ............. false
        //   export *all* tables: ............. false
        //   module type: ..................... commonjs
        //   parser engine type: .............. lalr
        //   output main() in the module: ..... true
        //   has user-specified main(): ....... false
        //   has user-specified require()/import modules for main():
        //   .................................. false
        //   number of expected conflicts: .... 0
        //
        //
        // Parser Analysis flags:
        //
        //   no significant actions (parser is a language matcher only):
        //   .................................. false
        //   uses yyleng: ..................... false
        //   uses yylineno: ................... false
        //   uses yytext: ..................... false
        //   uses yylloc: ..................... false
        //   uses ParseError API: ............. false
        //   uses YYERROR: .................... false
        //   uses YYRECOVERING: ............... false
        //   uses YYERROK: .................... false
        //   uses YYCLEARIN: .................. false
        //   tracks rule values: .............. true
        //   assigns rule values: ............. true
        //   uses location tracking: .......... false
        //   assigns location: ................ false
        //   uses yystack: .................... false
        //   uses yysstack: ................... false
        //   uses yysp: ....................... true
        //   uses yyrulelength: ............... false
        //   uses yyMergeLocationInfo API: .... false
        //   has error recovery: .............. false
        //   has error reporting: ............. false
        //
        // --------- END OF REPORT -----------
        trace: function no_op_trace() {},
        JisonParserError: JisonParserError,
        yy: {},
        options: {
            type: "lalr",
            hasPartialLrUpgradeOnConflict: true,
            errorRecoveryTokenDiscardCount: 3
        },
        symbols_: {
            "$accept": 0,
            "$end": 1,
            "ADD": 3,
            "ANGLE": 16,
            "CHS": 22,
            "COMMA": 14,
            "CSS_CPROP": 13,
            "CSS_VAR": 12,
            "DIV": 6,
            "EMS": 20,
            "EOF": 1,
            "EXS": 21,
            "FREQ": 18,
            "LENGTH": 15,
            "LPAREN": 7,
            "MUL": 5,
            "NESTED_CALC": 9,
            "NUMBER": 11,
            "PERCENTAGE": 28,
            "PREFIX": 10,
            "REMS": 23,
            "RES": 19,
            "RPAREN": 8,
            "SUB": 4,
            "TIME": 17,
            "VHS": 24,
            "VMAXS": 27,
            "VMINS": 26,
            "VWS": 25,
            "css_value": 33,
            "css_variable": 32,
            "error": 2,
            "expression": 29,
            "math_expression": 30,
            "value": 31
        },
        terminals_: {
            1: "EOF",
            2: "error",
            3: "ADD",
            4: "SUB",
            5: "MUL",
            6: "DIV",
            7: "LPAREN",
            8: "RPAREN",
            9: "NESTED_CALC",
            10: "PREFIX",
            11: "NUMBER",
            12: "CSS_VAR",
            13: "CSS_CPROP",
            14: "COMMA",
            15: "LENGTH",
            16: "ANGLE",
            17: "TIME",
            18: "FREQ",
            19: "RES",
            20: "EMS",
            21: "EXS",
            22: "CHS",
            23: "REMS",
            24: "VHS",
            25: "VWS",
            26: "VMINS",
            27: "VMAXS",
            28: "PERCENTAGE"
        },
        TERROR: 2,
        EOF: 1,
        // internals: defined here so the object *structure* doesn't get modified by parse() et al,
        // thus helping JIT compilers like Chrome V8.
        originalQuoteName: null,
        originalParseError: null,
        cleanupAfterParse: null,
        constructParseErrorInfo: null,
        yyMergeLocationInfo: null,
        __reentrant_call_depth: 0,
        __error_infos: [],
        __error_recovery_infos: [],
        // APIs which will be set up depending on user action code analysis:
        //yyRecovering: 0,
        //yyErrOk: 0,
        //yyClearIn: 0,
        // Helper APIs
        // -----------
        // Helper function which can be overridden by user code later on: put suitable quotes around
        // literal IDs in a description string.
        quoteName: function parser_quoteName(id_str) {
            return '"' + id_str + '"';
        },
        // Return the name of the given symbol (terminal or non-terminal) as a string, when available.
        //
        // Return NULL when the symbol is unknown to the parser.
        getSymbolName: function parser_getSymbolName(symbol) {
            if (this.terminals_[symbol]) return this.terminals_[symbol];
            // Otherwise... this might refer to a RULE token i.e. a non-terminal: see if we can dig that one up.
            //
            // An example of this may be where a rule's action code contains a call like this:
            //
            //      parser.getSymbolName(#$)
            //
            // to obtain a human-readable name of the current grammar rule.
            var s = this.symbols_;
            for(var key in s){
                if (s[key] === symbol) return key;
            }
            return null;
        },
        // Return a more-or-less human-readable description of the given symbol, when available,
        // or the symbol itself, serving as its own 'description' for lack of something better to serve up.
        //
        // Return NULL when the symbol is unknown to the parser.
        describeSymbol: function parser_describeSymbol(symbol) {
            if (symbol !== this.EOF && this.terminal_descriptions_ && this.terminal_descriptions_[symbol]) return this.terminal_descriptions_[symbol];
            else if (symbol === this.EOF) return 'end of input';
            var id = this.getSymbolName(symbol);
            if (id) return this.quoteName(id);
            return null;
        },
        // Produce a (more or less) human-readable list of expected tokens at the point of failure.
        //
        // The produced list may contain token or token set descriptions instead of the tokens
        // themselves to help turning this output into something that easier to read by humans
        // unless `do_not_describe` parameter is set, in which case a list of the raw, *numeric*,
        // expected terminals and nonterminals is produced.
        //
        // The returned list (array) will not contain any duplicate entries.
        collect_expected_token_set: function parser_collect_expected_token_set(state, do_not_describe) {
            var TERROR = this.TERROR;
            var tokenset = [];
            var check = {};
            // Has this (error?) state been outfitted with a custom expectations description text for human consumption?
            // If so, use that one instead of the less palatable token set.
            if (!do_not_describe && this.state_descriptions_ && this.state_descriptions_[state]) return [
                this.state_descriptions_[state]
            ];
            for(var p in this.table[state]){
                p = +p;
                if (p !== TERROR) {
                    var d = do_not_describe ? p : this.describeSymbol(p);
                    if (d && !check[d]) {
                        tokenset.push(d);
                        check[d] = true; // Mark this token description as already mentioned to prevent outputting duplicate entries.
                    }
                }
            }
            return tokenset;
        },
        productions_: bp({
            pop: u([
                29,
                s,
                [
                    30,
                    10
                ],
                31,
                31,
                32,
                32,
                s,
                [
                    33,
                    15
                ]
            ]),
            rule: u([
                2,
                s,
                [
                    3,
                    5
                ],
                4,
                7,
                s,
                [
                    1,
                    4
                ],
                2,
                4,
                6,
                s,
                [
                    1,
                    14
                ],
                2
            ])
        }),
        performAction: function parser__PerformAction(yystate /* action[1] */ , yysp, yyvstack) {
            /* this == yyval */ // the JS engine itself can go and remove these statements when `yy` turns out to be unused in any action code!
            var yy = this.yy;
            var yyparser = yy.parser;
            var yylexer = yy.lexer;
            switch(yystate){
                case 0:
                    /*! Production::    $accept : expression $end */ // default action (generated by JISON mode classic/merge :: 1,VT,VA,-,-,-,-,-,-):
                    this.$ = yyvstack[yysp - 1];
                    break;
                case 1:
                    /*! Production::    expression : math_expression EOF */ // default action (generated by JISON mode classic/merge :: 2,VT,VA,-,-,-,-,-,-):
                    this.$ = yyvstack[yysp - 1];
                    // END of default action (generated by JISON mode classic/merge :: 2,VT,VA,-,-,-,-,-,-)
                    return yyvstack[yysp - 1];
                case 2:
                /*! Production::    math_expression : math_expression ADD math_expression */ case 3:
                /*! Production::    math_expression : math_expression SUB math_expression */ case 4:
                /*! Production::    math_expression : math_expression MUL math_expression */ case 5:
                    /*! Production::    math_expression : math_expression DIV math_expression */ this.$ = {
                        type: 'MathExpression',
                        operator: yyvstack[yysp - 1],
                        left: yyvstack[yysp - 2],
                        right: yyvstack[yysp]
                    };
                    break;
                case 6:
                    /*! Production::    math_expression : LPAREN math_expression RPAREN */ this.$ = yyvstack[yysp - 1];
                    break;
                case 7:
                    /*! Production::    math_expression : NESTED_CALC LPAREN math_expression RPAREN */ this.$ = {
                        type: 'Calc',
                        value: yyvstack[yysp - 1]
                    };
                    break;
                case 8:
                    /*! Production::    math_expression : SUB PREFIX SUB NESTED_CALC LPAREN math_expression RPAREN */ this.$ = {
                        type: 'Calc',
                        value: yyvstack[yysp - 1],
                        prefix: yyvstack[yysp - 5]
                    };
                    break;
                case 9:
                /*! Production::    math_expression : css_variable */ case 10:
                /*! Production::    math_expression : css_value */ case 11:
                    /*! Production::    math_expression : value */ this.$ = yyvstack[yysp];
                    break;
                case 12:
                    /*! Production::    value : NUMBER */ this.$ = {
                        type: 'Value',
                        value: parseFloat(yyvstack[yysp])
                    };
                    break;
                case 13:
                    /*! Production::    value : SUB NUMBER */ this.$ = {
                        type: 'Value',
                        value: parseFloat(yyvstack[yysp]) * -1
                    };
                    break;
                case 14:
                    /*! Production::    css_variable : CSS_VAR LPAREN CSS_CPROP RPAREN */ this.$ = {
                        type: 'CssVariable',
                        value: yyvstack[yysp - 1]
                    };
                    break;
                case 15:
                    /*! Production::    css_variable : CSS_VAR LPAREN CSS_CPROP COMMA math_expression RPAREN */ this.$ = {
                        type: 'CssVariable',
                        value: yyvstack[yysp - 3],
                        fallback: yyvstack[yysp - 1]
                    };
                    break;
                case 16:
                    /*! Production::    css_value : LENGTH */ this.$ = {
                        type: 'LengthValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: /[a-z]+/.exec(yyvstack[yysp])[0]
                    };
                    break;
                case 17:
                    /*! Production::    css_value : ANGLE */ this.$ = {
                        type: 'AngleValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: /[a-z]+/.exec(yyvstack[yysp])[0]
                    };
                    break;
                case 18:
                    /*! Production::    css_value : TIME */ this.$ = {
                        type: 'TimeValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: /[a-z]+/.exec(yyvstack[yysp])[0]
                    };
                    break;
                case 19:
                    /*! Production::    css_value : FREQ */ this.$ = {
                        type: 'FrequencyValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: /[a-z]+/.exec(yyvstack[yysp])[0]
                    };
                    break;
                case 20:
                    /*! Production::    css_value : RES */ this.$ = {
                        type: 'ResolutionValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: /[a-z]+/.exec(yyvstack[yysp])[0]
                    };
                    break;
                case 21:
                    /*! Production::    css_value : EMS */ this.$ = {
                        type: 'EmValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: 'em'
                    };
                    break;
                case 22:
                    /*! Production::    css_value : EXS */ this.$ = {
                        type: 'ExValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: 'ex'
                    };
                    break;
                case 23:
                    /*! Production::    css_value : CHS */ this.$ = {
                        type: 'ChValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: 'ch'
                    };
                    break;
                case 24:
                    /*! Production::    css_value : REMS */ this.$ = {
                        type: 'RemValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: 'rem'
                    };
                    break;
                case 25:
                    /*! Production::    css_value : VHS */ this.$ = {
                        type: 'VhValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: 'vh'
                    };
                    break;
                case 26:
                    /*! Production::    css_value : VWS */ this.$ = {
                        type: 'VwValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: 'vw'
                    };
                    break;
                case 27:
                    /*! Production::    css_value : VMINS */ this.$ = {
                        type: 'VminValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: 'vmin'
                    };
                    break;
                case 28:
                    /*! Production::    css_value : VMAXS */ this.$ = {
                        type: 'VmaxValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: 'vmax'
                    };
                    break;
                case 29:
                    /*! Production::    css_value : PERCENTAGE */ this.$ = {
                        type: 'PercentageValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: '%'
                    };
                    break;
                case 30:
                    /*! Production::    css_value : SUB css_value */ var prev = yyvstack[yysp];
                    prev.value *= -1;
                    this.$ = prev;
                    break;
            }
        },
        table: bt({
            len: u([
                24,
                1,
                5,
                23,
                1,
                18,
                s,
                [
                    0,
                    3
                ],
                1,
                s,
                [
                    0,
                    16
                ],
                s,
                [
                    23,
                    4
                ],
                c,
                [
                    28,
                    3
                ],
                0,
                0,
                16,
                1,
                6,
                6,
                s,
                [
                    0,
                    3
                ],
                5,
                1,
                2,
                c,
                [
                    37,
                    3
                ],
                c,
                [
                    20,
                    3
                ],
                5,
                0,
                0
            ]),
            symbol: u([
                4,
                7,
                9,
                11,
                12,
                s,
                [
                    15,
                    19,
                    1
                ],
                1,
                1,
                s,
                [
                    3,
                    4,
                    1
                ],
                c,
                [
                    30,
                    19
                ],
                c,
                [
                    29,
                    4
                ],
                7,
                4,
                10,
                11,
                c,
                [
                    22,
                    14
                ],
                c,
                [
                    19,
                    3
                ],
                c,
                [
                    43,
                    22
                ],
                c,
                [
                    23,
                    69
                ],
                c,
                [
                    139,
                    4
                ],
                8,
                c,
                [
                    51,
                    24
                ],
                4,
                c,
                [
                    138,
                    15
                ],
                13,
                c,
                [
                    186,
                    5
                ],
                8,
                c,
                [
                    6,
                    6
                ],
                c,
                [
                    5,
                    5
                ],
                9,
                8,
                14,
                c,
                [
                    159,
                    47
                ],
                c,
                [
                    60,
                    10
                ]
            ]),
            type: u([
                s,
                [
                    2,
                    19
                ],
                s,
                [
                    0,
                    5
                ],
                1,
                s,
                [
                    2,
                    24
                ],
                s,
                [
                    0,
                    4
                ],
                c,
                [
                    22,
                    19
                ],
                c,
                [
                    43,
                    42
                ],
                c,
                [
                    23,
                    70
                ],
                c,
                [
                    28,
                    25
                ],
                c,
                [
                    45,
                    25
                ],
                c,
                [
                    113,
                    54
                ]
            ]),
            state: u([
                1,
                2,
                8,
                6,
                7,
                30,
                c,
                [
                    4,
                    3
                ],
                33,
                37,
                c,
                [
                    5,
                    3
                ],
                38,
                c,
                [
                    4,
                    3
                ],
                39,
                c,
                [
                    4,
                    3
                ],
                40,
                c,
                [
                    4,
                    3
                ],
                42,
                c,
                [
                    21,
                    4
                ],
                50,
                c,
                [
                    5,
                    3
                ],
                51,
                c,
                [
                    4,
                    3
                ]
            ]),
            mode: u([
                s,
                [
                    1,
                    179
                ],
                s,
                [
                    2,
                    3
                ],
                c,
                [
                    5,
                    5
                ],
                c,
                [
                    6,
                    4
                ],
                s,
                [
                    1,
                    57
                ]
            ]),
            goto: u([
                5,
                3,
                4,
                24,
                s,
                [
                    9,
                    15,
                    1
                ],
                s,
                [
                    25,
                    5,
                    1
                ],
                c,
                [
                    24,
                    19
                ],
                31,
                35,
                32,
                34,
                c,
                [
                    18,
                    14
                ],
                36,
                c,
                [
                    38,
                    19
                ],
                c,
                [
                    19,
                    57
                ],
                c,
                [
                    118,
                    4
                ],
                41,
                c,
                [
                    24,
                    19
                ],
                43,
                35,
                c,
                [
                    16,
                    14
                ],
                44,
                s,
                [
                    2,
                    3
                ],
                28,
                29,
                2,
                s,
                [
                    3,
                    3
                ],
                28,
                29,
                3,
                c,
                [
                    53,
                    4
                ],
                s,
                [
                    45,
                    5,
                    1
                ],
                c,
                [
                    100,
                    42
                ],
                52,
                c,
                [
                    5,
                    4
                ],
                53
            ])
        }),
        defaultActions: bda({
            idx: u([
                6,
                7,
                8,
                s,
                [
                    10,
                    16,
                    1
                ],
                33,
                34,
                39,
                40,
                41,
                45,
                47,
                52,
                53
            ]),
            goto: u([
                9,
                10,
                11,
                s,
                [
                    16,
                    14,
                    1
                ],
                12,
                1,
                30,
                13,
                s,
                [
                    4,
                    4,
                    1
                ],
                14,
                15,
                8
            ])
        }),
        parseError: function parseError(str, hash, ExceptionClass) {
            if (hash.recoverable) {
                if (typeof this.trace === 'function') this.trace(str);
                hash.destroy(); // destroy... well, *almost*!
            } else {
                if (typeof this.trace === 'function') this.trace(str);
                if (!ExceptionClass) ExceptionClass = this.JisonParserError;
                throw new ExceptionClass(str, hash);
            }
        },
        parse: function parse(input) {
            var self = this;
            var stack = new Array(128); // token stack: stores token which leads to state at the same index (column storage)
            var sstack = new Array(128); // state stack: stores states (column storage)
            var vstack = new Array(128); // semantic value stack
            var table = this.table;
            var sp = 0; // 'stack pointer': index into the stacks
            var symbol = 0;
            var TERROR = this.TERROR;
            var EOF = this.EOF;
            var ERROR_RECOVERY_TOKEN_DISCARD_COUNT = this.options.errorRecoveryTokenDiscardCount | 0 || 3;
            var NO_ACTION = [
                0,
                54 /* === table.length :: ensures that anyone using this new state will fail dramatically! */ 
            ];
            var lexer;
            if (this.__lexer__) lexer = this.__lexer__;
            else lexer = this.__lexer__ = Object.create(this.lexer);
            var sharedState_yy = {
                parseError: undefined,
                quoteName: undefined,
                lexer: undefined,
                parser: undefined,
                pre_parse: undefined,
                post_parse: undefined,
                pre_lex: undefined,
                post_lex: undefined // WARNING: must be written this way for the code expanders to work correctly in both ES5 and ES6 modes!
            };
            var ASSERT;
            if (typeof assert !== 'function') ASSERT = function JisonAssert(cond, msg) {
                if (!cond) throw new Error('assertion failed: ' + (msg || '***'));
            };
            else ASSERT = assert;
            this.yyGetSharedState = function yyGetSharedState() {
                return sharedState_yy;
            };
            function shallow_copy_noclobber(dst, src) {
                for(var k in src)if (typeof dst[k] === 'undefined' && Object.prototype.hasOwnProperty.call(src, k)) dst[k] = src[k];
            }
            // copy state
            shallow_copy_noclobber(sharedState_yy, this.yy);
            sharedState_yy.lexer = lexer;
            sharedState_yy.parser = this;
            // Does the shared state override the default `parseError` that already comes with this instance?
            if (typeof sharedState_yy.parseError === 'function') this.parseError = function parseErrorAlt(str, hash, ExceptionClass) {
                if (!ExceptionClass) ExceptionClass = this.JisonParserError;
                return sharedState_yy.parseError.call(this, str, hash, ExceptionClass);
            };
            else this.parseError = this.originalParseError;
            // Does the shared state override the default `quoteName` that already comes with this instance?
            if (typeof sharedState_yy.quoteName === 'function') this.quoteName = function quoteNameAlt(id_str) {
                return sharedState_yy.quoteName.call(this, id_str);
            };
            else this.quoteName = this.originalQuoteName;
            // set up the cleanup function; make it an API so that external code can re-use this one in case of
            // calamities or when the `%options no-try-catch` option has been specified for the grammar, in which
            // case this parse() API method doesn't come with a `finally { ... }` block any more!
            //
            // NOTE: as this API uses parse() as a closure, it MUST be set again on every parse() invocation,
            //       or else your `sharedState`, etc. references will be *wrong*!
            this.cleanupAfterParse = function parser_cleanupAfterParse(resultValue, invoke_post_methods, do_not_nuke_errorinfos) {
                var rv;
                if (invoke_post_methods) {
                    var hash;
                    if (sharedState_yy.post_parse || this.post_parse) // create an error hash info instance: we re-use this API in a **non-error situation**
                    // as this one delivers all parser internals ready for access by userland code.
                    hash = this.constructParseErrorInfo(null, null, null, false);
                    if (sharedState_yy.post_parse) {
                        rv = sharedState_yy.post_parse.call(this, sharedState_yy, resultValue, hash);
                        if (typeof rv !== 'undefined') resultValue = rv;
                    }
                    if (this.post_parse) {
                        rv = this.post_parse.call(this, sharedState_yy, resultValue, hash);
                        if (typeof rv !== 'undefined') resultValue = rv;
                    }
                    // cleanup:
                    if (hash && hash.destroy) hash.destroy();
                }
                if (this.__reentrant_call_depth > 1) return resultValue; // do not (yet) kill the sharedState when this is a reentrant run.
                // clean up the lingering lexer structures as well:
                if (lexer.cleanupAfterLex) lexer.cleanupAfterLex(do_not_nuke_errorinfos);
                // prevent lingering circular references from causing memory leaks:
                if (sharedState_yy) {
                    sharedState_yy.lexer = undefined;
                    sharedState_yy.parser = undefined;
                    if (lexer.yy === sharedState_yy) lexer.yy = undefined;
                }
                sharedState_yy = undefined;
                this.parseError = this.originalParseError;
                this.quoteName = this.originalQuoteName;
                // nuke the vstack[] array at least as that one will still reference obsoleted user values.
                // To be safe, we nuke the other internal stack columns as well...
                stack.length = 0; // fastest way to nuke an array without overly bothering the GC
                sstack.length = 0;
                vstack.length = 0;
                sp = 0;
                // nuke the error hash info instances created during this run.
                // Userland code must COPY any data/references
                // in the error hash instance(s) it is more permanently interested in.
                if (!do_not_nuke_errorinfos) {
                    for(var i = this.__error_infos.length - 1; i >= 0; i--){
                        var el = this.__error_infos[i];
                        if (el && typeof el.destroy === 'function') el.destroy();
                    }
                    this.__error_infos.length = 0;
                }
                return resultValue;
            };
            // NOTE: as this API uses parse() as a closure, it MUST be set again on every parse() invocation,
            //       or else your `lexer`, `sharedState`, etc. references will be *wrong*!
            this.constructParseErrorInfo = function parser_constructParseErrorInfo(msg, ex, expected, recoverable) {
                var pei = {
                    errStr: msg,
                    exception: ex,
                    text: lexer.match,
                    value: lexer.yytext,
                    token: this.describeSymbol(symbol) || symbol,
                    token_id: symbol,
                    line: lexer.yylineno,
                    expected: expected,
                    recoverable: recoverable,
                    state: state,
                    action: action,
                    new_state: newState,
                    symbol_stack: stack,
                    state_stack: sstack,
                    value_stack: vstack,
                    stack_pointer: sp,
                    yy: sharedState_yy,
                    lexer: lexer,
                    parser: this,
                    // and make sure the error info doesn't stay due to potential
                    // ref cycle via userland code manipulations.
                    // These would otherwise all be memory leak opportunities!
                    //
                    // Note that only array and object references are nuked as those
                    // constitute the set of elements which can produce a cyclic ref.
                    // The rest of the members is kept intact as they are harmless.
                    destroy: function destructParseErrorInfo() {
                        // remove cyclic references added to error info:
                        // info.yy = null;
                        // info.lexer = null;
                        // info.value = null;
                        // info.value_stack = null;
                        // ...
                        var rec = !!this.recoverable;
                        for(var key in this)if (this.hasOwnProperty(key) && typeof key === 'object') this[key] = undefined;
                        this.recoverable = rec;
                    }
                };
                // track this instance so we can `destroy()` it once we deem it superfluous and ready for garbage collection!
                this.__error_infos.push(pei);
                return pei;
            };
            function getNonTerminalFromCode(symbol) {
                var tokenName = self.getSymbolName(symbol);
                if (!tokenName) tokenName = symbol;
                return tokenName;
            }
            function stdLex() {
                var token = lexer.lex();
                // if token isn't its numeric value, convert
                if (typeof token !== 'number') token = self.symbols_[token] || token;
                return token || EOF;
            }
            function fastLex() {
                var token = lexer.fastLex();
                // if token isn't its numeric value, convert
                if (typeof token !== 'number') token = self.symbols_[token] || token;
                return token || EOF;
            }
            var lex = stdLex;
            var state, action, r, t;
            var yyval = {
                $: true,
                _$: undefined,
                yy: sharedState_yy
            };
            var p;
            var yyrulelen;
            var this_production;
            var newState;
            var retval = false;
            try {
                this.__reentrant_call_depth++;
                lexer.setInput(input, sharedState_yy);
                // NOTE: we *assume* no lexer pre/post handlers are set up *after* 
                // this initial `setInput()` call: hence we can now check and decide
                // whether we'll go with the standard, slower, lex() API or the
                // `fast_lex()` one:
                if (typeof lexer.canIUse === 'function') {
                    var lexerInfo = lexer.canIUse();
                    if (lexerInfo.fastLex && typeof fastLex === 'function') lex = fastLex;
                }
                vstack[sp] = null;
                sstack[sp] = 0;
                stack[sp] = 0;
                ++sp;
                if (this.pre_parse) this.pre_parse.call(this, sharedState_yy);
                if (sharedState_yy.pre_parse) sharedState_yy.pre_parse.call(this, sharedState_yy);
                newState = sstack[sp - 1];
                for(;;){
                    // retrieve state number from top of stack
                    state = newState; // sstack[sp - 1];
                    // use default actions if available
                    if (this.defaultActions[state]) {
                        action = 2;
                        newState = this.defaultActions[state];
                    } else {
                        // The single `==` condition below covers both these `===` comparisons in a single
                        // operation:
                        //
                        //     if (symbol === null || typeof symbol === 'undefined') ...
                        if (!symbol) symbol = lex();
                        // read action for current state and first input
                        t = table[state] && table[state][symbol] || NO_ACTION;
                        newState = t[1];
                        action = t[0];
                        // handle parse error
                        if (!action) {
                            var errStr;
                            var errSymbolDescr = this.describeSymbol(symbol) || symbol;
                            var expected = this.collect_expected_token_set(state);
                            // Report error
                            if (typeof lexer.yylineno === 'number') errStr = 'Parse error on line ' + (lexer.yylineno + 1) + ': ';
                            else errStr = 'Parse error: ';
                            if (typeof lexer.showPosition === 'function') errStr += '\n' + lexer.showPosition(69, 10) + '\n';
                            if (expected.length) errStr += 'Expecting ' + expected.join(', ') + ', got unexpected ' + errSymbolDescr;
                            else errStr += 'Unexpected ' + errSymbolDescr;
                            // we cannot recover from the error!
                            p = this.constructParseErrorInfo(errStr, null, expected, false);
                            r = this.parseError(p.errStr, p, this.JisonParserError);
                            if (typeof r !== 'undefined') retval = r;
                            break;
                        }
                    }
                    switch(action){
                        // catch misc. parse failures:
                        default:
                            // this shouldn't happen, unless resolve defaults are off
                            if (action instanceof Array) {
                                p = this.constructParseErrorInfo('Parse Error: multiple actions possible at state: ' + state + ', token: ' + symbol, null, null, false);
                                r = this.parseError(p.errStr, p, this.JisonParserError);
                                if (typeof r !== 'undefined') retval = r;
                                break;
                            }
                            // Another case of better safe than sorry: in case state transitions come out of another error recovery process
                            // or a buggy LUT (LookUp Table):
                            p = this.constructParseErrorInfo('Parsing halted. No viable error recovery approach available due to internal system failure.', null, null, false);
                            r = this.parseError(p.errStr, p, this.JisonParserError);
                            if (typeof r !== 'undefined') retval = r;
                            break;
                        // shift:
                        case 1:
                            stack[sp] = symbol;
                            vstack[sp] = lexer.yytext;
                            sstack[sp] = newState; // push state
                            ++sp;
                            symbol = 0;
                            continue;
                        // reduce:
                        case 2:
                            this_production = this.productions_[newState - 1]; // `this.productions_[]` is zero-based indexed while states start from 1 upwards...
                            yyrulelen = this_production[1];
                            r = this.performAction.call(yyval, newState, sp - 1, vstack);
                            if (typeof r !== 'undefined') {
                                retval = r;
                                break;
                            }
                            // pop off stack
                            sp -= yyrulelen;
                            // don't overwrite the `symbol` variable: use a local var to speed things up:
                            var ntsymbol = this_production[0]; // push nonterminal (reduce)
                            stack[sp] = ntsymbol;
                            vstack[sp] = yyval.$;
                            // goto new state = table[STATE][NONTERMINAL]
                            newState = table[sstack[sp - 1]][ntsymbol];
                            sstack[sp] = newState;
                            ++sp;
                            continue;
                        // accept:
                        case 3:
                            if (sp !== -2) {
                                retval = true;
                                // Return the `$accept` rule's `$$` result, if available.
                                //
                                // Also note that JISON always adds this top-most `$accept` rule (with implicit,
                                // default, action):
                                //
                                //     $accept: <startSymbol> $end
                                //                  %{ $$ = $1; @$ = @1; %}
                                //
                                // which, combined with the parse kernel's `$accept` state behaviour coded below,
                                // will produce the `$$` value output of the <startSymbol> rule as the parse result,
                                // IFF that result is *not* `undefined`. (See also the parser kernel code.)
                                //
                                // In code:
                                //
                                //                  %{
                                //                      @$ = @1;            // if location tracking support is included
                                //                      if (typeof $1 !== 'undefined')
                                //                          return $1;
                                //                      else
                                //                          return true;           // the default parse result if the rule actions don't produce anything
                                //                  %}
                                sp--;
                                if (typeof vstack[sp] !== 'undefined') retval = vstack[sp];
                            }
                            break;
                    }
                    break;
                }
            } catch (ex) {
                // report exceptions through the parseError callback too, but keep the exception intact
                // if it is a known parser or lexer error which has been thrown by parseError() already:
                if (ex instanceof this.JisonParserError) throw ex;
                else if (lexer && typeof lexer.JisonLexerError === 'function' && ex instanceof lexer.JisonLexerError) throw ex;
                p = this.constructParseErrorInfo('Parsing aborted due to exception.', ex, null, false);
                retval = false;
                r = this.parseError(p.errStr, p, this.JisonParserError);
                if (typeof r !== 'undefined') retval = r;
            } finally{
                retval = this.cleanupAfterParse(retval, true, true);
                this.__reentrant_call_depth--;
            } // /finally
            return retval;
        }
    };
    parser.originalParseError = parser.parseError;
    parser.originalQuoteName = parser.quoteName;
    /* lexer generated by jison-lex 0.6.1-215 */ /*
 * Returns a Lexer object of the following structure:
 *
 *  Lexer: {
 *    yy: {}     The so-called "shared state" or rather the *source* of it;
 *               the real "shared state" `yy` passed around to
 *               the rule actions, etc. is a direct reference!
 *
 *               This "shared context" object was passed to the lexer by way of 
 *               the `lexer.setInput(str, yy)` API before you may use it.
 *
 *               This "shared context" object is passed to the lexer action code in `performAction()`
 *               so userland code in the lexer actions may communicate with the outside world 
 *               and/or other lexer rules' actions in more or less complex ways.
 *
 *  }
 *
 *  Lexer.prototype: {
 *    EOF: 1,
 *    ERROR: 2,
 *
 *    yy:        The overall "shared context" object reference.
 *
 *    JisonLexerError: function(msg, hash),
 *
 *    performAction: function lexer__performAction(yy, yyrulenumber, YY_START),
 *
 *               The function parameters and `this` have the following value/meaning:
 *               - `this`    : reference to the `lexer` instance. 
 *                               `yy_` is an alias for `this` lexer instance reference used internally.
 *
 *               - `yy`      : a reference to the `yy` "shared state" object which was passed to the lexer
 *                             by way of the `lexer.setInput(str, yy)` API before.
 *
 *                             Note:
 *                             The extra arguments you specified in the `%parse-param` statement in your
 *                             **parser** grammar definition file are passed to the lexer via this object
 *                             reference as member variables.
 *
 *               - `yyrulenumber`   : index of the matched lexer rule (regex), used internally.
 *
 *               - `YY_START`: the current lexer "start condition" state.
 *
 *    parseError: function(str, hash, ExceptionClass),
 *
 *    constructLexErrorInfo: function(error_message, is_recoverable),
 *               Helper function.
 *               Produces a new errorInfo 'hash object' which can be passed into `parseError()`.
 *               See it's use in this lexer kernel in many places; example usage:
 *
 *                   var infoObj = lexer.constructParseErrorInfo('fail!', true);
 *                   var retVal = lexer.parseError(infoObj.errStr, infoObj, lexer.JisonLexerError);
 *
 *    options: { ... lexer %options ... },
 *
 *    lex: function(),
 *               Produce one token of lexed input, which was passed in earlier via the `lexer.setInput()` API.
 *               You MAY use the additional `args...` parameters as per `%parse-param` spec of the **lexer** grammar:
 *               these extra `args...` are added verbatim to the `yy` object reference as member variables.
 *
 *               WARNING:
 *               Lexer's additional `args...` parameters (via lexer's `%parse-param`) MAY conflict with
 *               any attributes already added to `yy` by the **parser** or the jison run-time; 
 *               when such a collision is detected an exception is thrown to prevent the generated run-time 
 *               from silently accepting this confusing and potentially hazardous situation! 
 *
 *    cleanupAfterLex: function(do_not_nuke_errorinfos),
 *               Helper function.
 *
 *               This helper API is invoked when the **parse process** has completed: it is the responsibility
 *               of the **parser** (or the calling userland code) to invoke this method once cleanup is desired. 
 *
 *               This helper may be invoked by user code to ensure the internal lexer gets properly garbage collected.
 *
 *    setInput: function(input, [yy]),
 *
 *
 *    input: function(),
 *
 *
 *    unput: function(str),
 *
 *
 *    more: function(),
 *
 *
 *    reject: function(),
 *
 *
 *    less: function(n),
 *
 *
 *    pastInput: function(n),
 *
 *
 *    upcomingInput: function(n),
 *
 *
 *    showPosition: function(),
 *
 *
 *    test_match: function(regex_match_array, rule_index),
 *
 *
 *    next: function(),
 *
 *
 *    begin: function(condition),
 *
 *
 *    pushState: function(condition),
 *
 *
 *    popState: function(),
 *
 *
 *    topState: function(),
 *
 *
 *    _currentRules: function(),
 *
 *
 *    stateStackSize: function(),
 *
 *
 *    performAction: function(yy, yy_, yyrulenumber, YY_START),
 *
 *
 *    rules: [...],
 *
 *
 *    conditions: {associative list: name ==> set},
 *  }
 *
 *
 *  token location info (`yylloc`): {
 *    first_line: n,
 *    last_line: n,
 *    first_column: n,
 *    last_column: n,
 *    range: [start_number, end_number]
 *               (where the numbers are indexes into the input string, zero-based)
 *  }
 *
 * ---
 *
 * The `parseError` function receives a 'hash' object with these members for lexer errors:
 *
 *  {
 *    text:        (matched text)
 *    token:       (the produced terminal token, if any)
 *    token_id:    (the produced terminal token numeric ID, if any)
 *    line:        (yylineno)
 *    loc:         (yylloc)
 *    recoverable: (boolean: TRUE when the parser MAY have an error recovery rule
 *                  available for this particular error)
 *    yy:          (object: the current parser internal "shared state" `yy`
 *                  as is also available in the rule actions; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    lexer:       (reference to the current lexer instance used by the parser)
 *  }
 *
 * while `this` will reference the current lexer instance.
 *
 * When `parseError` is invoked by the lexer, the default implementation will
 * attempt to invoke `yy.parser.parseError()`; when this callback is not provided
 * it will try to invoke `yy.parseError()` instead. When that callback is also not
 * provided, a `JisonLexerError` exception will be thrown containing the error
 * message and `hash`, as constructed by the `constructLexErrorInfo()` API.
 *
 * Note that the lexer's `JisonLexerError` error class is passed via the
 * `ExceptionClass` argument, which is invoked to construct the exception
 * instance to be thrown, so technically `parseError` will throw the object
 * produced by the `new ExceptionClass(str, hash)` JavaScript expression.
 *
 * ---
 *
 * You can specify lexer options by setting / modifying the `.options` object of your Lexer instance.
 * These options are available:
 *
 * (Options are permanent.)
 *  
 *  yy: {
 *      parseError: function(str, hash, ExceptionClass)
 *                 optional: overrides the default `parseError` function.
 *  }
 *
 *  lexer.options: {
 *      pre_lex:  function()
 *                 optional: is invoked before the lexer is invoked to produce another token.
 *                 `this` refers to the Lexer object.
 *      post_lex: function(token) { return token; }
 *                 optional: is invoked when the lexer has produced a token `token`;
 *                 this function can override the returned token value by returning another.
 *                 When it does not return any (truthy) value, the lexer will return
 *                 the original `token`.
 *                 `this` refers to the Lexer object.
 *
 * WARNING: the next set of options are not meant to be changed. They echo the abilities of
 * the lexer as per when it was compiled!
 *
 *      ranges: boolean
 *                 optional: `true` ==> token location info will include a .range[] member.
 *      flex: boolean
 *                 optional: `true` ==> flex-like lexing behaviour where the rules are tested
 *                 exhaustively to find the longest match.
 *      backtrack_lexer: boolean
 *                 optional: `true` ==> lexer regexes are tested in order and for invoked;
 *                 the lexer terminates the scan when a token is returned by the action code.
 *      xregexp: boolean
 *                 optional: `true` ==> lexer rule regexes are "extended regex format" requiring the
 *                 `XRegExp` library. When this %option has not been specified at compile time, all lexer
 *                 rule regexes have been written as standard JavaScript RegExp expressions.
 *  }
 */ var lexer = function() {
        /**
   * See also:
   * http://stackoverflow.com/questions/1382107/whats-a-good-way-to-extend-error-in-javascript/#35881508
   * but we keep the prototype.constructor and prototype.name assignment lines too for compatibility
   * with userland code which might access the derived class in a 'classic' way.
   *
   * @public
   * @constructor
   * @nocollapse
   */ function JisonLexerError(msg, hash) {
            Object.defineProperty(this, 'name', {
                enumerable: false,
                writable: false,
                value: 'JisonLexerError'
            });
            if (msg == null) msg = '???';
            Object.defineProperty(this, 'message', {
                enumerable: false,
                writable: true,
                value: msg
            });
            this.hash = hash;
            var stacktrace;
            if (hash && hash.exception instanceof Error) {
                var ex2 = hash.exception;
                this.message = ex2.message || msg;
                stacktrace = ex2.stack;
            }
            if (!stacktrace) {
                if (Error.hasOwnProperty('captureStackTrace')) // V8
                Error.captureStackTrace(this, this.constructor);
                else stacktrace = new Error(msg).stack;
            }
            if (stacktrace) Object.defineProperty(this, 'stack', {
                enumerable: false,
                writable: false,
                value: stacktrace
            });
        }
        if (typeof Object.setPrototypeOf === 'function') Object.setPrototypeOf(JisonLexerError.prototype, Error.prototype);
        else JisonLexerError.prototype = Object.create(Error.prototype);
        JisonLexerError.prototype.constructor = JisonLexerError;
        JisonLexerError.prototype.name = 'JisonLexerError';
        var lexer = {
            // Code Generator Information Report
            // ---------------------------------
            //
            // Options:
            //
            //   backtracking: .................... false
            //   location.ranges: ................. false
            //   location line+column tracking: ... true
            //
            //
            // Forwarded Parser Analysis flags:
            //
            //   uses yyleng: ..................... false
            //   uses yylineno: ................... false
            //   uses yytext: ..................... false
            //   uses yylloc: ..................... false
            //   uses lexer values: ............... true / true
            //   location tracking: ............... false
            //   location assignment: ............. false
            //
            //
            // Lexer Analysis flags:
            //
            //   uses yyleng: ..................... ???
            //   uses yylineno: ................... ???
            //   uses yytext: ..................... ???
            //   uses yylloc: ..................... ???
            //   uses ParseError API: ............. ???
            //   uses yyerror: .................... ???
            //   uses location tracking & editing:  ???
            //   uses more() API: ................. ???
            //   uses unput() API: ................ ???
            //   uses reject() API: ............... ???
            //   uses less() API: ................. ???
            //   uses display APIs pastInput(), upcomingInput(), showPosition():
            //        ............................. ???
            //   uses describeYYLLOC() API: ....... ???
            //
            // --------- END OF REPORT -----------
            EOF: 1,
            ERROR: 2,
            // JisonLexerError: JisonLexerError,        /// <-- injected by the code generator
            // options: {},                             /// <-- injected by the code generator
            // yy: ...,                                 /// <-- injected by setInput()
            __currentRuleSet__: null,
            __error_infos: [],
            __decompressed: false,
            done: false,
            _backtrack: false,
            _input: '',
            _more: false,
            _signaled_error_token: false,
            conditionStack: [],
            match: '',
            matched: '',
            matches: false,
            yytext: '',
            offset: 0,
            yyleng: 0,
            yylineno: 0,
            yylloc: null,
            /**
     * INTERNAL USE: construct a suitable error info hash object instance for `parseError`.
     * 
     * @public
     * @this {RegExpLexer}
     */ constructLexErrorInfo: function lexer_constructLexErrorInfo(msg, recoverable, show_input_position) {
                msg = '' + msg;
                // heuristic to determine if the error message already contains a (partial) source code dump
                // as produced by either `showPosition()` or `prettyPrintRange()`:
                if (show_input_position == undefined) show_input_position = !(msg.indexOf('\n') > 0 && msg.indexOf('^') > 0);
                if (this.yylloc && show_input_position) {
                    if (typeof this.prettyPrintRange === 'function') {
                        var pretty_src = this.prettyPrintRange(this.yylloc);
                        if (!/\n\s*$/.test(msg)) msg += '\n';
                        msg += '\n  Erroneous area:\n' + this.prettyPrintRange(this.yylloc);
                    } else if (typeof this.showPosition === 'function') {
                        var pos_str = this.showPosition();
                        if (pos_str) {
                            if (msg.length && msg[msg.length - 1] !== '\n' && pos_str[0] !== '\n') msg += '\n' + pos_str;
                            else msg += pos_str;
                        }
                    }
                }
                /** @constructor */ var pei = {
                    errStr: msg,
                    recoverable: !!recoverable,
                    text: this.match,
                    token: null,
                    line: this.yylineno,
                    loc: this.yylloc,
                    yy: this.yy,
                    lexer: this,
                    /**
         * and make sure the error info doesn't stay due to potential
         * ref cycle via userland code manipulations.
         * These would otherwise all be memory leak opportunities!
         * 
         * Note that only array and object references are nuked as those
         * constitute the set of elements which can produce a cyclic ref.
         * The rest of the members is kept intact as they are harmless.
         * 
         * @public
         * @this {LexErrorInfo}
         */ destroy: function destructLexErrorInfo() {
                        // remove cyclic references added to error info:
                        // info.yy = null;
                        // info.lexer = null;
                        // ...
                        var rec = !!this.recoverable;
                        for(var key in this)if (this.hasOwnProperty(key) && typeof key === 'object') this[key] = undefined;
                        this.recoverable = rec;
                    }
                };
                // track this instance so we can `destroy()` it once we deem it superfluous and ready for garbage collection!
                this.__error_infos.push(pei);
                return pei;
            },
            /**
     * handler which is invoked when a lexer error occurs.
     * 
     * @public
     * @this {RegExpLexer}
     */ parseError: function lexer_parseError(str, hash, ExceptionClass) {
                if (!ExceptionClass) ExceptionClass = this.JisonLexerError;
                if (this.yy) {
                    if (this.yy.parser && typeof this.yy.parser.parseError === 'function') return this.yy.parser.parseError.call(this, str, hash, ExceptionClass) || this.ERROR;
                    else if (typeof this.yy.parseError === 'function') return this.yy.parseError.call(this, str, hash, ExceptionClass) || this.ERROR;
                }
                throw new ExceptionClass(str, hash);
            },
            /**
     * method which implements `yyerror(str, ...args)` functionality for use inside lexer actions.
     * 
     * @public
     * @this {RegExpLexer}
     */ yyerror: function yyError(str /*, ...args */ ) {
                var lineno_msg = '';
                if (this.yylloc) lineno_msg = ' on line ' + (this.yylineno + 1);
                var p = this.constructLexErrorInfo('Lexical error' + lineno_msg + ': ' + str, this.options.lexerErrorsAreRecoverable);
                // Add any extra args to the hash under the name `extra_error_attributes`:
                var args = Array.prototype.slice.call(arguments, 1);
                if (args.length) p.extra_error_attributes = args;
                return this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;
            },
            /**
     * final cleanup function for when we have completed lexing the input;
     * make it an API so that external code can use this one once userland
     * code has decided it's time to destroy any lingering lexer error
     * hash object instances and the like: this function helps to clean
     * up these constructs, which *may* carry cyclic references which would
     * otherwise prevent the instances from being properly and timely
     * garbage-collected, i.e. this function helps prevent memory leaks!
     * 
     * @public
     * @this {RegExpLexer}
     */ cleanupAfterLex: function lexer_cleanupAfterLex(do_not_nuke_errorinfos) {
                // prevent lingering circular references from causing memory leaks:
                this.setInput('', {});
                // nuke the error hash info instances created during this run.
                // Userland code must COPY any data/references
                // in the error hash instance(s) it is more permanently interested in.
                if (!do_not_nuke_errorinfos) {
                    for(var i = this.__error_infos.length - 1; i >= 0; i--){
                        var el = this.__error_infos[i];
                        if (el && typeof el.destroy === 'function') el.destroy();
                    }
                    this.__error_infos.length = 0;
                }
                return this;
            },
            /**
     * clear the lexer token context; intended for internal use only
     * 
     * @public
     * @this {RegExpLexer}
     */ clear: function lexer_clear() {
                this.yytext = '';
                this.yyleng = 0;
                this.match = '';
                // - DO NOT reset `this.matched`
                this.matches = false;
                this._more = false;
                this._backtrack = false;
                var col = this.yylloc ? this.yylloc.last_column : 0;
                this.yylloc = {
                    first_line: this.yylineno + 1,
                    first_column: col,
                    last_line: this.yylineno + 1,
                    last_column: col,
                    range: [
                        this.offset,
                        this.offset
                    ]
                };
            },
            /**
     * resets the lexer, sets new input
     * 
     * @public
     * @this {RegExpLexer}
     */ setInput: function lexer_setInput(input, yy) {
                this.yy = yy || this.yy || {};
                // also check if we've fully initialized the lexer instance,
                // including expansion work to be done to go from a loaded
                // lexer to a usable lexer:
                if (!this.__decompressed) {
                    // step 1: decompress the regex list:
                    var rules = this.rules;
                    for(var i = 0, len = rules.length; i < len; i++){
                        var rule_re = rules[i];
                        // compression: is the RE an xref to another RE slot in the rules[] table?
                        if (typeof rule_re === 'number') rules[i] = rules[rule_re];
                    }
                    // step 2: unfold the conditions[] set to make these ready for use:
                    var conditions = this.conditions;
                    for(var k in conditions){
                        var spec = conditions[k];
                        var rule_ids = spec.rules;
                        var len = rule_ids.length;
                        var rule_regexes = new Array(len + 1); // slot 0 is unused; we use a 1-based index approach here to keep the hottest code in `lexer_next()` fast and simple! 
                        var rule_new_ids = new Array(len + 1);
                        for(var i = 0; i < len; i++){
                            var idx = rule_ids[i];
                            var rule_re = rules[idx];
                            rule_regexes[i + 1] = rule_re;
                            rule_new_ids[i + 1] = idx;
                        }
                        spec.rules = rule_new_ids;
                        spec.__rule_regexes = rule_regexes;
                        spec.__rule_count = len;
                    }
                    this.__decompressed = true;
                }
                this._input = input || '';
                this.clear();
                this._signaled_error_token = false;
                this.done = false;
                this.yylineno = 0;
                this.matched = '';
                this.conditionStack = [
                    'INITIAL'
                ];
                this.__currentRuleSet__ = null;
                this.yylloc = {
                    first_line: 1,
                    first_column: 0,
                    last_line: 1,
                    last_column: 0,
                    range: [
                        0,
                        0
                    ]
                };
                this.offset = 0;
                return this;
            },
            /**
     * edit the remaining input via user-specified callback.
     * This can be used to forward-adjust the input-to-parse, 
     * e.g. inserting macro expansions and alike in the
     * input which has yet to be lexed.
     * The behaviour of this API contrasts the `unput()` et al
     * APIs as those act on the *consumed* input, while this
     * one allows one to manipulate the future, without impacting
     * the current `yyloc` cursor location or any history. 
     * 
     * Use this API to help implement C-preprocessor-like
     * `#include` statements, etc.
     * 
     * The provided callback must be synchronous and is
     * expected to return the edited input (string).
     *
     * The `cpsArg` argument value is passed to the callback
     * as-is.
     *
     * `callback` interface: 
     * `function callback(input, cpsArg)`
     * 
     * - `input` will carry the remaining-input-to-lex string
     *   from the lexer.
     * - `cpsArg` is `cpsArg` passed into this API.
     * 
     * The `this` reference for the callback will be set to
     * reference this lexer instance so that userland code
     * in the callback can easily and quickly access any lexer
     * API. 
     *
     * When the callback returns a non-string-type falsey value,
     * we assume the callback did not edit the input and we
     * will using the input as-is.
     *
     * When the callback returns a non-string-type value, it
     * is converted to a string for lexing via the `"" + retval`
     * operation. (See also why: http://2ality.com/2012/03/converting-to-string.html 
     * -- that way any returned object's `toValue()` and `toString()`
     * methods will be invoked in a proper/desirable order.)
     * 
     * @public
     * @this {RegExpLexer}
     */ editRemainingInput: function lexer_editRemainingInput(callback, cpsArg) {
                var rv = callback.call(this, this._input, cpsArg);
                if (typeof rv !== 'string') {
                    if (rv) this._input = '' + rv;
                } else this._input = rv;
                return this;
            },
            /**
     * consumes and returns one char from the input
     * 
     * @public
     * @this {RegExpLexer}
     */ input: function lexer_input() {
                if (!this._input) //this.done = true;    -- don't set `done` as we want the lex()/next() API to be able to produce one custom EOF token match after this anyhow. (lexer can match special <<EOF>> tokens and perform user action code for a <<EOF>> match, but only does so *once*)
                return null;
                var ch = this._input[0];
                this.yytext += ch;
                this.yyleng++;
                this.offset++;
                this.match += ch;
                this.matched += ch;
                // Count the linenumber up when we hit the LF (or a stand-alone CR).
                // On CRLF, the linenumber is incremented when you fetch the CR or the CRLF combo
                // and we advance immediately past the LF as well, returning both together as if
                // it was all a single 'character' only.
                var slice_len = 1;
                var lines = false;
                if (ch === '\n') lines = true;
                else if (ch === '\r') {
                    lines = true;
                    var ch2 = this._input[1];
                    if (ch2 === '\n') {
                        slice_len++;
                        ch += ch2;
                        this.yytext += ch2;
                        this.yyleng++;
                        this.offset++;
                        this.match += ch2;
                        this.matched += ch2;
                        this.yylloc.range[1]++;
                    }
                }
                if (lines) {
                    this.yylineno++;
                    this.yylloc.last_line++;
                    this.yylloc.last_column = 0;
                } else this.yylloc.last_column++;
                this.yylloc.range[1]++;
                this._input = this._input.slice(slice_len);
                return ch;
            },
            /**
     * unshifts one char (or an entire string) into the input
     * 
     * @public
     * @this {RegExpLexer}
     */ unput: function lexer_unput(ch) {
                var len = ch.length;
                var lines = ch.split(/(?:\r\n?|\n)/g);
                this._input = ch + this._input;
                this.yytext = this.yytext.substr(0, this.yytext.length - len);
                this.yyleng = this.yytext.length;
                this.offset -= len;
                this.match = this.match.substr(0, this.match.length - len);
                this.matched = this.matched.substr(0, this.matched.length - len);
                if (lines.length > 1) {
                    this.yylineno -= lines.length - 1;
                    this.yylloc.last_line = this.yylineno + 1;
                    // Get last entirely matched line into the `pre_lines[]` array's
                    // last index slot; we don't mind when other previously 
                    // matched lines end up in the array too. 
                    var pre = this.match;
                    var pre_lines = pre.split(/(?:\r\n?|\n)/g);
                    if (pre_lines.length === 1) {
                        pre = this.matched;
                        pre_lines = pre.split(/(?:\r\n?|\n)/g);
                    }
                    this.yylloc.last_column = pre_lines[pre_lines.length - 1].length;
                } else this.yylloc.last_column -= len;
                this.yylloc.range[1] = this.yylloc.range[0] + this.yyleng;
                this.done = false;
                return this;
            },
            /**
     * cache matched text and append it on next action
     * 
     * @public
     * @this {RegExpLexer}
     */ more: function lexer_more() {
                this._more = true;
                return this;
            },
            /**
     * signal the lexer that this rule fails to match the input, so the
     * next matching rule (regex) should be tested instead.
     * 
     * @public
     * @this {RegExpLexer}
     */ reject: function lexer_reject() {
                if (this.options.backtrack_lexer) this._backtrack = true;
                else {
                    // when the `parseError()` call returns, we MUST ensure that the error is registered.
                    // We accomplish this by signaling an 'error' token to be produced for the current
                    // `.lex()` run.
                    var lineno_msg = '';
                    if (this.yylloc) lineno_msg = ' on line ' + (this.yylineno + 1);
                    var p = this.constructLexErrorInfo('Lexical error' + lineno_msg + ': You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).', false);
                    this._signaled_error_token = this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;
                }
                return this;
            },
            /**
     * retain first n characters of the match
     * 
     * @public
     * @this {RegExpLexer}
     */ less: function lexer_less(n) {
                return this.unput(this.match.slice(n));
            },
            /**
     * return (part of the) already matched input, i.e. for error
     * messages.
     * 
     * Limit the returned string length to `maxSize` (default: 20).
     * 
     * Limit the returned string to the `maxLines` number of lines of
     * input (default: 1).
     * 
     * Negative limit values equal *unlimited*.
     * 
     * @public
     * @this {RegExpLexer}
     */ pastInput: function lexer_pastInput(maxSize, maxLines) {
                var past = this.matched.substring(0, this.matched.length - this.match.length);
                if (maxSize < 0) maxSize = past.length;
                else if (!maxSize) maxSize = 20;
                if (maxLines < 0) maxLines = past.length; // can't ever have more input lines than this! 
                else if (!maxLines) maxLines = 1;
                // `substr` anticipation: treat \r\n as a single character and take a little
                // more than necessary so that we can still properly check against maxSize
                // after we've transformed and limited the newLines in here:
                past = past.substr(-maxSize * 2 - 2);
                // now that we have a significantly reduced string to process, transform the newlines
                // and chop them, then limit them:
                var a = past.replace(/\r\n|\r/g, '\n').split('\n');
                a = a.slice(-maxLines);
                past = a.join('\n');
                // When, after limiting to maxLines, we still have too much to return,
                // do add an ellipsis prefix...
                if (past.length > maxSize) past = '...' + past.substr(-maxSize);
                return past;
            },
            /**
     * return (part of the) upcoming input, i.e. for error messages.
     * 
     * Limit the returned string length to `maxSize` (default: 20).
     * 
     * Limit the returned string to the `maxLines` number of lines of input (default: 1).
     * 
     * Negative limit values equal *unlimited*.
     *
     * > ### NOTE ###
     * >
     * > *"upcoming input"* is defined as the whole of the both
     * > the *currently lexed* input, together with any remaining input
     * > following that. *"currently lexed"* input is the input 
     * > already recognized by the lexer but not yet returned with
     * > the lexer token. This happens when you are invoking this API
     * > from inside any lexer rule action code block. 
     * >
     * 
     * @public
     * @this {RegExpLexer}
     */ upcomingInput: function lexer_upcomingInput(maxSize, maxLines) {
                var next = this.match;
                if (maxSize < 0) maxSize = next.length + this._input.length;
                else if (!maxSize) maxSize = 20;
                if (maxLines < 0) maxLines = maxSize; // can't ever have more input lines than this! 
                else if (!maxLines) maxLines = 1;
                // `substring` anticipation: treat \r\n as a single character and take a little
                // more than necessary so that we can still properly check against maxSize
                // after we've transformed and limited the newLines in here:
                if (next.length < maxSize * 2 + 2) next += this._input.substring(0, maxSize * 2 + 2); // substring is faster on Chrome/V8 
                // now that we have a significantly reduced string to process, transform the newlines
                // and chop them, then limit them:
                var a = next.replace(/\r\n|\r/g, '\n').split('\n');
                a = a.slice(0, maxLines);
                next = a.join('\n');
                // When, after limiting to maxLines, we still have too much to return,
                // do add an ellipsis postfix...
                if (next.length > maxSize) next = next.substring(0, maxSize) + '...';
                return next;
            },
            /**
     * return a string which displays the character position where the
     * lexing error occurred, i.e. for error messages
     * 
     * @public
     * @this {RegExpLexer}
     */ showPosition: function lexer_showPosition(maxPrefix, maxPostfix) {
                var pre = this.pastInput(maxPrefix).replace(/\s/g, ' ');
                var c = new Array(pre.length + 1).join('-');
                return pre + this.upcomingInput(maxPostfix).replace(/\s/g, ' ') + '\n' + c + '^';
            },
            /**
     * return an YYLLOC info object derived off the given context (actual, preceding, following, current).
     * Use this method when the given `actual` location is not guaranteed to exist (i.e. when
     * it MAY be NULL) and you MUST have a valid location info object anyway:
     * then we take the given context of the `preceding` and `following` locations, IFF those are available,
     * and reconstruct the `actual` location info from those.
     * If this fails, the heuristic is to take the `current` location, IFF available.
     * If this fails as well, we assume the sought location is at/around the current lexer position
     * and then produce that one as a response. DO NOTE that these heuristic/derived location info
     * values MAY be inaccurate!
     *
     * NOTE: `deriveLocationInfo()` ALWAYS produces a location info object *copy* of `actual`, not just
     * a *reference* hence all input location objects can be assumed to be 'constant' (function has no side-effects).
     * 
     * @public
     * @this {RegExpLexer}
     */ deriveLocationInfo: function lexer_deriveYYLLOC(actual, preceding, following, current) {
                var loc = {
                    first_line: 1,
                    first_column: 0,
                    last_line: 1,
                    last_column: 0,
                    range: [
                        0,
                        0
                    ]
                };
                if (actual) {
                    loc.first_line = actual.first_line | 0;
                    loc.last_line = actual.last_line | 0;
                    loc.first_column = actual.first_column | 0;
                    loc.last_column = actual.last_column | 0;
                    if (actual.range) {
                        loc.range[0] = actual.range[0] | 0;
                        loc.range[1] = actual.range[1] | 0;
                    }
                }
                if (loc.first_line <= 0 || loc.last_line < loc.first_line) {
                    // plan B: heuristic using preceding and following:
                    if (loc.first_line <= 0 && preceding) {
                        loc.first_line = preceding.last_line | 0;
                        loc.first_column = preceding.last_column | 0;
                        if (preceding.range) loc.range[0] = actual.range[1] | 0;
                    }
                    if ((loc.last_line <= 0 || loc.last_line < loc.first_line) && following) {
                        loc.last_line = following.first_line | 0;
                        loc.last_column = following.first_column | 0;
                        if (following.range) loc.range[1] = actual.range[0] | 0;
                    }
                    // plan C?: see if the 'current' location is useful/sane too:
                    if (loc.first_line <= 0 && current && (loc.last_line <= 0 || current.last_line <= loc.last_line)) {
                        loc.first_line = current.first_line | 0;
                        loc.first_column = current.first_column | 0;
                        if (current.range) loc.range[0] = current.range[0] | 0;
                    }
                    if (loc.last_line <= 0 && current && (loc.first_line <= 0 || current.first_line >= loc.first_line)) {
                        loc.last_line = current.last_line | 0;
                        loc.last_column = current.last_column | 0;
                        if (current.range) loc.range[1] = current.range[1] | 0;
                    }
                }
                // sanitize: fix last_line BEFORE we fix first_line as we use the 'raw' value of the latter
                // or plan D heuristics to produce a 'sensible' last_line value:
                if (loc.last_line <= 0) {
                    if (loc.first_line <= 0) {
                        loc.first_line = this.yylloc.first_line;
                        loc.last_line = this.yylloc.last_line;
                        loc.first_column = this.yylloc.first_column;
                        loc.last_column = this.yylloc.last_column;
                        loc.range[0] = this.yylloc.range[0];
                        loc.range[1] = this.yylloc.range[1];
                    } else {
                        loc.last_line = this.yylloc.last_line;
                        loc.last_column = this.yylloc.last_column;
                        loc.range[1] = this.yylloc.range[1];
                    }
                }
                if (loc.first_line <= 0) {
                    loc.first_line = loc.last_line;
                    loc.first_column = 0; // loc.last_column; 
                    loc.range[1] = loc.range[0];
                }
                if (loc.first_column < 0) loc.first_column = 0;
                if (loc.last_column < 0) loc.last_column = loc.first_column > 0 ? loc.first_column : 80;
                return loc;
            },
            /**
     * return a string which displays the lines & columns of input which are referenced 
     * by the given location info range, plus a few lines of context.
     * 
     * This function pretty-prints the indicated section of the input, with line numbers 
     * and everything!
     * 
     * This function is very useful to provide highly readable error reports, while
     * the location range may be specified in various flexible ways:
     * 
     * - `loc` is the location info object which references the area which should be
     *   displayed and 'marked up': these lines & columns of text are marked up by `^`
     *   characters below each character in the entire input range.
     * 
     * - `context_loc` is the *optional* location info object which instructs this
     *   pretty-printer how much *leading* context should be displayed alongside
     *   the area referenced by `loc`. This can help provide context for the displayed
     *   error, etc.
     * 
     *   When this location info is not provided, a default context of 3 lines is
     *   used.
     * 
     * - `context_loc2` is another *optional* location info object, which serves
     *   a similar purpose to `context_loc`: it specifies the amount of *trailing*
     *   context lines to display in the pretty-print output.
     * 
     *   When this location info is not provided, a default context of 1 line only is
     *   used.
     * 
     * Special Notes:
     * 
     * - when the `loc`-indicated range is very large (about 5 lines or more), then
     *   only the first and last few lines of this block are printed while a
     *   `...continued...` message will be printed between them.
     * 
     *   This serves the purpose of not printing a huge amount of text when the `loc`
     *   range happens to be huge: this way a manageable & readable output results
     *   for arbitrary large ranges.
     * 
     * - this function can display lines of input which whave not yet been lexed.
     *   `prettyPrintRange()` can access the entire input!
     * 
     * @public
     * @this {RegExpLexer}
     */ prettyPrintRange: function lexer_prettyPrintRange(loc, context_loc, context_loc2) {
                loc = this.deriveLocationInfo(loc, context_loc, context_loc2);
                const CONTEXT = 3;
                const CONTEXT_TAIL = 1;
                const MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT = 2;
                var input = this.matched + this._input;
                var lines = input.split('\n');
                var l0 = Math.max(1, context_loc ? context_loc.first_line : loc.first_line - CONTEXT);
                var l1 = Math.max(1, context_loc2 ? context_loc2.last_line : loc.last_line + CONTEXT_TAIL);
                var lineno_display_width = 1 + Math.log10(l1 | 1) | 0;
                var ws_prefix = new Array(lineno_display_width).join(' ');
                var nonempty_line_indexes = [];
                var rv = lines.slice(l0 - 1, l1 + 1).map(function injectLineNumber(line, index) {
                    var lno = index + l0;
                    var lno_pfx = (ws_prefix + lno).substr(-lineno_display_width);
                    var rv = lno_pfx + ': ' + line;
                    var errpfx = new Array(lineno_display_width + 1).join('^');
                    var offset = 3;
                    var len = 0;
                    if (lno === loc.first_line) {
                        offset += loc.first_column;
                        len = Math.max(2, (lno === loc.last_line ? loc.last_column : line.length) - loc.first_column + 1);
                    } else if (lno === loc.last_line) len = Math.max(2, loc.last_column + 1);
                    else if (lno > loc.first_line && lno < loc.last_line) len = Math.max(2, line.length + 1);
                    if (len) {
                        var lead = new Array(offset).join('.');
                        var mark = new Array(len).join('^');
                        rv += '\n' + errpfx + lead + mark;
                        if (line.trim().length > 0) nonempty_line_indexes.push(index);
                    }
                    rv = rv.replace(/\t/g, ' ');
                    return rv;
                });
                // now make sure we don't print an overly large amount of error area: limit it 
                // to the top and bottom line count:
                if (nonempty_line_indexes.length > 2 * MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT) {
                    var clip_start = nonempty_line_indexes[MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT - 1] + 1;
                    var clip_end = nonempty_line_indexes[nonempty_line_indexes.length - MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT] - 1;
                    var intermediate_line = new Array(lineno_display_width + 1).join(' ') + '  (...continued...)';
                    intermediate_line += '\n' + new Array(lineno_display_width + 1).join('-') + '  (---------------)';
                    rv.splice(clip_start, clip_end - clip_start + 1, intermediate_line);
                }
                return rv.join('\n');
            },
            /**
     * helper function, used to produce a human readable description as a string, given
     * the input `yylloc` location object.
     * 
     * Set `display_range_too` to TRUE to include the string character index position(s)
     * in the description if the `yylloc.range` is available.
     * 
     * @public
     * @this {RegExpLexer}
     */ describeYYLLOC: function lexer_describe_yylloc(yylloc, display_range_too) {
                var l1 = yylloc.first_line;
                var l2 = yylloc.last_line;
                var c1 = yylloc.first_column;
                var c2 = yylloc.last_column;
                var dl = l2 - l1;
                var dc = c2 - c1;
                var rv;
                if (dl === 0) {
                    rv = 'line ' + l1 + ', ';
                    if (dc <= 1) rv += 'column ' + c1;
                    else rv += 'columns ' + c1 + ' .. ' + c2;
                } else rv = 'lines ' + l1 + '(column ' + c1 + ') .. ' + l2 + '(column ' + c2 + ')';
                if (yylloc.range && display_range_too) {
                    var r1 = yylloc.range[0];
                    var r2 = yylloc.range[1] - 1;
                    if (r2 <= r1) rv += ' {String Offset: ' + r1 + '}';
                    else rv += ' {String Offset range: ' + r1 + ' .. ' + r2 + '}';
                }
                return rv;
            },
            /**
     * test the lexed token: return FALSE when not a match, otherwise return token.
     * 
     * `match` is supposed to be an array coming out of a regex match, i.e. `match[0]`
     * contains the actually matched text string.
     * 
     * Also move the input cursor forward and update the match collectors:
     * 
     * - `yytext`
     * - `yyleng`
     * - `match`
     * - `matches`
     * - `yylloc`
     * - `offset`
     * 
     * @public
     * @this {RegExpLexer}
     */ test_match: function lexer_test_match(match, indexed_rule) {
                var token, lines, backup, match_str, match_str_len;
                if (this.options.backtrack_lexer) // save context
                backup = {
                    yylineno: this.yylineno,
                    yylloc: {
                        first_line: this.yylloc.first_line,
                        last_line: this.yylloc.last_line,
                        first_column: this.yylloc.first_column,
                        last_column: this.yylloc.last_column,
                        range: this.yylloc.range.slice(0)
                    },
                    yytext: this.yytext,
                    match: this.match,
                    matches: this.matches,
                    matched: this.matched,
                    yyleng: this.yyleng,
                    offset: this.offset,
                    _more: this._more,
                    _input: this._input,
                    //_signaled_error_token: this._signaled_error_token,
                    yy: this.yy,
                    conditionStack: this.conditionStack.slice(0),
                    done: this.done
                };
                match_str = match[0];
                match_str_len = match_str.length;
                // if (match_str.indexOf('\n') !== -1 || match_str.indexOf('\r') !== -1) {
                lines = match_str.split(/(?:\r\n?|\n)/g);
                if (lines.length > 1) {
                    this.yylineno += lines.length - 1;
                    this.yylloc.last_line = this.yylineno + 1;
                    this.yylloc.last_column = lines[lines.length - 1].length;
                } else this.yylloc.last_column += match_str_len;
                // }
                this.yytext += match_str;
                this.match += match_str;
                this.matched += match_str;
                this.matches = match;
                this.yyleng = this.yytext.length;
                this.yylloc.range[1] += match_str_len;
                // previous lex rules MAY have invoked the `more()` API rather than producing a token:
                // those rules will already have moved this `offset` forward matching their match lengths,
                // hence we must only add our own match length now:
                this.offset += match_str_len;
                this._more = false;
                this._backtrack = false;
                this._input = this._input.slice(match_str_len);
                // calling this method:
                //
                //   function lexer__performAction(yy, yyrulenumber, YY_START) {...}
                token = this.performAction.call(this, this.yy, indexed_rule, this.conditionStack[this.conditionStack.length - 1]);
                // otherwise, when the action codes are all simple return token statements:
                //token = this.simpleCaseActionClusters[indexed_rule];
                if (this.done && this._input) this.done = false;
                if (token) return token;
                else if (this._backtrack) {
                    // recover context
                    for(var k in backup)this[k] = backup[k];
                    this.__currentRuleSet__ = null;
                    return false; // rule action called reject() implying the next rule should be tested instead. 
                } else if (this._signaled_error_token) {
                    // produce one 'error' token as `.parseError()` in `reject()`
                    // did not guarantee a failure signal by throwing an exception!
                    token = this._signaled_error_token;
                    this._signaled_error_token = false;
                    return token;
                }
                return false;
            },
            /**
     * return next match in input
     * 
     * @public
     * @this {RegExpLexer}
     */ next: function lexer_next() {
                if (this.done) {
                    this.clear();
                    return this.EOF;
                }
                if (!this._input) this.done = true;
                var token, match, tempMatch, index;
                if (!this._more) this.clear();
                var spec = this.__currentRuleSet__;
                if (!spec) {
                    // Update the ruleset cache as we apparently encountered a state change or just started lexing.
                    // The cache is set up for fast lookup -- we assume a lexer will switch states much less often than it will
                    // invoke the `lex()` token-producing API and related APIs, hence caching the set for direct access helps
                    // speed up those activities a tiny bit.
                    spec = this.__currentRuleSet__ = this._currentRules();
                    // Check whether a *sane* condition has been pushed before: this makes the lexer robust against
                    // user-programmer bugs such as https://github.com/zaach/jison-lex/issues/19
                    if (!spec || !spec.rules) {
                        var lineno_msg = '';
                        if (this.options.trackPosition) lineno_msg = ' on line ' + (this.yylineno + 1);
                        var p = this.constructLexErrorInfo('Internal lexer engine error' + lineno_msg + ': The lex grammar programmer pushed a non-existing condition name "' + this.topState() + '"; this is a fatal error and should be reported to the application programmer team!', false);
                        // produce one 'error' token until this situation has been resolved, most probably by parse termination!
                        return this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;
                    }
                }
                var rule_ids = spec.rules;
                var regexes = spec.__rule_regexes;
                var len = spec.__rule_count;
                // Note: the arrays are 1-based, while `len` itself is a valid index,
                // hence the non-standard less-or-equal check in the next loop condition!
                for(var i = 1; i <= len; i++){
                    tempMatch = this._input.match(regexes[i]);
                    if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                        match = tempMatch;
                        index = i;
                        if (this.options.backtrack_lexer) {
                            token = this.test_match(tempMatch, rule_ids[i]);
                            if (token !== false) return token;
                            else if (this._backtrack) {
                                match = undefined;
                                continue; // rule action called reject() implying a rule MISmatch. 
                            } else // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                            return false;
                        } else if (!this.options.flex) break;
                    }
                }
                if (match) {
                    token = this.test_match(match, rule_ids[index]);
                    if (token !== false) return token;
                    // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                    return false;
                }
                if (!this._input) {
                    this.done = true;
                    this.clear();
                    return this.EOF;
                } else {
                    var lineno_msg = '';
                    if (this.options.trackPosition) lineno_msg = ' on line ' + (this.yylineno + 1);
                    var p = this.constructLexErrorInfo('Lexical error' + lineno_msg + ': Unrecognized text.', this.options.lexerErrorsAreRecoverable);
                    var pendingInput = this._input;
                    var activeCondition = this.topState();
                    var conditionStackDepth = this.conditionStack.length;
                    token = this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;
                    if (token === this.ERROR) // we can try to recover from a lexer error that `parseError()` did not 'recover' for us
                    // by moving forward at least one character at a time IFF the (user-specified?) `parseError()`
                    // has not consumed/modified any pending input or changed state in the error handler:
                    {
                        if (!this.matches && // and make sure the input has been modified/consumed ...
                        pendingInput === this._input && // ...or the lexer state has been modified significantly enough
                        // to merit a non-consuming error handling action right now.
                        activeCondition === this.topState() && conditionStackDepth === this.conditionStack.length) this.input();
                    }
                    return token;
                }
            },
            /**
     * return next match that has a token
     * 
     * @public
     * @this {RegExpLexer}
     */ lex: function lexer_lex() {
                var r;
                // allow the PRE/POST handlers set/modify the return token for maximum flexibility of the generated lexer:
                if (typeof this.pre_lex === 'function') r = this.pre_lex.call(this, 0);
                if (typeof this.options.pre_lex === 'function') // (also account for a userdef function which does not return any value: keep the token as is)
                r = this.options.pre_lex.call(this, r) || r;
                if (this.yy && typeof this.yy.pre_lex === 'function') // (also account for a userdef function which does not return any value: keep the token as is)
                r = this.yy.pre_lex.call(this, r) || r;
                while(!r)r = this.next();
                if (this.yy && typeof this.yy.post_lex === 'function') // (also account for a userdef function which does not return any value: keep the token as is)
                r = this.yy.post_lex.call(this, r) || r;
                if (typeof this.options.post_lex === 'function') // (also account for a userdef function which does not return any value: keep the token as is)
                r = this.options.post_lex.call(this, r) || r;
                if (typeof this.post_lex === 'function') // (also account for a userdef function which does not return any value: keep the token as is)
                r = this.post_lex.call(this, r) || r;
                return r;
            },
            /**
     * return next match that has a token. Identical to the `lex()` API but does not invoke any of the 
     * `pre_lex()` nor any of the `post_lex()` callbacks.
     * 
     * @public
     * @this {RegExpLexer}
     */ fastLex: function lexer_fastLex() {
                var r;
                while(!r)r = this.next();
                return r;
            },
            /**
     * return info about the lexer state that can help a parser or other lexer API user to use the
     * most efficient means available. This API is provided to aid run-time performance for larger
     * systems which employ this lexer.
     * 
     * @public
     * @this {RegExpLexer}
     */ canIUse: function lexer_canIUse() {
                var rv = {
                    fastLex: !(typeof this.pre_lex === 'function' || typeof this.options.pre_lex === 'function' || this.yy && typeof this.yy.pre_lex === 'function' || this.yy && typeof this.yy.post_lex === 'function' || typeof this.options.post_lex === 'function' || typeof this.post_lex === 'function') && typeof this.fastLex === 'function'
                };
                return rv;
            },
            /**
     * backwards compatible alias for `pushState()`;
     * the latter is symmetrical with `popState()` and we advise to use
     * those APIs in any modern lexer code, rather than `begin()`.
     * 
     * @public
     * @this {RegExpLexer}
     */ begin: function lexer_begin(condition) {
                return this.pushState(condition);
            },
            /**
     * activates a new lexer condition state (pushes the new lexer
     * condition state onto the condition stack)
     * 
     * @public
     * @this {RegExpLexer}
     */ pushState: function lexer_pushState(condition) {
                this.conditionStack.push(condition);
                this.__currentRuleSet__ = null;
                return this;
            },
            /**
     * pop the previously active lexer condition state off the condition
     * stack
     * 
     * @public
     * @this {RegExpLexer}
     */ popState: function lexer_popState() {
                var n = this.conditionStack.length - 1;
                if (n > 0) {
                    this.__currentRuleSet__ = null;
                    return this.conditionStack.pop();
                } else return this.conditionStack[0];
            },
            /**
     * return the currently active lexer condition state; when an index
     * argument is provided it produces the N-th previous condition state,
     * if available
     * 
     * @public
     * @this {RegExpLexer}
     */ topState: function lexer_topState(n) {
                n = this.conditionStack.length - 1 - Math.abs(n || 0);
                if (n >= 0) return this.conditionStack[n];
                else return 'INITIAL';
            },
            /**
     * (internal) determine the lexer rule set which is active for the
     * currently active lexer condition state
     * 
     * @public
     * @this {RegExpLexer}
     */ _currentRules: function lexer__currentRules() {
                if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) return this.conditions[this.conditionStack[this.conditionStack.length - 1]];
                else return this.conditions['INITIAL'];
            },
            /**
     * return the number of states currently on the stack
     * 
     * @public
     * @this {RegExpLexer}
     */ stateStackSize: function lexer_stateStackSize() {
                return this.conditionStack.length;
            },
            options: {
                trackPosition: true
            },
            JisonLexerError: JisonLexerError,
            performAction: function lexer__performAction(yy, yyrulenumber, YY_START) {
                var yy_ = this;
                var YYSTATE = YY_START;
                switch(yyrulenumber){
                    case 1:
                        break;
                    default:
                        return this.simpleCaseActionClusters[yyrulenumber];
                }
            },
            simpleCaseActionClusters: {
                /*! Conditions:: INITIAL */ /*! Rule::       (--[0-9a-z-A-Z-]*) */ 0: 13,
                /*! Conditions:: INITIAL */ /*! Rule::       \* */ 2: 5,
                /*! Conditions:: INITIAL */ /*! Rule::       \/ */ 3: 6,
                /*! Conditions:: INITIAL */ /*! Rule::       \+ */ 4: 3,
                /*! Conditions:: INITIAL */ /*! Rule::       - */ 5: 4,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)px\b */ 6: 15,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)cm\b */ 7: 15,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)mm\b */ 8: 15,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)in\b */ 9: 15,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)pt\b */ 10: 15,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)pc\b */ 11: 15,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)deg\b */ 12: 16,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)grad\b */ 13: 16,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)rad\b */ 14: 16,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)turn\b */ 15: 16,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)s\b */ 16: 17,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)ms\b */ 17: 17,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)Hz\b */ 18: 18,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)kHz\b */ 19: 18,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)dpi\b */ 20: 19,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)dpcm\b */ 21: 19,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)dppx\b */ 22: 19,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)em\b */ 23: 20,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)ex\b */ 24: 21,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)ch\b */ 25: 22,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)rem\b */ 26: 23,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vw\b */ 27: 25,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vh\b */ 28: 24,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vmin\b */ 29: 26,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vmax\b */ 30: 27,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)% */ 31: 28,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)\b */ 32: 11,
                /*! Conditions:: INITIAL */ /*! Rule::       (calc) */ 33: 9,
                /*! Conditions:: INITIAL */ /*! Rule::       (var) */ 34: 12,
                /*! Conditions:: INITIAL */ /*! Rule::       ([a-z]+) */ 35: 10,
                /*! Conditions:: INITIAL */ /*! Rule::       \( */ 36: 7,
                /*! Conditions:: INITIAL */ /*! Rule::       \) */ 37: 8,
                /*! Conditions:: INITIAL */ /*! Rule::       , */ 38: 14,
                /*! Conditions:: INITIAL */ /*! Rule::       $ */ 39: 1
            },
            rules: [
                /*  0: */ /^(?:(--[\d\-A-Za-z]*))/,
                /*  1: */ /^(?:\s+)/,
                /*  2: */ /^(?:\*)/,
                /*  3: */ /^(?:\/)/,
                /*  4: */ /^(?:\+)/,
                /*  5: */ /^(?:-)/,
                /*  6: */ /^(?:(\d+(\.\d*)?|\.\d+)px\b)/,
                /*  7: */ /^(?:(\d+(\.\d*)?|\.\d+)cm\b)/,
                /*  8: */ /^(?:(\d+(\.\d*)?|\.\d+)mm\b)/,
                /*  9: */ /^(?:(\d+(\.\d*)?|\.\d+)in\b)/,
                /* 10: */ /^(?:(\d+(\.\d*)?|\.\d+)pt\b)/,
                /* 11: */ /^(?:(\d+(\.\d*)?|\.\d+)pc\b)/,
                /* 12: */ /^(?:(\d+(\.\d*)?|\.\d+)deg\b)/,
                /* 13: */ /^(?:(\d+(\.\d*)?|\.\d+)grad\b)/,
                /* 14: */ /^(?:(\d+(\.\d*)?|\.\d+)rad\b)/,
                /* 15: */ /^(?:(\d+(\.\d*)?|\.\d+)turn\b)/,
                /* 16: */ /^(?:(\d+(\.\d*)?|\.\d+)s\b)/,
                /* 17: */ /^(?:(\d+(\.\d*)?|\.\d+)ms\b)/,
                /* 18: */ /^(?:(\d+(\.\d*)?|\.\d+)Hz\b)/,
                /* 19: */ /^(?:(\d+(\.\d*)?|\.\d+)kHz\b)/,
                /* 20: */ /^(?:(\d+(\.\d*)?|\.\d+)dpi\b)/,
                /* 21: */ /^(?:(\d+(\.\d*)?|\.\d+)dpcm\b)/,
                /* 22: */ /^(?:(\d+(\.\d*)?|\.\d+)dppx\b)/,
                /* 23: */ /^(?:(\d+(\.\d*)?|\.\d+)em\b)/,
                /* 24: */ /^(?:(\d+(\.\d*)?|\.\d+)ex\b)/,
                /* 25: */ /^(?:(\d+(\.\d*)?|\.\d+)ch\b)/,
                /* 26: */ /^(?:(\d+(\.\d*)?|\.\d+)rem\b)/,
                /* 27: */ /^(?:(\d+(\.\d*)?|\.\d+)vw\b)/,
                /* 28: */ /^(?:(\d+(\.\d*)?|\.\d+)vh\b)/,
                /* 29: */ /^(?:(\d+(\.\d*)?|\.\d+)vmin\b)/,
                /* 30: */ /^(?:(\d+(\.\d*)?|\.\d+)vmax\b)/,
                /* 31: */ /^(?:(\d+(\.\d*)?|\.\d+)%)/,
                /* 32: */ /^(?:(\d+(\.\d*)?|\.\d+)\b)/,
                /* 33: */ /^(?:(calc))/,
                /* 34: */ /^(?:(var))/,
                /* 35: */ /^(?:([a-z]+))/,
                /* 36: */ /^(?:\()/,
                /* 37: */ /^(?:\))/,
                /* 38: */ /^(?:,)/,
                /* 39: */ /^(?:$)/
            ],
            conditions: {
                'INITIAL': {
                    rules: [
                        0,
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11,
                        12,
                        13,
                        14,
                        15,
                        16,
                        17,
                        18,
                        19,
                        20,
                        21,
                        22,
                        23,
                        24,
                        25,
                        26,
                        27,
                        28,
                        29,
                        30,
                        31,
                        32,
                        33,
                        34,
                        35,
                        36,
                        37,
                        38,
                        39
                    ],
                    inclusive: true
                }
            }
        };
        return lexer;
    }();
    parser.lexer = lexer;
    function Parser() {
        this.yy = {};
    }
    Parser.prototype = parser;
    parser.Parser = Parser;
    return new Parser();
}();
$a165840c76c6afe6$export$8f49e4af10703ce3 = $a165840c76c6afe6$var$parser;
$a165840c76c6afe6$export$7acfa6ed01010e37 = $a165840c76c6afe6$var$parser.Parser;
$a165840c76c6afe6$export$98e6a39c04603d36 = function() {
    return $a165840c76c6afe6$var$parser.parse.apply($a165840c76c6afe6$var$parser, arguments);
};

});

parcelRegister("8nBRK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.flip = $619dd81247578d79$var$flip;

var $bJf2Y = parcelRequire("bJf2Y");
var $619dd81247578d79$var$_convert2 = $619dd81247578d79$var$_interopRequireDefault($bJf2Y);
function $619dd81247578d79$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $619dd81247578d79$var$reduce(node, precision) {
    if (node.type === "MathExpression") return $619dd81247578d79$var$reduceMathExpression(node, precision);
    if (node.type === "Calc") return $619dd81247578d79$var$reduce(node.value, precision);
    return node;
}
function $619dd81247578d79$var$isEqual(left, right) {
    return left.type === right.type && left.value === right.value;
}
function $619dd81247578d79$var$isValueType(type) {
    switch(type){
        case 'LengthValue':
        case 'AngleValue':
        case 'TimeValue':
        case 'FrequencyValue':
        case 'ResolutionValue':
        case 'EmValue':
        case 'ExValue':
        case 'ChValue':
        case 'RemValue':
        case 'VhValue':
        case 'VwValue':
        case 'VminValue':
        case 'VmaxValue':
        case 'PercentageValue':
        case 'Value':
            return true;
    }
    return false;
}
function $619dd81247578d79$var$convertMathExpression(node, precision) {
    var nodes = (0, $619dd81247578d79$var$_convert2.default)(node.left, node.right, precision);
    var left = $619dd81247578d79$var$reduce(nodes.left, precision);
    var right = $619dd81247578d79$var$reduce(nodes.right, precision);
    if (left.type === "MathExpression" && right.type === "MathExpression") {
        if (left.operator === '/' && right.operator === '*' || left.operator === '-' && right.operator === '+' || left.operator === '*' && right.operator === '/' || left.operator === '+' && right.operator === '-') {
            if ($619dd81247578d79$var$isEqual(left.right, right.right)) nodes = (0, $619dd81247578d79$var$_convert2.default)(left.left, right.left, precision);
            else if ($619dd81247578d79$var$isEqual(left.right, right.left)) nodes = (0, $619dd81247578d79$var$_convert2.default)(left.left, right.right, precision);
            left = $619dd81247578d79$var$reduce(nodes.left, precision);
            right = $619dd81247578d79$var$reduce(nodes.right, precision);
        }
    }
    node.left = left;
    node.right = right;
    return node;
}
function $619dd81247578d79$var$flip(operator) {
    return operator === '+' ? '-' : '+';
}
function $619dd81247578d79$var$flipValue(node) {
    if ($619dd81247578d79$var$isValueType(node.type)) node.value = -node.value;
    else if (node.type == 'MathExpression') {
        node.left = $619dd81247578d79$var$flipValue(node.left);
        node.right = $619dd81247578d79$var$flipValue(node.right);
    }
    return node;
}
function $619dd81247578d79$var$reduceAddSubExpression(node, precision) {
    var _node = node, left = _node.left, right = _node.right, op = _node.operator;
    if (left.type === 'CssVariable' || right.type === 'CssVariable') return node;
    // something + 0 => something
    // something - 0 => something
    if (right.value === 0) return left;
    // 0 + something => something
    if (left.value === 0 && op === "+") return right;
    // 0 - something => -something
    if (left.value === 0 && op === "-") return $619dd81247578d79$var$flipValue(right);
    // value + value
    // value - value
    if (left.type === right.type && $619dd81247578d79$var$isValueType(left.type)) {
        node = Object.assign({}, left);
        if (op === "+") node.value = left.value + right.value;
        else node.value = left.value - right.value;
    }
    // value <op> (expr)
    if ($619dd81247578d79$var$isValueType(left.type) && (right.operator === '+' || right.operator === '-') && right.type === 'MathExpression') {
        // value + (value + something) => (value + value) + something
        // value + (value - something) => (value + value) - something
        // value - (value + something) => (value - value) - something
        // value - (value - something) => (value - value) + something
        if (left.type === right.left.type) {
            node = Object.assign({}, node);
            node.left = $619dd81247578d79$var$reduce({
                type: 'MathExpression',
                operator: op,
                left: left,
                right: right.left
            }, precision);
            node.right = right.right;
            node.operator = op === '-' ? $619dd81247578d79$var$flip(right.operator) : right.operator;
            return $619dd81247578d79$var$reduce(node, precision);
        } else if (left.type === right.right.type) {
            node = Object.assign({}, node);
            node.left = $619dd81247578d79$var$reduce({
                type: 'MathExpression',
                operator: op === '-' ? $619dd81247578d79$var$flip(right.operator) : right.operator,
                left: left,
                right: right.right
            }, precision);
            node.right = right.left;
            return $619dd81247578d79$var$reduce(node, precision);
        }
    }
    // (expr) <op> value
    if (left.type === 'MathExpression' && (left.operator === '+' || left.operator === '-') && $619dd81247578d79$var$isValueType(right.type)) {
        // (value + something) + value => (value + value) + something
        // (value - something) + value => (value + value) - something
        // (value + something) - value => (value - value) + something
        // (value - something) - value => (value - value) - something
        if (right.type === left.left.type) {
            node = Object.assign({}, left);
            node.left = $619dd81247578d79$var$reduce({
                type: 'MathExpression',
                operator: op,
                left: left.left,
                right: right
            }, precision);
            return $619dd81247578d79$var$reduce(node, precision);
        } else if (right.type === left.right.type) {
            node = Object.assign({}, left);
            if (left.operator === '-') {
                node.right = $619dd81247578d79$var$reduce({
                    type: 'MathExpression',
                    operator: op === '-' ? '+' : '-',
                    left: right,
                    right: left.right
                }, precision);
                node.operator = op === '-' ? '-' : '+';
            } else node.right = $619dd81247578d79$var$reduce({
                type: 'MathExpression',
                operator: op,
                left: left.right,
                right: right
            }, precision);
            if (node.right.value < 0) {
                node.right.value *= -1;
                node.operator = node.operator === '-' ? '+' : '-';
            }
            return $619dd81247578d79$var$reduce(node, precision);
        }
    }
    return node;
}
function $619dd81247578d79$var$reduceDivisionExpression(node, precision) {
    if (!$619dd81247578d79$var$isValueType(node.right.type)) return node;
    if (node.right.type !== 'Value') throw new Error("Cannot divide by \"" + node.right.unit + "\", number expected");
    if (node.right.value === 0) throw new Error('Cannot divide by zero');
    // (expr) / value
    if (node.left.type === 'MathExpression') {
        if ($619dd81247578d79$var$isValueType(node.left.left.type) && $619dd81247578d79$var$isValueType(node.left.right.type)) {
            node.left.left.value /= node.right.value;
            node.left.right.value /= node.right.value;
            return $619dd81247578d79$var$reduce(node.left, precision);
        }
        return node;
    } else if ($619dd81247578d79$var$isValueType(node.left.type)) {
        node.left.value /= node.right.value;
        return node.left;
    }
    return node;
}
function $619dd81247578d79$var$reduceMultiplicationExpression(node) {
    // (expr) * value
    if (node.left.type === 'MathExpression' && node.right.type === 'Value') {
        if ($619dd81247578d79$var$isValueType(node.left.left.type) && $619dd81247578d79$var$isValueType(node.left.right.type)) {
            node.left.left.value *= node.right.value;
            node.left.right.value *= node.right.value;
            return node.left;
        }
    } else if ($619dd81247578d79$var$isValueType(node.left.type) && node.right.type === 'Value') {
        node.left.value *= node.right.value;
        return node.left;
    } else if (node.left.type === 'Value' && node.right.type === 'MathExpression') {
        if ($619dd81247578d79$var$isValueType(node.right.left.type) && $619dd81247578d79$var$isValueType(node.right.right.type)) {
            node.right.left.value *= node.left.value;
            node.right.right.value *= node.left.value;
            return node.right;
        }
    } else if (node.left.type === 'Value' && $619dd81247578d79$var$isValueType(node.right.type)) {
        node.right.value *= node.left.value;
        return node.right;
    }
    return node;
}
function $619dd81247578d79$var$reduceMathExpression(node, precision) {
    node = $619dd81247578d79$var$convertMathExpression(node, precision);
    switch(node.operator){
        case "+":
        case "-":
            return $619dd81247578d79$var$reduceAddSubExpression(node, precision);
        case "/":
            return $619dd81247578d79$var$reduceDivisionExpression(node, precision);
        case "*":
            return $619dd81247578d79$var$reduceMultiplicationExpression(node);
    }
    return node;
}
module.exports.default = $619dd81247578d79$var$reduce;

});
parcelRegister("bJf2Y", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $e3WAX = parcelRequire("e3WAX");
var $889f91b7777ca440$var$_cssUnitConverter2 = $889f91b7777ca440$var$_interopRequireDefault($e3WAX);
function $889f91b7777ca440$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $889f91b7777ca440$var$convertNodes(left, right, precision) {
    switch(left.type){
        case 'LengthValue':
        case 'AngleValue':
        case 'TimeValue':
        case 'FrequencyValue':
        case 'ResolutionValue':
            return $889f91b7777ca440$var$convertAbsoluteLength(left, right, precision);
        default:
            return {
                left: left,
                right: right
            };
    }
}
function $889f91b7777ca440$var$convertAbsoluteLength(left, right, precision) {
    if (right.type === left.type) right = {
        type: left.type,
        value: (0, $889f91b7777ca440$var$_cssUnitConverter2.default)(right.value, right.unit, left.unit, precision),
        unit: left.unit
    };
    return {
        left: left,
        right: right
    };
}
module.exports.default = $889f91b7777ca440$var$convertNodes;
module.exports = module.exports['default'];

});
parcelRegister("e3WAX", function(module, exports) {
var $a3cecc42eafd4fde$var$conversions = {
    // length
    'px': {
        'px': 1,
        'cm': 96.0 / 2.54,
        'mm': 96.0 / 25.4,
        'in': 96,
        'pt': 96.0 / 72.0,
        'pc': 16
    },
    'cm': {
        'px': 2.54 / 96.0,
        'cm': 1,
        'mm': 0.1,
        'in': 2.54,
        'pt': 2.54 / 72.0,
        'pc': 2.54 / 6.0
    },
    'mm': {
        'px': 25.4 / 96.0,
        'cm': 10,
        'mm': 1,
        'in': 25.4,
        'pt': 25.4 / 72.0,
        'pc': 25.4 / 6.0
    },
    'in': {
        'px': 1.0 / 96.0,
        'cm': 1.0 / 2.54,
        'mm': 1.0 / 25.4,
        'in': 1,
        'pt': 1.0 / 72.0,
        'pc': 1.0 / 6.0
    },
    'pt': {
        'px': 0.75,
        'cm': 72.0 / 2.54,
        'mm': 72.0 / 25.4,
        'in': 72,
        'pt': 1,
        'pc': 12
    },
    'pc': {
        'px': 0.0625,
        'cm': 6.0 / 2.54,
        'mm': 6.0 / 25.4,
        'in': 6,
        'pt': 6.0 / 72.0,
        'pc': 1
    },
    // angle
    'deg': {
        'deg': 1,
        'grad': 0.9,
        'rad': 180 / Math.PI,
        'turn': 360
    },
    'grad': {
        'deg': 400 / 360,
        'grad': 1,
        'rad': 200 / Math.PI,
        'turn': 400
    },
    'rad': {
        'deg': Math.PI / 180,
        'grad': Math.PI / 200,
        'rad': 1,
        'turn': Math.PI * 2
    },
    'turn': {
        'deg': 1 / 360,
        'grad': 1 / 400,
        'rad': 0.5 / Math.PI,
        'turn': 1
    },
    // time
    's': {
        's': 1,
        'ms': 0.001
    },
    'ms': {
        's': 1000,
        'ms': 1
    },
    // frequency
    'Hz': {
        'Hz': 1,
        'kHz': 1000
    },
    'kHz': {
        'Hz': 0.001,
        'kHz': 1
    },
    // resolution
    'dpi': {
        'dpi': 1,
        'dpcm': 1.0 / 2.54,
        'dppx': 1 / 96
    },
    'dpcm': {
        'dpi': 2.54,
        'dpcm': 1,
        'dppx': 2.54 / 96.0
    },
    'dppx': {
        'dpi': 96,
        'dpcm': 96.0 / 2.54,
        'dppx': 1
    }
};
module.exports = function(value, sourceUnit, targetUnit, precision) {
    if (!$a3cecc42eafd4fde$var$conversions.hasOwnProperty(targetUnit)) throw new Error("Cannot convert to " + targetUnit);
    if (!$a3cecc42eafd4fde$var$conversions[targetUnit].hasOwnProperty(sourceUnit)) throw new Error("Cannot convert from " + sourceUnit + " to " + targetUnit);
    precision = Math.pow(10, parseInt(precision) || 5);
    return Math.round($a3cecc42eafd4fde$var$conversions[targetUnit][sourceUnit] * value * precision) / precision;
};

});



parcelRegister("hYnJW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = function(calc, node, precision) {
    var str = $d15a748316f7199c$var$stringify(node, precision);
    if (node.type === "MathExpression") // if calc expression couldn't be resolved to a single value, re-wrap it as
    // a calc()
    str = calc + "(" + str + ")";
    return str;
};

var $8nBRK = parcelRequire("8nBRK");
var $d15a748316f7199c$var$order = {
    "*": 0,
    "/": 0,
    "+": 1,
    "-": 1
};
function $d15a748316f7199c$var$round(value, prec) {
    if (prec !== false) {
        var precision = Math.pow(10, prec);
        return Math.round(value * precision) / precision;
    }
    return value;
}
function $d15a748316f7199c$var$stringify(node, prec) {
    switch(node.type){
        case "MathExpression":
            var left = node.left, right = node.right, op = node.operator;
            var str = "";
            if (left.type === 'MathExpression' && $d15a748316f7199c$var$order[op] < $d15a748316f7199c$var$order[left.operator]) str += "(" + $d15a748316f7199c$var$stringify(left, prec) + ")";
            else str += $d15a748316f7199c$var$stringify(left, prec);
            str += " " + node.operator + " ";
            if (right.type === 'MathExpression' && $d15a748316f7199c$var$order[op] < $d15a748316f7199c$var$order[right.operator]) str += "(" + $d15a748316f7199c$var$stringify(right, prec) + ")";
            else if (right.type === 'MathExpression' && op === "-" && [
                "+",
                "-"
            ].includes(right.operator)) {
                // fix #52 : a-(b+c) = a-b-c
                right.operator = (0, $8nBRK.flip)(right.operator);
                str += $d15a748316f7199c$var$stringify(right, prec);
            } else str += $d15a748316f7199c$var$stringify(right, prec);
            return str;
        case "Value":
            return $d15a748316f7199c$var$round(node.value, prec);
        case 'CssVariable':
            if (node.fallback) return "var(" + node.value + ", " + $d15a748316f7199c$var$stringify(node.fallback, prec, true) + ")";
            return "var(" + node.value + ")";
        case 'Calc':
            if (node.prefix) return "-" + node.prefix + "-calc(" + $d15a748316f7199c$var$stringify(node.value, prec) + ")";
            return "calc(" + $d15a748316f7199c$var$stringify(node.value, prec) + ")";
        default:
            return $d15a748316f7199c$var$round(node.value, prec) + node.unit;
    }
}
module.exports = module.exports["default"];

});


parcelRegister("hRG4n", function(module, exports) {

$parcel$export(module.exports, "default", () => $d018050ac926ff2a$export$2e2bcd8739ae039);
// import memoize from 'lodash/memoize';
const $d018050ac926ff2a$var$MEASUREMENT_ELEMENT_ID = '__react_svg_text_measurement_id';
function $d018050ac926ff2a$export$2e2bcd8739ae039(str, style) {
    try {
        // Calculate length of each word to be used to determine number of words per line
        let textEl = document.getElementById($d018050ac926ff2a$var$MEASUREMENT_ELEMENT_ID);
        if (!textEl) {
            const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            svg.setAttribute('aria-hidden', 'true');
            svg.style.width = '0';
            svg.style.height = '0';
            svg.style.position = 'absolute';
            svg.style.top = '-100%';
            svg.style.left = '-100%';
            textEl = document.createElementNS('http://www.w3.org/2000/svg', 'text');
            textEl.setAttribute('id', $d018050ac926ff2a$var$MEASUREMENT_ELEMENT_ID);
            svg.appendChild(textEl);
            document.body.appendChild(svg);
        }
        Object.assign(textEl.style, style);
        textEl.textContent = str;
        return textEl.getComputedTextLength();
    } catch (e) {
        return null;
    }
} // TODO: Implement without lodash
 // export default memoize(getStringWidth, (str, style) => `${str}_${JSON.stringify(style)}`);

});




parcelRegister("dFdp9", function(module, exports) {

$parcel$export(module.exports, "DonutMarkLabels", () => $9f298093bfc25e3c$export$1d7ea9ddbe30b32);

var $8OBna = parcelRequire("8OBna");

var $1xLej = parcelRequire("1xLej");

var $k2cKq = parcelRequire("k2cKq");

var $2OMIu = parcelRequire("2OMIu");
const $9f298093bfc25e3c$export$1d7ea9ddbe30b32 = (0, $1xLej.element)(function DonutMarkLabels(_ref) {
    let { arcs: arcs, hide: hide } = _ref;
    if (hide) return null;
    const arcPath = (0, $8OBna.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: arcs.map((arc)=>{
            const arcCentroid = arcPath.centroid({
                innerRadius: arc.innerRadius,
                outerRadius: arc.outerRadius,
                startAngle: arc.startAngle,
                endAngle: arc.endAngle
            });
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k2cKq.ValueLabel), {
                x: arcCentroid[0],
                y: arcCentroid[1],
                color: arc.fill,
                children: arc.value
            }, `stack-label-${arc.key}`);
        })
    });
});

});
parcelRegister("k2cKq", function(module, exports) {

$parcel$export(module.exports, "ValueLabel", () => $e95de202321265c6$export$d0e17caf98739ceb);
/* label.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $bwpsq = parcelRequire("bwpsq");

var $1xLej = parcelRequire("1xLej");

var $5rJQH = parcelRequire("5rJQH");

var $lCjFE = parcelRequire("lCjFE");

var $lASMz = parcelRequire("lASMz");

var $2OMIu = parcelRequire("2OMIu");
const $e95de202321265c6$var$labelTextStyles = null;
function $e95de202321265c6$var$ValueLabel(_ref) {
    let { x: x, y: y, color: color, formatter: formatter = (0, $lCjFE.default).formatNumberAbbreviated, children: children } = _ref;
    if (!children) return null;
    if (typeof children === 'number' || typeof children === 'string') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5rJQH.default), {
        x: x,
        y: y,
        style: {
            fill: (0, $lASMz.getMaxContrast)(color)
        },
        verticalAnchor: "middle",
        alignmentBaseline: "central",
        className: (0, $bwpsq.default)([
            "_1fjgnkob _ect41wi2 _1wyb1crf"
        ]),
        children: formatter(children)
    });
    return children;
}
const $e95de202321265c6$export$d0e17caf98739ceb = (0, $1xLej.element)($e95de202321265c6$var$ValueLabel);

});
parcelRegister("lASMz", function(module, exports) {

$parcel$export(module.exports, "getMaxContrast", () => $fb87746cb2f21746$export$499db937e3cd4eb2);

var $kTHGn = parcelRequire("kTHGn");

var $7UL8A = parcelRequire("7UL8A");
function $fb87746cb2f21746$var$getLuminance(_ref) {
    let { r: r, g: g, b: b } = _ref;
    const a = [
        r,
        g,
        b
    ].map((v)=>{
        v /= 255;
        return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
}
function $fb87746cb2f21746$var$getContrast(color1, color2) {
    const lum1 = $fb87746cb2f21746$var$getLuminance(color1) + 0.05;
    const lum2 = $fb87746cb2f21746$var$getLuminance(color2) + 0.05;
    return Math.max(lum1, lum2) / Math.min(lum1, lum2);
}
function $fb87746cb2f21746$var$getTokenAndFallback(cssVar) {
    // Extract the number from the CSS variable name
    const numberMatch = cssVar.match(/\d+/);
    const number = numberMatch ? numberMatch[0] : '';
    // Extract all terms following '--ds-' and before the number
    const termsMatch = cssVar.match(/--ds-(.+)-\d+/);
    const terms = termsMatch ? termsMatch[1].split('-') : [];
    // Extract the hexadecimal color from the CSS variable
    const hexColorMatch = cssVar.match(/#[0-9a-fA-F]{6}/);
    const hexColor = hexColorMatch ? hexColorMatch[0] : '';
    // Create the desired format by joining all extracted terms
    const token = `color.${terms.join('.') + '.' + number}`;
    return {
        token: token,
        fallback: hexColor
    };
}
function $fb87746cb2f21746$export$499db937e3cd4eb2(arcColor) {
    const isPattern = arcColor.includes('url');
    const { token: token, fallback: fallback } = $fb87746cb2f21746$var$getTokenAndFallback(arcColor);
    const colorHex = (0, $kTHGn.default)(token, fallback);
    const color = (0, $7UL8A.rgb)(arcColor.startsWith('var(') ? colorHex : arcColor);
    if (isPattern) return 'black';
    if (!color) return '';
    const blackContrast = $fb87746cb2f21746$var$getContrast(color, (0, $7UL8A.rgb)('black'));
    const whiteContrast = $fb87746cb2f21746$var$getContrast(color, (0, $7UL8A.rgb)('white'));
    if (whiteContrast >= 4.5) return 'white';
    if (blackContrast >= 4.5) return 'black';
    return 'white';
}

});
parcelRegister("7UL8A", function(module, exports) {

$parcel$export(module.exports, "Color", () => Color);
$parcel$export(module.exports, "darker", () => darker);
$parcel$export(module.exports, "brighter", () => brighter);
$parcel$export(module.exports, "default", () => color);
$parcel$export(module.exports, "hslConvert", () => hslConvert);
$parcel$export(module.exports, "Rgb", () => Rgb);
$parcel$export(module.exports, "rgbConvert", () => rgbConvert);
$parcel$export(module.exports, "rgb", () => rgb);
$parcel$export(module.exports, "hsl", () => hsl);

var $eeO9w = parcelRequire("eeO9w");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $eeO9w.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $eeO9w.default)(Rgb, rgb, (0, $eeO9w.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $eeO9w.default)(Hsl, hsl, (0, $eeO9w.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("eeO9w", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5d946be86aedd6a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extend", () => $a5d946be86aedd6a$export$8b58be045bf06082);
function $a5d946be86aedd6a$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $a5d946be86aedd6a$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});





parcelRegister("dwEoN", function(module, exports) {

$parcel$export(module.exports, "DonutMarks", () => $9d8d99e31a956a19$export$a717cf1f0d95f89e);

var $1xLej = parcelRequire("1xLej");

var $dZ3lg = parcelRequire("dZ3lg");

var $n8hTk = parcelRequire("n8hTk");

var $7poGd = parcelRequire("7poGd");

var $2OMIu = parcelRequire("2OMIu");
const $9d8d99e31a956a19$export$a717cf1f0d95f89e = (0, $1xLej.element)(function DonutMarks(_ref) {
    let { arcs: arcs, labelAccessor: labelAccessor } = _ref;
    const { getActiveMark: getActiveMark } = (0, $7poGd.useEventMark)({
        tooltip: (0, $n8hTk.donutChartEvents).tooltip,
        legend: (0, $n8hTk.donutChartEvents).legend,
        labelAccessor: labelAccessor
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: arcs.map((arc, i)=>{
            const activeMark = getActiveMark();
            const isActive = activeMark === labelAccessor(arc.data);
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dZ3lg.Arc), {
                ariaLabel: arc.ariaLabel,
                datum: arc.data,
                innerRadius: arc.innerRadius,
                outerRadius: isActive ? arc.outerRadius + arc.outerRadius * 0.03 : arc.outerRadius,
                opacity: !activeMark || isActive ? 1 : 0.4,
                startAngle: arc.startAngle,
                endAngle: arc.endAngle,
                padAngle: arc.padAngle,
                fill: arc.fill,
                transition: `opacity .3s, d .3s`
            }, `Stack-${arc.key}-${i}`);
        })
    });
});

});
parcelRegister("7poGd", function(module, exports) {

$parcel$export(module.exports, "useEventMark", () => $564e03194b2f603c$export$ed8317a0a2c494ec);

var $5uXOq = parcelRequire("5uXOq");

var $3pncq = parcelRequire("3pncq");
function $564e03194b2f603c$export$ed8317a0a2c494ec(_ref) {
    let { tooltip: tooltip, legend: legend, labelAccessor: labelAccessor } = _ref;
    // Hook to manage active tooltip state and compute opacity based on hover events.
    const [active, setActive] = (0, $5uXOq.useState)();
    if (tooltip) // Listen to tooltip events to update active state for hovered arc.
    (0, $3pncq.useChartEvents)(tooltip, [
        'pointerout',
        'pointermove'
    ], (d)=>{
        var _d$eventData, _d$eventData2;
        setActive({
            label: ((_d$eventData = d.eventData) === null || _d$eventData === void 0 ? void 0 : _d$eventData.distance) === 0 ? labelAccessor((_d$eventData2 = d.eventData) === null || _d$eventData2 === void 0 ? void 0 : _d$eventData2.datum) : undefined
        });
    });
    // Listen to legend events to update active state for hovered legend item.
    (0, $3pncq.useChartEvents)(legend, (d)=>{
        setActive({
            label: d.eventData
        });
    });
    // Determine opacity for a given arc based on the active tooltip state.
    const getActiveMark = ()=>{
        return active === null || active === void 0 ? void 0 : active.label;
    };
    return {
        getActiveMark: getActiveMark
    };
}

});


parcelRegister("8Yq1M", function(module, exports) {

$parcel$export(module.exports, "DonutScalesElement", () => $68881de45079d03f$export$2fe94717b0d39350);

var $5uXOq = parcelRequire("5uXOq");

var $gXw8D = parcelRequire("gXw8D");

var $1xLej = parcelRequire("1xLej");
var $9ZuYc = parcelRequire("9ZuYc");

var $kmv5v = parcelRequire("kmv5v");

var $gUvRg = parcelRequire("gUvRg");
const $68881de45079d03f$export$2fe94717b0d39350 = (0, $1xLej.element)((_ref)=>{
    let { data: data, colorAccessor: colorAccessor, valueAccessor: valueAccessor, sort: sort, children: children } = _ref;
    const { fillStyles: fillStyles, enableDefaultPatterns: enableDefaultPatterns, useThemeFillStyles: useThemeFillStyles } = (0, $9ZuYc.useElementProps)((0, $gXw8D.default).elements.Theme);
    const value = (0, $5uXOq.useMemo)(()=>{
        const sortedData = sort === 'none' ? data : [
            ...data
        ].sort((a, b)=>{
            const valueA = valueAccessor(a);
            const valueB = valueAccessor(b);
            if (valueA === valueB) return 0;
            const comparison = valueA > valueB ? 1 : -1;
            return sort === 'desc' ? -comparison : comparison;
        });
        const { domain: domain, range: range } = useThemeFillStyles({
            fillStyles: enableDefaultPatterns ? (0, $gUvRg.DEFAULT_ORDINAL_PATTERNS) : fillStyles
        });
        const colorScale = (0, $kmv5v.default)({
            domain: domain ? domain : sortedData.map(colorAccessor),
            range: range
        });
        return {
            colorScale: colorScale,
            data: sortedData
        };
    }, [
        data,
        colorAccessor,
        valueAccessor,
        fillStyles,
        enableDefaultPatterns
    ]);
    return children(value);
});

});
parcelRegister("kmv5v", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed2dfa167e8d85b0$export$2e2bcd8739ae039);

var $8idDz = parcelRequire("8idDz");

var $43Qz9 = parcelRequire("43Qz9");
const $ed2dfa167e8d85b0$export$6c7fd0f60d1828d8 = (0, $43Qz9.default)('domain', 'range', 'reverse', 'unknown');
function $ed2dfa167e8d85b0$export$2e2bcd8739ae039(config) {
    return $ed2dfa167e8d85b0$export$6c7fd0f60d1828d8((0, $8idDz.default)(), config);
}

});
parcelRegister("8idDz", function(module, exports) {

$parcel$export(module.exports, "implicit", () => $609a953a3e88158e$export$e4f898ab14d9d460);
$parcel$export(module.exports, "default", () => $609a953a3e88158e$export$2e2bcd8739ae039);

var $ifNm6 = parcelRequire("ifNm6");

var $l4Hc4 = parcelRequire("l4Hc4");
const $609a953a3e88158e$export$e4f898ab14d9d460 = Symbol("implicit");
function $609a953a3e88158e$export$2e2bcd8739ae039() {
    var index = new (0, $ifNm6.InternMap)(), domain = [], range = [], unknown = $609a953a3e88158e$export$e4f898ab14d9d460;
    function scale(d) {
        let i = index.get(d);
        if (i === undefined) {
            if (unknown !== $609a953a3e88158e$export$e4f898ab14d9d460) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new (0, $ifNm6.InternMap)();
        for (const value of _){
            if (index.has(value)) continue;
            index.set(value, domain.push(value) - 1);
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $609a953a3e88158e$export$2e2bcd8739ae039(domain, range).unknown(unknown);
    };
    (0, $l4Hc4.initRange).apply(scale, arguments);
    return scale;
}

});
parcelRegister("ifNm6", function(module, exports) {

$parcel$export(module.exports, "InternMap", () => $d49fe9b4e774f532$export$dcc6fb7d82b5bc7b);
$parcel$export(module.exports, "InternSet", () => $d49fe9b4e774f532$export$55278c3294239828);
class $d49fe9b4e774f532$export$dcc6fb7d82b5bc7b extends Map {
    constructor(entries, key = $d49fe9b4e774f532$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
    get(key) {
        return super.get($d49fe9b4e774f532$var$intern_get(this, key));
    }
    has(key) {
        return super.has($d49fe9b4e774f532$var$intern_get(this, key));
    }
    set(key, value) {
        return super.set($d49fe9b4e774f532$var$intern_set(this, key), value);
    }
    delete(key) {
        return super.delete($d49fe9b4e774f532$var$intern_delete(this, key));
    }
}
class $d49fe9b4e774f532$export$55278c3294239828 extends Set {
    constructor(values, key = $d49fe9b4e774f532$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
    has(value) {
        return super.has($d49fe9b4e774f532$var$intern_get(this, value));
    }
    add(value) {
        return super.add($d49fe9b4e774f532$var$intern_set(this, value));
    }
    delete(value) {
        return super.delete($d49fe9b4e774f532$var$intern_delete(this, value));
    }
}
function $d49fe9b4e774f532$var$intern_get({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function $d49fe9b4e774f532$var$intern_set({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function $d49fe9b4e774f532$var$intern_delete({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(key);
        _intern.delete(key);
    }
    return value;
}
function $d49fe9b4e774f532$var$keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});

parcelRegister("l4Hc4", function(module, exports) {

$parcel$export(module.exports, "initRange", () => $f57b7a0f29a58702$export$23c7bb9e6558da2a);
$parcel$export(module.exports, "initInterpolator", () => $f57b7a0f29a58702$export$7d6b419e59e83f3d);
function $f57b7a0f29a58702$export$23c7bb9e6558da2a(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $f57b7a0f29a58702$export$7d6b419e59e83f3d(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}

});


parcelRegister("43Qz9", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f5037bd137aac66$export$2e2bcd8739ae039);

var $7GYRE = parcelRequire("7GYRE");

var $l05O2 = parcelRequire("l05O2");

var $7LsZ0 = parcelRequire("7LsZ0");

var $hke6x = parcelRequire("hke6x");

var $3ceyM = parcelRequire("3ceyM");

var $32PlF = parcelRequire("32PlF");

var $4B7Iu = parcelRequire("4B7Iu");

var $hkMz3 = parcelRequire("hkMz3");

var $9Qnao = parcelRequire("9Qnao");

var $5Tjo7 = parcelRequire("5Tjo7");

var $7ayMb = parcelRequire("7ayMb");

var $l1zuV = parcelRequire("l1zuV");

var $jh40H = parcelRequire("jh40H");

var $cRABE = parcelRequire("cRABE");
const $2f5037bd137aac66$export$5f274da11658f617 = [
    // domain => nice => zero
    'domain',
    'nice',
    'zero',
    // interpolate before round
    'interpolate',
    'round',
    // set range then reverse
    'range',
    'reverse',
    // Order does not matter for these operators
    'align',
    'base',
    'clamp',
    'constant',
    'exponent',
    'padding',
    'unknown'
];
// Use Record to enforce that all keys in OperatorType must exist.
const $2f5037bd137aac66$var$operators = {
    domain: $3ceyM.default,
    nice: $hkMz3.default,
    zero: $cRABE.default,
    interpolate: $4B7Iu.default,
    round: $l1zuV.default,
    align: $7GYRE.default,
    base: $l05O2.default,
    clamp: $7LsZ0.default,
    constant: $hke6x.default,
    exponent: $32PlF.default,
    padding: $9Qnao.default,
    range: $5Tjo7.default,
    reverse: $7ayMb.default,
    unknown: $jh40H.default
};
function $2f5037bd137aac66$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, ops = new Array(_len), _key = 0; _key < _len; _key++)ops[_key] = arguments[_key];
    const selection = new Set(ops);
    const selectedOps = $2f5037bd137aac66$export$5f274da11658f617.filter((o)=>selection.has(o));
    return function applyOperators(scale, config) {
        if (typeof config !== 'undefined') selectedOps.forEach((op)=>{
            $2f5037bd137aac66$var$operators[op](scale, config);
        });
        return scale;
    };
}

});
parcelRegister("7GYRE", function(module, exports) {

$parcel$export(module.exports, "default", () => $599bab0e1c824f05$export$2e2bcd8739ae039);
function $599bab0e1c824f05$export$2e2bcd8739ae039(scale, config) {
    if ('align' in scale && 'align' in config && typeof config.align !== 'undefined') scale.align(config.align);
}

});

parcelRegister("l05O2", function(module, exports) {

$parcel$export(module.exports, "default", () => $f49e1a091ed7e264$export$2e2bcd8739ae039);
function $f49e1a091ed7e264$export$2e2bcd8739ae039(scale, config) {
    if ('base' in scale && 'base' in config && typeof config.base !== 'undefined') scale.base(config.base);
}

});

parcelRegister("7LsZ0", function(module, exports) {

$parcel$export(module.exports, "default", () => $01757969c5b305b9$export$2e2bcd8739ae039);
function $01757969c5b305b9$export$2e2bcd8739ae039(scale, config) {
    if ('clamp' in scale && 'clamp' in config && typeof config.clamp !== 'undefined') scale.clamp(config.clamp);
}

});

parcelRegister("hke6x", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9cf3ec8fbd68e18$export$2e2bcd8739ae039);
function $c9cf3ec8fbd68e18$export$2e2bcd8739ae039(scale, config) {
    if ('constant' in scale && 'constant' in config && typeof config.constant !== 'undefined') scale.constant(config.constant);
}

});

parcelRegister("3ceyM", function(module, exports) {

$parcel$export(module.exports, "default", () => $253dc96173c89eca$export$2e2bcd8739ae039);
function $253dc96173c89eca$export$2e2bcd8739ae039(scale, config) {
    if (config.domain) {
        if ('nice' in scale || 'quantiles' in scale) // continuous input scales
        scale.domain(config.domain);
        else if ('padding' in scale) // point and band scales
        scale.domain(config.domain);
        else // ordinal and threshold scale
        scale.domain(config.domain);
    }
}

});

parcelRegister("32PlF", function(module, exports) {

$parcel$export(module.exports, "default", () => $237963c1785dbf22$export$2e2bcd8739ae039);
function $237963c1785dbf22$export$2e2bcd8739ae039(scale, config) {
    if ('exponent' in scale && 'exponent' in config && typeof config.exponent !== 'undefined') scale.exponent(config.exponent);
}

});

parcelRegister("4B7Iu", function(module, exports) {

$parcel$export(module.exports, "default", () => $35909a7efa93455b$export$2e2bcd8739ae039);

var $4vEbn = parcelRequire("4vEbn");
function $35909a7efa93455b$export$2e2bcd8739ae039(scale, config) {
    if ('interpolate' in config && 'interpolate' in scale && typeof config.interpolate !== 'undefined') {
        const interpolator = (0, $4vEbn.default)(config.interpolate);
        scale.interpolate(interpolator);
    }
}

});
parcelRegister("4vEbn", function(module, exports) {

$parcel$export(module.exports, "default", () => $34893a11689c5a4b$export$2e2bcd8739ae039);

var $bktzi = parcelRequire("bktzi");
var $45TwU = parcelRequire("45TwU");
var $9faDM = parcelRequire("9faDM");
var $fBRs6 = parcelRequire("fBRs6");
var $aG0QU = parcelRequire("aG0QU");
const $34893a11689c5a4b$var$interpolatorMap = {
    lab: (0, $fBRs6.default),
    hcl: (0, $45TwU.default),
    'hcl-long': (0, $45TwU.hclLong),
    hsl: (0, $9faDM.default),
    'hsl-long': (0, $9faDM.hslLong),
    cubehelix: (0, $bktzi.default),
    'cubehelix-long': (0, $bktzi.cubehelixLong),
    rgb: (0, $aG0QU.default)
};
function $34893a11689c5a4b$export$2e2bcd8739ae039(interpolate) {
    switch(interpolate){
        case 'lab':
        case 'hcl':
        case 'hcl-long':
        case 'hsl':
        case 'hsl-long':
        case 'cubehelix':
        case 'cubehelix-long':
        case 'rgb':
            return $34893a11689c5a4b$var$interpolatorMap[interpolate];
        default:
    }
    const { type: type, gamma: gamma } = interpolate;
    const interpolator = $34893a11689c5a4b$var$interpolatorMap[type];
    return typeof gamma === 'undefined' ? interpolator : interpolator.gamma(gamma);
}

});
parcelRegister("bktzi", function(module, exports) {

$parcel$export(module.exports, "default", () => $83f87f9993df75d4$export$2e2bcd8739ae039);
$parcel$export(module.exports, "cubehelixLong", () => $83f87f9993df75d4$export$934fa09ad474a1b4);

var $eKYlI = parcelRequire("eKYlI");

var $9fc6H = parcelRequire("9fc6H");
function $83f87f9993df75d4$var$cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, $eKYlI.default)(start)).h, (end = (0, $eKYlI.default)(end)).h), s = (0, $9fc6H.default)(start.s, end.s), l = (0, $9fc6H.default)(start.l, end.l), opacity = (0, $9fc6H.default)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
var $83f87f9993df75d4$export$2e2bcd8739ae039 = $83f87f9993df75d4$var$cubehelix((0, $9fc6H.hue));
var $83f87f9993df75d4$export$934fa09ad474a1b4 = $83f87f9993df75d4$var$cubehelix((0, $9fc6H.default));

});
parcelRegister("eKYlI", function(module, exports) {

$parcel$export(module.exports, "default", () => $abe42cac81644644$export$2e2bcd8739ae039);

var $eeO9w = parcelRequire("eeO9w");

var $7UL8A = parcelRequire("7UL8A");

var $fS7Ud = parcelRequire("fS7Ud");
var $abe42cac81644644$var$A = -0.14861, $abe42cac81644644$var$B = 1.78277, $abe42cac81644644$var$C = -0.29227, $abe42cac81644644$var$D = -0.90649, $abe42cac81644644$var$E = 1.97294, $abe42cac81644644$var$ED = $abe42cac81644644$var$E * $abe42cac81644644$var$D, $abe42cac81644644$var$EB = $abe42cac81644644$var$E * $abe42cac81644644$var$B, $abe42cac81644644$var$BC_DA = $abe42cac81644644$var$B * $abe42cac81644644$var$C - $abe42cac81644644$var$D * $abe42cac81644644$var$A;
function $abe42cac81644644$var$cubehelixConvert(o) {
    if (o instanceof $abe42cac81644644$export$57ed4bde61a1e2f2) return new $abe42cac81644644$export$57ed4bde61a1e2f2(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof (0, $7UL8A.Rgb))) o = (0, $7UL8A.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = ($abe42cac81644644$var$BC_DA * b + $abe42cac81644644$var$ED * r - $abe42cac81644644$var$EB * g) / ($abe42cac81644644$var$BC_DA + $abe42cac81644644$var$ED - $abe42cac81644644$var$EB), bl = b - l, k = ($abe42cac81644644$var$E * (g - l) - $abe42cac81644644$var$C * bl) / $abe42cac81644644$var$D, s = Math.sqrt(k * k + bl * bl) / ($abe42cac81644644$var$E * l * (1 - l)), h = s ? Math.atan2(k, bl) * (0, $fS7Ud.degrees) - 120 : NaN;
    return new $abe42cac81644644$export$57ed4bde61a1e2f2(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function $abe42cac81644644$export$2e2bcd8739ae039(h, s, l, opacity) {
    return arguments.length === 1 ? $abe42cac81644644$var$cubehelixConvert(h) : new $abe42cac81644644$export$57ed4bde61a1e2f2(h, s, l, opacity == null ? 1 : opacity);
}
function $abe42cac81644644$export$57ed4bde61a1e2f2(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $eeO9w.default)($abe42cac81644644$export$57ed4bde61a1e2f2, $abe42cac81644644$export$2e2bcd8739ae039, (0, $eeO9w.extend)((0, $7UL8A.Color), {
    brighter (k) {
        k = k == null ? (0, $7UL8A.brighter) : Math.pow((0, $7UL8A.brighter), k);
        return new $abe42cac81644644$export$57ed4bde61a1e2f2(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? (0, $7UL8A.darker) : Math.pow((0, $7UL8A.darker), k);
        return new $abe42cac81644644$export$57ed4bde61a1e2f2(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * (0, $fS7Ud.radians), l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new (0, $7UL8A.Rgb)(255 * (l + a * ($abe42cac81644644$var$A * cosh + $abe42cac81644644$var$B * sinh)), 255 * (l + a * ($abe42cac81644644$var$C * cosh + $abe42cac81644644$var$D * sinh)), 255 * (l + a * ($abe42cac81644644$var$E * cosh)), this.opacity);
    }
}));

});
parcelRegister("fS7Ud", function(module, exports) {

$parcel$export(module.exports, "radians", () => $b8e20817cb73101d$export$8449e153fbd325fc);
$parcel$export(module.exports, "degrees", () => $b8e20817cb73101d$export$41fc368e1a942b97);
const $b8e20817cb73101d$export$8449e153fbd325fc = Math.PI / 180;
const $b8e20817cb73101d$export$41fc368e1a942b97 = 180 / Math.PI;

});


parcelRegister("9fc6H", function(module, exports) {

$parcel$export(module.exports, "hue", () => $6baee7f5715a9c6b$export$97d7b0c7ddb78dcf);
$parcel$export(module.exports, "gamma", () => $6baee7f5715a9c6b$export$a7ebe8cc6aaf8d37);
$parcel$export(module.exports, "default", () => $6baee7f5715a9c6b$export$2e2bcd8739ae039);

var $28ku5 = parcelRequire("28ku5");
function $6baee7f5715a9c6b$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $6baee7f5715a9c6b$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $6baee7f5715a9c6b$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $6baee7f5715a9c6b$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $28ku5.default)(isNaN(a) ? b : a);
}
function $6baee7f5715a9c6b$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $6baee7f5715a9c6b$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $6baee7f5715a9c6b$var$exponential(a, b, y) : (0, $28ku5.default)(isNaN(a) ? b : a);
    };
}
function $6baee7f5715a9c6b$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $6baee7f5715a9c6b$var$linear(a, d) : (0, $28ku5.default)(isNaN(a) ? b : a);
}

});
parcelRegister("28ku5", function(module, exports) {

$parcel$export(module.exports, "default", () => $18dc37dae666c7d2$export$2e2bcd8739ae039);
var $18dc37dae666c7d2$export$2e2bcd8739ae039 = (x)=>()=>x;

});



parcelRegister("45TwU", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fb2b41fd8805549$export$2e2bcd8739ae039);
$parcel$export(module.exports, "hclLong", () => $2fb2b41fd8805549$export$5aaa50f7615f9b70);

var $40oml = parcelRequire("40oml");

var $9fc6H = parcelRequire("9fc6H");
function $2fb2b41fd8805549$var$hcl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $40oml.hcl)(start)).h, (end = (0, $40oml.hcl)(end)).h), c = (0, $9fc6H.default)(start.c, end.c), l = (0, $9fc6H.default)(start.l, end.l), opacity = (0, $9fc6H.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.c = c(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $2fb2b41fd8805549$export$2e2bcd8739ae039 = $2fb2b41fd8805549$var$hcl((0, $9fc6H.hue));
var $2fb2b41fd8805549$export$5aaa50f7615f9b70 = $2fb2b41fd8805549$var$hcl((0, $9fc6H.default));

});
parcelRegister("40oml", function(module, exports) {

$parcel$export(module.exports, "default", () => $2eaa0ec960060b67$export$2e2bcd8739ae039);
$parcel$export(module.exports, "hcl", () => $2eaa0ec960060b67$export$d0e870ba50062ff1);

var $eeO9w = parcelRequire("eeO9w");

var $7UL8A = parcelRequire("7UL8A");

var $fS7Ud = parcelRequire("fS7Ud");
// https://observablehq.com/@mbostock/lab-and-rgb
const $2eaa0ec960060b67$var$K = 18, $2eaa0ec960060b67$var$Xn = 0.96422, $2eaa0ec960060b67$var$Yn = 1, $2eaa0ec960060b67$var$Zn = 0.82521, $2eaa0ec960060b67$var$t0 = 4 / 29, $2eaa0ec960060b67$var$t1 = 6 / 29, $2eaa0ec960060b67$var$t2 = 3 * $2eaa0ec960060b67$var$t1 * $2eaa0ec960060b67$var$t1, $2eaa0ec960060b67$var$t3 = $2eaa0ec960060b67$var$t1 * $2eaa0ec960060b67$var$t1 * $2eaa0ec960060b67$var$t1;
function $2eaa0ec960060b67$var$labConvert(o) {
    if (o instanceof $2eaa0ec960060b67$export$f2722c70a60257f7) return new $2eaa0ec960060b67$export$f2722c70a60257f7(o.l, o.a, o.b, o.opacity);
    if (o instanceof $2eaa0ec960060b67$export$d9397e094a5fbb9a) return $2eaa0ec960060b67$var$hcl2lab(o);
    if (!(o instanceof (0, $7UL8A.Rgb))) o = (0, $7UL8A.rgbConvert)(o);
    var r = $2eaa0ec960060b67$var$rgb2lrgb(o.r), g = $2eaa0ec960060b67$var$rgb2lrgb(o.g), b = $2eaa0ec960060b67$var$rgb2lrgb(o.b), y = $2eaa0ec960060b67$var$xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / $2eaa0ec960060b67$var$Yn), x, z;
    if (r === g && g === b) x = z = y;
    else {
        x = $2eaa0ec960060b67$var$xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / $2eaa0ec960060b67$var$Xn);
        z = $2eaa0ec960060b67$var$xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / $2eaa0ec960060b67$var$Zn);
    }
    return new $2eaa0ec960060b67$export$f2722c70a60257f7(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function $2eaa0ec960060b67$export$3e2c219d3ab79d01(l, opacity) {
    return new $2eaa0ec960060b67$export$f2722c70a60257f7(l, 0, 0, opacity == null ? 1 : opacity);
}
function $2eaa0ec960060b67$export$2e2bcd8739ae039(l, a, b, opacity) {
    return arguments.length === 1 ? $2eaa0ec960060b67$var$labConvert(l) : new $2eaa0ec960060b67$export$f2722c70a60257f7(l, a, b, opacity == null ? 1 : opacity);
}
function $2eaa0ec960060b67$export$f2722c70a60257f7(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $eeO9w.default)($2eaa0ec960060b67$export$f2722c70a60257f7, $2eaa0ec960060b67$export$2e2bcd8739ae039, (0, $eeO9w.extend)((0, $7UL8A.Color), {
    brighter (k) {
        return new $2eaa0ec960060b67$export$f2722c70a60257f7(this.l + $2eaa0ec960060b67$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker (k) {
        return new $2eaa0ec960060b67$export$f2722c70a60257f7(this.l - $2eaa0ec960060b67$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb () {
        var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
        x = $2eaa0ec960060b67$var$Xn * $2eaa0ec960060b67$var$lab2xyz(x);
        y = $2eaa0ec960060b67$var$Yn * $2eaa0ec960060b67$var$lab2xyz(y);
        z = $2eaa0ec960060b67$var$Zn * $2eaa0ec960060b67$var$lab2xyz(z);
        return new (0, $7UL8A.Rgb)($2eaa0ec960060b67$var$lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), $2eaa0ec960060b67$var$lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), $2eaa0ec960060b67$var$lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
    }
}));
function $2eaa0ec960060b67$var$xyz2lab(t) {
    return t > $2eaa0ec960060b67$var$t3 ? Math.pow(t, 1 / 3) : t / $2eaa0ec960060b67$var$t2 + $2eaa0ec960060b67$var$t0;
}
function $2eaa0ec960060b67$var$lab2xyz(t) {
    return t > $2eaa0ec960060b67$var$t1 ? t * t * t : $2eaa0ec960060b67$var$t2 * (t - $2eaa0ec960060b67$var$t0);
}
function $2eaa0ec960060b67$var$lrgb2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function $2eaa0ec960060b67$var$rgb2lrgb(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function $2eaa0ec960060b67$var$hclConvert(o) {
    if (o instanceof $2eaa0ec960060b67$export$d9397e094a5fbb9a) return new $2eaa0ec960060b67$export$d9397e094a5fbb9a(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof $2eaa0ec960060b67$export$f2722c70a60257f7)) o = $2eaa0ec960060b67$var$labConvert(o);
    if (o.a === 0 && o.b === 0) return new $2eaa0ec960060b67$export$d9397e094a5fbb9a(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
    var h = Math.atan2(o.b, o.a) * (0, $fS7Ud.degrees);
    return new $2eaa0ec960060b67$export$d9397e094a5fbb9a(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function $2eaa0ec960060b67$export$5a21418738164530(l, c, h, opacity) {
    return arguments.length === 1 ? $2eaa0ec960060b67$var$hclConvert(l) : new $2eaa0ec960060b67$export$d9397e094a5fbb9a(h, c, l, opacity == null ? 1 : opacity);
}
function $2eaa0ec960060b67$export$d0e870ba50062ff1(h, c, l, opacity) {
    return arguments.length === 1 ? $2eaa0ec960060b67$var$hclConvert(h) : new $2eaa0ec960060b67$export$d9397e094a5fbb9a(h, c, l, opacity == null ? 1 : opacity);
}
function $2eaa0ec960060b67$export$d9397e094a5fbb9a(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
}
function $2eaa0ec960060b67$var$hcl2lab(o) {
    if (isNaN(o.h)) return new $2eaa0ec960060b67$export$f2722c70a60257f7(o.l, 0, 0, o.opacity);
    var h = o.h * (0, $fS7Ud.radians);
    return new $2eaa0ec960060b67$export$f2722c70a60257f7(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
(0, $eeO9w.default)($2eaa0ec960060b67$export$d9397e094a5fbb9a, $2eaa0ec960060b67$export$d0e870ba50062ff1, (0, $eeO9w.extend)((0, $7UL8A.Color), {
    brighter (k) {
        return new $2eaa0ec960060b67$export$d9397e094a5fbb9a(this.h, this.c, this.l + $2eaa0ec960060b67$var$K * (k == null ? 1 : k), this.opacity);
    },
    darker (k) {
        return new $2eaa0ec960060b67$export$d9397e094a5fbb9a(this.h, this.c, this.l - $2eaa0ec960060b67$var$K * (k == null ? 1 : k), this.opacity);
    },
    rgb () {
        return $2eaa0ec960060b67$var$hcl2lab(this).rgb();
    }
}));

});


parcelRegister("9faDM", function(module, exports) {

$parcel$export(module.exports, "default", () => $6badc4c070d16f58$export$2e2bcd8739ae039);
$parcel$export(module.exports, "hslLong", () => $6badc4c070d16f58$export$a2c535e270a59256);

var $7UL8A = parcelRequire("7UL8A");

var $9fc6H = parcelRequire("9fc6H");
function $6badc4c070d16f58$var$hsl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $7UL8A.hsl)(start)).h, (end = (0, $7UL8A.hsl)(end)).h), s = (0, $9fc6H.default)(start.s, end.s), l = (0, $9fc6H.default)(start.l, end.l), opacity = (0, $9fc6H.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.s = s(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $6badc4c070d16f58$export$2e2bcd8739ae039 = $6badc4c070d16f58$var$hsl((0, $9fc6H.hue));
var $6badc4c070d16f58$export$a2c535e270a59256 = $6badc4c070d16f58$var$hsl((0, $9fc6H.default));

});

parcelRegister("fBRs6", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5d3c63d13f1ba54$export$2e2bcd8739ae039);

var $40oml = parcelRequire("40oml");

var $9fc6H = parcelRequire("9fc6H");
function $b5d3c63d13f1ba54$export$2e2bcd8739ae039(start, end) {
    var l = (0, $9fc6H.default)((start = (0, $40oml.default)(start)).l, (end = (0, $40oml.default)(end)).l), a = (0, $9fc6H.default)(start.a, end.a), b = (0, $9fc6H.default)(start.b, end.b), opacity = (0, $9fc6H.default)(start.opacity, end.opacity);
    return function(t) {
        start.l = l(t);
        start.a = a(t);
        start.b = b(t);
        start.opacity = opacity(t);
        return start + "";
    };
}

});

parcelRegister("aG0QU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c5e7ce60195f842$export$2e2bcd8739ae039);
$parcel$export(module.exports, "rgbBasis", () => $7c5e7ce60195f842$export$2c0e28f2e2852d3f);
$parcel$export(module.exports, "rgbBasisClosed", () => $7c5e7ce60195f842$export$53d5214f625ccd4c);

var $7UL8A = parcelRequire("7UL8A");

var $IzpFC = parcelRequire("IzpFC");

var $jde0I = parcelRequire("jde0I");

var $9fc6H = parcelRequire("9fc6H");
var $7c5e7ce60195f842$export$2e2bcd8739ae039 = function rgbGamma(y) {
    var color = (0, $9fc6H.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, $7UL8A.rgb)(start)).r, (end = (0, $7UL8A.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $9fc6H.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $7c5e7ce60195f842$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $7UL8A.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $7c5e7ce60195f842$export$2c0e28f2e2852d3f = $7c5e7ce60195f842$var$rgbSpline((0, $IzpFC.default));
var $7c5e7ce60195f842$export$53d5214f625ccd4c = $7c5e7ce60195f842$var$rgbSpline((0, $jde0I.default));

});
parcelRegister("IzpFC", function(module, exports) {

$parcel$export(module.exports, "basis", () => $085f9477972cbd8b$export$4e41033bfeec1a4c);
$parcel$export(module.exports, "default", () => $085f9477972cbd8b$export$2e2bcd8739ae039);
function $085f9477972cbd8b$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $085f9477972cbd8b$export$2e2bcd8739ae039(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $085f9477972cbd8b$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("jde0I", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfca19696d8e5441$export$2e2bcd8739ae039);

var $IzpFC = parcelRequire("IzpFC");
function $dfca19696d8e5441$export$2e2bcd8739ae039(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $IzpFC.basis)((t - i / n) * n, v0, v1, v2, v3);
    };
}

});




parcelRegister("hkMz3", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9e9f9c99dbaa252$export$2e2bcd8739ae039);
parcelRequire("gsGNk");
var $cRW5v = parcelRequire("cRW5v");
var $kSdfl = parcelRequire("kSdfl");
var $7yDT1 = parcelRequire("7yDT1");
var $2jkSd = parcelRequire("2jkSd");
var $dayZI = parcelRequire("dayZI");
var $8vb39 = parcelRequire("8vb39");
var $idw3k = parcelRequire("idw3k");

var $h2d2u = parcelRequire("h2d2u");
const $c9e9f9c99dbaa252$var$localTimeIntervals = {
    day: (0, $cRW5v.timeDay),
    hour: (0, $kSdfl.timeHour),
    minute: (0, $7yDT1.timeMinute),
    month: (0, $2jkSd.timeMonth),
    second: (0, $dayZI.second),
    week: (0, $8vb39.timeSunday),
    year: (0, $idw3k.timeYear)
};
const $c9e9f9c99dbaa252$var$utcIntervals = {
    day: (0, $cRW5v.utcDay),
    hour: (0, $kSdfl.utcHour),
    minute: (0, $7yDT1.utcMinute),
    month: (0, $2jkSd.utcMonth),
    second: (0, $dayZI.second),
    week: (0, $8vb39.utcSunday),
    year: (0, $idw3k.utcYear)
};
function $c9e9f9c99dbaa252$export$2e2bcd8739ae039(scale, config) {
    if ('nice' in config && typeof config.nice !== 'undefined' && 'nice' in scale) {
        const { nice: nice } = config;
        if (typeof nice === 'boolean') {
            if (nice) scale.nice();
        } else if (typeof nice === 'number') scale.nice(nice);
        else {
            const timeScale = scale;
            const isUtc = (0, $h2d2u.default)(timeScale);
            if (typeof nice === 'string') timeScale.nice(isUtc ? $c9e9f9c99dbaa252$var$utcIntervals[nice] : $c9e9f9c99dbaa252$var$localTimeIntervals[nice]);
            else {
                const { interval: interval, step: step } = nice;
                const parsedInterval = (isUtc ? $c9e9f9c99dbaa252$var$utcIntervals[interval] : $c9e9f9c99dbaa252$var$localTimeIntervals[interval]).every(step);
                if (parsedInterval != null) timeScale.nice(parsedInterval);
            }
        }
    }
}

});
parcelRegister("gsGNk", function(module, exports) {

$parcel$export(module.exports, "utcMillisecond", () => (parcelRequire("co6MX")).millisecond);
$parcel$export(module.exports, "timeMillisecond", () => (parcelRequire("co6MX")).millisecond);
$parcel$export(module.exports, "utcSecond", () => (parcelRequire("dayZI")).second);
$parcel$export(module.exports, "timeSecond", () => (parcelRequire("dayZI")).second);
$parcel$export(module.exports, "timeMinute", () => (parcelRequire("7yDT1")).timeMinute);
$parcel$export(module.exports, "utcMinute", () => (parcelRequire("7yDT1")).utcMinute);
$parcel$export(module.exports, "timeHour", () => (parcelRequire("kSdfl")).timeHour);
$parcel$export(module.exports, "utcHour", () => (parcelRequire("kSdfl")).utcHour);
$parcel$export(module.exports, "timeDay", () => (parcelRequire("cRW5v")).timeDay);
$parcel$export(module.exports, "utcDay", () => (parcelRequire("cRW5v")).utcDay);
$parcel$export(module.exports, "unixDay", () => (parcelRequire("cRW5v")).unixDay);
$parcel$export(module.exports, "timeWeek", () => (parcelRequire("8vb39")).timeSunday);
$parcel$export(module.exports, "timeSunday", () => (parcelRequire("8vb39")).timeSunday);
$parcel$export(module.exports, "timeMonday", () => (parcelRequire("8vb39")).timeMonday);
$parcel$export(module.exports, "timeTuesday", () => (parcelRequire("8vb39")).timeTuesday);
$parcel$export(module.exports, "timeWednesday", () => (parcelRequire("8vb39")).timeWednesday);
$parcel$export(module.exports, "timeThursday", () => (parcelRequire("8vb39")).timeThursday);
$parcel$export(module.exports, "timeFriday", () => (parcelRequire("8vb39")).timeFriday);
$parcel$export(module.exports, "timeSaturday", () => (parcelRequire("8vb39")).timeSaturday);
$parcel$export(module.exports, "utcWeek", () => (parcelRequire("8vb39")).utcSunday);
$parcel$export(module.exports, "utcSunday", () => (parcelRequire("8vb39")).utcSunday);
$parcel$export(module.exports, "utcMonday", () => (parcelRequire("8vb39")).utcMonday);
$parcel$export(module.exports, "utcTuesday", () => (parcelRequire("8vb39")).utcTuesday);
$parcel$export(module.exports, "utcWednesday", () => (parcelRequire("8vb39")).utcWednesday);
$parcel$export(module.exports, "utcThursday", () => (parcelRequire("8vb39")).utcThursday);
$parcel$export(module.exports, "utcFriday", () => (parcelRequire("8vb39")).utcFriday);
$parcel$export(module.exports, "utcSaturday", () => (parcelRequire("8vb39")).utcSaturday);
$parcel$export(module.exports, "timeMonth", () => (parcelRequire("2jkSd")).timeMonth);
$parcel$export(module.exports, "utcMonth", () => (parcelRequire("2jkSd")).utcMonth);
$parcel$export(module.exports, "timeYear", () => (parcelRequire("idw3k")).timeYear);
$parcel$export(module.exports, "utcYear", () => (parcelRequire("idw3k")).utcYear);


var $co6MX = parcelRequire("co6MX");

var $dayZI = parcelRequire("dayZI");

var $7yDT1 = parcelRequire("7yDT1");

var $kSdfl = parcelRequire("kSdfl");

var $cRW5v = parcelRequire("cRW5v");

var $8vb39 = parcelRequire("8vb39");

var $2jkSd = parcelRequire("2jkSd");

var $idw3k = parcelRequire("idw3k");

var $dCu2z = parcelRequire("dCu2z");

});
parcelRegister("co6MX", function(module, exports) {

$parcel$export(module.exports, "millisecond", () => $904cfdfe660e697c$export$edc5e5cb87280477);

var $ecWlt = parcelRequire("ecWlt");
const $904cfdfe660e697c$export$edc5e5cb87280477 = (0, $ecWlt.timeInterval)(()=>{
// noop
}, (date, step)=>{
    date.setTime(+date + step);
}, (start, end)=>{
    return end - start;
});
// An optimized implementation for this simple case.
$904cfdfe660e697c$export$edc5e5cb87280477.every = (k)=>{
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $904cfdfe660e697c$export$edc5e5cb87280477;
    return (0, $ecWlt.timeInterval)((date)=>{
        date.setTime(Math.floor(date / k) * k);
    }, (date, step)=>{
        date.setTime(+date + step * k);
    }, (start, end)=>{
        return (end - start) / k;
    });
};
const $904cfdfe660e697c$export$9a27fac83d67afd3 = $904cfdfe660e697c$export$edc5e5cb87280477.range;

});

parcelRegister("dCu2z", function(module, exports) {

$parcel$export(module.exports, "utcTicks", () => $9ea6205f05c3bf94$export$826ba5ae907e9767);
$parcel$export(module.exports, "utcTickInterval", () => $9ea6205f05c3bf94$export$6262d8d056ea44c4);
$parcel$export(module.exports, "timeTicks", () => $9ea6205f05c3bf94$export$60c76498552d28a6);
$parcel$export(module.exports, "timeTickInterval", () => $9ea6205f05c3bf94$export$69511150134dd174);

var $88EGG = parcelRequire("88EGG");
var $80JJl = parcelRequire("80JJl");

var $fUrRw = parcelRequire("fUrRw");

var $co6MX = parcelRequire("co6MX");

var $dayZI = parcelRequire("dayZI");

var $7yDT1 = parcelRequire("7yDT1");

var $kSdfl = parcelRequire("kSdfl");

var $cRW5v = parcelRequire("cRW5v");

var $8vb39 = parcelRequire("8vb39");

var $2jkSd = parcelRequire("2jkSd");

var $idw3k = parcelRequire("idw3k");
function $9ea6205f05c3bf94$var$ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            (0, $dayZI.second),
            1,
            (0, $fUrRw.durationSecond)
        ],
        [
            (0, $dayZI.second),
            5,
            5 * (0, $fUrRw.durationSecond)
        ],
        [
            (0, $dayZI.second),
            15,
            15 * (0, $fUrRw.durationSecond)
        ],
        [
            (0, $dayZI.second),
            30,
            30 * (0, $fUrRw.durationSecond)
        ],
        [
            minute,
            1,
            (0, $fUrRw.durationMinute)
        ],
        [
            minute,
            5,
            5 * (0, $fUrRw.durationMinute)
        ],
        [
            minute,
            15,
            15 * (0, $fUrRw.durationMinute)
        ],
        [
            minute,
            30,
            30 * (0, $fUrRw.durationMinute)
        ],
        [
            hour,
            1,
            (0, $fUrRw.durationHour)
        ],
        [
            hour,
            3,
            3 * (0, $fUrRw.durationHour)
        ],
        [
            hour,
            6,
            6 * (0, $fUrRw.durationHour)
        ],
        [
            hour,
            12,
            12 * (0, $fUrRw.durationHour)
        ],
        [
            day,
            1,
            (0, $fUrRw.durationDay)
        ],
        [
            day,
            2,
            2 * (0, $fUrRw.durationDay)
        ],
        [
            week,
            1,
            (0, $fUrRw.durationWeek)
        ],
        [
            month,
            1,
            (0, $fUrRw.durationMonth)
        ],
        [
            month,
            3,
            3 * (0, $fUrRw.durationMonth)
        ],
        [
            year,
            1,
            (0, $fUrRw.durationYear)
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, $88EGG.default)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, $80JJl.tickStep)(start / (0, $fUrRw.durationYear), stop / (0, $fUrRw.durationYear), count));
        if (i === 0) return (0, $co6MX.millisecond).every(Math.max((0, $80JJl.tickStep)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [$9ea6205f05c3bf94$export$826ba5ae907e9767, $9ea6205f05c3bf94$export$6262d8d056ea44c4] = $9ea6205f05c3bf94$var$ticker((0, $idw3k.utcYear), (0, $2jkSd.utcMonth), (0, $8vb39.utcSunday), (0, $cRW5v.unixDay), (0, $kSdfl.utcHour), (0, $7yDT1.utcMinute));
const [$9ea6205f05c3bf94$export$60c76498552d28a6, $9ea6205f05c3bf94$export$69511150134dd174] = $9ea6205f05c3bf94$var$ticker((0, $idw3k.timeYear), (0, $2jkSd.timeMonth), (0, $8vb39.timeSunday), (0, $cRW5v.timeDay), (0, $kSdfl.timeHour), (0, $7yDT1.timeMinute));

});
parcelRegister("88EGG", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ecea1c7e6e17c2e$export$2e2bcd8739ae039);

var $9eRkP = parcelRequire("9eRkP");

var $jaL7t = parcelRequire("jaL7t");
function $5ecea1c7e6e17c2e$export$2e2bcd8739ae039(f) {
    let compare1, compare2, delta;
    // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = (0, $9eRkP.default);
        compare2 = (d, x)=>(0, $9eRkP.default)(f(d), x);
        delta = (d, x)=>f(d) - x;
    } else {
        compare1 = f === (0, $9eRkP.default) || f === (0, $jaL7t.default) ? f : $5ecea1c7e6e17c2e$var$zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x, lo = 0, hi = a.length) {
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function $5ecea1c7e6e17c2e$var$zero() {
    return 0;
}

});
parcelRegister("9eRkP", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b9ecb1327aa878a$export$2e2bcd8739ae039);
function $6b9ecb1327aa878a$export$2e2bcd8739ae039(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("jaL7t", function(module, exports) {

$parcel$export(module.exports, "default", () => $df538075a00c34cb$export$2e2bcd8739ae039);
function $df538075a00c34cb$export$2e2bcd8739ae039(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});


parcelRegister("80JJl", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d51cbe8842854f5$export$2e2bcd8739ae039);
$parcel$export(module.exports, "tickIncrement", () => $5d51cbe8842854f5$export$bc64d00cc98e7e95);
$parcel$export(module.exports, "tickStep", () => $5d51cbe8842854f5$export$81087d9b915d4ede);
const $5d51cbe8842854f5$var$e10 = Math.sqrt(50), $5d51cbe8842854f5$var$e5 = Math.sqrt(10), $5d51cbe8842854f5$var$e2 = Math.sqrt(2);
function $5d51cbe8842854f5$var$tickSpec(start, stop, count) {
    const step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log10(step)), error = step / Math.pow(10, power), factor = error >= $5d51cbe8842854f5$var$e10 ? 10 : error >= $5d51cbe8842854f5$var$e5 ? 5 : error >= $5d51cbe8842854f5$var$e2 ? 2 : 1;
    let i1, i2, inc;
    if (power < 0) {
        inc = Math.pow(10, -power) / factor;
        i1 = Math.round(start * inc);
        i2 = Math.round(stop * inc);
        if (i1 / inc < start) ++i1;
        if (i2 / inc > stop) --i2;
        inc = -inc;
    } else {
        inc = Math.pow(10, power) * factor;
        i1 = Math.round(start / inc);
        i2 = Math.round(stop / inc);
        if (i1 * inc < start) ++i1;
        if (i2 * inc > stop) --i2;
    }
    if (i2 < i1 && 0.5 <= count && count < 2) return $5d51cbe8842854f5$var$tickSpec(start, stop, count * 2);
    return [
        i1,
        i2,
        inc
    ];
}
function $5d51cbe8842854f5$export$2e2bcd8739ae039(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    if (!(count > 0)) return [];
    if (start === stop) return [
        start
    ];
    const reverse = stop < start, [i1, i2, inc] = reverse ? $5d51cbe8842854f5$var$tickSpec(stop, start, count) : $5d51cbe8842854f5$var$tickSpec(start, stop, count);
    if (!(i2 >= i1)) return [];
    const n = i2 - i1 + 1, ticks = new Array(n);
    if (reverse) {
        if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) / -inc;
        else for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) * inc;
    } else {
        if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) / -inc;
        else for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) * inc;
    }
    return ticks;
}
function $5d51cbe8842854f5$export$bc64d00cc98e7e95(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    return $5d51cbe8842854f5$var$tickSpec(start, stop, count)[2];
}
function $5d51cbe8842854f5$export$81087d9b915d4ede(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    const reverse = stop < start, inc = reverse ? $5d51cbe8842854f5$export$bc64d00cc98e7e95(stop, start, count) : $5d51cbe8842854f5$export$bc64d00cc98e7e95(start, stop, count);
    return (reverse ? -1 : 1) * (inc < 0 ? 1 / -inc : inc);
}

});



parcelRegister("h2d2u", function(module, exports) {

$parcel$export(module.exports, "default", () => $c66cbce40cd050e1$export$2e2bcd8739ae039);
const $c66cbce40cd050e1$var$TEST_TIME = new Date(Date.UTC(2020, 1, 2, 3, 4, 5));
const $c66cbce40cd050e1$var$TEST_FORMAT = '%Y-%m-%d %H:%M';
function $c66cbce40cd050e1$export$2e2bcd8739ae039(scale) {
    // The only difference between time and utc scale is
    // whether the tick format function is utcFormat or timeFormat
    const output = scale.tickFormat(1, $c66cbce40cd050e1$var$TEST_FORMAT)($c66cbce40cd050e1$var$TEST_TIME);
    return output === '2020-02-02 03:04';
}

});


parcelRegister("9Qnao", function(module, exports) {

$parcel$export(module.exports, "default", () => $72aaf0d19c6233a3$export$2e2bcd8739ae039);
function $72aaf0d19c6233a3$export$2e2bcd8739ae039(scale, config) {
    if ('padding' in scale && 'padding' in config && typeof config.padding !== 'undefined') scale.padding(config.padding);
    if ('paddingInner' in scale && 'paddingInner' in config && typeof config.paddingInner !== 'undefined') scale.paddingInner(config.paddingInner);
    if ('paddingOuter' in scale && 'paddingOuter' in config && typeof config.paddingOuter !== 'undefined') scale.paddingOuter(config.paddingOuter);
}

});

parcelRegister("5Tjo7", function(module, exports) {

$parcel$export(module.exports, "default", () => $44a120d973e435b7$export$2e2bcd8739ae039);
function $44a120d973e435b7$export$2e2bcd8739ae039(scale, config) {
    if (config.range) {
        if ('padding' in scale) // point and band scales
        scale.range(config.range);
        else // the rest
        scale.range(config.range);
    }
}

});

parcelRegister("7ayMb", function(module, exports) {

$parcel$export(module.exports, "default", () => $538471668cf337cd$export$2e2bcd8739ae039);
function $538471668cf337cd$export$2e2bcd8739ae039(scale, config) {
    if (config.reverse) {
        const reversedRange = scale.range().slice().reverse();
        if ('padding' in scale) // point and band scales
        scale.range(reversedRange);
        else // the rest
        scale.range(reversedRange);
    }
}

});

parcelRegister("l1zuV", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4e53a19703fcc0b$export$2e2bcd8739ae039);

var $8Masb = parcelRequire("8Masb");
function $f4e53a19703fcc0b$export$2e2bcd8739ae039(scale, config) {
    if ('round' in config && typeof config.round !== 'undefined') {
        if (config.round && 'interpolate' in config && typeof config.interpolate !== 'undefined') console.warn(`[visx/scale/applyRound] ignoring round: scale config contains round and interpolate. only applying interpolate. config:`, config);
        else if ('round' in scale) // for point and band scales
        scale.round(config.round);
        else if ('interpolate' in scale && config.round) // for continuous output scales
        // setting config.round = true
        // is actually setting interpolator to interpolateRound
        // as these scales do not have scale.round() function
        scale.interpolate((0, $8Masb.default));
    }
}

});
parcelRegister("8Masb", function(module, exports) {

$parcel$export(module.exports, "default", () => $663aea45c6d13a8b$export$2e2bcd8739ae039);
function $663aea45c6d13a8b$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}

});


parcelRegister("jh40H", function(module, exports) {

$parcel$export(module.exports, "default", () => $e082b73313513920$export$2e2bcd8739ae039);
function $e082b73313513920$export$2e2bcd8739ae039(scale, config) {
    if ('unknown' in scale && 'unknown' in config && typeof config.unknown !== 'undefined') scale.unknown(config.unknown);
}

});

parcelRegister("cRABE", function(module, exports) {

$parcel$export(module.exports, "default", () => $95d6d482ec8c2544$export$2e2bcd8739ae039);
function $95d6d482ec8c2544$export$2e2bcd8739ae039(scale, config) {
    if ('zero' in config && config.zero === true) {
        const domain = scale.domain();
        const [a, b] = domain;
        const isDescending = b < a;
        const [min, max] = isDescending ? [
            b,
            a
        ] : [
            a,
            b
        ];
        const domainWithZero = [
            Math.min(0, min),
            Math.max(0, max)
        ];
        scale.domain(isDescending ? domainWithZero.reverse() : domainWithZero);
    }
}

});




parcelRegister("8aZwB", function(module, exports) {

$parcel$export(module.exports, "DonutTooltipOverlay", () => $5f3efb7a4bd14f95$export$b33ac6556176a316);

var $5uXOq = parcelRequire("5uXOq");

var $1xLej = parcelRequire("1xLej");

var $dZ3lg = parcelRequire("dZ3lg");

var $xpxC7 = parcelRequire("xpxC7");

var $dYSV3 = parcelRequire("dYSV3");

var $3pncq = parcelRequire("3pncq");

var $2OMIu = parcelRequire("2OMIu");
const $5f3efb7a4bd14f95$export$b33ac6556176a316 = (0, $1xLej.element)(function DonutTooltipOverlay(_ref) {
    let { arcs: arcs, onClick: onClick } = _ref;
    const { showTooltip: showTooltip, hideTooltip: hideTooltip } = (0, $5uXOq.useContext)((0, $dYSV3.default));
    const { emit: emitMouseMove } = (0, $3pncq.useChartEvents)((0, $xpxC7.tooltipEvent), 'pointermove', showTooltip);
    const { emit: emitClick } = (0, $3pncq.useChartEvents)((0, $xpxC7.tooltipEvent), 'pointerdown', onClick);
    const { emit: emitOut } = (0, $3pncq.useChartEvents)((0, $xpxC7.tooltipEvent), 'pointerout', hideTooltip);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("g", {
        style: {
            cursor: onClick ? 'pointer' : 'default'
        },
        children: arcs.map((arc)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dZ3lg.Arc), {
                onPointerMove: (e)=>emitMouseMove(e, {
                        datum: arc.data,
                        distance: 0
                    }),
                onPointerOut: (e)=>emitOut(e, undefined),
                onPointerDown: (e)=>emitClick(e, {
                        datum: arc.data,
                        distance: 0
                    }),
                ariaLabel: `${arc.ariaLabel}-overlay`,
                "aria-hidden": true,
                outerRadius: arc.outerRadius,
                innerRadius: arc.innerRadius,
                startAngle: arc.startAngle,
                endAngle: arc.endAngle,
                padAngle: arc.padAngle,
                fill: 'transparent'
            }, `DonutStack-${arc.key}`))
    });
});

});

parcelRegister("6MKTx", function(module, exports) {

$parcel$export(module.exports, "PureDonutChart", () => $4f0b9a1741a5e453$export$d983777419d59151);

var $5uXOq = parcelRequire("5uXOq");

var $9ZuYc = parcelRequire("9ZuYc");

var $2OPEf = parcelRequire("2OPEf");

var $3fYJX = parcelRequire("3fYJX");

var $9ZCPf = parcelRequire("9ZCPf");

var $fO4qI = parcelRequire("fO4qI");

var $lFJ6b = parcelRequire("lFJ6b");

var $5LUa1 = parcelRequire("5LUa1");

var $gT017 = parcelRequire("gT017");

var $lbM48 = parcelRequire("lbM48");

var $c9FTW = parcelRequire("c9FTW");

var $kRW1r = parcelRequire("kRW1r");

var $19KuE = parcelRequire("19KuE");

var $2OMIu = parcelRequire("2OMIu");
function $4f0b9a1741a5e453$var$useAccessors(_ref) {
    let { valueAccessor: valueAccessor, labelAccessor: labelAccessor, colorAccessor: colorAccessor } = _ref;
    const [value, label, color] = (0, $5uXOq.useMemo)(()=>{
        const [v] = (0, $fO4qI.useSafeAccessors)(valueAccessor);
        const [l] = (0, $fO4qI.useSafeAccessors)(labelAccessor);
        const [c] = (0, $fO4qI.useSafeAccessors)(colorAccessor);
        return [
            v,
            l,
            c
        ];
    }, [
        valueAccessor,
        labelAccessor,
        colorAccessor
    ]);
    return {
        value: value,
        label: label,
        color: color
    };
}
function $4f0b9a1741a5e453$export$d983777419d59151(_ref2) {
    let { data: data, width: width, height: height, innerRadius: userInnerRadius, outerRadius: userOuterRadius, margin: margin = (0, $lFJ6b.DEFAULT_MARGIN), valueAccessor: valueAccessor, colorAccessor: colorAccessor, labelAccessor: labelAccessor, svgRef: svgRef } = _ref2;
    const layoutProps = (0, $9ZuYc.useElementProps)((0, $2OPEf.Layout));
    const { value: value, label: label, color: color } = $4f0b9a1741a5e453$var$useAccessors({
        valueAccessor: valueAccessor,
        labelAccessor: labelAccessor,
        colorAccessor: colorAccessor
    });
    // TODO: FIX THIS SO WE KNOW WHEN TO SHIFT PIE CHART OVER.
    // const layoutProps = useElementProps(Layout);
    // const sideBySide = !layoutProps.gridTemplate?.includes('legend');
    const plotHeight = Math.max(0, height - (margin.top + margin.bottom));
    const plotWidth = Math.max(0, width - (margin.left + margin.right));
    const outerRadius = userOuterRadius || Math.min(plotHeight || 0, plotWidth || 0) / 2;
    const innerRadius = userInnerRadius !== undefined ? userInnerRadius : outerRadius / 1.3;
    /* When height is not provided, the chart's height will be set to match its width */ const calculateHeight = layoutProps.height == null && layoutProps.width != null;
    const fixedHeight = calculateHeight ? `${plotWidth}px` : '100%';
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $19KuE.DonutDataProvider), {
        data: data,
        width: plotWidth,
        height: plotHeight,
        valueAccessor: value,
        labelAccessor: label,
        colorAccessor: color,
        margin: margin,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gT017.DonutLegend), {}),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3fYJX.default), {
                innerRef: svgRef,
                height: fixedHeight,
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $9ZCPf.default), {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lbM48.DonutPatterns), {}),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c9FTW.DonutStackSlot), {})
                    ]
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5LUa1.DataTable), {}),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kRW1r.DonutTooltip), {})
        ]
    });
}

});
parcelRegister("3fYJX", function(module, exports) {

$parcel$export(module.exports, "default", () => $25f1e3917ef986ed$export$2e2bcd8739ae039);
/* Plot.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $bwpsq = parcelRequire("bwpsq");

var $1xLej = parcelRequire("1xLej");

var $2OMIu = parcelRequire("2OMIu");
var $25f1e3917ef986ed$export$2e2bcd8739ae039 = (0, $1xLej.element)(function Plot(_ref) {
    let { top: top = 0, left: left = 0, width: width = '100%', height: height = '100%', transform: transform, children: children, innerRef: innerRef, ...restProps } = _ref;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
            ref: innerRef,
            width: width,
            height: height,
            transform: transform || `translate(${left}, ${top})`,
            ...restProps,
            className: (0, $bwpsq.default)([
                "_nd5lah6b _16jlkb7n _1ul9idpf _1tkeidpf _1reoewfl _18m9ewfl _1pbyidpf"
            ]),
            children: children
        })
    });
});

});

parcelRegister("fO4qI", function(module, exports) {

$parcel$export(module.exports, "useSafeAccessors", () => $b81ef6354b1c1aaa$export$1ff31c13ab3c61e1);
$parcel$export(module.exports, "getFirstItem", () => $b81ef6354b1c1aaa$export$fbdeaa6a76694f71);
$parcel$export(module.exports, "getSecondItem", () => $b81ef6354b1c1aaa$export$18f9732b2021233c);
function $b81ef6354b1c1aaa$export$227cf200245550ef(accessor) {
    if (typeof accessor === 'string') {
        function s(d) {
            try {
                return d[accessor];
            } catch  {
                return 0;
            }
        }
        return s;
    } else if (typeof accessor === 'number') {
        function s1(d) {
            try {
                return d[accessor];
            } catch  {
                return 0;
            }
        }
        return s1;
    }
    function s2(d) {
        try {
            return accessor instanceof Function ? accessor(d) : 0;
        } catch  {
            return 0;
        }
    }
    return s2;
}
function $b81ef6354b1c1aaa$export$1ff31c13ab3c61e1() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return args.map((d)=>$b81ef6354b1c1aaa$export$227cf200245550ef(d));
}
function $b81ef6354b1c1aaa$export$3a667a3b7e4d6701(l) {
    return typeof (l === null || l === void 0 ? void 0 : l.x) === 'number' ? l === null || l === void 0 ? void 0 : l.x : 0;
}
function $b81ef6354b1c1aaa$export$337238c011325465(l) {
    return typeof (l === null || l === void 0 ? void 0 : l.y) === 'number' ? l === null || l === void 0 ? void 0 : l.y : 0;
}
function $b81ef6354b1c1aaa$export$dd2b6e807fb37ba3(l) {
    return l === null || l === void 0 ? void 0 : l.source;
}
function $b81ef6354b1c1aaa$export$c22522a4dfa48e9c(l) {
    return l === null || l === void 0 ? void 0 : l.target;
}
function $b81ef6354b1c1aaa$export$fbdeaa6a76694f71(d) {
    return d === null || d === void 0 ? void 0 : d[0];
}
function $b81ef6354b1c1aaa$export$18f9732b2021233c(d) {
    return d === null || d === void 0 ? void 0 : d[1];
}

});

parcelRegister("5LUa1", function(module, exports) {

$parcel$export(module.exports, "DataTable", () => $433ce7e23219ab53$export$df30df7ec97b32b5);

var $5uXOq = parcelRequire("5uXOq");

var $dBbYh = parcelRequire("dBbYh");

var $19KuE = parcelRequire("19KuE");

var $2OMIu = parcelRequire("2OMIu");

const $433ce7e23219ab53$var$LazyDataTableModal = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>Promise.resolve((parcelRequire("4Yvz8"))).then((module)=>({
            default: module.DataTableModal
        })));
function $433ce7e23219ab53$export$df30df7ec97b32b5() {
    const { showDataTable: showDataTable, closeDataTable: closeDataTable } = (0, $dBbYh.useMenuData)();
    const { data: data } = (0, $19KuE.useDonutData)();
    return showDataTable ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
        fallback: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            style: {
                visibility: 'hidden'
            }
        }),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($433ce7e23219ab53$var$LazyDataTableModal, {
            data: data,
            closeModal: closeDataTable
        })
    }) : null;
}

});
parcelRegister("19KuE", function(module, exports) {

$parcel$export(module.exports, "DonutDataProvider", () => $0d7ab25958c047fa$export$201ee326cc161324);
$parcel$export(module.exports, "useDonutData", () => $0d7ab25958c047fa$export$570f964a43ebb08);

var $5uXOq = parcelRequire("5uXOq");

var $dBbYh = parcelRequire("dBbYh");

var $gUvRg = parcelRequire("gUvRg");

var $dPkIY = parcelRequire("dPkIY");

var $8Yq1M = parcelRequire("8Yq1M");

var $2OMIu = parcelRequire("2OMIu");
const $0d7ab25958c047fa$var$DataContext = /*#__PURE__*/ (0, $5uXOq.createContext)({});
function $0d7ab25958c047fa$export$201ee326cc161324(_ref) {
    let { children: children, ...props } = _ref;
    const { showPatterns: showPatterns } = (0, $dBbYh.useMenuData)();
    const fillStyles = (0, $dPkIY.useChartColors)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gUvRg.Theme), {
        fillStyles: fillStyles,
        enableDefaultPatterns: showPatterns,
        useThemeFillStyles: (0, $gUvRg.useThemeFillStyles),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Yq1M.DonutScalesElement), {
            ...props,
            sort: "asc",
            children: (scales)=>/*#__PURE__*/ (0, $2OMIu.jsx)($0d7ab25958c047fa$var$DataContext.Provider, {
                    value: {
                        ...props,
                        ...scales
                    },
                    children: children
                })
        })
    });
}
function $0d7ab25958c047fa$export$570f964a43ebb08() {
    return (0, $5uXOq.useContext)($0d7ab25958c047fa$var$DataContext);
}

});
parcelRegister("dPkIY", function(module, exports) {

$parcel$export(module.exports, "useChartColors", () => $a1101d36d76c4617$export$dfe353952a449cf6);

var $hxoiH = parcelRequire("hxoiH");

var $5uXOq = parcelRequire("5uXOq");

var $gUvRg = parcelRequire("gUvRg");
const $a1101d36d76c4617$export$dfe353952a449cf6 = ()=>{
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    const colors = (0, $5uXOq.useMemo)(()=>colorMode === 'dark' ? (0, $gUvRg.DARK_ORDINAL_COLORS) : (0, $gUvRg.LIGHT_ORDINAL_COLORS), [
        colorMode
    ]);
    return colors;
};

});



parcelRegister("gT017", function(module, exports) {

$parcel$export(module.exports, "DonutLegend", () => $c4b1cbcc910271de$export$bd81b761982512ab);

var $jogiL = parcelRequire("jogiL");

var $19KuE = parcelRequire("19KuE");

var $2OMIu = parcelRequire("2OMIu");
function $c4b1cbcc910271de$export$bd81b761982512ab() {
    const { data: data, colorAccessor: colorAccessor, labelAccessor: labelAccessor, colorScale: colorScale } = (0, $19KuE.useDonutData)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jogiL.OrdinalLegend), {
        shape: "circle",
        data: data,
        colorScale: colorScale,
        colorAccessor: colorAccessor,
        labelAccessor: labelAccessor,
        justifyContent: 'center'
    });
}

});

parcelRegister("lbM48", function(module, exports) {

$parcel$export(module.exports, "DonutPatterns", () => $f6cfe8eb87dbbb52$export$bbefc336dd56edb0);

var $gXw8D = parcelRequire("gXw8D");

var $9ZuYc = parcelRequire("9ZuYc");

var $dBbYh = parcelRequire("dBbYh");

var $gUvRg = parcelRequire("gUvRg");

var $2OMIu = parcelRequire("2OMIu");
const $f6cfe8eb87dbbb52$export$bbefc336dd56edb0 = ()=>{
    const { patternDefs: patternDefs } = (0, $9ZuYc.useElementProps)((0, $gXw8D.default).elements.Theme);
    const { showPatterns: showPatterns } = (0, $dBbYh.useMenuData)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: showPatterns ? (0, $gUvRg.DEFAULT_ORDINAL_PATTERNS_DEFS) : patternDefs
    });
};

});

parcelRegister("c9FTW", function(module, exports) {

$parcel$export(module.exports, "DonutStackSlot", () => $8d96d40a829d3e8b$export$24ce8a819edcba7b);

var $1xLej = parcelRequire("1xLej");
var $9ZuYc = parcelRequire("9ZuYc");

var $2OPEf = parcelRequire("2OPEf");

var $9ZCPf = parcelRequire("9ZCPf");

var $19KuE = parcelRequire("19KuE");

var $dcCcf = parcelRequire("dcCcf");

var $dFdp9 = parcelRequire("dFdp9");

var $dwEoN = parcelRequire("dwEoN");

var $8aZwB = parcelRequire("8aZwB");

var $iATZD = parcelRequire("iATZD");

var $2OMIu = parcelRequire("2OMIu");
const $8d96d40a829d3e8b$export$8874d6b2a9285ec0 = (0, $1xLej.element)(function DonutStack(_ref) {
    let { data: data, valueAccessor: valueAccessor, labelAccessor: labelAccessor, colorAccessor: colorAccessor, colorScale: colorScale, innerRadius: innerRadius, outerRadius: outerRadius, transform: transform } = _ref;
    const arcs = (0, $iATZD.default)(data, valueAccessor, labelAccessor, colorAccessor, colorScale, innerRadius, outerRadius);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $9ZCPf.default), {
        transform: transform,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dwEoN.DonutMarks), {
                arcs: arcs,
                labelAccessor: labelAccessor
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dFdp9.DonutMarkLabels), {
                arcs: arcs,
                hide: true
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dcCcf.DonutMetric), {
                data: data,
                valueAccessor: valueAccessor,
                innerRadius: innerRadius,
                hide: false
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8aZwB.DonutTooltipOverlay), {
                arcs: arcs
            })
        ]
    });
});
function $8d96d40a829d3e8b$export$24ce8a819edcba7b() {
    const { data: data, valueAccessor: valueAccessor, labelAccessor: labelAccessor, colorAccessor: colorAccessor, colorScale: colorScale, innerRadius: innerRadius, outerRadius: outerRadius, width: width, height: height } = (0, $19KuE.useDonutData)();
    const layoutProps = (0, $9ZuYc.useElementProps)((0, $2OPEf.Layout));
    // DISABLE
    // const sideBySide = !layoutProps.gridTemplate?.includes('legend');
    const sideBySide = false;
    const transform = `translate(${sideBySide ? width - outerRadius : width / 2},${height / 2})`;
    return /*#__PURE__*/ (0, $2OMIu.jsx)($8d96d40a829d3e8b$export$8874d6b2a9285ec0, {
        data: data,
        valueAccessor: valueAccessor,
        labelAccessor: labelAccessor,
        colorAccessor: colorAccessor,
        colorScale: colorScale,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        transform: transform
    });
}

});
parcelRegister("iATZD", function(module, exports) {

$parcel$export(module.exports, "default", () => $d89705dd8da899a1$export$2e2bcd8739ae039);

var $52WFU = parcelRequire("52WFU");
function $d89705dd8da899a1$var$getStackArcs(data, valueAccessor, labelAccessor, colorAccessor, colorScale, innerRadius, outerRadius) {
    const pie = (0, $52WFU.default)().value(valueAccessor).sort(null);
    const arcs = pie(data);
    const stackArcs = arcs.map((arc)=>({
            key: labelAccessor(arc.data),
            ariaLabel: `${labelAccessor(arc.data)}, ${valueAccessor(arc.data)}`,
            innerRadius: innerRadius !== undefined && innerRadius < 1 ? 1 : innerRadius,
            outerRadius: outerRadius,
            startAngle: arc.startAngle,
            endAngle: arc.endAngle,
            padAngle: 0.01,
            fill: colorScale(colorAccessor(arc.data)),
            value: valueAccessor(arc.data),
            data: arc.data
        }));
    return stackArcs;
}
var $d89705dd8da899a1$export$2e2bcd8739ae039 = $d89705dd8da899a1$var$getStackArcs;

});
parcelRegister("52WFU", function(module, exports) {

$parcel$export(module.exports, "default", () => $3acaa74456ded336$export$2e2bcd8739ae039);

var $etq9h = parcelRequire("etq9h");

var $cuOMt = parcelRequire("cuOMt");

var $kb2rg = parcelRequire("kb2rg");

var $khiZx = parcelRequire("khiZx");

var $fassv = parcelRequire("fassv");
function $3acaa74456ded336$export$2e2bcd8739ae039() {
    var value = (0, $khiZx.default), sortValues = (0, $kb2rg.default), sort = null, startAngle = (0, $cuOMt.default)(0), endAngle = (0, $cuOMt.default)((0, $fassv.tau)), padAngle = (0, $cuOMt.default)(0);
    function pie(data) {
        var i, n = (data = (0, $etq9h.default)(data)).length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min((0, $fassv.tau), Math.max(-(0, $fassv.tau), endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
        for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
        // Optionally sort the arcs by previously-computed values or by data.
        if (sortValues != null) index.sort(function(i, j) {
            return sortValues(arcs[i], arcs[j]);
        });
        else if (sort != null) index.sort(function(i, j) {
            return sort(data[i], data[j]);
        });
        // Compute the arcs! They are stored in the original data's order.
        for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
            data: data[j],
            index: i,
            value: v,
            startAngle: a0,
            endAngle: a1,
            padAngle: p
        };
        return arcs;
    }
    pie.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $cuOMt.default)(+_), pie) : value;
    };
    pie.sortValues = function(_) {
        return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
    };
    pie.sort = function(_) {
        return arguments.length ? (sort = _, sortValues = null, pie) : sort;
    };
    pie.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $cuOMt.default)(+_), pie) : startAngle;
    };
    pie.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $cuOMt.default)(+_), pie) : endAngle;
    };
    pie.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $cuOMt.default)(+_), pie) : padAngle;
    };
    return pie;
}

});
parcelRegister("etq9h", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8980eaf6ef73194$export$2e2bcd8739ae039);
var $a8980eaf6ef73194$export$58adb3bec8346d0f = Array.prototype.slice;
function $a8980eaf6ef73194$export$2e2bcd8739ae039(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}

});

parcelRegister("kb2rg", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb06b9ff52e0af65$export$2e2bcd8739ae039);
function $eb06b9ff52e0af65$export$2e2bcd8739ae039(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});

parcelRegister("khiZx", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec34207d5dbb9d55$export$2e2bcd8739ae039);
function $ec34207d5dbb9d55$export$2e2bcd8739ae039(d) {
    return d;
}

});




parcelRegister("kRW1r", function(module, exports) {

$parcel$export(module.exports, "DonutTooltip", () => $f315c3ea6f65b130$export$9aab0b7a42ef8058);

var $5uXOq = parcelRequire("5uXOq");

var $dYSV3 = parcelRequire("dYSV3");

var $8upbu = parcelRequire("8upbu");

var $19KuE = parcelRequire("19KuE");

var $2OMIu = parcelRequire("2OMIu");
function $f315c3ea6f65b130$export$9aab0b7a42ef8058() {
    const { colorAccessor: colorAccessor, colorScale: colorScale, valueAccessor: valueAccessor, labelAccessor: labelAccessor } = (0, $19KuE.useDonutData)();
    const { tooltipData: tooltipData, tooltipLeft: tooltipLeft, tooltipTop: tooltipTop } = (0, $5uXOq.useContext)((0, $dYSV3.default));
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8upbu.SingleSeriesTooltip), {
        tooltipData: tooltipData,
        tooltipLeft: tooltipLeft,
        tooltipTop: tooltipTop,
        colorAccessor: colorAccessor,
        colorScale: colorScale,
        valueAccessor: valueAccessor,
        labelAccessor: labelAccessor
    });
}

});



parcelRegister("6CDHh", function(module, exports) {

$parcel$export(module.exports, "CustomLayout", () => $3bb97e8a40746504$export$38801bd36eb3c5d0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $gXw8D = parcelRequire("gXw8D");

var $1xLej = parcelRequire("1xLej");
var $9ZuYc = parcelRequire("9ZuYc");
const $3bb97e8a40746504$var$layoutStyles = null;
// Note: includes legend
const $3bb97e8a40746504$var$chartStyles = null;
const $3bb97e8a40746504$export$38801bd36eb3c5d0 = (0, $1xLej.element)(()=>{
    const { children: children, width: width, height: height } = (0, $9ZuYc.useElementProps)((0, $gXw8D.default).elements.Layout);
    const [fadeInOpacity, setFadeInOpacity] = (0, $5uXOq.useState)(0);
    (0, $5uXOq.useEffect)(()=>{
        let isMounted = true;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const ref = window.requestAnimationFrame(()=>{
            // TODO: would be nice to fade in without triggering another render
            if (isMounted) setFadeInOpacity(1);
        });
        return ()=>{
            isMounted = false;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.cancelAnimationFrame(ref);
        };
    }, [
        setFadeInOpacity
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-element": "layout",
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            width: width,
            height: height
        },
        className: (0, $bwpsq.default)([
            "_1e0c1txw _kqswh2mm _4t3i1osq _2lx21bp4 _vchhusvi _bfhkvuon"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-element": "chart",
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            opacity: fadeInOpacity
        },
        className: (0, $bwpsq.default)([
            "_v56414fr _zulp1ejb _1e0c1txw _1ul9idpf _1tkeidpf _16jlidpf _2lx21sxn"
        ])
    }, children)));
}, {
    as: (0, $gXw8D.default).elements.Layout
});

});

parcelRegister("85STF", function(module, exports) {

$parcel$export(module.exports, "CustomLegend", () => $5379b7a6d751b585$export$502a55a813e9c262);

var $5uXOq = parcelRequire("5uXOq");

var $gXw8D = parcelRequire("gXw8D");

var $1xLej = parcelRequire("1xLej");
var $9ZuYc = parcelRequire("9ZuYc");
const $5379b7a6d751b585$export$502a55a813e9c262 = (0, $1xLej.element)(()=>{
    const { data: data } = (0, $9ZuYc.useElementProps)((0, $gXw8D.default).elements.Legend);
    // Sort the data by value in ascending order, but keep "Other" at the end
    data.sort((a, b)=>{
        if (a.label === 'Other') return 1;
        if (b.label === 'Other') return -1;
        return (a.value ?? 0) - (b.value ?? 0);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gXw8D.default).elements.Legend, {
        data: data,
        maxRows: 10
    });
}, {
    as: (0, $gXw8D.default).elements.Legend
});

});

parcelRegister("53Pxl", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2cf376488da595b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e2cf376488da595b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    centerTextLabel: {
        "id": "issue-field-statistics.single-select-chart-container.donut-chart.center-text-label",
        "defaultMessage": "Total"
    }
});

});


parcelRegister("kKAkB", function(module, exports) {

$parcel$export(module.exports, "HorizontalBarChart", () => $c0b39a071da17525$export$2d84115b1316e023);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $181Rm = parcelRequire("181Rm");

var $f10PG = parcelRequire("f10PG");

var $ezrHX = parcelRequire("ezrHX");
const $c0b39a071da17525$var$MAX_WIDTH = 600;
const $c0b39a071da17525$export$2d84115b1316e023 = ({ data: data, width: initialWidth })=>{
    const width = Math.min(initialWidth, $c0b39a071da17525$var$MAX_WIDTH);
    // Sort the data by value in ascending order, but keep "Other" at start
    data.sort((a, b)=>{
        if (a.label === 'Other') return -1;
        if (b.label === 'Other') return 1;
        return (a.value ?? 0) - (b.value ?? 0);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $181Rm.default), {
        data: data,
        width: Math.floor(width),
        yAccessor: (d)=>d.value,
        xAccessor: (d)=>d.label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ezrHX.CustomLayout), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f10PG.CustomAxisLeftText), {
        sideBarWidth: width
    }));
};

});
parcelRegister("181Rm", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d27fb18a7b55403$export$2e2bcd8739ae039);

var $epG85 = parcelRequire("epG85");

var $hhESq = parcelRequire("hhESq");

var $ft4EL = parcelRequire("ft4EL");

var $6nv1a = parcelRequire("6nv1a");

var $3KKAW = parcelRequire("3KKAW");

var $2OMIu = parcelRequire("2OMIu");
function $0d27fb18a7b55403$export$2e2bcd8739ae039(_ref) {
    let { children: children, ...props } = _ref;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $epG85.default), {
        ...props,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hhESq.BarGroupHorizontal), {}),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3KKAW.BarGroupHorizontalScalesElement), {}),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $epG85.default).elements.TooltipOverlay, {
                horizontal: true
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $epG85.default).elements.TooltipEmitter, {
                horizontal: true
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $epG85.default).elements.Grid, {
                rowLineStyle: "hidden",
                columnLineStyle: "solid"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $epG85.default).elements.AxisLeftLine, {
                hide: true
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $epG85.default).elements.AxisLeftTick, {
                hide: true
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $epG85.default).elements.AxisBottomTick, {
                hide: true
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $epG85.default).elements.AxisBottomLine, {
                hide: true
            }),
            children
        ]
    });
}
$0d27fb18a7b55403$export$2e2bcd8739ae039.elements = {
    ...(0, $epG85.default).elements,
    Scales: (0, $3KKAW.BarGroupHorizontalScalesElement),
    Marks: (0, $6nv1a.BarGroupHorizontalMarks).Component,
    MarkLabels: (0, $ft4EL.BarGroupHorizontalLabels).Component
};

});
parcelRegister("epG85", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7e4147ff34f7841$export$2e2bcd8739ae039);

var $17PP9 = parcelRequire("17PP9");

var $lOXm0 = parcelRequire("lOXm0");

var $hqZma = parcelRequire("hqZma");

var $cXzUG = parcelRequire("cXzUG");
parcelRequire("lWVLr");
var $7Nxvv = parcelRequire("7Nxvv");
var $lWVLr = parcelRequire("lWVLr");

var $e2CtX = parcelRequire("e2CtX");

var $erST8 = parcelRequire("erST8");

var $3B9ij = parcelRequire("3B9ij");

var $chU1I = parcelRequire("chU1I");
var $PfPCm = parcelRequire("PfPCm");

var $iTGbP = parcelRequire("iTGbP");

var $cgmj2 = parcelRequire("cgmj2");

var $doqD0 = parcelRequire("doqD0");
var $l6fAT = parcelRequire("l6fAT");

var $1Tf3y = parcelRequire("1Tf3y");

var $lA40p = parcelRequire("lA40p");

var $02ifK = parcelRequire("02ifK");

var $e0UVN = parcelRequire("e0UVN");

var $2pOyr = parcelRequire("2pOyr");

var $arL7j = parcelRequire("arL7j");

var $dwg9t = parcelRequire("dwg9t");

var $ggVTz = parcelRequire("ggVTz");

var $cKYPp = parcelRequire("cKYPp");

var $fAwZ6 = parcelRequire("fAwZ6");

var $2OMIu = parcelRequire("2OMIu");
function $a7e4147ff34f7841$export$2e2bcd8739ae039(_ref) {
    let { width: width, height: height, data: data, children: children, ...restProps } = _ref;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $17PP9.ElementsProvider), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e0UVN.default), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $PfPCm.MenuProvider), {
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $02ifK.default), {
                    children: [
                        children,
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lWVLr.LayoutContainer), {
                            width: width,
                            height: height,
                            data: data,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e2CtX.DimensionsWrapper), {
                                children: (_ref2)=>{
                                    let { margin: margin, plotHeight: plotHeight, plotWidth: plotWidth, plotSvgRef: plotSvgRef } = _ref2;
                                    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fAwZ6.PureBarChart), {
                                        svgRef: plotSvgRef,
                                        height: plotHeight,
                                        width: plotWidth,
                                        margin: margin,
                                        data: data,
                                        ...restProps
                                    });
                                }
                            })
                        })
                    ]
                })
            })
        })
    });
}
$a7e4147ff34f7841$export$2e2bcd8739ae039.elements = {
    // All of the Axis Left components
    AxisLeft: (0, $cXzUG.AxisLeft).Component,
    AxisLeftText: (0, $cXzUG.AxisLeftText).Component,
    AxisLeftTick: (0, $cXzUG.AxisLeftTick).Component,
    AxisLeftLine: (0, $cXzUG.AxisLeftLine).Component,
    // AxisBottomComponents
    AxisBottom: (0, $hqZma.AxisBottom).Component,
    AxisBottomText: (0, $hqZma.AxisBottomText).Component,
    AxisBottomTick: (0, $hqZma.AxisBottomTick).Component,
    AxisBottomLine: (0, $hqZma.AxisBottomLine).Component,
    Grid: (0, $erST8.Grid).Component,
    Legend: (0, $3B9ij.OrdinalLegend).Component,
    Layout: (0, $7Nxvv.Layout).Component,
    Title: (0, $l6fAT.Title).Component,
    SubTitle: (0, $doqD0.Subtitle).Component,
    Marks: (0, $dwg9t.BarGroupMarks).Component,
    Mark: (0, $iTGbP.Bar).Component,
    MarkLabels: (0, $arL7j.BarGroupMarkLabels).Component,
    Scales: (0, $ggVTz.BarScalesElement).Component,
    Theme: (0, $cgmj2.Theme).Component,
    // Tooltip component
    Tooltip: (0, $2pOyr.MultiSeriesTooltip).Component,
    TooltipHeader: (0, $1Tf3y.TooltipHeader).Component,
    TooltipRow: (0, $lA40p.TooltipRow).Component,
    // Tooltip overlay that adds svg marks
    TooltipOverlay: (0, $cKYPp.BarTooltipOverlayElement).Component,
    // Emitter which captures events
    TooltipEmitter: (0, $cKYPp.BarTooltipOverlayEmitterElement).Component,
    Menu: (0, $chU1I.Menu).Component,
    DataTable: (0, $lOXm0.DataTable).Component
};

});
parcelRegister("17PP9", function(module, exports) {

$parcel$export(module.exports, "ElementsProvider", () => $0d1ea50b01d1ff20$export$71c0ba76abe92a7e);
$parcel$export(module.exports, "useElements", () => $0d1ea50b01d1ff20$export$83d5c6859f2ae3df);
$parcel$export(module.exports, "useElementProps", () => $0d1ea50b01d1ff20$export$8edbe6dd5606980);

var $5uXOq = parcelRequire("5uXOq");

var $2OMIu = parcelRequire("2OMIu");

var $6cAn5 = parcelRequire("6cAn5");
const $0d1ea50b01d1ff20$export$a92ee76f0b1f4e66 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
function $0d1ea50b01d1ff20$export$71c0ba76abe92a7e(_ref) {
    let { children: children, defaultProps: defaultProps, kind: kind } = _ref;
    const ctx = $0d1ea50b01d1ff20$export$83d5c6859f2ae3df();
    const value = (0, $5uXOq.useMemo)(()=>{
        // If kind is specified, we assume we are in nested element so we get the parent registry
        // Ideally we'd use WeakMap but node < 20 does not support symbols as keys
        const registry = kind && (ctx === null || ctx === void 0 ? void 0 : ctx.registry) || new Map();
        const registeredOverrideComponents = kind && (ctx === null || ctx === void 0 ? void 0 : ctx.registeredOverrideComponents) || new Map();
        return {
            registry: registry,
            registeredOverrideComponents: registeredOverrideComponents,
            register: (kind, value)=>{
                if (!registeredOverrideComponents.get(kind)) registeredOverrideComponents.set(kind, []);
                const overrideComps = registeredOverrideComponents.get(kind) || [];
                if (!overrideComps.includes(value.Component)) overrideComps.push(value.Component);
                if (overrideComps[overrideComps.length - 1] === value.Component) registry.set(kind, value);
            },
            retrieve: (kind)=>registry.get(kind),
            isNested: (k)=>k === kind || Boolean(ctx === null || ctx === void 0 ? void 0 : ctx.isNested(k)),
            getProps: (k)=>k === kind ? defaultProps : ctx === null || ctx === void 0 ? void 0 : ctx.getProps(k),
            getOuterProps: (k)=>{
                var _registry$get;
                return Boolean(ctx === null || ctx === void 0 ? void 0 : ctx.isNested(k)) ? (_registry$get = registry.get(k)) === null || _registry$get === void 0 ? void 0 : _registry$get.outerProps : null;
            }
        };
    }, [
        kind,
        defaultProps
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($0d1ea50b01d1ff20$export$a92ee76f0b1f4e66.Provider, {
        value: value,
        children: children
    });
}
const $0d1ea50b01d1ff20$export$83d5c6859f2ae3df = ()=>(0, $5uXOq.useContext)($0d1ea50b01d1ff20$export$a92ee76f0b1f4e66);
function $0d1ea50b01d1ff20$export$8edbe6dd5606980(element, _temp) {
    var _process, _process$env, _useElements, _useElements2, _useElements3;
    let { mergeWith: mergeWith } = _temp === void 0 ? {} : _temp;
    if (typeof element.kind !== 'symbol') throw new Error('Invalid element argument. It must be an element or an element Component.');
    if (((_process = $6cAn5) === null || _process === void 0 ? void 0 : (_process$env = _process.env) === null || _process$env === void 0 ? void 0 : _process$env.NODE_ENV) === 'development' && !((_useElements = $0d1ea50b01d1ff20$export$83d5c6859f2ae3df()) !== null && _useElements !== void 0 && _useElements.isNested(element.kind))) throw new Error('Invalid element argument. Only props of parent elements can be retrieved.');
    return {
        ...(_useElements2 = $0d1ea50b01d1ff20$export$83d5c6859f2ae3df()) === null || _useElements2 === void 0 ? void 0 : _useElements2.getProps(element.kind),
        ...(_useElements3 = $0d1ea50b01d1ff20$export$83d5c6859f2ae3df()) === null || _useElements3 === void 0 ? void 0 : _useElements3.getOuterProps(element.kind),
        ...mergeWith
    };
}

});

parcelRegister("lOXm0", function(module, exports) {

$parcel$export(module.exports, "DataTable", () => $fe2c4ef74d91a16f$export$df30df7ec97b32b5);
$parcel$export(module.exports, "DataTableModal", () => $fe2c4ef74d91a16f$export$4717a7afeef78908);
/* DataTable.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $bwpsq = parcelRequire("bwpsq");

var $42CjB = parcelRequire("42CjB");

var $k3qRI = parcelRequire("k3qRI");

var $lLLkM = parcelRequire("lLLkM");

var $1R1Ge = parcelRequire("1R1Ge");
var $7QSqG = parcelRequire("7QSqG");
var $jgVsb = parcelRequire("jgVsb");

var $bT1Sw = parcelRequire("bT1Sw");

var $l6fAT = parcelRequire("l6fAT");

var $ltC0t = parcelRequire("ltC0t");

var $2OMIu = parcelRequire("2OMIu");
const $fe2c4ef74d91a16f$var$gridStyles = null;
const $fe2c4ef74d91a16f$export$a8a28302b48950e6 = null;
function $fe2c4ef74d91a16f$var$getHeaders(headers) {
    const cellHeaders = headers.map((header)=>({
            key: header,
            content: (0, $ltC0t.toSentenceCase)(header),
            isSortable: true
        }));
    return {
        cells: cellHeaders
    };
}
function $fe2c4ef74d91a16f$var$getRows(data) {
    if (!data.length) {
        const keys = Object.keys(data);
        const rowData = keys.map((k)=>{
            var _data;
            const cellData = (_data = data[k]) === null || _data === void 0 ? void 0 : _data.toString();
            return {
                key: cellData,
                content: cellData
            };
        });
        return [
            {
                key: 'row-0',
                cells: rowData
            }
        ];
    }
    const rows = data.map((d, i)=>{
        const keys = Object.keys(d);
        const rowData = keys.map((k)=>{
            var _d$k;
            const cellData = (_d$k = d[k]) === null || _d$k === void 0 ? void 0 : _d$k.toString();
            return {
                key: cellData,
                content: cellData
            };
        });
        return {
            key: `row-${i}`,
            cells: rowData
        };
    });
    return rows;
}
function $fe2c4ef74d91a16f$export$84cbf2d941927b3b(_ref) {
    let { data: data, headers: userDefinedHeaders } = _ref;
    if (!data || Array.isArray(data) && data.length === 0) return null;
    const headers = userDefinedHeaders ? $fe2c4ef74d91a16f$var$getHeaders(userDefinedHeaders) : data && $fe2c4ef74d91a16f$var$getHeaders(Object.keys(data[0]));
    const rows = $fe2c4ef74d91a16f$var$getRows(data);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_n3tdu2gc _1reo1wug _18m91wug _ect41sbm _opvxu2gc _91ih1gjq _1ouib76v _cnoh16g6 _a2nzu2gc _9f9g1oud _slyj1fxt _1xc811bn"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k3qRI.default), {
            head: headers,
            rows: rows,
            rowsPerPage: 10,
            defaultPage: 1,
            loadingSpinnerSize: "large"
        })
    });
}
const $fe2c4ef74d91a16f$export$df30df7ec97b32b5 = (0, $bT1Sw.element)($fe2c4ef74d91a16f$export$84cbf2d941927b3b);
function $fe2c4ef74d91a16f$export$4717a7afeef78908(_ref2) {
    let { data: data, closeModal: closeModal } = _ref2;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $1R1Ge.default), {
        onClose: closeModal,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jgVsb.default), {
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                    className: (0, $bwpsq.default)([
                        "_1bsb1osq _1e0c11p5 _zulppxbi _1lmcg5aa _yv0e1ghl _4cvr1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                            className: (0, $bwpsq.default)([
                                "_1bahh9n0 _nd5l1bvj"
                            ]),
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                                appearance: "subtle",
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($lLLkM))),
                                label: "Close Modal",
                                onClick: closeModal
                            })
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                            className: (0, $bwpsq.default)([
                                "_1bahv2br _nd5l1cy2"
                            ]),
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l6fAT.Title), {})
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7QSqG.default), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)($fe2c4ef74d91a16f$export$df30df7ec97b32b5, {
                    data: data
                })
            })
        ]
    });
}

});
parcelRegister("bT1Sw", function(module, exports) {

$parcel$export(module.exports, "element", () => $8a7649c186b65558$export$8454457683f90105);
// Chart element takes a chart type generic which says what kind of overrides we can do

var $17PP9 = parcelRequire("17PP9");

var $2OMIu = parcelRequire("2OMIu");
function $8a7649c186b65558$export$8454457683f90105(DefaultComponent, options) {
    var _options$as;
    if (options === void 0) options = {};
    const displayName = DefaultComponent.displayName || DefaultComponent.name || options.displayName;
    const kind = ((_options$as = options.as) === null || _options$as === void 0 ? void 0 : _options$as.kind) || Symbol(displayName);
    if (options.as && !options.as.kind) throw new Error('Invalid "as" component. It must be an `element` or `element.Component` value.');
    /**
   * When used outside its own slot, it will register the override
   * while when its used inside the slot, it will render the component
   */ const ElementComponent = (outerProps)=>{
        const ctx = (0, $17PP9.useElements)();
        if (!ctx) throw new Error('Element must be used inside an ElementsProvider');
        // Check if we are rendering under the own ElementComponent, if so, just render
        if (ctx !== null && ctx !== void 0 && ctx.isNested(kind)) return /*#__PURE__*/ (0, $2OMIu.jsx)(DefaultComponent, {
            ...!options.as && ctx.getProps(kind),
            ...outerProps
        });
        else {
            ctx.register(kind, {
                Component: DefaultComponent,
                outerProps: outerProps
            });
            return null;
        }
    };
    ElementComponent.kind = kind;
    // When as is defined we return the component without any slot implementation
    if (options.as) return ElementComponent;
    /**
   * Defines the slot where the element will be rendered, grabbing the implementation from the context
   */ const ElementSlot = (defaultProps)=>{
        const ctx = (0, $17PP9.useElements)();
        const { Component: Component = DefaultComponent, outerProps: outerProps } = (ctx === null || ctx === void 0 ? void 0 : ctx.retrieve(kind)) || {};
        const isSelf = Component === DefaultComponent;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $17PP9.ElementsProvider), {
            kind: kind,
            defaultProps: defaultProps,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                ...isSelf && defaultProps,
                ...outerProps
            })
        });
    };
    ElementSlot.kind = kind;
    ElementSlot.Component = ElementComponent;
    ElementSlot.displayName = `element(${displayName})`;
    return ElementSlot;
}

});

parcelRegister("l6fAT", function(module, exports) {

$parcel$export(module.exports, "Title", () => $f5c641277358ed4b$export$f99233281efd08a0);
/* title.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $bwpsq = parcelRequire("bwpsq");

var $bT1Sw = parcelRequire("bT1Sw");

var $2OMIu = parcelRequire("2OMIu");
const $f5c641277358ed4b$var$titleTextStyle = null;
function $f5c641277358ed4b$var$Title(_ref) {
    let { children: children } = _ref;
    if (!children) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("h2", {
        className: (0, $bwpsq.default)([
            "_syaz1gjq _k48pni7l _zg8l4jg8 _ect4e86e _1wyb7vkz _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1yt461nu"
        ]),
        children: children
    });
}
const $f5c641277358ed4b$export$f99233281efd08a0 = (0, $bT1Sw.element)($f5c641277358ed4b$var$Title);

});

parcelRegister("ltC0t", function(module, exports) {

$parcel$export(module.exports, "toSentenceCase", () => $fa29c9baa9a7a709$export$dcbb097fa84257c1);
$parcel$export(module.exports, "default", () => $fa29c9baa9a7a709$export$2e2bcd8739ae039);

var $hjll3 = parcelRequire("hjll3");
const $fa29c9baa9a7a709$var$formatNumberAbbreviated = (value)=>{
    if (value === null) return 'null';
    let numberValue;
    if (typeof value === 'string') {
        const parsedValue = Number(value);
        if (isNaN(parsedValue)) return value;
        numberValue = parsedValue;
    } else numberValue = value;
    return new Intl.NumberFormat('en-US', {
        notation: 'compact',
        compactDisplay: 'short'
    }).format(numberValue);
};
const $fa29c9baa9a7a709$var$percentChange = (currentValue, previousValue)=>{
    if (previousValue === 0) return (currentValue * 100).toFixed();
    return (Math.abs(previousValue - currentValue) / previousValue * 100).toFixed();
};
const $fa29c9baa9a7a709$var$formatMillisecond = (0, $hjll3.timeFormat)('.%L'), $fa29c9baa9a7a709$var$formatSecond = (0, $hjll3.timeFormat)(':%S'), $fa29c9baa9a7a709$var$formatMinute = (0, $hjll3.timeFormat)('%I:%M'), $fa29c9baa9a7a709$var$formatHour = (0, $hjll3.timeFormat)('%I %p'), $fa29c9baa9a7a709$var$formatDay = (0, $hjll3.timeFormat)('%b %d'), $fa29c9baa9a7a709$var$formatWeek = (0, $hjll3.timeFormat)('%b %d'), $fa29c9baa9a7a709$var$formatMonth = (0, $hjll3.timeFormat)('%b'), $fa29c9baa9a7a709$var$formatYear = (0, $hjll3.timeFormat)('%Y');
function $fa29c9baa9a7a709$export$16cec29b78b14126(date) {
    return ((0, $hjll3.timeSecond)(date) < date ? $fa29c9baa9a7a709$var$formatMillisecond : (0, $hjll3.timeMinute)(date) < date ? $fa29c9baa9a7a709$var$formatSecond : (0, $hjll3.timeHour)(date) < date ? $fa29c9baa9a7a709$var$formatMinute : (0, $hjll3.timeDay)(date) < date ? $fa29c9baa9a7a709$var$formatHour : (0, $hjll3.timeMonth)(date) < date ? (0, $hjll3.timeWeek)(date) < date ? $fa29c9baa9a7a709$var$formatDay : $fa29c9baa9a7a709$var$formatWeek : (0, $hjll3.timeYear)(date) < date ? $fa29c9baa9a7a709$var$formatMonth : $fa29c9baa9a7a709$var$formatYear)(date);
}
function $fa29c9baa9a7a709$export$dcbb097fa84257c1(str) {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}
var $fa29c9baa9a7a709$export$2e2bcd8739ae039 = {
    formatNumberAbbreviated: $fa29c9baa9a7a709$var$formatNumberAbbreviated,
    percentChange: $fa29c9baa9a7a709$var$percentChange,
    multiTimeFormat: $fa29c9baa9a7a709$export$16cec29b78b14126,
    toSentenceCase: $fa29c9baa9a7a709$export$dcbb097fa84257c1
};

});
parcelRegister("hjll3", function(module, exports) {
// https://d3js.org v7.7.0 Copyright 2010-2022 Mike Bostock
(function(global, factory) {
    factory(module.exports);
})(module.exports, function(exports1) {
    'use strict';
    var version = "7.7.0";
    function ascending$3(a, b) {
        return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
    }
    function descending$2(a, b) {
        return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
    }
    function bisector(f) {
        let compare1, compare2, delta;
        // If an accessor is specified, promote it to a comparator. In this case we
        // can test whether the search value is (self-) comparable. We can’t do this
        // for a comparator (except for specific, known comparators) because we can’t
        // tell if the comparator is symmetric, and an asymmetric comparator can’t be
        // used to test whether a single value is comparable.
        if (f.length !== 2) {
            compare1 = ascending$3;
            compare2 = (d, x)=>ascending$3(f(d), x);
            delta = (d, x)=>f(d) - x;
        } else {
            compare1 = f === ascending$3 || f === descending$2 ? f : zero$1;
            compare2 = f;
            delta = f;
        }
        function left(a, x, lo = 0, hi = a.length) {
            if (lo < hi) {
                if (compare1(x, x) !== 0) return hi;
                do {
                    const mid = lo + hi >>> 1;
                    if (compare2(a[mid], x) < 0) lo = mid + 1;
                    else hi = mid;
                }while (lo < hi);
            }
            return lo;
        }
        function right(a, x, lo = 0, hi = a.length) {
            if (lo < hi) {
                if (compare1(x, x) !== 0) return hi;
                do {
                    const mid = lo + hi >>> 1;
                    if (compare2(a[mid], x) <= 0) lo = mid + 1;
                    else hi = mid;
                }while (lo < hi);
            }
            return lo;
        }
        function center(a, x, lo = 0, hi = a.length) {
            const i = left(a, x, lo, hi - 1);
            return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
        }
        return {
            left: left,
            center: center,
            right: right
        };
    }
    function zero$1() {
        return 0;
    }
    function number$3(x) {
        return x === null ? NaN : +x;
    }
    function* numbers(values, valueof) {
        if (valueof === undefined) {
            for (let value of values)if (value != null && (value = +value) >= value) yield value;
        } else {
            let index = -1;
            for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
        }
    }
    const ascendingBisect = bisector(ascending$3);
    const bisectRight = ascendingBisect.right;
    const bisectLeft = ascendingBisect.left;
    const bisectCenter = bisector(number$3).center;
    var bisect = bisectRight;
    function blur(values, r) {
        if (!((r = +r) >= 0)) throw new RangeError("invalid r");
        let length = values.length;
        if (!((length = Math.floor(length)) >= 0)) throw new RangeError("invalid length");
        if (!length || !r) return values;
        const blur = blurf(r);
        const temp = values.slice();
        blur(values, temp, 0, length, 1);
        blur(temp, values, 0, length, 1);
        blur(values, temp, 0, length, 1);
        return values;
    }
    const blur2 = Blur2(blurf);
    const blurImage = Blur2(blurfImage);
    function Blur2(blur) {
        return function(data, rx, ry = rx) {
            if (!((rx = +rx) >= 0)) throw new RangeError("invalid rx");
            if (!((ry = +ry) >= 0)) throw new RangeError("invalid ry");
            let { data: values, width: width, height: height } = data;
            if (!((width = Math.floor(width)) >= 0)) throw new RangeError("invalid width");
            if (!((height = Math.floor(height !== undefined ? height : values.length / width)) >= 0)) throw new RangeError("invalid height");
            if (!width || !height || !rx && !ry) return data;
            const blurx = rx && blur(rx);
            const blury = ry && blur(ry);
            const temp = values.slice();
            if (blurx && blury) {
                blurh(blurx, temp, values, width, height);
                blurh(blurx, values, temp, width, height);
                blurh(blurx, temp, values, width, height);
                blurv(blury, values, temp, width, height);
                blurv(blury, temp, values, width, height);
                blurv(blury, values, temp, width, height);
            } else if (blurx) {
                blurh(blurx, values, temp, width, height);
                blurh(blurx, temp, values, width, height);
                blurh(blurx, values, temp, width, height);
            } else if (blury) {
                blurv(blury, values, temp, width, height);
                blurv(blury, temp, values, width, height);
                blurv(blury, values, temp, width, height);
            }
            return data;
        };
    }
    function blurh(blur, T, S, w, h) {
        for(let y = 0, n = w * h; y < n;)blur(T, S, y, y += w, 1);
    }
    function blurv(blur, T, S, w, h) {
        for(let x = 0, n = w * h; x < w; ++x)blur(T, S, x, x + n, w);
    }
    function blurfImage(radius) {
        const blur = blurf(radius);
        return (T, S, start, stop, step)=>{
            start <<= 2, stop <<= 2, step <<= 2;
            blur(T, S, start + 0, stop + 0, step);
            blur(T, S, start + 1, stop + 1, step);
            blur(T, S, start + 2, stop + 2, step);
            blur(T, S, start + 3, stop + 3, step);
        };
    }
    // Given a target array T, a source array S, sets each value T[i] to the average
    // of {S[i - r], …, S[i], …, S[i + r]}, where r = ⌊radius⌋, start <= i < stop,
    // for each i, i + step, i + 2 * step, etc., and where S[j] is clamped between
    // S[start] (inclusive) and S[stop] (exclusive). If the given radius is not an
    // integer, S[i - r - 1] and S[i + r + 1] are added to the sum, each weighted
    // according to r - ⌊radius⌋.
    function blurf(radius) {
        const radius0 = Math.floor(radius);
        if (radius0 === radius) return bluri(radius);
        const t = radius - radius0;
        const w = 2 * radius + 1;
        return (T, S, start, stop, step)=>{
            if (!((stop -= step) >= start)) return; // inclusive stop
            let sum = radius0 * S[start];
            const s0 = step * radius0;
            const s1 = s0 + step;
            for(let i = start, j = start + s0; i < j; i += step)sum += S[Math.min(stop, i)];
            for(let i = start, j = stop; i <= j; i += step){
                sum += S[Math.min(stop, i + s0)];
                T[i] = (sum + t * (S[Math.max(start, i - s1)] + S[Math.min(stop, i + s1)])) / w;
                sum -= S[Math.max(start, i - s0)];
            }
        };
    }
    // Like blurf, but optimized for integer radius.
    function bluri(radius) {
        const w = 2 * radius + 1;
        return (T, S, start, stop, step)=>{
            if (!((stop -= step) >= start)) return; // inclusive stop
            let sum = radius * S[start];
            const s = step * radius;
            for(let i = start, j = start + s; i < j; i += step)sum += S[Math.min(stop, i)];
            for(let i = start, j = stop; i <= j; i += step){
                sum += S[Math.min(stop, i + s)];
                T[i] = sum / w;
                sum -= S[Math.max(start, i - s)];
            }
        };
    }
    function count$1(values, valueof) {
        let count = 0;
        if (valueof === undefined) {
            for (let value of values)if (value != null && (value = +value) >= value) ++count;
        } else {
            let index = -1;
            for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count;
        }
        return count;
    }
    function length$3(array) {
        return array.length | 0;
    }
    function empty$2(length) {
        return !(length > 0);
    }
    function arrayify(values) {
        return typeof values !== "object" || "length" in values ? values : Array.from(values);
    }
    function reducer(reduce) {
        return (values)=>reduce(...values);
    }
    function cross$2(...values) {
        const reduce = typeof values[values.length - 1] === "function" && reducer(values.pop());
        values = values.map(arrayify);
        const lengths = values.map(length$3);
        const j = values.length - 1;
        const index = new Array(j + 1).fill(0);
        const product = [];
        if (j < 0 || lengths.some(empty$2)) return product;
        while(true){
            product.push(index.map((j, i)=>values[i][j]));
            let i = j;
            while(++index[i] === lengths[i]){
                if (i === 0) return reduce ? product.map(reduce) : product;
                index[i--] = 0;
            }
        }
    }
    function cumsum(values, valueof) {
        var sum = 0, index = 0;
        return Float64Array.from(values, valueof === undefined ? (v)=>sum += +v || 0 : (v)=>sum += +valueof(v, index++, values) || 0);
    }
    function variance(values, valueof) {
        let count = 0;
        let delta;
        let mean = 0;
        let sum = 0;
        if (valueof === undefined) {
            for (let value of values)if (value != null && (value = +value) >= value) {
                delta = value - mean;
                mean += delta / ++count;
                sum += delta * (value - mean);
            }
        } else {
            let index = -1;
            for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
                delta = value - mean;
                mean += delta / ++count;
                sum += delta * (value - mean);
            }
        }
        if (count > 1) return sum / (count - 1);
    }
    function deviation(values, valueof) {
        const v = variance(values, valueof);
        return v ? Math.sqrt(v) : v;
    }
    function extent$1(values, valueof) {
        let min;
        let max;
        if (valueof === undefined) {
            for (const value of values)if (value != null) {
                if (min === undefined) {
                    if (value >= value) min = max = value;
                } else {
                    if (min > value) min = value;
                    if (max < value) max = value;
                }
            }
        } else {
            let index = -1;
            for (let value of values)if ((value = valueof(value, ++index, values)) != null) {
                if (min === undefined) {
                    if (value >= value) min = max = value;
                } else {
                    if (min > value) min = value;
                    if (max < value) max = value;
                }
            }
        }
        return [
            min,
            max
        ];
    }
    // https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
    class Adder {
        constructor(){
            this._partials = new Float64Array(32);
            this._n = 0;
        }
        add(x) {
            const p = this._partials;
            let i = 0;
            for(let j = 0; j < this._n && j < 32; j++){
                const y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
                if (lo) p[i++] = lo;
                x = hi;
            }
            p[i] = x;
            this._n = i + 1;
            return this;
        }
        valueOf() {
            const p = this._partials;
            let n = this._n, x, y, lo, hi = 0;
            if (n > 0) {
                hi = p[--n];
                while(n > 0){
                    x = hi;
                    y = p[--n];
                    hi = x + y;
                    lo = y - (hi - x);
                    if (lo) break;
                }
                if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
                    y = lo * 2;
                    x = hi + y;
                    if (y == x - hi) hi = x;
                }
            }
            return hi;
        }
    }
    function fsum(values, valueof) {
        const adder = new Adder();
        if (valueof === undefined) {
            for (let value of values)if (value = +value) adder.add(value);
        } else {
            let index = -1;
            for (let value of values)if (value = +valueof(value, ++index, values)) adder.add(value);
        }
        return +adder;
    }
    function fcumsum(values, valueof) {
        const adder = new Adder();
        let index = -1;
        return Float64Array.from(values, valueof === undefined ? (v)=>adder.add(+v || 0) : (v)=>adder.add(+valueof(v, ++index, values) || 0));
    }
    class InternMap extends Map {
        constructor(entries, key = keyof){
            super();
            Object.defineProperties(this, {
                _intern: {
                    value: new Map()
                },
                _key: {
                    value: key
                }
            });
            if (entries != null) for (const [key, value] of entries)this.set(key, value);
        }
        get(key) {
            return super.get(intern_get(this, key));
        }
        has(key) {
            return super.has(intern_get(this, key));
        }
        set(key, value) {
            return super.set(intern_set(this, key), value);
        }
        delete(key) {
            return super.delete(intern_delete(this, key));
        }
    }
    class InternSet extends Set {
        constructor(values, key = keyof){
            super();
            Object.defineProperties(this, {
                _intern: {
                    value: new Map()
                },
                _key: {
                    value: key
                }
            });
            if (values != null) for (const value of values)this.add(value);
        }
        has(value) {
            return super.has(intern_get(this, value));
        }
        add(value) {
            return super.add(intern_set(this, value));
        }
        delete(value) {
            return super.delete(intern_delete(this, value));
        }
    }
    function intern_get({ _intern: _intern, _key: _key }, value) {
        const key = _key(value);
        return _intern.has(key) ? _intern.get(key) : value;
    }
    function intern_set({ _intern: _intern, _key: _key }, value) {
        const key = _key(value);
        if (_intern.has(key)) return _intern.get(key);
        _intern.set(key, value);
        return value;
    }
    function intern_delete({ _intern: _intern, _key: _key }, value) {
        const key = _key(value);
        if (_intern.has(key)) {
            value = _intern.get(key);
            _intern.delete(key);
        }
        return value;
    }
    function keyof(value) {
        return value !== null && typeof value === "object" ? value.valueOf() : value;
    }
    function identity$9(x) {
        return x;
    }
    function group(values, ...keys) {
        return nest(values, identity$9, identity$9, keys);
    }
    function groups(values, ...keys) {
        return nest(values, Array.from, identity$9, keys);
    }
    function flatten$1(groups, keys) {
        for(let i = 1, n = keys.length; i < n; ++i)groups = groups.flatMap((g)=>g.pop().map(([key, value])=>[
                    ...g,
                    key,
                    value
                ]));
        return groups;
    }
    function flatGroup(values, ...keys) {
        return flatten$1(groups(values, ...keys), keys);
    }
    function flatRollup(values, reduce, ...keys) {
        return flatten$1(rollups(values, reduce, ...keys), keys);
    }
    function rollup(values, reduce, ...keys) {
        return nest(values, identity$9, reduce, keys);
    }
    function rollups(values, reduce, ...keys) {
        return nest(values, Array.from, reduce, keys);
    }
    function index$4(values, ...keys) {
        return nest(values, identity$9, unique, keys);
    }
    function indexes(values, ...keys) {
        return nest(values, Array.from, unique, keys);
    }
    function unique(values) {
        if (values.length !== 1) throw new Error("duplicate key");
        return values[0];
    }
    function nest(values, map, reduce, keys) {
        return function regroup(values, i) {
            if (i >= keys.length) return reduce(values);
            const groups = new InternMap();
            const keyof = keys[i++];
            let index = -1;
            for (const value of values){
                const key = keyof(value, ++index, values);
                const group = groups.get(key);
                if (group) group.push(value);
                else groups.set(key, [
                    value
                ]);
            }
            for (const [key, values] of groups)groups.set(key, regroup(values, i));
            return map(groups);
        }(values, 0);
    }
    function permute(source, keys) {
        return Array.from(keys, (key)=>source[key]);
    }
    function sort(values, ...F) {
        if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
        values = Array.from(values);
        let [f] = F;
        if (f && f.length !== 2 || F.length > 1) {
            const index = Uint32Array.from(values, (d, i)=>i);
            if (F.length > 1) {
                F = F.map((f)=>values.map(f));
                index.sort((i, j)=>{
                    for (const f of F){
                        const c = ascendingDefined(f[i], f[j]);
                        if (c) return c;
                    }
                });
            } else {
                f = values.map(f);
                index.sort((i, j)=>ascendingDefined(f[i], f[j]));
            }
            return permute(values, index);
        }
        return values.sort(compareDefined(f));
    }
    function compareDefined(compare = ascending$3) {
        if (compare === ascending$3) return ascendingDefined;
        if (typeof compare !== "function") throw new TypeError("compare is not a function");
        return (a, b)=>{
            const x = compare(a, b);
            if (x || x === 0) return x;
            return (compare(b, b) === 0) - (compare(a, a) === 0);
        };
    }
    function ascendingDefined(a, b) {
        return (a == null || !(a >= a)) - (b == null || !(b >= b)) || (a < b ? -1 : a > b ? 1 : 0);
    }
    function groupSort(values, reduce, key) {
        return (reduce.length !== 2 ? sort(rollup(values, reduce, key), ([ak, av], [bk, bv])=>ascending$3(av, bv) || ascending$3(ak, bk)) : sort(group(values, key), ([ak, av], [bk, bv])=>reduce(av, bv) || ascending$3(ak, bk))).map(([key])=>key);
    }
    var array$5 = Array.prototype;
    var slice$3 = array$5.slice;
    function constant$b(x) {
        return ()=>x;
    }
    var e10 = Math.sqrt(50), e5 = Math.sqrt(10), e2 = Math.sqrt(2);
    function ticks(start, stop, count) {
        var reverse, i = -1, n, ticks, step;
        stop = +stop, start = +start, count = +count;
        if (start === stop && count > 0) return [
            start
        ];
        if (reverse = stop < start) n = start, start = stop, stop = n;
        if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
        if (step > 0) {
            let r0 = Math.round(start / step), r1 = Math.round(stop / step);
            if (r0 * step < start) ++r0;
            if (r1 * step > stop) --r1;
            ticks = new Array(n = r1 - r0 + 1);
            while(++i < n)ticks[i] = (r0 + i) * step;
        } else {
            step = -step;
            let r0 = Math.round(start * step), r1 = Math.round(stop * step);
            if (r0 / step < start) ++r0;
            if (r1 / step > stop) --r1;
            ticks = new Array(n = r1 - r0 + 1);
            while(++i < n)ticks[i] = (r0 + i) / step;
        }
        if (reverse) ticks.reverse();
        return ticks;
    }
    function tickIncrement(start, stop, count) {
        var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
        return power >= 0 ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
    }
    function tickStep(start, stop, count) {
        var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
        if (error >= e10) step1 *= 10;
        else if (error >= e5) step1 *= 5;
        else if (error >= e2) step1 *= 2;
        return stop < start ? -step1 : step1;
    }
    function nice$1(start, stop, count) {
        let prestep;
        while(true){
            const step = tickIncrement(start, stop, count);
            if (step === prestep || step === 0 || !isFinite(step)) return [
                start,
                stop
            ];
            else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            }
            prestep = step;
        }
    }
    function thresholdSturges(values) {
        return Math.ceil(Math.log(count$1(values)) / Math.LN2) + 1;
    }
    function bin() {
        var value = identity$9, domain = extent$1, threshold = thresholdSturges;
        function histogram(data) {
            if (!Array.isArray(data)) data = Array.from(data);
            var i, n = data.length, x, step, values = new Array(n);
            for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
            var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1);
            // Convert number of thresholds into uniform thresholds, and nice the
            // default domain accordingly.
            if (!Array.isArray(tz)) {
                const max = x1, tn = +tz;
                if (domain === extent$1) [x0, x1] = nice$1(x0, x1, tn);
                tz = ticks(x0, x1, tn);
                // If the domain is aligned with the first tick (which it will by
                // default), then we can use quantization rather than bisection to bin
                // values, which is substantially faster.
                if (tz[0] <= x0) step = tickIncrement(x0, x1, tn);
                // If the last threshold is coincident with the domain’s upper bound, the
                // last bin will be zero-width. If the default domain is used, and this
                // last threshold is coincident with the maximum input value, we can
                // extend the niced upper bound by one tick to ensure uniform bin widths;
                // otherwise, we simply remove the last threshold. Note that we don’t
                // coerce values or the domain to numbers, and thus must be careful to
                // compare order (>=) rather than strict equality (===)!
                if (tz[tz.length - 1] >= x1) {
                    if (max >= x1 && domain === extent$1) {
                        const step = tickIncrement(x0, x1, tn);
                        if (isFinite(step)) {
                            if (step > 0) x1 = (Math.floor(x1 / step) + 1) * step;
                            else if (step < 0) x1 = (Math.ceil(x1 * -step) + 1) / -step;
                        }
                    } else tz.pop();
                }
            }
            // Remove any thresholds outside the domain.
            // Be careful not to mutate an array owned by the user!
            var m = tz.length, a = 0, b = m;
            while(tz[a] <= x0)++a;
            while(tz[b - 1] > x1)--b;
            if (a || b < m) tz = tz.slice(a, b), m = b - a;
            var bins = new Array(m + 1), bin;
            // Initialize bins.
            for(i = 0; i <= m; ++i){
                bin = bins[i] = [];
                bin.x0 = i > 0 ? tz[i - 1] : x0;
                bin.x1 = i < m ? tz[i] : x1;
            }
            // Assign data to bins by value, ignoring any outside the domain.
            if (isFinite(step)) {
                if (step > 0) {
                    for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[Math.min(m, Math.floor((x - x0) / step))].push(data[i]);
                } else if (step < 0) {
                    for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) {
                        const j = Math.floor((x0 - x) * step);
                        bins[Math.min(m, j + (tz[j] <= x))].push(data[i]); // handle off-by-one due to rounding
                    }
                }
            } else {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[bisect(tz, x, 0, m)].push(data[i]);
            }
            return bins;
        }
        histogram.value = function(_) {
            return arguments.length ? (value = typeof _ === "function" ? _ : constant$b(_), histogram) : value;
        };
        histogram.domain = function(_) {
            return arguments.length ? (domain = typeof _ === "function" ? _ : constant$b([
                _[0],
                _[1]
            ]), histogram) : domain;
        };
        histogram.thresholds = function(_) {
            return arguments.length ? (threshold = typeof _ === "function" ? _ : constant$b(Array.isArray(_) ? slice$3.call(_) : _), histogram) : threshold;
        };
        return histogram;
    }
    function max$3(values, valueof) {
        let max;
        if (valueof === undefined) {
            for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
        } else {
            let index = -1;
            for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
        }
        return max;
    }
    function maxIndex(values, valueof) {
        let max;
        let maxIndex = -1;
        let index = -1;
        if (valueof === undefined) for (const value of values){
            ++index;
            if (value != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
        }
        else {
            for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
        }
        return maxIndex;
    }
    function min$2(values, valueof) {
        let min;
        if (valueof === undefined) {
            for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
        } else {
            let index = -1;
            for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
        }
        return min;
    }
    function minIndex(values, valueof) {
        let min;
        let minIndex = -1;
        let index = -1;
        if (valueof === undefined) for (const value of values){
            ++index;
            if (value != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
        }
        else {
            for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
        }
        return minIndex;
    }
    // Based on https://github.com/mourner/quickselect
    // ISC license, Copyright 2018 Vladimir Agafonkin.
    function quickselect(array, k, left = 0, right = Infinity, compare) {
        k = Math.floor(k);
        left = Math.floor(Math.max(0, left));
        right = Math.floor(Math.min(array.length - 1, right));
        if (!(left <= k && k <= right)) return array;
        compare = compare === undefined ? ascendingDefined : compareDefined(compare);
        while(right > left){
            if (right - left > 600) {
                const n = right - left + 1;
                const m = k - left + 1;
                const z = Math.log(n);
                const s = 0.5 * Math.exp(2 * z / 3);
                const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
                const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
                const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
                quickselect(array, k, newLeft, newRight, compare);
            }
            const t = array[k];
            let i = left;
            let j = right;
            swap$1(array, left, k);
            if (compare(array[right], t) > 0) swap$1(array, left, right);
            while(i < j){
                swap$1(array, i, j), ++i, --j;
                while(compare(array[i], t) < 0)++i;
                while(compare(array[j], t) > 0)--j;
            }
            if (compare(array[left], t) === 0) swap$1(array, left, j);
            else ++j, swap$1(array, j, right);
            if (j <= k) left = j + 1;
            if (k <= j) right = j - 1;
        }
        return array;
    }
    function swap$1(array, i, j) {
        const t = array[i];
        array[i] = array[j];
        array[j] = t;
    }
    function greatest(values, compare = ascending$3) {
        let max;
        let defined = false;
        if (compare.length === 1) {
            let maxValue;
            for (const element of values){
                const value = compare(element);
                if (defined ? ascending$3(value, maxValue) > 0 : ascending$3(value, value) === 0) {
                    max = element;
                    maxValue = value;
                    defined = true;
                }
            }
        } else {
            for (const value of values)if (defined ? compare(value, max) > 0 : compare(value, value) === 0) {
                max = value;
                defined = true;
            }
        }
        return max;
    }
    function quantile$1(values, p, valueof) {
        values = Float64Array.from(numbers(values, valueof));
        if (!(n = values.length) || isNaN(p = +p)) return;
        if (p <= 0 || n < 2) return min$2(values);
        if (p >= 1) return max$3(values);
        var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = max$3(quickselect(values, i0).subarray(0, i0 + 1)), value1 = min$2(values.subarray(i0 + 1));
        return value0 + (value1 - value0) * (i - i0);
    }
    function quantileSorted(values, p, valueof = number$3) {
        if (!(n = values.length) || isNaN(p = +p)) return;
        if (p <= 0 || n < 2) return +valueof(values[0], 0, values);
        if (p >= 1) return +valueof(values[n - 1], n - 1, values);
        var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
        return value0 + (value1 - value0) * (i - i0);
    }
    function quantileIndex(values, p, valueof) {
        values = Float64Array.from(numbers(values, valueof));
        if (!(n = values.length) || isNaN(p = +p)) return;
        if (p <= 0 || n < 2) return minIndex(values);
        if (p >= 1) return maxIndex(values);
        var n, i = Math.floor((n - 1) * p), order = (i, j)=>ascendingDefined(values[i], values[j]), index = quickselect(Uint32Array.from(values, (_, i)=>i), i, 0, n - 1, order);
        return greatest(index.subarray(0, i + 1), (i)=>values[i]);
    }
    function thresholdFreedmanDiaconis(values, min, max) {
        return Math.ceil((max - min) / (2 * (quantile$1(values, 0.75) - quantile$1(values, 0.25)) * Math.pow(count$1(values), -1 / 3)));
    }
    function thresholdScott(values, min, max) {
        return Math.ceil((max - min) * Math.cbrt(count$1(values)) / (3.49 * deviation(values)));
    }
    function mean(values, valueof) {
        let count = 0;
        let sum = 0;
        if (valueof === undefined) {
            for (let value of values)if (value != null && (value = +value) >= value) ++count, sum += value;
        } else {
            let index = -1;
            for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count, sum += value;
        }
        if (count) return sum / count;
    }
    function median(values, valueof) {
        return quantile$1(values, 0.5, valueof);
    }
    function medianIndex(values, valueof) {
        return quantileIndex(values, 0.5, valueof);
    }
    function* flatten(arrays) {
        for (const array of arrays)yield* array;
    }
    function merge(arrays) {
        return Array.from(flatten(arrays));
    }
    function mode(values, valueof) {
        const counts = new InternMap();
        if (valueof === undefined) {
            for (let value of values)if (value != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
        } else {
            let index = -1;
            for (let value of values)if ((value = valueof(value, ++index, values)) != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
        }
        let modeValue;
        let modeCount = 0;
        for (const [value, count] of counts)if (count > modeCount) {
            modeCount = count;
            modeValue = value;
        }
        return modeValue;
    }
    function pairs(values, pairof = pair) {
        const pairs1 = [];
        let previous;
        let first = false;
        for (const value of values){
            if (first) pairs1.push(pairof(previous, value));
            previous = value;
            first = true;
        }
        return pairs1;
    }
    function pair(a, b) {
        return [
            a,
            b
        ];
    }
    function range$2(start, stop, step) {
        start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
        var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
        while(++i < n)range[i] = start + i * step;
        return range;
    }
    function rank(values, valueof = ascending$3) {
        if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
        let V = Array.from(values);
        const R = new Float64Array(V.length);
        if (valueof.length !== 2) V = V.map(valueof), valueof = ascending$3;
        const compareIndex = (i, j)=>valueof(V[i], V[j]);
        let k, r;
        Uint32Array.from(V, (_, i)=>i).sort(valueof === ascending$3 ? (i, j)=>ascendingDefined(V[i], V[j]) : compareDefined(compareIndex)).forEach((j, i)=>{
            const c = compareIndex(j, k === undefined ? j : k);
            if (c >= 0) {
                if (k === undefined || c > 0) k = j, r = i;
                R[j] = r;
            } else R[j] = NaN;
        });
        return R;
    }
    function least(values, compare = ascending$3) {
        let min;
        let defined = false;
        if (compare.length === 1) {
            let minValue;
            for (const element of values){
                const value = compare(element);
                if (defined ? ascending$3(value, minValue) < 0 : ascending$3(value, value) === 0) {
                    min = element;
                    minValue = value;
                    defined = true;
                }
            }
        } else {
            for (const value of values)if (defined ? compare(value, min) < 0 : compare(value, value) === 0) {
                min = value;
                defined = true;
            }
        }
        return min;
    }
    function leastIndex(values, compare = ascending$3) {
        if (compare.length === 1) return minIndex(values, compare);
        let minValue;
        let min = -1;
        let index = -1;
        for (const value of values){
            ++index;
            if (min < 0 ? compare(value, value) === 0 : compare(value, minValue) < 0) {
                minValue = value;
                min = index;
            }
        }
        return min;
    }
    function greatestIndex(values, compare = ascending$3) {
        if (compare.length === 1) return maxIndex(values, compare);
        let maxValue;
        let max = -1;
        let index = -1;
        for (const value of values){
            ++index;
            if (max < 0 ? compare(value, value) === 0 : compare(value, maxValue) > 0) {
                maxValue = value;
                max = index;
            }
        }
        return max;
    }
    function scan(values, compare) {
        const index = leastIndex(values, compare);
        return index < 0 ? undefined : index;
    }
    var shuffle$1 = shuffler(Math.random);
    function shuffler(random) {
        return function shuffle(array, i0 = 0, i1 = array.length) {
            let m = i1 - (i0 = +i0);
            while(m){
                const i = random() * m-- | 0, t = array[m + i0];
                array[m + i0] = array[i + i0];
                array[i + i0] = t;
            }
            return array;
        };
    }
    function sum$2(values, valueof) {
        let sum = 0;
        if (valueof === undefined) {
            for (let value of values)if (value = +value) sum += value;
        } else {
            let index = -1;
            for (let value of values)if (value = +valueof(value, ++index, values)) sum += value;
        }
        return sum;
    }
    function transpose(matrix) {
        if (!(n = matrix.length)) return [];
        for(var i = -1, m = min$2(matrix, length$2), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
        return transpose;
    }
    function length$2(d) {
        return d.length;
    }
    function zip() {
        return transpose(arguments);
    }
    function every(values, test) {
        if (typeof test !== "function") throw new TypeError("test is not a function");
        let index = -1;
        for (const value of values){
            if (!test(value, ++index, values)) return false;
        }
        return true;
    }
    function some(values, test) {
        if (typeof test !== "function") throw new TypeError("test is not a function");
        let index = -1;
        for (const value of values){
            if (test(value, ++index, values)) return true;
        }
        return false;
    }
    function filter$1(values, test) {
        if (typeof test !== "function") throw new TypeError("test is not a function");
        const array = [];
        let index = -1;
        for (const value of values)if (test(value, ++index, values)) array.push(value);
        return array;
    }
    function map$1(values, mapper) {
        if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
        if (typeof mapper !== "function") throw new TypeError("mapper is not a function");
        return Array.from(values, (value, index)=>mapper(value, index, values));
    }
    function reduce(values, reducer, value) {
        if (typeof reducer !== "function") throw new TypeError("reducer is not a function");
        const iterator = values[Symbol.iterator]();
        let done, next, index = -1;
        if (arguments.length < 3) {
            ({ done: done, value: value } = iterator.next());
            if (done) return;
            ++index;
        }
        while({ done: done, value: next } = iterator.next(), !done)value = reducer(value, next, ++index, values);
        return value;
    }
    function reverse$1(values) {
        if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
        return Array.from(values).reverse();
    }
    function difference(values, ...others) {
        values = new InternSet(values);
        for (const other of others)for (const value of other)values.delete(value);
        return values;
    }
    function disjoint(values, other) {
        const iterator = other[Symbol.iterator](), set = new InternSet();
        for (const v of values){
            if (set.has(v)) return false;
            let value, done;
            while({ value: value, done: done } = iterator.next()){
                if (done) break;
                if (Object.is(v, value)) return false;
                set.add(value);
            }
        }
        return true;
    }
    function intersection(values, ...others) {
        values = new InternSet(values);
        others = others.map(set$2);
        out: for (const value of values){
            for (const other of others)if (!other.has(value)) {
                values.delete(value);
                continue out;
            }
        }
        return values;
    }
    function set$2(values) {
        return values instanceof InternSet ? values : new InternSet(values);
    }
    function superset(values, other) {
        const iterator = values[Symbol.iterator](), set = new Set();
        for (const o of other){
            const io = intern(o);
            if (set.has(io)) continue;
            let value, done;
            while({ value: value, done: done } = iterator.next()){
                if (done) return false;
                const ivalue = intern(value);
                set.add(ivalue);
                if (Object.is(io, ivalue)) break;
            }
        }
        return true;
    }
    function intern(value) {
        return value !== null && typeof value === "object" ? value.valueOf() : value;
    }
    function subset(values, other) {
        return superset(other, values);
    }
    function union(...others) {
        const set = new InternSet();
        for (const other of others)for (const o of other)set.add(o);
        return set;
    }
    function identity$8(x) {
        return x;
    }
    var top = 1, right = 2, bottom = 3, left = 4, epsilon$6 = 1e-6;
    function translateX(x) {
        return "translate(" + x + ",0)";
    }
    function translateY(y) {
        return "translate(0," + y + ")";
    }
    function number$2(scale) {
        return (d)=>+scale(d);
    }
    function center$1(scale, offset) {
        offset = Math.max(0, scale.bandwidth() - offset * 2) / 2;
        if (scale.round()) offset = Math.round(offset);
        return (d)=>+scale(d) + offset;
    }
    function entering() {
        return !this.__axis;
    }
    function axis(orient, scale) {
        var tickArguments = [], tickValues = null, tickFormat = null, tickSizeInner = 6, tickSizeOuter = 6, tickPadding = 3, offset = typeof window !== "undefined" && window.devicePixelRatio > 1 ? 0 : 0.5, k = orient === top || orient === left ? -1 : 1, x = orient === left || orient === right ? "x" : "y", transform = orient === top || orient === bottom ? translateX : translateY;
        function axis(context) {
            var values = tickValues == null ? scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain() : tickValues, format = tickFormat == null ? scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : identity$8 : tickFormat, spacing = Math.max(tickSizeInner, 0) + tickPadding, range = scale.range(), range0 = +range[0] + offset, range1 = +range[range.length - 1] + offset, position = (scale.bandwidth ? center$1 : number$2)(scale.copy(), offset), selection = context.selection ? context.selection() : context, path = selection.selectAll(".domain").data([
                null
            ]), tick = selection.selectAll(".tick").data(values, scale).order(), tickExit = tick.exit(), tickEnter = tick.enter().append("g").attr("class", "tick"), line = tick.select("line"), text = tick.select("text");
            path = path.merge(path.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "currentColor"));
            tick = tick.merge(tickEnter);
            line = line.merge(tickEnter.append("line").attr("stroke", "currentColor").attr(x + "2", k * tickSizeInner));
            text = text.merge(tickEnter.append("text").attr("fill", "currentColor").attr(x, k * spacing).attr("dy", orient === top ? "0em" : orient === bottom ? "0.71em" : "0.32em"));
            if (context !== selection) {
                path = path.transition(context);
                tick = tick.transition(context);
                line = line.transition(context);
                text = text.transition(context);
                tickExit = tickExit.transition(context).attr("opacity", epsilon$6).attr("transform", function(d) {
                    return isFinite(d = position(d)) ? transform(d + offset) : this.getAttribute("transform");
                });
                tickEnter.attr("opacity", epsilon$6).attr("transform", function(d) {
                    var p = this.parentNode.__axis;
                    return transform((p && isFinite(p = p(d)) ? p : position(d)) + offset);
                });
            }
            tickExit.remove();
            path.attr("d", orient === left || orient === right ? tickSizeOuter ? "M" + k * tickSizeOuter + "," + range0 + "H" + offset + "V" + range1 + "H" + k * tickSizeOuter : "M" + offset + "," + range0 + "V" + range1 : tickSizeOuter ? "M" + range0 + "," + k * tickSizeOuter + "V" + offset + "H" + range1 + "V" + k * tickSizeOuter : "M" + range0 + "," + offset + "H" + range1);
            tick.attr("opacity", 1).attr("transform", function(d) {
                return transform(position(d) + offset);
            });
            line.attr(x + "2", k * tickSizeInner);
            text.attr(x, k * spacing).text(format);
            selection.filter(entering).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", orient === right ? "start" : orient === left ? "end" : "middle");
            selection.each(function() {
                this.__axis = position;
            });
        }
        axis.scale = function(_) {
            return arguments.length ? (scale = _, axis) : scale;
        };
        axis.ticks = function() {
            return tickArguments = Array.from(arguments), axis;
        };
        axis.tickArguments = function(_) {
            return arguments.length ? (tickArguments = _ == null ? [] : Array.from(_), axis) : tickArguments.slice();
        };
        axis.tickValues = function(_) {
            return arguments.length ? (tickValues = _ == null ? null : Array.from(_), axis) : tickValues && tickValues.slice();
        };
        axis.tickFormat = function(_) {
            return arguments.length ? (tickFormat = _, axis) : tickFormat;
        };
        axis.tickSize = function(_) {
            return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
        };
        axis.tickSizeInner = function(_) {
            return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
        };
        axis.tickSizeOuter = function(_) {
            return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
        };
        axis.tickPadding = function(_) {
            return arguments.length ? (tickPadding = +_, axis) : tickPadding;
        };
        axis.offset = function(_) {
            return arguments.length ? (offset = +_, axis) : offset;
        };
        return axis;
    }
    function axisTop(scale) {
        return axis(top, scale);
    }
    function axisRight(scale) {
        return axis(right, scale);
    }
    function axisBottom(scale) {
        return axis(bottom, scale);
    }
    function axisLeft(scale) {
        return axis(left, scale);
    }
    var noop$3 = {
        value: ()=>{}
    };
    function dispatch() {
        for(var i = 0, n = arguments.length, _ = {}, t; i < n; ++i){
            if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
            _[t] = [];
        }
        return new Dispatch(_);
    }
    function Dispatch(_) {
        this._ = _;
    }
    function parseTypenames$1(typenames, types) {
        return typenames.trim().split(/^|\s+/).map(function(t) {
            var name = "", i = t.indexOf(".");
            if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
            if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
            return {
                type: t,
                name: name
            };
        });
    }
    Dispatch.prototype = dispatch.prototype = {
        constructor: Dispatch,
        on: function(typename, callback) {
            var _ = this._, T = parseTypenames$1(typename + "", _), t, i = -1, n = T.length;
            // If no callback was specified, return the callback of the given type and name.
            if (arguments.length < 2) {
                while(++i < n)if ((t = (typename = T[i]).type) && (t = get$1(_[t], typename.name))) return t;
                return;
            }
            // If a type was specified, set the callback for the given type and name.
            // Otherwise, if a null callback was specified, remove callbacks of the given name.
            if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
            while(++i < n){
                if (t = (typename = T[i]).type) _[t] = set$1(_[t], typename.name, callback);
                else if (callback == null) for(t in _)_[t] = set$1(_[t], typename.name, null);
            }
            return this;
        },
        copy: function() {
            var copy = {}, _ = this._;
            for(var t in _)copy[t] = _[t].slice();
            return new Dispatch(copy);
        },
        call: function(type, that) {
            if ((n = arguments.length - 2) > 0) for(var args = new Array(n), i = 0, n, t; i < n; ++i)args[i] = arguments[i + 2];
            if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
            for(t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
        },
        apply: function(type, that, args) {
            if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
            for(var t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
        }
    };
    function get$1(type, name) {
        for(var i = 0, n = type.length, c; i < n; ++i){
            if ((c = type[i]).name === name) return c.value;
        }
    }
    function set$1(type, name, callback) {
        for(var i = 0, n = type.length; i < n; ++i)if (type[i].name === name) {
            type[i] = noop$3, type = type.slice(0, i).concat(type.slice(i + 1));
            break;
        }
        if (callback != null) type.push({
            name: name,
            value: callback
        });
        return type;
    }
    var xhtml = "http://www.w3.org/1999/xhtml";
    var namespaces = {
        svg: "http://www.w3.org/2000/svg",
        xhtml: xhtml,
        xlink: "http://www.w3.org/1999/xlink",
        xml: "http://www.w3.org/XML/1998/namespace",
        xmlns: "http://www.w3.org/2000/xmlns/"
    };
    function namespace(name) {
        var prefix = name += "", i = prefix.indexOf(":");
        if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
        return namespaces.hasOwnProperty(prefix) ? {
            space: namespaces[prefix],
            local: name
        } : name; // eslint-disable-line no-prototype-builtins
    }
    function creatorInherit(name) {
        return function() {
            var document1 = this.ownerDocument, uri = this.namespaceURI;
            return uri === xhtml && document1.documentElement.namespaceURI === xhtml ? document1.createElement(name) : document1.createElementNS(uri, name);
        };
    }
    function creatorFixed(fullname) {
        return function() {
            return this.ownerDocument.createElementNS(fullname.space, fullname.local);
        };
    }
    function creator(name) {
        var fullname = namespace(name);
        return (fullname.local ? creatorFixed : creatorInherit)(fullname);
    }
    function none$2() {}
    function selector(selector) {
        return selector == null ? none$2 : function() {
            return this.querySelector(selector);
        };
    }
    function selection_select(select) {
        if (typeof select !== "function") select = selector(select);
        for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
                if ("__data__" in node) subnode.__data__ = node.__data__;
                subgroup[i] = subnode;
            }
        }
        return new Selection$1(subgroups, this._parents);
    }
    // Given something array like (or null), returns something that is strictly an
    // array. This is used to ensure that array-like objects passed to d3.selectAll
    // or selection.selectAll are converted into proper arrays when creating a
    // selection; we don’t ever want to create a selection backed by a live
    // HTMLCollection or NodeList. However, note that selection.selectAll will use a
    // static NodeList as a group, since it safely derived from querySelectorAll.
    function array$4(x) {
        return x == null ? [] : Array.isArray(x) ? x : Array.from(x);
    }
    function empty$1() {
        return [];
    }
    function selectorAll(selector) {
        return selector == null ? empty$1 : function() {
            return this.querySelectorAll(selector);
        };
    }
    function arrayAll(select) {
        return function() {
            return array$4(select.apply(this, arguments));
        };
    }
    function selection_selectAll(select) {
        if (typeof select === "function") select = arrayAll(select);
        else select = selectorAll(select);
        for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
                subgroups.push(select.call(node, node.__data__, i, group));
                parents.push(node);
            }
        }
        return new Selection$1(subgroups, parents);
    }
    function matcher(selector) {
        return function() {
            return this.matches(selector);
        };
    }
    function childMatcher(selector) {
        return function(node) {
            return node.matches(selector);
        };
    }
    var find$1 = Array.prototype.find;
    function childFind(match) {
        return function() {
            return find$1.call(this.children, match);
        };
    }
    function childFirst() {
        return this.firstElementChild;
    }
    function selection_selectChild(match) {
        return this.select(match == null ? childFirst : childFind(typeof match === "function" ? match : childMatcher(match)));
    }
    var filter = Array.prototype.filter;
    function children() {
        return Array.from(this.children);
    }
    function childrenFilter(match) {
        return function() {
            return filter.call(this.children, match);
        };
    }
    function selection_selectChildren(match) {
        return this.selectAll(match == null ? children : childrenFilter(typeof match === "function" ? match : childMatcher(match)));
    }
    function selection_filter(match) {
        if (typeof match !== "function") match = matcher(match);
        for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
        }
        return new Selection$1(subgroups, this._parents);
    }
    function sparse(update) {
        return new Array(update.length);
    }
    function selection_enter() {
        return new Selection$1(this._enter || this._groups.map(sparse), this._parents);
    }
    function EnterNode(parent, datum) {
        this.ownerDocument = parent.ownerDocument;
        this.namespaceURI = parent.namespaceURI;
        this._next = null;
        this._parent = parent;
        this.__data__ = datum;
    }
    EnterNode.prototype = {
        constructor: EnterNode,
        appendChild: function(child) {
            return this._parent.insertBefore(child, this._next);
        },
        insertBefore: function(child, next) {
            return this._parent.insertBefore(child, next);
        },
        querySelector: function(selector) {
            return this._parent.querySelector(selector);
        },
        querySelectorAll: function(selector) {
            return this._parent.querySelectorAll(selector);
        }
    };
    function constant$a(x) {
        return function() {
            return x;
        };
    }
    function bindIndex(parent, group, enter, update, exit, data) {
        var i = 0, node, groupLength = group.length, dataLength = data.length;
        // Put any non-null nodes that fit into update.
        // Put any null nodes into enter.
        // Put any remaining data into enter.
        for(; i < dataLength; ++i)if (node = group[i]) {
            node.__data__ = data[i];
            update[i] = node;
        } else enter[i] = new EnterNode(parent, data[i]);
        // Put any non-null nodes that don’t fit into exit.
        for(; i < groupLength; ++i)if (node = group[i]) exit[i] = node;
    }
    function bindKey(parent, group, enter, update, exit, data, key) {
        var i, node, nodeByKeyValue = new Map, groupLength = group.length, dataLength = data.length, keyValues = new Array(groupLength), keyValue;
        // Compute the key for each node.
        // If multiple nodes have the same key, the duplicates are added to exit.
        for(i = 0; i < groupLength; ++i)if (node = group[i]) {
            keyValues[i] = keyValue = key.call(node, node.__data__, i, group) + "";
            if (nodeByKeyValue.has(keyValue)) exit[i] = node;
            else nodeByKeyValue.set(keyValue, node);
        }
        // Compute the key for each datum.
        // If there a node associated with this key, join and add it to update.
        // If there is not (or the key is a duplicate), add it to enter.
        for(i = 0; i < dataLength; ++i){
            keyValue = key.call(parent, data[i], i, data) + "";
            if (node = nodeByKeyValue.get(keyValue)) {
                update[i] = node;
                node.__data__ = data[i];
                nodeByKeyValue.delete(keyValue);
            } else enter[i] = new EnterNode(parent, data[i]);
        }
        // Add any remaining nodes that were not bound to data to exit.
        for(i = 0; i < groupLength; ++i)if ((node = group[i]) && nodeByKeyValue.get(keyValues[i]) === node) exit[i] = node;
    }
    function datum(node) {
        return node.__data__;
    }
    function selection_data(value, key) {
        if (!arguments.length) return Array.from(this, datum);
        var bind = key ? bindKey : bindIndex, parents = this._parents, groups = this._groups;
        if (typeof value !== "function") value = constant$a(value);
        for(var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j){
            var parent = parents[j], group = groups[j], groupLength = group.length, data = arraylike(value.call(parent, parent && parent.__data__, j, parents)), dataLength = data.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
            bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
            // Now connect the enter nodes to their following update node, such that
            // appendChild can insert the materialized enter node before this node,
            // rather than at the end of the parent node.
            for(var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0)if (previous = enterGroup[i0]) {
                if (i0 >= i1) i1 = i0 + 1;
                while(!(next = updateGroup[i1]) && ++i1 < dataLength);
                previous._next = next || null;
            }
        }
        update = new Selection$1(update, parents);
        update._enter = enter;
        update._exit = exit;
        return update;
    }
    // Given some data, this returns an array-like view of it: an object that
    // exposes a length property and allows numeric indexing. Note that unlike
    // selectAll, this isn’t worried about “live” collections because the resulting
    // array will only be used briefly while data is being bound. (It is possible to
    // cause the data to change while iterating by using a key function, but please
    // don’t; we’d rather avoid a gratuitous copy.)
    function arraylike(data) {
        return typeof data === "object" && "length" in data ? data // Array, TypedArray, NodeList, array-like
         : Array.from(data); // Map, Set, iterable, string, or anything else
    }
    function selection_exit() {
        return new Selection$1(this._exit || this._groups.map(sparse), this._parents);
    }
    function selection_join(onenter, onupdate, onexit) {
        var enter = this.enter(), update = this, exit = this.exit();
        if (typeof onenter === "function") {
            enter = onenter(enter);
            if (enter) enter = enter.selection();
        } else enter = enter.append(onenter + "");
        if (onupdate != null) {
            update = onupdate(update);
            if (update) update = update.selection();
        }
        if (onexit == null) exit.remove();
        else onexit(exit);
        return enter && update ? enter.merge(update).order() : update;
    }
    function selection_merge(context) {
        var selection = context.selection ? context.selection() : context;
        for(var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
            for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
        }
        for(; j < m0; ++j)merges[j] = groups0[j];
        return new Selection$1(merges, this._parents);
    }
    function selection_order() {
        for(var groups = this._groups, j = -1, m = groups.length; ++j < m;){
            for(var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;)if (node = group[i]) {
                if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
                next = node;
            }
        }
        return this;
    }
    function selection_sort(compare) {
        if (!compare) compare = ascending$2;
        function compareNode(a, b) {
            return a && b ? compare(a.__data__, b.__data__) : !a - !b;
        }
        for(var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group[i]) sortgroup[i] = node;
            sortgroup.sort(compareNode);
        }
        return new Selection$1(sortgroups, this._parents).order();
    }
    function ascending$2(a, b) {
        return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
    }
    function selection_call() {
        var callback = arguments[0];
        arguments[0] = this;
        callback.apply(null, arguments);
        return this;
    }
    function selection_nodes() {
        return Array.from(this);
    }
    function selection_node() {
        for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j)for(var group = groups[j], i = 0, n = group.length; i < n; ++i){
            var node = group[i];
            if (node) return node;
        }
        return null;
    }
    function selection_size() {
        let size = 0;
        for (const node of this)++size; // eslint-disable-line no-unused-vars
        return size;
    }
    function selection_empty() {
        return !this.node();
    }
    function selection_each(callback) {
        for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
            for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) callback.call(node, node.__data__, i, group);
        }
        return this;
    }
    function attrRemove$1(name) {
        return function() {
            this.removeAttribute(name);
        };
    }
    function attrRemoveNS$1(fullname) {
        return function() {
            this.removeAttributeNS(fullname.space, fullname.local);
        };
    }
    function attrConstant$1(name, value) {
        return function() {
            this.setAttribute(name, value);
        };
    }
    function attrConstantNS$1(fullname, value) {
        return function() {
            this.setAttributeNS(fullname.space, fullname.local, value);
        };
    }
    function attrFunction$1(name, value) {
        return function() {
            var v = value.apply(this, arguments);
            if (v == null) this.removeAttribute(name);
            else this.setAttribute(name, v);
        };
    }
    function attrFunctionNS$1(fullname, value) {
        return function() {
            var v = value.apply(this, arguments);
            if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
            else this.setAttributeNS(fullname.space, fullname.local, v);
        };
    }
    function selection_attr(name, value) {
        var fullname = namespace(name);
        if (arguments.length < 2) {
            var node = this.node();
            return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
        }
        return this.each((value == null ? fullname.local ? attrRemoveNS$1 : attrRemove$1 : typeof value === "function" ? fullname.local ? attrFunctionNS$1 : attrFunction$1 : fullname.local ? attrConstantNS$1 : attrConstant$1)(fullname, value));
    }
    function defaultView(node) {
        return node.ownerDocument && node.ownerDocument.defaultView // node is a Node
         || node.document && node // node is a Window
         || node.defaultView; // node is a Document
    }
    function styleRemove$1(name) {
        return function() {
            this.style.removeProperty(name);
        };
    }
    function styleConstant$1(name, value, priority) {
        return function() {
            this.style.setProperty(name, value, priority);
        };
    }
    function styleFunction$1(name, value, priority) {
        return function() {
            var v = value.apply(this, arguments);
            if (v == null) this.style.removeProperty(name);
            else this.style.setProperty(name, v, priority);
        };
    }
    function selection_style(name, value, priority) {
        return arguments.length > 1 ? this.each((value == null ? styleRemove$1 : typeof value === "function" ? styleFunction$1 : styleConstant$1)(name, value, priority == null ? "" : priority)) : styleValue(this.node(), name);
    }
    function styleValue(node, name) {
        return node.style.getPropertyValue(name) || defaultView(node).getComputedStyle(node, null).getPropertyValue(name);
    }
    function propertyRemove(name) {
        return function() {
            delete this[name];
        };
    }
    function propertyConstant(name, value) {
        return function() {
            this[name] = value;
        };
    }
    function propertyFunction(name, value) {
        return function() {
            var v = value.apply(this, arguments);
            if (v == null) delete this[name];
            else this[name] = v;
        };
    }
    function selection_property(name, value) {
        return arguments.length > 1 ? this.each((value == null ? propertyRemove : typeof value === "function" ? propertyFunction : propertyConstant)(name, value)) : this.node()[name];
    }
    function classArray(string) {
        return string.trim().split(/^|\s+/);
    }
    function classList(node) {
        return node.classList || new ClassList(node);
    }
    function ClassList(node) {
        this._node = node;
        this._names = classArray(node.getAttribute("class") || "");
    }
    ClassList.prototype = {
        add: function(name) {
            var i = this._names.indexOf(name);
            if (i < 0) {
                this._names.push(name);
                this._node.setAttribute("class", this._names.join(" "));
            }
        },
        remove: function(name) {
            var i = this._names.indexOf(name);
            if (i >= 0) {
                this._names.splice(i, 1);
                this._node.setAttribute("class", this._names.join(" "));
            }
        },
        contains: function(name) {
            return this._names.indexOf(name) >= 0;
        }
    };
    function classedAdd(node, names) {
        var list = classList(node), i = -1, n = names.length;
        while(++i < n)list.add(names[i]);
    }
    function classedRemove(node, names) {
        var list = classList(node), i = -1, n = names.length;
        while(++i < n)list.remove(names[i]);
    }
    function classedTrue(names) {
        return function() {
            classedAdd(this, names);
        };
    }
    function classedFalse(names) {
        return function() {
            classedRemove(this, names);
        };
    }
    function classedFunction(names, value) {
        return function() {
            (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
        };
    }
    function selection_classed(name, value) {
        var names = classArray(name + "");
        if (arguments.length < 2) {
            var list = classList(this.node()), i = -1, n = names.length;
            while(++i < n)if (!list.contains(names[i])) return false;
            return true;
        }
        return this.each((typeof value === "function" ? classedFunction : value ? classedTrue : classedFalse)(names, value));
    }
    function textRemove() {
        this.textContent = "";
    }
    function textConstant$1(value) {
        return function() {
            this.textContent = value;
        };
    }
    function textFunction$1(value) {
        return function() {
            var v = value.apply(this, arguments);
            this.textContent = v == null ? "" : v;
        };
    }
    function selection_text(value) {
        return arguments.length ? this.each(value == null ? textRemove : (typeof value === "function" ? textFunction$1 : textConstant$1)(value)) : this.node().textContent;
    }
    function htmlRemove() {
        this.innerHTML = "";
    }
    function htmlConstant(value) {
        return function() {
            this.innerHTML = value;
        };
    }
    function htmlFunction(value) {
        return function() {
            var v = value.apply(this, arguments);
            this.innerHTML = v == null ? "" : v;
        };
    }
    function selection_html(value) {
        return arguments.length ? this.each(value == null ? htmlRemove : (typeof value === "function" ? htmlFunction : htmlConstant)(value)) : this.node().innerHTML;
    }
    function raise() {
        if (this.nextSibling) this.parentNode.appendChild(this);
    }
    function selection_raise() {
        return this.each(raise);
    }
    function lower() {
        if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
    }
    function selection_lower() {
        return this.each(lower);
    }
    function selection_append(name) {
        var create = typeof name === "function" ? name : creator(name);
        return this.select(function() {
            return this.appendChild(create.apply(this, arguments));
        });
    }
    function constantNull() {
        return null;
    }
    function selection_insert(name, before) {
        var create = typeof name === "function" ? name : creator(name), select = before == null ? constantNull : typeof before === "function" ? before : selector(before);
        return this.select(function() {
            return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
        });
    }
    function remove() {
        var parent = this.parentNode;
        if (parent) parent.removeChild(this);
    }
    function selection_remove() {
        return this.each(remove);
    }
    function selection_cloneShallow() {
        var clone = this.cloneNode(false), parent = this.parentNode;
        return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
    }
    function selection_cloneDeep() {
        var clone = this.cloneNode(true), parent = this.parentNode;
        return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
    }
    function selection_clone(deep) {
        return this.select(deep ? selection_cloneDeep : selection_cloneShallow);
    }
    function selection_datum(value) {
        return arguments.length ? this.property("__data__", value) : this.node().__data__;
    }
    function contextListener(listener) {
        return function(event) {
            listener.call(this, event, this.__data__);
        };
    }
    function parseTypenames(typenames) {
        return typenames.trim().split(/^|\s+/).map(function(t) {
            var name = "", i = t.indexOf(".");
            if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
            return {
                type: t,
                name: name
            };
        });
    }
    function onRemove(typename) {
        return function() {
            var on = this.__on;
            if (!on) return;
            for(var j = 0, i = -1, m = on.length, o; j < m; ++j)if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) this.removeEventListener(o.type, o.listener, o.options);
            else on[++i] = o;
            if (++i) on.length = i;
            else delete this.__on;
        };
    }
    function onAdd(typename, value, options) {
        return function() {
            var on = this.__on, o, listener = contextListener(value);
            if (on) {
                for(var j = 0, m = on.length; j < m; ++j)if ((o = on[j]).type === typename.type && o.name === typename.name) {
                    this.removeEventListener(o.type, o.listener, o.options);
                    this.addEventListener(o.type, o.listener = listener, o.options = options);
                    o.value = value;
                    return;
                }
            }
            this.addEventListener(typename.type, listener, options);
            o = {
                type: typename.type,
                name: typename.name,
                value: value,
                listener: listener,
                options: options
            };
            if (!on) this.__on = [
                o
            ];
            else on.push(o);
        };
    }
    function selection_on(typename, value, options) {
        var typenames = parseTypenames(typename + ""), i, n = typenames.length, t;
        if (arguments.length < 2) {
            var on = this.node().__on;
            if (on) for(var j = 0, m = on.length, o; j < m; ++j)for(i = 0, o = on[j]; i < n; ++i){
                if ((t = typenames[i]).type === o.type && t.name === o.name) return o.value;
            }
            return;
        }
        on = value ? onAdd : onRemove;
        for(i = 0; i < n; ++i)this.each(on(typenames[i], value, options));
        return this;
    }
    function dispatchEvent(node, type, params) {
        var window1 = defaultView(node), event = window1.CustomEvent;
        if (typeof event === "function") event = new event(type, params);
        else {
            event = window1.document.createEvent("Event");
            if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
            else event.initEvent(type, false, false);
        }
        node.dispatchEvent(event);
    }
    function dispatchConstant(type, params) {
        return function() {
            return dispatchEvent(this, type, params);
        };
    }
    function dispatchFunction(type, params) {
        return function() {
            return dispatchEvent(this, type, params.apply(this, arguments));
        };
    }
    function selection_dispatch(type, params) {
        return this.each((typeof params === "function" ? dispatchFunction : dispatchConstant)(type, params));
    }
    function* selection_iterator() {
        for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
            for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) yield node;
        }
    }
    var root$1 = [
        null
    ];
    function Selection$1(groups, parents) {
        this._groups = groups;
        this._parents = parents;
    }
    function selection() {
        return new Selection$1([
            [
                document.documentElement
            ]
        ], root$1);
    }
    function selection_selection() {
        return this;
    }
    Selection$1.prototype = selection.prototype = {
        constructor: Selection$1,
        select: selection_select,
        selectAll: selection_selectAll,
        selectChild: selection_selectChild,
        selectChildren: selection_selectChildren,
        filter: selection_filter,
        data: selection_data,
        enter: selection_enter,
        exit: selection_exit,
        join: selection_join,
        merge: selection_merge,
        selection: selection_selection,
        order: selection_order,
        sort: selection_sort,
        call: selection_call,
        nodes: selection_nodes,
        node: selection_node,
        size: selection_size,
        empty: selection_empty,
        each: selection_each,
        attr: selection_attr,
        style: selection_style,
        property: selection_property,
        classed: selection_classed,
        text: selection_text,
        html: selection_html,
        raise: selection_raise,
        lower: selection_lower,
        append: selection_append,
        insert: selection_insert,
        remove: selection_remove,
        clone: selection_clone,
        datum: selection_datum,
        on: selection_on,
        dispatch: selection_dispatch,
        [Symbol.iterator]: selection_iterator
    };
    function select(selector) {
        return typeof selector === "string" ? new Selection$1([
            [
                document.querySelector(selector)
            ]
        ], [
            document.documentElement
        ]) : new Selection$1([
            [
                selector
            ]
        ], root$1);
    }
    function create$1(name) {
        return select(creator(name).call(document.documentElement));
    }
    var nextId = 0;
    function local$1() {
        return new Local;
    }
    function Local() {
        this._ = "@" + (++nextId).toString(36);
    }
    Local.prototype = local$1.prototype = {
        constructor: Local,
        get: function(node) {
            var id = this._;
            while(!(id in node))if (!(node = node.parentNode)) return;
            return node[id];
        },
        set: function(node, value) {
            return node[this._] = value;
        },
        remove: function(node) {
            return this._ in node && delete node[this._];
        },
        toString: function() {
            return this._;
        }
    };
    function sourceEvent(event) {
        let sourceEvent;
        while(sourceEvent = event.sourceEvent)event = sourceEvent;
        return event;
    }
    function pointer(event, node) {
        event = sourceEvent(event);
        if (node === undefined) node = event.currentTarget;
        if (node) {
            var svg = node.ownerSVGElement || node;
            if (svg.createSVGPoint) {
                var point = svg.createSVGPoint();
                point.x = event.clientX, point.y = event.clientY;
                point = point.matrixTransform(node.getScreenCTM().inverse());
                return [
                    point.x,
                    point.y
                ];
            }
            if (node.getBoundingClientRect) {
                var rect = node.getBoundingClientRect();
                return [
                    event.clientX - rect.left - node.clientLeft,
                    event.clientY - rect.top - node.clientTop
                ];
            }
        }
        return [
            event.pageX,
            event.pageY
        ];
    }
    function pointers(events, node) {
        if (events.target) {
            events = sourceEvent(events);
            if (node === undefined) node = events.currentTarget;
            events = events.touches || [
                events
            ];
        }
        return Array.from(events, (event)=>pointer(event, node));
    }
    function selectAll(selector) {
        return typeof selector === "string" ? new Selection$1([
            document.querySelectorAll(selector)
        ], [
            document.documentElement
        ]) : new Selection$1([
            array$4(selector)
        ], root$1);
    }
    // These are typically used in conjunction with noevent to ensure that we can
    // preventDefault on the event.
    const nonpassive = {
        passive: false
    };
    const nonpassivecapture = {
        capture: true,
        passive: false
    };
    function nopropagation$2(event) {
        event.stopImmediatePropagation();
    }
    function noevent$2(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
    }
    function dragDisable(view) {
        var root = view.document.documentElement, selection = select(view).on("dragstart.drag", noevent$2, nonpassivecapture);
        if ("onselectstart" in root) selection.on("selectstart.drag", noevent$2, nonpassivecapture);
        else {
            root.__noselect = root.style.MozUserSelect;
            root.style.MozUserSelect = "none";
        }
    }
    function yesdrag(view, noclick) {
        var root = view.document.documentElement, selection = select(view).on("dragstart.drag", null);
        if (noclick) {
            selection.on("click.drag", noevent$2, nonpassivecapture);
            setTimeout(function() {
                selection.on("click.drag", null);
            }, 0);
        }
        if ("onselectstart" in root) selection.on("selectstart.drag", null);
        else {
            root.style.MozUserSelect = root.__noselect;
            delete root.__noselect;
        }
    }
    var constant$9 = (x)=>()=>x;
    function DragEvent(type, { sourceEvent: sourceEvent, subject: subject, target: target, identifier: identifier, active: active, x: x, y: y, dx: dx, dy: dy, dispatch: dispatch }) {
        Object.defineProperties(this, {
            type: {
                value: type,
                enumerable: true,
                configurable: true
            },
            sourceEvent: {
                value: sourceEvent,
                enumerable: true,
                configurable: true
            },
            subject: {
                value: subject,
                enumerable: true,
                configurable: true
            },
            target: {
                value: target,
                enumerable: true,
                configurable: true
            },
            identifier: {
                value: identifier,
                enumerable: true,
                configurable: true
            },
            active: {
                value: active,
                enumerable: true,
                configurable: true
            },
            x: {
                value: x,
                enumerable: true,
                configurable: true
            },
            y: {
                value: y,
                enumerable: true,
                configurable: true
            },
            dx: {
                value: dx,
                enumerable: true,
                configurable: true
            },
            dy: {
                value: dy,
                enumerable: true,
                configurable: true
            },
            _: {
                value: dispatch
            }
        });
    }
    DragEvent.prototype.on = function() {
        var value = this._.on.apply(this._, arguments);
        return value === this._ ? this : value;
    };
    // Ignore right-click, since that should open the context menu.
    function defaultFilter$2(event) {
        return !event.ctrlKey && !event.button;
    }
    function defaultContainer() {
        return this.parentNode;
    }
    function defaultSubject(event, d) {
        return d == null ? {
            x: event.x,
            y: event.y
        } : d;
    }
    function defaultTouchable$2() {
        return navigator.maxTouchPoints || "ontouchstart" in this;
    }
    function drag() {
        var filter = defaultFilter$2, container = defaultContainer, subject = defaultSubject, touchable = defaultTouchable$2, gestures = {}, listeners = dispatch("start", "drag", "end"), active = 0, mousedownx, mousedowny, mousemoving, touchending, clickDistance2 = 0;
        function drag(selection) {
            selection.on("mousedown.drag", mousedowned).filter(touchable).on("touchstart.drag", touchstarted).on("touchmove.drag", touchmoved, nonpassive).on("touchend.drag touchcancel.drag", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
        }
        function mousedowned(event, d) {
            if (touchending || !filter.call(this, event, d)) return;
            var gesture = beforestart(this, container.call(this, event, d), event, d, "mouse");
            if (!gesture) return;
            select(event.view).on("mousemove.drag", mousemoved, nonpassivecapture).on("mouseup.drag", mouseupped, nonpassivecapture);
            dragDisable(event.view);
            nopropagation$2(event);
            mousemoving = false;
            mousedownx = event.clientX;
            mousedowny = event.clientY;
            gesture("start", event);
        }
        function mousemoved(event) {
            noevent$2(event);
            if (!mousemoving) {
                var dx = event.clientX - mousedownx, dy = event.clientY - mousedowny;
                mousemoving = dx * dx + dy * dy > clickDistance2;
            }
            gestures.mouse("drag", event);
        }
        function mouseupped(event) {
            select(event.view).on("mousemove.drag mouseup.drag", null);
            yesdrag(event.view, mousemoving);
            noevent$2(event);
            gestures.mouse("end", event);
        }
        function touchstarted(event, d) {
            if (!filter.call(this, event, d)) return;
            var touches = event.changedTouches, c = container.call(this, event, d), n = touches.length, i, gesture;
            for(i = 0; i < n; ++i)if (gesture = beforestart(this, c, event, d, touches[i].identifier, touches[i])) {
                nopropagation$2(event);
                gesture("start", event, touches[i]);
            }
        }
        function touchmoved(event) {
            var touches = event.changedTouches, n = touches.length, i, gesture;
            for(i = 0; i < n; ++i)if (gesture = gestures[touches[i].identifier]) {
                noevent$2(event);
                gesture("drag", event, touches[i]);
            }
        }
        function touchended(event) {
            var touches = event.changedTouches, n = touches.length, i, gesture;
            if (touchending) clearTimeout(touchending);
            touchending = setTimeout(function() {
                touchending = null;
            }, 500); // Ghost clicks are delayed!
            for(i = 0; i < n; ++i)if (gesture = gestures[touches[i].identifier]) {
                nopropagation$2(event);
                gesture("end", event, touches[i]);
            }
        }
        function beforestart(that, container, event, d, identifier, touch) {
            var dispatch = listeners.copy(), p = pointer(touch || event, container), dx, dy, s;
            if ((s = subject.call(that, new DragEvent("beforestart", {
                sourceEvent: event,
                target: drag,
                identifier: identifier,
                active: active,
                x: p[0],
                y: p[1],
                dx: 0,
                dy: 0,
                dispatch: dispatch
            }), d)) == null) return;
            dx = s.x - p[0] || 0;
            dy = s.y - p[1] || 0;
            return function gesture(type, event, touch) {
                var p0 = p, n;
                switch(type){
                    case "start":
                        gestures[identifier] = gesture, n = active++;
                        break;
                    case "end":
                        delete gestures[identifier], --active; // falls through
                    case "drag":
                        p = pointer(touch || event, container), n = active;
                        break;
                }
                dispatch.call(type, that, new DragEvent(type, {
                    sourceEvent: event,
                    subject: s,
                    target: drag,
                    identifier: identifier,
                    active: n,
                    x: p[0] + dx,
                    y: p[1] + dy,
                    dx: p[0] - p0[0],
                    dy: p[1] - p0[1],
                    dispatch: dispatch
                }), d);
            };
        }
        drag.filter = function(_) {
            return arguments.length ? (filter = typeof _ === "function" ? _ : constant$9(!!_), drag) : filter;
        };
        drag.container = function(_) {
            return arguments.length ? (container = typeof _ === "function" ? _ : constant$9(_), drag) : container;
        };
        drag.subject = function(_) {
            return arguments.length ? (subject = typeof _ === "function" ? _ : constant$9(_), drag) : subject;
        };
        drag.touchable = function(_) {
            return arguments.length ? (touchable = typeof _ === "function" ? _ : constant$9(!!_), drag) : touchable;
        };
        drag.on = function() {
            var value = listeners.on.apply(listeners, arguments);
            return value === listeners ? drag : value;
        };
        drag.clickDistance = function(_) {
            return arguments.length ? (clickDistance2 = (_ = +_) * _, drag) : Math.sqrt(clickDistance2);
        };
        return drag;
    }
    function define(constructor, factory, prototype) {
        constructor.prototype = factory.prototype = prototype;
        prototype.constructor = constructor;
    }
    function extend(parent, definition) {
        var prototype = Object.create(parent.prototype);
        for(var key in definition)prototype[key] = definition[key];
        return prototype;
    }
    function Color() {}
    var darker = 0.7;
    var brighter = 1 / darker;
    var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
    var named = {
        aliceblue: 0xf0f8ff,
        antiquewhite: 0xfaebd7,
        aqua: 0x00ffff,
        aquamarine: 0x7fffd4,
        azure: 0xf0ffff,
        beige: 0xf5f5dc,
        bisque: 0xffe4c4,
        black: 0x000000,
        blanchedalmond: 0xffebcd,
        blue: 0x0000ff,
        blueviolet: 0x8a2be2,
        brown: 0xa52a2a,
        burlywood: 0xdeb887,
        cadetblue: 0x5f9ea0,
        chartreuse: 0x7fff00,
        chocolate: 0xd2691e,
        coral: 0xff7f50,
        cornflowerblue: 0x6495ed,
        cornsilk: 0xfff8dc,
        crimson: 0xdc143c,
        cyan: 0x00ffff,
        darkblue: 0x00008b,
        darkcyan: 0x008b8b,
        darkgoldenrod: 0xb8860b,
        darkgray: 0xa9a9a9,
        darkgreen: 0x006400,
        darkgrey: 0xa9a9a9,
        darkkhaki: 0xbdb76b,
        darkmagenta: 0x8b008b,
        darkolivegreen: 0x556b2f,
        darkorange: 0xff8c00,
        darkorchid: 0x9932cc,
        darkred: 0x8b0000,
        darksalmon: 0xe9967a,
        darkseagreen: 0x8fbc8f,
        darkslateblue: 0x483d8b,
        darkslategray: 0x2f4f4f,
        darkslategrey: 0x2f4f4f,
        darkturquoise: 0x00ced1,
        darkviolet: 0x9400d3,
        deeppink: 0xff1493,
        deepskyblue: 0x00bfff,
        dimgray: 0x696969,
        dimgrey: 0x696969,
        dodgerblue: 0x1e90ff,
        firebrick: 0xb22222,
        floralwhite: 0xfffaf0,
        forestgreen: 0x228b22,
        fuchsia: 0xff00ff,
        gainsboro: 0xdcdcdc,
        ghostwhite: 0xf8f8ff,
        gold: 0xffd700,
        goldenrod: 0xdaa520,
        gray: 0x808080,
        green: 0x008000,
        greenyellow: 0xadff2f,
        grey: 0x808080,
        honeydew: 0xf0fff0,
        hotpink: 0xff69b4,
        indianred: 0xcd5c5c,
        indigo: 0x4b0082,
        ivory: 0xfffff0,
        khaki: 0xf0e68c,
        lavender: 0xe6e6fa,
        lavenderblush: 0xfff0f5,
        lawngreen: 0x7cfc00,
        lemonchiffon: 0xfffacd,
        lightblue: 0xadd8e6,
        lightcoral: 0xf08080,
        lightcyan: 0xe0ffff,
        lightgoldenrodyellow: 0xfafad2,
        lightgray: 0xd3d3d3,
        lightgreen: 0x90ee90,
        lightgrey: 0xd3d3d3,
        lightpink: 0xffb6c1,
        lightsalmon: 0xffa07a,
        lightseagreen: 0x20b2aa,
        lightskyblue: 0x87cefa,
        lightslategray: 0x778899,
        lightslategrey: 0x778899,
        lightsteelblue: 0xb0c4de,
        lightyellow: 0xffffe0,
        lime: 0x00ff00,
        limegreen: 0x32cd32,
        linen: 0xfaf0e6,
        magenta: 0xff00ff,
        maroon: 0x800000,
        mediumaquamarine: 0x66cdaa,
        mediumblue: 0x0000cd,
        mediumorchid: 0xba55d3,
        mediumpurple: 0x9370db,
        mediumseagreen: 0x3cb371,
        mediumslateblue: 0x7b68ee,
        mediumspringgreen: 0x00fa9a,
        mediumturquoise: 0x48d1cc,
        mediumvioletred: 0xc71585,
        midnightblue: 0x191970,
        mintcream: 0xf5fffa,
        mistyrose: 0xffe4e1,
        moccasin: 0xffe4b5,
        navajowhite: 0xffdead,
        navy: 0x000080,
        oldlace: 0xfdf5e6,
        olive: 0x808000,
        olivedrab: 0x6b8e23,
        orange: 0xffa500,
        orangered: 0xff4500,
        orchid: 0xda70d6,
        palegoldenrod: 0xeee8aa,
        palegreen: 0x98fb98,
        paleturquoise: 0xafeeee,
        palevioletred: 0xdb7093,
        papayawhip: 0xffefd5,
        peachpuff: 0xffdab9,
        peru: 0xcd853f,
        pink: 0xffc0cb,
        plum: 0xdda0dd,
        powderblue: 0xb0e0e6,
        purple: 0x800080,
        rebeccapurple: 0x663399,
        red: 0xff0000,
        rosybrown: 0xbc8f8f,
        royalblue: 0x4169e1,
        saddlebrown: 0x8b4513,
        salmon: 0xfa8072,
        sandybrown: 0xf4a460,
        seagreen: 0x2e8b57,
        seashell: 0xfff5ee,
        sienna: 0xa0522d,
        silver: 0xc0c0c0,
        skyblue: 0x87ceeb,
        slateblue: 0x6a5acd,
        slategray: 0x708090,
        slategrey: 0x708090,
        snow: 0xfffafa,
        springgreen: 0x00ff7f,
        steelblue: 0x4682b4,
        tan: 0xd2b48c,
        teal: 0x008080,
        thistle: 0xd8bfd8,
        tomato: 0xff6347,
        turquoise: 0x40e0d0,
        violet: 0xee82ee,
        wheat: 0xf5deb3,
        white: 0xffffff,
        whitesmoke: 0xf5f5f5,
        yellow: 0xffff00,
        yellowgreen: 0x9acd32
    };
    define(Color, color, {
        copy (channels) {
            return Object.assign(new this.constructor, this, channels);
        },
        displayable () {
            return this.rgb().displayable();
        },
        hex: color_formatHex,
        formatHex: color_formatHex,
        formatHex8: color_formatHex8,
        formatHsl: color_formatHsl,
        formatRgb: color_formatRgb,
        toString: color_formatRgb
    });
    function color_formatHex() {
        return this.rgb().formatHex();
    }
    function color_formatHex8() {
        return this.rgb().formatHex8();
    }
    function color_formatHsl() {
        return hslConvert(this).formatHsl();
    }
    function color_formatRgb() {
        return this.rgb().formatRgb();
    }
    function color(format) {
        var m, l;
        format = (format + "").trim().toLowerCase();
        return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
         : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
         : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
         : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
         : null // invalid hex
        ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
         : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
         : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
         : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
         : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
         : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
         : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
         : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
    }
    function rgbn(n) {
        return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
    }
    function rgba(r, g, b, a) {
        if (a <= 0) r = g = b = NaN;
        return new Rgb(r, g, b, a);
    }
    function rgbConvert(o) {
        if (!(o instanceof Color)) o = color(o);
        if (!o) return new Rgb;
        o = o.rgb();
        return new Rgb(o.r, o.g, o.b, o.opacity);
    }
    function rgb(r, g, b, opacity) {
        return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
    }
    function Rgb(r, g, b, opacity) {
        this.r = +r;
        this.g = +g;
        this.b = +b;
        this.opacity = +opacity;
    }
    define(Rgb, rgb, extend(Color, {
        brighter (k) {
            k = k == null ? brighter : Math.pow(brighter, k);
            return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
        },
        darker (k) {
            k = k == null ? darker : Math.pow(darker, k);
            return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
        },
        rgb () {
            return this;
        },
        clamp () {
            return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
        },
        displayable () {
            return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
        },
        hex: rgb_formatHex,
        formatHex: rgb_formatHex,
        formatHex8: rgb_formatHex8,
        formatRgb: rgb_formatRgb,
        toString: rgb_formatRgb
    }));
    function rgb_formatHex() {
        return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
    }
    function rgb_formatHex8() {
        return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
    }
    function rgb_formatRgb() {
        const a = clampa(this.opacity);
        return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
    }
    function clampa(opacity) {
        return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
    }
    function clampi(value) {
        return Math.max(0, Math.min(255, Math.round(value) || 0));
    }
    function hex(value) {
        value = clampi(value);
        return (value < 16 ? "0" : "") + value.toString(16);
    }
    function hsla(h, s, l, a) {
        if (a <= 0) h = s = l = NaN;
        else if (l <= 0 || l >= 1) h = s = NaN;
        else if (s <= 0) h = NaN;
        return new Hsl(h, s, l, a);
    }
    function hslConvert(o) {
        if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
        if (!(o instanceof Color)) o = color(o);
        if (!o) return new Hsl;
        if (o instanceof Hsl) return o;
        o = o.rgb();
        var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
        if (s) {
            if (r === max) h = (g - b) / s + (g < b) * 6;
            else if (g === max) h = (b - r) / s + 2;
            else h = (r - g) / s + 4;
            s /= l < 0.5 ? max + min : 2 - max - min;
            h *= 60;
        } else s = l > 0 && l < 1 ? 0 : h;
        return new Hsl(h, s, l, o.opacity);
    }
    function hsl$2(h, s, l, opacity) {
        return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
    }
    function Hsl(h, s, l, opacity) {
        this.h = +h;
        this.s = +s;
        this.l = +l;
        this.opacity = +opacity;
    }
    define(Hsl, hsl$2, extend(Color, {
        brighter (k) {
            k = k == null ? brighter : Math.pow(brighter, k);
            return new Hsl(this.h, this.s, this.l * k, this.opacity);
        },
        darker (k) {
            k = k == null ? darker : Math.pow(darker, k);
            return new Hsl(this.h, this.s, this.l * k, this.opacity);
        },
        rgb () {
            var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
            return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
        },
        clamp () {
            return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
        },
        displayable () {
            return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
        },
        formatHsl () {
            const a = clampa(this.opacity);
            return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
        }
    }));
    function clamph(value) {
        value = (value || 0) % 360;
        return value < 0 ? value + 360 : value;
    }
    function clampt(value) {
        return Math.max(0, Math.min(1, value || 0));
    }
    /* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
        return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
    }
    const radians$1 = Math.PI / 180;
    const degrees$2 = 180 / Math.PI;
    // https://observablehq.com/@mbostock/lab-and-rgb
    const K = 18, Xn = 0.96422, Yn = 1, Zn = 0.82521, t0$1 = 4 / 29, t1$1 = 6 / 29, t2 = 3 * t1$1 * t1$1, t3 = t1$1 * t1$1 * t1$1;
    function labConvert(o) {
        if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
        if (o instanceof Hcl) return hcl2lab(o);
        if (!(o instanceof Rgb)) o = rgbConvert(o);
        var r = rgb2lrgb(o.r), g = rgb2lrgb(o.g), b = rgb2lrgb(o.b), y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn), x, z;
        if (r === g && g === b) x = z = y;
        else {
            x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
            z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
        }
        return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
    }
    function gray(l, opacity) {
        return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
    }
    function lab$1(l, a, b, opacity) {
        return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
    }
    function Lab(l, a, b, opacity) {
        this.l = +l;
        this.a = +a;
        this.b = +b;
        this.opacity = +opacity;
    }
    define(Lab, lab$1, extend(Color, {
        brighter (k) {
            return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
        },
        darker (k) {
            return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
        },
        rgb () {
            var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
            x = Xn * lab2xyz(x);
            y = Yn * lab2xyz(y);
            z = Zn * lab2xyz(z);
            return new Rgb(lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
        }
    }));
    function xyz2lab(t) {
        return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0$1;
    }
    function lab2xyz(t) {
        return t > t1$1 ? t * t * t : t2 * (t - t0$1);
    }
    function lrgb2rgb(x) {
        return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
    }
    function rgb2lrgb(x) {
        return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
    }
    function hclConvert(o) {
        if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
        if (!(o instanceof Lab)) o = labConvert(o);
        if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
        var h = Math.atan2(o.b, o.a) * degrees$2;
        return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
    }
    function lch(l, c, h, opacity) {
        return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
    }
    function hcl$2(h, c, l, opacity) {
        return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
    }
    function Hcl(h, c, l, opacity) {
        this.h = +h;
        this.c = +c;
        this.l = +l;
        this.opacity = +opacity;
    }
    function hcl2lab(o) {
        if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
        var h = o.h * radians$1;
        return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
    }
    define(Hcl, hcl$2, extend(Color, {
        brighter (k) {
            return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
        },
        darker (k) {
            return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
        },
        rgb () {
            return hcl2lab(this).rgb();
        }
    }));
    var A = -0.14861, B$1 = 1.78277, C = -0.29227, D$1 = -0.90649, E = 1.97294, ED = E * D$1, EB = E * B$1, BC_DA = B$1 * C - D$1 * A;
    function cubehelixConvert(o) {
        if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
        if (!(o instanceof Rgb)) o = rgbConvert(o);
        var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB), bl = b - l, k = (E * (g - l) - C * bl) / D$1, s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), h = s ? Math.atan2(k, bl) * degrees$2 - 120 : NaN;
        return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
    }
    function cubehelix$3(h, s, l, opacity) {
        return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
    }
    function Cubehelix(h, s, l, opacity) {
        this.h = +h;
        this.s = +s;
        this.l = +l;
        this.opacity = +opacity;
    }
    define(Cubehelix, cubehelix$3, extend(Color, {
        brighter (k) {
            k = k == null ? brighter : Math.pow(brighter, k);
            return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
        },
        darker (k) {
            k = k == null ? darker : Math.pow(darker, k);
            return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
        },
        rgb () {
            var h = isNaN(this.h) ? 0 : (this.h + 120) * radians$1, l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
            return new Rgb(255 * (l + a * (A * cosh + B$1 * sinh)), 255 * (l + a * (C * cosh + D$1 * sinh)), 255 * (l + a * (E * cosh)), this.opacity);
        }
    }));
    function basis$1(t1, v0, v1, v2, v3) {
        var t2 = t1 * t1, t3 = t2 * t1;
        return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
    }
    function basis$2(values) {
        var n = values.length - 1;
        return function(t) {
            var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
            return basis$1((t - i / n) * n, v0, v1, v2, v3);
        };
    }
    function basisClosed$1(values) {
        var n = values.length;
        return function(t) {
            var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
            return basis$1((t - i / n) * n, v0, v1, v2, v3);
        };
    }
    var constant$8 = (x)=>()=>x;
    function linear$2(a, d) {
        return function(t) {
            return a + t * d;
        };
    }
    function exponential$1(a, b, y) {
        return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
            return Math.pow(a + t * b, y);
        };
    }
    function hue$1(a, b) {
        var d = b - a;
        return d ? linear$2(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant$8(isNaN(a) ? b : a);
    }
    function gamma$1(y) {
        return (y = +y) === 1 ? nogamma : function(a, b) {
            return b - a ? exponential$1(a, b, y) : constant$8(isNaN(a) ? b : a);
        };
    }
    function nogamma(a, b) {
        var d = b - a;
        return d ? linear$2(a, d) : constant$8(isNaN(a) ? b : a);
    }
    var interpolateRgb = function rgbGamma(y) {
        var color = gamma$1(y);
        function rgb$1(start, end) {
            var r = color((start = rgb(start)).r, (end = rgb(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = nogamma(start.opacity, end.opacity);
            return function(t) {
                start.r = r(t);
                start.g = g(t);
                start.b = b(t);
                start.opacity = opacity(t);
                return start + "";
            };
        }
        rgb$1.gamma = rgbGamma;
        return rgb$1;
    }(1);
    function rgbSpline(spline) {
        return function(colors) {
            var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
            for(i = 0; i < n; ++i){
                color = rgb(colors[i]);
                r[i] = color.r || 0;
                g[i] = color.g || 0;
                b[i] = color.b || 0;
            }
            r = spline(r);
            g = spline(g);
            b = spline(b);
            color.opacity = 1;
            return function(t) {
                color.r = r(t);
                color.g = g(t);
                color.b = b(t);
                return color + "";
            };
        };
    }
    var rgbBasis = rgbSpline(basis$2);
    var rgbBasisClosed = rgbSpline(basisClosed$1);
    function numberArray(a, b) {
        if (!b) b = [];
        var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
        return function(t) {
            for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
            return c;
        };
    }
    function isNumberArray(x) {
        return ArrayBuffer.isView(x) && !(x instanceof DataView);
    }
    function array$3(a, b) {
        return (isNumberArray(b) ? numberArray : genericArray)(a, b);
    }
    function genericArray(a, b) {
        var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
        for(i = 0; i < na; ++i)x[i] = interpolate$2(a[i], b[i]);
        for(; i < nb; ++i)c[i] = b[i];
        return function(t) {
            for(i = 0; i < na; ++i)c[i] = x[i](t);
            return c;
        };
    }
    function date$1(a, b) {
        var d = new Date;
        return a = +a, b = +b, function(t) {
            return d.setTime(a * (1 - t) + b * t), d;
        };
    }
    function interpolateNumber(a, b) {
        return a = +a, b = +b, function(t) {
            return a * (1 - t) + b * t;
        };
    }
    function object$1(a, b) {
        var i = {}, c = {}, k;
        if (a === null || typeof a !== "object") a = {};
        if (b === null || typeof b !== "object") b = {};
        for(k in b)if (k in a) i[k] = interpolate$2(a[k], b[k]);
        else c[k] = b[k];
        return function(t) {
            for(k in i)c[k] = i[k](t);
            return c;
        };
    }
    var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, reB = new RegExp(reA.source, "g");
    function zero(b) {
        return function() {
            return b;
        };
    }
    function one(b) {
        return function(t) {
            return b(t) + "";
        };
    }
    function interpolateString(a, b) {
        var bi = reA.lastIndex = reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
        // Coerce inputs to strings.
        a = a + "", b = b + "";
        // Interpolate pairs of numbers in a & b.
        while((am = reA.exec(a)) && (bm = reB.exec(b))){
            if ((bs = bm.index) > bi) {
                bs = b.slice(bi, bs);
                if (s[i]) s[i] += bs; // coalesce with previous string
                else s[++i] = bs;
            }
            if ((am = am[0]) === (bm = bm[0])) {
                if (s[i]) s[i] += bm; // coalesce with previous string
                else s[++i] = bm;
            } else {
                s[++i] = null;
                q.push({
                    i: i,
                    x: interpolateNumber(am, bm)
                });
            }
            bi = reB.lastIndex;
        }
        // Add remains of b.
        if (bi < b.length) {
            bs = b.slice(bi);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        // Special optimization for only a single match.
        // Otherwise, interpolate each of the numbers and rejoin the string.
        return s.length < 2 ? q[0] ? one(q[0].x) : zero(b) : (b = q.length, function(t) {
            for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        });
    }
    function interpolate$2(a, b) {
        var t = typeof b, c;
        return b == null || t === "boolean" ? constant$8(b) : (t === "number" ? interpolateNumber : t === "string" ? (c = color(b)) ? (b = c, interpolateRgb) : interpolateString : b instanceof color ? interpolateRgb : b instanceof Date ? date$1 : isNumberArray(b) ? numberArray : Array.isArray(b) ? genericArray : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object$1 : interpolateNumber)(a, b);
    }
    function discrete(range) {
        var n = range.length;
        return function(t) {
            return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
        };
    }
    function hue(a, b) {
        var i = hue$1(+a, +b);
        return function(t) {
            var x = i(t);
            return x - 360 * Math.floor(x / 360);
        };
    }
    function interpolateRound(a, b) {
        return a = +a, b = +b, function(t) {
            return Math.round(a * (1 - t) + b * t);
        };
    }
    var degrees$1 = 180 / Math.PI;
    var identity$7 = {
        translateX: 0,
        translateY: 0,
        rotate: 0,
        skewX: 0,
        scaleX: 1,
        scaleY: 1
    };
    function decompose(a, b, c, d, e, f) {
        var scaleX, scaleY, skewX;
        if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
        if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
        if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
        if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
        return {
            translateX: e,
            translateY: f,
            rotate: Math.atan2(b, a) * degrees$1,
            skewX: Math.atan(skewX) * degrees$1,
            scaleX: scaleX,
            scaleY: scaleY
        };
    }
    var svgNode;
    /* eslint-disable no-undef */ function parseCss(value) {
        const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
        return m.isIdentity ? identity$7 : decompose(m.a, m.b, m.c, m.d, m.e, m.f);
    }
    function parseSvg(value) {
        if (value == null) return identity$7;
        if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
        svgNode.setAttribute("transform", value);
        if (!(value = svgNode.transform.baseVal.consolidate())) return identity$7;
        value = value.matrix;
        return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
    }
    function interpolateTransform(parse, pxComma, pxParen, degParen) {
        function pop(s) {
            return s.length ? s.pop() + " " : "";
        }
        function translate(xa, ya, xb, yb, s, q) {
            if (xa !== xb || ya !== yb) {
                var i = s.push("translate(", null, pxComma, null, pxParen);
                q.push({
                    i: i - 4,
                    x: interpolateNumber(xa, xb)
                }, {
                    i: i - 2,
                    x: interpolateNumber(ya, yb)
                });
            } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
        }
        function rotate(a, b, s, q) {
            if (a !== b) {
                if (a - b > 180) b += 360;
                else if (b - a > 180) a += 360; // shortest path
                q.push({
                    i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                    x: interpolateNumber(a, b)
                });
            } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
        }
        function skewX(a, b, s, q) {
            if (a !== b) q.push({
                i: s.push(pop(s) + "skewX(", null, degParen) - 2,
                x: interpolateNumber(a, b)
            });
            else if (b) s.push(pop(s) + "skewX(" + b + degParen);
        }
        function scale(xa, ya, xb, yb, s, q) {
            if (xa !== xb || ya !== yb) {
                var i = s.push(pop(s) + "scale(", null, ",", null, ")");
                q.push({
                    i: i - 4,
                    x: interpolateNumber(xa, xb)
                }, {
                    i: i - 2,
                    x: interpolateNumber(ya, yb)
                });
            } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
        }
        return function(a, b) {
            var s = [], q = []; // number interpolators
            a = parse(a), b = parse(b);
            translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
            rotate(a.rotate, b.rotate, s, q);
            skewX(a.skewX, b.skewX, s, q);
            scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
            a = b = null; // gc
            return function(t) {
                var i = -1, n = q.length, o;
                while(++i < n)s[(o = q[i]).i] = o.x(t);
                return s.join("");
            };
        };
    }
    var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
    var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");
    var epsilon2$1 = 1e-12;
    function cosh(x) {
        return ((x = Math.exp(x)) + 1 / x) / 2;
    }
    function sinh(x) {
        return ((x = Math.exp(x)) - 1 / x) / 2;
    }
    function tanh(x) {
        return ((x = Math.exp(2 * x)) - 1) / (x + 1);
    }
    var interpolateZoom = function zoomRho(rho, rho2, rho4) {
        // p0 = [ux0, uy0, w0]
        // p1 = [ux1, uy1, w1]
        function zoom(p0, p1) {
            var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
            // Special case for u0 ≅ u1.
            if (d2 < epsilon2$1) {
                S = Math.log(w1 / w0) / rho;
                i = function(t) {
                    return [
                        ux0 + t * dx,
                        uy0 + t * dy,
                        w0 * Math.exp(rho * t * S)
                    ];
                };
            } else {
                var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
                S = (r1 - r0) / rho;
                i = function(t) {
                    var s = t * S, coshr0 = cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
                    return [
                        ux0 + u * dx,
                        uy0 + u * dy,
                        w0 * coshr0 / cosh(rho * s + r0)
                    ];
                };
            }
            i.duration = S * 1000 * rho / Math.SQRT2;
            return i;
        }
        zoom.rho = function(_) {
            var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
            return zoomRho(_1, _2, _4);
        };
        return zoom;
    }(Math.SQRT2, 2, 4);
    function hsl(hue) {
        return function(start, end) {
            var h = hue((start = hsl$2(start)).h, (end = hsl$2(end)).h), s = nogamma(start.s, end.s), l = nogamma(start.l, end.l), opacity = nogamma(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(t);
                start.opacity = opacity(t);
                return start + "";
            };
        };
    }
    var hsl$1 = hsl(hue$1);
    var hslLong = hsl(nogamma);
    function lab(start, end) {
        var l = nogamma((start = lab$1(start)).l, (end = lab$1(end)).l), a = nogamma(start.a, end.a), b = nogamma(start.b, end.b), opacity = nogamma(start.opacity, end.opacity);
        return function(t) {
            start.l = l(t);
            start.a = a(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    function hcl(hue) {
        return function(start, end) {
            var h = hue((start = hcl$2(start)).h, (end = hcl$2(end)).h), c = nogamma(start.c, end.c), l = nogamma(start.l, end.l), opacity = nogamma(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.c = c(t);
                start.l = l(t);
                start.opacity = opacity(t);
                return start + "";
            };
        };
    }
    var hcl$1 = hcl(hue$1);
    var hclLong = hcl(nogamma);
    function cubehelix$1(hue) {
        return function cubehelixGamma(y) {
            y = +y;
            function cubehelix(start, end) {
                var h = hue((start = cubehelix$3(start)).h, (end = cubehelix$3(end)).h), s = nogamma(start.s, end.s), l = nogamma(start.l, end.l), opacity = nogamma(start.opacity, end.opacity);
                return function(t) {
                    start.h = h(t);
                    start.s = s(t);
                    start.l = l(Math.pow(t, y));
                    start.opacity = opacity(t);
                    return start + "";
                };
            }
            cubehelix.gamma = cubehelixGamma;
            return cubehelix;
        }(1);
    }
    var cubehelix$2 = cubehelix$1(hue$1);
    var cubehelixLong = cubehelix$1(nogamma);
    function piecewise(interpolate, values) {
        if (values === undefined) values = interpolate, interpolate = interpolate$2;
        var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
        while(i < n)I[i] = interpolate(v, v = values[++i]);
        return function(t) {
            var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
            return I[i](t - i);
        };
    }
    function quantize$1(interpolator, n) {
        var samples = new Array(n);
        for(var i = 0; i < n; ++i)samples[i] = interpolator(i / (n - 1));
        return samples;
    }
    var frame = 0, timeout$1 = 0, interval$1 = 0, pokeDelay = 1000, taskHead, taskTail, clockLast = 0, clockNow = 0, clockSkew = 0, clock = typeof performance === "object" && performance.now ? performance : Date, setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) {
        setTimeout(f, 17);
    };
    function now() {
        return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
    }
    function clearNow() {
        clockNow = 0;
    }
    function Timer() {
        this._call = this._time = this._next = null;
    }
    Timer.prototype = timer.prototype = {
        constructor: Timer,
        restart: function(callback, delay, time) {
            if (typeof callback !== "function") throw new TypeError("callback is not a function");
            time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
            if (!this._next && taskTail !== this) {
                if (taskTail) taskTail._next = this;
                else taskHead = this;
                taskTail = this;
            }
            this._call = callback;
            this._time = time;
            sleep();
        },
        stop: function() {
            if (this._call) {
                this._call = null;
                this._time = Infinity;
                sleep();
            }
        }
    };
    function timer(callback, delay, time) {
        var t = new Timer;
        t.restart(callback, delay, time);
        return t;
    }
    function timerFlush() {
        now(); // Get the current time, if not already set.
        ++frame; // Pretend we’ve set an alarm, if we haven’t already.
        var t = taskHead, e;
        while(t){
            if ((e = clockNow - t._time) >= 0) t._call.call(undefined, e);
            t = t._next;
        }
        --frame;
    }
    function wake() {
        clockNow = (clockLast = clock.now()) + clockSkew;
        frame = timeout$1 = 0;
        try {
            timerFlush();
        } finally{
            frame = 0;
            nap();
            clockNow = 0;
        }
    }
    function poke() {
        var now = clock.now(), delay = now - clockLast;
        if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
    }
    function nap() {
        var t0, t1 = taskHead, t2, time = Infinity;
        while(t1)if (t1._call) {
            if (time > t1._time) time = t1._time;
            t0 = t1, t1 = t1._next;
        } else {
            t2 = t1._next, t1._next = null;
            t1 = t0 ? t0._next = t2 : taskHead = t2;
        }
        taskTail = t0;
        sleep(time);
    }
    function sleep(time) {
        if (frame) return; // Soonest alarm already set, or will be.
        if (timeout$1) timeout$1 = clearTimeout(timeout$1);
        var delay = time - clockNow; // Strictly less than if we recomputed clockNow.
        if (delay > 24) {
            if (time < Infinity) timeout$1 = setTimeout(wake, time - clock.now() - clockSkew);
            if (interval$1) interval$1 = clearInterval(interval$1);
        } else {
            if (!interval$1) clockLast = clock.now(), interval$1 = setInterval(poke, pokeDelay);
            frame = 1, setFrame(wake);
        }
    }
    function timeout(callback, delay, time) {
        var t = new Timer;
        delay = delay == null ? 0 : +delay;
        t.restart((elapsed)=>{
            t.stop();
            callback(elapsed + delay);
        }, delay, time);
        return t;
    }
    function interval(callback, delay, time) {
        var t = new Timer, total = delay;
        if (delay == null) return t.restart(callback, delay, time), t;
        t._restart = t.restart;
        t.restart = function(callback, delay, time) {
            delay = +delay, time = time == null ? now() : +time;
            t._restart(function tick(elapsed) {
                elapsed += total;
                t._restart(tick, total += delay, time);
                callback(elapsed);
            }, delay, time);
        };
        t.restart(callback, delay, time);
        return t;
    }
    var emptyOn = dispatch("start", "end", "cancel", "interrupt");
    var emptyTween = [];
    var CREATED = 0;
    var SCHEDULED = 1;
    var STARTING = 2;
    var STARTED = 3;
    var RUNNING = 4;
    var ENDING = 5;
    var ENDED = 6;
    function schedule(node, name, id, index, group, timing) {
        var schedules = node.__transition;
        if (!schedules) node.__transition = {};
        else if (id in schedules) return;
        create(node, id, {
            name: name,
            index: index,
            group: group,
            on: emptyOn,
            tween: emptyTween,
            time: timing.time,
            delay: timing.delay,
            duration: timing.duration,
            ease: timing.ease,
            timer: null,
            state: CREATED
        });
    }
    function init(node, id) {
        var schedule = get(node, id);
        if (schedule.state > CREATED) throw new Error("too late; already scheduled");
        return schedule;
    }
    function set(node, id) {
        var schedule = get(node, id);
        if (schedule.state > STARTED) throw new Error("too late; already running");
        return schedule;
    }
    function get(node, id) {
        var schedule = node.__transition;
        if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
        return schedule;
    }
    function create(node, id, self) {
        var schedules = node.__transition, tween;
        // Initialize the self timer when the transition is created.
        // Note the actual delay is not known until the first callback!
        schedules[id] = self;
        self.timer = timer(schedule, 0, self.time);
        function schedule(elapsed) {
            self.state = SCHEDULED;
            self.timer.restart(start, self.delay, self.time);
            // If the elapsed delay is less than our first sleep, start immediately.
            if (self.delay <= elapsed) start(elapsed - self.delay);
        }
        function start(elapsed) {
            var i, j, n, o;
            // If the state is not SCHEDULED, then we previously errored on start.
            if (self.state !== SCHEDULED) return stop();
            for(i in schedules){
                o = schedules[i];
                if (o.name !== self.name) continue;
                // While this element already has a starting transition during this frame,
                // defer starting an interrupting transition until that transition has a
                // chance to tick (and possibly end); see d3/d3-transition#54!
                if (o.state === STARTED) return timeout(start);
                // Interrupt the active transition, if any.
                if (o.state === RUNNING) {
                    o.state = ENDED;
                    o.timer.stop();
                    o.on.call("interrupt", node, node.__data__, o.index, o.group);
                    delete schedules[i];
                } else if (+i < id) {
                    o.state = ENDED;
                    o.timer.stop();
                    o.on.call("cancel", node, node.__data__, o.index, o.group);
                    delete schedules[i];
                }
            }
            // Defer the first tick to end of the current frame; see d3/d3#1576.
            // Note the transition may be canceled after start and before the first tick!
            // Note this must be scheduled before the start event; see d3/d3-transition#16!
            // Assuming this is successful, subsequent callbacks go straight to tick.
            timeout(function() {
                if (self.state === STARTED) {
                    self.state = RUNNING;
                    self.timer.restart(tick, self.delay, self.time);
                    tick(elapsed);
                }
            });
            // Dispatch the start event.
            // Note this must be done before the tween are initialized.
            self.state = STARTING;
            self.on.call("start", node, node.__data__, self.index, self.group);
            if (self.state !== STARTING) return; // interrupted
            self.state = STARTED;
            // Initialize the tween, deleting null tween.
            tween = new Array(n = self.tween.length);
            for(i = 0, j = -1; i < n; ++i)if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) tween[++j] = o;
            tween.length = j + 1;
        }
        function tick(elapsed) {
            var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = ENDING, 1), i = -1, n = tween.length;
            while(++i < n)tween[i].call(node, t);
            // Dispatch the end event.
            if (self.state === ENDING) {
                self.on.call("end", node, node.__data__, self.index, self.group);
                stop();
            }
        }
        function stop() {
            self.state = ENDED;
            self.timer.stop();
            delete schedules[id];
            for(var i in schedules)return; // eslint-disable-line no-unused-vars
            delete node.__transition;
        }
    }
    function interrupt(node, name) {
        var schedules = node.__transition, schedule, active, empty = true, i;
        if (!schedules) return;
        name = name == null ? null : name + "";
        for(i in schedules){
            if ((schedule = schedules[i]).name !== name) {
                empty = false;
                continue;
            }
            active = schedule.state > STARTING && schedule.state < ENDING;
            schedule.state = ENDED;
            schedule.timer.stop();
            schedule.on.call(active ? "interrupt" : "cancel", node, node.__data__, schedule.index, schedule.group);
            delete schedules[i];
        }
        if (empty) delete node.__transition;
    }
    function selection_interrupt(name) {
        return this.each(function() {
            interrupt(this, name);
        });
    }
    function tweenRemove(id, name) {
        var tween0, tween1;
        return function() {
            var schedule = set(this, id), tween = schedule.tween;
            // If this node shared tween with the previous node,
            // just assign the updated shared tween and we’re done!
            // Otherwise, copy-on-write.
            if (tween !== tween0) {
                tween1 = tween0 = tween;
                for(var i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                    tween1 = tween1.slice();
                    tween1.splice(i, 1);
                    break;
                }
            }
            schedule.tween = tween1;
        };
    }
    function tweenFunction(id, name, value) {
        var tween0, tween1;
        if (typeof value !== "function") throw new Error;
        return function() {
            var schedule = set(this, id), tween = schedule.tween;
            // If this node shared tween with the previous node,
            // just assign the updated shared tween and we’re done!
            // Otherwise, copy-on-write.
            if (tween !== tween0) {
                tween1 = (tween0 = tween).slice();
                for(var t = {
                    name: name,
                    value: value
                }, i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                    tween1[i] = t;
                    break;
                }
                if (i === n) tween1.push(t);
            }
            schedule.tween = tween1;
        };
    }
    function transition_tween(name, value) {
        var id = this._id;
        name += "";
        if (arguments.length < 2) {
            var tween = get(this.node(), id).tween;
            for(var i = 0, n = tween.length, t; i < n; ++i){
                if ((t = tween[i]).name === name) return t.value;
            }
            return null;
        }
        return this.each((value == null ? tweenRemove : tweenFunction)(id, name, value));
    }
    function tweenValue(transition, name, value) {
        var id = transition._id;
        transition.each(function() {
            var schedule = set(this, id);
            (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
        });
        return function(node) {
            return get(node, id).value[name];
        };
    }
    function interpolate$1(a, b) {
        var c;
        return (typeof b === "number" ? interpolateNumber : b instanceof color ? interpolateRgb : (c = color(b)) ? (b = c, interpolateRgb) : interpolateString)(a, b);
    }
    function attrRemove(name) {
        return function() {
            this.removeAttribute(name);
        };
    }
    function attrRemoveNS(fullname) {
        return function() {
            this.removeAttributeNS(fullname.space, fullname.local);
        };
    }
    function attrConstant(name, interpolate, value1) {
        var string00, string1 = value1 + "", interpolate0;
        return function() {
            var string0 = this.getAttribute(name);
            return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
        };
    }
    function attrConstantNS(fullname, interpolate, value1) {
        var string00, string1 = value1 + "", interpolate0;
        return function() {
            var string0 = this.getAttributeNS(fullname.space, fullname.local);
            return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
        };
    }
    function attrFunction(name, interpolate, value) {
        var string00, string10, interpolate0;
        return function() {
            var string0, value1 = value(this), string1;
            if (value1 == null) return void this.removeAttribute(name);
            string0 = this.getAttribute(name);
            string1 = value1 + "";
            return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
        };
    }
    function attrFunctionNS(fullname, interpolate, value) {
        var string00, string10, interpolate0;
        return function() {
            var string0, value1 = value(this), string1;
            if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
            string0 = this.getAttributeNS(fullname.space, fullname.local);
            string1 = value1 + "";
            return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
        };
    }
    function transition_attr(name, value) {
        var fullname = namespace(name), i = fullname === "transform" ? interpolateTransformSvg : interpolate$1;
        return this.attrTween(name, typeof value === "function" ? (fullname.local ? attrFunctionNS : attrFunction)(fullname, i, tweenValue(this, "attr." + name, value)) : value == null ? (fullname.local ? attrRemoveNS : attrRemove)(fullname) : (fullname.local ? attrConstantNS : attrConstant)(fullname, i, value));
    }
    function attrInterpolate(name, i) {
        return function(t) {
            this.setAttribute(name, i.call(this, t));
        };
    }
    function attrInterpolateNS(fullname, i) {
        return function(t) {
            this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
        };
    }
    function attrTweenNS(fullname, value) {
        var t0, i0;
        function tween() {
            var i = value.apply(this, arguments);
            if (i !== i0) t0 = (i0 = i) && attrInterpolateNS(fullname, i);
            return t0;
        }
        tween._value = value;
        return tween;
    }
    function attrTween(name, value) {
        var t0, i0;
        function tween() {
            var i = value.apply(this, arguments);
            if (i !== i0) t0 = (i0 = i) && attrInterpolate(name, i);
            return t0;
        }
        tween._value = value;
        return tween;
    }
    function transition_attrTween(name, value) {
        var key = "attr." + name;
        if (arguments.length < 2) return (key = this.tween(key)) && key._value;
        if (value == null) return this.tween(key, null);
        if (typeof value !== "function") throw new Error;
        var fullname = namespace(name);
        return this.tween(key, (fullname.local ? attrTweenNS : attrTween)(fullname, value));
    }
    function delayFunction(id, value) {
        return function() {
            init(this, id).delay = +value.apply(this, arguments);
        };
    }
    function delayConstant(id, value) {
        return value = +value, function() {
            init(this, id).delay = value;
        };
    }
    function transition_delay(value) {
        var id = this._id;
        return arguments.length ? this.each((typeof value === "function" ? delayFunction : delayConstant)(id, value)) : get(this.node(), id).delay;
    }
    function durationFunction(id, value) {
        return function() {
            set(this, id).duration = +value.apply(this, arguments);
        };
    }
    function durationConstant(id, value) {
        return value = +value, function() {
            set(this, id).duration = value;
        };
    }
    function transition_duration(value) {
        var id = this._id;
        return arguments.length ? this.each((typeof value === "function" ? durationFunction : durationConstant)(id, value)) : get(this.node(), id).duration;
    }
    function easeConstant(id, value) {
        if (typeof value !== "function") throw new Error;
        return function() {
            set(this, id).ease = value;
        };
    }
    function transition_ease(value) {
        var id = this._id;
        return arguments.length ? this.each(easeConstant(id, value)) : get(this.node(), id).ease;
    }
    function easeVarying(id, value) {
        return function() {
            var v = value.apply(this, arguments);
            if (typeof v !== "function") throw new Error;
            set(this, id).ease = v;
        };
    }
    function transition_easeVarying(value) {
        if (typeof value !== "function") throw new Error;
        return this.each(easeVarying(this._id, value));
    }
    function transition_filter(match) {
        if (typeof match !== "function") match = matcher(match);
        for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
        }
        return new Transition(subgroups, this._parents, this._name, this._id);
    }
    function transition_merge(transition) {
        if (transition._id !== this._id) throw new Error;
        for(var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
            for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
        }
        for(; j < m0; ++j)merges[j] = groups0[j];
        return new Transition(merges, this._parents, this._name, this._id);
    }
    function start(name) {
        return (name + "").trim().split(/^|\s+/).every(function(t) {
            var i = t.indexOf(".");
            if (i >= 0) t = t.slice(0, i);
            return !t || t === "start";
        });
    }
    function onFunction(id, name, listener) {
        var on0, on1, sit = start(name) ? init : set;
        return function() {
            var schedule = sit(this, id), on = schedule.on;
            // If this node shared a dispatch with the previous node,
            // just assign the updated shared dispatch and we’re done!
            // Otherwise, copy-on-write.
            if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);
            schedule.on = on1;
        };
    }
    function transition_on(name, listener) {
        var id = this._id;
        return arguments.length < 2 ? get(this.node(), id).on.on(name) : this.each(onFunction(id, name, listener));
    }
    function removeFunction(id) {
        return function() {
            var parent = this.parentNode;
            for(var i in this.__transition)if (+i !== id) return;
            if (parent) parent.removeChild(this);
        };
    }
    function transition_remove() {
        return this.on("end.remove", removeFunction(this._id));
    }
    function transition_select(select) {
        var name = this._name, id = this._id;
        if (typeof select !== "function") select = selector(select);
        for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
                if ("__data__" in node) subnode.__data__ = node.__data__;
                subgroup[i] = subnode;
                schedule(subgroup[i], name, id, i, subgroup, get(node, id));
            }
        }
        return new Transition(subgroups, this._parents, name, id);
    }
    function transition_selectAll(select) {
        var name = this._name, id = this._id;
        if (typeof select !== "function") select = selectorAll(select);
        for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
                for(var children = select.call(node, node.__data__, i, group), child, inherit = get(node, id), k = 0, l = children.length; k < l; ++k)if (child = children[k]) schedule(child, name, id, k, children, inherit);
                subgroups.push(children);
                parents.push(node);
            }
        }
        return new Transition(subgroups, parents, name, id);
    }
    var Selection = selection.prototype.constructor;
    function transition_selection() {
        return new Selection(this._groups, this._parents);
    }
    function styleNull(name, interpolate) {
        var string00, string10, interpolate0;
        return function() {
            var string0 = styleValue(this, name), string1 = (this.style.removeProperty(name), styleValue(this, name));
            return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : interpolate0 = interpolate(string00 = string0, string10 = string1);
        };
    }
    function styleRemove(name) {
        return function() {
            this.style.removeProperty(name);
        };
    }
    function styleConstant(name, interpolate, value1) {
        var string00, string1 = value1 + "", interpolate0;
        return function() {
            var string0 = styleValue(this, name);
            return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
        };
    }
    function styleFunction(name, interpolate, value) {
        var string00, string10, interpolate0;
        return function() {
            var string0 = styleValue(this, name), value1 = value(this), string1 = value1 + "";
            if (value1 == null) string1 = value1 = (this.style.removeProperty(name), styleValue(this, name));
            return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
        };
    }
    function styleMaybeRemove(id, name) {
        var on0, on1, listener0, key = "style." + name, event = "end." + key, remove;
        return function() {
            var schedule = set(this, id), on = schedule.on, listener = schedule.value[key] == null ? remove || (remove = styleRemove(name)) : undefined;
            // If this node shared a dispatch with the previous node,
            // just assign the updated shared dispatch and we’re done!
            // Otherwise, copy-on-write.
            if (on !== on0 || listener0 !== listener) (on1 = (on0 = on).copy()).on(event, listener0 = listener);
            schedule.on = on1;
        };
    }
    function transition_style(name, value, priority) {
        var i = (name += "") === "transform" ? interpolateTransformCss : interpolate$1;
        return value == null ? this.styleTween(name, styleNull(name, i)).on("end.style." + name, styleRemove(name)) : typeof value === "function" ? this.styleTween(name, styleFunction(name, i, tweenValue(this, "style." + name, value))).each(styleMaybeRemove(this._id, name)) : this.styleTween(name, styleConstant(name, i, value), priority).on("end.style." + name, null);
    }
    function styleInterpolate(name, i, priority) {
        return function(t) {
            this.style.setProperty(name, i.call(this, t), priority);
        };
    }
    function styleTween(name, value, priority) {
        var t, i0;
        function tween() {
            var i = value.apply(this, arguments);
            if (i !== i0) t = (i0 = i) && styleInterpolate(name, i, priority);
            return t;
        }
        tween._value = value;
        return tween;
    }
    function transition_styleTween(name, value, priority) {
        var key = "style." + (name += "");
        if (arguments.length < 2) return (key = this.tween(key)) && key._value;
        if (value == null) return this.tween(key, null);
        if (typeof value !== "function") throw new Error;
        return this.tween(key, styleTween(name, value, priority == null ? "" : priority));
    }
    function textConstant(value) {
        return function() {
            this.textContent = value;
        };
    }
    function textFunction(value) {
        return function() {
            var value1 = value(this);
            this.textContent = value1 == null ? "" : value1;
        };
    }
    function transition_text(value) {
        return this.tween("text", typeof value === "function" ? textFunction(tweenValue(this, "text", value)) : textConstant(value == null ? "" : value + ""));
    }
    function textInterpolate(i) {
        return function(t) {
            this.textContent = i.call(this, t);
        };
    }
    function textTween(value) {
        var t0, i0;
        function tween() {
            var i = value.apply(this, arguments);
            if (i !== i0) t0 = (i0 = i) && textInterpolate(i);
            return t0;
        }
        tween._value = value;
        return tween;
    }
    function transition_textTween(value) {
        var key = "text";
        if (arguments.length < 1) return (key = this.tween(key)) && key._value;
        if (value == null) return this.tween(key, null);
        if (typeof value !== "function") throw new Error;
        return this.tween(key, textTween(value));
    }
    function transition_transition() {
        var name = this._name, id0 = this._id, id1 = newId();
        for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
                var inherit = get(node, id0);
                schedule(node, name, id1, i, group, {
                    time: inherit.time + inherit.delay + inherit.duration,
                    delay: 0,
                    duration: inherit.duration,
                    ease: inherit.ease
                });
            }
        }
        return new Transition(groups, this._parents, name, id1);
    }
    function transition_end() {
        var on0, on1, that = this, id = that._id, size = that.size();
        return new Promise(function(resolve, reject) {
            var cancel = {
                value: reject
            }, end = {
                value: function() {
                    if (--size === 0) resolve();
                }
            };
            that.each(function() {
                var schedule = set(this, id), on = schedule.on;
                // If this node shared a dispatch with the previous node,
                // just assign the updated shared dispatch and we’re done!
                // Otherwise, copy-on-write.
                if (on !== on0) {
                    on1 = (on0 = on).copy();
                    on1._.cancel.push(cancel);
                    on1._.interrupt.push(cancel);
                    on1._.end.push(end);
                }
                schedule.on = on1;
            });
            // The selection was empty, resolve end immediately
            if (size === 0) resolve();
        });
    }
    var id = 0;
    function Transition(groups, parents, name, id) {
        this._groups = groups;
        this._parents = parents;
        this._name = name;
        this._id = id;
    }
    function transition(name) {
        return selection().transition(name);
    }
    function newId() {
        return ++id;
    }
    var selection_prototype = selection.prototype;
    Transition.prototype = transition.prototype = {
        constructor: Transition,
        select: transition_select,
        selectAll: transition_selectAll,
        selectChild: selection_prototype.selectChild,
        selectChildren: selection_prototype.selectChildren,
        filter: transition_filter,
        merge: transition_merge,
        selection: transition_selection,
        transition: transition_transition,
        call: selection_prototype.call,
        nodes: selection_prototype.nodes,
        node: selection_prototype.node,
        size: selection_prototype.size,
        empty: selection_prototype.empty,
        each: selection_prototype.each,
        on: transition_on,
        attr: transition_attr,
        attrTween: transition_attrTween,
        style: transition_style,
        styleTween: transition_styleTween,
        text: transition_text,
        textTween: transition_textTween,
        remove: transition_remove,
        tween: transition_tween,
        delay: transition_delay,
        duration: transition_duration,
        ease: transition_ease,
        easeVarying: transition_easeVarying,
        end: transition_end,
        [Symbol.iterator]: selection_prototype[Symbol.iterator]
    };
    const linear$1 = (t)=>+t;
    function quadIn(t) {
        return t * t;
    }
    function quadOut(t) {
        return t * (2 - t);
    }
    function quadInOut(t) {
        return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
    }
    function cubicIn(t) {
        return t * t * t;
    }
    function cubicOut(t) {
        return --t * t * t + 1;
    }
    function cubicInOut(t) {
        return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
    }
    var exponent$1 = 3;
    var polyIn = function custom(e) {
        e = +e;
        function polyIn(t) {
            return Math.pow(t, e);
        }
        polyIn.exponent = custom;
        return polyIn;
    }(exponent$1);
    var polyOut = function custom(e) {
        e = +e;
        function polyOut(t) {
            return 1 - Math.pow(1 - t, e);
        }
        polyOut.exponent = custom;
        return polyOut;
    }(exponent$1);
    var polyInOut = function custom(e) {
        e = +e;
        function polyInOut(t) {
            return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
        }
        polyInOut.exponent = custom;
        return polyInOut;
    }(exponent$1);
    var pi$4 = Math.PI, halfPi$3 = pi$4 / 2;
    function sinIn(t) {
        return +t === 1 ? 1 : 1 - Math.cos(t * halfPi$3);
    }
    function sinOut(t) {
        return Math.sin(t * halfPi$3);
    }
    function sinInOut(t) {
        return (1 - Math.cos(pi$4 * t)) / 2;
    }
    // tpmt is two power minus ten times t scaled to [0,1]
    function tpmt(x) {
        return (Math.pow(2, -10 * x) - 0.0009765625) * 1.0009775171065494;
    }
    function expIn(t) {
        return tpmt(1 - +t);
    }
    function expOut(t) {
        return 1 - tpmt(t);
    }
    function expInOut(t) {
        return ((t *= 2) <= 1 ? tpmt(1 - t) : 2 - tpmt(t - 1)) / 2;
    }
    function circleIn(t) {
        return 1 - Math.sqrt(1 - t * t);
    }
    function circleOut(t) {
        return Math.sqrt(1 - --t * t);
    }
    function circleInOut(t) {
        return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
    }
    var b1 = 4 / 11, b2 = 6 / 11, b3 = 8 / 11, b4 = 3 / 4, b5 = 9 / 11, b6 = 10 / 11, b7 = 15 / 16, b8 = 21 / 22, b9 = 63 / 64, b0 = 1 / b1 / b1;
    function bounceIn(t) {
        return 1 - bounceOut(1 - t);
    }
    function bounceOut(t) {
        return (t = +t) < b1 ? b0 * t * t : t < b3 ? b0 * (t -= b2) * t + b4 : t < b6 ? b0 * (t -= b5) * t + b7 : b0 * (t -= b8) * t + b9;
    }
    function bounceInOut(t) {
        return ((t *= 2) <= 1 ? 1 - bounceOut(1 - t) : bounceOut(t - 1) + 1) / 2;
    }
    var overshoot = 1.70158;
    var backIn = function custom(s) {
        s = +s;
        function backIn(t) {
            return (t = +t) * t * (s * (t - 1) + t);
        }
        backIn.overshoot = custom;
        return backIn;
    }(overshoot);
    var backOut = function custom(s) {
        s = +s;
        function backOut(t) {
            return --t * t * ((t + 1) * s + t) + 1;
        }
        backOut.overshoot = custom;
        return backOut;
    }(overshoot);
    var backInOut = function custom(s) {
        s = +s;
        function backInOut(t) {
            return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
        }
        backInOut.overshoot = custom;
        return backInOut;
    }(overshoot);
    var tau$5 = 2 * Math.PI, amplitude = 1, period = 0.3;
    var elasticIn = function custom(a, p) {
        var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau$5);
        function elasticIn(t) {
            return a * tpmt(- --t) * Math.sin((s - t) / p);
        }
        elasticIn.amplitude = function(a) {
            return custom(a, p * tau$5);
        };
        elasticIn.period = function(p) {
            return custom(a, p);
        };
        return elasticIn;
    }(amplitude, period);
    var elasticOut = function custom(a, p) {
        var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau$5);
        function elasticOut(t) {
            return 1 - a * tpmt(t = +t) * Math.sin((t + s) / p);
        }
        elasticOut.amplitude = function(a) {
            return custom(a, p * tau$5);
        };
        elasticOut.period = function(p) {
            return custom(a, p);
        };
        return elasticOut;
    }(amplitude, period);
    var elasticInOut = function custom(a, p) {
        var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau$5);
        function elasticInOut(t) {
            return ((t = t * 2 - 1) < 0 ? a * tpmt(-t) * Math.sin((s - t) / p) : 2 - a * tpmt(t) * Math.sin((s + t) / p)) / 2;
        }
        elasticInOut.amplitude = function(a) {
            return custom(a, p * tau$5);
        };
        elasticInOut.period = function(p) {
            return custom(a, p);
        };
        return elasticInOut;
    }(amplitude, period);
    var defaultTiming = {
        time: null,
        delay: 0,
        duration: 250,
        ease: cubicInOut
    };
    function inherit(node, id) {
        var timing;
        while(!(timing = node.__transition) || !(timing = timing[id])){
            if (!(node = node.parentNode)) throw new Error(`transition ${id} not found`);
        }
        return timing;
    }
    function selection_transition(name) {
        var id, timing;
        if (name instanceof Transition) id = name._id, name = name._name;
        else id = newId(), (timing = defaultTiming).time = now(), name = name == null ? null : name + "";
        for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) schedule(node, name, id, i, group, timing || inherit(node, id));
        }
        return new Transition(groups, this._parents, name, id);
    }
    selection.prototype.interrupt = selection_interrupt;
    selection.prototype.transition = selection_transition;
    var root = [
        null
    ];
    function active(node, name) {
        var schedules = node.__transition, schedule, i;
        if (schedules) {
            name = name == null ? null : name + "";
            for(i in schedules){
                if ((schedule = schedules[i]).state > SCHEDULED && schedule.name === name) return new Transition([
                    [
                        node
                    ]
                ], root, name, +i);
            }
        }
        return null;
    }
    var constant$7 = (x)=>()=>x;
    function BrushEvent(type, { sourceEvent: sourceEvent, target: target, selection: selection, mode: mode, dispatch: dispatch }) {
        Object.defineProperties(this, {
            type: {
                value: type,
                enumerable: true,
                configurable: true
            },
            sourceEvent: {
                value: sourceEvent,
                enumerable: true,
                configurable: true
            },
            target: {
                value: target,
                enumerable: true,
                configurable: true
            },
            selection: {
                value: selection,
                enumerable: true,
                configurable: true
            },
            mode: {
                value: mode,
                enumerable: true,
                configurable: true
            },
            _: {
                value: dispatch
            }
        });
    }
    function nopropagation$1(event) {
        event.stopImmediatePropagation();
    }
    function noevent$1(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
    }
    var MODE_DRAG = {
        name: "drag"
    }, MODE_SPACE = {
        name: "space"
    }, MODE_HANDLE = {
        name: "handle"
    }, MODE_CENTER = {
        name: "center"
    };
    const { abs: abs$3, max: max$2, min: min$1 } = Math;
    function number1(e) {
        return [
            +e[0],
            +e[1]
        ];
    }
    function number2(e) {
        return [
            number1(e[0]),
            number1(e[1])
        ];
    }
    var X = {
        name: "x",
        handles: [
            "w",
            "e"
        ].map(type),
        input: function(x, e) {
            return x == null ? null : [
                [
                    +x[0],
                    e[0][1]
                ],
                [
                    +x[1],
                    e[1][1]
                ]
            ];
        },
        output: function(xy) {
            return xy && [
                xy[0][0],
                xy[1][0]
            ];
        }
    };
    var Y = {
        name: "y",
        handles: [
            "n",
            "s"
        ].map(type),
        input: function(y, e) {
            return y == null ? null : [
                [
                    e[0][0],
                    +y[0]
                ],
                [
                    e[1][0],
                    +y[1]
                ]
            ];
        },
        output: function(xy) {
            return xy && [
                xy[0][1],
                xy[1][1]
            ];
        }
    };
    var XY = {
        name: "xy",
        handles: [
            "n",
            "w",
            "e",
            "s",
            "nw",
            "ne",
            "sw",
            "se"
        ].map(type),
        input: function(xy) {
            return xy == null ? null : number2(xy);
        },
        output: function(xy) {
            return xy;
        }
    };
    var cursors = {
        overlay: "crosshair",
        selection: "move",
        n: "ns-resize",
        e: "ew-resize",
        s: "ns-resize",
        w: "ew-resize",
        nw: "nwse-resize",
        ne: "nesw-resize",
        se: "nwse-resize",
        sw: "nesw-resize"
    };
    var flipX = {
        e: "w",
        w: "e",
        nw: "ne",
        ne: "nw",
        se: "sw",
        sw: "se"
    };
    var flipY = {
        n: "s",
        s: "n",
        nw: "sw",
        ne: "se",
        se: "ne",
        sw: "nw"
    };
    var signsX = {
        overlay: 1,
        selection: 1,
        n: null,
        e: 1,
        s: null,
        w: -1,
        nw: -1,
        ne: 1,
        se: 1,
        sw: -1
    };
    var signsY = {
        overlay: 1,
        selection: 1,
        n: -1,
        e: null,
        s: 1,
        w: null,
        nw: -1,
        ne: -1,
        se: 1,
        sw: 1
    };
    function type(t) {
        return {
            type: t
        };
    }
    // Ignore right-click, since that should open the context menu.
    function defaultFilter$1(event) {
        return !event.ctrlKey && !event.button;
    }
    function defaultExtent$1() {
        var svg = this.ownerSVGElement || this;
        if (svg.hasAttribute("viewBox")) {
            svg = svg.viewBox.baseVal;
            return [
                [
                    svg.x,
                    svg.y
                ],
                [
                    svg.x + svg.width,
                    svg.y + svg.height
                ]
            ];
        }
        return [
            [
                0,
                0
            ],
            [
                svg.width.baseVal.value,
                svg.height.baseVal.value
            ]
        ];
    }
    function defaultTouchable$1() {
        return navigator.maxTouchPoints || "ontouchstart" in this;
    }
    // Like d3.local, but with the name “__brush” rather than auto-generated.
    function local(node) {
        while(!node.__brush)if (!(node = node.parentNode)) return;
        return node.__brush;
    }
    function empty(extent) {
        return extent[0][0] === extent[1][0] || extent[0][1] === extent[1][1];
    }
    function brushSelection(node) {
        var state = node.__brush;
        return state ? state.dim.output(state.selection) : null;
    }
    function brushX() {
        return brush$1(X);
    }
    function brushY() {
        return brush$1(Y);
    }
    function brush() {
        return brush$1(XY);
    }
    function brush$1(dim) {
        var extent = defaultExtent$1, filter = defaultFilter$1, touchable = defaultTouchable$1, keys = true, listeners = dispatch("start", "brush", "end"), handleSize = 6, touchending;
        function brush(group) {
            var overlay = group.property("__brush", initialize).selectAll(".overlay").data([
                type("overlay")
            ]);
            overlay.enter().append("rect").attr("class", "overlay").attr("pointer-events", "all").attr("cursor", cursors.overlay).merge(overlay).each(function() {
                var extent = local(this).extent;
                select(this).attr("x", extent[0][0]).attr("y", extent[0][1]).attr("width", extent[1][0] - extent[0][0]).attr("height", extent[1][1] - extent[0][1]);
            });
            group.selectAll(".selection").data([
                type("selection")
            ]).enter().append("rect").attr("class", "selection").attr("cursor", cursors.selection).attr("fill", "#777").attr("fill-opacity", 0.3).attr("stroke", "#fff").attr("shape-rendering", "crispEdges");
            var handle = group.selectAll(".handle").data(dim.handles, function(d) {
                return d.type;
            });
            handle.exit().remove();
            handle.enter().append("rect").attr("class", function(d) {
                return "handle handle--" + d.type;
            }).attr("cursor", function(d) {
                return cursors[d.type];
            });
            group.each(redraw).attr("fill", "none").attr("pointer-events", "all").on("mousedown.brush", started).filter(touchable).on("touchstart.brush", started).on("touchmove.brush", touchmoved).on("touchend.brush touchcancel.brush", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
        }
        brush.move = function(group, selection, event) {
            if (group.tween) group.on("start.brush", function(event) {
                emitter(this, arguments).beforestart().start(event);
            }).on("interrupt.brush end.brush", function(event) {
                emitter(this, arguments).end(event);
            }).tween("brush", function() {
                var that = this, state = that.__brush, emit = emitter(that, arguments), selection0 = state.selection, selection1 = dim.input(typeof selection === "function" ? selection.apply(this, arguments) : selection, state.extent), i = interpolate$2(selection0, selection1);
                function tween(t) {
                    state.selection = t === 1 && selection1 === null ? null : i(t);
                    redraw.call(that);
                    emit.brush();
                }
                return selection0 !== null && selection1 !== null ? tween : tween(1);
            });
            else group.each(function() {
                var that = this, args = arguments, state = that.__brush, selection1 = dim.input(typeof selection === "function" ? selection.apply(that, args) : selection, state.extent), emit = emitter(that, args).beforestart();
                interrupt(that);
                state.selection = selection1 === null ? null : selection1;
                redraw.call(that);
                emit.start(event).brush(event).end(event);
            });
        };
        brush.clear = function(group, event) {
            brush.move(group, null, event);
        };
        function redraw() {
            var group = select(this), selection = local(this).selection;
            if (selection) {
                group.selectAll(".selection").style("display", null).attr("x", selection[0][0]).attr("y", selection[0][1]).attr("width", selection[1][0] - selection[0][0]).attr("height", selection[1][1] - selection[0][1]);
                group.selectAll(".handle").style("display", null).attr("x", function(d) {
                    return d.type[d.type.length - 1] === "e" ? selection[1][0] - handleSize / 2 : selection[0][0] - handleSize / 2;
                }).attr("y", function(d) {
                    return d.type[0] === "s" ? selection[1][1] - handleSize / 2 : selection[0][1] - handleSize / 2;
                }).attr("width", function(d) {
                    return d.type === "n" || d.type === "s" ? selection[1][0] - selection[0][0] + handleSize : handleSize;
                }).attr("height", function(d) {
                    return d.type === "e" || d.type === "w" ? selection[1][1] - selection[0][1] + handleSize : handleSize;
                });
            } else group.selectAll(".selection,.handle").style("display", "none").attr("x", null).attr("y", null).attr("width", null).attr("height", null);
        }
        function emitter(that, args, clean) {
            var emit = that.__brush.emitter;
            return emit && (!clean || !emit.clean) ? emit : new Emitter(that, args, clean);
        }
        function Emitter(that, args, clean) {
            this.that = that;
            this.args = args;
            this.state = that.__brush;
            this.active = 0;
            this.clean = clean;
        }
        Emitter.prototype = {
            beforestart: function() {
                if (++this.active === 1) this.state.emitter = this, this.starting = true;
                return this;
            },
            start: function(event, mode) {
                if (this.starting) this.starting = false, this.emit("start", event, mode);
                else this.emit("brush", event);
                return this;
            },
            brush: function(event, mode) {
                this.emit("brush", event, mode);
                return this;
            },
            end: function(event, mode) {
                if (--this.active === 0) delete this.state.emitter, this.emit("end", event, mode);
                return this;
            },
            emit: function(type, event, mode) {
                var d = select(this.that).datum();
                listeners.call(type, this.that, new BrushEvent(type, {
                    sourceEvent: event,
                    target: brush,
                    selection: dim.output(this.state.selection),
                    mode: mode,
                    dispatch: listeners
                }), d);
            }
        };
        function started(event) {
            if (touchending && !event.touches) return;
            if (!filter.apply(this, arguments)) return;
            var that = this, type = event.target.__data__.type, mode = (keys && event.metaKey ? type = "overlay" : type) === "selection" ? MODE_DRAG : keys && event.altKey ? MODE_CENTER : MODE_HANDLE, signX = dim === Y ? null : signsX[type], signY = dim === X ? null : signsY[type], state = local(that), extent = state.extent, selection = state.selection, W = extent[0][0], w0, w1, N = extent[0][1], n0, n1, E = extent[1][0], e0, e1, S = extent[1][1], s0, s1, dx = 0, dy = 0, moving, shifting = signX && signY && keys && event.shiftKey, lockX, lockY, points = Array.from(event.touches || [
                event
            ], (t)=>{
                const i = t.identifier;
                t = pointer(t, that);
                t.point0 = t.slice();
                t.identifier = i;
                return t;
            });
            interrupt(that);
            var emit = emitter(that, arguments, true).beforestart();
            if (type === "overlay") {
                if (selection) moving = true;
                const pts = [
                    points[0],
                    points[1] || points[0]
                ];
                state.selection = selection = [
                    [
                        w0 = dim === Y ? W : min$1(pts[0][0], pts[1][0]),
                        n0 = dim === X ? N : min$1(pts[0][1], pts[1][1])
                    ],
                    [
                        e0 = dim === Y ? E : max$2(pts[0][0], pts[1][0]),
                        s0 = dim === X ? S : max$2(pts[0][1], pts[1][1])
                    ]
                ];
                if (points.length > 1) move(event);
            } else {
                w0 = selection[0][0];
                n0 = selection[0][1];
                e0 = selection[1][0];
                s0 = selection[1][1];
            }
            w1 = w0;
            n1 = n0;
            e1 = e0;
            s1 = s0;
            var group = select(that).attr("pointer-events", "none");
            var overlay = group.selectAll(".overlay").attr("cursor", cursors[type]);
            if (event.touches) {
                emit.moved = moved;
                emit.ended = ended;
            } else {
                var view = select(event.view).on("mousemove.brush", moved, true).on("mouseup.brush", ended, true);
                if (keys) view.on("keydown.brush", keydowned, true).on("keyup.brush", keyupped, true);
                dragDisable(event.view);
            }
            redraw.call(that);
            emit.start(event, mode.name);
            function moved(event) {
                for (const p of event.changedTouches || [
                    event
                ]){
                    for (const d of points)if (d.identifier === p.identifier) d.cur = pointer(p, that);
                }
                if (shifting && !lockX && !lockY && points.length === 1) {
                    const point = points[0];
                    if (abs$3(point.cur[0] - point[0]) > abs$3(point.cur[1] - point[1])) lockY = true;
                    else lockX = true;
                }
                for (const point of points)if (point.cur) point[0] = point.cur[0], point[1] = point.cur[1];
                moving = true;
                noevent$1(event);
                move(event);
            }
            function move(event) {
                const point = points[0], point0 = point.point0;
                var t;
                dx = point[0] - point0[0];
                dy = point[1] - point0[1];
                switch(mode){
                    case MODE_SPACE:
                    case MODE_DRAG:
                        if (signX) dx = max$2(W - w0, min$1(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
                        if (signY) dy = max$2(N - n0, min$1(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
                        break;
                    case MODE_HANDLE:
                        if (points[1]) {
                            if (signX) w1 = max$2(W, min$1(E, points[0][0])), e1 = max$2(W, min$1(E, points[1][0])), signX = 1;
                            if (signY) n1 = max$2(N, min$1(S, points[0][1])), s1 = max$2(N, min$1(S, points[1][1])), signY = 1;
                        } else {
                            if (signX < 0) dx = max$2(W - w0, min$1(E - w0, dx)), w1 = w0 + dx, e1 = e0;
                            else if (signX > 0) dx = max$2(W - e0, min$1(E - e0, dx)), w1 = w0, e1 = e0 + dx;
                            if (signY < 0) dy = max$2(N - n0, min$1(S - n0, dy)), n1 = n0 + dy, s1 = s0;
                            else if (signY > 0) dy = max$2(N - s0, min$1(S - s0, dy)), n1 = n0, s1 = s0 + dy;
                        }
                        break;
                    case MODE_CENTER:
                        if (signX) w1 = max$2(W, min$1(E, w0 - dx * signX)), e1 = max$2(W, min$1(E, e0 + dx * signX));
                        if (signY) n1 = max$2(N, min$1(S, n0 - dy * signY)), s1 = max$2(N, min$1(S, s0 + dy * signY));
                        break;
                }
                if (e1 < w1) {
                    signX *= -1;
                    t = w0, w0 = e0, e0 = t;
                    t = w1, w1 = e1, e1 = t;
                    if (type in flipX) overlay.attr("cursor", cursors[type = flipX[type]]);
                }
                if (s1 < n1) {
                    signY *= -1;
                    t = n0, n0 = s0, s0 = t;
                    t = n1, n1 = s1, s1 = t;
                    if (type in flipY) overlay.attr("cursor", cursors[type = flipY[type]]);
                }
                if (state.selection) selection = state.selection; // May be set by brush.move!
                if (lockX) w1 = selection[0][0], e1 = selection[1][0];
                if (lockY) n1 = selection[0][1], s1 = selection[1][1];
                if (selection[0][0] !== w1 || selection[0][1] !== n1 || selection[1][0] !== e1 || selection[1][1] !== s1) {
                    state.selection = [
                        [
                            w1,
                            n1
                        ],
                        [
                            e1,
                            s1
                        ]
                    ];
                    redraw.call(that);
                    emit.brush(event, mode.name);
                }
            }
            function ended(event) {
                nopropagation$1(event);
                if (event.touches) {
                    if (event.touches.length) return;
                    if (touchending) clearTimeout(touchending);
                    touchending = setTimeout(function() {
                        touchending = null;
                    }, 500); // Ghost clicks are delayed!
                } else {
                    yesdrag(event.view, moving);
                    view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
                }
                group.attr("pointer-events", "all");
                overlay.attr("cursor", cursors.overlay);
                if (state.selection) selection = state.selection; // May be set by brush.move (on start)!
                if (empty(selection)) state.selection = null, redraw.call(that);
                emit.end(event, mode.name);
            }
            function keydowned(event) {
                switch(event.keyCode){
                    case 16:
                        shifting = signX && signY;
                        break;
                    case 18:
                        if (mode === MODE_HANDLE) {
                            if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                            if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                            mode = MODE_CENTER;
                            move(event);
                        }
                        break;
                    case 32:
                        if (mode === MODE_HANDLE || mode === MODE_CENTER) {
                            if (signX < 0) e0 = e1 - dx;
                            else if (signX > 0) w0 = w1 - dx;
                            if (signY < 0) s0 = s1 - dy;
                            else if (signY > 0) n0 = n1 - dy;
                            mode = MODE_SPACE;
                            overlay.attr("cursor", cursors.selection);
                            move(event);
                        }
                        break;
                    default:
                        return;
                }
                noevent$1(event);
            }
            function keyupped(event) {
                switch(event.keyCode){
                    case 16:
                        if (shifting) {
                            lockX = lockY = shifting = false;
                            move(event);
                        }
                        break;
                    case 18:
                        if (mode === MODE_CENTER) {
                            if (signX < 0) e0 = e1;
                            else if (signX > 0) w0 = w1;
                            if (signY < 0) s0 = s1;
                            else if (signY > 0) n0 = n1;
                            mode = MODE_HANDLE;
                            move(event);
                        }
                        break;
                    case 32:
                        if (mode === MODE_SPACE) {
                            if (event.altKey) {
                                if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                                if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                                mode = MODE_CENTER;
                            } else {
                                if (signX < 0) e0 = e1;
                                else if (signX > 0) w0 = w1;
                                if (signY < 0) s0 = s1;
                                else if (signY > 0) n0 = n1;
                                mode = MODE_HANDLE;
                            }
                            overlay.attr("cursor", cursors[type]);
                            move(event);
                        }
                        break;
                    default:
                        return;
                }
                noevent$1(event);
            }
        }
        function touchmoved(event) {
            emitter(this, arguments).moved(event);
        }
        function touchended(event) {
            emitter(this, arguments).ended(event);
        }
        function initialize() {
            var state = this.__brush || {
                selection: null
            };
            state.extent = number2(extent.apply(this, arguments));
            state.dim = dim;
            return state;
        }
        brush.extent = function(_) {
            return arguments.length ? (extent = typeof _ === "function" ? _ : constant$7(number2(_)), brush) : extent;
        };
        brush.filter = function(_) {
            return arguments.length ? (filter = typeof _ === "function" ? _ : constant$7(!!_), brush) : filter;
        };
        brush.touchable = function(_) {
            return arguments.length ? (touchable = typeof _ === "function" ? _ : constant$7(!!_), brush) : touchable;
        };
        brush.handleSize = function(_) {
            return arguments.length ? (handleSize = +_, brush) : handleSize;
        };
        brush.keyModifiers = function(_) {
            return arguments.length ? (keys = !!_, brush) : keys;
        };
        brush.on = function() {
            var value = listeners.on.apply(listeners, arguments);
            return value === listeners ? brush : value;
        };
        return brush;
    }
    var abs$2 = Math.abs;
    var cos$2 = Math.cos;
    var sin$2 = Math.sin;
    var pi$3 = Math.PI;
    var halfPi$2 = pi$3 / 2;
    var tau$4 = pi$3 * 2;
    var max$1 = Math.max;
    var epsilon$5 = 1e-12;
    function range$1(i, j) {
        return Array.from({
            length: j - i
        }, (_, k)=>i + k);
    }
    function compareValue(compare) {
        return function(a, b) {
            return compare(a.source.value + a.target.value, b.source.value + b.target.value);
        };
    }
    function chord() {
        return chord$1(false, false);
    }
    function chordTranspose() {
        return chord$1(false, true);
    }
    function chordDirected() {
        return chord$1(true, false);
    }
    function chord$1(directed, transpose) {
        var padAngle = 0, sortGroups = null, sortSubgroups = null, sortChords = null;
        function chord(matrix) {
            var n = matrix.length, groupSums = new Array(n), groupIndex = range$1(0, n), chords = new Array(n * n), groups = new Array(n), k = 0, dx;
            matrix = Float64Array.from({
                length: n * n
            }, transpose ? (_, i)=>matrix[i % n][i / n | 0] : (_, i)=>matrix[i / n | 0][i % n]);
            // Compute the scaling factor from value to angle in [0, 2pi].
            for(let i = 0; i < n; ++i){
                let x = 0;
                for(let j = 0; j < n; ++j)x += matrix[i * n + j] + directed * matrix[j * n + i];
                k += groupSums[i] = x;
            }
            k = max$1(0, tau$4 - padAngle * n) / k;
            dx = k ? padAngle : tau$4 / n;
            // Compute the angles for each group and constituent chord.
            {
                let x = 0;
                if (sortGroups) groupIndex.sort((a, b)=>sortGroups(groupSums[a], groupSums[b]));
                for (const i of groupIndex){
                    const x0 = x;
                    if (directed) {
                        const subgroupIndex = range$1(~n + 1, n).filter((j)=>j < 0 ? matrix[~j * n + i] : matrix[i * n + j]);
                        if (sortSubgroups) subgroupIndex.sort((a, b)=>sortSubgroups(a < 0 ? -matrix[~a * n + i] : matrix[i * n + a], b < 0 ? -matrix[~b * n + i] : matrix[i * n + b]));
                        for (const j of subgroupIndex)if (j < 0) {
                            const chord = chords[~j * n + i] || (chords[~j * n + i] = {
                                source: null,
                                target: null
                            });
                            chord.target = {
                                index: i,
                                startAngle: x,
                                endAngle: x += matrix[~j * n + i] * k,
                                value: matrix[~j * n + i]
                            };
                        } else {
                            const chord = chords[i * n + j] || (chords[i * n + j] = {
                                source: null,
                                target: null
                            });
                            chord.source = {
                                index: i,
                                startAngle: x,
                                endAngle: x += matrix[i * n + j] * k,
                                value: matrix[i * n + j]
                            };
                        }
                        groups[i] = {
                            index: i,
                            startAngle: x0,
                            endAngle: x,
                            value: groupSums[i]
                        };
                    } else {
                        const subgroupIndex = range$1(0, n).filter((j)=>matrix[i * n + j] || matrix[j * n + i]);
                        if (sortSubgroups) subgroupIndex.sort((a, b)=>sortSubgroups(matrix[i * n + a], matrix[i * n + b]));
                        for (const j of subgroupIndex){
                            let chord;
                            if (i < j) {
                                chord = chords[i * n + j] || (chords[i * n + j] = {
                                    source: null,
                                    target: null
                                });
                                chord.source = {
                                    index: i,
                                    startAngle: x,
                                    endAngle: x += matrix[i * n + j] * k,
                                    value: matrix[i * n + j]
                                };
                            } else {
                                chord = chords[j * n + i] || (chords[j * n + i] = {
                                    source: null,
                                    target: null
                                });
                                chord.target = {
                                    index: i,
                                    startAngle: x,
                                    endAngle: x += matrix[i * n + j] * k,
                                    value: matrix[i * n + j]
                                };
                                if (i === j) chord.source = chord.target;
                            }
                            if (chord.source && chord.target && chord.source.value < chord.target.value) {
                                const source = chord.source;
                                chord.source = chord.target;
                                chord.target = source;
                            }
                        }
                        groups[i] = {
                            index: i,
                            startAngle: x0,
                            endAngle: x,
                            value: groupSums[i]
                        };
                    }
                    x += dx;
                }
            }
            // Remove empty chords.
            chords = Object.values(chords);
            chords.groups = groups;
            return sortChords ? chords.sort(sortChords) : chords;
        }
        chord.padAngle = function(_) {
            return arguments.length ? (padAngle = max$1(0, _), chord) : padAngle;
        };
        chord.sortGroups = function(_) {
            return arguments.length ? (sortGroups = _, chord) : sortGroups;
        };
        chord.sortSubgroups = function(_) {
            return arguments.length ? (sortSubgroups = _, chord) : sortSubgroups;
        };
        chord.sortChords = function(_) {
            return arguments.length ? (_ == null ? sortChords = null : (sortChords = compareValue(_))._ = _, chord) : sortChords && sortChords._;
        };
        return chord;
    }
    const pi$2 = Math.PI, tau$3 = 2 * pi$2, epsilon$4 = 1e-6, tauEpsilon = tau$3 - epsilon$4;
    function Path$1() {
        this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
        this._ = "";
    }
    function path() {
        return new Path$1;
    }
    Path$1.prototype = path.prototype = {
        constructor: Path$1,
        moveTo: function(x, y) {
            this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
        },
        closePath: function() {
            if (this._x1 !== null) {
                this._x1 = this._x0, this._y1 = this._y0;
                this._ += "Z";
            }
        },
        lineTo: function(x, y) {
            this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
        },
        quadraticCurveTo: function(x1, y1, x, y) {
            this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
        },
        bezierCurveTo: function(x1, y1, x2, y2, x, y) {
            this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
        },
        arcTo: function(x1, y1, x2, y2, r) {
            x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
            var x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
            // Is the radius negative? Error.
            if (r < 0) throw new Error("negative radius: " + r);
            // Is this path empty? Move to (x1,y1).
            if (this._x1 === null) this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
            else if (!(l01_2 > epsilon$4)) ;
            else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon$4) || !r) this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
            else {
                var x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan((pi$2 - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
                // If the start tangent is not coincident with (x0,y0), line to.
                if (Math.abs(t01 - 1) > epsilon$4) this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
                this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
            }
        },
        arc: function(x, y, r, a0, a1, ccw) {
            x = +x, y = +y, r = +r, ccw = !!ccw;
            var dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
            // Is the radius negative? Error.
            if (r < 0) throw new Error("negative radius: " + r);
            // Is this path empty? Move to (x0,y0).
            if (this._x1 === null) this._ += "M" + x0 + "," + y0;
            else if (Math.abs(this._x1 - x0) > epsilon$4 || Math.abs(this._y1 - y0) > epsilon$4) this._ += "L" + x0 + "," + y0;
            // Is this arc empty? We’re done.
            if (!r) return;
            // Does the angle go the wrong way? Flip the direction.
            if (da < 0) da = da % tau$3 + tau$3;
            // Is this a complete circle? Draw two arcs to complete the circle.
            if (da > tauEpsilon) this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
            else if (da > epsilon$4) this._ += "A" + r + "," + r + ",0," + +(da >= pi$2) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
        },
        rect: function(x, y, w, h) {
            this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
        },
        toString: function() {
            return this._;
        }
    };
    var slice$2 = Array.prototype.slice;
    function constant$6(x) {
        return function() {
            return x;
        };
    }
    function defaultSource$1(d) {
        return d.source;
    }
    function defaultTarget(d) {
        return d.target;
    }
    function defaultRadius$1(d) {
        return d.radius;
    }
    function defaultStartAngle(d) {
        return d.startAngle;
    }
    function defaultEndAngle(d) {
        return d.endAngle;
    }
    function defaultPadAngle() {
        return 0;
    }
    function defaultArrowheadRadius() {
        return 10;
    }
    function ribbon(headRadius) {
        var source = defaultSource$1, target = defaultTarget, sourceRadius = defaultRadius$1, targetRadius = defaultRadius$1, startAngle = defaultStartAngle, endAngle = defaultEndAngle, padAngle = defaultPadAngle, context = null;
        function ribbon() {
            var buffer, s = source.apply(this, arguments), t = target.apply(this, arguments), ap = padAngle.apply(this, arguments) / 2, argv = slice$2.call(arguments), sr = +sourceRadius.apply(this, (argv[0] = s, argv)), sa0 = startAngle.apply(this, argv) - halfPi$2, sa1 = endAngle.apply(this, argv) - halfPi$2, tr = +targetRadius.apply(this, (argv[0] = t, argv)), ta0 = startAngle.apply(this, argv) - halfPi$2, ta1 = endAngle.apply(this, argv) - halfPi$2;
            if (!context) context = buffer = path();
            if (ap > epsilon$5) {
                if (abs$2(sa1 - sa0) > ap * 2 + epsilon$5) sa1 > sa0 ? (sa0 += ap, sa1 -= ap) : (sa0 -= ap, sa1 += ap);
                else sa0 = sa1 = (sa0 + sa1) / 2;
                if (abs$2(ta1 - ta0) > ap * 2 + epsilon$5) ta1 > ta0 ? (ta0 += ap, ta1 -= ap) : (ta0 -= ap, ta1 += ap);
                else ta0 = ta1 = (ta0 + ta1) / 2;
            }
            context.moveTo(sr * cos$2(sa0), sr * sin$2(sa0));
            context.arc(0, 0, sr, sa0, sa1);
            if (sa0 !== ta0 || sa1 !== ta1) {
                if (headRadius) {
                    var hr = +headRadius.apply(this, arguments), tr2 = tr - hr, ta2 = (ta0 + ta1) / 2;
                    context.quadraticCurveTo(0, 0, tr2 * cos$2(ta0), tr2 * sin$2(ta0));
                    context.lineTo(tr * cos$2(ta2), tr * sin$2(ta2));
                    context.lineTo(tr2 * cos$2(ta1), tr2 * sin$2(ta1));
                } else {
                    context.quadraticCurveTo(0, 0, tr * cos$2(ta0), tr * sin$2(ta0));
                    context.arc(0, 0, tr, ta0, ta1);
                }
            }
            context.quadraticCurveTo(0, 0, sr * cos$2(sa0), sr * sin$2(sa0));
            context.closePath();
            if (buffer) return context = null, buffer + "" || null;
        }
        if (headRadius) ribbon.headRadius = function(_) {
            return arguments.length ? (headRadius = typeof _ === "function" ? _ : constant$6(+_), ribbon) : headRadius;
        };
        ribbon.radius = function(_) {
            return arguments.length ? (sourceRadius = targetRadius = typeof _ === "function" ? _ : constant$6(+_), ribbon) : sourceRadius;
        };
        ribbon.sourceRadius = function(_) {
            return arguments.length ? (sourceRadius = typeof _ === "function" ? _ : constant$6(+_), ribbon) : sourceRadius;
        };
        ribbon.targetRadius = function(_) {
            return arguments.length ? (targetRadius = typeof _ === "function" ? _ : constant$6(+_), ribbon) : targetRadius;
        };
        ribbon.startAngle = function(_) {
            return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$6(+_), ribbon) : startAngle;
        };
        ribbon.endAngle = function(_) {
            return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$6(+_), ribbon) : endAngle;
        };
        ribbon.padAngle = function(_) {
            return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant$6(+_), ribbon) : padAngle;
        };
        ribbon.source = function(_) {
            return arguments.length ? (source = _, ribbon) : source;
        };
        ribbon.target = function(_) {
            return arguments.length ? (target = _, ribbon) : target;
        };
        ribbon.context = function(_) {
            return arguments.length ? (context = _ == null ? null : _, ribbon) : context;
        };
        return ribbon;
    }
    function ribbon$1() {
        return ribbon();
    }
    function ribbonArrow() {
        return ribbon(defaultArrowheadRadius);
    }
    var array$2 = Array.prototype;
    var slice$1 = array$2.slice;
    function ascending$1(a, b) {
        return a - b;
    }
    function area$3(ring) {
        var i = 0, n = ring.length, area = ring[n - 1][1] * ring[0][0] - ring[n - 1][0] * ring[0][1];
        while(++i < n)area += ring[i - 1][1] * ring[i][0] - ring[i - 1][0] * ring[i][1];
        return area;
    }
    var constant$5 = (x)=>()=>x;
    function contains$2(ring, hole) {
        var i = -1, n = hole.length, c;
        while(++i < n)if (c = ringContains(ring, hole[i])) return c;
        return 0;
    }
    function ringContains(ring, point) {
        var x = point[0], y = point[1], contains = -1;
        for(var i = 0, n = ring.length, j = n - 1; i < n; j = i++){
            var pi = ring[i], xi = pi[0], yi = pi[1], pj = ring[j], xj = pj[0], yj = pj[1];
            if (segmentContains(pi, pj, point)) return 0;
            if (yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi) contains = -contains;
        }
        return contains;
    }
    function segmentContains(a, b, c) {
        var i;
        return collinear$1(a, b, c) && within(a[i = +(a[0] === b[0])], c[i], b[i]);
    }
    function collinear$1(a, b, c) {
        return (b[0] - a[0]) * (c[1] - a[1]) === (c[0] - a[0]) * (b[1] - a[1]);
    }
    function within(p, q, r) {
        return p <= q && q <= r || r <= q && q <= p;
    }
    function noop$2() {}
    var cases = [
        [],
        [
            [
                [
                    1.0,
                    1.5
                ],
                [
                    0.5,
                    1.0
                ]
            ]
        ],
        [
            [
                [
                    1.5,
                    1.0
                ],
                [
                    1.0,
                    1.5
                ]
            ]
        ],
        [
            [
                [
                    1.5,
                    1.0
                ],
                [
                    0.5,
                    1.0
                ]
            ]
        ],
        [
            [
                [
                    1.0,
                    0.5
                ],
                [
                    1.5,
                    1.0
                ]
            ]
        ],
        [
            [
                [
                    1.0,
                    1.5
                ],
                [
                    0.5,
                    1.0
                ]
            ],
            [
                [
                    1.0,
                    0.5
                ],
                [
                    1.5,
                    1.0
                ]
            ]
        ],
        [
            [
                [
                    1.0,
                    0.5
                ],
                [
                    1.0,
                    1.5
                ]
            ]
        ],
        [
            [
                [
                    1.0,
                    0.5
                ],
                [
                    0.5,
                    1.0
                ]
            ]
        ],
        [
            [
                [
                    0.5,
                    1.0
                ],
                [
                    1.0,
                    0.5
                ]
            ]
        ],
        [
            [
                [
                    1.0,
                    1.5
                ],
                [
                    1.0,
                    0.5
                ]
            ]
        ],
        [
            [
                [
                    0.5,
                    1.0
                ],
                [
                    1.0,
                    0.5
                ]
            ],
            [
                [
                    1.5,
                    1.0
                ],
                [
                    1.0,
                    1.5
                ]
            ]
        ],
        [
            [
                [
                    1.5,
                    1.0
                ],
                [
                    1.0,
                    0.5
                ]
            ]
        ],
        [
            [
                [
                    0.5,
                    1.0
                ],
                [
                    1.5,
                    1.0
                ]
            ]
        ],
        [
            [
                [
                    1.0,
                    1.5
                ],
                [
                    1.5,
                    1.0
                ]
            ]
        ],
        [
            [
                [
                    0.5,
                    1.0
                ],
                [
                    1.0,
                    1.5
                ]
            ]
        ],
        []
    ];
    function Contours() {
        var dx = 1, dy = 1, threshold = thresholdSturges, smooth = smoothLinear;
        function contours(values) {
            var tz = threshold(values);
            // Convert number of thresholds into uniform thresholds.
            if (!Array.isArray(tz)) {
                const e = extent$1(values), ts = tickStep(e[0], e[1], tz);
                tz = ticks(Math.floor(e[0] / ts) * ts, Math.floor(e[1] / ts - 1) * ts, tz);
            } else tz = tz.slice().sort(ascending$1);
            return tz.map((value)=>contour(values, value));
        }
        // Accumulate, smooth contour rings, assign holes to exterior rings.
        // Based on https://github.com/mbostock/shapefile/blob/v0.6.2/shp/polygon.js
        function contour(values, value) {
            var polygons = [], holes = [];
            isorings(values, value, function(ring) {
                smooth(ring, values, value);
                if (area$3(ring) > 0) polygons.push([
                    ring
                ]);
                else holes.push(ring);
            });
            holes.forEach(function(hole) {
                for(var i = 0, n = polygons.length, polygon; i < n; ++i)if (contains$2((polygon = polygons[i])[0], hole) !== -1) {
                    polygon.push(hole);
                    return;
                }
            });
            return {
                type: "MultiPolygon",
                value: value,
                coordinates: polygons
            };
        }
        // Marching squares with isolines stitched into rings.
        // Based on https://github.com/topojson/topojson-client/blob/v3.0.0/src/stitch.js
        function isorings(values, value, callback) {
            var fragmentByStart = new Array, fragmentByEnd = new Array, x, y, t0, t1, t2, t3;
            // Special case for the first row (y = -1, t2 = t3 = 0).
            x = y = -1;
            t1 = values[0] >= value;
            cases[t1 << 1].forEach(stitch);
            while(++x < dx - 1){
                t0 = t1, t1 = values[x + 1] >= value;
                cases[t0 | t1 << 1].forEach(stitch);
            }
            cases[t1 << 0].forEach(stitch);
            // General case for the intermediate rows.
            while(++y < dy - 1){
                x = -1;
                t1 = values[y * dx + dx] >= value;
                t2 = values[y * dx] >= value;
                cases[t1 << 1 | t2 << 2].forEach(stitch);
                while(++x < dx - 1){
                    t0 = t1, t1 = values[y * dx + dx + x + 1] >= value;
                    t3 = t2, t2 = values[y * dx + x + 1] >= value;
                    cases[t0 | t1 << 1 | t2 << 2 | t3 << 3].forEach(stitch);
                }
                cases[t1 | t2 << 3].forEach(stitch);
            }
            // Special case for the last row (y = dy - 1, t0 = t1 = 0).
            x = -1;
            t2 = values[y * dx] >= value;
            cases[t2 << 2].forEach(stitch);
            while(++x < dx - 1){
                t3 = t2, t2 = values[y * dx + x + 1] >= value;
                cases[t2 << 2 | t3 << 3].forEach(stitch);
            }
            cases[t2 << 3].forEach(stitch);
            function stitch(line) {
                var start = [
                    line[0][0] + x,
                    line[0][1] + y
                ], end = [
                    line[1][0] + x,
                    line[1][1] + y
                ], startIndex = index(start), endIndex = index(end), f, g;
                if (f = fragmentByEnd[startIndex]) {
                    if (g = fragmentByStart[endIndex]) {
                        delete fragmentByEnd[f.end];
                        delete fragmentByStart[g.start];
                        if (f === g) {
                            f.ring.push(end);
                            callback(f.ring);
                        } else fragmentByStart[f.start] = fragmentByEnd[g.end] = {
                            start: f.start,
                            end: g.end,
                            ring: f.ring.concat(g.ring)
                        };
                    } else {
                        delete fragmentByEnd[f.end];
                        f.ring.push(end);
                        fragmentByEnd[f.end = endIndex] = f;
                    }
                } else if (f = fragmentByStart[endIndex]) {
                    if (g = fragmentByEnd[startIndex]) {
                        delete fragmentByStart[f.start];
                        delete fragmentByEnd[g.end];
                        if (f === g) {
                            f.ring.push(end);
                            callback(f.ring);
                        } else fragmentByStart[g.start] = fragmentByEnd[f.end] = {
                            start: g.start,
                            end: f.end,
                            ring: g.ring.concat(f.ring)
                        };
                    } else {
                        delete fragmentByStart[f.start];
                        f.ring.unshift(start);
                        fragmentByStart[f.start = startIndex] = f;
                    }
                } else fragmentByStart[startIndex] = fragmentByEnd[endIndex] = {
                    start: startIndex,
                    end: endIndex,
                    ring: [
                        start,
                        end
                    ]
                };
            }
        }
        function index(point) {
            return point[0] * 2 + point[1] * (dx + 1) * 4;
        }
        function smoothLinear(ring, values, value) {
            ring.forEach(function(point) {
                var x = point[0], y = point[1], xt = x | 0, yt = y | 0, v0, v1 = values[yt * dx + xt];
                if (x > 0 && x < dx && xt === x) {
                    v0 = values[yt * dx + xt - 1];
                    point[0] = x + (value - v0) / (v1 - v0) - 0.5;
                }
                if (y > 0 && y < dy && yt === y) {
                    v0 = values[(yt - 1) * dx + xt];
                    point[1] = y + (value - v0) / (v1 - v0) - 0.5;
                }
            });
        }
        contours.contour = contour;
        contours.size = function(_) {
            if (!arguments.length) return [
                dx,
                dy
            ];
            var _0 = Math.floor(_[0]), _1 = Math.floor(_[1]);
            if (!(_0 >= 0 && _1 >= 0)) throw new Error("invalid size");
            return dx = _0, dy = _1, contours;
        };
        contours.thresholds = function(_) {
            return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant$5(slice$1.call(_)) : constant$5(_), contours) : threshold;
        };
        contours.smooth = function(_) {
            return arguments.length ? (smooth = _ ? smoothLinear : noop$2, contours) : smooth === smoothLinear;
        };
        return contours;
    }
    function defaultX$1(d) {
        return d[0];
    }
    function defaultY$1(d) {
        return d[1];
    }
    function defaultWeight() {
        return 1;
    }
    function density() {
        var x = defaultX$1, y = defaultY$1, weight = defaultWeight, dx = 960, dy = 500, r = 20, k = 2, o = r * 3, n = dx + o * 2 >> k, m = dy + o * 2 >> k, threshold = constant$5(20);
        function grid(data) {
            var values = new Float32Array(n * m), pow2k = Math.pow(2, -k), i = -1;
            for (const d of data){
                var xi = (x(d, ++i, data) + o) * pow2k, yi = (y(d, i, data) + o) * pow2k, wi = +weight(d, i, data);
                if (xi >= 0 && xi < n && yi >= 0 && yi < m) {
                    var x0 = Math.floor(xi), y0 = Math.floor(yi), xt = xi - x0 - 0.5, yt = yi - y0 - 0.5;
                    values[x0 + y0 * n] += (1 - xt) * (1 - yt) * wi;
                    values[x0 + 1 + y0 * n] += xt * (1 - yt) * wi;
                    values[x0 + 1 + (y0 + 1) * n] += xt * yt * wi;
                    values[x0 + (y0 + 1) * n] += (1 - xt) * yt * wi;
                }
            }
            blur2({
                data: values,
                width: n,
                height: m
            }, r * pow2k);
            return values;
        }
        function density(data) {
            var values = grid(data), tz = threshold(values), pow4k = Math.pow(2, 2 * k);
            // Convert number of thresholds into uniform thresholds.
            if (!Array.isArray(tz)) tz = ticks(Number.MIN_VALUE, max$3(values) / pow4k, tz);
            return Contours().size([
                n,
                m
            ]).thresholds(tz.map((d)=>d * pow4k))(values).map((c, i)=>(c.value = +tz[i], transform(c)));
        }
        density.contours = function(data) {
            var values = grid(data), contours = Contours().size([
                n,
                m
            ]), pow4k = Math.pow(2, 2 * k), contour = (value)=>{
                value = +value;
                var c = transform(contours.contour(values, value * pow4k));
                c.value = value; // preserve exact threshold value
                return c;
            };
            Object.defineProperty(contour, "max", {
                get: ()=>max$3(values) / pow4k
            });
            return contour;
        };
        function transform(geometry) {
            geometry.coordinates.forEach(transformPolygon);
            return geometry;
        }
        function transformPolygon(coordinates) {
            coordinates.forEach(transformRing);
        }
        function transformRing(coordinates) {
            coordinates.forEach(transformPoint);
        }
        // TODO Optimize.
        function transformPoint(coordinates) {
            coordinates[0] = coordinates[0] * Math.pow(2, k) - o;
            coordinates[1] = coordinates[1] * Math.pow(2, k) - o;
        }
        function resize() {
            o = r * 3;
            n = dx + o * 2 >> k;
            m = dy + o * 2 >> k;
            return density;
        }
        density.x = function(_) {
            return arguments.length ? (x = typeof _ === "function" ? _ : constant$5(+_), density) : x;
        };
        density.y = function(_) {
            return arguments.length ? (y = typeof _ === "function" ? _ : constant$5(+_), density) : y;
        };
        density.weight = function(_) {
            return arguments.length ? (weight = typeof _ === "function" ? _ : constant$5(+_), density) : weight;
        };
        density.size = function(_) {
            if (!arguments.length) return [
                dx,
                dy
            ];
            var _0 = +_[0], _1 = +_[1];
            if (!(_0 >= 0 && _1 >= 0)) throw new Error("invalid size");
            return dx = _0, dy = _1, resize();
        };
        density.cellSize = function(_) {
            if (!arguments.length) return 1 << k;
            if (!((_ = +_) >= 1)) throw new Error("invalid cell size");
            return k = Math.floor(Math.log(_) / Math.LN2), resize();
        };
        density.thresholds = function(_) {
            return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant$5(slice$1.call(_)) : constant$5(_), density) : threshold;
        };
        density.bandwidth = function(_) {
            if (!arguments.length) return Math.sqrt(r * (r + 1));
            if (!((_ = +_) >= 0)) throw new Error("invalid bandwidth");
            return r = (Math.sqrt(4 * _ * _ + 1) - 1) / 2, resize();
        };
        return density;
    }
    const epsilon$3 = 1.1102230246251565e-16;
    const splitter = 134217729;
    const resulterrbound = (3 + 8 * epsilon$3) * epsilon$3;
    // fast_expansion_sum_zeroelim routine from oritinal code
    function sum$1(elen, e, flen, f, h) {
        let Q, Qnew, hh, bvirt;
        let enow = e[0];
        let fnow = f[0];
        let eindex = 0;
        let findex = 0;
        if (fnow > enow === fnow > -enow) {
            Q = enow;
            enow = e[++eindex];
        } else {
            Q = fnow;
            fnow = f[++findex];
        }
        let hindex = 0;
        if (eindex < elen && findex < flen) {
            if (fnow > enow === fnow > -enow) {
                Qnew = enow + Q;
                hh = Q - (Qnew - enow);
                enow = e[++eindex];
            } else {
                Qnew = fnow + Q;
                hh = Q - (Qnew - fnow);
                fnow = f[++findex];
            }
            Q = Qnew;
            if (hh !== 0) h[hindex++] = hh;
            while(eindex < elen && findex < flen){
                if (fnow > enow === fnow > -enow) {
                    Qnew = Q + enow;
                    bvirt = Qnew - Q;
                    hh = Q - (Qnew - bvirt) + (enow - bvirt);
                    enow = e[++eindex];
                } else {
                    Qnew = Q + fnow;
                    bvirt = Qnew - Q;
                    hh = Q - (Qnew - bvirt) + (fnow - bvirt);
                    fnow = f[++findex];
                }
                Q = Qnew;
                if (hh !== 0) h[hindex++] = hh;
            }
        }
        while(eindex < elen){
            Qnew = Q + enow;
            bvirt = Qnew - Q;
            hh = Q - (Qnew - bvirt) + (enow - bvirt);
            enow = e[++eindex];
            Q = Qnew;
            if (hh !== 0) h[hindex++] = hh;
        }
        while(findex < flen){
            Qnew = Q + fnow;
            bvirt = Qnew - Q;
            hh = Q - (Qnew - bvirt) + (fnow - bvirt);
            fnow = f[++findex];
            Q = Qnew;
            if (hh !== 0) h[hindex++] = hh;
        }
        if (Q !== 0 || hindex === 0) h[hindex++] = Q;
        return hindex;
    }
    function estimate(elen, e) {
        let Q = e[0];
        for(let i = 1; i < elen; i++)Q += e[i];
        return Q;
    }
    function vec(n) {
        return new Float64Array(n);
    }
    const ccwerrboundA = (3 + 16 * epsilon$3) * epsilon$3;
    const ccwerrboundB = (2 + 12 * epsilon$3) * epsilon$3;
    const ccwerrboundC = (9 + 64 * epsilon$3) * epsilon$3 * epsilon$3;
    const B = vec(4);
    const C1 = vec(8);
    const C2 = vec(12);
    const D = vec(16);
    const u = vec(4);
    function orient2dadapt(ax, ay, bx, by, cx, cy, detsum) {
        let acxtail, acytail, bcxtail, bcytail;
        let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0, u3;
        const acx = ax - cx;
        const bcx = bx - cx;
        const acy = ay - cy;
        const bcy = by - cy;
        s1 = acx * bcy;
        c = splitter * acx;
        ahi = c - (c - acx);
        alo = acx - ahi;
        c = splitter * bcy;
        bhi = c - (c - bcy);
        blo = bcy - bhi;
        s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        t1 = acy * bcx;
        c = splitter * acy;
        ahi = c - (c - acy);
        alo = acy - ahi;
        c = splitter * bcx;
        bhi = c - (c - bcx);
        blo = bcx - bhi;
        t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
        _i = s0 - t0;
        bvirt = s0 - _i;
        B[0] = s0 - (_i + bvirt) + (bvirt - t0);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 - t1;
        bvirt = _0 - _i;
        B[1] = _0 - (_i + bvirt) + (bvirt - t1);
        u3 = _j + _i;
        bvirt = u3 - _j;
        B[2] = _j - (u3 - bvirt) + (_i - bvirt);
        B[3] = u3;
        let det = estimate(4, B);
        let errbound = ccwerrboundB * detsum;
        if (det >= errbound || -det >= errbound) return det;
        bvirt = ax - acx;
        acxtail = ax - (acx + bvirt) + (bvirt - cx);
        bvirt = bx - bcx;
        bcxtail = bx - (bcx + bvirt) + (bvirt - cx);
        bvirt = ay - acy;
        acytail = ay - (acy + bvirt) + (bvirt - cy);
        bvirt = by - bcy;
        bcytail = by - (bcy + bvirt) + (bvirt - cy);
        if (acxtail === 0 && acytail === 0 && bcxtail === 0 && bcytail === 0) return det;
        errbound = ccwerrboundC * detsum + resulterrbound * Math.abs(det);
        det += acx * bcytail + bcy * acxtail - (acy * bcxtail + bcx * acytail);
        if (det >= errbound || -det >= errbound) return det;
        s1 = acxtail * bcy;
        c = splitter * acxtail;
        ahi = c - (c - acxtail);
        alo = acxtail - ahi;
        c = splitter * bcy;
        bhi = c - (c - bcy);
        blo = bcy - bhi;
        s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        t1 = acytail * bcx;
        c = splitter * acytail;
        ahi = c - (c - acytail);
        alo = acytail - ahi;
        c = splitter * bcx;
        bhi = c - (c - bcx);
        blo = bcx - bhi;
        t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
        _i = s0 - t0;
        bvirt = s0 - _i;
        u[0] = s0 - (_i + bvirt) + (bvirt - t0);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 - t1;
        bvirt = _0 - _i;
        u[1] = _0 - (_i + bvirt) + (bvirt - t1);
        u3 = _j + _i;
        bvirt = u3 - _j;
        u[2] = _j - (u3 - bvirt) + (_i - bvirt);
        u[3] = u3;
        const C1len = sum$1(4, B, 4, u, C1);
        s1 = acx * bcytail;
        c = splitter * acx;
        ahi = c - (c - acx);
        alo = acx - ahi;
        c = splitter * bcytail;
        bhi = c - (c - bcytail);
        blo = bcytail - bhi;
        s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        t1 = acy * bcxtail;
        c = splitter * acy;
        ahi = c - (c - acy);
        alo = acy - ahi;
        c = splitter * bcxtail;
        bhi = c - (c - bcxtail);
        blo = bcxtail - bhi;
        t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
        _i = s0 - t0;
        bvirt = s0 - _i;
        u[0] = s0 - (_i + bvirt) + (bvirt - t0);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 - t1;
        bvirt = _0 - _i;
        u[1] = _0 - (_i + bvirt) + (bvirt - t1);
        u3 = _j + _i;
        bvirt = u3 - _j;
        u[2] = _j - (u3 - bvirt) + (_i - bvirt);
        u[3] = u3;
        const C2len = sum$1(C1len, C1, 4, u, C2);
        s1 = acxtail * bcytail;
        c = splitter * acxtail;
        ahi = c - (c - acxtail);
        alo = acxtail - ahi;
        c = splitter * bcytail;
        bhi = c - (c - bcytail);
        blo = bcytail - bhi;
        s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        t1 = acytail * bcxtail;
        c = splitter * acytail;
        ahi = c - (c - acytail);
        alo = acytail - ahi;
        c = splitter * bcxtail;
        bhi = c - (c - bcxtail);
        blo = bcxtail - bhi;
        t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
        _i = s0 - t0;
        bvirt = s0 - _i;
        u[0] = s0 - (_i + bvirt) + (bvirt - t0);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 - t1;
        bvirt = _0 - _i;
        u[1] = _0 - (_i + bvirt) + (bvirt - t1);
        u3 = _j + _i;
        bvirt = u3 - _j;
        u[2] = _j - (u3 - bvirt) + (_i - bvirt);
        u[3] = u3;
        const Dlen = sum$1(C2len, C2, 4, u, D);
        return D[Dlen - 1];
    }
    function orient2d(ax, ay, bx, by, cx, cy) {
        const detleft = (ay - cy) * (bx - cx);
        const detright = (ax - cx) * (by - cy);
        const det = detleft - detright;
        if (detleft === 0 || detright === 0 || detleft > 0 !== detright > 0) return det;
        const detsum = Math.abs(detleft + detright);
        if (Math.abs(det) >= ccwerrboundA * detsum) return det;
        return -orient2dadapt(ax, ay, bx, by, cx, cy, detsum);
    }
    const EPSILON = Math.pow(2, -52);
    const EDGE_STACK = new Uint32Array(512);
    class Delaunator {
        static from(points, getX = defaultGetX, getY = defaultGetY) {
            const n = points.length;
            const coords = new Float64Array(n * 2);
            for(let i = 0; i < n; i++){
                const p = points[i];
                coords[2 * i] = getX(p);
                coords[2 * i + 1] = getY(p);
            }
            return new Delaunator(coords);
        }
        constructor(coords){
            const n = coords.length >> 1;
            if (n > 0 && typeof coords[0] !== 'number') throw new Error('Expected coords to contain numbers.');
            this.coords = coords;
            // arrays that will store the triangulation graph
            const maxTriangles = Math.max(2 * n - 5, 0);
            this._triangles = new Uint32Array(maxTriangles * 3);
            this._halfedges = new Int32Array(maxTriangles * 3);
            // temporary arrays for tracking the edges of the advancing convex hull
            this._hashSize = Math.ceil(Math.sqrt(n));
            this._hullPrev = new Uint32Array(n); // edge to prev edge
            this._hullNext = new Uint32Array(n); // edge to next edge
            this._hullTri = new Uint32Array(n); // edge to adjacent triangle
            this._hullHash = new Int32Array(this._hashSize).fill(-1); // angular edge hash
            // temporary arrays for sorting points
            this._ids = new Uint32Array(n);
            this._dists = new Float64Array(n);
            this.update();
        }
        update() {
            const { coords: coords, _hullPrev: hullPrev, _hullNext: hullNext, _hullTri: hullTri, _hullHash: hullHash } = this;
            const n = coords.length >> 1;
            // populate an array of point indices; calculate input data bbox
            let minX = Infinity;
            let minY = Infinity;
            let maxX = -Infinity;
            let maxY = -Infinity;
            for(let i = 0; i < n; i++){
                const x = coords[2 * i];
                const y = coords[2 * i + 1];
                if (x < minX) minX = x;
                if (y < minY) minY = y;
                if (x > maxX) maxX = x;
                if (y > maxY) maxY = y;
                this._ids[i] = i;
            }
            const cx = (minX + maxX) / 2;
            const cy = (minY + maxY) / 2;
            let minDist = Infinity;
            let i0, i1, i2;
            // pick a seed point close to the center
            for(let i = 0; i < n; i++){
                const d = dist(cx, cy, coords[2 * i], coords[2 * i + 1]);
                if (d < minDist) {
                    i0 = i;
                    minDist = d;
                }
            }
            const i0x = coords[2 * i0];
            const i0y = coords[2 * i0 + 1];
            minDist = Infinity;
            // find the point closest to the seed
            for(let i = 0; i < n; i++){
                if (i === i0) continue;
                const d = dist(i0x, i0y, coords[2 * i], coords[2 * i + 1]);
                if (d < minDist && d > 0) {
                    i1 = i;
                    minDist = d;
                }
            }
            let i1x = coords[2 * i1];
            let i1y = coords[2 * i1 + 1];
            let minRadius = Infinity;
            // find the third point which forms the smallest circumcircle with the first two
            for(let i = 0; i < n; i++){
                if (i === i0 || i === i1) continue;
                const r = circumradius(i0x, i0y, i1x, i1y, coords[2 * i], coords[2 * i + 1]);
                if (r < minRadius) {
                    i2 = i;
                    minRadius = r;
                }
            }
            let i2x = coords[2 * i2];
            let i2y = coords[2 * i2 + 1];
            if (minRadius === Infinity) {
                // order collinear points by dx (or dy if all x are identical)
                // and return the list as a hull
                for(let i = 0; i < n; i++)this._dists[i] = coords[2 * i] - coords[0] || coords[2 * i + 1] - coords[1];
                quicksort(this._ids, this._dists, 0, n - 1);
                const hull = new Uint32Array(n);
                let j = 0;
                for(let i = 0, d0 = -Infinity; i < n; i++){
                    const id = this._ids[i];
                    if (this._dists[id] > d0) {
                        hull[j++] = id;
                        d0 = this._dists[id];
                    }
                }
                this.hull = hull.subarray(0, j);
                this.triangles = new Uint32Array(0);
                this.halfedges = new Uint32Array(0);
                return;
            }
            // swap the order of the seed points for counter-clockwise orientation
            if (orient2d(i0x, i0y, i1x, i1y, i2x, i2y) < 0) {
                const i = i1;
                const x = i1x;
                const y = i1y;
                i1 = i2;
                i1x = i2x;
                i1y = i2y;
                i2 = i;
                i2x = x;
                i2y = y;
            }
            const center = circumcenter(i0x, i0y, i1x, i1y, i2x, i2y);
            this._cx = center.x;
            this._cy = center.y;
            for(let i = 0; i < n; i++)this._dists[i] = dist(coords[2 * i], coords[2 * i + 1], center.x, center.y);
            // sort the points by distance from the seed triangle circumcenter
            quicksort(this._ids, this._dists, 0, n - 1);
            // set up the seed triangle as the starting hull
            this._hullStart = i0;
            let hullSize = 3;
            hullNext[i0] = hullPrev[i2] = i1;
            hullNext[i1] = hullPrev[i0] = i2;
            hullNext[i2] = hullPrev[i1] = i0;
            hullTri[i0] = 0;
            hullTri[i1] = 1;
            hullTri[i2] = 2;
            hullHash.fill(-1);
            hullHash[this._hashKey(i0x, i0y)] = i0;
            hullHash[this._hashKey(i1x, i1y)] = i1;
            hullHash[this._hashKey(i2x, i2y)] = i2;
            this.trianglesLen = 0;
            this._addTriangle(i0, i1, i2, -1, -1, -1);
            for(let k = 0, xp, yp; k < this._ids.length; k++){
                const i = this._ids[k];
                const x = coords[2 * i];
                const y = coords[2 * i + 1];
                // skip near-duplicate points
                if (k > 0 && Math.abs(x - xp) <= EPSILON && Math.abs(y - yp) <= EPSILON) continue;
                xp = x;
                yp = y;
                // skip seed triangle points
                if (i === i0 || i === i1 || i === i2) continue;
                // find a visible edge on the convex hull using edge hash
                let start = 0;
                for(let j = 0, key = this._hashKey(x, y); j < this._hashSize; j++){
                    start = hullHash[(key + j) % this._hashSize];
                    if (start !== -1 && start !== hullNext[start]) break;
                }
                start = hullPrev[start];
                let e = start, q;
                while(q = hullNext[e], orient2d(x, y, coords[2 * e], coords[2 * e + 1], coords[2 * q], coords[2 * q + 1]) >= 0){
                    e = q;
                    if (e === start) {
                        e = -1;
                        break;
                    }
                }
                if (e === -1) continue; // likely a near-duplicate point; skip it
                // add the first triangle from the point
                let t = this._addTriangle(e, i, hullNext[e], -1, -1, hullTri[e]);
                // recursively flip triangles from the point until they satisfy the Delaunay condition
                hullTri[i] = this._legalize(t + 2);
                hullTri[e] = t; // keep track of boundary triangles on the hull
                hullSize++;
                // walk forward through the hull, adding more triangles and flipping recursively
                let n = hullNext[e];
                while(q = hullNext[n], orient2d(x, y, coords[2 * n], coords[2 * n + 1], coords[2 * q], coords[2 * q + 1]) < 0){
                    t = this._addTriangle(n, i, q, hullTri[i], -1, hullTri[n]);
                    hullTri[i] = this._legalize(t + 2);
                    hullNext[n] = n; // mark as removed
                    hullSize--;
                    n = q;
                }
                // walk backward from the other side, adding more triangles and flipping
                if (e === start) while(q = hullPrev[e], orient2d(x, y, coords[2 * q], coords[2 * q + 1], coords[2 * e], coords[2 * e + 1]) < 0){
                    t = this._addTriangle(q, i, e, -1, hullTri[e], hullTri[q]);
                    this._legalize(t + 2);
                    hullTri[q] = t;
                    hullNext[e] = e; // mark as removed
                    hullSize--;
                    e = q;
                }
                // update the hull indices
                this._hullStart = hullPrev[i] = e;
                hullNext[e] = hullPrev[n] = i;
                hullNext[i] = n;
                // save the two new edges in the hash table
                hullHash[this._hashKey(x, y)] = i;
                hullHash[this._hashKey(coords[2 * e], coords[2 * e + 1])] = e;
            }
            this.hull = new Uint32Array(hullSize);
            for(let i = 0, e = this._hullStart; i < hullSize; i++){
                this.hull[i] = e;
                e = hullNext[e];
            }
            // trim typed triangle mesh arrays
            this.triangles = this._triangles.subarray(0, this.trianglesLen);
            this.halfedges = this._halfedges.subarray(0, this.trianglesLen);
        }
        _hashKey(x, y) {
            return Math.floor(pseudoAngle(x - this._cx, y - this._cy) * this._hashSize) % this._hashSize;
        }
        _legalize(a) {
            const { _triangles: triangles, _halfedges: halfedges, coords: coords } = this;
            let i = 0;
            let ar = 0;
            // recursion eliminated with a fixed-size stack
            while(true){
                const b = halfedges[a];
                /* if the pair of triangles doesn't satisfy the Delaunay condition
             * (p1 is inside the circumcircle of [p0, pl, pr]), flip them,
             * then do the same check/flip recursively for the new pair of triangles
             *
             *           pl                    pl
             *          /||\                  /  \
             *       al/ || \bl            al/    \a
             *        /  ||  \              /      \
             *       /  a||b  \    flip    /___ar___\
             *     p0\   ||   /p1   =>   p0\---bl---/p1
             *        \  ||  /              \      /
             *       ar\ || /br             b\    /br
             *          \||/                  \  /
             *           pr                    pr
             */ const a0 = a - a % 3;
                ar = a0 + (a + 2) % 3;
                if (b === -1) {
                    if (i === 0) break;
                    a = EDGE_STACK[--i];
                    continue;
                }
                const b0 = b - b % 3;
                const al = a0 + (a + 1) % 3;
                const bl = b0 + (b + 2) % 3;
                const p0 = triangles[ar];
                const pr = triangles[a];
                const pl = triangles[al];
                const p1 = triangles[bl];
                const illegal = inCircle(coords[2 * p0], coords[2 * p0 + 1], coords[2 * pr], coords[2 * pr + 1], coords[2 * pl], coords[2 * pl + 1], coords[2 * p1], coords[2 * p1 + 1]);
                if (illegal) {
                    triangles[a] = p1;
                    triangles[b] = p0;
                    const hbl = halfedges[bl];
                    // edge swapped on the other side of the hull (rare); fix the halfedge reference
                    if (hbl === -1) {
                        let e = this._hullStart;
                        do {
                            if (this._hullTri[e] === bl) {
                                this._hullTri[e] = a;
                                break;
                            }
                            e = this._hullPrev[e];
                        }while (e !== this._hullStart);
                    }
                    this._link(a, hbl);
                    this._link(b, halfedges[ar]);
                    this._link(ar, bl);
                    const br = b0 + (b + 1) % 3;
                    // don't worry about hitting the cap: it can only happen on extremely degenerate input
                    if (i < EDGE_STACK.length) EDGE_STACK[i++] = br;
                } else {
                    if (i === 0) break;
                    a = EDGE_STACK[--i];
                }
            }
            return ar;
        }
        _link(a, b) {
            this._halfedges[a] = b;
            if (b !== -1) this._halfedges[b] = a;
        }
        // add a new triangle given vertex indices and adjacent half-edge ids
        _addTriangle(i0, i1, i2, a, b, c) {
            const t = this.trianglesLen;
            this._triangles[t] = i0;
            this._triangles[t + 1] = i1;
            this._triangles[t + 2] = i2;
            this._link(t, a);
            this._link(t + 1, b);
            this._link(t + 2, c);
            this.trianglesLen += 3;
            return t;
        }
    }
    // monotonically increases with real angle, but doesn't need expensive trigonometry
    function pseudoAngle(dx, dy) {
        const p = dx / (Math.abs(dx) + Math.abs(dy));
        return (dy > 0 ? 3 - p : 1 + p) / 4; // [0..1]
    }
    function dist(ax, ay, bx, by) {
        const dx = ax - bx;
        const dy = ay - by;
        return dx * dx + dy * dy;
    }
    function inCircle(ax, ay, bx, by, cx, cy, px, py) {
        const dx = ax - px;
        const dy = ay - py;
        const ex = bx - px;
        const ey = by - py;
        const fx = cx - px;
        const fy = cy - py;
        const ap = dx * dx + dy * dy;
        const bp = ex * ex + ey * ey;
        const cp = fx * fx + fy * fy;
        return dx * (ey * cp - bp * fy) - dy * (ex * cp - bp * fx) + ap * (ex * fy - ey * fx) < 0;
    }
    function circumradius(ax, ay, bx, by, cx, cy) {
        const dx = bx - ax;
        const dy = by - ay;
        const ex = cx - ax;
        const ey = cy - ay;
        const bl = dx * dx + dy * dy;
        const cl = ex * ex + ey * ey;
        const d = 0.5 / (dx * ey - dy * ex);
        const x = (ey * bl - dy * cl) * d;
        const y = (dx * cl - ex * bl) * d;
        return x * x + y * y;
    }
    function circumcenter(ax, ay, bx, by, cx, cy) {
        const dx = bx - ax;
        const dy = by - ay;
        const ex = cx - ax;
        const ey = cy - ay;
        const bl = dx * dx + dy * dy;
        const cl = ex * ex + ey * ey;
        const d = 0.5 / (dx * ey - dy * ex);
        const x = ax + (ey * bl - dy * cl) * d;
        const y = ay + (dx * cl - ex * bl) * d;
        return {
            x: x,
            y: y
        };
    }
    function quicksort(ids, dists, left, right) {
        if (right - left <= 20) for(let i = left + 1; i <= right; i++){
            const temp = ids[i];
            const tempDist = dists[temp];
            let j = i - 1;
            while(j >= left && dists[ids[j]] > tempDist)ids[j + 1] = ids[j--];
            ids[j + 1] = temp;
        }
        else {
            const median = left + right >> 1;
            let i = left + 1;
            let j = right;
            swap(ids, median, i);
            if (dists[ids[left]] > dists[ids[right]]) swap(ids, left, right);
            if (dists[ids[i]] > dists[ids[right]]) swap(ids, i, right);
            if (dists[ids[left]] > dists[ids[i]]) swap(ids, left, i);
            const temp = ids[i];
            const tempDist = dists[temp];
            while(true){
                do i++;
                while (dists[ids[i]] < tempDist);
                do j--;
                while (dists[ids[j]] > tempDist);
                if (j < i) break;
                swap(ids, i, j);
            }
            ids[left + 1] = ids[j];
            ids[j] = temp;
            if (right - i + 1 >= j - left) {
                quicksort(ids, dists, i, right);
                quicksort(ids, dists, left, j - 1);
            } else {
                quicksort(ids, dists, left, j - 1);
                quicksort(ids, dists, i, right);
            }
        }
    }
    function swap(arr, i, j) {
        const tmp = arr[i];
        arr[i] = arr[j];
        arr[j] = tmp;
    }
    function defaultGetX(p) {
        return p[0];
    }
    function defaultGetY(p) {
        return p[1];
    }
    const epsilon$2 = 1e-6;
    class Path {
        constructor(){
            this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
            this._ = "";
        }
        moveTo(x, y) {
            this._ += `M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}`;
        }
        closePath() {
            if (this._x1 !== null) {
                this._x1 = this._x0, this._y1 = this._y0;
                this._ += "Z";
            }
        }
        lineTo(x, y) {
            this._ += `L${this._x1 = +x},${this._y1 = +y}`;
        }
        arc(x, y, r) {
            x = +x, y = +y, r = +r;
            const x0 = x + r;
            const y0 = y;
            if (r < 0) throw new Error("negative radius");
            if (this._x1 === null) this._ += `M${x0},${y0}`;
            else if (Math.abs(this._x1 - x0) > epsilon$2 || Math.abs(this._y1 - y0) > epsilon$2) this._ += "L" + x0 + "," + y0;
            if (!r) return;
            this._ += `A${r},${r},0,1,1,${x - r},${y}A${r},${r},0,1,1,${this._x1 = x0},${this._y1 = y0}`;
        }
        rect(x, y, w, h) {
            this._ += `M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}h${+w}v${+h}h${-w}Z`;
        }
        value() {
            return this._ || null;
        }
    }
    class Polygon {
        constructor(){
            this._ = [];
        }
        moveTo(x, y) {
            this._.push([
                x,
                y
            ]);
        }
        closePath() {
            this._.push(this._[0].slice());
        }
        lineTo(x, y) {
            this._.push([
                x,
                y
            ]);
        }
        value() {
            return this._.length ? this._ : null;
        }
    }
    class Voronoi {
        constructor(delaunay, [xmin, ymin, xmax, ymax] = [
            0,
            0,
            960,
            500
        ]){
            if (!((xmax = +xmax) >= (xmin = +xmin)) || !((ymax = +ymax) >= (ymin = +ymin))) throw new Error("invalid bounds");
            this.delaunay = delaunay;
            this._circumcenters = new Float64Array(delaunay.points.length * 2);
            this.vectors = new Float64Array(delaunay.points.length * 2);
            this.xmax = xmax, this.xmin = xmin;
            this.ymax = ymax, this.ymin = ymin;
            this._init();
        }
        update() {
            this.delaunay.update();
            this._init();
            return this;
        }
        _init() {
            const { delaunay: { points: points, hull: hull, triangles: triangles }, vectors: vectors } = this;
            // Compute circumcenters.
            const circumcenters = this.circumcenters = this._circumcenters.subarray(0, triangles.length / 3 * 2);
            for(let i = 0, j = 0, n = triangles.length, x, y; i < n; i += 3, j += 2){
                const t1 = triangles[i] * 2;
                const t2 = triangles[i + 1] * 2;
                const t3 = triangles[i + 2] * 2;
                const x1 = points[t1];
                const y1 = points[t1 + 1];
                const x2 = points[t2];
                const y2 = points[t2 + 1];
                const x3 = points[t3];
                const y3 = points[t3 + 1];
                const dx = x2 - x1;
                const dy = y2 - y1;
                const ex = x3 - x1;
                const ey = y3 - y1;
                const ab = (dx * ey - dy * ex) * 2;
                if (Math.abs(ab) < 1e-9) {
                    // degenerate case (collinear diagram)
                    // almost equal points (degenerate triangle)
                    // the circumcenter is at the infinity, in a
                    // direction that is:
                    // 1. orthogonal to the halfedge.
                    let a = 1e9;
                    // 2. points away from the center; since the list of triangles starts
                    // in the center, the first point of the first triangle
                    // will be our reference
                    const r = triangles[0] * 2;
                    a *= Math.sign((points[r] - x1) * ey - (points[r + 1] - y1) * ex);
                    x = (x1 + x3) / 2 - a * ey;
                    y = (y1 + y3) / 2 + a * ex;
                } else {
                    const d = 1 / ab;
                    const bl = dx * dx + dy * dy;
                    const cl = ex * ex + ey * ey;
                    x = x1 + (ey * bl - dy * cl) * d;
                    y = y1 + (dx * cl - ex * bl) * d;
                }
                circumcenters[j] = x;
                circumcenters[j + 1] = y;
            }
            // Compute exterior cell rays.
            let h = hull[hull.length - 1];
            let p0, p1 = h * 4;
            let x0, x1 = points[2 * h];
            let y0, y1 = points[2 * h + 1];
            vectors.fill(0);
            for(let i = 0; i < hull.length; ++i){
                h = hull[i];
                p0 = p1, x0 = x1, y0 = y1;
                p1 = h * 4, x1 = points[2 * h], y1 = points[2 * h + 1];
                vectors[p0 + 2] = vectors[p1] = y0 - y1;
                vectors[p0 + 3] = vectors[p1 + 1] = x1 - x0;
            }
        }
        render(context) {
            const buffer = context == null ? context = new Path : undefined;
            const { delaunay: { halfedges: halfedges, inedges: inedges, hull: hull }, circumcenters: circumcenters, vectors: vectors } = this;
            if (hull.length <= 1) return null;
            for(let i = 0, n = halfedges.length; i < n; ++i){
                const j = halfedges[i];
                if (j < i) continue;
                const ti = Math.floor(i / 3) * 2;
                const tj = Math.floor(j / 3) * 2;
                const xi = circumcenters[ti];
                const yi = circumcenters[ti + 1];
                const xj = circumcenters[tj];
                const yj = circumcenters[tj + 1];
                this._renderSegment(xi, yi, xj, yj, context);
            }
            let h0, h1 = hull[hull.length - 1];
            for(let i = 0; i < hull.length; ++i){
                h0 = h1, h1 = hull[i];
                const t = Math.floor(inedges[h1] / 3) * 2;
                const x = circumcenters[t];
                const y = circumcenters[t + 1];
                const v = h0 * 4;
                const p = this._project(x, y, vectors[v + 2], vectors[v + 3]);
                if (p) this._renderSegment(x, y, p[0], p[1], context);
            }
            return buffer && buffer.value();
        }
        renderBounds(context) {
            const buffer = context == null ? context = new Path : undefined;
            context.rect(this.xmin, this.ymin, this.xmax - this.xmin, this.ymax - this.ymin);
            return buffer && buffer.value();
        }
        renderCell(i, context) {
            const buffer = context == null ? context = new Path : undefined;
            const points = this._clip(i);
            if (points === null || !points.length) return;
            context.moveTo(points[0], points[1]);
            let n = points.length;
            while(points[0] === points[n - 2] && points[1] === points[n - 1] && n > 1)n -= 2;
            for(let i = 2; i < n; i += 2)if (points[i] !== points[i - 2] || points[i + 1] !== points[i - 1]) context.lineTo(points[i], points[i + 1]);
            context.closePath();
            return buffer && buffer.value();
        }
        *cellPolygons() {
            const { delaunay: { points: points } } = this;
            for(let i = 0, n = points.length / 2; i < n; ++i){
                const cell = this.cellPolygon(i);
                if (cell) cell.index = i, yield cell;
            }
        }
        cellPolygon(i) {
            const polygon = new Polygon;
            this.renderCell(i, polygon);
            return polygon.value();
        }
        _renderSegment(x0, y0, x1, y1, context) {
            let S;
            const c0 = this._regioncode(x0, y0);
            const c1 = this._regioncode(x1, y1);
            if (c0 === 0 && c1 === 0) {
                context.moveTo(x0, y0);
                context.lineTo(x1, y1);
            } else if (S = this._clipSegment(x0, y0, x1, y1, c0, c1)) {
                context.moveTo(S[0], S[1]);
                context.lineTo(S[2], S[3]);
            }
        }
        contains(i, x, y) {
            if ((x = +x, x !== x) || (y = +y, y !== y)) return false;
            return this.delaunay._step(i, x, y) === i;
        }
        *neighbors(i) {
            const ci = this._clip(i);
            if (ci) for (const j of this.delaunay.neighbors(i)){
                const cj = this._clip(j);
                // find the common edge
                if (cj) loop: for(let ai = 0, li = ci.length; ai < li; ai += 2){
                    for(let aj = 0, lj = cj.length; aj < lj; aj += 2)if (ci[ai] == cj[aj] && ci[ai + 1] == cj[aj + 1] && ci[(ai + 2) % li] == cj[(aj + lj - 2) % lj] && ci[(ai + 3) % li] == cj[(aj + lj - 1) % lj]) {
                        yield j;
                        break loop;
                    }
                }
            }
        }
        _cell(i) {
            const { circumcenters: circumcenters, delaunay: { inedges: inedges, halfedges: halfedges, triangles: triangles } } = this;
            const e0 = inedges[i];
            if (e0 === -1) return null; // coincident point
            const points = [];
            let e = e0;
            do {
                const t = Math.floor(e / 3);
                points.push(circumcenters[t * 2], circumcenters[t * 2 + 1]);
                e = e % 3 === 2 ? e - 2 : e + 1;
                if (triangles[e] !== i) break; // bad triangulation
                e = halfedges[e];
            }while (e !== e0 && e !== -1);
            return points;
        }
        _clip(i) {
            // degenerate case (1 valid point: return the box)
            if (i === 0 && this.delaunay.hull.length === 1) return [
                this.xmax,
                this.ymin,
                this.xmax,
                this.ymax,
                this.xmin,
                this.ymax,
                this.xmin,
                this.ymin
            ];
            const points = this._cell(i);
            if (points === null) return null;
            const { vectors: V } = this;
            const v = i * 4;
            return V[v] || V[v + 1] ? this._clipInfinite(i, points, V[v], V[v + 1], V[v + 2], V[v + 3]) : this._clipFinite(i, points);
        }
        _clipFinite(i, points) {
            const n = points.length;
            let P = null;
            let x0, y0, x1 = points[n - 2], y1 = points[n - 1];
            let c0, c1 = this._regioncode(x1, y1);
            let e0, e1 = 0;
            for(let j = 0; j < n; j += 2){
                x0 = x1, y0 = y1, x1 = points[j], y1 = points[j + 1];
                c0 = c1, c1 = this._regioncode(x1, y1);
                if (c0 === 0 && c1 === 0) {
                    e0 = e1, e1 = 0;
                    if (P) P.push(x1, y1);
                    else P = [
                        x1,
                        y1
                    ];
                } else {
                    let S, sx0, sy0, sx1, sy1;
                    if (c0 === 0) {
                        if ((S = this._clipSegment(x0, y0, x1, y1, c0, c1)) === null) continue;
                        [sx0, sy0, sx1, sy1] = S;
                    } else {
                        if ((S = this._clipSegment(x1, y1, x0, y0, c1, c0)) === null) continue;
                        [sx1, sy1, sx0, sy0] = S;
                        e0 = e1, e1 = this._edgecode(sx0, sy0);
                        if (e0 && e1) this._edge(i, e0, e1, P, P.length);
                        if (P) P.push(sx0, sy0);
                        else P = [
                            sx0,
                            sy0
                        ];
                    }
                    e0 = e1, e1 = this._edgecode(sx1, sy1);
                    if (e0 && e1) this._edge(i, e0, e1, P, P.length);
                    if (P) P.push(sx1, sy1);
                    else P = [
                        sx1,
                        sy1
                    ];
                }
            }
            if (P) {
                e0 = e1, e1 = this._edgecode(P[0], P[1]);
                if (e0 && e1) this._edge(i, e0, e1, P, P.length);
            } else if (this.contains(i, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2)) return [
                this.xmax,
                this.ymin,
                this.xmax,
                this.ymax,
                this.xmin,
                this.ymax,
                this.xmin,
                this.ymin
            ];
            return P;
        }
        _clipSegment(x0, y0, x1, y1, c0, c1) {
            while(true){
                if (c0 === 0 && c1 === 0) return [
                    x0,
                    y0,
                    x1,
                    y1
                ];
                if (c0 & c1) return null;
                let x, y, c = c0 || c1;
                if (c & 8) x = x0 + (x1 - x0) * (this.ymax - y0) / (y1 - y0), y = this.ymax;
                else if (c & 4) x = x0 + (x1 - x0) * (this.ymin - y0) / (y1 - y0), y = this.ymin;
                else if (c & 2) y = y0 + (y1 - y0) * (this.xmax - x0) / (x1 - x0), x = this.xmax;
                else y = y0 + (y1 - y0) * (this.xmin - x0) / (x1 - x0), x = this.xmin;
                if (c0) x0 = x, y0 = y, c0 = this._regioncode(x0, y0);
                else x1 = x, y1 = y, c1 = this._regioncode(x1, y1);
            }
        }
        _clipInfinite(i, points, vx0, vy0, vxn, vyn) {
            let P = Array.from(points), p;
            if (p = this._project(P[0], P[1], vx0, vy0)) P.unshift(p[0], p[1]);
            if (p = this._project(P[P.length - 2], P[P.length - 1], vxn, vyn)) P.push(p[0], p[1]);
            if (P = this._clipFinite(i, P)) for(let j = 0, n = P.length, c0, c1 = this._edgecode(P[n - 2], P[n - 1]); j < n; j += 2){
                c0 = c1, c1 = this._edgecode(P[j], P[j + 1]);
                if (c0 && c1) j = this._edge(i, c0, c1, P, j), n = P.length;
            }
            else if (this.contains(i, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2)) P = [
                this.xmin,
                this.ymin,
                this.xmax,
                this.ymin,
                this.xmax,
                this.ymax,
                this.xmin,
                this.ymax
            ];
            return P;
        }
        _edge(i, e0, e1, P, j) {
            while(e0 !== e1){
                let x, y;
                switch(e0){
                    case 5:
                        e0 = 4;
                        continue; // top-left
                    case 4:
                        e0 = 6, x = this.xmax, y = this.ymin;
                        break; // top
                    case 6:
                        e0 = 2;
                        continue; // top-right
                    case 2:
                        e0 = 10, x = this.xmax, y = this.ymax;
                        break; // right
                    case 10:
                        e0 = 8;
                        continue; // bottom-right
                    case 8:
                        e0 = 9, x = this.xmin, y = this.ymax;
                        break; // bottom
                    case 9:
                        e0 = 1;
                        continue; // bottom-left
                    case 1:
                        e0 = 5, x = this.xmin, y = this.ymin;
                        break; // left
                }
                // Note: this implicitly checks for out of bounds: if P[j] or P[j+1] are
                // undefined, the conditional statement will be executed.
                if ((P[j] !== x || P[j + 1] !== y) && this.contains(i, x, y)) P.splice(j, 0, x, y), j += 2;
            }
            if (P.length > 4) for(let i = 0; i < P.length; i += 2){
                const j = (i + 2) % P.length, k = (i + 4) % P.length;
                if (P[i] === P[j] && P[j] === P[k] || P[i + 1] === P[j + 1] && P[j + 1] === P[k + 1]) P.splice(j, 2), i -= 2;
            }
            return j;
        }
        _project(x0, y0, vx, vy) {
            let t = Infinity, c, x, y;
            if (vy < 0) {
                if (y0 <= this.ymin) return null;
                if ((c = (this.ymin - y0) / vy) < t) y = this.ymin, x = x0 + (t = c) * vx;
            } else if (vy > 0) {
                if (y0 >= this.ymax) return null;
                if ((c = (this.ymax - y0) / vy) < t) y = this.ymax, x = x0 + (t = c) * vx;
            }
            if (vx > 0) {
                if (x0 >= this.xmax) return null;
                if ((c = (this.xmax - x0) / vx) < t) x = this.xmax, y = y0 + (t = c) * vy;
            } else if (vx < 0) {
                if (x0 <= this.xmin) return null;
                if ((c = (this.xmin - x0) / vx) < t) x = this.xmin, y = y0 + (t = c) * vy;
            }
            return [
                x,
                y
            ];
        }
        _edgecode(x, y) {
            return (x === this.xmin ? 1 : x === this.xmax ? 2 : 0) | (y === this.ymin ? 4 : y === this.ymax ? 8 : 0);
        }
        _regioncode(x, y) {
            return (x < this.xmin ? 1 : x > this.xmax ? 2 : 0) | (y < this.ymin ? 4 : y > this.ymax ? 8 : 0);
        }
    }
    const tau$2 = 2 * Math.PI, pow$2 = Math.pow;
    function pointX(p) {
        return p[0];
    }
    function pointY(p) {
        return p[1];
    }
    // A triangulation is collinear if all its triangles have a non-null area
    function collinear(d) {
        const { triangles: triangles, coords: coords } = d;
        for(let i = 0; i < triangles.length; i += 3){
            const a = 2 * triangles[i], b = 2 * triangles[i + 1], c = 2 * triangles[i + 2], cross = (coords[c] - coords[a]) * (coords[b + 1] - coords[a + 1]) - (coords[b] - coords[a]) * (coords[c + 1] - coords[a + 1]);
            if (cross > 1e-10) return false;
        }
        return true;
    }
    function jitter(x, y, r) {
        return [
            x + Math.sin(x + y) * r,
            y + Math.cos(x - y) * r
        ];
    }
    class Delaunay {
        static from(points, fx = pointX, fy = pointY, that) {
            return new Delaunay("length" in points ? flatArray(points, fx, fy, that) : Float64Array.from(flatIterable(points, fx, fy, that)));
        }
        constructor(points){
            this._delaunator = new Delaunator(points);
            this.inedges = new Int32Array(points.length / 2);
            this._hullIndex = new Int32Array(points.length / 2);
            this.points = this._delaunator.coords;
            this._init();
        }
        update() {
            this._delaunator.update();
            this._init();
            return this;
        }
        _init() {
            const d = this._delaunator, points = this.points;
            // check for collinear
            if (d.hull && d.hull.length > 2 && collinear(d)) {
                this.collinear = Int32Array.from({
                    length: points.length / 2
                }, (_, i)=>i).sort((i, j)=>points[2 * i] - points[2 * j] || points[2 * i + 1] - points[2 * j + 1]); // for exact neighbors
                const e = this.collinear[0], f = this.collinear[this.collinear.length - 1], bounds = [
                    points[2 * e],
                    points[2 * e + 1],
                    points[2 * f],
                    points[2 * f + 1]
                ], r = 1e-8 * Math.hypot(bounds[3] - bounds[1], bounds[2] - bounds[0]);
                for(let i = 0, n = points.length / 2; i < n; ++i){
                    const p = jitter(points[2 * i], points[2 * i + 1], r);
                    points[2 * i] = p[0];
                    points[2 * i + 1] = p[1];
                }
                this._delaunator = new Delaunator(points);
            } else delete this.collinear;
            const halfedges = this.halfedges = this._delaunator.halfedges;
            const hull = this.hull = this._delaunator.hull;
            const triangles = this.triangles = this._delaunator.triangles;
            const inedges = this.inedges.fill(-1);
            const hullIndex = this._hullIndex.fill(-1);
            // Compute an index from each point to an (arbitrary) incoming halfedge
            // Used to give the first neighbor of each point; for this reason,
            // on the hull we give priority to exterior halfedges
            for(let e = 0, n = halfedges.length; e < n; ++e){
                const p = triangles[e % 3 === 2 ? e - 2 : e + 1];
                if (halfedges[e] === -1 || inedges[p] === -1) inedges[p] = e;
            }
            for(let i = 0, n = hull.length; i < n; ++i)hullIndex[hull[i]] = i;
            // degenerate case: 1 or 2 (distinct) points
            if (hull.length <= 2 && hull.length > 0) {
                this.triangles = new Int32Array(3).fill(-1);
                this.halfedges = new Int32Array(3).fill(-1);
                this.triangles[0] = hull[0];
                inedges[hull[0]] = 1;
                if (hull.length === 2) {
                    inedges[hull[1]] = 0;
                    this.triangles[1] = hull[1];
                    this.triangles[2] = hull[1];
                }
            }
        }
        voronoi(bounds) {
            return new Voronoi(this, bounds);
        }
        *neighbors(i) {
            const { inedges: inedges, hull: hull, _hullIndex: _hullIndex, halfedges: halfedges, triangles: triangles, collinear: collinear } = this;
            // degenerate case with several collinear points
            if (collinear) {
                const l = collinear.indexOf(i);
                if (l > 0) yield collinear[l - 1];
                if (l < collinear.length - 1) yield collinear[l + 1];
                return;
            }
            const e0 = inedges[i];
            if (e0 === -1) return; // coincident point
            let e = e0, p0 = -1;
            do {
                yield p0 = triangles[e];
                e = e % 3 === 2 ? e - 2 : e + 1;
                if (triangles[e] !== i) return; // bad triangulation
                e = halfedges[e];
                if (e === -1) {
                    const p = hull[(_hullIndex[i] + 1) % hull.length];
                    if (p !== p0) yield p;
                    return;
                }
            }while (e !== e0);
        }
        find(x, y, i = 0) {
            if ((x = +x, x !== x) || (y = +y, y !== y)) return -1;
            const i0 = i;
            let c;
            while((c = this._step(i, x, y)) >= 0 && c !== i && c !== i0)i = c;
            return c;
        }
        _step(i, x, y) {
            const { inedges: inedges, hull: hull, _hullIndex: _hullIndex, halfedges: halfedges, triangles: triangles, points: points } = this;
            if (inedges[i] === -1 || !points.length) return (i + 1) % (points.length >> 1);
            let c = i;
            let dc = pow$2(x - points[i * 2], 2) + pow$2(y - points[i * 2 + 1], 2);
            const e0 = inedges[i];
            let e = e0;
            do {
                let t = triangles[e];
                const dt = pow$2(x - points[t * 2], 2) + pow$2(y - points[t * 2 + 1], 2);
                if (dt < dc) dc = dt, c = t;
                e = e % 3 === 2 ? e - 2 : e + 1;
                if (triangles[e] !== i) break; // bad triangulation
                e = halfedges[e];
                if (e === -1) {
                    e = hull[(_hullIndex[i] + 1) % hull.length];
                    if (e !== t) {
                        if (pow$2(x - points[e * 2], 2) + pow$2(y - points[e * 2 + 1], 2) < dc) return e;
                    }
                    break;
                }
            }while (e !== e0);
            return c;
        }
        render(context) {
            const buffer = context == null ? context = new Path : undefined;
            const { points: points, halfedges: halfedges, triangles: triangles } = this;
            for(let i = 0, n = halfedges.length; i < n; ++i){
                const j = halfedges[i];
                if (j < i) continue;
                const ti = triangles[i] * 2;
                const tj = triangles[j] * 2;
                context.moveTo(points[ti], points[ti + 1]);
                context.lineTo(points[tj], points[tj + 1]);
            }
            this.renderHull(context);
            return buffer && buffer.value();
        }
        renderPoints(context, r) {
            if (r === undefined && (!context || typeof context.moveTo !== "function")) r = context, context = null;
            r = r == undefined ? 2 : +r;
            const buffer = context == null ? context = new Path : undefined;
            const { points: points } = this;
            for(let i = 0, n = points.length; i < n; i += 2){
                const x = points[i], y = points[i + 1];
                context.moveTo(x + r, y);
                context.arc(x, y, r, 0, tau$2);
            }
            return buffer && buffer.value();
        }
        renderHull(context) {
            const buffer = context == null ? context = new Path : undefined;
            const { hull: hull, points: points } = this;
            const h = hull[0] * 2, n = hull.length;
            context.moveTo(points[h], points[h + 1]);
            for(let i = 1; i < n; ++i){
                const h = 2 * hull[i];
                context.lineTo(points[h], points[h + 1]);
            }
            context.closePath();
            return buffer && buffer.value();
        }
        hullPolygon() {
            const polygon = new Polygon;
            this.renderHull(polygon);
            return polygon.value();
        }
        renderTriangle(i, context) {
            const buffer = context == null ? context = new Path : undefined;
            const { points: points, triangles: triangles } = this;
            const t0 = triangles[i *= 3] * 2;
            const t1 = triangles[i + 1] * 2;
            const t2 = triangles[i + 2] * 2;
            context.moveTo(points[t0], points[t0 + 1]);
            context.lineTo(points[t1], points[t1 + 1]);
            context.lineTo(points[t2], points[t2 + 1]);
            context.closePath();
            return buffer && buffer.value();
        }
        *trianglePolygons() {
            const { triangles: triangles } = this;
            for(let i = 0, n = triangles.length / 3; i < n; ++i)yield this.trianglePolygon(i);
        }
        trianglePolygon(i) {
            const polygon = new Polygon;
            this.renderTriangle(i, polygon);
            return polygon.value();
        }
    }
    function flatArray(points, fx, fy, that) {
        const n = points.length;
        const array = new Float64Array(n * 2);
        for(let i = 0; i < n; ++i){
            const p = points[i];
            array[i * 2] = fx.call(that, p, i, points);
            array[i * 2 + 1] = fy.call(that, p, i, points);
        }
        return array;
    }
    function* flatIterable(points, fx, fy, that) {
        let i = 0;
        for (const p of points){
            yield fx.call(that, p, i, points);
            yield fy.call(that, p, i, points);
            ++i;
        }
    }
    var EOL = {}, EOF = {}, QUOTE = 34, NEWLINE = 10, RETURN = 13;
    function objectConverter(columns) {
        return new Function("d", "return {" + columns.map(function(name, i) {
            return JSON.stringify(name) + ": d[" + i + "] || \"\"";
        }).join(",") + "}");
    }
    function customConverter(columns, f) {
        var object = objectConverter(columns);
        return function(row, i) {
            return f(object(row), i, columns);
        };
    }
    // Compute unique columns in order of discovery.
    function inferColumns(rows) {
        var columnSet = Object.create(null), columns = [];
        rows.forEach(function(row) {
            for(var column in row)if (!(column in columnSet)) columns.push(columnSet[column] = column);
        });
        return columns;
    }
    function pad$1(value, width) {
        var s = value + "", length = s.length;
        return length < width ? new Array(width - length + 1).join(0) + s : s;
    }
    function formatYear$1(year) {
        return year < 0 ? "-" + pad$1(-year, 6) : year > 9999 ? "+" + pad$1(year, 6) : pad$1(year, 4);
    }
    function formatDate(date) {
        var hours = date.getUTCHours(), minutes = date.getUTCMinutes(), seconds = date.getUTCSeconds(), milliseconds = date.getUTCMilliseconds();
        return isNaN(date) ? "Invalid Date" : formatYear$1(date.getUTCFullYear()) + "-" + pad$1(date.getUTCMonth() + 1, 2) + "-" + pad$1(date.getUTCDate(), 2) + (milliseconds ? "T" + pad$1(hours, 2) + ":" + pad$1(minutes, 2) + ":" + pad$1(seconds, 2) + "." + pad$1(milliseconds, 3) + "Z" : seconds ? "T" + pad$1(hours, 2) + ":" + pad$1(minutes, 2) + ":" + pad$1(seconds, 2) + "Z" : minutes || hours ? "T" + pad$1(hours, 2) + ":" + pad$1(minutes, 2) + "Z" : "");
    }
    function dsvFormat(delimiter) {
        var reFormat = new RegExp("[\"" + delimiter + "\n\r]"), DELIMITER = delimiter.charCodeAt(0);
        function parse(text, f) {
            var convert, columns, rows = parseRows(text, function(row, i) {
                if (convert) return convert(row, i - 1);
                columns = row, convert = f ? customConverter(row, f) : objectConverter(row);
            });
            rows.columns = columns || [];
            return rows;
        }
        function parseRows(text, f) {
            var rows = [], N = text.length, I = 0, n = 0, t, eof = N <= 0, eol = false; // current token followed by EOL?
            // Strip the trailing newline.
            if (text.charCodeAt(N - 1) === NEWLINE) --N;
            if (text.charCodeAt(N - 1) === RETURN) --N;
            function token() {
                if (eof) return EOF;
                if (eol) return eol = false, EOL;
                // Unescape quotes.
                var i, j = I, c;
                if (text.charCodeAt(j) === QUOTE) {
                    while(I++ < N && text.charCodeAt(I) !== QUOTE || text.charCodeAt(++I) === QUOTE);
                    if ((i = I) >= N) eof = true;
                    else if ((c = text.charCodeAt(I++)) === NEWLINE) eol = true;
                    else if (c === RETURN) {
                        eol = true;
                        if (text.charCodeAt(I) === NEWLINE) ++I;
                    }
                    return text.slice(j + 1, i - 1).replace(/""/g, "\"");
                }
                // Find next delimiter or newline.
                while(I < N){
                    if ((c = text.charCodeAt(i = I++)) === NEWLINE) eol = true;
                    else if (c === RETURN) {
                        eol = true;
                        if (text.charCodeAt(I) === NEWLINE) ++I;
                    } else if (c !== DELIMITER) continue;
                    return text.slice(j, i);
                }
                // Return last token before EOF.
                return eof = true, text.slice(j, N);
            }
            while((t = token()) !== EOF){
                var row = [];
                while(t !== EOL && t !== EOF)row.push(t), t = token();
                if (f && (row = f(row, n++)) == null) continue;
                rows.push(row);
            }
            return rows;
        }
        function preformatBody(rows, columns) {
            return rows.map(function(row) {
                return columns.map(function(column) {
                    return formatValue(row[column]);
                }).join(delimiter);
            });
        }
        function format(rows, columns) {
            if (columns == null) columns = inferColumns(rows);
            return [
                columns.map(formatValue).join(delimiter)
            ].concat(preformatBody(rows, columns)).join("\n");
        }
        function formatBody(rows, columns) {
            if (columns == null) columns = inferColumns(rows);
            return preformatBody(rows, columns).join("\n");
        }
        function formatRows(rows) {
            return rows.map(formatRow).join("\n");
        }
        function formatRow(row) {
            return row.map(formatValue).join(delimiter);
        }
        function formatValue(value) {
            return value == null ? "" : value instanceof Date ? formatDate(value) : reFormat.test(value += "") ? "\"" + value.replace(/"/g, "\"\"") + "\"" : value;
        }
        return {
            parse: parse,
            parseRows: parseRows,
            format: format,
            formatBody: formatBody,
            formatRows: formatRows,
            formatRow: formatRow,
            formatValue: formatValue
        };
    }
    var csv$1 = dsvFormat(",");
    var csvParse = csv$1.parse;
    var csvParseRows = csv$1.parseRows;
    var csvFormat = csv$1.format;
    var csvFormatBody = csv$1.formatBody;
    var csvFormatRows = csv$1.formatRows;
    var csvFormatRow = csv$1.formatRow;
    var csvFormatValue = csv$1.formatValue;
    var tsv$1 = dsvFormat("\t");
    var tsvParse = tsv$1.parse;
    var tsvParseRows = tsv$1.parseRows;
    var tsvFormat = tsv$1.format;
    var tsvFormatBody = tsv$1.formatBody;
    var tsvFormatRows = tsv$1.formatRows;
    var tsvFormatRow = tsv$1.formatRow;
    var tsvFormatValue = tsv$1.formatValue;
    function autoType(object) {
        for(var key in object){
            var value = object[key].trim(), number, m;
            if (!value) value = null;
            else if (value === "true") value = true;
            else if (value === "false") value = false;
            else if (value === "NaN") value = NaN;
            else if (!isNaN(number = +value)) value = number;
            else if (m = value.match(/^([-+]\d{2})?\d{4}(-\d{2}(-\d{2})?)?(T\d{2}:\d{2}(:\d{2}(\.\d{3})?)?(Z|[-+]\d{2}:\d{2})?)?$/)) {
                if (fixtz && !!m[4] && !m[7]) value = value.replace(/-/g, "/").replace(/T/, " ");
                value = new Date(value);
            } else continue;
            object[key] = value;
        }
        return object;
    }
    // https://github.com/d3/d3-dsv/issues/45
    const fixtz = new Date("2019-01-01T00:00").getHours() || new Date("2019-07-01T00:00").getHours();
    function responseBlob(response) {
        if (!response.ok) throw new Error(response.status + " " + response.statusText);
        return response.blob();
    }
    function blob(input, init) {
        return fetch(input, init).then(responseBlob);
    }
    function responseArrayBuffer(response) {
        if (!response.ok) throw new Error(response.status + " " + response.statusText);
        return response.arrayBuffer();
    }
    function buffer(input, init) {
        return fetch(input, init).then(responseArrayBuffer);
    }
    function responseText(response) {
        if (!response.ok) throw new Error(response.status + " " + response.statusText);
        return response.text();
    }
    function text(input, init) {
        return fetch(input, init).then(responseText);
    }
    function dsvParse(parse) {
        return function(input, init, row) {
            if (arguments.length === 2 && typeof init === "function") row = init, init = undefined;
            return text(input, init).then(function(response) {
                return parse(response, row);
            });
        };
    }
    function dsv(delimiter, input, init, row) {
        if (arguments.length === 3 && typeof init === "function") row = init, init = undefined;
        var format = dsvFormat(delimiter);
        return text(input, init).then(function(response) {
            return format.parse(response, row);
        });
    }
    var csv = dsvParse(csvParse);
    var tsv = dsvParse(tsvParse);
    function image(input, init) {
        return new Promise(function(resolve, reject) {
            var image = new Image;
            for(var key in init)image[key] = init[key];
            image.onerror = reject;
            image.onload = function() {
                resolve(image);
            };
            image.src = input;
        });
    }
    function responseJson(response) {
        if (!response.ok) throw new Error(response.status + " " + response.statusText);
        if (response.status === 204 || response.status === 205) return;
        return response.json();
    }
    function json(input, init) {
        return fetch(input, init).then(responseJson);
    }
    function parser(type) {
        return (input, init)=>text(input, init).then((text)=>(new DOMParser).parseFromString(text, type));
    }
    var xml = parser("application/xml");
    var html = parser("text/html");
    var svg = parser("image/svg+xml");
    function center(x, y) {
        var nodes, strength = 1;
        if (x == null) x = 0;
        if (y == null) y = 0;
        function force() {
            var i, n = nodes.length, node, sx = 0, sy = 0;
            for(i = 0; i < n; ++i)node = nodes[i], sx += node.x, sy += node.y;
            for(sx = (sx / n - x) * strength, sy = (sy / n - y) * strength, i = 0; i < n; ++i)node = nodes[i], node.x -= sx, node.y -= sy;
        }
        force.initialize = function(_) {
            nodes = _;
        };
        force.x = function(_) {
            return arguments.length ? (x = +_, force) : x;
        };
        force.y = function(_) {
            return arguments.length ? (y = +_, force) : y;
        };
        force.strength = function(_) {
            return arguments.length ? (strength = +_, force) : strength;
        };
        return force;
    }
    function tree_add(d) {
        const x = +this._x.call(null, d), y = +this._y.call(null, d);
        return add(this.cover(x, y), x, y, d);
    }
    function add(tree, x, y, d) {
        if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points
        var parent, node = tree._root, leaf = {
            data: d
        }, x0 = tree._x0, y0 = tree._y0, x1 = tree._x1, y1 = tree._y1, xm, ym, xp, yp, right, bottom, i, j;
        // If the tree is empty, initialize the root as a leaf.
        if (!node) return tree._root = leaf, tree;
        // Find the existing leaf for the new point, or add it.
        while(node.length){
            if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
            else x1 = xm;
            if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
            else y1 = ym;
            if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
        }
        // Is the new point is exactly coincident with the existing point?
        xp = +tree._x.call(null, node.data);
        yp = +tree._y.call(null, node.data);
        if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;
        // Otherwise, split the leaf node until the old and new point are separated.
        do {
            parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
            if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
            else x1 = xm;
            if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
            else y1 = ym;
        }while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | xp >= xm));
        return parent[j] = node, parent[i] = leaf, tree;
    }
    function addAll(data) {
        var d, i, n = data.length, x, y, xz = new Array(n), yz = new Array(n), x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
        // Compute the points and their extent.
        for(i = 0; i < n; ++i){
            if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
            xz[i] = x;
            yz[i] = y;
            if (x < x0) x0 = x;
            if (x > x1) x1 = x;
            if (y < y0) y0 = y;
            if (y > y1) y1 = y;
        }
        // If there were no (valid) points, abort.
        if (x0 > x1 || y0 > y1) return this;
        // Expand the tree to cover the new points.
        this.cover(x0, y0).cover(x1, y1);
        // Add the new points.
        for(i = 0; i < n; ++i)add(this, xz[i], yz[i], data[i]);
        return this;
    }
    function tree_cover(x, y) {
        if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points
        var x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1;
        // If the quadtree has no extent, initialize them.
        // Integer extent are necessary so that if we later double the extent,
        // the existing quadrant boundaries don’t change due to floating point error!
        if (isNaN(x0)) {
            x1 = (x0 = Math.floor(x)) + 1;
            y1 = (y0 = Math.floor(y)) + 1;
        } else {
            var z = x1 - x0 || 1, node = this._root, parent, i;
            while(x0 > x || x >= x1 || y0 > y || y >= y1){
                i = (y < y0) << 1 | x < x0;
                parent = new Array(4), parent[i] = node, node = parent, z *= 2;
                switch(i){
                    case 0:
                        x1 = x0 + z, y1 = y0 + z;
                        break;
                    case 1:
                        x0 = x1 - z, y1 = y0 + z;
                        break;
                    case 2:
                        x1 = x0 + z, y0 = y1 - z;
                        break;
                    case 3:
                        x0 = x1 - z, y0 = y1 - z;
                        break;
                }
            }
            if (this._root && this._root.length) this._root = node;
        }
        this._x0 = x0;
        this._y0 = y0;
        this._x1 = x1;
        this._y1 = y1;
        return this;
    }
    function tree_data() {
        var data = [];
        this.visit(function(node) {
            if (!node.length) do data.push(node.data);
            while (node = node.next);
        });
        return data;
    }
    function tree_extent(_) {
        return arguments.length ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1]) : isNaN(this._x0) ? undefined : [
            [
                this._x0,
                this._y0
            ],
            [
                this._x1,
                this._y1
            ]
        ];
    }
    function Quad(node, x0, y0, x1, y1) {
        this.node = node;
        this.x0 = x0;
        this.y0 = y0;
        this.x1 = x1;
        this.y1 = y1;
    }
    function tree_find(x, y, radius) {
        var data, x0 = this._x0, y0 = this._y0, x1, y1, x2, y2, x3 = this._x1, y3 = this._y1, quads = [], node = this._root, q, i;
        if (node) quads.push(new Quad(node, x0, y0, x3, y3));
        if (radius == null) radius = Infinity;
        else {
            x0 = x - radius, y0 = y - radius;
            x3 = x + radius, y3 = y + radius;
            radius *= radius;
        }
        while(q = quads.pop()){
            // Stop searching if this quadrant can’t contain a closer node.
            if (!(node = q.node) || (x1 = q.x0) > x3 || (y1 = q.y0) > y3 || (x2 = q.x1) < x0 || (y2 = q.y1) < y0) continue;
            // Bisect the current quadrant.
            if (node.length) {
                var xm = (x1 + x2) / 2, ym = (y1 + y2) / 2;
                quads.push(new Quad(node[3], xm, ym, x2, y2), new Quad(node[2], x1, ym, xm, y2), new Quad(node[1], xm, y1, x2, ym), new Quad(node[0], x1, y1, xm, ym));
                // Visit the closest quadrant first.
                if (i = (y >= ym) << 1 | x >= xm) {
                    q = quads[quads.length - 1];
                    quads[quads.length - 1] = quads[quads.length - 1 - i];
                    quads[quads.length - 1 - i] = q;
                }
            } else {
                var dx = x - +this._x.call(null, node.data), dy = y - +this._y.call(null, node.data), d2 = dx * dx + dy * dy;
                if (d2 < radius) {
                    var d = Math.sqrt(radius = d2);
                    x0 = x - d, y0 = y - d;
                    x3 = x + d, y3 = y + d;
                    data = node.data;
                }
            }
        }
        return data;
    }
    function tree_remove(d) {
        if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points
        var parent, node = this._root, retainer, previous, next, x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1, x, y, xm, ym, right, bottom, i, j;
        // If the tree is empty, initialize the root as a leaf.
        if (!node) return this;
        // Find the leaf node for the point.
        // While descending, also retain the deepest parent with a non-removed sibling.
        if (node.length) while(true){
            if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
            else x1 = xm;
            if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
            else y1 = ym;
            if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
            if (!node.length) break;
            if (parent[i + 1 & 3] || parent[i + 2 & 3] || parent[i + 3 & 3]) retainer = parent, j = i;
        }
        // Find the point to remove.
        while(node.data !== d)if (!(previous = node, node = node.next)) return this;
        if (next = node.next) delete node.next;
        // If there are multiple coincident points, remove just the point.
        if (previous) return next ? previous.next = next : delete previous.next, this;
        // If this is the root point, remove it.
        if (!parent) return this._root = next, this;
        // Remove this leaf.
        next ? parent[i] = next : delete parent[i];
        // If the parent now contains exactly one leaf, collapse superfluous parents.
        if ((node = parent[0] || parent[1] || parent[2] || parent[3]) && node === (parent[3] || parent[2] || parent[1] || parent[0]) && !node.length) {
            if (retainer) retainer[j] = node;
            else this._root = node;
        }
        return this;
    }
    function removeAll(data) {
        for(var i = 0, n = data.length; i < n; ++i)this.remove(data[i]);
        return this;
    }
    function tree_root() {
        return this._root;
    }
    function tree_size() {
        var size = 0;
        this.visit(function(node) {
            if (!node.length) do ++size;
            while (node = node.next);
        });
        return size;
    }
    function tree_visit(callback) {
        var quads = [], q, node = this._root, child, x0, y0, x1, y1;
        if (node) quads.push(new Quad(node, this._x0, this._y0, this._x1, this._y1));
        while(q = quads.pop())if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
            var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
            if (child = node[3]) quads.push(new Quad(child, xm, ym, x1, y1));
            if (child = node[2]) quads.push(new Quad(child, x0, ym, xm, y1));
            if (child = node[1]) quads.push(new Quad(child, xm, y0, x1, ym));
            if (child = node[0]) quads.push(new Quad(child, x0, y0, xm, ym));
        }
        return this;
    }
    function tree_visitAfter(callback) {
        var quads = [], next = [], q;
        if (this._root) quads.push(new Quad(this._root, this._x0, this._y0, this._x1, this._y1));
        while(q = quads.pop()){
            var node = q.node;
            if (node.length) {
                var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
                if (child = node[0]) quads.push(new Quad(child, x0, y0, xm, ym));
                if (child = node[1]) quads.push(new Quad(child, xm, y0, x1, ym));
                if (child = node[2]) quads.push(new Quad(child, x0, ym, xm, y1));
                if (child = node[3]) quads.push(new Quad(child, xm, ym, x1, y1));
            }
            next.push(q);
        }
        while(q = next.pop())callback(q.node, q.x0, q.y0, q.x1, q.y1);
        return this;
    }
    function defaultX(d) {
        return d[0];
    }
    function tree_x(_) {
        return arguments.length ? (this._x = _, this) : this._x;
    }
    function defaultY(d) {
        return d[1];
    }
    function tree_y(_) {
        return arguments.length ? (this._y = _, this) : this._y;
    }
    function quadtree(nodes, x, y) {
        var tree = new Quadtree(x == null ? defaultX : x, y == null ? defaultY : y, NaN, NaN, NaN, NaN);
        return nodes == null ? tree : tree.addAll(nodes);
    }
    function Quadtree(x, y, x0, y0, x1, y1) {
        this._x = x;
        this._y = y;
        this._x0 = x0;
        this._y0 = y0;
        this._x1 = x1;
        this._y1 = y1;
        this._root = undefined;
    }
    function leaf_copy(leaf) {
        var copy = {
            data: leaf.data
        }, next = copy;
        while(leaf = leaf.next)next = next.next = {
            data: leaf.data
        };
        return copy;
    }
    var treeProto = quadtree.prototype = Quadtree.prototype;
    treeProto.copy = function() {
        var copy = new Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1), node = this._root, nodes, child;
        if (!node) return copy;
        if (!node.length) return copy._root = leaf_copy(node), copy;
        nodes = [
            {
                source: node,
                target: copy._root = new Array(4)
            }
        ];
        while(node = nodes.pop()){
            for(var i = 0; i < 4; ++i)if (child = node.source[i]) {
                if (child.length) nodes.push({
                    source: child,
                    target: node.target[i] = new Array(4)
                });
                else node.target[i] = leaf_copy(child);
            }
        }
        return copy;
    };
    treeProto.add = tree_add;
    treeProto.addAll = addAll;
    treeProto.cover = tree_cover;
    treeProto.data = tree_data;
    treeProto.extent = tree_extent;
    treeProto.find = tree_find;
    treeProto.remove = tree_remove;
    treeProto.removeAll = removeAll;
    treeProto.root = tree_root;
    treeProto.size = tree_size;
    treeProto.visit = tree_visit;
    treeProto.visitAfter = tree_visitAfter;
    treeProto.x = tree_x;
    treeProto.y = tree_y;
    function constant$4(x) {
        return function() {
            return x;
        };
    }
    function jiggle(random) {
        return (random() - 0.5) * 1e-6;
    }
    function x$4(d) {
        return d.x + d.vx;
    }
    function y$3(d) {
        return d.y + d.vy;
    }
    function collide(radius) {
        var nodes, radii, random, strength = 1, iterations = 1;
        if (typeof radius !== "function") radius = constant$4(radius == null ? 1 : +radius);
        function force() {
            var i, n = nodes.length, tree, node, xi, yi, ri, ri2;
            for(var k = 0; k < iterations; ++k){
                tree = quadtree(nodes, x$4, y$3).visitAfter(prepare);
                for(i = 0; i < n; ++i){
                    node = nodes[i];
                    ri = radii[node.index], ri2 = ri * ri;
                    xi = node.x + node.vx;
                    yi = node.y + node.vy;
                    tree.visit(apply);
                }
            }
            function apply(quad, x0, y0, x1, y1) {
                var data = quad.data, rj = quad.r, r = ri + rj;
                if (data) {
                    if (data.index > node.index) {
                        var x = xi - data.x - data.vx, y = yi - data.y - data.vy, l = x * x + y * y;
                        if (l < r * r) {
                            if (x === 0) x = jiggle(random), l += x * x;
                            if (y === 0) y = jiggle(random), l += y * y;
                            l = (r - (l = Math.sqrt(l))) / l * strength;
                            node.vx += (x *= l) * (r = (rj *= rj) / (ri2 + rj));
                            node.vy += (y *= l) * r;
                            data.vx -= x * (r = 1 - r);
                            data.vy -= y * r;
                        }
                    }
                    return;
                }
                return x0 > xi + r || x1 < xi - r || y0 > yi + r || y1 < yi - r;
            }
        }
        function prepare(quad) {
            if (quad.data) return quad.r = radii[quad.data.index];
            for(var i = quad.r = 0; i < 4; ++i)if (quad[i] && quad[i].r > quad.r) quad.r = quad[i].r;
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length, node;
            radii = new Array(n);
            for(i = 0; i < n; ++i)node = nodes[i], radii[node.index] = +radius(node, i, nodes);
        }
        force.initialize = function(_nodes, _random) {
            nodes = _nodes;
            random = _random;
            initialize();
        };
        force.iterations = function(_) {
            return arguments.length ? (iterations = +_, force) : iterations;
        };
        force.strength = function(_) {
            return arguments.length ? (strength = +_, force) : strength;
        };
        force.radius = function(_) {
            return arguments.length ? (radius = typeof _ === "function" ? _ : constant$4(+_), initialize(), force) : radius;
        };
        return force;
    }
    function index$3(d) {
        return d.index;
    }
    function find(nodeById, nodeId) {
        var node = nodeById.get(nodeId);
        if (!node) throw new Error("node not found: " + nodeId);
        return node;
    }
    function link$2(links) {
        var id = index$3, strength = defaultStrength, strengths, distance = constant$4(30), distances, nodes, count, bias, random, iterations = 1;
        if (links == null) links = [];
        function defaultStrength(link) {
            return 1 / Math.min(count[link.source.index], count[link.target.index]);
        }
        function force(alpha) {
            for(var k = 0, n = links.length; k < iterations; ++k)for(var i = 0, link, source, target, x, y, l, b; i < n; ++i){
                link = links[i], source = link.source, target = link.target;
                x = target.x + target.vx - source.x - source.vx || jiggle(random);
                y = target.y + target.vy - source.y - source.vy || jiggle(random);
                l = Math.sqrt(x * x + y * y);
                l = (l - distances[i]) / l * alpha * strengths[i];
                x *= l, y *= l;
                target.vx -= x * (b = bias[i]);
                target.vy -= y * b;
                source.vx += x * (b = 1 - b);
                source.vy += y * b;
            }
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length, m = links.length, nodeById = new Map(nodes.map((d, i)=>[
                    id(d, i, nodes),
                    d
                ])), link;
            for(i = 0, count = new Array(n); i < m; ++i){
                link = links[i], link.index = i;
                if (typeof link.source !== "object") link.source = find(nodeById, link.source);
                if (typeof link.target !== "object") link.target = find(nodeById, link.target);
                count[link.source.index] = (count[link.source.index] || 0) + 1;
                count[link.target.index] = (count[link.target.index] || 0) + 1;
            }
            for(i = 0, bias = new Array(m); i < m; ++i)link = links[i], bias[i] = count[link.source.index] / (count[link.source.index] + count[link.target.index]);
            strengths = new Array(m), initializeStrength();
            distances = new Array(m), initializeDistance();
        }
        function initializeStrength() {
            if (!nodes) return;
            for(var i = 0, n = links.length; i < n; ++i)strengths[i] = +strength(links[i], i, links);
        }
        function initializeDistance() {
            if (!nodes) return;
            for(var i = 0, n = links.length; i < n; ++i)distances[i] = +distance(links[i], i, links);
        }
        force.initialize = function(_nodes, _random) {
            nodes = _nodes;
            random = _random;
            initialize();
        };
        force.links = function(_) {
            return arguments.length ? (links = _, initialize(), force) : links;
        };
        force.id = function(_) {
            return arguments.length ? (id = _, force) : id;
        };
        force.iterations = function(_) {
            return arguments.length ? (iterations = +_, force) : iterations;
        };
        force.strength = function(_) {
            return arguments.length ? (strength = typeof _ === "function" ? _ : constant$4(+_), initializeStrength(), force) : strength;
        };
        force.distance = function(_) {
            return arguments.length ? (distance = typeof _ === "function" ? _ : constant$4(+_), initializeDistance(), force) : distance;
        };
        return force;
    }
    // https://en.wikipedia.org/wiki/Linear_congruential_generator#Parameters_in_common_use
    const a$2 = 1664525;
    const c$4 = 1013904223;
    const m$1 = 4294967296; // 2^32
    function lcg$2() {
        let s = 1;
        return ()=>(s = (a$2 * s + c$4) % m$1) / m$1;
    }
    function x$3(d) {
        return d.x;
    }
    function y$2(d) {
        return d.y;
    }
    var initialRadius = 10, initialAngle = Math.PI * (3 - Math.sqrt(5));
    function simulation(nodes) {
        var simulation, alpha = 1, alphaMin = 0.001, alphaDecay = 1 - Math.pow(alphaMin, 1 / 300), alphaTarget = 0, velocityDecay = 0.6, forces = new Map(), stepper = timer(step), event = dispatch("tick", "end"), random = lcg$2();
        if (nodes == null) nodes = [];
        function step() {
            tick();
            event.call("tick", simulation);
            if (alpha < alphaMin) {
                stepper.stop();
                event.call("end", simulation);
            }
        }
        function tick(iterations) {
            var i, n = nodes.length, node;
            if (iterations === undefined) iterations = 1;
            for(var k = 0; k < iterations; ++k){
                alpha += (alphaTarget - alpha) * alphaDecay;
                forces.forEach(function(force) {
                    force(alpha);
                });
                for(i = 0; i < n; ++i){
                    node = nodes[i];
                    if (node.fx == null) node.x += node.vx *= velocityDecay;
                    else node.x = node.fx, node.vx = 0;
                    if (node.fy == null) node.y += node.vy *= velocityDecay;
                    else node.y = node.fy, node.vy = 0;
                }
            }
            return simulation;
        }
        function initializeNodes() {
            for(var i = 0, n = nodes.length, node; i < n; ++i){
                node = nodes[i], node.index = i;
                if (node.fx != null) node.x = node.fx;
                if (node.fy != null) node.y = node.fy;
                if (isNaN(node.x) || isNaN(node.y)) {
                    var radius = initialRadius * Math.sqrt(0.5 + i), angle = i * initialAngle;
                    node.x = radius * Math.cos(angle);
                    node.y = radius * Math.sin(angle);
                }
                if (isNaN(node.vx) || isNaN(node.vy)) node.vx = node.vy = 0;
            }
        }
        function initializeForce(force) {
            if (force.initialize) force.initialize(nodes, random);
            return force;
        }
        initializeNodes();
        return simulation = {
            tick: tick,
            restart: function() {
                return stepper.restart(step), simulation;
            },
            stop: function() {
                return stepper.stop(), simulation;
            },
            nodes: function(_) {
                return arguments.length ? (nodes = _, initializeNodes(), forces.forEach(initializeForce), simulation) : nodes;
            },
            alpha: function(_) {
                return arguments.length ? (alpha = +_, simulation) : alpha;
            },
            alphaMin: function(_) {
                return arguments.length ? (alphaMin = +_, simulation) : alphaMin;
            },
            alphaDecay: function(_) {
                return arguments.length ? (alphaDecay = +_, simulation) : +alphaDecay;
            },
            alphaTarget: function(_) {
                return arguments.length ? (alphaTarget = +_, simulation) : alphaTarget;
            },
            velocityDecay: function(_) {
                return arguments.length ? (velocityDecay = 1 - _, simulation) : 1 - velocityDecay;
            },
            randomSource: function(_) {
                return arguments.length ? (random = _, forces.forEach(initializeForce), simulation) : random;
            },
            force: function(name, _) {
                return arguments.length > 1 ? (_ == null ? forces.delete(name) : forces.set(name, initializeForce(_)), simulation) : forces.get(name);
            },
            find: function(x, y, radius) {
                var i = 0, n = nodes.length, dx, dy, d2, node, closest;
                if (radius == null) radius = Infinity;
                else radius *= radius;
                for(i = 0; i < n; ++i){
                    node = nodes[i];
                    dx = x - node.x;
                    dy = y - node.y;
                    d2 = dx * dx + dy * dy;
                    if (d2 < radius) closest = node, radius = d2;
                }
                return closest;
            },
            on: function(name, _) {
                return arguments.length > 1 ? (event.on(name, _), simulation) : event.on(name);
            }
        };
    }
    function manyBody() {
        var nodes, node, random, alpha, strength = constant$4(-30), strengths, distanceMin2 = 1, distanceMax2 = Infinity, theta2 = 0.81;
        function force(_) {
            var i, n = nodes.length, tree = quadtree(nodes, x$3, y$2).visitAfter(accumulate);
            for(alpha = _, i = 0; i < n; ++i)node = nodes[i], tree.visit(apply);
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length, node;
            strengths = new Array(n);
            for(i = 0; i < n; ++i)node = nodes[i], strengths[node.index] = +strength(node, i, nodes);
        }
        function accumulate(quad) {
            var strength = 0, q, c, weight = 0, x, y, i;
            // For internal nodes, accumulate forces from child quadrants.
            if (quad.length) {
                for(x = y = i = 0; i < 4; ++i)if ((q = quad[i]) && (c = Math.abs(q.value))) strength += q.value, weight += c, x += c * q.x, y += c * q.y;
                quad.x = x / weight;
                quad.y = y / weight;
            } else {
                q = quad;
                q.x = q.data.x;
                q.y = q.data.y;
                do strength += strengths[q.data.index];
                while (q = q.next);
            }
            quad.value = strength;
        }
        function apply(quad, x1, _, x2) {
            if (!quad.value) return true;
            var x = quad.x - node.x, y = quad.y - node.y, w = x2 - x1, l = x * x + y * y;
            // Apply the Barnes-Hut approximation if possible.
            // Limit forces for very close nodes; randomize direction if coincident.
            if (w * w / theta2 < l) {
                if (l < distanceMax2) {
                    if (x === 0) x = jiggle(random), l += x * x;
                    if (y === 0) y = jiggle(random), l += y * y;
                    if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
                    node.vx += x * quad.value * alpha / l;
                    node.vy += y * quad.value * alpha / l;
                }
                return true;
            } else if (quad.length || l >= distanceMax2) return;
            // Limit forces for very close nodes; randomize direction if coincident.
            if (quad.data !== node || quad.next) {
                if (x === 0) x = jiggle(random), l += x * x;
                if (y === 0) y = jiggle(random), l += y * y;
                if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
            }
            do if (quad.data !== node) {
                w = strengths[quad.data.index] * alpha / l;
                node.vx += x * w;
                node.vy += y * w;
            }
            while (quad = quad.next);
        }
        force.initialize = function(_nodes, _random) {
            nodes = _nodes;
            random = _random;
            initialize();
        };
        force.strength = function(_) {
            return arguments.length ? (strength = typeof _ === "function" ? _ : constant$4(+_), initialize(), force) : strength;
        };
        force.distanceMin = function(_) {
            return arguments.length ? (distanceMin2 = _ * _, force) : Math.sqrt(distanceMin2);
        };
        force.distanceMax = function(_) {
            return arguments.length ? (distanceMax2 = _ * _, force) : Math.sqrt(distanceMax2);
        };
        force.theta = function(_) {
            return arguments.length ? (theta2 = _ * _, force) : Math.sqrt(theta2);
        };
        return force;
    }
    function radial$1(radius, x, y) {
        var nodes, strength = constant$4(0.1), strengths, radiuses;
        if (typeof radius !== "function") radius = constant$4(+radius);
        if (x == null) x = 0;
        if (y == null) y = 0;
        function force(alpha) {
            for(var i = 0, n = nodes.length; i < n; ++i){
                var node = nodes[i], dx = node.x - x || 1e-6, dy = node.y - y || 1e-6, r = Math.sqrt(dx * dx + dy * dy), k = (radiuses[i] - r) * strengths[i] * alpha / r;
                node.vx += dx * k;
                node.vy += dy * k;
            }
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length;
            strengths = new Array(n);
            radiuses = new Array(n);
            for(i = 0; i < n; ++i){
                radiuses[i] = +radius(nodes[i], i, nodes);
                strengths[i] = isNaN(radiuses[i]) ? 0 : +strength(nodes[i], i, nodes);
            }
        }
        force.initialize = function(_) {
            nodes = _, initialize();
        };
        force.strength = function(_) {
            return arguments.length ? (strength = typeof _ === "function" ? _ : constant$4(+_), initialize(), force) : strength;
        };
        force.radius = function(_) {
            return arguments.length ? (radius = typeof _ === "function" ? _ : constant$4(+_), initialize(), force) : radius;
        };
        force.x = function(_) {
            return arguments.length ? (x = +_, force) : x;
        };
        force.y = function(_) {
            return arguments.length ? (y = +_, force) : y;
        };
        return force;
    }
    function x$2(x) {
        var strength = constant$4(0.1), nodes, strengths, xz;
        if (typeof x !== "function") x = constant$4(x == null ? 0 : +x);
        function force(alpha) {
            for(var i = 0, n = nodes.length, node; i < n; ++i)node = nodes[i], node.vx += (xz[i] - node.x) * strengths[i] * alpha;
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length;
            strengths = new Array(n);
            xz = new Array(n);
            for(i = 0; i < n; ++i)strengths[i] = isNaN(xz[i] = +x(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
        }
        force.initialize = function(_) {
            nodes = _;
            initialize();
        };
        force.strength = function(_) {
            return arguments.length ? (strength = typeof _ === "function" ? _ : constant$4(+_), initialize(), force) : strength;
        };
        force.x = function(_) {
            return arguments.length ? (x = typeof _ === "function" ? _ : constant$4(+_), initialize(), force) : x;
        };
        return force;
    }
    function y$1(y) {
        var strength = constant$4(0.1), nodes, strengths, yz;
        if (typeof y !== "function") y = constant$4(y == null ? 0 : +y);
        function force(alpha) {
            for(var i = 0, n = nodes.length, node; i < n; ++i)node = nodes[i], node.vy += (yz[i] - node.y) * strengths[i] * alpha;
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length;
            strengths = new Array(n);
            yz = new Array(n);
            for(i = 0; i < n; ++i)strengths[i] = isNaN(yz[i] = +y(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
        }
        force.initialize = function(_) {
            nodes = _;
            initialize();
        };
        force.strength = function(_) {
            return arguments.length ? (strength = typeof _ === "function" ? _ : constant$4(+_), initialize(), force) : strength;
        };
        force.y = function(_) {
            return arguments.length ? (y = typeof _ === "function" ? _ : constant$4(+_), initialize(), force) : y;
        };
        return force;
    }
    function formatDecimal(x) {
        return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
    }
    // Computes the decimal coefficient and exponent of the specified number x with
    // significant digits p, where x is positive and p is in [1, 21] or undefined.
    // For example, formatDecimalParts(1.23) returns ["123", 0].
    function formatDecimalParts(x, p) {
        if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
        var i, coefficient = x.slice(0, i);
        // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
        // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
        return [
            coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
            +x.slice(i + 1)
        ];
    }
    function exponent(x) {
        return x = formatDecimalParts(Math.abs(x)), x ? x[1] : NaN;
    }
    function formatGroup(grouping, thousands) {
        return function(value, width) {
            var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
            while(i > 0 && g > 0){
                if (length + g + 1 > width) g = Math.max(1, width - length);
                t.push(value.substring(i -= g, i + g));
                if ((length += g + 1) > width) break;
                g = grouping[j = (j + 1) % grouping.length];
            }
            return t.reverse().join(thousands);
        };
    }
    function formatNumerals(numerals) {
        return function(value) {
            return value.replace(/[0-9]/g, function(i) {
                return numerals[+i];
            });
        };
    }
    // [[fill]align][sign][symbol][0][width][,][.precision][~][type]
    var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
    function formatSpecifier(specifier) {
        if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
        var match;
        return new FormatSpecifier({
            fill: match[1],
            align: match[2],
            sign: match[3],
            symbol: match[4],
            zero: match[5],
            width: match[6],
            comma: match[7],
            precision: match[8] && match[8].slice(1),
            trim: match[9],
            type: match[10]
        });
    }
    formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof
    function FormatSpecifier(specifier) {
        this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
        this.align = specifier.align === undefined ? ">" : specifier.align + "";
        this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
        this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
        this.zero = !!specifier.zero;
        this.width = specifier.width === undefined ? undefined : +specifier.width;
        this.comma = !!specifier.comma;
        this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
        this.trim = !!specifier.trim;
        this.type = specifier.type === undefined ? "" : specifier.type + "";
    }
    FormatSpecifier.prototype.toString = function() {
        return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
    };
    // Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
    function formatTrim(s) {
        out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
            case ".":
                i0 = i1 = i;
                break;
            case "0":
                if (i0 === 0) i0 = i;
                i1 = i;
                break;
            default:
                if (!+s[i]) break out;
                if (i0 > 0) i0 = 0;
                break;
        }
        return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
    }
    var prefixExponent;
    function formatPrefixAuto(x, p) {
        var d = formatDecimalParts(x, p);
        if (!d) return x + "";
        var coefficient = d[0], exponent = d[1], i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
        return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + formatDecimalParts(x, Math.max(0, p + i - 1))[0]; // less than 1y!
    }
    function formatRounded(x, p) {
        var d = formatDecimalParts(x, p);
        if (!d) return x + "";
        var coefficient = d[0], exponent = d[1];
        return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
    }
    var formatTypes = {
        "%": (x, p)=>(x * 100).toFixed(p),
        "b": (x)=>Math.round(x).toString(2),
        "c": (x)=>x + "",
        "d": formatDecimal,
        "e": (x, p)=>x.toExponential(p),
        "f": (x, p)=>x.toFixed(p),
        "g": (x, p)=>x.toPrecision(p),
        "o": (x)=>Math.round(x).toString(8),
        "p": (x, p)=>formatRounded(x * 100, p),
        "r": formatRounded,
        "s": formatPrefixAuto,
        "X": (x)=>Math.round(x).toString(16).toUpperCase(),
        "x": (x)=>Math.round(x).toString(16)
    };
    function identity$6(x) {
        return x;
    }
    var map = Array.prototype.map, prefixes = [
        "y",
        "z",
        "a",
        "f",
        "p",
        "n",
        "\xB5",
        "m",
        "",
        "k",
        "M",
        "G",
        "T",
        "P",
        "E",
        "Z",
        "Y"
    ];
    function formatLocale$1(locale) {
        var group = locale.grouping === undefined || locale.thousands === undefined ? identity$6 : formatGroup(map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? identity$6 : formatNumerals(map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
        function newFormat(specifier) {
            specifier = formatSpecifier(specifier);
            var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
            // The "n" type is an alias for ",g".
            if (type === "n") comma = true, type = "g";
            else if (!formatTypes[type]) precision === undefined && (precision = 12), trim = true, type = "g";
            // If zero fill is specified, padding goes after sign and before digits.
            if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
            // Compute the prefix and suffix.
            // For SI-prefix, the suffix is lazily computed.
            var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
            // What format function should we use?
            // Is this an integer type?
            // Can this type generate exponential notation?
            var formatType = formatTypes[type], maybeSuffix = /[defgprs%]/.test(type);
            // Set the default precision if not specified,
            // or clamp the specified precision to the supported range.
            // For significant precision, it must be in [1, 21].
            // For fixed precision, it must be in [0, 20].
            precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
            function format(value) {
                var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
                if (type === "c") {
                    valueSuffix = formatType(value) + valueSuffix;
                    value = "";
                } else {
                    value = +value;
                    // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                    var valueNegative = value < 0 || 1 / value < 0;
                    // Perform the initial formatting.
                    value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                    // Trim insignificant zeros.
                    if (trim) value = formatTrim(value);
                    // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                    if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                    // Compute the prefix and suffix.
                    valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                    valueSuffix = (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                    // Break the formatted value into the integer “value” part that can be
                    // grouped, and fractional or exponential “suffix” part that is not.
                    if (maybeSuffix) {
                        i = -1, n = value.length;
                        while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                            valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                            value = value.slice(0, i);
                            break;
                        }
                    }
                }
                // If the fill character is not "0", grouping is applied before padding.
                if (comma && !zero) value = group(value, Infinity);
                // Compute the padding.
                var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
                // If the fill character is "0", grouping is applied after padding.
                if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
                // Reconstruct the final output based on the desired alignment.
                switch(align){
                    case "<":
                        value = valuePrefix + value + valueSuffix + padding;
                        break;
                    case "=":
                        value = valuePrefix + padding + value + valueSuffix;
                        break;
                    case "^":
                        value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                        break;
                    default:
                        value = padding + valuePrefix + value + valueSuffix;
                        break;
                }
                return numerals(value);
            }
            format.toString = function() {
                return specifier + "";
            };
            return format;
        }
        function formatPrefix(specifier, value) {
            var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3, k = Math.pow(10, -e), prefix = prefixes[8 + e / 3];
            return function(value) {
                return f(k * value) + prefix;
            };
        }
        return {
            format: newFormat,
            formatPrefix: formatPrefix
        };
    }
    var locale$1;
    exports1.format = void 0;
    exports1.formatPrefix = void 0;
    defaultLocale$1({
        thousands: ",",
        grouping: [
            3
        ],
        currency: [
            "$",
            ""
        ]
    });
    function defaultLocale$1(definition) {
        locale$1 = formatLocale$1(definition);
        exports1.format = locale$1.format;
        exports1.formatPrefix = locale$1.formatPrefix;
        return locale$1;
    }
    function precisionFixed(step) {
        return Math.max(0, -exponent(Math.abs(step)));
    }
    function precisionPrefix(step, value) {
        return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
    }
    function precisionRound(step, max) {
        step = Math.abs(step), max = Math.abs(max) - step;
        return Math.max(0, exponent(max) - exponent(step)) + 1;
    }
    var epsilon$1 = 1e-6;
    var epsilon2 = 1e-12;
    var pi$1 = Math.PI;
    var halfPi$1 = pi$1 / 2;
    var quarterPi = pi$1 / 4;
    var tau$1 = pi$1 * 2;
    var degrees = 180 / pi$1;
    var radians = pi$1 / 180;
    var abs$1 = Math.abs;
    var atan = Math.atan;
    var atan2$1 = Math.atan2;
    var cos$1 = Math.cos;
    var ceil = Math.ceil;
    var exp = Math.exp;
    var hypot = Math.hypot;
    var log$1 = Math.log;
    var pow$1 = Math.pow;
    var sin$1 = Math.sin;
    var sign$1 = Math.sign || function(x) {
        return x > 0 ? 1 : x < 0 ? -1 : 0;
    };
    var sqrt$2 = Math.sqrt;
    var tan = Math.tan;
    function acos$1(x) {
        return x > 1 ? 0 : x < -1 ? pi$1 : Math.acos(x);
    }
    function asin$1(x) {
        return x > 1 ? halfPi$1 : x < -1 ? -halfPi$1 : Math.asin(x);
    }
    function haversin(x) {
        return (x = sin$1(x / 2)) * x;
    }
    function noop$1() {}
    function streamGeometry(geometry, stream) {
        if (geometry && streamGeometryType.hasOwnProperty(geometry.type)) streamGeometryType[geometry.type](geometry, stream);
    }
    var streamObjectType = {
        Feature: function(object, stream) {
            streamGeometry(object.geometry, stream);
        },
        FeatureCollection: function(object, stream) {
            var features = object.features, i = -1, n = features.length;
            while(++i < n)streamGeometry(features[i].geometry, stream);
        }
    };
    var streamGeometryType = {
        Sphere: function(object, stream) {
            stream.sphere();
        },
        Point: function(object, stream) {
            object = object.coordinates;
            stream.point(object[0], object[1], object[2]);
        },
        MultiPoint: function(object, stream) {
            var coordinates = object.coordinates, i = -1, n = coordinates.length;
            while(++i < n)object = coordinates[i], stream.point(object[0], object[1], object[2]);
        },
        LineString: function(object, stream) {
            streamLine(object.coordinates, stream, 0);
        },
        MultiLineString: function(object, stream) {
            var coordinates = object.coordinates, i = -1, n = coordinates.length;
            while(++i < n)streamLine(coordinates[i], stream, 0);
        },
        Polygon: function(object, stream) {
            streamPolygon(object.coordinates, stream);
        },
        MultiPolygon: function(object, stream) {
            var coordinates = object.coordinates, i = -1, n = coordinates.length;
            while(++i < n)streamPolygon(coordinates[i], stream);
        },
        GeometryCollection: function(object, stream) {
            var geometries = object.geometries, i = -1, n = geometries.length;
            while(++i < n)streamGeometry(geometries[i], stream);
        }
    };
    function streamLine(coordinates, stream, closed) {
        var i = -1, n = coordinates.length - closed, coordinate;
        stream.lineStart();
        while(++i < n)coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
        stream.lineEnd();
    }
    function streamPolygon(coordinates, stream) {
        var i = -1, n = coordinates.length;
        stream.polygonStart();
        while(++i < n)streamLine(coordinates[i], stream, 1);
        stream.polygonEnd();
    }
    function geoStream(object, stream) {
        if (object && streamObjectType.hasOwnProperty(object.type)) streamObjectType[object.type](object, stream);
        else streamGeometry(object, stream);
    }
    var areaRingSum$1 = new Adder();
    // hello?
    var areaSum$1 = new Adder(), lambda00$2, phi00$2, lambda0$2, cosPhi0$1, sinPhi0$1;
    var areaStream$1 = {
        point: noop$1,
        lineStart: noop$1,
        lineEnd: noop$1,
        polygonStart: function() {
            areaRingSum$1 = new Adder();
            areaStream$1.lineStart = areaRingStart$1;
            areaStream$1.lineEnd = areaRingEnd$1;
        },
        polygonEnd: function() {
            var areaRing = +areaRingSum$1;
            areaSum$1.add(areaRing < 0 ? tau$1 + areaRing : areaRing);
            this.lineStart = this.lineEnd = this.point = noop$1;
        },
        sphere: function() {
            areaSum$1.add(tau$1);
        }
    };
    function areaRingStart$1() {
        areaStream$1.point = areaPointFirst$1;
    }
    function areaRingEnd$1() {
        areaPoint$1(lambda00$2, phi00$2);
    }
    function areaPointFirst$1(lambda, phi) {
        areaStream$1.point = areaPoint$1;
        lambda00$2 = lambda, phi00$2 = phi;
        lambda *= radians, phi *= radians;
        lambda0$2 = lambda, cosPhi0$1 = cos$1(phi = phi / 2 + quarterPi), sinPhi0$1 = sin$1(phi);
    }
    function areaPoint$1(lambda, phi) {
        lambda *= radians, phi *= radians;
        phi = phi / 2 + quarterPi; // half the angular distance from south pole
        // Spherical excess E for a spherical triangle with vertices: south pole,
        // previous point, current point.  Uses a formula derived from Cagnoli’s
        // theorem.  See Todhunter, Spherical Trig. (1871), Sec. 103, Eq. (2).
        var dLambda = lambda - lambda0$2, sdLambda = dLambda >= 0 ? 1 : -1, adLambda = sdLambda * dLambda, cosPhi = cos$1(phi), sinPhi = sin$1(phi), k = sinPhi0$1 * sinPhi, u = cosPhi0$1 * cosPhi + k * cos$1(adLambda), v = k * sdLambda * sin$1(adLambda);
        areaRingSum$1.add(atan2$1(v, u));
        // Advance the previous points.
        lambda0$2 = lambda, cosPhi0$1 = cosPhi, sinPhi0$1 = sinPhi;
    }
    function area$2(object) {
        areaSum$1 = new Adder();
        geoStream(object, areaStream$1);
        return areaSum$1 * 2;
    }
    function spherical(cartesian) {
        return [
            atan2$1(cartesian[1], cartesian[0]),
            asin$1(cartesian[2])
        ];
    }
    function cartesian(spherical) {
        var lambda = spherical[0], phi = spherical[1], cosPhi = cos$1(phi);
        return [
            cosPhi * cos$1(lambda),
            cosPhi * sin$1(lambda),
            sin$1(phi)
        ];
    }
    function cartesianDot(a, b) {
        return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
    }
    function cartesianCross(a, b) {
        return [
            a[1] * b[2] - a[2] * b[1],
            a[2] * b[0] - a[0] * b[2],
            a[0] * b[1] - a[1] * b[0]
        ];
    }
    // TODO return a
    function cartesianAddInPlace(a, b) {
        a[0] += b[0], a[1] += b[1], a[2] += b[2];
    }
    function cartesianScale(vector, k) {
        return [
            vector[0] * k,
            vector[1] * k,
            vector[2] * k
        ];
    }
    // TODO return d
    function cartesianNormalizeInPlace(d) {
        var l = sqrt$2(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
        d[0] /= l, d[1] /= l, d[2] /= l;
    }
    var lambda0$1, phi0, lambda1, phi1, lambda2, lambda00$1, phi00$1, p0, deltaSum, ranges, range;
    var boundsStream$2 = {
        point: boundsPoint$1,
        lineStart: boundsLineStart,
        lineEnd: boundsLineEnd,
        polygonStart: function() {
            boundsStream$2.point = boundsRingPoint;
            boundsStream$2.lineStart = boundsRingStart;
            boundsStream$2.lineEnd = boundsRingEnd;
            deltaSum = new Adder();
            areaStream$1.polygonStart();
        },
        polygonEnd: function() {
            areaStream$1.polygonEnd();
            boundsStream$2.point = boundsPoint$1;
            boundsStream$2.lineStart = boundsLineStart;
            boundsStream$2.lineEnd = boundsLineEnd;
            if (areaRingSum$1 < 0) lambda0$1 = -(lambda1 = 180), phi0 = -(phi1 = 90);
            else if (deltaSum > epsilon$1) phi1 = 90;
            else if (deltaSum < -epsilon$1) phi0 = -90;
            range[0] = lambda0$1, range[1] = lambda1;
        },
        sphere: function() {
            lambda0$1 = -(lambda1 = 180), phi0 = -(phi1 = 90);
        }
    };
    function boundsPoint$1(lambda, phi) {
        ranges.push(range = [
            lambda0$1 = lambda,
            lambda1 = lambda
        ]);
        if (phi < phi0) phi0 = phi;
        if (phi > phi1) phi1 = phi;
    }
    function linePoint(lambda, phi) {
        var p = cartesian([
            lambda * radians,
            phi * radians
        ]);
        if (p0) {
            var normal = cartesianCross(p0, p), equatorial = [
                normal[1],
                -normal[0],
                0
            ], inflection = cartesianCross(equatorial, normal);
            cartesianNormalizeInPlace(inflection);
            inflection = spherical(inflection);
            var delta = lambda - lambda2, sign = delta > 0 ? 1 : -1, lambdai = inflection[0] * degrees * sign, phii, antimeridian = abs$1(delta) > 180;
            if (antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
                phii = inflection[1] * degrees;
                if (phii > phi1) phi1 = phii;
            } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
                phii = -inflection[1] * degrees;
                if (phii < phi0) phi0 = phii;
            } else {
                if (phi < phi0) phi0 = phi;
                if (phi > phi1) phi1 = phi;
            }
            if (antimeridian) {
                if (lambda < lambda2) {
                    if (angle(lambda0$1, lambda) > angle(lambda0$1, lambda1)) lambda1 = lambda;
                } else if (angle(lambda, lambda1) > angle(lambda0$1, lambda1)) lambda0$1 = lambda;
            } else if (lambda1 >= lambda0$1) {
                if (lambda < lambda0$1) lambda0$1 = lambda;
                if (lambda > lambda1) lambda1 = lambda;
            } else {
                if (lambda > lambda2) {
                    if (angle(lambda0$1, lambda) > angle(lambda0$1, lambda1)) lambda1 = lambda;
                } else if (angle(lambda, lambda1) > angle(lambda0$1, lambda1)) lambda0$1 = lambda;
            }
        } else ranges.push(range = [
            lambda0$1 = lambda,
            lambda1 = lambda
        ]);
        if (phi < phi0) phi0 = phi;
        if (phi > phi1) phi1 = phi;
        p0 = p, lambda2 = lambda;
    }
    function boundsLineStart() {
        boundsStream$2.point = linePoint;
    }
    function boundsLineEnd() {
        range[0] = lambda0$1, range[1] = lambda1;
        boundsStream$2.point = boundsPoint$1;
        p0 = null;
    }
    function boundsRingPoint(lambda, phi) {
        if (p0) {
            var delta = lambda - lambda2;
            deltaSum.add(abs$1(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
        } else lambda00$1 = lambda, phi00$1 = phi;
        areaStream$1.point(lambda, phi);
        linePoint(lambda, phi);
    }
    function boundsRingStart() {
        areaStream$1.lineStart();
    }
    function boundsRingEnd() {
        boundsRingPoint(lambda00$1, phi00$1);
        areaStream$1.lineEnd();
        if (abs$1(deltaSum) > epsilon$1) lambda0$1 = -(lambda1 = 180);
        range[0] = lambda0$1, range[1] = lambda1;
        p0 = null;
    }
    // Finds the left-right distance between two longitudes.
    // This is almost the same as (lambda1 - lambda0 + 360°) % 360°, except that we want
    // the distance between ±180° to be 360°.
    function angle(lambda0, lambda1) {
        return (lambda1 -= lambda0) < 0 ? lambda1 + 360 : lambda1;
    }
    function rangeCompare(a, b) {
        return a[0] - b[0];
    }
    function rangeContains(range, x) {
        return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
    }
    function bounds(feature) {
        var i, n, a, b, merged, deltaMax, delta;
        phi1 = lambda1 = -(lambda0$1 = phi0 = Infinity);
        ranges = [];
        geoStream(feature, boundsStream$2);
        // First, sort ranges by their minimum longitudes.
        if (n = ranges.length) {
            ranges.sort(rangeCompare);
            // Then, merge any ranges that overlap.
            for(i = 1, a = ranges[0], merged = [
                a
            ]; i < n; ++i){
                b = ranges[i];
                if (rangeContains(a, b[0]) || rangeContains(a, b[1])) {
                    if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
                    if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
                } else merged.push(a = b);
            }
            // Finally, find the largest gap between the merged ranges.
            // The final bounding box will be the inverse of this gap.
            for(deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i){
                b = merged[i];
                if ((delta = angle(a[1], b[0])) > deltaMax) deltaMax = delta, lambda0$1 = b[0], lambda1 = a[1];
            }
        }
        ranges = range = null;
        return lambda0$1 === Infinity || phi0 === Infinity ? [
            [
                NaN,
                NaN
            ],
            [
                NaN,
                NaN
            ]
        ] : [
            [
                lambda0$1,
                phi0
            ],
            [
                lambda1,
                phi1
            ]
        ];
    }
    var W0, W1, X0$1, Y0$1, Z0$1, X1$1, Y1$1, Z1$1, X2$1, Y2$1, Z2$1, lambda00, phi00, x0$4, y0$4, z0; // previous point
    var centroidStream$1 = {
        sphere: noop$1,
        point: centroidPoint$1,
        lineStart: centroidLineStart$1,
        lineEnd: centroidLineEnd$1,
        polygonStart: function() {
            centroidStream$1.lineStart = centroidRingStart$1;
            centroidStream$1.lineEnd = centroidRingEnd$1;
        },
        polygonEnd: function() {
            centroidStream$1.lineStart = centroidLineStart$1;
            centroidStream$1.lineEnd = centroidLineEnd$1;
        }
    };
    // Arithmetic mean of Cartesian vectors.
    function centroidPoint$1(lambda, phi) {
        lambda *= radians, phi *= radians;
        var cosPhi = cos$1(phi);
        centroidPointCartesian(cosPhi * cos$1(lambda), cosPhi * sin$1(lambda), sin$1(phi));
    }
    function centroidPointCartesian(x, y, z) {
        ++W0;
        X0$1 += (x - X0$1) / W0;
        Y0$1 += (y - Y0$1) / W0;
        Z0$1 += (z - Z0$1) / W0;
    }
    function centroidLineStart$1() {
        centroidStream$1.point = centroidLinePointFirst;
    }
    function centroidLinePointFirst(lambda, phi) {
        lambda *= radians, phi *= radians;
        var cosPhi = cos$1(phi);
        x0$4 = cosPhi * cos$1(lambda);
        y0$4 = cosPhi * sin$1(lambda);
        z0 = sin$1(phi);
        centroidStream$1.point = centroidLinePoint;
        centroidPointCartesian(x0$4, y0$4, z0);
    }
    function centroidLinePoint(lambda, phi) {
        lambda *= radians, phi *= radians;
        var cosPhi = cos$1(phi), x = cosPhi * cos$1(lambda), y = cosPhi * sin$1(lambda), z = sin$1(phi), w = atan2$1(sqrt$2((w = y0$4 * z - z0 * y) * w + (w = z0 * x - x0$4 * z) * w + (w = x0$4 * y - y0$4 * x) * w), x0$4 * x + y0$4 * y + z0 * z);
        W1 += w;
        X1$1 += w * (x0$4 + (x0$4 = x));
        Y1$1 += w * (y0$4 + (y0$4 = y));
        Z1$1 += w * (z0 + (z0 = z));
        centroidPointCartesian(x0$4, y0$4, z0);
    }
    function centroidLineEnd$1() {
        centroidStream$1.point = centroidPoint$1;
    }
    // See J. E. Brock, The Inertia Tensor for a Spherical Triangle,
    // J. Applied Mechanics 42, 239 (1975).
    function centroidRingStart$1() {
        centroidStream$1.point = centroidRingPointFirst;
    }
    function centroidRingEnd$1() {
        centroidRingPoint(lambda00, phi00);
        centroidStream$1.point = centroidPoint$1;
    }
    function centroidRingPointFirst(lambda, phi) {
        lambda00 = lambda, phi00 = phi;
        lambda *= radians, phi *= radians;
        centroidStream$1.point = centroidRingPoint;
        var cosPhi = cos$1(phi);
        x0$4 = cosPhi * cos$1(lambda);
        y0$4 = cosPhi * sin$1(lambda);
        z0 = sin$1(phi);
        centroidPointCartesian(x0$4, y0$4, z0);
    }
    function centroidRingPoint(lambda, phi) {
        lambda *= radians, phi *= radians;
        var cosPhi = cos$1(phi), x = cosPhi * cos$1(lambda), y = cosPhi * sin$1(lambda), z = sin$1(phi), cx = y0$4 * z - z0 * y, cy = z0 * x - x0$4 * z, cz = x0$4 * y - y0$4 * x, m = hypot(cx, cy, cz), w = asin$1(m), v = m && -w / m; // area weight multiplier
        X2$1.add(v * cx);
        Y2$1.add(v * cy);
        Z2$1.add(v * cz);
        W1 += w;
        X1$1 += w * (x0$4 + (x0$4 = x));
        Y1$1 += w * (y0$4 + (y0$4 = y));
        Z1$1 += w * (z0 + (z0 = z));
        centroidPointCartesian(x0$4, y0$4, z0);
    }
    function centroid$1(object) {
        W0 = W1 = X0$1 = Y0$1 = Z0$1 = X1$1 = Y1$1 = Z1$1 = 0;
        X2$1 = new Adder();
        Y2$1 = new Adder();
        Z2$1 = new Adder();
        geoStream(object, centroidStream$1);
        var x = +X2$1, y = +Y2$1, z = +Z2$1, m = hypot(x, y, z);
        // If the area-weighted ccentroid is undefined, fall back to length-weighted ccentroid.
        if (m < epsilon2) {
            x = X1$1, y = Y1$1, z = Z1$1;
            // If the feature has zero length, fall back to arithmetic mean of point vectors.
            if (W1 < epsilon$1) x = X0$1, y = Y0$1, z = Z0$1;
            m = hypot(x, y, z);
            // If the feature still has an undefined ccentroid, then return.
            if (m < epsilon2) return [
                NaN,
                NaN
            ];
        }
        return [
            atan2$1(y, x) * degrees,
            asin$1(z / m) * degrees
        ];
    }
    function constant$3(x) {
        return function() {
            return x;
        };
    }
    function compose(a, b) {
        function compose(x, y) {
            return x = a(x, y), b(x[0], x[1]);
        }
        if (a.invert && b.invert) compose.invert = function(x, y) {
            return x = b.invert(x, y), x && a.invert(x[0], x[1]);
        };
        return compose;
    }
    function rotationIdentity(lambda, phi) {
        return [
            abs$1(lambda) > pi$1 ? lambda + Math.round(-lambda / tau$1) * tau$1 : lambda,
            phi
        ];
    }
    rotationIdentity.invert = rotationIdentity;
    function rotateRadians(deltaLambda, deltaPhi, deltaGamma) {
        return (deltaLambda %= tau$1) ? deltaPhi || deltaGamma ? compose(rotationLambda(deltaLambda), rotationPhiGamma(deltaPhi, deltaGamma)) : rotationLambda(deltaLambda) : deltaPhi || deltaGamma ? rotationPhiGamma(deltaPhi, deltaGamma) : rotationIdentity;
    }
    function forwardRotationLambda(deltaLambda) {
        return function(lambda, phi) {
            return lambda += deltaLambda, [
                lambda > pi$1 ? lambda - tau$1 : lambda < -pi$1 ? lambda + tau$1 : lambda,
                phi
            ];
        };
    }
    function rotationLambda(deltaLambda) {
        var rotation = forwardRotationLambda(deltaLambda);
        rotation.invert = forwardRotationLambda(-deltaLambda);
        return rotation;
    }
    function rotationPhiGamma(deltaPhi, deltaGamma) {
        var cosDeltaPhi = cos$1(deltaPhi), sinDeltaPhi = sin$1(deltaPhi), cosDeltaGamma = cos$1(deltaGamma), sinDeltaGamma = sin$1(deltaGamma);
        function rotation(lambda, phi) {
            var cosPhi = cos$1(phi), x = cos$1(lambda) * cosPhi, y = sin$1(lambda) * cosPhi, z = sin$1(phi), k = z * cosDeltaPhi + x * sinDeltaPhi;
            return [
                atan2$1(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi),
                asin$1(k * cosDeltaGamma + y * sinDeltaGamma)
            ];
        }
        rotation.invert = function(lambda, phi) {
            var cosPhi = cos$1(phi), x = cos$1(lambda) * cosPhi, y = sin$1(lambda) * cosPhi, z = sin$1(phi), k = z * cosDeltaGamma - y * sinDeltaGamma;
            return [
                atan2$1(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi),
                asin$1(k * cosDeltaPhi - x * sinDeltaPhi)
            ];
        };
        return rotation;
    }
    function rotation(rotate) {
        rotate = rotateRadians(rotate[0] * radians, rotate[1] * radians, rotate.length > 2 ? rotate[2] * radians : 0);
        function forward(coordinates) {
            coordinates = rotate(coordinates[0] * radians, coordinates[1] * radians);
            return coordinates[0] *= degrees, coordinates[1] *= degrees, coordinates;
        }
        forward.invert = function(coordinates) {
            coordinates = rotate.invert(coordinates[0] * radians, coordinates[1] * radians);
            return coordinates[0] *= degrees, coordinates[1] *= degrees, coordinates;
        };
        return forward;
    }
    // Generates a circle centered at [0°, 0°], with a given radius and precision.
    function circleStream(stream, radius, delta, direction, t0, t1) {
        if (!delta) return;
        var cosRadius = cos$1(radius), sinRadius = sin$1(radius), step = direction * delta;
        if (t0 == null) {
            t0 = radius + direction * tau$1;
            t1 = radius - step / 2;
        } else {
            t0 = circleRadius(cosRadius, t0);
            t1 = circleRadius(cosRadius, t1);
            if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * tau$1;
        }
        for(var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step){
            point = spherical([
                cosRadius,
                -sinRadius * cos$1(t),
                -sinRadius * sin$1(t)
            ]);
            stream.point(point[0], point[1]);
        }
    }
    // Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].
    function circleRadius(cosRadius, point) {
        point = cartesian(point), point[0] -= cosRadius;
        cartesianNormalizeInPlace(point);
        var radius = acos$1(-point[1]);
        return ((-point[2] < 0 ? -radius : radius) + tau$1 - epsilon$1) % tau$1;
    }
    function circle$2() {
        var center = constant$3([
            0,
            0
        ]), radius = constant$3(90), precision = constant$3(6), ring, rotate, stream = {
            point: point
        };
        function point(x, y) {
            ring.push(x = rotate(x, y));
            x[0] *= degrees, x[1] *= degrees;
        }
        function circle() {
            var c = center.apply(this, arguments), r = radius.apply(this, arguments) * radians, p = precision.apply(this, arguments) * radians;
            ring = [];
            rotate = rotateRadians(-c[0] * radians, -c[1] * radians, 0).invert;
            circleStream(stream, r, p, 1);
            c = {
                type: "Polygon",
                coordinates: [
                    ring
                ]
            };
            ring = rotate = null;
            return c;
        }
        circle.center = function(_) {
            return arguments.length ? (center = typeof _ === "function" ? _ : constant$3([
                +_[0],
                +_[1]
            ]), circle) : center;
        };
        circle.radius = function(_) {
            return arguments.length ? (radius = typeof _ === "function" ? _ : constant$3(+_), circle) : radius;
        };
        circle.precision = function(_) {
            return arguments.length ? (precision = typeof _ === "function" ? _ : constant$3(+_), circle) : precision;
        };
        return circle;
    }
    function clipBuffer() {
        var lines = [], line;
        return {
            point: function(x, y, m) {
                line.push([
                    x,
                    y,
                    m
                ]);
            },
            lineStart: function() {
                lines.push(line = []);
            },
            lineEnd: noop$1,
            rejoin: function() {
                if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
            },
            result: function() {
                var result = lines;
                lines = [];
                line = null;
                return result;
            }
        };
    }
    function pointEqual(a, b) {
        return abs$1(a[0] - b[0]) < epsilon$1 && abs$1(a[1] - b[1]) < epsilon$1;
    }
    function Intersection(point, points, other, entry) {
        this.x = point;
        this.z = points;
        this.o = other; // another intersection
        this.e = entry; // is an entry?
        this.v = false; // visited
        this.n = this.p = null; // next & previous
    }
    // A generalized polygon clipping algorithm: given a polygon that has been cut
    // into its visible line segments, and rejoins the segments by interpolating
    // along the clip edge.
    function clipRejoin(segments, compareIntersection, startInside, interpolate, stream) {
        var subject = [], clip = [], i, n;
        segments.forEach(function(segment) {
            if ((n = segment.length - 1) <= 0) return;
            var n, p0 = segment[0], p1 = segment[n], x;
            if (pointEqual(p0, p1)) {
                if (!p0[2] && !p1[2]) {
                    stream.lineStart();
                    for(i = 0; i < n; ++i)stream.point((p0 = segment[i])[0], p0[1]);
                    stream.lineEnd();
                    return;
                }
                // handle degenerate cases by moving the point
                p1[0] += 2 * epsilon$1;
            }
            subject.push(x = new Intersection(p0, segment, null, true));
            clip.push(x.o = new Intersection(p0, null, x, false));
            subject.push(x = new Intersection(p1, segment, null, false));
            clip.push(x.o = new Intersection(p1, null, x, true));
        });
        if (!subject.length) return;
        clip.sort(compareIntersection);
        link$1(subject);
        link$1(clip);
        for(i = 0, n = clip.length; i < n; ++i)clip[i].e = startInside = !startInside;
        var start = subject[0], points, point;
        while(true){
            // Find first unvisited intersection.
            var current = start, isSubject = true;
            while(current.v)if ((current = current.n) === start) return;
            points = current.z;
            stream.lineStart();
            do {
                current.v = current.o.v = true;
                if (current.e) {
                    if (isSubject) for(i = 0, n = points.length; i < n; ++i)stream.point((point = points[i])[0], point[1]);
                    else interpolate(current.x, current.n.x, 1, stream);
                    current = current.n;
                } else {
                    if (isSubject) {
                        points = current.p.z;
                        for(i = points.length - 1; i >= 0; --i)stream.point((point = points[i])[0], point[1]);
                    } else interpolate(current.x, current.p.x, -1, stream);
                    current = current.p;
                }
                current = current.o;
                points = current.z;
                isSubject = !isSubject;
            }while (!current.v);
            stream.lineEnd();
        }
    }
    function link$1(array) {
        if (!(n = array.length)) return;
        var n, i = 0, a = array[0], b;
        while(++i < n){
            a.n = b = array[i];
            b.p = a;
            a = b;
        }
        a.n = b = array[0];
        b.p = a;
    }
    function longitude(point) {
        return abs$1(point[0]) <= pi$1 ? point[0] : sign$1(point[0]) * ((abs$1(point[0]) + pi$1) % tau$1 - pi$1);
    }
    function polygonContains(polygon, point) {
        var lambda = longitude(point), phi = point[1], sinPhi = sin$1(phi), normal = [
            sin$1(lambda),
            -cos$1(lambda),
            0
        ], angle = 0, winding = 0;
        var sum = new Adder();
        if (sinPhi === 1) phi = halfPi$1 + epsilon$1;
        else if (sinPhi === -1) phi = -halfPi$1 - epsilon$1;
        for(var i = 0, n = polygon.length; i < n; ++i){
            if (!(m = (ring = polygon[i]).length)) continue;
            var ring, m, point0 = ring[m - 1], lambda0 = longitude(point0), phi0 = point0[1] / 2 + quarterPi, sinPhi0 = sin$1(phi0), cosPhi0 = cos$1(phi0);
            for(var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1){
                var point1 = ring[j], lambda1 = longitude(point1), phi1 = point1[1] / 2 + quarterPi, sinPhi1 = sin$1(phi1), cosPhi1 = cos$1(phi1), delta = lambda1 - lambda0, sign = delta >= 0 ? 1 : -1, absDelta = sign * delta, antimeridian = absDelta > pi$1, k = sinPhi0 * sinPhi1;
                sum.add(atan2$1(k * sign * sin$1(absDelta), cosPhi0 * cosPhi1 + k * cos$1(absDelta)));
                angle += antimeridian ? delta + sign * tau$1 : delta;
                // Are the longitudes either side of the point’s meridian (lambda),
                // and are the latitudes smaller than the parallel (phi)?
                if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
                    var arc = cartesianCross(cartesian(point0), cartesian(point1));
                    cartesianNormalizeInPlace(arc);
                    var intersection = cartesianCross(normal, arc);
                    cartesianNormalizeInPlace(intersection);
                    var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * asin$1(intersection[2]);
                    if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) winding += antimeridian ^ delta >= 0 ? 1 : -1;
                }
            }
        }
        // First, determine whether the South pole is inside or outside:
        //
        // It is inside if:
        // * the polygon winds around it in a clockwise direction.
        // * the polygon does not (cumulatively) wind around it, but has a negative
        //   (counter-clockwise) area.
        //
        // Second, count the (signed) number of times a segment crosses a lambda
        // from the point to the South pole.  If it is zero, then the point is the
        // same side as the South pole.
        return (angle < -epsilon$1 || angle < epsilon$1 && sum < -epsilon2) ^ winding & 1;
    }
    function clip(pointVisible, clipLine, interpolate, start) {
        return function(sink) {
            var line = clipLine(sink), ringBuffer = clipBuffer(), ringSink = clipLine(ringBuffer), polygonStarted = false, polygon, segments, ring;
            var clip = {
                point: point,
                lineStart: lineStart,
                lineEnd: lineEnd,
                polygonStart: function() {
                    clip.point = pointRing;
                    clip.lineStart = ringStart;
                    clip.lineEnd = ringEnd;
                    segments = [];
                    polygon = [];
                },
                polygonEnd: function() {
                    clip.point = point;
                    clip.lineStart = lineStart;
                    clip.lineEnd = lineEnd;
                    segments = merge(segments);
                    var startInside = polygonContains(polygon, start);
                    if (segments.length) {
                        if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                        clipRejoin(segments, compareIntersection, startInside, interpolate, sink);
                    } else if (startInside) {
                        if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                        sink.lineStart();
                        interpolate(null, null, 1, sink);
                        sink.lineEnd();
                    }
                    if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
                    segments = polygon = null;
                },
                sphere: function() {
                    sink.polygonStart();
                    sink.lineStart();
                    interpolate(null, null, 1, sink);
                    sink.lineEnd();
                    sink.polygonEnd();
                }
            };
            function point(lambda, phi) {
                if (pointVisible(lambda, phi)) sink.point(lambda, phi);
            }
            function pointLine(lambda, phi) {
                line.point(lambda, phi);
            }
            function lineStart() {
                clip.point = pointLine;
                line.lineStart();
            }
            function lineEnd() {
                clip.point = point;
                line.lineEnd();
            }
            function pointRing(lambda, phi) {
                ring.push([
                    lambda,
                    phi
                ]);
                ringSink.point(lambda, phi);
            }
            function ringStart() {
                ringSink.lineStart();
                ring = [];
            }
            function ringEnd() {
                pointRing(ring[0][0], ring[0][1]);
                ringSink.lineEnd();
                var clean = ringSink.clean(), ringSegments = ringBuffer.result(), i, n = ringSegments.length, m, segment, point;
                ring.pop();
                polygon.push(ring);
                ring = null;
                if (!n) return;
                // No intersections.
                if (clean & 1) {
                    segment = ringSegments[0];
                    if ((m = segment.length - 1) > 0) {
                        if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                        sink.lineStart();
                        for(i = 0; i < m; ++i)sink.point((point = segment[i])[0], point[1]);
                        sink.lineEnd();
                    }
                    return;
                }
                // Rejoin connected segments.
                // TODO reuse ringBuffer.rejoin()?
                if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
                segments.push(ringSegments.filter(validSegment));
            }
            return clip;
        };
    }
    function validSegment(segment) {
        return segment.length > 1;
    }
    // Intersections are sorted along the clip edge. For both antimeridian cutting
    // and circle clipping, the same comparison is used.
    function compareIntersection(a, b) {
        return ((a = a.x)[0] < 0 ? a[1] - halfPi$1 - epsilon$1 : halfPi$1 - a[1]) - ((b = b.x)[0] < 0 ? b[1] - halfPi$1 - epsilon$1 : halfPi$1 - b[1]);
    }
    var clipAntimeridian = clip(function() {
        return true;
    }, clipAntimeridianLine, clipAntimeridianInterpolate, [
        -pi$1,
        -halfPi$1
    ]);
    // Takes a line and cuts into visible segments. Return values: 0 - there were
    // intersections or the line was empty; 1 - no intersections; 2 - there were
    // intersections, and the first and last segments should be rejoined.
    function clipAntimeridianLine(stream) {
        var lambda0 = NaN, phi0 = NaN, sign0 = NaN, clean; // no intersections
        return {
            lineStart: function() {
                stream.lineStart();
                clean = 1;
            },
            point: function(lambda1, phi1) {
                var sign1 = lambda1 > 0 ? pi$1 : -pi$1, delta = abs$1(lambda1 - lambda0);
                if (abs$1(delta - pi$1) < epsilon$1) {
                    stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? halfPi$1 : -halfPi$1);
                    stream.point(sign0, phi0);
                    stream.lineEnd();
                    stream.lineStart();
                    stream.point(sign1, phi0);
                    stream.point(lambda1, phi0);
                    clean = 0;
                } else if (sign0 !== sign1 && delta >= pi$1) {
                    if (abs$1(lambda0 - sign0) < epsilon$1) lambda0 -= sign0 * epsilon$1; // handle degeneracies
                    if (abs$1(lambda1 - sign1) < epsilon$1) lambda1 -= sign1 * epsilon$1;
                    phi0 = clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
                    stream.point(sign0, phi0);
                    stream.lineEnd();
                    stream.lineStart();
                    stream.point(sign1, phi0);
                    clean = 0;
                }
                stream.point(lambda0 = lambda1, phi0 = phi1);
                sign0 = sign1;
            },
            lineEnd: function() {
                stream.lineEnd();
                lambda0 = phi0 = NaN;
            },
            clean: function() {
                return 2 - clean; // if intersections, rejoin first and last segments
            }
        };
    }
    function clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
        var cosPhi0, cosPhi1, sinLambda0Lambda1 = sin$1(lambda0 - lambda1);
        return abs$1(sinLambda0Lambda1) > epsilon$1 ? atan((sin$1(phi0) * (cosPhi1 = cos$1(phi1)) * sin$1(lambda1) - sin$1(phi1) * (cosPhi0 = cos$1(phi0)) * sin$1(lambda0)) / (cosPhi0 * cosPhi1 * sinLambda0Lambda1)) : (phi0 + phi1) / 2;
    }
    function clipAntimeridianInterpolate(from, to, direction, stream) {
        var phi;
        if (from == null) {
            phi = direction * halfPi$1;
            stream.point(-pi$1, phi);
            stream.point(0, phi);
            stream.point(pi$1, phi);
            stream.point(pi$1, 0);
            stream.point(pi$1, -phi);
            stream.point(0, -phi);
            stream.point(-pi$1, -phi);
            stream.point(-pi$1, 0);
            stream.point(-pi$1, phi);
        } else if (abs$1(from[0] - to[0]) > epsilon$1) {
            var lambda = from[0] < to[0] ? pi$1 : -pi$1;
            phi = direction * lambda / 2;
            stream.point(-lambda, phi);
            stream.point(0, phi);
            stream.point(lambda, phi);
        } else stream.point(to[0], to[1]);
    }
    function clipCircle(radius) {
        var cr = cos$1(radius), delta = 6 * radians, smallRadius = cr > 0, notHemisphere = abs$1(cr) > epsilon$1; // TODO optimise for this common case
        function interpolate(from, to, direction, stream) {
            circleStream(stream, radius, delta, direction, from, to);
        }
        function visible(lambda, phi) {
            return cos$1(lambda) * cos$1(phi) > cr;
        }
        // Takes a line and cuts into visible segments. Return values used for polygon
        // clipping: 0 - there were intersections or the line was empty; 1 - no
        // intersections 2 - there were intersections, and the first and last segments
        // should be rejoined.
        function clipLine(stream) {
            var point0, c0, v0, v00, clean; // no intersections
            return {
                lineStart: function() {
                    v00 = v0 = false;
                    clean = 1;
                },
                point: function(lambda, phi) {
                    var point1 = [
                        lambda,
                        phi
                    ], point2, v = visible(lambda, phi), c = smallRadius ? v ? 0 : code(lambda, phi) : v ? code(lambda + (lambda < 0 ? pi$1 : -pi$1), phi) : 0;
                    if (!point0 && (v00 = v0 = v)) stream.lineStart();
                    if (v !== v0) {
                        point2 = intersect(point0, point1);
                        if (!point2 || pointEqual(point0, point2) || pointEqual(point1, point2)) point1[2] = 1;
                    }
                    if (v !== v0) {
                        clean = 0;
                        if (v) {
                            // outside going in
                            stream.lineStart();
                            point2 = intersect(point1, point0);
                            stream.point(point2[0], point2[1]);
                        } else {
                            // inside going out
                            point2 = intersect(point0, point1);
                            stream.point(point2[0], point2[1], 2);
                            stream.lineEnd();
                        }
                        point0 = point2;
                    } else if (notHemisphere && point0 && smallRadius ^ v) {
                        var t;
                        // If the codes for two points are different, or are both zero,
                        // and there this segment intersects with the small circle.
                        if (!(c & c0) && (t = intersect(point1, point0, true))) {
                            clean = 0;
                            if (smallRadius) {
                                stream.lineStart();
                                stream.point(t[0][0], t[0][1]);
                                stream.point(t[1][0], t[1][1]);
                                stream.lineEnd();
                            } else {
                                stream.point(t[1][0], t[1][1]);
                                stream.lineEnd();
                                stream.lineStart();
                                stream.point(t[0][0], t[0][1], 3);
                            }
                        }
                    }
                    if (v && (!point0 || !pointEqual(point0, point1))) stream.point(point1[0], point1[1]);
                    point0 = point1, v0 = v, c0 = c;
                },
                lineEnd: function() {
                    if (v0) stream.lineEnd();
                    point0 = null;
                },
                // Rejoin first and last segments if there were intersections and the first
                // and last points were visible.
                clean: function() {
                    return clean | (v00 && v0) << 1;
                }
            };
        }
        // Intersects the great circle between a and b with the clip circle.
        function intersect(a, b, two) {
            var pa = cartesian(a), pb = cartesian(b);
            // We have two planes, n1.p = d1 and n2.p = d2.
            // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).
            var n1 = [
                1,
                0,
                0
            ], n2 = cartesianCross(pa, pb), n2n2 = cartesianDot(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
            // Two polar points.
            if (!determinant) return !two && a;
            var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = cartesianCross(n1, n2), A = cartesianScale(n1, c1), B = cartesianScale(n2, c2);
            cartesianAddInPlace(A, B);
            // Solve |p(t)|^2 = 1.
            var u = n1xn2, w = cartesianDot(A, u), uu = cartesianDot(u, u), t2 = w * w - uu * (cartesianDot(A, A) - 1);
            if (t2 < 0) return;
            var t = sqrt$2(t2), q = cartesianScale(u, (-w - t) / uu);
            cartesianAddInPlace(q, A);
            q = spherical(q);
            if (!two) return q;
            // Two intersection points.
            var lambda0 = a[0], lambda1 = b[0], phi0 = a[1], phi1 = b[1], z;
            if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;
            var delta = lambda1 - lambda0, polar = abs$1(delta - pi$1) < epsilon$1, meridian = polar || delta < epsilon$1;
            if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;
            // Check that the first point is between a and b.
            if (meridian ? polar ? phi0 + phi1 > 0 ^ q[1] < (abs$1(q[0] - lambda0) < epsilon$1 ? phi0 : phi1) : phi0 <= q[1] && q[1] <= phi1 : delta > pi$1 ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
                var q1 = cartesianScale(u, (-w + t) / uu);
                cartesianAddInPlace(q1, A);
                return [
                    q,
                    spherical(q1)
                ];
            }
        }
        // Generates a 4-bit vector representing the location of a point relative to
        // the small circle's bounding box.
        function code(lambda, phi) {
            var r = smallRadius ? radius : pi$1 - radius, code = 0;
            if (lambda < -r) code |= 1; // left
            else if (lambda > r) code |= 2; // right
            if (phi < -r) code |= 4; // below
            else if (phi > r) code |= 8; // above
            return code;
        }
        return clip(visible, clipLine, interpolate, smallRadius ? [
            0,
            -radius
        ] : [
            -pi$1,
            radius - pi$1
        ]);
    }
    function clipLine(a, b, x0, y0, x1, y1) {
        var ax = a[0], ay = a[1], bx = b[0], by = b[1], t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
        r = x0 - ax;
        if (!dx && r > 0) return;
        r /= dx;
        if (dx < 0) {
            if (r < t0) return;
            if (r < t1) t1 = r;
        } else if (dx > 0) {
            if (r > t1) return;
            if (r > t0) t0 = r;
        }
        r = x1 - ax;
        if (!dx && r < 0) return;
        r /= dx;
        if (dx < 0) {
            if (r > t1) return;
            if (r > t0) t0 = r;
        } else if (dx > 0) {
            if (r < t0) return;
            if (r < t1) t1 = r;
        }
        r = y0 - ay;
        if (!dy && r > 0) return;
        r /= dy;
        if (dy < 0) {
            if (r < t0) return;
            if (r < t1) t1 = r;
        } else if (dy > 0) {
            if (r > t1) return;
            if (r > t0) t0 = r;
        }
        r = y1 - ay;
        if (!dy && r < 0) return;
        r /= dy;
        if (dy < 0) {
            if (r > t1) return;
            if (r > t0) t0 = r;
        } else if (dy > 0) {
            if (r < t0) return;
            if (r < t1) t1 = r;
        }
        if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
        if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
        return true;
    }
    var clipMax = 1e9, clipMin = -clipMax;
    // TODO Use d3-polygon’s polygonContains here for the ring check?
    // TODO Eliminate duplicate buffering in clipBuffer and polygon.push?
    function clipRectangle(x0, y0, x1, y1) {
        function visible(x, y) {
            return x0 <= x && x <= x1 && y0 <= y && y <= y1;
        }
        function interpolate(from, to, direction, stream) {
            var a = 0, a1 = 0;
            if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoint(from, to) < 0 ^ direction > 0) do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
            while ((a = (a + direction + 4) % 4) !== a1);
            else stream.point(to[0], to[1]);
        }
        function corner(p, direction) {
            return abs$1(p[0] - x0) < epsilon$1 ? direction > 0 ? 0 : 3 : abs$1(p[0] - x1) < epsilon$1 ? direction > 0 ? 2 : 1 : abs$1(p[1] - y0) < epsilon$1 ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
        }
        function compareIntersection(a, b) {
            return comparePoint(a.x, b.x);
        }
        function comparePoint(a, b) {
            var ca = corner(a, 1), cb = corner(b, 1);
            return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
        }
        return function(stream) {
            var activeStream = stream, bufferStream = clipBuffer(), segments, polygon, ring, x__, y__, v__, x_, y_, v_, first, clean;
            var clipStream = {
                point: point,
                lineStart: lineStart,
                lineEnd: lineEnd,
                polygonStart: polygonStart,
                polygonEnd: polygonEnd
            };
            function point(x, y) {
                if (visible(x, y)) activeStream.point(x, y);
            }
            function polygonInside() {
                var winding = 0;
                for(var i = 0, n = polygon.length; i < n; ++i)for(var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j){
                    a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
                    if (a1 <= y1) {
                        if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding;
                    } else if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding;
                }
                return winding;
            }
            // Buffer geometry within a polygon and then clip it en masse.
            function polygonStart() {
                activeStream = bufferStream, segments = [], polygon = [], clean = true;
            }
            function polygonEnd() {
                var startInside = polygonInside(), cleanInside = clean && startInside, visible = (segments = merge(segments)).length;
                if (cleanInside || visible) {
                    stream.polygonStart();
                    if (cleanInside) {
                        stream.lineStart();
                        interpolate(null, null, 1, stream);
                        stream.lineEnd();
                    }
                    if (visible) clipRejoin(segments, compareIntersection, startInside, interpolate, stream);
                    stream.polygonEnd();
                }
                activeStream = stream, segments = polygon = ring = null;
            }
            function lineStart() {
                clipStream.point = linePoint;
                if (polygon) polygon.push(ring = []);
                first = true;
                v_ = false;
                x_ = y_ = NaN;
            }
            // TODO rather than special-case polygons, simply handle them separately.
            // Ideally, coincident intersection points should be jittered to avoid
            // clipping issues.
            function lineEnd() {
                if (segments) {
                    linePoint(x__, y__);
                    if (v__ && v_) bufferStream.rejoin();
                    segments.push(bufferStream.result());
                }
                clipStream.point = point;
                if (v_) activeStream.lineEnd();
            }
            function linePoint(x, y) {
                var v = visible(x, y);
                if (polygon) ring.push([
                    x,
                    y
                ]);
                if (first) {
                    x__ = x, y__ = y, v__ = v;
                    first = false;
                    if (v) {
                        activeStream.lineStart();
                        activeStream.point(x, y);
                    }
                } else if (v && v_) activeStream.point(x, y);
                else {
                    var a = [
                        x_ = Math.max(clipMin, Math.min(clipMax, x_)),
                        y_ = Math.max(clipMin, Math.min(clipMax, y_))
                    ], b = [
                        x = Math.max(clipMin, Math.min(clipMax, x)),
                        y = Math.max(clipMin, Math.min(clipMax, y))
                    ];
                    if (clipLine(a, b, x0, y0, x1, y1)) {
                        if (!v_) {
                            activeStream.lineStart();
                            activeStream.point(a[0], a[1]);
                        }
                        activeStream.point(b[0], b[1]);
                        if (!v) activeStream.lineEnd();
                        clean = false;
                    } else if (v) {
                        activeStream.lineStart();
                        activeStream.point(x, y);
                        clean = false;
                    }
                }
                x_ = x, y_ = y, v_ = v;
            }
            return clipStream;
        };
    }
    function extent() {
        var x0 = 0, y0 = 0, x1 = 960, y1 = 500, cache, cacheStream, clip;
        return clip = {
            stream: function(stream) {
                return cache && cacheStream === stream ? cache : cache = clipRectangle(x0, y0, x1, y1)(cacheStream = stream);
            },
            extent: function(_) {
                return arguments.length ? (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1], cache = cacheStream = null, clip) : [
                    [
                        x0,
                        y0
                    ],
                    [
                        x1,
                        y1
                    ]
                ];
            }
        };
    }
    var lengthSum$1, lambda0, sinPhi0, cosPhi0;
    var lengthStream$1 = {
        sphere: noop$1,
        point: noop$1,
        lineStart: lengthLineStart,
        lineEnd: noop$1,
        polygonStart: noop$1,
        polygonEnd: noop$1
    };
    function lengthLineStart() {
        lengthStream$1.point = lengthPointFirst$1;
        lengthStream$1.lineEnd = lengthLineEnd;
    }
    function lengthLineEnd() {
        lengthStream$1.point = lengthStream$1.lineEnd = noop$1;
    }
    function lengthPointFirst$1(lambda, phi) {
        lambda *= radians, phi *= radians;
        lambda0 = lambda, sinPhi0 = sin$1(phi), cosPhi0 = cos$1(phi);
        lengthStream$1.point = lengthPoint$1;
    }
    function lengthPoint$1(lambda, phi) {
        lambda *= radians, phi *= radians;
        var sinPhi = sin$1(phi), cosPhi = cos$1(phi), delta = abs$1(lambda - lambda0), cosDelta = cos$1(delta), sinDelta = sin$1(delta), x = cosPhi * sinDelta, y = cosPhi0 * sinPhi - sinPhi0 * cosPhi * cosDelta, z = sinPhi0 * sinPhi + cosPhi0 * cosPhi * cosDelta;
        lengthSum$1.add(atan2$1(sqrt$2(x * x + y * y), z));
        lambda0 = lambda, sinPhi0 = sinPhi, cosPhi0 = cosPhi;
    }
    function length$1(object) {
        lengthSum$1 = new Adder();
        geoStream(object, lengthStream$1);
        return +lengthSum$1;
    }
    var coordinates = [
        null,
        null
    ], object = {
        type: "LineString",
        coordinates: coordinates
    };
    function distance(a, b) {
        coordinates[0] = a;
        coordinates[1] = b;
        return length$1(object);
    }
    var containsObjectType = {
        Feature: function(object, point) {
            return containsGeometry(object.geometry, point);
        },
        FeatureCollection: function(object, point) {
            var features = object.features, i = -1, n = features.length;
            while(++i < n)if (containsGeometry(features[i].geometry, point)) return true;
            return false;
        }
    };
    var containsGeometryType = {
        Sphere: function() {
            return true;
        },
        Point: function(object, point) {
            return containsPoint(object.coordinates, point);
        },
        MultiPoint: function(object, point) {
            var coordinates = object.coordinates, i = -1, n = coordinates.length;
            while(++i < n)if (containsPoint(coordinates[i], point)) return true;
            return false;
        },
        LineString: function(object, point) {
            return containsLine(object.coordinates, point);
        },
        MultiLineString: function(object, point) {
            var coordinates = object.coordinates, i = -1, n = coordinates.length;
            while(++i < n)if (containsLine(coordinates[i], point)) return true;
            return false;
        },
        Polygon: function(object, point) {
            return containsPolygon(object.coordinates, point);
        },
        MultiPolygon: function(object, point) {
            var coordinates = object.coordinates, i = -1, n = coordinates.length;
            while(++i < n)if (containsPolygon(coordinates[i], point)) return true;
            return false;
        },
        GeometryCollection: function(object, point) {
            var geometries = object.geometries, i = -1, n = geometries.length;
            while(++i < n)if (containsGeometry(geometries[i], point)) return true;
            return false;
        }
    };
    function containsGeometry(geometry, point) {
        return geometry && containsGeometryType.hasOwnProperty(geometry.type) ? containsGeometryType[geometry.type](geometry, point) : false;
    }
    function containsPoint(coordinates, point) {
        return distance(coordinates, point) === 0;
    }
    function containsLine(coordinates, point) {
        var ao, bo, ab;
        for(var i = 0, n = coordinates.length; i < n; i++){
            bo = distance(coordinates[i], point);
            if (bo === 0) return true;
            if (i > 0) {
                ab = distance(coordinates[i], coordinates[i - 1]);
                if (ab > 0 && ao <= ab && bo <= ab && (ao + bo - ab) * (1 - Math.pow((ao - bo) / ab, 2)) < epsilon2 * ab) return true;
            }
            ao = bo;
        }
        return false;
    }
    function containsPolygon(coordinates, point) {
        return !!polygonContains(coordinates.map(ringRadians), pointRadians(point));
    }
    function ringRadians(ring) {
        return ring = ring.map(pointRadians), ring.pop(), ring;
    }
    function pointRadians(point) {
        return [
            point[0] * radians,
            point[1] * radians
        ];
    }
    function contains$1(object, point) {
        return (object && containsObjectType.hasOwnProperty(object.type) ? containsObjectType[object.type] : containsGeometry)(object, point);
    }
    function graticuleX(y0, y1, dy) {
        var y = range$2(y0, y1 - epsilon$1, dy).concat(y1);
        return function(x) {
            return y.map(function(y) {
                return [
                    x,
                    y
                ];
            });
        };
    }
    function graticuleY(x0, x1, dx) {
        var x = range$2(x0, x1 - epsilon$1, dx).concat(x1);
        return function(y) {
            return x.map(function(x) {
                return [
                    x,
                    y
                ];
            });
        };
    }
    function graticule() {
        var x1, x0, X1, X0, y1, y0, Y1, Y0, dx = 10, dy = dx, DX = 90, DY = 360, x, y, X, Y, precision = 2.5;
        function graticule() {
            return {
                type: "MultiLineString",
                coordinates: lines()
            };
        }
        function lines() {
            return range$2(ceil(X0 / DX) * DX, X1, DX).map(X).concat(range$2(ceil(Y0 / DY) * DY, Y1, DY).map(Y)).concat(range$2(ceil(x0 / dx) * dx, x1, dx).filter(function(x) {
                return abs$1(x % DX) > epsilon$1;
            }).map(x)).concat(range$2(ceil(y0 / dy) * dy, y1, dy).filter(function(y) {
                return abs$1(y % DY) > epsilon$1;
            }).map(y));
        }
        graticule.lines = function() {
            return lines().map(function(coordinates) {
                return {
                    type: "LineString",
                    coordinates: coordinates
                };
            });
        };
        graticule.outline = function() {
            return {
                type: "Polygon",
                coordinates: [
                    X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1))
                ]
            };
        };
        graticule.extent = function(_) {
            if (!arguments.length) return graticule.extentMinor();
            return graticule.extentMajor(_).extentMinor(_);
        };
        graticule.extentMajor = function(_) {
            if (!arguments.length) return [
                [
                    X0,
                    Y0
                ],
                [
                    X1,
                    Y1
                ]
            ];
            X0 = +_[0][0], X1 = +_[1][0];
            Y0 = +_[0][1], Y1 = +_[1][1];
            if (X0 > X1) _ = X0, X0 = X1, X1 = _;
            if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
            return graticule.precision(precision);
        };
        graticule.extentMinor = function(_) {
            if (!arguments.length) return [
                [
                    x0,
                    y0
                ],
                [
                    x1,
                    y1
                ]
            ];
            x0 = +_[0][0], x1 = +_[1][0];
            y0 = +_[0][1], y1 = +_[1][1];
            if (x0 > x1) _ = x0, x0 = x1, x1 = _;
            if (y0 > y1) _ = y0, y0 = y1, y1 = _;
            return graticule.precision(precision);
        };
        graticule.step = function(_) {
            if (!arguments.length) return graticule.stepMinor();
            return graticule.stepMajor(_).stepMinor(_);
        };
        graticule.stepMajor = function(_) {
            if (!arguments.length) return [
                DX,
                DY
            ];
            DX = +_[0], DY = +_[1];
            return graticule;
        };
        graticule.stepMinor = function(_) {
            if (!arguments.length) return [
                dx,
                dy
            ];
            dx = +_[0], dy = +_[1];
            return graticule;
        };
        graticule.precision = function(_) {
            if (!arguments.length) return precision;
            precision = +_;
            x = graticuleX(y0, y1, 90);
            y = graticuleY(x0, x1, precision);
            X = graticuleX(Y0, Y1, 90);
            Y = graticuleY(X0, X1, precision);
            return graticule;
        };
        return graticule.extentMajor([
            [
                -180,
                -90 + epsilon$1
            ],
            [
                180,
                90 - epsilon$1
            ]
        ]).extentMinor([
            [
                -180,
                -80 - epsilon$1
            ],
            [
                180,
                80 + epsilon$1
            ]
        ]);
    }
    function graticule10() {
        return graticule()();
    }
    function interpolate(a, b) {
        var x0 = a[0] * radians, y0 = a[1] * radians, x1 = b[0] * radians, y1 = b[1] * radians, cy0 = cos$1(y0), sy0 = sin$1(y0), cy1 = cos$1(y1), sy1 = sin$1(y1), kx0 = cy0 * cos$1(x0), ky0 = cy0 * sin$1(x0), kx1 = cy1 * cos$1(x1), ky1 = cy1 * sin$1(x1), d = 2 * asin$1(sqrt$2(haversin(y1 - y0) + cy0 * cy1 * haversin(x1 - x0))), k = sin$1(d);
        var interpolate = d ? function(t) {
            var B = sin$1(t *= d) / k, A = sin$1(d - t) / k, x = A * kx0 + B * kx1, y = A * ky0 + B * ky1, z = A * sy0 + B * sy1;
            return [
                atan2$1(y, x) * degrees,
                atan2$1(z, sqrt$2(x * x + y * y)) * degrees
            ];
        } : function() {
            return [
                x0 * degrees,
                y0 * degrees
            ];
        };
        interpolate.distance = d;
        return interpolate;
    }
    var identity$5 = (x)=>x;
    var areaSum = new Adder(), areaRingSum = new Adder(), x00$2, y00$2, x0$3, y0$3;
    var areaStream = {
        point: noop$1,
        lineStart: noop$1,
        lineEnd: noop$1,
        polygonStart: function() {
            areaStream.lineStart = areaRingStart;
            areaStream.lineEnd = areaRingEnd;
        },
        polygonEnd: function() {
            areaStream.lineStart = areaStream.lineEnd = areaStream.point = noop$1;
            areaSum.add(abs$1(areaRingSum));
            areaRingSum = new Adder();
        },
        result: function() {
            var area = areaSum / 2;
            areaSum = new Adder();
            return area;
        }
    };
    function areaRingStart() {
        areaStream.point = areaPointFirst;
    }
    function areaPointFirst(x, y) {
        areaStream.point = areaPoint;
        x00$2 = x0$3 = x, y00$2 = y0$3 = y;
    }
    function areaPoint(x, y) {
        areaRingSum.add(y0$3 * x - x0$3 * y);
        x0$3 = x, y0$3 = y;
    }
    function areaRingEnd() {
        areaPoint(x00$2, y00$2);
    }
    var pathArea = areaStream;
    var x0$2 = Infinity, y0$2 = x0$2, x1 = -x0$2, y1 = x1;
    var boundsStream = {
        point: boundsPoint,
        lineStart: noop$1,
        lineEnd: noop$1,
        polygonStart: noop$1,
        polygonEnd: noop$1,
        result: function() {
            var bounds = [
                [
                    x0$2,
                    y0$2
                ],
                [
                    x1,
                    y1
                ]
            ];
            x1 = y1 = -(y0$2 = x0$2 = Infinity);
            return bounds;
        }
    };
    function boundsPoint(x, y) {
        if (x < x0$2) x0$2 = x;
        if (x > x1) x1 = x;
        if (y < y0$2) y0$2 = y;
        if (y > y1) y1 = y;
    }
    var boundsStream$1 = boundsStream;
    // TODO Enforce positive area for exterior, negative area for interior?
    var X0 = 0, Y0 = 0, Z0 = 0, X1 = 0, Y1 = 0, Z1 = 0, X2 = 0, Y2 = 0, Z2 = 0, x00$1, y00$1, x0$1, y0$1;
    var centroidStream = {
        point: centroidPoint,
        lineStart: centroidLineStart,
        lineEnd: centroidLineEnd,
        polygonStart: function() {
            centroidStream.lineStart = centroidRingStart;
            centroidStream.lineEnd = centroidRingEnd;
        },
        polygonEnd: function() {
            centroidStream.point = centroidPoint;
            centroidStream.lineStart = centroidLineStart;
            centroidStream.lineEnd = centroidLineEnd;
        },
        result: function() {
            var centroid = Z2 ? [
                X2 / Z2,
                Y2 / Z2
            ] : Z1 ? [
                X1 / Z1,
                Y1 / Z1
            ] : Z0 ? [
                X0 / Z0,
                Y0 / Z0
            ] : [
                NaN,
                NaN
            ];
            X0 = Y0 = Z0 = X1 = Y1 = Z1 = X2 = Y2 = Z2 = 0;
            return centroid;
        }
    };
    function centroidPoint(x, y) {
        X0 += x;
        Y0 += y;
        ++Z0;
    }
    function centroidLineStart() {
        centroidStream.point = centroidPointFirstLine;
    }
    function centroidPointFirstLine(x, y) {
        centroidStream.point = centroidPointLine;
        centroidPoint(x0$1 = x, y0$1 = y);
    }
    function centroidPointLine(x, y) {
        var dx = x - x0$1, dy = y - y0$1, z = sqrt$2(dx * dx + dy * dy);
        X1 += z * (x0$1 + x) / 2;
        Y1 += z * (y0$1 + y) / 2;
        Z1 += z;
        centroidPoint(x0$1 = x, y0$1 = y);
    }
    function centroidLineEnd() {
        centroidStream.point = centroidPoint;
    }
    function centroidRingStart() {
        centroidStream.point = centroidPointFirstRing;
    }
    function centroidRingEnd() {
        centroidPointRing(x00$1, y00$1);
    }
    function centroidPointFirstRing(x, y) {
        centroidStream.point = centroidPointRing;
        centroidPoint(x00$1 = x0$1 = x, y00$1 = y0$1 = y);
    }
    function centroidPointRing(x, y) {
        var dx = x - x0$1, dy = y - y0$1, z = sqrt$2(dx * dx + dy * dy);
        X1 += z * (x0$1 + x) / 2;
        Y1 += z * (y0$1 + y) / 2;
        Z1 += z;
        z = y0$1 * x - x0$1 * y;
        X2 += z * (x0$1 + x);
        Y2 += z * (y0$1 + y);
        Z2 += z * 3;
        centroidPoint(x0$1 = x, y0$1 = y);
    }
    var pathCentroid = centroidStream;
    function PathContext(context) {
        this._context = context;
    }
    PathContext.prototype = {
        _radius: 4.5,
        pointRadius: function(_) {
            return this._radius = _, this;
        },
        polygonStart: function() {
            this._line = 0;
        },
        polygonEnd: function() {
            this._line = NaN;
        },
        lineStart: function() {
            this._point = 0;
        },
        lineEnd: function() {
            if (this._line === 0) this._context.closePath();
            this._point = NaN;
        },
        point: function(x, y) {
            switch(this._point){
                case 0:
                    this._context.moveTo(x, y);
                    this._point = 1;
                    break;
                case 1:
                    this._context.lineTo(x, y);
                    break;
                default:
                    this._context.moveTo(x + this._radius, y);
                    this._context.arc(x, y, this._radius, 0, tau$1);
                    break;
            }
        },
        result: noop$1
    };
    var lengthSum = new Adder(), lengthRing, x00, y00, x0, y0;
    var lengthStream = {
        point: noop$1,
        lineStart: function() {
            lengthStream.point = lengthPointFirst;
        },
        lineEnd: function() {
            if (lengthRing) lengthPoint(x00, y00);
            lengthStream.point = noop$1;
        },
        polygonStart: function() {
            lengthRing = true;
        },
        polygonEnd: function() {
            lengthRing = null;
        },
        result: function() {
            var length = +lengthSum;
            lengthSum = new Adder();
            return length;
        }
    };
    function lengthPointFirst(x, y) {
        lengthStream.point = lengthPoint;
        x00 = x0 = x, y00 = y0 = y;
    }
    function lengthPoint(x, y) {
        x0 -= x, y0 -= y;
        lengthSum.add(sqrt$2(x0 * x0 + y0 * y0));
        x0 = x, y0 = y;
    }
    var pathMeasure = lengthStream;
    function PathString() {
        this._string = [];
    }
    PathString.prototype = {
        _radius: 4.5,
        _circle: circle$1(4.5),
        pointRadius: function(_) {
            if ((_ = +_) !== this._radius) this._radius = _, this._circle = null;
            return this;
        },
        polygonStart: function() {
            this._line = 0;
        },
        polygonEnd: function() {
            this._line = NaN;
        },
        lineStart: function() {
            this._point = 0;
        },
        lineEnd: function() {
            if (this._line === 0) this._string.push("Z");
            this._point = NaN;
        },
        point: function(x, y) {
            switch(this._point){
                case 0:
                    this._string.push("M", x, ",", y);
                    this._point = 1;
                    break;
                case 1:
                    this._string.push("L", x, ",", y);
                    break;
                default:
                    if (this._circle == null) this._circle = circle$1(this._radius);
                    this._string.push("M", x, ",", y, this._circle);
                    break;
            }
        },
        result: function() {
            if (this._string.length) {
                var result = this._string.join("");
                this._string = [];
                return result;
            } else return null;
        }
    };
    function circle$1(radius) {
        return "m0," + radius + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius + "z";
    }
    function index$2(projection, context) {
        var pointRadius = 4.5, projectionStream, contextStream;
        function path(object) {
            if (object) {
                if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
                geoStream(object, projectionStream(contextStream));
            }
            return contextStream.result();
        }
        path.area = function(object) {
            geoStream(object, projectionStream(pathArea));
            return pathArea.result();
        };
        path.measure = function(object) {
            geoStream(object, projectionStream(pathMeasure));
            return pathMeasure.result();
        };
        path.bounds = function(object) {
            geoStream(object, projectionStream(boundsStream$1));
            return boundsStream$1.result();
        };
        path.centroid = function(object) {
            geoStream(object, projectionStream(pathCentroid));
            return pathCentroid.result();
        };
        path.projection = function(_) {
            return arguments.length ? (projectionStream = _ == null ? (projection = null, identity$5) : (projection = _).stream, path) : projection;
        };
        path.context = function(_) {
            if (!arguments.length) return context;
            contextStream = _ == null ? (context = null, new PathString) : new PathContext(context = _);
            if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
            return path;
        };
        path.pointRadius = function(_) {
            if (!arguments.length) return pointRadius;
            pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
            return path;
        };
        return path.projection(projection).context(context);
    }
    function transform$1(methods) {
        return {
            stream: transformer$3(methods)
        };
    }
    function transformer$3(methods) {
        return function(stream) {
            var s = new TransformStream;
            for(var key in methods)s[key] = methods[key];
            s.stream = stream;
            return s;
        };
    }
    function TransformStream() {}
    TransformStream.prototype = {
        constructor: TransformStream,
        point: function(x, y) {
            this.stream.point(x, y);
        },
        sphere: function() {
            this.stream.sphere();
        },
        lineStart: function() {
            this.stream.lineStart();
        },
        lineEnd: function() {
            this.stream.lineEnd();
        },
        polygonStart: function() {
            this.stream.polygonStart();
        },
        polygonEnd: function() {
            this.stream.polygonEnd();
        }
    };
    function fit(projection, fitBounds, object) {
        var clip = projection.clipExtent && projection.clipExtent();
        projection.scale(150).translate([
            0,
            0
        ]);
        if (clip != null) projection.clipExtent(null);
        geoStream(object, projection.stream(boundsStream$1));
        fitBounds(boundsStream$1.result());
        if (clip != null) projection.clipExtent(clip);
        return projection;
    }
    function fitExtent(projection, extent, object) {
        return fit(projection, function(b) {
            var w = extent[1][0] - extent[0][0], h = extent[1][1] - extent[0][1], k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])), x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2, y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;
            projection.scale(150 * k).translate([
                x,
                y
            ]);
        }, object);
    }
    function fitSize(projection, size, object) {
        return fitExtent(projection, [
            [
                0,
                0
            ],
            size
        ], object);
    }
    function fitWidth(projection, width, object) {
        return fit(projection, function(b) {
            var w = +width, k = w / (b[1][0] - b[0][0]), x = (w - k * (b[1][0] + b[0][0])) / 2, y = -k * b[0][1];
            projection.scale(150 * k).translate([
                x,
                y
            ]);
        }, object);
    }
    function fitHeight(projection, height, object) {
        return fit(projection, function(b) {
            var h = +height, k = h / (b[1][1] - b[0][1]), x = -k * b[0][0], y = (h - k * (b[1][1] + b[0][1])) / 2;
            projection.scale(150 * k).translate([
                x,
                y
            ]);
        }, object);
    }
    var maxDepth = 16, cosMinDistance = cos$1(30 * radians); // cos(minimum angular distance)
    function resample(project, delta2) {
        return +delta2 ? resample$1(project, delta2) : resampleNone(project);
    }
    function resampleNone(project) {
        return transformer$3({
            point: function(x, y) {
                x = project(x, y);
                this.stream.point(x[0], x[1]);
            }
        });
    }
    function resample$1(project, delta2) {
        function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
            var dx = x1 - x0, dy = y1 - y0, d2 = dx * dx + dy * dy;
            if (d2 > 4 * delta2 && depth--) {
                var a = a0 + a1, b = b0 + b1, c = c0 + c1, m = sqrt$2(a * a + b * b + c * c), phi2 = asin$1(c /= m), lambda2 = abs$1(abs$1(c) - 1) < epsilon$1 || abs$1(lambda0 - lambda1) < epsilon$1 ? (lambda0 + lambda1) / 2 : atan2$1(b, a), p = project(lambda2, phi2), x2 = p[0], y2 = p[1], dx2 = x2 - x0, dy2 = y2 - y0, dz = dy * dx2 - dx * dy2;
                if (dz * dz / d2 > delta2 // perpendicular projected distance
                 || abs$1((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
                 || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) {
                    resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
                    stream.point(x2, y2);
                    resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
                }
            }
        }
        return function(stream) {
            var lambda00, x00, y00, a00, b00, c00, lambda0, x0, y0, a0, b0, c0; // previous point
            var resampleStream = {
                point: point,
                lineStart: lineStart,
                lineEnd: lineEnd,
                polygonStart: function() {
                    stream.polygonStart();
                    resampleStream.lineStart = ringStart;
                },
                polygonEnd: function() {
                    stream.polygonEnd();
                    resampleStream.lineStart = lineStart;
                }
            };
            function point(x, y) {
                x = project(x, y);
                stream.point(x[0], x[1]);
            }
            function lineStart() {
                x0 = NaN;
                resampleStream.point = linePoint;
                stream.lineStart();
            }
            function linePoint(lambda, phi) {
                var c = cartesian([
                    lambda,
                    phi
                ]), p = project(lambda, phi);
                resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
                stream.point(x0, y0);
            }
            function lineEnd() {
                resampleStream.point = point;
                stream.lineEnd();
            }
            function ringStart() {
                lineStart();
                resampleStream.point = ringPoint;
                resampleStream.lineEnd = ringEnd;
            }
            function ringPoint(lambda, phi) {
                linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
                resampleStream.point = linePoint;
            }
            function ringEnd() {
                resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, maxDepth, stream);
                resampleStream.lineEnd = lineEnd;
                lineEnd();
            }
            return resampleStream;
        };
    }
    var transformRadians = transformer$3({
        point: function(x, y) {
            this.stream.point(x * radians, y * radians);
        }
    });
    function transformRotate(rotate) {
        return transformer$3({
            point: function(x, y) {
                var r = rotate(x, y);
                return this.stream.point(r[0], r[1]);
            }
        });
    }
    function scaleTranslate(k, dx, dy, sx, sy) {
        function transform(x, y) {
            x *= sx;
            y *= sy;
            return [
                dx + k * x,
                dy - k * y
            ];
        }
        transform.invert = function(x, y) {
            return [
                (x - dx) / k * sx,
                (dy - y) / k * sy
            ];
        };
        return transform;
    }
    function scaleTranslateRotate(k, dx, dy, sx, sy, alpha) {
        if (!alpha) return scaleTranslate(k, dx, dy, sx, sy);
        var cosAlpha = cos$1(alpha), sinAlpha = sin$1(alpha), a = cosAlpha * k, b = sinAlpha * k, ai = cosAlpha / k, bi = sinAlpha / k, ci = (sinAlpha * dy - cosAlpha * dx) / k, fi = (sinAlpha * dx + cosAlpha * dy) / k;
        function transform(x, y) {
            x *= sx;
            y *= sy;
            return [
                a * x - b * y + dx,
                dy - b * x - a * y
            ];
        }
        transform.invert = function(x, y) {
            return [
                sx * (ai * x - bi * y + ci),
                sy * (fi - bi * x - ai * y)
            ];
        };
        return transform;
    }
    function projection(project) {
        return projectionMutator(function() {
            return project;
        })();
    }
    function projectionMutator(projectAt) {
        var project, k = 150, x = 480, y = 250, lambda = 0, phi = 0, deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, alpha = 0, sx = 1, sy = 1, theta = null, preclip = clipAntimeridian, x0 = null, y0, x1, y1, postclip = identity$5, delta2 = 0.5, projectResample, projectTransform, projectRotateTransform, cache, cacheStream;
        function projection(point) {
            return projectRotateTransform(point[0] * radians, point[1] * radians);
        }
        function invert(point) {
            point = projectRotateTransform.invert(point[0], point[1]);
            return point && [
                point[0] * degrees,
                point[1] * degrees
            ];
        }
        projection.stream = function(stream) {
            return cache && cacheStream === stream ? cache : cache = transformRadians(transformRotate(rotate)(preclip(projectResample(postclip(cacheStream = stream)))));
        };
        projection.preclip = function(_) {
            return arguments.length ? (preclip = _, theta = undefined, reset()) : preclip;
        };
        projection.postclip = function(_) {
            return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
        };
        projection.clipAngle = function(_) {
            return arguments.length ? (preclip = +_ ? clipCircle(theta = _ * radians) : (theta = null, clipAntimeridian), reset()) : theta * degrees;
        };
        projection.clipExtent = function(_) {
            return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, identity$5) : clipRectangle(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [
                [
                    x0,
                    y0
                ],
                [
                    x1,
                    y1
                ]
            ];
        };
        projection.scale = function(_) {
            return arguments.length ? (k = +_, recenter()) : k;
        };
        projection.translate = function(_) {
            return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [
                x,
                y
            ];
        };
        projection.center = function(_) {
            return arguments.length ? (lambda = _[0] % 360 * radians, phi = _[1] % 360 * radians, recenter()) : [
                lambda * degrees,
                phi * degrees
            ];
        };
        projection.rotate = function(_) {
            return arguments.length ? (deltaLambda = _[0] % 360 * radians, deltaPhi = _[1] % 360 * radians, deltaGamma = _.length > 2 ? _[2] % 360 * radians : 0, recenter()) : [
                deltaLambda * degrees,
                deltaPhi * degrees,
                deltaGamma * degrees
            ];
        };
        projection.angle = function(_) {
            return arguments.length ? (alpha = _ % 360 * radians, recenter()) : alpha * degrees;
        };
        projection.reflectX = function(_) {
            return arguments.length ? (sx = _ ? -1 : 1, recenter()) : sx < 0;
        };
        projection.reflectY = function(_) {
            return arguments.length ? (sy = _ ? -1 : 1, recenter()) : sy < 0;
        };
        projection.precision = function(_) {
            return arguments.length ? (projectResample = resample(projectTransform, delta2 = _ * _), reset()) : sqrt$2(delta2);
        };
        projection.fitExtent = function(extent, object) {
            return fitExtent(projection, extent, object);
        };
        projection.fitSize = function(size, object) {
            return fitSize(projection, size, object);
        };
        projection.fitWidth = function(width, object) {
            return fitWidth(projection, width, object);
        };
        projection.fitHeight = function(height, object) {
            return fitHeight(projection, height, object);
        };
        function recenter() {
            var center = scaleTranslateRotate(k, 0, 0, sx, sy, alpha).apply(null, project(lambda, phi)), transform = scaleTranslateRotate(k, x - center[0], y - center[1], sx, sy, alpha);
            rotate = rotateRadians(deltaLambda, deltaPhi, deltaGamma);
            projectTransform = compose(project, transform);
            projectRotateTransform = compose(rotate, projectTransform);
            projectResample = resample(projectTransform, delta2);
            return reset();
        }
        function reset() {
            cache = cacheStream = null;
            return projection;
        }
        return function() {
            project = projectAt.apply(this, arguments);
            projection.invert = project.invert && invert;
            return recenter();
        };
    }
    function conicProjection(projectAt) {
        var phi0 = 0, phi1 = pi$1 / 3, m = projectionMutator(projectAt), p = m(phi0, phi1);
        p.parallels = function(_) {
            return arguments.length ? m(phi0 = _[0] * radians, phi1 = _[1] * radians) : [
                phi0 * degrees,
                phi1 * degrees
            ];
        };
        return p;
    }
    function cylindricalEqualAreaRaw(phi0) {
        var cosPhi0 = cos$1(phi0);
        function forward(lambda, phi) {
            return [
                lambda * cosPhi0,
                sin$1(phi) / cosPhi0
            ];
        }
        forward.invert = function(x, y) {
            return [
                x / cosPhi0,
                asin$1(y * cosPhi0)
            ];
        };
        return forward;
    }
    function conicEqualAreaRaw(y0, y1) {
        var sy0 = sin$1(y0), n = (sy0 + sin$1(y1)) / 2;
        // Are the parallels symmetrical around the Equator?
        if (abs$1(n) < epsilon$1) return cylindricalEqualAreaRaw(y0);
        var c = 1 + sy0 * (2 * n - sy0), r0 = sqrt$2(c) / n;
        function project(x, y) {
            var r = sqrt$2(c - 2 * n * sin$1(y)) / n;
            return [
                r * sin$1(x *= n),
                r0 - r * cos$1(x)
            ];
        }
        project.invert = function(x, y) {
            var r0y = r0 - y, l = atan2$1(x, abs$1(r0y)) * sign$1(r0y);
            if (r0y * n < 0) l -= pi$1 * sign$1(x) * sign$1(r0y);
            return [
                l / n,
                asin$1((c - (x * x + r0y * r0y) * n * n) / (2 * n))
            ];
        };
        return project;
    }
    function conicEqualArea() {
        return conicProjection(conicEqualAreaRaw).scale(155.424).center([
            0,
            33.6442
        ]);
    }
    function albers() {
        return conicEqualArea().parallels([
            29.5,
            45.5
        ]).scale(1070).translate([
            480,
            250
        ]).rotate([
            96,
            0
        ]).center([
            -0.6,
            38.7
        ]);
    }
    // The projections must have mutually exclusive clip regions on the sphere,
    // as this will avoid emitting interleaving lines and polygons.
    function multiplex(streams) {
        var n = streams.length;
        return {
            point: function(x, y) {
                var i = -1;
                while(++i < n)streams[i].point(x, y);
            },
            sphere: function() {
                var i = -1;
                while(++i < n)streams[i].sphere();
            },
            lineStart: function() {
                var i = -1;
                while(++i < n)streams[i].lineStart();
            },
            lineEnd: function() {
                var i = -1;
                while(++i < n)streams[i].lineEnd();
            },
            polygonStart: function() {
                var i = -1;
                while(++i < n)streams[i].polygonStart();
            },
            polygonEnd: function() {
                var i = -1;
                while(++i < n)streams[i].polygonEnd();
            }
        };
    }
    // A composite projection for the United States, configured by default for
    // 960×500. The projection also works quite well at 960×600 if you change the
    // scale to 1285 and adjust the translate accordingly. The set of standard
    // parallels for each region comes from USGS, which is published here:
    // http://egsc.usgs.gov/isb/pubs/MapProjections/projections.html#albers
    function albersUsa() {
        var cache, cacheStream, lower48 = albers(), lower48Point, alaska = conicEqualArea().rotate([
            154,
            0
        ]).center([
            -2,
            58.5
        ]).parallels([
            55,
            65
        ]), alaskaPoint, hawaii = conicEqualArea().rotate([
            157,
            0
        ]).center([
            -3,
            19.9
        ]).parallels([
            8,
            18
        ]), hawaiiPoint, point, pointStream = {
            point: function(x, y) {
                point = [
                    x,
                    y
                ];
            }
        };
        function albersUsa(coordinates) {
            var x = coordinates[0], y = coordinates[1];
            return point = null, (lower48Point.point(x, y), point) || (alaskaPoint.point(x, y), point) || (hawaiiPoint.point(x, y), point);
        }
        albersUsa.invert = function(coordinates) {
            var k = lower48.scale(), t = lower48.translate(), x = (coordinates[0] - t[0]) / k, y = (coordinates[1] - t[1]) / k;
            return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii : lower48).invert(coordinates);
        };
        albersUsa.stream = function(stream) {
            return cache && cacheStream === stream ? cache : cache = multiplex([
                lower48.stream(cacheStream = stream),
                alaska.stream(stream),
                hawaii.stream(stream)
            ]);
        };
        albersUsa.precision = function(_) {
            if (!arguments.length) return lower48.precision();
            lower48.precision(_), alaska.precision(_), hawaii.precision(_);
            return reset();
        };
        albersUsa.scale = function(_) {
            if (!arguments.length) return lower48.scale();
            lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
            return albersUsa.translate(lower48.translate());
        };
        albersUsa.translate = function(_) {
            if (!arguments.length) return lower48.translate();
            var k = lower48.scale(), x = +_[0], y = +_[1];
            lower48Point = lower48.translate(_).clipExtent([
                [
                    x - 0.455 * k,
                    y - 0.238 * k
                ],
                [
                    x + 0.455 * k,
                    y + 0.238 * k
                ]
            ]).stream(pointStream);
            alaskaPoint = alaska.translate([
                x - 0.307 * k,
                y + 0.201 * k
            ]).clipExtent([
                [
                    x - 0.425 * k + epsilon$1,
                    y + 0.120 * k + epsilon$1
                ],
                [
                    x - 0.214 * k - epsilon$1,
                    y + 0.234 * k - epsilon$1
                ]
            ]).stream(pointStream);
            hawaiiPoint = hawaii.translate([
                x - 0.205 * k,
                y + 0.212 * k
            ]).clipExtent([
                [
                    x - 0.214 * k + epsilon$1,
                    y + 0.166 * k + epsilon$1
                ],
                [
                    x - 0.115 * k - epsilon$1,
                    y + 0.234 * k - epsilon$1
                ]
            ]).stream(pointStream);
            return reset();
        };
        albersUsa.fitExtent = function(extent, object) {
            return fitExtent(albersUsa, extent, object);
        };
        albersUsa.fitSize = function(size, object) {
            return fitSize(albersUsa, size, object);
        };
        albersUsa.fitWidth = function(width, object) {
            return fitWidth(albersUsa, width, object);
        };
        albersUsa.fitHeight = function(height, object) {
            return fitHeight(albersUsa, height, object);
        };
        function reset() {
            cache = cacheStream = null;
            return albersUsa;
        }
        return albersUsa.scale(1070);
    }
    function azimuthalRaw(scale) {
        return function(x, y) {
            var cx = cos$1(x), cy = cos$1(y), k = scale(cx * cy);
            if (k === Infinity) return [
                2,
                0
            ];
            return [
                k * cy * sin$1(x),
                k * sin$1(y)
            ];
        };
    }
    function azimuthalInvert(angle) {
        return function(x, y) {
            var z = sqrt$2(x * x + y * y), c = angle(z), sc = sin$1(c), cc = cos$1(c);
            return [
                atan2$1(x * sc, z * cc),
                asin$1(z && y * sc / z)
            ];
        };
    }
    var azimuthalEqualAreaRaw = azimuthalRaw(function(cxcy) {
        return sqrt$2(2 / (1 + cxcy));
    });
    azimuthalEqualAreaRaw.invert = azimuthalInvert(function(z) {
        return 2 * asin$1(z / 2);
    });
    function azimuthalEqualArea() {
        return projection(azimuthalEqualAreaRaw).scale(124.75).clipAngle(179.999);
    }
    var azimuthalEquidistantRaw = azimuthalRaw(function(c) {
        return (c = acos$1(c)) && c / sin$1(c);
    });
    azimuthalEquidistantRaw.invert = azimuthalInvert(function(z) {
        return z;
    });
    function azimuthalEquidistant() {
        return projection(azimuthalEquidistantRaw).scale(79.4188).clipAngle(179.999);
    }
    function mercatorRaw(lambda, phi) {
        return [
            lambda,
            log$1(tan((halfPi$1 + phi) / 2))
        ];
    }
    mercatorRaw.invert = function(x, y) {
        return [
            x,
            2 * atan(exp(y)) - halfPi$1
        ];
    };
    function mercator() {
        return mercatorProjection(mercatorRaw).scale(961 / tau$1);
    }
    function mercatorProjection(project) {
        var m = projection(project), center = m.center, scale = m.scale, translate = m.translate, clipExtent = m.clipExtent, x0 = null, y0, x1, y1; // clip extent
        m.scale = function(_) {
            return arguments.length ? (scale(_), reclip()) : scale();
        };
        m.translate = function(_) {
            return arguments.length ? (translate(_), reclip()) : translate();
        };
        m.center = function(_) {
            return arguments.length ? (center(_), reclip()) : center();
        };
        m.clipExtent = function(_) {
            return arguments.length ? (_ == null ? x0 = y0 = x1 = y1 = null : (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reclip()) : x0 == null ? null : [
                [
                    x0,
                    y0
                ],
                [
                    x1,
                    y1
                ]
            ];
        };
        function reclip() {
            var k = pi$1 * scale(), t = m(rotation(m.rotate()).invert([
                0,
                0
            ]));
            return clipExtent(x0 == null ? [
                [
                    t[0] - k,
                    t[1] - k
                ],
                [
                    t[0] + k,
                    t[1] + k
                ]
            ] : project === mercatorRaw ? [
                [
                    Math.max(t[0] - k, x0),
                    y0
                ],
                [
                    Math.min(t[0] + k, x1),
                    y1
                ]
            ] : [
                [
                    x0,
                    Math.max(t[1] - k, y0)
                ],
                [
                    x1,
                    Math.min(t[1] + k, y1)
                ]
            ]);
        }
        return reclip();
    }
    function tany(y) {
        return tan((halfPi$1 + y) / 2);
    }
    function conicConformalRaw(y0, y1) {
        var cy0 = cos$1(y0), n = y0 === y1 ? sin$1(y0) : log$1(cy0 / cos$1(y1)) / log$1(tany(y1) / tany(y0)), f = cy0 * pow$1(tany(y0), n) / n;
        if (!n) return mercatorRaw;
        function project(x, y) {
            if (f > 0) {
                if (y < -halfPi$1 + epsilon$1) y = -halfPi$1 + epsilon$1;
            } else if (y > halfPi$1 - epsilon$1) y = halfPi$1 - epsilon$1;
            var r = f / pow$1(tany(y), n);
            return [
                r * sin$1(n * x),
                f - r * cos$1(n * x)
            ];
        }
        project.invert = function(x, y) {
            var fy = f - y, r = sign$1(n) * sqrt$2(x * x + fy * fy), l = atan2$1(x, abs$1(fy)) * sign$1(fy);
            if (fy * n < 0) l -= pi$1 * sign$1(x) * sign$1(fy);
            return [
                l / n,
                2 * atan(pow$1(f / r, 1 / n)) - halfPi$1
            ];
        };
        return project;
    }
    function conicConformal() {
        return conicProjection(conicConformalRaw).scale(109.5).parallels([
            30,
            30
        ]);
    }
    function equirectangularRaw(lambda, phi) {
        return [
            lambda,
            phi
        ];
    }
    equirectangularRaw.invert = equirectangularRaw;
    function equirectangular() {
        return projection(equirectangularRaw).scale(152.63);
    }
    function conicEquidistantRaw(y0, y1) {
        var cy0 = cos$1(y0), n = y0 === y1 ? sin$1(y0) : (cy0 - cos$1(y1)) / (y1 - y0), g = cy0 / n + y0;
        if (abs$1(n) < epsilon$1) return equirectangularRaw;
        function project(x, y) {
            var gy = g - y, nx = n * x;
            return [
                gy * sin$1(nx),
                g - gy * cos$1(nx)
            ];
        }
        project.invert = function(x, y) {
            var gy = g - y, l = atan2$1(x, abs$1(gy)) * sign$1(gy);
            if (gy * n < 0) l -= pi$1 * sign$1(x) * sign$1(gy);
            return [
                l / n,
                g - sign$1(n) * sqrt$2(x * x + gy * gy)
            ];
        };
        return project;
    }
    function conicEquidistant() {
        return conicProjection(conicEquidistantRaw).scale(131.154).center([
            0,
            13.9389
        ]);
    }
    var A1 = 1.340264, A2 = -0.081106, A3 = 0.000893, A4 = 0.003796, M = sqrt$2(3) / 2, iterations = 12;
    function equalEarthRaw(lambda, phi) {
        var l = asin$1(M * sin$1(phi)), l2 = l * l, l6 = l2 * l2 * l2;
        return [
            lambda * cos$1(l) / (M * (A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2))),
            l * (A1 + A2 * l2 + l6 * (A3 + A4 * l2))
        ];
    }
    equalEarthRaw.invert = function(x, y) {
        var l = y, l2 = l * l, l6 = l2 * l2 * l2;
        for(var i = 0, delta, fy, fpy; i < iterations; ++i){
            fy = l * (A1 + A2 * l2 + l6 * (A3 + A4 * l2)) - y;
            fpy = A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2);
            l -= delta = fy / fpy, l2 = l * l, l6 = l2 * l2 * l2;
            if (abs$1(delta) < epsilon2) break;
        }
        return [
            M * x * (A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2)) / cos$1(l),
            asin$1(sin$1(l) / M)
        ];
    };
    function equalEarth() {
        return projection(equalEarthRaw).scale(177.158);
    }
    function gnomonicRaw(x, y) {
        var cy = cos$1(y), k = cos$1(x) * cy;
        return [
            cy * sin$1(x) / k,
            sin$1(y) / k
        ];
    }
    gnomonicRaw.invert = azimuthalInvert(atan);
    function gnomonic() {
        return projection(gnomonicRaw).scale(144.049).clipAngle(60);
    }
    function identity$4() {
        var k = 1, tx = 0, ty = 0, sx = 1, sy = 1, alpha = 0, ca, sa, x0 = null, y0, x1, y1, kx = 1, ky = 1, transform = transformer$3({
            point: function(x, y) {
                var p = projection([
                    x,
                    y
                ]);
                this.stream.point(p[0], p[1]);
            }
        }), postclip = identity$5, cache, cacheStream;
        function reset() {
            kx = k * sx;
            ky = k * sy;
            cache = cacheStream = null;
            return projection;
        }
        function projection(p) {
            var x = p[0] * kx, y = p[1] * ky;
            if (alpha) {
                var t = y * ca - x * sa;
                x = x * ca + y * sa;
                y = t;
            }
            return [
                x + tx,
                y + ty
            ];
        }
        projection.invert = function(p) {
            var x = p[0] - tx, y = p[1] - ty;
            if (alpha) {
                var t = y * ca + x * sa;
                x = x * ca - y * sa;
                y = t;
            }
            return [
                x / kx,
                y / ky
            ];
        };
        projection.stream = function(stream) {
            return cache && cacheStream === stream ? cache : cache = transform(postclip(cacheStream = stream));
        };
        projection.postclip = function(_) {
            return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
        };
        projection.clipExtent = function(_) {
            return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, identity$5) : clipRectangle(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [
                [
                    x0,
                    y0
                ],
                [
                    x1,
                    y1
                ]
            ];
        };
        projection.scale = function(_) {
            return arguments.length ? (k = +_, reset()) : k;
        };
        projection.translate = function(_) {
            return arguments.length ? (tx = +_[0], ty = +_[1], reset()) : [
                tx,
                ty
            ];
        };
        projection.angle = function(_) {
            return arguments.length ? (alpha = _ % 360 * radians, sa = sin$1(alpha), ca = cos$1(alpha), reset()) : alpha * degrees;
        };
        projection.reflectX = function(_) {
            return arguments.length ? (sx = _ ? -1 : 1, reset()) : sx < 0;
        };
        projection.reflectY = function(_) {
            return arguments.length ? (sy = _ ? -1 : 1, reset()) : sy < 0;
        };
        projection.fitExtent = function(extent, object) {
            return fitExtent(projection, extent, object);
        };
        projection.fitSize = function(size, object) {
            return fitSize(projection, size, object);
        };
        projection.fitWidth = function(width, object) {
            return fitWidth(projection, width, object);
        };
        projection.fitHeight = function(height, object) {
            return fitHeight(projection, height, object);
        };
        return projection;
    }
    function naturalEarth1Raw(lambda, phi) {
        var phi2 = phi * phi, phi4 = phi2 * phi2;
        return [
            lambda * (0.8707 - 0.131979 * phi2 + phi4 * (-0.013791 + phi4 * (0.003971 * phi2 - 0.001529 * phi4))),
            phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4)))
        ];
    }
    naturalEarth1Raw.invert = function(x, y) {
        var phi = y, i = 25, delta;
        do {
            var phi2 = phi * phi, phi4 = phi2 * phi2;
            phi -= delta = (phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4))) - y) / (1.007226 + phi2 * (0.045255 + phi4 * (-0.311325 + 0.259866 * phi2 - 0.005916 * 11 * phi4)));
        }while (abs$1(delta) > epsilon$1 && --i > 0);
        return [
            x / (0.8707 + (phi2 = phi * phi) * (-0.131979 + phi2 * (-0.013791 + phi2 * phi2 * phi2 * (0.003971 - 0.001529 * phi2)))),
            phi
        ];
    };
    function naturalEarth1() {
        return projection(naturalEarth1Raw).scale(175.295);
    }
    function orthographicRaw(x, y) {
        return [
            cos$1(y) * sin$1(x),
            sin$1(y)
        ];
    }
    orthographicRaw.invert = azimuthalInvert(asin$1);
    function orthographic() {
        return projection(orthographicRaw).scale(249.5).clipAngle(90 + epsilon$1);
    }
    function stereographicRaw(x, y) {
        var cy = cos$1(y), k = 1 + cos$1(x) * cy;
        return [
            cy * sin$1(x) / k,
            sin$1(y) / k
        ];
    }
    stereographicRaw.invert = azimuthalInvert(function(z) {
        return 2 * atan(z);
    });
    function stereographic() {
        return projection(stereographicRaw).scale(250).clipAngle(142);
    }
    function transverseMercatorRaw(lambda, phi) {
        return [
            log$1(tan((halfPi$1 + phi) / 2)),
            -lambda
        ];
    }
    transverseMercatorRaw.invert = function(x, y) {
        return [
            -y,
            2 * atan(exp(x)) - halfPi$1
        ];
    };
    function transverseMercator() {
        var m = mercatorProjection(transverseMercatorRaw), center = m.center, rotate = m.rotate;
        m.center = function(_) {
            return arguments.length ? center([
                -_[1],
                _[0]
            ]) : (_ = center(), [
                _[1],
                -_[0]
            ]);
        };
        m.rotate = function(_) {
            return arguments.length ? rotate([
                _[0],
                _[1],
                _.length > 2 ? _[2] + 90 : 90
            ]) : (_ = rotate(), [
                _[0],
                _[1],
                _[2] - 90
            ]);
        };
        return rotate([
            0,
            0,
            90
        ]).scale(159.155);
    }
    function defaultSeparation$1(a, b) {
        return a.parent === b.parent ? 1 : 2;
    }
    function meanX(children) {
        return children.reduce(meanXReduce, 0) / children.length;
    }
    function meanXReduce(x, c) {
        return x + c.x;
    }
    function maxY(children) {
        return 1 + children.reduce(maxYReduce, 0);
    }
    function maxYReduce(y, c) {
        return Math.max(y, c.y);
    }
    function leafLeft(node) {
        var children;
        while(children = node.children)node = children[0];
        return node;
    }
    function leafRight(node) {
        var children;
        while(children = node.children)node = children[children.length - 1];
        return node;
    }
    function cluster() {
        var separation = defaultSeparation$1, dx = 1, dy = 1, nodeSize = false;
        function cluster(root) {
            var previousNode, x = 0;
            // First walk, computing the initial x & y values.
            root.eachAfter(function(node) {
                var children = node.children;
                if (children) {
                    node.x = meanX(children);
                    node.y = maxY(children);
                } else {
                    node.x = previousNode ? x += separation(node, previousNode) : 0;
                    node.y = 0;
                    previousNode = node;
                }
            });
            var left = leafLeft(root), right = leafRight(root), x0 = left.x - separation(left, right) / 2, x1 = right.x + separation(right, left) / 2;
            // Second walk, normalizing x & y to the desired size.
            return root.eachAfter(nodeSize ? function(node) {
                node.x = (node.x - root.x) * dx;
                node.y = (root.y - node.y) * dy;
            } : function(node) {
                node.x = (node.x - x0) / (x1 - x0) * dx;
                node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
            });
        }
        cluster.separation = function(x) {
            return arguments.length ? (separation = x, cluster) : separation;
        };
        cluster.size = function(x) {
            return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], cluster) : nodeSize ? null : [
                dx,
                dy
            ];
        };
        cluster.nodeSize = function(x) {
            return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], cluster) : nodeSize ? [
                dx,
                dy
            ] : null;
        };
        return cluster;
    }
    function count(node) {
        var sum = 0, children = node.children, i = children && children.length;
        if (!i) sum = 1;
        else while(--i >= 0)sum += children[i].value;
        node.value = sum;
    }
    function node_count() {
        return this.eachAfter(count);
    }
    function node_each(callback, that) {
        let index = -1;
        for (const node of this)callback.call(that, node, ++index, this);
        return this;
    }
    function node_eachBefore(callback, that) {
        var node = this, nodes = [
            node
        ], children, i, index = -1;
        while(node = nodes.pop()){
            callback.call(that, node, ++index, this);
            if (children = node.children) for(i = children.length - 1; i >= 0; --i)nodes.push(children[i]);
        }
        return this;
    }
    function node_eachAfter(callback, that) {
        var node = this, nodes = [
            node
        ], next = [], children, i, n, index = -1;
        while(node = nodes.pop()){
            next.push(node);
            if (children = node.children) for(i = 0, n = children.length; i < n; ++i)nodes.push(children[i]);
        }
        while(node = next.pop())callback.call(that, node, ++index, this);
        return this;
    }
    function node_find(callback, that) {
        let index = -1;
        for (const node of this){
            if (callback.call(that, node, ++index, this)) return node;
        }
    }
    function node_sum(value) {
        return this.eachAfter(function(node) {
            var sum = +value(node.data) || 0, children = node.children, i = children && children.length;
            while(--i >= 0)sum += children[i].value;
            node.value = sum;
        });
    }
    function node_sort(compare) {
        return this.eachBefore(function(node) {
            if (node.children) node.children.sort(compare);
        });
    }
    function node_path(end) {
        var start = this, ancestor = leastCommonAncestor(start, end), nodes = [
            start
        ];
        while(start !== ancestor){
            start = start.parent;
            nodes.push(start);
        }
        var k = nodes.length;
        while(end !== ancestor){
            nodes.splice(k, 0, end);
            end = end.parent;
        }
        return nodes;
    }
    function leastCommonAncestor(a, b) {
        if (a === b) return a;
        var aNodes = a.ancestors(), bNodes = b.ancestors(), c = null;
        a = aNodes.pop();
        b = bNodes.pop();
        while(a === b){
            c = a;
            a = aNodes.pop();
            b = bNodes.pop();
        }
        return c;
    }
    function node_ancestors() {
        var node = this, nodes = [
            node
        ];
        while(node = node.parent)nodes.push(node);
        return nodes;
    }
    function node_descendants() {
        return Array.from(this);
    }
    function node_leaves() {
        var leaves = [];
        this.eachBefore(function(node) {
            if (!node.children) leaves.push(node);
        });
        return leaves;
    }
    function node_links() {
        var root = this, links = [];
        root.each(function(node) {
            if (node !== root) links.push({
                source: node.parent,
                target: node
            });
        });
        return links;
    }
    function* node_iterator() {
        var node = this, current, next = [
            node
        ], children, i, n;
        do {
            current = next.reverse(), next = [];
            while(node = current.pop()){
                yield node;
                if (children = node.children) for(i = 0, n = children.length; i < n; ++i)next.push(children[i]);
            }
        }while (next.length);
    }
    function hierarchy(data, children) {
        if (data instanceof Map) {
            data = [
                undefined,
                data
            ];
            if (children === undefined) children = mapChildren;
        } else if (children === undefined) children = objectChildren;
        var root = new Node$1(data), node, nodes = [
            root
        ], child, childs, i, n;
        while(node = nodes.pop())if ((childs = children(node.data)) && (n = (childs = Array.from(childs)).length)) {
            node.children = childs;
            for(i = n - 1; i >= 0; --i){
                nodes.push(child = childs[i] = new Node$1(childs[i]));
                child.parent = node;
                child.depth = node.depth + 1;
            }
        }
        return root.eachBefore(computeHeight);
    }
    function node_copy() {
        return hierarchy(this).eachBefore(copyData);
    }
    function objectChildren(d) {
        return d.children;
    }
    function mapChildren(d) {
        return Array.isArray(d) ? d[1] : null;
    }
    function copyData(node) {
        if (node.data.value !== undefined) node.value = node.data.value;
        node.data = node.data.data;
    }
    function computeHeight(node) {
        var height = 0;
        do node.height = height;
        while ((node = node.parent) && node.height < ++height);
    }
    function Node$1(data) {
        this.data = data;
        this.depth = this.height = 0;
        this.parent = null;
    }
    Node$1.prototype = hierarchy.prototype = {
        constructor: Node$1,
        count: node_count,
        each: node_each,
        eachAfter: node_eachAfter,
        eachBefore: node_eachBefore,
        find: node_find,
        sum: node_sum,
        sort: node_sort,
        path: node_path,
        ancestors: node_ancestors,
        descendants: node_descendants,
        leaves: node_leaves,
        links: node_links,
        copy: node_copy,
        [Symbol.iterator]: node_iterator
    };
    function optional(f) {
        return f == null ? null : required(f);
    }
    function required(f) {
        if (typeof f !== "function") throw new Error;
        return f;
    }
    function constantZero() {
        return 0;
    }
    function constant$2(x) {
        return function() {
            return x;
        };
    }
    // https://en.wikipedia.org/wiki/Linear_congruential_generator#Parameters_in_common_use
    const a$1 = 1664525;
    const c$3 = 1013904223;
    const m = 4294967296; // 2^32
    function lcg$1() {
        let s = 1;
        return ()=>(s = (a$1 * s + c$3) % m) / m;
    }
    function array$1(x) {
        return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
         : Array.from(x); // Map, Set, iterable, string, or anything else
    }
    function shuffle(array, random) {
        let m = array.length, t, i;
        while(m){
            i = random() * m-- | 0;
            t = array[m];
            array[m] = array[i];
            array[i] = t;
        }
        return array;
    }
    function enclose(circles) {
        return packEncloseRandom(circles, lcg$1());
    }
    function packEncloseRandom(circles, random) {
        var i = 0, n = (circles = shuffle(Array.from(circles), random)).length, B = [], p, e;
        while(i < n){
            p = circles[i];
            if (e && enclosesWeak(e, p)) ++i;
            else e = encloseBasis(B = extendBasis(B, p)), i = 0;
        }
        return e;
    }
    function extendBasis(B, p) {
        var i, j;
        if (enclosesWeakAll(p, B)) return [
            p
        ];
        // If we get here then B must have at least one element.
        for(i = 0; i < B.length; ++i){
            if (enclosesNot(p, B[i]) && enclosesWeakAll(encloseBasis2(B[i], p), B)) return [
                B[i],
                p
            ];
        }
        // If we get here then B must have at least two elements.
        for(i = 0; i < B.length - 1; ++i)for(j = i + 1; j < B.length; ++j){
            if (enclosesNot(encloseBasis2(B[i], B[j]), p) && enclosesNot(encloseBasis2(B[i], p), B[j]) && enclosesNot(encloseBasis2(B[j], p), B[i]) && enclosesWeakAll(encloseBasis3(B[i], B[j], p), B)) return [
                B[i],
                B[j],
                p
            ];
        }
        // If we get here then something is very wrong.
        throw new Error;
    }
    function enclosesNot(a, b) {
        var dr = a.r - b.r, dx = b.x - a.x, dy = b.y - a.y;
        return dr < 0 || dr * dr < dx * dx + dy * dy;
    }
    function enclosesWeak(a, b) {
        var dr = a.r - b.r + Math.max(a.r, b.r, 1) * 1e-9, dx = b.x - a.x, dy = b.y - a.y;
        return dr > 0 && dr * dr > dx * dx + dy * dy;
    }
    function enclosesWeakAll(a, B) {
        for(var i = 0; i < B.length; ++i){
            if (!enclosesWeak(a, B[i])) return false;
        }
        return true;
    }
    function encloseBasis(B) {
        switch(B.length){
            case 1:
                return encloseBasis1(B[0]);
            case 2:
                return encloseBasis2(B[0], B[1]);
            case 3:
                return encloseBasis3(B[0], B[1], B[2]);
        }
    }
    function encloseBasis1(a) {
        return {
            x: a.x,
            y: a.y,
            r: a.r
        };
    }
    function encloseBasis2(a, b) {
        var x1 = a.x, y1 = a.y, r1 = a.r, x2 = b.x, y2 = b.y, r2 = b.r, x21 = x2 - x1, y21 = y2 - y1, r21 = r2 - r1, l = Math.sqrt(x21 * x21 + y21 * y21);
        return {
            x: (x1 + x2 + x21 / l * r21) / 2,
            y: (y1 + y2 + y21 / l * r21) / 2,
            r: (l + r1 + r2) / 2
        };
    }
    function encloseBasis3(a, b, c) {
        var x1 = a.x, y1 = a.y, r1 = a.r, x2 = b.x, y2 = b.y, r2 = b.r, x3 = c.x, y3 = c.y, r3 = c.r, a2 = x1 - x2, a3 = x1 - x3, b2 = y1 - y2, b3 = y1 - y3, c2 = r2 - r1, c3 = r3 - r1, d1 = x1 * x1 + y1 * y1 - r1 * r1, d2 = d1 - x2 * x2 - y2 * y2 + r2 * r2, d3 = d1 - x3 * x3 - y3 * y3 + r3 * r3, ab = a3 * b2 - a2 * b3, xa = (b2 * d3 - b3 * d2) / (ab * 2) - x1, xb = (b3 * c2 - b2 * c3) / ab, ya = (a3 * d2 - a2 * d3) / (ab * 2) - y1, yb = (a2 * c3 - a3 * c2) / ab, A = xb * xb + yb * yb - 1, B = 2 * (r1 + xa * xb + ya * yb), C = xa * xa + ya * ya - r1 * r1, r = -(Math.abs(A) > 1e-6 ? (B + Math.sqrt(B * B - 4 * A * C)) / (2 * A) : C / B);
        return {
            x: x1 + xa + xb * r,
            y: y1 + ya + yb * r,
            r: r
        };
    }
    function place(b, a, c) {
        var dx = b.x - a.x, x, a2, dy = b.y - a.y, y, b2, d2 = dx * dx + dy * dy;
        if (d2) {
            a2 = a.r + c.r, a2 *= a2;
            b2 = b.r + c.r, b2 *= b2;
            if (a2 > b2) {
                x = (d2 + b2 - a2) / (2 * d2);
                y = Math.sqrt(Math.max(0, b2 / d2 - x * x));
                c.x = b.x - x * dx - y * dy;
                c.y = b.y - x * dy + y * dx;
            } else {
                x = (d2 + a2 - b2) / (2 * d2);
                y = Math.sqrt(Math.max(0, a2 / d2 - x * x));
                c.x = a.x + x * dx - y * dy;
                c.y = a.y + x * dy + y * dx;
            }
        } else {
            c.x = a.x + c.r;
            c.y = a.y;
        }
    }
    function intersects(a, b) {
        var dr = a.r + b.r - 1e-6, dx = b.x - a.x, dy = b.y - a.y;
        return dr > 0 && dr * dr > dx * dx + dy * dy;
    }
    function score(node) {
        var a = node._, b = node.next._, ab = a.r + b.r, dx = (a.x * b.r + b.x * a.r) / ab, dy = (a.y * b.r + b.y * a.r) / ab;
        return dx * dx + dy * dy;
    }
    function Node(circle) {
        this._ = circle;
        this.next = null;
        this.previous = null;
    }
    function packSiblingsRandom(circles, random) {
        if (!(n = (circles = array$1(circles)).length)) return 0;
        var a, b, c, n, aa, ca, i, j, k, sj, sk;
        // Place the first circle.
        a = circles[0], a.x = 0, a.y = 0;
        if (!(n > 1)) return a.r;
        // Place the second circle.
        b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
        if (!(n > 2)) return a.r + b.r;
        // Place the third circle.
        place(b, a, c = circles[2]);
        // Initialize the front-chain using the first three circles a, b and c.
        a = new Node(a), b = new Node(b), c = new Node(c);
        a.next = c.previous = b;
        b.next = a.previous = c;
        c.next = b.previous = a;
        // Attempt to place each remaining circle…
        pack: for(i = 3; i < n; ++i){
            place(a._, b._, c = circles[i]), c = new Node(c);
            // Find the closest intersecting circle on the front-chain, if any.
            // “Closeness” is determined by linear distance along the front-chain.
            // “Ahead” or “behind” is likewise determined by linear distance.
            j = b.next, k = a.previous, sj = b._.r, sk = a._.r;
            do if (sj <= sk) {
                if (intersects(j._, c._)) {
                    b = j, a.next = b, b.previous = a, --i;
                    continue pack;
                }
                sj += j._.r, j = j.next;
            } else {
                if (intersects(k._, c._)) {
                    a = k, a.next = b, b.previous = a, --i;
                    continue pack;
                }
                sk += k._.r, k = k.previous;
            }
            while (j !== k.next);
            // Success! Insert the new circle c between a and b.
            c.previous = a, c.next = b, a.next = b.previous = b = c;
            // Compute the new closest circle pair to the centroid.
            aa = score(a);
            while((c = c.next) !== b)if ((ca = score(c)) < aa) a = c, aa = ca;
            b = a.next;
        }
        // Compute the enclosing circle of the front chain.
        a = [
            b._
        ], c = b;
        while((c = c.next) !== b)a.push(c._);
        c = packEncloseRandom(a, random);
        // Translate the circles to put the enclosing circle around the origin.
        for(i = 0; i < n; ++i)a = circles[i], a.x -= c.x, a.y -= c.y;
        return c.r;
    }
    function siblings(circles) {
        packSiblingsRandom(circles, lcg$1());
        return circles;
    }
    function defaultRadius(d) {
        return Math.sqrt(d.value);
    }
    function index$1() {
        var radius = null, dx = 1, dy = 1, padding = constantZero;
        function pack(root) {
            const random = lcg$1();
            root.x = dx / 2, root.y = dy / 2;
            if (radius) root.eachBefore(radiusLeaf(radius)).eachAfter(packChildrenRandom(padding, 0.5, random)).eachBefore(translateChild(1));
            else root.eachBefore(radiusLeaf(defaultRadius)).eachAfter(packChildrenRandom(constantZero, 1, random)).eachAfter(packChildrenRandom(padding, root.r / Math.min(dx, dy), random)).eachBefore(translateChild(Math.min(dx, dy) / (2 * root.r)));
            return root;
        }
        pack.radius = function(x) {
            return arguments.length ? (radius = optional(x), pack) : radius;
        };
        pack.size = function(x) {
            return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [
                dx,
                dy
            ];
        };
        pack.padding = function(x) {
            return arguments.length ? (padding = typeof x === "function" ? x : constant$2(+x), pack) : padding;
        };
        return pack;
    }
    function radiusLeaf(radius) {
        return function(node) {
            if (!node.children) node.r = Math.max(0, +radius(node) || 0);
        };
    }
    function packChildrenRandom(padding, k, random) {
        return function(node) {
            if (children = node.children) {
                var children, i, n = children.length, r = padding(node) * k || 0, e;
                if (r) for(i = 0; i < n; ++i)children[i].r += r;
                e = packSiblingsRandom(children, random);
                if (r) for(i = 0; i < n; ++i)children[i].r -= r;
                node.r = e + r;
            }
        };
    }
    function translateChild(k) {
        return function(node) {
            var parent = node.parent;
            node.r *= k;
            if (parent) {
                node.x = parent.x + k * node.x;
                node.y = parent.y + k * node.y;
            }
        };
    }
    function roundNode(node) {
        node.x0 = Math.round(node.x0);
        node.y0 = Math.round(node.y0);
        node.x1 = Math.round(node.x1);
        node.y1 = Math.round(node.y1);
    }
    function treemapDice(parent, x0, y0, x1, y1) {
        var nodes = parent.children, node, i = -1, n = nodes.length, k = parent.value && (x1 - x0) / parent.value;
        while(++i < n){
            node = nodes[i], node.y0 = y0, node.y1 = y1;
            node.x0 = x0, node.x1 = x0 += node.value * k;
        }
    }
    function partition() {
        var dx = 1, dy = 1, padding = 0, round = false;
        function partition(root) {
            var n = root.height + 1;
            root.x0 = root.y0 = padding;
            root.x1 = dx;
            root.y1 = dy / n;
            root.eachBefore(positionNode(dy, n));
            if (round) root.eachBefore(roundNode);
            return root;
        }
        function positionNode(dy, n) {
            return function(node) {
                if (node.children) treemapDice(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
                var x0 = node.x0, y0 = node.y0, x1 = node.x1 - padding, y1 = node.y1 - padding;
                if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
                if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
                node.x0 = x0;
                node.y0 = y0;
                node.x1 = x1;
                node.y1 = y1;
            };
        }
        partition.round = function(x) {
            return arguments.length ? (round = !!x, partition) : round;
        };
        partition.size = function(x) {
            return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [
                dx,
                dy
            ];
        };
        partition.padding = function(x) {
            return arguments.length ? (padding = +x, partition) : padding;
        };
        return partition;
    }
    var preroot = {
        depth: -1
    }, ambiguous = {}, imputed = {};
    function defaultId(d) {
        return d.id;
    }
    function defaultParentId(d) {
        return d.parentId;
    }
    function stratify() {
        var id = defaultId, parentId = defaultParentId, path;
        function stratify(data) {
            var nodes = Array.from(data), currentId = id, currentParentId = parentId, n, d, i, root, parent, node, nodeId, nodeKey, nodeByKey = new Map;
            if (path != null) {
                const I = nodes.map((d, i)=>normalize$1(path(d, i, data)));
                const P = I.map(parentof);
                const S = new Set(I).add("");
                for (const i of P)if (!S.has(i)) {
                    S.add(i);
                    I.push(i);
                    P.push(parentof(i));
                    nodes.push(imputed);
                }
                currentId = (_, i)=>I[i];
                currentParentId = (_, i)=>P[i];
            }
            for(i = 0, n = nodes.length; i < n; ++i){
                d = nodes[i], node = nodes[i] = new Node$1(d);
                if ((nodeId = currentId(d, i, data)) != null && (nodeId += "")) {
                    nodeKey = node.id = nodeId;
                    nodeByKey.set(nodeKey, nodeByKey.has(nodeKey) ? ambiguous : node);
                }
                if ((nodeId = currentParentId(d, i, data)) != null && (nodeId += "")) node.parent = nodeId;
            }
            for(i = 0; i < n; ++i){
                node = nodes[i];
                if (nodeId = node.parent) {
                    parent = nodeByKey.get(nodeId);
                    if (!parent) throw new Error("missing: " + nodeId);
                    if (parent === ambiguous) throw new Error("ambiguous: " + nodeId);
                    if (parent.children) parent.children.push(node);
                    else parent.children = [
                        node
                    ];
                    node.parent = parent;
                } else {
                    if (root) throw new Error("multiple roots");
                    root = node;
                }
            }
            if (!root) throw new Error("no root");
            // When imputing internal nodes, only introduce roots if needed.
            // Then replace the imputed marker data with null.
            if (path != null) {
                while(root.data === imputed && root.children.length === 1)root = root.children[0], --n;
                for(let i = nodes.length - 1; i >= 0; --i){
                    node = nodes[i];
                    if (node.data !== imputed) break;
                    node.data = null;
                }
            }
            root.parent = preroot;
            root.eachBefore(function(node) {
                node.depth = node.parent.depth + 1;
                --n;
            }).eachBefore(computeHeight);
            root.parent = null;
            if (n > 0) throw new Error("cycle");
            return root;
        }
        stratify.id = function(x) {
            return arguments.length ? (id = optional(x), stratify) : id;
        };
        stratify.parentId = function(x) {
            return arguments.length ? (parentId = optional(x), stratify) : parentId;
        };
        stratify.path = function(x) {
            return arguments.length ? (path = optional(x), stratify) : path;
        };
        return stratify;
    }
    // To normalize a path, we coerce to a string, strip the trailing slash if any
    // (as long as the trailing slash is not immediately preceded by another slash),
    // and add leading slash if missing.
    function normalize$1(path) {
        path = `${path}`;
        let i = path.length;
        if (slash(path, i - 1) && !slash(path, i - 2)) path = path.slice(0, -1);
        return path[0] === "/" ? path : `/${path}`;
    }
    // Walk backwards to find the first slash that is not the leading slash, e.g.:
    // "/foo/bar" ⇥ "/foo", "/foo" ⇥ "/", "/" ↦ "". (The root is special-cased
    // because the id of the root must be a truthy value.)
    function parentof(path) {
        let i = path.length;
        if (i < 2) return "";
        while(--i > 1)if (slash(path, i)) break;
        return path.slice(0, i);
    }
    // Slashes can be escaped; to determine whether a slash is a path delimiter, we
    // count the number of preceding backslashes escaping the forward slash: an odd
    // number indicates an escaped forward slash.
    function slash(path, i) {
        if (path[i] === "/") {
            let k = 0;
            while(i > 0 && path[--i] === "\\")++k;
            if ((k & 1) === 0) return true;
        }
        return false;
    }
    function defaultSeparation(a, b) {
        return a.parent === b.parent ? 1 : 2;
    }
    // function radialSeparation(a, b) {
    //   return (a.parent === b.parent ? 1 : 2) / a.depth;
    // }
    // This function is used to traverse the left contour of a subtree (or
    // subforest). It returns the successor of v on this contour. This successor is
    // either given by the leftmost child of v or by the thread of v. The function
    // returns null if and only if v is on the highest level of its subtree.
    function nextLeft(v) {
        var children = v.children;
        return children ? children[0] : v.t;
    }
    // This function works analogously to nextLeft.
    function nextRight(v) {
        var children = v.children;
        return children ? children[children.length - 1] : v.t;
    }
    // Shifts the current subtree rooted at w+. This is done by increasing
    // prelim(w+) and mod(w+) by shift.
    function moveSubtree(wm, wp, shift) {
        var change = shift / (wp.i - wm.i);
        wp.c -= change;
        wp.s += shift;
        wm.c += change;
        wp.z += shift;
        wp.m += shift;
    }
    // All other shifts, applied to the smaller subtrees between w- and w+, are
    // performed by this function. To prepare the shifts, we have to adjust
    // change(w+), shift(w+), and change(w-).
    function executeShifts(v) {
        var shift = 0, change = 0, children = v.children, i = children.length, w;
        while(--i >= 0){
            w = children[i];
            w.z += shift;
            w.m += shift;
            shift += w.s + (change += w.c);
        }
    }
    // If vi-’s ancestor is a sibling of v, returns vi-’s ancestor. Otherwise,
    // returns the specified (default) ancestor.
    function nextAncestor(vim, v, ancestor) {
        return vim.a.parent === v.parent ? vim.a : ancestor;
    }
    function TreeNode(node, i) {
        this._ = node;
        this.parent = null;
        this.children = null;
        this.A = null; // default ancestor
        this.a = this; // ancestor
        this.z = 0; // prelim
        this.m = 0; // mod
        this.c = 0; // change
        this.s = 0; // shift
        this.t = null; // thread
        this.i = i; // number
    }
    TreeNode.prototype = Object.create(Node$1.prototype);
    function treeRoot(root) {
        var tree = new TreeNode(root, 0), node, nodes = [
            tree
        ], child, children, i, n;
        while(node = nodes.pop())if (children = node._.children) {
            node.children = new Array(n = children.length);
            for(i = n - 1; i >= 0; --i){
                nodes.push(child = node.children[i] = new TreeNode(children[i], i));
                child.parent = node;
            }
        }
        (tree.parent = new TreeNode(null, 0)).children = [
            tree
        ];
        return tree;
    }
    // Node-link tree diagram using the Reingold-Tilford "tidy" algorithm
    function tree() {
        var separation = defaultSeparation, dx = 1, dy = 1, nodeSize = null;
        function tree(root) {
            var t = treeRoot(root);
            // Compute the layout using Buchheim et al.’s algorithm.
            t.eachAfter(firstWalk), t.parent.m = -t.z;
            t.eachBefore(secondWalk);
            // If a fixed node size is specified, scale x and y.
            if (nodeSize) root.eachBefore(sizeNode);
            else {
                var left = root, right = root, bottom = root;
                root.eachBefore(function(node) {
                    if (node.x < left.x) left = node;
                    if (node.x > right.x) right = node;
                    if (node.depth > bottom.depth) bottom = node;
                });
                var s = left === right ? 1 : separation(left, right) / 2, tx = s - left.x, kx = dx / (right.x + s + tx), ky = dy / (bottom.depth || 1);
                root.eachBefore(function(node) {
                    node.x = (node.x + tx) * kx;
                    node.y = node.depth * ky;
                });
            }
            return root;
        }
        // Computes a preliminary x-coordinate for v. Before that, FIRST WALK is
        // applied recursively to the children of v, as well as the function
        // APPORTION. After spacing out the children by calling EXECUTE SHIFTS, the
        // node v is placed to the midpoint of its outermost children.
        function firstWalk(v) {
            var children = v.children, siblings = v.parent.children, w = v.i ? siblings[v.i - 1] : null;
            if (children) {
                executeShifts(v);
                var midpoint = (children[0].z + children[children.length - 1].z) / 2;
                if (w) {
                    v.z = w.z + separation(v._, w._);
                    v.m = v.z - midpoint;
                } else v.z = midpoint;
            } else if (w) v.z = w.z + separation(v._, w._);
            v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
        }
        // Computes all real x-coordinates by summing up the modifiers recursively.
        function secondWalk(v) {
            v._.x = v.z + v.parent.m;
            v.m += v.parent.m;
        }
        // The core of the algorithm. Here, a new subtree is combined with the
        // previous subtrees. Threads are used to traverse the inside and outside
        // contours of the left and right subtree up to the highest common level. The
        // vertices used for the traversals are vi+, vi-, vo-, and vo+, where the
        // superscript o means outside and i means inside, the subscript - means left
        // subtree and + means right subtree. For summing up the modifiers along the
        // contour, we use respective variables si+, si-, so-, and so+. Whenever two
        // nodes of the inside contours conflict, we compute the left one of the
        // greatest uncommon ancestors using the function ANCESTOR and call MOVE
        // SUBTREE to shift the subtree and prepare the shifts of smaller subtrees.
        // Finally, we add a new thread (if necessary).
        function apportion(v, w, ancestor) {
            if (w) {
                var vip = v, vop = v, vim = w, vom = vip.parent.children[0], sip = vip.m, sop = vop.m, sim = vim.m, som = vom.m, shift;
                while(vim = nextRight(vim), vip = nextLeft(vip), vim && vip){
                    vom = nextLeft(vom);
                    vop = nextRight(vop);
                    vop.a = v;
                    shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
                    if (shift > 0) {
                        moveSubtree(nextAncestor(vim, v, ancestor), v, shift);
                        sip += shift;
                        sop += shift;
                    }
                    sim += vim.m;
                    sip += vip.m;
                    som += vom.m;
                    sop += vop.m;
                }
                if (vim && !nextRight(vop)) {
                    vop.t = vim;
                    vop.m += sim - sop;
                }
                if (vip && !nextLeft(vom)) {
                    vom.t = vip;
                    vom.m += sip - som;
                    ancestor = v;
                }
            }
            return ancestor;
        }
        function sizeNode(node) {
            node.x *= dx;
            node.y = node.depth * dy;
        }
        tree.separation = function(x) {
            return arguments.length ? (separation = x, tree) : separation;
        };
        tree.size = function(x) {
            return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], tree) : nodeSize ? null : [
                dx,
                dy
            ];
        };
        tree.nodeSize = function(x) {
            return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], tree) : nodeSize ? [
                dx,
                dy
            ] : null;
        };
        return tree;
    }
    function treemapSlice(parent, x0, y0, x1, y1) {
        var nodes = parent.children, node, i = -1, n = nodes.length, k = parent.value && (y1 - y0) / parent.value;
        while(++i < n){
            node = nodes[i], node.x0 = x0, node.x1 = x1;
            node.y0 = y0, node.y1 = y0 += node.value * k;
        }
    }
    var phi = (1 + Math.sqrt(5)) / 2;
    function squarifyRatio(ratio, parent, x0, y0, x1, y1) {
        var rows = [], nodes = parent.children, row, nodeValue, i0 = 0, i1 = 0, n = nodes.length, dx, dy, value = parent.value, sumValue, minValue, maxValue, newRatio, minRatio, alpha, beta;
        while(i0 < n){
            dx = x1 - x0, dy = y1 - y0;
            // Find the next non-empty node.
            do sumValue = nodes[i1++].value;
            while (!sumValue && i1 < n);
            minValue = maxValue = sumValue;
            alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
            beta = sumValue * sumValue * alpha;
            minRatio = Math.max(maxValue / beta, beta / minValue);
            // Keep adding nodes while the aspect ratio maintains or improves.
            for(; i1 < n; ++i1){
                sumValue += nodeValue = nodes[i1].value;
                if (nodeValue < minValue) minValue = nodeValue;
                if (nodeValue > maxValue) maxValue = nodeValue;
                beta = sumValue * sumValue * alpha;
                newRatio = Math.max(maxValue / beta, beta / minValue);
                if (newRatio > minRatio) {
                    sumValue -= nodeValue;
                    break;
                }
                minRatio = newRatio;
            }
            // Position and record the row orientation.
            rows.push(row = {
                value: sumValue,
                dice: dx < dy,
                children: nodes.slice(i0, i1)
            });
            if (row.dice) treemapDice(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
            else treemapSlice(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
            value -= sumValue, i0 = i1;
        }
        return rows;
    }
    var squarify = function custom(ratio) {
        function squarify(parent, x0, y0, x1, y1) {
            squarifyRatio(ratio, parent, x0, y0, x1, y1);
        }
        squarify.ratio = function(x) {
            return custom((x = +x) > 1 ? x : 1);
        };
        return squarify;
    }(phi);
    function index() {
        var tile = squarify, round = false, dx = 1, dy = 1, paddingStack = [
            0
        ], paddingInner = constantZero, paddingTop = constantZero, paddingRight = constantZero, paddingBottom = constantZero, paddingLeft = constantZero;
        function treemap(root) {
            root.x0 = root.y0 = 0;
            root.x1 = dx;
            root.y1 = dy;
            root.eachBefore(positionNode);
            paddingStack = [
                0
            ];
            if (round) root.eachBefore(roundNode);
            return root;
        }
        function positionNode(node) {
            var p = paddingStack[node.depth], x0 = node.x0 + p, y0 = node.y0 + p, x1 = node.x1 - p, y1 = node.y1 - p;
            if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
            if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
            node.x0 = x0;
            node.y0 = y0;
            node.x1 = x1;
            node.y1 = y1;
            if (node.children) {
                p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
                x0 += paddingLeft(node) - p;
                y0 += paddingTop(node) - p;
                x1 -= paddingRight(node) - p;
                y1 -= paddingBottom(node) - p;
                if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
                if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
                tile(node, x0, y0, x1, y1);
            }
        }
        treemap.round = function(x) {
            return arguments.length ? (round = !!x, treemap) : round;
        };
        treemap.size = function(x) {
            return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [
                dx,
                dy
            ];
        };
        treemap.tile = function(x) {
            return arguments.length ? (tile = required(x), treemap) : tile;
        };
        treemap.padding = function(x) {
            return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
        };
        treemap.paddingInner = function(x) {
            return arguments.length ? (paddingInner = typeof x === "function" ? x : constant$2(+x), treemap) : paddingInner;
        };
        treemap.paddingOuter = function(x) {
            return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
        };
        treemap.paddingTop = function(x) {
            return arguments.length ? (paddingTop = typeof x === "function" ? x : constant$2(+x), treemap) : paddingTop;
        };
        treemap.paddingRight = function(x) {
            return arguments.length ? (paddingRight = typeof x === "function" ? x : constant$2(+x), treemap) : paddingRight;
        };
        treemap.paddingBottom = function(x) {
            return arguments.length ? (paddingBottom = typeof x === "function" ? x : constant$2(+x), treemap) : paddingBottom;
        };
        treemap.paddingLeft = function(x) {
            return arguments.length ? (paddingLeft = typeof x === "function" ? x : constant$2(+x), treemap) : paddingLeft;
        };
        return treemap;
    }
    function binary(parent, x0, y0, x1, y1) {
        var nodes = parent.children, i, n = nodes.length, sum, sums = new Array(n + 1);
        for(sums[0] = sum = i = 0; i < n; ++i)sums[i + 1] = sum += nodes[i].value;
        partition(0, n, parent.value, x0, y0, x1, y1);
        function partition(i, j, value, x0, y0, x1, y1) {
            if (i >= j - 1) {
                var node = nodes[i];
                node.x0 = x0, node.y0 = y0;
                node.x1 = x1, node.y1 = y1;
                return;
            }
            var valueOffset = sums[i], valueTarget = value / 2 + valueOffset, k = i + 1, hi = j - 1;
            while(k < hi){
                var mid = k + hi >>> 1;
                if (sums[mid] < valueTarget) k = mid + 1;
                else hi = mid;
            }
            if (valueTarget - sums[k - 1] < sums[k] - valueTarget && i + 1 < k) --k;
            var valueLeft = sums[k] - valueOffset, valueRight = value - valueLeft;
            if (x1 - x0 > y1 - y0) {
                var xk = value ? (x0 * valueRight + x1 * valueLeft) / value : x1;
                partition(i, k, valueLeft, x0, y0, xk, y1);
                partition(k, j, valueRight, xk, y0, x1, y1);
            } else {
                var yk = value ? (y0 * valueRight + y1 * valueLeft) / value : y1;
                partition(i, k, valueLeft, x0, y0, x1, yk);
                partition(k, j, valueRight, x0, yk, x1, y1);
            }
        }
    }
    function sliceDice(parent, x0, y0, x1, y1) {
        (parent.depth & 1 ? treemapSlice : treemapDice)(parent, x0, y0, x1, y1);
    }
    var resquarify = function custom(ratio) {
        function resquarify(parent, x0, y0, x1, y1) {
            if ((rows = parent._squarify) && rows.ratio === ratio) {
                var rows, row, nodes, i, j = -1, n, m = rows.length, value = parent.value;
                while(++j < m){
                    row = rows[j], nodes = row.children;
                    for(i = row.value = 0, n = nodes.length; i < n; ++i)row.value += nodes[i].value;
                    if (row.dice) treemapDice(row, x0, y0, x1, value ? y0 += (y1 - y0) * row.value / value : y1);
                    else treemapSlice(row, x0, y0, value ? x0 += (x1 - x0) * row.value / value : x1, y1);
                    value -= row.value;
                }
            } else {
                parent._squarify = rows = squarifyRatio(ratio, parent, x0, y0, x1, y1);
                rows.ratio = ratio;
            }
        }
        resquarify.ratio = function(x) {
            return custom((x = +x) > 1 ? x : 1);
        };
        return resquarify;
    }(phi);
    function area$1(polygon) {
        var i = -1, n = polygon.length, a, b = polygon[n - 1], area = 0;
        while(++i < n){
            a = b;
            b = polygon[i];
            area += a[1] * b[0] - a[0] * b[1];
        }
        return area / 2;
    }
    function centroid(polygon) {
        var i = -1, n = polygon.length, x = 0, y = 0, a, b = polygon[n - 1], c, k = 0;
        while(++i < n){
            a = b;
            b = polygon[i];
            k += c = a[0] * b[1] - b[0] * a[1];
            x += (a[0] + b[0]) * c;
            y += (a[1] + b[1]) * c;
        }
        return k *= 3, [
            x / k,
            y / k
        ];
    }
    // Returns the 2D cross product of AB and AC vectors, i.e., the z-component of
    // the 3D cross product in a quadrant I Cartesian coordinate system (+x is
    // right, +y is up). Returns a positive value if ABC is counter-clockwise,
    // negative if clockwise, and zero if the points are collinear.
    function cross$1(a, b, c) {
        return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
    }
    function lexicographicOrder(a, b) {
        return a[0] - b[0] || a[1] - b[1];
    }
    // Computes the upper convex hull per the monotone chain algorithm.
    // Assumes points.length >= 3, is sorted by x, unique in y.
    // Returns an array of indices into points in left-to-right order.
    function computeUpperHullIndexes(points) {
        const n = points.length, indexes = [
            0,
            1
        ];
        let size = 2, i;
        for(i = 2; i < n; ++i){
            while(size > 1 && cross$1(points[indexes[size - 2]], points[indexes[size - 1]], points[i]) <= 0)--size;
            indexes[size++] = i;
        }
        return indexes.slice(0, size); // remove popped points
    }
    function hull(points) {
        if ((n = points.length) < 3) return null;
        var i, n, sortedPoints = new Array(n), flippedPoints = new Array(n);
        for(i = 0; i < n; ++i)sortedPoints[i] = [
            +points[i][0],
            +points[i][1],
            i
        ];
        sortedPoints.sort(lexicographicOrder);
        for(i = 0; i < n; ++i)flippedPoints[i] = [
            sortedPoints[i][0],
            -sortedPoints[i][1]
        ];
        var upperIndexes = computeUpperHullIndexes(sortedPoints), lowerIndexes = computeUpperHullIndexes(flippedPoints);
        // Construct the hull polygon, removing possible duplicate endpoints.
        var skipLeft = lowerIndexes[0] === upperIndexes[0], skipRight = lowerIndexes[lowerIndexes.length - 1] === upperIndexes[upperIndexes.length - 1], hull = [];
        // Add upper hull in right-to-l order.
        // Then add lower hull in left-to-right order.
        for(i = upperIndexes.length - 1; i >= 0; --i)hull.push(points[sortedPoints[upperIndexes[i]][2]]);
        for(i = +skipLeft; i < lowerIndexes.length - skipRight; ++i)hull.push(points[sortedPoints[lowerIndexes[i]][2]]);
        return hull;
    }
    function contains(polygon, point) {
        var n = polygon.length, p = polygon[n - 1], x = point[0], y = point[1], x0 = p[0], y0 = p[1], x1, y1, inside = false;
        for(var i = 0; i < n; ++i){
            p = polygon[i], x1 = p[0], y1 = p[1];
            if (y1 > y !== y0 > y && x < (x0 - x1) * (y - y1) / (y0 - y1) + x1) inside = !inside;
            x0 = x1, y0 = y1;
        }
        return inside;
    }
    function length(polygon) {
        var i = -1, n = polygon.length, b = polygon[n - 1], xa, ya, xb = b[0], yb = b[1], perimeter = 0;
        while(++i < n){
            xa = xb;
            ya = yb;
            b = polygon[i];
            xb = b[0];
            yb = b[1];
            xa -= xb;
            ya -= yb;
            perimeter += Math.hypot(xa, ya);
        }
        return perimeter;
    }
    var defaultSource = Math.random;
    var uniform = function sourceRandomUniform(source) {
        function randomUniform(min, max) {
            min = min == null ? 0 : +min;
            max = max == null ? 1 : +max;
            if (arguments.length === 1) max = min, min = 0;
            else max -= min;
            return function() {
                return source() * max + min;
            };
        }
        randomUniform.source = sourceRandomUniform;
        return randomUniform;
    }(defaultSource);
    var int = function sourceRandomInt(source) {
        function randomInt(min, max) {
            if (arguments.length < 2) max = min, min = 0;
            min = Math.floor(min);
            max = Math.floor(max) - min;
            return function() {
                return Math.floor(source() * max + min);
            };
        }
        randomInt.source = sourceRandomInt;
        return randomInt;
    }(defaultSource);
    var normal = function sourceRandomNormal(source) {
        function randomNormal(mu, sigma) {
            var x, r;
            mu = mu == null ? 0 : +mu;
            sigma = sigma == null ? 1 : +sigma;
            return function() {
                var y;
                // If available, use the second previously-generated uniform random.
                if (x != null) y = x, x = null;
                else do {
                    x = source() * 2 - 1;
                    y = source() * 2 - 1;
                    r = x * x + y * y;
                }while (!r || r > 1);
                return mu + sigma * y * Math.sqrt(-2 * Math.log(r) / r);
            };
        }
        randomNormal.source = sourceRandomNormal;
        return randomNormal;
    }(defaultSource);
    var logNormal = function sourceRandomLogNormal(source) {
        var N = normal.source(source);
        function randomLogNormal() {
            var randomNormal = N.apply(this, arguments);
            return function() {
                return Math.exp(randomNormal());
            };
        }
        randomLogNormal.source = sourceRandomLogNormal;
        return randomLogNormal;
    }(defaultSource);
    var irwinHall = function sourceRandomIrwinHall(source) {
        function randomIrwinHall(n) {
            if ((n = +n) <= 0) return ()=>0;
            return function() {
                for(var sum = 0, i = n; i > 1; --i)sum += source();
                return sum + i * source();
            };
        }
        randomIrwinHall.source = sourceRandomIrwinHall;
        return randomIrwinHall;
    }(defaultSource);
    var bates = function sourceRandomBates(source) {
        var I = irwinHall.source(source);
        function randomBates(n) {
            // use limiting distribution at n === 0
            if ((n = +n) === 0) return source;
            var randomIrwinHall = I(n);
            return function() {
                return randomIrwinHall() / n;
            };
        }
        randomBates.source = sourceRandomBates;
        return randomBates;
    }(defaultSource);
    var exponential = function sourceRandomExponential(source) {
        function randomExponential(lambda) {
            return function() {
                return -Math.log1p(-source()) / lambda;
            };
        }
        randomExponential.source = sourceRandomExponential;
        return randomExponential;
    }(defaultSource);
    var pareto = function sourceRandomPareto(source) {
        function randomPareto(alpha) {
            if ((alpha = +alpha) < 0) throw new RangeError("invalid alpha");
            alpha = 1 / -alpha;
            return function() {
                return Math.pow(1 - source(), alpha);
            };
        }
        randomPareto.source = sourceRandomPareto;
        return randomPareto;
    }(defaultSource);
    var bernoulli = function sourceRandomBernoulli(source) {
        function randomBernoulli(p) {
            if ((p = +p) < 0 || p > 1) throw new RangeError("invalid p");
            return function() {
                return Math.floor(source() + p);
            };
        }
        randomBernoulli.source = sourceRandomBernoulli;
        return randomBernoulli;
    }(defaultSource);
    var geometric = function sourceRandomGeometric(source) {
        function randomGeometric(p) {
            if ((p = +p) < 0 || p > 1) throw new RangeError("invalid p");
            if (p === 0) return ()=>Infinity;
            if (p === 1) return ()=>1;
            p = Math.log1p(-p);
            return function() {
                return 1 + Math.floor(Math.log1p(-source()) / p);
            };
        }
        randomGeometric.source = sourceRandomGeometric;
        return randomGeometric;
    }(defaultSource);
    var gamma = function sourceRandomGamma(source) {
        var randomNormal = normal.source(source)();
        function randomGamma(k, theta) {
            if ((k = +k) < 0) throw new RangeError("invalid k");
            // degenerate distribution if k === 0
            if (k === 0) return ()=>0;
            theta = theta == null ? 1 : +theta;
            // exponential distribution if k === 1
            if (k === 1) return ()=>-Math.log1p(-source()) * theta;
            var d = (k < 1 ? k + 1 : k) - 1 / 3, c = 1 / (3 * Math.sqrt(d)), multiplier = k < 1 ? ()=>Math.pow(source(), 1 / k) : ()=>1;
            return function() {
                do {
                    do var x = randomNormal(), v = 1 + c * x;
                    while (v <= 0);
                    v *= v * v;
                    var u = 1 - source();
                }while (u >= 1 - 0.0331 * x * x * x * x && Math.log(u) >= 0.5 * x * x + d * (1 - v + Math.log(v)));
                return d * v * multiplier() * theta;
            };
        }
        randomGamma.source = sourceRandomGamma;
        return randomGamma;
    }(defaultSource);
    var beta = function sourceRandomBeta(source) {
        var G = gamma.source(source);
        function randomBeta(alpha, beta) {
            var X = G(alpha), Y = G(beta);
            return function() {
                var x = X();
                return x === 0 ? 0 : x / (x + Y());
            };
        }
        randomBeta.source = sourceRandomBeta;
        return randomBeta;
    }(defaultSource);
    var binomial = function sourceRandomBinomial(source) {
        var G = geometric.source(source), B = beta.source(source);
        function randomBinomial(n, p) {
            n = +n;
            if ((p = +p) >= 1) return ()=>n;
            if (p <= 0) return ()=>0;
            return function() {
                var acc = 0, nn = n, pp = p;
                while(nn * pp > 16 && nn * (1 - pp) > 16){
                    var i = Math.floor((nn + 1) * pp), y = B(i, nn - i + 1)();
                    if (y <= pp) {
                        acc += i;
                        nn -= i;
                        pp = (pp - y) / (1 - y);
                    } else {
                        nn = i - 1;
                        pp /= y;
                    }
                }
                var sign = pp < 0.5, pFinal = sign ? pp : 1 - pp, g = G(pFinal);
                for(var s = g(), k = 0; s <= nn; ++k)s += g();
                return acc + (sign ? k : nn - k);
            };
        }
        randomBinomial.source = sourceRandomBinomial;
        return randomBinomial;
    }(defaultSource);
    var weibull = function sourceRandomWeibull(source) {
        function randomWeibull(k, a, b) {
            var outerFunc;
            if ((k = +k) === 0) outerFunc = (x)=>-Math.log(x);
            else {
                k = 1 / k;
                outerFunc = (x)=>Math.pow(x, k);
            }
            a = a == null ? 0 : +a;
            b = b == null ? 1 : +b;
            return function() {
                return a + b * outerFunc(-Math.log1p(-source()));
            };
        }
        randomWeibull.source = sourceRandomWeibull;
        return randomWeibull;
    }(defaultSource);
    var cauchy = function sourceRandomCauchy(source) {
        function randomCauchy(a, b) {
            a = a == null ? 0 : +a;
            b = b == null ? 1 : +b;
            return function() {
                return a + b * Math.tan(Math.PI * source());
            };
        }
        randomCauchy.source = sourceRandomCauchy;
        return randomCauchy;
    }(defaultSource);
    var logistic = function sourceRandomLogistic(source) {
        function randomLogistic(a, b) {
            a = a == null ? 0 : +a;
            b = b == null ? 1 : +b;
            return function() {
                var u = source();
                return a + b * Math.log(u / (1 - u));
            };
        }
        randomLogistic.source = sourceRandomLogistic;
        return randomLogistic;
    }(defaultSource);
    var poisson = function sourceRandomPoisson(source) {
        var G = gamma.source(source), B = binomial.source(source);
        function randomPoisson(lambda) {
            return function() {
                var acc = 0, l = lambda;
                while(l > 16){
                    var n = Math.floor(0.875 * l), t = G(n)();
                    if (t > l) return acc + B(n - 1, l / t)();
                    acc += n;
                    l -= t;
                }
                for(var s = -Math.log1p(-source()), k = 0; s <= l; ++k)s -= Math.log1p(-source());
                return acc + k;
            };
        }
        randomPoisson.source = sourceRandomPoisson;
        return randomPoisson;
    }(defaultSource);
    // https://en.wikipedia.org/wiki/Linear_congruential_generator#Parameters_in_common_use
    const mul = 0x19660D;
    const inc = 0x3C6EF35F;
    const eps = 1 / 0x100000000;
    function lcg(seed = Math.random()) {
        let state = (0 <= seed && seed < 1 ? seed / eps : Math.abs(seed)) | 0;
        return ()=>(state = mul * state + inc | 0, eps * (state >>> 0));
    }
    function initRange(domain, range) {
        switch(arguments.length){
            case 0:
                break;
            case 1:
                this.range(domain);
                break;
            default:
                this.range(range).domain(domain);
                break;
        }
        return this;
    }
    function initInterpolator(domain, interpolator) {
        switch(arguments.length){
            case 0:
                break;
            case 1:
                if (typeof domain === "function") this.interpolator(domain);
                else this.range(domain);
                break;
            default:
                this.domain(domain);
                if (typeof interpolator === "function") this.interpolator(interpolator);
                else this.range(interpolator);
                break;
        }
        return this;
    }
    const implicit = Symbol("implicit");
    function ordinal() {
        var index = new InternMap(), domain = [], range = [], unknown = implicit;
        function scale(d) {
            let i = index.get(d);
            if (i === undefined) {
                if (unknown !== implicit) return unknown;
                index.set(d, i = domain.push(d) - 1);
            }
            return range[i % range.length];
        }
        scale.domain = function(_) {
            if (!arguments.length) return domain.slice();
            domain = [], index = new InternMap();
            for (const value of _){
                if (index.has(value)) continue;
                index.set(value, domain.push(value) - 1);
            }
            return scale;
        };
        scale.range = function(_) {
            return arguments.length ? (range = Array.from(_), scale) : range.slice();
        };
        scale.unknown = function(_) {
            return arguments.length ? (unknown = _, scale) : unknown;
        };
        scale.copy = function() {
            return ordinal(domain, range).unknown(unknown);
        };
        initRange.apply(scale, arguments);
        return scale;
    }
    function band() {
        var scale = ordinal().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
        delete scale.unknown;
        function rescale() {
            var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
            step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
            if (round) step = Math.floor(step);
            start += (stop - start - step * (n - paddingInner)) * align;
            bandwidth = step * (1 - paddingInner);
            if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
            var values = range$2(n).map(function(i) {
                return start + step * i;
            });
            return ordinalRange(reverse ? values.reverse() : values);
        }
        scale.domain = function(_) {
            return arguments.length ? (domain(_), rescale()) : domain();
        };
        scale.range = function(_) {
            return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
                r0,
                r1
            ];
        };
        scale.rangeRound = function(_) {
            return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
        };
        scale.bandwidth = function() {
            return bandwidth;
        };
        scale.step = function() {
            return step;
        };
        scale.round = function(_) {
            return arguments.length ? (round = !!_, rescale()) : round;
        };
        scale.padding = function(_) {
            return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
        };
        scale.paddingInner = function(_) {
            return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
        };
        scale.paddingOuter = function(_) {
            return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
        };
        scale.align = function(_) {
            return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
        };
        scale.copy = function() {
            return band(domain(), [
                r0,
                r1
            ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
        };
        return initRange.apply(rescale(), arguments);
    }
    function pointish(scale) {
        var copy = scale.copy;
        scale.padding = scale.paddingOuter;
        delete scale.paddingInner;
        delete scale.paddingOuter;
        scale.copy = function() {
            return pointish(copy());
        };
        return scale;
    }
    function point$4() {
        return pointish(band.apply(null, arguments).paddingInner(1));
    }
    function constants(x) {
        return function() {
            return x;
        };
    }
    function number$1(x) {
        return +x;
    }
    var unit = [
        0,
        1
    ];
    function identity$3(x) {
        return x;
    }
    function normalize(a, b) {
        return (b -= a = +a) ? function(x) {
            return (x - a) / b;
        } : constants(isNaN(b) ? NaN : 0.5);
    }
    function clamper(a, b) {
        var t;
        if (a > b) t = a, a = b, b = t;
        return function(x) {
            return Math.max(a, Math.min(b, x));
        };
    }
    // normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
    // interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
    function bimap(domain, range, interpolate) {
        var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
        if (d1 < d0) d0 = normalize(d1, d0), r0 = interpolate(r1, r0);
        else d0 = normalize(d0, d1), r0 = interpolate(r0, r1);
        return function(x) {
            return r0(d0(x));
        };
    }
    function polymap(domain, range, interpolate) {
        var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
        // Reverse descending domains.
        if (domain[j] < domain[0]) {
            domain = domain.slice().reverse();
            range = range.slice().reverse();
        }
        while(++i < j){
            d[i] = normalize(domain[i], domain[i + 1]);
            r[i] = interpolate(range[i], range[i + 1]);
        }
        return function(x) {
            var i = bisect(domain, x, 1, j) - 1;
            return r[i](d[i](x));
        };
    }
    function copy$1(source, target) {
        return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
    }
    function transformer$2() {
        var domain = unit, range = unit, interpolate = interpolate$2, transform, untransform, unknown, clamp = identity$3, piecewise, output, input;
        function rescale() {
            var n = Math.min(domain.length, range.length);
            if (clamp !== identity$3) clamp = clamper(domain[0], domain[n - 1]);
            piecewise = n > 2 ? polymap : bimap;
            output = input = null;
            return scale;
        }
        function scale(x) {
            return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
        }
        scale.invert = function(y) {
            return clamp(untransform((input || (input = piecewise(range, domain.map(transform), interpolateNumber)))(y)));
        };
        scale.domain = function(_) {
            return arguments.length ? (domain = Array.from(_, number$1), rescale()) : domain.slice();
        };
        scale.range = function(_) {
            return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
        };
        scale.rangeRound = function(_) {
            return range = Array.from(_), interpolate = interpolateRound, rescale();
        };
        scale.clamp = function(_) {
            return arguments.length ? (clamp = _ ? true : identity$3, rescale()) : clamp !== identity$3;
        };
        scale.interpolate = function(_) {
            return arguments.length ? (interpolate = _, rescale()) : interpolate;
        };
        scale.unknown = function(_) {
            return arguments.length ? (unknown = _, scale) : unknown;
        };
        return function(t, u) {
            transform = t, untransform = u;
            return rescale();
        };
    }
    function continuous() {
        return transformer$2()(identity$3, identity$3);
    }
    function tickFormat(start, stop, count, specifier) {
        var step = tickStep(start, stop, count), precision;
        specifier = formatSpecifier(specifier == null ? ",f" : specifier);
        switch(specifier.type){
            case "s":
                var value = Math.max(Math.abs(start), Math.abs(stop));
                if (specifier.precision == null && !isNaN(precision = precisionPrefix(step, value))) specifier.precision = precision;
                return exports1.formatPrefix(specifier, value);
            case "":
            case "e":
            case "g":
            case "p":
            case "r":
                if (specifier.precision == null && !isNaN(precision = precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
                break;
            case "f":
            case "%":
                if (specifier.precision == null && !isNaN(precision = precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
                break;
        }
        return exports1.format(specifier);
    }
    function linearish(scale) {
        var domain = scale.domain;
        scale.ticks = function(count) {
            var d = domain();
            return ticks(d[0], d[d.length - 1], count == null ? 10 : count);
        };
        scale.tickFormat = function(count, specifier) {
            var d = domain();
            return tickFormat(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
        };
        scale.nice = function(count) {
            if (count == null) count = 10;
            var d = domain();
            var i0 = 0;
            var i1 = d.length - 1;
            var start = d[i0];
            var stop = d[i1];
            var prestep;
            var step;
            var maxIter = 10;
            if (stop < start) {
                step = start, start = stop, stop = step;
                step = i0, i0 = i1, i1 = step;
            }
            while(maxIter-- > 0){
                step = tickIncrement(start, stop, count);
                if (step === prestep) {
                    d[i0] = start;
                    d[i1] = stop;
                    return domain(d);
                } else if (step > 0) {
                    start = Math.floor(start / step) * step;
                    stop = Math.ceil(stop / step) * step;
                } else if (step < 0) {
                    start = Math.ceil(start * step) / step;
                    stop = Math.floor(stop * step) / step;
                } else break;
                prestep = step;
            }
            return scale;
        };
        return scale;
    }
    function linear() {
        var scale = continuous();
        scale.copy = function() {
            return copy$1(scale, linear());
        };
        initRange.apply(scale, arguments);
        return linearish(scale);
    }
    function identity$2(domain) {
        var unknown;
        function scale(x) {
            return x == null || isNaN(x = +x) ? unknown : x;
        }
        scale.invert = scale;
        scale.domain = scale.range = function(_) {
            return arguments.length ? (domain = Array.from(_, number$1), scale) : domain.slice();
        };
        scale.unknown = function(_) {
            return arguments.length ? (unknown = _, scale) : unknown;
        };
        scale.copy = function() {
            return identity$2(domain).unknown(unknown);
        };
        domain = arguments.length ? Array.from(domain, number$1) : [
            0,
            1
        ];
        return linearish(scale);
    }
    function nice(domain, interval) {
        domain = domain.slice();
        var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
        if (x1 < x0) {
            t = i0, i0 = i1, i1 = t;
            t = x0, x0 = x1, x1 = t;
        }
        domain[i0] = interval.floor(x0);
        domain[i1] = interval.ceil(x1);
        return domain;
    }
    function transformLog(x) {
        return Math.log(x);
    }
    function transformExp(x) {
        return Math.exp(x);
    }
    function transformLogn(x) {
        return -Math.log(-x);
    }
    function transformExpn(x) {
        return -Math.exp(-x);
    }
    function pow10(x) {
        return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
    }
    function powp(base) {
        return base === 10 ? pow10 : base === Math.E ? Math.exp : (x)=>Math.pow(base, x);
    }
    function logp(base) {
        return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x)=>Math.log(x) / base);
    }
    function reflect(f) {
        return (x, k)=>-f(-x, k);
    }
    function loggish(transform) {
        const scale = transform(transformLog, transformExp);
        const domain = scale.domain;
        let base = 10;
        let logs;
        let pows;
        function rescale() {
            logs = logp(base), pows = powp(base);
            if (domain()[0] < 0) {
                logs = reflect(logs), pows = reflect(pows);
                transform(transformLogn, transformExpn);
            } else transform(transformLog, transformExp);
            return scale;
        }
        scale.base = function(_) {
            return arguments.length ? (base = +_, rescale()) : base;
        };
        scale.domain = function(_) {
            return arguments.length ? (domain(_), rescale()) : domain();
        };
        scale.ticks = (count)=>{
            const d = domain();
            let u = d[0];
            let v = d[d.length - 1];
            const r = v < u;
            if (r) [u, v] = [
                v,
                u
            ];
            let i = logs(u);
            let j = logs(v);
            let k;
            let t;
            const n = count == null ? 10 : +count;
            let z = [];
            if (!(base % 1) && j - i < n) {
                i = Math.floor(i), j = Math.ceil(j);
                if (u > 0) for(; i <= j; ++i)for(k = 1; k < base; ++k){
                    t = i < 0 ? k / pows(-i) : k * pows(i);
                    if (t < u) continue;
                    if (t > v) break;
                    z.push(t);
                }
                else for(; i <= j; ++i)for(k = base - 1; k >= 1; --k){
                    t = i > 0 ? k / pows(-i) : k * pows(i);
                    if (t < u) continue;
                    if (t > v) break;
                    z.push(t);
                }
                if (z.length * 2 < n) z = ticks(u, v, n);
            } else z = ticks(i, j, Math.min(j - i, n)).map(pows);
            return r ? z.reverse() : z;
        };
        scale.tickFormat = (count, specifier)=>{
            if (count == null) count = 10;
            if (specifier == null) specifier = base === 10 ? "s" : ",";
            if (typeof specifier !== "function") {
                if (!(base % 1) && (specifier = formatSpecifier(specifier)).precision == null) specifier.trim = true;
                specifier = exports1.format(specifier);
            }
            if (count === Infinity) return specifier;
            const k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
            return (d)=>{
                let i = d / pows(Math.round(logs(d)));
                if (i * base < base - 0.5) i *= base;
                return i <= k ? specifier(d) : "";
            };
        };
        scale.nice = ()=>{
            return domain(nice(domain(), {
                floor: (x)=>pows(Math.floor(logs(x))),
                ceil: (x)=>pows(Math.ceil(logs(x)))
            }));
        };
        return scale;
    }
    function log() {
        const scale = loggish(transformer$2()).domain([
            1,
            10
        ]);
        scale.copy = ()=>copy$1(scale, log()).base(scale.base());
        initRange.apply(scale, arguments);
        return scale;
    }
    function transformSymlog(c) {
        return function(x) {
            return Math.sign(x) * Math.log1p(Math.abs(x / c));
        };
    }
    function transformSymexp(c) {
        return function(x) {
            return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
        };
    }
    function symlogish(transform) {
        var c = 1, scale = transform(transformSymlog(c), transformSymexp(c));
        scale.constant = function(_) {
            return arguments.length ? transform(transformSymlog(c = +_), transformSymexp(c)) : c;
        };
        return linearish(scale);
    }
    function symlog() {
        var scale = symlogish(transformer$2());
        scale.copy = function() {
            return copy$1(scale, symlog()).constant(scale.constant());
        };
        return initRange.apply(scale, arguments);
    }
    function transformPow(exponent) {
        return function(x) {
            return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
        };
    }
    function transformSqrt(x) {
        return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
    }
    function transformSquare(x) {
        return x < 0 ? -x * x : x * x;
    }
    function powish(transform) {
        var scale = transform(identity$3, identity$3), exponent = 1;
        function rescale() {
            return exponent === 1 ? transform(identity$3, identity$3) : exponent === 0.5 ? transform(transformSqrt, transformSquare) : transform(transformPow(exponent), transformPow(1 / exponent));
        }
        scale.exponent = function(_) {
            return arguments.length ? (exponent = +_, rescale()) : exponent;
        };
        return linearish(scale);
    }
    function pow() {
        var scale = powish(transformer$2());
        scale.copy = function() {
            return copy$1(scale, pow()).exponent(scale.exponent());
        };
        initRange.apply(scale, arguments);
        return scale;
    }
    function sqrt$1() {
        return pow.apply(null, arguments).exponent(0.5);
    }
    function square$1(x) {
        return Math.sign(x) * x * x;
    }
    function unsquare(x) {
        return Math.sign(x) * Math.sqrt(Math.abs(x));
    }
    function radial() {
        var squared = continuous(), range = [
            0,
            1
        ], round = false, unknown;
        function scale(x) {
            var y = unsquare(squared(x));
            return isNaN(y) ? unknown : round ? Math.round(y) : y;
        }
        scale.invert = function(y) {
            return squared.invert(square$1(y));
        };
        scale.domain = function(_) {
            return arguments.length ? (squared.domain(_), scale) : squared.domain();
        };
        scale.range = function(_) {
            return arguments.length ? (squared.range((range = Array.from(_, number$1)).map(square$1)), scale) : range.slice();
        };
        scale.rangeRound = function(_) {
            return scale.range(_).round(true);
        };
        scale.round = function(_) {
            return arguments.length ? (round = !!_, scale) : round;
        };
        scale.clamp = function(_) {
            return arguments.length ? (squared.clamp(_), scale) : squared.clamp();
        };
        scale.unknown = function(_) {
            return arguments.length ? (unknown = _, scale) : unknown;
        };
        scale.copy = function() {
            return radial(squared.domain(), range).round(round).clamp(squared.clamp()).unknown(unknown);
        };
        initRange.apply(scale, arguments);
        return linearish(scale);
    }
    function quantile() {
        var domain = [], range = [], thresholds = [], unknown;
        function rescale() {
            var i = 0, n = Math.max(1, range.length);
            thresholds = new Array(n - 1);
            while(++i < n)thresholds[i - 1] = quantileSorted(domain, i / n);
            return scale;
        }
        function scale(x) {
            return x == null || isNaN(x = +x) ? unknown : range[bisect(thresholds, x)];
        }
        scale.invertExtent = function(y) {
            var i = range.indexOf(y);
            return i < 0 ? [
                NaN,
                NaN
            ] : [
                i > 0 ? thresholds[i - 1] : domain[0],
                i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
            ];
        };
        scale.domain = function(_) {
            if (!arguments.length) return domain.slice();
            domain = [];
            for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
            domain.sort(ascending$3);
            return rescale();
        };
        scale.range = function(_) {
            return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
        };
        scale.unknown = function(_) {
            return arguments.length ? (unknown = _, scale) : unknown;
        };
        scale.quantiles = function() {
            return thresholds.slice();
        };
        scale.copy = function() {
            return quantile().domain(domain).range(range).unknown(unknown);
        };
        return initRange.apply(scale, arguments);
    }
    function quantize() {
        var x0 = 0, x1 = 1, n = 1, domain = [
            0.5
        ], range = [
            0,
            1
        ], unknown;
        function scale(x) {
            return x != null && x <= x ? range[bisect(domain, x, 0, n)] : unknown;
        }
        function rescale() {
            var i = -1;
            domain = new Array(n);
            while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
            return scale;
        }
        scale.domain = function(_) {
            return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [
                x0,
                x1
            ];
        };
        scale.range = function(_) {
            return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
        };
        scale.invertExtent = function(y) {
            var i = range.indexOf(y);
            return i < 0 ? [
                NaN,
                NaN
            ] : i < 1 ? [
                x0,
                domain[0]
            ] : i >= n ? [
                domain[n - 1],
                x1
            ] : [
                domain[i - 1],
                domain[i]
            ];
        };
        scale.unknown = function(_) {
            return arguments.length ? (unknown = _, scale) : scale;
        };
        scale.thresholds = function() {
            return domain.slice();
        };
        scale.copy = function() {
            return quantize().domain([
                x0,
                x1
            ]).range(range).unknown(unknown);
        };
        return initRange.apply(linearish(scale), arguments);
    }
    function threshold() {
        var domain = [
            0.5
        ], range = [
            0,
            1
        ], unknown, n = 1;
        function scale(x) {
            return x != null && x <= x ? range[bisect(domain, x, 0, n)] : unknown;
        }
        scale.domain = function(_) {
            return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
        };
        scale.range = function(_) {
            return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
        };
        scale.invertExtent = function(y) {
            var i = range.indexOf(y);
            return [
                domain[i - 1],
                domain[i]
            ];
        };
        scale.unknown = function(_) {
            return arguments.length ? (unknown = _, scale) : unknown;
        };
        scale.copy = function() {
            return threshold().domain(domain).range(range).unknown(unknown);
        };
        return initRange.apply(scale, arguments);
    }
    const t0 = new Date, t1 = new Date;
    function timeInterval(floori, offseti, count, field) {
        function interval(date) {
            return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
        }
        interval.floor = (date)=>{
            return floori(date = new Date(+date)), date;
        };
        interval.ceil = (date)=>{
            return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
        };
        interval.round = (date)=>{
            const d0 = interval(date), d1 = interval.ceil(date);
            return date - d0 < d1 - date ? d0 : d1;
        };
        interval.offset = (date, step)=>{
            return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
        };
        interval.range = (start, stop, step)=>{
            const range = [];
            start = interval.ceil(start);
            step = step == null ? 1 : Math.floor(step);
            if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
            let previous;
            do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
            while (previous < start && start < stop);
            return range;
        };
        interval.filter = (test)=>{
            return timeInterval((date)=>{
                if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
            }, (date, step)=>{
                if (date >= date) {
                    if (step < 0) while(++step <= 0){
                        while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                    }
                    else while(--step >= 0){
                        while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                    }
                }
            });
        };
        if (count) {
            interval.count = (start, end)=>{
                t0.setTime(+start), t1.setTime(+end);
                floori(t0), floori(t1);
                return Math.floor(count(t0, t1));
            };
            interval.every = (step)=>{
                step = Math.floor(step);
                return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? (d)=>field(d) % step === 0 : (d)=>interval.count(0, d) % step === 0);
            };
        }
        return interval;
    }
    const millisecond = timeInterval(()=>{
    // noop
    }, (date, step)=>{
        date.setTime(+date + step);
    }, (start, end)=>{
        return end - start;
    });
    // An optimized implementation for this simple case.
    millisecond.every = (k)=>{
        k = Math.floor(k);
        if (!isFinite(k) || !(k > 0)) return null;
        if (!(k > 1)) return millisecond;
        return timeInterval((date)=>{
            date.setTime(Math.floor(date / k) * k);
        }, (date, step)=>{
            date.setTime(+date + step * k);
        }, (start, end)=>{
            return (end - start) / k;
        });
    };
    const milliseconds = millisecond.range;
    const durationSecond = 1000;
    const durationMinute = durationSecond * 60;
    const durationHour = durationMinute * 60;
    const durationDay = durationHour * 24;
    const durationWeek = durationDay * 7;
    const durationMonth = durationDay * 30;
    const durationYear = durationDay * 365;
    const second = timeInterval((date)=>{
        date.setTime(date - date.getMilliseconds());
    }, (date, step)=>{
        date.setTime(+date + step * durationSecond);
    }, (start, end)=>{
        return (end - start) / durationSecond;
    }, (date)=>{
        return date.getUTCSeconds();
    });
    const seconds = second.range;
    const timeMinute = timeInterval((date)=>{
        date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond);
    }, (date, step)=>{
        date.setTime(+date + step * durationMinute);
    }, (start, end)=>{
        return (end - start) / durationMinute;
    }, (date)=>{
        return date.getMinutes();
    });
    const timeMinutes = timeMinute.range;
    const utcMinute = timeInterval((date)=>{
        date.setUTCSeconds(0, 0);
    }, (date, step)=>{
        date.setTime(+date + step * durationMinute);
    }, (start, end)=>{
        return (end - start) / durationMinute;
    }, (date)=>{
        return date.getUTCMinutes();
    });
    const utcMinutes = utcMinute.range;
    const timeHour = timeInterval((date)=>{
        date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond - date.getMinutes() * durationMinute);
    }, (date, step)=>{
        date.setTime(+date + step * durationHour);
    }, (start, end)=>{
        return (end - start) / durationHour;
    }, (date)=>{
        return date.getHours();
    });
    const timeHours = timeHour.range;
    const utcHour = timeInterval((date)=>{
        date.setUTCMinutes(0, 0, 0);
    }, (date, step)=>{
        date.setTime(+date + step * durationHour);
    }, (start, end)=>{
        return (end - start) / durationHour;
    }, (date)=>{
        return date.getUTCHours();
    });
    const utcHours = utcHour.range;
    const timeDay = timeInterval((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationDay, (date)=>date.getDate() - 1);
    const timeDays = timeDay.range;
    const utcDay = timeInterval((date)=>{
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCDate(date.getUTCDate() + step);
    }, (start, end)=>{
        return (end - start) / durationDay;
    }, (date)=>{
        return date.getUTCDate() - 1;
    });
    const utcDays = utcDay.range;
    const unixDay = timeInterval((date)=>{
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCDate(date.getUTCDate() + step);
    }, (start, end)=>{
        return (end - start) / durationDay;
    }, (date)=>{
        return Math.floor(date / durationDay);
    });
    const unixDays = unixDay.range;
    function timeWeekday(i) {
        return timeInterval((date)=>{
            date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
            date.setHours(0, 0, 0, 0);
        }, (date, step)=>{
            date.setDate(date.getDate() + step * 7);
        }, (start, end)=>{
            return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationWeek;
        });
    }
    const timeSunday = timeWeekday(0);
    const timeMonday = timeWeekday(1);
    const timeTuesday = timeWeekday(2);
    const timeWednesday = timeWeekday(3);
    const timeThursday = timeWeekday(4);
    const timeFriday = timeWeekday(5);
    const timeSaturday = timeWeekday(6);
    const timeSundays = timeSunday.range;
    const timeMondays = timeMonday.range;
    const timeTuesdays = timeTuesday.range;
    const timeWednesdays = timeWednesday.range;
    const timeThursdays = timeThursday.range;
    const timeFridays = timeFriday.range;
    const timeSaturdays = timeSaturday.range;
    function utcWeekday(i) {
        return timeInterval((date)=>{
            date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
            date.setUTCHours(0, 0, 0, 0);
        }, (date, step)=>{
            date.setUTCDate(date.getUTCDate() + step * 7);
        }, (start, end)=>{
            return (end - start) / durationWeek;
        });
    }
    const utcSunday = utcWeekday(0);
    const utcMonday = utcWeekday(1);
    const utcTuesday = utcWeekday(2);
    const utcWednesday = utcWeekday(3);
    const utcThursday = utcWeekday(4);
    const utcFriday = utcWeekday(5);
    const utcSaturday = utcWeekday(6);
    const utcSundays = utcSunday.range;
    const utcMondays = utcMonday.range;
    const utcTuesdays = utcTuesday.range;
    const utcWednesdays = utcWednesday.range;
    const utcThursdays = utcThursday.range;
    const utcFridays = utcFriday.range;
    const utcSaturdays = utcSaturday.range;
    const timeMonth = timeInterval((date)=>{
        date.setDate(1);
        date.setHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setMonth(date.getMonth() + step);
    }, (start, end)=>{
        return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
    }, (date)=>{
        return date.getMonth();
    });
    const timeMonths = timeMonth.range;
    const utcMonth = timeInterval((date)=>{
        date.setUTCDate(1);
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCMonth(date.getUTCMonth() + step);
    }, (start, end)=>{
        return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
    }, (date)=>{
        return date.getUTCMonth();
    });
    const utcMonths = utcMonth.range;
    const timeYear = timeInterval((date)=>{
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setFullYear(date.getFullYear() + step);
    }, (start, end)=>{
        return end.getFullYear() - start.getFullYear();
    }, (date)=>{
        return date.getFullYear();
    });
    // An optimized implementation for this simple case.
    timeYear.every = (k)=>{
        return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : timeInterval((date)=>{
            date.setFullYear(Math.floor(date.getFullYear() / k) * k);
            date.setMonth(0, 1);
            date.setHours(0, 0, 0, 0);
        }, (date, step)=>{
            date.setFullYear(date.getFullYear() + step * k);
        });
    };
    const timeYears = timeYear.range;
    const utcYear = timeInterval((date)=>{
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCFullYear(date.getUTCFullYear() + step);
    }, (start, end)=>{
        return end.getUTCFullYear() - start.getUTCFullYear();
    }, (date)=>{
        return date.getUTCFullYear();
    });
    // An optimized implementation for this simple case.
    utcYear.every = (k)=>{
        return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : timeInterval((date)=>{
            date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
            date.setUTCMonth(0, 1);
            date.setUTCHours(0, 0, 0, 0);
        }, (date, step)=>{
            date.setUTCFullYear(date.getUTCFullYear() + step * k);
        });
    };
    const utcYears = utcYear.range;
    function ticker(year, month, week, day, hour, minute) {
        const tickIntervals = [
            [
                second,
                1,
                durationSecond
            ],
            [
                second,
                5,
                5 * durationSecond
            ],
            [
                second,
                15,
                15 * durationSecond
            ],
            [
                second,
                30,
                30 * durationSecond
            ],
            [
                minute,
                1,
                durationMinute
            ],
            [
                minute,
                5,
                5 * durationMinute
            ],
            [
                minute,
                15,
                15 * durationMinute
            ],
            [
                minute,
                30,
                30 * durationMinute
            ],
            [
                hour,
                1,
                durationHour
            ],
            [
                hour,
                3,
                3 * durationHour
            ],
            [
                hour,
                6,
                6 * durationHour
            ],
            [
                hour,
                12,
                12 * durationHour
            ],
            [
                day,
                1,
                durationDay
            ],
            [
                day,
                2,
                2 * durationDay
            ],
            [
                week,
                1,
                durationWeek
            ],
            [
                month,
                1,
                durationMonth
            ],
            [
                month,
                3,
                3 * durationMonth
            ],
            [
                year,
                1,
                durationYear
            ]
        ];
        function ticks(start, stop, count) {
            const reverse = stop < start;
            if (reverse) [start, stop] = [
                stop,
                start
            ];
            const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
            const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
            return reverse ? ticks.reverse() : ticks;
        }
        function tickInterval(start, stop, count) {
            const target = Math.abs(stop - start) / count;
            const i = bisector(([, , step])=>step).right(tickIntervals, target);
            if (i === tickIntervals.length) return year.every(tickStep(start / durationYear, stop / durationYear, count));
            if (i === 0) return millisecond.every(Math.max(tickStep(start, stop, count), 1));
            const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
            return t.every(step);
        }
        return [
            ticks,
            tickInterval
        ];
    }
    const [utcTicks, utcTickInterval] = ticker(utcYear, utcMonth, utcSunday, unixDay, utcHour, utcMinute);
    const [timeTicks, timeTickInterval] = ticker(timeYear, timeMonth, timeSunday, timeDay, timeHour, timeMinute);
    function localDate(d) {
        if (0 <= d.y && d.y < 100) {
            var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
            date.setFullYear(d.y);
            return date;
        }
        return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
    }
    function utcDate(d) {
        if (0 <= d.y && d.y < 100) {
            var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
            date.setUTCFullYear(d.y);
            return date;
        }
        return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
    }
    function newDate(y, m, d) {
        return {
            y: y,
            m: m,
            d: d,
            H: 0,
            M: 0,
            S: 0,
            L: 0
        };
    }
    function formatLocale(locale) {
        var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
        var periodRe = formatRe(locale_periods), periodLookup = formatLookup(locale_periods), weekdayRe = formatRe(locale_weekdays), weekdayLookup = formatLookup(locale_weekdays), shortWeekdayRe = formatRe(locale_shortWeekdays), shortWeekdayLookup = formatLookup(locale_shortWeekdays), monthRe = formatRe(locale_months), monthLookup = formatLookup(locale_months), shortMonthRe = formatRe(locale_shortMonths), shortMonthLookup = formatLookup(locale_shortMonths);
        var formats = {
            "a": formatShortWeekday,
            "A": formatWeekday,
            "b": formatShortMonth,
            "B": formatMonth,
            "c": null,
            "d": formatDayOfMonth,
            "e": formatDayOfMonth,
            "f": formatMicroseconds,
            "g": formatYearISO,
            "G": formatFullYearISO,
            "H": formatHour24,
            "I": formatHour12,
            "j": formatDayOfYear,
            "L": formatMilliseconds,
            "m": formatMonthNumber,
            "M": formatMinutes,
            "p": formatPeriod,
            "q": formatQuarter,
            "Q": formatUnixTimestamp,
            "s": formatUnixTimestampSeconds,
            "S": formatSeconds,
            "u": formatWeekdayNumberMonday,
            "U": formatWeekNumberSunday,
            "V": formatWeekNumberISO,
            "w": formatWeekdayNumberSunday,
            "W": formatWeekNumberMonday,
            "x": null,
            "X": null,
            "y": formatYear,
            "Y": formatFullYear,
            "Z": formatZone,
            "%": formatLiteralPercent
        };
        var utcFormats = {
            "a": formatUTCShortWeekday,
            "A": formatUTCWeekday,
            "b": formatUTCShortMonth,
            "B": formatUTCMonth,
            "c": null,
            "d": formatUTCDayOfMonth,
            "e": formatUTCDayOfMonth,
            "f": formatUTCMicroseconds,
            "g": formatUTCYearISO,
            "G": formatUTCFullYearISO,
            "H": formatUTCHour24,
            "I": formatUTCHour12,
            "j": formatUTCDayOfYear,
            "L": formatUTCMilliseconds,
            "m": formatUTCMonthNumber,
            "M": formatUTCMinutes,
            "p": formatUTCPeriod,
            "q": formatUTCQuarter,
            "Q": formatUnixTimestamp,
            "s": formatUnixTimestampSeconds,
            "S": formatUTCSeconds,
            "u": formatUTCWeekdayNumberMonday,
            "U": formatUTCWeekNumberSunday,
            "V": formatUTCWeekNumberISO,
            "w": formatUTCWeekdayNumberSunday,
            "W": formatUTCWeekNumberMonday,
            "x": null,
            "X": null,
            "y": formatUTCYear,
            "Y": formatUTCFullYear,
            "Z": formatUTCZone,
            "%": formatLiteralPercent
        };
        var parses = {
            "a": parseShortWeekday,
            "A": parseWeekday,
            "b": parseShortMonth,
            "B": parseMonth,
            "c": parseLocaleDateTime,
            "d": parseDayOfMonth,
            "e": parseDayOfMonth,
            "f": parseMicroseconds,
            "g": parseYear,
            "G": parseFullYear,
            "H": parseHour24,
            "I": parseHour24,
            "j": parseDayOfYear,
            "L": parseMilliseconds,
            "m": parseMonthNumber,
            "M": parseMinutes,
            "p": parsePeriod,
            "q": parseQuarter,
            "Q": parseUnixTimestamp,
            "s": parseUnixTimestampSeconds,
            "S": parseSeconds,
            "u": parseWeekdayNumberMonday,
            "U": parseWeekNumberSunday,
            "V": parseWeekNumberISO,
            "w": parseWeekdayNumberSunday,
            "W": parseWeekNumberMonday,
            "x": parseLocaleDate,
            "X": parseLocaleTime,
            "y": parseYear,
            "Y": parseFullYear,
            "Z": parseZone,
            "%": parseLiteralPercent
        };
        // These recursive directive definitions must be deferred.
        formats.x = newFormat(locale_date, formats);
        formats.X = newFormat(locale_time, formats);
        formats.c = newFormat(locale_dateTime, formats);
        utcFormats.x = newFormat(locale_date, utcFormats);
        utcFormats.X = newFormat(locale_time, utcFormats);
        utcFormats.c = newFormat(locale_dateTime, utcFormats);
        function newFormat(specifier, formats) {
            return function(date) {
                var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
                if (!(date instanceof Date)) date = new Date(+date);
                while(++i < n)if (specifier.charCodeAt(i) === 37) {
                    string.push(specifier.slice(j, i));
                    if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                    else pad = c === "e" ? " " : "0";
                    if (format = formats[c]) c = format(date, pad);
                    string.push(c);
                    j = i + 1;
                }
                string.push(specifier.slice(j, i));
                return string.join("");
            };
        }
        function newParse(specifier, Z) {
            return function(string) {
                var d = newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
                if (i != string.length) return null;
                // If a UNIX timestamp is specified, return it.
                if ("Q" in d) return new Date(d.Q);
                if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
                // If this is utcParse, never use the local timezone.
                if (Z && !("Z" in d)) d.Z = 0;
                // The am-pm flag is 0 for AM, and 1 for PM.
                if ("p" in d) d.H = d.H % 12 + d.p * 12;
                // If the month was not specified, inherit from the quarter.
                if (d.m === undefined) d.m = "q" in d ? d.q : 0;
                // Convert day-of-week and week-of-year to day-of-year.
                if ("V" in d) {
                    if (d.V < 1 || d.V > 53) return null;
                    if (!("w" in d)) d.w = 1;
                    if ("Z" in d) {
                        week = utcDate(newDate(d.y, 0, 1)), day = week.getUTCDay();
                        week = day > 4 || day === 0 ? utcMonday.ceil(week) : utcMonday(week);
                        week = utcDay.offset(week, (d.V - 1) * 7);
                        d.y = week.getUTCFullYear();
                        d.m = week.getUTCMonth();
                        d.d = week.getUTCDate() + (d.w + 6) % 7;
                    } else {
                        week = localDate(newDate(d.y, 0, 1)), day = week.getDay();
                        week = day > 4 || day === 0 ? timeMonday.ceil(week) : timeMonday(week);
                        week = timeDay.offset(week, (d.V - 1) * 7);
                        d.y = week.getFullYear();
                        d.m = week.getMonth();
                        d.d = week.getDate() + (d.w + 6) % 7;
                    }
                } else if ("W" in d || "U" in d) {
                    if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                    day = "Z" in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
                    d.m = 0;
                    d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
                }
                // If a time zone is specified, all fields are interpreted as UTC and then
                // offset according to the specified time zone.
                if ("Z" in d) {
                    d.H += d.Z / 100 | 0;
                    d.M += d.Z % 100;
                    return utcDate(d);
                }
                // Otherwise, all fields are in local time.
                return localDate(d);
            };
        }
        function parseSpecifier(d, specifier, string, j) {
            var i = 0, n = specifier.length, m = string.length, c, parse;
            while(i < n){
                if (j >= m) return -1;
                c = specifier.charCodeAt(i++);
                if (c === 37) {
                    c = specifier.charAt(i++);
                    parse = parses[c in pads ? specifier.charAt(i++) : c];
                    if (!parse || (j = parse(d, string, j)) < 0) return -1;
                } else if (c != string.charCodeAt(j++)) return -1;
            }
            return j;
        }
        function parsePeriod(d, string, i) {
            var n = periodRe.exec(string.slice(i));
            return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
        }
        function parseShortWeekday(d, string, i) {
            var n = shortWeekdayRe.exec(string.slice(i));
            return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
        }
        function parseWeekday(d, string, i) {
            var n = weekdayRe.exec(string.slice(i));
            return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
        }
        function parseShortMonth(d, string, i) {
            var n = shortMonthRe.exec(string.slice(i));
            return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
        }
        function parseMonth(d, string, i) {
            var n = monthRe.exec(string.slice(i));
            return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
        }
        function parseLocaleDateTime(d, string, i) {
            return parseSpecifier(d, locale_dateTime, string, i);
        }
        function parseLocaleDate(d, string, i) {
            return parseSpecifier(d, locale_date, string, i);
        }
        function parseLocaleTime(d, string, i) {
            return parseSpecifier(d, locale_time, string, i);
        }
        function formatShortWeekday(d) {
            return locale_shortWeekdays[d.getDay()];
        }
        function formatWeekday(d) {
            return locale_weekdays[d.getDay()];
        }
        function formatShortMonth(d) {
            return locale_shortMonths[d.getMonth()];
        }
        function formatMonth(d) {
            return locale_months[d.getMonth()];
        }
        function formatPeriod(d) {
            return locale_periods[+(d.getHours() >= 12)];
        }
        function formatQuarter(d) {
            return 1 + ~~(d.getMonth() / 3);
        }
        function formatUTCShortWeekday(d) {
            return locale_shortWeekdays[d.getUTCDay()];
        }
        function formatUTCWeekday(d) {
            return locale_weekdays[d.getUTCDay()];
        }
        function formatUTCShortMonth(d) {
            return locale_shortMonths[d.getUTCMonth()];
        }
        function formatUTCMonth(d) {
            return locale_months[d.getUTCMonth()];
        }
        function formatUTCPeriod(d) {
            return locale_periods[+(d.getUTCHours() >= 12)];
        }
        function formatUTCQuarter(d) {
            return 1 + ~~(d.getUTCMonth() / 3);
        }
        return {
            format: function(specifier) {
                var f = newFormat(specifier += "", formats);
                f.toString = function() {
                    return specifier;
                };
                return f;
            },
            parse: function(specifier) {
                var p = newParse(specifier += "", false);
                p.toString = function() {
                    return specifier;
                };
                return p;
            },
            utcFormat: function(specifier) {
                var f = newFormat(specifier += "", utcFormats);
                f.toString = function() {
                    return specifier;
                };
                return f;
            },
            utcParse: function(specifier) {
                var p = newParse(specifier += "", true);
                p.toString = function() {
                    return specifier;
                };
                return p;
            }
        };
    }
    var pads = {
        "-": "",
        "_": " ",
        "0": "0"
    }, numberRe = /^\s*\d+/, percentRe = /^%/, requoteRe = /[\\^$*+?|[\]().{}]/g;
    function pad(value, fill, width) {
        var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
        return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
    }
    function requote(s) {
        return s.replace(requoteRe, "\\$&");
    }
    function formatRe(names) {
        return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
    }
    function formatLookup(names) {
        return new Map(names.map((name, i)=>[
                name.toLowerCase(),
                i
            ]));
    }
    function parseWeekdayNumberSunday(d, string, i) {
        var n = numberRe.exec(string.slice(i, i + 1));
        return n ? (d.w = +n[0], i + n[0].length) : -1;
    }
    function parseWeekdayNumberMonday(d, string, i) {
        var n = numberRe.exec(string.slice(i, i + 1));
        return n ? (d.u = +n[0], i + n[0].length) : -1;
    }
    function parseWeekNumberSunday(d, string, i) {
        var n = numberRe.exec(string.slice(i, i + 2));
        return n ? (d.U = +n[0], i + n[0].length) : -1;
    }
    function parseWeekNumberISO(d, string, i) {
        var n = numberRe.exec(string.slice(i, i + 2));
        return n ? (d.V = +n[0], i + n[0].length) : -1;
    }
    function parseWeekNumberMonday(d, string, i) {
        var n = numberRe.exec(string.slice(i, i + 2));
        return n ? (d.W = +n[0], i + n[0].length) : -1;
    }
    function parseFullYear(d, string, i) {
        var n = numberRe.exec(string.slice(i, i + 4));
        return n ? (d.y = +n[0], i + n[0].length) : -1;
    }
    function parseYear(d, string, i) {
        var n = numberRe.exec(string.slice(i, i + 2));
        return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
    }
    function parseZone(d, string, i) {
        var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
        return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
    }
    function parseQuarter(d, string, i) {
        var n = numberRe.exec(string.slice(i, i + 1));
        return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
    }
    function parseMonthNumber(d, string, i) {
        var n = numberRe.exec(string.slice(i, i + 2));
        return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
    }
    function parseDayOfMonth(d, string, i) {
        var n = numberRe.exec(string.slice(i, i + 2));
        return n ? (d.d = +n[0], i + n[0].length) : -1;
    }
    function parseDayOfYear(d, string, i) {
        var n = numberRe.exec(string.slice(i, i + 3));
        return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
    }
    function parseHour24(d, string, i) {
        var n = numberRe.exec(string.slice(i, i + 2));
        return n ? (d.H = +n[0], i + n[0].length) : -1;
    }
    function parseMinutes(d, string, i) {
        var n = numberRe.exec(string.slice(i, i + 2));
        return n ? (d.M = +n[0], i + n[0].length) : -1;
    }
    function parseSeconds(d, string, i) {
        var n = numberRe.exec(string.slice(i, i + 2));
        return n ? (d.S = +n[0], i + n[0].length) : -1;
    }
    function parseMilliseconds(d, string, i) {
        var n = numberRe.exec(string.slice(i, i + 3));
        return n ? (d.L = +n[0], i + n[0].length) : -1;
    }
    function parseMicroseconds(d, string, i) {
        var n = numberRe.exec(string.slice(i, i + 6));
        return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
    }
    function parseLiteralPercent(d, string, i) {
        var n = percentRe.exec(string.slice(i, i + 1));
        return n ? i + n[0].length : -1;
    }
    function parseUnixTimestamp(d, string, i) {
        var n = numberRe.exec(string.slice(i));
        return n ? (d.Q = +n[0], i + n[0].length) : -1;
    }
    function parseUnixTimestampSeconds(d, string, i) {
        var n = numberRe.exec(string.slice(i));
        return n ? (d.s = +n[0], i + n[0].length) : -1;
    }
    function formatDayOfMonth(d, p) {
        return pad(d.getDate(), p, 2);
    }
    function formatHour24(d, p) {
        return pad(d.getHours(), p, 2);
    }
    function formatHour12(d, p) {
        return pad(d.getHours() % 12 || 12, p, 2);
    }
    function formatDayOfYear(d, p) {
        return pad(1 + timeDay.count(timeYear(d), d), p, 3);
    }
    function formatMilliseconds(d, p) {
        return pad(d.getMilliseconds(), p, 3);
    }
    function formatMicroseconds(d, p) {
        return formatMilliseconds(d, p) + "000";
    }
    function formatMonthNumber(d, p) {
        return pad(d.getMonth() + 1, p, 2);
    }
    function formatMinutes(d, p) {
        return pad(d.getMinutes(), p, 2);
    }
    function formatSeconds(d, p) {
        return pad(d.getSeconds(), p, 2);
    }
    function formatWeekdayNumberMonday(d) {
        var day = d.getDay();
        return day === 0 ? 7 : day;
    }
    function formatWeekNumberSunday(d, p) {
        return pad(timeSunday.count(timeYear(d) - 1, d), p, 2);
    }
    function dISO(d) {
        var day = d.getDay();
        return day >= 4 || day === 0 ? timeThursday(d) : timeThursday.ceil(d);
    }
    function formatWeekNumberISO(d, p) {
        d = dISO(d);
        return pad(timeThursday.count(timeYear(d), d) + (timeYear(d).getDay() === 4), p, 2);
    }
    function formatWeekdayNumberSunday(d) {
        return d.getDay();
    }
    function formatWeekNumberMonday(d, p) {
        return pad(timeMonday.count(timeYear(d) - 1, d), p, 2);
    }
    function formatYear(d, p) {
        return pad(d.getFullYear() % 100, p, 2);
    }
    function formatYearISO(d, p) {
        d = dISO(d);
        return pad(d.getFullYear() % 100, p, 2);
    }
    function formatFullYear(d, p) {
        return pad(d.getFullYear() % 10000, p, 4);
    }
    function formatFullYearISO(d, p) {
        var day = d.getDay();
        d = day >= 4 || day === 0 ? timeThursday(d) : timeThursday.ceil(d);
        return pad(d.getFullYear() % 10000, p, 4);
    }
    function formatZone(d) {
        var z = d.getTimezoneOffset();
        return (z > 0 ? "-" : (z *= -1, "+")) + pad(z / 60 | 0, "0", 2) + pad(z % 60, "0", 2);
    }
    function formatUTCDayOfMonth(d, p) {
        return pad(d.getUTCDate(), p, 2);
    }
    function formatUTCHour24(d, p) {
        return pad(d.getUTCHours(), p, 2);
    }
    function formatUTCHour12(d, p) {
        return pad(d.getUTCHours() % 12 || 12, p, 2);
    }
    function formatUTCDayOfYear(d, p) {
        return pad(1 + utcDay.count(utcYear(d), d), p, 3);
    }
    function formatUTCMilliseconds(d, p) {
        return pad(d.getUTCMilliseconds(), p, 3);
    }
    function formatUTCMicroseconds(d, p) {
        return formatUTCMilliseconds(d, p) + "000";
    }
    function formatUTCMonthNumber(d, p) {
        return pad(d.getUTCMonth() + 1, p, 2);
    }
    function formatUTCMinutes(d, p) {
        return pad(d.getUTCMinutes(), p, 2);
    }
    function formatUTCSeconds(d, p) {
        return pad(d.getUTCSeconds(), p, 2);
    }
    function formatUTCWeekdayNumberMonday(d) {
        var dow = d.getUTCDay();
        return dow === 0 ? 7 : dow;
    }
    function formatUTCWeekNumberSunday(d, p) {
        return pad(utcSunday.count(utcYear(d) - 1, d), p, 2);
    }
    function UTCdISO(d) {
        var day = d.getUTCDay();
        return day >= 4 || day === 0 ? utcThursday(d) : utcThursday.ceil(d);
    }
    function formatUTCWeekNumberISO(d, p) {
        d = UTCdISO(d);
        return pad(utcThursday.count(utcYear(d), d) + (utcYear(d).getUTCDay() === 4), p, 2);
    }
    function formatUTCWeekdayNumberSunday(d) {
        return d.getUTCDay();
    }
    function formatUTCWeekNumberMonday(d, p) {
        return pad(utcMonday.count(utcYear(d) - 1, d), p, 2);
    }
    function formatUTCYear(d, p) {
        return pad(d.getUTCFullYear() % 100, p, 2);
    }
    function formatUTCYearISO(d, p) {
        d = UTCdISO(d);
        return pad(d.getUTCFullYear() % 100, p, 2);
    }
    function formatUTCFullYear(d, p) {
        return pad(d.getUTCFullYear() % 10000, p, 4);
    }
    function formatUTCFullYearISO(d, p) {
        var day = d.getUTCDay();
        d = day >= 4 || day === 0 ? utcThursday(d) : utcThursday.ceil(d);
        return pad(d.getUTCFullYear() % 10000, p, 4);
    }
    function formatUTCZone() {
        return "+0000";
    }
    function formatLiteralPercent() {
        return "%";
    }
    function formatUnixTimestamp(d) {
        return +d;
    }
    function formatUnixTimestampSeconds(d) {
        return Math.floor(+d / 1000);
    }
    var locale;
    exports1.timeFormat = void 0;
    exports1.timeParse = void 0;
    exports1.utcFormat = void 0;
    exports1.utcParse = void 0;
    defaultLocale({
        dateTime: "%x, %X",
        date: "%-m/%-d/%Y",
        time: "%-I:%M:%S %p",
        periods: [
            "AM",
            "PM"
        ],
        days: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ],
        shortDays: [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
        ],
        months: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ],
        shortMonths: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ]
    });
    function defaultLocale(definition) {
        locale = formatLocale(definition);
        exports1.timeFormat = locale.format;
        exports1.timeParse = locale.parse;
        exports1.utcFormat = locale.utcFormat;
        exports1.utcParse = locale.utcParse;
        return locale;
    }
    var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
    function formatIsoNative(date) {
        return date.toISOString();
    }
    var formatIso = Date.prototype.toISOString ? formatIsoNative : exports1.utcFormat(isoSpecifier);
    var formatIso$1 = formatIso;
    function parseIsoNative(string) {
        var date = new Date(string);
        return isNaN(date) ? null : date;
    }
    var parseIso = +new Date("2000-01-01T00:00:00.000Z") ? parseIsoNative : exports1.utcParse(isoSpecifier);
    var parseIso$1 = parseIso;
    function date(t) {
        return new Date(t);
    }
    function number(t) {
        return t instanceof Date ? +t : +new Date(+t);
    }
    function calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
        var scale = continuous(), invert = scale.invert, domain = scale.domain;
        var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
        function tickFormat(date) {
            return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
        }
        scale.invert = function(y) {
            return new Date(invert(y));
        };
        scale.domain = function(_) {
            return arguments.length ? domain(Array.from(_, number)) : domain().map(date);
        };
        scale.ticks = function(interval) {
            var d = domain();
            return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
        };
        scale.tickFormat = function(count, specifier) {
            return specifier == null ? tickFormat : format(specifier);
        };
        scale.nice = function(interval) {
            var d = domain();
            if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
            return interval ? domain(nice(d, interval)) : scale;
        };
        scale.copy = function() {
            return copy$1(scale, calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
        };
        return scale;
    }
    function time() {
        return initRange.apply(calendar(timeTicks, timeTickInterval, timeYear, timeMonth, timeSunday, timeDay, timeHour, timeMinute, second, exports1.timeFormat).domain([
            new Date(2000, 0, 1),
            new Date(2000, 0, 2)
        ]), arguments);
    }
    function utcTime() {
        return initRange.apply(calendar(utcTicks, utcTickInterval, utcYear, utcMonth, utcSunday, utcDay, utcHour, utcMinute, second, exports1.utcFormat).domain([
            Date.UTC(2000, 0, 1),
            Date.UTC(2000, 0, 2)
        ]), arguments);
    }
    function transformer$1() {
        var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = identity$3, clamp = false, unknown;
        function scale(x) {
            return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
        }
        scale.domain = function(_) {
            return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
                x0,
                x1
            ];
        };
        scale.clamp = function(_) {
            return arguments.length ? (clamp = !!_, scale) : clamp;
        };
        scale.interpolator = function(_) {
            return arguments.length ? (interpolator = _, scale) : interpolator;
        };
        function range(interpolate) {
            return function(_) {
                var r0, r1;
                return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                    interpolator(0),
                    interpolator(1)
                ];
            };
        }
        scale.range = range(interpolate$2);
        scale.rangeRound = range(interpolateRound);
        scale.unknown = function(_) {
            return arguments.length ? (unknown = _, scale) : unknown;
        };
        return function(t) {
            transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
            return scale;
        };
    }
    function copy(source, target) {
        return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
    }
    function sequential() {
        var scale = linearish(transformer$1()(identity$3));
        scale.copy = function() {
            return copy(scale, sequential());
        };
        return initInterpolator.apply(scale, arguments);
    }
    function sequentialLog() {
        var scale = loggish(transformer$1()).domain([
            1,
            10
        ]);
        scale.copy = function() {
            return copy(scale, sequentialLog()).base(scale.base());
        };
        return initInterpolator.apply(scale, arguments);
    }
    function sequentialSymlog() {
        var scale = symlogish(transformer$1());
        scale.copy = function() {
            return copy(scale, sequentialSymlog()).constant(scale.constant());
        };
        return initInterpolator.apply(scale, arguments);
    }
    function sequentialPow() {
        var scale = powish(transformer$1());
        scale.copy = function() {
            return copy(scale, sequentialPow()).exponent(scale.exponent());
        };
        return initInterpolator.apply(scale, arguments);
    }
    function sequentialSqrt() {
        return sequentialPow.apply(null, arguments).exponent(0.5);
    }
    function sequentialQuantile() {
        var domain = [], interpolator = identity$3;
        function scale(x) {
            if (x != null && !isNaN(x = +x)) return interpolator((bisect(domain, x, 1) - 1) / (domain.length - 1));
        }
        scale.domain = function(_) {
            if (!arguments.length) return domain.slice();
            domain = [];
            for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
            domain.sort(ascending$3);
            return scale;
        };
        scale.interpolator = function(_) {
            return arguments.length ? (interpolator = _, scale) : interpolator;
        };
        scale.range = function() {
            return domain.map((d, i)=>interpolator(i / (domain.length - 1)));
        };
        scale.quantiles = function(n) {
            return Array.from({
                length: n + 1
            }, (_, i)=>quantile$1(domain, i / n));
        };
        scale.copy = function() {
            return sequentialQuantile(interpolator).domain(domain);
        };
        return initInterpolator.apply(scale, arguments);
    }
    function transformer() {
        var x0 = 0, x1 = 0.5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = identity$3, transform, clamp = false, unknown;
        function scale(x) {
            return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
        }
        scale.domain = function(_) {
            return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
                x0,
                x1,
                x2
            ];
        };
        scale.clamp = function(_) {
            return arguments.length ? (clamp = !!_, scale) : clamp;
        };
        scale.interpolator = function(_) {
            return arguments.length ? (interpolator = _, scale) : interpolator;
        };
        function range(interpolate) {
            return function(_) {
                var r0, r1, r2;
                return arguments.length ? ([r0, r1, r2] = _, interpolator = piecewise(interpolate, [
                    r0,
                    r1,
                    r2
                ]), scale) : [
                    interpolator(0),
                    interpolator(0.5),
                    interpolator(1)
                ];
            };
        }
        scale.range = range(interpolate$2);
        scale.rangeRound = range(interpolateRound);
        scale.unknown = function(_) {
            return arguments.length ? (unknown = _, scale) : unknown;
        };
        return function(t) {
            transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
            return scale;
        };
    }
    function diverging$1() {
        var scale = linearish(transformer()(identity$3));
        scale.copy = function() {
            return copy(scale, diverging$1());
        };
        return initInterpolator.apply(scale, arguments);
    }
    function divergingLog() {
        var scale = loggish(transformer()).domain([
            0.1,
            1,
            10
        ]);
        scale.copy = function() {
            return copy(scale, divergingLog()).base(scale.base());
        };
        return initInterpolator.apply(scale, arguments);
    }
    function divergingSymlog() {
        var scale = symlogish(transformer());
        scale.copy = function() {
            return copy(scale, divergingSymlog()).constant(scale.constant());
        };
        return initInterpolator.apply(scale, arguments);
    }
    function divergingPow() {
        var scale = powish(transformer());
        scale.copy = function() {
            return copy(scale, divergingPow()).exponent(scale.exponent());
        };
        return initInterpolator.apply(scale, arguments);
    }
    function divergingSqrt() {
        return divergingPow.apply(null, arguments).exponent(0.5);
    }
    function colors(specifier) {
        var n = specifier.length / 6 | 0, colors = new Array(n), i = 0;
        while(i < n)colors[i] = "#" + specifier.slice(i * 6, ++i * 6);
        return colors;
    }
    var category10 = colors("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");
    var Accent = colors("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666");
    var Dark2 = colors("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666");
    var Paired = colors("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928");
    var Pastel1 = colors("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2");
    var Pastel2 = colors("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc");
    var Set1 = colors("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999");
    var Set2 = colors("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3");
    var Set3 = colors("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f");
    var Tableau10 = colors("4e79a7f28e2ce1575976b7b259a14fedc949af7aa1ff9da79c755fbab0ab");
    var ramp$1 = (scheme)=>rgbBasis(scheme[scheme.length - 1]);
    var scheme$q = new Array(3).concat("d8b365f5f5f55ab4ac", "a6611adfc27d80cdc1018571", "a6611adfc27df5f5f580cdc1018571", "8c510ad8b365f6e8c3c7eae55ab4ac01665e", "8c510ad8b365f6e8c3f5f5f5c7eae55ab4ac01665e", "8c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e", "8c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e", "5430058c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e003c30", "5430058c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e003c30").map(colors);
    var BrBG = ramp$1(scheme$q);
    var scheme$p = new Array(3).concat("af8dc3f7f7f77fbf7b", "7b3294c2a5cfa6dba0008837", "7b3294c2a5cff7f7f7a6dba0008837", "762a83af8dc3e7d4e8d9f0d37fbf7b1b7837", "762a83af8dc3e7d4e8f7f7f7d9f0d37fbf7b1b7837", "762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b7837", "762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b7837", "40004b762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b783700441b", "40004b762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b783700441b").map(colors);
    var PRGn = ramp$1(scheme$p);
    var scheme$o = new Array(3).concat("e9a3c9f7f7f7a1d76a", "d01c8bf1b6dab8e1864dac26", "d01c8bf1b6daf7f7f7b8e1864dac26", "c51b7de9a3c9fde0efe6f5d0a1d76a4d9221", "c51b7de9a3c9fde0eff7f7f7e6f5d0a1d76a4d9221", "c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221", "c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221", "8e0152c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221276419", "8e0152c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221276419").map(colors);
    var PiYG = ramp$1(scheme$o);
    var scheme$n = new Array(3).concat("998ec3f7f7f7f1a340", "5e3c99b2abd2fdb863e66101", "5e3c99b2abd2f7f7f7fdb863e66101", "542788998ec3d8daebfee0b6f1a340b35806", "542788998ec3d8daebf7f7f7fee0b6f1a340b35806", "5427888073acb2abd2d8daebfee0b6fdb863e08214b35806", "5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b35806", "2d004b5427888073acb2abd2d8daebfee0b6fdb863e08214b358067f3b08", "2d004b5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b358067f3b08").map(colors);
    var PuOr = ramp$1(scheme$n);
    var scheme$m = new Array(3).concat("ef8a62f7f7f767a9cf", "ca0020f4a58292c5de0571b0", "ca0020f4a582f7f7f792c5de0571b0", "b2182bef8a62fddbc7d1e5f067a9cf2166ac", "b2182bef8a62fddbc7f7f7f7d1e5f067a9cf2166ac", "b2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac", "b2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac", "67001fb2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac053061", "67001fb2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac053061").map(colors);
    var RdBu = ramp$1(scheme$m);
    var scheme$l = new Array(3).concat("ef8a62ffffff999999", "ca0020f4a582bababa404040", "ca0020f4a582ffffffbababa404040", "b2182bef8a62fddbc7e0e0e09999994d4d4d", "b2182bef8a62fddbc7ffffffe0e0e09999994d4d4d", "b2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d", "b2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d", "67001fb2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d1a1a1a", "67001fb2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d1a1a1a").map(colors);
    var RdGy = ramp$1(scheme$l);
    var scheme$k = new Array(3).concat("fc8d59ffffbf91bfdb", "d7191cfdae61abd9e92c7bb6", "d7191cfdae61ffffbfabd9e92c7bb6", "d73027fc8d59fee090e0f3f891bfdb4575b4", "d73027fc8d59fee090ffffbfe0f3f891bfdb4575b4", "d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4", "d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4", "a50026d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4313695", "a50026d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4313695").map(colors);
    var RdYlBu = ramp$1(scheme$k);
    var scheme$j = new Array(3).concat("fc8d59ffffbf91cf60", "d7191cfdae61a6d96a1a9641", "d7191cfdae61ffffbfa6d96a1a9641", "d73027fc8d59fee08bd9ef8b91cf601a9850", "d73027fc8d59fee08bffffbfd9ef8b91cf601a9850", "d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850", "d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850", "a50026d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850006837", "a50026d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850006837").map(colors);
    var RdYlGn = ramp$1(scheme$j);
    var scheme$i = new Array(3).concat("fc8d59ffffbf99d594", "d7191cfdae61abdda42b83ba", "d7191cfdae61ffffbfabdda42b83ba", "d53e4ffc8d59fee08be6f59899d5943288bd", "d53e4ffc8d59fee08bffffbfe6f59899d5943288bd", "d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd", "d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd", "9e0142d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd5e4fa2", "9e0142d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd5e4fa2").map(colors);
    var Spectral = ramp$1(scheme$i);
    var scheme$h = new Array(3).concat("e5f5f999d8c92ca25f", "edf8fbb2e2e266c2a4238b45", "edf8fbb2e2e266c2a42ca25f006d2c", "edf8fbccece699d8c966c2a42ca25f006d2c", "edf8fbccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45006d2c00441b").map(colors);
    var BuGn = ramp$1(scheme$h);
    var scheme$g = new Array(3).concat("e0ecf49ebcda8856a7", "edf8fbb3cde38c96c688419d", "edf8fbb3cde38c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b").map(colors);
    var BuPu = ramp$1(scheme$g);
    var scheme$f = new Array(3).concat("e0f3dba8ddb543a2ca", "f0f9e8bae4bc7bccc42b8cbe", "f0f9e8bae4bc7bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe0868ac084081").map(colors);
    var GnBu = ramp$1(scheme$f);
    var scheme$e = new Array(3).concat("fee8c8fdbb84e34a33", "fef0d9fdcc8afc8d59d7301f", "fef0d9fdcc8afc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000").map(colors);
    var OrRd = ramp$1(scheme$e);
    var scheme$d = new Array(3).concat("ece2f0a6bddb1c9099", "f6eff7bdc9e167a9cf02818a", "f6eff7bdc9e167a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636").map(colors);
    var PuBuGn = ramp$1(scheme$d);
    var scheme$c = new Array(3).concat("ece7f2a6bddb2b8cbe", "f1eef6bdc9e174a9cf0570b0", "f1eef6bdc9e174a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0045a8d023858").map(colors);
    var PuBu = ramp$1(scheme$c);
    var scheme$b = new Array(3).concat("e7e1efc994c7dd1c77", "f1eef6d7b5d8df65b0ce1256", "f1eef6d7b5d8df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125698004367001f").map(colors);
    var PuRd = ramp$1(scheme$b);
    var scheme$a = new Array(3).concat("fde0ddfa9fb5c51b8a", "feebe2fbb4b9f768a1ae017e", "feebe2fbb4b9f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a017749006a").map(colors);
    var RdPu = ramp$1(scheme$a);
    var scheme$9 = new Array(3).concat("edf8b17fcdbb2c7fb8", "ffffcca1dab441b6c4225ea8", "ffffcca1dab441b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea8253494081d58").map(colors);
    var YlGnBu = ramp$1(scheme$9);
    var scheme$8 = new Array(3).concat("f7fcb9addd8e31a354", "ffffccc2e69978c679238443", "ffffccc2e69978c67931a354006837", "ffffccd9f0a3addd8e78c67931a354006837", "ffffccd9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443006837004529").map(colors);
    var YlGn = ramp$1(scheme$8);
    var scheme$7 = new Array(3).concat("fff7bcfec44fd95f0e", "ffffd4fed98efe9929cc4c02", "ffffd4fed98efe9929d95f0e993404", "ffffd4fee391fec44ffe9929d95f0e993404", "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506").map(colors);
    var YlOrBr = ramp$1(scheme$7);
    var scheme$6 = new Array(3).concat("ffeda0feb24cf03b20", "ffffb2fecc5cfd8d3ce31a1c", "ffffb2fecc5cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026").map(colors);
    var YlOrRd = ramp$1(scheme$6);
    var scheme$5 = new Array(3).concat("deebf79ecae13182bd", "eff3ffbdd7e76baed62171b5", "eff3ffbdd7e76baed63182bd08519c", "eff3ffc6dbef9ecae16baed63182bd08519c", "eff3ffc6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b").map(colors);
    var Blues = ramp$1(scheme$5);
    var scheme$4 = new Array(3).concat("e5f5e0a1d99b31a354", "edf8e9bae4b374c476238b45", "edf8e9bae4b374c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45006d2c00441b").map(colors);
    var Greens = ramp$1(scheme$4);
    var scheme$3 = new Array(3).concat("f0f0f0bdbdbd636363", "f7f7f7cccccc969696525252", "f7f7f7cccccc969696636363252525", "f7f7f7d9d9d9bdbdbd969696636363252525", "f7f7f7d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525000000").map(colors);
    var Greys = ramp$1(scheme$3);
    var scheme$2 = new Array(3).concat("efedf5bcbddc756bb1", "f2f0f7cbc9e29e9ac86a51a3", "f2f0f7cbc9e29e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a354278f3f007d").map(colors);
    var Purples = ramp$1(scheme$2);
    var scheme$1 = new Array(3).concat("fee0d2fc9272de2d26", "fee5d9fcae91fb6a4acb181d", "fee5d9fcae91fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181da50f1567000d").map(colors);
    var Reds = ramp$1(scheme$1);
    var scheme = new Array(3).concat("fee6cefdae6be6550d", "feeddefdbe85fd8d3cd94701", "feeddefdbe85fd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d94801a636037f2704").map(colors);
    var Oranges = ramp$1(scheme);
    function cividis(t) {
        t = Math.max(0, Math.min(1, t));
        return "rgb(" + Math.max(0, Math.min(255, Math.round(-4.54 - t * (35.34 - t * (2381.73 - t * (6402.7 - t * (7024.72 - t * 2710.57))))))) + ", " + Math.max(0, Math.min(255, Math.round(32.49 + t * (170.73 + t * (52.82 - t * (131.46 - t * (176.58 - t * 67.37))))))) + ", " + Math.max(0, Math.min(255, Math.round(81.24 + t * (442.36 - t * (2482.43 - t * (6167.24 - t * (6614.94 - t * 2475.67))))))) + ")";
    }
    var cubehelix = cubehelixLong(cubehelix$3(300, 0.5, 0.0), cubehelix$3(-240, 0.5, 1.0));
    var warm = cubehelixLong(cubehelix$3(-100, 0.75, 0.35), cubehelix$3(80, 1.50, 0.8));
    var cool = cubehelixLong(cubehelix$3(260, 0.75, 0.35), cubehelix$3(80, 1.50, 0.8));
    var c$2 = cubehelix$3();
    function rainbow(t) {
        if (t < 0 || t > 1) t -= Math.floor(t);
        var ts = Math.abs(t - 0.5);
        c$2.h = 360 * t - 100;
        c$2.s = 1.5 - 1.5 * ts;
        c$2.l = 0.8 - 0.9 * ts;
        return c$2 + "";
    }
    var c$1 = rgb(), pi_1_3 = Math.PI / 3, pi_2_3 = Math.PI * 2 / 3;
    function sinebow(t) {
        var x;
        t = (0.5 - t) * Math.PI;
        c$1.r = 255 * (x = Math.sin(t)) * x;
        c$1.g = 255 * (x = Math.sin(t + pi_1_3)) * x;
        c$1.b = 255 * (x = Math.sin(t + pi_2_3)) * x;
        return c$1 + "";
    }
    function turbo(t) {
        t = Math.max(0, Math.min(1, t));
        return "rgb(" + Math.max(0, Math.min(255, Math.round(34.61 + t * (1172.33 - t * (10793.56 - t * (33300.12 - t * (38394.49 - t * 14825.05))))))) + ", " + Math.max(0, Math.min(255, Math.round(23.31 + t * (557.33 + t * (1225.33 - t * (3574.96 - t * (1073.77 + t * 707.56))))))) + ", " + Math.max(0, Math.min(255, Math.round(27.2 + t * (3211.1 - t * (15327.97 - t * (27814 - t * (22569.18 - t * 6838.66))))))) + ")";
    }
    function ramp(range) {
        var n = range.length;
        return function(t) {
            return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
        };
    }
    var viridis = ramp(colors("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
    var magma = ramp(colors("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
    var inferno = ramp(colors("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
    var plasma = ramp(colors("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));
    function constant$1(x) {
        return function constant() {
            return x;
        };
    }
    const abs = Math.abs;
    const atan2 = Math.atan2;
    const cos = Math.cos;
    const max = Math.max;
    const min = Math.min;
    const sin = Math.sin;
    const sqrt = Math.sqrt;
    const epsilon = 1e-12;
    const pi = Math.PI;
    const halfPi = pi / 2;
    const tau = 2 * pi;
    function acos(x) {
        return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
    }
    function asin(x) {
        return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
    }
    function arcInnerRadius(d) {
        return d.innerRadius;
    }
    function arcOuterRadius(d) {
        return d.outerRadius;
    }
    function arcStartAngle(d) {
        return d.startAngle;
    }
    function arcEndAngle(d) {
        return d.endAngle;
    }
    function arcPadAngle(d) {
        return d && d.padAngle; // Note: optional!
    }
    function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
        var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
        if (t * t < epsilon) return;
        t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
        return [
            x0 + t * x10,
            y0 + t * y10
        ];
    }
    // Compute perpendicular offset line of length rc.
    // http://mathworld.wolfram.com/Circle-LineIntersection.html
    function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
        var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / sqrt(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * sqrt(max(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00;
        // Pick the closer of the two intersection points.
        // TODO Is there a faster way to determine which intersection to use?
        if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
        return {
            cx: cx0,
            cy: cy0,
            x01: -ox,
            y01: -oy,
            x11: cx0 * (r1 / r - 1),
            y11: cy0 * (r1 / r - 1)
        };
    }
    function arc() {
        var innerRadius = arcInnerRadius, outerRadius = arcOuterRadius, cornerRadius = constant$1(0), padRadius = null, startAngle = arcStartAngle, endAngle = arcEndAngle, padAngle = arcPadAngle, context = null;
        function arc() {
            var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - halfPi, a1 = endAngle.apply(this, arguments) - halfPi, da = abs(a1 - a0), cw = a1 > a0;
            if (!context) context = buffer = path();
            // Ensure that the outer radius is always larger than the inner radius.
            if (r1 < r0) r = r1, r1 = r0, r0 = r;
            // Is it a point?
            if (!(r1 > epsilon)) context.moveTo(0, 0);
            else if (da > tau - epsilon) {
                context.moveTo(r1 * cos(a0), r1 * sin(a0));
                context.arc(0, 0, r1, a0, a1, !cw);
                if (r0 > epsilon) {
                    context.moveTo(r0 * cos(a1), r0 * sin(a1));
                    context.arc(0, 0, r0, a1, a0, cw);
                }
            } else {
                var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > epsilon && (padRadius ? +padRadius.apply(this, arguments) : sqrt(r0 * r0 + r1 * r1)), rc = min(abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1;
                // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
                if (rp > epsilon) {
                    var p0 = asin(rp / r0 * sin(ap)), p1 = asin(rp / r1 * sin(ap));
                    if ((da0 -= p0 * 2) > epsilon) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                    else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                    if ((da1 -= p1 * 2) > epsilon) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                    else da1 = 0, a01 = a11 = (a0 + a1) / 2;
                }
                var x01 = r1 * cos(a01), y01 = r1 * sin(a01), x10 = r0 * cos(a10), y10 = r0 * sin(a10);
                // Apply rounded corners?
                if (rc > epsilon) {
                    var x11 = r1 * cos(a11), y11 = r1 * sin(a11), x00 = r0 * cos(a00), y00 = r0 * sin(a00), oc;
                    // Restrict the corner radius according to the sector angle.
                    if (da < pi && (oc = intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
                        var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / sin(acos((ax * bx + ay * by) / (sqrt(ax * ax + ay * ay) * sqrt(bx * bx + by * by))) / 2), lc = sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
                        rc0 = min(rc, (r0 - lc) / (kc - 1));
                        rc1 = min(rc, (r1 - lc) / (kc + 1));
                    }
                }
                // Is the sector collapsed to a line?
                if (!(da1 > epsilon)) context.moveTo(x01, y01);
                else if (rc1 > epsilon) {
                    t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                    t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                    context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
                    // Have the corners merged?
                    if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);
                    else {
                        context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
                        context.arc(0, 0, r1, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                        context.arc(t1.cx, t1.cy, rc1, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
                    }
                } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
                // Is there no inner ring, and it’s a circular sector?
                // Or perhaps it’s an annular sector collapsed due to padding?
                if (!(r0 > epsilon) || !(da0 > epsilon)) context.lineTo(x10, y10);
                else if (rc0 > epsilon) {
                    t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                    t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                    context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
                    // Have the corners merged?
                    if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);
                    else {
                        context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
                        context.arc(0, 0, r0, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                        context.arc(t1.cx, t1.cy, rc0, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
                    }
                } else context.arc(0, 0, r0, a10, a00, cw);
            }
            context.closePath();
            if (buffer) return context = null, buffer + "" || null;
        }
        arc.centroid = function() {
            var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi / 2;
            return [
                cos(a) * r,
                sin(a) * r
            ];
        };
        arc.innerRadius = function(_) {
            return arguments.length ? (innerRadius = typeof _ === "function" ? _ : constant$1(+_), arc) : innerRadius;
        };
        arc.outerRadius = function(_) {
            return arguments.length ? (outerRadius = typeof _ === "function" ? _ : constant$1(+_), arc) : outerRadius;
        };
        arc.cornerRadius = function(_) {
            return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : constant$1(+_), arc) : cornerRadius;
        };
        arc.padRadius = function(_) {
            return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : constant$1(+_), arc) : padRadius;
        };
        arc.startAngle = function(_) {
            return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$1(+_), arc) : startAngle;
        };
        arc.endAngle = function(_) {
            return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$1(+_), arc) : endAngle;
        };
        arc.padAngle = function(_) {
            return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant$1(+_), arc) : padAngle;
        };
        arc.context = function(_) {
            return arguments.length ? (context = _ == null ? null : _, arc) : context;
        };
        return arc;
    }
    var slice = Array.prototype.slice;
    function array(x) {
        return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
         : Array.from(x); // Map, Set, iterable, string, or anything else
    }
    function Linear(context) {
        this._context = context;
    }
    Linear.prototype = {
        areaStart: function() {
            this._line = 0;
        },
        areaEnd: function() {
            this._line = NaN;
        },
        lineStart: function() {
            this._point = 0;
        },
        lineEnd: function() {
            if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
            this._line = 1 - this._line;
        },
        point: function(x, y) {
            x = +x, y = +y;
            switch(this._point){
                case 0:
                    this._point = 1;
                    this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                    break;
                case 1:
                    this._point = 2; // falls through
                default:
                    this._context.lineTo(x, y);
                    break;
            }
        }
    };
    function curveLinear(context) {
        return new Linear(context);
    }
    function x$1(p) {
        return p[0];
    }
    function y(p) {
        return p[1];
    }
    function line(x, y$1) {
        var defined = constant$1(true), context = null, curve = curveLinear, output = null;
        x = typeof x === "function" ? x : x === undefined ? x$1 : constant$1(x);
        y$1 = typeof y$1 === "function" ? y$1 : y$1 === undefined ? y : constant$1(y$1);
        function line(data) {
            var i, n = (data = array(data)).length, d, defined0 = false, buffer;
            if (context == null) output = curve(buffer = path());
            for(i = 0; i <= n; ++i){
                if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                    if (defined0 = !defined0) output.lineStart();
                    else output.lineEnd();
                }
                if (defined0) output.point(+x(d, i, data), +y$1(d, i, data));
            }
            if (buffer) return output = null, buffer + "" || null;
        }
        line.x = function(_) {
            return arguments.length ? (x = typeof _ === "function" ? _ : constant$1(+_), line) : x;
        };
        line.y = function(_) {
            return arguments.length ? (y$1 = typeof _ === "function" ? _ : constant$1(+_), line) : y$1;
        };
        line.defined = function(_) {
            return arguments.length ? (defined = typeof _ === "function" ? _ : constant$1(!!_), line) : defined;
        };
        line.curve = function(_) {
            return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
        };
        line.context = function(_) {
            return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
        };
        return line;
    }
    function area(x0, y0, y1) {
        var x1 = null, defined = constant$1(true), context = null, curve = curveLinear, output = null;
        x0 = typeof x0 === "function" ? x0 : x0 === undefined ? x$1 : constant$1(+x0);
        y0 = typeof y0 === "function" ? y0 : y0 === undefined ? constant$1(0) : constant$1(+y0);
        y1 = typeof y1 === "function" ? y1 : y1 === undefined ? y : constant$1(+y1);
        function area(data) {
            var i, j, k, n = (data = array(data)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
            if (context == null) output = curve(buffer = path());
            for(i = 0; i <= n; ++i){
                if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                    if (defined0 = !defined0) {
                        j = i;
                        output.areaStart();
                        output.lineStart();
                    } else {
                        output.lineEnd();
                        output.lineStart();
                        for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                        output.lineEnd();
                        output.areaEnd();
                    }
                }
                if (defined0) {
                    x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                    output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
                }
            }
            if (buffer) return output = null, buffer + "" || null;
        }
        function arealine() {
            return line().defined(defined).curve(curve).context(context);
        }
        area.x = function(_) {
            return arguments.length ? (x0 = typeof _ === "function" ? _ : constant$1(+_), x1 = null, area) : x0;
        };
        area.x0 = function(_) {
            return arguments.length ? (x0 = typeof _ === "function" ? _ : constant$1(+_), area) : x0;
        };
        area.x1 = function(_) {
            return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : constant$1(+_), area) : x1;
        };
        area.y = function(_) {
            return arguments.length ? (y0 = typeof _ === "function" ? _ : constant$1(+_), y1 = null, area) : y0;
        };
        area.y0 = function(_) {
            return arguments.length ? (y0 = typeof _ === "function" ? _ : constant$1(+_), area) : y0;
        };
        area.y1 = function(_) {
            return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : constant$1(+_), area) : y1;
        };
        area.lineX0 = area.lineY0 = function() {
            return arealine().x(x0).y(y0);
        };
        area.lineY1 = function() {
            return arealine().x(x0).y(y1);
        };
        area.lineX1 = function() {
            return arealine().x(x1).y(y0);
        };
        area.defined = function(_) {
            return arguments.length ? (defined = typeof _ === "function" ? _ : constant$1(!!_), area) : defined;
        };
        area.curve = function(_) {
            return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
        };
        area.context = function(_) {
            return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
        };
        return area;
    }
    function descending$1(a, b) {
        return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
    }
    function identity$1(d) {
        return d;
    }
    function pie() {
        var value = identity$1, sortValues = descending$1, sort = null, startAngle = constant$1(0), endAngle = constant$1(tau), padAngle = constant$1(0);
        function pie(data) {
            var i, n = (data = array(data)).length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min(tau, Math.max(-tau, endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
            for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
            // Optionally sort the arcs by previously-computed values or by data.
            if (sortValues != null) index.sort(function(i, j) {
                return sortValues(arcs[i], arcs[j]);
            });
            else if (sort != null) index.sort(function(i, j) {
                return sort(data[i], data[j]);
            });
            // Compute the arcs! They are stored in the original data's order.
            for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
                data: data[j],
                index: i,
                value: v,
                startAngle: a0,
                endAngle: a1,
                padAngle: p
            };
            return arcs;
        }
        pie.value = function(_) {
            return arguments.length ? (value = typeof _ === "function" ? _ : constant$1(+_), pie) : value;
        };
        pie.sortValues = function(_) {
            return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
        };
        pie.sort = function(_) {
            return arguments.length ? (sort = _, sortValues = null, pie) : sort;
        };
        pie.startAngle = function(_) {
            return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$1(+_), pie) : startAngle;
        };
        pie.endAngle = function(_) {
            return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$1(+_), pie) : endAngle;
        };
        pie.padAngle = function(_) {
            return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant$1(+_), pie) : padAngle;
        };
        return pie;
    }
    var curveRadialLinear = curveRadial(curveLinear);
    function Radial(curve) {
        this._curve = curve;
    }
    Radial.prototype = {
        areaStart: function() {
            this._curve.areaStart();
        },
        areaEnd: function() {
            this._curve.areaEnd();
        },
        lineStart: function() {
            this._curve.lineStart();
        },
        lineEnd: function() {
            this._curve.lineEnd();
        },
        point: function(a, r) {
            this._curve.point(r * Math.sin(a), r * -Math.cos(a));
        }
    };
    function curveRadial(curve) {
        function radial(context) {
            return new Radial(curve(context));
        }
        radial._curve = curve;
        return radial;
    }
    function lineRadial(l) {
        var c = l.curve;
        l.angle = l.x, delete l.x;
        l.radius = l.y, delete l.y;
        l.curve = function(_) {
            return arguments.length ? c(curveRadial(_)) : c()._curve;
        };
        return l;
    }
    function lineRadial$1() {
        return lineRadial(line().curve(curveRadialLinear));
    }
    function areaRadial() {
        var a = area().curve(curveRadialLinear), c = a.curve, x0 = a.lineX0, x1 = a.lineX1, y0 = a.lineY0, y1 = a.lineY1;
        a.angle = a.x, delete a.x;
        a.startAngle = a.x0, delete a.x0;
        a.endAngle = a.x1, delete a.x1;
        a.radius = a.y, delete a.y;
        a.innerRadius = a.y0, delete a.y0;
        a.outerRadius = a.y1, delete a.y1;
        a.lineStartAngle = function() {
            return lineRadial(x0());
        }, delete a.lineX0;
        a.lineEndAngle = function() {
            return lineRadial(x1());
        }, delete a.lineX1;
        a.lineInnerRadius = function() {
            return lineRadial(y0());
        }, delete a.lineY0;
        a.lineOuterRadius = function() {
            return lineRadial(y1());
        }, delete a.lineY1;
        a.curve = function(_) {
            return arguments.length ? c(curveRadial(_)) : c()._curve;
        };
        return a;
    }
    function pointRadial(x, y) {
        return [
            (y = +y) * Math.cos(x -= Math.PI / 2),
            y * Math.sin(x)
        ];
    }
    class Bump {
        constructor(context, x){
            this._context = context;
            this._x = x;
        }
        areaStart() {
            this._line = 0;
        }
        areaEnd() {
            this._line = NaN;
        }
        lineStart() {
            this._point = 0;
        }
        lineEnd() {
            if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
            this._line = 1 - this._line;
        }
        point(x, y) {
            x = +x, y = +y;
            switch(this._point){
                case 0:
                    this._point = 1;
                    if (this._line) this._context.lineTo(x, y);
                    else this._context.moveTo(x, y);
                    break;
                case 1:
                    this._point = 2; // falls through
                default:
                    if (this._x) this._context.bezierCurveTo(this._x0 = (this._x0 + x) / 2, this._y0, this._x0, y, x, y);
                    else this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + y) / 2, x, this._y0, x, y);
                    break;
            }
            this._x0 = x, this._y0 = y;
        }
    }
    class BumpRadial {
        constructor(context){
            this._context = context;
        }
        lineStart() {
            this._point = 0;
        }
        lineEnd() {}
        point(x, y) {
            x = +x, y = +y;
            if (this._point++ === 0) this._x0 = x, this._y0 = y;
            else {
                const p0 = pointRadial(this._x0, this._y0);
                const p1 = pointRadial(this._x0, this._y0 = (this._y0 + y) / 2);
                const p2 = pointRadial(x, this._y0);
                const p3 = pointRadial(x, y);
                this._context.moveTo(...p0);
                this._context.bezierCurveTo(...p1, ...p2, ...p3);
            }
        }
    }
    function bumpX(context) {
        return new Bump(context, true);
    }
    function bumpY(context) {
        return new Bump(context, false);
    }
    function bumpRadial(context) {
        return new BumpRadial(context);
    }
    function linkSource(d) {
        return d.source;
    }
    function linkTarget(d) {
        return d.target;
    }
    function link(curve) {
        let source = linkSource;
        let target = linkTarget;
        let x = x$1;
        let y$1 = y;
        let context = null;
        let output = null;
        function link() {
            let buffer;
            const argv = slice.call(arguments);
            const s = source.apply(this, argv);
            const t = target.apply(this, argv);
            if (context == null) output = curve(buffer = path());
            output.lineStart();
            argv[0] = s, output.point(+x.apply(this, argv), +y$1.apply(this, argv));
            argv[0] = t, output.point(+x.apply(this, argv), +y$1.apply(this, argv));
            output.lineEnd();
            if (buffer) return output = null, buffer + "" || null;
        }
        link.source = function(_) {
            return arguments.length ? (source = _, link) : source;
        };
        link.target = function(_) {
            return arguments.length ? (target = _, link) : target;
        };
        link.x = function(_) {
            return arguments.length ? (x = typeof _ === "function" ? _ : constant$1(+_), link) : x;
        };
        link.y = function(_) {
            return arguments.length ? (y$1 = typeof _ === "function" ? _ : constant$1(+_), link) : y$1;
        };
        link.context = function(_) {
            return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), link) : context;
        };
        return link;
    }
    function linkHorizontal() {
        return link(bumpX);
    }
    function linkVertical() {
        return link(bumpY);
    }
    function linkRadial() {
        const l = link(bumpRadial);
        l.angle = l.x, delete l.x;
        l.radius = l.y, delete l.y;
        return l;
    }
    const sqrt3$2 = sqrt(3);
    var asterisk = {
        draw (context, size) {
            const r = sqrt(size + min(size / 28, 0.75)) * 0.59436;
            const t = r / 2;
            const u = t * sqrt3$2;
            context.moveTo(0, r);
            context.lineTo(0, -r);
            context.moveTo(-u, -t);
            context.lineTo(u, t);
            context.moveTo(-u, t);
            context.lineTo(u, -t);
        }
    };
    var circle = {
        draw (context, size) {
            const r = sqrt(size / pi);
            context.moveTo(r, 0);
            context.arc(0, 0, r, 0, tau);
        }
    };
    var cross = {
        draw (context, size) {
            const r = sqrt(size / 5) / 2;
            context.moveTo(-3 * r, -r);
            context.lineTo(-r, -r);
            context.lineTo(-r, -3 * r);
            context.lineTo(r, -3 * r);
            context.lineTo(r, -r);
            context.lineTo(3 * r, -r);
            context.lineTo(3 * r, r);
            context.lineTo(r, r);
            context.lineTo(r, 3 * r);
            context.lineTo(-r, 3 * r);
            context.lineTo(-r, r);
            context.lineTo(-3 * r, r);
            context.closePath();
        }
    };
    const tan30 = sqrt(1 / 3);
    const tan30_2 = tan30 * 2;
    var diamond = {
        draw (context, size) {
            const y = sqrt(size / tan30_2);
            const x = y * tan30;
            context.moveTo(0, -y);
            context.lineTo(x, 0);
            context.lineTo(0, y);
            context.lineTo(-x, 0);
            context.closePath();
        }
    };
    var diamond2 = {
        draw (context, size) {
            const r = sqrt(size) * 0.62625;
            context.moveTo(0, -r);
            context.lineTo(r, 0);
            context.lineTo(0, r);
            context.lineTo(-r, 0);
            context.closePath();
        }
    };
    var plus = {
        draw (context, size) {
            const r = sqrt(size - min(size / 7, 2)) * 0.87559;
            context.moveTo(-r, 0);
            context.lineTo(r, 0);
            context.moveTo(0, r);
            context.lineTo(0, -r);
        }
    };
    var square = {
        draw (context, size) {
            const w = sqrt(size);
            const x = -w / 2;
            context.rect(x, x, w, w);
        }
    };
    var square2 = {
        draw (context, size) {
            const r = sqrt(size) * 0.4431;
            context.moveTo(r, r);
            context.lineTo(r, -r);
            context.lineTo(-r, -r);
            context.lineTo(-r, r);
            context.closePath();
        }
    };
    const ka = 0.89081309152928522810;
    const kr = sin(pi / 10) / sin(7 * pi / 10);
    const kx = sin(tau / 10) * kr;
    const ky = -cos(tau / 10) * kr;
    var star = {
        draw (context, size) {
            const r = sqrt(size * ka);
            const x = kx * r;
            const y = ky * r;
            context.moveTo(0, -r);
            context.lineTo(x, y);
            for(let i = 1; i < 5; ++i){
                const a = tau * i / 5;
                const c = cos(a);
                const s = sin(a);
                context.lineTo(s * r, -c * r);
                context.lineTo(c * x - s * y, s * x + c * y);
            }
            context.closePath();
        }
    };
    const sqrt3$1 = sqrt(3);
    var triangle = {
        draw (context, size) {
            const y = -sqrt(size / (sqrt3$1 * 3));
            context.moveTo(0, y * 2);
            context.lineTo(-sqrt3$1 * y, -y);
            context.lineTo(sqrt3$1 * y, -y);
            context.closePath();
        }
    };
    const sqrt3 = sqrt(3);
    var triangle2 = {
        draw (context, size) {
            const s = sqrt(size) * 0.6824;
            const t = s / 2;
            const u = s * sqrt3 / 2; // cos(Math.PI / 6)
            context.moveTo(0, -s);
            context.lineTo(u, t);
            context.lineTo(-u, t);
            context.closePath();
        }
    };
    const c = -0.5;
    const s = sqrt(3) / 2;
    const k = 1 / sqrt(12);
    const a = (k / 2 + 1) * 3;
    var wye = {
        draw (context, size) {
            const r = sqrt(size / a);
            const x0 = r / 2, y0 = r * k;
            const x1 = x0, y1 = r * k + r;
            const x2 = -x1, y2 = y1;
            context.moveTo(x0, y0);
            context.lineTo(x1, y1);
            context.lineTo(x2, y2);
            context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
            context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
            context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
            context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
            context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
            context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
            context.closePath();
        }
    };
    var x = {
        draw (context, size) {
            const r = sqrt(size - min(size / 6, 1.7)) * 0.6189;
            context.moveTo(-r, -r);
            context.lineTo(r, r);
            context.moveTo(-r, r);
            context.lineTo(r, -r);
        }
    };
    // These symbols are designed to be filled.
    const symbolsFill = [
        circle,
        cross,
        diamond,
        square,
        star,
        triangle,
        wye
    ];
    // These symbols are designed to be stroked (with a width of 1.5px and round caps).
    const symbolsStroke = [
        circle,
        plus,
        x,
        triangle2,
        asterisk,
        square2,
        diamond2
    ];
    function Symbol$1(type, size) {
        let context = null;
        type = typeof type === "function" ? type : constant$1(type || circle);
        size = typeof size === "function" ? size : constant$1(size === undefined ? 64 : +size);
        function symbol() {
            let buffer;
            if (!context) context = buffer = path();
            type.apply(this, arguments).draw(context, +size.apply(this, arguments));
            if (buffer) return context = null, buffer + "" || null;
        }
        symbol.type = function(_) {
            return arguments.length ? (type = typeof _ === "function" ? _ : constant$1(_), symbol) : type;
        };
        symbol.size = function(_) {
            return arguments.length ? (size = typeof _ === "function" ? _ : constant$1(+_), symbol) : size;
        };
        symbol.context = function(_) {
            return arguments.length ? (context = _ == null ? null : _, symbol) : context;
        };
        return symbol;
    }
    function noop() {}
    function point$3(that, x, y) {
        that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
    }
    function Basis(context) {
        this._context = context;
    }
    Basis.prototype = {
        areaStart: function() {
            this._line = 0;
        },
        areaEnd: function() {
            this._line = NaN;
        },
        lineStart: function() {
            this._x0 = this._x1 = this._y0 = this._y1 = NaN;
            this._point = 0;
        },
        lineEnd: function() {
            switch(this._point){
                case 3:
                    point$3(this, this._x1, this._y1); // falls through
                case 2:
                    this._context.lineTo(this._x1, this._y1);
                    break;
            }
            if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
            this._line = 1 - this._line;
        },
        point: function(x, y) {
            x = +x, y = +y;
            switch(this._point){
                case 0:
                    this._point = 1;
                    this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                    break;
                case 1:
                    this._point = 2;
                    break;
                case 2:
                    this._point = 3;
                    this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // falls through
                default:
                    point$3(this, x, y);
                    break;
            }
            this._x0 = this._x1, this._x1 = x;
            this._y0 = this._y1, this._y1 = y;
        }
    };
    function basis(context) {
        return new Basis(context);
    }
    function BasisClosed(context) {
        this._context = context;
    }
    BasisClosed.prototype = {
        areaStart: noop,
        areaEnd: noop,
        lineStart: function() {
            this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
            this._point = 0;
        },
        lineEnd: function() {
            switch(this._point){
                case 1:
                    this._context.moveTo(this._x2, this._y2);
                    this._context.closePath();
                    break;
                case 2:
                    this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                    this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                    this._context.closePath();
                    break;
                case 3:
                    this.point(this._x2, this._y2);
                    this.point(this._x3, this._y3);
                    this.point(this._x4, this._y4);
                    break;
            }
        },
        point: function(x, y) {
            x = +x, y = +y;
            switch(this._point){
                case 0:
                    this._point = 1;
                    this._x2 = x, this._y2 = y;
                    break;
                case 1:
                    this._point = 2;
                    this._x3 = x, this._y3 = y;
                    break;
                case 2:
                    this._point = 3;
                    this._x4 = x, this._y4 = y;
                    this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                    break;
                default:
                    point$3(this, x, y);
                    break;
            }
            this._x0 = this._x1, this._x1 = x;
            this._y0 = this._y1, this._y1 = y;
        }
    };
    function basisClosed(context) {
        return new BasisClosed(context);
    }
    function BasisOpen(context) {
        this._context = context;
    }
    BasisOpen.prototype = {
        areaStart: function() {
            this._line = 0;
        },
        areaEnd: function() {
            this._line = NaN;
        },
        lineStart: function() {
            this._x0 = this._x1 = this._y0 = this._y1 = NaN;
            this._point = 0;
        },
        lineEnd: function() {
            if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
            this._line = 1 - this._line;
        },
        point: function(x, y) {
            x = +x, y = +y;
            switch(this._point){
                case 0:
                    this._point = 1;
                    break;
                case 1:
                    this._point = 2;
                    break;
                case 2:
                    this._point = 3;
                    var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                    this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                    break;
                case 3:
                    this._point = 4; // falls through
                default:
                    point$3(this, x, y);
                    break;
            }
            this._x0 = this._x1, this._x1 = x;
            this._y0 = this._y1, this._y1 = y;
        }
    };
    function basisOpen(context) {
        return new BasisOpen(context);
    }
    function Bundle(context, beta) {
        this._basis = new Basis(context);
        this._beta = beta;
    }
    Bundle.prototype = {
        lineStart: function() {
            this._x = [];
            this._y = [];
            this._basis.lineStart();
        },
        lineEnd: function() {
            var x = this._x, y = this._y, j = x.length - 1;
            if (j > 0) {
                var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
                while(++i <= j){
                    t = i / j;
                    this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
                }
            }
            this._x = this._y = null;
            this._basis.lineEnd();
        },
        point: function(x, y) {
            this._x.push(+x);
            this._y.push(+y);
        }
    };
    var bundle = function custom(beta) {
        function bundle(context) {
            return beta === 1 ? new Basis(context) : new Bundle(context, beta);
        }
        bundle.beta = function(beta) {
            return custom(+beta);
        };
        return bundle;
    }(0.85);
    function point$2(that, x, y) {
        that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
    }
    function Cardinal(context, tension) {
        this._context = context;
        this._k = (1 - tension) / 6;
    }
    Cardinal.prototype = {
        areaStart: function() {
            this._line = 0;
        },
        areaEnd: function() {
            this._line = NaN;
        },
        lineStart: function() {
            this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
            this._point = 0;
        },
        lineEnd: function() {
            switch(this._point){
                case 2:
                    this._context.lineTo(this._x2, this._y2);
                    break;
                case 3:
                    point$2(this, this._x1, this._y1);
                    break;
            }
            if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
            this._line = 1 - this._line;
        },
        point: function(x, y) {
            x = +x, y = +y;
            switch(this._point){
                case 0:
                    this._point = 1;
                    this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                    break;
                case 1:
                    this._point = 2;
                    this._x1 = x, this._y1 = y;
                    break;
                case 2:
                    this._point = 3; // falls through
                default:
                    point$2(this, x, y);
                    break;
            }
            this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
            this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
        }
    };
    var cardinal = function custom(tension) {
        function cardinal(context) {
            return new Cardinal(context, tension);
        }
        cardinal.tension = function(tension) {
            return custom(+tension);
        };
        return cardinal;
    }(0);
    function CardinalClosed(context, tension) {
        this._context = context;
        this._k = (1 - tension) / 6;
    }
    CardinalClosed.prototype = {
        areaStart: noop,
        areaEnd: noop,
        lineStart: function() {
            this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
            this._point = 0;
        },
        lineEnd: function() {
            switch(this._point){
                case 1:
                    this._context.moveTo(this._x3, this._y3);
                    this._context.closePath();
                    break;
                case 2:
                    this._context.lineTo(this._x3, this._y3);
                    this._context.closePath();
                    break;
                case 3:
                    this.point(this._x3, this._y3);
                    this.point(this._x4, this._y4);
                    this.point(this._x5, this._y5);
                    break;
            }
        },
        point: function(x, y) {
            x = +x, y = +y;
            switch(this._point){
                case 0:
                    this._point = 1;
                    this._x3 = x, this._y3 = y;
                    break;
                case 1:
                    this._point = 2;
                    this._context.moveTo(this._x4 = x, this._y4 = y);
                    break;
                case 2:
                    this._point = 3;
                    this._x5 = x, this._y5 = y;
                    break;
                default:
                    point$2(this, x, y);
                    break;
            }
            this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
            this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
        }
    };
    var cardinalClosed = function custom(tension) {
        function cardinal(context) {
            return new CardinalClosed(context, tension);
        }
        cardinal.tension = function(tension) {
            return custom(+tension);
        };
        return cardinal;
    }(0);
    function CardinalOpen(context, tension) {
        this._context = context;
        this._k = (1 - tension) / 6;
    }
    CardinalOpen.prototype = {
        areaStart: function() {
            this._line = 0;
        },
        areaEnd: function() {
            this._line = NaN;
        },
        lineStart: function() {
            this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
            this._point = 0;
        },
        lineEnd: function() {
            if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
            this._line = 1 - this._line;
        },
        point: function(x, y) {
            x = +x, y = +y;
            switch(this._point){
                case 0:
                    this._point = 1;
                    break;
                case 1:
                    this._point = 2;
                    break;
                case 2:
                    this._point = 3;
                    this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                    break;
                case 3:
                    this._point = 4; // falls through
                default:
                    point$2(this, x, y);
                    break;
            }
            this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
            this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
        }
    };
    var cardinalOpen = function custom(tension) {
        function cardinal(context) {
            return new CardinalOpen(context, tension);
        }
        cardinal.tension = function(tension) {
            return custom(+tension);
        };
        return cardinal;
    }(0);
    function point$1(that, x, y) {
        var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
        if (that._l01_a > epsilon) {
            var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
            x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
            y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
        }
        if (that._l23_a > epsilon) {
            var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
            x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
            y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
        }
        that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
    }
    function CatmullRom(context, alpha) {
        this._context = context;
        this._alpha = alpha;
    }
    CatmullRom.prototype = {
        areaStart: function() {
            this._line = 0;
        },
        areaEnd: function() {
            this._line = NaN;
        },
        lineStart: function() {
            this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
            this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
        },
        lineEnd: function() {
            switch(this._point){
                case 2:
                    this._context.lineTo(this._x2, this._y2);
                    break;
                case 3:
                    this.point(this._x2, this._y2);
                    break;
            }
            if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
            this._line = 1 - this._line;
        },
        point: function(x, y) {
            x = +x, y = +y;
            if (this._point) {
                var x23 = this._x2 - x, y23 = this._y2 - y;
                this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
            }
            switch(this._point){
                case 0:
                    this._point = 1;
                    this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                    break;
                case 1:
                    this._point = 2;
                    break;
                case 2:
                    this._point = 3; // falls through
                default:
                    point$1(this, x, y);
                    break;
            }
            this._l01_a = this._l12_a, this._l12_a = this._l23_a;
            this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
            this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
            this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
        }
    };
    var catmullRom = function custom(alpha) {
        function catmullRom(context) {
            return alpha ? new CatmullRom(context, alpha) : new Cardinal(context, 0);
        }
        catmullRom.alpha = function(alpha) {
            return custom(+alpha);
        };
        return catmullRom;
    }(0.5);
    function CatmullRomClosed(context, alpha) {
        this._context = context;
        this._alpha = alpha;
    }
    CatmullRomClosed.prototype = {
        areaStart: noop,
        areaEnd: noop,
        lineStart: function() {
            this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
            this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
        },
        lineEnd: function() {
            switch(this._point){
                case 1:
                    this._context.moveTo(this._x3, this._y3);
                    this._context.closePath();
                    break;
                case 2:
                    this._context.lineTo(this._x3, this._y3);
                    this._context.closePath();
                    break;
                case 3:
                    this.point(this._x3, this._y3);
                    this.point(this._x4, this._y4);
                    this.point(this._x5, this._y5);
                    break;
            }
        },
        point: function(x, y) {
            x = +x, y = +y;
            if (this._point) {
                var x23 = this._x2 - x, y23 = this._y2 - y;
                this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
            }
            switch(this._point){
                case 0:
                    this._point = 1;
                    this._x3 = x, this._y3 = y;
                    break;
                case 1:
                    this._point = 2;
                    this._context.moveTo(this._x4 = x, this._y4 = y);
                    break;
                case 2:
                    this._point = 3;
                    this._x5 = x, this._y5 = y;
                    break;
                default:
                    point$1(this, x, y);
                    break;
            }
            this._l01_a = this._l12_a, this._l12_a = this._l23_a;
            this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
            this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
            this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
        }
    };
    var catmullRomClosed = function custom(alpha) {
        function catmullRom(context) {
            return alpha ? new CatmullRomClosed(context, alpha) : new CardinalClosed(context, 0);
        }
        catmullRom.alpha = function(alpha) {
            return custom(+alpha);
        };
        return catmullRom;
    }(0.5);
    function CatmullRomOpen(context, alpha) {
        this._context = context;
        this._alpha = alpha;
    }
    CatmullRomOpen.prototype = {
        areaStart: function() {
            this._line = 0;
        },
        areaEnd: function() {
            this._line = NaN;
        },
        lineStart: function() {
            this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
            this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
        },
        lineEnd: function() {
            if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
            this._line = 1 - this._line;
        },
        point: function(x, y) {
            x = +x, y = +y;
            if (this._point) {
                var x23 = this._x2 - x, y23 = this._y2 - y;
                this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
            }
            switch(this._point){
                case 0:
                    this._point = 1;
                    break;
                case 1:
                    this._point = 2;
                    break;
                case 2:
                    this._point = 3;
                    this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                    break;
                case 3:
                    this._point = 4; // falls through
                default:
                    point$1(this, x, y);
                    break;
            }
            this._l01_a = this._l12_a, this._l12_a = this._l23_a;
            this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
            this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
            this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
        }
    };
    var catmullRomOpen = function custom(alpha) {
        function catmullRom(context) {
            return alpha ? new CatmullRomOpen(context, alpha) : new CardinalOpen(context, 0);
        }
        catmullRom.alpha = function(alpha) {
            return custom(+alpha);
        };
        return catmullRom;
    }(0.5);
    function LinearClosed(context) {
        this._context = context;
    }
    LinearClosed.prototype = {
        areaStart: noop,
        areaEnd: noop,
        lineStart: function() {
            this._point = 0;
        },
        lineEnd: function() {
            if (this._point) this._context.closePath();
        },
        point: function(x, y) {
            x = +x, y = +y;
            if (this._point) this._context.lineTo(x, y);
            else this._point = 1, this._context.moveTo(x, y);
        }
    };
    function linearClosed(context) {
        return new LinearClosed(context);
    }
    function sign(x) {
        return x < 0 ? -1 : 1;
    }
    // Calculate the slopes of the tangents (Hermite-type interpolation) based on
    // the following paper: Steffen, M. 1990. A Simple Method for Monotonic
    // Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
    // NOV(II), P. 443, 1990.
    function slope3(that, x2, y2) {
        var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
        return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
    }
    // Calculate a one-sided slope.
    function slope2(that, t) {
        var h = that._x1 - that._x0;
        return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
    }
    // According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
    // "you can express cubic Hermite interpolation in terms of cubic Bézier curves
    // with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
    function point(that, t0, t1) {
        var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
        that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
    }
    function MonotoneX(context) {
        this._context = context;
    }
    MonotoneX.prototype = {
        areaStart: function() {
            this._line = 0;
        },
        areaEnd: function() {
            this._line = NaN;
        },
        lineStart: function() {
            this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
            this._point = 0;
        },
        lineEnd: function() {
            switch(this._point){
                case 2:
                    this._context.lineTo(this._x1, this._y1);
                    break;
                case 3:
                    point(this, this._t0, slope2(this, this._t0));
                    break;
            }
            if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
            this._line = 1 - this._line;
        },
        point: function(x, y) {
            var t1 = NaN;
            x = +x, y = +y;
            if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
            switch(this._point){
                case 0:
                    this._point = 1;
                    this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                    break;
                case 1:
                    this._point = 2;
                    break;
                case 2:
                    this._point = 3;
                    point(this, slope2(this, t1 = slope3(this, x, y)), t1);
                    break;
                default:
                    point(this, this._t0, t1 = slope3(this, x, y));
                    break;
            }
            this._x0 = this._x1, this._x1 = x;
            this._y0 = this._y1, this._y1 = y;
            this._t0 = t1;
        }
    };
    function MonotoneY(context) {
        this._context = new ReflectContext(context);
    }
    (MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
        MonotoneX.prototype.point.call(this, y, x);
    };
    function ReflectContext(context) {
        this._context = context;
    }
    ReflectContext.prototype = {
        moveTo: function(x, y) {
            this._context.moveTo(y, x);
        },
        closePath: function() {
            this._context.closePath();
        },
        lineTo: function(x, y) {
            this._context.lineTo(y, x);
        },
        bezierCurveTo: function(x1, y1, x2, y2, x, y) {
            this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
        }
    };
    function monotoneX(context) {
        return new MonotoneX(context);
    }
    function monotoneY(context) {
        return new MonotoneY(context);
    }
    function Natural(context) {
        this._context = context;
    }
    Natural.prototype = {
        areaStart: function() {
            this._line = 0;
        },
        areaEnd: function() {
            this._line = NaN;
        },
        lineStart: function() {
            this._x = [];
            this._y = [];
        },
        lineEnd: function() {
            var x = this._x, y = this._y, n = x.length;
            if (n) {
                this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
                if (n === 2) this._context.lineTo(x[1], y[1]);
                else {
                    var px = controlPoints(x), py = controlPoints(y);
                    for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
                }
            }
            if (this._line || this._line !== 0 && n === 1) this._context.closePath();
            this._line = 1 - this._line;
            this._x = this._y = null;
        },
        point: function(x, y) {
            this._x.push(+x);
            this._y.push(+y);
        }
    };
    // See https://www.particleincell.com/2012/bezier-splines/ for derivation.
    function controlPoints(x) {
        var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
        a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
        for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
        a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
        for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
        a[n - 1] = r[n - 1] / b[n - 1];
        for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
        b[n - 1] = (x[n] + a[n - 1]) / 2;
        for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
        return [
            a,
            b
        ];
    }
    function natural(context) {
        return new Natural(context);
    }
    function Step(context, t) {
        this._context = context;
        this._t = t;
    }
    Step.prototype = {
        areaStart: function() {
            this._line = 0;
        },
        areaEnd: function() {
            this._line = NaN;
        },
        lineStart: function() {
            this._x = this._y = NaN;
            this._point = 0;
        },
        lineEnd: function() {
            if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
            if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
            if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
        },
        point: function(x, y) {
            x = +x, y = +y;
            switch(this._point){
                case 0:
                    this._point = 1;
                    this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                    break;
                case 1:
                    this._point = 2; // falls through
                default:
                    if (this._t <= 0) {
                        this._context.lineTo(this._x, y);
                        this._context.lineTo(x, y);
                    } else {
                        var x1 = this._x * (1 - this._t) + x * this._t;
                        this._context.lineTo(x1, this._y);
                        this._context.lineTo(x1, y);
                    }
                    break;
            }
            this._x = x, this._y = y;
        }
    };
    function step(context) {
        return new Step(context, 0.5);
    }
    function stepBefore(context) {
        return new Step(context, 0);
    }
    function stepAfter(context) {
        return new Step(context, 1);
    }
    function none$1(series, order) {
        if (!((n = series.length) > 1)) return;
        for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
            s0 = s1, s1 = series[order[i]];
            for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
        }
    }
    function none(series) {
        var n = series.length, o = new Array(n);
        while(--n >= 0)o[n] = n;
        return o;
    }
    function stackValue(d, key) {
        return d[key];
    }
    function stackSeries(key) {
        const series = [];
        series.key = key;
        return series;
    }
    function stack() {
        var keys = constant$1([]), order = none, offset = none$1, value = stackValue;
        function stack(data) {
            var sz = Array.from(keys.apply(this, arguments), stackSeries), i, n = sz.length, j = -1, oz;
            for (const d of data)for(i = 0, ++j; i < n; ++i)(sz[i][j] = [
                0,
                +value(d, sz[i].key, j, data)
            ]).data = d;
            for(i = 0, oz = array(order(sz)); i < n; ++i)sz[oz[i]].index = i;
            offset(sz, oz);
            return sz;
        }
        stack.keys = function(_) {
            return arguments.length ? (keys = typeof _ === "function" ? _ : constant$1(Array.from(_)), stack) : keys;
        };
        stack.value = function(_) {
            return arguments.length ? (value = typeof _ === "function" ? _ : constant$1(+_), stack) : value;
        };
        stack.order = function(_) {
            return arguments.length ? (order = _ == null ? none : typeof _ === "function" ? _ : constant$1(Array.from(_)), stack) : order;
        };
        stack.offset = function(_) {
            return arguments.length ? (offset = _ == null ? none$1 : _, stack) : offset;
        };
        return stack;
    }
    function expand(series, order) {
        if (!((n = series.length) > 0)) return;
        for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
            for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
            if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
        }
        none$1(series, order);
    }
    function diverging(series, order) {
        if (!((n = series.length) > 0)) return;
        for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
            if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) d[0] = yp, d[1] = yp += dy;
            else if (dy < 0) d[1] = yn, d[0] = yn += dy;
            else d[0] = 0, d[1] = dy;
        }
    }
    function silhouette(series, order) {
        if (!((n = series.length) > 0)) return;
        for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
            for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
            s0[j][1] += s0[j][0] = -y / 2;
        }
        none$1(series, order);
    }
    function wiggle(series, order) {
        if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
        for(var y = 0, j = 1, s0, m, n; j < m; ++j){
            for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
                var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
                for(var k = 0; k < i; ++k){
                    var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                    s3 += skj0 - skj1;
                }
                s1 += sij0, s2 += s3 * sij0;
            }
            s0[j - 1][1] += s0[j - 1][0] = y;
            if (s1) y -= s2 / s1;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        none$1(series, order);
    }
    function appearance(series) {
        var peaks = series.map(peak);
        return none(series).sort(function(a, b) {
            return peaks[a] - peaks[b];
        });
    }
    function peak(series) {
        var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
        while(++i < n)if ((vi = +series[i][1]) > vj) vj = vi, j = i;
        return j;
    }
    function ascending(series) {
        var sums = series.map(sum);
        return none(series).sort(function(a, b) {
            return sums[a] - sums[b];
        });
    }
    function sum(series) {
        var s = 0, i = -1, n = series.length, v;
        while(++i < n)if (v = +series[i][1]) s += v;
        return s;
    }
    function descending(series) {
        return ascending(series).reverse();
    }
    function insideOut(series) {
        var n = series.length, i, j, sums = series.map(sum), order = appearance(series), top = 0, bottom = 0, tops = [], bottoms = [];
        for(i = 0; i < n; ++i){
            j = order[i];
            if (top < bottom) {
                top += sums[j];
                tops.push(j);
            } else {
                bottom += sums[j];
                bottoms.push(j);
            }
        }
        return bottoms.reverse().concat(tops);
    }
    function reverse(series) {
        return none(series).reverse();
    }
    var constant = (x)=>()=>x;
    function ZoomEvent(type, { sourceEvent: sourceEvent, target: target, transform: transform, dispatch: dispatch }) {
        Object.defineProperties(this, {
            type: {
                value: type,
                enumerable: true,
                configurable: true
            },
            sourceEvent: {
                value: sourceEvent,
                enumerable: true,
                configurable: true
            },
            target: {
                value: target,
                enumerable: true,
                configurable: true
            },
            transform: {
                value: transform,
                enumerable: true,
                configurable: true
            },
            _: {
                value: dispatch
            }
        });
    }
    function Transform(k, x, y) {
        this.k = k;
        this.x = x;
        this.y = y;
    }
    Transform.prototype = {
        constructor: Transform,
        scale: function(k) {
            return k === 1 ? this : new Transform(this.k * k, this.x, this.y);
        },
        translate: function(x, y) {
            return x === 0 & y === 0 ? this : new Transform(this.k, this.x + this.k * x, this.y + this.k * y);
        },
        apply: function(point) {
            return [
                point[0] * this.k + this.x,
                point[1] * this.k + this.y
            ];
        },
        applyX: function(x) {
            return x * this.k + this.x;
        },
        applyY: function(y) {
            return y * this.k + this.y;
        },
        invert: function(location) {
            return [
                (location[0] - this.x) / this.k,
                (location[1] - this.y) / this.k
            ];
        },
        invertX: function(x) {
            return (x - this.x) / this.k;
        },
        invertY: function(y) {
            return (y - this.y) / this.k;
        },
        rescaleX: function(x) {
            return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
        },
        rescaleY: function(y) {
            return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
        },
        toString: function() {
            return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
        }
    };
    var identity = new Transform(1, 0, 0);
    transform.prototype = Transform.prototype;
    function transform(node) {
        while(!node.__zoom)if (!(node = node.parentNode)) return identity;
        return node.__zoom;
    }
    function nopropagation(event) {
        event.stopImmediatePropagation();
    }
    function noevent(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
    }
    // Ignore right-click, since that should open the context menu.
    // except for pinch-to-zoom, which is sent as a wheel+ctrlKey event
    function defaultFilter(event) {
        return (!event.ctrlKey || event.type === 'wheel') && !event.button;
    }
    function defaultExtent() {
        var e = this;
        if (e instanceof SVGElement) {
            e = e.ownerSVGElement || e;
            if (e.hasAttribute("viewBox")) {
                e = e.viewBox.baseVal;
                return [
                    [
                        e.x,
                        e.y
                    ],
                    [
                        e.x + e.width,
                        e.y + e.height
                    ]
                ];
            }
            return [
                [
                    0,
                    0
                ],
                [
                    e.width.baseVal.value,
                    e.height.baseVal.value
                ]
            ];
        }
        return [
            [
                0,
                0
            ],
            [
                e.clientWidth,
                e.clientHeight
            ]
        ];
    }
    function defaultTransform() {
        return this.__zoom || identity;
    }
    function defaultWheelDelta(event) {
        return -event.deltaY * (event.deltaMode === 1 ? 0.05 : event.deltaMode ? 1 : 0.002) * (event.ctrlKey ? 10 : 1);
    }
    function defaultTouchable() {
        return navigator.maxTouchPoints || "ontouchstart" in this;
    }
    function defaultConstrain(transform, extent, translateExtent) {
        var dx0 = transform.invertX(extent[0][0]) - translateExtent[0][0], dx1 = transform.invertX(extent[1][0]) - translateExtent[1][0], dy0 = transform.invertY(extent[0][1]) - translateExtent[0][1], dy1 = transform.invertY(extent[1][1]) - translateExtent[1][1];
        return transform.translate(dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1), dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1));
    }
    function zoom() {
        var filter = defaultFilter, extent = defaultExtent, constrain = defaultConstrain, wheelDelta = defaultWheelDelta, touchable = defaultTouchable, scaleExtent = [
            0,
            Infinity
        ], translateExtent = [
            [
                -Infinity,
                -Infinity
            ],
            [
                Infinity,
                Infinity
            ]
        ], duration = 250, interpolate = interpolateZoom, listeners = dispatch("start", "zoom", "end"), touchstarting, touchfirst, touchending, touchDelay = 500, wheelDelay = 150, clickDistance2 = 0, tapDistance = 10;
        function zoom(selection) {
            selection.property("__zoom", defaultTransform).on("wheel.zoom", wheeled, {
                passive: false
            }).on("mousedown.zoom", mousedowned).on("dblclick.zoom", dblclicked).filter(touchable).on("touchstart.zoom", touchstarted).on("touchmove.zoom", touchmoved).on("touchend.zoom touchcancel.zoom", touchended).style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
        }
        zoom.transform = function(collection, transform, point, event) {
            var selection = collection.selection ? collection.selection() : collection;
            selection.property("__zoom", defaultTransform);
            if (collection !== selection) schedule(collection, transform, point, event);
            else selection.interrupt().each(function() {
                gesture(this, arguments).event(event).start().zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform).end();
            });
        };
        zoom.scaleBy = function(selection, k, p, event) {
            zoom.scaleTo(selection, function() {
                var k0 = this.__zoom.k, k1 = typeof k === "function" ? k.apply(this, arguments) : k;
                return k0 * k1;
            }, p, event);
        };
        zoom.scaleTo = function(selection, k, p, event) {
            zoom.transform(selection, function() {
                var e = extent.apply(this, arguments), t0 = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p, p1 = t0.invert(p0), k1 = typeof k === "function" ? k.apply(this, arguments) : k;
                return constrain(translate(scale(t0, k1), p0, p1), e, translateExtent);
            }, p, event);
        };
        zoom.translateBy = function(selection, x, y, event) {
            zoom.transform(selection, function() {
                return constrain(this.__zoom.translate(typeof x === "function" ? x.apply(this, arguments) : x, typeof y === "function" ? y.apply(this, arguments) : y), extent.apply(this, arguments), translateExtent);
            }, null, event);
        };
        zoom.translateTo = function(selection, x, y, p, event) {
            zoom.transform(selection, function() {
                var e = extent.apply(this, arguments), t = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p;
                return constrain(identity.translate(p0[0], p0[1]).scale(t.k).translate(typeof x === "function" ? -x.apply(this, arguments) : -x, typeof y === "function" ? -y.apply(this, arguments) : -y), e, translateExtent);
            }, p, event);
        };
        function scale(transform, k) {
            k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], k));
            return k === transform.k ? transform : new Transform(k, transform.x, transform.y);
        }
        function translate(transform, p0, p1) {
            var x = p0[0] - p1[0] * transform.k, y = p0[1] - p1[1] * transform.k;
            return x === transform.x && y === transform.y ? transform : new Transform(transform.k, x, y);
        }
        function centroid(extent) {
            return [
                (+extent[0][0] + +extent[1][0]) / 2,
                (+extent[0][1] + +extent[1][1]) / 2
            ];
        }
        function schedule(transition, transform, point, event) {
            transition.on("start.zoom", function() {
                gesture(this, arguments).event(event).start();
            }).on("interrupt.zoom end.zoom", function() {
                gesture(this, arguments).event(event).end();
            }).tween("zoom", function() {
                var that = this, args = arguments, g = gesture(that, args).event(event), e = extent.apply(that, args), p = point == null ? centroid(e) : typeof point === "function" ? point.apply(that, args) : point, w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]), a = that.__zoom, b = typeof transform === "function" ? transform.apply(that, args) : transform, i = interpolate(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
                return function(t) {
                    if (t === 1) t = b; // Avoid rounding error on end.
                    else {
                        var l = i(t), k = w / l[2];
                        t = new Transform(k, p[0] - l[0] * k, p[1] - l[1] * k);
                    }
                    g.zoom(null, t);
                };
            });
        }
        function gesture(that, args, clean) {
            return !clean && that.__zooming || new Gesture(that, args);
        }
        function Gesture(that, args) {
            this.that = that;
            this.args = args;
            this.active = 0;
            this.sourceEvent = null;
            this.extent = extent.apply(that, args);
            this.taps = 0;
        }
        Gesture.prototype = {
            event: function(event) {
                if (event) this.sourceEvent = event;
                return this;
            },
            start: function() {
                if (++this.active === 1) {
                    this.that.__zooming = this;
                    this.emit("start");
                }
                return this;
            },
            zoom: function(key, transform) {
                if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
                if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
                if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
                this.that.__zoom = transform;
                this.emit("zoom");
                return this;
            },
            end: function() {
                if (--this.active === 0) {
                    delete this.that.__zooming;
                    this.emit("end");
                }
                return this;
            },
            emit: function(type) {
                var d = select(this.that).datum();
                listeners.call(type, this.that, new ZoomEvent(type, {
                    sourceEvent: this.sourceEvent,
                    target: zoom,
                    type: type,
                    transform: this.that.__zoom,
                    dispatch: listeners
                }), d);
            }
        };
        function wheeled(event, ...args) {
            if (!filter.apply(this, arguments)) return;
            var g = gesture(this, args).event(event), t = this.__zoom, k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], t.k * Math.pow(2, wheelDelta.apply(this, arguments)))), p = pointer(event);
            // If the mouse is in the same location as before, reuse it.
            // If there were recent wheel events, reset the wheel idle timeout.
            if (g.wheel) {
                if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) g.mouse[1] = t.invert(g.mouse[0] = p);
                clearTimeout(g.wheel);
            } else if (t.k === k) return;
            else {
                g.mouse = [
                    p,
                    t.invert(p)
                ];
                interrupt(this);
                g.start();
            }
            noevent(event);
            g.wheel = setTimeout(wheelidled, wheelDelay);
            g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent, translateExtent));
            function wheelidled() {
                g.wheel = null;
                g.end();
            }
        }
        function mousedowned(event, ...args) {
            if (touchending || !filter.apply(this, arguments)) return;
            var currentTarget = event.currentTarget, g = gesture(this, args, true).event(event), v = select(event.view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true), p = pointer(event, currentTarget), x0 = event.clientX, y0 = event.clientY;
            dragDisable(event.view);
            nopropagation(event);
            g.mouse = [
                p,
                this.__zoom.invert(p)
            ];
            interrupt(this);
            g.start();
            function mousemoved(event) {
                noevent(event);
                if (!g.moved) {
                    var dx = event.clientX - x0, dy = event.clientY - y0;
                    g.moved = dx * dx + dy * dy > clickDistance2;
                }
                g.event(event).zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = pointer(event, currentTarget), g.mouse[1]), g.extent, translateExtent));
            }
            function mouseupped(event) {
                v.on("mousemove.zoom mouseup.zoom", null);
                yesdrag(event.view, g.moved);
                noevent(event);
                g.event(event).end();
            }
        }
        function dblclicked(event, ...args) {
            if (!filter.apply(this, arguments)) return;
            var t0 = this.__zoom, p0 = pointer(event.changedTouches ? event.changedTouches[0] : event, this), p1 = t0.invert(p0), k1 = t0.k * (event.shiftKey ? 0.5 : 2), t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, args), translateExtent);
            noevent(event);
            if (duration > 0) select(this).transition().duration(duration).call(schedule, t1, p0, event);
            else select(this).call(zoom.transform, t1, p0, event);
        }
        function touchstarted(event, ...args) {
            if (!filter.apply(this, arguments)) return;
            var touches = event.touches, n = touches.length, g = gesture(this, args, event.changedTouches.length === n).event(event), started, i, t, p;
            nopropagation(event);
            for(i = 0; i < n; ++i){
                t = touches[i], p = pointer(t, this);
                p = [
                    p,
                    this.__zoom.invert(p),
                    t.identifier
                ];
                if (!g.touch0) g.touch0 = p, started = true, g.taps = 1 + !!touchstarting;
                else if (!g.touch1 && g.touch0[2] !== p[2]) g.touch1 = p, g.taps = 0;
            }
            if (touchstarting) touchstarting = clearTimeout(touchstarting);
            if (started) {
                if (g.taps < 2) touchfirst = p[0], touchstarting = setTimeout(function() {
                    touchstarting = null;
                }, touchDelay);
                interrupt(this);
                g.start();
            }
        }
        function touchmoved(event, ...args) {
            if (!this.__zooming) return;
            var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t, p, l;
            noevent(event);
            for(i = 0; i < n; ++i){
                t = touches[i], p = pointer(t, this);
                if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
                else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
            }
            t = g.that.__zoom;
            if (g.touch1) {
                var p0 = g.touch0[0], l0 = g.touch0[1], p1 = g.touch1[0], l1 = g.touch1[1], dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp, dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
                t = scale(t, Math.sqrt(dp / dl));
                p = [
                    (p0[0] + p1[0]) / 2,
                    (p0[1] + p1[1]) / 2
                ];
                l = [
                    (l0[0] + l1[0]) / 2,
                    (l0[1] + l1[1]) / 2
                ];
            } else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
            else return;
            g.zoom("touch", constrain(translate(t, p, l), g.extent, translateExtent));
        }
        function touchended(event, ...args) {
            if (!this.__zooming) return;
            var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t;
            nopropagation(event);
            if (touchending) clearTimeout(touchending);
            touchending = setTimeout(function() {
                touchending = null;
            }, touchDelay);
            for(i = 0; i < n; ++i){
                t = touches[i];
                if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
                else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
            }
            if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
            if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
            else {
                g.end();
                // If this was a dbltap, reroute to the (optional) dblclick.zoom handler.
                if (g.taps === 2) {
                    t = pointer(t, this);
                    if (Math.hypot(touchfirst[0] - t[0], touchfirst[1] - t[1]) < tapDistance) {
                        var p = select(this).on("dblclick.zoom");
                        if (p) p.apply(this, arguments);
                    }
                }
            }
        }
        zoom.wheelDelta = function(_) {
            return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : constant(+_), zoom) : wheelDelta;
        };
        zoom.filter = function(_) {
            return arguments.length ? (filter = typeof _ === "function" ? _ : constant(!!_), zoom) : filter;
        };
        zoom.touchable = function(_) {
            return arguments.length ? (touchable = typeof _ === "function" ? _ : constant(!!_), zoom) : touchable;
        };
        zoom.extent = function(_) {
            return arguments.length ? (extent = typeof _ === "function" ? _ : constant([
                [
                    +_[0][0],
                    +_[0][1]
                ],
                [
                    +_[1][0],
                    +_[1][1]
                ]
            ]), zoom) : extent;
        };
        zoom.scaleExtent = function(_) {
            return arguments.length ? (scaleExtent[0] = +_[0], scaleExtent[1] = +_[1], zoom) : [
                scaleExtent[0],
                scaleExtent[1]
            ];
        };
        zoom.translateExtent = function(_) {
            return arguments.length ? (translateExtent[0][0] = +_[0][0], translateExtent[1][0] = +_[1][0], translateExtent[0][1] = +_[0][1], translateExtent[1][1] = +_[1][1], zoom) : [
                [
                    translateExtent[0][0],
                    translateExtent[0][1]
                ],
                [
                    translateExtent[1][0],
                    translateExtent[1][1]
                ]
            ];
        };
        zoom.constrain = function(_) {
            return arguments.length ? (constrain = _, zoom) : constrain;
        };
        zoom.duration = function(_) {
            return arguments.length ? (duration = +_, zoom) : duration;
        };
        zoom.interpolate = function(_) {
            return arguments.length ? (interpolate = _, zoom) : interpolate;
        };
        zoom.on = function() {
            var value = listeners.on.apply(listeners, arguments);
            return value === listeners ? zoom : value;
        };
        zoom.clickDistance = function(_) {
            return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
        };
        zoom.tapDistance = function(_) {
            return arguments.length ? (tapDistance = +_, zoom) : tapDistance;
        };
        return zoom;
    }
    exports1.Adder = Adder;
    exports1.Delaunay = Delaunay;
    exports1.FormatSpecifier = FormatSpecifier;
    exports1.InternMap = InternMap;
    exports1.InternSet = InternSet;
    exports1.Node = Node$1;
    exports1.Voronoi = Voronoi;
    exports1.ZoomTransform = Transform;
    exports1.active = active;
    exports1.arc = arc;
    exports1.area = area;
    exports1.areaRadial = areaRadial;
    exports1.ascending = ascending$3;
    exports1.autoType = autoType;
    exports1.axisBottom = axisBottom;
    exports1.axisLeft = axisLeft;
    exports1.axisRight = axisRight;
    exports1.axisTop = axisTop;
    exports1.bin = bin;
    exports1.bisect = bisect;
    exports1.bisectCenter = bisectCenter;
    exports1.bisectLeft = bisectLeft;
    exports1.bisectRight = bisectRight;
    exports1.bisector = bisector;
    exports1.blob = blob;
    exports1.blur = blur;
    exports1.blur2 = blur2;
    exports1.blurImage = blurImage;
    exports1.brush = brush;
    exports1.brushSelection = brushSelection;
    exports1.brushX = brushX;
    exports1.brushY = brushY;
    exports1.buffer = buffer;
    exports1.chord = chord;
    exports1.chordDirected = chordDirected;
    exports1.chordTranspose = chordTranspose;
    exports1.cluster = cluster;
    exports1.color = color;
    exports1.contourDensity = density;
    exports1.contours = Contours;
    exports1.count = count$1;
    exports1.create = create$1;
    exports1.creator = creator;
    exports1.cross = cross$2;
    exports1.csv = csv;
    exports1.csvFormat = csvFormat;
    exports1.csvFormatBody = csvFormatBody;
    exports1.csvFormatRow = csvFormatRow;
    exports1.csvFormatRows = csvFormatRows;
    exports1.csvFormatValue = csvFormatValue;
    exports1.csvParse = csvParse;
    exports1.csvParseRows = csvParseRows;
    exports1.cubehelix = cubehelix$3;
    exports1.cumsum = cumsum;
    exports1.curveBasis = basis;
    exports1.curveBasisClosed = basisClosed;
    exports1.curveBasisOpen = basisOpen;
    exports1.curveBumpX = bumpX;
    exports1.curveBumpY = bumpY;
    exports1.curveBundle = bundle;
    exports1.curveCardinal = cardinal;
    exports1.curveCardinalClosed = cardinalClosed;
    exports1.curveCardinalOpen = cardinalOpen;
    exports1.curveCatmullRom = catmullRom;
    exports1.curveCatmullRomClosed = catmullRomClosed;
    exports1.curveCatmullRomOpen = catmullRomOpen;
    exports1.curveLinear = curveLinear;
    exports1.curveLinearClosed = linearClosed;
    exports1.curveMonotoneX = monotoneX;
    exports1.curveMonotoneY = monotoneY;
    exports1.curveNatural = natural;
    exports1.curveStep = step;
    exports1.curveStepAfter = stepAfter;
    exports1.curveStepBefore = stepBefore;
    exports1.descending = descending$2;
    exports1.deviation = deviation;
    exports1.difference = difference;
    exports1.disjoint = disjoint;
    exports1.dispatch = dispatch;
    exports1.drag = drag;
    exports1.dragDisable = dragDisable;
    exports1.dragEnable = yesdrag;
    exports1.dsv = dsv;
    exports1.dsvFormat = dsvFormat;
    exports1.easeBack = backInOut;
    exports1.easeBackIn = backIn;
    exports1.easeBackInOut = backInOut;
    exports1.easeBackOut = backOut;
    exports1.easeBounce = bounceOut;
    exports1.easeBounceIn = bounceIn;
    exports1.easeBounceInOut = bounceInOut;
    exports1.easeBounceOut = bounceOut;
    exports1.easeCircle = circleInOut;
    exports1.easeCircleIn = circleIn;
    exports1.easeCircleInOut = circleInOut;
    exports1.easeCircleOut = circleOut;
    exports1.easeCubic = cubicInOut;
    exports1.easeCubicIn = cubicIn;
    exports1.easeCubicInOut = cubicInOut;
    exports1.easeCubicOut = cubicOut;
    exports1.easeElastic = elasticOut;
    exports1.easeElasticIn = elasticIn;
    exports1.easeElasticInOut = elasticInOut;
    exports1.easeElasticOut = elasticOut;
    exports1.easeExp = expInOut;
    exports1.easeExpIn = expIn;
    exports1.easeExpInOut = expInOut;
    exports1.easeExpOut = expOut;
    exports1.easeLinear = linear$1;
    exports1.easePoly = polyInOut;
    exports1.easePolyIn = polyIn;
    exports1.easePolyInOut = polyInOut;
    exports1.easePolyOut = polyOut;
    exports1.easeQuad = quadInOut;
    exports1.easeQuadIn = quadIn;
    exports1.easeQuadInOut = quadInOut;
    exports1.easeQuadOut = quadOut;
    exports1.easeSin = sinInOut;
    exports1.easeSinIn = sinIn;
    exports1.easeSinInOut = sinInOut;
    exports1.easeSinOut = sinOut;
    exports1.every = every;
    exports1.extent = extent$1;
    exports1.fcumsum = fcumsum;
    exports1.filter = filter$1;
    exports1.flatGroup = flatGroup;
    exports1.flatRollup = flatRollup;
    exports1.forceCenter = center;
    exports1.forceCollide = collide;
    exports1.forceLink = link$2;
    exports1.forceManyBody = manyBody;
    exports1.forceRadial = radial$1;
    exports1.forceSimulation = simulation;
    exports1.forceX = x$2;
    exports1.forceY = y$1;
    exports1.formatDefaultLocale = defaultLocale$1;
    exports1.formatLocale = formatLocale$1;
    exports1.formatSpecifier = formatSpecifier;
    exports1.fsum = fsum;
    exports1.geoAlbers = albers;
    exports1.geoAlbersUsa = albersUsa;
    exports1.geoArea = area$2;
    exports1.geoAzimuthalEqualArea = azimuthalEqualArea;
    exports1.geoAzimuthalEqualAreaRaw = azimuthalEqualAreaRaw;
    exports1.geoAzimuthalEquidistant = azimuthalEquidistant;
    exports1.geoAzimuthalEquidistantRaw = azimuthalEquidistantRaw;
    exports1.geoBounds = bounds;
    exports1.geoCentroid = centroid$1;
    exports1.geoCircle = circle$2;
    exports1.geoClipAntimeridian = clipAntimeridian;
    exports1.geoClipCircle = clipCircle;
    exports1.geoClipExtent = extent;
    exports1.geoClipRectangle = clipRectangle;
    exports1.geoConicConformal = conicConformal;
    exports1.geoConicConformalRaw = conicConformalRaw;
    exports1.geoConicEqualArea = conicEqualArea;
    exports1.geoConicEqualAreaRaw = conicEqualAreaRaw;
    exports1.geoConicEquidistant = conicEquidistant;
    exports1.geoConicEquidistantRaw = conicEquidistantRaw;
    exports1.geoContains = contains$1;
    exports1.geoDistance = distance;
    exports1.geoEqualEarth = equalEarth;
    exports1.geoEqualEarthRaw = equalEarthRaw;
    exports1.geoEquirectangular = equirectangular;
    exports1.geoEquirectangularRaw = equirectangularRaw;
    exports1.geoGnomonic = gnomonic;
    exports1.geoGnomonicRaw = gnomonicRaw;
    exports1.geoGraticule = graticule;
    exports1.geoGraticule10 = graticule10;
    exports1.geoIdentity = identity$4;
    exports1.geoInterpolate = interpolate;
    exports1.geoLength = length$1;
    exports1.geoMercator = mercator;
    exports1.geoMercatorRaw = mercatorRaw;
    exports1.geoNaturalEarth1 = naturalEarth1;
    exports1.geoNaturalEarth1Raw = naturalEarth1Raw;
    exports1.geoOrthographic = orthographic;
    exports1.geoOrthographicRaw = orthographicRaw;
    exports1.geoPath = index$2;
    exports1.geoProjection = projection;
    exports1.geoProjectionMutator = projectionMutator;
    exports1.geoRotation = rotation;
    exports1.geoStereographic = stereographic;
    exports1.geoStereographicRaw = stereographicRaw;
    exports1.geoStream = geoStream;
    exports1.geoTransform = transform$1;
    exports1.geoTransverseMercator = transverseMercator;
    exports1.geoTransverseMercatorRaw = transverseMercatorRaw;
    exports1.gray = gray;
    exports1.greatest = greatest;
    exports1.greatestIndex = greatestIndex;
    exports1.group = group;
    exports1.groupSort = groupSort;
    exports1.groups = groups;
    exports1.hcl = hcl$2;
    exports1.hierarchy = hierarchy;
    exports1.histogram = bin;
    exports1.hsl = hsl$2;
    exports1.html = html;
    exports1.image = image;
    exports1.index = index$4;
    exports1.indexes = indexes;
    exports1.interpolate = interpolate$2;
    exports1.interpolateArray = array$3;
    exports1.interpolateBasis = basis$2;
    exports1.interpolateBasisClosed = basisClosed$1;
    exports1.interpolateBlues = Blues;
    exports1.interpolateBrBG = BrBG;
    exports1.interpolateBuGn = BuGn;
    exports1.interpolateBuPu = BuPu;
    exports1.interpolateCividis = cividis;
    exports1.interpolateCool = cool;
    exports1.interpolateCubehelix = cubehelix$2;
    exports1.interpolateCubehelixDefault = cubehelix;
    exports1.interpolateCubehelixLong = cubehelixLong;
    exports1.interpolateDate = date$1;
    exports1.interpolateDiscrete = discrete;
    exports1.interpolateGnBu = GnBu;
    exports1.interpolateGreens = Greens;
    exports1.interpolateGreys = Greys;
    exports1.interpolateHcl = hcl$1;
    exports1.interpolateHclLong = hclLong;
    exports1.interpolateHsl = hsl$1;
    exports1.interpolateHslLong = hslLong;
    exports1.interpolateHue = hue;
    exports1.interpolateInferno = inferno;
    exports1.interpolateLab = lab;
    exports1.interpolateMagma = magma;
    exports1.interpolateNumber = interpolateNumber;
    exports1.interpolateNumberArray = numberArray;
    exports1.interpolateObject = object$1;
    exports1.interpolateOrRd = OrRd;
    exports1.interpolateOranges = Oranges;
    exports1.interpolatePRGn = PRGn;
    exports1.interpolatePiYG = PiYG;
    exports1.interpolatePlasma = plasma;
    exports1.interpolatePuBu = PuBu;
    exports1.interpolatePuBuGn = PuBuGn;
    exports1.interpolatePuOr = PuOr;
    exports1.interpolatePuRd = PuRd;
    exports1.interpolatePurples = Purples;
    exports1.interpolateRainbow = rainbow;
    exports1.interpolateRdBu = RdBu;
    exports1.interpolateRdGy = RdGy;
    exports1.interpolateRdPu = RdPu;
    exports1.interpolateRdYlBu = RdYlBu;
    exports1.interpolateRdYlGn = RdYlGn;
    exports1.interpolateReds = Reds;
    exports1.interpolateRgb = interpolateRgb;
    exports1.interpolateRgbBasis = rgbBasis;
    exports1.interpolateRgbBasisClosed = rgbBasisClosed;
    exports1.interpolateRound = interpolateRound;
    exports1.interpolateSinebow = sinebow;
    exports1.interpolateSpectral = Spectral;
    exports1.interpolateString = interpolateString;
    exports1.interpolateTransformCss = interpolateTransformCss;
    exports1.interpolateTransformSvg = interpolateTransformSvg;
    exports1.interpolateTurbo = turbo;
    exports1.interpolateViridis = viridis;
    exports1.interpolateWarm = warm;
    exports1.interpolateYlGn = YlGn;
    exports1.interpolateYlGnBu = YlGnBu;
    exports1.interpolateYlOrBr = YlOrBr;
    exports1.interpolateYlOrRd = YlOrRd;
    exports1.interpolateZoom = interpolateZoom;
    exports1.interrupt = interrupt;
    exports1.intersection = intersection;
    exports1.interval = interval;
    exports1.isoFormat = formatIso$1;
    exports1.isoParse = parseIso$1;
    exports1.json = json;
    exports1.lab = lab$1;
    exports1.lch = lch;
    exports1.least = least;
    exports1.leastIndex = leastIndex;
    exports1.line = line;
    exports1.lineRadial = lineRadial$1;
    exports1.link = link;
    exports1.linkHorizontal = linkHorizontal;
    exports1.linkRadial = linkRadial;
    exports1.linkVertical = linkVertical;
    exports1.local = local$1;
    exports1.map = map$1;
    exports1.matcher = matcher;
    exports1.max = max$3;
    exports1.maxIndex = maxIndex;
    exports1.mean = mean;
    exports1.median = median;
    exports1.medianIndex = medianIndex;
    exports1.merge = merge;
    exports1.min = min$2;
    exports1.minIndex = minIndex;
    exports1.mode = mode;
    exports1.namespace = namespace;
    exports1.namespaces = namespaces;
    exports1.nice = nice$1;
    exports1.now = now;
    exports1.pack = index$1;
    exports1.packEnclose = enclose;
    exports1.packSiblings = siblings;
    exports1.pairs = pairs;
    exports1.partition = partition;
    exports1.path = path;
    exports1.permute = permute;
    exports1.pie = pie;
    exports1.piecewise = piecewise;
    exports1.pointRadial = pointRadial;
    exports1.pointer = pointer;
    exports1.pointers = pointers;
    exports1.polygonArea = area$1;
    exports1.polygonCentroid = centroid;
    exports1.polygonContains = contains;
    exports1.polygonHull = hull;
    exports1.polygonLength = length;
    exports1.precisionFixed = precisionFixed;
    exports1.precisionPrefix = precisionPrefix;
    exports1.precisionRound = precisionRound;
    exports1.quadtree = quadtree;
    exports1.quantile = quantile$1;
    exports1.quantileIndex = quantileIndex;
    exports1.quantileSorted = quantileSorted;
    exports1.quantize = quantize$1;
    exports1.quickselect = quickselect;
    exports1.radialArea = areaRadial;
    exports1.radialLine = lineRadial$1;
    exports1.randomBates = bates;
    exports1.randomBernoulli = bernoulli;
    exports1.randomBeta = beta;
    exports1.randomBinomial = binomial;
    exports1.randomCauchy = cauchy;
    exports1.randomExponential = exponential;
    exports1.randomGamma = gamma;
    exports1.randomGeometric = geometric;
    exports1.randomInt = int;
    exports1.randomIrwinHall = irwinHall;
    exports1.randomLcg = lcg;
    exports1.randomLogNormal = logNormal;
    exports1.randomLogistic = logistic;
    exports1.randomNormal = normal;
    exports1.randomPareto = pareto;
    exports1.randomPoisson = poisson;
    exports1.randomUniform = uniform;
    exports1.randomWeibull = weibull;
    exports1.range = range$2;
    exports1.rank = rank;
    exports1.reduce = reduce;
    exports1.reverse = reverse$1;
    exports1.rgb = rgb;
    exports1.ribbon = ribbon$1;
    exports1.ribbonArrow = ribbonArrow;
    exports1.rollup = rollup;
    exports1.rollups = rollups;
    exports1.scaleBand = band;
    exports1.scaleDiverging = diverging$1;
    exports1.scaleDivergingLog = divergingLog;
    exports1.scaleDivergingPow = divergingPow;
    exports1.scaleDivergingSqrt = divergingSqrt;
    exports1.scaleDivergingSymlog = divergingSymlog;
    exports1.scaleIdentity = identity$2;
    exports1.scaleImplicit = implicit;
    exports1.scaleLinear = linear;
    exports1.scaleLog = log;
    exports1.scaleOrdinal = ordinal;
    exports1.scalePoint = point$4;
    exports1.scalePow = pow;
    exports1.scaleQuantile = quantile;
    exports1.scaleQuantize = quantize;
    exports1.scaleRadial = radial;
    exports1.scaleSequential = sequential;
    exports1.scaleSequentialLog = sequentialLog;
    exports1.scaleSequentialPow = sequentialPow;
    exports1.scaleSequentialQuantile = sequentialQuantile;
    exports1.scaleSequentialSqrt = sequentialSqrt;
    exports1.scaleSequentialSymlog = sequentialSymlog;
    exports1.scaleSqrt = sqrt$1;
    exports1.scaleSymlog = symlog;
    exports1.scaleThreshold = threshold;
    exports1.scaleTime = time;
    exports1.scaleUtc = utcTime;
    exports1.scan = scan;
    exports1.schemeAccent = Accent;
    exports1.schemeBlues = scheme$5;
    exports1.schemeBrBG = scheme$q;
    exports1.schemeBuGn = scheme$h;
    exports1.schemeBuPu = scheme$g;
    exports1.schemeCategory10 = category10;
    exports1.schemeDark2 = Dark2;
    exports1.schemeGnBu = scheme$f;
    exports1.schemeGreens = scheme$4;
    exports1.schemeGreys = scheme$3;
    exports1.schemeOrRd = scheme$e;
    exports1.schemeOranges = scheme;
    exports1.schemePRGn = scheme$p;
    exports1.schemePaired = Paired;
    exports1.schemePastel1 = Pastel1;
    exports1.schemePastel2 = Pastel2;
    exports1.schemePiYG = scheme$o;
    exports1.schemePuBu = scheme$c;
    exports1.schemePuBuGn = scheme$d;
    exports1.schemePuOr = scheme$n;
    exports1.schemePuRd = scheme$b;
    exports1.schemePurples = scheme$2;
    exports1.schemeRdBu = scheme$m;
    exports1.schemeRdGy = scheme$l;
    exports1.schemeRdPu = scheme$a;
    exports1.schemeRdYlBu = scheme$k;
    exports1.schemeRdYlGn = scheme$j;
    exports1.schemeReds = scheme$1;
    exports1.schemeSet1 = Set1;
    exports1.schemeSet2 = Set2;
    exports1.schemeSet3 = Set3;
    exports1.schemeSpectral = scheme$i;
    exports1.schemeTableau10 = Tableau10;
    exports1.schemeYlGn = scheme$8;
    exports1.schemeYlGnBu = scheme$9;
    exports1.schemeYlOrBr = scheme$7;
    exports1.schemeYlOrRd = scheme$6;
    exports1.select = select;
    exports1.selectAll = selectAll;
    exports1.selection = selection;
    exports1.selector = selector;
    exports1.selectorAll = selectorAll;
    exports1.shuffle = shuffle$1;
    exports1.shuffler = shuffler;
    exports1.some = some;
    exports1.sort = sort;
    exports1.stack = stack;
    exports1.stackOffsetDiverging = diverging;
    exports1.stackOffsetExpand = expand;
    exports1.stackOffsetNone = none$1;
    exports1.stackOffsetSilhouette = silhouette;
    exports1.stackOffsetWiggle = wiggle;
    exports1.stackOrderAppearance = appearance;
    exports1.stackOrderAscending = ascending;
    exports1.stackOrderDescending = descending;
    exports1.stackOrderInsideOut = insideOut;
    exports1.stackOrderNone = none;
    exports1.stackOrderReverse = reverse;
    exports1.stratify = stratify;
    exports1.style = styleValue;
    exports1.subset = subset;
    exports1.sum = sum$2;
    exports1.superset = superset;
    exports1.svg = svg;
    exports1.symbol = Symbol$1;
    exports1.symbolAsterisk = asterisk;
    exports1.symbolCircle = circle;
    exports1.symbolCross = cross;
    exports1.symbolDiamond = diamond;
    exports1.symbolDiamond2 = diamond2;
    exports1.symbolPlus = plus;
    exports1.symbolSquare = square;
    exports1.symbolSquare2 = square2;
    exports1.symbolStar = star;
    exports1.symbolTriangle = triangle;
    exports1.symbolTriangle2 = triangle2;
    exports1.symbolWye = wye;
    exports1.symbolX = x;
    exports1.symbols = symbolsFill;
    exports1.symbolsFill = symbolsFill;
    exports1.symbolsStroke = symbolsStroke;
    exports1.text = text;
    exports1.thresholdFreedmanDiaconis = thresholdFreedmanDiaconis;
    exports1.thresholdScott = thresholdScott;
    exports1.thresholdSturges = thresholdSturges;
    exports1.tickFormat = tickFormat;
    exports1.tickIncrement = tickIncrement;
    exports1.tickStep = tickStep;
    exports1.ticks = ticks;
    exports1.timeDay = timeDay;
    exports1.timeDays = timeDays;
    exports1.timeFormatDefaultLocale = defaultLocale;
    exports1.timeFormatLocale = formatLocale;
    exports1.timeFriday = timeFriday;
    exports1.timeFridays = timeFridays;
    exports1.timeHour = timeHour;
    exports1.timeHours = timeHours;
    exports1.timeInterval = timeInterval;
    exports1.timeMillisecond = millisecond;
    exports1.timeMilliseconds = milliseconds;
    exports1.timeMinute = timeMinute;
    exports1.timeMinutes = timeMinutes;
    exports1.timeMonday = timeMonday;
    exports1.timeMondays = timeMondays;
    exports1.timeMonth = timeMonth;
    exports1.timeMonths = timeMonths;
    exports1.timeSaturday = timeSaturday;
    exports1.timeSaturdays = timeSaturdays;
    exports1.timeSecond = second;
    exports1.timeSeconds = seconds;
    exports1.timeSunday = timeSunday;
    exports1.timeSundays = timeSundays;
    exports1.timeThursday = timeThursday;
    exports1.timeThursdays = timeThursdays;
    exports1.timeTickInterval = timeTickInterval;
    exports1.timeTicks = timeTicks;
    exports1.timeTuesday = timeTuesday;
    exports1.timeTuesdays = timeTuesdays;
    exports1.timeWednesday = timeWednesday;
    exports1.timeWednesdays = timeWednesdays;
    exports1.timeWeek = timeSunday;
    exports1.timeWeeks = timeSundays;
    exports1.timeYear = timeYear;
    exports1.timeYears = timeYears;
    exports1.timeout = timeout;
    exports1.timer = timer;
    exports1.timerFlush = timerFlush;
    exports1.transition = transition;
    exports1.transpose = transpose;
    exports1.tree = tree;
    exports1.treemap = index;
    exports1.treemapBinary = binary;
    exports1.treemapDice = treemapDice;
    exports1.treemapResquarify = resquarify;
    exports1.treemapSlice = treemapSlice;
    exports1.treemapSliceDice = sliceDice;
    exports1.treemapSquarify = squarify;
    exports1.tsv = tsv;
    exports1.tsvFormat = tsvFormat;
    exports1.tsvFormatBody = tsvFormatBody;
    exports1.tsvFormatRow = tsvFormatRow;
    exports1.tsvFormatRows = tsvFormatRows;
    exports1.tsvFormatValue = tsvFormatValue;
    exports1.tsvParse = tsvParse;
    exports1.tsvParseRows = tsvParseRows;
    exports1.union = union;
    exports1.unixDay = unixDay;
    exports1.unixDays = unixDays;
    exports1.utcDay = utcDay;
    exports1.utcDays = utcDays;
    exports1.utcFriday = utcFriday;
    exports1.utcFridays = utcFridays;
    exports1.utcHour = utcHour;
    exports1.utcHours = utcHours;
    exports1.utcMillisecond = millisecond;
    exports1.utcMilliseconds = milliseconds;
    exports1.utcMinute = utcMinute;
    exports1.utcMinutes = utcMinutes;
    exports1.utcMonday = utcMonday;
    exports1.utcMondays = utcMondays;
    exports1.utcMonth = utcMonth;
    exports1.utcMonths = utcMonths;
    exports1.utcSaturday = utcSaturday;
    exports1.utcSaturdays = utcSaturdays;
    exports1.utcSecond = second;
    exports1.utcSeconds = seconds;
    exports1.utcSunday = utcSunday;
    exports1.utcSundays = utcSundays;
    exports1.utcThursday = utcThursday;
    exports1.utcThursdays = utcThursdays;
    exports1.utcTickInterval = utcTickInterval;
    exports1.utcTicks = utcTicks;
    exports1.utcTuesday = utcTuesday;
    exports1.utcTuesdays = utcTuesdays;
    exports1.utcWednesday = utcWednesday;
    exports1.utcWednesdays = utcWednesdays;
    exports1.utcWeek = utcSunday;
    exports1.utcWeeks = utcSundays;
    exports1.utcYear = utcYear;
    exports1.utcYears = utcYears;
    exports1.variance = variance;
    exports1.version = version;
    exports1.window = defaultView;
    exports1.xml = xml;
    exports1.zip = zip;
    exports1.zoom = zoom;
    exports1.zoomIdentity = identity;
    exports1.zoomTransform = transform;
});

});



parcelRegister("hqZma", function(module, exports) {

$parcel$export(module.exports, "AxisBottomTick", () => $cb1475830d00691d$export$34bea378c04af713);
$parcel$export(module.exports, "AxisBottomLine", () => $cb1475830d00691d$export$84b05a0ae8b61ab5);
$parcel$export(module.exports, "AxisBottomText", () => $cb1475830d00691d$export$ebfad67a29d89d08);
$parcel$export(module.exports, "AxisBottom", () => $cb1475830d00691d$export$deea0fad05dcb466);
/* AxisBottom.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $bwpsq = parcelRequire("bwpsq");

var $bT1Sw = parcelRequire("bT1Sw");

var $eFK63 = parcelRequire("eFK63");

var $jxg43 = parcelRequire("jxg43");

var $42C9W = parcelRequire("42C9W");

var $f8uii = parcelRequire("f8uii");

var $da7Ww = parcelRequire("da7Ww");

var $l5ab7 = parcelRequire("l5ab7");

var $2vbO1 = parcelRequire("2vbO1");

var $kq3PX = parcelRequire("kq3PX");

var $2OMIu = parcelRequire("2OMIu");
const $cb1475830d00691d$export$cd0785a309729df9 = {
    color: "var(--ds-text-subtlest, grey)",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
    fontSize: 12,
    textAlign: 'center'
};
const $cb1475830d00691d$var$tickLength = 8;
const $cb1475830d00691d$var$orientation = (0, $jxg43.default).bottom;
const $cb1475830d00691d$export$34bea378c04af713 = (0, $bT1Sw.element)((0, $l5ab7.Tick));
const $cb1475830d00691d$export$84b05a0ae8b61ab5 = (0, $bT1Sw.element)((_ref)=>{
    let { width: width, top: top, hide: hide } = _ref;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $da7Ww.AxisLine), {
        hide: hide,
        style: {
            borderBottom: `${(0, $da7Ww.axisLineStroke)} solid 2px`,
            width: `${width}px`,
            position: 'absolute',
            top: `${top}px`
        }
    });
});
const $cb1475830d00691d$export$ebfad67a29d89d08 = (0, $bT1Sw.element)((_ref2)=>{
    let { width: width, formatter: formatter, truncate: truncate, singleline: singleline, children: children, transform: transform } = _ref2;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2vbO1.TickText), {
        style: {
            width: width,
            transform: transform
        },
        formatter: formatter,
        truncate: truncate,
        singleline: singleline,
        children: children
    });
});
function $cb1475830d00691d$var$AxisBottom(_ref3) {
    let { scale: scale, numTicks: numTicks, tickValues: tickValues, top: top, left: left, rangePadding: rangePadding, hideZero: hideZero, label: label, hide: hide } = _ref3;
    if (hide) return null;
    const { ticks: ticks } = (0, $kq3PX.useAxisTicks)({
        scale: scale,
        numTicks: numTicks,
        tickValues: tickValues,
        orientation: $cb1475830d00691d$var$orientation,
        rangePadding: rangePadding,
        hideZero: hideZero,
        tickLength: $cb1475830d00691d$var$tickLength
    });
    const TickTextsComponent = ticks.map((_ref4)=>{
        let { value: value, index: index, from: from, to: to } = _ref4;
        const formatter = (0, $f8uii.default)(scale);
        return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            style: {
                left: `${to.x}px`
            },
            className: (0, $bwpsq.default)([
                "_yyhykb7n _1ii7kb7n _kqswh2mm _1bsbidpf _syaz13nv _ect41wi2 _1wyb1crf _y3gn1h6o"
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($cb1475830d00691d$export$ebfad67a29d89d08, {
                width: Number(scale.range()[1]) / ticks.length,
                formatter: formatter,
                truncate: (0, $42C9W.default)(scale) === 'string',
                transform: "translateX(-50%)",
                children: value
            })
        }, `axis-bottom-text-${index}-${value}-${from.toArray()}-${to.toArray()}`);
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                style: {
                    gridArea: 'plot'
                },
                children: /*#__PURE__*/ (0, $2OMIu.jsx)($cb1475830d00691d$export$84b05a0ae8b61ab5, {
                    width: left,
                    top: top
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                style: {
                    gridArea: 'axis-bottom',
                    display: 'grid',
                    gridTemplateRows: 'auto min-content'
                },
                "data-axis-type": "axis-bottom",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        className: (0, $bwpsq.default)([
                            "_1e0c11p5 _yv0ehkll _2z05hkll _ca0q1crf _lcxvglyw"
                        ]),
                        children: TickTextsComponent
                    }),
                    label && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        style: {
                            paddingTop: '8px',
                            width: '100%',
                            textAlign: 'center',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            ...(0, $eFK63.defaultTextHTMLProps)
                        },
                        children: label
                    })
                ]
            })
        ]
    });
}
const $cb1475830d00691d$export$deea0fad05dcb466 = (0, $bT1Sw.element)($cb1475830d00691d$var$AxisBottom);

});
parcelRegister("eFK63", function(module, exports) {

$parcel$export(module.exports, "defaultTextHTMLProps", () => $aae8a6d9dacb0080$export$51ee3858fd381684);
const $aae8a6d9dacb0080$export$554ff5554bedd348 = {
    textAnchor: 'middle',
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
    fontSize: 12,
    color: "var(--ds-text-subtlest, lightgrey)"
};
const $aae8a6d9dacb0080$export$51ee3858fd381684 = {
    textAlign: 'center',
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
    fontSize: 12,
    color: "var(--ds-text-subtlest, lightgrey)"
};

});

parcelRegister("jxg43", function(module, exports) {

$parcel$export(module.exports, "default", () => $e38d8f70dd0cbed6$export$2e2bcd8739ae039);
const $e38d8f70dd0cbed6$var$Orientation = {
    top: 'top',
    left: 'left',
    right: 'right',
    bottom: 'bottom'
};
var $e38d8f70dd0cbed6$export$2e2bcd8739ae039 = $e38d8f70dd0cbed6$var$Orientation;

});

parcelRegister("42C9W", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f14f2f7f7ffed93$export$2e2bcd8739ae039);
/**
 * Uses the scale domain to check the type of data.
 *
 * If domainValues[0] ends up being null, we will return string. Since null
 * can only be value on ordinal axis.
 */ function $2f14f2f7f7ffed93$export$2e2bcd8739ae039(scale) {
    const domainValues = scale.domain();
    if (domainValues.length === 0) return 'string';
    if (domainValues[0] instanceof Date || domainValues[domainValues.length - 1] instanceof Date) return 'time';
    else if (typeof domainValues[0] === 'number') return 'number';
    else return 'string';
}

});

parcelRegister("f8uii", function(module, exports) {

$parcel$export(module.exports, "default", () => $b04f1a26b98e19d6$export$2e2bcd8739ae039);

var $ltC0t = parcelRequire("ltC0t");
function $b04f1a26b98e19d6$export$2e2bcd8739ae039(scale) {
    // Broaden type before using 'xxx' in s as typeguard.
    const s = scale;
    // For point or band scales,
    // have to add offset to make the tick centered.
    if (scale.domain()[0] instanceof Date || scale.domain()[1] instanceof Date) return (0, $ltC0t.default).multiTimeFormat;
    else if ('tickFormat' in s) return (0, $ltC0t.default).formatNumberAbbreviated;
    return String;
}

});

parcelRegister("da7Ww", function(module, exports) {

$parcel$export(module.exports, "axisLineStroke", () => $99525ed62f9828e4$export$1b23eda9d50a8331);
$parcel$export(module.exports, "AxisLine", () => $99525ed62f9828e4$export$6b38ce563ca3e26b);

var $bT1Sw = parcelRequire("bT1Sw");

var $2OMIu = parcelRequire("2OMIu");
const $99525ed62f9828e4$export$1b23eda9d50a8331 = "var(--ds-border-bold, lightgrey)";
const $99525ed62f9828e4$export$6b38ce563ca3e26b = (0, $bT1Sw.element)((props)=>{
    const { style: style, hide: hide } = props;
    if (hide) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        style: style
    });
});

});

parcelRegister("l5ab7", function(module, exports) {

$parcel$export(module.exports, "Tick", () => $f591f5cc8874127e$export$b1778e7c62739fdb);

var $bT1Sw = parcelRequire("bT1Sw");

var $2OMIu = parcelRequire("2OMIu");
const $f591f5cc8874127e$var$tickStroke = "var(--ds-border-bold, lightgrey)";
const $f591f5cc8874127e$var$TICK_LENGTH = 8;
const $f591f5cc8874127e$var$STROKE_WIDTH = 1;
const $f591f5cc8874127e$export$b1778e7c62739fdb = (0, $bT1Sw.element)((props)=>{
    const { from: from, to: to, hide: hide } = props;
    const isHorizontal = (from === null || from === void 0 ? void 0 : from.y) === (to === null || to === void 0 ? void 0 : to.y);
    if (hide) return null;
    const border = isHorizontal ? {
        borderBottom: `${$f591f5cc8874127e$var$STROKE_WIDTH}px solid ${$f591f5cc8874127e$var$tickStroke}`
    } : {
        borderLeft: `${$f591f5cc8874127e$var$STROKE_WIDTH}px solid ${$f591f5cc8874127e$var$tickStroke}`
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        style: {
            ...border,
            width: isHorizontal ? $f591f5cc8874127e$var$TICK_LENGTH : 0,
            height: !isHorizontal ? $f591f5cc8874127e$var$TICK_LENGTH : 0,
            position: 'absolute',
            top: `calc(${to === null || to === void 0 ? void 0 : to.y}px)`,
            left: `calc(${from === null || from === void 0 ? void 0 : from.x}px)`,
            transform: isHorizontal ? `translateX(-${$f591f5cc8874127e$var$TICK_LENGTH}px)` : ``
        }
    });
});

});

parcelRegister("2vbO1", function(module, exports) {

$parcel$export(module.exports, "TickText", () => $1d27a2655db0185a$export$d3f6b56e9fbffff3);

var $3bDjY = parcelRequire("3bDjY");

var $hjll3 = parcelRequire("hjll3");

var $5uXOq = parcelRequire("5uXOq");

var $bT1Sw = parcelRequire("bT1Sw");

var $2OMIu = parcelRequire("2OMIu");
const $1d27a2655db0185a$var$TRUNCATE_STYLES = {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
};
const $1d27a2655db0185a$export$d3f6b56e9fbffff3 = (0, $bT1Sw.element)((props)=>{
    // TODO: Force singleline
    const { formatter: formatter, style: style, truncate: truncate, singleline: singleline, children: children } = props;
    const ref = (0, $5uXOq.useRef)(null);
    const truncateStyles = truncate ? $1d27a2655db0185a$var$TRUNCATE_STYLES : {};
    const tickContent = typeof formatter === 'function' ? formatter(children) : (0, $hjll3.timeFormat)(formatter)(children);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        tag: 'div',
        position: "bottom",
        content: tickContent,
        canAppear: ()=>{
            const element = ref.current;
            if (!element) return false;
            return element.offsetWidth < element.scrollWidth;
        },
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            ref: ref,
            style: {
                ...style,
                ...truncateStyles,
                pointerEvents: 'auto'
            },
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                children: tickContent
            })
        })
    });
});

});

parcelRegister("kq3PX", function(module, exports) {

$parcel$export(module.exports, "useAxisTicks", () => $edd9364b3322512a$export$b1d0fead756358a0);

var $cMo1a = parcelRequire("cMo1a");
var $eOdM1 = parcelRequire("eOdM1");
var $elPt5 = parcelRequire("elPt5");
var $2YVVm = parcelRequire("2YVVm");

var $jxg43 = parcelRequire("jxg43");


var $8LERT = parcelRequire("8LERT");

var $4ZQLi = parcelRequire("4ZQLi");
function $edd9364b3322512a$export$b1d0fead756358a0(_ref) {
    let { scale: scale, numTicks: numTicks, tickValues: tickValues, tickLength: tickLength, orientation: orientation, hideZero: hideZero = false } = _ref;
    const isLeft = orientation === (0, $jxg43.default).left;
    const isTop = orientation === (0, $jxg43.default).top;
    const horizontal = isTop || orientation === (0, $jxg43.default).bottom;
    const tickPosition = (0, $4ZQLi.default)(scale);
    const tickSign = isLeft || isTop ? -1 : 1;
    const range = scale.range();
    const scaleType = (0, $elPt5.default)(scale);
    const isNumeric = scaleType === 'linear' || scaleType === 'log';
    const tempCalcTicks = Math.round(Math.abs((range[1] || 1) - (range[0] || 0)) / (isLeft ? isNumeric ? (0, $22cf0ae7e72c2bef$export$b3026b3c8d26dc41) : 18 : (0, $22cf0ae7e72c2bef$export$b3026b3c8d26dc41)));
    const calculatedNumTicks = numTicks !== undefined ? numTicks : tempCalcTicks < 2 ? 2 : tempCalcTicks;
    let calculatedScale = scale;
    // Doing a detection here to figure out if we want the ticks to use temporal instead of the
    // ordinal tick detection.
    if ('timeUnit' in scale && typeof scale.timeUnit === 'function' && scale.timeUnit()) {
        const domain = scale.domain();
        if (domain.length > 0) calculatedScale = (0, $2YVVm.default)({
            range: scale.range(),
            domain: [
                scale.domain()[0],
                scale.domain()[scale.domain().length - 1]
            ]
        });
    }
    const filteredTickValues = (tickValues !== null && tickValues !== void 0 ? tickValues : (0, $eOdM1.default)(calculatedScale, calculatedNumTicks)).filter((value)=>!hideZero || value !== 0 && value !== '0').map((value, index)=>({
            value: value,
            index: index
        }));
    const ticks = filteredTickValues.reduce((filtered, _ref2)=>{
        let { value: value, index: index } = _ref2;
        const scaledValue = (0, $cMo1a.default)(tickPosition(value));
        if (tickPosition(value) !== undefined) filtered.push({
            value: value,
            index: index,
            from: (0, $8LERT.default)({
                x: scaledValue,
                y: 0
            }, horizontal),
            to: (0, $8LERT.default)({
                x: scaledValue,
                y: tickLength * tickSign
            }, horizontal)
        });
        return filtered;
    }, []);
    return {
        ticks: ticks
    };
}

});
parcelRegister("cMo1a", function(module, exports) {

$parcel$export(module.exports, "default", () => $94dc992be9846d59$export$2e2bcd8739ae039);
function $94dc992be9846d59$export$2e2bcd8739ae039(val) {
    if ((typeof val === 'function' || typeof val === 'object' && !!val) && 'valueOf' in val) {
        var num = val.valueOf();
        if (typeof num === 'number') return num;
    }
    return val;
}

});

parcelRegister("eOdM1", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac806b5b20fff3c3$export$2e2bcd8739ae039);
function $ac806b5b20fff3c3$export$2e2bcd8739ae039(scale, numTicks) {
    // Because `Scale` is generic type which maybe a subset of AnyD3Scale
    // that may not have `ticks` field,
    // TypeScript will not let us do the `'ticks' in scale` check directly.
    // Have to manually cast and expand type first.
    var s = scale;
    if ('ticks' in s) return s.ticks(numTicks);
    return s.domain().filter(function(_, index, arr) {
        return numTicks == null || arr.length <= numTicks || index % Math.round((arr.length - 1) / numTicks) === 0;
    });
}

});

parcelRegister("elPt5", function(module, exports) {

$parcel$export(module.exports, "default", () => $a72af3598e52f8a9$export$2e2bcd8739ae039);

var $jjmqp = parcelRequire("jjmqp");
function $a72af3598e52f8a9$export$2e2bcd8739ae039(scale) {
    // Try a sequence of typeguards to figure out the scale type
    if ('paddingInner' in scale) return 'band';
    if ('padding' in scale) return 'point';
    if ('quantiles' in scale) return 'quantile';
    if ('base' in scale) return 'log';
    if ('exponent' in scale) return scale.exponent() === 0.5 ? 'sqrt' : 'pow';
    if ('constant' in scale) return 'symlog';
    if ('clamp' in scale) {
        // Linear, Time or Utc scales
        if (scale.ticks()[0] instanceof Date) return (0, $jjmqp.default)(scale) ? 'utc' : 'time';
        return 'linear';
    }
    if ('nice' in scale) return 'quantize';
    if ('invertExtent' in scale) return 'threshold';
    return 'ordinal';
}

});
parcelRegister("jjmqp", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0f12fc7b7a74157$export$2e2bcd8739ae039);
var $e0f12fc7b7a74157$var$TEST_TIME = new Date(Date.UTC(2020, 1, 2, 3, 4, 5));
var $e0f12fc7b7a74157$var$TEST_FORMAT = '%Y-%m-%d %H:%M';
function $e0f12fc7b7a74157$export$2e2bcd8739ae039(scale) {
    // The only difference between time and utc scale is
    // whether the tick format function is utcFormat or timeFormat
    var output = scale.tickFormat(1, $e0f12fc7b7a74157$var$TEST_FORMAT)($e0f12fc7b7a74157$var$TEST_TIME);
    return output === '2020-02-02 03:04';
}

});


parcelRegister("2YVVm", function(module, exports) {

$parcel$export(module.exports, "default", () => $22be1de14d945e20$export$2e2bcd8739ae039);

var $hV9DI = parcelRequire("hV9DI");

var $caWsP = parcelRequire("caWsP");
var $22be1de14d945e20$export$a5ffb43f629473d4 = (0, $caWsP.default)('domain', 'range', 'reverse', 'clamp', 'interpolate', 'nice', 'round');
function $22be1de14d945e20$export$2e2bcd8739ae039(config) {
    return $22be1de14d945e20$export$a5ffb43f629473d4((0, $hV9DI.default)(), config);
}

});
parcelRegister("hV9DI", function(module, exports) {

$parcel$export(module.exports, "calendar", () => $d0bf3cbc94db3d51$export$56bbcdb8aca31149);
$parcel$export(module.exports, "default", () => $d0bf3cbc94db3d51$export$2e2bcd8739ae039);

var $cRW5v = parcelRequire("cRW5v");
var $kSdfl = parcelRequire("kSdfl");
var $7yDT1 = parcelRequire("7yDT1");
var $2jkSd = parcelRequire("2jkSd");
var $dayZI = parcelRequire("dayZI");
var $dCu2z = parcelRequire("dCu2z");
var $8vb39 = parcelRequire("8vb39");
var $idw3k = parcelRequire("idw3k");

var $duk0X = parcelRequire("duk0X");

var $jhkFB = parcelRequire("jhkFB");

var $l4Hc4 = parcelRequire("l4Hc4");

var $8h2kZ = parcelRequire("8h2kZ");
function $d0bf3cbc94db3d51$var$date(t) {
    return new Date(t);
}
function $d0bf3cbc94db3d51$var$number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function $d0bf3cbc94db3d51$export$56bbcdb8aca31149(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, $jhkFB.default)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, $d0bf3cbc94db3d51$var$number)) : domain().map($d0bf3cbc94db3d51$var$date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, $8h2kZ.default)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, $jhkFB.copy)(scale, $d0bf3cbc94db3d51$export$56bbcdb8aca31149(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function $d0bf3cbc94db3d51$export$2e2bcd8739ae039() {
    return (0, $l4Hc4.initRange).apply($d0bf3cbc94db3d51$export$56bbcdb8aca31149((0, $dCu2z.timeTicks), (0, $dCu2z.timeTickInterval), (0, $idw3k.timeYear), (0, $2jkSd.timeMonth), (0, $8vb39.timeSunday), (0, $cRW5v.timeDay), (0, $kSdfl.timeHour), (0, $7yDT1.timeMinute), (0, $dayZI.second), (0, $duk0X.timeFormat)).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}

});
parcelRegister("jhkFB", function(module, exports) {

$parcel$export(module.exports, "identity", () => $e08fa37ff0dcafa0$export$f0954fd7d5368655);
$parcel$export(module.exports, "copy", () => $e08fa37ff0dcafa0$export$784d13d8ee351f07);
$parcel$export(module.exports, "transformer", () => $e08fa37ff0dcafa0$export$6b468dcfb64c653c);
$parcel$export(module.exports, "default", () => $e08fa37ff0dcafa0$export$2e2bcd8739ae039);

var $babOZ = parcelRequire("babOZ");

var $6RkHc = parcelRequire("6RkHc");
var $3Rh7t = parcelRequire("3Rh7t");
var $8Masb = parcelRequire("8Masb");

var $8CHve = parcelRequire("8CHve");

var $bMlxp = parcelRequire("bMlxp");
var $e08fa37ff0dcafa0$var$unit = [
    0,
    1
];
function $e08fa37ff0dcafa0$export$f0954fd7d5368655(x) {
    return x;
}
function $e08fa37ff0dcafa0$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $8CHve.default)(isNaN(b) ? NaN : 0.5);
}
function $e08fa37ff0dcafa0$var$clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
}
// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $e08fa37ff0dcafa0$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $e08fa37ff0dcafa0$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $e08fa37ff0dcafa0$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $e08fa37ff0dcafa0$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
    // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $e08fa37ff0dcafa0$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $babOZ.default)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $e08fa37ff0dcafa0$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $e08fa37ff0dcafa0$export$6b468dcfb64c653c() {
    var domain = $e08fa37ff0dcafa0$var$unit, range = $e08fa37ff0dcafa0$var$unit, interpolate = (0, $6RkHc.default), transform, untransform, unknown, clamp = $e08fa37ff0dcafa0$export$f0954fd7d5368655, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== $e08fa37ff0dcafa0$export$f0954fd7d5368655) clamp = $e08fa37ff0dcafa0$var$clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? $e08fa37ff0dcafa0$var$polymap : $e08fa37ff0dcafa0$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), (0, $3Rh7t.default))))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, (0, $bMlxp.default)), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = (0, $8Masb.default), rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : $e08fa37ff0dcafa0$export$f0954fd7d5368655, rescale()) : clamp !== $e08fa37ff0dcafa0$export$f0954fd7d5368655;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $e08fa37ff0dcafa0$export$2e2bcd8739ae039() {
    return $e08fa37ff0dcafa0$export$6b468dcfb64c653c()($e08fa37ff0dcafa0$export$f0954fd7d5368655, $e08fa37ff0dcafa0$export$f0954fd7d5368655);
}

});
parcelRegister("babOZ", function(module, exports) {

$parcel$export(module.exports, "bisectRight", () => $8209cc5de140cbf4$export$4d945ad3ad5751b0);
$parcel$export(module.exports, "bisectLeft", () => $8209cc5de140cbf4$export$df7d25c84ebd12a5);
$parcel$export(module.exports, "default", () => $8209cc5de140cbf4$export$2e2bcd8739ae039);

var $9eRkP = parcelRequire("9eRkP");

var $88EGG = parcelRequire("88EGG");

var $gcXrx = parcelRequire("gcXrx");
const $8209cc5de140cbf4$var$ascendingBisect = (0, $88EGG.default)((0, $9eRkP.default));
const $8209cc5de140cbf4$export$4d945ad3ad5751b0 = $8209cc5de140cbf4$var$ascendingBisect.right;
const $8209cc5de140cbf4$export$df7d25c84ebd12a5 = $8209cc5de140cbf4$var$ascendingBisect.left;
const $8209cc5de140cbf4$export$c1cb828b1117c77b = (0, $88EGG.default)((0, $gcXrx.default)).center;
var $8209cc5de140cbf4$export$2e2bcd8739ae039 = $8209cc5de140cbf4$export$4d945ad3ad5751b0;

});
parcelRegister("gcXrx", function(module, exports) {

$parcel$export(module.exports, "default", () => $bccbe082a14f438f$export$2e2bcd8739ae039);
$parcel$export(module.exports, "numbers", () => $bccbe082a14f438f$export$1f6c9cc012ebacae);
function $bccbe082a14f438f$export$2e2bcd8739ae039(x) {
    return x === null ? NaN : +x;
}
function* $bccbe082a14f438f$export$1f6c9cc012ebacae(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}

});


parcelRegister("6RkHc", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fe7bf159d941aaa$export$2e2bcd8739ae039);

var $7UL8A = parcelRequire("7UL8A");

var $aG0QU = parcelRequire("aG0QU");

var $kTnyJ = parcelRequire("kTnyJ");

var $MJl9N = parcelRequire("MJl9N");

var $3Rh7t = parcelRequire("3Rh7t");

var $cNfx1 = parcelRequire("cNfx1");

var $aAMMD = parcelRequire("aAMMD");

var $28ku5 = parcelRequire("28ku5");

var $fwtCP = parcelRequire("fwtCP");
function $4fe7bf159d941aaa$export$2e2bcd8739ae039(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $28ku5.default)(b) : (t === "number" ? (0, $3Rh7t.default) : t === "string" ? (c = (0, $7UL8A.default)(b)) ? (b = c, $aG0QU.default) : (0, $aAMMD.default) : b instanceof (0, $7UL8A.default) ? (0, $aG0QU.default) : b instanceof Date ? (0, $MJl9N.default) : (0, $fwtCP.isNumberArray)(b) ? (0, $fwtCP.default) : Array.isArray(b) ? (0, $kTnyJ.genericArray) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, $cNfx1.default) : (0, $3Rh7t.default))(a, b);
}

});
parcelRegister("kTnyJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f35b380b021f8b08$export$2e2bcd8739ae039);
$parcel$export(module.exports, "genericArray", () => $f35b380b021f8b08$export$15d09067c6a5ee49);

var $6RkHc = parcelRequire("6RkHc");

var $fwtCP = parcelRequire("fwtCP");
function $f35b380b021f8b08$export$2e2bcd8739ae039(a, b) {
    return ((0, $fwtCP.isNumberArray)(b) ? (0, $fwtCP.default) : $f35b380b021f8b08$export$15d09067c6a5ee49)(a, b);
}
function $f35b380b021f8b08$export$15d09067c6a5ee49(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $6RkHc.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

});
parcelRegister("fwtCP", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4d0d32910153fd7$export$2e2bcd8739ae039);
$parcel$export(module.exports, "isNumberArray", () => $b4d0d32910153fd7$export$5cd576d1827d40c8);
function $b4d0d32910153fd7$export$2e2bcd8739ae039(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $b4d0d32910153fd7$export$5cd576d1827d40c8(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

});


parcelRegister("MJl9N", function(module, exports) {

$parcel$export(module.exports, "default", () => $0927a76fd784b52f$export$2e2bcd8739ae039);
function $0927a76fd784b52f$export$2e2bcd8739ae039(a, b) {
    var d = new Date;
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}

});

parcelRegister("3Rh7t", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cf399f0ec029057$export$2e2bcd8739ae039);
function $2cf399f0ec029057$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}

});

parcelRegister("cNfx1", function(module, exports) {

$parcel$export(module.exports, "default", () => $95061be058f50ffd$export$2e2bcd8739ae039);

var $6RkHc = parcelRequire("6RkHc");
function $95061be058f50ffd$export$2e2bcd8739ae039(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $6RkHc.default)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}

});

parcelRegister("aAMMD", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b631b92516e1d18$export$2e2bcd8739ae039);

var $3Rh7t = parcelRequire("3Rh7t");
var $7b631b92516e1d18$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $7b631b92516e1d18$var$reB = new RegExp($7b631b92516e1d18$var$reA.source, "g");
function $7b631b92516e1d18$var$zero(b) {
    return function() {
        return b;
    };
}
function $7b631b92516e1d18$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $7b631b92516e1d18$export$2e2bcd8739ae039(a, b) {
    var bi = $7b631b92516e1d18$var$reA.lastIndex = $7b631b92516e1d18$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $7b631b92516e1d18$var$reA.exec(a)) && (bm = $7b631b92516e1d18$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $3Rh7t.default)(am, bm)
            });
        }
        bi = $7b631b92516e1d18$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $7b631b92516e1d18$var$one(q[0].x) : $7b631b92516e1d18$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}

});


parcelRegister("8CHve", function(module, exports) {

$parcel$export(module.exports, "default", () => $64739e0ff1e8934d$export$2e2bcd8739ae039);
function $64739e0ff1e8934d$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("bMlxp", function(module, exports) {

$parcel$export(module.exports, "default", () => $8934e2622cfc7145$export$2e2bcd8739ae039);
function $8934e2622cfc7145$export$2e2bcd8739ae039(x) {
    return +x;
}

});


parcelRegister("8h2kZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6061b96d6d4d7b5e$export$2e2bcd8739ae039);
function $6061b96d6d4d7b5e$export$2e2bcd8739ae039(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}

});


parcelRegister("caWsP", function(module, exports) {

$parcel$export(module.exports, "default", () => $8dd3c4ebebad7819$export$2e2bcd8739ae039);

var $7NDDt = parcelRequire("7NDDt");

var $aag8f = parcelRequire("aag8f");

var $8m6Xe = parcelRequire("8m6Xe");

var $c8Zjd = parcelRequire("c8Zjd");

var $1MYRX = parcelRequire("1MYRX");

var $adff9 = parcelRequire("adff9");

var $1MyI8 = parcelRequire("1MyI8");

var $ic1Fv = parcelRequire("ic1Fv");

var $7goQn = parcelRequire("7goQn");

var $c1r8l = parcelRequire("c1r8l");

var $dWXcN = parcelRequire("dWXcN");

var $4sSWK = parcelRequire("4sSWK");

var $iuIpV = parcelRequire("iuIpV");

var $jUCfg = parcelRequire("jUCfg");
var $8dd3c4ebebad7819$export$5f274da11658f617 = [
    // domain => nice => zero
    'domain',
    'nice',
    'zero',
    // interpolate before round
    'interpolate',
    'round',
    // set range then reverse
    'range',
    'reverse',
    // Order does not matter for these operators
    'align',
    'base',
    'clamp',
    'constant',
    'exponent',
    'padding',
    'unknown'
];
// Use Record to enforce that all keys in OperatorType must exist.
var $8dd3c4ebebad7819$var$operators = {
    domain: (0, $7NDDt.default),
    nice: (0, $7goQn.default),
    zero: (0, $jUCfg.default),
    interpolate: (0, $ic1Fv.default),
    round: (0, $4sSWK.default),
    align: (0, $8m6Xe.default),
    base: (0, $c8Zjd.default),
    clamp: (0, $1MYRX.default),
    constant: (0, $adff9.default),
    exponent: (0, $1MyI8.default),
    padding: (0, $c1r8l.default),
    range: (0, $aag8f.default),
    reverse: (0, $dWXcN.default),
    unknown: (0, $iuIpV.default)
};
function $8dd3c4ebebad7819$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, ops = new Array(_len), _key = 0; _key < _len; _key++)ops[_key] = arguments[_key];
    var selection = new Set(ops);
    var selectedOps = $8dd3c4ebebad7819$export$5f274da11658f617.filter(function(o) {
        return selection.has(o);
    });
    return function applyOperators(scale, config) {
        if (typeof config !== 'undefined') selectedOps.forEach(function(op) {
            $8dd3c4ebebad7819$var$operators[op](scale, config);
        });
        return scale;
    };
}

});
parcelRegister("7NDDt", function(module, exports) {

$parcel$export(module.exports, "default", () => $5adbdad8d7dbd927$export$2e2bcd8739ae039);
function $5adbdad8d7dbd927$export$2e2bcd8739ae039(scale, config) {
    if (config.domain) {
        if ('nice' in scale || 'quantiles' in scale) // continuous input scales
        scale.domain(config.domain);
        else if ('padding' in scale) // point and band scales
        scale.domain(config.domain);
        else // ordinal and threshold scale
        scale.domain(config.domain);
    }
}

});

parcelRegister("aag8f", function(module, exports) {

$parcel$export(module.exports, "default", () => $76675a108d27a9d2$export$2e2bcd8739ae039);
function $76675a108d27a9d2$export$2e2bcd8739ae039(scale, config) {
    if (config.range) {
        if ('padding' in scale) // point and band scales
        scale.range(config.range);
        else // the rest
        scale.range(config.range);
    }
}

});

parcelRegister("8m6Xe", function(module, exports) {

$parcel$export(module.exports, "default", () => $6155c5c6f5439590$export$2e2bcd8739ae039);
function $6155c5c6f5439590$export$2e2bcd8739ae039(scale, config) {
    if ('align' in scale && 'align' in config && typeof config.align !== 'undefined') scale.align(config.align);
}

});

parcelRegister("c8Zjd", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d75ca1400c343c0$export$2e2bcd8739ae039);
function $8d75ca1400c343c0$export$2e2bcd8739ae039(scale, config) {
    if ('base' in scale && 'base' in config && typeof config.base !== 'undefined') scale.base(config.base);
}

});

parcelRegister("1MYRX", function(module, exports) {

$parcel$export(module.exports, "default", () => $14d97d80be7dc302$export$2e2bcd8739ae039);
function $14d97d80be7dc302$export$2e2bcd8739ae039(scale, config) {
    if ('clamp' in scale && 'clamp' in config && typeof config.clamp !== 'undefined') scale.clamp(config.clamp);
}

});

parcelRegister("adff9", function(module, exports) {

$parcel$export(module.exports, "default", () => $76f6f14eacc4e6ab$export$2e2bcd8739ae039);
function $76f6f14eacc4e6ab$export$2e2bcd8739ae039(scale, config) {
    if ('constant' in scale && 'constant' in config && typeof config.constant !== 'undefined') scale.constant(config.constant);
}

});

parcelRegister("1MyI8", function(module, exports) {

$parcel$export(module.exports, "default", () => $14c532f8d5c42e52$export$2e2bcd8739ae039);
function $14c532f8d5c42e52$export$2e2bcd8739ae039(scale, config) {
    if ('exponent' in scale && 'exponent' in config && typeof config.exponent !== 'undefined') scale.exponent(config.exponent);
}

});

parcelRegister("ic1Fv", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3eaa44c0ab3088c$export$2e2bcd8739ae039);

var $fVmmU = parcelRequire("fVmmU");
function $d3eaa44c0ab3088c$export$2e2bcd8739ae039(scale, config) {
    if ('interpolate' in config && 'interpolate' in scale && typeof config.interpolate !== 'undefined') {
        var interpolator = (0, $fVmmU.default)(config.interpolate);
        scale.interpolate(interpolator);
    }
}

});
parcelRegister("fVmmU", function(module, exports) {

$parcel$export(module.exports, "default", () => $b97d87c86200b9cc$export$2e2bcd8739ae039);

var $bktzi = parcelRequire("bktzi");
var $45TwU = parcelRequire("45TwU");
var $9faDM = parcelRequire("9faDM");
var $fBRs6 = parcelRequire("fBRs6");
var $aG0QU = parcelRequire("aG0QU");
var $b97d87c86200b9cc$var$interpolatorMap = {
    lab: (0, $fBRs6.default),
    hcl: (0, $45TwU.default),
    'hcl-long': (0, $45TwU.hclLong),
    hsl: (0, $9faDM.default),
    'hsl-long': (0, $9faDM.hslLong),
    cubehelix: (0, $bktzi.default),
    'cubehelix-long': (0, $bktzi.cubehelixLong),
    rgb: (0, $aG0QU.default)
};
function $b97d87c86200b9cc$export$2e2bcd8739ae039(interpolate) {
    switch(interpolate){
        case 'lab':
        case 'hcl':
        case 'hcl-long':
        case 'hsl':
        case 'hsl-long':
        case 'cubehelix':
        case 'cubehelix-long':
        case 'rgb':
            return $b97d87c86200b9cc$var$interpolatorMap[interpolate];
        default:
    }
    var type = interpolate.type, gamma = interpolate.gamma;
    var interpolator = $b97d87c86200b9cc$var$interpolatorMap[type];
    return typeof gamma === 'undefined' ? interpolator : interpolator.gamma(gamma);
}

});


parcelRegister("7goQn", function(module, exports) {

$parcel$export(module.exports, "default", () => $549d4c81fda79cdb$export$2e2bcd8739ae039);
parcelRequire("dwFQU");
var $cRW5v = parcelRequire("cRW5v");
var $kSdfl = parcelRequire("kSdfl");
var $7yDT1 = parcelRequire("7yDT1");
var $2jkSd = parcelRequire("2jkSd");
var $dayZI = parcelRequire("dayZI");
var $8vb39 = parcelRequire("8vb39");
var $idw3k = parcelRequire("idw3k");

var $jjmqp = parcelRequire("jjmqp");
var $549d4c81fda79cdb$var$localTimeIntervals = {
    day: (0, $cRW5v.timeDay),
    hour: (0, $kSdfl.timeHour),
    minute: (0, $7yDT1.timeMinute),
    month: (0, $2jkSd.timeMonth),
    second: (0, $dayZI.second),
    week: (0, $8vb39.timeSunday),
    year: (0, $idw3k.timeYear)
};
var $549d4c81fda79cdb$var$utcIntervals = {
    day: (0, $cRW5v.utcDay),
    hour: (0, $kSdfl.utcHour),
    minute: (0, $7yDT1.utcMinute),
    month: (0, $2jkSd.utcMonth),
    second: (0, $dayZI.second),
    week: (0, $8vb39.utcSunday),
    year: (0, $idw3k.utcYear)
};
function $549d4c81fda79cdb$export$2e2bcd8739ae039(scale, config) {
    if ('nice' in config && typeof config.nice !== 'undefined' && 'nice' in scale) {
        var nice = config.nice;
        if (typeof nice === 'boolean') {
            if (nice) scale.nice();
        } else if (typeof nice === 'number') scale.nice(nice);
        else {
            var timeScale = scale;
            var isUtc = (0, $jjmqp.default)(timeScale);
            if (typeof nice === 'string') timeScale.nice(isUtc ? $549d4c81fda79cdb$var$utcIntervals[nice] : $549d4c81fda79cdb$var$localTimeIntervals[nice]);
            else {
                var interval = nice.interval, step = nice.step;
                var parsedInterval = (isUtc ? $549d4c81fda79cdb$var$utcIntervals[interval] : $549d4c81fda79cdb$var$localTimeIntervals[interval]).every(step);
                if (parsedInterval != null) timeScale.nice(parsedInterval);
            }
        }
    }
}

});
parcelRegister("dwFQU", function(module, exports) {
$parcel$export(module.exports, "timeDay", () => (parcelRequire("cRW5v")).timeDay);
$parcel$export(module.exports, "timeHour", () => (parcelRequire("kSdfl")).timeHour);
$parcel$export(module.exports, "timeMinute", () => (parcelRequire("7yDT1")).timeMinute);
$parcel$export(module.exports, "timeMonth", () => (parcelRequire("2jkSd")).timeMonth);
$parcel$export(module.exports, "timeSecond", () => (parcelRequire("dayZI")).second);
$parcel$export(module.exports, "timeWeek", () => (parcelRequire("8vb39")).timeSunday);
$parcel$export(module.exports, "timeYear", () => (parcelRequire("idw3k")).timeYear);
$parcel$export(module.exports, "utcDay", () => (parcelRequire("cRW5v")).utcDay);
$parcel$export(module.exports, "utcHour", () => (parcelRequire("kSdfl")).utcHour);
$parcel$export(module.exports, "utcMinute", () => (parcelRequire("7yDT1")).utcMinute);
$parcel$export(module.exports, "utcMonth", () => (parcelRequire("2jkSd")).utcMonth);
$parcel$export(module.exports, "utcSecond", () => (parcelRequire("dayZI")).second);
$parcel$export(module.exports, "utcWeek", () => (parcelRequire("8vb39")).utcSunday);
$parcel$export(module.exports, "utcYear", () => (parcelRequire("idw3k")).utcYear);
/**
 * `@visx/vendor/d3-time` (ESM)
 * See upstream license: https://github.com/d3/d3-time/blob/main/LICENSE
 *
 * This ESM package re-exports the underlying installed dependencies of 
 * `node_modules/d3-time`
 */ parcelRequire("gsGNk");

});


parcelRegister("c1r8l", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c0aa03447ba5a2e$export$2e2bcd8739ae039);
function $8c0aa03447ba5a2e$export$2e2bcd8739ae039(scale, config) {
    if ('padding' in scale && 'padding' in config && typeof config.padding !== 'undefined') scale.padding(config.padding);
    if ('paddingInner' in scale && 'paddingInner' in config && typeof config.paddingInner !== 'undefined') scale.paddingInner(config.paddingInner);
    if ('paddingOuter' in scale && 'paddingOuter' in config && typeof config.paddingOuter !== 'undefined') scale.paddingOuter(config.paddingOuter);
}

});

parcelRegister("dWXcN", function(module, exports) {

$parcel$export(module.exports, "default", () => $a27e9e1fda753c21$export$2e2bcd8739ae039);
function $a27e9e1fda753c21$export$2e2bcd8739ae039(scale, config) {
    if (config.reverse) {
        var reversedRange = scale.range().slice().reverse();
        if ('padding' in scale) // point and band scales
        scale.range(reversedRange);
        else // the rest
        scale.range(reversedRange);
    }
}

});

parcelRegister("4sSWK", function(module, exports) {

$parcel$export(module.exports, "default", () => $3404662c433becd8$export$2e2bcd8739ae039);

var $8Masb = parcelRequire("8Masb");
function $3404662c433becd8$export$2e2bcd8739ae039(scale, config) {
    if ('round' in config && typeof config.round !== 'undefined') {
        if (config.round && 'interpolate' in config && typeof config.interpolate !== 'undefined') console.warn("[visx/scale/applyRound] ignoring round: scale config contains round and interpolate. only applying interpolate. config:", config);
        else if ('round' in scale) // for point and band scales
        scale.round(config.round);
        else if ('interpolate' in scale && config.round) // for continuous output scales
        // setting config.round = true
        // is actually setting interpolator to interpolateRound
        // as these scales do not have scale.round() function
        scale.interpolate((0, $8Masb.default));
    }
}

});

parcelRegister("iuIpV", function(module, exports) {

$parcel$export(module.exports, "default", () => $d76d7ba35e78d530$export$2e2bcd8739ae039);
function $d76d7ba35e78d530$export$2e2bcd8739ae039(scale, config) {
    if ('unknown' in scale && 'unknown' in config && typeof config.unknown !== 'undefined') scale.unknown(config.unknown);
}

});

parcelRegister("jUCfg", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7f0ea00b7703963$export$2e2bcd8739ae039);
function $e7f0ea00b7703963$export$2e2bcd8739ae039(scale, config) {
    if ('zero' in config && config.zero === true) {
        var domain = scale.domain();
        var a = domain[0], b = domain[1];
        var isDescending = b < a;
        var _ref = isDescending ? [
            b,
            a
        ] : [
            a,
            b
        ], min = _ref[0], max = _ref[1];
        var domainWithZero = [
            Math.min(0, min),
            Math.max(0, max)
        ];
        scale.domain(isDescending ? domainWithZero.reverse() : domainWithZero);
    }
}

});



const $22cf0ae7e72c2bef$export$b3026b3c8d26dc41 = 70;

parcelRegister("8LERT", function(module, exports) {

$parcel$export(module.exports, "default", () => $66226a162ab0f42c$export$2e2bcd8739ae039);

var $aDODq = parcelRequire("aDODq");
function $66226a162ab0f42c$export$2e2bcd8739ae039(_ref, horizontal) {
    let { x: x, y: y } = _ref;
    return new (0, $aDODq.default)(horizontal ? {
        x: x,
        y: y
    } : {
        x: y,
        y: x
    });
}

});
parcelRegister("aDODq", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bf4d2f2ef1d9d73$export$2e2bcd8739ae039);
class $7bf4d2f2ef1d9d73$export$2e2bcd8739ae039 {
    x = 0;
    y = 0;
    constructor(_ref){
        let { x: x = 0, y: y = 0 } = _ref;
        this.x = x;
        this.y = y;
    }
    value() {
        return {
            x: this.x,
            y: this.y
        };
    }
    toArray() {
        return [
            this.x,
            this.y
        ];
    }
}

});


parcelRegister("4ZQLi", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a35c94ede701419$export$2e2bcd8739ae039);
/**
 * Create a function that returns a tick position for the given tick value
 */ function $3a35c94ede701419$export$2e2bcd8739ae039(scale, align) {
    if (align === void 0) align = 'center';
    // Broaden type before using 'xxx' in s as typeguard.
    const s = scale;
    // For point or band scales,
    // have to add offset to make the tick at center or end.
    if (align !== 'start' && 'bandwidth' in s) {
        let offset = s.bandwidth();
        if (align === 'center') offset /= 2;
        if (s.round()) offset = Math.round(offset);
        return (d)=>{
            const scaledValue = s(d);
            return typeof scaledValue === 'number' ? scaledValue + offset : scaledValue;
        };
    }
    return scale;
}

});



parcelRegister("cXzUG", function(module, exports) {

$parcel$export(module.exports, "AxisLeftTick", () => $96f6da52418ad5a2$export$d9ad68803a03e71);
$parcel$export(module.exports, "AxisLeftLine", () => $96f6da52418ad5a2$export$25abdf51e62eb76e);
$parcel$export(module.exports, "AxisLeftText", () => $96f6da52418ad5a2$export$68f34be0235fe9c0);
$parcel$export(module.exports, "AxisLeft", () => $96f6da52418ad5a2$export$4b76feaa547cd202);
/* AxisLeft.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $bwpsq = parcelRequire("bwpsq");

var $bT1Sw = parcelRequire("bT1Sw");

var $eFK63 = parcelRequire("eFK63");

var $jxg43 = parcelRequire("jxg43");

var $42C9W = parcelRequire("42C9W");

var $f8uii = parcelRequire("f8uii");

var $da7Ww = parcelRequire("da7Ww");

var $l5ab7 = parcelRequire("l5ab7");

var $2vbO1 = parcelRequire("2vbO1");

var $kq3PX = parcelRequire("kq3PX");

var $2OMIu = parcelRequire("2OMIu");
const $96f6da52418ad5a2$export$ec95513e2647ff3 = {
    color: "var(--ds-text-subtlest, grey)",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
    fontSize: 12
};
const $96f6da52418ad5a2$var$tickLength = 8;
const $96f6da52418ad5a2$var$orientation = (0, $jxg43.default).left;
const $96f6da52418ad5a2$export$d9ad68803a03e71 = (0, $bT1Sw.element)((0, $l5ab7.Tick));
const $96f6da52418ad5a2$export$25abdf51e62eb76e = (0, $bT1Sw.element)((_ref)=>{
    let { height: height, hide: hide } = _ref;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $da7Ww.AxisLine), {
        hide: hide,
        style: {
            borderLeft: `2px solid ${(0, $da7Ww.axisLineStroke)}`,
            height: `${height}px`,
            position: 'absolute',
            transform: 'translateX(-1px)'
        }
    });
});
const $96f6da52418ad5a2$export$68f34be0235fe9c0 = (0, $bT1Sw.element)((_ref2)=>{
    let { width: width, formatter: formatter, truncate: truncate, singleline: singleline, children: children } = _ref2;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2vbO1.TickText), {
        style: {
            maxWidth: width
        },
        formatter: formatter,
        truncate: truncate,
        singleline: singleline,
        children: children
    });
});
function $96f6da52418ad5a2$var$AxisLeft(_ref3) {
    let { scale: scale, numTicks: numTicks, tickValues: tickValues, rangePadding: rangePadding, hideZero: hideZero, label: // TODO: Should label become it's own element?
    label, hide: hide } = _ref3;
    if (hide) return null;
    const { ticks: ticks } = (0, $kq3PX.useAxisTicks)({
        scale: scale,
        numTicks: numTicks,
        tickValues: tickValues,
        orientation: $96f6da52418ad5a2$var$orientation,
        rangePadding: rangePadding,
        hideZero: hideZero,
        tickLength: $96f6da52418ad5a2$var$tickLength
    });
    const TicksTextsComponent = ticks.map((_ref4)=>{
        let { value: value, index: index, from: from, to: to } = _ref4;
        const formatter = (0, $f8uii.default)(scale);
        return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            style: {
                // Ugh I hate you magic number
                top: `calc(${to.y}px - .6em)`,
                minWidth: 0,
                gridColumn: 1,
                gridRow: 1,
                position: 'relative',
                textAlign: 'right',
                ...$96f6da52418ad5a2$export$ec95513e2647ff3
            },
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($96f6da52418ad5a2$export$68f34be0235fe9c0, {
                formatter: formatter,
                width: 250,
                truncate: (0, $42C9W.default)(scale) === 'string',
                children: value
            })
        }, `axis-left-text-${index}-${value}-${from.toArray()}-${to.toArray()}`);
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                style: {
                    gridArea: 'plot',
                    display: 'flex'
                },
                children: /*#__PURE__*/ (0, $2OMIu.jsx)($96f6da52418ad5a2$export$25abdf51e62eb76e, {
                    height: scale.range()[0]
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                "data-axis-type": "axis-left",
                className: (0, $bwpsq.default)([
                    "_nd5l1jbf _1e0c11p5 _yv0elpux _1tke1osq"
                ]),
                children: [
                    label ? /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        style: {
                            overflow: 'hidden',
                            maxHeight: '100%',
                            width: 'max-content',
                            textOverflow: 'ellipsis',
                            alignSelf: 'center',
                            writingMode: 'vertical-rl',
                            transform: 'rotate(-180deg)',
                            paddingLeft: '8px',
                            whiteSpace: 'nowrap',
                            ...(0, $eFK63.defaultTextHTMLProps)
                        },
                        children: label
                    }) : /*#__PURE__*/ (0, $2OMIu.jsx)("div", {}),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        className: (0, $bwpsq.default)([
                            "_1e0c11p5 _1bsb1ris _wij21bp4 _yv0ehkll _2z05hkll _u5f31crf _lcxvglyw"
                        ]),
                        children: TicksTextsComponent
                    })
                ]
            })
        ]
    });
}
const $96f6da52418ad5a2$export$4b76feaa547cd202 = (0, $bT1Sw.element)($96f6da52418ad5a2$var$AxisLeft);

});

parcelRegister("lWVLr", function(module, exports) {

$parcel$export(module.exports, "LayoutContainer", () => $ffabd285ad88bd55$export$faad8b178f68f912);
$parcel$export(module.exports, "Layout", () => (parcelRequire("7Nxvv")).Layout);

var $7Nxvv = parcelRequire("7Nxvv");

var $2OMIu = parcelRequire("2OMIu");
function $ffabd285ad88bd55$export$faad8b178f68f912(_ref) {
    let { height: height, width: width, children: children, ...props } = _ref;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7Nxvv.Layout), {
        showBorder: true,
        width: width,
        height: height,
        hasSubtitle: true,
        gridTemplate: (0, $7Nxvv.defaultGrid),
        ...props,
        children: children
    });
}

});
parcelRegister("7Nxvv", function(module, exports) {

$parcel$export(module.exports, "defaultGrid", () => $5ad719d8f2270c77$export$aed5b7d86c3777ab);
$parcel$export(module.exports, "Layout", () => $5ad719d8f2270c77$export$c84671f46d6a1ca);
/* layout.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $bT1Sw = parcelRequire("bT1Sw");

var $bSbfx = parcelRequire("bSbfx");

var $chU1I = parcelRequire("chU1I");

var $doqD0 = parcelRequire("doqD0");
var $l6fAT = parcelRequire("l6fAT");

var $2OMIu = parcelRequire("2OMIu");
const $5ad719d8f2270c77$export$aed5b7d86c3777ab = [
    'title',
    'subtitle',
    'legend',
    'plot'
];
function $5ad719d8f2270c77$var$Layout(_ref) {
    var _ref2, _ordering$plot;
    let { children: children, width: width, height: height, gridTemplate: gridTemplate, hasSubtitle: hasSubtitle, overflow: overflow = 'hidden', showBorder: showBorder = true } = _ref;
    const ordering = gridTemplate.reduce((acc, key, i)=>{
        acc[key] = i + 1;
        return acc;
    }, {});
    const chartOrder = (_ref2 = (_ordering$plot = ordering['plot']) !== null && _ordering$plot !== void 0 ? _ordering$plot : ordering['plot-legend']) !== null && _ref2 !== void 0 ? _ref2 : ordering['legend-plot'];
    const chartFlexDirection = ordering['plot'] || ordering['legend'] ? 'column' : 'row';
    const chartFlexReverse = ordering['legend'] > ordering['plot'] || ordering['plot-legend'] ? '-reverse' : '';
    const [fadeInOpacity, setFadeInOpacity] = (0, $5uXOq.useState)(0);
    (0, $5uXOq.useEffect)(()=>{
        let isMounted = true;
        const ref = window.requestAnimationFrame(()=>{
            // TODO: would be nice to fade in without triggering another render
            if (isMounted) setFadeInOpacity(1);
        });
        return ()=>{
            isMounted = false;
            window.cancelAnimationFrame(ref);
        };
    }, [
        setFadeInOpacity
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
            "data-element": "layout",
            style: {
                width: width,
                height: height,
                backgroundColor: "var(--ds-surface, white)",
                border: showBorder ? `1px solid ${"var(--ds-border, lightgrey)"}` : '0px',
                padding: showBorder ? "var(--ds-space-200, 16px)" : 0,
                overflow: overflow
            },
            className: (0, $bwpsq.default)([
                "_1e0c1txw _kqswh2mm _4t3i1osq _2lx21bp4 _vchhusvi"
            ]),
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                    style: {
                        order: ordering.title,
                        position: 'relative'
                    },
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bSbfx.Icon), {}),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l6fAT.Title), {})
                    ]
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    style: {
                        order: ordering.subtitle
                    },
                    children: hasSubtitle && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $doqD0.Subtitle), {})
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    "data-element": "chart",
                    style: {
                        opacity: fadeInOpacity,
                        transition: 'opacity .3s ease-in-out',
                        order: chartOrder,
                        flexDirection: `${chartFlexDirection}${chartFlexReverse}`
                    },
                    className: (0, $bwpsq.default)([
                        "_1e0c1txw _1ul9idpf _1tkeidpf _16jlkb7n"
                    ]),
                    children: children
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $chU1I.ChartMenu), {})
            ]
        })
    });
}
const $5ad719d8f2270c77$export$c84671f46d6a1ca = (0, $bT1Sw.element)($5ad719d8f2270c77$var$Layout);

});
parcelRegister("bSbfx", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $8a4d76c7fe38e6da$export$f04a61298a47a40f);
/* icon.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $bwpsq = parcelRequire("bwpsq");

var $bT1Sw = parcelRequire("bT1Sw");

var $2OMIu = parcelRequire("2OMIu");
const $8a4d76c7fe38e6da$var$iconStyle = null;
function $8a4d76c7fe38e6da$var$Icon(_ref) {
    let { children: children } = _ref;
    if (!children) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_1bsb7vkz _4t3i1tcg _syaz1oju"
        ]),
        children: children
    });
}
const $8a4d76c7fe38e6da$export$f04a61298a47a40f = (0, $bT1Sw.element)($8a4d76c7fe38e6da$var$Icon);

});

parcelRegister("chU1I", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $8f22884b61eb2a4d$export$d9b273488cd8ce6f);
$parcel$export(module.exports, "ChartMenu", () => $8f22884b61eb2a4d$export$597da2837c1a3c88);

var $42CjB = parcelRequire("42CjB");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $3oUqw = parcelRequire("3oUqw");

var $bT1Sw = parcelRequire("bT1Sw");
var $17PP9 = parcelRequire("17PP9");
parcelRequire("lWVLr");
var $7Nxvv = parcelRequire("7Nxvv");

var $3Anq0 = parcelRequire("3Anq0");

var $PfPCm = parcelRequire("PfPCm");

var $2OMIu = parcelRequire("2OMIu");
const $8f22884b61eb2a4d$export$d9b273488cd8ce6f = (0, $bT1Sw.element)((_ref)=>{
    let { children: children, hide: hide = false, toggleDataTable: toggleDataTable, toggleShowPatterns: toggleShowPatterns, showPatterns: showPatterns, disablePatternOption: disablePatternOption = false } = _ref;
    if (hide) return null;
    const { showBorder: showBorder } = (0, $17PP9.useElementProps)((0, $7Nxvv.Layout));
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        style: {
            position: 'absolute',
            top: 0,
            right: 0,
            padding: showBorder ? "var(--ds-space-200, 16px)" : 0
        },
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $BLPHT.default), {
            trigger: (_ref2)=>{
                let { triggerRef: triggerRef, ...props } = _ref2;
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                    ...props,
                    appearance: "subtle",
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($3oUqw))),
                    label: "Chart Menu",
                    ref: triggerRef,
                    spacing: "compact"
                });
            },
            label: "Chart Menu",
            shouldRenderToParent: true,
            placement: "top-end",
            spacing: "compact",
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $aRoVz.default), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6B7KL.default), {
                        onClick: toggleDataTable,
                        testId: (0, $3Anq0.a11yStrings).showDataTable,
                        children: (0, $3Anq0.a11yStrings).showDataTable
                    }, (0, $3Anq0.a11yStrings).showDataTable),
                    !disablePatternOption ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6B7KL.default), {
                        onClick: toggleShowPatterns,
                        testId: (0, $3Anq0.a11yStrings).enablePatterns,
                        children: showPatterns ? (0, $3Anq0.a11yStrings).disablePatterns : (0, $3Anq0.a11yStrings).enablePatterns
                    }, (0, $3Anq0.a11yStrings).enablePatterns) : null,
                    children
                ]
            })
        })
    });
});
function $8f22884b61eb2a4d$export$597da2837c1a3c88(props) {
    const { toggleDataTable: toggleDataTable, toggleShowPatterns: toggleShowPatterns, showPatterns: showPatterns } = (0, $PfPCm.useMenuData)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)($8f22884b61eb2a4d$export$d9b273488cd8ce6f, {
        ...props,
        toggleDataTable: toggleDataTable,
        toggleShowPatterns: toggleShowPatterns,
        showPatterns: showPatterns
    });
}

});
parcelRegister("3Anq0", function(module, exports) {

$parcel$export(module.exports, "a11yStrings", () => $29c6e64aba406dd9$export$1bab900455080d68);
const $29c6e64aba406dd9$export$1bab900455080d68 = {
    enablePatterns: 'Enable Patterns',
    disablePatterns: 'Disable Patterns',
    showDataTable: 'Show Data Table'
};

});

parcelRegister("PfPCm", function(module, exports) {

$parcel$export(module.exports, "useMenuData", () => $09a10b5983af36a5$export$bf0039e2171862f5);
$parcel$export(module.exports, "MenuProvider", () => $09a10b5983af36a5$export$62b22d151866115d);

var $5uXOq = parcelRequire("5uXOq");

var $2OMIu = parcelRequire("2OMIu");
function $09a10b5983af36a5$export$2ce5e940c4008526() {
    const [showDataTable, setShowDataTable] = (0, $5uXOq.useState)(false);
    const [showPatterns, setShowPatterns] = (0, $5uXOq.useState)(false);
    const toggleDataTable = (0, $5uXOq.useCallback)(()=>{
        setShowDataTable((prevShowDataTable)=>!prevShowDataTable);
    }, [
        setShowDataTable
    ]);
    const closeDataTable = (0, $5uXOq.useCallback)(()=>{
        setShowDataTable(false);
    }, [
        setShowDataTable
    ]);
    const toggleShowPatterns = (0, $5uXOq.useCallback)(()=>{
        setShowPatterns((prevShowPatterns)=>!prevShowPatterns);
    }, [
        setShowPatterns
    ]);
    return {
        showDataTable: showDataTable,
        closeDataTable: closeDataTable,
        toggleDataTable: toggleDataTable,
        showPatterns: showPatterns,
        toggleShowPatterns: toggleShowPatterns
    };
}
const $09a10b5983af36a5$export$c7e742effb1c51e2 = /*#__PURE__*/ (0, $5uXOq.createContext)({});
function $09a10b5983af36a5$export$bf0039e2171862f5() {
    return (0, $5uXOq.useContext)($09a10b5983af36a5$export$c7e742effb1c51e2);
}
const $09a10b5983af36a5$export$62b22d151866115d = (_ref)=>{
    let { children: children } = _ref;
    const { showDataTable: showDataTable, toggleDataTable: toggleDataTable, closeDataTable: closeDataTable, showPatterns: showPatterns, toggleShowPatterns: toggleShowPatterns } = $09a10b5983af36a5$export$2ce5e940c4008526();
    return /*#__PURE__*/ (0, $2OMIu.jsx)($09a10b5983af36a5$export$c7e742effb1c51e2.Provider, {
        value: {
            showDataTable: showDataTable,
            showPatterns: showPatterns,
            closeDataTable: closeDataTable,
            toggleDataTable: toggleDataTable,
            toggleShowPatterns: toggleShowPatterns
        },
        children: children
    });
};

});


parcelRegister("doqD0", function(module, exports) {

$parcel$export(module.exports, "Subtitle", () => $9c022c0b2fd1f025$export$cf345ef34cd72655);
/* subtitle.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $bwpsq = parcelRequire("bwpsq");

var $bT1Sw = parcelRequire("bT1Sw");

var $2OMIu = parcelRequire("2OMIu");
const $9c022c0b2fd1f025$var$subTitleTextStyle = null;
function $9c022c0b2fd1f025$var$Subtitle(_ref) {
    let { children: children } = _ref;
    if (!children) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("h3", {
        className: (0, $bwpsq.default)([
            "_syaz1gjq _k48p1nn1 _ect41wi2 _1wyb1crf _zg8l4jg8 _vwz47vkz _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdftgi _19bvidpf"
        ]),
        children: children
    });
}
const $9c022c0b2fd1f025$export$cf345ef34cd72655 = (0, $bT1Sw.element)($9c022c0b2fd1f025$var$Subtitle);

});



parcelRegister("e2CtX", function(module, exports) {

$parcel$export(module.exports, "DimensionsWrapper", () => $a38f1a5b7b4f9d3d$export$a263c0cd0abdd921);

var $5uXOq = parcelRequire("5uXOq");
const $a38f1a5b7b4f9d3d$var$INITIAL_DIMENSIONS = {
    plotHeight: 100,
    plotWidth: 100,
    margin: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    }
};
function $a38f1a5b7b4f9d3d$export$a263c0cd0abdd921(_ref) {
    let { children: children } = _ref;
    const [, forceUpdate] = (0, $5uXOq.useState)({});
    const dimensions = (0, $5uXOq.useRef)($a38f1a5b7b4f9d3d$var$INITIAL_DIMENSIONS);
    const plotSvgRef = (0, $5uXOq.useRef)(null);
    // Update the dimensions and margin when the SVG element is resized.
    (0, $5uXOq.useEffect)(()=>{
        const resizeObserverSvg = new ResizeObserver((entries)=>{
            if (entries && entries[0]) {
                const { width: ws, height: hs } = entries[0].target.getBoundingClientRect();
                const newMargin = Object.assign({}, dimensions.current.margin);
                dimensions.current = {
                    margin: newMargin,
                    plotHeight: hs,
                    plotWidth: ws
                };
                forceUpdate({});
            }
        });
        // If parentDiv is available, observe it and its axis-left child (if exists).
        // If not, disconnect the observers.
        if (plotSvgRef.current) resizeObserverSvg.observe(plotSvgRef.current);
        return ()=>{
            resizeObserverSvg.disconnect();
        };
    }, []);
    return children({
        ...dimensions.current,
        plotSvgRef: plotSvgRef
    });
}

});

parcelRegister("erST8", function(module, exports) {

$parcel$export(module.exports, "Grid", () => $a84e29f28dbcd30d$export$ef2184bd89960b14);

var $bT1Sw = parcelRequire("bT1Sw");

var $jfNuF = parcelRequire("jfNuF");

var $f6BRA = parcelRequire("f6BRA");

var $2OMIu = parcelRequire("2OMIu");
function $a84e29f28dbcd30d$var$Grid(_ref) {
    let { top: top, left: left, xScale: xScale, yScale: yScale, width: width, height: height, rowStrokeWidth: rowStrokeWidth, columnStrokeWidth: columnStrokeWidth, columnStroke: columnStroke, rowStroke: rowStroke, numTicksRows: numTicksRows, numTicksColumns: numTicksColumns, rowLineStyle: rowLineStyle, columnLineStyle: columnLineStyle, xOffset: xOffset, yOffset: yOffset, rowTickValues: rowTickValues, columnTickValues: columnTickValues, hide: hide = false } = _ref;
    if (hide) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        style: {
            top: top,
            left: left,
            gridArea: 'plot'
        },
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f6BRA.GridRows), {
                scale: yScale,
                width: width,
                stroke: rowStroke,
                strokeWidth: rowStrokeWidth,
                numTicks: numTicksRows,
                lineStyle: rowLineStyle,
                offset: yOffset,
                tickValues: rowTickValues
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jfNuF.GridColumns), {
                scale: xScale,
                height: height,
                stroke: columnStroke,
                strokeWidth: columnStrokeWidth,
                numTicks: numTicksColumns,
                lineStyle: columnLineStyle,
                offset: xOffset,
                tickValues: columnTickValues
            })
        ]
    });
}
const $a84e29f28dbcd30d$export$ef2184bd89960b14 = (0, $bT1Sw.element)($a84e29f28dbcd30d$var$Grid);

});
parcelRegister("jfNuF", function(module, exports) {

$parcel$export(module.exports, "GridColumns", () => $e045cf746f0b4756$export$22a67e3ff32a357a);

var $5uXOq = parcelRequire("5uXOq");

var $bT1Sw = parcelRequire("bT1Sw");

var $hqZma = parcelRequire("hqZma");

var $kq3PX = parcelRequire("kq3PX");

var $jxg43 = parcelRequire("jxg43");

var $aDODq = parcelRequire("aDODq");

var $cMo1a = parcelRequire("cMo1a");

var $8KrAm = parcelRequire("8KrAm");

var $2OMIu = parcelRequire("2OMIu");
function $e045cf746f0b4756$var$GridColumns(_ref) {
    let { top: top = 0, left: left = 0, scale: scale, height: height, stroke: stroke = "var(--ds-border, lightgrey)", strokeWidth: strokeWidth = 1, numTicks: numTicks, lineStyle: lineStyle = 'solid', offset: offset, tickValues: tickValues, hide: hide = false } = _ref;
    if (hide) return null;
    const { ticks: ticks } = (0, $kq3PX.useAxisTicks)({
        scale: scale,
        numTicks: numTicks,
        tickValues: tickValues,
        tickLength: 8,
        orientation: (0, $jxg43.default).bottom,
        rangePadding: undefined
    });
    const scaleOffset = (offset !== null && offset !== void 0 ? offset : 0) + (0, $8KrAm.default)(scale) / 2;
    const tickLines = ticks.map((_ref2)=>{
        var _coerceNumber;
        let { value: value, index: index } = _ref2;
        const x = ((_coerceNumber = (0, $cMo1a.default)(scale(value))) !== null && _coerceNumber !== void 0 ? _coerceNumber : 0) + scaleOffset;
        return {
            index: index,
            from: new (0, $aDODq.default)({
                x: x,
                y: 0
            }),
            to: new (0, $aDODq.default)({
                x: x,
                y: height
            })
        };
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        style: {
            top: top,
            left: left,
            position: 'relative'
        },
        children: tickLines.map((_ref3)=>{
            let { from: from, to: to, index: index } = _ref3;
            return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hqZma.AxisBottomTick), {
                        from: from,
                        to: to
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        style: {
                            borderLeft: `${stroke} ${lineStyle} ${strokeWidth}px`,
                            height: `${to.y}px`,
                            position: 'absolute',
                            left: to.x
                        }
                    })
                ]
            }, `grid-columns-lines-${index}-${from.toArray()}-${to.toArray()}`);
        })
    });
}
const $e045cf746f0b4756$export$22a67e3ff32a357a = (0, $bT1Sw.element)($e045cf746f0b4756$var$GridColumns);

});
parcelRegister("8KrAm", function(module, exports) {

$parcel$export(module.exports, "default", () => $65e80487c092a9cc$export$2e2bcd8739ae039);
function $65e80487c092a9cc$export$2e2bcd8739ae039(scale) {
    return 'bandwidth' in scale ? scale.bandwidth() : 0;
}

});


parcelRegister("f6BRA", function(module, exports) {

$parcel$export(module.exports, "GridRows", () => $aff4c96cf8a8e597$export$f7ce055fe2ce64b1);

var $5uXOq = parcelRequire("5uXOq");

var $bT1Sw = parcelRequire("bT1Sw");

var $cXzUG = parcelRequire("cXzUG");

var $kq3PX = parcelRequire("kq3PX");

var $jxg43 = parcelRequire("jxg43");

var $aDODq = parcelRequire("aDODq");

var $cMo1a = parcelRequire("cMo1a");

var $8KrAm = parcelRequire("8KrAm");

var $2OMIu = parcelRequire("2OMIu");
function $aff4c96cf8a8e597$var$GridRows(_ref) {
    let { top: top = 0, left: left = 0, scale: scale, width: width, stroke: stroke = "var(--ds-border, lightgrey)", strokeWidth: strokeWidth = 1, numTicks: numTicks, lineStyle: lineStyle = 'solid', offset: offset, tickValues: tickValues, hide: hide = false } = _ref;
    if (hide) return null;
    const { ticks: ticks } = (0, $kq3PX.useAxisTicks)({
        scale: scale,
        numTicks: numTicks,
        tickValues: tickValues,
        tickLength: 8,
        orientation: (0, $jxg43.default).left,
        rangePadding: undefined
    });
    const scaleOffset = (offset !== null && offset !== void 0 ? offset : 0) + (0, $8KrAm.default)(scale) / 2;
    const tickLines = ticks.map((_ref2)=>{
        var _coerceNumber;
        let { value: value, index: index } = _ref2;
        const y = ((_coerceNumber = (0, $cMo1a.default)(scale(value))) !== null && _coerceNumber !== void 0 ? _coerceNumber : 0) + scaleOffset;
        return {
            index: index,
            from: new (0, $aDODq.default)({
                x: 0,
                y: y
            }),
            to: new (0, $aDODq.default)({
                x: width,
                y: y
            })
        };
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        style: {
            top: top,
            left: left,
            position: 'relative'
        },
        children: tickLines.map((_ref3)=>{
            let { from: from, to: to, index: index } = _ref3;
            return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cXzUG.AxisLeftTick), {
                        from: from,
                        to: to
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        style: {
                            borderBottom: `${strokeWidth}px ${lineStyle} ${stroke}`,
                            width: `${to.x}px`,
                            position: 'absolute',
                            top: `calc(${to.y}px)`
                        }
                    })
                ]
            }, `grid-rows-lines-${index}-${from.toArray()}-${to.toArray()}`);
        })
    });
}
const $aff4c96cf8a8e597$export$f7ce055fe2ce64b1 = (0, $bT1Sw.element)($aff4c96cf8a8e597$var$GridRows);

});


parcelRegister("3B9ij", function(module, exports) {

$parcel$export(module.exports, "LegendLabel", () => $29ec097709f60bdd$export$f77025011665b85c);
$parcel$export(module.exports, "OrdinalLegend", () => $29ec097709f60bdd$export$7f71253a43a34ee6);
/* OrdinalLegend.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $5uXOq = parcelRequire("5uXOq");

var $iZnN2 = parcelRequire("iZnN2");

var $bT1Sw = parcelRequire("bT1Sw");
var $17PP9 = parcelRequire("17PP9");

var $7Nxvv = parcelRequire("7Nxvv");


var $gEnb9 = parcelRequire("gEnb9");

var $2OMIu = parcelRequire("2OMIu");
const $29ec097709f60bdd$export$83dfac8e05432e26 = {
    color: "var(--ds-text-subtlest, #626F86)",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
    fontSize: '12px',
    margin: '8px 0px',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
};
const $29ec097709f60bdd$var$LegendSymbol = (_ref)=>{
    let { color: color, shape: shape } = _ref;
    let symbol;
    switch(shape){
        case 'square':
            symbol = /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                fill: color,
                width: (0, $0bd291d77cbdd29d$export$1949567a35c96224),
                height: (0, $0bd291d77cbdd29d$export$1949567a35c96224),
                rx: 1,
                ry: 1
            });
            break;
        case 'line':
            symbol = /*#__PURE__*/ (0, $2OMIu.jsx)("line", {
                x1: 0,
                y1: (0, $0bd291d77cbdd29d$export$1949567a35c96224) / 2,
                x2: (0, $0bd291d77cbdd29d$export$1949567a35c96224),
                y2: (0, $0bd291d77cbdd29d$export$1949567a35c96224) / 2,
                stroke: color,
                strokeWidth: 2
            });
            break;
        case 'circle':
        default:
            symbol = /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                fill: color,
                width: (0, $0bd291d77cbdd29d$export$1949567a35c96224),
                height: (0, $0bd291d77cbdd29d$export$1949567a35c96224),
                rx: (0, $0bd291d77cbdd29d$export$1949567a35c96224) / 2,
                ry: (0, $0bd291d77cbdd29d$export$1949567a35c96224) / 2
            });
    }
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
            width: (0, $0bd291d77cbdd29d$export$1949567a35c96224),
            height: (0, $0bd291d77cbdd29d$export$1949567a35c96224),
            children: symbol
        })
    });
};
const $29ec097709f60bdd$export$f77025011665b85c = (0, $bT1Sw.element)((_ref2)=>{
    let { labelAccessor: labelAccessor, datum: datum } = _ref2;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_syaz131l _ect41wi2 _1wyb1crf _19pkftgi _2hwxidpf _otyrftgi _18u0idpf _1bto1l2s _1reo15vq _18m915vq _o5721q9c"
        ]),
        children: labelAccessor(datum)
    });
});
const $29ec097709f60bdd$var$VerticalLegendMark = (_ref3)=>{
    let { color: color, labelAccessor: labelAccessor, shape: shape, opacity: opacity, datum: datum } = _ref3;
    const label = labelAccessor(datum);
    const { emitActiveSeriesKey: emitActiveSeriesKey } = (0, $iZnN2.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        style: {
            opacity: opacity
        },
        onPointerEnter: (e)=>emitActiveSeriesKey(e, label),
        onPointerLeave: (e)=>emitActiveSeriesKey(e, undefined),
        className: (0, $bwpsq.default)([
            "_1e0c1txw _zulpftgi _p12f1osq _4t3izwfg _1ul9idpf"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)($29ec097709f60bdd$var$LegendSymbol, {
                color: color,
                shape: shape
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)($29ec097709f60bdd$export$f77025011665b85c, {
                datum: datum,
                labelAccessor: labelAccessor
            })
        ]
    });
};
const $29ec097709f60bdd$var$HorizontalLegendMark = (_ref4)=>{
    let { color: color, labelAccessor: labelAccessor, shape: shape, opacity: opacity, datum: datum } = _ref4;
    const label = labelAccessor(datum);
    const { emitActiveSeriesKey: emitActiveSeriesKey } = (0, $iZnN2.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        style: {
            opacity: opacity
        },
        onPointerEnter: (e)=>emitActiveSeriesKey(e, label),
        onPointerLeave: (e)=>emitActiveSeriesKey(e, undefined),
        className: (0, $bwpsq.default)([
            "_1e0c116y _zulpftgi _4t3izwfg _1ul9idpf"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)($29ec097709f60bdd$var$LegendSymbol, {
                color: color,
                shape: shape
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)($29ec097709f60bdd$export$f77025011665b85c, {
                labelAccessor: labelAccessor,
                datum: datum
            })
        ]
    });
};
function $29ec097709f60bdd$var$VerticalLegend(_ref5) {
    let { data: data, colorAccessor: colorAccessor, colorScale: colorScale, labelAccessor: labelAccessor, shape: shape, justifyContent: justifyContent = 'center', maxRows: maxRows = 10 } = _ref5;
    const legendRef = (0, $5uXOq.useRef)(null);
    const [truncationIndex, setTruncationIndex] = (0, $5uXOq.useState)((0, $0bd291d77cbdd29d$export$7bf402e928540137));
    const flatData = (0, $gEnb9.useFlatData)({
        labelAccessor: labelAccessor,
        data: data
    });
    (0, $gEnb9.useTruncationIndexObserver)({
        legendRefCurrent: legendRef.current,
        setTruncationIndex: setTruncationIndex
    });
    const itemsToTruncate = flatData.length - (truncationIndex || 0);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: legendRef,
        style: {
            maxHeight: `${maxRows * (0, $0bd291d77cbdd29d$export$bc48d9a7fd313bb2) + 2}px`,
            justifyContent: justifyContent
        },
        className: (0, $bwpsq.default)([
            "_1e0c116y _1bah1h6o _1n261g80 _16jlidpf _1o9zidpf _i0dl1r5k _2lx21bp4 _ae4v1y6m _19pk1wug _2hwx1wug _otyr1wug _18u01wug _19bv1crf _4t3i1osq _1reo15vq _18m915vq _gy1p7vkz"
        ]),
        children: flatData.map((d, i)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
                children: itemsToTruncate > 0 && truncationIndex - 1 <= i ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                        style: {
                            position: 'relative'
                        },
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)($29ec097709f60bdd$var$VerticalLegendMark, {
                                color: colorScale(colorAccessor(d)),
                                labelAccessor: labelAccessor,
                                shape: shape,
                                opacity: 0,
                                datum: d
                            }, labelAccessor(d)),
                            truncationIndex - 1 === i && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                                style: {
                                    position: 'absolute',
                                    top: 0,
                                    left: 0
                                },
                                className: (0, $bwpsq.default)([
                                    "_syaz131l _ect41wi2 _1wyb1crf _19pkftgi _2hwxidpf _otyrftgi _18u0idpf _1bto1l2s _1reo15vq _18m915vq _o5721q9c"
                                ]),
                                children: ` ... ${itemsToTruncate + 1} more`
                            })
                        ]
                    })
                }) : /*#__PURE__*/ (0, $2OMIu.jsx)($29ec097709f60bdd$var$VerticalLegendMark, {
                    color: colorScale(colorAccessor(d)),
                    labelAccessor: labelAccessor,
                    shape: shape,
                    datum: d
                }, labelAccessor(d))
            }, `vertical-leged-entry${labelAccessor(d)}-${colorScale(colorAccessor(d))}-${i}`))
    });
}
function $29ec097709f60bdd$var$HorizontalLegend(_ref6) {
    let { data: data, colorAccessor: colorAccessor, colorScale: colorScale, labelAccessor: labelAccessor, shape: shape, justifyContent: justifyContent = 'flex-start', flexDirection: flexDirection = 'row', maxRows: maxRows = 5 } = _ref6;
    const legendRef = (0, $5uXOq.useRef)(null);
    const [truncationIndex, setTruncationIndex] = (0, $5uXOq.useState)((0, $0bd291d77cbdd29d$export$7bf402e928540137));
    const flatData = (0, $gEnb9.useFlatData)({
        labelAccessor: labelAccessor,
        data: data
    });
    (0, $gEnb9.useTruncationIndexObserver)({
        legendRefCurrent: legendRef.current,
        setTruncationIndex: setTruncationIndex
    });
    const itemsToTruncate = flatData.length - (truncationIndex || 0);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: legendRef,
        className: (0, $bwpsq.default)([
            "_1e0c116y _1n261g80 _16jlidpf _1o9zidpf _i0dl1wug _2lx21o5q _ae4v1y6m _1bsb1osq _1reo15vq _18m915vq _gy1p7vkz"
        ]),
        style: {
            maxHeight: `${maxRows * (0, $0bd291d77cbdd29d$export$bc48d9a7fd313bb2) + 2}px`,
            justifyContent: justifyContent,
            "--_j9pi5t": (0, $lD23V.default)(flexDirection)
        },
        children: flatData.map((d, i)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
                children: itemsToTruncate > 0 && truncationIndex - 1 === i ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                        style: {
                            position: 'relative'
                        },
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)($29ec097709f60bdd$var$HorizontalLegendMark, {
                                color: colorScale(colorAccessor(d)),
                                labelAccessor: labelAccessor,
                                shape: shape,
                                opacity: 0,
                                datum: d
                            }, labelAccessor(d)),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                                style: {
                                    position: 'absolute',
                                    top: 0,
                                    left: 0
                                },
                                className: (0, $bwpsq.default)([
                                    "_syaz131l _ect41wi2 _1wyb1crf _19pkftgi _2hwxidpf _otyrftgi _18u0idpf _1bto1l2s _1reo15vq _18m915vq _o5721q9c"
                                ]),
                                children: ` ... ${itemsToTruncate + 1} more`
                            })
                        ]
                    })
                }) : /*#__PURE__*/ (0, $2OMIu.jsx)($29ec097709f60bdd$var$HorizontalLegendMark, {
                    color: colorScale(colorAccessor(d)),
                    labelAccessor: labelAccessor,
                    shape: shape,
                    datum: d
                }, labelAccessor(d))
            }, `horizontal-leged-entry${labelAccessor(d)}-${colorScale(colorAccessor(d))}-${i}`))
    });
}
function $29ec097709f60bdd$export$734b3ee2d20431e7(_ref7) {
    var _layoutProps$gridTemp;
    let { data: data, colorAccessor: colorAccessor, colorScale: colorScale, labelAccessor: labelAccessor, shape: shape, maxRows: maxRows, justifyContent: justifyContent, flexDirection: flexDirection = 'row', hide: hide = false } = _ref7;
    const layoutProps = (0, $17PP9.useElementProps)((0, $7Nxvv.Layout));
    const sideBySide = !((_layoutProps$gridTemp = layoutProps.gridTemplate) !== null && _layoutProps$gridTemp !== void 0 && _layoutProps$gridTemp.includes('legend'));
    if (hide) return null;
    if (sideBySide) return /*#__PURE__*/ (0, $2OMIu.jsx)($29ec097709f60bdd$var$VerticalLegend, {
        data: data,
        colorAccessor: colorAccessor,
        colorScale: colorScale,
        labelAccessor: labelAccessor,
        shape: shape,
        maxRows: maxRows,
        justifyContent: justifyContent
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)($29ec097709f60bdd$var$HorizontalLegend, {
        data: data,
        colorAccessor: colorAccessor,
        colorScale: colorScale,
        labelAccessor: labelAccessor,
        shape: shape,
        maxRows: maxRows,
        justifyContent: justifyContent,
        flexDirection: flexDirection
    });
}
const $29ec097709f60bdd$export$7f71253a43a34ee6 = (0, $bT1Sw.element)($29ec097709f60bdd$export$734b3ee2d20431e7);

});
parcelRegister("iZnN2", function(module, exports) {

$parcel$export(module.exports, "EVENT_TYPE", () => $dd3060ab55d6e4ba$export$76a2e4c433c23bb9);
$parcel$export(module.exports, "SERIES_SOURCE", () => $dd3060ab55d6e4ba$export$8312cda563b4f1d7);
$parcel$export(module.exports, "default", () => $dd3060ab55d6e4ba$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lI55a = parcelRequire("lI55a");
const $dd3060ab55d6e4ba$export$76a2e4c433c23bb9 = 'pointermove';
const $dd3060ab55d6e4ba$export$8312cda563b4f1d7 = 'series-key-highlight';
function $dd3060ab55d6e4ba$export$2e2bcd8739ae039(eventType) {
    if (eventType === void 0) eventType = $dd3060ab55d6e4ba$export$76a2e4c433c23bb9;
    const emit = (0, $lI55a.default)();
    const emitActiveSeriesKey = (0, $5uXOq.useCallback)((event, label)=>emit === null || emit === void 0 ? void 0 : emit(eventType, event, $dd3060ab55d6e4ba$export$8312cda563b4f1d7, label), [
        emit
    ]);
    return {
        emitActiveSeriesKey: emitActiveSeriesKey
    };
}

});
parcelRegister("lI55a", function(module, exports) {

$parcel$export(module.exports, "default", () => $fce1a64b58ee40be$export$2e2bcd8739ae039);
// eslint-disable-next-line no-restricted-syntax

var $eIrko = parcelRequire("eIrko");

var $5uXOq = parcelRequire("5uXOq");

var $fsVNF = parcelRequire("fsVNF");
function $fce1a64b58ee40be$export$2e2bcd8739ae039(/** Type of event to subscribe to. */ eventType, /** Handler invoked on emission of EventType event.  */ handler, /** Optional valid sources for EventType subscription. */ allowedSources) {
    const emitter = (0, $5uXOq.useContext)((0, $fsVNF.default));
    const allowedSourcesRef = (0, $5uXOq.useRef)();
    allowedSourcesRef.current = allowedSources; // use ref so allowedSources[] can change without creating new handlers
    // wrap emitter.emit so we can enforce stricter type signature
    const emit = (0, $5uXOq.useCallback)((type, event, source, datum)=>{
        if (emitter) emitter.emit(type, {
            event: event,
            svgPoint: (0, $eIrko.default)(event),
            source: source,
            datum: datum
        });
    }, [
        emitter
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (emitter && eventType && handler) {
            // register handler, with source filtering as needed
            const handlerWithSourceFilter = (params)=>{
                var _allowedSourcesRef$cu;
                if (!allowedSourcesRef.current || params !== null && params !== void 0 && params.source && (_allowedSourcesRef$cu = allowedSourcesRef.current) !== null && _allowedSourcesRef$cu !== void 0 && _allowedSourcesRef$cu.includes(params.source)) handler(params);
            };
            emitter.on(eventType, handlerWithSourceFilter);
            return ()=>emitter === null || emitter === void 0 ? void 0 : emitter.off(eventType, handlerWithSourceFilter);
        }
        return undefined;
    }, [
        emitter,
        eventType,
        handler
    ]);
    return emitter ? emit : null;
}

});
parcelRegister("fsVNF", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4264e6f736a6013$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $b4264e6f736a6013$var$EventEmitterContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
var $b4264e6f736a6013$export$2e2bcd8739ae039 = $b4264e6f736a6013$var$EventEmitterContext;

});



const $0bd291d77cbdd29d$export$e64d201155cc8fe2 = 160;
const $0bd291d77cbdd29d$export$bc48d9a7fd313bb2 = 32;
const $0bd291d77cbdd29d$export$fece36e05d7a6c7b = 8;
const $0bd291d77cbdd29d$export$57cb39d4eda3140a = 16;
const $0bd291d77cbdd29d$export$1949567a35c96224 = 12;
const $0bd291d77cbdd29d$export$3a3ed70a2e553a67 = 2;
const $0bd291d77cbdd29d$export$7bf402e928540137 = 10000;

parcelRegister("gEnb9", function(module, exports) {

$parcel$export(module.exports, "useTruncationIndexObserver", () => $c1f25c9c571436f1$export$ec599d67f76e7af7);
$parcel$export(module.exports, "useFlatData", () => $c1f25c9c571436f1$export$f27cffe517b2d3a3);

var $5uXOq = parcelRequire("5uXOq");
const $c1f25c9c571436f1$export$178827bcd84b6d71 = (data, labelAccessor)=>{
    return data.reduce((flat, d)=>{
        const label = labelAccessor(d);
        if (flat[label]) return flat;
        const newFlatData = {
            ...flat
        };
        newFlatData[label] = d;
        return newFlatData;
    }, {});
};
const $c1f25c9c571436f1$export$5303528d1070ff6f = (value)=>{
    if (value === 'normal') return 8;
    else return parseFloat(value);
};
function $c1f25c9c571436f1$export$ec599d67f76e7af7(_ref) {
    let { legendRefCurrent: legendRefCurrent, setTruncationIndex: setTruncationIndex } = _ref;
    (0, $5uXOq.useEffect)(()=>{
        const observer = new ResizeObserver((entries)=>{
            let fit = 0;
            const content = [
                ...entries[0].target.children
            ];
            content.forEach((d)=>{
                // Look into isVisible function
                if (!$c1f25c9c571436f1$export$660f61eb7bd5242a(entries[0].target, d)) fit += 1;
            });
            setTruncationIndex(fit);
        });
        if (legendRefCurrent) observer.observe(legendRefCurrent);
        return ()=>{
            if (legendRefCurrent) observer.unobserve(legendRefCurrent);
        };
    }, [
        legendRefCurrent,
        setTruncationIndex
    ]);
}
const $c1f25c9c571436f1$export$660f61eb7bd5242a = (parent, child)=>{
    const box1coords = parent.getBoundingClientRect();
    const box2coords = child.getBoundingClientRect();
    if (box2coords.top + 2 < box1coords.top || box2coords.right - 2 > box1coords.right || box2coords.bottom - 2 > box1coords.bottom || box2coords.left + 2 < box1coords.left) return true;
    return false;
};
function $c1f25c9c571436f1$export$f27cffe517b2d3a3(_ref2) {
    let { labelAccessor: labelAccessor, data: data } = _ref2;
    return (0, $5uXOq.useMemo)(()=>Object.values(data.reduce((flat, d)=>{
            const label = labelAccessor(d);
            if (flat[label]) return flat;
            const newFlatData = {
                ...flat
            };
            newFlatData[label] = {
                ...d
            };
            return newFlatData;
        }, {})), [
        labelAccessor,
        data
    ]);
}

});


parcelRegister("iTGbP", function(module, exports) {

$parcel$export(module.exports, "PrivateBar", () => $dc1e1713f476a0f6$export$79dfc6df660f8241);
$parcel$export(module.exports, "Bar", () => $dc1e1713f476a0f6$export$bbc6c6369b38e3d1);
/* Bar.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $bwpsq = parcelRequire("bwpsq");

var $bT1Sw = parcelRequire("bT1Sw");

var $2OMIu = parcelRequire("2OMIu");
function $dc1e1713f476a0f6$var$createPathFromRoundedRect(x, y, width, height, radius) {
    if (radius === void 0) radius = {};
    const xEnd = x + width;
    const yEnd = y + height;
    const { topLeft: topLeft = 0, topRight: topRight = 0, bottomLeft: bottomLeft = 0, bottomRight: bottomRight = 0 } = radius;
    return `M${x + (topLeft !== null && topLeft !== void 0 ? topLeft : 0)} ${y}
    L${xEnd - (topRight !== null && topRight !== void 0 ? topRight : 0)} ${y}
    A${topRight !== null && topRight !== void 0 ? topRight : 0} ${topRight !== null && topRight !== void 0 ? topRight : 0} 0 0 1 ${xEnd} ${y + (topRight !== null && topRight !== void 0 ? topRight : 0)}
    L${xEnd} ${yEnd - (bottomRight !== null && bottomRight !== void 0 ? bottomRight : 0)}
    A${bottomRight !== null && bottomRight !== void 0 ? bottomRight : 0} ${bottomRight !== null && bottomRight !== void 0 ? bottomRight : 0} 0 0 1 ${xEnd - (bottomRight !== null && bottomRight !== void 0 ? bottomRight : 0)} ${yEnd}
    L${x + (bottomLeft !== null && bottomLeft !== void 0 ? bottomLeft : 0)} ${yEnd}
    A${bottomLeft !== null && bottomLeft !== void 0 ? bottomLeft : 0} ${bottomLeft !== null && bottomLeft !== void 0 ? bottomLeft : 0} 0 0 1 ${x} ${yEnd - (bottomLeft !== null && bottomLeft !== void 0 ? bottomLeft : 0)}
    L${x} ${y + (topLeft !== null && topLeft !== void 0 ? topLeft : 0)}
    A${topLeft !== null && topLeft !== void 0 ? topLeft : 0} ${topLeft !== null && topLeft !== void 0 ? topLeft : 0} 0 0 1 ${x + (topLeft !== null && topLeft !== void 0 ? topLeft : 0)} ${y}
    Z`;
}
const $dc1e1713f476a0f6$var$barStyles = null;
function $dc1e1713f476a0f6$export$79dfc6df660f8241(_ref) {
    let { datum: datum, innerRef: innerRef, ariaLabel: ariaLabel, x: x, y: y, width: width, height: height, cornerRadius: cornerRadius, fill: fill, opacity: opacity } = _ref;
    const d = $dc1e1713f476a0f6$var$createPathFromRoundedRect(x, y, width, height, cornerRadius);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
        fill: fill,
        opacity: opacity,
        role: "img",
        "aria-label": ariaLabel,
        ref: innerRef,
        d: d,
        className: (0, $bwpsq.default)([
            "_v564g17y"
        ])
    });
}
const $dc1e1713f476a0f6$export$bbc6c6369b38e3d1 = (0, $bT1Sw.element)($dc1e1713f476a0f6$export$79dfc6df660f8241);

});

parcelRegister("cgmj2", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ORDINAL_COLORS", () => $8ed8482abbab76e7$export$1a2fb10b6c1fe2eb);
$parcel$export(module.exports, "DEFAULT_ORDINAL_PATTERNS_DEFS", () => $8ed8482abbab76e7$export$3b4caf16b18628d7);
$parcel$export(module.exports, "useThemeFillStyles", () => $8ed8482abbab76e7$export$c533e33795ec3ca2);
$parcel$export(module.exports, "Theme", () => $8ed8482abbab76e7$export$14faa19a0f3bbeb2);

var $bT1Sw = parcelRequire("bT1Sw");

var $d9B5x = parcelRequire("d9B5x");
var $dTtIr = parcelRequire("dTtIr");
var $7jqLY = parcelRequire("7jqLY");
var $9VXb2 = parcelRequire("9VXb2");
var $ekGvZ = parcelRequire("ekGvZ");
var $e1sbT = parcelRequire("e1sbT");

var $2OMIu = parcelRequire("2OMIu");
const $8ed8482abbab76e7$export$f32b764d072ed1b7 = [
    "var(--ds-chart-categorical-1, #2898BD)",
    "var(--ds-chart-categorical-2, #5E4DB2)",
    "var(--ds-chart-categorical-3, #E56910)",
    "var(--ds-chart-categorical-4, #943D73)",
    "var(--ds-chart-categorical-5, #09326C)",
    "var(--ds-chart-categorical-6, #8F7EE7)",
    "var(--ds-chart-categorical-7, #50253F)",
    "var(--ds-chart-categorical-8, #A54800)"
];
const $8ed8482abbab76e7$export$5d11cb9bccf8f5db = [
    {
        key: 'danger',
        value: "var(--ds-chart-danger, #F15B50)"
    },
    {
        key: 'warning',
        value: "var(--ds-chart-warning, #B38600)"
    },
    {
        key: 'success',
        value: "var(--ds-chart-success, #22A06B)"
    },
    {
        key: 'discovery',
        value: "var(--ds-chart-discovery, #8F7EE7)"
    },
    {
        key: 'information',
        value: "var(--ds-chart-information, #388BFF)"
    },
    {
        key: 'neutral',
        value: "var(--ds-chart-neutral, #8590A2)"
    }
];
const $8ed8482abbab76e7$export$f29a3c9071a2ca9 = [
    "var(--ds-chart-red-bold, #2898BD)",
    "var(--ds-chart-orange-bold, #943D73)",
    "var(--ds-chart-yellow-bold, #E56910)",
    "var(--ds-chart-lime-bold, #5E4DB2)",
    "var(--ds-chart-green-bold, #09326C)",
    "var(--ds-chart-teal-bold, #09326C)",
    "var(--ds-chart-blue-bold, #8F7EE7)",
    "var(--ds-chart-purple-bold, #50253F)",
    "var(--ds-chart-magenta-bold, #A54800)",
    "var(--ds-chart-gray-bold, #A54800)",
    "var(--ds-chart-red-boldest, #2898BD)",
    "var(--ds-chart-orange-boldest, #943D73)",
    "var(--ds-chart-yellow-boldest, #E56910)",
    "var(--ds-chart-lime-boldest, #5E4DB2)",
    "var(--ds-chart-green-boldest, #09326C)",
    "var(--ds-chart-teal-boldest, #09326C)",
    "var(--ds-chart-blue-boldest, #8F7EE7)",
    "var(--ds-chart-purple-boldest, #50253F)",
    "var(--ds-chart-magenta-boldest, #A54800)",
    "var(--ds-chart-gray-boldest, #A54800)"
];
const $8ed8482abbab76e7$export$1a2fb10b6c1fe2eb = [
    "var(--ds-chart-brand, #2898BD)",
    "var(--ds-chart-orange-bold, #943D73)",
    "var(--ds-chart-magenta-bold, #E56910)",
    "var(--ds-chart-lime-bold, #5E4DB2)",
    "var(--ds-chart-purple-bold, #09326C)",
    "var(--ds-chart-teal-bold, #8F7EE7)",
    "var(--ds-chart-green-bold, #50253F)",
    "var(--ds-chart-blue-boldest, #A54800)"
];
const $8ed8482abbab76e7$export$3b4caf16b18628d7 = [
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ekGvZ.default), {
        id: 'lines1',
        height: 5,
        width: 5,
        stroke: '#000000',
        background: $8ed8482abbab76e7$export$1a2fb10b6c1fe2eb[0],
        strokeWidth: 1,
        orientation: [
            'diagonal'
        ]
    }),
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7jqLY.default), {
        id: 'crosshair1',
        width: 5,
        height: 5,
        stroke: '#000000',
        background: $8ed8482abbab76e7$export$1a2fb10b6c1fe2eb[1],
        strokeWidth: 0.7,
        rotation: 45,
        gap: 7
    }),
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ekGvZ.default), {
        id: 'lines2',
        height: 5,
        width: 5,
        stroke: '#000000',
        background: $8ed8482abbab76e7$export$1a2fb10b6c1fe2eb[2],
        strokeWidth: 1,
        orientation: [
            'diagonalRightToLeft'
        ]
    }),
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7jqLY.default), {
        id: 'crosshair2',
        width: 10,
        height: 10,
        stroke: '#000000',
        background: $8ed8482abbab76e7$export$1a2fb10b6c1fe2eb[3],
        strokeWidth: 0.5,
        rotation: 45,
        gap: 7
    }),
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dTtIr.default), {
        id: "circles1",
        height: 8,
        width: 8,
        radius: 1,
        background: $8ed8482abbab76e7$export$1a2fb10b6c1fe2eb[4],
        stroke: '#000000',
        strokeWidth: 0.4,
        complement: true,
        fill: 'none'
    }),
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e1sbT.default), {
        id: "waves1",
        height: 6,
        width: 6,
        stroke: '#000000',
        background: $8ed8482abbab76e7$export$1a2fb10b6c1fe2eb[5],
        strokeWidth: 0.5
    }),
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9VXb2.default), {
        id: "hexagons1",
        height: 3,
        background: $8ed8482abbab76e7$export$1a2fb10b6c1fe2eb[6],
        size: 3,
        gap: 2,
        strokeWidth: 0.5,
        stroke: "#000000"
    }),
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ekGvZ.default), {
        id: "lines3",
        height: 6,
        width: 5,
        stroke: '#000000',
        strokeDasharray: 3,
        background: $8ed8482abbab76e7$export$1a2fb10b6c1fe2eb[7],
        orientation: [
            'horizontal'
        ]
    })
];
const $8ed8482abbab76e7$export$7b0a836186aa9014 = (0, $d9B5x.getPatternUrls)($8ed8482abbab76e7$export$3b4caf16b18628d7);
const $8ed8482abbab76e7$export$c533e33795ec3ca2 = (_ref)=>{
    let { fillStyles: customFillStyles, enableDefaultPatterns: enableDefaultPatterns } = _ref;
    const fillStyles = enableDefaultPatterns ? $8ed8482abbab76e7$export$7b0a836186aa9014 : customFillStyles;
    if (!fillStyles) return {
        range: [],
        domain: []
    };
    if (fillStyles.filter((d)=>typeof d !== 'string').length > 0) return {
        domain: fillStyles.map((d)=>typeof d === 'string' ? d : d.key),
        range: fillStyles.map((d)=>typeof d === 'string' ? d : d.value)
    };
    else return {
        range: fillStyles === null || fillStyles === void 0 ? void 0 : fillStyles.map((d)=>typeof d === 'string' ? d : d.value)
    };
};
const $8ed8482abbab76e7$export$14faa19a0f3bbeb2 = (0, $bT1Sw.element)((_ref2)=>{
    let { children: children } = _ref2;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
});
const $8ed8482abbab76e7$export$569885e57444f84a = {
    accessibleCategorical: $8ed8482abbab76e7$export$f32b764d072ed1b7,
    categorical: $8ed8482abbab76e7$export$1a2fb10b6c1fe2eb,
    status: $8ed8482abbab76e7$export$5d11cb9bccf8f5db,
    categorical20: $8ed8482abbab76e7$export$f29a3c9071a2ca9,
    accessiblePatternDefs: $8ed8482abbab76e7$export$3b4caf16b18628d7
};

});
parcelRegister("d9B5x", function(module, exports) {

$parcel$export(module.exports, "getPatternUrls", () => $9938e29a28d7097f$export$c66920886885446e);
const $9938e29a28d7097f$export$c66920886885446e = (patterns)=>{
    if (!patterns) return [];
    return patterns.map((pattern)=>`url(#${pattern.props.id})`);
};

});

parcelRegister("dTtIr", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1d77660c0b91a6c$export$2e2bcd8739ae039);
// import cx from 'classnames';

var $12tJU = parcelRequire("12tJU");

var $2OMIu = parcelRequire("2OMIu");
function $a1d77660c0b91a6c$export$2e2bcd8739ae039(_ref) {
    var _corners;
    let { id: id, width: width, height: height, radius: radius = 2, fill: fill, stroke: stroke, strokeWidth: strokeWidth, strokeDasharray: strokeDasharray, background: background, complement: complement = false, className: className } = _ref;
    let corners;
    if (complement) corners = [
        [
            0,
            0
        ],
        [
            0,
            height
        ],
        [
            width,
            0
        ],
        [
            width,
            height
        ]
    ];
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $12tJU.default), {
        id: id,
        width: width,
        height: height,
        children: [
            !!background && /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                width: width,
                height: height,
                fill: background
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("circle", {
                // className={cx('visx-pattern-circle', className)}
                cx: width / 2,
                cy: height / 2,
                r: radius,
                fill: fill,
                stroke: stroke,
                strokeWidth: strokeWidth,
                strokeDasharray: strokeDasharray
            }),
            (_corners = corners) === null || _corners === void 0 ? void 0 : _corners.map((_ref2)=>{
                let [cornerX, cornerY] = _ref2;
                return /*#__PURE__*/ (0, $2OMIu.jsx)("circle", {
                    // className={cx('visx-pattern-circle visx-pattern-circle-complement', className)}
                    cx: cornerX,
                    cy: cornerY,
                    r: radius,
                    fill: fill,
                    stroke: stroke,
                    strokeWidth: strokeWidth,
                    strokeDasharray: strokeDasharray
                }, `${id}-complement-${cornerX}-${cornerY}`);
            })
        ]
    });
}

});
parcelRegister("12tJU", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c1d0bfb9e2e6ff6$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
function $0c1d0bfb9e2e6ff6$export$2e2bcd8739ae039(_ref) {
    let { id: id, width: width, height: height, children: children } = _ref;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("defs", {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("pattern", {
            id: id,
            width: width,
            height: height,
            patternUnits: "userSpaceOnUse",
            children: children
        })
    });
}

});


parcelRegister("7jqLY", function(module, exports) {

$parcel$export(module.exports, "default", () => $552f134aa047ca1f$export$2e2bcd8739ae039);

var $12tJU = parcelRequire("12tJU");

var $2OMIu = parcelRequire("2OMIu");
function $552f134aa047ca1f$export$2e2bcd8739ae039(_ref) {
    let { id: id, width: width, height: height, stroke: stroke = 'black', strokeWidth: strokeWidth = 1, strokeDasharray: strokeDasharray, background: background, className: className, rotation: rotation = 0, gap: gap = 10 } = _ref;
    const halfGap = gap / 2;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $12tJU.default), {
        id: id,
        width: gap,
        height: gap,
        children: [
            !!background && /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                width: gap,
                height: gap,
                fill: background
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                transform: `rotate(${rotation}, ${gap / 2}, ${gap / 2})`,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("line", {
                        // Horizontal line
                        x1: halfGap - width / 2,
                        y1: halfGap,
                        x2: halfGap + width / 2,
                        y2: halfGap,
                        stroke: stroke,
                        strokeWidth: strokeWidth,
                        strokeDasharray: strokeDasharray
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("line", {
                        // Vertical line
                        x1: halfGap,
                        y1: halfGap - height / 2,
                        x2: halfGap,
                        y2: halfGap + height / 2,
                        stroke: stroke,
                        strokeWidth: strokeWidth,
                        strokeDasharray: strokeDasharray
                    })
                ]
            })
        ]
    });
}

});

parcelRegister("9VXb2", function(module, exports) {

$parcel$export(module.exports, "default", () => $73b7573cb69bdfa6$export$2e2bcd8739ae039);

var $j92zy = parcelRequire("j92zy");

var $2OMIu = parcelRequire("2OMIu");
function $73b7573cb69bdfa6$export$2e2bcd8739ae039(_ref) {
    let { id: id, height: height, fill: fill, stroke: stroke, strokeWidth: strokeWidth, strokeDasharray: strokeDasharray, shapeRendering: shapeRendering, background: background, className: className, size: size = 3, gap: gap = 0 } = _ref;
    const hexWidth = size * Math.sqrt(3) + gap;
    const hexHeight = size * 2 + gap;
    const path = `
        M ${size * Math.sqrt(3) / 2 + gap / 2},${gap / 2}
        L ${size * Math.sqrt(3) + gap / 2},${size / 2 + gap / 2}
        L ${size * Math.sqrt(3) + gap / 2},${size * 1.5 + gap / 2}
        L ${size * Math.sqrt(3) / 2 + gap / 2},${size * 2 + gap / 2}
        L ${gap / 2},${size * 1.5 + gap / 2}
        L ${gap / 2},${size / 2 + gap / 2}
        Z
    `;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j92zy.default), {
        path: path,
        id: id,
        width: hexWidth,
        height: hexHeight,
        fill: fill,
        stroke: stroke,
        strokeWidth: strokeWidth,
        strokeDasharray: strokeDasharray,
        shapeRendering: shapeRendering,
        background: background
    });
}

});
parcelRegister("j92zy", function(module, exports) {

$parcel$export(module.exports, "default", () => $df00da6821c1721f$export$2e2bcd8739ae039);
// import cx from 'classnames';

var $12tJU = parcelRequire("12tJU");

var $2OMIu = parcelRequire("2OMIu");
function $df00da6821c1721f$export$2e2bcd8739ae039(_ref) {
    let { id: id, width: width, height: height, path: path, fill: fill = 'transparent', stroke: stroke, strokeWidth: strokeWidth, strokeDasharray: strokeDasharray, strokeLinecap: strokeLinecap = 'square', shapeRendering: shapeRendering = 'auto', background: background, className: className } = _ref;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $12tJU.default), {
        id: id,
        width: width,
        height: height,
        children: [
            !!background && /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                width: width,
                height: height,
                fill: background
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                // className={cx('visx-pattern-path', className)}
                d: path,
                fill: fill,
                stroke: stroke,
                strokeWidth: strokeWidth,
                strokeDasharray: strokeDasharray,
                strokeLinecap: strokeLinecap,
                shapeRendering: shapeRendering
            })
        ]
    });
}

});


parcelRegister("ekGvZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6f3e98601748030$export$2e2bcd8739ae039);
// import cx from 'classnames';

var $1GwA3 = parcelRequire("1GwA3");

var $12tJU = parcelRequire("12tJU");

var $2OMIu = parcelRequire("2OMIu");
function $a6f3e98601748030$export$777054cdc3eb6ab2(_ref) {
    let { height: height, orientation: orientation } = _ref;
    switch(orientation){
        case (0, $1GwA3.PatternOrientation).horizontal:
            return `M 0,${height / 2} l ${height},0`;
        case (0, $1GwA3.PatternOrientation).diagonal:
            return `M 0,${height} l ${height},${-height} M ${-height / 4},${height / 4} l ${height / 2},${-height / 2}
             M ${3 / 4 * height},${5 / 4 * height} l ${height / 2},${-height / 2}`;
        case (0, $1GwA3.PatternOrientation).diagonalRightToLeft:
            return `M 0,0 l ${height},${height}
        M ${-height / 4},${3 / 4 * height} l ${height / 2},${height / 2}
        M ${3 / 4 * height},${-height / 4} l ${height / 2},${height / 2}`;
        case (0, $1GwA3.PatternOrientation).vertical:
        default:
            return `M ${height / 2}, 0 l 0, ${height}`;
    }
}
function $a6f3e98601748030$export$2e2bcd8739ae039(_ref2) {
    let { id: id, width: width, height: height, stroke: stroke, strokeWidth: strokeWidth, strokeDasharray: strokeDasharray, strokeLinecap: strokeLinecap = 'square', shapeRendering: shapeRendering = 'auto', orientation: orientation = [
        'vertical'
    ], background: background, className: className } = _ref2;
    const orientations = Array.isArray(orientation) ? orientation : [
        orientation
    ];
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $12tJU.default), {
        id: id,
        width: width,
        height: height,
        children: [
            !!background && /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                // className={cx('visx-pattern-line-background')}
                width: width,
                height: height,
                fill: background
            }),
            orientations.map((o, i)=>/*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    // className={cx('visx-pattern-line', className)}
                    d: $a6f3e98601748030$export$777054cdc3eb6ab2({
                        orientation: o,
                        height: height
                    }),
                    stroke: stroke,
                    strokeWidth: strokeWidth,
                    strokeDasharray: strokeDasharray,
                    strokeLinecap: strokeLinecap,
                    shapeRendering: shapeRendering
                }, `visx-${id}-line-${o}-${i}`))
        ]
    });
}

});
parcelRegister("1GwA3", function(module, exports) {

$parcel$export(module.exports, "PatternOrientation", () => $13a2fc7b62d049a2$export$c37d4d4692ef0c91);
const $13a2fc7b62d049a2$export$c37d4d4692ef0c91 = {
    horizontal: 'horizontal',
    vertical: 'vertical',
    diagonal: 'diagonal',
    diagonalRightToLeft: 'diagonalRightToLeft'
};

});


parcelRegister("e1sbT", function(module, exports) {

$parcel$export(module.exports, "default", () => $a35706caca164049$export$2e2bcd8739ae039);
// import cx from 'classnames';

var $j92zy = parcelRequire("j92zy");

var $2OMIu = parcelRequire("2OMIu");
function $a35706caca164049$export$2e2bcd8739ae039(_ref) {
    let { id: id, width: width, height: height, fill: fill, stroke: stroke, strokeWidth: strokeWidth, strokeDasharray: strokeDasharray, strokeLinecap: strokeLinecap, shapeRendering: shapeRendering, background: background, className: className } = _ref;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j92zy.default), {
        path: `M 0 ${height / 2} c ${height / 8} ${-height / 4} , ${height * 3 / 8} ${-height / 4} , ${height / 2} 0
             c ${height / 8} ${height / 4} , ${height * 3 / 8} ${height / 4} , ${height / 2} 0 M ${-height / 2} ${height / 2}
             c ${height / 8} ${height / 4} , ${height * 3 / 8} ${height / 4} , ${height / 2} 0 M ${height} ${height / 2}
             c ${height / 8} ${-height / 4} , ${height * 3 / 8} ${-height / 4} , ${height / 2} 0`,
        id: id,
        width: width,
        height: height,
        fill: fill,
        stroke: stroke,
        strokeWidth: strokeWidth,
        strokeDasharray: strokeDasharray,
        strokeLinecap: strokeLinecap,
        shapeRendering: shapeRendering,
        background: background
    });
}

});


parcelRegister("1Tf3y", function(module, exports) {

$parcel$export(module.exports, "TooltipHeader", () => $16069b6018acac22$export$fd7ac08b5fcaeea);
/* TooltipHeader.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $bwpsq = parcelRequire("bwpsq");

var $bT1Sw = parcelRequire("bT1Sw");

var $2OMIu = parcelRequire("2OMIu");
const $16069b6018acac22$var$headerCss = null;
function $16069b6018acac22$var$TooltipHeader(_ref) {
    let { children: children, hide: hide, datum: datum } = _ref;
    if (hide) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_1wpz1fhb _syaz1glm _1wyb1skh _ect41wi2 _k48p1nn1 _slp31hna"
        ]),
        children: children
    });
}
const $16069b6018acac22$export$fd7ac08b5fcaeea = (0, $bT1Sw.element)($16069b6018acac22$var$TooltipHeader);

});

parcelRegister("lA40p", function(module, exports) {

$parcel$export(module.exports, "TooltipRow", () => $fb601131272529e7$export$4cf463b4a9fc631a);
/* TooltipRow.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $bwpsq = parcelRequire("bwpsq");

var $bT1Sw = parcelRequire("bT1Sw");

var $2OMIu = parcelRequire("2OMIu");
const $fb601131272529e7$var$outerDivCss = null;
const $fb601131272529e7$var$innerDivCss = null;
const $fb601131272529e7$var$colorItemCss = null;
const $fb601131272529e7$var$labelItemCss = null;
const $fb601131272529e7$var$valueItemCss = null;
function $fb601131272529e7$var$TooltipRow(_ref) {
    let { color: color, label: label, value: value, datum: datum } = _ref;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_1wpz1fhb _1bah1yb4 _4cvr1h6o _1e0c116y"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
            className: (0, $bwpsq.default)([
                "_u5f3ftgi _1bah1y6m _4cvr1h6o _zulpftgi _1e0c1txw"
            ]),
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        "_1bah1y6m _4cvr1h6o _zulpftgi _1e0c1txw"
                    ]),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
                        style: {
                            width: 12,
                            height: 12,
                            borderRadius: 2
                        },
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                            width: "100%",
                            height: "100%",
                            fill: color
                        })
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        "_ect41wi2 _syaz13nv _1wybdlk8 _k48p1nn1 _slp31hna"
                    ]),
                    children: label
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        "_ect41wi2 _syaz13nv _1wybdlk8 _k48p1nn1 _vwz41q5e _slp31hna"
                    ]),
                    children: value
                })
            ]
        })
    });
}
const $fb601131272529e7$export$4cf463b4a9fc631a = (0, $bT1Sw.element)($fb601131272529e7$var$TooltipRow);

});

parcelRegister("02ifK", function(module, exports) {

$parcel$export(module.exports, "default", () => $006e58b2f5bf66cd$export$2e2bcd8739ae039);

var $iktP3 = parcelRequire("iktP3");

var $5uXOq = parcelRequire("5uXOq");

var $fsVNF = parcelRequire("fsVNF");

var $2OMIu = parcelRequire("2OMIu");
function $006e58b2f5bf66cd$export$2e2bcd8739ae039(_ref) {
    let { children: children } = _ref;
    const emitter = (0, $5uXOq.useMemo)(()=>(0, $iktP3.default)(), []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fsVNF.default).Provider, {
        value: emitter,
        children: children
    });
}

});

parcelRegister("e0UVN", function(module, exports) {

$parcel$export(module.exports, "default", () => $a33d3a1e9d33e815$export$2e2bcd8739ae039);

var $2qM0c = parcelRequire("2qM0c");

var $5uXOq = parcelRequire("5uXOq");

var $f76Li = parcelRequire("f76Li");

var $lrseF = parcelRequire("lrseF");

var $2OMIu = parcelRequire("2OMIu");
function $a33d3a1e9d33e815$var$isValidNumber(_) {
    return _ != null && typeof _ === 'number' && !Number.isNaN(_) && Number.isFinite(_);
}
function $a33d3a1e9d33e815$export$2e2bcd8739ae039(_ref) {
    let { hideTooltipDebounceMs: hideTooltipDebounceMs = 200, children: children } = _ref;
    const { tooltipOpen: tooltipOpen, tooltipLeft: tooltipLeft, tooltipTop: tooltipTop, tooltipData: tooltipData, updateTooltip: updateTooltip, hideTooltip: privateHideTooltip } = (0, $f76Li.default)(undefined);
    const debouncedHideTooltip = (0, $5uXOq.useRef)(null);
    function cancelDeboundedHideTooltip() {
        if (debouncedHideTooltip.current) {
            debouncedHideTooltip.current.cancel();
            debouncedHideTooltip.current = null;
        }
    }
    (0, $5uXOq.useEffect)(()=>cancelDeboundedHideTooltip, []);
    const showTooltip = (0, $5uXOq.useRef)((_ref2)=>{
        let { svgPoint: svgPoint, index: index, datum: datum, distanceX: distanceX, distanceY: distanceY, nearestSeriesData: nearestSeriesData, event: event } = _ref2;
        // cancel any hideTooltip calls so it won't hide after invoking the logic below
        cancelDeboundedHideTooltip();
        const cleanDistanceX = $a33d3a1e9d33e815$var$isValidNumber(distanceX) ? distanceX : Infinity;
        const cleanDistanceY = $a33d3a1e9d33e815$var$isValidNumber(distanceY) ? distanceY : Infinity;
        const distance = Math.sqrt(cleanDistanceX ** 2 + cleanDistanceY ** 2);
        // Event is valid up here. Hasn't been nullified yet.
        // We can call event.persist() but storing in a variable seems more elegant.
        const tooltipLeft = event && 'clientX' in event ? event === null || event === void 0 ? void 0 : event.clientX : svgPoint === null || svgPoint === void 0 ? void 0 : svgPoint.x;
        const tooltipTop = event && 'clientY' in event ? event === null || event === void 0 ? void 0 : event.clientY : svgPoint === null || svgPoint === void 0 ? void 0 : svgPoint.y;
        updateTooltip((_ref3)=>{
            let { tooltipData: tooltipData } = _ref3;
            // const currNearestDatumDistance =
            //     currData?.nearestDatum && isValidNumber(currData.nearestDatum.distance)
            //         ? currData.nearestDatum.distance
            //         : Infinity;
            return {
                tooltipOpen: true,
                tooltipLeft: tooltipLeft,
                tooltipTop: tooltipTop,
                tooltipData: {
                    // nearestDatum:
                    //     (currData?.nearestDatum?.key ?? '') !== key &&
                    //     currNearestDatumDistance < distance
                    //         ? currData?.nearestDatum
                    //         : {key, index, datum, distance},
                    nearestDatum: {
                        index: index,
                        datum: datum,
                        distance: distance
                    },
                    nearestSeriesData: nearestSeriesData
                }
            };
        });
    });
    const hideTooltip = (0, $5uXOq.useCallback)(()=>{
        debouncedHideTooltip.current = (0, (/*@__PURE__*/$parcel$interopDefault($2qM0c)))(privateHideTooltip, hideTooltipDebounceMs);
        debouncedHideTooltip.current();
    }, [
        privateHideTooltip,
        hideTooltipDebounceMs
    ]);
    const value = (0, $5uXOq.useMemo)(()=>({
            tooltipOpen: tooltipOpen,
            tooltipLeft: tooltipLeft,
            tooltipTop: tooltipTop,
            tooltipData: tooltipData,
            updateTooltip: updateTooltip,
            showTooltip: showTooltip.current,
            hideTooltip: hideTooltip
        }), [
        hideTooltip,
        tooltipData,
        tooltipLeft,
        tooltipOpen,
        tooltipTop,
        updateTooltip
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lrseF.default).Provider, {
        value: value,
        children: children
    });
}

});
parcelRegister("f76Li", function(module, exports) {

$parcel$export(module.exports, "default", () => $b00cc13b202009ca$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $b00cc13b202009ca$export$2e2bcd8739ae039(/** Optional initial TooltipState. */ initialTooltipState) {
    const [tooltipState, setTooltipState] = (0, $5uXOq.useState)({
        tooltipOpen: false,
        ...initialTooltipState
    });
    const showTooltip = (0, $5uXOq.useCallback)((showArgs)=>setTooltipState(typeof showArgs === 'function' ? (_ref)=>{
            let { tooltipOpen: tooltipOpen, ...show } = _ref;
            return {
                ...showArgs(show),
                tooltipOpen: true
            };
        } : {
            tooltipOpen: true,
            tooltipLeft: showArgs.tooltipLeft,
            tooltipTop: showArgs.tooltipTop,
            tooltipData: showArgs.tooltipData
        }), [
        setTooltipState
    ]);
    const hideTooltip = (0, $5uXOq.useCallback)(()=>setTooltipState({
            tooltipOpen: false,
            tooltipLeft: undefined,
            tooltipTop: undefined,
            tooltipData: undefined
        }), [
        setTooltipState
    ]);
    return {
        tooltipOpen: tooltipState.tooltipOpen,
        tooltipLeft: tooltipState.tooltipLeft,
        tooltipTop: tooltipState.tooltipTop,
        tooltipData: tooltipState.tooltipData,
        updateTooltip: setTooltipState,
        showTooltip: showTooltip,
        hideTooltip: hideTooltip
    };
}

});

parcelRegister("lrseF", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9c205926e36fc90$export$2e2bcd8739ae039);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $5uXOq = parcelRequire("5uXOq");
const $f9c205926e36fc90$var$TooltipContext = /*#__PURE__*/ (0, $5uXOq.createContext)({});
var $f9c205926e36fc90$export$2e2bcd8739ae039 = $f9c205926e36fc90$var$TooltipContext;

});


parcelRegister("2pOyr", function(module, exports) {

$parcel$export(module.exports, "MultiSeriesTooltip", () => $1c2521aa24f64dee$export$a2bd9600d7197e69);

var $bT1Sw = parcelRequire("bT1Sw");

var $1Tf3y = parcelRequire("1Tf3y");

var $lA40p = parcelRequire("lA40p");

var $5RaE1 = parcelRequire("5RaE1");

var $ltC0t = parcelRequire("ltC0t");

var $2OMIu = parcelRequire("2OMIu");
function $1c2521aa24f64dee$var$MultiSeriesTooltip(_ref) {
    var _tooltipData$nearestD, _window, _window2, _tooltipData$nearestS;
    let { tooltipData: tooltipData, tooltipLeft: tooltipLeft, tooltipTop: tooltipTop, xAccessor: xAccessor, yAccessor: yAccessor, colorAccessor: colorAccessor, colorScale: colorScale, valueFormatter: valueFormatter = (0, $ltC0t.default).formatNumberAbbreviated } = _ref;
    const datum = tooltipData === null || tooltipData === void 0 ? void 0 : (_tooltipData$nearestD = tooltipData.nearestDatum) === null || _tooltipData$nearestD === void 0 ? void 0 : _tooltipData$nearestD.datum;
    // TODO: SSR check
    const scrollX = ((_window = window) === null || _window === void 0 ? void 0 : _window.scrollX) || 0;
    const scrollY = ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.scrollY) || 0;
    const portalLeft = (tooltipLeft || 0) + scrollX;
    const portalTop = (tooltipTop || 0) + scrollY;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: datum && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5RaE1.default), {
            left: portalLeft,
            top: portalTop,
            tooltipPortalElement: document.body,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Tf3y.TooltipHeader), {
                    datum: datum,
                    children: xAccessor(datum) instanceof Date ? (0, $ltC0t.default).multiTimeFormat(xAccessor(datum)) : String(xAccessor(datum))
                }),
                tooltipData === null || tooltipData === void 0 ? void 0 : (_tooltipData$nearestS = tooltipData.nearestSeriesData) === null || _tooltipData$nearestS === void 0 ? void 0 : _tooltipData$nearestS.map((d, i)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $lA40p.TooltipRow), {
                        datum: d,
                        color: colorScale(colorAccessor(d)),
                        label: colorAccessor(d),
                        value: String(valueFormatter(yAccessor(d)))
                    }, String(xAccessor(d)) + i))
            ]
        })
    });
}
const $1c2521aa24f64dee$export$a2bd9600d7197e69 = (0, $bT1Sw.element)($1c2521aa24f64dee$var$MultiSeriesTooltip);

});
parcelRegister("5RaE1", function(module, exports) {

$parcel$export(module.exports, "default", () => $443a28c41fa47583$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $clgDn = parcelRequire("clgDn");

var $2OMIu = parcelRequire("2OMIu");
const $443a28c41fa47583$var$DEFAULT_TRANSLATE = 'translate(0%, -100%)';
function $443a28c41fa47583$var$TooltipWithBounds(_ref) {
    let { children: children, left: initialLeft = 0, offsetLeft: offsetLeft = 2, offsetTop: offsetTop = -2, style: style = (0, $clgDn.defaultStyles), top: initialTop = 0, unstyled: unstyled = false, ...otherProps } = _ref;
    const elementRef = (0, $5uXOq.useRef)(null);
    const [transformStyle, setTransformStyle] = (0, $5uXOq.useState)($443a28c41fa47583$var$DEFAULT_TRANSLATE);
    (0, $5uXOq.useEffect)(()=>{
        var _elementRef$current;
        const rect = (_elementRef$current = elementRef.current) === null || _elementRef$current === void 0 ? void 0 : _elementRef$current.getBoundingClientRect();
        if (rect) {
            const outOfViewTop = Math.min(0, initialTop - rect.height);
            const outOfViewRight = Math.max(0, initialLeft + rect.width - window.innerWidth);
            const translateX = outOfViewRight > 0 ? -rect.width : 0;
            const translateY = outOfViewTop < 0 ? 0 : -rect.height;
            setTransformStyle(`translate(${translateX}px, ${translateY}px )`);
        }
    }, [
        initialTop,
        initialLeft,
        elementRef
    ]); // Dependency on adjusted state
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $clgDn.default), {
        ref: elementRef,
        style: {
            top: initialTop + offsetTop,
            left: initialLeft + offsetLeft,
            transform: transformStyle,
            transition: 'transform 0.3s',
            ...!unstyled && style
        },
        ...otherProps,
        children: children
    });
}
var $443a28c41fa47583$export$2e2bcd8739ae039 = $443a28c41fa47583$var$TooltipWithBounds;

});
parcelRegister("clgDn", function(module, exports) {

$parcel$export(module.exports, "defaultStyles", () => $8fc459612f6eae76$export$214b055320e0bf32);
$parcel$export(module.exports, "default", () => $8fc459612f6eae76$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $2OMIu = parcelRequire("2OMIu");
const $8fc459612f6eae76$export$214b055320e0bf32 = {
    position: 'absolute',
    backgroundColor: "var(--ds-surface-overlay, white)",
    padding: '.3rem .5rem',
    borderRadius: '3px',
    fontSize: '14px',
    boxShadow: `0px 8px 12px ${"var(--ds-shadow-overflow-perimeter, grey)"}`,
    lineHeight: '1em',
    pointerEvents: 'none',
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 12,
    paddingBottom: 12,
    overflow: 'hidden',
    border: `1px ${"var(--ds-border, grey)"} solid`,
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    gap: 4,
    zIndex: 999,
    display: 'flex'
};
const $8fc459612f6eae76$var$Tooltip = /*#__PURE__*/ (0, $5uXOq.forwardRef)((_ref, ref)=>{
    let { className: className, top: top, left: left, tooltipPortalElement: tooltipPortalElement, offsetLeft: offsetLeft = 0, offsetTop: offsetTop = 0, style: style = $8fc459612f6eae76$export$214b055320e0bf32, children: children, unstyled: unstyled = false, applyPositionStyle: applyPositionStyle = false } = _ref;
    const elem = /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: ref,
        className: className,
        style: {
            top: top == null || offsetTop == null ? top : top + offsetTop,
            left: left == null || offsetLeft == null ? left : left + offsetLeft,
            ...applyPositionStyle && {
                position: 'absolute'
            },
            ...!unstyled && style
        },
        children: children
    });
    // Render via portal
    if (tooltipPortalElement) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: /*#__PURE__*/ (0, $7nsd3.createPortal)(elem, tooltipPortalElement)
    });
    return elem;
});
$8fc459612f6eae76$var$Tooltip.displayName = 'Tooltip';
var $8fc459612f6eae76$export$2e2bcd8739ae039 = $8fc459612f6eae76$var$Tooltip;

});



parcelRegister("arL7j", function(module, exports) {

$parcel$export(module.exports, "BarGroupMarkLabels", () => $79b0f96bd5a8555c$export$d00262aaa41e206c);

var $bT1Sw = parcelRequire("bT1Sw");

var $8WT90 = parcelRequire("8WT90");

var $dnJJh = parcelRequire("dnJJh");

var $2OMIu = parcelRequire("2OMIu");
const $79b0f96bd5a8555c$export$d00262aaa41e206c = (0, $bT1Sw.element)(function BarGroupMarkLabels(_ref) {
    let { barGroups: barGroups, hide: hide } = _ref;
    if (hide) return null;
    return barGroups.map((barGroup)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dnJJh.default), {
            left: barGroup.x0,
            children: barGroup.bars.map((bar)=>{
                if (!bar.width || !bar.height) return null;
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8WT90.ValueLabel), {
                        x: bar.x + bar.width / 2,
                        y: bar.y + bar.height / 2,
                        color: bar.color,
                        children: bar.yValue.toString()
                    }, `bar-stack-label-${barGroup.index}-${bar.index}`)
                });
            })
        }, `bar-group-labels-${barGroup.index}-${barGroup.x0}`));
});

});
parcelRegister("8WT90", function(module, exports) {

$parcel$export(module.exports, "ValueLabel", () => $683e8406f9035644$export$d0e17caf98739ceb);
/* label.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $bwpsq = parcelRequire("bwpsq");

var $bT1Sw = parcelRequire("bT1Sw");

var $cwHYm = parcelRequire("cwHYm");

var $ltC0t = parcelRequire("ltC0t");

var $jQ5Qu = parcelRequire("jQ5Qu");

var $2OMIu = parcelRequire("2OMIu");
const $683e8406f9035644$var$labelTextStyles = null;
function $683e8406f9035644$var$ValueLabel(_ref) {
    let { x: x, y: y, color: color, formatter: formatter = (0, $ltC0t.default).formatNumberAbbreviated, children: children } = _ref;
    if (!children) return null;
    if (typeof children === 'number' || typeof children === 'string') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwHYm.default), {
        x: x,
        y: y,
        style: {
            fill: (0, $jQ5Qu.getMaxContrast)(color)
        },
        verticalAnchor: "middle",
        alignmentBaseline: "central",
        className: (0, $bwpsq.default)([
            "_1fjgnkob _ect41wi2 _1wyb1crf"
        ]),
        children: formatter(children)
    });
    return children;
}
const $683e8406f9035644$export$d0e17caf98739ceb = (0, $bT1Sw.element)($683e8406f9035644$var$ValueLabel);

});
parcelRegister("cwHYm", function(module, exports) {

$parcel$export(module.exports, "default", () => $91ea953eed024a92$export$2e2bcd8739ae039);

var $3bDjY = parcelRequire("3bDjY");

var $ikfTR = parcelRequire("ikfTR");

var $2OMIu = parcelRequire("2OMIu");
const $91ea953eed024a92$var$SVG_STYLE = {
    overflow: 'visible'
};
function $91ea953eed024a92$export$2e2bcd8739ae039(props) {
    const { dx: dx = 0, dy: dy = 0, textAnchor: textAnchor = 'start', innerRef: innerRef, innerTextRef: innerTextRef, verticalAnchor: verticalAnchor, alignmentBaseline: alignmentBaseline, angle: angle, lineHeight: lineHeight = '1em', scaleToFit: // eslint-disable-next-line @typescript-eslint/no-unused-vars
    scaleToFit = false, capHeight: capHeight, truncate: truncate, singleline: singleline, children: children, ...textProps } = props;
    const { x: x = 0, fontSize: fontSize } = textProps;
    const { wordsByLines: wordsByLines, startDy: startDy, transform: transform, truncated: truncated } = (0, $ikfTR.default)(props);
    /*
   * NOTE: We may need to change this <g> tag back to a <svg> tag at some point
   *
   * https://github.com/airbnb/visx/issues/971
   *
   * The core developer says the following "This is intentional as it simplifies positioning, rotation, and scaling."
   *
   * We measure the axis labels using the element ref. This works fine in some browsers but firefox
   * adds default sizes to svgs. Whereas chrome will respect empty width/height as null value.
   *
   * We currently don't do very fancy things with this text component so ok to switch to <g> for now.
   *
   * I did have to move the dx/dy translates from x/y attributes to a css transform since they
   * use em to center the text.
   */ const textComponent = /*#__PURE__*/ (0, $2OMIu.jsx)("g", {
        ref: innerRef,
        fontSize: fontSize,
        style: {
            ...$91ea953eed024a92$var$SVG_STYLE,
            transform: `translate(calc(${dx}), calc(${dy}))`
        },
        children: wordsByLines.length > 0 ? /*#__PURE__*/ (0, $2OMIu.jsx)("text", {
            ref: innerTextRef,
            transform: transform,
            ...textProps,
            textAnchor: textAnchor,
            children: wordsByLines.map((line, index)=>/*#__PURE__*/ (0, $2OMIu.jsx)("tspan", {
                    alignmentBaseline: alignmentBaseline,
                    x: x,
                    dy: index === 0 ? startDy : lineHeight,
                    children: line.words.join(' ')
                }, index))
        }) : null
    });
    if (truncated) {
        var _props$children;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
            tag: "g",
            content: (_props$children = props.children) === null || _props$children === void 0 ? void 0 : _props$children.toString(),
            position: "bottom",
            children: textComponent
        });
    }
    return textComponent;
}

});
parcelRegister("ikfTR", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5766daa0bc60be3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6xQMF = parcelRequire("6xQMF");

var $lMXX0 = parcelRequire("lMXX0");
function $d5766daa0bc60be3$var$isNumber(val) {
    return typeof val === 'number';
}
function $d5766daa0bc60be3$var$isXOrYInValid(xOrY) {
    return(// number that is not NaN or Infinity
    typeof xOrY === 'number' && Number.isFinite(xOrY) || // for percentage
    typeof xOrY === 'string');
}
function $d5766daa0bc60be3$export$2e2bcd8739ae039(props) {
    const { verticalAnchor: verticalAnchor = 'start', scaleToFit: scaleToFit = false, angle: angle, width: width, lineHeight: lineHeight = '1em', capHeight: capHeight = '0em', children: // Magic number from d3
    // capHeight = '0.71em',
    children, truncate: truncate, style: style, singleline: singleline, ...textProps } = props;
    const { x: x = 0, y: y = 0 } = textProps;
    const isXOrYNotValid = !$d5766daa0bc60be3$var$isXOrYInValid(x) || !$d5766daa0bc60be3$var$isXOrYInValid(y);
    const { wordsWithWidth: wordsWithWidth, spaceWidth: spaceWidth } = (0, $5uXOq.useMemo)(()=>{
        const words = children == null ? [] : children.toString().split(/(?:(?!\u00A0+)\s+)/);
        return {
            wordsWithWidth: words.map((word)=>({
                    word: word,
                    wordWidth: (0, $lMXX0.default)(word, style) || 0
                })),
            spaceWidth: (0, $lMXX0.default)('\u00A0', style) || 0
        };
    }, [
        children,
        style
    ]);
    const { wordsByLines: wordsByLines, truncated: truncated } = (0, $5uXOq.useMemo)(()=>{
        let isTruncated = false;
        if (isXOrYNotValid) return {
            wordsByLines: [],
            truncated: isTruncated
        };
        // Only perform calculations if using features that require them (multiline, scaleToFit)
        if (width || scaleToFit) {
            const words = wordsWithWidth.reduce((result, _ref)=>{
                let { word: word, wordWidth: wordWidth } = _ref;
                const currentLine = result[result.length - 1];
                if (currentLine && (width == null || scaleToFit || truncate || singleline || (currentLine.width || 0) + wordWidth + spaceWidth < width)) {
                    currentLine.words.push(word);
                    currentLine.width = currentLine.width || 0;
                    currentLine.width += wordWidth + spaceWidth;
                } else {
                    // Add first word to line or word is too long to scaleToFit on existing line
                    const newLine = {
                        words: [
                            word
                        ],
                        width: wordWidth
                    };
                    result.push(newLine);
                }
                return result;
            }, []);
            // Word can be added to an existing line
            if (truncate && width) {
                const ellipsesWidth = (0, $lMXX0.default)('...', style) || 0;
                const joinedWords = words[0].words.join('\u00A0');
                const joinedSubstring = joinedWords.substring(0, (width - ellipsesWidth) / (words[0].width || 0) * joinedWords.length);
                if (joinedSubstring !== joinedWords) {
                    isTruncated = true;
                    words[0].words = [
                        joinedSubstring + '...'
                    ];
                }
            }
            return {
                wordsByLines: words,
                truncated: isTruncated
            };
        }
        return {
            wordsByLines: [
                {
                    words: children == null ? [] : children.toString().split(/(?:(?!\u00A0+)\s+)/)
                }
            ],
            truncated: isTruncated
        };
    }, [
        isXOrYNotValid,
        width,
        scaleToFit,
        children,
        wordsWithWidth,
        spaceWidth
    ]);
    const startDy = (0, $5uXOq.useMemo)(()=>{
        const startDyStr = isXOrYNotValid ? '' : verticalAnchor === 'start' ? (0, (/*@__PURE__*/$parcel$interopDefault($6xQMF)))(`calc(${capHeight})`) : verticalAnchor === 'middle' ? (0, (/*@__PURE__*/$parcel$interopDefault($6xQMF)))(`calc(${(wordsByLines.length - 1) / 2} * -${lineHeight} + (${capHeight} / 2))`) : (0, (/*@__PURE__*/$parcel$interopDefault($6xQMF)))(`calc(${wordsByLines.length - 1} * -${lineHeight})`);
        return startDyStr;
    }, [
        isXOrYNotValid,
        verticalAnchor,
        capHeight,
        wordsByLines.length,
        lineHeight
    ]);
    const transform = (0, $5uXOq.useMemo)(()=>{
        const transforms = [];
        if (isXOrYNotValid) return '';
        if ($d5766daa0bc60be3$var$isNumber(x) && $d5766daa0bc60be3$var$isNumber(y) && $d5766daa0bc60be3$var$isNumber(width) && scaleToFit && wordsByLines.length > 0) {
            const lineWidth = wordsByLines[0].width || 1;
            const sx = scaleToFit === 'shrink-only' ? Math.min(width / lineWidth, 1) : width / lineWidth;
            const sy = sx;
            const originX = x - sx * x;
            const originY = y - sy * y;
            transforms.push(`matrix(${sx}, 0, 0, ${sy}, ${originX}, ${originY})`);
        }
        if (angle) transforms.push(`rotate(${angle}, ${x}, ${y})`);
        return transforms.length > 0 ? transforms.join(' ') : '';
    }, [
        isXOrYNotValid,
        x,
        y,
        width,
        scaleToFit,
        wordsByLines,
        angle
    ]);
    return {
        wordsByLines: wordsByLines,
        startDy: startDy,
        transform: transform,
        truncated: truncated
    };
}

});
parcelRegister("lMXX0", function(module, exports) {

$parcel$export(module.exports, "default", () => $fdcc959e1e17280b$export$2e2bcd8739ae039);
// import memoize from 'lodash/memoize';
const $fdcc959e1e17280b$var$MEASUREMENT_ELEMENT_ID = '__react_svg_text_measurement_id';
function $fdcc959e1e17280b$export$2e2bcd8739ae039(str, style) {
    try {
        // Calculate length of each word to be used to determine number of words per line
        let textEl = document.getElementById($fdcc959e1e17280b$var$MEASUREMENT_ELEMENT_ID);
        if (!textEl) {
            const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            svg.setAttribute('aria-hidden', 'true');
            svg.style.width = '0';
            svg.style.height = '0';
            svg.style.position = 'absolute';
            svg.style.top = '-100%';
            svg.style.left = '-100%';
            textEl = document.createElementNS('http://www.w3.org/2000/svg', 'text');
            textEl.setAttribute('id', $fdcc959e1e17280b$var$MEASUREMENT_ELEMENT_ID);
            svg.appendChild(textEl);
            document.body.appendChild(svg);
        }
        Object.assign(textEl.style, style);
        textEl.textContent = str;
        return textEl.getComputedTextLength();
    } catch (e) {
        return null;
    }
} // TODO: Implement without lodash
 // export default memoize(getStringWidth, (str, style) => `${str}_${JSON.stringify(style)}`);

});



parcelRegister("jQ5Qu", function(module, exports) {

$parcel$export(module.exports, "getMaxContrast", () => $e7176877f098873f$export$499db937e3cd4eb2);

var $kTHGn = parcelRequire("kTHGn");

var $7UL8A = parcelRequire("7UL8A");
function $e7176877f098873f$var$getLuminance(_ref) {
    let { r: r, g: g, b: b } = _ref;
    const a = [
        r,
        g,
        b
    ].map((v)=>{
        v /= 255;
        return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
}
function $e7176877f098873f$var$getContrast(color1, color2) {
    const lum1 = $e7176877f098873f$var$getLuminance(color1) + 0.05;
    const lum2 = $e7176877f098873f$var$getLuminance(color2) + 0.05;
    return Math.max(lum1, lum2) / Math.min(lum1, lum2);
}
function $e7176877f098873f$var$getTokenAndFallback(cssVar) {
    // Extract the number from the CSS variable name
    const numberMatch = cssVar.match(/\d+/);
    const number = numberMatch ? numberMatch[0] : '';
    // Extract all terms following '--ds-' and before the number
    const termsMatch = cssVar.match(/--ds-(.+)-\d+/);
    const terms = termsMatch ? termsMatch[1].split('-') : [];
    // Extract the hexadecimal color from the CSS variable
    const hexColorMatch = cssVar.match(/#[0-9a-fA-F]{6}/);
    const hexColor = hexColorMatch ? hexColorMatch[0] : '';
    // Create the desired format by joining all extracted terms
    const token = `color.${terms.join('.') + '.' + number}`;
    return {
        token: token,
        fallback: hexColor
    };
}
function $e7176877f098873f$export$499db937e3cd4eb2(arcColor) {
    const isPattern = arcColor.includes('url');
    const { token: token, fallback: fallback } = $e7176877f098873f$var$getTokenAndFallback(arcColor);
    const colorHex = (0, $kTHGn.default)(token, fallback);
    const color = (0, $7UL8A.rgb)(arcColor.startsWith('var(') ? colorHex : arcColor);
    if (isPattern) return 'black';
    if (!color) return '';
    const blackContrast = $e7176877f098873f$var$getContrast(color, (0, $7UL8A.rgb)('black'));
    const whiteContrast = $e7176877f098873f$var$getContrast(color, (0, $7UL8A.rgb)('white'));
    if (whiteContrast >= 4.5) return 'white';
    if (blackContrast >= 4.5) return 'black';
    return 'white';
}

});


parcelRegister("dnJJh", function(module, exports) {

$parcel$export(module.exports, "default", () => $9be0e5401983ef4c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
function $9be0e5401983ef4c$export$2e2bcd8739ae039(_ref) {
    let { top: top = 0, left: left = 0, transform: transform, children: children, innerRef: innerRef, ...restProps } = _ref;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("g", {
        ref: innerRef,
        transform: transform || `translate(${left}, ${top})`,
        ...restProps,
        children: children
    });
}

});


parcelRegister("dwg9t", function(module, exports) {

$parcel$export(module.exports, "BarGroupMarks", () => $9d7acaf02478f739$export$fe396ea701d4567e);

var $bT1Sw = parcelRequire("bT1Sw");

var $iTGbP = parcelRequire("iTGbP");

var $dnJJh = parcelRequire("dnJJh");

var $dluWU = parcelRequire("dluWU");

var $2OMIu = parcelRequire("2OMIu");
const $9d7acaf02478f739$export$fe396ea701d4567e = (0, $bT1Sw.element)(function BarGroupMarks(_ref) {
    let { barGroups: barGroups, roundedCorners: roundedCorners = false } = _ref;
    return barGroups.map((barGroup)=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dnJJh.default), {
            left: barGroup.x0,
            children: barGroup.bars.map((bar)=>{
                const cornerRadius = roundedCorners && bar.height > 2 * (0, $dluWU.CORNER_RADIUS_VALUE).SMALL && bar.width > 2 * (0, $dluWU.CORNER_RADIUS_VALUE).SMALL ? (0, $dluWU.CORNER_RADIUS_VALUE).SMALL : (0, $dluWU.CORNER_RADIUS_VALUE).NONE;
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iTGbP.Bar), {
                    ariaLabel: `${bar.label}, x: ${bar.xValue}, y: ${bar.yValue}`,
                    x: bar.x,
                    y: bar.y,
                    datum: bar.datum,
                    width: bar.width,
                    height: bar.height,
                    fill: bar.color,
                    cornerRadius: {
                        topLeft: cornerRadius,
                        topRight: cornerRadius
                    }
                }, `bar-group-bar-${barGroup.index}-${bar.index}-${bar.xValue}-${bar.key}`);
            })
        }, `bar-group-marks-${barGroup.index}-${barGroup.x0}`);
    });
});

});
parcelRegister("dluWU", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_MARGIN", () => $9b753e5f48cfde8e$export$6475e56bfff61883);
$parcel$export(module.exports, "STACK_GAP", () => $9b753e5f48cfde8e$export$56b61e27223adae9);
$parcel$export(module.exports, "CORNER_RADIUS_VALUE", () => $9b753e5f48cfde8e$export$a15d94c34ecbca08);
const $9b753e5f48cfde8e$export$6475e56bfff61883 = {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
};
const $9b753e5f48cfde8e$export$601d4a48e295711b = 150;
const $9b753e5f48cfde8e$export$56b61e27223adae9 = 1;
const $9b753e5f48cfde8e$export$4d00931646175b35 = 2;
const $9b753e5f48cfde8e$export$a15d94c34ecbca08 = {
    SMALL: 2,
    MEDIUM: 4,
    LARGE: 8,
    NONE: 0
};

});


parcelRegister("ggVTz", function(module, exports) {

$parcel$export(module.exports, "useMaximumYValue", () => $bd8b0cc46655e91a$export$b6f0cda1573da4a7);
$parcel$export(module.exports, "calculateXScaleDomain", () => $bd8b0cc46655e91a$export$25d8e7ab8cac3e31);
$parcel$export(module.exports, "calculateYDomain", () => $bd8b0cc46655e91a$export$d2ffead7cf0bfe5c);
$parcel$export(module.exports, "BarScalesElement", () => $bd8b0cc46655e91a$export$399ec5971eff5385);

var $hjll3 = parcelRequire("hjll3");

var $5uXOq = parcelRequire("5uXOq");

var $bT1Sw = parcelRequire("bT1Sw");
var $17PP9 = parcelRequire("17PP9");
parcelRequire("8WCE9");
var $i3RkB = parcelRequire("i3RkB");
var $8WCE9 = parcelRequire("8WCE9");
var $5pfgu = parcelRequire("5pfgu");
var $juXo4 = parcelRequire("juXo4");

var $6jSGb = parcelRequire("6jSGb");

var $cgmj2 = parcelRequire("cgmj2");
function $bd8b0cc46655e91a$export$b6f0cda1573da4a7(data, x, y, stacked) {
    const total = (0, $5uXOq.useMemo)(()=>{
        if (!stacked) return (0, $hjll3.max)(data, y) || 1;
        const grouped = (0, $hjll3.group)(data, x);
        const totals = [];
        grouped.forEach((colorGroup)=>{
            totals.push((0, $hjll3.sum)(colorGroup.map(y)));
        });
        return (0, $hjll3.max)(totals) || 1;
    }, [
        data,
        x,
        y,
        stacked
    ]);
    return total;
}
function $bd8b0cc46655e91a$export$25d8e7ab8cac3e31(_ref) {
    let { xData: xData, timeUnit: timeUnit, range: range, padding: padding } = _ref;
    if (timeUnit) {
        // @ts-expect-error unknown error expected
        const timeExtent = (0, $hjll3.extent)(xData);
        let timeInterval = (0, $hjll3.timeYear);
        switch(timeUnit){
            case 'days':
                timeInterval = (0, $hjll3.timeDay);
                break;
            case 'months':
                timeInterval = (0, $hjll3.timeMonth);
                break;
            case 'weeks':
                timeInterval = (0, $hjll3.timeWeek);
                break;
            default:
                break;
        }
        const timeDomain = timeInterval.range(timeExtent[0], timeInterval.offset(timeExtent[1], 1), 1);
        return (0, $8WCE9.scaleBandTime)({
            range: range,
            padding: padding,
            domain: timeDomain
        });
    } else // @ts-expect-error unknown error expected
    return (0, $i3RkB.default)({
        domain: [
            ...new Set(xData)
        ],
        range: range,
        padding: padding
    });
}
function $bd8b0cc46655e91a$export$d2ffead7cf0bfe5c(_ref2) {
    let { totalYValue: totalYValue, yDomain: yDomain, normalize: normalize } = _ref2;
    const domainOutput = normalize ? [
        0,
        1
    ] : [
        0,
        totalYValue
    ];
    if (yDomain && yDomain[0] != null) domainOutput[0] = yDomain[0];
    if (yDomain && yDomain[1] != null) domainOutput[1] = yDomain[1];
    return domainOutput;
}
const $bd8b0cc46655e91a$export$399ec5971eff5385 = (0, $bT1Sw.element)((props)=>{
    const { data: data, x: x, y: y, color: color, width: width, height: height, yDomain: yDomain, timeUnit: timeUnit } = props;
    const { fillStyles: fillStyles, enableDefaultPatterns: enableDefaultPatterns, useThemeFillStyles: useThemeFillStyles } = (0, $17PP9.useElementProps)((0, $cgmj2.Theme));
    const totalYValue = $bd8b0cc46655e91a$export$b6f0cda1573da4a7(data || [], x, y, false);
    const value = (0, $5uXOq.useMemo)(()=>{
        const xScaleRange = [
            0,
            width
        ];
        const xScalePadding = 0.25;
        const xScale = $bd8b0cc46655e91a$export$25d8e7ab8cac3e31({
            xData: data.map(x),
            timeUnit: timeUnit,
            range: xScaleRange,
            padding: xScalePadding
        });
        const groupScale = (0, $i3RkB.default)({
            domain: [
                ...new Set(data.map(color))
            ],
            range: [
                0,
                (0, $6jSGb.default)(xScale)
            ],
            padding: 0.1
        });
        const yScale = (0, $5pfgu.default)({
            domain: $bd8b0cc46655e91a$export$d2ffead7cf0bfe5c({
                totalYValue: totalYValue,
                yDomain: yDomain
            }),
            range: [
                height,
                0
            ]
        });
        const { domain: domain, range: range } = useThemeFillStyles({
            fillStyles: fillStyles,
            enableDefaultPatterns: enableDefaultPatterns
        });
        const colorScale = (0, $juXo4.default)({
            domain: domain ? domain : data.map(color),
            range: range
        });
        // This needs to go somewhere else. And should probably use the x data.
        const seriesData = (0, $hjll3.group)(data, x);
        return {
            xScale: xScale,
            yScale: yScale,
            colorScale: colorScale,
            groupScale: groupScale,
            seriesData: seriesData
        };
    }, [
        data,
        width,
        height,
        totalYValue,
        x,
        yDomain,
        timeUnit,
        fillStyles,
        enableDefaultPatterns
    ]);
    return props.children(value);
});

});
parcelRegister("8WCE9", function(module, exports) {

$parcel$export(module.exports, "scaleBandTime", () => $6831b7e75dd8af74$export$3664991d076c12bd);
$parcel$export(module.exports, "scaleBand", () => (parcelRequire("i3RkB")).default);
// only export what we use
// eslint-disable-next-line no-restricted-syntax

var $cMo1a = parcelRequire("cMo1a");
var $eOdM1 = parcelRequire("eOdM1");
var $elPt5 = parcelRequire("elPt5");
var $i3RkB = parcelRequire("i3RkB");
var $5pfgu = parcelRequire("5pfgu");
var $38Bo0 = parcelRequire("38Bo0");
var $juXo4 = parcelRequire("juXo4");
var $lLx1Y = parcelRequire("lLx1Y");
var $2YVVm = parcelRequire("2YVVm");
// Creating a combination scale that adds a timeUnit function
// I may want to adjust how we are doing this.
function $6831b7e75dd8af74$export$3664991d076c12bd(config) {
    const scale = (0, $i3RkB.default)(config);
    scale.timeUnit = function() {
        return config === null || config === void 0 ? void 0 : config.timeUnit;
    };
    return scale;
}

});
parcelRegister("i3RkB", function(module, exports) {

$parcel$export(module.exports, "default", () => $d261e04fb6b55f5b$export$2e2bcd8739ae039);

var $gMRSL = parcelRequire("gMRSL");

var $caWsP = parcelRequire("caWsP");
var $d261e04fb6b55f5b$export$933021962cd38dc1 = (0, $caWsP.default)('domain', 'range', 'reverse', 'align', 'padding', 'round');
function $d261e04fb6b55f5b$export$2e2bcd8739ae039(config) {
    return $d261e04fb6b55f5b$export$933021962cd38dc1((0, $gMRSL.default)(), config);
}

});
parcelRegister("gMRSL", function(module, exports) {

$parcel$export(module.exports, "default", () => $c38aecf3af0f59a7$export$2e2bcd8739ae039);
$parcel$export(module.exports, "point", () => $c38aecf3af0f59a7$export$105684a3041cb6f3);

var $7urYO = parcelRequire("7urYO");

var $l4Hc4 = parcelRequire("l4Hc4");

var $8idDz = parcelRequire("8idDz");
function $c38aecf3af0f59a7$export$2e2bcd8739ae039() {
    var scale = (0, $8idDz.default)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, $7urYO.default)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return $c38aecf3af0f59a7$export$2e2bcd8739ae039(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return (0, $l4Hc4.initRange).apply(rescale(), arguments);
}
function $c38aecf3af0f59a7$var$pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return $c38aecf3af0f59a7$var$pointish(copy());
    };
    return scale;
}
function $c38aecf3af0f59a7$export$105684a3041cb6f3() {
    return $c38aecf3af0f59a7$var$pointish($c38aecf3af0f59a7$export$2e2bcd8739ae039.apply(null, arguments).paddingInner(1));
}

});
parcelRegister("7urYO", function(module, exports) {

$parcel$export(module.exports, "default", () => $574109f1d23a3200$export$2e2bcd8739ae039);
function $574109f1d23a3200$export$2e2bcd8739ae039(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

});



parcelRegister("5pfgu", function(module, exports) {

$parcel$export(module.exports, "default", () => $3efb20df079e2ed4$export$2e2bcd8739ae039);

var $gcmOU = parcelRequire("gcmOU");

var $caWsP = parcelRequire("caWsP");
var $3efb20df079e2ed4$export$7ce4d19a8c2ea22f = (0, $caWsP.default)('domain', 'range', 'reverse', 'clamp', 'interpolate', 'nice', 'round', 'zero');
function $3efb20df079e2ed4$export$2e2bcd8739ae039(config) {
    return $3efb20df079e2ed4$export$7ce4d19a8c2ea22f((0, $gcmOU.default)(), config);
}

});
parcelRegister("gcmOU", function(module, exports) {

$parcel$export(module.exports, "linearish", () => $bcaf77e9c6cf2e73$export$16a5d4b4a61a274d);
$parcel$export(module.exports, "default", () => $bcaf77e9c6cf2e73$export$2e2bcd8739ae039);

var $80JJl = parcelRequire("80JJl");

var $jhkFB = parcelRequire("jhkFB");

var $l4Hc4 = parcelRequire("l4Hc4");

var $e86SE = parcelRequire("e86SE");
function $bcaf77e9c6cf2e73$export$16a5d4b4a61a274d(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $80JJl.default)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $e86SE.default)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, $80JJl.tickIncrement)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function $bcaf77e9c6cf2e73$export$2e2bcd8739ae039() {
    var scale = (0, $jhkFB.default)();
    scale.copy = function() {
        return (0, $jhkFB.copy)(scale, $bcaf77e9c6cf2e73$export$2e2bcd8739ae039());
    };
    (0, $l4Hc4.initRange).apply(scale, arguments);
    return $bcaf77e9c6cf2e73$export$16a5d4b4a61a274d(scale);
}

});
parcelRegister("e86SE", function(module, exports) {

$parcel$export(module.exports, "default", () => $a497265f873a5cba$export$2e2bcd8739ae039);

var $80JJl = parcelRequire("80JJl");

var $lIJDz = parcelRequire("lIJDz");
var $d52Pl = parcelRequire("d52Pl");
var $jGaQB = parcelRequire("jGaQB");
var $eP35l = parcelRequire("eP35l");
var $3n7r8 = parcelRequire("3n7r8");
function $a497265f873a5cba$export$2e2bcd8739ae039(start, stop, count, specifier) {
    var step = (0, $80JJl.tickStep)(start, stop, count), precision;
    specifier = (0, $d52Pl.default)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $eP35l.default)(step, value))) specifier.precision = precision;
            return (0, $lIJDz.formatPrefix)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $3n7r8.default)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $jGaQB.default)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $lIJDz.format)(specifier);
}

});
parcelRegister("lIJDz", function(module, exports) {

$parcel$export(module.exports, "format", () => $fd011b9e7fff9861$export$d9468344d3651243);
$parcel$export(module.exports, "formatPrefix", () => $fd011b9e7fff9861$export$8d85692a469dde6f);

var $9lU0X = parcelRequire("9lU0X");
var $fd011b9e7fff9861$var$locale;
var $fd011b9e7fff9861$export$d9468344d3651243;
var $fd011b9e7fff9861$export$8d85692a469dde6f;
$fd011b9e7fff9861$export$2e2bcd8739ae039({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function $fd011b9e7fff9861$export$2e2bcd8739ae039(definition) {
    $fd011b9e7fff9861$var$locale = (0, $9lU0X.default)(definition);
    $fd011b9e7fff9861$export$d9468344d3651243 = $fd011b9e7fff9861$var$locale.format;
    $fd011b9e7fff9861$export$8d85692a469dde6f = $fd011b9e7fff9861$var$locale.formatPrefix;
    return $fd011b9e7fff9861$var$locale;
}

});
parcelRegister("9lU0X", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cf18683e7066ef8$export$2e2bcd8739ae039);

var $4PYTL = parcelRequire("4PYTL");

var $lumKq = parcelRequire("lumKq");

var $69LQu = parcelRequire("69LQu");

var $d52Pl = parcelRequire("d52Pl");

var $hFRdc = parcelRequire("hFRdc");

var $61KNZ = parcelRequire("61KNZ");

var $6be9G = parcelRequire("6be9G");

var $koqnZ = parcelRequire("koqnZ");
var $6cf18683e7066ef8$var$map = Array.prototype.map, $6cf18683e7066ef8$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $6cf18683e7066ef8$export$2e2bcd8739ae039(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? (0, $koqnZ.default) : (0, $lumKq.default)($6cf18683e7066ef8$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? (0, $koqnZ.default) : (0, $69LQu.default)($6cf18683e7066ef8$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $d52Pl.default)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
        // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g";
        else if (!(0, $61KNZ.default)[type]) precision === undefined && (precision = 12), trim = true, type = "g";
        // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
        // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
        // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = (0, $61KNZ.default)[type], maybeSuffix = /[defgprs%]/.test(type);
        // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value;
                // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0;
                // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                // Trim insignificant zeros.
                if (trim) value = (0, $hFRdc.default)(value);
                // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $6cf18683e7066ef8$var$prefixes[8 + (0, $6be9G.prefixExponent) / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            }
            // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity);
            // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
            // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
            // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $d52Pl.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $4PYTL.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $6cf18683e7066ef8$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}

});
parcelRegister("4PYTL", function(module, exports) {

$parcel$export(module.exports, "default", () => $385b29fac2777bcf$export$2e2bcd8739ae039);

var $dTsA8 = parcelRequire("dTsA8");
function $385b29fac2777bcf$export$2e2bcd8739ae039(x) {
    return x = (0, $dTsA8.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
}

});
parcelRegister("dTsA8", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1d6952536ec19e2$export$2e2bcd8739ae039);
$parcel$export(module.exports, "formatDecimalParts", () => $a1d6952536ec19e2$export$8f8e23dd27dc19f5);
function $a1d6952536ec19e2$export$2e2bcd8739ae039(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
}
function $a1d6952536ec19e2$export$8f8e23dd27dc19f5(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

});


parcelRegister("lumKq", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa4e0b8ad8ee75a1$export$2e2bcd8739ae039);
function $fa4e0b8ad8ee75a1$export$2e2bcd8739ae039(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}

});

parcelRegister("69LQu", function(module, exports) {

$parcel$export(module.exports, "default", () => $47b8b274d7519d09$export$2e2bcd8739ae039);
function $47b8b274d7519d09$export$2e2bcd8739ae039(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}

});

parcelRegister("d52Pl", function(module, exports) {

$parcel$export(module.exports, "default", () => $985def61c5e3febe$export$2e2bcd8739ae039);
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $985def61c5e3febe$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $985def61c5e3febe$export$2e2bcd8739ae039(specifier) {
    if (!(match = $985def61c5e3febe$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $985def61c5e3febe$export$963aac351db36ed4({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$985def61c5e3febe$export$2e2bcd8739ae039.prototype = $985def61c5e3febe$export$963aac351db36ed4.prototype; // instanceof
function $985def61c5e3febe$export$963aac351db36ed4(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$985def61c5e3febe$export$963aac351db36ed4.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

});

parcelRegister("hFRdc", function(module, exports) {

$parcel$export(module.exports, "default", () => $cddf8aca24d838af$export$2e2bcd8739ae039);
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $cddf8aca24d838af$export$2e2bcd8739ae039(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

});

parcelRegister("61KNZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $463724a038112234$export$2e2bcd8739ae039);

var $dTsA8 = parcelRequire("dTsA8");

var $6be9G = parcelRequire("6be9G");

var $91t1p = parcelRequire("91t1p");
var $463724a038112234$export$2e2bcd8739ae039 = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": (0, $dTsA8.default),
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, $91t1p.default)(x * 100, p),
    "r": (0, $91t1p.default),
    "s": (0, $6be9G.default),
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};

});
parcelRegister("6be9G", function(module, exports) {

$parcel$export(module.exports, "prefixExponent", () => $47fec017c029c8e0$export$6863724d9a42263);
$parcel$export(module.exports, "default", () => $47fec017c029c8e0$export$2e2bcd8739ae039);

var $dTsA8 = parcelRequire("dTsA8");
var $47fec017c029c8e0$export$6863724d9a42263;
function $47fec017c029c8e0$export$2e2bcd8739ae039(x, p) {
    var d = (0, $dTsA8.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - ($47fec017c029c8e0$export$6863724d9a42263 = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $dTsA8.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

});

parcelRegister("91t1p", function(module, exports) {

$parcel$export(module.exports, "default", () => $691ab825243f2afd$export$2e2bcd8739ae039);

var $dTsA8 = parcelRequire("dTsA8");
function $691ab825243f2afd$export$2e2bcd8739ae039(x, p) {
    var d = (0, $dTsA8.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

});


parcelRegister("koqnZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed8a843c78cf60aa$export$2e2bcd8739ae039);
function $ed8a843c78cf60aa$export$2e2bcd8739ae039(x) {
    return x;
}

});



parcelRegister("jGaQB", function(module, exports) {

$parcel$export(module.exports, "default", () => $e53a5aa57132374c$export$2e2bcd8739ae039);

var $4PYTL = parcelRequire("4PYTL");
function $e53a5aa57132374c$export$2e2bcd8739ae039(step) {
    return Math.max(0, -(0, $4PYTL.default)(Math.abs(step)));
}

});

parcelRegister("eP35l", function(module, exports) {

$parcel$export(module.exports, "default", () => $aca838c0481a7c13$export$2e2bcd8739ae039);

var $4PYTL = parcelRequire("4PYTL");
function $aca838c0481a7c13$export$2e2bcd8739ae039(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $4PYTL.default)(value) / 3))) * 3 - (0, $4PYTL.default)(Math.abs(step)));
}

});

parcelRegister("3n7r8", function(module, exports) {

$parcel$export(module.exports, "default", () => $274949d87d20acb5$export$2e2bcd8739ae039);

var $4PYTL = parcelRequire("4PYTL");
function $274949d87d20acb5$export$2e2bcd8739ae039(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $4PYTL.default)(max) - (0, $4PYTL.default)(step)) + 1;
}

});




parcelRegister("38Bo0", function(module, exports) {

$parcel$export(module.exports, "default", () => $248f1e8d28412739$export$2e2bcd8739ae039);

var $iB1I6 = parcelRequire("iB1I6");

var $caWsP = parcelRequire("caWsP");
var $248f1e8d28412739$export$8cc7d5fc9fe1e0a3 = (0, $caWsP.default)('domain', 'range', 'reverse', 'base', 'clamp', 'interpolate', 'nice', 'round');
function $248f1e8d28412739$export$2e2bcd8739ae039(config) {
    return $248f1e8d28412739$export$8cc7d5fc9fe1e0a3((0, $iB1I6.default)(), config);
}

});
parcelRegister("iB1I6", function(module, exports) {

$parcel$export(module.exports, "loggish", () => $d89d02543259a0b5$export$860836db074028f0);
$parcel$export(module.exports, "default", () => $d89d02543259a0b5$export$2e2bcd8739ae039);

var $80JJl = parcelRequire("80JJl");

var $lIJDz = parcelRequire("lIJDz");
var $d52Pl = parcelRequire("d52Pl");

var $8h2kZ = parcelRequire("8h2kZ");

var $jhkFB = parcelRequire("jhkFB");

var $l4Hc4 = parcelRequire("l4Hc4");
function $d89d02543259a0b5$var$transformLog(x) {
    return Math.log(x);
}
function $d89d02543259a0b5$var$transformExp(x) {
    return Math.exp(x);
}
function $d89d02543259a0b5$var$transformLogn(x) {
    return -Math.log(-x);
}
function $d89d02543259a0b5$var$transformExpn(x) {
    return -Math.exp(-x);
}
function $d89d02543259a0b5$var$pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function $d89d02543259a0b5$var$powp(base) {
    return base === 10 ? $d89d02543259a0b5$var$pow10 : base === Math.E ? Math.exp : (x)=>Math.pow(base, x);
}
function $d89d02543259a0b5$var$logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x)=>Math.log(x) / base);
}
function $d89d02543259a0b5$var$reflect(f) {
    return (x, k)=>-f(-x, k);
}
function $d89d02543259a0b5$export$860836db074028f0(transform) {
    const scale = transform($d89d02543259a0b5$var$transformLog, $d89d02543259a0b5$var$transformExp);
    const domain = scale.domain;
    let base = 10;
    let logs;
    let pows;
    function rescale() {
        logs = $d89d02543259a0b5$var$logp(base), pows = $d89d02543259a0b5$var$powp(base);
        if (domain()[0] < 0) {
            logs = $d89d02543259a0b5$var$reflect(logs), pows = $d89d02543259a0b5$var$reflect(pows);
            transform($d89d02543259a0b5$var$transformLogn, $d89d02543259a0b5$var$transformExpn);
        } else transform($d89d02543259a0b5$var$transformLog, $d89d02543259a0b5$var$transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = (count)=>{
        const d = domain();
        let u = d[0];
        let v = d[d.length - 1];
        const r = v < u;
        if (r) [u, v] = [
            v,
            u
        ];
        let i = logs(u);
        let j = logs(v);
        let k;
        let t;
        const n = count == null ? 10 : +count;
        let z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1; k < base; ++k){
                t = i < 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1; k >= 1; --k){
                t = i > 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, $80JJl.default)(u, v, n);
        } else z = (0, $80JJl.default)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = (count, specifier)=>{
        if (count == null) count = 10;
        if (specifier == null) specifier = base === 10 ? "s" : ",";
        if (typeof specifier !== "function") {
            if (!(base % 1) && (specifier = (0, $d52Pl.default)(specifier)).precision == null) specifier.trim = true;
            specifier = (0, $lIJDz.format)(specifier);
        }
        if (count === Infinity) return specifier;
        const k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return (d)=>{
            let i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = ()=>{
        return domain((0, $8h2kZ.default)(domain(), {
            floor: (x)=>pows(Math.floor(logs(x))),
            ceil: (x)=>pows(Math.ceil(logs(x)))
        }));
    };
    return scale;
}
function $d89d02543259a0b5$export$2e2bcd8739ae039() {
    const scale = $d89d02543259a0b5$export$860836db074028f0((0, $jhkFB.transformer)()).domain([
        1,
        10
    ]);
    scale.copy = ()=>(0, $jhkFB.copy)(scale, $d89d02543259a0b5$export$2e2bcd8739ae039()).base(scale.base());
    (0, $l4Hc4.initRange).apply(scale, arguments);
    return scale;
}

});


parcelRegister("juXo4", function(module, exports) {

$parcel$export(module.exports, "default", () => $e31ee2bae0007f48$export$2e2bcd8739ae039);

var $8idDz = parcelRequire("8idDz");

var $caWsP = parcelRequire("caWsP");
var $e31ee2bae0007f48$export$6c7fd0f60d1828d8 = (0, $caWsP.default)('domain', 'range', 'reverse', 'unknown');
function $e31ee2bae0007f48$export$2e2bcd8739ae039(config) {
    return $e31ee2bae0007f48$export$6c7fd0f60d1828d8((0, $8idDz.default)(), config);
}

});

parcelRegister("lLx1Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd879c046e084e2b$export$2e2bcd8739ae039);

var $gMRSL = parcelRequire("gMRSL");

var $caWsP = parcelRequire("caWsP");
var $fd879c046e084e2b$export$1c86c961a04b7858 = (0, $caWsP.default)('domain', 'range', 'reverse', 'align', 'padding', 'round');
function $fd879c046e084e2b$export$2e2bcd8739ae039(config) {
    return $fd879c046e084e2b$export$1c86c961a04b7858((0, $gMRSL.point)(), config);
}

});


parcelRegister("6jSGb", function(module, exports) {

$parcel$export(module.exports, "default", () => $499eeea25e19f1a9$export$2e2bcd8739ae039);
function $499eeea25e19f1a9$export$2e2bcd8739ae039(scale) {
    if ('bandwidth' in scale) return scale.bandwidth();
    const range = scale.range();
    const domain = scale.domain();
    return Math.abs(range[range.length - 1] - range[0]) / domain.length;
}

});


parcelRegister("cKYPp", function(module, exports) {

$parcel$export(module.exports, "BarTooltipOverlayElement", () => $9498f71ba797135a$export$5ba4961e00f9d36);
$parcel$export(module.exports, "BarTooltipOverlayEmitterElement", () => $9498f71ba797135a$export$7224ce4821955367);
$parcel$export(module.exports, "BarTooltipOverlayEmitter", () => $9498f71ba797135a$export$e3d7d80d1df1466);
$parcel$export(module.exports, "BarTooltipOverlay", () => $9498f71ba797135a$export$a6d588001e949ed2);

var $5uXOq = parcelRequire("5uXOq");

var $bT1Sw = parcelRequire("bT1Sw");

var $iTGbP = parcelRequire("iTGbP");

var $6jSGb = parcelRequire("6jSGb");


var $lrseF = parcelRequire("lrseF");

var $13b02 = parcelRequire("13b02");

var $3xZ2d = parcelRequire("3xZ2d");

var $aEZ4R = parcelRequire("aEZ4R");

var $2OMIu = parcelRequire("2OMIu");
const $9498f71ba797135a$export$5ba4961e00f9d36 = (0, $bT1Sw.element)((props)=>{
    var _tooltipData$nearestD, _tooltipData$nearestD2, _tooltipData$nearestD3;
    const { tooltipOpen: tooltipOpen, tooltipData: tooltipData, showTooltip: showTooltip, hideTooltip: hideTooltip, width: width, height: height, xScale: xScale, yScale: yScale, horizontal: horizontal, xAccessor: xAccessor, yAccessor: yAccessor, margin: margin, seriesData: seriesData, data: data, hide: hide } = props;
    if (hide) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: tooltipOpen && (tooltipData === null || tooltipData === void 0 ? void 0 : (_tooltipData$nearestD = tooltipData.nearestDatum) === null || _tooltipData$nearestD === void 0 ? void 0 : _tooltipData$nearestD.datum) && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: !horizontal ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iTGbP.PrivateBar), {
                x: (xScale(xAccessor(tooltipData === null || tooltipData === void 0 ? void 0 : (_tooltipData$nearestD2 = tooltipData.nearestDatum) === null || _tooltipData$nearestD2 === void 0 ? void 0 : _tooltipData$nearestD2.datum)) || 0) - 5,
                y: 0,
                opacity: 0.5,
                fill: "var(--ds-interaction-hovered, #00000029)",
                width: (0, $6jSGb.default)(xScale) + 10,
                height: height
            }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iTGbP.PrivateBar), {
                y: (yScale(xAccessor(tooltipData === null || tooltipData === void 0 ? void 0 : (_tooltipData$nearestD3 = tooltipData.nearestDatum) === null || _tooltipData$nearestD3 === void 0 ? void 0 : _tooltipData$nearestD3.datum)) || 0) - 5,
                x: 0,
                opacity: 0.5,
                fill: "var(--ds-interaction-hovered, #00000029)",
                height: (0, $6jSGb.default)(yScale) + 10,
                width: width
            })
        })
    });
});
const $9498f71ba797135a$export$7224ce4821955367 = (0, $bT1Sw.element)((props)=>{
    const { width: width, height: height, xScale: xScale, yScale: yScale, horizontal: horizontal, xAccessor: xAccessor, yAccessor: yAccessor, margin: margin, seriesData: seriesData, showTooltip: showTooltip, hideTooltip: hideTooltip, onClick: onClick, data: data, hide: hide } = props;
    if (hide) return null;
    const eventEmitters = (0, $13b02.default)({
        source: (0, $0277c50b98747247$export$69b1818e3c4e83f9)
    });
    (0, $3xZ2d.default)({
        dataKey: 'nearest',
        onPointerMove: (d)=>showTooltip(d),
        onPointerOut: ()=>hideTooltip(),
        onPointerDown: (d)=>onClick && onClick(d),
        allowedSources: [
            (0, $0277c50b98747247$export$69b1818e3c4e83f9)
        ],
        horizontal: horizontal,
        width: width,
        margin: margin,
        height: height,
        data: data,
        xScale: xScale,
        yScale: yScale,
        xAccessor: xAccessor,
        yAccessor: yAccessor,
        seriesData: seriesData
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
            style: {
                cursor: onClick ? 'pointer' : 'default'
            },
            width: width,
            height: height,
            fill: "transparent",
            ...eventEmitters
        })
    });
});
function $9498f71ba797135a$export$e3d7d80d1df1466() {
    const { width: width, height: height, margin: margin, xScale: xScale, yScale: yScale, xAccessor: xAccessor, yAccessor: yAccessor, seriesData: seriesData, data: data } = (0, $aEZ4R.useBarData)();
    const { showTooltip: showTooltip, hideTooltip: hideTooltip } = (0, $5uXOq.useContext)((0, $lrseF.default));
    return /*#__PURE__*/ (0, $2OMIu.jsx)($9498f71ba797135a$export$7224ce4821955367, {
        showTooltip: showTooltip,
        hideTooltip: hideTooltip,
        width: width,
        height: height,
        xScale: xScale,
        yScale: yScale,
        xAccessor: xAccessor,
        yAccessor: yAccessor,
        data: data,
        seriesData: seriesData,
        margin: margin
    });
}
function $9498f71ba797135a$export$a6d588001e949ed2() {
    const { width: width, height: height, margin: margin, xScale: xScale, yScale: yScale, xAccessor: xAccessor, yAccessor: yAccessor, seriesData: seriesData, data: data } = (0, $aEZ4R.useBarData)();
    const { showTooltip: showTooltip, tooltipData: tooltipData, tooltipOpen: tooltipOpen, hideTooltip: hideTooltip } = (0, $5uXOq.useContext)((0, $lrseF.default));
    return /*#__PURE__*/ (0, $2OMIu.jsx)($9498f71ba797135a$export$5ba4961e00f9d36, {
        tooltipOpen: tooltipOpen,
        showTooltip: showTooltip,
        hideTooltip: hideTooltip,
        tooltipData: tooltipData,
        width: width,
        height: height,
        xScale: xScale,
        yScale: yScale,
        xAccessor: xAccessor,
        yAccessor: yAccessor,
        data: data,
        seriesData: seriesData,
        margin: margin
    });
}

});
const $0277c50b98747247$export$69b1818e3c4e83f9 = '__XY_EVENT_SOURCE__';

parcelRegister("13b02", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c3e9a8e4cb9b40b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lI55a = parcelRequire("lI55a");
function $0c3e9a8e4cb9b40b$export$2e2bcd8739ae039(_ref) {
    let { source: source, onPointerOut: onPointerOut = true, onPointerMove: onPointerMove = true, onPointerUp: onPointerUp = true, onPointerDown: onPointerDown = true, onFocus: onFocus = false, onBlur: onBlur = false } = _ref;
    const emit = (0, $lI55a.default)();
    const emitPointerMove = (0, $5uXOq.useCallback)((event, datum)=>emit === null || emit === void 0 ? void 0 : emit('pointermove', event, source, datum), [
        emit,
        source
    ]);
    const emitPointerOut = (0, $5uXOq.useCallback)((event)=>emit === null || emit === void 0 ? void 0 : emit('pointerout', event, source), [
        emit,
        source
    ]);
    const emitPointerUp = (0, $5uXOq.useCallback)((event)=>emit === null || emit === void 0 ? void 0 : emit('pointerup', event, source), [
        emit,
        source
    ]);
    const emitPointerDown = (0, $5uXOq.useCallback)((event, datum)=>emit === null || emit === void 0 ? void 0 : emit('pointerdown', event, source, datum), [
        emit,
        source
    ]);
    const emitFocus = (0, $5uXOq.useCallback)((event)=>emit === null || emit === void 0 ? void 0 : emit('focus', event, source), [
        emit,
        source
    ]);
    const emitBlur = (0, $5uXOq.useCallback)((event)=>emit === null || emit === void 0 ? void 0 : emit('blur', event, source), [
        emit,
        source
    ]);
    return {
        onPointerMove: onPointerMove ? emitPointerMove : undefined,
        onFocus: onFocus ? emitFocus : undefined,
        onBlur: onBlur ? emitBlur : undefined,
        onPointerOut: onPointerOut ? emitPointerOut : undefined,
        onPointerUp: onPointerUp ? emitPointerUp : undefined,
        onPointerDown: onPointerDown ? emitPointerDown : undefined
    };
}

});

parcelRegister("3xZ2d", function(module, exports) {

$parcel$export(module.exports, "default", () => $2953cc62a817af6a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5yRts = parcelRequire("5yRts");

var $4grX0 = parcelRequire("4grX0");

var $lI55a = parcelRequire("lI55a");
const $2953cc62a817af6a$export$76917c244f8b44cb = '__POINTER_EVENTS_ALL';
const $2953cc62a817af6a$export$ee16f91d64c2973e = '__POINTER_EVENTS_NEAREST';
function $2953cc62a817af6a$export$1d0a87a519049f8c(event) {
    return !!event && ('clientX' in event || 'changedTouches' in event);
}
function $2953cc62a817af6a$export$9829d00ac5f2232d(event) {
    return !!event && !$2953cc62a817af6a$export$1d0a87a519049f8c(event);
}
function $2953cc62a817af6a$export$2e2bcd8739ae039(_ref) {
    let { findNearestDatum: findNearestDatumProps, onBlur: onBlur, onFocus: onFocus, onPointerMove: onPointerMove, onPointerOut: onPointerOut, onPointerUp: onPointerUp, onPointerDown: onPointerDown, allowedSources: allowedSources, width: width, height: height, margin: margin, data: data, xScale: xScale, yScale: yScale, xAccessor: xAccessor, yAccessor: yAccessor, seriesData: seriesData, horizontal: horizontal } = _ref;
    // this logic is shared by pointerup, pointermove, and focus handlers
    const getHandlerParams = (0, $5uXOq.useCallback)((params)=>{
        const { svgPoint: svgPoint, event: event } = params || {};
        // nearest Datum across all dataKeys, if relevant
        // let nearestDatumPointerParams: EventHandlerParams<Datum> | null = null;
        // let nearestDatumDistance = Infinity;
        if (params && event && svgPoint && width && height) {
            const findNearestFunction = !horizontal ? (0, $5yRts.default) : (0, $4grX0.default);
            const nearestDatum = findNearestFunction({
                height: height,
                data: data,
                point: {
                    x: svgPoint.x - margin.left,
                    y: svgPoint.y - margin.top
                },
                width: width,
                xAccessor: !horizontal ? xAccessor : yAccessor,
                xScale: xScale,
                yAccessor: !horizontal ? yAccessor : xAccessor,
                yScale: yScale
            });
            if (nearestDatum) {
                const access = xAccessor;
                // TODO: get all of the data nearest
                const pointerParams = [
                    {
                        svgPoint: svgPoint,
                        event: event,
                        ...nearestDatum,
                        nearestSeriesData: seriesData.get(access(nearestDatum === null || nearestDatum === void 0 ? void 0 : nearestDatum.datum))
                    }
                ];
                // dataKey === POINTER_EVENTS_NEAREST
                // console.log(pointerParams);
                //     ? [nearestDatumPointerParams]
                // : dataKey === POINTER_EVENTS_ALL || Array.isArray(dataKey)
                //   ? Object.values(pointerParamsByKey)
                //   : [pointerParamsByKey[dataKey]];
                return pointerParams.filter((param)=>param);
            } else {
                const pointerParams = [
                    {
                        svgPoint: svgPoint,
                        event: event,
                        datum: null
                    }
                ];
                return pointerParams.filter((param)=>param);
            }
        }
        return [];
    }, [
        data,
        xScale,
        yScale,
        width,
        height,
        (0, $5yRts.default)
    ]);
    const handlePointerMove = (0, $5uXOq.useCallback)((params)=>{
        if (onPointerMove) getHandlerParams(params).forEach((p)=>onPointerMove(p));
    }, [
        getHandlerParams,
        onPointerMove
    ]);
    const handlePointerUp = (0, $5uXOq.useCallback)((params)=>{
        if (onPointerUp) getHandlerParams(params).forEach((p)=>onPointerUp(p));
    }, [
        getHandlerParams,
        onPointerUp
    ]);
    const handlePointerDown = (0, $5uXOq.useCallback)((params)=>{
        if (onPointerDown) getHandlerParams(params).forEach((p)=>onPointerDown(p));
    }, [
        getHandlerParams,
        onPointerDown
    ]);
    const handleFocus = (0, $5uXOq.useCallback)((params)=>{
        if (onFocus) getHandlerParams(params).forEach((p)=>onFocus(p));
    }, [
        getHandlerParams,
        onFocus
    ]);
    const handlePointerOut = (0, $5uXOq.useCallback)((params)=>{
        const event = params === null || params === void 0 ? void 0 : params.event;
        if (event && $2953cc62a817af6a$export$1d0a87a519049f8c(event) && onPointerOut) onPointerOut(event);
    }, [
        onPointerOut
    ]);
    const handleBlur = (0, $5uXOq.useCallback)((params)=>{
        const event = params === null || params === void 0 ? void 0 : params.event;
        if (event && $2953cc62a817af6a$export$9829d00ac5f2232d(event) && onBlur) onBlur(event);
    }, [
        onBlur
    ]);
    (0, $lI55a.default)('pointermove', onPointerMove ? handlePointerMove : undefined, allowedSources);
    (0, $lI55a.default)('pointerout', onPointerOut ? handlePointerOut : undefined, allowedSources);
    (0, $lI55a.default)('pointerup', onPointerUp ? handlePointerUp : undefined, allowedSources);
    (0, $lI55a.default)('pointerdown', onPointerDown ? handlePointerDown : undefined, allowedSources);
    (0, $lI55a.default)('focus', onFocus ? handleFocus : undefined, allowedSources);
    (0, $lI55a.default)('blur', onBlur ? handleBlur : undefined, allowedSources);
}

});
parcelRegister("5yRts", function(module, exports) {

$parcel$export(module.exports, "default", () => $40c99b8ee82fea7e$export$2e2bcd8739ae039);

var $8EmVK = parcelRequire("8EmVK");
function $40c99b8ee82fea7e$export$2e2bcd8739ae039(_ref) {
    let { xScale: scale, xAccessor: accessor, yScale: yScale, yAccessor: yAccessor, point: point, data: data } = _ref;
    if (!point) return null;
    const nearestDatum = (0, $8EmVK.default)({
        scale: scale,
        accessor: accessor,
        scaledValue: point.x,
        data: data
    });
    return nearestDatum ? {
        datum: nearestDatum.datum,
        index: nearestDatum.index,
        distanceX: nearestDatum.distance,
        distanceY: Math.abs(Number(yScale(yAccessor(nearestDatum.datum))) - point.y)
    } : null;
}

});
parcelRegister("8EmVK", function(module, exports) {

$parcel$export(module.exports, "default", () => $64c3d8a41a163589$export$2e2bcd8739ae039);

var $hjll3 = parcelRequire("hjll3");
function $64c3d8a41a163589$export$2e2bcd8739ae039(_ref) {
    let { scale: scale, accessor: accessor, scaledValue: scaledValue, data: data } = _ref;
    const coercedScale = scale; // broaden type before type guards below
    let nearestDatum;
    let nearestDatumIndex;
    // if scale has .invert(), convert svg coord to nearest data value
    if ('invert' in coercedScale && typeof coercedScale.invert === 'function') {
        const bisect = (0, $hjll3.bisector)(accessor).left;
        // find closest data value, then map that to closest datum
        const dataValue = Number(coercedScale.invert(scaledValue));
        const index = bisect(data, dataValue);
        // take the two datum nearest this index, and compute which is closer
        const nearestDatum0 = data[index - 1];
        const nearestDatum1 = data[index];
        nearestDatum = !nearestDatum0 || Math.abs(dataValue - accessor(nearestDatum0)) > Math.abs(dataValue - accessor(nearestDatum1)) ? nearestDatum1 : nearestDatum0;
        nearestDatumIndex = nearestDatum === nearestDatum0 ? index - 1 : index;
    } else if ('step' in coercedScale && typeof coercedScale.step !== 'undefined') {
        // band scales don't have an invert function but they do have discrete domains
        // so we manually invert
        const domain = scale.domain();
        const range = scale.range().map(Number);
        // Remove the padding for the points
        // https://github.com/airbnb/visx/issues/1602
        // Need to consider
        const sortedRange = [
            ...range
        ].sort((a, b)=>a - b); // bisectLeft assumes sort
        const sortedDomain = range[0] < range[1] ? domain : domain.reverse();
        let domainValue = 0;
        if ('paddingInner' in scale) {
            // BandScale
            // Get the outer padding.
            const paddingOuter = scale(sortedDomain[0]) || 0;
            // Get each band size
            const eachBand = coercedScale.step();
            // Find the index
            const index = Math.floor((scaledValue - paddingOuter) / eachBand);
            // Get domain value
            domainValue = sortedDomain[Math.max(0, Math.min(index, sortedDomain.length - 1))];
        } else {
            // PointScale
            // Create ranges that take into account the padding of the first and last
            // elements. Basically if there is 0 padding then the first element
            // should go into the negative by 1/2 the step amount.
            const rangePoints = (0, $hjll3.range)(sortedRange[0] - coercedScale.step() * (0.5 - coercedScale.padding()), sortedRange[1] + coercedScale.step() * (0.5 - coercedScale.padding()), coercedScale.step());
            domainValue = sortedDomain[(0, $hjll3.bisectLeft)(rangePoints, scaledValue) - 1];
        }
        const index = data.findIndex((d)=>String(accessor(d)) === String(domainValue));
        nearestDatum = data[index];
        nearestDatumIndex = index;
    } else {
        console.warn('[visx/xychart/findNearestDatum] encountered incompatible scale type, bailing');
        return null;
    }
    if (nearestDatum == null || nearestDatumIndex == null) return null;
    const distance = Math.abs(Number(coercedScale(accessor(nearestDatum))) - scaledValue);
    return {
        datum: nearestDatum,
        index: nearestDatumIndex,
        distance: distance
    };
}

});


parcelRegister("4grX0", function(module, exports) {

$parcel$export(module.exports, "default", () => $31ae567ddf80c493$export$2e2bcd8739ae039);

var $8EmVK = parcelRequire("8EmVK");
function $31ae567ddf80c493$export$2e2bcd8739ae039(_ref) {
    let { yScale: scale, yAccessor: accessor, xScale: xScale, xAccessor: xAccessor, point: point, data: data } = _ref;
    if (!point) return null;
    const nearestDatum = (0, $8EmVK.default)({
        scale: scale,
        accessor: accessor,
        scaledValue: point.y,
        data: data
    });
    return nearestDatum ? {
        datum: nearestDatum.datum,
        index: nearestDatum.index,
        distanceY: nearestDatum.distance,
        distanceX: Math.abs(Number(xScale(xAccessor(nearestDatum.datum))) - point.x)
    } : null;
}

});


parcelRegister("aEZ4R", function(module, exports) {

$parcel$export(module.exports, "BarDataProvider", () => $7c2d04805347e364$export$b2c9e5e1e06afcc9);
$parcel$export(module.exports, "useBarData", () => $7c2d04805347e364$export$315829aab2a8c649);

var $5uXOq = parcelRequire("5uXOq");

var $PfPCm = parcelRequire("PfPCm");

var $cgmj2 = parcelRequire("cgmj2");

var $ggVTz = parcelRequire("ggVTz");

var $2OMIu = parcelRequire("2OMIu");
const $7c2d04805347e364$var$DataContext = /*#__PURE__*/ (0, $5uXOq.createContext)({});
function $7c2d04805347e364$export$b2c9e5e1e06afcc9(_ref) {
    let { children: children, ...props } = _ref;
    const { showPatterns: showPatterns } = (0, $PfPCm.useMenuData)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cgmj2.Theme), {
        fillStyles: (0, $cgmj2.DEFAULT_ORDINAL_COLORS),
        enableDefaultPatterns: showPatterns,
        useThemeFillStyles: (0, $cgmj2.useThemeFillStyles),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ggVTz.BarScalesElement), {
            ...props,
            children: (scales)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)($7c2d04805347e364$var$DataContext.Provider, {
                        value: {
                            ...props,
                            ...scales
                        },
                        children: children
                    })
                })
        })
    });
}
function $7c2d04805347e364$export$315829aab2a8c649() {
    return (0, $5uXOq.useContext)($7c2d04805347e364$var$DataContext);
}

});


parcelRegister("fAwZ6", function(module, exports) {

$parcel$export(module.exports, "PureBarChart", () => $b593cdda4009ff24$export$1870517ff3080193);

var $5uXOq = parcelRequire("5uXOq");

var $cMmlP = parcelRequire("cMmlP");

var $hi6Wp = parcelRequire("hi6Wp");

var $dnJJh = parcelRequire("dnJJh");

var $8j5jo = parcelRequire("8j5jo");

var $dluWU = parcelRequire("dluWU");

var $4zOFu = parcelRequire("4zOFu");

var $7RF0L = parcelRequire("7RF0L");

var $5jWQu = parcelRequire("5jWQu");

var $h3rAq = parcelRequire("h3rAq");

var $F3H4n = parcelRequire("F3H4n");

var $dcOT3 = parcelRequire("dcOT3");

var $4HTJ0 = parcelRequire("4HTJ0");

var $cKYPp = parcelRequire("cKYPp");

var $aEZ4R = parcelRequire("aEZ4R");

var $2OMIu = parcelRequire("2OMIu");
function $b593cdda4009ff24$var$defaultColorAccessor() {
    return (_)=>'';
}
function $b593cdda4009ff24$var$useAccessors(_ref) {
    let { xAccessor: xAccessor, yAccessor: yAccessor, colorAccessor: colorAccessor } = _ref;
    // GENERATE ENCODINGS
    const [x, y, color] = (0, $5uXOq.useMemo)(()=>{
        const [x] = (0, $8j5jo.useSafeAccessors)(xAccessor);
        const [y] = (0, $8j5jo.useSafeAccessors)(yAccessor);
        const [color] = (0, $8j5jo.useSafeAccessors)(colorAccessor);
        return [
            x,
            y,
            color
        ];
    }, [
        xAccessor,
        yAccessor,
        colorAccessor
    ]);
    return {
        x: x,
        y: y,
        color: color
    };
}
function $b593cdda4009ff24$export$1870517ff3080193(_ref2) {
    let { data: data, width: width, height: height, xAccessor: xAccessor, yAccessor: yAccessor, colorAccessor: colorAccessor, margin: margin = (0, $dluWU.DEFAULT_MARGIN), svgRef: svgRef } = _ref2;
    // TODO: move this to container so the dimentions returned are already correct
    const [plotHeight, plotWidth] = (0, $5uXOq.useMemo)(()=>[
            Math.max(0, height - margin.top - margin.bottom),
            Math.max(0, width - margin.left - margin.right)
        ], [
        height,
        margin,
        width
    ]);
    const { x: x, y: y, color: color } = $b593cdda4009ff24$var$useAccessors({
        xAccessor: xAccessor,
        yAccessor: yAccessor,
        colorAccessor: colorAccessor || $b593cdda4009ff24$var$defaultColorAccessor()
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $aEZ4R.BarDataProvider), {
        data: data,
        width: plotWidth,
        height: plotHeight,
        x: x,
        y: y,
        xAccessor: x,
        yAccessor: y,
        color: color,
        colorAccessor: color,
        margin: margin,
        children: [
            colorAccessor && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $F3H4n.BarLegend), {}),
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $cMmlP.default), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4zOFu.BarAxes), {}),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $h3rAq.BarGrid), {}),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hi6Wp.default), {
                        innerRef: svgRef,
                        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dnJJh.default), {
                            top: margin.top,
                            left: margin.left,
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dcOT3.BarPatterns), {}),
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7RF0L.BarMarkSlot), {}),
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cKYPp.BarTooltipOverlay), {}),
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cKYPp.BarTooltipOverlayEmitter), {})
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4HTJ0.BarTooltip), {}),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5jWQu.DataTable), {})
        ]
    });
}

});
parcelRegister("cMmlP", function(module, exports) {

$parcel$export(module.exports, "default", () => $94db4e2c58c24248$export$2e2bcd8739ae039);
/* CartesianGrid.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $bwpsq = parcelRequire("bwpsq");

var $2OMIu = parcelRequire("2OMIu");
function $94db4e2c58c24248$export$2e2bcd8739ae039(_ref) {
    let { children: children } = _ref;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_1e0c1txw _kqswh2mm _16jlkb7n _1tkeidpf _1ul9idpf"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            className: (0, $bwpsq.default)([
                "_1e0c11p5 _yv0ey09t _2z051qft _zulp1nty _1lmcpu6d _1ul9idpf _1tkeidpf _1bsb1osq _4t3i1osq"
            ]),
            children: children
        })
    });
}

});

parcelRegister("hi6Wp", function(module, exports) {

$parcel$export(module.exports, "default", () => $c96980735a92a865$export$2e2bcd8739ae039);
/* Plot.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $bwpsq = parcelRequire("bwpsq");

var $bT1Sw = parcelRequire("bT1Sw");

var $2OMIu = parcelRequire("2OMIu");
var $c96980735a92a865$export$2e2bcd8739ae039 = (0, $bT1Sw.element)(function Plot(_ref) {
    let { top: top = 0, left: left = 0, width: width = '100%', height: height = '100%', transform: transform, children: children, innerRef: innerRef, ...restProps } = _ref;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
            ref: innerRef,
            width: width,
            height: height,
            transform: transform || `translate(${left}, ${top})`,
            ...restProps,
            className: (0, $bwpsq.default)([
                "_nd5lah6b _16jlkb7n _1ul9idpf _1tkeidpf _1reoewfl _18m9ewfl _1pbyidpf"
            ]),
            children: children
        })
    });
});

});

parcelRegister("8j5jo", function(module, exports) {

$parcel$export(module.exports, "useSafeAccessors", () => $60c437dea181ada7$export$1ff31c13ab3c61e1);
$parcel$export(module.exports, "getFirstItem", () => $60c437dea181ada7$export$fbdeaa6a76694f71);
$parcel$export(module.exports, "getSecondItem", () => $60c437dea181ada7$export$18f9732b2021233c);
function $60c437dea181ada7$export$227cf200245550ef(accessor) {
    if (typeof accessor === 'string') {
        function s(d) {
            try {
                return d[accessor];
            } catch  {
                return 0;
            }
        }
        return s;
    } else if (typeof accessor === 'number') {
        function s1(d) {
            try {
                return d[accessor];
            } catch  {
                return 0;
            }
        }
        return s1;
    }
    function s2(d) {
        try {
            return accessor instanceof Function ? accessor(d) : 0;
        } catch  {
            return 0;
        }
    }
    return s2;
}
function $60c437dea181ada7$export$1ff31c13ab3c61e1() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return args.map((d)=>$60c437dea181ada7$export$227cf200245550ef(d));
}
function $60c437dea181ada7$export$3a667a3b7e4d6701(l) {
    return typeof (l === null || l === void 0 ? void 0 : l.x) === 'number' ? l === null || l === void 0 ? void 0 : l.x : 0;
}
function $60c437dea181ada7$export$337238c011325465(l) {
    return typeof (l === null || l === void 0 ? void 0 : l.y) === 'number' ? l === null || l === void 0 ? void 0 : l.y : 0;
}
function $60c437dea181ada7$export$dd2b6e807fb37ba3(l) {
    return l === null || l === void 0 ? void 0 : l.source;
}
function $60c437dea181ada7$export$c22522a4dfa48e9c(l) {
    return l === null || l === void 0 ? void 0 : l.target;
}
function $60c437dea181ada7$export$fbdeaa6a76694f71(d) {
    return d === null || d === void 0 ? void 0 : d[0];
}
function $60c437dea181ada7$export$18f9732b2021233c(d) {
    return d === null || d === void 0 ? void 0 : d[1];
}

});

parcelRegister("4zOFu", function(module, exports) {

$parcel$export(module.exports, "BarAxes", () => $3551bbeee5340be1$export$2212d638e9c7f00f);

var $hqZma = parcelRequire("hqZma");

var $cXzUG = parcelRequire("cXzUG");

var $aEZ4R = parcelRequire("aEZ4R");

var $2OMIu = parcelRequire("2OMIu");
function $3551bbeee5340be1$export$2212d638e9c7f00f() {
    const { xScale: xScale, yScale: yScale, height: height, width: width } = (0, $aEZ4R.useBarData)();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hqZma.AxisBottom), {
                scale: xScale,
                top: height,
                left: width
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cXzUG.AxisLeft), {
                scale: yScale
            })
        ]
    });
}

});

parcelRegister("7RF0L", function(module, exports) {

$parcel$export(module.exports, "BarGroup", () => $5b9d4ba7b0c88f2a$export$54ef77743fe39325);
$parcel$export(module.exports, "BarMarkSlot", () => $5b9d4ba7b0c88f2a$export$a8a51762e68574d8);

var $bT1Sw = parcelRequire("bT1Sw");

var $dnJJh = parcelRequire("dnJJh");

var $aEZ4R = parcelRequire("aEZ4R");

var $arL7j = parcelRequire("arL7j");

var $dwg9t = parcelRequire("dwg9t");

var $cp7lx = parcelRequire("cp7lx");

var $2OMIu = parcelRequire("2OMIu");
const $5b9d4ba7b0c88f2a$export$54ef77743fe39325 = (0, $bT1Sw.element)(function BarGroup(_ref) {
    let { data: data, top: top, left: left, xScale: xScale, yScale: yScale, colorScale: colorScale, groupScale: groupScale, colorAccessor: colorAccessor, groupAccessor: groupAccessor, valueAccessor: valueAccessor, xAccessor: xAccessor } = _ref;
    const barGroups = (0, $cp7lx.getBarGroups)(data, groupScale, xScale, yScale, colorScale, groupAccessor, valueAccessor, colorAccessor, xAccessor);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dnJJh.default), {
        top: top,
        left: left,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dwg9t.BarGroupMarks), {
                barGroups: barGroups,
                roundedCorners: true
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $arL7j.BarGroupMarkLabels), {
                barGroups: barGroups,
                hide: true
            })
        ]
    });
});
function $5b9d4ba7b0c88f2a$export$a8a51762e68574d8() {
    const { data: data, xAccessor: xAccessor, yAccessor: yAccessor, colorAccessor: colorAccessor, colorScale: colorScale, groupScale: groupScale, xScale: xScale, yScale: yScale } = (0, $aEZ4R.useBarData)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)($5b9d4ba7b0c88f2a$export$54ef77743fe39325, {
        data: data,
        groupScale: groupScale,
        xScale: xScale,
        yScale: yScale,
        colorScale: colorScale,
        xAccessor: xAccessor,
        valueAccessor: yAccessor,
        colorAccessor: colorAccessor,
        groupAccessor: colorAccessor
    });
}

});
parcelRegister("cp7lx", function(module, exports) {

$parcel$export(module.exports, "getBarGroups", () => $907d84b07dc8893a$export$b0379c1526b79abe);

var $hjll3 = parcelRequire("hjll3");
function $907d84b07dc8893a$var$getScaleBandwidth(scale) {
    return 'bandwidth' in scale ? scale.bandwidth() : 0;
}
function $907d84b07dc8893a$export$b0379c1526b79abe(data, groupScale, xScale, yScale, colorScale, groupAccessor, valueAccessor, colorAccessor, xAccessor) {
    const barWidth = $907d84b07dc8893a$var$getScaleBandwidth(groupScale);
    const groups = (0, $hjll3.group)(data, groupAccessor);
    const barGroups = Array.from(groups).map((_ref, i)=>{
        let [key, entries] = _ref;
        return {
            index: i,
            x0: groupScale(key),
            bars: entries.map((d, j)=>{
                var _yScale;
                return {
                    index: j,
                    key: key,
                    datum: d,
                    width: barWidth,
                    xValue: xAccessor(d) || 0,
                    yValue: valueAccessor(d) || 0,
                    x: xScale(xAccessor(d)) || 0,
                    y: yScale(valueAccessor(d)) || 0,
                    label: colorAccessor(d) || '',
                    color: colorScale(colorAccessor(d)),
                    height: yScale.range()[0] - ((_yScale = yScale(valueAccessor(d))) !== null && _yScale !== void 0 ? _yScale : yScale.range()[0])
                };
            })
        };
    });
    return barGroups;
}

});


parcelRegister("5jWQu", function(module, exports) {

$parcel$export(module.exports, "DataTable", () => $3dfc5f9b9010c7cb$export$df30df7ec97b32b5);

var $5uXOq = parcelRequire("5uXOq");

var $PfPCm = parcelRequire("PfPCm");

var $aEZ4R = parcelRequire("aEZ4R");

var $2OMIu = parcelRequire("2OMIu");

const $3dfc5f9b9010c7cb$var$LazyDataTableModal = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>Promise.resolve((parcelRequire("lOXm0"))).then((module)=>({
            default: module.DataTableModal
        })));
function $3dfc5f9b9010c7cb$export$df30df7ec97b32b5() {
    const { showDataTable: showDataTable, closeDataTable: closeDataTable } = (0, $PfPCm.useMenuData)();
    const { data: data } = (0, $aEZ4R.useBarData)();
    return showDataTable ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
        fallback: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            style: {
                visibility: 'hidden'
            }
        }),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($3dfc5f9b9010c7cb$var$LazyDataTableModal, {
            data: data,
            closeModal: closeDataTable
        })
    }) : null;
}

});

parcelRegister("h3rAq", function(module, exports) {

$parcel$export(module.exports, "BarGrid", () => $c6a81d93c24dd46f$export$fb11aa615404ad71);

var $erST8 = parcelRequire("erST8");

var $aEZ4R = parcelRequire("aEZ4R");

var $2OMIu = parcelRequire("2OMIu");
function $c6a81d93c24dd46f$export$fb11aa615404ad71() {
    const { xScale: xScale, yScale: yScale, height: height, width: width } = (0, $aEZ4R.useBarData)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $erST8.Grid), {
        rowLineStyle: "solid",
        columnLineStyle: "hidden",
        xScale: xScale,
        yScale: yScale,
        width: width,
        height: height
    });
}

});

parcelRegister("F3H4n", function(module, exports) {

$parcel$export(module.exports, "BarLegend", () => $07b6b1efa859beb0$export$9a281618489c171);

var $3B9ij = parcelRequire("3B9ij");

var $aEZ4R = parcelRequire("aEZ4R");

var $2OMIu = parcelRequire("2OMIu");
function $07b6b1efa859beb0$export$9a281618489c171() {
    const { data: data, colorAccessor: colorAccessor, colorScale: colorScale } = (0, $aEZ4R.useBarData)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3B9ij.OrdinalLegend), {
        shape: "square",
        data: data,
        colorScale: colorScale,
        colorAccessor: colorAccessor,
        labelAccessor: colorAccessor
    });
}

});

parcelRegister("dcOT3", function(module, exports) {

$parcel$export(module.exports, "BarPatterns", () => $99d3de702876114d$export$73f9b7830d32a61e);

var $epG85 = parcelRequire("epG85");

var $17PP9 = parcelRequire("17PP9");

var $PfPCm = parcelRequire("PfPCm");

var $cgmj2 = parcelRequire("cgmj2");

var $2OMIu = parcelRequire("2OMIu");
const $99d3de702876114d$export$73f9b7830d32a61e = ()=>{
    const { patternDefs: patternDefs } = (0, $17PP9.useElementProps)((0, $epG85.default).elements.Theme);
    const { showPatterns: showPatterns } = (0, $PfPCm.useMenuData)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: showPatterns ? (0, $cgmj2.DEFAULT_ORDINAL_PATTERNS_DEFS) : patternDefs
    });
};

});

parcelRegister("4HTJ0", function(module, exports) {

$parcel$export(module.exports, "BarTooltip", () => $36d66762af5c6a24$export$f509e97905f1d31f);

var $5uXOq = parcelRequire("5uXOq");

var $lrseF = parcelRequire("lrseF");

var $2pOyr = parcelRequire("2pOyr");

var $aEZ4R = parcelRequire("aEZ4R");

var $2OMIu = parcelRequire("2OMIu");
function $36d66762af5c6a24$export$f509e97905f1d31f() {
    const { xAccessor: xAccessor, yAccessor: yAccessor, colorAccessor: colorAccessor, colorScale: colorScale } = (0, $aEZ4R.useBarData)();
    const { tooltipData: tooltipData, tooltipLeft: tooltipLeft, tooltipTop: tooltipTop } = (0, $5uXOq.useContext)((0, $lrseF.default));
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2pOyr.MultiSeriesTooltip), {
        tooltipData: tooltipData,
        tooltipLeft: tooltipLeft,
        tooltipTop: tooltipTop,
        xAccessor: xAccessor,
        yAccessor: yAccessor,
        colorAccessor: colorAccessor,
        colorScale: colorScale
    });
}

});



parcelRegister("hhESq", function(module, exports) {

$parcel$export(module.exports, "BarGroupHorizontal", () => $c953bb7e79beb6df$export$ca0ea6f4f6e77023);

var $bT1Sw = parcelRequire("bT1Sw");
var $17PP9 = parcelRequire("17PP9");

var $dnJJh = parcelRequire("dnJJh");

var $7RF0L = parcelRequire("7RF0L");

var $ft4EL = parcelRequire("ft4EL");

var $6nv1a = parcelRequire("6nv1a");

var $IqHcb = parcelRequire("IqHcb");

var $2OMIu = parcelRequire("2OMIu");
function $c953bb7e79beb6df$var$BarGroupHorizontal(props) {
    const { data: data, top: top, left: left, xScale: xScale, yScale: yScale, colorScale: colorScale, groupScale: groupScale, colorAccessor: colorAccessor, groupAccessor: groupAccessor, valueAccessor: valueAccessor, xAccessor: xAccessor } = (0, $17PP9.useElementProps)((0, $7RF0L.BarGroup), {
        mergeWith: props
    });
    const barGroups = (0, $IqHcb.getHorizontalBarGroups)(data, groupScale, xScale, yScale, colorScale, groupAccessor, valueAccessor, colorAccessor, xAccessor);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dnJJh.default), {
        top: top,
        left: left,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6nv1a.BarGroupHorizontalMarks), {
                barGroups: barGroups,
                roundedCorners: true
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ft4EL.BarGroupHorizontalLabels), {
                barGroups: barGroups,
                hide: true
            })
        ]
    });
}
const $c953bb7e79beb6df$export$ca0ea6f4f6e77023 = (0, $bT1Sw.element)($c953bb7e79beb6df$var$BarGroupHorizontal, {
    as: (0, $7RF0L.BarGroup)
});

});
parcelRegister("ft4EL", function(module, exports) {

$parcel$export(module.exports, "BarGroupHorizontalLabels", () => $b42d2d20ec6e978b$export$c934468eb2e0ea9c);

var $bT1Sw = parcelRequire("bT1Sw");

var $8WT90 = parcelRequire("8WT90");

var $dnJJh = parcelRequire("dnJJh");

var $2OMIu = parcelRequire("2OMIu");
const $b42d2d20ec6e978b$export$c934468eb2e0ea9c = (0, $bT1Sw.element)(function BarGroupHorizontalMarks(_ref) {
    let { barGroups: barGroups, hide: hide } = _ref;
    if (hide) return null;
    return barGroups.map((barGroup)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dnJJh.default), {
            top: barGroup.x0,
            children: barGroup.bars.map((bar)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $8WT90.ValueLabel), {
                    x: bar.x + bar.width,
                    y: bar.y + bar.height / 2,
                    color: bar.color,
                    children: bar.yValue.toString()
                }, `bar-group-label-${barGroup.index}-${bar.index}`))
        }, `bar-group-${barGroup.index}-${barGroup.x0}`));
});

});

parcelRegister("6nv1a", function(module, exports) {

$parcel$export(module.exports, "BarGroupHorizontalMarks", () => $4a4cf388352f75af$export$a1a3a490a3ff3095);

var $bT1Sw = parcelRequire("bT1Sw");

var $iTGbP = parcelRequire("iTGbP");

var $dnJJh = parcelRequire("dnJJh");

var $dluWU = parcelRequire("dluWU");

var $2OMIu = parcelRequire("2OMIu");
const $4a4cf388352f75af$export$a1a3a490a3ff3095 = (0, $bT1Sw.element)(function BarGroupHorizontalMarks(_ref) {
    let { barGroups: barGroups, roundedCorners: roundedCorners = true, baseRoundedCorners: baseRoundedCorners = false } = _ref;
    return barGroups.map((barGroup)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dnJJh.default), {
            top: barGroup.x0,
            children: barGroup.bars.map((bar)=>{
                const cornerRadius = bar.height > 2 * (0, $dluWU.CORNER_RADIUS_VALUE).SMALL && bar.width > 2 * (0, $dluWU.CORNER_RADIUS_VALUE).SMALL ? (0, $dluWU.CORNER_RADIUS_VALUE).SMALL : (0, $dluWU.CORNER_RADIUS_VALUE).NONE;
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iTGbP.Bar), {
                    ariaLabel: `${bar.label}, x: ${bar.yValue}, y: ${bar.xValue}`,
                    x: bar.x,
                    y: bar.y,
                    width: bar.width,
                    datum: bar.datum,
                    height: bar.height,
                    fill: bar.color,
                    cornerRadius: {
                        ...roundedCorners ? {
                            topRight: cornerRadius,
                            bottomRight: cornerRadius
                        } : {},
                        ...baseRoundedCorners ? {
                            topLeft: cornerRadius,
                            bottomLeft: cornerRadius
                        } : {}
                    }
                }, `bar-group-bar-${barGroup.index}-${bar.index}-${bar.xValue}-${bar.key}`);
            })
        }, `bar-group-${barGroup.index}-${barGroup.x0}`));
});

});

parcelRegister("IqHcb", function(module, exports) {

$parcel$export(module.exports, "getHorizontalBarGroups", () => $0858d162a90bae8d$export$bf66c194b5d480d3);

var $hjll3 = parcelRequire("hjll3");

var $6jSGb = parcelRequire("6jSGb");
function $0858d162a90bae8d$export$bf66c194b5d480d3(data, groupScale, xScale, yScale, colorScale, groupAccessor, valueAccessor, colorAccessor, xAccessor) {
    const barWidth = (0, $6jSGb.default)(groupScale);
    const groups = (0, $hjll3.group)(data, groupAccessor);
    const barGroups = Array.from(groups).map((_ref, i)=>{
        let [key, entries] = _ref;
        return {
            index: i,
            x0: groupScale(key),
            bars: entries.map((d, j)=>{
                return {
                    index: j,
                    key: key,
                    datum: d,
                    height: barWidth,
                    xValue: xAccessor(d) || 0,
                    yValue: valueAccessor(d) || 0,
                    label: colorAccessor(d) || '',
                    y: yScale(xAccessor(d)) || 0,
                    x: 0,
                    color: colorScale(colorAccessor(d)),
                    width: xScale(valueAccessor(d)) || 0
                };
            })
        };
    });
    return barGroups;
}

});


parcelRegister("3KKAW", function(module, exports) {

$parcel$export(module.exports, "BarGroupHorizontalScalesElement", () => $2bb9cfbca25ab016$export$e839b74fab6169e4);

var $hjll3 = parcelRequire("hjll3");

var $5uXOq = parcelRequire("5uXOq");

var $bT1Sw = parcelRequire("bT1Sw");
var $17PP9 = parcelRequire("17PP9");
parcelRequire("8WCE9");
var $i3RkB = parcelRequire("i3RkB");
var $5pfgu = parcelRequire("5pfgu");
var $juXo4 = parcelRequire("juXo4");

var $6jSGb = parcelRequire("6jSGb");

var $cgmj2 = parcelRequire("cgmj2");

var $ggVTz = parcelRequire("ggVTz");
/** Public props */ function $2bb9cfbca25ab016$var$BarGroupHorizontalScalesElement(props) {
    const { data: data, x: x, y: y, color: color, width: width, height: height, yDomain: yDomain, timeUnit: timeUnit, children: children } = (0, $17PP9.useElementProps)((0, $ggVTz.BarScalesElement), {
        mergeWith: props
    });
    const { fillStyles: fillStyles, enableDefaultPatterns: enableDefaultPatterns, useThemeFillStyles: useThemeFillStyles } = (0, $17PP9.useElementProps)((0, $cgmj2.Theme));
    const totalYValue = (0, $ggVTz.useMaximumYValue)(data || [], x, y, false);
    const value = (0, $5uXOq.useMemo)(()=>{
        const xScaleRange = [
            height,
            0
        ];
        const xScalePadding = 0.25;
        const xScale = (0, $ggVTz.calculateXScaleDomain)({
            xData: data.map(x),
            timeUnit: timeUnit,
            range: xScaleRange,
            padding: xScalePadding
        });
        const groupScale = (0, $i3RkB.default)({
            domain: [
                ...new Set(data.map(color))
            ],
            range: [
                0,
                (0, $6jSGb.default)(xScale)
            ],
            padding: 0.1
        });
        const yScale = (0, $5pfgu.default)({
            domain: (0, $ggVTz.calculateYDomain)({
                totalYValue: totalYValue,
                yDomain: yDomain
            }),
            range: [
                0,
                width
            ]
        });
        const { domain: domain, range: range } = useThemeFillStyles({
            fillStyles: fillStyles,
            enableDefaultPatterns: enableDefaultPatterns
        });
        const colorScale = (0, $juXo4.default)({
            domain: domain ? domain : data.map(color),
            range: range
        });
        const seriesData = (0, $hjll3.group)(data, x);
        return {
            xScale: yScale,
            yScale: xScale,
            colorScale: colorScale,
            groupScale: groupScale,
            seriesData: seriesData
        };
    }, [
        data,
        width,
        height,
        totalYValue,
        x,
        yDomain,
        timeUnit,
        fillStyles,
        enableDefaultPatterns
    ]);
    return children(value);
}
const $2bb9cfbca25ab016$export$e839b74fab6169e4 = (0, $bT1Sw.element)($2bb9cfbca25ab016$var$BarGroupHorizontalScalesElement, {
    as: (0, $ggVTz.BarScalesElement).Component
});

});


parcelRegister("f10PG", function(module, exports) {

$parcel$export(module.exports, "CustomAxisLeftText", () => $93a2815890ca28f6$export$82b464522a99ba59);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $181Rm = parcelRequire("181Rm");

var $bT1Sw = parcelRequire("bT1Sw");
var $17PP9 = parcelRequire("17PP9");
const $93a2815890ca28f6$export$82b464522a99ba59 = (0, $bT1Sw.element)(({ sideBarWidth: sideBarWidth })=>{
    const { children: children } = (0, $17PP9.useElementProps)((0, $181Rm.default).elements.AxisLeftText);
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        // We want to scale the width of the axis text relative to the width of the side bar
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            maxWidth: `calc(${sideBarWidth / 3}px)`
        },
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
        ])
    }, /*#__PURE__*/ $5uXOq.createElement("span", null, children?.toString()));
}, {
    as: (0, $181Rm.default).elements.AxisLeftText
});
const $93a2815890ca28f6$var$axisStyles = null;

});

parcelRegister("ezrHX", function(module, exports) {

$parcel$export(module.exports, "CustomLayout", () => $382a50a6aa75e72e$export$38801bd36eb3c5d0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $181Rm = parcelRequire("181Rm");

var $bT1Sw = parcelRequire("bT1Sw");
var $17PP9 = parcelRequire("17PP9");
// The right most label in the y-axis can extend outside of the chart area if it is positioned at the edge of the chart.
// Whether this occurs or not depends on values present in the chart (i.e. use value 100 with all other values being less than 10).
// Fixing this would require changes in AVP, so for now the simplest solution is to add some right padding and clip any excess.
// Labels should never be more than 4 characters long, 1000 is shown as 1K, 1000000 is shown as 1M, so we just need to account for this.
const $382a50a6aa75e72e$var$layoutStyles = null;
const $382a50a6aa75e72e$var$paddingRight = 16; // space.200 === 16px
const $382a50a6aa75e72e$var$chartStyles = null;
const $382a50a6aa75e72e$export$38801bd36eb3c5d0 = (0, $bT1Sw.element)(()=>{
    const { children: children, width: width, height: height } = (0, $17PP9.useElementProps)((0, $181Rm.default).elements.Layout);
    const [fadeInOpacity, setFadeInOpacity] = (0, $5uXOq.useState)(0);
    (0, $5uXOq.useEffect)(()=>{
        let isMounted = true;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const ref = window.requestAnimationFrame(()=>{
            // TODO: would be nice to fade in without triggering another render
            if (isMounted) setFadeInOpacity(1);
        });
        return ()=>{
            isMounted = false;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.cancelAnimationFrame(ref);
        };
    }, [
        setFadeInOpacity
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-element": "layout",
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            width: width ? width - $382a50a6aa75e72e$var$paddingRight : undefined,
            height: height
        },
        className: (0, $bwpsq.default)([
            "_1reozryt _u5f3pxbi"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-element": "chart",
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            opacity: fadeInOpacity
        },
        className: (0, $bwpsq.default)([
            "_v56414fr _1e0c1txw _1ul9idpf _1tkeidpf _1h1t1smo"
        ])
    }, children)));
}, {
    as: (0, $181Rm.default).elements.Layout
});

});


parcelRegister("dUJCJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $00347ab46067e4f7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $00347ab46067e4f7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    chartTypeError: {
        "id": "issue-field-statistics.single-select-chart-container.chart-type-error",
        "defaultMessage": " Invalid chart type. Please select a valid chart type from the options below."
    },
    chartTypeSelectLabel: {
        "id": "issue-field-statistics.single-select-chart-container.chart-type-select-label",
        "defaultMessage": "Chart type"
    },
    donutChartLabel: {
        "id": "issue-field-statistics.single-select-chart-container.donut-chart-label",
        "defaultMessage": "Donut chart"
    },
    horizontalBarChartLabel: {
        "id": "issue-field-statistics.single-select-chart-container.horizontal-bar-chart-label",
        "defaultMessage": "Horizontal bar chart"
    }
});

});


const $03857339d4f662fa$export$eb686c593382b322 = 40; // space.250 * 2 = 40px
const $03857339d4f662fa$export$6b0a922783b1a3e9 = 24; // space.150 * 2 = 24px

parcelRegister("1ovIw", function(module, exports) {

$parcel$export(module.exports, "default", () => $3af034c7ae137843$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3af034c7ae137843$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noFieldSelectedError: {
        "id": "business-issue-field-statistics.statistics-sidebar.no-field-selected-error",
        "defaultMessage": "We can't show this chart because it uses one of your hidden fields. Select a different field from the dropdown."
    }
});

});



parcelRegister("5ea6B", function(module, exports) {

$parcel$export(module.exports, "filterStatisticFields", () => $721e5fcee88f3f56$export$297d943b5bad2c36);
const $721e5fcee88f3f56$var$SUPPORTED_STATISTIC_FIELD_TYPES = [
    'com.atlassian.jira.plugin.system.customfieldtypes:select',
    'com.atlassian.jira.plugin.system.customfieldtypes:float',
    'com.atlassian.jira.plugin.system.customfieldtypes:storypoint',
    'com.atlassian.jira.plugin.system.customfieldtypes:radiobuttons',
    'com.atlassian.jira.plugin.system.customfieldtypes:userpicker',
    'com.pyxis.greenhopper.jira:jsw-story-points',
    'assignee',
    'reporter',
    'status',
    'priority',
    'issuetype'
];
const $721e5fcee88f3f56$export$297d943b5bad2c36 = (fields)=>{
    return fields.filter((field)=>field.__typename === 'JiraNumberField' || field.type && $721e5fcee88f3f56$var$SUPPORTED_STATISTIC_FIELD_TYPES.includes(field.type));
};

});



parcelRegister("i0CN8", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0a0f82215b28cfe$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b0a0f82215b28cfe$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    shareTitle: {
        "id": "business-list.list-view.header-actions.share-title",
        "defaultMessage": "List"
    },
    simpleSearch: {
        "id": "business-list.list-view.header-actions.simple-search",
        "defaultMessage": "Search list"
    },
    searchLabel: {
        "id": "business-list.list-view.header-actions.search-label",
        "defaultMessage": "Typing letters in the search input applies filters"
    },
    format: {
        "id": "business-list.list-view.header-actions.conditional-formatting",
        "defaultMessage": "Format"
    }
});

});

parcelRegister("h4BPz", function(module, exports) {

$parcel$export(module.exports, "useFilterProps", () => $882feec1572e145b$export$5e00405c50f0041a);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $hE5wF = parcelRequire("hE5wF");

var $5fc53 = parcelRequire("5fc53");

var $4nnGr = parcelRequire("4nnGr");

var $8TUlY = parcelRequire("8TUlY");
const $882feec1572e145b$var$createStringSet = (0, $8QpSo.default)((...args)=>new Set([
        ...args
    ]));
const $882feec1572e145b$export$5e00405c50f0041a = ()=>{
    const { getAvailableFields: getAvailableFields } = (0, $8TUlY.useIssueFields)();
    const { isSoftwareFieldsEnabled: isSoftwareFieldsEnabled } = (0, $4nnGr.useJWMListFeatures)();
    const availableFields = (0, $5uXOq.useMemo)(()=>getAvailableFields(), [
        getAvailableFields
    ]);
    // Only hides active sprints if the field is not available or is not software or FF is off
    const hiddenQuickFilters = (0, $5uXOq.useMemo)(()=>{
        if (!isSoftwareFieldsEnabled) return [
            'ACTIVE_SPRINTS'
        ];
        const sprintField = availableFields.find((field)=>field.type === (0, $5fc53.SPRINT_TYPE));
        if (sprintField == null) return [
            'ACTIVE_SPRINTS'
        ];
        return [];
    }, [
        availableFields,
        isSoftwareFieldsEnabled
    ]);
    const allowedAliasFieldId = (0, $5uXOq.useMemo)(()=>{
        if (!isSoftwareFieldsEnabled) return;
        const fieldsAliases = availableFields.filter((field)=>field.aliasFieldId === (0, $hE5wF.STORY_POINTS_ALIAS_FIELD_ID) || field.aliasFieldId === (0, $hE5wF.STORY_POINT_ESTIMATE_ALIAS_FIELD_ID)).map((field)=>field.aliasFieldId);
        if (fieldsAliases.length === 0) return;
        return $882feec1572e145b$var$createStringSet(...fieldsAliases);
    }, [
        availableFields,
        isSoftwareFieldsEnabled
    ]);
    return {
        allowedAliasFieldId: allowedAliasFieldId,
        hiddenQuickFilters: hiddenQuickFilters
    };
};

});

parcelRegister("2ITuF", function(module, exports) {

$parcel$export(module.exports, "ListMoreMenu", () => $6175e171ccd75011$export$c0940d69bffc1ad9);
/* ListMoreMenu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");

var $eZJjh = parcelRequire("eZJjh");

var $3bDjY = parcelRequire("3bDjY");

var $8U6zd = parcelRequire("8U6zd");

var $g5r1G = parcelRequire("g5r1G");

var $jgJNO = parcelRequire("jgJNO");

var $4mO32 = parcelRequire("4mO32");

var $koVbs = parcelRequire("koVbs");

var $47gW9 = parcelRequire("47gW9");

var $7XluA = parcelRequire("7XluA");

var $22OQR = parcelRequire("22OQR");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

var $hCCtP = parcelRequire("hCCtP");

var $c3sfT = parcelRequire("c3sfT");

var $iRnrA = parcelRequire("iRnrA");
const $6175e171ccd75011$var$styles = {
    fallbackMenu: "_1bsbfp70 _1e0c1txw _1bah1h6o _4cvr1h6o _ca0qpxbi _n3tdpxbi"
};
const $6175e171ccd75011$export$c0940d69bffc1ad9 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isMoreMenuOpen, setIsMoreMenuOpen] = (0, $5uXOq.useState)(false);
    const closeMoreMenu = (0, $5uXOq.useCallback)(()=>setIsMoreMenuOpen(false), []);
    const toggleMoreMenu = (0, $5uXOq.useCallback)(()=>setIsMoreMenuOpen((oldIsOpen)=>!oldIsOpen), []);
    const { onClickFormatButton: onClickFormatButton } = (0, $g5r1G.useGetFormatRulesClick)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $c3sfT.moreMenuContentEntryPoint), {});
    const moreMenuContentTrigger = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions, !isMoreMenuOpen);
    const moreMenuProps = (0, $5uXOq.useMemo)(()=>({
            onClose: closeMoreMenu,
            onClickFormatButton: onClickFormatButton
        }), [
        closeMoreMenu,
        onClickFormatButton
    ]);
    const moreMenuContent = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "business-list-more-menu",
            packageName: "@atlassian/jira-business-list",
            runtimeProps: moreMenuProps,
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
                xcss: $6175e171ccd75011$var$styles.fallbackMenu
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), null))
        })), [
        entryPointReferenceSubject,
        moreMenuProps
    ]);
    const moreMenuTrigger = (0, $5uXOq.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formatMessage((0, $iRnrA.default).triggerLabel),
            position: "top",
            hideTooltipOnClick: true
        }, (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh-headers-buttons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCCtP.ThemedIconButton), {
            ...triggerProps,
            appearance: "default",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($8U6zd))),
            ref: (element)=>{
                moreMenuContentTrigger(element);
                if (typeof triggerProps.ref === 'function') triggerProps.ref(element);
            },
            isSelected: isMoreMenuOpen,
            onClick: toggleMoreMenu,
            label: formatMessage((0, $iRnrA.default).triggerLabel),
            testId: "business-list.ui.list-view.header-actions.more-menu.more-menu"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $22OQR.ThemedButton), {
            ...triggerProps,
            ref: (element)=>{
                moreMenuContentTrigger(element);
                if (typeof triggerProps.ref === 'function') triggerProps.ref(element);
            },
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8U6zd))), {
                label: "",
                spacing: "spacious",
                color: "currentColor"
            }),
            isSelected: isMoreMenuOpen,
            onClick: toggleMoreMenu,
            "aria-label": formatMessage((0, $iRnrA.default).triggerLabel),
            testId: "business-list.ui.list-view.header-actions.more-menu.more-menu-old"
        })), [
        formatMessage,
        isMoreMenuOpen,
        moreMenuContentTrigger,
        toggleMoreMenu
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isMoreMenuOpen,
        onClose: closeMoreMenu,
        placement: "bottom-end",
        content: moreMenuContent,
        trigger: moreMenuTrigger,
        testId: "business-list.ui.list-view.header-actions.more-menu.more-menu-popup",
        messageId: "business-list.ui.list-view.header-actions.more-menu.popup.more-menu-popup",
        messageType: "transactional"
    });
};

});
parcelRegister("g5r1G", function(module, exports) {

$parcel$export(module.exports, "useGetFormatRulesClick", () => $8ca37f609e18a796$export$777c2bb91a0db32);

var $5uXOq = parcelRequire("5uXOq");

var $cm8b5 = parcelRequire("cm8b5");

var $4mO32 = parcelRequire("4mO32");

var $koeKL = parcelRequire("koeKL");

var $daQYX = parcelRequire("daQYX");

var $7XluA = parcelRequire("7XluA");

var $8iVnX = parcelRequire("8iVnX");

var $dkq9p = parcelRequire("dkq9p");

var $hug5L = parcelRequire("hug5L");

var $9Unx5 = parcelRequire("9Unx5");

var $eTGH6 = parcelRequire("eTGH6");
const $8ca37f609e18a796$export$777c2bb91a0db32 = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const projectData = (0, $daQYX.useProject)();
    const [hydrateJql] = (0, $hug5L.useFormatRulesSerialisedJql)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $dkq9p.formatRulesEntryPoint), {
        projectKey: projectData.key,
        cloudId: cloudId,
        hydrateJql: hydrateJql
    });
    const errorFallback = (0, $5uXOq.useCallback)(({ error: error })=>// TODO: show error flag
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cm8b5.ExperienceFailed), {
            experience: (0, $8iVnX.LIST_FORMAT_RULE_EXPERIENCE),
            error: error
        }), []);
    const { onClickFormatButton: onClickFormatButton } = (0, $eTGH6.useFormatRulesSidebar)({
        SidebarComponent: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
                entryPointReferenceSubject: entryPointReferenceSubject,
                id: "jwm.business.format.rules",
                packageName: "jiraBusinessFormatRules",
                runtimeProps: props,
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9Unx5.SidebarFallback), null),
                errorFallback: errorFallback
            }),
        projectId: String(projectData.id)
    });
    const onClick = (0, $5uXOq.useCallback)(({ showOnboarding: showOnboarding })=>{
        entryPointActions.load();
        onClickFormatButton({
            showOnboarding: showOnboarding
        });
    }, [
        entryPointActions,
        onClickFormatButton
    ]);
    return {
        onClickFormatButton: onClick
    };
};

});

parcelRegister("c3sfT", function(module, exports) {

$parcel$export(module.exports, "moreMenuContentEntryPoint", () => $bf33a3ade19643c1$export$b4db54f6e08979a8);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $bf33a3ade19643c1$export$b4db54f6e08979a8 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("eApwZ")), {
        moduleId: "a0e8f5a3",
        moduleName: "ListMoreMenuContent"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("eApwZ", function(module, exports) {

let $a9e83b67503b99d0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a9e83b67503b99d0$var$load("iTIW4").then(()=>parcelRequire('iZAzS'));

});


parcelRegister("iRnrA", function(module, exports) {

$parcel$export(module.exports, "default", () => $3358f6c7efee7c9c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3358f6c7efee7c9c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    triggerLabel: {
        "id": "business-list.list-view.header-actions.more-menu.trigger-label",
        "defaultMessage": "More actions"
    }
});

});



parcelRegister("aQK8w", function(module, exports) {

$parcel$export(module.exports, "default", () => $440547739bd87478$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $440547739bd87478$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    listHeading: {
        "id": "business-list.list-view.list-heading",
        "defaultMessage": "List"
    },
    unassignedOption: {
        "id": "business-list.list-view.unassigned-option",
        "defaultMessage": "Unassigned"
    },
    assignToMe: {
        "id": "business-list.list-view.assign-to-me",
        "defaultMessage": "Assign to me"
    },
    loadingMoreItems: {
        "id": "business-list.list-view.loading-more-items",
        "defaultMessage": "Loading more items..."
    }
});

});

parcelRegister("dfOFF", function(module, exports) {

$parcel$export(module.exports, "InteractionMetrics", () => $7ab82445f13b3e8b$export$341b330828bd3906);

var $dJ1ye = parcelRequire("dJ1ye");
const $7ab82445f13b3e8b$export$341b330828bd3906 = ()=>{
    const interactionMetrics = (0, $dJ1ye.useInteractionMetrics)();
    if (interactionMetrics[0, $dJ1ye.COLUMN_RESIZED].state === 'started') interactionMetrics[0, $dJ1ye.COLUMN_RESIZED].stop({
        stopTime: Math.floor(performance.now())
    });
    if (interactionMetrics[0, $dJ1ye.COLUMN_VISIBILITY_CHANGED].state === 'started') interactionMetrics[0, $dJ1ye.COLUMN_VISIBILITY_CHANGED].stop({
        stopTime: Math.floor(performance.now())
    });
    if (interactionMetrics[0, $dJ1ye.DND_ROW_DROPPED].state === 'started') interactionMetrics[0, $dJ1ye.DND_ROW_DROPPED].stop({
        stopTime: Math.floor(performance.now())
    });
    return null;
};

});

parcelRegister("8nhP8", function(module, exports) {

$parcel$export(module.exports, "AsyncReparentModal", () => $90b147095b0262a8$export$2afac3ca0625436);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $7lNbC = parcelRequire("7lNbC");

var $emGcb = parcelRequire("emGcb");
const $90b147095b0262a8$var$runtimeProps = {};
const $90b147095b0262a8$var$entryPointParams = {};
const $90b147095b0262a8$export$2afac3ca0625436 = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $7lNbC.reparentModalEntryPoint), $90b147095b0262a8$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "jwm.list.reparent-modal",
        packageName: (0, $emGcb.PACKAGE_NAME),
        teamName: "keystone",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: $90b147095b0262a8$var$runtimeProps,
        errorFallback: "unmount"
    });
};

});
parcelRegister("7lNbC", function(module, exports) {

$parcel$export(module.exports, "reparentModalEntryPoint", () => $bdf94962c4e0afae$export$e5e5cbbac06953a1);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $bdf94962c4e0afae$export$e5e5cbbac06953a1 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("ljvKa")), {
        moduleId: "aa8d69b8"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("ljvKa", function(module, exports) {

let $f843fef077a77739$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f843fef077a77739$var$load("5uP3r").then(()=>parcelRequire('5yG4z'));

});


parcelRegister("emGcb", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $1b79c8e8f28b4c9b$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "SUBTASK_HIERARCHY_LEVEL", () => $1b79c8e8f28b4c9b$export$5b388ccfa29be01);
const $1b79c8e8f28b4c9b$export$b8b9d90f9e5bd72b = 'jiraBusinessList';
const $1b79c8e8f28b4c9b$export$5b388ccfa29be01 = -1;

});


parcelRegister("86297", function(module, exports) {

$parcel$export(module.exports, "WelcomeModal", () => $ca13a99450889d63$export$9d12d42929c3fcf);

var $5uXOq = parcelRequire("5uXOq");

var $gaIrH = parcelRequire("gaIrH");

var $kw5KD = parcelRequire("kw5KD");

var $7CMCs = parcelRequire("7CMCs");

var $daQYX = parcelRequire("daQYX");
const $ca13a99450889d63$var$ConditionalWelcomeModalForSoftware = ()=>{
    const shouldShowModal = (0, $kw5KD.useShouldShowWelcomeModal)('list');
    const project = (0, $daQYX.useProject)();
    const isSoftwareProject = project?.type === 'software';
    return shouldShowModal && isSoftwareProject ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gaIrH.AsyncWelcomeModal), {
        source: "list"
    }) : null;
};
const $ca13a99450889d63$export$9d12d42929c3fcf = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "welcome-modal-list-view",
        packageName: "jiraBusinessList",
        teamName: "jlove-makkuro"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ca13a99450889d63$var$ConditionalWelcomeModalForSoftware, null));
};

});
parcelRegister("gaIrH", function(module, exports) {

$parcel$export(module.exports, "AsyncWelcomeModal", () => $469ada65feba09b1$export$d08881a6c29dfdb2);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");


var $lkem5 = parcelRequire("lkem5");

var $9yQlD = parcelRequire("9yQlD");

var $lfTZh = parcelRequire("lfTZh");

var $l8ruj = parcelRequire("l8ruj");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $469ada65feba09b1$var$LazyWelcomeModal = (0, $kxZPA.lazy)(()=>(parcelRequire("kcpih")).then(({ WelcomeModal: WelcomeModal })=>WelcomeModal), {
    moduleId: "./src/packages/software/onboarding-modals/src/ui/welcome-modal/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $469ada65feba09b1$var$LazyWelcomeModalWizard = (0, $kxZPA.lazy)(()=>(parcelRequire("4O3Zc")).then(({ WelcomeModal: WelcomeModal })=>WelcomeModal), {
    moduleId: "./src/packages/software/onboarding-modals/src/ui/welcome-modal/wizard/index.tsx"
});
const $469ada65feba09b1$export$d08881a6c29dfdb2 = ({ source: source })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "async-onboarding-welcome-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lkem5.ErrorBoundaryWithChunkErrorLogging), {
        id: "asyncWelcomeModalComponent",
        fallback: "unmount",
        packageName: "jiraSoftwareOnboardingModals",
        teamName: "jlove-makkuro"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "software-onboarding-modals-welcome-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, // eslint-disable-next-line jira/ff/no-preconditioning
    (0, $4R6GH.fg)('jira_onboarding_wizard_m1_feature_gate') && [
        'list',
        'board'
    ].includes(source) && // our new wizard only needs to render on list/board
    (0, $9yQlD.sessionStorageProvider).get((0, $6784cbc7d62e5d7c$export$c9dc4cb209930823)) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($469ada65feba09b1$var$LazyWelcomeModalWizard, {
        source: source
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($469ada65feba09b1$var$LazyWelcomeModal, {
        source: source
    }))));
};

});
parcelRegister("kcpih", function(module, exports) {

let $eb488c742b758410$var$load = (parcelRequire("28QjX"))(4);
module.exports = $eb488c742b758410$var$load("3kB5A").then(()=>parcelRequire('68yeS'));

});

parcelRegister("4O3Zc", function(module, exports) {

let $37feec83868dc1e9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $37feec83868dc1e9$var$load("chhFU").then(()=>parcelRequire('1l5pF'));

});


parcelRegister("kw5KD", function(module, exports) {

$parcel$export(module.exports, "useShouldShowModalBasedOnSessionStorage", () => $37bcf797fd2f572d$export$b39cbd941f378bec);
$parcel$export(module.exports, "useShouldShowWelcomeModal", () => $37bcf797fd2f572d$export$b01115c2f75a04f8);

var $5uXOq = parcelRequire("5uXOq");


var $9yQlD = parcelRequire("9yQlD");

var $i4CeP = parcelRequire("i4CeP");
const $37bcf797fd2f572d$export$b39cbd941f378bec = ()=>{
    const shouldShowModalBasedOnSessionStorage = (0, $5uXOq.useMemo)(()=>{
        const isWizardDuringSignup = (0, $9yQlD.sessionStorageProvider).get((0, $6784cbc7d62e5d7c$export$c45d2ea50af63a85));
        if (isWizardDuringSignup) return false;
        const sessionStorageVal = (0, $9yQlD.sessionStorageProvider).get((0, $6784cbc7d62e5d7c$export$e3884212029f7bef));
        if (sessionStorageVal === undefined) return false;
        return true;
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        // Remove the session storage value to prevent the modal showing again
        (0, $9yQlD.sessionStorageProvider).remove((0, $6784cbc7d62e5d7c$export$e3884212029f7bef));
    }, []);
    return shouldShowModalBasedOnSessionStorage;
};
const $37bcf797fd2f572d$export$b01115c2f75a04f8 = (source)=>{
    const canShowNudgeTour = (0, $i4CeP.useCanShowNudgeTour)();
    const sessionStorageVal = (0, $5uXOq.useMemo)(()=>(0, $9yQlD.sessionStorageProvider).get((0, $6784cbc7d62e5d7c$export$e3884212029f7bef)), []);
    const isWizardDuringSignup = (0, $9yQlD.sessionStorageProvider).get((0, $6784cbc7d62e5d7c$export$c45d2ea50af63a85));
    if (isWizardDuringSignup) return false;
    if (sessionStorageVal === undefined) return false;
    return canShowNudgeTour(source);
};

});
parcelRegister("i4CeP", function(module, exports) {

$parcel$export(module.exports, "useCanShowNudgeTour", () => $f9e2cd0a6b3c1f13$export$3381da528a252680);

var $4R6GH = parcelRequire("4R6GH");

var $8Bc5A = parcelRequire("8Bc5A");

var $cE2Qr = parcelRequire("cE2Qr");
const $f9e2cd0a6b3c1f13$export$3381da528a252680 = ()=>{
    const [completedTaskList] = (0, $cE2Qr.useCompletedTaskList)();
    const [shouldShowScrumOnboardingExperience] = (0, $cE2Qr.useShouldShowScrumOnboardingExperience)();
    const [shouldShowOnboardingKanbanTour] = (0, $cE2Qr.useShouldShowOnboardingKanbanTour)();
    const shouldShowOnboardingScrumTour = shouldShowScrumOnboardingExperience === true && // edge case for KURO-2088: After welcome modal failed to load, users complete welcome tour by themselves. Welcome modal should be skipped to load on refreshment.
    !completedTaskList.includes((0, $8Bc5A.SCRUM_ONBOARDING_TASK));
    return (source)=>{
        switch(source){
            case 'board':
                return shouldShowOnboardingKanbanTour;
            case 'backlog':
                return shouldShowOnboardingScrumTour;
            case 'timeline':
                // display if eligible for either board/backlog scenarios
                return shouldShowOnboardingKanbanTour || shouldShowOnboardingScrumTour;
            case 'list':
                if ((0, $4R6GH.fg)('jira_onboarding_wizard_m1_feature_gate')) return true;
                return false;
            default:
                return false;
        }
    };
};

});



parcelRegister("35R0r", function(module, exports) {

$parcel$export(module.exports, "useGetColumns", () => $8c034c8d39e84861$export$5cedf9467e164d21);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $hE5wF = parcelRequire("hE5wF");

var $daQYX = parcelRequire("daQYX");

var $35OFV = parcelRequire("35OFV");

var $iILDa = parcelRequire("iILDa");

var $ijSZT = parcelRequire("ijSZT");

var $57lFd = parcelRequire("57lFd");

var $939cg = parcelRequire("939cg");

var $gULOk = parcelRequire("gULOk");

var $5fc53 = parcelRequire("5fc53");

var $g5X3G = parcelRequire("g5X3G");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $eTDjN = parcelRequire("eTDjN");

var $cjOYL = parcelRequire("cjOYL");

var $3fT9O = parcelRequire("3fT9O");

var $3rO9r = parcelRequire("3rO9r");

var $4HIDQ = parcelRequire("4HIDQ");

var $lt1LT = parcelRequire("lt1LT");

var $8TUlY = parcelRequire("8TUlY");

var $9u99d = parcelRequire("9u99d");

var $gEb1A = parcelRequire("gEb1A");

var $3O2kS = parcelRequire("3O2kS");

var $koElh = parcelRequire("koElh");

var $99NMg = parcelRequire("99NMg");

var $3yRl2 = parcelRequire("3yRl2");

var $i29pf = parcelRequire("i29pf");

var $kX1vD = parcelRequire("kX1vD");

var $al7Aq = parcelRequire("al7Aq");

var $3jNxz = parcelRequire("3jNxz");

var $bFmRi = parcelRequire("bFmRi");

var $3rwUA = parcelRequire("3rwUA");

var $3Vqf5 = parcelRequire("3Vqf5");

var $iQ6fh = parcelRequire("iQ6fh");

var $0CGYD = parcelRequire("0CGYD");

var $e7PC0 = parcelRequire("e7PC0");

var $aQK8w = parcelRequire("aQK8w");

var $aYkrQ = parcelRequire("aYkrQ");

var $1vBWF = parcelRequire("1vBWF");

var $hTzzn = parcelRequire("hTzzn");

var $eRBDs = parcelRequire("eRBDs");

var $1HY3B = parcelRequire("1HY3B");

var $f9qBd = parcelRequire("f9qBd");

var $7xYOf = parcelRequire("7xYOf");

var $bRFLq = parcelRequire("bRFLq");

var $c9UvN = parcelRequire("c9UvN");

var $lup7l = parcelRequire("lup7l");

var $9gyyM = parcelRequire("9gyyM");

var $iydSP = parcelRequire("iydSP");

var $eTHix = parcelRequire("eTHix");

var $7NVIZ = parcelRequire("7NVIZ");

var $3T0IO = parcelRequire("3T0IO");
const $8c034c8d39e84861$var$dateFieldWidth = 145;
const $8c034c8d39e84861$var$getAlwaysVisibleFieldsMemoized = (0, $8QpSo.default)((0, $lt1LT.getAlwaysVisibleFields));
const $8c034c8d39e84861$export$23779177436374fa = ()=>({
        [(0, $5fc53.ISSUE_TYPE)]: 110,
        key: 120,
        [(0, $5fc53.SUMMARY_TYPE)]: 400,
        [(0, $5fc53.STATUS_TYPE)]: 120,
        [(0, $5fc53.ASSIGNEE_TYPE)]: 180,
        [(0, $5fc53.REPORTER_TYPE)]: 180,
        [(0, $5fc53.USER_CF_TYPE)]: 180,
        [(0, $5fc53.DUE_DATE_TYPE)]: $8c034c8d39e84861$var$dateFieldWidth,
        [(0, $5fc53.CREATED)]: $8c034c8d39e84861$var$dateFieldWidth,
        [(0, $5fc53.UPDATED)]: $8c034c8d39e84861$var$dateFieldWidth,
        [(0, $5fc53.PRIORITY_TYPE)]: 120,
        [(0, $5fc53.LABELS_TYPE)]: 170,
        [(0, $5fc53.SELECT_CF_TYPE)]: 120,
        [(0, $5fc53.MULTI_SELECT_CF_TYPE)]: 170,
        [(0, $5fc53.URL_CF_TYPE)]: 180,
        [(0, $5fc53.MULTI_USER_CF_TYPE)]: 200,
        moreFields: 50,
        [(0, $5fc53.DATETIME_CF_TYPE)]: 200,
        [(0, $5fc53.COMPONENTS_TYPE)]: 170,
        [(0, $5fc53.CATEGORY_TYPE)]: 170,
        [(0, $5fc53.COMMENT_TYPE)]: 145,
        [(0, $hE5wF.COMMENT_SUMMARY_TYPE)]: 145,
        [(0, $hE5wF.REMOTE_ISSUE_LINKS_TYPE)]: 200,
        [(0, $5fc53.SPRINT_TYPE)]: 145,
        ...(0, $35OFV.getColumnWidths)()
    });
const $8c034c8d39e84861$export$f2dfe9615519b1 = ()=>({
        [(0, $5fc53.TEXT_AREA_CF_TYPE)]: false,
        [(0, $5fc53.MULTI_USER_CF_TYPE)]: false,
        [(0, $5fc53.PEOPLE_CF_TYPE)]: false,
        [(0, $5fc53.COMMENT_TYPE)]: false,
        [(0, $hE5wF.COMMENT_SUMMARY_TYPE)]: false,
        [(0, $hE5wF.REMOTE_ISSUE_LINKS_TYPE)]: false,
        ...(0, $ijSZT.getSortingDisabledFields)()
    });
const $8c034c8d39e84861$var$COMMON_COLUMN_ATTRIBUTES = {
    frozen: false,
    maxWidth: 640,
    minWidth: 120,
    resizable: true
};
const $8c034c8d39e84861$var$COLUMN_ATTRIBUTE_OVERRIDES = {
    [(0, $5fc53.PRIORITY_TYPE)]: {
        minWidth: 52
    },
    [(0, $hE5wF.REMOTE_ISSUE_LINKS_TYPE)]: {
        minWidth: 200
    },
    key: {
        minWidth: 72
    }
};
const $8c034c8d39e84861$var$selectRowColumn = (showBulkEditOnboarding)=>({
        key: (0, $3rO9r.SELECT_ROW_COLUMN_ID),
        dataKey: (0, $3rO9r.SELECT_ROW_COLUMN_ID),
        width: (0, $eTDjN.SELECT_ROW_COLUMN_WIDTH),
        headerRenderer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7xYOf.SelectAllColumnCheckbox), {
            showBulkEditOnboarding: showBulkEditOnboarding
        }),
        cellRenderer: (props)=>{
            if ((0, $3fT9O.isItemSkeleton)(props.rowData.issueId)) // experimenting with inlining CSS here to avoid styled-components runtime perf overhead
            // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                style: (0, $cjOYL.loadingCellStyles)
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3yRl2.CellNavigation), {
                columnIndex: 0,
                rowIndex: props.rowIndex || 0
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7xYOf.SelectRowCheckbox), props));
        }
    });
const $8c034c8d39e84861$var$iconSize = 'medium';
const $8c034c8d39e84861$var$EMPTY_ARRAY = [];
const $8c034c8d39e84861$var$EMPTY_PAGES_ARRAY = [];
const $8c034c8d39e84861$var$isTimeTrackingConfigNeeded = (field)=>field.type === (0, $5fc53.TIME_ESTIMATE_TYPE);
const $8c034c8d39e84861$export$5cedf9467e164d21 = ({ columnWidths: columnWidths, rowHeight: rowHeight, openIssueModal: openIssueModal, highlightRow: highlightRow, loading: pageLoading, projectId: projectId, onIssueUpdated: onIssueUpdated, showBulkEditOnboarding: showBulkEditOnboarding = false })=>{
    const { hierarchyLevelsWithCache: hierarchyLevelsWithCache, getVisibleFields: getVisibleFields, loading: loading, isVisibleFieldsCached: isVisibleFieldsCached } = (0, $8TUlY.useIssueFields)();
    const visibleFields = getVisibleFields();
    const iconMap = (0, $iILDa.getFieldIcons)($8c034c8d39e84861$var$iconSize);
    const { data: projectData, getProjectData: getProjectData, loading: projectDataLoading } = (0, $koElh.useJiraSettings)();
    const [, { getParentIssueKeysByChildId: getParentIssueKeysByChildId }] = (0, $9u99d.useHierarchyStore)();
    const { globalSystemFields: globalSystemFields } = (0, $3O2kS.useSystemFields)();
    const { onOpenCommentsSidebar: onOpenCommentsSidebar, selectedIssueKey: selectedIssueKey } = (0, $4HIDQ.useCommentsSidebar)({
        CommentsSidebar: $bFmRi.CommentsSidebar
    });
    const isIssueViewVisible = (0, $939cg.useIssueViewIsVisible)();
    const [{ createFields: createFields }] = (0, $gEb1A.useInlineFieldCreateControls)();
    const [hierarchyStore] = (0, $9u99d.useHierarchyStore)();
    const currentFirstRowKey = (0, $5uXOq.useRef)();
    const project = (0, $daQYX.useProject)();
    const defaultColumnWidths = (0, $5uXOq.useMemo)(()=>$8c034c8d39e84861$export$23779177436374fa(), []);
    const sortingActions = (0, $5uXOq.useMemo)(()=>$8c034c8d39e84861$export$f2dfe9615519b1(), []);
    const columnFields = (0, $5uXOq.useMemo)(()=>{
        const _columnFields = [
            ...visibleFields
        ];
        if (createFields.length > 0) createFields.forEach(({ fieldId: fieldId, name: name, type: type, createIndex: createIndex })=>{
            const placeholderField = {
                id: `${(0, $3rO9r.PLACEHOLDER_COLUMN)}-${fieldId}`,
                name: name,
                type: type
            };
            if (createIndex != null) _columnFields.splice(createIndex, 0, placeholderField);
            else _columnFields.push(placeholderField);
        });
        return _columnFields;
    }, [
        visibleFields,
        createFields
    ]);
    // This function finds the first issue row from the top within the first group item
    const getFirstGroupChildRowKey = (0, $5uXOq.useCallback)(()=>{
        const groups = hierarchyStore.hierarchyData.data;
        const firstGroupChild = groups[0]?.children;
        if (!Array.isArray(groups) || !firstGroupChild) return null;
        const firstGroupRow = firstGroupChild.length > 0 && firstGroupChild[0].key.startsWith((0, $3fT9O.INLINE_CREATE_ITEM_PREFIX)) ? firstGroupChild[1] : firstGroupChild[0];
        const firstGroupChildRowKey = firstGroupRow?.key ?? null;
        return firstGroupChildRowKey;
    }, [
        hierarchyStore.hierarchyData.data
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const firstGroupChildRowKey = getFirstGroupChildRowKey();
        currentFirstRowKey.current = firstGroupChildRowKey;
    }, [
        getFirstGroupChildRowKey
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // defer loading project data until estimate column is visible
        if (!projectData && visibleFields.find((field)=>field.type === (0, $5fc53.TIME_ESTIMATE_TYPE)) && !projectDataLoading && pageLoading === false) getProjectData();
    }, [
        projectData,
        pageLoading,
        getProjectData,
        visibleFields,
        projectDataLoading
    ]);
    const hierarchyLevelsByName = (0, $5uXOq.useMemo)(()=>Object.fromEntries(hierarchyLevelsWithCache.map((hierarchyLevel)=>[
                hierarchyLevel.name,
                hierarchyLevel.level,
                hierarchyLevel.id
            ])), [
        hierarchyLevelsWithCache
    ]);
    const cellRenderers = (0, $5uXOq.useMemo)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const toReturn = {};
        columnFields.map((field, index)=>{
            switch(field.type){
                case 0, $5fc53.ISSUE_TYPE:
                    return {
                        [field.id]: ({ cellData: cellData = {}, rowData: rowData })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eTHix.TypeCell), {
                                id: rowData.issueId,
                                iconUrl: cellData.iconUrl,
                                name: cellData.name,
                                avatarId: field.fieldConfig?.avatarId,
                                onChildCreateButtonClicked: rowData.onChildCreateButtonClicked,
                                hierarchyLevel: hierarchyLevelsByName[rowData.issuetype.name ?? ''],
                                rankIndex: rowData.rankIndex
                            })
                    };
                case 'key':
                    return {
                        [field.id]: ({ cellData: cellData, rowData: rowData })=>{
                            const parentIssues = getParentIssueKeysByChildId(rowData.issueId);
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0CGYD.KeyCell), {
                                issueId: rowData.id,
                                issueKey: cellData,
                                parentIssues: parentIssues,
                                onOpenIssueModal: openIssueModal,
                                ...(0, $6s1PB.expVal)('jira_unread_comments_in_list_view', 'isEnabled', false) ? {
                                    issueHasUnreadComment: rowData?.commentSummary?.hasUnreadComment
                                } : {}
                            });
                        }
                    };
                case 0, $5fc53.SUMMARY_TYPE:
                    return {
                        [field.id]: ({ cellData: cellData, rowData: rowData, rowIndex: rowIndex })=>{
                            const isNudgeCell = rowIndex === 0 || rowData?.key === currentFirstRowKey.current;
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iydSP.TextCell), {
                                isNudgeCell: !isIssueViewVisible && isNudgeCell,
                                issueId: rowData.issueId,
                                issueKey: (0, $g5X3G.toIssueKey)(rowData.key),
                                fieldType: (0, $5fc53.SUMMARY_TYPE),
                                fieldValue: cellData,
                                fieldKey: field.id,
                                isEditable: field.fieldConfig?.isEditable ?? false,
                                testId: "business-list.ui.list-view.summary-cell"
                            });
                        }
                    };
                case 0, $5fc53.URL_CF_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData })=>{
                            const url = (0, $57lFd.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            rowData.fields, field.id, 'url', null);
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NVIZ.UrlCell), {
                                issueKey: (0, $g5X3G.toIssueKey)(rowData.key),
                                fieldType: (0, $5fc53.URL_CF_TYPE),
                                fieldValue: url,
                                fieldKey: field.id,
                                isEditable: field.fieldConfig?.isEditable ?? false,
                                fieldName: field.name,
                                issueType: rowData.issuetype.name,
                                issueTypeId: rowData.issuetype.id
                            });
                        }
                    };
                case 0, $5fc53.TEXT_CF_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData })=>{
                            const wiki = (0, $57lFd.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            rowData.fields, field.id, 'wiki', null);
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iydSP.TextCell), {
                                issueId: rowData.issueId,
                                issueKey: (0, $g5X3G.toIssueKey)(rowData.key),
                                fieldType: (0, $5fc53.TEXT_CF_TYPE),
                                fieldValue: wiki,
                                fieldKey: field.id,
                                isEditable: field.fieldConfig?.isEditable ?? false,
                                fieldName: field.name,
                                issueType: rowData.issuetype.name,
                                issueTypeId: rowData.issuetype.id,
                                testId: "business-list.ui.list-view.text-cf-cell"
                            });
                        }
                    };
                case 0, $5fc53.TEXT_AREA_CF_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData })=>{
                            const adf = (0, $57lFd.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            rowData.fields, field.id, 'adf', null);
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gyyM.TextAreaCell), {
                                fieldKey: field.id,
                                fieldType: (0, $5fc53.TEXT_AREA_CF_TYPE),
                                issueKey: (0, $g5X3G.toIssueKey)(rowData.key),
                                onClick: (event)=>openIssueModal(rowData)(event),
                                fieldValue: adf,
                                ...(0, $6s1PB.expVal)('jira_unread_comments_in_list_view', 'isEnabled', false) ? {
                                    issueHasUnreadComment: rowData?.commentSummary?.hasUnreadComment
                                } : {}
                            });
                        }
                    };
                case 0, $5fc53.STATUS_TYPE:
                    return {
                        [field.id]: ({ cellData: cellData, rowData: rowData, column: column })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lup7l.default), {
                                issueKey: (0, $g5X3G.toIssueKey)(rowData.key),
                                width: column.width,
                                height: rowHeight,
                                rowData: rowData,
                                onHighlightRow: highlightRow,
                                ...cellData
                            })
                    };
                case 0, $5fc53.ASSIGNEE_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData, column: column })=>{
                            const userField = (0, $57lFd.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            rowData.fields, field.id, 'userValue', undefined);
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3T0IO.default), {
                                fieldKey: field.id,
                                fieldType: (0, $5fc53.ASSIGNEE_TYPE),
                                issueKey: (0, $g5X3G.toIssueKey)(rowData.key),
                                initialValue: userField,
                                width: column.width,
                                emptyUserNameText: (0, $aQK8w.default).unassignedOption,
                                loggedInUserActionNameText: (0, $aQK8w.default).assignToMe,
                                testId: "business-list.ui.list-view.assignee-cell",
                                fieldName: field.name,
                                issueType: rowData.issuetype.name,
                                issueTypeId: rowData.issuetype.id
                            });
                        }
                    };
                case 0, $5fc53.COMMENT_TYPE:
                case 0, $hE5wF.COMMENT_SUMMARY_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData })=>{
                            const totalCount = rowData?.commentSummary?.totalCount;
                            const hasUnread = rowData?.commentSummary?.hasUnreadComment;
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3jNxz.CommentsCell), {
                                issueKey: (0, $g5X3G.toIssueKey)(rowData.key),
                                isSelected: selectedIssueKey === rowData.key,
                                onClick: onOpenCommentsSidebar,
                                totalCount: totalCount,
                                ...(0, $4R6GH.fg)('_jira_unread_comments_in_list_view_gate') ? {
                                    columnIndex: index
                                } : {},
                                ...(0, $6s1PB.expVal)('jira_unread_comments_in_list_view', 'isEnabled', false) ? {
                                    hasUnread: hasUnread
                                } : {}
                            });
                        }
                    };
                case 0, $5fc53.REPORTER_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData, column: column })=>{
                            const userField = (0, $57lFd.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            rowData.fields, field.id, 'userValue', undefined);
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3T0IO.default), {
                                fieldKey: field.id,
                                fieldType: (0, $5fc53.REPORTER_TYPE),
                                issueKey: (0, $g5X3G.toIssueKey)(rowData.key),
                                initialValue: userField,
                                width: column.width,
                                emptyUserNameText: (0, $aQK8w.default).unassignedOption,
                                loggedInUserActionNameText: (0, $aQK8w.default).assignToMe,
                                isEditable: field.fieldConfig?.isEditable ?? false,
                                fieldName: field.name,
                                issueType: rowData.issuetype.name,
                                issueTypeId: rowData.issuetype.id
                            });
                        }
                    };
                case 0, $5fc53.USER_CF_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData, column: column })=>{
                            const userField = (0, $57lFd.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            rowData.fields, field.id, 'selectedUser', undefined);
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3T0IO.default), {
                                fieldKey: field.id,
                                fieldType: (0, $5fc53.USER_CF_TYPE),
                                issueKey: (0, $g5X3G.toIssueKey)(rowData.key),
                                initialValue: userField,
                                width: column.width,
                                emptyUserNameText: (0, $aQK8w.default).unassignedOption,
                                loggedInUserActionNameText: (0, $aQK8w.default).assignToMe,
                                // @ts-expect-error - TS2339 - Property 'isEditable' does not exist on type 'never'.
                                isEditable: userField?.isEditable,
                                fieldName: field.name,
                                issueType: rowData.issuetype.name,
                                issueTypeId: rowData.issuetype.id
                            });
                        }
                    };
                case 0, $5fc53.LABELS_CF_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData, column: column })=>{
                            const labels = (0, $57lFd.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            rowData.fields, field.id, 'labels', []);
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e7PC0.default), {
                                fieldKey: field.id,
                                fieldType: (0, $5fc53.LABELS_CF_TYPE),
                                issueKey: (0, $g5X3G.toIssueKey)(rowData.key),
                                issueId: rowData.issueId,
                                issueLabels: labels,
                                width: column.width,
                                isEditable: field.fieldConfig?.isEditable ?? false,
                                fieldName: field.name,
                                issueType: rowData.issuetype.name,
                                issueTypeId: rowData.issuetype.id
                            });
                        }
                    };
                case 0, $5fc53.LABELS_TYPE:
                    return {
                        [field.id]: ({ cellData: cellData, rowData: rowData, column: column })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e7PC0.default), {
                                fieldKey: field.id,
                                fieldType: (0, $5fc53.LABELS_TYPE),
                                issueKey: (0, $g5X3G.toIssueKey)(rowData.key),
                                issueId: rowData.issueId,
                                issueLabels: cellData,
                                width: column.width,
                                isEditable: field.fieldConfig?.isEditable ?? false,
                                fieldName: field.name,
                                issueType: rowData.issuetype.name,
                                issueTypeId: rowData.issuetype.id
                            })
                    };
                case 0, $5fc53.PRIORITY_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData, column: column })=>{
                            const priorityValue = (0, $57lFd.safeGetTransformedFieldValue)(rowData.fields, field.id, 'priority', {});
                            const { name: name, id: id } = rowData.issuetype;
                            if (typeof name !== 'string' || typeof id !== 'string') return;
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1HY3B.default), {
                                ...priorityValue,
                                fieldType: (0, $5fc53.PRIORITY_TYPE),
                                issueKey: (0, $g5X3G.toIssueKey)(rowData.key),
                                width: column.width,
                                height: rowHeight,
                                fieldName: field.name,
                                issueType: name,
                                issueTypeId: id,
                                testId: "business-list.ui.list-view.priority-cell",
                                isEditable: field.fieldConfig?.isEditable ?? false,
                                selectOptions: field.fieldConfig?.options ?? []
                            });
                        }
                    };
                case 0, $5fc53.DUE_DATE_TYPE:
                    return {
                        [field.id]: ({ cellData: cellData, rowData: rowData })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Vqf5.default), {
                                issueId: rowData.issueId,
                                fieldKey: field.id,
                                dateOnly: cellData,
                                fieldType: (0, $5fc53.DUE_DATE_TYPE),
                                issueKey: (0, $g5X3G.toIssueKey)(rowData.key),
                                isDue: String(rowData.status?.categoryId) !== String((0, $gULOk.categoryIdForStatusCategory)((0, $gULOk.DONE))),
                                testId: "business-list.ui.list-view.date-cell",
                                fieldName: field.name,
                                issueType: rowData.issuetype.name,
                                issueTypeId: rowData.issuetype.id
                            })
                    };
                case 0, $5fc53.CREATED:
                case 0, $5fc53.UPDATED:
                    return {
                        [field.id]: ({ cellData: cellData, rowData: rowData })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Vqf5.default), {
                                issueId: rowData.issueId,
                                fieldKey: field.id,
                                readOnly: true,
                                dateOnly: cellData,
                                onOpenIssueModal: openIssueModal,
                                rowData: rowData,
                                fieldName: field.name,
                                issueType: rowData.issuetype.name,
                                issueTypeId: rowData.issuetype.id,
                                ...(0, $6s1PB.expVal)('jira_unread_comments_in_list_view', 'isEnabled', false) ? {
                                    issueHasUnreadComment: rowData?.commentSummary?.hasUnreadComment
                                } : {}
                            })
                    };
                case 0, $5fc53.SELECT_CF_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData, column: column })=>{
                            const selectedValue = (0, $57lFd.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            rowData.fields, field.id, 'selectedValue', undefined);
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bRFLq.default), {
                                fieldType: (0, $5fc53.SELECT_CF_TYPE),
                                fieldName: field.name,
                                width: column.width,
                                fieldKey: field.id,
                                issueKey: (0, $g5X3G.toIssueKey)(rowData.key),
                                issueId: rowData.issueId,
                                fieldValue: selectedValue,
                                isEditable: field.fieldConfig?.isEditable ?? false,
                                issueType: rowData.issuetype.name,
                                issueTypeId: rowData.issuetype.id
                            });
                        }
                    };
                case 0, $5fc53.MULTI_SELECT_CF_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData, column: column })=>{
                            const selectedValues = (0, $57lFd.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            rowData.fields, field.id, 'selectedValues', undefined);
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aYkrQ.default), {
                                fieldType: (0, $5fc53.MULTI_SELECT_CF_TYPE),
                                fieldName: field.name,
                                selectOptions: field.fieldConfig?.selectOptions,
                                width: column.width,
                                fieldKey: field.id,
                                issueKey: (0, $g5X3G.toIssueKey)(rowData.key),
                                issueId: rowData.issueId,
                                fieldValue: selectedValues,
                                isEditable: field.fieldConfig?.isEditable ?? false,
                                issueType: rowData.issuetype.name,
                                issueTypeId: rowData.issuetype.id
                            });
                        }
                    };
                case 0, $5fc53.CATEGORY_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData, column: column })=>{
                            const getFieldValue = ()=>(0, $57lFd.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                                rowData.fields, field.id, 'value', null);
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $99NMg.default), {
                                issueId: rowData.issueId,
                                issueKey: (0, $g5X3G.toIssueKey)(rowData.key),
                                width: column.width,
                                fieldKey: field.id,
                                fieldType: (0, $5fc53.CATEGORY_TYPE),
                                issueTypeId: rowData.issuetype.id != null ? Number.parseInt(rowData.issuetype.id, 10) : -1,
                                isEditable: true,
                                fieldValue: getFieldValue(),
                                fieldName: field.name,
                                issueType: rowData.issuetype?.name
                            });
                        }
                    };
                case 0, $5fc53.TIME_ESTIMATE_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData })=>{
                            const originalEstimate = (0, $57lFd.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            rowData.fields, field.id, 'originalEstimate', null);
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eRBDs.default), {
                                config: projectData?.jiraSettings?.timeTracking ?? undefined,
                                isEditable: field.fieldConfig?.isEditable ?? false,
                                fieldId: field.id,
                                issueKey: (0, $g5X3G.toIssueKey)(rowData.key),
                                issueId: rowData.issueId,
                                fieldValue: originalEstimate
                            });
                        }
                    };
                case 0, $5fc53.DATE_CF_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData })=>{
                            const stringValue = (0, $57lFd.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            rowData.fields, field.id, 'stringValue', null);
                            return rowData && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Vqf5.default), {
                                issueId: rowData.issueId,
                                issueKey: (0, $g5X3G.toIssueKey)(rowData.key),
                                fieldKey: field.id,
                                readOnly: !field.fieldConfig?.isEditable,
                                fieldType: (0, $5fc53.DATE_CF_TYPE),
                                fieldValue: stringValue,
                                fieldName: field.name,
                                issueType: rowData.issuetype.name,
                                issueTypeId: rowData.issuetype.id
                            });
                        }
                    };
                case 0, $5fc53.NUMBER_CF_TYPE:
                case 0, $5fc53.STORY_POINTS_TYPE:
                case 0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData })=>{
                            const numberField = (0, $57lFd.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            rowData.fields, field.id, 'floatValue', undefined);
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTzzn.default), {
                                issueKey: (0, $g5X3G.toIssueKey)(rowData.key),
                                fieldKey: field.id,
                                fieldType: field.type,
                                isEditable: field.fieldConfig?.isEditable ?? false,
                                // @ts-expect-error - TS2322 - Type 'undefined' is not assignable to type 'number | null'.
                                fieldValue: numberField,
                                fieldName: field.name,
                                issueType: rowData.issuetype.name,
                                issueTypeId: rowData.issuetype.id
                            });
                        }
                    };
                case 0, $5fc53.DATETIME_CF_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData, column: column })=>{
                            const dateTimeField = (0, $57lFd.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            rowData.fields, field.id, 'dateTimeValue', undefined);
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iQ6fh.default), {
                                height: rowHeight,
                                width: column.width,
                                issueKey: (0, $g5X3G.toIssueKey)(rowData.key),
                                fieldKey: field.id,
                                isEditable: field.fieldConfig?.isEditable ?? false,
                                fieldValue: dateTimeField,
                                fieldName: field.name,
                                issueType: rowData.issuetype.name,
                                issueTypeId: rowData.issuetype.id
                            });
                        }
                    };
                case 0, $5fc53.MULTI_USER_CF_TYPE:
                case 0, $5fc53.PEOPLE_CF_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData, column: column })=>{
                            const multiUserField = (0, $57lFd.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            rowData.fields, field.id, field.type === (0, $5fc53.MULTI_USER_CF_TYPE) ? 'selectedUsers' : 'users', undefined);
                            const fieldType = field.type;
                            if (fieldType == null) return null;
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1vBWF.default), {
                                height: rowHeight,
                                fieldKey: field.id,
                                fieldType: fieldType,
                                issueKey: (0, $g5X3G.toIssueKey)(rowData.key),
                                initialValue: multiUserField,
                                width: column.width,
                                isEditable: field.fieldConfig?.isEditable ?? false,
                                fieldName: field.name,
                                issueType: rowData.issuetype.name,
                                issueTypeId: rowData.issuetype.id
                            });
                        }
                    };
                case 0, $5fc53.COMPONENTS_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData, column: column })=>{
                            const componentsField = (0, $57lFd.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            rowData.fields, field.id, 'componentValues', undefined);
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3rwUA.default), {
                                width: column.width,
                                issueKey: (0, $g5X3G.toIssueKey)(rowData.key),
                                fieldKey: field.id,
                                fieldValue: componentsField,
                                isEditable: field.fieldConfig?.isEditable ?? false,
                                issueId: rowData.issueId
                            });
                        }
                    };
                case 0, $hE5wF.REMOTE_ISSUE_LINKS_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData, rowIndex: rowIndex })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f9qBd.default), {
                                issueKey: (0, $g5X3G.toIssueKey)(rowData.key),
                                issueId: rowData.issueId,
                                pages: rowData.confluenceLinks?.linkedConfluencePages?.pages || $8c034c8d39e84861$var$EMPTY_PAGES_ARRAY,
                                pageCount: rowData.confluenceLinks?.linkedConfluencePages?.pageCount || 0,
                                isNudgeCell: !isIssueViewVisible && (rowIndex === 0 || rowData?.key === currentFirstRowKey.current) && (0, $4R6GH.fg)('grw_1266_killswitch')
                            })
                    };
                case 0, $5fc53.MULTI_CHECKBOXES_CF_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData, column: column })=>{
                            const selectedValues = (0, $57lFd.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            rowData.fields, field.id, 'selectedValues', null);
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kX1vD.default), {
                                width: column.width,
                                issueKey: (0, $g5X3G.toIssueKey)(rowData.key),
                                fieldKey: field.id,
                                fieldName: field.name,
                                fieldValue: selectedValues,
                                isEditable: field.fieldConfig?.isEditable ?? false,
                                issueId: rowData.issueId,
                                issueType: rowData.issuetype.name,
                                issueTypeId: rowData.issuetype.id
                            });
                        }
                    };
                case 0, $5fc53.SPRINT_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData, column: column })=>{
                            const selectedValues = (0, $57lFd.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            rowData.fields, field.id, 'sprint', null);
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c9UvN.default), {
                                width: column.width,
                                issueKey: (0, $g5X3G.toIssueKey)(rowData.key),
                                fieldKey: field.id,
                                fieldName: field.name,
                                fieldValue: selectedValues,
                                isEditable: field.fieldConfig?.isEditable ?? false,
                                issueId: rowData.issueId,
                                issueType: rowData.issuetype.name,
                                issueTypeId: rowData.issuetype.id,
                                issueTypeLevel: rowData.issuetype.level
                            });
                        }
                    };
                default:
                    return {
                        [field.id]: undefined
                    };
            }
        }).forEach((fieldEntry)=>fieldEntry && Object.keys(fieldEntry).forEach((fieldKey)=>{
                toReturn[fieldKey] = fieldEntry[fieldKey];
            }));
        return toReturn;
    }, [
        columnFields,
        hierarchyLevelsByName,
        getParentIssueKeysByChildId,
        openIssueModal,
        isIssueViewVisible,
        rowHeight,
        highlightRow,
        selectedIssueKey,
        onOpenCommentsSidebar,
        projectData?.jiraSettings?.timeTracking
    ]);
    const iconMapWithCategoriesEnabled = (0, $5uXOq.useCallback)((field)=>{
        if (field.type === (0, $5fc53.ISSUE_TYPE)) return null;
        if (field.type === (0, $5fc53.CATEGORY_TYPE)) return field.type != null && iconMap[field.type];
        // This should come after the check for category type
        // Since category has a customfield_X id which is different across projects we should not check for id
        return iconMap[field.id] ?? (field.type !== undefined && iconMap[field.type]);
    }, [
        iconMap
    ]);
    const canEditField = project.isSimplified && project.permissions?.administerProject;
    return (0, $5uXOq.useMemo)(()=>loading && !isVisibleFieldsCached ? $8c034c8d39e84861$var$EMPTY_ARRAY : [
            $8c034c8d39e84861$var$selectRowColumn(showBulkEditOnboarding),
            ...columnFields.map((field, index)=>{
                const width = columnWidths[field.id] ?? // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly issuetype: 120 | 90; readonly key: 120; readonly summary: 400; readonly status: 120; readonly assignee: 180; readonly reporter: 180; readonly "com.atlassian.jira.plugin.system.customfieldtypes:userpicker": 180; ... 12 more ...; readonly "com.atlassian.jira.plugin.system.customfieldtypes:jwm-category": 170...'.
                (field.type !== undefined && defaultColumnWidths[field.type]) ?? 120;
                return {
                    key: field.id,
                    dataKey: field.id,
                    width: width,
                    /*
       * https://autodesk.github.io/react-base-table/docs/get-started
       * To avoid "unnecessary" re-renders, BaseTable ignores functions when comparing column definition by default.
       * Hence, external values not passed as inputs to the renderer function need to be specified as props here. This was causing
       * the time original estimate cell to display stale data since the config data is fetched async after initial render.
       */ timeTrackingConfig: $8c034c8d39e84861$var$isTimeTrackingConfigNeeded(field) ? projectData?.jiraSettings?.timeTracking : undefined,
                    headerRenderer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $al7Aq.ColumnHeader), {
                        icon: // TODO: JET-3805-Replace mocked data with real BE data
                        iconMapWithCategoriesEnabled(field),
                        label: field.name,
                        fieldId: field.id,
                        fieldType: field.type,
                        canSortField: field.type !== undefined && // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly "com.atlassian.jira.plugin.system.customfieldtypes:textarea": false; readonly "com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker": false; readonly "com.atlassian.jira.plugin.system.customfieldtypes:people": false; }'.
                        (sortingActions[field.type] ?? true) && !field.id.startsWith((0, $3rO9r.PLACEHOLDER_COLUMN)),
                        canHideField: !$8c034c8d39e84861$var$getAlwaysVisibleFieldsMemoized().includes(field.id) && !field.id.startsWith((0, $3rO9r.PLACEHOLDER_COLUMN)),
                        canEditField: !!(canEditField && globalSystemFields.length && !globalSystemFields.includes(field.id) && !field.id.startsWith((0, $3rO9r.PLACEHOLDER_COLUMN))),
                        disableDrag: (0, $3rO9r.COLUMNS_WITH_DISABLED_REORDERING).includes(field.id) || field.id.startsWith((0, $3rO9r.PLACEHOLDER_COLUMN)),
                        index: index
                    }),
                    cellRenderer: (params)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i29pf.CellWithHorizontalVirtualization), {
                            ...params,
                            cellRenderers: cellRenderers,
                            field: field,
                            key: params.column.key,
                            onIssueUpdated: onIssueUpdated,
                            projectId: projectId,
                            width: width
                        }),
                    ...$8c034c8d39e84861$var$COMMON_COLUMN_ATTRIBUTES,
                    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly priority: { readonly minWidth: 52; }; readonly key: { readonly minWidth: 72; }; readonly issuetype?: { resizable: boolean; minWidth: number; } | undefined; }'.
                    ...$8c034c8d39e84861$var$COLUMN_ATTRIBUTE_OVERRIDES[field.id]
                };
            })
        ], [
        loading,
        isVisibleFieldsCached,
        showBulkEditOnboarding,
        columnFields,
        columnWidths,
        defaultColumnWidths,
        projectData?.jiraSettings?.timeTracking,
        iconMapWithCategoriesEnabled,
        sortingActions,
        canEditField,
        globalSystemFields,
        cellRenderers,
        onIssueUpdated,
        projectId
    ]);
};

});
parcelRegister("35OFV", function(module, exports) {

$parcel$export(module.exports, "getColumnWidths", () => $82c6a3ce6b6561ce$export$e54c9225ca52acc);

var $8QpSo = parcelRequire("8QpSo");

var $29sHF = parcelRequire("29sHF");

var $45bkV = parcelRequire("45bkV");

var $3kayq = parcelRequire("3kayq");

var $ja4AN = parcelRequire("ja4AN");

var $2hdRM = parcelRequire("2hdRM");

var $jAVAE = parcelRequire("jAVAE");

var $1B2ke = parcelRequire("1B2ke");

var $UXtnp = parcelRequire("UXtnp");
const $82c6a3ce6b6561ce$export$e54c9225ca52acc = (0, $8QpSo.default)(()=>({
        ...(0, $UXtnp.versionColumnWidth),
        ...(0, $29sHF.devSummaryColumnWidth),
        ...(0, $1B2ke.teamColumnWidth),
        ...(0, $45bkV.goalsColumnWidth),
        ...(0, $jAVAE.resolutionColumnWidth),
        ...(0, $3kayq.groupColumnWidth),
        ...(0, $2hdRM.radioSelectColumnWidth),
        ...(0, $ja4AN.projectColumnWidth)
    }));

});
parcelRegister("29sHF", function(module, exports) {

$parcel$export(module.exports, "devSummaryColumnWidth", () => $2b3505fa8b29c774$export$358a1d02595241e8);

var $5fc53 = parcelRequire("5fc53");
const $2b3505fa8b29c774$export$358a1d02595241e8 = {
    [(0, $5fc53.DEV_SUMMARY_CF_TYPE)]: 160
};

});

parcelRegister("45bkV", function(module, exports) {

$parcel$export(module.exports, "goalsColumnWidth", () => $43e3d5588f0a98c3$export$775dc358f0002ea0);

var $5fc53 = parcelRequire("5fc53");
const $43e3d5588f0a98c3$export$775dc358f0002ea0 = {
    [(0, $5fc53.GOALS_CF_TYPE)]: 160
};

});

parcelRegister("3kayq", function(module, exports) {

$parcel$export(module.exports, "groupColumnWidth", () => $ac63a7647149f192$export$67a3cc86fcd4231);

var $5fc53 = parcelRequire("5fc53");
const $ac63a7647149f192$export$67a3cc86fcd4231 = {
    [(0, $5fc53.GROUP_CF_TYPE)]: 160,
    [(0, $5fc53.MULTI_GROUP_CF_TYPE)]: 160
};

});

parcelRegister("ja4AN", function(module, exports) {

$parcel$export(module.exports, "projectColumnWidth", () => $f742573b639cf5c7$export$8f9363e2d2217d2a);

var $5fc53 = parcelRequire("5fc53");
const $f742573b639cf5c7$export$8f9363e2d2217d2a = {
    [(0, $5fc53.PROJECT_PICKER_CF_TYPE)]: 160
};

});

parcelRegister("2hdRM", function(module, exports) {

$parcel$export(module.exports, "radioSelectColumnWidth", () => $97ec0edab3d93beb$export$c34ad8e09b312cd3);

var $5fc53 = parcelRequire("5fc53");
const $97ec0edab3d93beb$export$c34ad8e09b312cd3 = {
    [(0, $5fc53.RADIO_BUTTONS_CF_TYPE)]: 160
};

});

parcelRegister("jAVAE", function(module, exports) {

$parcel$export(module.exports, "resolutionColumnWidth", () => $14dc170c77505262$export$a759c5e7f31f10ca);

var $5fc53 = parcelRequire("5fc53");
const $14dc170c77505262$export$a759c5e7f31f10ca = {
    [(0, $5fc53.RESOLUTION_TYPE)]: 160
};

});

parcelRegister("1B2ke", function(module, exports) {

$parcel$export(module.exports, "teamColumnWidth", () => $c7cd699e434b0d38$export$1f7dab61cbeaeb04);

var $5fc53 = parcelRequire("5fc53");
const $c7cd699e434b0d38$export$1f7dab61cbeaeb04 = {
    [(0, $5fc53.TEAMS_PLATFORM_CF_TYPE)]: 160
};

});

parcelRegister("UXtnp", function(module, exports) {

$parcel$export(module.exports, "versionColumnWidth", () => $b29d1cd1f93af855$export$99cf8efcc69bcfe1);

var $5fc53 = parcelRequire("5fc53");
const $b29d1cd1f93af855$export$99cf8efcc69bcfe1 = {
    [(0, $5fc53.VERSION_CF_TYPE)]: 160,
    [(0, $5fc53.MULTI_VERSION_CF_TYPE)]: 160,
    [(0, $5fc53.AFFECTS_VERSIONS_TYPE)]: 160,
    [(0, $5fc53.FIX_VERSIONS_TYPE)]: 160
};

});


parcelRegister("iILDa", function(module, exports) {

$parcel$export(module.exports, "getFieldIcons", () => $7baed92d0530c851$export$df250ca2240f6516);

var $gJBT6 = parcelRequire("gJBT6");

var $dCm1o = parcelRequire("dCm1o");

var $e9eMH = parcelRequire("e9eMH");

var $bViCV = parcelRequire("bViCV");

var $662ks = parcelRequire("662ks");

var $3TWSN = parcelRequire("3TWSN");

var $bgVbd = parcelRequire("bgVbd");

var $ct5ko = parcelRequire("ct5ko");

var $iAedE = parcelRequire("iAedE");

var $jlels = parcelRequire("jlels");

var $39zTs = parcelRequire("39zTs");

var $a3Xnj = parcelRequire("a3Xnj");

var $6WNmP = parcelRequire("6WNmP");

var $6TIYL = parcelRequire("6TIYL");
const $7baed92d0530c851$export$df250ca2240f6516 = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((size)=>{
    const spacing = size === 'medium' && (0, $dCm1o.isVisualRefreshEnabled)() ? 'spacious' : 'none';
    const legacyFieldIcons = (0, $6TIYL.getLegacyFieldIcons)({
        size: size,
        spacing: spacing
    });
    return {
        ...legacyFieldIcons,
        ...(0, $6WNmP.getVersionIcons)(size, spacing),
        ...(0, $bgVbd.getParentIcon)(size, spacing),
        ...(0, $bViCV.getDevSummaryIcons)(size, spacing),
        ...(0, $a3Xnj.getTeamIcons)(size, spacing),
        ...(0, $662ks.getGoalsIcons)(size, spacing),
        ...(0, $jlels.getResolutionIcons)(size, spacing),
        ...(0, $3TWSN.getGroupIcons)(size, spacing),
        ...(0, $39zTs.getStatusCategoryIcons)(size, spacing),
        ...(0, $iAedE.getRadioSelectIcon)(size, spacing),
        ...(0, $ct5ko.getProjectIcons)(size, spacing),
        ...(0, $e9eMH.getCascadingSelectIcons)(size, spacing)
    };
});

});
parcelRegister("e9eMH", function(module, exports) {

$parcel$export(module.exports, "getCascadingSelectIcons", () => $cab199932002825c$export$a1c73b689cfdba0d);

var $5uXOq = parcelRequire("5uXOq");

var $bEjt9 = parcelRequire("bEjt9");

var $lxS2w = parcelRequire("lxS2w");

var $5fc53 = parcelRequire("5fc53");
const $cab199932002825c$export$a1c73b689cfdba0d = (size, spacing)=>({
        [(0, $5fc53.CASCADING_SELECT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bEjt9))), {
            label: "",
            color: "currentColor",
            spacing: spacing,
            LEGACY_size: size,
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($lxS2w)))
        })
    });

});
parcelRegister("lxS2w", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $faf6993318468f57$var$_react = $faf6993318468f57$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $faf6993318468f57$var$_listBulleted = $faf6993318468f57$var$_interopRequireDefault((parcelRequire("bEjt9")));
function $faf6993318468f57$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $faf6993318468f57$var$EditorBulletListIcon = (props)=>/*#__PURE__*/ $faf6993318468f57$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 8c0-.552.444-1 1-1 .552 0 1 .444 1 1 0 .552-.444 1-1 1-.552 0-1-.444-1-1m5-1h6a1 1 0 0 1 0 2h-6a1 1 0 0 1 0-2m-5 5c0-.552.444-1 1-1 .552 0 1 .444 1 1 0 .552-.444 1-1 1-.552 0-1-.444-1-1m5-1h6a1 1 0 0 1 0 2h-6a1 1 0 0 1 0-2m-5 5c0-.552.444-1 1-1 .552 0 1 .444 1 1 0 .552-.444 1-1 1-.552 0-1-.444-1-1m5-1h6a1 1 0 0 1 0 2h-6a1 1 0 0 1 0-2"/></svg>`
    }, props, {
        newIcon: $faf6993318468f57$var$_listBulleted.default
    }));
$faf6993318468f57$var$EditorBulletListIcon.displayName = 'EditorBulletListIcon';
var $faf6993318468f57$var$_default = module.exports.default = $faf6993318468f57$var$EditorBulletListIcon;

});


parcelRegister("bViCV", function(module, exports) {

$parcel$export(module.exports, "getDevSummaryIcons", () => $5eb2ab3f85f5e801$export$af7756d867a4596f);

var $5uXOq = parcelRequire("5uXOq");

var $4iPF3 = parcelRequire("4iPF3");

var $9XvX5 = parcelRequire("9XvX5");

var $5fc53 = parcelRequire("5fc53");
const $5eb2ab3f85f5e801$export$af7756d867a4596f = (size, spacing)=>({
        [(0, $5fc53.DEV_SUMMARY_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4iPF3))), {
            label: "",
            color: "currentColor",
            spacing: spacing,
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($9XvX5))),
            LEGACY_size: size
        })
    });

});
parcelRegister("4iPF3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bb7d4b05cefe88d0219507dc0673c3e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3220eab15e59539d$var$_react = $3220eab15e59539d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3220eab15e59539d$var$_baseNew = $3220eab15e59539d$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3220eab15e59539d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Branch".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3220eab15e59539d$var$BranchIcon = (props)=>/*#__PURE__*/ $3220eab15e59539d$var$_react.default.createElement($3220eab15e59539d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122V9H3.5V5.372A2.25 2.25 0 0 1 2 3.25m9.75-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.25.75a2.25 2.25 0 1 1 3 2.122v4.878a3.25 3.25 0 0 1-3.25 3.25H6.372a2.25 2.25 0 1 1 0-1.5H9.25A1.75 1.75 0 0 0 11 10.25V5.372A2.25 2.25 0 0 1 9.5 3.25M4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$3220eab15e59539d$var$BranchIcon.displayName = 'BranchIcon';
var $3220eab15e59539d$var$_default = module.exports.default = $3220eab15e59539d$var$BranchIcon;

});

parcelRegister("9XvX5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $740268c474e86b43$var$_react = $740268c474e86b43$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $740268c474e86b43$var$_branch = $740268c474e86b43$var$_interopRequireDefault((parcelRequire("4iPF3")));
function $740268c474e86b43$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $740268c474e86b43$var$BitbucketBranchesIcon = (props)=>/*#__PURE__*/ $740268c474e86b43$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M19 11c0 1.3-.8 2.4-2 2.8V15c0 2.2-1.8 4-4 4h-2.2c-.4 1.2-1.5 2-2.8 2-1.7 0-3-1.3-3-3 0-1.3.8-2.4 2-2.8V8.8C5.9 8.4 5 7.3 5 6c0-1.7 1.3-3 3-3s3 1.3 3 3c0 1.3-.8 2.4-2.1 2.8v6.4c.9.3 1.6.9 1.9 1.8H13c1.1 0 2-.9 2-2v-1.2c-1.2-.4-2-1.5-2-2.8 0-1.7 1.3-3 3-3s3 1.3 3 3M8 5c-.5 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1m8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1m-8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1"/></svg>`
    }, props, {
        newIcon: $740268c474e86b43$var$_branch.default
    }));
$740268c474e86b43$var$BitbucketBranchesIcon.displayName = 'BitbucketBranchesIcon';
var $740268c474e86b43$var$_default = module.exports.default = $740268c474e86b43$var$BitbucketBranchesIcon;

});


parcelRegister("662ks", function(module, exports) {

$parcel$export(module.exports, "getGoalsIcons", () => $2abb01abbbef961f$export$191c71adb6287036);

var $5uXOq = parcelRequire("5uXOq");

var $4iV1e = parcelRequire("4iV1e");

var $5fc53 = parcelRequire("5fc53");

var $dCm1o = parcelRequire("dCm1o");
const $2abb01abbbef961f$export$191c71adb6287036 = (size, spacing)=>({
        [(0, $5fc53.GOALS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4iV1e))), {
            label: "",
            spacing: spacing,
            LEGACY_size: size,
            color: (0, $dCm1o.isVisualRefreshEnabled)() ? 'currentColor' : "var(--ds-icon, #44546F)"
        })
    });

});

parcelRegister("3TWSN", function(module, exports) {

$parcel$export(module.exports, "getGroupIcons", () => $22c451d7b18611a5$export$4b39ade85c5051f7);

var $5uXOq = parcelRequire("5uXOq");

var $fptva = parcelRequire("fptva");

var $kFO36 = parcelRequire("kFO36");

var $5fc53 = parcelRequire("5fc53");
const $22c451d7b18611a5$export$4b39ade85c5051f7 = (size, spacing)=>({
        [(0, $5fc53.GROUP_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fptva))), {
            color: "currentColor",
            spacing: spacing,
            LEGACY_size: size,
            label: "",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($kFO36)))
        }),
        [(0, $5fc53.MULTI_GROUP_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fptva))), {
            color: "currentColor",
            spacing: spacing,
            LEGACY_size: size,
            label: "",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($kFO36)))
        })
    });

});

parcelRegister("bgVbd", function(module, exports) {

$parcel$export(module.exports, "getParentIcon", () => $ed8bbd7a9b338871$export$744c82990563f55a);

var $5uXOq = parcelRequire("5uXOq");

var $5fc53 = parcelRequire("5fc53");

var $8PbqG = parcelRequire("8PbqG");
const $ed8bbd7a9b338871$export$744c82990563f55a = ()=>({
        [(0, $5fc53.PARENT_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8PbqG.HierarchyIcon), null)
    });

});
parcelRegister("8PbqG", function(module, exports) {

$parcel$export(module.exports, "HierarchyIcon", () => $40fd4b04549e2998$export$8c3a8f220bd0db42);

var $5uXOq = parcelRequire("5uXOq");

var $7XYc4 = parcelRequire("7XYc4");

var $dCm1o = parcelRequire("dCm1o");
const $40fd4b04549e2998$var$HierarchyIconOld = ({ size: size = 24 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        cx: "4.33333",
        cy: "4.66732",
        r: "1.33333",
        stroke: "#9FADBC",
        strokeWidth: "1.33333"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        cx: "10.9998",
        cy: "11.3333",
        r: "1.33333",
        stroke: "#9FADBC",
        strokeWidth: "1.33333"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M4.3335 6V8.66667C4.3335 10.1394 5.5274 11.3333 7.00016 11.3333H9.66683",
        stroke: "#9FADBC",
        strokeWidth: "1.33333"
    }));
const $40fd4b04549e2998$var$HierarchyIconNew = ({ size: size = 24 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        cx: "4.33333",
        cy: "4.66732",
        r: "1.33333",
        stroke: "currentColor",
        strokeWidth: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        cx: "10.9998",
        cy: "11.3333",
        r: "1.33333",
        stroke: "currentColor",
        strokeWidth: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M4.3335 6V8.66667C4.3335 10.1394 5.5274 11.3333 7.00016 11.3333H9.66683",
        stroke: "currentColor",
        strokeWidth: "1"
    }));
const $40fd4b04549e2998$export$8c3a8f220bd0db42 = (0, $7XYc4.componentWithCondition)(()=>(0, $dCm1o.isVisualRefreshEnabled)(), $40fd4b04549e2998$var$HierarchyIconNew, $40fd4b04549e2998$var$HierarchyIconOld);

});


parcelRegister("ct5ko", function(module, exports) {

$parcel$export(module.exports, "getProjectIcons", () => $9104da68dce3f532$export$6db5abb9a6c7aec2);

var $5uXOq = parcelRequire("5uXOq");

var $9xuGL = parcelRequire("9xuGL");

var $bP37O = parcelRequire("bP37O");

var $5fc53 = parcelRequire("5fc53");
const $9104da68dce3f532$export$6db5abb9a6c7aec2 = (size, spacing)=>({
        [(0, $5fc53.PROJECT_PICKER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9xuGL))), {
            color: "currentColor",
            label: "",
            spacing: spacing,
            LEGACY_size: size,
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($bP37O)))
        })
    });

});

parcelRegister("iAedE", function(module, exports) {

$parcel$export(module.exports, "getRadioSelectIcon", () => $c74528cd7e4bc25a$export$c36fadaa74abd39e);

var $5uXOq = parcelRequire("5uXOq");

var $kqGQn = parcelRequire("kqGQn");

var $iQHJo = parcelRequire("iQHJo");

var $5fc53 = parcelRequire("5fc53");
const $c74528cd7e4bc25a$export$c36fadaa74abd39e = (size, spacing)=>({
        [(0, $5fc53.RADIO_BUTTONS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kqGQn))), {
            color: "currentColor",
            label: "",
            spacing: spacing,
            LEGACY_size: size,
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($iQHJo)))
        })
    });

});

parcelRegister("jlels", function(module, exports) {

$parcel$export(module.exports, "getResolutionIcons", () => $7c2789aa231c9f2d$export$e9550187a88e57a5);

var $5uXOq = parcelRequire("5uXOq");

var $bjo8S = parcelRequire("bjo8S");

var $4DXCl = parcelRequire("4DXCl");

var $5fc53 = parcelRequire("5fc53");
const $7c2789aa231c9f2d$export$e9550187a88e57a5 = (size, spacing)=>({
        [(0, $5fc53.RESOLUTION_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bjo8S))), {
            color: "currentColor",
            spacing: spacing,
            LEGACY_size: size,
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($4DXCl))),
            label: ""
        })
    });

});
parcelRegister("bjo8S", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3e71f4112aeb66b16fbd284cc49bbc6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $83c43234bc70a485$var$_react = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $83c43234bc70a485$var$_baseNew = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $83c43234bc70a485$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $83c43234bc70a485$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $83c43234bc70a485$var$_react.default.createElement($83c43234bc70a485$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m15.076 3.23-8.75 10.5a.75.75 0 0 1-1.159-.008l-4.25-5.25 1.166-.944 3.675 4.54 8.166-9.798z" clip-rule="evenodd"/>`
    }, props));
$83c43234bc70a485$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $83c43234bc70a485$var$_default = module.exports.default = $83c43234bc70a485$var$CheckMarkIcon;

});

parcelRegister("4DXCl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $36190cbd288fec69$var$_react = $36190cbd288fec69$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $36190cbd288fec69$var$_checkMark = $36190cbd288fec69$var$_interopRequireDefault((parcelRequire("bjo8S")));
function $36190cbd288fec69$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $36190cbd288fec69$var$EditorDoneIcon = (props)=>/*#__PURE__*/ $36190cbd288fec69$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
    }, props, {
        newIcon: $36190cbd288fec69$var$_checkMark.default
    }));
$36190cbd288fec69$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
var $36190cbd288fec69$var$_default = module.exports.default = $36190cbd288fec69$var$EditorDoneIcon;

});


parcelRegister("39zTs", function(module, exports) {

$parcel$export(module.exports, "getStatusCategoryIcons", () => $d864fb264f22652f$export$f263f5d2ca3dcccb);

var $5uXOq = parcelRequire("5uXOq");

var $cgRoK = parcelRequire("cgRoK");

var $1pwdH = parcelRequire("1pwdH");

var $5fc53 = parcelRequire("5fc53");
const $d864fb264f22652f$export$f263f5d2ca3dcccb = (size, spacing)=>({
        [(0, $5fc53.STATUS_CATEGORY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cgRoK))), {
            color: "currentColor",
            spacing: spacing,
            LEGACY_size: size,
            label: "",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($1pwdH)))
        })
    });

});
parcelRegister("cgRoK", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f3dcba78c5e5642b8396cd93a41d6ef1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8ef0666e0cb275e1$var$_react = $8ef0666e0cb275e1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8ef0666e0cb275e1$var$_baseNew = $8ef0666e0cb275e1$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $8ef0666e0cb275e1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Lozenge".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for inserting status lozenges in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8ef0666e0cb275e1$var$LozengeIcon = (props)=>/*#__PURE__*/ $8ef0666e0cb275e1$var$_react.default.createElement($8ef0666e0cb275e1$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V6a.5.5 0 0 0-.5-.5zm11 3.25H3v-1.5h10z" clip-rule="evenodd"/>`
    }, props));
$8ef0666e0cb275e1$var$LozengeIcon.displayName = 'LozengeIcon';
var $8ef0666e0cb275e1$var$_default = module.exports.default = $8ef0666e0cb275e1$var$LozengeIcon;

});

parcelRegister("1pwdH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $10711e7344caba74$var$_react = $10711e7344caba74$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $10711e7344caba74$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $10711e7344caba74$var$StatusIcon = (props)=>/*#__PURE__*/ $10711e7344caba74$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M4 5h16c1.105 0 2 1.045 2 2.333v9.334C22 17.955 21.105 19 20 19H4c-1.105 0-2-1.045-2-2.333V7.333C2 6.045 2.895 5 4 5m3.465 9.887h1.278L6.786 9.251H5.399l-1.957 5.636h1.183l.434-1.343h1.98zM6.02 10.423h.07l.7 2.21H5.313zm6.215 4.464c1.203 0 1.95-.625 1.95-1.613 0-.726-.544-1.289-1.29-1.344v-.07a1.22 1.22 0 0 0 1.02-1.203c0-.871-.653-1.406-1.747-1.406H9.704v5.636zm-1.352-4.734h.985c.562 0 .886.27.886.719 0 .453-.347.715-.984.715h-.887zm0 3.832v-1.601h1.024c.695 0 1.074.273 1.074.789 0 .527-.367.812-1.047.812zm6.762 1.047c1.36 0 2.352-.84 2.45-2.059h-1.15c-.112.621-.62 1.02-1.296 1.02-.89 0-1.441-.738-1.441-1.926s.55-1.922 1.437-1.922c.672 0 1.184.426 1.297 1.074h1.148c-.086-1.226-1.109-2.113-2.445-2.113-1.637 0-2.645 1.13-2.645 2.961 0 1.836 1.012 2.965 2.645 2.965"/></svg>`
    }, props));
$10711e7344caba74$var$StatusIcon.displayName = 'StatusIcon';
var $10711e7344caba74$var$_default = module.exports.default = $10711e7344caba74$var$StatusIcon;

});


parcelRegister("a3Xnj", function(module, exports) {

$parcel$export(module.exports, "getTeamIcons", () => $a56e7484244cb118$export$b7d8ffd86073bea);

var $5uXOq = parcelRequire("5uXOq");

var $c781K = parcelRequire("c781K");

var $8E9tB = parcelRequire("8E9tB");

var $5fc53 = parcelRequire("5fc53");
const $a56e7484244cb118$export$b7d8ffd86073bea = (size, spacing)=>({
        [(0, $5fc53.TEAMS_PLATFORM_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c781K))), {
            color: "currentColor",
            spacing: spacing,
            LEGACY_size: size,
            label: "",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($8E9tB)))
        })
    });

});

parcelRegister("6WNmP", function(module, exports) {

$parcel$export(module.exports, "getVersionIcons", () => $f62a45208355ca06$export$5c5f41529027464e);

var $5uXOq = parcelRequire("5uXOq");

var $2Ljwn = parcelRequire("2Ljwn");

var $jUUuf = parcelRequire("jUUuf");

var $5fc53 = parcelRequire("5fc53");
const $f62a45208355ca06$export$5c5f41529027464e = (size, spacing)=>({
        [(0, $5fc53.VERSION_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2Ljwn))), {
            color: "currentColor",
            spacing: spacing,
            LEGACY_size: size,
            label: "",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($jUUuf)))
        }),
        [(0, $5fc53.MULTI_VERSION_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2Ljwn))), {
            color: "currentColor",
            spacing: spacing,
            LEGACY_size: size,
            label: "",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($jUUuf)))
        }),
        [(0, $5fc53.AFFECTS_VERSIONS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2Ljwn))), {
            color: "currentColor",
            spacing: spacing,
            LEGACY_size: size,
            label: "",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($jUUuf)))
        }),
        [(0, $5fc53.FIX_VERSIONS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2Ljwn))), {
            color: "currentColor",
            spacing: spacing,
            LEGACY_size: size,
            label: "",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($jUUuf)))
        })
    });

});

parcelRegister("6TIYL", function(module, exports) {

$parcel$export(module.exports, "getLegacyFieldIcons", () => $c2272700869b41b5$export$eddca397cc46c15);

var $5uXOq = parcelRequire("5uXOq");

var $6L0PY = parcelRequire("6L0PY");

var $3fesp = parcelRequire("3fesp");

var $aoKYM = parcelRequire("aoKYM");

var $hyKRO = parcelRequire("hyKRO");

var $bFmnZ = parcelRequire("bFmnZ");

var $ehis8 = parcelRequire("ehis8");

var $fhbwe = parcelRequire("fhbwe");

var $jAy2o = parcelRequire("jAy2o");

var $1f9bV = parcelRequire("1f9bV");

var $izMdR = parcelRequire("izMdR");

var $fYy29 = parcelRequire("fYy29");

var $kdfZa = parcelRequire("kdfZa");

var $fptva = parcelRequire("fptva");

var $1bKdn = parcelRequire("1bKdn");

var $8mG85 = parcelRequire("8mG85");

var $iRvAI = parcelRequire("iRvAI");

var $eKl4L = parcelRequire("eKl4L");

var $kauzw = parcelRequire("kauzw");

var $cTemL = parcelRequire("cTemL");

var $6aY6N = parcelRequire("6aY6N");

var $asS9k = parcelRequire("asS9k");

var $DBbS0 = parcelRequire("DBbS0");

var $7dTJQ = parcelRequire("7dTJQ");

var $a76wv = parcelRequire("a76wv");

var $7WxSP = parcelRequire("7WxSP");

var $3kXe9 = parcelRequire("3kXe9");

var $6uqJA = parcelRequire("6uqJA");

var $lRPYt = parcelRequire("lRPYt");

var $8sgpE = parcelRequire("8sgpE");

var $cL0IW = parcelRequire("cL0IW");

var $8FAWm = parcelRequire("8FAWm");

var $aLbwz = parcelRequire("aLbwz");

var $eWXbg = parcelRequire("eWXbg");

var $h8cgU = parcelRequire("h8cgU");

var $j85Tc = parcelRequire("j85Tc");

var $5IlYG = parcelRequire("5IlYG");

var $iyo13 = parcelRequire("iyo13");

var $gKopa = parcelRequire("gKopa");

var $hORKG = parcelRequire("hORKG");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $hE5wF = parcelRequire("hE5wF");

var $5fc53 = parcelRequire("5fc53");

var $dCm1o = parcelRequire("dCm1o");
const $c2272700869b41b5$var$PriorityIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20ZM12 18.2222C15.4364 18.2222 18.2222 15.4364 18.2222 12C18.2222 8.56356 15.4364 5.77778 12 5.77778C8.56356 5.77778 5.77778 8.56356 5.77778 12C5.77778 15.4364 8.56356 18.2222 12 18.2222ZM14.1219 13.5914L14.0381 13.5174L12 11.48L9.96186 13.5174C9.64143 13.8378 9.13725 13.8625 8.78855 13.5914L8.70481 13.5174C8.38438 13.197 8.35973 12.6928 8.63086 12.3441L8.70481 12.2604L11.3715 9.5937C11.6919 9.27327 12.1961 9.24861 12.5448 9.51975L12.6285 9.5937L15.2952 12.2604C15.6423 12.6075 15.6423 13.1703 15.2952 13.5174C14.9748 13.8378 14.4706 13.8625 14.1219 13.5914Z",
        fill: "currentColor"
    }));
const $c2272700869b41b5$var$StatusIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM18.2222 12C18.2222 8.56356 15.4364 5.77778 12 5.77778C8.56356 5.77778 5.77778 8.56356 5.77778 12C5.77778 15.4364 8.56356 18.2222 12 18.2222C15.4364 18.2222 18.2222 15.4364 18.2222 12ZM15.3664 11.4518L15.2952 11.3715C15.3267 11.4029 15.3553 11.4362 15.381 11.4708C15.3969 11.4923 15.4118 11.5144 15.4257 11.5372C15.4324 11.5479 15.4386 11.5588 15.4447 11.5697C15.4544 11.5873 15.4637 11.6054 15.4723 11.6239C15.4794 11.639 15.486 11.6544 15.4922 11.6699C15.4993 11.6875 15.5057 11.7051 15.5115 11.7229C15.5158 11.7361 15.5199 11.7498 15.5237 11.7636C15.5291 11.7827 15.5337 11.802 15.5377 11.8215C15.5407 11.837 15.5434 11.8525 15.5457 11.868C15.5483 11.8849 15.5504 11.9024 15.552 11.92C15.5539 11.9416 15.555 11.9626 15.5554 11.9837C15.5555 11.9886 15.5556 11.9943 15.5556 12L15.5554 12.0172C15.555 12.0382 15.5539 12.0593 15.552 12.0802L15.5556 12C15.5556 12.0439 15.5524 12.087 15.5462 12.1292C15.5436 12.1467 15.5404 12.1648 15.5366 12.1829C15.5331 12.1999 15.5293 12.2162 15.5249 12.2323C15.521 12.2463 15.5168 12.2606 15.5122 12.2748C15.5059 12.2943 15.4989 12.3135 15.4913 12.3325C15.4855 12.3467 15.4795 12.3606 15.4731 12.3744C15.4639 12.3941 15.4539 12.4138 15.4431 12.4331C15.438 12.4423 15.4326 12.4517 15.4269 12.461C15.4135 12.4829 15.3993 12.5041 15.3843 12.5246C15.3793 12.5315 15.3743 12.5382 15.3691 12.5448C15.3528 12.5655 15.3393 12.5815 15.3252 12.597L15.2952 12.6285L12.6285 15.2952C12.2814 15.6423 11.7186 15.6423 11.3715 15.2952C11.051 14.9748 11.0264 14.4706 11.2975 14.1219L11.3715 14.0381L12.52 12.8889H9.33333C8.84241 12.8889 8.44444 12.4909 8.44444 12C8.44444 11.5468 8.78355 11.1729 9.22184 11.118L9.33333 11.1111H12.5218L11.3715 9.96187C11.051 9.64144 11.0264 9.13724 11.2975 8.78853L11.3715 8.70479C11.6919 8.38436 12.1961 8.35971 12.5448 8.63085L12.6285 8.70479L15.2977 11.374C15.3221 11.3985 15.345 11.4245 15.3664 11.4518Z",
        fill: "currentColor"
    }));
// Custom icon not from Atlaskit
const $c2272700869b41b5$var$NumberGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M7 4h10a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3zm.417 10.636h1.15V9.141H7.42L6 10.12v1.07l1.348-.93h.069v4.376zm1.923-3.85v.02h1.067v-.024c0-.506.365-.857.898-.857.503 0 .861.313.861.755 0 .357-.194.643-.967 1.397l-1.794 1.756v.803h3.964v-.955h-2.406v-.069l1.05-1.002c.953-.895 1.277-1.409 1.277-2.007 0-.944-.8-1.603-1.947-1.603-1.188 0-2.003.724-2.003 1.786zm5.811 1.466h.682c.617 0 .994.297.994.777 0 .469-.4.792-.975.792-.59 0-.983-.293-1.017-.757h-1.1c.05 1.035.88 1.713 2.106 1.713 1.253 0 2.159-.697 2.159-1.66 0-.724-.472-1.226-1.226-1.31v-.069c.613-.125 1.013-.62 1.013-1.257 0-.864-.811-1.481-1.939-1.481-1.2 0-1.972.655-2.01 1.695H14.9c.03-.476.385-.777.918-.777.537 0 .88.282.88.723 0 .45-.355.754-.876.754h-.67v.857z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $c2272700869b41b5$var$TypeIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.9299 7C10.9299 6.44772 11.3776 6 11.9299 6C12.4822 6 12.9299 6.44772 12.9299 7V10.268L15.76 8.63397C16.2383 8.35783 16.8499 8.5217 17.1261 9C17.4022 9.47829 17.2383 10.0899 16.76 10.366L13.9299 12L16.76 13.634C17.2383 13.9101 17.4022 14.5217 17.1261 15C16.8499 15.4783 16.2383 15.6422 15.76 15.366L12.9299 13.732V17C12.9299 17.5523 12.4822 18 11.9299 18C11.3776 18 10.9299 17.5523 10.9299 17V13.7321L8.09978 15.366C7.62148 15.6422 7.00989 15.4783 6.73375 15C6.45761 14.5217 6.62148 13.9101 7.09978 13.634L9.9299 12L7.09978 10.366C6.62148 10.0899 6.45761 9.47829 6.73375 9C7.00989 8.5217 7.62148 8.35783 8.09978 8.63397L10.9299 10.2679V7Z",
        fill: "currentColor"
    }));
const $c2272700869b41b5$var$KeyIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 6C9.44772 6 9 6.44772 9 7V9H7C6.44772 9 6 9.44772 6 10C6 10.5523 6.44772 11 7 11H9V13H7C6.44772 13 6 13.4477 6 14C6 14.5523 6.44772 15 7 15H9V17C9 17.5523 9.44772 18 10 18C10.5523 18 11 17.5523 11 17V15H13V17C13 17.5523 13.4477 18 14 18C14.5523 18 15 17.5523 15 17V15H17C17.5523 15 18 14.5523 18 14C18 13.4477 17.5523 13 17 13H15V11H17C17.5523 11 18 10.5523 18 10C18 9.44772 17.5523 9 17 9H15V7C15 6.44772 14.5523 6 14 6C13.4477 6 13 6.44772 13 7V9H11V7C11 6.44772 10.5523 6 10 6ZM13 13V11H11V13H13Z",
        fill: "currentColor"
    }));
const $c2272700869b41b5$var$EpicIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.5 6C17.3284 6 18 6.67157 18 7.5V16.5C18 17.3284 17.3284 18 16.5 18H7.5C6.67157 18 6 17.3284 6 16.5V7.5C6 6.67157 6.67157 6 7.5 6H16.5ZM12.375 8.25C12.2625 8.25 12.165 8.30175 12.096 8.37975L9.11175 12.1088C9.1095 12.111 9.08475 12.1425 9.08475 12.1425C9.03525 12.2092 9 12.2865 9 12.375C9 12.582 9.168 12.75 9.375 12.75C9.396 12.75 9.41325 12.7537 9.43275 12.75H11.25V15.375C11.25 15.582 11.418 15.75 11.625 15.75C11.718 15.75 11.8005 15.7125 11.8658 15.657C11.8658 15.657 11.9123 15.6068 11.9295 15.582L14.88 11.8972C14.8943 11.8837 14.9033 11.868 14.9153 11.8522L14.9355 11.8275C14.9722 11.7667 15 11.7 15 11.625C15 11.418 14.832 11.25 14.625 11.25H12.75V8.625C12.75 8.418 12.582 8.25 12.375 8.25Z",
        fill: "currentColor"
    }));
const $c2272700869b41b5$var$renderChevronDownIcon = ({ size: size })=>(0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $c2272700869b41b5$var$iconSpacing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hORKG))), {
        label: "",
        color: "var(--ds-icon, #44546F)"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hORKG))), {
        LEGACY_size: size,
        color: "currentColor",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($asS9k))),
        label: ""
    });
const $c2272700869b41b5$export$eddca397cc46c15 = ({ size: size, spacing: spacing })=>({
        key: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c2272700869b41b5$var$KeyIcon, null),
        [(0, $5fc53.ISSUE_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c2272700869b41b5$var$TypeIcon, null),
        [(0, $5fc53.SUMMARY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6L0PY))), {
            color: "currentColor",
            spacing: spacing,
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($a76wv))),
            LEGACY_size: size,
            label: ""
        }),
        [(0, $5fc53.STATUS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c2272700869b41b5$var$StatusIcon, null),
        [(0, $5fc53.ASSIGNEE_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($izMdR))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($3kXe9))),
            spacing: spacing,
            LEGACY_size: size,
            label: ""
        }),
        [(0, $5fc53.LABELS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eKl4L))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($cL0IW))),
            spacing: spacing,
            LEGACY_size: size,
            label: ""
        }),
        [(0, $5fc53.DUE_DATE_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3fesp))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($cTemL))),
            spacing: spacing,
            LEGACY_size: size,
            label: ""
        }),
        [(0, $5fc53.CREATED)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3fesp))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($cTemL))),
            spacing: spacing,
            LEGACY_size: size,
            label: ""
        }),
        [(0, $5fc53.UPDATED)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3fesp))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($cTemL))),
            spacing: spacing,
            LEGACY_size: size,
            label: ""
        }),
        [(0, $5fc53.RESOLUTION_DATE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3fesp))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($cTemL))),
            spacing: spacing,
            LEGACY_size: size,
            label: ""
        }),
        [(0, $5fc53.PRIORITY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c2272700869b41b5$var$PriorityIcon, null),
        [(0, $5fc53.REPORTER_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($izMdR))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($3kXe9))),
            spacing: spacing,
            LEGACY_size: size,
            label: ""
        }),
        [(0, $5fc53.TEXT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kauzw))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($lRPYt))),
            spacing: spacing,
            LEGACY_size: size,
            label: ""
        }),
        [(0, $5fc53.URL_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1f9bV))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($7WxSP))),
            spacing: spacing,
            LEGACY_size: size,
            label: ""
        }),
        [(0, $5fc53.USER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bKdn))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($j85Tc))),
            spacing: spacing,
            LEGACY_size: size,
            label: ""
        }),
        [(0, $5fc53.TEXT_AREA_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6L0PY))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($a76wv))),
            spacing: spacing,
            LEGACY_size: size,
            label: ""
        }),
        [(0, $5fc53.SELECT_CF_TYPE)]: $c2272700869b41b5$var$renderChevronDownIcon({
            size: size
        }),
        [(0, $5fc53.MULTI_SELECT_CF_TYPE)]: $c2272700869b41b5$var$renderChevronDownIcon({
            size: size
        }),
        [(0, $5fc53.DATE_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3fesp))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($cTemL))),
            spacing: spacing,
            LEGACY_size: size,
            label: ""
        }),
        [(0, $5fc53.NUMBER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c2272700869b41b5$var$NumberGlyph, null),
        [(0, $5fc53.TIME_ESTIMATE_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hyKRO))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($6uqJA))),
            spacing: spacing,
            LEGACY_size: size,
            label: ""
        }),
        [(0, $5fc53.MULTI_USER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fptva))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($h8cgU))),
            spacing: spacing,
            LEGACY_size: size,
            label: ""
        }),
        [(0, $5fc53.DATETIME_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hyKRO))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($5IlYG))),
            spacing: spacing,
            LEGACY_size: size,
            label: ""
        }),
        [(0, $5fc53.COMPONENTS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ehis8))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($7dTJQ))),
            spacing: spacing,
            LEGACY_size: size,
            label: ""
        }),
        [(0, $5fc53.STORY_POINTS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c2272700869b41b5$var$NumberGlyph, null),
        [(0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c2272700869b41b5$var$NumberGlyph, null),
        [(0, $5fc53.LABELS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eKl4L))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($cL0IW))),
            spacing: spacing,
            LEGACY_size: size,
            label: ""
        }),
        [(0, $5fc53.PEOPLE_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fptva))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($h8cgU))),
            spacing: spacing,
            LEGACY_size: size,
            label: ""
        }),
        [(0, $5fc53.SUBTASKS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iRvAI))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($gKopa))),
            spacing: spacing,
            LEGACY_size: size,
            label: ""
        }),
        [(0, $5fc53.CATEGORY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fYy29))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($aLbwz))),
            spacing: spacing,
            LEGACY_size: size,
            label: ""
        }),
        [(0, $5fc53.EPIC_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c2272700869b41b5$var$EpicIcon, null),
        [(0, $5fc53.COMMENT_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bFmnZ))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($DBbS0))),
            spacing: spacing,
            LEGACY_size: size,
            label: ""
        }),
        [(0, $hE5wF.COMMENT_SUMMARY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bFmnZ))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($DBbS0))),
            spacing: spacing,
            LEGACY_size: size,
            label: ""
        }),
        [(0, $5fc53.MULTI_CHECKBOXES_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aoKYM))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($6aY6N))),
            spacing: spacing,
            LEGACY_size: size,
            label: ""
        }),
        [(0, $5fc53.SPRINT_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8mG85))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($iyo13))),
            spacing: spacing,
            LEGACY_size: size,
            label: ""
        }),
        [(0, $hE5wF.REMOTE_ISSUE_LINKS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kdfZa))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($eWXbg))),
            spacing: spacing,
            LEGACY_size: size,
            label: ""
        }),
        [(0, $5fc53.ISSUE_LINKS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jAy2o))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($8sgpE))),
            spacing: spacing,
            LEGACY_size: size,
            label: ""
        }),
        [(0, $hE5wF.CARD_COVERS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fhbwe))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($8FAWm))),
            spacing: spacing,
            LEGACY_size: size,
            label: ""
        })
    });
const $c2272700869b41b5$var$iconSpacing = (0, $8CUq3.xcss)({
    margin: 'space.075',
    marginTop: 'space.050'
});

});
parcelRegister("6L0PY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8c17960d483820ffdc74817869db42b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4eb7c81f940e2211$var$_react = $4eb7c81f940e2211$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $4eb7c81f940e2211$var$_baseNew = $4eb7c81f940e2211$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $4eb7c81f940e2211$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignTextLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: align text left, align content left, summary.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4eb7c81f940e2211$var$AlignTextLeftIcon = (props)=>/*#__PURE__*/ $4eb7c81f940e2211$var$_react.default.createElement($4eb7c81f940e2211$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm0 5.25H1v-1.5h14zM8 14H1v-1.5h7z" clip-rule="evenodd"/>`
    }, props));
$4eb7c81f940e2211$var$AlignTextLeftIcon.displayName = 'AlignTextLeftIcon';
var $4eb7c81f940e2211$var$_default = module.exports.default = $4eb7c81f940e2211$var$AlignTextLeftIcon;

});

parcelRegister("3fesp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43a4f9fcd22489798c1322bda48936cf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25cdfcb8bb836404$var$_react = $25cdfcb8bb836404$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $25cdfcb8bb836404$var$_baseNew = $25cdfcb8bb836404$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $25cdfcb8bb836404$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $25cdfcb8bb836404$var$CalendarIcon = (props)=>/*#__PURE__*/ $25cdfcb8bb836404$var$_react.default.createElement($25cdfcb8bb836404$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.5 2.5v2H6v-2h4v2h1.5v-2H13a.5.5 0 0 1 .5.5v3h-11V3a.5.5 0 0 1 .5-.5zm-2 5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5zm9-6.5H13a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1.5V0H6v1h4V0h1.5z" clip-rule="evenodd"/>`
    }, props));
$25cdfcb8bb836404$var$CalendarIcon.displayName = 'CalendarIcon';
var $25cdfcb8bb836404$var$_default = module.exports.default = $25cdfcb8bb836404$var$CalendarIcon;

});

parcelRegister("bFmnZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::451c857042316b193f6451d1ac5153c9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $87e4e36d6c115ce9$var$_react = $87e4e36d6c115ce9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $87e4e36d6c115ce9$var$_baseNew = $87e4e36d6c115ce9$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $87e4e36d6c115ce9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Comment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $87e4e36d6c115ce9$var$CommentIcon = (props)=>/*#__PURE__*/ $87e4e36d6c115ce9$var$_react.default.createElement($87e4e36d6c115ce9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125v8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25zM2.625 2C2.004 2 1.5 2.504 1.5 3.125v10.833L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125v-8.25C14.5 2.504 13.996 2 13.375 2zM12 6.5H4V5h8zm-3 3H4V8h5z" clip-rule="evenodd"/>`
    }, props));
$87e4e36d6c115ce9$var$CommentIcon.displayName = 'CommentIcon';
var $87e4e36d6c115ce9$var$_default = module.exports.default = $87e4e36d6c115ce9$var$CommentIcon;

});

parcelRegister("ehis8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b85e957a451f01111d5005fe7bfa754b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a650f78d49c8cbb1$var$_react = $a650f78d49c8cbb1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a650f78d49c8cbb1$var$_baseNew = $a650f78d49c8cbb1$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $a650f78d49c8cbb1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Component".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for components in Jira and Compass.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a650f78d49c8cbb1$var$ComponentIcon = (props)=>/*#__PURE__*/ $a650f78d49c8cbb1$var$_react.default.createElement($a650f78d49c8cbb1$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.75A.75.75 0 0 1 2.75 2h3.5a.75.75 0 0 1 .75.75V4.5h2V2.75A.75.75 0 0 1 9.75 2h3.5a.75.75 0 0 1 .75.75V4.5a2 2 0 0 1 2 2V12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6.5a2 2 0 0 1 2-2zM3.5 4.5h2v-1h-2zm9 0v-1h-2v1zM2 6a.5.5 0 0 0-.5.5V12a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V6.5A.5.5 0 0 0 14 6z" clip-rule="evenodd"/>`
    }, props));
$a650f78d49c8cbb1$var$ComponentIcon.displayName = 'ComponentIcon';
var $a650f78d49c8cbb1$var$_default = module.exports.default = $a650f78d49c8cbb1$var$ComponentIcon;

});

parcelRegister("fhbwe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::92d4dfc113a3924af0f8a9fba22d539c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b1f160f6235a0c00$var$_react = $b1f160f6235a0c00$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b1f160f6235a0c00$var$_baseNew = $b1f160f6235a0c00$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $b1f160f6235a0c00$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Image".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: images, image upload.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b1f160f6235a0c00$var$ImageIcon = (props)=>/*#__PURE__*/ $b1f160f6235a0c00$var$_react.default.createElement($b1f160f6235a0c00$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.75 4a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5"/><path fill="currentcolor" fill-rule="evenodd" d="M13 1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zM3 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h.644l6.274-7.723.053-.058a.75.75 0 0 1 1.06 0L13.5 8.19V3a.5.5 0 0 0-.5-.5zm2.575 11H13a.5.5 0 0 0 .5-.5v-2.69l-2.943-2.943z" clip-rule="evenodd"/>`
    }, props));
$b1f160f6235a0c00$var$ImageIcon.displayName = 'ImageIcon';
var $b1f160f6235a0c00$var$_default = module.exports.default = $b1f160f6235a0c00$var$ImageIcon;

});

parcelRegister("1f9bV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7acdc4638dae9667d9917d02594abf75>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0e7e525cdad15340$var$_react = $0e7e525cdad15340$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0e7e525cdad15340$var$_baseNew = $0e7e525cdad15340$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $0e7e525cdad15340$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0e7e525cdad15340$var$LinkIcon = (props)=>/*#__PURE__*/ $0e7e525cdad15340$var$_react.default.createElement($0e7e525cdad15340$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.22 2.22a3.932 3.932 0 1 1 5.56 5.56l-2.25 2.25-1.06-1.06 2.25-2.25a2.432 2.432 0 0 0-3.44-3.44L7.03 5.53 5.97 4.47zm3.06 3.56-5.5 5.5-1.06-1.06 5.5-5.5zM2.22 8.22l2.25-2.25 1.06 1.06-2.25 2.25a2.432 2.432 0 0 0 3.44 3.44l2.25-2.25 1.06 1.06-2.25 2.25a3.932 3.932 0 1 1-5.56-5.56" clip-rule="evenodd"/>`
    }, props));
$0e7e525cdad15340$var$LinkIcon.displayName = 'LinkIcon';
var $0e7e525cdad15340$var$_default = module.exports.default = $0e7e525cdad15340$var$LinkIcon;

});

parcelRegister("izMdR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a1b019ad514d335985b9dfdb2c8fe134>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d860e6e53b6f4f6d$var$_react = $d860e6e53b6f4f6d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d860e6e53b6f4f6d$var$_baseNew = $d860e6e53b6f4f6d$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $d860e6e53b6f4f6d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Mention".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for user mentions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d860e6e53b6f4f6d$var$MentionIcon = (props)=>/*#__PURE__*/ $d860e6e53b6f4f6d$var$_react.default.createElement($d860e6e53b6f4f6d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 3.25 12.13l.75 1.3A8 8 0 1 1 16 8c0 .842-.28 1.775-.817 2.513-.547.751-1.401 1.344-2.522 1.344-.577 0-1.07-.177-1.462-.507a2.5 2.5 0 0 1-.66-.908C9.387 11.776 7.529 12.346 6 11.464 4.229 10.441 3.926 8.057 4.969 6.25S8.229 3.513 10 4.536c1.12.647 1.66 1.87 1.633 3.105l-.005.13c0 .687.038 1.397.226 1.923.091.255.201.415.313.51.098.083.242.153.494.153.536 0 .976-.27 1.31-.727.342-.47.529-1.091.529-1.63A6.5 6.5 0 0 0 8 1.5m2.133 6.102c.015-.798-.328-1.447-.883-1.767C8.39 5.339 7.02 5.698 6.268 7s-.377 2.67.482 3.165c.86.496 2.23.137 2.982-1.165.244-.422.37-.866.397-1.287z" clip-rule="evenodd"/>`
    }, props));
$d860e6e53b6f4f6d$var$MentionIcon.displayName = 'MentionIcon';
var $d860e6e53b6f4f6d$var$_default = module.exports.default = $d860e6e53b6f4f6d$var$MentionIcon;

});

parcelRegister("8mG85", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3028194b67909de4178ae7b995e8e7b7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $61710ed7f2aa84a3$var$_react = $61710ed7f2aa84a3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $61710ed7f2aa84a3$var$_baseNew = $61710ed7f2aa84a3$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $61710ed7f2aa84a3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Sprint".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sprints in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $61710ed7f2aa84a3$var$SprintIcon = (props)=>/*#__PURE__*/ $61710ed7f2aa84a3$var$_react.default.createElement($61710ed7f2aa84a3$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A4.75 4.75 0 0 0 8 11h5.44l-2.22-2.22 1.06-1.06 3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5-1.06-1.06 2.22-2.22H0V11h3.938A6.25 6.25 0 1 1 14.25 6.25h-1.5A4.75 4.75 0 0 0 8 1.5" clip-rule="evenodd"/>`
    }, props));
$61710ed7f2aa84a3$var$SprintIcon.displayName = 'SprintIcon';
var $61710ed7f2aa84a3$var$_default = module.exports.default = $61710ed7f2aa84a3$var$SprintIcon;

});

parcelRegister("iRvAI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cb1eed99abd44e812ae4cb98f136c93f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dbb5ae8ec700c853$var$_react = $dbb5ae8ec700c853$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $dbb5ae8ec700c853$var$_baseNew = $dbb5ae8ec700c853$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $dbb5ae8ec700c853$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Subtasks".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for subtask work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dbb5ae8ec700c853$var$SubtasksIcon = (props)=>/*#__PURE__*/ $dbb5ae8ec700c853$var$_react.default.createElement($dbb5ae8ec700c853$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 9.25a.5.5 0 0 0-.5-.5H8.75V13a.5.5 0 0 0 .5.5H13a.5.5 0 0 0 .5-.5zM7.25 3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v3.75a.5.5 0 0 0 .5.5h4.25zm1.5 4.25H13a2 2 0 0 1 2 2V13a2 2 0 0 1-2 2H9.25a2 2 0 0 1-2-2V8.75H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h3.75a2 2 0 0 1 2 2z"/>`
    }, props));
$dbb5ae8ec700c853$var$SubtasksIcon.displayName = 'SubtasksIcon';
var $dbb5ae8ec700c853$var$_default = module.exports.default = $dbb5ae8ec700c853$var$SubtasksIcon;

});

parcelRegister("kauzw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::79f720bc74e9099bd9cc2a24f95932ca>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eaec74c566e8a5e8$var$_react = $eaec74c566e8a5e8$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $eaec74c566e8a5e8$var$_baseNew = $eaec74c566e8a5e8$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $eaec74c566e8a5e8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextStyle".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for text styles in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eaec74c566e8a5e8$var$TextStyleIcon = (props)=>/*#__PURE__*/ $eaec74c566e8a5e8$var$_react.default.createElement($eaec74c566e8a5e8$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.799.484A.75.75 0 0 1 7.5 0h1.018a.75.75 0 0 1 .701.485l3.733 9.875a.8.8 0 0 1 .048.265V11h-1.5v-.238L10.456 8H5.55L4.5 10.763V11H3v-.375a.8.8 0 0 1 .049-.266zM6.119 6.5h3.77L8.01 1.524z" clip-rule="evenodd"/>`
    }, props));
$eaec74c566e8a5e8$var$TextStyleIcon.displayName = 'TextStyleIcon';
var $eaec74c566e8a5e8$var$_default = module.exports.default = $eaec74c566e8a5e8$var$TextStyleIcon;

});

parcelRegister("cTemL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9625c3edd02eaf26$var$_react = $9625c3edd02eaf26$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $9625c3edd02eaf26$var$_calendar = $9625c3edd02eaf26$var$_interopRequireDefault((parcelRequire("3fesp")));
function $9625c3edd02eaf26$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9625c3edd02eaf26$var$CalendarIcon = (props)=>/*#__PURE__*/ $9625c3edd02eaf26$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.006V6.994C3 5.893 3.892 5 4.995 5M5 9v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9zm1-5a1 1 0 0 1 2 0v1H6zm10 0a1 1 0 0 1 2 0v1h-2zm-9 9v-2.001h2V13zm8 0v-2.001h2V13zm-4 0v-2.001h2.001V13zm-4 4v-2h2v2zm4 0v-2h2.001v2zm4 0v-2h2v2z"/></svg>`
    }, props, {
        newIcon: $9625c3edd02eaf26$var$_calendar.default
    }));
$9625c3edd02eaf26$var$CalendarIcon.displayName = 'CalendarIcon';
var $9625c3edd02eaf26$var$_default = module.exports.default = $9625c3edd02eaf26$var$CalendarIcon;

});

parcelRegister("asS9k", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $79e685e2724d7fad$var$_react = $79e685e2724d7fad$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $79e685e2724d7fad$var$_chevronDown = $79e685e2724d7fad$var$_interopRequireDefault((parcelRequire("iy9RA")));
function $79e685e2724d7fad$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $79e685e2724d7fad$var$ChevronDownCircleIcon = (props)=>/*#__PURE__*/ $79e685e2724d7fad$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M8.292 10.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0"/></g></svg>`
    }, props, {
        newIcon: $79e685e2724d7fad$var$_chevronDown.default
    }));
$79e685e2724d7fad$var$ChevronDownCircleIcon.displayName = 'ChevronDownCircleIcon';
var $79e685e2724d7fad$var$_default = module.exports.default = $79e685e2724d7fad$var$ChevronDownCircleIcon;

});

parcelRegister("DBbS0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $07707de1f3ce8a8c$var$_react = $07707de1f3ce8a8c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $07707de1f3ce8a8c$var$_comment = $07707de1f3ce8a8c$var$_interopRequireDefault((parcelRequire("bFmnZ")));
function $07707de1f3ce8a8c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $07707de1f3ce8a8c$var$CommentIcon = (props)=>/*#__PURE__*/ $07707de1f3ce8a8c$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M4.998 11.513c0-3.038 3.141-5.51 7.002-5.51s7.002 2.472 7.002 5.51c0 3.039-3.141 5.51-7.002 5.51s-7.002-2.471-7.002-5.51m14.84 7.771v-.001s-1.564-2.26-.767-3.116l-.037.02C20.261 14.902 21 13.279 21 11.513 21 7.371 16.963 4 12 4s-9 3.37-9 7.513 4.037 7.514 9 7.514c1.42 0 2.76-.285 3.957-.776 1.003 1.022 2.287 1.572 3.24 1.719l.002-.003a.5.5 0 0 0 .164.033.515.515 0 0 0 .474-.716"/><rect width="10" height="2" x="7" y="9" rx="1"/><rect width="5" height="2" x="7" y="12" rx="1"/></g></svg>`
    }, props, {
        newIcon: $07707de1f3ce8a8c$var$_comment.default
    }));
$07707de1f3ce8a8c$var$CommentIcon.displayName = 'CommentIcon';
var $07707de1f3ce8a8c$var$_default = module.exports.default = $07707de1f3ce8a8c$var$CommentIcon;

});

parcelRegister("7dTJQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5424fbcfeb6a920c$var$_react = $5424fbcfeb6a920c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $5424fbcfeb6a920c$var$_component = $5424fbcfeb6a920c$var$_interopRequireDefault((parcelRequire("ehis8")));
function $5424fbcfeb6a920c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5424fbcfeb6a920c$var$ComponentIcon = (props)=>/*#__PURE__*/ $5424fbcfeb6a920c$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M5 17.991c0 .007 14.005.009 14.005.009-.006 0-.005-7.991-.005-7.991C19 10.002 4.995 10 4.995 10 5.001 10 5 17.991 5 17.991M3 10.01C3 8.899 3.893 8 4.995 8h14.01C20.107 8 21 8.902 21 10.009v7.982c0 1.11-.893 2.009-1.995 2.009H4.995A2.004 2.004 0 0 1 3 17.991z"/><path d="M7 8.34h2V6.67H7zM5 6.67C5 5.75 5.9 5 7 5h2c1.11 0 2 .75 2 1.67v1.67c0 .92-.9 1.66-2 1.66H7c-1.11 0-2-.75-2-1.66zm10 1.67h2V6.67h-2zm-2-1.67c0-.92.9-1.67 2-1.67h2c1.11 0 2 .75 2 1.67v1.67c0 .92-.9 1.67-2 1.67h-2c-1.11-.01-2-.76-2-1.67z"/></g></svg>`
    }, props, {
        newIcon: $5424fbcfeb6a920c$var$_component.default
    }));
$5424fbcfeb6a920c$var$ComponentIcon.displayName = 'ComponentIcon';
var $5424fbcfeb6a920c$var$_default = module.exports.default = $5424fbcfeb6a920c$var$ComponentIcon;

});

parcelRegister("a76wv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $75cf9e3d9f96735a$var$_react = $75cf9e3d9f96735a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $75cf9e3d9f96735a$var$_alignTextLeft = $75cf9e3d9f96735a$var$_interopRequireDefault((parcelRequire("6L0PY")));
function $75cf9e3d9f96735a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $75cf9e3d9f96735a$var$EditorAlignLeftIcon = (props)=>/*#__PURE__*/ $75cf9e3d9f96735a$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7 7h10a1 1 0 0 1 0 2H7a1 1 0 1 1 0-2m0 4h10a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2m0 4h5a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2"/></svg>`
    }, props, {
        newIcon: $75cf9e3d9f96735a$var$_alignTextLeft.default
    }));
$75cf9e3d9f96735a$var$EditorAlignLeftIcon.displayName = 'EditorAlignLeftIcon';
var $75cf9e3d9f96735a$var$_default = module.exports.default = $75cf9e3d9f96735a$var$EditorAlignLeftIcon;

});

parcelRegister("7WxSP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5c883bb6fff27f31$var$_react = $5c883bb6fff27f31$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $5c883bb6fff27f31$var$_link = $5c883bb6fff27f31$var$_interopRequireDefault((parcelRequire("1f9bV")));
function $5c883bb6fff27f31$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5c883bb6fff27f31$var$EditorLinkIcon = (props)=>/*#__PURE__*/ $5c883bb6fff27f31$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12.654 8.764a.858.858 0 0 1-1.213-1.213l1.214-1.214a3.717 3.717 0 0 1 5.257 0 3.714 3.714 0 0 1 .001 5.258l-1.214 1.214-.804.804a3.72 3.72 0 0 1-5.263.005.858.858 0 0 1 1.214-1.214c.781.782 2.05.78 2.836-.005l.804-.803 1.214-1.214a2 2 0 0 0-.001-2.831 2 2 0 0 0-2.83 0zm-.808 6.472a.858.858 0 0 1 1.213 1.213l-1.214 1.214a3.717 3.717 0 0 1-5.257 0 3.714 3.714 0 0 1-.001-5.258l1.214-1.214.804-.804a3.72 3.72 0 0 1 5.263-.005.858.858 0 0 1-1.214 1.214 2.005 2.005 0 0 0-2.836.005l-.804.803L7.8 13.618a2 2 0 0 0 .001 2.831 2 2 0 0 0 2.83 0z"/></svg>`
    }, props, {
        newIcon: $5c883bb6fff27f31$var$_link.default
    }));
$5c883bb6fff27f31$var$EditorLinkIcon.displayName = 'EditorLinkIcon';
var $5c883bb6fff27f31$var$_default = module.exports.default = $5c883bb6fff27f31$var$EditorLinkIcon;

});

parcelRegister("3kXe9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $26e12eaafd006aef$var$_react = $26e12eaafd006aef$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $26e12eaafd006aef$var$_mention = $26e12eaafd006aef$var$_interopRequireDefault((parcelRequire("izMdR")));
function $26e12eaafd006aef$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $26e12eaafd006aef$var$EditorMentionIcon = (props)=>/*#__PURE__*/ $26e12eaafd006aef$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12.062 13.93c-.904 0-1.451-.734-1.451-1.945 0-1.226.538-1.952 1.467-1.952.928 0 1.422.764 1.422 1.967 0 1.195-.502 1.93-1.438 1.93M12 5c-3.925 0-7 3.075-7 7 0 4.596 3.521 7 7 7 .874 0 1.613-.09 2.258-.279a.751.751 0 0 0-.42-1.44c-.506.147-1.108.22-1.838.22-2.649 0-5.5-1.722-5.5-5.5 0-3.085 2.415-5.5 5.5-5.5 3.239 0 5.5 1.952 5.5 4.75 0 2.045-1.044 3-1.75 3-.007 0-.75-.11-.75-.75v-4a.75.75 0 1 0-1.5 0v.187c-.347-.585-1.017-.952-1.796-.952C10.103 8.736 9 10.04 9 11.938c0 1.984 1.103 3.312 2.753 3.312.865 0 1.51-.387 1.865-1.076.334 1.016 1.37 1.576 2.132 1.576 1.598 0 3.25-1.683 3.25-4.5C19 7.628 16.058 5 12 5"/></svg>`
    }, props, {
        newIcon: $26e12eaafd006aef$var$_mention.default
    }));
$26e12eaafd006aef$var$EditorMentionIcon.displayName = 'EditorMentionIcon';
var $26e12eaafd006aef$var$_default = module.exports.default = $26e12eaafd006aef$var$EditorMentionIcon;

});

parcelRegister("6uqJA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4b9a484973717fe2$var$_react = $4b9a484973717fe2$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $4b9a484973717fe2$var$_clock = $4b9a484973717fe2$var$_interopRequireDefault((parcelRequire("hyKRO")));
function $4b9a484973717fe2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4b9a484973717fe2$var$EmojiFrequentIcon = (props)=>/*#__PURE__*/ $4b9a484973717fe2$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 4c-4.412 0-8 3.588-8 8s3.588 8 8 8 8-3.588 8-8-3.588-8-8-8m0 14.222A6.23 6.23 0 0 1 5.778 12 6.23 6.23 0 0 1 12 5.778 6.23 6.23 0 0 1 18.222 12 6.23 6.23 0 0 1 12 18.222m.889-6.59V8.448c0-.489-.4-.889-.889-.889s-.889.4-.889.89v3.555c0 .248.103.471.268.633l2.195 2.194a.89.89 0 0 0 1.257 0 .89.89 0 0 0 0-1.256z"/></svg>`
    }, props, {
        newIcon: $4b9a484973717fe2$var$_clock.default
    }));
$4b9a484973717fe2$var$EmojiFrequentIcon.displayName = 'EmojiFrequentIcon';
var $4b9a484973717fe2$var$_default = module.exports.default = $4b9a484973717fe2$var$EmojiFrequentIcon;

});

parcelRegister("lRPYt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $feb6dd38b103e72a$var$_react = $feb6dd38b103e72a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $feb6dd38b103e72a$var$_textStyle = $feb6dd38b103e72a$var$_interopRequireDefault((parcelRequire("kauzw")));
function $feb6dd38b103e72a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $feb6dd38b103e72a$var$EmojiKeyboardIcon = (props)=>/*#__PURE__*/ $feb6dd38b103e72a$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m5.84 6.95-3.82 9.97a.5.5 0 0 0 .47.68H3.7a.5.5 0 0 0 .47-.33l.68-1.88a.5.5 0 0 1 .47-.33h3.8a.5.5 0 0 1 .47.33l.68 1.88a.5.5 0 0 0 .47.33h1.27a.5.5 0 0 0 .47-.68L8.69 6.95a.7.7 0 0 0-.66-.45H6.49a.7.7 0 0 0-.65.45m1.57 2.46 1.25 3.41a.2.2 0 0 1-.19.27h-2.5a.2.2 0 0 1-.19-.27l1.25-3.41a.2.2 0 0 1 .38 0m10.14 6.46c1.22 0 2.14-1.01 2.14-2.6s-.9-2.53-2.14-2.53c-1.26 0-2.18.94-2.18 2.53 0 1.58.9 2.6 2.18 2.6m2.16.6c-.37.83-1.28 1.43-2.44 1.43-2.57 0-4.27-2-4.27-4.64 0-2.55 1.66-4.57 4.2-4.57 1.56 0 2.28.83 2.5 1.33v-.34c0-.25.01-.39.21-.58q.21-.18.62-.16h.76a.58.58 0 0 1 .5.17c.21.2.19.42.19.58v6.39q0 .34.02.9 0 .29-.12.43a.63.63 0 0 1-.51.24h-.93c-.19 0-.45-.08-.53-.18s-.16-.23-.18-.53a6 6 0 0 1-.01-.36z"/></svg>`
    }, props, {
        newIcon: $feb6dd38b103e72a$var$_textStyle.default
    }));
$feb6dd38b103e72a$var$EmojiKeyboardIcon.displayName = 'EmojiKeyboardIcon';
var $feb6dd38b103e72a$var$_default = module.exports.default = $feb6dd38b103e72a$var$EmojiKeyboardIcon;

});

parcelRegister("8FAWm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $64fecea1e5bea51d$var$_react = $64fecea1e5bea51d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $64fecea1e5bea51d$var$_image = $64fecea1e5bea51d$var$_interopRequireDefault((parcelRequire("fhbwe")));
function $64fecea1e5bea51d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $64fecea1e5bea51d$var$MediaServicesScaleLargeIcon = (props)=>/*#__PURE__*/ $64fecea1e5bea51d$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 6.007v11.986C5 18.55 5.45 19 6.007 19h11.986C18.55 19 19 18.55 19 17.993V6.007C19 5.45 18.55 5 17.993 5H6.007C5.45 5 5 5.45 5 6.007m-2 0A3.006 3.006 0 0 1 6.007 3h11.986A3.006 3.006 0 0 1 21 6.007v11.986A3.006 3.006 0 0 1 17.993 21H6.007A3.006 3.006 0 0 1 3 17.993z"/><path d="M11.005 17H16.5c.27 0 .5-.228.5-.509v-1.634a.73.73 0 0 0-.167-.44L14.5 11.85a.24.24 0 0 0-.344-.006L11 15l-.821-.821a.25.25 0 0 0-.358 0l-2.465 2.465c-.195.195-.136.356.135.356z"/><circle cx="9" cy="9" r="2"/></g></svg>`
    }, props, {
        newIcon: $64fecea1e5bea51d$var$_image.default
    }));
$64fecea1e5bea51d$var$MediaServicesScaleLargeIcon.displayName = 'MediaServicesScaleLargeIcon';
var $64fecea1e5bea51d$var$_default = module.exports.default = $64fecea1e5bea51d$var$MediaServicesScaleLargeIcon;

});

parcelRegister("5IlYG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $42921c21e7131d9e$var$_react = $42921c21e7131d9e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $42921c21e7131d9e$var$_clock = $42921c21e7131d9e$var$_interopRequireDefault((parcelRequire("hyKRO")));
function $42921c21e7131d9e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $42921c21e7131d9e$var$RecentIcon = (props)=>/*#__PURE__*/ $42921c21e7131d9e$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11 8.002v4.002c0 .28.116.53.301.712l2.47 2.47a1.003 1.003 0 0 0 1.414 0 1.003 1.003 0 0 0 0-1.415L13 11.586V6a1 1 0 0 0-2 0zM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10"/></svg>`
    }, props, {
        newIcon: $42921c21e7131d9e$var$_clock.default
    }));
$42921c21e7131d9e$var$RecentIcon.displayName = 'RecentIcon';
var $42921c21e7131d9e$var$_default = module.exports.default = $42921c21e7131d9e$var$RecentIcon;

});

parcelRegister("iyo13", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d81e080f0024ae1d$var$_react = $d81e080f0024ae1d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $d81e080f0024ae1d$var$_sprint = $d81e080f0024ae1d$var$_interopRequireDefault((parcelRequire("8mG85")));
function $d81e080f0024ae1d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d81e080f0024ae1d$var$SprintIcon = (props)=>/*#__PURE__*/ $d81e080f0024ae1d$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="m17.717 17.137-1.436-1.438a1.003 1.003 0 0 1 1.418-1.418l3.007 3.01a1 1 0 0 1 0 1.417l-3.007 3.01a1.003 1.003 0 0 1-1.417-1.42l1.3-1.3-6.072-.003A8 8 0 0 1 4 11.01C4 6.587 7.582 3 12 3s8 3.587 8 8.01a8 8 0 0 1-.789 3.451l-1.438-1.44a6.1 6.1 0 0 0 .345-2.01A6.12 6.12 0 0 0 12 4.884a6.12 6.12 0 0 0-6.118 6.125 6.12 6.12 0 0 0 5.647 6.102zm-12.163-.119c.561.759 1.456 1.49 2.457 1.981L3.937 19C3.42 19 3 18.552 3 18s.42-1 .937-1l1.614.005z"/></svg>`
    }, props, {
        newIcon: $d81e080f0024ae1d$var$_sprint.default
    }));
$d81e080f0024ae1d$var$SprintIcon.displayName = 'SprintIcon';
var $d81e080f0024ae1d$var$_default = module.exports.default = $d81e080f0024ae1d$var$SprintIcon;

});

parcelRegister("gKopa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c313df89ecedecba$var$_react = $c313df89ecedecba$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $c313df89ecedecba$var$_subtasks = $c313df89ecedecba$var$_interopRequireDefault((parcelRequire("iRvAI")));
function $c313df89ecedecba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c313df89ecedecba$var$SubtaskIcon = (props)=>/*#__PURE__*/ $c313df89ecedecba$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M19 7c1.105.003 2 .899 2 2.006v9.988A2.005 2.005 0 0 1 18.994 21H9.006A2.005 2.005 0 0 1 7 19h11c.555 0 1-.448 1-1zM3 5.006C3 3.898 3.897 3 5.006 3h9.988C16.102 3 17 3.897 17 5.006v9.988A2.005 2.005 0 0 1 14.994 17H5.006A2.005 2.005 0 0 1 3 14.994zM5 5v10h10V5z"/><path d="M7.707 9.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L9 10.586z"/></g></svg>`
    }, props, {
        newIcon: $c313df89ecedecba$var$_subtasks.default
    }));
$c313df89ecedecba$var$SubtaskIcon.displayName = 'SubtaskIcon';
var $c313df89ecedecba$var$_default = module.exports.default = $c313df89ecedecba$var$SubtaskIcon;

});



parcelRegister("939cg", function(module, exports) {

$parcel$export(module.exports, "useIssueViewIsVisible", () => $34fa9fb07bb53175$export$433ecf2b8511729e);

var $hE5wF = parcelRequire("hE5wF");

var $ieDtd = parcelRequire("ieDtd");
const $34fa9fb07bb53175$export$433ecf2b8511729e = ()=>{
    const [selectedIssueKey] = (0, $ieDtd.useQueryParam)((0, $hE5wF.SELECTED_ISSUE_PARAM));
    return selectedIssueKey != null;
};

});

parcelRegister("cjOYL", function(module, exports) {

$parcel$export(module.exports, "loadingCellStyles", () => $8fe3565086e02d38$export$81b1b3cccf003fa1);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $gwIPs = parcelRequire("gwIPs");
const $8fe3565086e02d38$export$81b1b3cccf003fa1 = {
    backgroundColor: "var(--ds-skeleton, #091E420F)",
    paddingleft: '1px',
    borderRadius: `${(0, $gwIPs.borderRadius)}px`,
    width: `calc(100% - ${(0, $gwIPs.gridSize) * 2}px)`,
    height: `calc(100% - ${(0, $gwIPs.gridSize) * 2}px)`,
    marginLeft: "var(--ds-space-100, 8px)"
};
const $8fe3565086e02d38$export$5191481abee8295e = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_9povrw": (0, $lD23V.default)(__cmplp.width - (0, $gwIPs.gridSize) * 2, "px"),
            "--_1z066df": (0, $lD23V.default)(__cmplp.height - (0, $gwIPs.gridSize) * 2, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _bfhkn82g _14eot94y _1bsb5cnj _4t3i5cnj _18u0u2gc",
            __cmplp.width ? "_1bsb1fse" : "_1bsb5cnj",
            __cmplp.height ? "_4t3i14kp" : "_4t3i5cnj",
            __cmplp.className
        ])
    });
});

});

parcelRegister("4HIDQ", function(module, exports) {

$parcel$export(module.exports, "useCommentsSidebar", () => $13a0c7c1170b3aa4$export$aec60bac36c8115);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $bUSNl = parcelRequire("bUSNl");

var $hE5wF = parcelRequire("hE5wF");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $ieDtd = parcelRequire("ieDtd");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $gP1aD = parcelRequire("gP1aD");
const $13a0c7c1170b3aa4$export$aec60bac36c8115 = ({ CommentsSidebar: CommentsSidebar })=>{
    const [selectedIssueKey, setSelectedIssueKey] = (0, $ieDtd.useQueryParam)((0, $hE5wF.SELECTED_COMMENT_PARAM));
    const [, { setSidebarContent: setSidebarContent }] = (0, $bUSNl.useSidebar)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { updateCommentsCache: updateCommentsCache } = (0, $6s1PB.expVal)('jira_unread_comments_in_list_view', 'isEnabled', false) ? (0, $gP1aD.useUpdateCommentsCellCache)() : {
        updateCommentsCache: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    };
    // set query param when comment cell is clicked
    const onOpen = (0, $5uXOq.useCallback)(// Remove optional on analyticsAttributes when jira_unread_comments_in_list_view experiment is cleaned up
    (issueKey, analyticAttributes)=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'commentsSidebar opened', {
            ...analyticAttributes && (0, $4R6GH.fg)('_jira_unread_comments_in_list_view_gate') ? analyticAttributes : {}
        });
        setSelectedIssueKey(issueKey);
        if ((0, $6s1PB.expVal)('jira_unread_comments_in_list_view', 'isEnabled', false)) updateCommentsCache(issueKey);
    }, [
        createAnalyticsEvent,
        setSelectedIssueKey,
        updateCommentsCache
    ]);
    // close comment sidebar on [X] button click
    const onClose = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'commentsSidebar closed');
        setSelectedIssueKey(undefined);
        setSidebarContent(null);
    }, [
        createAnalyticsEvent,
        setSelectedIssueKey,
        setSidebarContent
    ]);
    // set sidebar content after query param is set
    (0, $5uXOq.useEffect)(()=>{
        if (selectedIssueKey) {
            const newContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CommentsSidebar, {
                issueKey: selectedIssueKey,
                onClose: onClose
            });
            setSidebarContent(newContent);
        }
    }, [
        CommentsSidebar,
        onClose,
        selectedIssueKey,
        setSidebarContent
    ]);
    return {
        selectedIssueKey: selectedIssueKey,
        onOpenCommentsSidebar: onOpen,
        onCloseCommentsSidebar: onClose
    };
};

});

parcelRegister("3O2kS", function(module, exports) {

$parcel$export(module.exports, "useSystemFields", () => $a34a71fc4c701024$export$91f469581f79f11f);

var $5uXOq = parcelRequire("5uXOq");

var $hE5wF = parcelRequire("hE5wF");

var $1T2vX = parcelRequire("1T2vX");
const $a34a71fc4c701024$export$91f469581f79f11f = ()=>{
    const { data: data } = (0, $1T2vX.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const globalSystemFields = (0, $5uXOq.useMemo)(()=>{
        // if we don't have the issue types data yet, return an empty array
        if (!data || !data.fields || !data.fields.length) return [];
        const issueTypesAndFieldsData = data.fields;
        return issueTypesAndFieldsData.filter((field)=>!field.id.startsWith('customfield')).map((field)=>field.id).concat('key', (0, $hE5wF.COMMENT_SUMMARY_TYPE), (0, $hE5wF.REMOTE_ISSUE_LINKS_TYPE));
    }, [
        data
    ]);
    return {
        globalSystemFields: globalSystemFields
    };
};

});

parcelRegister("koElh", function(module, exports) {

$parcel$export(module.exports, "useJiraSettings", () => $8d4b4af78901e39c$export$5de424af876772e4);

var $5tTFS = parcelRequire("5tTFS");

var $jcw0u = parcelRequire("jcw0u");

var $4NLOw = parcelRequire("4NLOw");

var $fJJRm = parcelRequire("fJJRm");
const $8d4b4af78901e39c$export$5de424af876772e4 = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [getProjectData, { data: data, loading: loading, error: error }] = (0, $5tTFS.useLazyQuery)((0, $fJJRm.JIRA_SETTINGS_QUERY), {
        onError: (apolloError)=>{
            if (!(0, $4NLOw.shouldHandleTheError)(apolloError)) return;
            (0, $jcw0u.default)({
                meta: {
                    id: 'jiraSettingsQuery',
                    packageName: 'jiraBusinessList',
                    teamName: 'keystone'
                },
                attributes: {
                    message: 'Failed to fetch jira settings in list view'
                },
                error: apolloError,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    });
    return {
        error: error,
        loading: loading,
        data: data,
        getProjectData: getProjectData
    };
};

});
parcelRegister("fJJRm", function(module, exports) {

$parcel$export(module.exports, "JIRA_SETTINGS_QUERY", () => $4f83e50084561132$export$652ac25405e90703);

var $5cllN = parcelRequire("5cllN");
const $4f83e50084561132$export$652ac25405e90703 = (0, $5cllN.default)`
  query JiraBusinessSettings {
    jiraSettings {
      timeTracking {
        isTimeTrackingEnabled
        hoursPerDay
        daysPerWeek
        defaultUnit
        format
      }
    }
  }
`;

});


parcelRegister("99NMg", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcf1c729996b187a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $64gJA = parcelRequire("64gJA");

var $daQYX = parcelRequire("daQYX");

var $b5lmY = parcelRequire("b5lmY");

var $e0a4D = parcelRequire("e0a4D");

var $eTDjN = parcelRequire("eTDjN");

var $dSjBh = parcelRequire("dSjBh");

var $3aLMK = parcelRequire("3aLMK");

var $gvQOt = parcelRequire("gvQOt");

var $cPZte = parcelRequire("cPZte");
const $dcf1c729996b187a$var$CategoryCell = ({ isEditable: isEditable, fieldKey: fieldKey, fieldValue: fieldValue, issueKey: issueKey, width: width, fieldType: fieldType, issueTypeId: issueTypeId, wrapperRef: wrapperRef, fieldName: fieldName, editMode: editMode = false, cellRef: cellRef, issueType: issueType = '', inputValue: inputValue, onInputChange: onInputChange })=>{
    const [categoryToDeleteInModal, setCategoryToDeleteInModal] = (0, $5uXOq.useState)(null);
    const { editFieldError: editFieldError, categoryState: categoryState, createAndAssignNewCategory: createAndAssignNewCategory, checkCategoryNameAlreadyExists: checkCategoryNameAlreadyExists, updateCategory: updateCategory, deleteAndUnassignCategory: deleteAndUnassignCategory, categoryOptions: categoryOptions, assignCategoryToCell: assignCategoryToCell } = (0, $64gJA.useCategoryCellStateController)({
        fieldValue: fieldValue,
        fieldType: fieldType,
        issueKey: issueKey,
        fieldKey: fieldKey,
        issueTypeId: issueTypeId,
        createExperience: (0, $eTDjN.CREATE_CATEGORY_EXPERIENCE),
        updateExperience: (0, $eTDjN.UPDATE_CATEGORY_EXPERIENCE),
        deleteExperience: (0, $eTDjN.DELETE_CATEGORY_EXPERIENCE)
    });
    const project = (0, $daQYX.useProject)();
    const onDeleteCompleted = (0, $5uXOq.useCallback)(()=>{
        setCategoryToDeleteInModal(null);
    }, [
        setCategoryToDeleteInModal
    ]);
    // we need to sort the options so that the selected category is at the top of the list
    // as the first option is hovered by default and will be selected if `Enter` is pressed
    // immediately after the select dropdown is shown
    const sortedCategories = (0, $5uXOq.useMemo)(()=>{
        if (categoryState == null) return categoryOptions;
        const selectedCategoryIndex = categoryOptions.findIndex((option)=>option.value === categoryState?.optionId);
        if (selectedCategoryIndex === -1) return categoryOptions;
        const sortedCategoryOptions = [
            ...categoryOptions
        ];
        const selectedCategoryOption = sortedCategoryOptions[selectedCategoryIndex];
        sortedCategoryOptions.splice(selectedCategoryIndex, 1);
        sortedCategoryOptions.unshift(selectedCategoryOption);
        return sortedCategoryOptions;
    }, [
        categoryOptions,
        categoryState
    ]);
    const triggerContent = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dSjBh.CategoryCellContent), {
            isEditable: isEditable,
            categoryState: categoryState
        }), [
        isEditable,
        categoryState
    ]);
    const tmpError = project.isSimplified && editFieldError;
    const staticContent = triggerContent;
    const cellContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, editMode || categoryToDeleteInModal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gvQOt.EditCategoryCell), {
        width: width,
        issueTypeId: issueTypeId,
        categoryOptions: sortedCategories,
        triggerContent: triggerContent,
        wrapperRef: wrapperRef,
        setCategoryToDeleteInModal: setCategoryToDeleteInModal,
        categoryState: categoryState,
        onCategoryNameAlreadyExists: checkCategoryNameAlreadyExists,
        onCategoryCreate: createAndAssignNewCategory,
        onCategoryCellValueChange: assignCategoryToCell,
        onCategoryUpdate: updateCategory,
        cellRef: cellRef,
        inputValue: inputValue,
        onInputChange: onInputChange
    }) : staticContent, categoryToDeleteInModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3aLMK.default), {
        categoryToDelete: categoryToDeleteInModal,
        onDeleteCompleted: onDeleteCompleted,
        onCategoryDelete: deleteAndUnassignCategory
    }), tmpError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0a4D.FixItErrorFlag), {
        error: editFieldError,
        title: (0, $cPZte.default).errorTitle,
        description: (0, $cPZte.default).errorMessage,
        issueType: issueType,
        issueTypeId: String(issueTypeId),
        fieldId: fieldKey,
        fieldName: fieldName
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b5lmY.CellWrapper), {
        isEditable: isEditable,
        hasPadding: false,
        testId: "business-list.ui.list-view.category-cell.cell-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: $dcf1c729996b187a$var$cellContentStyles
    }, cellContent));
};
var $dcf1c729996b187a$export$2e2bcd8739ae039 = $dcf1c729996b187a$var$CategoryCell;
const $dcf1c729996b187a$var$cellContentStyles = (0, $8CUq3.xcss)({
    width: '100%',
    height: '100%'
});

});
parcelRegister("64gJA", function(module, exports) {

$parcel$export(module.exports, "useCategoryCellStateController", () => $e8c2b17de9ebf948$export$6b6a02976fa812c3);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $daQYX = parcelRequire("daQYX");

var $jcw0u = parcelRequire("jcw0u");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $lQE94 = parcelRequire("lQE94");

var $itmJb = parcelRequire("itmJb");

var $lVJAU = parcelRequire("lVJAU");

var $kWfaA = parcelRequire("kWfaA");

var $aNJFF = parcelRequire("aNJFF");

var $4czz5 = parcelRequire("4czz5");

var $a3IM2 = parcelRequire("a3IM2");

var $bPi86 = parcelRequire("bPi86");

var $lnCtA = parcelRequire("lnCtA");

var $hqdlT = parcelRequire("hqdlT");

var $kzvKj = parcelRequire("kzvKj");
const $e8c2b17de9ebf948$export$614564ba26164c27 = 'OPTIMISTIC_UPDATE_OPTION_ID';
const $e8c2b17de9ebf948$export$575776c1bc65689e = 'OPTIMISTIC_CREATE_OPTION_ID';
const $e8c2b17de9ebf948$export$6b6a02976fa812c3 = ({ fieldValue: fieldValue, fieldType: fieldType, issueKey: issueKey, fieldKey: fieldKey, issueTypeId: issueTypeId, createExperience: createExperience, updateExperience: updateExperience, deleteExperience: deleteExperience })=>{
    const prevFieldValueRef = (0, $5uXOq.useRef)(fieldValue);
    const { categoryOptions: categoryOptions } = (0, $kWfaA.useCategoryOptionsService)();
    const [categoryState, setCategoryState] = (0, $5uXOq.useState)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    fieldValue);
    // created for functions in useCallback to read state value without dependant on it
    const categoryStateRef = (0, $5uXOq.useRef)(categoryState);
    categoryStateRef.current = categoryState;
    const project = (0, $daQYX.useProject)();
    const isProjectAdmin = project.permissions.administerProject;
    const isProjectSimplified = project.isSimplified;
    const projectKey = project.key;
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ value: value, error: editFieldError }, { saveValue: saveValue }] = (0, $lQE94.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: fieldValue ? {
            id: fieldValue?.optionId,
            value: fieldValue?.value,
            color: fieldValue?.color
        } : null
    });
    const { createCategory: createCategory } = (0, $4czz5.useCreateCategory)({
        experience: createExperience
    });
    const { updateCategory: updateCategoryService, error: updateCategoryError } = (0, $bPi86.useUpdateCategory)({
        experience: updateExperience
    });
    const { deleteCategory: deleteCategory, error: deleteError } = (0, $a3IM2.useDeleteCategory)({
        experience: deleteExperience
    });
    const { addCategory: addCategoryToCache, updateCategory: updateCategoryInCache, removeCategory: removeCategoryInCache } = (0, $kWfaA.useCategoryOptionsCache)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    (0, $5uXOq.useEffect)(()=>{
        // sync fieldValue into the local state
        const fieldValueHasChanged = prevFieldValueRef.current?.optionId !== fieldValue?.optionId || prevFieldValueRef.current?.value !== fieldValue?.value || prevFieldValueRef.current?.color !== fieldValue?.color;
        if (fieldValueHasChanged) {
            prevFieldValueRef.current = fieldValue;
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            setCategoryState(fieldValue);
        }
    }, [
        categoryOptions,
        fieldValue,
        setCategoryState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const valueHasChanged = categoryState?.optionId !== value?.id || categoryState?.value !== value?.value || categoryState?.color !== value?.color;
        if (valueHasChanged) {
            const newValue = value ? {
                optionId: value.id,
                value: value.value,
                color: value.color
            } : null;
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            setCategoryState(newValue);
        }
    }, [
        categoryState,
        value
    ]);
    /**
   * This `useEffect` is responsible for syncing localState `categoryState` with categoryOptions cache in `categoryOptions`
   *
   * Scenarios where this `categoryState` needs to be synced:
   * - when a category option inside `categoryOptions` gets renamed
   * - when a category option in `categoryOptions` is deleted
   */ (0, $5uXOq.useEffect)(()=>{
        const currentCategoryState = categoryStateRef.current;
        // ignore syncing with `categoryOptions`, if current cell does not have category assigned
        if (!currentCategoryState) return;
        // ignore syncing with `categoryOptions`, if the current categoryState is the result of optimistic create
        // because the optimistic created value will not exist in `categoryOptions` cache
        if (currentCategoryState.optionId === $e8c2b17de9ebf948$export$575776c1bc65689e) return;
        const categoryOption = categoryOptions.find((o)=>o.value === currentCategoryState.optionId);
        /**
     * This code is for "when a category option in `categoryOptions` is deleted"
     * if we cannot find the `categoryState` in the `categoryOptions` cache, it means it has been deleted
     */ if (!categoryOption) return;
        /**
     * This code is for "when a category option inside `categoryOptions` gets updated (renamed or change color)"
     * Updating localState `categoryState` if the categoryState.value has been renamed or color has been changed
     */ if (currentCategoryState.value !== categoryOption?.label || currentCategoryState.color !== categoryOption?.color) setCategoryState({
            ...currentCategoryState,
            value: categoryOption?.label,
            color: categoryOption?.color
        });
    }, [
        categoryOptions,
        setCategoryState
    ]);
    // created ref for functions in useCallback to read options value without dependant on it
    const categoryOptionsRef = (0, $5uXOq.useRef)(categoryOptions);
    categoryOptionsRef.current = categoryOptions;
    const getCategoryOptionFromName = (0, $5uXOq.useCallback)((categoryName)=>categoryOptionsRef.current.find((co)=>co.label.toLocaleLowerCase() === categoryName.toLocaleLowerCase()), []);
    // Need to transform the value to use property key `id` instead of `optionId` when saving a category.
    // This is to avoid the issue with the saved category pointing to previously deleted category with the same name, since the BE uses `id` instead of `optionId`.
    // More details can be found on this page: https://hello.atlassian.net/wiki/spaces/JBus/pages/2986685178/Weird+behaviour+on+Category+and+Custom+Dropdown+delete+and+recover
    const getOptionIdToSave = (optionId)=>({
            id: optionId
        });
    const handleSaveValueError = (0, $5uXOq.useCallback)((e, id)=>{
        // TMP error handling is located within the cell ui component
        if (!isProjectSimplified) {
            const errorFlag = (0, $kzvKj.getSaveValueErrorFlag)(e, isAdmin || isProjectAdmin, ()=>{
                if (isProjectSimplified) push(`/jira/core/projects/${projectKey}/settings/issuetypes`);
                else push(`/plugins/servlet/project-config/${projectKey}/fields`);
            });
            showFlag(errorFlag);
        }
        (0, $jcw0u.default)({
            meta: {
                id: id,
                packageName: 'jiraBusinessCategories',
                teamName: 'jira-warepil'
            },
            error: e,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        isAdmin,
        isProjectAdmin,
        isProjectSimplified,
        projectKey,
        push,
        showFlag
    ]);
    const checkCategoryNameAlreadyExists = (0, $5uXOq.useCallback)((categoryName)=>{
        const trimmedCategoryName = categoryName.trim();
        if (getCategoryOptionFromName(trimmedCategoryName)) return true;
        return false;
    }, [
        getCategoryOptionFromName
    ]);
    const createAndAssignNewCategory = (0, $5uXOq.useCallback)(async (categoryName, color)=>{
        // check permission
        if (!isProjectAdmin) return;
        const trimmedCategoryName = categoryName.trim();
        if (trimmedCategoryName === '') {
            showFlag({
                type: 'error',
                title: formatMessage((0, $hqdlT.default).createdCategoryNameCantBeEmpty),
                messageId: 'business-categories.controllers.category-cell-state-controller.show-flag.error.created-category-name-cant-be-empty',
                messageType: 'transactional'
            });
            return;
        }
        if (getCategoryOptionFromName(trimmedCategoryName)) {
            showFlag((0, $lnCtA.CATEGORY_NAME_ALREADY_EXISTS_ERROR_FLAG));
            return;
        }
        // used for rollback optimistic update
        const previousCategoryState = categoryStateRef.current;
        // assign to the issue - optimistic
        setCategoryState({
            optionId: $e8c2b17de9ebf948$export$575776c1bc65689e,
            value: trimmedCategoryName,
            color: color
        });
        // Depends on the UX, we want to add the optimistic update into categoryOptions cache in this line
        // however current UX does not really require that, since the options will close instantly after creating new category, so optimistic update will never be shown to user
        let categoryMutationResult;
        try {
            // create category in BE using mutation
            categoryMutationResult = await createCategory({
                issueTypeId: issueTypeId,
                value: trimmedCategoryName,
                color: color
            });
            // add the created mutation into options cache
            if (categoryMutationResult) addCategoryToCache({
                id: categoryMutationResult.id,
                color: categoryMutationResult.color,
                option: {
                    optionId: categoryMutationResult.option?.optionId,
                    value: categoryMutationResult.option?.value,
                    id: categoryMutationResult.option?.id,
                    isDisabled: categoryMutationResult.option?.isDisabled
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            const isCategoryNameAlreadyExistsError = e.message === (0, $lnCtA.CATEGORY_NAME_ALREADY_EXISTS_ERROR_MESSAGE);
            const errorFlag = isCategoryNameAlreadyExistsError ? (0, $lnCtA.CATEGORY_NAME_ALREADY_EXISTS_ERROR_FLAG) : (0, $aNJFF.CREATE_FAILED_FLAG);
            showFlag(errorFlag);
            // Only fire analytics for unknown errors
            if (!isCategoryNameAlreadyExistsError) (0, $jcw0u.default)({
                meta: {
                    id: 'jwmCreateCategory',
                    packageName: 'jiraBusinessCategories',
                    teamName: 'jira-warepil'
                },
                error: e,
                sendToPrivacyUnsafeSplunk: true
            });
            // rollback optimistic update changes when fail
            setCategoryState(previousCategoryState);
            return;
        }
        if (!categoryMutationResult) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'jwmCreateCategoryEmpty',
                    packageName: 'jiraBusinessCategories',
                    teamName: 'jira-warepil'
                },
                error: new Error('categoryMutationResult is empty'),
                sendToPrivacyUnsafeSplunk: true
            });
            // rollback optimistic update changes when fail
            setCategoryState(previousCategoryState);
            return;
        }
        // then assign it after creation
        try {
            await saveValue({
                ...getOptionIdToSave(categoryMutationResult.option.optionId),
                value: categoryMutationResult.option.value ?? null,
                color: categoryMutationResult.color ?? null
            }, null, createAnalyticsEvent({}));
            setCategoryState({
                optionId: categoryMutationResult.option.optionId,
                value: categoryMutationResult.option.value,
                color: categoryMutationResult.color
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            handleSaveValueError(e, 'jwmCreateCategoryThenAssign');
            // rollback optimistic update changes when fail
            setCategoryState(previousCategoryState);
        }
    }, [
        isProjectAdmin,
        getCategoryOptionFromName,
        showFlag,
        formatMessage,
        createCategory,
        issueTypeId,
        addCategoryToCache,
        saveValue,
        createAnalyticsEvent,
        handleSaveValueError
    ]);
    const updateCategory = (0, $5uXOq.useCallback)(async ({ optionId: optionId, newCategoryName: newCategoryName, newCategoryColor: newCategoryColor })=>{
        // check permission
        if (!isProjectAdmin) return;
        const oldCategoryOption = categoryOptionsRef.current.find((co)=>co.value === optionId);
        const trimmedNewCategoryName = newCategoryName.trim();
        if (trimmedNewCategoryName === oldCategoryOption?.label.trim() && newCategoryColor === oldCategoryOption?.color) return;
        if (trimmedNewCategoryName === '') {
            showFlag({
                type: 'error',
                title: formatMessage((0, $hqdlT.default).renamedCategoryCantBeEmpty),
                messageId: 'business-categories.controllers.category-cell-state-controller.show-flag.error.renamed-category-cant-be-empty',
                messageType: 'transactional'
            });
            return;
        }
        const categoryOptionWithSameName = getCategoryOptionFromName(trimmedNewCategoryName);
        if (categoryOptionWithSameName && categoryOptionWithSameName.value !== optionId) {
            showFlag((0, $lnCtA.CATEGORY_NAME_ALREADY_EXISTS_ERROR_FLAG));
            return;
        }
        // update name and color optimistically in the options cache
        updateCategoryInCache({
            option: {
                optionId: optionId,
                value: trimmedNewCategoryName
            },
            color: newCategoryColor
        });
        const isCurrentCategoryRenamed = categoryStateRef.current && optionId === categoryStateRef.current.optionId;
        // also update in the issue
        if (isCurrentCategoryRenamed) setCategoryState({
            optionId: optionId,
            value: trimmedNewCategoryName,
            color: newCategoryColor
        });
        let updateResponse = null;
        try {
            // send the request
            updateResponse = await updateCategoryService({
                optionId: Number.parseInt(optionId, 10),
                issueTypeId: issueTypeId,
                value: trimmedNewCategoryName,
                color: newCategoryColor
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'jwmCategoryUpdateCategory',
                    packageName: 'jiraBusinessCategories',
                    teamName: 'jira-warepil'
                },
                error: e,
                sendToPrivacyUnsafeSplunk: true
            });
        } finally{
            // Check if update failed
            if (updateCategoryError || !updateResponse) {
                // Not firing Error flag in here, since it is already handled in service level
                (0, $jcw0u.default)({
                    meta: {
                        id: 'jwmCategoryUpdateCategoryError',
                        packageName: 'jiraBusinessCategories',
                        teamName: 'jira-warepil'
                    },
                    error: updateCategoryError ? new Error(updateCategoryError?.message ?? 'updateCategory mutation error') : new Error('updateCategoryMutationResult is empty'),
                    sendToPrivacyUnsafeSplunk: true
                });
                // rollback optimistic update
                updateCategoryInCache({
                    option: {
                        optionId: optionId,
                        value: oldCategoryOption?.label ?? ''
                    },
                    color: oldCategoryOption?.color ?? null
                });
                if (isCurrentCategoryRenamed) setCategoryState({
                    optionId: optionId,
                    value: oldCategoryOption?.label ?? '',
                    color: oldCategoryOption?.color ?? null
                });
            }
        }
    }, [
        isProjectAdmin,
        getCategoryOptionFromName,
        updateCategoryInCache,
        showFlag,
        formatMessage,
        setCategoryState,
        updateCategoryService,
        issueTypeId,
        updateCategoryError
    ]);
    const deleteAndUnassignCategory = (0, $5uXOq.useCallback)(async (optionIdToDelete)=>{
        // check permission
        if (!isProjectAdmin) return;
        const categoryOptionToDelete = categoryOptionsRef.current.find((co)=>co.value === optionIdToDelete);
        if (!categoryOptionToDelete) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'jwmCategoryDeleteCategoryNotFound',
                    packageName: 'jiraBusinessCategories',
                    teamName: 'jira-warepil'
                },
                error: new Error('Cannot find categoryOption to delete'),
                sendToPrivacyUnsafeSplunk: true
            });
            return;
        }
        // we're not doing optimistic delete because the UI will prevent users to see category again until the delete finishes, so there is no need to do rollback if delete fails too
        try {
            // delete request to BE
            const deleteSuccess = await deleteCategory({
                issueTypeId: issueTypeId,
                optionId: Number.parseInt(optionIdToDelete, 10)
            });
            if (!deleteSuccess) {
                (0, $jcw0u.default)({
                    meta: {
                        id: 'jwmCategoryDeleteCategorySuccessFalse',
                        packageName: 'jiraBusinessCategories',
                        teamName: 'jira-warepil'
                    },
                    error: new Error(deleteError?.message ?? 'Category delete mutation result.success is false'),
                    sendToPrivacyUnsafeSplunk: true
                });
                return;
            }
            removeCategoryInCache(optionIdToDelete);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            // Not firing error flag because service layer already has it
            (0, $jcw0u.default)({
                meta: {
                    id: 'jwmCategoryDeleteCategoryError',
                    packageName: 'jiraBusinessCategories',
                    teamName: 'jira-warepil'
                },
                error: e,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        deleteCategory,
        deleteError?.message,
        isProjectAdmin,
        issueTypeId,
        removeCategoryInCache
    ]);
    const assignCategoryToCell = (0, $5uXOq.useCallback)(async (categoryToAssign)=>{
        if (categoryState?.optionId === categoryToAssign?.optionId) return;
        // used for rollback optimistic update
        const previousCategoryState = categoryStateRef.current;
        setCategoryState(categoryToAssign);
        try {
            await saveValue(categoryToAssign ? {
                ...getOptionIdToSave(categoryToAssign?.optionId),
                value: categoryToAssign?.value ?? null,
                color: categoryToAssign?.color ?? null
            } : null, null, createAnalyticsEvent({}));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            handleSaveValueError(e, 'jwmCategoryAssign');
            setCategoryState(previousCategoryState);
        }
    }, [
        categoryState?.optionId,
        saveValue,
        createAnalyticsEvent,
        handleSaveValueError
    ]);
    return {
        editFieldError: editFieldError,
        categoryState: categoryState,
        categoryOptions: categoryOptions,
        createAndAssignNewCategory: createAndAssignNewCategory,
        checkCategoryNameAlreadyExists: checkCategoryNameAlreadyExists,
        updateCategory: updateCategory,
        deleteAndUnassignCategory: deleteAndUnassignCategory,
        assignCategoryToCell: assignCategoryToCell
    };
};

});
parcelRegister("lQE94", function(module, exports) {

$parcel$export(module.exports, "useContextualIssueIdForIssueKey", () => $c31e2d123e024ddc$export$76d937477b5f784a);
$parcel$export(module.exports, "useEditField", () => $c31e2d123e024ddc$export$343e962d356c0af1);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $3BIWb = parcelRequire("3BIWb");

var $2YZCu = parcelRequire("2YZCu");

var $4R6GH = parcelRequire("4R6GH");

var $jJZqs = parcelRequire("jJZqs");

var $fZneA = parcelRequire("fZneA");

var $ctrpc = parcelRequire("ctrpc");

var $d6AeP = parcelRequire("d6AeP");

var $2gCtH = parcelRequire("2gCtH");

var $afs7f = parcelRequire("afs7f");

var $15WDX = parcelRequire("15WDX");

var $biQrn = parcelRequire("biQrn");

var $8zOmE = parcelRequire("8zOmE");

var $3fAi8 = parcelRequire("3fAi8");

var $99cgx = parcelRequire("99cgx");
/**
 * Some responses contain `fields` property without `fieldKey`.
 * We must avoid changing the state of this fields by checking `fieldKey` property in the `fields`.
 * @param response
 * @param fieldKey
 */ const $c31e2d123e024ddc$var$getFieldValue = (response, fieldKey)=>{
    if (!response) return null;
    if (response.fields) {
        if (Object.hasOwnProperty.call(response.fields, fieldKey)) return response.fields[fieldKey];
        return null;
    }
    return response;
};
const $c31e2d123e024ddc$var$shouldCallSetFieldValue = (response, fieldKey)=>{
    if (!response) return false;
    if (response.fields) return !!Object.hasOwnProperty.call(response.fields, fieldKey);
    return true;
};
const $c31e2d123e024ddc$export$3796d3fdbc2e6b54 = (fieldOptions)=>{
    // di-ignore - Please fix parent-switcher examples
    const baseUrl = '';
    const { issueKey: issueKey, issueId: issueId, fieldKey: fieldKey, fieldType: fieldType, initialValue: initialValue, analyticsFieldKeyAlias: analyticsFieldKeyAlias, analyticsFieldTypeAlias: analyticsFieldTypeAlias, mapNonOptimisticResponse: mapNonOptimisticResponse = $c31e2d123e024ddc$var$getFieldValue, saveField: saveField = (0, $99cgx.defaultSaveField), saveFieldById: saveFieldById = (0, $99cgx.defaultSaveFieldById), addValuesToField: addValuesToField = (0, $99cgx.defaultAddValuesToField), removeValuesFromField: removeValuesFromField = (0, $99cgx.defaultRemoveValuesFromField), onSubmit: onSubmit = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onSuccess: onSuccess = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onFailure: onFailure = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) } = fieldOptions;
    // We need to track the mounted state as it is possible that a component
    // using this hook can be unmounted before the async edit operation is completed.
    // Causing a react warning about setting state on an unmounted component.
    const isMounted = (0, $biQrn.useIsMounted)();
    const [fieldPersistedValue, { setFieldValue: setFieldValue }] = (0, $3fAi8.useFieldValue)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const fieldValue = fieldPersistedValue !== undefined ? fieldPersistedValue : initialValue;
    const [error, setError] = (0, $5uXOq.useState)(null);
    const [loading, setLoading] = (0, $5uXOq.useState)(false);
    const resetError = (0, $5uXOq.useCallback)(()=>{
        if (isMounted.current) setError(null);
    }, [
        setError,
        isMounted
    ]);
    const editFieldValue = (0, $5uXOq.useCallback)(async (editOperation, editOperationType, valuesForOperation, valuesForUI, meta, analyticsEvent, options = {
        isOptimistic: true
    })=>{
        let result;
        const actualFieldType = analyticsFieldTypeAlias ?? fieldType;
        const analyticsData = {
            editOperationType: editOperationType,
            issueId: issueId,
            fieldKey: analyticsFieldKeyAlias ?? fieldKey,
            fieldType: actualFieldType
        };
        if (isMounted.current) {
            setLoading(true);
            setError(null);
        }
        try {
            onSubmit(fieldValue, valuesForOperation, meta, analyticsEvent);
            if (options.isOptimistic) setFieldValue(issueKey, fieldKey, valuesForUI);
            result = await editOperation(issueKey, fieldKey, valuesForOperation, baseUrl, meta);
            const fieldValueResponse = mapNonOptimisticResponse(result, fieldKey);
            $c31e2d123e024ddc$var$shouldCallSetFieldValue(result, fieldKey) && setFieldValue(issueKey, fieldKey, fieldValueResponse);
            onSuccess(fieldValueResponse ?? valuesForOperation, analyticsEvent, meta);
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'field updated', analyticsData);
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'field updateSucceeded', analyticsData);
            if ((0, $4R6GH.fg)('one_event_rules_them_all_fg')) (0, $ctrpc.getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd(fieldKey, {
                analytics: analyticsEvent,
                attributes: {
                    fieldType: actualFieldType,
                    isInlineEditing: !(0, $d6AeP.getIsEditFromIssueView)(analyticsEvent),
                    ...(0, $4R6GH.fg)('one_event_improvements_1') && {
                        issueId: issueId
                    }
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (ex) {
            result = Promise.reject(ex);
            onFailure(ex, valuesForOperation);
            setFieldValue(issueKey, fieldKey, fieldValue);
            if (isMounted.current) setError(ex);
            const isValidationError = ex instanceof (0, $jJZqs.ValidationError);
            if (!isValidationError) (0, $2YZCu.default).safeErrorWithoutCustomerData('issue-field.save-value', `Failed to update field ${fieldKey} of type ${fieldType}`, ex);
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'field updateFailed', {
                fieldKey: fieldKey,
                fieldType: analyticsFieldTypeAlias ?? fieldType,
                isValidationError: isValidationError,
                isClientFetchError: (0, $fZneA.isClientFetchError)(ex)
            });
            if ((0, $4R6GH.fg)('one_event_rules_them_all_fg')) (0, $ctrpc.getUpdateAnalyticsFlowHelper)().endSession(fieldKey);
        }
        if (isMounted.current) setLoading(false);
        return result;
    }, [
        issueId,
        analyticsFieldKeyAlias,
        fieldKey,
        analyticsFieldTypeAlias,
        fieldType,
        isMounted,
        onSubmit,
        fieldValue,
        setFieldValue,
        issueKey,
        onSuccess,
        onFailure,
        mapNonOptimisticResponse
    ]);
    const saveValue = (0, $5uXOq.useCallback)(async (newValue, meta, analyticsEvent)=>editFieldValue(saveField, 'set', newValue, newValue, meta, analyticsEvent), [
        editFieldValue,
        saveField
    ]);
    const saveById = (0, $5uXOq.useCallback)(async (newValue, meta, analyticsEvent)=>editFieldValue(saveFieldById, 'set', newValue, newValue, meta, analyticsEvent, {
            isOptimistic: false
        }), [
        editFieldValue,
        saveFieldById
    ]);
    const addValues = (0, $5uXOq.useCallback)(async (valuesToAdd, expectedValuesAfterAdding, meta, analyticsEvent)=>editFieldValue(addValuesToField, 'add', valuesToAdd, expectedValuesAfterAdding, meta, analyticsEvent), [
        editFieldValue,
        addValuesToField
    ]);
    const removeValues = (0, $5uXOq.useCallback)(async (valuesToRemove, expectedValuesAfterRemoval, meta, analyticsEvent)=>editFieldValue(removeValuesFromField, 'remove', valuesToRemove, expectedValuesAfterRemoval, meta, analyticsEvent), [
        editFieldValue,
        removeValuesFromField
    ]);
    return [
        {
            value: fieldValue,
            loading: loading,
            error: error
        },
        {
            saveById: saveById,
            saveValue: saveValue,
            addValues: addValues,
            removeValues: removeValues,
            resetError: resetError
        }
    ];
};
const $c31e2d123e024ddc$export$76d937477b5f784a = (issueKey)=>{
    const contextualIssueId = (0, $2gCtH.useIssueId)();
    const contextualIssueKey = (0, $2gCtH.useIssueKey)();
    return contextualIssueKey === issueKey ? contextualIssueId : null;
};
const $c31e2d123e024ddc$var$getAdditionalProperties = (meta, isEditFromIssueView)=>{
    if (!meta || typeof meta === 'object') return {
        ...meta ?? {},
        isEditFromIssueView: isEditFromIssueView
    };
    return meta;
};
const $c31e2d123e024ddc$export$343e962d356c0af1 = (fieldOptions)=>{
    const { fieldKey: fieldKey, issueId: issueIdFromFieldOptions, issueKey: issueKey, onSubmit: onSubmit = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onSuccess: onSuccess = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onFailure: onFailure = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), shouldPreventIssueViewSoftRefresh: shouldPreventIssueViewSoftRefresh = false } = fieldOptions;
    const [, { fieldChanged: fieldChanged, fieldChangeFailed: fieldChangeFailed, fieldChangeRequested: fieldChangeRequested }] = (0, $15WDX.useIssueViewFieldUpdateEvents)();
    const contextualIssueId = $c31e2d123e024ddc$export$76d937477b5f784a(issueKey);
    const issueId = issueIdFromFieldOptions ?? contextualIssueId;
    const onSubmitFn = (0, $5uXOq.useCallback)((oldValue, newValue, meta, event)=>{
        onSubmit(oldValue, newValue, meta, event);
        issueId && fieldChangeRequested(issueId, fieldKey, newValue, meta);
    }, [
        fieldChangeRequested,
        fieldKey,
        issueId,
        onSubmit
    ]);
    const onSuccessFn = (0, $5uXOq.useCallback)(async (fieldValue, event, meta)=>{
        onSuccess(fieldValue);
        issueId && fieldChanged(issueId, fieldKey, fieldValue, undefined, (0, $4R6GH.fg)('one_event_rules_them_all_fg') ? $c31e2d123e024ddc$var$getAdditionalProperties(meta, (0, $d6AeP.getIsEditFromIssueView)(event)) : meta);
        if (!shouldPreventIssueViewSoftRefresh && !(0, $d6AeP.getIsEditFromIssueView)(event)) try {
            const reason = (0, $afs7f.Reason).SoftRefresh;
            await (0, $3BIWb.default).refreshIssuePageThrowable(issueKey, reason);
        } catch (error) {
            (0, $2YZCu.default).safeErrorWithoutCustomerData('issue.fields.use-edit-field.refresh', error instanceof Error ? error.message : 'useEditField issue refresh failed');
        }
    }, [
        fieldChanged,
        fieldKey,
        shouldPreventIssueViewSoftRefresh,
        issueId,
        issueKey,
        onSuccess
    ]);
    const onFailureFn = (0, $5uXOq.useCallback)((error, failedValue)=>{
        onFailure(error, failedValue);
        issueId && fieldChangeFailed(issueId, fieldKey);
    }, [
        fieldChangeFailed,
        fieldKey,
        issueId,
        onFailure
    ]);
    return $c31e2d123e024ddc$export$3796d3fdbc2e6b54({
        ...fieldOptions,
        onSubmit: onSubmitFn,
        onSuccess: onSuccessFn,
        onFailure: onFailureFn
    });
};

});
parcelRegister("3BIWb", function(module, exports) {

$parcel$export(module.exports, "default", () => $b65e83eb4ced9ce9$export$2e2bcd8739ae039);
const $b65e83eb4ced9ce9$var$REFRESH_ISSUE_PAGE_EVENT = 'legacy_refreshIssuePage';
const $b65e83eb4ced9ce9$var$UPDATE_ISSUE_GLANCE_EVENT = 'legacy_updateIssueGlance';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b65e83eb4ced9ce9$var$addEventListener = (event, callback)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.addEventListener(event, callback);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b65e83eb4ced9ce9$var$removeEventListener = (event, callback)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.removeEventListener(event, callback);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b65e83eb4ced9ce9$var$addRefreshIssueListener = (callback)=>$b65e83eb4ced9ce9$var$addEventListener($b65e83eb4ced9ce9$var$REFRESH_ISSUE_PAGE_EVENT, callback);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b65e83eb4ced9ce9$var$removeRefreshIssueListener = (callback)=>$b65e83eb4ced9ce9$var$removeEventListener($b65e83eb4ced9ce9$var$REFRESH_ISSUE_PAGE_EVENT, callback);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b65e83eb4ced9ce9$var$addUpdateIssueGlanceListener = (callback)=>$b65e83eb4ced9ce9$var$addEventListener($b65e83eb4ced9ce9$var$UPDATE_ISSUE_GLANCE_EVENT, callback);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b65e83eb4ced9ce9$var$removeUpdateIssueGlanceListener = (callback)=>$b65e83eb4ced9ce9$var$removeEventListener($b65e83eb4ced9ce9$var$UPDATE_ISSUE_GLANCE_EVENT, callback);
const $b65e83eb4ced9ce9$var$refreshIssuePageThrowable = (issueKey, reason = 'ON_DEMAND')=>{
    try {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.dispatchEvent(new CustomEvent($b65e83eb4ced9ce9$var$REFRESH_ISSUE_PAGE_EVENT, {
            detail: [
                issueKey,
                {
                    mergeIntoCurrent: false,
                    reason: reason
                }
            ]
        }));
        return Promise.resolve();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return Promise.reject(e);
    }
};
const $b65e83eb4ced9ce9$var$refreshIssuePage = (issueKey)=>// Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    $b65e83eb4ced9ce9$var$refreshIssuePageThrowable(issueKey).catch(()=>{});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b65e83eb4ced9ce9$export$2e2bcd8739ae039 = {
    addRefreshIssueListener: $b65e83eb4ced9ce9$var$addRefreshIssueListener,
    removeRefreshIssueListener: $b65e83eb4ced9ce9$var$removeRefreshIssueListener,
    addUpdateIssueGlanceListener: $b65e83eb4ced9ce9$var$addUpdateIssueGlanceListener,
    removeUpdateIssueGlanceListener: $b65e83eb4ced9ce9$var$removeUpdateIssueGlanceListener,
    refreshIssuePageThrowable: $b65e83eb4ced9ce9$var$refreshIssuePageThrowable,
    refreshIssuePage: $b65e83eb4ced9ce9$var$refreshIssuePage
};

});

parcelRegister("d6AeP", function(module, exports) {

$parcel$export(module.exports, "getIsEditFromIssueView", () => $843704b157f0fa59$export$8846558eb0b5fa3);

var $hBuqR = parcelRequire("hBuqR");

var $lhVtI = parcelRequire("lhVtI");
const $843704b157f0fa59$export$8846558eb0b5fa3 = (event)=>{
    const ISSUE_VIEW_SOURCES = [
        'fullIssueScreen',
        'boardIssueViewScreen',
        'agility-backlogScreen',
        'issueNavigatorEmbeddedIssueViewScreen',
        'globalIssueNavigatorIssueScreen',
        'mobileIssueScreen',
        'classicRoadmapScreen',
        'roadmapScreen',
        'versionDetailsIssueScreen',
        'bitbucketIssueScreen',
        'jsmQueueAgentViewSidebarScreen',
        'viewQueueIssueScreen',
        'jswModalIssueAppScreen',
        'jwmModalIssueAppScreen',
        'jswSidebarIssueAppScreen',
        'jwmSidebarIssueAppScreen'
    ];
    const { payload: { source: source } } = (0, $lhVtI.getEvent)(event);
    if (!source) return false;
    if (ISSUE_VIEW_SOURCES.includes(source)) // event originated from issue view location
    return true;
    if (source.startsWith((0, $hBuqR.PACKAGE_NAME_GASV3))) // event originated from forge app, which can only be mounted in issue view for field editing
    return true;
    return false;
};

});

parcelRegister("afs7f", function(module, exports) {

$parcel$export(module.exports, "Reason", () => $90b3aba4b3cc23bb$export$fe867595c4640fb1);
const $90b3aba4b3cc23bb$export$fe867595c4640fb1 = {
    /**
	 * Aka hard refresh, used by Ecosystem apps to refresh issue view on demand
	 * 1) Full issue view refresh
	 * 2) Hard Ecosystem apps refresh (causes remounting of the apps)
	 */ OnDemand: 'ON_DEMAND',
    /**
	 * Used by Jira internally to update issue view on demand without forcing Ecosystem apps to rerender
	 * 1) Full issue view refresh only
	 * 2) Ecosystem app aren't hard refreshed, however, if field's value has changed, Forge custom field will rerender
	 */ SoftRefresh: 'SOFT_REFRESH',
    /**
	 * Issue view refresh caused by Realtime service (Jirt)
	 */ Realtime: 'REALTIME'
};

});

parcelRegister("15WDX", function(module, exports) {

$parcel$export(module.exports, "useIssueViewFieldUpdateEvents", () => $947bdf396d8056bc$export$444af741f6d8f512);
$parcel$export(module.exports, "IssueViewFieldUpdateEventContainer", () => $947bdf396d8056bc$export$f9eb49cc2f0e28ce);

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $5YMLs = parcelRequire("5YMLs");

var $3z81P = parcelRequire("3z81P");
const $947bdf396d8056bc$var$registerEventHandler = (type, eventHandler)=>({ getState: getState, setState: setState })=>{
        if (typeof eventHandler !== 'function') // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        const { eventHandlers: eventHandlers } = getState();
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ onChange: OnChangeHandler[]; }'.
        const typeEventHandlers = eventHandlers[type];
        setState({
            eventHandlers: {
                ...eventHandlers,
                [type]: typeEventHandlers.concat([
                    eventHandler
                ])
            }
        });
        return ()=>{
            const { eventHandlers: eventHandlersForUnregister } = getState();
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ onChange: OnChangeHandler[]; }'.
            const typeEventHandlersForUnregister = eventHandlersForUnregister[type];
            const newTypeEventHandlers = typeEventHandlersForUnregister.filter(// @ts-expect-error - TS7006 - Parameter 'handler' implicitly has an 'any' type.
            (handler)=>handler !== eventHandler);
            setState({
                eventHandlers: {
                    ...eventHandlersForUnregister,
                    [type]: newTypeEventHandlers
                }
            });
        };
    };
const $947bdf396d8056bc$var$fieldChanged = (issueId, fieldId, fieldValue, aggFieldChangeProps, additionalProperties)=>({ getState: getState })=>{
        let value = fieldValue;
        if (aggFieldChangeProps) value = (0, $5YMLs.transformAggToLegacy)({
            fieldValue: fieldValue,
            aggFieldChangeProps: aggFieldChangeProps
        });
        const eventHandlers = getState().eventHandlers.onChange;
        eventHandlers.forEach((eventHandler)=>{
            eventHandler({
                issueId: issueId,
                fieldId: // field id is required to be compatible with v1 onChange API
                fieldId,
                meta: {
                    fieldId: fieldId,
                    fieldValue: value,
                    additionalProperties: additionalProperties
                },
                type: (0, $3z81P.ChangeEventTypes).FIELD_CHANGED
            });
        });
    };
const $947bdf396d8056bc$var$fieldChangeFailed = (issueId, fieldId)=>({ getState: getState })=>{
        const eventHandlers = getState().eventHandlers.onChange;
        eventHandlers.forEach((eventHandler)=>{
            eventHandler({
                issueId: issueId,
                meta: {
                    fieldId: fieldId
                },
                type: (0, $3z81P.ChangeEventTypes).FIELD_CHANGE_FAILED
            });
        });
    };
const $947bdf396d8056bc$var$fieldChangeRequested = (issueId, fieldId, fieldValue, additionalProperties, aggFieldChangeProps)=>({ getState: getState })=>{
        let value = fieldValue;
        if (aggFieldChangeProps) value = (0, $5YMLs.transformAggToLegacy)({
            fieldValue: fieldValue,
            aggFieldChangeProps: aggFieldChangeProps
        });
        const eventHandlers = getState().eventHandlers.onChange;
        eventHandlers.forEach((eventHandler)=>{
            eventHandler({
                issueId: issueId,
                meta: {
                    fieldId: fieldId,
                    fieldValue: value,
                    additionalProperties: additionalProperties
                },
                type: (0, $3z81P.ChangeEventTypes).FIELD_CHANGE_REQUESTED
            });
        });
    };
const $947bdf396d8056bc$var$actions = {
    fieldChanged: $947bdf396d8056bc$var$fieldChanged,
    fieldChangeFailed: $947bdf396d8056bc$var$fieldChangeFailed,
    fieldChangeRequested: $947bdf396d8056bc$var$fieldChangeRequested,
    registerEventHandler: $947bdf396d8056bc$var$registerEventHandler
};
// this is a global state
const $947bdf396d8056bc$var$store = (0, $iXqE5.createStore)({
    name: 'issue-view-field-update-events',
    initialState: {
        eventHandlers: {
            onChange: []
        }
    },
    actions: $947bdf396d8056bc$var$actions
});
const $947bdf396d8056bc$export$444af741f6d8f512 = (0, $3sQ5x.createHook)($947bdf396d8056bc$var$store, {
    selector: null
});
const $947bdf396d8056bc$export$f9eb49cc2f0e28ce = (0, $gg7kZ.createContainer)($947bdf396d8056bc$var$store);

});
parcelRegister("5YMLs", function(module, exports) {

$parcel$export(module.exports, "transformAggToLegacy", () => $1da8cbd2b672325c$export$d951e3c38e10736d);

var $bMD69 = parcelRequire("bMD69");

var $5fc53 = parcelRequire("5fc53");

var $1pF6B = parcelRequire("1pF6B");

var $lTnWS = parcelRequire("lTnWS");
const $1da8cbd2b672325c$export$d951e3c38e10736d = ({ fieldValue: fieldValue, aggFieldChangeProps: aggFieldChangeProps })=>{
    if (!aggFieldChangeProps?.__typename) throw new Error('node did not have __typename');
    switch(aggFieldChangeProps.__typename){
        // These fields require context for their transform in transformAggFieldToLegacyField so need to be manually implemented
        // This is not an exhaustive list, I did a quick check is all, so best to check the transform works as expected as you migrate fields to relay
        // These are commented out because they are not implemented and due to types can't just be added here until implemented
        // case JSM_PEOPLE_GQL_FIELD:
        // case ISSUE_RESTRICTION_GQL_FIELD:
        // otherwise we can default to the existing package
        case 0, $5fc53.RADIO_GQL_FIELD:
        case 0, $5fc53.TEAM_VIEW_GQL_FIELD:
        case 0, $5fc53.MULTI_GROUP_PICKER_GQL_FIELD:
        case 0, $5fc53.SINGLE_GROUP_PICKER_GQL_FIELD:
        case 0, $5fc53.MULTI_USER_PICKER_GQL_FIELD:
        case 0, $5fc53.PEOPLE_GQL_FIELD:
        case 0, $5fc53.SECURITY_GQL_FIELD:
        case 0, $5fc53.NUMBER_GQL_FIELD:
        case 0, $5fc53.TEXT_GQL_FIELD:
        case 0, $5fc53.USER_PICKER_GQL_FIELD:
        case 0, $5fc53.PRIORITY_GQL_FIELD:
        case 0, $5fc53.URL_GQL_FIELD:
        case 0, $5fc53.DATE_PICKER_GQL_FIELD:
        case 0, $5fc53.PROJECT_GQL_FIELD:
        case 0, $5fc53.DATE_TIME_GQL_FIELD:
        case 0, $5fc53.COLOR_GQL_FIELD:
        case 0, $5fc53.ORIGINAL_ESTIMATE_GQL_FIELD:
        case 0, $5fc53.ISSUE_TYPE_GQL_FIELD:
        case 0, $5fc53.VOTES_GQL_FIELD:
        case 0, $5fc53.WATCHES_GQL_FIELD:
        case 0, $5fc53.RESOLUTION_GQL_FIELD:
        case 0, $5fc53.STATUS_GQL_FIELD:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return (0, $bMD69.transformAggFieldToLegacyField)({
                [$1da8cbd2b672325c$var$getValueKey(aggFieldChangeProps.__typename)]: fieldValue,
                __typename: aggFieldChangeProps.__typename,
                type: aggFieldChangeProps.type
            })?.value;
        case 0, $5fc53.RICH_TEXT_GQL_FIELD:
            return (0, $lTnWS.transformAggRichTextFieldValueToLegacyFieldValue)(fieldValue, aggFieldChangeProps.renderer);
        case 0, $5fc53.PARENT_GQL_FIELD:
            return (0, $1pF6B.transformAggParentFieldValueToLegacyFieldValue)(fieldValue);
        case 0, $5fc53.SPRINT_GQL_FIELD:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return (0, $bMD69.transformAggFieldToLegacyField)({
                __typename: aggFieldChangeProps.__typename,
                type: aggFieldChangeProps.type,
                ...fieldValue
            })?.value;
        case 0, $5fc53.TIME_TRACKING_GQL_FIELD:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return (0, $bMD69.transformAggFieldToLegacyField)({
                __typename: aggFieldChangeProps.__typename,
                type: aggFieldChangeProps.type,
                originalEstimate: fieldValue.originalEstimate,
                remainingEstimate: fieldValue.remainingEstimate,
                timeSpent: fieldValue.timeSpent
            })?.value;
        case 0, $5fc53.CHECKBOX_GQL_FIELD:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return (0, $bMD69.transformAggFieldToLegacyField)({
                __typename: aggFieldChangeProps.__typename,
                type: aggFieldChangeProps.type,
                selectedOptions: fieldValue.selectedOptions,
                checkboxesFieldOptions: fieldValue.fieldOptions
            })?.value;
        case 0, $5fc53.COMPONENTS_GQL_FIELD:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return (0, $bMD69.transformAggFieldToLegacyField)({
                __typename: aggFieldChangeProps.__typename,
                type: aggFieldChangeProps.type,
                selectedComponentsConnection: fieldValue.selectedComponentsConnection
            })?.value;
        default:
            throw new Error('__typename not implemented');
    }
};
const $1da8cbd2b672325c$var$getValueKey = (__typename)=>{
    const VALUE_KEYS = {
        [(0, $5fc53.TEXT_GQL_FIELD)]: 'text',
        [(0, $5fc53.NUMBER_GQL_FIELD)]: 'number',
        [(0, $5fc53.PRIORITY_GQL_FIELD)]: 'priority',
        [(0, $5fc53.USER_PICKER_GQL_FIELD)]: 'user',
        [(0, $5fc53.DATE_PICKER_GQL_FIELD)]: 'date',
        [(0, $5fc53.PROJECT_GQL_FIELD)]: 'project',
        [(0, $5fc53.DATE_TIME_GQL_FIELD)]: 'dateTime',
        [(0, $5fc53.ORIGINAL_ESTIMATE_GQL_FIELD)]: 'originalEstimate',
        [(0, $5fc53.URL_GQL_FIELD)]: 'uri',
        [(0, $5fc53.SECURITY_GQL_FIELD)]: 'securityLevel',
        [(0, $5fc53.PEOPLE_GQL_FIELD)]: 'selectedUsersConnection',
        [(0, $5fc53.WATCHES_GQL_FIELD)]: 'watch',
        [(0, $5fc53.VOTES_GQL_FIELD)]: 'vote',
        [(0, $5fc53.COLOR_GQL_FIELD)]: 'color',
        [(0, $5fc53.MULTI_USER_PICKER_GQL_FIELD)]: 'selectedUsersConnection',
        [(0, $5fc53.ISSUE_TYPE_GQL_FIELD)]: 'issueType',
        [(0, $5fc53.RESOLUTION_GQL_FIELD)]: 'resolution',
        [(0, $5fc53.MULTI_GROUP_PICKER_GQL_FIELD)]: 'selectedGroupsConnection',
        [(0, $5fc53.SINGLE_GROUP_PICKER_GQL_FIELD)]: 'selectedGroup',
        [(0, $5fc53.TEAM_VIEW_GQL_FIELD)]: 'selectedTeam',
        [(0, $5fc53.STATUS_GQL_FIELD)]: 'status',
        [(0, $5fc53.RADIO_GQL_FIELD)]: 'selectedOption',
        [(0, $5fc53.RICH_TEXT_GQL_FIELD)]: 'richText'
    };
    const value = VALUE_KEYS[__typename];
    if (value) return value;
    throw new Error(`Did you forget to implement getValueKey for your field type? Couldn't find a value in the map for ${__typename}`);
};

});
parcelRegister("bMD69", function(module, exports) {

$parcel$export(module.exports, "transformAggFieldToLegacyField", () => $af5e8bab0defb9c8$export$586ba15cbf3d3031);
$parcel$export(module.exports, "transformAggFieldsToLegacyFields", () => $af5e8bab0defb9c8$export$ba106ff8c087e6b1);

var $8QpSo = parcelRequire("8QpSo");

var $5fc53 = parcelRequire("5fc53");

var $9bgym = parcelRequire("9bgym");

var $6iJEF = parcelRequire("6iJEF");

var $9UrtF = parcelRequire("9UrtF");

var $hsEaK = parcelRequire("hsEaK");

var $2qu1N = parcelRequire("2qu1N");

var $16Zia = parcelRequire("16Zia");

var $iv8Rf = parcelRequire("iv8Rf");

var $hDlc2 = parcelRequire("hDlc2");

var $c3LW9 = parcelRequire("c3LW9");

var $h92P3 = parcelRequire("h92P3");

var $aeO9V = parcelRequire("aeO9V");

var $6Tnq8 = parcelRequire("6Tnq8");

var $6mbsj = parcelRequire("6mbsj");

var $d3nG3 = parcelRequire("d3nG3");

var $1xW6n = parcelRequire("1xW6n");

var $fW9XR = parcelRequire("fW9XR");

var $bKMMB = parcelRequire("bKMMB");

var $7JL37 = parcelRequire("7JL37");

var $dulCG = parcelRequire("dulCG");

var $6vno6 = parcelRequire("6vno6");

var $as0vY = parcelRequire("as0vY");

var $6dPLd = parcelRequire("6dPLd");

var $gKccZ = parcelRequire("gKccZ");

var $jnUrZ = parcelRequire("jnUrZ");

var $iJtmd = parcelRequire("iJtmd");

var $iPyq0 = parcelRequire("iPyq0");

var $384lj = parcelRequire("384lj");

var $axTS6 = parcelRequire("axTS6");

var $lfJ6H = parcelRequire("lfJ6H");

var $9UXU7 = parcelRequire("9UXU7");

var $b6BoU = parcelRequire("b6BoU");

var $gak3n = parcelRequire("gak3n");

var $i47fO = parcelRequire("i47fO");

var $gvljZ = parcelRequire("gvljZ");

var $6XFn2 = parcelRequire("6XFn2");

var $6e1Ya = parcelRequire("6e1Ya");

var $640u2 = parcelRequire("640u2");

var $hBEiJ = parcelRequire("hBEiJ");

var $1XNj2 = parcelRequire("1XNj2");

var $f6zXW = parcelRequire("f6zXW");

var $fB4wX = parcelRequire("fB4wX");

var $cXBkk = parcelRequire("cXBkk");

var $iDKu3 = parcelRequire("iDKu3");

var $aGv90 = parcelRequire("aGv90");

var $19DRh = parcelRequire("19DRh");

var $lkW3a = parcelRequire("lkW3a");

var $lQAwK = parcelRequire("lQAwK");

var $8qOI6 = parcelRequire("8qOI6");

var $cbd7V = parcelRequire("cbd7V");

var $6hj44 = parcelRequire("6hj44");

var $4nh4C = parcelRequire("4nh4C");

var $hA3EZ = parcelRequire("hA3EZ");

var $2z4xE = parcelRequire("2z4xE");

var $cO2KQ = parcelRequire("cO2KQ");

var $5sETx = parcelRequire("5sETx");

var $f454b = parcelRequire("f454b");

var $aafIf = parcelRequire("aafIf");

var $2yWre = parcelRequire("2yWre");

var $lUeQj = parcelRequire("lUeQj");

var $6SWOK = parcelRequire("6SWOK");

var $cMc7B = parcelRequire("cMc7B");

var $38GNL = parcelRequire("38GNL");

var $avV20 = parcelRequire("avV20");

var $cbXvu = parcelRequire("cbXvu");

var $aSXJi = parcelRequire("aSXJi");

var $8uxcU = parcelRequire("8uxcU");

var $arKlm = parcelRequire("arKlm");

var $hCKV6 = parcelRequire("hCKV6");

var $d8wC0 = parcelRequire("d8wC0");
// We're memoising this just in case we FF another field
const $af5e8bab0defb9c8$var$getTransformersNonMemoised = ()=>({
        [(0, $5fc53.AFFECTED_SERVICES_GQL_FIELD)]: (0, $9bgym.transformAggAffectedServicesToLegacyField),
        [(0, $5fc53.BOOLEAN_GQL_FIELD)]: (0, $9UrtF.transformAggBooleanToLegacyField),
        [(0, $5fc53.CASCADING_SELECT_GQL_FIELD)]: (0, $hsEaK.transformAggCascadingSelectToLegacyField),
        [(0, $5fc53.CHECKBOX_GQL_FIELD)]: (0, $2qu1N.transformAggCheckboxToLegacyField),
        [(0, $5fc53.CMDB_GQL_FIELD)]: (0, $16Zia.transformAggCMDBToLegacyField),
        [(0, $5fc53.MULTI_SELECT_GQL_FIELD)]: (0, $19DRh.transformAggMultipleSelectToLegacyField),
        [(0, $5fc53.COMPONENTS_GQL_FIELD)]: (0, $hDlc2.transformAggComponentsToLegacyField),
        [(0, $5fc53.CONNECT_DATE_TIME_GQL_FIELD)]: (0, $c3LW9.transformAggConnectDateTimeToLegacyField),
        [(0, $5fc53.CONNECT_MULTI_SELECT_GQL_FIELD)]: (0, $h92P3.transformAggConnectMultipleSelectToLegacyField),
        [(0, $5fc53.CONNECT_NUMBER_GQL_FIELD)]: (0, $aeO9V.transformAggConnectNumberToLegacyField),
        [(0, $5fc53.CONNECT_RICH_TEXT_GQL_FIELD)]: (0, $6Tnq8.transformAggConnectRichTextToLegacyField),
        [(0, $5fc53.CONNECT_SINGLE_SELECT_GQL_FIELD)]: (0, $6mbsj.transformAggConnectSingleSelectToLegacyField),
        [(0, $5fc53.CONNECT_TEXT_GQL_FIELD)]: (0, $d3nG3.transformAggConnectTextToLegacyField),
        [(0, $5fc53.COLOR_GQL_FIELD)]: (0, $iv8Rf.transformAggColorToLegacyField),
        [(0, $5fc53.DATE_PICKER_GQL_FIELD)]: (0, $fW9XR.transformAggDatePickerToLegacyField),
        [(0, $5fc53.DATE_TIME_GQL_FIELD)]: (0, $bKMMB.transformAggDateTimePickerToLegacyField),
        [(0, $5fc53.EPIC_LINK_GQL_FIELD)]: (0, $7JL37.transformAggEpicLinkToLegacyField),
        [(0, $5fc53.FLAG_GQL_FIELD)]: (0, $dulCG.transformAggFlagToLegacyField),
        [(0, $5fc53.FORGE_DATETIME_GQL_FIELD)]: (0, $as0vY.transformAggForgeDateTimeToLegacyField),
        [(0, $5fc53.FORGE_DATE_GQL_FIELD)]: (0, $6vno6.transformAggForgeDateToLegacyField),
        [(0, $5fc53.FORGE_GROUP_GQL_FIELD)]: (0, $6dPLd.transformAggForgeGroupToLegacyField),
        [(0, $5fc53.FORGE_GROUPS_GQL_FIELD)]: (0, $gKccZ.transformAggForgeGroupsToLegacyField),
        [(0, $5fc53.FORGE_NUMBER_GQL_FIELD)]: (0, $jnUrZ.transformAggForgeNumberToLegacyField),
        [(0, $5fc53.FORGE_OBJECT_GQL_FIELD)]: (0, $iJtmd.transformAggForgeObjectToLegacyField),
        [(0, $5fc53.FORGE_STRING_GQL_FIELD)]: (0, $iPyq0.transformAggForgeStringToLegacyField),
        [(0, $5fc53.FORGE_STRINGS_GQL_FIELD)]: (0, $384lj.transformAggForgeStringsToLegacyField),
        [(0, $5fc53.FORGE_USER_GQL_FIELD)]: (0, $axTS6.transformAggForgeUserToLegacyField),
        [(0, $5fc53.FORGE_USERS_GQL_FIELD)]: (0, $lfJ6H.transformAggForgeUsersToLegacyField),
        [(0, $5fc53.ISSUE_RESTRICTION_GQL_FIELD)]: (0, $b6BoU.transformAggIssueRestrictionToLegacyField),
        [(0, $5fc53.ISSUE_TYPE_GQL_FIELD)]: (0, $gak3n.transformAggIssueTypeToLegacyField),
        [(0, $5fc53.JSM_APPROVAL_GQL_FIELD)]: (0, $i47fO.transformAggJSMApprovalsToLegacyField),
        [(0, $5fc53.JSM_ASSETS_GQL_FIELD)]: (0, $6iJEF.transformAggAssetToLegacyField),
        [(0, $5fc53.JSM_MAJOR_INCIDENT_FIELD)]: (0, $6XFn2.transformAggJSMMajorIncidentToLegacyField),
        [(0, $5fc53.JSM_ORGANIZATION_GQL_FIELD)]: (0, $6e1Ya.transformAggJSMOrganizationToLegacyField),
        [(0, $5fc53.JSM_ENTITLEMENTS_GQL_FIELD)]: (0, $gvljZ.transformAggJSMEntitlementsToLegacyField),
        [(0, $5fc53.JSM_SENTIMENT_GQL_FIELD)]: (0, $cXBkk.transformAggJSMSentimentToLegacyField),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        [(0, $5fc53.JSM_PEOPLE_GQL_FIELD)]: (0, $lkW3a.transformAggMultipleUserPickerToLegacyField),
        [(0, $5fc53.JSM_REQUEST_FEEDBACK_GQL_FIELD)]: (0, $hBEiJ.transformAggJSMRequestFeedbackToLegacyField),
        [(0, $5fc53.JSM_REQUEST_LANGUAGE_GQL_FIELD)]: (0, $1XNj2.transformAggJSMRequestLanguageToLegacyField),
        [(0, $5fc53.JSM_REQUEST_TYPE_GQL_FIELD)]: (0, $f6zXW.transformAggJSMRequestTypeToLegacyField),
        [(0, $5fc53.JSM_RESPONDERS_GQL_FIELD)]: (0, $fB4wX.transformAggJSMRespondersToLegacyField),
        [(0, $5fc53.LABEL_GQL_FIELD)]: (0, $iDKu3.transformAggLabelsNodeToLegacyField),
        [(0, $5fc53.PRIORITY_GQL_FIELD)]: (0, $6hj44.transformAggPriorityToLegacyField),
        [(0, $5fc53.MULTI_GROUP_PICKER_GQL_FIELD)]: (0, $aGv90.transformAggMultiGroupPickerToLegacyField),
        [(0, $5fc53.MULTI_USER_PICKER_GQL_FIELD)]: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $lkW3a.transformAggMultipleUserPickerToLegacyField),
        [(0, $5fc53.NUMBER_GQL_FIELD)]: (0, $8qOI6.transformAggNumberToLegacyField),
        [(0, $5fc53.ORIGINAL_ESTIMATE_GQL_FIELD)]: (0, $cbd7V.transformAggOriginalEstimateToLegacyField),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        [(0, $5fc53.PEOPLE_GQL_FIELD)]: (0, $lkW3a.transformAggMultipleUserPickerToLegacyField),
        [(0, $5fc53.PROFORMA_FORMS_GQL_FIELD)]: (0, $4nh4C.transformAggProformaFormsToLegacyField),
        [(0, $5fc53.PROJECT_GQL_FIELD)]: (0, $hA3EZ.transformAggProjectToLegacyField),
        [(0, $5fc53.MULTI_VERSION_GQL_FIELD)]: (0, $lQAwK.transformAggMultipleVersionPickerToLegacyField),
        [(0, $5fc53.RADIO_GQL_FIELD)]: (0, $2z4xE.transformAggRadioSelectToLegacyField),
        [(0, $5fc53.RICH_TEXT_GQL_FIELD)]: (0, $5sETx.transformAggRichTextToLegacyField),
        [(0, $5fc53.RESOLUTION_GQL_FIELD)]: (0, $cO2KQ.transformAggResolutionToLegacyField),
        [(0, $5fc53.SECURITY_GQL_FIELD)]: (0, $f454b.transformAggSecurityLevelToLegacyField),
        [(0, $5fc53.SPRINT_GQL_FIELD)]: (0, $38GNL.transformAggSprintToLegacyField),
        [(0, $5fc53.STATUS_GQL_FIELD)]: (0, $avV20.transformAggStatusToLegacyField),
        [(0, $5fc53.SINGLE_GROUP_PICKER_GQL_FIELD)]: (0, $aafIf.transformAggSingleGroupPickerToLegacyField),
        [(0, $5fc53.SINGLE_SELECT_GQL_FIELD)]: (0, $lUeQj.transformAggSingleSelectToLegacyField),
        [(0, $5fc53.TEAM_GQL_FIELD)]: (0, $cbXvu.transformAggTeamToLegacyField),
        [(0, $5fc53.TEAM_VIEW_GQL_FIELD)]: (0, $aSXJi.transformAggTeamViewToLegacyField),
        [(0, $5fc53.TEXT_GQL_FIELD)]: (0, $2yWre.transformAggSingleLineTextToLegacyField),
        [(0, $5fc53.TIME_TRACKING_GQL_FIELD)]: (0, $8uxcU.transformAggTimeTrackingToLegacyField),
        [(0, $5fc53.USER_PICKER_GQL_FIELD)]: (0, $6SWOK.transformAggSingleSelectUserPickerToLegacyField),
        [(0, $5fc53.URL_GQL_FIELD)]: (0, $arKlm.transformAggUrlToLegacyField),
        [(0, $5fc53.VERSION_GQL_FIELD)]: (0, $cMc7B.transformAggSingleVersionPickerToLegacyField),
        [(0, $5fc53.VOTES_GQL_FIELD)]: (0, $hCKV6.transformAggVotesToLegacyField),
        [(0, $5fc53.WATCHES_GQL_FIELD)]: (0, $d8wC0.transformAggWatchesToLegacyField),
        [(0, $5fc53.DATA_CLASSIFICATION_FIELD)]: (0, $1xW6n.transformAggDataClassificationToLegacyField),
        [(0, $5fc53.GOALS_GQL_FIELD)]: (0, $9UXU7.transformAggGoalsToLegacyField),
        [(0, $5fc53.JCS_ORGANIZATION_GQL_FIELD)]: (0, $640u2.transformAggJCSOrganizationToLegacyField)
    });
const $af5e8bab0defb9c8$var$getTransformers = (0, $8QpSo.default)($af5e8bab0defb9c8$var$getTransformersNonMemoised);
const $af5e8bab0defb9c8$export$586ba15cbf3d3031 = (node, projectContext)=>{
    const typename = node.__typename;
    const transformer = $af5e8bab0defb9c8$var$getTransformers()[typename];
    return transformer ? transformer(node, projectContext) : undefined;
};
const $af5e8bab0defb9c8$export$ba106ff8c087e6b1 = (fields, projectField)=>{
    if (fields == null) return {};
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return fields.reduce((fieldsState, fieldEdge)=>{
        if (fieldEdge?.node != null) {
            const projectContext = projectField != null ? projectField : (0, $hA3EZ.getProjectField)(fields)?.project;
            const transformedField = $af5e8bab0defb9c8$export$586ba15cbf3d3031(fieldEdge.node, projectContext);
            if (transformedField != null) {
                const fieldData = 'key' in transformedField ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                {
                    [transformedField.key]: transformedField
                } : transformedField;
                Object.assign(fieldsState, fieldData);
            }
        }
        return fieldsState;
    }, {});
};

});
parcelRegister("9bgym", function(module, exports) {

$parcel$export(module.exports, "transformAggAffectedServicesToLegacyField", () => $0bce5d1c363f27e8$export$231e0419515441d4);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $0bce5d1c363f27e8$var$transformJiraServicesToLegacyServices = ({ serviceId: serviceId, name: name })=>({
        id: serviceId,
        name: name ?? undefined
    });
const $0bce5d1c363f27e8$export$231e0419515441d4 = (node)=>{
    if (node.type !== (0, $5fc53.SERVICE_ENTITY_CF_TYPE)) return undefined;
    const hasValue = Boolean(node.selectedAffectedServicesConnection?.edges?.length);
    const value = hasValue ? (0, $o7K5u.transformAggConnection)(node.selectedAffectedServicesConnection, $0bce5d1c363f27e8$var$transformJiraServicesToLegacyServices) : null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        autoCompleteUrl: node.searchUrl != null ? `${node.searchUrl}?query=` : null,
        value: value,
        schema: {
            configuration: null,
            custom: (0, $5fc53.SERVICE_ENTITY_CF_TYPE),
            items: 'service-entity-field',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});
const $650578330a102f55$export$89b8c5d86c10a68c = 'atlassian-wiki-renderer';
const $650578330a102f55$export$a4a240cb4053b29f = 'jira-text-renderer';
const $650578330a102f55$export$840ed33fa94f7693 = 'frother-control-renderer';

parcelRegister("o7K5u", function(module, exports) {

$parcel$export(module.exports, "transformAggNodeToLegacyField", () => $cfa10031dfb7ad46$export$e7ea61856a169c36);
$parcel$export(module.exports, "transformAggConnection", () => $cfa10031dfb7ad46$export$daf92cda81d86cdc);
$parcel$export(module.exports, "toLegacyConnectOption", () => $cfa10031dfb7ad46$export$b5de5f3d2de73afc);
const $cfa10031dfb7ad46$export$e7ea61856a169c36 = (node)=>({
        ari: 'id' in node ? node.id : undefined,
        key: 'fieldId' in node && !!node.fieldId ? node.fieldId : '',
        title: 'name' in node ? node.name : '',
        editable: Boolean('isEditableInIssueView' in node ? node.isEditableInIssueView : 'fieldConfig' in node && node.fieldConfig != null && 'isEditable' in node.fieldConfig && node.fieldConfig.isEditable),
        required: Boolean('fieldConfig' in node && node.fieldConfig != null && 'isRequired' in node.fieldConfig && node.fieldConfig.isRequired),
        autoCompleteUrl: 'searchUrl' in node ? node.searchUrl : null,
        allowedValues: [],
        value: null,
        schema: {
            type: 'type' in node ? node.type : '',
            custom: null,
            system: null
        },
        description: 'description' in node && node.description ? node.description : undefined
    });
const $cfa10031dfb7ad46$export$daf92cda81d86cdc = (connection, transformCallback)=>{
    const edges = connection?.edges ?? [];
    if (transformCallback) return edges.map((edge)=>edge?.node != null ? transformCallback(edge.node) : null).filter(Boolean);
    return edges.map((edge)=>edge?.node).filter(Boolean);
};
const $cfa10031dfb7ad46$export$b5de5f3d2de73afc = (node)=>{
    if (!node) return null;
    return {
        value: node.value ?? null,
        id: parseInt(node.optionId, 10)
    };
};

});


parcelRegister("6iJEF", function(module, exports) {

$parcel$export(module.exports, "transformAggAssetToLegacyField", () => $b9f6b8590a60f3b3$export$2136dcd78a2ef18f);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $b9f6b8590a60f3b3$export$2136dcd78a2ef18f = (node)=>{
    switch(node.type){
        case 0, $5fc53.ASSETS_CF_TYPE:
            {
                const hasValue = Boolean(node.selectedAssetsConnection?.edges?.length);
                const assetValue = hasValue ? (0, $o7K5u.transformAggConnection)(node.selectedAssetsConnection, ({ appKey: appKey, originId: originId, serializedOrigin: serializedOrigin, value: value })=>({
                        appKey: appKey,
                        originId: originId,
                        serializedOrigin: serializedOrigin,
                        value: value
                    })) : null;
                return {
                    ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                    autoCompleteUrl: node.searchUrl,
                    value: assetValue,
                    schema: {
                        custom: node.type,
                        system: null,
                        items: 'sd-asset',
                        type: 'array',
                        renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                        configuration: null
                    }
                };
            }
        default:
            return undefined;
    }
};

});

parcelRegister("9UrtF", function(module, exports) {

$parcel$export(module.exports, "transformAggBooleanToLegacyField", () => $474331244347ccdb$export$4bd89b95f0d10de9);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $474331244347ccdb$export$4bd89b95f0d10de9 = (node)=>{
    switch(node.type){
        case 0, $5fc53.SERVICEDESK_INCIDENT_MANAGEMENT_TYPE:
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: {
                    alertLinking: {
                        enabled: node.value
                    }
                },
                schema: {
                    configuration: null,
                    items: null,
                    renderer: null,
                    custom: null,
                    system: (0, $5fc53.SERVICEDESK_INCIDENT_MANAGEMENT_TYPE),
                    type: (0, $5fc53.SERVICEDESK_INCIDENT_MANAGEMENT_TYPE)
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("hsEaK", function(module, exports) {

$parcel$export(module.exports, "transformAggCascadingSelectToLegacyField", () => $afb6a8576bf8d731$export$a8778af5ceb1017c);


var $o7K5u = parcelRequire("o7K5u");
const $afb6a8576bf8d731$export$a8778af5ceb1017c = (node)=>{
    let value = null;
    if (node.cascadingOption) {
        const { childOptionValue: childOptionValue, parentOptionValue: parentOptionValue } = node.cascadingOption;
        const child = childOptionValue ? {
            child: {
                id: childOptionValue.optionId,
                value: childOptionValue.value
            }
        } : {};
        value = {
            // assigned in the statement above
            id: parentOptionValue?.optionId,
            value: parentOptionValue?.value,
            ...child
        };
    }
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        allowedValues: [],
        schema: {
            type: 'option-with-child',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("2qu1N", function(module, exports) {

$parcel$export(module.exports, "transformAggCheckboxToLegacyField", () => $3efe07b8b545ea99$export$baa5afdbd8fd12d3);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $3efe07b8b545ea99$export$baa5afdbd8fd12d3 = (node)=>{
    switch(node.type){
        case 0, $5fc53.MULTI_CHECKBOXES_CF_TYPE:
            {
                // We're inlining the transformers per field here so it'll be easy to remove them once we make the allowedValues async
                const value = (0, $o7K5u.transformAggConnection)(node.selectedOptions, (option)=>({
                        id: option.optionId,
                        value: option.value ?? null,
                        ari: option.id
                    }));
                const allowedValues = (0, $o7K5u.transformAggConnection)(node.checkboxesFieldOptions, (option)=>({
                        id: option.optionId,
                        value: option.value ?? null,
                        ari: option.id
                    }));
                return {
                    ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                    value: value.length ? value : null,
                    allowedValues: allowedValues,
                    schema: {
                        type: 'array',
                        renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                        custom: node.type,
                        system: null,
                        items: 'option',
                        configuration: null
                    }
                };
            }
        default:
            return undefined;
    }
};

});

parcelRegister("16Zia", function(module, exports) {

$parcel$export(module.exports, "transformAggCMDBToLegacyField", () => $4d2c21f2e394ef74$export$93506453d9bb56ae);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $4d2c21f2e394ef74$var$transformObjectTypeToLegacy = (attribute, workspaceId)=>({
        workspaceId: workspaceId,
        id: `${workspaceId}:${attribute.objectTypeId}`,
        name: attribute.name,
        objectSchemaId: attribute.objectSchemaId,
        objectTypeId: attribute.objectTypeId,
        // `icon` is unused
        icon: {
            id: attribute.icon.id,
            name: attribute.icon.name,
            url16: attribute.icon.url16,
            url48: attribute.icon.url48
        }
    });
const $4d2c21f2e394ef74$var$transformCMDBConfigurationToLegacyConfiguration = (node)=>{
    if (!node.cmdbFieldConfig) return node.isInsightAvailable === false ? {
        isInsightAvailable: node.isInsightAvailable
    } : {};
    return {
        cmdbFieldConfig: {
            multiple: node.cmdbFieldConfig.multiple,
            objectSchemaId: node.cmdbFieldConfig.objectSchemaId.split('/')[2],
            attributesDisplayedOnIssue: (0, $o7K5u.transformAggConnection)(node.cmdbFieldConfig?.attributesDisplayedOnIssue),
            attributesIncludedInAutoCompleteSearch: (0, $o7K5u.transformAggConnection)(node.cmdbFieldConfig?.attributesIncludedInAutoCompleteSearch)
        },
        isInsightAvailable: node.isInsightAvailable,
        wasInsightRequestSuccessful: node.wasInsightRequestSuccessful
    };
};
const $4d2c21f2e394ef74$var$transformObjectTypeAttributeToLegacy = (type)=>{
    switch(type){
        case 'REFERENCED_OBJECT':
            return 1;
        case 'USER':
            return 2;
        case 'GROUP':
            return 4;
        case 'PROJECT':
            return 6;
        case 'STATUS':
            return 7;
        case 'BITBUCKET_REPO':
            return 8;
        case 'OPSGENIE_TEAM':
            return 9;
        case 'DEFAULT':
            return 0;
        default:
            // eslint-disable-next-line no-console
            console.error(new Error(`Unknown attribute type found in transformObjectTypeAttributeToLegacy: ${type}. Mapping type to '-1'`));
            return -1;
    }
};
const $4d2c21f2e394ef74$var$transformReferencedObject = (node)=>({
        id: node.objectGlobalId,
        workspaceId: node.workspaceId,
        objectKey: node.objectKey,
        label: node.label,
        avatar: node.avatar,
        objectId: node.objectId
    });
const $4d2c21f2e394ef74$var$transformCmdbUser = (node)=>({
        avatarUrl: node.picture,
        displayName: node.name,
        name: node.name,
        key: node.accountId
    });
const $4d2c21f2e394ef74$var$transformCmdbGroup = (node)=>({
        name: node.name
    });
const $4d2c21f2e394ef74$var$transformCmdbProject = (node)=>({
        avatarUrl: node.avatar?.large,
        id: Number(node.id),
        key: node.key,
        name: node.name
    });
const $4d2c21f2e394ef74$var$transformCmdbBitbucketRepo = (node)=>({
        uuid: node.uuid,
        name: node.name,
        url: node.url,
        avatarUrl: node.avatarUrl
    });
const $4d2c21f2e394ef74$var$transformCmdbOpsgenieTeam = (node)=>({
        id: node.id,
        name: node.name,
        url: node.url
    });
const $4d2c21f2e394ef74$var$transformCmdbStatus = (node)=>({
        id: node.id,
        name: node.name,
        category: node.category
    });
const $4d2c21f2e394ef74$var$transformObjectAttributeValuesToLegacy = (node)=>{
    if (!node) return null;
    const defaultObjectValue = {
        displayValue: node.displayValue,
        searchValue: node.searchValue,
        ...node.value != null ? {
            value: node.value
        } : {}
    };
    if (node.referencedObject) return {
        ...defaultObjectValue,
        referencedObject: $4d2c21f2e394ef74$var$transformReferencedObject(node.referencedObject)
    };
    if (node.user) return {
        ...defaultObjectValue,
        user: $4d2c21f2e394ef74$var$transformCmdbUser(node.user)
    };
    if (node.group) return {
        ...defaultObjectValue,
        group: $4d2c21f2e394ef74$var$transformCmdbGroup(node.group)
    };
    if (node.project) return {
        ...defaultObjectValue,
        project: $4d2c21f2e394ef74$var$transformCmdbProject(node.project)
    };
    if (node.bitbucketRepo) return {
        ...defaultObjectValue,
        bitbucketRepo: $4d2c21f2e394ef74$var$transformCmdbBitbucketRepo(node.bitbucketRepo)
    };
    if (node.opsgenieTeam) return {
        ...defaultObjectValue,
        opsgenieTeam: $4d2c21f2e394ef74$var$transformCmdbOpsgenieTeam(node.opsgenieTeam)
    };
    if (node.status) return {
        ...defaultObjectValue,
        status: $4d2c21f2e394ef74$var$transformCmdbStatus(node.status)
    };
    return defaultObjectValue;
};
const $4d2c21f2e394ef74$var$transformObjectAttributesToLegacyObjectAttributes = (node, workspaceId)=>{
    if (!node) return null;
    const { objectTypeAttributeId: objectTypeAttributeId, objectTypeAttribute: objectTypeAttribute } = node;
    return {
        objectTypeAttributeId: objectTypeAttributeId,
        workspaceId: workspaceId,
        objectAttributeValues: (0, $o7K5u.transformAggConnection)(node.objectAttributeValues, $4d2c21f2e394ef74$var$transformObjectAttributeValuesToLegacy),
        objectTypeAttribute: {
            id: objectTypeAttributeId,
            label: objectTypeAttribute.label,
            name: objectTypeAttribute.name,
            workspaceId: workspaceId,
            type: $4d2c21f2e394ef74$var$transformObjectTypeAttributeToLegacy(objectTypeAttribute.type),
            ...objectTypeAttribute.defaultType ? {
                defaultType: {
                    id: objectTypeAttribute.defaultType.id,
                    name: objectTypeAttribute.defaultType.name
                }
            } : {}
        }
    };
};
const $4d2c21f2e394ef74$var$transformJiraCMDBToLegacyCMDB = (node)=>{
    if (!node) return null;
    const { label: label, objectGlobalId: objectGlobalId, objectId: objectId, objectKey: objectKey, workspaceId: workspaceId, webUrl: webUrl, avatar: avatar } = node;
    return {
        attributes: (0, $o7K5u.transformAggConnection)(node.attributes, (nodeAttribute)=>$4d2c21f2e394ef74$var$transformObjectAttributesToLegacyObjectAttributes(nodeAttribute, workspaceId)),
        avatar: avatar,
        label: label,
        id: objectGlobalId,
        objectId: objectId,
        objectKey: objectKey,
        workspaceId: workspaceId,
        links: {
            self: webUrl
        },
        objectType: $4d2c21f2e394ef74$var$transformObjectTypeToLegacy(node.objectType, workspaceId)
    };
};
const $4d2c21f2e394ef74$export$93506453d9bb56ae = (node)=>{
    if (node.type !== (0, $5fc53.CMDB_OBJECT_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        autoCompleteUrl: node.searchUrl != null ? `${node.searchUrl}?` : null,
        configuration: $4d2c21f2e394ef74$var$transformCMDBConfigurationToLegacyConfiguration(node),
        value: (0, $o7K5u.transformAggConnection)(node.selectedCmdbObjectsConnection, $4d2c21f2e394ef74$var$transformJiraCMDBToLegacyCMDB),
        schema: {
            configuration: null,
            custom: (0, $5fc53.CMDB_OBJECT_CF_TYPE),
            items: 'cmdb-object-field',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("iv8Rf", function(module, exports) {

$parcel$export(module.exports, "transformAggColorToLegacyField", () => $b83a62ddd17b4586$export$587c178f1b45e5e9);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $b83a62ddd17b4586$export$587c178f1b45e5e9 = (node)=>{
    const value = node.color?.colorKey ?? null;
    switch(node.type){
        case 0, $5fc53.EPIC_COLOR_TYPE:
        case 0, $5fc53.COLOR_CF_TYPE:
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: value,
                schema: {
                    configuration: null,
                    type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
                    renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                    custom: node.type,
                    system: null,
                    items: null
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("hDlc2", function(module, exports) {

$parcel$export(module.exports, "transformAggComponentsToLegacyField", () => $315456e18e2330f5$export$97a9275777684b77);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
// @DoNotExport Flow is deriving component's type
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $315456e18e2330f5$var$transformJiraComponentToLegacyComponent = (component)=>{
    if (component == null) return null;
    return {
        id: component.componentId,
        name: component.name,
        ari: component.ari,
        metadata: component.metadata
    };
};
const $315456e18e2330f5$export$97a9275777684b77 = (node)=>{
    if (node.type !== (0, $5fc53.COMPONENTS_TYPE)) return undefined;
    const value = (0, $o7K5u.transformAggConnection)(node.selectedComponentsConnection, $315456e18e2330f5$var$transformJiraComponentToLegacyComponent);
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        allowedValues: [],
        value: value,
        schema: {
            configuration: null,
            items: 'component',
            renderer: (0, $650578330a102f55$export$840ed33fa94f7693),
            type: (0, $5fc53.ISSUE_FIELD_MULTI_SELECT_CF_TYPE),
            custom: null,
            system: (0, $5fc53.COMPONENTS_TYPE)
        }
    };
};

});

parcelRegister("c3LW9", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectDateTimeToLegacyField", () => $e80217ec1ee321d5$export$e6d015aa746cbdaf);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $e80217ec1ee321d5$export$e6d015aa746cbdaf = (node)=>({
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.dateTime ?? null,
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            custom: node.type,
            type: (0, $5fc53.ISSUE_FIELD_DATETIME_CF_TYPE)
        }
    });

});

parcelRegister("h92P3", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectMultipleSelectToLegacyField", () => $1bb7cdf99e93ff64$export$edf5c98d20696686);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $1bb7cdf99e93ff64$export$edf5c98d20696686 = (node)=>{
    const value = (0, $o7K5u.transformAggConnection)(node.selectedOptions, (0, $o7K5u.toLegacyConnectOption));
    const allowedValues = (0, $o7K5u.transformAggConnection)(node.connectMultiSelectFieldOptions, (0, $o7K5u.toLegacyConnectOption));
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value.length ? value : null,
        allowedValues: allowedValues,
        schema: {
            type: (0, $5fc53.ISSUE_FIELD_MULTI_SELECT_CF_TYPE),
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: (0, $5fc53.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE),
            configuration: null
        }
    };
};

});

parcelRegister("aeO9V", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectNumberToLegacyField", () => $b8a5823753f7873f$export$4638a5dd3285d8f2);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $b8a5823753f7873f$export$4638a5dd3285d8f2 = (node)=>({
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.number ?? null,
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            custom: node.type,
            type: (0, $5fc53.ISSUE_FIELD_NUMBER_CF_TYPE)
        }
    });

});

parcelRegister("6Tnq8", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectRichTextToLegacyField", () => $f9558299012f1c2e$export$11063e1f9210f191);

var $kz2lw = parcelRequire("kz2lw");


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $f9558299012f1c2e$var$emptyAdfObject = (0, $kz2lw.getEmptyADF)();
const $f9558299012f1c2e$var$getPlainTextValue = (node)=>{
    if (!node.richText) return null;
    if (node.richText.plainText == null) return '';
    return node.richText.plainText;
};
const $f9558299012f1c2e$export$11063e1f9210f191 = (node)=>{
    const { renderer: renderer } = node;
    if ((0, $dMYPq.default)(node)) return undefined;
    const isPlainTextRenderer = renderer === (0, $650578330a102f55$export$a4a240cb4053b29f);
    const values = isPlainTextRenderer ? {
        value: $f9558299012f1c2e$var$getPlainTextValue(node)
    } : {
        adfValue: node.richText?.adfValue?.json || $f9558299012f1c2e$var$emptyAdfObject
    };
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        ...values,
        schema: {
            custom: (0, $5fc53.TEXT_AREA_CF_TYPE),
            renderer: renderer,
            type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
            system: null,
            configuration: null,
            items: null
        }
    };
};

});
parcelRegister("dMYPq", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4fed9edf4c76e19$export$2e2bcd8739ae039);

var $2YZCu = parcelRequire("2YZCu");
const $f4fed9edf4c76e19$export$c63f561360bafed1 = 'issue.agg-field-transformers.missing-renderer';
// If the renderer is missing, log an error and return true.
// This was added as part of https://jplat.atlassian.net/browse/JIV-14881 to help identify why
// fields are sometimes missing the renderer.
const $f4fed9edf4c76e19$var$isFieldMissingRenderer = (field)=>{
    try {
        // Narrow the type of field to fields with a renderer
        if (!('renderer' in field)) return false;
        if (field?.renderer) return false;
        (0, $2YZCu.default).safeErrorWithoutCustomerData($f4fed9edf4c76e19$export$c63f561360bafed1, `Field ${field.fieldId} of type ${field.__typename} has missing renderer: ${field.renderer}`);
        return true;
    } catch  {
        return false;
    }
};
var $f4fed9edf4c76e19$export$2e2bcd8739ae039 = $f4fed9edf4c76e19$var$isFieldMissingRenderer;

});


parcelRegister("6mbsj", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectSingleSelectToLegacyField", () => $ceb0872dd5eafe49$export$e44db7cf61369a28);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $ceb0872dd5eafe49$export$e44db7cf61369a28 = (node)=>{
    let value = null;
    if (node.fieldOption != null) value = {
        id: parseInt(node.fieldOption?.optionId, 10),
        value: node.fieldOption?.value
    };
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        allowedValues: (0, $o7K5u.transformAggConnection)(node.connectSingleSelectFieldOptions, (0, $o7K5u.toLegacyConnectOption)),
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            custom: node.type,
            type: (0, $5fc53.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE)
        }
    };
};

});

parcelRegister("d3nG3", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectTextToLegacyField", () => $145b645a3d2e801e$export$dd05277f5aa90657);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $145b645a3d2e801e$export$dd05277f5aa90657 = (node)=>({
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.text,
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE)
        }
    });

});

parcelRegister("1xW6n", function(module, exports) {

$parcel$export(module.exports, "transformAggDataClassificationToLegacyField", () => $1a8d4561538d1d2b$export$b5edfdc89a7a2932);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $1a8d4561538d1d2b$export$b5edfdc89a7a2932 = (node)=>({
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        key: (0, $5fc53.DATA_CLASSIFICATION_TYPE),
        value: node,
        schema: {
            configuration: null,
            items: null,
            renderer: null,
            custom: null,
            system: null,
            type: (0, $5fc53.DATA_CLASSIFICATION_TYPE)
        }
    });

});

parcelRegister("fW9XR", function(module, exports) {

$parcel$export(module.exports, "transformAggDatePickerToLegacyField", () => $c44a652aaa9bff90$export$3d6e51d37c0454a9);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $c44a652aaa9bff90$export$3d6e51d37c0454a9 = (node)=>{
    switch(node.type){
        case 0, $5fc53.DUE_DATE_TYPE:
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: typeof node.date === 'string' ? node.date : null,
                schema: {
                    type: (0, $5fc53.ISSUE_FIELD_DATE_CF_TYPE),
                    configuration: null,
                    system: node.type,
                    renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                    custom: null,
                    items: null
                }
            };
        case 0, $5fc53.DATE_CF_TYPE:
        case 0, $5fc53.BASELINE_START_CF_TYPE:
        case 0, $5fc53.BASELINE_END_CF_TYPE:
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: typeof node.date === 'string' ? node.date : null,
                schema: {
                    type: (0, $5fc53.ISSUE_FIELD_DATE_CF_TYPE),
                    custom: node.type,
                    configuration: null,
                    renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                    system: null,
                    items: null
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("bKMMB", function(module, exports) {

$parcel$export(module.exports, "transformAggDateTimePickerToLegacyField", () => $fb29b1af2f1467e0$export$3de22f1277f0c239);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $fb29b1af2f1467e0$var$defaultSchema = {
    type: (0, $5fc53.ISSUE_FIELD_DATETIME_CF_TYPE),
    custom: null,
    system: null,
    configuration: null,
    items: null,
    renderer: (0, $650578330a102f55$export$a4a240cb4053b29f)
};
const $fb29b1af2f1467e0$export$3de22f1277f0c239 = (node)=>{
    switch(node.type){
        case 0, $5fc53.CREATED:
        case 0, $5fc53.UPDATED:
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: node.dateTime || '',
                schema: {
                    ...$fb29b1af2f1467e0$var$defaultSchema,
                    system: node.type,
                    renderer: null
                }
            };
        case 0, $5fc53.RESOLUTION_DATE:
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: node.dateTime ?? null,
                schema: {
                    ...$fb29b1af2f1467e0$var$defaultSchema,
                    system: node.type,
                    renderer: null
                }
            };
        case 0, $5fc53.DATETIME_CF_TYPE:
        case 0, $5fc53.FIRST_RESPONSE_DATE_CF_TYPE:
        case 0, $5fc53.REQUEST_FEEDBACK_DATE_CF_TYPE:
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: node.dateTime ?? null,
                schema: {
                    ...$fb29b1af2f1467e0$var$defaultSchema,
                    custom: node.type
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("7JL37", function(module, exports) {

$parcel$export(module.exports, "transformAggEpicLinkToLegacyField", () => $3279d658ea1a4982$export$1311f30c94840aa2);

var $7SCny = parcelRequire("7SCny");

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $3279d658ea1a4982$var$transformJiraEpicToLegacyEpicLink = (epic)=>{
    if (epic == null) return null;
    return {
        id: Number(epic.issueId),
        key: epic.key || '',
        done: !!epic.done,
        name: epic.name || '',
        summary: epic.summary || '',
        color: {
            key: epic.color ?? (0, $7SCny.AgileColors).AGILE_COLOR_1
        },
        // This can only be set from cache handlers
        fromCache: false
    };
};
const $3279d658ea1a4982$export$1311f30c94840aa2 = (node)=>{
    if (node.type !== (0, $5fc53.EPIC_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        autoCompleteUrl: node.searchUrl,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        value: $3279d658ea1a4982$var$transformJiraEpicToLegacyEpicLink(node.epic),
        schema: {
            configuration: null,
            items: null,
            renderer: 'jira-text-renderer',
            type: 'any',
            custom: (0, $5fc53.EPIC_TYPE),
            system: null
        }
    };
};

});
parcelRegister("7SCny", function(module, exports) {

$parcel$export(module.exports, "PURPLE", () => $8e4230f608d6b965$export$7ffdeca4b2f927a2);
$parcel$export(module.exports, "DARK_PURPLE", () => $8e4230f608d6b965$export$c815fe495e8174a0);
$parcel$export(module.exports, "BLUE", () => $8e4230f608d6b965$export$738c3b9a44c87ecc);
$parcel$export(module.exports, "DARK_BLUE", () => $8e4230f608d6b965$export$1225f83626261b80);
$parcel$export(module.exports, "GREEN", () => $8e4230f608d6b965$export$48d4b2cd5bc0e88b);
$parcel$export(module.exports, "DARK_GREEN", () => $8e4230f608d6b965$export$c6f4cf2e5768eb78);
$parcel$export(module.exports, "TEAL", () => $8e4230f608d6b965$export$d0446fe88325854e);
$parcel$export(module.exports, "DARK_TEAL", () => $8e4230f608d6b965$export$bb848c92687e69dc);
$parcel$export(module.exports, "YELLOW", () => $8e4230f608d6b965$export$aab610c505c06a8f);
$parcel$export(module.exports, "DARK_YELLOW", () => $8e4230f608d6b965$export$466af87757d343a2);
$parcel$export(module.exports, "ORANGE", () => $8e4230f608d6b965$export$3de5e29ed1757f9b);
$parcel$export(module.exports, "DARK_ORANGE", () => $8e4230f608d6b965$export$da02e4820b6ab753);
$parcel$export(module.exports, "GREY", () => $8e4230f608d6b965$export$7d278ca694634874);
$parcel$export(module.exports, "DARK_GREY", () => $8e4230f608d6b965$export$26453300bfc61cb8);
$parcel$export(module.exports, "COLORS", () => $8e4230f608d6b965$export$56d196d2844d1ca1);
$parcel$export(module.exports, "SERVER_PURPLE", () => $8e4230f608d6b965$export$792af22a0198af8d);
$parcel$export(module.exports, "SERVER_DARK_PURPLE", () => $8e4230f608d6b965$export$588af712afdcb006);
$parcel$export(module.exports, "SERVER_BLUE", () => $8e4230f608d6b965$export$84c4918645391802);
$parcel$export(module.exports, "SERVER_DARK_BLUE", () => $8e4230f608d6b965$export$b8f1f5838352a33a);
$parcel$export(module.exports, "SERVER_GREEN", () => $8e4230f608d6b965$export$9384b7e350ee6542);
$parcel$export(module.exports, "SERVER_DARK_GREEN", () => $8e4230f608d6b965$export$87d3fb8d8656d38b);
$parcel$export(module.exports, "SERVER_TEAL", () => $8e4230f608d6b965$export$b0b4ce3e99e66aae);
$parcel$export(module.exports, "SERVER_DARK_TEAL", () => $8e4230f608d6b965$export$a89b77a449bd223e);
$parcel$export(module.exports, "SERVER_YELLOW", () => $8e4230f608d6b965$export$9a33b5e3cde94885);
$parcel$export(module.exports, "SERVER_DARK_YELLOW", () => $8e4230f608d6b965$export$33253d7862bceb8a);
$parcel$export(module.exports, "SERVER_ORANGE", () => $8e4230f608d6b965$export$6609c2b23fc42f39);
$parcel$export(module.exports, "SERVER_DARK_ORANGE", () => $8e4230f608d6b965$export$cd994662b5911917);
$parcel$export(module.exports, "SERVER_GREY", () => $8e4230f608d6b965$export$1793d43e13e078c5);
$parcel$export(module.exports, "SERVER_DARK_GREY", () => $8e4230f608d6b965$export$487a6e9145526564);
$parcel$export(module.exports, "GHX_LABEL_1", () => $8e4230f608d6b965$export$e4bdf2d4c4bbb15e);
$parcel$export(module.exports, "GHX_LABEL_2", () => $8e4230f608d6b965$export$8f5c1c5512278dc6);
$parcel$export(module.exports, "GHX_LABEL_3", () => $8e4230f608d6b965$export$94ac87c81ed074a7);
$parcel$export(module.exports, "GHX_LABEL_4", () => $8e4230f608d6b965$export$6bc9ab1f489f76f7);
$parcel$export(module.exports, "GHX_LABEL_5", () => $8e4230f608d6b965$export$610a2c132b6fcf96);
$parcel$export(module.exports, "GHX_LABEL_6", () => $8e4230f608d6b965$export$8e4997dba71f1c40);
$parcel$export(module.exports, "GHX_LABEL_7", () => $8e4230f608d6b965$export$18a545b4e69b27b4);
$parcel$export(module.exports, "GHX_LABEL_8", () => $8e4230f608d6b965$export$27fff1a0d295292a);
$parcel$export(module.exports, "GHX_LABEL_9", () => $8e4230f608d6b965$export$e57aa662a56724e1);
$parcel$export(module.exports, "GHX_LABEL_10", () => $8e4230f608d6b965$export$4b0d63e2c3be2072);
$parcel$export(module.exports, "GHX_LABEL_11", () => $8e4230f608d6b965$export$457ecb9560f2bf83);
$parcel$export(module.exports, "GHX_LABEL_12", () => $8e4230f608d6b965$export$a866db37165a696c);
$parcel$export(module.exports, "GHX_LABEL_13", () => $8e4230f608d6b965$export$9b18447c1168a1b6);
$parcel$export(module.exports, "GHX_LABEL_14", () => $8e4230f608d6b965$export$93b9ad4020e271b7);
$parcel$export(module.exports, "AGILE_COLOR_1", () => $8e4230f608d6b965$export$5cd2af17b34de3e3);
$parcel$export(module.exports, "AGILE_COLOR_2", () => $8e4230f608d6b965$export$987671fa69482a7b);
$parcel$export(module.exports, "AGILE_COLOR_3", () => $8e4230f608d6b965$export$70ba8a5b1f4c7446);
$parcel$export(module.exports, "AGILE_COLOR_4", () => $8e4230f608d6b965$export$fcd1c42d8d3ebd36);
$parcel$export(module.exports, "AGILE_COLOR_5", () => $8e4230f608d6b965$export$f80a5bd2fa0ba256);
$parcel$export(module.exports, "AGILE_COLOR_6", () => $8e4230f608d6b965$export$37ad5ce8d2aeaf78);
$parcel$export(module.exports, "AGILE_COLOR_7", () => $8e4230f608d6b965$export$9dc62d5d151cb355);
$parcel$export(module.exports, "AGILE_COLOR_8", () => $8e4230f608d6b965$export$1ed15b30f5663f92);
$parcel$export(module.exports, "AGILE_COLOR_9", () => $8e4230f608d6b965$export$5d23a84d55ac1644);
$parcel$export(module.exports, "AGILE_COLOR_10", () => $8e4230f608d6b965$export$bf08c9a6ed42e349);
$parcel$export(module.exports, "AGILE_COLOR_11", () => $8e4230f608d6b965$export$66c5d8f0b5ff279c);
$parcel$export(module.exports, "AGILE_COLOR_12", () => $8e4230f608d6b965$export$da30755a37c3a597);
$parcel$export(module.exports, "AGILE_COLOR_13", () => $8e4230f608d6b965$export$721cf84faff6bf19);
$parcel$export(module.exports, "AGILE_COLOR_14", () => $8e4230f608d6b965$export$4b8f8666bd7b61dd);
$parcel$export(module.exports, "Colors", () => $8e4230f608d6b965$export$c537fa0d021d010b);
$parcel$export(module.exports, "ServerColors", () => $8e4230f608d6b965$export$d33d39828a18210a);
$parcel$export(module.exports, "ClassicEpicColors", () => $8e4230f608d6b965$export$f476e6e43e0101e7);
$parcel$export(module.exports, "AgileColors", () => $8e4230f608d6b965$export$4b7407b8700035bd);
/**
 * @fileoverview This file was moved from `@atlassian/jira-issue-epic-color-types`
 * so that these types do not require atlaskit dependencies.
 *
 * Color constants
 */ const $8e4230f608d6b965$export$7ffdeca4b2f927a2 = 'PURPLE';
const $8e4230f608d6b965$export$c815fe495e8174a0 = 'DARK_PURPLE';
const $8e4230f608d6b965$export$738c3b9a44c87ecc = 'BLUE';
const $8e4230f608d6b965$export$1225f83626261b80 = 'DARK_BLUE';
const $8e4230f608d6b965$export$48d4b2cd5bc0e88b = 'GREEN';
const $8e4230f608d6b965$export$c6f4cf2e5768eb78 = 'DARK_GREEN';
const $8e4230f608d6b965$export$d0446fe88325854e = 'TEAL';
const $8e4230f608d6b965$export$bb848c92687e69dc = 'DARK_TEAL';
const $8e4230f608d6b965$export$aab610c505c06a8f = 'YELLOW';
const $8e4230f608d6b965$export$466af87757d343a2 = 'DARK_YELLOW';
const $8e4230f608d6b965$export$3de5e29ed1757f9b = 'ORANGE';
const $8e4230f608d6b965$export$da02e4820b6ab753 = 'DARK_ORANGE';
const $8e4230f608d6b965$export$7d278ca694634874 = 'GREY';
const $8e4230f608d6b965$export$26453300bfc61cb8 = 'DARK_GREY';
const $8e4230f608d6b965$export$56d196d2844d1ca1 = [
    $8e4230f608d6b965$export$7ffdeca4b2f927a2,
    $8e4230f608d6b965$export$c815fe495e8174a0,
    $8e4230f608d6b965$export$738c3b9a44c87ecc,
    $8e4230f608d6b965$export$1225f83626261b80,
    $8e4230f608d6b965$export$48d4b2cd5bc0e88b,
    $8e4230f608d6b965$export$c6f4cf2e5768eb78,
    $8e4230f608d6b965$export$d0446fe88325854e,
    $8e4230f608d6b965$export$bb848c92687e69dc,
    $8e4230f608d6b965$export$aab610c505c06a8f,
    $8e4230f608d6b965$export$466af87757d343a2,
    $8e4230f608d6b965$export$3de5e29ed1757f9b,
    $8e4230f608d6b965$export$da02e4820b6ab753,
    $8e4230f608d6b965$export$7d278ca694634874,
    $8e4230f608d6b965$export$26453300bfc61cb8
];
const $8e4230f608d6b965$export$792af22a0198af8d = 'purple';
const $8e4230f608d6b965$export$588af712afdcb006 = 'dark_purple';
const $8e4230f608d6b965$export$84c4918645391802 = 'blue';
const $8e4230f608d6b965$export$b8f1f5838352a33a = 'dark_blue';
const $8e4230f608d6b965$export$9384b7e350ee6542 = 'green';
const $8e4230f608d6b965$export$87d3fb8d8656d38b = 'dark_green';
const $8e4230f608d6b965$export$b0b4ce3e99e66aae = 'teal';
const $8e4230f608d6b965$export$a89b77a449bd223e = 'dark_teal';
const $8e4230f608d6b965$export$9a33b5e3cde94885 = 'yellow';
const $8e4230f608d6b965$export$33253d7862bceb8a = 'dark_yellow';
const $8e4230f608d6b965$export$6609c2b23fc42f39 = 'orange';
const $8e4230f608d6b965$export$cd994662b5911917 = 'dark_orange';
const $8e4230f608d6b965$export$1793d43e13e078c5 = 'grey';
const $8e4230f608d6b965$export$487a6e9145526564 = 'dark_grey';
const $8e4230f608d6b965$export$e4bdf2d4c4bbb15e = 'ghx-label-1';
const $8e4230f608d6b965$export$8f5c1c5512278dc6 = 'ghx-label-2';
const $8e4230f608d6b965$export$94ac87c81ed074a7 = 'ghx-label-3';
const $8e4230f608d6b965$export$6bc9ab1f489f76f7 = 'ghx-label-4';
const $8e4230f608d6b965$export$610a2c132b6fcf96 = 'ghx-label-5';
const $8e4230f608d6b965$export$8e4997dba71f1c40 = 'ghx-label-6';
const $8e4230f608d6b965$export$18a545b4e69b27b4 = 'ghx-label-7';
const $8e4230f608d6b965$export$27fff1a0d295292a = 'ghx-label-8';
const $8e4230f608d6b965$export$e57aa662a56724e1 = 'ghx-label-9';
const $8e4230f608d6b965$export$4b0d63e2c3be2072 = 'ghx-label-10';
const $8e4230f608d6b965$export$457ecb9560f2bf83 = 'ghx-label-11';
const $8e4230f608d6b965$export$a866db37165a696c = 'ghx-label-12';
const $8e4230f608d6b965$export$9b18447c1168a1b6 = 'ghx-label-13';
const $8e4230f608d6b965$export$93b9ad4020e271b7 = 'ghx-label-14';
const $8e4230f608d6b965$export$5cd2af17b34de3e3 = 'color_1';
const $8e4230f608d6b965$export$987671fa69482a7b = 'color_2';
const $8e4230f608d6b965$export$70ba8a5b1f4c7446 = 'color_3';
const $8e4230f608d6b965$export$fcd1c42d8d3ebd36 = 'color_4';
const $8e4230f608d6b965$export$f80a5bd2fa0ba256 = 'color_5';
const $8e4230f608d6b965$export$37ad5ce8d2aeaf78 = 'color_6';
const $8e4230f608d6b965$export$9dc62d5d151cb355 = 'color_7';
const $8e4230f608d6b965$export$1ed15b30f5663f92 = 'color_8';
const $8e4230f608d6b965$export$5d23a84d55ac1644 = 'color_9';
const $8e4230f608d6b965$export$bf08c9a6ed42e349 = 'color_10';
const $8e4230f608d6b965$export$66c5d8f0b5ff279c = 'color_11';
const $8e4230f608d6b965$export$da30755a37c3a597 = 'color_12';
const $8e4230f608d6b965$export$721cf84faff6bf19 = 'color_13';
const $8e4230f608d6b965$export$4b8f8666bd7b61dd = 'color_14';
const $8e4230f608d6b965$export$c537fa0d021d010b = {
    PURPLE: $8e4230f608d6b965$export$7ffdeca4b2f927a2,
    DARK_PURPLE: $8e4230f608d6b965$export$c815fe495e8174a0,
    BLUE: $8e4230f608d6b965$export$738c3b9a44c87ecc,
    DARK_BLUE: $8e4230f608d6b965$export$1225f83626261b80,
    GREEN: $8e4230f608d6b965$export$48d4b2cd5bc0e88b,
    DARK_GREEN: $8e4230f608d6b965$export$c6f4cf2e5768eb78,
    TEAL: $8e4230f608d6b965$export$d0446fe88325854e,
    DARK_TEAL: $8e4230f608d6b965$export$bb848c92687e69dc,
    YELLOW: $8e4230f608d6b965$export$aab610c505c06a8f,
    DARK_YELLOW: $8e4230f608d6b965$export$466af87757d343a2,
    ORANGE: $8e4230f608d6b965$export$3de5e29ed1757f9b,
    DARK_ORANGE: $8e4230f608d6b965$export$da02e4820b6ab753,
    GREY: $8e4230f608d6b965$export$7d278ca694634874,
    DARK_GREY: $8e4230f608d6b965$export$26453300bfc61cb8
};
const $8e4230f608d6b965$export$d33d39828a18210a = {
    SERVER_PURPLE: $8e4230f608d6b965$export$792af22a0198af8d,
    SERVER_DARK_PURPLE: $8e4230f608d6b965$export$588af712afdcb006,
    SERVER_BLUE: $8e4230f608d6b965$export$84c4918645391802,
    SERVER_DARK_BLUE: $8e4230f608d6b965$export$b8f1f5838352a33a,
    SERVER_GREEN: $8e4230f608d6b965$export$9384b7e350ee6542,
    SERVER_DARK_GREEN: $8e4230f608d6b965$export$87d3fb8d8656d38b,
    SERVER_TEAL: $8e4230f608d6b965$export$b0b4ce3e99e66aae,
    SERVER_DARK_TEAL: $8e4230f608d6b965$export$a89b77a449bd223e,
    SERVER_YELLOW: $8e4230f608d6b965$export$9a33b5e3cde94885,
    SERVER_DARK_YELLOW: $8e4230f608d6b965$export$33253d7862bceb8a,
    SERVER_ORANGE: $8e4230f608d6b965$export$6609c2b23fc42f39,
    SERVER_DARK_ORANGE: $8e4230f608d6b965$export$cd994662b5911917,
    SERVER_GREY: $8e4230f608d6b965$export$1793d43e13e078c5,
    SERVER_DARK_GREY: $8e4230f608d6b965$export$487a6e9145526564
};
const $8e4230f608d6b965$export$f476e6e43e0101e7 = {
    GHX_LABEL_1: $8e4230f608d6b965$export$e4bdf2d4c4bbb15e,
    GHX_LABEL_2: $8e4230f608d6b965$export$8f5c1c5512278dc6,
    GHX_LABEL_3: $8e4230f608d6b965$export$94ac87c81ed074a7,
    GHX_LABEL_4: $8e4230f608d6b965$export$6bc9ab1f489f76f7,
    GHX_LABEL_5: $8e4230f608d6b965$export$610a2c132b6fcf96,
    GHX_LABEL_6: $8e4230f608d6b965$export$8e4997dba71f1c40,
    GHX_LABEL_7: $8e4230f608d6b965$export$18a545b4e69b27b4,
    GHX_LABEL_8: $8e4230f608d6b965$export$27fff1a0d295292a,
    GHX_LABEL_9: $8e4230f608d6b965$export$e57aa662a56724e1,
    GHX_LABEL_10: $8e4230f608d6b965$export$4b0d63e2c3be2072,
    GHX_LABEL_11: $8e4230f608d6b965$export$457ecb9560f2bf83,
    GHX_LABEL_12: $8e4230f608d6b965$export$a866db37165a696c,
    GHX_LABEL_13: $8e4230f608d6b965$export$9b18447c1168a1b6,
    GHX_LABEL_14: $8e4230f608d6b965$export$93b9ad4020e271b7
};
const $8e4230f608d6b965$export$4b7407b8700035bd = {
    AGILE_COLOR_1: $8e4230f608d6b965$export$5cd2af17b34de3e3,
    AGILE_COLOR_2: $8e4230f608d6b965$export$987671fa69482a7b,
    AGILE_COLOR_3: $8e4230f608d6b965$export$70ba8a5b1f4c7446,
    AGILE_COLOR_4: $8e4230f608d6b965$export$fcd1c42d8d3ebd36,
    AGILE_COLOR_5: $8e4230f608d6b965$export$f80a5bd2fa0ba256,
    AGILE_COLOR_6: $8e4230f608d6b965$export$37ad5ce8d2aeaf78,
    AGILE_COLOR_7: $8e4230f608d6b965$export$9dc62d5d151cb355,
    AGILE_COLOR_8: $8e4230f608d6b965$export$1ed15b30f5663f92,
    AGILE_COLOR_9: $8e4230f608d6b965$export$5d23a84d55ac1644,
    AGILE_COLOR_10: $8e4230f608d6b965$export$bf08c9a6ed42e349,
    AGILE_COLOR_11: $8e4230f608d6b965$export$66c5d8f0b5ff279c,
    AGILE_COLOR_12: $8e4230f608d6b965$export$da30755a37c3a597,
    AGILE_COLOR_13: $8e4230f608d6b965$export$721cf84faff6bf19,
    AGILE_COLOR_14: $8e4230f608d6b965$export$4b8f8666bd7b61dd
};

});


parcelRegister("dulCG", function(module, exports) {

$parcel$export(module.exports, "transformAggFlagToLegacyField", () => $f31e97d89b497c1c$export$31555b6ea19f4c2);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $f31e97d89b497c1c$var$transformJiraFlagToLegacyFlag = (flag)=>{
    if (flag == null || flag.isFlagged == null) return null;
    return [
        {
            value: flag.isFlagged
        }
    ];
};
const $f31e97d89b497c1c$export$31555b6ea19f4c2 = (node)=>{
    // Agg flag field comes back as multichecbox CF type instead of current graphql flagged CF type
    if (node.type !== (0, $5fc53.MULTI_CHECKBOXES_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: $f31e97d89b497c1c$var$transformJiraFlagToLegacyFlag(node.flag),
        schema: {
            configuration: null,
            custom: (0, $5fc53.FLAGGED_CF_TYPE),
            items: 'option',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("6vno6", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeDateToLegacyField", () => $f5e60b2709763004$export$30fccfce22948120);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $f5e60b2709763004$export$30fccfce22948120 = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.date,
        autoCompleteUrl: null,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_DATE_CF_TYPE)
        }
    };
};

});

parcelRegister("as0vY", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeDateTimeToLegacyField", () => $3520698819975afe$export$61b1f0cbd04c7b9c);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $3520698819975afe$export$61b1f0cbd04c7b9c = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.dateTime,
        autoCompleteUrl: null,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_DATETIME_CF_TYPE)
        }
    };
};

});

parcelRegister("6dPLd", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeGroupToLegacyField", () => $ce6b58a5b1f45912$export$60b03d63015cbb9f);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $ce6b58a5b1f45912$export$60b03d63015cbb9f = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.selectedGroup ? {
            name: node.selectedGroup.name
        } : null,
        autoCompleteUrl: null,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_SINGLE_GROUP_CF_TYPE)
        }
    };
};

});

parcelRegister("gKccZ", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeGroupsToLegacyField", () => $256d8054300c3cdf$export$2dfa4944fba5d1f5);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $256d8054300c3cdf$export$2dfa4944fba5d1f5 = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    const value = node.selectedGroupsConnection?.edges?.length ? (0, $o7K5u.transformAggConnection)(node.selectedGroupsConnection, ({ name: name })=>({
            name: name
        })) : null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            items: (0, $5fc53.ISSUE_FIELD_SINGLE_GROUP_CF_TYPE),
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
        }
    };
};

});

parcelRegister("jnUrZ", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeNumberToLegacyField", () => $c68528ed0dfd109c$export$5dab8986dc45db07);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $c68528ed0dfd109c$export$5dab8986dc45db07 = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.number,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_NUMBER_CF_TYPE)
        }
    };
};

});

parcelRegister("iJtmd", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeObjectToLegacyField", () => $c814454c00552e79$export$fbdabdbae2a203b9);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $c814454c00552e79$export$fbdabdbae2a203b9 = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    const value = (()=>{
        if (node.object == null) return null;
        try {
            return JSON.parse(node.object);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            throw new Error('Failed to transform forge object field: node.object was invalid JSON object');
        }
    })();
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_OBJECT_CF_TYPE)
        }
    };
};

});

parcelRegister("iPyq0", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeStringToLegacyField", () => $29f719811f573640$export$3a581fb4b3e578bd);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $29f719811f573640$export$3a581fb4b3e578bd = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.text,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE)
        }
    };
};

});

parcelRegister("384lj", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeStringsToLegacyField", () => $0d30cb879c19e1ba$export$418a06cb5dc6aba5);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $0d30cb879c19e1ba$export$418a06cb5dc6aba5 = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    const hasValue = Boolean(node.selectedLabelsConnection?.edges?.length);
    const value = hasValue ? (0, $o7K5u.transformAggConnection)(node.selectedLabelsConnection, ({ name: name })=>name) : null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        autoCompleteUrl: node.searchUrl,
        schema: {
            configuration: null,
            items: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
        }
    };
};

});

parcelRegister("axTS6", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeUserToLegacyField", () => $0669940239efeaff$export$bc73c7a747f907e5);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");

var $iob0v = parcelRequire("iob0v");
const $0669940239efeaff$export$bc73c7a747f907e5 = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.user ? (0, $iob0v.transformJiraUserToLegacyServerUser)(node.user) : null,
        autoCompleteUrl: node.searchUrl,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_USER_CF_TYPE)
        }
    };
};

});
parcelRegister("iob0v", function(module, exports) {

$parcel$export(module.exports, "transformJiraUserToLegacyServerUser", () => $42550039db1edc00$export$d7b231260a016eaf);

const $42550039db1edc00$var$getAccountType = (objectType)=>{
    switch(objectType){
        case 'AtlassianAccountUser':
            return 0, $145004f7a92e2423$export$981400c14dd99bc0;
        case 'CustomerUser':
            return 0, $145004f7a92e2423$export$2823897fb92cd040;
        case 'AppUser':
            return 0, $145004f7a92e2423$export$1973ca62b6c5abfe;
        default:
            return 0, $145004f7a92e2423$export$d1f5101c0939e3fe;
    }
};
const $42550039db1edc00$var$generateAvatarUrls = (url)=>({
        '16x16': url,
        '24x24': url,
        '32x32': url,
        '48x48': url
    });
const $42550039db1edc00$export$d7b231260a016eaf = (user)=>{
    if (!user) return null;
    const userOptionalKeysMap = {
        emailAddress: 'email',
        locale: 'locale',
        timeZone: 'zoneinfo'
    };
    const optionalValues = {};
    Object.entries(userOptionalKeysMap).forEach(([key, aggKey])=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const aggValue = user[aggKey];
        if (aggValue !== undefined && aggValue !== null) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        optionalValues[key] = aggValue;
    });
    const avatars = user.picture != null ? {
        avatarUrl: user.picture,
        avatarUrls: $42550039db1edc00$var$generateAvatarUrls(user.picture)
    } : {};
    return {
        ...avatars,
        ...optionalValues,
        accountId: user.accountId,
        accountType: $42550039db1edc00$var$getAccountType(user.__typename),
        active: user.accountStatus === 'active',
        displayName: user.name
    };
};

});
const $145004f7a92e2423$export$981400c14dd99bc0 = 'atlassian';
const $145004f7a92e2423$export$2823897fb92cd040 = 'customer';
const $145004f7a92e2423$export$1973ca62b6c5abfe = 'app';
const $145004f7a92e2423$export$d1f5101c0939e3fe = 'unknown';



parcelRegister("lfJ6H", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeUsersToLegacyField", () => $eb3ddd1fb571c94a$export$bbfea2e2f2c853b8);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");

var $iob0v = parcelRequire("iob0v");
const $eb3ddd1fb571c94a$export$bbfea2e2f2c853b8 = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    const value = node.selectedUsersConnection?.edges?.length ? (0, $o7K5u.transformAggConnection)(node.selectedUsersConnection, (0, $iob0v.transformJiraUserToLegacyServerUser)) : null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            items: (0, $5fc53.ISSUE_FIELD_USER_CF_TYPE),
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
        }
    };
};

});

parcelRegister("9UXU7", function(module, exports) {

$parcel$export(module.exports, "transformAggGoalsToLegacyField", () => $a8d444f432651533$export$158301a02ae4cbe7);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $a8d444f432651533$export$158301a02ae4cbe7 = (node)=>{
    if (node.type !== (0, $5fc53.GOALS_CF_TYPE)) return undefined;
    const value = node.selectedGoals ? {
        goals: node.selectedGoals?.edges?.filter((edge)=>edge?.node !== null).map((edge)=>({
                id: edge?.node?.id || '',
                name: edge?.node?.name || '',
                status: edge?.node?.status || null
            })) || [],
        totalCount: node.selectedGoals?.totalCount || 0
    } : null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            custom: (0, $5fc53.GOALS_CF_TYPE),
            items: null,
            renderer: null,
            system: null,
            type: (0, $5fc53.GOALS_CF_TYPE)
        }
    };
};

});

parcelRegister("b6BoU", function(module, exports) {

$parcel$export(module.exports, "transformAggIssueRestrictionToLegacyField", () => $d0a0e03637cc83cd$export$62db794d5816e28e);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $d0a0e03637cc83cd$var$transformJiraRoleToRestriction = (role)=>{
    if (role == null) return null;
    return {
        restrictionValue: role.roleId
    };
};
const $d0a0e03637cc83cd$export$62db794d5816e28e = (node, projectContext)=>{
    if (node.type !== (0, $5fc53.ISSUE_RESTRICTION_TYPE)) return undefined;
    const roles = (0, $o7K5u.transformAggConnection)(node.selectedRolesConnection, $d0a0e03637cc83cd$var$transformJiraRoleToRestriction);
    const restrictions = roles.length > 0 ? {
        projectrole: roles
    } : {};
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: {
            shouldDisplay: projectContext?.canSetIssueRestriction === true,
            issuerestrictions: restrictions
        },
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            type: (0, $5fc53.ISSUE_RESTRICTION_TYPE),
            custom: null,
            system: node.type
        }
    };
};

});

parcelRegister("gak3n", function(module, exports) {

$parcel$export(module.exports, "getSystemAggJiraIssueType", () => $4f9b530de681b60e$export$b4644a0cc2f2935e);
$parcel$export(module.exports, "transformJiraIssueTypeToLegacyIssueType", () => $4f9b530de681b60e$export$2356062173546155);
$parcel$export(module.exports, "transformAggIssueTypeToLegacyField", () => $4f9b530de681b60e$export$de2eb3b47c7c887b);


var $imYFg = parcelRequire("imYFg");

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $4f9b530de681b60e$export$d95e76b2d065f98d = {
    avatarId: 0,
    self: ''
};
const $4f9b530de681b60e$export$b4644a0cc2f2935e = (fields)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const issueTypeField = fields?.find((edge)=>edge?.node != null && edge.node.__typename === (0, $5fc53.ISSUE_TYPE_GQL_FIELD) && edge.node.type === (0, $5fc53.ISSUE_TYPE))?.node;
    if (issueTypeField == null || issueTypeField.__typename !== (0, $5fc53.ISSUE_TYPE_GQL_FIELD) || issueTypeField.type !== (0, $5fc53.ISSUE_TYPE)) throw new Error(`Failed to get system issue type: ${(0, $5fc53.ISSUE_TYPE_GQL_FIELD)} with ${(0, $5fc53.ISSUE_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(fields ?? '')}]`);
    if (issueTypeField.issueType == null) throw new Error(`Failed to get system issue type: ${(0, $5fc53.ISSUE_TYPE_GQL_FIELD)}.issueType is missing [${JSON.stringify(issueTypeField)}]`);
    return issueTypeField.issueType;
};
const $4f9b530de681b60e$export$2356062173546155 = (issueType)=>({
        ...$4f9b530de681b60e$export$d95e76b2d065f98d,
        id: issueType.issueTypeId,
        iconUrl: issueType.avatar?.medium ?? '',
        name: issueType.name,
        description: 'description' in issueType && issueType.description != null ? issueType.description : '',
        hierarchyLevel: issueType.hierarchy.level,
        subtask: issueType.hierarchy.level === (0, $imYFg.ISSUE_TYPE_HIERARCHY_LEVEL).SUBTASK_LEVEL
    });
const $4f9b530de681b60e$export$de2eb3b47c7c887b = (node)=>{
    if (node.type !== (0, $5fc53.ISSUE_TYPE) || node.issueType == null) throw new Error(`Failed to transform ${(0, $5fc53.ISSUE_TYPE_GQL_FIELD)}: type is not ${(0, $5fc53.ISSUE_TYPE)} or 'issueType' is empty [${JSON.stringify(node)}]`);
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: $4f9b530de681b60e$export$2356062173546155(node.issueType),
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: (0, $5fc53.ISSUE_TYPE),
            type: (0, $5fc53.ISSUE_TYPE)
        }
    };
};

});
parcelRegister("imYFg", function(module, exports) {

$parcel$export(module.exports, "ISSUE_TYPE_HIERARCHY_LEVEL", () => $ccb1a8095461a82a$export$2fe6880f0073407c);

var $g4tDr = parcelRequire("g4tDr");
const $ccb1a8095461a82a$export$2fe6880f0073407c = {
    SUBTASK_LEVEL: (0, $g4tDr.ISSUE_HIERARCHY_LEVEL_SUBTASK),
    BASE_LEVEL: (0, $g4tDr.ISSUE_HIERARCHY_LEVEL_BASE),
    LEVEL_ONE: (0, $g4tDr.ISSUE_HIERARCHY_LEVEL_EPIC),
    LEVEL_TWO: 2
};

});
parcelRegister("g4tDr", function(module, exports) {

$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_GOAL", () => $03dd5f7faa501890$export$2294cfc7730248df);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_STRATEGY", () => $03dd5f7faa501890$export$961a1d6da881600c);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_INITIATIVE", () => $03dd5f7faa501890$export$e11dea67b88ee556);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_EPIC", () => $03dd5f7faa501890$export$9ad20e435294162a);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_BASE", () => $03dd5f7faa501890$export$a454b3474c5ee5f5);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_SUBTASK", () => $03dd5f7faa501890$export$b69c1b48ce8f83de);
$parcel$export(module.exports, "BASE_HIERARCHY_TYPE", () => $03dd5f7faa501890$export$ba7c785763a2a58f);
$parcel$export(module.exports, "CHILD_HIERARCHY_TYPE", () => $03dd5f7faa501890$export$e09d07f2dcff2603);
$parcel$export(module.exports, "PARENT_HIERARCHY_TYPE", () => $03dd5f7faa501890$export$1165245f61159842);
$parcel$export(module.exports, "EPIC_PARENT_HIERARCHY_TYPE", () => $03dd5f7faa501890$export$8a96a83b3f957e58);
$parcel$export(module.exports, "toHierarchyLevel", () => $03dd5f7faa501890$export$c0c893ca5ccae9dd);
$parcel$export(module.exports, "isBaseHierarchyLevel", () => $03dd5f7faa501890$export$bcf91a9d8c5b0f58);
$parcel$export(module.exports, "isEpicHierarchyLevel", () => $03dd5f7faa501890$export$e415cf60723c7aae);
$parcel$export(module.exports, "isSubtaskHierarchyLevel", () => $03dd5f7faa501890$export$41f00a40e2ebd6e8);
$parcel$export(module.exports, "getHierarchyLevelType", () => $03dd5f7faa501890$export$556b686fea6fb229);
$parcel$export(module.exports, "getHierarchyLevelTypeSplitEpicFromCustom", () => $03dd5f7faa501890$export$638ac52227e67c8);
const $03dd5f7faa501890$export$2294cfc7730248df = 4;
const $03dd5f7faa501890$export$961a1d6da881600c = 3;
const $03dd5f7faa501890$export$e11dea67b88ee556 = 2;
const $03dd5f7faa501890$export$9ad20e435294162a = 1;
const $03dd5f7faa501890$export$a454b3474c5ee5f5 = 0;
const $03dd5f7faa501890$export$b69c1b48ce8f83de = -1;
const $03dd5f7faa501890$export$ba7c785763a2a58f = 'BASE';
const $03dd5f7faa501890$export$e09d07f2dcff2603 = 'CHILD';
const $03dd5f7faa501890$export$1165245f61159842 = 'PARENT';
const $03dd5f7faa501890$export$8a96a83b3f957e58 = 'EPIC';
const $03dd5f7faa501890$export$c0c893ca5ccae9dd = (level)=>level;
const $03dd5f7faa501890$export$bcf91a9d8c5b0f58 = (level)=>{
    const numericLevel = Number(level);
    if (Number.isNaN(numericLevel)) return true;
    return numericLevel === $03dd5f7faa501890$export$a454b3474c5ee5f5;
};
const $03dd5f7faa501890$export$e415cf60723c7aae = (level)=>{
    const numericLevel = Number(level);
    if (Number.isNaN(numericLevel)) return false;
    return numericLevel === $03dd5f7faa501890$export$9ad20e435294162a;
};
const $03dd5f7faa501890$export$41f00a40e2ebd6e8 = (level)=>{
    const numericLevel = Number(level);
    if (Number.isNaN(numericLevel)) return false;
    return numericLevel === $03dd5f7faa501890$export$b69c1b48ce8f83de;
};
const $03dd5f7faa501890$export$556b686fea6fb229 = (hierarchyLevel)=>{
    if (Number(hierarchyLevel) > 0) return $03dd5f7faa501890$export$1165245f61159842;
    if (Number(hierarchyLevel) < 0) return $03dd5f7faa501890$export$e09d07f2dcff2603;
    return $03dd5f7faa501890$export$ba7c785763a2a58f;
};
const $03dd5f7faa501890$export$638ac52227e67c8 = (hierarchyLevel)=>{
    if (Number(hierarchyLevel) === 1) return $03dd5f7faa501890$export$8a96a83b3f957e58;
    if (Number(hierarchyLevel) > 1) return $03dd5f7faa501890$export$1165245f61159842;
    if (Number(hierarchyLevel) < 0) return $03dd5f7faa501890$export$e09d07f2dcff2603;
    return $03dd5f7faa501890$export$ba7c785763a2a58f;
};

});



parcelRegister("i47fO", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMApprovalsToLegacyField", () => $448e6754d8bf50d1$export$b14d30f2a9e4c343);

var $9ar3z = parcelRequire("9ar3z");

var $5fc53 = parcelRequire("5fc53");

var $g5X3G = parcelRequire("g5X3G");

var $o7K5u = parcelRequire("o7K5u");

var $iob0v = parcelRequire("iob0v");
const $448e6754d8bf50d1$var$transformApproverPrincipalsToLegacy = (approverPrincipal)=>{
    if (!approverPrincipal) return undefined;
    switch(approverPrincipal.__typename){
        case 0, $5fc53.JSM_USER_APPROVER_PRINCIPAL_FIELD:
            return {
                id: (0, $g5X3G.toAccountId)(approverPrincipal.user.accountId),
                name: approverPrincipal.user.name,
                meta: {
                    jiraRest: approverPrincipal.jiraRest
                },
                type: 'user',
                avatarUrl: approverPrincipal.user.picture
            };
        case 0, $5fc53.JSM_GROUP_APPROVER_PRINCIPAL_FIELD:
            return {
                id: (0, $9ar3z.toGroupId)(approverPrincipal.groupId),
                meta: {
                    memberCount: approverPrincipal.memberCount,
                    approvedCount: approverPrincipal.approvedCount
                },
                name: approverPrincipal.name,
                type: 'group'
            };
        default:
            return undefined;
    }
};
const $448e6754d8bf50d1$var$getApproverDecision = (decision)=>{
    switch(decision){
        case 0, $9ar3z.APPROVER_APPROVED:
            return 0, $9ar3z.APPROVER_APPROVED;
        case 0, $9ar3z.APPROVER_DECLINED:
            return 0, $9ar3z.APPROVER_DECLINED;
        case 0, $9ar3z.APPROVER_PENDING:
        default:
            return 0, $9ar3z.APPROVER_PENDING;
    }
};
const $448e6754d8bf50d1$var$transformApproverToLegacy = (approvalNode)=>{
    if (!approvalNode) return undefined;
    const approver = (0, $iob0v.transformJiraUserToLegacyServerUser)(approvalNode.approver);
    if (!approver) return undefined;
    return {
        approverDecision: $448e6754d8bf50d1$var$getApproverDecision(approvalNode.approverDecision),
        approver: approver
    };
};
const $448e6754d8bf50d1$var$transformConfigurationToLegacy = (configurations)=>{
    // This function contains a lot of null checks and default empty values to satisfy flow because
    // the AGG type coming back is in the shape of [JiraServiceManagementApprovalConfiguration]
    // Which means technically it can be an empty array. Even though we will always only ever
    // get 1 object back.
    const { approversConfigurations: approversConfigurations = [], condition: condition } = configurations?.[0] || {};
    const approverConfiguration = approversConfigurations[0];
    return {
        approvers: {
            type: approverConfiguration?.type ?? '',
            customFieldName: approverConfiguration?.fieldName ?? '',
            customFieldId: approverConfiguration?.fieldId ?? ''
        },
        condition: {
            type: condition?.type ?? '',
            value: condition?.value ?? ''
        }
    };
};
const $448e6754d8bf50d1$var$transformDateToLegacy = (date)=>({
        epochMillis: new Date(date).valueOf()
    });
const $448e6754d8bf50d1$var$transformStatusToLegacy = (status)=>({
        name: status.name || '',
        category: Number(status.categoryId)
    });
const $448e6754d8bf50d1$var$transformActiveApprovalToLegacy = (activeApproval)=>{
    const { id: id, configurations: configurations, status: status, createdDate: createdDate, canAnswerApproval: canAnswerApproval, pendingApprovalCount: pendingApprovalCount, name: name, finalDecision: finalDecision, approvalState: approvalState, approvedStatus: approvedStatus } = activeApproval;
    return {
        id: id,
        approvalState: approvalState,
        approvedStatus: approvedStatus,
        finalDecision: $448e6754d8bf50d1$var$getApproverDecision(finalDecision),
        name: name,
        pendingApprovalCount: pendingApprovalCount,
        canAnswerApproval: canAnswerApproval,
        approverPrincipals: (0, $o7K5u.transformAggConnection)(activeApproval.approverPrincipals, $448e6754d8bf50d1$var$transformApproverPrincipalsToLegacy),
        approvers: (0, $o7K5u.transformAggConnection)(activeApproval.approvers, $448e6754d8bf50d1$var$transformApproverToLegacy),
        configuration: $448e6754d8bf50d1$var$transformConfigurationToLegacy(configurations),
        createdDate: $448e6754d8bf50d1$var$transformDateToLegacy(createdDate ?? ''),
        decisions: (0, $o7K5u.transformAggConnection)(activeApproval.decisions, $448e6754d8bf50d1$var$transformApproverToLegacy),
        excludedApprovers: (0, $o7K5u.transformAggConnection)(activeApproval.excludedApprovers, (0, $iob0v.transformJiraUserToLegacyServerUser)),
        status: status ? $448e6754d8bf50d1$var$transformStatusToLegacy(status) : null
    };
};
const $448e6754d8bf50d1$var$transformCompletedApprovalToLegacy = (completedApproval)=>{
    if (!completedApproval) return undefined;
    const { id: id, name: name, finalDecision: finalDecision, createdDate: createdDate, completedDate: completedDate, status: status } = completedApproval;
    return {
        id: id,
        name: name,
        finalDecision: $448e6754d8bf50d1$var$getApproverDecision(finalDecision),
        createdDate: $448e6754d8bf50d1$var$transformDateToLegacy(createdDate ?? ''),
        completedDate: $448e6754d8bf50d1$var$transformDateToLegacy(completedDate),
        status: status ? $448e6754d8bf50d1$var$transformStatusToLegacy(status) : null,
        approvers: (0, $o7K5u.transformAggConnection)(completedApproval.approvers, $448e6754d8bf50d1$var$transformApproverToLegacy)
    };
};
const $448e6754d8bf50d1$export$b14d30f2a9e4c343 = (node)=>{
    if (node.type !== (0, $5fc53.SERVICEDESK_APPROVAL_TYPE)) return undefined;
    const activeApproval = node.activeApproval ? {
        activeApproval: $448e6754d8bf50d1$var$transformActiveApprovalToLegacy(node.activeApproval)
    } : {};
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: {
            ...activeApproval,
            completedApprovals: (0, $o7K5u.transformAggConnection)(node.completedApprovalsConnection, $448e6754d8bf50d1$var$transformCompletedApprovalToLegacy)
        },
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: null,
            system: (0, $5fc53.SERVICEDESK_APPROVAL_TYPE),
            type: (0, $5fc53.SERVICEDESK_APPROVAL_TYPE)
        }
    };
};

});
parcelRegister("9ar3z", function(module, exports) {

$parcel$export(module.exports, "toGroupId", () => $4a7fc5eda3865b0e$export$779c261480444a4d);
$parcel$export(module.exports, "APPROVER_PENDING", () => $4a7fc5eda3865b0e$export$3b59c4db06f5829b);
$parcel$export(module.exports, "APPROVER_APPROVED", () => $4a7fc5eda3865b0e$export$e17ae8ca1010e2a4);
$parcel$export(module.exports, "APPROVER_DECLINED", () => $4a7fc5eda3865b0e$export$b5a0d270c9cd7435);
$parcel$export(module.exports, "APPROVAL_OK", () => $4a7fc5eda3865b0e$export$2e6187b6a4348938);
const $4a7fc5eda3865b0e$export$779c261480444a4d = (x)=>x;
const $4a7fc5eda3865b0e$export$3b59c4db06f5829b = 'pending';
const $4a7fc5eda3865b0e$export$e17ae8ca1010e2a4 = 'approved';
const $4a7fc5eda3865b0e$export$b5a0d270c9cd7435 = 'declined';
const $4a7fc5eda3865b0e$export$2e6187b6a4348938 = 'OK';
const $4a7fc5eda3865b0e$export$b5d660d719b8009 = 'INSUFFICIENT_APPROVERS';

});


parcelRegister("gvljZ", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMEntitlementsToLegacyField", () => $b281bef34e07e20f$export$850fadda8a5e6f27);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $b281bef34e07e20f$export$850fadda8a5e6f27 = (node)=>{
    if (node.type !== (0, $5fc53.ENTITLEMENT_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.selectedEntitlement,
        schema: {
            configuration: null,
            custom: (0, $5fc53.ENTITLEMENT_CF_TYPE),
            items: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("6XFn2", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMMajorIncidentToLegacyField", () => $926c732f6621d9fd$export$d4e0b2288fb31144);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $926c732f6621d9fd$export$d4e0b2288fb31144 = (node)=>({
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.majorIncident,
        renderedValue: null,
        configuration: {},
        schema: {
            configuration: null,
            custom: (0, $5fc53.MAJOR_INCIDENT_CF_TYPE),
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE)
        }
    });

});

parcelRegister("6e1Ya", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMOrganizationToLegacyField", () => $0e4eebb31cef7087$export$7bd14951253a7c5f);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $0e4eebb31cef7087$export$7bd14951253a7c5f = (node)=>{
    if (node.type !== (0, $5fc53.ORGANIZATIONS_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: (0, $o7K5u.transformAggConnection)(node.selectedOrganizationsConnection, (selectedNode)=>({
                id: selectedNode.organizationId,
                name: selectedNode.organizationName
            })),
        schema: {
            configuration: null,
            custom: (0, $5fc53.ORGANIZATIONS_CF_TYPE),
            items: 'sd-customerorganization',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("640u2", function(module, exports) {

$parcel$export(module.exports, "transformAggJCSOrganizationToLegacyField", () => $84b085b51db539b3$export$81bfe5b16f9be413);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $84b085b51db539b3$export$81bfe5b16f9be413 = (node)=>{
    if (node.type !== (0, $5fc53.ORGANIZATION_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.selectedOrganization,
        schema: {
            configuration: null,
            custom: (0, $5fc53.ORGANIZATION_CF_TYPE),
            items: 'sd-customerorganization',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("hBEiJ", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMRequestFeedbackToLegacyField", () => $841fa8e5b9308ced$export$c52c6988b335096);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $841fa8e5b9308ced$export$c52c6988b335096 = (node)=>{
    if (node.type !== (0, $5fc53.REQUEST_FEEDBACK_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.feedback,
        schema: {
            type: 'sd-feedback',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: (0, $5fc53.REQUEST_FEEDBACK_CF_TYPE),
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("1XNj2", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMRequestLanguageToLegacyField", () => $1edf1c9b37cdb462$export$6a53240e225f742);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $1edf1c9b37cdb462$export$6a53240e225f742 = (node)=>{
    if (node.type !== (0, $5fc53.REQUEST_LANGUAGE_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.language,
        allowedValues: [
            ...node.languages ?? []
        ],
        schema: {
            type: 'sd-request-lang',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: (0, $5fc53.REQUEST_LANGUAGE_CF_TYPE),
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("f6zXW", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMRequestTypeToLegacyField", () => $8030de3237296d5c$export$5ffaab1383177efa);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $8030de3237296d5c$var$transformRequestTypeToLegacy = (requestType)=>{
    if (!requestType) return null;
    return {
        requestType: {
            id: parseInt(requestType.requestTypeId, 10),
            issueTypeId: requestType.issueType?.issueTypeId || '',
            name: requestType.name || '',
            icon: {
                _links: {
                    iconUrls: {
                        '48x48': requestType.avatar?.large || ''
                    }
                }
            }
        }
    };
};
const $8030de3237296d5c$export$5ffaab1383177efa = (node)=>{
    if (node.type !== (0, $5fc53.REQUEST_TYPE_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        // @ts-expect-error - Argument of type '{ readonly avatar: { readonly large: string | null | undefined; readonly medium: string | null | undefined; readonly small: string | null | undefined; readonly xsmall: string | null | undefined; } | null | undefined; readonly id: string; readonly issueType: { ...; } | ... 1 more ... | undefined; readonly name: strin...' is not assignable to parameter of type '{ readonly avatar: { readonly large: string | null | undefined; readonly medium: string | null | undefined; readonly small: string | null | undefined; readonly xsmall: string | null | undefined; } | null | undefined; readonly id: string; readonly issueType: { ...; } | ... 1 more ... | undefined; readonly name: strin...'.
        value: $8030de3237296d5c$var$transformRequestTypeToLegacy(node.requestType),
        schema: {
            configuration: null,
            custom: (0, $5fc53.REQUEST_TYPE_CF_TYPE),
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'sd-customerrequesttype'
        }
    };
};

});

parcelRegister("fB4wX", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMRespondersToLegacyField", () => $0ea07ade045943f7$export$5171c4d1ae5bcde5);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $0ea07ade045943f7$var$transformJiraResponderToLegacyResponder = (responder)=>{
    if (responder == null) return undefined;
    switch(responder.__typename){
        case 0, $5fc53.JSM_USER_RESPONDER_GQL_FIELD:
            if (responder.user === null) return undefined;
            return {
                // @ts-expect-error - 'responder.user' is possibly 'undefined'.
                ari: responder.user.canonicalAccountId,
                // @ts-expect-error - 'responder.user' is possibly 'undefined'.
                avatarUrl: responder.user.picture,
                // @ts-expect-error - 'responder.user' is possibly 'undefined'.
                name: responder.user.name,
                type: 'user'
            };
        case 0, $5fc53.JSM_TEAM_RESPONDER_FIELD:
            return {
                // @ts-expect-error - Type 'string | null | undefined' is not assignable to type 'string | null'.
                ari: responder.teamId,
                // @ts-expect-error - Type 'string | null | undefined' is not assignable to type 'string | null'.
                name: responder.teamName,
                type: 'team'
            };
        default:
            return undefined;
    }
};
const $0ea07ade045943f7$export$5171c4d1ae5bcde5 = (node)=>{
    if (node.type !== (0, $5fc53.RESPONDERS_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        autoCompleteUrl: node.searchUrl != null ? `${node.searchUrl}?query=` : null,
        value: (0, $o7K5u.transformAggConnection)(node.respondersConnection, $0ea07ade045943f7$var$transformJiraResponderToLegacyResponder),
        schema: {
            configuration: null,
            custom: (0, $5fc53.RESPONDERS_CF_TYPE),
            items: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("cXBkk", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMSentimentToLegacyField", () => $5dcf9f49c6a1536d$export$702d3754a4c7d90a);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $5dcf9f49c6a1536d$export$702d3754a4c7d90a = (node)=>{
    if (node.type !== (0, $5fc53.SENTIMENT_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.sentiment,
        schema: {
            configuration: null,
            custom: (0, $5fc53.SENTIMENT_CF_TYPE),
            items: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("iDKu3", function(module, exports) {

$parcel$export(module.exports, "transformAggLabelsNodeToLegacyField", () => $5345161012c71e28$export$98e4f56e2e6c44fe);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $5345161012c71e28$var$defaultSchema = {
    configuration: null,
    items: 'string',
    type: (0, $5fc53.ISSUE_FIELD_MULTI_SELECT_CF_TYPE),
    renderer: (0, $650578330a102f55$export$a4a240cb4053b29f)
};
const $5345161012c71e28$export$98e4f56e2e6c44fe = (node)=>{
    const selectedLabels = (0, $o7K5u.transformAggConnection)(node.selectedLabelsConnection, ({ name: name })=>name);
    switch(node.type){
        case 0, $5fc53.LABELS_TYPE:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: selectedLabels,
                schema: {
                    ...$5345161012c71e28$var$defaultSchema,
                    custom: null,
                    system: node.type
                }
            };
        case 0, $5fc53.LABELS_CF_TYPE:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                // empty value for custom labels field is null while system labels field is `[]`
                value: selectedLabels.length === 0 ? null : selectedLabels,
                schema: {
                    ...$5345161012c71e28$var$defaultSchema,
                    custom: node.type,
                    system: null
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("aGv90", function(module, exports) {

$parcel$export(module.exports, "transformAggMultiGroupPickerToLegacyField", () => $ee565846dd4aef42$export$f968da580693597d);


var $o7K5u = parcelRequire("o7K5u");
const $ee565846dd4aef42$export$f968da580693597d = (node)=>{
    const value = (0, $o7K5u.transformAggConnection)(node.selectedGroupsConnection, (groupNode)=>({
            groupId: groupNode.groupId,
            name: groupNode.name
        }));
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value.length > 0 ? value : null,
        schema: {
            type: 'array',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: 'group',
            configuration: null
        }
    };
};

});

parcelRegister("19DRh", function(module, exports) {

$parcel$export(module.exports, "transformAggMultipleSelectToLegacyField", () => $d83d25c034b1d99f$export$869fb8fbcb97e0ee);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $d83d25c034b1d99f$export$869fb8fbcb97e0ee = (node)=>{
    switch(node.type){
        case 0, $5fc53.MULTI_SELECT_CF_TYPE:
            {
                const value = (0, $o7K5u.transformAggConnection)(node.selectedOptions, (option)=>({
                        id: option.optionId,
                        value: option.value ?? null,
                        ari: option.id
                    }));
                return {
                    ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                    value: value.length ? value : null,
                    allowedValues: [],
                    schema: {
                        type: 'array',
                        renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                        custom: node.type,
                        system: null,
                        items: 'option',
                        configuration: null
                    }
                };
            }
        default:
            return undefined;
    }
};

});

parcelRegister("lkW3a", function(module, exports) {

$parcel$export(module.exports, "transformAggMultipleUserPickerToLegacyField", () => $9b1f1d40e628c968$export$cdd9991119eb040e);

var $2vSU6 = parcelRequire("2vSU6");


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $hA3EZ = parcelRequire("hA3EZ");

var $iob0v = parcelRequire("iob0v");
const $9b1f1d40e628c968$export$cdd9991119eb040e = (node, projectContext)=>{
    const value = (0, $o7K5u.transformAggConnection)(node.selectedUsersConnection, (0, $iob0v.transformJiraUserToLegacyServerUser));
    const legacyFieldValues = {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value.length > 0 ? value : null,
        schema: {
            configuration: null,
            custom: node.type,
            items: 'user',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
    switch(node.type){
        case 0, $5fc53.REQUEST_PARTICIPANTS_CF_TYPE:
            if (node.__typename === (0, $5fc53.MULTI_USER_PICKER_GQL_FIELD)) return {
                ...legacyFieldValues,
                value: value
            };
            if ((0, $hA3EZ.getProjectType)(projectContext?.projectType) !== (0, $2vSU6.SERVICE_DESK_PROJECT)) return undefined;
            // Empty array is the expected value when there are no request
            // participants.
            return {
                ...legacyFieldValues,
                value: value
            };
        case 0, $5fc53.PARTICIPANTS_CF_TYPE:
        case 0, $5fc53.MULTI_USER_CF_TYPE:
            return legacyFieldValues;
        case 0, $5fc53.APPROVERS_LIST_CF_TYPE:
        case 0, $5fc53.PEOPLE_CF_TYPE:
            {
                const schemaConfig = 'isMulti' in node && node.isMulti != null ? [
                    {
                        key: 'isMulti',
                        value: String(node.isMulti)
                    }
                ] : null;
                return {
                    ...legacyFieldValues,
                    autoCompleteUrl: node.searchUrl,
                    schema: {
                        ...legacyFieldValues.schema,
                        configuration: schemaConfig
                    }
                };
            }
        default:
            return undefined;
    }
};

});
parcelRegister("hA3EZ", function(module, exports) {

$parcel$export(module.exports, "getProjectType", () => $e3d5807b112803bd$export$3dd0da95519c1a33);
$parcel$export(module.exports, "getProjectField", () => $e3d5807b112803bd$export$b19207d974ad5e77);
$parcel$export(module.exports, "getSystemAggJiraProject", () => $e3d5807b112803bd$export$d100105d56da4a0a);
$parcel$export(module.exports, "isAggJiraProjectClassic", () => $e3d5807b112803bd$export$3502ed01c034e451);
$parcel$export(module.exports, "transformAggSystemProjectToProjectContext", () => $e3d5807b112803bd$export$77162d1422f22f47);
$parcel$export(module.exports, "transformAggProjectToLegacyField", () => $e3d5807b112803bd$export$30c14b802399f417);

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");



var $5fc53 = parcelRequire("5fc53");

var $g5X3G = parcelRequire("g5X3G");

var $o7K5u = parcelRequire("o7K5u");
const $e3d5807b112803bd$var$getProjectStatus = (status)=>{
    switch(status){
        case 'ACTIVE':
            return 0, $cd476f3ecebdab63$export$62113557945f790a;
        case 'ARCHIVED':
            return 0, $cd476f3ecebdab63$export$4ccc35479ba9ad1;
        case 'DELETED':
            return 0, $cd476f3ecebdab63$export$a95d71e582b8bc0;
        default:
            // Based on `getProjectStatus` from src/packages/issue/issue-view/src/common/service/issue/issue-transformer.js
            return 0, $cd476f3ecebdab63$export$62113557945f790a;
    }
};
const $e3d5807b112803bd$export$3dd0da95519c1a33 = (projectType)=>{
    if (projectType === 'CUSTOMER_SERVICE' && (0, $4R6GH.fg)('jcs_project_type_m3')) return 0, $2vSU6.CUSTOMER_SERVICE_PROJECT;
    switch(projectType){
        case 'SERVICE_DESK':
            return 0, $2vSU6.SERVICE_DESK_PROJECT;
        case 'BUSINESS':
            return 0, $2vSU6.CORE_PROJECT;
        case 'SOFTWARE':
            return 0, $2vSU6.SOFTWARE_PROJECT;
        case 'PRODUCT_DISCOVERY':
            return 0, $2vSU6.PRODUCT_DISCOVERY_PROJECT;
        default:
            return null;
    }
};
const $e3d5807b112803bd$export$b19207d974ad5e77 = (fields)=>{
    /**
	 * The only way to get the type to return an optional value with `AggJiraProject` type
	 * is to re-assign the type wihtout throwing an error.
	 */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return fields?.find((edge)=>edge?.node?.__typename === (0, $5fc53.PROJECT_GQL_FIELD) && edge?.node?.type != null && edge.node.type === (0, $5fc53.PROJECT_TYPE))?.node;
};
const $e3d5807b112803bd$export$d100105d56da4a0a = (fields)=>{
    /**
	 * We only want the system `PROJECT_TYPE` field.
	 * For custom fields, e.g., project picker, see `transformAggProjectToLegacyField`
	 */ const projectField = $e3d5807b112803bd$export$b19207d974ad5e77(fields);
    // Needs the `PROJECT_GQL_FIELD` refinement so we can return as `AggJiraProject`
    if (projectField == null || projectField.__typename !== (0, $5fc53.PROJECT_GQL_FIELD)) throw new Error(`Failed to get system project data: ${(0, $5fc53.PROJECT_GQL_FIELD)} with ${(0, $5fc53.PROJECT_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(fields ?? '')}]`);
    if (projectField.project == null) throw new Error(`Failed to get system project data: ${(0, $5fc53.PROJECT_GQL_FIELD)}.project is missing [${JSON.stringify(projectField)}]`);
    return projectField.project;
};
const $e3d5807b112803bd$export$f7d5cb97957d02e3 = (project)=>project?.projectStyle === 'TEAM_MANAGED_PROJECT';
const $e3d5807b112803bd$export$3502ed01c034e451 = (project)=>!$e3d5807b112803bd$export$f7d5cb97957d02e3(project);
const $e3d5807b112803bd$var$transformAggProjectToServerProjectOption = (project)=>{
    if (project == null) return null;
    const { projectId: projectId, key: key, name: name, avatar: avatar } = project;
    return {
        name: name,
        id: projectId ?? undefined,
        key: (0, $g5X3G.toProjectKey)(key),
        avatarUrls: {
            '48x48': avatar?.large || ''
        }
    };
};
const $e3d5807b112803bd$export$77162d1422f22f47 = (project)=>{
    const { projectId: projectId, name: name, key: key, avatar: avatar, status: status, projectType: type, navigationMetadata: navigationMetadata } = project;
    const projectType = $e3d5807b112803bd$export$3dd0da95519c1a33(type);
    if (projectType == null) throw new Error(`Failed to transform system project: projectType ${String(type)} was invalid`);
    return {
        projectId: projectId,
        projectType: projectType,
        projectName: name,
        projectKey: key,
        projectStatus: $e3d5807b112803bd$var$getProjectStatus(status),
        avatarUrl: avatar?.medium,
        isSimplified: $e3d5807b112803bd$export$f7d5cb97957d02e3(project),
        boardId: navigationMetadata?.boardId
    };
};
const $e3d5807b112803bd$export$275f121d4e6f5165 = (fields)=>{
    const project = $e3d5807b112803bd$export$d100105d56da4a0a(fields);
    return $e3d5807b112803bd$export$77162d1422f22f47(project);
};
const $e3d5807b112803bd$var$transformAggProjectToLegacyProjectPickerField = (node)=>({
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        allowedValues: [],
        value: $e3d5807b112803bd$var$transformAggProjectToServerProjectOption(node.project),
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            type: (0, $5fc53.PROJECT_TYPE),
            custom: (0, $5fc53.PROJECT_PICKER_CF_TYPE),
            system: null
        }
    });
const $e3d5807b112803bd$var$transformAggProjectToLegacySimilarIssuesField = (node)=>{
    // Similar issues field only exist in JSM projects
    if ($e3d5807b112803bd$export$3dd0da95519c1a33(node.project?.projectType) !== (0, $2vSU6.SERVICE_DESK_PROJECT)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        key: (0, $5fc53.SIMILAR_ISSUES_TYPE),
        title: (0, $5fc53.SIMILAR_ISSUES_TYPE),
        value: node.project?.similarIssues?.featureEnabled === true,
        schema: {
            configuration: null,
            items: null,
            renderer: null,
            type: (0, $5fc53.SIMILAR_ISSUES_TYPE),
            custom: null,
            system: (0, $5fc53.SIMILAR_ISSUES_TYPE)
        }
    };
};
const $e3d5807b112803bd$var$transformAggProjectToLegacyProjectField = (node)=>{
    if (node?.__typename !== (0, $5fc53.PROJECT_GQL_FIELD) || node?.type === null || node?.type !== (0, $5fc53.PROJECT_TYPE)) throw new Error(`Failed to get system project data: ${(0, $5fc53.PROJECT_GQL_FIELD)} with ${(0, $5fc53.PROJECT_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(node)}]`);
    const projectField = node;
    if (projectField == null || projectField.__typename !== (0, $5fc53.PROJECT_GQL_FIELD)) throw new Error(`Failed to get system project data: ${(0, $5fc53.PROJECT_GQL_FIELD)} with ${(0, $5fc53.PROJECT_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(node ?? '')}]`);
    if (projectField.project == null) throw new Error(`Failed to get system project data: ${(0, $5fc53.PROJECT_GQL_FIELD)}.project is missing [${JSON.stringify(projectField)}]`);
    const project = projectField.project;
    const { projectType: type } = project;
    const projectType = $e3d5807b112803bd$export$3dd0da95519c1a33(type);
    if (projectType == null) throw new Error(`Failed to transform project: projectType ${String(project?.projectType)} was invalid`);
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: {
            projectType: projectType
        }
    };
};
const $e3d5807b112803bd$var$transformAggProjectToLegacyFieldByType = (node)=>{
    const projectType = $e3d5807b112803bd$export$3dd0da95519c1a33(node.project?.projectType);
    if (projectType === (0, $2vSU6.SERVICE_DESK_PROJECT)) // Similar issues field only exist in JSM projects
    return $e3d5807b112803bd$var$transformAggProjectToLegacySimilarIssuesField(node);
    if (projectType === (0, $2vSU6.PRODUCT_DISCOVERY_PROJECT)) return $e3d5807b112803bd$var$transformAggProjectToLegacyProjectField(node);
    return undefined;
};
const $e3d5807b112803bd$export$30c14b802399f417 = (node)=>{
    if ((0, $4R6GH.fg)('jpd_idea_panel_in_issue_view')) switch(node.type){
        case 0, $5fc53.PROJECT_PICKER_CF_TYPE:
            return $e3d5807b112803bd$var$transformAggProjectToLegacyProjectPickerField(node);
        case 0, $5fc53.PROJECT_TYPE:
            // For the system project, see `transformAggProjectToProjectContext`
            return $e3d5807b112803bd$var$transformAggProjectToLegacyFieldByType(node);
        default:
            return undefined;
    }
    else switch(node.type){
        case 0, $5fc53.PROJECT_PICKER_CF_TYPE:
            return $e3d5807b112803bd$var$transformAggProjectToLegacyProjectPickerField(node);
        case 0, $5fc53.PROJECT_TYPE:
            // For the system project, see `transformAggProjectToProjectContext`
            return $e3d5807b112803bd$var$transformAggProjectToLegacySimilarIssuesField(node);
        default:
            return undefined;
    }
};

});
const $cd476f3ecebdab63$export$62113557945f790a = 'PROJECT_ACTIVE';
const $cd476f3ecebdab63$export$4ccc35479ba9ad1 = 'PROJECT_ARCHIVED';
const $cd476f3ecebdab63$export$a95d71e582b8bc0 = 'PROJECT_TRASHED';



parcelRegister("lQAwK", function(module, exports) {

$parcel$export(module.exports, "transformAggMultipleVersionPickerToLegacyField", () => $dc0acfee4cadcdcd$export$6207ea60703068d8);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $149sa = parcelRequire("149sa");
const $dc0acfee4cadcdcd$var$defaultSchema = {
    configuration: null,
    custom: null,
    items: 'version',
    renderer: (0, $650578330a102f55$export$840ed33fa94f7693),
    system: null,
    type: 'array'
};
const $dc0acfee4cadcdcd$export$6207ea60703068d8 = (node)=>{
    if (node.type !== (0, $5fc53.MULTI_VERSION_CF_TYPE) && node.type !== (0, $5fc53.AFFECTS_VERSIONS_TYPE) && node.type !== (0, $5fc53.FIX_VERSIONS_TYPE)) return undefined;
    const legacyFieldValues = {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        allowedValues: [],
        value: (0, $o7K5u.transformAggConnection)(node.selectedVersionsConnection, (0, $149sa.transformAggVersionToLegacyVersion))
    };
    switch(node.type){
        case 0, $5fc53.MULTI_VERSION_CF_TYPE:
            return {
                ...legacyFieldValues,
                value: legacyFieldValues.value.length === 0 ? null : legacyFieldValues.value,
                schema: {
                    ...$dc0acfee4cadcdcd$var$defaultSchema,
                    custom: (0, $5fc53.MULTI_VERSION_CF_TYPE)
                }
            };
        case 0, $5fc53.AFFECTS_VERSIONS_TYPE:
        case 0, $5fc53.FIX_VERSIONS_TYPE:
            return {
                ...legacyFieldValues,
                schema: {
                    ...$dc0acfee4cadcdcd$var$defaultSchema,
                    system: node.type
                }
            };
        default:
            return undefined;
    }
};

});
parcelRegister("149sa", function(module, exports) {

$parcel$export(module.exports, "transformAggVersionToLegacyVersion", () => $4617842fe98d5759$export$becef8d087e8b62b);

var $jPhQo = parcelRequire("jPhQo");
const $4617842fe98d5759$export$becef8d087e8b62b = (version)=>({
        id: version.versionId ?? '',
        name: version.name ?? '',
        description: version.description ?? '',
        archived: version.status === (0, $jPhQo.VersionStatus).ARCHIVED,
        released: version.status === (0, $jPhQo.VersionStatus).RELEASED,
        ari: version.id
    });

});
parcelRegister("jPhQo", function(module, exports) {

$parcel$export(module.exports, "VersionStatus", () => $b5bd69c03cab3461$export$8c6e0f93bfb5c6a4);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports




var $imYFg = parcelRequire("imYFg");

var $5fc53 = parcelRequire("5fc53");

const $b5bd69c03cab3461$export$8c6e0f93bfb5c6a4 = {
    ARCHIVED: 'ARCHIVED',
    RELEASED: 'RELEASED',
    UNRELEASED: 'UNRELEASED'
};

});



parcelRegister("8qOI6", function(module, exports) {

$parcel$export(module.exports, "transformAggNumberToLegacyField", () => $b542e2b397d83c88$export$d754a24ed0096d2f);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $b542e2b397d83c88$export$d754a24ed0096d2f = (node)=>{
    const fieldType = node.isStoryPointField === true ? (0, $5fc53.STORY_POINTS_TYPE) : node.type;
    switch(fieldType){
        case 0, $5fc53.NUMBER_CF_TYPE:
        case 0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE:
        case 0, $5fc53.STORY_POINTS_TYPE:
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: node.number ?? null,
                schema: {
                    configuration: null,
                    items: null,
                    renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                    custom: fieldType,
                    system: null,
                    type: (0, $5fc53.ISSUE_FIELD_NUMBER_CF_TYPE)
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("cbd7V", function(module, exports) {

$parcel$export(module.exports, "transformAggOriginalEstimateToLegacyField", () => $47597066e94f8347$export$f08d02fdc74f920e);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $47597066e94f8347$export$f08d02fdc74f920e = (node)=>{
    if (node.type !== (0, $5fc53.TIME_ESTIMATE_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.originalEstimate?.timeInSeconds ?? null,
        schema: {
            configuration: null,
            custom: null,
            system: node.type,
            items: null,
            type: (0, $5fc53.ISSUE_FIELD_NUMBER_CF_TYPE),
            renderer: null
        }
    };
};

});

parcelRegister("6hj44", function(module, exports) {

$parcel$export(module.exports, "transformAggPriorityToLegacyField", () => $47c25f6616be0140$export$9e966ce605f800d2);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $47c25f6616be0140$var$transformJiraPriorityToLegacyPriority = (priority)=>{
    if (priority == null) return null;
    return {
        id: priority.priorityId,
        iconUrl: String(priority.iconUrl || ''),
        name: priority.name || '',
        sequence: priority.sequence || undefined
    };
};
const $47c25f6616be0140$export$9e966ce605f800d2 = (node)=>{
    if (node.type !== (0, $5fc53.PRIORITY_TYPE)) return undefined;
    const allowedValues = (0, $o7K5u.transformAggConnection)('priorities' in node ? node.priorities : null, $47c25f6616be0140$var$transformJiraPriorityToLegacyPriority);
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        allowedValues: allowedValues,
        // @ts-expect-error - Argument of type '{ readonly color: string | null | undefined; readonly iconUrl: string | null | undefined; readonly name: string | null | undefined; readonly priorityId: string; } | { readonly iconUrl: string | ... 1 more ... | undefined; readonly name: string | ... 1 more ... | undefined; readonly priorityId: string; } | { ...; } |...' is not assignable to parameter of type 'AggJiraPriority | null'.
        value: $47c25f6616be0140$var$transformJiraPriorityToLegacyPriority(node.priority),
        schema: {
            type: (0, $5fc53.PRIORITY_TYPE),
            custom: null,
            system: (0, $5fc53.PRIORITY_TYPE),
            configuration: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f)
        }
    };
};

});

parcelRegister("4nh4C", function(module, exports) {

$parcel$export(module.exports, "transformAggProformaFormsToLegacyField", () => $27d464e5749e1114$export$fdcdbf17b0d4e36f);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $27d464e5749e1114$export$fdcdbf17b0d4e36f = (node)=>{
    if (node.type !== (0, $5fc53.PROFORMA_FORMS)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.proformaForms,
        schema: {
            configuration: null,
            items: null,
            system: (0, $5fc53.PROFORMA_FORMS),
            custom: null,
            renderer: null,
            type: (0, $5fc53.PROFORMA_FORMS)
        }
    };
};

});

parcelRegister("2z4xE", function(module, exports) {

$parcel$export(module.exports, "transformAggRadioSelectToLegacyField", () => $b545e68fef1c7c25$export$f147f1eb3a15ccfc);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $b545e68fef1c7c25$export$f147f1eb3a15ccfc = (node)=>{
    if (node.type !== (0, $5fc53.RADIO_BUTTONS_CF_TYPE)) return undefined;
    const value = node.selectedOption ? {
        id: node.selectedOption?.optionId,
        value: node.selectedOption?.value,
        isDisabled: node.selectedOption?.isDisabled
    } : null;
    const allowedValues = (0, $o7K5u.transformAggConnection)(node.radioSelectFieldOptions, (option)=>({
            id: option.optionId,
            value: option.value ?? null,
            ari: option.id
        }));
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        allowedValues: allowedValues,
        schema: {
            type: 'option',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("cO2KQ", function(module, exports) {

$parcel$export(module.exports, "transformAggResolutionToLegacyField", () => $b13d1a2c3ca9d3cb$export$179f600c7e1d0230);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $b13d1a2c3ca9d3cb$var$resolutionTransformer = (resolution)=>{
    if (resolution == null) return null;
    return {
        id: resolution.resolutionId,
        name: resolution.name || ''
    };
};
const $b13d1a2c3ca9d3cb$export$179f600c7e1d0230 = (node)=>{
    if (node.type !== (0, $5fc53.RESOLUTION_TYPE)) return undefined;
    const value = $b13d1a2c3ca9d3cb$var$resolutionTransformer(node.resolution);
    const allowedValues = (0, $o7K5u.transformAggConnection)(node.resolutions, $b13d1a2c3ca9d3cb$var$resolutionTransformer);
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        allowedValues: allowedValues,
        schema: {
            type: (0, $5fc53.RESOLUTION_TYPE),
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: null,
            system: (0, $5fc53.RESOLUTION_TYPE),
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("5sETx", function(module, exports) {

$parcel$export(module.exports, "transformAggRichTextToLegacyField", () => $181b5722dae42ee4$export$e65ff2ce94be106e);

var $kz2lw = parcelRequire("kz2lw");


var $5fc53 = parcelRequire("5fc53");

var $fCo6Y = parcelRequire("fCo6Y");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $181b5722dae42ee4$var$emptyAdfObject = (0, $kz2lw.getEmptyADF)();
const $181b5722dae42ee4$var$getSchema = (aggType, renderer)=>{
    switch(aggType){
        case 0, $5fc53.TEXT_AREA_CF_TYPE:
            return {
                custom: aggType,
                renderer: renderer,
                type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
                system: null,
                configuration: null,
                items: null
            };
        case 0, $5fc53.DESCRIPTION_TYPE:
        case 0, $5fc53.ENVIRONMENT_TYPE:
        default:
            return {
                system: aggType,
                renderer: renderer,
                type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
                custom: null,
                configuration: null,
                items: null
            };
    }
};
// Exactly match the legacy /graphql value, handling the case where the field is empty and has never been edited
// There's no functional difference between `null` or empty string when rendering the field in the issue view.
const $181b5722dae42ee4$var$getPlainTextValue = (node)=>{
    // When the field is empty and a value has never been set
    if (!node.richText) return null;
    // When the field has been set to a value, and then set back to empty
    if (node.richText?.plainText == null) return '';
    return node.richText?.plainText;
};
const $181b5722dae42ee4$export$e65ff2ce94be106e = (node)=>{
    // Description field always renders with ADF
    const { renderer: renderer } = node;
    if ((0, $dMYPq.default)(node)) return undefined;
    const isPlainTextRenderer = node.type !== (0, $5fc53.DESCRIPTION_TYPE) && renderer === (0, $650578330a102f55$export$a4a240cb4053b29f);
    if (isPlainTextRenderer) return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: $181b5722dae42ee4$var$getPlainTextValue(node),
        schema: $181b5722dae42ee4$var$getSchema(node.type, renderer)
    };
    const adfValueJson = node.richText?.adfValue?.json ?? null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        // The usages of the collection is deprecated.
        adfValue: adfValueJson ? (0, $fCo6Y.removeCollectionFromAdf)(adfValueJson) : $181b5722dae42ee4$var$emptyAdfObject,
        value: null,
        schema: $181b5722dae42ee4$var$getSchema(node.type, renderer)
    };
};

});
parcelRegister("fCo6Y", function(module, exports) {

$parcel$export(module.exports, "emptyAdfObject", () => $79bd166f69131b05$export$202742e99f678c60);
$parcel$export(module.exports, "removeCollectionFromAdf", () => $79bd166f69131b05$export$9e9311e676291037);
$parcel$export(module.exports, "convertAdfStringToObject", () => $79bd166f69131b05$export$ee70d4eb14697455);
$parcel$export(module.exports, "isOnlyWhitespaceAdf", () => $79bd166f69131b05$export$cf4bde415465976c);
$parcel$export(module.exports, "removeNewLineCharactersFromAdf", () => $79bd166f69131b05$export$d6ce0667c33b94ff);
$parcel$export(module.exports, "removeTrailingNewLineCharacters", () => $79bd166f69131b05$export$3688e35a300432d6);
$parcel$export(module.exports, "simplifyAdf", () => $79bd166f69131b05$export$def86d25f0c7f0bc);
$parcel$export(module.exports, "hasEmojiNode", () => $79bd166f69131b05$export$8c6c40d1455b914a);
$parcel$export(module.exports, "hasMediaFileNodes", () => $79bd166f69131b05$export$9a632b58fb9b287c);
$parcel$export(module.exports, "hasMediaFileNodesUpdated", () => $79bd166f69131b05$export$80a6e90c7b29d88c);

var $lmhF9 = parcelRequire("lmhF9");
var $l1C1k = parcelRequire("l1C1k");

var $2YZCu = parcelRequire("2YZCu");
const $79bd166f69131b05$export$202742e99f678c60 = {
    type: 'doc',
    version: 1,
    content: []
};
const $79bd166f69131b05$export$9e9311e676291037 = (adf)=>{
    if (adf === null || adf === undefined) return null;
    if (adf.type === 'media' && adf.attrs) return {
        ...adf,
        attrs: {
            ...adf.attrs,
            collection: ''
        }
    };
    if (adf.type === 'mediaInline' && adf.attrs) return {
        ...adf,
        attrs: {
            ...adf.attrs,
            collection: ''
        }
    };
    if (adf.content) return {
        ...adf,
        content: adf.content.map($79bd166f69131b05$export$9e9311e676291037)
    };
    return adf;
};
const $79bd166f69131b05$export$ee70d4eb14697455 = (adf)=>{
    if (typeof adf === 'string') try {
        return $79bd166f69131b05$export$9e9311e676291037(JSON.parse(adf));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('rich-content.convert-adf-to-object', 'Failed to parse rich content', error);
        return null;
    }
    return $79bd166f69131b05$export$9e9311e676291037(adf);
};
const $79bd166f69131b05$export$cf4bde415465976c = (adf)=>adf && adf.content ? adf.content.every((content)=>{
        if (content.type === 'paragraph') return !content.content || content.content.length === 0 || content.content.every((innerContent)=>innerContent.type === 'text' ? (innerContent.text || '').match(/^\s*$/) !== null : false);
        return false;
    }) : false;
const $79bd166f69131b05$export$d6ce0667c33b94ff = (adf)=>{
    if (!adf || !adf.content) return $79bd166f69131b05$export$202742e99f678c60;
    let len;
    for(len = adf.content.length - 1; len >= 0 && adf.content[len].content && adf.content[len].type === 'paragraph' && adf.content[len].content.length === 0; len -= 1){
        // if the last item of the node is of type mediaGroup, we don't want to strip newline character as
        // it practically makes it unclickable. Leave a new line character so there is still some space for ppl to click
        if (len > 0 && adf.content[len - 1].type === 'mediaGroup') break;
    }
    return {
        ...adf,
        content: adf.content.slice(0, len + 1)
    };
};
const $79bd166f69131b05$export$3688e35a300432d6 = (text)=>text.replace(/[\r\n]+$/, '');
const $79bd166f69131b05$export$def86d25f0c7f0bc = (adf)=>$79bd166f69131b05$export$cf4bde415465976c(adf) ? $79bd166f69131b05$export$202742e99f678c60 : adf;
const $79bd166f69131b05$export$8c6c40d1455b914a = (doc)=>{
    let hasEmoji = false;
    (0, $l1C1k.traverse)(doc, {
        emoji: ()=>{
            hasEmoji = true;
            return false; // stop traversing
        }
    });
    return hasEmoji;
};
const $79bd166f69131b05$export$9a632b58fb9b287c = (doc)=>{
    const mediaNodes = new Map();
    (0, $l1C1k.traverse)(doc, {
        media: (node)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mediaNode = node;
            if (mediaNode.attrs.type === 'external') return;
            mediaNodes.set(mediaNode.attrs.id, node);
        },
        mediaInline: (node)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mediaInlineNode = node;
            mediaNodes.set(mediaInlineNode.attrs.id, node);
        }
    });
    return mediaNodes.size > 0;
};
const $79bd166f69131b05$export$80a6e90c7b29d88c = (currentDoc, newDoc)=>{
    const currentMediaNodes = new Set();
    const newMediaNodes = new Set();
    const updatedMediaNodes = new Set();
    if (newDoc) (0, $l1C1k.traverse)(newDoc, {
        media: (node)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mediaNode = node;
            if (mediaNode.attrs.type === 'external') return;
            newMediaNodes.add(mediaNode.attrs.id);
        },
        mediaInline: (node)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mediaInlineNode = node;
            newMediaNodes.add(mediaInlineNode.attrs.id);
        }
    });
    if (currentDoc) (0, $l1C1k.traverse)(currentDoc, {
        media: (node)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mediaNode = node;
            if (mediaNode.attrs.type === 'external') return;
            currentMediaNodes.add(mediaNode.attrs.id);
            if (newMediaNodes.size) {
                const matchedNode = newMediaNodes.has(mediaNode.attrs.id);
                if (!matchedNode) updatedMediaNodes.add(mediaNode.attrs.id);
            }
        },
        mediaInline: (node)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mediaInlineNode = node;
            currentMediaNodes.add(mediaInlineNode.attrs.id);
            if (newMediaNodes.size) {
                const matchedNode = newMediaNodes.has(mediaInlineNode.attrs.id);
                if (!matchedNode) updatedMediaNodes.add(mediaInlineNode.attrs.id);
            }
        }
    });
    return currentMediaNodes.size !== newMediaNodes.size || !!updatedMediaNodes.size;
};
const $79bd166f69131b05$export$ddf077301434502d = (doc)=>{
    if (doc === null || doc === undefined) return false;
    const nonSimpleTextNodes = (0, $lmhF9.filter)(doc, (node)=>node.type !== 'paragraph' && node.type !== 'doc' && node.type !== 'text');
    return nonSimpleTextNodes.length === 0;
};



const $79bd166f69131b05$export$2277e89f0b6d4ed = async (node)=>{
    // the imports here were kept async so as not to blow the bundle sizes for everyone
    const { defaultSchema: defaultSchema } = await (parcelRequire("hr7QF"));
    const { WikiMarkupTransformer: WikiMarkupTransformer } = await (parcelRequire("7y1vK"));
    const { JSONTransformer: JSONTransformer } = await (parcelRequire("76p3g"));
    const jsonTransformer = new JSONTransformer();
    const wikiMarkupTransformer = new WikiMarkupTransformer(defaultSchema);
    if (node === null || node === undefined) return '';
    const pmNode = jsonTransformer.parse(node);
    return wikiMarkupTransformer.encode(pmNode);
};

});
parcelRegister("lmhF9", function(module, exports) {

$parcel$export(module.exports, "filter", () => $cb7d90be6f5f5975$export$3dea766d36a8935f);

var $l1C1k = parcelRequire("l1C1k");
function $cb7d90be6f5f5975$export$3dea766d36a8935f(adf, callback) {
    const result = [];
    (0, $l1C1k.traverse)(adf, {
        any: (node)=>{
            if (callback(node)) result.push(node);
        }
    });
    return result;
}

});
parcelRegister("l1C1k", function(module, exports) {

$parcel$export(module.exports, "traverse", () => $b903aab814d8ed47$export$df3f009e3d155b20);
function $b903aab814d8ed47$export$735cfea22ce30f58(_visitors) {
    return true;
}
function $b903aab814d8ed47$export$df3f009e3d155b20(adf, visitors) {
    if (!$b903aab814d8ed47$export$735cfea22ce30f58(visitors)) throw new Error(`Visitors are not valid: "${Object.keys(visitors).join(', ')}"`);
    return $b903aab814d8ed47$var$traverseNode(adf, {
        node: undefined
    }, visitors, 0, 0);
}
function $b903aab814d8ed47$var$traverseNode(adfNode, parent, visitors, index, depth) {
    const visitor = visitors[adfNode.type] || visitors['any'];
    let newNode = {
        ...adfNode
    };
    if (visitor) {
        const processedNode = visitor({
            ...newNode
        }, parent, index, depth);
        if (processedNode === false) return false;
        newNode = processedNode || adfNode;
    }
    if (newNode.content) newNode.content = newNode.content.reduce((acc, node, idx)=>{
        if (!node) return acc;
        const processedNode = $b903aab814d8ed47$var$traverseNode(node, {
            node: newNode,
            parent: parent
        }, visitors, idx, depth + 1);
        if (processedNode !== false) acc.push(processedNode);
        return acc;
    }, []);
    return newNode;
}

});


parcelRegister("hr7QF", function(module, exports) {

let $cb1b0bd85c89df65$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cb1b0bd85c89df65$var$load("kI93O").then(()=>parcelRequire('kOFhM'));

});

parcelRegister("7y1vK", function(module, exports) {

let $57ece16cf096b3ea$var$load = (parcelRequire("28QjX"))(4);
module.exports = $57ece16cf096b3ea$var$load("9ZhML").then(()=>parcelRequire('dN5CS'));

});

parcelRegister("76p3g", function(module, exports) {

let $52bc86acca96045c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $52bc86acca96045c$var$load("a7dPb").then(()=>parcelRequire('hYNZx'));

});



parcelRegister("f454b", function(module, exports) {

$parcel$export(module.exports, "transformAggSecurityLevelToLegacyField", () => $811c3c0495fb451c$export$45e25e2a6750ea5a);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $811c3c0495fb451c$var$transformJiraSecurityLevel = (securityLevel)=>{
    if (securityLevel == null) return null;
    return {
        id: securityLevel.securityId,
        description: securityLevel.description || '',
        name: securityLevel.name || ''
    };
};
const $811c3c0495fb451c$export$45e25e2a6750ea5a = (node)=>({
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: $811c3c0495fb451c$var$transformJiraSecurityLevel(node.securityLevel),
        allowedValues: (0, $o7K5u.transformAggConnection)(node.securityLevels, $811c3c0495fb451c$var$transformJiraSecurityLevel),
        schema: {
            configuration: null,
            type: (0, $5fc53.SECURITY_LEVEL_TYPE_OVERRIDE),
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: null,
            system: (0, $5fc53.SECURITY_LEVEL_TYPE),
            items: null
        }
    });

});

parcelRegister("aafIf", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleGroupPickerToLegacyField", () => $950a9b8297396bb3$export$e6697ec5bdac9ec0);


var $o7K5u = parcelRequire("o7K5u");
const $950a9b8297396bb3$export$e6697ec5bdac9ec0 = (node)=>{
    const value = node.selectedGroup != null ? {
        groupId: node.selectedGroup.groupId,
        name: node.selectedGroup.name
    } : null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            type: 'group',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("2yWre", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleLineTextToLegacyField", () => $f5309f9bc8791ddf$export$31f32b3fd9e5ab6);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $f5309f9bc8791ddf$var$defaultSchema = {
    configuration: null,
    items: null,
    renderer: (0, $650578330a102f55$export$a4a240cb4053b29f)
};
const $f5309f9bc8791ddf$export$31f32b3fd9e5ab6 = (node)=>{
    const defaultTransformedField = {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.text
    };
    switch(node.type){
        case 0, $5fc53.EPIC_NAME_TYPE:
        case 0, $5fc53.MESSAGE_EDIT_CF_TYPE:
        case 0, $5fc53.MESSAGE_VIEW_CF_TYPE:
        case 0, $5fc53.READ_ONLY_CF_TYPE:
        case 0, $5fc53.TEXT_CF_TYPE:
        case 0, $5fc53.USER_PROPERTY_CF_TYPE:
            return {
                ...defaultTransformedField,
                schema: {
                    ...$f5309f9bc8791ddf$var$defaultSchema,
                    custom: node.type,
                    system: null,
                    type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE)
                }
            };
        case 0, $5fc53.RANK_CF_TYPE:
            return {
                ...defaultTransformedField,
                schema: {
                    ...$f5309f9bc8791ddf$var$defaultSchema,
                    custom: node.type,
                    system: null,
                    type: (0, $5fc53.ISSUE_FIELD_ANY_CF_TYPE)
                }
            };
        case 0, $5fc53.SUMMARY_TYPE:
            return {
                ...defaultTransformedField,
                schema: {
                    ...$f5309f9bc8791ddf$var$defaultSchema,
                    type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
                    custom: null,
                    system: node.type
                }
            };
        case 0, $5fc53.SERVICEDESK_PRACTICES_TYPE:
            // Transform field only if the practice has a value
            return node.text != null ? {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: [
                    node.text
                ],
                schema: {
                    ...$f5309f9bc8791ddf$var$defaultSchema,
                    renderer: null,
                    custom: null,
                    system: node.type,
                    type: (0, $5fc53.SERVICEDESK_PRACTICES_TYPE)
                }
            } : undefined;
        default:
            return undefined;
    }
};

});

parcelRegister("lUeQj", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleSelectToLegacyField", () => $9513f3f43c691d67$export$4e113f935e09d226);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $9513f3f43c691d67$var$getField = (node, customType)=>{
    const value = node.fieldOption != null ? {
        ari: node.fieldOption.id,
        id: node.fieldOption.optionId,
        value: node.fieldOption.value
    } : null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            type: 'option',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: customType || node.type,
            system: null,
            items: null,
            configuration: null
        }
    };
};
const $9513f3f43c691d67$export$4e113f935e09d226 = (node)=>{
    switch(node.type){
        case 0, $5fc53.EPIC_STATUS_TYPE:
        case 0, $5fc53.SELECT_CF_TYPE:
            return $9513f3f43c691d67$var$getField(node);
        case 0, $5fc53.CATEGORY_TYPE:
            return $9513f3f43c691d67$var$getField(node, (0, $5fc53.SELECT_CF_TYPE));
        default:
            return undefined;
    }
};

});

parcelRegister("6SWOK", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleSelectUserPickerToLegacyField", () => $7348765074cf60a5$export$7bf73fc06c6d71be);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $iob0v = parcelRequire("iob0v");
const $7348765074cf60a5$export$7bf73fc06c6d71be = (node)=>{
    const legacyField = {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.user ? (0, $iob0v.transformJiraUserToLegacyServerUser)(node.user) : null
    };
    switch(node.type){
        case 0, $5fc53.ASSIGNEE_TYPE:
        case 0, $5fc53.REPORTER_TYPE:
            return {
                ...legacyField,
                schema: {
                    type: (0, $5fc53.ISSUE_FIELD_USER_CF_TYPE),
                    custom: null,
                    system: node.type,
                    renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                    configuration: null,
                    items: null
                }
            };
        case 0, $5fc53.USER_CF_TYPE:
        case 0, $5fc53.LAST_UPDATER_OR_COMMENTER_CF_TYPE:
            return {
                ...legacyField,
                schema: {
                    type: (0, $5fc53.ISSUE_FIELD_USER_CF_TYPE),
                    custom: node.type,
                    system: null,
                    renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                    configuration: null,
                    items: null
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("cMc7B", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleVersionPickerToLegacyField", () => $1c34fc6a70d0e0b4$export$d03f622577260442);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $149sa = parcelRequire("149sa");
const $1c34fc6a70d0e0b4$export$d03f622577260442 = (node)=>{
    if (node.type !== (0, $5fc53.VERSION_CF_TYPE)) return undefined;
    const allowedValues = (0, $o7K5u.transformAggConnection)(null, (0, $149sa.transformAggVersionToLegacyVersion));
    const value = node.version ? (0, $149sa.transformAggVersionToLegacyVersion)(node.version) : null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        allowedValues: allowedValues,
        value: value,
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            type: (0, $5fc53.ISSUE_FIELD_VERSION_CF_TYPE),
            custom: (0, $5fc53.VERSION_CF_TYPE),
            system: null
        }
    };
};

});

parcelRegister("38GNL", function(module, exports) {

$parcel$export(module.exports, "transformAggSprintToLegacyField", () => $05e0b9d6b707c3a6$export$9b5bb05d50970021);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $05e0b9d6b707c3a6$var$SprintOptionalKeyMap = {
    goal: 'goal',
    completeDate: 'completionDate',
    startDate: 'startDate',
    endDate: 'endDate'
};
const $05e0b9d6b707c3a6$var$transformAggSprintToLegacySprint = (sprint)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const optionalValues = {};
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.keys($05e0b9d6b707c3a6$var$SprintOptionalKeyMap).forEach((key)=>{
        const aggKey = $05e0b9d6b707c3a6$var$SprintOptionalKeyMap[key];
        const aggValue = sprint[aggKey];
        if (aggValue !== undefined && aggValue !== null) optionalValues[key] = aggValue;
    });
    return {
        id: Number(sprint.sprintId),
        name: sprint.name,
        state: sprint.state?.toLowerCase(),
        boardId: Number(sprint.boardName) || 0,
        ...optionalValues
    };
};
const $05e0b9d6b707c3a6$export$9b5bb05d50970021 = (node)=>{
    if (node.type !== (0, $5fc53.SPRINT_TYPE)) return undefined;
    const sprints = (0, $o7K5u.transformAggConnection)(node.selectedSprintsConnection, $05e0b9d6b707c3a6$var$transformAggSprintToLegacySprint);
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: sprints,
        schema: {
            configuration: null,
            custom: (0, $5fc53.SPRINT_TYPE),
            items: 'json',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("avV20", function(module, exports) {

$parcel$export(module.exports, "getStatusesDeprecatedValue", () => $e8b60f3bf3251c5a$export$b80ec59d806c2f94);
$parcel$export(module.exports, "transformAggStatusToLegacyField", () => $e8b60f3bf3251c5a$export$c80e5acb1c882c48);

var $gULOk = parcelRequire("gULOk");

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $e8b60f3bf3251c5a$export$b80ec59d806c2f94 = (fields)=>{
    const { status: status } = fields;
    if (!status || status.value == null) return {};
    const { value: value } = status;
    return {
        [value.id]: {
            id: value.id,
            name: value.name,
            statusCategory: (0, $gULOk.statusCategoryForId)(value.statusCategory?.id)
        }
    };
};
const $e8b60f3bf3251c5a$var$transformJiraStatusToLegacyStatus = (status)=>{
    if (status == null) return null;
    const { statusCategory: statusCategory } = status;
    return {
        id: status.statusId,
        name: status.name || '',
        statusCategory: {
            id: Number(statusCategory.statusCategoryId)
        }
    };
};
const $e8b60f3bf3251c5a$export$c80e5acb1c882c48 = (node)=>{
    if (node.type !== (0, $5fc53.STATUS_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: $e8b60f3bf3251c5a$var$transformJiraStatusToLegacyStatus(node.status),
        schema: {
            configuration: null,
            items: null,
            renderer: null,
            type: (0, $5fc53.STATUS_TYPE),
            custom: null,
            system: (0, $5fc53.STATUS_TYPE)
        }
    };
};

});

parcelRegister("cbXvu", function(module, exports) {

$parcel$export(module.exports, "transformAggTeamToLegacyField", () => $2c8c4053c45e92fb$export$fb1b80497e96456f);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $2c8c4053c45e92fb$export$fb1b80497e96456f = (node)=>{
    if (node.type !== (0, $5fc53.TEAM_CF_TYPE)) return undefined;
    const value = node.selectedTeam ? {
        id: node.selectedTeam.teamId,
        title: node.selectedTeam.name,
        isShared: node.selectedTeam.isShared,
        avatarUrl: node.selectedTeam.avatar?.medium
    } : null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            custom: (0, $5fc53.TEAM_CF_TYPE),
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: (0, $5fc53.ISSUE_FIELD_ANY_CF_TYPE)
        }
    };
};

});

parcelRegister("aSXJi", function(module, exports) {

$parcel$export(module.exports, "transformAggTeamViewToLegacyField", () => $b1861ddba2f2c1e6$export$6f6aaafb49bd4769);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $b1861ddba2f2c1e6$var$transformAggTeamViewToLegacyTeam = (team)=>{
    if (team == null) return null;
    return {
        id: team.jiraSuppliedTeamId,
        name: team.jiraSuppliedName || '',
        isVisible: team.jiraSuppliedVisibility || false,
        avatarUrl: team.jiraSuppliedAvatar?.xsmall || '',
        isVerified: team.jiraSuppliedIsVerified || false
    };
};
const $b1861ddba2f2c1e6$export$6f6aaafb49bd4769 = (node)=>{
    if (node.type !== (0, $5fc53.TEAMS_PLATFORM_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        // @ts-expect-error - Argument of type '{ readonly jiraSuppliedAvatar: { readonly large: string | null | undefined; readonly medium: string | null | undefined; readonly small: string | null | undefined; readonly xsmall: string | null | undefined; } | null | undefined; readonly jiraSuppliedId: string; readonly jiraSuppliedName: string | ... 1 more ... | un...' is not assignable to parameter of type '{ readonly jiraSuppliedAvatar: { readonly large: string | null | undefined; readonly medium: string | null | undefined; readonly small: string | null | undefined; readonly xsmall: string | null | undefined; } | null | undefined; readonly jiraSuppliedId: string; readonly jiraSuppliedName: string | ... 1 more ... | un...'.
        value: $b1861ddba2f2c1e6$var$transformAggTeamViewToLegacyTeam(node.selectedTeam),
        schema: {
            configuration: null,
            custom: (0, $5fc53.TEAMS_PLATFORM_CF_TYPE),
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'team'
        }
    };
};

});

parcelRegister("8uxcU", function(module, exports) {

$parcel$export(module.exports, "transformAggTimeTrackingToLegacyField", () => $63b0d60fa2cc1a3e$export$874d9bd14269ec6f);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $63b0d60fa2cc1a3e$var$getEstimateValues = (estimate, key)=>{
    if (estimate) return {
        [key]: estimate.timeInSeconds || 0
    };
    return {};
};
const $63b0d60fa2cc1a3e$export$874d9bd14269ec6f = (node)=>{
    if (node.type !== (0, $5fc53.TIME_TRACKING_TYPE)) return undefined;
    const originalEstimate = $63b0d60fa2cc1a3e$var$getEstimateValues(node.originalEstimate || null, 'originalEstimateSeconds');
    const remainingEstimate = $63b0d60fa2cc1a3e$var$getEstimateValues(node.remainingEstimate || null, 'remainingEstimateSeconds');
    const timeSpent = $63b0d60fa2cc1a3e$var$getEstimateValues(node.timeSpent || null, 'timeSpentSeconds');
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: {
            ...originalEstimate,
            ...remainingEstimate,
            ...timeSpent
        },
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: (0, $5fc53.TIME_TRACKING_TYPE),
            type: (0, $5fc53.TIME_TRACKING_TYPE)
        }
    };
};

});

parcelRegister("arKlm", function(module, exports) {

$parcel$export(module.exports, "transformAggUrlToLegacyField", () => $86ba2c1106803d01$export$6e950e0ec9801f6c);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $86ba2c1106803d01$export$6e950e0ec9801f6c = (node)=>{
    if (node.type !== (0, $5fc53.URL_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.uri ?? null,
        schema: {
            configuration: null,
            custom: (0, $5fc53.URL_CF_TYPE),
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE)
        }
    };
};

});

parcelRegister("hCKV6", function(module, exports) {

$parcel$export(module.exports, "transformAggVotesToLegacyField", () => $78b4a5963398330d$export$8966614b8594736);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $78b4a5963398330d$var$transformAggVoteToLegacyVote = (vote)=>({
        votes: vote.count != null ? Number(vote.count) : 0,
        hasVoted: vote.hasVoted ?? false
    });
const $78b4a5963398330d$export$8966614b8594736 = (node)=>{
    if (node.type !== (0, $5fc53.VOTES_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.vote ? $78b4a5963398330d$var$transformAggVoteToLegacyVote(node.vote) : null,
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: null,
            system: (0, $5fc53.VOTES_TYPE),
            type: (0, $5fc53.VOTES_TYPE)
        }
    };
};

});

parcelRegister("d8wC0", function(module, exports) {

$parcel$export(module.exports, "transformAggWatchesToLegacyField", () => $a83bab4858993b2f$export$6730cb17d10d6156);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $a83bab4858993b2f$var$transformAggWatchesToLegacyWatches = (watch)=>({
        watchCount: watch.count != null ? Number(watch.count) : 0,
        isWatching: watch.isWatching ?? false
    });
const $a83bab4858993b2f$export$6730cb17d10d6156 = (node)=>{
    if (node.type !== (0, $5fc53.WATCHES_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.watch ? $a83bab4858993b2f$var$transformAggWatchesToLegacyWatches(node.watch) : null,
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: null,
            system: (0, $5fc53.WATCHES_TYPE),
            type: (0, $5fc53.WATCHES_TYPE)
        }
    };
};

});


parcelRegister("1pF6B", function(module, exports) {

$parcel$export(module.exports, "transformAggParentFieldValueToLegacyFieldValue", () => $f8196a61a82995ed$export$d8a5feb2bb0425b4);
const $f8196a61a82995ed$export$d8a5feb2bb0425b4 = (parentIssue)=>{
    if (!parentIssue) return null;
    return {
        id: parentIssue.issueId,
        ari: parentIssue.id,
        key: parentIssue.key,
        self: parentIssue.webUrl,
        color: parentIssue.issueColorField?.color?.colorKey,
        fields: {
            summary: parentIssue.summaryField?.text,
            issuetype: {
                name: parentIssue.issueTypeField?.issueType?.name,
                iconUrl: parentIssue.issueTypeField?.issueType?.avatar?.xsmall,
                // We do not have this data
                id: '',
                self: '',
                description: '',
                subtask: false,
                avatarId: 0,
                hierarchyLevel: 0
            }
        }
    };
};

});

parcelRegister("lTnWS", function(module, exports) {

$parcel$export(module.exports, "transformAggRichTextFieldValueToLegacyFieldValue", () => $51ceecc021979aad$export$b3a2c3992977726e);

var $kz2lw = parcelRequire("kz2lw");


var $fCo6Y = parcelRequire("fCo6Y");
const $51ceecc021979aad$var$emptyAdfObject = (0, $kz2lw.getEmptyADF)();
const $51ceecc021979aad$export$b3a2c3992977726e = (richText, renderer)=>{
    if (!renderer) throw new Error('aggFieldChangeProps did not have renderer');
    if (renderer === (0, $650578330a102f55$export$a4a240cb4053b29f)) {
        if (richText.plainText !== undefined) return richText.plainText;
        return richText?.adfValue?.convertedPlainText?.plainText;
    }
    return richText?.adfValue?.json ? (0, $fCo6Y.removeCollectionFromAdf)(richText?.adfValue?.json) : $51ceecc021979aad$var$emptyAdfObject;
};

});


parcelRegister("3z81P", function(module, exports) {

$parcel$export(module.exports, "ChangeEventTypes", () => $c6ffe75554a4bac3$export$8db21fc94823e1cc);
// Copied over from `src/packages/issue/issue-view/src/model/change-type.js`
const $c6ffe75554a4bac3$var$FIELD_CHANGE_REQUESTED = 'FIELD_CHANGE_REQUESTED';
const $c6ffe75554a4bac3$var$FIELD_CHANGED = 'FIELD_CHANGED';
const $c6ffe75554a4bac3$var$FIELD_CHANGE_FAILED = 'FIELD_CHANGE_FAILED';
const $c6ffe75554a4bac3$export$8db21fc94823e1cc = {
    [$c6ffe75554a4bac3$var$FIELD_CHANGE_REQUESTED]: $c6ffe75554a4bac3$var$FIELD_CHANGE_REQUESTED,
    [$c6ffe75554a4bac3$var$FIELD_CHANGE_FAILED]: $c6ffe75554a4bac3$var$FIELD_CHANGE_FAILED,
    [$c6ffe75554a4bac3$var$FIELD_CHANGED]: $c6ffe75554a4bac3$var$FIELD_CHANGED
};

});


parcelRegister("biQrn", function(module, exports) {

$parcel$export(module.exports, "useIsMounted", () => $c6adaed2787020bf$export$80c2a3957bcb42ea);

var $5uXOq = parcelRequire("5uXOq");
const $c6adaed2787020bf$export$80c2a3957bcb42ea = ()=>{
    const isMounted = (0, $5uXOq.useRef)(true);
    (0, $5uXOq.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, [
        isMounted
    ]);
    return isMounted;
};

});


parcelRegister("kWfaA", function(module, exports) {

$parcel$export(module.exports, "useCategoryOptionsService", () => $a97cefcd4418779b$export$343b4a5d0ceb0f64);
$parcel$export(module.exports, "useCategoryOptionsCache", () => $a97cefcd4418779b$export$c28db2c8cc3e5deb);

var $5uXOq = parcelRequire("5uXOq");

var $5tTFS = parcelRequire("5tTFS");

var $12jwF = parcelRequire("12jwF");

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");


var $gEn6y = parcelRequire("gEn6y");

var $jEgAa = parcelRequire("jEgAa");
const $a97cefcd4418779b$export$343b4a5d0ceb0f64 = ()=>{
    const entityAri = (0, $12jwF.useEntityAri)();
    const { data: data, loading: loading, error: error } = (0, $5tTFS.useQuery)((0, $gEn6y.CATEGORY_OPTIONS), {
        variables: {
            projectId: entityAri,
            first: (0, $a50aeb58786ea834$export$ec93a669a20aa982)
        },
        onError: (apolloError)=>{
            (0, $jcw0u.default)({
                meta: {
                    id: 'jwmCategoryOptions',
                    packageName: 'jiraBusinessCategories',
                    teamName: 'jira-warepil'
                },
                attributes: {
                    message: 'Failed to fetch category options with color'
                },
                error: Array.isArray(apolloError) && apolloError.length > 0 ? apolloError[0] : apolloError,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    });
    const options = (0, $5uXOq.useMemo)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    ()=>(0, $jEgAa.transformCategoryOptionsData)(data), [
        data
    ]);
    return {
        categoryOptions: options,
        loading: loading,
        error: error
    };
};
const $a97cefcd4418779b$export$c28db2c8cc3e5deb = ()=>{
    const analyticsTaskName = 'useCategoryOptionsCacheApolloCacheActions';
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const client = (0, $5tTFS.useApolloClient)();
    const entityAri = (0, $12jwF.useEntityAri)();
    const getNewTotalCount = (0, $5uXOq.useCallback)((currentCount, action)=>{
        if (currentCount && action === 'ADD') return currentCount + 1;
        if (currentCount && action === 'REMOVE') return currentCount - 1;
        return currentCount;
    }, []);
    const categoryOptionsCache = (0, $5uXOq.useCallback)((category, action)=>{
        const getCachedListData = ()=>{
            try {
                const read = client.readQuery({
                    query: (0, $gEn6y.CATEGORY_OPTIONS),
                    variables: {
                        projectId: entityAri,
                        first: (0, $a50aeb58786ea834$export$ec93a669a20aa982)
                    }
                });
                (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheRead taskSuccess', {
                    task: analyticsTaskName
                });
                return read;
            } catch (e) {
                (0, $jcw0u.default)({
                    error: e instanceof Error ? e : new Error('Unknown cache read error'),
                    meta: {
                        id: 'categoryOptionsCache',
                        packageName: 'jiraBusinessCategories',
                        teamName: 'jira-warepil'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true,
                    attributes: {
                        task: analyticsTaskName,
                        query: JSON.stringify((0, $gEn6y.CATEGORY_OPTIONS)),
                        variables: {
                            projectId: entityAri,
                            first: (0, $a50aeb58786ea834$export$ec93a669a20aa982)
                        },
                        error: JSON.stringify(e),
                        eventName: 'apolloCacheRead taskFail'
                    }
                });
                return null;
            }
        };
        const data = getCachedListData();
        if (data == null || data.jira?.jwmCategoryOptions?.__typename === 'QueryError') return;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const edges = data.jira?.jwmCategoryOptions?.edges;
        if (edges == null) return;
        const newEdges = [
            ...edges
        ];
        const index = newEdges.findIndex((edge)=>edge && edge.node?.option?.optionId === category.option.optionId);
        switch(action){
            case 'ADD':
                newEdges.push({
                    __typename: 'JiraWorkManagementCategoryOptionEdge',
                    node: {
                        __typename: 'JiraWorkManagementCategoryOption',
                        id: category.id || '',
                        color: category.color || null,
                        option: {
                            id: category.option.id || '',
                            optionId: category.option.optionId,
                            value: category.option.value || '',
                            isDisabled: false,
                            __typename: 'JiraOption'
                        }
                    }
                });
                break;
            case 'REMOVE':
                if (index !== -1) newEdges.splice(index, 1);
                break;
            case 'UPDATE':
                if (index !== -1) {
                    const edgeToUpdate = newEdges[index];
                    if (edgeToUpdate) {
                        const edgeUpdated = {
                            ...edgeToUpdate,
                            node: edgeToUpdate?.node && {
                                ...edgeToUpdate.node,
                                option: edgeToUpdate.node.option && {
                                    ...edgeToUpdate?.node?.option,
                                    value: category.option.value || ''
                                },
                                color: category.color || null
                            }
                        };
                        newEdges.splice(index, 1, edgeUpdated);
                    }
                }
                break;
            default:
                return;
        }
        const totalCount = data.jira?.jwmCategoryOptions?.totalCount || null;
        const newTotalCount = getNewTotalCount(totalCount, action);
        const newData = {
            ...data,
            jira: data.jira && {
                ...data.jira,
                jwmCategoryOptions: data?.jira?.jwmCategoryOptions?.__typename === 'JiraWorkManagementCategoryOptionConnection' ? {
                    ...data.jira.jwmCategoryOptions,
                    edges: newEdges,
                    totalCount: newTotalCount
                } : null
            }
        };
        try {
            client.writeQuery({
                query: (0, $gEn6y.CATEGORY_OPTIONS),
                variables: {
                    projectId: entityAri,
                    first: (0, $a50aeb58786ea834$export$ec93a669a20aa982)
                },
                data: newData
            });
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheWrite taskSuccess', {
                task: analyticsTaskName
            });
        } catch (e) {
            (0, $jcw0u.default)({
                error: e instanceof Error ? e : new Error('Unknown cache write error'),
                meta: {
                    id: 'categoryOptionsCache',
                    packageName: 'jiraBusinessCategories',
                    teamName: 'jira-warepil'
                },
                sendToPrivacyUnsafeSplunk: true,
                skipSentry: true,
                attributes: {
                    task: analyticsTaskName,
                    query: JSON.stringify((0, $gEn6y.CATEGORY_OPTIONS)),
                    variables: {
                        projectId: entityAri,
                        first: (0, $a50aeb58786ea834$export$ec93a669a20aa982)
                    },
                    eventName: 'apolloCacheWrite taskFail',
                    error: JSON.stringify(e)
                }
            });
        }
    }, [
        client,
        createAnalyticsEvent,
        entityAri,
        getNewTotalCount
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            addCategory (category) {
                categoryOptionsCache(category, 'ADD');
            },
            removeCategory (optionId) {
                categoryOptionsCache({
                    option: {
                        optionId: optionId
                    },
                    color: null
                }, 'REMOVE');
            },
            updateCategory (category) {
                categoryOptionsCache(category, 'UPDATE');
            }
        }), [
        categoryOptionsCache
    ]);
};

});
const $a50aeb58786ea834$export$a93d8cd30a94ee3a = 'jwmCategoryOptions';
const $a50aeb58786ea834$export$ec93a669a20aa982 = 200;

parcelRegister("gEn6y", function(module, exports) {

$parcel$export(module.exports, "CATEGORY_OPTIONS", () => $4a56a0feb05d0795$export$ce79ac9d0544a95e);

var $5cllN = parcelRequire("5cllN");

var $cNu0r = parcelRequire("cNu0r");
const $4a56a0feb05d0795$export$ce79ac9d0544a95e = (0, $5cllN.default)`
  query JwmCategoryOptions($projectId: ID!, $first: Int) {
    jira {
        jwmCategoryOptions(projectId: $projectId, first: $first) {
            ... on JiraWorkManagementCategoryOptionConnection {
                edges {
                    node {
                        ...JwmCategoryOptionsFragment
                    }
                }
                pageInfo {
                    hasNextPage
                    hasPreviousPage
                }
                totalCount
            }
            ... on QueryError {
                message
                extensions {
                    statusCode
                    errorType
                }
            }
        }
    }
  }
  ${(0, $cNu0r.JWM_CATEGORY_OPTIONS_FRAGMENT)}
`;

});

parcelRegister("jEgAa", function(module, exports) {

$parcel$export(module.exports, "transformCategoryOptionsData", () => $2411a5cf60539afa$export$e25f9b0517b88333);
const $2411a5cf60539afa$export$e25f9b0517b88333 = (data)=>{
    if (data?.jira?.jwmCategoryOptions && 'edges' in data?.jira?.jwmCategoryOptions && Array.isArray(data?.jira?.jwmCategoryOptions.edges)) {
        const items = [];
        data.jira.jwmCategoryOptions.edges.forEach((edge)=>{
            if (edge && edge.node && edge.node.option) items.push({
                label: edge.node.option.value ?? '',
                value: String(edge.node.option.optionId),
                color: edge.node.color
            });
        });
        return items;
    }
    return [];
};

});


parcelRegister("aNJFF", function(module, exports) {

$parcel$export(module.exports, "CREATE_FAILED_FLAG", () => $bf14fe7c647de186$export$a94c54b030e108e);
$parcel$export(module.exports, "QUERY_NAME", () => $bf14fe7c647de186$export$a93d8cd30a94ee3a);

var $kdKGv = parcelRequire("kdKGv");
const $bf14fe7c647de186$export$a94c54b030e108e = {
    type: 'error',
    title: (0, $kdKGv.default).createErrorTitle,
    description: (0, $kdKGv.default).createErrorMessage,
    messageId: 'business-categories.services.create-category.create-failed-flag.error.error.create-failed-flag',
    messageType: 'transactional'
};
const $bf14fe7c647de186$export$a93d8cd30a94ee3a = 'jwmCreateCategory';

});
parcelRegister("kdKGv", function(module, exports) {

$parcel$export(module.exports, "default", () => $2dedaab0aa0d8004$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2dedaab0aa0d8004$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createErrorTitle: {
        "id": "business-categories.services.create-category.create-error-title",
        "defaultMessage": "We couldn't create the category"
    },
    createErrorMessage: {
        "id": "business-categories.services.create-category.create-error-message",
        "defaultMessage": "Check your connection, then give it another try."
    }
});

});


parcelRegister("4czz5", function(module, exports) {

$parcel$export(module.exports, "useCreateCategory", () => $7821cae2a3a7cc15$export$4225ec1f1086359b);

var $5uXOq = parcelRequire("5uXOq");

var $5tTFS = parcelRequire("5tTFS");

var $daQYX = parcelRequire("daQYX");

var $cm8b5 = parcelRequire("cm8b5");

var $jcw0u = parcelRequire("jcw0u");

var $pa9q9 = parcelRequire("pa9q9");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $aNJFF = parcelRequire("aNJFF");

var $ezZV6 = parcelRequire("ezZV6");
const $7821cae2a3a7cc15$export$4225ec1f1086359b = ({ experience: experience, onCompleted: onCompleted })=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const project = (0, $daQYX.useProject)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const startExperience = (0, $cm8b5.useExperienceStart)(experience);
    const markExperienceSuccess = (0, $cm8b5.useExperienceSuccess)(experience);
    const markExperienceFailed = (0, $cm8b5.useExperienceFail)(experience);
    const projectId = String(project.id);
    const [createCategory, { data: data, loading: loading, error: error }] = (0, $5tTFS.useMutation)((0, $ezZV6.CREATE_CATEGORY), {
        onError: (apolloError)=>{
            markExperienceFailed(`${experience.experience} category service error handling`, apolloError);
            showFlag((0, $aNJFF.CREATE_FAILED_FLAG));
            (0, $jcw0u.default)({
                meta: {
                    id: 'jwmCreateCategory',
                    packageName: 'jiraBusinessCategories',
                    teamName: 'jira-warepil'
                },
                attributes: {
                    message: 'Failed to create category'
                },
                error: apolloError,
                sendToPrivacyUnsafeSplunk: true
            });
        },
        onCompleted: (onCompletedData)=>{
            if (onCompletedData?.createJwmCategory?.errors) return;
            markExperienceSuccess();
            if (onCompleted) onCompleted(onCompletedData);
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), `${(0, $aNJFF.QUERY_NAME)} succeeded`);
        }
    });
    const create = (0, $5uXOq.useCallback)(async ({ issueTypeId: issueTypeId, value: value, color: color })=>{
        startExperience();
        const response = await createCategory({
            variables: {
                input: {
                    projectId: projectId,
                    issueTypeId: issueTypeId,
                    value: value,
                    color: color
                }
            }
        });
        const result = response?.data?.createJwmCategory;
        if (result?.success) {
            if (result.category?.option?.optionId) return {
                id: result.category.id,
                color: result.category.color,
                option: {
                    optionId: result.category.option.optionId,
                    value: result.category.option.value,
                    id: result.category.option.id,
                    isDisabled: result.category.option.isDisabled
                }
            };
            return null;
        }
        const createError = result?.errors?.find((e)=>e.message);
        if (createError) throw new Error(createError.message || '');
        return null;
    }, [
        createCategory,
        projectId,
        startExperience
    ]);
    // find error that has message
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const mutationBadRequestError = data?.createJwmCategory?.errors?.find((e)=>e.message);
    return {
        error: // if there are any errors from Apollo, surface that first
        // otherwise if there are errors from bad request, use that
        error || mutationBadRequestError,
        data: data,
        loading: loading,
        createCategory: create
    };
};

});
parcelRegister("ezZV6", function(module, exports) {

$parcel$export(module.exports, "CREATE_CATEGORY", () => $28fbafb28db5b55c$export$b88942163ad28b3e);

var $5cllN = parcelRequire("5cllN");

var $cNu0r = parcelRequire("cNu0r");
const $28fbafb28db5b55c$export$b88942163ad28b3e = (0, $5cllN.default)`
  mutation JwmCreateCategory($input: JWMCreateCategoryInput!) {
    createJwmCategory(input: $input) {
      success
      errors {
        message
        extensions {
          errorType
          statusCode
        }
      }
      category {
        ...JwmCategoryOptionsFragment
      }
    }
  }
  ${(0, $cNu0r.JWM_CATEGORY_OPTIONS_FRAGMENT)}
`;

});


parcelRegister("a3IM2", function(module, exports) {

$parcel$export(module.exports, "useDeleteCategory", () => $937fc5423e55917e$export$daf5e0a4ffd89067);

var $5uXOq = parcelRequire("5uXOq");

var $5tTFS = parcelRequire("5tTFS");

var $daQYX = parcelRequire("daQYX");

var $cm8b5 = parcelRequire("cm8b5");

var $2YZCu = parcelRequire("2YZCu");

var $pa9q9 = parcelRequire("pa9q9");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $iyUAx = parcelRequire("iyUAx");

var $77qU8 = parcelRequire("77qU8");
const $937fc5423e55917e$export$daf5e0a4ffd89067 = ({ experience: experience, onCompleted: onCompleted })=>{
    const startExperience = (0, $cm8b5.useExperienceStart)(experience);
    const markExperienceSuccess = (0, $cm8b5.useExperienceSuccess)(experience);
    const markExperienceFailed = (0, $cm8b5.useExperienceFail)(experience);
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const project = (0, $daQYX.useProject)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const projectId = String(project.id);
    const [deleteJwmCategory, { data: data, loading: loading, error: error }] = (0, $5tTFS.useMutation)((0, $77qU8.DELETE_JIRA_BUSINESS_CATEGORY), {
        onError: (apolloError)=>{
            markExperienceFailed(`${experience.experience} category service error handling`, apolloError);
            showFlag((0, $iyUAx.DELETE_FAILED_FLAG));
            (0, $2YZCu.default).safeErrorWithoutCustomerData((0, $iyUAx.PACKAGE_LOCATION), 'ApolloError: Failed to delete category');
        },
        onCompleted: (onCompletedData)=>{
            markExperienceSuccess();
            if (onCompleted) onCompleted(onCompletedData);
            if (onCompletedData?.deleteJwmCategory?.errors) {
                showFlag((0, $iyUAx.DELETE_FAILED_FLAG));
                return;
            }
            showFlag((0, $iyUAx.DELETE_SUCCESS_FLAG));
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), `${(0, $iyUAx.QUERY_NAME)} succeeded`);
        }
    });
    const deleteCategory = (0, $5uXOq.useCallback)(async ({ issueTypeId: issueTypeId, optionId: optionId })=>{
        startExperience();
        const response = await deleteJwmCategory({
            variables: {
                input: {
                    projectId: projectId,
                    issueTypeId: issueTypeId,
                    optionId: optionId
                }
            }
        });
        const result = response?.data?.deleteJwmCategory;
        if (result?.success) return true;
        return false;
    }, [
        deleteJwmCategory,
        projectId,
        startExperience
    ]);
    // find error that has message
    const mutationBadRequestError = (0, $5uXOq.useMemo)(()=>data?.deleteJwmCategory?.errors?.find((e)=>e.message), [
        data
    ]);
    return {
        error: // if there are any errors from Apollo, surface that first
        // otherwise if there are errors from bad request, use that
        error || mutationBadRequestError,
        data: data,
        loading: loading,
        deleteCategory: deleteCategory
    };
};

});
parcelRegister("iyUAx", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_LOCATION", () => $58fe877000abe9fc$export$7ec1427613e4cea);
$parcel$export(module.exports, "DELETE_FAILED_FLAG", () => $58fe877000abe9fc$export$73026709962f2ff);
$parcel$export(module.exports, "DELETE_SUCCESS_FLAG", () => $58fe877000abe9fc$export$b4ec21d91832b908);
$parcel$export(module.exports, "QUERY_NAME", () => $58fe877000abe9fc$export$a93d8cd30a94ee3a);

var $gzbtb = parcelRequire("gzbtb");
const $58fe877000abe9fc$export$7ec1427613e4cea = 'jira-business.categories.src.services.delete-category';
const $58fe877000abe9fc$export$73026709962f2ff = {
    type: 'error',
    title: (0, $gzbtb.default).deleteErrorTitle,
    description: (0, $gzbtb.default).deleteErrorMessage,
    messageId: 'business-categories.services.delete-category.delete-failed-flag.error.error.delete-failed-flag',
    messageType: 'transactional'
};
const $58fe877000abe9fc$export$b4ec21d91832b908 = {
    type: 'success',
    title: (0, $gzbtb.default).deleteSuccessTitle,
    description: (0, $gzbtb.default).deleteSuccessMessage,
    messageId: 'business-categories.services.delete-category.delete-success-flag.success.success.delete-success-flag',
    messageType: 'transactional'
};
const $58fe877000abe9fc$export$a93d8cd30a94ee3a = 'deleteJwmCategory';

});
parcelRegister("gzbtb", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ffa0dde618c2f18$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1ffa0dde618c2f18$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    deleteErrorTitle: {
        "id": "business-categories.services.delete-category.delete-error-title",
        "defaultMessage": "We couldn't delete the category"
    },
    deleteErrorMessage: {
        "id": "business-categories.services.delete-category.delete-error-message",
        "defaultMessage": "Check your connection, then give it another try."
    },
    deleteSuccessTitle: {
        "id": "business-categories.services.delete-category.delete-success-title",
        "defaultMessage": "Category deleted"
    },
    deleteSuccessMessage: {
        "id": "business-categories.services.delete-category.delete-success-message",
        "defaultMessage": "Category has been deleted from your business project."
    }
});

});


parcelRegister("77qU8", function(module, exports) {

$parcel$export(module.exports, "DELETE_JIRA_BUSINESS_CATEGORY", () => $ed174276a5198c68$export$1117beef9815e76c);

var $5cllN = parcelRequire("5cllN");
const $ed174276a5198c68$export$1117beef9815e76c = (0, $5cllN.default)`
  mutation DeleteJwmCategory($input: JWMDeleteCategoryInput!) {
    deleteJwmCategory(input: $input) {
      success
      errors {
        message
        extensions {
          errorType
          statusCode
        }
      }
    }
  }
`;

});


parcelRegister("bPi86", function(module, exports) {

$parcel$export(module.exports, "useUpdateCategory", () => $8abe70ef9e503944$export$89393e180ebe9dba);

var $5uXOq = parcelRequire("5uXOq");

var $5tTFS = parcelRequire("5tTFS");

var $daQYX = parcelRequire("daQYX");

var $cm8b5 = parcelRequire("cm8b5");

var $jcw0u = parcelRequire("jcw0u");

var $pa9q9 = parcelRequire("pa9q9");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $bLYBp = parcelRequire("bLYBp");

var $imjuR = parcelRequire("imjuR");
const $8abe70ef9e503944$export$89393e180ebe9dba = ({ experience: experience, onCompleted: onCompleted })=>{
    const startExperience = (0, $cm8b5.useExperienceStart)(experience);
    const markExperienceSuccess = (0, $cm8b5.useExperienceSuccess)(experience);
    const markExperienceFailed = (0, $cm8b5.useExperienceFail)(experience);
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const project = (0, $daQYX.useProject)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const projectId = String(project.id);
    const [updateCategory, { data: data, loading: loading, error: error }] = (0, $5tTFS.useMutation)((0, $imjuR.UPDATE_CATEGORY), {
        onError: (apolloError)=>{
            markExperienceFailed(`${experience.experience} category service error handling`, apolloError);
            showFlag((0, $bLYBp.UPDATE_FAILED_FLAG));
            (0, $jcw0u.default)({
                meta: {
                    id: 'jwmUpdateCategory',
                    packageName: 'jiraBusinessCategories',
                    teamName: 'jira-warepil'
                },
                attributes: {
                    message: 'Failed to update category'
                },
                error: apolloError,
                sendToPrivacyUnsafeSplunk: true
            });
        },
        onCompleted: (onCompletedData)=>{
            if (onCompletedData?.updateJwmCategory?.errors) {
                showFlag((0, $bLYBp.UPDATE_FAILED_FLAG));
                return;
            }
            markExperienceSuccess();
            showFlag((0, $bLYBp.UPDATE_SUCCESS_FLAG));
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), `${(0, $bLYBp.QUERY_NAME)} succeeded`);
            if (onCompleted) onCompleted(onCompletedData);
        }
    });
    const update = (0, $5uXOq.useCallback)(async ({ issueTypeId: issueTypeId, optionId: optionId, value: value, color: color })=>{
        startExperience();
        const response = await updateCategory({
            variables: {
                input: {
                    projectId: projectId,
                    issueTypeId: issueTypeId,
                    optionId: optionId,
                    value: value,
                    color: color
                }
            }
        });
        const result = response?.data?.updateJwmCategory;
        if (result?.success) {
            if (result.category) return result.category;
        }
        return null;
    }, [
        startExperience,
        updateCategory,
        projectId
    ]);
    // find error that has message
    const mutationBadRequestError = (0, $5uXOq.useMemo)(()=>data?.updateJwmCategory?.errors?.find((e)=>e.message), [
        data
    ]);
    return {
        error: error || mutationBadRequestError,
        data: data,
        loading: loading,
        updateCategory: update
    };
};

});
parcelRegister("bLYBp", function(module, exports) {

$parcel$export(module.exports, "UPDATE_FAILED_FLAG", () => $a7944c290a9fef53$export$ce554ac3b5c50c57);
$parcel$export(module.exports, "UPDATE_SUCCESS_FLAG", () => $a7944c290a9fef53$export$4780917480343dea);
$parcel$export(module.exports, "QUERY_NAME", () => $a7944c290a9fef53$export$a93d8cd30a94ee3a);

var $gbPvu = parcelRequire("gbPvu");
const $a7944c290a9fef53$export$ce554ac3b5c50c57 = {
    type: 'error',
    title: (0, $gbPvu.default).updateErrorTitle,
    description: (0, $gbPvu.default).updateErrorMessage,
    messageId: 'business-categories.services.update-category.update-failed-flag.error.error.update-failed-flag',
    messageType: 'transactional'
};
const $a7944c290a9fef53$export$4780917480343dea = {
    type: 'success',
    title: (0, $gbPvu.default).updateSuccessTitle,
    description: (0, $gbPvu.default).updateSuccessMessage,
    messageId: 'business-categories.services.update-category.update-success-flag.success.success.update-success-flag',
    messageType: 'transactional'
};
const $a7944c290a9fef53$export$a93d8cd30a94ee3a = 'jwmUpdateCategory';

});
parcelRegister("gbPvu", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfc86e442988f8be$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $bfc86e442988f8be$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    updateErrorTitle: {
        "id": "business-categories.services.update-category.update-error-title",
        "defaultMessage": "We couldn't update the category"
    },
    updateErrorMessage: {
        "id": "business-categories.services.update-category.update-error-message",
        "defaultMessage": "Check your connection, then give it another try."
    },
    updateSuccessTitle: {
        "id": "business-categories.services.update-category.update-success-title",
        "defaultMessage": "Category updated"
    },
    updateSuccessMessage: {
        "id": "business-categories.services.update-category.update-success-message",
        "defaultMessage": "Category has been updated successfully."
    }
});

});


parcelRegister("imjuR", function(module, exports) {

$parcel$export(module.exports, "UPDATE_CATEGORY", () => $7d152b99758b43ea$export$95f0050ef87b4d2c);

var $5cllN = parcelRequire("5cllN");

var $cNu0r = parcelRequire("cNu0r");
const $7d152b99758b43ea$export$95f0050ef87b4d2c = (0, $5cllN.default)`
  mutation JwmUpdateCategory($input: JWMUpdateCategoryInput!) {
    updateJwmCategory(input: $input) {
      success
      errors {
        message
        extensions {
          errorType
          statusCode
        }
      }
      category {
        ...JwmCategoryOptionsFragment
      }
    }
  }
  ${(0, $cNu0r.JWM_CATEGORY_OPTIONS_FRAGMENT)}
`;

});


parcelRegister("lnCtA", function(module, exports) {

$parcel$export(module.exports, "KNOWN_ERROR_MESSAGE", () => $93467720d58c9bc8$export$b1ecc86f640c9cfe);
$parcel$export(module.exports, "CATEGORY_NAME_ALREADY_EXISTS_ERROR_MESSAGE", () => $93467720d58c9bc8$export$4d51e3539367ec13);
$parcel$export(module.exports, "CATEGORY_NAME_ALREADY_EXISTS_ERROR_FLAG", () => $93467720d58c9bc8$export$e4ea5893185263d8);

var $hqdlT = parcelRequire("hqdlT");
const $93467720d58c9bc8$export$b1ecc86f640c9cfe = 'It is not on the appropriate screen, or unknown.';
const $93467720d58c9bc8$export$4d51e3539367ec13 = 'Category with the same name exists';
const $93467720d58c9bc8$export$e4ea5893185263d8 = {
    type: 'error',
    title: (0, $hqdlT.default).categoryNameAlreadyExists,
    messageId: 'business-categories.controllers.category-cell-state-controller.category-name-already-exists-error-flag.error.error.category-name-already-exists-error-flag',
    messageType: 'transactional'
};

});
parcelRegister("hqdlT", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd0893495adf500d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $fd0893495adf500d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    knownErrorNonAdminTitle: {
        "id": "business-categories.controllers.category-cell-state-controller.known-error-non-admin-title",
        "defaultMessage": "Error editing this field"
    },
    knownErrorNonAdminDescription: {
        "id": "business-categories.controllers.category-cell-state-controller.known-error-non-admin-description",
        "defaultMessage": "You\u2019ll either need edit permissions, or the project admin will need to add the category field to this issue type. To learn more, speak to your project admin."
    },
    knownErrorAdminTitle: {
        "id": "business-categories.controllers.category-cell-state-controller.known-error-admin-title",
        "defaultMessage": "To edit this field you\u2019ll need to go to project settings and add the category field to this issue type."
    },
    knownErrorAdminCta: {
        "id": "business-categories.controllers.category-cell-state-controller.known-error-admin-cta",
        "defaultMessage": "Go to project settings"
    },
    networkErrorTitle: {
        "id": "business-categories.controllers.category-cell-state-controller.network-error-title",
        "defaultMessage": "An unexpected error occurred. Check your network connection, then refresh your page to try again."
    },
    genericErrorTitle: {
        "id": "business-categories.controllers.category-cell-state-controller.generic-error-title",
        "defaultMessage": "An unexpected error occurred. Wait a few moments, then refresh your page to try again."
    },
    createdCategoryNameCantBeEmpty: {
        "id": "business-categories.controllers.category-cell-state-controller.created-category-name-cant-be-empty",
        "defaultMessage": "Categories can\u2019t be left blank. To create a category, give it a name."
    },
    renamedCategoryCantBeEmpty: {
        "id": "business-categories.controllers.category-cell-state-controller.renamed-category-cant-be-empty",
        "defaultMessage": "Categories can\u2019t be left blank. To rename a category, give it a name."
    },
    categoryNameAlreadyExists: {
        "id": "business-categories.controllers.category-cell-state-controller.category-name-already-exists",
        "defaultMessage": "The name you\u2019ve selected for this category already exists. Try a new name."
    },
    knownErrorNonAdminDescriptionIssueTermRefresh: {
        "id": "business-categories.controllers.category-cell-state-controller.known-error-non-admin-description-issue-term-refresh",
        "defaultMessage": "You\u2019ll either need edit permissions, or the project admin will need to add the category field to this work type. To learn more, speak to your project admin."
    },
    knownErrorAdminTitleIssueTermRefresh: {
        "id": "business-categories.controllers.category-cell-state-controller.known-error-admin-title-issue-term-refresh",
        "defaultMessage": "To edit this field you\u2019ll need to go to project settings and add the category field to this work type."
    }
});

});


parcelRegister("kzvKj", function(module, exports) {

$parcel$export(module.exports, "getSaveValueErrorFlag", () => $c765599d0c6c0ffc$export$e5c7668e936e16e1);

var $6s1PB = parcelRequire("6s1PB");

var $lnCtA = parcelRequire("lnCtA");

var $hqdlT = parcelRequire("hqdlT");
const $c765599d0c6c0ffc$export$e5c7668e936e16e1 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
error, isAdminOrProjectAdmin, onOpenSettings)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const errorMessage = error.errors?.find((e)=>e.error)?.error;
    const isKnownErrorMessage = errorMessage && errorMessage.includes((0, $lnCtA.KNOWN_ERROR_MESSAGE));
    const FLAG = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? $c765599d0c6c0ffc$export$a6efb19cdceab88f : $c765599d0c6c0ffc$export$674d6632095d387f;
    if (error.statusCode === 400 && isKnownErrorMessage) return isAdminOrProjectAdmin ? $c765599d0c6c0ffc$export$3510136e72b8218b({
        onOpenSettings: onOpenSettings
    }) : FLAG;
    if (error.statusCode) return $c765599d0c6c0ffc$export$a077289c8607d69d;
    return $c765599d0c6c0ffc$export$bbdfcd88a11759b1;
};
const $c765599d0c6c0ffc$export$674d6632095d387f = {
    type: 'error',
    title: (0, $hqdlT.default).knownErrorNonAdminTitle,
    description: (0, $hqdlT.default).knownErrorNonAdminDescription,
    messageId: 'business-categories.controllers.category-cell-state-controller.known-error-non-admin-flag-with-issue-term.error.error.known-error-non-admin-flag-with-issue-term',
    messageType: 'transactional'
};
const $c765599d0c6c0ffc$export$a6efb19cdceab88f = {
    type: 'error',
    title: (0, $hqdlT.default).knownErrorNonAdminTitle,
    description: (0, $hqdlT.default).knownErrorNonAdminDescriptionIssueTermRefresh,
    messageId: 'business-categories.controllers.category-cell-state-controller.known-error-non-admin-flag.error.error.known-error-non-admin-flag',
    messageType: 'transactional'
};
const $c765599d0c6c0ffc$export$3510136e72b8218b = ({ onOpenSettings: onOpenSettings })=>({
        type: 'error',
        title: (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $hqdlT.default).knownErrorAdminTitleIssueTermRefresh : (0, $hqdlT.default).knownErrorAdminTitle,
        actions: [
            {
                content: (0, $hqdlT.default).knownErrorAdminCta,
                onClick: onOpenSettings
            }
        ],
        messageId: 'business-categories.controllers.category-cell-state-controller.flag.error.error.known-error-admin',
        messageType: 'transactional'
    });
const $c765599d0c6c0ffc$export$a077289c8607d69d = {
    type: 'error',
    title: (0, $hqdlT.default).genericErrorTitle,
    messageId: 'business-categories.controllers.category-cell-state-controller.generic-error-flag.error.error.generic-error-flag',
    messageType: 'transactional'
};
const $c765599d0c6c0ffc$export$bbdfcd88a11759b1 = {
    type: 'error',
    title: (0, $hqdlT.default).networkErrorTitle,
    messageId: 'business-categories.controllers.category-cell-state-controller.network-error-flag.error.error.network-error-flag',
    messageType: 'transactional'
};

});


parcelRegister("b5lmY", function(module, exports) {

$parcel$export(module.exports, "WrapperCommon", () => $f10e7d989c7a367e$export$2cd335d97b9054d6);
$parcel$export(module.exports, "CellWrapper", () => $f10e7d989c7a367e$export$4812fadef83edffe);
$parcel$export(module.exports, "TextCellWrapper", () => $f10e7d989c7a367e$export$aea2b0ba32a5c9ab);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $f10e7d989c7a367e$export$2cd335d97b9054d6 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $f10e7d989c7a367e$var$wrapperCommonStyles
    }, props.children);
const $f10e7d989c7a367e$export$4812fadef83edffe = ({ isEditable: isEditable, testId: testId, children: children, hasPadding: hasPadding = true, ariaLabel: ariaLabel, onCut: onCut, onCopy: onCopy, onPaste: onPaste })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $f10e7d989c7a367e$var$wrapperCommonStyles,
            $f10e7d989c7a367e$var$cellWrapperStyles,
            isEditable && $f10e7d989c7a367e$var$editableCellWrapperStyles,
            hasPadding && $f10e7d989c7a367e$var$cellWrapperPaddingStyles
        ],
        testId: testId,
        "aria-label": ariaLabel,
        onCut: onCut,
        onCopy: onCopy,
        onPaste: onPaste
    }, children);
const $f10e7d989c7a367e$export$aea2b0ba32a5c9ab = ({ isEditable: isEditable, testId: testId, ariaLabel: ariaLabel, children: children, onCut: onCut, onCopy: onCopy, onPaste: onPaste })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $f10e7d989c7a367e$var$textCellWrapperStyles,
            isEditable && $f10e7d989c7a367e$var$editableTextCellWrapperStyles
        ],
        testId: testId,
        "aria-label": ariaLabel,
        onCut: onCut,
        onCopy: onCopy,
        onPaste: onPaste
    }, children);
const $f10e7d989c7a367e$var$wrapperCommonStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    outline: 'none'
});
const $f10e7d989c7a367e$var$cellWrapperStyles = (0, $8CUq3.xcss)({
    boxSizing: 'border-box',
    borderRadius: 'border.radius'
});
const $f10e7d989c7a367e$var$cellWrapperPaddingStyles = (0, $8CUq3.xcss)({
    paddingLeft: 'space.100'
});
const $f10e7d989c7a367e$var$editableCellWrapperStyles = (0, $8CUq3.xcss)({
    cursor: 'pointer'
});
const $f10e7d989c7a367e$var$textCellWrapperStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    outline: 'none',
    paddingTop: 'space.0',
    paddingBottom: 'space.0',
    paddingLeft: 'space.075',
    paddingRight: 'space.075',
    // @ts-expect-error - TS2353 - Object literal may only specify known properties, and 'form' does not exist in type 'SafeCSSObject'
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    form: {
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '[data-ds--text-field--input]': {
            height: '100%',
            outline: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '[data-ds--text-field--container], [data-ds--text-field--container]:focus-within': {
            outline: 'none',
            boxShadow: 'none',
            border: 'none'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    span: {
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    }
});
const $f10e7d989c7a367e$var$editableTextCellWrapperStyles = (0, $8CUq3.xcss)({
    cursor: 'text'
});

});

parcelRegister("e0a4D", function(module, exports) {

$parcel$export(module.exports, "FixItErrorFlag", () => $ebb64575ccac1f6b$export$68221e9bb70731fc);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dS3PR = parcelRequire("dS3PR");

var $daQYX = parcelRequire("daQYX");

var $2AOGO = parcelRequire("2AOGO");

var $6s1PB = parcelRequire("6s1PB");

var $jJZqs = parcelRequire("jJZqs");

var $LJaTB = parcelRequire("LJaTB");
var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $8tf7c = parcelRequire("8tf7c");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $fvbnb = parcelRequire("fvbnb");
const $ebb64575ccac1f6b$export$68221e9bb70731fc = ({ error: error, title: title, description: description, issueType: issueType, issueTypeId: issueTypeId, fieldId: fieldId, fieldName: fieldName })=>{
    const project = (0, $daQYX.useProject)();
    if (project.isSimplified) {
        const ASSOCIATION_OR_PERMISSION_ERROR = `Field '${fieldId}' cannot be set. It is not on the appropriate screen, or unknown.`;
        const errorMessage = error instanceof (0, $jJZqs.ValidationError) ? error.errors && error.errors[0] && error.errors[0].error || error.message : String(error);
        const isFixitError = errorMessage?.includes(ASSOCIATION_OR_PERMISSION_ERROR);
        const isEditPermissionError = isFixitError && !project.permissions.editIssues;
        if (isEditPermissionError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ebb64575ccac1f6b$var$EditPermissionErrorFlag, null);
        if (isFixitError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ebb64575ccac1f6b$var$FieldAssociationErrorFlag, {
            issueType: issueType,
            fieldName: fieldName,
            fieldId: fieldId,
            projectId: project.id,
            issueTypeId: issueTypeId,
            isAdmin: project.permissions.administerProject
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8tf7c.ErrorFlag), {
        error: error,
        title: title,
        description: description
    });
};
const $ebb64575ccac1f6b$var$EditPermissionErrorFlag = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'flag shown', 'editPermissionErrorFlag');
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $LJaTB.FlagRenderer), {
        flag: {
            type: 'warning',
            title: formatMessage((0, $fvbnb.default).editPermissionErrorTitle),
            messageId: 'business-fields.common.ui.fixit-error-flag.flag.warning.edit-permission-error-flag.flag-renderer',
            messageType: 'transactional',
            actions: [
                {
                    content: formatMessage((0, $fvbnb.default).editPermissionErrorAction),
                    href: '/secure/ContactAdministrators!default.jspa',
                    target: '_blank',
                    onClick: ()=>{
                        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'contactAdministratorFromEditPermissionFlag');
                    }
                }
            ]
        }
    });
};
const $ebb64575ccac1f6b$var$FieldAssociationErrorFlag = ({ fieldId: fieldId, fieldName: fieldName, issueType: issueType, projectId: projectId, issueTypeId: issueTypeId, isAdmin: isAdmin })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { associate: associate } = (0, $2AOGO.useAssociateField)();
    const { dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    const [shouldAssociate, setShouldAssociate] = (0, $5uXOq.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const dismissPreviousFlags = (0, $5uXOq.useRef)(true);
    const FIXIT_ERROR_FLAG_ID = `FIXIT_ERROR_FLAG_FOR_${issueTypeId}_${fieldId}`;
    (0, $5uXOq.useEffect)(()=>{
        if (shouldAssociate) {
            setShouldAssociate(false);
            associate({
                input: {
                    projectId: String(projectId),
                    fieldId: fieldId,
                    issueTypeIds: [
                        Number(issueTypeId)
                    ]
                },
                fieldName: fieldName,
                issueType: issueType,
                showSuccess: true,
                analyticsAttributes: {
                    source: 'business-fields.common.ui.fixit-error-flag'
                }
            }) // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            .catch(()=>{});
        }
    }, [
        associate,
        fieldId,
        fieldName,
        issueType,
        issueTypeId,
        projectId,
        shouldAssociate
    ]);
    (0, $5uXOq.useEffect)(()=>{
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'flag shown', 'fixItErrorFlag');
    }, [
        createAnalyticsEvent
    ]);
    const actions = isAdmin ? [
        {
            content: formatMessage((0, $fvbnb.default).updateFieldAssociationAction),
            onClick: async ()=>{
                if (projectId) {
                    dismissFlag(FIXIT_ERROR_FLAG_ID); // When associate service is called from the flag, it triggers refetch available fields internally, but
                    // `refetch` function is `undefined`. This could be because the flag is mounted outside of the view component
                    // where the available fields service hasn't been called yet (we can only refetch a service that has been called at least once).
                    // Hence we need to make sure we call associate() inside of the cell.
                    setShouldAssociate(true);
                }
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'associateFieldFromFixItFlag');
            }
        }
    ] : [
        {
            content: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $fvbnb.default).editIssueTypesPermissionErrorActionIssueTermRefresh : (0, $fvbnb.default).editIssueTypesPermissionErrorAction),
            href: '/secure/ContactAdministrators!default.jspa',
            target: '_blank',
            onClick: ()=>{
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'contactAdministratorFromFixitFlag');
            }
        }
    ]; // dismiss any existing flag with the same id
    if (dismissPreviousFlags.current) {
        dismissFlag(FIXIT_ERROR_FLAG_ID);
        dismissPreviousFlags.current = false;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $LJaTB.FlagRenderer), {
        flag: {
            id: FIXIT_ERROR_FLAG_ID,
            type: 'warning',
            title: [
                (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $fvbnb.default).editAssociationErrorTitleIssueTermRefresh : (0, $fvbnb.default).editAssociationErrorTitle,
                {
                    fieldName: fieldName,
                    issueType: issueType,
                    normal: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ebb64575ccac1f6b$var$FlagMessageWrapper, null, chunks),
                    strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
                            as: "strong"
                        }, chunks)
                }
            ],
            messageId: 'business-fields.common.ui.fixit-error-flag.flag.warning.field-association-error-flag.flag-renderer',
            messageType: 'transactional',
            actions: actions
        }
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ebb64575ccac1f6b$var$FlagMessageWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_k48pi7a9",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2AOGO", function(module, exports) {

$parcel$export(module.exports, "useAssociateField", () => $bda9e90d453c18dd$export$b4b274ed0d9c5388);

var $5uXOq = parcelRequire("5uXOq");

var $dS3PR = parcelRequire("dS3PR");

var $388MD = parcelRequire("388MD");

var $jFfcO = parcelRequire("jFfcO");

var $6s1PB = parcelRequire("6s1PB");

var $7HGHK = parcelRequire("7HGHK");
var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $ceIBL = parcelRequire("ceIBL");

var $6N6hk = parcelRequire("6N6hk");

var $d44vd = parcelRequire("d44vd");
const $bda9e90d453c18dd$export$c18a1e642576984f = (0, $7HGHK.toFlagId)('associate-field-error-flag');
const $bda9e90d453c18dd$export$5122d1806ca6643c = (0, $7HGHK.toFlagId)('associate-field-success-flag');
const $bda9e90d453c18dd$export$a2a68c9b88c306f0 = (0, $7HGHK.toFlagId)('refetch-fields-error-flag');
const $bda9e90d453c18dd$export$b4b274ed0d9c5388 = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    const { associate: associate, loading: loading, error: error } = (0, $ceIBL.useAssociateField)();
    const { refetchFields: refetchFields } = (0, $388MD.useRefetchFields)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    // the BE has a limitation where it cannot handle multiple associate calls in flight so we need a queue
    const [{ associateQueue: associateQueue }, { setAssociateQueue: setAssociateQueue, associate: associateStore, addToAssociateQueue: addToAssociateQueue }] = (0, $6N6hk.useAssociateFieldStore)();
    const associateField = (0, $5uXOq.useCallback)(({ input: input, fieldName: fieldName, issueType: issueType, showSuccess: showSuccess = false, analyticsAttributes: analyticsAttributes })=>new Promise((resolve, reject)=>{
            addToAssociateQueue({
                resolve: resolve,
                reject: reject,
                fieldProps: {
                    input: input,
                    fieldName: fieldName,
                    issueType: issueType,
                    showSuccess: showSuccess,
                    analyticsAttributes: analyticsAttributes
                }
            });
        }), [
        addToAssociateQueue
    ]);
    const associateNextInQueue = (0, $5uXOq.useCallback)(async ()=>{
        if (associateQueue.length === 0) return;
        const [{ resolve: resolve, reject: reject, fieldProps: { input: input, fieldName: fieldName, issueType: issueType, showSuccess: showSuccess, analyticsAttributes: analyticsAttributes = {} } }] = associateQueue;
        setAssociateQueue(associateQueue.splice(1)); // returns new array by keeping the first one only
        dismissFlag(`${$bda9e90d453c18dd$export$c18a1e642576984f}-${input.fieldId}`);
        dismissFlag(`${$bda9e90d453c18dd$export$a2a68c9b88c306f0}-${input.fieldId}`);
        const result = await associate({
            input: input
        });
        if (!result?.data?.jira?.jwmAssociateField?.success) {
            showFlag({
                id: `${$bda9e90d453c18dd$export$c18a1e642576984f}-${input.fieldId}`,
                type: 'error',
                title: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $d44vd.default).associateFieldErrorTitleV2IssueTermRefresh : (0, $d44vd.default).associateFieldErrorTitleV2, {
                    fieldName: fieldName
                }),
                description: (0, $d44vd.default).associateFieldErrorMessageV2,
                messageId: `business-inline-field-config-sidebar.controllers.associate-field.showFlag.error.${$bda9e90d453c18dd$export$c18a1e642576984f}-${input.fieldId}.associateFieldError`,
                messageType: 'transactional',
                actions: [
                    {
                        content: (0, $d44vd.default).associateFieldTryAgainAction,
                        onClick: ()=>{
                            associateField({
                                input: input,
                                fieldName: fieldName,
                                issueType: issueType,
                                showSuccess: showSuccess,
                                analyticsAttributes: analyticsAttributes
                            });
                        }
                    }
                ]
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'associate failed', analyticsAttributes);
            reject(new Error('Associate field mutation did not succeed'));
            return;
        }
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'field associated', analyticsAttributes);
        if (showSuccess) showFlag({
            id: $bda9e90d453c18dd$export$5122d1806ca6643c,
            type: 'success',
            title: (0, $d44vd.default).successTitle,
            description: [
                (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $d44vd.default).successDescriptionIssueTermRefresh : (0, $d44vd.default).successDescription,
                {
                    fieldName: fieldName,
                    issueType: issueType,
                    strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
                            as: "strong"
                        }, chunks)
                }
            ],
            messageId: `business-inline-field-config-sidebar.controllers.associate-field.showFlag.success.${$bda9e90d453c18dd$export$c18a1e642576984f}-${input.fieldId}`,
            messageType: 'transactional'
        });
        try {
            await refetchFields({
                shouldRetry: ([response])=>!(0, $jFfcO.isFieldInResponse)({
                        response: response,
                        fieldId: input.fieldId
                    })
            });
        } catch (e) {
            showFlag({
                id: `${$bda9e90d453c18dd$export$a2a68c9b88c306f0}-${input.fieldId}`,
                type: 'error',
                title: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $d44vd.default).refetchFieldsErrorTitleIssueTermRefresh : (0, $d44vd.default).refetchFieldsErrorTitle, {
                    fieldName: fieldName
                }),
                description: (0, $d44vd.default).refetchFieldsErrorMessage,
                messageId: `business-inline-field-config-sidebar.controllers.associate-field.showFlag.error.${$bda9e90d453c18dd$export$c18a1e642576984f}-${input.fieldId}.refetchFieldsError`,
                messageType: 'transactional'
            });
            reject(e);
            return;
        }
        resolve(result);
    }, [
        associateQueue,
        setAssociateQueue,
        dismissFlag,
        associate,
        createAnalyticsEvent,
        showFlag,
        formatMessage,
        associateField,
        refetchFields
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (associateQueue.length > 0) associateStore(associateNextInQueue);
    }, [
        associateQueue,
        associateNextInQueue,
        associateStore
    ]);
    return {
        associate: associateField,
        loading: loading,
        error: error
    };
};

});
parcelRegister("jFfcO", function(module, exports) {

$parcel$export(module.exports, "isFieldInResponse", () => $d5c202bb1245d36b$export$c323cb8dc752a295);
const $d5c202bb1245d36b$export$c323cb8dc752a295 = ({ fieldId: fieldId, response: response })=>{
    const field = (response.data.jiraBusinessAvailableFields?.edges ?? []).find((issueTypeEdge)=>issueTypeEdge?.node?.fields?.edges?.find((fieldEdge)=>fieldEdge?.node?.fieldId === fieldId));
    return !!field;
};

});

parcelRegister("ceIBL", function(module, exports) {

$parcel$export(module.exports, "useAssociateField", () => $e51943b33e758b1d$export$b4b274ed0d9c5388);

var $5tTFS = parcelRequire("5tTFS");

var $cm8b5 = parcelRequire("cm8b5");

var $jcw0u = parcelRequire("jcw0u");

var $eCBf9 = parcelRequire("eCBf9");

var $8empw = parcelRequire("8empw");

var $ki8aF = parcelRequire("ki8aF");

var $l0lZL = parcelRequire("l0lZL");
const $e51943b33e758b1d$export$a93d8cd30a94ee3a = 'associateJwmFieldMutation';
const $e51943b33e758b1d$var$findMutationBadRequestError = (data)=>data?.jira?.jwmAssociateField?.errors?.find((e)=>e.message);
const $e51943b33e758b1d$export$b4b274ed0d9c5388 = ()=>{
    const onExperienceSuccess = (0, $cm8b5.useExperienceSuccess)((0, $ki8aF.ASSOCIATE_FIELD_EXPERIENCE));
    const onExperienceFail = (0, $cm8b5.useExperienceFail)((0, $ki8aF.ASSOCIATE_FIELD_EXPERIENCE));
    const onExperienceStart = (0, $cm8b5.useExperienceStart)((0, $ki8aF.ASSOCIATE_FIELD_EXPERIENCE));
    const [associateField, { loading: loading, error: error }] = (0, $5tTFS.useMutation)((0, $l0lZL.QUERY), {
        onError: (apolloError)=>{
            (0, $jcw0u.default)({
                meta: {
                    id: $e51943b33e758b1d$export$a93d8cd30a94ee3a,
                    packageName: 'jiraBusinessInlineFieldConfigSidebar',
                    teamName: 'deliveroo'
                },
                error: Array.isArray(apolloError) && apolloError.length > 0 ? apolloError[0] : apolloError,
                attributes: {
                    message: 'Failed to associate the field with issue types'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            onExperienceFail('Failed to associate the field with issue types', apolloError);
        },
        onCompleted: (apolloData)=>{
            const mutationBadRequestError = $e51943b33e758b1d$var$findMutationBadRequestError(apolloData);
            if (mutationBadRequestError) {
                const isClientError = (0, $8empw.isClientErrorResponse)(mutationBadRequestError.extensions?.statusCode);
                isClientError ? onExperienceSuccess() : onExperienceFail('Failed to associate the field with issue types', new (0, $eCBf9.MutationError)(mutationBadRequestError));
            } else onExperienceSuccess();
        }
    });
    const associate = ({ input: input })=>{
        onExperienceStart();
        return associateField({
            variables: {
                input: input
            }
        });
    };
    return {
        associate: associate,
        loading: loading,
        error: error
    };
};

});
parcelRegister("8empw", function(module, exports) {

$parcel$export(module.exports, "isClientErrorResponse", () => $356c6d91a785011f$export$fa1f4b2a472e138c);
const $356c6d91a785011f$export$fa1f4b2a472e138c = (statusCode)=>statusCode && statusCode >= 400 && statusCode < 500 || false;

});

parcelRegister("ki8aF", function(module, exports) {

$parcel$export(module.exports, "availableFieldTypes", () => $f17544388eb6b17d$export$93dbaa9aec3844f0);
$parcel$export(module.exports, "CREATE_FIELD_EXPERIENCE", () => $f17544388eb6b17d$export$9eae0a16f5941351);
$parcel$export(module.exports, "ASSOCIATE_FIELD_EXPERIENCE", () => $f17544388eb6b17d$export$335bd3f229a4665a);
$parcel$export(module.exports, "DELETE_FIELD_EXPERIENCE", () => $f17544388eb6b17d$export$d7cc90452cff4bb3);
$parcel$export(module.exports, "UPDATE_FIELD_EXPERIENCE", () => $f17544388eb6b17d$export$64421f268399035e);
$parcel$export(module.exports, "GET_FIELDS_CONFIGURATION_EXPERIENCE", () => $f17544388eb6b17d$export$88bd6cc0b5f8c349);
$parcel$export(module.exports, "GET_FIELD_DETAILS_EXPERIENCE", () => $f17544388eb6b17d$export$e6582dde0a4e6af7);

var $5fc53 = parcelRequire("5fc53");
const $f17544388eb6b17d$var$defaultFieldOperations = {
    editable: true,
    canModifyRequired: true,
    canModifyOptions: true,
    canModifyDefaultValue: true,
    canModifyPropertyConfiguration: true,
    removable: true,
    categoriesWhitelist: [],
    canAssociateInSettings: true,
    deletable: true
};
const $f17544388eb6b17d$var$operations = {
    ...$f17544388eb6b17d$var$defaultFieldOperations,
    canModifyDefaultValue: false
};
const $f17544388eb6b17d$export$93dbaa9aec3844f0 = [
    {
        key: (0, $5fc53.TEXT_CF_TYPE),
        name: 'Short text',
        operations: $f17544388eb6b17d$var$operations
    },
    {
        key: (0, $5fc53.TEXT_AREA_CF_TYPE),
        name: 'Paragraph',
        operations: $f17544388eb6b17d$var$operations
    },
    {
        key: (0, $5fc53.DATETIME_CF_TYPE),
        name: 'Timestamp',
        operations: $f17544388eb6b17d$var$operations
    },
    {
        key: (0, $5fc53.SELECT_CF_TYPE),
        name: 'Dropdown',
        operations: $f17544388eb6b17d$var$operations
    },
    {
        key: (0, $5fc53.DATE_CF_TYPE),
        name: 'Date',
        operations: $f17544388eb6b17d$var$operations
    },
    {
        key: (0, $5fc53.NUMBER_CF_TYPE),
        name: 'Number',
        operations: $f17544388eb6b17d$var$operations
    },
    {
        key: (0, $5fc53.LABELS_CF_TYPE),
        name: 'Labels',
        operations: $f17544388eb6b17d$var$operations
    },
    {
        key: (0, $5fc53.MULTI_CHECKBOXES_CF_TYPE),
        name: 'Checkbox',
        operations: $f17544388eb6b17d$var$operations
    },
    {
        key: (0, $5fc53.PEOPLE_CF_TYPE),
        name: 'People',
        operations: $f17544388eb6b17d$var$operations
    },
    {
        key: (0, $5fc53.URL_CF_TYPE),
        name: 'Url',
        operations: $f17544388eb6b17d$var$operations
    }
];
const $f17544388eb6b17d$export$b8b9d90f9e5bd72b = 'jiraBusinessInlineFieldConfigSidebar';
const $f17544388eb6b17d$export$9eae0a16f5941351 = {
    experience: 'createField',
    packageName: $f17544388eb6b17d$export$b8b9d90f9e5bd72b,
    teamName: 'deliveroo'
};
const $f17544388eb6b17d$export$335bd3f229a4665a = {
    experience: 'associateField',
    packageName: $f17544388eb6b17d$export$b8b9d90f9e5bd72b,
    teamName: 'deliveroo'
};
const $f17544388eb6b17d$export$d7cc90452cff4bb3 = {
    experience: 'deleteField',
    packageName: $f17544388eb6b17d$export$b8b9d90f9e5bd72b,
    teamName: 'deliveroo'
};
const $f17544388eb6b17d$export$64421f268399035e = {
    experience: 'updateField',
    packageName: $f17544388eb6b17d$export$b8b9d90f9e5bd72b,
    teamName: 'deliveroo'
};
const $f17544388eb6b17d$export$88bd6cc0b5f8c349 = {
    experience: 'getFieldsConfiguration',
    packageName: $f17544388eb6b17d$export$b8b9d90f9e5bd72b,
    teamName: 'deliveroo'
};
const $f17544388eb6b17d$export$e6582dde0a4e6af7 = {
    experience: 'getFieldDetails',
    packageName: $f17544388eb6b17d$export$b8b9d90f9e5bd72b,
    teamName: 'deliveroo'
};

});

parcelRegister("l0lZL", function(module, exports) {

$parcel$export(module.exports, "QUERY", () => $e534c5bba2da4535$export$2b91517d6d5b4365);

var $5cllN = parcelRequire("5cllN");
const $e534c5bba2da4535$export$2b91517d6d5b4365 = (0, $5cllN.default)`
mutation JwmAssociateField ($input: JiraWorkManagementAssociateFieldInput!) {
  jira {
    jwmAssociateField (input: $input) {
      success
      errors {
        extensions {
          errorType
          statusCode
        }
        message
      }
      associatedIssueTypeIds
    }
  }
}
`;

});


parcelRegister("6N6hk", function(module, exports) {

$parcel$export(module.exports, "useAssociateFieldStore", () => $aface8d3c0a62f76$export$877fa8e9cadf66c8);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $aface8d3c0a62f76$var$actions = {
    addAssociatingField: (fieldId)=>({ setState: setState, getState: getState })=>{
            setState({
                associatingFields: [
                    ...getState().associatingFields,
                    fieldId
                ]
            });
        },
    removeAssociatingField: (fieldId)=>({ setState: setState, getState: getState })=>{
            setState({
                associatingFields: getState().associatingFields.filter((assocFieldId)=>fieldId !== assocFieldId)
            });
        },
    setAssociateQueue: (associateQueue)=>({ setState: setState })=>{
            setState({
                associateQueue: associateQueue
            });
        },
    addToAssociateQueue: (itemToAssociate)=>({ setState: setState, getState: getState })=>{
            setState({
                associateQueue: [
                    ...getState().associateQueue,
                    itemToAssociate
                ]
            });
        },
    setIsAssociating: (isAssociating)=>({ setState: setState })=>{
            setState({
                isAssociating: isAssociating
            });
        },
    associate: (associateFunction)=>async ({ setState: setState, getState: getState })=>{
            if (!getState().isAssociating) {
                setState({
                    isAssociating: true
                });
                try {
                    await associateFunction();
                } finally{
                    setState({
                        isAssociating: false
                    });
                }
            }
        }
};
const $aface8d3c0a62f76$var$Store = (0, $iXqE5.createStore)({
    initialState: {
        associatingFields: [],
        associateQueue: [],
        isAssociating: false
    },
    actions: $aface8d3c0a62f76$var$actions,
    name: 'JwmFieldConfigAssociatingFields'
});
const $aface8d3c0a62f76$export$877fa8e9cadf66c8 = (0, $3sQ5x.createHook)($aface8d3c0a62f76$var$Store);

});

parcelRegister("d44vd", function(module, exports) {

$parcel$export(module.exports, "default", () => $adc3ae8cb1b6f08f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $adc3ae8cb1b6f08f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    associateFieldErrorTitleV2: {
        "id": "business-inline-field-config-sidebar.controllers.associate-field.associate-field-error-title-v-2",
        "defaultMessage": "Unable to connect {fieldName} to issue types in this project"
    },
    associateFieldErrorMessageV2: {
        "id": "business-inline-field-config-sidebar.controllers.associate-field.associate-field-error-message-v-2",
        "defaultMessage": "Check your connection, then try again."
    },
    associateFieldTryAgainAction: {
        "id": "business-inline-field-config-sidebar.controllers.associate-field.associate-field-try-again-action",
        "defaultMessage": "Try again"
    },
    refetchFieldsErrorTitle: {
        "id": "business-inline-field-config-sidebar.controllers.associate-field.refetch-fields-error-title",
        "defaultMessage": "{fieldName} has been associated to issue types in the list view"
    },
    refetchFieldsErrorMessage: {
        "id": "business-inline-field-config-sidebar.controllers.associate-field.refetch-fields-error-message",
        "defaultMessage": "Wait a few moments and try refreshing your page to see the change."
    },
    successTitle: {
        "id": "business-inline-field-config-sidebar.controllers.associate-field.success-title",
        "defaultMessage": "Field association updated!"
    },
    successDescription: {
        "id": "business-inline-field-config-sidebar.controllers.associate-field.success-description",
        "defaultMessage": "You can now use the <strong>{fieldName}</strong> field for your <strong>{issueType}</strong> issue type"
    },
    associateFieldErrorTitleV2IssueTermRefresh: {
        "id": "business-inline-field-config-sidebar.controllers.associate-field.associate-field-error-title-v-2-issue-term-refresh",
        "defaultMessage": "Unable to connect {fieldName} to work types in this project"
    },
    refetchFieldsErrorTitleIssueTermRefresh: {
        "id": "business-inline-field-config-sidebar.controllers.associate-field.refetch-fields-error-title-issue-term-refresh",
        "defaultMessage": "{fieldName} has been associated to work types in the list view"
    },
    successDescriptionIssueTermRefresh: {
        "id": "business-inline-field-config-sidebar.controllers.associate-field.success-description-issue-term-refresh",
        "defaultMessage": "You can now use the <strong>{fieldName}</strong> field for a <strong>{issueType}</strong>"
    }
});

});


parcelRegister("fvbnb", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ca24c5034e4757b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0ca24c5034e4757b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    editAssociationErrorTitle: {
        "id": "business-fields.common.fixit-error-flag.edit-association-error-title",
        "defaultMessage": "<normal><strong>{fieldName}</strong> is not associated to the <strong>{issueType}</strong> issue type</normal>"
    },
    updateFieldAssociationAction: {
        "id": "business-fields.common.fixit-error-flag.update-field-association-action",
        "defaultMessage": "Update field association"
    },
    editPermissionErrorTitle: {
        "id": "business-fields.common.fixit-error-flag.edit-permission-error-title",
        "defaultMessage": "You do not have permission to edit in this project"
    },
    editPermissionErrorAction: {
        "id": "business-fields.common.fixit-error-flag.edit-permission-error-action",
        "defaultMessage": "Contact your project admin"
    },
    editIssueTypesPermissionErrorAction: {
        "id": "business-fields.common.fixit-error-flag.edit-issue-types-permission-error-action",
        "defaultMessage": "Contact your project admin to edit issue types"
    },
    editAssociationErrorTitleIssueTermRefresh: {
        "id": "business-fields.common.fixit-error-flag.edit-association-error-title-issue-term-refresh",
        "defaultMessage": "<normal><strong>{fieldName}</strong> isn't associated with a <strong>{issueType}</strong>.</normal>"
    },
    editIssueTypesPermissionErrorActionIssueTermRefresh: {
        "id": "business-fields.common.fixit-error-flag.edit-issue-types-permission-error-action-issue-term-refresh",
        "defaultMessage": "Contact your project admin to edit work types"
    }
});

});


parcelRegister("dSjBh", function(module, exports) {

$parcel$export(module.exports, "CategoryCellContent", () => $56d35fac8f7fcd7a$export$acfc5fe93bbbc6de);

var $5uXOq = parcelRequire("5uXOq");

var $DhnKp = parcelRequire("DhnKp");

var $k2xO1 = parcelRequire("k2xO1");
const $56d35fac8f7fcd7a$export$acfc5fe93bbbc6de = ({ categoryState: categoryState, isEditable: isEditable, onClick: onClick })=>{
    if (!categoryState) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k2xO1.TagListWrapper), {
        onClick: onClick,
        isEditable: isEditable,
        "data-testid": "business-list.ui.list-view.category-cell.category-cell-content.no-category-wrapper"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k2xO1.TagListWrapper), {
        onClick: onClick,
        isEditable: isEditable,
        "data-testid": "business-list.ui.list-view.category-cell.category-cell-content.category-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $DhnKp.default), {
        categoryColor: categoryState.color?.toString() ?? null,
        categoryName: categoryState.value ?? ''
    }));
};

});
parcelRegister("k2xO1", function(module, exports) {

$parcel$export(module.exports, "TagListWrapper", () => $34393a02d8ac31b7$export$e4f5eab7c40840c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

const $34393a02d8ac31b7$export$e4f5eab7c40840c = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFocused: isFocused, isEditable: isEditable, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1uzc8vy": (0, $lD23V.default)((0, $ddd90f161976f576$export$e643c5fb607dbcc5))
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _11c82smr _11vw1qnq _1e0c1txw _4cvr1h6o _1bsb1osq _4t3i1osq _1n261q9c _ca0qidpf _u5f312x7 _n3tdidpf _19bv12x7 _o5721q9c _hc7q15vq _njtz15vq _p7r1116y",
            __cmplp.isFocused ? "_16qs179s" : "_16qsglyw",
            __cmplp.isFocused ? "_bfhkvuon" : "_bfhk18uv",
            __cmplp.isEditable ?? true ? "_80omtlke" : "_80om73ad",
            __cmplp.className
        ])
    });
});

});
const $ddd90f161976f576$var$SHADOW_SIZE = 2;
const $ddd90f161976f576$export$e643c5fb607dbcc5 = `0 0 0 ${$ddd90f161976f576$var$SHADOW_SIZE}px ${"var(--ds-border-focused, #388BFF)"} inset`;
const $ddd90f161976f576$export$258441c8a79bb589 = 40;



parcelRegister("3aLMK", function(module, exports) {

$parcel$export(module.exports, "default", () => $efa1d55d3f04cd7e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $efa1d55d3f04cd7e$var$LazyDeleteCategoryModal = (0, $kxZPA.lazy)(()=>(parcelRequire("gKRbW")), {
    ssr: false,
    moduleId: "./src/packages/business/list/src/ui/list-view/category-cell/delete-category-modal/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$efa1d55d3f04cd7e$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "delete-category-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($efa1d55d3f04cd7e$var$LazyDeleteCategoryModal, props));

});
parcelRegister("gKRbW", function(module, exports) {

let $c32a33f1ffb529bc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c32a33f1ffb529bc$var$load("5cHFe").then(()=>parcelRequire('dyQ1C'));

});


parcelRegister("gvQOt", function(module, exports) {

$parcel$export(module.exports, "EditCategoryCell", () => $9ae93109dcf682a6$export$a89ef86139e07798);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $dC5iT = parcelRequire("dC5iT");
var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $bChGW = parcelRequire("bChGW");

var $41j30 = parcelRequire("41j30");

var $dKy4F = parcelRequire("dKy4F");


var $2uW5h = parcelRequire("2uW5h");

var $daQYX = parcelRequire("daQYX");

var $jRzRt = parcelRequire("jRzRt");

var $4R6GH = parcelRequire("4R6GH");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $pa9q9 = parcelRequire("pa9q9");

var $5fc53 = parcelRequire("5fc53");

var $jgJNO = parcelRequire("jgJNO");

var $eTDjN = parcelRequire("eTDjN");

var $6du7W = parcelRequire("6du7W");

var $lI995 = parcelRequire("lI995");

var $1pa56 = parcelRequire("1pa56");

var $bqVq1 = parcelRequire("bqVq1");

var $jGpUV = parcelRequire("jGpUV");
const $9ae93109dcf682a6$export$494249755a84b147 = (field)=>field != null && field.type === (0, $5fc53.CATEGORY_TYPE); // Creating type guard because Typescript bug with filtering readonly array
// https://github.com/microsoft/TypeScript/issues/17002#issuecomment-494937708
const $9ae93109dcf682a6$var$isReadOnlyArray = (param)=>Array.isArray(param);
const $9ae93109dcf682a6$var$LOAD_OPTIONS_DEBOUNCE_TIMER = 300;
const $9ae93109dcf682a6$var$POPUP_OFFSET = [
    0,
    -(0, $eTDjN.DEFAULT_ROW_HEIGHT)
];
const $9ae93109dcf682a6$var$optionStyles = {
    root: "_1di6glyw"
};
const $9ae93109dcf682a6$export$a89ef86139e07798 = ({ width: width, issueTypeId: issueTypeId, categoryState: categoryState, categoryOptions: categoryOptions, triggerContent: triggerContent, setCategoryToDeleteInModal: setCategoryToDeleteInModal, onCategoryCellValueChange: onCategoryCellValueChange, onCategoryUpdate: onCategoryUpdate, onCategoryCreate: onCategoryCreate, onCategoryNameAlreadyExists: onCategoryNameAlreadyExists, wrapperRef: wrapperRef, cellRef: cellRef, inputValue: inputValue, onInputChange: onInputChange })=>{
    const [defaultCategoryOptions, setDefaultCategoryOptions] = (0, $5uXOq.useState)(categoryOptions);
    const [editCategoryCellState, setEditCategoryCellState] = (0, $5uXOq.useState)({
        status: 'idle'
    });
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const project = (0, $daQYX.useProject)();
    const hasAdminPermission = project.permissions.administerProject;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isCreateOptionFocused = (0, $5uXOq.useRef)(false);
    const searchCategories = (0, $5uXOq.useCallback)((query = '')=>{
        // TODO: JET-3807 Replace with back end fetch API
        const filteredCategories = categoryOptions.filter((categoryOption)=>categoryOption?.label.toLowerCase().startsWith(query.toLowerCase()));
        return Promise.resolve(filteredCategories);
    }, [
        categoryOptions
    ]);
    (0, $5uXOq.useEffect)(()=>{
        setDefaultCategoryOptions(categoryOptions);
    }, [
        categoryOptions
    ]);
    const loadOptionsDebounced = (0, $5uXOq.useCallback)((...args)=>{
        const debounced = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(searchCategories, $9ae93109dcf682a6$var$LOAD_OPTIONS_DEBOUNCE_TIMER, {
            leading: true
        });
        return debounced(...args);
    }, [
        searchCategories
    ]);
    const showErrorFlag = (0, $5uXOq.useCallback)(()=>{
        showFlag({
            id: (0, $1pa56.CREATE_CATEGORY_ERROR_FLAG_ID),
            render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1pa56.default), null)
        });
    }, [
        showFlag
    ]);
    const handleChange = (0, $5uXOq.useCallback)((newOption)=>{
        if ($9ae93109dcf682a6$var$isReadOnlyArray(newOption)) // Select component supports both single and multiple select
        // for categories we don't allow multiple select
        return;
        const isValueEqual = newOption?.value === categoryState?.optionId; // handleChange is triggered when we click edit a category
        // in which cases we don't want to saveAndClose
        if (isValueEqual || editCategoryCellState.status !== 'idle') return;
        onCategoryCellValueChange(newOption ? {
            optionId: newOption.value,
            value: newOption.label,
            color: newOption.color
        } : null);
    }, [
        categoryState?.optionId,
        editCategoryCellState.status,
        onCategoryCellValueChange
    ]);
    const updateEditingCategory = (0, $5uXOq.useCallback)((categoryLabel, categoryValue, categoryColor)=>{
        setEditCategoryCellState({
            status: 'updating-category',
            categoryName: categoryLabel ?? '',
            categoryOptionId: categoryValue ?? '',
            categoryColor: categoryColor ?? null
        });
    }, []);
    const handleCreate = (0, $5uXOq.useCallback)((categoryName)=>{
        if (!hasAdminPermission) {
            showErrorFlag();
            return;
        }
        setEditCategoryCellState({
            status: 'creating-category',
            categoryToBeCreated: categoryName
        });
    }, [
        hasAdminPermission,
        showErrorFlag
    ]);
    const onNewCategoryFormSubmit = (0, $5uXOq.useCallback)((newCategory)=>{
        onCategoryCreate(newCategory.categoryName, newCategory.categoryColor);
        setEditCategoryCellState({
            status: 'idle'
        });
    }, [
        onCategoryCreate
    ]);
    const onEditCategoryFormSubmit = (0, $5uXOq.useCallback)((updatedCategory)=>{
        if (editCategoryCellState.status === 'updating-category') {
            onCategoryUpdate({
                optionId: editCategoryCellState.categoryOptionId,
                newCategoryName: updatedCategory.categoryName,
                newCategoryColor: updatedCategory.categoryColor
            });
            setEditCategoryCellState({
                status: 'idle'
            });
        }
    }, [
        onCategoryUpdate,
        editCategoryCellState
    ]);
    const getCreateCategoryLabel = (0, $5uXOq.useCallback)((categoryInputValue)=>`${categoryInputValue} (${formatMessage((0, $jGpUV.default).createNewCategory)})`, [
        formatMessage
    ]);
    const trigger = (0, $5uXOq.useCallback)((triggerProps)=>{
        const ref = (node)=>{
            if (typeof triggerProps.ref === 'function') triggerProps.ref(node);
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
            ...triggerProps,
            xcss: $9ae93109dcf682a6$var$popupTriggerStyles,
            ref: ref
        }, triggerContent);
    }, [
        triggerContent
    ]);
    const getCustomComponents = (0, $5uXOq.useCallback)((onContentUpdate)=>({
            Option: (optionProps)=>{
                const { label: label, value: value, data: optionPropsData, isFocused: isFocused } = optionProps;
                const { __isNew__: isCreateOption } = optionPropsData;
                isCreateOptionFocused.current = isCreateOption && isFocused;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Option, {
                    ...optionProps,
                    xcss: $9ae93109dcf682a6$var$optionStyles.root
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bqVq1.default), {
                    label: label,
                    value: value,
                    color: optionPropsData?.color,
                    isFocused: isFocused,
                    isCreateOption: isCreateOption,
                    issueTypeId: issueTypeId,
                    onCategoryIsEditing: (categoryLabel, categoryValue, categoryColor)=>{
                        updateEditingCategory(categoryLabel, categoryValue, categoryColor);
                        onContentUpdate();
                    },
                    onCategoryUpdate: onCategoryUpdate,
                    categoryBeenEdited: editCategoryCellState.status === 'updating-category' ? editCategoryCellState.categoryName : null,
                    wrapperRef: wrapperRef,
                    selectedOption: categoryState?.value ?? '',
                    setCategoryToDeleteInModal: setCategoryToDeleteInModal
                }));
            }
        }), [
        issueTypeId,
        updateEditingCategory,
        onCategoryUpdate,
        editCategoryCellState,
        wrapperRef,
        categoryState?.value,
        setCategoryToDeleteInModal
    ]);
    const styles = (0, $5uXOq.useMemo)(()=>({
            dropdownIndicator: (base)=>({
                    ...base,
                    display: 'none'
                }),
            option: (base)=>({
                    ...base,
                    padding: '0px',
                    // A grey background is applied when hard presing on the edit/delete category control buttons
                    ':active': {
                        backgroundColor: 'none'
                    },
                    ...editCategoryCellState.status === 'updating-category' && {
                        boxShadow: 'none',
                        background: 'none'
                    }
                }),
            container: (base)=>({
                    ...base,
                    cursor: `${editCategoryCellState.status === 'updating-category' ? 'default' : 'pointer'}`,
                    background: "var(--ds-surface, #FFFFFF)"
                })
        }), [
        editCategoryCellState.status
    ]);
    const noOptionMessage = (0, $5uXOq.useCallback)(()=>{
        if ((0, $4R6GH.fg)('jira_project_deny_viewers_create_category')) {
            if (!inputValue || inputValue.trim().length === 0) return formatMessage((0, $jGpUV.default).noMatches);
            return !hasAdminPermission ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $9ae93109dcf682a6$var$noResultsStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
                ...(0, $jGpUV.default).noMatchesContactAdmin,
                values: {
                    br: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null),
                    contactAdminLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $41j30.default), {
                        href: "/jira/contact-administrator"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $jGpUV.default).contactAdminLink))
                }
            })) : formatMessage((0, $jGpUV.default).noMatches);
        }
        return formatMessage((0, $jGpUV.default).noMatches);
    }, [
        formatMessage,
        inputValue,
        hasAdminPermission
    ]);
    const PopupComponentBasedOnOptionsHeight = (0, $5uXOq.useMemo)(()=>(0, $jRzRt.getPopupComponentWithHeight)({
            numOptions: defaultCategoryOptions.length,
            hasFooter: true
        }), [
        defaultCategoryOptions
    ]);
    const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
        if (editCategoryCellState.status !== 'idle') return true;
        if (event.code === 'Tab') return true;
        if (event.code === 'Enter' && isCreateOptionFocused.current) return true;
        return false;
    }, [
        editCategoryCellState.status
    ]);
    const handleBlur = (0, $5uXOq.useCallback)(()=>true, []);
    (0, $5uXOq.useImperativeHandle)(cellRef, ()=>({
            onKeyDown: handleKeyDown,
            onBlur: handleBlur
        }), [
        handleKeyDown,
        handleBlur
    ]);
    const categoryEditData = (0, $5uXOq.useMemo)(()=>editCategoryCellState.status === 'updating-category' ? {
            categoryName: editCategoryCellState.categoryName,
            categoryColor: editCategoryCellState.categoryColor
        } : {
            categoryName: '',
            categoryColor: null
        }, [
        editCategoryCellState
    ]);
    const canCreateNewCategory = (0, $5uXOq.useMemo)(()=>{
        const denyAllNewCategories = ()=>false; // undefined tells react-select to use the default behavior for deciding if a new category name is valid
        return !hasAdminPermission ? denyAllNewCategories : undefined;
    }, [
        hasAdminPermission
    ]);
    const popupContent = (0, $5uXOq.useCallback)(({ update: onContentUpdate })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lI995.CellContentWrapper // -1px border left from gridcell
        ), {
            preferredWidth: editCategoryCellState.status === 'idle' ? width - 1 : (0, $c8d9a5c50f0c3337$export$5aa64aeadd515250) - 1,
            "data-testid": "business-list.ui.list-view.category-cell.edit-category-cell.category-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6du7W.default), {
            autoFocus: true,
            isValidNewOption: (0, $4R6GH.fg)('jira_project_deny_viewers_create_category') ? canCreateNewCategory : undefined,
            value: (0, $dKy4F.toCategorySelectOption)(categoryState),
            label: editCategoryCellState.status === 'creating-category' ? editCategoryCellState.categoryToBeCreated : formatMessage((0, $jGpUV.default).placeholder),
            placeholder: editCategoryCellState.status === 'creating-category' ? editCategoryCellState.categoryToBeCreated : formatMessage((0, $jGpUV.default).placeholder),
            onChange: handleChange,
            isClearable: true,
            isMulti: false,
            isDisabled: editCategoryCellState.status !== 'idle',
            noOptionsMessage: noOptionMessage,
            menuIsOpen: editCategoryCellState.status === 'idle',
            onCreateOption: (categoryName)=>{
                handleCreate(categoryName);
                onContentUpdate();
            },
            formatCreateLabel: getCreateCategoryLabel,
            defaultOptions: defaultCategoryOptions,
            loadOptions: loadOptionsDebounced,
            components: getCustomComponents(onContentUpdate),
            styles: styles,
            inputValue: inputValue,
            onInputChange: onInputChange
        })), editCategoryCellState.status !== 'idle' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2uW5h.default), {
            initialData: editCategoryCellState.status === 'creating-category' ? {
                categoryName: editCategoryCellState.categoryToBeCreated,
                categoryColor: null
            } : categoryEditData,
            type: editCategoryCellState.status === 'creating-category' ? 'create' : 'edit',
            onCancel: ()=>{
                setEditCategoryCellState({
                    status: 'idle'
                });
                onContentUpdate();
            },
            onCheckExistingCategoryName: onCategoryNameAlreadyExists,
            onSubmit: editCategoryCellState.status === 'creating-category' ? onNewCategoryFormSubmit : onEditCategoryFormSubmit
        })), [
        canCreateNewCategory,
        inputValue,
        onInputChange,
        editCategoryCellState,
        width,
        categoryState,
        formatMessage,
        handleChange,
        noOptionMessage,
        handleCreate,
        getCreateCategoryLabel,
        defaultCategoryOptions,
        loadOptionsDebounced,
        getCustomComponents,
        styles,
        categoryEditData,
        onNewCategoryFormSubmit,
        onEditCategoryFormSubmit,
        onCategoryNameAlreadyExists
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        testId: "business-list.ui.list-view.category-cell.edit-category-cell.popup",
        isOpen: true,
        placement: "bottom-start",
        messageId: "business-list.ui.list-view.category-cell.edit-category-cell.popup",
        messageType: "transactional",
        autoFocus: false,
        offset: $9ae93109dcf682a6$var$POPUP_OFFSET,
        popupComponent: // PopupComponentBasedOnOptionsHeight is used to calculate the height to accommodate total of options in the dropdown
        // when the editCategoryCellState is changed to non `idle`, to prevent cutoff of the `CategoryForm`, which can be taller than the total of options in the dropdown
        // we want to recalculate the height based on the content of the popup, which is the default behavior of the PopupComponent
        editCategoryCellState.status === 'idle' ? PopupComponentBasedOnOptionsHeight : (0, $jRzRt.PopupComponent),
        trigger: trigger,
        content: popupContent
    });
};
const $9ae93109dcf682a6$var$popupTriggerStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.neutral.subtle',
    padding: 'space.0'
});
const $9ae93109dcf682a6$var$noResultsStyles = (0, $8CUq3.xcss)({
    textAlign: 'start'
});

});
parcelRegister("dKy4F", function(module, exports) {

$parcel$export(module.exports, "toCategorySelectOption", () => $458e9e69d75d72fc$export$2187805b683a1b65);
const $458e9e69d75d72fc$export$2187805b683a1b65 = (jiraOption)=>{
    if (jiraOption == null) return null;
    return {
        value: String(jiraOption.optionId),
        label: jiraOption.value || '',
        color: jiraOption.color
    };
};

});

const $c8d9a5c50f0c3337$export$5aa64aeadd515250 = 370;

parcelRegister("2uW5h", function(module, exports) {

$parcel$export(module.exports, "default", () => $f318f1743b0e0ca7$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $iKhOS = parcelRequire("iKhOS");

var $fVnbM = parcelRequire("fVnbM");
var $2rqOp = parcelRequire("2rqOp");

var $efXp3 = parcelRequire("efXp3");
var $qfj8c = parcelRequire("qfj8c");
var $7O4UO = parcelRequire("7O4UO");

var $l1N8i = parcelRequire("l1N8i");

var $ebd3R = parcelRequire("ebd3R");

var $3dGN0 = parcelRequire("3dGN0");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $kY99m = parcelRequire("kY99m");

var $4R6GH = parcelRequire("4R6GH");

var $7XYc4 = parcelRequire("7XYc4");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dCm1o = parcelRequire("dCm1o");

var $gSwFG = parcelRequire("gSwFG");

var $kTBFu = parcelRequire("kTBFu");

var $DhnKp = parcelRequire("DhnKp");

var $jordx = parcelRequire("jordx");
const $f318f1743b0e0ca7$var$CategoryForm = ({ onCancel: onCancel, onSubmit: onSubmit, initialData: initialData, type: type, onCheckExistingCategoryName: onCheckExistingCategoryName })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { categoryColor: categoryColor, categoryName: categoryName } = initialData;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [currentColor, setCurrentColor] = (0, $5uXOq.useState)(categoryColor === null ? (0, $gSwFG.getRandomColor)() : categoryColor);
    const [currentName, setCurrentName] = (0, $5uXOq.useState)(categoryName);
    const inputElement = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'CategoryForm viewed', {
            purpose: type
        });
    }, [
        createAnalyticsEvent,
        type
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (inputElement.current) // This ensures that the input element is focused after the component is rendered
        (0, (/*@__PURE__*/$parcel$interopDefault($iKhOS)))(()=>inputElement?.current?.focus());
    }, []);
    const isValidCategoryName = (0, $5uXOq.useCallback)((value)=>{
        // Blank category name validation
        if (!value || value.trim() === '') return formatMessage((0, $jordx.default).errorMessageBlankCategoryName);
        if ((0, $4R6GH.fg)('jira_project_category_duplication_error_validation')) {
            if (onCheckExistingCategoryName(value)) return formatMessage((0, $jordx.default).errorMessageDuplicateCategoryName);
        }
        return undefined;
    }, [
        formatMessage,
        onCheckExistingCategoryName
    ]);
    const handleSubmit = (0, $5uXOq.useCallback)((formData)=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', type === 'edit' ? 'categoryFormSave' : 'categoryFormAdd');
        onSubmit && onSubmit(formData);
    }, [
        createAnalyticsEvent,
        onSubmit,
        type
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $f318f1743b0e0ca7$var$formStyles,
        backgroundColor: "elevation.surface.overlay"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $f318f1743b0e0ca7$var$previewStyles,
        testId: "business-categories.ui.category-form.preview"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h4",
        size: "small"
    }, type === 'edit' ? formatMessage((0, $jordx.default).editCategoryTitle) : formatMessage((0, $jordx.default).newCategoryTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3dGN0))), {
        label: "",
        color: "var(--ds-icon-subtle, #626F86)",
        spacing: (0, $dCm1o.isVisualRefreshEnabled)() ? 'spacious' : 'none',
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($ebd3R)))
    }), currentName !== '' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f318f1743b0e0ca7$var$TagContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $DhnKp.default), {
        categoryName: currentName,
        categoryColor: currentColor
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $efXp3.default), {
        onSubmit: handleSubmit
    }, ({ formProps: formProps, submitting: submitting })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f318f1743b0e0ca7$var$StyledForm, {
            ...formProps,
            autoComplete: "off",
            "data-testid": "business-categories.ui.category-form.form"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f318f1743b0e0ca7$var$FieldsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
            name: "categoryName",
            defaultValue: initialData.categoryName,
            testId: "business-categories.ui.category-form.category-name",
            validate: isValidCategoryName
        }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $f318f1743b0e0ca7$var$textFieldWrapperStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
                ...fieldProps,
                "aria-label": formatMessage((0, $jordx.default).categoryNameLabel),
                autoComplete: "off",
                autoFocus: true,
                ref: inputElement,
                placeholder: formatMessage((0, $jordx.default).categoryNamePlaceholder),
                onChange: (e)=>{
                    setCurrentName(e.currentTarget.value);
                    fieldProps.onChange(e);
                },
                width: "100%"
            }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, error)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f318f1743b0e0ca7$var$FieldsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
            name: "categoryColor",
            defaultValue: currentColor
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kTBFu.CategoryColorPicker), {
                ...fieldProps,
                onChangeColor: (newColor)=>{
                    setCurrentColor(newColor);
                    fieldProps.onChange(newColor);
                    (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'color clicked', 'categoryFormColorPicker', {
                        color: newColor
                    });
                },
                color: currentColor
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            gap: "space.100",
            justifyContent: "end"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "subtle",
            testId: "business-categories.ui.category-form.cancel-button",
            onClick: ()=>{
                onCancel();
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'categoryFormCancel');
            }
        }, formatMessage((0, $jordx.default).cancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2rqOp.default), {
            appearance: "primary",
            type: "submit",
            isLoading: submitting,
            testId: "business-categories.ui.category-form.submit-button",
            isDisabled: (0, $4R6GH.fg)('jira_project_category_duplication_error_validation') ? isValidCategoryName(currentName) !== undefined : false
        }, type === 'edit' ? formatMessage((0, $jordx.default).saveButton) : formatMessage((0, $jordx.default).addButton))))));
};
var $f318f1743b0e0ca7$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($f318f1743b0e0ca7$var$CategoryForm);
const $f318f1743b0e0ca7$var$formStyles = (0, $8CUq3.xcss)({
    marginBlockStart: 'space.100',
    borderRadius: 'border.radius.200',
    boxShadow: 'elevation.shadow.overlay',
    display: 'block',
    padding: 'space.200',
    width: 'fit-content'
});
const $f318f1743b0e0ca7$var$previewStyles = (0, $8CUq3.xcss)({
    whiteSpace: 'nowrap',
    maxWidth: '360px',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
const $f318f1743b0e0ca7$var$tagContainerStyles = (0, $8CUq3.xcss)({
    display: 'grid',
    paddingTop: 'space.025'
});
const $f318f1743b0e0ca7$var$TagContainer = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $f318f1743b0e0ca7$var$tagContainerStyles
    }, children), (0, $5uXOq.Fragment)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f318f1743b0e0ca7$var$StyledForm = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "form", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f318f1743b0e0ca7$var$FieldsWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_otyrpxbi",
            __cmplp.className
        ])
    });
});
const $f318f1743b0e0ca7$var$textFieldWrapperStyles = (0, $8CUq3.xcss)({
    maxWidth: '360px',
    width: '100%'
});

});
parcelRegister("iKhOS", function(module, exports) {

var $1gef8 = parcelRequire("1gef8");

var $g7i7g = parcelRequire("g7i7g");
/**
 * Defers invoking the `func` until the current call stack has cleared. Any
 * additional arguments are provided to `func` when it's invoked.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to defer.
 * @param {...*} [args] The arguments to invoke `func` with.
 * @returns {number} Returns the timer id.
 * @example
 *
 * _.defer(function(text) {
 *   console.log(text);
 * }, 'deferred');
 * // => Logs 'deferred' after one millisecond.
 */ var $da5a5877d5d6860c$var$defer = $g7i7g(function(func, args) {
    return $1gef8(func, 1, args);
});
module.exports = $da5a5877d5d6860c$var$defer;

});
parcelRegister("1gef8", function(module, exports) {
/** Error message constants. */ var $0eb25573bf32f124$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * The base implementation of `_.delay` and `_.defer` which accepts `args`
 * to provide to `func`.
 *
 * @private
 * @param {Function} func The function to delay.
 * @param {number} wait The number of milliseconds to delay invocation.
 * @param {Array} args The arguments to provide to `func`.
 * @returns {number|Object} Returns the timer id or timeout object.
 */ function $0eb25573bf32f124$var$baseDelay(func, wait, args) {
    if (typeof func != 'function') throw new TypeError($0eb25573bf32f124$var$FUNC_ERROR_TEXT);
    return setTimeout(function() {
        func.apply(undefined, args);
    }, wait);
}
module.exports = $0eb25573bf32f124$var$baseDelay;

});


parcelRegister("kTBFu", function(module, exports) {

$parcel$export(module.exports, "CategoryColorPicker", () => $8a8f7ec2b7d5afbc$export$cb1530364589b080);

var $5uXOq = parcelRequire("5uXOq");

var $lGTQx = parcelRequire("lGTQx");
var $3zNHM = parcelRequire("3zNHM");

var $koVbs = parcelRequire("koVbs");

var $gSwFG = parcelRequire("gSwFG");

var $3m7Ch = parcelRequire("3m7Ch");
const $8a8f7ec2b7d5afbc$export$cb1530364589b080 = ({ color: color, onChangeColor: onChangeColor })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const colorPalette = (0, $3m7Ch.CATEGORY_THEMES).map(({ backgroundColor: backgroundColor, messageLabel: messageLabel })=>({
            label: formatMessage(messageLabel),
            value: backgroundColor
        }));
    const handleChangeColor = (0, $5uXOq.useCallback)((_, newColor)=>{
        onChangeColor((0, $gSwFG.getColorNameFromValue)(newColor));
    }, [
        onChangeColor
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lGTQx.default), {
        cols: colorPalette.length / 5,
        palette: colorPalette,
        selectedColor: (0, $gSwFG.getValueFromColorName)(color),
        onChange: handleChangeColor,
        mode: (0, $3zNHM.Compact),
        checkMarkColor: color.includes('LIGHT') ? (0, $3m7Ch.CHECK_MARK_COLOR_LIGHT) : (0, $3m7Ch.CHECK_MARK_COLOR_DARK),
        autoFocus: false,
        isFocusLockEnabled: false,
        isInsideMenu: false
    });
};

});
parcelRegister("lGTQx", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5e30770a4da4328$export$2e2bcd8739ae039);
/* ColorPaletteMenu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $kD00A = parcelRequire("kD00A");

var $gB4mS = parcelRequire("gB4mS");
var $994MI = parcelRequire("994MI");
var $cb25w = parcelRequire("cb25w");

var $l0sd0 = parcelRequire("l0sd0");

var $5dAp2 = parcelRequire("5dAp2");

const $c5e30770a4da4328$export$4bbfe93c6a14e8e6 = ({ autoFocus: autoFocus = true, isFocusLockEnabled: isFocusLockEnabled = true, isInsideMenu: isInsideMenu = true, createAnalyticsEvent: createAnalyticsEvent, onChange: onChange, palette: palette, selectedColor: selectedColor, checkMarkColor: checkMarkColor, label: label = 'Color picker', cols: cols = 6, mode: mode = (0, $kD00A.Mode).Standard, initialFocusRef: initialFocusRef, variant: variant = 'fill' })=>{
    const { options: options, value: selectedValue } = (0, $5dAp2.getOptions)(palette, selectedColor);
    const fullLabel = `${label}, ${selectedValue.label} selected`;
    const selectedColorIndex = selectedValue.value ? options.findIndex(({ value: value })=>value === selectedValue.value) : 0;
    const [focusedIndex, setFocusedIndex] = (0, $5uXOq.useState)(selectedColorIndex);
    const createAndFireEventOnAtlaskit = (0, $gB4mS.default)('atlaskit');
    const changeAnalyticsCaller = ()=>{
        if (createAnalyticsEvent) return createAndFireEventOnAtlaskit({
            action: 'clicked',
            actionSubject: 'color-palette-menu',
            attributes: {
                componentName: 'color-picker',
                packageName: "platform-pkg",
                packageVersion: "0.0.0-use.local"
            }
        })(createAnalyticsEvent);
        return undefined;
    };
    const colorCardRefs = (0, $5uXOq.useMemo)(()=>[], []);
    const handleChange = (event, value)=>{
        onChange(event, value, changeAnalyticsCaller());
    };
    (0, $5uXOq.useEffect)(()=>{
        colorCardRefs[focusedIndex]?.focus();
    }, [
        focusedIndex,
        colorCardRefs
    ]);
    const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
        const numItems = options.length;
        switch(event.key){
            case 0, $8fa07a9626e5ffeb$export$1734a06b2397c2a8:
            case 0, $8fa07a9626e5ffeb$export$695331c89a36efd6:
                setFocusedIndex((prevIndex)=>(prevIndex + 1) % numItems);
                break;
            case 0, $8fa07a9626e5ffeb$export$b34c7ae3fd8138d2:
            case 0, $8fa07a9626e5ffeb$export$842fd6cf65a6b80c:
                setFocusedIndex((prevIndex)=>(prevIndex - 1 + numItems) % numItems);
                break;
            case 0, $8fa07a9626e5ffeb$export$10f6869ed0a7d75b:
                if (isFocusLockEnabled) {
                    event.preventDefault();
                    event.stopPropagation();
                    setFocusedIndex(selectedColorIndex);
                }
                break;
            default:
                break;
        }
    }, [
        isFocusLockEnabled,
        selectedColorIndex,
        setFocusedIndex,
        options
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "aria-label": fullLabel,
        role: isInsideMenu ? 'menu' : 'radiogroup',
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            width: `${(0, $5dAp2.getWidth)(cols, mode)}px`
        },
        className: (0, $bwpsq.default)([
            "_1e0c1txw _kqswh2mm _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _bfhk1bhr",
            mode === (0, $kD00A.Mode).Standard && "_2rkosqtm _16qs1akw"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            className: (0, $bwpsq.default)([
                "_1e0c1txw _1n261g80 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
                mode === (0, $kD00A.Mode).Compact && "_ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t"
            ]),
            children: options.map(({ label: label, value: value }, index)=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        "_1e0c1txw _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _4t3izwfg"
                    ]),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l0sd0.default), {
                        type: (0, $8fa07a9626e5ffeb$export$2643a2cdce1d3963),
                        label: label,
                        value: value,
                        checkMarkColor: checkMarkColor,
                        isOption: true,
                        selected: value === selectedValue.value,
                        onClick: handleChange,
                        ref: (ref)=>{
                            colorCardRefs[index] = ref;
                        },
                        autoFocus: autoFocus,
                        initialFocusRef: value === selectedValue.value ? initialFocusRef : undefined,
                        isInsideMenu: isInsideMenu,
                        onKeyDown: handleKeyDown,
                        variant: variant
                    })
                }, value))
        })
    });
};
var $c5e30770a4da4328$export$2e2bcd8739ae039 = (0, $994MI.default)({
    componentName: 'color-picker',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
})((0, $cb25w.default)()($c5e30770a4da4328$export$4bbfe93c6a14e8e6));
const $c5e30770a4da4328$var$colorCardWrapperStyles = null;
const $c5e30770a4da4328$var$colorPaletteContainerStyles = null;
const $c5e30770a4da4328$var$colorPaletteContainerCompactStyles = null;
const $c5e30770a4da4328$var$colorPaletteMenuStyles = null;
const $c5e30770a4da4328$var$colorPaletteMenuStandardStyles = null;

});
parcelRegister("kD00A", function(module, exports) {

$parcel$export(module.exports, "Mode", () => $e25de60b37efd75a$export$9484bbecc3c49a2e);
var $e25de60b37efd75a$export$9484bbecc3c49a2e = /*#__PURE__*/ function(Mode) {
    Mode[Mode["Compact"] = 0] = "Compact";
    Mode[Mode["Standard"] = 1] = "Standard";
    return Mode;
}({});

});

parcelRegister("l0sd0", function(module, exports) {

$parcel$export(module.exports, "default", () => $d681a23420d49946$export$2e2bcd8739ae039);
/* ColorCard.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $eJbwP = parcelRequire("eJbwP");

var $3bDjY = parcelRequire("3bDjY");



var $bWn3s = parcelRequire("bWn3s");
const $d681a23420d49946$var$ColorCard = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, componentRef)=>{
    const { type: type, autoFocus: autoFocus = true, initialFocusRef: initialFocusRef, isInsideMenu: isInsideMenu = true, value: value, label: label, selected: selected, focused: focused, checkMarkColor: checkMarkColor = (0, $829f609a65d26a98$export$29a4f05edc054374), isTabbing: isTabbing, onClick: onClick, onKeyDown: onKeyDown, variant: variant = 'fill' } = props;
    const ref = (0, $5uXOq.useRef)(null);
    const isInitialFocus = (0, $5uXOq.useRef)(true);
    const isColorPaletteMenu = type === (0, $8fa07a9626e5ffeb$export$2643a2cdce1d3963);
    const handleMouseDown = (0, $5uXOq.useCallback)((event)=>{
        event.preventDefault();
    }, []);
    const handleClick = (0, $5uXOq.useCallback)((event)=>{
        if (onClick) {
            event.preventDefault();
            onClick(event, value);
        }
    }, [
        onClick,
        value
    ]);
    const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
        if ((isColorPaletteMenu || isTabbing === undefined || isTabbing) && onClick && (event.key === (0, $8fa07a9626e5ffeb$export$8152f929a25a0ff4) || event.key === (0, $8fa07a9626e5ffeb$export$e51a3576c045c8d5))) {
            event.preventDefault();
            if (isTabbing) event.stopPropagation();
            onClick(event, value);
        }
        if (isColorPaletteMenu) onKeyDown?.(event);
        else if (event.key === (0, $8fa07a9626e5ffeb$export$10f6869ed0a7d75b)) {
            event.preventDefault();
            event.stopPropagation();
        }
    }, [
        isColorPaletteMenu,
        isTabbing,
        value,
        onClick,
        onKeyDown
    ]);
    (0, $5uXOq.useImperativeHandle)(componentRef, ()=>({
            focus: ()=>{
                if (isColorPaletteMenu) {
                    if (isInitialFocus.current) {
                        autoFocus && !initialFocusRef && ref.current?.focus();
                        isInitialFocus.current = false;
                    } else ref.current?.focus();
                }
            }
        }), [
        autoFocus,
        isColorPaletteMenu,
        initialFocusRef
    ]);
    const isInsideMenuRole = isInsideMenu ? 'menuitemradio' : 'radio';
    const role = isColorPaletteMenu ? isInsideMenuRole : 'presentation';
    const ariaChecked = isColorPaletteMenu ? selected : undefined;
    const ariaLabel = isColorPaletteMenu ? label : undefined;
    const isOutlineVariant = variant === 'outline';
    const newCheckmarkColor = isOutlineVariant ? "var(--ds-icon, #44546F)" : checkMarkColor;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: label,
        children: (tooltipProps)=>{
            delete tooltipProps['aria-describedby'];
            return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                ...tooltipProps,
                ref: initialFocusRef ? (0, $bWn3s.mergeRefs)([
                    ref,
                    tooltipProps.ref,
                    initialFocusRef
                ]) : (0, $bWn3s.mergeRefs)([
                    ref,
                    tooltipProps.ref
                ]),
                role: role,
                tabIndex: selected ? 0 : -1,
                "aria-checked": ariaChecked,
                "aria-label": ariaLabel,
                onClick: handleClick,
                onMouseDown: handleMouseDown,
                onKeyDown: handleKeyDown,
                className: (0, $bwpsq.default)([
                    "_19it4jjs _2rko130s _v564ervx _12ji1r31 _1qu2glyw _12y31o36 _1e0c1o8l _kqswh2mm _1bsbzwfg _4t3izwfg _vchhusvi _bfhktxrc _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _80omtlke",
                    (isColorPaletteMenu || isTabbing === undefined || isTabbing) && "_858uvmul _4cvxvmul",
                    focused && (isColorPaletteMenu || !isTabbing) && "_1h6dvmul"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        "_1bsb1osq _4t3i1osq _1e0c1txw _4cvr1h6o _1bah1h6o"
                    ]),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    , {
                        style: isOutlineVariant ? {
                            borderColor: value || 'grey'
                        } : {
                            backgroundColor: value || 'transparent'
                        },
                        className: (0, $bwpsq.default)([
                            "_2rkosqtm _1bsb1tcg _4t3i1tcg _16qs16qq",
                            isOutlineVariant && "_189e1bk5 _1dqonqa1 _16qsglyw"
                        ]),
                        children: selected && /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJbwP))), {
                            color: newCheckmarkColor,
                            label: "",
                            spacing: "spacious",
                            LEGACY_margin: "1px"
                        })
                    })
                })
            });
        }
    });
});
var $d681a23420d49946$export$2e2bcd8739ae039 = $d681a23420d49946$var$ColorCard;
const $d681a23420d49946$var$colorCardOptionTabbingStyles = null;
const $d681a23420d49946$var$colorCardOptionFocusedStyles = null;
const $d681a23420d49946$var$sharedColorContainerStyles = null;
const $d681a23420d49946$var$colorCardWrapperStyles = null;
const $d681a23420d49946$var$colorCardContentStyles = null;
const $d681a23420d49946$var$colorCardContentStylesOutline = null;

});
parcelRegister("eJbwP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::666ec8073f4584891951ab85e48975eb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ab8e35fd94105dfe$var$_react = $ab8e35fd94105dfe$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ab8e35fd94105dfe$var$_checkMark = $ab8e35fd94105dfe$var$_interopRequireDefault((parcelRequire("bjo8S")));

var $ab8e35fd94105dfe$var$_done = $ab8e35fd94105dfe$var$_interopRequireDefault((parcelRequire("4DXCl")));
function $ab8e35fd94105dfe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "EditorDoneIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ab8e35fd94105dfe$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $ab8e35fd94105dfe$var$_react.default.createElement($ab8e35fd94105dfe$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $ab8e35fd94105dfe$var$_done.default
    }, props));
$ab8e35fd94105dfe$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $ab8e35fd94105dfe$var$_default = module.exports.default = $ab8e35fd94105dfe$var$CheckMarkIcon;

});

const $8fa07a9626e5ffeb$export$9fea11a016bc5bcf = 'COLOR_PICKER';
const $8fa07a9626e5ffeb$export$2643a2cdce1d3963 = 'COLOR_PALETTE_MENU';
const $8fa07a9626e5ffeb$export$64c9b8c6e6a2c6ac = 32;
const $8fa07a9626e5ffeb$export$e51a3576c045c8d5 = ' ';
const $8fa07a9626e5ffeb$export$8152f929a25a0ff4 = 'Enter';
const $8fa07a9626e5ffeb$export$b34c7ae3fd8138d2 = 'ArrowUp';
const $8fa07a9626e5ffeb$export$1734a06b2397c2a8 = 'ArrowDown';
const $8fa07a9626e5ffeb$export$842fd6cf65a6b80c = 'ArrowLeft';
const $8fa07a9626e5ffeb$export$695331c89a36efd6 = 'ArrowRight';
const $8fa07a9626e5ffeb$export$10f6869ed0a7d75b = 'Tab';
const $8fa07a9626e5ffeb$export$929c2026f4dd54a2 = 'Escape';


parcelRegister("5dAp2", function(module, exports) {

$parcel$export(module.exports, "getWidth", () => $38874a93fb14a10d$export$3c49c185de0c2bfc);
$parcel$export(module.exports, "getOptions", () => $38874a93fb14a10d$export$d2312e68e1f5ad00);
// AFP-2532 TODO: Fix automatic suppressions below
// eslint-disable-next-line @atlassian/tangerine/import/entry-points

var $k5uoT = parcelRequire("k5uoT");


var $8QpSo = parcelRequire("8QpSo");

var $kD00A = parcelRequire("kD00A");
const $38874a93fb14a10d$export$3c49c185de0c2bfc = (cols, mode)=>{
    const width = cols * ((0, $8fa07a9626e5ffeb$export$64c9b8c6e6a2c6ac) + (0, $k5uoT.gridSize)() / 2);
    return mode === (0, $kD00A.Mode).Standard ? width + (0, $k5uoT.gridSize)() : width;
};
const $38874a93fb14a10d$export$d2312e68e1f5ad00 = (0, $8QpSo.default)((palette, selectedColor, showDefaultSwatchColor)=>{
    let focusedItemIndex = 0;
    let defaultSelectedColor = palette[0];
    if (!showDefaultSwatchColor) defaultSelectedColor = {
        label: '',
        value: ''
    };
    const value = palette.find((color, index)=>{
        if (color.value === selectedColor) {
            focusedItemIndex = index;
            return true;
        }
        return false;
    }) || defaultSelectedColor;
    return {
        options: palette,
        value: value,
        focusedItemIndex: focusedItemIndex
    };
});

});


parcelRegister("3zNHM", function(module, exports) {

$parcel$export(module.exports, "Compact", () => $06f62cb25bd09d8d$export$6479582a9c9e50ce);
$parcel$export(module.exports, "default", () => $06f62cb25bd09d8d$export$2e2bcd8739ae039);

var $3PpqK = parcelRequire("3PpqK");

var $kD00A = parcelRequire("kD00A");

var $lGTQx = parcelRequire("lGTQx");
const { Compact: $06f62cb25bd09d8d$export$6479582a9c9e50ce, Standard: $06f62cb25bd09d8d$export$d5a1f56087d42b19 } = (0, $kD00A.Mode);
var $06f62cb25bd09d8d$export$2e2bcd8739ae039 = (0, $3PpqK.default);

});
parcelRegister("3PpqK", function(module, exports) {

$parcel$export(module.exports, "default", () => $f994db29f75e4622$export$2e2bcd8739ae039);
/* ColorPicker.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $b9dFI = parcelRequire("b9dFI");

var $1ErJq = parcelRequire("1ErJq");

var $jKrb6 = parcelRequire("jKrb6");


var $gB4mS = parcelRequire("gB4mS");
var $994MI = parcelRequire("994MI");
var $cb25w = parcelRequire("cb25w");

var $5dAp2 = parcelRequire("5dAp2");

var $8RXs9 = parcelRequire("8RXs9");

var $VSDnB = parcelRequire("VSDnB");

var $7oXeG = parcelRequire("7oXeG");
const $f994db29f75e4622$var$defaultPopperProps = {
    strategy: 'fixed',
    modifiers: [
        {
            name: 'offset',
            options: {
                offset: [
                    0,
                    8
                ]
            }
        }
    ],
    placement: 'bottom-start'
};
const $f994db29f75e4622$var$packageName = "platform-pkg";
const $f994db29f75e4622$var$packageVersion = "0.0.0-use.local";
class $f994db29f75e4622$var$ColorPickerWithoutAnalyticsBase extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { palette: palette, selectedColor: selectedColor, checkMarkColor: checkMarkColor, cols: cols, popperProps: popperProps = $f994db29f75e4622$var$defaultPopperProps, label: label = 'Color picker', triggerId: triggerId, selectedColourSwatchSize: selectedColourSwatchSize, showDefaultSwatchColor: showDefaultSwatchColor = true, isDisabledSelectedSwatch: isDisabledSelectedSwatch, intl: intl, variant: variant = 'fill' } = this.props;
        const { options: options, value: value } = (0, $5dAp2.getOptions)(palette, selectedColor, showDefaultSwatchColor);
        const fullLabel = this.getFullLabel(intl, value, label);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b9dFI.default), {
            target: ({ ref: ref, isOpen: isOpen })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    ref: ref,
                    className: (0, $bwpsq.default)([
                        "_1e0c1o8l"
                    ]),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1ErJq.default), {
                        ...value,
                        label: fullLabel,
                        expanded: isOpen,
                        swatchSize: selectedColourSwatchSize,
                        isDisabled: isDisabledSelectedSwatch,
                        id: triggerId,
                        variant: variant
                    })
                }),
            popperProps: popperProps,
            maxMenuWidth: "auto",
            minMenuWidth: "auto",
            options: options,
            label: fullLabel,
            value: value,
            components: $jKrb6,
            onChange: this.onChangeSelect,
            searchThreshold: Number.MAX_VALUE,
            //@ts-ignore react-select unsupported props
            cols: cols,
            checkMarkColor: checkMarkColor,
            variant: variant,
            onKeyDown: this.onKeyDown,
            isTabbing: this.state.isTabbing,
            onOptionKeyDown: this.onOptionKeyDown,
            ...(0, $VSDnB.fg)('one_event_rules_them_all_fg') && {
                onMenuOpen: this.props.onMenuOpen
            }
        });
    }
    constructor(...args){
        super(...args), this.createAndFireEventOnAtlaskit = (0, $gB4mS.default)('atlaskit'), this.state = {
            isTabbing: false
        }, this.changeAnalyticsCaller = ()=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) return this.createAndFireEventOnAtlaskit({
                action: 'clicked',
                actionSubject: 'color-picker',
                attributes: {
                    componentName: 'color-picker',
                    packageName: $f994db29f75e4622$var$packageName,
                    packageVersion: $f994db29f75e4622$var$packageVersion
                }
            })(createAnalyticsEvent);
            return undefined;
        }, this.onChangeSelect = (option)=>{
            this.props.onChange(option.value, this.changeAnalyticsCaller());
        }, this.onOptionKeyDown = (value)=>{
            this.props.onChange(value, this.changeAnalyticsCaller());
        }, this.onKeyDown = (e)=>{
            const key = e.key;
            if (key === (0, $8fa07a9626e5ffeb$export$10f6869ed0a7d75b)) this.setState({
                isTabbing: true
            });
            else if (key === (0, $8fa07a9626e5ffeb$export$b34c7ae3fd8138d2) || key === (0, $8fa07a9626e5ffeb$export$1734a06b2397c2a8)) this.setState({
                isTabbing: false
            });
            else if (key === (0, $8fa07a9626e5ffeb$export$929c2026f4dd54a2)) e.stopPropagation();
        }, this.getFullLabel = (intl, value, label)=>{
            if (value && value.label) return intl.formatMessage((0, $7oXeG.default).colorPickerAriaLabel, {
                color: value.label,
                message: label
            });
            else return label;
        };
    }
}
const $f994db29f75e4622$export$2fcf66ed38ff3cf5 = (0, $8RXs9.default)($f994db29f75e4622$var$ColorPickerWithoutAnalyticsBase);
var $f994db29f75e4622$export$2e2bcd8739ae039 = (0, $994MI.default)({
    componentName: 'color-picker',
    packageName: $f994db29f75e4622$var$packageName,
    packageVersion: $f994db29f75e4622$var$packageVersion
})((0, $cb25w.default)()($f994db29f75e4622$export$2fcf66ed38ff3cf5));
const $f994db29f75e4622$var$colorCardWrapperStyles = null;

});
parcelRegister("1ErJq", function(module, exports) {

$parcel$export(module.exports, "default", () => $609735830782207d$export$2e2bcd8739ae039);
/* Trigger.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3bDjY = parcelRequire("3bDjY");

var $VSDnB = parcelRequire("VSDnB");
const $609735830782207d$var$ColorCard = ({ value: value, label: label, expanded: expanded, onClick: onClick, swatchSize: swatchSize = 'default', isDisabled: isDisabled, id: id, variant: variant = 'fill' })=>{
    const handleMouseDown = (0, $5uXOq.useCallback)((event)=>{
        event.preventDefault();
    }, []);
    const handleClick = (0, $5uXOq.useCallback)((event)=>{
        if (onClick) {
            event.preventDefault();
            onClick();
        }
    }, [
        onClick
    ]);
    const isOutlineVariant = variant === 'outline';
    const colorCardStyles = isOutlineVariant ? {
        borderColor: value || 'grey'
    } : {
        backgroundColor: value || 'transparent'
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: label,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("button", {
            disabled: isDisabled,
            onClick: handleClick,
            onMouseDown: handleMouseDown,
            "aria-label": label,
            "aria-expanded": expanded,
            "aria-haspopup": true,
            type: "button",
            id: id,
            className: (0, $bwpsq.default)([
                "_19it4jjs _2rko130s _v564ervx _12ji1r31 _1qu2glyw _12y31o36 _1e0c1o8l _kqswh2mm _vchhusvi _bfhktxrc _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _80omtlke",
                swatchSize === 'small' ? "_1bsb1tcg _4t3i1tcg _154i1i6y" : "_1bsbzwfg _4t3izwfg",
                "_nt751r31 _gk8x1r31 _49pcglyw _24ueglyw _1hvw1o36 _b4yv1o36 _858u1l4g _rslm1l4g _4cvxtxrc",
                expanded && !(0, $VSDnB.fg)('platform-design-system-dsp-20821-color-pickr-focus') && "_12ji1r31 _1qu2glyw _12y31o36 _1h6d1l4g"
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                className: (0, $bwpsq.default)([
                    "_1bsb1osq _4t3i1osq _1e0c1txw _4cvr1h6o _1bah1h6o"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    style: colorCardStyles,
                    className: (0, $bwpsq.default)([
                        isOutlineVariant ? "_2rkosqtm _189e1bk5 _1dqonqa1" : "_2rkosqtm _16qs16qq",
                        swatchSize === 'small' ? "_1bsb7vkz _4t3i7vkz" : "_1bsb1tcg _4t3i1tcg"
                    ])
                })
            })
        })
    });
};
var $609735830782207d$export$2e2bcd8739ae039 = $609735830782207d$var$ColorCard;
const $609735830782207d$var$sharedColorContainerStyles = null;
const $609735830782207d$var$smallColorContainerSize = null;
const $609735830782207d$var$defaultColorContainerSize = null;
const $609735830782207d$var$colorCardButtonStyles = null;
const $609735830782207d$var$colorCardButtonFocusedStyles = null;
const $609735830782207d$var$colorCardWrapperStyles = null;
const $609735830782207d$var$colorCardContentStyles = null;
const $609735830782207d$var$colorCardContentStylesOutline = null;
const $609735830782207d$var$smallColorCardContentSize = null;
const $609735830782207d$var$defaultColorCardContentSize = null;

});

parcelRegister("jKrb6", function(module, exports) {

$parcel$export(module.exports, "MenuList", () => $b794a85d007e2dce$export$d4c4e98c5044dc8);
$parcel$export(module.exports, "Option", () => $b794a85d007e2dce$export$36d18380658d5d20);
$parcel$export(module.exports, "DropdownIndicator", () => $b794a85d007e2dce$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "Placeholder", () => $b794a85d007e2dce$export$84712d0562a614b8);
/* components.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $l0sd0 = parcelRequire("l0sd0");

var $5dAp2 = parcelRequire("5dAp2");


var $koVbs = parcelRequire("koVbs");

var $7oXeG = parcelRequire("7oXeG");
const $b794a85d007e2dce$export$d4c4e98c5044dc8 = (props)=>{
    const { //@ts-ignore react-select unsupported props
    selectProps: { cols: cols }, innerRef: innerRef, children: children } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "group",
        "aria-label": formatMessage((0, $7oXeG.default).menuListAriaLabel),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            maxWidth: cols ? (0, $5dAp2.getWidth)(cols) : undefined
        },
        //@ts-ignore react-select unsupported props
        ref: innerRef,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1n261g80 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66"
        ]),
        children: children
    });
};
const $b794a85d007e2dce$export$36d18380658d5d20 = (props)=>{
    const { data: { value: value, label: label }, //@ts-ignore react-select unsupported props
    selectProps: { checkMarkColor: checkMarkColor, onOptionKeyDown: onOptionKeyDown, isTabbing: isTabbing, variant: variant }, isFocused: isFocused, isSelected: isSelected, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ...innerProps,
        role: "radio",
        "aria-checked": isSelected,
        "aria-selected": undefined,
        "aria-label": label,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _4t3izwfg"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l0sd0.default), {
            type: (0, $8fa07a9626e5ffeb$export$9fea11a016bc5bcf),
            label: label,
            value: value,
            checkMarkColor: checkMarkColor,
            isOption: true,
            focused: isFocused,
            selected: isSelected,
            onKeyDown: (value)=>onOptionKeyDown(value),
            isTabbing: isTabbing,
            variant: variant
        })
    });
};
const $b794a85d007e2dce$export$ec98719d3db7f2e4 = ()=>null;
const $b794a85d007e2dce$export$84712d0562a614b8 = ()=>null;
const $b794a85d007e2dce$var$colorCardWrapperStyles = null;
const $b794a85d007e2dce$var$colorPaletteContainerStyles = null;

});
parcelRegister("7oXeG", function(module, exports) {

$parcel$export(module.exports, "default", () => $d42a6da5a6d06680$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d42a6da5a6d06680$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    colorPickerAriaLabel: {
        id: 'jira.color-picker.src.color-picker-aria-label',
        defaultMessage: '{color} selected, {message}',
        description: 'This text is used as aria-label text in color picker component'
    },
    menuListAriaLabel: {
        id: 'jira.color-picker.src.menu-list-aria-label',
        defaultMessage: 'Color picker list',
        description: 'This text is used as aria-label text for the listbox element in color picker component'
    }
});

});





parcelRegister("jordx", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c37a3fe09f6772c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0c37a3fe09f6772c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    categoryNameLabel: {
        "id": "business-categories.category-form.category-name-label",
        "defaultMessage": "Category name"
    },
    categoryNamePlaceholder: {
        "id": "business-categories.category-form.category-name-placeholder",
        "defaultMessage": "New category"
    },
    cancelButton: {
        "id": "business-categories.category-form.cancel-button",
        "defaultMessage": "Cancel"
    },
    saveButton: {
        "id": "business-categories.category-form.save-button",
        "defaultMessage": "Save"
    },
    addButton: {
        "id": "business-categories.category-form.add-button",
        "defaultMessage": "Add"
    },
    errorMessageBlankCategoryName: {
        "id": "business-categories.category-form.error-message-blank-category-name",
        "defaultMessage": "Category name cannot be blank"
    },
    errorMessageDuplicateCategoryName: {
        "id": "business-categories.category-form.error-message-duplicate-category-name",
        "defaultMessage": "The name you've selected for this category already exists. Try a new name."
    },
    editCategoryTitle: {
        "id": "business-categories.category-form.edit-category-title",
        "defaultMessage": "Edit category"
    },
    newCategoryTitle: {
        "id": "business-categories.category-form.new-category-title",
        "defaultMessage": "New category"
    }
});

});


parcelRegister("jRzRt", function(module, exports) {

$parcel$export(module.exports, "PopupComponent", () => $75cd825029e592f3$export$9fac2d040f3ed438);
$parcel$export(module.exports, "getPopupComponentWithHeight", () => $75cd825029e592f3$export$21bfee93f8bea1c4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $5uXOq = parcelRequire("5uXOq");
const $75cd825029e592f3$var$OPTION_COMPACT_HEIGHT = 28;
const $75cd825029e592f3$var$OPTION_DEFAULT_HEIGHT = 40;
const $75cd825029e592f3$var$INPUT_HEIGHT = 48;
const $75cd825029e592f3$var$FOOTER_HEIGHT = 46;
const $75cd825029e592f3$var$MENU_LIST_HEIGHT = 300;
const $75cd825029e592f3$var$GROUP_PADDING = 6;
const $75cd825029e592f3$var$ACTION_OPTION_HEIGHT = 42;
const $75cd825029e592f3$export$9fac2d040f3ed438 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($75cd825029e592f3$var$PopupComponentContainer, {
        ...props,
        ref: ref
    }));
const $75cd825029e592f3$export$21bfee93f8bea1c4 = ({ numOptions: numOptions, hasInput: hasInput = true, hasFooter: hasFooter = false, spacing: spacing = 'compact', numGroups: numGroups = 0, numActionOptions: numActionOptions = 0 })=>{
    const newGroupAndActionOptions = numGroups * $75cd825029e592f3$var$GROUP_PADDING + numActionOptions * $75cd825029e592f3$var$ACTION_OPTION_HEIGHT;
    const menuHeight = numOptions * (spacing === 'compact' ? $75cd825029e592f3$var$OPTION_COMPACT_HEIGHT : $75cd825029e592f3$var$OPTION_DEFAULT_HEIGHT) + newGroupAndActionOptions;
    const menuAdjustedHeight = Math.min(menuHeight, $75cd825029e592f3$var$MENU_LIST_HEIGHT);
    const height = menuAdjustedHeight + (hasInput ? $75cd825029e592f3$var$INPUT_HEIGHT : 0) + (hasFooter ? $75cd825029e592f3$var$FOOTER_HEIGHT : 0);
    return /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($75cd825029e592f3$var$PopupComponentContainer, {
            ...props,
            ref: ref,
            height: height
        }));
};
const $75cd825029e592f3$var$shadowSize = 2;
const $75cd825029e592f3$var$boxShadow = `0 0 0 ${$75cd825029e592f3$var$shadowSize}px ${"var(--ds-border-focused, #388BFF)"} inset`;
const $75cd825029e592f3$var$transition = 'box-shadow 0.1s cubic-bezier(0.47, 0.03, 0.49, 1.38)';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $75cd825029e592f3$var$PopupComponentContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_10ib6lf": (0, $lD23V.default)(__cmplp.height, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_v5641ni2 _bfhk18uv _nt751r31 _49pcglyw _1hvw1o36 _7ehi4ls2",
            __cmplp.height != null ? "_4t3it1jn" : "_4t3i1kw7",
            __cmplp.className
        ])
    });
});

});

parcelRegister("6du7W", function(module, exports) {

$parcel$export(module.exports, "default", () => $01e27ef03a76e529$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $01e27ef03a76e529$var$CreatableSelect = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("bjCER")), {
    ssr: false,
    moduleId: "./src/packages/business/list/src/common/ui/lazy-creatable-select/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$01e27ef03a76e529$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "creatable-select",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($01e27ef03a76e529$var$CreatableSelect, props));

});
parcelRegister("bjCER", function(module, exports) {

let $83cf74c3435d75ea$var$load = (parcelRequire("28QjX"))(4);
module.exports = $83cf74c3435d75ea$var$load("89uv2").then(()=>parcelRequire('cTNS8'));

});


parcelRegister("1pa56", function(module, exports) {

$parcel$export(module.exports, "CREATE_CATEGORY_ERROR_FLAG_ID", () => $10d2ca19e2b09d36$export$2938ca3596e53b03);
$parcel$export(module.exports, "default", () => $10d2ca19e2b09d36$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $e4yMr = parcelRequire("e4yMr");

var $dD7Zc = parcelRequire("dD7Zc");

var $4R6GH = parcelRequire("4R6GH");

var $7HGHK = parcelRequire("7HGHK");

var $d4xRU = parcelRequire("d4xRU");

var $pa9q9 = parcelRequire("pa9q9");

var $7HGHK = parcelRequire("7HGHK");

var $8Q4sF = parcelRequire("8Q4sF");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $391Aj = parcelRequire("391Aj");
const $10d2ca19e2b09d36$export$2938ca3596e53b03 = (0, $7HGHK.toFlagId)('create-category-error-flag');
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$10d2ca19e2b09d36$export$2e2bcd8739ae039 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { dismissFlag: dismissFlag } = (0, $pa9q9.useFlagService)();
    const onDismissed = (0, $5uXOq.useCallback)(()=>{
        dismissFlag({
            command: (0, $7HGHK.DISMISS_COMMAND),
            id: $10d2ca19e2b09d36$export$2938ca3596e53b03
        });
    }, [
        dismissFlag
    ]);
    const handleContactAdminClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'contactAdministrator');
    }, [
        createAnalyticsEvent
    ]);
    return (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4xRU.default), {
            id: (0, $7HGHK.fromFlagId)($10d2ca19e2b09d36$export$2938ca3596e53b03),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
                spacing: "spacious",
                label: "error",
                color: "var(--ds-icon-danger, #C9372C)"
            }),
            title: formatMessage((0, $391Aj.default).noPermissionToCreateCategoryTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Q4sF.FormattedI18nMessage), {
                message: formatMessage((0, $391Aj.default).createCategoryNoPermissions, {
                    linkStart: '{linkStart}',
                    linkEnd: '{linkEnd}'
                }),
                componentsMapping: {
                    link: ({ children: children })=>(0, $4R6GH.fg)('replace-anchor-with-link__keystone') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
                            href: "/secure/ContactAdministrators!default.jspa",
                            target: "_blank",
                            onClick: handleContactAdminClick
                        }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
                            href: "/secure/ContactAdministrators!default.jspa",
                            target: "_blank",
                            onClick: handleContactAdminClick
                        }, children)
                }
            }),
            onDismissed: onDismissed,
            messageId: "business-list.ui.list-view.category-cell.edit-category-cell.create-error-flag.flag",
            messageType: "transactional"
        }), [
        formatMessage,
        onDismissed,
        handleContactAdminClick
    ]);
};

});
parcelRegister("8Q4sF", function(module, exports) {

$parcel$export(module.exports, "FormattedI18nMessage", () => $7c8c20575fbc9bfc$export$200d7bd7633253ce);

var $5uXOq = parcelRequire("5uXOq");

var $gHDlh = parcelRequire("gHDlh");

var $9Byym = parcelRequire("9Byym");
const $7c8c20575fbc9bfc$export$200d7bd7633253ce = (props)=>{
    const { message: message, packageName: packageName, componentsMapping: componentsMapping } = props;
    const messageParts = (0, $5uXOq.useMemo)(()=>{
        const { tags: tags, openTags: openTags, closeTags: closeTags } = (0, $9Byym.getTags)(componentsMapping);
        try {
            const parts = [];
            let token = '';
            let TagComponent;
            let closeTagLookup;
            for(let i = 0; i < message.length; i += 1){
                const letter = message[i];
                token += letter;
                if ((0, $9Byym.isCloseTagDelimiter)(letter)) {
                    const firstTagFound = (0, $9Byym.findTag)(token, {
                        tags: openTags
                    });
                    if (firstTagFound !== null && firstTagFound !== undefined) {
                        // if we have a tag already means it is a malformed message since it is 2 subsequent open tags
                        if (TagComponent) throw new (0, $gHDlh.MalformedMessageError)();
                        const text = token.replace(firstTagFound, '');
                        parts.push(text);
                        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
                        const tagInfo = tags[firstTagFound];
                        TagComponent = tagInfo.component;
                        closeTagLookup = tagInfo.close;
                        token = '';
                    }
                }
                if (closeTagLookup !== null && closeTagLookup !== undefined && (0, $9Byym.isCloseTagDelimiter)(letter) && (0, $9Byym.isAnyTag)(token, {
                    tags: [
                        closeTagLookup
                    ]
                })) {
                    // this mean that we do not have an open tag for this closing tag
                    if (!TagComponent) throw new (0, $gHDlh.MalformedMessageError)();
                    const text = token.replace(closeTagLookup, '');
                    parts.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TagComponent, null, text));
                    TagComponent = undefined;
                    token = '';
                    closeTagLookup = undefined;
                }
                if ((0, $9Byym.isCloseTagDelimiter)(letter) && (0, $9Byym.isAnyTag)(token, {
                    tags: closeTags
                })) {
                    // if we do not have an open tag mean we are closing a tag that is not open
                    if (!TagComponent) throw new (0, $gHDlh.MalformedMessageError)();
                }
            }
            // if we reached the end and we have an open tag, mean this message is malformed
            if (TagComponent || closeTagLookup) throw new (0, $gHDlh.MalformedMessageError)();
            // flush anything we keep in the current token
            if (token.length > 0) parts.push(token);
            return parts;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e instanceof (0, $gHDlh.MalformedMessageError)) {
                (0, $gHDlh.logMalformedMessageError)({
                    message: message,
                    packageName: packageName
                });
                return [
                    (0, $gHDlh.getMalformedMessage)({
                        message: message,
                        closeTags: closeTags,
                        openTags: openTags
                    })
                ];
            }
            throw e;
        }
    }, [
        message,
        packageName,
        componentsMapping
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, messageParts.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
            key: index
        }, item)));
};

});
parcelRegister("gHDlh", function(module, exports) {

$parcel$export(module.exports, "getMalformedMessage", () => $ecff24857c176a60$export$f085cf20ec1f69ab);
$parcel$export(module.exports, "logMalformedMessageError", () => $ecff24857c176a60$export$954c3e6aad1c9429);
$parcel$export(module.exports, "MalformedMessageError", () => $ecff24857c176a60$export$40d900e818b9630e);

var $2YZCu = parcelRequire("2YZCu");

var $jcw0u = parcelRequire("jcw0u");

const $ecff24857c176a60$export$f085cf20ec1f69ab = ({ message: message, openTags: openTags, closeTags: closeTags })=>[
        ...openTags,
        ...closeTags
    ].reduce((acc, tag)=>acc.replace(new RegExp(tag, 'g'), ''), message);
const $ecff24857c176a60$export$954c3e6aad1c9429 = ({ message: message, packageName: packageName })=>{
    if (packageName !== null && packageName !== undefined) {
        const errorMessage = `Malformed message: ${message}`;
        // Send error log to analytics pipeline (i.e. SFX) and Sentry
        (0, $jcw0u.default)({
            meta: {
                packageName: packageName,
                id: (0, $5514815b06163219$export$f3390a0e172fee41)
            },
            attributes: {
                message: errorMessage
            }
        });
        // Send error log to Splunk
        const location = `${packageName}.${(0, $5514815b06163219$export$f3390a0e172fee41)}`;
        (0, $2YZCu.default).unsafeErrorWithCustomerData(location, errorMessage);
    }
};
class $ecff24857c176a60$export$40d900e818b9630e extends Error {
    constructor(){
        super('Malformed i18n message');
    }
}

});
const $5514815b06163219$export$f3390a0e172fee41 = 'formattedI18NMessage';


parcelRegister("9Byym", function(module, exports) {

$parcel$export(module.exports, "getTags", () => $84498158f946a67b$export$af63d7414243dad3);
$parcel$export(module.exports, "isAnyTag", () => $84498158f946a67b$export$38ffa64fc639355f);
$parcel$export(module.exports, "findTag", () => $84498158f946a67b$export$dfca0f74034f8657);
$parcel$export(module.exports, "isCloseTagDelimiter", () => $84498158f946a67b$export$d5170904651e91b1);

const $84498158f946a67b$export$af63d7414243dad3 = (componentsMapping)=>Object.entries(componentsMapping).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (acc, [key, value])=>{
        const open = `{${key}Start}`;
        const close = `{${key}End}`;
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        acc.tags[open] = {
            close: close,
            component: value
        };
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.openTags.push(open);
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.closeTags.push(close);
        return acc;
    }, {
        tags: {},
        openTags: [],
        closeTags: []
    });
const $84498158f946a67b$export$38ffa64fc639355f = (text, { tags: tags })=>tags.some((tag)=>text.includes(tag));
const $84498158f946a67b$export$dfca0f74034f8657 = (text, { tags: tags })=>tags.find((tag)=>text.includes(tag));
const $84498158f946a67b$export$d5170904651e91b1 = (letter)=>letter === (0, $7ed9c0b663db8b35$export$a10c567c3288a6b4);

});
const $7ed9c0b663db8b35$export$a10c567c3288a6b4 = '}';



parcelRegister("391Aj", function(module, exports) {

$parcel$export(module.exports, "default", () => $78189dae7fad13c4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $78189dae7fad13c4$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noPermissionToCreateCategoryTitle: {
        "id": "business-list.list-view.category-cell.edit-category-cell.create-error-flag.no-permission-to-create-category-title",
        "defaultMessage": "Unable to add category"
    },
    noPermissionToCreateCategory: {
        "id": "business-list.list-view.category-cell.edit-category-cell.create-error-flag.no-permission-to-create-category",
        "defaultMessage": "To add a category, you'll need to {contactAdmin}"
    },
    createCategoryNoPermissions: {
        "id": "business-list.list-view.category-cell.edit-category-cell.create-error-flag.create-category-no-permissions",
        "defaultMessage": "To add a category, you'll need to {linkStart}contact your admin{linkEnd}"
    },
    contactAdmin: {
        "id": "business-list.list-view.category-cell.edit-category-cell.create-error-flag.contact-admin",
        "defaultMessage": "contact your admin"
    }
});

});


parcelRegister("bqVq1", function(module, exports) {

$parcel$export(module.exports, "default", () => $781f3b0d516b33ef$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $42CjB = parcelRequire("42CjB");

var $4IrpZ = parcelRequire("4IrpZ");

var $5nRKm = parcelRequire("5nRKm");

var $4ChK1 = parcelRequire("4ChK1");

var $hUqzg = parcelRequire("hUqzg");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $DhnKp = parcelRequire("DhnKp");

var $daQYX = parcelRequire("daQYX");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dCm1o = parcelRequire("dCm1o");

var $fLR9b = parcelRequire("fLR9b");

var $4VVfj = parcelRequire("4VVfj");
const $781f3b0d516b33ef$var$CustomSelectOption = (optionProps)=>{
    const { onCategoryIsEditing: onCategoryIsEditing, categoryBeenEdited: categoryBeenEdited, label: label, value: optionId, color: color, isCreateOption: isCreateOption = false, isFocused: isFocused, selectedOption: selectedOption, setCategoryToDeleteInModal: setCategoryToDeleteInModal } = optionProps;
    const isOptionBeingEdited = categoryBeenEdited === label;
    const isEditing = categoryBeenEdited != null;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const project = (0, $daQYX.useProject)();
    const hasAdminPermission = project.permissions.administerProject;
    const handleEditClick = (0, $5uXOq.useCallback)((e)=>{
        e.stopPropagation();
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'jwmListViewCategoryOptionButtonEdit');
        onCategoryIsEditing(label, optionId, color);
    }, [
        createAnalyticsEvent,
        onCategoryIsEditing,
        label,
        optionId,
        color
    ]);
    const handleDeleteClick = (0, $5uXOq.useCallback)((e)=>{
        e.stopPropagation();
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'jwmListViewCategoryOptionButtonDelete');
        setCategoryToDeleteInModal({
            label: label,
            value: optionId,
            color: color
        });
    }, [
        color,
        createAnalyticsEvent,
        label,
        optionId,
        setCategoryToDeleteInModal
    ]);
    const handleEditKeyDownOld = (0, $5uXOq.useCallback)((e)=>{
        if (e.key === 'Enter') {
            e.preventDefault();
            handleEditClick(e);
        }
    }, [
        handleEditClick
    ]);
    const handleEditKeyDown = (0, $5uXOq.useCallback)((e)=>{
        if (e.key === 'Enter') {
            e.preventDefault();
            handleEditClick(e);
        }
    }, [
        handleEditClick
    ]);
    const handleDeleteKeyDownOld = (0, $5uXOq.useCallback)((e)=>{
        if (e.key === 'Enter') {
            e.preventDefault();
            handleDeleteClick(e);
        }
    }, [
        handleDeleteClick
    ]);
    const handleDeleteKeyDown = (0, $5uXOq.useCallback)((e)=>{
        if (e.key === 'Enter') {
            e.preventDefault();
            handleDeleteClick(e);
        }
    }, [
        handleDeleteClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4VVfj.OptionWrapper), {
        isOptionBeingEdited: isOptionBeingEdited,
        isEditing: isEditing,
        testId: `business-list.ui.list-view.category-cell.edit-category-cell.custom-select-option-${label}`
    }, (!isEditing || !isOptionBeingEdited) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($781f3b0d516b33ef$var$CategoryWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $DhnKp.default), {
        categoryColor: color,
        categoryName: label
    })), hasAdminPermission && !isCreateOption && !isEditing && isFocused && ((0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $781f3b0d516b33ef$var$optionIconsWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5nRKm))),
        appearance: "subtle",
        spacing: "compact",
        label: formatMessage((0, $fLR9b.default).rename),
        onKeyDown: handleEditKeyDown,
        onClick: handleEditClick,
        testId: "business-list.ui.list-view.category-cell.edit-category-cell.custom-select-option.edit-button"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4IrpZ))),
        appearance: "subtle",
        spacing: "compact",
        label: formatMessage((0, $fLR9b.default).delete),
        onKeyDown: handleDeleteKeyDown,
        onClick: handleDeleteClick,
        testId: "business-list.ui.list-view.category-cell.edit-category-cell.custom-select-option.delete-button"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($781f3b0d516b33ef$var$OptionIconsWrapper, {
        isHoveringOption: selectedOption === label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        "aria-label": formatMessage((0, $fLR9b.default).rename),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4ChK1))), {
            LEGACY_size: "small",
            label: formatMessage((0, $fLR9b.default).rename)
        }),
        onKeyDown: handleEditKeyDownOld,
        onClick: handleEditClick,
        testId: "business-list.ui.list-view.category-cell.edit-category-cell.custom-select-option.edit-button"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        "aria-label": formatMessage((0, $fLR9b.default).delete),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hUqzg))), {
            LEGACY_size: "small",
            label: formatMessage((0, $fLR9b.default).delete)
        }),
        onKeyDown: handleDeleteKeyDownOld,
        onClick: handleDeleteClick,
        testId: "business-list.ui.list-view.category-cell.edit-category-cell.custom-select-option.delete-button"
    }))));
};
const $781f3b0d516b33ef$var$optionIconsWrapperStyles = (0, $8CUq3.xcss)({
    position: 'absolute',
    right: "var(--ds-space-0, 0px)",
    paddingLeft: 'space.075',
    paddingRight: 'space.075',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    gap: 'space.050'
});
var $781f3b0d516b33ef$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
 = /*#__PURE__*/ (0, $5uXOq.memo)($781f3b0d516b33ef$var$CustomSelectOption);
const $781f3b0d516b33ef$var$CategoryWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1dza",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $781f3b0d516b33ef$var$OptionIconsWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _1xi2ze3t _ca0qidpf _u5f312x7 _n3tdidpf _19bv12x7 _4t3i1osq _1e0c1txw _4cvr1h6o _7dir18uv",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5nRKm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ce3559d453dff44735097f553c900f9f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3eb8cab3ab465b93$var$_react = $3eb8cab3ab465b93$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3eb8cab3ab465b93$var$_baseNew = $3eb8cab3ab465b93$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3eb8cab3ab465b93$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3eb8cab3ab465b93$var$EditIcon = (props)=>/*#__PURE__*/ $3eb8cab3ab465b93$var$_react.default.createElement($3eb8cab3ab465b93$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.586.854a2 2 0 0 1 2.828 0l.732.732a2 2 0 0 1 0 2.828L10.01 9.551a2 2 0 0 1-.864.51l-3.189.91a.75.75 0 0 1-.927-.927l.91-3.189a2 2 0 0 1 .51-.864zm1.768 1.06a.5.5 0 0 0-.708 0l-.585.586L13.5 3.94l.586-.586a.5.5 0 0 0 0-.707zM12.439 5 11 3.56 7.51 7.052a.5.5 0 0 0-.128.217l-.54 1.89 1.89-.54a.5.5 0 0 0 .217-.127zM3 2.501a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-3H15v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-10a2 2 0 0 1 2-2h3v1.5z" clip-rule="evenodd"/>`
    }, props));
$3eb8cab3ab465b93$var$EditIcon.displayName = 'EditIcon';
var $3eb8cab3ab465b93$var$_default = module.exports.default = $3eb8cab3ab465b93$var$EditIcon;

});

parcelRegister("4ChK1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::631c9d525a923bb24b78f7aa2d70d92c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $35c87913ec905242$var$_react = $35c87913ec905242$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $35c87913ec905242$var$_edit = $35c87913ec905242$var$_interopRequireDefault((parcelRequire("5nRKm")));

var $35c87913ec905242$var$_edit2 = $35c87913ec905242$var$_interopRequireDefault((parcelRequire("gsEeL")));
function $35c87913ec905242$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EditIcon.
 * This component is EditIcon, with `UNSAFE_fallbackIcon` set to "EditIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $35c87913ec905242$var$EditIcon = (props)=>/*#__PURE__*/ $35c87913ec905242$var$_react.default.createElement($35c87913ec905242$var$_edit.default, Object.assign({
        LEGACY_fallbackIcon: $35c87913ec905242$var$_edit2.default
    }, props));
$35c87913ec905242$var$EditIcon.Name = 'EditIconMigration';
var $35c87913ec905242$var$_default = module.exports.default = $35c87913ec905242$var$EditIcon;

});
parcelRegister("gsEeL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bfbe7921991bc4cb$var$_react = $bfbe7921991bc4cb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $bfbe7921991bc4cb$var$_edit = $bfbe7921991bc4cb$var$_interopRequireDefault((parcelRequire("5nRKm")));
function $bfbe7921991bc4cb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bfbe7921991bc4cb$var$EditIcon = (props)=>/*#__PURE__*/ $bfbe7921991bc4cb$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zm5.92-2.62-2.12-2.12L16.31 6l2.12 2.12zm9.9-9.9-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
    }, props, {
        newIcon: $bfbe7921991bc4cb$var$_edit.default
    }));
$bfbe7921991bc4cb$var$EditIcon.displayName = 'EditIcon';
var $bfbe7921991bc4cb$var$_default = module.exports.default = $bfbe7921991bc4cb$var$EditIcon;

});


parcelRegister("fLR9b", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee59b30e5221a127$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ee59b30e5221a127$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    rename: {
        "id": "business-list.list-view.category-cell.edit-category-cell.custom-select-option.rename",
        "defaultMessage": "Rename"
    },
    delete: {
        "id": "business-list.list-view.category-cell.edit-category-cell.custom-select-option.delete",
        "defaultMessage": "Delete"
    },
    confirm: {
        "id": "business-list.list-view.category-cell.edit-category-cell.custom-select-option.confirm",
        "defaultMessage": "Confirm"
    },
    cancel: {
        "id": "business-list.list-view.category-cell.edit-category-cell.custom-select-option.cancel",
        "defaultMessage": "Cancel"
    }
});

});

parcelRegister("4VVfj", function(module, exports) {

$parcel$export(module.exports, "OptionWrapper", () => $9de8c43051ae513c$export$d6f6a072cce04542);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");
const $9de8c43051ae513c$var$optionWrapperBaseStyles = (0, $8CUq3.xcss)({
    minHeight: '25px',
    position: 'relative',
    paddingBlock: 'space.075',
    paddingInline: 'space.150',
    cursor: 'pointer'
});
const $9de8c43051ae513c$var$isOptionBeingEditedStyles = (0, $8CUq3.xcss)({
    padding: 'space.0'
});
const $9de8c43051ae513c$var$isEditingStyles = (0, $8CUq3.xcss)({
    cursor: 'inherit'
});
const $9de8c43051ae513c$export$d6f6a072cce04542 = ({ isOptionBeingEdited: isOptionBeingEdited, isEditing: isEditing, testId: testId, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        justifyContent: "space-between",
        xcss: [
            $9de8c43051ae513c$var$optionWrapperBaseStyles,
            isOptionBeingEdited && $9de8c43051ae513c$var$isOptionBeingEditedStyles,
            isEditing && $9de8c43051ae513c$var$isEditingStyles
        ],
        testId: testId
    }, children);
const $9de8c43051ae513c$export$7a73e3f07eb82217 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1dza",
            __cmplp.className
        ])
    });
});
const $9de8c43051ae513c$export$8220e436750973f7 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _1xi2ze3t _ca0qidpf _u5f312x7 _n3tdidpf _19bv12x7 _4t3i1osq _1e0c1txw _4cvr1h6o _7dir18uv",
            __cmplp.className
        ])
    });
});

});


parcelRegister("jGpUV", function(module, exports) {

$parcel$export(module.exports, "default", () => $f500da77f7450823$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f500da77f7450823$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    placeholder: {
        "id": "business-list.list-view.category-cell.edit-category-cell.placeholder",
        "defaultMessage": "Add category"
    },
    createNewCategory: {
        "id": "business-list.list-view.category-cell.edit-category-cell.create-new-category",
        "defaultMessage": "New category"
    },
    noMatches: {
        "id": "business-list.list-view.category-cell.edit-category-cell.no-matches",
        "defaultMessage": "No matches found"
    },
    noMatchesContactAdmin: {
        "id": "business-list.list-view.category-cell.edit-category-cell.no-matches-contact-admin",
        "defaultMessage": "No category found. {br}{br}To add a category in this project, you'll need to {contactAdminLink}."
    },
    contactAdminLink: {
        "id": "business-list.list-view.category-cell.edit-category-cell.contact-admin-link",
        "defaultMessage": "contact your admin"
    }
});

});


parcelRegister("cPZte", function(module, exports) {

$parcel$export(module.exports, "default", () => $0eaa0ae61f6f7add$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0eaa0ae61f6f7add$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorTitle: {
        "id": "business-list.list-view.category-cell.error-title",
        "defaultMessage": "We couldn't save the new value"
    },
    errorMessage: {
        "id": "business-list.list-view.category-cell.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    }
});

});


parcelRegister("3yRl2", function(module, exports) {

$parcel$export(module.exports, "CellNavigation", () => $82fabdbd20c0ce7c$export$8511762758d83099);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $af2fN = parcelRequire("af2fN");

var $icf02 = parcelRequire("icf02");

var $9fuVs = parcelRequire("9fuVs");

var $1XJ20 = parcelRequire("1XJ20");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $eTDjN = parcelRequire("eTDjN");

var $lI995 = parcelRequire("lI995");

var $3xYte = parcelRequire("3xYte");

var $2gmNO = parcelRequire("2gmNO");

var $2LpEi = parcelRequire("2LpEi");

var $d3rVJ = parcelRequire("d3rVJ");
const $82fabdbd20c0ce7c$var$isNonCharacterKey = (event)=>event.key.length > 1 || event.ctrlKey || event.metaKey;
const $82fabdbd20c0ce7c$var$copiedFromStyles = null;
const $82fabdbd20c0ce7c$export$8511762758d83099 = /*#__PURE__*/ (0, $5uXOq.memo)(({ children: children, columnIndex: columnIndex, rowIndex: rowIndex, field: field, onSendNodeSelected: onSendNodeSelected, onSendClearNodeSelection: onSendClearNodeSelection, issue: issue, fieldId: fieldId })=>{
    const [{ isSelected: isSelected = false, isCopiedFrom: isCopiedFrom = false }, { setSelectedCell: setSelectedCell, clearSelectedCell: clearSelectedCell, clearCopiedFromCell: clearCopiedFromCell }] = (0, $3xYte.useCellSelected)({
        column: columnIndex,
        row: rowIndex,
        issueId: issue?.issueId,
        fieldId: field?.id
    });
    const isSelectedRef = (0, $5uXOq.useRef)(isSelected);
    const prevIsSelected = (0, $1XJ20.usePreviousWithInitial)(isSelected);
    const horizontalNavigationRef = (0, $5uXOq.useRef)(false);
    const wrapperRef = (0, $5uXOq.useRef)(null);
    const cellRef = (0, $5uXOq.useRef)(null);
    const { navigate: navigate } = (0, $3xYte.useCellActions)();
    const [{ tableRef: tableRef }] = (0, $2LpEi.useTableRefStore)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [editMode, setEditModeFn] = (0, $5uXOq.useState)(false);
    const [inputValue, setInputValue] = (0, $5uXOq.useState)();
    const [isHovering, setIsHovering] = (0, $5uXOq.useState)(false);
    // If double click to edit is enabled, cell is activated on first click and then go to edit mode on second.
    // Using ref instead of state to avoid a rerender as it was causing side effects inside dialogs
    const isCellActiveRef = (0, $5uXOq.useRef)(false);
    const editModeRef = (0, $5uXOq.useRef)(editMode);
    editModeRef.current = editMode;
    let formatRuleBackgroundColor = null;
    let formatRuleHoverColor = null;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const issueFields = issue?.fields;
    if ((0, $4R6GH.fg)('list_view_conditional_formatting_updates')) ({ backgroundColor: formatRuleBackgroundColor, hoverColor: formatRuleHoverColor } = // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $af2fN.useGetColorFormatRuleNew)({
        formattingArea: 'CELL',
        fieldId: fieldId,
        issueId: String(issue?.issueId),
        issueFields: issueFields
    }));
    else // eslint-disable-next-line react-hooks/rules-of-hooks
    formatRuleBackgroundColor = (0, $af2fN.useGetColorFormatRule)({
        formattingArea: 'CELL',
        fieldId: fieldId,
        issueId: String(issue?.issueId),
        issueFields: issueFields
    });
    const isEditable = field?.fieldConfig?.isEditable ?? true;
    const isNewKeyboardNavField = field?.type && (0, $d3rVJ.getNewNavSupportedFieldTypes)().has(field.type);
    const setEditMode = (0, $5uXOq.useCallback)((nextEditMode)=>{
        if (nextEditMode === editMode) return;
        if (!isNewKeyboardNavField || isEditable) setEditModeFn(nextEditMode);
    }, [
        editMode,
        isEditable,
        isNewKeyboardNavField
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // allow first render isSelected to call the fn
        if (isSelected === true && prevIsSelected === false) {
            onSendNodeSelected && onSendNodeSelected();
            horizontalNavigationRef.current = false;
        }
        if (isSelected === false && prevIsSelected === true) onSendClearNodeSelection && onSendClearNodeSelection(); // only clear if prev value is true
    }, [
        isSelected,
        onSendClearNodeSelection,
        onSendNodeSelected,
        prevIsSelected
    ]);
    (0, $5uXOq.useEffect)(()=>{
        isSelectedRef.current = isSelected;
        if (isSelected && wrapperRef.current) wrapperRef.current.focus();
    }, [
        isSelected
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            if (isSelectedRef.current) clearSelectedCell();
        }, [
        clearSelectedCell
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isNewKeyboardNavField) {
            if (isSelected === false && editMode) setEditMode(false);
        }
    }, [
        editMode,
        isSelected,
        isNewKeyboardNavField,
        setEditMode
    ]);
    const handleFocus = (0, $5uXOq.useCallback)(()=>{
        setSelectedCell(columnIndex, rowIndex);
    }, [
        columnIndex,
        rowIndex,
        setSelectedCell
    ]);
    const handleBlur = (0, $5uXOq.useCallback)((event)=>{
        if ((!isNewKeyboardNavField || event.relatedTarget) && !event.currentTarget?.contains(event.relatedTarget)) {
            isCellActiveRef.current = false;
            const stop = cellRef.current?.onBlur?.(event);
            if (stop) return;
            clearSelectedCell();
        }
    }, [
        clearSelectedCell,
        isNewKeyboardNavField
    ]);
    const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
        if (isNewKeyboardNavField) {
            const stop = cellRef.current?.onKeyDown?.(event);
            if (stop) return;
        }
        const horizontalNavKeyPressed = (0, $d3rVJ.VALID_HORIZONTAL_NAV_KEYS).has(event.key);
        const isTabPressed = event.key === (0, $d3rVJ.KEY_TAB);
        const isValidKey = (0, $d3rVJ.VALID_NAVIGATION_KEYS).has(event.key);
        if (event.shiftKey && !isTabPressed) return;
        if (!isValidKey) {
            if (isNewKeyboardNavField && !editMode && !$82fabdbd20c0ce7c$var$isNonCharacterKey(event)) {
                setEditMode(true);
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'typeToEdit',
                    actionSubject: 'listNavigated'
                }), {
                    fieldType: field.type
                });
                setTimeout(()=>{
                    setInputValue(event.key);
                });
            }
            return;
        }
        const isScrolling = !!tableRef?.current?.table?.bodyRef?.state?.isScrolling;
        const navigationInProgress = isSelected && horizontalNavigationRef.current && horizontalNavKeyPressed;
        if (navigationInProgress || isScrolling) return;
        const fireNavigationAnalytics = ()=>{
            const EVENT_KEY = event.key === (0, $d3rVJ.KEY_SPACE) ? 'Space' : event.key;
            const attributes = isNewKeyboardNavField && [
                'Enter',
                'Tab',
                'Escape',
                'Space'
            ].includes(EVENT_KEY) ? {
                isEditMode: editMode,
                fieldType: field.type
            } : {};
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                action: EVENT_KEY,
                actionSubject: 'listNavigated'
            }), attributes);
        };
        const handleNavigationEvent = (overrideDirection)=>{
            const direction = overrideDirection ?? (0, $d3rVJ.NAV_KEYS_TO_DIRECTION)[event.key];
            if (horizontalNavKeyPressed) horizontalNavigationRef.current = true;
            navigate(direction, tableRef);
        };
        if (isNewKeyboardNavField && editMode) switch(event.key){
            case 0, $d3rVJ.KEY_ENTER:
                setTimeout(()=>{
                    setEditMode(false);
                    wrapperRef?.current?.focus();
                    handleNavigationEvent((0, $eTDjN.DOWN));
                    fireNavigationAnalytics();
                }, 1);
                return;
            case 0, $d3rVJ.KEY_ESCAPE:
                setTimeout(()=>{
                    setEditMode(false);
                    setInputValue(undefined);
                    wrapperRef?.current?.focus();
                });
                return;
            case 0, $d3rVJ.KEY_TAB:
                setTimeout(()=>{
                    setEditMode(false);
                    wrapperRef?.current?.focus();
                    handleNavigationEvent(event.shiftKey ? (0, $eTDjN.LEFT) : (0, $eTDjN.RIGHT));
                    fireNavigationAnalytics();
                }, 1);
                return;
            case 0, $d3rVJ.KEY_SPACE:
                // move selection down when pressing Space exits edit mode
                setTimeout(()=>{
                    if (!editModeRef.current) {
                        wrapperRef?.current?.focus();
                        handleNavigationEvent((0, $eTDjN.DOWN));
                        fireNavigationAnalytics();
                    }
                }, 1);
                return;
            case 0, $d3rVJ.KEY_UP:
            case 0, $d3rVJ.KEY_DOWN:
            case 0, $d3rVJ.KEY_LEFT:
            case 0, $d3rVJ.KEY_RIGHT:
                return;
            default:
        }
        const tableDataLength = tableRef?.current?.table?.props?.data?.length || 0;
        const totalColumns = tableRef?.current?.table?.props?.columns?.length || 0;
        const isFirstTableItem = columnIndex === 0 && rowIndex === 0;
        const isLastTableItem = columnIndex === totalColumns - 1 && rowIndex === tableDataLength - 1;
        const isDirectionLeft = event.key === (0, $d3rVJ.KEY_LEFT) || isTabPressed && event.shiftKey;
        const isDirectionRight = event.key === (0, $d3rVJ.KEY_RIGHT) || isTabPressed && !event.shiftKey;
        if (isFirstTableItem && isDirectionLeft || isLastTableItem && isDirectionRight) return;
        event.preventDefault();
        fireNavigationAnalytics();
        switch(event.key){
            case 0, $d3rVJ.KEY_UP:
            case 0, $d3rVJ.KEY_DOWN:
                handleNavigationEvent();
                break;
            case 0, $d3rVJ.KEY_LEFT:
                if (columnIndex > 0) handleNavigationEvent();
                break;
            case 0, $d3rVJ.KEY_RIGHT:
                if (columnIndex < totalColumns - 1) handleNavigationEvent();
                break;
            case 0, $d3rVJ.KEY_TAB:
                handleNavigationEvent(event.shiftKey ? (0, $eTDjN.LEFT) : (0, $eTDjN.RIGHT));
                break;
            case 0, $d3rVJ.KEY_ENTER:
                if (!isNewKeyboardNavField || !editMode) wrapperRef?.current?.click();
                break;
            case 0, $d3rVJ.KEY_SPACE:
                if (!isNewKeyboardNavField || !editMode) wrapperRef?.current?.click();
                break;
            case 0, $d3rVJ.KEY_ESCAPE:
                if (!isNewKeyboardNavField || !editMode) {
                    clearSelectedCell();
                    clearCopiedFromCell();
                    wrapperRef?.current?.blur();
                }
                break;
            default:
                break;
        }
    }, [
        isNewKeyboardNavField,
        tableRef,
        isSelected,
        editMode,
        columnIndex,
        rowIndex,
        setEditMode,
        createAnalyticsEvent,
        field?.type,
        navigate,
        clearSelectedCell,
        clearCopiedFromCell
    ]);
    const handleClick = (0, $5uXOq.useCallback)((event)=>{
        if (isNewKeyboardNavField) {
            const stop = cellRef.current?.onClick?.(event);
            if (stop) return;
        }
        setEditMode(true);
    }, [
        isNewKeyboardNavField,
        setEditMode
    ]);
    const handleMouseEnter = (0, $5uXOq.useCallback)(()=>setIsHovering(true), [
        setIsHovering
    ]);
    const handleMouseLeave = (0, $5uXOq.useCallback)(()=>setIsHovering(false), [
        setIsHovering
    ]);
    const onInputChange = (0, $5uXOq.useCallback)((value)=>setInputValue(value), []);
    const getClone = ()=>{
        if (/*#__PURE__*/ (0, $5uXOq.isValidElement)(children)) {
            if (isNewKeyboardNavField) return /*#__PURE__*/ (0, $5uXOq.cloneElement)(children, {
                isSelected: isSelected,
                wrapperRef: wrapperRef,
                cellRef: cellRef,
                editMode: editMode,
                setEditMode: setEditMode,
                isHovering: isHovering,
                inputValue: inputValue,
                onInputChange: onInputChange
            });
            return /*#__PURE__*/ (0, $5uXOq.cloneElement)(children, {
                isSelected: isSelected,
                wrapperRef: wrapperRef,
                onFocus: handleFocus,
                onBlur: handleBlur,
                onKeyDown: handleKeyDown
            });
        }
        return children;
    };
    if (isNewKeyboardNavField) {
        const getCellContainer = (props = {})=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lI995.CellContainer), {
                ref: wrapperRef,
                isFocused: isSelected,
                tabIndex: 0,
                "data-testid": (0, $icf02.CELL_WRAPPER_TEST_ID),
                onMouseEnter: handleMouseEnter,
                onMouseLeave: handleMouseLeave,
                onBlur: handleBlur,
                onFocus: handleFocus,
                onClick: handleClick,
                formatRuleBackgroundColor: formatRuleBackgroundColor,
                formatRuleHoverColor: formatRuleHoverColor,
                ...props
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                className: (0, $bwpsq.default)([
                    isCopiedFrom && "_kqswh2mm _rfx3glpi _3l88yh40 _kzdagq9o _15m61p6i _cfu11ule _1cs8stnw _1kt9b3bt _1mp4mslj _kfgtmslj _1rus18uv _dsq4glyw _1g0vidpf"
                ])
            }, getClone()), isSelected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null));
        if (issue && field) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2gmNO.ClipboardController), {
            issue: issue,
            field: field,
            fieldId: fieldId,
            isSelected: isSelected,
            isEditMode: editMode,
            onKeyDown: handleKeyDown
        }, getCellContainer());
        return getCellContainer({
            onKeyDown: handleKeyDown
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, getClone());
});

});
parcelRegister("af2fN", function(module, exports) {

$parcel$export(module.exports, "useGetColorFormatRule", () => $0759c2c8622ae825$export$7162d2241c1da066);
$parcel$export(module.exports, "useGetColorFormatRuleNew", () => $0759c2c8622ae825$export$8027caa9547dee98);

var $5uXOq = parcelRequire("5uXOq");

var $hug5L = parcelRequire("hug5L");

var $6yL7o = parcelRequire("6yL7o");
const $0759c2c8622ae825$export$7162d2241c1da066 = ({ formattingArea: formattingArea, fieldId: fieldId, issueId: issueId, issueFields: issueFields })=>{
    const [{ rowRules: rowRules, cellRulesByFieldId: cellRulesByFieldId, issueIdRowRuleMatched: issueIdRowRuleMatched }, { setMatchedRowRule: setMatchedRowRule }] = (0, $hug5L.useFormatRulesStore)();
    const isCellArea = formattingArea === 'CELL';
    const formatRule = (0, $5uXOq.useMemo)(()=>{
        if (!issueFields || !issueId) return null;
        const rules = isCellArea && fieldId ? cellRulesByFieldId[fieldId] : rowRules;
        if (!rules?.length) return null;
        const rule = (0, $6yL7o.getColorFormatRules)({
            rules: rules,
            issueFields: issueFields
        });
        if (!rule) return null;
        if (isCellArea) {
            // If there is a row rule that is ranked before should not use the cell rule color
            const rowRule = issueIdRowRuleMatched[issueId];
            if (rowRule?.index != null && rowRule.index < rule.index) return null;
        }
        return rule;
    }, [
        cellRulesByFieldId,
        fieldId,
        isCellArea,
        issueFields,
        issueId,
        issueIdRowRuleMatched,
        rowRules
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isCellArea && formatRule && issueId) // we store the matched row rule for the issue
        setMatchedRowRule({
            rule: formatRule,
            issueId: issueId
        });
    }, [
        formatRule,
        isCellArea,
        issueId,
        setMatchedRowRule
    ]);
    return formatRule?.color || null;
};
const $0759c2c8622ae825$export$8027caa9547dee98 = ({ formattingArea: formattingArea, fieldId: fieldId, issueId: issueId, issueFields: issueFields })=>{
    const [{ rowRules: rowRules, cellRulesByFieldId: cellRulesByFieldId, issueIdRowRuleMatched: issueIdRowRuleMatched }, { setMatchedRowRule: setMatchedRowRule }] = (0, $hug5L.useFormatRulesStore)();
    const isCellArea = formattingArea === 'CELL';
    const formatRule = (0, $5uXOq.useMemo)(()=>{
        if (!issueFields || !issueId) return null;
        const rules = isCellArea && fieldId ? cellRulesByFieldId[fieldId] : rowRules;
        if (!rules?.length) return null;
        const rule = (0, $6yL7o.getColorFormatRules)({
            rules: rules,
            issueFields: issueFields
        });
        if (!rule) return null;
        if (isCellArea) {
            // If there is a row rule that is ranked before should not use the cell rule color
            const rowRule = issueIdRowRuleMatched[issueId];
            if (rowRule?.index != null && rowRule.index < rule.index) return null;
        }
        return rule;
    }, [
        cellRulesByFieldId,
        fieldId,
        isCellArea,
        issueFields,
        issueId,
        issueIdRowRuleMatched,
        rowRules
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isCellArea && formatRule && issueId) // we store the matched row rule for the issue
        setMatchedRowRule({
            rule: formatRule,
            issueId: issueId
        });
    }, [
        formatRule,
        isCellArea,
        issueId,
        setMatchedRowRule
    ]);
    return {
        backgroundColor: formatRule?.color || null,
        hoverColor: formatRule?.hoverColor || null
    };
};

});
parcelRegister("6yL7o", function(module, exports) {

$parcel$export(module.exports, "getColorFormatRules", () => $00e9da19cc1fb303$export$251900d893745a4b);

var $gJBT6 = parcelRequire("gJBT6");

var $ey4Q6 = parcelRequire("ey4Q6");
const $00e9da19cc1fb303$export$251900d893745a4b = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(({ rules: rules, issueFields: issueFields })=>{
    if (!issueFields || !rules) return null;
    const issueFieldsById = {};
    issueFields.forEach((field)=>{
        issueFieldsById[field.fieldId] = field;
    });
    for (const rule of rules){
        const { operator: operator, value: value, fieldId: fieldId } = rule;
        if (operator && fieldId) {
            const ruleField = issueFieldsById[fieldId];
            if ((0, $ey4Q6.isFormatRuleEvaluationSupported)(ruleField?.type)) {
                const ruleResult = (0, $ey4Q6.evaluateFormatRule)(ruleField?.type, {
                    field: ruleField,
                    operator: operator,
                    value: value
                });
                if (ruleResult) return rule;
            }
        }
    }
    return null;
}, (args)=>JSON.stringify(args));

});
parcelRegister("ey4Q6", function(module, exports) {

$parcel$export(module.exports, "evaluateFormatRule", () => $565f99cf872d9328$export$311cdf99cceaadec);
$parcel$export(module.exports, "isFormatRuleEvaluationSupported", () => $565f99cf872d9328$export$e5e9880b1a0ddbe4);

var $8QpSo = parcelRequire("8QpSo");

var $dth51 = parcelRequire("dth51");

var $gWw5G = parcelRequire("gWw5G");

var $ikY6i = parcelRequire("ikY6i");

var $gdYT7 = parcelRequire("gdYT7");

var $4RRRc = parcelRequire("4RRRc");

var $a6LRq = parcelRequire("a6LRq");

var $kEdiA = parcelRequire("kEdiA");

var $5tKyS = parcelRequire("5tKyS");

var $6r8Er = parcelRequire("6r8Er");

var $1HNg6 = parcelRequire("1HNg6");

var $EAgoA = parcelRequire("EAgoA");

var $jFqRZ = parcelRequire("jFqRZ");

var $gydIO = parcelRequire("gydIO");

var $2ut8I = parcelRequire("2ut8I");

var $8DFJJ = parcelRequire("8DFJJ");
const $565f99cf872d9328$export$1179b9c33b3930fd = (0, $8QpSo.default)(()=>({
        ...(0, $jFqRZ.textEvaluateFormatRule),
        ...(0, $ikY6i.labelsEvaluateFormatRule),
        ...(0, $2ut8I.userEvaluateFormatRule),
        ...(0, $gWw5G.dateEvaluateFormatRule),
        ...(0, $4RRRc.numberEvaluateFormatRule),
        ...(0, $a6LRq.priorityEvaluateFormatRule),
        ...(0, $kEdiA.projectEvaluateFormatRule),
        ...(0, $1HNg6.sprintEvaluateFormatRule),
        ...(0, $8DFJJ.versionEvaluateFormatRule),
        ...(0, $gydIO.typeEvaluateFormatRule),
        ...(0, $EAgoA.statusEvaluateFormatRule),
        ...(0, $6r8Er.singleSelectEvaluateFormatRule),
        ...(0, $gdYT7.multiSelectEvaluateFormatRule),
        ...(0, $5tKyS.radioEvaluateFormatRule),
        ...(0, $dth51.componentsEvaluateFormatRule)
    }));
const $565f99cf872d9328$export$311cdf99cceaadec = (fieldType, ...args)=>{
    const handlers = $565f99cf872d9328$export$1179b9c33b3930fd();
    if (handlers[fieldType] == null) return;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return handlers[fieldType]?.(...args);
};
const $565f99cf872d9328$export$e5e9880b1a0ddbe4 = (fieldType)=>{
    if (!fieldType) return false;
    const handlers = $565f99cf872d9328$export$1179b9c33b3930fd();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return handlers[fieldType] != null;
};

});
parcelRegister("dth51", function(module, exports) {

$parcel$export(module.exports, "componentsEvaluateFormatRule", () => $8a98ab87f413ef83$export$e0e459c1e8cd74a0);

var $5fc53 = parcelRequire("5fc53");
// TODO: update to use componentId once FLINGO-927 is done
const $8a98ab87f413ef83$var$evaluateHandler = {
    CONTAINS: (field, value)=>Boolean(Array.isArray(value) && field.value?.filter((fieldValue)=>fieldValue && value?.includes(fieldValue.name)).length === value?.length),
    HAS_ANY_OF: (field, value)=>Array.isArray(value) && Boolean(field.value?.some((fieldValue)=>fieldValue && value?.includes(fieldValue.name))),
    DOES_NOT_CONTAIN: (field, value)=>Boolean(Array.isArray(value) && field.value?.filter((fieldValue)=>fieldValue && value?.includes(fieldValue.name)).length !== value?.length),
    IS_EMPTY: (field)=>!field.value || field.value?.length === 0,
    IS_NOT_EMPTY: (field)=>Boolean(field.value && field.value.length > 0)
};
const $8a98ab87f413ef83$var$evaluateFormatRule = ({ field: field, operator: operator, value: value })=>{
    const evaluateHandlerFn = $8a98ab87f413ef83$var$evaluateHandler[operator];
    if (!evaluateHandlerFn) return false;
    return evaluateHandlerFn(field, value);
};
const $8a98ab87f413ef83$export$e0e459c1e8cd74a0 = {
    [(0, $5fc53.COMPONENTS_TYPE)]: $8a98ab87f413ef83$var$evaluateFormatRule
};

});

parcelRegister("gWw5G", function(module, exports) {

$parcel$export(module.exports, "dateEvaluateFormatRule", () => $cf5a4f98ddbaf658$export$289deaf929c3babd);

var $72LGt = parcelRequire("72LGt");
var $dnQN3 = parcelRequire("dnQN3");
var $9mNfg = parcelRequire("9mNfg");
var $79nXx = parcelRequire("79nXx");
var $kUxFz = parcelRequire("kUxFz");
var $f1uil = parcelRequire("f1uil");
var $ki4Ey = parcelRequire("ki4Ey");
var $9JptI = parcelRequire("9JptI");
var $iTBZZ = parcelRequire("iTBZZ");
var $jovBr = parcelRequire("jovBr");
var $iMVUf = parcelRequire("iMVUf");
var $eZDAP = parcelRequire("eZDAP");
var $htiPW = parcelRequire("htiPW");
var $6HFRN = parcelRequire("6HFRN");
var $eBfUM = parcelRequire("eBfUM");

var $5fc53 = parcelRequire("5fc53");

var $42ioY = parcelRequire("42ioY");
const $cf5a4f98ddbaf658$var$evaluateHandler = {
    IS: (field, value)=>{
        if (field.value && typeof value === 'string') {
            const fieldDate = (0, $eZDAP.default)(field.value);
            switch(value){
                case (0, $42ioY.DATE_VALUE_OPERATORS).TODAY:
                    return (0, $9JptI.default)(fieldDate);
                case (0, $42ioY.DATE_VALUE_OPERATORS).TOMORROW:
                    return (0, $iTBZZ.default)(fieldDate);
                case (0, $42ioY.DATE_VALUE_OPERATORS).YESTERDAY:
                    return (0, $iMVUf.default)(fieldDate);
                case (0, $42ioY.DATE_VALUE_OPERATORS).THIS_WEEK:
                    return (0, $ki4Ey.default)(fieldDate);
                case (0, $42ioY.DATE_VALUE_OPERATORS).LAST_WEEK:
                    return (0, $dnQN3.default)(fieldDate, new Date()) === -1;
                case (0, $42ioY.DATE_VALUE_OPERATORS).NEXT_WEEK:
                    return (0, $dnQN3.default)(fieldDate, new Date()) === 1;
                case (0, $42ioY.DATE_VALUE_OPERATORS).THIS_QUARTER:
                    return (0, $72LGt.default)(fieldDate, new Date()) === 0;
                case (0, $42ioY.DATE_VALUE_OPERATORS).LAST_QUARTER:
                    return (0, $72LGt.default)(fieldDate, new Date()) === -1;
                case (0, $42ioY.DATE_VALUE_OPERATORS).NEXT_QUARTER:
                    return (0, $72LGt.default)(fieldDate, new Date()) === 1;
                case (0, $42ioY.DATE_VALUE_OPERATORS).THIS_YEAR:
                    return (0, $9mNfg.default)(fieldDate, new Date()) === 0;
                case (0, $42ioY.DATE_VALUE_OPERATORS).LAST_YEAR:
                    return (0, $9mNfg.default)(fieldDate, new Date()) === -1;
                case (0, $42ioY.DATE_VALUE_OPERATORS).NEXT_YEAR:
                    return (0, $9mNfg.default)(fieldDate, new Date()) === 1;
                default:
                    {
                        const dateValue = (0, $eZDAP.default)(value);
                        if ((0, $jovBr.default)(dateValue)) return (0, $f1uil.default)(dateValue, fieldDate);
                        return false;
                    }
            }
        }
        return false;
    },
    IS_AFTER: (field, value)=>{
        if (field.value && typeof value === 'string') {
            const fieldDate = (0, $eZDAP.default)(field.value);
            switch(value){
                case (0, $42ioY.DATE_VALUE_OPERATORS).TODAY:
                    return (0, $79nXx.default)(fieldDate, (0, $htiPW.default)());
                case (0, $42ioY.DATE_VALUE_OPERATORS).TOMORROW:
                    return (0, $79nXx.default)(fieldDate, (0, $6HFRN.default)());
                case (0, $42ioY.DATE_VALUE_OPERATORS).YESTERDAY:
                    return (0, $79nXx.default)(fieldDate, (0, $eBfUM.default)());
                case (0, $42ioY.DATE_VALUE_OPERATORS).THIS_WEEK:
                    return (0, $dnQN3.default)(fieldDate, new Date()) > 0;
                case (0, $42ioY.DATE_VALUE_OPERATORS).LAST_WEEK:
                    return (0, $dnQN3.default)(fieldDate, new Date()) >= 0;
                case (0, $42ioY.DATE_VALUE_OPERATORS).NEXT_WEEK:
                    return (0, $dnQN3.default)(fieldDate, new Date()) > 1;
                case (0, $42ioY.DATE_VALUE_OPERATORS).THIS_QUARTER:
                    return (0, $72LGt.default)(fieldDate, new Date()) > 0;
                case (0, $42ioY.DATE_VALUE_OPERATORS).LAST_QUARTER:
                    return (0, $72LGt.default)(fieldDate, new Date()) >= 0;
                case (0, $42ioY.DATE_VALUE_OPERATORS).NEXT_QUARTER:
                    return (0, $72LGt.default)(fieldDate, new Date()) > 1;
                case (0, $42ioY.DATE_VALUE_OPERATORS).THIS_YEAR:
                    return (0, $9mNfg.default)(fieldDate, new Date()) > 0;
                case (0, $42ioY.DATE_VALUE_OPERATORS).LAST_YEAR:
                    return (0, $9mNfg.default)(fieldDate, new Date()) >= 0;
                case (0, $42ioY.DATE_VALUE_OPERATORS).NEXT_YEAR:
                    return (0, $9mNfg.default)(fieldDate, new Date()) > 1;
                default:
                    {
                        const dateValue = (0, $eZDAP.default)(value);
                        if ((0, $jovBr.default)(dateValue)) return (0, $79nXx.default)(fieldDate, dateValue);
                        return false;
                    }
            }
        }
        return false;
    },
    IS_BEFORE: (field, value)=>{
        if (field.value && typeof value === 'string') {
            const fieldDate = (0, $eZDAP.default)(field.value);
            switch(value){
                case (0, $42ioY.DATE_VALUE_OPERATORS).TODAY:
                    return (0, $kUxFz.default)(fieldDate, (0, $htiPW.default)());
                case (0, $42ioY.DATE_VALUE_OPERATORS).TOMORROW:
                    return (0, $kUxFz.default)(fieldDate, (0, $6HFRN.default)());
                case (0, $42ioY.DATE_VALUE_OPERATORS).YESTERDAY:
                    return (0, $kUxFz.default)(fieldDate, (0, $eBfUM.default)());
                case (0, $42ioY.DATE_VALUE_OPERATORS).THIS_WEEK:
                    return (0, $dnQN3.default)(fieldDate, new Date()) < 0;
                case (0, $42ioY.DATE_VALUE_OPERATORS).LAST_WEEK:
                    return (0, $dnQN3.default)(fieldDate, new Date()) < -1;
                case (0, $42ioY.DATE_VALUE_OPERATORS).NEXT_WEEK:
                    return (0, $dnQN3.default)(fieldDate, new Date()) < 1;
                case (0, $42ioY.DATE_VALUE_OPERATORS).THIS_QUARTER:
                    return (0, $72LGt.default)(fieldDate, new Date()) < 0;
                case (0, $42ioY.DATE_VALUE_OPERATORS).LAST_QUARTER:
                    return (0, $72LGt.default)(fieldDate, new Date()) < -1;
                case (0, $42ioY.DATE_VALUE_OPERATORS).NEXT_QUARTER:
                    return (0, $72LGt.default)(fieldDate, new Date()) < 1;
                case (0, $42ioY.DATE_VALUE_OPERATORS).THIS_YEAR:
                    return (0, $9mNfg.default)(fieldDate, new Date()) < 0;
                case (0, $42ioY.DATE_VALUE_OPERATORS).LAST_YEAR:
                    return (0, $9mNfg.default)(fieldDate, new Date()) < -1;
                case (0, $42ioY.DATE_VALUE_OPERATORS).NEXT_YEAR:
                    return (0, $9mNfg.default)(fieldDate, new Date()) < 1;
                default:
                    {
                        const dateValue = (0, $eZDAP.default)(value);
                        if ((0, $jovBr.default)(dateValue)) return (0, $kUxFz.default)(fieldDate, dateValue);
                        return false;
                    }
            }
        }
        return false;
    },
    IS_NOT: (field, value)=>!$cf5a4f98ddbaf658$var$evaluateHandler.IS?.(field, value),
    IS_ON_OR_AFTER: (field, value)=>Boolean($cf5a4f98ddbaf658$var$evaluateHandler.IS?.(field, value) || $cf5a4f98ddbaf658$var$evaluateHandler.IS_AFTER?.(field, value)),
    IS_ON_OR_BEFORE: (field, value)=>Boolean($cf5a4f98ddbaf658$var$evaluateHandler.IS?.(field, value) || $cf5a4f98ddbaf658$var$evaluateHandler.IS_BEFORE?.(field, value)),
    IS_EMPTY: (field)=>!field.value,
    IS_NOT_EMPTY: (field)=>Boolean(field.value)
};
const $cf5a4f98ddbaf658$var$evaluateFormatRule = ({ field: field, operator: operator, value: value })=>{
    const evaluateHandlerFn = $cf5a4f98ddbaf658$var$evaluateHandler[operator];
    if (!evaluateHandlerFn) return false;
    return evaluateHandlerFn(field, value);
};
const $cf5a4f98ddbaf658$export$289deaf929c3babd = {
    [(0, $5fc53.START_DATE_TYPE)]: $cf5a4f98ddbaf658$var$evaluateFormatRule,
    [(0, $5fc53.UPDATED)]: $cf5a4f98ddbaf658$var$evaluateFormatRule,
    [(0, $5fc53.CREATED)]: $cf5a4f98ddbaf658$var$evaluateFormatRule,
    [(0, $5fc53.DUE_DATE_TYPE)]: $cf5a4f98ddbaf658$var$evaluateFormatRule,
    [(0, $5fc53.DATE_CF_TYPE)]: $cf5a4f98ddbaf658$var$evaluateFormatRule
};

});

parcelRegister("ikY6i", function(module, exports) {

$parcel$export(module.exports, "labelsEvaluateFormatRule", () => $71e37884e7a6cf86$export$44959830567aabae);

var $5fc53 = parcelRequire("5fc53");
const $71e37884e7a6cf86$var$evaluateHandler = {
    CONTAINS: (field, value)=>Boolean(Array.isArray(value) && field.value?.filter((fieldValue)=>fieldValue && value?.includes(fieldValue)).length === value?.length),
    HAS_ANY_OF: (field, value)=>Array.isArray(value) && Boolean(field.value?.some((fieldValue)=>fieldValue && value?.includes(fieldValue))),
    DOES_NOT_CONTAIN: (field, value)=>Boolean(Array.isArray(value) && field.value?.filter((fieldValue)=>fieldValue && value?.includes(fieldValue)).length !== value?.length),
    IS_EMPTY: (field)=>field.value?.length === 0,
    IS_NOT_EMPTY: (field)=>field.value?.length > 0
};
const $71e37884e7a6cf86$var$evaluateFormatRule = ({ field: field, operator: operator, value: value })=>{
    const evaluateHandlerFn = $71e37884e7a6cf86$var$evaluateHandler[operator];
    if (!evaluateHandlerFn) return false;
    return evaluateHandlerFn(field, value);
};
const $71e37884e7a6cf86$export$44959830567aabae = {
    [(0, $5fc53.LABELS_TYPE)]: $71e37884e7a6cf86$var$evaluateFormatRule,
    [(0, $5fc53.LABELS_CF_TYPE)]: $71e37884e7a6cf86$var$evaluateFormatRule
};

});

parcelRegister("gdYT7", function(module, exports) {

$parcel$export(module.exports, "multiSelectEvaluateFormatRule", () => $8e3351380c39cef1$export$52c36143869699f1);

var $5fc53 = parcelRequire("5fc53");
// TODO: update to compare by optionId once FLINGO-940 is done
const $8e3351380c39cef1$var$evaluateHandler = {
    CONTAINS: (field, value)=>Boolean(Array.isArray(value) && field.value?.filter((fieldValue)=>fieldValue && value?.includes(fieldValue.value)).length === value?.length),
    HAS_ANY_OF: (field, value)=>Array.isArray(value) && Boolean(field.value?.some((fieldValue)=>fieldValue && value?.includes(fieldValue.value))),
    DOES_NOT_CONTAIN: (field, value)=>Boolean(Array.isArray(value) && field.value?.filter((fieldValue)=>fieldValue && value?.includes(fieldValue.value)).length !== value?.length),
    IS_EMPTY: (field)=>!field.value || field.value?.length === 0,
    IS_NOT_EMPTY: (field)=>Boolean(field.value && field.value.length > 0)
};
const $8e3351380c39cef1$var$evaluateFormatRule = ({ field: field, operator: operator, value: value })=>{
    const evaluateHandlerFn = $8e3351380c39cef1$var$evaluateHandler[operator];
    if (!evaluateHandlerFn) return false;
    return evaluateHandlerFn(field, value);
};
const $8e3351380c39cef1$export$52c36143869699f1 = {
    [(0, $5fc53.MULTI_SELECT_CF_TYPE)]: $8e3351380c39cef1$var$evaluateFormatRule
};

});

parcelRegister("4RRRc", function(module, exports) {

$parcel$export(module.exports, "numberEvaluateFormatRule", () => $3189a44e1211082b$export$8b123092055dd2da);

var $5fc53 = parcelRequire("5fc53");
const $3189a44e1211082b$var$evaluateHandler = {
    EQUALS: (field, value)=>Boolean(field.value && field.value === Number(value)),
    DOES_NOT_EQUAL: (field, value)=>Boolean(field.value && field.value !== Number(value)),
    GREATER_THAN: (field, value)=>Boolean(field.value && field.value > Number(value)),
    GREATER_THAN_OR_EQUALS: (field, value)=>Boolean(field.value && field.value >= Number(value)),
    LESS_THAN: (field, value)=>Boolean(field.value && field.value < Number(value)),
    LESS_THAN_OR_EQUALS: (field, value)=>Boolean(field.value && field.value <= Number(value)),
    IS_EMPTY: (field)=>!field.value,
    IS_NOT_EMPTY: (field)=>Boolean(field.value)
};
const $3189a44e1211082b$var$evaluateFormatRule = ({ field: field, operator: operator, value: value })=>{
    const evaluateHandlerFn = $3189a44e1211082b$var$evaluateHandler[operator];
    if (!evaluateHandlerFn) return false;
    return evaluateHandlerFn(field, value);
};
const $3189a44e1211082b$export$8b123092055dd2da = {
    [(0, $5fc53.NUMBER_CF_TYPE)]: $3189a44e1211082b$var$evaluateFormatRule,
    [(0, $5fc53.STORY_POINTS_TYPE)]: $3189a44e1211082b$var$evaluateFormatRule,
    [(0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE)]: $3189a44e1211082b$var$evaluateFormatRule
};

});

parcelRegister("a6LRq", function(module, exports) {

$parcel$export(module.exports, "priorityEvaluateFormatRule", () => $8254740ac77e923c$export$8d97b18a0e2778ac);

var $5fc53 = parcelRequire("5fc53");
const $8254740ac77e923c$var$evaluateHandler = {
    IS: (field, value)=>Boolean(field.value?.priorityId === value),
    IS_NOT: (field, value)=>Boolean(field.value?.priorityId !== value),
    IS_EMPTY: (field)=>!field.value,
    IS_NOT_EMPTY: (field)=>Boolean(field.value)
};
const $8254740ac77e923c$var$evaluateFormatRule = ({ field: field, operator: operator, value: value })=>{
    const evaluateHandlerFn = $8254740ac77e923c$var$evaluateHandler[operator];
    if (!evaluateHandlerFn) return false;
    return evaluateHandlerFn(field, value);
};
const $8254740ac77e923c$export$8d97b18a0e2778ac = {
    [(0, $5fc53.PRIORITY_TYPE)]: $8254740ac77e923c$var$evaluateFormatRule
};

});

parcelRegister("kEdiA", function(module, exports) {

$parcel$export(module.exports, "projectEvaluateFormatRule", () => $b24eab0f30116df2$export$abda41e836fbe53a);

var $5fc53 = parcelRequire("5fc53");
const $b24eab0f30116df2$var$evaluateHandler = {
    IS: (field, value)=>Boolean(field.value?.projectId === value),
    IS_NOT: (field, value)=>Boolean(field.value?.projectId !== value),
    IS_EMPTY: (field)=>!field.value,
    IS_NOT_EMPTY: (field)=>Boolean(field.value)
};
const $b24eab0f30116df2$var$evaluateFormatRule = ({ field: field, operator: operator, value: value })=>{
    const evaluateHandlerFn = $b24eab0f30116df2$var$evaluateHandler[operator];
    if (!evaluateHandlerFn) return false;
    return evaluateHandlerFn(field, value);
};
const $b24eab0f30116df2$export$abda41e836fbe53a = {
    [(0, $5fc53.PROJECT_PICKER_CF_TYPE)]: $b24eab0f30116df2$var$evaluateFormatRule
};

});

parcelRegister("5tKyS", function(module, exports) {

$parcel$export(module.exports, "radioEvaluateFormatRule", () => $f4b1ee03a5b932e8$export$4f805002362dd334);

var $5fc53 = parcelRequire("5fc53");
const $f4b1ee03a5b932e8$var$evaluateHandler = {
    IS: (field, value)=>Boolean(field.value?.value === value),
    IS_NOT: (field, value)=>Boolean(field.value?.value !== value),
    IS_EMPTY: (field)=>!field.value,
    IS_NOT_EMPTY: (field)=>Boolean(field.value)
};
const $f4b1ee03a5b932e8$var$evaluateFormatRule = ({ field: field, operator: operator, value: value })=>{
    const evaluateHandlerFn = $f4b1ee03a5b932e8$var$evaluateHandler[operator];
    if (!evaluateHandlerFn) return false;
    return evaluateHandlerFn(field, value);
};
const $f4b1ee03a5b932e8$export$4f805002362dd334 = {
    [(0, $5fc53.RADIO_BUTTONS_CF_TYPE)]: $f4b1ee03a5b932e8$var$evaluateFormatRule
};

});

parcelRegister("6r8Er", function(module, exports) {

$parcel$export(module.exports, "singleSelectEvaluateFormatRule", () => $199d65a5d5fffc5d$export$466ec2bab0b5512f);

var $5fc53 = parcelRequire("5fc53");
// TODO: FLINGO:940 - use value.optionId once that ticket is done
const $199d65a5d5fffc5d$var$evaluateHandler = {
    IS: (field, value)=>Boolean(field.value?.value === value),
    IS_NOT: (field, value)=>Boolean(field.value?.value !== value),
    IS_EMPTY: (field)=>!field.value,
    IS_NOT_EMPTY: (field)=>Boolean(field.value)
};
const $199d65a5d5fffc5d$var$evaluateFormatRule = ({ field: field, operator: operator, value: value })=>{
    const evaluateHandlerFn = $199d65a5d5fffc5d$var$evaluateHandler[operator];
    if (!evaluateHandlerFn) return false;
    return evaluateHandlerFn(field, value);
};
const $199d65a5d5fffc5d$export$466ec2bab0b5512f = {
    [(0, $5fc53.SELECT_CF_TYPE)]: $199d65a5d5fffc5d$var$evaluateFormatRule
};

});

parcelRegister("1HNg6", function(module, exports) {

$parcel$export(module.exports, "sprintEvaluateFormatRule", () => $9b0e26a2a4ad2db8$export$4a797e9c240634e1);

var $5fc53 = parcelRequire("5fc53");
const $9b0e26a2a4ad2db8$var$evaluateHandler = {
    IS: (field, value)=>Boolean(field.value.length && field.value[0]?.sprintId === value),
    IS_NOT: (field, value)=>Boolean(field.value.length && field.value[0]?.sprintId !== value),
    IS_EMPTY: (field)=>!field.value || !field.value.length,
    IS_NOT_EMPTY: (field)=>Boolean(field.value.length)
};
const $9b0e26a2a4ad2db8$var$evaluateFormatRule = ({ field: field, operator: operator, value: value })=>{
    const evaluateHandlerFn = $9b0e26a2a4ad2db8$var$evaluateHandler[operator];
    if (!evaluateHandlerFn) return false;
    return evaluateHandlerFn(field, value);
};
const $9b0e26a2a4ad2db8$export$4a797e9c240634e1 = {
    [(0, $5fc53.SPRINT_TYPE)]: $9b0e26a2a4ad2db8$var$evaluateFormatRule
};

});

parcelRegister("EAgoA", function(module, exports) {

$parcel$export(module.exports, "statusEvaluateFormatRule", () => $bf093575e5ef4233$export$e03c41425f1d323d);

var $5fc53 = parcelRequire("5fc53");
// TODO: update to compare the status id
const $bf093575e5ef4233$var$evaluateHandler = {
    IS: (field, value)=>field.statusId === value,
    IS_NOT: (field, value)=>field.statusId !== value,
    HAS_ANY_OF: (field, value)=>Array.isArray(value) && Boolean(value?.includes(field.statusId))
};
const $bf093575e5ef4233$var$evaluateFormatRule = ({ field: field, operator: operator, value: value })=>{
    const evaluateHandlerFn = $bf093575e5ef4233$var$evaluateHandler[operator];
    if (!evaluateHandlerFn) return false;
    return evaluateHandlerFn(field, value);
};
const $bf093575e5ef4233$export$e03c41425f1d323d = {
    [(0, $5fc53.STATUS_TYPE)]: $bf093575e5ef4233$var$evaluateFormatRule
};

});

parcelRegister("jFqRZ", function(module, exports) {

$parcel$export(module.exports, "textEvaluateFormatRule", () => $6e9dda04111fc2ba$export$c4da0f7dd3518065);

var $5fc53 = parcelRequire("5fc53");
const $6e9dda04111fc2ba$var$evaluateHandler = {
    IS_EMPTY: (field)=>Boolean(!field.value),
    IS_NOT_EMPTY: (field)=>Boolean(field.value),
    CONTAINS: (field, value)=>Boolean(typeof value === 'string' && field.value?.includes(value)),
    DOES_NOT_CONTAIN: (field, value)=>Boolean(typeof value === 'string' && !field.value?.includes(value))
};
const $6e9dda04111fc2ba$var$evaluateFormatRule = ({ field: field, operator: operator, value: value })=>{
    const evaluateHandlerFn = $6e9dda04111fc2ba$var$evaluateHandler[operator];
    if (!evaluateHandlerFn) return false;
    return evaluateHandlerFn(field, value);
};
const $6e9dda04111fc2ba$export$c4da0f7dd3518065 = {
    [(0, $5fc53.SUMMARY_TYPE)]: $6e9dda04111fc2ba$var$evaluateFormatRule,
    [(0, $5fc53.TEXT_CF_TYPE)]: $6e9dda04111fc2ba$var$evaluateFormatRule
};

});

parcelRegister("gydIO", function(module, exports) {

$parcel$export(module.exports, "typeEvaluateFormatRule", () => $3585a67825579232$export$8b8aad40b9f7a09b);

var $5fc53 = parcelRequire("5fc53");
const $3585a67825579232$var$evaluateHandler = {
    IS: (field, value)=>Boolean(field.issueTypeId === value),
    IS_NOT: (field, value)=>Boolean(field.issueTypeId !== value),
    IS_EMPTY: (field)=>!field.value,
    IS_NOT_EMPTY: (field)=>Boolean(field.value)
};
const $3585a67825579232$var$evaluateFormatRule = ({ field: field, operator: operator, value: value })=>{
    const evaluateHandlerFn = $3585a67825579232$var$evaluateHandler[operator];
    if (!evaluateHandlerFn) return false;
    return evaluateHandlerFn(field, value);
};
const $3585a67825579232$export$8b8aad40b9f7a09b = {
    [(0, $5fc53.ISSUE_TYPE)]: $3585a67825579232$var$evaluateFormatRule
};

});

parcelRegister("2ut8I", function(module, exports) {

$parcel$export(module.exports, "userEvaluateFormatRule", () => $dd6beeb81d7c9301$export$27e95a93355e9d3c);

var $5fc53 = parcelRequire("5fc53");

var $lJP8I = parcelRequire("lJP8I");
const $dd6beeb81d7c9301$var$evaluateHandler = {
    IS: (field, value)=>{
        if (value === (0, $lJP8I.USER_EMPTY_OPERATORS).UNASSIGNED || value === (0, $lJP8I.USER_EMPTY_OPERATORS).EMPTY) return Boolean(!field.value?.accountId);
        return Boolean(field.value?.accountId === value);
    },
    IS_NOT: (field, value)=>{
        if (value === (0, $lJP8I.USER_EMPTY_OPERATORS).UNASSIGNED || value === (0, $lJP8I.USER_EMPTY_OPERATORS).EMPTY) return Boolean(field.value?.accountId);
        return Boolean(field.value?.accountId !== value);
    }
};
const $dd6beeb81d7c9301$var$evaluateFormatRule = ({ field: field, operator: operator, value: value })=>{
    const evaluateHandlerFn = $dd6beeb81d7c9301$var$evaluateHandler[operator];
    if (!evaluateHandlerFn) return false;
    return evaluateHandlerFn(field, value);
};
const $dd6beeb81d7c9301$var$evaluateMultiUserHandler = {
    CONTAINS: (field, value)=>Boolean(Array.isArray(value) && field.value?.filter((fieldValue)=>value?.includes(fieldValue.accountId)).length === value.length),
    HAS_ANY_OF: (field, value)=>Boolean(Array.isArray(value) && field.value?.some((fieldValue)=>value?.includes(fieldValue.accountId))),
    DOES_NOT_CONTAIN: (field, value)=>Boolean(Array.isArray(value) && field.value?.some((fieldValue)=>!value?.includes(fieldValue.accountId))),
    IS_EMPTY: (field)=>field.value?.length === 0,
    IS_NOT_EMPTY: (field)=>field.value?.length > 0
};
const $dd6beeb81d7c9301$var$evaluateFormatRulesForMultiUser = ({ field: field, operator: operator, value: value })=>{
    const evaluateHandlerFn = $dd6beeb81d7c9301$var$evaluateMultiUserHandler[operator];
    if (!evaluateHandlerFn) return false;
    return evaluateHandlerFn(field, value);
};
const $dd6beeb81d7c9301$export$27e95a93355e9d3c = {
    [(0, $5fc53.USER_CF_TYPE)]: $dd6beeb81d7c9301$var$evaluateFormatRule,
    [(0, $5fc53.REPORTER_TYPE)]: $dd6beeb81d7c9301$var$evaluateFormatRule,
    [(0, $5fc53.ASSIGNEE_TYPE)]: $dd6beeb81d7c9301$var$evaluateFormatRule,
    [(0, $5fc53.MULTI_USER_CF_TYPE)]: $dd6beeb81d7c9301$var$evaluateFormatRulesForMultiUser,
    [(0, $5fc53.PEOPLE_CF_TYPE)]: $dd6beeb81d7c9301$var$evaluateFormatRulesForMultiUser
};

});
parcelRegister("lJP8I", function(module, exports) {

$parcel$export(module.exports, "USER_EMPTY_OPERATORS", () => $b34ee070465ec63a$export$d6d1c00539a63d49);
const $b34ee070465ec63a$export$d6d1c00539a63d49 = {
    UNASSIGNED: 'UNASSIGNED',
    EMPTY: 'EMPTY'
};

});


parcelRegister("8DFJJ", function(module, exports) {

$parcel$export(module.exports, "versionEvaluateFormatRule", () => $66c00a81039c929b$export$da4c4fbd4009c683);

var $5fc53 = parcelRequire("5fc53");
// TODO: FLINGO:925 - use value.id once that ticket is done
const $66c00a81039c929b$var$evaluateHandler = {
    IS: (field, value)=>Boolean(field.value?.name === value),
    IS_NOT: (field, value)=>Boolean(field.value?.name !== value),
    IS_EMPTY: (field)=>!field.value,
    IS_NOT_EMPTY: (field)=>Boolean(field.value)
};
const $66c00a81039c929b$var$evaluateFormatRule = ({ field: field, operator: operator, value: value })=>{
    const evaluateHandlerFn = $66c00a81039c929b$var$evaluateHandler[operator];
    if (!evaluateHandlerFn) return false;
    return evaluateHandlerFn(field, value);
};
const $66c00a81039c929b$var$evaluateMultiVersionHandler = {
    CONTAINS: (field, value)=>Boolean(Array.isArray(value) && field.value?.filter((fieldValue)=>value?.includes(fieldValue.name)).length === value.length),
    HAS_ANY_OF: (field, value)=>Boolean(Array.isArray(value) && field.value?.some((fieldValue)=>value?.includes(fieldValue.name))),
    DOES_NOT_CONTAIN: (field, value)=>!(Array.isArray(value) && field.value?.filter((fieldValue)=>value?.includes(fieldValue.name)).length === value.length),
    IS_EMPTY: (field)=>field.value?.length === 0,
    IS_NOT_EMPTY: (field)=>Boolean(field.value && field.value?.length > 0)
};
const $66c00a81039c929b$var$evaluateFormatRulesForMultiVersion = ({ field: field, operator: operator, value: value })=>{
    const evaluateHandlerFn = $66c00a81039c929b$var$evaluateMultiVersionHandler[operator];
    if (!evaluateHandlerFn) return false;
    return evaluateHandlerFn(field, value);
};
const $66c00a81039c929b$export$da4c4fbd4009c683 = {
    [(0, $5fc53.VERSION_CF_TYPE)]: $66c00a81039c929b$var$evaluateFormatRule,
    [(0, $5fc53.MULTI_VERSION_CF_TYPE)]: $66c00a81039c929b$var$evaluateFormatRulesForMultiVersion,
    [(0, $5fc53.FIX_VERSIONS_TYPE)]: $66c00a81039c929b$var$evaluateFormatRulesForMultiVersion,
    [(0, $5fc53.AFFECTS_VERSIONS_TYPE)]: $66c00a81039c929b$var$evaluateFormatRulesForMultiVersion
};

});




parcelRegister("icf02", function(module, exports) {

$parcel$export(module.exports, "CELL_WRAPPER_TEST_ID", () => $4ffb91ba355bde2b$export$dec9ff238ffa9d69);
$parcel$export(module.exports, "useMultiSelectKeyDown", () => $4ffb91ba355bde2b$export$704331f55cc6e6a4);

var $5uXOq = parcelRequire("5uXOq");
const $4ffb91ba355bde2b$export$dec9ff238ffa9d69 = 'business-list.ui.list-view.cell-navigation.cell-container';
const $4ffb91ba355bde2b$export$c4f223e53a47f1c6 = (element)=>element?.getAttribute('data-testid') === $4ffb91ba355bde2b$export$dec9ff238ffa9d69;
const $4ffb91ba355bde2b$export$704331f55cc6e6a4 = ({ editMode: editMode = true, wasEditMode: wasEditMode = false, menuIsOpen: menuIsOpen, setMenuIsOpen: setMenuIsOpen, saveAndClose: saveAndClose, onEscapeKeyPress: onEscapeKeyPress })=>{
    const shouldCloseWithoutSaving = (0, $5uXOq.useRef)(false);
    const saveAndCloseRef = (0, $5uXOq.useRef)(saveAndClose);
    saveAndCloseRef.current = saveAndClose;
    (0, $5uXOq.useEffect)(()=>{
        shouldCloseWithoutSaving.current = false;
    }, [
        editMode
    ]);
    const saveOnBlur = (0, $5uXOq.useCallback)(()=>{
        // save on blur when user did not press Escape
        if (wasEditMode && !editMode) {
            if (!shouldCloseWithoutSaving.current) {
                saveAndClose();
                // set close without saving to true because we already saved
                shouldCloseWithoutSaving.current = true;
            } else shouldCloseWithoutSaving.current = false;
        }
    }, [
        editMode,
        saveAndClose,
        wasEditMode
    ]);
    const saveOnUnmount = (0, $5uXOq.useCallback)(()=>{
        // save on edit view unmount
        if (!shouldCloseWithoutSaving.current) saveAndCloseRef.current();
        else shouldCloseWithoutSaving.current = false;
    }, []);
    const onKeyDown = (0, $5uXOq.useCallback)((event)=>{
        if (editMode) {
            // Close the menu on selecting an option
            if (menuIsOpen && [
                'Enter',
                'Tab',
                'Space'
            ].includes(event.code)) {
                setMenuIsOpen(false);
                return true;
            }
            // save and close when menu is closed
            if (!menuIsOpen && [
                'Enter',
                'Tab'
            ].includes(event.code)) {
                saveAndClose();
                // set close without saving to true because we already saved
                shouldCloseWithoutSaving.current = true;
                return false;
            }
            // Reopen the menu when the user types or hits down arrow
            if (!menuIsOpen && (event.code === 'ArrowDown' || event.code.startsWith('Key') && !event.metaKey && !event.ctrlKey)) {
                setMenuIsOpen(true);
                return true;
            }
            if (event.code === 'Escape') {
                shouldCloseWithoutSaving.current = true;
                onEscapeKeyPress && onEscapeKeyPress();
            }
        }
        return false;
    }, [
        editMode,
        menuIsOpen,
        onEscapeKeyPress,
        saveAndClose,
        setMenuIsOpen
    ]);
    return {
        onKeyDown: onKeyDown,
        saveOnBlur: saveOnBlur,
        saveOnUnmount: saveOnUnmount
    };
};

});

parcelRegister("3xYte", function(module, exports) {

$parcel$export(module.exports, "useCellSelected", () => $e7c44969594389ca$export$82315ac370e9a611);
$parcel$export(module.exports, "useHasCellSelection", () => $e7c44969594389ca$export$a808344e7adc2015);
$parcel$export(module.exports, "useCellActions", () => $e7c44969594389ca$export$98b52eeb50fa4d73);

var $jDUax = parcelRequire("jDUax");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $eTDjN = parcelRequire("eTDjN");

var $2CfGf = parcelRequire("2CfGf");


var $guydz = parcelRequire("guydz");
const $e7c44969594389ca$var$actions = {
    clearSelectedCell: ()=>({ setState: setState })=>{
            setState({
                selectedCell: undefined
            });
        },
    clearCopiedFromCell: ()=>({ setState: setState })=>{
            setState({
                copiedFromCell: null
            });
        },
    setSelectedCell: (columnIndex, rowIndex)=>({ setState: setState, getState: getState })=>{
            const { selectedCell: selectedCell } = getState();
            if ((0, $guydz.checkIsCellSelected)(selectedCell, columnIndex, rowIndex)) return;
            setState({
                selectedCell: {
                    column: columnIndex,
                    row: rowIndex
                }
            });
        },
    setCopiedFromCell: (fieldId, issueId)=>({ setState: setState, getState: getState })=>{
            if (!fieldId || !issueId) return;
            const { copiedFromCell: copiedFromCell } = getState();
            if ((0, $guydz.checkIsCellCopiedFrom)(copiedFromCell, fieldId, issueId)) return;
            setState({
                copiedFromCell: {
                    fieldId: fieldId,
                    issueId: issueId
                }
            });
        },
    navigate: (direction, tableRef, dragAndDropButtonRow)=>({ setState: setState, getState: getState })=>{
            const { selectedCell: selectedCell } = getState();
            const tableRefProps = tableRef?.current?.table?.props;
            const tableData = tableRefProps?.data;
            const tableWidth = tableRefProps?.width || 0;
            const scrollLeft = tableRef?.current?.table?.bodyRef?.state?.scrollLeft || 0;
            const tableColumns = tableRefProps?.columns || [];
            const { visibleColumns: visibleColumns } = (0, $2CfGf.getColumnVisibilityIndexes)(scrollLeft, tableWidth, tableColumns);
            // Handle navigation from drag and drop button to the last cell of the row above.
            if (dragAndDropButtonRow && tableData) {
                // stay on the same cell if the new row is a group item row
                if ((0, $jDUax.isGroupItem)(tableData?.[dragAndDropButtonRow - 1]?.issueId?.toString() || null)) return;
                (0, $guydz.scrollCellIntoView)(tableRef, visibleColumns, direction, {
                    column: 0,
                    row: dragAndDropButtonRow
                }, {
                    column: tableColumns.length - 1,
                    row: dragAndDropButtonRow - 1
                });
                setTimeout(()=>{
                    setState({
                        selectedCell: {
                            column: tableColumns.length - 1,
                            row: dragAndDropButtonRow - 1
                        }
                    });
                }, (0, $8ae9e10bb829c07c$export$c10811fdbc59f0be));
                return;
            }
            if (!selectedCell || !tableData) return;
            const { newColumnIndex: newColumnIndex, newRowIndex: newRowIndex } = (0, $guydz.getUpdatedNavigationIndexes)(selectedCell, direction, tableColumns, tableData);
            // stay on the same cell if the new row is a group item row
            if (tableData && (0, $jDUax.isGroupItem)(tableData?.[newRowIndex]?.issueId?.toString() || null)) return;
            (0, $guydz.scrollCellIntoView)(tableRef, visibleColumns, direction, selectedCell, {
                column: newColumnIndex,
                row: newRowIndex
            });
            const prevCellColumn = selectedCell.column;
            // Focus on the drag and drop button only if the last column was selected
            // and the next selected column and row is the first of the next row.
            const shouldFocusOnDragAndDropButton = prevCellColumn === tableColumns.length - 1 && newColumnIndex === 0 && newRowIndex < tableData.length;
            // wait for all scroll, focus and blur events to finish before setting state
            if (shouldFocusOnDragAndDropButton) {
                const { issueId: issueId } = tableData[newRowIndex];
                setTimeout(()=>{
                    if (typeof document !== 'undefined') document.dispatchEvent(new CustomEvent(`${(0, $eTDjN.DRAG_AND_DROP_BUTTON_FOCUS_EVENT)}`, {
                        detail: {
                            issueId: issueId
                        }
                    }));
                }, (0, $8ae9e10bb829c07c$export$c10811fdbc59f0be));
            } else setTimeout(()=>{
                setState({
                    selectedCell: {
                        column: newColumnIndex,
                        row: newRowIndex
                    }
                });
            }, (0, $8ae9e10bb829c07c$export$c10811fdbc59f0be));
        }
};
const $e7c44969594389ca$export$390f32400eaf98c9 = (0, $iXqE5.createStore)({
    initialState: {
        selectedCell: undefined,
        copiedFromCell: null,
        prevScrolledColumnIndex: undefined
    },
    actions: $e7c44969594389ca$var$actions,
    name: 'JwmCellNavigation'
});
const $e7c44969594389ca$export$82315ac370e9a611 = (0, $3sQ5x.createHook)($e7c44969594389ca$export$390f32400eaf98c9, {
    // we need to use the selector to prevent unnecessary re-render in all the cells every time the focus change
    selector: (0, $guydz.getCellSelectedSelector)
});
const $e7c44969594389ca$export$a808344e7adc2015 = (0, $3sQ5x.createHook)($e7c44969594389ca$export$390f32400eaf98c9, {
    selector: (0, $guydz.getHasSelectionSelector)
});
const $e7c44969594389ca$export$98b52eeb50fa4d73 = (0, $3sQ5x.createActionsHook)($e7c44969594389ca$export$390f32400eaf98c9);

});
const $8ae9e10bb829c07c$export$c10811fdbc59f0be = 50;

parcelRegister("guydz", function(module, exports) {

$parcel$export(module.exports, "checkIsCellSelected", () => $de36b09dafacedf7$export$137ef1ae0e2f1e4f);
$parcel$export(module.exports, "checkIsCellCopiedFrom", () => $de36b09dafacedf7$export$10a6e994f306d4c1);
$parcel$export(module.exports, "getCellSelectedSelector", () => $de36b09dafacedf7$export$8faeda346ea872cf);
$parcel$export(module.exports, "getHasSelectionSelector", () => $de36b09dafacedf7$export$f296623a5c5deab7);
$parcel$export(module.exports, "getUpdatedNavigationIndexes", () => $de36b09dafacedf7$export$e86d0c724f5bd464);
$parcel$export(module.exports, "scrollCellIntoView", () => $de36b09dafacedf7$export$5d689075caa24122);

var $2HfxU = parcelRequire("2HfxU");

var $hYfgW = parcelRequire("hYfgW");

var $jDUax = parcelRequire("jDUax");

var $6dDSs = parcelRequire("6dDSs");

var $eTDjN = parcelRequire("eTDjN");
const $de36b09dafacedf7$export$137ef1ae0e2f1e4f = (selectedCell, columnIndex, rowIndex)=>selectedCell ? selectedCell.column === columnIndex && selectedCell.row === rowIndex : false;
const $de36b09dafacedf7$export$10a6e994f306d4c1 = (copiedCell, fieldId, issueId)=>{
    if (!copiedCell || !fieldId || !issueId) return false;
    return copiedCell.fieldId === fieldId && copiedCell.issueId === issueId;
};
const $de36b09dafacedf7$export$8faeda346ea872cf = (0, $6dDSs.createSelector)((state, coordinate)=>({
        isCellSelected: $de36b09dafacedf7$export$137ef1ae0e2f1e4f(state.selectedCell, coordinate.column, coordinate.row),
        isCellCopiedFrom: $de36b09dafacedf7$export$10a6e994f306d4c1(state.copiedFromCell, coordinate.fieldId, coordinate.issueId)
    }), ({ isCellSelected: isCellSelected, isCellCopiedFrom: isCellCopiedFrom })=>({
        isSelected: isCellSelected,
        isCopiedFrom: isCellCopiedFrom ?? false
    }));
const $de36b09dafacedf7$export$f296623a5c5deab7 = (0, $6dDSs.createSelector)((state)=>({
        hasSelection: !!state.selectedCell
    }), ({ hasSelection: hasSelection })=>({
        hasSelection: hasSelection
    }));
const $de36b09dafacedf7$var$getNewColumnIndex = (initialCell, direction, totalColumns, totalRows)=>{
    const { column: initialColumnIndex, row: initialRowIndex } = initialCell;
    const lastColumnIndex = totalColumns - 1;
    const lastRowIndex = totalRows - 1;
    const isFirstTableItem = initialColumnIndex === 0 && initialRowIndex === 0;
    const isLastTableItem = initialColumnIndex === lastColumnIndex && initialRowIndex === lastRowIndex;
    if (direction === (0, $eTDjN.LEFT) && !isFirstTableItem) return (initialColumnIndex || totalColumns) - 1;
    if (direction === (0, $eTDjN.RIGHT) && !isLastTableItem) return (initialColumnIndex + 1) % totalColumns;
    return initialColumnIndex;
};
const $de36b09dafacedf7$var$getNewRowIndex = (initialCell, direction, tableData)=>{
    const { row: initialRowIndex } = initialCell;
    if (direction === (0, $eTDjN.UP)) {
        let newRowIndex = initialRowIndex - 1;
        while(newRowIndex > 0 && (0, $jDUax.isGroupItem)(tableData[newRowIndex]?.issueId?.toString() || null))newRowIndex--;
        return Math.max(0, newRowIndex);
    }
    if (direction === (0, $eTDjN.DOWN)) {
        let nextRowIndex = initialRowIndex + 1;
        while(nextRowIndex < tableData.length && (0, $jDUax.isGroupItem)(tableData[nextRowIndex]?.issueId?.toString() || null))nextRowIndex++;
        return Math.min(tableData.length - 1, nextRowIndex);
    }
    return initialRowIndex;
};
const $de36b09dafacedf7$export$e86d0c724f5bd464 = (initialCell, direction, tableColumn, tableData)=>{
    const totalColumns = tableColumn.length;
    const totalRows = tableData.length;
    const newColumnIndex = $de36b09dafacedf7$var$getNewColumnIndex(initialCell, direction, totalColumns, totalRows);
    if (direction === (0, $eTDjN.UP) || direction === (0, $eTDjN.DOWN)) {
        const newRowIndex = $de36b09dafacedf7$var$getNewRowIndex(initialCell, direction, tableData);
        return {
            newColumnIndex: newColumnIndex,
            newRowIndex: newRowIndex
        };
    }
    if (direction === (0, $eTDjN.RIGHT) && newColumnIndex === 0) {
        const newRowIndex = $de36b09dafacedf7$var$getNewRowIndex(initialCell, (0, $eTDjN.DOWN), tableData);
        return {
            newColumnIndex: newColumnIndex,
            newRowIndex: newRowIndex
        };
    }
    if (direction === (0, $eTDjN.LEFT) && newColumnIndex === totalColumns - 1) {
        const newRowIndex = $de36b09dafacedf7$var$getNewRowIndex(initialCell, (0, $eTDjN.UP), tableData);
        return {
            newColumnIndex: newColumnIndex,
            newRowIndex: newRowIndex
        };
    }
    return {
        newColumnIndex: newColumnIndex,
        newRowIndex: initialCell.row
    };
};
const $de36b09dafacedf7$export$5d689075caa24122 = (tableRef, visibleColumns, direction, initialCell, newCell)=>{
    const tableWidth = tableRef.current?.table?.props?.width || 0;
    const tableColumns = tableRef.current?.table?.props?.columns || [];
    const { column: initialColumnIndex, row: initialRowIndex } = initialCell;
    const { column: newColumnIndex, row: newRowIndex } = newCell;
    if (initialRowIndex !== newRowIndex) setTimeout(()=>tableRef.current?.scrollToRow(newRowIndex, 'auto'));
    if (direction === (0, $eTDjN.LEFT)) {
        const firstVisibleColumn = (0, (/*@__PURE__*/$parcel$interopDefault($2HfxU)))(visibleColumns);
        const shouldScrollColumnIntoView = firstVisibleColumn === initialColumnIndex || firstVisibleColumn === newColumnIndex || newColumnIndex > initialColumnIndex;
        if (shouldScrollColumnIntoView) {
            const scrollAmount = tableColumns.slice(0, newColumnIndex).reduce((acc, column)=>acc + column.width, 0);
            setTimeout(()=>tableRef.current?.scrollToLeft(scrollAmount));
        }
    }
    if (direction === (0, $eTDjN.RIGHT)) {
        const lastVisibleColumn = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))(visibleColumns);
        const shouldScrollColumnIntoView = lastVisibleColumn === initialColumnIndex || lastVisibleColumn === newColumnIndex || newColumnIndex < initialColumnIndex;
        if (shouldScrollColumnIntoView) {
            const totalWidthUntilNextCell = tableColumns.slice(0, newColumnIndex + 1).reduce((acc, column)=>acc + column.width, 0);
            const scrollAmount = Math.max(0, totalWidthUntilNextCell - tableWidth);
            setTimeout(()=>tableRef.current?.scrollToLeft(scrollAmount));
        }
    }
};

});
parcelRegister("2HfxU", function(module, exports) {

module.exports = (parcelRequire("bH3EF"));

});
parcelRegister("bH3EF", function(module, exports) {
/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias first
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.head([1, 2, 3]);
 * // => 1
 *
 * _.head([]);
 * // => undefined
 */ function $88368ba58341d518$var$head(array) {
    return array && array.length ? array[0] : undefined;
}
module.exports = $88368ba58341d518$var$head;

});




parcelRegister("2gmNO", function(module, exports) {

$parcel$export(module.exports, "ClipboardController", () => $0be66f78721f7623$export$16d13693519be2ee);

var $5uXOq = parcelRequire("5uXOq");

var $daTLS = parcelRequire("daTLS");

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $4R6GH = parcelRequire("4R6GH");

var $3xYte = parcelRequire("3xYte");

var $g65iA = parcelRequire("g65iA");
const $0be66f78721f7623$export$16d13693519be2ee = ({ children: children, issue: issue, field: field, fieldId: fieldId, isSelected: isSelected, isEditMode: isEditMode, onKeyDown: onKeyDown })=>{
    const transformedField = (0, $5uXOq.useMemo)(()=>issue.fields?.find((f)=>{
            const fieldId_ = field.id === 'key' ? 'issuekey' : field.id;
            return f.fieldId === fieldId_;
        }), [
        field.id,
        issue.fields
    ]);
    const isFieldAssociated = (0, $4R6GH.fg)('list-view-clipboard-issuetype-undefined') ? field.issueTypes?.includes(issue.issuetype?.id ?? '') : field.issueTypes?.includes(issue.issuetype.id ?? '');
    const transformedMissingField = isFieldAssociated ? {
        type: field.type,
        fieldId: field.id,
        value: null
    } : null;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [clipboard, setClipboard] = (0, $5uXOq.useState)(null);
    const [isCutting, setIsCutting] = (0, $5uXOq.useState)(false);
    const [contentToCopy, setContentToCopy] = (0, $5uXOq.useState)(null);
    const { setCopiedFromCell: setCopiedFromCell, clearCopiedFromCell: clearCopiedFromCell } = (0, $3xYte.useCellActions)();
    const isEditable = field.fieldConfig?.isEditable ?? true;
    const canBeUnset = (0, $5uXOq.useMemo)(()=>(0, $g65iA.canBeReset)(field), [
        field
    ]);
    const issueForCopyAndPaste = (0, $5uXOq.useMemo)(()=>({
            key: issue.key,
            issueId: issue.issueId,
            issueType: issue.issuetype
        }), [
        issue.issueId,
        issue.issuetype,
        issue.key
    ]);
    const { renderPrepareToCopyComponent: renderPrepareToCopyComponent, renderPasteHandlerComponent: renderPasteHandlerComponent, renderCutOnlyHandlerComponent: renderCutOnlyHandlerComponent } = (0, $daTLS.useClipboard)(issueForCopyAndPaste, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    transformedField ?? transformedMissingField, fieldId);
    const { reportError: reportError, dismissFlag: dismissFlag, showErroFlag: showErroFlag } = (0, $g65iA.useClipboardErrorReporting)(field);
    const onPaste = (0, $5uXOq.useCallback)((success, error)=>{
        dismissFlag();
        setClipboard(null);
        if (success) (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'cell pasted', {
            fieldType: field.type
        });
        else reportError({
            action: 'paste',
            error: error
        });
        if (isFieldAssociated && !transformedField) (0, $jcw0u.default)({
            meta: {
                id: 'jiraClipboardController',
                packageName: 'jiraBusinessList',
                teamName: 'keystone'
            },
            attributes: {
                message: `A field of type ${field.type} is missing in BE response`,
                fieldType: field.type
            },
            error: new Error('jiraClipboardControllerMissingFieldError')
        });
    }, [
        createAnalyticsEvent,
        dismissFlag,
        field.type,
        isFieldAssociated,
        reportError,
        transformedField
    ]);
    const onCut = (0, $5uXOq.useCallback)((success, error)=>{
        dismissFlag();
        setIsCutting(false);
        if (!success) reportError({
            action: 'cut',
            error: error
        });
    }, [
        dismissFlag,
        reportError
    ]);
    const paste = (0, $5uXOq.useCallback)((event)=>{
        if (isEditMode || !isEditable) return;
        const data = event.clipboardData;
        setClipboard({
            plainText: data?.getData('text/plain'),
            html: data?.getData('text/html')
        });
    }, [
        setClipboard,
        isEditMode,
        isEditable
    ]);
    const handleSetClipboardData = (0, $5uXOq.useCallback)((e, clipboardItem, action)=>{
        if (!e.clipboardData || !clipboardItem || !clipboardItem.plainText || !clipboardItem.html) {
            showErroFlag({
                action: action
            });
            return;
        }
        e.clipboardData.setData('text/plain', clipboardItem.plainText);
        e.clipboardData.setData('text/html', clipboardItem.html);
    }, [
        showErroFlag
    ]);
    const copyEventListener = (0, $5uXOq.useCallback)((e)=>{
        if (!isSelected || isEditMode) return;
        dismissFlag();
        if ((0, $4R6GH.fg)('list_clipboard_item_is_not_provided_bugfix')) handleSetClipboardData(e, contentToCopy, 'copy');
        else try {
            (0, $g65iA.setDataToClipboard)(e, contentToCopy);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            reportError({
                action: 'copy',
                error: error
            });
            return;
        }
        e.preventDefault();
        setCopiedFromCell(field.id, issue?.issueId);
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'cell copied', {
            fieldType: field.type,
            hasCopied: true
        });
    }, [
        isSelected,
        isEditMode,
        dismissFlag,
        setCopiedFromCell,
        field.id,
        field.type,
        issue?.issueId,
        createAnalyticsEvent,
        handleSetClipboardData,
        contentToCopy,
        reportError
    ]);
    const cutEventListener = (0, $5uXOq.useCallback)((e)=>{
        if (!isSelected || isEditMode) return;
        if ((0, $4R6GH.fg)('list_clipboard_item_is_not_provided_bugfix')) handleSetClipboardData(e, contentToCopy, 'cut');
        else try {
            (0, $g65iA.setDataToClipboard)(e, contentToCopy);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            reportError({
                action: 'cut',
                error: error
            });
            return;
        }
        e.preventDefault();
        dismissFlag();
        setCopiedFromCell(field.id, issue?.issueId);
        setIsCutting(true);
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'cell cut', {
            fieldType: field.type,
            canBeReset: canBeUnset,
            hasCopied: true
        });
    }, [
        isSelected,
        isEditMode,
        dismissFlag,
        setCopiedFromCell,
        field.id,
        field.type,
        issue?.issueId,
        createAnalyticsEvent,
        canBeUnset,
        handleSetClipboardData,
        contentToCopy,
        reportError
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isSelected) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.addEventListener('paste', paste, true);
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.addEventListener('copy', copyEventListener);
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.addEventListener('cut', cutEventListener);
        } else {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.removeEventListener('paste', paste, true);
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.removeEventListener('copy', copyEventListener);
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.removeEventListener('cut', cutEventListener);
        }
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.removeEventListener('paste', paste, true);
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.removeEventListener('copy', copyEventListener);
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.removeEventListener('cut', cutEventListener);
        };
    }, [
        copyEventListener,
        cutEventListener,
        isSelected,
        paste
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, $5uXOq.cloneElement)(children, {
        onKeyDown: onKeyDown
    }), clipboard && renderPasteHandlerComponent({
        clipboard: clipboard,
        onPaste: onPaste,
        isEditable: isEditable,
        onBeforePaste: clearCopiedFromCell
    }), isCutting && renderCutOnlyHandlerComponent({
        onCut: onCut,
        isEditable: canBeUnset
    }), isSelected && renderPrepareToCopyComponent({
        onContentReady: setContentToCopy
    }));
};

});
parcelRegister("daTLS", function(module, exports) {

$parcel$export(module.exports, "useClipboard", () => $31ec25dabeedbefa$export$2314ca2a3e892862);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $bj6Oi = parcelRequire("bj6Oi");

var $bxNFR = parcelRequire("bxNFR");

var $koVbs = parcelRequire("koVbs");

var $1xoxe = parcelRequire("1xoxe");

var $7CjVW = parcelRequire("7CjVW");

var $3O2T0 = parcelRequire("3O2T0");

var $9de3P = parcelRequire("9de3P");
const $31ec25dabeedbefa$var$PrepareToCopyComponent = ({ issue: issue, field: field, onMissingClipboardHandler: onMissingClipboardHandler, onContentReady: onContentReady })=>{
    const Component = (0, $7CjVW.getClipboardHandlerComponent)(field?.type);
    (0, $5uXOq.useEffect)(()=>{
        if (!Component) try {
            const result = onMissingClipboardHandler();
            onContentReady(result);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            onContentReady(null);
        }
    }, [
        Component,
        onContentReady,
        onMissingClipboardHandler
    ]);
    if (!Component) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
        issue: issue,
        field: field,
        action: "prepare-to-copy",
        onComplete: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onContentReady: onContentReady,
        metadata: null
    });
};
const $31ec25dabeedbefa$var$CutOnlyHandlerComponent = ({ issue: issue, field: field, onCut: onCut, isEditable: isEditable })=>{
    const Component = (0, $7CjVW.getClipboardHandlerComponent)(field.type);
    const checkIsEditable = (0, $5uXOq.useCallback)(()=>{
        if (!isEditable) throw new (0, $bj6Oi.ClientSideValidationError)((0, $1xoxe.VALIDATION_ERROR_CODES).NON_EDITABLE);
    }, [
        isEditable
    ]);
    if (!isEditable) {
        onCut(false, new (0, $bj6Oi.ClientSideValidationError)((0, $1xoxe.VALIDATION_ERROR_CODES).NON_EDITABLE));
        return null;
    }
    if (!Component) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
        issue: issue,
        field: field,
        action: "cut-only",
        onComplete: onCut,
        metadata: {
            fieldId: field.fieldId,
            fieldType: field.type,
            fieldValue: null
        },
        onBeforeAction: checkIsEditable
    });
};
const $31ec25dabeedbefa$export$2314ca2a3e892862 = (issue, field, fieldId)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const getCellValueFallback = (0, $5uXOq.useCallback)(()=>{
        if (!field) throw new (0, $bj6Oi.ClientSideValidationError)((0, $1xoxe.VALIDATION_ERROR_CODES).MISSING_FIELD);
        return (0, $3O2T0.getCellValue)(field, issue, formatMessage);
    }, [
        field,
        formatMessage,
        issue
    ]);
    const renderPrepareToCopyComponent = ({ onContentReady: onContentReady })=>{
        if (!field || !issue?.key || !issue?.issueId) return;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($31ec25dabeedbefa$var$PrepareToCopyComponent, {
            issue: issue,
            field: field,
            onMissingClipboardHandler: getCellValueFallback,
            onContentReady: onContentReady
        });
    };
    const renderPasteHandlerComponent = ({ clipboard: clipboard, onPaste: onPaste, isEditable: isEditable, onBeforePaste: onBeforePaste })=>{
        if (!issue?.key || !issue?.issueId) return onPaste(false, new (0, $bj6Oi.ClientSideValidationError)((0, $1xoxe.VALIDATION_ERROR_CODES).MISSING_ISSUE));
        const isTopLevelField = fieldId && (0, $1xoxe.SUPPORTED_TOP_LEVEL_FIELD_TYPES).includes(fieldId);
        const fieldType = isTopLevelField ? fieldId : field?.type;
        if (!fieldType) return onPaste(false, new (0, $bj6Oi.ClientSideValidationError)((0, $1xoxe.VALIDATION_ERROR_CODES).MISSING_FIELD));
        const PasteHandlerComponent = field && (0, $7CjVW.getClipboardHandlerComponent)(field?.type);
        if (!PasteHandlerComponent || !isEditable) return onPaste(false, new (0, $bxNFR.UnsupportedOperationError)(`Pasting on field type ${fieldType} is not supported`));
        if (!clipboard?.plainText) return onPaste(false, new (0, $bj6Oi.ClientSideValidationError)((0, $1xoxe.VALIDATION_ERROR_CODES).EMPTY_CLIPBOARD));
        const metadata = (0, $9de3P.getFieldMetadataFromClipboard)(clipboard);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(PasteHandlerComponent, {
            issue: issue,
            field: field,
            action: "paste",
            clipboardItem: clipboard,
            onBeforeAction: onBeforePaste,
            onComplete: onPaste,
            metadata: metadata
        });
    };
    const renderCutOnlyHandlerComponent = ({ onCut: onCut, isEditable: isEditable })=>{
        if (!field || !issue?.key || !issue?.issueId) return onCut(false, new (0, $bj6Oi.ClientSideValidationError)((0, $1xoxe.VALIDATION_ERROR_CODES).MISSING_FIELD));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($31ec25dabeedbefa$var$CutOnlyHandlerComponent, {
            issue: issue,
            field: field,
            onCut: onCut,
            isEditable: isEditable
        });
    };
    return {
        renderPasteHandlerComponent: renderPasteHandlerComponent,
        renderPrepareToCopyComponent: renderPrepareToCopyComponent,
        renderCutOnlyHandlerComponent: renderCutOnlyHandlerComponent
    };
};

});
parcelRegister("bj6Oi", function(module, exports) {

$parcel$export(module.exports, "ClientSideValidationError", () => $fdb996f0512636de$export$5ba9b77898e6c81d);
$parcel$export(module.exports, "isClientSideValidationError", () => $fdb996f0512636de$export$ea2382f3076b0d69);
class $fdb996f0512636de$export$5ba9b77898e6c81d extends Error {
    constructor(message){
        super(message);
        this.name = 'ClientSideValidationError';
        this.skipSentry = true;
    }
}
const $fdb996f0512636de$export$ea2382f3076b0d69 = (error)=>error instanceof $fdb996f0512636de$export$5ba9b77898e6c81d;

});

parcelRegister("bxNFR", function(module, exports) {

$parcel$export(module.exports, "UnsupportedOperationError", () => $a9534f2b2fe2c376$export$ab59e00737fb22e6);
$parcel$export(module.exports, "isUnsupportedOperationError", () => $a9534f2b2fe2c376$export$cdab81fcd467111);
class $a9534f2b2fe2c376$export$ab59e00737fb22e6 extends Error {
    constructor(message){
        super(message);
        this.name = 'UnsupportedOperationError';
        this.skipSentry = true;
    }
}
const $a9534f2b2fe2c376$export$cdab81fcd467111 = (error)=>error instanceof $a9534f2b2fe2c376$export$ab59e00737fb22e6;

});

parcelRegister("1xoxe", function(module, exports) {

$parcel$export(module.exports, "VALIDATION_ERROR_CODES", () => $5f608d3cb06b552d$export$6d25692f75bd9b88);
$parcel$export(module.exports, "SUPPORTED_TOP_LEVEL_FIELD_TYPES", () => $5f608d3cb06b552d$export$71645e77fbde68a0);

var $hE5wF = parcelRequire("hE5wF");

var $5fc53 = parcelRequire("5fc53");
const $5f608d3cb06b552d$export$6d25692f75bd9b88 = {
    NULL_GETTER: 'NULL_GETTER',
    MISSING_FIELD: 'MISSING_FIELD',
    MISSING_ISSUE: 'MISSING_ISSUE',
    NON_COMPATIBLE_FIELD_TYPE: 'NON_COMPATIBLE_FIELD_TYPE',
    EMPTY_CLIPBOARD: 'EMPTY_CLIPBOARD',
    NON_EDITABLE: 'NON_EDITABLE'
};
const $5f608d3cb06b552d$export$71645e77fbde68a0 = [
    (0, $5fc53.COMMENT_TYPE),
    (0, $hE5wF.COMMENT_SUMMARY_TYPE),
    (0, $hE5wF.REMOTE_ISSUE_LINKS_TYPE)
];

});

parcelRegister("7CjVW", function(module, exports) {

$parcel$export(module.exports, "getClipboardHandlerComponent", () => $42bcc5428b94d826$export$547cefce1a43344e);

var $8QpSo = parcelRequire("8QpSo");

var $5PsOy = parcelRequire("5PsOy");

var $jhaRN = parcelRequire("jhaRN");

var $auKIK = parcelRequire("auKIK");

var $ayltP = parcelRequire("ayltP");

var $8WsUD = parcelRequire("8WsUD");

var $inOlw = parcelRequire("inOlw");

var $bZjVN = parcelRequire("bZjVN");

var $7Y57h = parcelRequire("7Y57h");

var $1ZojP = parcelRequire("1ZojP");

var $233vh = parcelRequire("233vh");

var $62Lxt = parcelRequire("62Lxt");

var $eOY1D = parcelRequire("eOY1D");

var $g8t8K = parcelRequire("g8t8K");

var $8swam = parcelRequire("8swam");

var $lhJy9 = parcelRequire("lhJy9");

var $jtn4P = parcelRequire("jtn4P");

var $1O7xL = parcelRequire("1O7xL");

var $dCJsI = parcelRequire("dCJsI");

var $57YE2 = parcelRequire("57YE2");

var $iAC09 = parcelRequire("iAC09");

var $eowGc = parcelRequire("eowGc");

var $4dpsE = parcelRequire("4dpsE");

var $9UQ66 = parcelRequire("9UQ66");
const $42bcc5428b94d826$var$createClipboardHandlers = (0, $8QpSo.default)(()=>({
        ...(0, $jhaRN.categoryClipboardHandler),
        ...(0, $auKIK.checkboxClipboardHandler),
        ...(0, $ayltP.componentsClipboardHandler),
        ...(0, $9UQ66.versionClipboardHandler),
        ...(0, $7Y57h.labelsClipboardHandler),
        ...(0, $233vh.numberClipboardHandler),
        ...(0, $4dpsE.userClipboardHandler),
        ...(0, $4dpsE.multiUserClipboardHandler),
        ...(0, $1ZojP.multiSelectClipboardHandler),
        ...(0, $8WsUD.dateClipboardHandler),
        ...(0, $inOlw.dateTimeClipboardHandler),
        ...(0, $57YE2.textClipboardHandler),
        ...(0, $lhJy9.richTextClipboardHandler),
        ...(0, $eOY1D.priorityClipboardHandler),
        ...(0, $jtn4P.singleSelectClipboardHandler),
        ...(0, $1O7xL.sprintClipboardHandler),
        ...(0, $iAC09.timeTrackingClipboardHandler),
        ...(0, $eowGc.urlClipboardHandler),
        ...(0, $dCJsI.teamClipboardHandler),
        ...(0, $62Lxt.parentClipboardHandler),
        ...(0, $bZjVN.groupClipboardHandler),
        ...(0, $g8t8K.projectClipboardHandler),
        ...(0, $5PsOy.cascadingSelectClipboardHandler),
        ...(0, $8swam.radioSelectClipboardHandler)
    }));
const $42bcc5428b94d826$export$547cefce1a43344e = (fieldType)=>{
    const handlers = $42bcc5428b94d826$var$createClipboardHandlers();
    if (!fieldType || handlers[fieldType] == null) return;
    return handlers[fieldType];
};

});
parcelRegister("5PsOy", function(module, exports) {

$parcel$export(module.exports, "cascadingSelectClipboardHandler", () => $029a3ce5110ccb9a$export$9fd387ed8e8432cb);

var $5fc53 = parcelRequire("5fc53");

var $dZxXA = parcelRequire("dZxXA");

var $4UjyI = parcelRequire("4UjyI");

var $ks0ly = parcelRequire("ks0ly");

var $3O2T0 = parcelRequire("3O2T0");
const $029a3ce5110ccb9a$var$isCascadingSelectOption = (fieldValue)=>fieldValue != null && typeof fieldValue === 'object' && 'parentOptionValue' in fieldValue;
const $029a3ce5110ccb9a$var$getPastedValue = (clipboardItem, metadata)=>{
    if (!(0, $3O2T0.assertClipboardHasRichFormat)(clipboardItem) || !(0, $3O2T0.assertClipboardDataIsCompatible)(metadata, [
        (0, $5fc53.CASCADING_SELECT_CF_TYPE)
    ])) return null;
    if (!$029a3ce5110ccb9a$var$isCascadingSelectOption(metadata.fieldValue)) return null;
    const { parentOptionValue: parentOptionValue, childOptionValue: childOptionValue } = metadata.fieldValue;
    return {
        parentOptionValue: parentOptionValue,
        childOptionValue: childOptionValue
    };
};
const $029a3ce5110ccb9a$export$5da374e426806c6a = (fieldValue)=>{
    if (fieldValue && fieldValue.parentOptionValue) {
        if (fieldValue.childOptionValue) return `${fieldValue.parentOptionValue.value} - ${fieldValue.childOptionValue.value}`;
        return `${fieldValue.parentOptionValue.value}`;
    }
    return '';
};
function $029a3ce5110ccb9a$var$assertCascadingSelectField(field) {
    if (!field) throw new Error('Field is required');
    if (field.type !== (0, $5fc53.CASCADING_SELECT_CF_TYPE)) throw new Error('Field type is not supported');
}
const $029a3ce5110ccb9a$var$useCascadingSelectClipboardHandler = (issue, field)=>{
    $029a3ce5110ccb9a$var$assertCascadingSelectField(field);
    const [{ value: value }, { saveValue: saveValue }] = (0, $dZxXA.useCascadingSelectField)({
        fieldAriId: field.id,
        issueKey: issue.key,
        fieldKey: field.fieldId,
        initialValue: $029a3ce5110ccb9a$var$isCascadingSelectOption(field.value) ? field.value : null
    });
    return (0, $ks0ly.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: $029a3ce5110ccb9a$export$5da374e426806c6a(value),
        currentValue: value,
        getPastedValue: $029a3ce5110ccb9a$var$getPastedValue,
        saveValue: saveValue
    });
};
const $029a3ce5110ccb9a$var$CascadingSelectClipboardHelper = (0, $4UjyI.createClipboardHelperComponent)($029a3ce5110ccb9a$var$useCascadingSelectClipboardHandler);
const $029a3ce5110ccb9a$export$9fd387ed8e8432cb = {
    [(0, $5fc53.CASCADING_SELECT_CF_TYPE)]: $029a3ce5110ccb9a$var$CascadingSelectClipboardHelper
};

});
parcelRegister("dZxXA", function(module, exports) {

$parcel$export(module.exports, "useCascadingSelectField", () => $d1627e1289106486$export$f7e91b2d1b79d323);

var $k6djR = parcelRequire("k6djR");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $lQE94 = parcelRequire("lQE94");

var $5fc53 = parcelRequire("5fc53");
const $d1627e1289106486$export$f7e91b2d1b79d323 = ({ fieldAriId: fieldAriId, issueKey: issueKey, fieldKey: fieldKey, initialValue: initialValue, onFailure: onFailure })=>{
    const [editValue, setEditValue] = (0, $5uXOq.useState)(initialValue);
    const [commit] = (0, $8Uumt.useMutation)((0, $k6djR.default));
    const saveField = (0, $5uXOq.useCallback)((_iKey, _fKey, valuesForOperation)=>{
        if (!valuesForOperation) return Promise.resolve(undefined);
        const { parentOptionValue: parentOptionValue, childOptionValue: childOptionValue } = valuesForOperation;
        commit({
            variables: {
                input: {
                    id: fieldAriId,
                    operation: {
                        operation: 'SET',
                        parentOption: parentOptionValue?.id,
                        childOption: childOptionValue?.id
                    }
                }
            },
            onError: onFailure,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            optimisticResponse: {
                jira: {
                    updateCascadingSelectField: {
                        success: true,
                        errors: null
                    }
                }
            }
        });
        return Promise.resolve(undefined);
    }, [
        commit,
        fieldAriId,
        onFailure
    ]);
    const [{ value: value }, { saveValue: saveValue }] = (0, $lQE94.useEditField)({
        fieldType: (0, $5fc53.CASCADING_SELECT_CF_TYPE),
        issueId: fieldAriId,
        issueKey: issueKey,
        initialValue: initialValue,
        fieldKey: fieldKey,
        saveField: saveField
    });
    return [
        {
            value: value,
            editValue: editValue,
            setEditValue: setEditValue
        },
        {
            saveValue: saveValue
        }
    ];
};

});
parcelRegister("k6djR", function(module, exports) {

$parcel$export(module.exports, "default", () => $f35d4af38035f678$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5337e08f4a6e3693b40b3f92c8241db8>>
 * @relayHash bc0a11e2d247719800de1eb6e77c7c87
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 12730951e32e781c2e6ae674a94e143040f31ada508e9e2b7d53cf86f2aea40f
const $f35d4af38035f678$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "JiraCascadingSelectFieldPayload",
                    "kind": "LinkedField",
                    "name": "updateCascadingSelectField",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "cascadingSelectField_Mutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "cascadingSelectField_Mutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "12730951e32e781c2e6ae674a94e143040f31ada508e9e2b7d53cf86f2aea40f",
            "metadata": {},
            "name": "cascadingSelectField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$f35d4af38035f678$var$node.hash = "30c90a51c8447b75fc86baef709bc308";
var $f35d4af38035f678$export$2e2bcd8739ae039 = $f35d4af38035f678$var$node;

});


parcelRegister("4UjyI", function(module, exports) {

$parcel$export(module.exports, "createClipboardHelperComponent", () => $8ccc65698593f46d$export$6ac5565d32c446cd);

var $5uXOq = parcelRequire("5uXOq");
const $8ccc65698593f46d$export$6ac5565d32c446cd = (useFieldPasteHandler)=>({ issue: issue, field: field, clipboardItem: clipboardItem, metadata: metadata, action: action, onBeforeAction: onBeforeAction, onComplete: onComplete, onContentReady: onContentReady })=>{
        const [hasBeenCalled, setHasBeenCalled] = (0, $5uXOq.useState)(false);
        const { contentToCopy: contentToCopy, copyHandler: copyHandler, pasteHandler: pasteHandler, cutHandler: cutHandler } = useFieldPasteHandler(issue, field);
        (0, $5uXOq.useEffect)(()=>{
            async function handlePrepareToCopy() {
                if (!contentToCopy || !onContentReady) return;
                try {
                    onContentReady(contentToCopy);
                    onComplete(true);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    onComplete(false, error);
                }
            }
            if (action === 'prepare-to-copy') handlePrepareToCopy();
        }, [
            onComplete,
            hasBeenCalled,
            action,
            copyHandler,
            contentToCopy,
            onContentReady
        ]);
        (0, $5uXOq.useEffect)(()=>{
            async function handlePaste() {
                if (!clipboardItem || hasBeenCalled) return;
                setHasBeenCalled(true);
                onBeforeAction?.();
                try {
                    await pasteHandler(clipboardItem, metadata);
                    onComplete(true);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    onComplete(false, error);
                }
            }
            if (action === 'paste') handlePaste();
        }, [
            clipboardItem,
            onComplete,
            pasteHandler,
            metadata,
            hasBeenCalled,
            action,
            onBeforeAction
        ]);
        (0, $5uXOq.useEffect)(()=>{
            async function handleCutOnly() {
                if (hasBeenCalled) return;
                setHasBeenCalled(true);
                try {
                    await cutHandler();
                    onComplete(true);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    onComplete(false, error);
                }
            }
            if (action === 'cut-only') handleCutOnly();
        }, [
            clipboardItem,
            onComplete,
            cutHandler,
            metadata,
            hasBeenCalled,
            action,
            onBeforeAction,
            copyHandler
        ]);
        return null;
    };

});

parcelRegister("ks0ly", function(module, exports) {

$parcel$export(module.exports, "useClipboardHandler", () => $2321e17aa8b25bd2$export$bc92cd7bfdca2774);

var $5uXOq = parcelRequire("5uXOq");

var $bj6Oi = parcelRequire("bj6Oi");

var $2NMNM = parcelRequire("2NMNM");

var $1xoxe = parcelRequire("1xoxe");

var $3O2T0 = parcelRequire("3O2T0");
function $2321e17aa8b25bd2$export$bc92cd7bfdca2774({ issue: issue, field: field, currentStringValue: currentStringValue, currentValue: currentValue, getPastedValue: getPastedValue, saveValue: saveValue, emptyValue: emptyValue }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const getContentToCopy = (0, $5uXOq.useCallback)(()=>(0, $3O2T0.getFieldValueAsClipboardItem)(field, issue, currentStringValue, currentValue), [
        currentStringValue,
        currentValue,
        field,
        issue
    ]);
    const [contentToCopy, setContentToCopy] = (0, $5uXOq.useState)(getContentToCopy);
    (0, $5uXOq.useEffect)(()=>{
        if (contentToCopy?.html !== getContentToCopy()?.html) setContentToCopy(getContentToCopy());
    }, [
        getContentToCopy,
        contentToCopy
    ]);
    const copyHandler = (0, $5uXOq.useCallback)(async ()=>{
        const { html: html, plainText: plainText } = (0, $3O2T0.getFieldValueAsClipboardItem)(field, issue, currentStringValue, currentValue);
        if (!plainText || !html) throw new (0, $bj6Oi.ClientSideValidationError)((0, $1xoxe.VALIDATION_ERROR_CODES).NULL_GETTER);
        await (0, $3O2T0.addToClipboard)(plainText, html);
    }, [
        currentStringValue,
        currentValue,
        field,
        issue
    ]);
    const pasteHandler = (0, $5uXOq.useCallback)(async (clipboardItem, metadata)=>{
        const value = getPastedValue(clipboardItem, metadata);
        if (!value || Array.isArray(value) && !value.length) throw new (0, $bj6Oi.ClientSideValidationError)((0, $1xoxe.VALIDATION_ERROR_CODES).EMPTY_CLIPBOARD);
        await saveValue(value, null, createAnalyticsEvent({}));
    }, [
        getPastedValue,
        saveValue,
        createAnalyticsEvent
    ]);
    const cutHandler = (0, $5uXOq.useCallback)(async ()=>{
        await saveValue(emptyValue ?? null, null, createAnalyticsEvent({}));
    }, [
        saveValue,
        emptyValue,
        createAnalyticsEvent
    ]);
    return {
        contentToCopy: contentToCopy,
        copyHandler: copyHandler,
        pasteHandler: pasteHandler,
        cutHandler: cutHandler
    };
}

});
parcelRegister("3O2T0", function(module, exports) {

$parcel$export(module.exports, "assertClipboardHasPlainTextFormat", () => $c7bbbd6441a8af75$export$4f1e704a7a6a6107);
$parcel$export(module.exports, "assertClipboardHasRichFormat", () => $c7bbbd6441a8af75$export$acf1aef2ce2e9ad4);
$parcel$export(module.exports, "assertClipboardDataIsCompatible", () => $c7bbbd6441a8af75$export$4957d49d1a7a1b9e);
$parcel$export(module.exports, "getFieldValueAsClipboardItem", () => $c7bbbd6441a8af75$export$7afe662a0eda30a6);
$parcel$export(module.exports, "addToClipboard", () => $c7bbbd6441a8af75$export$89af511f3acca517);
$parcel$export(module.exports, "getCellValue", () => $c7bbbd6441a8af75$export$b1f6fa0c5f374def);

var $bj6Oi = parcelRequire("bj6Oi");

var $4R6GH = parcelRequire("4R6GH");

var $9mWE9 = parcelRequire("9mWE9");

var $1xoxe = parcelRequire("1xoxe");
function $c7bbbd6441a8af75$export$4f1e704a7a6a6107(clipboardItem) {
    if (!clipboardItem?.plainText) throw new (0, $bj6Oi.ClientSideValidationError)((0, $1xoxe.VALIDATION_ERROR_CODES).EMPTY_CLIPBOARD);
    return true;
}
function $c7bbbd6441a8af75$export$acf1aef2ce2e9ad4(clipboardItem) {
    $c7bbbd6441a8af75$export$4f1e704a7a6a6107(clipboardItem);
    if (!clipboardItem?.html) throw new (0, $bj6Oi.ClientSideValidationError)((0, $1xoxe.VALIDATION_ERROR_CODES).NON_COMPATIBLE_FIELD_TYPE);
    return true;
}
function $c7bbbd6441a8af75$export$4957d49d1a7a1b9e(metadata, compatibleTypes) {
    if (!metadata?.fieldType || !compatibleTypes.includes(metadata?.fieldType)) throw new (0, $bj6Oi.ClientSideValidationError)((0, $1xoxe.VALIDATION_ERROR_CODES).NON_COMPATIBLE_FIELD_TYPE);
    return true;
}
function $c7bbbd6441a8af75$var$getStringifiedRichFieldValue(richValue) {
    if (!richValue) return null;
    if (typeof richValue === 'string') return {
        value: richValue
    };
    return richValue;
}
const $c7bbbd6441a8af75$var$safelyAddRichValueToHtml = (html, richValue)=>{
    try {
        const DOM = new DOMParser().parseFromString(html, 'text/html');
        DOM.body?.querySelector('div')?.setAttribute('data-field-value', JSON.stringify(richValue));
        return DOM.body?.innerHTML || '';
    } catch (e) {
        return html;
    }
};
function $c7bbbd6441a8af75$export$7afe662a0eda30a6(field, issue, textValue, value) {
    const richValue = $c7bbbd6441a8af75$var$getStringifiedRichFieldValue(value);
    if (!textValue) return {};
    const html = `<div data-type="list-cell" data-issue-type-level="${issue?.issueType?.level}" data-field-id="${field.fieldId}" data-field-type="${field.type}">${textValue}</div>`;
    return {
        html: richValue ? $c7bbbd6441a8af75$var$safelyAddRichValueToHtml(html, richValue) : html,
        plainText: textValue
    };
}
const $c7bbbd6441a8af75$export$89af511f3acca517 = (plainText, html)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const blobPlain = new window.Blob([
        plainText
    ], {
        type: 'text/plain'
    });
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const blobHTML = new window.Blob([
        html
    ], {
        type: 'text/html'
    });
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const clipboardItem = new window.ClipboardItem({
        'text/html': blobHTML,
        'text/plain': blobPlain
    });
    return (0, $4R6GH.fg)('jfp-magma-undefined-navigator') ? globalThis.navigator.clipboard.write([
        clipboardItem
    ]) : navigator.clipboard.write([
        clipboardItem
    ]); // eslint-disable-line jira/jira-ssr/no-unchecked-globals-usage
};
const $c7bbbd6441a8af75$export$b1f6fa0c5f374def = (field, issue, formatMessage)=>{
    const textValue = (0, $9mWE9.getStringValue)(field.type, field, formatMessage);
    const richValue = $c7bbbd6441a8af75$var$getStringifiedRichFieldValue((0, $9mWE9.getRichOrStringValue)(field.type, field));
    if (!textValue) return {};
    const html = `<div data-type="list-cell" data-issue-type-level="${issue?.issueType?.level}" data-field-id="${field.fieldId}" data-field-type="${field.type}">${textValue}</div>`;
    return {
        html: richValue ? $c7bbbd6441a8af75$var$safelyAddRichValueToHtml(html, richValue) : html,
        plainText: textValue
    };
};

});
parcelRegister("9mWE9", function(module, exports) {

$parcel$export(module.exports, "getStringValue", () => $6e5ff40d78ee90c0$export$5da374e426806c6a);
$parcel$export(module.exports, "isStringValueSupported", () => $6e5ff40d78ee90c0$export$c7e2e8fb7867bf39);
$parcel$export(module.exports, "getRichOrStringValue", () => $6e5ff40d78ee90c0$export$efe475f7dd73bf7c);
// Used in for bulk copy

var $8QpSo = parcelRequire("8QpSo");

var $jKNTt = parcelRequire("jKNTt");

var $hnYsi = parcelRequire("hnYsi");

var $bkhZT = parcelRequire("bkhZT");

var $4ckl0 = parcelRequire("4ckl0");

var $9FPlx = parcelRequire("9FPlx");

var $j0kCu = parcelRequire("j0kCu");

var $4436V = parcelRequire("4436V");

var $4r55J = parcelRequire("4r55J");

var $1q6eD = parcelRequire("1q6eD");

var $k0gwt = parcelRequire("k0gwt");

var $8oWyK = parcelRequire("8oWyK");

var $3ebyg = parcelRequire("3ebyg");

var $lDYU1 = parcelRequire("lDYU1");

var $iPTHj = parcelRequire("iPTHj");

var $a7Aen = parcelRequire("a7Aen");

var $6IPMF = parcelRequire("6IPMF");

var $cNLaA = parcelRequire("cNLaA");

var $ha4No = parcelRequire("ha4No");

var $7T77A = parcelRequire("7T77A");

var $kIloX = parcelRequire("kIloX");

var $6sBiS = parcelRequire("6sBiS");

var $bv3n4 = parcelRequire("bv3n4");

var $eVlry = parcelRequire("eVlry");

var $fD5gp = parcelRequire("fD5gp");

var $gaDgh = parcelRequire("gaDgh");

var $6NkwW = parcelRequire("6NkwW");

var $ayYAS = parcelRequire("ayYAS");

var $4q3hR = parcelRequire("4q3hR");

var $4OYfI = parcelRequire("4OYfI");

var $55rRx = parcelRequire("55rRx");
const $6e5ff40d78ee90c0$var$createStringValueHandlers = (0, $8QpSo.default)(()=>({
        ...(0, $hnYsi.categoryStringValueHandler),
        ...(0, $bkhZT.checkboxStringValueHandler),
        ...(0, $4ckl0.componentsStringValueHandler),
        ...(0, $55rRx.versionStringValueHandler),
        ...(0, $iPTHj.parentStringValueHandler),
        ...(0, $4436V.devSummaryStringValueHandler),
        ...(0, $8oWyK.labelsStringValueHandler),
        ...(0, $lDYU1.numberStringValueHandler),
        ...(0, $k0gwt.keyStringValueHandler),
        ...(0, $ayYAS.typeStringValueHandler),
        ...(0, $4OYfI.userStringValueHandler),
        ...(0, $fD5gp.teamStringValueHandler),
        ...(0, $1q6eD.groupStringValueHandler),
        ...(0, $ha4No.resolutionStringValueHandler),
        ...(0, $j0kCu.dateTimeStringValueHandler),
        ...(0, $9FPlx.dateStringValueHandler),
        ...(0, $4r55J.goalStringValueHandler),
        ...(0, $gaDgh.textStringValueHandler),
        ...(0, $a7Aen.priorityStringValueHandler),
        ...(0, $cNLaA.radioSelectStringValueHandler),
        ...(0, $4q3hR.urlStringValueHandler),
        ...(0, $3ebyg.multiSelectStringValueHandler),
        ...(0, $eVlry.statusStringValueHandler),
        ...(0, $bv3n4.statusCategoryStringValueHandler),
        ...(0, $6NkwW.timeTrackingStringValueHandler),
        ...(0, $kIloX.singleSelectStringValueHandler),
        ...(0, $6sBiS.sprintStringValueHandler),
        ...(0, $7T77A.richTextStringValueHandler),
        ...(0, $6IPMF.projectStringValueHandler),
        ...(0, $jKNTt.cascadingSelectStringValueHandler)
    }));
const $6e5ff40d78ee90c0$export$5da374e426806c6a = (fieldType, ...args)=>{
    const handlers = $6e5ff40d78ee90c0$var$createStringValueHandlers();
    if (handlers[fieldType] == null) return;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return handlers[fieldType]?.(...args);
};
const $6e5ff40d78ee90c0$export$c7e2e8fb7867bf39 = (fieldType)=>{
    const handlers = $6e5ff40d78ee90c0$var$createStringValueHandlers();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return handlers[fieldType] != null;
};
const $6e5ff40d78ee90c0$var$createRichValueHandlers = (0, $8QpSo.default)(()=>({
        ...(0, $hnYsi.categoryRichValueHandler),
        ...(0, $bkhZT.checkboxRichValueHandler),
        ...(0, $4ckl0.componentsRichValueHandler),
        ...(0, $4OYfI.userRichValueHandler),
        ...(0, $55rRx.versionRichValueHandler),
        ...(0, $a7Aen.priorityRichValueHandler),
        ...(0, $3ebyg.multiSelectRichValueHandler),
        ...(0, $kIloX.singleSelectRichValueHandler),
        ...(0, $6sBiS.sprintRichValueHandler),
        ...(0, $iPTHj.parentRichValueHandler),
        ...(0, $fD5gp.teamRichValueHandler),
        ...(0, $6IPMF.projectRichValueHandler),
        ...(0, $1q6eD.groupRichValueHandler),
        ...(0, $jKNTt.cascadingSelectRichValueHandler),
        ...(0, $cNLaA.radioSelectRichValueHandler)
    }));
const $6e5ff40d78ee90c0$export$3c808f0df8be4abb = (fieldType)=>{
    const handlers = $6e5ff40d78ee90c0$var$createRichValueHandlers();
    if (fieldType in handlers) return true;
    return false;
};
const $6e5ff40d78ee90c0$export$efe475f7dd73bf7c = (fieldType, ...args)=>{
    const handlers = $6e5ff40d78ee90c0$var$createRichValueHandlers();
    if ($6e5ff40d78ee90c0$export$3c808f0df8be4abb(fieldType)) return(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    handlers[fieldType]?.(...args));
    return $6e5ff40d78ee90c0$export$5da374e426806c6a(fieldType, ...args);
};

});
parcelRegister("hnYsi", function(module, exports) {

$parcel$export(module.exports, "categoryStringValueHandler", () => $1b891cb4842f6194$export$648bd4153bebf5ec);
$parcel$export(module.exports, "categoryRichValueHandler", () => $1b891cb4842f6194$export$c7c1e80cbae33846);

var $5fc53 = parcelRequire("5fc53");
const $1b891cb4842f6194$var$getCategoryStringValue = (field)=>String(field.value?.value ?? '');
const $1b891cb4842f6194$export$648bd4153bebf5ec = {
    [(0, $5fc53.CATEGORY_TYPE)]: $1b891cb4842f6194$var$getCategoryStringValue
};
const $1b891cb4842f6194$var$getCategoryRichValue = (field)=>field.value ?? null;
const $1b891cb4842f6194$export$c7c1e80cbae33846 = {
    [(0, $5fc53.CATEGORY_TYPE)]: $1b891cb4842f6194$var$getCategoryRichValue
};

});

parcelRegister("bkhZT", function(module, exports) {

$parcel$export(module.exports, "checkboxStringValueHandler", () => $46beb28657e205e5$export$e8595eb8b08dfff6);
$parcel$export(module.exports, "checkboxRichValueHandler", () => $46beb28657e205e5$export$8c6878c535c99dc0);

var $5fc53 = parcelRequire("5fc53");
const $46beb28657e205e5$var$getCheckboxValue = (field)=>String(field.value?.map((option)=>option?.value || '').join(', ') || '');
const $46beb28657e205e5$export$e8595eb8b08dfff6 = {
    [(0, $5fc53.MULTI_CHECKBOXES_CF_TYPE)]: $46beb28657e205e5$var$getCheckboxValue
};
const $46beb28657e205e5$var$getCheckboxRichValue = (field)=>field.value ?? [];
const $46beb28657e205e5$export$8c6878c535c99dc0 = {
    [(0, $5fc53.MULTI_CHECKBOXES_CF_TYPE)]: $46beb28657e205e5$var$getCheckboxRichValue
};

});

parcelRegister("4ckl0", function(module, exports) {

$parcel$export(module.exports, "componentsStringValueHandler", () => $cea76a4879655623$export$8c05fcecf4920250);
$parcel$export(module.exports, "componentsRichValueHandler", () => $cea76a4879655623$export$22a98ba00b45930);

var $5fc53 = parcelRequire("5fc53");
const $cea76a4879655623$var$getComponentsStringValue = (field)=>String(field.value?.map((option)=>option?.name ?? '').join(', ') ?? '');
const $cea76a4879655623$export$8c05fcecf4920250 = {
    [(0, $5fc53.COMPONENTS_TYPE)]: $cea76a4879655623$var$getComponentsStringValue
};
const $cea76a4879655623$var$getComponentsRichValue = (field)=>field.value ?? [];
const $cea76a4879655623$export$22a98ba00b45930 = {
    [(0, $5fc53.COMPONENTS_TYPE)]: $cea76a4879655623$var$getComponentsRichValue
};

});

parcelRegister("9FPlx", function(module, exports) {

$parcel$export(module.exports, "dateStringValueHandler", () => $4da089b6762dd39d$export$e35cf2b38b82bde);

var $k7m40 = parcelRequire("k7m40");

var $5fc53 = parcelRequire("5fc53");
const $4da089b6762dd39d$var$getDateValue = (field)=>{
    if (field.value && (field.type === (0, $5fc53.CREATED) || field.type === (0, $5fc53.UPDATED))) return (0, $k7m40.default)(new Date(field.value), 'yyyy-MM-dd');
    return field.value || '';
};
const $4da089b6762dd39d$export$e35cf2b38b82bde = {
    [(0, $5fc53.START_DATE_TYPE)]: $4da089b6762dd39d$var$getDateValue,
    [(0, $5fc53.UPDATED)]: $4da089b6762dd39d$var$getDateValue,
    [(0, $5fc53.CREATED)]: $4da089b6762dd39d$var$getDateValue,
    [(0, $5fc53.DUE_DATE_TYPE)]: $4da089b6762dd39d$var$getDateValue,
    [(0, $5fc53.DATE_CF_TYPE)]: $4da089b6762dd39d$var$getDateValue
};

});

parcelRegister("j0kCu", function(module, exports) {

$parcel$export(module.exports, "dateTimeStringValueHandler", () => $9ef6e18d548be661$export$3364b5b1994fef68);

var $5fc53 = parcelRequire("5fc53");
const $9ef6e18d548be661$var$getDateTimeValue = (field)=>field.value || '';
const $9ef6e18d548be661$export$3364b5b1994fef68 = {
    [(0, $5fc53.DATETIME_CF_TYPE)]: $9ef6e18d548be661$var$getDateTimeValue
};

});

parcelRegister("4436V", function(module, exports) {

$parcel$export(module.exports, "devSummaryStringValueHandler", () => $b2aa768b91edea85$export$92f03a013990abef);

var $5fc53 = parcelRequire("5fc53");

var $jTRqe = parcelRequire("jTRqe");
const $b2aa768b91edea85$var$getDevSummaryValue = (field, formatMessage)=>{
    if (formatMessage && field) {
        if (field.isMerged) return formatMessage((0, $jTRqe.default).merged);
        if (field.isUnderReview) return formatMessage((0, $jTRqe.default).underReview);
        if (field.commitCount) return formatMessage((0, $jTRqe.default).commit, {
            count: field.commitCount
        });
    }
    return '';
};
const $b2aa768b91edea85$export$92f03a013990abef = {
    [(0, $5fc53.DEV_SUMMARY_CF_TYPE)]: $b2aa768b91edea85$var$getDevSummaryValue
};

});
parcelRegister("jTRqe", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d9a7893539a3bb7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9d9a7893539a3bb7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    underReview: {
        "id": "business-fields.common.field-types.dev-summary.value.under-review",
        "defaultMessage": "Under review"
    },
    merged: {
        "id": "business-fields.common.field-types.dev-summary.value.merged",
        "defaultMessage": "Merged"
    },
    commit: {
        "id": "business-fields.common.field-types.dev-summary.value.commit",
        "defaultMessage": "{count, plural, one {# commit} other {# commits}}"
    }
});

});


parcelRegister("4r55J", function(module, exports) {

$parcel$export(module.exports, "goalStringValueHandler", () => $435d98029b25b04d$export$fc09a341d50e572e);

var $5fc53 = parcelRequire("5fc53");
const $435d98029b25b04d$export$75c4ea7a4006e4cc = (fieldValue)=>{
    // we only keep the first goal object in the store (field value)
    const goalsStringValue = fieldValue.goals.map((goal)=>goal.name).join(', ');
    const remainingCount = fieldValue.totalCount - fieldValue.goals.length;
    if (remainingCount > 0) return `${goalsStringValue} +${remainingCount}`;
    return goalsStringValue;
};
const $435d98029b25b04d$var$getGoalsSelectValue = (field)=>$435d98029b25b04d$export$75c4ea7a4006e4cc(field.value);
const $435d98029b25b04d$export$fc09a341d50e572e = {
    [(0, $5fc53.GOALS_CF_TYPE)]: $435d98029b25b04d$var$getGoalsSelectValue
};

});

parcelRegister("1q6eD", function(module, exports) {

$parcel$export(module.exports, "groupStringValueHandler", () => $3a1a62e1b381c27a$export$520e19bcc394328a);
$parcel$export(module.exports, "groupRichValueHandler", () => $3a1a62e1b381c27a$export$2df4c615ae11e379);

var $5fc53 = parcelRequire("5fc53");
const $3a1a62e1b381c27a$var$getSingleGroupValue = (field)=>field.value?.name ?? '';
const $3a1a62e1b381c27a$var$getMultipleGroupValue = (field)=>field.value == null ? '' : field.value.map((v)=>v?.name).join(',');
const $3a1a62e1b381c27a$var$getSingleGroupRichValue = (field)=>field.value ?? null;
const $3a1a62e1b381c27a$var$getMultipleGroupRichValue = (field)=>field.value ?? [];
const $3a1a62e1b381c27a$export$520e19bcc394328a = {
    [(0, $5fc53.GROUP_CF_TYPE)]: $3a1a62e1b381c27a$var$getSingleGroupValue,
    [(0, $5fc53.MULTI_GROUP_CF_TYPE)]: $3a1a62e1b381c27a$var$getMultipleGroupValue
};
const $3a1a62e1b381c27a$export$2df4c615ae11e379 = {
    [(0, $5fc53.GROUP_CF_TYPE)]: $3a1a62e1b381c27a$var$getSingleGroupRichValue,
    [(0, $5fc53.MULTI_GROUP_CF_TYPE)]: $3a1a62e1b381c27a$var$getMultipleGroupRichValue
};

});

parcelRegister("k0gwt", function(module, exports) {

$parcel$export(module.exports, "keyStringValueHandler", () => $4ab5244b7319c856$export$6a82d6d16aaf1aae);
const $4ab5244b7319c856$var$getKeyValue = (field)=>String(field.value || '');
const $4ab5244b7319c856$export$6a82d6d16aaf1aae = {
    key: $4ab5244b7319c856$var$getKeyValue
};

});

parcelRegister("8oWyK", function(module, exports) {

$parcel$export(module.exports, "labelsStringValueHandler", () => $444aac30a5c82b3f$export$614150a18e87c3e9);

var $5fc53 = parcelRequire("5fc53");
const $444aac30a5c82b3f$var$getLabelsValue = (field)=>String(field.value.join(', ') || '');
const $444aac30a5c82b3f$export$614150a18e87c3e9 = {
    [(0, $5fc53.LABELS_TYPE)]: $444aac30a5c82b3f$var$getLabelsValue,
    [(0, $5fc53.LABELS_CF_TYPE)]: $444aac30a5c82b3f$var$getLabelsValue
};

});

parcelRegister("3ebyg", function(module, exports) {

$parcel$export(module.exports, "multiSelectStringValueHandler", () => $f30130b65ee57709$export$a8b18450ad254ab4);
$parcel$export(module.exports, "multiSelectRichValueHandler", () => $f30130b65ee57709$export$5b873e39c38cc9ad);

var $5fc53 = parcelRequire("5fc53");
const $f30130b65ee57709$var$getMultiSelectStringValue = (field)=>String(field.value?.map((option)=>option?.value ?? '').join(', ') ?? '');
const $f30130b65ee57709$export$a8b18450ad254ab4 = {
    [(0, $5fc53.MULTI_SELECT_CF_TYPE)]: $f30130b65ee57709$var$getMultiSelectStringValue
};
const $f30130b65ee57709$var$getMultiSelectRichValue = (field)=>field.value ?? [];
const $f30130b65ee57709$export$5b873e39c38cc9ad = {
    [(0, $5fc53.MULTI_SELECT_CF_TYPE)]: $f30130b65ee57709$var$getMultiSelectRichValue
};

});

parcelRegister("lDYU1", function(module, exports) {

$parcel$export(module.exports, "numberStringValueHandler", () => $c17bd39a28c9b001$export$e0e13344aaa5277f);

var $5fc53 = parcelRequire("5fc53");
const $c17bd39a28c9b001$var$getNumberValue = (field)=>String(field.value || '');
const $c17bd39a28c9b001$export$e0e13344aaa5277f = {
    [(0, $5fc53.NUMBER_CF_TYPE)]: $c17bd39a28c9b001$var$getNumberValue,
    [(0, $5fc53.STORY_POINTS_TYPE)]: $c17bd39a28c9b001$var$getNumberValue,
    [(0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE)]: $c17bd39a28c9b001$var$getNumberValue
};

});

parcelRegister("iPTHj", function(module, exports) {

$parcel$export(module.exports, "parentStringValueHandler", () => $c4c1a0f4617bd749$export$c53efd3fefacccdb);
$parcel$export(module.exports, "parentRichValueHandler", () => $c4c1a0f4617bd749$export$bd920f00473058fd);

var $5fc53 = parcelRequire("5fc53");
const $c4c1a0f4617bd749$var$getParentValue = (field)=>field.value ? field.value.issueKey : '';
const $c4c1a0f4617bd749$export$c53efd3fefacccdb = {
    [(0, $5fc53.PARENT_TYPE)]: $c4c1a0f4617bd749$var$getParentValue
};
const $c4c1a0f4617bd749$var$getParentRichValue = (field)=>field.value ?? null;
const $c4c1a0f4617bd749$export$bd920f00473058fd = {
    [(0, $5fc53.PARENT_TYPE)]: $c4c1a0f4617bd749$var$getParentRichValue
};

});

parcelRegister("a7Aen", function(module, exports) {

$parcel$export(module.exports, "priorityStringValueHandler", () => $3673cf72ee9bcf66$export$2fcd34cd217ed0e0);
$parcel$export(module.exports, "priorityRichValueHandler", () => $3673cf72ee9bcf66$export$74a600c7fe980807);

var $5fc53 = parcelRequire("5fc53");
const $3673cf72ee9bcf66$var$isNewTransformedPriorityField = (field)=>typeof field.value === 'object' && 'name' in (field.value || {});
const $3673cf72ee9bcf66$var$isOldTransformedPriorityField = (field)=>typeof field.value === 'string';
const $3673cf72ee9bcf66$var$getPriorityValue = (field)=>{
    if ($3673cf72ee9bcf66$var$isNewTransformedPriorityField(field)) return field.value?.name || '';
    if ($3673cf72ee9bcf66$var$isOldTransformedPriorityField(field)) return field.value;
    return '';
};
const $3673cf72ee9bcf66$export$2fcd34cd217ed0e0 = {
    [(0, $5fc53.PRIORITY_TYPE)]: $3673cf72ee9bcf66$var$getPriorityValue
};
const $3673cf72ee9bcf66$var$getPriorityRichValue = (field)=>field.value || null;
const $3673cf72ee9bcf66$export$74a600c7fe980807 = {
    [(0, $5fc53.PRIORITY_TYPE)]: $3673cf72ee9bcf66$var$getPriorityRichValue
};

});

parcelRegister("6IPMF", function(module, exports) {

$parcel$export(module.exports, "projectStringValueHandler", () => $542d9437b6783744$export$ac54e893c65fec32);
$parcel$export(module.exports, "projectRichValueHandler", () => $542d9437b6783744$export$24de57791a81b4b0);

var $5fc53 = parcelRequire("5fc53");
const $542d9437b6783744$var$getProjectValue = (field)=>field.value?.name ?? '';
const $542d9437b6783744$export$ac54e893c65fec32 = {
    [(0, $5fc53.PROJECT_PICKER_CF_TYPE)]: $542d9437b6783744$var$getProjectValue
};
const $542d9437b6783744$var$getProjectRichValue = (field)=>field.value ?? null;
const $542d9437b6783744$export$24de57791a81b4b0 = {
    [(0, $5fc53.PROJECT_PICKER_CF_TYPE)]: $542d9437b6783744$var$getProjectRichValue
};

});

parcelRegister("cNLaA", function(module, exports) {

$parcel$export(module.exports, "radioSelectStringValueHandler", () => $43d3560737b9942f$export$5716e87f97e42f22);
$parcel$export(module.exports, "radioSelectRichValueHandler", () => $43d3560737b9942f$export$c28597602359ee5);

var $5fc53 = parcelRequire("5fc53");
const $43d3560737b9942f$var$getRadioSelectValue = (field)=>field.value?.value ?? '';
const $43d3560737b9942f$export$5716e87f97e42f22 = {
    [(0, $5fc53.RADIO_BUTTONS_CF_TYPE)]: $43d3560737b9942f$var$getRadioSelectValue
};
const $43d3560737b9942f$var$getRadioSelectRichValue = (field)=>field.value ?? null;
const $43d3560737b9942f$export$c28597602359ee5 = {
    [(0, $5fc53.RADIO_BUTTONS_CF_TYPE)]: $43d3560737b9942f$var$getRadioSelectRichValue
};

});

parcelRegister("ha4No", function(module, exports) {

$parcel$export(module.exports, "resolutionStringValueHandler", () => $5582bb0e1df9d6cf$export$ce4b64838599caf9);

var $5fc53 = parcelRequire("5fc53");

var $k8BN5 = parcelRequire("k8BN5");
const $5582bb0e1df9d6cf$var$getResolutionValue = (field, formatMessage)=>{
    if (field.value?.name) return field.value?.name;
    return formatMessage ? formatMessage((0, $k8BN5.default).unresolvedResolution) : '';
};
const $5582bb0e1df9d6cf$export$ce4b64838599caf9 = {
    [(0, $5fc53.RESOLUTION_TYPE)]: $5582bb0e1df9d6cf$var$getResolutionValue
};

});
parcelRegister("k8BN5", function(module, exports) {

$parcel$export(module.exports, "default", () => $3602b5c2c6ac20d9$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3602b5c2c6ac20d9$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    unresolvedResolution: {
        "id": "business-fields.common.field-types.resolution.value.unresolved-resolution",
        "defaultMessage": "Unresolved"
    }
});

});


parcelRegister("7T77A", function(module, exports) {

$parcel$export(module.exports, "richTextStringValueHandler", () => $f6dcab5e3bea46a6$export$b6df34212c07f1f3);

var $5fc53 = parcelRequire("5fc53");
const $f6dcab5e3bea46a6$var$getStringValue = (field)=>String(field.value || '');
const $f6dcab5e3bea46a6$export$b6df34212c07f1f3 = {
    [(0, $5fc53.TEXT_AREA_CF_TYPE)]: $f6dcab5e3bea46a6$var$getStringValue
};

});

parcelRegister("kIloX", function(module, exports) {

$parcel$export(module.exports, "singleSelectStringValueHandler", () => $579e3ef3b403676c$export$6477cb7a98167465);
$parcel$export(module.exports, "singleSelectRichValueHandler", () => $579e3ef3b403676c$export$8f1681f1304731e9);

var $5fc53 = parcelRequire("5fc53");
const $579e3ef3b403676c$var$getSingleSelectValue = (field)=>String(field.value?.value || '');
const $579e3ef3b403676c$export$6477cb7a98167465 = {
    [(0, $5fc53.SELECT_CF_TYPE)]: $579e3ef3b403676c$var$getSingleSelectValue
};
const $579e3ef3b403676c$var$getSingleSelectRichValue = (field)=>field.value || null;
const $579e3ef3b403676c$export$8f1681f1304731e9 = {
    [(0, $5fc53.SELECT_CF_TYPE)]: $579e3ef3b403676c$var$getSingleSelectRichValue
};

});

parcelRegister("6sBiS", function(module, exports) {

$parcel$export(module.exports, "sprintStringValueHandler", () => $9a4dceb1207c7cf8$export$c934a6ef333435f4);
$parcel$export(module.exports, "sprintRichValueHandler", () => $9a4dceb1207c7cf8$export$363144cf26cab14d);

var $5fc53 = parcelRequire("5fc53");
const $9a4dceb1207c7cf8$var$getSprintStringValue = (field)=>String(field.value?.map((option)=>option?.name ?? '').join(', ') ?? '');
const $9a4dceb1207c7cf8$export$c934a6ef333435f4 = {
    [(0, $5fc53.SPRINT_TYPE)]: $9a4dceb1207c7cf8$var$getSprintStringValue
};
const $9a4dceb1207c7cf8$var$getSprintRichValue = (field)=>field.value ?? [];
const $9a4dceb1207c7cf8$export$363144cf26cab14d = {
    [(0, $5fc53.SPRINT_TYPE)]: $9a4dceb1207c7cf8$var$getSprintRichValue
};

});

parcelRegister("bv3n4", function(module, exports) {

$parcel$export(module.exports, "statusCategoryStringValueHandler", () => $41eba0e4a35a010c$export$fbf872252a7f1d2d);

var $5fc53 = parcelRequire("5fc53");
const $41eba0e4a35a010c$var$getStatusCategoryValue = (field)=>field.value?.name ?? '';
const $41eba0e4a35a010c$export$fbf872252a7f1d2d = {
    [(0, $5fc53.STATUS_CATEGORY_TYPE)]: $41eba0e4a35a010c$var$getStatusCategoryValue
};

});

parcelRegister("eVlry", function(module, exports) {

$parcel$export(module.exports, "statusStringValueHandler", () => $9a139c828513cd4a$export$237f3a01398656da);

var $5fc53 = parcelRequire("5fc53");
const $9a139c828513cd4a$var$getStatusValue = (field)=>String(field.name || '');
const $9a139c828513cd4a$export$237f3a01398656da = {
    [(0, $5fc53.STATUS_TYPE)]: $9a139c828513cd4a$var$getStatusValue
};

});

parcelRegister("fD5gp", function(module, exports) {

$parcel$export(module.exports, "teamStringValueHandler", () => $d10084d34c71b8cd$export$b5a765abdc307683);
$parcel$export(module.exports, "teamRichValueHandler", () => $d10084d34c71b8cd$export$c73de7087af53cf7);

var $5fc53 = parcelRequire("5fc53");
const $d10084d34c71b8cd$var$getTeamValue = (field)=>field.value?.name ?? '';
const $d10084d34c71b8cd$export$b5a765abdc307683 = {
    [(0, $5fc53.TEAMS_PLATFORM_CF_TYPE)]: $d10084d34c71b8cd$var$getTeamValue
};
const $d10084d34c71b8cd$var$getTeamRichValue = (field)=>field.value ?? null;
const $d10084d34c71b8cd$export$c73de7087af53cf7 = {
    [(0, $5fc53.TEAMS_PLATFORM_CF_TYPE)]: $d10084d34c71b8cd$var$getTeamRichValue
};

});

parcelRegister("gaDgh", function(module, exports) {

$parcel$export(module.exports, "textStringValueHandler", () => $78fd0eaf044fb7cb$export$ec13eae086c24fc4);

var $5fc53 = parcelRequire("5fc53");
const $78fd0eaf044fb7cb$var$getTextValue = (field)=>String(field.value || '');
const $78fd0eaf044fb7cb$export$ec13eae086c24fc4 = {
    [(0, $5fc53.SUMMARY_TYPE)]: $78fd0eaf044fb7cb$var$getTextValue,
    [(0, $5fc53.TEXT_CF_TYPE)]: $78fd0eaf044fb7cb$var$getTextValue
};

});

parcelRegister("6NkwW", function(module, exports) {

$parcel$export(module.exports, "timeTrackingStringValueHandler", () => $820aa870fe03580c$export$d2867bf3f48fbaac);

var $5fc53 = parcelRequire("5fc53");
const $820aa870fe03580c$var$getStringValue = (field)=>field.value?.timeAsString || '';
const $820aa870fe03580c$export$d2867bf3f48fbaac = {
    [(0, $5fc53.TIME_ESTIMATE_TYPE)]: $820aa870fe03580c$var$getStringValue
};

});

parcelRegister("ayYAS", function(module, exports) {

$parcel$export(module.exports, "typeStringValueHandler", () => $4822c57804ac4083$export$8a5121728c374439);

var $5fc53 = parcelRequire("5fc53");
const $4822c57804ac4083$var$getTypeValue = (field)=>String(field.value || '');
const $4822c57804ac4083$export$8a5121728c374439 = {
    [(0, $5fc53.ISSUE_TYPE)]: $4822c57804ac4083$var$getTypeValue
};

});

parcelRegister("4q3hR", function(module, exports) {

$parcel$export(module.exports, "urlStringValueHandler", () => $cef1dc7a90fd274d$export$7f5de2e826ef2c21);

var $5fc53 = parcelRequire("5fc53");
const $cef1dc7a90fd274d$var$getUrlValue = (field)=>String(field.value || '');
const $cef1dc7a90fd274d$export$7f5de2e826ef2c21 = {
    [(0, $5fc53.URL_CF_TYPE)]: $cef1dc7a90fd274d$var$getUrlValue
};

});

parcelRegister("4OYfI", function(module, exports) {

$parcel$export(module.exports, "userStringValueHandler", () => $26297ec6841ed337$export$160c08a2783fe34b);
$parcel$export(module.exports, "userRichValueHandler", () => $26297ec6841ed337$export$5fad1a6b4b204395);

var $5fc53 = parcelRequire("5fc53");
const $26297ec6841ed337$var$getUserStringValue = (field)=>String(field.value?.name || '');
const $26297ec6841ed337$var$getUsersStringValue = (field)=>String(field.value.map((user)=>user?.name).join(', ') || '');
const $26297ec6841ed337$export$160c08a2783fe34b = {
    [(0, $5fc53.USER_CF_TYPE)]: $26297ec6841ed337$var$getUserStringValue,
    [(0, $5fc53.REPORTER_TYPE)]: $26297ec6841ed337$var$getUserStringValue,
    [(0, $5fc53.ASSIGNEE_TYPE)]: $26297ec6841ed337$var$getUserStringValue,
    [(0, $5fc53.MULTI_USER_CF_TYPE)]: $26297ec6841ed337$var$getUsersStringValue,
    [(0, $5fc53.PEOPLE_CF_TYPE)]: $26297ec6841ed337$var$getUsersStringValue
};
const $26297ec6841ed337$var$getUserRichValue = (field)=>field.value || null;
const $26297ec6841ed337$var$getUserListRichValue = (field)=>field.value || [];
const $26297ec6841ed337$export$5fad1a6b4b204395 = {
    [(0, $5fc53.USER_CF_TYPE)]: $26297ec6841ed337$var$getUserRichValue,
    [(0, $5fc53.REPORTER_TYPE)]: $26297ec6841ed337$var$getUserRichValue,
    [(0, $5fc53.ASSIGNEE_TYPE)]: $26297ec6841ed337$var$getUserRichValue,
    [(0, $5fc53.MULTI_USER_CF_TYPE)]: $26297ec6841ed337$var$getUserListRichValue,
    [(0, $5fc53.PEOPLE_CF_TYPE)]: $26297ec6841ed337$var$getUserListRichValue
};

});

parcelRegister("55rRx", function(module, exports) {

$parcel$export(module.exports, "versionStringValueHandler", () => $5fc1c692afc7905d$export$608329dccbc25996);
$parcel$export(module.exports, "versionRichValueHandler", () => $5fc1c692afc7905d$export$534995286ab15bde);

var $5fc53 = parcelRequire("5fc53");
const $5fc1c692afc7905d$var$getSingleVersionValue = (field)=>field.value?.name ?? '';
const $5fc1c692afc7905d$var$getMultipleVersionValue = (field)=>field.value == null ? '' : field.value.map((v)=>v.name).join(',');
const $5fc1c692afc7905d$var$getSingleVersionRichValue = (field)=>field.value ?? null;
const $5fc1c692afc7905d$var$getMultipleVersionRichValue = (field)=>field.value ?? [];
const $5fc1c692afc7905d$export$608329dccbc25996 = {
    [(0, $5fc53.VERSION_CF_TYPE)]: $5fc1c692afc7905d$var$getSingleVersionValue,
    [(0, $5fc53.MULTI_VERSION_CF_TYPE)]: $5fc1c692afc7905d$var$getMultipleVersionValue,
    [(0, $5fc53.FIX_VERSIONS_TYPE)]: $5fc1c692afc7905d$var$getMultipleVersionValue,
    [(0, $5fc53.AFFECTS_VERSIONS_TYPE)]: $5fc1c692afc7905d$var$getMultipleVersionValue
};
const $5fc1c692afc7905d$export$534995286ab15bde = {
    [(0, $5fc53.VERSION_CF_TYPE)]: $5fc1c692afc7905d$var$getSingleVersionRichValue,
    [(0, $5fc53.MULTI_VERSION_CF_TYPE)]: $5fc1c692afc7905d$var$getMultipleVersionRichValue,
    [(0, $5fc53.FIX_VERSIONS_TYPE)]: $5fc1c692afc7905d$var$getMultipleVersionRichValue,
    [(0, $5fc53.AFFECTS_VERSIONS_TYPE)]: $5fc1c692afc7905d$var$getMultipleVersionRichValue
};

});





parcelRegister("jhaRN", function(module, exports) {

$parcel$export(module.exports, "categoryClipboardHandler", () => $7aabea9eb9c86fb2$export$b2a7ae1b92d8afd3);

var $lQE94 = parcelRequire("lQE94");

var $5fc53 = parcelRequire("5fc53");

var $4UjyI = parcelRequire("4UjyI");

var $ks0ly = parcelRequire("ks0ly");

var $3O2T0 = parcelRequire("3O2T0");

var $9aWWe = parcelRequire("9aWWe");
const $7aabea9eb9c86fb2$var$isCategory = (fieldValue)=>fieldValue != null && typeof fieldValue === 'object' && 'value' in fieldValue && 'id' in fieldValue;
const $7aabea9eb9c86fb2$var$isTransformedCategory = (fieldValue)=>fieldValue != null && typeof fieldValue === 'object' && 'value' in fieldValue && 'optionId' in fieldValue;
const $7aabea9eb9c86fb2$var$getPastedValue = (clipboardItem, metadata)=>{
    if (!(0, $3O2T0.assertClipboardHasRichFormat)(clipboardItem) || !(0, $3O2T0.assertClipboardDataIsCompatible)(metadata, (0, $9aWWe.categorySupportedTypes))) return null;
    if (!$7aabea9eb9c86fb2$var$isCategory(metadata.fieldValue)) return null;
    return metadata.fieldValue;
};
const $7aabea9eb9c86fb2$var$useCategoryClipboardHandler = (issue, field)=>{
    const [{ value: value }, { saveValue: saveValue }] = (0, $lQE94.useEditField)({
        fieldKey: field.fieldId,
        issueKey: issue.key,
        fieldType: (0, $5fc53.CATEGORY_TYPE),
        initialValue: field.value && $7aabea9eb9c86fb2$var$isTransformedCategory(field.value) ? {
            id: field.value.optionId,
            value: field.value.value,
            color: field.value?.color
        } : null
    });
    return (0, $ks0ly.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: value?.value || '',
        currentValue: value,
        getPastedValue: $7aabea9eb9c86fb2$var$getPastedValue,
        saveValue: saveValue
    });
};
const $7aabea9eb9c86fb2$var$CategoryClipboardHelper = (0, $4UjyI.createClipboardHelperComponent)($7aabea9eb9c86fb2$var$useCategoryClipboardHandler);
const $7aabea9eb9c86fb2$export$b2a7ae1b92d8afd3 = {
    [(0, $5fc53.CATEGORY_TYPE)]: $7aabea9eb9c86fb2$var$CategoryClipboardHelper
};

});
parcelRegister("9aWWe", function(module, exports) {

$parcel$export(module.exports, "categorySupportedTypes", () => $2f068fc1b946612b$export$7a3abb279a994c7d);

var $5fc53 = parcelRequire("5fc53");
const $2f068fc1b946612b$export$7a3abb279a994c7d = [
    (0, $5fc53.CATEGORY_TYPE)
];

});


parcelRegister("auKIK", function(module, exports) {

$parcel$export(module.exports, "checkboxClipboardHandler", () => $2abffd1afef5cafd$export$a637ce753d346a9a);

var $7Y3nn = parcelRequire("7Y3nn");

var $5fc53 = parcelRequire("5fc53");

var $4UjyI = parcelRequire("4UjyI");

var $ks0ly = parcelRequire("ks0ly");

var $3O2T0 = parcelRequire("3O2T0");

var $8jn7A = parcelRequire("8jn7A");
const $2abffd1afef5cafd$var$isTransformedCheckboxOption = (option)=>!!option && typeof option === 'object' && 'optionId' in option && 'value' in option;
const $2abffd1afef5cafd$var$isTransformedCheckbox = (fieldValue)=>Array.isArray(fieldValue) && fieldValue.every($2abffd1afef5cafd$var$isTransformedCheckboxOption);
const $2abffd1afef5cafd$var$isCheckboxValue = (fieldValue)=>Array.isArray(fieldValue) && fieldValue.every((option)=>!!option && typeof option === 'object' && 'id' in option && 'value' in option);
const $2abffd1afef5cafd$var$emptyValue = [];
const $2abffd1afef5cafd$var$getPastedValue = (clipboardItem, metadata)=>{
    if (!(0, $3O2T0.assertClipboardHasRichFormat)(clipboardItem) || !(0, $3O2T0.assertClipboardDataIsCompatible)(metadata, (0, $8jn7A.checkboxSupportedTypes))) return [];
    if (!$2abffd1afef5cafd$var$isCheckboxValue(metadata?.fieldValue)) return [];
    return metadata?.fieldValue ?? [];
};
function $2abffd1afef5cafd$var$assertCheckboxField(field) {
    if (!field) throw new Error('Field is required');
    if (field.type !== (0, $5fc53.MULTI_CHECKBOXES_CF_TYPE)) throw new Error('Field type is not supported');
}
const $2abffd1afef5cafd$var$useCheckboxClipboardHandler = (issue, field)=>{
    $2abffd1afef5cafd$var$assertCheckboxField(field);
    const [{ value: value }, { saveValue: saveValue }] = (0, $7Y3nn.useCheckboxSelectField)({
        fieldKey: field.fieldId,
        issueKey: issue.key,
        initialValue: $2abffd1afef5cafd$var$isTransformedCheckbox(field.value) ? field.value.filter(Boolean).map((option)=>({
                id: option.optionId,
                value: option.value ?? ''
            })) : undefined
    });
    return (0, $ks0ly.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: value?.map((option)=>option?.value || '').join(', ') || '',
        currentValue: value,
        getPastedValue: $2abffd1afef5cafd$var$getPastedValue,
        saveValue: saveValue,
        emptyValue: $2abffd1afef5cafd$var$emptyValue
    });
};
const $2abffd1afef5cafd$var$CheckboxClipboardHelper = (0, $4UjyI.createClipboardHelperComponent)($2abffd1afef5cafd$var$useCheckboxClipboardHandler);
const $2abffd1afef5cafd$export$a637ce753d346a9a = {
    [(0, $5fc53.MULTI_CHECKBOXES_CF_TYPE)]: $2abffd1afef5cafd$var$CheckboxClipboardHelper
};

});
parcelRegister("7Y3nn", function(module, exports) {

$parcel$export(module.exports, "useCheckboxSelectField", () => $d31cc439efc1ff22$export$64fe88e084e8ce22);

var $lQE94 = parcelRequire("lQE94");

var $54wEF = parcelRequire("54wEF");

var $69oHP = parcelRequire("69oHP");
const $d31cc439efc1ff22$export$64fe88e084e8ce22 = ({ issueKey: issueKey, initialValue: initialValue = null, fieldKey: fieldKey, onSuccess: onSuccess, onFailure: onFailure })=>{
    const [fieldConfig] = (0, $54wEF.useFieldConfig)(issueKey, fieldKey);
    const fieldType = (0, $69oHP.getFieldType)(fieldConfig.value) || 'array';
    const [{ value: value, loading: loading, error: error }, { saveValue: saveValue, saveById: saveById, resetError: resetError }] = (0, $lQE94.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: initialValue,
        onSuccess: onSuccess,
        onFailure: onFailure
    });
    return [
        {
            value: value,
            loading: loading,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            saveById: saveById,
            resetError: resetError
        }
    ];
};

});
parcelRegister("54wEF", function(module, exports) {

$parcel$export(module.exports, "useIssueFieldConfig", () => $a5085d8f4019d625$export$5406c21e0d275680);
$parcel$export(module.exports, "useIssueFieldConfigWithoutRefetch", () => $a5085d8f4019d625$export$217a0e2f2962f4ae);
$parcel$export(module.exports, "useIssueFieldConfigWithoutUimOverrides", () => $a5085d8f4019d625$export$5f641a998c6dfa06);
$parcel$export(module.exports, "useFieldConfig", () => $a5085d8f4019d625$export$70da50df1be2dbe1);
$parcel$export(module.exports, "useFieldConfigWithoutRefetch", () => $a5085d8f4019d625$export$1eed575f8f3334eb);
$parcel$export(module.exports, "useFieldConfigActions", () => $a5085d8f4019d625$export$28a22fd0dedf31b7);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $4R6GH = parcelRequire("4R6GH");

var $jJZqs = parcelRequire("jJZqs");

var $eusud = parcelRequire("eusud");

var $iZIvy = parcelRequire("iZIvy");

var $eDXka = parcelRequire("eDXka");

var $gXz4p = parcelRequire("gXz4p");

var $biQrn = parcelRequire("biQrn");

var $2N3tQ = parcelRequire("2N3tQ");
const $a5085d8f4019d625$export$9715ac6597e498fd = ()=>`
  query fieldConfigurationQuery($issueKey: String) {
    issue(issueIdOrKey: $issueKey, latestVersion: true, screen: "view") {
      fields {
        key
        schema {
          type
          custom
          customId
          system
          renderer
        }
        autoCompleteUrl
        allowedValues
        operations
        required
        editable
        title
        description
      }
    }
  }`;
const $a5085d8f4019d625$var$fieldConfigurationQueryExperienceDescription = ({ wasExperienceSuccessful: wasExperienceSuccessful, errorMessage: errorMessage, traceId: traceId })=>{
    const errorMessageItem = errorMessage != null ? {
        errorMessage: errorMessage
    } : {};
    const traceIdItem = traceId != null ? {
        traceId: traceId
    } : {};
    return {
        experience: (0, $eDXka.IssueViewFetchOperations).FIELD_CONFIGURATION,
        wasExperienceSuccesful: wasExperienceSuccessful,
        analyticsSource: 'Issue View Field Configuration Query',
        additionalAttributes: {
            method: 'GET',
            ...errorMessageItem,
            ...traceIdItem
        },
        application: null,
        edition: null
    };
};
const $a5085d8f4019d625$var$fieldConfigurationQueryExperienceTracking = ({ wasExperienceSuccessful: wasExperienceSuccessful, error: error })=>{
    (0, $gXz4p.sendExperienceAnalytics)($a5085d8f4019d625$var$fieldConfigurationQueryExperienceDescription({
        wasExperienceSuccessful: wasExperienceSuccessful,
        ...error?.message != null ? {
            errorMessage: error.message
        } : {},
        ...error instanceof (0, $jJZqs.default) && error.traceId != null ? {
            traceId: error.traceId
        } : {}
    }));
};
const $a5085d8f4019d625$var$fetchData = async (issueKey)=>{
    try {
        const response = await (0, $eusud.performPostRequest)((0, $iZIvy.getGraphQlUrl)('', (0, $eDXka.IssueViewFetchOperations).FIELD_CONFIGURATION), {
            body: JSON.stringify({
                query: $a5085d8f4019d625$export$9715ac6597e498fd(),
                variables: {
                    issueKey: issueKey
                }
            })
        });
        if (response?.data?.issue?.fields) {
            const fieldConfigData = response.data.issue.fields.reduce(// @ts-expect-error - TS7006 - Parameter 'result' implicitly has an 'any' type. | TS7006 - Parameter 'field' implicitly has an 'any' type.
            (result, field)=>({
                    // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                    ...result,
                    [field.key]: {
                        autoCompleteUrl: field.autoCompleteUrl,
                        allowedValues: field.allowedValues,
                        isEditable: field.editable,
                        isRequired: field.required,
                        schema: field.schema,
                        title: field.title,
                        ...field.description ? {
                            description: field.description
                        } : {}
                    }
                }), {});
            $a5085d8f4019d625$var$fieldConfigurationQueryExperienceTracking({
                wasExperienceSuccessful: true
            });
            return fieldConfigData;
        }
        $a5085d8f4019d625$var$fieldConfigurationQueryExperienceTracking({
            wasExperienceSuccessful: false,
            error: new Error('Unexpected field configuration response')
        });
        return null;
    } catch (error) {
        $a5085d8f4019d625$var$fieldConfigurationQueryExperienceTracking({
            wasExperienceSuccessful: false,
            error: error instanceof (0, $jJZqs.default) ? error : undefined
        });
        return null;
    }
};
const $a5085d8f4019d625$var$requestSet = new Set();
const $a5085d8f4019d625$var$issueFieldConfigServiceDefaultOptions = {
    skipRefresh: false
};
const $a5085d8f4019d625$var$useIssueFieldConfigRefetch = (issueKey, value, { skipRefresh: skipRefresh } = $a5085d8f4019d625$var$issueFieldConfigServiceDefaultOptions)=>{
    const isMounted = (0, $biQrn.useIsMounted)();
    const [, { setIssueConfig: setIssueConfig }] = (0, $2N3tQ.useFieldConfigStoreActions)();
    const [loading, setLoading] = (0, $5uXOq.useState)(()=>!skipRefresh && value === undefined && !$a5085d8f4019d625$var$requestSet.has(issueKey));
    const getData = (0, $5uXOq.useCallback)(async ()=>{
        setLoading(true);
        $a5085d8f4019d625$var$requestSet.add(issueKey);
        const result = await $a5085d8f4019d625$var$fetchData(issueKey);
        setIssueConfig(issueKey, result);
        $a5085d8f4019d625$var$requestSet.delete(issueKey);
        if (isMounted.current) setLoading(false);
    }, [
        isMounted,
        issueKey,
        setIssueConfig
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const shouldGetData = (0, $4R6GH.fg)('jiv-19312-fix-fieldconfigurationquery-refetch') ? !skipRefresh && !$a5085d8f4019d625$var$requestSet.has(issueKey) && value === undefined && issueKey !== '' : !skipRefresh && !$a5085d8f4019d625$var$requestSet.has(issueKey) && value === undefined;
        if (shouldGetData) getData();
    }, [
        issueKey,
        value,
        getData,
        skipRefresh
    ]);
    return [
        {
            loading: loading
        }
    ];
};
const $a5085d8f4019d625$var$useIssueFieldConfigStoreWithUimOverrides = ({ issueKey: issueKey })=>{
    const [value] = (0, $2N3tQ.useIssueFieldConfigStore)({
        issueKey: issueKey
    });
    const [overrides] = (0, $2N3tQ.useIssueOverridesStore)({
        issueKey: issueKey
    });
    return (0, $5uXOq.useMemo)(()=>{
        if (// When fields configurations are not valid, we don't want overrides
        !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(value) && // We should not override if UI modifications is not available in general or for the field
        overrides !== undefined) {
            // Iteration over the base fields (`value`) prevents creation of partial configs with just UIM overrides.
            const issueWithOverrides = Object.entries(value).reduce((acc, [fieldKey, fieldValues])=>{
                acc[fieldKey] = {
                    ...fieldValues,
                    ...overrides[fieldKey]
                };
                return acc;
            }, {});
            return [
                issueWithOverrides
            ];
        }
        return [
            value
        ];
    }, [
        value,
        overrides
    ]);
};
const $a5085d8f4019d625$var$useFieldConfigStoreWithUimOverrides = ({ issueKey: issueKey, fieldKey: fieldKey })=>{
    const [value] = (0, $2N3tQ.useFieldConfigStore)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const [overrides] = (0, $2N3tQ.useFieldOverridesStore)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    if (// When fields configurations are not valid, we don't want overrides
    !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(value) && // We should not override if UI modifications is not available in general or for the field
    overrides !== undefined) return [
        {
            ...value,
            ...overrides
        }
    ];
    return [
        value
    ];
};
const $a5085d8f4019d625$export$5406c21e0d275680 = (issueKey)=>{
    const [value] = $a5085d8f4019d625$var$useIssueFieldConfigStoreWithUimOverrides({
        issueKey: issueKey
    });
    const [{ loading: loading }] = $a5085d8f4019d625$var$useIssueFieldConfigRefetch(issueKey, value);
    return [
        {
            value: value,
            loading: loading
        }
    ];
};
const $a5085d8f4019d625$export$217a0e2f2962f4ae = (issueKey)=>{
    const [value] = $a5085d8f4019d625$var$useIssueFieldConfigStoreWithUimOverrides({
        issueKey: issueKey
    });
    return [
        {
            value: value
        }
    ];
};
const $a5085d8f4019d625$export$5f641a998c6dfa06 = ({ issueKey: issueKey })=>{
    const [value] = (0, $2N3tQ.useIssueFieldConfigStore)({
        issueKey: issueKey
    });
    const [{ loading: loading }] = $a5085d8f4019d625$var$useIssueFieldConfigRefetch(issueKey, value);
    return [
        {
            value: value,
            loading: loading
        }
    ];
};
const $a5085d8f4019d625$export$70da50df1be2dbe1 = (issueKey, fieldKey, options = $a5085d8f4019d625$var$issueFieldConfigServiceDefaultOptions)=>{
    const [value] = $a5085d8f4019d625$var$useFieldConfigStoreWithUimOverrides({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const [{ loading: loading }] = $a5085d8f4019d625$var$useIssueFieldConfigRefetch(issueKey, value, options);
    return [
        {
            value: value,
            loading: loading
        }
    ];
};
const $a5085d8f4019d625$export$1eed575f8f3334eb = (issueKey, fieldKey)=>{
    const [value] = $a5085d8f4019d625$var$useFieldConfigStoreWithUimOverrides({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    return [
        {
            value: value
        }
    ];
};
const $a5085d8f4019d625$export$28a22fd0dedf31b7 = ()=>{
    const [, setIssueConfigActions] = (0, $2N3tQ.useFieldConfigStoreActions)();
    const actions = (0, $5uXOq.useMemo)(()=>{
        const setIssueConfig = (issueKey, issueConfig)=>setIssueConfigActions.setIssueConfig(issueKey, issueConfig);
        const setIssuesConfig = (issuesWithConfigurations)=>setIssueConfigActions.setIssuesConfig(issuesWithConfigurations);
        const mergeIssueConfig = (issueKey, issueConfig)=>setIssueConfigActions.mergeIssueConfig(issueKey, issueConfig);
        const mergeIssuesConfig = (issuesWithConfigurations)=>setIssueConfigActions.mergeIssuesConfig(issuesWithConfigurations);
        const setFieldConfigValue = (issueKey, fieldKey, fieldConfigValue)=>setIssueConfigActions.setFieldConfigValue(issueKey, fieldKey, fieldConfigValue);
        return {
            setIssueConfig: setIssueConfig,
            setIssuesConfig: setIssuesConfig,
            mergeIssueConfig: mergeIssueConfig,
            mergeIssuesConfig: mergeIssuesConfig,
            setFieldConfigValue: setFieldConfigValue
        };
    }, [
        setIssueConfigActions
    ]);
    return [
        null,
        actions
    ];
};

});
parcelRegister("iZIvy", function(module, exports) {

$parcel$export(module.exports, "getGraphQlUrl", () => $ef2130f553e5234b$export$5647e6bbf2b3526f);
$parcel$export(module.exports, "getFieldDataOptions", () => $ef2130f553e5234b$export$f2fec0cacdfabaaf);

var $96nmc = parcelRequire("96nmc");

var $chLKn = parcelRequire("chLKn");

const $ef2130f553e5234b$export$5647e6bbf2b3526f = (baseUrl, operation)=>`${baseUrl}/rest/graphql/1/${(0, $96nmc.appendOperationQuery)(operation)}`;
const $ef2130f553e5234b$export$f2fec0cacdfabaaf = (issueKey, projectKey)=>({
        method: 'POST',
        body: JSON.stringify({
            query: (0, $chLKn.default)(issueKey, projectKey)
        })
    });

});
parcelRegister("chLKn", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c7dcb170a6dfaf0$export$2e2bcd8739ae039);
const $2c7dcb170a6dfaf0$export$ecc155df19ba52ff = (literals, ...substitutions)=>{
    let result = '';
    // run the loop only for the substitution count
    substitutions.forEach((key, i)=>{
        result += literals[i];
        result += key.toString();
    });
    // add the last literal
    result += literals[literals.length - 1];
    return result;
};
const $2c7dcb170a6dfaf0$var$getIsHybridAgilityProjectQuery = ()=>`
    isHybridAgilityProject
    `;
const $2c7dcb170a6dfaf0$var$getEnvironmentQuery = ()=>`environmentAdf {
        value
    }`;
const $2c7dcb170a6dfaf0$var$getAgileQuery = ()=>`
    agile {
        epic {
          key
        },
    }`;
const $2c7dcb170a6dfaf0$var$getCustomFieldSchemaConfiguration = ()=>`configuration {
        key
        value
    }
    `;
const $2c7dcb170a6dfaf0$var$getProjectQuery = (projectKey)=>`
        project(projectIdOrKey: "${projectKey}") {
            id
            name
            key
            projectTypeKey
            simplified
            avatarUrls {
                key
                value
            }
            archived
            deleted
        }`;
var // Disable this eslint rule temporarily so we can query for configuration
// eslint-disable-next-line jira/import/no-anonymous-default-export
$2c7dcb170a6dfaf0$export$2e2bcd8739ae039 = (issueKey, projectKey)=>$2c7dcb170a6dfaf0$export$ecc155df19ba52ff`query issueDataQuery {
        issue(issueIdOrKey: "${issueKey}", latestVersion: true, screen: "view") {
            id
            viewScreenId
            fields {
                key
                title
                editable
                required
                autoCompleteUrl
                allowedValues
                content
                renderedContent
                schema {
                    custom
                    system
                    ${$2c7dcb170a6dfaf0$var$getCustomFieldSchemaConfiguration()}
                    items
                    type
                    renderer
                }
                configuration
            }
            expandAssigneeInSubtasks
            expandAssigneeInIssuelinks
            expandTimeTrackingInSubtasks
            systemFields {
                descriptionAdf {
                    value
                }
                ${$2c7dcb170a6dfaf0$var$getEnvironmentQuery()}
            }
            customFields {
                textareaAdf {
                    key
                    value
                }
            }
            ${$2c7dcb170a6dfaf0$var$getIsHybridAgilityProjectQuery()}
            ${$2c7dcb170a6dfaf0$var$getAgileQuery()}
        }
        ${$2c7dcb170a6dfaf0$var$getProjectQuery(projectKey)}
    }`;

});


parcelRegister("eDXka", function(module, exports) {

$parcel$export(module.exports, "TIMESTAMP_DISPLAY_SETTING", () => $9f0f96bc04f1e77a$export$9f4ee8e6dc9a0a55);
$parcel$export(module.exports, "CHILD_ISSUES_LIMIT_BEST_PRACTICE_FLAG_DISMISSED", () => $9f0f96bc04f1e77a$export$e7d75f9d93dfa3df);
$parcel$export(module.exports, "IssueViewFetchOperations", () => $9f0f96bc04f1e77a$export$b38f30d67f730bc4);
const $9f0f96bc04f1e77a$export$9f4ee8e6dc9a0a55 = 'jira.user.issue.details.timestamp-display-setting';
const $9f0f96bc04f1e77a$export$e7d75f9d93dfa3df = 'jira.user.issue.child-issues-limit.best-practice-flag.dismissed';
const $9f0f96bc04f1e77a$export$b38f30d67f730bc4 = {
    EARLY_FETCH_GRAPHQL: 'earlyFetchIssueDataQuery',
    INITIAL_GRAPHQL: 'issueDataQuery',
    EARLY_FETCH_GIRA: 'earlyFetchIssueViewInteractiveQuery',
    INITIAL_GIRA: 'issueViewInteractiveQuery',
    EARLY_FETCH_AGG: 'earlyFetchMainIssueAggQuery',
    INITIAL_AGG: 'mainIssueAggQuery',
    EARLY_FETCH_NON_CRITICAL_GIRA: 'earlyFetchIssueViewNonCriticalGiraQuery',
    NON_CRITICAL_GIRA: 'issueViewNonCriticalGiraQuery',
    VIEW_SCREEN_ID: 'viewScreenIdQuery',
    FIELD_CONFIGURATION: 'fieldConfigurationQuery',
    FIELD_DESCRIPTION: 'fieldDescriptionQuery',
    ATTACHMENT: 'attachmentsQuery'
};

});

parcelRegister("2N3tQ", function(module, exports) {

$parcel$export(module.exports, "useIssueFieldConfigStore", () => $0471f3f4df57179c$export$52f51db4e2b3da57);
$parcel$export(module.exports, "useFieldConfigStore", () => $0471f3f4df57179c$export$f9beb98c7488fd61);
$parcel$export(module.exports, "useFieldConfigStoreActions", () => $0471f3f4df57179c$export$314199caf05d245);
$parcel$export(module.exports, "useIssueOverridesStore", () => $0471f3f4df57179c$export$ff357cf5a96ec0c6);
$parcel$export(module.exports, "useFieldOverridesStore", () => $0471f3f4df57179c$export$6e41e9c34587d557);
$parcel$export(module.exports, "useFieldOverridesStoreWithLabel", () => $0471f3f4df57179c$export$e704d739927bd1d6);
$parcel$export(module.exports, "useOverridesStoreActions", () => $0471f3f4df57179c$export$d94ae842140da412);
$parcel$export(module.exports, "useFieldOptionsOverrides", () => $0471f3f4df57179c$export$bfea9bb9bad7bc8f);
$parcel$export(module.exports, "useIsFieldBusy", () => $0471f3f4df57179c$export$982ff1008c2e2780);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ 
var $dGvGJ = parcelRequire("dGvGJ");

var $1UikQ = parcelRequire("1UikQ");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $0471f3f4df57179c$var$setIssueConfig = (issueKey, issueConfiguration)=>({ setState: setState })=>{
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: IssueConfiguration | null; }' is not assignable to parameter of type 'Partial<Partial<Record<string, IssueConfiguration>>>'.
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: issueConfiguration
        });
    };
const $0471f3f4df57179c$var$mergeIssueConfig = (issueKey, issueConfiguration)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, getState()[issueKey], issueConfiguration)
        });
    };
const $0471f3f4df57179c$var$setIssuesConfig = (issuesWithConfigurations)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = issuesWithConfigurations.reduce((acc, issue)=>({
                ...acc,
                ...issue
            }), {});
        setState(newIssues);
    };
const $0471f3f4df57179c$var$mergeIssuesConfig = (issuesWithConfigurations)=>({ setState: setState, getState: getState })=>{
        if (issuesWithConfigurations.length === 0) return;
        const newIssues = {};
        issuesWithConfigurations.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState((0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, getState(), newIssues));
    };
const $0471f3f4df57179c$var$setFieldConfigValue = (issueKey, fieldKey, fieldConfiguration)=>({ setState: setState, getState: getState })=>{
        const issueKeyFieldConfiguration = getState()[issueKey];
        if (issueKeyFieldConfiguration && issueKeyFieldConfiguration[fieldKey]) setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...getState()[issueKey],
                [fieldKey]: {
                    ...getState()[issueKey][fieldKey],
                    ...fieldConfiguration
                }
            }
        });
    };
const $0471f3f4df57179c$var$actions = {
    setIssueConfig: $0471f3f4df57179c$var$setIssueConfig,
    setIssuesConfig: $0471f3f4df57179c$var$setIssuesConfig,
    mergeIssueConfig: $0471f3f4df57179c$var$mergeIssueConfig,
    mergeIssuesConfig: $0471f3f4df57179c$var$mergeIssuesConfig,
    setFieldConfigValue: $0471f3f4df57179c$var$setFieldConfigValue
};
// this is a global state
const $0471f3f4df57179c$var$store = (0, $iXqE5.createStore)({
    name: 'issue-field-config',
    initialState: {},
    actions: $0471f3f4df57179c$var$actions
});
const $0471f3f4df57179c$var$getIssueFieldConfig = (0, $dGvGJ.createSelector)((state, props)=>state[props.issueKey], (issue)=>issue);
const $0471f3f4df57179c$export$52f51db4e2b3da57 = (0, $3sQ5x.createHook)($0471f3f4df57179c$var$store, {
    selector: $0471f3f4df57179c$var$getIssueFieldConfig
});
const $0471f3f4df57179c$var$getFieldConfig = (0, $dGvGJ.createSelector)((state, props)=>state[props.issueKey], (state, props)=>props.fieldKey, (issue, fieldKey)=>{
    // issue being undefined means we haven't fetched it yet
    // issue being null means it doesn't exist.
    // either way we just return that value
    if (issue == null) return issue;
    // if we have the field key, return it. Otherwise return null to show
    // we have done a data fetch of the issue but the field doesn't exist
    return issue[fieldKey] ? issue[fieldKey] : null;
});
const $0471f3f4df57179c$var$getFieldConfigWithLabel = (0, $dGvGJ.createSelector)($0471f3f4df57179c$var$getFieldConfig, (fieldConfig)=>{
    if (fieldConfig?.title === undefined) return fieldConfig;
    return {
        ...fieldConfig,
        label: fieldConfig.title
    };
});
const $0471f3f4df57179c$var$getFieldOptionsOverrides = (0, $dGvGJ.createSelector)((state, props)=>state[props.issueKey], (state, props)=>props.fieldKey, (issue, fieldKey)=>{
    // issue being undefined means we haven't fetched it yet
    // issue being null means it doesn't exist.
    // either way we just return that value
    if (issue == null) return issue;
    // if we have the field key, return it. Otherwise return null to show
    // we have done a data fetch of the issue but the field doesn't exist
    return issue[fieldKey] ? issue[fieldKey].allowedValuesOverrides : null;
});
const $0471f3f4df57179c$export$f9beb98c7488fd61 = (0, $3sQ5x.createHook)($0471f3f4df57179c$var$store, {
    selector: $0471f3f4df57179c$var$getFieldConfig
});
const $0471f3f4df57179c$export$314199caf05d245 = (0, $3sQ5x.createHook)($0471f3f4df57179c$var$store, {
    selector: null
});
const $0471f3f4df57179c$var$setOverrides = (issueKey, fieldKey, fieldConfigOverrides)=>({ setState: setState, getState: getState })=>{
        const issueKeyFieldConfigurationWithOverrides = getState()[issueKey] ?? {};
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...issueKeyFieldConfigurationWithOverrides,
                [fieldKey]: {
                    ...issueKeyFieldConfigurationWithOverrides[fieldKey],
                    ...fieldConfigOverrides
                }
            }
        });
    };
const $0471f3f4df57179c$var$resetOverridesStore = (issueKey)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        setState({
            [issueKey]: undefined
        });
    };
const $0471f3f4df57179c$var$overridesActions = {
    setFieldConfigOverridesValue: $0471f3f4df57179c$var$setOverrides,
    resetOverridesStore: $0471f3f4df57179c$var$resetOverridesStore
};
// Store contains overrides to the field config. It is used by UI modifications to override field config properties by apps.
// UI modifications is a Forge extension point providing apps JS API to override field's properties: name, description, isEditable
// and limit visibility of select fields options.
const $0471f3f4df57179c$var$overridesStore = (0, $iXqE5.createStore)({
    name: 'issue-field-overrides',
    initialState: {},
    actions: $0471f3f4df57179c$var$overridesActions
});
const $0471f3f4df57179c$export$ff357cf5a96ec0c6 = (0, $3sQ5x.createHook)($0471f3f4df57179c$var$overridesStore, {
    selector: $0471f3f4df57179c$var$getIssueFieldConfig
});
const $0471f3f4df57179c$export$6e41e9c34587d557 = (0, $3sQ5x.createHook)($0471f3f4df57179c$var$overridesStore, {
    selector: $0471f3f4df57179c$var$getFieldConfig
});
const $0471f3f4df57179c$export$e704d739927bd1d6 = (0, $3sQ5x.createStateHook)($0471f3f4df57179c$var$overridesStore, {
    selector: $0471f3f4df57179c$var$getFieldConfigWithLabel
});
const $0471f3f4df57179c$export$d94ae842140da412 = (0, $3sQ5x.createActionsHook)($0471f3f4df57179c$var$overridesStore);
const $0471f3f4df57179c$export$bfea9bb9bad7bc8f = (0, $3sQ5x.createHook)($0471f3f4df57179c$var$overridesStore, {
    selector: $0471f3f4df57179c$var$getFieldOptionsOverrides
});
const $0471f3f4df57179c$var$getIsFieldBusySelector = (state, args)=>{
    const { fieldId: fieldId, issueKey: issueKey } = args;
    return fieldId !== undefined && !!state[issueKey]?.[fieldId]?.isBusy;
};
const $0471f3f4df57179c$export$982ff1008c2e2780 = (0, $3sQ5x.createStateHook)($0471f3f4df57179c$var$overridesStore, {
    selector: $0471f3f4df57179c$var$getIsFieldBusySelector
});

});


parcelRegister("69oHP", function(module, exports) {

$parcel$export(module.exports, "getFieldType", () => $53d3f894a8bd7ffe$export$b9089a6e41ed43aa);
$parcel$export(module.exports, "isRichTextSupported", () => $53d3f894a8bd7ffe$export$24d1b07fa0e9f9f1);


var $fOGZN = parcelRequire("fOGZN");

var $5fc53 = parcelRequire("5fc53");
const $53d3f894a8bd7ffe$var$atlassianSystemCFTypes = ()=>{
    const customSystemFields = (0, $fOGZN.specialFields)();
    return [
        ...(0, $fOGZN.customFieldsToDisplay)().filter((cf)=>!(0, $fOGZN.ecosystemCustomFields).includes(cf)),
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'SpecialFieldTypes'.
        ...Object.keys(customSystemFields).map((key)=>customSystemFields[key]),
        (0, $5fc53.FLAGGED_CF_TYPE)
    ];
};
const $53d3f894a8bd7ffe$export$f521834fc2bfcd81 = (custom)=>$53d3f894a8bd7ffe$var$atlassianSystemCFTypes().find((type)=>type === custom);
const $53d3f894a8bd7ffe$export$b9089a6e41ed43aa = (field)=>{
    const fieldSchema = field ? field.schema : undefined;
    return fieldSchema ? $53d3f894a8bd7ffe$export$f521834fc2bfcd81(fieldSchema.custom) || fieldSchema.system || fieldSchema.type : undefined;
};
const $53d3f894a8bd7ffe$export$24d1b07fa0e9f9f1 = (field)=>{
    const fieldSchema = field ? field.schema : undefined;
    return fieldSchema ? fieldSchema.type === (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE) && fieldSchema.renderer === (0, $650578330a102f55$export$89b8c5d86c10a68c) || $53d3f894a8bd7ffe$export$b9089a6e41ed43aa(field) === (0, $5fc53.DESCRIPTION_TYPE) : false;
};

});
parcelRegister("fOGZN", function(module, exports) {

$parcel$export(module.exports, "ISSUE_TYPE", () => $1df76d38eb6e3f90$export$ebb48b08205007c5);
$parcel$export(module.exports, "ISSUE_SUMMARY", () => $1df76d38eb6e3f90$export$a464614f8f5fe986);
$parcel$export(module.exports, "SUBTASK_PARENT", () => $1df76d38eb6e3f90$export$a311a3c9b207604e);
$parcel$export(module.exports, "WATCHES", () => $1df76d38eb6e3f90$export$289917d9a7031e1d);
$parcel$export(module.exports, "VOTES", () => $1df76d38eb6e3f90$export$81614f6dc3be5b00);
$parcel$export(module.exports, "SECURITY", () => $1df76d38eb6e3f90$export$72a5630aa398d6b4);
$parcel$export(module.exports, "ISSUE_RESTRICTION", () => $1df76d38eb6e3f90$export$caf1ff54fbdf44bf);
$parcel$export(module.exports, "ASSIGNEE", () => $1df76d38eb6e3f90$export$f8f7545d2bb78afb);
$parcel$export(module.exports, "REPORTER", () => $1df76d38eb6e3f90$export$6d7021166edc895c);
$parcel$export(module.exports, "DUE_DATE", () => $1df76d38eb6e3f90$export$cf7e173386d30cdd);
$parcel$export(module.exports, "PRIORITY", () => $1df76d38eb6e3f90$export$bb34f3538ba26c7e);
$parcel$export(module.exports, "LABELS", () => $1df76d38eb6e3f90$export$79b91d4669dcadcb);
$parcel$export(module.exports, "EPIC", () => $1df76d38eb6e3f90$export$3cb4a99a332e4186);
$parcel$export(module.exports, "FIX_VERSIONS", () => $1df76d38eb6e3f90$export$d7e18f5730074533);
$parcel$export(module.exports, "AFFECTS_VERSIONS", () => $1df76d38eb6e3f90$export$c435f0000304e508);
$parcel$export(module.exports, "TIME_TRACKING", () => $1df76d38eb6e3f90$export$ee99ef6ee562a446);
$parcel$export(module.exports, "TIME_ESTIMATE", () => $1df76d38eb6e3f90$export$a6a74b4bc927d39f);
$parcel$export(module.exports, "STATUS", () => $1df76d38eb6e3f90$export$e50006273435e7d4);
$parcel$export(module.exports, "CREATED", () => $1df76d38eb6e3f90$export$ff39ebd4bb12b718);
$parcel$export(module.exports, "UPDATED", () => $1df76d38eb6e3f90$export$cd8e68094cb5c3cb);
$parcel$export(module.exports, "SUMMARY", () => $1df76d38eb6e3f90$export$913055729e1380b2);
$parcel$export(module.exports, "DESCRIPTION", () => $1df76d38eb6e3f90$export$d44826c816b5619b);
$parcel$export(module.exports, "COMMENT", () => $1df76d38eb6e3f90$export$a29989082612d0d9);
$parcel$export(module.exports, "EPIC_ISSUES", () => $1df76d38eb6e3f90$export$8fe3d5be8cb17459);
$parcel$export(module.exports, "CHILDREN_ISSUES", () => $1df76d38eb6e3f90$export$3b3d0889022c85b3);
$parcel$export(module.exports, "ENVIRONMENT", () => $1df76d38eb6e3f90$export$be46596bc6608f3b);
$parcel$export(module.exports, "SUBTASKS", () => $1df76d38eb6e3f90$export$f528fadbfdb3c25e);
$parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD", () => $1df76d38eb6e3f90$export$f10e53e8928b61bd);
$parcel$export(module.exports, "PARENT", () => $1df76d38eb6e3f90$export$e0dfb65d1047c53c);
$parcel$export(module.exports, "PORTFOLIO_CHILD_ISSUES", () => $1df76d38eb6e3f90$export$aba22e09a66f6826);
$parcel$export(module.exports, "SELECT_CUSTOM_FIELD_TYPE", () => $1df76d38eb6e3f90$export$826d657005bbe54c);
$parcel$export(module.exports, "FLAG_ACTIONS", () => $1df76d38eb6e3f90$export$cdbd1eb3b05729e0);
$parcel$export(module.exports, "CARD_COVER_ACTIONS", () => $1df76d38eb6e3f90$export$c161a774ec2e7e56);
$parcel$export(module.exports, "specialFields", () => $1df76d38eb6e3f90$export$89e5c40c0f5c7561);
$parcel$export(module.exports, "ecosystemCustomFields", () => $1df76d38eb6e3f90$export$87934b3672715c91);
$parcel$export(module.exports, "customFieldsToDisplay", () => $1df76d38eb6e3f90$export$efd443bccc4c01ed);
$parcel$export(module.exports, "itemDocumentationUrls", () => $1df76d38eb6e3f90$export$a18b3a656ee9c709);
$parcel$export(module.exports, "emptyConfiguration", () => $1df76d38eb6e3f90$export$a52507e68e7aeeb);
$parcel$export(module.exports, "softwareConfiguration", () => $1df76d38eb6e3f90$export$27e0678365e5dcff);
$parcel$export(module.exports, "simpleSoftwareBoardConfiguration", () => $1df76d38eb6e3f90$export$aebf676dfa727a1c);
$parcel$export(module.exports, "standardRoadmapConfiguration", () => $1df76d38eb6e3f90$export$1afca4d3eb6b218b);
$parcel$export(module.exports, "bitbucketConfiguration", () => $1df76d38eb6e3f90$export$8a060ed6f66c43b0);
$parcel$export(module.exports, "mobileConfiguration", () => $1df76d38eb6e3f90$export$78a2cb921e46f5eb);
$parcel$export(module.exports, "serviceDeskConfiguration", () => $1df76d38eb6e3f90$export$db1115186532f6d5);
$parcel$export(module.exports, "connectConfiguration", () => $1df76d38eb6e3f90$export$557d5094ec5cf234);
$parcel$export(module.exports, "getIssueConfiguration", () => $1df76d38eb6e3f90$export$902f6c5cc939598a);

var $65mz3 = parcelRequire("65mz3");

var $2vSU6 = parcelRequire("2vSU6");

var $5fc53 = parcelRequire("5fc53");
const $1df76d38eb6e3f90$export$ebb48b08205007c5 = 'issuetype';
const $1df76d38eb6e3f90$export$a464614f8f5fe986 = 'summary';
const $1df76d38eb6e3f90$export$a311a3c9b207604e = 'parent';
const $1df76d38eb6e3f90$export$2a4f270075a033de = 'parent-issue';
const $1df76d38eb6e3f90$export$4561a4960baf1b2b = 'parent'; // new Hierarchy unification parent field
const $1df76d38eb6e3f90$export$289917d9a7031e1d = 'watches';
const $1df76d38eb6e3f90$export$81614f6dc3be5b00 = 'votes';
const $1df76d38eb6e3f90$export$72a5630aa398d6b4 = 'security';
const $1df76d38eb6e3f90$export$caf1ff54fbdf44bf = 'issuerestriction';
const $1df76d38eb6e3f90$export$f8f7545d2bb78afb = 'assignee';
const $1df76d38eb6e3f90$export$6d7021166edc895c = 'reporter';
const $1df76d38eb6e3f90$export$cf7e173386d30cdd = 'duedate';
const $1df76d38eb6e3f90$export$bb34f3538ba26c7e = 'priority';
const $1df76d38eb6e3f90$export$79b91d4669dcadcb = 'labels';
const $1df76d38eb6e3f90$export$cbedbfe2cd0caec7 = 'components';
const $1df76d38eb6e3f90$export$950d47e775e208ee = 'devSummary';
const $1df76d38eb6e3f90$export$f91d2bb4cc99fa5e = 'releases';
const $1df76d38eb6e3f90$export$a316570a0dbfd2b0 = 'sprint';
const $1df76d38eb6e3f90$export$405b6d72f2d243a9 = 'storyPointsField';
const $1df76d38eb6e3f90$export$3cb4a99a332e4186 = 'epic';
const $1df76d38eb6e3f90$export$d7e18f5730074533 = 'fixVersions';
const $1df76d38eb6e3f90$export$c435f0000304e508 = 'versions';
const $1df76d38eb6e3f90$export$ee99ef6ee562a446 = 'timetracking';
const $1df76d38eb6e3f90$export$a6a74b4bc927d39f = 'timeoriginalestimate';
const $1df76d38eb6e3f90$export$e50006273435e7d4 = 'status';
const $1df76d38eb6e3f90$export$f1a6ce22cbb7eb32 = 'resolution';
const $1df76d38eb6e3f90$export$ff39ebd4bb12b718 = 'created';
const $1df76d38eb6e3f90$export$cd8e68094cb5c3cb = 'updated';
const $1df76d38eb6e3f90$export$1d0e0bb6a21b800b = 'SLA_PANEL';
const $1df76d38eb6e3f90$export$340fac260c3e3637 = 'LINKED_ALERTS';
const $1df76d38eb6e3f90$export$24ec4dcc8e5b08ef = 'CHAT_CHANNEL';
const $1df76d38eb6e3f90$export$8631065e0909313 = 'MSTEAMS_CHANNEL';
const $1df76d38eb6e3f90$export$3c4dccba7d7e0acb = 'ZOOM_MEETING';
const $1df76d38eb6e3f90$export$cd5e9246357daec3 = 'CONFERENCE_CALL';
const $1df76d38eb6e3f90$export$9c83bd19c3ffd90d = 'SENTIMENT';
const $1df76d38eb6e3f90$export$c5c04443c6097d6e = 'ASSET_ONBOARDING';
const $1df76d38eb6e3f90$export$26d855f4cd7e5fe9 = 'MANAGE_STAKEHOLDERS';
const $1df76d38eb6e3f90$export$913055729e1380b2 = 'summary';
const $1df76d38eb6e3f90$export$d44826c816b5619b = 'description';
const $1df76d38eb6e3f90$export$a29989082612d0d9 = 'comment';
const $1df76d38eb6e3f90$export$8fe3d5be8cb17459 = 'epic-issues'; // this field is only served in classic projects
const $1df76d38eb6e3f90$export$3b3d0889022c85b3 = 'children-issues';
const $1df76d38eb6e3f90$export$be46596bc6608f3b = 'environment';
const $1df76d38eb6e3f90$export$f528fadbfdb3c25e = 'subtasks';
const $1df76d38eb6e3f90$export$f10e53e8928b61bd = 'dataclassification';
const $1df76d38eb6e3f90$export$e0dfb65d1047c53c = (0, $5fc53.PARENT_CF_TYPE);
const $1df76d38eb6e3f90$export$aba22e09a66f6826 = 'portfolio-child-issues';
const $1df76d38eb6e3f90$export$826d657005bbe54c = (0, $5fc53.SELECT_CF_TYPE);
const $1df76d38eb6e3f90$export$cdbd1eb3b05729e0 = 'flagActions';
const $1df76d38eb6e3f90$export$c161a774ec2e7e56 = 'cardCoverActions';
const $1df76d38eb6e3f90$export$89e5c40c0f5c7561 = ()=>{
    const fields = {
        [$1df76d38eb6e3f90$export$3cb4a99a332e4186]: 'com.pyxis.greenhopper.jira:gh-epic-link',
        [$1df76d38eb6e3f90$export$a316570a0dbfd2b0]: 'com.pyxis.greenhopper.jira:gh-sprint',
        [$1df76d38eb6e3f90$export$405b6d72f2d243a9]: 'com.atlassian.jira.plugin.system.customfieldtypes:storypoint',
        [(0, $5fc53.TEAM_CF_TYPE)]: (0, $5fc53.TEAM_CF_TYPE),
        [(0, $5fc53.PARENT_CF_TYPE)]: (0, $5fc53.PARENT_CF_TYPE),
        [(0, $5fc53.BASELINE_START_CF_TYPE)]: (0, $5fc53.BASELINE_START_CF_TYPE),
        [(0, $5fc53.BASELINE_END_CF_TYPE)]: (0, $5fc53.BASELINE_END_CF_TYPE),
        [(0, $5fc53.COLOR_CF_TYPE)]: (0, $5fc53.COLOR_CF_TYPE),
        [(0, $5fc53.EPIC_COLOR_TYPE)]: (0, $5fc53.EPIC_COLOR_TYPE),
        [(0, $5fc53.EPIC_NAME_TYPE)]: (0, $5fc53.EPIC_NAME_TYPE)
    };
    return fields;
};
const $1df76d38eb6e3f90$export$87934b3672715c91 = [
    (0, $5fc53.ISSUE_FIELD_NUMBER_CF_TYPE),
    (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
    (0, $5fc53.ISSUE_FIELD_DATETIME_CF_TYPE),
    (0, $5fc53.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE),
    (0, $5fc53.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
];
const $1df76d38eb6e3f90$var$serviceDeskCustomFields = [
    (0, $5fc53.REQUEST_PARTICIPANTS_CF_TYPE),
    (0, $5fc53.ORGANIZATIONS_CF_TYPE),
    (0, $5fc53.REQUEST_LANGUAGE_CF_TYPE),
    (0, $5fc53.REQUEST_FEEDBACK_CF_TYPE),
    (0, $5fc53.APPROVALS_CF_TYPE),
    (0, $5fc53.APPROVERS_LIST_CF_TYPE),
    (0, $5fc53.REQUEST_TYPE_CF_TYPE),
    (0, $5fc53.CMDB_OBJECT_CF_TYPE),
    (0, $5fc53.RESPONDERS_CF_TYPE),
    (0, $5fc53.MAJOR_INCIDENT_CF_TYPE),
    (0, $5fc53.ENTITLEMENT_CF_TYPE),
    (0, $5fc53.SENTIMENT_CF_TYPE),
    (0, $5fc53.ORGANIZATION_CF_TYPE)
];
const $1df76d38eb6e3f90$export$efd443bccc4c01ed = ()=>[
        (0, $5fc53.LABELS_CF_TYPE),
        (0, $5fc53.TEXT_CF_TYPE),
        (0, $5fc53.MULTI_USER_CF_TYPE),
        (0, $5fc53.PARTICIPANTS_CF_TYPE),
        (0, $5fc53.URL_CF_TYPE),
        (0, $5fc53.NUMBER_CF_TYPE),
        (0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE),
        (0, $5fc53.SELECT_CF_TYPE),
        (0, $5fc53.MULTI_SELECT_CF_TYPE),
        (0, $5fc53.VERSION_CF_TYPE),
        (0, $5fc53.TEXT_AREA_CF_TYPE),
        (0, $5fc53.MULTI_VERSION_CF_TYPE),
        (0, $5fc53.DATE_CF_TYPE),
        (0, $5fc53.GROUP_CF_TYPE),
        (0, $5fc53.MULTI_GROUP_CF_TYPE),
        (0, $5fc53.USER_CF_TYPE),
        (0, $5fc53.MULTI_CHECKBOXES_CF_TYPE),
        (0, $5fc53.RADIO_BUTTONS_CF_TYPE),
        (0, $5fc53.DATETIME_CF_TYPE),
        (0, $5fc53.ASSETS_CF_TYPE),
        (0, $5fc53.SERVICE_ENTITY_CF_TYPE),
        (0, $5fc53.PEOPLE_CF_TYPE),
        (0, $5fc53.CASCADING_SELECT_CF_TYPE),
        (0, $5fc53.PROJECT_PICKER_CF_TYPE),
        (0, $5fc53.TEAMS_PLATFORM_CF_TYPE),
        (0, $5fc53.READ_ONLY_CF_TYPE),
        (0, $5fc53.EPIC_STATUS_TYPE),
        (0, $5fc53.MESSAGE_VIEW_CF_TYPE),
        (0, $5fc53.MESSAGE_EDIT_CF_TYPE),
        (0, $5fc53.CATEGORY_TYPE),
        (0, $5fc53.GOALS_CF_TYPE),
        ...$1df76d38eb6e3f90$export$87934b3672715c91,
        ...$1df76d38eb6e3f90$var$serviceDeskCustomFields
    ];
const $1df76d38eb6e3f90$export$a18b3a656ee9c709 = {
    [(0, $2vSU6.SOFTWARE_PROJECT)]: 'https://confluence.atlassian.com/jirasoftwarecloud/configure-field-layout-in-the-issue-view-961798059.html',
    [(0, $2vSU6.CORE_PROJECT)]: 'https://confluence.atlassian.com/jiracorecloud/configure-field-layout-in-the-issue-view-961798123.html',
    [(0, $2vSU6.SERVICE_DESK_PROJECT)]: 'https://support.atlassian.com/jira-service-desk-cloud/docs/what-are-the-different-sections-in-the-issue-view/'
};
const $1df76d38eb6e3f90$export$a52507e68e7aeeb = ()=>({
        issueActions: []
    });
const $1df76d38eb6e3f90$export$381ce08838c53afa = ()=>({
        applicationKey: (0, $65mz3.default).CORE_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$27e0678365e5dcff = ()=>({
        applicationKey: (0, $65mz3.default).SOFTWARE_ISSUE,
        issueActions: [
            $1df76d38eb6e3f90$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$aebf676dfa727a1c = ()=>({
        applicationKey: (0, $65mz3.default).SIMPLE_SOFTWARE_BOARD,
        issueActions: [
            $1df76d38eb6e3f90$export$cdbd1eb3b05729e0,
            $1df76d38eb6e3f90$export$c161a774ec2e7e56
        ],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$1afca4d3eb6b218b = ()=>({
        applicationKey: (0, $65mz3.default).STANDARD_ROADMAP_ISSUE,
        issueActions: [
            $1df76d38eb6e3f90$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$8a060ed6f66c43b0 = ()=>({
        applicationKey: (0, $65mz3.default).BITBUCKET_ISSUE,
        issueActions: []
    });
const $1df76d38eb6e3f90$export$78a2cb921e46f5eb = ()=>({
        applicationKey: (0, $65mz3.default).MOBILE_ISSUE,
        issueActions: []
    });
const $1df76d38eb6e3f90$export$db1115186532f6d5 = ()=>({
        applicationKey: (0, $65mz3.default).SERVICE_DESK,
        issueActions: [],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$557d5094ec5cf234 = ()=>({
        applicationKey: (0, $65mz3.default).CONNECT_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$902f6c5cc939598a = (config)=>{
    if (config) switch(config.projectType){
        case 0, $2vSU6.SOFTWARE_PROJECT:
            if (config.isSimplified) return $1df76d38eb6e3f90$export$aebf676dfa727a1c();
            return $1df76d38eb6e3f90$export$27e0678365e5dcff();
        case 0, $2vSU6.CORE_PROJECT:
            return $1df76d38eb6e3f90$export$381ce08838c53afa();
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return $1df76d38eb6e3f90$export$db1115186532f6d5();
        default:
            // fallback to sofware config
            return $1df76d38eb6e3f90$export$27e0678365e5dcff();
    }
    return $1df76d38eb6e3f90$export$27e0678365e5dcff();
};

});



parcelRegister("8jn7A", function(module, exports) {

$parcel$export(module.exports, "checkboxSupportedTypes", () => $c89b01151f17f142$export$432ca25b66c37cc2);

var $5fc53 = parcelRequire("5fc53");
const $c89b01151f17f142$export$432ca25b66c37cc2 = [
    (0, $5fc53.MULTI_CHECKBOXES_CF_TYPE)
];

});


parcelRegister("ayltP", function(module, exports) {

$parcel$export(module.exports, "componentsClipboardHandler", () => $3e4fdb5e75808293$export$4edb8679282799b3);

var $5uXOq = parcelRequire("5uXOq");

var $1ODRz = parcelRequire("1ODRz");

var $5fc53 = parcelRequire("5fc53");

var $4UjyI = parcelRequire("4UjyI");

var $ks0ly = parcelRequire("ks0ly");

var $3O2T0 = parcelRequire("3O2T0");

var $edOg5 = parcelRequire("edOg5");
const $3e4fdb5e75808293$var$isTransformedComponentsOption = (option)=>!!option && typeof option === 'object' && 'componentId' in option && 'name' in option;
const $3e4fdb5e75808293$var$isTransformedComponents = (fieldValue)=>Array.isArray(fieldValue) && fieldValue.every($3e4fdb5e75808293$var$isTransformedComponentsOption);
const $3e4fdb5e75808293$var$isValidComponentsValue = (fieldValue)=>Array.isArray(fieldValue) && fieldValue.every((option)=>!!option && typeof option === 'object' && 'id' in option && 'name' in option);
const $3e4fdb5e75808293$var$emptyValue = [];
const $3e4fdb5e75808293$var$getPastedValue = (clipboardItem, metadata)=>{
    if (!(0, $3O2T0.assertClipboardHasRichFormat)(clipboardItem) || !(0, $3O2T0.assertClipboardDataIsCompatible)(metadata, (0, $edOg5.componentsSupportedTypes))) return [];
    if (!$3e4fdb5e75808293$var$isValidComponentsValue(metadata?.fieldValue)) return [];
    return metadata?.fieldValue;
};
function $3e4fdb5e75808293$var$assertComponentsField(field) {
    if (!field) throw new Error('Field is required');
    if (field.type !== (0, $5fc53.COMPONENTS_TYPE)) throw new Error('Field type is not supported');
}
const $3e4fdb5e75808293$var$useComponentsClipboardHandler = (issue, field)=>{
    $3e4fdb5e75808293$var$assertComponentsField(field);
    const [{ value: value }, { saveValue: saveValue }] = (0, $1ODRz.useComponentsField)({
        issueKey: issue.key,
        initialValue: $3e4fdb5e75808293$var$isTransformedComponents(field?.value) ? field.value.map((component)=>({
                id: component.componentId,
                name: component.name
            })) : $3e4fdb5e75808293$var$emptyValue
    });
    const saveValueFn = (0, $5uXOq.useCallback)((valueToSave, meta, analyticsEvent)=>/**
			 * Wrap saveValue to make sure the saved value is never set to `null`
			 */ saveValue(valueToSave ?? [], meta, analyticsEvent), [
        saveValue
    ]);
    return (0, $ks0ly.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: value?.map(({ name: name })=>name).join(', ') || '',
        currentValue: value,
        getPastedValue: $3e4fdb5e75808293$var$getPastedValue,
        saveValue: saveValueFn
    });
};
const $3e4fdb5e75808293$var$ComponentsClipboardHelper = (0, $4UjyI.createClipboardHelperComponent)($3e4fdb5e75808293$var$useComponentsClipboardHandler);
const $3e4fdb5e75808293$export$4edb8679282799b3 = {
    [(0, $5fc53.COMPONENTS_TYPE)]: $3e4fdb5e75808293$var$ComponentsClipboardHelper
};

});
parcelRegister("1ODRz", function(module, exports) {

$parcel$export(module.exports, "useComponentsField", () => $ee14033da18c8c3a$export$adf68b6acc459cc4);

var $9XE6b = parcelRequire("9XE6b");

var $lQE94 = parcelRequire("lQE94");

var $54wEF = parcelRequire("54wEF");

const $ee14033da18c8c3a$export$adf68b6acc459cc4 = ({ issueKey: issueKey, initialValue: initialValue, onSuccess: onSuccess, onFailure: onFailure })=>{
    const [{ value: fieldConfig }] = (0, $54wEF.useFieldConfig)(issueKey, (0, $e9be48d6d2c01760$export$98a935eb30de54ab));
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(fieldConfig, 'schema.type', 'array');
    const [{ loading: loading, value: value, error: error }, { saveById: saveById, saveValue: saveValue, resetError: resetError }] = (0, $lQE94.useEditField)({
        fieldKey: (0, $e9be48d6d2c01760$export$98a935eb30de54ab),
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: initialValue || null,
        onSuccess: onSuccess,
        onFailure: onFailure
    });
    return [
        {
            loading: loading,
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            saveById: saveById,
            resetError: resetError
        }
    ];
};

});
const $e9be48d6d2c01760$export$e18419056f3d184a = 'assignee';
const $e9be48d6d2c01760$export$45cafdfd629c3ca1 = 'reporter';
const $e9be48d6d2c01760$export$d5bc879e3b748593 = 'description';
const $e9be48d6d2c01760$export$a68dbc90211df1a8 = 'fixVersions';
const $e9be48d6d2c01760$export$93605f2a09aa8d26 = 'labels';
const $e9be48d6d2c01760$export$4420b7468f889692 = 'status';
const $e9be48d6d2c01760$export$e7cf1830fe735d1f = 'summary';
const $e9be48d6d2c01760$export$5fbd3b15555b9ef2 = 'timeoriginalestimate';
const $e9be48d6d2c01760$export$a5fc282ab2bf9b89 = 'issuelinks';
const $e9be48d6d2c01760$export$b52547457d714bc0 = 'epic-issues';
const $e9be48d6d2c01760$export$3cca6e37a5823d5a = 'children-issues';
const $e9be48d6d2c01760$export$98a935eb30de54ab = 'components';
const $e9be48d6d2c01760$export$f7a17147527dd688 = 'flag';


parcelRegister("edOg5", function(module, exports) {

$parcel$export(module.exports, "componentsSupportedTypes", () => $518b8de6724142ac$export$99fbea5790ee13d2);

var $5fc53 = parcelRequire("5fc53");
const $518b8de6724142ac$export$99fbea5790ee13d2 = [
    (0, $5fc53.COMPONENTS_TYPE)
];

});


parcelRegister("8WsUD", function(module, exports) {

$parcel$export(module.exports, "dateClipboardHandler", () => $0e296f48531c340f$export$e718187ed2d7ce50);

var $a3qR8 = parcelRequire("a3qR8");

var $5fc53 = parcelRequire("5fc53");

var $4UjyI = parcelRequire("4UjyI");

var $ks0ly = parcelRequire("ks0ly");

var $3O2T0 = parcelRequire("3O2T0");

var $dllQ7 = parcelRequire("dllQ7");
const $0e296f48531c340f$var$getPastedValue = (clipboardItem, metadata)=>{
    if (!(0, $3O2T0.assertClipboardHasPlainTextFormat)(clipboardItem) || !(0, $3O2T0.assertClipboardDataIsCompatible)(metadata, (0, $dllQ7.dateSupportedTypes))) return null;
    return clipboardItem.plainText;
};
function $0e296f48531c340f$var$assertDateField(field) {
    if (!field) throw new Error('Field is required');
    if (field.type !== (0, $5fc53.START_DATE_TYPE) && field.type !== (0, $5fc53.UPDATED) && field.type !== (0, $5fc53.CREATED) && field.type !== (0, $5fc53.DUE_DATE_TYPE) && field.type !== (0, $5fc53.DATE_CF_TYPE)) throw new Error('Field type is not supported');
}
const $0e296f48531c340f$var$useDateClipboardHandler = (issue, field)=>{
    $0e296f48531c340f$var$assertDateField(field);
    const [{ value: value }, { saveValue: saveValue }] = (0, $a3qR8.useDateField)({
        issueKey: issue.key,
        fieldKey: field?.fieldId,
        initialValue: field?.value
    });
    return (0, $ks0ly.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: value,
        currentValue: value,
        getPastedValue: $0e296f48531c340f$var$getPastedValue,
        saveValue: saveValue
    });
};
const $0e296f48531c340f$var$DateClipboardHelper = (0, $4UjyI.createClipboardHelperComponent)($0e296f48531c340f$var$useDateClipboardHandler);
const $0e296f48531c340f$export$e718187ed2d7ce50 = {
    [(0, $5fc53.START_DATE_TYPE)]: $0e296f48531c340f$var$DateClipboardHelper,
    [(0, $5fc53.UPDATED)]: $0e296f48531c340f$var$DateClipboardHelper,
    [(0, $5fc53.CREATED)]: $0e296f48531c340f$var$DateClipboardHelper,
    [(0, $5fc53.DUE_DATE_TYPE)]: $0e296f48531c340f$var$DateClipboardHelper,
    [(0, $5fc53.DATE_CF_TYPE)]: $0e296f48531c340f$var$DateClipboardHelper
};

});
parcelRegister("a3qR8", function(module, exports) {

$parcel$export(module.exports, "useDateField", () => $b32b8f04096d0815$export$5591b0b878c1a989);

var $lQE94 = parcelRequire("lQE94");

var $54wEF = parcelRequire("54wEF");
const $b32b8f04096d0815$export$5591b0b878c1a989 = ({ issueKey: issueKey, fieldKey: fieldKey, initialValue: initialValue, onSuccess: onSuccess })=>{
    // useFieldConfig now returns an object { value, loading } instead of just the fieldConfig value
    // if possible when touching this, try and refactor to pass the new object instead of just the value
    const [{ value: fieldConfig }] = (0, $54wEF.useFieldConfig)(issueKey, fieldKey);
    const fieldType = fieldConfig?.schema.type ?? 'date';
    const [{ loading: loading, value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $lQE94.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: initialValue || null,
        onSuccess: onSuccess
    });
    return [
        {
            loading: loading,
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});

parcelRegister("dllQ7", function(module, exports) {

$parcel$export(module.exports, "dateSupportedTypes", () => $ce6c091136a1238e$export$c1d8f1bf05dab6ae);

var $5fc53 = parcelRequire("5fc53");
const $ce6c091136a1238e$export$c1d8f1bf05dab6ae = [
    (0, $5fc53.START_DATE_TYPE),
    (0, $5fc53.UPDATED),
    (0, $5fc53.CREATED),
    (0, $5fc53.DUE_DATE_TYPE),
    (0, $5fc53.DATE_CF_TYPE)
];

});


parcelRegister("inOlw", function(module, exports) {

$parcel$export(module.exports, "dateTimeClipboardHandler", () => $8eed2e51af79adf5$export$6fbf80b68eb3090c);

var $3c83i = parcelRequire("3c83i");

var $5fc53 = parcelRequire("5fc53");

var $4UjyI = parcelRequire("4UjyI");

var $ks0ly = parcelRequire("ks0ly");

var $3O2T0 = parcelRequire("3O2T0");

var $9zEWU = parcelRequire("9zEWU");
const $8eed2e51af79adf5$var$getPastedValue = (clipboardItem, metadata)=>{
    if (!(0, $3O2T0.assertClipboardHasPlainTextFormat)(clipboardItem) || !(0, $3O2T0.assertClipboardDataIsCompatible)(metadata, (0, $9zEWU.dateTimeSupportedTypes))) return null;
    return clipboardItem.plainText;
};
function $8eed2e51af79adf5$var$assertDateTimeField(field) {
    if (!field) throw new Error('Field is required');
    if (field.type !== (0, $5fc53.DATETIME_CF_TYPE)) throw new Error('Field type is not supported');
}
const $8eed2e51af79adf5$var$useDateTimeClipboardHandler = (issue, field)=>{
    $8eed2e51af79adf5$var$assertDateTimeField(field);
    const [{ value: value }, { saveValue: saveValue }] = (0, $3c83i.useDateTimeField)({
        issueKey: issue.key,
        fieldKey: field?.fieldId,
        initialValue: field?.value || null
    });
    return (0, $ks0ly.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: value,
        currentValue: value,
        getPastedValue: $8eed2e51af79adf5$var$getPastedValue,
        saveValue: saveValue
    });
};
const $8eed2e51af79adf5$var$DateTimeClipboardHelper = (0, $4UjyI.createClipboardHelperComponent)($8eed2e51af79adf5$var$useDateTimeClipboardHandler);
const $8eed2e51af79adf5$export$6fbf80b68eb3090c = {
    [(0, $5fc53.DATETIME_CF_TYPE)]: $8eed2e51af79adf5$var$DateTimeClipboardHelper
};

});
parcelRegister("3c83i", function(module, exports) {

$parcel$export(module.exports, "useDateTimeField", () => $7f247d23c9fd3e62$export$2c2e7f1ceedfa8fa);

var $lQE94 = parcelRequire("lQE94");

var $54wEF = parcelRequire("54wEF");
const $7f247d23c9fd3e62$export$2c2e7f1ceedfa8fa = ({ issueKey: issueKey, fieldKey: fieldKey, initialValue: initialValue, onSuccess: onSuccess, onFailure: onFailure })=>{
    // useFieldConfig now returns an object { value, loading } instead of just the fieldConfig value
    // if possible when touching this, try and refactor to pass the new object instead of just the value
    const [{ value: fieldConfig }] = (0, $54wEF.useFieldConfig)(issueKey, fieldKey);
    const fieldType = fieldConfig?.schema.type ?? 'datetime';
    const [{ loading: loading, value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $lQE94.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: initialValue || null,
        onSuccess: onSuccess,
        onFailure: onFailure
    });
    return [
        {
            loading: loading,
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});

parcelRegister("9zEWU", function(module, exports) {

$parcel$export(module.exports, "dateTimeSupportedTypes", () => $dd83f9f28fcc0252$export$80f63aa16e4e1227);

var $5fc53 = parcelRequire("5fc53");
const $dd83f9f28fcc0252$export$80f63aa16e4e1227 = [
    (0, $5fc53.DATETIME_CF_TYPE)
];

});


parcelRegister("bZjVN", function(module, exports) {

$parcel$export(module.exports, "groupClipboardHandler", () => $a4549a8af071c112$export$ae43e91e8e2e40e7);

var $lQE94 = parcelRequire("lQE94");

var $5fc53 = parcelRequire("5fc53");

var $4UjyI = parcelRequire("4UjyI");

var $ks0ly = parcelRequire("ks0ly");

var $3O2T0 = parcelRequire("3O2T0");

var $ekKiJ = parcelRequire("ekKiJ");
const $a4549a8af071c112$var$isTransformedSingleGroup = (option)=>!!option && typeof option === 'object' && 'groupId' in option && 'name' in option;
const $a4549a8af071c112$var$isTransformedMultipleGroups = (fieldValue)=>Array.isArray(fieldValue) && fieldValue.every($a4549a8af071c112$var$isTransformedSingleGroup);
const $a4549a8af071c112$var$emptyValue = [];
const $a4549a8af071c112$var$getPastedSingleGroupValue = (clipboardItem, metadata)=>{
    if (!(0, $3O2T0.assertClipboardHasRichFormat)(clipboardItem) || !(0, $3O2T0.assertClipboardDataIsCompatible)(metadata, (0, $ekKiJ.groupSupportedTypes))) return null;
    if (!$a4549a8af071c112$var$isTransformedSingleGroup(metadata.fieldValue)) return null;
    return metadata?.fieldValue;
};
const $a4549a8af071c112$var$getPastedMultipleGroupsValue = (clipboardItem, metadata)=>{
    if (!(0, $3O2T0.assertClipboardHasRichFormat)(clipboardItem) || !(0, $3O2T0.assertClipboardDataIsCompatible)(metadata, (0, $ekKiJ.groupSupportedTypes))) return null;
    if (!$a4549a8af071c112$var$isTransformedMultipleGroups(metadata.fieldValue)) return null;
    return metadata?.fieldValue;
};
const $a4549a8af071c112$var$useSingleGroupClipboardHandler = (issue, field)=>{
    const [{ value: value }, { saveValue: saveValue }] = (0, $lQE94.useEditField)({
        fieldKey: field.fieldId,
        issueKey: issue.key,
        fieldType: field.type,
        initialValue: $a4549a8af071c112$var$isTransformedSingleGroup(field.value) ? field.value : null
    });
    return (0, $ks0ly.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: value?.name || null,
        currentValue: value,
        getPastedValue: $a4549a8af071c112$var$getPastedSingleGroupValue,
        saveValue: saveValue
    });
};
const $a4549a8af071c112$var$useMultipleGroupsClipboardHandler = (issue, field)=>{
    const [{ value: value }, { saveValue: saveValue }] = (0, $lQE94.useEditField)({
        fieldKey: field.fieldId,
        issueKey: issue.key,
        fieldType: field.type,
        initialValue: $a4549a8af071c112$var$isTransformedMultipleGroups(field.value) ? field.value : $a4549a8af071c112$var$emptyValue
    });
    return (0, $ks0ly.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: value?.map((group)=>group.name).join(', ') || null,
        currentValue: value,
        getPastedValue: $a4549a8af071c112$var$getPastedMultipleGroupsValue,
        saveValue: saveValue
    });
};
const $a4549a8af071c112$var$SingleGroupClipboardHelper = (0, $4UjyI.createClipboardHelperComponent)($a4549a8af071c112$var$useSingleGroupClipboardHandler);
const $a4549a8af071c112$var$MultipleGroupsClipboardHelper = (0, $4UjyI.createClipboardHelperComponent)($a4549a8af071c112$var$useMultipleGroupsClipboardHandler);
const $a4549a8af071c112$export$ae43e91e8e2e40e7 = {
    [(0, $5fc53.GROUP_CF_TYPE)]: $a4549a8af071c112$var$SingleGroupClipboardHelper,
    [(0, $5fc53.MULTI_GROUP_CF_TYPE)]: $a4549a8af071c112$var$MultipleGroupsClipboardHelper
};

});

parcelRegister("7Y57h", function(module, exports) {

$parcel$export(module.exports, "labelsClipboardHandler", () => $0aba695b13ee6ae7$export$b0d4c8fecec395de);

var $iY5Zn = parcelRequire("iY5Zn");

var $5fc53 = parcelRequire("5fc53");

var $4UjyI = parcelRequire("4UjyI");

var $ks0ly = parcelRequire("ks0ly");

var $3O2T0 = parcelRequire("3O2T0");
const $0aba695b13ee6ae7$var$getPastedValue = (clipboardItem, metadata)=>{
    if (!(0, $3O2T0.assertClipboardHasPlainTextFormat)(clipboardItem) || !(0, $3O2T0.assertClipboardDataIsCompatible)(metadata, [
        (0, $5fc53.LABELS_TYPE),
        (0, $5fc53.LABELS_CF_TYPE)
    ])) return null;
    return clipboardItem.plainText.split(',').map((label)=>label.trim());
};
function $0aba695b13ee6ae7$var$assertLabelsField(field) {
    if (!field) throw new Error('Field is required');
    if (field.type !== (0, $5fc53.LABELS_TYPE) && field.type !== (0, $5fc53.LABELS_CF_TYPE)) throw new Error('Field type is not supported');
}
function $0aba695b13ee6ae7$var$isNotNull(value) {
    return value !== null;
}
const $0aba695b13ee6ae7$var$useLabelsClipboardHandler = (issue, field)=>{
    $0aba695b13ee6ae7$var$assertLabelsField(field);
    const [{ value: value }, { saveValue: saveValue }] = (0, $iY5Zn.useLabelsField)({
        issueKey: issue.key,
        issueId: issue.issueId,
        fieldKey: field?.fieldId,
        initialValue: Array.isArray(field?.value) ? field.value.filter($0aba695b13ee6ae7$var$isNotNull) : []
    });
    return (0, $ks0ly.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: value?.join(', ') || '',
        currentValue: value,
        getPastedValue: $0aba695b13ee6ae7$var$getPastedValue,
        saveValue: saveValue
    });
};
const $0aba695b13ee6ae7$var$LabelsClipboardHelper = (0, $4UjyI.createClipboardHelperComponent)($0aba695b13ee6ae7$var$useLabelsClipboardHandler);
const $0aba695b13ee6ae7$export$b0d4c8fecec395de = {
    [(0, $5fc53.LABELS_TYPE)]: $0aba695b13ee6ae7$var$LabelsClipboardHelper,
    [(0, $5fc53.LABELS_CF_TYPE)]: $0aba695b13ee6ae7$var$LabelsClipboardHelper
};

});
parcelRegister("iY5Zn", function(module, exports) {

$parcel$export(module.exports, "useLabelsField", () => $bfbd97057d68d7c4$export$64894e54f74d7bc5);

var $9XE6b = parcelRequire("9XE6b");

var $lQE94 = parcelRequire("lQE94");

var $54wEF = parcelRequire("54wEF");


var $9sTOh = parcelRequire("9sTOh");
const $bfbd97057d68d7c4$export$64894e54f74d7bc5 = ({ fieldKey: // `fieldKey` can be `labels` or `customfield_`
fieldKey, issueId: issueId, issueKey: issueKey, fieldType: fieldType, onSuccess: onSuccess, onFailure: onFailure, initialValue: initialValue })=>{
    const saveLabelsFieldField = (0, $9sTOh.useSaveLabelsField)(issueId);
    const saveField = saveLabelsFieldField;
    const [{ value: fieldConfig }] = (0, $54wEF.useFieldConfig)(issueKey, fieldKey);
    const labelsFieldType = fieldType || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(fieldConfig, 'schema.type', 'array');
    // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
    const [{ error: error, value: value }, { resetError: resetError, saveValue: saveValue }] = (0, $lQE94.useEditField)({
        fieldType: labelsFieldType,
        issueId: issueId,
        issueKey: issueKey,
        onSuccess: onSuccess,
        onFailure: onFailure,
        initialValue: initialValue || null,
        fieldKey: fieldKey || (0, $e9be48d6d2c01760$export$93605f2a09aa8d26),
        saveField: saveField
    });
    return [
        {
            error: error,
            value: value,
            fieldConfig: fieldConfig
        },
        {
            resetError: resetError,
            saveValue: saveValue
        }
    ];
};

});
parcelRegister("9sTOh", function(module, exports) {

$parcel$export(module.exports, "useSaveLabelsField", () => $bfea513db97883c2$export$212ad40ad2c2a1db);

var $l32RZ = parcelRequire("l32RZ");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $jJZqs = parcelRequire("jJZqs");

var $koeKL = parcelRequire("koeKL");
/**
 * @deprecated (do not copy/use) TODO: find a way to get ari rather than building it
 * https://jplat.atlassian.net/browse/JIV-13978
 */ const $bfea513db97883c2$var$buildId = (cloudId, issueId, fieldKey)=>`ari:cloud:jira:${cloudId}:issuefieldvalue/${issueId}/${fieldKey}`;
const $bfea513db97883c2$export$212ad40ad2c2a1db = (issueId)=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const [commit] = (0, $8Uumt.useMutation)((0, $l32RZ.default));
    return (0, $5uXOq.useCallback)(async (_issueKey, fieldKey, value)=>new Promise((resolve, reject)=>{
            commit({
                variables: {
                    input: {
                        id: $bfea513db97883c2$var$buildId(cloudId, issueId, fieldKey),
                        operations: [
                            {
                                operation: 'SET',
                                labels: value || []
                            }
                        ]
                    }
                },
                onCompleted (mutationData) {
                    if (mutationData.jira?.updateLabelsField) {
                        const { success: success, errors: responseErrors } = mutationData.jira?.updateLabelsField;
                        if (success) {
                            resolve();
                            return;
                        }
                        if (responseErrors?.length) reject(responseErrors[0].message ? new (0, $jJZqs.ValidationError)(responseErrors[0].message) : new Error('Unknown error when mutating labels'));
                    } else reject(new Error('Unknown error when mutating labels'));
                },
                onError (error) {
                    reject(error);
                }
            });
        }), [
        cloudId,
        commit,
        issueId
    ]);
};

});
parcelRegister("l32RZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b06b0a9852b299ba$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<02958262adc79579690047a7d7c476b7>>
 * @relayHash 30b56244c1b7e036e52debb35dd6fcf2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d9561e4e88b317e2954d5ed9798719aaa143c5c332b9bc9b9f0da41947c9216b
const $b06b0a9852b299ba$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSaveLabelsField_LabelsMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraLabelsFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateLabelsField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraLabelsField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "labels_issueFieldLabelsInlineEditViewFull_LabelsInlineEditView"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSaveLabelsField_LabelsMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraLabelsFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateLabelsField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraLabelsField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "first",
                                                    "value": 1000
                                                }
                                            ],
                                            "concreteType": "JiraLabelConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedLabelsConnection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "totalCount"
                                                },
                                                {
                                                    "concreteType": "JiraLabelEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraLabel",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "selectedLabelsConnection(first:1000)"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        },
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "concreteType": "JiraFieldConfig",
                                            "kind": "LinkedField",
                                            "name": "fieldConfig",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isEditable"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d9561e4e88b317e2954d5ed9798719aaa143c5c332b9bc9b9f0da41947c9216b",
            "metadata": {},
            "name": "useSaveLabelsField_LabelsMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$b06b0a9852b299ba$var$node.hash = "8ad20115daf17ea5e9001db36624cdd7";
var $b06b0a9852b299ba$export$2e2bcd8739ae039 = $b06b0a9852b299ba$var$node;

});




parcelRegister("1ZojP", function(module, exports) {

$parcel$export(module.exports, "multiSelectClipboardHandler", () => $8ccd5b5ee2d1f5bd$export$4181cf95bcdec65a);

var $hWkQo = parcelRequire("hWkQo");

var $5fc53 = parcelRequire("5fc53");

var $4UjyI = parcelRequire("4UjyI");

var $ks0ly = parcelRequire("ks0ly");

var $3O2T0 = parcelRequire("3O2T0");

var $Hn0D6 = parcelRequire("Hn0D6");
const $8ccd5b5ee2d1f5bd$var$isTransformedMultiSelectOption = (option)=>!!option && typeof option === 'object' && 'optionId' in option && 'value' in option;
const $8ccd5b5ee2d1f5bd$var$isTransformedMultiSelect = (fieldValue)=>Array.isArray(fieldValue) && fieldValue.every($8ccd5b5ee2d1f5bd$var$isTransformedMultiSelectOption);
const $8ccd5b5ee2d1f5bd$var$isMultiSelectValue = (fieldValue)=>Array.isArray(fieldValue) && fieldValue.every((option)=>!!option && typeof option === 'object' && 'id' in option && 'value' in option);
const $8ccd5b5ee2d1f5bd$var$emptyValue = [];
function $8ccd5b5ee2d1f5bd$var$isNotNull(value) {
    return value !== null;
}
const $8ccd5b5ee2d1f5bd$var$getPastedValue = (clipboardItem, metadata)=>{
    if (!(0, $3O2T0.assertClipboardHasRichFormat)(clipboardItem) || !(0, $3O2T0.assertClipboardDataIsCompatible)(metadata, (0, $Hn0D6.multiSelectSupportedTypes))) return null;
    if (!$8ccd5b5ee2d1f5bd$var$isMultiSelectValue(metadata.fieldValue)) return null;
    return metadata.fieldValue?.filter($8ccd5b5ee2d1f5bd$var$isNotNull) ?? null;
};
function $8ccd5b5ee2d1f5bd$var$assertMultiSelectField(field) {
    if (!field) throw new Error('Field is required');
    if (field.type !== (0, $5fc53.MULTI_SELECT_CF_TYPE)) throw new Error('Field type is not supported');
}
const $8ccd5b5ee2d1f5bd$var$useMultiSelectClipboardHandler = (issue, field)=>{
    $8ccd5b5ee2d1f5bd$var$assertMultiSelectField(field);
    const [{ value: value }, { saveValue: saveValue }] = (0, $hWkQo.useMultiSelectField)({
        fieldKey: field.fieldId,
        issueKey: issue.key,
        fieldType: (0, $5fc53.MULTI_SELECT_CF_TYPE),
        initialValue: $8ccd5b5ee2d1f5bd$var$isTransformedMultiSelect(field.value) ? field.value.map((option)=>({
                id: option.optionId,
                value: option.value
            })) : $8ccd5b5ee2d1f5bd$var$emptyValue
    });
    // ensure it is an array instead of null
    const saveFn = (valueToSave, meta, analyticsEvent)=>saveValue(valueToSave ?? $8ccd5b5ee2d1f5bd$var$emptyValue, meta, analyticsEvent);
    return (0, $ks0ly.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: value?.map((option)=>option.value).join(', ') || '',
        currentValue: value,
        getPastedValue: $8ccd5b5ee2d1f5bd$var$getPastedValue,
        saveValue: saveFn
    });
};
const $8ccd5b5ee2d1f5bd$var$MultiSelectClipboardHelper = (0, $4UjyI.createClipboardHelperComponent)($8ccd5b5ee2d1f5bd$var$useMultiSelectClipboardHandler);
const $8ccd5b5ee2d1f5bd$export$4181cf95bcdec65a = {
    [(0, $5fc53.MULTI_SELECT_CF_TYPE)]: $8ccd5b5ee2d1f5bd$var$MultiSelectClipboardHelper
};

});
parcelRegister("hWkQo", function(module, exports) {

$parcel$export(module.exports, "useSingleSelectField", () => $960925b05bbc934f$export$de455e978fcfd3cf);
$parcel$export(module.exports, "useMultiSelectField", () => $960925b05bbc934f$export$a996b308983609cf);

var $lQE94 = parcelRequire("lQE94");

var $54wEF = parcelRequire("54wEF");

var $69oHP = parcelRequire("69oHP");

var $aorE7 = parcelRequire("aorE7");
const $960925b05bbc934f$var$useSelectField = ({ issueKey: issueKey, fieldKey: fieldKey, fieldDefaultSchemaType: fieldDefaultSchemaType, onSuccess: onSuccess, onFailure: onFailure, saveField: saveField, fieldType: fieldType, initialValue: initialValue })=>{
    const [fieldConfig] = (0, $54wEF.useFieldConfig)(issueKey, fieldKey);
    const resolvedFieldType = fieldType || (0, $69oHP.getFieldType)(fieldConfig.value) || fieldDefaultSchemaType;
    const [{ value: value, loading: loading, error: error }, { saveValue: saveValue, saveById: saveById, resetError: resetError }] = (0, $lQE94.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: resolvedFieldType,
        initialValue: // @ts-expect-error Fix in https://jplat.jira.atlassian.cloud/browse/JIV-17559
        initialValue,
        onSuccess: onSuccess,
        onFailure: onFailure,
        saveField: saveField
    });
    return [
        {
            value: value,
            loading: loading,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            saveById: saveById,
            resetError: resetError
        }
    ];
};
const $960925b05bbc934f$export$de455e978fcfd3cf = (props)=>{
    const saveSingleSelectField = (0, $aorE7.useSingleSelectMutation)();
    return $960925b05bbc934f$var$useSelectField({
        ...props,
        saveField: saveSingleSelectField,
        fieldDefaultSchemaType: 'option'
    });
};
const $960925b05bbc934f$export$a996b308983609cf = (props)=>$960925b05bbc934f$var$useSelectField({
        ...props,
        fieldDefaultSchemaType: 'array'
    });

});
parcelRegister("aorE7", function(module, exports) {

$parcel$export(module.exports, "useSingleSelectMutation", () => $e4e6c684acb49b66$export$e568023bd1bde626);

var $cRpav = parcelRequire("cRpav");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $jJZqs = parcelRequire("jJZqs");

var $2gCtH = parcelRequire("2gCtH");

var $koeKL = parcelRequire("koeKL");

var $kSlPt = parcelRequire("kSlPt");
function $e4e6c684acb49b66$export$e568023bd1bde626() {
    const cloudId = (0, $koeKL.useCloudId)();
    const issueContextIssueId = (0, $2gCtH.useIssueId)();
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const [commit] = (0, $8Uumt.useMutation)((0, $cRpav.default));
    return (0, $5uXOq.useCallback)(async (issueKey, fieldId, option)=>{
        const { issueId: issueId, fieldOptionAri: fieldOptionAri } = await (0, $kSlPt.fetchMissingIssueAndFieldOptionData)(issueContextIssueId, option, environment, {
            cloudId: cloudId,
            issueKey: issueKey,
            fieldId: fieldId
        });
        return new Promise((resolve, reject)=>{
            commit({
                variables: {
                    input: {
                        // @todo: we shouldn't be manually constructing ARIs
                        // https://jplat.jira.atlassian.cloud/browse/JIV-16566
                        id: `ari:cloud:jira:${cloudId}:issuefieldvalue/${issueId}/${fieldId}`,
                        operation: {
                            operation: 'SET',
                            id: fieldOptionAri
                        }
                    }
                },
                onCompleted (data) {
                    if (!data.jira?.updateSingleSelectField) {
                        reject(new Error('unknown error occurred'));
                        return;
                    }
                    const { success: success, errors: errors, field: field } = data.jira.updateSingleSelectField;
                    if (!success || errors?.length) {
                        reject(errors?.[0].message ? new (0, $jJZqs.ValidationError)(errors[0].message) : new Error('unknown error occurred'));
                        return;
                    }
                    resolve(field?.fieldOption ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    {
                        ari: field.fieldOption.id,
                        value: field.fieldOption.value,
                        id: field.fieldOption.optionId
                    } : null);
                },
                onError: reject
            });
        });
    }, [
        cloudId,
        commit,
        environment,
        issueContextIssueId
    ]);
}

});
parcelRegister("cRpav", function(module, exports) {

$parcel$export(module.exports, "default", () => $443ef4dbea26c47c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b7735160732824337ac8d363f0c91a06>>
 * @relayHash 396cef6d317a9982d56bae0401d0192f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e79778d8ae574a33e0439f2d59888b0f1b3db2a38ec6c0682cf054fcc665db61
const $443ef4dbea26c47c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "concreteType": "JiraOption",
        "kind": "LinkedField",
        "name": "fieldOption",
        "plural": false,
        "selections": [
            v4 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "optionId"
            },
            {
                "kind": "ScalarField",
                "name": "value"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSingleSelectMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSingleSelectFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSingleSelectField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraSingleSelectField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSingleSelectMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSingleSelectFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSingleSelectField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraSingleSelectField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e79778d8ae574a33e0439f2d59888b0f1b3db2a38ec6c0682cf054fcc665db61",
            "metadata": {},
            "name": "useSingleSelectMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$443ef4dbea26c47c$var$node.hash = "b8d6036932768e6445d7615f80fc6acb";
var $443ef4dbea26c47c$export$2e2bcd8739ae039 = $443ef4dbea26c47c$var$node;

});

parcelRegister("kSlPt", function(module, exports) {

$parcel$export(module.exports, "fetchMissingIssueAndFieldOptionData", () => $04141e8649a14bd2$export$def6f7858b27fc01);

var $8KOXt = parcelRequire("8KOXt");

var $8Uumt = parcelRequire("8Uumt");
async function $04141e8649a14bd2$export$def6f7858b27fc01(issueId, option, environment, vars) {
    const skipFieldOptionAri = option === null || Boolean(option.ari);
    // we have all the data required to make the mutation. if the field option
    // value is null that means we are unsetting so an ari is not required
    if (issueId && skipFieldOptionAri) return {
        issueId: issueId,
        fieldOptionAri: option?.ari ?? null
    };
    const result = await (0, $8Uumt.fetchQuery)(environment, (0, $8KOXt.default), {
        ...vars,
        // @todo: how do we scale when the value is empty for fields with large
        //        amount of options
        // @see https://jplat.jira.atlassian.cloud/browse/JIV-16573
        searchBy: option?.value,
        skipFieldOptionAri: skipFieldOptionAri
    }, {
        fetchPolicy: 'store-or-network'
    }).toPromise();
    const jiraIssue = result?.jira?.issueByKey;
    if (!jiraIssue?.issueId) throw new Error('failed fetch issue id');
    let ari = option != null ? option?.ari : null;
    if (!skipFieldOptionAri) ari = option ? jiraIssue?.fieldsById?.edges?.[0]?.node?.fieldOptions?.edges?.find((opt)=>opt?.node?.optionId === option.id)?.node?.id : null;
    // ari being null is still valid request as the user will be unsetting it
    // so here we check for undefined only meaning that the query above returned
    // an empty options connection, or we could not match the `optionId` from the
    // nodes in the connection.
    if (ari === undefined) throw new Error('failed to fetch field option ari');
    return {
        issueId: jiraIssue.issueId,
        fieldOptionAri: ari
    };
}

});
parcelRegister("8KOXt", function(module, exports) {

$parcel$export(module.exports, "default", () => $16036a00db06e9b2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c6ed6f2e80602085b4937748ddaf953d>>
 * @relayHash 524d85ce5dded2d9716dceedb13042f0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b143065b2371a01a056e06ca6a0f574cd106056b83483283319b3b7d3d180d58
const $16036a00db06e9b2$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueKey"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchBy"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skipFieldOptionAri"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "issueKey"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v7 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "ids.0",
                    "variableName": "fieldId"
                }
            ],
            "kind": "ListValue",
            "name": "ids"
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "searchBy",
                        "variableName": "searchBy"
                    }
                ],
                "concreteType": "JiraOptionConnection",
                "kind": "LinkedField",
                "name": "fieldOptions",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraOptionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v8 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "optionId"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraSingleSelectField"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "utilsUseSingleSelectMutationMissingIssueAndFieldOptionDataQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueByKey",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "condition": "skipFieldOptionAri",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "args": v7 /*: any*/ ,
                                            "concreteType": "JiraIssueFieldConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldsById",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueFieldEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v9 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "utilsUseSingleSelectMutationMissingIssueAndFieldOptionDataQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueByKey",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "condition": "skipFieldOptionAri",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "args": v7 /*: any*/ ,
                                            "concreteType": "JiraIssueFieldConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldsById",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueFieldEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__typename"
                                                                },
                                                                v9 /*: any*/ ,
                                                                v8 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v8 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b143065b2371a01a056e06ca6a0f574cd106056b83483283319b3b7d3d180d58",
            "metadata": {},
            "name": "utilsUseSingleSelectMutationMissingIssueAndFieldOptionDataQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$16036a00db06e9b2$var$node.hash = "9fecb581bfb367efbee5768f0f78cc7a";
var $16036a00db06e9b2$export$2e2bcd8739ae039 = $16036a00db06e9b2$var$node;

});




parcelRegister("Hn0D6", function(module, exports) {

$parcel$export(module.exports, "multiSelectSupportedTypes", () => $3c0f93086e9e92c6$export$9cb7f11173b6b689);

var $5fc53 = parcelRequire("5fc53");
const $3c0f93086e9e92c6$export$9cb7f11173b6b689 = [
    (0, $5fc53.MULTI_SELECT_CF_TYPE)
];

});


parcelRegister("233vh", function(module, exports) {

$parcel$export(module.exports, "numberClipboardHandler", () => $f90ed9f2a3070025$export$801c183086232047);

var $bj6Oi = parcelRequire("bj6Oi");

var $3wves = parcelRequire("3wves");

var $5fc53 = parcelRequire("5fc53");

var $1xoxe = parcelRequire("1xoxe");

var $4UjyI = parcelRequire("4UjyI");

var $ks0ly = parcelRequire("ks0ly");

var $3O2T0 = parcelRequire("3O2T0");
const $f90ed9f2a3070025$var$getPastedValue = (clipboardItem)=>{
    if (!(0, $3O2T0.assertClipboardHasPlainTextFormat)(clipboardItem)) return null;
    if (Number.isNaN(Number(clipboardItem.plainText))) throw new (0, $bj6Oi.ClientSideValidationError)((0, $1xoxe.VALIDATION_ERROR_CODES).NON_COMPATIBLE_FIELD_TYPE);
    return Number(clipboardItem.plainText);
};
const $f90ed9f2a3070025$var$useNumberClipboardHandler = (issue, field)=>{
    const [{ value: value }, { saveValue: saveValue }] = (0, $3wves.useNumberField)({
        issueKey: issue.key,
        fieldKey: field?.fieldId,
        initialValue: typeof field?.value === 'number' ? field?.value : undefined
    });
    return (0, $ks0ly.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: typeof value === 'number' ? String(value) : null,
        currentValue: value,
        getPastedValue: $f90ed9f2a3070025$var$getPastedValue,
        saveValue: saveValue
    });
};
const $f90ed9f2a3070025$var$NumberClipboardHelper = (0, $4UjyI.createClipboardHelperComponent)($f90ed9f2a3070025$var$useNumberClipboardHandler);
const $f90ed9f2a3070025$export$801c183086232047 = {
    [(0, $5fc53.NUMBER_CF_TYPE)]: $f90ed9f2a3070025$var$NumberClipboardHelper,
    [(0, $5fc53.STORY_POINTS_TYPE)]: $f90ed9f2a3070025$var$NumberClipboardHelper,
    [(0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE)]: $f90ed9f2a3070025$var$NumberClipboardHelper
};

});
parcelRegister("3wves", function(module, exports) {

$parcel$export(module.exports, "useNumberField", () => $b5136d35d41d8f83$export$23f548e970bdf099);

var $9XE6b = parcelRequire("9XE6b");

var $lQE94 = parcelRequire("lQE94");

var $54wEF = parcelRequire("54wEF");
const $b5136d35d41d8f83$export$23f548e970bdf099 = ({ issueKey: issueKey, fieldKey: fieldKey, initialValue: initialValue, onSubmit: onSubmit, onSuccess: onSuccess, onFailure: onFailure, saveField: saveField })=>{
    // useFieldConfig now returns an object { value, loading } instead of just the fieldConfig value
    // if possible when touching this, try and refactor to pass the new object instead of just the value
    const [{ value: fieldConfig }] = (0, $54wEF.useFieldConfig)(issueKey, fieldKey);
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(fieldConfig, 'schema.type', 'number');
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $lQE94.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: initialValue || null,
        onSubmit: onSubmit,
        onSuccess: onSuccess,
        onFailure: onFailure,
        saveField: saveField
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});


parcelRegister("62Lxt", function(module, exports) {

$parcel$export(module.exports, "parentClipboardHandler", () => $1d8be24e4a514978$export$a8a030d8148a051e);

var $5uXOq = parcelRequire("5uXOq");

var $4FipU = parcelRequire("4FipU");

var $5fc53 = parcelRequire("5fc53");

var $4UjyI = parcelRequire("4UjyI");

var $ks0ly = parcelRequire("ks0ly");

var $3O2T0 = parcelRequire("3O2T0");
const $1d8be24e4a514978$var$isTransformedParentOption = (fieldValue)=>fieldValue != null && typeof fieldValue === 'object' && 'issueKey' in fieldValue && 'summary' in fieldValue && 'issueType' in fieldValue && 'issueId' in fieldValue;
const $1d8be24e4a514978$var$isParentOption = (fieldValue)=>fieldValue != null && typeof fieldValue === 'object' && 'value' in fieldValue && 'label' in fieldValue && 'key' in fieldValue && 'fields' in fieldValue;
const $1d8be24e4a514978$var$getPastedValue = (clipboardItem, metadata, issue)=>{
    if (!(0, $3O2T0.assertClipboardHasRichFormat)(clipboardItem) || !(0, $3O2T0.assertClipboardDataIsCompatible)(metadata, [
        (0, $5fc53.PARENT_TYPE)
    ])) return null;
    // only paste when level is the same for source and destination issues
    if (String(issue?.issueType?.level) !== metadata.sourceIssueTypeLevel) return null;
    if (!$1d8be24e4a514978$var$isParentOption(metadata.fieldValue)) return null;
    return metadata.fieldValue;
};
const $1d8be24e4a514978$var$toParentFieldOption = (value)=>{
    const { issueKey: issueKey, issueId: issueId, summary: summary, issueType: issueType } = value;
    if (summary == null || issueType == null) return null;
    return {
        value: issueId,
        label: summary,
        key: issueKey,
        fields: {
            summary: summary,
            issuetype: issueType
        }
    };
};
const $1d8be24e4a514978$var$useParentClipboardHandler = (issue, field)=>{
    const [{ value: value }, { saveValue: saveValue }] = (0, $4FipU.useParentField)({
        fieldKey: field.fieldId,
        issueKey: issue.key,
        issueId: issue.issueId,
        initialValue: $1d8be24e4a514978$var$isTransformedParentOption(field.value) ? $1d8be24e4a514978$var$toParentFieldOption(field.value) : null
    });
    const createPastedValueWithIssue = (0, $5uXOq.useMemo)(()=>(clipboardItem, metadata)=>$1d8be24e4a514978$var$getPastedValue(clipboardItem, metadata, issue), [
        issue
    ]);
    return (0, $ks0ly.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: value?.key ?? '',
        currentValue: value,
        getPastedValue: createPastedValueWithIssue,
        saveValue: saveValue
    });
};
const $1d8be24e4a514978$var$ParentClipboardHelper = (0, $4UjyI.createClipboardHelperComponent)($1d8be24e4a514978$var$useParentClipboardHandler);
const $1d8be24e4a514978$export$a8a030d8148a051e = {
    [(0, $5fc53.PARENT_TYPE)]: $1d8be24e4a514978$var$ParentClipboardHelper
};

});
parcelRegister("4FipU", function(module, exports) {

$parcel$export(module.exports, "useParentField", () => $9abd8b32d92effd3$export$23f8a245702eecc6);

var $4R6GH = parcelRequire("4R6GH");

var $eusud = parcelRequire("eusud");

var $lQE94 = parcelRequire("lQE94");

var $54wEF = parcelRequire("54wEF");

var $5fc53 = parcelRequire("5fc53");
const $9abd8b32d92effd3$export$984ebf992eeb92e6 = async (issueKey, fieldKey, newValue)=>(0, $eusud.performPutRequest)(`/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify({
            fields: {
                [fieldKey]: newValue && newValue.value ? {
                    id: newValue.value
                } : null
            }
        })
    });
const $9abd8b32d92effd3$export$aee311d2cd3543e6 = (response)=>{
    if (!response?.fields) return null;
    return response.fields.parent;
};
const $9abd8b32d92effd3$export$23f8a245702eecc6 = (props)=>{
    const { fieldKey: fieldKey, issueId: issueId, issueKey: issueKey, onSuccess: onSuccess, onFailure: onFailure, onSaveField: onSaveField, initialValue: initialValue = null } = props;
    const [{ value: fieldConfig }] = (0, $54wEF.useFieldConfig)(issueKey, fieldKey);
    const fieldType = fieldConfig?.schema.custom ?? (0, $5fc53.PARENT_TYPE);
    const [{ error: error, value: value }, { resetError: resetError, saveValue: saveValue, saveById: saveById }] = (0, $lQE94.useEditField)({
        fieldKey: fieldKey,
        fieldType: fieldType,
        issueId: issueId,
        issueKey: issueKey,
        onSuccess: onSuccess,
        onFailure: onFailure,
        initialValue: initialValue,
        saveField: onSaveField && (0, $4R6GH.fg)('issue_view_in_program_board') ? onSaveField : $9abd8b32d92effd3$export$984ebf992eeb92e6,
        mapNonOptimisticResponse: $9abd8b32d92effd3$export$aee311d2cd3543e6
    });
    const valueOption = value || null;
    return [
        {
            value: valueOption,
            fieldConfig: fieldConfig,
            error: error
        },
        {
            saveValue: saveValue,
            saveById: saveById,
            resetError: resetError
        }
    ];
};

});


parcelRegister("eOY1D", function(module, exports) {

$parcel$export(module.exports, "priorityClipboardHandler", () => $50c5f5d2210d721b$export$b89004aa95786c81);

var $lQE94 = parcelRequire("lQE94");

var $5fc53 = parcelRequire("5fc53");

var $4UjyI = parcelRequire("4UjyI");

var $ks0ly = parcelRequire("ks0ly");

var $3O2T0 = parcelRequire("3O2T0");

var $wQk2k = parcelRequire("wQk2k");
const $50c5f5d2210d721b$var$isTransformedPriority = (fieldValue)=>fieldValue != null && typeof fieldValue === 'object' && 'name' in fieldValue && 'priorityId' in fieldValue && 'iconUrl' in fieldValue;
const $50c5f5d2210d721b$var$getPastedValue = (clipboardItem, metadata)=>{
    if (!(0, $3O2T0.assertClipboardHasRichFormat)(clipboardItem) || !(0, $3O2T0.assertClipboardDataIsCompatible)(metadata, (0, $wQk2k.prioritySupportedTypes))) return null;
    if (!$50c5f5d2210d721b$var$isTransformedPriority(metadata.fieldValue)) return null;
    const { name: name, iconUrl: iconUrl, priorityId: priorityId } = metadata.fieldValue;
    return {
        name: name,
        iconUrl: iconUrl,
        priorityId: priorityId
    };
};
const $50c5f5d2210d721b$var$usePriorityClipboardHandler = (issue, field)=>{
    const [{ value: value }, { saveValue: saveValue }] = (0, $lQE94.useEditField)({
        fieldKey: (0, $5fc53.PRIORITY_TYPE),
        issueKey: issue.key,
        fieldType: (0, $5fc53.PRIORITY_TYPE),
        initialValue: $50c5f5d2210d721b$var$isTransformedPriority(field.value) ? field.value : undefined
    });
    return (0, $ks0ly.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: value?.name || null,
        currentValue: value,
        getPastedValue: $50c5f5d2210d721b$var$getPastedValue,
        saveValue: saveValue
    });
};
const $50c5f5d2210d721b$var$PriorityClipboardHelper = (0, $4UjyI.createClipboardHelperComponent)($50c5f5d2210d721b$var$usePriorityClipboardHandler);
const $50c5f5d2210d721b$export$b89004aa95786c81 = {
    [(0, $5fc53.PRIORITY_TYPE)]: $50c5f5d2210d721b$var$PriorityClipboardHelper
};

});
parcelRegister("wQk2k", function(module, exports) {

$parcel$export(module.exports, "prioritySupportedTypes", () => $4c97812eae062814$export$870d540e29b75531);

var $5fc53 = parcelRequire("5fc53");
const $4c97812eae062814$export$870d540e29b75531 = [
    (0, $5fc53.PRIORITY_TYPE)
];

});


parcelRegister("g8t8K", function(module, exports) {

$parcel$export(module.exports, "projectClipboardHandler", () => $adecb6b7202ff60d$export$54ffe1b6751ffaa1);

var $crLaw = parcelRequire("crLaw");

var $5fc53 = parcelRequire("5fc53");

var $4UjyI = parcelRequire("4UjyI");

var $ks0ly = parcelRequire("ks0ly");

var $3O2T0 = parcelRequire("3O2T0");
const $adecb6b7202ff60d$var$isProjectOption = (fieldValue)=>fieldValue != null && typeof fieldValue === 'object' && 'name' in fieldValue && 'avatarUrls' in fieldValue && 'key' in fieldValue;
const $adecb6b7202ff60d$var$getPastedValue = (clipboardItem, metadata)=>{
    if (!(0, $3O2T0.assertClipboardHasRichFormat)(clipboardItem) || !(0, $3O2T0.assertClipboardDataIsCompatible)(metadata, [
        (0, $5fc53.PROJECT_PICKER_CF_TYPE)
    ])) return null;
    if (!$adecb6b7202ff60d$var$isProjectOption(metadata.fieldValue)) return null;
    const { avatarUrls: avatarUrls, key: key, name: name } = metadata.fieldValue;
    return {
        avatarUrls: avatarUrls,
        key: key,
        name: name
    };
};
function $adecb6b7202ff60d$var$assertProjectField(field) {
    if (!field) throw new Error('Field is required');
    if (field.type !== (0, $5fc53.PROJECT_PICKER_CF_TYPE)) throw new Error('Field type is not supported');
}
const $adecb6b7202ff60d$var$useProjectClipboardHandler = (issue, field)=>{
    $adecb6b7202ff60d$var$assertProjectField(field);
    const [{ value: value }, { saveValue: saveValue }] = (0, $crLaw.useProjectField)({
        issueKey: issue.key,
        fieldKey: field?.fieldId,
        initialValue: field?.value ?? null
    });
    return (0, $ks0ly.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: value?.name ?? '',
        currentValue: value,
        getPastedValue: $adecb6b7202ff60d$var$getPastedValue,
        saveValue: saveValue
    });
};
const $adecb6b7202ff60d$var$ProjectClipboardHelper = (0, $4UjyI.createClipboardHelperComponent)($adecb6b7202ff60d$var$useProjectClipboardHandler);
const $adecb6b7202ff60d$export$54ffe1b6751ffaa1 = {
    [(0, $5fc53.PROJECT_PICKER_CF_TYPE)]: $adecb6b7202ff60d$var$ProjectClipboardHelper
};

});
parcelRegister("crLaw", function(module, exports) {

$parcel$export(module.exports, "useProjectField", () => $c53050cb92cb8ee9$export$85a22e7dcab3be80);

var $9XE6b = parcelRequire("9XE6b");

var $lQE94 = parcelRequire("lQE94");

var $54wEF = parcelRequire("54wEF");

var $5fc53 = parcelRequire("5fc53");
const $c53050cb92cb8ee9$export$85a22e7dcab3be80 = ({ issueKey: issueKey, fieldKey: fieldKey, onSuccess: onSuccess, onFailure: onFailure, initialValue: initialValue = null })=>{
    // useFieldConfig now returns an object { value, loading } instead of just the fieldConfig value
    // if possible when touching this, try and refactor to pass the new object instead of just the value
    const [{ value: fieldConfig }] = (0, $54wEF.useFieldConfig)(issueKey, fieldKey);
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(fieldConfig, 'schema.type', (0, $5fc53.PROJECT_PICKER_CF_TYPE));
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $lQE94.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: initialValue,
        onSuccess: onSuccess,
        onFailure: onFailure
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});


parcelRegister("8swam", function(module, exports) {

$parcel$export(module.exports, "radioSelectClipboardHandler", () => $631e8a3a716c702e$export$29dacd6ff7afb87c);

var $9sUAX = parcelRequire("9sUAX");

var $5fc53 = parcelRequire("5fc53");

var $4UjyI = parcelRequire("4UjyI");

var $ks0ly = parcelRequire("ks0ly");

var $3O2T0 = parcelRequire("3O2T0");

var $cyODY = parcelRequire("cyODY");
const $631e8a3a716c702e$var$isRadioSelectOption = (fieldValue)=>fieldValue != null && typeof fieldValue === 'object' && 'id' in fieldValue && 'value' in fieldValue;
const $631e8a3a716c702e$var$getPastedValue = (clipboardItem, metadata)=>{
    if (!(0, $3O2T0.assertClipboardHasRichFormat)(clipboardItem) || !(0, $3O2T0.assertClipboardDataIsCompatible)(metadata, (0, $cyODY.radioSelectSupportedTypes))) return null;
    if (!$631e8a3a716c702e$var$isRadioSelectOption(metadata.fieldValue)) return null;
    return {
        id: metadata.fieldValue.id,
        value: metadata.fieldValue.value
    };
};
const $631e8a3a716c702e$var$useRadioSelectClipboardHandler = (issue, field)=>{
    $631e8a3a716c702e$var$assertRadioSelectField(field);
    const [{ value: value }, { saveValue: saveValue }] = (0, $9sUAX.useRadioSelectCustomField)({
        issueKey: issue.key,
        fieldKey: field?.fieldId,
        initialValue: field?.value ? field?.value : null
    });
    const { value: valueAsString = null } = value ?? {};
    return (0, $ks0ly.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: valueAsString,
        currentValue: value,
        getPastedValue: $631e8a3a716c702e$var$getPastedValue,
        saveValue: saveValue
    });
};
function $631e8a3a716c702e$var$assertRadioSelectField(field) {
    if (!field) throw new Error('Field is required');
    if (field.type !== (0, $5fc53.RADIO_BUTTONS_CF_TYPE)) throw new Error('Field type is not supported');
}
const $631e8a3a716c702e$var$RadioSelectClipboardHelper = (0, $4UjyI.createClipboardHelperComponent)($631e8a3a716c702e$var$useRadioSelectClipboardHandler);
const $631e8a3a716c702e$export$29dacd6ff7afb87c = {
    [(0, $5fc53.RADIO_BUTTONS_CF_TYPE)]: $631e8a3a716c702e$var$RadioSelectClipboardHelper
};

});
parcelRegister("9sUAX", function(module, exports) {

$parcel$export(module.exports, "useRadioSelectCustomField", () => $a90ed6d8b34d430d$export$ef02e43cfb758362);

var $9XE6b = parcelRequire("9XE6b");

var $lQE94 = parcelRequire("lQE94");

var $54wEF = parcelRequire("54wEF");
const $a90ed6d8b34d430d$export$ef02e43cfb758362 = ({ issueKey: issueKey, fieldKey: fieldKey, initialValue: initialValue = null, onFailure: onFailure, onSuccess: onSuccess })=>{
    const [fieldConfig] = (0, $54wEF.useFieldConfig)(issueKey, fieldKey);
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(fieldConfig.value, 'schema.type', 'option');
    const options = fieldConfig.value?.allowedValues ?? [];
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError, saveById: saveById }] = (0, $lQE94.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: initialValue,
        onSuccess: onSuccess,
        onFailure: onFailure
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig,
            options: options
        },
        {
            saveValue: saveValue,
            resetError: resetError,
            saveById: saveById
        }
    ];
};

});


parcelRegister("lhJy9", function(module, exports) {

$parcel$export(module.exports, "richTextClipboardHandler", () => $c5aa69c4a9e562f8$export$f1f0130932e64bf7);

var $lQE94 = parcelRequire("lQE94");

var $5fc53 = parcelRequire("5fc53");

var $4UjyI = parcelRequire("4UjyI");

var $ks0ly = parcelRequire("ks0ly");

var $3O2T0 = parcelRequire("3O2T0");

var $5zOc3 = parcelRequire("5zOc3");
const $c5aa69c4a9e562f8$var$getPastedValue = (clipboardItem, metadata)=>{
    if (!(0, $3O2T0.assertClipboardHasPlainTextFormat)(clipboardItem) || !(0, $3O2T0.assertClipboardDataIsCompatible)(metadata, (0, $5zOc3.richTextSupportedTypes))) return null;
    return JSON.parse(clipboardItem.plainText);
};
function $c5aa69c4a9e562f8$var$assertRichTextField(field) {
    if (!field) throw new Error('Field is required');
    if (field.type !== (0, $5fc53.TEXT_AREA_CF_TYPE)) throw new Error('Field type is not supported');
}
const $c5aa69c4a9e562f8$var$useRichTextClipboardHandler = (issue, field)=>{
    $c5aa69c4a9e562f8$var$assertRichTextField(field);
    const [{ value: value }, { saveValue: saveValue }] = (0, $lQE94.useEditField)({
        issueKey: issue.key,
        fieldKey: field.fieldId,
        fieldType: field.type,
        initialValue: field.value ?? null
    });
    return (0, $ks0ly.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: typeof value !== 'string' ? JSON.stringify(value) : '',
        currentValue: value,
        getPastedValue: $c5aa69c4a9e562f8$var$getPastedValue,
        saveValue: saveValue
    });
};
const $c5aa69c4a9e562f8$var$RichTextClipboardHelper = (0, $4UjyI.createClipboardHelperComponent)($c5aa69c4a9e562f8$var$useRichTextClipboardHandler);
const $c5aa69c4a9e562f8$export$f1f0130932e64bf7 = {
    [(0, $5fc53.TEXT_AREA_CF_TYPE)]: $c5aa69c4a9e562f8$var$RichTextClipboardHelper
};

});
parcelRegister("5zOc3", function(module, exports) {

$parcel$export(module.exports, "richTextSupportedTypes", () => $5eaf4c5a462accac$export$8eb80ed0ab47e2a5);

var $5fc53 = parcelRequire("5fc53");
const $5eaf4c5a462accac$export$8eb80ed0ab47e2a5 = [
    (0, $5fc53.TEXT_AREA_CF_TYPE)
];

});


parcelRegister("jtn4P", function(module, exports) {

$parcel$export(module.exports, "singleSelectClipboardHandler", () => $7e8851a662dc3d52$export$40b3cfc25c74248b);

var $hWkQo = parcelRequire("hWkQo");

var $5fc53 = parcelRequire("5fc53");

var $4UjyI = parcelRequire("4UjyI");

var $ks0ly = parcelRequire("ks0ly");

var $3O2T0 = parcelRequire("3O2T0");

var $15cxS = parcelRequire("15cxS");
const $7e8851a662dc3d52$var$isSingleSelectValue = (fieldValue)=>fieldValue != null && typeof fieldValue === 'object' && 'value' in fieldValue && 'id' in fieldValue;
const $7e8851a662dc3d52$var$isTransformedSingleSelectOption = (fieldValue)=>fieldValue != null && typeof fieldValue === 'object' && 'value' in fieldValue && 'optionId' in fieldValue;
const $7e8851a662dc3d52$var$getPastedValue = (clipboardItem, metadata)=>{
    if (!(0, $3O2T0.assertClipboardHasRichFormat)(clipboardItem) || !(0, $3O2T0.assertClipboardDataIsCompatible)(metadata, (0, $15cxS.singleSelectSupportedTypes))) return null;
    if (!$7e8851a662dc3d52$var$isSingleSelectValue(metadata.fieldValue)) return null;
    return metadata.fieldValue;
};
const $7e8851a662dc3d52$var$useSingleSelectClipboardHandler = (issue, field)=>{
    const [{ value: value }, { saveValue: saveValue }] = (0, $hWkQo.useSingleSelectField)({
        fieldKey: field.fieldId,
        issueKey: issue.key,
        initialValue: $7e8851a662dc3d52$var$isTransformedSingleSelectOption(field.value) ? {
            id: field.value.optionId,
            value: field.value.value
        } : null
    });
    return (0, $ks0ly.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: value?.value || '',
        currentValue: value,
        getPastedValue: $7e8851a662dc3d52$var$getPastedValue,
        saveValue: saveValue
    });
};
const $7e8851a662dc3d52$var$SingleSelectClipboardHelper = (0, $4UjyI.createClipboardHelperComponent)($7e8851a662dc3d52$var$useSingleSelectClipboardHandler);
const $7e8851a662dc3d52$export$40b3cfc25c74248b = {
    [(0, $5fc53.SELECT_CF_TYPE)]: $7e8851a662dc3d52$var$SingleSelectClipboardHelper
};

});
parcelRegister("15cxS", function(module, exports) {

$parcel$export(module.exports, "singleSelectSupportedTypes", () => $ebca28208c1fe29b$export$2bbc728e21b0f517);

var $5fc53 = parcelRequire("5fc53");
const $ebca28208c1fe29b$export$2bbc728e21b0f517 = [
    (0, $5fc53.SELECT_CF_TYPE)
];

});


parcelRegister("1O7xL", function(module, exports) {

$parcel$export(module.exports, "sprintClipboardHandler", () => $3cacae2083c5de9b$export$43b74ee26a0ff997);

var $5uXOq = parcelRequire("5uXOq");

var $dMnMc = parcelRequire("dMnMc");

var $a29sl = parcelRequire("a29sl");

var $5fc53 = parcelRequire("5fc53");

var $4UjyI = parcelRequire("4UjyI");

var $ks0ly = parcelRequire("ks0ly");

var $3O2T0 = parcelRequire("3O2T0");

var $hIYZb = parcelRequire("hIYZb");
const $3cacae2083c5de9b$var$isTransformedSprintOption = (option)=>option != null && typeof option === 'object' && 'sprintId' in option && 'name' in option && 'state' in option;
const $3cacae2083c5de9b$var$isTransformedSprint = (fieldValue)=>Array.isArray(fieldValue) && fieldValue.every($3cacae2083c5de9b$var$isTransformedSprintOption);
const $3cacae2083c5de9b$var$isSprintValue = (fieldValue)=>Array.isArray(fieldValue) && fieldValue.every((option)=>option != null && typeof option === 'object' && 'id' in option && 'name' in option && 'state' in option && 'boardId' in option);
const $3cacae2083c5de9b$var$emptyValue = [];
const $3cacae2083c5de9b$var$getPastedValue = (clipboardItem, metadata)=>{
    if (!(0, $3O2T0.assertClipboardHasRichFormat)(clipboardItem) || !(0, $3O2T0.assertClipboardDataIsCompatible)(metadata, (0, $hIYZb.sprintSupportedTypes))) return [];
    if (!$3cacae2083c5de9b$var$isSprintValue(metadata?.fieldValue)) return [];
    return metadata?.fieldValue ?? [];
};
const $3cacae2083c5de9b$var$toSprintValue = (sprint)=>({
        id: Number(sprint.sprintId),
        name: String(sprint.name),
        state: String(sprint.state),
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        boardId: Number((0, $dMnMc.getBoardId)(window.location.href))
    });
const $3cacae2083c5de9b$var$useSprintClipboardHandler = (issue, field)=>{
    const [{ value: value }, { saveValue: saveValue }] = (0, $a29sl.useSprintField)({
        issueKey: issue.key,
        fieldKey: field.fieldId,
        initialValue: $3cacae2083c5de9b$var$isTransformedSprint(field.value) ? field.value.map($3cacae2083c5de9b$var$toSprintValue) : $3cacae2083c5de9b$var$emptyValue
    });
    const saveValueFn = (0, $5uXOq.useCallback)((valueToSave, meta, analyticsEvent)=>/**
			 * Wrap saveValue to make sure the saved value is never set to `null`
			 */ saveValue(valueToSave ?? [], meta, analyticsEvent), [
        saveValue
    ]);
    return (0, $ks0ly.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: value?.map((sprint)=>sprint.name).join(', ') || '',
        currentValue: value,
        getPastedValue: $3cacae2083c5de9b$var$getPastedValue,
        saveValue: saveValueFn,
        emptyValue: $3cacae2083c5de9b$var$emptyValue
    });
};
const $3cacae2083c5de9b$var$SprintClipboardHelper = (0, $4UjyI.createClipboardHelperComponent)($3cacae2083c5de9b$var$useSprintClipboardHandler);
const $3cacae2083c5de9b$export$43b74ee26a0ff997 = {
    [(0, $5fc53.SPRINT_TYPE)]: $3cacae2083c5de9b$var$SprintClipboardHelper
};

});
parcelRegister("a29sl", function(module, exports) {

$parcel$export(module.exports, "useSprintField", () => $2fd006a23bf8311f$export$414b643c95e23ae5);

var $5uXOq = parcelRequire("5uXOq");

var $eusud = parcelRequire("eusud");

var $lQE94 = parcelRequire("lQE94");

var $54wEF = parcelRequire("54wEF");

var $5fc53 = parcelRequire("5fc53");

var $jOtoq = parcelRequire("jOtoq");
const $2fd006a23bf8311f$export$218ac2eb848871c9 = async (issueKey, fieldKey, newValue)=>{
    const value = (0, $jOtoq.getActiveOrFutureSprint)(newValue);
    return (0, $eusud.performPutRequest)(`/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify({
            fields: {
                // We're only saving the sprint id
                [fieldKey]: value ? value.id : null
            }
        })
    });
};
const $2fd006a23bf8311f$export$414b643c95e23ae5 = (props)=>{
    const { fieldKey: fieldKey, issueId: issueId, issueKey: issueKey, onSuccess: onSuccess, onFailure: onFailure, initialValue: initialValue = [] } = props;
    const [{ value: fieldConfig }] = (0, $54wEF.useFieldConfig)(issueKey, fieldKey);
    const fieldType = fieldConfig?.schema.custom ?? (0, $5fc53.SPRINT_TYPE);
    const [{ error: error, value: value }, { resetError: resetError, saveValue: saveValue }] = (0, $lQE94.useEditField)({
        fieldKey: fieldKey,
        fieldType: fieldType,
        issueId: issueId,
        issueKey: issueKey,
        onSuccess: onSuccess,
        onFailure: onFailure,
        initialValue: initialValue,
        saveField: $2fd006a23bf8311f$export$218ac2eb848871c9
    });
    const currentSprint = (0, $5uXOq.useMemo)(()=>(0, $jOtoq.getActiveOrFutureSprint)(value), [
        value
    ]);
    const closedSprints = (0, $5uXOq.useMemo)(()=>(0, $jOtoq.getClosedSprints)(value), [
        value
    ]);
    return [
        {
            currentSprint: currentSprint,
            closedSprints: closedSprints,
            error: error,
            value: value,
            fieldConfig: fieldConfig
        },
        {
            resetError: resetError,
            saveValue: saveValue
        }
    ];
};

});
parcelRegister("jOtoq", function(module, exports) {

$parcel$export(module.exports, "getActiveOrFutureSprint", () => $baca344a1a8bf89a$export$976090522bae1157);
$parcel$export(module.exports, "getClosedSprints", () => $baca344a1a8bf89a$export$d643f70a4819e76d);

var $3spCR = parcelRequire("3spCR");

var $249dD = parcelRequire("249dD");
const $baca344a1a8bf89a$export$976090522bae1157 = (value)=>{
    const activeSprint = (0, $249dD.findSprintWithState)(value, (0, $3spCR.ACTIVE_SPRINT_STATE));
    if (activeSprint) return activeSprint;
    const futureSprint = (0, $249dD.findSprintWithState)(value, (0, $3spCR.FUTURE_SPRINT_STATE));
    if (futureSprint) return futureSprint;
    return null;
};
const $baca344a1a8bf89a$export$d643f70a4819e76d = (value)=>{
    if (!value) return [];
    return value.filter((0, $249dD.hasState)((0, $3spCR.CLOSED_SPRINT_STATE)));
};

});
parcelRegister("3spCR", function(module, exports) {

$parcel$export(module.exports, "ACTIVE_SPRINT_STATE", () => $113c1ed08a0bda4f$export$3ebc9911a79d714f);
$parcel$export(module.exports, "FUTURE_SPRINT_STATE", () => $113c1ed08a0bda4f$export$863e42082c6bde5);
$parcel$export(module.exports, "CLOSED_SPRINT_STATE", () => $113c1ed08a0bda4f$export$86cdef09a89e8c4b);
$parcel$export(module.exports, "SPRINT_STATES", () => $113c1ed08a0bda4f$export$73a0206a4dc59760);
const $113c1ed08a0bda4f$export$3ebc9911a79d714f = 'ACTIVE';
const $113c1ed08a0bda4f$export$863e42082c6bde5 = 'FUTURE';
const $113c1ed08a0bda4f$export$86cdef09a89e8c4b = 'CLOSED';
const $113c1ed08a0bda4f$export$73a0206a4dc59760 = {
    ACTIVE: $113c1ed08a0bda4f$export$3ebc9911a79d714f,
    CLOSED: $113c1ed08a0bda4f$export$86cdef09a89e8c4b,
    FUTURE: $113c1ed08a0bda4f$export$863e42082c6bde5
};

});

parcelRegister("249dD", function(module, exports) {

$parcel$export(module.exports, "hasState", () => $cfadc135289d0d3a$export$d2fec4e2fc5f065a);
$parcel$export(module.exports, "findSprintWithState", () => $cfadc135289d0d3a$export$fb6b70a9c996212b);
$parcel$export(module.exports, "mapSprintOptionToData", () => $cfadc135289d0d3a$export$fb7a6b38a05bd2b7);
$parcel$export(module.exports, "transformSuggestions", () => $cfadc135289d0d3a$export$1d0ee4320c26fb60);

var $3spCR = parcelRequire("3spCR");

var $e7pk8 = parcelRequire("e7pk8");
const $cfadc135289d0d3a$export$e6c9132cef5ee76f = (sprintId)=>`/secure/GHGoToBoard.jspa?sprintId=${sprintId}`;
const $cfadc135289d0d3a$export$d2fec4e2fc5f065a = (state)=>(sprint)=>sprint.state !== undefined && sprint.state.toLowerCase() === state.toLowerCase();
const $cfadc135289d0d3a$export$fb6b70a9c996212b = (sprints, state)=>{
    if (!sprints) return undefined;
    return sprints.find($cfadc135289d0d3a$export$d2fec4e2fc5f065a(state));
};
const $cfadc135289d0d3a$export$d63c3784bf3852ca = (state)=>{
    if (state !== undefined) {
        const stateKey = state.toUpperCase();
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly ACTIVE: "ACTIVE"; readonly CLOSED: "CLOSED"; readonly FUTURE: "FUTURE"; }'.
        return (0, $3spCR.SPRINT_STATES)[stateKey];
    }
    return undefined;
};
const $cfadc135289d0d3a$export$fb7a6b38a05bd2b7 = ({ value: value })=>Number(value);
const $cfadc135289d0d3a$export$fbb2e1641ffac377 = (option)=>({
        id: Number(option.value),
        name: String(option.label),
        state: option.state,
        // mapSprintValueToOption ensures there will always be a boardId
        boardId: Number(option.data?.boardId) || 0
    });
const $cfadc135289d0d3a$export$b9928e57702db7d9 = (items)=>items.map($cfadc135289d0d3a$export$fbb2e1641ffac377);
const $cfadc135289d0d3a$export$cbdf60de7f2200e7 = (option)=>({
        id: Number(option.value),
        boardName: option.description,
        name: String(option.label),
        // mapSprintSuggestionToOption ensures there will always be a state
        // @ts-expect-error - TS2322 - Type 'SprintState | undefined' is not assignable to type 'SprintState'.
        stateKey: $cfadc135289d0d3a$export$d63c3784bf3852ca(option.state),
        // mapSprintSuggestionToOption ensures there will always be a date
        date: String(option.data?.date)
    });
const $cfadc135289d0d3a$export$db10bf437c75c497 = (items)=>items.map($cfadc135289d0d3a$export$cbdf60de7f2200e7);
const $cfadc135289d0d3a$export$15c97379ebef6b30 = (sprint)=>({
        id: sprint.id,
        description: sprint.boardName,
        label: sprint.name,
        state: sprint.stateKey,
        value: sprint.id,
        data: {
            date: sprint.date,
            fromCache: sprint.fromCache
        }
    });
const $cfadc135289d0d3a$export$c1cb9e6f1beaee0d = (items)=>items.map($cfadc135289d0d3a$export$15c97379ebef6b30);
const $cfadc135289d0d3a$export$ce3013ece3dbf252 = (sprint)=>({
        id: sprint.id,
        name: sprint.name,
        href: $cfadc135289d0d3a$export$e6c9132cef5ee76f(sprint.id),
        endDate: sprint.endDate || ''
    });
const $cfadc135289d0d3a$export$755a6a3c6172f7e = (sprint)=>({
        label: sprint.name,
        value: sprint.id,
        href: $cfadc135289d0d3a$export$e6c9132cef5ee76f(sprint.id),
        state: $cfadc135289d0d3a$export$d63c3784bf3852ca(sprint.state),
        data: {
            boardId: sprint.boardId,
            date: sprint.startDate
        }
    });
const $cfadc135289d0d3a$export$cbcaba92baa2e404 = (items)=>items.map($cfadc135289d0d3a$export$755a6a3c6172f7e);
const $cfadc135289d0d3a$export$1d0ee4320c26fb60 = (suggestionsFromServer, formatMessage)=>{
    const serverSuggestions = suggestionsFromServer.suggestions || [];
    const allMatches = suggestionsFromServer.allMatches || [];
    const allItems = serverSuggestions.concat(allMatches);
    const activeItems = allItems.filter((sprint)=>sprint.stateKey === (0, $3spCR.ACTIVE_SPRINT_STATE)).map($cfadc135289d0d3a$export$15c97379ebef6b30);
    const futureItems = allItems.filter((sprint)=>sprint.stateKey === (0, $3spCR.FUTURE_SPRINT_STATE)).map($cfadc135289d0d3a$export$15c97379ebef6b30);
    const sprints = [
        {
            label: formatMessage((0, $e7pk8.default).activeSprints),
            options: activeItems
        },
        {
            label: formatMessage((0, $e7pk8.default).futureSprints),
            options: futureItems
        }
    ];
    return sprints;
};

});
parcelRegister("e7pk8", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f3d56beb10e0cde$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1f3d56beb10e0cde$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    activeSprints: {
        "id": "issue-field-sprint.common.active-sprints",
        "defaultMessage": "Active"
    },
    futureSprints: {
        "id": "issue-field-sprint.common.future-sprints",
        "defaultMessage": "Future"
    },
    recentSprints: {
        "id": "issue-field-sprint.common.recent-sprints",
        "defaultMessage": "Recent sprints"
    }
});

});




parcelRegister("hIYZb", function(module, exports) {

$parcel$export(module.exports, "sprintSupportedTypes", () => $48d47f85fb1aba83$export$e25836d1d6e63e05);

var $5fc53 = parcelRequire("5fc53");
const $48d47f85fb1aba83$export$e25836d1d6e63e05 = [
    (0, $5fc53.SPRINT_TYPE)
];

});


parcelRegister("dCJsI", function(module, exports) {

$parcel$export(module.exports, "teamClipboardHandler", () => $ce6b26da99d59604$export$c625d5eb0e1357b2);

var $4tlhS = parcelRequire("4tlhS");

var $5fc53 = parcelRequire("5fc53");

var $4UjyI = parcelRequire("4UjyI");

var $ks0ly = parcelRequire("ks0ly");

var $3O2T0 = parcelRequire("3O2T0");
const $ce6b26da99d59604$var$isTransformedTeamOption = (fieldValue)=>fieldValue != null && typeof fieldValue === 'object' && 'id' in fieldValue && 'name' in fieldValue;
function $ce6b26da99d59604$var$assertTeamField(field) {
    if (!field) throw new Error('Field is required');
    if (field.type !== (0, $5fc53.TEAMS_PLATFORM_CF_TYPE)) throw new Error('Field type is not supported');
}
const $ce6b26da99d59604$var$getPastedValue = (clipboardItem, metadata)=>{
    if (!(0, $3O2T0.assertClipboardHasRichFormat)(clipboardItem) || !(0, $3O2T0.assertClipboardDataIsCompatible)(metadata, [
        (0, $5fc53.TEAMS_PLATFORM_CF_TYPE)
    ])) return null;
    if (!$ce6b26da99d59604$var$isTransformedTeamOption(metadata.fieldValue)) return null;
    const { id: id, name: name } = metadata.fieldValue;
    return {
        id: id,
        name: name
    };
};
const $ce6b26da99d59604$var$useTeamClipboardHandler = (issue, field)=>{
    $ce6b26da99d59604$var$assertTeamField(field);
    const [{ value: value }, { saveValue: saveValue }] = (0, $4tlhS.useTeamField)({
        issueKey: issue.key,
        fieldKey: field?.fieldId,
        initialValue: $ce6b26da99d59604$var$isTransformedTeamOption(field.value) ? field.value : undefined
    });
    return (0, $ks0ly.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: field.value?.name ?? '',
        currentValue: value,
        getPastedValue: $ce6b26da99d59604$var$getPastedValue,
        saveValue: saveValue
    });
};
const $ce6b26da99d59604$var$TeamClipboardHelper = (0, $4UjyI.createClipboardHelperComponent)($ce6b26da99d59604$var$useTeamClipboardHandler);
const $ce6b26da99d59604$export$c625d5eb0e1357b2 = {
    [(0, $5fc53.TEAMS_PLATFORM_CF_TYPE)]: $ce6b26da99d59604$var$TeamClipboardHelper
};

});
parcelRegister("4tlhS", function(module, exports) {

$parcel$export(module.exports, "useTeamField", () => $27aed0aa4f300f8f$export$183b0f27978cd3a6);
$parcel$export(module.exports, "useTeamFieldRelay", () => $27aed0aa4f300f8f$export$9cb6c5f2b8075e40);

var $21z07 = parcelRequire("21z07");

var $fYWdS = parcelRequire("fYWdS");

var $5uXOq = parcelRequire("5uXOq");

var $9XE6b = parcelRequire("9XE6b");

var $8Uumt = parcelRequire("8Uumt");

var $jJZqs = parcelRequire("jJZqs");

var $fZneA = parcelRequire("fZneA");

var $lQE94 = parcelRequire("lQE94");

var $99cgx = parcelRequire("99cgx");

var $54wEF = parcelRequire("54wEF");

var $15WDX = parcelRequire("15WDX");

var $8zOmE = parcelRequire("8zOmE");

var $1qWIA = parcelRequire("1qWIA");
const $27aed0aa4f300f8f$var$saveField = async (issueKey, fieldKey, newValue, baseUrl)=>{
    const newId = newValue?.id ?? null;
    return (0, $99cgx.defaultSaveField)(issueKey, fieldKey, newId, baseUrl);
};
const $27aed0aa4f300f8f$export$183b0f27978cd3a6 = ({ issueKey: issueKey, fieldKey: fieldKey, onSuccess: onSuccess, onFailure: onFailure, initialValue: initialValue })=>{
    // useFieldConfig now returns an object { value, loading } instead of just the fieldConfig value
    // if possible when touching this, try and refactor to pass the new object instead of just the value
    const [{ value: fieldConfig }] = (0, $54wEF.useFieldConfig)(issueKey, fieldKey);
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(fieldConfig, 'schema.type', 'array');
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $lQE94.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: initialValue || null,
        onSuccess: onSuccess,
        saveField: $27aed0aa4f300f8f$var$saveField,
        onFailure: onFailure
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};
const $27aed0aa4f300f8f$var$transformComponentValueToAggValue = (value)=>{
    if (!value) return null;
    const jiraSuppliedId = (0, $1qWIA.isRecentlyCreatedTeam)(value) ? value.teamAri : value?.teamId ?? '';
    return {
        jiraSuppliedId: jiraSuppliedId,
        jiraSuppliedName: value?.name ?? '',
        jiraSuppliedVisibility: true,
        jiraSuppliedTeamId: value?.id ?? '',
        jiraIncludesYou: !!value?.includesYou,
        jiraMemberCount: value?.memberCount ?? 0,
        jiraSuppliedIsVerified: value?.isVerified ?? false
    };
};
const $27aed0aa4f300f8f$export$a3e1bed60407fb27 = (fieldData)=>{
    if (!fieldData) return null;
    return {
        id: fieldData.jiraSuppliedTeamId,
        name: fieldData.jiraSuppliedName ?? '',
        isVisible: !!fieldData.jiraSuppliedVisibility,
        teamId: fieldData.jiraSuppliedId,
        memberCount: fieldData.jiraMemberCount ?? 0,
        includesYou: !!fieldData?.jiraIncludesYou,
        isVerified: !!fieldData.jiraSuppliedIsVerified
    };
};
const $27aed0aa4f300f8f$export$9cb6c5f2b8075e40 = ({ fragmentKey: fragmentKey, onSuccess: onSuccess, onFailure: onFailure })=>{
    const [, { fieldChanged: fieldChanged, fieldChangeFailed: fieldChangeFailed, fieldChangeRequested: fieldChangeRequested }] = (0, $15WDX.useIssueViewFieldUpdateEvents)();
    const [error, setError] = (0, $5uXOq.useState)(null);
    // eslint-disable-next-line @atlassian/relay/no-wrapping-hooks, @atlassian/relay/query-restriction
    const data = (0, $8Uumt.useFragment)((0, $fYWdS.default), fragmentKey);
    const issueId = data?.issue?.id;
    const [commit] = (0, $8Uumt.useMutation)((0, $21z07.default));
    async function saveValue(value, meta, analyticsEvent) {
        const newAggValue = $27aed0aa4f300f8f$var$transformComponentValueToAggValue(value);
        const analyticsData = {
            editOperationType: 'set',
            issueId: issueId,
            fieldKey: data.fieldId,
            fieldType: data.type
        };
        (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'field updated', analyticsData);
        (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'field updateSucceeded', analyticsData);
        issueId && fieldChangeRequested(issueId, data.fieldId, newAggValue, undefined, {
            type: data.type,
            __typename: data.__typename
        });
        commit({
            variables: {
                input: {
                    id: data.id,
                    operation: {
                        operation: 'SET',
                        id: newAggValue?.jiraSuppliedId ?? null
                    }
                }
            },
            onCompleted: (mutationData)=>{
                if (mutationData.jira?.updateTeamField?.success) {
                    issueId && fieldChanged(issueId, data.fieldId, newAggValue, {
                        type: data.type,
                        __typename: data.__typename
                    });
                    onSuccess && onSuccess(value);
                } else issueId && fieldChangeFailed(issueId, data.fieldId);
            },
            onError (ex) {
                issueId && fieldChangeFailed(issueId, data.fieldId);
                onFailure && onFailure(ex, value);
                const isValidationError = ex instanceof (0, $jJZqs.ValidationError);
                (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'field updateFailed', {
                    fieldKey: data.fieldId,
                    fieldType: data.type,
                    isValidationError: isValidationError,
                    isClientFetchError: (0, $fZneA.isClientFetchError)(ex)
                });
            },
            optimisticResponse: {
                jira: {
                    updateTeamField: {
                        success: true,
                        errors: [],
                        field: {
                            id: data.id,
                            issue: {
                                id: issueId ?? '',
                                key: data.issue?.key ?? ''
                            },
                            selectedTeam: {
                                jiraSuppliedId: newAggValue?.jiraSuppliedId ?? '',
                                jiraSuppliedName: newAggValue?.jiraSuppliedName,
                                jiraSuppliedVisibility: newAggValue?.jiraSuppliedVisibility,
                                jiraSuppliedTeamId: newAggValue?.jiraSuppliedTeamId ?? '',
                                jiraSuppliedIsVerified: newAggValue?.jiraSuppliedIsVerified ?? false
                            }
                        }
                    }
                }
            }
        });
    }
    function resetError() {
        setError(null);
    }
    return [
        {
            value: $27aed0aa4f300f8f$export$a3e1bed60407fb27(data.selectedTeam),
            error: error,
            fieldConfig: {
                isEditable: !!data.fieldConfig?.isEditable,
                allowedValues: [],
                isRequired: !!data.fieldConfig?.isRequired,
                schema: {
                    custom: null,
                    system: null,
                    type: ''
                },
                title: ''
            }
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});
parcelRegister("21z07", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b8acf545d58806c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7fc0502ff549a8c4e06e6b3d59e246d2>>
 * @relayHash 3f86665263bd67a53812b5dcdb4dfcce
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e6b07a8e81c1be6f46a10a4231b4e1bc71690c0bcb8ce848c3281cd3f4f0cc2d
const $2b8acf545d58806c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "key"
    }, v6 = {
        "concreteType": "JiraTeamView",
        "kind": "LinkedField",
        "name": "selectedTeam",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "jiraSuppliedId"
            },
            {
                "kind": "ScalarField",
                "name": "jiraSuppliedName"
            },
            {
                "kind": "ScalarField",
                "name": "jiraSuppliedVisibility"
            },
            {
                "kind": "ScalarField",
                "name": "jiraSuppliedTeamId"
            },
            {
                "kind": "ScalarField",
                "name": "jiraSuppliedIsVerified"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "services_issueViewLayoutTeamField_IssueViewTeamField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraTeamFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateTeamField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraTeamViewField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "issue",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ 
                                            ]
                                        },
                                        v6 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "services_issueViewLayoutTeamField_IssueViewTeamField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraTeamFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateTeamField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraTeamViewField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "issue",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v4 /*: any*/ 
                                            ]
                                        },
                                        v6 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e6b07a8e81c1be6f46a10a4231b4e1bc71690c0bcb8ce848c3281cd3f4f0cc2d",
            "metadata": {},
            "name": "services_issueViewLayoutTeamField_IssueViewTeamField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$2b8acf545d58806c$var$node.hash = "dca06ae4c83255d09cc392c66e52117b";
var $2b8acf545d58806c$export$2e2bcd8739ae039 = $2b8acf545d58806c$var$node;

});

parcelRegister("fYWdS", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1a725b9b2a8270c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a2244ce2bcc2963c9185120ec42b6b58>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c1a725b9b2a8270c$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "services_issueViewLayoutTeamField_IssueViewTeamField",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            {
                "concreteType": "JiraFieldConfig",
                "kind": "LinkedField",
                "name": "fieldConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isEditable"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isRequired"
                    }
                ]
            },
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "issue",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    }
                ]
            },
            {
                "concreteType": "JiraTeamView",
                "kind": "LinkedField",
                "name": "selectedTeam",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "jiraSuppliedId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "jiraSuppliedName"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "jiraSuppliedVisibility"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "jiraSuppliedTeamId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "jiraIncludesYou"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "jiraMemberCount"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "jiraSuppliedIsVerified"
                    }
                ]
            }
        ],
        "type": "JiraTeamViewField"
    };
}();
$c1a725b9b2a8270c$var$node.hash = "8c3bb1e3d5a83b7a3ff4e3251e28c658";
var $c1a725b9b2a8270c$export$2e2bcd8739ae039 = $c1a725b9b2a8270c$var$node;

});

parcelRegister("1qWIA", function(module, exports) {

$parcel$export(module.exports, "isRecentlyCreatedTeam", () => $9f11830d093821e1$export$695c72729cb9130e);
const $9f11830d093821e1$export$695c72729cb9130e = (team)=>{
    return team != null && Object.hasOwn(team, 'isRecentlyCreated');
};

});



parcelRegister("57YE2", function(module, exports) {

$parcel$export(module.exports, "textClipboardHandler", () => $a446163e363c852b$export$c09434927c21c56);

var $3p8iD = parcelRequire("3p8iD");

var $80wkc = parcelRequire("80wkc");

var $5fc53 = parcelRequire("5fc53");

var $4UjyI = parcelRequire("4UjyI");

var $ks0ly = parcelRequire("ks0ly");

var $3O2T0 = parcelRequire("3O2T0");
const $a446163e363c852b$var$getPastedValue = (clipboardItem)=>{
    if (!(0, $3O2T0.assertClipboardHasPlainTextFormat)(clipboardItem)) return null;
    return clipboardItem.plainText;
};
function $a446163e363c852b$var$assertTextField(field) {
    if (!field) throw new Error('Field is required');
    if (field.type !== (0, $5fc53.TEXT_CF_TYPE) && field.type !== (0, $5fc53.SUMMARY_TYPE)) throw new Error('Field type is not supported');
}
const $a446163e363c852b$var$useSummaryClipboardHandler = (issue, field)=>{
    $a446163e363c852b$var$assertTextField(field);
    const [{ value: value }, { saveValue: saveValue }] = (0, $80wkc.useSummaryField)({
        // Dataset's in integration tests defined issueId as number,
        // which allows to bypass the type check
        issueId: issue.issueId.toString(),
        issueKey: issue.key,
        initialValue: field.value
    });
    return (0, $ks0ly.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: value,
        currentValue: value,
        getPastedValue: $a446163e363c852b$var$getPastedValue,
        saveValue: saveValue
    });
};
const $a446163e363c852b$var$useTextClipboardHandler = (issue, field)=>{
    $a446163e363c852b$var$assertTextField(field);
    const [{ value: value }, { saveValue: saveValue }] = (0, $3p8iD.useTextCustomField)({
        issueKey: issue.key,
        fieldKey: field.fieldId,
        initialValue: field.value
    });
    return (0, $ks0ly.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: value,
        currentValue: value,
        getPastedValue: $a446163e363c852b$var$getPastedValue,
        saveValue: saveValue
    });
};
const $a446163e363c852b$var$SummaryClipboardHelper = (0, $4UjyI.createClipboardHelperComponent)($a446163e363c852b$var$useSummaryClipboardHandler);
const $a446163e363c852b$var$TextClipboardHelper = (0, $4UjyI.createClipboardHelperComponent)($a446163e363c852b$var$useTextClipboardHandler);
const $a446163e363c852b$export$c09434927c21c56 = {
    [(0, $5fc53.SUMMARY_TYPE)]: $a446163e363c852b$var$SummaryClipboardHelper,
    [(0, $5fc53.TEXT_CF_TYPE)]: $a446163e363c852b$var$TextClipboardHelper
};

});
parcelRegister("3p8iD", function(module, exports) {

$parcel$export(module.exports, "useTextCustomField", () => $08dedeee1aa4605e$export$1e71b41e5a5c15c3);

var $9XE6b = parcelRequire("9XE6b");

var $lQE94 = parcelRequire("lQE94");

var $54wEF = parcelRequire("54wEF");
const $08dedeee1aa4605e$export$1e71b41e5a5c15c3 = ({ issueKey: issueKey, fieldKey: fieldKey, initialValue: initialValue, onSuccess: onSuccess, onFailure: onFailure })=>{
    const [fieldConfig] = (0, $54wEF.useFieldConfig)(issueKey, fieldKey);
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(fieldConfig.value, 'schema.type', 'string');
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $lQE94.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: initialValue || null,
        onSuccess: onSuccess,
        onFailure: onFailure
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});

parcelRegister("80wkc", function(module, exports) {

$parcel$export(module.exports, "useSummaryField", () => $3937341f26b89a45$export$a01f0885983ceff0);

var $9XE6b = parcelRequire("9XE6b");

var $lQE94 = parcelRequire("lQE94");

var $54wEF = parcelRequire("54wEF");

var $5fc53 = parcelRequire("5fc53");

var $4R6GH = parcelRequire("4R6GH");

var $lcPD8 = parcelRequire("lcPD8");
const $3937341f26b89a45$export$a01f0885983ceff0 = ({ issueId: issueId, issueKey: issueKey, initialValue: initialValue, onSubmit: onSubmit, onSuccess: onSuccess, onFailure: onFailure, onSaveField: onSaveField })=>{
    const [fieldConfig] = (0, $54wEF.useFieldConfig)(issueKey, (0, $5fc53.SUMMARY_TYPE));
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(fieldConfig.value, 'schema.type', 'string');
    const saveField = (0, $4R6GH.fg)('relay-migration-issue-fields-summary') ? (0, $lcPD8.useSaveSummaryField)(issueId) : undefined;
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $lQE94.useEditField)({
        fieldKey: (0, $5fc53.SUMMARY_TYPE),
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: initialValue || null,
        onSubmit: onSubmit,
        onSuccess: onSuccess,
        onFailure: onFailure,
        ...(0, $4R6GH.fg)('relay-migration-issue-fields-summary') && {
            saveField: saveField
        },
        // delete this condition and keep code inside when removing the isIncrementPlanningEnabled FF
        ...onSaveField && {
            saveField: onSaveField
        }
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});
parcelRegister("lcPD8", function(module, exports) {

$parcel$export(module.exports, "useSaveSummaryField", () => $296ba0222c720503$export$2429979662d1fc23);

var $883fO = parcelRequire("883fO");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $2RKeg = parcelRequire("2RKeg");

var $jJZqs = parcelRequire("jJZqs");

var $koeKL = parcelRequire("koeKL");
const $296ba0222c720503$export$2429979662d1fc23 = (issueId)=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const [commit] = (0, $8Uumt.useMutation)((0, $883fO.default));
    return (0, $5uXOq.useCallback)(async (_issueKey, fieldId, newValue)=>new Promise((resolve, reject)=>{
            commit({
                variables: {
                    input: {
                        id: (0, $2RKeg.JiraIssuefieldvalueAri).create({
                            siteId: cloudId,
                            issueId: issueId || '',
                            fieldId: fieldId
                        }).toString(),
                        operation: {
                            operation: 'SET',
                            text: newValue
                        }
                    }
                },
                onCompleted (response) {
                    if (response.jira?.updateSingleLineTextField) {
                        const { success: success, errors: responseErrors } = response.jira?.updateSingleLineTextField;
                        if (success) {
                            resolve();
                            return;
                        }
                        if (responseErrors?.length) reject(responseErrors[0].message ? new (0, $jJZqs.ValidationError)(responseErrors[0].message) : new Error('Unknown error when mutating summary'));
                    } else reject(new Error('Unknown error when mutating summary'));
                },
                onError (error) {
                    reject(error);
                }
            });
        }), [
        cloudId,
        commit,
        issueId
    ]);
};

});
parcelRegister("883fO", function(module, exports) {

$parcel$export(module.exports, "default", () => $d80cb93aeec4c927$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<502aa471f5d0893ece5715d9f8b2453a>>
 * @relayHash 96311ac8cd1b2e15ed7072740a91fd80
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 24e8667d902ba1fdadfcd6a7137edc6ca942d8be00bc0084996320ad25442808
const $d80cb93aeec4c927$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSaveSummaryFieldMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSingleLineTextFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSingleLineTextField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraSingleLineTextField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "singleLineTextHeading_issueFieldSingleLineTextInlineEditHeading_SingleLineTextHeadingInlineEditView"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSaveSummaryFieldMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSingleLineTextFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSingleLineTextField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraSingleLineTextField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isEditableInIssueView"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "text"
                                        },
                                        {
                                            "concreteType": "JiraFieldConfig",
                                            "kind": "LinkedField",
                                            "name": "fieldConfig",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isRequired"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "24e8667d902ba1fdadfcd6a7137edc6ca942d8be00bc0084996320ad25442808",
            "metadata": {},
            "name": "useSaveSummaryFieldMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$d80cb93aeec4c927$var$node.hash = "d7d58a3dc9f48f40fffb61682948b25d";
var $d80cb93aeec4c927$export$2e2bcd8739ae039 = $d80cb93aeec4c927$var$node;

});

parcelRegister("2RKeg", function(module, exports) {

$parcel$export(module.exports, "JiraIssuefieldvalueAri", () => $2164641f4a4b33a7$export$828c4931ae562af7);

var $gB07r = parcelRequire("gB07r");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/jira/issuefieldvalue/manifest.ts
var $2164641f4a4b33a7$var$jiraIssuefieldvalueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $gB07r.JiraIssuefieldvalueAriResourceOwner),
    resourceType: (0, $gB07r.JiraIssuefieldvalueAriResourceType),
    resourceIdSlug: "{issueId}/{fieldId}",
    resourceIdSegmentFormats: {
        issueId: /[0-9]+/,
        // eslint-disable-line no-useless-escape
        fieldId: /[a-zA-Z0-9_\-]+/
    }
};
// src/jira/issuefieldvalue/index.ts
var $2164641f4a4b33a7$export$828c4931ae562af7 = class _JiraIssuefieldvalueAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._issueId = opts.resourceIdSegmentValues.issueId, this._fieldId = opts.resourceIdSegmentValues.fieldId;
    }
    get siteId() {
        return this._siteId;
    }
    get issueId() {
        return this._issueId;
    }
    get fieldId() {
        return this._fieldId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $2164641f4a4b33a7$var$jiraIssuefieldvalueAriStaticOpts.qualifier,
            platformQualifier: $2164641f4a4b33a7$var$jiraIssuefieldvalueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $2164641f4a4b33a7$var$jiraIssuefieldvalueAriStaticOpts.resourceOwner,
            resourceType: $2164641f4a4b33a7$var$jiraIssuefieldvalueAriStaticOpts.resourceType,
            resourceId: `${opts.issueId}/${opts.fieldId}`,
            resourceIdSegmentValues: {
                issueId: opts.issueId,
                fieldId: opts.fieldId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $2164641f4a4b33a7$var$jiraIssuefieldvalueAriStaticOpts);
        return new _JiraIssuefieldvalueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $2164641f4a4b33a7$var$jiraIssuefieldvalueAriStaticOpts);
        return new _JiraIssuefieldvalueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            issueId: this.issueId,
            fieldId: this.fieldId
        };
    }
};

});
parcelRegister("gB07r", function(module, exports) {

$parcel$export(module.exports, "JiraIssuefieldvalueAriResourceOwner", () => $c15031ac9edfd973$export$39e9358142fbbc64);
$parcel$export(module.exports, "JiraIssuefieldvalueAriResourceType", () => $c15031ac9edfd973$export$f9e57427271adc95);
// src/jira/issuefieldvalue/types.ts
var $c15031ac9edfd973$export$39e9358142fbbc64 = "jira", $c15031ac9edfd973$export$f9e57427271adc95 = "issuefieldvalue";

});





parcelRegister("iAC09", function(module, exports) {

$parcel$export(module.exports, "timeTrackingClipboardHandler", () => $1b0eb1d2d59158fe$export$a6166b81649f40c4);

var $8Zm3O = parcelRequire("8Zm3O");

var $5fc53 = parcelRequire("5fc53");

var $4UjyI = parcelRequire("4UjyI");

var $ks0ly = parcelRequire("ks0ly");

var $3O2T0 = parcelRequire("3O2T0");

var $g92DA = parcelRequire("g92DA");
const $1b0eb1d2d59158fe$var$getPastedValue = (clipboardItem, metadata)=>{
    if (!(0, $3O2T0.assertClipboardHasPlainTextFormat)(clipboardItem) || !(0, $3O2T0.assertClipboardDataIsCompatible)(metadata, (0, $g92DA.timeTrackingSupportedTypes))) return null;
    const time = Number(clipboardItem.plainText);
    if (Number.isNaN(time)) return null;
    return time;
};
function $1b0eb1d2d59158fe$var$assertTimeTrackingField(field) {
    if (!field) throw new Error('Field is required');
    if (field.type !== (0, $5fc53.TIME_ESTIMATE_TYPE)) throw new Error('Field type is not supported');
}
const $1b0eb1d2d59158fe$var$useTimeTrackingClipboardHandler = (issue, field)=>{
    $1b0eb1d2d59158fe$var$assertTimeTrackingField(field);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const fieldValue = field.value;
    const hookInitialValue = fieldValue?.timeAsString && fieldValue?.timeInSeconds && {
        originalEstimate: fieldValue.timeAsString,
        originalEstimateSeconds: fieldValue.timeInSeconds
    } || {};
    const [{ value: value }, { saveValue: saveValue }] = (0, $8Zm3O.useOriginalEstimateField)({
        issueKey: issue.key,
        issueId: issue.issueId,
        fieldId: field.fieldId,
        timeTrackingValue: hookInitialValue
    });
    return (0, $ks0ly.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: typeof value === 'number' ? String(value) : null,
        currentValue: value,
        getPastedValue: $1b0eb1d2d59158fe$var$getPastedValue,
        saveValue: saveValue
    });
};
const $1b0eb1d2d59158fe$var$TimeTrackingClipboardHelper = (0, $4UjyI.createClipboardHelperComponent)($1b0eb1d2d59158fe$var$useTimeTrackingClipboardHandler);
const $1b0eb1d2d59158fe$export$a6166b81649f40c4 = {
    [(0, $5fc53.TIME_ESTIMATE_TYPE)]: $1b0eb1d2d59158fe$var$TimeTrackingClipboardHelper
};

});
parcelRegister("8Zm3O", function(module, exports) {

$parcel$export(module.exports, "saveField", () => $dbb581df97946a35$export$72a8b15fb4557735);
$parcel$export(module.exports, "useOriginalEstimateField", () => $dbb581df97946a35$export$ce089f5e05395af0);
$parcel$export(module.exports, "useOriginalEstimateFieldWithTimeTracking", () => $dbb581df97946a35$export$a79ecf7a6123f80e);

var $ebyGx = parcelRequire("ebyGx");

var $eusud = parcelRequire("eusud");

var $lQE94 = parcelRequire("lQE94");

var $54wEF = parcelRequire("54wEF");

var $akMx1 = parcelRequire("akMx1");

var $9odSb = parcelRequire("9odSb");

var $5fc53 = parcelRequire("5fc53");

var $4tcSU = parcelRequire("4tcSU");

var $gEYwC = parcelRequire("gEYwC");
const $dbb581df97946a35$export$347b6dd45094a5fd = (timeTrackingValue)=>{
    const hasTimeLogged = timeTrackingValue?.timeSpentSeconds != null;
    const hasTimeRemainUpdated = timeTrackingValue?.remainingEstimateSeconds != null && timeTrackingValue?.remainingEstimateSeconds !== timeTrackingValue?.originalEstimateSeconds;
    return hasTimeLogged || hasTimeRemainUpdated;
};
const $dbb581df97946a35$export$72a8b15fb4557735 = async ({ issueId: issueId, newValue: newValue, timeTrackingValue: timeTrackingValue })=>{
    const hasTimeRemainingEstimate = $dbb581df97946a35$export$347b6dd45094a5fd(timeTrackingValue);
    // Convert the value in seconds to a time string to send to Jira.
    // 1m is always 60s, so we can do this safely.
    // we have to convert the final value to a whole number as passing decimal
    // values in minutes errors.
    const value = newValue !== null ? (0, $akMx1.secondsToWholeMinuteTimeString)(newValue) : null;
    // https://jdog.jira-dev.com/browse/BENTO-792 - The Time Estimate field is always shown,
    // because we always the return the timeoriginalestimate field from the backend. In order to
    // prevent the field from being visible but not editable when Time Tracking is missing from the
    // screen config, we use this legacy endpoint to save the field.
    return (0, $eusud.performPostRequest)('/secure/AjaxIssueAction.jspa?decorator=none', {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: (0, $ebyGx.stringify)({
            issueId: issueId,
            timetracking_originalestimate: value,
            timetracking_targetsubfield: hasTimeRemainingEstimate ? 'timetracking_originalestimate' : undefined,
            ...(0, $gEYwC.originalEstimateBodyParams),
            singleFieldEdit: true,
            skipScreenCheck: true,
            atl_token: (0, $4tcSU.default)()
        })
    });
};
const $dbb581df97946a35$export$ce089f5e05395af0 = ({ issueKey: issueKey, issueId: issueId, fieldId: fieldId, timeTrackingValue: timeTrackingValue, onSubmit: onSubmit, onSuccess: onSuccess, onFailure: onFailure })=>{
    // useFieldConfig now returns an object { value, loading } instead of just the fieldConfig value
    // if possible when touching this, try and refactor to pass the new object instead of just the value
    const [{ value: fieldConfig }] = (0, $54wEF.useFieldConfig)(issueKey, fieldId);
    const fieldType = fieldConfig?.schema.system || '';
    const saveClassicField = (_, __, newValue)=>$dbb581df97946a35$export$72a8b15fb4557735({
            issueId: issueId,
            newValue: newValue,
            timeTrackingValue: timeTrackingValue
        });
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $lQE94.useEditField)({
        fieldKey: fieldId,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: null,
        saveField: saveClassicField,
        onSuccess: onSuccess,
        onFailure: onFailure,
        onSubmit: onSubmit
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};
const $dbb581df97946a35$export$a79ecf7a6123f80e = ({ issueKey: issueKey, issueId: issueId, fieldKey: fieldKey, onSubmit: onSubmit, onSuccess: onSuccess, onFailure: onFailure })=>{
    const timeTrack = (0, $9odSb.useTimeTrackingField)({
        fieldKey: (0, $5fc53.TIME_TRACKING_TYPE),
        issueId: issueId,
        issueKey: issueKey
    });
    let timeTrackingValue = {};
    if (timeTrack) {
        const trackData = timeTrack[0].value;
        timeTrackingValue = {
            originalEstimateSeconds: trackData.originalEstimateSeconds,
            timeSpentSeconds: trackData.timeSpentSeconds,
            remainingEstimateSeconds: trackData.remainingEstimateSeconds
        };
    }
    const [{ value: value, error: error, fieldConfig: fieldConfig }, { saveValue: saveValue, resetError: resetError }] = $dbb581df97946a35$export$ce089f5e05395af0({
        fieldId: fieldKey,
        issueKey: issueKey,
        issueId: issueId,
        timeTrackingValue: timeTrackingValue,
        onSuccess: onSuccess,
        onFailure: onFailure,
        onSubmit: onSubmit
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});
parcelRegister("akMx1", function(module, exports) {

$parcel$export(module.exports, "secondsToWholeMinuteTimeString", () => $ebeaf61d195e1652$export$e090c313e2cb7081);
const $ebeaf61d195e1652$var$SECONDS_PER_MINUTE = 60;
const $ebeaf61d195e1652$export$e090c313e2cb7081 = (seconds)=>`${Math.round(seconds / $ebeaf61d195e1652$var$SECONDS_PER_MINUTE)}m`;
var $ebeaf61d195e1652$export$2e2bcd8739ae039 = $ebeaf61d195e1652$export$e090c313e2cb7081;

});

parcelRegister("9odSb", function(module, exports) {

$parcel$export(module.exports, "useTimeTrackingField", () => $eb158ccbc60bd81b$export$eda25773281b1630);

var $lQE94 = parcelRequire("lQE94");

var $54wEF = parcelRequire("54wEF");
const $eb158ccbc60bd81b$export$eda25773281b1630 = ({ issueKey: issueKey, fieldKey: fieldKey, onSubmit: onSubmit, onSuccess: onSuccess, onFailure: onFailure })=>{
    const [{ value: fieldConfig }] = (0, $54wEF.useFieldConfig)(issueKey, fieldKey);
    const fieldType = fieldConfig?.schema.system || '';
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $lQE94.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: {
            originalEstimateSeconds: 0,
            timeSpentSeconds: 0,
            remainingEstimateSeconds: 0
        },
        onSuccess: onSuccess,
        onFailure: onFailure,
        onSubmit: onSubmit
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});

parcelRegister("gEYwC", function(module, exports) {

$parcel$export(module.exports, "originalEstimateBodyParams", () => $0f3bfc7baad799e0$export$25ca12ed4532196);
$parcel$export(module.exports, "originalEstimateEditTestId", () => $0f3bfc7baad799e0$export$85273aacc194bf89);
$parcel$export(module.exports, "originalEstimateViewTestId", () => $0f3bfc7baad799e0$export$97847a81d7704a9e);
$parcel$export(module.exports, "READ_VIEW_CONTAINER_SELECTOR_NAME", () => $0f3bfc7baad799e0$export$916dec1cd99a42a1);
$parcel$export(module.exports, "READ_VIEW_CONTAINER_SELECTOR", () => $0f3bfc7baad799e0$export$5c18970ef161f5b6);
$parcel$export(module.exports, "HOVER_CONTAINER_SELECTOR_NAME", () => $0f3bfc7baad799e0$export$c43a88184f234cd2);
$parcel$export(module.exports, "HOVER_CONTAINER_SELECTOR", () => $0f3bfc7baad799e0$export$366394ad8172710b);
// used to verify mock is originalEstimate
const $0f3bfc7baad799e0$export$25ca12ed4532196 = {
    fieldsToForcePresent: 'timetracking'
};
const $0f3bfc7baad799e0$export$85273aacc194bf89 = 'issue-field-original-estimate-editview-full.ui.original-estimate.edit';
const $0f3bfc7baad799e0$export$97847a81d7704a9e = 'issue-field-original-estimate.ui.view';
const $0f3bfc7baad799e0$export$916dec1cd99a42a1 = 'jira-issue-field-inline-edit-read-view-container';
const $0f3bfc7baad799e0$export$5c18970ef161f5b6 = `[data-component-selector="${$0f3bfc7baad799e0$export$916dec1cd99a42a1}"]`;
const $0f3bfc7baad799e0$export$c43a88184f234cd2 = 'jira-issue-field-original-estimate-hover-container';
const $0f3bfc7baad799e0$export$366394ad8172710b = `[data-component-selector="${$0f3bfc7baad799e0$export$c43a88184f234cd2}"]`;

});


parcelRegister("g92DA", function(module, exports) {

$parcel$export(module.exports, "timeTrackingSupportedTypes", () => $7cfa5cc7eb8e971f$export$de876e84f23a34b2);

var $5fc53 = parcelRequire("5fc53");
const $7cfa5cc7eb8e971f$export$de876e84f23a34b2 = [
    (0, $5fc53.TIME_ESTIMATE_TYPE)
];

});


parcelRegister("eowGc", function(module, exports) {

$parcel$export(module.exports, "urlClipboardHandler", () => $6d04cb075a7ac863$export$6e2f5cd13985078c);

var $hJx2A = parcelRequire("hJx2A");

var $5fc53 = parcelRequire("5fc53");

var $4UjyI = parcelRequire("4UjyI");

var $ks0ly = parcelRequire("ks0ly");

var $3O2T0 = parcelRequire("3O2T0");
const $6d04cb075a7ac863$var$getPastedValue = (clipboardItem)=>{
    if (!(0, $3O2T0.assertClipboardHasPlainTextFormat)(clipboardItem)) return null;
    return clipboardItem.plainText;
};
function $6d04cb075a7ac863$var$assertUrlField(field) {
    if (!field) throw new Error('Field is required');
    if (field.type !== (0, $5fc53.URL_CF_TYPE)) throw new Error('Field type is not supported');
}
const $6d04cb075a7ac863$var$useUrlClipboardHandler = (issue, field)=>{
    $6d04cb075a7ac863$var$assertUrlField(field);
    const [{ value: value }, { saveValue: saveValue }] = (0, $hJx2A.useUrlCustomField)({
        issueKey: issue.key,
        fieldKey: field?.fieldId,
        initialValue: field.value
    });
    return (0, $ks0ly.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: value ?? '',
        currentValue: value,
        getPastedValue: $6d04cb075a7ac863$var$getPastedValue,
        saveValue: saveValue
    });
};
const $6d04cb075a7ac863$var$UrlClipboardHelper = (0, $4UjyI.createClipboardHelperComponent)($6d04cb075a7ac863$var$useUrlClipboardHandler);
const $6d04cb075a7ac863$export$6e2f5cd13985078c = {
    [(0, $5fc53.URL_CF_TYPE)]: $6d04cb075a7ac863$var$UrlClipboardHelper
};

});
parcelRegister("hJx2A", function(module, exports) {

$parcel$export(module.exports, "useUrlCustomField", () => $5c820c84e8064736$export$8745adc9879e9e03);

var $9XE6b = parcelRequire("9XE6b");

var $lQE94 = parcelRequire("lQE94");

var $54wEF = parcelRequire("54wEF");
const $5c820c84e8064736$export$8745adc9879e9e03 = ({ issueKey: issueKey, fieldKey: fieldKey, onSuccess: onSuccess, onFailure: onFailure, initialValue: initialValue = null })=>{
    const [fieldConfig] = (0, $54wEF.useFieldConfig)(issueKey, fieldKey);
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(fieldConfig.value, 'schema.type', 'string');
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $lQE94.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: initialValue,
        onSuccess: onSuccess,
        onFailure: onFailure
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});


parcelRegister("4dpsE", function(module, exports) {

$parcel$export(module.exports, "userClipboardHandler", () => $d5837a14d54538d4$export$5fdc9960135beb70);
$parcel$export(module.exports, "multiUserClipboardHandler", () => $d5837a14d54538d4$export$6c011954430f0654);

var $9pwsK = parcelRequire("9pwsK");

var $lKk7c = parcelRequire("lKk7c");

var $5FzCC = parcelRequire("5FzCC");

var $jXbbD = parcelRequire("jXbbD");

var $5fc53 = parcelRequire("5fc53");

var $4UjyI = parcelRequire("4UjyI");

var $ks0ly = parcelRequire("ks0ly");

var $3O2T0 = parcelRequire("3O2T0");

var $jO40L = parcelRequire("jO40L");
const $d5837a14d54538d4$var$isTransformedUser = (fieldValue)=>fieldValue != null && typeof fieldValue === 'object' && 'accountId' in fieldValue && 'name' in fieldValue && 'picture' in fieldValue;
const $d5837a14d54538d4$var$isTransformedUserList = (fieldValue)=>fieldValue != null && Array.isArray(fieldValue) && fieldValue.length > 0 && fieldValue.every($d5837a14d54538d4$var$isTransformedUser);
function $d5837a14d54538d4$var$isUserValue(fieldValue) {
    return fieldValue != null && typeof fieldValue === 'object' && 'accountId' in fieldValue && 'displayName' in fieldValue && 'avatarUrls' in fieldValue;
}
function $d5837a14d54538d4$var$isUserValueList(fieldValue) {
    return fieldValue != null && Array.isArray(fieldValue) && fieldValue.length > 0 && fieldValue.every($d5837a14d54538d4$var$isUserValue);
}
function $d5837a14d54538d4$var$transformToUserValue(fieldValue) {
    const { accountId: accountId, name: name, picture: picture } = fieldValue;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return {
        accountId: accountId,
        displayName: name,
        avatarUrl: picture,
        avatarUrls: {
            '48x48': picture
        }
    };
}
function $d5837a14d54538d4$var$getPastedValue(clipboardItem, metadata) {
    if (!(0, $3O2T0.assertClipboardHasRichFormat)(clipboardItem) || !(0, $3O2T0.assertClipboardDataIsCompatible)(metadata, (0, $jO40L.userSupportedTypes))) return null;
    if (!$d5837a14d54538d4$var$isUserValue(metadata.fieldValue)) return null;
    return metadata.fieldValue;
}
function $d5837a14d54538d4$var$getPastedValuePlural(clipboardItem, metadata) {
    if (!(0, $3O2T0.assertClipboardHasRichFormat)(clipboardItem) || !(0, $3O2T0.assertClipboardDataIsCompatible)(metadata, (0, $jO40L.multiUserSupportedTypes))) return null;
    if (!$d5837a14d54538d4$var$isUserValueList(metadata.fieldValue)) return null;
    return metadata.fieldValue;
}
const $d5837a14d54538d4$var$useAssigneeClipboardHandler = (issue, field)=>{
    const [{ value: value }, { saveValue: saveValue }] = (0, $9pwsK.default)({
        issueKey: issue.key,
        initialValue: $d5837a14d54538d4$var$isTransformedUser(field.value) ? $d5837a14d54538d4$var$transformToUserValue(field.value) : undefined
    });
    return (0, $ks0ly.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: value?.displayName || null,
        currentValue: value,
        getPastedValue: $d5837a14d54538d4$var$getPastedValue,
        saveValue: saveValue
    });
};
const $d5837a14d54538d4$var$useReporterClipboardHandler = (issue, field)=>{
    const [{ value: value }, { saveValue: saveValue }] = (0, $jXbbD.useReporterField)({
        issueKey: issue.key,
        initialValue: $d5837a14d54538d4$var$isTransformedUser(field.value) ? $d5837a14d54538d4$var$transformToUserValue(field.value) : undefined
    });
    return (0, $ks0ly.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: value?.displayName || null,
        currentValue: value,
        getPastedValue: $d5837a14d54538d4$var$getPastedValue,
        saveValue: saveValue
    });
};
const $d5837a14d54538d4$var$useSingleUserClipboardHandler = (issue, field)=>{
    const [{ value: value }, { saveValue: saveValue }] = (0, $lKk7c.useUserCustomField)({
        issueKey: issue.key,
        fieldKey: field.fieldId,
        initialValue: $d5837a14d54538d4$var$isTransformedUser(field.value) ? $d5837a14d54538d4$var$transformToUserValue(field.value) : undefined
    });
    return (0, $ks0ly.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: value?.displayName || null,
        currentValue: value,
        getPastedValue: $d5837a14d54538d4$var$getPastedValue,
        saveValue: saveValue
    });
};
const $d5837a14d54538d4$var$useMultiUserClipboardHandler = (issue, field)=>{
    const [{ value: value }, { saveValue: saveValue }] = (0, $5FzCC.useMultiUserCustomField)({
        issueKey: issue.key,
        fieldKey: field.fieldId,
        initialValue: $d5837a14d54538d4$var$isTransformedUserList(field.value) ? field.value.map($d5837a14d54538d4$var$transformToUserValue) : undefined
    });
    return (0, $ks0ly.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: value?.map((user)=>user.displayName).join(', ') || null,
        currentValue: value,
        getPastedValue: $d5837a14d54538d4$var$getPastedValuePlural,
        saveValue: saveValue
    });
};
const $d5837a14d54538d4$var$UserClipboardHelper = (0, $4UjyI.createClipboardHelperComponent)($d5837a14d54538d4$var$useSingleUserClipboardHandler);
const $d5837a14d54538d4$var$MultiUserClipboardHelper = (0, $4UjyI.createClipboardHelperComponent)($d5837a14d54538d4$var$useMultiUserClipboardHandler);
const $d5837a14d54538d4$var$AssigneeClipboardHelper = (0, $4UjyI.createClipboardHelperComponent)($d5837a14d54538d4$var$useAssigneeClipboardHandler);
const $d5837a14d54538d4$var$ReporterClipboardHelper = (0, $4UjyI.createClipboardHelperComponent)($d5837a14d54538d4$var$useReporterClipboardHandler);
const $d5837a14d54538d4$export$5fdc9960135beb70 = {
    [(0, $5fc53.USER_CF_TYPE)]: $d5837a14d54538d4$var$UserClipboardHelper,
    [(0, $5fc53.REPORTER_TYPE)]: $d5837a14d54538d4$var$ReporterClipboardHelper,
    [(0, $5fc53.ASSIGNEE_TYPE)]: $d5837a14d54538d4$var$AssigneeClipboardHelper
};
const $d5837a14d54538d4$export$6c011954430f0654 = {
    [(0, $5fc53.MULTI_USER_CF_TYPE)]: $d5837a14d54538d4$var$MultiUserClipboardHelper,
    [(0, $5fc53.PEOPLE_CF_TYPE)]: $d5837a14d54538d4$var$MultiUserClipboardHelper
};

});
parcelRegister("9pwsK", function(module, exports) {

$parcel$export(module.exports, "useAssigneeField", () => $698ad2ce222cbf0d$export$e3a8121b536e7353);
$parcel$export(module.exports, "default", () => $698ad2ce222cbf0d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9XE6b = parcelRequire("9XE6b");

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $eusud = parcelRequire("eusud");

var $lQE94 = parcelRequire("lQE94");

var $54wEF = parcelRequire("54wEF");

var $3fAi8 = parcelRequire("3fAi8");



var $1kqLh = parcelRequire("1kqLh");
const $698ad2ce222cbf0d$var$getCurrentAssigneeUrl = (_baseUrl, issueKey)=>`/rest/api/3/issue/${issueKey}?fields=assignee`;
const $698ad2ce222cbf0d$var$getCurrentAssignee = async (baseUrl, issueKey)=>{
    const response = await (0, $eusud.performGetRequest)($698ad2ce222cbf0d$var$getCurrentAssigneeUrl(baseUrl, issueKey));
    const { assignee: assignee } = response.fields;
    return assignee;
};
const $698ad2ce222cbf0d$export$e3a8121b536e7353 = ({ issueKey: issueKey, initialValue: initialValue, onSubmit: onSubmit, onSuccess: onSuccess, onFailure: onFailure, onSaveField: onSaveField })=>{
    const fieldKey = (0, $e9be48d6d2c01760$export$e18419056f3d184a);
    // useFieldConfig now returns an object { value, loading } instead of just the fieldConfig value
    // if possible when touching this, try and refactor to pass the new object instead of just the value
    const [{ value: fieldConfig }] = (0, $54wEF.useFieldConfig)(issueKey, fieldKey);
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(fieldConfig, 'schema.type', 'user');
    const [, { setFieldValue: setFieldValue }] = (0, $3fAi8.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $e9be48d6d2c01760$export$e18419056f3d184a)
    });
    const baseUrl = '';
    const onSaveSuccess = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter 'currentAssignee' implicitly has an 'any' type.
    (currentAssignee)=>{
        if (currentAssignee && currentAssignee.accountId === (0, $c1e3a0a8493b8e86$export$f5d5f6bb902f1027)) $698ad2ce222cbf0d$var$getCurrentAssignee(baseUrl, issueKey).then((assignee)=>{
            setFieldValue(issueKey, (0, $e9be48d6d2c01760$export$e18419056f3d184a), assignee);
            onSuccess?.(assignee);
        }).catch((error)=>{
            (0, $jcw0u.default)({
                meta: {
                    id: 'currentAssigneeFetch',
                    packageName: 'jiraIssueFieldAssignee'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            onSuccess?.(currentAssignee); // In case api fail, better to show Automatic only
        });
        else onSuccess?.(currentAssignee);
    }, [
        baseUrl,
        issueKey,
        onSuccess,
        setFieldValue
    ]);
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $lQE94.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: initialValue || null,
        onSubmit: onSubmit,
        onSuccess: onSaveSuccess,
        onFailure: onFailure,
        saveField: (0, $4R6GH.fg)('issue_cards_in_program_board') ? onSaveField || (0, $1kqLh.saveAssigneeField) : (0, $1kqLh.saveAssigneeField)
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};
var $698ad2ce222cbf0d$export$2e2bcd8739ae039 = $698ad2ce222cbf0d$export$e3a8121b536e7353;

});
const $c1e3a0a8493b8e86$export$bdab9bfb39981463 = '__UNASSIGNED_ID__';
const $c1e3a0a8493b8e86$export$d875316cb0cd94f7 = '__INVITE_PEOPLE_ID__';
const $c1e3a0a8493b8e86$export$f5d5f6bb902f1027 = '-1';

parcelRegister("1kqLh", function(module, exports) {

$parcel$export(module.exports, "saveAssigneeField", () => $181ec719237f646a$export$4966afe29c596da8);

var $eusud = parcelRequire("eusud");
const $181ec719237f646a$export$4966afe29c596da8 = async (issueKey, fieldKey, newValue, _baseUrl)=>{
    const userValue = newValue;
    return (0, $eusud.performPutRequest)(`/rest/api/3/issue/${issueKey}/assignee`, {
        // the accountId field set to null will unassign the user from the issue as a fallback
        body: JSON.stringify({
            accountId: userValue?.accountId || null
        })
    });
};

});


parcelRegister("lKk7c", function(module, exports) {

$parcel$export(module.exports, "useUserCustomField", () => $915ad675f09dae67$export$44f19b35a6cf5de7);

var $9XE6b = parcelRequire("9XE6b");

var $lQE94 = parcelRequire("lQE94");

var $54wEF = parcelRequire("54wEF");

var $5fc53 = parcelRequire("5fc53");
const $915ad675f09dae67$export$44f19b35a6cf5de7 = ({ issueKey: issueKey, fieldKey: fieldKey, initialValue: initialValue, onSubmit: onSubmit, onSuccess: onSuccess, onFailure: onFailure })=>{
    const [{ value: fieldConfig }] = (0, $54wEF.useFieldConfig)(issueKey, fieldKey);
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(fieldConfig, 'schema.type', (0, $5fc53.USER_CF_TYPE));
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $lQE94.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: initialValue || null,
        onSubmit: onSubmit,
        onSuccess: onSuccess,
        onFailure: onFailure
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});

parcelRegister("5FzCC", function(module, exports) {

$parcel$export(module.exports, "useMultiUserCustomField", () => $aa0502e28ab7d5f7$export$80bbf5398d3851fe);

var $9XE6b = parcelRequire("9XE6b");

var $lQE94 = parcelRequire("lQE94");

var $54wEF = parcelRequire("54wEF");

var $5fc53 = parcelRequire("5fc53");
const $aa0502e28ab7d5f7$export$80bbf5398d3851fe = ({ issueKey: issueKey, fieldKey: fieldKey, initialValue: initialValue, onSubmit: onSubmit, onSuccess: onSuccess, onFailure: onFailure })=>{
    const [{ value: fieldConfig }] = (0, $54wEF.useFieldConfig)(issueKey, fieldKey);
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(fieldConfig, 'schema.type', (0, $5fc53.MULTI_USER_CF_TYPE));
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $lQE94.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: initialValue || null,
        onSubmit: onSubmit,
        onSuccess: onSuccess,
        onFailure: onFailure
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});

parcelRegister("jXbbD", function(module, exports) {

$parcel$export(module.exports, "useReporterField", () => $26ce637363a1a7cc$export$62a1425ef3dadde5);

var $9XE6b = parcelRequire("9XE6b");

var $lQE94 = parcelRequire("lQE94");

var $54wEF = parcelRequire("54wEF");

var $5fc53 = parcelRequire("5fc53");

const $26ce637363a1a7cc$export$62a1425ef3dadde5 = ({ issueKey: issueKey, initialValue: initialValue, onSubmit: onSubmit, onSuccess: onSuccess, onFailure: onFailure })=>{
    const fieldKey = (0, $e9be48d6d2c01760$export$45cafdfd629c3ca1);
    const [{ value: fieldConfig }] = (0, $54wEF.useFieldConfig)(issueKey, fieldKey);
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(fieldConfig, 'schema.type', (0, $5fc53.REPORTER_TYPE));
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $lQE94.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: initialValue || null,
        onSubmit: onSubmit,
        onSuccess: onSuccess,
        onFailure: onFailure
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});

parcelRegister("jO40L", function(module, exports) {

$parcel$export(module.exports, "userSupportedTypes", () => $9ab5e35e7add97a9$export$ef7e74d56a5479e);
$parcel$export(module.exports, "multiUserSupportedTypes", () => $9ab5e35e7add97a9$export$60f19a2c9595ba14);

var $5fc53 = parcelRequire("5fc53");
const $9ab5e35e7add97a9$export$ef7e74d56a5479e = [
    (0, $5fc53.USER_CF_TYPE),
    (0, $5fc53.REPORTER_TYPE),
    (0, $5fc53.ASSIGNEE_TYPE)
];
const $9ab5e35e7add97a9$export$60f19a2c9595ba14 = [
    (0, $5fc53.MULTI_USER_CF_TYPE),
    (0, $5fc53.PEOPLE_CF_TYPE)
];

});


parcelRegister("9UQ66", function(module, exports) {

$parcel$export(module.exports, "versionClipboardHandler", () => $9e30f249684de572$export$ac26006c0d5889ca);

var $lQE94 = parcelRequire("lQE94");

var $5fc53 = parcelRequire("5fc53");

var $4UjyI = parcelRequire("4UjyI");

var $ks0ly = parcelRequire("ks0ly");

var $3O2T0 = parcelRequire("3O2T0");

var $8g1d0 = parcelRequire("8g1d0");
const $9e30f249684de572$var$isTransformedSingleVersion = (option)=>!!option && typeof option === 'object' && 'id' in option && 'name' in option;
const $9e30f249684de572$var$isTransformedMultipleVersions = (fieldValue)=>Array.isArray(fieldValue) && fieldValue.every($9e30f249684de572$var$isTransformedSingleVersion);
const $9e30f249684de572$var$emptyValue = [];
function $9e30f249684de572$var$assertVersionField(field) {
    if (!field) throw new Error('Field is required');
    if (field.type !== (0, $5fc53.MULTI_VERSION_CF_TYPE) && field.type !== (0, $5fc53.AFFECTS_VERSIONS_TYPE) && field.type !== (0, $5fc53.FIX_VERSIONS_TYPE) && field.type !== (0, $5fc53.VERSION_CF_TYPE)) throw new Error('Field type is not supported');
}
const $9e30f249684de572$var$getPastedValue = (clipboardItem, metadata)=>{
    if (!(0, $3O2T0.assertClipboardHasPlainTextFormat)(clipboardItem) || !(0, $3O2T0.assertClipboardDataIsCompatible)(metadata, (0, $8g1d0.versionSupportedTypes))) return null;
    if (!$9e30f249684de572$var$isTransformedMultipleVersions(metadata?.fieldValue) && !$9e30f249684de572$var$isTransformedSingleVersion(metadata?.fieldValue)) return null;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    if (!(0, $8g1d0.versionSupportedTypes).includes(metadata.fieldType)) return null;
    return metadata?.fieldValue;
};
const $9e30f249684de572$var$getInitialValue = (field)=>{
    if (field.type === (0, $5fc53.VERSION_CF_TYPE)) return field.value ?? null;
    return $9e30f249684de572$var$isTransformedMultipleVersions(field.value) ? field.value : $9e30f249684de572$var$emptyValue;
};
const $9e30f249684de572$var$useVersionClipboardHandler = (issue, field)=>{
    $9e30f249684de572$var$assertVersionField(field);
    const [{ value: value }, { saveValue: saveValue }] = (0, $lQE94.useEditField)({
        fieldKey: field.fieldId,
        issueKey: issue.key,
        fieldType: field.type,
        initialValue: $9e30f249684de572$var$getInitialValue(field)
    });
    return (0, $ks0ly.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: $9e30f249684de572$var$isTransformedSingleVersion(field.value) ? field.value?.name ?? null : field.value?.map((v)=>v.name).join(',') ?? null,
        currentValue: value,
        getPastedValue: $9e30f249684de572$var$getPastedValue,
        saveValue: saveValue
    });
};
const $9e30f249684de572$var$VersionClipboardHelper = (0, $4UjyI.createClipboardHelperComponent)($9e30f249684de572$var$useVersionClipboardHandler);
const $9e30f249684de572$export$ac26006c0d5889ca = {
    [(0, $5fc53.VERSION_CF_TYPE)]: $9e30f249684de572$var$VersionClipboardHelper,
    [(0, $5fc53.MULTI_VERSION_CF_TYPE)]: $9e30f249684de572$var$VersionClipboardHelper,
    [(0, $5fc53.AFFECTS_VERSIONS_TYPE)]: $9e30f249684de572$var$VersionClipboardHelper,
    [(0, $5fc53.FIX_VERSIONS_TYPE)]: $9e30f249684de572$var$VersionClipboardHelper
};

});


parcelRegister("9de3P", function(module, exports) {

$parcel$export(module.exports, "getFieldMetadataFromClipboard", () => $8710af0b45a9f4dc$export$6de7bf511f204c08);
const $8710af0b45a9f4dc$export$6de7bf511f204c08 = (clipboard)=>{
    if (!clipboard?.html) return null;
    try {
        const clipboardDocument = new DOMParser().parseFromString(clipboard.html, 'text/html');
        const data = clipboardDocument.body?.querySelector('div')?.dataset;
        if (!data || !data.fieldType || !data.fieldId) return null;
        return {
            fieldType: data.fieldType,
            fieldId: data.fieldId,
            fieldValue: data.fieldValue ? JSON.parse(data.fieldValue) : null,
            sourceIssueTypeLevel: data.issueTypeLevel
        };
    } catch (e) {
        return null;
    }
};
const $8710af0b45a9f4dc$export$94a5f06e658f87e2 = ()=>Promise.resolve(false);

});


parcelRegister("g65iA", function(module, exports) {

$parcel$export(module.exports, "canBeReset", () => $4a9a7d152ef300aa$export$7f0aa0ea8c7401f3);
$parcel$export(module.exports, "useClipboardErrorReporting", () => $4a9a7d152ef300aa$export$a3594035e6545378);
$parcel$export(module.exports, "setDataToClipboard", () => $4a9a7d152ef300aa$export$8b3dcc1c5e2cc52e);

var $5uXOq = parcelRequire("5uXOq");

var $bj6Oi = parcelRequire("bj6Oi");

var $bxNFR = parcelRequire("bxNFR");

var $1xoxe = parcelRequire("1xoxe");

var $jcw0u = parcelRequire("jcw0u");

var $6s1PB = parcelRequire("6s1PB");

var $7HGHK = parcelRequire("7HGHK");
var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $bGSLr = parcelRequire("bGSLr");
const $4a9a7d152ef300aa$var$UNSETTABLE_FIELD_TYPES = {
    issuekey: true,
    issuetype: true,
    priority: true,
    status: true,
    parent: true
};
const $4a9a7d152ef300aa$export$7f0aa0ea8c7401f3 = (field)=>{
    const isEditable = field.fieldConfig?.isEditable ?? false;
    const isRequired = field.fieldConfig?.isRequired ?? false;
    if (field.type != null && field.type in $4a9a7d152ef300aa$var$UNSETTABLE_FIELD_TYPES) return false;
    return isEditable && !isRequired;
};
const $4a9a7d152ef300aa$var$getPasteMessage = (wrappedFormatMessage, error)=>{
    if (error && (0, $bj6Oi.isClientSideValidationError)(error)) {
        if (error.message === (0, $1xoxe.VALIDATION_ERROR_CODES).EMPTY_CLIPBOARD) return {
            title: wrappedFormatMessage((0, $bGSLr.default).emptyClipboardTitle),
            description: wrappedFormatMessage((0, $bGSLr.default).pasteEmptyClipboardError)
        };
        if (error.message === (0, $1xoxe.VALIDATION_ERROR_CODES).MISSING_FIELD) return {
            title: wrappedFormatMessage((0, $bGSLr.default).pasteErrorTitle),
            description: wrappedFormatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bGSLr.default).missingFieldAssociationErrorIssueTermRefresh : (0, $bGSLr.default).missingFieldAssociationError)
        };
        if (error.message === (0, $1xoxe.VALIDATION_ERROR_CODES).NON_COMPATIBLE_FIELD_TYPE) return {
            title: wrappedFormatMessage((0, $bGSLr.default).pasteErrorTitle),
            description: wrappedFormatMessage((0, $bGSLr.default).pasteUnsupportedError)
        };
    }
    if (error && (0, $bxNFR.isUnsupportedOperationError)(error)) return {
        title: wrappedFormatMessage((0, $bGSLr.default).pasteErrorTitle),
        description: wrappedFormatMessage((0, $bGSLr.default).pasteUnsupportedError)
    };
    return {
        title: wrappedFormatMessage((0, $bGSLr.default).pasteErrorTitle),
        description: wrappedFormatMessage((0, $bGSLr.default).genericServerError)
    };
};
const $4a9a7d152ef300aa$var$getCutMessage = (wrappedFormatMessage, error)=>{
    if (error && (0, $bj6Oi.isClientSideValidationError)(error) && error.message === (0, $1xoxe.VALIDATION_ERROR_CODES).NON_EDITABLE) return {
        title: wrappedFormatMessage((0, $bGSLr.default).cutErrorTitle),
        description: wrappedFormatMessage((0, $bGSLr.default).cutNonEditableError)
    };
    return {
        title: wrappedFormatMessage((0, $bGSLr.default).cutErrorTitle),
        description: wrappedFormatMessage((0, $bGSLr.default).genericServerError)
    };
};
const $4a9a7d152ef300aa$var$getCopyMessage = (wrappedFormatMessage)=>({
        title: wrappedFormatMessage((0, $bGSLr.default).copyErrorTitle),
        description: wrappedFormatMessage((0, $bGSLr.default).copyValidationError)
    });
const $4a9a7d152ef300aa$export$82f46aa4e6535a45 = (action, wrappedFormatMessage, error)=>{
    if (action === 'paste') return $4a9a7d152ef300aa$var$getPasteMessage(wrappedFormatMessage, error);
    if (action === 'cut') return $4a9a7d152ef300aa$var$getCutMessage(wrappedFormatMessage, error);
    if (action === 'copy') return $4a9a7d152ef300aa$var$getCopyMessage(wrappedFormatMessage);
};
const $4a9a7d152ef300aa$var$uniqueFlagId = (0, $7HGHK.toFlagId)('LIST_COPY_PASTE_FLAG');
const $4a9a7d152ef300aa$export$a3594035e6545378 = (field)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { dismissFlag: dismissFlag, showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const showErroFlag = (0, $5uXOq.useCallback)(({ action: action, error: error })=>{
        const wrappedFormatMessage = (message)=>formatMessage(message, {
                name: field.name
            });
        const errorMessage = $4a9a7d152ef300aa$export$82f46aa4e6535a45(action, wrappedFormatMessage, error);
        if (!errorMessage) return;
        const flagType = !error || (0, $bj6Oi.isClientSideValidationError)(error) ? 'warning' : 'error';
        showFlag({
            id: $4a9a7d152ef300aa$var$uniqueFlagId,
            type: flagType,
            title: errorMessage.title,
            description: errorMessage.description,
            messageId: `business-list.controllers.clipboard.showFlag.${flagType}`,
            messageType: 'transactional'
        });
    }, [
        field.name,
        formatMessage,
        showFlag
    ]);
    const reportError = (0, $5uXOq.useCallback)(({ action: action, error: error })=>{
        if (!error) return;
        const ugcSafeMessage = `Failed to ${action} a field of type ${field.type}`;
        (0, $jcw0u.default)({
            meta: {
                id: 'jiraClipboardController',
                packageName: 'jiraBusinessList',
                teamName: 'keystone'
            },
            attributes: {
                message: ugcSafeMessage,
                fieldType: field.type,
                operation: action
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        showErroFlag({
            action: action,
            error: error
        });
    }, [
        field.type,
        showErroFlag
    ]);
    return {
        reportError: reportError,
        dismissFlag: ()=>dismissFlag($4a9a7d152ef300aa$var$uniqueFlagId),
        showErroFlag: showErroFlag
    };
};
const $4a9a7d152ef300aa$export$8b3dcc1c5e2cc52e = (e, clipboardItem)=>{
    if (!e.clipboardData || !clipboardItem || !clipboardItem.plainText || !clipboardItem.html) throw new Error('Clipboard item is not provided');
    e.clipboardData.setData('text/plain', clipboardItem.plainText);
    e.clipboardData.setData('text/html', clipboardItem.html);
};

});
parcelRegister("bGSLr", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ab19ff3c4a36483$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3ab19ff3c4a36483$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    pasteErrorTitle: {
        "id": "business-list.controllers.clipboard.paste-error-title",
        "defaultMessage": "Unable to paste"
    },
    cutErrorTitle: {
        "id": "business-list.controllers.clipboard.cut-error-title",
        "defaultMessage": "We couldn't cut this field"
    },
    copyErrorTitle: {
        "id": "business-list.controllers.clipboard.copy-error-title",
        "defaultMessage": "Unable to copy"
    },
    emptyClipboardTitle: {
        "id": "business-list.controllers.clipboard.empty-clipboard-title",
        "defaultMessage": "Your clipboard is empty"
    },
    genericServerError: {
        "id": "business-list.controllers.clipboard.generic-server-error",
        "defaultMessage": "Your changes couldn't be saved."
    },
    pasteUnsupportedError: {
        "id": "business-list.controllers.clipboard.paste-unsupported-error",
        "defaultMessage": "This can't be pasted on {name}."
    },
    missingFieldAssociationError: {
        "id": "business-list.controllers.clipboard.missing-field-association-error",
        "defaultMessage": "Can't paste on {name}, looks like the field is not associated to this issue type."
    },
    cutNonEditableError: {
        "id": "business-list.controllers.clipboard.cut-non-editable-error",
        "defaultMessage": "{name} is copied to your clipboard instead."
    },
    copyValidationError: {
        "id": "business-list.controllers.clipboard.copy-validation-error",
        "defaultMessage": "{name} can't be copied."
    },
    pasteEmptyClipboardError: {
        "id": "business-list.controllers.clipboard.paste-empty-clipboard-error",
        "defaultMessage": "Cut or copy your data, then try again."
    },
    missingFieldAssociationErrorIssueTermRefresh: {
        "id": "business-list.controllers.clipboard.missing-field-association-error-issue-term-refresh",
        "defaultMessage": "Can't paste on {name}, looks like the field is not associated to this work type."
    }
});

});



parcelRegister("d3rVJ", function(module, exports) {

$parcel$export(module.exports, "KEY_LEFT", () => $dea06fb03addf101$export$fc4577f2a2af0ae3);
$parcel$export(module.exports, "KEY_RIGHT", () => $dea06fb03addf101$export$c40f9845adc73fb5);
$parcel$export(module.exports, "KEY_UP", () => $dea06fb03addf101$export$390330c10ff2b9a1);
$parcel$export(module.exports, "KEY_DOWN", () => $dea06fb03addf101$export$a80636c6f41931fe);
$parcel$export(module.exports, "KEY_SPACE", () => $dea06fb03addf101$export$e51a3576c045c8d5);
$parcel$export(module.exports, "KEY_ENTER", () => $dea06fb03addf101$export$8152f929a25a0ff4);
$parcel$export(module.exports, "KEY_ESCAPE", () => $dea06fb03addf101$export$929c2026f4dd54a2);
$parcel$export(module.exports, "KEY_TAB", () => $dea06fb03addf101$export$10f6869ed0a7d75b);
$parcel$export(module.exports, "VALID_HORIZONTAL_NAV_KEYS", () => $dea06fb03addf101$export$4db3e0c7105aa3de);
$parcel$export(module.exports, "VALID_NAVIGATION_KEYS", () => $dea06fb03addf101$export$dbef91493a5ef2ef);
$parcel$export(module.exports, "NAV_KEYS_TO_DIRECTION", () => $dea06fb03addf101$export$678e8f968de3f1e5);
$parcel$export(module.exports, "getNewNavSupportedFieldTypes", () => $dea06fb03addf101$export$a421a6d0cf26d9e);

var $8QpSo = parcelRequire("8QpSo");

var $hE5wF = parcelRequire("hE5wF");

var $7q7Al = parcelRequire("7q7Al");

var $5fc53 = parcelRequire("5fc53");

var $eTDjN = parcelRequire("eTDjN");
const $dea06fb03addf101$export$fc4577f2a2af0ae3 = 'ArrowLeft';
const $dea06fb03addf101$export$c40f9845adc73fb5 = 'ArrowRight';
const $dea06fb03addf101$export$390330c10ff2b9a1 = 'ArrowUp';
const $dea06fb03addf101$export$a80636c6f41931fe = 'ArrowDown';
const $dea06fb03addf101$export$e51a3576c045c8d5 = ' ';
const $dea06fb03addf101$export$8152f929a25a0ff4 = 'Enter';
const $dea06fb03addf101$export$929c2026f4dd54a2 = 'Escape';
const $dea06fb03addf101$export$10f6869ed0a7d75b = 'Tab';
const $dea06fb03addf101$export$4db3e0c7105aa3de = new Set([
    $dea06fb03addf101$export$fc4577f2a2af0ae3,
    $dea06fb03addf101$export$c40f9845adc73fb5,
    $dea06fb03addf101$export$10f6869ed0a7d75b
]);
const $dea06fb03addf101$export$dbef91493a5ef2ef = new Set([
    ...$dea06fb03addf101$export$4db3e0c7105aa3de,
    $dea06fb03addf101$export$390330c10ff2b9a1,
    $dea06fb03addf101$export$a80636c6f41931fe,
    $dea06fb03addf101$export$e51a3576c045c8d5,
    $dea06fb03addf101$export$8152f929a25a0ff4,
    $dea06fb03addf101$export$929c2026f4dd54a2
]);
const $dea06fb03addf101$export$678e8f968de3f1e5 = {
    [$dea06fb03addf101$export$fc4577f2a2af0ae3]: (0, $eTDjN.LEFT),
    [$dea06fb03addf101$export$c40f9845adc73fb5]: (0, $eTDjN.RIGHT),
    [$dea06fb03addf101$export$390330c10ff2b9a1]: (0, $eTDjN.UP),
    [$dea06fb03addf101$export$a80636c6f41931fe]: (0, $eTDjN.DOWN)
};
const $dea06fb03addf101$var$NEW_NAV_SUPPORTED_FIELD_TYPES = new Set([
    (0, $5fc53.ASSIGNEE_TYPE),
    (0, $5fc53.CATEGORY_TYPE),
    (0, $5fc53.COMPONENTS_TYPE),
    (0, $5fc53.COMMENT_TYPE),
    (0, $hE5wF.COMMENT_SUMMARY_TYPE),
    (0, $5fc53.CREATED),
    (0, $5fc53.DATE_CF_TYPE),
    (0, $5fc53.DATETIME_CF_TYPE),
    (0, $5fc53.DUE_DATE_TYPE),
    (0, $5fc53.ISSUE_TYPE),
    (0, $5fc53.LABELS_TYPE),
    (0, $5fc53.LABELS_CF_TYPE),
    (0, $5fc53.MULTI_CHECKBOXES_CF_TYPE),
    (0, $5fc53.MULTI_SELECT_CF_TYPE),
    (0, $5fc53.MULTI_USER_CF_TYPE),
    (0, $5fc53.NUMBER_CF_TYPE),
    (0, $5fc53.PEOPLE_CF_TYPE),
    (0, $5fc53.PRIORITY_TYPE),
    (0, $hE5wF.REMOTE_ISSUE_LINKS_TYPE),
    (0, $5fc53.REPORTER_TYPE),
    (0, $5fc53.STORY_POINTS_TYPE),
    (0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE),
    (0, $5fc53.SPRINT_TYPE),
    (0, $5fc53.SUMMARY_TYPE),
    (0, $5fc53.SELECT_CF_TYPE),
    (0, $5fc53.STATUS_TYPE),
    (0, $5fc53.TEXT_AREA_CF_TYPE),
    (0, $5fc53.TEXT_CF_TYPE),
    (0, $5fc53.TIME_ESTIMATE_TYPE),
    (0, $5fc53.UPDATED),
    (0, $5fc53.URL_CF_TYPE),
    (0, $5fc53.USER_CF_TYPE),
    'key'
]);
const $dea06fb03addf101$export$a421a6d0cf26d9e = (0, $8QpSo.default)(()=>new Set([
        ...$dea06fb03addf101$var$NEW_NAV_SUPPORTED_FIELD_TYPES,
        ...(0, $7q7Al.getSupportedFieldTypes)(true)
    ]));

});


parcelRegister("i29pf", function(module, exports) {

$parcel$export(module.exports, "CellWithHorizontalVirtualization", () => $1ecf207fc704f608$export$9f868e7b7b690ae0);

var $5uXOq = parcelRequire("5uXOq");


var $7q7Al = parcelRequire("7q7Al");

var $7xKtR = parcelRequire("7xKtR");

var $5fc53 = parcelRequire("5fc53");

var $4R6GH = parcelRequire("4R6GH");

var $ltZxv = parcelRequire("ltZxv");

var $cjOYL = parcelRequire("cjOYL");

var $3fT9O = parcelRequire("3fT9O");

var $3rO9r = parcelRequire("3rO9r");

var $cYskc = parcelRequire("cYskc");

var $jUhIo = parcelRequire("jUhIo");
const $1ecf207fc704f608$var$FieldCellWithIssueViewHandler = (props)=>{
    const { createOpenIssueModalHandler: createOpenIssueModalHandler } = (0, $ltZxv.useIssueModalActions)();
    const otherProps = (0, $5uXOq.useMemo)(()=>({
            createOpenIssueModalHandler: createOpenIssueModalHandler
        }), [
        createOpenIssueModalHandler
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7xKtR.FieldCell), {
        ...props,
        otherProps: otherProps
    });
};
const $1ecf207fc704f608$var$FieldCell = (props)=>{
    if (props.fieldType === (0, $5fc53.PARENT_TYPE) && (0, $4R6GH.fg)('remove_issue_view_dependency_on_business_field')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1ecf207fc704f608$var$FieldCellWithIssueViewHandler, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7xKtR.FieldCell), props);
};
const $1ecf207fc704f608$export$f6f0c3fe4ec306ea = /*#__PURE__*/ (0, $5uXOq.memo)(({ cellRenderers: cellRenderers, field: field, onIssueUpdated: onIssueUpdated, projectId: projectId, width: width, ...rest })=>{
    const cellRenderer = (0, $7xKtR.isFieldCellTypes)(field.type) && (0, $7xKtR.isFieldCellSupported)(field.type) ? (params)=>{
        const { rowData: rowData, rowIndex: rowIndex, columnIndex: columnIndex } = params;
        if ((0, $3fT9O.isItemSkeleton)(rowData.issueId) || field.id.startsWith((0, $3rO9r.PLACEHOLDER_COLUMN))) // experimenting with inlining CSS here to avoid styled-components runtime perf overhead
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testId": "business-list.ui.list-view.loading-cell",
            // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            style: (0, $cjOYL.loadingCellStyles)
        });
        let cellData;
        if ((0, $7q7Al.isTopLevelField)(field.type)) {
            const key = (0, $7q7Al.getTopLevelFieldKey)(field.type);
            if (key) cellData = rowData[key];
        } else // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        cellData = rowData.fields?.find((f)=>f.fieldId === field.id);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jUhIo.WithCellSelection), {
            depth: rowData.depth,
            width: width,
            fieldId: field.id,
            projectId: projectId,
            issueId: rowData.issueId,
            position: rowIndex === 0 ? (0, $44496cc0f0c1ce14$export$86bcdda8e7a22b9d) : (0, $44496cc0f0c1ce14$export$a3a66eb204e551b3),
            rowIndex: rowIndex,
            columnIndex: columnIndex,
            field: field,
            issue: rowData
        }, ()=>// Check for type existence was already done above
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1ecf207fc704f608$var$FieldCell, {
                fieldType: field.type ?? '',
                ...params,
                cellData: cellData,
                onIssueUpdated: onIssueUpdated,
                fieldId: field.id,
                fieldName: field.name
            }));
    } : (params)=>{
        const { rowData: rowData, rowIndex: rowIndex, columnIndex: columnIndex } = params;
        if ((0, $3fT9O.isItemSkeleton)(rowData.issueId) || field.id.startsWith((0, $3rO9r.PLACEHOLDER_COLUMN))) // experimenting with inlining CSS here to avoid styled-components runtime perf overhead
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testId": "business-list.ui.list-view.loading-cell",
            // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            style: (0, $cjOYL.loadingCellStyles)
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jUhIo.WithCellSelection), {
            depth: rowData.depth,
            width: width,
            fieldId: field.id,
            projectId: projectId,
            issueId: rowData.issueId,
            position: rowIndex === 0 ? (0, $44496cc0f0c1ce14$export$86bcdda8e7a22b9d) : (0, $44496cc0f0c1ce14$export$a3a66eb204e551b3),
            rowIndex: rowIndex,
            columnIndex: columnIndex,
            field: field,
            issue: rowData
        }, ()=>cellRenderers[field.id](params));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, cellRenderer({
        ...rest,
        onIssueUpdated: onIssueUpdated
    }));
});
$1ecf207fc704f608$export$f6f0c3fe4ec306ea.displayName = 'Cell';
const $1ecf207fc704f608$export$9f868e7b7b690ae0 = (props)=>{
    const isColumnVisible = (0, $cYskc.useIsColumnVisible)(props.column);
    return isColumnVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1ecf207fc704f608$export$f6f0c3fe4ec306ea, props) : null;
};

});
const $44496cc0f0c1ce14$export$86bcdda8e7a22b9d = 'inner';
const $44496cc0f0c1ce14$export$a3a66eb204e551b3 = 'outer';

parcelRegister("7xKtR", function(module, exports) {

$parcel$export(module.exports, "isFieldCellSupported", () => $50b53fd6303170ad$export$33fa2ddeaefadb7f);
$parcel$export(module.exports, "isFieldCellTypes", () => $50b53fd6303170ad$export$6a0360e2da5b783e);
$parcel$export(module.exports, "FieldCell", () => $50b53fd6303170ad$export$8ae908fe84f8a33b);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $9hMF9 = parcelRequire("9hMF9");

var $3RxLo = parcelRequire("3RxLo");

var $7Qe9Z = parcelRequire("7Qe9Z");

var $lna2D = parcelRequire("lna2D");

var $kpNUY = parcelRequire("kpNUY");

var $8egWI = parcelRequire("8egWI");

var $c2t1Z = parcelRequire("c2t1Z");

var $kpiLK = parcelRequire("kpiLK");

var $1RGG5 = parcelRequire("1RGG5");

var $cphvi = parcelRequire("cphvi");

var $jRQOz = parcelRequire("jRQOz");
const $50b53fd6303170ad$var$createFieldCellComponents = (0, $8QpSo.default)(()=>({
        ...(0, $jRQOz.versionCellHandler),
        ...(0, $kpNUY.parentCellHandler),
        ...(0, $3RxLo.devSummaryCellHandler),
        ...(0, $7Qe9Z.goalsCellHandler),
        ...(0, $cphvi.teamCellHandler),
        ...(0, $kpiLK.resolutionCellHandler),
        ...(0, $lna2D.groupCellHandler),
        ...(0, $1RGG5.statusCategoryCellHandler),
        ...(0, $c2t1Z.radioSelectCellHandler),
        ...(0, $8egWI.projectCellHandler),
        ...(0, $9hMF9.cascadingSelectCellHandler)
    }));
const $50b53fd6303170ad$export$33fa2ddeaefadb7f = (fieldType)=>{
    const Components = $50b53fd6303170ad$var$createFieldCellComponents();
    return Components[fieldType] != null;
};
const $50b53fd6303170ad$export$6a0360e2da5b783e = (_)=>true;
const $50b53fd6303170ad$export$8ae908fe84f8a33b = ({ fieldType: fieldType, ...cellProps })=>{
    const Components = $50b53fd6303170ad$var$createFieldCellComponents();
    if (!$50b53fd6303170ad$export$6a0360e2da5b783e(fieldType)) return null;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const Component = Components[fieldType];
    if (Component == null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, cellProps);
};

});
parcelRegister("9hMF9", function(module, exports) {

$parcel$export(module.exports, "cascadingSelectCellHandler", () => $43d2cd2de4baae92$export$27b118c54b403d55);

var $5uXOq = parcelRequire("5uXOq");

var $5fc53 = parcelRequire("5fc53");

var $dZxXA = parcelRequire("dZxXA");

var $b5lmY = parcelRequire("b5lmY");

var $dNtZc = parcelRequire("dNtZc");

var $iCm5X = parcelRequire("iCm5X");
const $43d2cd2de4baae92$export$4f505fdc26f544f5 = ({ rowData: issue, cellData: field, setEditMode: setEditMode, editMode: editMode, column: { width: preferredWidth }, cellRef: cellRef })=>{
    const [cascadingSelectValue, setCascadingSelectValue] = (0, $5uXOq.useState)(field?.value ?? null);
    // Update the value when it is updated in cache (e.g. via realtime)
    (0, $5uXOq.useEffect)(()=>{
        setCascadingSelectValue(field?.value ?? null);
    }, [
        field?.value
    ]);
    const isEditable = (0, $5uXOq.useMemo)(()=>issue.fieldConfig?.isEditable || false, [
        issue.fieldConfig?.isEditable
    ]);
    const [{ value: value }] = (0, $dZxXA.useCascadingSelectField)({
        fieldAriId: field?.id ?? '',
        issueKey: issue.key,
        fieldKey: field?.fieldId ?? '',
        initialValue: field?.value ?? null
    });
    if (value !== cascadingSelectValue) setCascadingSelectValue(value);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b5lmY.CellWrapper), {
        isEditable: isEditable,
        testId: "business-fields.ui.cascading-select.cell.cell-wrapper"
    }, editMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dNtZc.CascadingSelectEdit), {
        cellRef: cellRef,
        setEditMode: setEditMode,
        fieldAriId: field?.id ?? '',
        onChange: setCascadingSelectValue,
        preferredWidth: preferredWidth,
        readContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iCm5X.CascadingSelectRead), {
            value: cascadingSelectValue
        }),
        currentValue: cascadingSelectValue,
        issueKey: issue.key,
        fieldKey: field?.fieldId || ''
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iCm5X.CascadingSelectRead), {
        value: cascadingSelectValue
    }));
};
const $43d2cd2de4baae92$export$27b118c54b403d55 = {
    [(0, $5fc53.CASCADING_SELECT_CF_TYPE)]: $43d2cd2de4baae92$export$4f505fdc26f544f5
};

});
parcelRegister("dNtZc", function(module, exports) {

$parcel$export(module.exports, "CascadingSelectEdit", () => $d278b52f9752e6e0$export$e624ed4af58fd142);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $jOJ3A = parcelRequire("jOJ3A");
const $d278b52f9752e6e0$export$e624ed4af58fd142 = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $jOJ3A.CascadingSelectEditEntryPoint), {});
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jwm.business.fields.cascadingSelect.edit",
        packageName: "jiraBusinessFields",
        runtimeProps: props,
        fallback: props.readContent
    });
};

});
parcelRegister("jOJ3A", function(module, exports) {

$parcel$export(module.exports, "CascadingSelectEditEntryPoint", () => $5d4b7f45d5089d76$export$93e961c95d3c1b6a);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $5d4b7f45d5089d76$export$93e961c95d3c1b6a = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("5Vozb")), {
        moduleId: "2a2020e5"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("5Vozb", function(module, exports) {

let $450554fe7036f99a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $450554fe7036f99a$var$load("juSSi").then(()=>parcelRequire('lylJ2'));

});



parcelRegister("iCm5X", function(module, exports) {

$parcel$export(module.exports, "CascadingSelectRead", () => $bbdaaf7db4173b66$export$1e55dc71aaaa2cc4);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $jKNTt = parcelRequire("jKNTt");
const $bbdaaf7db4173b66$export$1e55dc71aaaa2cc4 = ({ value: value })=>{
    if (value == null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $bbdaaf7db4173b66$var$containerStyles
    }, (0, $jKNTt.getCascadingSelectStringValue)(value));
};
const $bbdaaf7db4173b66$var$containerStyles = (0, $8CUq3.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '100%',
    display: 'block'
});

});


parcelRegister("3RxLo", function(module, exports) {

$parcel$export(module.exports, "devSummaryCellHandler", () => $59f75287926d77d9$export$31d4252fa9154106);

var $5uXOq = parcelRequire("5uXOq");

var $5fc53 = parcelRequire("5fc53");

var $b5lmY = parcelRequire("b5lmY");

var $bThTZ = parcelRequire("bThTZ");
const $59f75287926d77d9$export$e04e820b15fa1f63 = ({ rowData: rowData, cellData: cellData, editMode: editMode, setEditMode: setEditMode, cellRef: cellRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b5lmY.CellWrapper), {
        isEditable: false
    }, cellData && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bThTZ.DevSummaryRead), {
        ...cellData,
        isHovering: false,
        issueId: rowData.issueId,
        editMode: editMode,
        setEditMode: setEditMode,
        cellRef: cellRef
    }));
const $59f75287926d77d9$export$31d4252fa9154106 = {
    [(0, $5fc53.DEV_SUMMARY_CF_TYPE)]: $59f75287926d77d9$export$e04e820b15fa1f63
};

});
parcelRegister("bThTZ", function(module, exports) {

$parcel$export(module.exports, "DevSummaryRead", () => $31f6a400bfa036d1$export$9147ca8c33d1d192);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $8YTUU = parcelRequire("8YTUU");

var $lxrPB = parcelRequire("lxrPB");

var $kcaDR = parcelRequire("kcaDR");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $jgJNO = parcelRequire("jgJNO");

var $fcSLY = parcelRequire("fcSLY");

var $9OXo1 = parcelRequire("9OXo1");

var $lfl7G = parcelRequire("lfl7G");

var $5ryCV = parcelRequire("5ryCV");
// Maybe we need to pass this to the cell from the list view
const $31f6a400bfa036d1$var$popupOffset = [
    -8,
    0
];
const $31f6a400bfa036d1$var$scopeId = 'software-list.list';
const $31f6a400bfa036d1$export$9147ca8c33d1d192 = ({ issueId: issueId, isMerged: isMerged, isUnderReview: isUnderReview, commitCount: commitCount, editMode: editMode, setEditMode: setEditMode, cellRef: cellRef, ...props })=>{
    const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
    const issueAri = (0, $5uXOq.useMemo)(()=>(0, $kcaDR.createIssueAri)(cloudId, issueId.toString()), [
        cloudId,
        issueId
    ]);
    const devInfoType = isMerged || isUnderReview ? (0, $8YTUU.DevInfoTypes).PULLREQUEST : (0, $8YTUU.DevInfoTypes).COMMIT;
    const { id: experienceId, name: experienceName } = (0, $lfl7G.experienceDetails)[devInfoType];
    const onExperienceSuccess = (0, $3bQtK.useExperienceSuccess)({
        experience: experienceName
    });
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            issueId: issueAri
        }), [
        issueAri
    ]);
    // eslint-disable-next-line @atlassian/react-entrypoint/prefer-entrypoint-file-import
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject, stopMetric: stopMetric } = (0, $4mO32.useEntryPoint)((0, $lfl7G.popupEntryPoints)[devInfoType], entryPointParams, (0, $lfl7G.metricsDev)[devInfoType]);
    const entryPointErrorBoundaryProps = (0, $5uXOq.useMemo)(()=>({
            ...(0, $lfl7G.packageDetails)[devInfoType],
            errorFallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lxrPB.default), {
                    devInfoType: devInfoType,
                    issueAri: issueAri,
                    scopeId: $31f6a400bfa036d1$var$scopeId
                })
        }), [
        devInfoType,
        issueAri
    ]);
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            issueAri: issueAri,
            devInfoType: devInfoType,
            onReady: ()=>{
                stopMetric();
                onExperienceSuccess();
            },
            scopeId: $31f6a400bfa036d1$var$scopeId
        }), [
        issueAri,
        devInfoType,
        stopMetric,
        onExperienceSuccess
    ]);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (editMode) entryPointActions.load();
    }, [
        editMode,
        entryPointActions
    ]);
    const handleMouseEnter = (0, $5uXOq.useCallback)(()=>{
        if (!editMode) entryPointActions.preload();
    }, [
        entryPointActions,
        editMode
    ]);
    const handleMouseLeave = (0, $5uXOq.useCallback)(()=>{
        entryPointActions.cancelPreload();
    }, [
        entryPointActions
    ]);
    const popupTrigger = (0, $5uXOq.useCallback)(({ ref: ref, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, 'aria-controls': ariaControls })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            ref: ref,
            role: "button",
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHaspopup,
            "aria-controls": ariaControls,
            xcss: $31f6a400bfa036d1$var$triggerContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ryCV.DevSummaryLozenge), {
            isMerged: isMerged,
            isUnderReview: isUnderReview,
            commitCount: commitCount,
            ...props
        })), [
        commitCount,
        isMerged,
        isUnderReview,
        props
    ]);
    const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
        if (event.code === 'Tab') return true;
        return false;
    }, []);
    const cellOverrides = (0, $5uXOq.useCallback)(()=>({
            onKeyDown: handleKeyDown
        }), [
        handleKeyDown
    ]);
    (0, $5uXOq.useImperativeHandle)(cellRef, cellOverrides, [
        cellOverrides
    ]);
    if (!isMerged && !isUnderReview && commitCount === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($31f6a400bfa036d1$var$Container, {
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        "data-testId": "business-fields.ui.dev-summary.cell.read.container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        placement: "bottom-start",
        messageId: "business-fields.ui.dev-summary.cell.read.popup",
        messageType: "transactional",
        autoFocus: false,
        shouldUseCaptureOnOutsideClick: true,
        testId: "business-fields.ui.dev-summary.cell.read.popup",
        trigger: popupTrigger,
        isOpen: editMode,
        offset: $31f6a400bfa036d1$var$popupOffset,
        onClose: ()=>setEditMode(false),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kaHBi.ExperienceStart), {
                analyticsSource: experienceName,
                experience: experienceName,
                experienceId: experienceId
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
                entryPointReferenceSubject: entryPointReferenceSubject,
                ...entryPointErrorBoundaryProps,
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fcSLY.DevInfoDetailsPopupSkeleton), {
                    devinfoType: devInfoType
                }),
                runtimeProps: runtimeProps
            }))
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $31f6a400bfa036d1$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4t3i1osq _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $31f6a400bfa036d1$var$triggerContainerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    boxSizing: 'border-box',
    alignItems: 'center'
});

});
parcelRegister("8YTUU", function(module, exports) {

$parcel$export(module.exports, "DevInfoTypes", () => $ba5542dc32884ee4$export$a100703e17b2650a);
$parcel$export(module.exports, "DevInfoTypeMap", () => $ba5542dc32884ee4$export$39c00ace65e13f2d);
$parcel$export(module.exports, "ButtonStatus", () => $ba5542dc32884ee4$export$477d4d2d93581a40);
const $ba5542dc32884ee4$export$a100703e17b2650a = Object.freeze({
    BRANCH: 'branch',
    COMMIT: 'commit',
    PULLREQUEST: 'pullrequest',
    DECLINED: 'declined',
    MERGED: 'merged',
    DEPLOYMENT: 'deployment',
    DESIGN: 'design'
});
const $ba5542dc32884ee4$export$39c00ace65e13f2d = {
    [$ba5542dc32884ee4$export$a100703e17b2650a.BRANCH]: 'branch',
    [$ba5542dc32884ee4$export$a100703e17b2650a.COMMIT]: 'commit',
    [$ba5542dc32884ee4$export$a100703e17b2650a.PULLREQUEST]: 'pull request',
    [$ba5542dc32884ee4$export$a100703e17b2650a.MERGED]: 'pull request',
    [$ba5542dc32884ee4$export$a100703e17b2650a.DECLINED]: 'pull request',
    [$ba5542dc32884ee4$export$a100703e17b2650a.DEPLOYMENT]: 'deployment',
    [$ba5542dc32884ee4$export$a100703e17b2650a.DESIGN]: 'design'
};
const $ba5542dc32884ee4$export$477d4d2d93581a40 = Object.freeze({
    ACTIVE: 'active',
    HOVER: 'hover',
    DEFAULT: 'default'
});

});

parcelRegister("lxrPB", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfd87e1125ba31c4$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $l1N8i = parcelRequire("l1N8i");

var $dD7Zc = parcelRequire("dD7Zc");

var $koVbs = parcelRequire("koVbs");

var $ifS9h = parcelRequire("ifS9h");

var $8YTUU = parcelRequire("8YTUU");

var $dt6Va = parcelRequire("dt6Va");

var $el2W3 = parcelRequire("el2W3");
const $cfd87e1125ba31c4$var$ErrorFallback = ({ devInfoType: devInfoType, issueAri: issueAri, scopeId: scopeId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { showDevDetailDialogForPopup: showDevDetailDialogForPopup } = (0, $dt6Va.useShowDevDetailDialogForPopup)(scopeId);
    const handleLinkClick = ()=>{
        showDevDetailDialogForPopup(devInfoType, issueAri);
    };
    const devInfoTypeName = (0, $8YTUU.DevInfoTypeMap)[devInfoType];
    const errorMessage = devInfoType === (0, $8YTUU.DevInfoTypes).DESIGN ? formatMessage((0, $el2W3.default).designErrorDescription, {
        devInfoType: devInfoTypeName
    }) : formatMessage((0, $el2W3.default).errorDescription, {
        devInfoType: devInfoTypeName
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ifS9h.PopupContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ifS9h.PopupTitle), null, formatMessage((0, $el2W3.default).errorPopupTitle, {
        devInfoType: (0, $8YTUU.DevInfoTypeMap)[devInfoType]
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cfd87e1125ba31c4$var$Header, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
        spacing: "spacious",
        label: "",
        color: "var(--ds-icon-danger, #C9372C)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cfd87e1125ba31c4$var$Title, null, formatMessage((0, $el2W3.default).errorTitle)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cfd87e1125ba31c4$var$Description, null, errorMessage, devInfoType !== (0, $8YTUU.DevInfoTypes).DESIGN && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cfd87e1125ba31c4$var$StyledButton, {
        appearance: "link",
        onClick: handleLinkClick
    }, formatMessage((0, $el2W3.default).developmentErrorDescriptionCta))));
};
var $cfd87e1125ba31c4$export$2e2bcd8739ae039 = $cfd87e1125ba31c4$var$ErrorFallback;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cfd87e1125ba31c4$var$Title = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u01b66",
            __cmplp.className
        ])
    });
});
const $cfd87e1125ba31c4$var$Description = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz131l _18u0u2gc",
            __cmplp.className
        ])
    });
});
const $cfd87e1125ba31c4$var$StyledButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ytiidpf _7yhbidpf _1bdkidpf _24rcidpf _1yxxidpf _12r2i7a9 _if291ule",
            __cmplp.className
        ])
    });
});
const $cfd87e1125ba31c4$var$Header = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _syaz131l _19pku2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ifS9h", function(module, exports) {

$parcel$export(module.exports, "PopupContainer", () => $88fc3594fd7e78a2$export$cca08eed9de89ba9);
$parcel$export(module.exports, "LinkContainer", () => $88fc3594fd7e78a2$export$af2ec3aa21d10ab7);
$parcel$export(module.exports, "PopupHeader", () => $88fc3594fd7e78a2$export$b11ea9d6e8111404);
$parcel$export(module.exports, "StyledDate", () => $88fc3594fd7e78a2$export$30301703d55848e7);
$parcel$export(module.exports, "RepositoryInfo", () => $88fc3594fd7e78a2$export$fde5e3d077213a6f);
$parcel$export(module.exports, "PopupTitle", () => $88fc3594fd7e78a2$export$b834616c6081368f);
$parcel$export(module.exports, "StyledLink", () => $88fc3594fd7e78a2$export$9048d548939551ee);
$parcel$export(module.exports, "PopupOverflowSection", () => $88fc3594fd7e78a2$export$9e3158dc6a3a0f92);
$parcel$export(module.exports, "PopupKeyline", () => $88fc3594fd7e78a2$export$a0765d4427758c62);
$parcel$export(module.exports, "PopupOverflowButton", () => $88fc3594fd7e78a2$export$aeb11758c9d29e5c);
$parcel$export(module.exports, "TimeDisplay", () => $88fc3594fd7e78a2$export$9b3df3d60caed5f9);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $l1N8i = parcelRequire("l1N8i");

var $41j30 = parcelRequire("41j30");
const $88fc3594fd7e78a2$export$cca08eed9de89ba9 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _1bsbnklw _1tkeys9h _vchhusvi",
            __cmplp.className
        ])
    });
});
const $88fc3594fd7e78a2$export$af2ec3aa21d10ab7 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _otyr1b66",
            __cmplp.className
        ])
    });
});
const $88fc3594fd7e78a2$export$b11ea9d6e8111404 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $88fc3594fd7e78a2$export$30301703d55848e7 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz131l _otyridpf _1e0c1txw _o5724jg8",
            __cmplp.className
        ])
    });
});
const $88fc3594fd7e78a2$export$fde5e3d077213a6f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz131l _o5724jg8",
            __cmplp.className
        ])
    });
});
const $88fc3594fd7e78a2$export$80b51772092eddc0 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz131l _1p1dangw _otyr1b66",
            __cmplp.className
        ])
    });
});
const $88fc3594fd7e78a2$export$b834616c6081368f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xxsmall",
        as: "div"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($88fc3594fd7e78a2$export$80b51772092eddc0, props));
const $88fc3594fd7e78a2$export$9048d548939551ee = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $41j30.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81ixg _k48pmoej _syaz14q2 _otyru2gc",
            __cmplp.className
        ])
    });
});
const $88fc3594fd7e78a2$export$9e3158dc6a3a0f92 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkpxbi",
            __cmplp.className
        ])
    });
});
const $88fc3594fd7e78a2$export$a0765d4427758c62 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3it94y _bfhkmuej _otyrutpp",
            __cmplp.className
        ])
    });
});
const $88fc3594fd7e78a2$export$aeb11758c9d29e5c = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ytiidpf _7yhbidpf _1bdkidpf _24rcidpf _1yxxidpf _12r2i7a9",
            __cmplp.className
        ])
    });
});
const $88fc3594fd7e78a2$export$9b3df3d60caed5f9 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u01b66 _80omtlke",
            __cmplp.className
        ])
    });
});

});

parcelRegister("dt6Va", function(module, exports) {

$parcel$export(module.exports, "useShowDevDetailDialogForPopup", () => $71478bde10e2ba46$export$cdc75a6c65207319);

var $4HJKb = parcelRequire("4HJKb");


var $dXq4S = parcelRequire("dXq4S");

var $8YTUU = parcelRequire("8YTUU");
const $71478bde10e2ba46$export$166d6c8e7de25541 = (issueAri)=>(0, $dXq4S.parseAri)(issueAri)?.resourceId;
const $71478bde10e2ba46$var$devInfoTypeToPanelDataType = (devInfoType)=>{
    if (devInfoType === (0, $8YTUU.DevInfoTypes).COMMIT) return 0, $61a2cd6236d50c20$export$2e42513c7764d5f3;
    if (devInfoType === (0, $8YTUU.DevInfoTypes).DEPLOYMENT) return 0, $61a2cd6236d50c20$export$90cac6260ae9ced5;
    return devInfoType;
};
function $71478bde10e2ba46$export$cdc75a6c65207319(scopeId) {
    const { showDevDetailDialog: showDevDetailDialog } = (0, $4HJKb.useDevOpsDetailsDialogLoaderActions)(scopeId || 'software-board.board');
    const showDevDetailDialogForPopup = (devInfoType, issueAri)=>{
        const type = $71478bde10e2ba46$var$devInfoTypeToPanelDataType(devInfoType);
        const issueId = $71478bde10e2ba46$export$166d6c8e7de25541(issueAri);
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'PanelDataTypes'.
        showDevDetailDialog(type, undefined, '', issueId);
    };
    return {
        showDevDetailDialogForPopup: showDevDetailDialogForPopup
    };
}

});
parcelRegister("4HJKb", function(module, exports) {

$parcel$export(module.exports, "loadDialogBridge", () => $ccf4b85a4aaf3a68$export$7e12f7cd0f50fe5a);
$parcel$export(module.exports, "DevOpsDetailsDialogLoaderContainer", () => $ccf4b85a4aaf3a68$export$5e6e4cfb89bdcb55);
$parcel$export(module.exports, "DevOpsDetailsDialogLoaderSubscriber", () => $ccf4b85a4aaf3a68$export$693f51ab225dff94);
$parcel$export(module.exports, "useDevOpsDetailsDialogLoaderActions", () => $ccf4b85a4aaf3a68$export$506ad06ecf691cd3);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $6BZYo = parcelRequire("6BZYo");


var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");
var $bKpgX = parcelRequire("bKpgX");

var $62M1I = parcelRequire("62M1I");
const $ccf4b85a4aaf3a68$export$7e12f7cd0f50fe5a = async ()=>// eslint-disable-next-line jira/wrm/no-load-bridge
    (0, $6BZYo.loadBridge)({
        name: (0, $62M1I.DEV_DETAILS_WRM_RESOURCE),
        wrmKeys: [
            'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-wrm',
            'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf-resources'
        ]
    });
const $ccf4b85a4aaf3a68$export$e324594224ef24da = {
    resetState: (stateOverrides)=>({ setState: setState })=>{
            // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
            setState({
                ...(0, $62M1I.INITIAL_STATE),
                ...stateOverrides
            });
        },
    updateState: (stateUpdates)=>({ getState: getState, setState: setState })=>{
            // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'. | TS2722 - Cannot invoke an object which is possibly 'undefined'.
            setState({
                ...getState(),
                ...stateUpdates
            });
        },
    showDevDetailDialog: (itemType, legacyData, targetIssueKey, targetIssueId)=>({ setState: setState, getState: getState })=>{
            if (itemType === (0, $61a2cd6236d50c20$export$3f1e2b276d607490)) // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
            setState({
                // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
                ...getState(),
                legacyDevPanelDetailsDialogShownCounter: // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
                getState().legacyDevPanelDetailsDialogShownCounter + 1,
                isDevPanelDetailsDialogShown: false,
                dataTypeSelected: itemType,
                legacyData: legacyData,
                issueKey: targetIssueKey,
                issueId: targetIssueId
            });
            else // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
            setState({
                // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
                ...getState(),
                isDevPanelDetailsDialogShown: true,
                dataTypeSelected: itemType,
                issueKey: targetIssueKey,
                issueId: targetIssueId
            });
        },
    closeDetailDialog: ()=>({ setState: setState, getState: getState })=>{
            // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
            setState({
                // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
                ...getState(),
                // @ts-expect-error - TS2322 - Type '""' is not assignable to type 'PanelDataTypes | undefined'.
                dataTypeSelected: '',
                isDevPanelDetailsDialogShown: false,
                issueKey: undefined,
                issueId: undefined
            });
        }
};
const $ccf4b85a4aaf3a68$export$390f32400eaf98c9 = (0, $iXqE5.createStore)({
    name: 'DetailsDialogLoaderRemoteState',
    initialState: (0, $62M1I.INITIAL_STATE),
    actions: $ccf4b85a4aaf3a68$export$e324594224ef24da
});
const $ccf4b85a4aaf3a68$export$5e6e4cfb89bdcb55 = (0, $gg7kZ.createContainer)($ccf4b85a4aaf3a68$export$390f32400eaf98c9);
const $ccf4b85a4aaf3a68$export$693f51ab225dff94 = (0, $51nlc.createSubscriber)($ccf4b85a4aaf3a68$export$390f32400eaf98c9);
const $ccf4b85a4aaf3a68$export$550d4b3c29100112 = (0, $3sQ5x.createHook)($ccf4b85a4aaf3a68$export$390f32400eaf98c9);
function $ccf4b85a4aaf3a68$export$506ad06ecf691cd3(scopeId) {
    return (0, $bKpgX.defaultRegistry).getStore($ccf4b85a4aaf3a68$export$390f32400eaf98c9, scopeId)?.actions;
}

});
const $61a2cd6236d50c20$export$e18d81f044132a0e = 'branch';
const $61a2cd6236d50c20$export$74a388a09f2a004e = 'build';
const $61a2cd6236d50c20$export$2e42513c7764d5f3 = 'repository';
const $61a2cd6236d50c20$export$3f1e2b276d607490 = 'review';
const $61a2cd6236d50c20$export$90cac6260ae9ced5 = 'deployment-environment';
const $61a2cd6236d50c20$export$6f74b53d652f13f3 = 'pullrequest';
const $61a2cd6236d50c20$export$c69477f358d30f7e = 'feature-flags';
const $61a2cd6236d50c20$export$56470bdd9cd798d0 = 'remote-links';
const $61a2cd6236d50c20$export$b4bb784d069c9ab = 'development.details.details-header';

parcelRegister("62M1I", function(module, exports) {

$parcel$export(module.exports, "INITIAL_STATE", () => $bf37254db56efc10$export$36d128238e6b60f5);
$parcel$export(module.exports, "DEV_DETAILS_WRM_RESOURCE", () => $bf37254db56efc10$export$43a8ab4f373ff0ee);
const $bf37254db56efc10$export$36d128238e6b60f5 = {
    issueId: '',
    issueKey: undefined,
    locale: 'en_US',
    // @ts-expect-error - TS2322 - Type '""' is not assignable to type 'PanelDataTypes'.
    dataTypeSelected: '',
    legacyData: undefined,
    isDevPanelDetailsDialogShown: false,
    legacyDevPanelDetailsDialogShownCounter: 0
};
const $bf37254db56efc10$export$b5ed55f3ed234f95 = 'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf-resources';
const $bf37254db56efc10$export$43a8ab4f373ff0ee = 'jira-development-status/releasereport/dev-status-dialog-bridge';
const $bf37254db56efc10$export$432f9ff6c01431e3 = 'jira-development-status/util/WRM';

});



parcelRegister("el2W3", function(module, exports) {

$parcel$export(module.exports, "default", () => $06bd70345536382a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $06bd70345536382a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorPopupTitle: {
        "id": "development-board-common.error-fallback.error-popup-title",
        "defaultMessage": "{devInfoType}"
    },
    errorTitle: {
        "id": "development-board-common.error-fallback.error-title",
        "defaultMessage": "Something went wrong"
    },
    errorDescription: {
        "id": "development-board-common.error-fallback.error-description",
        "defaultMessage": "For some reason we couldn't load this {devInfoType}."
    },
    developmentErrorDescriptionCta: {
        "id": "development-board-common.error-fallback.development-error-description-cta",
        "defaultMessage": "View all development information."
    },
    designErrorDescription: {
        "id": "development-board-common.error-fallback.design-error-description",
        "defaultMessage": "For some reason we couldn't load this design. Refresh your page to try again."
    }
});

});


parcelRegister("kcaDR", function(module, exports) {

$parcel$export(module.exports, "createIssueAri", () => $f1bea1631292edff$export$6b0ec881a3540845);

var $dXq4S = parcelRequire("dXq4S");
const $f1bea1631292edff$export$6b0ec881a3540845 = (cloudId, issueId)=>(0, $dXq4S.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'issue',
        resourceId: issueId
    });

});

parcelRegister("fcSLY", function(module, exports) {

$parcel$export(module.exports, "DevInfoDetailsPopupSkeleton", () => $035c776c62f1033d$export$9044eba4855892a5);
/* DevInfoDetailsPopupSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $3MeBY = parcelRequire("3MeBY");

var $6lSRL = parcelRequire("6lSRL");

var $46wcL = parcelRequire("46wcL");

var $ifLw4 = parcelRequire("ifLw4");

var $khjtp = parcelRequire("khjtp");
// Try to keep SPA JS bundle as small as possible, skeletons should not have dependencies, so here we use hard coding instead of import gridSize
const $035c776c62f1033d$var$customCssStyles = null;
const $035c776c62f1033d$var$skeletonStyles = null;
const $035c776c62f1033d$export$ae7439e01588d047 = {
    BRANCH: 'branch',
    COMMIT: 'commit',
    PULLREQUEST: 'pullrequest',
    DEPLOYMENT: 'deployment',
    DESIGN: 'design'
};
const $035c776c62f1033d$var$skeletonAsset = {
    [$035c776c62f1033d$export$ae7439e01588d047.BRANCH]: (0, (/*@__PURE__*/$parcel$interopDefault($3MeBY))),
    [$035c776c62f1033d$export$ae7439e01588d047.COMMIT]: (0, (/*@__PURE__*/$parcel$interopDefault($6lSRL))),
    [$035c776c62f1033d$export$ae7439e01588d047.PULLREQUEST]: (0, (/*@__PURE__*/$parcel$interopDefault($khjtp))),
    [$035c776c62f1033d$export$ae7439e01588d047.DEPLOYMENT]: (0, (/*@__PURE__*/$parcel$interopDefault($46wcL))),
    [$035c776c62f1033d$export$ae7439e01588d047.DESIGN]: (0, (/*@__PURE__*/$parcel$interopDefault($ifLw4)))
};
const $035c776c62f1033d$export$9044eba4855892a5 = ({ devinfoType: devinfoType })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            devinfoType === $035c776c62f1033d$export$ae7439e01588d047.BRANCH && "_1bsbnklw _4t3i1lit _ca0qze3t _u5f3pxbi _n3tdze3t _19bvpxbi _vchhusvi",
            devinfoType === $035c776c62f1033d$export$ae7439e01588d047.COMMIT && "_1bsbnklw _4t3i1lit _ca0qze3t _u5f3pxbi _n3tdze3t _19bvpxbi _vchhusvi",
            devinfoType === $035c776c62f1033d$export$ae7439e01588d047.PULLREQUEST && "_1bsbnklw _ca0qze3t _u5f3pxbi _n3tdze3t _19bvpxbi _vchhusvi _4t3imgvx",
            devinfoType === $035c776c62f1033d$export$ae7439e01588d047.DEPLOYMENT && "_1bsbnklw _4t3i1lit",
            devinfoType === $035c776c62f1033d$export$ae7439e01588d047.DESIGN && "_1bsbnklw _4t3i1lit _ca0qze3t _u5f3pxbi _n3tdze3t _19bvpxbi _vchhusvi"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: $035c776c62f1033d$var$skeletonAsset[devinfoType],
        className: (0, $bwpsq.default)([
            "_1wgmglyw _rcujmgjw"
        ])
    }));

});
parcelRegister("3MeBY", function(module, exports) {
module.exports = new URL("branch-details-popup.tpl.90980aef.svg", import.meta.url).toString();

});

parcelRegister("6lSRL", function(module, exports) {
module.exports = new URL("commit-details-popup.tpl.ef7b25c8.svg", import.meta.url).toString();

});

parcelRegister("46wcL", function(module, exports) {
module.exports = new URL("deployment-details-popup.tpl.d0e045e6.svg", import.meta.url).toString();

});

parcelRegister("ifLw4", function(module, exports) {
module.exports = new URL("design-details-popup.tpl.da785a24.svg", import.meta.url).toString();

});

parcelRegister("khjtp", function(module, exports) {
module.exports = new URL("pr-details-popup.tpl.2fd71422.svg", import.meta.url).toString();

});


parcelRegister("lfl7G", function(module, exports) {

$parcel$export(module.exports, "metricsDev", () => $b87793044194a9b0$export$9d08247a1076ddb0);
$parcel$export(module.exports, "experienceDetails", () => $b87793044194a9b0$export$ba2604b0fdde2542);
$parcel$export(module.exports, "packageDetails", () => $b87793044194a9b0$export$48b44d9f3c6e15de);
$parcel$export(module.exports, "popupEntryPoints", () => $b87793044194a9b0$export$1452632269dce6);

var $dGrdR = parcelRequire("dGrdR");

var $6KTxo = parcelRequire("6KTxo");

var $8YTUU = parcelRequire("8YTUU");

var $890PS = parcelRequire("890PS");
const $b87793044194a9b0$var$commitDetailsPopupLoad = (0, $dGrdR.metrics).interaction({
    key: 'list.commit-details-popup-load'
});
const $b87793044194a9b0$var$prDetailsPopupLoad = (0, $dGrdR.metrics).interaction({
    key: 'list.pr-details-popup-load'
});
const $b87793044194a9b0$export$9d08247a1076ddb0 = {
    [(0, $8YTUU.DevInfoTypes).COMMIT]: $b87793044194a9b0$var$commitDetailsPopupLoad,
    [(0, $8YTUU.DevInfoTypes).PULLREQUEST]: $b87793044194a9b0$var$prDetailsPopupLoad
};
const $b87793044194a9b0$export$ba2604b0fdde2542 = {
    [(0, $8YTUU.DevInfoTypes).COMMIT]: {
        id: 'commitDetailsPopup',
        name: 'jiraSoftwareListCommitDetailsPopup'
    },
    [(0, $8YTUU.DevInfoTypes).PULLREQUEST]: {
        id: 'prDetailsPopup',
        name: 'jiraSoftwareListPrDetailsPopup'
    }
};
const $b87793044194a9b0$export$48b44d9f3c6e15de = {
    [(0, $8YTUU.DevInfoTypes).COMMIT]: {
        id: 'renderCommitDetailsPopup',
        packageName: 'jiraDevelopmentListCommitDetailsPopup',
        teamName: 'nova'
    },
    [(0, $8YTUU.DevInfoTypes).PULLREQUEST]: {
        id: 'renderPRDetailsPopup',
        packageName: 'jiraDevelopmentListPrDetailsPopup',
        teamName: 'nova'
    }
};
const $b87793044194a9b0$export$1452632269dce6 = {
    [(0, $8YTUU.DevInfoTypes).COMMIT]: (0, $6KTxo.commitDetailsEntryPoint),
    [(0, $8YTUU.DevInfoTypes).PULLREQUEST]: (0, $890PS.pullRequestDetailsEntryPoint)
};

});
parcelRegister("6KTxo", function(module, exports) {

$parcel$export(module.exports, "commitDetailsEntryPoint", () => $9842290edc643ca7$export$543707906869c79b);

var $kmK4e = parcelRequire("kmK4e");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $9842290edc643ca7$export$543707906869c79b = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("bdUYl")), {
        moduleId: "c43c4a0f"
    }),
    getPreloadProps: ({ issueId: issueId })=>({
            queries: {
                commitDetailsForIssue: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $kmK4e.default,
                    variables: {
                        issueId: issueId
                    }
                }
            }
        })
});

});
parcelRegister("kmK4e", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1a92de7c94d3b0d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1084bead4ae00878b2af2c8348929c25>>
 * @relayHash eed264a6d119fbca146eb1de817b2b96
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2ca7f0754b23691dc5194f86cd173cbad109ceb27dcdfea5465741efb60afa5b
const $e1a92de7c94d3b0d$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "2ca7f0754b23691dc5194f86cd173cbad109ceb27dcdfea5465741efb60afa5b",
        "metadata": {},
        "name": "mainJiraBoardFetchCommitDetailsForIssueQuery",
        "operationKind": "query",
        "text": null
    }
};
var $e1a92de7c94d3b0d$export$2e2bcd8739ae039 = $e1a92de7c94d3b0d$var$node;

});

parcelRegister("bdUYl", function(module, exports) {

let $82bd1a2348ffaf0f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $82bd1a2348ffaf0f$var$load("dROov").then(()=>parcelRequire('1ml2E'));

});


parcelRegister("890PS", function(module, exports) {

$parcel$export(module.exports, "pullRequestDetailsEntryPoint", () => $0896cca9b8d893af$export$37ab544e7066c095);

var $5E8Mw = parcelRequire("5E8Mw");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $0896cca9b8d893af$export$37ab544e7066c095 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("aZi5Z")), {
        moduleId: "1b74db53"
    }),
    getPreloadProps: ({ issueId: issueId, isNetworkOnly: isNetworkOnly = false })=>({
            queries: {
                pullRequestDetailsForIssue: {
                    options: {
                        fetchPolicy: isNetworkOnly ? 'network-only' : 'store-and-network'
                    },
                    parameters: $5E8Mw.default,
                    variables: {
                        issueId: issueId
                    }
                }
            }
        })
});

});
parcelRegister("5E8Mw", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a4d40ac042e33e2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e18ba82933463bea77a039cb31341c83>>
 * @relayHash ec62760f3d36372780325706797b1fb2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 91484d5c2ad4c1c580a3b56066bfe36c5fe9798b2804e958c3c96ecd098886b0
const $6a4d40ac042e33e2$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "91484d5c2ad4c1c580a3b56066bfe36c5fe9798b2804e958c3c96ecd098886b0",
        "metadata": {},
        "name": "mainJiraBoardFetchPullRequestDetailsForIssueQuery",
        "operationKind": "query",
        "text": null
    }
};
var $6a4d40ac042e33e2$export$2e2bcd8739ae039 = $6a4d40ac042e33e2$var$node;

});

parcelRegister("aZi5Z", function(module, exports) {

let $7ffda351df524733$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7ffda351df524733$var$load("aefuM").then(()=>parcelRequire('cnLAn'));

});



parcelRegister("5ryCV", function(module, exports) {

$parcel$export(module.exports, "DevSummaryLozenge", () => $2b9afaa1c90ae7b8$export$3bb699b6db60f511);

var $5uXOq = parcelRequire("5uXOq");

var $3u0c5 = parcelRequire("3u0c5");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $k2xO1 = parcelRequire("k2xO1");

var $fRYcY = parcelRequire("fRYcY");
const $2b9afaa1c90ae7b8$export$3bb699b6db60f511 = ({ isUnderReview: isUnderReview, isMerged: isMerged, commitCount: commitCount, pullRequestsCount: pullRequestsCount })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (isMerged || isUnderReview) {
        const tooltipText = formatMessage((0, $fRYcY.default).pullRequest, {
            count: pullRequestsCount
        });
        const lozengeText = isMerged ? formatMessage((0, $fRYcY.default).merged) : formatMessage((0, $fRYcY.default).underReview);
        const lozengeAppearance = isMerged ? 'success' : 'default';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k2xO1.TagListWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: tooltipText,
            position: "top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
            appearance: lozengeAppearance
        }, lozengeText)));
    }
    if (commitCount > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $2b9afaa1c90ae7b8$var$linkStyles
    }, formatMessage((0, $fRYcY.default).commit, {
        count: commitCount
    }));
};
const $2b9afaa1c90ae7b8$var$linkStyles = (0, $8CUq3.xcss)({
    color: 'color.text.accent.blue',
    paddingLeft: 'space.075'
});

});
parcelRegister("fRYcY", function(module, exports) {

$parcel$export(module.exports, "default", () => $4429f82c000b7221$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4429f82c000b7221$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    underReview: {
        "id": "business-fields.dev-summary.cell.read.lozenge.under-review",
        "defaultMessage": "Under review"
    },
    merged: {
        "id": "business-fields.dev-summary.cell.read.lozenge.merged",
        "defaultMessage": "Merged"
    },
    commit: {
        "id": "business-fields.dev-summary.cell.read.lozenge.commit",
        "defaultMessage": "{count, plural, one {# commit} other {# commits}}"
    },
    pullRequest: {
        "id": "business-fields.dev-summary.cell.read.lozenge.pull-request",
        "defaultMessage": "{count, plural, one {# pull request} other {# pull requests}}"
    }
});

});




parcelRegister("7Qe9Z", function(module, exports) {

$parcel$export(module.exports, "goalsCellHandler", () => $91d6f645e6d5af35$export$524e25319ef30df1);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $hv5Vo = parcelRequire("hv5Vo");

var $l213r = parcelRequire("l213r");

var $5fc53 = parcelRequire("5fc53");

var $2NMNM = parcelRequire("2NMNM");

var $b5lmY = parcelRequire("b5lmY");

var $cZbJv = parcelRequire("cZbJv");

var $jno68 = parcelRequire("jno68");
const $91d6f645e6d5af35$var$defaultValue = {
    goals: [],
    totalCount: 0
};
const $91d6f645e6d5af35$export$aea87ff07be8100d = ({ rowData: issue, cellData: field, editMode: editMode, setEditMode: setEditMode, fieldId: fieldId, fieldName: fieldName, cellRef: cellRef })=>{
    const [goalsValue, setGoalsValue] = (0, $5uXOq.useState)(field?.value ?? $91d6f645e6d5af35$var$defaultValue);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const isEditable = field?.isEditable ?? true;
    const isFieldAssociated = (0, $jno68.useIsFieldAssociatedWithIssueType)({
        fieldId: fieldId,
        issueTypeId: issue.issuetype?.id
    });
    const [{ value: value }, { saveValue: saveValue }] = (0, $l213r.useGoalsField)({
        issueId: issue.issueId,
        issueKey: issue.key,
        fieldKey: fieldId,
        initialValue: field?.value ?? $91d6f645e6d5af35$var$defaultValue
    });
    (0, $5uXOq.useEffect)(()=>{
        setGoalsValue(field?.value ?? $91d6f645e6d5af35$var$defaultValue);
    }, [
        field?.value
    ]);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(value, goalsValue)) setGoalsValue(value);
    const onClose = (0, $5uXOq.useCallback)(()=>{
        setEditMode(false);
    }, [
        setEditMode
    ]);
    const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
        if (event.code === 'Tab') return true;
        return false;
    }, []);
    const cellOverrides = (0, $5uXOq.useCallback)(()=>({
            onKeyDown: handleKeyDown
        }), [
        handleKeyDown
    ]);
    (0, $5uXOq.useImperativeHandle)(cellRef, cellOverrides, [
        cellOverrides
    ]);
    const onGoalPicked = (0, $5uXOq.useCallback)((goal)=>{
        const newValue = {
            goals: [
                ...goalsValue.goals,
                goal
            ],
            totalCount: goalsValue.totalCount + 1
        };
        setGoalsValue(newValue);
        saveValue(newValue, null, createAnalyticsEvent({}));
    }, [
        createAnalyticsEvent,
        goalsValue.goals,
        goalsValue.totalCount,
        saveValue
    ]);
    const onGoalUnlinked = (0, $5uXOq.useCallback)((_, remainingGoals)=>{
        const newValue = {
            goals: remainingGoals,
            totalCount: goalsValue.totalCount > 0 ? goalsValue.totalCount - 1 : 0
        };
        setGoalsValue(newValue);
        saveValue(newValue, null, createAnalyticsEvent({}));
    }, [
        createAnalyticsEvent,
        goalsValue.totalCount,
        saveValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b5lmY.CellWrapper), {
        isEditable: isEditable
    }, isFieldAssociated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hv5Vo.default), {
        issueAri: issue.id,
        editMode: editMode,
        goals: goalsValue.goals,
        goalCount: goalsValue.totalCount,
        onClose: onClose,
        isEditable: isEditable,
        onGoalPicked: onGoalPicked,
        onGoalUnlinked: onGoalUnlinked
    }), !isFieldAssociated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cZbJv.AssociateFieldPopup), {
        isOpen: editMode,
        issueType: issue.issuetype?.name,
        issueTypeId: issue.issuetype?.id,
        fieldId: fieldId,
        fieldName: fieldName,
        onClose: onClose
    }));
};
const $91d6f645e6d5af35$export$524e25319ef30df1 = {
    [(0, $5fc53.GOALS_CF_TYPE)]: $91d6f645e6d5af35$export$aea87ff07be8100d
};

});
parcelRegister("hv5Vo", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d219a9dbdcde069$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $kMSay = parcelRequire("kMSay");

var $cm8b5 = parcelRequire("cm8b5");

var $47gW9 = parcelRequire("47gW9");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $pa9q9 = parcelRequire("pa9q9");

var $ctrpc = parcelRequire("ctrpc");

var $5fc53 = parcelRequire("5fc53");

var $jgJNO = parcelRequire("jgJNO");

var $2NMNM = parcelRequire("2NMNM");

var $koeKL = parcelRequire("koeKL");

var $gwIPs = parcelRequire("gwIPs");

var $4R6GH = parcelRequire("4R6GH");

var $dXq4S = parcelRequire("dXq4S");

var $e9BT8 = parcelRequire("e9BT8");

var $hvXUb = parcelRequire("hvXUb");

var $g75FT = parcelRequire("g75FT");

var $gZCQJ = parcelRequire("gZCQJ");

var $c0Z9B = parcelRequire("c0Z9B");

var $1JUx3 = parcelRequire("1JUx3");
const $4d219a9dbdcde069$var$POPUP_OFFSET = [
    -8,
    8
];
const $4d219a9dbdcde069$var$GoalsPicker = ({ issueAri: issueAri, goals: goals, goalCount: goalCount, isEditable: isEditable, editMode: editMode, onClose: onClose, onGoalPicked: onGoalPicked, onGoalUnlinked: onGoalUnlinked, showPlaceholder: showPlaceholder, entityType: entityType })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const pressTracing = (0, $kMSay.default)('platform-goal-picker');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const ariaLabel = (0, $gZCQJ.useGoalsCellAriaLabel)({
        goalCount: goalCount,
        goals: goals,
        showPlaceholder: showPlaceholder
    });
    const startExperience = (0, $cm8b5.useExperienceStart)((0, $e9BT8.VIEW_GOAL_PICKER_EXPERIENCE));
    const { showFlag: showFlag, hasFlag: hasFlag } = (0, $pa9q9.useFlagsService)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $c0Z9B.goalPickerPopoverEntryPoint), {
        cloudId: cloudId,
        issueAri: issueAri
    });
    const buttonTrigger = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (editMode) // load the entry point when the popup is opened
        entryPointActions.load();
    }, [
        editMode,
        entryPointActions
    ]);
    // Analytics
    (0, $5uXOq.useEffect)(()=>{
        if (editMode) {
            startExperience();
            pressTracing();
            // fire analytics start
            (0, $ctrpc.getUpdateAnalyticsFlowHelper)().fireAnalyticsStart((0, $5fc53.GOALS_CF_TYPE), {
                analytics: createAnalyticsEvent({}),
                attributes: {
                    fieldType: 'goals'
                }
            });
        }
    }, [
        editMode,
        startExperience,
        pressTracing,
        createAnalyticsEvent
    ]);
    const issueId = issueAri && (0, $dXq4S.isAri)(issueAri) && (0, $4R6GH.fg)('one_event_improvements_1') ? (0, $dXq4S.getAriConfig)(issueAri).resourceId : undefined;
    const handleGoalPicked = (0, $5uXOq.useCallback)((goal)=>{
        // fire analytics end
        (0, $ctrpc.getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd((0, $5fc53.GOALS_CF_TYPE), {
            analytics: createAnalyticsEvent({}),
            attributes: {
                fieldType: 'goals',
                goalId: goal.id,
                action: 'goal linked',
                // it'll take some time for goalCount to get updated, so we increment it here
                numLinkedGoals: goalCount + 1,
                ...issueId && (0, $4R6GH.fg)('one_event_improvements_1') && {
                    issueId: issueId
                }
            }
        });
        onGoalPicked(goal);
    }, [
        createAnalyticsEvent,
        goalCount,
        issueId,
        onGoalPicked
    ]);
    const handleGoalUnlinked = (0, $5uXOq.useCallback)((goalUnlinkedId, remainingGoals)=>{
        // fire analytics end
        (0, $ctrpc.getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd((0, $5fc53.GOALS_CF_TYPE), {
            analytics: createAnalyticsEvent({}),
            attributes: {
                fieldType: 'goals',
                goalId: goalUnlinkedId,
                action: 'goal unlinked',
                numLinkedGoals: remainingGoals.length,
                ...issueId && (0, $4R6GH.fg)('one_event_improvements_1') && {
                    issueId: issueId
                }
            }
        });
        onGoalUnlinked(goalUnlinkedId, remainingGoals);
    }, [
        createAnalyticsEvent,
        issueId,
        onGoalUnlinked
    ]);
    const popupTrigger = (0, $5uXOq.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            role: "button",
            "aria-label": ariaLabel,
            xcss: $4d219a9dbdcde069$var$triggerStyles,
            ...triggerProps,
            ref: (element)=>{
                buttonTrigger(element);
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                triggerProps.ref(element);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g75FT.GoalsCellContent), {
            showPlaceholder: showPlaceholder,
            goals: goals,
            goalCount: goalCount,
            isEditable: isEditable
        })), [
        ariaLabel,
        buttonTrigger,
        goalCount,
        goals,
        isEditable,
        showPlaceholder
    ]);
    const errorFallback = (0, $5uXOq.useCallback)(({ error: error })=>{
        if (!hasFlag?.((0, $1JUx3.ERROR_FLAG_ID))) showFlag((0, $1JUx3.POPUP_ENTRYPOINT_ERROR_FLAG));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cm8b5.ExperienceFailed), {
            experience: (0, $e9BT8.VIEW_GOAL_PICKER_EXPERIENCE),
            error: error
        });
    }, [
        hasFlag,
        showFlag
    ]);
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            issueAri: issueAri,
            goalCount: goalCount,
            onGoalPicked: handleGoalPicked,
            onGoalUnlinked: handleGoalUnlinked,
            onClose: onClose,
            entityType: entityType
        }), [
        goalCount,
        handleGoalPicked,
        handleGoalUnlinked,
        issueAri,
        onClose,
        entityType
    ]);
    const content = (0, $5uXOq.useCallback)(({ update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "jwm.goals.picker.edit.popup",
            packageName: "jiraBusinessGoalPicker",
            teamName: "jira-yurree",
            runtimeProps: {
                ...runtimeProps,
                onContentsResized: update
            },
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hvXUb.LoadingContent), null),
            errorFallback: errorFallback
        }), [
        entryPointReferenceSubject,
        errorFallback,
        runtimeProps
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: $4d219a9dbdcde069$var$goalPickerStyles,
        alignItems: "center",
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        messageType: "transactional",
        messageId: "business-goal-picker.ui.jira-popup",
        autoFocus: false,
        isOpen: editMode,
        content: content,
        trigger: popupTrigger,
        offset: $4d219a9dbdcde069$var$POPUP_OFFSET,
        placement: "bottom-start",
        onClose: onClose,
        shouldUseCaptureOnOutsideClick: true,
        zIndex: (0, $gwIPs.layers).modal,
        // Cannot render the goal picker to parent because it contains a
        // form which doesn't work when rendered inside another form eg. InnerInlineEdit
        shouldRenderToParent: false
    }));
};
var $4d219a9dbdcde069$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($4d219a9dbdcde069$var$GoalsPicker);
const $4d219a9dbdcde069$var$triggerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    height: '100%',
    width: '100%',
    flexGrow: 1,
    flexDirection: 'column',
    alignItems: 'center'
});
const $4d219a9dbdcde069$var$goalPickerStyles = (0, $8CUq3.xcss)({
    minHeight: '100%',
    width: '100%'
});

});
parcelRegister("e9BT8", function(module, exports) {

$parcel$export(module.exports, "VIEW_GOAL_PICKER_EXPERIENCE", () => $7ba6d9612cf1f5cf$export$e665d677258d0141);
const $7ba6d9612cf1f5cf$export$e665d677258d0141 = {
    experience: 'viewGoalPicker',
    packageName: 'jiraBusinessGoalPicker',
    teamName: 'jira-yurree'
};

});

parcelRegister("hvXUb", function(module, exports) {

$parcel$export(module.exports, "LoadingContent", () => $46b92da982e69756$export$4ab3512e4872e6ff);

var $5uXOq = parcelRequire("5uXOq");

var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $eZJjh = parcelRequire("eZJjh");
const $46b92da982e69756$export$4ab3512e4872e6ff = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        justifyContent: "center",
        alignItems: "center",
        xcss: $46b92da982e69756$var$loadingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "large"
    }));
const $46b92da982e69756$var$loadingStyles = (0, $8CUq3.xcss)({
    height: '100%',
    width: '342px',
    padding: 'space.500'
});

});

parcelRegister("g75FT", function(module, exports) {

$parcel$export(module.exports, "GoalsCellContent", () => $e1e87c226c626164$export$72e457a3c2c5d2a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $4iV1e = parcelRequire("4iV1e");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $en3kR = parcelRequire("en3kR");

var $iv6X1 = parcelRequire("iv6X1");

var $koVbs = parcelRequire("koVbs");

var $jjqnH = parcelRequire("jjqnH");

var $9ChYQ = parcelRequire("9ChYQ");

var $6nBz0 = parcelRequire("6nBz0");
const $e1e87c226c626164$export$72e457a3c2c5d2a = ({ goals: goals, goalCount: goalCount, isEditable: isEditable, showPlaceholder: showPlaceholder = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { isExperimentEnabled: isExperimentEnabled } = (0, $iv6X1.useBespokeEmptyFieldTextExperiment)();
    if (goalCount > 0 && goals !== null && goals.length > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e1e87c226c626164$var$Wrapper, {
        "data-testid": "business-goal-picker.ui.goals-cell-content.wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: $e1e87c226c626164$var$iconStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $en3kR.GoalIcon), {
        size: "16",
        appearance: (0, $en3kR.normalizeGoalAppearance)(goals[0].status || 'PENDING'),
        goalIconKey: "GOAL"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jjqnH.GoalName), {
        name: goals[0].name
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9ChYQ.GoalsCount), {
        goalCount: goalCount
    }));
    let noGoalsContent;
    if (showPlaceholder) // if placeholder is displayed we wouldn't show 'add goal'
    noGoalsContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $e1e87c226c626164$var$noGoalsStyles
    }, formatMessage(isExperimentEnabled ? (0, $6nBz0.default).addGoal : (0, $6nBz0.default).noGoals));
    else if (isEditable) noGoalsContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $e1e87c226c626164$var$addGoalStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4iV1e))), {
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #44546F)"
    }), formatMessage((0, $6nBz0.default).addGoal));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e1e87c226c626164$var$Wrapper, {
        "data-testid": "business-goal-picker.ui.goals-cell-content.wrapper"
    }, noGoalsContent);
};
const $e1e87c226c626164$var$GOAL_PICKER_ADD_GOAL_DISPLAY = '--jira-goal-picker-cell-add-goal-display';
const $e1e87c226c626164$var$addGoalStyles = (0, $8CUq3.xcss)({
    display: `var(${$e1e87c226c626164$var$GOAL_PICKER_ADD_GOAL_DISPLAY}, none)`,
    gap: 'space.100',
    alignItems: 'center',
    color: 'color.text.subtlest'
});
const $e1e87c226c626164$var$noGoalsStyles = (0, $8CUq3.xcss)({
    gap: 'space.100',
    alignItems: 'center',
    color: 'color.text.subtlest'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e1e87c226c626164$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1e0c1txw _80omtlke _1bsb1osq _4t3i1osq _u5f3u2gc _vchhusvi _16jlkb7n _4cvr1h6o _tj4x1txw _2ooc1txw",
            __cmplp.className
        ])
    });
});
const $e1e87c226c626164$var$iconStyles = (0, $8CUq3.xcss)({
    width: 'space.200'
});

});
parcelRegister("en3kR", function(module, exports) {

$parcel$export(module.exports, "GoalIcon", () => $a6db28d963218554$export$134cbcd70c6693b8);
$parcel$export(module.exports, "normalizeGoalAppearance", () => $a6db28d963218554$export$f1b3ca93191ce5cc);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $cwmS5 = parcelRequire("cwmS5");

var $4iV1e = parcelRequire("4iV1e");

var $4DRId = parcelRequire("4DRId");

var $3pgsH = parcelRequire("3pgsH");

var $h7ddS = parcelRequire("h7ddS");

var $dOSG9 = parcelRequire("dOSG9");
const $a6db28d963218554$var$appearanceToColorMap = {
    DEFAULT: 'gray',
    MENU: 'gray',
    OFF_TRACK: 'red',
    AT_RISK: 'yellow',
    ON_TRACK: 'green'
};
const $a6db28d963218554$var$appearanceToNewColorMap = {
    MENU: "var(--ds-icon, #44546F)",
    DEFAULT: "var(--ds-icon-accent-gray, #758195)",
    OFF_TRACK: "var(--ds-icon-danger, #C9372C)",
    AT_RISK: "var(--ds-icon-warning, #E56910)",
    ON_TRACK: "var(--ds-icon-success, #22A06B)"
};
const $a6db28d963218554$var$keyToIconMap = {
    GOAL: (0, (/*@__PURE__*/$parcel$interopDefault($4iV1e))),
    OBJECTIVE: (0, (/*@__PURE__*/$parcel$interopDefault($3pgsH))),
    KEY_RESULT: (0, (/*@__PURE__*/$parcel$interopDefault($4DRId)))
};
const $a6db28d963218554$var$getLabel = (intl, label, localizedLabel)=>{
    if (label) return label;
    if (localizedLabel && (0, $dOSG9.isMessageId)(localizedLabel?.messageId)) return intl.formatMessage((0, $dOSG9.messages)[localizedLabel.messageId]);
    return '';
};
const $a6db28d963218554$export$134cbcd70c6693b8 = ({ appearance: appearance, size: size, localizedLabel: localizedLabel, goalIconKey: goalIconKey = 'GOAL', isVisualRefresh: isVisualRefresh = false, visualRefreshSpacing: visualRefreshSpacing = 'none', label: label, shouldScale: shouldScale = false })=>{
    const intl = (0, $koVbs.default)();
    const iconLabel = $a6db28d963218554$var$getLabel(intl, label, localizedLabel);
    const Icon = $a6db28d963218554$var$keyToIconMap[goalIconKey] ?? $a6db28d963218554$var$keyToIconMap.GOAL;
    if (isVisualRefresh) {
        const ResizableIcon = Icon;
        return /*#__PURE__*/ (0, $2OMIu.jsx)(ResizableIcon, {
            shouldScale: shouldScale,
            color: $a6db28d963218554$var$appearanceToNewColorMap[appearance],
            label: iconLabel,
            spacing: visualRefreshSpacing
        });
    }
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        size: size,
        icon: Icon,
        label: iconLabel,
        appearance: $a6db28d963218554$var$appearanceToColorMap[appearance]
    });
};
const $a6db28d963218554$export$f1b3ca93191ce5cc = (statusValue)=>{
    const appearanceUppercase = statusValue.toLocaleUpperCase();
    return (0, $h7ddS.isGoalAppearance)(appearanceUppercase) ? appearanceUppercase : 'DEFAULT';
};

});
parcelRegister("cwmS5", function(module, exports) {

$parcel$export(module.exports, "default", () => $a921419639fe8f6f$export$2e2bcd8739ae039);
/* icon-tile.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");
const $a921419639fe8f6f$var$sizeMap = {
    '16': "_1bsb7vkz _4t3i7vkz",
    '24': "_1bsb1tcg _4t3i1tcg",
    '32': "_1bsbzwfg _4t3izwfg",
    '40': "_1bsb1ylp _4t3i1ylp",
    '48': "_1bsbckbl _4t3ickbl"
};
const $a921419639fe8f6f$var$appearanceMap = {
    grayBold: "_bfhk1t1b _syaz5w2r",
    limeBold: "_bfhktde4 _syaz5w2r",
    greenBold: "_bfhk1e5c _syaz5w2r",
    blueBold: "_bfhkc8cv _syaz5w2r",
    redBold: "_bfhkuibq _syaz5w2r",
    purpleBold: "_bfhkygwo _syaz5w2r",
    magentaBold: "_bfhkc3uk _syaz5w2r",
    tealBold: "_bfhk2c8p _syaz5w2r",
    orangeBold: "_bfhkjgng _syaz5w2r",
    yellowBold: "_bfhk1vop _syaz5w2r",
    gray: "_bfhk1v33 _syaz16ni",
    lime: "_bfhkz2ec _syaz8645",
    orange: "_bfhkf2vu _syaz7r97",
    magenta: "_bfhkv9ra _syazv8hk",
    green: "_bfhk1wnw _syaz17hp",
    blue: "_bfhk4v9p _syaz1ov1",
    red: "_bfhk1rtt _syaznbxb",
    purple: "_bfhk1jkz _syaz5yjc",
    teal: "_bfhk1a17 _syaz8uof",
    yellow: "_bfhk3fv2 _syaz1oqg"
};
const $a921419639fe8f6f$var$shapeMap = {
    square: "_2rkoiti9",
    circle: "_2rko14q2"
};
const $a921419639fe8f6f$var$iconTileStyles = null;
function $a921419639fe8f6f$export$2e2bcd8739ae039(props) {
    const { icon: Icon, label: label, appearance: appearance, size: size = '24', shape: shape = 'square', LEGACY_fallbackComponent: LEGACY_fallbackComponent, testId: testId } = props;
    const ExpandedIcon = Icon;
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (LEGACY_fallbackComponent && !(0, $VSDnB.fg)('platform-visual-refresh-icons')) return LEGACY_fallbackComponent;
    else return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_1e0c116y _vchhusvi _4cvr1h6o _1bah1h6o _1wybidpf",
            $a921419639fe8f6f$var$appearanceMap[appearance],
            $a921419639fe8f6f$var$sizeMap[size],
            $a921419639fe8f6f$var$shapeMap[shape]
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)(ExpandedIcon, {
            color: "currentColor",
            label: label,
            spacing: "spacious",
            shouldScale: true
        })
    });
}

});

parcelRegister("4DRId", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9ba563912d9cb57c78d7ea4485b79c7f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3614780827b64603$var$_react = $3614780827b64603$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3614780827b64603$var$_baseNew = $3614780827b64603$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3614780827b64603$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "KeyResult".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing key results.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3614780827b64603$var$KeyResultIcon = (props)=>/*#__PURE__*/ $3614780827b64603$var$_react.default.createElement($3614780827b64603$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.435.001a.75.75 0 0 1 .547.194l3.023 2.75-1.01 1.11-2.437-2.217A10.2 10.2 0 0 0 7.527 7.25h3.163l1.28-1.28a.75.75 0 0 1 .53-.22h2.75a.75.75 0 0 1 .671 1.085L15.339 8l.582 1.165a.75.75 0 0 1-.67 1.085H12.5a.75.75 0 0 1-.531-.22l-1.28-1.28H7.528c.149 2.02.895 3.88 2.051 5.41l2.414-2.213 1.014 1.106-3 2.75a.75.75 0 0 1-1.07-.059A11.75 11.75 0 0 1 6.023 8.75H2.756l1.361 1.184-.984 1.132-2.875-2.5a.75.75 0 0 1 0-1.132l2.875-2.5.984 1.132L2.755 7.25h3.269A11.7 11.7 0 0 1 8.914.255a.75.75 0 0 1 .52-.254m2.626 8 .75.749h1.226l-.208-.414a.75.75 0 0 1 0-.671l.208-.415H12.81z" clip-rule="evenodd"/>`
    }, props));
$3614780827b64603$var$KeyResultIcon.displayName = 'KeyResultIcon';
var $3614780827b64603$var$_default = module.exports.default = $3614780827b64603$var$KeyResultIcon;

});

parcelRegister("3pgsH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6209776ef69c56f26af2970fd840a919>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $27b079e3ef5ffb2f$var$_react = $27b079e3ef5ffb2f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $27b079e3ef5ffb2f$var$_baseNew = $27b079e3ef5ffb2f$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $27b079e3ef5ffb2f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Objective".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for objectives.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $27b079e3ef5ffb2f$var$ObjectiveIcon = (props)=>/*#__PURE__*/ $27b079e3ef5ffb2f$var$_react.default.createElement($27b079e3ef5ffb2f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13.422.02a.75.75 0 0 1 .54.493l.38 1.144 1.145.381a.75.75 0 0 1 .293 1.242l-2 2a.75.75 0 0 1-.53.22h-1.69L8.03 9.03 6.97 7.97l3.53-3.53V2.75a.75.75 0 0 1 .22-.53l2-2a.75.75 0 0 1 .702-.2M12 4h.94l.922-.922-.35-.116a.75.75 0 0 1-.473-.475l-.117-.349-.922.923zM8 1.5A6.5 6.5 0 1 0 14.5 8H16a8 8 0 1 1-8-8zM8 5a3 3 0 1 0 3 3h1.5A4.5 4.5 0 1 1 8 3.5z" clip-rule="evenodd"/>`
    }, props));
$27b079e3ef5ffb2f$var$ObjectiveIcon.displayName = 'ObjectiveIcon';
var $27b079e3ef5ffb2f$var$_default = module.exports.default = $27b079e3ef5ffb2f$var$ObjectiveIcon;

});

parcelRegister("h7ddS", function(module, exports) {

$parcel$export(module.exports, "isGoalAppearance", () => $926e58146ec2300b$export$86d2476abee3806b);
$parcel$export(module.exports, "isGoalIconKey", () => $926e58146ec2300b$export$51f87e2f4bd9e4bf);
const $926e58146ec2300b$export$d6870ac5e959c0f5 = [
    'DEFAULT',
    'ON_TRACK',
    'AT_RISK',
    'OFF_TRACK',
    'MENU'
];
const $926e58146ec2300b$export$86d2476abee3806b = (value)=>$926e58146ec2300b$export$d6870ac5e959c0f5.includes(value);
const $926e58146ec2300b$export$d7b4c6a971e28318 = [
    'ON_TRACK',
    'AT_RISK',
    'OFF_TRACK',
    'PENDING',
    'DONE',
    'CANCELLED',
    'PAUSED',
    'ARCHIVED'
];
const $926e58146ec2300b$export$a65140e49f013a96 = [
    'GOAL',
    'OBJECTIVE',
    'KEY_RESULT'
];
const $926e58146ec2300b$export$51f87e2f4bd9e4bf = (value)=>$926e58146ec2300b$export$a65140e49f013a96.includes(value);

});

parcelRegister("dOSG9", function(module, exports) {

$parcel$export(module.exports, "isMessageId", () => $a371d973bdb7f9d5$export$d28699f9b486207b);
$parcel$export(module.exports, "messages", () => $a371d973bdb7f9d5$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $a371d973bdb7f9d5$var$MESSAGE_IDS = [
    'townsquare.api.goal-state.on-track',
    'townsquare.api.goal-state.off-track',
    'townsquare.api.goal-state.at-risk',
    'townsquare.api.goal-state.pending',
    'townsquare.api.goal-state.completed',
    'townsquare.api.goal-state.cancelled',
    'townsquare.api.goal-state.paused'
];
const $a371d973bdb7f9d5$export$d28699f9b486207b = (value)=>$a371d973bdb7f9d5$var$MESSAGE_IDS.includes(value);
const $a371d973bdb7f9d5$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    'townsquare.api.goal-state.on-track': {
        id: 'Goals.icon.label.on-track',
        defaultMessage: 'On track',
        description: 'The label for the "on track" goal status'
    },
    'townsquare.api.goal-state.off-track': {
        id: 'Goals.icon.label.off-track',
        defaultMessage: 'Off track',
        description: 'The label for the "off track" goal status'
    },
    'townsquare.api.goal-state.at-risk': {
        id: 'Goals.icon.label.at-risk',
        defaultMessage: 'At risk',
        description: 'The label for the "at risk" goal status'
    },
    'townsquare.api.goal-state.pending': {
        id: 'Goals.icon.label.pending',
        defaultMessage: 'Pending',
        description: 'The label for the "pending" goal status'
    },
    'townsquare.api.goal-state.completed': {
        id: 'Goals.icon.label.completed',
        defaultMessage: 'Completed',
        description: 'The label for the "completed" goal status'
    },
    'townsquare.api.goal-state.cancelled': {
        id: 'Goals.icon.label.cancelled',
        defaultMessage: 'Cancelled',
        description: 'The label for the "cancelled" goal status'
    },
    'townsquare.api.goal-state.paused': {
        id: 'Goals.icon.label.paused',
        defaultMessage: 'Paused',
        description: 'The label for the "paused" goal status'
    }
});

});


parcelRegister("iv6X1", function(module, exports) {

$parcel$export(module.exports, "useBespokeEmptyFieldTextExperiment", () => $79e1a209ff1442cd$export$5a7b1bb3c8ba459f);

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $2gCtH = parcelRequire("2gCtH");

var $93Yeu = parcelRequire("93Yeu");

var $2vSU6 = parcelRequire("2vSU6");
const $79e1a209ff1442cd$var$useIsExperimentEligible = ()=>{
    const issueKey = (0, $2gCtH.useIssueKey)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const projectType = (0, $93Yeu.useProjectType)(projectKey);
    /* Some URL patterns where Issue view is rendered either in a modal or full page or in a sidebar
	The common pattern is presence of issue key in the URL pathname or search params
	1. /browse/TEST-1
	2. /issues/TEST-1
	3. /jira/software/c/projects/TEST/issues/TEST-1
	4. /jira/software/c/projects/TEST/boards/1?selectedIssue=TEST-1
	5. /jira/software/c/projects/TEST/boards/1/backlog?selectedIssue=TEST-1
	6. /jira/software/c/projects/TEST/list?selectedIssue=TEST-1
	*/ const ISSUE_KEY_REGEX = /[A-Z][A-Z0-9]+-\d+/;
    let isFieldRenderedInIssueView = false;
    try {
        isFieldRenderedInIssueView = // eslint-disable-next-line no-restricted-globals
        ISSUE_KEY_REGEX.test(location.search) || ISSUE_KEY_REGEX.test(location.pathname);
    } catch (error) {
        // If regex test fails for some reason, default to false
        isFieldRenderedInIssueView = false;
    }
    return projectType === (0, $2vSU6.SOFTWARE_PROJECT) && isFieldRenderedInIssueView && (0, $4R6GH.fg)('bespoke_empty_field_text_gate');
};
const $79e1a209ff1442cd$export$5a7b1bb3c8ba459f = ()=>{
    const isExperimentEligible = $79e1a209ff1442cd$var$useIsExperimentEligible();
    const isVisibleAlways = isExperimentEligible && (0, $6s1PB.expValEquals)('bespoke_empty_field_text_experiment', 'showBespokeFieldText', 'always', 'never');
    const isVisibleOnHover = isExperimentEligible && (0, $6s1PB.expValEquals)('bespoke_empty_field_text_experiment', 'showBespokeFieldText', 'hover', 'never');
    return {
        isExperimentEnabled: isVisibleAlways || isVisibleOnHover,
        isVisibleAlways: isVisibleAlways,
        isVisibleOnHover: isVisibleOnHover
    };
};

});

parcelRegister("jjqnH", function(module, exports) {

$parcel$export(module.exports, "GoalName", () => $ea6d388f7d79d28d$export$4427fb3cde8dd0cf);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $ea6d388f7d79d28d$export$4427fb3cde8dd0cf = ({ name: name })=>name && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $ea6d388f7d79d28d$var$goalTextStyles,
        as: "span"
    }, name);
const $ea6d388f7d79d28d$var$goalTextStyles = (0, $8CUq3.xcss)({
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});

});

parcelRegister("9ChYQ", function(module, exports) {

$parcel$export(module.exports, "GoalsCount", () => $01e107082108f486$export$cb088e21a8acb84d);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $01e107082108f486$export$cb088e21a8acb84d = ({ goalCount: goalCount })=>{
    const numberOfGoals = (0, $5uXOq.useMemo)(()=>goalCount > 1 ? `+${goalCount - 1}` : '', [
        goalCount
    ]);
    return numberOfGoals && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "span",
        xcss: $01e107082108f486$var$countStyles
    }, numberOfGoals);
};
const $01e107082108f486$var$countStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.disabled',
    fontWeight: "var(--ds-font-weight-regular, 400)",
    borderRadius: 'border.radius',
    paddingInline: 'space.050',
    pointerEvents: 'none'
});

});

parcelRegister("6nBz0", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa925733c785654d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $aa925733c785654d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    addGoal: {
        "id": "business-goal-picker.goals-cell-content.add-goal",
        "defaultMessage": "Add goal"
    },
    noGoals: {
        "id": "business-goal-picker.goals-cell-content.no-goals",
        "defaultMessage": "None"
    },
    linkedGoals: {
        "id": "business-goal-picker.goals-cell-content.goals-linked",
        "defaultMessage": "{goalCount, plural, other {# goals} one {# goal}} linked"
    }
});

});


parcelRegister("gZCQJ", function(module, exports) {

$parcel$export(module.exports, "useGoalsCellAriaLabel", () => $bc223400301b4fa1$export$65ef52b68009f944);

var $koVbs = parcelRequire("koVbs");

var $6nBz0 = parcelRequire("6nBz0");
const $bc223400301b4fa1$export$65ef52b68009f944 = ({ goalCount: goalCount, showPlaceholder: showPlaceholder, goals: goals })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (showPlaceholder) return undefined;
    if (goalCount === 0) return formatMessage((0, $6nBz0.default).addGoal);
    if (goalCount === 1) return goals[0].name;
    return formatMessage((0, $6nBz0.default).linkedGoals, {
        goalCount: goalCount
    });
};

});

parcelRegister("c0Z9B", function(module, exports) {

$parcel$export(module.exports, "goalPickerPopoverEntryPoint", () => $90eb827e4736f9e8$export$2917eb3a6c81ef7c);

var $jcI49 = parcelRequire("jcI49");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $90eb827e4736f9e8$export$2917eb3a6c81ef7c = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("3AKIH")), {
        moduleId: "97c2ac23"
    }),
    getPreloadProps: ({ cloudId: cloudId, issueAri: issueAri })=>({
            queries: {
                mainGoalsPopupContentQuery: {
                    parameters: (0, $jcI49.default),
                    variables: {
                        cloudId: cloudId,
                        issueAri: issueAri
                    },
                    options: {
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});

});
parcelRegister("jcI49", function(module, exports) {

$parcel$export(module.exports, "default", () => $56a552aaf657035b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cc863f7c0959b2e25deb284199453eea>>
 * @relayHash c13167dac448e4f5c0b631b60ba23ded
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bb7cccd795fc3a3a7749d89cb300deef1b787136f6c16ee2e1ebb17697a40cdd
const $56a552aaf657035b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "cloudId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "concreteType": "TownsquareUnshardedUserCapabilities",
        "kind": "LinkedField",
        "name": "userCapabilities",
        "plural": false,
        "selections": [
            {
                "concreteType": "TownsquareUnshardedCapability",
                "kind": "LinkedField",
                "name": "capabilities",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "capability"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "capabilityContainer"
                    }
                ]
            }
        ]
    }, v5 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "issueAri"
    }, v6 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        },
        v5 /*: any*/ 
    ], v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = [
        v8 /*: any*/ 
    ], v10 = {
        "kind": "InlineFragment",
        "selections": v9 /*: any*/ ,
        "type": "Node",
        "abstractKey": "__isNode"
    }, v11 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v12 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v13 = [
        "id"
    ], v14 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        },
        v5 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "mainGoalsPopupContentQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "issueGoals_AtlassianGoalPicker"
                },
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TownsquareUnshardedWorkspaceSummaryConnection",
                    "kind": "LinkedField",
                    "name": "townsquareUnsharded_allWorkspaceSummariesForOrg",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "TownsquareUnshardedWorkspaceSummaryEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "TownsquareUnshardedWorkspaceSummary",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "mainGoalsPopupContentQuery",
            "selections": [
                {
                    "concreteType": "GraphStore",
                    "kind": "LinkedField",
                    "name": "graphStore",
                    "plural": false,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalConnection",
                            "kind": "LinkedField",
                            "name": "jiraEpicContributesToAtlasGoal",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "url"
                                                        },
                                                        {
                                                            "concreteType": "TownsquareStatus",
                                                            "kind": "LinkedField",
                                                            "name": "status",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                },
                                                                {
                                                                    "concreteType": "TownsquareLocalizationField",
                                                                    "kind": "LinkedField",
                                                                    "name": "localizedLabel",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "messageId"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "TownsquareGoalIcon",
                                                            "kind": "LinkedField",
                                                            "name": "icon",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "key"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "appearance"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "TownsquareGoal"
                                                },
                                                v10 /*: any*/ 
                                            ]
                                        },
                                        v11 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v12 /*: any*/ 
                            ]
                        },
                        {
                            "args": v6 /*: any*/ ,
                            "filters": v13 /*: any*/ ,
                            "handle": "connection",
                            "key": "LinkedGoals_jiraEpicContributesToAtlasGoal",
                            "kind": "LinkedHandle",
                            "name": "jiraEpicContributesToAtlasGoal"
                        },
                        {
                            "alias": "issueGoalPicker",
                            "args": v14 /*: any*/ ,
                            "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalConnection",
                            "kind": "LinkedField",
                            "name": "jiraEpicContributesToAtlasGoal",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v9 /*: any*/ ,
                                                    "type": "TownsquareGoal"
                                                },
                                                v10 /*: any*/ 
                                            ]
                                        },
                                        v11 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v12 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "issueGoalPicker",
                            "args": v14 /*: any*/ ,
                            "filters": v13 /*: any*/ ,
                            "handle": "connection",
                            "key": "Goals_issueGoalPicker",
                            "kind": "LinkedHandle",
                            "name": "jiraEpicContributesToAtlasGoal"
                        }
                    ]
                },
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TownsquareUnshardedWorkspaceSummaryConnection",
                    "kind": "LinkedField",
                    "name": "townsquareUnsharded_allWorkspaceSummariesForOrg",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "TownsquareUnshardedWorkspaceSummaryEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "TownsquareUnshardedWorkspaceSummary",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "bb7cccd795fc3a3a7749d89cb300deef1b787136f6c16ee2e1ebb17697a40cdd",
            "metadata": {},
            "name": "mainGoalsPopupContentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$56a552aaf657035b$var$node.hash = "46961c295be31891ee43ef13cc35d017";
var $56a552aaf657035b$export$2e2bcd8739ae039 = $56a552aaf657035b$var$node;

});

parcelRegister("3AKIH", function(module, exports) {

let $29d8f985c28ba70c$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $29d8f985c28ba70c$var$load("ffQaD"),
    $29d8f985c28ba70c$var$load("kvRbA"),
    $29d8f985c28ba70c$var$load("76n7a"),
    $29d8f985c28ba70c$var$load("l253H"),
    $29d8f985c28ba70c$var$load("cbnTi")
]).then(()=>parcelRequire('hrswT'));

});


parcelRegister("1JUx3", function(module, exports) {

$parcel$export(module.exports, "ERROR_FLAG_ID", () => $bf42591600af2e30$export$f5e4c120ac01b615);
$parcel$export(module.exports, "POPUP_ENTRYPOINT_ERROR_FLAG", () => $bf42591600af2e30$export$bb0d35c1fc48487f);

var $hadBz = parcelRequire("hadBz");
const $bf42591600af2e30$export$f5e4c120ac01b615 = 'OPEN_GOAL_PICKER_ERROR_FLAG';
const $bf42591600af2e30$export$bb0d35c1fc48487f = {
    id: $bf42591600af2e30$export$f5e4c120ac01b615,
    type: 'error',
    title: (0, $hadBz.default).errorFlagTitle,
    description: (0, $hadBz.default).errorFlagDescription,
    isAutoDismiss: true,
    messageId: 'business-goal-picker.ui.popup-entrypoint-error-flag.error',
    messageType: 'transactional'
};

});
parcelRegister("hadBz", function(module, exports) {

$parcel$export(module.exports, "default", () => $29eed584a2262e67$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $29eed584a2262e67$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorFlagTitle: {
        "id": "business-goal-picker.error-flag-title",
        "defaultMessage": "Something's gone wrong"
    },
    errorFlagDescription: {
        "id": "business-goal-picker.error-flag-description",
        "defaultMessage": "Our team has been notified. If the problem persists, please contact Atlassian Support."
    }
});

});



parcelRegister("l213r", function(module, exports) {

$parcel$export(module.exports, "useGoalsField", () => $fa1aa5746e3ca5cc$export$c45dcf2640399301);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $eiowN = parcelRequire("eiowN");

var $2RKeg = parcelRequire("2RKeg");

var $lQE94 = parcelRequire("lQE94");

var $5fc53 = parcelRequire("5fc53");

var $koeKL = parcelRequire("koeKL");

var $iJZ8l = parcelRequire("iJZ8l");
const $fa1aa5746e3ca5cc$export$c45dcf2640399301 = ({ fieldKey: fieldKey, issueId: issueId, issueKey: issueKey, onSuccess: onSuccess, onFailure: onFailure, initialValue: initialValue })=>{
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const cloudId = (0, $koeKL.useCloudId)();
    const getDataId = (0, $5uXOq.useCallback)(// issueId can be undefined so passing this in after the saveField check to avoid TS error and ensure we actually have a valid value
    (typeName, issue)=>(0, $iJZ8l.default)({
            id: (0, $2RKeg.JiraIssuefieldvalueAri).create({
                siteId: cloudId,
                issueId: issue.toString(),
                fieldId: fieldKey
            }).toString()
        }, typeName), [
        cloudId,
        fieldKey
    ]);
    const saveField = (0, $5uXOq.useCallback)((_iKey, _fKey, valuesForOperation)=>{
        (0, $8Uumt.commitLocalUpdate)(environment, (store)=>{
            if (!issueId) return;
            const dataID = getDataId('JiraGoalsField', issueId);
            if (!dataID) return;
            const goalsField = store.get(dataID);
            if (!goalsField) return;
            const connection = (0, $eiowN.ConnectionHandler).getConnection(goalsField, 'issue_view_goals_field_selectedGoals');
            if (connection == null) return;
            let edges = connection.getLinkedRecords('edges');
            if (!edges || edges.length === 0) {
                const newGoalDataId = getDataId('JiraGoalsField:selectedGoals(first:1):edges:0', issueId);
                if (!newGoalDataId) return;
                const newEdge = (0, $eiowN.ConnectionHandler).createEdge(store, connection, store.create(newGoalDataId, 'JiraGoal'), 'JiraGoalEdge');
                (0, $eiowN.ConnectionHandler).insertEdgeBefore(connection, newEdge);
                edges = connection.getLinkedRecords('edges');
            }
            if (!edges) return;
            // We should only ever have one edge
            const node = edges[0].getLinkedRecord('node');
            if (valuesForOperation.totalCount === 0) {
                const nodeId = node?.getDataID();
                const edgeId = edges[0].getDataID();
                if (!nodeId || !edgeId) return;
                // delete both the node and the edge to avoid invariant violations
                store.delete(nodeId);
                store.delete(edgeId);
                // Clear the connection to avoid invariant violations
                connection.setLinkedRecords([], 'edges');
            } else {
                node?.setValue(valuesForOperation.goals[0].id, 'id');
                node?.setValue(valuesForOperation.goals[0].name, 'name');
                node?.setValue(valuesForOperation.goals[0].status, 'status');
            }
            // We _should_ alway require the count to update
            connection?.setValue(valuesForOperation.totalCount, 'totalCount');
        });
        return Promise.resolve(undefined);
    }, [
        environment,
        getDataId,
        issueId
    ]);
    const [{ error: error, value: value }, { resetError: resetError, saveValue: saveValue }] = (0, $lQE94.useEditField)({
        fieldType: (0, $5fc53.GOALS_CF_TYPE),
        issueId: issueId,
        issueKey: issueKey,
        onSuccess: onSuccess,
        onFailure: onFailure,
        initialValue: initialValue,
        fieldKey: fieldKey,
        saveField: saveField,
        shouldPreventIssueViewSoftRefresh: true
    });
    return [
        {
            error: error,
            value: value
        },
        {
            resetError: resetError,
            saveValue: saveValue
        }
    ];
};

});

parcelRegister("cZbJv", function(module, exports) {

$parcel$export(module.exports, "AssociateFieldPopup", () => $7f730dd37615959a$export$bd4255b1f989bfbd);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $daQYX = parcelRequire("daQYX");

var $2AOGO = parcelRequire("2AOGO");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $jgJNO = parcelRequire("jgJNO");

var $1FGgx = parcelRequire("1FGgx");
const $7f730dd37615959a$var$POPUP_OFFSET = [
    -8,
    8
];
const $7f730dd37615959a$export$bd4255b1f989bfbd = ({ isOpen: isOpen, issueType: issueType, issueTypeId: issueTypeId, fieldId: fieldId, fieldName: fieldName, onClose: onClose })=>{
    const project = (0, $daQYX.useProject)();
    const { associate: associate } = (0, $2AOGO.useAssociateField)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const canAssociateField = project.permissions.administerProject && project.isSimplified && issueType !== undefined && issueTypeId !== undefined;
    const popupTrigger = (0, $5uXOq.useCallback)(({ ref: ref, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, 'aria-controls': ariaControls })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            ref: ref,
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHaspopup,
            "aria-controls": ariaControls,
            xcss: $7f730dd37615959a$var$triggerStyles,
            role: "button",
            "aria-label": formatMessage((0, $1FGgx.default).linkGoals)
        }), [
        formatMessage
    ]);
    const onAssociateField = (0, $5uXOq.useCallback)(()=>{
        associate({
            input: {
                projectId: String(project.id),
                fieldId: fieldId,
                issueTypeIds: [
                    Number(issueTypeId)
                ]
            },
            fieldName: fieldName,
            issueType: issueType,
            showSuccess: true,
            analyticsAttributes: {
                source: 'business-list.shared.fields.goals-cell'
            }
        });
        onClose();
    }, [
        associate,
        fieldId,
        fieldName,
        issueType,
        issueTypeId,
        onClose,
        project.id
    ]);
    const content = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
            space: "space.100",
            xcss: $7f730dd37615959a$var$popupStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $1FGgx.default).associateGoalsFieldBodyIssueTermRefresh : (0, $1FGgx.default).associateGoalsFieldBody, {
            issueType: issueType,
            fieldName: fieldName,
            bold: (chunk)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                    as: "strong"
                }, chunk)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, canAssociateField ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            onClick: onAssociateField,
            appearance: "link",
            spacing: "none"
        }, formatMessage((0, $1FGgx.default).updateFieldAssociationAction)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            href: "/secure/ContactAdministrators!default.jspa",
            target: "_blank",
            onClick: onClose,
            appearance: "link",
            spacing: "none"
        }, formatMessage((0, $1FGgx.default).contactAdmin))))), [
        canAssociateField,
        fieldName,
        formatMessage,
        issueType,
        onAssociateField,
        onClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isOpen,
        content: content,
        trigger: popupTrigger,
        offset: $7f730dd37615959a$var$POPUP_OFFSET,
        placement: "bottom-start",
        messageId: "business-fields.ui.goals.cell.associate-field-popup.popup",
        messageType: "transactional",
        onClose: onClose
    });
};
const $7f730dd37615959a$var$popupStyles = (0, $8CUq3.xcss)({
    width: '300px',
    paddingTop: 'space.200',
    paddingBottom: 'space.200',
    paddingLeft: 'space.300',
    paddingRight: 'space.300'
});
const $7f730dd37615959a$var$triggerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    height: '100%',
    width: '100%'
});

});
parcelRegister("1FGgx", function(module, exports) {

$parcel$export(module.exports, "default", () => $50db2cf807dc99d2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $50db2cf807dc99d2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    associateGoalsFieldBody: {
        "id": "business-fields.goals.cell.associate-field-popup.associate-goals-field-body",
        "defaultMessage": "The <bold>{fieldName}</bold> field isn't associated with the <bold>{issueType}</bold> issue type."
    },
    contactAdmin: {
        "id": "business-fields.goals.cell.associate-field-popup.contact-admin",
        "defaultMessage": "Contact Admin"
    },
    updateFieldAssociationAction: {
        "id": "business-fields.goals.cell.associate-field-popup.update-field-association-action",
        "defaultMessage": "Update field association"
    },
    linkGoals: {
        "id": "business-fields.goals.cell.associate-field-popup.link-goals",
        "defaultMessage": "Link Goals"
    },
    associateGoalsFieldBodyIssueTermRefresh: {
        "id": "business-fields.goals.cell.associate-field-popup.associate-goals-field-body-issue-term-refresh",
        "defaultMessage": "The <bold>{fieldName}</bold> field isn't associated with the work type."
    }
});

});


parcelRegister("jno68", function(module, exports) {

$parcel$export(module.exports, "useIsFieldAssociatedWithIssueType", () => $30156937743291f0$export$cb0b144001cec81a);

var $5uXOq = parcelRequire("5uXOq");

var $1T2vX = parcelRequire("1T2vX");
const $30156937743291f0$export$cb0b144001cec81a = ({ fieldId: fieldId, issueTypeId: issueTypeId })=>{
    const { typesWithFields: typesWithFields } = (0, $1T2vX.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const isFieldAssociated = (0, $5uXOq.useMemo)(()=>{
        if (issueTypeId === undefined) return false;
        const issueTypeFields = typesWithFields.find((type)=>type.issueType.id === issueTypeId)?.fields;
        return issueTypeFields?.some((issueTypeField)=>issueTypeField.id === fieldId) ?? false;
    }, [
        fieldId,
        issueTypeId,
        typesWithFields
    ]);
    return isFieldAssociated;
};

});


parcelRegister("lna2D", function(module, exports) {

$parcel$export(module.exports, "groupCellHandler", () => $178b2eb52257e100$export$b2844c90dc2ccc0f);

var $5uXOq = parcelRequire("5uXOq");

var $lQE94 = parcelRequire("lQE94");

var $5fc53 = parcelRequire("5fc53");

var $b5lmY = parcelRequire("b5lmY");

var $2etjA = parcelRequire("2etjA");

var $3J9ez = parcelRequire("3J9ez");
const $178b2eb52257e100$export$2f128d21295c820 = ({ rowData: issue, cellData: field, column: { width: preferredWidth }, editMode: editMode, setEditMode: setEditMode, cellRef: cellRef, inputValue: inputValue, onInputChange: onInputChange })=>{
    const [selectedGroups, setSelectedGroups] = (0, $5uXOq.useState)(field?.value ?? null);
    const [{ value: fieldValue }] = (0, $lQE94.useEditField)({
        fieldKey: field?.fieldId ?? '',
        issueKey: issue.key,
        fieldType: field?.type ?? '',
        initialValue: field?.value ?? null
    });
    if (!editMode && fieldValue !== selectedGroups) setSelectedGroups(fieldValue);
    // Updated the value when a new updated is receive it
    (0, $5uXOq.useEffect)(()=>{
        setSelectedGroups(field?.value ?? null);
    }, [
        field?.value
    ]);
    const isEditable = (0, $5uXOq.useMemo)(()=>issue.fieldConfig?.isEditable || false, [
        issue.fieldConfig?.isEditable
    ]);
    const isMulti = (0, $5uXOq.useMemo)(()=>field?.type !== 'com.atlassian.jira.plugin.system.customfieldtypes:grouppicker', [
        field?.type
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b5lmY.CellWrapper), {
        isEditable: isEditable,
        testId: "business-fields.ui.group.cell.cell-wrapper"
    }, editMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2etjA.GroupEdit), {
        cellRef: cellRef,
        setEditMode: setEditMode,
        inputValue: inputValue,
        onInputChange: onInputChange,
        isMulti: isMulti,
        fieldName: field?.name || '',
        onChange: setSelectedGroups,
        preferredWidth: preferredWidth,
        selectedGroups: selectedGroups,
        fieldKey: field?.fieldId || '',
        issueKey: issue.key,
        fieldType: field?.type || '',
        initialValue: field?.value ?? null,
        readContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3J9ez.GroupRead), {
            isEditable: isEditable,
            selectedGroups: selectedGroups
        })
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3J9ez.GroupRead), {
        isEditable: isEditable,
        selectedGroups: selectedGroups
    }));
};
const $178b2eb52257e100$export$b2844c90dc2ccc0f = {
    [(0, $5fc53.GROUP_CF_TYPE)]: $178b2eb52257e100$export$2f128d21295c820,
    [(0, $5fc53.MULTI_GROUP_CF_TYPE)]: $178b2eb52257e100$export$2f128d21295c820
};

});
parcelRegister("2etjA", function(module, exports) {

$parcel$export(module.exports, "GroupEdit", () => $d65840a6527f96eb$export$9036da6562372d3b);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $cObeo = parcelRequire("cObeo");
const $d65840a6527f96eb$var$entryPointParams = {};
const $d65840a6527f96eb$export$9036da6562372d3b = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $cObeo.groupEditEntryPoint), $d65840a6527f96eb$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jwm.business.fields.group.edit",
        packageName: "jiraBusinessFields",
        runtimeProps: props,
        fallback: props.readContent
    });
};

});
parcelRegister("cObeo", function(module, exports) {

$parcel$export(module.exports, "groupEditEntryPoint", () => $262750810fef9327$export$20cce7641ad91969);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $262750810fef9327$export$20cce7641ad91969 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("9U3Tw")), {
        moduleId: "fc335c35"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("9U3Tw", function(module, exports) {

let $735c5d5d19e80dda$var$load = (parcelRequire("28QjX"))(4);
module.exports = $735c5d5d19e80dda$var$load("9jFkl").then(()=>parcelRequire('c4MTA'));

});



parcelRegister("3J9ez", function(module, exports) {

$parcel$export(module.exports, "GroupRead", () => $fc80ff35ded673cb$export$d8ab1fa8206677db);

var $5uXOq = parcelRequire("5uXOq");

var $d9xxV = parcelRequire("d9xxV");

var $b5lmY = parcelRequire("b5lmY");

var $k2xO1 = parcelRequire("k2xO1");
const $fc80ff35ded673cb$export$d8ab1fa8206677db = ({ selectedGroups: selectedGroups, isEditable: isEditable })=>{
    const group = (0, $5uXOq.useMemo)(()=>Array.isArray(selectedGroups) ? selectedGroups[0]?.name : selectedGroups?.name, [
        selectedGroups
    ]);
    const count = (0, $5uXOq.useMemo)(()=>Array.isArray(selectedGroups) ? selectedGroups.length - 1 : 0, [
        selectedGroups
    ]);
    if (group == null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b5lmY.WrapperCommon), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k2xO1.TagListWrapper), {
        isEditable: isEditable
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d9xxV.default), {
        text: group
    }), count > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d9xxV.default), {
        text: `+${count}`
    })));
};

});


parcelRegister("kpNUY", function(module, exports) {

$parcel$export(module.exports, "parentCellHandler", () => $bcdec2aa400fb11e$export$342c67b3a001949f);

var $5uXOq = parcelRequire("5uXOq");

var $4FipU = parcelRequire("4FipU");

var $5fc53 = parcelRequire("5fc53");

var $g5X3G = parcelRequire("g5X3G");

var $4R6GH = parcelRequire("4R6GH");

var $b5lmY = parcelRequire("b5lmY");

var $5SDWV = parcelRequire("5SDWV");

var $cVGH1 = parcelRequire("cVGH1");
const $bcdec2aa400fb11e$var$transformFieldToParent = (field)=>{
    if (field?.value?.summary == null || field?.value?.issueType == null || field?.value?.issueId == null || field?.value?.issueKey == null) return null;
    return {
        key: field?.value.issueKey,
        value: field?.value?.issueId,
        label: field?.value?.summary,
        fields: {
            summary: field?.value?.summary,
            issuetype: field?.value?.issueType
        },
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        color: field?.value?.color
    };
};
const $bcdec2aa400fb11e$export$d5a4cc78f8c5a2cd = ({ rowData: issue, cellData: field, column: { width: preferredWidth }, editMode: editMode, setEditMode: setEditMode, onIssueUpdated: onIssueUpdated, cellRef: cellRef, otherProps: otherProps })=>{
    const [parent, setParent] = (0, $5uXOq.useState)($bcdec2aa400fb11e$var$transformFieldToParent(field));
    const [{ value: value }] = (0, $4FipU.useParentField)({
        issueKey: (0, $g5X3G.toIssueKey)(issue.key),
        fieldKey: field?.fieldId ?? '',
        issueId: issue.issueId
    });
    if (value && value !== parent) setParent(value);
    // Updated the value when a new updated is receive it
    (0, $5uXOq.useEffect)(()=>{
        setParent($bcdec2aa400fb11e$var$transformFieldToParent(field));
    }, [
        field
    ]);
    const handleChange = (0, $5uXOq.useCallback)((newParent)=>{
        setParent((oldParent)=>{
            if (field != null) onIssueUpdated({
                fieldId: field.fieldId,
                fieldType: field.type,
                issueId: issue.issueId,
                newValue: newParent,
                oldValue: oldParent,
                issueKey: (0, $g5X3G.toIssueKey)(issue.key)
            });
            return newParent;
        });
        setEditMode(false);
    }, [
        field,
        issue.issueId,
        issue.key,
        onIssueUpdated,
        setEditMode
    ]);
    const handleFailure = (0, $5uXOq.useCallback)(()=>{
        setEditMode(false);
    }, [
        setEditMode
    ]);
    if (field == null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b5lmY.CellWrapper), {
        isEditable: true
    }, editMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5SDWV.ParentEdit), {
        parent: parent,
        cellRef: cellRef,
        fieldId: field.fieldId,
        issueKey: issue.key,
        issueId: issue.issueId,
        preferredWidth: preferredWidth,
        onChange: handleChange,
        onFailure: handleFailure,
        readContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cVGH1.ParentRead), {
            parent: parent,
            createOpenIssueModalHandler: (0, $4R6GH.fg)('remove_issue_view_dependency_on_business_field') ? otherProps?.createOpenIssueModalHandler : undefined
        })
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cVGH1.ParentRead), {
        parent: parent,
        createOpenIssueModalHandler: (0, $4R6GH.fg)('remove_issue_view_dependency_on_business_field') ? otherProps?.createOpenIssueModalHandler : undefined
    }));
};
const $bcdec2aa400fb11e$export$342c67b3a001949f = {
    [(0, $5fc53.PARENT_TYPE)]: $bcdec2aa400fb11e$export$d5a4cc78f8c5a2cd
};

});
parcelRegister("5SDWV", function(module, exports) {

$parcel$export(module.exports, "ParentEdit", () => $dd8c5fbe0789c866$export$c7e5e7ddde2d8f0);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $lqdAB = parcelRequire("lqdAB");
const $dd8c5fbe0789c866$var$entryPointParams = {};
const $dd8c5fbe0789c866$export$c7e5e7ddde2d8f0 = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $lqdAB.parentEditEntryPoint), $dd8c5fbe0789c866$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jwm.business.fields.parent.edit",
        packageName: "jiraBusinessFields",
        runtimeProps: props,
        fallback: props.readContent
    });
};

});
parcelRegister("lqdAB", function(module, exports) {

$parcel$export(module.exports, "parentEditEntryPoint", () => $340f6220f071f296$export$1d2363001ed1e75d);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $340f6220f071f296$export$1d2363001ed1e75d = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("2167a")), {
        moduleId: "9c7e10fe"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("2167a", function(module, exports) {

let $17806afb5aa04f42$var$load = (parcelRequire("28QjX"))(4);
module.exports = $17806afb5aa04f42$var$load("9VQKa").then(()=>parcelRequire('1jioY'));

});



parcelRegister("cVGH1", function(module, exports) {

$parcel$export(module.exports, "ParentRead", () => $652a909455a2ba76$export$500e192e2d559470);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $ltZxv = parcelRequire("ltZxv");

var $76pK6 = parcelRequire("76pK6");

var $4R6GH = parcelRequire("4R6GH");
const $652a909455a2ba76$export$500e192e2d559470 = ({ parent: parent, createOpenIssueModalHandler: createOpenIssueModalHandlerProps })=>{
    const { createOpenIssueModalHandler: createOpenIssueModalHandler } = (0, $ltZxv.useIssueModalActions)();
    const handleClick = (0, $5uXOq.useCallback)((e)=>{
        if (parent == null || parent.key == null) return;
        if (createOpenIssueModalHandlerProps != null && (0, $4R6GH.fg)('remove_issue_view_dependency_on_business_field')) return createOpenIssueModalHandlerProps({
            key: parent.key
        })(e);
        return createOpenIssueModalHandler({
            key: parent.key
        })(e);
    }, [
        createOpenIssueModalHandler,
        createOpenIssueModalHandlerProps,
        parent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $652a909455a2ba76$var$parentCellStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $76pK6.ParentViewField), {
        value: parent,
        noValueText: "",
        isMobile: false,
        onClick: handleClick
    }));
};
const $652a909455a2ba76$var$parentCellStyles = (0, $8CUq3.xcss)({
    maxWidth: '100%'
});

});
parcelRegister("76pK6", function(module, exports) {

$parcel$export(module.exports, "ParentViewField", () => $6009579b1db350c9$export$51036c707862fc9f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $hjSul = parcelRequire("hjSul");

var $iv6X1 = parcelRequire("iv6X1");

var $iVcsU = parcelRequire("iVcsU");

var $8KNKh = parcelRequire("8KNKh");
const $6009579b1db350c9$var$Summary = ({ isMobile: isMobile, onClick: onClick, label: label, lozengeTheme: lozengeTheme, issueKey: issueKey })=>{
    if (isMobile) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6009579b1db350c9$var$WrapperNoClick, {
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: lozengeTheme
    }, label);
    if (onClick != null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6009579b1db350c9$var$ButtonText, {
        onClick: onClick,
        style: lozengeTheme
    }, label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6009579b1db350c9$var$LinkText, {
        "data-testid": "issue-field-parent.ui.view-link",
        href: `/browse/${issueKey}`,
        style: lozengeTheme
    }, label);
};
const $6009579b1db350c9$export$51036c707862fc9f = (props)=>{
    const { value: value, noValueText: noValueText, isMobile: isMobile, onClick: onClick } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const noValueTextExperiment = formatMessage((0, $8KNKh.default).noValueTextExperiment);
    const { isExperimentEnabled: isExperimentEnabled } = (0, $iv6X1.useBespokeEmptyFieldTextExperiment)();
    if (value) {
        const { key: key, fields: fields } = value;
        const label = `${key} ${fields.summary}`;
        const style = value.color ? (0, $iVcsU.getLozengeThemeByColor)(value.color) : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: label,
            position: "bottom"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6009579b1db350c9$var$Container, {
            "data-testid": "issue-field-parent.ui.container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6009579b1db350c9$var$Icon, {
            src: fields.issuetype.iconUrl,
            alt: formatMessage((0, $8KNKh.default).icon, {
                issueType: fields?.issuetype.name || ''
            })
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6009579b1db350c9$var$Summary, {
            isMobile: isMobile,
            label: label,
            lozengeTheme: style,
            onClick: onClick,
            issueKey: key
        })));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6009579b1db350c9$var$EmptyValue, {
        "data-testid": "issue-field-parent.ui.view-read-view-empty-value"
    }, isExperimentEnabled ? noValueTextExperiment : noValueText);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6009579b1db350c9$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c1txw _2lx2vrvc _o5721q9c _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $6009579b1db350c9$var$LinkText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $hjSul.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _2rko1sit _11c82smr _1bto1l2s _o5721q9c _80omtlke _p12f1osq _ca0qidpf _u5f31b66 _n3tdidpf _19bv1b66 _2hwxu2gc _9oik18uv _1bnx8stv _jf4cnqa1",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $6009579b1db350c9$var$ButtonText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _2rko1sit _11c82smr _19itglyw _11q7glyw _12ji1r31 _1qu21kw7 _12y31o36 _o5721q9c _80omtlke _4t3igktf _p12f1osq _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66 _2hwxu2gc _syaz1kw7 _vwz44jg8 _1bto1l2s _1e0c1ule _nt751r31 _49pcglyw _1hvw1o36 _9oik18uv _1bnx8stv _jf4cnqa1",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6009579b1db350c9$var$Icon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2hwx12x7 _p12f7vkz",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $6009579b1db350c9$var$WrapperNoClick = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _2rko1sit _11c82smr _1bto1l2s _o5721q9c _1e0c1ule _4t3i7vkz _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66 _p12f1osq _2hwxu2gc _vwz44jg8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6009579b1db350c9$var$EmptyValue = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz131l",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iVcsU", function(module, exports) {

$parcel$export(module.exports, "getOptionColorElem", () => $608100d8bb869e55$export$b00899e73680c477);
$parcel$export(module.exports, "mapDataToOptions", () => $608100d8bb869e55$export$99a866ffa3af7d8b);
$parcel$export(module.exports, "mapOptionToData", () => $608100d8bb869e55$export$fc800909123977f3);
$parcel$export(module.exports, "preventEscKeyPropagationKeyPressHandler", () => $608100d8bb869e55$export$feb08457bf70a411);
$parcel$export(module.exports, "getLozengeThemeByColor", () => $608100d8bb869e55$export$949dc67535a8ff2);
/* utils.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $heWHN = parcelRequire("heWHN");

var $iHPnC = parcelRequire("iHPnC");
const $608100d8bb869e55$export$bc913b9c9057634d = (color)=>color === undefined || color === '' ? 'transparent' : (0, $heWHN.MAP_COLORS_TO_VALUE)[color];
const $608100d8bb869e55$export$b00899e73680c477 = (color)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($608100d8bb869e55$var$ColorPatch, {
        color: color,
        "data-testid": `issue-field-parent.common.color-patch-${color}`
    });
const $608100d8bb869e55$export$99a866ffa3af7d8b = (issueParents)=>{
    return issueParents.map(({ id: id, issueType: issueType, key: key, summary: summary, color: color, isDone: isDone })=>({
            id: id,
            key: key,
            fields: {
                issuetype: issueType,
                summary: summary
            },
            color: color,
            value: id,
            label: `${key} ${summary}`,
            isDone: isDone
        }));
};
const $608100d8bb869e55$export$fc800909123977f3 = (option)=>({
        id: option.value
    });
const $608100d8bb869e55$export$9b822862d986dfdf = (0, $iHPnC.transformColorToTheme)((colorSchema)=>({
        color: colorSchema.text,
        backgroundColor: colorSchema.textBackground
    }));
const $608100d8bb869e55$export$feb08457bf70a411 = (event)=>{
    if (event?.key === 'Escape') event?.nativeEvent?.stopImmediatePropagation();
};
const $608100d8bb869e55$export$949dc67535a8ff2 = (color)=>$608100d8bb869e55$export$9b822862d986dfdf[color];
// We adjust the size of the color patch away from normal grid sizes because
// the issue type icon actually has a 1px border on each side, which is 2x1px on width/height
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $608100d8bb869e55$var$ColorPatch = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1nzbko4": (0, $lD23V.default)($608100d8bb869e55$export$bc913b9c9057634d(__cmplp.color))
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1y44 _1bsbdlk8 _1ul9dlk8 _4t3idlk8 _bfhk1vzt",
            __cmplp.className
        ])
    });
});

});
parcelRegister("heWHN", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_EPIC_COLOR", () => $3a4ee6f2b0ce40ab$export$c2357bec51c5cf5b);
$parcel$export(module.exports, "MAP_COLORS_TO_VALUE", () => $3a4ee6f2b0ce40ab$export$db33d74b098e3da9);
$parcel$export(module.exports, "MAP_COLORS_TO_TOKEN", () => $3a4ee6f2b0ce40ab$export$fc5fe4213a5703f1);
$parcel$export(module.exports, "MAP_VALUE_TO_COLOR", () => $3a4ee6f2b0ce40ab$export$a6cb26e106674600);
$parcel$export(module.exports, "MAP_FROM_SERVER_COLOR", () => $3a4ee6f2b0ce40ab$export$43264b0781f10167);
$parcel$export(module.exports, "MAP_FROM_CLIENT_SERVER_COLOR", () => $3a4ee6f2b0ce40ab$export$aedca9f3a1ee43d7);
$parcel$export(module.exports, "MAP_FROM_SERVER_CLASSIC_COLOR", () => $3a4ee6f2b0ce40ab$export$fb5d051fe1b2bccc);
$parcel$export(module.exports, "MAP_FROM_CLIENT_CLASSIC_COLOR", () => $3a4ee6f2b0ce40ab$export$c13af2d9629c53d8);
$parcel$export(module.exports, "MAP_FROM_AGILE_COLOR", () => $3a4ee6f2b0ce40ab$export$994d3ffa39be04fd);
$parcel$export(module.exports, "MAP_FROM_CLIENT_AGILE_COLOR", () => $3a4ee6f2b0ce40ab$export$db17671bf37971e7);
$parcel$export(module.exports, "MAP_COLOR_TO_AK_COLOR", () => $3a4ee6f2b0ce40ab$export$82fc3b0b98905453);
$parcel$export(module.exports, "BASE_COLOR_SCHEMA", () => $3a4ee6f2b0ce40ab$export$92b6aebfb522f0d9);

var $ggSx2 = parcelRequire("ggSx2");


var $7SCny = parcelRequire("7SCny");
const $3a4ee6f2b0ce40ab$export$c2357bec51c5cf5b = 'PURPLE';
const $3a4ee6f2b0ce40ab$export$db33d74b098e3da9 = {
    [(0, $7SCny.PURPLE)]: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
    [(0, $7SCny.BLUE)]: "var(--ds-background-accent-blue-subtle, #579DFF)",
    [(0, $7SCny.GREEN)]: "var(--ds-background-accent-green-subtle, #4BCE97)",
    [(0, $7SCny.TEAL)]: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    [(0, $7SCny.YELLOW)]: "var(--ds-background-accent-yellow-subtle, #F5CD47)",
    [(0, $7SCny.ORANGE)]: "var(--ds-background-accent-red-subtle, #F87168)",
    [(0, $7SCny.GREY)]: "var(--ds-background-accent-gray-subtle, #8590A2)",
    [(0, $7SCny.DARK_PURPLE)]: "var(--ds-background-accent-purple-bolder, #6E5DC6)",
    [(0, $7SCny.DARK_BLUE)]: "var(--ds-background-accent-blue-bolder, #0C66E4)",
    [(0, $7SCny.DARK_GREEN)]: "var(--ds-background-accent-green-bolder, #1F845A)",
    [(0, $7SCny.DARK_TEAL)]: "var(--ds-background-accent-teal-bolder, #227D9B)",
    [(0, $7SCny.DARK_YELLOW)]: "var(--ds-background-accent-orange-bolder, #C25100)",
    [(0, $7SCny.DARK_ORANGE)]: "var(--ds-background-accent-red-bolder, #C9372C)",
    [(0, $7SCny.DARK_GREY)]: "var(--ds-background-accent-gray-bolder, #626F86)"
};
const $3a4ee6f2b0ce40ab$export$fc5fe4213a5703f1 = {
    [(0, $829f609a65d26a98$exports).P200]: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
    [(0, $829f609a65d26a98$exports).B200]: "var(--ds-background-accent-blue-subtle, #579DFF)",
    [(0, $829f609a65d26a98$exports).G200]: "var(--ds-background-accent-green-subtle, #4BCE97)",
    [(0, $829f609a65d26a98$exports).T200]: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    [(0, $829f609a65d26a98$exports).Y200]: "var(--ds-background-accent-yellow-subtle, #F5CD47)",
    [(0, $829f609a65d26a98$exports).R200]: "var(--ds-background-accent-red-subtle, #F87168)",
    [(0, $829f609a65d26a98$exports).N200]: "var(--ds-background-accent-gray-subtle, #8590A2)",
    [(0, $829f609a65d26a98$exports).P400]: "var(--ds-background-accent-purple-bolder, #6E5DC6)",
    [(0, $829f609a65d26a98$exports).B400]: "var(--ds-background-accent-blue-bolder, #0C66E4)",
    [(0, $829f609a65d26a98$exports).G400]: "var(--ds-background-accent-green-bolder, #1F845A)",
    [(0, $829f609a65d26a98$exports).T400]: "var(--ds-background-accent-teal-bolder, #227D9B)",
    [(0, $829f609a65d26a98$exports).Y400]: "var(--ds-background-accent-orange-bolder, #C25100)",
    [(0, $829f609a65d26a98$exports).R400]: "var(--ds-background-accent-red-bolder, #C9372C)",
    [(0, $829f609a65d26a98$exports).N700]: "var(--ds-background-accent-gray-bolder, #626F86)"
};
const $3a4ee6f2b0ce40ab$export$a6cb26e106674600 = (0, (/*@__PURE__*/$parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$db33d74b098e3da9);
const $3a4ee6f2b0ce40ab$export$43264b0781f10167 = {
    [(0, $7SCny.SERVER_PURPLE)]: (0, $7SCny.PURPLE),
    [(0, $7SCny.SERVER_DARK_PURPLE)]: (0, $7SCny.DARK_PURPLE),
    [(0, $7SCny.SERVER_BLUE)]: (0, $7SCny.BLUE),
    [(0, $7SCny.SERVER_DARK_BLUE)]: (0, $7SCny.DARK_BLUE),
    [(0, $7SCny.SERVER_GREEN)]: (0, $7SCny.GREEN),
    [(0, $7SCny.SERVER_DARK_GREEN)]: (0, $7SCny.DARK_GREEN),
    [(0, $7SCny.SERVER_TEAL)]: (0, $7SCny.TEAL),
    [(0, $7SCny.SERVER_DARK_TEAL)]: (0, $7SCny.DARK_TEAL),
    [(0, $7SCny.SERVER_YELLOW)]: (0, $7SCny.YELLOW),
    [(0, $7SCny.SERVER_DARK_YELLOW)]: (0, $7SCny.DARK_YELLOW),
    [(0, $7SCny.SERVER_ORANGE)]: (0, $7SCny.ORANGE),
    [(0, $7SCny.SERVER_DARK_ORANGE)]: (0, $7SCny.DARK_ORANGE),
    [(0, $7SCny.SERVER_GREY)]: (0, $7SCny.GREY),
    [(0, $7SCny.SERVER_DARK_GREY)]: (0, $7SCny.DARK_GREY)
};
const $3a4ee6f2b0ce40ab$export$aedca9f3a1ee43d7 = (0, (/*@__PURE__*/$parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$43264b0781f10167);
const $3a4ee6f2b0ce40ab$export$fb5d051fe1b2bccc = {
    [(0, $7SCny.GHX_LABEL_1)]: (0, $7SCny.DARK_GREY),
    [(0, $7SCny.GHX_LABEL_2)]: (0, $7SCny.DARK_YELLOW),
    [(0, $7SCny.GHX_LABEL_3)]: (0, $7SCny.YELLOW),
    [(0, $7SCny.GHX_LABEL_4)]: (0, $7SCny.DARK_BLUE),
    [(0, $7SCny.GHX_LABEL_5)]: (0, $7SCny.DARK_TEAL),
    [(0, $7SCny.GHX_LABEL_6)]: (0, $7SCny.GREEN),
    [(0, $7SCny.GHX_LABEL_7)]: (0, $7SCny.PURPLE),
    [(0, $7SCny.GHX_LABEL_8)]: (0, $7SCny.DARK_PURPLE),
    [(0, $7SCny.GHX_LABEL_9)]: (0, $7SCny.ORANGE),
    [(0, $7SCny.GHX_LABEL_10)]: (0, $7SCny.BLUE),
    [(0, $7SCny.GHX_LABEL_11)]: (0, $7SCny.TEAL),
    [(0, $7SCny.GHX_LABEL_12)]: (0, $7SCny.GREY),
    [(0, $7SCny.GHX_LABEL_13)]: (0, $7SCny.DARK_GREEN),
    [(0, $7SCny.GHX_LABEL_14)]: (0, $7SCny.DARK_ORANGE)
};
const $3a4ee6f2b0ce40ab$export$c13af2d9629c53d8 = (0, (/*@__PURE__*/$parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$fb5d051fe1b2bccc);
const $3a4ee6f2b0ce40ab$export$994d3ffa39be04fd = {
    [(0, $7SCny.AGILE_COLOR_1)]: (0, $7SCny.DARK_GREY),
    [(0, $7SCny.AGILE_COLOR_2)]: (0, $7SCny.DARK_YELLOW),
    [(0, $7SCny.AGILE_COLOR_3)]: (0, $7SCny.YELLOW),
    [(0, $7SCny.AGILE_COLOR_4)]: (0, $7SCny.DARK_BLUE),
    [(0, $7SCny.AGILE_COLOR_5)]: (0, $7SCny.DARK_TEAL),
    [(0, $7SCny.AGILE_COLOR_6)]: (0, $7SCny.GREEN),
    [(0, $7SCny.AGILE_COLOR_7)]: (0, $7SCny.PURPLE),
    [(0, $7SCny.AGILE_COLOR_8)]: (0, $7SCny.DARK_PURPLE),
    [(0, $7SCny.AGILE_COLOR_9)]: (0, $7SCny.ORANGE),
    [(0, $7SCny.AGILE_COLOR_10)]: (0, $7SCny.BLUE),
    [(0, $7SCny.AGILE_COLOR_11)]: (0, $7SCny.TEAL),
    [(0, $7SCny.AGILE_COLOR_12)]: (0, $7SCny.GREY),
    [(0, $7SCny.AGILE_COLOR_13)]: (0, $7SCny.DARK_GREEN),
    [(0, $7SCny.AGILE_COLOR_14)]: (0, $7SCny.DARK_ORANGE)
};
const $3a4ee6f2b0ce40ab$export$db17671bf37971e7 = (0, (/*@__PURE__*/$parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$994d3ffa39be04fd);
const $3a4ee6f2b0ce40ab$export$1fdd5a248b5f697c = {
    [(0, $7SCny.GHX_LABEL_1)]: (0, $7SCny.AGILE_COLOR_1),
    [(0, $7SCny.GHX_LABEL_2)]: (0, $7SCny.AGILE_COLOR_2),
    [(0, $7SCny.GHX_LABEL_3)]: (0, $7SCny.AGILE_COLOR_3),
    [(0, $7SCny.GHX_LABEL_4)]: (0, $7SCny.AGILE_COLOR_4),
    [(0, $7SCny.GHX_LABEL_5)]: (0, $7SCny.AGILE_COLOR_5),
    [(0, $7SCny.GHX_LABEL_6)]: (0, $7SCny.AGILE_COLOR_6),
    [(0, $7SCny.GHX_LABEL_7)]: (0, $7SCny.AGILE_COLOR_7),
    [(0, $7SCny.GHX_LABEL_8)]: (0, $7SCny.AGILE_COLOR_8),
    [(0, $7SCny.GHX_LABEL_9)]: (0, $7SCny.AGILE_COLOR_9),
    [(0, $7SCny.GHX_LABEL_10)]: (0, $7SCny.AGILE_COLOR_10),
    [(0, $7SCny.GHX_LABEL_11)]: (0, $7SCny.AGILE_COLOR_11),
    [(0, $7SCny.GHX_LABEL_12)]: (0, $7SCny.AGILE_COLOR_12),
    [(0, $7SCny.GHX_LABEL_13)]: (0, $7SCny.AGILE_COLOR_13),
    [(0, $7SCny.GHX_LABEL_14)]: (0, $7SCny.AGILE_COLOR_14)
};
const $3a4ee6f2b0ce40ab$export$82fc3b0b98905453 = {
    [(0, $7SCny.DARK_GREY)]: 'grey',
    [(0, $7SCny.DARK_YELLOW)]: 'yellow',
    [(0, $7SCny.YELLOW)]: 'yellowLight',
    [(0, $7SCny.DARK_BLUE)]: 'blue',
    [(0, $7SCny.DARK_TEAL)]: 'teal',
    [(0, $7SCny.GREEN)]: 'greenLight',
    [(0, $7SCny.PURPLE)]: 'purpleLight',
    [(0, $7SCny.DARK_PURPLE)]: 'purple',
    [(0, $7SCny.ORANGE)]: 'redLight',
    [(0, $7SCny.BLUE)]: 'blueLight',
    [(0, $7SCny.TEAL)]: 'tealLight',
    [(0, $7SCny.GREY)]: 'greyLight',
    [(0, $7SCny.DARK_GREEN)]: 'green',
    [(0, $7SCny.DARK_ORANGE)]: 'red'
};
const $3a4ee6f2b0ce40ab$export$703aca53c431bb88 = {
    [(0, $7SCny.AGILE_COLOR_1)]: 'grey',
    [(0, $7SCny.AGILE_COLOR_2)]: 'yellow',
    [(0, $7SCny.AGILE_COLOR_3)]: 'yellowLight',
    [(0, $7SCny.AGILE_COLOR_4)]: 'blue',
    [(0, $7SCny.AGILE_COLOR_5)]: 'teal',
    [(0, $7SCny.AGILE_COLOR_6)]: 'greenLight',
    [(0, $7SCny.AGILE_COLOR_7)]: 'purpleLight',
    [(0, $7SCny.AGILE_COLOR_8)]: 'purple',
    [(0, $7SCny.AGILE_COLOR_9)]: 'redLight',
    [(0, $7SCny.AGILE_COLOR_10)]: 'blueLight',
    [(0, $7SCny.AGILE_COLOR_11)]: 'tealLight',
    [(0, $7SCny.AGILE_COLOR_12)]: 'greyLight',
    [(0, $7SCny.AGILE_COLOR_13)]: 'green',
    [(0, $7SCny.AGILE_COLOR_14)]: 'red'
};
const $3a4ee6f2b0ce40ab$export$92b6aebfb522f0d9 = {
    [(0, $7SCny.PURPLE)]: {
        primary: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
        secondary: "var(--ds-background-accent-purple-bolder, #6E5DC6)",
        text: "var(--ds-text-accent-purple, #5E4DB2)",
        textBackground: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
        border: "var(--ds-border-accent-purple, #8270DB)",
        line: "var(--ds-border-accent-purple, #8270DB)",
        primaryGradient: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
        hasContrastSecondaryGradient: true
    },
    [(0, $7SCny.BLUE)]: {
        primary: "var(--ds-background-accent-blue-subtle, #579DFF)",
        secondary: "var(--ds-background-accent-blue-bolder, #0C66E4)",
        text: "var(--ds-text-accent-blue, #0055CC)",
        textBackground: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
        border: "var(--ds-border-accent-blue, #1D7AFC)",
        line: "var(--ds-border-accent-blue, #1D7AFC)",
        primaryGradient: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
        hasContrastSecondaryGradient: true
    },
    [(0, $7SCny.GREEN)]: {
        primary: "var(--ds-background-accent-green-subtle, #4BCE97)",
        secondary: "var(--ds-background-accent-green-bolder, #1F845A)",
        text: "var(--ds-text-accent-green, #216E4E)",
        textBackground: "var(--ds-background-accent-green-subtler, #BAF3DB)",
        border: "var(--ds-border-accent-green, #22A06B)",
        line: "var(--ds-border-accent-green, #22A06B)",
        primaryGradient: "var(--ds-background-accent-green-subtler, #BAF3DB)",
        hasContrastSecondaryGradient: true
    },
    [(0, $7SCny.TEAL)]: {
        primary: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
        secondary: "var(--ds-background-accent-teal-bolder, #227D9B)",
        text: "var(--ds-text-accent-teal, #206A83)",
        textBackground: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        border: "var(--ds-border-accent-teal, #2898BD)",
        line: "var(--ds-border-accent-teal, #2898BD)",
        primaryGradient: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        hasContrastSecondaryGradient: true
    },
    [(0, $7SCny.YELLOW)]: {
        primary: "var(--ds-background-accent-yellow-subtle, #F5CD47)",
        secondary: "var(--ds-background-accent-yellow-bolder, #946F00)",
        text: "var(--ds-text-accent-yellow, #7F5F01)",
        textBackground: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
        border: "var(--ds-border-accent-yellow, #B38600)",
        line: "var(--ds-border-accent-yellow, #B38600)",
        primaryGradient: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
        hasContrastSecondaryGradient: true
    },
    [(0, $7SCny.ORANGE)]: {
        primary: "var(--ds-background-accent-red-subtle, #F87168)",
        secondary: "var(--ds-background-accent-red-bolder, #C9372C)",
        text: "var(--ds-text-accent-red, #AE2E24)",
        textBackground: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        border: "var(--ds-border-accent-red, #E2483D)",
        line: "var(--ds-border-accent-red, #E2483D)",
        primaryGradient: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        hasContrastSecondaryGradient: true
    },
    [(0, $7SCny.GREY)]: {
        primary: "var(--ds-background-accent-gray-subtle, #8590A2)",
        secondary: "var(--ds-background-accent-gray-bolder, #626F86)",
        text: "var(--ds-text-accent-gray, #44546F)",
        textBackground: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        border: "var(--ds-border-accent-gray, #758195)",
        line: "var(--ds-border-accent-gray, #758195)",
        primaryGradient: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        hasContrastSecondaryGradient: true
    },
    [(0, $7SCny.DARK_PURPLE)]: {
        primary: "var(--ds-background-accent-purple-bolder, #6E5DC6)",
        secondary: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-purple-bolder, #6E5DC6)",
        border: "var(--ds-border-accent-purple, #8270DB)",
        line: "var(--ds-border-accent-purple, #8270DB)",
        primaryGradient: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
        hasContrastSecondaryGradient: false
    },
    [(0, $7SCny.DARK_BLUE)]: {
        primary: "var(--ds-background-accent-blue-bolder, #0C66E4)",
        secondary: "var(--ds-background-accent-blue-subtle, #579DFF)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-blue-bolder, #0C66E4)",
        border: "var(--ds-border-accent-blue, #1D7AFC)",
        line: "var(--ds-border-accent-blue, #1D7AFC)",
        primaryGradient: "var(--ds-background-accent-blue-subtle, #579DFF)",
        hasContrastSecondaryGradient: false
    },
    [(0, $7SCny.DARK_GREEN)]: {
        primary: "var(--ds-background-accent-green-bolder, #1F845A)",
        secondary: "var(--ds-background-accent-green-subtle, #4BCE97)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-green-bolder, #1F845A)",
        border: "var(--ds-border-accent-green, #22A06B)",
        line: "var(--ds-border-accent-green, #22A06B)",
        primaryGradient: "var(--ds-background-accent-green-subtle, #4BCE97)",
        hasContrastSecondaryGradient: false
    },
    [(0, $7SCny.DARK_TEAL)]: {
        primary: "var(--ds-background-accent-teal-bolder, #227D9B)",
        secondary: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-teal-bolder, #227D9B)",
        border: "var(--ds-border-accent-teal, #2898BD)",
        line: "var(--ds-border-accent-teal, #2898BD)",
        primaryGradient: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
        hasContrastSecondaryGradient: false
    },
    [(0, $7SCny.DARK_YELLOW)]: {
        primary: "var(--ds-background-accent-orange-bolder, #C25100)",
        secondary: "var(--ds-background-accent-orange-subtle, #FEA362)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-orange-bolder, #C25100)",
        border: "var(--ds-background-accent-orange-subtle, #FEA362)",
        line: "var(--ds-border-accent-orange, #E56910)",
        primaryGradient: "var(--ds-background-accent-orange-subtle, #FEA362)",
        hasContrastSecondaryGradient: false
    },
    [(0, $7SCny.DARK_ORANGE)]: {
        primary: "var(--ds-background-accent-red-bolder, #C9372C)",
        secondary: "var(--ds-background-accent-red-subtle, #F87168)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-red-bolder, #C9372C)",
        border: "var(--ds-background-accent-red-subtle, #F87168)",
        line: "var(--ds-border-accent-red, #E2483D)",
        primaryGradient: "var(--ds-background-accent-red-subtle, #F87168)",
        hasContrastSecondaryGradient: false
    },
    [(0, $7SCny.DARK_GREY)]: {
        primary: "var(--ds-background-accent-gray-bolder, #626F86)",
        secondary: "var(--ds-background-accent-gray-subtle, #8590A2)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-gray-bolder, #626F86)",
        border: "var(--ds-background-accent-gray-subtle, #8590A2)",
        line: "var(--ds-border-accent-gray, #758195)",
        primaryGradient: "var(--ds-background-accent-gray-subtle, #8590A2)",
        hasContrastSecondaryGradient: false
    }
};

});

parcelRegister("iHPnC", function(module, exports) {

$parcel$export(module.exports, "asColor", () => $e626bf77f0e696c5$export$b74af6529f09947);
$parcel$export(module.exports, "asServerColor", () => $e626bf77f0e696c5$export$442690a499ee9598);
$parcel$export(module.exports, "asClassicEpicColor", () => $e626bf77f0e696c5$export$eb754032c0b9698c);
$parcel$export(module.exports, "transformColorToTheme", () => $e626bf77f0e696c5$export$37c9bd72afe7f286);
$parcel$export(module.exports, "getValueFromColor", () => $e626bf77f0e696c5$export$a00423580059ae28);
$parcel$export(module.exports, "getColorFromValue", () => $e626bf77f0e696c5$export$6d14528e40cbe34b);
$parcel$export(module.exports, "toFrontendColor", () => $e626bf77f0e696c5$export$574e4dbf3c01f0ad);
$parcel$export(module.exports, "toBackendColor", () => $e626bf77f0e696c5$export$47af25386a01de1);
$parcel$export(module.exports, "classicToFrontendColor", () => $e626bf77f0e696c5$export$8f81207f7ac5fb9a);
$parcel$export(module.exports, "classicToBackendColor", () => $e626bf77f0e696c5$export$28fb68bb1de025d5);
$parcel$export(module.exports, "getDefaultColorPalette", () => $e626bf77f0e696c5$export$f6e067d5c418081a);
$parcel$export(module.exports, "getLozengeThemeByColor", () => $e626bf77f0e696c5$export$949dc67535a8ff2);
$parcel$export(module.exports, "getRandomColor", () => $e626bf77f0e696c5$export$e4369cabd7e84cd9);

var $ggSx2 = parcelRequire("ggSx2");

var $7SCny = parcelRequire("7SCny");

var $heWHN = parcelRequire("heWHN");

var $ehxiD = parcelRequire("ehxiD");
const $e626bf77f0e696c5$export$b74af6529f09947 = (color)=>{
    if (color == null) return (0, $7SCny.Colors).PURPLE;
    if (color in (0, $7SCny.Colors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $heWHN.MAP_FROM_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_SERVER_COLOR)[color];
    if (color in (0, $heWHN.MAP_FROM_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_AGILE_COLOR)[color];
    if (color in (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)[color];
    return (0, $7SCny.Colors).PURPLE;
};
const $e626bf77f0e696c5$export$442690a499ee9598 = (color)=>{
    if (color == null) return (0, $7SCny.ServerColors).SERVER_PURPLE;
    if (color in (0, $7SCny.ServerColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)[color];
    if (color in (0, $heWHN.MAP_FROM_AGILE_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_AGILE_COLOR)[color] in (0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)[(0, $heWHN.MAP_FROM_AGILE_COLOR)[color]];
    if (color in (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)) return (0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
    return (0, $7SCny.ServerColors).SERVER_PURPLE;
};
const $e626bf77f0e696c5$export$eb754032c0b9698c = (color)=>{
    if (color === null) return (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $7SCny.Colors).PURPLE];
    if (color in (0, $7SCny.ClassicEpicColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
    if (color in (0, $heWHN.MAP_FROM_SERVER_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_COLOR)[color] in (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $heWHN.MAP_FROM_SERVER_COLOR)[color]];
    if (color in (0, $heWHN.MAP_FROM_AGILE_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_AGILE_COLOR)[color] in (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $heWHN.MAP_FROM_AGILE_COLOR)[color]];
    // i.e: ghx-label-7
    return (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $7SCny.Colors).PURPLE];
};
const $e626bf77f0e696c5$export$1a0a4af71e00cea4 = (color)=>{
    if (color === null) return (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $7SCny.Colors).PURPLE];
    if (color in (0, $7SCny.AgileColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)[color];
    if (color in (0, $heWHN.MAP_FROM_SERVER_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_COLOR)[color] in (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $heWHN.MAP_FROM_SERVER_COLOR)[color]];
    if (color in (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)) return (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
    // i.e: color_7
    return (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $7SCny.Colors).PURPLE];
};
const $e626bf77f0e696c5$export$37c9bd72afe7f286 = (transformation, colorSchemaExtension)=>{
    const newColorSchema = {
        ...(0, $heWHN.BASE_COLOR_SCHEMA),
        ...colorSchemaExtension
    };
    const extendedColors = (colorSchemaExtension ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.keys(colorSchemaExtension) : []).concat(Object.keys((0, $7SCny.Colors)));
    return extendedColors.reduce((obj, color)=>Object.assign(obj, {
            [color]: transformation(newColorSchema[color])
        }), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {});
};
const $e626bf77f0e696c5$export$a00423580059ae28 = (color)=>(0, $heWHN.MAP_COLORS_TO_VALUE)[color] || (0, $heWHN.MAP_COLORS_TO_VALUE)[0, $7SCny.PURPLE];
const $e626bf77f0e696c5$export$6d14528e40cbe34b = (value)=>// NOTE: lodash invert coerce the output to Dictionary<string> instead of using a polymorphic type
    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'Color'.
    (0, (/*@__PURE__*/$parcel$interopDefault($ggSx2)))((0, $heWHN.MAP_COLORS_TO_VALUE))[value] || (0, $7SCny.PURPLE);
const $e626bf77f0e696c5$export$574e4dbf3c01f0ad = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, $heWHN.MAP_FROM_SERVER_COLOR) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_COLOR)[colorStr] : (0, $7SCny.PURPLE);
const $e626bf77f0e696c5$export$47af25386a01de1 = (color)=>(0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)[color];
const $e626bf77f0e696c5$export$8f81207f7ac5fb9a = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)[colorStr] : (0, $7SCny.PURPLE);
const $e626bf77f0e696c5$export$28fb68bb1de025d5 = (color)=>(0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
/**
 * Return default color palette
 */ const $e626bf77f0e696c5$var$paletteColorValues = $e626bf77f0e696c5$export$37c9bd72afe7f286((colorSchema)=>colorSchema.primary);
const $e626bf77f0e696c5$export$f6e067d5c418081a = (formatMessage)=>[
        {
            label: formatMessage((0, $ehxiD.default).purpleLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).PURPLE]
        },
        {
            label: formatMessage((0, $ehxiD.default).blueLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).BLUE]
        },
        {
            label: formatMessage((0, $ehxiD.default).greenLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).GREEN]
        },
        {
            label: formatMessage((0, $ehxiD.default).tealLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).TEAL]
        },
        {
            label: formatMessage((0, $ehxiD.default).yellowLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).YELLOW]
        },
        {
            label: formatMessage((0, $ehxiD.default).orangeLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).ORANGE]
        },
        {
            label: formatMessage((0, $ehxiD.default).greyLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).GREY]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkPurpleLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).DARK_PURPLE]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkBlueLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).DARK_BLUE]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkGreenLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).DARK_GREEN]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkTealLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).DARK_TEAL]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkYellowLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).DARK_YELLOW]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkOrangeLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).DARK_ORANGE]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkGreyLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).DARK_GREY]
        }
    ];
const $e626bf77f0e696c5$export$9b822862d986dfdf = $e626bf77f0e696c5$export$37c9bd72afe7f286((colorSchema)=>({
        color: colorSchema.text,
        backgroundColor: colorSchema.textBackground
    }));
const $e626bf77f0e696c5$export$949dc67535a8ff2 = (color = (0, $heWHN.DEFAULT_EPIC_COLOR))=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $e626bf77f0e696c5$export$9b822862d986dfdf[color] ?? $e626bf77f0e696c5$export$9b822862d986dfdf[0, $heWHN.DEFAULT_EPIC_COLOR];
const $e626bf77f0e696c5$export$e4369cabd7e84cd9 = ()=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const colorKeys = Object.keys((0, $7SCny.Colors));
    return colorKeys[Math.floor(Math.random() * colorKeys.length)];
};

});
parcelRegister("ehxiD", function(module, exports) {

$parcel$export(module.exports, "default", () => $50b7e3d933c7b9f7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $50b7e3d933c7b9f7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    purpleLabel: {
        "id": "issue-epic-color.common.purple-label",
        "defaultMessage": "purple"
    },
    blueLabel: {
        "id": "issue-epic-color.common.blue-label",
        "defaultMessage": "blue"
    },
    greenLabel: {
        "id": "issue-epic-color.common.green-label",
        "defaultMessage": "green"
    },
    tealLabel: {
        "id": "issue-epic-color.common.teal-label",
        "defaultMessage": "teal"
    },
    yellowLabel: {
        "id": "issue-epic-color.common.yellow-label",
        "defaultMessage": "yellow"
    },
    orangeLabel: {
        "id": "issue-epic-color.common.orange-label",
        "defaultMessage": "orange"
    },
    greyLabel: {
        "id": "issue-epic-color.common.grey-label",
        "defaultMessage": "grey"
    },
    darkPurpleLabel: {
        "id": "issue-epic-color.common.dark-purple-label",
        "defaultMessage": "dark purple"
    },
    darkBlueLabel: {
        "id": "issue-epic-color.common.dark-blue-label",
        "defaultMessage": "dark blue"
    },
    darkGreenLabel: {
        "id": "issue-epic-color.common.dark-green-label",
        "defaultMessage": "dark green"
    },
    darkTealLabel: {
        "id": "issue-epic-color.common.dark-teal-label",
        "defaultMessage": "dark teal"
    },
    darkYellowLabel: {
        "id": "issue-epic-color.common.dark-yellow-label",
        "defaultMessage": "dark yellow"
    },
    darkOrangeLabel: {
        "id": "issue-epic-color.common.dark-orange-label",
        "defaultMessage": "dark orange"
    },
    darkGreyLabel: {
        "id": "issue-epic-color.common.dark-grey-label",
        "defaultMessage": "dark grey"
    }
});

});



parcelRegister("8KNKh", function(module, exports) {

$parcel$export(module.exports, "default", () => $63688812b02739a0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $63688812b02739a0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    parentTitle: {
        "id": "issue-field-parent.parent-title",
        "defaultMessage": "Click to visit {label}"
    },
    icon: {
        "id": "issue-field-parent.icon",
        "defaultMessage": "{issueType} icon"
    },
    noValueTextExperiment: {
        "id": "issue-field-parent.no-value-text-experiment",
        "defaultMessage": "Add parent"
    }
});

});




parcelRegister("8egWI", function(module, exports) {

$parcel$export(module.exports, "projectCellHandler", () => $45583a47da1accfa$export$ae050ab68eec4031);

var $5uXOq = parcelRequire("5uXOq");

var $crLaw = parcelRequire("crLaw");

var $5fc53 = parcelRequire("5fc53");

var $b5lmY = parcelRequire("b5lmY");

var $7ry80 = parcelRequire("7ry80");

var $2I8hn = parcelRequire("2I8hn");
const $45583a47da1accfa$export$a0acc7707bde1d3 = ({ rowData: issue, cellData: field, column: { width: preferredWidth }, editMode: editMode, setEditMode: setEditMode, cellRef: cellRef })=>{
    const [project, setProject] = (0, $5uXOq.useState)(field?.value);
    const [{ value: value }] = (0, $crLaw.useProjectField)({
        issueKey: issue.key,
        fieldKey: field?.fieldId || '',
        initialValue: field?.value
    });
    if (value !== project) setProject(value);
    if (field == null) return null;
    const readContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2I8hn.ProjectRead), {
        project: project
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b5lmY.CellWrapper), {
        isEditable: true,
        hasPadding: false,
        testId: "business-fields.ui.project.cell.cell-wrapper"
    }, editMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ry80.ProjectEdit), {
        issueKey: issue.key,
        fieldKey: field.fieldId,
        option: project,
        onChange: setProject,
        setEditMode: setEditMode,
        readContent: readContent,
        preferredWidth: preferredWidth,
        cellRef: cellRef
    }) : readContent);
};
const $45583a47da1accfa$export$ae050ab68eec4031 = {
    [(0, $5fc53.PROJECT_PICKER_CF_TYPE)]: $45583a47da1accfa$export$a0acc7707bde1d3
};

});
parcelRegister("7ry80", function(module, exports) {

$parcel$export(module.exports, "ProjectEdit", () => $7975949636177568$export$847a1c7fcc9fac3d);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $8dqjY = parcelRequire("8dqjY");
const $7975949636177568$export$847a1c7fcc9fac3d = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $8dqjY.projectEditEntryPoint), {});
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jwm.business.fields.project.edit",
        packageName: "jiraBusinessFields",
        runtimeProps: props,
        fallback: props.readContent
    });
};

});
parcelRegister("8dqjY", function(module, exports) {

$parcel$export(module.exports, "projectEditEntryPoint", () => $635f5330de127ee9$export$a995c657f37f351f);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $635f5330de127ee9$export$a995c657f37f351f = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("5Miyk")), {
        moduleId: "934d87d1"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("5Miyk", function(module, exports) {

let $434fd39c0873ce00$var$load = (parcelRequire("28QjX"))(4);
module.exports = $434fd39c0873ce00$var$load("jFeGq").then(()=>parcelRequire('l7zSa'));

});



parcelRegister("2I8hn", function(module, exports) {

$parcel$export(module.exports, "ProjectRead", () => $d78a6889e5251e69$export$c2b863d8638c3f33);

var $5uXOq = parcelRequire("5uXOq");

var $20ivj = parcelRequire("20ivj");
const $d78a6889e5251e69$export$c2b863d8638c3f33 = ({ project: project })=>project ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $20ivj.ProjectReadView), {
        value: project
    }) : null;

});
parcelRegister("20ivj", function(module, exports) {

$parcel$export(module.exports, "ProjectReadView", () => $8724762dba6fa853$export$5c3359f22f4596bc);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ujWmd = parcelRequire("ujWmd");

var $jhmo0 = parcelRequire("jhmo0");
var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $8724762dba6fa853$export$5c3359f22f4596bc = ({ value: value, noValueText: noValueText, onClick: onClick, isTruncated: isTruncated = true, contentRef: contentRef })=>{
    const onClickLink = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
    (e)=>{
        e.stopPropagation();
        onClick && onClick(e);
    }, [
        onClick
    ]);
    if (value === undefined || value === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $8724762dba6fa853$var$emptyValueContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8724762dba6fa853$var$EmptyValue, {
        "data-testid": "issue-field-project.ui.view-read-view-empty-value"
    }, noValueText || ''));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const stopPropagation = (e)=>{
        e.stopPropagation();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8724762dba6fa853$var$ReadViewContainer, {
        "data-component-selector": "project-read-view-container"
    }, Boolean(value.avatarUrls['48x48']) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8724762dba6fa853$var$AvatarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        appearance: "square",
        size: "xsmall",
        src: value.avatarUrls['48x48'],
        borderColor: "transparent",
        testId: "issue-field-project.ui.project-avatar"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $8724762dba6fa853$var$labelContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jhmo0.default), {
        testId: "issue-field-project.ui.view-label-link",
        onClick: onClickLink,
        onKeyUp: stopPropagation,
        onKeyDown: stopPropagation,
        href: `/projects/${value.key}`,
        xcss: [
            $8724762dba6fa853$var$labelLinkStylesBase,
            isTruncated ? $8724762dba6fa853$var$labelLinkStylesTruncated : $8724762dba6fa853$var$labelLinkStylesNonTruncated
        ],
        ref: contentRef
    }, value.name)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8724762dba6fa853$var$EmptyValue = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz131l",
            __cmplp.className
        ])
    });
});
const $8724762dba6fa853$var$ReadViewContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _1e0c1txw _4cvr1h6o _p12fuuw1 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
            __cmplp.className
        ])
    });
});
const $8724762dba6fa853$var$emptyValueContainerStyles = (0, $8CUq3.xcss)({
    paddingLeft: 'space.075',
    paddingRight: 'space.075'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8724762dba6fa853$var$AvatarWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2hwxu2gc _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $8724762dba6fa853$var$labelContainerStyles = (0, $8CUq3.xcss)({
    display: 'inline-flex',
    minWidth: '0',
    marginRight: 'space.100'
});
const $8724762dba6fa853$var$labelLinkStylesBase = (0, $8CUq3.xcss)({
    display: 'inline-block',
    maxWidth: '100%',
    textDecoration: 'none',
    ':hover': {
        textDecoration: 'underline'
    }
});
const $8724762dba6fa853$var$labelLinkStylesTruncated = (0, $8CUq3.xcss)({
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
const $8724762dba6fa853$var$labelLinkStylesNonTruncated = (0, $8CUq3.xcss)({
    overflowWrap: 'anywhere'
});

});



parcelRegister("c2t1Z", function(module, exports) {

$parcel$export(module.exports, "radioSelectCellHandler", () => $eff2712f4a54ccf5$export$cf09278854214c31);

var $5uXOq = parcelRequire("5uXOq");

var $cSD7y = parcelRequire("cSD7y");

var $koVbs = parcelRequire("koVbs");

var $9sUAX = parcelRequire("9sUAX");

var $aSk8p = parcelRequire("aSk8p");

var $5fc53 = parcelRequire("5fc53");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $b5lmY = parcelRequire("b5lmY");

var $btDbz = parcelRequire("btDbz");

var $2VWmE = parcelRequire("2VWmE");

var $4cSsp = parcelRequire("4cSsp");
const $eff2712f4a54ccf5$var$transformToOption = (option)=>{
    if (!option) return null;
    const { id: id, value: value } = option;
    return {
        value: id,
        label: value
    };
};
const $eff2712f4a54ccf5$var$RadioSelectOld = ({ rowData: issue, cellData: field, column: { width: preferredWidth }, editMode: editMode, setEditMode: setEditMode })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const handleFailure = (0, $5uXOq.useCallback)((err)=>{
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'field updateFailed', 'radioSelectIssueField', {
            error: err
        });
    }, [
        createAnalyticsEvent
    ]);
    const [{ value: customFieldValue, options: radioOptions }, { saveValue: saveValue }] = (0, $9sUAX.useRadioSelectCustomField)({
        issueKey: issue.key,
        fieldKey: field?.fieldId || '',
        initialValue: field?.value ?? null,
        onFailure: handleFailure
    });
    const option = $eff2712f4a54ccf5$var$transformToOption(customFieldValue);
    const emptyOption = (0, $5uXOq.useMemo)(()=>({
            label: formatMessage((0, $2VWmE.default).noValue),
            value: ''
        }), [
        formatMessage
    ]);
    /**
   * Options supplied to the RadioSelect component. An empty option may be present to allow
   * for deselection.
   */ const options = (0, $5uXOq.useMemo)(()=>{
        const result = (0, $aSk8p.mapDataToOptions)(radioOptions);
        // TODO: When we get around to supporting isRequired, we need to omit the emptyOption
        if (option) result.unshift(emptyOption);
        return result;
    }, [
        option,
        emptyOption,
        radioOptions
    ]);
    /**
   * Given the new selected option, save and move back to read only mode.
   */ const handleChange = (0, $5uXOq.useCallback)((newValue)=>{
        const newOption = newValue?.value ? newValue : null;
        const transformForSave = (0, $aSk8p.mapOptionToData)({
            value: newOption?.value ?? '',
            label: newOption?.label ?? ''
        });
        saveValue(transformForSave, null, createAnalyticsEvent({}));
        setEditMode(false);
    }, [
        saveValue,
        createAnalyticsEvent,
        setEditMode
    ]);
    const isEditable = (0, $5uXOq.useMemo)(()=>issue.fieldConfig?.isEditable || false, [
        issue.fieldConfig?.isEditable
    ]);
    if (field == null) return null;
    const placeholder = formatMessage((0, $2VWmE.default).placeholder, {
        fieldName: field.name
    });
    const label = formatMessage((0, $2VWmE.default).label, {
        fieldName: field.name
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b5lmY.CellWrapper), {
        isEditable: isEditable,
        hasPadding: false,
        testId: "business-fields.ui.radio-select.cell.cell-wrapper"
    }, editMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $btDbz.RadioSelectEdit), {
        fieldId: field.id,
        fieldKey: field.fieldId,
        fieldName: field.name,
        label: label,
        placeholder: placeholder,
        option: option,
        options: options,
        readContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4cSsp.RadioSelectRead), null, option?.label ?? ''),
        preferredWidth: preferredWidth,
        onChange: handleChange,
        setEditMode: setEditMode
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4cSsp.RadioSelectRead), null, option?.label ?? ''));
};
const $eff2712f4a54ccf5$var$RadioSelectWithRelay = ({ rowData: issue, cellData: field, column: { width: preferredWidth }, editMode: editMode, cellRef: cellRef, setEditMode: setEditMode, wrapperRef: wrapperRef })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const handleFailure = (0, $5uXOq.useCallback)((err)=>{
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'field updateFailed', 'radioSelectIssueField', {
            error: err
        });
    }, [
        createAnalyticsEvent
    ]);
    const [{ value: value }, { saveValue: saveValue }] = (0, $9sUAX.useRadioSelectCustomField)({
        issueKey: issue.key,
        fieldKey: field?.fieldId || '',
        initialValue: field?.value ?? null,
        onFailure: handleFailure
    });
    const option = $eff2712f4a54ccf5$var$transformToOption(value);
    /**
   * Given the new selected option, save and move back to read only mode.
   */ const handleChange = (0, $5uXOq.useCallback)((newValue)=>{
        const transformForSave = newValue ? (0, $aSk8p.mapOptionToData)({
            label: newValue.label,
            value: newValue.value
        }) : null;
        if (transformForSave?.id !== option?.value) saveValue(transformForSave, null, createAnalyticsEvent({}));
        setEditMode(false);
    }, [
        option,
        saveValue,
        createAnalyticsEvent,
        setEditMode
    ]);
    const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
        if (event.key === 'Delete' || event.key === 'Backspace') wrapperRef && setTimeout(()=>{
            wrapperRef?.current?.focus();
        });
        return false;
    }, [
        wrapperRef
    ]);
    const cellOverrides = (0, $5uXOq.useCallback)(()=>({
            onKeyDown: handleKeyDown
        }), [
        handleKeyDown
    ]);
    (0, $5uXOq.useImperativeHandle)(cellRef, cellOverrides, [
        cellOverrides
    ]);
    const isEditable = (0, $5uXOq.useMemo)(()=>issue.fieldConfig?.isEditable || false, [
        issue.fieldConfig?.isEditable
    ]);
    if (field == null) return null;
    const label = formatMessage((0, $2VWmE.default).label, {
        fieldName: field.name
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b5lmY.CellWrapper), {
        isEditable: isEditable,
        hasPadding: false,
        testId: "business-fields.ui.radio-select.cell.cell-wrapper"
    }, editMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $btDbz.RadioSelectEdit), {
        fieldId: field.id,
        fieldKey: field.fieldId,
        fieldName: field.name,
        label: label,
        option: option,
        readContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4cSsp.RadioSelectRead), null, option?.label ?? ''),
        preferredWidth: preferredWidth,
        onChange: handleChange,
        setEditMode: setEditMode
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4cSsp.RadioSelectRead), null, option?.label ?? ''));
};
const $eff2712f4a54ccf5$export$b6b4cb8dcfd6af64 = (0, $cSD7y.componentWithFG)('jira-list-view-radio-cell-relay-edit-view', $eff2712f4a54ccf5$var$RadioSelectWithRelay, $eff2712f4a54ccf5$var$RadioSelectOld);
const $eff2712f4a54ccf5$export$cf09278854214c31 = {
    [(0, $5fc53.RADIO_BUTTONS_CF_TYPE)]: $eff2712f4a54ccf5$export$b6b4cb8dcfd6af64
};

});
parcelRegister("aSk8p", function(module, exports) {

$parcel$export(module.exports, "mapDataToOptions", () => $08634f5a5ba1d218$export$99a866ffa3af7d8b);
$parcel$export(module.exports, "mapOptionToData", () => $08634f5a5ba1d218$export$fc800909123977f3);
const $08634f5a5ba1d218$export$99a866ffa3af7d8b = (data)=>data.map(({ id: id, value: value })=>({
            label: value,
            value: id
        }));
const $08634f5a5ba1d218$export$fc800909123977f3 = ({ label: label, value: value })=>({
        id: value,
        value: label
    });

});

parcelRegister("btDbz", function(module, exports) {

$parcel$export(module.exports, "RadioSelectEdit", () => $a8701065c7d51775$export$7f25860f9e4ad119);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $9ibIo = parcelRequire("9ibIo");
const $a8701065c7d51775$var$entryPointParams = {};
const $a8701065c7d51775$export$7f25860f9e4ad119 = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $9ibIo.radioSelectEntryPoint), $a8701065c7d51775$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jwm.business.fields.radio-select.edit",
        packageName: "jiraBusinessFields",
        runtimeProps: props,
        fallback: props.readContent
    });
};

});
parcelRegister("9ibIo", function(module, exports) {

$parcel$export(module.exports, "radioSelectEntryPoint", () => $40269a041ca57c58$export$ec67c8b087cb34f);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $40269a041ca57c58$export$ec67c8b087cb34f = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("7Pdw7")), {
        moduleId: "ff25c236"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("7Pdw7", function(module, exports) {

let $5b27c80731e809ba$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5b27c80731e809ba$var$load("kwNJW").then(()=>parcelRequire('jGw9Z'));

});



parcelRegister("2VWmE", function(module, exports) {

$parcel$export(module.exports, "default", () => $e41ec29dcf651d45$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e41ec29dcf651d45$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noValue: {
        "id": "business-fields.radio-select.cell.no-value",
        "defaultMessage": "None"
    },
    placeholder: {
        "id": "business-fields.radio-select.cell.placeholder",
        "defaultMessage": "Select { fieldName }"
    },
    label: {
        "id": "business-fields.radio-select.cell.label",
        "defaultMessage": "{ fieldName }"
    }
});

});

parcelRegister("4cSsp", function(module, exports) {

$parcel$export(module.exports, "RadioSelectRead", () => $c70baf2fa049d53c$export$51198f70a0069b1e);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $b5lmY = parcelRequire("b5lmY");
const $c70baf2fa049d53c$export$51198f70a0069b1e = ({ children: children })=>{
    if (!children) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b5lmY.WrapperCommon), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $c70baf2fa049d53c$var$optionWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $c70baf2fa049d53c$var$optionTextStyles
    }, children)));
};
const $c70baf2fa049d53c$var$optionWrapperStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    padding: 'space.075'
});
// TODO: replace with Text component from atlaskit when out of beta
const $c70baf2fa049d53c$var$optionTextStyles = (0, $8CUq3.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});

});


parcelRegister("kpiLK", function(module, exports) {

$parcel$export(module.exports, "resolutionCellHandler", () => $9795b82c42e160a8$export$9762e1de55e8d420);

var $5uXOq = parcelRequire("5uXOq");

var $5fc53 = parcelRequire("5fc53");

var $b5lmY = parcelRequire("b5lmY");

var $1l3QS = parcelRequire("1l3QS");
const $9795b82c42e160a8$export$8b67413bfec99fe = ({ cellData: field })=>{
    const [resolution, setResolution] = (0, $5uXOq.useState)(field?.value || null);
    (0, $5uXOq.useEffect)(()=>{
        setResolution(field?.value || null);
    }, [
        field?.value
    ]);
    if (field == null) return null;
    const readContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1l3QS.ResolutionRead), {
        resolution: resolution
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b5lmY.CellWrapper), {
        isEditable: false,
        hasPadding: true
    }, readContent);
};
const $9795b82c42e160a8$export$9762e1de55e8d420 = {
    [(0, $5fc53.RESOLUTION_TYPE)]: $9795b82c42e160a8$export$8b67413bfec99fe
};

});
parcelRegister("1l3QS", function(module, exports) {

$parcel$export(module.exports, "ResolutionRead", () => $5014dda692555891$export$8741d57e18b24f9f);

var $5uXOq = parcelRequire("5uXOq");

var $03RlV = parcelRequire("03RlV");
const $5014dda692555891$export$8741d57e18b24f9f = ({ resolution: resolution })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $03RlV.ResolutionReadView), {
        value: resolution,
        isLabelClickEnabled: true,
        hideIcon: true
    });

});
parcelRegister("03RlV", function(module, exports) {

$parcel$export(module.exports, "ResolutionReadView", () => $4770b901e9bb750b$export$dfd4dfe034c38e3f);

var $5uXOq = parcelRequire("5uXOq");

var $47bDC = parcelRequire("47bDC");

var $ky7e4 = parcelRequire("ky7e4");

var $3bDjY = parcelRequire("3bDjY");

var $gwIPs = parcelRequire("gwIPs");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $4oAv9 = parcelRequire("4oAv9");
const $4770b901e9bb750b$export$dfd4dfe034c38e3f = ({ value: value, isLabelClickEnabled: isLabelClickEnabled, hideIcon: hideIcon = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const hasResolution = value;
    const resolutionName = value?.name || formatMessage((0, $4oAv9.default).unresolvedResolution);
    const icon = hasResolution && !hideIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ky7e4))), {
        LEGACY_size: "medium",
        spacing: "spacious",
        label: (0, $4R6GH.fg)('deployment_issue_sideview_icon_a11y') ? '' : resolutionName,
        testId: "issue-field-resolution.ui.read.check-icon",
        color: "var(--ds-icon-success, #22A06B)",
        "aria-hidden": !!(0, $4R6GH.fg)('deployment_issue_sideview_icon_a11y')
    }) : null;
    const renderResolutionLabel = (labelName)=>{
        const resolutionStatusLabel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4770b901e9bb750b$var$ResolutionStatusLabel, {
            "data-testid": "issue-field-resolution.ui.read.resolution-status-label",
            isDisabled: !isLabelClickEnabled,
            isDarkText: isLabelClickEnabled || !!hasResolution
        }, labelName);
        return !isLabelClickEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formatMessage((0, $4oAv9.default).readViewMessage),
            position: "top"
        }, resolutionStatusLabel) : resolutionStatusLabel;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4770b901e9bb750b$var$Container, {
        addPadding: !isLabelClickEnabled,
        "data-testid": "issue-field-resolution.ui.read.label"
    }, icon, renderResolutionLabel(resolutionName));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4770b901e9bb750b$var$Container = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-6kdpa7-0"
})(({ addPadding: addPadding })=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        padding: addPadding ? `0 ${(0, $gwIPs.gridSize) * 2}px 0 12px` : 0,
        display: 'flex',
        alignItems: 'center',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${(0, $gwIPs.gridSize) * 4}px`
    }));
const $4770b901e9bb750b$var$itemTruncateWidth = (0, $gwIPs.gridSize) * 25;
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4770b901e9bb750b$var$ResolutionStatusLabel = /*#__PURE__*/ (0, $47bDC.default).span.withConfig({
    componentId: "sc-6kdpa7-1"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: props.isDarkText ? "var(--ds-text-subtle, #44546F)" : "var(--ds-text-subtlest, #626F86)",
        display: 'block',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `${$4770b901e9bb750b$var$itemTruncateWidth}px`
    }), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.isDisabled ? ':hover { cursor: not-allowed; }' : '');

});
parcelRegister("ky7e4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4eca488eebd24f6b0c74ed2566069d9c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ef5c96854bbf6178$var$_react = $ef5c96854bbf6178$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ef5c96854bbf6178$var$_checkMark = $ef5c96854bbf6178$var$_interopRequireDefault((parcelRequire("bjo8S")));

var $ef5c96854bbf6178$var$_check = $ef5c96854bbf6178$var$_interopRequireDefault((parcelRequire("kbxJz")));
function $ef5c96854bbf6178$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "CheckIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ef5c96854bbf6178$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $ef5c96854bbf6178$var$_react.default.createElement($ef5c96854bbf6178$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $ef5c96854bbf6178$var$_check.default
    }, props));
$ef5c96854bbf6178$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $ef5c96854bbf6178$var$_default = module.exports.default = $ef5c96854bbf6178$var$CheckMarkIcon;

});
parcelRegister("kbxJz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eb1f0098e5a023eb$var$_react = $eb1f0098e5a023eb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $eb1f0098e5a023eb$var$_checkMark = $eb1f0098e5a023eb$var$_interopRequireDefault((parcelRequire("bjo8S")));
function $eb1f0098e5a023eb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $eb1f0098e5a023eb$var$CheckIcon = (props)=>/*#__PURE__*/ $eb1f0098e5a023eb$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.735 12.322a1 1 0 0 0-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2336 2336 0 0 0 3.939-3.883l.04-.04a493 493 0 0 0 3.658-3.643 1 1 0 0 0-1.424-1.404 518 518 0 0 1-3.64 3.625l-.04.04a2049 2049 0 0 1-3.775 3.722z"/></svg>`
    }, props, {
        newIcon: $eb1f0098e5a023eb$var$_checkMark.default
    }));
$eb1f0098e5a023eb$var$CheckIcon.displayName = 'CheckIcon';
var $eb1f0098e5a023eb$var$_default = module.exports.default = $eb1f0098e5a023eb$var$CheckIcon;

});


parcelRegister("4oAv9", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e635713c840273f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3e635713c840273f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    readViewMessage: {
        "id": "issue-field-resolution.read.read-view-message",
        "defaultMessage": "You cannot edit the resolution field"
    },
    unresolvedResolution: {
        "id": "issue-field-resolution.read.unresolved-resolution",
        "defaultMessage": "Unresolved"
    }
});

});




parcelRegister("1RGG5", function(module, exports) {

$parcel$export(module.exports, "statusCategoryCellHandler", () => $f94184594f4cccc9$export$1c03cc5b920eec85);

var $5uXOq = parcelRequire("5uXOq");

var $5fc53 = parcelRequire("5fc53");

var $b5lmY = parcelRequire("b5lmY");

var $8phy8 = parcelRequire("8phy8");
const $f94184594f4cccc9$export$8b895f86148e277 = ({ cellData: field })=>{
    const [statusCategory, setStatusCategory] = (0, $5uXOq.useState)(field?.value || null);
    (0, $5uXOq.useEffect)(()=>{
        setStatusCategory(field?.value || null);
    }, [
        field?.value
    ]);
    if (field == null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b5lmY.CellWrapper), {
        isEditable: false
    }, statusCategory && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8phy8.StatusCategoryRead), statusCategory));
};
const $f94184594f4cccc9$export$1c03cc5b920eec85 = {
    [(0, $5fc53.STATUS_CATEGORY_TYPE)]: $f94184594f4cccc9$export$8b895f86148e277
};

});
parcelRegister("8phy8", function(module, exports) {

$parcel$export(module.exports, "StatusCategoryRead", () => $9ef1191a4c6818d2$export$3d1939a7f374f0ac);

var $5uXOq = parcelRequire("5uXOq");

var $3u0c5 = parcelRequire("3u0c5");

var $gULOk = parcelRequire("gULOk");

var $dCm1o = parcelRequire("dCm1o");
const $9ef1191a4c6818d2$var$appearanceMap = {
    [(0, $gULOk.UNDEFINED)]: 'default',
    [(0, $gULOk.TODO)]: 'default',
    [(0, $gULOk.DONE)]: 'success',
    [(0, $gULOk.IN_PROGRESS)]: 'inprogress'
};
const $9ef1191a4c6818d2$export$3d1939a7f374f0ac = ({ statusCategoryId: statusCategoryId, name: name })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
        testId: "business-fields.ui.status-category.cell.read.lozenge",
        appearance: $9ef1191a4c6818d2$var$appearanceMap[(0, $gULOk.statusCategoryForId)(statusCategoryId)],
        isBold: (0, $dCm1o.isVisualRefreshEnabled)()
    }, name);

});


parcelRegister("cphvi", function(module, exports) {

$parcel$export(module.exports, "teamCellHandler", () => $f5afb002faf95f63$export$c23dfb5658df72ac);

var $5uXOq = parcelRequire("5uXOq");

var $4tlhS = parcelRequire("4tlhS");

var $5fc53 = parcelRequire("5fc53");

var $g5X3G = parcelRequire("g5X3G");

var $b5lmY = parcelRequire("b5lmY");

var $cnBEF = parcelRequire("cnBEF");

var $iM6lG = parcelRequire("iM6lG");
const $f5afb002faf95f63$export$2ea8e60ef5e5f6ad = ({ rowData: issue, cellData: field, column: { width: preferredWidth }, editMode: editMode, setEditMode: setEditMode, cellRef: cellRef })=>{
    const [team, setTeam] = (0, $5uXOq.useState)(field?.value);
    const [{ value: value }] = (0, $4tlhS.useTeamField)({
        issueKey: (0, $g5X3G.toIssueKey)(issue.key),
        fieldKey: field?.fieldId ?? '',
        initialValue: team
    });
    if (value !== team) setTeam(value);
    (0, $5uXOq.useEffect)(()=>{
        setTeam(field?.value);
    }, [
        field?.value
    ]);
    if (field == null) return null;
    const readContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iM6lG.TeamRead), {
        team: team
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b5lmY.CellWrapper), {
        isEditable: true,
        hasPadding: false,
        testId: "business-fields.ui.team.cell.cell-wrapper"
    }, editMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cnBEF.TeamEdit), {
        issueKey: issue.key,
        fieldKey: field.fieldId,
        team: team,
        onChange: setTeam,
        setEditMode: setEditMode,
        readContent: readContent,
        preferredWidth: preferredWidth,
        cellRef: cellRef
    }) : readContent);
};
const $f5afb002faf95f63$export$c23dfb5658df72ac = {
    [(0, $5fc53.TEAMS_PLATFORM_CF_TYPE)]: $f5afb002faf95f63$export$2ea8e60ef5e5f6ad
};

});
parcelRegister("cnBEF", function(module, exports) {

$parcel$export(module.exports, "TeamEdit", () => $40d4e5a5df33f9ab$export$88197130b31e38af);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $ioccx = parcelRequire("ioccx");
const $40d4e5a5df33f9ab$export$88197130b31e38af = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $ioccx.teamEditEntryPoint), {});
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jwm.business.fields.team.edit",
        packageName: "jiraBusinessFields",
        runtimeProps: props,
        fallback: props.readContent
    });
};

});
parcelRegister("ioccx", function(module, exports) {

$parcel$export(module.exports, "teamEditEntryPoint", () => $3ce79e2e803c0940$export$9bcf1ad2d1e96b95);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $3ce79e2e803c0940$export$9bcf1ad2d1e96b95 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("9O7ZU")), {
        moduleId: "e322dd82"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("9O7ZU", function(module, exports) {

let $723efcb3e066877a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $723efcb3e066877a$var$load("3c2x2").then(()=>parcelRequire('c9AOc'));

});



parcelRegister("iM6lG", function(module, exports) {

$parcel$export(module.exports, "TeamRead", () => $14befa705267cf1b$export$5f2e28c402b347f);

var $5uXOq = parcelRequire("5uXOq");

var $cUfIr = parcelRequire("cUfIr");
const $14befa705267cf1b$export$5f2e28c402b347f = ({ team: team })=>team ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cUfIr.TeamPickerView), {
        defaultValue: team,
        placeholder: "",
        isEditable: false
    }) : null;

});
parcelRegister("cUfIr", function(module, exports) {

$parcel$export(module.exports, "TeamPickerView", () => $4276e1b7b30e55b4$export$d284ae84f659e68c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable jira/integration/test-id-by-folder-structure */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $hGgHi = parcelRequire("hGgHi");

var $jhVLw = parcelRequire("jhVLw");

var $fuhQD = parcelRequire("fuhQD");

var $c0aEF = parcelRequire("c0aEF");
var $dS3PR = parcelRequire("dS3PR");

var $3bDjY = parcelRequire("3bDjY");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $iv6X1 = parcelRequire("iv6X1");

var $cq6Ui = parcelRequire("cq6Ui");

var $4vyX4 = parcelRequire("4vyX4");
const $4276e1b7b30e55b4$var$ErrorView = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $4vyX4.default).teamErrorViewTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4276e1b7b30e55b4$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4276e1b7b30e55b4$var$Text_, {
        isDisabled: true,
        "data-testid": "issue-field-team.ui.view-error-value-text"
    }, formatMessage((0, $4vyX4.default).teamErrorViewText))));
};
const $4276e1b7b30e55b4$export$d284ae84f659e68c = (props)=>{
    const { defaultValue: defaultValue, isEditable: isEditable, placeholder: placeholder, noPaddingLeft: noPaddingLeft } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const noValueTextExperiment = formatMessage((0, $4vyX4.default).noValueTextExperiment);
    const { isExperimentEnabled: isExperimentEnabled } = (0, $iv6X1.useBespokeEmptyFieldTextExperiment)();
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(defaultValue)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4276e1b7b30e55b4$var$ReadViewContainerEmpty, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        testId: "issue-field-team.ui.view-empty-value-text",
        color: isExperimentEnabled ? 'color.text.subtlest' : 'color.text.subtle'
    }, isExperimentEnabled ? noValueTextExperiment : placeholder));
    if (defaultValue.isVisible === false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4276e1b7b30e55b4$var$ErrorView, null);
    const team = defaultValue;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4276e1b7b30e55b4$var$Wrapper, {
        isEditable: isEditable,
        noPaddingLeft: noPaddingLeft
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jhVLw.default), {
        isInset: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cq6Ui.default), {
        teamId: team.id,
        trigger: "hover-click",
        position: "left-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0aEF.default), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4276e1b7b30e55b4$var$Text_, {
        "data-testid": "issue-field-team.ui.view-team-name"
    }, team.name), team.isVerified && (0, $4R6GH.fg)('verified_team_in_team_picker_in_jira') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fuhQD.VerifiedTeamIcon), null)))));
};
var $4276e1b7b30e55b4$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
 = $4276e1b7b30e55b4$export$d284ae84f659e68c;
const $4276e1b7b30e55b4$var$ReadViewContainerEmpty = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c82smr _1e0c1txw _p12f1osq _ca0q12x7 _u5f312x7 _n3td12x7 _19bv12x7 _1tke7vkz _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $4276e1b7b30e55b4$var$Text_ = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDisabled: isDisabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_p8iyn6": (0, $lD23V.default)(__cmplp.isDisabled ? "var(--ds-text-subtlest, #626F86)" : "var(--ds-text, #172B4D)")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1yt4x7n9 _vwz4gktf _y3gn1e5h _syaz1ylt _4cvr1h6o _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $4276e1b7b30e55b4$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isEditable: isEditable, noPaddingLeft: noPaddingLeft, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_167ft80": (0, $lD23V.default)(__cmplp.isEditable ? 'pointer' : 'default'),
            "--_1qzp7z5": (0, $lD23V.default)(__cmplp.noPaddingLeft ? undefined : "var(--ds-space-075, 6px)")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_80omm20a _19bv11d4 _1bsb1osq _1e0c1txw _4cvr1h6o _nbr41txw _dskl1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cq6Ui", function(module, exports) {

$parcel$export(module.exports, "default", () => $542f601a1b50d9f3$export$2e2bcd8739ae039);


const $542f601a1b50d9f3$var$ConditionalProfileCard = (parcelRequire("cVfTl")).default;
var // below is a pre-existing lint violation, don't add more eslint-disable for this rule please!!
// eslint-disable-next-line @atlaspack/no-importcond-exports
$542f601a1b50d9f3$export$2e2bcd8739ae039 = $542f601a1b50d9f3$var$ConditionalProfileCard;

});
parcelRegister("cVfTl", function(module, exports) {

module.exports = (parcelRequire("avM1e"))('empanada_team_profilecard_trial_sync_trigger', function() {
    return parcelRequire('3FCPe');
}, function() {
    return parcelRequire('1dNQ0');
});

});





parcelRegister("jRQOz", function(module, exports) {

$parcel$export(module.exports, "versionCellHandler", () => $3c8fb7bb3047c601$export$fc6264270343b1df);

var $5uXOq = parcelRequire("5uXOq");

var $lQE94 = parcelRequire("lQE94");

var $5fc53 = parcelRequire("5fc53");

var $b5lmY = parcelRequire("b5lmY");

var $6q9eL = parcelRequire("6q9eL");

var $kg162 = parcelRequire("kg162");
const $3c8fb7bb3047c601$export$710c4688cbbfc14a = ({ rowData: issue, cellData: field, column: { width: preferredWidth }, editMode: editMode, setEditMode: setEditMode, cellRef: cellRef, inputValue: inputValue, onInputChange: onInputChange })=>{
    const [selectedVersions, setSelectedVersions] = (0, $5uXOq.useState)(field?.value ?? null);
    const [{ value: fieldValue }] = (0, $lQE94.useEditField)({
        fieldKey: field?.fieldId ?? '',
        issueKey: issue.key,
        fieldType: field?.type ?? '',
        initialValue: field?.value ?? null
    });
    // Update the value when it is updated externally (e.g. when a new value is pasted)
    if (!editMode && fieldValue !== selectedVersions) setSelectedVersions(fieldValue);
    // Update the value when it is updated in cache (e.g. via realtime)
    (0, $5uXOq.useEffect)(()=>{
        setSelectedVersions(field?.value ?? null);
    }, [
        field?.value
    ]);
    const isEditable = (0, $5uXOq.useMemo)(()=>issue.fieldConfig?.isEditable || false, [
        issue.fieldConfig?.isEditable
    ]);
    const isMulti = (0, $5uXOq.useMemo)(()=>field?.type !== 'com.atlassian.jira.plugin.system.customfieldtypes:version', [
        field?.type
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b5lmY.CellWrapper), {
        isEditable: isEditable,
        testId: "business-fields.ui.version.cell.cell-wrapper"
    }, editMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6q9eL.VersionEdit), {
        cellRef: cellRef,
        setEditMode: setEditMode,
        inputValue: inputValue,
        onInputChange: onInputChange,
        isMulti: isMulti,
        fieldName: field?.name || '',
        onChange: setSelectedVersions,
        preferredWidth: preferredWidth,
        selectedVersions: selectedVersions,
        fieldKey: field?.fieldId || '',
        issueKey: issue.key,
        fieldType: field?.type || '',
        initialValue: field?.value ?? null,
        readContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kg162.VersionRead), {
            isEditable: isEditable,
            selectedVersions: selectedVersions
        })
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kg162.VersionRead), {
        isEditable: isEditable,
        selectedVersions: selectedVersions
    }));
};
const $3c8fb7bb3047c601$export$fc6264270343b1df = {
    [(0, $5fc53.VERSION_CF_TYPE)]: $3c8fb7bb3047c601$export$710c4688cbbfc14a,
    [(0, $5fc53.MULTI_VERSION_CF_TYPE)]: $3c8fb7bb3047c601$export$710c4688cbbfc14a,
    [(0, $5fc53.FIX_VERSIONS_TYPE)]: $3c8fb7bb3047c601$export$710c4688cbbfc14a,
    [(0, $5fc53.AFFECTS_VERSIONS_TYPE)]: $3c8fb7bb3047c601$export$710c4688cbbfc14a
};

});
parcelRegister("6q9eL", function(module, exports) {

$parcel$export(module.exports, "VersionEdit", () => $d29ec3c07469f399$export$3c0e57d9b0204cdc);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $kRxRA = parcelRequire("kRxRA");
const $d29ec3c07469f399$var$entryPointParams = {};
const $d29ec3c07469f399$export$3c0e57d9b0204cdc = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $kRxRA.versionEditEntryPoint), $d29ec3c07469f399$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jwm.business.fields.version.edit",
        packageName: "jiraBusinessFields",
        runtimeProps: props,
        fallback: props.readContent
    });
};

});
parcelRegister("kRxRA", function(module, exports) {

$parcel$export(module.exports, "versionEditEntryPoint", () => $02328e8a90a0c71c$export$e4a061611063756b);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $02328e8a90a0c71c$export$e4a061611063756b = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("iOl5p")), {
        moduleId: "d7202e48"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("iOl5p", function(module, exports) {

let $db1d40cffcbdf472$var$load = (parcelRequire("28QjX"))(4);
module.exports = $db1d40cffcbdf472$var$load("gNxm7").then(()=>parcelRequire('azBtZ'));

});



parcelRegister("kg162", function(module, exports) {

$parcel$export(module.exports, "VersionRead", () => $b5ef598bab0a2320$export$6cc418351c9e7765);

var $5uXOq = parcelRequire("5uXOq");

var $d9xxV = parcelRequire("d9xxV");

var $b5lmY = parcelRequire("b5lmY");

var $k2xO1 = parcelRequire("k2xO1");
const $b5ef598bab0a2320$export$6cc418351c9e7765 = ({ selectedVersions: selectedVersions, isEditable: isEditable })=>{
    const [version, count] = (0, $5uXOq.useMemo)(()=>{
        if (Array.isArray(selectedVersions)) {
            const [firstVersion, ...others] = selectedVersions ?? [];
            return [
                firstVersion?.name,
                others.length
            ];
        }
        if (selectedVersions != null) return [
            selectedVersions.name,
            0
        ];
        return [
            undefined,
            0
        ];
    }, [
        selectedVersions
    ]);
    if (version == null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b5lmY.WrapperCommon), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k2xO1.TagListWrapper), {
        isEditable: isEditable
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d9xxV.default), {
        text: version
    }), count > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d9xxV.default), {
        text: `+${count}`
    })));
};

});



parcelRegister("cYskc", function(module, exports) {

$parcel$export(module.exports, "ColumnVisibilityProvider", () => $0a181db91170dacc$export$a60887dfea90a0d9);
$parcel$export(module.exports, "useColumnVisibilityUpdater", () => $0a181db91170dacc$export$ef90c8750ba3bb5);
$parcel$export(module.exports, "useIsColumnVisible", () => $0a181db91170dacc$export$3dbd1ecf42329eea);

var $5uXOq = parcelRequire("5uXOq");

var $8Qi2I = parcelRequire("8Qi2I");
const $0a181db91170dacc$var$VISIBILITY_OFFSET = 120;
const $0a181db91170dacc$var$getVisibleColumns = (scrollLeft, tableWidth, columns)=>{
    const windowLeft = scrollLeft - $0a181db91170dacc$var$VISIBILITY_OFFSET;
    const windowRight = scrollLeft + tableWidth + $0a181db91170dacc$var$VISIBILITY_OFFSET;
    const result = new Map();
    let currentOffset = 0;
    for (const column of columns){
        const columnLeft = currentOffset;
        const columnRight = columnLeft + column.width;
        const isVisible = columnRight >= windowLeft && columnLeft <= windowRight;
        result.set(column.key, isVisible);
        currentOffset = columnRight;
    }
    return result;
};
const $0a181db91170dacc$var$ColumnVisibilityUpdaterContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $0a181db91170dacc$var$ColumnVisibilityAccessorContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $0a181db91170dacc$export$a60887dfea90a0d9 = ({ children: children, columns: columns, width: width })=>{
    const [scrollPosition, setScrollPosition] = (0, $5uXOq.useState)({
        scrollLeft: 0
    });
    const visibleColumns = (0, $5uXOq.useMemo)(()=>$0a181db91170dacc$var$getVisibleColumns(scrollPosition.scrollLeft, width, columns), [
        columns,
        scrollPosition.scrollLeft,
        width
    ]);
    // Use a deeply memoized value to prevent triggering a re-render when the
    // values haven't actually changed
    const memoizedVisibileColumns = (0, $8Qi2I.useDeepMemo)(()=>visibleColumns, [
        visibleColumns
    ]);
    const getIsColumnVisible = (0, $5uXOq.useCallback)(({ key: key })=>// We should always have a value at this point, but we'll default to
        // true as a minor performance hit is better than missing content
        memoizedVisibileColumns.get(key) ?? true, [
        memoizedVisibileColumns
    ]);
    const columnVisibilityAccessor = (0, $5uXOq.useMemo)(()=>({
            getIsColumnVisible: getIsColumnVisible
        }), [
        getIsColumnVisible
    ]);
    const columnVisibilityUpdater = (0, $5uXOq.useMemo)(()=>({
            handleScroll: ({ scrollLeft: scrollLeft })=>setScrollPosition((prev)=>scrollLeft !== prev.scrollLeft ? {
                        scrollLeft: scrollLeft
                    } : prev)
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0a181db91170dacc$var$ColumnVisibilityUpdaterContext.Provider, {
        value: columnVisibilityUpdater
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0a181db91170dacc$var$ColumnVisibilityAccessorContext.Provider, {
        value: columnVisibilityAccessor
    }, children));
};
const $0a181db91170dacc$export$ef90c8750ba3bb5 = ()=>{
    const context = (0, $5uXOq.useContext)($0a181db91170dacc$var$ColumnVisibilityUpdaterContext);
    if (!context) throw new Error("'useColumnVisibilityUpdater' must be used inside a 'ColumnVisibilityProvider'");
    return context;
};
const $0a181db91170dacc$export$3dbd1ecf42329eea = (column)=>{
    const context = (0, $5uXOq.useContext)($0a181db91170dacc$var$ColumnVisibilityAccessorContext);
    if (!context) throw new Error("'useIsColumnVisible' must be used inside a 'ColumnVisibilityProvider'");
    return context.getIsColumnVisible(column);
};

});

parcelRegister("jUhIo", function(module, exports) {

$parcel$export(module.exports, "WithCellSelection", () => $b18a2b2a33e74111$export$3f3bc47e8aed32cb);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $6l4ko = parcelRequire("6l4ko");

var $b9ZBg = parcelRequire("b9ZBg");

var $bDD22 = parcelRequire("bDD22");

var $koVbs = parcelRequire("koVbs");

var $5fc53 = parcelRequire("5fc53");

var $eTDjN = parcelRequire("eTDjN");

var $3yRl2 = parcelRequire("3yRl2");

var $d93RL = parcelRequire("d93RL");
const $b18a2b2a33e74111$export$3f3bc47e8aed32cb = /*#__PURE__*/ (0, $5uXOq.memo)(({ projectId: projectId, fieldId: fieldId, issueId: issueId, position: position, children: children, rowIndex: rowIndex, columnIndex: columnIndex, width: width, field: field, issue: issue, depth: depth = 0 })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ nodeSelection: nodeSelection }, { sendNodeSelected: sendNodeSelected, sendClearNodeSelection: sendClearNodeSelection }] = (0, $6l4ko.useCollabStore)();
    const nodeId = (0, $5uXOq.useMemo)(()=>(0, $bDD22.getPresenceNodeId)({
            projectId: projectId,
            viewId: 'list',
            nodeId: `${fieldId}-${issueId}`
        }), [
        projectId,
        issueId,
        fieldId
    ]);
    const selections = nodeSelection[nodeId];
    const selection = selections && selections[0];
    const isIssueType = fieldId === (0, $5fc53.ISSUE_TYPE);
    const onSendNodeSelected = (0, $5uXOq.useCallback)(()=>sendNodeSelected({
            nodeId: nodeId
        }), [
        sendNodeSelected,
        nodeId
    ]);
    const onSendClearNodeSelection = (0, $5uXOq.useCallback)(()=>sendClearNodeSelection({
            nodeId: nodeId
        }), [
        sendClearNodeSelection,
        nodeId
    ]);
    const renderedChildren = (0, $5uXOq.useMemo)(()=>children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3yRl2.CellNavigation), {
            columnIndex: columnIndex,
            rowIndex: rowIndex,
            field: field,
            issue: issue,
            fieldId: fieldId,
            onSendNodeSelected: onSendNodeSelected,
            onSendClearNodeSelection: onSendClearNodeSelection
        }, children()), [
        children,
        columnIndex,
        fieldId,
        onSendClearNodeSelection,
        onSendNodeSelected,
        rowIndex,
        field,
        issue
    ]);
    if (selection) {
        const hasMoreSelections = selections && selections.length > 1; // exclude first selection of the list
        const tooltipContent = hasMoreSelections ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, selections.map(({ user: user }, i)=>i !== 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                key: user.name
            }, user.name))) : null;
        const otherSelectionsContent = hasMoreSelections ? formatMessage((0, $d93RL.default).moreSelections, {
            count: selections.length - 1
        }) : '';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b18a2b2a33e74111$var$NodeWrapper, {
            isIssueType: isIssueType,
            width: width,
            depth: depth
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b9ZBg.NodeSelectionWrapper), {
            color: selection.color
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: tooltipContent,
            position: "top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b9ZBg.ParticipantBadge), {
            color: selection.color,
            position: position
        }, selection.user.name, otherSelectionsContent)), renderedChildren));
    }
    return renderedChildren;
});
const $b18a2b2a33e74111$var$nodeWrapperBaseStyles = null;
const $b18a2b2a33e74111$var$NodeWrapper = ({ isIssueType: isIssueType, width: width, depth: depth, children: children, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div" // eslint-disable-next-line jira/react/no-style-attribute
    , {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...isIssueType && {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                paddingLeft: `${depth > 0 ? (0, $eTDjN.EXPAND_ICON_INDENT_WIDTH) * depth + 4 : 0}px`,
                boxSizing: 'border-box',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                width: `${width - (0, $eTDjN.LIST_PADDING_LEFT)}px`
            }
        },
        ...rest,
        className: (0, $bwpsq.default)([
            "_kqswstnw _1bsb1kw7 _4t3i1ylp"
        ])
    }, children);

});
parcelRegister("6l4ko", function(module, exports) {

$parcel$export(module.exports, "useCollabStore", () => $b8a7111dc9f99b0c$export$4159ae80cfa2156);
$parcel$export(module.exports, "useCollabStoreActions", () => $b8a7111dc9f99b0c$export$534626027136f733);
$parcel$export(module.exports, "useNodeSelections", () => $b8a7111dc9f99b0c$export$28a23d5e701a52d9);

var $3JOCw = parcelRequire("3JOCw");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $lVnZu = parcelRequire("lVnZu");

const $b8a7111dc9f99b0c$var$updateUserInParticipants = (user)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            participants: state.participants.map((participant)=>{
                if (participant.clientId === user.userId) return {
                    ...participant,
                    avatar: user.avatar,
                    name: user.name,
                    email: user.email
                };
                return participant;
            })
        });
    };
const $b8a7111dc9f99b0c$var$participantsJoined = (joined)=>({ getState: getState, setState: setState })=>{
        const uniqueJoined = (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))(joined, ({ sessionId: sessionId })=>sessionId);
        const newParticipantSessionIds = uniqueJoined.map(({ sessionId: sessionId })=>sessionId);
        const state = getState();
        const { provider: provider } = state;
        const newParticipants = [
            ...state.participants.filter(({ sessionId: sessionId })=>!newParticipantSessionIds.includes(sessionId)),
            ...uniqueJoined
        ];
        // Collab team advised we should limit the number of max connections to control the load on collab service
        if (newParticipants.length >= (0, $8c1bce549db6af3b$export$3debf01bbfa135e5) && provider) {
            // sort users by last active (last joined)
            const sortedUsers = newParticipants.sort((userA, userB)=>userA.lastActive > userB.lastActive ? 1 : -1);
            const currentUser = sortedUsers.find((user)=>user.sessionId === provider.sessionId);
            const lastActiveUser = sortedUsers[sortedUsers.length - 1];
            // kick the last joined user out
            setState({
                ...state,
                participants: newParticipants.filter(({ sessionId: sessionId })=>sessionId !== lastActiveUser.sessionId)
            });
            if (lastActiveUser.sessionId === currentUser?.sessionId) provider.destroy();
            return;
        }
        setState({
            ...state,
            participants: newParticipants
        });
    };
const $b8a7111dc9f99b0c$var$participantsLeft = (left)=>({ getState: getState, setState: setState })=>{
        const leftSessionIds = left.map(({ sessionId: sessionId })=>sessionId);
        const state = getState();
        // cleanup user selection when they leave the session
        const newSelection = {};
        Object.keys(state.nodeSelection).forEach((nodeIdKey)=>{
            const selections = state.nodeSelection[nodeIdKey];
            if (selections.length > 0) {
                const filteredSelections = selections.filter((selection)=>!leftSessionIds.includes(selection.sessionId));
                if (filteredSelections.length === 0) return;
                newSelection[nodeIdKey] = filteredSelections;
            }
        });
        setState({
            ...state,
            participants: state.participants.filter(({ sessionId: sessionId })=>!leftSessionIds.includes(sessionId)),
            nodeSelection: newSelection
        });
    };
const $b8a7111dc9f99b0c$var$setProvider = (provider)=>({ getState: getState, setState: setState })=>setState({
            ...getState(),
            provider: provider
        });
const $b8a7111dc9f99b0c$var$sendNodeSelected = ({ nodeId: nodeId })=>({ getState: getState })=>{
        if (nodeId == null) return;
        const { provider: provider, participants: participants } = getState();
        if (participants.length <= 1) return;
        if (provider) provider.sendMessage({
            type: 'telepointer',
            sessionId: provider.sessionId,
            selection: {
                type: 'nodeSelection',
                anchor: JSON.stringify({
                    nodeId: nodeId
                })
            }
        });
    };
const $b8a7111dc9f99b0c$var$sendClearNodeSelection = ({ nodeId: nodeId, dropParams: dropParams })=>({ getState: getState })=>{
        if (nodeId == null) return;
        const { provider: provider, participants: participants } = getState();
        if (participants.length <= 1) return;
        if (provider) provider.sendMessage({
            type: 'telepointer',
            sessionId: provider.sessionId,
            selection: {
                type: 'nodeSelection',
                head: JSON.stringify({
                    nodeId: nodeId,
                    dropParams: dropParams
                })
            }
        });
    };
const $b8a7111dc9f99b0c$var$setNodeSelection = ({ nodeId: nodeId, sessionId: sessionId, user: user })=>({ setState: setState, getState: getState })=>{
        const { color: color } = (0, $lVnZu.getColorFromString)(sessionId);
        const newSelection = {
            nodeId: nodeId,
            user: user,
            color: color,
            sessionId: sessionId
        };
        const state = getState();
        const dedupCurrentSelection = state.nodeSelection[nodeId] && state.nodeSelection[nodeId].filter((selection)=>selection.user.userId !== user.userId);
        const nodeSelection = dedupCurrentSelection ? [
            ...dedupCurrentSelection,
            newSelection
        ] : [
            newSelection
        ];
        // deduplicate selected nodes from this user, because each user can have only one selected node on the page
        // see JET-2794
        const dedupOtherSelections = {};
        Object.keys(state.nodeSelection).forEach((nodeIdKey)=>{
            // keep selections from all other users
            const selections = state.nodeSelection[nodeIdKey];
            if (selections.length > 0) {
                const filteredSelections = selections.filter((selection)=>selection.user.userId !== user.userId);
                if (filteredSelections.length === 0) return;
                dedupOtherSelections[nodeIdKey] = filteredSelections;
            }
        });
        setState({
            ...state,
            nodeSelection: {
                ...dedupOtherSelections,
                [nodeId]: nodeSelection
            }
        });
    };
const $b8a7111dc9f99b0c$var$clearNodeSelection = ({ nodeId: nodeId })=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const newNodeSelection = {};
        Object.keys(state.nodeSelection).forEach((nodeIdKey)=>{
            if (nodeIdKey !== nodeId) newNodeSelection[nodeIdKey] = state.nodeSelection[nodeIdKey];
        });
        setState({
            ...state,
            nodeSelection: newNodeSelection
        });
    };
const $b8a7111dc9f99b0c$var$actions = {
    setProvider: $b8a7111dc9f99b0c$var$setProvider,
    participantsLeft: $b8a7111dc9f99b0c$var$participantsLeft,
    participantsJoined: $b8a7111dc9f99b0c$var$participantsJoined,
    updateUserInParticipants: $b8a7111dc9f99b0c$var$updateUserInParticipants,
    sendNodeSelected: $b8a7111dc9f99b0c$var$sendNodeSelected,
    sendClearNodeSelection: $b8a7111dc9f99b0c$var$sendClearNodeSelection,
    setNodeSelection: $b8a7111dc9f99b0c$var$setNodeSelection,
    clearNodeSelection: $b8a7111dc9f99b0c$var$clearNodeSelection
};
const $b8a7111dc9f99b0c$var$Store = (0, $iXqE5.createStore)({
    initialState: {
        provider: null,
        participants: [],
        nodeSelection: {}
    },
    actions: $b8a7111dc9f99b0c$var$actions,
    name: 'JWMCollabStore'
});
const $b8a7111dc9f99b0c$export$4159ae80cfa2156 = (0, $3sQ5x.createHook)($b8a7111dc9f99b0c$var$Store);
const $b8a7111dc9f99b0c$export$534626027136f733 = (0, $3sQ5x.createActionsHook)($b8a7111dc9f99b0c$var$Store);
const $b8a7111dc9f99b0c$export$28a23d5e701a52d9 = (0, $3sQ5x.createStateHook)($b8a7111dc9f99b0c$var$Store, {
    selector: (state, props)=>{
        const selections = state.nodeSelection[props.nodeId];
        return Array.isArray(selections) && selections.length ? selections : undefined;
    }
});

});
parcelRegister("lVnZu", function(module, exports) {

$parcel$export(module.exports, "getColorFromString", () => $cb176b2a2314f98e$export$137ec5185b12f5a2);

const $cb176b2a2314f98e$var$colors = [
    (0, $829f609a65d26a98$exports).R300,
    (0, $829f609a65d26a98$exports).R400,
    (0, $829f609a65d26a98$exports).R500,
    (0, $829f609a65d26a98$exports).Y300,
    (0, $829f609a65d26a98$exports).Y400,
    (0, $829f609a65d26a98$exports).Y500,
    (0, $829f609a65d26a98$exports).G300,
    (0, $829f609a65d26a98$exports).G400,
    (0, $829f609a65d26a98$exports).G500,
    (0, $829f609a65d26a98$exports).T300,
    (0, $829f609a65d26a98$exports).T400,
    (0, $829f609a65d26a98$exports).T500,
    (0, $829f609a65d26a98$exports).P300,
    (0, $829f609a65d26a98$exports).P400,
    (0, $829f609a65d26a98$exports).P500,
    (0, $829f609a65d26a98$exports).N200,
    (0, $829f609a65d26a98$exports).N500,
    (0, $829f609a65d26a98$exports).N800
];
const $cb176b2a2314f98e$export$137ec5185b12f5a2 = (str)=>{
    let hash = 0;
    for(let i = 0; i < str.length; i += 1){
        /* eslint-disable no-bitwise */ hash = (hash << 5) - hash + str.charCodeAt(i);
        hash &= hash;
    /* eslint-enable no-bitwise */ }
    const index = Math.abs(hash) % $cb176b2a2314f98e$var$colors.length;
    const hexColor = $cb176b2a2314f98e$var$colors[index];
    return {
        index: index,
        color: hexColor
    };
};

});

const $8c1bce549db6af3b$export$3debf01bbfa135e5 = 80;


parcelRegister("b9ZBg", function(module, exports) {

$parcel$export(module.exports, "NodeSelectionWrapper", () => $245afad9428c4f83$export$f758a58bee5c7927);
$parcel$export(module.exports, "ParticipantBadge", () => $245afad9428c4f83$export$91bc13dfc76fa8fa);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

const $245afad9428c4f83$var$BADGE_SIZE = 16;
// the badge text color will remain white regardless of the theme applied
const $245afad9428c4f83$var$BADGE_TEXT_COLOR = 'white';
const $245afad9428c4f83$export$f758a58bee5c7927 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_oor3vt": (0, $lD23V.default)(`0 0 0 2px ${__cmplp.color} inset`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1sit _1bsb1osq _4t3i1osq _16qs1zte",
            __cmplp.className
        ])
    });
});
const $245afad9428c4f83$export$91bc13dfc76fa8fa = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { position: position, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_xexnhp": (0, $lD23V.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11q71cj8 _11c8dcr7 _kqswstnw _1e0c1txw _1bah1h6o _4cvr1h6o _1xi2idpf _1bsb1wug _4t3i7vkz _1pbykb7n _ca0qidpf _u5f31b66 _n3tdidpf _19bv1b66 _vchhusvi _syazu67f",
            __cmplp.position === (0, $44496cc0f0c1ce14$export$86bcdda8e7a22b9d) ? "_154iidpf" : "_154id439",
            __cmplp.position === (0, $44496cc0f0c1ce14$export$86bcdda8e7a22b9d) ? "_2rko1pph" : "_2rko2hs0",
            __cmplp.className
        ])
    });
});

});

parcelRegister("bDD22", function(module, exports) {

$parcel$export(module.exports, "getPresenceNodeId", () => $a5ff4c6838514ad6$export$b31325f2ad6cf0b5);
const $a5ff4c6838514ad6$export$b31325f2ad6cf0b5 = ({ projectId: projectId, viewId: viewId, nodeId: nodeId })=>`project:${projectId}:view/${viewId}/node/${nodeId}`;

});

parcelRegister("d93RL", function(module, exports) {

$parcel$export(module.exports, "default", () => $62998662af00620d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $62998662af00620d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    moreSelections: {
        "id": "business-list.list-view.cell.with-cell-selection.more-selections",
        "defaultMessage": " + {count, plural, one {# other} other {# others}}"
    }
});

});



parcelRegister("kX1vD", function(module, exports) {

$parcel$export(module.exports, "default", () => $0140b4c5d32ff7f1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $0140b4c5d32ff7f1$var$CheckboxCell = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("2nH6H")), {
    moduleId: "./src/packages/business/list/src/ui/list-view/checkbox-cell/main.tsx"
});
const $0140b4c5d32ff7f1$var$AsyncCheckboxCell = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "checkbox-cell",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0140b4c5d32ff7f1$var$CheckboxCell, props));
var $0140b4c5d32ff7f1$export$2e2bcd8739ae039 = $0140b4c5d32ff7f1$var$AsyncCheckboxCell;

});
parcelRegister("2nH6H", function(module, exports) {

let $1bbf2aebd4230465$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1bbf2aebd4230465$var$load("bSMN9").then(()=>parcelRequire('bzcYv'));

});


parcelRegister("al7Aq", function(module, exports) {

$parcel$export(module.exports, "ColumnHeader", () => $37ba110525867ccd$export$5667c09b71ee0f05);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $34ck9 = parcelRequire("34ck9");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $daQYX = parcelRequire("daQYX");

var $eq0nK = parcelRequire("eq0nK");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $7XYc4 = parcelRequire("7XYc4");

var $8VBZp = parcelRequire("8VBZp");

var $82a7H = parcelRequire("82a7H");

var $fXEYJ = parcelRequire("fXEYJ");


var $gEb1A = parcelRequire("gEb1A");

var $5ipyI = parcelRequire("5ipyI");

var $5XBz0 = parcelRequire("5XBz0");

var $lLkXN = parcelRequire("lLkXN");
const $37ba110525867ccd$var$BOUNDARY = 70;
const $37ba110525867ccd$var$MOUSE_MOVE_THROTTLE = 16;
const $37ba110525867ccd$export$cdd17a489f5a2a5c = 'business-list.ui.list-view.column-header.column-header-container';
const $37ba110525867ccd$var$COLUMN_HEADER_DRAG_HANDLE_TEST_ID = 'business-list.ui.list-view.column-header.column-header-container.drag-handle';
const $37ba110525867ccd$var$VisualRefreshIconWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        justifyContent: "center",
        alignItems: "center",
        xcss: $37ba110525867ccd$var$iconWrapperStyle
    }, children);
const $37ba110525867ccd$export$5667c09b71ee0f05 = ({ icon: icon, label: label, canSortField: canSortField = true, canHideField: canHideField = false, canEditField: canEditField = false, fieldId: fieldId, fieldType: fieldType = '', disableDrag: isDragDisabled, index: index })=>{
    const [isHovering, setIsHovering] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const project = (0, $daQYX.useProject)();
    const projectId = String(project.id);
    const ref = (0, $5uXOq.useRef)(null);
    const { status: dragStatus } = (0, $82a7H.useReorderColumns)({
        ref: ref,
        id: fieldId,
        index: index,
        isDragDisabled: isDragDisabled
    });
    const { dropTargetJSX: dropTargetJSX } = (0, $8VBZp.useFullHeightColumnDropTarget)({
        id: fieldId,
        index: index
    });
    const [{ isSelected: isSelected }] = (0, $gEb1A.useInlineFieldCreateControls)();
    const { clearIndex: clearIndex, clearIndexAfterDelay: clearIndexAfterDelay, setIndex: setIndex } = (0, $fXEYJ.useInlineCreateActions)();
    const { getFieldDetails: getFieldDetails, fieldDetails: fieldDetails, called: called } = (0, $eq0nK.useFieldDetails)(projectId, false);
    (0, $5uXOq.useEffect)(()=>{
        if (canEditField && isHovering && !fieldDetails && !called) getFieldDetails(fieldId);
    }, [
        called,
        canEditField,
        fieldDetails,
        fieldId,
        getFieldDetails,
        isHovering
    ]);
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ updated: MessageDescriptorV2; created: MessageDescriptorV2; priority: MessageDescriptorV2; duedate: MessageDescriptorV2; ... 5 more ...; issuetype: MessageDescriptorV2; }'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ updated: MessageDescriptorV2; created: MessageDescriptorV2; priority: MessageDescriptorV2; duedate: MessageDescriptorV2; ... 5 more ...; issuetype: MessageDescriptorV2; }'.
    const customLabel = (0, $lLkXN.default)[fieldId] ? formatMessage((0, $lLkXN.default)[fieldId]) : label;
    const showActions = canSortField || canHideField || canEditField;
    const editActionIsVisible = canEditField && !!fieldDetails?.operations.editable;
    const columnActions = showActions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($37ba110525867ccd$var$ActionsWrapper, {
        "data-testid": "business-list.ui.list-view.column-header.actions-wrapper"
    }, canSortField && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5XBz0.default), {
        columnName: fieldId,
        isVisible: isHovering,
        fieldType: fieldType
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ipyI.default), {
        fieldId: fieldId,
        isVisible: isHovering,
        fieldType: fieldType,
        visibleActions: {
            sort: canSortField,
            hide: canHideField,
            edit: editActionIsVisible
        }
    })) : null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const calculateColumnIndex = (0, $5uXOq.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($34ck9)))((event)=>{
        if (!event.currentTarget) return;
        const rect = event.currentTarget.getBoundingClientRect();
        const x = event.clientX - rect.left;
        const width = rect.right - rect.left;
        if (x < width / 2 && x <= $37ba110525867ccd$var$BOUNDARY) setIndex((0, $42342df24820ed74$export$d6f887e0c1be1b74), index - 1);
        else if (x >= width / 2 && x >= width - $37ba110525867ccd$var$BOUNDARY) setIndex((0, $42342df24820ed74$export$d6f887e0c1be1b74), index);
        else clearIndex((0, $42342df24820ed74$export$d6f887e0c1be1b74));
    }, $37ba110525867ccd$var$MOUSE_MOVE_THROTTLE), [
        index,
        setIndex,
        clearIndex
    ]);
    const handleMouseEnter = (0, $5uXOq.useCallback)(()=>setIsHovering(true), []);
    const handleMouseLeave = (0, $5uXOq.useCallback)(()=>{
        setIsHovering(false);
        !isSelected && clearIndexAfterDelay((0, $42342df24820ed74$export$d6f887e0c1be1b74));
    }, [
        clearIndexAfterDelay,
        isSelected
    ]);
    const handleMouseMove = (0, $5uXOq.useCallback)((event)=>{
        event.persist(); // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        if (ref.current?.contains(event.target)) calculateColumnIndex(event);
        else clearIndex((0, $42342df24820ed74$export$d6f887e0c1be1b74));
    }, [
        calculateColumnIndex,
        clearIndex
    ]);
    const IconWrapperComponent = (0, $dCm1o.isVisualRefreshEnabled)() ? $37ba110525867ccd$var$VisualRefreshIconWrapper : $37ba110525867ccd$var$IconWrapper;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($37ba110525867ccd$var$ColumnHeaderContainer, {
        "data-testid": $37ba110525867ccd$export$cdd17a489f5a2a5c,
        ref: ref,
        dragStatus: dragStatus,
        isDragDisabled: isDragDisabled,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onMouseMove: handleMouseMove
    }, (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        xcss: [
            $37ba110525867ccd$var$titleStyle,
            index > 0 && $37ba110525867ccd$var$columnStyle
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $37ba110525867ccd$var$textWrapperStyle
    }, customLabel)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($37ba110525867ccd$var$Title, null, isHovering && isDragDisabled !== true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($37ba110525867ccd$var$ColumnDragHandle, {
        "data-testid": $37ba110525867ccd$var$COLUMN_HEADER_DRAG_HANDLE_TEST_ID
    }) : icon != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IconWrapperComponent, null, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($37ba110525867ccd$var$TextWrapper, null, customLabel)), dragStatus === 'idle' ? columnActions : null, isDragDisabled !== true ? dropTargetJSX : null);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $37ba110525867ccd$var$ColumnDragHandle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1kt9mrja _is061gjq _1mp41tcg _cfu11txw _24gj1h6o _18oh15vq _eid31b66 _fntn1b66 _sxliewfl _bc1wewfl",
            __cmplp.className
        ])
    });
});
const $37ba110525867ccd$var$iconWrapperStyle = (0, $8CUq3.xcss)({
    height: 'size.200',
    width: 'size.200',
    marginRight: 'space.050',
    marginLeft: 'space.050'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $37ba110525867ccd$var$ActionsWrapperOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _16jlkb7n _4t3i1osq _1e0c1txw _4cvr1h6o _1bah1yb4 _19pkidpf _2hwx1b66 _otyridpf _18u01b66 _x7odidpf",
            __cmplp.className
        ])
    });
});
const $37ba110525867ccd$var$actionsWrapperStyles = null;
const $37ba110525867ccd$var$ActionsWrapper = (0, $7XYc4.componentWithCondition)(()=>(0, $dCm1o.isVisualRefreshEnabled)(), ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "business-list.ui.list-view.column-header.actions-wrapper",
        className: (0, $bwpsq.default)([
            "_zulp1b66 _kqswh2mm _16jlkb7n _4t3i1osq _1e0c1txw _4cvr1h6o _1bahesu3 _19pkidpf _2hwx1b66 _otyridpf _18u01b66 _x7odidpf"
        ])
    }, children), $37ba110525867ccd$var$ActionsWrapperOld); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $37ba110525867ccd$var$IconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _1bsb1tcg _16jlidpf _4t3i1tcg _2hwx1b66 _18u01b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $37ba110525867ccd$var$TextWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _16jlidpf _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $37ba110525867ccd$var$Title = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c1txw _4cvr1h6o _16jlidpf _4t3i1osq",
            __cmplp.className
        ])
    });
});
const $37ba110525867ccd$var$titleStyle = (0, $8CUq3.xcss)({
    flexGrow: 0,
    overflow: 'hidden',
    height: '100%',
    font: 'font.heading.xxsmall',
    color: 'color.text.subtle'
});
const $37ba110525867ccd$var$columnStyle = (0, $8CUq3.xcss)({
    paddingLeft: 'space.100'
});
const $37ba110525867ccd$var$textWrapperStyle = (0, $8CUq3.xcss)({
    flexGrow: 0,
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $37ba110525867ccd$var$ColumnHeaderContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDragDisabled: isDragDisabled, dragStatus: dragStatus, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bsb1osq _4t3i1osq _kqswh2mm",
            __cmplp.isDragDisabled === false && "_80om1qgj",
            __cmplp.dragStatus === 'dragging' && "_11q7syzs _syaz1lh4 _80om5szm",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eq0nK", function(module, exports) {

$parcel$export(module.exports, "useFieldDetails", () => $91a98daf25b371ef$export$ad7ee326a4c8ec42);

var $5uXOq = parcelRequire("5uXOq");

var $kV9ss = parcelRequire("kV9ss");
var $hnYwO = parcelRequire("hnYwO");

var $7HGHK = parcelRequire("7HGHK");
var $pa9q9 = parcelRequire("pa9q9");

var $9OXo1 = parcelRequire("9OXo1");

var $kpbr3 = parcelRequire("kpbr3");

var $bBm7i = parcelRequire("bBm7i");

var $baVaq = parcelRequire("baVaq");
const $91a98daf25b371ef$export$3fa4bbd5b4cf486d = (0, $7HGHK.toFlagId)('field-details-error-flag');
const $91a98daf25b371ef$export$ad7ee326a4c8ec42 = (projectId, showErrorFlag = true)=>{
    const { getFieldDetails: getFieldDetailsService, fieldDetails: fieldDetails, loading: loading, error: error, called: called } = (0, $kpbr3.useFieldDetails)();
    const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    const projectAri = (0, $5uXOq.useMemo)(()=>(0, $kV9ss.JiraProjectAri).create({
            siteId: cloudId,
            projectId: projectId
        }).toString(), [
        projectId,
        cloudId
    ]);
    const cloudAri = (0, $5uXOq.useMemo)(()=>(0, $hnYwO.JiraSiteAri).create({
            siteId: cloudId
        }).toString(), [
        cloudId
    ]);
    const getFieldDetails = (0, $5uXOq.useCallback)((fieldId)=>{
        getFieldDetailsService({
            fieldId: fieldId,
            cloudId: cloudAri,
            projectId: projectAri
        });
    }, [
        getFieldDetailsService,
        cloudAri,
        projectAri
    ]);
    const associatedFieldDetails = (0, $5uXOq.useMemo)(()=>(0, $bBm7i.toAssociatedField)(fieldDetails), [
        fieldDetails
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!showErrorFlag) return;
        if (error) showFlag({
            id: $91a98daf25b371ef$export$3fa4bbd5b4cf486d,
            type: 'error',
            title: (0, $baVaq.default).errorTitle,
            description: (0, $baVaq.default).errorMessage,
            messageId: 'business-inline-field-config-sidebar.controllers.field-details.show-flag.error',
            messageType: 'transactional'
        });
        else dismissFlag($91a98daf25b371ef$export$3fa4bbd5b4cf486d);
    }, [
        error,
        showFlag,
        dismissFlag,
        showErrorFlag
    ]);
    return {
        getFieldDetails: getFieldDetails,
        fieldDetails: associatedFieldDetails,
        loading: loading,
        error: error,
        called: called
    };
};

});
parcelRegister("kpbr3", function(module, exports) {

$parcel$export(module.exports, "useFieldDetails", () => $658da91d25e18b7a$export$ad7ee326a4c8ec42);

var $5uXOq = parcelRequire("5uXOq");

var $5tTFS = parcelRequire("5tTFS");

var $cm8b5 = parcelRequire("cm8b5");

var $jcw0u = parcelRequire("jcw0u");

var $ki8aF = parcelRequire("ki8aF");

var $erWQJ = parcelRequire("erWQJ");
const $658da91d25e18b7a$export$ad7ee326a4c8ec42 = ()=>{
    const onExperienceSuccess = (0, $cm8b5.useExperienceSuccess)((0, $ki8aF.GET_FIELD_DETAILS_EXPERIENCE));
    const onExperienceFail = (0, $cm8b5.useExperienceFail)((0, $ki8aF.GET_FIELD_DETAILS_EXPERIENCE));
    const onExperienceStart = (0, $cm8b5.useExperienceStart)((0, $ki8aF.GET_FIELD_DETAILS_EXPERIENCE));
    const [getFieldDetailsQuery, { data: data, loading: loading, error: error, called: called }] = (0, $5tTFS.useLazyQuery)((0, $erWQJ.QUERY), {
        onCompleted: ()=>{
            onExperienceSuccess();
        },
        onError: (apolloError)=>{
            (0, $jcw0u.default)({
                meta: {
                    id: 'JwmCustomFieldDetails',
                    packageName: 'jiraBusinessInlineFieldConfigSidebar',
                    teamName: 'deliveroo'
                },
                error: Array.isArray(apolloError) && apolloError.length > 0 ? apolloError[0] : apolloError,
                attributes: {
                    message: 'Failed to retrieve field details'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            onExperienceFail('Failed to retrieve field details', apolloError);
        },
        fetchPolicy: 'no-cache'
    });
    const getFieldDetails = (0, $5uXOq.useCallback)((variables)=>{
        onExperienceStart();
        getFieldDetailsQuery({
            variables: variables
        });
    }, [
        onExperienceStart,
        getFieldDetailsQuery
    ]);
    return {
        getFieldDetails: getFieldDetails,
        fieldDetails: data,
        error: error,
        loading: loading,
        called: called
    };
};

});
parcelRegister("erWQJ", function(module, exports) {

$parcel$export(module.exports, "QUERY", () => $6511b5c120994298$export$2b91517d6d5b4365);

var $5cllN = parcelRequire("5cllN");
const $6511b5c120994298$export$2b91517d6d5b4365 = (0, $5cllN.default)`
query JWMFieldDetails($cloudId: ID!, $projectId: ID!, $fieldId: String!) {
  jira {
    jwmCustomFieldDetails(cloudId: $cloudId, projectId: $projectId, fieldId: $fieldId) {
      fieldId
      name
      type
      description
      options(first: 100) {
        edges {
          node {
            optionId
            value
            isDisabled
            color {
              id
              colorKey
            }
          }
        }
      }
      configuration
      operations {
        editable
        removable
        deletable
        categoriesWhitelist
        canModifyRequired
        canModifyOptions
        canModifyDefaultValue
        canModifyPropertyConfiguration
        canAssociateInSettings
      }
    }
  }
}`;

});


parcelRegister("bBm7i", function(module, exports) {

$parcel$export(module.exports, "toAssociatedField", () => $0db552f318bae4ea$export$b14a602973946199);

var $6s1PB = parcelRequire("6s1PB");
const $0db552f318bae4ea$export$b14a602973946199 = (data)=>{
    const fieldDetails = data?.jira?.jwmCustomFieldDetails;
    if (!fieldDetails) return;
    return {
        name: fieldDetails.name ?? '',
        key: fieldDetails.fieldId ?? '',
        externalUuid: fieldDetails.fieldId ?? '',
        type: fieldDetails.type ?? '',
        custom: true,
        global: false,
        description: fieldDetails.description ?? '',
        category: '',
        required: false,
        options: fieldDetails.options?.edges ? fieldDetails.options.edges.map((edge)=>({
                id: +String(edge?.node?.optionId),
                optimisticId: String(edge?.node?.optionId),
                value: String(edge?.node?.value),
                externalUuid: String(edge?.node?.optionId),
                ...fieldDetails.type === 'com.atlassian.jira.plugin.system.customfieldtypes:select' && (0, $6s1PB.expVal)('thor_colourful_single_select_milestone2_experiment', 'isColorfulSingleSelectEnabled', false) ? {
                    colour: edge?.node?.color?.colorKey
                } : {}
            })) : undefined,
        configuration: fieldDetails.configuration,
        operations: {
            editable: fieldDetails.operations?.editable ?? false,
            deletable: fieldDetails.operations?.deletable ?? false,
            removable: fieldDetails.operations?.removable ?? false,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            categoriesWhitelist: fieldDetails.operations?.categoriesWhitelist ?? [],
            canAssociateInSettings: fieldDetails.operations?.canAssociateInSettings ?? false,
            canModifyOptions: fieldDetails.operations?.canModifyOptions ?? false,
            canModifyDefaultValue: false,
            canModifyPropertyConfiguration: fieldDetails.operations?.canModifyPropertyConfiguration ?? false,
            canModifyRequired: fieldDetails.operations?.canModifyRequired ?? false
        },
        availability: null
    };
};

});

parcelRegister("baVaq", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a5a6b3aa3631c1c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5a5a6b3aa3631c1c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorTitle: {
        "id": "business-inline-field-config-sidebar.controllers.field-details.error-title",
        "defaultMessage": "We couldn't load the field details"
    },
    errorMessage: {
        "id": "business-inline-field-config-sidebar.controllers.field-details.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    }
});

});


parcelRegister("8VBZp", function(module, exports) {

$parcel$export(module.exports, "useFullHeightColumnDropTarget", () => $fe00cb5b0c4fbecc$export$2d25a320c0ca42d3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $5uJ9N = parcelRequire("5uJ9N");

var $5bBwj = parcelRequire("5bBwj");
const $fe00cb5b0c4fbecc$export$79660a248b11010 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _154iidpf _1ltvidpf _1bsb1lxk _4t3iz7a8 _1e0cglyw",
            __cmplp.className
        ])
    });
});
function $fe00cb5b0c4fbecc$export$2d25a320c0ca42d3({ id: id, index: index }) {
    const [closestEdge, setClosestEdge] = (0, $5uXOq.useState)(null);
    const [isDraggingAnyColumn, setIsDraggingAnyColumn] = (0, $5uXOq.useState)(false);
    const { monitorForElements: monitorForElements, dropTargetForElements: dropTargetForElements, attachClosestEdge: attachClosestEdge, extractClosestEdge: extractClosestEdge } = (0, $5bBwj.useDragAndDropAsyncModules)();
    const dropTargetRef = (0, $5uXOq.useRef)(null);
    const dropTargetJSX = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fe00cb5b0c4fbecc$export$79660a248b11010, {
        ref: dropTargetRef,
        "data-testid": "business-list.controllers.drag-and-drop.use-full-height-column-drop-target.drop-target"
    }, closestEdge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uJ9N.DropIndicator), {
        edge: closestEdge,
        type: "no-terminal"
    }));
    (0, $5uXOq.useEffect)(()=>monitorForElements({
            canMonitor ({ source: source }) {
                return source.data.type === 'table-header';
            },
            onGenerateDragPreview () {
                if (dropTargetRef.current) dropTargetRef.current.style.display = 'block';
            },
            onDragStart () {
                setIsDraggingAnyColumn(true);
            },
            onDrop () {
                setIsDraggingAnyColumn(false);
                if (dropTargetRef.current) dropTargetRef.current.style.display = 'none';
            }
        }), [
        monitorForElements,
        setIsDraggingAnyColumn
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const dropTarget = dropTargetRef.current;
        if (!isDraggingAnyColumn || !dropTarget) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        return dropTargetForElements({
            element: dropTarget,
            getIsSticky () {
                return true;
            },
            getData ({ input: input, element: element }) {
                const data = {
                    id: id,
                    index: index
                };
                return attachClosestEdge(data, {
                    input: input,
                    element: element,
                    allowedEdges: [
                        'left',
                        'right'
                    ]
                });
            },
            canDrop ({ source: source }) {
                return source.data.type === 'table-header';
            },
            onDrag ({ source: source, self: self }) {
                if (source.data.id !== id) setClosestEdge(extractClosestEdge(self.data));
            },
            onDragLeave () {
                setClosestEdge(null);
            },
            onDrop () {
                setClosestEdge(null);
            }
        });
    }, [
        attachClosestEdge,
        dropTargetForElements,
        extractClosestEdge,
        id,
        index,
        isDraggingAnyColumn
    ]);
    return {
        dropTargetJSX: dropTargetJSX
    };
}

});
parcelRegister("5uJ9N", function(module, exports) {

$parcel$export(module.exports, "DropIndicator", () => $057503bea847bf4c$export$62ed72bc21f6b8a6);
$parcel$export(module.exports, "default", () => $057503bea847bf4c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $40bhS = parcelRequire("40bhS");

var $choBO = parcelRequire("choBO");
function $057503bea847bf4c$export$62ed72bc21f6b8a6({ appearance: appearance = 'default', edge: edge, gap: gap, indent: indent, type: type }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $40bhS.Line), {
        edge: edge,
        gap: gap,
        strokeColor: (0, $choBO.presetStrokeColors)[appearance],
        type: type,
        indent: indent
    });
}
var // This default export is intended for usage with React.lazy
$057503bea847bf4c$export$2e2bcd8739ae039 = $057503bea847bf4c$export$62ed72bc21f6b8a6;

});
parcelRegister("40bhS", function(module, exports) {

$parcel$export(module.exports, "Line", () => $5554523a258e458d$export$17d680238e50603e);
/* line.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $choBO = parcelRequire("choBO");
const $5554523a258e458d$var$edgeToOrientationMap = {
    top: 'horizontal',
    bottom: 'horizontal',
    left: 'vertical',
    right: 'vertical'
};
const $5554523a258e458d$var$baseStyles = {
    root: "_1e0c1ule _kqswstnw _1pbykb7n _lcxvglyw _bfhkys7w _rfx31ssb _3l8810ly _kzdanqa1 _15m6ys7w _cfu11ld9 _1kt9b3bt _1cs8stnw _13y0usvi _1mp4vjfa _kfgtvjfa"
};
const $5554523a258e458d$var$orientationStyles = {
    horizontal: "_4t3i10ly _1e02fghn _rjxpidpf _z5wtuj5p",
    vertical: "_1bsb10ly _154ifghn _94n5idpf _1aukuj5p"
};
const $5554523a258e458d$var$edgeStyles = {
    top: "_154ihv0e _1auk70hn",
    right: "_1xi2hv0e _ooun70hn",
    bottom: "_94n5hv0e _19wo70hn",
    left: "_1ltvhv0e _qnec70hn"
};
const $5554523a258e458d$var$lineStartFrom = {
    // - half the terminal bleeding out the containing element
    // - half the terminal inside the containing element (we need to position the line next to this)
    terminal: ({ indent: indent })=>`calc(var(--terminal-radius) + ${indent})`,
    // The full terminal is inside the containing element (we need to position the line next to this)
    'terminal-no-bleed': ({ indent: indent })=>`calc(var(--terminal-diameter) + ${indent})`,
    // No terminal to worry about, line should take up all the space
    'no-terminal': ({ indent: indent })=>indent
};
function $5554523a258e458d$export$17d680238e50603e({ edge: edge, gap: gap = '0px', indent: indent = '0px', strokeColor: strokeColor = (0, $choBO.presetStrokeColors).default, strokeWidth: strokeWidth = (0, $choBO.presetStrokeWidth), type: type = 'terminal' }) {
    const orientation = $5554523a258e458d$var$edgeToOrientationMap[edge];
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        style: {
            // ## All
            '--stroke-color': strokeColor,
            '--stroke-width': strokeWidth,
            // Shift line and terminal on the main access to account for gaps between items
            '--main-axis-offset': `calc(-0.5 * (${gap} + var(--stroke-width)))`,
            // ## Line
            // If there is a terminal, we want the line to start from next to it
            '--line-main-axis-start': $5554523a258e458d$var$lineStartFrom[type]({
                indent: indent
            }),
            // ## Terminal
            '--terminal-display': type === 'no-terminal' ? 'none' : 'block',
            '--terminal-diameter': 'calc(var(--stroke-width) * 4)',
            '--terminal-radius': 'calc(var(--terminal-diameter) / 2)',
            // The line is positioned to account for the the terminal (--line-main-axis-start).
            // The terminal is rendered relative to the line (it's a `::before`)
            // We need to pull the terminal backwards so it sits before the start of the line
            '--terminal-main-axis-start': 'calc(-1 * var(--terminal-diameter))',
            // Pull the terminal backwards on the cross axis (eg "up" on "vertical")
            // so the center of the terminal lines up with the center of the line
            '--terminal-cross-axis-offset': 'calc(calc(var(--stroke-width) - var(--terminal-diameter)) / 2)'
        },
        className: (0, $bwpsq.default)([
            $5554523a258e458d$var$baseStyles.root,
            $5554523a258e458d$var$orientationStyles[orientation],
            $5554523a258e458d$var$edgeStyles[edge]
        ])
    });
}
var // For React.lazy
$5554523a258e458d$export$2e2bcd8739ae039 = $5554523a258e458d$export$17d680238e50603e;

});
parcelRegister("choBO", function(module, exports) {

$parcel$export(module.exports, "presetStrokeColors", () => $9f99301ec58274c5$export$477fafec326bfca0);
$parcel$export(module.exports, "presetStrokeWidth", () => $9f99301ec58274c5$export$45db03aa04b685e3);
const $9f99301ec58274c5$export$477fafec326bfca0 = {
    default: "var(--ds-border-selected, #0C66E4)",
    warning: "var(--ds-border-warning, #E56910)"
};
const $9f99301ec58274c5$export$45db03aa04b685e3 = "var(--ds-border-width-outline, 2px)";

});



parcelRegister("5bBwj", function(module, exports) {

$parcel$export(module.exports, "useDragAndDropAsyncModules", () => $10de5cf2cc5a4997$export$c56d63ea801ce3a6);

var $5uXOq = parcelRequire("5uXOq");

var $e39Vk = parcelRequire("e39Vk");
var $gXGDg = parcelRequire("gXGDg");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

const $10de5cf2cc5a4997$export$d146a9e5d792fbb2 = ()=>(0, $e39Vk.importForInteraction)(()=>Promise.resolve((parcelRequire("7gWdR"))), {
        moduleId: "a81eb583"
    });

const $10de5cf2cc5a4997$export$7c4ce555ad7d3850 = ()=>(0, $e39Vk.importForInteraction)(()=>(parcelRequire("dYLtr")), {
        moduleId: "63a9d67a"
    });

const $10de5cf2cc5a4997$export$435d59857451154b = ()=>(0, $e39Vk.importForInteraction)(()=>(parcelRequire("6H2C3")), {
        moduleId: "5ef6ba42"
    });

const $10de5cf2cc5a4997$export$361499d975b59f21 = ()=>(0, $e39Vk.importForInteraction)(()=>(parcelRequire("02BtW")), {
        moduleId: "fbbc3330"
    });

const $10de5cf2cc5a4997$export$5e8458edfac77ad = ()=>(0, $e39Vk.importForInteraction)(()=>Promise.resolve((parcelRequire("4hDdm"))), {
        moduleId: "8a3e47ea"
    });

const $10de5cf2cc5a4997$export$d75430c29c69863c = ()=>(0, $e39Vk.importForInteraction)(()=>(parcelRequire("aG4HC")), {
        moduleId: "b863ce2b"
    });
const $10de5cf2cc5a4997$export$86880b4b2e1a2384 = 'column.widths';
const $10de5cf2cc5a4997$var$actions = {
    loadModules: ()=>({ setState: setState })=>{
            (0, $gXGDg.waitForAllResources)([
                $10de5cf2cc5a4997$export$d146a9e5d792fbb2(),
                $10de5cf2cc5a4997$export$7c4ce555ad7d3850(),
                $10de5cf2cc5a4997$export$435d59857451154b(),
                $10de5cf2cc5a4997$export$361499d975b59f21(),
                $10de5cf2cc5a4997$export$5e8458edfac77ad(),
                $10de5cf2cc5a4997$export$d75430c29c69863c()
            ]).onComplete(([{ draggable: draggable, monitorForElements: monitorForElements, dropTargetForElements: dropTargetForElements }, { autoScroller: autoScroller }, { attachClosestEdge: attachClosestEdge, extractClosestEdge: extractClosestEdge }, // @ts-expect-error waitForAllResources has a wrong type
            { getReorderDestinationIndex: getReorderDestinationIndex }, // @ts-expect-error same as above
            { combine: combine }, // @ts-expect-error same as above
            { attachInstruction: attachInstruction, extractInstruction: extractInstruction }])=>{
                setState({
                    draggable: draggable,
                    monitorForElements: monitorForElements,
                    dropTargetForElements: dropTargetForElements,
                    autoScroller: autoScroller,
                    attachClosestEdge: attachClosestEdge,
                    extractClosestEdge: extractClosestEdge,
                    getReorderDestinationIndex: getReorderDestinationIndex,
                    combine: combine,
                    attachInstruction: attachInstruction,
                    extractInstruction: extractInstruction
                });
            });
        }
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-empty-function
const $10de5cf2cc5a4997$var$noop = ()=>()=>{};
const $10de5cf2cc5a4997$var$Store = (0, $iXqE5.createStore)({
    initialState: {
        draggable: $10de5cf2cc5a4997$var$noop,
        monitorForElements: $10de5cf2cc5a4997$var$noop,
        dropTargetForElements: $10de5cf2cc5a4997$var$noop,
        autoScroller: {
            start: $10de5cf2cc5a4997$var$noop,
            stop: $10de5cf2cc5a4997$var$noop,
            updateInput: $10de5cf2cc5a4997$var$noop
        },
        attachClosestEdge: $10de5cf2cc5a4997$var$noop,
        extractClosestEdge: $10de5cf2cc5a4997$var$noop,
        getReorderDestinationIndex: $10de5cf2cc5a4997$var$noop,
        combine: $10de5cf2cc5a4997$var$noop,
        attachInstruction: $10de5cf2cc5a4997$var$noop,
        extractInstruction: $10de5cf2cc5a4997$var$noop
    },
    actions: $10de5cf2cc5a4997$var$actions,
    name: 'JWMDragAndDropAsyncModulesStore'
});
const $10de5cf2cc5a4997$var$useHook = (0, $3sQ5x.createHook)($10de5cf2cc5a4997$var$Store);
const $10de5cf2cc5a4997$export$c56d63ea801ce3a6 = ()=>{
    const [asyncModules, { loadModules: loadModules }] = $10de5cf2cc5a4997$var$useHook();
    (0, $5uXOq.useEffect)(()=>{
        loadModules();
    }, [
        loadModules
    ]);
    return asyncModules;
};

});
parcelRegister("e39Vk", function(module, exports) {

$parcel$export(module.exports, "importForInteraction", () => $1224ecfa51385ab0$export$5b50cea0b44df65b);

var $eIMrK = parcelRequire("eIMrK");

var $eYVtd = parcelRequire("eYVtd");

var $iyWSs = parcelRequire("iyWSs");
const $1224ecfa51385ab0$var$cache = (0, $eIMrK.createCache)(new Map());
function $1224ecfa51385ab0$export$5b50cea0b44df65b(loader, opts) {
    const resource = $1224ecfa51385ab0$var$cache.get(opts.moduleId, ()=>(0, $eYVtd.JSResource)(()=>(0, $iyWSs.postTask)(loader, {
                priority: 'user-visible'
            }), opts));
    resource.load().catch(()=>{});
    return resource;
}

});

parcelRegister("gXGDg", function(module, exports) {

$parcel$export(module.exports, "waitForAllResources", () => $29bb74f10fe3539e$export$c33694368275e0ee);
function $29bb74f10fe3539e$export$c33694368275e0ee(resources) {
    return {
        onComplete (onLoad, onError) {
            const cleanups = [];
            const values = new Array(resources.length);
            let completed = false;
            const dispose = ()=>{
                cleanups.forEach((cleanup)=>cleanup());
                cleanups.length = 0;
            };
            const done = ()=>{
                dispose();
                completed = true;
            };
            let loadedResources = 0;
            for(let i = 0; i < resources.length && !completed; i++){
                const completable = resources[i];
                cleanups.push(completable.onComplete((value)=>{
                    values[i] = value;
                    loadedResources++;
                    if (loadedResources === resources.length) {
                        onLoad(values);
                        done();
                    }
                }, (error)=>{
                    onError?.(error);
                    done();
                }));
            }
            return dispose;
        }
    };
}

});

parcelRegister("dYLtr", function(module, exports) {

let $a2d5b44afdc5050c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a2d5b44afdc5050c$var$load("c1M2z").then(()=>parcelRequire('41Tr4'));

});

parcelRegister("6H2C3", function(module, exports) {

let $4df8c912a4f64b58$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4df8c912a4f64b58$var$load("aIcDF").then(()=>parcelRequire('biEfA'));

});

parcelRegister("02BtW", function(module, exports) {

let $007d432c973eefda$var$load = (parcelRequire("28QjX"))(4);
module.exports = $007d432c973eefda$var$load("gnGNG").then(()=>parcelRequire('9EGGH'));

});

parcelRegister("aG4HC", function(module, exports) {

let $7c61796f6a8a4639$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7c61796f6a8a4639$var$load("kiGLs").then(()=>parcelRequire('f3lfW'));

});



parcelRegister("82a7H", function(module, exports) {

$parcel$export(module.exports, "useReorderColumns", () => $a66eb853dd98550b$export$b250c61f32d9da58);

var $5uXOq = parcelRequire("5uXOq");

var $5bBwj = parcelRequire("5bBwj");

var $1msUu = parcelRequire("1msUu");

var $c9pDL = parcelRequire("c9pDL");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $a66eb853dd98550b$var$noop = ()=>{};
const $a66eb853dd98550b$export$b250c61f32d9da58 = ({ id: id, index: index, isDragDisabled: isDragDisabled, ref: ref })=>{
    const [status, setStatus] = (0, $5uXOq.useState)('idle');
    const { combine: combine, draggable: draggable } = (0, $5bBwj.useDragAndDropAsyncModules)();
    (0, $5uXOq.useEffect)(()=>{
        const el = ref.current;
        if (isDragDisabled || !el) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        let nextSiblingCleanupFn = $a66eb853dd98550b$var$noop;
        let tableBodyCleanupFn = $a66eb853dd98550b$var$noop;
        return combine(draggable({
            element: el,
            getInitialData () {
                return {
                    type: 'table-header',
                    id: id,
                    index: index
                };
            },
            onGenerateDragPreview () {
                setStatus('preview');
                // make sure the drag preview doesn't have table scroll
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const tableBody = el.closest(`.${(0, $1msUu.cl).BASE_TABLE}`)?.querySelector(`.${(0, $1msUu.cl).BASE_TABLE_BODY}`);
                if (tableBody) tableBodyCleanupFn = (0, $c9pDL.setStyle)(tableBody, {
                    overflow: 'hidden'
                });
                // hide resize handle for the drag preview
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const nextSibling = el?.nextSibling;
                if (nextSibling) nextSiblingCleanupFn = (0, $c9pDL.setStyle)(nextSibling, {
                    visibility: 'hidden'
                });
            },
            onDragStart () {
                setStatus('dragging');
                tableBodyCleanupFn();
            },
            onDrop () {
                setStatus('idle');
                nextSiblingCleanupFn();
            }
        }));
    }, [
        isDragDisabled,
        id,
        index,
        ref,
        draggable,
        combine
    ]);
    return {
        status: status
    };
};

});
parcelRegister("1msUu", function(module, exports) {

$parcel$export(module.exports, "cssVarTableHeight", () => $64e1e978e44c4adf$export$4c4d2d5ba926bbe5);
$parcel$export(module.exports, "cl", () => $64e1e978e44c4adf$export$b975d55abac2bbe3);
$parcel$export(module.exports, "INDENT_PER_LEVEL", () => $64e1e978e44c4adf$export$130b26c73bb9d040);
$parcel$export(module.exports, "EXPAND_DELAY_MS", () => $64e1e978e44c4adf$export$e5daf2bc041d74b0);
$parcel$export(module.exports, "SUBTASK_HIERARCHY_LEVEL", () => $64e1e978e44c4adf$export$5b388ccfa29be01);
const $64e1e978e44c4adf$export$4c4d2d5ba926bbe5 = '--jwm-list-height';
const $64e1e978e44c4adf$export$b975d55abac2bbe3 = {
    BASE_TABLE: 'BaseTable',
    BASE_TABLE_BODY: 'BaseTable__body',
    BASE_TABLE_TABLE: 'BaseTable__table',
    MULTIDRAG_COUNTER: 'jwm-multidrag-counter'
};
const $64e1e978e44c4adf$export$130b26c73bb9d040 = 25;
const $64e1e978e44c4adf$export$e5daf2bc041d74b0 = 500;
const $64e1e978e44c4adf$export$5b388ccfa29be01 = -1;

});

parcelRegister("c9pDL", function(module, exports) {

$parcel$export(module.exports, "setStyle", () => $50cb8c6939a4f8ce$export$37a5fde709c1db82);
/* eslint-disable no-param-reassign */ /** Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $50cb8c6939a4f8ce$export$37a5fde709c1db82(el, css) {
    const originalCss = {};
    Object.keys(css).forEach((property)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        originalCss[property] = el.style[property];
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        el.style[property] = css[property];
    });
    return ()=>{
        Object.keys(originalCss).forEach((property)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            el.style[property] = originalCss[property];
        });
    };
}

});


parcelRegister("fXEYJ", function(module, exports) {

$parcel$export(module.exports, "InlineCreateContainer", () => $cddeccc1bbf0ec5a$export$c61fba5cf4e215ae);
$parcel$export(module.exports, "useInlineCreateActions", () => $cddeccc1bbf0ec5a$export$5d97dcebeb3ebb31);
$parcel$export(module.exports, "useInlineIssueCreateContext", () => $cddeccc1bbf0ec5a$export$81dc4a9ada8e5cf3);
$parcel$export(module.exports, "useInlineFieldCreateContext", () => $cddeccc1bbf0ec5a$export$3b94b6fe5fe8d50d);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");
const $cddeccc1bbf0ec5a$var$CLEAR_DELAY = 300;
const $cddeccc1bbf0ec5a$var$initialState = {
    issue: {
        index: undefined,
        isIndexLocked: false,
        timeoutId: undefined
    },
    field: {
        index: undefined,
        isIndexLocked: false,
        timeoutId: undefined
    }
};
const $cddeccc1bbf0ec5a$var$actions = {
    setIndex: (key, index)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            setState({
                [key]: {
                    ...getState()[key],
                    index: index
                }
            });
            dispatch($cddeccc1bbf0ec5a$var$actions.lockIndex(key));
        },
    clearIndex: (key)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            setState({
                [key]: {
                    ...getState()[key],
                    index: undefined
                }
            });
            dispatch($cddeccc1bbf0ec5a$var$actions.unlockIndex(key));
        },
    clearIndexAfterDelay: (key)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const timeoutId = setTimeout(()=>{
                if (!getState()[key].isIndexLocked) {
                    dispatch($cddeccc1bbf0ec5a$var$actions.clearIndex(key));
                    setState({
                        [key]: {
                            ...getState()[key],
                            timeoutId: undefined
                        }
                    });
                }
            }, $cddeccc1bbf0ec5a$var$CLEAR_DELAY);
            setState({
                [key]: {
                    ...getState()[key],
                    isIndexLocked: false,
                    timeoutId: timeoutId
                }
            });
        },
    lockIndex: (key)=>({ setState: setState, getState: getState })=>{
            const { timeoutId: timeoutId } = getState()[key];
            if (timeoutId) clearTimeout(timeoutId);
            setState({
                [key]: {
                    ...getState()[key],
                    isIndexLocked: true,
                    timeoutId: undefined
                }
            });
        },
    unlockIndex: (key)=>({ setState: setState, getState: getState })=>{
            setState({
                [key]: {
                    ...getState()[key],
                    isIndexLocked: false
                }
            });
        }
};
const $cddeccc1bbf0ec5a$export$c61fba5cf4e215ae = (0, $gg7kZ.createContainer)();
const $cddeccc1bbf0ec5a$var$Store = (0, $iXqE5.createStore)({
    initialState: $cddeccc1bbf0ec5a$var$initialState,
    actions: $cddeccc1bbf0ec5a$var$actions,
    name: 'JwmListInlineCreate',
    containedBy: $cddeccc1bbf0ec5a$export$c61fba5cf4e215ae
});
const $cddeccc1bbf0ec5a$export$1baf430619906b52 = (0, $3sQ5x.createHook)($cddeccc1bbf0ec5a$var$Store);
const $cddeccc1bbf0ec5a$export$5d97dcebeb3ebb31 = (0, $3sQ5x.createActionsHook)($cddeccc1bbf0ec5a$var$Store);
const $cddeccc1bbf0ec5a$var$getInlineIssueCreate = (state)=>state.issue;
const $cddeccc1bbf0ec5a$var$getInlineFieldCreate = (state)=>state.field;
const $cddeccc1bbf0ec5a$export$81dc4a9ada8e5cf3 = (0, $3sQ5x.createHook)($cddeccc1bbf0ec5a$var$Store, {
    selector: $cddeccc1bbf0ec5a$var$getInlineIssueCreate
});
const $cddeccc1bbf0ec5a$export$3b94b6fe5fe8d50d = (0, $3sQ5x.createHook)($cddeccc1bbf0ec5a$var$Store, {
    selector: $cddeccc1bbf0ec5a$var$getInlineFieldCreate
});

});

const $42342df24820ed74$export$76a449e52fa0e1e8 = 'issue';
const $42342df24820ed74$export$d6f887e0c1be1b74 = 'field';

parcelRegister("5ipyI", function(module, exports) {

$parcel$export(module.exports, "default", () => $f222cc05ded03b86$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $drTrn = parcelRequire("drTrn");
const $f222cc05ded03b86$var$ActionsDropdownMenu = ({ isVisible: isVisible, ...rest })=>{
    const [isMenuOpen, setMenuOpen] = (0, $5uXOq.useState)(false);
    // Defer loading ActionsDropdownMenu until the column is hovered
    return isMenuOpen || isVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $drTrn.default), {
        ...rest,
        setMenuOpen: setMenuOpen
    }) : null;
};
var $f222cc05ded03b86$export$2e2bcd8739ae039 = $f222cc05ded03b86$var$ActionsDropdownMenu;

});
parcelRegister("drTrn", function(module, exports) {

$parcel$export(module.exports, "default", () => $1db2672fdce0ae7e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1db2672fdce0ae7e$var$ActionsDropdownMenu = (0, $kxZPA.lazy)(()=>(parcelRequire("drZDs")), {
    ssr: false,
    moduleId: "./src/packages/business/list/src/ui/list-view/column-header/field-actions/actions-dropdown-menu/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1db2672fdce0ae7e$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jwm-common-actions-dropdown-menu",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1db2672fdce0ae7e$var$ActionsDropdownMenu, props));

});
parcelRegister("drZDs", function(module, exports) {

let $9cad9b7e59f5eba1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9cad9b7e59f5eba1$var$load("gKS78").then(()=>parcelRequire('a06mX'));

});



parcelRegister("5XBz0", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed25a2e670ce827d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2UUq6 = parcelRequire("2UUq6");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $ed25a2e670ce827d$export$9951126d1499b75c = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("jHmlW")), {
    ssr: false,
    moduleId: "./src/packages/business/list/src/ui/list-view/column-header/field-actions/sorting-indicator/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ed25a2e670ce827d$export$2e2bcd8739ae039 = (props)=>{
    const [sorting] = (0, $2UUq6.useSorting)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "sorting-indicator",
        fallback: null
    }, (props.columnName === sorting.sortBy || props.isVisible) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed25a2e670ce827d$export$9951126d1499b75c, props));
};

});
parcelRegister("jHmlW", function(module, exports) {

let $e5735f4a880aacc3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e5735f4a880aacc3$var$load("gLrZI").then(()=>parcelRequire('9aBEu'));

});


parcelRegister("lLkXN", function(module, exports) {

$parcel$export(module.exports, "default", () => $93fe1610c739516b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $93fe1610c739516b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    issuetype: {
        "id": "business-list.list-view.column-header.issuetype",
        "defaultMessage": "Type"
    },
    issuekey: {
        "id": "business-list.list-view.column-header.issuekey",
        "defaultMessage": "Key"
    },
    summary: {
        "id": "business-list.list-view.column-header.summary",
        "defaultMessage": "Summary"
    },
    status: {
        "id": "business-list.list-view.column-header.status",
        "defaultMessage": "Status"
    },
    assignee: {
        "id": "business-list.list-view.column-header.assignee",
        "defaultMessage": "Assignee"
    },
    labels: {
        "id": "business-list.list-view.column-header.labels",
        "defaultMessage": "Labels"
    },
    duedate: {
        "id": "business-list.list-view.column-header.duedate",
        "defaultMessage": "Due date"
    },
    priority: {
        "id": "business-list.list-view.column-header.priority",
        "defaultMessage": "Priority"
    },
    created: {
        "id": "business-list.list-view.column-header.created",
        "defaultMessage": "Created"
    },
    updated: {
        "id": "business-list.list-view.column-header.updated",
        "defaultMessage": "Updated"
    }
});

});


parcelRegister("3jNxz", function(module, exports) {

$parcel$export(module.exports, "CommentsCell", () => $28e29ee490039ab9$export$11f3e85eadff465c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bFmnZ = parcelRequire("bFmnZ");

var $DBbS0 = parcelRequire("DBbS0");

var $dC5iT = parcelRequire("dC5iT");
var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $kzK6P = parcelRequire("kzK6P");
const $28e29ee490039ab9$export$11f3e85eadff465c = ({ issueKey: issueKey, onClick: onClick, totalCount: totalCount, cellRef: cellRef, hasUnread: hasUnread, columnIndex: columnIndex })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    // Temporary attributes for Unread Comments in List View experiment
    // Clean up in https://hello.jira.atlassian.cloud/browse/WAR-1557
    const analyticAttributes = (0, $5uXOq.useMemo)(()=>{
        return (0, $4R6GH.fg)('_jira_unread_comments_in_list_view_gate') ? {
            totalCount: typeof totalCount === 'number' ? totalCount : undefined,
            columnIndex: columnIndex,
            ...(0, $6s1PB.expVal)('jira_unread_comments_in_list_view', 'isEnabled', false) ? {
                issueHasUnreadComment: hasUnread
            } : {}
        } : undefined;
    }, [
        columnIndex,
        hasUnread,
        totalCount
    ]);
    const handleClick = (0, $5uXOq.useCallback)(()=>{
        onClick(issueKey, analyticAttributes);
    }, [
        onClick,
        issueKey,
        analyticAttributes
    ]);
    const handleKeyDownNew = (0, $5uXOq.useCallback)((event)=>{
        if (event.code === 'Enter') {
            onClick(issueKey, analyticAttributes);
            return true;
        }
        return false;
    }, [
        analyticAttributes,
        issueKey,
        onClick
    ]);
    const cellOverrides = (0, $5uXOq.useCallback)(()=>({
            onKeyDown: handleKeyDownNew,
            onClick: ()=>true
        }), [
        handleKeyDownNew
    ]);
    (0, $5uXOq.useImperativeHandle)(cellRef, cellOverrides, [
        cellOverrides
    ]);
    const renderedCommentCount = (0, $5uXOq.useMemo)(()=>{
        if (totalCount == null) return null;
         // No comments, add comment
        if (totalCount === 0) return formatMessage((0, $kzK6P.default).addComment);
         // Less than 100 comments, show count
        if (totalCount < 100) return formatMessage((0, $kzK6P.default).commentsCount, {
            commentCount: totalCount
        });
         // More than 99 comments, show 99+
        return formatMessage((0, $kzK6P.default).moreComments);
    }, [
        formatMessage,
        totalCount
    ]);
    const cellContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($28e29ee490039ab9$export$6ce170286acaa8d3, {
        noComments: totalCount === 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bFmnZ))), {
        color: "currentColor",
        label: formatMessage((0, $kzK6P.default).comments),
        LEGACY_size: "medium",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($DBbS0)))
    }), renderedCommentCount));
    const newCellContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $28e29ee490039ab9$var$contentWrapperNewStyles,
            (0, $dCm1o.isVisualRefreshEnabled)() && $28e29ee490039ab9$var$refreshedContentWrapperStyles,
            totalCount === 0 && $28e29ee490039ab9$var$noCommentsStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bFmnZ))), {
        color: "currentColor",
        label: formatMessage((0, $kzK6P.default).comments),
        LEGACY_size: "medium",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($DBbS0)))
    }), hasUnread && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($28e29ee490039ab9$var$UnreadIndicator, null), renderedCommentCount);
    const content = (0, $6s1PB.expVal)('jira_unread_comments_in_list_view', 'isEnabled', false) ? newCellContent : cellContent;
    return (0, $4R6GH.fg)('custom-interactive-elements-not-keyboard-focusable') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
        backgroundColor: "color.background.neutral.subtle",
        xcss: $28e29ee490039ab9$var$wrapperStyles,
        onClick: handleClick
    }, content) : // eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $28e29ee490039ab9$var$wrapperStyles,
        onClick: handleClick
    }, content);
};
const $28e29ee490039ab9$var$UnreadIndicator = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $28e29ee490039ab9$var$unreadIndicatorStyles,
            (0, $dCm1o.isVisualRefreshEnabled)() && $28e29ee490039ab9$var$refreshedIndicatorStyles
        ],
        testId: "business-list.ui.list-view.comments-cell.unread"
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $28e29ee490039ab9$export$6ce170286acaa8d3 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { noComments: noComments, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _4t3i1osq _7yhb1b66",
            __cmplp.noComments ? "_syaz131l" : "_syaz1x9z",
            __cmplp.className
        ])
    });
});
const $28e29ee490039ab9$var$contentWrapperNewStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    position: 'relative',
    gap: 'space.050',
    color: 'color.text.accent.gray.bolder'
});
const $28e29ee490039ab9$var$refreshedContentWrapperStyles = (0, $8CUq3.xcss)({
    gap: 'space.100'
});
const $28e29ee490039ab9$var$noCommentsStyles = (0, $8CUq3.xcss)({
    color: 'color.text.subtlest'
});
const $28e29ee490039ab9$var$wrapperStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    cursor: 'pointer',
    paddingLeft: 'space.100',
    backgroundColor: 'color.background.neutral.subtle'
});
const $28e29ee490039ab9$var$unreadIndicatorStyles = (0, $8CUq3.xcss)({
    position: 'absolute',
    width: "var(--ds-space-075, 6px)",
    height: "var(--ds-space-075, 6px)",
    border: `2px solid ${"var(--ds-surface, #FFFFFF)"}`,
    background: "var(--ds-icon-information, #1D7AFC)",
    borderRadius: "var(--ds-space-075, 6px)",
    boxSizing: 'content-box',
    top: '8px',
    left: '14px'
});
const $28e29ee490039ab9$var$refreshedIndicatorStyles = (0, $8CUq3.xcss)({
    left: '11px'
});

});
parcelRegister("kzK6P", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7bb374695f8a620$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a7bb374695f8a620$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    comments: {
        "id": "business-list.list-view.comments-cell.comments",
        "defaultMessage": "Comments"
    },
    commentsCount: {
        "id": "business-list.list-view.comments-cell.comments-count",
        "defaultMessage": "{commentCount, plural, one {# comment} other {# comments}}"
    },
    moreComments: {
        "id": "business-list.list-view.comments-cell.more-comments",
        "defaultMessage": "99+ comments"
    },
    addComment: {
        "id": "business-list.list-view.comments-cell.add-comment",
        "defaultMessage": "Add comment"
    }
});

});


parcelRegister("bFmRi", function(module, exports) {

$parcel$export(module.exports, "CommentsSidebar", () => $e49b3d0a939d5434$export$46e144cce632afca);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");


var $7eqRV = parcelRequire("7eqRV");

var $lfTZh = parcelRequire("lfTZh");

var $iXVV6 = parcelRequire("iXVV6");

var $lb0Dk = parcelRequire("lb0Dk");

var $kxZPA = parcelRequire("kxZPA");

var $5JdtV = parcelRequire("5JdtV");
const $e49b3d0a939d5434$var$PACKAGE_NAME = 'jwmCommentsSidebarIssueApp';

const $e49b3d0a939d5434$export$35dd9ab573b87c3f = (0, $kxZPA.lazy)(()=>(parcelRequire("6r0bl")), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
});
const $e49b3d0a939d5434$export$46e144cce632afca = /*#__PURE__*/ (0, $5uXOq.memo)(({ issueKey: issueKey, onClose: onClose })=>{
    (0, $5JdtV.useScrollToComments)({
        issueKey: issueKey
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: "businessCommentsSidebarInListView"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7eqRV.IssueBoundary), {
        packageName: $e49b3d0a939d5434$var$PACKAGE_NAME
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e49b3d0a939d5434$var$CSSAntiCorruptionLayer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-app",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lb0Dk.IssueViewSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e49b3d0a939d5434$export$35dd9ab573b87c3f, {
        analyticsSource: (0, $fcf97b7a09088940$export$7ca28938a07e0c33),
        issueKey: issueKey,
        onClose: onClose,
        shouldSetInitialFocus: true,
        shouldShowCloseButton: true,
        shouldShowRootProjectsBreadcrumb: true,
        isSpaEnabled: false,
        isLoadedWithPage: false,
        viewModeOptions: {
            viewMode: 'SIDEBAR'
        }
    })))));
});
/**
 * Used to fix styles of Issue App in Sidebar broken by nested selectors affecting clipboard boundary
 * inline div on feature cleanup
 * remove div on SidebarContent improvement
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e49b3d0a939d5434$var$CSSAntiCorruptionLayer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq _vchhusvi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5JdtV", function(module, exports) {

$parcel$export(module.exports, "useScrollToComments", () => $33ba799027cb914b$export$5baf464300edba1e);

var $5uXOq = parcelRequire("5uXOq");

var $k9tnV = parcelRequire("k9tnV");

var $92wsG = parcelRequire("92wsG");
const $33ba799027cb914b$var$INTERVAL = 100;
const $33ba799027cb914b$var$TIMEOUT = 10000;
// account for Bento's sticky header
const $33ba799027cb914b$var$SCROLL_PADDING = 34;
const $33ba799027cb914b$export$f0c653cfd7dea798 = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const nodes = Array.from(document.querySelectorAll(`#${(0, $92wsG.ELID_ISSUE_HEADER)} + div h2`));
    // take the last H2 inside Bento (comments section header)
    return nodes.length ? nodes[nodes.length - 1] : null;
};
const $33ba799027cb914b$export$5baf464300edba1e = ({ issueKey: issueKey })=>{
    const intervalId = (0, $5uXOq.useRef)();
    const timeoutId = (0, $5uXOq.useRef)();
    const isTimeout = (0, $5uXOq.useRef)(false);
    const waitForElement = (0, $5uXOq.useCallback)(()=>{
        if (isTimeout.current) return;
        const ref = $33ba799027cb914b$export$f0c653cfd7dea798();
        if (ref) // sometimes the browser can't immediately scroll,
        // so we add a small timeout here to let it render Bento first
        setTimeout(()=>{
            ref && (0, $k9tnV.default)(ref, {
                scrollMode: 'always',
                block: 'start',
                inline: 'nearest',
                behavior: (actions)=>actions.forEach(({ el: el, top: top })=>{
                        // eslint-disable-next-line no-param-reassign
                        el.scrollTop = top - $33ba799027cb914b$var$SCROLL_PADDING;
                    })
            });
        }, 300);
        else intervalId.current = setTimeout(waitForElement, $33ba799027cb914b$var$INTERVAL);
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        clearTimeout(intervalId.current);
        clearTimeout(timeoutId.current);
        isTimeout.current = false;
        // clear the interval in case comments section never shows up
        timeoutId.current = setTimeout(()=>{
            isTimeout.current = true;
        }, $33ba799027cb914b$var$TIMEOUT);
        // kick off the interval if issueKey changes + on mount
        intervalId.current = setTimeout(waitForElement, $33ba799027cb914b$var$INTERVAL);
        // clear interval on unmount
        return ()=>{
            clearTimeout(intervalId.current);
            clearTimeout(timeoutId.current);
        };
    }, [
        waitForElement,
        issueKey
    ]);
};

});
parcelRegister("92wsG", function(module, exports) {

$parcel$export(module.exports, "issueAppModalWrapperClassName", () => $fcc2b749aa610036$export$6bf7918be801e6c5);
$parcel$export(module.exports, "MODAL_DROPDOWN_PORTAL_CLASS_NAME", () => $fcc2b749aa610036$export$bab98b619b4558be);
$parcel$export(module.exports, "EDITOR_DROPDOWN_PORTAL_CLASS_NAME", () => $fcc2b749aa610036$export$2ec9dc4e52ec0b5d);
$parcel$export(module.exports, "EDITOR_END_CLASS_NAME", () => $fcc2b749aa610036$export$18cffbebfac64f6d);
$parcel$export(module.exports, "EDITOR_START_CLASS_NAME", () => $fcc2b749aa610036$export$ebb284f63692b8b2);
$parcel$export(module.exports, "ISSUE_DESCRIPTION_EDITOR_ID", () => $fcc2b749aa610036$export$b8a46c806f8a6ef3);
$parcel$export(module.exports, "GIC_ISSUE_DESCRIPTION_EDITOR_ID", () => $fcc2b749aa610036$export$96cae1d6f7d37701);
$parcel$export(module.exports, "ELID_ISSUE_HEADER", () => $fcc2b749aa610036$export$4ca9dd62cc85a6c6);
$parcel$export(module.exports, "ELID_ISSUE_HEADER_ACTIONS", () => $fcc2b749aa610036$export$23d48b936935fa57);
$parcel$export(module.exports, "ELID_ISSUE_ACTIVITY_FEED", () => $fcc2b749aa610036$export$f1f90756574f5f9b);
$parcel$export(module.exports, "AGG_ISSUE_ERROR_ANALYTICS", () => $fcc2b749aa610036$export$66553a9be1be2f7e);
$parcel$export(module.exports, "QUICK_ADD_ITEMS_ADD_BUTTON_REF_KEY", () => $fcc2b749aa610036$export$899103370186f1a1);
$parcel$export(module.exports, "DESIGN_PANEL_HEADING_ADD_DESIGN_REF_KEY", () => $fcc2b749aa610036$export$736b3d7f44d56d71);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $fmm8O = parcelRequire("fmm8O");

var $38bVB = parcelRequire("38bVB");











var $79RqQ = parcelRequire("79RqQ");

const $fcc2b749aa610036$export$6bf7918be801e6c5 = '_issue-app-modal-dialog-wrapper';
const $fcc2b749aa610036$export$bab98b619b4558be = 'issue-app-modal-ak-dropdown-portal';
const $fcc2b749aa610036$export$2ec9dc4e52ec0b5d = 'issue-app-modal-editor-dropdown-portal';
const $fcc2b749aa610036$export$18cffbebfac64f6d = 'issue-editor-end';
const $fcc2b749aa610036$export$ebb284f63692b8b2 = 'issue-editor-start';
const $fcc2b749aa610036$export$b8a46c806f8a6ef3 = 'issue-description-editor';
const $fcc2b749aa610036$export$96cae1d6f7d37701 = 'issue-create.common.ui.fields.description-field.wrapper';
const $fcc2b749aa610036$export$3ef7e400a3598524 = 'issue.error';
const $fcc2b749aa610036$export$4ca9dd62cc85a6c6 = 'jira-issue-header';
const $fcc2b749aa610036$export$23d48b936935fa57 = 'jira-issue-header-actions';
const $fcc2b749aa610036$export$f1f90756574f5f9b = 'jira-issue-activity-feed';
const $fcc2b749aa610036$export$66553a9be1be2f7e = 'issue.error.agg';
const $fcc2b749aa610036$export$899103370186f1a1 = 'quick-add-items.add-button';
const $fcc2b749aa610036$export$736b3d7f44d56d71 = 'design-panel.heading.add-design';

});
parcelRegister("fmm8O", function(module, exports) {

$parcel$export(module.exports, "TOGGLE_WATCHING_ERROR", () => $99d43d51c2dfe210$export$ec8031e221d27341);
$parcel$export(module.exports, "COMMENT_ADD_ERROR_GENERIC", () => $99d43d51c2dfe210$export$78f84210a13989cb);
$parcel$export(module.exports, "COMMENT_ADD_ERROR_INVALID", () => $99d43d51c2dfe210$export$10b0b01977598ffc);
$parcel$export(module.exports, "COMMENT_ACTION_ERROR_INVALID_PERMISSION", () => $99d43d51c2dfe210$export$8443c3b41d7f09d8);
$parcel$export(module.exports, "COMMENT_CONTENT_EXCEEDED_ERROR", () => $99d43d51c2dfe210$export$9b38ca770beaf3d0);
$parcel$export(module.exports, "SAVE_COMMENT_SUCCESS_FLAG_MESSAGE", () => $99d43d51c2dfe210$export$eef81693e817e3a6);
$parcel$export(module.exports, "COMMENT_FUTURE_TIME_ERROR", () => $99d43d51c2dfe210$export$a0d4d86bde270ad6);
$parcel$export(module.exports, "COMMENT_DELETE_ERROR", () => $99d43d51c2dfe210$export$6b6cd1b99772a4a1);
$parcel$export(module.exports, "EDITOR_ERROR", () => $99d43d51c2dfe210$export$2e48be8618f1b4f8);
$parcel$export(module.exports, "ATTACHMENT_ADD_ERROR", () => $99d43d51c2dfe210$export$c060b7873ebc2eb3);
$parcel$export(module.exports, "ATTACHMENT_ADD_EXCEED_SIZE_LIMIT_ERROR", () => $99d43d51c2dfe210$export$1f8e6f6f8d64a715);
$parcel$export(module.exports, "ATTACHMENT_ADD_SUCCESS", () => $99d43d51c2dfe210$export$1f92a25b34c4df93);
$parcel$export(module.exports, "DELETE_LINKED_ISSUE_ERROR", () => $99d43d51c2dfe210$export$d8750340852b965e);
$parcel$export(module.exports, "REMOTE_LINK_VALIDATION_ERROR", () => $99d43d51c2dfe210$export$f0962d071c2a358a);
$parcel$export(module.exports, "ATTACHMENT_DELETE_ERROR", () => $99d43d51c2dfe210$export$ef7767ceecf9097c);
$parcel$export(module.exports, "WATCH_TOGGLE_UPDATE_ERROR", () => $99d43d51c2dfe210$export$516af79f4e3b8794);
$parcel$export(module.exports, "FETCH_WATCHERS_ERROR", () => $99d43d51c2dfe210$export$cde4105f7711a10a);
$parcel$export(module.exports, "STOP_WATCHING_SUCCESS", () => $99d43d51c2dfe210$export$f674d1f44f57f99d);
$parcel$export(module.exports, "START_WATCHING_SUCCESS", () => $99d43d51c2dfe210$export$bff6b5ab70bcec53);
$parcel$export(module.exports, "REMOVE_WATCHER_ERROR", () => $99d43d51c2dfe210$export$37934e343a22c4e6);
$parcel$export(module.exports, "ADD_WATCHER_ERROR", () => $99d43d51c2dfe210$export$6a1827094c1ef6d8);
$parcel$export(module.exports, "SUBTASKS_REORDER_ERROR_GENERIC", () => $99d43d51c2dfe210$export$bb96d519395e5dcc);
$parcel$export(module.exports, "LOG_WORK_CONFIRM_ERROR", () => $99d43d51c2dfe210$export$18bd55ba676f8b6d);
$parcel$export(module.exports, "ASSIGN_TO_ME_SUCCESS", () => $99d43d51c2dfe210$export$1249a100986a9489);
$parcel$export(module.exports, "REMOVE_FROM_ME_SUCCESS", () => $99d43d51c2dfe210$export$6b737093486e5a4e);
$parcel$export(module.exports, "CREATE_CHILD_ISSUE_ERROR", () => $99d43d51c2dfe210$export$a2723f15441225d0);
$parcel$export(module.exports, "LINK_CHILD_ISSUE_ERROR", () => $99d43d51c2dfe210$export$569f7258d337be55);
$parcel$export(module.exports, "CHANGE_ISSUE_TYPE_SUCCESS", () => $99d43d51c2dfe210$export$f92af4e9761d23b9);
$parcel$export(module.exports, "CHANGE_ISSUE_TYPE_ERROR", () => $99d43d51c2dfe210$export$16dc9ff6a8822a90);
$parcel$export(module.exports, "DELETE_ISSUE_ERROR", () => $99d43d51c2dfe210$export$d4030883b7b7a04);
$parcel$export(module.exports, "ADD_WORKLOG_SUCCESS", () => $99d43d51c2dfe210$export$2519b72aefd62ee3);
$parcel$export(module.exports, "ADD_WORKLOG_FAILURE", () => $99d43d51c2dfe210$export$190e4e4a6ee2a0a2);
$parcel$export(module.exports, "WORKLOGS_PER_ISSUE_LIMIT_EXCEEDED", () => $99d43d51c2dfe210$export$f1709ebef49207cc);
$parcel$export(module.exports, "UPDATE_TIME_REMAINING_FAILURE", () => $99d43d51c2dfe210$export$bde55584c7518e8d);
$parcel$export(module.exports, "EDIT_WORKLOG_SUCCESS", () => $99d43d51c2dfe210$export$cf8d549e537c67d3);
$parcel$export(module.exports, "EDIT_WORKLOG_FAILURE", () => $99d43d51c2dfe210$export$2d33e591258e36a8);
$parcel$export(module.exports, "DELETE_WORKLOG_SUCCESS", () => $99d43d51c2dfe210$export$b595535e9bb1a2a2);
$parcel$export(module.exports, "DELETE_WORKLOG_FAILURE", () => $99d43d51c2dfe210$export$c3739a68f63b7e09);
$parcel$export(module.exports, "RICH_CONTENT_FIELD_CONFIRM_ERROR", () => $99d43d51c2dfe210$export$6ba6cb22d5a3c521);
$parcel$export(module.exports, "RICH_CONTENT_FIELD_MAXIMUM_LENGTH_EXCEEDED_ERROR", () => $99d43d51c2dfe210$export$b1a41c9183097dc);
$parcel$export(module.exports, "RICH_CONTENT_FIELD_REQUIRED_ERROR", () => $99d43d51c2dfe210$export$67544887e2b37fbc);
$parcel$export(module.exports, "DELETE_CONFLUENCE_PAGE_LINK_FAILED", () => $99d43d51c2dfe210$export$67566c205c72838a);
$parcel$export(module.exports, "SAVE_APPROVAL_ANSWER_ERROR", () => $99d43d51c2dfe210$export$733fe45ab8c75209);
$parcel$export(module.exports, "SAVE_APPROVAL_ANSWER_SUCCESS", () => $99d43d51c2dfe210$export$9d1386a2d0651ca9);
$parcel$export(module.exports, "EDIT_EPIC_COLOUR_ERROR", () => $99d43d51c2dfe210$export$56094d7f6af14eac);
$parcel$export(module.exports, "EDIT_ISSUE_COLOUR_ERROR", () => $99d43d51c2dfe210$export$92d58445895900f9);
$parcel$export(module.exports, "FETCH_JIRA_APP_LINKS_ERROR", () => $99d43d51c2dfe210$export$75d850be4d27b98e);
$parcel$export(module.exports, "CONFLUENCE_LINKS_PER_ISSUE_LIMIT_EXCEEDED", () => $99d43d51c2dfe210$export$9030bf81702823b8);
$parcel$export(module.exports, "COMMENTS_PER_ISSUE_LIMIT_EXCEEDED", () => $99d43d51c2dfe210$export$a2a71fb6b193e549);
$parcel$export(module.exports, "ISSUE_LINKS_PER_ISSUE_LIMIT_EXCEEDED", () => $99d43d51c2dfe210$export$8c5e4d3dfe9a1c32);
$parcel$export(module.exports, "ISSUE_REMOTE_LINKS_PER_ISSUE_LIMIT_EXCEEDED", () => $99d43d51c2dfe210$export$49d11338d75de478);
$parcel$export(module.exports, "ISSUE_ATTACHMENTS_PER_ISSUE_LIMIT_EXCEEDED", () => $99d43d51c2dfe210$export$3573d8ff428b4c8f);
$parcel$export(module.exports, "COMMENTS_LIMIT_EXCEEDED_FIELDS_LIST", () => $99d43d51c2dfe210$export$c0657c5ed1bbfed4);
const $99d43d51c2dfe210$export$ec8031e221d27341 = 'TOGGLE_WATCHING_ERROR';
const $99d43d51c2dfe210$export$78f84210a13989cb = 'COMMENT_ADD_ERROR_GENERIC';
const $99d43d51c2dfe210$export$10b0b01977598ffc = 'COMMENT_ADD_ERROR_INVALID';
const $99d43d51c2dfe210$export$8443c3b41d7f09d8 = 'COMMENT_ACTION_ERROR_INVALID_PERMISSION';
const $99d43d51c2dfe210$export$9b38ca770beaf3d0 = 'COMMENT_CONTENT_EXCEEDED_ERROR';
const $99d43d51c2dfe210$export$eef81693e817e3a6 = 'SAVE_COMMENT_SUCCESS_FLAG_MESSAGE';
const $99d43d51c2dfe210$export$a0d4d86bde270ad6 = 'COMMENT_FUTURE_TIME_ERROR';
const $99d43d51c2dfe210$export$6b6cd1b99772a4a1 = 'COMMENT_DELETE_ERROR';
const $99d43d51c2dfe210$export$2e48be8618f1b4f8 = 'EDITOR_ERROR';
const $99d43d51c2dfe210$export$c060b7873ebc2eb3 = 'ATTACHMENT_ADD_ERROR';
const $99d43d51c2dfe210$export$1f8e6f6f8d64a715 = 'ATTACHMENT_ADD_EXCEED_SIZE_LIMIT_ERROR';
const $99d43d51c2dfe210$export$1f92a25b34c4df93 = 'ATTACHMENT_ADD_SUCCESS';
const $99d43d51c2dfe210$export$d8750340852b965e = 'DELETE_LINKED_ISSUE_ERROR';
const $99d43d51c2dfe210$export$f0962d071c2a358a = 'REMOTE_LINK_VALIDATION_ERROR';
const $99d43d51c2dfe210$export$ef7767ceecf9097c = 'ATTACHMENT_DELETE_ERROR';
const $99d43d51c2dfe210$export$516af79f4e3b8794 = 'WATCH_TOGGLE_UPDATE_ERROR';
const $99d43d51c2dfe210$export$cde4105f7711a10a = 'FETCH_WATCHERS_ERROR';
const $99d43d51c2dfe210$export$f674d1f44f57f99d = 'STOP_WATCHING_SUCCESS';
const $99d43d51c2dfe210$export$bff6b5ab70bcec53 = 'START_WATCHING_SUCCESS';
const $99d43d51c2dfe210$export$37934e343a22c4e6 = 'REMOVE_WATCHER_ERROR';
const $99d43d51c2dfe210$export$6a1827094c1ef6d8 = 'ADD_WATCHER_ERROR';
const $99d43d51c2dfe210$export$bb96d519395e5dcc = 'SUBTASKS_REORDER_ERROR_GENERIC';
const $99d43d51c2dfe210$export$18bd55ba676f8b6d = 'LOG_WORK_CONFIRM_ERROR';
const $99d43d51c2dfe210$export$1249a100986a9489 = 'ASSIGN_TO_ME_SUCCESS';
const $99d43d51c2dfe210$export$6b737093486e5a4e = 'REMOVE_FROM_ME_SUCCESS';
const $99d43d51c2dfe210$export$a2723f15441225d0 = 'CREATE_CHILD_ISSUE_ERROR';
const $99d43d51c2dfe210$export$569f7258d337be55 = 'LINK_CHILD_ISSUE_ERROR';
const $99d43d51c2dfe210$export$f92af4e9761d23b9 = 'CHANGE_ISSUE_TYPE_SUCCESS';
const $99d43d51c2dfe210$export$16dc9ff6a8822a90 = 'CHANGE_ISSUE_TYPE_ERROR';
const $99d43d51c2dfe210$export$d4030883b7b7a04 = 'DELETE_ISSUE_ERROR';
const $99d43d51c2dfe210$export$2519b72aefd62ee3 = 'ADD_WORKLOG_SUCCESS';
const $99d43d51c2dfe210$export$190e4e4a6ee2a0a2 = 'ADD_WORKLOG_FAILURE';
const $99d43d51c2dfe210$export$f1709ebef49207cc = 'WORKLOGS_PER_ISSUE_LIMIT_EXCEEDED';
const $99d43d51c2dfe210$export$2357f9add92f1c9b = 'UPDATE_TIME_REMAINING_SUCCESS';
const $99d43d51c2dfe210$export$bde55584c7518e8d = 'UPDATE_TIME_REMAINING_FAILURE';
const $99d43d51c2dfe210$export$cf8d549e537c67d3 = 'EDIT_WORKLOG_SUCCESS';
const $99d43d51c2dfe210$export$2d33e591258e36a8 = 'EDIT_WORKLOG_FAILURE';
const $99d43d51c2dfe210$export$b595535e9bb1a2a2 = 'DELETE_WORKLOG_SUCCESS';
const $99d43d51c2dfe210$export$c3739a68f63b7e09 = 'DELETE_WORKLOG_FAILURE';
const $99d43d51c2dfe210$export$6ba6cb22d5a3c521 = 'RICH_CONTENT_FIELD_CONFIRM_ERROR';
const $99d43d51c2dfe210$export$b1a41c9183097dc = 'RICH_CONTENT_FIELD_MAXIMUM_LENGTH_EXCEEDED_ERROR';
const $99d43d51c2dfe210$export$67544887e2b37fbc = 'RICH_CONTENT_FIELD_REQUIRED_ERROR';
const $99d43d51c2dfe210$export$67566c205c72838a = 'DELETE_CONFLUENCE_PAGE_LINK_FAILED';
const $99d43d51c2dfe210$export$e3245a362f751a4a = 'DELETE_WEB_LINK_FAILED';
const $99d43d51c2dfe210$export$3408969e4d418350 = 'CLICKTHROUGH_BANNER_DISMISS_SUCCESS';
const $99d43d51c2dfe210$export$733fe45ab8c75209 = 'SAVE_APPROVAL_ANSWER_ERROR';
const $99d43d51c2dfe210$export$9d1386a2d0651ca9 = 'SAVE_APPROVAL_ANSWER_SUCCESS';
const $99d43d51c2dfe210$export$56094d7f6af14eac = 'EDIT_EPIC_COLOUR_ERROR';
const $99d43d51c2dfe210$export$92d58445895900f9 = 'EDIT_ISSUE_COLOUR_ERROR';
const $99d43d51c2dfe210$export$75d850be4d27b98e = 'FETCH_JIRA_APP_LINKS_ERROR';
const $99d43d51c2dfe210$export$9030bf81702823b8 = 'CONFLUENCE_LINKS_PER_ISSUE_LIMIT_EXCEEDED';
const $99d43d51c2dfe210$export$a2a71fb6b193e549 = 'COMMENTS_PER_ISSUE_LIMIT_EXCEEDED';
const $99d43d51c2dfe210$export$2dd786d54c8f9397 = 'COMMENTS_INTERNAL_SERVER_ERROR';
const $99d43d51c2dfe210$export$8c5e4d3dfe9a1c32 = 'ISSUE_LINKS_PER_ISSUE_LIMIT_EXCEEDED';
const $99d43d51c2dfe210$export$49d11338d75de478 = 'ISSUE_REMOTE_LINKS_PER_ISSUE_LIMIT_EXCEEDED';
const $99d43d51c2dfe210$export$3573d8ff428b4c8f = 'ISSUE_ATTACHMENTS_PER_ISSUE_LIMIT_EXCEEDED';
const $99d43d51c2dfe210$export$c0657c5ed1bbfed4 = [
    $99d43d51c2dfe210$export$a2a71fb6b193e549,
    $99d43d51c2dfe210$export$3573d8ff428b4c8f
];

});

parcelRegister("38bVB", function(module, exports) {

$parcel$export(module.exports, "getChildIssuesLimit", () => $393fc438b9efd4fd$export$89b6937a83edcaa6);
$parcel$export(module.exports, "EXCEEDED_LIMIT_INITIAL_LOAD", () => $393fc438b9efd4fd$export$763881dbba851043);
$parcel$export(module.exports, "EXCEEDED_LIMIT_AFTER_LOAD", () => $393fc438b9efd4fd$export$8a23145a6d5f95e3);
$parcel$export(module.exports, "WITHIN_LIMIT", () => $393fc438b9efd4fd$export$a7af19981a3e4baf);
$parcel$export(module.exports, "HREF", () => $393fc438b9efd4fd$export$74921a9774a80542);
$parcel$export(module.exports, "IN_PRODUCT_HELP", () => $393fc438b9efd4fd$export$cd480f5ec4739dab);
$parcel$export(module.exports, "WHAT_ARE_ISSUE_TYPES_URL", () => $393fc438b9efd4fd$export$470a531b30a8dea1);
$parcel$export(module.exports, "IN_PRODUCT_HELP_ARTICLE_IDS", () => $393fc438b9efd4fd$export$3691506c72823b65);
$parcel$export(module.exports, "DISMISSED", () => $393fc438b9efd4fd$export$6a4add537aaf5560);
$parcel$export(module.exports, "DEFAULT_ASSIGNEE_PERMISSION_ERROR_MESSAGE", () => $393fc438b9efd4fd$export$6d6e3176028f2228);
$parcel$export(module.exports, "DEFAULT_ASSIGNEE_PERMISSION_ERROR_MESSAGE_FE", () => $393fc438b9efd4fd$export$17d19a319fd47c32);
$parcel$export(module.exports, "GIC_CALLBACK_PAYLOAD_INLINE_CREATE_ID", () => $393fc438b9efd4fd$export$9e448086914e060);
$parcel$export(module.exports, "GIC_CALLBACK_PAYLOAD_AI_BREAKDOWN_CREATE_ID", () => $393fc438b9efd4fd$export$2dd6afd9432dbc93);

var $2vSU6 = parcelRequire("2vSU6");
const $393fc438b9efd4fd$var$CHILD_ISSUES_LIMIT = 500;
const $393fc438b9efd4fd$export$89b6937a83edcaa6 = ()=>$393fc438b9efd4fd$var$CHILD_ISSUES_LIMIT;
const $393fc438b9efd4fd$export$763881dbba851043 = 'EXCEEDED_LIMIT_INITIAL_LOAD';
const $393fc438b9efd4fd$export$8a23145a6d5f95e3 = 'EXCEEDED_LIMIT_AFTER_LOAD';
const $393fc438b9efd4fd$export$a7af19981a3e4baf = 'WITHIN_LIMIT';
const $393fc438b9efd4fd$export$74921a9774a80542 = 'HREF';
const $393fc438b9efd4fd$export$cd480f5ec4739dab = 'IN_PRODUCT_HELP';
const $393fc438b9efd4fd$export$470a531b30a8dea1 = 'https://support.atlassian.com/jira-cloud-administration/docs/what-are-issue-types/';
const $393fc438b9efd4fd$export$3691506c72823b65 = {
    [(0, $2vSU6.CORE_PROJECT)]: '2uhc4ieBPinkLJlWbdhXkC',
    [(0, $2vSU6.SOFTWARE_PROJECT)]: 'z6BNb3cPucF3fi5UA85Ma',
    [(0, $2vSU6.SERVICE_DESK_PROJECT)]: '6feRxZzkYUHez8TwHTjSut',
    [(0, $2vSU6.CUSTOMER_SERVICE_PROJECT)]: null,
    [(0, $2vSU6.PRODUCT_DISCOVERY_PROJECT)]: null
};
const $393fc438b9efd4fd$export$6a4add537aaf5560 = 'dismissed';
const $393fc438b9efd4fd$export$6d6e3176028f2228 = 'The default assignee does NOT have ASSIGNABLE permission OR Unassigned issues are turned off.';
const $393fc438b9efd4fd$export$17d19a319fd47c32 = "The default assignee doesn\u2019t have the Assignable User permission, or unassigned issues are turned off.";
const $393fc438b9efd4fd$export$9e448086914e060 = 'issue-view-child-issues-panel-inline-create';
const $393fc438b9efd4fd$export$2dd6afd9432dbc93 = 'issue-view-child-issues-panel-ai-breakdown-create';

});

parcelRegister("79RqQ", function(module, exports) {

$parcel$export(module.exports, "ATTACHMENTS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE", () => $5fa2842a51e11b84$export$dd2d62bc7ec6ce51);
$parcel$export(module.exports, "COMMENTS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE", () => $5fa2842a51e11b84$export$db1ab2b83dc17aa9);
$parcel$export(module.exports, "WORKLOGS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE", () => $5fa2842a51e11b84$export$940ce115dba33e55);
$parcel$export(module.exports, "REMOTE_ISSUE_LINKS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE", () => $5fa2842a51e11b84$export$4ec1f3604b85d553);
$parcel$export(module.exports, "GROUP_VISIBILITY_SETTING_NOT_ENABLED", () => $5fa2842a51e11b84$export$69483322ede4b803);
$parcel$export(module.exports, "ISSUE_LIMIT_FIELDS_ERROR_MESSAGE_LIST", () => $5fa2842a51e11b84$export$e65b95e776ce6f27);
const $5fa2842a51e11b84$export$dd2d62bc7ec6ce51 = 'ATTACHMENTS_PER_ISSUE_LIMIT_EXCEEDED: 2000';
const $5fa2842a51e11b84$export$db1ab2b83dc17aa9 = 'COMMENTS_PER_ISSUE_LIMIT_EXCEEDED: 5000';
const $5fa2842a51e11b84$export$940ce115dba33e55 = 'WORKLOGS_PER_ISSUE_LIMIT_EXCEEDED: 10000';
const $5fa2842a51e11b84$export$4ec1f3604b85d553 = 'REMOTE_ISSUE_LINKS_PER_ISSUE_LIMIT_EXCEEDED: 2000';
const $5fa2842a51e11b84$export$69483322ede4b803 = 'GROUP_VISIBILITY_SETTING_NOT_ENABLED';
const $5fa2842a51e11b84$export$e65b95e776ce6f27 = [
    $5fa2842a51e11b84$export$dd2d62bc7ec6ce51,
    $5fa2842a51e11b84$export$db1ab2b83dc17aa9,
    $5fa2842a51e11b84$export$940ce115dba33e55,
    $5fa2842a51e11b84$export$4ec1f3604b85d553
];

});

const $7e58198413094512$export$bd6f44214f84c29a = 4102;
const $7e58198413094512$export$aa53f670803b96e = 3165;




parcelRegister("3rwUA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c54c7ad473af2c3d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $c54c7ad473af2c3d$var$ComponentsCell = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("c6Zof")), {
    moduleId: "./src/packages/business/list/src/ui/list-view/components-cell/main.tsx"
});
const $c54c7ad473af2c3d$var$AsyncComponentsCell = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "components-cell",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c54c7ad473af2c3d$var$ComponentsCell, props));
var $c54c7ad473af2c3d$export$2e2bcd8739ae039 = $c54c7ad473af2c3d$var$AsyncComponentsCell;

});
parcelRegister("c6Zof", function(module, exports) {

let $8d15aa64884edf5d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8d15aa64884edf5d$var$load("4W01V").then(()=>parcelRequire('lzZqM'));

});


parcelRegister("3Vqf5", function(module, exports) {

$parcel$export(module.exports, "default", () => $5964753ef696e100$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $acknU = parcelRequire("acknU");

var $7qZ1x = parcelRequire("7qZ1x");

var $1I7E8 = parcelRequire("1I7E8");

var $kgoHi = parcelRequire("kgoHi");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $kY99m = parcelRequire("kY99m");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $e0a4D = parcelRequire("e0a4D");

var $gwIPs = parcelRequire("gwIPs");

var $lQE94 = parcelRequire("lQE94");

var $6yeNV = parcelRequire("6yeNV");

var $1p96B = parcelRequire("1p96B");

var $4kK95 = parcelRequire("4kK95");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $DVljb = parcelRequire("DVljb");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

var $f1akg = parcelRequire("f1akg");

var $eTDjN = parcelRequire("eTDjN");

var $lI995 = parcelRequire("lI995");

var $luwkS = parcelRequire("luwkS");

var $7pQZt = parcelRequire("7pQZt");
const $5964753ef696e100$var$DATE_FORMAT_OPTIONS = {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
};
const $5964753ef696e100$var$ALL_NUMERIC_DATE_FORMAT_OPTIONS = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    format: 'dd/mm/yyyy'
};
const $5964753ef696e100$var$NUMERIC_DATE_FORMAT_REGEX = /^[0-9]{1,2}[-/][0-9]{1,2}[-/][0-9]{4}$/;
const $5964753ef696e100$var$INVALID_DATE = 'Invalid Date';
const $5964753ef696e100$var$EMPTY_ARR = [];
const $5964753ef696e100$var$TEST_ID_PREFIX = 'business-list.ui.list-view.date-cell.date-cell';
const $5964753ef696e100$var$CALENDAR_PROPS = {
    style: {
        display: 'inline-block',
        boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #091E4240, 0px 0px 1px #091E424f)"
    }
};
const $5964753ef696e100$var$POPUP_OFFSET = [
    0,
    2 * (0, $gwIPs.gridSize)
];
const $5964753ef696e100$var$DateCell = /*#__PURE__*/ (0, $5uXOq.memo)(({ dateOnly: dateOnly, readOnly: readOnly = false, issueKey: issueKey = '', isDue: isDue = false, onOpenIssueModal: onOpenIssueModal, rowData: rowData, fieldKey: fieldKey, fieldValue: fieldValue = null, fieldType: fieldType = '', wrapperRef: wrapperRef, testId: testId, editMode: editMode = false, setEditMode: setEditMode = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isHovering: isHovering = false, cellRef: cellRef, fieldName: fieldName = '', issueType: issueType = '', issueTypeId: issueTypeId = '', inputValue: inputValue, onInputChange: onInputChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), issueHasUnreadComment: issueHasUnreadComment })=>{
    const locale = (0, $DVljb.useLocale)();
    const weekStartDay = (0, $1p96B.getLocale)(locale)?.options?.weekStartsOn;
    const standardizedLocale = (0, $6yeNV.standardizeLocale)(locale);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatDate: formatDateIntl, formatMessage: formatMessage } = (0, $koVbs.default)();
    const formatDate = (0, $5uXOq.useCallback)((date, dateFormatOptions = $5964753ef696e100$var$DATE_FORMAT_OPTIONS)=>date ? formatDateIntl(date.toLocalDate(), (0, $6s1PB.expVal)('color_due_date_all_views', 'showColoredDueDate', false) ? dateFormatOptions : $5964753ef696e100$var$DATE_FORMAT_OPTIONS) : '', [
        formatDateIntl
    ]);
    const [localizationProvider] = (0, $5uXOq.useState)((0, $7qZ1x.createLocalizationProvider)(standardizedLocale));
    const [{ value: ISOStringValue_, error: error }, { saveValue: saveISOStringValue, resetError: resetError }] = (0, $lQE94.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: dateOnly?.toISOString() || fieldValue
    });
    const ISOStringValue = (0, $5uXOq.useMemo)(()=>{
        /**
     * dateTime -> date conversion
     * This prevents DateOnly.fromISODateString(ISOStringValue) from throwing when copy-pasting values from "Created" to "Due Date"
     */ if (ISOStringValue_ && !(0, $4kK95.DateOnly).isISODateString(ISOStringValue_)) return (0, $4kK95.DateOnly).fromDateAccordingToLocalTime(new Date(ISOStringValue_)).toISOString();
        return ISOStringValue_;
    }, [
        ISOStringValue_
    ]);
    const currentValue = (0, $5uXOq.useMemo)(()=>formatDate(ISOStringValue !== null ? (0, $4kK95.DateOnly).fromISODateString(ISOStringValue) : null), [
        ISOStringValue,
        formatDate
    ]);
    const [textInputValue, setTextInputValue] = [
        inputValue ?? currentValue,
        onInputChange
    ];
    const formatDateString = (0, $5uXOq.useCallback)((dateString)=>dateString === null || dateString === '' ? '' : formatDate((0, $4kK95.DateOnly).fromISODateString(dateString)), [
        formatDate
    ]);
    const saveAndClose = (0, $5uXOq.useCallback)(()=>{
        setEditMode(false);
        if (textInputValue === formatDateString(ISOStringValue)) return;
         // In order to support entering dates with the format '16 Jun 2022',
        // we first attempt to convert the input value into 'dd/mm/yyyy'.
        // If the format is different, an 'Invalid Date' is returned instead
        // Visit https://formatjs.io/docs/intl/#formatdate for more information
        const formattedInputValue = formatDateIntl(new Date(String(textInputValue)), $5964753ef696e100$var$ALL_NUMERIC_DATE_FORMAT_OPTIONS);
        const isFormattedInputValid = // formattedInputValue should have the format 'dd/mm/yyyy' which is checked by regex, the same check is implemented in DateOnly.fromISODateString
        // INVALID_DATE doesn't cover the cases like year 80000, month 01, day 01 which is considered invalid, regex condition checks it!
        formattedInputValue !== $5964753ef696e100$var$INVALID_DATE && $5964753ef696e100$var$NUMERIC_DATE_FORMAT_REGEX.test(formattedInputValue);
        const parsedDate = localizationProvider.parseDate(isFormattedInputValid ? formattedInputValue : String(textInputValue));
        const isEmptyValue = textInputValue === '';
        const isNewDateInputValid = !Number.isNaN(Number(parsedDate)) || isEmptyValue;
        if (isNewDateInputValid) saveISOStringValue(isEmptyValue ? null : (0, $4kK95.DateOnly).fromDateAccordingToLocalTime(new Date(parsedDate)).toISOString(), null, createAnalyticsEvent({}));
        else setTextInputValue(formatDateString(ISOStringValue));
    }, [
        setEditMode,
        textInputValue,
        formatDateString,
        ISOStringValue,
        formatDateIntl,
        localizationProvider,
        saveISOStringValue,
        createAnalyticsEvent,
        setTextInputValue
    ]);
    const handleClick = (0, $5uXOq.useCallback)((event)=>{
        if (!readOnly && !editMode) setEditMode(true);
        if (onOpenIssueModal && rowData) {
            onOpenIssueModal({
                id: rowData.id,
                key: rowData.key
            })(event);
            (0, $4R6GH.fg)('_jira_unread_comments_in_list_view_gate') && (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'dateCell clicked', {
                issueHasUnreadComment: issueHasUnreadComment
            });
        }
        return true;
    }, [
        readOnly,
        editMode,
        onOpenIssueModal,
        rowData,
        setEditMode,
        createAnalyticsEvent,
        issueHasUnreadComment
    ]);
    const handleDateSelect = (0, $5uXOq.useCallback)(({ iso: iso })=>{
        setTextInputValue(formatDate((0, $4kK95.DateOnly).fromISODateString(iso)));
        saveISOStringValue(iso, null, createAnalyticsEvent({}));
        setEditMode(false); // setTimeout used here as there is conflict with textfield autofocus
        setTimeout(()=>{
            wrapperRef?.current?.focus();
        });
    }, [
        setTextInputValue,
        formatDate,
        saveISOStringValue,
        createAnalyticsEvent,
        setEditMode,
        wrapperRef
    ]);
    const handleChange = (0, $5uXOq.useCallback)((e)=>{
        resetError();
        setTextInputValue(e.target.value);
    }, [
        resetError,
        setTextInputValue
    ]);
    const handleKeyDownNew = (0, $5uXOq.useCallback)((e)=>{
        if (readOnly && ![
            'Tab',
            'ArrowUp',
            'ArrowDown',
            'ArrowLeft',
            'ArrowRight'
        ].includes(e.code)) {
            setEditMode(false);
            return true;
        }
        if (editMode) {
            if (!(e.target instanceof HTMLElement)) return;
             // allow keyboard navigation in the datepicker popup component
            if ([
                'Tab',
                'ArrowUp',
                'ArrowDown',
                'ArrowLeft',
                'ArrowRight'
            ].includes(e.code)) return true;
            if ([
                'Enter',
                'Space'
            ].includes(e.code) && [
                `${$5964753ef696e100$var$TEST_ID_PREFIX}--previous-month`,
                `${$5964753ef696e100$var$TEST_ID_PREFIX}--next-month`
            ].includes(e.target.getAttribute('data-testid') ?? '')) return true;
             // save value on hitting enter in text input
            if (e.key === 'Enter' && e.target.nodeName === 'INPUT') {
                saveAndClose();
                return false;
            }
        }
    }, [
        editMode,
        readOnly,
        saveAndClose,
        setEditMode
    ]);
    const defaultDate = ISOStringValue === null || ISOStringValue === '' ? (0, $4kK95.DateOnly).fromDateAccordingToLocalTime(new Date()).toISOString() : ISOStringValue;
    const defaultDateOnly = (0, $4kK95.DateOnly).fromISODateString(defaultDate);
    const dateOnlyToday = (0, $4kK95.DateOnly).fromDateAccordingToLocalTime(new Date());
    const dateOnlyFromISOString = ISOStringValue !== null ? (0, $4kK95.DateOnly).fromISODateString(ISOStringValue) : null;
    const pastDue = Boolean(isDue && dateOnlyFromISOString && (0, $4kK95.DateOnly).compare(dateOnlyFromISOString, dateOnlyToday) < 0);
    const dueToday = Boolean(isDue && dateOnlyFromISOString && (0, $4kK95.DateOnly).compare(dateOnlyFromISOString, dateOnlyToday) === 0);
    const staticContent = (0, $5uXOq.useMemo)(()=>{
        const renderDate = ()=>{
            if (ISOStringValue) {
                if ((0, $dCm1o.isVisualRefreshEnabled)()) {
                    if ((0, $6s1PB.expVal)('color_due_date_all_views', 'showColoredDueDate', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f1akg.ColoredDueDate), {
                        dateString: ISOStringValue,
                        pastDue: pastDue,
                        dueToday: dueToday,
                        clockIconTestId: "business-list.ui.list-view.date-cell.clock-icon",
                        warningIconTestId: "business-list.ui.list-view.date-cell.warning-icon",
                        calendarIconTestId: "business-list.ui.list-view.date-cell.calendar-icon"
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
                        xcss: [
                            $5964753ef696e100$var$dateTagStyles,
                            pastDue ? $5964753ef696e100$var$overdueStyles : $5964753ef696e100$var$normalDateStyles
                        ]
                    }, formatDate(dateOnlyFromISOString));
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5964753ef696e100$var$DateLozenge, {
                    id: !pastDue ? (0, $eTDjN.DATE_LOZENGE_ID) : '',
                    pastDue: pastDue
                }, formatDate(dateOnlyFromISOString));
            }
        };
        return ISOStringValue !== null && ISOStringValue !== '' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            xcss: $5964753ef696e100$var$dateLozengeStyles,
            justifyContent: "start",
            alignItems: "center"
        }, renderDate());
    }, [
        ISOStringValue,
        pastDue,
        dueToday,
        dateOnlyFromISOString,
        formatDate
    ]);
    const popupContent = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5964753ef696e100$var$DropdownWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luwkS.default), {
            defaultSelected: [
                defaultDate
            ],
            defaultDay: defaultDateOnly.getDay(),
            defaultMonth: defaultDateOnly.getMonth(),
            defaultYear: defaultDateOnly.getYear(),
            defaultPreviouslySelected: $5964753ef696e100$var$EMPTY_ARR,
            defaultDisabled: $5964753ef696e100$var$EMPTY_ARR,
            innerProps: $5964753ef696e100$var$CALENDAR_PROPS,
            onSelect: handleDateSelect,
            locale: standardizedLocale,
            testId: $5964753ef696e100$var$TEST_ID_PREFIX,
            weekStartDay: weekStartDay
        })), [
        defaultDate,
        defaultDateOnly,
        handleDateSelect,
        standardizedLocale,
        weekStartDay
    ]);
    const popupTrigger = (0, $5uXOq.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", triggerProps, editMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5964753ef696e100$var$DateForm, {
            "data-testid": "business-list.ui.list-view.date-cell.form"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
            appearance: "none",
            value: textInputValue,
            autoFocus: true,
            onChange: handleChange,
            placeholder: localizationProvider.formatDate(new Date(new Date().getTime()))
        })) : staticContent, (ISOStringValue === null || ISOStringValue === '') && !editMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lI995.EmptyCellContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acknU))), {
            spacing: "spacious",
            label: formatMessage((0, $7pQZt.default).emptyDate)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, formatMessage((0, $7pQZt.default).emptyDate)))), [
        editMode,
        textInputValue,
        handleChange,
        localizationProvider,
        staticContent,
        ISOStringValue,
        formatMessage
    ]);
    const content = (0, $5uXOq.useMemo)(()=>isHovering || editMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
            isOpen: editMode,
            placement: "bottom-start",
            offset: $5964753ef696e100$var$POPUP_OFFSET,
            autoFocus: false,
            content: popupContent,
            trigger: popupTrigger
        }) : staticContent, [
        staticContent,
        editMode,
        isHovering,
        popupContent,
        popupTrigger
    ]);
    const cellOverrides = (0, $5uXOq.useMemo)(()=>()=>({
                onClick: handleClick,
                onKeyDown: handleKeyDownNew
            }), [
        handleClick,
        handleKeyDownNew
    ]);
    (0, $5uXOq.useImperativeHandle)(cellRef, cellOverrides, [
        cellOverrides
    ]);
    const dateCell = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, content, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0a4D.FixItErrorFlag), {
        error: error,
        title: (0, $7pQZt.default).errorTitle,
        description: (0, $7pQZt.default).errorMessage,
        issueType: issueType,
        issueTypeId: issueTypeId,
        fieldId: fieldKey,
        fieldName: fieldName
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5964753ef696e100$var$DateContainerNew, {
        "data-testid": testId,
        tabIndex: 0
    }, dateCell);
});
var $5964753ef696e100$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $5964753ef696e100$var$DateCell;
const $5964753ef696e100$var$DateForm = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "form", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkv77o _2hwxv77o _otyrv77o _18u0v77o",
            __cmplp.className
        ])
    });
}); // this is used to position the Popup while its loading the async content
const $5964753ef696e100$var$DropdownWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1tke1mjv _1ul9nklw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5964753ef696e100$var$DateContainerNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bsbmslj _4t3i1osq _xmji1r31 _gxxuglyw _34ir1o36 _k2u01osq _8jdu1osq _h61aze3t _1pchze3t _1bayze3t _lmlqu2gc",
            __cmplp.className
        ])
    });
});
const $5964753ef696e100$var$dateLozengeStyles = (0, $8CUq3.xcss)({
    width: '100%',
    paddingLeft: 'space.075'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5964753ef696e100$var$DateLozenge = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { pastDue: pastDue, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoglpi _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66 _lcxvglyw",
            __cmplp.pastDue ? "_11q71gly" : "_11q7m7j4",
            __cmplp.pastDue ? "_syaz1tmw" : "_syaz1gjq",
            __cmplp.className
        ])
    });
});
const $5964753ef696e100$var$dateTagStyles = (0, $8CUq3.xcss)({
    borderStyle: 'solid',
    borderRadius: 'border.radius',
    borderWidth: 'border.width',
    paddingLeft: 'space.075',
    paddingRight: 'space.075',
    paddingTop: 'space.025',
    paddingBottom: 'space.025'
});
const $5964753ef696e100$var$overdueStyles = (0, $8CUq3.xcss)({
    color: 'color.text.danger',
    borderColor: 'color.border.danger'
});
const $5964753ef696e100$var$normalDateStyles = (0, $8CUq3.xcss)({
    color: 'color.text',
    borderColor: 'color.border'
});

});
parcelRegister("acknU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9571ec76557171a7f54748c218c48225>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $76cad653a4883392$var$_react = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $76cad653a4883392$var$_calendar = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("3fesp")));

var $76cad653a4883392$var$_calendar2 = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("cTemL")));
function $76cad653a4883392$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CalendarIcon.
 * This component is CalendarIcon, with `UNSAFE_fallbackIcon` set to "CalendarIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $76cad653a4883392$var$CalendarIcon = (props)=>/*#__PURE__*/ $76cad653a4883392$var$_react.default.createElement($76cad653a4883392$var$_calendar.default, Object.assign({
        LEGACY_fallbackIcon: $76cad653a4883392$var$_calendar2.default
    }, props));
$76cad653a4883392$var$CalendarIcon.Name = 'CalendarIconMigration';
var $76cad653a4883392$var$_default = module.exports.default = $76cad653a4883392$var$CalendarIcon;

});

parcelRegister("7qZ1x", function(module, exports) {

$parcel$export(module.exports, "createLocalizationProvider", () => $71bdd27445bf5301$export$ea56ca58f08ffa52);

var $lCAti = parcelRequire("lCAti");

var $is0Fy = parcelRequire("is0Fy");

var $1cWOp = parcelRequire("1cWOp");
const $71bdd27445bf5301$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $lCAti.normalizeLocale)(locale);
    const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
    const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(date);
    const getDays = (weekStartDay = 0, length)=>{
        const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
            weekday: length
        });
        // Right now there is no way to find out first day of the week based on Intl (locale)
        // api. Check issue here: https://github.com/tc39/ecma402/issues/6
        // So we rotate the weekdays based on #weekStartDay parameter.
        const weekdays = [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ];
        const rotatedWeekdays = weekStartDay > 0 ? [
            ...weekdays.slice(weekStartDay),
            ...weekdays.slice(0, weekStartDay)
        ] : weekdays;
        return rotatedWeekdays.map((day)=>{
            // Some short days are longer than 3 characters but are unique if the first
            // three non-white characters are used.
            const result = dayFormatter// Date range chosen which has a Sun-Sat range so we can extract the names
            .format(new Date(2000, 9, day + 1, 12))// \u200E matches on the Left-to-Right Mark character in IE/Edge
            .replace(/[\s\u200E]/g, '');
            // If short days, only return first three characters. Else return whole thing
            if (length === 'short') return result.substring(0, 3);
            else return result;
        });
    };
    const getDaysShort = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'short');
    };
    const getDaysLong = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'long');
    };
    const getMonthsLong = ()=>{
        const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
            month: 'long'
        });
        return [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map((month)=>// Date chosen for no real reason, the only important part is the month
            // Using 2020 'cos Safari has a faulty implementation when we use the year 2000
            // Intl.DateTimeFormat("en-US", { month: 'long'}).format(new Date(2000, 3, 1))
            // should give "April" but gives "March" in Safari
            monthFormatter.format(new Date(2020, month, 1)));
    };
    const parseDate = (date, options = {})=>(0, $is0Fy.createDateParser)(normalizedLocale)(date, options);
    const formatToParts = (date = new Date())=>{
        const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
        /**
		 * Safari has a bug that returns the wrong month for years 2005 and before.
		 * The error occurs when the passed date has been created with numbers, like new Date(2000, 3, 1)
		 * Not all the months fail in each year. To ensure the correct output,
		 * we select 2020 as the base year for the whole date,
		 * then we replace in the result the original input year
		 */ const fixedDate = new Date(date);
        fixedDate.setFullYear(2020);
        const fixedParts = (0, $1cWOp.toFormattedParts)(formatter.formatToParts(fixedDate));
        const originalParts = (0, $1cWOp.toFormattedParts)(formatter.formatToParts(date));
        if (fixedParts.year) fixedParts.year = originalParts.year;
        /**
		 * Chrome has a bug that returns hour="00" when it's 12:00pm in certain languages
		 * We fix it by detecting the real time with getHours method
		 */ if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
        return fixedParts;
    };
    return {
        getDaysShort: getDaysShort,
        getDaysLong: getDaysLong,
        getMonthsLong: getMonthsLong,
        formatDate: formatDate,
        formatTime: formatTime,
        parseDate: parseDate,
        formatToParts: formatToParts
    };
};

});
parcelRegister("lCAti", function(module, exports) {

$parcel$export(module.exports, "normalizeLocale", () => $13af55a9724edafd$export$dca0327c9b9c6498);
const $13af55a9724edafd$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');

});

parcelRegister("is0Fy", function(module, exports) {

$parcel$export(module.exports, "createDateParser", () => $d8bb223589902df4$export$cfa2ef2687faeda2);

var $lCAti = parcelRequire("lCAti");

var $3wYKB = parcelRequire("3wYKB");
const $d8bb223589902df4$var$INVALID_DATE = new Date(NaN);
const $d8bb223589902df4$var$INVARIANT = {
    year: 1993,
    month: 2,
    day: 18
};
const $d8bb223589902df4$var$INVARIANT_DATE = (0, $3wYKB.toDate)($d8bb223589902df4$var$INVARIANT);
const $d8bb223589902df4$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
const $d8bb223589902df4$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
// Internet Explorer returns non-printing characters when formatting a date
const $d8bb223589902df4$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
const $d8bb223589902df4$var$extractDateParts = (matchResult)=>{
    return matchResult// Get the 3 capture groups
    .splice(1, 4)// Convert them to numbers
    .map((datePart)=>parseInt(datePart, 10));
};
const $d8bb223589902df4$export$cfa2ef2687faeda2 = (locale)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $lCAti.normalizeLocale)(locale);
    const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
    // Generate a date string from a hard coded date, this allows us to determine
    // the year/month/day position for the provided locale.
    const rawDateString = dateFormatter.format($d8bb223589902df4$var$INVARIANT_DATE);
    const shortDate = $d8bb223589902df4$var$stripExtras(rawDateString);
    // Extract the date pieces from the locale formatted date string
    const formatMatch = shortDate.match($d8bb223589902df4$var$FORMAT_EXTRACTOR_REGEX);
    if (!formatMatch) throw new Error('Unable to create DateParser');
    const formatParts = $d8bb223589902df4$var$extractDateParts(formatMatch);
    // Find the year/month/day positions of the locale formatted invariant date
    const yearPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.year);
    const monthPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.month);
    const dayPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.day);
    return (date, options = {})=>{
        const dateMatch = $d8bb223589902df4$var$stripExtras(date).match($d8bb223589902df4$var$DATE_PARSER_REGEX);
        if (!dateMatch) return $d8bb223589902df4$var$INVALID_DATE;
        const dateParts = $d8bb223589902df4$var$extractDateParts(dateMatch);
        // Use the previously extracted year/month/day positions to extract each
        // date piece.
        const extractedDate = {
            year: dateParts[yearPosition],
            month: dateParts[monthPosition],
            day: dateParts[dayPosition]
        };
        const normalizedDate = (0, $3wYKB.normalizeDate)(extractedDate, options?.defaultFirstDay);
        if (!(0, $3wYKB.isValid)(normalizedDate)) return $d8bb223589902df4$var$INVALID_DATE;
        return (0, $3wYKB.toDate)(normalizedDate);
    };
};

});
parcelRegister("3wYKB", function(module, exports) {

$parcel$export(module.exports, "toDate", () => $121d324fc62f760d$export$e67a095c620b86fe);
$parcel$export(module.exports, "isValid", () => $121d324fc62f760d$export$1ea939691cdc45b8);
$parcel$export(module.exports, "normalizeDate", () => $121d324fc62f760d$export$fcc71269590ba0a8);
/**
 * A numerical representation of a date:
 *  - year: any positive integer
 *  - month: 1 - 12 (Jan - Dec)
 *  - day: 1 - [28, 29, 30, 31] (depending on month)
 */ const $121d324fc62f760d$export$abe96da78d4f59dd = (date)=>({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
    });
const $121d324fc62f760d$export$e67a095c620b86fe = (date)=>// The 'proper' month is stored in a DateObj but Date expects month index
    new Date(date.year, date.month - 1, date.day);
const $121d324fc62f760d$export$553d7fa8e3805fc0 = (year)=>{
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};
const $121d324fc62f760d$export$f645ddd439eb259d = (year, month)=>{
    // February depends on leap year
    if (month === 2 && $121d324fc62f760d$export$553d7fa8e3805fc0(year)) return 29;
    return [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][month - 1];
};
const $121d324fc62f760d$export$1ea939691cdc45b8 = (date)=>{
    const { year: year, month: month, day: day } = date;
    const daysInMonth = $121d324fc62f760d$export$f645ddd439eb259d(year, month);
    return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
};
const $121d324fc62f760d$export$fcc71269590ba0a8 = (date, defaultFirstDay = false)=>{
    const now = $121d324fc62f760d$export$abe96da78d4f59dd(new Date());
    const { year: year, month: month, day: day } = date;
    // 19 should evaluate to 2019
    const fullYear = year < 100 ? 2000 + year : year;
    // Missing date pieces are filled in with their current date values
    const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
    const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
    const normalizedDay = !isNaN(day) && day !== 0 ? day : month !== 0 && defaultFirstDay ? 1 : now.day;
    return {
        year: normalizedYear,
        month: normalizedMonth,
        day: normalizedDay
    };
};

});


parcelRegister("1cWOp", function(module, exports) {

$parcel$export(module.exports, "toFormattedParts", () => $56bd04270448c035$export$9b7ca29af37c192);
const $56bd04270448c035$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
            ...result,
            [datePart.type]: datePart.value
        }), {});

});


parcelRegister("6yeNV", function(module, exports) {

$parcel$export(module.exports, "standardizeLocale", () => $e3b19be89da6c3f8$export$ca06804549ae25fb);
$parcel$export(module.exports, "verifyTimeZone", () => $e3b19be89da6c3f8$export$93ff13646da25bd);

var $lzeFL = parcelRequire("lzeFL");

var $2YZCu = parcelRequire("2YZCu");
const $e3b19be89da6c3f8$export$95b7602913551865 = 'en-US';
const $e3b19be89da6c3f8$export$ca06804549ae25fb = (jiraLocale)=>{
    if (typeof jiraLocale !== 'string') {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('jira-issue-format-date.standardize-locale', `Invalid input type for locale was passed in: ${jiraLocale}. Falling back to ${$e3b19be89da6c3f8$export$95b7602913551865}.`);
        return $e3b19be89da6c3f8$export$95b7602913551865;
    }
    const standardizedLocale = jiraLocale.replace('_', '-');
    switch(standardizedLocale){
        case 'en':
            return 'en-US';
        case 'en-UK':
            return 'en-GB';
        default:
            if (!(0, $lzeFL.default).includes(jiraLocale)) (0, $2YZCu.default).safeWarnWithoutCustomerData('jira-issue-format-date.standardize-locale', `Discovered unsupported locale: ${jiraLocale}. This value was not modified, but its use may lead to unpredictable behaviour for formatting.`);
            return standardizedLocale;
    }
};
const $e3b19be89da6c3f8$export$93ff13646da25bd = (timeZone)=>{
    try {
        Intl.DateTimeFormat($e3b19be89da6c3f8$export$95b7602913551865, {
            timeZone: timeZone
        });
        return timeZone;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('jira-issue-format-date.verify-time-zone', `Invalid timeZone: ${String(timeZone)}. Date time formatting cannot be performed with this value. Falling back to undefined`, error);
        return undefined;
    }
};

});

parcelRegister("f1akg", function(module, exports) {

$parcel$export(module.exports, "ColoredDueDate", () => $3f739dd1d004c9d2$export$63c54814247cca36);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $jpopi = parcelRequire("jpopi");

var $acknU = parcelRequire("acknU");

var $hyKRO = parcelRequire("hyKRO");

var $jCESp = parcelRequire("jCESp");

var $3bDjY = parcelRequire("3bDjY");

var $DVljb = parcelRequire("DVljb");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $1eyaH = parcelRequire("1eyaH");

var $cpjnU = parcelRequire("cpjnU");

var $CKlOf = parcelRequire("CKlOf");
const $3f739dd1d004c9d2$var$RecurringWorkItemIcon = ({ testId: testId })=>{
    const { issueProperties: issueProperties, isUpdatingRule: isUpdatingRule } = (0, $1eyaH.useRecurWorkItemState)();
    if (!issueProperties && !isUpdatingRule || (0, $cpjnU.isRecurOnCompleteToggleRule)(issueProperties)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jpopi))), {
        label: "",
        testId: testId
    });
};
const $3f739dd1d004c9d2$export$63c54814247cca36 = ({ dateString: dateString, pastDue: pastDue, dueToday: dueToday, warningIconTestId: warningIconTestId, clockIconTestId: clockIconTestId, calendarIconTestId: calendarIconTestId, tooltipTestId: tooltipTestId, isShortFormat: isShortFormat = false, maybeShowRecurIcon: maybeShowRecurIcon = false, recurIconTestId: recurIconTestId })=>{
    const locale = (0, $DVljb.useLocale)();
    const localeString = locale.replace('_', '-');
    const formatter = new Intl.DateTimeFormat(localeString, {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        timeZone: 'UTC'
    });
    const parts = formatter.formatToParts(new Date(dateString));
    const formatDateParts = ({ dateParts: dateParts, includeYear: includeYear = true })=>{
        let result = '';
        dateParts.forEach((part, index)=>{
            const nextPart = dateParts[index + 1];
            const skipCurrentPart = nextPart?.type === 'timeZoneName' && part.type === 'literal' && part.value === ', ';
            if (!skipCurrentPart && (part.type === 'year' && includeYear || part.type !== 'year' && part.type !== 'timeZoneName')) result += part.value;
        });
        return result;
    };
    const displayDate = isShortFormat ? formatDateParts({
        dateParts: parts,
        includeYear: false
    }) : formatDateParts({
        dateParts: parts
    });
    const tooltipDate = formatDateParts({
        dateParts: parts,
        includeYear: true
    });
    const dueMessage = pastDue ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $CKlOf.messages).overdue,
        values: {
            date: tooltipDate
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $CKlOf.messages).due,
        values: {
            date: tooltipDate
        }
    });
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const iconLabel = pastDue ? formatMessage((0, $CKlOf.messages).overdue, {
        date: tooltipDate
    }) : formatMessage((0, $CKlOf.messages).due, {
        date: tooltipDate
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: dueMessage,
        position: "top",
        testId: tooltipTestId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $3f739dd1d004c9d2$var$styles.dateTag,
            $3f739dd1d004c9d2$var$styles.flexContainer,
            pastDue ? $3f739dd1d004c9d2$var$styles.overdue : undefined,
            dueToday ? $3f739dd1d004c9d2$var$styles.dueToday : undefined,
            !pastDue && !dueToday ? $3f739dd1d004c9d2$var$styles.normalDate : undefined
        ],
        testId: "coloured-due-date.ui.colored-due-date-container",
        tabIndex: 0,
        role: "button",
        "aria-label": iconLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $3f739dd1d004c9d2$var$styles.dueDateIcon,
        testId: "coloured-due-date.ui.tooltip-container"
    }, pastDue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jCESp))), {
        LEGACY_size: "medium",
        label: iconLabel,
        color: "var(--ds-text-danger, #AE2E24)",
        testId: warningIconTestId
    }), dueToday && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hyKRO))), {
        LEGACY_size: "medium",
        label: iconLabel,
        color: "var(--ds-text-warning, #A54800)",
        testId: clockIconTestId
    }), !dueToday && !pastDue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acknU))), {
        label: iconLabel,
        color: "var(--ds-text, #172B4D)",
        LEGACY_size: "medium",
        testId: calendarIconTestId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "aria-hidden": "true"
    }, displayDate), maybeShowRecurIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3f739dd1d004c9d2$var$RecurringWorkItemIcon, {
        testId: recurIconTestId
    })));
};
const $3f739dd1d004c9d2$var$styles = {
    dateTag: (0, $8CUq3.xcss)({
        paddingLeft: 'space.075',
        paddingRight: 'space.075',
        borderStyle: 'solid',
        borderRadius: 'border.radius.100',
        borderWidth: 'border.width',
        color: 'color.text',
        cursor: 'pointer'
    }),
    flexContainer: (0, $8CUq3.xcss)({
        display: 'flex',
        alignItems: 'center',
        gap: 'space.050'
    }),
    overdue: (0, $8CUq3.xcss)({
        color: 'color.text.danger',
        borderColor: 'color.border.danger'
    }),
    dueToday: (0, $8CUq3.xcss)({
        color: 'color.text.warning',
        borderColor: 'color.border.warning'
    }),
    normalDate: (0, $8CUq3.xcss)({
        color: 'color.text',
        borderColor: 'color.border'
    }),
    dueDateIcon: (0, $8CUq3.xcss)({
        display: 'flex',
        alignItems: 'center'
    })
};

});
parcelRegister("jpopi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a88758e67a65d8683bdcd5e828d8b686>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e21348dd48989821$var$_react = $e21348dd48989821$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e21348dd48989821$var$_baseNew = $e21348dd48989821$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $e21348dd48989821$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Repeat".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for setting objects to recur (eg Work items, Forms)
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e21348dd48989821$var$RepeatIcon = (props)=>/*#__PURE__*/ $e21348dd48989821$var$_react.default.createElement($e21348dd48989821$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m8.78 3.72-3-3-1.06 1.06L6.44 3.5H4.5a4.5 4.5 0 0 0 0 9h1V11h-1a3 3 0 0 1 0-6h1.94L4.72 6.72l1.06 1.06 3-3a.75.75 0 0 0 0-1.06M11.5 5a3 3 0 1 1 0 6H9.56l1.72-1.72-1.06-1.06-3 3a.75.75 0 0 0 0 1.06l3 3 1.06-1.06-1.72-1.72h1.94a4.5 4.5 0 1 0 0-9h-1V5z" clip-rule="evenodd"/>`
    }, props));
$e21348dd48989821$var$RepeatIcon.displayName = 'RepeatIcon';
var $e21348dd48989821$var$_default = module.exports.default = $e21348dd48989821$var$RepeatIcon;

});

parcelRegister("jCESp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::22f154a5d93289d4bcc4dadb1207abea>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e49146301a0d3a89$var$_react = $e49146301a0d3a89$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e49146301a0d3a89$var$_baseNew = $e49146301a0d3a89$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $e49146301a0d3a89$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WarningOutline".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Low-impact warnings. Overdue dates in Atlassian Home.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e49146301a0d3a89$var$WarningOutlineIcon = (props)=>/*#__PURE__*/ $e49146301a0d3a89$var$_react.default.createElement($e49146301a0d3a89$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.7 1.384c.996-1.816 3.605-1.818 4.602-.003l5.35 9.73C16.612 12.86 15.346 15 13.35 15H2.667C.67 15-.594 12.862.365 11.113zm3.288.72a1.125 1.125 0 0 0-1.972 0l-5.336 9.73c-.41.75.132 1.666.987 1.666H13.35c.855 0 1.398-.917.986-1.667z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M7.25 9V4h1.5v5z" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$e49146301a0d3a89$var$WarningOutlineIcon.displayName = 'WarningOutlineIcon';
var $e49146301a0d3a89$var$_default = module.exports.default = $e49146301a0d3a89$var$WarningOutlineIcon;

});

parcelRegister("1eyaH", function(module, exports) {

$parcel$export(module.exports, "RecurWorkItemContainer", () => $299cd71373520f02$export$32458a51e0870d6c);
$parcel$export(module.exports, "useRecurWorkItemState", () => $299cd71373520f02$export$5730c874dfb9803f);
$parcel$export(module.exports, "useRecurWorkItemActions", () => $299cd71373520f02$export$eb9ad4e1e739768e);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");

var $koeKL = parcelRequire("koeKL");

var $2tT7R = parcelRequire("2tT7R");

var $93Yeu = parcelRequire("93Yeu");

var $cYlk7 = parcelRequire("cYlk7");

var $2YZCu = parcelRequire("2YZCu");

var $hVn1P = parcelRequire("hVn1P");

var $lQupu = parcelRequire("lQupu");
const $299cd71373520f02$var$RecurWorkItemStoreContainer = (0, $gg7kZ.createContainer)();
const $299cd71373520f02$export$32458a51e0870d6c = ({ children: children, issueKey: issueKey })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const environment = (0, $2tT7R.useEnvironment)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const projectId = (0, $93Yeu.useProjectId)(projectKey);
    const { data: currentUser } = (0, $cYlk7.useCurrentUser)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    if (!projectId) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('jira-recur-work-item.src.controllers.RecurWorkItemContainer', 'Error initialising RecurWorkItemContainer, could not retrieve projectId');
        return children;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($299cd71373520f02$var$RecurWorkItemStoreContainer, {
        scope: `recur-${issueKey}`,
        issueKey: issueKey,
        environment: environment,
        cloudId: cloudId,
        currentUserAccountId: currentUser.user.accountId,
        projectId: projectId,
        createAnalyticsEvent: createAnalyticsEvent
    }, children);
};
const $299cd71373520f02$export$390f32400eaf98c9 = (0, $iXqE5.createStore)({
    name: 'RecurWorkItemStore',
    initialState: (0, $lQupu.INITIAL_STATE),
    actions: $hVn1P.actions,
    containedBy: $299cd71373520f02$var$RecurWorkItemStoreContainer,
    handlers: {
        onInit: ()=>async ({ dispatch: dispatch })=>{
                await dispatch((0, $hVn1P.actions).fetch());
            }
    }
});
const $299cd71373520f02$export$6630e454597fb59c = (0, $3sQ5x.createHook)($299cd71373520f02$export$390f32400eaf98c9);
const $299cd71373520f02$export$5730c874dfb9803f = (0, $3sQ5x.createStateHook)($299cd71373520f02$export$390f32400eaf98c9);
const $299cd71373520f02$export$eb9ad4e1e739768e = (0, $3sQ5x.createActionsHook)($299cd71373520f02$export$390f32400eaf98c9);

});
parcelRegister("hVn1P", function(module, exports) {

$parcel$export(module.exports, "actions", () => $a7f343d49f172fdb$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $7Sl82 = parcelRequire("7Sl82");

var $l9xxv = parcelRequire("l9xxv");

var $bvhsR = parcelRequire("bvhsR");

var $c8g0F = parcelRequire("c8g0F");
const $a7f343d49f172fdb$export$5153917efea4a83d = (issueProperties)=>({ setState: setState })=>{
        setState({
            issueProperties: issueProperties
        });
    };
const $a7f343d49f172fdb$export$e324594224ef24da = {
    fetch: $7Sl82.fetch,
    setIssueProperties: $a7f343d49f172fdb$export$5153917efea4a83d,
    setAsNonRecurringIssue: $l9xxv.setAsNonRecurringIssue,
    setAsRecurringIssue: $bvhsR.setAsRecurringIssue,
    updateRule: $c8g0F.updateRule
};

});
parcelRegister("7Sl82", function(module, exports) {

$parcel$export(module.exports, "fetch", () => $88fd35b220315252$export$e7aa7bc5c1b3cfb3);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $4R6GH = parcelRequire("4R6GH");

var $m8SHd = parcelRequire("m8SHd");

var $ahBjy = parcelRequire("ahBjy");

var $fAJ3G = parcelRequire("fAJ3G");

var $519t2 = parcelRequire("519t2");

var $cpjnU = parcelRequire("cpjnU");
const $88fd35b220315252$export$e7aa7bc5c1b3cfb3 = ()=>async ({ setState: setState }, { createAnalyticsEvent: createAnalyticsEvent, issueKey: issueKey, environment: environment, cloudId: cloudId, projectId: projectId, currentUserAccountId: currentUserAccountId })=>{
        setState({
            isFetching: true,
            errors: null
        });
        try {
            // First fetch issue-properties
            const { value: issueProperties } = await (0, $519t2.callServiceWithAnalytics)(createAnalyticsEvent({}), (0, $m8SHd.fetchIssueProperties)(issueKey), 'fetchIssueProperties');
            let ruleSummary;
            // Only fetch rule summary if a rule exists in issue-properties and not a grandfathered recur-on-complete rule
            if (issueProperties?.automationRuleUuid) {
                ruleSummary = await (0, $519t2.callServiceWithAnalytics)(createAnalyticsEvent({}), (0, $m8SHd.fetchRuleSummary)(environment, cloudId, projectId, issueProperties.automationRuleUuid), 'fetchRuleSummary');
                // If rule doesn't exist or is disabled, delete issue-properties
                if (!ruleSummary || ruleSummary?.ruleState === (0, $ahBjy.RuleState).DISABLED) {
                    await (0, $519t2.callServiceWithAnalytics)(createAnalyticsEvent({}), (0, $fAJ3G.deleteIssueProperties)({
                        issueKey: issueKey
                    }), 'deleteIssueProperties');
                    setState({
                        isFetching: false,
                        hasFetched: true,
                        issueProperties: null
                    });
                    return;
                }
            }
            let isRuleOwner;
            if ((0, $cpjnU.isRecurOnCompleteToggleRule)(issueProperties)) isRuleOwner = true;
            else if (ruleSummary) isRuleOwner = ruleSummary.authorAccountId === currentUserAccountId;
            else isRuleOwner = null;
            setState({
                isFetching: false,
                hasFetched: true,
                issueProperties: issueProperties,
                isRuleOwner: isRuleOwner,
                ...(0, $4R6GH.fg)('jira-recur-single-work-item-on-sched-due-date-gate') && {
                    hasBootstrapError: false
                }
            });
        } catch (error) {
            setState({
                isFetching: false,
                hasFetched: true,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                errors: [
                    error
                ],
                hasBootstrapError: true
            });
        }
    };

});
parcelRegister("m8SHd", function(module, exports) {

$parcel$export(module.exports, "fetchIssueProperties", () => $85e12c64cfd21e7a$export$efa35964e975bd30);
$parcel$export(module.exports, "fetchRuleSummary", () => $85e12c64cfd21e7a$export$3cada9835f092161);

var $c5wox = parcelRequire("c5wox");

var $jJZqs = parcelRequire("jJZqs");

var $eusud = parcelRequire("eusud");
const $85e12c64cfd21e7a$export$efa35964e975bd30 = async (issueKey)=>{
    const recurrenceConfigEndpoint = `/rest/api/2/issue/${issueKey}/properties/recurrence-config`;
    try {
        return await (0, $eusud.performGetRequest)(recurrenceConfigEndpoint);
    } catch (error) {
        if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) return Promise.resolve({
            value: null
        });
        throw error;
    }
};
const $85e12c64cfd21e7a$export$3cada9835f092161 = async (environment, cloudId, projectId, ruleUuid)=>{
    const automationStack = await (0, $c5wox.getAutomationStack)(environment, cloudId);
    const summaryEndpoint = `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/${projectId}/rule/${ruleUuid}/summary`;
    try {
        return await (0, $eusud.performGetRequest)(summaryEndpoint);
    } catch (error) {
        if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) return null;
        throw error;
    }
};

});
parcelRegister("c5wox", function(module, exports) {

$parcel$export(module.exports, "getAutomationStack", () => $8833cfad9f41bd36$export$6123178d3f5fb24d);
$parcel$export(module.exports, "getAutomationRecommendationsUrl", () => $8833cfad9f41bd36$export$38f41aa7b608011d);
$parcel$export(module.exports, "getBaseAutomationUrl", () => $8833cfad9f41bd36$export$8e479e490e1e69bc);

var $bSSG7 = parcelRequire("bSSG7");

var $4R6GH = parcelRequire("4R6GH");
const $8833cfad9f41bd36$var$localStorage = (0, $bSSG7.createLocalStorageProvider)('automation-menu');
const $8833cfad9f41bd36$var$getLatestStack = async (cloudId)=>fetch(`/gateway/api/automation/internal-api/jira/${cloudId}/pro/rest/environments`).then((response)=>response.json()).then((response)=>{
        const stacks = response.prod.otherStacks.filter(({ releasedSuccessfully: releasedSuccessfully })=>!releasedSuccessfully).map(({ stack: stack })=>stack);
        return stacks.length > 0 ? stacks[0] : null;
    }).catch(()=>null);
const $8833cfad9f41bd36$export$6123178d3f5fb24d = async (env, cloudId)=>{
    if (env === 'prod') {
        if ((0, $4R6GH.fg)('automation-platform-pre-prod-instance')) {
            const stack = await $8833cfad9f41bd36$var$getLatestStack(cloudId);
            return stack ?? 'pro';
        }
        return 'pro';
    }
    // Set this manually to your Automation dev stack e.g. devesukmajaya. The full key is: __storejs_automation-menu_automationStack
    const stackOverride = $8833cfad9f41bd36$var$localStorage.get('automationStack');
    return stackOverride || 'staging';
};
const $8833cfad9f41bd36$export$45ce04a98782e28a = async (env, cloudId, projectId)=>{
    const automationStack = await $8833cfad9f41bd36$export$6123178d3f5fb24d(env, cloudId);
    return `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/rules/invocation/${projectId}`;
};
const $8833cfad9f41bd36$export$f8e019b45a22d26a = async (env, cloudId, ruleId)=>{
    const automationStack = await $8833cfad9f41bd36$export$6123178d3f5fb24d(env, cloudId);
    return `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/rules/invocation/${ruleId}`;
};
const $8833cfad9f41bd36$export$38f41aa7b608011d = async ({ env: env, cloudId: cloudId, target: target })=>{
    const automationStack = await $8833cfad9f41bd36$export$6123178d3f5fb24d(env, cloudId);
    return `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/v1/recommendation/templates?target=${target}`;
};
const $8833cfad9f41bd36$export$8e479e490e1e69bc = ({ projectKey: projectKey, projectType: projectType, isSimplified: isSimplified })=>{
    /**
	 * Confusing mapping of urls here.
	 * Classic Projects - always under /automate
	 * Next Gen Projects - under /automation for all project types except JSD
	 */ if ((0, $4R6GH.fg)('jcs_project_type_m3')) switch(projectType){
        case 'customer_service':
        case 'service_desk':
            return `/jira/servicedesk/projects/${projectKey}/settings/automate`;
        case 'business':
            return `/jira/core/projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
        default:
            return `/jira/software/${isSimplified ? '' : 'c/'}projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
    }
    switch(projectType){
        case 'service_desk':
            return `/jira/servicedesk/projects/${projectKey}/settings/automate`;
        case 'business':
            return `/jira/core/projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
        default:
            return `/jira/software/${isSimplified ? '' : 'c/'}projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
    }
};

});


parcelRegister("ahBjy", function(module, exports) {

$parcel$export(module.exports, "RuleState", () => $50cbc517c5c98dcf$export$c22ef3527b5f5563);
$parcel$export(module.exports, "CONDITION", () => $50cbc517c5c98dcf$export$1cfe08df32bc8f76);
$parcel$export(module.exports, "FORM_TITLE_ID", () => $50cbc517c5c98dcf$export$66f4c6e4b9206abf);
$parcel$export(module.exports, "SOFTWARE_END_USER_TEMPLATE_2", () => $50cbc517c5c98dcf$export$c07ca23c166d6344);
const $50cbc517c5c98dcf$export$c22ef3527b5f5563 = {
    DISABLED: 'DISABLED',
    ENABLED: 'ENABLED',
    MISSING_PERMS: 'MISSING_PERMS'
};
const $50cbc517c5c98dcf$export$1cfe08df32bc8f76 = {
    SCHEDULE: 'SCHEDULE',
    SCHEDULE_IF_COMPLETE: 'SCHEDULE_IF_COMPLETE'
};
const $50cbc517c5c98dcf$export$f7109619a5e9e0d6 = 'recurWorkItemForm';
const $50cbc517c5c98dcf$export$66f4c6e4b9206abf = 'recur-work-item-form-title';
const $50cbc517c5c98dcf$export$c07ca23c166d6344 = 'software_end_user_template_2';

});

parcelRegister("fAJ3G", function(module, exports) {

$parcel$export(module.exports, "deleteRule", () => $dcc2b085f6f8ace7$export$988cba38e738f27d);
$parcel$export(module.exports, "deleteIssueProperties", () => $dcc2b085f6f8ace7$export$3906c12f20991cd1);
$parcel$export(module.exports, "disableRule", () => $dcc2b085f6f8ace7$export$44bd9fdb7edbb04a);

var $c5wox = parcelRequire("c5wox");

var $eusud = parcelRequire("eusud");
const $dcc2b085f6f8ace7$export$988cba38e738f27d = async ({ environment: environment, cloudId: cloudId, projectId: projectId, ruleUuid: ruleUuid })=>{
    const automationStack = await (0, $c5wox.getAutomationStack)(environment, cloudId);
    const DELETE_RULE_URL = `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/${projectId}/rule/${ruleUuid}`;
    return (0, $eusud.performDeleteRequest)(DELETE_RULE_URL);
};
const $dcc2b085f6f8ace7$export$3906c12f20991cd1 = async ({ issueKey: issueKey })=>{
    const ruleConfigEndpoint = `/rest/api/2/issue/${issueKey}/properties/recurrence-config`;
    return (0, $eusud.performDeleteRequest)(ruleConfigEndpoint);
};
const $dcc2b085f6f8ace7$export$44bd9fdb7edbb04a = async ({ environment: environment, cloudId: cloudId, projectId: projectId, ruleUuid: ruleUuid })=>{
    const automationStack = await (0, $c5wox.getAutomationStack)(environment, cloudId);
    const disableRuleEndpoint = `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/${projectId}/rule/${ruleUuid}/disable`;
    return (0, $eusud.performPatchRequest)(disableRuleEndpoint);
};

});

parcelRegister("519t2", function(module, exports) {

$parcel$export(module.exports, "callServiceWithAnalytics", () => $ad2a8aebaff4128f$export$7ad2acdaf7d8c23c);

var $jJZqs = parcelRequire("jJZqs");

var $8zOmE = parcelRequire("8zOmE");
const $ad2a8aebaff4128f$var$getErrorAttributes = (error)=>{
    if (error instanceof Error) return {
        errorMessage: error.message,
        ...error instanceof (0, $jJZqs.default) && {
            statusCode: error.statusCode
        }
    };
    return {};
};
const $ad2a8aebaff4128f$export$7ad2acdaf7d8c23c = async (analyticsEvent, requestPromise, requestName, attributes = {})=>{
    try {
        const response = await requestPromise;
        (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, `${requestName} succeeded`, {
            ...attributes
        });
        return response;
    } catch (err) {
        (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, `${requestName} failed`, {
            ...attributes,
            ...$ad2a8aebaff4128f$var$getErrorAttributes(err)
        });
        throw err;
    }
};

});

parcelRegister("cpjnU", function(module, exports) {

$parcel$export(module.exports, "mapFrequencyToRRule", () => $c35d2016d68e7b8d$export$e01411a3db8dd3d7);
$parcel$export(module.exports, "mapFrequencyToSmartOffsetValue", () => $c35d2016d68e7b8d$export$777fffdd861d4f20);
$parcel$export(module.exports, "getFrequencyFromRRule", () => $c35d2016d68e7b8d$export$71b17ee07540e13b);
$parcel$export(module.exports, "getRecurMenuItemLabel", () => $c35d2016d68e7b8d$export$c7198a7e75d4478b);
$parcel$export(module.exports, "getSuccessFlagContent", () => $c35d2016d68e7b8d$export$8eef89c3d24cb712);
$parcel$export(module.exports, "isRecurOnCompleteToggleRule", () => $c35d2016d68e7b8d$export$b57843f38b80b500);
$parcel$export(module.exports, "hasRuleChanged", () => $c35d2016d68e7b8d$export$8dc77b9e863f46b);
$parcel$export(module.exports, "applyUserTimezone", () => $c35d2016d68e7b8d$export$555109634e8a63b6);

var $ajpes = parcelRequire("ajpes");

var $1GF3c = parcelRequire("1GF3c");

var $gwejS = parcelRequire("gwejS");

var $7jns1 = parcelRequire("7jns1");

var $bbVsP = parcelRequire("bbVsP");
var $jpR5P = parcelRequire("jpR5P");

var $9eJ96 = parcelRequire("9eJ96");

var $5D9Ji = parcelRequire("5D9Ji");
const $c35d2016d68e7b8d$export$e01411a3db8dd3d7 = (timeframe, recurWeeklyConfig)=>{
    switch(timeframe){
        case 'DAILY':
            return {
                frequency: (0, $9eJ96.Frequencies).DAILY,
                interval: 1
            };
        case 'WEEKDAY':
            return {
                frequency: (0, $9eJ96.Frequencies).DAILY,
                byDay: [
                    (0, $9eJ96.Days).MO,
                    (0, $9eJ96.Days).TU,
                    (0, $9eJ96.Days).WE,
                    (0, $9eJ96.Days).TH,
                    (0, $9eJ96.Days).FR
                ],
                interval: 1
            };
        case 'WEEKLY':
            return {
                frequency: (0, $9eJ96.Frequencies).WEEKLY,
                byDay: recurWeeklyConfig,
                interval: 1
            };
        case 'FORTNIGHTLY':
            // There is no native FORTNIGHTLY frequency for ical, so we need to combine WEEKLY with interval 2
            return {
                frequency: (0, $9eJ96.Frequencies).WEEKLY,
                byDay: recurWeeklyConfig,
                interval: 2
            };
        default:
            throw new Error(`Unknown timeframe: ${timeframe}`);
    }
};
const $c35d2016d68e7b8d$export$777fffdd861d4f20 = (timeframe)=>{
    switch(timeframe){
        case 'DAILY':
            return '{{now.plusDays(1)}}';
        case 'WEEKDAY':
            return '{{now.plusBusinessDays(1)}}';
        case 'WEEKLY':
            return '{{now.plusWeeks(1)}}';
        case 'FORTNIGHTLY':
            return '{{now.plusWeeks(2)}}';
        default:
            throw new Error(`Could not calculate due date smart offset value: ${timeframe}`);
    }
};
const $c35d2016d68e7b8d$export$71b17ee07540e13b = (rrule)=>{
    if (rrule.frequency === (0, $9eJ96.Frequencies).DAILY) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(rrule.byDay, [
            (0, $9eJ96.Days).MO,
            (0, $9eJ96.Days).TU,
            (0, $9eJ96.Days).WE,
            (0, $9eJ96.Days).TH,
            (0, $9eJ96.Days).FR
        ])) return 'WEEKDAY';
        return 'DAILY';
    }
    if (rrule.frequency === (0, $9eJ96.Frequencies).WEEKLY) {
        if (rrule.interval === 2) return 'FORTNIGHTLY';
        return 'WEEKLY';
    }
};
const $c35d2016d68e7b8d$export$c7198a7e75d4478b = (rrule, isRecurOnComplete = false)=>{
    if (isRecurOnComplete) return (0, $5D9Ji.default).recursOnComplete;
    const frequency = $c35d2016d68e7b8d$export$71b17ee07540e13b(rrule);
    // Every business day (Monday to Friday)
    if (frequency === 'WEEKDAY') return (0, $5D9Ji.default).recursEveryWeekday;
    // Daily
    if (frequency === 'DAILY') return (0, $5D9Ji.default).recursDaily;
    // Fortnightly
    if (frequency === 'FORTNIGHTLY') return (0, $5D9Ji.default).recursEveryTwoWeeks;
    // Weekly
    if (frequency === 'WEEKLY') return (0, $5D9Ji.default).recursWeekly;
    return (0, $5D9Ji.default).setToRecur;
};
const $c35d2016d68e7b8d$var$byDayOptions = Object.values((0, $9eJ96.Days));
const $c35d2016d68e7b8d$var$getWeekDayNameFromByDay = (byDayValue, intl)=>{
    const dayIndex = $c35d2016d68e7b8d$var$byDayOptions.indexOf(byDayValue);
    if (dayIndex < 0) throw new Error(`Invalid ByDay value provided: ${byDayValue}. Valid options: ${$c35d2016d68e7b8d$var$byDayOptions}`);
    const firstDayOfWeek = (0, $1GF3c.default)(new Date(), {
        weekStartsOn: 1
    });
    const day = (0, $gwejS.default)(firstDayOfWeek, dayIndex);
    return intl.formatDate(day, {
        weekday: 'long'
    });
};
const $c35d2016d68e7b8d$export$5c6d45150d1588c0 = ({ byDayValues: byDayValues, intl: intl, standardizedLocale: standardizedLocale })=>new Intl.ListFormat(standardizedLocale, {
        style: 'long',
        type: 'conjunction'
    }).format(Array.from(byDayValues, (byDayValue)=>$c35d2016d68e7b8d$var$getWeekDayNameFromByDay(byDayValue, intl)));
const $c35d2016d68e7b8d$export$8eef89c3d24cb712 = ({ frequency: frequency, recurCondition: recurCondition, recurWeeklyConfig: recurWeeklyConfig, intl: intl, standardizedLocale: standardizedLocale, issueKey: issueKey, issueType: issueType })=>{
    const issueTypeLowercase = issueType.toLocaleLowerCase(standardizedLocale);
    switch(recurCondition){
        case 'SCHEDULE_IF_COMPLETE':
            switch(frequency){
                case 'DAILY':
                    return {
                        title: intl.formatMessage((0, $5D9Ji.default).successFlagTitleRecurOnScheduleIfCompleteDaily, {
                            issueKey: issueKey
                        }),
                        description: intl.formatMessage((0, $5D9Ji.default).successFlagDescriptionRecurOnScheduleIfCompleteDaily, {
                            issueType: issueTypeLowercase
                        })
                    };
                case 'WEEKDAY':
                    return {
                        title: intl.formatMessage((0, $5D9Ji.default).successFlagTitleRecurOnScheduleIfCompleteWeekday, {
                            issueKey: issueKey
                        }),
                        description: intl.formatMessage((0, $5D9Ji.default).successFlagDescriptionRecurOnScheduleIfCompleteWeekday, {
                            issueType: issueTypeLowercase
                        })
                    };
                case 'WEEKLY':
                    return {
                        title: intl.formatMessage((0, $5D9Ji.default).successFlagTitleRecurOnScheduleIfCompleteWeekly, {
                            issueKey: issueKey
                        }),
                        description: intl.formatMessage((0, $5D9Ji.default).successFlagDescriptionRecurOnScheduleIfCompleteWeekly, {
                            issueType: issueTypeLowercase,
                            weekDayNames: $c35d2016d68e7b8d$export$5c6d45150d1588c0({
                                byDayValues: recurWeeklyConfig ?? [],
                                intl: intl,
                                standardizedLocale: standardizedLocale
                            })
                        })
                    };
                case 'FORTNIGHTLY':
                    return {
                        title: intl.formatMessage((0, $5D9Ji.default).successFlagTitleRecurOnScheduleIfCompleteFortnightly, {
                            issueKey: issueKey
                        }),
                        description: intl.formatMessage((0, $5D9Ji.default).successFlagDescriptionRecurOnScheduleIfCompleteFortnightly, {
                            issueType: issueTypeLowercase,
                            weekDayNames: $c35d2016d68e7b8d$export$5c6d45150d1588c0({
                                byDayValues: recurWeeklyConfig ?? [],
                                intl: intl,
                                standardizedLocale: standardizedLocale
                            })
                        })
                    };
                default:
                    throw new Error(`Unknown frequency: ${frequency}`);
            }
        case 'SCHEDULE':
            switch(frequency){
                case 'DAILY':
                    return {
                        title: intl.formatMessage((0, $5D9Ji.default).successFlagTitleRecurOnScheduleDaily, {
                            issueKey: issueKey
                        })
                    };
                case 'WEEKDAY':
                    return {
                        title: intl.formatMessage((0, $5D9Ji.default).successFlagTitleRecurOnScheduleWeekday, {
                            issueKey: issueKey
                        })
                    };
                case 'WEEKLY':
                    return {
                        title: intl.formatMessage((0, $5D9Ji.default).successFlagTitleRecurOnScheduleWeekly, {
                            issueKey: issueKey,
                            weekDayNames: $c35d2016d68e7b8d$export$5c6d45150d1588c0({
                                byDayValues: recurWeeklyConfig ?? [],
                                intl: intl,
                                standardizedLocale: standardizedLocale
                            })
                        })
                    };
                case 'FORTNIGHTLY':
                    return {
                        title: intl.formatMessage((0, $5D9Ji.default).successFlagTitleRecurOnScheduleFortnightly, {
                            issueKey: issueKey,
                            weekDayNames: $c35d2016d68e7b8d$export$5c6d45150d1588c0({
                                byDayValues: recurWeeklyConfig ?? [],
                                intl: intl,
                                standardizedLocale: standardizedLocale
                            })
                        })
                    };
                default:
                    throw new Error(`Unknown frequency: ${frequency}`);
            }
        default:
            throw new Error(`Unknown recur condition: ${recurCondition}`);
    }
};
const $c35d2016d68e7b8d$export$b57843f38b80b500 = (issueProperties)=>{
    return !!issueProperties && !!issueProperties.token && (issueProperties.recurOnScheduleConfig === null || issueProperties.recurOnScheduleConfig === undefined);
};
const $c35d2016d68e7b8d$var$areByDaysEqual = ({ byDays: byDays, anotherByDays: anotherByDays })=>{
    // assumes lists have a consistent order
    if (byDays === undefined) return anotherByDays === undefined;
    if (anotherByDays === undefined) return false;
    if (byDays.length !== anotherByDays.length) return false;
    return byDays.every((byDay, index)=>byDay === anotherByDays[index]);
};
const $c35d2016d68e7b8d$var$areDatesEqual = (date1, date2)=>{
    if (date1 === undefined || date2 === undefined) return date1 === date2;
    // We only care about checking the date equality, not the time
    return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate();
};
const $c35d2016d68e7b8d$export$8dc77b9e863f46b = ({ formInput: formInput, formOutput: formOutput })=>{
    // comparing 2 recur-on-schedule rules
    if (formInput.frequency !== formOutput.frequency || formInput.condition !== formOutput.condition || !$c35d2016d68e7b8d$var$areDatesEqual(formInput.endsOn, formOutput.endsOn)) return true;
    if (formInput.frequency === 'WEEKLY' || formInput.frequency === 'FORTNIGHTLY') return !$c35d2016d68e7b8d$var$areByDaysEqual({
        byDays: formInput.byDay,
        anotherByDays: formOutput.byDay
    });
    return false;
};
const $c35d2016d68e7b8d$export$555109634e8a63b6 = (date, browserTimezone, userTimezone)=>{
    const browserTimezoneOffsetMs = (0, $7jns1.default)(browserTimezone);
    const userTimezoneOffsetMs = (0, $7jns1.default)(userTimezone);
    return (0, $bbVsP.default)((0, $jpR5P.default)(date, browserTimezoneOffsetMs), userTimezoneOffsetMs);
};

});
parcelRegister("9eJ96", function(module, exports) {

$parcel$export(module.exports, "NEWLINE_REGEX", () => $1079d16957e265b2$export$665ca7211e0c33c);
$parcel$export(module.exports, "FOLD_LINES_REGEX", () => $1079d16957e265b2$export$4b7f22f32fbb5949);
$parcel$export(module.exports, "LF", () => $1079d16957e265b2$export$606cfc2a8896c91f);
$parcel$export(module.exports, "NewlineCharacters", () => $1079d16957e265b2$export$ccae594c20078277);
$parcel$export(module.exports, "NewlineCharacterValues", () => $1079d16957e265b2$export$c3edd2b21ac02f88);
$parcel$export(module.exports, "Frequencies", () => $1079d16957e265b2$export$895ee510b2e84ade);
$parcel$export(module.exports, "Days", () => $1079d16957e265b2$export$d3134eff2123aadb);
$parcel$export(module.exports, "BEGIN_VEVENT", () => $1079d16957e265b2$export$67de00e87412dc6f);
$parcel$export(module.exports, "END_VEVENT", () => $1079d16957e265b2$export$987d86d2e891c4cb);
$parcel$export(module.exports, "DTSTART", () => $1079d16957e265b2$export$fd1a0e011a586e26);
$parcel$export(module.exports, "RRULE", () => $1079d16957e265b2$export$d86ed937a45b0291);
$parcel$export(module.exports, "ICalSpecificationFields", () => $1079d16957e265b2$export$98eba4d8ff00c139);
$parcel$export(module.exports, "ICalSupportedFields", () => $1079d16957e265b2$export$38b1323f325ffd22);
$parcel$export(module.exports, "TZID", () => $1079d16957e265b2$export$5b9a78912028c06d);
$parcel$export(module.exports, "DTStartProperties", () => $1079d16957e265b2$export$20184b745430719e);
$parcel$export(module.exports, "FREQ", () => $1079d16957e265b2$export$fb124b4fa837b262);
$parcel$export(module.exports, "UNTIL", () => $1079d16957e265b2$export$4cc4f35131ed029c);
$parcel$export(module.exports, "INTERVAL", () => $1079d16957e265b2$export$7dea0e6e08f87a8a);
$parcel$export(module.exports, "BYHOUR", () => $1079d16957e265b2$export$a764ed9c4884f76d);
$parcel$export(module.exports, "BYMINUTE", () => $1079d16957e265b2$export$7a96578de7a037b6);
$parcel$export(module.exports, "BYSECOND", () => $1079d16957e265b2$export$55bcca3bd8d3041f);
$parcel$export(module.exports, "BYDAY", () => $1079d16957e265b2$export$f512ea3e90612d03);
$parcel$export(module.exports, "BYMONTH", () => $1079d16957e265b2$export$b3203f635d74ce88);
$parcel$export(module.exports, "BYMONTHDAY", () => $1079d16957e265b2$export$15623ad945e92c4c);
$parcel$export(module.exports, "RRuleProperties", () => $1079d16957e265b2$export$7898bd020dba0a27);
$parcel$export(module.exports, "MISSING", () => $1079d16957e265b2$export$64c81710c321f252);
$parcel$export(module.exports, "EMPTY", () => $1079d16957e265b2$export$ccb33e29d92c9a58);
$parcel$export(module.exports, "INVALID", () => $1079d16957e265b2$export$9a105a556e65c2c0);
$parcel$export(module.exports, "VALID", () => $1079d16957e265b2$export$f3abe3d006c81602);
const $1079d16957e265b2$export$665ca7211e0c33c = /\r?\n/;
const $1079d16957e265b2$export$4b7f22f32fbb5949 = /\r?\n[ \t]/g; // match line breaks followed by a whitespace character (space or tab)
const $1079d16957e265b2$export$ae9ea0d00d3d8982 = 'CRLF';
const $1079d16957e265b2$export$a1f3f1ef020bdc3a = '\r\n';
const $1079d16957e265b2$export$606cfc2a8896c91f = 'LF';
const $1079d16957e265b2$export$477fea8aa280bb1e = '\n';
const $1079d16957e265b2$export$ccae594c20078277 = {
    CRLF: $1079d16957e265b2$export$ae9ea0d00d3d8982,
    LF: $1079d16957e265b2$export$606cfc2a8896c91f
};
const $1079d16957e265b2$export$c3edd2b21ac02f88 = {
    [$1079d16957e265b2$export$ae9ea0d00d3d8982]: $1079d16957e265b2$export$a1f3f1ef020bdc3a,
    [$1079d16957e265b2$export$606cfc2a8896c91f]: $1079d16957e265b2$export$477fea8aa280bb1e
};
const $1079d16957e265b2$export$895ee510b2e84ade = {
    SECONDLY: 'SECONDLY',
    MINUTELY: 'MINUTELY',
    HOURLY: 'HOURLY',
    DAILY: 'DAILY',
    WEEKLY: 'WEEKLY',
    MONTHLY: 'MONTHLY',
    YEARLY: 'YEARLY'
};
const $1079d16957e265b2$export$d3134eff2123aadb = {
    MO: 'MO',
    TU: 'TU',
    WE: 'WE',
    TH: 'TH',
    FR: 'FR',
    SA: 'SA',
    SU: 'SU'
};
const $1079d16957e265b2$export$f62540a8bebc4ed3 = 'BEGIN';
const $1079d16957e265b2$export$32239d68d9c6cb49 = 'END';
const $1079d16957e265b2$export$67de00e87412dc6f = 'BEGIN:VEVENT';
const $1079d16957e265b2$export$987d86d2e891c4cb = 'END:VEVENT';
const $1079d16957e265b2$export$fd1a0e011a586e26 = 'DTSTART';
const $1079d16957e265b2$export$d86ed937a45b0291 = 'RRULE';
const $1079d16957e265b2$export$913055729e1380b2 = 'SUMMARY';
const $1079d16957e265b2$export$87d0ca22edb7493a = 'LOCATION';
const $1079d16957e265b2$export$d44826c816b5619b = 'DESCRIPTION';
const $1079d16957e265b2$export$c8b4a4d253b84ce0 = 'UID';
const $1079d16957e265b2$export$34694f8d8b23ee2a = 'SEQUENCE';
const $1079d16957e265b2$export$e50006273435e7d4 = 'STATUS';
const $1079d16957e265b2$export$36034111438e3f25 = 'TRANSP';
const $1079d16957e265b2$export$bb34f3538ba26c7e = 'PRIORITY';
const $1079d16957e265b2$export$30dbcad954808285 = 'DTEND';
const $1079d16957e265b2$export$bacc88974c736870 = 'DURATION';
const $1079d16957e265b2$export$da3a32b38cbf59ba = 'ATTACH';
const $1079d16957e265b2$export$5e0bdf8bba8d5088 = 'ATTENDEE';
const $1079d16957e265b2$export$a513ea61a7bee91c = 'CATEGORIES';
const $1079d16957e265b2$export$a29989082612d0d9 = 'COMMENT';
const $1079d16957e265b2$export$11038cc09fdccb91 = 'CONTACT';
const $1079d16957e265b2$export$133ffe3c8efbf133 = 'EXDATE';
const $1079d16957e265b2$export$7e27a94778a9d7d7 = 'EXRULE';
const $1079d16957e265b2$export$3d166b1dacd2503a = 'RDATE';
const $1079d16957e265b2$export$47a1d4cd38dddc05 = 'RELATED-TO';
const $1079d16957e265b2$export$4e841128923ef26 = 'RESOURCES';
const $1079d16957e265b2$export$1c0dd28c42f2741e = 'RECURRENCE-ID';
const $1079d16957e265b2$export$61abde59b50deb8e = 'URL';
const $1079d16957e265b2$export$ff39ebd4bb12b718 = 'CREATED';
const $1079d16957e265b2$export$2ebcefe61501d5fe = 'DTSTAMP';
const $1079d16957e265b2$export$90812500f628da64 = 'LAST-MODIFIED';
const $1079d16957e265b2$export$5409f4c14bda7ac = 'ORGANIZER';
const $1079d16957e265b2$export$9fe99b3b71be9378 = 'REQUEST-STATUS';
const $1079d16957e265b2$export$98eba4d8ff00c139 = {
    BEGIN: $1079d16957e265b2$export$f62540a8bebc4ed3,
    END: $1079d16957e265b2$export$32239d68d9c6cb49,
    BEGIN_VEVENT: $1079d16957e265b2$export$67de00e87412dc6f,
    END_VEVENT: $1079d16957e265b2$export$987d86d2e891c4cb,
    SUMMARY: $1079d16957e265b2$export$913055729e1380b2,
    LOCATION: $1079d16957e265b2$export$87d0ca22edb7493a,
    DESCRIPTION: $1079d16957e265b2$export$d44826c816b5619b,
    UID: $1079d16957e265b2$export$c8b4a4d253b84ce0,
    SEQUENCE: $1079d16957e265b2$export$34694f8d8b23ee2a,
    STATUS: $1079d16957e265b2$export$e50006273435e7d4,
    TRANSP: $1079d16957e265b2$export$36034111438e3f25,
    PRIORITY: $1079d16957e265b2$export$bb34f3538ba26c7e,
    DTSTART: $1079d16957e265b2$export$fd1a0e011a586e26,
    RRULE: $1079d16957e265b2$export$d86ed937a45b0291,
    DTEND: $1079d16957e265b2$export$30dbcad954808285,
    DURATION: $1079d16957e265b2$export$bacc88974c736870,
    ATTACH: $1079d16957e265b2$export$da3a32b38cbf59ba,
    ATTENDEE: $1079d16957e265b2$export$5e0bdf8bba8d5088,
    CATEGORIES: $1079d16957e265b2$export$a513ea61a7bee91c,
    COMMENT: $1079d16957e265b2$export$a29989082612d0d9,
    CONTACT: $1079d16957e265b2$export$11038cc09fdccb91,
    EXDATE: $1079d16957e265b2$export$133ffe3c8efbf133,
    EXRULE: $1079d16957e265b2$export$7e27a94778a9d7d7,
    RDATE: $1079d16957e265b2$export$3d166b1dacd2503a,
    RELATED_TO: $1079d16957e265b2$export$47a1d4cd38dddc05,
    RESOURCES: $1079d16957e265b2$export$4e841128923ef26,
    RECURRENCE_ID: $1079d16957e265b2$export$1c0dd28c42f2741e,
    URL: $1079d16957e265b2$export$61abde59b50deb8e,
    CREATED: $1079d16957e265b2$export$ff39ebd4bb12b718,
    DTSTAMP: $1079d16957e265b2$export$2ebcefe61501d5fe,
    LAST_MODIFIED: $1079d16957e265b2$export$90812500f628da64,
    ORGANIZER: $1079d16957e265b2$export$5409f4c14bda7ac,
    REQUEST_STATUS: $1079d16957e265b2$export$9fe99b3b71be9378
};
const $1079d16957e265b2$export$38b1323f325ffd22 = {
    DTSTART: $1079d16957e265b2$export$fd1a0e011a586e26,
    RRULE: $1079d16957e265b2$export$d86ed937a45b0291
};
const $1079d16957e265b2$export$5b9a78912028c06d = 'TZID';
const $1079d16957e265b2$export$20184b745430719e = {
    DTSTART: $1079d16957e265b2$export$fd1a0e011a586e26,
    TZID: $1079d16957e265b2$export$5b9a78912028c06d
};
const $1079d16957e265b2$export$fb124b4fa837b262 = 'FREQ';
const $1079d16957e265b2$export$4cc4f35131ed029c = 'UNTIL';
const $1079d16957e265b2$export$7dea0e6e08f87a8a = 'INTERVAL';
const $1079d16957e265b2$export$a764ed9c4884f76d = 'BYHOUR';
const $1079d16957e265b2$export$7a96578de7a037b6 = 'BYMINUTE';
const $1079d16957e265b2$export$55bcca3bd8d3041f = 'BYSECOND';
const $1079d16957e265b2$export$f512ea3e90612d03 = 'BYDAY';
const $1079d16957e265b2$export$b3203f635d74ce88 = 'BYMONTH';
const $1079d16957e265b2$export$15623ad945e92c4c = 'BYMONTHDAY';
const $1079d16957e265b2$export$7898bd020dba0a27 = {
    FREQ: $1079d16957e265b2$export$fb124b4fa837b262,
    UNTIL: $1079d16957e265b2$export$4cc4f35131ed029c,
    INTERVAL: $1079d16957e265b2$export$7dea0e6e08f87a8a,
    BYHOUR: $1079d16957e265b2$export$a764ed9c4884f76d,
    BYMINUTE: $1079d16957e265b2$export$7a96578de7a037b6,
    BYSECOND: $1079d16957e265b2$export$55bcca3bd8d3041f,
    BYDAY: $1079d16957e265b2$export$f512ea3e90612d03,
    BYMONTH: $1079d16957e265b2$export$b3203f635d74ce88,
    BYMONTHDAY: $1079d16957e265b2$export$15623ad945e92c4c
};
const $1079d16957e265b2$export$64c81710c321f252 = 'MISSING';
const $1079d16957e265b2$export$ccb33e29d92c9a58 = 'EMPTY';
const $1079d16957e265b2$export$9a105a556e65c2c0 = 'INVALID';
const $1079d16957e265b2$export$f3abe3d006c81602 = 'VALID';

});

parcelRegister("5D9Ji", function(module, exports) {

$parcel$export(module.exports, "default", () => $f056e68da25dd6c2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f056e68da25dd6c2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    formTitle: {
        "id": "recur-work-item.form-title",
        "defaultMessage": "Set to recur"
    },
    saveButtonText: {
        "id": "recur-work-item.save-button-text",
        "defaultMessage": "Save"
    },
    cancelButtonText: {
        "id": "recur-work-item.cancel-button-text",
        "defaultMessage": "Cancel"
    },
    deleteButtonText: {
        "id": "recur-work-item.delete-button-text",
        "defaultMessage": "Delete"
    },
    recurFieldsLabel: {
        "id": "recur-work-item.recur-fields-label",
        "defaultMessage": "Recur"
    },
    setToRecur: {
        "id": "recur-work-item.set-to-recur",
        "defaultMessage": "Set to recur"
    },
    recursDaily: {
        "id": "recur-work-item.recurs-daily",
        "defaultMessage": "Recurs daily"
    },
    recursEveryWeekday: {
        "id": "recur-work-item.recurs-every-weekday",
        "defaultMessage": "Every weekday (Monday to Friday)"
    },
    recursWeekly: {
        "id": "recur-work-item.recurs-weekly",
        "defaultMessage": "Recurs weekly"
    },
    recursEveryTwoWeeks: {
        "id": "recur-work-item.recurs-every-two-weeks",
        "defaultMessage": "Recurs every 2 weeks"
    },
    recursOnComplete: {
        "id": "recur-work-item.recurs-on-complete",
        "defaultMessage": "Recurs when completed"
    },
    successFlagTitleRecurOnScheduleIfCompleteDaily: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-if-complete-daily",
        "defaultMessage": "{issueKey} recurs every day"
    },
    successFlagTitleRecurOnScheduleIfCompleteWeekday: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-if-complete-weekday",
        "defaultMessage": "{issueKey} recurs every weekday"
    },
    successFlagTitleRecurOnScheduleIfCompleteWeekly: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-if-complete-weekly",
        "defaultMessage": "{issueKey} recurs every week"
    },
    successFlagTitleRecurOnScheduleIfCompleteFortnightly: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-if-complete-fortnightly",
        "defaultMessage": "{issueKey} recurs every 2 weeks"
    },
    successFlagDescriptionRecurOnScheduleIfCompleteDaily: {
        "id": "recur-work-item.success-flag-description-recur-on-schedule-if-complete-daily",
        "defaultMessage": "This {issueType} recurs daily when completed"
    },
    successFlagDescriptionRecurOnScheduleIfCompleteWeekday: {
        "id": "recur-work-item.success-flag-description-recur-on-schedule-if-complete-weekday",
        "defaultMessage": "This {issueType} recurs every weekday when completed"
    },
    successFlagDescriptionRecurOnScheduleIfCompleteWeekly: {
        "id": "recur-work-item.success-flag-description-recur-on-schedule-if-complete-weekly",
        "defaultMessage": "This {issueType} recurs weekly on {weekDayNames} when completed"
    },
    successFlagDescriptionRecurOnScheduleIfCompleteFortnightly: {
        "id": "recur-work-item.success-flag-description-recur-on-schedule-if-complete-fortnightly",
        "defaultMessage": "This {issueType} recurs every 2 weeks on {weekDayNames} when completed"
    },
    successFlagTitleRecurOnScheduleDaily: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-daily",
        "defaultMessage": "{issueKey} recurs every day"
    },
    successFlagTitleRecurOnScheduleWeekday: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-weekday",
        "defaultMessage": "{issueKey} recurs every weekday"
    },
    successFlagTitleRecurOnScheduleWeekly: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-weekly",
        "defaultMessage": "{issueKey} recurs every week on {weekDayNames}"
    },
    successFlagTitleRecurOnScheduleFortnightly: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-fortnightly",
        "defaultMessage": "{issueKey} recurs every 2 weeks on {weekDayNames}"
    },
    goBackLabel: {
        "id": "recur-work-item.go-back-label",
        "defaultMessage": "Go back"
    },
    errorFlagReloadPageButton: {
        "id": "recur-work-item.error-flag-reload-page-button",
        "defaultMessage": "Reload page"
    },
    errorFlagDescription: {
        "id": "recur-work-item.error-flag-description",
        "defaultMessage": "If this keeps happening, share this information with your admin, who should <link>contact support</link>."
    },
    errorFlagTitle: {
        "id": "recur-work-item.error-flag-title",
        "defaultMessage": "Something went wrong on our end"
    }
});

});



parcelRegister("l9xxv", function(module, exports) {

$parcel$export(module.exports, "setAsNonRecurringIssue", () => $867e9b1c0261db63$export$7b76980c59e9a391);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8zOmE = parcelRequire("8zOmE");

var $lQupu = parcelRequire("lQupu");

var $fAJ3G = parcelRequire("fAJ3G");

var $519t2 = parcelRequire("519t2");
const $867e9b1c0261db63$export$7b76980c59e9a391 = ({ isProjectAdmin: isProjectAdmin, isRuleOwner: isRuleOwner, isSiteAdmin: isSiteAdmin, skipDeletingIssueProperties: skipDeletingIssueProperties = false })=>async ({ setState: setState, getState: getState }, { createAnalyticsEvent: createAnalyticsEvent, issueKey: issueKey, environment: environment, cloudId: cloudId, projectId: projectId })=>{
        const { issueProperties: issueProperties, errors: errors, isUpdatingRule: isUpdatingRule } = getState();
        // this can't be !automationRuleUuid because recur-on-complete rules won't have an
        // automationRuleUuid, but they will have issueProperties
        if (!issueProperties) {
            const error = new Error('User is trying to delete a rule before the rule data has been stored.');
            setState({
                errors: [
                    ...errors ?? [],
                    error
                ]
            });
            throw error;
        }
        if (!isSiteAdmin && !isProjectAdmin && !isRuleOwner) {
            const error = new Error('User does not have permission to set issue as non-recurring.');
            setState({
                // TODO: decide if we want to be appending to this list or overwriting it
                errors: [
                    ...errors ?? [],
                    error
                ]
            });
            throw error;
        }
        const { automationRuleUuid: ruleUuid, templateId: templateId, recurOnScheduleConfig: recurOnScheduleConfig } = issueProperties;
        if (skipDeletingIssueProperties && !ruleUuid) // nothing to do
        return;
        setState({
            isDeletingRule: true
        });
        const analyticsEvent = createAnalyticsEvent({});
        // delete or disable the rule if we know the rule UUID
        if (ruleUuid) try {
            if (isRuleOwner || isSiteAdmin) {
                await (0, $519t2.callServiceWithAnalytics)(analyticsEvent, (0, $fAJ3G.deleteRule)({
                    environment: environment,
                    cloudId: cloudId,
                    projectId: projectId,
                    ruleUuid: ruleUuid
                }), 'deleteRule');
                (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'recurringRule deleted', {
                    issueKey: // TODO: add ruleId attribute
                    issueKey,
                    ruleUuid: ruleUuid,
                    templateId: templateId,
                    recurCondition: recurOnScheduleConfig?.recurCondition,
                    isUpdateForExistingRule: isUpdatingRule
                });
            } else {
                await (0, $519t2.callServiceWithAnalytics)(analyticsEvent, (0, $fAJ3G.disableRule)({
                    environment: environment,
                    cloudId: cloudId,
                    projectId: projectId,
                    ruleUuid: ruleUuid
                }), 'disableRule');
                (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'recurringRule disabled', {
                    issueKey: // TODO: add ruleId attribute
                    issueKey,
                    ruleUuid: ruleUuid,
                    templateId: templateId,
                    recurCondition: recurOnScheduleConfig?.recurCondition,
                    isUpdateForExistingRule: isUpdatingRule
                });
            }
        } catch (error) {
            // abort if the rule cannot be deleted/disabled
            setState({
                isDeletingRule: false,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                errors: [
                    ...errors ?? [],
                    error
                ]
            });
            throw error;
        }
        if (skipDeletingIssueProperties) {
            // we only get here if we've successfully deleted/disabled a recur-on-schedule rule.
            // it's not possible to re-enable disabled rules, so we can assume that the rule will
            // no longer generate future work items. this means that the issue's issue properties
            // are no longer important to store.
            setState({
                isDeletingRule: false,
                ...(0, $lQupu.NO_RULE_PARTIAL_STATE)
            });
            return;
        }
        try {
            await (0, $519t2.callServiceWithAnalytics)(analyticsEvent, (0, $fAJ3G.deleteIssueProperties)({
                issueKey: issueKey
            }), 'deleteIssueProperties');
            setState({
                isDeletingRule: false,
                ...(0, $lQupu.NO_RULE_PARTIAL_STATE)
            });
        } catch (error) {
            if (!ruleUuid) {
                // in this case, we haven't deleted or disabled the rule, so the rule can still generate
                // future work items. we leave the rule stored in state unchanged and rethrow the error.
                setState({
                    isDeletingRule: false,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    errors: [
                        ...errors ?? [],
                        error
                    ]
                });
                throw error;
            }
            // don't rethrow because from the user's perspective, the work item is no longer recurring.
            setState({
                isDeletingRule: false,
                ...(0, $lQupu.NO_RULE_PARTIAL_STATE),
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                errors: [
                    ...errors ?? [],
                    error
                ]
            });
        }
    };

});
parcelRegister("lQupu", function(module, exports) {

$parcel$export(module.exports, "INITIAL_STATE", () => $6bdecc95b0135cf9$export$36d128238e6b60f5);
$parcel$export(module.exports, "NO_RULE_PARTIAL_STATE", () => $6bdecc95b0135cf9$export$a1b15f9b9ceb0f70);
const $6bdecc95b0135cf9$export$36d128238e6b60f5 = {
    hasFetched: false,
    isFetching: false,
    isCreatingRule: false,
    isDeletingRule: false,
    isUpdatingRule: false,
    errors: null,
    hasBootstrapError: false,
    isRuleOwner: null,
    issueProperties: null
};
const $6bdecc95b0135cf9$export$a1b15f9b9ceb0f70 = {
    isRuleOwner: null,
    issueProperties: null
};

});


parcelRegister("bvhsR", function(module, exports) {

$parcel$export(module.exports, "setAsRecurringIssue", () => $fe7808073e642503$export$5d9cc8e9f9314f21);

var $7Jxgt = parcelRequire("7Jxgt");

var $8zOmE = parcelRequire("8zOmE");

var $cS75I = parcelRequire("cS75I");

var $ahBjy = parcelRequire("ahBjy");

var $519t2 = parcelRequire("519t2");
const $fe7808073e642503$export$5d9cc8e9f9314f21 = ({ recurOnScheduleConfig: { rRule: rRule, recurCondition: recurCondition, dueDateOffsetSmartValue: dueDateOffsetSmartValue } })=>async ({ setState: setState, getState: getState }, { createAnalyticsEvent: createAnalyticsEvent, issueKey: issueKey, environment: environment, cloudId: cloudId, projectId: projectId })=>{
        const { errors: errors, isUpdatingRule: isUpdatingRule } = getState();
        setState({
            isCreatingRule: true
        });
        const recurrenceToken = (0, $7Jxgt.v4)();
        const templateId = (0, $ahBjy.SOFTWARE_END_USER_TEMPLATE_2);
        const analyticsEvent = createAnalyticsEvent({});
        try {
            const createTemplateResponse = await (0, $519t2.callServiceWithAnalytics)(analyticsEvent, (0, $cS75I.createTemplate)({
                environment: environment,
                cloudId: cloudId,
                projectId: projectId,
                recurrenceToken: recurrenceToken,
                recurCondition: recurCondition,
                rRule: rRule,
                dueDateOffsetSmartValue: dueDateOffsetSmartValue
            }), 'createTemplate');
            if (createTemplateResponse?.ruleUuid) {
                await (0, $519t2.callServiceWithAnalytics)(analyticsEvent, (0, $cS75I.setIssueProperties)({
                    issueKey: issueKey,
                    recurrenceToken: recurrenceToken,
                    ruleUuid: createTemplateResponse.ruleUuid,
                    recurCondition: recurCondition,
                    rRule: rRule,
                    templateId: templateId,
                    dueDateOffsetSmartValue: dueDateOffsetSmartValue
                }), 'setIssueProperties');
                (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'recurringRule created', {
                    issueKey: // TODO: add ruleId attribute
                    issueKey,
                    ruleUuid: createTemplateResponse.ruleUuid,
                    templateId: templateId,
                    recurCondition: recurCondition,
                    isUpdateForExistingRule: isUpdatingRule
                });
                const issueProperties = {
                    automationRuleUuid: createTemplateResponse.ruleUuid,
                    token: recurrenceToken,
                    templateId: templateId,
                    recurOnScheduleConfig: {
                        rRule: rRule,
                        dueDateOffsetSmartValue: dueDateOffsetSmartValue,
                        recurCondition: recurCondition
                    }
                };
                setState({
                    isCreatingRule: false,
                    issueProperties: issueProperties,
                    isRuleOwner: true
                });
            } else throw new Error('New rule failed to be created.');
        } catch (error) {
            setState({
                isCreatingRule: false,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                errors: [
                    ...errors ?? [],
                    error
                ]
            });
            throw error;
        }
    };

});
parcelRegister("cS75I", function(module, exports) {

$parcel$export(module.exports, "createTemplate", () => $d425ed86c31f35f6$export$7b7ae612b60e1630);
$parcel$export(module.exports, "setIssueProperties", () => $d425ed86c31f35f6$export$5153917efea4a83d);

var $kV9ss = parcelRequire("kV9ss");

var $c5wox = parcelRequire("c5wox");

var $eusud = parcelRequire("eusud");

var $ahBjy = parcelRequire("ahBjy");
const $d425ed86c31f35f6$export$7b7ae612b60e1630 = async ({ environment: environment, cloudId: cloudId, projectId: projectId, recurrenceToken: recurrenceToken, recurCondition: recurCondition, rRule: rRule, dueDateOffsetSmartValue: dueDateOffsetSmartValue })=>{
    const automationStack = await (0, $c5wox.getAutomationStack)(environment, cloudId);
    const CREATE_TEMPLATE_URL = `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/public/rest/v1/template/create`;
    const ruleHomeARI = (0, $kV9ss.JiraProjectAri).create({
        siteId: cloudId,
        projectId: String(projectId)
    });
    const payload = {
        ruleHome: ruleHomeARI,
        templateId: (0, $ahBjy.SOFTWARE_END_USER_TEMPLATE_2),
        parameters: {
            recurrenceToken: {
                value: recurrenceToken,
                type: 'TEXT'
            },
            rRule: {
                value: rRule,
                type: 'TEXT'
            },
            dueDateOffsetSmartValue: {
                value: dueDateOffsetSmartValue,
                type: 'TEXT'
            },
            recurCondition: {
                value: recurCondition,
                type: 'TEXT'
            }
        }
    };
    return (0, $eusud.performPostRequest)(CREATE_TEMPLATE_URL, {
        body: JSON.stringify(payload)
    });
};
const $d425ed86c31f35f6$export$5153917efea4a83d = async ({ issueKey: issueKey, ruleUuid: ruleUuid, recurrenceToken: recurrenceToken, recurCondition: recurCondition, rRule: rRule, templateId: templateId, dueDateOffsetSmartValue: dueDateOffsetSmartValue })=>{
    const issuePropertiesEndpoint = `/rest/api/2/issue/${issueKey}/properties/recurrence-config`;
    const requestBody = {
        automationRuleUuid: ruleUuid,
        token: recurrenceToken,
        templateId: templateId,
        recurOnScheduleConfig: {
            rRule: rRule,
            dueDateOffsetSmartValue: dueDateOffsetSmartValue,
            recurCondition: recurCondition
        }
    };
    return (0, $eusud.performPutRequest)(issuePropertiesEndpoint, {
        body: JSON.stringify(requestBody)
    });
};

});


parcelRegister("c8g0F", function(module, exports) {

$parcel$export(module.exports, "updateRule", () => $257e932348ccd8c0$export$b2ebf395d72c5a4c);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8zOmE = parcelRequire("8zOmE");

var $fAJ3G = parcelRequire("fAJ3G");

var $519t2 = parcelRequire("519t2");

var $bvhsR = parcelRequire("bvhsR");

var $l9xxv = parcelRequire("l9xxv");
const $257e932348ccd8c0$export$b2ebf395d72c5a4c = ({ isProjectAdmin: isProjectAdmin, isRuleOwner: isRuleOwner, isSiteAdmin: isSiteAdmin, recurOnScheduleConfig: recurOnScheduleConfig })=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { createAnalyticsEvent: createAnalyticsEvent, issueKey: issueKey })=>{
        const { issueProperties: issueProperties, errors: errors } = getState();
        if (!issueProperties) {
            // if there is no existing rule, then create a new rule and update issue properties
            await dispatch((0, $bvhsR.setAsRecurringIssue)({
                recurOnScheduleConfig: recurOnScheduleConfig
            }));
            return;
        }
        const { automationRuleUuid: ruleUuid, templateId: templateId } = issueProperties;
        setState({
            isUpdatingRule: true
        });
        try {
            await dispatch((0, $l9xxv.setAsNonRecurringIssue)({
                isProjectAdmin: isProjectAdmin,
                isRuleOwner: isRuleOwner,
                isSiteAdmin: isSiteAdmin,
                // we'll update issue properties later
                skipDeletingIssueProperties: true
            }));
        } catch (error) {
            // don't need to save the error to state because setAsNonRecurringIssue should already do this
            setState({
                isUpdatingRule: false
            });
            throw error;
        }
        // create the new rule
        try {
            await dispatch((0, $bvhsR.setAsRecurringIssue)({
                recurOnScheduleConfig: recurOnScheduleConfig
            }));
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'recurringRule updated', {
                issueKey: // TODO: add ruleId attribute
                issueKey,
                ruleUuid: ruleUuid,
                templateId: templateId,
                recurCondition: recurOnScheduleConfig?.recurCondition,
                isUpdateForExistingRule: true
            });
            setState({
                isUpdatingRule: false
            });
        } catch (error) {
            // if we fail to create the rule and update issue properties, then we need to go back and remove the
            // original recurring rule config from issue properties
            try {
                setState({
                    isDeletingRule: true
                });
                await (0, $519t2.callServiceWithAnalytics)(createAnalyticsEvent({}), (0, $fAJ3G.deleteIssueProperties)({
                    issueKey: issueKey
                }), 'deleteIssueProperties');
                setState({
                    isDeletingRule: false,
                    isUpdatingRule: false,
                    issueProperties: null,
                    isRuleOwner: null,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    errors: [
                        ...errors ?? [],
                        error
                    ]
                });
            } catch (anotherError) {
                // we've made no changes to the rule config since we called `setAsNonRecurringIssue` above,
                // so we don't need to update ruleSummary or issueProperties.
                setState({
                    isDeletingRule: false,
                    isUpdatingRule: false,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    errors: [
                        ...errors ?? [],
                        error,
                        anotherError
                    ]
                });
                throw anotherError;
            }
            // we've just successfully deleted the existing rule; we haven't actually created a new one.
            throw error;
        }
    };

});



parcelRegister("CKlOf", function(module, exports) {

$parcel$export(module.exports, "messages", () => $d9e9728e1365538b$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $d9e9728e1365538b$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    overdue: {
        "id": "business.list.ui.list-view.date-cell.overdue",
        "defaultMessage": "Overdue since {date}"
    },
    due: {
        "id": "business.list.ui.list-view.date-cell.due",
        "defaultMessage": "Due on {date}"
    }
});

});


parcelRegister("luwkS", function(module, exports) {

$parcel$export(module.exports, "default", () => $e37f02f7dd24a69d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $e37f02f7dd24a69d$var$Calendar = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("emMHU")), {
    ssr: false,
    moduleId: "./src/packages/business/list/src/ui/list-view/date-cell/async-calendar/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e37f02f7dd24a69d$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "calendar",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e37f02f7dd24a69d$var$Calendar, props));

});
parcelRegister("emMHU", function(module, exports) {

let $a758e704f4bb48f5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a758e704f4bb48f5$var$load("jHb4U").then(()=>parcelRequire('jaONu'));

});


parcelRegister("7pQZt", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf5372cb47c43ab2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $cf5372cb47c43ab2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    emptyDate: {
        "id": "business-list.list-view.date-cell.empty-date",
        "defaultMessage": "None"
    },
    errorTitle: {
        "id": "business-list.list-view.date-cell.error-title",
        "defaultMessage": "We couldn't save the date value."
    },
    errorMessage: {
        "id": "business-list.list-view.date-cell.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    },
    due: {
        "id": "date-with-urgency-indicator.due",
        "defaultMessage": "Due on {date}"
    },
    overdue: {
        "id": "date-with-urgency-indicator.overdue",
        "defaultMessage": "Overdue since {date}"
    }
});

});


parcelRegister("iQ6fh", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b9bcd5d05e0ecfc$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $2NMNM = parcelRequire("2NMNM");

var $8yYK6 = parcelRequire("8yYK6");

var $kgoHi = parcelRequire("kgoHi");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $e0a4D = parcelRequire("e0a4D");

var $jRzRt = parcelRequire("jRzRt");

var $koVbs = parcelRequire("koVbs");

var $lQE94 = parcelRequire("lQE94");

var $8tRRd = parcelRequire("8tRRd");

var $jgJNO = parcelRequire("jgJNO");

var $eTDjN = parcelRequire("eTDjN");

var $lI995 = parcelRequire("lI995");

var $fDcD3 = parcelRequire("fDcD3");

var $fdumZ = parcelRequire("fdumZ");

var $fBU5v = parcelRequire("fBU5v");
const $9b9bcd5d05e0ecfc$var$POPUP_OFFSET = [
    0,
    -(0, $eTDjN.DEFAULT_ROW_HEIGHT) - 1
];
const $9b9bcd5d05e0ecfc$var$DateTimeCell = /*#__PURE__*/ (0, $5uXOq.memo)(({ issueKey: issueKey = '', fieldKey: fieldKey, fieldValue: fieldValue = null, width: width, height: height, isSelected: isSelected = false, editMode: editMode = false, setEditMode: setEditMode = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isHovering: isHovering = false, cellRef: cellRef, fieldName: fieldName = '', issueType: issueType = '', issueTypeId: issueTypeId = '', inputValue: inputValue, onInputChange: onInputChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const textInputValue = (inputValue ?? fieldValue) || '';
    const setTextInputValue = (0, $5uXOq.useCallback)((value)=>onInputChange(value === null ? '' : value), [
        onInputChange
    ]);
    const { formatDateTime: formatDateTime } = (0, $8tRRd.useDateTimeFormatter)(null);
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $lQE94.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: 'datetime',
        initialValue: fieldValue
    });
    (0, $5uXOq.useEffect)(()=>{
        setTextInputValue(value);
    }, [
        setTextInputValue,
        value
    ]);
    const handleChange = (0, $5uXOq.useCallback)((newValue)=>{
        resetError();
        if (newValue === value) return;
        saveValue(newValue, null, createAnalyticsEvent({}));
    }, [
        createAnalyticsEvent,
        resetError,
        saveValue,
        value
    ]);
    const saveAndClose = (0, $5uXOq.useCallback)(()=>{
        setEditMode(false);
        if (textInputValue === value) return;
        saveValue(textInputValue, null, createAnalyticsEvent({}));
    }, [
        createAnalyticsEvent,
        saveValue,
        textInputValue,
        value,
        setEditMode
    ]);
    const staticContent = textInputValue !== null && textInputValue !== '' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lI995.Container), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fBU5v.CellContent), null, formatDateTime(textInputValue)));
    const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
        if (editMode && [
            'Enter',
            'Tab'
        ].includes(event.code)) return true;
        return false;
    }, [
        editMode
    ]);
    const popupContent = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fDcD3.default), {
            width: width,
            height: height,
            value: textInputValue,
            onChange: handleChange
        }), [
        handleChange,
        height,
        textInputValue,
        width
    ]);
    const popupTrigger = (0, $5uXOq.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", triggerProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lI995.Container), null, textInputValue !== null && textInputValue !== '' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fBU5v.CellContent), null, formatDateTime(textInputValue)), (textInputValue === null || textInputValue === '') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lI995.EmptyCellContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8yYK6))), {
            spacing: "spacious",
            label: formatMessage((0, $fdumZ.default).emptyDate)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, formatMessage((0, $fdumZ.default).emptyDate))))), [
        formatDateTime,
        formatMessage,
        textInputValue
    ]);
    (0, $5uXOq.useImperativeHandle)(cellRef, ()=>({
            onKeyDown: handleKeyDown
        }), [
        handleKeyDown
    ]);
    const cellContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isHovering || editMode || isSelected ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        autoFocus: false,
        isOpen: editMode,
        placement: "bottom-start",
        messageId: "business-list.ui.list-view.date-time-cell.popup",
        messageType: "transactional",
        offset: $9b9bcd5d05e0ecfc$var$POPUP_OFFSET,
        popupComponent: (0, $jRzRt.PopupComponent),
        onClose: saveAndClose,
        content: popupContent,
        trigger: popupTrigger
    }) : staticContent, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0a4D.FixItErrorFlag), {
        error: error,
        title: (0, $fdumZ.default).errorTitle,
        description: (0, $fdumZ.default).errorMessage,
        issueType: issueType,
        issueTypeId: issueTypeId,
        fieldId: fieldKey,
        fieldName: fieldName
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: [
            $9b9bcd5d05e0ecfc$var$wrapperStyles
        ],
        testId: "business-list.ui.list-view.date-time-cell.cell-container"
    }, cellContent);
});
var $9b9bcd5d05e0ecfc$export$2e2bcd8739ae039 = $9b9bcd5d05e0ecfc$var$DateTimeCell;
const $9b9bcd5d05e0ecfc$var$wrapperStyles = (0, $8CUq3.xcss)({
    width: '100%',
    height: '100%'
});

});
parcelRegister("8yYK6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::61cc856ba673fb016dcc97fed2247ace>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $63c09dee2c4be134$var$_react = $63c09dee2c4be134$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $63c09dee2c4be134$var$_clock = $63c09dee2c4be134$var$_interopRequireDefault((parcelRequire("hyKRO")));

var $63c09dee2c4be134$var$_recent = $63c09dee2c4be134$var$_interopRequireDefault((parcelRequire("5IlYG")));
function $63c09dee2c4be134$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ClockIcon.
 * This component is ClockIcon, with `UNSAFE_fallbackIcon` set to "RecentIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: recent, time input, sprint time remaining, overdue task work type status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $63c09dee2c4be134$var$ClockIcon = (props)=>/*#__PURE__*/ $63c09dee2c4be134$var$_react.default.createElement($63c09dee2c4be134$var$_clock.default, Object.assign({
        LEGACY_fallbackIcon: $63c09dee2c4be134$var$_recent.default
    }, props));
$63c09dee2c4be134$var$ClockIcon.Name = 'ClockIconMigration';
var $63c09dee2c4be134$var$_default = module.exports.default = $63c09dee2c4be134$var$ClockIcon;

});

parcelRegister("8tRRd", function(module, exports) {

$parcel$export(module.exports, "useDateTimeFormatter", () => $e6616d5994c4d841$export$163f492669f74d5b);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $cYlk7 = parcelRequire("cYlk7");

var $DVljb = parcelRequire("DVljb");

var $1YbNB = parcelRequire("1YbNB");

var $6yeNV = parcelRequire("6yeNV");
const $e6616d5994c4d841$export$163f492669f74d5b = (overrideTimeZone)=>{
    (0, $gKZoD.di)(Intl);
    const { data: { // @ts-expect-error - TS2339 - Property 'timeZone' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
    user: { timeZone: timeZonePreference } } } = (0, $cYlk7.useCurrentUser)();
    const timeZone = overrideTimeZone ?? timeZonePreference;
    const jiraLocal = (0, $DVljb.useLocale)();
    const standardizedLocale = (0, $6yeNV.standardizeLocale)(jiraLocal);
    const verifiedTimeZone = (0, $6yeNV.verifyTimeZone)(timeZone);
    const dateTimeFormatter = (0, $5uXOq.useMemo)(()=>new Intl.DateTimeFormat(standardizedLocale, {
            ...(0, $1YbNB.longDateTimeFormat),
            timeZone: verifiedTimeZone
        }), [
        standardizedLocale,
        verifiedTimeZone
    ]);
    const dateOnlyFormatter = (0, $5uXOq.useMemo)(()=>new Intl.DateTimeFormat(standardizedLocale, {
            ...(0, $1YbNB.longDateOnlyFormat),
            timeZone: 'UTC'
        }), [
        standardizedLocale
    ]);
    const formatDateTime = (0, $5uXOq.useCallback)((date)=>{
        const rawValue = typeof date === 'string' ? new Date(date) : date;
        return dateTimeFormatter.format(rawValue);
    }, [
        dateTimeFormatter
    ]);
    const formatDateOnly = (0, $5uXOq.useCallback)((date)=>dateOnlyFormatter.format(new Date(date)), [
        dateOnlyFormatter
    ]);
    return {
        formatDateTime: /**
		 * Returns the long form of a date value with respect to the user's locale and timezone preferences
		 *
		 * @param {string|number|date} date Value as either an [ISO8601 string](https://www.w3.org/TR/NOTE-datetime) (eg `"1997-07-16T19:20:30.45+01:00"`), epoch number (eg `1615431020`), or vanilla `Date` object
		 *
		 * ## Examples
		 *
		 * ```js
		 * // returns Jan 22, 2021, 1:11 PM
		 * formatDateTime(1611281490857) // where user locale is "en-US"
		 *
		 * // returns 2021年1月22日 午後1:11
		 * formatDateTime(1611281490857) // where user locale is "ja-JP"
		 * ```
		 */ formatDateTime,
        formatDateOnly: /**
		 * Returns the long form of a date without time value with respect to the user's locale. Timezones do not apply to these dates.
		 *
		 * @param {string} date Value as a 'YYYY-MM-DD' string (eg `"1997-07-16"`)
		 *
		 * ## Examples
		 *
		 * ```js
		 * // returns Jan 22, 2021
		 * formatDateOnly('2021-01-22') // where user locale is "en-US"
		 *
		 * // returns 2021年1月22日
		 * formatDateOnly('2021-01-22') // where user locale is "ja-JP"
		 * ```
		 */ formatDateOnly
    };
};

});
parcelRegister("1YbNB", function(module, exports) {

$parcel$export(module.exports, "longDateTimeFormat", () => $71114821d9cd9835$export$f2f390060309965);
$parcel$export(module.exports, "longDateOnlyFormat", () => $71114821d9cd9835$export$51f819d50bcd4ae1);
/**
 * If this file gets changed, please update platform/packages/proforma/proforma-common-core/src/form-system/components/questions/common/defaultDateTimeFormats.tsx or let the owners know via #jsm-request-intake.
 *
 * Proforma wants to stay consistent with Jira date and time format options.
 *
 * Later on Proforma will introduce React Context to pass config props, and this will be removed.
 */ /**
 * Long format of a date time, eg "Jun 16, 1971, 2:34 AM" with 12h/24h formatting resolved from locale
 */ const $71114821d9cd9835$export$f2f390060309965 = {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
};
const $71114821d9cd9835$export$51f819d50bcd4ae1 = {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
};

});


parcelRegister("fDcD3", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bae380e69b076bf$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $8bae380e69b076bf$var$DateTimeFieldEditView = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("hpA4c")), {
    ssr: false,
    moduleId: "./src/packages/business/list/src/ui/list-view/date-time-cell/async-date-time-picker/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8bae380e69b076bf$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "date-time-field-edit-view",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8bae380e69b076bf$var$DateTimeFieldEditView, props));

});
parcelRegister("hpA4c", function(module, exports) {

let $cad0bf8bbebae015$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cad0bf8bbebae015$var$load("4i5ak").then(()=>parcelRequire('9xCka'));

});


parcelRegister("fdumZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0efcea67dc18ed61$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0efcea67dc18ed61$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    emptyDate: {
        "id": "business-list.list-view.date-time-cell.empty-date",
        "defaultMessage": "None"
    },
    errorTitle: {
        "id": "business-list.list-view.date-time-cell.error-title",
        "defaultMessage": "We couldn't save the date time value."
    },
    errorMessage: {
        "id": "business-list.list-view.date-time-cell.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    }
});

});

parcelRegister("fBU5v", function(module, exports) {

$parcel$export(module.exports, "CellContent", () => $003a848b9a178764$export$3b628a2b5574282f);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $003a848b9a178764$export$3b628a2b5574282f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bto1l2s",
            __cmplp.className
        ])
    });
});

});


parcelRegister("0CGYD", function(module, exports) {

$parcel$export(module.exports, "KeyCell", () => $0ff0bb70369876ca$export$4d17c2f4d9bbf823);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $b0JGA = parcelRequire("b0JGA");

var $btivG = parcelRequire("btivG");

var $jOyH3 = parcelRequire("jOyH3");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $bG3pQ = parcelRequire("bG3pQ");

var $hE5wF = parcelRequire("hE5wF");

var $1JH9w = parcelRequire("1JH9w");

var $b6nbP = parcelRequire("b6nbP");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $6s1PB = parcelRequire("6s1PB");

var $aPg5m = parcelRequire("aPg5m");

var $3xYte = parcelRequire("3xYte");

var $4nnGr = parcelRequire("4nnGr");

var $mH57d = parcelRequire("mH57d");

var $92kct = parcelRequire("92kct");

var $9YM9G = parcelRequire("9YM9G");
const $0ff0bb70369876ca$export$4d17c2f4d9bbf823 = /*#__PURE__*/ (0, $5uXOq.memo)(({ issueId: issueId, issueKey: issueKey, parentIssues: parentIssues, onOpenIssueModal: onOpenIssueModal, isHovering: isHovering = false, cellRef: cellRef, issueHasUnreadComment: issueHasUnreadComment })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isCopied, setIsCopied] = (0, $5uXOq.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { issueViewInteraction: issueViewInteraction } = (0, $4nnGr.useJWMListFeatures)();
    const { showFlatList: showFlatList } = (0, $mH57d.useHierarchyConfig)();
    const { prefetchIssue: prefetchIssue } = (0, $1JH9w.usePrefetchIssueViewDataActions)();
    const [{ hasSelection: hasSelection }] = (0, $3xYte.useHasCellSelection)();
    const handleIssueKeyMouseEnter = (0, $5uXOq.useCallback)(()=>{
        prefetchIssue(issueKey);
    }, [
        issueKey,
        prefetchIssue
    ]);
    const { clearSelectedCell: clearSelectedCell } = (0, $3xYte.useCellActions)();
    const handleCopyClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'keyCell copyIssueLink', {});
    }, [
        createAnalyticsEvent
    ]);
    const handleCopyReset = (0, $5uXOq.useCallback)(()=>setIsCopied(false), [
        setIsCopied
    ]);
    const handleClickChange = (0, $5uXOq.useCallback)((status)=>setIsCopied(status), []);
    const onEmbedIssueClick = (0, $5uXOq.useCallback)((event)=>{
        clearSelectedCell();
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'issue clicked', 'listEmbedIssue');
        (0, $bG3pQ.openViewFromEmbed)({
            key: (0, $hE5wF.SELECTED_ISSUE_PARAM),
            value: issueKey
        });
        event.preventDefault();
        event.stopPropagation();
    }, [
        clearSelectedCell,
        createAnalyticsEvent,
        issueKey
    ]);
    const onIssueKeyClick = (0, $5uXOq.useCallback)(({ id: id, key: key })=>(event)=>{
            event.stopPropagation();
            clearSelectedCell();
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'keyCell linkClicked', {
                ...(0, $6s1PB.expVal)('jira_unread_comments_in_list_view', 'isEnabled', false) ? {
                    issueHasUnreadComment: issueHasUnreadComment
                } : {}
            });
            onOpenIssueModal({
                id: id,
                key: key
            })(event);
        }, [
        clearSelectedCell,
        createAnalyticsEvent,
        issueHasUnreadComment,
        onOpenIssueModal
    ]);
    const handleKeyDownNew = (0, $5uXOq.useCallback)((e)=>{
        if (e.key === 'Enter') issueViewInteraction === 'openNewTab' ? onEmbedIssueClick(e) : onIssueKeyClick({
            id: issueId,
            key: issueKey
        })(e);
        return false;
    }, [
        issueId,
        issueKey,
        issueViewInteraction,
        onEmbedIssueClick,
        onIssueKeyClick
    ]);
    const handleCopyIconFocus = (0, $5uXOq.useCallback)((e)=>{
        // do not allow focus to propagate or it will select the cell
        e.stopPropagation();
    }, []);
    (0, $5uXOq.useImperativeHandle)(cellRef, ()=>({
            onClick: ()=>true,
            onKeyDown: handleKeyDownNew
        }), [
        handleKeyDownNew
    ]);
    let keyContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9YM9G.IssueKey), {
        href: `/browse/${issueKey}`,
        onClick: issueViewInteraction === 'openNewTab' ? onEmbedIssueClick : onIssueKeyClick({
            id: issueId,
            key: issueKey
        }),
        onMouseEnter: handleIssueKeyMouseEnter,
        "data-testid": "business-list.ui.list-view.key-cell.issue-key"
    }, issueKey);
    if (showFlatList && parentIssues != null) keyContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0ff0bb70369876ca$var$IssueKeyContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0ff0bb70369876ca$var$ParentIssueKeysWrapper, null, parentIssues.map(({ id: id, key: key }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
            key: id
        }, index > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0ff0bb70369876ca$var$ParentIssueKeysDivider, null, "/"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9YM9G.IssueKey), {
            href: `/browse/${key}`,
            onClick: issueViewInteraction === 'openNewTab' ? onEmbedIssueClick : onIssueKeyClick({
                id: id,
                key: key
            }),
            "data-testid": "business-list.ui.list-view.key-cell.parent-issue-key"
        }, key)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0ff0bb70369876ca$var$IssueKeyHierarchyWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aPg5m.default), {
        label: "",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9YM9G.IssueKey), {
        href: `/browse/${issueKey}`,
        onClick: issueViewInteraction === 'openNewTab' ? onEmbedIssueClick : onIssueKeyClick({
            id: issueId,
            key: issueKey
        }),
        "data-testid": "business-list.ui.list-view.key-cell.issue-key"
    }, issueKey)));
    /**
   * when copy and paste is enabled,
   * - show the copy icon when:
   * 		- hovering
   * 		- issue key has just been copied - so the reset logic built into the copy icon can be triggered after 3 seconds
   * - hide the copy icon when:
   * 		- there is a selection in the list, so the copy action doesn't conflict with other cell's copy action
   */ const shouldShowCopyIcon = !hasSelection && isHovering || isCopied;
    const keyCellContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, keyContent, shouldShowCopyIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0ff0bb70369876ca$var$CopyIconWrapper, {
        onFocus: handleCopyIconFocus
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b6nbP.default), {
        id: `copy-${issueKey}`,
        label: formatMessage((0, $92kct.default).copy),
        tooltipDelay: 0,
        tooltipLabel: formatMessage((0, $92kct.default).copy),
        tooltipLabelPosition: "top",
        shouldFitContainer: true,
        value: typeof window !== 'undefined' ? `${window.location.origin}/browse/${issueKey}` : '',
        hideFieldText: true,
        remountOnChange: true,
        onCopyClick: handleCopyClick,
        onClickChange: handleClickChange,
        onCopyReset: handleCopyReset
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle-link",
        iconBefore: isCopied ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b0JGA))), {
            label: formatMessage((0, $92kct.default).copied),
            color: "var(--ds-icon-success, #22A06B)",
            LEGACY_primaryColor: "var(--ds-background-success-bold, #1F845A)",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($btivG))),
            LEGACY_size: "small"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jOyH3))), {
            LEGACY_size: "small",
            label: formatMessage((0, $92kct.default).copy)
        }),
        spacing: "none",
        "aria-label": isCopied ? formatMessage((0, $92kct.default).copied) : formatMessage((0, $92kct.default).copy)
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $0ff0bb70369876ca$var$issueKeyCellStyles
    }, keyCellContent);
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0ff0bb70369876ca$var$CopyIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_v5641hdd _tzy41r8u _t9ec12hf _u5f31b66 _4t3ipxbi _kqswstnw _1xi2idpf",
            __cmplp.className
        ])
    });
});
const $0ff0bb70369876ca$var$issueKeyCellStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    outline: 'none',
    paddingLeft: 'space.100',
    paddingRight: 'space.100',
    fontWeight: "var(--ds-font-weight-medium, 500)",
    cursor: 'pointer',
    color: 'color.text',
    position: 'relative',
    '--copy-icon-opacity': 0,
    '--copy-icon-transform': `translate(${"var(--ds-space-negative-100, -8px)"}, 0)`,
    ':hover': {
        // @ts-expect-error - TS2353 - Object literal may only specify known properties, and ''--copy-icon-opacity'' does not exist in type 'SafeCSSObject'
        '--copy-icon-opacity': 1,
        '--copy-icon-transform': 'translate(0, 0)'
    }
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0ff0bb70369876ca$var$IssueKeyContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _1bsb1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0ff0bb70369876ca$var$IssueKeyHierarchyWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0ff0bb70369876ca$var$ParentIssueKeysWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81o8v _1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0ff0bb70369876ca$var$ParentIssueKeysDivider = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3v77o _n3tdidpf _19bvv77o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jOyH3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0c2e6e563a714afa66b2c445d0695bd6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e6cd993777d46e1b$var$_react = $e6cd993777d46e1b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e6cd993777d46e1b$var$_link = $e6cd993777d46e1b$var$_interopRequireDefault((parcelRequire("1f9bV")));

var $e6cd993777d46e1b$var$_link2 = $e6cd993777d46e1b$var$_interopRequireDefault((parcelRequire("458iJ")));
function $e6cd993777d46e1b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LinkIcon.
 * This component is LinkIcon, with `UNSAFE_fallbackIcon` set to "LinkIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e6cd993777d46e1b$var$LinkIcon = (props)=>/*#__PURE__*/ $e6cd993777d46e1b$var$_react.default.createElement($e6cd993777d46e1b$var$_link.default, Object.assign({
        LEGACY_fallbackIcon: $e6cd993777d46e1b$var$_link2.default
    }, props));
$e6cd993777d46e1b$var$LinkIcon.Name = 'LinkIconMigration';
var $e6cd993777d46e1b$var$_default = module.exports.default = $e6cd993777d46e1b$var$LinkIcon;

});
parcelRegister("458iJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2f8e117d74b4de46$var$_react = $2f8e117d74b4de46$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $2f8e117d74b4de46$var$_link = $2f8e117d74b4de46$var$_interopRequireDefault((parcelRequire("1f9bV")));
function $2f8e117d74b4de46$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2f8e117d74b4de46$var$LinkIcon = (props)=>/*#__PURE__*/ $2f8e117d74b4de46$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m12.856 5.457-.937.92a1 1 0 0 0 0 1.437 1.047 1.047 0 0 0 1.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 0 1 .203 3.81l-2.903 2.852a2.646 2.646 0 0 1-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 0 0-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47"/><path d="m11.144 19.543.937-.92a1 1 0 0 0 0-1.437 1.047 1.047 0 0 0-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 0 1-.203-3.81l2.903-2.852a2.646 2.646 0 0 1 3.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 0 0 .357 6.82c1.893 1.517 4.695 1.226 6.422-.47"/></g></svg>`
    }, props, {
        newIcon: $2f8e117d74b4de46$var$_link.default
    }));
$2f8e117d74b4de46$var$LinkIcon.displayName = 'LinkIcon';
var $2f8e117d74b4de46$var$_default = module.exports.default = $2f8e117d74b4de46$var$LinkIcon;

});


parcelRegister("bG3pQ", function(module, exports) {

$parcel$export(module.exports, "openViewFromEmbed", () => $b6fc163d26910ed9$export$a29603f2eb9b6da6);

var $gKZoD = parcelRequire("gKZoD");
const $b6fc163d26910ed9$export$a29603f2eb9b6da6 = (param)=>{
    (0, $gKZoD.di)(window);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const cleanUrl = window.location.href.replace('/embed', '');
    const currentUrl = new URL(cleanUrl);
    if (param != null) currentUrl.searchParams.append(param.key, param.value);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.open(currentUrl.href, '_blank');
};

});

parcelRegister("b6nbP", function(module, exports) {

$parcel$export(module.exports, "default", () => $f75a19e3ebf5c6c9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7EEmi = parcelRequire("7EEmi");
class $f75a19e3ebf5c6c9$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            className: undefined,
            shouldFitContainer: false,
            hideFieldText: false,
            onCopyClick: undefined,
            onCopyReset: undefined,
            tooltipDelay: undefined,
            remountOnChange: false,
            tooltipDisabled: false
        };
    }
    componentWillUnmount() {
        clearTimeout(this.timeoutId);
    }
    render() {
        const { id: id, label: label, tooltipLabel: tooltipLabel, tooltipLabelPosition: tooltipLabelPosition, tooltipDelay: tooltipDelay, remountOnChange: remountOnChange, value: value, className: className, shouldFitContainer: shouldFitContainer, hideFieldText: hideFieldText, tooltipDisabled: tooltipDisabled, ariaDescribedBy: ariaDescribedBy } = this.props;
        // When the input field holding the copy text is hidden, its value is not set in
        // the input field to avoid it accidentally being included in a selection when the user
        // is copying other content on the page.
        const fieldValue = hideFieldText ? '' : value;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7EEmi.default), {
            id: id,
            label: label,
            tooltipLabel: tooltipLabel,
            tooltipLabelPosition: tooltipLabelPosition,
            tooltipDelay: tooltipDelay,
            remountOnChange: remountOnChange,
            fieldKey: value,
            value: fieldValue,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            shouldFitContainer: shouldFitContainer,
            hideFieldText: hideFieldText,
            ...this.state,
            onCopyClick: this.onCopyClick,
            innerInputRef: this.onRef,
            tooltipDisabled: tooltipDisabled,
            ariaDescribedBy: ariaDescribedBy
        }, this.props.children);
    }
    constructor(...args){
        super(...args), this.state = {
            copied: false,
            copyFailed: false
        }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onCopyClick = (event, analyticsEvent)=>{
            if (!this.inputTextRef || !this.inputTextRef.current) return;
            this.props.onCopyClick && this.props.onCopyClick(event, analyticsEvent);
            if (this.props.hideFieldText) // For hidden fields, update the input field ref to include the value only after the user
            // has clicked the copy button.
            this.inputTextRef.current.value = this.props.value;
            this.inputTextRef.current.select();
            let success = false;
            try {
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                success = document.execCommand('copy');
                this.setState({
                    copied: true
                });
                this.props.onClickChange && this.props.onClickChange(true);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                success = false;
            }
            if (!success) this.setState({
                copyFailed: true
            });
            this.timeoutId = setTimeout(()=>{
                this.setState({
                    copied: false,
                    copyFailed: false
                });
                this.props.onCopyReset && this.props.onCopyReset();
            }, 3000);
            if (this.props.onCopyFinish) this.props.onCopyFinish();
        }, this.onRef = (ref)=>{
            this.inputTextRef = ref;
        };
    }
}

});
parcelRegister("7EEmi", function(module, exports) {

$parcel$export(module.exports, "StyledButton", () => $4e1842edd397110a$export$2d5d2ba3c7c8c40b);
$parcel$export(module.exports, "default", () => $4e1842edd397110a$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3Fq5M = parcelRequire("3Fq5M");

var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $kY99m = parcelRequire("kY99m");

var $3bDjY = parcelRequire("3bDjY");

var $fVAPR = parcelRequire("fVAPR");

var $az4zD = parcelRequire("az4zD");


var $gT8ZY = parcelRequire("gT8ZY");

var $9iXoh = parcelRequire("9iXoh");
class $4e1842edd397110a$export$71579edc8f362e35 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            id: (0, $68788ede79b59f1f$export$4f0520e0d7c4c7b0),
            className: undefined,
            copyFailed: false,
            shouldFitContainer: false,
            hideFieldText: false,
            tooltipDelay: 100,
            remountOnChange: false
        };
    }
    constructor(props){
        super(props);
        this.textInput = /*#__PURE__*/ (0, $5uXOq.createRef)();
        this.props.innerInputRef(this.textInput);
    }
    renderDefaultButton() {
        const { tooltipLabel: tooltipLabel, onCopyClick: onCopyClick } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e1842edd397110a$export$2d5d2ba3c7c8c40b, {
            onClick: onCopyClick,
            "aria-label": tooltipLabel
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3Fq5M))), {
            color: "currentColor",
            label: ""
        }));
    }
    render() {
        const { id: id, fieldKey: fieldKey, value: value, label: label, tooltipLabel: tooltipLabel, tooltipLabelPosition: tooltipLabelPosition, tooltipDelay: tooltipDelay, remountOnChange: remountOnChange, intl: intl, copied: copied, onCopyClick: onCopyClick, shouldFitContainer: shouldFitContainer, copyFailed: copyFailed, hideFieldText: hideFieldText, tooltipDisabled: tooltipDisabled, ...props } = this.props;
        let actualTooltipLabel = tooltipLabel;
        if (copied) actualTooltipLabel = intl.formatMessage((0, $gT8ZY.default).copied);
        else if (copyFailed) actualTooltipLabel = intl.formatMessage((0, $gT8ZY.default).copyFailed);
        const copyButton = !this.props.children ? null : // @ts-expect-error - TS2769 - No overload matches this call.
        /*#__PURE__*/ (0, $5uXOq.cloneElement)((0, $5uXOq.Children).only(this.props.children), {
            onClick: onCopyClick
        });
        return(// @ts-expect-error - TS2741 - Property 'hideFieldText' is missing in type '{ children: Element[]; className: string | undefined; innerInputRef: (arg1: HTMLInputElementRef) => void; }' but required in type 'Readonly<ThemedOuterStyledProps<ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & { hideFieldText: boolean; }, any>>'.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9iXoh.Root), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9iXoh.FieldContainer), {
            shouldFitContainer: shouldFitContainer,
            hideFieldText: hideFieldText
        }, label && !hideFieldText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVAPR.FieldLabel), {
            htmlFor: (0, $68788ede79b59f1f$export$4f0520e0d7c4c7b0),
            label: label
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
            "aria-hidden": hideFieldText ? 'true' : undefined,
            key: fieldKey,
            id: id,
            name: (0, $68788ede79b59f1f$export$4f0520e0d7c4c7b0),
            label: label,
            value: value,
            isReadOnly: true,
            ref: this.textInput,
            tabIndex: hideFieldText ? -1 : undefined,
            "aria-describedby": props.ariaDescribedBy
        })), tooltipDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e1842edd397110a$var$FlexGrow, null, copyButton || this.renderDefaultButton()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            tag: "span",
            key: remountOnChange ? actualTooltipLabel : undefined,
            delay: tooltipDelay,
            position: tooltipLabelPosition,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
                "aria-live": "assertive"
            }, actualTooltipLabel)
        }, copyButton || this.renderDefaultButton())));
    }
}
var $4e1842edd397110a$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($4e1842edd397110a$export$71579edc8f362e35);
const $4e1842edd397110a$export$2d5d2ba3c7c8c40b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
        ...props,
        xcss: $4e1842edd397110a$var$pressableStyles
    });
$4e1842edd397110a$export$2d5d2ba3c7c8c40b.displayName = 'StyledButton'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4e1842edd397110a$var$FlexGrow = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n",
            __cmplp.className
        ])
    });
});
const $4e1842edd397110a$var$pressableStyles = (0, $8CUq3.xcss)({
    height: '40px',
    width: '40px',
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage -- The token value "4px" and fallback "3px" do not match and can't be replaced automatically.
    borderRadius: "var(--ds-border-radius, 3px)",
    ':hover': {
        background: "var(--ds-background-neutral-hovered, #091E4224)"
    },
    ':active': {
        background: "var(--ds-background-neutral-pressed, #091E424F)"
    }
});

});
parcelRegister("fVAPR", function(module, exports) {

$parcel$export(module.exports, "FieldLabel", () => $97462970d1593b07$export$1acdcf5a973a8414);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $l1N8i = parcelRequire("l1N8i");
const $97462970d1593b07$export$1acdcf5a973a8414 = ({ label: label, htmlFor: htmlFor, isRequired: isRequired = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($97462970d1593b07$var$Label, {
        htmlFor: htmlFor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xxsmall",
        as: "h2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz131l _1e0c1ule _ca0qv47k _u5f3idpf _n3td1b66 _19bvidpf _ect41gqc"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, label), isRequired ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        role: "presentation",
        className: (0, $bwpsq.default)([
            "_syaz1tmw _19bvv77o _ect41gqc"
        ])
    }, "*") : null)));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $97462970d1593b07$var$Label = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1ule",
            __cmplp.className
        ])
    });
});
const $97462970d1593b07$var$labelStyle = null;
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $97462970d1593b07$var$requiredIndicatorStyle = null;

});

const $68788ede79b59f1f$export$4f0520e0d7c4c7b0 = 'field-copy-text';

parcelRegister("gT8ZY", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb069c8c90804ba8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $fb069c8c90804ba8$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    copied: {
        "id": "common.field-copy-text.copied",
        "defaultMessage": "Copied!"
    },
    copyFailed: {
        "id": "common.field-copy-text.copy-failed",
        "defaultMessage": "Couldn't copy to clipboard"
    }
});

});

parcelRegister("9iXoh", function(module, exports) {

$parcel$export(module.exports, "Root", () => $d3bb6eb164541ffa$export$be92b6f5f03c0fe9);
$parcel$export(module.exports, "FieldContainer", () => $d3bb6eb164541ffa$export$b5c4b0e7cd7f148b);
// eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");
const $d3bb6eb164541ffa$export$be92b6f5f03c0fe9 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1g0si8d-0"
})({
    display: 'flex',
    alignItems: 'flex-end'
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.hideFieldText === true ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $47bDC.css)({
        userSelect: 'none'
    }) : '');
const $d3bb6eb164541ffa$export$b5c4b0e7cd7f148b = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1g0si8d-1"
})({
    marginRight: "var(--ds-space-100, 8px)"
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.shouldFitContainer ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $47bDC.css)({
        flexGrow: 1
    }) : '', // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.hideFieldText === true ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $47bDC.css)({
        position: 'absolute',
        left: '-9999px',
        height: 0,
        opacity: 0,
        pointerEvents: 'none',
        userSelect: 'none'
    }) : '');

});



parcelRegister("aPg5m", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bdcab90fa945ecc$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $6bdcab90fa945ecc$var$defaultStrokeColor = "var(--ds-text-accent-blue-bolder, #09326C)";
const $6bdcab90fa945ecc$var$HierarchyIconSVG = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        cx: "5.33333",
        cy: "5.33333",
        r: "1.33333",
        stroke: props.stroke || $6bdcab90fa945ecc$var$defaultStrokeColor,
        strokeWidth: "1.33333",
        fill: "none"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        cx: "10.6667",
        cy: "10.6666",
        r: "1.33333",
        stroke: props.stroke || $6bdcab90fa945ecc$var$defaultStrokeColor,
        strokeWidth: "1.33333",
        fill: "none"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M5.33337 6.66669V9.33335C5.33337 10.0697 5.93033 10.6667 6.66671 10.6667H9.33337",
        stroke: props.stroke || $6bdcab90fa945ecc$var$defaultStrokeColor,
        strokeWidth: "1.33333",
        fill: "none"
    }));
const $6bdcab90fa945ecc$var$HierarchyIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        glyph: (customGlyphProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6bdcab90fa945ecc$var$HierarchyIconSVG, {
                ...customGlyphProps,
                stroke: props.stroke
            }),
        size: props.size,
        label: props.label
    });
var $6bdcab90fa945ecc$export$2e2bcd8739ae039 = $6bdcab90fa945ecc$var$HierarchyIcon;

});

parcelRegister("92kct", function(module, exports) {

$parcel$export(module.exports, "default", () => $5144cc01f8a4b829$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5144cc01f8a4b829$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    copy: {
        "id": "business-list.list-view.key-cell.copy",
        "defaultMessage": "Copy link"
    },
    copied: {
        "id": "business-list.list-view.key-cell.copied",
        "defaultMessage": "Copied"
    }
});

});

parcelRegister("9YM9G", function(module, exports) {

$parcel$export(module.exports, "IssueKey", () => $3e1b6ecd7d064439$export$40bed7a29c3b629);
/* issue-key.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hjSul = parcelRequire("hjSul");
/**
 * This aims to address the a11y issues reported in [ENGHEALTH-10934](https://hello.jira.atlassian.cloud/browse/ENGHEALTH-10934).
 *
 * Also worth pointing out that the a11y issues reported is only an issue in the context of cypress and how it
 * runs Storybook examples. Due to some [historical technical reasons](https://atlassian.slack.com/archives/C02785CLSTW/p1734910857523639),
 * we can't load design system tokens in Storybook when cypress runs its tests. This causes the fallback
 * color value to be used which fails the test(s). The newer version of `token()` doesn't require a fallback to be
 * passed and will provide a more appropriate and up to date value for the fallback.
 */ function $3e1b6ecd7d064439$var$IssueKeyLink(props, ref) {
    return /*#__PURE__*/ $5uXOq.createElement((0, $hjSul.Link), {
        ref: ref,
        ...props,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _syaz1gjq _1bto1l2s _k48pi7a9 _u5f3utpp _30l31gjq"
        ])
    });
}
const $3e1b6ecd7d064439$var$issueKeyLinkStyles = null;
const $3e1b6ecd7d064439$export$40bed7a29c3b629 = /*#__PURE__*/ (0, $5uXOq.forwardRef)($3e1b6ecd7d064439$var$IssueKeyLink);

});


parcelRegister("e7PC0", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4b41839aa9a40ba$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $DEWI6 = parcelRequire("DEWI6");

var $ajpes = parcelRequire("ajpes");

var $8Rkzz = parcelRequire("8Rkzz");

var $2x3Cb = parcelRequire("2x3Cb");

var $1I7E8 = parcelRequire("1I7E8");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $bChGW = parcelRequire("bChGW");

var $d9xxV = parcelRequire("d9xxV");

var $3bDjY = parcelRequire("3bDjY");

var $jldZL = parcelRequire("jldZL");

var $b5lmY = parcelRequire("b5lmY");

var $icf02 = parcelRequire("icf02");

var $e0a4D = parcelRequire("e0a4D");

var $jRzRt = parcelRequire("jRzRt");

var $k2xO1 = parcelRequire("k2xO1");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $iY5Zn = parcelRequire("iY5Zn");

var $1XJ20 = parcelRequire("1XJ20");

var $2NMNM = parcelRequire("2NMNM");

var $dCm1o = parcelRequire("dCm1o");

var $7ldcY = parcelRequire("7ldcY");

var $ek97b = parcelRequire("ek97b");

var $eTDjN = parcelRequire("eTDjN");

var $6du7W = parcelRequire("6du7W");

var $lI995 = parcelRequire("lI995");

var $1h5yY = parcelRequire("1h5yY");

var $l6CFv = parcelRequire("l6CFv");
const $c4b41839aa9a40ba$var$defaultIssueLabels = [];
const $c4b41839aa9a40ba$var$POPUP_OFFSET_NEW = [
    0,
    -(0, $eTDjN.DEFAULT_ROW_HEIGHT)
];
const $c4b41839aa9a40ba$var$multiValueRemoveStyles = {
    root: "_1tga113p _11lgglyw _1e22lcct _wb7e1iit _gy631fxt _13dibs82"
};
const $c4b41839aa9a40ba$var$multiValueStyles = {
    root: "_hn7lze3t _ujoyze3t",
    isVisualRefreshDisabled: "_2rkoiti9 _bfhk18uv _1vxp1b66 _1onpze3t _3lltze3t _k4bfze3t"
};
const $c4b41839aa9a40ba$var$multiValueLabelStyles = {
    root: "_1oqf3acm"
};
const $c4b41839aa9a40ba$var$LabelsCell = /*#__PURE__*/ (0, $5uXOq.memo)(({ issueKey: issueKey, issueId: issueId, issueLabels: issueLabels = $c4b41839aa9a40ba$var$defaultIssueLabels, width: width, fieldType: fieldType, fieldKey: fieldKey, isSelected: isSelected = false, isEditable: isEditable, fieldName: fieldName = '', issueType: issueType = '', issueTypeId: issueTypeId = '', editMode: editMode = false, setEditMode: setEditMode = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isHovering: isHovering = false, cellRef: cellRef, inputValue: inputValue, onInputChange: onInputChange })=>{
    const inputRef = (0, $5uXOq.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ error: error, value: value }, { saveValue: saveValue, resetError: resetError }] = (0, $iY5Zn.useLabelsField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: issueLabels,
        issueId: issueId,
        onFailure: ()=>setLabels(issueLabels)
    });
    const { defaultSuggestions: defaultSuggestions, addDefaultSuggestion: addDefaultSuggestion, getSuggestions: getSuggestions } = (0, $1h5yY.useLabels)(issueId, fieldKey); // Note the type here is not LabelsValue as it's impossible for updatedLabels to be null
    const updatedLabels = (0, $5uXOq.useMemo)(()=>value || $c4b41839aa9a40ba$var$defaultIssueLabels, [
        value
    ]);
    const [menuIsOpen, setMenuIsOpen] = (0, $5uXOq.useState)(editMode);
    const wasEditMode = (0, $1XJ20.usePreviousWithInitial)(editMode);
    (0, $5uXOq.useEffect)(()=>{
        setMenuIsOpen(editMode);
    }, [
        editMode
    ]); // Note the type here is not LabelsValue as it's impossible for labels to be null
    const [labels, setLabels] = (0, $5uXOq.useState)(()=>updatedLabels); // Update the internal state in response to external data changes. Note
    // that setting state here is more efficient than with a `useEffect`
    // hook - see
    // https://react.dev/learn/you-might-not-need-an-effect#adjusting-some-state-when-a-prop-changes
    if (!editMode && !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(labels, updatedLabels) && !wasEditMode) setLabels(updatedLabels);
    const saveAndClose = (0, $5uXOq.useCallback)(()=>{
        setEditMode(false);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(labels.slice().sort(), updatedLabels.slice().sort())) saveValue(labels, null, createAnalyticsEvent({})).then(()=>{
            labels.filter((label)=>issueLabels.indexOf(label) === -1).forEach((suggestion)=>{
                addDefaultSuggestion(suggestion);
            });
        }) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        .catch(()=>{});
    }, [
        setEditMode,
        labels,
        updatedLabels,
        saveValue,
        createAnalyticsEvent,
        issueLabels,
        addDefaultSuggestion
    ]);
    const onEscapeKeyPress = (0, $5uXOq.useCallback)(()=>{
        setEditMode(false);
        setLabels(issueLabels);
    }, [
        issueLabels,
        setEditMode
    ]);
    const { onKeyDown: onMultiSelectKeyDown, saveOnBlur: saveOnBlur } = (0, $icf02.useMultiSelectKeyDown)({
        editMode: editMode,
        wasEditMode: wasEditMode,
        menuIsOpen: menuIsOpen,
        setMenuIsOpen: setMenuIsOpen,
        saveAndClose: saveAndClose,
        onEscapeKeyPress: onEscapeKeyPress
    });
    (0, $5uXOq.useEffect)(saveOnBlur, [
        saveOnBlur
    ]);
    const cellOverrides = (0, $5uXOq.useCallback)(()=>({
            onKeyDown: onMultiSelectKeyDown
        }), [
        onMultiSelectKeyDown
    ]);
    (0, $5uXOq.useImperativeHandle)(cellRef, cellOverrides, [
        cellOverrides
    ]);
    const handleLabelsChange = (0, $5uXOq.useCallback)((newValue)=>{
        resetError();
        if (newValue) setLabels(Array.isArray(newValue) ? newValue.map((option)=>String(option.label)).sort() : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        [
            newValue.label
        ]);
        else setLabels([]);
    }, [
        resetError
    ]);
    const handleCreateOption = (0, $5uXOq.useCallback)((label)=>{
        setLabels([
            ...labels,
            label
        ].sort());
    }, [
        labels
    ]);
    const handleInputRef = (0, $5uXOq.useCallback)((ref)=>{
        if (inputRef) // @ts-expect-error - TS2540 - Cannot assign to 'current' because it is a read-only property.
        inputRef.current = ref;
    }, [
        inputRef
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (editMode) inputRef?.current?.focus();
    }, [
        editMode,
        issueLabels
    ]);
    const staticContent = (0, $5uXOq.useMemo)(()=>labels.map((label)=>{
            if ((0, $6s1PB.expVal)('adding-color-to-labels-field-in-jira-experiment', 'isColoredLabelsEnabled', false)) {
                if ((0, $dCm1o.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                    as: "span",
                    xcss: $c4b41839aa9a40ba$var$tagContainerStyles,
                    key: label
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d9xxV.default), {
                    text: label,
                    color: (0, $7ldcY.memoizeGetAutoGeneratedColorForLabelsTag)(label)
                }));
                const { backgroundColor: borderColor } = (0, $ek97b.getColorMetadata)((0, $7ldcY.memoizeGetAutoGeneratedColorForLabels)(label));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span" // eslint-disable-next-line jira/react/no-style-attribute, @typescript-eslint/consistent-type-assertions
                , {
                    style: {
                        '--tag-border-color': borderColor
                    },
                    key: label,
                    className: (0, $bwpsq.default)([
                        "_14ownqa1 _7x4ft94y _kr194o00 _1plv18uv _zmp81fxt _1blw1fxt"
                    ])
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d9xxV.default), {
                    text: label
                }));
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d9xxV.default), {
                key: label,
                text: label
            });
        }), [
        labels
    ]);
    const defaultOptions = (0, $5uXOq.useMemo)(()=>defaultSuggestions.filter((suggestion)=>labels.indexOf(suggestion.label) === -1).map((suggestion)=>({
                label: suggestion.label,
                value: suggestion.label
            })), [
        defaultSuggestions,
        labels
    ]);
    const styles = (0, $5uXOq.useMemo)(()=>({
            option: (base)=>({
                    ...base,
                    textOverflow: 'ellipsis',
                    overflow: 'hidden'
                })
        }), []);
    const labelsValueStyles = (0, $5uXOq.useMemo)(()=>({
            multiValue: (base, { data: data })=>{
                const { backgroundColor: borderColor } = (0, $ek97b.getColorMetadata)((0, $7ldcY.memoizeGetAutoGeneratedColorForLabels)(data.label));
                return {
                    ...base,
                    border: `1px solid ${borderColor}`,
                    '& > div > div > div': {
                        paddingLeft: 0,
                        paddingRight: 0
                    },
                    ...!(0, $dCm1o.isVisualRefreshEnabled)() ? {
                        borderRadius: "var(--ds-border-radius-100, 4px)",
                        backgroundColor: 'transparent',
                        '& > div': {
                            paddingLeft: "var(--ds-space-050, 4px)",
                            paddingRight: 0,
                            paddingTop: 0,
                            paddingBottom: 0
                        }
                    } : {}
                };
            },
            multiValueLabel: (base)=>({
                    ...base,
                    '& > div > div': {
                        borderColor: 'transparent'
                    }
                })
        }), []);
    const labelsRemoveIconStyles = (0, $5uXOq.useMemo)(()=>({
            multiValueRemove: (base)=>({
                    ...base,
                    '& > div > span > svg': {
                        transform: 'scale(1.5)',
                        fill: 'none'
                    },
                    '& > div > span > svg > g > path': {
                        d: 'path("m 2 10 l 4 -4 m 4 -4 L 6 6 m 0 0 L 2 2 m 4 4 l 4 4")',
                        transform: 'translate(5px, 6px)',
                        stroke: "var(--ds-text, #172B4D)",
                        strokeWidth: '1.5'
                    }
                })
        }), []);
    const selectStyles = (0, $5uXOq.useMemo)(()=>{
        if ((0, $6s1PB.expVal)('adding-color-to-labels-field-in-jira-experiment', 'isColoredLabelsEnabled', false)) {
            if (!(0, $dCm1o.isVisualRefreshEnabled)()) return {
                ...styles,
                ...labelsValueStyles,
                ...labelsRemoveIconStyles
            };
            return {
                ...styles,
                ...labelsValueStyles
            };
        }
        if ((0, $dCm1o.isVisualRefreshEnabled)()) return styles;
        return {};
    }, [
        labelsRemoveIconStyles,
        labelsValueStyles,
        styles
    ]);
    const formatCreateLabel = (0, $5uXOq.useCallback)((inputValue_)=>`${inputValue_} (${formatMessage((0, $l6CFv.default).createNewItem)})`, [
        formatMessage
    ]);
    const noOptionsMessage = (0, $5uXOq.useCallback)((args)=>labels.find((label)=>label === args.inputValue) ? formatMessage((0, $l6CFv.default).duplicate) : formatMessage((0, $l6CFv.default).noResults), [
        formatMessage,
        labels
    ]);
    const popupTrigger = (0, $5uXOq.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", triggerProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k2xO1.TagListWrapper), {
            isEditable: isEditable,
            "data-testid": "business-list.ui.list-view.labels-cell.tag-list-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: labels.join(', '),
            position: "top"
        }, staticContent))), [
        labels,
        isEditable,
        staticContent
    ]);
    const popupContent = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lI995.CellContentWrapper), {
            preferredWidth: width - 1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jldZL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2x3Cb.Label), {
            htmlFor: "business-list.ui.list-view.labels-cell.popup-content-lazy-creatable-select"
        }, formatMessage((0, $l6CFv.default).labelMultipleOptionsLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6du7W.default), {
            isMulti: true,
            isClearable: true,
            autoFocus: true,
            menuIsOpen: menuIsOpen,
            placeholder: formatMessage((0, $l6CFv.default).placeholder),
            value: labels.map((label)=>({
                    value: label,
                    label: label
                })),
            onChange: handleLabelsChange,
            loadOptions: getSuggestions,
            defaultOptions: defaultOptions,
            onCreateOption: handleCreateOption,
            formatCreateLabel: formatCreateLabel,
            ...(0, $6s1PB.expVal)('adding-color-to-labels-field-in-jira-experiment', 'isColoredLabelsEnabled', false) ? {
                isColored: true
            } : {},
            noOptionsMessage: noOptionsMessage,
            closeMenuOnSelect: false,
            onInputRef: handleInputRef,
            inputId: "business-list.ui.list-view.labels-cell.popup-content-lazy-creatable-select",
            label: formatMessage((0, $l6CFv.default).selectBoxLabel),
            tabSelectsValue: true,
            inputValue: inputValue,
            onInputChange: onInputChange,
            styles: selectStyles,
            components: {
                ...(0, $6s1PB.expVal)('adding-color-to-labels-field-in-jira-experiment', 'isColoredLabelsEnabled', false) && {
                    MultiValueContainer: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).MultiValueContainer, {
                            ...props,
                            xcss: (0, $DEWI6.cx)($c4b41839aa9a40ba$var$multiValueStyles.root, !(0, $dCm1o.isVisualRefreshEnabled)() && $c4b41839aa9a40ba$var$multiValueStyles.isVisualRefreshDisabled)
                        }),
                    MultiValueLabel: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).MultiValueLabel, {
                            ...props,
                            xcss: !(0, $dCm1o.isVisualRefreshEnabled)() && $c4b41839aa9a40ba$var$multiValueLabelStyles.root
                        }),
                    MultiValueRemove: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).MultiValueRemove, {
                            ...props,
                            xcss: !(0, $dCm1o.isVisualRefreshEnabled)() && $c4b41839aa9a40ba$var$multiValueRemoveStyles.root
                        })
                }
            }
        })), [
        width,
        formatMessage,
        menuIsOpen,
        labels,
        handleLabelsChange,
        getSuggestions,
        defaultOptions,
        handleCreateOption,
        formatCreateLabel,
        noOptionsMessage,
        handleInputRef,
        inputValue,
        onInputChange,
        selectStyles
    ]);
    const popupComponent = (0, $5uXOq.useMemo)(()=>(0, $jRzRt.getPopupComponentWithHeight)({
            numOptions: Math.min(8, defaultSuggestions.length),
            hasFooter: true
        }), [
        defaultSuggestions
    ]);
    const cellContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isHovering || editMode || isSelected ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
        isOpen: editMode,
        placement: "bottom-start",
        autoFocus: false,
        offset: $c4b41839aa9a40ba$var$POPUP_OFFSET_NEW,
        popupComponent: popupComponent,
        content: popupContent,
        trigger: popupTrigger,
        testId: "business-list.ui.list-view.labels-cell.labels-menu"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k2xO1.TagListWrapper), null, staticContent), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0a4D.FixItErrorFlag), {
        error: error,
        title: (0, $l6CFv.default).errorTitle,
        description: (0, $l6CFv.default).errorMessage,
        issueType: issueType,
        issueTypeId: issueTypeId,
        fieldId: fieldKey,
        fieldName: fieldName
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b5lmY.CellWrapper), {
        isEditable: isEditable,
        testId: "business-list.ui.list-view.labels-cell.cell-container",
        hasPadding: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c4b41839aa9a40ba$var$ContentWrapper, null, cellContent));
});
var $c4b41839aa9a40ba$export$2e2bcd8739ae039 = $c4b41839aa9a40ba$var$LabelsCell;
const $c4b41839aa9a40ba$var$ContentWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: [
            $c4b41839aa9a40ba$var$wrapperStyles
        ]
    }, children);
const $c4b41839aa9a40ba$var$wrapperStyles = (0, $8CUq3.xcss)({
    width: '100%',
    height: '100%'
});
const $c4b41839aa9a40ba$var$tagContainerStyles = (0, $8CUq3.xcss)({
    display: 'inline-flex',
    minWidth: '45px'
});
const $c4b41839aa9a40ba$var$tagBorderStyles = null;

});
parcelRegister("7ldcY", function(module, exports) {

$parcel$export(module.exports, "memoizeGetAutoGeneratedColorForLabels", () => $7fa3a87d53177c9e$export$8100203285e9ab92);
$parcel$export(module.exports, "memoizeGetAutoGeneratedColorForLabelsTag", () => $7fa3a87d53177c9e$export$a80529ae8ec44f02);

var $gJBT6 = parcelRequire("gJBT6");

var $1L3S5 = parcelRequire("1L3S5");

var $fzY6y = parcelRequire("fzY6y");

var $96pcJ = parcelRequire("96pcJ");
const $7fa3a87d53177c9e$export$97056d4b28203ee9 = (option)=>{
    if (option) {
        const hashValue = (0, $fzY6y.getHashValueForText)(option);
        const randomIndex = (0, $96pcJ.getRandomIndex)(hashValue);
        return (0, $1L3S5.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT)[randomIndex].name;
    }
    return (0, $1L3S5.GREY_META).name;
};
const $7fa3a87d53177c9e$export$a3f5334e7a13e57a = (option)=>{
    if (option) {
        const hashValue = (0, $fzY6y.getHashValueForText)(option);
        const randomIndex = (0, $96pcJ.getRandomIndex)(hashValue);
        return (0, $1L3S5.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT)[randomIndex].tagColor;
    }
    return (0, $1L3S5.GREY_META).tagColor;
};
const $7fa3a87d53177c9e$export$8100203285e9ab92 = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))($7fa3a87d53177c9e$export$97056d4b28203ee9);
const $7fa3a87d53177c9e$export$a80529ae8ec44f02 = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))($7fa3a87d53177c9e$export$a3f5334e7a13e57a);

});
parcelRegister("1L3S5", function(module, exports) {

$parcel$export(module.exports, "GREY_META", () => $0d4a83e59182b411$export$11b75436f568ab00);
$parcel$export(module.exports, "CHECK_MARK_COLOR_DARK", () => $0d4a83e59182b411$export$270aee965367aeb3);
$parcel$export(module.exports, "CHECK_MARK_COLOR_LIGHT", () => $0d4a83e59182b411$export$941ef40ef5fdd2b1);
$parcel$export(module.exports, "OPTION_COLOR_THEMES", () => $0d4a83e59182b411$export$7f42563469df7e01);
$parcel$export(module.exports, "OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT", () => $0d4a83e59182b411$export$2c649adf8351b065);
$parcel$export(module.exports, "OPTION_COLOR_THEMES_MAP", () => $0d4a83e59182b411$export$7c14120abebd4749);

var $9GtPC = parcelRequire("9GtPC");
const $0d4a83e59182b411$var$GREY_LIGHTEST_META = {
    name: 'GREY_LIGHTEST',
    backgroundColor: "var(--ds-background-neutral, #091E420F)",
    textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
    messageLabel: (0, $9GtPC.default).greyLightest
};
const $0d4a83e59182b411$var$GREY_LIGHTER_META = {
    name: 'GREY_LIGHTER',
    backgroundColor: "var(--ds-background-neutral-hovered, #091E4224)",
    textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
    messageLabel: (0, $9GtPC.default).greyLighter
};
const $0d4a83e59182b411$export$11b75436f568ab00 = {
    name: 'GREY',
    tagColor: 'grey',
    backgroundColor: "var(--ds-background-neutral-pressed, #091E424F)",
    textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
    messageLabel: (0, $9GtPC.default).grey
};
const $0d4a83e59182b411$var$GREY_DARKER_META = {
    name: 'GREY_DARKER',
    tagColor: 'greyDarker',
    backgroundColor: "var(--ds-background-neutral-bold, #44546F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).greyDarker
};
const $0d4a83e59182b411$var$GREY_DARKEST_META = {
    name: 'GREY_DARKEST',
    backgroundColor: "var(--ds-background-neutral-bold-pressed, #172B4D)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).greyDarkest
};
const $0d4a83e59182b411$var$PURPLE_LIGHTEST_META = {
    name: 'PURPLE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-purple-subtlest, #F3F0FF)",
    textColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    messageLabel: (0, $9GtPC.default).purpleLightest
};
const $0d4a83e59182b411$var$PURPLE_LIGHTER_META = {
    name: 'PURPLE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
    textColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    messageLabel: (0, $9GtPC.default).purpleLighter
};
const $0d4a83e59182b411$var$PURPLE_META = {
    name: 'PURPLE',
    tagColor: 'purple',
    backgroundColor: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
    textColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    messageLabel: (0, $9GtPC.default).purple
};
const $0d4a83e59182b411$export$7c314e2461a7241b = {
    name: 'PURPLE_DARKER',
    backgroundColor: "var(--ds-text-accent-purple, #5E4DB2)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).purpleDarker
};
const $0d4a83e59182b411$var$PURPLE_DARKEST_META = {
    name: 'PURPLE_DARKEST',
    backgroundColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).purpleDarkest
};
const $0d4a83e59182b411$var$BLUE_LIGHTEST_META = {
    name: 'BLUE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-blue-subtlest, #E9F2FF)",
    textColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    messageLabel: (0, $9GtPC.default).blueLightest
};
const $0d4a83e59182b411$var$BLUE_LIGHTER_META = {
    name: 'BLUE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
    textColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    messageLabel: (0, $9GtPC.default).blueLighter
};
const $0d4a83e59182b411$var$BLUE_META = {
    name: 'BLUE',
    backgroundColor: "var(--ds-background-accent-blue-subtle, #579DFF)",
    textColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    messageLabel: (0, $9GtPC.default).blue
};
const $0d4a83e59182b411$var$BLUE_DARKER_META = {
    name: 'BLUE_DARKER',
    backgroundColor: "var(--ds-text-accent-blue, #0055CC)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).blueDarker
};
const $0d4a83e59182b411$export$69c4eac71b813fba = {
    name: 'BLUE_DARKEST',
    backgroundColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).blueDarkest
};
const $0d4a83e59182b411$var$TEAL_LIGHTEST_META = {
    name: 'TEAL_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: (0, $9GtPC.default).tealLightest
};
const $0d4a83e59182b411$var$TEAL_LIGHTER_META = {
    name: 'TEAL_LIGHTER',
    backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: (0, $9GtPC.default).tealLighter
};
const $0d4a83e59182b411$var$TEAL_META = {
    name: 'TEAL',
    tagColor: 'teal',
    backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: (0, $9GtPC.default).teal
};
const $0d4a83e59182b411$export$6daaa1cc3f46f41 = {
    name: 'TEAL_DARKER',
    backgroundColor: "var(--ds-text-accent-teal, #206A83)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).tealDarker
};
const $0d4a83e59182b411$var$TEAL_DARKEST_META = {
    name: 'TEAL_DARKEST',
    backgroundColor: "var(--ds-text-accent-teal-bolder, #164555)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).tealDarkest
};
const $0d4a83e59182b411$var$GREEN_LIGHTEST_META = {
    name: 'GREEN_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $9GtPC.default).greenLightest
};
const $0d4a83e59182b411$var$GREEN_LIGHTER_META = {
    name: 'GREEN_LIGHTER',
    backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $9GtPC.default).greenLighter
};
const $0d4a83e59182b411$var$GREEN_META = {
    name: 'GREEN',
    tagColor: 'green',
    backgroundColor: "var(--ds-background-accent-green-subtle, #4BCE97)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $9GtPC.default).green
};
const $0d4a83e59182b411$var$GREEN_DARKER_META = {
    name: 'GREEN_DARKER',
    backgroundColor: "var(--ds-background-accent-green-bolder, #1F845A)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).greenDarker
};
const $0d4a83e59182b411$var$GREEN_DARKEST_META = {
    name: 'GREEN_DARKEST',
    backgroundColor: "var(--ds-text-accent-green-bolder, #164B35)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).greenDarkest
};
const $0d4a83e59182b411$var$LIME_LIGHTEST_META = {
    name: 'LIME_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $9GtPC.default).limeLightest
};
const $0d4a83e59182b411$var$LIME_LIGHTER_META = {
    name: 'LIME_LIGHTER',
    backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $9GtPC.default).limeLighter
};
const $0d4a83e59182b411$var$LIME_META = {
    name: 'LIME',
    backgroundColor: "var(--ds-background-accent-lime-subtle, #94C748)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $9GtPC.default).lime
};
const $0d4a83e59182b411$var$LIME_DARKER_META = {
    name: 'LIME_DARKER',
    backgroundColor: "var(--ds-text-accent-lime, #4C6B1F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).limeDarker
};
const $0d4a83e59182b411$var$LIME_DARKEST_META = {
    name: 'LIME_DARKEST',
    backgroundColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).limeDarkest
};
const $0d4a83e59182b411$var$YELLOW_LIGHTEST_META = {
    name: 'YELLOW_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $9GtPC.default).yellowLightest
};
const $0d4a83e59182b411$var$YELLOW_LIGHTER_META = {
    name: 'YELLOW_LIGHTER',
    backgroundColor: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $9GtPC.default).yellowLighter
};
const $0d4a83e59182b411$var$YELLOW_META = {
    name: 'YELLOW',
    tagColor: 'yellow',
    backgroundColor: "var(--ds-background-accent-yellow-subtle, #F5CD47)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $9GtPC.default).yellow
};
const $0d4a83e59182b411$var$YELLOW_DARKER_META = {
    name: 'YELLOW_DARKER',
    backgroundColor: "var(--ds-text-accent-yellow, #7F5F01)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).yellowDarker
};
const $0d4a83e59182b411$var$YELLOW_DARKEST_META = {
    name: 'YELLOW_DARKEST',
    backgroundColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).yellowDarkest
};
const $0d4a83e59182b411$var$ORANGE_LIGHTEST_META = {
    name: 'ORANGE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-orange-subtlest, #FFF3EB)",
    textColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    messageLabel: (0, $9GtPC.default).orangeLightest
};
const $0d4a83e59182b411$var$ORANGE_LIGHTER_META = {
    name: 'ORANGE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
    textColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    messageLabel: (0, $9GtPC.default).orangeLighter
};
const $0d4a83e59182b411$var$ORANGE_META = {
    name: 'ORANGE',
    tagColor: 'orange',
    backgroundColor: "var(--ds-background-accent-orange-subtle, #FEA362)",
    textColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    messageLabel: (0, $9GtPC.default).orange
};
const $0d4a83e59182b411$var$ORANGE_DARKER_META = {
    name: 'ORANGE_DARKER',
    backgroundColor: "var(--ds-background-accent-orange-bolder, #C25100)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).orangeDarker
};
const $0d4a83e59182b411$var$ORANGE_DARKEST_META = {
    name: 'ORANGE_DARKEST',
    backgroundColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).orangeDarkest
};
const $0d4a83e59182b411$var$RED_LIGHTEST_META = {
    name: 'RED_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-red-subtlest, #FFECEB)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: (0, $9GtPC.default).redLightest
};
const $0d4a83e59182b411$var$RED_LIGHTER_META = {
    name: 'RED_LIGHTER',
    backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: (0, $9GtPC.default).redLighter
};
const $0d4a83e59182b411$var$RED_META = {
    name: 'RED',
    tagColor: 'red',
    backgroundColor: "var(--ds-background-accent-red-subtle, #F87168)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: (0, $9GtPC.default).red
};
const $0d4a83e59182b411$var$RED_DARKER_META = {
    name: 'RED_DARKER',
    backgroundColor: "var(--ds-background-accent-red-bolder, #C9372C)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).redDarker
};
const $0d4a83e59182b411$var$RED_DARKEST_META = {
    name: 'RED_DARKEST',
    backgroundColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).redDarkest
};
const $0d4a83e59182b411$var$MAGENTA_LIGHTEST_META = {
    name: 'MAGENTA_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    messageLabel: (0, $9GtPC.default).magentaLightest
};
const $0d4a83e59182b411$var$MAGENTA_LIGHTER_META = {
    name: 'MAGENTA_LIGHTER',
    backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    messageLabel: (0, $9GtPC.default).magentaLighter
};
const $0d4a83e59182b411$var$MAGENTA_META = {
    name: 'MAGENTA',
    tagColor: 'magenta',
    backgroundColor: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    messageLabel: (0, $9GtPC.default).magenta
};
const $0d4a83e59182b411$var$MAGENTA_DARKER_META = {
    name: 'MAGENTA_DARKER',
    backgroundColor: "var(--ds-text-accent-magenta, #943D73)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).magentaDarker
};
const $0d4a83e59182b411$var$MAGENTA_DARKEST_META = {
    name: 'MAGENTA_DARKEST',
    backgroundColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).magentaDarkest
};
const $0d4a83e59182b411$export$270aee965367aeb3 = "var(--ds-text-inverse, #FFFFFF)";
const $0d4a83e59182b411$export$941ef40ef5fdd2b1 = "var(--ds-text, #172B4D)";
const $0d4a83e59182b411$export$7f42563469df7e01 = [
    $0d4a83e59182b411$var$GREY_LIGHTEST_META,
    $0d4a83e59182b411$var$PURPLE_LIGHTEST_META,
    $0d4a83e59182b411$var$BLUE_LIGHTEST_META,
    $0d4a83e59182b411$var$TEAL_LIGHTEST_META,
    $0d4a83e59182b411$var$GREEN_LIGHTEST_META,
    $0d4a83e59182b411$var$LIME_LIGHTEST_META,
    $0d4a83e59182b411$var$YELLOW_LIGHTEST_META,
    $0d4a83e59182b411$var$ORANGE_LIGHTEST_META,
    $0d4a83e59182b411$var$RED_LIGHTEST_META,
    $0d4a83e59182b411$var$MAGENTA_LIGHTEST_META,
    $0d4a83e59182b411$var$GREY_LIGHTER_META,
    $0d4a83e59182b411$var$PURPLE_LIGHTER_META,
    $0d4a83e59182b411$var$BLUE_LIGHTER_META,
    $0d4a83e59182b411$var$TEAL_LIGHTER_META,
    $0d4a83e59182b411$var$GREEN_LIGHTER_META,
    $0d4a83e59182b411$var$LIME_LIGHTER_META,
    $0d4a83e59182b411$var$YELLOW_LIGHTER_META,
    $0d4a83e59182b411$var$ORANGE_LIGHTER_META,
    $0d4a83e59182b411$var$RED_LIGHTER_META,
    $0d4a83e59182b411$var$MAGENTA_LIGHTER_META,
    $0d4a83e59182b411$export$11b75436f568ab00,
    $0d4a83e59182b411$var$PURPLE_META,
    $0d4a83e59182b411$var$BLUE_META,
    $0d4a83e59182b411$var$TEAL_META,
    $0d4a83e59182b411$var$GREEN_META,
    $0d4a83e59182b411$var$LIME_META,
    $0d4a83e59182b411$var$YELLOW_META,
    $0d4a83e59182b411$var$ORANGE_META,
    $0d4a83e59182b411$var$RED_META,
    $0d4a83e59182b411$var$MAGENTA_META,
    $0d4a83e59182b411$var$GREY_DARKER_META,
    $0d4a83e59182b411$export$7c314e2461a7241b,
    $0d4a83e59182b411$var$BLUE_DARKER_META,
    $0d4a83e59182b411$export$6daaa1cc3f46f41,
    $0d4a83e59182b411$var$GREEN_DARKER_META,
    $0d4a83e59182b411$var$LIME_DARKER_META,
    $0d4a83e59182b411$var$YELLOW_DARKER_META,
    $0d4a83e59182b411$var$ORANGE_DARKER_META,
    $0d4a83e59182b411$var$RED_DARKER_META,
    $0d4a83e59182b411$var$MAGENTA_DARKER_META,
    $0d4a83e59182b411$var$GREY_DARKEST_META,
    $0d4a83e59182b411$var$PURPLE_DARKEST_META,
    $0d4a83e59182b411$export$69c4eac71b813fba,
    $0d4a83e59182b411$var$TEAL_DARKEST_META,
    $0d4a83e59182b411$var$GREEN_DARKEST_META,
    $0d4a83e59182b411$var$LIME_DARKEST_META,
    $0d4a83e59182b411$var$YELLOW_DARKEST_META,
    $0d4a83e59182b411$var$ORANGE_DARKEST_META,
    $0d4a83e59182b411$var$RED_DARKEST_META,
    $0d4a83e59182b411$var$MAGENTA_DARKEST_META
];
const $0d4a83e59182b411$export$2c649adf8351b065 = [
    $0d4a83e59182b411$var$PURPLE_META,
    $0d4a83e59182b411$var$YELLOW_META,
    $0d4a83e59182b411$var$GREEN_META,
    $0d4a83e59182b411$var$TEAL_META,
    $0d4a83e59182b411$var$RED_META,
    $0d4a83e59182b411$var$ORANGE_META,
    $0d4a83e59182b411$var$MAGENTA_META,
    $0d4a83e59182b411$var$GREY_DARKER_META,
    $0d4a83e59182b411$export$11b75436f568ab00
];
const $0d4a83e59182b411$var$OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT_MAP = {};
$0d4a83e59182b411$export$2c649adf8351b065.forEach((option)=>{
    $0d4a83e59182b411$var$OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT_MAP[option.name] = option;
});
const $0d4a83e59182b411$export$7c14120abebd4749 = {};
$0d4a83e59182b411$export$7f42563469df7e01.forEach((option)=>{
    $0d4a83e59182b411$export$7c14120abebd4749[option.name] = option;
});

});
parcelRegister("9GtPC", function(module, exports) {

$parcel$export(module.exports, "default", () => $8610941b4777e2f7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8610941b4777e2f7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    greyLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey-lightest",
        "defaultMessage": "Grey lightest"
    },
    greyLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey-lighter",
        "defaultMessage": "Grey lighter"
    },
    grey: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey",
        "defaultMessage": "Grey"
    },
    greyDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey-darker",
        "defaultMessage": "Grey darker"
    },
    greyDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey-darkest",
        "defaultMessage": "Grey darkest"
    },
    purpleLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple-lightest",
        "defaultMessage": "Purple lightest"
    },
    purpleLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple-lighter",
        "defaultMessage": "Purple lighter"
    },
    purple: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple",
        "defaultMessage": "Purple"
    },
    purpleDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple-darker",
        "defaultMessage": "Purple darker"
    },
    purpleDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple-darkest",
        "defaultMessage": "Purple darkest"
    },
    blueLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue-lightest",
        "defaultMessage": "Blue lightest"
    },
    blueLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue-lighter",
        "defaultMessage": "Blue lighter"
    },
    blue: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue",
        "defaultMessage": "Blue"
    },
    blueDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue-darker",
        "defaultMessage": "Blue darker"
    },
    blueDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue-darkest",
        "defaultMessage": "Blue darkest"
    },
    tealLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal-lightest",
        "defaultMessage": "Teal lightest"
    },
    tealLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal-lighter",
        "defaultMessage": "Teal lighter"
    },
    teal: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal",
        "defaultMessage": "Teal"
    },
    tealDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal-darker",
        "defaultMessage": "Teal darker"
    },
    tealDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal-darkest",
        "defaultMessage": "Teal darkest"
    },
    greenLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green-lightest",
        "defaultMessage": "Green lightest"
    },
    greenLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green-lighter",
        "defaultMessage": "Green lighter"
    },
    green: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green",
        "defaultMessage": "Green"
    },
    greenDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green-darker",
        "defaultMessage": "Green darker"
    },
    greenDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green-darkest",
        "defaultMessage": "Green darkest"
    },
    limeLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime-lightest",
        "defaultMessage": "Lime lightest"
    },
    limeLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime-lighter",
        "defaultMessage": "Lime lighter"
    },
    lime: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime",
        "defaultMessage": "Lime"
    },
    limeDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime-darker",
        "defaultMessage": "Lime darker"
    },
    limeDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime-darkest",
        "defaultMessage": "Lime darkest"
    },
    yellowLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow-lightest",
        "defaultMessage": "Yellow lightest"
    },
    yellowLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow-lighter",
        "defaultMessage": "Yellow lighter"
    },
    yellow: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow",
        "defaultMessage": "Yellow"
    },
    yellowDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow-darker",
        "defaultMessage": "Yellow darker"
    },
    yellowDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow-darkest",
        "defaultMessage": "Yellow darkest"
    },
    orangeLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange-lightest",
        "defaultMessage": "Orange lightest"
    },
    orangeLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange-lighter",
        "defaultMessage": "Orange lighter"
    },
    orange: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange",
        "defaultMessage": "Orange"
    },
    orangeDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange-darker",
        "defaultMessage": "Orange darker"
    },
    orangeDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange-darkest",
        "defaultMessage": "Orange darkest"
    },
    redLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red-lightest",
        "defaultMessage": "Red lightest"
    },
    redLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red-lighter",
        "defaultMessage": "Red lighter"
    },
    red: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red",
        "defaultMessage": "Red"
    },
    redDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red-darker",
        "defaultMessage": "Red darker"
    },
    redDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red-darkest",
        "defaultMessage": "Red darkest"
    },
    magentaLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta-lightest",
        "defaultMessage": "Magenta lightest"
    },
    magentaLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta-lighter",
        "defaultMessage": "Magenta lighter"
    },
    magenta: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta",
        "defaultMessage": "Magenta"
    },
    magentaDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta-darker",
        "defaultMessage": "Magenta darker"
    },
    magentaDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta-darkest",
        "defaultMessage": "Magenta darkest"
    }
});

});


parcelRegister("fzY6y", function(module, exports) {

$parcel$export(module.exports, "getHashValueForText", () => $899e3507d4080274$export$e352defce701b36e);

const $899e3507d4080274$export$e352defce701b36e = (text)=>{
    let hashValue = 0;
    for(let i = 0; i < text.length; i++)hashValue = (hashValue * (0, $37d3405989cb4520$export$d15e38bcd75fda7c) + text.charCodeAt(i)) % (0, $37d3405989cb4520$export$e143f4b09221a374);
    return hashValue;
};

});
/*
 * This is used to calculate the hash value of the provided text,
 * allowing us to generate random hash values for the options in the Labels field.
 * As a result, we enhance the randomization of color assignments to Labels.
 */ const $37d3405989cb4520$export$d15e38bcd75fda7c = 256;
const $37d3405989cb4520$export$e143f4b09221a374 = 1000000007;


parcelRegister("96pcJ", function(module, exports) {

$parcel$export(module.exports, "getRandomIndex", () => $9ffc042ff38af51a$export$cb0dffe2d2ae675a);

var $1L3S5 = parcelRequire("1L3S5");
const $9ffc042ff38af51a$export$cb0dffe2d2ae675a = (hashValue)=>{
    const colorThemesLength = (0, $1L3S5.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT).length;
    const randomIndex = hashValue % colorThemesLength;
    return randomIndex;
};

});


parcelRegister("ek97b", function(module, exports) {

$parcel$export(module.exports, "getRandomColor", () => $c5f14892c9125c93$export$e4369cabd7e84cd9);
$parcel$export(module.exports, "getColorNameFromValue", () => $c5f14892c9125c93$export$b5ccbadd112d8ce9);
$parcel$export(module.exports, "getValueFromColorName", () => $c5f14892c9125c93$export$9eff62e8ee2aaa2c);
$parcel$export(module.exports, "getColorMetadata", () => $c5f14892c9125c93$export$49fce7fdcf55f26d);

var $1L3S5 = parcelRequire("1L3S5");
const $c5f14892c9125c93$export$e4369cabd7e84cd9 = ()=>{
    const randomIndex = Math.floor(Math.random() * (0, $1L3S5.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT).length);
    return (0, $1L3S5.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT)[randomIndex].name;
};
const $c5f14892c9125c93$export$b5ccbadd112d8ce9 = (colorValue)=>(0, $1L3S5.OPTION_COLOR_THEMES).find((item)=>item.backgroundColor === colorValue)?.name ?? '';
const $c5f14892c9125c93$export$9eff62e8ee2aaa2c = (colorName)=>(0, $1L3S5.OPTION_COLOR_THEMES_MAP)[colorName]?.backgroundColor ?? '';
const $c5f14892c9125c93$export$49fce7fdcf55f26d = (colorName)=>{
    if (!colorName) return 0, $1L3S5.GREY_META;
    return (0, $1L3S5.OPTION_COLOR_THEMES_MAP)[colorName] ?? (0, $1L3S5.GREY_META);
};
const $c5f14892c9125c93$export$4ef6b7574883e63d = ()=>(0, $1L3S5.OPTION_COLOR_THEMES).map((item)=>item.name);

});

parcelRegister("1h5yY", function(module, exports) {

$parcel$export(module.exports, "useLabels", () => $700f5c352b9b5a67$export$d6875122194c7b44);

var $5uXOq = parcelRequire("5uXOq");

var $eusud = parcelRequire("eusud");

var $FtZX9 = parcelRequire("FtZX9");

var $1iIjC = parcelRequire("1iIjC");
const $700f5c352b9b5a67$var$LABEL_SUGGESTIONS_DEBOUNCE_MS = 500;
const $700f5c352b9b5a67$export$d6875122194c7b44 = (issueId, fieldKey)=>{
    const [{ defaultSuggestions: defaultSuggestions, defaultSuggestionsIssueId: defaultSuggestionsIssueId }, { setDefaultSuggestions: setDefaultSuggestions, addDefaultSuggestion: addDefaultSuggestion, setDefaultSuggestionsIssueId: setDefaultSuggestionsIssueId }] = (0, $1iIjC.useLabelsStore)(issueId);
    if (!defaultSuggestionsIssueId) setDefaultSuggestionsIssueId(issueId);
    const autoCompleteUrl = (0, $5uXOq.useMemo)(()=>{
        let url = `/rest/api/1.0/labels/${issueId}/suggest?`;
        if (fieldKey !== 'labels') url += `customFieldId=${fieldKey.split('_').reverse()[0]}&`;
        url += 'query=';
        return url;
    }, [
        fieldKey,
        issueId
    ]);
    const loadSuggestions = (0, $5uXOq.useCallback)((query)=>{
        const url = `${autoCompleteUrl}${encodeURIComponent(query)}`;
        return (0, $eusud.performGetRequest)(url).then((response)=>response.suggestions);
    }, [
        autoCompleteUrl
    ]);
    const getSuggestions = (0, $5uXOq.useCallback)((query)=>{
        if (!query && defaultSuggestions) return Promise.resolve(defaultSuggestions);
        return loadSuggestions(query);
    }, [
        defaultSuggestions,
        loadSuggestions
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (defaultSuggestionsIssueId === issueId && !defaultSuggestions) loadSuggestions('').then((suggestions)=>{
            setDefaultSuggestions(suggestions);
        });
    }, [
        defaultSuggestionsIssueId,
        defaultSuggestions,
        issueId,
        loadSuggestions,
        setDefaultSuggestions
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            defaultSuggestions: defaultSuggestions ?? [],
            getSuggestions: (0, $FtZX9.default)(getSuggestions, $700f5c352b9b5a67$var$LABEL_SUGGESTIONS_DEBOUNCE_MS),
            addDefaultSuggestion: addDefaultSuggestion
        }), [
        defaultSuggestions,
        getSuggestions,
        addDefaultSuggestion
    ]);
};

});
parcelRegister("FtZX9", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebb46637e8f856b8$export$2e2bcd8739ae039);
const $ebb46637e8f856b8$var$defer = ()=>{
    const deferred = {};
    deferred.promise = new Promise((resolve, reject)=>{
        deferred.resolve = resolve;
        deferred.reject = reject;
    });
    return deferred;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $ebb46637e8f856b8$var$debounce(fn, wait = 0) {
    let deferred;
    let timer;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let lastArgs;
    function flush() {
        const thisDeferred = deferred;
        clearTimeout(timer);
        if (thisDeferred) // @ts-expect-error - TS2683 - 'this' implicitly has type 'any' because it does not have a type annotation. | TS7005 - Variable 'lastArgs' implicitly has an 'any' type.
        // eslint-disable-next-line @typescript-eslint/no-invalid-this
        Promise.resolve(fn.apply(this, lastArgs)).then(thisDeferred.resolve, thisDeferred.reject);
        lastArgs = [];
        deferred = null;
    }
    // @ts-expect-error - TS2322 - Type '(...args: readonly any[]) => any' is not assignable to type 'F'.
    return function debounced(...args) {
        if (deferred) clearTimeout(timer);
        else deferred = $ebb46637e8f856b8$var$defer();
        lastArgs = args;
        // @ts-expect-error - TS2683 - 'this' implicitly has type 'any' because it does not have a type annotation.
        // eslint-disable-next-line @typescript-eslint/no-invalid-this
        timer = setTimeout(flush.bind(this), wait);
        return deferred.promise;
    };
}
var $ebb46637e8f856b8$export$2e2bcd8739ae039 = $ebb46637e8f856b8$var$debounce;

});

parcelRegister("1iIjC", function(module, exports) {

$parcel$export(module.exports, "useLabelsStore", () => $37d133c6b4ba9e4c$export$760f05b2dd641a7b);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $37d133c6b4ba9e4c$var$actions = {
    setDefaultSuggestions: (defaultSuggestions)=>({ setState: setState })=>{
            setState({
                defaultSuggestions: defaultSuggestions
            });
        },
    addDefaultSuggestion: (label)=>({ setState: setState, getState: getState })=>{
            const defaultSuggestions = getState().defaultSuggestions ? [
                ...getState().defaultSuggestions
            ] : [];
            const idx = defaultSuggestions.findIndex((suggestion)=>suggestion.label === label);
            if (idx >= 0) defaultSuggestions.splice(idx, 1);
            setState({
                defaultSuggestions: [
                    {
                        label: label,
                        value: label
                    },
                    ...defaultSuggestions
                ].slice(0, 20)
            });
        },
    setDefaultSuggestionsIssueId: (issueId)=>({ setState: setState, getState: getState })=>{
            if (!getState().defaultSuggestionsIssueId) setState({
                defaultSuggestionsIssueId: issueId
            });
        }
};
const $37d133c6b4ba9e4c$var$LabelsStore = (0, $iXqE5.createStore)({
    initialState: {
        defaultSuggestions: null,
        defaultSuggestionsIssueId: null
    },
    actions: $37d133c6b4ba9e4c$var$actions,
    name: 'JWMLabels'
});
const $37d133c6b4ba9e4c$export$57a5095d1d6807d3 = (0, $3sQ5x.createHook)($37d133c6b4ba9e4c$var$LabelsStore);
const $37d133c6b4ba9e4c$export$760f05b2dd641a7b = (issueId)=>{
    const labelsStore = $37d133c6b4ba9e4c$export$57a5095d1d6807d3();
    const [, { setDefaultSuggestionsIssueId: setDefaultSuggestionsIssueId }] = labelsStore;
    setDefaultSuggestionsIssueId(issueId);
    return labelsStore;
};

});


parcelRegister("l6CFv", function(module, exports) {

$parcel$export(module.exports, "default", () => $745d1bccd087eebb$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $745d1bccd087eebb$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorTitle: {
        "id": "business-list.list-view.labels-cell.error-title",
        "defaultMessage": "We couldn't set the labels value"
    },
    errorMessage: {
        "id": "business-list.list-view.labels-cell.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    },
    placeholder: {
        "id": "business-list.list-view.labels-cell.placeholder",
        "defaultMessage": "Select label"
    },
    createNewItem: {
        "id": "business-list.list-view.labels-cell.create-new-item",
        "defaultMessage": "New label"
    },
    noResults: {
        "id": "business-list.list-view.labels-cell.no-results",
        "defaultMessage": "No matches found"
    },
    duplicate: {
        "id": "business-list.list-view.labels-cell.duplicate",
        "defaultMessage": "Label already added"
    },
    labelMultipleOptionsLabel: {
        "id": "business-list.list-view.labels-cell.label-multiple-options-label",
        "defaultMessage": "Multiple labels can be selected"
    },
    selectBoxLabel: {
        "id": "business-list.list-view.labels-cell.select-box-label",
        "defaultMessage": "Label"
    }
});

});


parcelRegister("aYkrQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e634a5fcd705fbcc$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $e634a5fcd705fbcc$var$MultiSelectCell = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("2fgfd")), {
    moduleId: "./src/packages/business/list/src/ui/list-view/multi-select-cell/main.tsx"
});
const $e634a5fcd705fbcc$var$AsyncMultiSelectCell = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "multi-select-cell",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e634a5fcd705fbcc$var$MultiSelectCell, props));
var $e634a5fcd705fbcc$export$2e2bcd8739ae039 = $e634a5fcd705fbcc$var$AsyncMultiSelectCell;

});
parcelRegister("2fgfd", function(module, exports) {

let $1a29954769a531e4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1a29954769a531e4$var$load("gFZ0j").then(()=>parcelRequire('7mtWh'));

});


parcelRegister("1vBWF", function(module, exports) {

$parcel$export(module.exports, "default", () => $b785165cee754a9c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $ujWmd = parcelRequire("ujWmd");

var $jnhNB = parcelRequire("jnhNB");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $b5lmY = parcelRequire("b5lmY");

var $e0a4D = parcelRequire("e0a4D");

var $jRzRt = parcelRequire("jRzRt");

var $koVbs = parcelRequire("koVbs");

var $lQE94 = parcelRequire("lQE94");

var $1XJ20 = parcelRequire("1XJ20");

var $jgJNO = parcelRequire("jgJNO");

var $2NMNM = parcelRequire("2NMNM");

var $eTDjN = parcelRequire("eTDjN");

var $lI995 = parcelRequire("lI995");

var $j6Uv1 = parcelRequire("j6Uv1");

var $f2d3w = parcelRequire("f2d3w");

var $l4l7M = parcelRequire("l4l7M");
const $b785165cee754a9c$var$MENU_MIN_WIDTH = 260;
const $b785165cee754a9c$var$MAX_AVATAR = 5;
const $b785165cee754a9c$var$POPUP_OFFSET_NEW = [
    0,
    6 - (0, $eTDjN.DEFAULT_ROW_HEIGHT)
];
const $b785165cee754a9c$export$f4784aff017e1cd6 = /*#__PURE__*/ (0, $5uXOq.memo)(({ isEditable: isEditable, userOptions: userOptions })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, userOptions && userOptions.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jnhNB.default), {
        appearance: "stack",
        data: userOptions.map((user)=>({
                name: user.name,
                src: user.avatarUrl ?? ''
            })),
        maxCount: $b785165cee754a9c$var$MAX_AVATAR,
        size: "small"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lI995.AvatarItem), {
        isUnassigned: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        appearance: "circle",
        src: "",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lI995.DisplayName), null, formatMessage((0, $f2d3w.default).emptyMultiUser))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b785165cee754a9c$var$AvatarGroupContainer, {
        isEditable: isEditable,
        testId: "business-list.ui.list-view.multi-user-cell.avatar-group-container"
    }, content);
});
const $b785165cee754a9c$var$MultiUserCell = /*#__PURE__*/ (0, $5uXOq.memo)(({ initialValue: _initialValue, fieldKey: fieldKey, fieldType: fieldType, issueKey: issueKey, isEditable: isEditable, width: width, height: height, isSelected: isSelected = false, wrapperRef: wrapperRef, fieldName: fieldName = '', issueType: issueType = '', issueTypeId: issueTypeId = '', editMode: editMode = false, setEditMode: setEditMode = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isHovering: isHovering = false, cellRef: cellRef })=>{
    const initialValue = (0, $5uXOq.useMemo)(()=>_initialValue?.map((0, $l4l7M.transformToUserOption)).filter(Boolean) ?? null, [
        _initialValue
    ]);
    const userPickerWidth = width > $b785165cee754a9c$var$MENU_MIN_WIDTH ? width : $b785165cee754a9c$var$MENU_MIN_WIDTH;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [{ value: savedValue, error: error }, { saveValue: saveValue }] = (0, $lQE94.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: initialValue,
        onFailure: ()=>{
            setUserOptions(savedValue ?? null);
        }
    });
    const [userOptions, setUserOptions] = (0, $5uXOq.useState)(savedValue);
    const wasEditMode = (0, $1XJ20.usePreviousWithInitial)(editMode);
    const hasValueUpdated = (0, $5uXOq.useRef)(false);
    // Update the internal state in response to external data changes. Note
    // that setting state here is more efficient than with a `useEffect`
    // hook - see
    // https://react.dev/learn/you-might-not-need-an-effect#adjusting-some-state-when-a-prop-changes
    if (!editMode && !(0, $l4l7M.isUserOptionsEqual)(savedValue, userOptions) && !wasEditMode) setUserOptions(savedValue);
    const handleChange = (0, $5uXOq.useCallback)((userPickerValue)=>{
        let newValue = null;
        if (userPickerValue) newValue = Array.isArray(userPickerValue) ? userPickerValue : null;
        setUserOptions(newValue);
        /**
     * `hasValueUpdated` is used in keyboard navigation to check whether pressing Enter has changed the value,
     * so that we know if we need to exit edit mode on `Enter` or not
     */ hasValueUpdated.current = true;
        setTimeout(()=>{
            hasValueUpdated.current = false;
        });
    }, []);
    const saveAndClose = (0, $5uXOq.useCallback)(()=>{
        setEditMode(false);
        if ((0, $l4l7M.isUserOptionsEqual)(savedValue, userOptions)) return;
        saveValue(userOptions, null, createAnalyticsEvent({}));
    }, [
        createAnalyticsEvent,
        saveValue,
        savedValue,
        setEditMode,
        userOptions
    ]);
    const handleContentKeyDown = (0, $5uXOq.useCallback)((e)=>{
        if (e.key === 'Escape') {
            e.preventDefault();
            saveAndClose();
            wrapperRef?.current?.focus();
        }
    }, [
        saveAndClose,
        wrapperRef
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (wasEditMode && !editMode) saveAndClose();
    }, [
        editMode,
        saveAndClose,
        wasEditMode
    ]);
    const handleKeyDownNew = (0, $5uXOq.useCallback)((event)=>{
        if (editMode && event.code === 'Enter') {
            if (!hasValueUpdated.current) {
                setEditMode(false);
                return false;
            }
            return true;
        }
        return false;
    }, [
        editMode,
        setEditMode
    ]);
    const cellOverrides = (0, $5uXOq.useCallback)(()=>({
            onKeyDown: handleKeyDownNew
        }), [
        handleKeyDownNew
    ]);
    (0, $5uXOq.useImperativeHandle)(cellRef, cellOverrides, [
        cellOverrides
    ]);
    const popupTrigger = (0, $5uXOq.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
            ...triggerProps,
            xcss: $b785165cee754a9c$var$popupTriggerStyles,
            testId: "business-list.ui.list-view.multi-user-cell.popup-trigger"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b785165cee754a9c$export$f4784aff017e1cd6, {
            isEditable: isEditable,
            userOptions: userOptions
        })), [
        isEditable,
        userOptions
    ]);
    const popupContent = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j6Uv1.default), {
            width: width,
            height: height,
            userPickerWidth: userPickerWidth,
            menuMinWidth: $b785165cee754a9c$var$MENU_MIN_WIDTH,
            placeholder: formatMessage((0, $f2d3w.default).placeholder),
            fieldId: fieldType,
            value: userOptions,
            // @ts-expect-error - TS2322 - Type '(userPickerValue: UserOption) => void' is not assignable to type '() => void'.
            onChange: handleChange,
            onKeyDown: handleContentKeyDown,
            autoCompleteUrl: `/rest/api/3/user/recommend?${new URLSearchParams({
                context: 'CustomMultiUserField',
                ...issueKey && {
                    issueKey: issueKey
                },
                query: ''
            })}`
        }), [
        issueKey,
        fieldType,
        formatMessage,
        handleChange,
        handleContentKeyDown,
        height,
        userOptions,
        userPickerWidth,
        width
    ]);
    const content = isHovering || editMode || isSelected ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        offset: $b785165cee754a9c$var$POPUP_OFFSET_NEW,
        placement: "bottom-start",
        messageId: "business-list.ui.list-view.multi-user-cell.popup",
        messageType: "transactional",
        isOpen: editMode,
        onClose: saveAndClose,
        popupComponent: (0, $jRzRt.PopupComponent),
        autoFocus: false,
        trigger: popupTrigger,
        content: popupContent
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b785165cee754a9c$export$f4784aff017e1cd6, {
        isEditable: isEditable,
        userOptions: userOptions
    });
    const cellContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isEditable ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b785165cee754a9c$export$f4784aff017e1cd6, {
        isEditable: isEditable,
        userOptions: userOptions
    }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0a4D.FixItErrorFlag), {
        error: error,
        title: (0, $f2d3w.default).errorTitle,
        description: (0, $f2d3w.default).errorMessage,
        issueType: issueType,
        issueTypeId: issueTypeId,
        fieldId: fieldKey,
        fieldName: fieldName
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b5lmY.CellWrapper), {
        isEditable: isEditable,
        testId: "business-list.ui.list-view.multi-user-cell.cell-container",
        hasPadding: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b785165cee754a9c$var$ContentWrapper, null, cellContent));
});
var $b785165cee754a9c$export$2e2bcd8739ae039 = $b785165cee754a9c$var$MultiUserCell;
const $b785165cee754a9c$var$ContentWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $b785165cee754a9c$var$wrapperStyles
        ]
    }, children);
const $b785165cee754a9c$var$AvatarGroupContainer = ({ children: children, isEditable: isEditable, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        testId: testId,
        alignItems: "center",
        xcss: [
            $b785165cee754a9c$var$avatarGroupContainerStyles,
            isEditable ? $b785165cee754a9c$var$avatarGroupContainerPointerStyles : $b785165cee754a9c$var$avatarGroupContainerDefaultStyles
        ]
    }, children);
const $b785165cee754a9c$var$avatarGroupContainerStyles = (0, $8CUq3.xcss)({
    paddingLeft: 'space.100',
    width: '100%'
});
const $b785165cee754a9c$var$avatarGroupContainerDefaultStyles = (0, $8CUq3.xcss)({
    cursor: 'default'
});
const $b785165cee754a9c$var$avatarGroupContainerPointerStyles = (0, $8CUq3.xcss)({
    cursor: 'pointer'
});
const $b785165cee754a9c$var$wrapperStyles = (0, $8CUq3.xcss)({
    width: '100%'
});
const $b785165cee754a9c$var$popupTriggerStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.neutral.subtle',
    padding: 'space.0'
});

});
parcelRegister("j6Uv1", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d85d6e6b7e2c69b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2d85d6e6b7e2c69b$var$UserPicker = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("cca1J")), {
    ssr: false,
    moduleId: "./src/packages/business/list/src/ui/list-view/multi-user-cell/async-user-picker/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2d85d6e6b7e2c69b$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "user-picker",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2d85d6e6b7e2c69b$var$UserPicker, props));

});
parcelRegister("cca1J", function(module, exports) {

let $8e0e622e31ea2d0f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8e0e622e31ea2d0f$var$load("ad6Pq").then(()=>parcelRequire('1mKwT'));

});


parcelRegister("f2d3w", function(module, exports) {

$parcel$export(module.exports, "default", () => $d48a4df130d53300$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d48a4df130d53300$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    emptyMultiUser: {
        "id": "business-list.list-view.multi-user-cell.empty-multi-user",
        "defaultMessage": "None"
    },
    placeholder: {
        "id": "business-list.list-view.multi-user-cell.placeholder",
        "defaultMessage": "Select User"
    },
    errorTitle: {
        "id": "business-list.list-view.multi-user-cell.error-title",
        "defaultMessage": "We couldn't save the user value."
    },
    errorMessage: {
        "id": "business-list.list-view.multi-user-cell.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    }
});

});

parcelRegister("l4l7M", function(module, exports) {

$parcel$export(module.exports, "isUserOptionsEqual", () => $d63c6d7fdbb78e58$export$28c83218de06edb7);
$parcel$export(module.exports, "transformToUserOption", () => $d63c6d7fdbb78e58$export$5924759166d7a225);

var $ajpes = parcelRequire("ajpes");

var $7qDUb = parcelRequire("7qDUb");
const $d63c6d7fdbb78e58$var$sortUserOptions = (options)=>(0, (/*@__PURE__*/$parcel$interopDefault($7qDUb)))(options, [
        'id'
    ]);
const $d63c6d7fdbb78e58$export$28c83218de06edb7 = (a, b)=>(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(a, b) || (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(a && $d63c6d7fdbb78e58$var$sortUserOptions(a), b && $d63c6d7fdbb78e58$var$sortUserOptions(b));
const $d63c6d7fdbb78e58$export$5924759166d7a225 = (userData)=>{
    if (!userData) return null;
    return {
        avatarUrl: 'picture' in userData ? userData.picture : userData.avatarUrl,
        id: userData.accountId,
        name: userData.name ?? ''
    };
};

});


parcelRegister("hTzzn", function(module, exports) {

$parcel$export(module.exports, "default", () => $39a390424aeb4478$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $2NMNM = parcelRequire("2NMNM");

var $kY99m = parcelRequire("kY99m");

var $b5lmY = parcelRequire("b5lmY");

var $e0a4D = parcelRequire("e0a4D");

var $lQE94 = parcelRequire("lQE94");

var $9Ludo = parcelRequire("9Ludo");
const $39a390424aeb4478$var$getInputValue = ({ inputValue: inputValue, fieldValue: fieldValue })=>{
    if (typeof inputValue === 'undefined') return fieldValue;
    return typeof inputValue === 'string' && inputValue ? Number(inputValue) : null;
};
const $39a390424aeb4478$var$NumberCell = /*#__PURE__*/ (0, $5uXOq.memo)(({ issueKey: issueKey, fieldKey: fieldKey, fieldType: fieldType = '', isEditable: isEditable, fieldValue: fieldValue = null, fieldName: fieldName, editMode: editMode = false, setEditMode: setEditMode = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), cellRef: cellRef, issueType: issueType = '', issueTypeId: issueTypeId = '', inputValue: inputValue, onInputChange: onInputChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) })=>{
    const numValue = $39a390424aeb4478$var$getInputValue({
        inputValue: inputValue,
        fieldValue: fieldValue
    });
    const setNumValue = (0, $5uXOq.useCallback)((value)=>onInputChange(value !== null ? String(value) : ''), [
        onInputChange
    ]);
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $lQE94.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: fieldValue
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const saveAndClose = (0, $5uXOq.useCallback)(()=>{
        if (editMode) {
            setEditMode(false);
            numValue !== value && saveValue(numValue, null, createAnalyticsEvent({}));
        }
    }, [
        createAnalyticsEvent,
        editMode,
        numValue,
        saveValue,
        value,
        setEditMode
    ]);
    const handleChange = (0, $5uXOq.useCallback)((event)=>{
        resetError();
        const typedValue = event.target.value === '' ? null : parseFloat(Number(event.target.value).toFixed(3));
        setNumValue(typedValue);
    }, [
        resetError,
        setNumValue
    ]);
    const handleKeyDownNew = (0, $5uXOq.useCallback)((event)=>{
        if (editMode && event.code === 'Escape') setNumValue(value || null);
        return false;
    }, [
        editMode,
        setNumValue,
        value
    ]);
    const cellOverrides = (0, $5uXOq.useCallback)(()=>({
            onKeyDown: handleKeyDownNew
        }), [
        handleKeyDownNew
    ]);
    (0, $5uXOq.useImperativeHandle)(cellRef, cellOverrides, [
        cellOverrides
    ]);
    const numberCell = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, editMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("form", {
        onSubmit: saveAndClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($39a390424aeb4478$var$Textfield, {
        autoFocus: true,
        type: "number",
        onBlur: saveAndClose,
        value: numValue === null ? '' : numValue,
        onChange: handleChange,
        step: "any"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($39a390424aeb4478$var$NumberLabel, null, value), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0a4D.FixItErrorFlag), {
        error: error,
        title: (0, $9Ludo.default).errorTitle,
        description: (0, $9Ludo.default).errorMessage,
        issueType: issueType,
        issueTypeId: issueTypeId,
        fieldId: fieldKey,
        fieldName: fieldName
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b5lmY.TextCellWrapper), {
        testId: "business-list.ui.list-view.number-cell.text-field-wrapper",
        isEditable: isEditable,
        ariaLabel: fieldName
    }, numberCell);
});
var $39a390424aeb4478$export$2e2bcd8739ae039 = $39a390424aeb4478$var$NumberCell;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $39a390424aeb4478$var$NumberLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y3gnusic _u5f3u2gc _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $39a390424aeb4478$var$Textfield = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $kY99m.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19bvusic _n3elu2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9Ludo", function(module, exports) {

$parcel$export(module.exports, "default", () => $0448640e1edfd035$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0448640e1edfd035$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorTitle: {
        "id": "business-list.list-view.number-cell.error-title",
        "defaultMessage": "We couldn't save the number value."
    },
    errorMessage: {
        "id": "business-list.list-view.number-cell.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    }
});

});


parcelRegister("eRBDs", function(module, exports) {

$parcel$export(module.exports, "default", () => $acb1c4daaf17e66b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $acb1c4daaf17e66b$var$OriginalEstimateCell = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("6ks1a")), {
    moduleId: "./src/packages/business/list/src/ui/list-view/original-estimate-cell/main.tsx"
});
const $acb1c4daaf17e66b$var$AsyncOriginalEstimateCell = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "original-estimate-cell",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($acb1c4daaf17e66b$var$OriginalEstimateCell, props));
var $acb1c4daaf17e66b$export$2e2bcd8739ae039 = $acb1c4daaf17e66b$var$AsyncOriginalEstimateCell;

});
parcelRegister("6ks1a", function(module, exports) {

let $49ba5813a3a3b584$var$load = (parcelRequire("28QjX"))(4);
module.exports = $49ba5813a3a3b584$var$load("khBek").then(()=>parcelRequire('23FiY'));

});


parcelRegister("1HY3B", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae1740356bb7001c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $1I7E8 = parcelRequire("1I7E8");

var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $b5lmY = parcelRequire("b5lmY");

var $e0a4D = parcelRequire("e0a4D");

var $8ad1n = parcelRequire("8ad1n");

var $jRzRt = parcelRequire("jRzRt");

var $gwIPs = parcelRequire("gwIPs");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $lQE94 = parcelRequire("lQE94");

var $20vaL = parcelRequire("20vaL");

var $5fc53 = parcelRequire("5fc53");

var $2NMNM = parcelRequire("2NMNM");

var $eTDjN = parcelRequire("eTDjN");

var $lI995 = parcelRequire("lI995");

var $3tdNZ = parcelRequire("3tdNZ");

var $ATTEL = parcelRequire("ATTEL");
// -gridsize coming from ImgSpan padding right
const $ae1740356bb7001c$var$POPUP_OFFSET = [
    -(0, $gwIPs.gridSize),
    2 - (0, $eTDjN.DEFAULT_ROW_HEIGHT)
];
const $ae1740356bb7001c$var$PriorityCellView = /*#__PURE__*/ (0, $5uXOq.memo)(({ name: name, iconUrl: iconUrl, onClick: onClick, width: width, height: height, isHovering: isHovering })=>{
    if (name === null || name === undefined || iconUrl == null) return null;
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $20vaL.CardPriority), {
        uri: iconUrl,
        name: name
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lI995.CellContentContainer), {
        onClick: onClick,
        width: width,
        height: height,
        "data-testid": "business-list.ui.list-view.priority-cell.priority-cell-view"
    }, isHovering ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: name
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ae1740356bb7001c$var$InnerContainer, null, content)) : content);
});
$ae1740356bb7001c$var$PriorityCellView.displayName = 'PriorityCellView';
const $ae1740356bb7001c$var$PriorityCell = /*#__PURE__*/ (0, $5uXOq.memo)(({ name: name, iconUrl: iconUrl, issueKey: issueKey, issueType: issueType, width: width, height: height, fieldType: fieldType, isSelected: isSelected = false, wrapperRef: wrapperRef, isEditable: isEditable, selectOptions: selectOptions, issueTypeId: issueTypeId, fieldName: fieldName, testId: testId, editMode: editMode = false, setEditMode: setEditMode = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isHovering: isHovering = false, inputValue: inputValue, onInputChange: onInputChange })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ value: value, error: error }, { saveValue: saveValue }] = (0, $lQE94.useEditField)({
        fieldKey: (0, $5fc53.PRIORITY_TYPE),
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: {
            name: name,
            iconUrl: iconUrl
        }
    });
    const cellViewProps = (0, $5uXOq.useMemo)(()=>({
            name: value && value.name,
            iconUrl: value && value.iconUrl,
            width: width,
            height: height
        }), [
        value,
        width,
        height
    ]);
    const handleChange = (0, $5uXOq.useCallback)((option)=>{
        setEditMode(false);
        const selectedOption = selectOptions.find((fieldoption)=>fieldoption.name === option?.value);
        selectedOption && saveValue(selectedOption, null, createAnalyticsEvent({}));
        setTimeout(()=>{
            wrapperRef?.current?.focus();
        });
    }, [
        setEditMode,
        selectOptions,
        saveValue,
        createAnalyticsEvent,
        wrapperRef
    ]);
    const handlePopupClose = (0, $5uXOq.useCallback)(()=>{
        setEditMode(false);
    }, [
        setEditMode
    ]);
    const popupTrigger = (0, $5uXOq.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
            ...triggerProps,
            xcss: $ae1740356bb7001c$var$popupTriggerStyles,
            testId: "business-list.ui.list-view.priority-cell.trigger"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ae1740356bb7001c$var$PriorityCellView, {
            ...cellViewProps,
            isHovering: isHovering
        })), [
        isHovering,
        cellViewProps
    ]); // we need to sort the options so that the selected priority is at the top of the list
    // as the first option is hovered by default and will be selected if `Enter` is pressed
    // immediately after the select dropdown is shown
    const prioritySelectOptions = (0, $5uXOq.useMemo)(()=>{
        let selectedPriorityOption = null;
        const priorityOptions = [];
        (selectOptions || []).forEach((option)=>{
            if (option.name == null) return;
            const priorityOption = {
                label: option.name,
                value: option.name
            };
            if (option.name === value?.name) selectedPriorityOption = priorityOption;
            else priorityOptions.push(priorityOption);
        });
        if (selectedPriorityOption != null) priorityOptions.unshift(selectedPriorityOption);
        return priorityOptions;
    }, [
        selectOptions,
        value?.name
    ]);
    const getFormatOptionLabel = (0, $5uXOq.useCallback)((option)=>{
        const selectedOption = selectOptions.find((fieldoption)=>fieldoption.name === option?.value);
        if (selectedOption?.iconUrl === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, option.label || '');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ae1740356bb7001c$var$OptionWrapper, {
            "data-testid": "business-list.ui.list-view.priority-cell.priority-option"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ae1740356bb7001c$var$ImgSpan, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ae1740356bb7001c$var$StyledImage, {
            src: selectedOption.iconUrl,
            alt: option.label,
            role: "none"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ae1740356bb7001c$var$FlexSpan, null, option.label));
    }, [
        selectOptions
    ]);
    const popupContent = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lI995.CellContentWrapper // -1px border left from gridcell
        ), {
            preferredWidth: width - 1,
            "data-testid": "business-list.ui.list-view.priority-cell.popup-content"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8ad1n.default), {
            autoFocus: true,
            menuIsOpen: true,
            placeholder: formatMessage((0, $3tdNZ.default).placeholder),
            options: prioritySelectOptions,
            onChange: handleChange,
            value: (0, $ATTEL.transformValue)(value),
            formatOptionLabel: getFormatOptionLabel,
            isMulti: false,
            isInvalid: false,
            isClearable: false,
            tabSelectsValue: true,
            inputValue: inputValue,
            onInputChange: onInputChange
        })), [
        formatMessage,
        getFormatOptionLabel,
        handleChange,
        inputValue,
        onInputChange,
        prioritySelectOptions,
        value,
        width
    ]);
    const popupComponent = (0, $5uXOq.useMemo)(()=>(0, $jRzRt.getPopupComponentWithHeight)({
            numOptions: selectOptions.length ?? 0
        }), [
        selectOptions.length
    ]);
    const popup = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
            isOpen: editMode,
            placement: "bottom-start",
            onClose: handlePopupClose,
            trigger: popupTrigger,
            offset: $ae1740356bb7001c$var$POPUP_OFFSET,
            popupComponent: popupComponent,
            content: popupContent,
            autoFocus: false
        }), [
        editMode,
        handlePopupClose,
        popupTrigger,
        popupContent,
        popupComponent
    ]);
    const content = (0, $5uXOq.useMemo)(()=>isHovering || editMode || isSelected ? popup : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ae1740356bb7001c$var$PriorityCellView, {
            ...cellViewProps,
            isHovering: isHovering
        }), [
        isHovering,
        editMode,
        isSelected,
        popup,
        cellViewProps
    ]);
    const cellContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isEditable === false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ae1740356bb7001c$var$PriorityCellView, {
        ...cellViewProps,
        isHovering: isHovering
    }) : content, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0a4D.FixItErrorFlag), {
        error: error,
        title: (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $3tdNZ.default).errorTitleIssueTermRefresh : (0, $3tdNZ.default).errorTitle,
        description: (0, $3tdNZ.default).errorMessage,
        issueType: issueType,
        issueTypeId: issueTypeId,
        fieldId: (0, $5fc53.PRIORITY_TYPE),
        fieldName: fieldName
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b5lmY.CellWrapper), {
        isEditable: isEditable,
        testId: testId
    }, cellContent);
});
var $ae1740356bb7001c$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $ae1740356bb7001c$var$PriorityCell;
const $ae1740356bb7001c$var$InnerContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4t3i1osq _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ae1740356bb7001c$var$FlexSpan = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ae1740356bb7001c$var$ImgSpan = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _u5f3u2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ae1740356bb7001c$var$OptionWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ae1740356bb7001c$var$StyledImage = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb7vkz _4t3i7vkz",
            __cmplp.className
        ])
    });
});
const $ae1740356bb7001c$var$popupTriggerStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.neutral.subtle',
    padding: 'space.0'
});

});
parcelRegister("8ad1n", function(module, exports) {

$parcel$export(module.exports, "default", () => $c414531c2730e4db$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/deprecations/no-rll-client-async-experiences
const $c414531c2730e4db$var$Select = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("2fwpz")), {
    ssr: false,
    moduleId: "./src/packages/business/shared/fields/src/common/ui/lazy-select/main.tsx"
});
const $c414531c2730e4db$var$SelectComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "select",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c414531c2730e4db$var$Select, props));
var $c414531c2730e4db$export$2e2bcd8739ae039 = $c414531c2730e4db$var$SelectComponent;

});
parcelRegister("2fwpz", function(module, exports) {

let $1a361fbb5641e21c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1a361fbb5641e21c$var$load("hTffr").then(()=>parcelRequire('46JGW'));

});


parcelRegister("20vaL", function(module, exports) {

$parcel$export(module.exports, "CardPriority", () => $cc5d64f9a1c4db88$export$92d93d4ee23c212c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3bDjY = parcelRequire("3bDjY");

var $gwIPs = parcelRequire("gwIPs");

var $koVbs = parcelRequire("koVbs");

var $jsE5o = parcelRequire("jsE5o");
const $cc5d64f9a1c4db88$export$92d93d4ee23c212c = (props)=>{
    const { name: name, uri: uri } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const priorityLevel = formatMessage((0, $jsE5o.default).priorityTooltip, {
        priorityLevel: name
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc5d64f9a1c4db88$var$Icon, {
        "data-testid": "platform-card.common.ui.priority.icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: priorityLevel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc5d64f9a1c4db88$export$3e431a229df88919, {
        alt: priorityLevel,
        src: uri
    })));
};
var $cc5d64f9a1c4db88$export$2e2bcd8739ae039 = $cc5d64f9a1c4db88$export$92d93d4ee23c212c;
const $cc5d64f9a1c4db88$var$iconSize = (0, $gwIPs.gridSize) * 2;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cc5d64f9a1c4db88$var$Icon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $cc5d64f9a1c4db88$export$3e431a229df88919 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb7vkz _4t3i7vkz _s7n41ndm",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jsE5o", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd4384d9d4bf039b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $fd4384d9d4bf039b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    priorityTooltip: {
        "id": "platform-ui-card.common.priority.priority-tooltip",
        "defaultMessage": "{priorityLevel} priority"
    }
});

});


parcelRegister("3tdNZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d9c47e3a393eda9$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8d9c47e3a393eda9$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorTitle: {
        "id": "business-list.list-view.priority-cell.error-title",
        "defaultMessage": "We couldn't save the issue priority."
    },
    errorMessage: {
        "id": "business-list.list-view.priority-cell.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    },
    placeholder: {
        "id": "business-list.list-view.priority-cell.placeholder",
        "defaultMessage": "Select Priority"
    },
    priorityLabel: {
        "id": "business-list.list-view.priority-cell.priority-label",
        "defaultMessage": "{priority} priority"
    },
    errorTitleIssueTermRefresh: {
        "id": "business-list.list-view.priority-cell.error-title-issue-term-refresh",
        "defaultMessage": "We couldn't save the work item priority "
    }
});

});

parcelRegister("ATTEL", function(module, exports) {

$parcel$export(module.exports, "transformValue", () => $f053920f1d5fc034$export$98c150630afe5417);
const $f053920f1d5fc034$export$98c150630afe5417 = (value)=>{
    if (!value) return [];
    const valuesArray = Array.isArray(value) ? value : [
        value
    ];
    return valuesArray.map(({ name: name })=>({
            value: name,
            label: name
        }));
};

});


parcelRegister("f9qBd", function(module, exports) {

$parcel$export(module.exports, "default", () => $97d6faa0e27a5cf5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $97d6faa0e27a5cf5$var$RemoteIssueLinksCell = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("kYd1R")), {
    moduleId: "./src/packages/business/list/src/ui/list-view/remote-issue-links-cell/main.tsx"
});
const $97d6faa0e27a5cf5$var$AsyncRemoteIssueLinksCell = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "remote-issue-links-cell",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($97d6faa0e27a5cf5$var$RemoteIssueLinksCell, props));
var $97d6faa0e27a5cf5$export$2e2bcd8739ae039 = $97d6faa0e27a5cf5$var$AsyncRemoteIssueLinksCell;

});
parcelRegister("kYd1R", function(module, exports) {

let $f443848664a7b05d$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $f443848664a7b05d$var$load("fliVL"),
    $f443848664a7b05d$var$load("7inKM")
]).then(()=>parcelRequire('dkDSI'));

});


parcelRegister("7xYOf", function(module, exports) {

$parcel$export(module.exports, "SelectRowCheckbox", () => $93c39f1bb8ec9d60$export$ee74d161095f15ae);
$parcel$export(module.exports, "SelectAllColumnCheckbox", () => $93c39f1bb8ec9d60$export$7ea5ed11456af816);

var $5uXOq = parcelRequire("5uXOq");

var $iAbh9 = parcelRequire("iAbh9");

var $deqCE = parcelRequire("deqCE");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $eTDjN = parcelRequire("eTDjN");

var $2GQqf = parcelRequire("2GQqf");

var $mk7k0 = parcelRequire("mk7k0");

var $cNbiI = parcelRequire("cNbiI");

var $bW4OH = parcelRequire("bW4OH");

var $fC925 = parcelRequire("fC925");

var $d61RR = parcelRequire("d61RR");
const $93c39f1bb8ec9d60$export$ee74d161095f15ae = /*#__PURE__*/ (0, $5uXOq.memo)(({ rowData: rowData, rowIndex: rowIndex, onKeyDown: onKeyDown, ...props })=>{
    const { issueId: rowIssueId, id: id } = rowData;
    const issueId = String(rowIssueId);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [, { selectIssues: selectIssues, unselectIssues: unselectIssues }] = (0, $mk7k0.useBulkSelectionStore)();
    const [isRowSelected] = (0, $mk7k0.useIsIssueSelected)({
        issueId: issueId,
        parentIssueId: rowData.parentIssueId
    });
    const { onShiftKeyBulkSelection: onShiftKeyBulkSelection } = (0, $bW4OH.useShiftKeySelection)();
    const bulkOpsFlow = (0, $iAbh9.useBulkOpsSessionContext)();
    const onClickCheckbox = (0, $5uXOq.useCallback)(({ isChecked: isChecked, shiftKeyPressed: shiftKeyPressed })=>{
        const bulkOpsSessionID = bulkOpsFlow?.getFlowAttributes()?.bulkOpsSessionID ?? '';
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'checkbox clicked', 'selectIssue', {
            isChecked: isChecked,
            rowIndex: rowIndex,
            shiftKeyPressed: shiftKeyPressed,
            bulkOpsSessionID: bulkOpsSessionID
        });
        if (isChecked) selectIssues({
            issues: [
                issueId
            ],
            rowIndex: rowIndex
        });
        else unselectIssues({
            issues: [
                issueId
            ],
            rowIndex: rowIndex
        });
        if (shiftKeyPressed) onShiftKeyBulkSelection({
            isChecked: isChecked,
            rowIndex: rowIndex
        });
    }, [
        createAnalyticsEvent,
        issueId,
        onShiftKeyBulkSelection,
        rowIndex,
        selectIssues,
        unselectIssues,
        bulkOpsFlow
    ]);
    const handleKeyDown = (0, $5uXOq.useCallback)((e)=>{
        if (e.key === 'Enter') {
            onClickCheckbox({
                isChecked: !isRowSelected,
                shiftKeyPressed: e.shiftKey
            });
            return;
        }
        if (e.shiftKey && e.key === 'Tab' || e.key === 'ArrowLeft' && typeof document !== 'undefined') {
            e.preventDefault();
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.dispatchEvent(new CustomEvent(`${(0, $eTDjN.DRAG_AND_DROP_BUTTON_FOCUS_EVENT)}`, {
                detail: {
                    issueId: issueId
                }
            }));
            return;
        }
        onKeyDown?.(e);
    }, [
        isRowSelected,
        onClickCheckbox,
        onKeyDown,
        issueId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const focusOnCheckbox = (e)=>{
            if (String(e.detail.issueId) !== issueId) return;
            if (typeof document !== 'undefined') {
                const checkbox = document.getElementById(`${(0, $eTDjN.BULK_SELECT_CHECKBOX_ID)}-${issueId}`);
                checkbox?.focus();
            }
        };
        typeof document !== 'undefined' && document.addEventListener(`${(0, $eTDjN.BULK_SELECT_CHECKBOX_ID)}-focus`, focusOnCheckbox);
        return ()=>{
            typeof document !== 'undefined' && document.removeEventListener(`${(0, $eTDjN.BULK_SELECT_CHECKBOX_ID)}-focus`, focusOnCheckbox);
        };
    }, [
        issueId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fC925.DragHandle), {
        issueId: issueId,
        parentIssueId: rowData.parentIssueId,
        hierarchyLevel: rowData.issuetype?.level
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2GQqf.BulkSelectCheckbox), {
        id: `${(0, $eTDjN.BULK_SELECT_CHECKBOX_ID)}-${issueId}`,
        onClick: onClickCheckbox,
        isChecked: isRowSelected,
        onKeyDown: handleKeyDown,
        isDisabled: id.startsWith((0, $deqCE.OPTIMISTIC_ID_PREFIX)),
        label: formatMessage((0, $d61RR.default).selectIssue, {
            issueKey: rowData.key
        }),
        ...props
    }));
});
const $93c39f1bb8ec9d60$export$7ea5ed11456af816 = /*#__PURE__*/ (0, $5uXOq.memo)(({ showBulkEditOnboarding: showBulkEditOnboarding = false })=>{
    const { isIndeterminate: isIndeterminate, onClickCheckbox: onClickCheckbox, isChecked: isChecked } = (0, $cNbiI.useSelectAllCheckbox)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isPulseActive, setIsPulseActive] = (0, $5uXOq.useState)(!isChecked);
    const onClickSelectAllCheckbox = (0, $5uXOq.useCallback)((e)=>{
        onClickCheckbox(e);
        setIsPulseActive(false);
    }, [
        onClickCheckbox
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2GQqf.BulkSelectCheckbox), {
        onClick: onClickSelectAllCheckbox,
        isChecked: isChecked || isIndeterminate,
        isIndeterminate: isIndeterminate,
        label: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $d61RR.default).selectAllIssueTermRefresh : (0, $d61RR.default).selectAll),
        hasPulse: showBulkEditOnboarding && isPulseActive && (0, $4R6GH.fg)('jira_list_view_bulk_edit_changeboarding')
    });
});

});
parcelRegister("cNbiI", function(module, exports) {

$parcel$export(module.exports, "useSelectAllCheckbox", () => $90aa8202aedd922f$export$1f1cc91657e74385);

var $5uXOq = parcelRequire("5uXOq");

var $1XJ20 = parcelRequire("1XJ20");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $8e3Yw = parcelRequire("8e3Yw");

var $9u99d = parcelRequire("9u99d");

var $mk7k0 = parcelRequire("mk7k0");

var $79pxk = parcelRequire("79pxk");

var $4DEgE = parcelRequire("4DEgE");
const $90aa8202aedd922f$export$1f1cc91657e74385 = ()=>{
    const [{ hierarchyData: { data: data, isLoadingNextPage: isLoadingNextPage }, childrenItems: childrenItems }] = (0, $9u99d.useHierarchyStore)();
    const [{ areAllIssuesSelected: areAllIssuesSelected, selectedIssues: selectedIssues }, { selectAllIssues: selectAllIssues, selectAll: selectAll, clearSelection: clearSelection, unselectAll: unselectAll }] = (0, $mk7k0.useBulkSelectionStore)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { fetchingGroups: fetchingGroups, selectCollapsedGroups: selectCollapsedGroups } = (0, $79pxk.useSelectCollapsedGroups)();
    const [groupByFieldId] = (0, $8e3Yw.useGroupBy)();
    const prevGroupByFieldId = (0, $1XJ20.usePreviousWithInitial)(groupByFieldId);
    const isGrouping = groupByFieldId != null;
    (0, $5uXOq.useEffect)(()=>{
        if (prevGroupByFieldId !== groupByFieldId) // if the groupByFieldId is updated, clear the selection
        clearSelection();
    }, [
        clearSelection,
        groupByFieldId,
        prevGroupByFieldId
    ]);
    /*
        UNSELECT - if is all selected and we get new data we should unselect the "select all" checkbox
        to avoid comparing all the data we can just update the select all once we:
        - fetch a new page
        - fetch any children
    */ (0, $5uXOq.useEffect)(()=>{
        if (isLoadingNextPage && areAllIssuesSelected) unselectAll();
    }, [
        areAllIssuesSelected,
        isLoadingNextPage,
        unselectAll
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (areAllIssuesSelected) {
            if (!isGrouping) unselectAll();
            else if (isGrouping && !fetchingGroups) unselectAll();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        JSON.stringify(childrenItems),
        data.length
    ]);
    /*
        SELECT ALL - if all the issues are selected we should check the 'select all checkbox'
        to avoid comparing all the data we can just check if it's all selected when an issue is selected
    */ (0, $5uXOq.useEffect)(()=>{
        if (!areAllIssuesSelected && selectedIssues.size) {
            // if is no grouping and there are more data selected we should check if all are selected.
            if (!isGrouping && selectedIssues.size >= data.length) {
                const allIssues = (0, $4DEgE.getAllIssuesIds)({
                    data: data,
                    childrenItems: childrenItems
                });
                if (allIssues.length === selectedIssues.size) selectAll();
            } else if (isGrouping) {
                // if some of the groups were not fetched and have issues, then not select all
                for(let i = 0; i < data.length; i += 1){
                    const group = data[i];
                    const hasChildren = group.childSummary?.hasChildren;
                    if (hasChildren && childrenItems[group.issueId] === undefined) return;
                }
                const allIssues = (0, $4DEgE.getAllIssuesIds)({
                    data: data,
                    childrenItems: childrenItems
                });
                if (allIssues.length === selectedIssues.size) selectAll();
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedIssues
    ]);
    const onClickCheckbox = (0, $5uXOq.useCallback)(({ isChecked: isChecked })=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'checkbox clicked', 'selectAll', {
            isChecked: isChecked
        });
        if (isChecked) {
            const allIssues = (0, $4DEgE.getAllIssuesIds)({
                data: data,
                childrenItems: childrenItems
            });
            // if it's an empty project we don't want to anything
            if (!allIssues.length && !isGrouping) return;
            selectAllIssues({
                issues: allIssues
            });
            if (isGrouping) selectCollapsedGroups(data);
        } else clearSelection();
    }, [
        childrenItems,
        clearSelection,
        createAnalyticsEvent,
        data,
        isGrouping,
        selectAllIssues,
        selectCollapsedGroups
    ]);
    return {
        isChecked: areAllIssuesSelected,
        isIndeterminate: !areAllIssuesSelected && selectedIssues.size > 0,
        onClickCheckbox: onClickCheckbox
    };
};

});

parcelRegister("fC925", function(module, exports) {

$parcel$export(module.exports, "DragHandle", () => $1fb0b7c4540da9f7$export$a0c24614540b0efb);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $fSR12 = parcelRequire("fSR12");

var $3bDjY = parcelRequire("3bDjY");

var $kRkJF = parcelRequire("kRkJF");

var $33Toe = parcelRequire("33Toe");

var $koVbs = parcelRequire("koVbs");

var $7mPT9 = parcelRequire("7mPT9");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $4R6GH = parcelRequire("4R6GH");

var $6s1PB = parcelRequire("6s1PB");

var $aHcof = parcelRequire("aHcof");

var $8e3Yw = parcelRequire("8e3Yw");

var $9u99d = parcelRequire("9u99d");

var $hb2SN = parcelRequire("hb2SN");

var $dkRGQ = parcelRequire("dkRGQ");

var $5SOge = parcelRequire("5SOge");

var $tx8ST = parcelRequire("tx8ST");

var $1hMwG = parcelRequire("1hMwG");
const $1fb0b7c4540da9f7$export$6857f01327f0ba6b = 'business-list.ui.list-view.select-row-cell.drag-handle.handle';
const $1fb0b7c4540da9f7$export$d14865b4344e4f2d = 'business-list.ui.list-view.select-row-cell.drag-handle.drag-handle-container';
function $1fb0b7c4540da9f7$export$a0c24614540b0efb({ issueId: issueId, parentIssueId: parentIssueId, hierarchyLevel: issueHierarchyLevel }) {
    const { disallowDragWithMessage: disallowDragWithMessage, isDragHandleHidden: isDragHandleHidden, dragHandleRef: dragHandleRef, onDrag: handleDrag, onDragTargetKeyDown: handleDragTargetKeyDown, onContainerKeyDown: handleContainerKeyDown } = (0, $aHcof.useDraggableRow)();
    const [{ issuesMap: issuesMap, hierarchyData: hierarchyData }] = (0, $9u99d.useHierarchyStore)();
    const currentIssues = parentIssueId ? issuesMap.get(parentIssueId)?.children : hierarchyData.data;
    const currentIssueIndex = currentIssues?.findIndex((issue)=>issue.issueId === Number(issueId));
    const { loading: loading } = (0, $5SOge.useRankIssue)();
    const { rankFirst: rankFirst, rankLast: rankLast, rankBefore: rankBefore, rankAfter: rankAfter } = (0, $dkRGQ.useRankIssueActions)(issueId, parentIssueId);
    const isOptimisticItem = (0, $33Toe.isOptimisticIssue)(Number(issueId));
    const [groupByFieldId] = (0, $8e3Yw.useGroupBy)();
    const isGrouping = groupByFieldId != null;
    const { isFiltering: isFiltering } = (0, $kRkJF.useFilteredViewContextInput)({
        view: 'list'
    });
    const [{ hierarchyLevel: hierarchyLevel }] = (0, $tx8ST.useHierarchyLevel)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [, { openReparentModal: openReparentModal }] = (0, $hb2SN.useReparentModalStore)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const handleOpenReparentModal = (0, $5uXOq.useCallback)(()=>{
        openReparentModal(String(issueId));
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'reparent clicked', 'dragHandleDropdown');
    }, [
        createAnalyticsEvent,
        issueId,
        openReparentModal
    ]);
    if (disallowDragWithMessage != null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: disallowDragWithMessage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1fb0b7c4540da9f7$var$DragHandleContainer, {
        onKeyDown: handleContainerKeyDown,
        "data-testid": $1fb0b7c4540da9f7$export$d14865b4344e4f2d
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fSR12.DragHandleButtonSmall), {
        // Inline style because the drag handle button does not handle disabled states
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        ref: dragHandleRef,
        "data-drag-handle": true,
        label: formatMessage((0, $1hMwG.default).reorder),
        "aria-disabled": "true",
        onKeyDown: handleDragTargetKeyDown,
        className: (0, $bwpsq.default)([
            "_80om13gf _1e0c1xpt"
        ]),
        style: {
            "--_9h4ns6": (0, $lD23V.default)(isDragHandleHidden ? 'none' : 'flex')
        }
    })));
    if (isOptimisticItem) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1fb0b7c4540da9f7$var$Handle, {
        disallowDrag: true,
        "data-drag-handle": true,
        "data-testid": $1fb0b7c4540da9f7$export$6857f01327f0ba6b
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1fb0b7c4540da9f7$var$DragHandleContainer, {
        onKeyDown: handleContainerKeyDown
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fSR12.DragHandleButtonSmall), {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/no-unsafe-style-overrides -- Ignored via go/DSP-18766
                ref: (0, $7mPT9.mergeRefs)(dragHandleRef, triggerRef),
                "data-drag-handle": true,
                label: formatMessage((0, $1hMwG.default).reorder),
                ...triggerProps,
                onDrag: handleDrag,
                onKeyDown: handleDragTargetKeyDown,
                className: (0, $bwpsq.default)([
                    "_1e0c1xpt"
                ]),
                style: {
                    "--_9h4ns6": (0, $lD23V.default)(isDragHandleHidden ? 'none' : 'flex')
                }
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), null, !loading && currentIssueIndex != null && currentIssueIndex > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: rankFirst
    }, formatMessage((()=>{
        if ((0, $6s1PB.expVal)('jira-itr-m4-exp-3', 'isEnabled', false)) return (0, $1hMwG.default).movetoTopIssueTerminologyRefreshM4;
        if ((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3')) return (0, $1hMwG.default).movetoTopIssueTermRefresh;
        return (0, $1hMwG.default).movetoTop;
    })())), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: rankBefore
    }, formatMessage((()=>{
        if ((0, $6s1PB.expVal)('jira-itr-m4-exp-3', 'isEnabled', false)) return (0, $1hMwG.default).moveUpIssueTerminologyRefreshM4;
        if ((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3')) return (0, $1hMwG.default).moveUpIssueTermRefresh;
        return (0, $1hMwG.default).moveUp;
    })()))), !loading && currentIssues && currentIssueIndex !== currentIssues.length - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: rankAfter
    }, formatMessage((()=>{
        if ((0, $6s1PB.expVal)('jira-itr-m4-exp-3', 'isEnabled', false)) return (0, $1hMwG.default).moveDownIssueTerminologyRefreshM4;
        if ((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3')) return (0, $1hMwG.default).moveDownIssueTermRefresh;
        return (0, $1hMwG.default).moveDown;
    })())), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: rankLast
    }, formatMessage((()=>{
        if ((0, $6s1PB.expVal)('jira-itr-m4-exp-3', 'isEnabled', false)) return (0, $1hMwG.default).moveToBottomIssueTerminologyRefreshM4;
        if ((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3')) return (0, $1hMwG.default).moveToBottomIssueTermRefresh;
        return (0, $1hMwG.default).moveToBottom;
    })()))), !loading && !isFiltering && !isGrouping && issueHierarchyLevel !== hierarchyLevel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: handleOpenReparentModal
    }, parentIssueId != null ? formatMessage((0, $1hMwG.default).changeParent) : formatMessage((0, $1hMwG.default).addParent)))));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1fb0b7c4540da9f7$var$DragHandleContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _19bvv77o _1ltvu2gc _154ize3t _94n5ze3t _1e0c1txw _4cvr1h6o _is06131l _1mp4gktf _cfu11txw _24gj1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1fb0b7c4540da9f7$var$Handle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { disallowDrag: disallowDrag, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0cglyw _kqswstnw _1ltvv77o _154ize3t _94n5ze3t _1kt9mrja _is06131l _1mp4gktf _cfu11txw _24gj1h6o _kfgt1osq _19o61h6o",
            __cmplp.disallowDrag ? "_wxb013gf" : "_wxb01qgj",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fSR12", function(module, exports) {

$parcel$export(module.exports, "DragHandleButtonSmall", () => $9e0d22c00c6251eb$export$81bd0a2e6f324029);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $57Zji = parcelRequire("57Zji");

var $1zAi3 = parcelRequire("1zAi3");

var $VSDnB = parcelRequire("VSDnB");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $1R0ak = parcelRequire("1R0ak");
const $9e0d22c00c6251eb$var$iconSmallStyles = (0, $8CUq3.xcss)({
    display: 'inline-flex',
    marginInline: 'space.negative.050'
});
const $9e0d22c00c6251eb$var$iconSmallStylesNew = (0, $8CUq3.xcss)({
    display: 'inline-flex'
});
const $9e0d22c00c6251eb$export$81bd0a2e6f324029 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function DragHandleButton({ label: label, ...buttonProps }, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1R0ak.DragHandleButtonBase), {
        ref: ref,
        ...buttonProps,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
            xcss: (0, $VSDnB.fg)('platform-component-visual-refresh') || (0, $VSDnB.fg)('platform-visual-refresh-icons') ? $9e0d22c00c6251eb$var$iconSmallStylesNew : $9e0d22c00c6251eb$var$iconSmallStyles,
            children: (0, $VSDnB.fg)('platform-component-visual-refresh') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($57Zji))), {
                color: "currentColor",
                label: label
            }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1zAi3))), {
                color: "currentColor",
                label: label,
                LEGACY_size: "small"
            })
        })
    });
});

});
parcelRegister("57Zji", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c021dd04da16bc130f1da0e63e621476>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3bbd2a25619c0aa4$var$_react = $3bbd2a25619c0aa4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3bbd2a25619c0aa4$var$_baseNew = $3bbd2a25619c0aa4$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3bbd2a25619c0aa4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "DragHandleVertical".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dragging elements along a vertical axis.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3bbd2a25619c0aa4$var$DragHandleVerticalIcon = (props)=>/*#__PURE__*/ $3bbd2a25619c0aa4$var$_react.default.createElement($3bbd2a25619c0aa4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5 2.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0m4.5 0a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M5 6a1.25 1.25 0 1 1-2.5 0A1.25 1.25 0 0 1 5 6m4.5 0A1.25 1.25 0 1 1 7 6a1.25 1.25 0 0 1 2.5 0M5 9.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0m4.5 0a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0"/>`,
        type: 'utility'
    }, props));
$3bbd2a25619c0aa4$var$DragHandleVerticalIcon.displayName = 'DragHandleVerticalIcon';
var $3bbd2a25619c0aa4$var$_default = module.exports.default = $3bbd2a25619c0aa4$var$DragHandleVerticalIcon;

});

parcelRegister("1zAi3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::773d3e284dd6aa2dffd7def63d4a5183>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $125535c8ed3191e2$var$_react = $125535c8ed3191e2$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $125535c8ed3191e2$var$_dragHandleVertical = $125535c8ed3191e2$var$_interopRequireDefault((parcelRequire("57Zji")));

var $125535c8ed3191e2$var$_dragHandler = $125535c8ed3191e2$var$_interopRequireDefault((parcelRequire("78tet")));
function $125535c8ed3191e2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DragHandleVerticalIcon.
 * This component is DragHandleVerticalIcon, with `UNSAFE_fallbackIcon` set to "DragHandlerIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dragging elements along a vertical axis.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $125535c8ed3191e2$var$DragHandleVerticalIcon = (props)=>/*#__PURE__*/ $125535c8ed3191e2$var$_react.default.createElement($125535c8ed3191e2$var$_dragHandleVertical.default, Object.assign({
        LEGACY_fallbackIcon: $125535c8ed3191e2$var$_dragHandler.default
    }, props));
$125535c8ed3191e2$var$DragHandleVerticalIcon.Name = 'DragHandleVerticalIconMigration';
var $125535c8ed3191e2$var$_default = module.exports.default = $125535c8ed3191e2$var$DragHandleVerticalIcon;

});
parcelRegister("78tet", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $531ff4bbcd008815$var$_react = $531ff4bbcd008815$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $531ff4bbcd008815$var$_dragHandleVertical = $531ff4bbcd008815$var$_interopRequireDefault((parcelRequire("aQg6X")));
function $531ff4bbcd008815$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $531ff4bbcd008815$var$DragHandlerIcon = (props)=>/*#__PURE__*/ $531ff4bbcd008815$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="10" cy="8" r="1"/><circle cx="14" cy="8" r="1"/><circle cx="10" cy="16" r="1"/><circle cx="14" cy="16" r="1"/><circle cx="10" cy="12" r="1"/><circle cx="14" cy="12" r="1"/></g></svg>`
    }, props, {
        newIcon: $531ff4bbcd008815$var$_dragHandleVertical.default
    }));
$531ff4bbcd008815$var$DragHandlerIcon.displayName = 'DragHandlerIcon';
var $531ff4bbcd008815$var$_default = module.exports.default = $531ff4bbcd008815$var$DragHandlerIcon;

});
parcelRegister("aQg6X", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::37637907bc962c27c98c216148025653>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7e4b4215d4b0ee00$var$_react = $7e4b4215d4b0ee00$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7e4b4215d4b0ee00$var$_baseNew = $7e4b4215d4b0ee00$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $7e4b4215d4b0ee00$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "DragHandleVertical".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dragging elements along a vertical axis.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7e4b4215d4b0ee00$var$DragHandleVerticalIcon = (props)=>/*#__PURE__*/ $7e4b4215d4b0ee00$var$_react.default.createElement($7e4b4215d4b0ee00$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M7 2.75a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m5.5 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0M7 8a1.75 1.75 0 1 1-3.5 0A1.75 1.75 0 0 1 7 8m5.5 0A1.75 1.75 0 1 1 9 8a1.75 1.75 0 0 1 3.5 0M7 13.25a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m5.5 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0"/>`
    }, props));
$7e4b4215d4b0ee00$var$DragHandleVerticalIcon.displayName = 'DragHandleVerticalIcon';
var $7e4b4215d4b0ee00$var$_default = module.exports.default = $7e4b4215d4b0ee00$var$DragHandleVerticalIcon;

});



parcelRegister("1R0ak", function(module, exports) {

$parcel$export(module.exports, "DragHandleButtonBase", () => $34ba86d040d49b37$export$c099c65cfbd84d0a);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $jhVLw = parcelRequire("jhVLw");
function $34ba86d040d49b37$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Cannot use `@atlaskit/button` here because it cancels `mousedown` events
 * which prevents dragging.
 */ const $34ba86d040d49b37$var$buttonStyles = {
    name: "1waumgt",
    styles: "color:var(--ds-text, #172B4D);border-radius:var(--ds-border-radius-100, 4px);padding:var(--ds-space-0, 0px);width:max-content;border:none;cursor:grab;display:flex"
};
const $34ba86d040d49b37$var$buttonAppearanceStyles = {
    default: {
        name: "1dab6g1",
        styles: "background-color:var(--ds-background-neutral, #091E420F);&:hover{background-color:var(--ds-background-neutral-hovered, #091E4224);}&:active{background-color:var(--ds-background-neutral-pressed, #091E424F);}"
    },
    subtle: {
        name: "1hy78sx",
        styles: "background-color:var(--ds-background-neutral-subtle, #00000000);&:hover{background-color:var(--ds-background-neutral-subtle-hovered, #091E420F);}&:active{background-color:var(--ds-background-neutral-subtle-pressed, #091E4224);}"
    },
    selected: {
        name: "1pi0h5q",
        styles: "background-color:var(--ds-background-selected, #E9F2FF);color:var(--ds-text-selected, #0C66E4)"
    }
};
const $34ba86d040d49b37$export$c099c65cfbd84d0a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function DragHandleButton({ children: children, isSelected: isSelected = false, testId: testId, appearance: appearanceProp = 'default', type: /**
   * Defaulting to `button` instead of `submit` (native default in some cases).
   *
   * A type of `submit` only makes sense in a form context, and isn't very
   * relevant to a drag handle.
   *
   * `@atlaskit/button` also defaults to a type of `button` as well, as it
   * is more semantically appropriate in a wider range of cases.
   */ type = 'button', ...buttonProps }, ref) {
    const appearance = isSelected ? 'selected' : appearanceProp;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jhVLw.default), null, /*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
        ref: ref,
        css: [
            $34ba86d040d49b37$var$buttonStyles,
            $34ba86d040d49b37$var$buttonAppearanceStyles[appearance]
        ],
        "data-testid": testId,
        type: type,
        ...buttonProps
    }, children));
});

});


parcelRegister("aHcof", function(module, exports) {

$parcel$export(module.exports, "DraggableRowContext", () => $8686e476f30c2781$export$58601e96edd1b5b4);
$parcel$export(module.exports, "useDraggableRow", () => $8686e476f30c2781$export$a878804271d34ba8);

var $5uXOq = parcelRequire("5uXOq");
const $8686e476f30c2781$export$58601e96edd1b5b4 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
function $8686e476f30c2781$export$a878804271d34ba8() {
    const context = (0, $5uXOq.useContext)($8686e476f30c2781$export$58601e96edd1b5b4);
    if (context == null) throw new Error('Unable to retrieve DraggableRow context');
    return context;
}

});

parcelRegister("dkRGQ", function(module, exports) {

$parcel$export(module.exports, "useRankIssueActions", () => $9ee421b5cac4ecb7$export$87538f9c3aec3a67);

var $5uXOq = parcelRequire("5uXOq");

var $egmQO = parcelRequire("egmQO");

var $jDUax = parcelRequire("jDUax");

var $koeKL = parcelRequire("koeKL");

var $9u99d = parcelRequire("9u99d");

var $eg2To = parcelRequire("eg2To");

var $5SOge = parcelRequire("5SOge");
function $9ee421b5cac4ecb7$export$87538f9c3aec3a67(issueId, parentIssueId) {
    const cloudId = (0, $koeKL.useCloudId)();
    const input = (0, $eg2To.useIssuesInput)({
        groupIssueId: (0, $jDUax.isGroupItem)(parentIssueId) ? parentIssueId : undefined,
        parentIssueId: !(0, $jDUax.isGroupItem)(parentIssueId) ? parentIssueId : undefined
    });
    const variables = (0, $5uXOq.useMemo)(()=>({
            ...(0, $egmQO.getVariables)(input),
            cloudId: cloudId
        }), [
        cloudId,
        input
    ]);
    const [{ issuesMap: issuesMap, hierarchyData: hierarchyData }] = (0, $9u99d.useHierarchyStore)();
    const { rankIssue: rankIssue } = (0, $5SOge.useRankIssue)();
    const currentIssues = parentIssueId ? issuesMap.get(parentIssueId)?.children : hierarchyData.data;
    const currentIssueIndex = currentIssues?.findIndex((issue)=>issue.issueId === Number(issueId));
    const rankItem = (0, $5uXOq.useCallback)(({ oldIndex: oldIndex, newIndex: newIndex })=>{
        if (oldIndex == null || newIndex == null) return;
        if (currentIssues == null || currentIssueIndex == null || currentIssueIndex === -1) return;
        rankIssue({
            newIndex: newIndex,
            oldIndex: oldIndex,
            issues: currentIssues,
            variables: variables
        });
    }, [
        currentIssueIndex,
        currentIssues,
        rankIssue,
        variables
    ]);
    const rankAfter = (0, $5uXOq.useCallback)(()=>{
        rankItem({
            oldIndex: currentIssueIndex,
            ...currentIssueIndex != null ? {
                newIndex: currentIssueIndex + 1
            } : {}
        });
    }, [
        rankItem,
        currentIssueIndex
    ]);
    const rankBefore = (0, $5uXOq.useCallback)(()=>{
        rankItem({
            oldIndex: currentIssueIndex,
            ...currentIssueIndex != null ? {
                newIndex: currentIssueIndex - 1
            } : {}
        });
    }, [
        rankItem,
        currentIssueIndex
    ]);
    const rankFirst = (0, $5uXOq.useCallback)(()=>{
        rankItem({
            oldIndex: currentIssueIndex,
            newIndex: 0
        });
    }, [
        rankItem,
        currentIssueIndex
    ]);
    const rankLast = (0, $5uXOq.useCallback)(()=>{
        rankItem({
            oldIndex: currentIssueIndex,
            ...currentIssues != null ? {
                newIndex: currentIssues?.length - 1
            } : {}
        });
    }, [
        rankItem,
        currentIssueIndex,
        currentIssues
    ]);
    return {
        rankFirst: rankFirst,
        rankLast: rankLast,
        rankBefore: rankBefore,
        rankAfter: rankAfter
    };
}

});
parcelRegister("5SOge", function(module, exports) {

$parcel$export(module.exports, "useRankIssue", () => $77a89c01dc5b1159$export$dbe3d15eebe7e64c);

var $5uXOq = parcelRequire("5uXOq");

var $egmQO = parcelRequire("egmQO");

var $cm8b5 = parcelRequire("cm8b5");

var $2UUq6 = parcelRequire("2UUq6");

var $jDUax = parcelRequire("jDUax");

var $krCqe = parcelRequire("krCqe");

var $jcw0u = parcelRequire("jcw0u");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $pa9q9 = parcelRequire("pa9q9");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $koeKL = parcelRequire("koeKL");

var $61h55 = parcelRequire("61h55");

var $aQbWi = parcelRequire("aQbWi");

var $eg2To = parcelRequire("eg2To");

var $1vW2U = parcelRequire("1vW2U");

var $aqtm0 = parcelRequire("aqtm0");
const $77a89c01dc5b1159$export$2d7a379894b4651b = ()=>(error)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'rankIssuelistViewRestQuery',
                packageName: 'jiraBusinessList',
                teamName: 'keystone'
            },
            attributes: {
                message: 'Failed to rank issue in list view via Rest'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    };
const $77a89c01dc5b1159$export$dbe3d15eebe7e64c = ()=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const [{ sortBy: sortBy }] = (0, $2UUq6.useSorting)();
    const cloudId = (0, $koeKL.useCloudId)();
    const intl = (0, $koVbs.default)();
    const isBlockedBySorting = sortBy !== undefined && sortBy !== null;
    const [{ rankParentIssueId: rankParentIssueId }] = (0, $aQbWi.useRankParent)();
    const input = (0, $eg2To.useIssuesInput)({
        groupIssueId: (0, $jDUax.isGroupItem)(rankParentIssueId) ? rankParentIssueId : undefined,
        parentIssueId: !(0, $jDUax.isGroupItem)(rankParentIssueId) ? rankParentIssueId : undefined
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const startExperience = (0, $cm8b5.useExperienceStart)((0, $1vW2U.RANK_ISSUE_EXPERIENCE));
    const markExperienceSuccess = (0, $cm8b5.useExperienceSuccess)((0, $1vW2U.RANK_ISSUE_EXPERIENCE));
    const markExperienceFailed = (0, $cm8b5.useExperienceFail)((0, $1vW2U.RANK_ISSUE_EXPERIENCE));
    const onError = (0, $5uXOq.useMemo)(()=>$77a89c01dc5b1159$export$2d7a379894b4651b(), []);
    const { loading: loading, rankListViewIssue: rankListViewIssue } = (0, $krCqe.useRankIssue)({
        query: (0, $61h55.LIST_VIEW_QUERY),
        variables: {
            ...(0, $egmQO.getVariables)(input),
            cloudId: cloudId
        },
        onError: (error, rankIssueErrorPayload)=>{
            const showWorkTypeDetails = rankIssueErrorPayload.issueKey && rankIssueErrorPayload.workType && (0, $6s1PB.expVal)('jira-itr-m4-exp-3', 'isEnabled', false);
            onError(error);
            if (error.statusCode === 403) {
                if (showWorkTypeDetails) showFlag((0, $aqtm0.getRankItemFail403FlagWithWorkType)(intl, rankIssueErrorPayload));
                else showFlag((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $1vW2U.RANK_ITEM_FAIL_403_FLAG_NEW) : (0, $1vW2U.RANK_ITEM_FAIL_403_FLAG));
            } else if (error.statusCode === 404) {
                if (showWorkTypeDetails) showFlag((0, $aqtm0.getRankItemFail404FlagWithWorkType)(intl, rankIssueErrorPayload));
                else showFlag((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $1vW2U.RANK_ITEM_FAIL_404_FLAG_NEW) : (0, $1vW2U.RANK_ITEM_FAIL_404_FLAG));
            } else {
                if (showWorkTypeDetails) showFlag((0, $aqtm0.getRankItemFailGenericFlagWithWorkType)(intl, rankIssueErrorPayload));
                else showFlag((0, $1vW2U.RANK_ITEM_FAIL_GENERIC_FLAG));
                if (error.statusCode >= 500) {
                    markExperienceFailed('list issue rank failed', error);
                    return;
                }
            }
            markExperienceSuccess();
        },
        onSuccess: ()=>{
            markExperienceSuccess();
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'issue update', {
                fieldKey: 'rank'
            });
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'listRankIssue success');
        },
        onStart: ()=>{
            startExperience();
        }
    });
    const rankIssue = ({ newIndex: newIndex, oldIndex: oldIndex, issues: issues, issueToRank: issueToRank, variables: variables, skipUpdateCache: skipUpdateCache, instruction: instruction, relativeIssueOverride: relativeIssueOverride })=>{
        const params = {
            oldIndex: oldIndex,
            newIndex: newIndex,
            issues: issues,
            issueToRank: issueToRank,
            variables: variables,
            skipUpdateCache: skipUpdateCache,
            instruction: instruction,
            relativeIssueOverride: relativeIssueOverride
        };
        rankListViewIssue(params);
    };
    return {
        rankIssue: rankIssue,
        isBlockedBySorting: isBlockedBySorting,
        loading: loading
    };
};

});
parcelRegister("krCqe", function(module, exports) {

$parcel$export(module.exports, "useRankIssue", () => $25d51d58b2db8192$export$dbe3d15eebe7e64c);

var $5uXOq = parcelRequire("5uXOq");

var $dqDis = parcelRequire("dqDis");

var $eusud = parcelRequire("eusud");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $6s1PB = parcelRequire("6s1PB");

var $hlKA4 = parcelRequire("hlKA4");

var $eVIe2 = parcelRequire("eVIe2");
const $25d51d58b2db8192$var$performRestCall = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
performRequest, url, issueId, relativeIssueId, setLoading, onError, onSuccess)=>{
    performRequest(url, {
        body: JSON.stringify({
            issueId: Number(issueId),
            relativeIssueId: Number(relativeIssueId)
        })
    }).then(()=>{
        setLoading(false);
        onSuccess && onSuccess();
    }).catch((error)=>{
        setLoading(false);
        onError && onError(error);
    });
};
const $25d51d58b2db8192$export$dbe3d15eebe7e64c = ({ query: query, variables: variables, onError: onError, onSuccess: onSuccess, onStart: onStart })=>{
    const [loading, setLoading] = (0, $5uXOq.useState)(false);
    const { getCachedIssueById: getCachedIssueById, updateItemsInCache: updateItemsInCache } = (0, $hlKA4.useCacheActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const queryRef = (0, $5uXOq.useRef)(query);
    queryRef.current = query;
    const variablesRef = (0, $5uXOq.useRef)(variables);
    variablesRef.current = variables;
    const rank = (0, $5uXOq.useCallback)(({ issueId: issueId, relativeIssue: relativeIssue, rankCall: rankCall, skipUpdateCache: skipUpdateCache, variablesInput: variablesInput })=>{
        setLoading(true);
        onStart && onStart();
        const cacheVariables = variablesInput ?? variablesRef.current;
        const issueToRank = getCachedIssueById({
            issueId: issueId,
            query: queryRef.current,
            variables: cacheVariables
        });
        const relativeIssueRank = relativeIssue.rank;
        if (issueToRank && relativeIssueRank) {
            const optimisticRank = rankCall === 'rankBefore' ? (0, $dqDis.getPreviousRank)(relativeIssueRank) : (0, $dqDis.getNextRank)(relativeIssueRank);
            // Skip updating the rank field in cache if re-rank issue is part of the reparenting operation.
            if (!skipUpdateCache) updateItemsInCache({
                query: queryRef.current,
                variables: cacheVariables,
                issueIds: [
                    issueToRank?.issueId
                ],
                updateItem: ()=>(0, $eVIe2.getOptimisticRanked)(issueToRank, optimisticRank)
            });
            let issueKey;
            let workType;
            if (issueToRank.fields && (0, $6s1PB.expVal)('jira-itr-m4-exp-3', 'isEnabled', false)) for (const field of issueToRank.fields){
                if (field.fieldId === 'issuetype') workType = field.issueType.name;
                else if (field.fieldId === 'issuekey') issueKey = field.text;
            }
            $25d51d58b2db8192$var$performRestCall((0, $eusud.performPutRequest), `/rest/board-api/1/rank/${rankCall}`, Number(issueToRank.issueId), Number(relativeIssue.issueId), setLoading, (error)=>{
                onError(error, {
                    issueKey: issueKey,
                    workType: workType
                });
                updateItemsInCache({
                    query: query,
                    variables: cacheVariables,
                    issueIds: [
                        issueToRank?.issueId
                    ],
                    updateItem: (existingIssue)=>({
                            ...existingIssue,
                            fields: existingIssue.fields?.filter((field)=>field?.aliasFieldId !== 'rank').concat(issueToRank.fields?.find((field)=>field?.aliasFieldId === 'rank'))
                        })
                });
            }, ()=>{
                onSuccess && onSuccess();
                (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'issueRank succeeded');
            });
        } else setLoading(false);
    }, [
        createAnalyticsEvent,
        getCachedIssueById,
        onError,
        onStart,
        onSuccess,
        query,
        updateItemsInCache
    ]);
    const rankListViewIssue = (0, $5uXOq.useCallback)(({ newIndex: newIndex, oldIndex: oldIndex, issues: issues, issueToRank: prevIssueToRank, variables: variablesInput, skipUpdateCache: skipUpdateCache, instruction: instruction, relativeIssueOverride: relativeIssueOverride })=>{
        const rankingIssue = prevIssueToRank ?? issues[oldIndex];
        const { rankCall: rankCall, relativeIssue: relativeIssue } = (0, $eVIe2.getListViewRelativeIssueInfo)({
            newIndex: newIndex,
            oldIndex: oldIndex,
            issues: issues,
            instruction: instruction,
            relativeIssueOverride: relativeIssueOverride
        });
        if (relativeIssue) rank({
            relativeIssue: relativeIssue,
            issueId: rankingIssue.issueId,
            rankCall: rankCall,
            variablesInput: variablesInput,
            skipUpdateCache: skipUpdateCache
        });
    }, [
        rank
    ]);
    return {
        loading: loading,
        rank: rank,
        rankListViewIssue: rankListViewIssue
    };
};

});

parcelRegister("1vW2U", function(module, exports) {

$parcel$export(module.exports, "RANK_ISSUE_EXPERIENCE", () => $3cf701d1c6798b87$export$1cc6cf3582688fdd);
$parcel$export(module.exports, "RANK_ITEM_FAIL_GENERIC_FLAG", () => $3cf701d1c6798b87$export$8d4e704b1891708c);
$parcel$export(module.exports, "RANK_ITEM_FAIL_404_FLAG", () => $3cf701d1c6798b87$export$3d4660e65f55cbb9);
$parcel$export(module.exports, "RANK_ITEM_FAIL_404_FLAG_NEW", () => $3cf701d1c6798b87$export$c1cc3a4bbf199816);
$parcel$export(module.exports, "RANK_ITEM_FAIL_403_FLAG", () => $3cf701d1c6798b87$export$8e1bffd4c5401c9e);
$parcel$export(module.exports, "RANK_ITEM_FAIL_403_FLAG_NEW", () => $3cf701d1c6798b87$export$abad146ab2dd0701);

var $6s1PB = parcelRequire("6s1PB");

var $e5wyW = parcelRequire("e5wyW");

var $79389 = parcelRequire("79389");
const $3cf701d1c6798b87$var$PACKAGE_NAME = 'jiraBusinessList';
const $3cf701d1c6798b87$var$descriptionSelector = (0, $e5wyW.functionWithCondition)(()=>(0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false), ()=>(0, $79389.default).rankItem404ErrorDescriptionIssueTermRefresh, ()=>(0, $79389.default).rankItem404ErrorDescription);
const $3cf701d1c6798b87$export$1cc6cf3582688fdd = {
    experience: 'rankIssue',
    packageName: $3cf701d1c6798b87$var$PACKAGE_NAME,
    teamName: 'keystone'
};
const $3cf701d1c6798b87$export$8d4e704b1891708c = {
    type: 'error',
    title: (0, $79389.default).rankItemErrorTitle,
    description: (0, $79389.default).rankItemErrorDescription,
    messageId: 'business-list.controllers.use-rank-issue.rank-item-fail-generic-flag.error.error.rank-item-fail-generic-flag',
    messageType: 'transactional'
};
const $3cf701d1c6798b87$export$3d4660e65f55cbb9 = {
    type: 'error',
    title: (0, $79389.default).rankItemErrorTitle,
    description: $3cf701d1c6798b87$var$descriptionSelector(),
    messageId: 'business-list.controllers.use-rank-issue.rank-item-fail-404-flag.error.error.rank-item-fail-404-flag',
    messageType: 'transactional'
};
const $3cf701d1c6798b87$export$c1cc3a4bbf199816 = {
    type: 'error',
    title: (0, $79389.default).rankItemErrorTitle,
    description: (0, $79389.default).rankItem404ErrorDescriptionIssueTermRefresh,
    messageId: 'business-list.controllers.use-rank-issue.rank-item-fail-404-flag-new.error.error.rank-item-fail-404-flag-new',
    messageType: 'transactional'
};
const $3cf701d1c6798b87$export$8e1bffd4c5401c9e = {
    type: 'error',
    title: (0, $79389.default).rankItemErrorTitle,
    description: $3cf701d1c6798b87$var$descriptionSelector(),
    messageId: 'business-list.controllers.use-rank-issue.rank-item-fail-403-flag.error.error.rank-item-fail-403-flag',
    messageType: 'transactional'
};
const $3cf701d1c6798b87$export$abad146ab2dd0701 = {
    type: 'error',
    title: (0, $79389.default).rankItemErrorTitle,
    description: (0, $79389.default).rankItem403ErrorDescriptionIssueTermRefresh,
    messageId: 'business-list.controllers.use-rank-issue.rank-item-fail-403-flag-new.error.error.rank-item-fail-403-flag-new',
    messageType: 'transactional'
};

});
parcelRegister("79389", function(module, exports) {

$parcel$export(module.exports, "default", () => $98ca5710e85e7360$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $98ca5710e85e7360$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    rankItemErrorTitle: {
        "id": "business-list.controllers.use-rank-issue.rank-item-error-title",
        "defaultMessage": "Something's gone wrong"
    },
    rankItemErrorTitleIssueTerminologyRefreshM4: {
        "id": "business-list.controllers.use-rank-issue.rank-item-error-title-issue-terminology-refresh-m4",
        "defaultMessage": "We can\u2019t move {workType} {issueKey}"
    },
    rankItemErrorDescription: {
        "id": "business-list.controllers.use-rank-issue.rank-item-error-description",
        "defaultMessage": "Refresh the page and try again."
    },
    rankItem403ErrorDescription: {
        "id": "business-list.controllers.use-rank-issue.rank-item-403-error-description",
        "defaultMessage": "You don\u2019t have permission to move this issue. Contact a project admin."
    },
    rankItem404ErrorDescription: {
        "id": "business-list.controllers.use-rank-issue.rank-item-404-error-description",
        "defaultMessage": "We\u2019re having trouble moving this issue. To continue, refresh the page."
    },
    rankItem403ErrorDescriptionIssueTermRefresh: {
        "id": "business-list.controllers.use-rank-issue.rank-item-403-error-description-issue-term-refresh",
        "defaultMessage": "You don\u2019t have permission to move this work item. Contact your admin."
    },
    rankItem404ErrorDescriptionIssueTermRefresh: {
        "id": "business-list.controllers.use-rank-issue.rank-item-404-error-description-issue-term-refresh",
        "defaultMessage": "We\u2019re having trouble moving this work item. To continue, refresh the page."
    },
    rankItem404ErrorDescriptionIssueTerminologyRefreshM4: {
        "id": "business-list.controllers.use-rank-issue.rank-item-404-error-description-issue-terminology-refresh-m4",
        "defaultMessage": "Refresh and try again."
    }
});

});


parcelRegister("aqtm0", function(module, exports) {

$parcel$export(module.exports, "getRankItemFailGenericFlagWithWorkType", () => $094d47c40563aa55$export$a410554d50546f53);
$parcel$export(module.exports, "getRankItemFail404FlagWithWorkType", () => $094d47c40563aa55$export$2d4a7410e074364d);
$parcel$export(module.exports, "getRankItemFail403FlagWithWorkType", () => $094d47c40563aa55$export$c9c989d713e3215e);

var $79389 = parcelRequire("79389");
const $094d47c40563aa55$export$a410554d50546f53 = (intl, { issueKey: issueKey, workType: workType })=>{
    return {
        type: 'error',
        title: intl.formatMessage((0, $79389.default).rankItemErrorTitleIssueTerminologyRefreshM4, {
            issueKey: issueKey,
            workType: workType
        }),
        description: (0, $79389.default).rankItemErrorDescription,
        messageId: 'business-list.controllers.use-rank-issue.flag.error.rank-item-fail-generic-flag.error.error.rank-item-fail-generic-flag',
        messageType: 'transactional'
    };
};
const $094d47c40563aa55$export$2d4a7410e074364d = (intl, { issueKey: issueKey, workType: workType })=>{
    return {
        type: 'error',
        title: intl.formatMessage((0, $79389.default).rankItemErrorTitleIssueTerminologyRefreshM4, {
            issueKey: issueKey,
            workType: workType
        }),
        description: intl.formatMessage((0, $79389.default).rankItem404ErrorDescriptionIssueTerminologyRefreshM4, {
            issueKey: issueKey,
            workType: workType
        }),
        messageId: 'business-list.controllers.use-rank-issue.flag.error.rank-item-fail-generic-flag.error.error.rank-item-fail-generic-flag.1',
        messageType: 'transactional'
    };
};
const $094d47c40563aa55$export$c9c989d713e3215e = (intl, { issueKey: issueKey, workType: workType })=>{
    return {
        type: 'error',
        title: intl.formatMessage((0, $79389.default).rankItemErrorTitleIssueTerminologyRefreshM4, {
            issueKey: issueKey,
            workType: workType
        }),
        description: (0, $79389.default).rankItem403ErrorDescriptionIssueTermRefresh,
        messageId: 'business-list.controllers.use-rank-issue.flag.error.rank-item-fail-generic-flag.error.error.rank-item-fail-generic-flag.1.1',
        messageType: 'transactional'
    };
};

});



parcelRegister("1hMwG", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a7c463c0e640081$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8a7c463c0e640081$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    moveUp: {
        "id": "business-list.list-view.select-row-cell.drag-handle.move-up",
        "defaultMessage": "Move issue up"
    },
    movetoTop: {
        "id": "business-list.list-view.select-row-cell.drag-handle.moveto-top",
        "defaultMessage": "Move issue to the top"
    },
    moveDown: {
        "id": "business-list.list-view.select-row-cell.drag-handle.move-down",
        "defaultMessage": "Move issue down"
    },
    moveToBottom: {
        "id": "business-list.list-view.select-row-cell.drag-handle.move-to-bottom",
        "defaultMessage": "Move issue to the bottom"
    },
    moveUpIssueTermRefresh: {
        "id": "business-list.list-view.select-row-cell.drag-handle.move-up-issue-term-refresh",
        "defaultMessage": "Move work item up"
    },
    movetoTopIssueTermRefresh: {
        "id": "business-list.list-view.select-row-cell.drag-handle.moveto-top-issue-term-refresh",
        "defaultMessage": "Move work item to the top"
    },
    moveDownIssueTermRefresh: {
        "id": "business-list.list-view.select-row-cell.drag-handle.move-down-issue-term-refresh",
        "defaultMessage": "Move work item down"
    },
    moveToBottomIssueTermRefresh: {
        "id": "business-list.list-view.select-row-cell.drag-handle.move-to-bottom-issue-term-refresh",
        "defaultMessage": "Move work item to the bottom"
    },
    moveUpIssueTerminologyRefreshM4: {
        "id": "business-list.list-view.select-row-cell.drag-handle.move-up-issue-terminology-refresh-m4",
        "defaultMessage": "Move up"
    },
    movetoTopIssueTerminologyRefreshM4: {
        "id": "business-list.list-view.select-row-cell.drag-handle.moveto-top-issue-terminology-refresh-m4",
        "defaultMessage": "Move to the top"
    },
    moveDownIssueTerminologyRefreshM4: {
        "id": "business-list.list-view.select-row-cell.drag-handle.move-down-issue-terminology-refresh-m4",
        "defaultMessage": "Move down"
    },
    moveToBottomIssueTerminologyRefreshM4: {
        "id": "business-list.list-view.select-row-cell.drag-handle.move-to-bottom-issue-terminology-refresh-m4",
        "defaultMessage": "Move to the bottom"
    },
    addParent: {
        "id": "business-list.list-view.select-row-cell.drag-handle.add-parent",
        "defaultMessage": "Add parent"
    },
    changeParent: {
        "id": "business-list.list-view.select-row-cell.drag-handle.change-parent",
        "defaultMessage": "Change parent"
    },
    reorder: {
        "id": "business-list.list-view.select-row-cell.drag-handle.reorder",
        "defaultMessage": "Reorder"
    }
});

});


parcelRegister("d61RR", function(module, exports) {

$parcel$export(module.exports, "default", () => $3adb82dd2da115ea$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3adb82dd2da115ea$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    selectAll: {
        "id": "business-list.list-view.select-row-cell.select-all",
        "defaultMessage": "Select all issues"
    },
    selectIssue: {
        "id": "business-list.list-view.select-row-cell.select-issue",
        "defaultMessage": "Select {issueKey}"
    },
    selectAllIssueTermRefresh: {
        "id": "business-list.list-view.select-row-cell.select-all-issue-term-refresh",
        "defaultMessage": "Select all work items"
    }
});

});


parcelRegister("bRFLq", function(module, exports) {

$parcel$export(module.exports, "default", () => $8cccca969844fc83$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $8Rkzz = parcelRequire("8Rkzz");

var $1I7E8 = parcelRequire("1I7E8");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $4R6GH = parcelRequire("4R6GH");

var $b5lmY = parcelRequire("b5lmY");

var $e0a4D = parcelRequire("e0a4D");

var $8ad1n = parcelRequire("8ad1n");

var $jRzRt = parcelRequire("jRzRt");

var $k2xO1 = parcelRequire("k2xO1");

var $koVbs = parcelRequire("koVbs");

var $lQE94 = parcelRequire("lQE94");

var $2NMNM = parcelRequire("2NMNM");

var $dCm1o = parcelRequire("dCm1o");

var $eTDjN = parcelRequire("eTDjN");

var $lI995 = parcelRequire("lI995");

var $92WqQ = parcelRequire("92WqQ");

var $3KPLw = parcelRequire("3KPLw");
const $8cccca969844fc83$var$transformValueWithOptionId = (values)=>{
    if (!values) return [];
    const valuesArray = Array.isArray(values) ? values : [
        values
    ];
    return valuesArray.map(({ optionId: optionId, value: value })=>({
            value: value,
            label: value,
            optionId: optionId
        }));
};
const $8cccca969844fc83$var$getValue = (values)=>{
    if (Array.isArray(values)) return values[0]?.value ?? '';
    return values?.value ?? '';
};
const $8cccca969844fc83$var$transformLabels = (values)=>values.map(({ value: value })=>value).join(', ');
const $8cccca969844fc83$var$POPUP_OFFSET_NEW = [
    0,
    -(0, $eTDjN.DEFAULT_ROW_HEIGHT) - 1
];
const $8cccca969844fc83$var$SingleSelectCell = /*#__PURE__*/ (0, $5uXOq.memo)(({ issueKey: issueKey, fieldValue: fieldValue = null, width: width, fieldKey: fieldKey, fieldName: fieldName, isEditable: isEditable, fieldType: fieldType, isSelected: isSelected = false, wrapperRef: wrapperRef, issueType: issueType = '', issueTypeId: issueTypeId = '', editMode: editMode = false, setEditMode: setEditMode = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isHovering: isHovering = false, inputValue: inputValue, onInputChange: onInputChange, cellRef: cellRef })=>{
    const { latestFieldOptions: latestFieldOptions, getLatestFieldValue: getLatestFieldValue } = (0, $92WqQ.useCellOptions)({
        fieldId: fieldKey
    });
    const latestFieldValue = getLatestFieldValue(fieldValue);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [selectValue, setSelectValue] = (0, $5uXOq.useState)($8cccca969844fc83$var$transformValueWithOptionId(latestFieldValue));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [prevFieldValue, setPrevFieldValue] = (0, $5uXOq.useState)(fieldValue);
    const clearOnBlur = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        // to update value when cell data is updated elsewhere
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(fieldValue, prevFieldValue)) {
            setSelectValue($8cccca969844fc83$var$transformValueWithOptionId(latestFieldValue));
            setPrevFieldValue(fieldValue);
        }
    }, [
        fieldValue,
        latestFieldValue,
        prevFieldValue
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // to update selectValue when field config options data is updated elsewhere
        const latestSelectValue = $8cccca969844fc83$var$transformValueWithOptionId(getLatestFieldValue(selectValue));
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(selectValue, latestSelectValue)) setSelectValue(latestSelectValue);
    }, [
        getLatestFieldValue,
        selectValue
    ]);
    const [{ value: editValue, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $lQE94.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: $8cccca969844fc83$var$transformValueWithOptionId(fieldValue),
        onSuccess: (v)=>setSelectValue($8cccca969844fc83$var$transformValueWithOptionId(v)),
        onFailure: ()=>setSelectValue($8cccca969844fc83$var$transformValueWithOptionId(editValue))
    });
    const currentEditValue = $8cccca969844fc83$var$getValue(editValue);
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, $4R6GH.fg)('single-value-cell-loop-bug')) return;
        if ($8cccca969844fc83$var$getValue(selectValue) !== currentEditValue) setSelectValue($8cccca969844fc83$var$transformValueWithOptionId(editValue));
         // Regardless of what selectValue is at that point in time; if editValue's value changes, synchronize them.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentEditValue
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $4R6GH.fg)('single-value-cell-loop-bug')) return;
        if ($8cccca969844fc83$var$getValue(selectValue) !== $8cccca969844fc83$var$getValue(editValue)) setSelectValue($8cccca969844fc83$var$transformValueWithOptionId(editValue));
    }, [
        editValue,
        selectValue
    ]);
    const saveAndClose = (0, $5uXOq.useCallback)(()=>{
        setEditMode(false);
    }, [
        setEditMode
    ]);
    const handleSelectChange = (0, $5uXOq.useCallback)((newValue)=>{
        resetError();
        const selection = Array.isArray(newValue) ? newValue[0] : newValue;
        setSelectValue(selection ? [
            selection
        ] : []);
        saveValue(selection, null, createAnalyticsEvent({}));
        if (newValue != null) {
            setEditMode(false);
            wrapperRef && setTimeout(()=>{
                wrapperRef?.current?.focus();
            });
            clearOnBlur.current = false;
        } else clearOnBlur.current = true;
    }, [
        createAnalyticsEvent,
        resetError,
        saveValue,
        setEditMode,
        wrapperRef
    ]);
    const staticContent = (0, $5uXOq.useMemo)(()=>selectValue.map(({ value: value })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                as: "span",
                key: value,
                xcss: (0, $dCm1o.isVisualRefreshEnabled)() ? $8cccca969844fc83$var$selectFieldStyles : $8cccca969844fc83$var$selectFieldStylesOld
            }, value)), [
        selectValue
    ]); // we need to sort the options so that the selected value is at the top of the list
    // as the first option is hovered by default and will be selected if `Enter` is pressed
    // immediately after the select dropdown is shown
    const sortedSelectOptions = (0, $5uXOq.useMemo)(()=>{
        if (!selectValue.length) return latestFieldOptions;
        const selectedOptionIndex = latestFieldOptions.findIndex((option)=>option.value === selectValue[0].value);
        const sortedOptions = [
            ...latestFieldOptions
        ];
        if (selectedOptionIndex > -1) sortedOptions.splice(selectedOptionIndex, 1);
        sortedOptions.unshift(selectValue[0]);
        return sortedOptions;
    }, [
        latestFieldOptions,
        selectValue
    ]);
    const popupContent = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lI995.CellContentWrapper // -1px border left from gridcell
        ), {
            preferredWidth: width - 1,
            "data-testid": "business-list.ui.list-view.single-select-cell.cell-content-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8ad1n.default), {
            autoFocus: true,
            menuIsOpen: editMode,
            placeholder: formatMessage((0, $3KPLw.default).placeholder, {
                fieldName: fieldName
            }),
            isClearable: true,
            options: sortedSelectOptions,
            isMulti: false,
            onChange: handleSelectChange,
            value: selectValue,
            isInvalid: !!error,
            tabSelectsValue: true,
            inputValue: inputValue,
            onInputChange: onInputChange
        })), [
        width,
        editMode,
        formatMessage,
        fieldName,
        sortedSelectOptions,
        handleSelectChange,
        selectValue,
        error,
        inputValue,
        onInputChange
    ]);
    const popupTrigger = (0, $5uXOq.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
            ...triggerProps,
            xcss: $8cccca969844fc83$var$popupTriggerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k2xO1.TagListWrapper), {
            isEditable: isEditable
        }, selectValue.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: $8cccca969844fc83$var$transformLabels(selectValue),
            position: "top"
        }, staticContent))), [
        isEditable,
        selectValue,
        staticContent
    ]);
    const handleKeydown = (0, $5uXOq.useCallback)((e)=>{
        if (editMode) {
            if (selectValue[0] == null) {
                if (e.key === 'Escape') clearOnBlur.current = false;
                setSelectValue($8cccca969844fc83$var$transformValueWithOptionId(prevFieldValue));
            } else if (e.key === 'Delete') {
                saveValue(null, null, createAnalyticsEvent({}));
                setEditMode(false);
                setTimeout(()=>{
                    wrapperRef?.current?.focus();
                });
                clearOnBlur.current = false;
            }
        }
        return false;
    }, [
        createAnalyticsEvent,
        editMode,
        prevFieldValue,
        saveValue,
        selectValue,
        setEditMode,
        wrapperRef
    ]);
    const handleBlur = (0, $5uXOq.useCallback)(()=>{
        if (clearOnBlur.current) {
            saveValue(null, null, createAnalyticsEvent({}));
            clearOnBlur.current = false;
        }
        return false;
    }, [
        createAnalyticsEvent,
        saveValue
    ]);
    const cellOverrides = (0, $5uXOq.useMemo)(()=>()=>({
                onKeyDown: handleKeydown,
                onBlur: handleBlur
            }), [
        handleKeydown,
        handleBlur
    ]);
    (0, $5uXOq.useImperativeHandle)(cellRef, cellOverrides, [
        cellOverrides
    ]);
    const popupComponent = (0, $5uXOq.useMemo)(()=>(0, $jRzRt.getPopupComponentWithHeight)({
            numOptions: latestFieldOptions.length
        }), [
        latestFieldOptions
    ]);
    const cellContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isHovering || editMode || isSelected ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
        isOpen: editMode,
        placement: "bottom-start",
        autoFocus: false,
        offset: $8cccca969844fc83$var$POPUP_OFFSET_NEW,
        onClose: saveAndClose,
        popupComponent: popupComponent,
        content: popupContent,
        trigger: popupTrigger
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k2xO1.TagListWrapper), null, staticContent), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0a4D.FixItErrorFlag), {
        error: error,
        title: (0, $3KPLw.default).errorTitle,
        description: (0, $3KPLw.default).errorMessage,
        issueType: issueType,
        issueTypeId: issueTypeId,
        fieldId: fieldKey,
        fieldName: fieldName
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b5lmY.CellWrapper), {
        isEditable: isEditable,
        testId: "business-list.ui.list-view.single-select-cell.cell-container",
        hasPadding: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8cccca969844fc83$var$ContentWrapper, null, cellContent));
});
var $8cccca969844fc83$export$2e2bcd8739ae039 = $8cccca969844fc83$var$SingleSelectCell;
const $8cccca969844fc83$var$ContentWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: [
            $8cccca969844fc83$var$wrapperStyles
        ]
    }, children);
const $8cccca969844fc83$var$wrapperStyles = (0, $8CUq3.xcss)({
    width: '100%',
    height: '100%'
});
const $8cccca969844fc83$var$selectFieldStylesOld = (0, $8CUq3.xcss)({
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    borderRadius: 'border.radius',
    margin: 'space.050',
    paddingLeft: 'space.050',
    paddingRight: 'space.050',
    backgroundColor: 'color.background.neutral',
    color: 'color.text'
});
const $8cccca969844fc83$var$selectFieldStyles = (0, $8CUq3.xcss)({
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    color: 'color.text',
    margin: 'space.050',
    paddingLeft: 'space.050',
    paddingRight: 'space.050',
    backgroundColor: 'color.background.neutral.subtle',
    boxSizing: 'border-box',
    borderRadius: 'border.radius',
    border: 'solid',
    borderWidth: 'border.width',
    borderColor: 'color.border'
});
const $8cccca969844fc83$var$popupTriggerStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.neutral.subtle',
    padding: 'space.0',
    width: '100%'
});

});
parcelRegister("92WqQ", function(module, exports) {

$parcel$export(module.exports, "useCellOptions", () => $19f8277dc3393798$export$60a5a2d5b09fbd7b);

var $1T2vX = parcelRequire("1T2vX");
const $19f8277dc3393798$export$60a5a2d5b09fbd7b = ({ fieldId: fieldId })=>{
    const { data: { fields: fields } } = (0, $1T2vX.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const fieldConfigOptions = fields.filter((f)=>f.id === fieldId)?.[0]?.fieldConfig?.selectOptions ?? [];
    const getLatestFieldValue = (fieldValue)=>{
        const optionMap = {};
        fieldConfigOptions?.forEach((field)=>{
            const { value: value, optionId: optionId } = field;
            optionMap[String(optionId)] = value;
        });
        let updated = false;
        const updatedFieldValue = [];
        const fieldValueArray = Array.isArray(fieldValue) ? fieldValue : [
            fieldValue
        ];
        fieldValueArray?.forEach((field)=>{
            if (field) {
                const { optionId: optionId, value: value } = field;
                const strOptionId = String(optionId);
                if (value !== optionMap[strOptionId]) updated = true;
                updatedFieldValue.push({
                    optionId: optionId,
                    value: optionMap[strOptionId] ?? value,
                    label: optionMap[strOptionId] ?? value
                });
            }
        });
        if (!Array.isArray(fieldValue)) return updated ? updatedFieldValue[0] : fieldValue;
        return updated ? updatedFieldValue : fieldValue;
    };
    return {
        latestFieldOptions: fieldConfigOptions || [],
        getLatestFieldValue: getLatestFieldValue
    };
};

});

parcelRegister("3KPLw", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8f2cb9ffc307ad9$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f8f2cb9ffc307ad9$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorTitle: {
        "id": "business-list.list-view.single-select-cell.error-title",
        "defaultMessage": "We couldn't set the select value"
    },
    errorMessage: {
        "id": "business-list.list-view.single-select-cell.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    },
    placeholder: {
        "id": "business-list.list-view.single-select-cell.placeholder",
        "defaultMessage": "Select {fieldName}"
    }
});

});


parcelRegister("c9UvN", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc464360d7e190ae$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6tfhf = parcelRequire("6tfhf");

var $1I7E8 = parcelRequire("1I7E8");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $d9xxV = parcelRequire("d9xxV");

var $3bDjY = parcelRequire("3bDjY");

var $b5lmY = parcelRequire("b5lmY");

var $e0a4D = parcelRequire("e0a4D");

var $jRzRt = parcelRequire("jRzRt");

var $k2xO1 = parcelRequire("k2xO1");

var $gULOk = parcelRequire("gULOk");

var $dMnMc = parcelRequire("dMnMc");

var $koVbs = parcelRequire("koVbs");

var $a29sl = parcelRequire("a29sl");

var $2NMNM = parcelRequire("2NMNM");

var $g5X3G = parcelRequire("g5X3G");

var $eTDjN = parcelRequire("eTDjN");

var $9u99d = parcelRequire("9u99d");

var $3dLJg = parcelRequire("3dLJg");

var $lWtBl = parcelRequire("lWtBl");
const $fc464360d7e190ae$var$POPUP_OFFSET = [
    0,
    -(0, $eTDjN.DEFAULT_ROW_HEIGHT) - 1
];
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $fc464360d7e190ae$var$noop = ()=>{};
const $fc464360d7e190ae$var$SprintCell = /*#__PURE__*/ (0, $5uXOq.memo)(({ fieldKey: fieldKey, issueKey: issueKey, issueId: issueId, isEditable: isEditable, fieldValue: fieldValue, width: width, wrapperRef: wrapperRef, fieldName: fieldName = '', issueType: issueType = '', issueTypeId: issueTypeId = '', issueTypeLevel: issueTypeLevel, editMode: editMode = false, isHovering: isHovering = false, isSelected: isSelected = false, setEditMode: setEditMode = $fc464360d7e190ae$var$noop, inputValue: inputValue, onInputChange: onInputChange, cellRef: cellRef })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const boardId = (0, $dMnMc.getBoardId)(typeof window !== 'undefined' ? window.location.href : '');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [{ issuesMap: issuesMap }] = (0, $9u99d.useHierarchyStore)();
    const initialValue = (0, $5uXOq.useMemo)(()=>{
        if (fieldValue && Array.isArray(fieldValue) && fieldValue.length) {
            const initialSprintValue = fieldValue[0];
            if (initialSprintValue) return [
                {
                    id: Number(initialSprintValue.sprintId),
                    name: String(initialSprintValue.name),
                    state: String(initialSprintValue.state),
                    boardId: Number(boardId)
                }
            ];
        }
        return undefined;
    }, [
        boardId,
        fieldValue
    ]);
    const [{ value: sprintValue, error: error }, { saveValue: saveValue }] = (0, $a29sl.useSprintField)({
        fieldKey: fieldKey,
        initialValue: initialValue,
        onSuccess: $fc464360d7e190ae$var$noop,
        onFailure: $fc464360d7e190ae$var$noop,
        issueKey: (0, $g5X3G.toIssueKey)(issueKey),
        issueId: issueId
    });
    const currentValue = sprintValue.length ? sprintValue[0] : undefined;
    const [selectValue, setSelectValue] = (0, $5uXOq.useState)(currentValue);
    const clearOnBlur = (0, $5uXOq.useRef)(false);
    if (currentValue?.id !== selectValue?.id && !editMode) setSelectValue(currentValue);
    const popupComponent = (0, $5uXOq.useMemo)(()=>(0, $jRzRt.getPopupComponentWithHeight)({
            numOptions: 0,
            hasFooter: false
        }), []);
    const handleClose = (0, $5uXOq.useCallback)(()=>{
        setEditMode(false);
    }, [
        setEditMode
    ]);
    const saveCellValue = (0, $5uXOq.useCallback)(async (value, meta, analyticsEvent)=>{
        setSelectValue(value[0]);
        if (value[0] != null) {
            saveValue(value, meta, analyticsEvent);
            clearOnBlur.current = false;
        } else clearOnBlur.current = true;
    }, [
        saveValue
    ]);
    const handleKeydown = (0, $5uXOq.useCallback)((e)=>{
        if (editMode) {
            if (selectValue == null) {
                if (e.key === 'Escape') clearOnBlur.current = false;
                setSelectValue(currentValue);
            } else if (e.key === 'Delete') {
                saveValue([], null, createAnalyticsEvent({}));
                setEditMode(false);
                setTimeout(()=>{
                    wrapperRef?.current?.focus();
                });
                clearOnBlur.current = false;
            }
        }
        return false;
    }, [
        createAnalyticsEvent,
        currentValue,
        editMode,
        saveValue,
        selectValue,
        setEditMode,
        wrapperRef
    ]);
    const handleBlur = (0, $5uXOq.useCallback)(()=>{
        if (clearOnBlur.current) {
            saveValue([], null, createAnalyticsEvent({}));
            clearOnBlur.current = false;
        }
        return false;
    }, [
        createAnalyticsEvent,
        saveValue
    ]);
    const cellOverrides = (0, $5uXOq.useMemo)(()=>()=>({
                onKeyDown: handleKeydown,
                onBlur: handleBlur
            }), [
        handleKeydown,
        handleBlur
    ]);
    (0, $5uXOq.useImperativeHandle)(cellRef, cellOverrides, [
        cellOverrides
    ]);
    const popupContent = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lWtBl.SprintPopupContent), {
            wrapperRef: wrapperRef,
            width: width,
            currentSprint: selectValue,
            onCloseMenu: handleClose,
            saveValue: saveCellValue,
            issueTypeLevel: issueTypeLevel,
            inputValue: inputValue,
            onInputChange: onInputChange,
            label: formatMessage((0, $3dLJg.default).placeholder)
        }), [
        wrapperRef,
        width,
        selectValue,
        handleClose,
        saveCellValue,
        issueTypeLevel,
        inputValue,
        onInputChange,
        formatMessage
    ]);
    const staticContent = (0, $5uXOq.useMemo)(()=>{
        const sprintName = currentValue?.name;
        if (currentValue?.state === 'CLOSED' && sprintName) {
            const issue = issuesMap.get(issueId.toString());
            if (issue && issue.status?.categoryId !== (0, $gULOk.StatusCategoryIds)[(0, $gULOk.StatusCategoryTypes).DONE].toString()) // closed sprints should not be shown if the status is not done
            // means that this ticket is on the backlog
            return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d9xxV.default), {
                text: sprintName,
                color: "greenLight",
                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                    xcss: $fc464360d7e190ae$var$iconWrapperStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6tfhf))), {
                    LEGACY_size: "small",
                    label: formatMessage((0, $3dLJg.default).completedSprintTooltip, {
                        sprintName: currentValue.name
                    })
                }))
            });
        }
        return currentValue && sprintName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d9xxV.default), {
            text: sprintName
        });
    }, [
        currentValue,
        formatMessage,
        issueId,
        issuesMap
    ]);
    const popupTrigger = (0, $5uXOq.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
            ...triggerProps,
            xcss: $fc464360d7e190ae$var$popupTriggerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k2xO1.TagListWrapper), {
            isEditable: isEditable
        }, staticContent && currentValue?.state === 'CLOSED' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formatMessage((0, $3dLJg.default).completedSprintTooltip, {
                sprintName: currentValue.name
            }),
            position: "top"
        }, staticContent) : staticContent)), [
        isEditable,
        staticContent,
        currentValue,
        formatMessage
    ]);
    const cellContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isHovering || editMode || isSelected ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
        isOpen: editMode,
        placement: "bottom-start",
        autoFocus: false,
        offset: $fc464360d7e190ae$var$POPUP_OFFSET,
        popupComponent: popupComponent,
        content: popupContent,
        trigger: popupTrigger
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k2xO1.TagListWrapper), null, staticContent), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0a4D.FixItErrorFlag), {
        error: error,
        title: (0, $3dLJg.default).errorTitle,
        description: (0, $3dLJg.default).errorMessage,
        issueType: issueType,
        issueTypeId: issueTypeId,
        fieldId: fieldKey,
        fieldName: fieldName
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b5lmY.CellWrapper), {
        isEditable: isEditable,
        hasPadding: false,
        testId: "business-list.ui.list-view.sprint-cell.cell-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fc464360d7e190ae$var$ContentWrapper, null, cellContent));
});
var $fc464360d7e190ae$export$2e2bcd8739ae039 = $fc464360d7e190ae$var$SprintCell;
const $fc464360d7e190ae$var$ContentWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: [
            $fc464360d7e190ae$var$wrapperStyles
        ]
    }, children);
const $fc464360d7e190ae$var$iconWrapperStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.025',
    marginLeft: 'space.025'
});
const $fc464360d7e190ae$var$wrapperStyles = (0, $8CUq3.xcss)({
    width: '100%',
    height: '100%'
});
const $fc464360d7e190ae$var$popupTriggerStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.neutral.subtle',
    padding: 'space.0'
});

});
parcelRegister("6tfhf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::569a9d4c43cf146ba3fe04b1751c4915>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4b614d420cef9065$var$_react = $4b614d420cef9065$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $4b614d420cef9065$var$_checkCircle = $4b614d420cef9065$var$_interopRequireDefault((parcelRequire("34OIV")));

var $4b614d420cef9065$var$_checkCircleOutline = $4b614d420cef9065$var$_interopRequireDefault((parcelRequire("6tSZM")));
function $4b614d420cef9065$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckCircleIcon.
 * This component is CheckCircleIcon, with `UNSAFE_fallbackIcon` set to "CheckCircleOutlineIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: completed items, productivity emoji category. Completed task work type in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4b614d420cef9065$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $4b614d420cef9065$var$_react.default.createElement($4b614d420cef9065$var$_checkCircle.default, Object.assign({
        LEGACY_fallbackIcon: $4b614d420cef9065$var$_checkCircleOutline.default
    }, props));
$4b614d420cef9065$var$CheckCircleIcon.Name = 'CheckCircleIconMigration';
var $4b614d420cef9065$var$_default = module.exports.default = $4b614d420cef9065$var$CheckCircleIcon;

});
parcelRegister("6tSZM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4b801c7587081e8b$var$_react = $4b801c7587081e8b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $4b801c7587081e8b$var$_checkCircle = $4b801c7587081e8b$var$_interopRequireDefault((parcelRequire("34OIV")));
function $4b801c7587081e8b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4b801c7587081e8b$var$CheckCircleOutlineIcon = (props)=>/*#__PURE__*/ $4b801c7587081e8b$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16m0 2C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10"/><path d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $4b801c7587081e8b$var$_checkCircle.default
    }));
$4b801c7587081e8b$var$CheckCircleOutlineIcon.displayName = 'CheckCircleOutlineIcon';
var $4b801c7587081e8b$var$_default = module.exports.default = $4b801c7587081e8b$var$CheckCircleOutlineIcon;

});


parcelRegister("3dLJg", function(module, exports) {

$parcel$export(module.exports, "default", () => $890b85c3e24c0170$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $890b85c3e24c0170$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorTitle: {
        "id": "business-list.list-view.sprint-cell.error-title",
        "defaultMessage": "We couldn't set the sprint value"
    },
    errorMessage: {
        "id": "business-list.list-view.sprint-cell.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    },
    placeholder: {
        "id": "business-list.list-view.sprint-cell.placeholder",
        "defaultMessage": "Select sprint"
    },
    completedSprintTooltip: {
        "id": "business-list.list-view.sprint-cell.completed-sprint-tooltip",
        "defaultMessage": "{sprintName} is complete"
    }
});

});

parcelRegister("lWtBl", function(module, exports) {

$parcel$export(module.exports, "SprintPopupContent", () => $dda5a4bc5db7630b$export$48152b89ed0e4e13);

var $5uXOq = parcelRequire("5uXOq");

var $daQYX = parcelRequire("daQYX");

var $8ad1n = parcelRequire("8ad1n");

var $dMnMc = parcelRequire("dMnMc");

var $jcw0u = parcelRequire("jcw0u");

var $koVbs = parcelRequire("koVbs");

var $249dD = parcelRequire("249dD");

var $bW9R0 = parcelRequire("bW9R0");

var $2NMNM = parcelRequire("2NMNM");

var $8q5UJ = parcelRequire("8q5UJ");

var $lI995 = parcelRequire("lI995");

var $9hpga = parcelRequire("9hpga");

var $cYmr7 = parcelRequire("cYmr7");

var $kBrmp = parcelRequire("kBrmp");
const $dda5a4bc5db7630b$var$AUTO_COMPLETE_URL = '/rest/greenhopper/1.0/sprint/picker?query=';
const $dda5a4bc5db7630b$var$SPRINT_HELP_ARTICLE = {
    href: 'https://support.atlassian.com/jira-software-cloud/docs/sprints-in-next-gen-projects/',
    helpArticleId: '4czk5C61YP1n5wpBCfITEN'
};
const $dda5a4bc5db7630b$export$48152b89ed0e4e13 = /*#__PURE__*/ (0, $5uXOq.memo)(({ wrapperRef: wrapperRef, width: width, onCloseMenu: onCloseMenu, currentSprint: currentSprint, saveValue: saveValue, issueTypeLevel: issueTypeLevel, inputValue: inputValue, onInputChange: onInputChange, label: label })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const projectData = (0, $daQYX.useProject)();
    const projectKey = projectData.key;
    const boardId = (0, $dMnMc.getBoardId)(typeof window !== 'undefined' ? window.location.href : '');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [options, setOptions] = (0, $5uXOq.useState)([]);
    const [fetchError, setFetchError] = (0, $5uXOq.useState)();
    const [{ isLoadingSuggestions: isLoadingSuggestions }, { getSprintSuggestions: getSprintSuggestions, setIsLoadingSuggestions: setIsLoadingSuggestions }] = (0, $bW9R0.useSprintSuggestions)({
        getSuggestions: (0, $kBrmp.getSprintSuggestions)
    });
    const fetchSuggestions = (0, $5uXOq.useCallback)(()=>{
        setIsLoadingSuggestions(true);
        getSprintSuggestions($dda5a4bc5db7630b$var$AUTO_COMPLETE_URL, '', projectKey).then((suggestionsFromServer)=>{
            setIsLoadingSuggestions(false);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const sprintOptions = (0, $249dD.transformSuggestions)({
                ...suggestionsFromServer,
                suggestions: suggestionsFromServer?.suggestions?.filter((option)=>option?.id !== Number(currentSprint?.id)),
                allMatches: suggestionsFromServer?.allMatches?.filter((option)=>option?.id !== Number(currentSprint?.id))
            }, formatMessage);
            setOptions(sprintOptions);
        }).catch((error)=>{
            setIsLoadingSuggestions(false);
            setFetchError(error);
            (0, $jcw0u.default)({
                meta: {
                    id: 'fetchSprintSuggestions',
                    packageName: 'jiraBusinessList',
                    teamName: 'keystone'
                },
                attributes: {
                    message: 'Error trying to fetch sprint suggestions'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        });
    }, [
        currentSprint?.id,
        formatMessage,
        getSprintSuggestions,
        projectKey,
        setIsLoadingSuggestions
    ]);
    const isSubTask = issueTypeLevel === -1;
    (0, $5uXOq.useEffect)(()=>{
        if (!isSubTask) fetchSuggestions();
    }, [
        fetchSuggestions,
        isSubTask
    ]);
    const handleChange = (0, $5uXOq.useCallback)((option)=>{
        saveValue(option != null ? [
            (0, $kBrmp.mapOptionToSprint)(option, boardId)
        ] : [], null, createAnalyticsEvent({}));
        if (option != null) {
            onCloseMenu();
            setTimeout(()=>{
                wrapperRef?.current?.focus();
            });
        }
    }, [
        boardId,
        createAnalyticsEvent,
        onCloseMenu,
        saveValue,
        wrapperRef
    ]);
    const selectComponents = (0, $5uXOq.useMemo)(()=>{
        if (isSubTask) return {
            NoOptionsMessage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9hpga.default), {
                    message: formatMessage((0, $cYmr7.default).cannotEditSubtasks),
                    analyticsCellName: "sprint",
                    helpArticle: $dda5a4bc5db7630b$var$SPRINT_HELP_ARTICLE,
                    onHandleLearnMore: onCloseMenu
                })
        };
        if (fetchError) return {
            NoOptionsMessage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8q5UJ.default), {
                    onTryAgain: fetchSuggestions,
                    message: formatMessage((0, $cYmr7.default).cannotLoadSprintSuggestions),
                    analyticsCellName: "sprint"
                })
        };
        return {};
    }, [
        fetchError,
        fetchSuggestions,
        formatMessage,
        isSubTask,
        onCloseMenu
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lI995.CellContentWrapper), {
        "data-testid": "business-list.ui.list-view.sprint-cell.popup-content.cell-content-wrapper",
        preferredWidth: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8ad1n.default), {
        autoFocus: true,
        menuIsOpen: true,
        isClearable: true,
        placeholder: formatMessage((0, $cYmr7.default).placeholder),
        options: options,
        onChange: handleChange,
        isInvalid: false,
        value: currentSprint ? [
            {
                label: currentSprint.name,
                value: currentSprint.id.toString()
            }
        ] : [],
        isLoading: isLoadingSuggestions,
        isMulti: false,
        components: selectComponents,
        tabSelectsValue: true,
        inputValue: inputValue,
        onInputChange: onInputChange,
        "aria-label": label
    }));
});

});
parcelRegister("bW9R0", function(module, exports) {

$parcel$export(module.exports, "useSprintSuggestions", () => $76a69867a9473261$export$16d0ab78a0b529dc);

var $5uXOq = parcelRequire("5uXOq");

var $ebyGx = parcelRequire("ebyGx");

var $eusud = parcelRequire("eusud");

const $76a69867a9473261$var$defaultParams = (0, $ebyGx.stringify)({
    maxActiveSprints: (0, $546eebefed97ea78$export$7112c73100e3ee45),
    maxResults: (0, $546eebefed97ea78$export$f6b2881bc1090cea)
});
const $76a69867a9473261$export$6945d45e210d19eb = async (autoCompleteUrl, query, projectKey)=>{
    let queryString;
    if (projectKey !== null && projectKey !== undefined) queryString = `${autoCompleteUrl}${encodeURIComponent(query)}&projectKey=${encodeURIComponent(projectKey)}&${$76a69867a9473261$var$defaultParams}`;
    else queryString = `${autoCompleteUrl}${encodeURIComponent(query)}&${$76a69867a9473261$var$defaultParams}`;
    return (0, $eusud.performGetRequest)(queryString);
};
const $76a69867a9473261$export$16d0ab78a0b529dc = (props)=>{
    const { getSuggestions: getSuggestions = $76a69867a9473261$export$6945d45e210d19eb } = props || {};
    const [isLoadingSuggestions, setIsLoadingSuggestions] = (0, $5uXOq.useState)(false);
    const getSprintSuggestions = (0, $5uXOq.useCallback)(async (autoCompleteUrl, query, projectKey)=>{
        try {
            const response = await getSuggestions(autoCompleteUrl, query, projectKey);
            setIsLoadingSuggestions(false);
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setIsLoadingSuggestions(false);
            throw error;
        }
    }, [
        getSuggestions,
        setIsLoadingSuggestions
    ]);
    const actions = (0, $5uXOq.useMemo)(()=>({
            getSprintSuggestions: getSprintSuggestions,
            setIsLoadingSuggestions: setIsLoadingSuggestions
        }), [
        getSprintSuggestions,
        setIsLoadingSuggestions
    ]);
    return [
        {
            isLoadingSuggestions: isLoadingSuggestions
        },
        actions
    ];
};

});
const $546eebefed97ea78$export$f27038d72181627e = '/rest/greenhopper/1.0/sprint/picker?query=';
const $546eebefed97ea78$export$7112c73100e3ee45 = 5;
const $546eebefed97ea78$export$f6b2881bc1090cea = 10;


parcelRegister("8q5UJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9920cddfd7fbcb2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9yOBd = parcelRequire("9yOBd");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $g67r8 = parcelRequire("g67r8");
const $c9920cddfd7fbcb2$var$LazySelectFetchError = ({ onTryAgain: onTryAgain, message: message, analyticsCellName: analyticsCellName })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleOnTryAgain = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'tryAgain', {
            cell: analyticsCellName
        });
        onTryAgain && onTryAgain();
    }, [
        analyticsCellName,
        createAnalyticsEvent,
        onTryAgain
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: $c9920cddfd7fbcb2$var$wrapperStyles,
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $c9920cddfd7fbcb2$var$errorMessageWrapperStyles
    }, message), onTryAgain && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yOBd.default), {
        appearance: "link",
        spacing: "none",
        onClick: (event)=>{
            event.stopPropagation();
            handleOnTryAgain();
        },
        theme: (currentTheme, theme)=>{
            const buttonTheme = currentTheme(theme);
            return {
                ...buttonTheme,
                buttonStyles: {
                    ...buttonTheme.buttonStyles,
                    alignItems: 'center'
                }
            };
        }
    }, formatMessage((0, $g67r8.default).tryAgain))));
};
var $c9920cddfd7fbcb2$export$2e2bcd8739ae039 = $c9920cddfd7fbcb2$var$LazySelectFetchError;
const $c9920cddfd7fbcb2$var$wrapperStyles = (0, $8CUq3.xcss)({
    height: "var(--ds-space-600, 48px)",
    paddingLeft: 'space.150',
    paddingRight: 'space.150'
});
const $c9920cddfd7fbcb2$var$errorMessageWrapperStyles = (0, $8CUq3.xcss)({
    marginRight: 'space.100'
});

});
parcelRegister("g67r8", function(module, exports) {

$parcel$export(module.exports, "default", () => $133d7df961eec9be$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $133d7df961eec9be$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    tryAgain: {
        "id": "business-list.common.lazy-select-fetch-error.try-again",
        "defaultMessage": "Try again"
    }
});

});


parcelRegister("9hpga", function(module, exports) {

$parcel$export(module.exports, "default", () => $c77fd297c3e380f1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $5Zxxp = parcelRequire("5Zxxp");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $hjSul = parcelRequire("hjSul");

var $9x7UV = parcelRequire("9x7UV");
const $c77fd297c3e380f1$var$SelectEditError = ({ helpArticle: helpArticle, message: message, analyticsCellName: analyticsCellName, onHandleLearnMore: onHandleLearnMore })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleLearnMore = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'learnMore', {
            cell: analyticsCellName
        });
        onHandleLearnMore && onHandleLearnMore();
    }, [
        analyticsCellName,
        createAnalyticsEvent,
        onHandleLearnMore
    ]);
    const { href: href, helpArticleId: helpArticleId } = helpArticle;
    const fallbackAnchor = (0, $5uXOq.useMemo)(()=>href !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjSul.Link), {
            href: href,
            onClick: handleLearnMore
        }, formatMessage((0, $9x7UV.default).learnMore)), [
        formatMessage,
        handleLearnMore,
        href
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $c77fd297c3e380f1$var$wrapperStyles
    }, message, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "span",
        xcss: $c77fd297c3e380f1$var$helpLinkStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Zxxp.HelpPanelLink), {
        articleId: helpArticleId,
        type: "HELP_ARTICLE",
        appearance: "link",
        spacing: "none",
        onClick: handleLearnMore,
        fallbackComponent: fallbackAnchor
    }, formatMessage((0, $9x7UV.default).learnMore))));
};
var $c77fd297c3e380f1$export$2e2bcd8739ae039 = $c77fd297c3e380f1$var$SelectEditError;
const $c77fd297c3e380f1$var$wrapperStyles = (0, $8CUq3.xcss)({
    height: "var(--ds-space-600, 48px)",
    paddingLeft: 'space.150',
    paddingRight: 'space.150'
});
const $c77fd297c3e380f1$var$helpLinkStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.100'
});

});
parcelRegister("9x7UV", function(module, exports) {

$parcel$export(module.exports, "default", () => $b783b04dfd5628dd$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b783b04dfd5628dd$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    learnMore: {
        "id": "business-list.common.select-edit-error.learn-more",
        "defaultMessage": "Learn more"
    }
});

});


parcelRegister("cYmr7", function(module, exports) {

$parcel$export(module.exports, "default", () => $0eb2a6421c0780c2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0eb2a6421c0780c2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    placeholder: {
        "id": "business-list.list-view.sprint-cell.popup-content.placeholder",
        "defaultMessage": "Select sprint"
    },
    cannotLoadSprintSuggestions: {
        "id": "business-list.list-view.sprint-cell.popup-content.cannot-load-sprint-suggestions",
        "defaultMessage": "Couldn't load the sprints."
    },
    cannotEditSubtasks: {
        "id": "business-list.list-view.sprint-cell.popup-content.cannot-edit-subtasks",
        "defaultMessage": "Subtasks remain in the same sprint as their parent task."
    }
});

});

parcelRegister("kBrmp", function(module, exports) {

$parcel$export(module.exports, "getSprintSuggestions", () => $992e6f25010ccbd7$export$a5ccca5b51d5d670);
$parcel$export(module.exports, "mapOptionToSprint", () => $992e6f25010ccbd7$export$dc6ac67640c50628);

var $eusud = parcelRequire("eusud");
const $992e6f25010ccbd7$export$c1102c96d31ebe29 = (autoCompleteUrl, query, projectKey)=>{
    const queryString = `${autoCompleteUrl}${encodeURIComponent(query)}`;
    if (projectKey !== null && projectKey !== undefined) return `${queryString}&projectKey=${encodeURIComponent(projectKey)}`;
    return queryString;
};
const $992e6f25010ccbd7$export$a5ccca5b51d5d670 = async (autoCompleteUrl, query, projectKey)=>(0, $eusud.performGetRequest)($992e6f25010ccbd7$export$c1102c96d31ebe29(autoCompleteUrl, query, projectKey));
const $992e6f25010ccbd7$export$dc6ac67640c50628 = (option, boardId)=>({
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        name: option.label,
        id: Number(option.value),
        boardId: Number(boardId),
        state: option.state
    });

});



parcelRegister("lup7l", function(module, exports) {

$parcel$export(module.exports, "default", () => $045d9dc4d0939a23$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ajpes = parcelRequire("ajpes");

var $8Rkzz = parcelRequire("8Rkzz");

var $eGdV2 = parcelRequire("eGdV2");

var $3u0c5 = parcelRequire("3u0c5");

var $1I7E8 = parcelRequire("1I7E8");

var $dC5iT = parcelRequire("dC5iT");
var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $bChGW = parcelRequire("bChGW");


var $daQYX = parcelRequire("daQYX");

var $b5lmY = parcelRequire("b5lmY");

var $8ad1n = parcelRequire("8ad1n");

var $jRzRt = parcelRequire("jRzRt");

var $gULOk = parcelRequire("gULOk");

var $gwIPs = parcelRequire("gwIPs");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $9RrVQ = parcelRequire("9RrVQ");

var $bUXoM = parcelRequire("bUXoM");

var $2NMNM = parcelRequire("2NMNM");

var $9OXo1 = parcelRequire("9OXo1");

var $dCm1o = parcelRequire("dCm1o");

var $fJ83Q = parcelRequire("fJ83Q");

var $N7jPX = parcelRequire("N7jPX");


var $4Gswu = parcelRequire("4Gswu");

var $gyeeU = parcelRequire("gyeeU");

var $eTDjN = parcelRequire("eTDjN");

var $8q5UJ = parcelRequire("8q5UJ");

var $lI995 = parcelRequire("lI995");

var $mk7k0 = parcelRequire("mk7k0");

var $hGiaW = parcelRequire("hGiaW");

var $fr1UQ = parcelRequire("fr1UQ");

var $3AZQW = parcelRequire("3AZQW");

var $5uSmq = parcelRequire("5uSmq");
const $045d9dc4d0939a23$var$serviceProjectType = 'business';
const $045d9dc4d0939a23$var$CREATE_STATUS = 'createStatus';
const $045d9dc4d0939a23$var$EDIT_STATUS = 'editStatus';
const $045d9dc4d0939a23$var$fireExposureForCombinedImpactAAExperiment = ()=>{
    (0, $6s1PB.expVal)('combined_adoption_configuration_experiment_aa', 'isEnabled', false);
    return true;
};
const $045d9dc4d0939a23$var$Option = ({ children: children, ...props })=>{
    if (props.data.optionType === $045d9dc4d0939a23$var$CREATE_STATUS) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fJ83Q.OptionWithButtonStyle), {
        ...props,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _16qsglyw"
        ])
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Option, props, children);
};
const $045d9dc4d0939a23$var$CustomOptionToSupportStickyFooter = ({ children: children, menuListRef: menuListRef, ...props })=>{
    if ([
        $045d9dc4d0939a23$var$CREATE_STATUS,
        $045d9dc4d0939a23$var$EDIT_STATUS
    ].includes(props.data.optionType)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fJ83Q.OptionWithButtonStyle), {
        ...props,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _16qsglyw"
        ])
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Gswu.OptionWithAutoKeyboardScroll), {
        ...props,
        containerRef: menuListRef,
        className: (0, $bwpsq.default)([
            "_1rjcu2gc"
        ])
    }, children);
};
const $045d9dc4d0939a23$export$60035e0a086aefd4 = /*#__PURE__*/ (0, $5uXOq.memo)(({ option: option, hasDuplicateStatusesInTargets: hasDuplicateStatusesInTargets })=>{
    if (option.transition == null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($045d9dc4d0939a23$var$OptionWrapper, null, hasDuplicateStatusesInTargets ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($045d9dc4d0939a23$var$TransitionWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($045d9dc4d0939a23$var$TransitionLabel, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($045d9dc4d0939a23$var$TransitionName, null, option.transition?.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eGdV2))), {
        LEGACY_size: "small",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($045d9dc4d0939a23$var$StatusName, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
        isBold: (0, $dCm1o.isVisualRefreshEnabled)(),
        appearance: (0, $5uSmq.toAppearance)(option.transition.to)
    }, option.transition.to.name)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
        isBold: (0, $dCm1o.isVisualRefreshEnabled)(),
        appearance: (0, $5uSmq.toAppearance)(option.transition.to)
    }, option.transition.to.name)));
});
const $045d9dc4d0939a23$var$ServiceWrapper = /*#__PURE__*/ (0, $5uXOq.memo)(({ id: id, name: name, categoryId: categoryId, issueKey: issueKey, children: children, onStatusChange: onStatusChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), issueId: issueId })=>{
    const { baseUrl: baseUrl } = (0, $9OXo1.useTenantContext)();
    const initialValue = {
        id: id,
        name: name,
        statusCategory: {
            id: categoryId
        }
    };
    const statusServiceChildren = (0, $5uXOq.useCallback)(({ value: statusFromService, loading: saving, transitionStatus: transitionStatus })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUXoM.TransitionsQuery), {
            issueKey: issueKey,
            baseUrl: baseUrl,
            status: statusFromService,
            isSaving: saving,
            projectType: $045d9dc4d0939a23$var$serviceProjectType
        }, ({ data: transitions, loading: loading, fetch: fetchTransitions })=>children({
                transitions: transitions,
                statusFromService: statusFromService,
                transitionStatus: transitionStatus,
                serviceBusy: saving || loading,
                fetchTransitions: fetchTransitions
            })), [
        issueKey,
        baseUrl,
        children
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9RrVQ.StatusService), {
        appearance: "lozenge",
        projectType: $045d9dc4d0939a23$var$serviceProjectType,
        initialValue: initialValue,
        issueKey: issueKey,
        issueId: issueId,
        baseUrl: baseUrl,
        onSubmit: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onSuccess: onStatusChange,
        onFailure: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onEditStart: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onEditCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        checkRefreshedData: true
    }, statusServiceChildren);
});
$045d9dc4d0939a23$var$ServiceWrapper.displayName = 'ServiceWrapper';
const $045d9dc4d0939a23$var$POPUP_OFFSET = // we should push it down by 2px to adjust the border withs and align with the cell
[
    -(0, $gwIPs.gridSize),
    2 - (0, $eTDjN.DEFAULT_ROW_HEIGHT)
];
const $045d9dc4d0939a23$var$Transitions = /*#__PURE__*/ (0, $5uXOq.memo)(({ transitions: transitions, statusFromService: statusFromService, transitionStatus: transitionStatus, fetchTransitions: fetchTransitions, serviceBusy: serviceBusy, isMenuOpen: isMenuOpen, setIsMenuOpen: setIsMenuOpen, isSelected: isSelected, isHovering: isHovering, isLozengeBold: isLozengeBold, width: width, height: height, wrapperRef: wrapperRef, inputRef: inputRef, onMenuOpen: onMenuOpen, onPopupClose: onPopupClose, inputValue: inputValue, onInputChange: onInputChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), issueTypeId: issueTypeId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [availableTransitions, setAvailableTransitions] = (0, $5uXOq.useState)(transitions);
    const [transitionsReady, setTransitionsReady] = (0, $5uXOq.useState)(false);
    const noOptionWrapperRef = (0, $5uXOq.useRef)(null); // The kill-switch for the experiment jira_inline_create_status_list_view using Statsig Dynamic Configs
    const project = (0, $6s1PB.expVal)('jira_inline_create_status_list_view_kill_switch', 'value', false) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $daQYX.useProject)() : null;
    const isAdmin = project?.permissions?.administerProject ?? false;
    const isTMP = project?.isSimplified ?? false;
    const { id: projectId, key: projectKey, type: projectType } = project || {
        type: null
    };
    const shouldShowCreateStatusButton = isAdmin && isTMP; // transitions prop changes on every render, this is used as a perf improvement
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(transitions, availableTransitions)) {
            setAvailableTransitions(transitions);
            setTimeout(()=>{
                setTransitionsReady(true);
            }, 100);
        }
    }, [
        transitions,
        availableTransitions
    ]); // select input loses focus when we load options and re-render popup
    (0, $5uXOq.useEffect)(()=>{
        if (serviceBusy === false && inputRef?.current) setTimeout(()=>{
            inputRef.current?.focus();
        }, 1);
    }, [
        serviceBusy,
        inputRef
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isMenuOpen && (!transitions || !transitions.length)) fetchTransitions(createAnalyticsEvent({}));
    }, [
        createAnalyticsEvent,
        fetchTransitions,
        isMenuOpen,
        transitions
    ]);
    const handleMenuOpenChange = (0, $5uXOq.useCallback)(()=>{
        fetchTransitions(createAnalyticsEvent({}));
    }, [
        fetchTransitions,
        createAnalyticsEvent
    ]);
    const handleTransitionChange = (0, $5uXOq.useCallback)((option)=>{
        const transitionOption = option;
        if (option?.optionType === $045d9dc4d0939a23$var$CREATE_STATUS) // This is to allow keyboard users trigger the CreateStatusModal
        createStatusButtonRef?.current?.click();
        else if (option?.optionType === $045d9dc4d0939a23$var$EDIT_STATUS) // This is to allow keyboard users trigger the EditStatusModal
        editStatusButtonRef?.current?.click();
        else if (transitionOption?.transition) transitionStatus(transitionOption?.transition, createAnalyticsEvent({}));
        onMenuOpen(false);
        wrapperRef?.current && setTimeout(()=>{
            wrapperRef?.current?.focus();
        });
    }, [
        createAnalyticsEvent,
        onMenuOpen,
        wrapperRef,
        transitionStatus
    ]);
    const handleInputChange = (0, $5uXOq.useCallback)((value, { action: action })=>{
        // Prevent the search value from clearing when tabbing to the Create Status button in the no search results view
        if ((action === 'input-blur' || action === 'menu-close') && noOptionWrapperRef?.current && (0, $4R6GH.fg)('inline_config_a11y_improvements')) return;
         /**
       * Wait for transitions to finish loading, otherwise it clears inputValue
       */ 
        if (transitionsReady) onInputChange(value);
    }, [
        onInputChange,
        transitionsReady
    ]);
    const selectValue = (0, $5uXOq.useMemo)(()=>(0, $5uSmq.transformValue)(statusFromService), [
        statusFromService
    ]); // we need to sort the options so that the selected status is at the top of the list
    // as the first option is hovered by default and will be selected if `Enter` is pressed
    // immediately after the select dropdown is shown
    const selectOptions = (0, $5uXOq.useMemo)(()=>{
        let selectedStatusOption = null;
        const statusOptions = [];
        (availableTransitions || []).forEach((transitionOption)=>{
            if (transitionOption.name == null) return;
            const statusOption = {
                label: transitionOption.to.name,
                value: transitionOption.to.name,
                transition: transitionOption
            };
            if (transitionOption.to.name === statusFromService?.name) selectedStatusOption = statusOption;
            else statusOptions.push(statusOption);
        });
        if (selectedStatusOption != null) statusOptions.unshift(selectedStatusOption);
        if (statusOptions.length && isTMP && isAdmin && $045d9dc4d0939a23$var$fireExposureForCombinedImpactAAExperiment() && // NOTE: same FG in front of the following experiments, new activated tenants pass 100% for combined_adoption_configuration_experiment and fail 100% on the other...
        ((0, $6s1PB.expVal)('jira_inline_create_status_list_view', 'isInlineCreateStatusEnabled', false) || (0, $6s1PB.expVal)('combined_adoption_configuration_experiment', 'isEnabled', false))) {
            const createStatusOption = {
                label: formatMessage((0, $3AZQW.default).createStatus),
                value: $045d9dc4d0939a23$var$CREATE_STATUS,
                optionType: $045d9dc4d0939a23$var$CREATE_STATUS,
                groupType: (0, $8109ad51236d2441$export$e13d614fc55c6ce9)
            };
            const editStatusOption = {
                label: formatMessage((0, $3AZQW.default).editStatus),
                value: $045d9dc4d0939a23$var$EDIT_STATUS,
                optionType: $045d9dc4d0939a23$var$EDIT_STATUS,
                groupType: (0, $8109ad51236d2441$export$e13d614fc55c6ce9)
            };
            return [
                {
                    options: statusOptions,
                    label: undefined
                },
                {
                    options: [
                        createStatusOption,
                        ...statusOptions.length > 0 && selectValue && issueTypeId && projectKey && isMenuOpen && (0, $6s1PB.expVal)('jira_inline_edit_status_list_view', 'isInlineEditStatusEnabled', false) ? [
                            editStatusOption
                        ] : []
                    ],
                    label: undefined
                }
            ];
        }
        return statusOptions;
    }, [
        availableTransitions,
        isTMP,
        isAdmin,
        statusFromService?.name,
        selectValue,
        issueTypeId,
        projectKey,
        formatMessage,
        isMenuOpen
    ]);
    const hasDuplicateStatusesInTargets = (0, $5uXOq.useMemo)(()=>{
        const targetStatusNames = availableTransitions ? availableTransitions.map((transition)=>transition.to.name) : [];
        return targetStatusNames.some((statusName, index)=>targetStatusNames.indexOf(statusName) !== index);
    }, [
        availableTransitions
    ]);
    const statusNames = (0, $5uXOq.useMemo)(()=>shouldShowCreateStatusButton ? selectOptions[0]?.options?.map((option)=>option.label) ?? [] : [], [
        shouldShowCreateStatusButton,
        selectOptions
    ]);
    const createStatusButtonRef = (0, $5uXOq.useRef)(null);
    const editStatusButtonRef = (0, $5uXOq.useRef)(null);
    const menuListRef = (0, $5uXOq.useRef)(null);
    const selectComponents = (0, $5uXOq.useMemo)(()=>({
            NoOptionsMessage: ()=>inputValue ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                    ref: noOptionWrapperRef
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8q5UJ.default), {
                    message: formatMessage((0, $3AZQW.default).noSearchResults)
                }), isTMP && isAdmin && projectKey && projectType && issueTypeId && $045d9dc4d0939a23$var$fireExposureForCombinedImpactAAExperiment() && // NOTE: same FG in front of the following experiments, new activated tenants pass 100% for combined_adoption_configuration_experiment and fail 100% on the other...
                ((0, $6s1PB.expVal)('jira_inline_create_status_list_view', 'isInlineCreateStatusEnabled', false) || (0, $6s1PB.expVal)('combined_adoption_configuration_experiment', 'isEnabled', false)) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hGiaW.CreateStatusButton), {
                    statusNames: statusNames,
                    projectId: String(projectId),
                    projectKey: projectKey,
                    projectType: projectType,
                    issueTypeId: issueTypeId,
                    shouldReturnFocus: wrapperRef,
                    isNoResultsView: true,
                    analyticsSource: (0, $77f8834f432b7338$export$7e2d75b13279a710)
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8q5UJ.default), {
                    onTryAgain: handleMenuOpenChange,
                    message: formatMessage((0, $3AZQW.default).cannotLoadTransitions),
                    analyticsCellName: "status"
                }),
            Group: (0, $N7jPX.GroupComponentWithStickyFooter),
            MenuList: isAdmin && isTMP && isMenuOpen && (0, $6s1PB.expVal)('jira_inline_edit_status_list_view', 'isInlineEditStatusEnabled', false) ? ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).MenuList, {
                    ...props,
                    innerRef: menuListRef,
                    innerProps: {
                        ...props.innerProps,
                        style: {
                            paddingTop: 0
                        }
                    }
                }, children) : (0, $bChGW.components).MenuList,
            Option: isAdmin && isTMP && isMenuOpen && (0, $6s1PB.expVal)('jira_inline_edit_status_list_view', 'isInlineEditStatusEnabled', false) ? ({ children: children, ...optionProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($045d9dc4d0939a23$var$CustomOptionToSupportStickyFooter, {
                    menuListRef: menuListRef,
                    ...optionProps
                }, children) : $045d9dc4d0939a23$var$Option
        }), [
        isAdmin,
        isTMP,
        inputValue,
        formatMessage,
        projectKey,
        projectType,
        issueTypeId,
        statusNames,
        projectId,
        wrapperRef,
        handleMenuOpenChange,
        noOptionWrapperRef,
        isMenuOpen
    ]);
    const relatedStatuses = (0, $5uXOq.useMemo)(()=>{
        return selectOptions // Flatten the groups
        .flatMap((group)=>'options' in group ? group.options : [
                group
            ]) // Filter out the group type options
        .filter((option)=>option && !('groupType' in option)) // Filter out the options that don't have a transition
        .filter((option)=>!!option.transition?.to).map(({ transition: transition })=>{
            const mappedStatus = {
                id: transition?.to.id ?? '',
                statusName: transition?.to.name ?? '',
                statusCategory: (0, $gULOk.statusCategoryForId)(transition?.to.statusCategory.id)
            };
            return mappedStatus;
        }) // Filter out duplicate statuses
        .filter((status, index, self)=>index === self.findIndex((t)=>t.statusName === status.statusName));
    }, [
        selectOptions
    ]);
    const getFormatOptionLabel = (0, $5uXOq.useCallback)((option)=>{
        if (isTMP && isAdmin && projectKey && projectType && issueTypeId && option.optionType === $045d9dc4d0939a23$var$CREATE_STATUS && $045d9dc4d0939a23$var$fireExposureForCombinedImpactAAExperiment() && // NOTE: same FG in front of the following experiments, new activated tenants pass 100% for combined_adoption_configuration_experiment and fail 100% on the other...
        ((0, $6s1PB.expVal)('jira_inline_create_status_list_view', 'isInlineCreateStatusEnabled', false) || (0, $6s1PB.expVal)('combined_adoption_configuration_experiment', 'isEnabled', false))) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hGiaW.CreateStatusButton), {
            buttonRef: createStatusButtonRef,
            statusNames: statusNames,
            projectId: String(projectId),
            projectKey: projectKey,
            projectType: projectType,
            issueTypeId: issueTypeId,
            shouldReturnFocus: wrapperRef,
            analyticsSource: (0, $77f8834f432b7338$export$4edb790587638895)
        });
        if (isTMP && isAdmin && projectKey && projectType && issueTypeId && option.optionType === $045d9dc4d0939a23$var$EDIT_STATUS) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fr1UQ.EditStatusButton), {
            buttonRef: editStatusButtonRef,
            statusNames: statusNames,
            projectId: String(projectId),
            projectKey: projectKey,
            projectType: projectType,
            issueTypeId: issueTypeId,
            shouldReturnFocus: wrapperRef,
            analyticsSource: (0, $77f8834f432b7338$export$4edb790587638895),
            status: {
                statusName: statusFromService.name,
                statusCategory: (0, $gULOk.statusCategoryForId)(statusFromService.statusCategory.id),
                id: statusFromService.id
            },
            statuses: relatedStatuses,
            onEditStatusSuccess: handleMenuOpenChange
        });
        const statusOption = option;
        if (statusOption.transition == null) return statusOption.label || '';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($045d9dc4d0939a23$export$60035e0a086aefd4, {
            option: statusOption,
            hasDuplicateStatusesInTargets: hasDuplicateStatusesInTargets
        });
    }, [
        isTMP,
        isAdmin,
        projectKey,
        projectType,
        issueTypeId,
        hasDuplicateStatusesInTargets,
        statusNames,
        projectId,
        wrapperRef,
        relatedStatuses,
        statusFromService,
        handleMenuOpenChange
    ]);
    const handleInputRef = (0, $5uXOq.useCallback)((ref)=>{
        if (inputRef) // @ts-expect-error - TS2540 - Cannot assign to 'current' because it is a read-only property.
        // eslint-disable-next-line no-param-reassign
        inputRef.current = ref;
    }, [
        inputRef
    ]);
    const SelectWrapper = (0, $4R6GH.fg)('inline_config_a11y_improvements') ? (0, $gyeeU.AtlaskitSelectInlineTabActivator) : (0, $5uXOq.Fragment);
    const popupContent = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lI995.CellContentWrapper // -1px border left from gridcell
        ), {
            preferredWidth: width - 1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SelectWrapper, {
            isMenuOpen: isMenuOpen,
            setIsMenuOpen: setIsMenuOpen,
            inputValue: inputValue ?? '',
            setInputValue: onInputChange
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8ad1n.default), {
            autoFocus: true,
            menuIsOpen: (0, $4R6GH.fg)('inline_config_a11y_improvements') ? isMenuOpen : true,
            placeholder: formatMessage((0, $3AZQW.default).placeholder),
            options: selectOptions,
            onChange: handleTransitionChange,
            value: selectValue,
            formatOptionLabel: getFormatOptionLabel,
            isMulti: false,
            isInvalid: false,
            isClearable: false,
            isLoading: serviceBusy,
            components: selectComponents,
            onInputRef: handleInputRef,
            tabSelectsValue: !(0, $4R6GH.fg)('inline_config_a11y_improvements'),
            inputValue: inputValue,
            onInputChange: handleInputChange,
            ...(0, $4R6GH.fg)('inline_config_a11y_improvements') && {
                onKeyDown: (e)=>{
                    if ((0, $4R6GH.fg)('inline_config_a11y_improvements')) {
                        if (e.key === 'Tab') // Needed for tab to Create Status button in NoOptionsMessage
                        e.stopPropagation();
                    }
                }
            }
        }))), [
        width,
        formatMessage,
        selectOptions,
        handleTransitionChange,
        selectValue,
        getFormatOptionLabel,
        serviceBusy,
        selectComponents,
        handleInputRef,
        inputValue,
        handleInputChange,
        SelectWrapper,
        isMenuOpen,
        setIsMenuOpen,
        onInputChange
    ]);
    const popupTrigger = (0, $5uXOq.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
            ...triggerProps,
            xcss: $045d9dc4d0939a23$var$popupTriggerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lI995.CellContentContainer), {
            onClick: handleMenuOpenChange,
            width: width,
            height: height
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
            isBold: isLozengeBold,
            appearance: (0, $5uSmq.toAppearance)(statusFromService)
        }, statusFromService.name))), [
        handleMenuOpenChange,
        width,
        height,
        isLozengeBold,
        statusFromService
    ]);
    const popupComponent = (0, $5uXOq.useMemo)(()=>(0, $jRzRt.getPopupComponentWithHeight)(shouldShowCreateStatusButton ? {
            numOptions: selectOptions[0]?.options?.length ?? 0,
            numActionOptions: selectOptions[1]?.options?.length ?? 0,
            numGroups: Math.max(selectOptions.length - 1, 0)
        } : {
            numOptions: selectOptions.length
        }), [
        shouldShowCreateStatusButton,
        selectOptions
    ]);
    const statusMenu = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
            isOpen: isMenuOpen,
            placement: "bottom-start",
            autoFocus: false,
            offset: $045d9dc4d0939a23$var$POPUP_OFFSET,
            popupComponent: popupComponent,
            content: popupContent,
            trigger: popupTrigger,
            onClose: onPopupClose,
            testId: "business-list.ui.list-view.status-cell.status-menu"
        }), [
        isMenuOpen,
        onPopupClose,
        popupContent,
        popupTrigger,
        popupComponent
    ]);
    return isHovering || isMenuOpen || isSelected ? statusMenu : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
        isBold: isLozengeBold,
        appearance: (0, $5uSmq.toAppearance)(statusFromService)
    }, statusFromService.name);
});
const $045d9dc4d0939a23$var$StatusCell = /*#__PURE__*/ (0, $5uXOq.memo)(({ id: id, name: name, categoryId: categoryId, issueKey: issueKey, width: width, height: height, onHighlightRow: onHighlightRow, isSelected: isSelected = false, wrapperRef: wrapperRef, rowData: rowData, editMode: editMode = false, setEditMode: setEditMode = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isHovering: isHovering = false, inputValue: inputValue, onInputChange: onInputChange })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const containerRef = (0, $5uXOq.useRef)(null);
    const inputRef = (0, $5uXOq.useRef)(null);
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const [isRowSelected] = (0, $mk7k0.useIsIssueSelected)({
        issueId: String(rowData.issueId)
    });
    const isLozengeBold = (0, $dCm1o.isVisualRefreshEnabled)() || isRowSelected && categoryId === (0, $gULOk.StatusCategoryIds)[(0, $gULOk.StatusCategoryTypes).INDETERMINATE];
    const onCompleted = (0, $5uXOq.useCallback)(()=>onHighlightRow && onHighlightRow(issueKey), [
        issueKey,
        onHighlightRow
    ]);
    const onPopupClose = (0, $5uXOq.useCallback)(()=>{
        setEditMode(false);
    }, [
        setEditMode
    ]);
    const handleStatusChange = (0, $5uXOq.useCallback)((value)=>{
        if (value.statusCategory.id === (0, $gULOk.StatusCategoryIds)[(0, $gULOk.StatusCategoryTypes).DONE] && !(0, $4R6GH.fg)('show-modernised-issue-transition-success-flag')) {
            showFlag({
                messageId: 'business-list.ui.list-view.status-cell.show-flag.success',
                messageType: 'transactional',
                id: 'marked-as-done-flag',
                isAutoDismiss: true,
                type: 'success',
                title: `\u{1F389} ${formatMessage((0, $3AZQW.default).markedAsDoneFlagTitle)}`,
                description: [
                    (0, $3AZQW.default).markedAsDone,
                    {
                        issue: `${issueKey}`,
                        statusName: value.name
                    }
                ],
                actions: [
                    {
                        content: (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $3AZQW.default).viewIssueIssueTermRefresh : (0, $3AZQW.default).viewIssue,
                        href: `/browse/${issueKey}`,
                        target: '_blank'
                    }
                ]
            });
            onCompleted();
        }
    }, [
        formatMessage,
        issueKey,
        onCompleted,
        showFlag
    ]);
    const transitionsChildren = (0, $5uXOq.useCallback)(({ transitions: transitions, statusFromService: statusFromService, transitionStatus: transitionStatus, fetchTransitions: fetchTransitions, serviceBusy: serviceBusy })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($045d9dc4d0939a23$var$Transitions, {
            transitions: transitions,
            statusFromService: statusFromService,
            transitionStatus: transitionStatus,
            fetchTransitions: fetchTransitions,
            serviceBusy: serviceBusy,
            isSelected: isSelected,
            isHovering: isHovering,
            isMenuOpen: editMode,
            setIsMenuOpen: setEditMode,
            isLozengeBold: isLozengeBold,
            width: width,
            height: height,
            wrapperRef: wrapperRef,
            containerRef: containerRef,
            inputRef: inputRef,
            onPopupClose: onPopupClose,
            onMenuOpen: setEditMode,
            inputValue: inputValue,
            onInputChange: onInputChange,
            issueTypeId: rowData.issuetype.id
        }), [
        isSelected,
        isHovering,
        editMode,
        isLozengeBold,
        width,
        height,
        wrapperRef,
        onPopupClose,
        setEditMode,
        inputValue,
        onInputChange,
        rowData.issuetype.id
    ]);
    const cellContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($045d9dc4d0939a23$var$ServiceWrapper, {
        id: id,
        issueId: String(rowData.issueId),
        name: name,
        categoryId: categoryId,
        issueKey: issueKey,
        onStatusChange: handleStatusChange
    }, transitionsChildren);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b5lmY.CellWrapper), {
        isEditable: true,
        testId: "business-list.ui.list-view.status-cell.cell-container"
    }, cellContent);
});
var $045d9dc4d0939a23$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $045d9dc4d0939a23$var$StatusCell;
const $045d9dc4d0939a23$var$TransitionLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o _1t211l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $045d9dc4d0939a23$var$TransitionName = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jl11wp _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $045d9dc4d0939a23$var$StatusName = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y3gnusic",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $045d9dc4d0939a23$var$OptionWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1sit _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $045d9dc4d0939a23$var$TransitionWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1yb4 _2lx21bp4 _1bsb1osq _4t3i1osq",
            __cmplp.className
        ])
    });
});
const $045d9dc4d0939a23$var$popupTriggerStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.neutral.subtle',
    padding: 'space.0'
});
const $045d9dc4d0939a23$var$buttonOptionStyles = null;
const $045d9dc4d0939a23$var$transitionOptionStyles = null;

});
parcelRegister("eGdV2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::101a51255f7076752a2af1f3fc652adc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aaffc8f190d8dd35$var$_react = $aaffc8f190d8dd35$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $aaffc8f190d8dd35$var$_arrowRight = $aaffc8f190d8dd35$var$_interopRequireDefault((parcelRequire("h1TKi")));

var $aaffc8f190d8dd35$var$_arrowRight2 = $aaffc8f190d8dd35$var$_interopRequireDefault((parcelRequire("8RBk4")));
function $aaffc8f190d8dd35$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowRightIcon.
 * This component is ArrowRightIcon, with `UNSAFE_fallbackIcon` set to "ArrowRightIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $aaffc8f190d8dd35$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $aaffc8f190d8dd35$var$_react.default.createElement($aaffc8f190d8dd35$var$_arrowRight.default, Object.assign({
        LEGACY_fallbackIcon: $aaffc8f190d8dd35$var$_arrowRight2.default
    }, props));
$aaffc8f190d8dd35$var$ArrowRightIcon.Name = 'ArrowRightIconMigration';
var $aaffc8f190d8dd35$var$_default = module.exports.default = $aaffc8f190d8dd35$var$ArrowRightIcon;

});
parcelRegister("h1TKi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::11b8e18b02050eefbe32dafc654ee453>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c65dc59efb96b35a$var$_react = $c65dc59efb96b35a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c65dc59efb96b35a$var$_baseNew = $c65dc59efb96b35a$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $c65dc59efb96b35a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c65dc59efb96b35a$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $c65dc59efb96b35a$var$_react.default.createElement($c65dc59efb96b35a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.44 7.25 8.72 3.53l1.06-1.06 5 5a.75.75 0 0 1 0 1.06l-5 5-1.06-1.06 3.72-3.72H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$c65dc59efb96b35a$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $c65dc59efb96b35a$var$_default = module.exports.default = $c65dc59efb96b35a$var$ArrowRightIcon;

});

parcelRegister("8RBk4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6740397d4ba98b13$var$_react = $6740397d4ba98b13$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $6740397d4ba98b13$var$_arrowRight = $6740397d4ba98b13$var$_interopRequireDefault((parcelRequire("h1TKi")));
function $6740397d4ba98b13$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6740397d4ba98b13$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $6740397d4ba98b13$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.793 5.793a1 1 0 0 0 0 1.414L15.586 11H6a1 1 0 0 0 0 2h9.586l-3.793 3.793a1 1 0 0 0 0 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a1 1 0 0 0 .293-.679v-.057a1 1 0 0 0-.293-.678l-5.499-5.5a1 1 0 0 0-1.415 0"/></svg>`
    }, props, {
        newIcon: $6740397d4ba98b13$var$_arrowRight.default
    }));
$6740397d4ba98b13$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $6740397d4ba98b13$var$_default = module.exports.default = $6740397d4ba98b13$var$ArrowRightIcon;

});


const $77f8834f432b7338$export$c766acff4513a976 = 'summaryView';
const $77f8834f432b7338$export$4edb790587638895 = 'listView';
const $77f8834f432b7338$export$7e2d75b13279a710 = 'listViewNoResults';
const $77f8834f432b7338$export$5e4b47163db377f = 'listViewGroupByStatus';
const $77f8834f432b7338$export$cafb161c2b21b455 = 'issueView';
const $77f8834f432b7338$export$66397ed56abea4ca = 'gicView';
const $77f8834f432b7338$export$46d07e67f98555aa = 'editStatusButton';
const $77f8834f432b7338$export$415149578ef78676 = 'deleteStatusButton';

parcelRegister("9RrVQ", function(module, exports) {

$parcel$export(module.exports, "StatusService", () => $9d12d6dcae452c2c$export$3e14b51c9a9c5a1a);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $2YZCu = parcelRequire("2YZCu");

var $cSD7y = parcelRequire("cSD7y");

var $4R6GH = parcelRequire("4R6GH");

var $jJZqs = parcelRequire("jJZqs");

var $fZneA = parcelRequire("fZneA");

var $eusud = parcelRequire("eusud");

var $34Vv8 = parcelRequire("34Vv8");

var $ctrpc = parcelRequire("ctrpc");

var $d6AeP = parcelRequire("d6AeP");

var $3fAi8 = parcelRequire("3fAi8");

var $jpZIw = parcelRequire("jpZIw");

var $dTUtq = parcelRequire("dTUtq");

var $gXz4p = parcelRequire("gXz4p");

var $k0ahW = parcelRequire("k0ahW");

var $aubl2 = parcelRequire("aubl2");

var $dXq4S = parcelRequire("dXq4S");

var $5fc53 = parcelRequire("5fc53");

var $8zOmE = parcelRequire("8zOmE");

var $koeKL = parcelRequire("koeKL");

var $2gCtH = parcelRequire("2gCtH");

var $6r7fT = parcelRequire("6r7fT");



var $270P6 = parcelRequire("270P6");

var $d7lJH = parcelRequire("d7lJH");

var $55hg5 = parcelRequire("55hg5");
const $9d12d6dcae452c2c$export$7a6a15706decd0f9 = '#issue-workflow-transition-submit';
const $9d12d6dcae452c2c$export$582c70653d60fda9 = (selector, event, handler)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const el = document.querySelector(selector);
    if (el) el.removeEventListener(event, handler);
};
const $9d12d6dcae452c2c$export$8e05e1932c4b20b0 = (selector, event, handler)=>{
    $9d12d6dcae452c2c$export$582c70653d60fda9(selector, event, handler);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const el = document.querySelector(selector);
    if (el) el.addEventListener(event, handler);
};
// eslint-disable-next-line jira/react/no-class-components
class $9d12d6dcae452c2c$var$StatusServiceOld extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            onSubmit: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onFailure: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onEditStart: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onEditCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    /**
	 * Lets the consumer control the value of this component. If the consumer passes a `value` prop
	 * it will override the value in state, as long as the component is not in loading state. That's because the component
	 * will only let the consumer know about the new status value once the transition is complete (i.e. loading=false).
	 *
	 * This lifecycle method gets called before every invocation of render().
	 */ static getDerivedStateFromProps(props, state) {
        if (state.loading || !props.value) return null;
        return {
            value: props.value
        };
    }
    constructor(props){
        super(props), this.componentDidUpdate = (prevProps)=>{
            if ((0, $4R6GH.fg)('jira-edit-status-field-refresh-state')) {
                const isNewStatus = this.props.initialValue && prevProps.initialValue && prevProps.initialValue.id !== this.props.initialValue.id && this.props.initialValue.id !== this.state.value.id;
                const hasNameChanged = this.props.initialValue && prevProps.initialValue && prevProps.initialValue.name !== this.props.initialValue.name;
                const hasCategoryChanged = this.props.initialValue && prevProps.initialValue && prevProps.initialValue.statusCategory.id !== this.props.initialValue.statusCategory.id;
                if (isNewStatus || this.props.checkRefreshedData && (hasNameChanged || hasCategoryChanged)) this.setState({
                    loading: false,
                    value: this.props.initialValue
                });
            } else if (// If we receive a new prop that is different to the old one and it is different
            // to our state then trust it and update the state.
            this.props.initialValue && prevProps.initialValue && prevProps.initialValue.id !== this.props.initialValue.id && this.props.initialValue.id !== this.state.value.id) this.setState({
                loading: false,
                value: this.props.initialValue
            });
        }, this.isDialogOpened = false, this.isDialogConfirmPressed = false, this.onDialogContentReady = ()=>{
            // This event fired by a dialog before the dialog itself is rendered and visible to the user
            // That's why we need to postpone sending the response to the next moment after it became visible
            setTimeout(()=>{
                this.bindDialogFormHandlers();
                this.isDialogOpened = true;
                this.isDialogConfirmPressed = false;
            });
        }, this.bindDialogFormHandlers = ()=>{
            $9d12d6dcae452c2c$export$8e05e1932c4b20b0($9d12d6dcae452c2c$export$7a6a15706decd0f9, 'click', this.onClickDialogConfirm);
        }, this.unbindDialogFormHandlers = ()=>{
            $9d12d6dcae452c2c$export$582c70653d60fda9($9d12d6dcae452c2c$export$7a6a15706decd0f9, 'click', this.onClickDialogConfirm);
        }, this.handleBeforeDialogHide = ()=>{
            this.unbindDialogFormHandlers();
            this.isDialogOpened = false;
            this.isDialogConfirmPressed = false;
        }, this.onClickDialogConfirm = ()=>{
            // Dialog confirm button press will result in either successfully closing of dialog, or error and dialog re-rendering,
            // so we are starting both interactions
            this.isDialogConfirmPressed = true;
        }, this.resetError = ()=>this.setState({
                error: null
            }), this.submit = (transition, event)=>{
            const oldValue = this.state.value;
            const newValue = transition.to;
            if ((0, $4R6GH.fg)('one_event_rules_them_all_fg')) {
                const isEditFromIssueView = (0, $d6AeP.getIsEditFromIssueView)(event);
                const issueAri = this.props.issueId;
                const issueId = issueAri && (0, $dXq4S.isAri)(issueAri) && (0, $4R6GH.fg)('one_event_iteration_3') ? (0, $dXq4S.getAriConfig)(issueAri).resourceId : issueAri;
                (0, $ctrpc.getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd((0, $5fc53.STATUS_TYPE), {
                    analytics: event,
                    attributes: {
                        fieldType: (0, $5fc53.STATUS_TYPE),
                        oldValId: oldValue.statusId ?? oldValue.id,
                        newValId: newValue.id,
                        oldStatusCategoryId: oldValue.statusCategory.id,
                        newStatusCategoryId: newValue.statusCategory.id,
                        isInlineEditing: !isEditFromIssueView,
                        ...(0, $4R6GH.fg)('one_event_improvements_1') && {
                            issueId: issueId
                        }
                    }
                });
            }
            this.setState({
                loading: true,
                value: newValue
            });
            this.props.onSubmit(oldValue, newValue, {
                transition: transition
            }, event);
        }, this.success = ({ status: status, event: event, viaDialog: viaDialog = false })=>{
            this.setState({
                loading: false,
                lastSavedValue: status
            });
            this.props.fieldValueActions.setFieldValue(this.props.issueKey, (0, $5fc53.STATUS_TYPE), status);
            this.props.onSuccess(status, viaDialog, event);
            (0, $8zOmE.fireTrackAnalytics)(event, 'statusField transitioned', 'statusField');
            (0, $gXz4p.sendExperienceAnalytics)((0, $270P6.transitionIssueExperienceDescription)(true, 'POST', (0, $4R6GH.fg)('thor_resolve_transition_event_gate') ? this.props.source ?? '' : 'Issue View Status Service', this.props.projectType));
        }, this.failure = (error, event)=>{
            this.setState({
                error: error,
                loading: false,
                value: this.state.lastSavedValue || this.props.value || this.props.initialValue
            });
            this.props.onFailure(error);
            const isValidationError = error instanceof (0, $jJZqs.ValidationError);
            if (isValidationError) this.props.flagService.showFlag((0, $55hg5.default)(error.message));
            else this.props.flagService.showFlag((0, $d7lJH.default)({
                error: error,
                traceId: error.traceId
            }));
            (0, $8zOmE.fireOperationalAnalytics)(event, 'statusField postTransitionFailed', {
                validationError: isValidationError,
                isClientFetchError: (0, $fZneA.isClientFetchError)(error)
            });
            if ((0, $k0ahW.default)(error) || (0, $4R6GH.fg)('thor_resolve_transition_event_gate')) (0, $gXz4p.sendExperienceAnalytics)((0, $270P6.transitionIssueExperienceDescription)(false, 'POST', (0, $4R6GH.fg)('thor_resolve_transition_event_gate') ? this.props.source ?? '' : 'Issue View Status Service', this.props.projectType, error.message, error.traceId, error.statusCode, (0, $6r7fT.isAbortableError)(error) && (0, $4R6GH.fg)('thor_add_taskabort_events_for_core_experiences') ? 'taskAbort' : 'taskFail'));
            else (0, $gXz4p.sendExperienceAnalytics)((0, $270P6.transitionIssueExperienceDescription)(true, 'POST', (0, $4R6GH.fg)('thor_resolve_transition_event_gate') ? this.props.source ?? '' : 'Issue View Status Service', this.props.projectType));
        }, this.cancel = ()=>{
            // @ts-expect-error - TS2322 - Type 'Status | undefined' is not assignable to type 'Status'.
            this.setState({
                loading: false,
                value: this.props.value || this.props.initialValue
            });
            this.props.onEditCancel();
            this.props.workflowTransitionsActions.setTransitionInProgress(false);
        }, this.transitionStatus = async (transition, event)=>{
            const { appearance: appearance, issueKey: issueKey, renderIssueTransitionModal: renderIssueTransitionModal, renderIssueTransitionSuccessFlag: renderIssueTransitionSuccessFlag } = this.props;
            const newStatus = transition.to;
            this.submit(transition, event);
            try {
                if (transition.hasScreen) {
                    const handleDialogSuccess = ()=>{
                        (0, $8zOmE.fireTrackAnalytics)(event, 'issueTransition success', {
                            triggerPointKey: (0, $5101b286174175c1$export$a6eb4c39beb71474),
                            isModalOpen: true
                        });
                        (0, $4R6GH.fg)('show-modernised-issue-transition-success-flag') && renderIssueTransitionSuccessFlag?.(issueKey, newStatus.name);
                        return this.success({
                            status: newStatus,
                            event: event,
                            viaDialog: true
                        });
                    };
                    const handleDialogCancel = ()=>{
                        (0, $8zOmE.fireTrackAnalytics)(event, 'issueTransition cancel', {
                            triggerPointKey: (0, $5101b286174175c1$export$a6eb4c39beb71474),
                            isModalOpen: true
                        });
                        return this.cancel();
                    };
                    const handleDialogError = ()=>{
                        (0, $8zOmE.fireTrackAnalytics)(event, 'issueTransition failed', {
                            triggerPointKey: (0, $5101b286174175c1$export$a6eb4c39beb71474),
                            isModalOpen: true
                        });
                    };
                    if (renderIssueTransitionModal) {
                        const { issueId: issueId } = this.props;
                        renderIssueTransitionModal({
                            payload: {
                                issueId: issueId,
                                issueKey: issueKey,
                                transitionId: transition.id
                            },
                            triggerPointKey: appearance === 'lozenge' ? 'issue-transition-status-field-trigger' : 'issue-transition-issue-view',
                            onDialogSuccess: handleDialogSuccess,
                            onDialogCancel: handleDialogCancel,
                            onDialogError: handleDialogError,
                            analyticsEvent: event
                        });
                    }
                } else {
                    if (this.props.onUpdateStatusMutation && (0, $4R6GH.fg)('relay-migration-issue-fields-status')) await this.props.onUpdateStatusMutation?.({
                        transitionId: transition.id,
                        newStatus: newStatus
                    });
                    else await (0, $eusud.performPostRequest)(`/rest/api/2/issue/${issueKey}/transitions`, {
                        body: JSON.stringify({
                            transition: transition
                        })
                    });
                    (0, $8zOmE.fireTrackAnalytics)(event, 'issueTransition success', {
                        triggerPointKey: (0, $5101b286174175c1$export$a6eb4c39beb71474),
                        isModalOpen: false
                    });
                    (0, $4R6GH.fg)('show-modernised-issue-transition-success-flag') && renderIssueTransitionSuccessFlag?.(issueKey, newStatus.name);
                    this.success({
                        status: newStatus,
                        event: event
                    });
                }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $2YZCu.default).safeErrorWithoutCustomerData((0, $878fbedb9c4ca329$export$25529a3376b831fd), error);
                (0, $8zOmE.fireTrackAnalytics)(event, 'issueTransition failed', {
                    triggerPointKey: (0, $5101b286174175c1$export$a6eb4c39beb71474),
                    isModalOpen: false
                });
                this.failure(error, event);
            }
        }, this.api = {
            transitionStatus: this.transitionStatus,
            resetError: this.resetError
        };
        const value = props.value || props.initialValue;
        if (value == null) throw new Error('Either value or initialValue prop is required.');
        this.state = {
            value: value,
            lastSavedValue: value,
            loading: false,
            error: null
        };
    }
    componentDidMount() {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('legacyJiraDialogContentReady', this.onDialogContentReady);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('legacyJiraDialogBeforeHide', this.handleBeforeDialogHide);
    }
    componentWillUnmount() {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.removeEventListener('legacyJiraDialogContentReady', this.onDialogContentReady);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.removeEventListener('legacyJiraDialogBeforeHide', this.handleBeforeDialogHide);
        this.unbindDialogFormHandlers();
        this.isDialogOpened = false;
    }
    render() {
        return this.props.children({
            ...this.state,
            ...this.api
        });
    }
}
const $9d12d6dcae452c2c$var$StatusServiceNew = ({ value: propValue, initialValue: initialValue, onSubmit: onSubmit = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onSuccess: onSuccess = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onFailure: onFailure = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onEditCancel: onEditCancel = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), children: children, ...props })=>{
    const [stateValue, setStateValue] = (0, $5uXOq.useState)(()=>{
        const value = propValue || initialValue;
        if (!value) throw new Error('Either value or initialValue prop is required.');
        return value;
    });
    const [lastSavedValue, setLastSavedValue] = (0, $5uXOq.useState)(stateValue);
    const [loading, setLoading] = (0, $5uXOq.useState)(false);
    const [stateError, setError] = (0, $5uXOq.useState)(null);
    // These are unused but we are keeping parity with the class component
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [isDialogOpened, setIsDialogOpened] = (0, $5uXOq.useState)(false);
    // These are unused but we are keeping parity with the class component
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [isDialogConfirmPressed, setIsDialogConfirmPressed] = (0, $5uXOq.useState)(false);
    /**
	 * Equivalent to getDerivedStateFromProps in class component version.
	 *
	 * Lets the consumer control the value of this component. If the consumer passes a `value` prop
	 * it will override the value in state, as long as the component is not in loading state. That's because the component
	 * will only let the consumer know about the new status value once the transition is complete (i.e. loading=false).
	 *
	 * This lifecycle method gets called before every invocation of render().
	 */ const value = (0, $5uXOq.useMemo)(()=>{
        if (loading || !propValue) return stateValue;
        return propValue;
    }, [
        loading,
        propValue,
        stateValue
    ]);
    // componentDidUpdate
    const prevInitialValueRef = (0, $5uXOq.useRef)(initialValue);
    (0, $5uXOq.useLayoutEffect)(()=>{
        const prevInitialValue = prevInitialValueRef.current;
        const newInitialValue = initialValue;
        if ((0, $4R6GH.fg)('jira-edit-status-field-refresh-state')) {
            const isNewStatus = newInitialValue && prevInitialValue && prevInitialValue.id !== newInitialValue.id && newInitialValue.id !== value.id;
            const hasNameChanged = newInitialValue && prevInitialValue && prevInitialValue.name !== newInitialValue.name;
            const hasCategoryChanged = newInitialValue && prevInitialValue && prevInitialValue.statusCategory.id !== newInitialValue.statusCategory.id;
            if (isNewStatus || props.checkRefreshedData && (hasNameChanged || hasCategoryChanged)) {
                setLoading(false);
                setStateValue(newInitialValue);
            }
        } else if (// If we receive a new prop that is different to the old one and it is different
        // to our state then trust it and update the state.
        newInitialValue && prevInitialValue && prevInitialValue.id !== newInitialValue.id && newInitialValue.id !== value.id) {
            setLoading(false);
            setStateValue(newInitialValue);
        }
        prevInitialValueRef.current = newInitialValue;
    }, [
        initialValue,
        props.checkRefreshedData,
        value.id
    ]);
    const onClickDialogConfirm = (0, $5uXOq.useCallback)(()=>{
        setIsDialogConfirmPressed(true);
    }, []);
    const bindDialogFormHandlers = (0, $5uXOq.useCallback)(()=>{
        $9d12d6dcae452c2c$export$8e05e1932c4b20b0($9d12d6dcae452c2c$export$7a6a15706decd0f9, 'click', onClickDialogConfirm);
    }, [
        onClickDialogConfirm
    ]);
    const unbindDialogFormHandlers = (0, $5uXOq.useCallback)(()=>{
        $9d12d6dcae452c2c$export$582c70653d60fda9($9d12d6dcae452c2c$export$7a6a15706decd0f9, 'click', onClickDialogConfirm);
    }, [
        onClickDialogConfirm
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // componentDidMount
        const onDialogContentReady = ()=>{
            // Using setTimeout as that was the class component version - this may need to be changed for concurrent
            // This event fired by a dialog before the dialog itself is rendered and visible to the user
            // That's why we need to postpone sending the response to the next moment after it became visible
            setTimeout(()=>{
                bindDialogFormHandlers();
                setIsDialogOpened(true);
                setIsDialogConfirmPressed(false);
            });
        };
        const handleBeforeDialogHide = ()=>{
            unbindDialogFormHandlers();
            setIsDialogOpened(false);
            setIsDialogConfirmPressed(false);
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('legacyJiraDialogContentReady', onDialogContentReady);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('legacyJiraDialogBeforeHide', handleBeforeDialogHide);
        return ()=>{
            // componentWillUnmount
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.removeEventListener('legacyJiraDialogContentReady', onDialogContentReady);
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.removeEventListener('legacyJiraDialogBeforeHide', handleBeforeDialogHide);
            unbindDialogFormHandlers();
        // this.isDialogOpened = false; // we dont need to change the state since we are unmounting
        };
    }, [
        bindDialogFormHandlers,
        unbindDialogFormHandlers
    ]);
    const resetError = (0, $5uXOq.useCallback)(()=>{
        setError(null);
    }, []);
    const submit = (0, $5uXOq.useCallback)((transition, event)=>{
        const oldValue = value;
        const newValue = transition.to;
        if ((0, $4R6GH.fg)('one_event_rules_them_all_fg')) {
            const isEditFromIssueView = (0, $d6AeP.getIsEditFromIssueView)(event);
            const issueAri = props.issueId;
            const issueId = issueAri && (0, $dXq4S.isAri)(issueAri) && (0, $4R6GH.fg)('one_event_iteration_3') ? (0, $dXq4S.getAriConfig)(issueAri).resourceId : issueAri;
            (0, $ctrpc.getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd((0, $5fc53.STATUS_TYPE), {
                analytics: event,
                attributes: {
                    fieldType: (0, $5fc53.STATUS_TYPE),
                    // Disabling typechange to keep parity
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                    oldValId: oldValue.statusId ?? oldValue.id,
                    newValId: newValue.id,
                    oldStatusCategoryId: oldValue.statusCategory.id,
                    newStatusCategoryId: newValue.statusCategory.id,
                    isInlineEditing: !isEditFromIssueView,
                    ...(0, $4R6GH.fg)('one_event_improvements_1') && {
                        issueId: issueId
                    }
                }
            });
        }
        setLoading(true);
        setStateValue(newValue);
        onSubmit(oldValue, newValue, {
            transition: transition
        }, event);
    }, [
        value,
        onSubmit,
        props.issueId
    ]);
    const success = (0, $5uXOq.useCallback)(({ status: status, event: event, viaDialog: viaDialog = false })=>{
        setLoading(false);
        setLastSavedValue(status);
        props.fieldValueActions.setFieldValue(props.issueKey, (0, $5fc53.STATUS_TYPE), status);
        onSuccess(status, viaDialog, event);
        (0, $8zOmE.fireTrackAnalytics)(event, 'statusField transitioned', 'statusField');
        (0, $gXz4p.sendExperienceAnalytics)((0, $270P6.transitionIssueExperienceDescription)(true, 'POST', (0, $4R6GH.fg)('thor_resolve_transition_event_gate') ? props.source ?? '' : 'Issue View Status Service', props.projectType));
    }, [
        onSuccess,
        props.fieldValueActions,
        props.issueKey,
        props.projectType,
        props.source
    ]);
    const failure = (0, $5uXOq.useCallback)((error, event)=>{
        setError(error);
        setLoading(false);
        setStateValue(lastSavedValue || propValue || initialValue);
        onFailure(error);
        const isValidationError = error instanceof (0, $jJZqs.ValidationError);
        if (isValidationError) props.flagService.showFlag((0, $55hg5.default)(error.message));
        else props.flagService.showFlag((0, $d7lJH.default)({
            error: error,
            traceId: error.traceId
        }));
        (0, $8zOmE.fireOperationalAnalytics)(event, 'statusField postTransitionFailed', {
            validationError: isValidationError,
            isClientFetchError: (0, $fZneA.isClientFetchError)(error)
        });
        if ((0, $k0ahW.default)(error) || (0, $4R6GH.fg)('thor_resolve_transition_event_gate')) (0, $gXz4p.sendExperienceAnalytics)((0, $270P6.transitionIssueExperienceDescription)(false, 'POST', (0, $4R6GH.fg)('thor_resolve_transition_event_gate') ? props.source ?? '' : 'Issue View Status Service', props.projectType, error.message, error.traceId, error.statusCode, (0, $6r7fT.isAbortableError)(error) && (0, $4R6GH.fg)('thor_add_taskabort_events_for_core_experiences') ? 'taskAbort' : 'taskFail'));
        else (0, $gXz4p.sendExperienceAnalytics)((0, $270P6.transitionIssueExperienceDescription)(true, 'POST', (0, $4R6GH.fg)('thor_resolve_transition_event_gate') ? props.source ?? '' : 'Issue View Status Service', props.projectType));
    }, [
        initialValue,
        lastSavedValue,
        onFailure,
        propValue,
        props.flagService,
        props.projectType,
        props.source
    ]);
    const cancel = (0, $5uXOq.useCallback)(()=>{
        setLoading(false);
        // @ts-expect-error - TS2322 - Type 'Status | undefined' is not assignable to type 'Status'.
        setStateValue(propValue || initialValue);
        onEditCancel();
        props.workflowTransitionsActions.setTransitionInProgress(false);
    }, [
        initialValue,
        onEditCancel,
        propValue,
        props.workflowTransitionsActions
    ]);
    const transitionStatus = (0, $5uXOq.useCallback)(async (transition, event)=>{
        const { appearance: appearance, issueKey: issueKey, renderIssueTransitionModal: renderIssueTransitionModal, renderIssueTransitionSuccessFlag: renderIssueTransitionSuccessFlag } = props;
        const newStatus = transition.to;
        submit(transition, event);
        try {
            if (transition.hasScreen) {
                const handleDialogSuccess = ()=>{
                    (0, $8zOmE.fireTrackAnalytics)(event, 'issueTransition success', {
                        triggerPointKey: (0, $5101b286174175c1$export$a6eb4c39beb71474),
                        isModalOpen: true
                    });
                    (0, $4R6GH.fg)('show-modernised-issue-transition-success-flag') && renderIssueTransitionSuccessFlag?.(issueKey, newStatus.name);
                    return success({
                        status: newStatus,
                        event: event,
                        viaDialog: true
                    });
                };
                const handleDialogCancel = ()=>{
                    (0, $8zOmE.fireTrackAnalytics)(event, 'issueTransition cancel', {
                        triggerPointKey: (0, $5101b286174175c1$export$a6eb4c39beb71474),
                        isModalOpen: true
                    });
                    return cancel();
                };
                const handleDialogError = ()=>{
                    (0, $8zOmE.fireTrackAnalytics)(event, 'issueTransition failed', {
                        triggerPointKey: (0, $5101b286174175c1$export$a6eb4c39beb71474),
                        isModalOpen: true
                    });
                };
                if (renderIssueTransitionModal) {
                    const { issueId: issueId } = props;
                    renderIssueTransitionModal({
                        payload: {
                            issueId: issueId,
                            issueKey: issueKey,
                            transitionId: transition.id
                        },
                        triggerPointKey: appearance === 'lozenge' ? 'issue-transition-status-field-trigger' : 'issue-transition-issue-view',
                        onDialogSuccess: handleDialogSuccess,
                        onDialogCancel: handleDialogCancel,
                        onDialogError: handleDialogError,
                        analyticsEvent: event
                    });
                }
            } else {
                if (props.onUpdateStatusMutation && (0, $4R6GH.fg)('relay-migration-issue-fields-status')) await props.onUpdateStatusMutation?.({
                    transitionId: transition.id,
                    newStatus: newStatus
                });
                else await (0, $eusud.performPostRequest)(`/rest/api/2/issue/${issueKey}/transitions`, {
                    body: JSON.stringify({
                        transition: transition
                    })
                });
                (0, $8zOmE.fireTrackAnalytics)(event, 'issueTransition success', {
                    triggerPointKey: (0, $5101b286174175c1$export$a6eb4c39beb71474),
                    isModalOpen: false
                });
                (0, $4R6GH.fg)('show-modernised-issue-transition-success-flag') && renderIssueTransitionSuccessFlag?.(issueKey, newStatus.name);
                success({
                    status: newStatus,
                    event: event
                });
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $2YZCu.default).safeErrorWithoutCustomerData((0, $878fbedb9c4ca329$export$25529a3376b831fd), error);
            (0, $8zOmE.fireTrackAnalytics)(event, 'issueTransition failed', {
                triggerPointKey: (0, $5101b286174175c1$export$a6eb4c39beb71474),
                isModalOpen: false
            });
            failure(error, event);
        }
    }, [
        cancel,
        failure,
        props,
        submit,
        success
    ]);
    const state = (0, $5uXOq.useMemo)(()=>({
            value: value,
            lastSavedValue: lastSavedValue,
            loading: loading,
            error: stateError
        }), [
        value,
        lastSavedValue,
        loading,
        stateError
    ]);
    const api = (0, $5uXOq.useMemo)(()=>({
            transitionStatus: transitionStatus,
            resetError: resetError
        }), [
        resetError,
        transitionStatus
    ]);
    return children({
        ...state,
        ...api
    });
};
const $9d12d6dcae452c2c$export$be60a1d722248cfa = (0, $cSD7y.componentWithFG)('jira-concurrent-status-field-fix', $9d12d6dcae452c2c$var$StatusServiceNew, $9d12d6dcae452c2c$var$StatusServiceOld);
const $9d12d6dcae452c2c$var$StatusServiceWithoutAriIdOld = (props)=>{
    const { issueId: issueId } = props;
    const cloudId = (0, $koeKL.useCloudId)();
    const ariIssueId = issueId ? (0, $dXq4S.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'issue',
        resourceId: issueId
    }) : undefined;
    const renderIssueTransitionModal = (0, $jpZIw.useOpenIssueTransitionModal)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9d12d6dcae452c2c$export$be60a1d722248cfa, {
        ...props,
        renderIssueTransitionModal: renderIssueTransitionModal,
        issueId: ariIssueId
    });
};
const $9d12d6dcae452c2c$var$StatusServiceWithoutAriIdNew = (props)=>{
    const { issueId: issueId } = props;
    const cloudId = (0, $koeKL.useCloudId)();
    const ariIssueId = issueId ? (0, $dXq4S.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'issue',
        resourceId: issueId
    }) : undefined;
    const renderIssueTransitionModal = (0, $jpZIw.useOpenIssueTransitionModal)();
    const { showIssueTransitionSuccessFlag: showIssueTransitionSuccessFlag } = (0, $dTUtq.useShowFlag)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9d12d6dcae452c2c$export$be60a1d722248cfa, {
        ...props,
        renderIssueTransitionModal: renderIssueTransitionModal,
        renderIssueTransitionSuccessFlag: showIssueTransitionSuccessFlag,
        issueId: ariIssueId
    });
};
const $9d12d6dcae452c2c$var$StatusServiceWithoutAriId = (0, $cSD7y.componentWithFG)('show-modernised-issue-transition-success-flag', $9d12d6dcae452c2c$var$StatusServiceWithoutAriIdNew, $9d12d6dcae452c2c$var$StatusServiceWithoutAriIdOld);
const $9d12d6dcae452c2c$var$StatusServiceForMigrateIssueTransitionEnabledBase = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9d12d6dcae452c2c$var$StatusServiceWithoutAriId, props);
const $9d12d6dcae452c2c$var$StatusServiceForMigrateIssueTransitionEnabledWithAnalyticsSource = (props)=>{
    const source = (0, $2gCtH.useAnalyticsSource)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9d12d6dcae452c2c$var$StatusServiceForMigrateIssueTransitionEnabledBase, {
        ...props,
        source: source
    });
};
const $9d12d6dcae452c2c$var$StatusServiceForMigrateIssueTransitionEnabled = (0, $cSD7y.componentWithFG)('thor_resolve_transition_event_gate', $9d12d6dcae452c2c$var$StatusServiceForMigrateIssueTransitionEnabledWithAnalyticsSource, $9d12d6dcae452c2c$var$StatusServiceForMigrateIssueTransitionEnabledBase);
const $9d12d6dcae452c2c$var$StatusWithValueService = (props)=>{
    const [, workflowTransitionsActions] = (0, $aubl2.useWorkflowTransitionsActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3fAi8.FieldValueSubscriber), {
        issueKey: props.issueKey,
        fieldKey: (0, $5fc53.STATUS_TYPE)
    }, (value, fieldValueActions)=>{
        const statusServiceProps = {
            value: // Overrides the value in the store if the consumer really wants to do it
            value,
            ...props,
            fieldValueActions: fieldValueActions,
            workflowTransitionsActions: workflowTransitionsActions
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9d12d6dcae452c2c$var$StatusServiceForMigrateIssueTransitionEnabled, statusServiceProps);
    });
};
const $9d12d6dcae452c2c$export$3e14b51c9a9c5a1a = (0, $34Vv8.default)($9d12d6dcae452c2c$var$StatusWithValueService);

});
parcelRegister("jpZIw", function(module, exports) {

$parcel$export(module.exports, "useOpenIssueTransitionModal", () => $f41d32ebe3d90af0$export$736bd10472c63b49);
$parcel$export(module.exports, "useCloseIssueTransitionModal", () => $f41d32ebe3d90af0$export$4629f18d511ad32e);
$parcel$export(module.exports, "useTriggerIssueTransitionModal", () => $f41d32ebe3d90af0$export$95a1e9702d78f223);
$parcel$export(module.exports, "default", () => $f41d32ebe3d90af0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lTEVZ = parcelRequire("lTEVZ");

var $4R6GH = parcelRequire("4R6GH");

var $6ikhl = parcelRequire("6ikhl");

var $2gCtH = parcelRequire("2gCtH");

var $ct2PA = parcelRequire("ct2PA");

var $3NlyR = parcelRequire("3NlyR");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $9MiT2 = parcelRequire("9MiT2");

var $fNOVA = parcelRequire("fNOVA");

var $1btwe = parcelRequire("1btwe");

var $gjoNn = parcelRequire("gjoNn");

var $ipUU1 = parcelRequire("ipUU1");

var $jHYHS = parcelRequire("jHYHS");
const $f41d32ebe3d90af0$export$736bd10472c63b49 = ()=>{
    const { openIssueTransitionModal: openIssueTransitionModalAction, openIssueTransitionModalNew: openIssueTransitionModalNew } = (0, $gjoNn.useTriggerIssueTransitionModalActions)();
    const { stateGet: { state: { isEnabled: isEnabled = true } = {} } = {} } = (0, $fNOVA.useIssueTransitionLabsOptIn)();
    const publish = (0, $1btwe.usePublishOpenIssueTransitionModalPubSub)();
    const source = (0, $2gCtH.useAnalyticsSource)();
    const { fireUIEvent: fireUIEvent } = (0, $3NlyR.useIssueTransitionUIAnalyticsEvent)();
    const { stateGet: { state: state } } = (0, $9MiT2.useIssueTransitionChangeboardingPreferences)();
    const { fireOperationalAnalyticsTransitionScreenOpened: fireOperationalAnalyticsTransitionScreenOpened } = (0, $ct2PA.useIssueTransitionsOperationalAnalyticsEvent)();
    const benefitsModal = typeof state !== 'number' ? state?.benefitsModal : undefined;
    const { isDisabled: isDisabled, nextDateToShowBenefitsModal: nextDateToShowBenefitsModal } = benefitsModal || {};
    return (0, $5uXOq.useCallback)((nextState)=>{
        try {
            const { triggerPointKey: triggerPointKey } = nextState || {};
            const isNewITSEnabled = (0, $jHYHS.isNewTransitionScreenEnabled)(isEnabled, triggerPointKey);
            if ((0, $4R6GH.fg)('modern_issue_transition_enable_benefits_modal')) {
                fireOperationalAnalyticsTransitionScreenOpened({
                    actionSubject: 'issueTransition triggered',
                    isBenefitsModalFGEneabled: (0, $4R6GH.fg)('modern_issue_transition_enable_benefits_modal'),
                    preferNewIssueTransitionScreen: isEnabled,
                    issueViewAnalyticsSource: source,
                    isBenefitsModalDisabled: isDisabled,
                    dateToShowBenefitsModal: nextDateToShowBenefitsModal || undefined
                });
                openIssueTransitionModalNew({
                    nextState: nextState,
                    preferNewIssueTransitionScreen: isEnabled,
                    issueViewAnalyticsSource: source,
                    publishTriggerToOpenTransitions: publish,
                    isBenefitsModalDisabled: isDisabled,
                    dateToShowBenefitsModal: nextDateToShowBenefitsModal || undefined,
                    fireUIEvent: fireUIEvent
                });
                return;
            }
            if ((0, $4R6GH.fg)('fix-connect-app-not-loading')) {
                if (isNewITSEnabled && source === 'connect-issue') {
                    // fire UI event when issue transition is opened via connect API
                    fireUIEvent({
                        actionSubject: 'issueTransition',
                        actionSubjectId: 'connectIssue',
                        action: 'opened'
                    });
                    publish(nextState, isEnabled);
                } else openIssueTransitionModalAction(nextState, isEnabled);
            } else if (source === 'connect-issue') {
                // fire UI event when issue transition is opened via connect API
                fireUIEvent({
                    actionSubject: 'issueTransition',
                    actionSubjectId: 'connectIssue',
                    action: 'opened'
                });
                publish(nextState, isEnabled);
            } else openIssueTransitionModalAction(nextState, isEnabled);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $lTEVZ.fireIssueTransitionErrorAnalytics)({
                meta: {
                    id: 'transitionIssueTrigger',
                    packageName: 'jiraIssueTransitionTrigger',
                    teamName: 'gryffindor'
                },
                attributes: {
                    transitionModalVersion: 'NEW'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }, [
        fireOperationalAnalyticsTransitionScreenOpened,
        isEnabled,
        source,
        isDisabled,
        nextDateToShowBenefitsModal,
        openIssueTransitionModalNew,
        publish,
        fireUIEvent,
        openIssueTransitionModalAction
    ]);
};
const $f41d32ebe3d90af0$export$4629f18d511ad32e = ()=>{
    const [, { resetState: resetState }] = (0, $6ikhl.useInlineFieldsActions)();
    const { closeIssueTransitionModal: closeIssueTransitionModalAction } = (0, $gjoNn.useTriggerIssueTransitionModalActions)();
    const { payload: { issueKey: issueKey, transitionId: transitionId }, onDialogCancel: onDialogCancel, onDialogError: onDialogError, onDialogSuccess: onDialogSuccess } = (0, $gjoNn.useTriggerIssueTransitionModalState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return (0, $5uXOq.useCallback)((shouldOpenLegacyModal = false)=>{
        closeIssueTransitionModalAction();
        resetState();
        if (shouldOpenLegacyModal) {
            const onOpenDialog = ()=>{
                (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'legacyTransitionsScreen Switched');
            };
            (0, $ipUU1.openLegacyIssueTransitionModal)({
                issueKey: issueKey,
                isReopenScenario: true,
                transitionId: transitionId,
                onDialogCancel: onDialogCancel,
                onDialogError: onDialogError,
                onDialogSuccess: onDialogSuccess,
                onOpenDialog: onOpenDialog
            });
        }
    }, [
        closeIssueTransitionModalAction,
        createAnalyticsEvent,
        issueKey,
        onDialogCancel,
        onDialogError,
        onDialogSuccess,
        transitionId,
        resetState
    ]);
};
const $f41d32ebe3d90af0$export$95a1e9702d78f223 = ()=>{
    const state = (0, $gjoNn.useTriggerIssueTransitionModalState)();
    const actions = (0, $gjoNn.useTriggerIssueTransitionModalActions)();
    const { openIssueTransitionModalNew: openIssueTransitionModalNew, ...restActions } = actions;
    const openIssueTransitionModal = $f41d32ebe3d90af0$export$736bd10472c63b49();
    return [
        state,
        {
            ...restActions,
            openIssueTransitionModal: openIssueTransitionModal
        }
    ];
};
var $f41d32ebe3d90af0$export$2e2bcd8739ae039 = $f41d32ebe3d90af0$export$95a1e9702d78f223;

});
parcelRegister("lTEVZ", function(module, exports) {

$parcel$export(module.exports, "fireIssueTransitionErrorAnalytics", () => $63e82840dc2f165f$export$3839c9497170b08f);

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $fukJp = parcelRequire("fukJp");
const $63e82840dc2f165f$export$3839c9497170b08f = (payload)=>{
    if (!(0, $4R6GH.fg)('issue-transition-fire-error-analytics-refactor')) return (0, $jcw0u.default)(payload);
    const { attributes: attributes = {}, error: error, ...otherPayload } = payload;
    (0, $fukJp.fireErrorAnalyticsCommon)({
        ...otherPayload,
        attributes: {
            ...attributes
        },
        error: error
    });
};

});
parcelRegister("fukJp", function(module, exports) {

$parcel$export(module.exports, "fireErrorAnalyticsCommon", () => $2a45d398159543ce$export$51f199f6846377f7);

var $jcw0u = parcelRequire("jcw0u");

var $1qgAp = parcelRequire("1qgAp");
const $2a45d398159543ce$export$51f199f6846377f7 = (payload)=>{
    const { skipSentry: skipSentry = true, attributes: attributes, ...otherPayload } = payload;
    (0, $jcw0u.default)({
        ...otherPayload,
        attributes: {
            ...attributes,
            ...(0, $1qgAp.getTenantAttributes)()
        },
        skipSentry: // skiping sentry as true for fireErrorAnalytics
        skipSentry
    });
};

});
parcelRegister("1qgAp", function(module, exports) {

$parcel$export(module.exports, "getTenantAttributes", () => $b69c35ebd4c3a77a$export$bc31ff13a0bbe592);

var $j8DrX = parcelRequire("j8DrX");

var $c04PQ = parcelRequire("c04PQ");
const $b69c35ebd4c3a77a$export$bc31ff13a0bbe592 = ()=>{
    const shard = (0, $j8DrX.default)('ajs-shard');
    const region = (0, $j8DrX.default)('ajs-region');
    return {
        shard: shard,
        region: region,
        isFedRamp: (0, $c04PQ.isFedRamp)()
    };
};

});



parcelRegister("6ikhl", function(module, exports) {

$parcel$export(module.exports, "useInlineFields", () => $d56dd4f138add558$export$71d5b5acb7d7f5ce);
$parcel$export(module.exports, "useInlineField", () => $d56dd4f138add558$export$14c9655e9d9e873c);
$parcel$export(module.exports, "useInlineFieldsActions", () => $d56dd4f138add558$export$cdb4b503c6154b35);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $5rCpD = parcelRequire("5rCpD");
// Inline fields state tracks field states in create issue view as the user interacts with them
// this is particularly needed as we want to save the field's value when the user
// unfocuses the field
const $d56dd4f138add558$var$store = (0, $iXqE5.createStore)({
    name: 'forge.inline-fields-state',
    initialState: {},
    actions: $5rCpD.default
});
const $d56dd4f138add558$export$71d5b5acb7d7f5ce = (0, $3sQ5x.createHook)($d56dd4f138add558$var$store);
const $d56dd4f138add558$export$14c9655e9d9e873c = (0, $3sQ5x.createHook)($d56dd4f138add558$var$store, {
    selector: (state, fieldId)=>state[fieldId]
});
const $d56dd4f138add558$export$cdb4b503c6154b35 = (0, $3sQ5x.createHook)($d56dd4f138add558$var$store, {
    selector: null
});

});
parcelRegister("5rCpD", function(module, exports) {

$parcel$export(module.exports, "default", () => $02373df28193ad93$export$2e2bcd8739ae039);

var $hPhpd = parcelRequire("hPhpd");
const $02373df28193ad93$var$actions = {
    setFieldState: $hPhpd.setFieldState,
    resetState: $hPhpd.resetState,
    dispatchRetryFunction: $hPhpd.dispatchRetryFunction,
    dispatchFormSubmits: $hPhpd.dispatchFormSubmits
};
var $02373df28193ad93$export$2e2bcd8739ae039 = $02373df28193ad93$var$actions;

});
parcelRegister("hPhpd", function(module, exports) {

$parcel$export(module.exports, "setFieldState", () => $9eca433be421af07$export$80fd62d9217dd703);
$parcel$export(module.exports, "resetState", () => $9eca433be421af07$export$8e84bad0b35de9e8);
$parcel$export(module.exports, "dispatchRetryFunction", () => $9eca433be421af07$export$27c59f06a7c1fe26);
$parcel$export(module.exports, "dispatchFormSubmits", () => $9eca433be421af07$export$42fd5e650971333b);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $4R6GH = parcelRequire("4R6GH");


var $9J85a = parcelRequire("9J85a");
const $9eca433be421af07$export$80fd62d9217dd703 = (data)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const stateObject = {
            status: data.status !== undefined ? data.status : currentState[data.fieldId]?.status,
            formRef: data.formRef !== undefined ? data.formRef : currentState[data.fieldId]?.formRef,
            retryFunction: data.retryFunction !== undefined ? data.retryFunction : currentState[data.fieldId]?.retryFunction,
            ...(0, $4R6GH.fg)('fcf-new-submit-on-gic-and-tv') ? {
                onFormSubmit: data.onFormSubmit !== undefined ? data.onFormSubmit : currentState[data.fieldId]?.onFormSubmit
            } : {}
        };
        setState({
            ...getState(),
            [data.fieldId]: stateObject
        });
    };
const $9eca433be421af07$export$8e84bad0b35de9e8 = ()=>({ getState: getState, setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const stateToOverride = {};
        Object.getOwnPropertyNames(getState()).forEach((fieldId)=>{
            stateToOverride[fieldId] = {
                status: (0, $3e5c7761c2e3cf02$export$bbf78c43fa5268c8)
            };
        });
        setState(stateToOverride);
    };
const $9eca433be421af07$export$27c59f06a7c1fe26 = (fieldId)=>async ({ getState: getState })=>{
        const currentState = getState();
        const fieldData = currentState[fieldId];
        const retryFunction = fieldData?.retryFunction;
        retryFunction && retryFunction();
    };
const $9eca433be421af07$export$42fd5e650971333b = ()=>async ({ getState: getState })=>{
        const currentState = getState();
        Object.keys(currentState).forEach((fieldId)=>{
            if (currentState[fieldId]?.status === (0, $3e5c7761c2e3cf02$export$32bbcfb76243a487)) {
                if ((0, $4R6GH.fg)('fcf-new-submit-on-gic-and-tv')) currentState[fieldId]?.onFormSubmit?.();
                else {
                    const formRef = currentState[fieldId]?.formRef;
                    (0, $9J85a.dispatchFormSubmitAndBlurElements)(formRef);
                }
            }
        });
    };

});
const $3e5c7761c2e3cf02$export$32bbcfb76243a487 = 'FOCUSED';
const $3e5c7761c2e3cf02$export$f81c1d6b9217380c = 'PENDING';
const $3e5c7761c2e3cf02$export$2ace7d3737836262 = 'RESOLVED';
const $3e5c7761c2e3cf02$export$9956c6a700e724c4 = 'STORED';
const $3e5c7761c2e3cf02$export$742c877aeb0f3dbd = 'FAILED';
const $3e5c7761c2e3cf02$export$bbf78c43fa5268c8 = 'IDLE';
const $3e5c7761c2e3cf02$export$ae7c16bdba5e2e15 = 10000;
const $3e5c7761c2e3cf02$export$30daef8830f2505d = 'WAIT';
const $3e5c7761c2e3cf02$export$f86e250f1a7b07c8 = 'PROCEED';
const $3e5c7761c2e3cf02$export$e784a07a62e2e0e5 = 'TIMEOUT';

parcelRegister("9J85a", function(module, exports) {

$parcel$export(module.exports, "submitForgeFormField", () => $b1c36799aab2b39a$export$7e50fee868362aa2);
$parcel$export(module.exports, "dispatchFormSubmitAndBlurElements", () => $b1c36799aab2b39a$export$4d639a8e0790daf2);
$parcel$export(module.exports, "isBlurEventTriggeredOutsideTheField", () => $b1c36799aab2b39a$export$ee23412a8bea9333);

const $b1c36799aab2b39a$export$7e50fee868362aa2 = (formRef)=>{
    formRef?.current?.requestSubmit();
};
const $b1c36799aab2b39a$export$4d639a8e0790daf2 = (formRef)=>{
    $b1c36799aab2b39a$export$7e50fee868362aa2(formRef);
    if (formRef?.current?.elements) Array.from(formRef.current.elements).forEach((element)=>{
        if ('blur' in element && typeof element.blur === 'function') element?.blur();
    });
};
const $b1c36799aab2b39a$export$ee23412a8bea9333 = (fieldState, event, divRef)=>fieldState?.status === (0, $3e5c7761c2e3cf02$export$32bbcfb76243a487) && !divRef.current?.contains(event.relatedTarget);

});




parcelRegister("ct2PA", function(module, exports) {

$parcel$export(module.exports, "useIssueTransitionsOperationalAnalyticsEvent", () => $539a3126b0b48d6d$export$4d10663856b750d0);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $539a3126b0b48d6d$export$4d10663856b750d0 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const fireOperationalEventIssueTransitionFieldsCount = (0, $5uXOq.useCallback)(({ actionSubject: actionSubject, fieldCount: fieldCount })=>{
        const analyticsEvent = createAnalyticsEvent({});
        (0, $8zOmE.fireOperationalAnalyticsDeferred)(analyticsEvent, actionSubject, {
            fieldCount: fieldCount
        });
    }, [
        createAnalyticsEvent
    ]);
    const fireOperationalAnalyticsPermissionsUnAvailable = (0, $5uXOq.useCallback)(({ actionSubject: actionSubject })=>{
        const analyticsEvent = createAnalyticsEvent({});
        (0, $8zOmE.fireOperationalAnalyticsDeferred)(analyticsEvent, actionSubject);
    }, [
        createAnalyticsEvent
    ]);
    const fireOperationalAnalyticsTransitionScreenOpened = (0, $5uXOq.useCallback)(({ actionSubject: actionSubject, isBenefitsModalFGEneabled: isBenefitsModalFGEneabled, preferNewIssueTransitionScreen: preferNewIssueTransitionScreen, issueViewAnalyticsSource: issueViewAnalyticsSource, isBenefitsModalDisabled: isBenefitsModalDisabled, dateToShowBenefitsModal: dateToShowBenefitsModal })=>{
        const analyticsEvent = createAnalyticsEvent({});
        (0, $8zOmE.fireOperationalAnalyticsDeferred)(analyticsEvent, actionSubject, {
            isBenefitsModalFGEneabled: isBenefitsModalFGEneabled,
            preferNewIssueTransitionScreen: preferNewIssueTransitionScreen,
            issueViewAnalyticsSource: issueViewAnalyticsSource,
            isBenefitsModalDisabled: isBenefitsModalDisabled,
            dateToShowBenefitsModal: dateToShowBenefitsModal
        });
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireOperationalEventIssueTransitionFieldsCount: fireOperationalEventIssueTransitionFieldsCount,
        fireOperationalAnalyticsPermissionsUnAvailable: fireOperationalAnalyticsPermissionsUnAvailable,
        fireOperationalAnalyticsTransitionScreenOpened: fireOperationalAnalyticsTransitionScreenOpened
    };
};

});

parcelRegister("3NlyR", function(module, exports) {

$parcel$export(module.exports, "useIssueTransitionUIAnalyticsEvent", () => $5656c248adec15f1$export$d0823e3d2e087672);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $5656c248adec15f1$export$d0823e3d2e087672 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const fireUIEvent = (0, $5uXOq.useCallback)(({ analyticsEvent: analyticsEvent, actionSubjectId: actionSubjectId, action: action = 'clicked', actionSubject: actionSubject, attributes: attributes = {} })=>{
        if (analyticsEvent !== undefined) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, actionSubjectId, attributes);
        else {
            const createdAnalyticsEvent = createAnalyticsEvent({
                action: action,
                actionSubject: actionSubject
            });
            (0, $8zOmE.fireUIAnalytics)(createdAnalyticsEvent, actionSubjectId, attributes);
        }
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireUIEvent: fireUIEvent
    };
};

});

parcelRegister("1btwe", function(module, exports) {

$parcel$export(module.exports, "usePublishOpenIssueTransitionModalPubSub", () => $9796b79be99bbec0$export$76b6328962c9935f);

var $5uXOq = parcelRequire("5uXOq");


var $iXy8e = parcelRequire("iXy8e");
const $9796b79be99bbec0$export$76b6328962c9935f = ()=>(0, $5uXOq.useCallback)((payload, isEnabled)=>{
        (0, $iXy8e.ITSPubSub).publish((0, $10a759732c3f1985$export$283bfc4a4b25707a), {
            payload: payload,
            isEnabled: isEnabled
        });
    }, []);

});
const $10a759732c3f1985$export$283bfc4a4b25707a = 'open-issue-transition-modal';

parcelRegister("iXy8e", function(module, exports) {

$parcel$export(module.exports, "ITSPubSub", () => $c6c4e897a3edd1a2$export$a3877931259d622e);

var $da7iT = parcelRequire("da7iT");
const $c6c4e897a3edd1a2$export$a3877931259d622e = new (0, $da7iT.PubSubHub)();
const $c6c4e897a3edd1a2$export$58b86c4766378620 = ()=>({
        ...$c6c4e897a3edd1a2$export$a3877931259d622e
    });

});
parcelRegister("da7iT", function(module, exports) {

$parcel$export(module.exports, "PubSubHub", () => $4d1dbccbbe967a62$export$e3607828f8f2c01e);
class $4d1dbccbbe967a62$export$e3607828f8f2c01e {
    constructor(){
        this.subscribers = {};
        this.subscribe = (event, subscriber)=>{
            let subs = this.subscribers[event];
            if (!subs) {
                subs = [];
                this.subscribers[event] = subs;
            }
            subs?.push(subscriber);
            return ()=>this.unsubscribe(event, subscriber);
        };
        this.unsubscribe = (event, subscriber)=>{
            const subs = this.subscribers[event];
            if (subs) this.subscribers[event] = subs.filter((subscription)=>subscription !== subscriber);
        };
        this.publish = (event, data)=>{
            const subs = this.subscribers[event];
            if (subs?.length) subs?.forEach((subscriber)=>subscriber(data));
        };
        this.clearAll = ()=>{
            this.subscribers = {};
        };
    }
}

});



parcelRegister("gjoNn", function(module, exports) {

$parcel$export(module.exports, "TriggerIssueTransitionModalContainer", () => $18f6c8628e84d111$export$8ad65e459a406a8a);
$parcel$export(module.exports, "useTriggerIssueTransitionModalActions", () => $18f6c8628e84d111$export$68de001c738e4145);
$parcel$export(module.exports, "useTriggerIssueTransitionModalState", () => $18f6c8628e84d111$export$d3aceeec551eaab5);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");

var $QnL9H = parcelRequire("QnL9H");

var $bpOxh = parcelRequire("bpOxh");
const $18f6c8628e84d111$var$store = (0, $iXqE5.createStore)({
    name: 'issue-transition.issue-transition-form.use-trigger-issue-transition-modal',
    initialState: $QnL9H.initialState,
    actions: $bpOxh
});
const $18f6c8628e84d111$export$8ad65e459a406a8a = (0, $gg7kZ.createContainer)($18f6c8628e84d111$var$store);
const $18f6c8628e84d111$export$68de001c738e4145 = (0, $3sQ5x.createActionsHook)($18f6c8628e84d111$var$store);
const $18f6c8628e84d111$export$d3aceeec551eaab5 = (0, $3sQ5x.createStateHook)($18f6c8628e84d111$var$store);

});
parcelRegister("QnL9H", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $b1651ed43432db50$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "OPEN_MODERN_TRANSITION_MODAL", () => $b1651ed43432db50$export$7320afd6d2c7276d);
$parcel$export(module.exports, "OPEN_LEGACY_TRANSITION_MODAL", () => $b1651ed43432db50$export$8ed7400ca8e89de2);

const $b1651ed43432db50$export$d4c72bab9d6cc13a = {
    isModalOpen: false,
    isBenefitsModalOpen: false,
    isSubsequentLoad: false,
    payload: {
        issueId: '',
        issueKey: '',
        transitionId: ''
    },
    id: 'issue-transition-dialog',
    title: null,
    fetchedIssueId: '',
    triggerPointKey: (0, $b09837015a6d4fc3$export$8d987f6e80b74000),
    openLegacyTransitionsDialog: null,
    onDialogSuccess: null,
    onDialogCancel: null,
    onDialogError: null
};
const $b1651ed43432db50$export$7320afd6d2c7276d = 'OPEN_MODERN_TRANSITION_MODAL';
const $b1651ed43432db50$export$8ed7400ca8e89de2 = 'OPEN_LEGACY_TRANSITION_MODAL';

});
const $b09837015a6d4fc3$export$ef94a84e2990361c = 'issue-transition-issue-view';
const $b09837015a6d4fc3$export$de11f84a7d32933b = 'issue-transition-board-card-transition';
const $b09837015a6d4fc3$export$6c46e4003e7b7e9c = 'issue-transition-advanced-roadmaps-jira-transition';
const $b09837015a6d4fc3$export$e77cd508fbc3b5ba = 'issue-transition-backlog-inline-transition';
const $b09837015a6d4fc3$export$4edf4c3eee5081f6 = 'issue-transition-issue-view-shortcut-dialog';
const $b09837015a6d4fc3$export$27b74e685c26e665 = 'issue-transition-command-palette-status-field-transition';
const $b09837015a6d4fc3$export$290710ac08f770c0 = 'issue-transition-issue-results-shortcut-transition';
const $b09837015a6d4fc3$export$ddade13ad1b89bf0 = 'issue-transition-status-field-trigger';
const $b09837015a6d4fc3$export$8d987f6e80b74000 = 'trigger-point-key-not-defined';
const $b09837015a6d4fc3$export$2bf0e335b815a90b = 'comment';
const $b09837015a6d4fc3$export$1b8cc53b37a62399 = 'worklog';
const $b09837015a6d4fc3$export$d624b8367eb730df = 'issuelinks';


parcelRegister("bpOxh", function(module, exports) {

$parcel$export(module.exports, "closeIssueTransitionModal", () => (parcelRequire("3KYVT")).default);
$parcel$export(module.exports, "openIssueTransitionModal", () => (parcelRequire("3cIaS")).default);
$parcel$export(module.exports, "restoreState", () => (parcelRequire("keQtD")).default);
$parcel$export(module.exports, "setFetchedIssueId", () => (parcelRequire("fb5Xn")).default);
$parcel$export(module.exports, "hideBenefitsModal", () => (parcelRequire("bemkp")).default);
$parcel$export(module.exports, "openIssueTransitionModalNew", () => (parcelRequire("bnv5t")).default);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $3KYVT = parcelRequire("3KYVT");

var $3cIaS = parcelRequire("3cIaS");

var $keQtD = parcelRequire("keQtD");

var $fb5Xn = parcelRequire("fb5Xn");

var $bemkp = parcelRequire("bemkp");

var $bnv5t = parcelRequire("bnv5t");

});
parcelRegister("3KYVT", function(module, exports) {

$parcel$export(module.exports, "default", () => $09ddf425c332ed49$export$2e2bcd8739ae039);

var $QnL9H = parcelRequire("QnL9H");
const $09ddf425c332ed49$var$closeIssueTransitionModal = ()=>({ setState: setState })=>{
        setState({
            ...(0, $QnL9H.initialState),
            isModalOpen: false,
            isSubsequentLoad: true
        });
    };
var $09ddf425c332ed49$export$2e2bcd8739ae039 = $09ddf425c332ed49$var$closeIssueTransitionModal;

});

parcelRegister("3cIaS", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc7e957c004b1c31$export$2e2bcd8739ae039);

var $8Rkzz = parcelRequire("8Rkzz");

var $eVcDT = parcelRequire("eVcDT");

var $emTT1 = parcelRequire("emTT1");

var $lTEVZ = parcelRequire("lTEVZ");

var $jtjyW = parcelRequire("jtjyW");

var $jHYHS = parcelRequire("jHYHS");
const $cc7e957c004b1c31$var$openIssueTransitionModal = (nextState, preferNewIssueTransitionScreen = true)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const { payload: { issueKey: issueKey = '', transitionId: transitionId = '' }, onDialogSuccess: onDialogSuccess, onDialogCancel: onDialogCancel, onDialogError: onDialogError, triggerPointKey: triggerPointKey } = nextState || {
            payload: {}
        };
        let transitionModalVersion = '';
        const isNewITSEnabled = (0, $jHYHS.isNewTransitionScreenEnabled)(preferNewIssueTransitionScreen, triggerPointKey);
        try {
            if (isNewITSEnabled) {
                transitionModalVersion = 'NEW';
                (0, $jtjyW.startIssueTransitionMetrics)(currentState.isSubsequentLoad);
                setState({
                    ...currentState,
                    isModalOpen: true,
                    // making fetchedIssueId as blank to ensure we donot end up using stale issueId
                    fetchedIssueId: '',
                    ...nextState
                });
            } else {
                transitionModalVersion = 'OLD';
                (0, $emTT1.timeToRenderTransitionModal).start();
                new (0, $eVcDT.default)({
                    issueKey: issueKey,
                    transitionId: transitionId
                }).onDialogSuccess(onDialogSuccess || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).onDialogCancel(onDialogCancel || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).onDialogError(onDialogError || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).show();
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $lTEVZ.fireIssueTransitionErrorAnalytics)({
                meta: {
                    id: 'transitionIssueTrigger',
                    packageName: 'jiraIssueTransitionTrigger',
                    teamName: 'gryffindor'
                },
                error: error,
                attributes: {
                    transitionModalVersion: transitionModalVersion
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
var $cc7e957c004b1c31$export$2e2bcd8739ae039 = $cc7e957c004b1c31$var$openIssueTransitionModal;

});
parcelRegister("eVcDT", function(module, exports) {

$parcel$export(module.exports, "default", () => $25bfe0b90f22578e$export$2e2bcd8739ae039);

var $8Rkzz = parcelRequire("8Rkzz");

var $6BZYo = parcelRequire("6BZYo");
var $ig88W = parcelRequire("ig88W");
var $7T84i = parcelRequire("7T84i");
var $9B86Q = parcelRequire("9B86Q");
var $cQZXC = parcelRequire("cQZXC");
var $8JNtu = parcelRequire("8JNtu");

var $4tcSU = parcelRequire("4tcSU");

var $4R6GH = parcelRequire("4R6GH");

var $emTT1 = parcelRequire("emTT1");
class $25bfe0b90f22578e$export$2e2bcd8739ae039 {
    constructor({ issueId: issueId, transitionId: transitionId, issueKey: issueKey, issueKeys: issueKeys }){
        this.onDialogSuccessCallback = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
        this.onDialogErrorCallback = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
        this.onDialogCancelCallback = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
        this.issueId = issueId;
        this.transitionId = transitionId;
        this.issueKey = issueKey;
        this.issueKeys = issueKeys;
    }
    static{
        this.onDialogContentReady = ()=>{
            // This event fired by a dialog before the dialog itself is rendered and visible to the user
            // That's why we need to postpone sending the response to the next moment after it became visible
            setTimeout(()=>{
                (0, $emTT1.timeToRenderTransitionModal).stop();
            });
        };
    }
    onDialogSuccess(onDialogSuccessCallback) {
        this.onDialogSuccessCallback = onDialogSuccessCallback;
        return this;
    }
    onDialogError(onDialogErrorCallback) {
        this.onDialogErrorCallback = onDialogErrorCallback;
        return this;
    }
    onDialogCancel(onDialogCancelCallback) {
        this.onDialogCancelCallback = onDialogCancelCallback;
        return this;
    }
    getIssueParam() {
        if (this.issueId != null) return `id=${this.issueId}`;
        if (this.issueKey != null) return `key=${this.issueKey}`;
        return '';
    }
    getUrl() {
        const { issueKeys: issueKeys } = this;
        if (issueKeys != null) // key= is needed to be sent together with keys= because of legacy API
        return `/secure/BulkTransitionIssue!default.jspa?keys=${issueKeys.join(',')}&key=${issueKeys[0]}&action=${this.transitionId}&atl_token=${(0, $4tcSU.default)() || ''}&decorator=dialog&inline=true&returnUrl=`;
        return `/secure/WorkflowUIDispatcher.jspa?${this.getIssueParam()}&action=${this.transitionId}&atl_token=${(0, $4tcSU.default)() || ''}&returnUrl=`;
    }
    async show() {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('legacyJiraDialogContentReady', $25bfe0b90f22578e$export$2e2bcd8739ae039.onDialogContentReady);
        let FormDialog;
        /**
		 * Trying out different ways of load the AMD bundle for legacy issue transition dialog
		 */ /* eslint-disable jira/wrm/no-load-bridge */ if ((0, $4R6GH.fg)('legacy-its-modal-load-with-load-bridge-weak')) FormDialog = await (0, $9B86Q.loadBridgeWeak)({
            name: 'jira/dialog/form-dialog'
        });
        else if ((0, $4R6GH.fg)('legacy-its-modal-load-with-load-bridge-strict')) {
            await (0, $cQZXC.waitForHeritage)();
            FormDialog = await (0, $7T84i.loadBridgeStrict)({
                name: 'jira/dialog/form-dialog',
                wrmKeys: [
                    'wrc!jira.webresources:dialogs'
                ]
            });
        } else if ((0, $4R6GH.fg)('legacy-issue-transition-load-bridge')) {
            await (0, $8JNtu.wrmRequire)([
                'wrc!jira.webresources:dialogs'
            ]);
            FormDialog = await (0, $ig88W.loadBridgeRace)({
                name: 'jira/dialog/form-dialog',
                timeout: 2000
            });
        } else FormDialog = await (0, $6BZYo.loadBridge)({
            name: 'jira/dialog/form-dialog',
            wrmKeys: 'wrc!jira.webresources:dialogs'
        });
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const dialog = new FormDialog({
            id: 'edit-issue-dialog',
            ajaxOptions: {
                url: this.getUrl(),
                dataType: 'json'
            },
            autoClose: true,
            widthClass: 'large',
            onDialogFinished: this.onDialogSuccessCallback,
            onUnSuccessfulSubmit: this.onDialogErrorCallback,
            shouldLoadHeritageFormDialogContext: true
        });
        const cancelNativeHandler = (event)=>{
            if (!(event instanceof CustomEvent)) return;
            const dialogElement = event.detail.popup;
            const { reason: reason } = event.detail;
            if (dialogElement.is(dialog.get$popup())) {
                if (reason === 'cancel' || reason === 'esc') this.onDialogCancelCallback(event, dialogElement, reason);
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                document.removeEventListener('legacyJiraDialogBeforeHide', cancelNativeHandler);
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                document.removeEventListener('legacyJiraDialogContentReady', $25bfe0b90f22578e$export$2e2bcd8739ae039.onDialogContentReady);
            }
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('legacyJiraDialogBeforeHide', cancelNativeHandler);
        dialog.show();
    }
}

});
parcelRegister("emTT1", function(module, exports) {

$parcel$export(module.exports, "timeToRenderTransitionModal", () => $4a78c80c71ff3414$export$9d20a86383e90d09);

var $dGrdR = parcelRequire("dGrdR");
const $4a78c80c71ff3414$export$9d20a86383e90d09 = (0, $dGrdR.metrics).interaction({
    key: 'issue.time-to.render-issue-transition-screen',
    // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
    histogram: {
        result: '500_1000_2500_4000_7000_10000'
    }
});

});


parcelRegister("jtjyW", function(module, exports) {

$parcel$export(module.exports, "startIssueTransitionMetrics", () => $1832266ecf87e128$export$3fc439100e136a52);

var $eTXmK = parcelRequire("eTXmK");

var $lL2Jl = parcelRequire("lL2Jl");

var $lP1Jn = parcelRequire("lP1Jn");

var $fc6nm = parcelRequire("fc6nm");
const $1832266ecf87e128$export$3fc439100e136a52 = (isSubsequentLoad)=>{
    (0, $lL2Jl.IssueTransitionLoadUFOExperience).start();
    (0, $lL2Jl.IssueTransitionUFOExperience).start();
    const issueTransitionModalLoadMetric = isSubsequentLoad ? (0, $lP1Jn.issueTransittionModalLoadSubsequent) : (0, $lP1Jn.issueTransitionModalLoad);
    if (isSubsequentLoad) (0, $eTXmK.default)('issue-transition.transition-modal-subsequent');
    else (0, $eTXmK.default)('issue-transition.transition-modal');
    issueTransitionModalLoadMetric.start();
    (0, $fc6nm.startUimTTI)();
};

});
parcelRegister("lL2Jl", function(module, exports) {

$parcel$export(module.exports, "IssueTransitionLoadUFOExperience", () => $f07939f1a4892f29$export$8fb308d8abecd81a);
$parcel$export(module.exports, "IssueTransitionSubmitUFOExpereince", () => $f07939f1a4892f29$export$bd3bf8b90a131c50);
$parcel$export(module.exports, "IssueTransitionUFOExperience", () => $f07939f1a4892f29$export$2f3b26e8acf79182);

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");
const $f07939f1a4892f29$export$8fb308d8abecd81a = new (0, $duUGa.UFOExperience)('issue-transition-screen.transition-load', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom,
    category: 'issue-transition-screen.transition-load'
});
const $f07939f1a4892f29$export$bd3bf8b90a131c50 = new (0, $duUGa.UFOExperience)('issue-transition-screen.transition-submit', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom,
    category: 'issue-transition-screen.transition-sumbit'
});
const $f07939f1a4892f29$export$2f3b26e8acf79182 = new (0, $duUGa.UFOExperience)('issue-transition-screen.transition-issue', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom,
    category: 'issue-transition-screen.transition-issue'
});

});

parcelRegister("lP1Jn", function(module, exports) {

$parcel$export(module.exports, "issueTransitionModalLoad", () => $e48205cb6c384272$export$772fb4a8bd181fd6);
$parcel$export(module.exports, "issueTransittionModalLoadSubsequent", () => $e48205cb6c384272$export$afa89f024c56a00a);

var $dGrdR = parcelRequire("dGrdR");
const $e48205cb6c384272$export$772fb4a8bd181fd6 = (0, $dGrdR.metrics).interaction({
    key: 'issue-transition-modal'
});
const $e48205cb6c384272$export$afa89f024c56a00a = (0, $dGrdR.metrics).interaction({
    key: 'issue-transition-modal-subsequent'
});

});

parcelRegister("fc6nm", function(module, exports) {

$parcel$export(module.exports, "startUimTTI", () => $50f6a9f98192a4eb$export$ae34c17d9cd2c876);
$parcel$export(module.exports, "markIssueTransitionLoaded", () => $50f6a9f98192a4eb$export$7cc1bb35860c7c25);
$parcel$export(module.exports, "stopTTI", () => $50f6a9f98192a4eb$export$30ca4c461fab486c);
$parcel$export(module.exports, "cancelTTI", () => $50f6a9f98192a4eb$export$27f2445288b528c);
$parcel$export(module.exports, "markIframeLoad", () => $50f6a9f98192a4eb$export$7a2709fc1e33401a);
$parcel$export(module.exports, "markFieldsRegistered", () => $50f6a9f98192a4eb$export$cf3893335c93e33b);
$parcel$export(module.exports, "markOnInitResolved", () => $50f6a9f98192a4eb$export$d86f4868694f2aa7);
/**
 * For issue view, we moved similar constants to view-specific packages.
 * However, for issue-transition, such a move causes a circular dependency with @atlassian/jira-issue-transition-trigger package,
 * since view-specific/issue-transition imports trigger points related functionality from @atlassian/jira-issue-transition-trigger.
 * Therefore, for now, let's keep it here.
 */ 
var $dGrdR = parcelRequire("dGrdR");
const $50f6a9f98192a4eb$var$uimInIssueTransitionTTI = (0, $dGrdR.metrics).interaction({
    key: 'ui-modifications-in-issue-transition',
    timings: [
        {
            key: 'issue-transition-tti-delta',
            startMark: 'issue-transition-tti'
        },
        {
            key: 'script-execution',
            startMark: 'iframe-load'
        },
        {
            key: 'loading-indicators-visibility',
            startMark: 'fields-registered'
        },
        {
            key: 'time-until-oninit-resolved',
            endMark: 'oninit-resolved'
        }
    ]
});
const $50f6a9f98192a4eb$export$ae34c17d9cd2c876 = ()=>{
    $50f6a9f98192a4eb$var$uimInIssueTransitionTTI.start();
};
const $50f6a9f98192a4eb$export$7cc1bb35860c7c25 = ()=>$50f6a9f98192a4eb$var$uimInIssueTransitionTTI.mark('issue-transition-tti');
const $50f6a9f98192a4eb$export$30ca4c461fab486c = (customData)=>{
    $50f6a9f98192a4eb$var$uimInIssueTransitionTTI.stop({
        customData: customData
    });
};
const $50f6a9f98192a4eb$export$27f2445288b528c = ()=>{
    $50f6a9f98192a4eb$var$uimInIssueTransitionTTI.cancel();
};
const $50f6a9f98192a4eb$export$7a2709fc1e33401a = ()=>{
    $50f6a9f98192a4eb$var$uimInIssueTransitionTTI.mark('iframe-load');
};
const $50f6a9f98192a4eb$export$cf3893335c93e33b = ()=>{
    $50f6a9f98192a4eb$var$uimInIssueTransitionTTI.mark('fields-registered');
};
const $50f6a9f98192a4eb$export$d86f4868694f2aa7 = ()=>{
    $50f6a9f98192a4eb$var$uimInIssueTransitionTTI.mark('oninit-resolved');
};

});


parcelRegister("jHYHS", function(module, exports) {

$parcel$export(module.exports, "isNewTransitionScreenEnabled", () => $5f3a7dc1f1182e00$export$1f5b72e7dbe0548d);

var $c04PQ = parcelRequire("c04PQ");

var $4R6GH = parcelRequire("4R6GH");
const $5f3a7dc1f1182e00$export$1f5b72e7dbe0548d = (preferNewIssueTransitionScreen, triggerPointKey)=>{
    if ((0, $c04PQ.isFedRamp)()) return true;
    if (!(0, $4R6GH.fg)('render-modern-issue-transition')) return false;
    if (!triggerPointKey) return false;
    return preferNewIssueTransitionScreen || (0, $4R6GH.fg)('issue-transition-customisation-for-srb');
};

});


parcelRegister("keQtD", function(module, exports) {

$parcel$export(module.exports, "default", () => $9984214aecd9b0cd$export$2e2bcd8739ae039);
const $9984214aecd9b0cd$var$restoreState = (stateToRestore)=>({ setState: setState })=>{
        setState(stateToRestore);
    };
var $9984214aecd9b0cd$export$2e2bcd8739ae039 = $9984214aecd9b0cd$var$restoreState;

});

parcelRegister("fb5Xn", function(module, exports) {

$parcel$export(module.exports, "default", () => $58f04f71b4951234$export$2e2bcd8739ae039);
/**
 *
 * @deprecated since we should not be using this in the log run
 * we should not call this method any where and should clean this up as soon as GIC-JIS migration is done
 * @param issueId
 * @returns
 */ const $58f04f71b4951234$var$setFetchedIssueId = (issueId)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const { fetchedIssueId: fetchedIssueId } = currentState;
        if (issueId !== fetchedIssueId) setState({
            ...currentState,
            fetchedIssueId: issueId
        });
    };
var $58f04f71b4951234$export$2e2bcd8739ae039 = $58f04f71b4951234$var$setFetchedIssueId;

});

parcelRegister("bemkp", function(module, exports) {

$parcel$export(module.exports, "default", () => $66c42f9cd1814e06$export$2e2bcd8739ae039);

var $QnL9H = parcelRequire("QnL9H");

var $jtjyW = parcelRequire("jtjyW");
const $66c42f9cd1814e06$var$hideBenefitsModal = (nextAction)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        if (nextAction === (0, $QnL9H.OPEN_MODERN_TRANSITION_MODAL)) {
            (0, $jtjyW.startIssueTransitionMetrics)(currentState.isSubsequentLoad);
            setState({
                ...currentState,
                isBenefitsModalOpen: false,
                isModalOpen: true
            });
        } else if (nextAction === (0, $QnL9H.OPEN_LEGACY_TRANSITION_MODAL)) {
            const { openLegacyTransitionsDialog: openLegacyTransitionsDialog } = getState();
            setState({
                ...currentState,
                isBenefitsModalOpen: false,
                isModalOpen: false
            });
            openLegacyTransitionsDialog?.();
        }
    };
var $66c42f9cd1814e06$export$2e2bcd8739ae039 = $66c42f9cd1814e06$var$hideBenefitsModal;

});

parcelRegister("bnv5t", function(module, exports) {

$parcel$export(module.exports, "default", () => $0522276a96c69778$export$2e2bcd8739ae039);

var $8Rkzz = parcelRequire("8Rkzz");

var $eVcDT = parcelRequire("eVcDT");

var $emTT1 = parcelRequire("emTT1");

var $lTEVZ = parcelRequire("lTEVZ");

var $4R6GH = parcelRequire("4R6GH");

var $jtjyW = parcelRequire("jtjyW");

var $jHYHS = parcelRequire("jHYHS");
const $0522276a96c69778$var$openIssueTransitionModalNew = ({ nextState: nextState, preferNewIssueTransitionScreen: preferNewIssueTransitionScreen = true, issueViewAnalyticsSource: issueViewAnalyticsSource, publishTriggerToOpenTransitions: publishTriggerToOpenTransitions, isBenefitsModalDisabled: isBenefitsModalDisabled, dateToShowBenefitsModal: dateToShowBenefitsModal, fireUIEvent: fireUIEvent })=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const { payload: { issueKey: issueKey = '', transitionId: transitionId = '' }, onDialogSuccess: onDialogSuccess, onDialogCancel: onDialogCancel, onDialogError: onDialogError, triggerPointKey: triggerPointKey } = nextState || {
            payload: {}
        };
        let transitionModalVersion = '';
        const isNewITSEnabled = (0, $jHYHS.isNewTransitionScreenEnabled)(preferNewIssueTransitionScreen, triggerPointKey);
        try {
            if (isNewITSEnabled) {
                if (issueViewAnalyticsSource === 'connect-issue') {
                    publishTriggerToOpenTransitions?.(nextState, preferNewIssueTransitionScreen);
                    fireUIEvent?.({
                        actionSubject: 'issueTransition',
                        actionSubjectId: 'connectIssue',
                        action: 'opened'
                    });
                    return;
                }
                transitionModalVersion = 'NEW';
                (0, $jtjyW.startIssueTransitionMetrics)(currentState.isSubsequentLoad);
                setState({
                    ...currentState,
                    isModalOpen: true,
                    // making fetchedIssueId as blank to ensure we donot end up using stale issueId
                    fetchedIssueId: '',
                    ...nextState
                });
                return;
            }
            const currentDate = new Date();
            const showBenefitsModalOnDate = dateToShowBenefitsModal && dateToShowBenefitsModal !== 'null' ? new Date(dateToShowBenefitsModal) : new Date(-1);
            const isDateToShowBenefitsModalLessThanCurrentDate = currentDate >= showBenefitsModalOnDate;
            if (!isBenefitsModalDisabled && issueViewAnalyticsSource !== 'connect-issue' && isDateToShowBenefitsModalLessThanCurrentDate && (0, $4R6GH.fg)('render-modern-issue-transition')) {
                // add condition to show BenefitsModal
                transitionModalVersion = 'NEW';
                const callback = ()=>{
                    (0, $emTT1.timeToRenderTransitionModal).start();
                    new (0, $eVcDT.default)({
                        issueKey: issueKey,
                        transitionId: transitionId
                    }).onDialogSuccess(onDialogSuccess || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).onDialogCancel(onDialogCancel || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).onDialogError(onDialogError || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).show();
                };
                setState({
                    ...currentState,
                    isBenefitsModalOpen: true,
                    // making fetchedIssueId as blank to ensure we donot end up using stale issueId
                    fetchedIssueId: '',
                    ...nextState,
                    openLegacyTransitionsDialog: callback
                });
            } else {
                transitionModalVersion = 'OLD';
                (0, $emTT1.timeToRenderTransitionModal).start();
                new (0, $eVcDT.default)({
                    issueKey: issueKey,
                    transitionId: transitionId
                }).onDialogSuccess(onDialogSuccess || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).onDialogCancel(onDialogCancel || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).onDialogError(onDialogError || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).show();
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $lTEVZ.fireIssueTransitionErrorAnalytics)({
                meta: {
                    id: 'transitionIssueTrigger',
                    packageName: 'jiraIssueTransitionTrigger',
                    teamName: 'gryffindor'
                },
                error: error,
                attributes: {
                    transitionModalVersion: transitionModalVersion
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
var $0522276a96c69778$export$2e2bcd8739ae039 = $0522276a96c69778$var$openIssueTransitionModalNew;

});



parcelRegister("ipUU1", function(module, exports) {

$parcel$export(module.exports, "openLegacyIssueTransitionModal", () => $f258fa9a0604f29b$export$6bfef2005bd55204);

var $8Rkzz = parcelRequire("8Rkzz");

var $eVcDT = parcelRequire("eVcDT");

var $emTT1 = parcelRequire("emTT1");

var $lTEVZ = parcelRequire("lTEVZ");
const $f258fa9a0604f29b$export$6bfef2005bd55204 = ({ issueKey: issueKey, transitionId: transitionId, onDialogSuccess: onDialogSuccess, onDialogCancel: onDialogCancel, onDialogError: onDialogError, isReopenScenario: isReopenScenario = false, onOpenDialog: onOpenDialog })=>{
    try {
        (0, $emTT1.timeToRenderTransitionModal).start();
        new (0, $eVcDT.default)({
            issueKey: issueKey,
            transitionId: transitionId
        }).onDialogSuccess(onDialogSuccess || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).onDialogCancel(onDialogCancel || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).onDialogError(onDialogError || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).show();
        onOpenDialog?.();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $lTEVZ.fireIssueTransitionErrorAnalytics)({
            meta: {
                id: 'transitionIssueTrigger',
                packageName: 'jiraIssueTransitionTrigger',
                teamName: 'gryffindor'
            },
            error: error,
            attributes: {
                transitionModalVersion: 'OLD',
                isReopenScenario: isReopenScenario
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});


parcelRegister("dTUtq", function(module, exports) {

$parcel$export(module.exports, "useShowFlag", () => $4e3d7d0cd8105532$export$46b5557ad4264ef7);

var $5uXOq = parcelRequire("5uXOq");

var $lTEVZ = parcelRequire("lTEVZ");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $koiRX = parcelRequire("koiRX");

var $6OtcO = parcelRequire("6OtcO");
const $4e3d7d0cd8105532$export$46b5557ad4264ef7 = ()=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [workType] = (0, $koiRX.useIssueTypeName)();
    const showIssueTransitionSuccessFlag = (0, $5uXOq.useCallback)((issueKey, status)=>{
        try {
            showFlag((0, $6OtcO.getTransitionSuccessFlag)(issueKey, status, formatMessage, workType));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $lTEVZ.fireIssueTransitionErrorAnalytics)({
                meta: {
                    id: 'showSuccessFlag',
                    packageName: 'jiraIssueTransitionUseShowFlag',
                    teamName: 'gryffindor'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        formatMessage,
        showFlag,
        workType
    ]);
    const showIssueTransitionFailureFlag = (0, $5uXOq.useCallback)((issueKey, traceId)=>showFlag((0, $6OtcO.getTransitionFailureFlag)(issueKey, formatMessage, traceId, workType)), [
        formatMessage,
        showFlag,
        workType
    ]);
    return {
        showIssueTransitionSuccessFlag: showIssueTransitionSuccessFlag,
        showIssueTransitionFailureFlag: showIssueTransitionFailureFlag
    };
};

});
parcelRegister("6OtcO", function(module, exports) {

$parcel$export(module.exports, "getTransitionSuccessFlag", () => $12ec3642dfb43880$export$8cfa71b43d733669);
$parcel$export(module.exports, "getTransitionFailureFlag", () => $12ec3642dfb43880$export$d9438db72c9548f1);

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $7HGHK = parcelRequire("7HGHK");

var $4O0IR = parcelRequire("4O0IR");
const $12ec3642dfb43880$var$ISSUE_TRANSITION_SUCCESS_FLAG_ID = 'issueTransitionSuccessful';
const $12ec3642dfb43880$var$ISSUE_TRANSITION_FAILURE_FLAG_ID = 'issueTransitionFailure';
const $12ec3642dfb43880$export$8cfa71b43d733669 = (issueKey, status, formatMessage, workType)=>{
    const showLinkToIssue = Boolean(issueKey && status);
    const successFlagTitle = ()=>{
        if (workType && (0, $6s1PB.expVal)('jira-itr-m4-exp-3', 'isEnabled', false)) return formatMessage((0, $4O0IR.default).issueTransitionSuccessfulIssueTerminologyRefreshM4, {
            workType: workType,
            issueKey: issueKey
        });
        return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? formatMessage((0, $4O0IR.default).issueTransitionSuccessfulIssueTermRefresh) : formatMessage((0, $4O0IR.default).issueTransitionSuccessful);
    };
    if (showLinkToIssue) return {
        id: (0, $7HGHK.toFlagId)($12ec3642dfb43880$var$ISSUE_TRANSITION_SUCCESS_FLAG_ID),
        type: 'success',
        title: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $4O0IR.default).issueTransitionSuccessfulWithIssueKeyAndStatusIssueTermRefresh : (0, $4O0IR.default).issueTransitionSuccessfulWithIssueKeyAndStatus, {
            issueKey: issueKey,
            status: status
        }),
        description: (0, $4O0IR.default).issueTransitionSuccessfulFlagDescription,
        messageId: `issue-transition-use-show-flag.ui.use-show-flag.${$12ec3642dfb43880$var$ISSUE_TRANSITION_SUCCESS_FLAG_ID}.success.issueTransitionSuccessfulWithIssueKeyAndStatus`,
        messageType: 'transactional'
    };
    return {
        id: (0, $7HGHK.toFlagId)($12ec3642dfb43880$var$ISSUE_TRANSITION_SUCCESS_FLAG_ID),
        type: 'success',
        title: successFlagTitle(),
        messageId: `issue-transition-use-show-flag.ui.use-show-flag.${$12ec3642dfb43880$var$ISSUE_TRANSITION_SUCCESS_FLAG_ID}.success.issueTransitionSuccessful`,
        messageType: 'transactional'
    };
};
const $12ec3642dfb43880$export$d9438db72c9548f1 = (issueKey, formatMessage, traceId, workType)=>{
    const failureFlagTitle = ()=>{
        if (workType && (0, $6s1PB.expVal)('jira-itr-m4-exp-3', 'isEnabled', false)) return formatMessage((0, $4O0IR.default).issueTransitionFailureIssueTerminologyRefreshM4, {
            workType: workType,
            issueKey: issueKey
        });
        return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? formatMessage((0, $4O0IR.default).issueTransitionFailureIssueTermRefresh) : formatMessage((0, $4O0IR.default).issueTransitionFailure);
    };
    return {
        id: (0, $7HGHK.toFlagId)($12ec3642dfb43880$var$ISSUE_TRANSITION_FAILURE_FLAG_ID),
        type: 'error',
        title: issueKey ? formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $4O0IR.default).issueTransitionFailureWithKeyIssueTermRefresh : (0, $4O0IR.default).issueTransitionFailureWithKey, {
            issueKey: issueKey
        }) : failureFlagTitle(),
        messageId: `issue-transition-use-show-flag.ui.use-show-flag.${$12ec3642dfb43880$var$ISSUE_TRANSITION_FAILURE_FLAG_ID}.error`,
        messageType: 'transactional',
        ...traceId ? {
            traceId: traceId,
            error: new Error('TransitionFailureFlag')
        } : {}
    };
};

});
parcelRegister("4O0IR", function(module, exports) {

$parcel$export(module.exports, "default", () => $d201576bd998790a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d201576bd998790a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    issueTransitionSuccessful: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-successful",
        "defaultMessage": "Issue has been updated."
    },
    issueTransitionSuccessfulWithIssueKeyAndStatus: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-successful-with-issue-key-and-status",
        "defaultMessage": "{issueKey} moved to {status}."
    },
    issueTransitionSuccessfulFlagDescription: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-successful-flag-description",
        "defaultMessage": "Kudos for keeping things up-to-date!"
    },
    issueTransitionFailure: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-failure",
        "defaultMessage": "Issue could not be updated."
    },
    issueTransitionFailureWithKey: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-failure-with-key",
        "defaultMessage": "We couldn't update {issueKey}."
    },
    viewIssue: {
        "id": "issue-transition-use-show-flag.use-show-flag.view-issue",
        "defaultMessage": "View issue"
    },
    issueTransitionSuccessfulIssueTermRefresh: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-successful-issue-term-refresh",
        "defaultMessage": "Work item has been updated."
    },
    issueTransitionSuccessfulIssueTerminologyRefreshM4: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-successful-issue-terminology-refresh-m4",
        "defaultMessage": "Updated {workType} {issueKey}."
    },
    issueTransitionFailureIssueTermRefresh: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-failure-issue-term-refresh",
        "defaultMessage": "Work item could not be updated."
    },
    issueTransitionFailureIssueTerminologyRefreshM4: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-failure-issue-terminology-refresh-m4",
        "defaultMessage": "We can\u2019t update {workType} {issueKey}."
    },
    viewIssueIssueTermRefresh: {
        "id": "issue-transition-use-show-flag.use-show-flag.view-issue-issue-term-refresh",
        "defaultMessage": "View"
    },
    issueTransitionSuccessfulWithIssueKeyAndStatusIssueTermRefresh: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-successful-with-issue-key-and-status-issue-term-refresh",
        "defaultMessage": "{issueKey} moved to {status}."
    },
    issueTransitionFailureWithKeyIssueTermRefresh: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-failure-with-key-issue-term-refresh",
        "defaultMessage": "We couldn't update {issueKey}."
    }
});

});



parcelRegister("k0ahW", function(module, exports) {

$parcel$export(module.exports, "default", () => $022f11dfbb4aab97$export$2e2bcd8739ae039);


var $jJZqs = parcelRequire("jJZqs");
const $022f11dfbb4aab97$var$errorCases4xx = [
    (0, $3cd8a0ece36fbae5$export$9de493bcd9b1d977),
    (0, $3cd8a0ece36fbae5$export$a3269a3914b007e3),
    (0, $3cd8a0ece36fbae5$export$67d19e9a991baa07),
    (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef),
    (0, $3cd8a0ece36fbae5$export$c09e7ea0fc79f34f),
    (0, $3cd8a0ece36fbae5$export$5244030134e99)
];
const $022f11dfbb4aab97$var$statusCodeIs4xx = (statusCode)=>$022f11dfbb4aab97$var$errorCases4xx.some((status)=>status === statusCode);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$022f11dfbb4aab97$export$2e2bcd8739ae039 = (error)=>{
    const isValidationError = error instanceof (0, $jJZqs.ValidationError);
    if (isValidationError) return false;
    const isFetchError = error instanceof (0, $jJZqs.default);
    if (isFetchError && !!error.statusCode && $022f11dfbb4aab97$var$statusCodeIs4xx(error.statusCode)) return false;
    if (error.name === (0, $jJZqs.TYPE_ERROR_NAME) || error.name === (0, $jJZqs.ABORT_ERROR_NAME)) return false;
    return true;
};

});
const $3cd8a0ece36fbae5$export$ff39ebd4bb12b718 = 201;
const $3cd8a0ece36fbae5$export$3288b14b6745c572 = 204;
const $3cd8a0ece36fbae5$export$9de493bcd9b1d977 = 400;
const $3cd8a0ece36fbae5$export$67d19e9a991baa07 = 401;
const $3cd8a0ece36fbae5$export$a3269a3914b007e3 = 403;
const $3cd8a0ece36fbae5$export$8bca792d963eb0ef = 404;
const $3cd8a0ece36fbae5$export$4a3cb39801694eee = 407;
const $3cd8a0ece36fbae5$export$fa405bbf47d510e2 = 408;
const $3cd8a0ece36fbae5$export$c09e7ea0fc79f34f = 409;
const $3cd8a0ece36fbae5$export$5244030134e99 = 412;
const $3cd8a0ece36fbae5$export$f90ac1df0b60853d = 413;
const $3cd8a0ece36fbae5$export$a447d0a965e16776 = 422;
const $3cd8a0ece36fbae5$export$3b48aba8957000cd = 426;
const $3cd8a0ece36fbae5$export$6763168a631449a2 = 429;
const $3cd8a0ece36fbae5$export$e813cd7045fcc98d = 500;
const $3cd8a0ece36fbae5$export$2ce38d41a306034e = 502;
const $3cd8a0ece36fbae5$export$974c37534b0191b1 = 503;
const $3cd8a0ece36fbae5$export$5400e8dddac3fcf3 = 504;


parcelRegister("aubl2", function(module, exports) {

$parcel$export(module.exports, "useWorkflowTransitionsValue", () => $8cffab54c7064731$export$435cba24c8d1ddf6);
$parcel$export(module.exports, "useWorkflowTransitionsTransitionInProgress", () => $8cffab54c7064731$export$9b35656991b0ecda);
$parcel$export(module.exports, "useWorkflowTransitionsActions", () => $8cffab54c7064731$export$d5245ade1619037b);

var $5uXOq = parcelRequire("5uXOq");

var $4PVOa = parcelRequire("4PVOa");
const $8cffab54c7064731$export$435cba24c8d1ddf6 = ()=>{
    const [value, { setState: setState }] = (0, $4PVOa.useWorkflowTransitionsStoreValue)();
    return [
        value,
        setState
    ];
};
const $8cffab54c7064731$export$9b35656991b0ecda = ()=>{
    const [value] = (0, $4PVOa.useWorkflowTransitionsStoreTransitionInProgress)();
    return value;
};
const $8cffab54c7064731$export$d5245ade1619037b = ()=>{
    const [, actions] = (0, $4PVOa.useWorkflowTransitionsStoreActions)();
    const workflowActions = (0, $5uXOq.useMemo)(()=>{
        // @ts-expect-error - TS7006 - Parameter 'partialState' implicitly has an 'any' type.
        const setState = (partialState)=>{
            actions.setState(partialState);
        };
        const setTransitionInProgress = (isLoading)=>{
            actions.setTransitionInProgress(isLoading);
        };
        return {
            setState: setState,
            setTransitionInProgress: setTransitionInProgress
        };
    }, [
        actions
    ]);
    return [
        null,
        workflowActions
    ];
};

});
parcelRegister("4PVOa", function(module, exports) {

$parcel$export(module.exports, "useWorkflowTransitionsStoreValue", () => $e5b56d683dce601e$export$435e780321f76edc);
$parcel$export(module.exports, "useWorkflowTransitionsStoreTransitionInProgress", () => $e5b56d683dce601e$export$35c153667c57d035);
$parcel$export(module.exports, "useWorkflowTransitionsStoreActions", () => $e5b56d683dce601e$export$370707f36c1f66df);
$parcel$export(module.exports, "WorkflowTransitionsStoreContainer", () => $e5b56d683dce601e$export$1e23e2bdfc599859);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $7maqj = parcelRequire("7maqj");
const $e5b56d683dce601e$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: 'workflow-transitions',
    initialState: {
        data: null,
        loading: false,
        error: null,
        ui: {
            transitionInProgress: false
        }
    },
    actions: $7maqj.actions
});
const $e5b56d683dce601e$export$435e780321f76edc = (0, $3sQ5x.createHook)($e5b56d683dce601e$export$6f57813fe9f31bf9, {
    selector: (state)=>state
});
const $e5b56d683dce601e$export$35c153667c57d035 = (0, $3sQ5x.createHook)($e5b56d683dce601e$export$6f57813fe9f31bf9, {
    selector: (state)=>state.ui.transitionInProgress
});
const $e5b56d683dce601e$export$370707f36c1f66df = (0, $3sQ5x.createHook)($e5b56d683dce601e$export$6f57813fe9f31bf9, {
    selector: null
});
const $e5b56d683dce601e$export$1e23e2bdfc599859 = (0, $gg7kZ.createContainer)($e5b56d683dce601e$export$6f57813fe9f31bf9);

});
parcelRegister("7maqj", function(module, exports) {

$parcel$export(module.exports, "actions", () => $d085cbf81f7ccf7c$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $d085cbf81f7ccf7c$var$setState = (state = {})=>({ setState: setSweetState, getState: getState })=>{
        const newState = {
            ...getState(),
            ...state
        };
        setSweetState(newState);
    };
const $d085cbf81f7ccf7c$export$c4d3076bd1999d92 = (transitionInProgress)=>({ setState: setSweetState, getState: getState })=>{
        setSweetState({
            ui: {
                ...getState().ui,
                transitionInProgress: transitionInProgress
            }
        });
    };
const $d085cbf81f7ccf7c$export$e324594224ef24da = {
    setState: $d085cbf81f7ccf7c$var$setState,
    setTransitionInProgress: $d085cbf81f7ccf7c$export$c4d3076bd1999d92
};

});



parcelRegister("6r7fT", function(module, exports) {

$parcel$export(module.exports, "trackOrLogClientError", () => $cdae82c8a9c247d5$export$2fc29872103bf255);
$parcel$export(module.exports, "isAbortableError", () => $cdae82c8a9c247d5$export$e05e0fb17c2ab75a);

var $2YZCu = parcelRequire("2YZCu");

var $jcw0u = parcelRequire("jcw0u");

var $fZneA = parcelRequire("fZneA");

var $3vXOY = parcelRequire("3vXOY");

var $jJZqs = parcelRequire("jJZqs");
const $cdae82c8a9c247d5$export$c392d6295c0a29c7 = (location, message, error)=>{
    (0, $jcw0u.default)({
        error: error,
        attributes: {
            message: message
        },
        meta: {
            id: location,
            packageName: 'jiraIssueViewCommonUtils'
        }
    });
};
const $cdae82c8a9c247d5$export$2fc29872103bf255 = (location, message, error)=>{
    if (error instanceof TypeError && (0, $fZneA.isClientFetchError)(error)) $cdae82c8a9c247d5$export$c392d6295c0a29c7(location, message, error);
    else (0, $2YZCu.default).safeErrorWithoutCustomerData(location, message, error);
};
const $cdae82c8a9c247d5$export$e05e0fb17c2ab75a = (error)=>{
    const statusCode = (0, $3vXOY.extractStatusCode)(error);
    if ((0, $fZneA.isHttpClientErrorStatusCode)(statusCode) || !statusCode && (0, $fZneA.isClientFetchError)(error) || error?.name === (0, $jJZqs.VALIDATION_ERROR_NAME)) return true;
    return false;
};

});
parcelRegister("3vXOY", function(module, exports) {

$parcel$export(module.exports, "getStatusCodeFromGraphQLErrors", () => $47b135a1579c5003$export$37c7f88726f3fb5e);
$parcel$export(module.exports, "extractStatusCode", () => $47b135a1579c5003$export$1fdf7c1c0741a7e7);

var $9XE6b = parcelRequire("9XE6b");

var $fEeCa = parcelRequire("fEeCa");
const $47b135a1579c5003$export$37c7f88726f3fb5e = (graphQLErrors)=>{
    const statusCodes = graphQLErrors.map((e)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(e, [
            'extensions',
            'statusCode'
        ])).filter((statusCode)=>!!statusCode);
    const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($fEeCa)))(statusCodes);
    return statusCode || null;
};
const $47b135a1579c5003$export$1fdf7c1c0741a7e7 = (error)=>{
    const errorStatusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'statusCode'
    ], null);
    const graphQLErrors = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'graphQLErrors'
    ], null);
    const networkError = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'networkError'
    ], null);
    const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(networkError, [
        'statusCode'
    ], null);
    if (typeof errorStatusCode === 'number') return errorStatusCode;
    if (typeof statusCode === 'number') return statusCode;
    if (Array.isArray(graphQLErrors) && graphQLErrors.length > 0) return $47b135a1579c5003$export$37c7f88726f3fb5e(graphQLErrors);
    return null;
};

});
parcelRegister("fEeCa", function(module, exports) {

var $la2vn = parcelRequire("la2vn");

var $5JMmU = parcelRequire("5JMmU");

var $etyzk = parcelRequire("etyzk");
/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */ function $b645ed9a7ba1767e$var$max(array) {
    return array && array.length ? $la2vn(array, $etyzk, $5JMmU) : undefined;
}
module.exports = $b645ed9a7ba1767e$var$max;

});
parcelRegister("la2vn", function(module, exports) {

var $4faK3 = parcelRequire("4faK3");
/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */ function $f67c7999c5b61dcb$var$baseExtremum(array, iteratee, comparator) {
    var index = -1, length = array.length;
    while(++index < length){
        var value = array[index], current = iteratee(value);
        if (current != null && (computed === undefined ? current === current && !$4faK3(current) : comparator(current, computed))) var computed = current, result = value;
    }
    return result;
}
module.exports = $f67c7999c5b61dcb$var$baseExtremum;

});

parcelRegister("5JMmU", function(module, exports) {
/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */ function $42d6acb577163acc$var$baseGt(value, other) {
    return value > other;
}
module.exports = $42d6acb577163acc$var$baseGt;

});




const $878fbedb9c4ca329$export$71a8e2ae8cfade56 = 'issue-field.status.fetch-transitions';
const $878fbedb9c4ca329$export$25529a3376b831fd = 'issue-field.status.post-transition';
const $878fbedb9c4ca329$export$4bf6353caa97e8e7 = 'issue-field.status.fetch-view-workflow';
const $878fbedb9c4ca329$export$136fc24ec1bfcefd = 'VIEW_READONLY_WORKFLOW';
const $878fbedb9c4ca329$export$624e7abc8d9cada5 = 'ADMINISTER';

const $5101b286174175c1$export$a6eb4c39beb71474 = 'issue-transition-status-field';

parcelRegister("270P6", function(module, exports) {

$parcel$export(module.exports, "transitionIssueExperienceDescription", () => $435fd9ced643a015$export$1afc7ca514c2b5b9);

var $4Pf62 = parcelRequire("4Pf62");

var $4R6GH = parcelRequire("4R6GH");

var $efvDm = parcelRequire("efvDm");

var $ldyPw = parcelRequire("ldyPw");
const $435fd9ced643a015$export$1afc7ca514c2b5b9 = (wasSuccessful, method, analyticsSource, projectType, errorMessage, traceId, statusCode, action)=>{
    let application = null;
    let edition = null;
    if (projectType !== null) try {
        const { appEditions: appEditions } = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
        application = (0, $efvDm.getApplicationForProject)(projectType);
        edition = (0, $ldyPw.getEdition)(application, appEditions);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    // application and edition already default to null.
    }
    // Flow sadly cannot do multiple spreads in one object, and additionalAttributes
    // cannot potentially contain fields as undefined.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const additionalAttributes = {};
    if (errorMessage != null) additionalAttributes.errorMessage = errorMessage;
    if (traceId != null) additionalAttributes.traceId = traceId;
    if (statusCode) additionalAttributes.statusCode = statusCode;
    const newExperience = method === 'POST' ? 'transitionIssue' : 'getTransitions';
    const experience = (0, $4R6GH.fg)('thor_resolve_transition_event_gate') ? newExperience : 'transitionIssue';
    return {
        experience: experience,
        action: action,
        wasExperienceSuccesful: wasSuccessful,
        analyticsSource: analyticsSource,
        application: application,
        edition: edition,
        additionalAttributes: {
            ...additionalAttributes,
            method: method
        }
    };
};

});

parcelRegister("d7lJH", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf133abbd76f3557$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $bf133abbd76f3557$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "issue-field-status.services.flags.transition-failed-error.main.title",
        "defaultMessage": "We couldn't update the status"
    },
    description: {
        "id": "issue-field-status.services.flags.transition-failed-error.main.description",
        "defaultMessage": "Check your network connection, then try reloading the issue."
    }
});
const $bf133abbd76f3557$var$statusTransitionErrorFlag = (flagConfig)=>({
        messageId: `issue.fields.status.services.flags.transition-failed-error.flag.error.${flagConfig?.error?.name}`,
        messageType: 'transactional',
        type: 'error',
        title: $bf133abbd76f3557$var$messages.title,
        description: $bf133abbd76f3557$var$messages.description,
        isAutoDismiss: true,
        ...flagConfig || {}
    });
var $bf133abbd76f3557$export$2e2bcd8739ae039 = $bf133abbd76f3557$var$statusTransitionErrorFlag;

});

parcelRegister("55hg5", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d918a4398288451$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $7d918a4398288451$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "issue-field-status.services.flags.validation-error.main.title",
        "defaultMessage": "Transition failed"
    }
});
const $7d918a4398288451$var$statusTransitionValidationErrorFlag = (description)=>({
        messageId: 'issue-field-status.services.flags.validation-error.flag.warning.error',
        messageType: 'transactional',
        type: 'warning',
        title: $7d918a4398288451$var$messages.title,
        description: {
            id: 'issue-field.status.services.flags.validation-error.main.description',
            defaultMessage: description
        },
        isAutoDismiss: true
    });
var $7d918a4398288451$export$2e2bcd8739ae039 = $7d918a4398288451$var$statusTransitionValidationErrorFlag;

});


parcelRegister("bUXoM", function(module, exports) {

$parcel$export(module.exports, "TransitionsQuery", () => $16e688304a9816fa$export$e166c7039d71);

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $7iJwP = parcelRequire("7iJwP");

var $crJh3 = parcelRequire("crJh3");
const $16e688304a9816fa$export$e166c7039d71 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "issue.fields.status.transitions-query"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJwP.default), {
        id: "fields.status.transitions-query",
        packageName: "jiraIssueFieldStatus",
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $crJh3.TransitionsQuery), props)));

});
parcelRegister("crJh3", function(module, exports) {

$parcel$export(module.exports, "getStatusTransitionsUrl", () => $d2bb6497d10e73da$export$661439a50b90a96f);
$parcel$export(module.exports, "TransitionsQuery", () => $d2bb6497d10e73da$export$e166c7039d71);

var $5uXOq = parcelRequire("5uXOq");

var $cb25w = parcelRequire("cb25w");

var $4R6GH = parcelRequire("4R6GH");

var $7f4tk = parcelRequire("7f4tk");

var $3fAi8 = parcelRequire("3fAi8");

var $gXz4p = parcelRequire("gXz4p");

var $6r7fT = parcelRequire("6r7fT");

var $k0ahW = parcelRequire("k0ahW");

var $4PVOa = parcelRequire("4PVOa");

var $aubl2 = parcelRequire("aubl2");

var $8zOmE = parcelRequire("8zOmE");

var $2vSU6 = parcelRequire("2vSU6");

var $2gCtH = parcelRequire("2gCtH");

var $cSD7y = parcelRequire("cSD7y");

var $93Yeu = parcelRequire("93Yeu");

var $k9JTq = parcelRequire("k9JTq");

var $ldyPw = parcelRequire("ldyPw");

var $6s1PB = parcelRequire("6s1PB");


var $270P6 = parcelRequire("270P6");

var $399w3 = parcelRequire("399w3");

var $iLLko = parcelRequire("iLLko");
const $d2bb6497d10e73da$export$661439a50b90a96f = (_baseUrl, issueKey)=>`/rest/api/2/issue/${issueKey}/transitions?sortByOpsBarAndStatus=true`;
const $d2bb6497d10e73da$var$enhancedSendExperienceAnalytics = (successful, projectType, errorMessage, traceId, statusCode, source, action)=>{
    const description = typeof errorMessage === 'string' || (0, $4R6GH.fg)('thor_resolve_transition_event_gate') ? (0, $270P6.transitionIssueExperienceDescription)(successful, 'GET', (0, $4R6GH.fg)('thor_resolve_transition_event_gate') ? source ?? '' : 'Issue View BaseTransitionsQuery', projectType || null, errorMessage, traceId, statusCode, action) : (0, $270P6.transitionIssueExperienceDescription)(successful, 'GET', (0, $4R6GH.fg)('thor_resolve_transition_event_gate') ? source ?? '' : 'Issue View BaseTransitionsQuery', projectType || null);
    (0, $gXz4p.sendExperienceAnalytics)(description);
};
const $d2bb6497d10e73da$export$4f5a845fd57540e7 = (props)=>{
    const { status: status, issueKey: issueKey, baseUrl: baseUrl, projectType: projectType, preFetch: preFetch, createAnalyticsEvent: createAnalyticsEvent, isSaving: isSaving, source: source } = props;
    const [transitionsState, setTransitionsState] = (0, $aubl2.useWorkflowTransitionsValue)();
    const isSingletonRequestRef = (0, $5uXOq.useRef)(false);
    // This is a workaround to ensure that the loading state is up to date in useEffect
    // without it leading to an infinite loop.
    const isTransitionStateLoading = (0, $5uXOq.useRef)(transitionsState.loading);
    isTransitionStateLoading.current = transitionsState.loading;
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const isSimplifiedProject = (0, $93Yeu.useIsSimplifiedProject)(projectKey);
    const appEditions = (0, $k9JTq.useAppEditions)();
    const isStatusMoveExperimentEnabled = (0, $5uXOq.useMemo)(()=>{
        const isJSWFreeOrStandard = projectType === (0, $2vSU6.SOFTWARE_PROJECT) && (appEditions?.software === (0, $ldyPw.FREE_EDITION) || appEditions?.software === (0, $ldyPw.STANDARD_EDITION));
        const isJWMFreeOrStandard = projectType === (0, $2vSU6.CORE_PROJECT) && (appEditions?.core === (0, $ldyPw.FREE_EDITION) || appEditions?.core === (0, $ldyPw.STANDARD_EDITION));
        const isStatusPositionExperimentEnabledForTMP = (isSimplifiedProject ?? false) && (isJSWFreeOrStandard || isJWMFreeOrStandard) && (0, $6s1PB.expVal)('jira-mie-state-position-exp', 'isStatusPositionExperimentEnabled', false);
        const isStatusPositionExperimentEnabledForCMP = isSimplifiedProject === false && (isJSWFreeOrStandard || isJWMFreeOrStandard) && (0, $6s1PB.expVal)('move-resolution-next-to-status', 'isStatusExperimentEnabled', false);
        return isStatusPositionExperimentEnabledForTMP || isStatusPositionExperimentEnabledForCMP;
    }, [
        projectType,
        isSimplifiedProject,
        appEditions
    ]);
    const [fieldValues] = (0, $3fAi8.useFieldsValues)(issueKey);
    const { fetchTransitions: fetchTransitions } = (0, $4R6GH.fg)('relay-migration-issue-fields-status') ? (0, $399w3.useFetchTransitionsForStatusField)({
        issueKey: issueKey
    }) : {
        fetchTransitions: ()=>[]
    };
    const fetch = (0, $5uXOq.useCallback)(async (event)=>{
        if (!isStatusMoveExperimentEnabled && transitionsState.loading) return;
        if (isStatusMoveExperimentEnabled && isTransitionStateLoading?.current) return;
        if (isSingletonRequestRef.current) return;
        isSingletonRequestRef.current = true;
        setTransitionsState({
            loading: true,
            error: null
        });
        try {
            let transitions;
            if ((0, $4R6GH.fg)('relay-migration-issue-fields-status')) transitions = await fetchTransitions();
            else {
                const result = await (0, $7f4tk.default)($d2bb6497d10e73da$export$661439a50b90a96f(baseUrl, issueKey));
                transitions = (0, $iLLko.filterTransitionsWithDestinationAndCategory)(result.transitions).map((0, $iLLko.transformTransitionToStore));
            }
            (0, $8zOmE.fireTrackAnalyticsDeferred)(event, 'statusField transitionsFetched', 'statusField', {
                count: transitions.length
            });
            // Issue Transition SLA
            if ((0, $4R6GH.fg)('thor_resolve_transition_event_gate')) $d2bb6497d10e73da$var$enhancedSendExperienceAnalytics(true, projectType, undefined, undefined, undefined, source);
            else $d2bb6497d10e73da$var$enhancedSendExperienceAnalytics(true, projectType);
            setTransitionsState({
                data: transitions,
                loading: false,
                error: null
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $6r7fT.trackOrLogClientError)((0, $878fbedb9c4ca329$export$71a8e2ae8cfade56), e.toString(), e);
            // Issue Transition SLA
            if ((0, $k0ahW.default)(e) || (0, $4R6GH.fg)('thor_resolve_transition_event_gate')) $d2bb6497d10e73da$var$enhancedSendExperienceAnalytics(false, projectType, `${e.name || ''} ${e.message}`.trim(), e.traceId, e.statusCode, (0, $4R6GH.fg)('thor_resolve_transition_event_gate') ? source : undefined, (0, $6r7fT.isAbortableError)(e) && (0, $4R6GH.fg)('thor_add_taskabort_events_for_core_experiences') ? 'taskAbort' : 'taskFail');
            else $d2bb6497d10e73da$var$enhancedSendExperienceAnalytics(true, projectType);
            setTransitionsState({
                data: null,
                loading: false,
                error: e
            });
        }
        isSingletonRequestRef.current = false;
    }, // we want to fetch the transitions whenever any field values change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        baseUrl,
        issueKey,
        projectType,
        setTransitionsState,
        fieldValues,
        isStatusMoveExperimentEnabled
    ]);
    const useProperEffect = (0, $4R6GH.fg)('relay-migration-issue-fields-status') ? (0, $5uXOq.useLayoutEffect) : (0, $5uXOq.useMemo);
    // re-evaluates fetching data again whenever issueKey changes
    // we have to use useLayoutEffect instead of useEffect here because useMemo will be invoked before render
    // we cannot use useMemo in concurrent - if setState within a useMemo concurrent breaks
    // eg, when you have a parent issue and navigate to a child issue - the child issue loads the parent data instead
    // when you use useMemo
    useProperEffect(()=>{
        if (preFetch === true && createAnalyticsEvent) fetch(createAnalyticsEvent({}));
    }, [
        issueKey,
        preFetch,
        createAnalyticsEvent,
        setTransitionsState,
        fetch
    ]);
    // We need to clear the "data" list whenever the status object changes, because
    // each status has a different list of transitions associated with it.
    // We could achieve a similar behaviour by using a "key" prop when rendering
    // TransitionQuery, but that causes problems with keeping the focus on the component
    // when the status changes. We are using the full status object as "self-transitions"
    // from one status to itself need to exhibit the same behaviour, and it also fixes a bug
    // with PopupSelect downstream
    (0, $5uXOq.useEffect)(()=>{
        if (isSaving) setTransitionsState({
            data: null
        });
        else if (!isSaving && preFetch === true && createAnalyticsEvent) fetch(createAnalyticsEvent({}));
    }, [
        isSaving,
        status,
        preFetch,
        createAnalyticsEvent,
        setTransitionsState,
        fetch
    ]);
    return props.children({
        ...transitionsState,
        data: transitionsState.data ? transitionsState.data.map((0, $iLLko.transformTransitionFromStore)) : null,
        fetch: fetch
    });
};
const $d2bb6497d10e73da$var$ScopedTransitionsQueryBase = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4PVOa.WorkflowTransitionsStoreContainer), {
        scope: props.issueKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d2bb6497d10e73da$export$4f5a845fd57540e7, props));
const $d2bb6497d10e73da$var$TransitionQueryWithAnalyticsSource = (props)=>{
    const source = (0, $2gCtH.useAnalyticsSource)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d2bb6497d10e73da$var$ScopedTransitionsQueryBase, {
        ...props,
        source: source
    });
};
const $d2bb6497d10e73da$export$833bdce708ba82a6 = (0, $cSD7y.componentWithFG)('thor_resolve_transition_event_gate', $d2bb6497d10e73da$var$TransitionQueryWithAnalyticsSource, $d2bb6497d10e73da$var$ScopedTransitionsQueryBase);
const $d2bb6497d10e73da$export$e166c7039d71 = (0, $cb25w.default)()($d2bb6497d10e73da$export$833bdce708ba82a6);

});
parcelRegister("399w3", function(module, exports) {

$parcel$export(module.exports, "useFetchTransitionsForStatusField", () => $bac4918992388b6b$export$bff299af05778444);

var $cO6TL = parcelRequire("cO6TL");

var $5uXOq = parcelRequire("5uXOq");

var $eiowN = parcelRequire("eiowN");

var $5yJb9 = parcelRequire("5yJb9");

var $koeKL = parcelRequire("koeKL");

var $5Wobd = parcelRequire("5Wobd");

var $jJZqs = parcelRequire("jJZqs");

var $4R6GH = parcelRequire("4R6GH");
const $bac4918992388b6b$var$OPERATION_NAME = 'transitionsRelayQueryForStatusFieldQuery';
const $bac4918992388b6b$var$fetchTransitionsQuery = (issueKey, cloudId)=>(0, $eiowN.fetchQuery)((0, $5yJb9.default)(), (0, $cO6TL.default), {
        issueKey: issueKey,
        cloudId: cloudId
    });
const $bac4918992388b6b$var$formatResponse = (data)=>data?.jira?.issueByKey?.statusField?.transitions?.edges?.map((edge)=>({
            id: edge?.node?.transitionId ?? 0,
            name: edge?.node?.name ?? '',
            hasScreen: edge?.node?.hasScreen ?? false,
            isGlobal: edge?.node?.isGlobal ?? false,
            isInitial: edge?.node?.isInitial ?? false,
            isConditional: edge?.node?.hasPreConditions ?? false,
            isLooped: edge?.node?.isLooped ?? false,
            to: {
                id: parseInt(edge?.node?.to?.statusId ?? '', 10),
                name: edge?.node?.to?.name ?? '',
                description: '',
                statusCategory: {
                    id: parseInt(edge?.node?.to?.statusCategory?.statusCategoryId ?? '', 10)
                }
            },
            from: null
        })) ?? [];
const $bac4918992388b6b$export$bff299af05778444 = ({ issueKey: issueKey })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const fetchTransitions = (0, $5uXOq.useCallback)(async ()=>{
        if ((0, $4R6GH.fg)('thor_resolve_transition_event_gate')) {
            (0, $5Wobd.startCapturingTraceIds)($bac4918992388b6b$var$OPERATION_NAME);
            try {
                const data = await $bac4918992388b6b$var$fetchTransitionsQuery(issueKey, cloudId).toPromise();
                return $bac4918992388b6b$var$formatResponse(data);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                const firstError = error?.source?.errors?.[0] || {};
                const statusCode = firstError?.extensions?.statusCode ?? error.statusCode ?? error.status;
                const errorMessage = firstError.message ?? error.message;
                throw new (0, $jJZqs.default)(statusCode, errorMessage || `Relay Fetch call failed with status code: ${statusCode}`, (0, $5Wobd.getTraceIds)($bac4918992388b6b$var$OPERATION_NAME)?.[0] ?? error.traceId);
            } finally{
                (0, $5Wobd.stopCapturingTraceIds)($bac4918992388b6b$var$OPERATION_NAME);
            }
        }
        const data = await $bac4918992388b6b$var$fetchTransitionsQuery(issueKey, cloudId).toPromise();
        return $bac4918992388b6b$var$formatResponse(data);
    }, [
        cloudId,
        issueKey
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            fetchTransitions: fetchTransitions
        }), [
        fetchTransitions
    ]);
};

});
parcelRegister("cO6TL", function(module, exports) {

$parcel$export(module.exports, "default", () => $51bba1402798face$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ad848ef2c030384b9c0dbb654e369a1c>>
 * @relayHash 796dc965641af207a0b9419914846a68
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 20d04eb1eb34d95f608eed19bd7178ed5e44deabd2a8e0e10666e1f6ff5f998b
const $51bba1402798face$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueKey"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "issueKey"
        }
    ], v2 = [
        {
            "kind": "Literal",
            "name": "sortingOption",
            "value": "OPS_BAR_THEN_STATUS_CATEGORY"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "transitionId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "name"
    }, v5 = {
        "kind": "ScalarField",
        "name": "hasScreen"
    }, v6 = {
        "kind": "ScalarField",
        "name": "isGlobal"
    }, v7 = {
        "kind": "ScalarField",
        "name": "isInitial"
    }, v8 = {
        "kind": "ScalarField",
        "name": "isLooped"
    }, v9 = {
        "kind": "ScalarField",
        "name": "hasPreConditions"
    }, v10 = {
        "kind": "ScalarField",
        "name": "statusId"
    }, v11 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v12 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "transitionsRelayQueryForStatusFieldQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraStatusField",
                                    "kind": "LinkedField",
                                    "name": "statusField",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v2 /*: any*/ ,
                                            "concreteType": "JiraTransitionConnection",
                                            "kind": "LinkedField",
                                            "name": "transitions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraTransitionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraTransition",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v3 /*: any*/ ,
                                                                v4 /*: any*/ ,
                                                                v5 /*: any*/ ,
                                                                v6 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                v8 /*: any*/ ,
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "to",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v10 /*: any*/ ,
                                                                        v4 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraStatusCategory",
                                                                            "kind": "LinkedField",
                                                                            "name": "statusCategory",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v11 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "transitions(sortingOption:\"OPS_BAR_THEN_STATUS_CATEGORY\")"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "transitionsRelayQueryForStatusFieldQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraStatusField",
                                    "kind": "LinkedField",
                                    "name": "statusField",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v2 /*: any*/ ,
                                            "concreteType": "JiraTransitionConnection",
                                            "kind": "LinkedField",
                                            "name": "transitions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraTransitionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraTransition",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v3 /*: any*/ ,
                                                                v4 /*: any*/ ,
                                                                v5 /*: any*/ ,
                                                                v6 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                v8 /*: any*/ ,
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "to",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v10 /*: any*/ ,
                                                                        v4 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraStatusCategory",
                                                                            "kind": "LinkedField",
                                                                            "name": "statusCategory",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v11 /*: any*/ ,
                                                                                v12 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v12 /*: any*/ 
                                                                    ]
                                                                },
                                                                v12 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "transitions(sortingOption:\"OPS_BAR_THEN_STATUS_CATEGORY\")"
                                        },
                                        v12 /*: any*/ 
                                    ]
                                },
                                v12 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "20d04eb1eb34d95f608eed19bd7178ed5e44deabd2a8e0e10666e1f6ff5f998b",
            "metadata": {},
            "name": "transitionsRelayQueryForStatusFieldQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$51bba1402798face$var$node.hash = "ef8a89687e1190fb71a38a47f8fc039c";
var $51bba1402798face$export$2e2bcd8739ae039 = $51bba1402798face$var$node;

});


parcelRegister("iLLko", function(module, exports) {

$parcel$export(module.exports, "filterTransitionsWithDestinationAndCategory", () => $ad6093c5a367a301$export$f27913d8073a7e1);
$parcel$export(module.exports, "transformTransitionToStore", () => $ad6093c5a367a301$export$3482bcbbb2a2b63a);
$parcel$export(module.exports, "transformTransitionFromStore", () => $ad6093c5a367a301$export$1eab4bccf39ab44d);
const $ad6093c5a367a301$export$f27913d8073a7e1 = (transitions = [])=>transitions.filter((transition)=>!!transition.to && !!transition.to.statusCategory);
const $ad6093c5a367a301$export$3482bcbbb2a2b63a = (transition)=>({
        id: parseInt(transition.id, 10),
        name: transition.name,
        hasScreen: transition.hasScreen,
        isGlobal: transition.isGlobal,
        isInitial: transition.isInitial,
        isConditional: transition.isConditional,
        ...typeof transition.isLooped === 'boolean' && {
            isLooped: transition.isLooped
        },
        to: {
            id: parseInt(transition.to.id, 10),
            name: transition.to.name,
            description: '',
            statusCategory: {
                id: transition.to.statusCategory.id
            }
        },
        from: null
    });
const $ad6093c5a367a301$export$1eab4bccf39ab44d = (transition)=>({
        id: String(transition.id),
        name: transition.name,
        hasScreen: transition.hasScreen,
        isGlobal: transition.isGlobal,
        isInitial: transition.isInitial,
        isConditional: transition.isConditional,
        ...typeof transition.isLooped === 'boolean' && {
            isLooped: transition.isLooped
        },
        to: {
            id: String(transition.to.id),
            name: transition.to.name,
            statusCategory: {
                id: transition.to.statusCategory.id
            }
        }
    });

});



parcelRegister("fJ83Q", function(module, exports) {

$parcel$export(module.exports, "OptionWithButtonStyle", () => $bb57911f4b9388b9$export$b3382093e45b6db9);

var $5uXOq = parcelRequire("5uXOq");

var $bChGW = parcelRequire("bChGW");

var $dC5iT = parcelRequire("dC5iT");
const $bb57911f4b9388b9$export$b3382093e45b6db9 = ({ children: children, onHover: onHover, testId: testId, ...optionProps })=>{
    const customisedGetStyles = (propertyName, props)=>{
        return {
            ...optionProps.getStyles(propertyName, props),
            boxShadow: 'none',
            cursor: 'pointer',
            padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"}`
        };
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        onMouseOver: onHover,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Option, {
        ...optionProps,
        getStyles: customisedGetStyles
    }, children));
};

});

parcelRegister("N7jPX", function(module, exports) {

$parcel$export(module.exports, "GroupComponentWithStickyFooter", () => $20e766b49ec0b86c$export$a4fcc8b2698425e6);
/* GroupComponentWithStickyFooter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $bChGW = parcelRequire("bChGW");

const $20e766b49ec0b86c$var$groupStyles = {
    root: "_ca0qze3t"
};
const $20e766b49ec0b86c$export$a4fcc8b2698425e6 = ({ children: children, ...groupProps })=>{
    const containStickyFooterGroup = (0, $5uXOq.useMemo)(()=>{
        return groupProps.data.options.find((option)=>option.groupType === (0, $8109ad51236d2441$export$e13d614fc55c6ce9));
    }, [
        groupProps.data.options
    ]);
    if (containStickyFooterGroup) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $20e766b49ec0b86c$var$stickyFooterGroupWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Group, {
        ...groupProps,
        innerProps: {
            ...groupProps.innerProps ?? {},
            style: {
                ...groupProps.innerProps?.style ?? {},
                paddingTop: 0
            },
            className: (0, $8109ad51236d2441$export$1ae91d219a8713ac)
        },
        xcss: $20e766b49ec0b86c$var$groupStyles.root
    }, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Group, groupProps, children);
};
const $20e766b49ec0b86c$var$stickyFooterGroupWrapper = (0, $8CUq3.xcss)({
    borderTop: `2px solid ${"var(--ds-border, #091E4224)"}`,
    backgroundColor: 'elevation.surface.overlay',
    borderBottomLeftRadius: 'border.radius.200',
    borderBottomRightRadius: 'border.radius.200',
    position: 'sticky',
    bottom: 'space.negative.100',
    marginBottom: 'space.negative.100',
    paddingTop: 'space.050'
});

});
const $8109ad51236d2441$export$e13d614fc55c6ce9 = 'STICKY_FOOTER_GROUP_TYPE';
const $8109ad51236d2441$export$1ae91d219a8713ac = 'select-sticky-footer';


parcelRegister("4Gswu", function(module, exports) {

$parcel$export(module.exports, "OptionWithAutoKeyboardScroll", () => $615e8210cb21f219$export$39118cd824d8af0b);

var $5uXOq = parcelRequire("5uXOq");

var $bChGW = parcelRequire("bChGW");

var $7mPT9 = parcelRequire("7mPT9");

var $3LKEA = parcelRequire("3LKEA");

const $615e8210cb21f219$export$39118cd824d8af0b = ({ children: children, containerRef: containerRef, ...optionProps })=>{
    const focusedOptionRef = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>{
        if (optionProps.isFocused) {
            // We only auto scroll for focus with keyboard only, not for focus with mouse hover
            // because mouse users will manual scroll when browsing options
            if (!focusedOptionRef.current?.parentElement || focusedOptionRef.current?.matches(':hover')) return;
            // We need to add bottom offset when scrolling which is the current height of sticky footer options group
            const stickFooterBottomOffset = globalThis?.document.querySelector(`.${(0, $8109ad51236d2441$export$1ae91d219a8713ac)}`)?.clientHeight ?? 0;
            (0, $3LKEA.scrollIntoView)(containerRef?.current ?? focusedOptionRef.current.parentElement, focusedOptionRef.current, stickFooterBottomOffset);
        }
    }, [
        containerRef,
        optionProps.isFocused
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Option, {
        ...optionProps,
        innerRef: (0, $7mPT9.mergeRefs)(optionProps.innerRef, focusedOptionRef)
    }, children);
};

});
parcelRegister("3LKEA", function(module, exports) {

$parcel$export(module.exports, "appendStickyFooterOptions", () => $cc9569724dc25e59$export$870da2f71d38aa94);
$parcel$export(module.exports, "useAppendStickyFooterOptions", () => $cc9569724dc25e59$export$9ef0653bfb9844e7);
$parcel$export(module.exports, "scrollIntoView", () => $cc9569724dc25e59$export$53a0910f038337bd);

var $5uXOq = parcelRequire("5uXOq");

const $cc9569724dc25e59$export$870da2f71d38aa94 = (options, footerOptions)=>{
    return [
        ...options,
        {
            options: footerOptions.map((footerOption)=>{
                return {
                    ...footerOption,
                    groupType: (0, $8109ad51236d2441$export$e13d614fc55c6ce9)
                };
            })
        }
    ];
};
const $cc9569724dc25e59$export$9ef0653bfb9844e7 = (options, footerOptions)=>{
    return (0, $5uXOq.useMemo)(()=>$cc9569724dc25e59$export$870da2f71d38aa94(options, footerOptions), [
        footerOptions,
        options
    ]);
};
function $cc9569724dc25e59$export$53a0910f038337bd(menuEl, focusedEl, bottomOffset = 0) {
    const menuRect = menuEl.getBoundingClientRect();
    const focusedRect = focusedEl.getBoundingClientRect();
    const overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom - bottomOffset) // eslint-disable-next-line no-param-reassign
    menuEl.scrollTop = Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + bottomOffset + overScroll, menuEl.scrollHeight - bottomOffset);
    else if (focusedRect.top - overScroll < menuRect.top) // eslint-disable-next-line no-param-reassign
    menuEl.scrollTop = Math.max(focusedEl.offsetTop - overScroll, 0);
}

});


parcelRegister("gyeeU", function(module, exports) {

$parcel$export(module.exports, "AtlaskitSelectInlineTabActivator", () => $77cb954647054621$export$db135681be6e3fdb);

var $5uXOq = parcelRequire("5uXOq");

var $ku1fk = parcelRequire("ku1fk");

var $dC5iT = parcelRequire("dC5iT");

var $4R6GH = parcelRequire("4R6GH");
const $77cb954647054621$export$db135681be6e3fdb = ({ setInputValue: setInputValue, setIsMenuOpen: setIsMenuOpen, inputValue: inputValue, isMenuOpen: isMenuOpen, children: children })=>{
    const selectWrapperRef = (0, $5uXOq.useRef)(null);
    const handleBlur = (0, $5uXOq.useCallback)((e)=>{
        // Always close the menu on outside focus and mouse events
        if (selectWrapperRef.current && e.target instanceof Node && // This is to make sure we only blur when focusing outside of the select
        // This is required to allow interacting with inline buttons inside the select dropdown
        !selectWrapperRef.current.contains(e.target)) {
            setInputValue?.('');
            setIsMenuOpen(false);
            return;
        }
        // Always toggle the menu open/closed on internal mousedown events
        if (e.type === 'mousedown') {
            // Reset the input value when closing the menu
            if (isMenuOpen) setInputValue?.('');
            setIsMenuOpen(!isMenuOpen);
        }
    }, [
        isMenuOpen,
        setInputValue,
        setIsMenuOpen
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // Listen to focus and mousedown events to close the select dropdown when clicking or focusing outside of it
        globalThis?.document?.addEventListener('focusin', handleBlur);
        globalThis?.document?.addEventListener('mousedown', handleBlur);
        return ()=>{
            globalThis?.document?.removeEventListener('focusin', handleBlur);
            globalThis?.document?.removeEventListener('mousedown', handleBlur);
        };
    }, [
        handleBlur
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // Open the menu when the input value changes
        if (!isMenuOpen && inputValue) setIsMenuOpen(true);
    }, [
        inputValue,
        isMenuOpen,
        setIsMenuOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        testId: "inline-config-buttons-for-select.atlaskit-select-inline-tab-activator",
        ref: selectWrapperRef,
        onKeyDown: (e)=>{
            const openMenuKeys = [
                'ArrowDown',
                'ArrowUp',
                'Enter',
                ' '
            ];
            // Only override keydown events when the menu is open or to open the menu
            if (!isMenuOpen && !openMenuKeys.includes(e.key)) return;
            switch(e.key){
                // This is to handle closing the Select menu when pressing Escape
                case 'Escape':
                    setIsMenuOpen(false);
                    setInputValue?.('');
                    break;
                // This is to allow tabbing inside the Select menu
                // if the current focus one is last tabbable element, focus the first tabbable element
                // to prevent tabbing out of the Select menu
                case 'Tab':
                    {
                        (0, $4R6GH.fg)('inline_config_a11y_improvements') && e.stopPropagation();
                        const tabbableEls = (0, (/*@__PURE__*/$parcel$interopDefault($ku1fk)))(e.currentTarget);
                        if (tabbableEls.length < 2) return;
                        const isLastTabbable = tabbableEls[tabbableEls.length - 1] === globalThis?.document?.activeElement;
                        if (isLastTabbable) {
                            e.preventDefault();
                            tabbableEls[0].focus();
                        }
                        break;
                    }
                // This is to allow navigating inside the Select menu using Arrow keys after focusing on inline buttons
                // Because users can only continue navigating using Arrow keys if the focus is on the text input of select
                case 'ArrowDown':
                case 'ArrowUp':
                    {
                        if (!isMenuOpen) {
                            setIsMenuOpen(true);
                            return;
                        }
                        const tabbableEls = (0, (/*@__PURE__*/$parcel$interopDefault($ku1fk)))(e.currentTarget);
                        if (tabbableEls.length < 2) return;
                        tabbableEls[0].focus();
                        break;
                    }
                case 'Enter':
                case ' ':
                    if (!isMenuOpen) setIsMenuOpen(true);
                    break;
                default:
                    break;
            }
        }
    }, children);
};

});

parcelRegister("hGiaW", function(module, exports) {

$parcel$export(module.exports, "CreateStatusButton", () => $0bd7367942f2c9b8$export$d2e0b4f33d77a2b8);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $dZbEw = parcelRequire("dZbEw");

var $gKECL = parcelRequire("gKECL");

var $koVbs = parcelRequire("koVbs");

var $eSc2f = parcelRequire("eSc2f");

var $2KAtx = parcelRequire("2KAtx");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $koeKL = parcelRequire("koeKL");

var $4R6GH = parcelRequire("4R6GH");

var $5fc53 = parcelRequire("5fc53");

var $5jhd5 = parcelRequire("5jhd5");

var $lSLA0 = parcelRequire("lSLA0");

var $2lh30 = parcelRequire("2lh30");

var $8e3Yw = parcelRequire("8e3Yw");

var $ZA7IV = parcelRequire("ZA7IV");
const $0bd7367942f2c9b8$export$d2e0b4f33d77a2b8 = ({ statusNames: statusNames, onCreateStatusSuccess: onCreateStatusSuccess, projectId: projectId, projectKey: projectKey, projectType: projectType, issueTypeId: issueTypeId, isNoResultsView: isNoResultsView, shouldReturnFocus: shouldReturnFocus, buttonRef: buttonRef = null, isButtonWithIcon: isButtonWithIcon, hasMultipleWorkflows: hasMultipleWorkflows, analyticsSource: analyticsSource })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const cloudId = (0, $koeKL.useCloudId)();
    const [groupByFieldId] = (0, $8e3Yw.useGroupBy)();
    const isGroupingByStatus = groupByFieldId === (0, $5fc53.STATUS_TYPE);
    const { triggerListViewGroupByCacheRefresh: triggerListViewGroupByCacheRefresh, triggerWorkflowCacheRefresh: triggerWorkflowCacheRefresh } = (0, $4R6GH.fg)('refetch_status_on_list_group_by_status') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $2lh30.useListViewRefreshCacheActions)() : {
        triggerListViewGroupByCacheRefresh: undefined,
        triggerWorkflowCacheRefresh: undefined
    };
    const onStatusCreated = (0, $5uXOq.useCallback)(()=>{
        if (isGroupingByStatus) {
            triggerWorkflowCacheRefresh?.();
            triggerListViewGroupByCacheRefresh?.();
        }
        onCreateStatusSuccess?.();
    }, [
        isGroupingByStatus,
        onCreateStatusSuccess,
        triggerListViewGroupByCacheRefresh,
        triggerWorkflowCacheRefresh
    ]);
    const isPressable = (0, $4R6GH.fg)('inline_config_a11y_improvements') ? isNoResultsView || isButtonWithIcon : true;
    const handleClick = (0, $5uXOq.useCallback)((e)=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'createStatusButton', {
            source: analyticsSource
        });
        // Because we are triggering the click manually for keyboard users
        // this handler becomes the source-of-truth handler for both keyboard users and mouse users
        // However, we need to stopPropagation from here to prevent double modal for mouse users
        // When mouse user clicks the button, if we don't stop propagation here, handleTransitionChange
        // will be called which will trigger click manually again and cause double modal rendering
        e.stopPropagation();
    }, [
        analyticsSource,
        createAnalyticsEvent
    ]);
    const onModalClose = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'closed',
            actionSubject: 'inlineCreateStatusModal'
        }), {
            source: analyticsSource
        });
    }, [
        analyticsSource,
        createAnalyticsEvent
    ]);
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            statusNames: statusNames,
            projectId: projectId,
            projectKey: projectKey,
            projectType: projectType,
            onClose: onModalClose,
            isNewControllerEnabled: true,
            workflowAssociatedIssueTypeId: issueTypeId,
            onStatusCreated: onStatusCreated,
            createStatusExperience: $lSLA0.createStatusExperience,
            source: analyticsSource,
            hasMultipleWorkflows: hasMultipleWorkflows
        }), [
        statusNames,
        projectId,
        projectKey,
        projectType,
        onModalClose,
        issueTypeId,
        onStatusCreated,
        analyticsSource,
        hasMultipleWorkflows
    ]);
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            projectKey: projectKey
        }), [
        cloudId,
        projectKey
    ]);
    const Wrapper = isPressable ? (0, $5ILhZ.default) : (0, $dC5iT.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2KAtx.ModalEntryPointPressableTrigger), {
        entryPoint: (0, $gKECL.asyncInlineCreateStatusModal),
        entryPointProps: entryPointProps,
        entryPointParams: entryPointParams,
        interactionName: "create-status-modal",
        modalProps: {
            ...(0, $eSc2f.defaultModalProps),
            shouldReturnFocus: shouldReturnFocus
        },
        forwardedRef: buttonRef,
        useInternalModal: true,
        Fallback: (0, $4R6GH.fg)('jgfeng_new_work_type_fallback_loading_state') ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5jhd5.FormDialogSkeleton), {
                numFormFields: 2
            }) : undefined
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Wrapper, {
            onClick: handleClick,
            backgroundColor: "color.background.neutral.subtle",
            xcss: [
                isNoResultsView ? $0bd7367942f2c9b8$var$createStatusInlineNoResultStyles : $0bd7367942f2c9b8$var$createStatusInlineStyles,
                isButtonWithIcon && $0bd7367942f2c9b8$var$createStatusInlineWithIconStyles
            ],
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ref: ref
        }, isButtonWithIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $0bd7367942f2c9b8$var$iconButtonStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dZbEw))), {
            label: ""
        })), formatMessage((0, $ZA7IV.default).createStatus)));
};
const $0bd7367942f2c9b8$var$createStatusInlineNoResultStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.150',
    color: 'color.link',
    fontWeight: 'font.weight.bold'
});
const $0bd7367942f2c9b8$var$createStatusInlineStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    width: '100%',
    padding: 'space.150',
    color: 'color.text',
    fontWeight: 'font.weight.medium'
});
const $0bd7367942f2c9b8$var$createStatusInlineWithIconStyles = (0, $8CUq3.xcss)({
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    },
    ':focus-visible': {
        // @ts-expect-error - outlineOffset currently does not support negative tokens - see https://atlassian.slack.com/archives/CFJ9DU39U/p1733863467395999
        outlineOffset: "var(--ds-space-negative-025, -2px)",
        outlineStyle: 'auto',
        outlineWidth: 'border.width.outline',
        outlineColor: 'color.border.focused'
    }
});
const $0bd7367942f2c9b8$var$iconButtonStyles = (0, $8CUq3.xcss)({
    paddingRight: 'space.100',
    paddingLeft: 'space.100'
});

});
parcelRegister("gKECL", function(module, exports) {

$parcel$export(module.exports, "asyncInlineCreateStatusModal", () => $7044591110f97598$export$64a761d25b20910a);

var $8p8PB = parcelRequire("8p8PB");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $7044591110f97598$export$64a761d25b20910a = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("2DxoZ")), {
        moduleId: "4ce02bb0"
    }),
    getPreloadProps: ({ cloudId: cloudId, projectKey: projectKey })=>({
            queries: {
                inlineCreateStatusModal: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $8p8PB.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        })
});

});
parcelRegister("8p8PB", function(module, exports) {

$parcel$export(module.exports, "default", () => $32f21baf6b88fc48$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a1c9f0ca0f32a1a7d832e77365f43e75>>
 * @relayHash 0df4748cd7c393765978be5843c7a913
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a6f93e860194a5c2419c4911409b28d0ab9e3c6da5d722ecc79fae56d217265b
const $32f21baf6b88fc48$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "a6f93e860194a5c2419c4911409b28d0ab9e3c6da5d722ecc79fae56d217265b",
        "metadata": {},
        "name": "srcAsyncInlineCreateStatusQuery",
        "operationKind": "query",
        "text": null
    }
};
var $32f21baf6b88fc48$export$2e2bcd8739ae039 = $32f21baf6b88fc48$var$node;

});

parcelRegister("2DxoZ", function(module, exports) {

let $1eb9223cdb2c4a87$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1eb9223cdb2c4a87$var$load("51fo4").then(()=>parcelRequire('e1e78'));

});


parcelRegister("eSc2f", function(module, exports) {

$parcel$export(module.exports, "defaultModalProps", () => $b84f9512c4920c38$export$14c11acc66fd51b3);
const $b84f9512c4920c38$export$14c11acc66fd51b3 = {
    width: 'small'
};

});

parcelRegister("5jhd5", function(module, exports) {

$parcel$export(module.exports, "FormDialogSkeleton", () => $cbf418453919c3e8$export$3e5b4585c21ca29d);

var $5uXOq = parcelRequire("5uXOq");

var $kgoHi = parcelRequire("kgoHi");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $1DVhQ = parcelRequire("1DVhQ");
const $cbf418453919c3e8$var$COMMON_SKELETON_PROPS = {
    borderRadius: 8,
    isShimmering: true
};
const $cbf418453919c3e8$export$3e5b4585c21ca29d = ({ numFormFields: numFormFields })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        direction: "column",
        xcss: $cbf418453919c3e8$var$modalSkeletonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        direction: "column",
        xcss: $cbf418453919c3e8$var$headerSkeletonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.250"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
        width: "40%",
        height: 24,
        ...$cbf418453919c3e8$var$COMMON_SKELETON_PROPS,
        testId: "form-dialog-skeleton.ui.header-title"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
        width: "35%",
        height: 16,
        ...$cbf418453919c3e8$var$COMMON_SKELETON_PROPS,
        testId: "form-dialog-skeleton.ui.header-subtitle"
    }))), Array.from({
        length: numFormFields
    }).map((_, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
            space: "space.050",
            key: idx,
            xcss: $cbf418453919c3e8$var$formFieldSkeletonStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
            width: "30%",
            height: 16,
            ...$cbf418453919c3e8$var$COMMON_SKELETON_PROPS,
            testId: `form-field-label-${idx}`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
            width: "100%",
            height: 40,
            ...$cbf418453919c3e8$var$COMMON_SKELETON_PROPS,
            testId: `form-field-input-${idx}`
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        justifyContent: "end",
        gap: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
        width: 72,
        height: 32,
        ...$cbf418453919c3e8$var$COMMON_SKELETON_PROPS,
        testId: "form-dialog-skeleton.ui.cancel-button"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
        width: 72,
        height: 32,
        ...$cbf418453919c3e8$var$COMMON_SKELETON_PROPS,
        testId: "form-dialog-skeleton.ui.submit-button"
    }))));
const $cbf418453919c3e8$var$modalSkeletonStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'elevation.surface.overlay',
    borderRadius: '12px',
    width: '394px',
    padding: 'space.300'
});
const $cbf418453919c3e8$var$headerSkeletonStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.100'
});
const $cbf418453919c3e8$var$formFieldSkeletonStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.100',
    marginBottom: 'space.100'
});

});

parcelRegister("lSLA0", function(module, exports) {

$parcel$export(module.exports, "createStatusExperience", () => $258adf3d2abf1f30$export$750cfa63c61c5008);
$parcel$export(module.exports, "editStatusExperience", () => $258adf3d2abf1f30$export$1c3aa89ea6d8c93d);

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");
const $258adf3d2abf1f30$export$750cfa63c61c5008 = new (0, $duUGa.UFOExperience)('business-list.create-status', {
    type: (0, $atdLB.ExperienceTypes).Operation,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom
});
const $258adf3d2abf1f30$export$1c3aa89ea6d8c93d = new (0, $duUGa.UFOExperience)('business-list.edit-status', {
    type: (0, $atdLB.ExperienceTypes).Operation,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom
});

});

parcelRegister("ZA7IV", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fbed1cf1f6a65de$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2fbed1cf1f6a65de$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createStatus: {
        "id": "business-list.ui.list-view.status-cell.create-status-button.create-status",
        "defaultMessage": "Create status"
    }
});

});


parcelRegister("fr1UQ", function(module, exports) {

$parcel$export(module.exports, "EditStatusButton", () => $15bafdf71c5bd8b4$export$bc1c056aa3d67f87);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $i7SlO = parcelRequire("i7SlO");

var $koVbs = parcelRequire("koVbs");

var $eSc2f = parcelRequire("eSc2f");

var $2KAtx = parcelRequire("2KAtx");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $5fc53 = parcelRequire("5fc53");

var $5jhd5 = parcelRequire("5jhd5");

var $4R6GH = parcelRequire("4R6GH");

var $lSLA0 = parcelRequire("lSLA0");

var $2lh30 = parcelRequire("2lh30");

var $8e3Yw = parcelRequire("8e3Yw");

var $cehTG = parcelRequire("cehTG");
const $15bafdf71c5bd8b4$export$bc1c056aa3d67f87 = ({ statusNames: statusNames, status: status, statuses: statuses, projectId: projectId, projectKey: projectKey, projectType: projectType, issueTypeId: issueTypeId, shouldReturnFocus: shouldReturnFocus, buttonRef: buttonRef = null, analyticsSource: analyticsSource, onEditStatusSuccess: onEditStatusSuccess })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [groupByFieldId] = (0, $8e3Yw.useGroupBy)();
    const isGroupingByStatus = groupByFieldId === (0, $5fc53.STATUS_TYPE);
    const { triggerListViewCacheRefresh: triggerListViewCacheRefresh, triggerListViewGroupByCacheRefresh: triggerListViewGroupByCacheRefresh, triggerWorkflowCacheRefresh: triggerWorkflowCacheRefresh } = (0, $2lh30.useListViewRefreshCacheActions)();
    const onStatusUpdated = (0, $5uXOq.useCallback)(async ()=>{
        await triggerListViewCacheRefresh();
        await triggerWorkflowCacheRefresh();
        if (isGroupingByStatus) await triggerListViewGroupByCacheRefresh();
        onEditStatusSuccess && await onEditStatusSuccess();
    }, [
        isGroupingByStatus,
        onEditStatusSuccess,
        triggerListViewCacheRefresh,
        triggerWorkflowCacheRefresh,
        triggerListViewGroupByCacheRefresh
    ]);
    const handleClick = (0, $5uXOq.useCallback)((e)=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'editStatusButton', {
            source: analyticsSource
        });
        // Because we are triggering the click manually for keyboard users
        // this handler becomes the source-of-truth handler for both keyboard users and mouse users
        // However, we need to stopPropagation from here to prevent double modal for mouse users
        // When mouse user clicks the button, if we don't stop propagation here, handleTransitionChange
        // will be called which will trigger click manually again and cause double modal rendering
        e.stopPropagation();
    }, [
        analyticsSource,
        createAnalyticsEvent
    ]);
    const onModalClose = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'closed',
            actionSubject: 'inlineEditStatusModal'
        }), {
            source: analyticsSource
        });
    }, [
        analyticsSource,
        createAnalyticsEvent
    ]);
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            statusNames: statusNames,
            projectId: projectId,
            projectKey: projectKey,
            projectType: projectType,
            onClose: onModalClose,
            issueTypeId: issueTypeId ?? '',
            onStatusUpdated: onStatusUpdated,
            editStatusExperience: $lSLA0.editStatusExperience,
            status: status,
            statuses: statuses,
            source: analyticsSource,
            shouldShowStatusSelect: true
        }), [
        statusNames,
        projectId,
        projectKey,
        projectType,
        onModalClose,
        issueTypeId,
        onStatusUpdated,
        analyticsSource,
        status,
        statuses
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2KAtx.ModalEntryPointPressableTrigger), {
        entryPoint: (0, $i7SlO.asyncInlineEditStatusModal),
        entryPointProps: entryPointProps,
        interactionName: "edit-status-modal",
        modalProps: {
            ...(0, $eSc2f.defaultModalProps),
            shouldReturnFocus: shouldReturnFocus
        },
        forwardedRef: buttonRef,
        useInternalModal: true,
        Fallback: (0, $4R6GH.fg)('jgfeng_new_work_type_fallback_loading_state') ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5jhd5.FormDialogSkeleton), {
                numFormFields: 3
            }) : undefined
    }, ({ ref: ref })=>// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            onClick: handleClick,
            backgroundColor: "color.background.neutral.subtle",
            xcss: [
                $15bafdf71c5bd8b4$var$editStatusInlineStyles
            ],
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ref: ref
        }, formatMessage((0, $cehTG.default).editStatus)));
};
const $15bafdf71c5bd8b4$var$editStatusInlineStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    width: '100%',
    padding: 'space.150',
    color: 'color.text',
    fontWeight: 'font.weight.medium'
});

});
parcelRegister("i7SlO", function(module, exports) {

$parcel$export(module.exports, "asyncInlineEditStatusModal", () => $bc5734c540f0c454$export$c3f451c40832a786);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $bc5734c540f0c454$export$c3f451c40832a786 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("4Ajos")).then((module)=>module.AsyncInlineEditStatusModal), {
        moduleId: "177d76fa",
        moduleName: "AsyncInlineEditStatusModal"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("4Ajos", function(module, exports) {

let $356991598dd2ef64$var$load = (parcelRequire("28QjX"))(4);
module.exports = $356991598dd2ef64$var$load("2UWfb").then(()=>parcelRequire('5zJw9'));

});


parcelRegister("cehTG", function(module, exports) {

$parcel$export(module.exports, "default", () => $750a470f5934733a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $750a470f5934733a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    editStatus: {
        "id": "business-list.ui.list-view.status-cell.edit-status-button.edit-status",
        "defaultMessage": "Edit status"
    }
});

});


parcelRegister("3AZQW", function(module, exports) {

$parcel$export(module.exports, "default", () => $7233d047052dbe1d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7233d047052dbe1d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    markedAsDoneFlagTitle: {
        "id": "business-list.list-view.status-cell.marked-as-done-flag-title",
        "defaultMessage": "Nice one!"
    },
    markedAsDone: {
        "id": "business-list.list-view.status-cell.marked-as-done",
        "defaultMessage": "Marked \"{issue}\" as {statusName}"
    },
    viewIssue: {
        "id": "business-list.list-view.status-cell.view-issue",
        "defaultMessage": "View issue"
    },
    markedAsDoneOld: {
        "id": "business-list.list-view.status-cell.marked-as-done-old",
        "defaultMessage": "Marked {link} as {statusName}"
    },
    placeholder: {
        "id": "business-list.list-view.status-cell.placeholder",
        "defaultMessage": "Select Status"
    },
    cannotLoadTransitions: {
        "id": "business-list.list-view.status-cell.cannot-load-transitions",
        "defaultMessage": "Couldn't load the statuses."
    },
    noSearchResults: {
        "id": "business-list.list-view.status-cell.no-search-results",
        "defaultMessage": "It looks like we can't find any statuses that match."
    },
    viewIssueIssueTermRefresh: {
        "id": "business-list.list-view.status-cell.view-issue-issue-term-refresh",
        "defaultMessage": "View"
    },
    createStatus: {
        "id": "business-list.list-view.status-cell.create-status",
        "defaultMessage": "Create status"
    },
    editStatus: {
        "id": "business-list.list-view.status-cell.edit-status",
        "defaultMessage": "Edit status"
    }
});

});

parcelRegister("5uSmq", function(module, exports) {

$parcel$export(module.exports, "transformValue", () => $e92a4dbef880f9fe$export$98c150630afe5417);
$parcel$export(module.exports, "toAppearance", () => $e92a4dbef880f9fe$export$cbc76b787f60c037);

var $gULOk = parcelRequire("gULOk");
const $e92a4dbef880f9fe$var$appearanceMap = {
    [(0, $gULOk.UNDEFINED)]: 'default',
    [(0, $gULOk.TODO)]: 'default',
    [(0, $gULOk.DONE)]: 'success',
    [(0, $gULOk.IN_PROGRESS)]: 'inprogress'
};
const $e92a4dbef880f9fe$export$98c150630afe5417 = (value)=>{
    if (!value) return [];
    const valuesArray = Array.isArray(value) ? value : [
        value
    ];
    return valuesArray.map(({ name: name })=>({
            value: name,
            label: name
        }));
};
const $e92a4dbef880f9fe$export$cbc76b787f60c037 = (statusValue)=>statusValue.statusCategory.id ? $e92a4dbef880f9fe$var$appearanceMap[(0, $gULOk.statusCategoryForId)(statusValue.statusCategory.id)] : $e92a4dbef880f9fe$var$appearanceMap[0, $gULOk.UNDEFINED];

});


parcelRegister("9gyyM", function(module, exports) {

$parcel$export(module.exports, "TextAreaCell", () => $309d1fc5b0994c7c$export$1e25c2913c11e42f);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $bG3pQ = parcelRequire("bG3pQ");

var $hE5wF = parcelRequire("hE5wF");

var $lQE94 = parcelRequire("lQE94");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $fCo6Y = parcelRequire("fCo6Y");

var $4R6GH = parcelRequire("4R6GH");

var $fkAB3 = parcelRequire("fkAB3");

var $4nnGr = parcelRequire("4nnGr");
const $309d1fc5b0994c7c$export$1e25c2913c11e42f = /*#__PURE__*/ (0, $5uXOq.memo)(({ fieldKey: fieldKey, fieldType: fieldType, fieldValue: fieldValue, onClick: onClick, issueKey: issueKey, cellRef: cellRef, issueHasUnreadComment: issueHasUnreadComment })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { issueViewInteraction: issueViewInteraction } = (0, $4nnGr.useJWMListFeatures)();
    const [textValue, setTextValue] = (0, $5uXOq.useState)('');
    const onEmbedClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'textAreaCell clicked', 'listEmbedIssue');
        (0, $bG3pQ.openViewFromEmbed)({
            key: (0, $hE5wF.SELECTED_ISSUE_PARAM),
            value: issueKey
        });
    }, [
        createAnalyticsEvent,
        issueKey
    ]);
    const [{ value: extractedFieldValue }] = (0, $lQE94.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: fieldValue
    });
    const cellValue = extractedFieldValue;
    // keeping value up-to-date with bento value
    // text area value is type string
    (0, $5uXOq.useEffect)(()=>{
        // TODO: JEH-62
        (0, $fkAB3.getADFMarkup)((0, $fCo6Y.convertAdfStringToObject)(cellValue)).then((value)=>setTextValue(value));
    }, [
        cellValue
    ]);
    const handleClick = (0, $5uXOq.useCallback)((event)=>{
        if (issueViewInteraction === 'openNewTab') onEmbedClick();
        else {
            onClick(event);
            if ((0, $4R6GH.fg)('_jira_unread_comments_in_list_view_gate')) (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'textAreaCell clicked', 'listIssue', {
                issueHasUnreadComment: issueHasUnreadComment
            });
        }
    }, [
        createAnalyticsEvent,
        issueHasUnreadComment,
        issueViewInteraction,
        onClick,
        onEmbedClick
    ]);
    const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
        if (event.code === 'Enter') {
            handleClick(event);
            return true;
        }
        return false;
    }, [
        handleClick
    ]);
    const cellOverrides = (0, $5uXOq.useCallback)(()=>({
            onClick: ()=>true,
            onKeyDown: handleKeyDown
        }), [
        handleKeyDown
    ]);
    (0, $5uXOq.useImperativeHandle)(cellRef, cellOverrides, [
        cellOverrides
    ]);
    return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $309d1fc5b0994c7c$var$wrapperStyles,
        onClick: handleClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $309d1fc5b0994c7c$var$textStyles,
        as: "span"
    }, textValue)));
});
const $309d1fc5b0994c7c$var$wrapperStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    cursor: 'pointer'
});
const $309d1fc5b0994c7c$var$textStyles = (0, $8CUq3.xcss)({
    padding: 'space.075',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});

});
parcelRegister("fkAB3", function(module, exports) {

$parcel$export(module.exports, "getADFMarkup", () => $d25444d60d26b6d9$export$3d7eec7fcefdad14);



const $d25444d60d26b6d9$export$3d7eec7fcefdad14 = async (node)=>{
    if (node === null || node === undefined || typeof node === 'string') return '';
    const schemaPromise = (parcelRequire("hr7QF"));
    const wikiPromise = (parcelRequire("7y1vK"));
    const jsonPromise = (parcelRequire("76p3g"));
    const [{ defaultSchema: defaultSchema }, { WikiMarkupTransformer: WikiMarkupTransformer }, { JSONTransformer: JSONTransformer }] = await Promise.all([
        schemaPromise,
        wikiPromise,
        jsonPromise
    ]);
    const wikiTransformer = new WikiMarkupTransformer(defaultSchema);
    const adfTransformer = new JSONTransformer();
    const pmNode = adfTransformer.parse(node);
    return wikiTransformer.encode(pmNode);
};

});


parcelRegister("iydSP", function(module, exports) {

$parcel$export(module.exports, "TextCell", () => $310165238372edbd$export$765aced31cc89655);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $9dZ1c = parcelRequire("9dZ1c");

var $iZOJ9 = parcelRequire("iZOJ9");

var $2NMNM = parcelRequire("2NMNM");

var $kY99m = parcelRequire("kY99m");

var $6ByXP = parcelRequire("6ByXP");

var $b5lmY = parcelRequire("b5lmY");

var $e0a4D = parcelRequire("e0a4D");

var $1T1ir = parcelRequire("1T1ir");

var $6s1PB = parcelRequire("6s1PB");

var $lQE94 = parcelRequire("lQE94");

var $1RMb0 = parcelRequire("1RMb0");

var $k2wwp = parcelRequire("k2wwp");


var $iXGUb = parcelRequire("iXGUb");

var $5YWZW = parcelRequire("5YWZW");

var $64Oxj = parcelRequire("64Oxj");
const $310165238372edbd$export$fc152bafe73dcaee = (props)=>{
    const { editMode: editMode, highlight: highlight, fieldName: fieldName, onSubmit: onSubmit, onBlur: onBlur, onChange: onChange, onKeyDown: onKeyDown, value: value, testId: testId } = props;
    if (editMode) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("form", {
        onSubmit: onSubmit ?? (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
        testId: testId ? `${testId}-field` : undefined,
        autoFocus: true,
        onBlur: onBlur,
        value: value,
        onChange: onChange,
        onKeyDown: onKeyDown,
        "aria-label": fieldName
    }));
    if (value && typeof value === 'string' && (0, $iZOJ9.isSafeUrl)(value) && (0, $6s1PB.expValEquals)('jsw_perf_format-links-in-custom-fields', 'list-view', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1RMb0.LazySingleLineSmartLink), {
        anchorTarget: "_blank",
        url: value,
        fieldType: "text"
    });
    if (highlight && highlight.length > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k2wwp.default), {
        highlight: highlight,
        text: value
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": testId
    }, value);
};
const $310165238372edbd$export$765aced31cc89655 = ({ issueKey: issueKey, fieldKey: fieldKey, isEditable: isEditable, fieldValue: fieldValue, fieldType: fieldType, testId: testId, isNudgeCell: isNudgeCell = false, wrapperRef: wrapperRef, issueId: issueId, editMode: editMode = false, setEditMode: setEditMode = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), cellRef: cellRef, issueType: issueType = '', issueTypeId: issueTypeId = '', fieldName: fieldName = '', inputValue: inputValue, onInputChange: setTextValue = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) })=>{
    const searchHighlight = (0, $1T1ir.useSimpleSearchHighlight)();
    const textValue = (inputValue ?? fieldValue) || '';
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $lQE94.useEditField)({
        fieldKey: fieldKey,
        issueId: issueId,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: fieldValue,
        onFailure: ()=>{
            setTextValue(value || '');
        }
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { ref: inlineEditNudgeRef } = (0, $9dZ1c.useRegisterNudgeTarget)((0, $dbbf68c32d8c4308$export$a1398a6ef9526001), isNudgeCell);
    (0, $5uXOq.useEffect)(()=>{
        if (wrapperRef?.current) inlineEditNudgeRef.current = wrapperRef.current;
    }, [
        inlineEditNudgeRef,
        wrapperRef
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (fieldValue) setTextValue(fieldValue);
    }, [
        fieldValue,
        setTextValue
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // when the value (from useEditField) changes, update the textValue (from the input field).
        if (value !== textValue) setTextValue(value || '');
    }, // we only care about value changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        setTextValue,
        value
    ]);
    const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
        if (editMode && event.code === 'Escape') setTextValue(value || '');
        return false;
    }, [
        editMode,
        setTextValue,
        value
    ]);
    const saveAndClose = (0, $5uXOq.useCallback)(()=>{
        if (editMode) {
            setEditMode(false);
            if (textValue !== value) saveValue(textValue, null, createAnalyticsEvent({}));
        }
    }, [
        editMode,
        textValue,
        value,
        saveValue,
        createAnalyticsEvent,
        setEditMode
    ]);
    const handleBlur = (0, $5uXOq.useCallback)(()=>{
        saveAndClose();
    }, [
        saveAndClose
    ]);
    const handleChange = (0, $5uXOq.useCallback)((event)=>{
        setTextValue(event.target.value);
        resetError();
    }, [
        resetError,
        setTextValue
    ]);
    const renderNudgeWrapper = (children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXGUb.InlineEditListNudgeAsync), null, children);
    const handleSubmit = (0, $5uXOq.useCallback)(()=>{
        saveAndClose();
    }, [
        saveAndClose
    ]);
    const cellOverrides = (0, $5uXOq.useCallback)(()=>({
            onKeyDown: handleKeyDown
        }), [
        handleKeyDown
    ]);
    (0, $5uXOq.useImperativeHandle)(cellRef, cellOverrides, [
        cellOverrides
    ]);
    const handleSpotlightClose = (0, $5uXOq.useCallback)((event)=>{
        // Need to stop the event as its auto focusing on the cell and putting it in edit mode
        event.stopPropagation();
        setEditMode(false);
        setTimeout(()=>{
            wrapperRef?.current?.focus();
        }, 0);
    }, [
        setEditMode,
        wrapperRef
    ]);
    const textCell = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($310165238372edbd$export$fc152bafe73dcaee, {
        editMode: editMode,
        onBlur: handleBlur,
        onSubmit: handleSubmit,
        onChange: handleChange,
        value: textValue,
        highlight: searchHighlight,
        testId: testId,
        fieldName: fieldName
    }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0a4D.FixItErrorFlag), {
        error: error,
        title: (0, $64Oxj.default).errorTitle,
        description: (0, $64Oxj.default).errorMessage,
        issueType: issueType,
        issueTypeId: issueTypeId,
        fieldId: fieldKey,
        fieldName: fieldName
    }));
    const textCellWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6ByXP.ConditionalWrapper), {
        condition: isNudgeCell,
        renderWrapper: renderNudgeWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b5lmY.TextCellWrapper), {
        isEditable: isEditable,
        testId: "business-list.ui.list-view.text-cell.text-cell-wrapper"
    }, textCell));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5YWZW.ClickToEditOnboardingTour), {
        isNudgeCell: isNudgeCell,
        wrapperRef: wrapperRef,
        onClose: handleSpotlightClose
    }, textCellWrapper);
};

});
parcelRegister("iZOJ9", function(module, exports) {

$parcel$export(module.exports, "isSafeUrl", () => $dd4545da25e52dce$export$c9f92f5469372e0f);
$parcel$export(module.exports, "linkify", () => $dd4545da25e52dce$export$8ccbde94d5c7f8e7);
$parcel$export(module.exports, "linkifyMatch", () => $dd4545da25e52dce$export$6f7d7761b97f967);
$parcel$export(module.exports, "getLinkMatch", () => $dd4545da25e52dce$export$ce9ae45aed3e4ec);
$parcel$export(module.exports, "normalizeUrl", () => $dd4545da25e52dce$export$6535eb414fa2c8b6);
$parcel$export(module.exports, "isRootRelative", () => $dd4545da25e52dce$export$23579274a7a24f7b);
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $i6xkD = parcelRequire("i6xkD");
const $dd4545da25e52dce$var$whitelistedURLPatterns = [
    /^https?:\/\//im,
    /^ftps?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^smb:\/\//im,
    /^dynamicsnav:\/\//im,
    /^jamfselfservice:\/\//im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:/im,
    /^facetime:/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/im,
    /^notes:\/\//im,
    /^hipchat:\/\//im,
    // This is not a valid sourcetree link, but we support this pattern for backwards compatibility
    /^sourcetree:/im,
    /^sourcetree:\/\//im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
    /^#/im
];
const $dd4545da25e52dce$export$c9f92f5469372e0f = (url)=>{
    const urlTrimmed = url.trim();
    if (urlTrimmed.length === 0) return true;
    return $dd4545da25e52dce$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
};
const $dd4545da25e52dce$export$8ccbde94d5c7f8e7 = (0, (/*@__PURE__*/$parcel$interopDefault($i6xkD)))();
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('sourcetree:', 'http:');
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('jamfselfservice:', 'http:');
const $dd4545da25e52dce$var$urlWithoutSpacesValidator = {
    validate: /[^\s]+/
};
// `tel:` URI spec is https://datatracker.ietf.org/doc/html/rfc3966
// We're not validating the phone number or separators - but if there's a space it definitely isn't a valid `tel:` URI
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('tel:', $dd4545da25e52dce$var$urlWithoutSpacesValidator);
// https://datatracker.ietf.org/doc/html/rfc8089
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('file:', $dd4545da25e52dce$var$urlWithoutSpacesValidator);
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('notes:', 'http:');
const $dd4545da25e52dce$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
const $dd4545da25e52dce$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
$dd4545da25e52dce$var$tlds.push($dd4545da25e52dce$var$tlds2Char);
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.tlds($dd4545da25e52dce$var$tlds, false);
const $dd4545da25e52dce$export$746d02eae03c72e1 = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
const $dd4545da25e52dce$export$6f7d7761b97f967 = (text)=>{
    if (!$dd4545da25e52dce$export$746d02eae03c72e1.test(text)) return [];
    const matches = [];
    let startpos = 0;
    let substr;
    while(substr = text.substr(startpos)){
        const link = (substr.match($dd4545da25e52dce$export$746d02eae03c72e1) || [
            ''
        ])[0];
        if (link) {
            const index = substr.search($dd4545da25e52dce$export$746d02eae03c72e1);
            const start = index >= 0 ? index + startpos : index;
            const end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos += end;
        } else break;
    }
    return matches;
};
function $dd4545da25e52dce$export$ce9ae45aed3e4ec(str) {
    if (!str) return null;
    // linkify-it mishandles closing braces on long urls, so we preference using our own regex first:
    // https://product-fabric.atlassian.net/browse/ED-13669
    let match = $dd4545da25e52dce$export$6f7d7761b97f967(str);
    if (!match.length) match = $dd4545da25e52dce$export$8ccbde94d5c7f8e7.match(str);
    return match && match[0];
}
function $dd4545da25e52dce$export$6535eb414fa2c8b6(url) {
    const match = $dd4545da25e52dce$export$ce9ae45aed3e4ec(url);
    return match && match.url || '';
}
function $dd4545da25e52dce$export$23579274a7a24f7b(url) {
    // Support `#top` and `#` special references as per:
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#linking_to_an_element_on_the_same_page
    return url.startsWith('/') || url === '#top' || url === '#';
}

});
parcelRegister("i6xkD", function(module, exports) {
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $d2e2a485107d561a$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $d2e2a485107d561a$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $d2e2a485107d561a$var$isString(obj) {
    return $d2e2a485107d561a$var$_class(obj) === '[object String]';
}
function $d2e2a485107d561a$var$isObject(obj) {
    return $d2e2a485107d561a$var$_class(obj) === '[object Object]';
}
function $d2e2a485107d561a$var$isRegExp(obj) {
    return $d2e2a485107d561a$var$_class(obj) === '[object RegExp]';
}
function $d2e2a485107d561a$var$isFunction(obj) {
    return $d2e2a485107d561a$var$_class(obj) === '[object Function]';
}
function $d2e2a485107d561a$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $d2e2a485107d561a$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $d2e2a485107d561a$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $d2e2a485107d561a$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $d2e2a485107d561a$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $d2e2a485107d561a$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $d2e2a485107d561a$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $d2e2a485107d561a$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $d2e2a485107d561a$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $d2e2a485107d561a$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $d2e2a485107d561a$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("9mKTr"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($d2e2a485107d561a$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($d2e2a485107d561a$var$isObject(val)) {
            if ($d2e2a485107d561a$var$isRegExp(val.validate)) compiled.validate = $d2e2a485107d561a$var$createValidator(val.validate);
            else if ($d2e2a485107d561a$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($d2e2a485107d561a$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $d2e2a485107d561a$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($d2e2a485107d561a$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $d2e2a485107d561a$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($d2e2a485107d561a$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|' + '(' + self.re.host_fuzzy_test.source + ')|' + '@', 'i');
    //
    // Cleanup
    //
    $d2e2a485107d561a$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $d2e2a485107d561a$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $d2e2a485107d561a$var$createMatch(self, shift) {
    var match = new $d2e2a485107d561a$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $d2e2a485107d561a$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $d2e2a485107d561a$var$LinkifyIt)) return new $d2e2a485107d561a$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($d2e2a485107d561a$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $d2e2a485107d561a$var$assign({}, $d2e2a485107d561a$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $d2e2a485107d561a$var$assign({}, $d2e2a485107d561a$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $d2e2a485107d561a$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $d2e2a485107d561a$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $d2e2a485107d561a$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $d2e2a485107d561a$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($d2e2a485107d561a$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($d2e2a485107d561a$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $d2e2a485107d561a$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $d2e2a485107d561a$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $d2e2a485107d561a$var$LinkifyIt;

});
parcelRegister("9mKTr", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("b9ep3")).source;
    re.src_Cc = (parcelRequire("23ErL")).source;
    re.src_Z = (parcelRequire("oRY4m")).source;
    re.src_P = (parcelRequire("9bBmm")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-]).|' + // allow `I'm_king` if no pair found
    '\\.{2,3}[a-zA-Z0-9%/]|' + // github has ... in commit range links. Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]).|' + (opts && opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + '\\,(?!' + re.src_ZCc + ').|' + // allow `,,,` in paths
    '\\!(?!' + re.src_ZCc + '|[!]).|' + '\\?(?!' + re.src_ZCc + '|[?]).' + ')+' + '|\\/' + ')?';
    re.src_email_name = '[\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]+';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + // don't allow `--` in domain names, because:
    // - that can conflict with markdown &mdash; / &ndash;
    // - nobody use those anyway
    '(?:' + re.src_pseudo_letter + '(?:-(?!-)|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|\\(|' + re.src_ZCc + ')(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});
parcelRegister("b9ep3", function(module, exports) {
module.exports = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;

});

parcelRegister("23ErL", function(module, exports) {
module.exports = /[\0-\x1F\x7F-\x9F]/;

});

parcelRegister("oRY4m", function(module, exports) {
module.exports = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;

});

parcelRegister("9bBmm", function(module, exports) {
module.exports = /[!-#%-\*,-/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E49\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC9\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;

});




parcelRegister("1RMb0", function(module, exports) {

$parcel$export(module.exports, "LazySingleLineSmartLink", () => $1520f3a29774e13a$export$80092fcb07ccc4b4);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $7c22Q = parcelRequire("7c22Q");
const $1520f3a29774e13a$var$entryPointParams = {};
const $1520f3a29774e13a$export$80092fcb07ccc4b4 = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $7c22Q.SingleLineSmartLinkEntryPoint), $1520f3a29774e13a$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "jira.issue-field.single-line-smart-link",
        packageName: "issue-field-smart-link",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props
    });
};

});
parcelRegister("7c22Q", function(module, exports) {

$parcel$export(module.exports, "SingleLineSmartLinkEntryPoint", () => $5f4ae65db2a1976a$export$e236c9b35543c8d);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $5f4ae65db2a1976a$export$e236c9b35543c8d = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("lEZC9")).then((module)=>module.SingleLineSmartLink), {
        moduleId: "97818dc4"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("lEZC9", function(module, exports) {

let $fc4d20b9422643e9$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $fc4d20b9422643e9$var$load("fliVL"),
    $fc4d20b9422643e9$var$load("eVTNs")
]).then(()=>parcelRequire('k2J4N'));

});



parcelRegister("k2wwp", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e37bd657627b5db$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $1H6kL = parcelRequire("1H6kL");

var $cM7El = parcelRequire("cM7El");
const $5e37bd657627b5db$var$HighlightTextWithParser = /*#__PURE__*/ (0, $5uXOq.memo)(({ text: text, highlight: highlight })=>{
    const parts = (0, $1H6kL.getParts)(highlight, text);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cM7El.default), {
        parts: parts
    });
});
var $5e37bd657627b5db$export$2e2bcd8739ae039 = $5e37bd657627b5db$var$HighlightTextWithParser;

});
parcelRegister("1H6kL", function(module, exports) {

$parcel$export(module.exports, "removeAccents", () => $0b92ef830f5aa8e4$export$f3f2882e8b11d731);
$parcel$export(module.exports, "getParts", () => $0b92ef830f5aa8e4$export$a3aee8a24a54661f);

var $8QDwl = parcelRequire("8QDwl");

var $ajpes = parcelRequire("ajpes");

var $3JOCw = parcelRequire("3JOCw");

var $8QpSo = parcelRequire("8QpSo");
const $0b92ef830f5aa8e4$export$f3f2882e8b11d731 = (0, $8QpSo.default)((text)=>text.normalize('NFD').replace(/[\u0300-\u036f]/g, ''));
const $0b92ef830f5aa8e4$export$1633667427d99697 = (0, $8QpSo.default)((highlight)=>{
    const escapedFilter = highlight.map((phrase)=>(0, (/*@__PURE__*/$parcel$interopDefault($8QDwl)))(phrase)).join('|');
    return new RegExp(escapedFilter, 'gmi');
}, (newArgs, lastArgs)=>{
    if (newArgs.length !== lastArgs.length) return false;
    const equalityFn = (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)));
    return newArgs.every((newArg, index)=>equalityFn(newArg, lastArgs[index]));
});
const $0b92ef830f5aa8e4$export$2235873b95f89ea = (content)=>({
        type: 'text',
        content: content
    });
const $0b92ef830f5aa8e4$export$39ae7d355c29b45f = (content)=>({
        type: 'highlight',
        content: content
    });
const $0b92ef830f5aa8e4$export$c05c39859172f90c = (str, regExp)=>{
    const ms = [];
    let m = regExp.exec(str);
    while(m){
        ms.push(m);
        m = regExp.exec(str);
    }
    return ms;
};
const $0b92ef830f5aa8e4$export$a3aee8a24a54661f = (highlight, text)=>{
    if (highlight == null || highlight.filter((phrase)=>phrase !== '').length === 0) return [
        $0b92ef830f5aa8e4$export$2235873b95f89ea(text)
    ];
    const parts = [];
    // Long text lengths will cause "Invalid regular expression" error
    const truncatedHighlight = highlight.map((phrase)=>phrase.substring(0, 255));
    const highlightRegExp = $0b92ef830f5aa8e4$export$1633667427d99697(truncatedHighlight.filter((phrase)=>phrase !== ''));
    const textWithoutAccents = $0b92ef830f5aa8e4$export$f3f2882e8b11d731(text);
    const textMatches = $0b92ef830f5aa8e4$export$c05c39859172f90c(text, highlightRegExp);
    const textWithoutAccentsMatches = $0b92ef830f5aa8e4$export$c05c39859172f90c(textWithoutAccents, highlightRegExp);
    const highlightMatches = (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))([
        ...textWithoutAccentsMatches,
        ...textMatches
    ], 'index');
    let currentPosition = 0;
    highlightMatches.forEach((match)=>{
        const matchText = text.slice(match.index, match.index + match[0].length);
        const leading = text.slice(currentPosition, match.index);
        if (leading !== '') parts.push($0b92ef830f5aa8e4$export$2235873b95f89ea(leading));
        parts.push($0b92ef830f5aa8e4$export$39ae7d355c29b45f(matchText));
        currentPosition = match.index + matchText.length;
    });
    const trailing = text.slice(currentPosition);
    if (trailing !== '') parts.push($0b92ef830f5aa8e4$export$2235873b95f89ea(trailing));
    return parts;
};

});

parcelRegister("cM7El", function(module, exports) {

$parcel$export(module.exports, "default", () => $328475be93221885$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $328475be93221885$var$Mark = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "mark", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_bfhki1yw _syaz1fxt",
            __cmplp.className
        ])
    });
});
const $328475be93221885$var$HighlightText = ({ parts: parts })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, parts.map((part, i)=>{
        if (part.type === 'text') return part.content;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($328475be93221885$var$Mark, {
            key: i
        }, part.content);
    }));
var $328475be93221885$export$2e2bcd8739ae039 = $328475be93221885$var$HighlightText;

});


parcelRegister("iXGUb", function(module, exports) {

$parcel$export(module.exports, "InlineEditListNudgeAsync", () => $ecb11ac319bfddf4$export$ae0c23fe550deebc);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");


var $avYCR = parcelRequire("avYCR");
const $ecb11ac319bfddf4$var$runtimeProps = {};
const $ecb11ac319bfddf4$var$entryPointParams = {};
const $ecb11ac319bfddf4$export$ae0c23fe550deebc = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $avYCR.inlineEditNudgeEntrypoint), $ecb11ac319bfddf4$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: (0, $dbbf68c32d8c4308$export$501e36925fa10eef),
        packageName: "jiraListOnboarding",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
        runtimeProps: $ecb11ac319bfddf4$var$runtimeProps
    }));
};

});
parcelRegister("avYCR", function(module, exports) {

$parcel$export(module.exports, "inlineEditNudgeEntrypoint", () => $e132edaa0d1fa946$export$8073de424af508bc);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $e132edaa0d1fa946$export$8073de424af508bc = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("2RhOD")), {
        moduleId: "1e3103f7"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("2RhOD", function(module, exports) {

let $214e59d55c40f9f3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $214e59d55c40f9f3$var$load("7DoZ0").then(()=>parcelRequire('kbd1h'));

});



parcelRegister("5YWZW", function(module, exports) {

$parcel$export(module.exports, "ClickToEditOnboardingTour", () => $2582cb405acaae8c$export$7b4b56fb1204d901);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $6ByXP = parcelRequire("6ByXP");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $4R6GH = parcelRequire("4R6GH");

var $cRuls = parcelRequire("cRuls");

var $kmVCz = parcelRequire("kmVCz");
const $2582cb405acaae8c$var$isMacOS = ()=>/Mac/i.test(typeof window !== 'undefined' ? window?.navigator?.platform : '');
function $2582cb405acaae8c$export$7b4b56fb1204d901(props) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const steps = {
        'copy-paste': {
            heading: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $kmVCz.default).clickToEditCopyPasteHeadingIssueTermRefresh : (0, $kmVCz.default).clickToEditCopyPasteHeading),
            body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
                values: {
                    code: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2582cb405acaae8c$var$Code, null, chunks)
                },
                ...$2582cb405acaae8c$var$isMacOS() ? (0, $kmVCz.default).clickToEditCopyPasteBodyMac : (0, $kmVCz.default).clickToEditCopyPasteBodyWindows
            })
        },
        navigation: {
            heading: formatMessage((0, $kmVCz.default).clickToEditNavigationHeading),
            body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
                values: {
                    code: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2582cb405acaae8c$var$Code, null, chunks)
                },
                ...$2582cb405acaae8c$var$isMacOS() ? (0, $kmVCz.default).clickToEditNavigationBodyMac : (0, $kmVCz.default).clickToEditNavigationBodyWindows
            })
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2582cb405acaae8c$var$CopyPasteOnboardingTour, {
        ...props,
        cohort: "control",
        steps: steps
    });
}
function $2582cb405acaae8c$export$c6deaa5246c3126(props) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const getCopyPasteStep = ()=>{
        if ($2582cb405acaae8c$var$isMacOS()) return (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $kmVCz.default).clickToSelectCopyPasteBodyMacIssueTermRefresh : (0, $kmVCz.default).clickToSelectCopyPasteBodyMac;
        return (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $kmVCz.default).clickToSelectCopyPasteBodyWindowsIssueTermRefresh : (0, $kmVCz.default).clickToSelectCopyPasteBodyWindows;
    };
    const steps = {
        'copy-paste': {
            heading: formatMessage((0, $kmVCz.default).clickToSelectCopyPasteHeading),
            body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
                values: {
                    code: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2582cb405acaae8c$var$Code, null, chunks)
                },
                ...getCopyPasteStep()
            })
        },
        navigation: {
            heading: formatMessage((0, $kmVCz.default).clickToSelectNavigationHeading),
            body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
                values: {
                    code: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2582cb405acaae8c$var$Code, null, chunks)
                },
                ...$2582cb405acaae8c$var$isMacOS() ? (0, $kmVCz.default).clickToSelectNavigationBodyMac : (0, $kmVCz.default).clickToSelectNavigationBodyWindows
            })
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2582cb405acaae8c$var$CopyPasteOnboardingTour, {
        ...props,
        cohort: "variation",
        steps: steps
    });
}
function $2582cb405acaae8c$var$CopyPasteOnboardingTour({ children: children, isNudgeCell: isNudgeCell, wrapperRef: wrapperRef, steps: steps, cohort: cohort, onClose: onClose }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6ByXP.ConditionalWrapper), {
        condition: isNudgeCell,
        renderWrapper: (wrappedChildren)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cRuls.CopyPasteTourAsync), {
                wrapperRef: wrapperRef,
                cohort: cohort,
                steps: steps,
                onClose: onClose
            }, wrappedChildren)
    }, children);
}
function $2582cb405acaae8c$var$Code({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("code", {
        className: (0, $bwpsq.default)([
            "_11c81u0j _2rkoglpi _1reo1wug _18m91wug _1dqoglyw _bfhkm7j4 _syaz15cr _1e0c1nu9 _ca0qv77o _u5f3m5ip _n3tdv77o _19bvm5ip _16d9qvcn _1i4q1hna _o5721jtm"
        ])
    }, children);
}
const $2582cb405acaae8c$var$codeStyles = null;

});
parcelRegister("cRuls", function(module, exports) {

$parcel$export(module.exports, "CopyPasteTourAsync", () => $6b8ba61cbc1ed3f7$export$cc0fbe7c384bfe4a);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $6b8ba61cbc1ed3f7$var$LazyCopyPasteTour = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("oHhPz")), {
    ssr: false,
    moduleId: "./src/packages/business/list/src/common/ui/lazy-copy-paste-tour/main.tsx"
});
function $6b8ba61cbc1ed3f7$export$cc0fbe7c384bfe4a(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "copy-paste-onboarding-tour",
        fallback: props.children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6b8ba61cbc1ed3f7$var$LazyCopyPasteTour, props));
}

});
parcelRegister("oHhPz", function(module, exports) {

let $04a3d1d2555de126$var$load = (parcelRequire("28QjX"))(4);
module.exports = $04a3d1d2555de126$var$load("8qRcT").then(()=>parcelRequire('dytsQ'));

});


parcelRegister("kmVCz", function(module, exports) {

$parcel$export(module.exports, "default", () => $393dcda9650aa91a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $393dcda9650aa91a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    clickToEditCopyPasteHeading: {
        "id": "business-list.list-view.text-cell.copy-paste-onboarding.click-to-edit-copy-paste-heading",
        "defaultMessage": "Edit issues inline, or copy and paste"
    },
    clickToEditCopyPasteHeadingIssueTermRefresh: {
        "id": "business-list.list-view.text-cell.copy-paste-onboarding.click-to-edit-copy-paste-heading-issue-term-refresh",
        "defaultMessage": "Edit work items inline, or copy and paste"
    },
    clickToEditCopyPasteBodyMac: {
        "id": "business-list.list-view.text-cell.copy-paste-onboarding.click-to-edit-copy-paste-body-mac",
        "defaultMessage": "Select a cell to quickly edit details. To copy and paste without editing, select <code>esc</code> then <code>command</code> + <code>C</code> / <code>V</code>."
    },
    clickToEditCopyPasteBodyWindows: {
        "id": "business-list.list-view.text-cell.copy-paste-onboarding.click-to-edit-copy-paste-body-windows",
        "defaultMessage": "Select a cell to quickly edit details. To copy and paste without editing, select <code>esc</code> then <code>ctrl</code> + <code>C</code> / <code>V</code>."
    },
    clickToEditNavigationHeading: {
        "id": "business-list.list-view.text-cell.copy-paste-onboarding.click-to-edit-navigation-heading",
        "defaultMessage": "Navigate with your keyboard"
    },
    clickToEditNavigationBodyMac: {
        "id": "business-list.list-view.text-cell.copy-paste-onboarding.click-to-edit-navigation-body-mac",
        "defaultMessage": "Select a cell then use <code>tab</code> and arrow keys to navigate your list. Use <code>return</code> to edit details, and <code>esc</code> to exit edit mode."
    },
    clickToEditNavigationBodyWindows: {
        "id": "business-list.list-view.text-cell.copy-paste-onboarding.click-to-edit-navigation-body-windows",
        "defaultMessage": "Select a cell then use <code>tab</code> and arrow keys to navigate your list. Use <code>enter</code> to edit details, and <code>esc</code> to exit edit mode."
    },
    clickToSelectCopyPasteHeading: {
        "id": "business-list.list-view.text-cell.copy-paste-onboarding.click-to-select-copy-paste-heading",
        "defaultMessage": "Copy and paste details, just like a spreadsheet"
    },
    clickToSelectCopyPasteBodyMac: {
        "id": "business-list.list-view.text-cell.copy-paste-onboarding.click-to-select-copy-paste-body-mac",
        "defaultMessage": "To copy and paste issue details, select a cell then <code>command</code> + <code>C</code> / <code>V</code>. Select the cell again to edit."
    },
    clickToSelectCopyPasteBodyWindows: {
        "id": "business-list.list-view.text-cell.copy-paste-onboarding.click-to-select-copy-paste-body-windows",
        "defaultMessage": "To copy and paste issue details, select a cell then <code>ctrl</code> + <code>C</code> / <code>V</code>. Select the cell again to edit."
    },
    clickToSelectCopyPasteBodyMacIssueTermRefresh: {
        "id": "business-list.list-view.text-cell.copy-paste-onboarding.click-to-select-copy-paste-body-mac-issue-term-refresh",
        "defaultMessage": "To copy and paste work item details, select a cell then <code>command</code> + <code>C</code> / <code>V</code>. Select the cell again to edit."
    },
    clickToSelectCopyPasteBodyWindowsIssueTermRefresh: {
        "id": "business-list.list-view.text-cell.copy-paste-onboarding.click-to-select-copy-paste-body-windows-issue-term-refresh",
        "defaultMessage": "To copy and paste work item details, select a cell then <code>ctrl</code> + <code>C</code> / <code>V</code>. Select the cell again to edit."
    },
    clickToSelectNavigationHeading: {
        "id": "business-list.list-view.text-cell.copy-paste-onboarding.click-to-select-navigation-heading",
        "defaultMessage": "Navigate with your keyboard"
    },
    clickToSelectNavigationBodyMac: {
        "id": "business-list.list-view.text-cell.copy-paste-onboarding.click-to-select-navigation-body-mac",
        "defaultMessage": "Select a cell then use <code>tab</code> and arrow keys to navigate your list. Use <code>return</code> to edit details, and <code>esc</code> to exit edit mode."
    },
    clickToSelectNavigationBodyWindows: {
        "id": "business-list.list-view.text-cell.copy-paste-onboarding.click-to-select-navigation-body-windows",
        "defaultMessage": "Select a cell then use <code>tab</code> and arrow keys to navigate your list. Use <code>enter</code> to edit details, and <code>esc</code> to exit edit mode."
    }
});

});


parcelRegister("64Oxj", function(module, exports) {

$parcel$export(module.exports, "default", () => $0089743c0f9c5c88$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0089743c0f9c5c88$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorTitle: {
        "id": "business-list.list-view.text-cell.error-title",
        "defaultMessage": "We couldn't save the text value."
    },
    errorMessage: {
        "id": "business-list.list-view.text-cell.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    }
});

});


parcelRegister("eTHix", function(module, exports) {

$parcel$export(module.exports, "TypeCell", () => $d801f8d5b8ae88a1$export$1034b01824b6a80);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3bDjY = parcelRequire("3bDjY");

var $6ByXP = parcelRequire("6ByXP");

var $1T2vX = parcelRequire("1T2vX");

var $33Toe = parcelRequire("33Toe");

var $jjlQu = parcelRequire("jjlQu");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dCm1o = parcelRequire("dCm1o");

var $1CXMr = parcelRequire("1CXMr");

var $lDRI0 = parcelRequire("lDRI0");

var $4nnGr = parcelRequire("4nnGr");

var $mH57d = parcelRequire("mH57d");

var $88kyp = parcelRequire("88kyp");
const $d801f8d5b8ae88a1$var$empty = ()=>null;
const $d801f8d5b8ae88a1$export$1034b01824b6a80 = /*#__PURE__*/ (0, $5uXOq.memo)(({ id: id, iconUrl: iconUrl, name: name, avatarId: avatarId = '', onChildCreateButtonClicked: onChildCreateButtonClicked, hierarchyLevel: hierarchyLevel = 0, isSelected: isSelected = false, cellRef: cellRef, rankIndex: rankIndex })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { showFlatList: showFlatList } = (0, $mH57d.useHierarchyConfig)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handlePlusButtonClick = (0, $5uXOq.useCallback)((event)=>{
        event.preventDefault();
        onChildCreateButtonClicked && setTimeout(()=>{
            onChildCreateButtonClicked();
        });
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'childCreateButton');
    }, [
        createAnalyticsEvent,
        onChildCreateButtonClicked
    ]);
    const { hasCreateSubtask: hasCreateSubtask } = (0, $4nnGr.useJWMListFeatures)();
    const { data: { issueTypes: issueTypes } } = (0, $1T2vX.useIssueTypesAndFields)({
        issueOperation: 'CREATE'
    });
    const canCreateChildIssue = hierarchyLevel > 0 ? issueTypes.some((issueType)=>issueType.hierarchyLevel === hierarchyLevel - 1) : hasCreateSubtask && issueTypes.some((issueType)=>issueType.hierarchyLevel === -1);
    const canCreateChild = !(0, $33Toe.isOptimisticIssue)(Number(id)) && !showFlatList && typeof onChildCreateButtonClicked === 'function' && canCreateChildIssue;
    const getButtonLabel = (()=>{
        if ((0, $6s1PB.expVal)('jira-itr-m4-exp-3', 'isEnabled', false)) return formatMessage((0, $88kyp.default).createChildItemIssueTerminologyRefreshM4, {
            issueLevel: hierarchyLevel ? 'child work item' : 'subtask'
        });
        return formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $88kyp.default).createChildItemIssueTermRefresh : (0, $88kyp.default).createChildItem);
    })();
    const childCreateContent = canCreateChild && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6ByXP.ConditionalWrapper), {
        condition: rankIndex === 0 && (0, $lDRI0.shouldWrapTypeCellOnboardingSpotlight)(),
        renderWrapper: ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lDRI0.HierarchySpotlightWrapper), {
                renderTrigger: (isSpotlightVisible)=>{
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1CXMr.default), {
                        tooltip: getButtonLabel,
                        label: getButtonLabel,
                        onClick: handlePlusButtonClick,
                        shouldDisplayBtn: isSpotlightVisible || isSelected
                    });
                }
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1CXMr.default), {
        tooltip: getButtonLabel,
        label: getButtonLabel,
        onClick: handlePlusButtonClick,
        shouldDisplayBtn: isSelected
    }));
    const iconContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jjlQu.default), {
        url: iconUrl,
        alt: name,
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jjlQu.default), {
                url: `/secure/viewavatar?size=medium&avatarId=${avatarId}&avatarType=issuetype`,
                alt: name,
                fallback: $d801f8d5b8ae88a1$var$empty
            })
    });
    const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
        if (event.code === 'Enter') return true;
        return false;
    }, []); // ignore clicks to avoid entering editMode
    const handleClick = (0, $5uXOq.useCallback)(()=>true, []);
    const cellOverrides = (0, $5uXOq.useMemo)(()=>()=>({
                onClick: handleClick,
                onKeyDown: handleKeyDown
            }), [
        handleClick,
        handleKeyDown
    ]);
    (0, $5uXOq.useImperativeHandle)(cellRef, cellOverrides, [
        cellOverrides
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d801f8d5b8ae88a1$var$TypeWrapper, {
        "data-testid": "business-list.ui.list-view.type-cell.type-wrapper",
        canCreateChild: canCreateChild,
        tabIndex: 0,
        isVisualRefresh: (0, $dCm1o.isVisualRefreshEnabled)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: name
    }, iconContent), childCreateContent);
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d801f8d5b8ae88a1$var$TypeWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisualRefresh: isVisualRefresh, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_12ji1r31 _1qu2glyw _12y31o36 _2rkoglpi _1e0c1txw _4cvr1h6o _1bsb1osq _4t3i1osq _19bvldb6",
            __cmplp ? "_1hlxu2gc" : "_1hlxidpf",
            __cmplp.isVisualRefresh ? "_p7r11txw _tij01h6o" : "_k8empxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jjlQu", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7f7206d8a029d15$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable jira/react/handler-naming */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $gwIPs = parcelRequire("gwIPs");
const $e7f7206d8a029d15$export$c6d2b2df39d78e5b = (0, $gwIPs.gridSize) * 2;
class $e7f7206d8a029d15$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            url: undefined,
            title: undefined,
            alt: undefined,
            width: $e7f7206d8a029d15$export$c6d2b2df39d78e5b,
            height: $e7f7206d8a029d15$export$c6d2b2df39d78e5b,
            fallback: undefined
        };
    }
    render() {
        const { title: title, url: url, alt: alt, fallback: fallback } = this.props;
        const width = this.convertSize(this.props.width);
        const height = this.convertSize(this.props.height);
        if (this.state.isBroken && fallback) return fallback();
        if (url) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e7f7206d8a029d15$var$Image, {
            src: url,
            width: width,
            height: height,
            title: title ?? undefined,
            alt: alt ?? '',
            onError: this.onError,
            /**
       * Disabling dragging so drags happen on the parent instead of this icon.
       */ draggable: false,
            "data-vc": "common-components-async-icon"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $e7f7206d8a029d15$var$placeholderStyles,
            // eslint-disable-next-line jira/react/no-style-attribute
            style: {
                height: height,
                width: width
            },
            backgroundColor: "color.background.input.hovered",
            testId: "common-components-async-icon.placeholder"
        });
    }
    constructor(...args){
        super(...args), this.state = {
            isBroken: false
        }, this.onError = ()=>{
            this.setState({
                isBroken: true
            });
        }, this.convertSize = (size)=>size ? `${size}px` : '0';
    }
}
const $e7f7206d8a029d15$var$placeholderStyles = (0, $8CUq3.xcss)({
    borderRadius: '3px',
    display: 'flex',
    flex: 'none'
});
// Firefox displays the alt text when the image can't load, the narrow provided width
// means this alt text leaks into the summary vertically if overflow is allowed
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e7f7206d8a029d15$var$Image = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _16jlidpf _1o9zidpf _i0dl1wug",
            __cmplp.className
        ])
    });
});

});

parcelRegister("88kyp", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c549057f047aa0e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1c549057f047aa0e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    addChildItem: {
        "id": "business-list.list-view.type-cell.add-child-item",
        "defaultMessage": "Add child item"
    },
    createSubtask: {
        "id": "business-list.list-view.type-cell.create-subtask",
        "defaultMessage": "Create subtask"
    },
    createTask: {
        "id": "business-list.list-view.type-cell.create-task",
        "defaultMessage": "Create"
    },
    createChildItem: {
        "id": "business-list.list-view.type-cell.create-child-item",
        "defaultMessage": "Create child issue"
    },
    createChildItemIssueTermRefresh: {
        "id": "business-list.list-view.type-cell.create-child-item-issue-term-refresh",
        "defaultMessage": "Create child work item"
    },
    createChildItemIssueTerminologyRefreshM4: {
        "id": "business-list.list-view.type-cell.create-child-item-issue-terminology-refresh-m4",
        "defaultMessage": "Create {issueLevel, select, subtask {subtask} other {child work item}}"
    }
});

});


parcelRegister("7NVIZ", function(module, exports) {

$parcel$export(module.exports, "UrlCell", () => $38f12ffb698c385f$export$110272e30ac53e5);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $2NMNM = parcelRequire("2NMNM");

var $kY99m = parcelRequire("kY99m");

var $b5lmY = parcelRequire("b5lmY");

var $e0a4D = parcelRequire("e0a4D");

var $6s1PB = parcelRequire("6s1PB");

var $7XYc4 = parcelRequire("7XYc4");

var $lQE94 = parcelRequire("lQE94");

var $cdzQd = parcelRequire("cdzQd");

var $inpY4 = parcelRequire("inpY4");
const $38f12ffb698c385f$export$110272e30ac53e5 = /*#__PURE__*/ (0, $5uXOq.memo)(({ issueKey: issueKey, fieldKey: fieldKey, isEditable: isEditable, fieldValue: fieldValue, fieldType: fieldType, fieldName: fieldName = '', issueType: issueType = '', issueTypeId: issueTypeId = '', editMode: editMode = false, setEditMode: setEditMode = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), cellRef: cellRef, inputValue: textValue = fieldValue ?? '', onInputChange: setTextValue = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) })=>{
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $lQE94.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: fieldValue
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        // reset textValue when there's an error
        if (error && value !== textValue) setTextValue(value ?? '');
    }, [
        error,
        setTextValue,
        textValue,
        value
    ]);
    const saveAndClose = (0, $5uXOq.useCallback)(()=>{
        if (editMode) {
            setEditMode(false);
            if (textValue !== value) saveValue(textValue, null, createAnalyticsEvent({}));
        }
    }, [
        createAnalyticsEvent,
        editMode,
        saveValue,
        setEditMode,
        textValue,
        value
    ]);
    const handleChange = (0, $5uXOq.useCallback)((event)=>{
        setTextValue(event.target.value);
        resetError();
    }, [
        resetError,
        setTextValue
    ]);
    const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
        if (editMode && event.code === 'Escape') setTextValue(value ?? '');
        return false;
    }, [
        editMode,
        setTextValue,
        value
    ]);
    const cellOverrides = (0, $5uXOq.useMemo)(()=>()=>({
                onKeyDown: handleKeyDown
            }), [
        handleKeyDown
    ]);
    (0, $5uXOq.useImperativeHandle)(cellRef, cellOverrides, [
        cellOverrides
    ]);
    const handleSubmit = (0, $5uXOq.useCallback)(()=>{
        saveAndClose();
    }, [
        saveAndClose
    ]);
    const cellContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, editMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("form", {
        onSubmit: handleSubmit
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
        autoFocus: true,
        onBlur: saveAndClose,
        value: textValue,
        onChange: handleChange
    })) : value != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cdzQd.SmartLink), {
        value: value
    }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0a4D.FixItErrorFlag), {
        error: error,
        title: (0, $inpY4.default).errorTitle,
        description: (0, $inpY4.default).errorMessage,
        issueType: issueType,
        issueTypeId: issueTypeId,
        fieldId: fieldKey,
        fieldName: fieldName
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b5lmY.CellWrapper), {
        isEditable: isEditable,
        testId: "business-list.ui.list-view.url-cell.url-cell-wrapper",
        hasPadding: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($38f12ffb698c385f$var$Wrapper, null, cellContent));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $38f12ffb698c385f$var$NonSmartLinkWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _80om1kdv _o5721q9c _35md1txw _1fqm1h6o _1uv11osq _1gvb1osq _1yds1osq _1hw71txw _156d1y6m _6wji1h6o _bod01osq _dkzuu2gc _17f7u2gc _at0eu2gc _1nx0u2gc _18ywh2mm _1j631txw _1tuuidpf _1lxnidpf _2vryidpf _1umfidpf",
            __cmplp.className
        ])
    });
});
const $38f12ffb698c385f$var$SmartLinkWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _80om1kdv _o5721q9c _35md1txw _1fqm1h6o _1uv11osq _1gvb1osq _1yds1osq _h5vp1txw _16gx1y6m _1qxz1h6o _i78x1osq _3sjwu2gc _1ci4u2gc _12llu2gc _xn80u2gc _i9kvh2mm _18vc1txw _18z6idpf _svocidpf _r8aoidpf _1kmuidpf",
            __cmplp.className
        ])
    });
});
const $38f12ffb698c385f$var$Wrapper = (0, $7XYc4.componentWithCondition)(()=>(0, $6s1PB.expValEquals)('jsw_perf_format-links-in-custom-fields', 'list-view', true), $38f12ffb698c385f$var$SmartLinkWrapper, $38f12ffb698c385f$var$NonSmartLinkWrapper);

});
parcelRegister("cdzQd", function(module, exports) {

$parcel$export(module.exports, "SmartLink", () => $66799bc77fd126d1$export$8416d4d37a0abf2d);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $9Xmvg = parcelRequire("9Xmvg");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $6s1PB = parcelRequire("6s1PB");

var $1RMb0 = parcelRequire("1RMb0");
const $66799bc77fd126d1$export$8416d4d37a0abf2d = ({ value: value })=>{
    const DefaultLink = (0, $5uXOq.useCallback)(()=>// eslint-disable-next-line @atlaskit/design-system/no-html-anchor
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
            href: value,
            target: "_blank"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($66799bc77fd126d1$var$LinkText, null, value), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($66799bc77fd126d1$var$LinkFollower, {
            "data-component-selector": "business-list.ui.list-view.url-cell.link-follower"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9Xmvg))), {
            spacing: "spacious",
            label: value
        }))), [
        value
    ]);
    if (value && (0, $6s1PB.expValEquals)('jsw_perf_format-links-in-custom-fields', 'list-view', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $66799bc77fd126d1$var$smartLinkWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1RMb0.LazySingleLineSmartLink), {
        anchorTarget: "_blank",
        url: value,
        fieldType: "url"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DefaultLink, null);
};
const $66799bc77fd126d1$var$smartLinkWrapperStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.100',
    marginRight: 'space.100'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $66799bc77fd126d1$var$LinkFollower = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1ejb _bfhk1w7a _1e0cglyw _4cvr1h6o _1o9zidpf",
            __cmplp.className
        ])
    });
});
const $66799bc77fd126d1$var$LinkText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _o5721q9c _p12f1osq _1bto1l2s _1o9zkb7n",
            __cmplp.className
        ])
    });
});

});

parcelRegister("inpY4", function(module, exports) {

$parcel$export(module.exports, "default", () => $6208e8c575652861$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6208e8c575652861$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorTitle: {
        "id": "business-list.list-view.url-cell.error-title",
        "defaultMessage": "We couldn't save the text value."
    },
    errorMessage: {
        "id": "business-list.list-view.url-cell.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    }
});

});


parcelRegister("3T0IO", function(module, exports) {

$parcel$export(module.exports, "default", () => $b41ddb03500305ca$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $8Rkzz = parcelRequire("8Rkzz");

var $laWvb = parcelRequire("laWvb");

var $7Jxgt = parcelRequire("7Jxgt");

var $ujWmd = parcelRequire("ujWmd");

var $99M5v = parcelRequire("99M5v");

var $1I7E8 = parcelRequire("1I7E8");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $eZJjh = parcelRequire("eZJjh");

var $kY99m = parcelRequire("kY99m");

var $3bDjY = parcelRequire("3bDjY");

var $4R6GH = parcelRequire("4R6GH");

var $bmZvc = parcelRequire("bmZvc");

var $hE5wF = parcelRequire("hE5wF");

var $b5lmY = parcelRequire("b5lmY");

var $e0a4D = parcelRequire("e0a4D");

var $jRzRt = parcelRequire("jRzRt");

var $7wK4b = parcelRequire("7wK4b");

var $gwIPs = parcelRequire("gwIPs");

var $koVbs = parcelRequire("koVbs");

var $7lGt2 = parcelRequire("7lGt2");

var $1kqLh = parcelRequire("1kqLh");

var $kt8K4 = parcelRequire("kt8K4");

var $lQE94 = parcelRequire("lQE94");

var $5fc53 = parcelRequire("5fc53");

var $cYlk7 = parcelRequire("cYlk7");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $90yGq = parcelRequire("90yGq");

var $6s1PB = parcelRequire("6s1PB");

var $itmJb = parcelRequire("itmJb");

var $h36wX = parcelRequire("h36wX");

var $jq9TF = parcelRequire("jq9TF");

var $lI995 = parcelRequire("lI995");

var $epX45 = parcelRequire("epX45");

var $khm7P = parcelRequire("khm7P");
const $b41ddb03500305ca$var$SEARCH_DEBOUNCE_TIMEOUT = 300;
const $b41ddb03500305ca$var$EMPTY_USER_ID = '__EMPTY_USER_ID__';
const $b41ddb03500305ca$var$INVITE_PEOPLE_ID = '__INVITE_PEOPLE_ID__';
const $b41ddb03500305ca$var$MAX_NUMBER_OF_OPTIONS = 7;
const $b41ddb03500305ca$var$LISTBOX_OPTION_PREFIX = `user-option-${(0, $7Jxgt.v4)()}`;
const $b41ddb03500305ca$var$LISTBOX_LIST_ID = `user-listbox-${(0, $7Jxgt.v4)()}`;
const $b41ddb03500305ca$var$getOptionId = (index)=>`${$b41ddb03500305ca$var$LISTBOX_OPTION_PREFIX}-${index}`;
const $b41ddb03500305ca$var$createTestId = (testId, suffix = '')=>testId != null ? `${testId}${suffix}` : undefined;
const $b41ddb03500305ca$var$getAvatarUrl = (user)=>user.avatarUrls && user.avatarUrls[0, $hE5wF.DEFAULT_AVATAR_RES] ? user.avatarUrls[0, $hE5wF.DEFAULT_AVATAR_RES] : '';
const $b41ddb03500305ca$var$UserCell = /*#__PURE__*/ (0, $5uXOq.memo)(({ initialValue: initialValue, fieldKey: fieldKey, fieldType: fieldType, issueKey: issueKey, isEditable: isEditable = true, width: width, emptyUserNameText: emptyUserNameText, loggedInUserActionNameText: loggedInUserActionNameText, testId: testId, wrapperRef: wrapperRef, editMode: editMode = false, setEditMode: setEditMode = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isHovering: isHovering = false, cellRef: cellRef, fieldName: fieldName = '', issueType: issueType = '', issueTypeId: issueTypeId = '', inputValue: inputValue, onInputChange: setTextValue = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { openAddPeopleModal: openAddPeopleModal } = (0, $7wK4b.useAddPeople)();
    const userQuery = (0, $5uXOq.useRef)({
        previousQuery: undefined
    }).current;
    const [{ data: users, loading: loadingUsers, error: error }, fetchUsers] = (0, $kt8K4.default)(`/rest/api/3/user/assignable/search?issueKey=${issueKey}&maxResults=${$b41ddb03500305ca$var$MAX_NUMBER_OF_OPTIONS}&query=`);
    const emptyUserName = formatMessage(emptyUserNameText);
    const listboxLabel = formatMessage((0, $khm7P.default).assigneeList);
    const emptyUser = (0, $5uXOq.useMemo)(()=>({
            accountId: $b41ddb03500305ca$var$EMPTY_USER_ID,
            displayName: formatMessage((0, $7lGt2.default).unassignedOption),
            avatarUrls: {}
        }), [
        formatMessage
    ]);
    const invitePeople = (0, $5uXOq.useMemo)(()=>({
            accountId: $b41ddb03500305ca$var$INVITE_PEOPLE_ID,
            displayName: formatMessage((0, $7lGt2.default).invitePeopleOptionAdmin),
            avatarUrls: {}
        }), [
        formatMessage
    ]);
    const initialValueUser = (0, $5uXOq.useMemo)(()=>{
        if (initialValue) return {
            accountId: initialValue.accountId,
            displayName: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            initialValue?.name || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            initialValue.displayName,
            avatarUrls: {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [(0, $hE5wF.DEFAULT_AVATAR_RES)]: initialValue?.picture
            }
        };
        return null;
    }, [
        initialValue
    ]);
    const [{ value: assigneeValue, error: updateError }, { saveValue: saveValue }] = (0, $lQE94.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: initialValueUser,
        ...fieldKey === (0, $5fc53.ASSIGNEE_TYPE) ? {
            saveField: (0, $1kqLh.saveAssigneeField)
        } : {}
    });
    const value = assigneeValue;
    const [highlightedUserIndex, setHighlightedUserIndex] = (0, $5uXOq.useState)(0);
    const [activeDescendentId, setActiveDescendentId] = (0, $5uXOq.useState)('');
    const currentUserAccountId = (0, $90yGq.useAccountId)();
    const [isStartSearching, setIsStartSearching] = (0, $5uXOq.useState)(false);
    const [userValue, setUserValue] = (0, $5uXOq.useState)(null); // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const currentUser = (0, $5uXOq.useRef)((0, $cYlk7.useCurrentUser)().data.user);
    const [userDisplayName, setUserDisplayName] = (0, $5uXOq.useState)(userValue?.displayName ?? emptyUserName);
    const textValue = inputValue ?? userDisplayName;
    const [usersList, setUsersList] = (0, $5uXOq.useState)([]);
    const [fetchedUsers, setFetchedUsers] = (0, $5uXOq.useState)(false);
    const isUnassigned = !userValue?.accountId;
    const selectedAvatarUrl = userValue?.displayName === textValue ? $b41ddb03500305ca$var$getAvatarUrl(userValue) : '';
    const isAdmin = (0, $itmJb.useIsAdmin)(); // eslint-disable-next-line jira/deprecations/ban-identifiers, jira/ff/unsafe-no-exposure
    const [config] = (0, $6s1PB.UNSAFE_noExposureExp)('jira_improve_invite_via_assignee');
    const isImproveInviteViaAssigneeTargetted = (0, $jq9TF.useIsEligibleForInviteOnOpen)();
    const isImproveInviteViaAssigneeEnabled = isImproveInviteViaAssigneeTargetted && config.get('isEnabled', false);
    const userOptions = (0, $5uXOq.useMemo)(()=>{
        const isAssigneeFieldType = fieldKey === (0, $5fc53.ASSIGNEE_TYPE) && isStartSearching;
        if (isAssigneeFieldType) {
            // if search has started and, we have less than 3 users, we need to show invite people option
            const invitePeopleOption = usersList.length <= 2 || isImproveInviteViaAssigneeEnabled ? [
                invitePeople
            ] : [];
            const emptyOption = textValue === '' ? [
                emptyUser
            ] : [];
            return [
                ...emptyOption,
                ...usersList.slice(0, Math.min($b41ddb03500305ca$var$MAX_NUMBER_OF_OPTIONS, usersList.length + 1)),
                ...invitePeopleOption
            ];
        } // If we are here, it means there is no query for this field, so we show the default values
        if (usersList.length === 0) return [
            emptyUser,
            ...isImproveInviteViaAssigneeEnabled ? [
                invitePeople
            ] : []
        ];
         // it's assigned to the current user
        return [
            ...isUnassigned || value?.accountId !== currentUserAccountId ? [
                currentUser.current
            ] : [],
            ...isUnassigned ? [] : [
                emptyUser
            ],
            ...usersList.filter((u)=>u.accountId !== currentUser.current.accountId).slice(0, Math.min($b41ddb03500305ca$var$MAX_NUMBER_OF_OPTIONS, usersList.length + 1)),
            ...isImproveInviteViaAssigneeEnabled ? [
                invitePeople
            ] : []
        ];
    }, [
        fieldKey,
        isStartSearching,
        usersList,
        isUnassigned,
        value?.accountId,
        currentUserAccountId,
        emptyUser,
        isImproveInviteViaAssigneeEnabled,
        invitePeople,
        textValue
    ]);
    (0, $5uXOq.useEffect)(()=>{
        setTextValue(userDisplayName);
    }, [
        setTextValue,
        userDisplayName
    ]);
    (0, $5uXOq.useEffect)(()=>{
        setUserValue(value);
        setUserDisplayName(value?.displayName ?? emptyUserName);
    }, [
        value,
        emptyUserName
    ]);
    (0, $5uXOq.useEffect)(()=>{
        setUsersList(users);
    }, [
        users
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (editMode && isEditable && !fetchedUsers) {
            setFetchedUsers(true);
            fetchUsers();
        }
    }, [
        usersList,
        editMode,
        isEditable,
        fetchUsers,
        fetchedUsers
    ]);
    const handleUserOptionClick = (0, $5uXOq.useCallback)((user)=>(event)=>{
            event.stopPropagation();
            setEditMode(false);
            setIsStartSearching(false);
            const isInvitePeopleID = user.accountId === $b41ddb03500305ca$var$INVITE_PEOPLE_ID;
            if (isInvitePeopleID) openAddPeopleModal(undefined, 'listInviteFromAssigneeBtn');
            setUserDisplayName(isInvitePeopleID ? '' : user.displayName);
            setTextValue(isInvitePeopleID ? '' : user.displayName);
            saveValue(user.accountId === $b41ddb03500305ca$var$EMPTY_USER_ID || isInvitePeopleID ? null : user, null, createAnalyticsEvent({})); // settimeout used here as focus is lost due to Textfield blur event
            setTimeout(()=>{
                wrapperRef?.current?.focus();
            });
        }, [
        setEditMode,
        setTextValue,
        saveValue,
        createAnalyticsEvent,
        openAddPeopleModal,
        wrapperRef
    ]);
    const [handleSearch] = (0, $laWvb.default)((query)=>{
        query !== userQuery.previousQuery && fetchUsers(query);
        userQuery.previousQuery = query;
        setHighlightedUserIndex(0);
    }, $b41ddb03500305ca$var$SEARCH_DEBOUNCE_TIMEOUT);
    const handleTextChange = (0, $5uXOq.useCallback)((event)=>{
        const newValue = event.target.value;
        setTextValue(newValue);
        setIsStartSearching(true);
        handleSearch(newValue);
    }, [
        handleSearch,
        setTextValue
    ]);
    const handleKeyDown = (0, $5uXOq.useCallback)((e)=>{
        if (!(e.target instanceof HTMLElement) || e.target.nodeName !== 'INPUT') return;
        switch(e.code){
            case 'ArrowUp':
                {
                    const activeIndex = highlightedUserIndex === 0 ? userOptions.length - 1 : highlightedUserIndex - 1;
                    setHighlightedUserIndex(activeIndex);
                    return true;
                }
            case 'ArrowDown':
                {
                    const activeIndex = highlightedUserIndex === userOptions.length - 1 ? 0 : highlightedUserIndex + 1;
                    setHighlightedUserIndex(activeIndex);
                    return true;
                }
            case 'Enter':
                userOptions[highlightedUserIndex] && handleUserOptionClick(userOptions[highlightedUserIndex])(e);
                return false;
            default:
                return false;
        }
    }, [
        userOptions,
        handleUserOptionClick,
        highlightedUserIndex
    ]);
    const handlePopupClose = (0, $5uXOq.useCallback)(()=>{
        setEditMode(false);
        setIsStartSearching(false);
        setTextValue(userDisplayName);
        setHighlightedUserIndex(0);
    }, [
        setEditMode,
        setTextValue,
        userDisplayName
    ]);
    const handleTextRef = (0, $5uXOq.useCallback)((textFieldRef)=>{
        // Workaround to force close any other open overlays
        textFieldRef?.click();
        textFieldRef?.focus();
    }, []); /**
           * Static cell renderer (without hovering): minimum HTML to improve page load.
           * We use Atlaskit avatar for hover/active state as it renders SVG for Unassigned state
           */ 
    const staticContent = (0, $5uXOq.useMemo)(()=>isUnassigned ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bmZvc.AvatarLite), {
            avatarUrl: selectedAvatarUrl,
            testId: $b41ddb03500305ca$var$createTestId(testId, '--avatar')
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lI995.DisplayName), {
            "data-testid": $b41ddb03500305ca$var$createTestId(testId, '--name')
        }, userDisplayName)), [
        isUnassigned,
        selectedAvatarUrl,
        testId,
        userDisplayName
    ]);
    const userDisplayLabel = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: userDisplayName
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lI995.DisplayName), {
            "data-testid": $b41ddb03500305ca$var$createTestId(testId, '--name')
        }, userDisplayName)), [
        testId,
        userDisplayName
    ]);
    const popupTrigger = (0, $5uXOq.useCallback)(({ ref: ref, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lI995.AvatarItem), {
            isUnassigned: isUnassigned && !editMode,
            ref: ref,
            ...!(0, $4R6GH.fg)('fix_accessibility_violation_user_cell_in_jira_list') && triggerProps,
            "data-testid": "business-list.ui.list-view.user-cell.popup-avatar-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
            appearance: "circle",
            src: selectedAvatarUrl,
            size: "small"
        }), editMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $b41ddb03500305ca$var$userSearchWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
            ...(0, $4R6GH.fg)('fix_accessibility_violation_user_cell_in_jira_list') && triggerProps,
            appearance: "none",
            value: textValue === emptyUserName ? '' : textValue,
            onChange: handleTextChange,
            placeholder: emptyUserName,
            ref: handleTextRef,
            role: "combobox",
            "aria-expanded": true,
            "aria-autocomplete": "list",
            "aria-controls": $b41ddb03500305ca$var$LISTBOX_LIST_ID,
            "aria-activedescendant": activeDescendentId,
            "data-testid": $b41ddb03500305ca$var$createTestId(testId, '--user-search-input')
        })) : userDisplayLabel()), [
        isUnassigned,
        editMode,
        selectedAvatarUrl,
        textValue,
        emptyUserName,
        handleTextChange,
        handleTextRef,
        activeDescendentId,
        testId,
        userDisplayLabel
    ]);
    const popupContent = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b41ddb03500305ca$var$UsersContainer, {
            width: width,
            role: "listbox",
            id: $b41ddb03500305ca$var$LISTBOX_LIST_ID,
            "aria-label": listboxLabel
        }, userOptions.map((user, index)=>{
            const id = $b41ddb03500305ca$var$getOptionId(index);
            const isInvitePeople = user.accountId === $b41ddb03500305ca$var$INVITE_PEOPLE_ID;
            const shouldHighlight = index === highlightedUserIndex;
            if (shouldHighlight && activeDescendentId !== id) setActiveDescendentId(id);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b41ddb03500305ca$var$UserOptionWrapper, {
                id: id,
                key: user.accountId,
                onClick: handleUserOptionClick(user),
                highlighted: shouldHighlight,
                "data-testid": $b41ddb03500305ca$var$createTestId(testId, `--option-${index}`),
                role: "option",
                "aria-selected": shouldHighlight
            }, isInvitePeople ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $b41ddb03500305ca$var$iconWrapperStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($99M5v))), {
                label: "Add",
                LEGACY_size: "medium",
                spacing: "spacious"
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
                appearance: "circle",
                src: $b41ddb03500305ca$var$getAvatarUrl(user),
                size: "small"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lI995.DisplayName), null, user.displayName ?? emptyUserName, user.accountId === currentUserAccountId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b41ddb03500305ca$var$AdditionalInfo, null, ' ' /* the space here is important for accessibility, it separates the words */ , "(", formatMessage(loggedInUserActionNameText), ")")));
        }), loadingUsers && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b41ddb03500305ca$var$SpinnerWrapper, {
            "data-testid": "business-list.ui.list-view.user-cell.spinner-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), null)), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $epX45.default), {
            onFetchUsers: fetchUsers
        })), [
        activeDescendentId,
        currentUserAccountId,
        emptyUserName,
        error,
        fetchUsers,
        formatMessage,
        handleUserOptionClick,
        highlightedUserIndex,
        listboxLabel,
        loadingUsers,
        loggedInUserActionNameText,
        testId,
        userOptions,
        width
    ]);
    const popupOffset = (0, $5uXOq.useMemo)(()=>[
            -(0, $gwIPs.gridSize),
            (0, $gwIPs.gridSize)
        ], []);
    const popupComponent = (0, $5uXOq.useMemo)(()=>(0, $jRzRt.getPopupComponentWithHeight)({
            numOptions: Math.min(userOptions.length, $b41ddb03500305ca$var$MAX_NUMBER_OF_OPTIONS),
            spacing: 'default',
            hasInput: false
        }), [
        userOptions
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (editMode && (0, $4R6GH.fg)('jsw_list_assignee_focused_analytics')) {
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'userPicker focused', {
                context: 'assignee'
            });
            if (isImproveInviteViaAssigneeTargetted && (0, $6s1PB.expVal)('jira_improve_invite_via_assignee', 'isEnabled', false)) (0, $h36wX.fireInviteItemRendererEvent)({
                createAnalyticsEvent: createAnalyticsEvent,
                suggestionsCount: usersList.length,
                isAdmin: isAdmin
            });
        }
    }, [
        editMode,
        createAnalyticsEvent,
        isImproveInviteViaAssigneeTargetted,
        isAdmin,
        usersList
    ]); // hover/active state
    const content = (0, $5uXOq.useMemo)(()=>isHovering || editMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
            isOpen: editMode,
            placement: "bottom-start",
            onClose: handlePopupClose,
            autoFocus: false,
            trigger: popupTrigger,
            content: popupContent,
            offset: popupOffset,
            popupComponent: popupComponent
        }) : staticContent, [
        isHovering,
        editMode,
        handlePopupClose,
        popupTrigger,
        popupContent,
        popupOffset,
        popupComponent,
        staticContent
    ]);
    const cellOverrides = (0, $5uXOq.useMemo)(()=>()=>({
                onKeyDown: handleKeyDown
            }), [
        handleKeyDown
    ]);
    (0, $5uXOq.useImperativeHandle)(cellRef, cellOverrides, [
        cellOverrides
    ]);
    if (!isEditable && value?.accountId == null) return null;
    const userCell = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isEditable ? content : staticContent, updateError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0a4D.FixItErrorFlag), {
        error: updateError,
        title: (0, $khm7P.default).errorTitle,
        description: (0, $khm7P.default).errorMessage,
        issueType: issueType,
        issueTypeId: issueTypeId,
        fieldId: fieldKey,
        fieldName: fieldName
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b5lmY.CellWrapper), {
        isEditable: isEditable,
        testId: $b41ddb03500305ca$var$createTestId(testId, '--cell-wrapper')
    }, userCell);
});
var $b41ddb03500305ca$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $b41ddb03500305ca$var$UserCell;
const $b41ddb03500305ca$var$AdditionalInfo = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz131l",
            __cmplp.className
        ])
    });
});
const $b41ddb03500305ca$var$iconWrapperStyles = (0, $8CUq3.xcss)({
    margin: 'space.025'
});
const $b41ddb03500305ca$var$userSearchWrapperStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.negative.025'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b41ddb03500305ca$var$UsersContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1gljcou": (0, $lD23V.default)(__cmplp.width, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1ul9p3fh _1bsb1rkg _bfhkvuon _16qszucj",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b41ddb03500305ca$var$UserOptionWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { highlighted: highlighted, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1ylp _1e0c1txw _ca0qidpf _u5f3u2gc _n3tdidpf _19bvu2gc _4cvr1h6o _80omtlke _ce7e1b66",
            __cmplp.highlighted ? "_bfhk1v33" : "_bfhk1kw7",
            __cmplp.highlighted ? "_irr311bn" : "_irr311bn",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b41ddb03500305ca$var$SpinnerWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1ylp _1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7lGt2", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2aaed3328149e1d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e2aaed3328149e1d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    unassignedOption: {
        "id": "issue-field-assignee.unassigned-option",
        "defaultMessage": "Unassigned"
    },
    automaticOption: {
        "id": "issue-field-assignee.automatic-option",
        "defaultMessage": "Automatic"
    },
    assignToMe: {
        "id": "issue-field-assignee.assign-to-me",
        "defaultMessage": "Assign to me"
    },
    searchForAssignee: {
        "id": "issue-field-assignee.search-for-assignee",
        "defaultMessage": "Search for assignee"
    },
    invitePeopleOption: {
        "id": "issue-field-assignee.invite-people-option",
        "defaultMessage": "Add teammate to Jira"
    },
    invitePeopleOptionAdmin: {
        "id": "issue-field-assignee.invite-people-option-admin",
        "defaultMessage": "Invite teammate to Jira"
    }
});

});

parcelRegister("kt8K4", function(module, exports) {

$parcel$export(module.exports, "default", () => $564a5b059c2a0fff$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $2YZCu = parcelRequire("2YZCu");

var $7f4tk = parcelRequire("7f4tk");
const $564a5b059c2a0fff$var$useUsersQuery = (autoCompleteUrl, customFetchUsers)=>{
    const [users, setUsers] = (0, $5uXOq.useState)([]);
    const [error, setError] = (0, $5uXOq.useState)(undefined);
    const [loading, setLoading] = (0, $5uXOq.useState)(false);
    const currentQuery = (0, $5uXOq.useRef)('');
    const fetchUsers = (0, $5uXOq.useCallback)(// @ts-expect-error - TS2345 - Argument of type '(query?: string | undefined) => Promise<void> | Promise<never[]>' is not assignable to parameter of type 'FetchUsers'.
    (query = '')=>{
        if ([
            '',
            null,
            undefined
        ].includes(autoCompleteUrl)) return Promise.resolve([]);
        setLoading(true);
        currentQuery.current = query;
        if (error) setError(undefined);
        const usersFetchUrl = `${autoCompleteUrl || ''}${query}`;
        const fetchUsersMethod = customFetchUsers && (0, $4R6GH.fg)('issue_cards_in_program_board') ? customFetchUsers(query) : (0, $7f4tk.default)(usersFetchUrl);
        return fetchUsersMethod.then((response)=>{
            if (query === currentQuery.current) setUsers(response);
        }).catch((err)=>{
            if (query === currentQuery.current) setError(err);
            const errorMessage = customFetchUsers && (0, $4R6GH.fg)('issue_cards_in_program_board') ? 'Failed to fetch using custom user fetcher' : 'Failed to fetch users';
            (0, $2YZCu.default).safeErrorWithoutCustomerData('issue.fields.assigne', errorMessage, err);
        }).finally(()=>setLoading(false));
    }, [
        autoCompleteUrl,
        error,
        customFetchUsers
    ]);
    return [
        {
            data: users,
            error: error,
            loading: loading
        },
        fetchUsers
    ];
};
var $564a5b059c2a0fff$export$2e2bcd8739ae039 = $564a5b059c2a0fff$var$useUsersQuery;

});

parcelRegister("h36wX", function(module, exports) {

$parcel$export(module.exports, "fireInviteItemRendererEvent", () => $92b31ca8d85d4433$export$85383b532f48700a);
$parcel$export(module.exports, "useAssigneeOptions", () => $92b31ca8d85d4433$export$1eb7ccf9fc55d2e8);

var $3OKtJ = parcelRequire("3OKtJ");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $itmJb = parcelRequire("itmJb");

var $leRCk = parcelRequire("leRCk");


var $fhSLy = parcelRequire("fhSLy");

var $7lGt2 = parcelRequire("7lGt2");
const $92b31ca8d85d4433$export$85383b532f48700a = ({ createAnalyticsEvent: createAnalyticsEvent, suggestionsCount: suggestionsCount, isAdmin: isAdmin, isInviteAndAssignFromBoard: isInviteAndAssignFromBoard = false })=>{
    if (createAnalyticsEvent === undefined || createAnalyticsEvent === null) return;
    const action = 'rendered';
    const actionSubject = 'inviteItem';
    const event = createAnalyticsEvent({
        action: action,
        actionSubject: actionSubject
    });
    const attrs = {
        fieldId: 'assignee',
        userRole: isAdmin ? 'admin' : 'basic',
        suggestionsCount: suggestionsCount,
        source: 'assigneeField',
        ...isInviteAndAssignFromBoard && {
            isInviteAndAssignFromBoard: true
        }
    };
    (0, $8zOmE.fireUIAnalytics)(event, `${actionSubject} ${action}`, attrs);
};
const $92b31ca8d85d4433$export$1eb7ccf9fc55d2e8 = ({ value: value, users: users, intl: intl, shouldPreloadAssignToMe: shouldPreloadAssignToMe, search: search, enablePeopleInvite: enablePeopleInvite, enableAutomaticOption: enableAutomaticOption, suggestedEmailDomain: suggestedEmailDomain, isEligibleForInviteAndAssign: isEligibleForInviteAndAssign, shouldHideUnassigned: shouldHideUnassigned, shouldShowInviteOnOpen: shouldShowInviteOnOpen })=>{
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const unassigned = (0, $fhSLy.getUnassignedUser)(intl);
    const automaticOption = (0, $fhSLy.getAutomaticUserOption)(intl);
    const valueOption = (0, $fhSLy.getUserOptionFromUser)(value || unassigned);
    const [{ data: loggedInUser }] = (0, $leRCk.useUserSubscriber)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const loggedInUserOption = loggedInUser ? {
        ...(0, $fhSLy.getUserOptionFromUser)(loggedInUser),
        publicName: intl.formatMessage((0, $7lGt2.default).assignToMe)
    } : null;
    const isInvalidSearch = search === undefined || search === '';
    // show unassigned option if value is defined and no search or unassigned display name match the search
    const showUnassigned = !shouldHideUnassigned && (isInvalidSearch ? Boolean(value?.accountId) : unassigned.displayName.toLowerCase().startsWith((search || '').toLowerCase()));
    let showAutomaticOption = false;
    if (enableAutomaticOption === true) showAutomaticOption = isInvalidSearch ? Boolean(value?.accountId !== (0, $c1e3a0a8493b8e86$export$f5d5f6bb902f1027)) : automaticOption.displayName.toLowerCase().startsWith((search || '').toLowerCase());
    const isLoggedInUserCurrentValue = loggedInUserOption !== null && valueOption.id === loggedInUserOption.id;
    const isLoggedInUserMatchSearch = users.some((user)=>loggedInUserOption !== null && user.accountId === loggedInUserOption.id);
    const showAssignToMeOnInit = !isLoggedInUserCurrentValue && (shouldPreloadAssignToMe || isLoggedInUserMatchSearch);
    const showAssignToMe = isInvalidSearch ? showAssignToMeOnInit : isLoggedInUserMatchSearch;
    const userOptions = users.filter((user)=>// remove selected user (value) from users list when search is not defined
        (!isInvalidSearch || user.accountId !== valueOption.id) && // remove logged in user (is already added in 2nd position above)
        !(loggedInUserOption !== null && user.accountId === loggedInUserOption.id)).map((0, $fhSLy.getUserOptionFromUser));
    const invitePeopleOptions = [];
    if (enablePeopleInvite === true && shouldShowInviteOnOpen) {
        if (isEligibleForInviteAndAssign && search) invitePeopleOptions.push((0, $3OKtJ.getInviteAndAssignPeopleOption)(intl.formatMessage, search, suggestedEmailDomain));
        else invitePeopleOptions.push((0, $fhSLy.getUserOptionFromUser)((0, $fhSLy.getInvitePeopleOption)(intl, isAdmin)));
    } else if (enablePeopleInvite === true && !isInvalidSearch && userOptions.length < 3) {
        if (isEligibleForInviteAndAssign) {
            invitePeopleOptions.push((0, $3OKtJ.getInviteAndAssignPeopleOption)(intl.formatMessage, search, suggestedEmailDomain));
            $92b31ca8d85d4433$export$85383b532f48700a({
                createAnalyticsEvent: createAnalyticsEvent,
                suggestionsCount: userOptions.length,
                isAdmin: isAdmin,
                isInviteAndAssignFromBoard: true
            });
        } else {
            $92b31ca8d85d4433$export$85383b532f48700a({
                createAnalyticsEvent: createAnalyticsEvent,
                suggestionsCount: userOptions.length,
                isAdmin: isAdmin
            });
            invitePeopleOptions.push((0, $fhSLy.getUserOptionFromUser)((0, $fhSLy.getInvitePeopleOption)(intl, isAdmin)));
        }
    }
    const options = [
        ...showUnassigned ? [
            (0, $fhSLy.getUserOptionFromUser)(unassigned)
        ] : [],
        ...showAutomaticOption ? [
            (0, $fhSLy.getUserOptionFromUser)(automaticOption)
        ] : [],
        ...showAssignToMe && loggedInUserOption !== null ? [
            loggedInUserOption
        ] : [],
        ...userOptions,
        ...invitePeopleOptions
    ];
    return [
        valueOption,
        options,
        {
            userOptionsCount: userOptions.length
        }
    ];
};

});
parcelRegister("3OKtJ", function(module, exports) {

$parcel$export(module.exports, "isValidEmailAddress", () => $d369cb9a3149539e$export$866f45a7554d0870);
$parcel$export(module.exports, "getInviteAndAssignPeopleOption", () => $d369cb9a3149539e$export$34e0d98131b0b98a);

var $M0UM1 = parcelRequire("M0UM1");

var $ePvDo = parcelRequire("ePvDo");


var $eXneb = parcelRequire("eXneb");
const $d369cb9a3149539e$var$getInviteAndAssignOption = (inputValue, suggestedEmailDomain)=>{
    const isEmail = inputValue && [
        (0, $a56e5eac5897104f$export$18d36911c7f94286),
        (0, $a56e5eac5897104f$export$da1c529049028734)
    ].includes((0, $M0UM1.isValidEmail)(inputValue));
    const value = isEmail || !suggestedEmailDomain ? inputValue : `${inputValue.replace(/\s+/g, '.').toLocaleLowerCase()}@${suggestedEmailDomain}`;
    return value;
};
const $d369cb9a3149539e$export$866f45a7554d0870 = (inputValue)=>inputValue && (0, $M0UM1.isValidEmail)(inputValue) === (0, $a56e5eac5897104f$export$18d36911c7f94286);
const $d369cb9a3149539e$export$34e0d98131b0b98a = (formatMessage, input, suggestedEmailDomain)=>{
    const possibleEmail = $d369cb9a3149539e$var$getInviteAndAssignOption(input, suggestedEmailDomain);
    return {
        id: (0, $a56e5eac5897104f$export$898547b9297d1a3a),
        name: possibleEmail,
        avatarUrl: (0, (/*@__PURE__*/$parcel$interopDefault($ePvDo))),
        byline: formatMessage((0, $eXneb.default).inviteAndAssign),
        isDisabled: (0, $M0UM1.isValidEmail)(possibleEmail) !== 'VALID'
    };
};

});
parcelRegister("ePvDo", function(module, exports) {
module.exports = new URL("email.very-specific-illu.3b6402e8.png", import.meta.url).toString();

});

const $a56e5eac5897104f$export$898547b9297d1a3a = '_INVITE_AND_ASSIGN_ID_';
const $a56e5eac5897104f$export$18d36911c7f94286 = 'VALID';
const $a56e5eac5897104f$export$da1c529049028734 = 'POTENTIAL';

parcelRegister("eXneb", function(module, exports) {

$parcel$export(module.exports, "default", () => $31de51ead46cb5cc$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $31de51ead46cb5cc$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    inviteAndAssign: {
        "id": "invite-and-assign.common.invite-and-assign",
        "defaultMessage": "Invite and assign"
    }
});

});


parcelRegister("fhSLy", function(module, exports) {

$parcel$export(module.exports, "getUnassignedUser", () => $bdabf260f25df73f$export$42c5a0b65ef9ee80);
$parcel$export(module.exports, "getAutomaticUserOption", () => $bdabf260f25df73f$export$8d7a63500893c8c);
$parcel$export(module.exports, "getInvitePeopleOption", () => $bdabf260f25df73f$export$84a82764cf0a696e);
$parcel$export(module.exports, "getUserOptionFromUser", () => $bdabf260f25df73f$export$16086438354dcc85);
$parcel$export(module.exports, "getUserFromUserOption", () => $bdabf260f25df73f$export$78a8bcc5bd21caa2);
$parcel$export(module.exports, "getUserAvatarUrl", () => $bdabf260f25df73f$export$7d801d84202c7743);
$parcel$export(module.exports, "getUserShape", () => $bdabf260f25df73f$export$322b6ab8c29a006e);

var $7lGt2 = parcelRequire("7lGt2");

var $gRwYv = parcelRequire("gRwYv");

const $bdabf260f25df73f$export$42c5a0b65ef9ee80 = ({ formatMessage: formatMessage })=>({
        accountId: (0, $c1e3a0a8493b8e86$export$bdab9bfb39981463),
        displayName: formatMessage((0, $7lGt2.default).unassignedOption),
        avatarUrls: {}
    });
const $bdabf260f25df73f$export$8d7a63500893c8c = ({ formatMessage: formatMessage })=>({
        accountId: (0, $c1e3a0a8493b8e86$export$f5d5f6bb902f1027),
        displayName: formatMessage((0, $7lGt2.default).automaticOption),
        avatarUrls: {}
    });
const $bdabf260f25df73f$export$84a82764cf0a696e = ({ formatMessage: formatMessage }, isAdmin)=>({
        accountId: (0, $c1e3a0a8493b8e86$export$d875316cb0cd94f7),
        displayName: formatMessage(isAdmin ? (0, $7lGt2.default).invitePeopleOptionAdmin : (0, $7lGt2.default).invitePeopleOption),
        avatarUrls: {
            '48x48': (0, (/*@__PURE__*/$parcel$interopDefault($gRwYv)))
        }
    });
const $bdabf260f25df73f$export$16086438354dcc85 = ({ accountId: accountId, displayName: displayName, avatarUrls: avatarUrls, emailAddress: emailAddress })=>({
        id: accountId || '',
        name: displayName,
        avatarUrl: avatarUrls['48x48'],
        // @ts-expect-error Will be part of JIV-13488; `user.emailAddress` returned by the REST API can be null depending on their privacy settings
        byline: emailAddress
    });
const $bdabf260f25df73f$export$78a8bcc5bd21caa2 = ({ id: id, name: name, avatarUrl: avatarUrl })=>({
        accountId: id,
        displayName: name,
        avatarUrls: {
            '48x48': avatarUrl
        }
    });
const $bdabf260f25df73f$export$7d801d84202c7743 = ({ avatarUrls: avatarUrls })=>avatarUrls['48x48'];
const $bdabf260f25df73f$export$322b6ab8c29a006e = (accountId, displayName, avatarUrl)=>({
        accountId: accountId,
        displayName: displayName,
        avatarUrls: {
            '48x48': avatarUrl
        }
    });

});
parcelRegister("gRwYv", function(module, exports) {
module.exports = new URL("add.b8fea212.png", import.meta.url).toString();

});



parcelRegister("jq9TF", function(module, exports) {

$parcel$export(module.exports, "useIsEligibleForInviteOnOpen", () => $10e3b4d6fb18a81c$export$68fb0ef7a3be1bd);

var $itmJb = parcelRequire("itmJb");

var $cNd4s = parcelRequire("cNd4s");

var $DgoP6 = parcelRequire("DgoP6");
const $10e3b4d6fb18a81c$export$68fb0ef7a3be1bd = ()=>{
    const { isCurrentProjectJiraSoftware: isCurrentProjectJiraSoftware } = (0, $DgoP6.useIsCurrentProjectJiraSoftware)();
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    return isCurrentProjectJiraSoftware && (isAdmin || isSiteAdmin);
};

});
parcelRegister("DgoP6", function(module, exports) {

$parcel$export(module.exports, "useIsCurrentProjectJiraSoftware", () => $9b91e5ab0a1f0062$export$7c1f0cb7cb50b335);

var $dAfqg = parcelRequire("dAfqg");

var $2vSU6 = parcelRequire("2vSU6");
const $9b91e5ab0a1f0062$export$7c1f0cb7cb50b335 = ()=>{
    const { data: projectContextData, loading: loading } = (0, $dAfqg.useProjectContext)();
    const isCurrentProjectJiraSoftware = projectContextData?.projectType === (0, $2vSU6.SOFTWARE_PROJECT);
    return {
        loading: loading,
        isCurrentProjectJiraSoftware: isCurrentProjectJiraSoftware
    };
};

});


parcelRegister("epX45", function(module, exports) {

$parcel$export(module.exports, "default", () => $f033b6ab4405a7b1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $9yOBd = parcelRequire("9yOBd");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $1pQYV = parcelRequire("1pQYV");
const $f033b6ab4405a7b1$var$ErrorUser = ({ onFetchUsers: onFetchUsers })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f033b6ab4405a7b1$var$Wrapper, {
        role: "alert"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $f033b6ab4405a7b1$var$errorMessageWrapperStyles
    }, formatMessage((0, $1pQYV.default).cannotLoadUsers)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f033b6ab4405a7b1$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yOBd.default), {
        appearance: "link",
        spacing: "none",
        onClick: (event)=>{
            event.stopPropagation();
            onFetchUsers();
        },
        theme: (currentTheme, theme)=>{
            const buttonTheme = currentTheme(theme);
            return {
                ...buttonTheme,
                buttonStyles: {
                    ...buttonTheme.buttonStyles,
                    alignItems: 'center'
                }
            };
        }
    }, formatMessage((0, $1pQYV.default).tryAgain))));
};
var $f033b6ab4405a7b1$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $f033b6ab4405a7b1$var$ErrorUser;
const $f033b6ab4405a7b1$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1ylp _1e0c1txw _4cvr1h6o _ca0qidpf _u5f3utpp _n3tdidpf _19bvutpp _1bah1h6o",
            __cmplp.className
        ])
    });
});
const $f033b6ab4405a7b1$var$ButtonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _16jlkb7n _4t3i1osq",
            __cmplp.className
        ])
    });
});
const $f033b6ab4405a7b1$var$errorMessageWrapperStyles = (0, $8CUq3.xcss)({
    marginRight: 'space.100'
});

});
parcelRegister("1pQYV", function(module, exports) {

$parcel$export(module.exports, "default", () => $4daaf0cbf201f34b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4daaf0cbf201f34b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    cannotLoadUsers: {
        "id": "business-list.list-view.user-cell.error-user.cannot-load-users",
        "defaultMessage": "Couldn\u2019t find users."
    },
    tryAgain: {
        "id": "business-list.list-view.user-cell.error-user.try-again",
        "defaultMessage": "Try again"
    }
});

});


parcelRegister("khm7P", function(module, exports) {

$parcel$export(module.exports, "default", () => $42b1bed06f795cb8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $42b1bed06f795cb8$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorTitle: {
        "id": "business-list.list-view.user-cell.error-title",
        "defaultMessage": "We couldn't save the user value."
    },
    errorMessage: {
        "id": "business-list.list-view.user-cell.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    },
    assigneeList: {
        "id": "business-list.list-view.user-cell.assignee-list",
        "defaultMessage": "Users"
    }
});

});



parcelRegister("1pfh5", function(module, exports) {

$parcel$export(module.exports, "MigrationFeedback", () => $b7e67134743bb003$export$1b0008e0ed119185);

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $kbqIt = parcelRequire("kbqIt");

var $3rLiX = parcelRequire("3rLiX");

var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $dseDh = parcelRequire("dseDh");

var $7iULw = parcelRequire("7iULw");

var $eGLgs = parcelRequire("eGLgs");

var $koeKL = parcelRequire("koeKL");

var $koVbs = parcelRequire("koVbs");

var $2tT7R = parcelRequire("2tT7R");

var $8AqDm = parcelRequire("8AqDm");


var $95vhi = parcelRequire("95vhi");
const $b7e67134743bb003$export$1b0008e0ed119185 = ()=>{
    const radioGroupId = `radio-group-${(0, $7Jxgt.v4)()}`;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { updateAdditionalFields: updateAdditionalFields } = (0, $dseDh.useFeedbackCollectorActions)();
    const onChangeMigrationOption = (0, $5uXOq.useCallback)((event)=>{
        updateAdditionalFields((0, $95vhi.buildAdditionalFields)(event.target.value));
    }, [
        updateAdditionalFields
    ]);
    const MSG_ENGAGEMENT_ID = (0, $2tT7R.useEnvironment)() === (0, $87aa479245ff7699$export$c0ff33dc19b9700c) ? (0, $87aa479245ff7699$export$f11ef8cc53a560d2) : (0, $87aa479245ff7699$export$6ec010ee2800546c);
    const cloudId = (0, $koeKL.useCloudId)();
    const coordinationClient = (0, $5uXOq.useMemo)(// eslint-disable-next-line jira/choreographer/choreographer-context-required
    ()=>new (0, $eGLgs.CoordinationClient)(cloudId, (0, $87aa479245ff7699$export$c7e6a6b283196232), false, '', 'engagement'), [
        cloudId
    ]);
    const [isEnrolled, stopEnrolment] = (0, $kbqIt.useCoordination)(coordinationClient, MSG_ENGAGEMENT_ID);
    const { openFeedbackCollector: openFeedbackCollector } = (0, $dseDh.useFeedbackCollectorActions)();
    (0, $5uXOq.useEffect)(()=>{
        if (isEnrolled) {
            stopEnrolment(false);
            openFeedbackCollector({
                showTypeField: false,
                feedbackTitle: formatMessage((0, $8AqDm.default).feedbackTitle),
                feedbackTitleDetails: formatMessage((0, $8AqDm.default).feedbackTitleDetails),
                entrypointId: (0, $7iULw.ENTRYPOINT_ID_JIRA_PLATFORM),
                feedbackGroupId: (0, $87aa479245ff7699$export$14b33d63628336c2),
                submitButtonLabel: formatMessage((0, $8AqDm.default).feedbackSubmitButton),
                // @ts-expect-error: Object literal may only specify known properties, and 'customTextAreaLabel' does not exist in type 'FeedbackCollectorProps'.ts(2345)
                customTextAreaLabel: formatMessage((0, $8AqDm.default).feedbackTextareaLabel),
                renderCustomContent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
                        space: "space.100",
                        xcss: $b7e67134743bb003$var$wrapperStyle
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                        id: radioGroupId
                    }, formatMessage((0, $8AqDm.default).feedbackOptionsLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3rLiX.default), {
                        testId: "business-list.ui.list-view.list-migration-feedback.radio-group",
                        options: [
                            {
                                value: (0, $87aa479245ff7699$export$c41856d475b59ac7),
                                label: formatMessage((0, $8AqDm.default).migrateSettings)
                            },
                            {
                                value: (0, $87aa479245ff7699$export$d6689da66d7a728e),
                                label: formatMessage((0, $8AqDm.default).noMigrateSettings)
                            }
                        ],
                        onChange: onChangeMigrationOption,
                        "aria-labelledby": radioGroupId
                    })),
                additionalFields: (0, $95vhi.buildAdditionalFields)()
            });
        }
    }, [
        formatMessage,
        isEnrolled,
        onChangeMigrationOption,
        openFeedbackCollector,
        radioGroupId,
        stopEnrolment
    ]);
    return null;
};
const $b7e67134743bb003$var$wrapperStyle = (0, $8CUq3.xcss)({
    marginTop: 'space.200'
});

});
parcelRegister("3rLiX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ca8b717dad009c8c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eGmKJ = parcelRequire("eGmKJ");

var $9KnKW = parcelRequire("9KnKW");

var $jouoW = parcelRequire("jouoW");
const $ca8b717dad009c8c$var$noOptions = [];
function $ca8b717dad009c8c$export$2e2bcd8739ae039(props) {
    const { onChange: onChange, options: options = $ca8b717dad009c8c$var$noOptions, value: propValue, defaultValue: defaultValue, id: id, isDisabled: isDisabled, isRequired: isRequired, isInvalid: isInvalid, onInvalid: onInvalid = (0, $eGmKJ.default), name: name, analyticsContext: analyticsContext, ['aria-labelledby']: ariaLabelledBy, testId: testId } = props;
    const uid = (0, $9KnKW.useId)();
    const [selectedValue, setSelectedValue] = (0, $5uXOq.useState)(propValue !== undefined ? propValue : defaultValue);
    const onRadioChange = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        setSelectedValue(e.currentTarget.value);
        if (onChange) onChange(e, analyticsEvent);
    }, [
        onChange
    ]);
    // If propValue is provided than act as a controlled component
    // If not then act as an uncontrolled component using the value from state
    const value = typeof propValue !== 'undefined' ? propValue : selectedValue;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "radiogroup",
        "aria-labelledby": ariaLabelledBy,
        "data-testid": testId,
        "aria-describedby": isInvalid ? `${id || uid}-error` : undefined,
        id: id || uid,
        children: options.map(({ ...optionProps }, index)=>{
            if (typeof isDisabled !== 'undefined') optionProps.isDisabled = isDisabled;
            const isChecked = value !== null && optionProps.value === value;
            return /*#__PURE__*/ (0, $5uXOq.createElement)((0, $jouoW.default), {
                ...optionProps,
                name: name || optionProps.name,
                key: index,
                onChange: onRadioChange,
                onInvalid: onInvalid,
                isInvalid: isChecked && isInvalid,
                isChecked: isChecked,
                testId: optionProps.testId || testId,
                isRequired: isRequired,
                analyticsContext: analyticsContext
            });
        })
    });
}

});
parcelRegister("jouoW", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d22fafff331be84$export$2e2bcd8739ae039);
/* radio.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $VSDnB = parcelRequire("VSDnB");
const $5d22fafff331be84$var$packageName = "platform-pkg";
const $5d22fafff331be84$var$packageVersion = "0.0.0-use.local";
const $5d22fafff331be84$var$noop = (0, $eGmKJ.default);
const $5d22fafff331be84$var$labelPaddingStyles = null;
const $5d22fafff331be84$var$labelStyles = null;
const $5d22fafff331be84$var$radioStyles = null;
const $5d22fafff331be84$var$newRadioStyles = null;
const $5d22fafff331be84$var$InnerRadio = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function Radio(props, ref) {
    const { ariaLabel: ariaLabel, isDisabled: isDisabled = false, isRequired: isRequired, isInvalid: isInvalid = false, isChecked: isChecked = false, label: label, name: name, onChange: onChange = $5d22fafff331be84$var$noop, value: value, testId: testId, analyticsContext: analyticsContext, // events and all other input props
    ...rest } = props;
    const onChangeAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'radio',
        packageName: $5d22fafff331be84$var$packageName,
        packageVersion: $5d22fafff331be84$var$packageVersion
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("label", {
        "data-testid": testId && `${testId}--radio-label`,
        "data-disabled": isDisabled ? 'true' : undefined,
        className: (0, $bwpsq.default)([
            "_11c82smr _1e0c1txw _vchhusvi _kqswh2mm _4cvr1y6m _syazj3m3 _mqf81tvo _g7st13gf"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                ...rest,
                tabIndex: 0,
                "aria-label": ariaLabel,
                checked: isChecked,
                disabled: isDisabled,
                name: name,
                onChange: onChangeAnalytics,
                required: isRequired,
                type: "radio",
                value: value,
                "data-testid": testId && `${testId}--radio-input`,
                // use :invalid selector
                "data-invalid": isInvalid ? 'true' : undefined,
                ref: ref,
                className: (0, $bwpsq.default)([
                    "_18s8ze3t _19it3vzd _2rko1q5u _12ji1r31 _1qu2glyw _12y31o36 _v56415j1 _1e0c1txw _1bsb1tcg _4t3i1tcg _kqswh2mm _4cvr1h6o _1bah1h6o _1o9zidpf _bfhk4t47 _13diglyw _1q6qmag2 _11511fmg _1s6w1qbb _tqbwidpf _t9ec1s1q _s7n4jp4b _wstuglyw _16r2ucr4 _14mj1q5u _qc5orqeg _z0ai1cbz _1qdg1cbz _18postnw _aetrb3bt _1peq1xmd _iosizyvw _11jyzyvw _f3ett94y _19ybk8x7 _1d7pk8x7 _j5dh13gf _scgf13gf _1gcs13gf _1x1a13gf _6hp813gf _4rya1y1w _o1bd1y1w _nxi61y1w _neoe1y1w _1el21y1w _lekrzcs9 _11v7zcs9 _1f8czcs9 _s2ftzcs9 _17a1zcs9 _x48a15t7 _1ib215t7 _1yk915t7 _gdmb15t7 _pmm415t7 _y2mvehbj _1bg4jfq9 _6tjkehbj _awqnjfq9 _1rvq10ko _1p9j1fmg _x2tzhh5a _1iwzhh5a _sj8y1wq0 _jckox2ru _1dvd1fmg _60ak1dzn",
                    (0, $VSDnB.fg)('platform-visual-refresh-icons') && "_t9ec1soj _z0ai120g _1qdg120g"
                ])
            }),
            label ? /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                className: (0, $bwpsq.default)([
                    "_85i5v77o _1q51v77o _y4ti1b66 _bozg1b66"
                ]),
                children: label
            }) : null
        ]
    });
}); /**
     * __Radio__
     *
     * A radio input allows users to select only one option from a number of choices. Radio is generally displayed in a radio group.
     *
     * - [Examples](https://atlassian.design/components/radio/examples)
     * - [Code](https://atlassian.design/components/radio/code)
     * - [Usage](https://atlassian.design/components/radio/usage)
     */ 
const $5d22fafff331be84$var$Radio = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Radio(props, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)($5d22fafff331be84$var$InnerRadio, {
        ...props,
        ref: ref
    });
}));
var $5d22fafff331be84$export$2e2bcd8739ae039 = $5d22fafff331be84$var$Radio;

});


parcelRegister("8AqDm", function(module, exports) {

$parcel$export(module.exports, "default", () => $156e780feff0c07d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $156e780feff0c07d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    feedbackTitle: {
        "id": "business-list.list-migration-feedback.feedback-title",
        "defaultMessage": "What should happen to your List view preferences?"
    },
    feedbackTitleDetails: {
        "id": "business-list.list-migration-feedback.feedback-title-details",
        "defaultMessage": "We're merging List view into All work."
    },
    feedbackTextareaLabel: {
        "id": "business-list.list-view.list-migration-feedback.feedback-textarea-label",
        "defaultMessage": "Tell us why?"
    },
    noMigrateSettings: {
        "id": "business-list.list-view.list-migration-feedback.feedback-options.no-migrate-settings",
        "defaultMessage": "I'm happy to start fresh in the new All work view"
    },
    migrateSettings: {
        "id": "business-list.list-view.list-migration-feedback.feedback-options.migrate-settings",
        "defaultMessage": "It's important to keep my current view settings"
    },
    feedbackOptionsLabel: {
        "id": "business-list.list-view.list-migration-feedback.feedback-options.feedback-options-label",
        "defaultMessage": "To help make the transition smoother, we'd like to know how important it is to keep your current view settings (like grouping, hidden columns, and hierarchy). We'll confirm your choice before any changes happen."
    },
    feedbackSubmitButton: {
        "id": "business-list.list-view.list-migration-feedback.feedback-submit-button",
        "defaultMessage": "Give feedback"
    }
});

});

const $87aa479245ff7699$export$14b33d63628336c2 = 'jira-list-view-migration-feedback';
const $87aa479245ff7699$export$d6689da66d7a728e = 'do-not-migrate-me';
const $87aa479245ff7699$export$c41856d475b59ac7 = 'yes';
const $87aa479245ff7699$export$efe42d347ea15b42 = 'no-response';
const $87aa479245ff7699$export$7d5d4c32f29189c3 = 'customfield_10047';
const $87aa479245ff7699$export$f11ef8cc53a560d2 = 'jira-list-migration-feedback';
const $87aa479245ff7699$export$6ec010ee2800546c = 'jira-list-migration-feedback-prd'; // TODO: Create EP prod msg
const $87aa479245ff7699$export$c0ff33dc19b9700c = 'staging';
const $87aa479245ff7699$export$c7e6a6b283196232 = '/gateway/api';

parcelRegister("95vhi", function(module, exports) {

$parcel$export(module.exports, "buildAdditionalFields", () => $0578655502d38fa2$export$1aeb402f5df31a89);

function $0578655502d38fa2$export$1aeb402f5df31a89(migrationOption = (0, $87aa479245ff7699$export$efe42d347ea15b42)) {
    return [
        {
            id: (0, $87aa479245ff7699$export$7d5d4c32f29189c3),
            value: `feedback-group-id: ${(0, $87aa479245ff7699$export$14b33d63628336c2)} \n selected-migrate-option: ${migrationOption}`
        }
    ];
}

});




parcelRegister("f00ho", function(module, exports) {

$parcel$export(module.exports, "SeenIt", () => $0835234f1d6fd648$export$dbdcc139f79b9b57);

var $5uXOq = parcelRequire("5uXOq");

var $i205g = parcelRequire("i205g");
const $0835234f1d6fd648$export$6be99c53fabc250b = 630720000000; // ~20 years
const $0835234f1d6fd648$export$dbdcc139f79b9b57 = /*#__PURE__*/ (0, $5uXOq.memo)(({ flag: flag })=>{
    (0, $5uXOq.useEffect)(()=>{
        (0, $i205g.setFlag)(flag, $0835234f1d6fd648$export$6be99c53fabc250b);
    }, [
        flag
    ]);
    return null;
});

});
parcelRegister("i205g", function(module, exports) {

$parcel$export(module.exports, "getFlags", () => $2e5c55e74efea073$export$d5815430bcc75df0);
$parcel$export(module.exports, "setFlag", () => $2e5c55e74efea073$export$5e165df1e30a1331);

var $dPSWJ = parcelRequire("dPSWJ");

var $sLb2Q = parcelRequire("sLb2Q");

var $4Pf62 = parcelRequire("4Pf62");

var $1nokx = parcelRequire("1nokx");

var $7UyIQ = parcelRequire("7UyIQ");
const $2e5c55e74efea073$export$442e3330dfabd1f5 = 3600000; // 1 hour
const $2e5c55e74efea073$export$4d45fa66d41a8ca9 = 2592000000; // ~1 month
const $2e5c55e74efea073$export$d5815430bcc75df0 = async (request)=>{
    const { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const flagKeys = Object.keys(request);
    const retrieveFlagKeysLookup = (0, (/*@__PURE__*/$parcel$interopDefault($sLb2Q)))(flagKeys);
    if (!atlassianAccountId || isAnonymous) return (0, (/*@__PURE__*/$parcel$interopDefault($dPSWJ)))(retrieveFlagKeysLookup, ()=>({
            status: true,
            lastSeenDate: null
        }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const flags = {};
    if (0, $7UyIQ.default) flagKeys.forEach((flagKey)=>{
        // @ts-expect-error - Object is possibly 'null'.
        const value = (0, $7UyIQ.default).get(flagKey);
        if (value) {
            delete retrieveFlagKeysLookup[flagKey];
            flags[flagKey] = value;
        }
    });
    const retrieveFlagKeys = Object.keys(retrieveFlagKeysLookup);
    if (retrieveFlagKeys.length > 0) Object.assign(flags, await (0, $1nokx.getFlags)(atlassianAccountId, retrieveFlagKeys));
    if (0, $7UyIQ.default) {
        const now = Date.now();
        retrieveFlagKeys.forEach((flagKey)=>{
            // Not sure whats going wrong here - but i assume `apiGetFlags` may not always return all `retrieveFalgKeys`
            // and so `flags[flagKey]` can be undefined - so we have to guard against it
            if (!flags[flagKey]) return;
            const { status: status } = flags[flagKey];
            const ttlNotSeen = request[flagKey].ttlNotSeen || $2e5c55e74efea073$export$442e3330dfabd1f5;
            const ttlSeen = request[flagKey].ttlSeen || $2e5c55e74efea073$export$4d45fa66d41a8ca9;
            // @ts-expect-error - TS2531: Object is possibly 'null'.
            (0, $7UyIQ.default).set(flagKey, flags[flagKey], now + (status ? ttlSeen : ttlNotSeen));
        });
    }
    return flags;
};
const $2e5c55e74efea073$export$5e165df1e30a1331 = async (flagKey, ttl = $2e5c55e74efea073$export$4d45fa66d41a8ca9)=>{
    const { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
    if (!atlassianAccountId || isAnonymous) return;
    if (0, $7UyIQ.default) {
        const value = (0, $7UyIQ.default).get(flagKey);
        if (value && value.status) return;
        const now = new Date();
        (0, $7UyIQ.default).set(flagKey, {
            status: true,
            lastSeenDate: now.toISOString()
        }, now.getTime() + ttl);
    }
    await (0, $1nokx.setFlag)(atlassianAccountId, flagKey);
};

});
parcelRegister("sLb2Q", function(module, exports) {

var $hsOo6 = parcelRequire("hsOo6");

var $dVL8S = parcelRequire("dVL8S");
/**
 * This method is like `_.fromPairs` except that it accepts two arrays,
 * one of property identifiers and one of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 0.4.0
 * @category Array
 * @param {Array} [props=[]] The property identifiers.
 * @param {Array} [values=[]] The property values.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.zipObject(['a', 'b'], [1, 2]);
 * // => { 'a': 1, 'b': 2 }
 */ function $056736098c9e0b45$var$zipObject(props, values) {
    return $dVL8S(props || [], values || [], $hsOo6);
}
module.exports = $056736098c9e0b45$var$zipObject;

});
parcelRegister("dVL8S", function(module, exports) {
/**
 * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
 *
 * @private
 * @param {Array} props The property identifiers.
 * @param {Array} values The property values.
 * @param {Function} assignFunc The function to assign values.
 * @returns {Object} Returns the new object.
 */ function $a2452aab1e6d9d16$var$baseZipObject(props, values, assignFunc) {
    var index = -1, length = props.length, valsLength = values.length, result = {};
    while(++index < length){
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
    }
    return result;
}
module.exports = $a2452aab1e6d9d16$var$baseZipObject;

});


parcelRegister("1nokx", function(module, exports) {

$parcel$export(module.exports, "setFlag", () => $4c27c5726c27889e$export$5e165df1e30a1331);
$parcel$export(module.exports, "getFlags", () => $4c27c5726c27889e$export$d5815430bcc75df0);

var $dPSWJ = parcelRequire("dPSWJ");

var $jJZqs = parcelRequire("jJZqs");
const $4c27c5726c27889e$export$c1f083639d344e75 = 'https://have-i-seen-it.us-east-1.prod.public.atl-paas.net';
const $4c27c5726c27889e$export$5e165df1e30a1331 = (userKey, flagKey)=>{
    const data = {
        userKey: userKey,
        flagKey: flagKey
    };
    return fetch(`${$4c27c5726c27889e$export$c1f083639d344e75}/flag`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    }).then((response)=>{
        if (!response.ok) throw new (0, $jJZqs.default)(response.status, response.statusText);
        return undefined;
    });
};
const $4c27c5726c27889e$var$convertToDates = (response)=>(0, (/*@__PURE__*/$parcel$interopDefault($dPSWJ)))(response, ({ status: status, lastSeenDate: lastSeenDate })=>({
            status: status,
            lastSeenDate: lastSeenDate ? new Date(lastSeenDate) : null
        }));
const $4c27c5726c27889e$export$d5815430bcc75df0 = (userKey, flagKeys)=>{
    const params = new URLSearchParams();
    flagKeys.forEach((flagKey)=>params.append('flagKey', flagKey));
    params.append('userKey', userKey);
    return fetch(`${$4c27c5726c27889e$export$c1f083639d344e75}/flags?${params.toString()}`).then((response)=>{
        if (!response.ok) throw new (0, $jJZqs.default)(response.status, response.statusText);
        return response.json();
    }).then((response)=>$4c27c5726c27889e$var$convertToDates(response));
};

});

parcelRegister("7UyIQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $158da724691281b4$export$2e2bcd8739ae039);

var $eNf8a = parcelRequire("eNf8a");

var $4Pf62 = parcelRequire("4Pf62");

var $2YZCu = parcelRequire("2YZCu");
/**
 * Return an ExpirableStorage to be used with the "have i seen it" service.
 *
 * If the user is anonymous, return null.
 */ const $158da724691281b4$var$createStorage = ()=>{
    let storage = null;
    try {
        let context;
        try {
            context = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            return storage;
        }
        const { atlassianAccountId: atlassianAccountId } = context;
        if (atlassianAccountId) storage = (0, $eNf8a.createSessionExpirableStorageProvider)(`have-i-seen-it-${atlassianAccountId.replace(/:/g, '_')}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('have-i-seen-it.storage', 'Failed to initialize storage.');
    }
    return storage;
};
var $158da724691281b4$export$2e2bcd8739ae039 = $158da724691281b4$var$createStorage();

});



parcelRegister("fNi03", function(module, exports) {

$parcel$export(module.exports, "useBoard", () => $860e4a990aab148d$export$15adc93832970b54);

var $5uXOq = parcelRequire("5uXOq");

var $doZTA = parcelRequire("doZTA");

var $gpXo6 = parcelRequire("gpXo6");

var $1J3t1 = parcelRequire("1J3t1");

var $6VnTH = parcelRequire("6VnTH");
const $860e4a990aab148d$var$USER_BOARD_ROUTE_NAMES = [
    'rapidboard-user-board',
    'rapidboard-user-backlog',
    'rapidboard-user-report',
    'rapidboard-user-board-settings',
    'rapidboard-user-reports-overview',
    'software-reports-velocity-user-board'
];
const $860e4a990aab148d$var$isOnUserBoardRoute = (routeName)=>$860e4a990aab148d$var$USER_BOARD_ROUTE_NAMES.includes(routeName);
const $860e4a990aab148d$var$isOnLocationLessBoardRoute = (match, query)=>{
    const { locationless: locationless = 'false' } = query;
    return match.url.includes('RapidBoard.jspa') && JSON.parse(locationless) === true;
};
const $860e4a990aab148d$export$50230c720b1c453e = ()=>{
    const [{ match: match, route: route, query: query }] = (0, $doZTA.useRouter)();
    return $860e4a990aab148d$var$isOnUserBoardRoute(route.name) || $860e4a990aab148d$var$isOnLocationLessBoardRoute(match, query);
};
const $860e4a990aab148d$export$15adc93832970b54 = ()=>{
    const isOnUserOrLocationlessBoardRoute = $860e4a990aab148d$export$50230c720b1c453e();
    // pb -> project board
    const { data: pb, loading: pbLoading, error: pbError } = (0, $1J3t1.useJiraSoftwareProjectNavigation)();
    // ub -> user board
    const { data: ub, loading: ubLoading, error: ubError } = (0, $gpXo6.useJiraUserBoardNavigationResource)();
    const projectBoard = (0, $5uXOq.useMemo)(()=>pb && (0, $6VnTH.extractData)(pb), [
        pb
    ]);
    const userBoard = (0, $5uXOq.useMemo)(()=>ub && (0, $6VnTH.extractUserBoard)(ub), [
        ub
    ]);
    if (isOnUserOrLocationlessBoardRoute) return {
        data: userBoard,
        loading: ubLoading,
        error: ubError
    };
    return {
        data: projectBoard,
        loading: pbLoading,
        error: pbError
    };
};

});
parcelRegister("gpXo6", function(module, exports) {

$parcel$export(module.exports, "useJiraUserBoardNavigationResource", () => $c3c49f06ba708347$export$517acde8347261e3);

var $7xTO3 = parcelRequire("7xTO3");

var $2YP9W = parcelRequire("2YP9W");
const $c3c49f06ba708347$export$517acde8347261e3 = ()=>(0, $2YP9W.useResource)((0, $7xTO3.staticJSWUserBoardSidebarNavigationResource));

});


parcelRegister("9dbF6", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $5979c081afa32bfa$export$eb40d3df56aa5c53);

var $5uXOq = parcelRequire("5uXOq");

var $5h5Fg = parcelRequire("5h5Fg");

var $16v4H = parcelRequire("16v4H");

var $3iTiR = parcelRequire("3iTiR");

var $54I24 = parcelRequire("54I24");

var $8OHH4 = parcelRequire("8OHH4");
const $5979c081afa32bfa$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $8OHH4.isSubProductProps)(props) ? props.subProduct : (0, $16v4H.subProductFromProjectTypeForAnalytics)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5h5Fg.default), {
        op: (0, $54I24.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3iTiR.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("3iTiR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1214b0731559b377$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $01Rn4 = parcelRequire("01Rn4");

var $hFChZ = parcelRequire("hFChZ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1214b0731559b377$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $01Rn4.default), {
        op: (0, $hFChZ.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("hFChZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e606430ead76cd8$export$2e2bcd8739ae039);

var $2YZCu = parcelRequire("2YZCu");

var $eusud = parcelRequire("eusud");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0e606430ead76cd8$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $eusud.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("54I24", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcbbcd48ca398ed4$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $7T84i = parcelRequire("7T84i");
var $9B86Q = parcelRequire("9B86Q");
var $cQZXC = parcelRequire("cQZXC");


var $2YZCu = parcelRequire("2YZCu");

var $fjcgS = parcelRequire("fjcgS");
const $bcbbcd48ca398ed4$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bcbbcd48ca398ed4$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $86344d58e71e925a$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $bcbbcd48ca398ed4$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $cQZXC.waitForHeritage)() : null, ()=>(0, $7T84i.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $9B86Q.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $2YZCu.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $86344d58e71e925a$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("8OHH4", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $701d07b56c3e3574$export$c3063d6d7a8c075f);
const $701d07b56c3e3574$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';

});


parcelRegister("vtv5G", function(module, exports) {

$parcel$export(module.exports, "PageHeader", () => $1e3e99d8c5424320$export$53f1cd6809577fc5);

var $5uXOq = parcelRequire("5uXOq");

var $kgoHi = parcelRequire("kgoHi");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $dGTaF = parcelRequire("dGTaF");

var $30OeB = parcelRequire("30OeB");

var $kLwbb = parcelRequire("kLwbb");
const $1e3e99d8c5424320$export$53f1cd6809577fc5 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        xcss: $1e3e99d8c5424320$var$pageHeaderStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dGTaF.Breadcrumb), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: $1e3e99d8c5424320$var$titleWrapperStyles
    }, formatMessage((0, $kLwbb.default).listViewTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $30OeB.default), null))));
};
const $1e3e99d8c5424320$var$pageHeaderStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.300'
});
const $1e3e99d8c5424320$var$titleWrapperStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    maxWidth: '100%',
    overflow: 'hidden',
    flex: '1 1 auto',
    font: "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});

});
parcelRegister("dGTaF", function(module, exports) {

$parcel$export(module.exports, "Breadcrumb", () => $385eff7becfd7160$export$dabcc1ec9dd9d1cc);

var $5uXOq = parcelRequire("5uXOq");

var $jS4lj = parcelRequire("jS4lj");

var $gEFwt = parcelRequire("gEFwt");

var $daQYX = parcelRequire("daQYX");
const $385eff7becfd7160$export$dabcc1ec9dd9d1cc = ()=>{
    const project = (0, $daQYX.useProject)();
    return(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore TS2741: Property 'baseUrl' is missing
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gEFwt.default), {
        projectKey: project.key,
        projectName: project.name,
        projectId: String(project.id),
        isSimplifiedProject: project.isSimplified
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jS4lj.default), null)));
};

});

parcelRegister("30OeB", function(module, exports) {

$parcel$export(module.exports, "default", () => $910e7cee32eae6d0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $2xMvF = parcelRequire("2xMvF");

var $jPxJ7 = parcelRequire("jPxJ7");

var $koVbs = parcelRequire("koVbs");

var $8nDEz = parcelRequire("8nDEz");
const $910e7cee32eae6d0$var$FEEDBACK_GROUP_ID = 'jsw-list-feedback';
const $910e7cee32eae6d0$var$FeedbackButton = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const openFeedbackModal = (0, $jPxJ7.useFeedbackCollector)({
        projectType: 'software'
    });
    const onClick = (0, $5uXOq.useCallback)(()=>{
        openFeedbackModal($910e7cee32eae6d0$var$FEEDBACK_GROUP_ID);
    }, [
        openFeedbackModal
    ]);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2xMvF))), {
            label: "",
            LEGACY_size: "medium"
        }),
        appearance: "subtle",
        onClick: onClick
    }, formatMessage((0, $8nDEz.default).feedback));
    return content;
};
var $910e7cee32eae6d0$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($910e7cee32eae6d0$var$FeedbackButton);

});
parcelRegister("2xMvF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::95953690df38ef00a14db2c04a212acb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1da44ae3ec70ec89$var$_react = $1da44ae3ec70ec89$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $1da44ae3ec70ec89$var$_feedback = $1da44ae3ec70ec89$var$_interopRequireDefault((parcelRequire("5dqGX")));

var $1da44ae3ec70ec89$var$_feedback2 = $1da44ae3ec70ec89$var$_interopRequireDefault((parcelRequire("2mVws")));
function $1da44ae3ec70ec89$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for FeedbackIcon.
 * This component is FeedbackIcon, with `UNSAFE_fallbackIcon` set to "EditorFeedbackIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1da44ae3ec70ec89$var$FeedbackIcon = (props)=>/*#__PURE__*/ $1da44ae3ec70ec89$var$_react.default.createElement($1da44ae3ec70ec89$var$_feedback.default, Object.assign({
        LEGACY_fallbackIcon: $1da44ae3ec70ec89$var$_feedback2.default
    }, props));
$1da44ae3ec70ec89$var$FeedbackIcon.Name = 'FeedbackIconMigration';
var $1da44ae3ec70ec89$var$_default = module.exports.default = $1da44ae3ec70ec89$var$FeedbackIcon;

});
parcelRegister("2mVws", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1b9a41a3ba9d94ab$var$_react = $1b9a41a3ba9d94ab$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $1b9a41a3ba9d94ab$var$_feedback = $1b9a41a3ba9d94ab$var$_interopRequireDefault((parcelRequire("5dqGX")));
function $1b9a41a3ba9d94ab$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1b9a41a3ba9d94ab$var$EditorFeedbackIcon = (props)=>/*#__PURE__*/ $1b9a41a3ba9d94ab$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M10.922 14.517 5.87 12.68l-.932-.339C4.418 12.151 4 11.552 4 11c0-.556.42-1.153.938-1.341l9.124-3.318c.52-.19.938.105.938.654v8.01c0 .54-.42.842-.938.654zM6 14.227l2 .728V17c0 .552-.405 1.202-.895 1.447l-.21.106C6.4 18.8 6 18.549 6 18.009zm11.224-4.78a.5.5 0 1 1-.448-.894l2-1a.5.5 0 1 1 .448.894zm-.448 4a.5.5 0 0 1 .448-.894l2 1a.5.5 0 0 1-.448.894zM17 11.5a.5.5 0 1 1 0-1h3a.5.5 0 1 1 0 1z"/></svg>`
    }, props, {
        newIcon: $1b9a41a3ba9d94ab$var$_feedback.default
    }));
$1b9a41a3ba9d94ab$var$EditorFeedbackIcon.displayName = 'EditorFeedbackIcon';
var $1b9a41a3ba9d94ab$var$_default = module.exports.default = $1b9a41a3ba9d94ab$var$EditorFeedbackIcon;

});


parcelRegister("8nDEz", function(module, exports) {

$parcel$export(module.exports, "default", () => $3505edf37cd4514b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3505edf37cd4514b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    feedback: {
        "id": "spa-apps-jsw-list.page-header.feedback-button.feedback",
        "defaultMessage": "Give feedback"
    }
});

});


parcelRegister("kLwbb", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8c8e3b65c4c1397$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f8c8e3b65c4c1397$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    listViewTitle: {
        "id": "spa-apps-jsw-list.page-header.list-view-title",
        "defaultMessage": "List"
    }
});

});



const $135ded4f9a1460dc$export$dcd281f501ceae1a = 'issue-view-layout-templates-views.ui.context.visible-hidden.ui.pinned-fields';
const $135ded4f9a1460dc$export$2aca0ebce9a48d61 = 'issue-view-layout-templates-views.ui.context.visible-hidden.ui.visible-fields';
const $135ded4f9a1460dc$export$fc60a8d420264e7d = 'issue-view-layout-templates-views.ui.context.visible-hidden.ui.hidden-fields';
const $135ded4f9a1460dc$export$e1184c3be46bd7cb = false;
const $135ded4f9a1460dc$export$2028cf1423b28cf8 = 'global-spotlight-target-';
const $135ded4f9a1460dc$export$988f0f6f6457039a = 'status-and-approval-spotlight';

const $c5ab1cac32219280$export$87b07f66f76af007 = 1000;
const $c5ab1cac32219280$export$7cf28317477c9e48 = 'w';

const $13918fc81534c491$export$cb17e3c17bc50301 = 'Epic';
const $13918fc81534c491$export$d29cf9c8492f955d = 'Base';
const $13918fc81534c491$export$7fbc739f2667a35e = 'Subtask';

const $05ea8866f66e1e3c$export$37b67b9fa9f77199 = 'APPLINK_MISSING';
const $05ea8866f66e1e3c$export$d1fe0e8f550fe68d = 'APPLINK_REQ_AUTH';
const $05ea8866f66e1e3c$export$a6054426471fb4c4 = 'REMOTE_SERVER';
const $05ea8866f66e1e3c$export$cdf8a4853fe35e61 = 'REMOTE_LINK_MISSING';


//# sourceMappingURL=async-software-list-entrypoint.b9c69868.js.map
